/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: any;
  /** Represents NULL values */
  Void: any;
};

export type ComWixBookingsCalendarApiV2QuerySessionsRequestInput = {
  /**
   * Start of the time range for which sessions are returned, in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)).
   *
   * Sessions that begin before the `fromDate` but end after it are included in the results. For recurring session definitions, this means the `start` value is before the `fromDate` and the `UNTIL` value in the `recurrence` property is after the `fromDate`.
   *
   * Required, unless `query.cursorPaging` is provided.
   */
  fromDate?: InputMaybe<Scalars['String']>;
  /**
   * Whether to include sessions imported from connected external calendars in the results.
   *
   * Default: `false`.
   */
  includeExternal?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to return only single session instances and instances of recurring sessions.
   *
   * If `true`, only single session instances and instances of recurring sessions are returned.
   *
   * If `false`, only recurring session definitions are returned. **Note:** Cursor pagination is not supported for recurring session definition queries.
   *
   * Default: `true`.
   */
  instances?: InputMaybe<Scalars['Boolean']>;
  /** Query options. */
  query?: InputMaybe<ComWixBookingsCalendarApiV2UpstreamWixCommonQueryV2Input>;
  /**
   * End of the time range for which sessions are returned, in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)).
   *
   * Sessions that begin before the `toDate` but end after it are included in the results. For recurring session definitions, this means the `start` value is before the `toDate` and the `UNTIL` value in the `recurrence` property is after the `toDate`.
   *
   * Required, unless `query.cursorPaging` is provided.
   *
   * Max: 1 year after `fromDate` for session instance queries. This limit doesn't apply to recurring session definition queries.
   */
  toDate?: InputMaybe<Scalars['String']>;
  /**
   * Type of sessions to return.
   * + `EVENT`: Returns only sessions of type `EVENT`.
   * + `WORKING_HOURS`: Returns only sessions of type `WORKING_HOURS`.
   * + `ALL`: Returns sessions of all types.
   *
   * Default: `EVENT`.
   */
  type?: InputMaybe<ComWixBookingsCalendarApiV2QuerySessionsRequestSessionTypeFilter>;
};

export enum ComWixBookingsCalendarApiV2QuerySessionsRequestSessionTypeFilter {
  /** Return sessions of any type. */
  All = 'ALL',
  /** Filter sessions of type `EVENT`. This is the default. */
  Event = 'EVENT',
  UnknownSessionType = 'UNKNOWN_SESSION_TYPE',
  /** Filter sessions of type `WORKING_HOURS`. */
  WorkingHours = 'WORKING_HOURS'
}

export type ComWixBookingsCalendarApiV2QuerySessionsResponse = {
  __typename?: 'ComWixBookingsCalendarApiV2QuerySessionsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Session>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixBookingsCalendarApiV2UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of sessions to return.
   *
   * Default: `100`
   * Max: `1000`
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsCalendarApiV2UpstreamWixCommonQueryV2Input = {
  /**
   * Cursor token pointing to a page of results.
   * Not used in the first request.
   * Following requests use the cursor token and not `filter`.
   */
  cursorPaging?: InputMaybe<ComWixBookingsCalendarApiV2UpstreamWixCommonCursorPagingInput>;
  /**
   * Predefined sets of fields to return.
   * - `NO_PI`: Returns session objects without personal information.
   * - `ALL_PI`: Returns complete session objects, including personal information. Requires the Read Bookings Calendar - Including Participants or the Manage Bookings Services and Settings or the Manage Business Calendar [permission scope](https://devforum.wix.com/kb/en/article/available-permissions).
   *
   * Default: `NO_PI`
   */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object. For field support for filters, see
   * [Sessions: Supported Filters](./filtering).
   * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) for more information about querying with filters.
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixBookingsCommonApiV1Location = {
  __typename?: 'ComWixBookingsCommonApiV1Location';
  /** Free text address used when locationType is `OWNER_CUSTOM`. */
  address?: Maybe<Scalars['String']>;
  /**
   * The Wix Business location formatted address.
   * Valid when `locationType` is `OWNER_BUSINESS`. Defaults to the business's location.
   * To retrieve the full location data please use the [Locations API](https://dev.wix.com/api/rest/business-info/locations).
   */
  businessLocation?: Maybe<ComWixpressLocationsLocation>;
  /** Custom address, used when locationType is `"OWNER_CUSTOM"`. Might be used when locationType is `"CUSTOM"` in case the owner sets a custom address for the session which is different from the default. */
  customAddress?: Maybe<ComWixBookingsUpstreamWixCommonAddress>;
  /**
   * Location type.
   * One of:
   * - `"OWNER_BUSINESS"` The business address as set in the site’s general settings.
   * - `"OWNER_CUSTOM"` The address as set when creating the service.
   * - `"CUSTOM"` The address set for the individual session.
   */
  locationType?: Maybe<ComWixBookingsCommonApiV1LocationLocationType>;
};

export type ComWixBookingsCommonApiV1LocationInput = {
  /** Free text address used when locationType is `OWNER_CUSTOM`. */
  address?: InputMaybe<Scalars['String']>;
  /**
   * The Wix Business location formatted address.
   * Valid when `locationType` is `OWNER_BUSINESS`. Defaults to the business's location.
   * To retrieve the full location data please use the [Locations API](https://dev.wix.com/api/rest/business-info/locations).
   */
  businessLocation?: InputMaybe<ComWixpressLocationsLocationInput>;
  /** Custom address, used when locationType is `"OWNER_CUSTOM"`. Might be used when locationType is `"CUSTOM"` in case the owner sets a custom address for the session which is different from the default. */
  customAddress?: InputMaybe<ComWixBookingsUpstreamWixCommonAddressInput>;
  /**
   * Location type.
   * One of:
   * - `"OWNER_BUSINESS"` The business address as set in the site’s general settings.
   * - `"OWNER_CUSTOM"` The address as set when creating the service.
   * - `"CUSTOM"` The address set for the individual session.
   */
  locationType?: InputMaybe<ComWixBookingsCommonApiV1LocationLocationType>;
};

export enum ComWixBookingsCommonApiV1LocationLocationType {
  Custom = 'CUSTOM',
  OwnerBusiness = 'OWNER_BUSINESS',
  OwnerCustom = 'OWNER_CUSTOM',
  Undefined = 'UNDEFINED'
}

export type ComWixBookingsCommonApiV1Price = {
  __typename?: 'ComWixBookingsCommonApiV1Price';
  /** Required payment amount. */
  amount?: Maybe<Scalars['String']>;
  /** Currency in which the amount is quoted. */
  currency?: Maybe<Scalars['String']>;
  /** Amount of a down payment or deposit as part of the transaction. */
  downPayAmount?: Maybe<Scalars['String']>;
};

export type ComWixBookingsCommonApiV1PriceInput = {
  /** Required payment amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Currency in which the amount is quoted. */
  currency?: InputMaybe<Scalars['String']>;
  /** Amount of a down payment or deposit as part of the transaction. */
  downPayAmount?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsCommonApiV1QueryMetaData = {
  __typename?: 'ComWixBookingsCommonApiV1QueryMetaData';
  items?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsCommonApiV1Rate = {
  __typename?: 'ComWixBookingsCommonApiV1Rate';
  /**
   * Default service price. Always vailable when a service has
   * [variants](https://dev.wix.com/api/rest/wix-bookings/service-options-and-variants/introduction).
   * Sometimes also available for services without variants.
   * Ignored in [updates to a service](https://dev.wix.com/api/rest/wix-bookings/services/service/update-service),
   * when either `labeled_price_options` or `price_text` is also specified.
   */
  defaultVariedPrice?: Maybe<ComWixBookingsCommonApiV1Price>;
  /**
   * Mapping between a named price option, for example, adult or child prices, and the price, currency, and down payment amount.
   * When present in an update request, the `default_varied_price` is ignored to support backward compatibility.
   */
  labeledPriceOptions?: Maybe<ComWixBookingsCommonApiV1Price>;
  /**
   * Textual price information used when **Price Per Session** is set to **Custom Price** in the app's service details page.
   * When present in an update request, the `default_varied_price` is ignored to support backward compatibility.
   */
  priceText?: Maybe<Scalars['String']>;
};

export type ComWixBookingsCommonApiV1RateInput = {
  /**
   * Default service price. Always vailable when a service has
   * [variants](https://dev.wix.com/api/rest/wix-bookings/service-options-and-variants/introduction).
   * Sometimes also available for services without variants.
   * Ignored in [updates to a service](https://dev.wix.com/api/rest/wix-bookings/services/service/update-service),
   * when either `labeled_price_options` or `price_text` is also specified.
   */
  defaultVariedPrice?: InputMaybe<ComWixBookingsCommonApiV1PriceInput>;
  /**
   * Mapping between a named price option, for example, adult or child prices, and the price, currency, and down payment amount.
   * When present in an update request, the `default_varied_price` is ignored to support backward compatibility.
   */
  labeledPriceOptions?: InputMaybe<ComWixBookingsCommonApiV1PriceInput>;
  /**
   * Textual price information used when **Price Per Session** is set to **Custom Price** in the app's service details page.
   * When present in an update request, the `default_varied_price` is ignored to support backward compatibility.
   */
  priceText?: InputMaybe<Scalars['String']>;
};

export enum ComWixBookingsExternalcalendarSpiV1CalendarTypeEnumCalendarType {
  /** [Google Calendar](https://developers.google.com/calendar/api/guides/overview). */
  Google = 'GOOGLE',
  /** Apple iCalendar. */
  ICal = 'I_CAL',
  /** Microsoft Calendar. For example, Office 365 calendar or Outlook calendar. */
  Microsoft = 'MICROSOFT',
  /** __Deprecated__. Use `MICROSOFT` instead. */
  Office_365 = 'OFFICE_365',
  /** A different type of external calendar, not listed here. */
  Other = 'OTHER',
  /** __Deprecated__. Use `MICROSOFT` instead. */
  Outlook = 'OUTLOOK',
  /** There is no information about the external calendar type. */
  Undefined = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1Availability = {
  __typename?: 'ComWixBookingsSchedulesApiV1Availability';
  /** Constraints for calculating the schedule's availability. */
  constraints?: Maybe<ComWixBookingsSchedulesApiV1AvailabilityConstraints>;
  /** Date and time the schedule stops being available for booking. No value indicates no end time. */
  end?: Maybe<Scalars['String']>;
  /** Other schedules that impact the availability calculation. Relevant only when there are availability constraints. */
  linkedSchedules?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1LinkedSchedule>>>;
  /**
   * Not supported yet.
   * A list of possible locations for the session when `use_default_location` is set to `false`. Slots are generated for each location. Only one of the possible locations can be chosen by the customer.
   *
   * **NOTE**: When using the `locations` parameter, the default location is not automatically included in the list.
   */
  locations?: Maybe<Array<Maybe<ComWixBookingsCommonApiV1Location>>>;
  /** Date and time the schedule starts to be available for booking. */
  start?: Maybe<Scalars['String']>;
  /**
   * Not supported yet.
   * Whether the schedule's slots are only available at the schedule's default location, as set in `schedule.location`. If set to `false`, the `locations` array is used to set the possible locations of the schedule's sessions.
   * Default is `true`.
   */
  useDefaultLocation?: Maybe<Scalars['Boolean']>;
};

export type ComWixBookingsSchedulesApiV1AvailabilityConstraints = {
  __typename?: 'ComWixBookingsSchedulesApiV1AvailabilityConstraints';
  /**
   * A list of duration options for slots, in minutes. Minimum value for a duration is 1.
   * The availability calculation generates slots with these durations, where there is no conflict with existing sessions or other availability constraints.
   */
  slotDurations?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** An object defining the time between available slots' start times.  For example, a slot with slots_split_interval=5 can start every 5 minutes. The default is the slot duration. */
  slotsSplitInterval?: Maybe<ComWixBookingsSchedulesApiV1SplitInterval>;
  /**
   * Specify how to split the slots in intervals of minutes.
   * This value indicates the time between available slots' start time. e.g., from 5 minute slots (3:00, 3:05, 3:15) and 1 hour slots (3:00, 4:00, 5:00).
   * Optional. The default is the first duration in slot_durations field.
   * Deprecated. Use the `split_slots_interval.value_in_minutes`.
   */
  splitInterval?: Maybe<Scalars['Int']>;
  /**
   * The number of minutes between the `end` of one slot, and the `start` of the next.
   * Minimum value is 0, maximum value is 120.
   */
  timeBetweenSlots?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1AvailabilityConstraintsInput = {
  /**
   * A list of duration options for slots, in minutes. Minimum value for a duration is 1.
   * The availability calculation generates slots with these durations, where there is no conflict with existing sessions or other availability constraints.
   */
  slotDurations?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** An object defining the time between available slots' start times.  For example, a slot with slots_split_interval=5 can start every 5 minutes. The default is the slot duration. */
  slotsSplitInterval?: InputMaybe<ComWixBookingsSchedulesApiV1SplitIntervalInput>;
  /**
   * Specify how to split the slots in intervals of minutes.
   * This value indicates the time between available slots' start time. e.g., from 5 minute slots (3:00, 3:05, 3:15) and 1 hour slots (3:00, 4:00, 5:00).
   * Optional. The default is the first duration in slot_durations field.
   * Deprecated. Use the `split_slots_interval.value_in_minutes`.
   */
  splitInterval?: InputMaybe<Scalars['Int']>;
  /**
   * The number of minutes between the `end` of one slot, and the `start` of the next.
   * Minimum value is 0, maximum value is 120.
   */
  timeBetweenSlots?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1AvailabilityInput = {
  /** Constraints for calculating the schedule's availability. */
  constraints?: InputMaybe<ComWixBookingsSchedulesApiV1AvailabilityConstraintsInput>;
  /** Date and time the schedule stops being available for booking. No value indicates no end time. */
  end?: InputMaybe<Scalars['String']>;
  /** Other schedules that impact the availability calculation. Relevant only when there are availability constraints. */
  linkedSchedules?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1LinkedScheduleInput>>>;
  /**
   * Not supported yet.
   * A list of possible locations for the session when `use_default_location` is set to `false`. Slots are generated for each location. Only one of the possible locations can be chosen by the customer.
   *
   * **NOTE**: When using the `locations` parameter, the default location is not automatically included in the list.
   */
  locations?: InputMaybe<Array<InputMaybe<ComWixBookingsCommonApiV1LocationInput>>>;
  /** Date and time the schedule starts to be available for booking. */
  start?: InputMaybe<Scalars['String']>;
  /**
   * Not supported yet.
   * Whether the schedule's slots are only available at the schedule's default location, as set in `schedule.location`. If set to `false`, the `locations` array is used to set the possible locations of the schedule's sessions.
   * Default is `true`.
   */
  useDefaultLocation?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixBookingsSchedulesApiV1AvailabilityPolicyInput = {
  /** Specify how to split the schedule slots in intervals of minutes. */
  splitInterval?: InputMaybe<ComWixBookingsSchedulesApiV1SplitIntervalInput>;
};

export type ComWixBookingsSchedulesApiV1AvailabilityPolicyUpdatedInput = {
  availabilityPolicy?: InputMaybe<ComWixBookingsSchedulesApiV1AvailabilityPolicyInput>;
};

export type ComWixBookingsSchedulesApiV1BatchRequestInput = {
  /**
   * Cancel multiple schedules.
   * The given schedules move to a CANCELLED status which means that all sessions up until
   * the cancellation point in time are kept, while removing all following sessions.
   */
  cancelRequests?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1CancelScheduleRequestInput>>>;
  /** Create multiple schedules. */
  createRequests?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1CreateScheduleRequestInput>>>;
  /** Update multiple schedules. Not Supported yet. */
  updateRequests?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1UpdateScheduleRequestInput>>>;
};

export type ComWixBookingsSchedulesApiV1BatchResponse = {
  __typename?: 'ComWixBookingsSchedulesApiV1BatchResponse';
  /** Cancelled schedules. */
  cancelled?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Schedule>>>;
  /** Created schedules. */
  created?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Schedule>>>;
  /** Updated schedules. */
  updated?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Schedule>>>;
};

export type ComWixBookingsSchedulesApiV1CalendarConference = {
  __typename?: 'ComWixBookingsSchedulesApiV1CalendarConference';
  /** ID of the account owner in the video conferencing service. */
  accountOwnerId?: Maybe<Scalars['String']>;
  /** A generated id for the conference entity - Base62($providerId$accountOwnerId$conferenceId) */
  conferenceId?: Maybe<Scalars['String']>;
  /** Conference type. */
  conferenceType?: Maybe<ComWixBookingsSchedulesApiV1CalendarConferenceConferenceType>;
  /** Conference description. */
  description?: Maybe<Scalars['String']>;
  /** Conference meeting ID in the provider's conferencing system. */
  externalId?: Maybe<Scalars['String']>;
  /** URL used by a guest to join the conference. */
  guestUrl?: Maybe<Scalars['String']>;
  /** URL used by the host to start the conference. */
  hostUrl?: Maybe<Scalars['String']>;
  /** Wix Calendar conference ID. */
  id?: Maybe<Scalars['String']>;
  /** Password to join the conference. */
  password?: Maybe<Scalars['String']>;
  /** Conference provider ID. */
  providerId?: Maybe<Scalars['String']>;
};

export enum ComWixBookingsSchedulesApiV1CalendarConferenceConferenceType {
  /** User-defined meeting. */
  Custom = 'CUSTOM',
  /** API-generated online meeting. */
  OnlineMeetingProvider = 'ONLINE_MEETING_PROVIDER',
  /** Undefined conference type. */
  Undefined = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1CalendarConferenceInput = {
  /** ID of the account owner in the video conferencing service. */
  accountOwnerId?: InputMaybe<Scalars['String']>;
  /** A generated id for the conference entity - Base62($providerId$accountOwnerId$conferenceId) */
  conferenceId?: InputMaybe<Scalars['String']>;
  /** Conference type. */
  conferenceType?: InputMaybe<ComWixBookingsSchedulesApiV1CalendarConferenceConferenceType>;
  /** Conference description. */
  description?: InputMaybe<Scalars['String']>;
  /** Conference meeting ID in the provider's conferencing system. */
  externalId?: InputMaybe<Scalars['String']>;
  /** URL used by a guest to join the conference. */
  guestUrl?: InputMaybe<Scalars['String']>;
  /** URL used by the host to start the conference. */
  hostUrl?: InputMaybe<Scalars['String']>;
  /** Wix Calendar conference ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Password to join the conference. */
  password?: InputMaybe<Scalars['String']>;
  /** Conference provider ID. */
  providerId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1CalendarDateTime = {
  __typename?: 'ComWixBookingsSchedulesApiV1CalendarDateTime';
  /** An object containing the local date and time for the business's time zone. */
  localDateTime?: Maybe<ComWixBookingsSchedulesApiV1LocalDateTime>;
  /**
   * The time zone. Optional. Derived from the schedule's time zone.
   * In case this field is associated with recurring session, this field is empty.
   */
  timeZone?: Maybe<Scalars['String']>;
  /**
   * UTC date-time in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)) format. If a time zone offset is specified, the time is converted to UTC. For example, if you specify  `new Date('2021-01-06T16:00:00.000-07:00')`, the stored value will be `"2021-01-06T23:00:00.000Z"`.
   * Required if `localDateTime` is not specified.
   * If `localDateTime` is specified, `timestamp` is calculated as `localDateTime`, using the business's time zone.
   */
  timestamp?: Maybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1CalendarDateTimeInput = {
  /** An object containing the local date and time for the business's time zone. */
  localDateTime?: InputMaybe<ComWixBookingsSchedulesApiV1LocalDateTimeInput>;
  /**
   * The time zone. Optional. Derived from the schedule's time zone.
   * In case this field is associated with recurring session, this field is empty.
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * UTC date-time in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)) format. If a time zone offset is specified, the time is converted to UTC. For example, if you specify  `new Date('2021-01-06T16:00:00.000-07:00')`, the stored value will be `"2021-01-06T23:00:00.000Z"`.
   * Required if `localDateTime` is not specified.
   * If `localDateTime` is specified, `timestamp` is calculated as `localDateTime`, using the business's time zone.
   */
  timestamp?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1CancelScheduleRequestInput = {
  /** Time to cancel the sessions from. Optional. If this field is empty, all of this schedule's sessions will be canceled. */
  from?: InputMaybe<Scalars['String']>;
  /** Deprecated, use participant_notification */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
  /** Whether to notify participants about the change, and an optional custom message. */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /** Whether to preserve future sessions with reservations. Defaults to false. */
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
  /** Schedule ID. */
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1ConferenceProvider = {
  __typename?: 'ComWixBookingsSchedulesApiV1ConferenceProvider';
  /** Conferencing provider ID */
  providerId?: Maybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1ConferenceProviderInput = {
  /** Conferencing provider ID */
  providerId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1CreateScheduleRequestInput = {
  /** Optional. Idempotency key. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Schedule. */
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
};

export type ComWixBookingsSchedulesApiV1ExternalCalendarInfo = {
  __typename?: 'ComWixBookingsSchedulesApiV1ExternalCalendarInfo';
  /** The external calendar type (e.g. Google Calendar, iCal, etc). */
  calendarType?: Maybe<ComWixBookingsExternalcalendarSpiV1CalendarTypeEnumCalendarType>;
};

export type ComWixBookingsSchedulesApiV1ExternalCalendarInfoInput = {
  /** The external calendar type (e.g. Google Calendar, iCal, etc). */
  calendarType?: InputMaybe<ComWixBookingsExternalcalendarSpiV1CalendarTypeEnumCalendarType>;
};

export type ComWixBookingsSchedulesApiV1ExternalCalendarOverrides = {
  __typename?: 'ComWixBookingsSchedulesApiV1ExternalCalendarOverrides';
  /** Synced description of the external calendar event. */
  description?: Maybe<Scalars['String']>;
  /** Synced title of the external calendar event. */
  title?: Maybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput = {
  /** Synced description of the external calendar event. */
  description?: InputMaybe<Scalars['String']>;
  /** Synced title of the external calendar event. */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1Frequency = {
  __typename?: 'ComWixBookingsSchedulesApiV1Frequency';
  /** The frequency of the recurrence in weeks. i.e. when this value is 4, the interval occurs every 4 weeks. Optional. The default is 1. minimum: 1, maximum: 52. */
  repetition?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1FrequencyInput = {
  /** The frequency of the recurrence in weeks. i.e. when this value is 4, the interval occurs every 4 weeks. Optional. The default is 1. minimum: 1, maximum: 52. */
  repetition?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1GetSessionRequestInput = {
  /**
   * Predefined sets of fields to return.
   * - `NO_PI`: Returns session objects without personal information.
   * - `ALL_PI`: Returns complete session objects, including personal information. Requires the CALENDAR.SESSION_READ_PI permission scope.
   *
   * Default: `NO_PI`
   */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
};

export type ComWixBookingsSchedulesApiV1Interval = {
  __typename?: 'ComWixBookingsSchedulesApiV1Interval';
  /** The day the interval occurs. Optional. The default is the day of the recurring interval's start time. */
  daysOfWeek?: Maybe<ComWixBookingsSchedulesApiV1IntervalDay>;
  /** The duration of the interval in minutes. Required. Part of the session end time calculation. */
  duration?: Maybe<Scalars['Int']>;
  /** The hour of the day the interval occurs. Must be consistent with the interval start time. Optional. The default is 0. Minimum: 0, maximum: 23. */
  hourOfDay?: Maybe<Scalars['Int']>;
  /** The minutes of the hour the interval accrues. Must be consistent with the interval end time. Optional. The default is 0. Minimum: 0, maximum: 59. */
  minuteOfHour?: Maybe<Scalars['Int']>;
};

export enum ComWixBookingsSchedulesApiV1IntervalDay {
  /** Friday. */
  Fri = 'FRI',
  /** Monday. */
  Mon = 'MON',
  /** Saturday. */
  Sat = 'SAT',
  /** Sunday. */
  Sun = 'SUN',
  /** Thursday. */
  Thu = 'THU',
  /** Tuesday. */
  Tue = 'TUE',
  /** Undefined. */
  Undefined = 'UNDEFINED',
  /** Wednesday. */
  Wed = 'WED'
}

export type ComWixBookingsSchedulesApiV1IntervalInput = {
  /** The day the interval occurs. Optional. The default is the day of the recurring interval's start time. */
  daysOfWeek?: InputMaybe<ComWixBookingsSchedulesApiV1IntervalDay>;
  /** The duration of the interval in minutes. Required. Part of the session end time calculation. */
  duration?: InputMaybe<Scalars['Int']>;
  /** The hour of the day the interval occurs. Must be consistent with the interval start time. Optional. The default is 0. Minimum: 0, maximum: 23. */
  hourOfDay?: InputMaybe<Scalars['Int']>;
  /** The minutes of the hour the interval accrues. Must be consistent with the interval end time. Optional. The default is 0. Minimum: 0, maximum: 59. */
  minuteOfHour?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1IntervalSplitInput = {
  intervals?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1RecurringIntervalInput>>>;
  newScheduleVersion?: InputMaybe<Scalars['Int']>;
  oldScheduleVersion?: InputMaybe<Scalars['Int']>;
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1LinkedSchedule = {
  __typename?: 'ComWixBookingsSchedulesApiV1LinkedSchedule';
  /** Schedule ID. */
  scheduleId?: Maybe<Scalars['String']>;
  /** Owner ID, of the linked schedule. */
  scheduleOwnerId?: Maybe<Scalars['String']>;
  /**
   * The name of the linked schedule owner. It may be a resource name or a service name. Optional.
   * This field is inherited from the schedule identified by scheduleId above.
   */
  scheduleOwnerName?: Maybe<Scalars['String']>;
  /**
   * The user id of the linked schedule owner. Optional.
   * This field is inherited from the schedule identified by scheduleId above.
   * NOT IMPLEMENTED. YET.
   */
  scheduleOwnerUserId?: Maybe<Scalars['String']>;
  /** Sets this schedule's availability for the duration of the linked schedule's sessions. Default is `"BUSY"`. */
  transparency?: Maybe<ComWixBookingsSchedulesApiV1LinkedScheduleTransparency>;
};

export type ComWixBookingsSchedulesApiV1LinkedScheduleInput = {
  /** Schedule ID. */
  scheduleId?: InputMaybe<Scalars['String']>;
  /** Owner ID, of the linked schedule. */
  scheduleOwnerId?: InputMaybe<Scalars['String']>;
  /**
   * The name of the linked schedule owner. It may be a resource name or a service name. Optional.
   * This field is inherited from the schedule identified by scheduleId above.
   */
  scheduleOwnerName?: InputMaybe<Scalars['String']>;
  /**
   * The user id of the linked schedule owner. Optional.
   * This field is inherited from the schedule identified by scheduleId above.
   * NOT IMPLEMENTED. YET.
   */
  scheduleOwnerUserId?: InputMaybe<Scalars['String']>;
  /** Sets this schedule's availability for the duration of the linked schedule's sessions. Default is `"BUSY"`. */
  transparency?: InputMaybe<ComWixBookingsSchedulesApiV1LinkedScheduleTransparency>;
};

export enum ComWixBookingsSchedulesApiV1LinkedScheduleTransparency {
  /** The schedule can't have available slots during the linked schedule's sessions. */
  Busy = 'BUSY',
  /** The schedule can have available slots during the linked schedule's sessions. */
  Free = 'FREE',
  Undefined = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1LocalDateTime = {
  __typename?: 'ComWixBookingsSchedulesApiV1LocalDateTime';
  /** Day of the month, from 1-31. */
  dayOfMonth?: Maybe<Scalars['Int']>;
  /** Hour of the day in 24-hour format, from 0-23. */
  hourOfDay?: Maybe<Scalars['Int']>;
  /** Minute, from 0-59. */
  minutesOfHour?: Maybe<Scalars['Int']>;
  /** Month number, from 1-12. */
  monthOfYear?: Maybe<Scalars['Int']>;
  /** Year. 4-digit format. */
  year?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1LocalDateTimeInput = {
  /** Day of the month, from 1-31. */
  dayOfMonth?: InputMaybe<Scalars['Int']>;
  /** Hour of the day in 24-hour format, from 0-23. */
  hourOfDay?: InputMaybe<Scalars['Int']>;
  /** Minute, from 0-59. */
  minutesOfHour?: InputMaybe<Scalars['Int']>;
  /** Month number, from 1-12. */
  monthOfYear?: InputMaybe<Scalars['Int']>;
  /** Year. 4-digit format. */
  year?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1MigrationDataInput = {
  businessId?: InputMaybe<Scalars['String']>;
  staffs?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1MigrationDataStaffDataInput>>>;
};

export type ComWixBookingsSchedulesApiV1MigrationDataStaffDataInput = {
  refreshToken?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
  syncRequestEmail?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1MigrationEventInput = {
  migrationData?: InputMaybe<ComWixBookingsSchedulesApiV1MigrationDataInput>;
};

export type ComWixBookingsSchedulesApiV1MultipleSessionsCreatedInput = {
  schedulesWithSessions?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1ScheduleWithSessionsInput>>>;
};

export type ComWixBookingsSchedulesApiV1Participant = {
  __typename?: 'ComWixBookingsSchedulesApiV1Participant';
  /**
   * Approval status for the participant.
   * <!-- Commented out untill updateParticipant is exposed Generally the same status as the booking, unless updated using the `updateParticipant()` API. Defaults to `"UNDEFINED"`.-->
   */
  approvalStatus?: Maybe<ComWixBookingsSchedulesApiV1ParticipantApprovalStatus>;
  /** Contact ID. */
  contactId?: Maybe<Scalars['String']>;
  /** Participant's email address. */
  email?: Maybe<Scalars['String']>;
  /** Participant ID. Currently represents the booking.id. */
  id?: Maybe<Scalars['String']>;
  /** Whether the participant was inherited from the schedule, as opposed to being booked directly to the session. */
  inherited?: Maybe<Scalars['Boolean']>;
  /** Participant's name. */
  name?: Maybe<Scalars['String']>;
  /** Group or party size. The number of people attending. Defaults to 0. Maximum is 250. */
  partySize?: Maybe<Scalars['Int']>;
  /** Participant's phone number. */
  phone?: Maybe<Scalars['String']>;
};

export enum ComWixBookingsSchedulesApiV1ParticipantApprovalStatus {
  /** Approved by the business. */
  Approved = 'APPROVED',
  /** Declined by the business. */
  Declined = 'DECLINED',
  /** Pending business approval. */
  Pending = 'PENDING',
  /** Default. */
  Undefined = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1ParticipantInput = {
  /**
   * Approval status for the participant.
   * <!-- Commented out untill updateParticipant is exposed Generally the same status as the booking, unless updated using the `updateParticipant()` API. Defaults to `"UNDEFINED"`.-->
   */
  approvalStatus?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantApprovalStatus>;
  /** Contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Participant's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Participant ID. Currently represents the booking.id. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether the participant was inherited from the schedule, as opposed to being booked directly to the session. */
  inherited?: InputMaybe<Scalars['Boolean']>;
  /** Participant's name. */
  name?: InputMaybe<Scalars['String']>;
  /** Group or party size. The number of people attending. Defaults to 0. Maximum is 250. */
  partySize?: InputMaybe<Scalars['Int']>;
  /** Participant's phone number. */
  phone?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1ParticipantNotificationInput = {
  /** Custom message to send to the participants about the changes to the booking. */
  message?: InputMaybe<Scalars['String']>;
  /**
   * Optional additional metadata.
   * Supported only in V3 APIs.
   */
  metadata?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to send the message about the changes to the customer.
   *
   * Default: `false`
   */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixBookingsSchedulesApiV1RecurringInterval = {
  __typename?: 'ComWixBookingsSchedulesApiV1RecurringInterval';
  /** Specifies the list of linked schedules and the way this link affects the corresponding schedules' availability. Can be calculated from the schedule or overridden on the recurring interval. */
  affectedSchedules?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1LinkedSchedule>>>;
  /** The end time of the recurring interval. Optional. Empty value indicates that there is no end time. */
  end?: Maybe<Scalars['String']>;
  /** The frequency of the interval. Optional. The default is frequency with the default repetition. */
  frequency?: Maybe<ComWixBookingsSchedulesApiV1Frequency>;
  /** The recurring interval identifier. */
  id?: Maybe<Scalars['String']>;
  /** The interval rules. The day, hour and minutes the interval is recurring. */
  interval?: Maybe<ComWixBookingsSchedulesApiV1Interval>;
  /** The type of recurring interval. */
  intervalType?: Maybe<ComWixBookingsSchedulesApiV1RecurringIntervalRecurringIntervalType>;
  /** The start time of the recurring interval. Required. */
  start?: Maybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1RecurringIntervalInput = {
  /** Specifies the list of linked schedules and the way this link affects the corresponding schedules' availability. Can be calculated from the schedule or overridden on the recurring interval. */
  affectedSchedules?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1LinkedScheduleInput>>>;
  /** The end time of the recurring interval. Optional. Empty value indicates that there is no end time. */
  end?: InputMaybe<Scalars['String']>;
  /** The frequency of the interval. Optional. The default is frequency with the default repetition. */
  frequency?: InputMaybe<ComWixBookingsSchedulesApiV1FrequencyInput>;
  /** The recurring interval identifier. */
  id?: InputMaybe<Scalars['String']>;
  /** The interval rules. The day, hour and minutes the interval is recurring. */
  interval?: InputMaybe<ComWixBookingsSchedulesApiV1IntervalInput>;
  /** The type of recurring interval. */
  intervalType?: InputMaybe<ComWixBookingsSchedulesApiV1RecurringIntervalRecurringIntervalType>;
  /** The start time of the recurring interval. Required. */
  start?: InputMaybe<Scalars['String']>;
};

export enum ComWixBookingsSchedulesApiV1RecurringIntervalRecurringIntervalType {
  /** A recurring interval for availability. */
  Availability = 'AVAILABILITY',
  /** A recurring interval of events. */
  Event = 'EVENT',
  /** Deprecated. */
  TimeAvailability = 'TIME_AVAILABILITY',
  /** The default value. Sessions for this interval will be of type EVENT. */
  Undefined = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1RecurringSessionSplitInput = {
  newScheduleVersion?: InputMaybe<Scalars['Int']>;
  oldScheduleVersion?: InputMaybe<Scalars['Int']>;
  recurringSessions?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>>>;
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1RecurringSessionsUpdatedInput = {
  /** New schedule's recurring session list. */
  newRecurringSessions?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>>>;
  /** Old schedule's recurring session list. */
  oldRecurringSessions?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>>>;
};

export type ComWixBookingsSchedulesApiV1Schedule = {
  __typename?: 'ComWixBookingsSchedulesApiV1Schedule';
  /** __Deprecated.__ */
  availability?: Maybe<ComWixBookingsSchedulesApiV1Availability>;
  /**
   * A conference created for the schedule. This is used when a participant is added to a schedule.
   * **Partially deprecated.** Only `hostUrl` and `guestUrl` are to be supported.
   */
  calendarConference?: Maybe<ComWixBookingsSchedulesApiV1CalendarConference>;
  /**
   * Maximum number of participants that can be added to the schedule's sessions.
   * Must be at most `1` for schedule whose availability is affected by another schedule. E.g, appointment schedules of the Wix Bookings app.
   */
  capacity?: Maybe<Scalars['Int']>;
  /** __Deprecated.__ */
  conferenceProvider?: Maybe<ComWixBookingsSchedulesApiV1ConferenceProvider>;
  /** Schedule creation date. */
  created?: Maybe<Scalars['String']>;
  /** __Deprecated.__ */
  externalCalendarOverrides?: Maybe<ComWixBookingsSchedulesApiV1ExternalCalendarOverrides>;
  /** Start time of the first session in the schedule. */
  firstSessionStart?: Maybe<Scalars['String']>;
  /** Schedule ID. */
  id?: Maybe<Scalars['String']>;
  /** Fields which were inherited from the Business Info page under Settings in the Dashboard. */
  inheritedFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Deprecated. Please use the [Sessions API](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session) instead. */
  intervals?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1RecurringInterval>>>;
  /** End time of the last session in the schedule. */
  lastSessionEnd?: Maybe<Scalars['String']>;
  /** Default location for the schedule's sessions. */
  location?: Maybe<ComWixBookingsCommonApiV1Location>;
  /**
   * *Partial list** of participants which are registered to sessions in this schedule.
   * Participants who are registered in the schedule are automatically registered to any session that is created for the schedule.
   * To retrieve the full list of schedule participants please use the [Query Extended Bookings API](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/query-extended-bookings).
   */
  participants?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Participant>>>;
  /** Deprecated. Please use the [Booking Services V2](https://dev.wix.com/api/rest/wix-bookings/services-v2) payment instead. */
  rate?: Maybe<ComWixBookingsCommonApiV1Rate>;
  /** ID of the schedule's owner entity. This may be a resource ID or a service ID. */
  scheduleOwnerId?: Maybe<Scalars['String']>;
  /** The name of the schedule owner. It may be a resource name or a service name. Optional. */
  scheduleOwnerName?: Maybe<Scalars['String']>;
  /**
   * The user id of the schedule owner. Optional.
   * Currently, in Bookings system, it would be present when the schedule is owned by a staff resource and the resource is connected to a user.
   * NOT IMPLEMENTED. YET.
   */
  scheduleOwnerUserId?: Maybe<Scalars['String']>;
  /** Schedule status. Default: Created */
  status?: Maybe<ComWixBookingsSchedulesApiV1ScheduleScheduleStatus>;
  /**
   * __Deprecated.__
   * Tags for grouping schedules. These tags are the default tags for the schedule's sessions.
   * The Wix Bookings app uses the following predefined tags to set schedule type: `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE"`. Once the schedule type is set using these tags, you cannot update it. In addition to the app's tags, you can create and update your own tags.
   */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Schedule's time zone in [Area/Location](https://en.wikipedia.org/wiki/Tz_database) format. Read-only.
   * Derived from the Wix Business time zone.
   */
  timeZone?: Maybe<Scalars['String']>;
  /** Default title for the schedule's sessions. Maximum length: 6000 characters. */
  title?: Maybe<Scalars['String']>;
  /** Number of participants registered to sessions in this schedule, calculated as the sum of the party sizes. */
  totalNumberOfParticipants?: Maybe<Scalars['Int']>;
  /** Schedule last update date. */
  updated?: Maybe<Scalars['String']>;
  /** Schedule version number, updated each time the schedule is updated. */
  version?: Maybe<Scalars['Int']>;
  /** The schedule version, updated each time the schedule or the schedule participants are updated. */
  versions?: Maybe<ComWixBookingsSchedulesApiV1ScheduleVersion>;
};

export type ComWixBookingsSchedulesApiV1ScheduleCancelledInput = {
  oldSchedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  /** Whether to notify participants about the change and an optional custom message */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
};

export type ComWixBookingsSchedulesApiV1ScheduleCreatedInput = {
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
};

export type ComWixBookingsSchedulesApiV1ScheduleInput = {
  /** __Deprecated.__ */
  availability?: InputMaybe<ComWixBookingsSchedulesApiV1AvailabilityInput>;
  /**
   * A conference created for the schedule. This is used when a participant is added to a schedule.
   * **Partially deprecated.** Only `hostUrl` and `guestUrl` are to be supported.
   */
  calendarConference?: InputMaybe<ComWixBookingsSchedulesApiV1CalendarConferenceInput>;
  /**
   * Maximum number of participants that can be added to the schedule's sessions.
   * Must be at most `1` for schedule whose availability is affected by another schedule. E.g, appointment schedules of the Wix Bookings app.
   */
  capacity?: InputMaybe<Scalars['Int']>;
  /** __Deprecated.__ */
  conferenceProvider?: InputMaybe<ComWixBookingsSchedulesApiV1ConferenceProviderInput>;
  /** Schedule creation date. */
  created?: InputMaybe<Scalars['String']>;
  /** __Deprecated.__ */
  externalCalendarOverrides?: InputMaybe<ComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput>;
  /** Start time of the first session in the schedule. */
  firstSessionStart?: InputMaybe<Scalars['String']>;
  /** Schedule ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Fields which were inherited from the Business Info page under Settings in the Dashboard. */
  inheritedFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Deprecated. Please use the [Sessions API](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session) instead. */
  intervals?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1RecurringIntervalInput>>>;
  /** End time of the last session in the schedule. */
  lastSessionEnd?: InputMaybe<Scalars['String']>;
  /** Default location for the schedule's sessions. */
  location?: InputMaybe<ComWixBookingsCommonApiV1LocationInput>;
  /**
   * *Partial list** of participants which are registered to sessions in this schedule.
   * Participants who are registered in the schedule are automatically registered to any session that is created for the schedule.
   * To retrieve the full list of schedule participants please use the [Query Extended Bookings API](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/query-extended-bookings).
   */
  participants?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1ParticipantInput>>>;
  /** Deprecated. Please use the [Booking Services V2](https://dev.wix.com/api/rest/wix-bookings/services-v2) payment instead. */
  rate?: InputMaybe<ComWixBookingsCommonApiV1RateInput>;
  /** ID of the schedule's owner entity. This may be a resource ID or a service ID. */
  scheduleOwnerId?: InputMaybe<Scalars['String']>;
  /** The name of the schedule owner. It may be a resource name or a service name. Optional. */
  scheduleOwnerName?: InputMaybe<Scalars['String']>;
  /**
   * The user id of the schedule owner. Optional.
   * Currently, in Bookings system, it would be present when the schedule is owned by a staff resource and the resource is connected to a user.
   * NOT IMPLEMENTED. YET.
   */
  scheduleOwnerUserId?: InputMaybe<Scalars['String']>;
  /** Schedule status. Default: Created */
  status?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleScheduleStatus>;
  /**
   * __Deprecated.__
   * Tags for grouping schedules. These tags are the default tags for the schedule's sessions.
   * The Wix Bookings app uses the following predefined tags to set schedule type: `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE"`. Once the schedule type is set using these tags, you cannot update it. In addition to the app's tags, you can create and update your own tags.
   */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Schedule's time zone in [Area/Location](https://en.wikipedia.org/wiki/Tz_database) format. Read-only.
   * Derived from the Wix Business time zone.
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /** Default title for the schedule's sessions. Maximum length: 6000 characters. */
  title?: InputMaybe<Scalars['String']>;
  /** Number of participants registered to sessions in this schedule, calculated as the sum of the party sizes. */
  totalNumberOfParticipants?: InputMaybe<Scalars['Int']>;
  /** Schedule last update date. */
  updated?: InputMaybe<Scalars['String']>;
  /** Schedule version number, updated each time the schedule is updated. */
  version?: InputMaybe<Scalars['Int']>;
  /** The schedule version, updated each time the schedule or the schedule participants are updated. */
  versions?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleVersionInput>;
};

export type ComWixBookingsSchedulesApiV1ScheduleNotificationInput = {
  availabilityPolicyUpdated?: InputMaybe<ComWixBookingsSchedulesApiV1AvailabilityPolicyUpdatedInput>;
  instanceId?: InputMaybe<Scalars['String']>;
  intervalSplit?: InputMaybe<ComWixBookingsSchedulesApiV1IntervalSplitInput>;
  /** supported only for schedule migration apis. */
  migrationEvent?: InputMaybe<ComWixBookingsSchedulesApiV1MigrationEventInput>;
  /** supported only for schedule migration apis. */
  multipleSessionsCreated?: InputMaybe<ComWixBookingsSchedulesApiV1MultipleSessionsCreatedInput>;
  /** Whether to notify participants about changed sessions. deprecated, use participant_notification */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
  recurringSessionSplit?: InputMaybe<ComWixBookingsSchedulesApiV1RecurringSessionSplitInput>;
  /** true when the schedule belongs to a site that is rolled out to calendar v3 */
  rolledOut?: InputMaybe<Scalars['Boolean']>;
  scheduleCancelled?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleCancelledInput>;
  scheduleCreated?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleCreatedInput>;
  /** Inspect `schedule.scheduleOwnerUserId` on `scheduleUpdated` instead. */
  scheduleUnassignedFromUser?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleUnassignedFromUserInput>;
  scheduleUpdated?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleUpdatedInput>;
  sessionCancelled?: InputMaybe<ComWixBookingsSchedulesApiV1SessionCancelledInput>;
  sessionCreated?: InputMaybe<ComWixBookingsSchedulesApiV1SessionCreatedInput>;
  sessionUpdated?: InputMaybe<ComWixBookingsSchedulesApiV1SessionUpdatedInput>;
  /** site properties. Optional. Given in create schedule notification. */
  siteProperties?: InputMaybe<ComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput>;
};

export enum ComWixBookingsSchedulesApiV1ScheduleScheduleStatus {
  /** The schedule was cancelled. */
  Cancelled = 'CANCELLED',
  /** The schedule was created. */
  Created = 'CREATED',
  /** Undefined schedule status. */
  Undefined = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1ScheduleUnassignedFromUserInput = {
  /** The schedule that was unassigned from the user. */
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  /** The Wix user id. */
  userId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1ScheduleUpdatedInput = {
  /** The new schedule after the update. */
  newSchedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  /** The old schedule before the update. */
  oldSchedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  /** Whether to notify participants about the change and an optional custom message */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /**
   * Recurring sessions updated event. If this field is given, the reason for the schedule updated event was
   * updating at least one of the given schedule's recurring sessions.
   * This event is triggered by create/update/delete recurring session apis.
   */
  recurringSessions?: InputMaybe<ComWixBookingsSchedulesApiV1RecurringSessionsUpdatedInput>;
  /**
   * Whether this notification was created as a result of an anonymization request, such as GDPR.
   * An anonymized participant will have the following details:
   * name = "deleted"
   * phone = "deleted"
   * email = "deleted@deleted.com"
   */
  triggeredByAnonymizeRequest?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixBookingsSchedulesApiV1ScheduleVersion = {
  __typename?: 'ComWixBookingsSchedulesApiV1ScheduleVersion';
  /** Participants version number, updated each time the schedule participants are updated. */
  participantsVersion?: Maybe<Scalars['Int']>;
  /** Schedule version number, updated each time the schedule is updated. */
  scheduleVersion?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1ScheduleVersionInput = {
  /** Participants version number, updated each time the schedule participants are updated. */
  participantsVersion?: InputMaybe<Scalars['Int']>;
  /** Schedule version number, updated each time the schedule is updated. */
  scheduleVersion?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1ScheduleWithSessionsInput = {
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  sessions?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>>>;
  siteProperties?: InputMaybe<ComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput>;
};

export type ComWixBookingsSchedulesApiV1Session = {
  __typename?: 'ComWixBookingsSchedulesApiV1Session';
  /**
   * An object specifying a list of schedules and the way each schedule's availability is affected by the session. For example, the schedule of an instructor is affected by sessions of the class that they instruct.
   * The array is inherited from the schedule and can be overridden even if the session is a recurring session.
   */
  affectedSchedules?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1LinkedSchedule>>>;
  /**
   * A conference created for the session according to the details set in the schedule's conference provider information.
   * If the session is a recurring session, this field is inherited from the schedule.
   * **Partially deprecated.** Only `hostUrl` and `guestUrl` are to be supported.
   */
  calendarConference?: Maybe<ComWixBookingsSchedulesApiV1CalendarConference>;
  /**
   * Maximum number of participants that can be added to the session. Defaults to the schedule capacity.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  capacity?: Maybe<Scalars['Int']>;
  /**
   * An object specifying the end date and time of the session. The `end` time must be after the `start` time and be same type as `start`.
   * If the session is a recurring session, `end` must contain a `localDateTime`.
   */
  end?: Maybe<ComWixBookingsSchedulesApiV1CalendarDateTime>;
  /** The ID of the event in the new Calendar Events V3 API. */
  event?: Maybe<WixCalendarEventsV3Event>;
  /** The ID of the event in the new Calendar Events V3 API. */
  eventId?: Maybe<Scalars['String']>;
  /** Information about the external calendar, if the session originated in an external calendar. */
  externalCalendarInfo?: Maybe<ComWixBookingsSchedulesApiV1ExternalCalendarInfo>;
  /** __Deprecated.__ */
  externalCalendarOverrides?: Maybe<ComWixBookingsSchedulesApiV1ExternalCalendarOverrides>;
  /** Session ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * A list of properties for which values were inherited from the schedule.
   * This does not include participants that were inherited from the schedule.
   */
  inheritedFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A string representing a recurrence rule (RRULE) if the session is an instance of a recurrence pattern.
   * Empty when the session is not an instance of a recurrence rule, or if the session defines a recurrence pattern, and `recurrence` is not empty.
   */
  instanceOfRecurrence?: Maybe<Scalars['String']>;
  /**
   * An object describing the location where the session takes place.
   * Defaults to the schedule location.
   * For single sessions, `session.location.businessLocation` can only be provided for locations that are defined in the schedule using `schedule.location` or `schedule.availability.locations`.
   */
  location?: Maybe<ComWixBookingsCommonApiV1Location>;
  /**
   * Additional information about the session.
   * Notes are not supported for recurring sessions.
   */
  notes?: Maybe<Scalars['String']>;
  /** Original start date and time of the session in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)) format. */
  originalStart?: Maybe<Scalars['String']>;
  /**
   * *Partial list** list of participants booked for the session.
   * The list includes participants who have registered for this specific session, and participants who have registered for a schedule that includes this session.
   * If the session is a recurring session, this field must be empty.
   * To retrieve the full list of session participants please use the [Query Extended Bookings API](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/query-extended-bookings).
   */
  participants?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Participant>>>;
  /** Deprecated. Please use the [Booking Services V2](https://dev.wix.com/api/rest/wix-bookings/services-v2) payment instead. */
  rate?: Maybe<ComWixBookingsCommonApiV1Rate>;
  /**
   * A string representing a recurrence rule (RRULE) for a recurring session, as defined in [iCalendar RFC 5545](https://icalendar.org/iCalendar-RFC-5545/3-3-10-recurrence-rule.html).
   * If the session is an instance of a recurrence pattern, the `instanceOfRecurrence` property will be contain the recurrence rule and this property will be empty.
   * The RRULE defines a rule for repeating a session.
   * Supported parameters are:
   *
   * |Keyword|Description|Supported values|
   * |--|--|---|
   * |`FREQ`|The frequency at which the session is recurs. Required.|`WEEKLY`|
   * |`INTERVAL`|How often, in terms of `FREQ`, the session recurs. Default is 1. Optional.|
   * |`UNTIL`|The UTC end date and time of the recurrence. Optional.|
   * |`BYDAY`|Day of the week when the event should recur. Required.|One of: `MO`, `TU`, `WE`, `TH`, `FR`, `SA`, `SU`|
   *
   *
   * For example, a session that repeats every second week on a Monday until January 7, 2022 at 8 AM:
   * `"FREQ=WEEKLY;INTERVAL=2;BYDAY=MO;UNTIL=20220107T080000Z"`
   *
   * <!--ORIGINAL COMMENTS:
   * `FREQ` — The frequency with which the session should be repeated (such as DAILY or WEEKLY).
   * Supported `WEEKLY` value is supported.
   * INTERVAL — Works together with FREQ to specify how often the session should be repeated. For example, FREQ=WEEKLY;INTERVAL=2 means once every two weeks. Optional. Default value is 1.
   * COUNT — The number of times this event should be repeated. Not yet supported.
   * UNTIL — The UTC date & time until which the session should be repeated. This parameter is optional. When it is not specified, the event repeats forever.
   * The format is a short ISO date, followed by 'T' and a short time with seconds and without milliseconds, terminated by the UTC designator 'Z'. For example, until Jan. 19th 2018 at 7:00 AM: 'UNTIL=20180119T070000Z'.
   * BYDAY - The days of the week when the event should be repeated. Currently, only a single day is supported. This parameter is mandatory.
   * Possible values are: MO, TU, WE, TH, FR, SA, SU
   * Note that DTSTART and DTEND lines are not allowed in this field; session start and end times are specified in the start and end fields.
   * **Example**: FREQ=WEEKLY;INTERVAL=2;BYDAY=MO;UNTIL=20200427T070000Z
   * ORIGINAL COMMENTS-->
   */
  recurrence?: Maybe<Scalars['String']>;
  /**
   * Recurring interval ID. Defined when a session will be a recurring session. read-only. Optional.
   * For example, when creating a class service  with recurring sessions, you add a recurrence rule to create recurring sessions.
   * This field is omitted for single sessions or instances of recurring sessions.
   * Specified when the session was originally generated from a schedule recurring interval.
   * Deprecated. Use `recurringSessionId`.
   */
  recurringIntervalId?: Maybe<Scalars['String']>;
  /** The ID of the recurring session if this session is an instance of a recurrence. Use this ID to update the recurrence and all of the instances. */
  recurringSessionId?: Maybe<Scalars['String']>;
  /**
   * The remaining number of participants that can be added to the session. Read-only.
   * Can be negative, in case the session is over capacity.
   */
  remainingCapacity?: Maybe<Scalars['Int']>;
  /** ID of the schedule that the session belongs to. */
  scheduleId?: Maybe<Scalars['String']>;
  /** ID of the resource or service that the session's schedule belongs to. */
  scheduleOwnerId?: Maybe<Scalars['String']>;
  /** The name of the schedule owner. It may be a resource name or a service name. Optional. */
  scheduleOwnerName?: Maybe<Scalars['String']>;
  /**
   * The user id of the schedule owner. Optional.
   * NOT IMPLEMENTED YET.
   */
  scheduleOwnerUserId?: Maybe<Scalars['String']>;
  /** An object specifying the start date and time of the session. If the session is a recurring session, `start` must contain a `localDateTime`. */
  start?: Maybe<ComWixBookingsSchedulesApiV1CalendarDateTime>;
  /** Session status. */
  status?: Maybe<ComWixBookingsSchedulesApiV1SessionStatus>;
  /**
   * __Deprecated.__
   * Tags for the session.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Time reserved after the session end time, derived from the schedule availability constraints and the time between slots. Read-only.
   * If the session is a recurring session, this field must be empty.
   */
  timeReservedAfter?: Maybe<Scalars['Int']>;
  /**
   * Session title.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  title?: Maybe<Scalars['String']>;
  /**
   * The number of participants booked for the session. Read-only.
   * Calculated as the sum of the party sizes.
   */
  totalNumberOfParticipants?: Maybe<Scalars['Int']>;
  /** Session type. */
  type?: Maybe<ComWixBookingsSchedulesApiV1SessionType>;
  /**
   * The session version.
   * Composed by the schedule, session and participants versions.
   */
  version?: Maybe<ComWixBookingsSchedulesApiV1SessionVersion>;
};

export type ComWixBookingsSchedulesApiV1SessionCancelledInput = {
  /** Whether to notify participants about the change and an optional custom message */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
};

export type ComWixBookingsSchedulesApiV1SessionCreatedInput = {
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
};

export type ComWixBookingsSchedulesApiV1SessionInput = {
  /**
   * An object specifying a list of schedules and the way each schedule's availability is affected by the session. For example, the schedule of an instructor is affected by sessions of the class that they instruct.
   * The array is inherited from the schedule and can be overridden even if the session is a recurring session.
   */
  affectedSchedules?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1LinkedScheduleInput>>>;
  /**
   * A conference created for the session according to the details set in the schedule's conference provider information.
   * If the session is a recurring session, this field is inherited from the schedule.
   * **Partially deprecated.** Only `hostUrl` and `guestUrl` are to be supported.
   */
  calendarConference?: InputMaybe<ComWixBookingsSchedulesApiV1CalendarConferenceInput>;
  /**
   * Maximum number of participants that can be added to the session. Defaults to the schedule capacity.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  capacity?: InputMaybe<Scalars['Int']>;
  /**
   * An object specifying the end date and time of the session. The `end` time must be after the `start` time and be same type as `start`.
   * If the session is a recurring session, `end` must contain a `localDateTime`.
   */
  end?: InputMaybe<ComWixBookingsSchedulesApiV1CalendarDateTimeInput>;
  /** The ID of the event in the new Calendar Events V3 API. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Information about the external calendar, if the session originated in an external calendar. */
  externalCalendarInfo?: InputMaybe<ComWixBookingsSchedulesApiV1ExternalCalendarInfoInput>;
  /** __Deprecated.__ */
  externalCalendarOverrides?: InputMaybe<ComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput>;
  /** Session ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * A list of properties for which values were inherited from the schedule.
   * This does not include participants that were inherited from the schedule.
   */
  inheritedFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * A string representing a recurrence rule (RRULE) if the session is an instance of a recurrence pattern.
   * Empty when the session is not an instance of a recurrence rule, or if the session defines a recurrence pattern, and `recurrence` is not empty.
   */
  instanceOfRecurrence?: InputMaybe<Scalars['String']>;
  /**
   * An object describing the location where the session takes place.
   * Defaults to the schedule location.
   * For single sessions, `session.location.businessLocation` can only be provided for locations that are defined in the schedule using `schedule.location` or `schedule.availability.locations`.
   */
  location?: InputMaybe<ComWixBookingsCommonApiV1LocationInput>;
  /**
   * Additional information about the session.
   * Notes are not supported for recurring sessions.
   */
  notes?: InputMaybe<Scalars['String']>;
  /** Original start date and time of the session in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)) format. */
  originalStart?: InputMaybe<Scalars['String']>;
  /**
   * *Partial list** list of participants booked for the session.
   * The list includes participants who have registered for this specific session, and participants who have registered for a schedule that includes this session.
   * If the session is a recurring session, this field must be empty.
   * To retrieve the full list of session participants please use the [Query Extended Bookings API](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/query-extended-bookings).
   */
  participants?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1ParticipantInput>>>;
  /** Deprecated. Please use the [Booking Services V2](https://dev.wix.com/api/rest/wix-bookings/services-v2) payment instead. */
  rate?: InputMaybe<ComWixBookingsCommonApiV1RateInput>;
  /**
   * A string representing a recurrence rule (RRULE) for a recurring session, as defined in [iCalendar RFC 5545](https://icalendar.org/iCalendar-RFC-5545/3-3-10-recurrence-rule.html).
   * If the session is an instance of a recurrence pattern, the `instanceOfRecurrence` property will be contain the recurrence rule and this property will be empty.
   * The RRULE defines a rule for repeating a session.
   * Supported parameters are:
   *
   * |Keyword|Description|Supported values|
   * |--|--|---|
   * |`FREQ`|The frequency at which the session is recurs. Required.|`WEEKLY`|
   * |`INTERVAL`|How often, in terms of `FREQ`, the session recurs. Default is 1. Optional.|
   * |`UNTIL`|The UTC end date and time of the recurrence. Optional.|
   * |`BYDAY`|Day of the week when the event should recur. Required.|One of: `MO`, `TU`, `WE`, `TH`, `FR`, `SA`, `SU`|
   *
   *
   * For example, a session that repeats every second week on a Monday until January 7, 2022 at 8 AM:
   * `"FREQ=WEEKLY;INTERVAL=2;BYDAY=MO;UNTIL=20220107T080000Z"`
   *
   * <!--ORIGINAL COMMENTS:
   * `FREQ` — The frequency with which the session should be repeated (such as DAILY or WEEKLY).
   * Supported `WEEKLY` value is supported.
   * INTERVAL — Works together with FREQ to specify how often the session should be repeated. For example, FREQ=WEEKLY;INTERVAL=2 means once every two weeks. Optional. Default value is 1.
   * COUNT — The number of times this event should be repeated. Not yet supported.
   * UNTIL — The UTC date & time until which the session should be repeated. This parameter is optional. When it is not specified, the event repeats forever.
   * The format is a short ISO date, followed by 'T' and a short time with seconds and without milliseconds, terminated by the UTC designator 'Z'. For example, until Jan. 19th 2018 at 7:00 AM: 'UNTIL=20180119T070000Z'.
   * BYDAY - The days of the week when the event should be repeated. Currently, only a single day is supported. This parameter is mandatory.
   * Possible values are: MO, TU, WE, TH, FR, SA, SU
   * Note that DTSTART and DTEND lines are not allowed in this field; session start and end times are specified in the start and end fields.
   * **Example**: FREQ=WEEKLY;INTERVAL=2;BYDAY=MO;UNTIL=20200427T070000Z
   * ORIGINAL COMMENTS-->
   */
  recurrence?: InputMaybe<Scalars['String']>;
  /**
   * Recurring interval ID. Defined when a session will be a recurring session. read-only. Optional.
   * For example, when creating a class service  with recurring sessions, you add a recurrence rule to create recurring sessions.
   * This field is omitted for single sessions or instances of recurring sessions.
   * Specified when the session was originally generated from a schedule recurring interval.
   * Deprecated. Use `recurringSessionId`.
   */
  recurringIntervalId?: InputMaybe<Scalars['String']>;
  /** The ID of the recurring session if this session is an instance of a recurrence. Use this ID to update the recurrence and all of the instances. */
  recurringSessionId?: InputMaybe<Scalars['String']>;
  /**
   * The remaining number of participants that can be added to the session. Read-only.
   * Can be negative, in case the session is over capacity.
   */
  remainingCapacity?: InputMaybe<Scalars['Int']>;
  /** ID of the schedule that the session belongs to. */
  scheduleId?: InputMaybe<Scalars['String']>;
  /** ID of the resource or service that the session's schedule belongs to. */
  scheduleOwnerId?: InputMaybe<Scalars['String']>;
  /** The name of the schedule owner. It may be a resource name or a service name. Optional. */
  scheduleOwnerName?: InputMaybe<Scalars['String']>;
  /**
   * The user id of the schedule owner. Optional.
   * NOT IMPLEMENTED YET.
   */
  scheduleOwnerUserId?: InputMaybe<Scalars['String']>;
  /** An object specifying the start date and time of the session. If the session is a recurring session, `start` must contain a `localDateTime`. */
  start?: InputMaybe<ComWixBookingsSchedulesApiV1CalendarDateTimeInput>;
  /** Session status. */
  status?: InputMaybe<ComWixBookingsSchedulesApiV1SessionStatus>;
  /**
   * __Deprecated.__
   * Tags for the session.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Time reserved after the session end time, derived from the schedule availability constraints and the time between slots. Read-only.
   * If the session is a recurring session, this field must be empty.
   */
  timeReservedAfter?: InputMaybe<Scalars['Int']>;
  /**
   * Session title.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  title?: InputMaybe<Scalars['String']>;
  /**
   * The number of participants booked for the session. Read-only.
   * Calculated as the sum of the party sizes.
   */
  totalNumberOfParticipants?: InputMaybe<Scalars['Int']>;
  /** Session type. */
  type?: InputMaybe<ComWixBookingsSchedulesApiV1SessionType>;
  /**
   * The session version.
   * Composed by the schedule, session and participants versions.
   */
  version?: InputMaybe<ComWixBookingsSchedulesApiV1SessionVersionInput>;
};

export enum ComWixBookingsSchedulesApiV1SessionStatus {
  /**
   * Session is cancelled.
   * A cancelled session can be the cancellation of a recurring session that should no longer be displayed or a deleted single session.
   * The ListSessions returns cancelled sessions only if 'includeDelete' flag is set to true.
   */
  Cancelled = 'CANCELLED',
  /** Session is confirmed. Default status. */
  Confirmed = 'CONFIRMED',
  /** Undefined status. */
  Undefined = 'UNDEFINED'
}

export enum ComWixBookingsSchedulesApiV1SessionType {
  /** Deprecated. Represents a resource's available hours. Please use WORKING_HOURS. */
  Availability = 'AVAILABILITY',
  /**
   * Creates an event on the calendar for the owner of the schedule that the session belongs to.
   * Default type.
   */
  Event = 'EVENT',
  /** Deprecated. Please use WORKING_HOURS. */
  TimeAvailability = 'TIME_AVAILABILITY',
  Undefined = 'UNDEFINED',
  /** Represents a resource's available working hours. */
  WorkingHours = 'WORKING_HOURS'
}

export type ComWixBookingsSchedulesApiV1SessionUpdatedInput = {
  newSession?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  oldSession?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** Whether to notify participants about the change and an optional custom message */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /**
   * Whether this notification was created as a result of an anonymization request, such as GDPR.
   * An anonymized participant will have the following details:
   * name = "deleted"
   * phone = "deleted"
   * email = "deleted@deleted.com"
   */
  triggeredByAnonymizeRequest?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixBookingsSchedulesApiV1SessionVersion = {
  __typename?: 'ComWixBookingsSchedulesApiV1SessionVersion';
  /** Incremental version number, which is updated on each change to the session or on changes affecting the session. */
  number?: Maybe<Scalars['Long']>;
  /** Participants version number, updated each time the session participants are updated. */
  participantsVersion?: Maybe<Scalars['Int']>;
  /** Schedule version number, updated each time the schedule is updated. */
  scheduleVersion?: Maybe<Scalars['Int']>;
  /** Session version number, updated each time the session is updated. */
  sessionVersion?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1SessionVersionInput = {
  /** Incremental version number, which is updated on each change to the session or on changes affecting the session. */
  number?: InputMaybe<Scalars['Long']>;
  /** Participants version number, updated each time the session participants are updated. */
  participantsVersion?: InputMaybe<Scalars['Int']>;
  /** Schedule version number, updated each time the schedule is updated. */
  scheduleVersion?: InputMaybe<Scalars['Int']>;
  /** Session version number, updated each time the session is updated. */
  sessionVersion?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput = {
  /** The global time zone value. */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1SplitInterval = {
  __typename?: 'ComWixBookingsSchedulesApiV1SplitInterval';
  /**
   * Whether the slot duration is used as the split interval value.
   * If `same_as_duration` is `true`, the `value_in_minutes` is the sum of the first duration in
   * `schedule.availabilityConstraints.SlotDurations` field, and `schedule.availabilityConstraints.TimeBetweenSlots` field.
   */
  sameAsDuration?: Maybe<Scalars['Boolean']>;
  /** Number of minutes between available slots' start times when `same_as_duration` is `false`. */
  valueInMinutes?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1SplitIntervalInput = {
  /**
   * Whether the slot duration is used as the split interval value.
   * If `same_as_duration` is `true`, the `value_in_minutes` is the sum of the first duration in
   * `schedule.availabilityConstraints.SlotDurations` field, and `schedule.availabilityConstraints.TimeBetweenSlots` field.
   */
  sameAsDuration?: InputMaybe<Scalars['Boolean']>;
  /** Number of minutes between available slots' start times when `same_as_duration` is `false`. */
  valueInMinutes?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1UpdateScheduleRequestInput = {
  /** Optional. Defaults to false. In case of updated intervals' start time, this field indicates whether to align those interval's time exceptions. */
  alignTimeExceptions?: InputMaybe<Scalars['Boolean']>;
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Deprecated, use participant_notification. */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
  /** Whether to notify participants about the change, and an optional custom message. */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /** Schedule. */
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
};

export type ComWixBookingsSchedulesVeloV2CreateSessionRequestInput = {
  /** The session to create. */
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
};

export type ComWixBookingsSchedulesVeloV2CreateSessionResponse = {
  __typename?: 'ComWixBookingsSchedulesVeloV2CreateSessionResponse';
  /** The created session. */
  session?: Maybe<ComWixBookingsSchedulesApiV1Session>;
};

export type ComWixBookingsSchedulesVeloV2DeleteSessionRequestInput = {
  /** Whether to notify participants about the change, and an optional custom message. */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /** The ID of the session to delete. */
  sessionId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesVeloV2UpdateSessionRequestInput = {
  /** Field mask of fields to update. */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to notify participants about the change, and an optional custom message. */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /** The session to update. */
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
};

export type ComWixBookingsSchedulesVeloV2UpdateSessionResponse = {
  __typename?: 'ComWixBookingsSchedulesVeloV2UpdateSessionResponse';
  /** The updated session. */
  session?: Maybe<ComWixBookingsSchedulesApiV1Session>;
};

export type ComWixBookingsUpstreamWixCommonAddress = {
  __typename?: 'ComWixBookingsUpstreamWixCommonAddress';
  /** Main address line, usually street and number, as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Country code. */
  country?: Maybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: Maybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<ComWixBookingsUpstreamWixCommonAddressLocation>;
  /** Free text to help find the address. */
  hint?: Maybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street name, number and apartment number. */
  streetAddress?: Maybe<ComWixBookingsUpstreamWixCommonStreetAddress>;
  /** Subdivision. Usually state, region, prefecture or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  subdivision?: Maybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: Maybe<Array<Maybe<ComWixBookingsUpstreamWixCommonSubdivision>>>;
};

export type ComWixBookingsUpstreamWixCommonAddressInput = {
  /** Main address line, usually street and number, as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Country code. */
  country?: InputMaybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<ComWixBookingsUpstreamWixCommonAddressLocationInput>;
  /** Free text to help find the address. */
  hint?: InputMaybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street name, number and apartment number. */
  streetAddress?: InputMaybe<ComWixBookingsUpstreamWixCommonStreetAddressInput>;
  /** Subdivision. Usually state, region, prefecture or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: InputMaybe<Array<InputMaybe<ComWixBookingsUpstreamWixCommonSubdivisionInput>>>;
};

export type ComWixBookingsUpstreamWixCommonAddressLocation = {
  __typename?: 'ComWixBookingsUpstreamWixCommonAddressLocation';
  /** Address latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type ComWixBookingsUpstreamWixCommonAddressLocationInput = {
  /** Address latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type ComWixBookingsUpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsUpstreamWixCommonQueryInput = {
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixBookingsUpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixBookingsUpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixBookingsUpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixBookingsUpstreamWixCommonStreetAddress = {
  __typename?: 'ComWixBookingsUpstreamWixCommonStreetAddress';
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type ComWixBookingsUpstreamWixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsUpstreamWixCommonSubdivision = {
  __typename?: 'ComWixBookingsUpstreamWixCommonSubdivision';
  /** Subdivision code. Usually state, region, prefecture or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  code?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixBookingsUpstreamWixCommonSubdivisionInput = {
  /** Subdivision code. Usually state, region, prefecture or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  code?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomCartCheckoutCommonApiV1CatalogOverrideFields = {
  __typename?: 'ComWixEcomCartCheckoutCommonApiV1CatalogOverrideFields';
  /** Only eligible for catalog items with `lineItem.paymentOption.value` type of `DEPOSIT_ONLINE`. */
  depositAmount?: Maybe<Scalars['String']>;
  /** Item description lines. Used when displaying the line item to customers. */
  descriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
  /** Item price **before** discounts. */
  fullPrice?: Maybe<Scalars['String']>;
  /** Item image. */
  image?: Maybe<ComWixEcomCartCheckoutCommonApiV1Image>;
  /** Payment method selected for the item. */
  paymentOption?: Maybe<ComWixEcomCartCheckoutCommonApiV1PaymentOption>;
  /** Physical properties of the item. */
  physicalProperties?: Maybe<ComWixEcommerceCatalogSpiApiV1PhysicalProperties>;
  /** Item price **after** discounts. */
  price?: Maybe<Scalars['String']>;
  /** Item name. */
  productName?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  /**
   * Whether to save the payment method on the order.
   *
   * Default: `false`
   */
  savePaymentMethod?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomCartCheckoutCommonApiV1CatalogOverrideFieldsInput = {
  /** Only eligible for catalog items with `lineItem.paymentOption.value` type of `DEPOSIT_ONLINE`. */
  depositAmount?: InputMaybe<Scalars['String']>;
  /** Item description lines. Used when displaying the line item to customers. */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Item price **before** discounts. */
  fullPrice?: InputMaybe<Scalars['String']>;
  /** Item image. */
  image?: InputMaybe<ComWixEcomCartCheckoutCommonApiV1ImageInput>;
  /** Payment method selected for the item. */
  paymentOption?: InputMaybe<ComWixEcomCartCheckoutCommonApiV1PaymentOptionInput>;
  /** Physical properties of the item. */
  physicalProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput>;
  /** Item price **after** discounts. */
  price?: InputMaybe<Scalars['String']>;
  /** Item name. */
  productName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /**
   * Whether to save the payment method on the order.
   *
   * Default: `false`
   */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomCartCheckoutCommonApiV1CustomContentReference = {
  __typename?: 'ComWixEcomCartCheckoutCommonApiV1CustomContentReference';
  /**
   * ID of the app providing the content.
   *
   * You can get your app's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * ID of the component within the app it belongs to.
   *
   * You can get your component's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   */
  componentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomCartCheckoutCommonApiV1CustomContentReferenceInput = {
  /**
   * ID of the app providing the content.
   *
   * You can get your app's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * ID of the component within the app it belongs to.
   *
   * You can get your component's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   */
  componentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomCartCheckoutCommonApiV1CustomLineItemInput = {
  /** Catalog and item reference. Includes IDs for the item and the catalog it came from, as well as further optional info. Optional for custom line items, which don't trigger the Catalog service plugin. */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** Item payment policy that requires customer consent to complete purchase. The payment policy will be displayed on the checkout page. */
  consentRequiredPaymentPolicy?: InputMaybe<Scalars['String']>;
  /** Delivery profile ID. */
  deliveryProfileId?: InputMaybe<Scalars['String']>;
  /**
   * Partial payment for the given item to be paid upfront during the checkout.
   *
   * Eligible for catalog items with type `DEPOSIT_ONLINE`.
   * When omitted, the item's price will not be split and is expected to be paid in a single installment.
   */
  depositAmount?: InputMaybe<Scalars['String']>;
  /** Custom line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Digital file ID and name. Required if `itemType: DIGITAL`. */
  digitalFile?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SecuredMediaInput>;
  /**
   * Whether the line item quantity is fixed and cannot be changed.
   *
   * Default: `false`
   */
  fixedQuantity?: InputMaybe<Scalars['Boolean']>;
  /** Item price **before** catalog-defined discount. Defaults to `price` when not provided. */
  fullPrice?: InputMaybe<Scalars['String']>;
  /**
   * Custom line item ID. If passed, `id` must be unique.
   *
   * Default: auto-generated ID
   */
  id?: InputMaybe<Scalars['String']>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: InputMaybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemTypeInput>;
  /** Custom line item's media. */
  media?: InputMaybe<ComWixEcomCartCheckoutCommonApiV1ImageInput>;
  /**
   * Whether the item can only be purchased by site members.
   *
   * Default: `false`
   */
  membersOnly?: InputMaybe<Scalars['Boolean']>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1ModifierGroupInput>>>;
  /**
   * Type of selected payment option for current item. Defaults to `FULL_PAYMENT_ONLINE`.
   *
   * + `FULL_PAYMENT_ONLINE` - Entire payment for this item happens as part of the checkout.
   * + `FULL_PAYMENT_OFFLINE` - Entire payment for this item happens after the checkout. For example, when using cash, check, or other offline payment methods.
   * + `MEMBERSHIP` - Payment for this item is done by charging a membership. When this option is used, `lineItem.price.amount` is 0.
   * + `DEPOSIT_ONLINE` -  Partial payment for the given item to be paid upfront during the checkout. Amount to be paid is defined by deposit_amount field.
   */
  paymentOption?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
  /** Physical properties of the item. */
  physicalProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput>;
  /** Policies to be displayed to the customer on the checkout page. */
  policies?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1PolicyInput>>>;
  /**
   * Custom line item price.
   *
   * Must be a number or a decimal without symbols.
   */
  price?: InputMaybe<Scalars['String']>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput>;
  /**
   * Whether the price is not yet defined, and will be updated after the order is created.
   *
   * Default: `false`
   */
  priceUndetermined?: InputMaybe<Scalars['Boolean']>;
  /** Name of the item or product. */
  productName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /**
   * Custom line item quantity.
   *
   * Min: `1`
   * Max: `100000`
   */
  quantity?: InputMaybe<Scalars['Int']>;
  /**
   * Item quantity available for purchase. Only return this if inventory is managed.
   * Not returning this field means that the buyer can "infinitely" tick up the number of items in the cart.
   */
  quantityAvailable?: InputMaybe<Scalars['Int']>;
  /**
   * In cases where `catalogReference.catalogItemId` is NOT the actual catalog item ID, this field will return the true item's ID.
   *
   * + For example, for Wix Bookings, `catalogReference.catalogItemId` is the booking ID. Therefore this value is set to the service ID.
   * + In most cases, this field is the same as `catalogReference.catalogItemId`.
   * + Used in membership validation.
   */
  rootCatalogItemId?: InputMaybe<Scalars['String']>;
  /**
   * Whether to save the payment method on the order.
   *
   * Default: `false`
   */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
  /**
   * Service properties. When relevant, this contains information such as date and number of participants.
   * Used, among other things, when checking for valid memberships.
   */
  serviceProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ServicePropertiesInput>;
  /** Subscription option info. This field is internal and only used by Stores. */
  subscriptionOptionInfo?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput>;
  /** Tax group ID for this custom line item. */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /** Address to use for tax calculation purposes. */
  taxableAddress?: InputMaybe<ComWixEcommercePlatformCommonApiTaxableAddressInput>;
  /** URL to the item's page on the site. When not provided, the link back from the cart page to the relevant product page will not work. */
  url?: InputMaybe<WixCommonPageUrlV2Input>;
};

export type ComWixEcomCartCheckoutCommonApiV1Image = {
  __typename?: 'ComWixEcomCartCheckoutCommonApiV1Image';
  /** Image alt text. Optional. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. Optional. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixEcomCartCheckoutCommonApiV1ImageInput = {
  /** Image alt text. Optional. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. Optional. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomCartCheckoutCommonApiV1ItemModifier = {
  __typename?: 'ComWixEcomCartCheckoutCommonApiV1ItemModifier';
  /** Optional additional details or clarification for the modifier. */
  details?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
  /** Modifier ID. */
  id?: Maybe<Scalars['String']>;
  /** Primary display label for the modifier. */
  label?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
  /** The price of the modifier. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The quantity of this modifier. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomCartCheckoutCommonApiV1ItemModifierInput = {
  /** Optional additional details or clarification for the modifier. */
  details?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** Modifier ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Primary display label for the modifier. */
  label?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** The price of the modifier. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The quantity of this modifier. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomCartCheckoutCommonApiV1ModifierGroup = {
  __typename?: 'ComWixEcomCartCheckoutCommonApiV1ModifierGroup';
  /** Modifier group id. */
  id?: Maybe<Scalars['String']>;
  /** List of modifiers in this group. */
  modifiers?: Maybe<Array<Maybe<ComWixEcomCartCheckoutCommonApiV1ItemModifier>>>;
  /** Modifier group name. */
  name?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
};

export type ComWixEcomCartCheckoutCommonApiV1ModifierGroupInput = {
  /** Modifier group id. */
  id?: InputMaybe<Scalars['String']>;
  /** List of modifiers in this group. */
  modifiers?: InputMaybe<Array<InputMaybe<ComWixEcomCartCheckoutCommonApiV1ItemModifierInput>>>;
  /** Modifier group name. */
  name?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
};

export type ComWixEcomCartCheckoutCommonApiV1PaymentOption = {
  __typename?: 'ComWixEcomCartCheckoutCommonApiV1PaymentOption';
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  value?: Maybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
};

export type ComWixEcomCartCheckoutCommonApiV1PaymentOptionInput = {
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  value?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
};

export type ComWixEcomDiscountsActiveTimeInfo = {
  __typename?: 'ComWixEcomDiscountsActiveTimeInfo';
  /** Date and time the discount rule is active **till**, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  end?: Maybe<Scalars['String']>;
  /** Date and time the discount rule is active **from**, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  start?: Maybe<Scalars['String']>;
};

export type ComWixEcomDiscountsActiveTimeInfoInput = {
  /** Date and time the discount rule is active **till**, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  end?: InputMaybe<Scalars['String']>;
  /** Date and time the discount rule is active **from**, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  start?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomDiscountsAppliedDiscount = {
  __typename?: 'ComWixEcomDiscountsAppliedDiscount';
  /** Applied discount rule. */
  appliedDiscountRule?: Maybe<ComWixEcomDiscountsAppliedDiscountRule>;
  /** Discount type. */
  discountType?: Maybe<ComWixEcomDiscountsDiscountTargetType>;
  /** IDs of line items the discount applies to, in GUID format. */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomDiscountsAppliedDiscountRule = {
  __typename?: 'ComWixEcomDiscountsAppliedDiscountRule';
  /** Total amount reduced from all discounted line items. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Applied discount rule ID. */
  discountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
  /** Discount rule type. */
  discountRuleType?: Maybe<ComWixEcomDiscountsDiscountDiscountType>;
  /** Applied discount rule ID. */
  id?: Maybe<Scalars['String']>;
  /** Discount rule name. */
  name?: Maybe<ComWixEcomDiscountsDiscountRuleName>;
};

export type ComWixEcomDiscountsBuyXGetYInfo = {
  __typename?: 'ComWixEcomDiscountsBuyXGetYInfo';
  /** Information about which items must be in the cart (buy X) for the discount to apply (get Y). */
  customerBuys?: Maybe<ComWixEcomDiscountsCustomerBuy>;
  /** Information about which items will be discounted (get Y). */
  customerGets?: Maybe<ComWixEcomDiscountsCustomerGet>;
  /**
   * The maximum number of times the 'buy X get Y' discount can be applied.
   * For example, when the value of `limit` is `2`, with a "2+1" sale on all items, the following logic applies:
   * + Buy 2 get 1, buy 3 get 1.
   * + Buy 4 get 2, buy 6 get 2, buy 9 get 2, and so on.
   */
  limit?: Maybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsBuyXGetYInfoInput = {
  /** Information about which items must be in the cart (buy X) for the discount to apply (get Y). */
  customerBuys?: InputMaybe<ComWixEcomDiscountsCustomerBuyInput>;
  /** Information about which items will be discounted (get Y). */
  customerGets?: InputMaybe<ComWixEcomDiscountsCustomerGetInput>;
  /**
   * The maximum number of times the 'buy X get Y' discount can be applied.
   * For example, when the value of `limit` is `2`, with a "2+1" sale on all items, the following logic applies:
   * + Buy 2 get 1, buy 3 get 1.
   * + Buy 4 get 2, buy 6 get 2, buy 9 get 2, and so on.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsCatalogItemFilter = {
  __typename?: 'ComWixEcomDiscountsCatalogItemFilter';
  /** Catalog App ID. For example, the Wix Stores, Wix Bookings, or 3rd-party `appId`. */
  catalogAppId?: Maybe<Scalars['String']>;
  /** ID of the item within its Wix or 3rd-party catalog. For example, `productId` for Wix Stores. */
  catalogItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomDiscountsCatalogItemFilterInput = {
  /** Catalog App ID. For example, the Wix Stores, Wix Bookings, or 3rd-party `appId`. */
  catalogAppId?: InputMaybe<Scalars['String']>;
  /** ID of the item within its Wix or 3rd-party catalog. For example, `productId` for Wix Stores. */
  catalogItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomDiscountsCreateDiscountRuleRequestInput = {
  /** Discount rule info. */
  discountRule?: InputMaybe<ComWixEcomDiscountsDiscountRuleInput>;
};

export type ComWixEcomDiscountsCreateDiscountRuleResponse = {
  __typename?: 'ComWixEcomDiscountsCreateDiscountRuleResponse';
  /** Discount rule. */
  discountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
};

export type ComWixEcomDiscountsCustomFilter = {
  __typename?: 'ComWixEcomDiscountsCustomFilter';
  /** Custom filter app ID, when relevant. */
  appId?: Maybe<Scalars['String']>;
  /**
   * Custom filter in `{ "key": "value" }` form.
   * For example, an array of `collectionIDs`:
   * `{ ["collectionId": "12345"], ["collectionId": "67890"] }`.
   */
  params?: Maybe<Scalars['JSON']>;
};

export type ComWixEcomDiscountsCustomFilterInput = {
  /** Custom filter app ID, when relevant. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Custom filter in `{ "key": "value" }` form.
   * For example, an array of `collectionIDs`:
   * `{ ["collectionId": "12345"], ["collectionId": "67890"] }`.
   */
  params?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomDiscountsCustomerBuy = {
  __typename?: 'ComWixEcomDiscountsCustomerBuy';
  /** Minimum number of items the customer must add to the cart to be eligible for a discount. */
  minimumQuantity?: Maybe<Scalars['Int']>;
  /** Minimum price the customer must add to the cart to be eligible for a discount. */
  minimumSpend?: Maybe<Scalars['String']>;
  /** Scopes of the items that must be added to the cart to enable the discount. */
  scopes?: Maybe<Array<Maybe<ComWixEcomDiscountsScope>>>;
};

export type ComWixEcomDiscountsCustomerBuyInput = {
  /** Minimum number of items the customer must add to the cart to be eligible for a discount. */
  minimumQuantity?: InputMaybe<Scalars['Int']>;
  /** Minimum price the customer must add to the cart to be eligible for a discount. */
  minimumSpend?: InputMaybe<Scalars['String']>;
  /** Scopes of the items that must be added to the cart to enable the discount. */
  scopes?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsScopeInput>>>;
};

export type ComWixEcomDiscountsCustomerGet = {
  __typename?: 'ComWixEcomDiscountsCustomerGet';
  /**
   * Exact number of items in the cart that will be discounted.
   * If the cart contains fewer items than the value of quantity, the discount will not apply.
   */
  quantity?: Maybe<Scalars['Int']>;
  /** Scopes of the items that will be discounted. */
  scopes?: Maybe<Array<Maybe<ComWixEcomDiscountsScope>>>;
};

export type ComWixEcomDiscountsCustomerGetInput = {
  /**
   * Exact number of items in the cart that will be discounted.
   * If the cart contains fewer items than the value of quantity, the discount will not apply.
   */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Scopes of the items that will be discounted. */
  scopes?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsScopeInput>>>;
};

export type ComWixEcomDiscountsDeleteDiscountRuleRequestInput = {
  /** ID of the discount rule to delete. */
  discountRuleId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomDiscountsDiscount = {
  __typename?: 'ComWixEcomDiscountsDiscount';
  /** Data related to `BUY_X_GET_Y` target type. */
  buyXGetYInfo?: Maybe<ComWixEcomDiscountsBuyXGetYInfo>;
  /** Discount type. */
  discountType?: Maybe<ComWixEcomDiscountsDiscountDiscountType>;
  /** Amount to discount from original price. */
  fixedAmount?: Maybe<Scalars['String']>;
  /** Fixed price. Line item will be fixed to this price. */
  fixedPrice?: Maybe<Scalars['String']>;
  /** Percentage to discount from original price. */
  percentage?: Maybe<Scalars['Float']>;
  /** Data related to `SPECIFIC_ITEMS` target type. */
  specificItemsInfo?: Maybe<ComWixEcomDiscountsSpecificItemsInfo>;
  /**
   * Discount target.
   *
   * + `SPECIFIC_ITEMS`: Discount applies to a specific set of items.
   */
  targetType?: Maybe<ComWixEcomDiscountsDiscountTargetType>;
};

export enum ComWixEcomDiscountsDiscountDiscountType {
  /** Price is reduced by fixed amount. */
  FixedAmount = 'FIXED_AMOUNT',
  /** Price will be set to fixed amount. */
  FixedPrice = 'FIXED_PRICE',
  /** Price is reduced by percentage value. */
  Percentage = 'PERCENTAGE',
  Undefined = 'UNDEFINED'
}

export type ComWixEcomDiscountsDiscountInput = {
  /** Data related to `BUY_X_GET_Y` target type. */
  buyXGetYInfo?: InputMaybe<ComWixEcomDiscountsBuyXGetYInfoInput>;
  /** Discount type. */
  discountType?: InputMaybe<ComWixEcomDiscountsDiscountDiscountType>;
  /** Amount to discount from original price. */
  fixedAmount?: InputMaybe<Scalars['String']>;
  /** Fixed price. Line item will be fixed to this price. */
  fixedPrice?: InputMaybe<Scalars['String']>;
  /** Percentage to discount from original price. */
  percentage?: InputMaybe<Scalars['Float']>;
  /** Data related to `SPECIFIC_ITEMS` target type. */
  specificItemsInfo?: InputMaybe<ComWixEcomDiscountsSpecificItemsInfoInput>;
  /**
   * Discount target.
   *
   * + `SPECIFIC_ITEMS`: Discount applies to a specific set of items.
   */
  targetType?: InputMaybe<ComWixEcomDiscountsDiscountTargetType>;
};

export type ComWixEcomDiscountsDiscountRule = {
  __typename?: 'ComWixEcomDiscountsDiscountRule';
  /**
   * Whether the discount rule is active.
   *
   * Default: `true`
   */
  active?: Maybe<Scalars['Boolean']>;
  /** Time frame in which the discount rule is active. */
  activeTimeInfo?: Maybe<ComWixEcomDiscountsActiveTimeInfo>;
  /** Date and time the discount rule was created. */
  createdDate?: Maybe<Scalars['String']>;
  /**
   * List of discounts that are applied when one or more triggers are met.
   *
   * > **Notes:**
   * >
   * > + Currently, only 1 discount can be defined per discount rule.
   * > + A discount rule can be applied on multiple items per cart.
   * > + A discount rule can only be applied once per item.
   */
  discounts?: Maybe<ComWixEcomDiscountsDiscounts>;
  /** Data Extensions. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Discount rule ID. */
  id?: Maybe<Scalars['String']>;
  /** Discount rule name. */
  name?: Maybe<Scalars['String']>;
  /** calculated string which describe the discount rule */
  offer?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the discount rule is updated.
   * To prevent conflicting changes, the current `revision` must be passed when updating the discount rule.
   */
  revision?: Maybe<Scalars['Long']>;
  /** Discount advance settings. */
  settings?: Maybe<ComWixEcomDiscountsDiscountSettings>;
  /**
   * Discount rule status.
   * Default: `UNDEFINED`
   */
  status?: Maybe<ComWixEcomDiscountsDiscountRuleStatus>;
  /**
   * Discount rule trigger.
   * A set of conditions that must be met for the `discounts` to be applied.
   * Not passing a trigger will cause the discount to always apply.
   */
  trigger?: Maybe<ComWixEcomDiscountsDiscountTrigger>;
  /** Date and time the discount rule was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Number of times the discount rule was used. */
  usageCount?: Maybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsDiscountRuleInput = {
  /**
   * Whether the discount rule is active.
   *
   * Default: `true`
   */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Time frame in which the discount rule is active. */
  activeTimeInfo?: InputMaybe<ComWixEcomDiscountsActiveTimeInfoInput>;
  /** Date and time the discount rule was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /**
   * List of discounts that are applied when one or more triggers are met.
   *
   * > **Notes:**
   * >
   * > + Currently, only 1 discount can be defined per discount rule.
   * > + A discount rule can be applied on multiple items per cart.
   * > + A discount rule can only be applied once per item.
   */
  discounts?: InputMaybe<ComWixEcomDiscountsDiscountsInput>;
  /** Data Extensions. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Discount rule ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Discount rule name. */
  name?: InputMaybe<Scalars['String']>;
  /** calculated string which describe the discount rule */
  offer?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the discount rule is updated.
   * To prevent conflicting changes, the current `revision` must be passed when updating the discount rule.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** Discount advance settings. */
  settings?: InputMaybe<ComWixEcomDiscountsDiscountSettingsInput>;
  /**
   * Discount rule status.
   * Default: `UNDEFINED`
   */
  status?: InputMaybe<ComWixEcomDiscountsDiscountRuleStatus>;
  /**
   * Discount rule trigger.
   * A set of conditions that must be met for the `discounts` to be applied.
   * Not passing a trigger will cause the discount to always apply.
   */
  trigger?: InputMaybe<ComWixEcomDiscountsDiscountTriggerInput>;
  /** Date and time the discount rule was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Number of times the discount rule was used. */
  usageCount?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsDiscountRuleName = {
  __typename?: 'ComWixEcomDiscountsDiscountRuleName';
  /** Original discount rule name (in site's default language). */
  original?: Maybe<Scalars['String']>;
  /**
   * Translated discount rule name according to buyer language.
   *
   * Default: `original`
   */
  translated?: Maybe<Scalars['String']>;
};

export enum ComWixEcomDiscountsDiscountRuleStatus {
  /** Rule status is expired, it might have been live in the past. */
  Expired = 'EXPIRED',
  /** Rule status is live. */
  Live = 'LIVE',
  /** Rule status is pending, it might be live in the future. */
  Pending = 'PENDING',
  /** Rule status is not defined. */
  Undefined = 'UNDEFINED'
}

export type ComWixEcomDiscountsDiscountSettings = {
  __typename?: 'ComWixEcomDiscountsDiscountSettings';
  /** Discount applies to either `ALL_ITEMS`, or to the `LOWEST_PRICED_ITEM`. */
  appliesTo?: Maybe<ComWixEcomDiscountsDiscountSettingsAppliedSubjectType>;
  /**
   * Whether the discount will apply to subscriptions.
   *
   * Default: `false`
   */
  includeSubscription?: Maybe<Scalars['Boolean']>;
  /**
   * Opt in to indexing this discount rule by an offline pipeline.
   * Default value is false (rules are not indexed by default).
   * The purpose of indexing discount rules is to allow fast reads of potential discounts on given catalog items,
   * without having to do heavy calculations like in `GetAppliedDiscounts` API.
   * One can read this data from [Discounts Cache Reader Service](https://todo-add-working-link)
   * This can be used for example, to display potential discounts on the storefront.
   */
  indexOptIn?: Maybe<Scalars['Boolean']>;
  /** Maximum total number of uses allowed for the discount rule. */
  usageLimit?: Maybe<Scalars['Int']>;
  /**
   * The usage limit per user per discount.
   * When not provided, this setting will not apply.
   */
  usageLimitPerUser?: Maybe<Scalars['Int']>;
};

export enum ComWixEcomDiscountsDiscountSettingsAppliedSubjectType {
  /** Discount applies to all items at checkout. */
  AllItems = 'ALL_ITEMS',
  /** Discount applies to the lowest priced item at checkout. */
  LowestPricedItem = 'LOWEST_PRICED_ITEM',
  Undefined = 'UNDEFINED'
}

export type ComWixEcomDiscountsDiscountSettingsInput = {
  /** Discount applies to either `ALL_ITEMS`, or to the `LOWEST_PRICED_ITEM`. */
  appliesTo?: InputMaybe<ComWixEcomDiscountsDiscountSettingsAppliedSubjectType>;
  /**
   * Whether the discount will apply to subscriptions.
   *
   * Default: `false`
   */
  includeSubscription?: InputMaybe<Scalars['Boolean']>;
  /**
   * Opt in to indexing this discount rule by an offline pipeline.
   * Default value is false (rules are not indexed by default).
   * The purpose of indexing discount rules is to allow fast reads of potential discounts on given catalog items,
   * without having to do heavy calculations like in `GetAppliedDiscounts` API.
   * One can read this data from [Discounts Cache Reader Service](https://todo-add-working-link)
   * This can be used for example, to display potential discounts on the storefront.
   */
  indexOptIn?: InputMaybe<Scalars['Boolean']>;
  /** Maximum total number of uses allowed for the discount rule. */
  usageLimit?: InputMaybe<Scalars['Int']>;
  /**
   * The usage limit per user per discount.
   * When not provided, this setting will not apply.
   */
  usageLimitPerUser?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomDiscountsDiscountTargetType {
  /** Target type is a buy x get y */
  BuyXGetY = 'BUY_X_GET_Y',
  /** Target type is a set of specific items */
  SpecificItems = 'SPECIFIC_ITEMS',
  /** Target type is not defined */
  Undefined = 'UNDEFINED'
}

export type ComWixEcomDiscountsDiscountTrigger = {
  __typename?: 'ComWixEcomDiscountsDiscountTrigger';
  /** Chain multiple triggers with the `and` operator. */
  and?: Maybe<ComWixEcomDiscountsDiscountTriggerAnd>;
  /** Custom trigger. */
  customTrigger?: Maybe<ComWixEcomDiscountsDiscountTriggerCustom>;
  /** Item quantity trigger range. */
  itemQuantityRange?: Maybe<ComWixEcomDiscountsDiscountTriggerItemQuantityRange>;
  /** Chain multiple triggers with the `or` operator. */
  or?: Maybe<ComWixEcomDiscountsDiscountTriggerOr>;
  /** Subtotal trigger range. */
  subtotalRange?: Maybe<ComWixEcomDiscountsDiscountTriggerSubtotalRange>;
  /** Trigger type. */
  triggerType?: Maybe<ComWixEcomDiscountsDiscountTriggerTriggerType>;
};

export type ComWixEcomDiscountsDiscountTriggerAnd = {
  __typename?: 'ComWixEcomDiscountsDiscountTriggerAnd';
  /** List of triggers to have an "AND" operator between their results. */
  triggers?: Maybe<Array<Maybe<ComWixEcomDiscountsDiscountTrigger>>>;
};

export type ComWixEcomDiscountsDiscountTriggerAndInput = {
  /** List of triggers to have an "AND" operator between their results. */
  triggers?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsDiscountTriggerInput>>>;
};

export type ComWixEcomDiscountsDiscountTriggerCustom = {
  __typename?: 'ComWixEcomDiscountsDiscountTriggerCustom';
  /** ID of the app that created the trigger. */
  appId?: Maybe<Scalars['String']>;
  /** Trigger ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Additional data in { "key": value } form.
   * + This data will be passed to the Custom Triggers Service SPI.
   * + For example, for a trigger that would activate if temperature is above 30 degrees, `params` field would be: `{ "minTemp": 30 }`.
   */
  params?: Maybe<Scalars['JSON']>;
};

export type ComWixEcomDiscountsDiscountTriggerCustomInput = {
  /** ID of the app that created the trigger. */
  appId?: InputMaybe<Scalars['String']>;
  /** Trigger ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Additional data in { "key": value } form.
   * + This data will be passed to the Custom Triggers Service SPI.
   * + For example, for a trigger that would activate if temperature is above 30 degrees, `params` field would be: `{ "minTemp": 30 }`.
   */
  params?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomDiscountsDiscountTriggerInput = {
  /** Chain multiple triggers with the `and` operator. */
  and?: InputMaybe<ComWixEcomDiscountsDiscountTriggerAndInput>;
  /** Custom trigger. */
  customTrigger?: InputMaybe<ComWixEcomDiscountsDiscountTriggerCustomInput>;
  /** Item quantity trigger range. */
  itemQuantityRange?: InputMaybe<ComWixEcomDiscountsDiscountTriggerItemQuantityRangeInput>;
  /** Chain multiple triggers with the `or` operator. */
  or?: InputMaybe<ComWixEcomDiscountsDiscountTriggerOrInput>;
  /** Subtotal trigger range. */
  subtotalRange?: InputMaybe<ComWixEcomDiscountsDiscountTriggerSubtotalRangeInput>;
  /** Trigger type. */
  triggerType?: InputMaybe<ComWixEcomDiscountsDiscountTriggerTriggerType>;
};

export type ComWixEcomDiscountsDiscountTriggerItemQuantityRange = {
  __typename?: 'ComWixEcomDiscountsDiscountTriggerItemQuantityRange';
  /** Minimum item quantity (inclusive). */
  from?: Maybe<Scalars['Int']>;
  /** Relevant scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: Maybe<Array<Maybe<ComWixEcomDiscountsScope>>>;
  /** Maximum item quantity (inclusive). */
  to?: Maybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsDiscountTriggerItemQuantityRangeInput = {
  /** Minimum item quantity (inclusive). */
  from?: InputMaybe<Scalars['Int']>;
  /** Relevant scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsScopeInput>>>;
  /** Maximum item quantity (inclusive). */
  to?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsDiscountTriggerOr = {
  __typename?: 'ComWixEcomDiscountsDiscountTriggerOr';
  /** List of triggers to have an "OR" operator between their results. */
  triggers?: Maybe<Array<Maybe<ComWixEcomDiscountsDiscountTrigger>>>;
};

export type ComWixEcomDiscountsDiscountTriggerOrInput = {
  /** List of triggers to have an "OR" operator between their results. */
  triggers?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsDiscountTriggerInput>>>;
};

export type ComWixEcomDiscountsDiscountTriggerSubtotalRange = {
  __typename?: 'ComWixEcomDiscountsDiscountTriggerSubtotalRange';
  /** Minimum subtotal price (inclusive). */
  from?: Maybe<Scalars['String']>;
  /** Relevant scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: Maybe<Array<Maybe<ComWixEcomDiscountsScope>>>;
  /** Maximum subtotal price (inclusive). */
  to?: Maybe<Scalars['String']>;
};

export type ComWixEcomDiscountsDiscountTriggerSubtotalRangeInput = {
  /** Minimum subtotal price (inclusive). */
  from?: InputMaybe<Scalars['String']>;
  /** Relevant scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsScopeInput>>>;
  /** Maximum subtotal price (inclusive). */
  to?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomDiscountsDiscountTriggerTriggerType {
  /** Operator used for chaining multiple triggers. Currently 1 `AND` chain operator is supported. */
  And = 'AND',
  /** Custom trigger type defined in `customTrigger` object. */
  Custom = 'CUSTOM',
  /** Quantity of items in scope must be within specified `itemQuantityRange` values. */
  ItemQuantityRange = 'ITEM_QUANTITY_RANGE',
  /** Chain multiple triggers with OR operator */
  Or = 'OR',
  /** Subtotal must be within the specified `subtotalRange` values. */
  SubtotalRange = 'SUBTOTAL_RANGE',
  Undefined = 'UNDEFINED'
}

export type ComWixEcomDiscountsDiscounts = {
  __typename?: 'ComWixEcomDiscountsDiscounts';
  /** Discounts. */
  values?: Maybe<Array<Maybe<ComWixEcomDiscountsDiscount>>>;
};

export type ComWixEcomDiscountsDiscountsInput = {
  /** Discounts. */
  values?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsDiscountInput>>>;
};

export type ComWixEcomDiscountsGetAppliedDiscountsRequestInput = {
  /** Line items for which to check for discount rules. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsLineItemInput>>>;
  /** Persistent ID that correlates between the various eCommerce elements: cart, checkout, and order. */
  purchaseFlowId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomDiscountsGetAppliedDiscountsResponse = {
  __typename?: 'ComWixEcomDiscountsGetAppliedDiscountsResponse';
  /** All eligible discounts. */
  appliedDiscounts?: Maybe<Array<Maybe<ComWixEcomDiscountsAppliedDiscount>>>;
};

export type ComWixEcomDiscountsGetDiscountRuleRequestInput = {
  id: Scalars['ID'];
};

export type ComWixEcomDiscountsLineItemInput = {
  /** Catalog and item reference info. Learn more about [integrating Wix Stores products with Wix eCommerce](https://dev.wix.com/api/rest/wix-stores/catalog/ecommerce-integration). */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item price. */
  price?: InputMaybe<Scalars['String']>;
  /** Line item quantity. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsQueryDiscountRulesRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type ComWixEcomDiscountsQueryDiscountRulesResponse = {
  __typename?: 'ComWixEcomDiscountsQueryDiscountRulesResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixEcomDiscountsDiscountRule>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixEcomDiscountsScope = {
  __typename?: 'ComWixEcomDiscountsScope';
  /** Catalog item filter. Must be passed with `type."CATALOG_ITEM"`. */
  catalogItemFilter?: Maybe<ComWixEcomDiscountsCatalogItemFilter>;
  /** Custom filter. Must be passed with `type."CATALOG_ITEM"`. */
  customFilter?: Maybe<ComWixEcomDiscountsCustomFilter>;
  /** Scope ID. */
  id?: Maybe<Scalars['String']>;
  /** Scope type. */
  type?: Maybe<ComWixEcomDiscountsScopeType>;
};

export type ComWixEcomDiscountsScopeInput = {
  /** Catalog item filter. Must be passed with `type."CATALOG_ITEM"`. */
  catalogItemFilter?: InputMaybe<ComWixEcomDiscountsCatalogItemFilterInput>;
  /** Custom filter. Must be passed with `type."CATALOG_ITEM"`. */
  customFilter?: InputMaybe<ComWixEcomDiscountsCustomFilterInput>;
  /** Scope ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Scope type. */
  type?: InputMaybe<ComWixEcomDiscountsScopeType>;
};

export enum ComWixEcomDiscountsScopeType {
  /** Specific catalog items */
  CatalogItem = 'CATALOG_ITEM',
  /** Specific items by custom filters */
  CustomFilter = 'CUSTOM_FILTER',
  UndefinedScope = 'UNDEFINED_SCOPE'
}

export type ComWixEcomDiscountsSpecificItemsInfo = {
  __typename?: 'ComWixEcomDiscountsSpecificItemsInfo';
  /**
   * limit number of items the discount can be applied to
   * if no limit specified, the discount will be applied to all items in the request that match 'scopes' field
   */
  limit?: Maybe<Scalars['Int']>;
  /** All associated scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: Maybe<Array<Maybe<ComWixEcomDiscountsScope>>>;
};

export type ComWixEcomDiscountsSpecificItemsInfoInput = {
  /**
   * limit number of items the discount can be applied to
   * if no limit specified, the discount will be applied to all items in the request that match 'scopes' field
   */
  limit?: InputMaybe<Scalars['Int']>;
  /** All associated scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsScopeInput>>>;
};

export type ComWixEcomDiscountsUpdateDiscountRuleRequestInput = {
  /** Discount rule info. */
  discountRule?: InputMaybe<ComWixEcomDiscountsDiscountRuleInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomDiscountsUpdateDiscountRuleResponse = {
  __typename?: 'ComWixEcomDiscountsUpdateDiscountRuleResponse';
  /** Updated discount rule. */
  discountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
};

export type ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem = {
  __typename?: 'ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem';
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Description lines to replace the original
   * This is optional - If you do not want to override, do not return this and the original description lines will be used
   * If you do pass it, it overrides the existing description line.
   * If you want to append, copy the original description lines and add your own
   */
  overriddenDescriptionLines?: Maybe<ComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines>;
  /** Option to hide specific sections */
  renderingConfig?: Maybe<ComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig>;
};

export type ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItemWithActions = {
  __typename?: 'ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItemWithActions';
  /**
   * Optional list of actions to be rendered next to the line item
   * Implementation depends on the client (checkout page, mobile)
   */
  actions?: Maybe<Array<Maybe<ComWixEcomLineItemsEnricherSpiApiV1LineItemAction>>>;
  /** Line item ID */
  id?: Maybe<Scalars['String']>;
  /**
   * Description lines to replace the original
   * This is optional - If you do not want to override, do not return this and the original description lines will be used
   * If you do pass it, it overrides the existing description line.
   * If you want to append, copy the original description lines and add your own
   */
  overriddenDescriptionLines?: Maybe<ComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines>;
  /** Option to hide specific sections */
  renderingConfig?: Maybe<ComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig>;
};

export type ComWixEcomLineItemsEnricherSpiApiV1LineItemAction = {
  __typename?: 'ComWixEcomLineItemsEnricherSpiApiV1LineItemAction';
  /**
   * The unique id of the action
   * for example: DOWNLOAD_LINK, ADD_TO_CALENDAR
   * Note that a specific client may rely on action id and parameters and ignore the URL or the other way around
   */
  actionId?: Maybe<Scalars['String']>;
  /** Parameters for the actions, will be used by the client implementing the action based on actionId */
  actionParameters?: Maybe<Scalars['JSON']>;
  /** the translated text to display (i.e. will be shown "as is") */
  label?: Maybe<Scalars['String']>;
  /** the key that we use to save the text in the editor settings panel */
  settingsKey?: Maybe<Scalars['String']>;
  /**
   * URL to navigate to in order to perform the action
   * can be relative e.g "/api/download" or absolute e.g. "http://www.google.com"
   * Note that a specific client may rely on action id and parameters and ignore the URL or the other way around
   */
  url?: Maybe<Scalars['String']>;
};

export type ComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig = {
  __typename?: 'ComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig';
  hidePrice?: Maybe<Scalars['Boolean']>;
  hideQuantity?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines = {
  __typename?: 'ComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines';
  descriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
};

export type ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForCheckoutResponse = {
  __typename?: 'ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForCheckoutResponse';
  enrichedLineItems?: Maybe<Array<Maybe<ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem>>>;
};

export type ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForOrderPageResponse = {
  __typename?: 'ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForOrderPageResponse';
  enrichedLineItems?: Maybe<Array<Maybe<ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem>>>;
};

export type ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForThankYouPageResponse = {
  __typename?: 'ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForThankYouPageResponse';
  enrichedLineItems?: Maybe<Array<Maybe<ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItemWithActions>>>;
};

export type ComWixEcomMembershipsSpiV1HostInvalidMembership = {
  __typename?: 'ComWixEcomMembershipsSpiV1HostInvalidMembership';
  /** Membership details. */
  membership?: Maybe<ComWixEcomMembershipsSpiV1HostMembership>;
  /** Reason why this membership is invalid and cannot be used. */
  reason?: Maybe<Scalars['String']>;
};

export type ComWixEcomMembershipsSpiV1HostInvalidMembershipInput = {
  /** Membership details. */
  membership?: InputMaybe<ComWixEcomMembershipsSpiV1HostMembershipInput>;
  /** Reason why this membership is invalid and cannot be used. */
  reason?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomMembershipsSpiV1HostMembership = {
  __typename?: 'ComWixEcomMembershipsSpiV1HostMembership';
  /** Additional data about this membership. */
  additionalData?: Maybe<Scalars['JSON']>;
  /** ID of the application providing this payment option. */
  appId?: Maybe<Scalars['String']>;
  /** Optional - For a membership that has limited credits, information about credit usage. */
  credits?: Maybe<ComWixEcomMembershipsSpiV1MembershipPaymentCredits>;
  /** Optional - TMembership expiry date. */
  expirationDate?: Maybe<Scalars['String']>;
  /** Membership ID. */
  id?: Maybe<Scalars['String']>;
  /** Line item IDs which are "paid" for by this membership. */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The name of this membership. */
  name?: Maybe<ComWixEcomMembershipsSpiV1MembershipName>;
};

export type ComWixEcomMembershipsSpiV1HostMembershipInput = {
  /** Additional data about this membership. */
  additionalData?: InputMaybe<Scalars['JSON']>;
  /** ID of the application providing this payment option. */
  appId?: InputMaybe<Scalars['String']>;
  /** Optional - For a membership that has limited credits, information about credit usage. */
  credits?: InputMaybe<ComWixEcomMembershipsSpiV1MembershipPaymentCreditsInput>;
  /** Optional - TMembership expiry date. */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** Membership ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item IDs which are "paid" for by this membership. */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of this membership. */
  name?: InputMaybe<ComWixEcomMembershipsSpiV1MembershipNameInput>;
};

export type ComWixEcomMembershipsSpiV1HostSelectedMembership = {
  __typename?: 'ComWixEcomMembershipsSpiV1HostSelectedMembership';
  /** ID of the app providing this payment option. */
  appId?: Maybe<Scalars['String']>;
  /** Membership ID. */
  id?: Maybe<Scalars['String']>;
  /** IDs of the line items this membership applies to. */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomMembershipsSpiV1HostSelectedMembershipInput = {
  /** ID of the app providing this payment option. */
  appId?: InputMaybe<Scalars['String']>;
  /** Membership ID. */
  id?: InputMaybe<Scalars['String']>;
  /** IDs of the line items this membership applies to. */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomMembershipsSpiV1HostSelectedMemberships = {
  __typename?: 'ComWixEcomMembershipsSpiV1HostSelectedMemberships';
  /** Selected memberships. */
  memberships?: Maybe<Array<Maybe<ComWixEcomMembershipsSpiV1HostSelectedMembership>>>;
};

export type ComWixEcomMembershipsSpiV1HostSelectedMembershipsInput = {
  /** Selected memberships. */
  memberships?: InputMaybe<Array<InputMaybe<ComWixEcomMembershipsSpiV1HostSelectedMembershipInput>>>;
};

export type ComWixEcomMembershipsSpiV1MembershipName = {
  __typename?: 'ComWixEcomMembershipsSpiV1MembershipName';
  /** Membership name. */
  original?: Maybe<Scalars['String']>;
  /** Translated membership name. Defaults to `original` when not provided. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomMembershipsSpiV1MembershipNameInput = {
  /** Membership name. */
  original?: InputMaybe<Scalars['String']>;
  /** Translated membership name. Defaults to `original` when not provided. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomMembershipsSpiV1MembershipPaymentCredits = {
  __typename?: 'ComWixEcomMembershipsSpiV1MembershipPaymentCredits';
  /** Membership's remaining amount of credits. */
  remaining?: Maybe<Scalars['Int']>;
  /** Membership's total amount of credits. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixEcomMembershipsSpiV1MembershipPaymentCreditsInput = {
  /** Membership's remaining amount of credits. */
  remaining?: InputMaybe<Scalars['Int']>;
  /** Membership's total amount of credits. */
  total?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1AdditionalFeeRefund = {
  __typename?: 'ComWixEcomOrdersBillingV1AdditionalFeeRefund';
  /** Additional fee ID. */
  additionalFeeId?: Maybe<Scalars['String']>;
  /**
   * Amount to refund.
   *
   * Passing an empty value will refund the remaining refundable amount.
   */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1AdditionalFeeRefundInput = {
  /** Additional fee ID. */
  additionalFeeId?: InputMaybe<Scalars['String']>;
  /**
   * Amount to refund.
   *
   * Passing an empty value will refund the remaining refundable amount.
   */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersBillingV1AdditionalFeeRefundOption = {
  __typename?: 'ComWixEcomOrdersBillingV1AdditionalFeeRefundOption';
  /** Additional fee ID. */
  additionalFeeId?: Maybe<Scalars['String']>;
  /** Original additional fee amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional fee amount available for refund. */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded additional fee amount. */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1AdditionalFeeRefundability = {
  __typename?: 'ComWixEcomOrdersBillingV1AdditionalFeeRefundability';
  /** Additional fee ID. */
  additionalFeeId?: Maybe<Scalars['String']>;
  /** Original additional fee amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional fee amount available for refund. */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded additional fee amount. */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1AggregatedRefundSummary = {
  __typename?: 'ComWixEcomOrdersBillingV1AggregatedRefundSummary';
  /** Total cost of the additional fees being refunded. */
  additionalFeesTotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Discount amount for the items being refunded. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the line items being refunded (without tax and discount). */
  lineItemsSubtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the items being refunded (without tax and discount). */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax amount for the items being refunded. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total refund amount. */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodRequestInput = {
  /** Amount to authorize. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Currency code, in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format. */
  currency?: InputMaybe<Scalars['String']>;
  /** Settings for scheduled action to perform automatically. */
  delayedCaptureSettings?: InputMaybe<ComWixEcomOrdersBillingV1DelayedCaptureSettingsInput>;
  /**
   * Order ID.
   *
   * The order must have a saved payment method associated.
   * Pass the order ID to the List Transactions For Single Order method and search the response for a payment with `regularPaymentDetails.savedPaymentMethod: true`.
   * If no saved payment exists, the call will fail.
   */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodResponse = {
  __typename?: 'ComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodResponse';
  /** Order transactions updated with authorized payment. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Authorized payment. */
  payment?: Maybe<ComWixEcomOrdersPaymentsV1Payment>;
};

export type ComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodRequestInput = {
  /** Amount to authorize on saved payment method. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Currency. */
  currency?: InputMaybe<Scalars['String']>;
  /** Delayed capture settings. */
  delayedCaptureSettings?: InputMaybe<ComWixEcomOrdersBillingV1DelayedCaptureSettingsInput>;
  /** Order ID. Must have saved payment method associated with it. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodResponse = {
  __typename?: 'ComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodResponse';
  /** Order transactions after payment was authorized. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Authorized payment, created using saved payment method. */
  payment?: Maybe<ComWixEcomOrdersPaymentsV1Payment>;
};

export type ComWixEcomOrdersBillingV1CalculateRefundRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** List of line items, shipping and additional fees to be calculated for refund. */
  refundItems?: InputMaybe<ComWixEcomOrdersBillingV1RefundItemsInput>;
};

export type ComWixEcomOrdersBillingV1CalculateRefundResponse = {
  __typename?: 'ComWixEcomOrdersBillingV1CalculateRefundResponse';
  /** Whether refund is available for the given list of items. */
  available?: Maybe<Scalars['Boolean']>;
  /** Calculated summary of each item provided for refund. */
  calculatedRefundItems?: Maybe<ComWixEcomOrdersBillingV1CalculatedRefundItems>;
  /** If the calculated refund is not available, this field contains error details and amounts for each item. */
  notAvailable?: Maybe<ComWixEcomOrdersBillingV1CalculatedRefundNotAvailableStatus>;
  /**
   * Aggregated summary of all items provided for refund.
   *
   * This field is not returned when refund is not available for the given list of items.
   */
  summary?: Maybe<ComWixEcomOrdersBillingV1AggregatedRefundSummary>;
};

export type ComWixEcomOrdersBillingV1CalculatedAdditionalFeeRefund = {
  __typename?: 'ComWixEcomOrdersBillingV1CalculatedAdditionalFeeRefund';
  /** Additional fee refund details. */
  additionalFee?: Maybe<ComWixEcomOrdersBillingV1AdditionalFeeRefund>;
  /** Calculated refund summary for this additional fee. */
  summary?: Maybe<ComWixEcomOrdersBillingV1CalculatedRefundSummary>;
};

export type ComWixEcomOrdersBillingV1CalculatedLineItemRefund = {
  __typename?: 'ComWixEcomOrdersBillingV1CalculatedLineItemRefund';
  /** Line item refund details. */
  item?: Maybe<ComWixEcomOrdersBillingV1LineItemRefund>;
  /** Calculated refund summary for this line item. */
  summary?: Maybe<ComWixEcomOrdersBillingV1CalculatedRefundSummary>;
};

export type ComWixEcomOrdersBillingV1CalculatedRefundItems = {
  __typename?: 'ComWixEcomOrdersBillingV1CalculatedRefundItems';
  /** Calculated refund details for each additional fee. */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1CalculatedAdditionalFeeRefund>>>;
  /** Calculated refund details for each line item. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1CalculatedLineItemRefund>>>;
  /** Calculated refund details for the shipping fee. */
  shipping?: Maybe<ComWixEcomOrdersBillingV1CalculatedShippingRefund>;
};

export type ComWixEcomOrdersBillingV1CalculatedRefundNotAvailableStatus = {
  __typename?: 'ComWixEcomOrdersBillingV1CalculatedRefundNotAvailableStatus';
  /** Refund calculation errors. */
  errors?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1CalculationError>>>;
};

export type ComWixEcomOrdersBillingV1CalculatedRefundSummary = {
  __typename?: 'ComWixEcomOrdersBillingV1CalculatedRefundSummary';
  /** Discount amount for the items being refunded. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the items being refunded (without tax and discount). */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax amount for the items being refunded. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total refundable amount. */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1CalculatedShippingRefund = {
  __typename?: 'ComWixEcomOrdersBillingV1CalculatedShippingRefund';
  /** Shipping refund details. */
  shipping?: Maybe<ComWixEcomOrdersBillingV1ShippingRefund>;
  /** Calculated refund summary for shipping. */
  summary?: Maybe<ComWixEcomOrdersBillingV1CalculatedRefundSummary>;
};

export type ComWixEcomOrdersBillingV1CalculationError = {
  __typename?: 'ComWixEcomOrdersBillingV1CalculationError';
  /** Additional fee */
  additionalFee?: Maybe<ComWixEcomOrdersBillingV1AdditionalFeeRefund>;
  /** Error details */
  error?: Maybe<WixApiDetails>;
  /** Line item */
  lineItem?: Maybe<ComWixEcomOrdersBillingV1LineItemRefund>;
  /** Shipping */
  shipping?: Maybe<ComWixEcomOrdersBillingV1ShippingRefund>;
};

export type ComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** List payment IDs and amounts to capture. */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersBillingV1PaymentCaptureInput>>>;
};

export type ComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsResponse = {
  __typename?: 'ComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsResponse';
  /** Order transactions updated with captured payment. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersBillingV1DelayedCaptureSettingsInput = {
  /**
   * Delay duration before performing the scheduled action.
   * > **Note:** If not set, the payment provider's default period will be used.
   */
  delayDuration?: InputMaybe<ComWixEcommercePlatformCommonApiDurationInput>;
  /** The action to perform on the authorized payment after the specified duration. */
  scheduledAction?: InputMaybe<ComWixEcomOrdersBillingV1DelayedCaptureSettingsScheduledAction>;
};

export enum ComWixEcomOrdersBillingV1DelayedCaptureSettingsScheduledAction {
  /** Whether payment will be auto-captured when duration passes. */
  Capture = 'CAPTURE',
  Unspecified = 'UNSPECIFIED',
  /** Whether payment will be auto-voided when duration passes. */
  Void = 'VOID'
}

export type ComWixEcomOrdersBillingV1GenerateReceiptsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment IDs. */
  paymentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersBillingV1GenerateReceiptsResponse = {
  __typename?: 'ComWixEcomOrdersBillingV1GenerateReceiptsResponse';
  /** Generated receipts information. */
  receipts?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1ReceiptInfo>>>;
};

export type ComWixEcomOrdersBillingV1GetOrderRefundabilityRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1GetOrderRefundabilityResponse = {
  __typename?: 'ComWixEcomOrdersBillingV1GetOrderRefundabilityResponse';
  /** List of additional fee refund amounts - both previously refunded and the amount still available for refund. */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1AdditionalFeeRefundability>>>;
  /** List of line item refund quantities. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1LineItemRefundability>>>;
  /** Payments and their refundability amounts and statuses. */
  payments?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1PaymentRefundability>>>;
  /** Aggregated payments summary. */
  paymentsSummary?: Maybe<ComWixEcomOrdersBillingV1PaymentsSummary>;
  /** Shipping refund amounts - both previously refunded and the amount still available for refund. */
  shipping?: Maybe<ComWixEcomOrdersBillingV1ShippingRefundability>;
};

export type ComWixEcomOrdersBillingV1GetRefundOptionsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1GetRefundOptionsResponse = {
  __typename?: 'ComWixEcomOrdersBillingV1GetRefundOptionsResponse';
  /** Refund options for additional fees: Describes available refund amount per additional fee. */
  additionalFeeRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1AdditionalFeeRefundOption>>>;
  /** Refund options for order items: Describes how much of each item can be refunded. */
  lineItemRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1LineItemRefundOption>>>;
  /**
   * Refund options for payments, linked to given order.
   * Contains refundability status and max refund amounts for each payment.
   */
  paymentRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1PaymentRefundOption>>>;
  /** Aggregated summary of payments. */
  paymentsSummary?: Maybe<ComWixEcomOrdersBillingV1PaymentsSummary>;
  /** Refund option for shipping: Describes available refund amount for shipping. */
  shippingRefundOption?: Maybe<ComWixEcomOrdersBillingV1ShippingRefundOption>;
};

export type ComWixEcomOrdersBillingV1LineItemRefund = {
  __typename?: 'ComWixEcomOrdersBillingV1LineItemRefund';
  /** Line item ID. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Quantity to refund. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1LineItemRefundInput = {
  /** Line item ID. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Quantity to refund. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1LineItemRefundOption = {
  __typename?: 'ComWixEcomOrdersBillingV1LineItemRefundOption';
  /** Line item quantity that is available for refund. */
  availableRefundQuantity?: Maybe<Scalars['Int']>;
  /** Line item ID. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Original line item quantity before any refunds. */
  originalQuantity?: Maybe<Scalars['Int']>;
  /** Previously refunded line item quantity. */
  refundedQuantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1LineItemRefundability = {
  __typename?: 'ComWixEcomOrdersBillingV1LineItemRefundability';
  /** Line item quantity that is available for refund. */
  availableRefundQuantity?: Maybe<Scalars['Int']>;
  /** Line item ID. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Original line item quantity before any refunds. */
  originalQuantity?: Maybe<Scalars['Int']>;
  /** Previously refunded line item quantity. */
  refundedQuantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus = {
  __typename?: 'ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus';
  /** Reason why the payment must be manually refunded via the payment provider's dashboard. */
  reason?: Maybe<ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatusManuallyRefundableReason>;
};

export enum ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatusManuallyRefundableReason {
  Expired = 'EXPIRED',
  NotSupported = 'NOT_SUPPORTED',
  Offline = 'OFFLINE',
  RequiresCardReader = 'REQUIRES_CARD_READER',
  UnknownReason = 'UNKNOWN_REASON'
}

export type ComWixEcomOrdersBillingV1MembershipPaymentSummary = {
  __typename?: 'ComWixEcomOrdersBillingV1MembershipPaymentSummary';
  /** IDs of line items paid with a membership. */
  paidLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** IDs of line items paid with a membership and available for refund. */
  refundableLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** IDs of line items previously refunded, and paid with a membership. */
  refundedLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersBillingV1MonetaryPaymentSummary = {
  __typename?: 'ComWixEcomOrdersBillingV1MonetaryPaymentSummary';
  /**
   * Maximum amount to refund,  **if** the refund is available.
   * max_refund = paid - refunded - refund_pending
   * `maxRefund` is calculated as `paid` minus `refunded` minus `refundPending`.
   */
  maxRefund?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Paid amount. */
  paid?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Pending refund amount. */
  refundPending?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Refunded amount. */
  refunded?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1NonRefundablePaymentStatus = {
  __typename?: 'ComWixEcomOrdersBillingV1NonRefundablePaymentStatus';
  /** Reason why the payment is not refundable. */
  reason?: Maybe<ComWixEcomOrdersBillingV1NonRefundablePaymentStatusNonRefundableReason>;
};

export enum ComWixEcomOrdersBillingV1NonRefundablePaymentStatusNonRefundableReason {
  AlreadyRefunded = 'ALREADY_REFUNDED',
  DisabledByProvider = 'DISABLED_BY_PROVIDER',
  Forbidden = 'FORBIDDEN',
  NotPaid = 'NOT_PAID',
  OrderIsPending = 'ORDER_IS_PENDING',
  OrderIsRejected = 'ORDER_IS_REJECTED',
  PendingRefund = 'PENDING_REFUND',
  ProviderIsDown = 'PROVIDER_IS_DOWN',
  TransactionNotFound = 'TRANSACTION_NOT_FOUND',
  UnknownReason = 'UNKNOWN_REASON',
  ZeroPrice = 'ZERO_PRICE'
}

export type ComWixEcomOrdersBillingV1PaymentCaptureInput = {
  /**
   * Capture amount.
   *
   * > **Note:** If not provided, the full authorized amount will be captured.
   */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** ID of the payment to capture. */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1PaymentInfo = {
  __typename?: 'ComWixEcomOrdersBillingV1PaymentInfo';
  /** Details of the credit card used for this payment. */
  creditCardDetails?: Maybe<ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails>;
  /** Membership payment summary. */
  membership?: Maybe<ComWixEcomOrdersBillingV1MembershipPaymentSummary>;
  /** Monetary payment summary. */
  monetary?: Maybe<ComWixEcomOrdersBillingV1MonetaryPaymentSummary>;
  /** Whether the payment was made offline. For example, when using cash or when marked as paid in the Business Manager. */
  offlinePayment?: Maybe<Scalars['Boolean']>;
  /** Payment ID. */
  paymentId?: Maybe<Scalars['String']>;
  /**
   * Payment method. Non-exhaustive list of supported values:
   *
   * `CreditCard`, `Alipay`, `AstropayCash`, `AstropayDBT`, `AstropayMBT`, `Bitcoin`, `BitPay`, `Cash`, `ConvenienceStore`, `EPay`, `Fake`, `Giropay`, `IDeal`, `InPerson`, `Klarna`, `MercadoPago`, `Netpay`, `NordeaSolo`, `Offline`, `PagSeguro`, `PayEasy`, `PayPal`, `Paysafecard`, `Paysafecash`, `PointOfSale`, `Poli`, `Privat24`, `Przelewy24`, `RapidTransfer`, `Sepa`, `Skrill`, `Sofort`, `Trustly`, `Neteller`, `Unionpay`, `UniPay`, `Yandex`
   */
  paymentMethod?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1PaymentRefundInput = {
  /** Refund amount. Not relevant for membership and gift card refunds. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Indicates that refund is made externally and manually (on the payment provider's side)
   * When false (default), the payment gateway will be called in order to make an actual refund, and then the payment will be marked as refunded.
   * When true, the payment will only be *marked* as refunded, and no actual refund will be performed.
   */
  externalRefund?: InputMaybe<Scalars['Boolean']>;
  /** Specific payment within the order to refund */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1PaymentRefundOption = {
  __typename?: 'ComWixEcomOrdersBillingV1PaymentRefundOption';
  /** Reason why the payment is only manually refundable. */
  manuallyRefundable?: Maybe<ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus>;
  /** Reason why the payment is not refundable. */
  nonRefundable?: Maybe<ComWixEcomOrdersBillingV1NonRefundablePaymentStatus>;
  /** Payment details. */
  payment?: Maybe<ComWixEcomOrdersBillingV1PaymentInfo>;
  /** URL to the payment provider's dashboard. */
  providerLink?: Maybe<Scalars['String']>;
  /** Whether the payment is available for both automatic and manual refunds. */
  refundable?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersBillingV1PaymentRefundability = {
  __typename?: 'ComWixEcomOrdersBillingV1PaymentRefundability';
  /** Reason why the payment is only manually refundable. */
  manuallyRefundable?: Maybe<ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus>;
  /** Reason why the payment is not refundable. */
  nonRefundable?: Maybe<ComWixEcomOrdersBillingV1NonRefundablePaymentStatus>;
  /** Payment details. */
  payment?: Maybe<ComWixEcomOrdersBillingV1PaymentInfo>;
  /** URL to the payment provider's dashboard. */
  providerLink?: Maybe<Scalars['String']>;
  /** Whether the payment is available for both automatic and manual refunds. */
  refundable?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersBillingV1PaymentsSummary = {
  __typename?: 'ComWixEcomOrdersBillingV1PaymentsSummary';
  /** Membership payments summary. */
  membership?: Maybe<ComWixEcomOrdersBillingV1MembershipPaymentSummary>;
  /** Monetary payments summary. */
  monetary?: Maybe<ComWixEcomOrdersBillingV1MonetaryPaymentSummary>;
};

export type ComWixEcomOrdersBillingV1ReceiptInfo = {
  __typename?: 'ComWixEcomOrdersBillingV1ReceiptInfo';
  /** Payment ID. */
  paymentId?: Maybe<Scalars['String']>;
  /** Receipt ID. */
  receipt?: Maybe<WixReceiptsV1Receipt>;
  /** Receipt ID. */
  receiptId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1RefundItemsInput = {
  /** Additional fees and their amounts to refund. */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersBillingV1AdditionalFeeRefundInput>>>;
  /** Line items and their quantities to refund. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersBillingV1LineItemRefundInput>>>;
  /** Shipping amount to refund. */
  shipping?: InputMaybe<ComWixEcomOrdersBillingV1ShippingRefundInput>;
};

export type ComWixEcomOrdersBillingV1RefundPaymentsRequestInput = {
  /** Customer-provided reason for the refund. */
  customerReason?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** List of payments and their amounts to refund. */
  paymentRefunds?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersBillingV1PaymentRefundInput>>>;
  /** List of line items, shipping and additional fees to refund. */
  refundItems?: InputMaybe<ComWixEcomOrdersBillingV1RefundItemsInput>;
  /** Side effect actions for restocking and notifications. */
  sideEffects?: InputMaybe<ComWixEcomOrdersBillingV1RefundSideEffectsInput>;
};

export type ComWixEcomOrdersBillingV1RefundPaymentsResponse = {
  __typename?: 'ComWixEcomOrdersBillingV1RefundPaymentsResponse';
  /** The order's transactions records after the refunds were performed. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Refund details. */
  refund?: Maybe<ComWixEcomOrdersPaymentsV1Refund>;
};

export type ComWixEcomOrdersBillingV1RefundSideEffectsInput = {
  /** Notification side effects. */
  notifications?: InputMaybe<ComWixEcomOrdersBillingV1RefundSideEffectsNotificationSideEffectsInput>;
  /** Restocking side effects. */
  restock?: InputMaybe<ComWixEcomOrdersBillingV1RefundSideEffectsRestockSideEffectsInput>;
};

export type ComWixEcomOrdersBillingV1RefundSideEffectsNotificationSideEffectsInput = {
  /** Custom message added to the refund confirmation email. */
  customMessage?: InputMaybe<Scalars['String']>;
  /**
   * Whether to send a refund confirmation email to the customer.
   *
   * Default: `false`
   */
  sendCustomerEmail?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersBillingV1RefundSideEffectsRestockItemInput = {
  /** Line item ID. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Quantity to restock. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1RefundSideEffectsRestockSideEffectsInput = {
  /** List of items to restock. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersBillingV1RefundSideEffectsRestockItemInput>>>;
};

export type ComWixEcomOrdersBillingV1ShippingRefund = {
  __typename?: 'ComWixEcomOrdersBillingV1ShippingRefund';
  /**
   * Amount to refund.
   *
   * Passing an empty value will refund the remaining refundable amount.
   */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1ShippingRefundInput = {
  /**
   * Amount to refund.
   *
   * Passing an empty value will refund the remaining refundable amount.
   */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersBillingV1ShippingRefundOption = {
  __typename?: 'ComWixEcomOrdersBillingV1ShippingRefundOption';
  /** Original shipping fee amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Shipping fee amount available for refund. */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded shipping fee amount. */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1ShippingRefundability = {
  __typename?: 'ComWixEcomOrdersBillingV1ShippingRefundability';
  /** Original shipping fee amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Shipping fee amount available for refund. */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded shipping fee amount. */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1VoidAuthorizedPaymentsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** IDs of the authorized payments to void. */
  paymentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersBillingV1VoidAuthorizedPaymentsResponse = {
  __typename?: 'ComWixEcomOrdersBillingV1VoidAuthorizedPaymentsResponse';
  /** Order transactions updated with voided payment. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentRequestInput = {
  /** List of order IDs and their associated fulfillments. */
  ordersWithFulfillments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersFulfillmentsV1BulkCreateOrderWithFulfillmentsInput>>>;
};

export type ComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentResponse = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersFulfillmentsV1BulkOrderFulfillmentsResult>>>;
};

export type ComWixEcomOrdersFulfillmentsV1BulkCreateOrderWithFulfillmentsInput = {
  /** Fulfillments associated with the order. */
  fulfillments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersFulfillmentsV1FulfillmentInput>>>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1BulkOrderFulfillmentsResult = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1BulkOrderFulfillmentsResult';
  /** Item metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  ordersWithFulfillments?: Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>;
};

export type ComWixEcomOrdersFulfillmentsV1CreateFulfillmentRequestInput = {
  /** Fulfillment info. */
  fulfillment?: InputMaybe<ComWixEcomOrdersFulfillmentsV1FulfillmentInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1CreateFulfillmentResponse = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1CreateFulfillmentResponse';
  /** ID of created fulfillment. */
  fulfillmentId?: Maybe<Scalars['String']>;
  /** Order ID and the orders' fulfillments. */
  orderWithFulfillments?: Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>;
};

export type ComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfo = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfo';
  /** Custom fulfillment info in key:value form. */
  fieldsData?: Maybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfoInput = {
  /** Custom fulfillment info in key:value form. */
  fieldsData?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersFulfillmentsV1DeleteFulfillmentRequestInput = {
  /** ID of the fulfillment to delete. */
  fulfillmentId?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1DeleteFulfillmentResponse = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1DeleteFulfillmentResponse';
  /** Order ID and the order's associated fulfillments after deletion. */
  orderWithFulfillments?: Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>;
};

export type ComWixEcomOrdersFulfillmentsV1Fulfillment = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1Fulfillment';
  /** Fulfillment handling complete. */
  completed?: Maybe<Scalars['Boolean']>;
  /** Fulfillment creation date and time in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: Maybe<Scalars['String']>;
  /** Custom fulfillment info. */
  customInfo?: Maybe<ComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfo>;
  /** Fulfillment ID. */
  id?: Maybe<Scalars['String']>;
  /** Line items being fulfilled. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersFulfillmentsV1FulfillmentLineItem>>>;
  /**
   * __Optional.__ Fulfillment status.
   *
   * Supported values:
   * + `"Pending"`
   * + `"Accepted"`
   * + `"Ready"`
   * + `"In_Delivery"`
   * + `"Fulfilled"`
   */
  status?: Maybe<Scalars['String']>;
  /** Tracking info. */
  trackingInfo?: Maybe<ComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfo>;
};

export type ComWixEcomOrdersFulfillmentsV1FulfillmentInput = {
  /** Fulfillment handling complete. */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Fulfillment creation date and time in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Custom fulfillment info. */
  customInfo?: InputMaybe<ComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfoInput>;
  /** Fulfillment ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line items being fulfilled. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersFulfillmentsV1FulfillmentLineItemInput>>>;
  /**
   * Fulfillment status.
   *
   * Supported values:
   * + `"Pending"`
   * + `"Accepted"`
   * + `"Ready"`
   * + `"In_Delivery"`
   * + `"Fulfilled"`
   */
  status?: InputMaybe<Scalars['String']>;
  /** Tracking info. */
  trackingInfo?: InputMaybe<ComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfoInput>;
};

export type ComWixEcomOrdersFulfillmentsV1FulfillmentLineItem = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1FulfillmentLineItem';
  /** Line item ID (mirrors the ID of the order line item). */
  id?: Maybe<Scalars['String']>;
  /**
   * Line item quantity.
   * * If this property isn't passed on creation, it defaults to the number of items not already linked to a fulfillment.
   * * If the order does not have the requested quantity of line items available to add to this fulfillment, the fulfillment will not be created and an error is returned.
   *
   * Min: `1`
   * Max: `100000`
   */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersFulfillmentsV1FulfillmentLineItemInput = {
  /** Line item ID (mirrors the ID of the order line item). */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Line item quantity.
   * * If this property isn't passed on creation, it defaults to the number of items not already linked to a fulfillment.
   * * If the order does not have the requested quantity of line items available to add to this fulfillment, the fulfillment will not be created and an error is returned.
   *
   * Min: `1`
   * Max: `100000`
   */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfo = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfo';
  /**
   * Shipping provider. Using one of the following shipping providers will allow for auto-filling the tracking link:
   * * `'fedex'`
   * * `'ups'`
   * * `'usps'`
   * * `'dhl'`
   * * `'canadaPost'`
   */
  shippingProvider?: Maybe<Scalars['String']>;
  /** Tracking link. Auto-filled if a predefined shipping provider is used, otherwise provided on creation. */
  trackingLink?: Maybe<Scalars['String']>;
  /** Shipping/delivery tracking number. */
  trackingNumber?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfoInput = {
  /**
   * Shipping provider. Using one of the following shipping providers will allow for auto-filling the tracking link:
   * * `'fedex'`
   * * `'ups'`
   * * `'usps'`
   * * `'dhl'`
   * * `'canadaPost'`
   */
  shippingProvider?: InputMaybe<Scalars['String']>;
  /** Tracking link. Auto-filled if a predefined shipping provider is used, otherwise provided on creation. */
  trackingLink?: InputMaybe<Scalars['String']>;
  /** Shipping/delivery tracking number. */
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersRequestInput = {
  /** List of order IDs for which to retrieve fulfillments. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersResponse = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersResponse';
  /** List of order IDs and their associated fulfillments. */
  ordersWithFulfillments?: Maybe<Array<Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>>>;
};

export type ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderRequestInput = {
  /** Order ID for which to retrieve fulfillments. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderResponse = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderResponse';
  /** List of fulfillments associated with the order. */
  orderWithFulfillments?: Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>;
};

export type ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments';
  /** Fulfillments associated with the order. */
  fulfillments?: Maybe<Array<Maybe<ComWixEcomOrdersFulfillmentsV1Fulfillment>>>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1UpdateFulfillmentRequestInput = {
  /** Set of fields to update. Fields that aren't included in `fieldMask.paths` are ignored. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Fulfillment info to update. */
  fulfillment?: InputMaybe<ComWixEcomOrdersFulfillmentsV1FulfillmentInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1UpdateFulfillmentResponse = {
  __typename?: 'ComWixEcomOrdersFulfillmentsV1UpdateFulfillmentResponse';
  /** Order ID and the orders' associated fulfillments after update. */
  orderWithFulfillments?: Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>;
};

export type ComWixEcomOrdersIndexerV1BatchOfTriggerReindexOrderRequestInput = {
  requests?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersIndexerV1TriggerReindexOrderRequestInput>>>;
};

export type ComWixEcomOrdersIndexerV1TriggerReindexOrderRequestInput = {
  metasiteId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersIndexerV1TriggerReindexRequestInput = {
  metasiteId?: InputMaybe<Scalars['String']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersInvoicesV1AddInvoiceToOrderRequestInput = {
  /** Invoice info. */
  invoiceInfo?: InputMaybe<ComWixEcomOrdersInvoicesV1InvoiceInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1AddInvoiceToOrderResponse = {
  __typename?: 'ComWixEcomOrdersInvoicesV1AddInvoiceToOrderResponse';
  /** List of order invoices. */
  orderInvoices?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1Invoice>>>;
};

export type ComWixEcomOrdersInvoicesV1BulkGenerateInvoicesRequestInput = {
  /** Order IDs. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersInvoicesV1BulkGenerateInvoicesResponse = {
  __typename?: 'ComWixEcomOrdersInvoicesV1BulkGenerateInvoicesResponse';
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1BulkInvoiceResult>>>;
};

export type ComWixEcomOrdersInvoicesV1BulkInvoiceResult = {
  __typename?: 'ComWixEcomOrdersInvoicesV1BulkInvoiceResult';
  item?: Maybe<ComWixEcomOrdersInvoicesV1InvoiceForOrder>;
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersInvoicesV1GenerateInvoiceRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1GenerateInvoiceResponse = {
  __typename?: 'ComWixEcomOrdersInvoicesV1GenerateInvoiceResponse';
  /** Invoice ID. */
  invoiceId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberRequestInput = {
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Date and time the payment was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  issueDate?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberResponse = {
  __typename?: 'ComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberResponse';
  /** Invoice ID. */
  invoiceId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1GetOrderInvoiceRequestInput = {
  /** Invoice ID. */
  invoiceId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1GetOrderInvoiceResponse = {
  __typename?: 'ComWixEcomOrdersInvoicesV1GetOrderInvoiceResponse';
  /** Invoice info. */
  invoiceInfo?: Maybe<ComWixEcomOrdersInvoicesV1Invoice>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1Invoice = {
  __typename?: 'ComWixEcomOrdersInvoicesV1Invoice';
  /** ID of the app that set the invoice. */
  appId?: Maybe<Scalars['String']>;
  /** Invoice ID. */
  id?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1InvoiceForOrder = {
  __typename?: 'ComWixEcomOrdersInvoicesV1InvoiceForOrder';
  /** Invoice ID. */
  invoiceId?: Maybe<Scalars['String']>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1InvoiceInput = {
  /** ID of the app that set the invoice. */
  appId?: InputMaybe<Scalars['String']>;
  /** Invoice ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1InvoicesForOrder = {
  __typename?: 'ComWixEcomOrdersInvoicesV1InvoicesForOrder';
  /** Invoices info. Deprecated: use `invoices_info` instead */
  invoices?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1Invoice>>>;
  /** Invoices info. */
  invoicesInfo?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1Invoice>>>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersRequestInput = {
  /** Order IDs for which to retrieve invoices. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersResponse = {
  __typename?: 'ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersResponse';
  /** List of order IDs and their associated invoices. */
  invoicesForOrder?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1InvoicesForOrder>>>;
};

export type ComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderResponse = {
  __typename?: 'ComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderResponse';
  /** List of invoices. */
  invoices?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1Invoice>>>;
};

export type ComWixEcomOrdersNotificationsV1BulkSendBuyerPickupConfirmationEmailsRequestInput = {
  /** IDs of orders to send pickup emails for. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersNotificationsV1BulkSendBuyerShippingConfirmationEmailsRequestInput = {
  /** IDs of orders to send pickup emails for. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersNotificationsV1PreviewBuyerConfirmationEmailResponse = {
  __typename?: 'ComWixEcomOrdersNotificationsV1PreviewBuyerConfirmationEmailResponse';
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewBuyerPaymentsReceivedEmailResponse = {
  __typename?: 'ComWixEcomOrdersNotificationsV1PreviewBuyerPaymentsReceivedEmailResponse';
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewBuyerPickupConfirmationEmailResponse = {
  __typename?: 'ComWixEcomOrdersNotificationsV1PreviewBuyerPickupConfirmationEmailResponse';
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewCancelEmailRequestInput = {
  /** Personal note added to the email (optional) */
  customMessage?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewCancelEmailResponse = {
  __typename?: 'ComWixEcomOrdersNotificationsV1PreviewCancelEmailResponse';
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailRequestInput = {
  /** Personal note added to the email (optional) */
  customMessage?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund amount */
  refundAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Refund ID. (Optional) */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailResponse = {
  __typename?: 'ComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailResponse';
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewEmailByTypeRequestInput = {
  emailType?: InputMaybe<ComWixEcomOrdersNotificationsV1PreviewEmailType>;
};

export type ComWixEcomOrdersNotificationsV1PreviewEmailByTypeResponse = {
  __typename?: 'ComWixEcomOrdersNotificationsV1PreviewEmailByTypeResponse';
  emailPreview?: Maybe<Scalars['String']>;
};

export enum ComWixEcomOrdersNotificationsV1PreviewEmailType {
  DownloadLinks = 'DOWNLOAD_LINKS',
  OrderPlaced = 'ORDER_PLACED',
  OrderReadyForPickup = 'ORDER_READY_FOR_PICKUP',
  OrderShipped = 'ORDER_SHIPPED'
}

export type ComWixEcomOrdersNotificationsV1PreviewRefundEmailRequestInput = {
  /** Personal note added to the email (optional) */
  customMessage?: InputMaybe<Scalars['String']>;
  /** Refund business details */
  details?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundDetailsInput>;
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund amount */
  refundAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Refund ID. (Optional) */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewRefundEmailResponse = {
  __typename?: 'ComWixEcomOrdersNotificationsV1PreviewRefundEmailResponse';
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewResendDownloadLinksEmailResponse = {
  __typename?: 'ComWixEcomOrdersNotificationsV1PreviewResendDownloadLinksEmailResponse';
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewShippingConfirmationEmailResponse = {
  __typename?: 'ComWixEcomOrdersNotificationsV1PreviewShippingConfirmationEmailResponse';
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendBuyerConfirmationEmailRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendBuyerPaymentsReceivedEmailRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendBuyerPickupConfirmationEmailRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendBuyerShippingConfirmationEmailRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendCancelRefundEmailRequestInput = {
  /** Personal note added to the email (optional) */
  customMessage?: InputMaybe<Scalars['String']>;
  /** The ID of order that is canceled/refunded */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund amount */
  refundAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Refund ID. (Optional) */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedNotificationRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedPushRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendRefundEmailRequestInput = {
  /** Personal note added to the email (optional) */
  customMessage?: InputMaybe<Scalars['String']>;
  /** The ID of order that is refunded */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund ID */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund';
  /** Additional fee  ID. */
  additionalFeeId?: Maybe<Scalars['String']>;
  /** Amount to refund. Empty value means refund for remaining (refundable) amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundInput = {
  /** Additional fee  ID. */
  additionalFeeId?: InputMaybe<Scalars['String']>;
  /** Amount to refund. Empty value means refund for remaining (refundable) amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundOption = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundOption';
  /** Additional fee ID */
  additionalFeeId?: Maybe<Scalars['String']>;
  /** Original additional fee amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional fee amount available for refund */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded additional fee amount */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidRequestInput = {
  /** IDs of orders to mark as paid. */
  ecomOrderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /**
   * Items updated by the bulk action.
   * The Order entity within the results optimistically changes its payment status to paid, however this process is async.
   */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput = {
  /** ID of the line item being refunded */
  id?: InputMaybe<Scalars['String']>;
  /** How much of that line item is being refunded */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse';
  /** Line item ID */
  id?: Maybe<Scalars['String']>;
  /** Refundable amount for requested quantity of items (price of requested quantity of items without tax and discount) */
  price?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundRequestInput = {
  /** Order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Refunded line items and quantity */
  refundItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput>>>;
  /** Should include shipping in refund calculation */
  refundShipping?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CalculateRefundResponse';
  /** Discount given for this order */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The refundable items of that order */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse>>>;
  /** Previous refund given on that order */
  previouslyRefundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total shipping cost for order */
  shipping?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the order (without tax) */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax cost of the order */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total refundable amount */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1RequestInput = {
  /** Order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Refunded line items and quantity */
  refundItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput>>>;
  /** Should include shipping in refund calculation */
  refundShipping?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1Response = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1Response';
  /** Discount given for this order */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The refundable items of that order */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse>>>;
  /** Previous refund given on that order */
  previouslyRefundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total shipping cost for order */
  shipping?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the order (without tax) */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax cost of the order */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total refundable amount */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2RequestInput = {
  /**
   * Refund details: list of items that are going to be refunded
   * (Optional): When not passed will return calculation for all items available for refund (line items, additional fees, shipping)
   */
  details?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput>;
  /** Order ID */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2Response = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2Response';
  /** Refund with given list of items will succeed */
  available?: Maybe<Scalars['Boolean']>;
  /** Calculated summary of each item provided for refund */
  calculatedDetails?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundDetails>;
  /**
   * Refund with given list of items will cause validation error. Contains details of items that would cause
   * validation error.
   */
  notAvailable?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundNotAvailableStatus>;
  /** Calculated summary of all items provided for refund */
  summary?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundSummary>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedAdditionalFeeRefund = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CalculatedAdditionalFeeRefund';
  /** Additional fee refund details */
  additionalFee?: Maybe<ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund>;
  /** Is refund available with given details */
  available?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedLineItemRefund = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CalculatedLineItemRefund';
  /** Calculated refund amount for given item */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Line item refund details */
  item?: Maybe<ComWixEcomOrdersPaymentsCollectorV1LineItemRefund>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundDetails = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundDetails';
  /** Calculated refund details for each order additional fee */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedAdditionalFeeRefund>>>;
  /** Calculated refund details for each order item */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedLineItemRefund>>>;
  /** Calculated refund details for order shipping */
  shipping?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedShippingRefund>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundNotAvailableStatus = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundNotAvailableStatus';
  /** Refund calculation errors */
  errors?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculationError>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundSummary = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundSummary';
  /** Discount of the items being refunded */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded amount for given order */
  previouslyRefundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Shipping amount that is being refunded */
  shipping?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the items being refunded (without tax) */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax of the items being refunded */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total refundable amount */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedShippingRefund = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CalculatedShippingRefund';
  /** Is refund available with given details */
  available?: Maybe<Scalars['Boolean']>;
  /** Shipping refund details */
  shipping?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ShippingRefund>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculationError = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CalculationError';
  /** Additional fee */
  additionalFee?: Maybe<ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund>;
  /** Error details */
  error?: Maybe<WixApiDetails>;
  /** Line item */
  lineItem?: Maybe<ComWixEcomOrdersPaymentsCollectorV1LineItemRefund>;
  /** Shipping */
  shipping?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ShippingRefund>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentRequestInput = {
  /**
   * Capture amount.
   * Currently we support only full payment amount capture.
   */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Wix eCommerce order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Payment ID */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsRequestInput = {
  /** Wix eCommerce order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Capture payments information */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1PaymentCaptureInput>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsResponse';
  /** All order's transactions after the capture was triggered */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ChargeMembershipsRequestInput = {
  /** Order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /**
   * The member id. Do not attempt to get it from the request context, since in some cases the caller is not a member
   * but a user which is using the membership on behalf of the a member
   */
  memberId?: InputMaybe<Scalars['String']>;
  /** List of items to be paid by memberships */
  membershipCharges?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1MembershipChargeItemInput>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodRequestInput = {
  /** Amount to be charged */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Ecom Order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodResponse';
  /** Payment gateway's order ID (e.g Wix Payments) */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ChargedByInput = {
  /** Full name - name of the user who initiated the payment */
  fullName?: InputMaybe<Scalars['String']>;
  /** ID - id of the user who initiated the payment */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderRequestInput = {
  /** Information about the user who initiated the payment. */
  chargedBy?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1ChargedByInput>;
  /**
   * Whether to delay capture of the payment.
   *
   * Default: false
   */
  delayedCapture?: InputMaybe<Scalars['Boolean']>;
  /** Ecom order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderResponse';
  /** ID of the order created in the payment gateway */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsInput = {
  /** Delay duration before execution. Optional - if not set, providers default period will be used */
  delayDuration?: InputMaybe<ComWixEcommercePlatformCommonApiDurationInput>;
  /** Specifies the automatic action (void/capture) for authorized transaction after the specified duration */
  scheduledAction?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsScheduledAction>;
};

export enum ComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsScheduledAction {
  /** Whether payment will be auto-captured when duration passes */
  Capture = 'CAPTURE',
  Unspecified = 'UNSPECIFIED',
  /** Whether payment will be auto-voided when duration passes */
  Void = 'VOID'
}

export type ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusRequestInput = {
  /** Ecom order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusResponse';
  /** Collectable order amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Whether authorization supported */
  authorizationSupported?: Maybe<Scalars['Boolean']>;
  /** Payment collectability status */
  status?: Maybe<ComWixEcomOrdersPaymentsCollectorV1PaymentCollectabilityStatusEnumPaymentCollectabilityStatus>;
};

export type ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsRequestInput = {
  /** Order Id */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsResponse';
  /** Refund options for additional fees: Describes available refund amount per additional fee */
  additionalFeeRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundOption>>>;
  /** Refund options for order items: Describes how much of each item can be refunded */
  lineItemRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1LineItemRefundOption>>>;
  /** Refund options for payments, linked to given order. Contains refundability status and max refund amounts for each payment */
  paymentRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1PaymentRefundOption>>>;
  /** Aggregated summary of payments */
  paymentsSummary?: Maybe<ComWixEcomOrdersPaymentsCollectorV1PaymentsSummary>;
  /** Refund option for shipping: Describes available refund amount for shipping */
  shippingRefundOption?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ShippingRefundOption>;
};

export type ComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusRequestInput = {
  /** Order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusResponse';
  /** Refundability details. */
  refundabilities?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1Refundability>>>;
  /** Whether the order supports refunding per item. */
  refundablePerItem?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1LineItemRefund = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1LineItemRefund';
  /** Line item ID */
  lineItemId?: Maybe<Scalars['String']>;
  /** Quantity to refund */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1LineItemRefundInput = {
  /** Line item ID */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Quantity to refund */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1LineItemRefundOption = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1LineItemRefundOption';
  /** Line item quantity available for refund */
  availableRefundQuantity?: Maybe<Scalars['Int']>;
  /** Line item ID */
  lineItemId?: Maybe<Scalars['String']>;
  /** Line item quantity */
  originalQuantity?: Maybe<Scalars['Int']>;
  /** Previously refunded quantity */
  refundedQuantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatus = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatus';
  /** Reason why payment has to be refunded manually via payment provider dashboard */
  reason?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatusManuallyRefundableReason>;
};

export enum ComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatusManuallyRefundableReason {
  Expired = 'EXPIRED',
  NotSupported = 'NOT_SUPPORTED',
  Offline = 'OFFLINE',
  UnknownReason = 'UNKNOWN_REASON'
}

export type ComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidRequestInput = {
  /** Ecom order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersPaymentsCollectorV1MembershipChargeItemInput = {
  /** ID of the application providing this payment option */
  appId?: InputMaybe<Scalars['String']>;
  /** Catalog and item reference info. */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** line item id of Checkout/Order line item */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Additional data about this membership */
  membershipAdditionalData?: InputMaybe<Scalars['JSON']>;
  /** The id of used membership */
  membershipId?: InputMaybe<Scalars['String']>;
  /** The name of used membership */
  membershipName?: InputMaybe<ComWixEcomMembershipsSpiV1MembershipNameInput>;
  /**
   * Usually would be the same as catalogReference.catalogItemId
   * For cases when these are not the same, this field would return the actual id of the item in the catalog
   * For example, for Wix bookings, catalogReference.catalogItemId is the booking id, and this value is being set to be the service id
   */
  rootCatalogItemId?: InputMaybe<Scalars['String']>;
  /** Properties of the service. When relevant, contains information such as date and number of participants. */
  serviceProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ServicePropertiesInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary';
  /** Line items that were paid with membership */
  paidLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Line items, paid with membership, that are available for refund */
  refundableLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Previously refunded line items that were paid with membership */
  refundedLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary';
  /**
   * Maximum amount to refund ** when refund is allowed  **
   * max_refund = paid - refunded - refund_pending
   */
  maxRefund?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Paid amount */
  paid?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Pending refund amount */
  refundPending?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Refunded amount */
  refunded?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatus = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatus';
  /** Reason why payment is not refundable */
  reason?: Maybe<ComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatusNonRefundableReason>;
};

export enum ComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatusNonRefundableReason {
  AlreadyRefunded = 'ALREADY_REFUNDED',
  DisabledByProvider = 'DISABLED_BY_PROVIDER',
  Forbidden = 'FORBIDDEN',
  NotPaid = 'NOT_PAID',
  PendingRefund = 'PENDING_REFUND',
  ProviderIsDown = 'PROVIDER_IS_DOWN',
  TransactionNotFound = 'TRANSACTION_NOT_FOUND',
  UnknownReason = 'UNKNOWN_REASON',
  ZeroPrice = 'ZERO_PRICE'
}

export type ComWixEcomOrdersPaymentsCollectorV1PaymentCaptureInput = {
  /**
   * Capture amount.
   * If not provided - full authorized amount will be captured.
   */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Payment ID */
  paymentId?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomOrdersPaymentsCollectorV1PaymentCollectabilityStatusEnumPaymentCollectabilityStatus {
  Collectable = 'COLLECTABLE',
  NoncollectableMissingPaymentMethod = 'NONCOLLECTABLE_MISSING_PAYMENT_METHOD',
  NoncollectableOrderHasSubscriptions = 'NONCOLLECTABLE_ORDER_HAS_SUBSCRIPTIONS',
  NoncollectableOrderIsCancelled = 'NONCOLLECTABLE_ORDER_IS_CANCELLED',
  NoncollectableOrderIsPaid = 'NONCOLLECTABLE_ORDER_IS_PAID',
  NoncollectableOrderIsPending = 'NONCOLLECTABLE_ORDER_IS_PENDING',
  NoncollectableOrderIsRejected = 'NONCOLLECTABLE_ORDER_IS_REJECTED',
  Unknown = 'UNKNOWN'
}

export type ComWixEcomOrdersPaymentsCollectorV1PaymentInfo = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1PaymentInfo';
  /** Details of credit card, used for this payment */
  creditCardDetails?: Maybe<ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails>;
  /** Membership payment summary */
  membership?: Maybe<ComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary>;
  /** Monetary payment summary */
  monetary?: Maybe<ComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary>;
  /** Payment ID */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1PaymentRefundInput = {
  /** Refund amount. Not relevant for membership and gift card refunds. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Indicates that refund is made externally and manually (on the payment provider's side)
   * When false (default), the payment gateway will be called in order to make an actual refund, and then the payment will be marked as refunded.
   * When true, the payment will only be *marked* as refunded, and no actual refund will be performed.
   */
  externalRefund?: InputMaybe<Scalars['Boolean']>;
  /** Specific payment within the order to refund */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1PaymentRefundOption = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1PaymentRefundOption';
  /** Payment is refundable. Only manual refund. Contains reason */
  manuallyRefundable?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatus>;
  /** Payment is not refundable. Contains reason */
  nonRefundable?: Maybe<ComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatus>;
  /** Payment details with summary */
  payment?: Maybe<ComWixEcomOrdersPaymentsCollectorV1PaymentInfo>;
  /** Link to payment provider dashboard */
  providerLink?: Maybe<Scalars['String']>;
  /** Payment is refundable. Available for automatic and manual refund */
  refundable?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1PaymentsSummary = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1PaymentsSummary';
  /** Membership payments summary */
  membership?: Maybe<ComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary>;
  /** Monetary payments summary */
  monetary?: Maybe<ComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary>;
};

export type ComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionRequestInput = {
  /** Amount to collect */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Delayed capture payment settings */
  delayedCaptureSettings?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsInput>;
  /** Ecom order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /**
   * Specifies whether payment collection is initiated by Merchant or User of User
   * Default: `true`
   */
  merchantInitiated?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optional parameter. When present, payment collection will be performed using given payment gateway order.
   * Existing payment gateway order will be updated with a new amount.
   * When parameter is absent, new payment gateway order will be created and used for payment collection.
   */
  paymentGatewayOrderId?: InputMaybe<Scalars['String']>;
  /** Redirect urls which are used to return buyer to third party system. */
  redirectUrls?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RedirectUrlsInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionResponse';
  /** Payment gateway order id which is associated with given payment */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RecordManuallyCollectedPaymentRequestInput = {
  /** Amount to be recorded as approved manual payment for given order */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RedirectUrlsInput = {
  /** URL to redirect buyer in case of buyer canceled the transaction */
  cancelUrl?: InputMaybe<Scalars['String']>;
  /** URL to redirect buyer in case of failed/rejected transaction */
  errorUrl?: InputMaybe<Scalars['String']>;
  /** URL to redirect buyer in case of pending transaction (that might take some time to process) */
  pendingUrl?: InputMaybe<Scalars['String']>;
  /** URL to redirect buyer in case of approved (successful) transaction */
  successUrl?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput = {
  /** Additional fees to refund */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundInput>>>;
  /** Reason for the refund, provided by customer (optional). */
  customerReason?: InputMaybe<Scalars['String']>;
  /** Line items to refund */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1LineItemRefundInput>>>;
  /** Shipping to refund */
  shipping?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1ShippingRefundInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundRequestInput = {
  /** Details about refunded items */
  details?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput>;
  /** The order this refund is related to */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund operations information */
  paymentRefunds?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1PaymentRefundInput>>>;
  /** Side effect details related to refund */
  sideEffects?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1RefundResponse';
  /** All order's transactions after the refunds were added */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Created refund */
  refund?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1Refund>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsInput = {
  /** Notification side effects */
  notifications?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsNotificationSideEffectsInput>;
  /** Restock side effects */
  restock?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockSideEffectsInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsNotificationSideEffectsInput = {
  /** Custom message added to the refund confirmation emails. */
  customMessage?: InputMaybe<Scalars['String']>;
  /** Customer will be notified about each refund transaction via email. Default: false */
  sendCustomerEmail?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockItemInput = {
  /** Line item ID */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Quantity to restock */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockSideEffectsInput = {
  /** List of items for restock */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockItemInput>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1Refundability = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1Refundability';
  /** Reason why payment is only refundable manually. */
  manuallyRefundableReason?: Maybe<ComWixEcomOrdersPaymentsCollectorV1RefundabilityManuallyRefundableReason>;
  /** Reason why payment is not refundable. */
  nonRefundableReason?: Maybe<ComWixEcomOrdersPaymentsCollectorV1RefundabilityNonRefundableReason>;
  /** Payment ID. */
  paymentId?: Maybe<Scalars['String']>;
  /** Link to payment provider dashboard. */
  providerLink?: Maybe<Scalars['String']>;
  /** Payment refundability status. */
  refundabilityStatus?: Maybe<ComWixEcomOrdersPaymentsCollectorV1RefundabilityRefundableStatus>;
};

export enum ComWixEcomOrdersPaymentsCollectorV1RefundabilityManuallyRefundableReason {
  Expired = 'EXPIRED',
  NotSupported = 'NOT_SUPPORTED',
  Offline = 'OFFLINE',
  RequiresCardReader = 'REQUIRES_CARD_READER'
}

export enum ComWixEcomOrdersPaymentsCollectorV1RefundabilityNonRefundableReason {
  AccessDenied = 'ACCESS_DENIED',
  AlreadyRefunded = 'ALREADY_REFUNDED',
  DisabledByProvider = 'DISABLED_BY_PROVIDER',
  Forbidden = 'FORBIDDEN',
  InternalError = 'INTERNAL_ERROR',
  None = 'NONE',
  NotPaid = 'NOT_PAID',
  OrderIsPending = 'ORDER_IS_PENDING',
  OrderIsRejected = 'ORDER_IS_REJECTED',
  PendingRefund = 'PENDING_REFUND',
  ProviderIsDown = 'PROVIDER_IS_DOWN',
  TransactionNotFound = 'TRANSACTION_NOT_FOUND',
  ZeroPrice = 'ZERO_PRICE'
}

export enum ComWixEcomOrdersPaymentsCollectorV1RefundabilityRefundableStatus {
  Manual = 'MANUAL',
  NotRefundable = 'NOT_REFUNDABLE',
  Refundable = 'REFUNDABLE'
}

export type ComWixEcomOrdersPaymentsCollectorV1ShippingRefund = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1ShippingRefund';
  /** Amount to refund. Empty value means refund for remaining (refundable) amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ShippingRefundInput = {
  /** Amount to refund. Empty value means refund for remaining (refundable) amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ShippingRefundOption = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1ShippingRefundOption';
  /** Original shipping amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Shipping amount available for refund */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded shipping amount */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1TriggerRefundRequestInput = {
  /** Business model of a refund */
  details?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundDetailsInput>;
  /** The order this refund related to */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Refund operations information */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1PaymentRefundInput>>>;
  /** Side effect details related to refund */
  sideEffects?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundSideEffectsInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1TriggerRefundResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1TriggerRefundResponse';
  /** Payment ID's that the refund execution had failed for */
  failedPaymentIds?: Maybe<Array<Maybe<WixCommonItemMetadata>>>;
  /** All order's transactions after the refunds were added */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Created refund ID */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentRequestInput = {
  /** Wix eCommerce order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Payment ID */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsRequestInput = {
  /** Wix eCommerce order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Payment IDs */
  paymentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsResponse';
  /** All order's transactions after the void was triggered */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1AddChargebackRequestInput = {
  /** Chargeback. */
  chargeback?: InputMaybe<ComWixEcomOrdersPaymentsV1ChargebackInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment ID. */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AddChargebackResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1AddChargebackResponse';
  /** Chargeback. */
  chargeback?: Maybe<ComWixEcomOrdersPaymentsV1Chargeback>;
  /** Order transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Payment ID of a payment which received chargeback. */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AddInvoiceToOrderRequestInput = {
  /** Invoice info. */
  invoiceInfo?: InputMaybe<ComWixEcomOrdersPaymentsV1InvoiceInfoInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AddInvoiceToOrderResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1AddInvoiceToOrderResponse';
  /** List of order invoices. */
  orderInvoices?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1InvoiceInfo>>>;
};

export type ComWixEcomOrdersPaymentsV1AddPaymentsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payments to be added to order. */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1PaymentInput>>>;
};

export type ComWixEcomOrdersPaymentsV1AddPaymentsResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1AddPaymentsResponse';
  /** Order ID and its associated transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** IDs of added order payments. */
  paymentsIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsV1AddRefundRequestInput = {
  /** Order ID this refunds related to */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund with refund transactions to be added to order. */
  refund?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundInput>;
  /** Side effect details related to refund */
  sideEffects?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundSideEffectsInput>;
};

export type ComWixEcomOrdersPaymentsV1AddRefundResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1AddRefundResponse';
  /** Order ID and its associated transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Created refund ID */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AdditionalFeeRefund = {
  __typename?: 'ComWixEcomOrdersPaymentsV1AdditionalFeeRefund';
  /** Additional fee ID. */
  additionalFeeId?: Maybe<Scalars['String']>;
  /** Refund amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsV1AdditionalFeeRefundInput = {
  /** Additional fee ID. */
  additionalFeeId?: InputMaybe<Scalars['String']>;
  /** Refund amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsV1AggregatedRefundSummary = {
  __typename?: 'ComWixEcomOrdersPaymentsV1AggregatedRefundSummary';
  /** Breakdown of refunded items. Available only after refund is complete. */
  breakdown?: Maybe<ComWixEcomOrdersPaymentsV1RefundItemsBreakdown>;
  /** Failed refund amount - the portion of `requestedRefund` that failed. */
  failedRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Whether at least one refund transaction is still in `"PENDING"` status. */
  pending?: Maybe<Scalars['Boolean']>;
  /** Pending refund amount - the portion of `requestedRefund` that is still pending. */
  pendingRefund?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Refunded amount - the portion of `requestedRefund` that refunded successfully. */
  refunded?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total amount requested for refund. */
  requestedRefund?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsV1AggregatedRefundSummaryInput = {
  /** Breakdown of refunded items. Available only after refund is complete. */
  breakdown?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundItemsBreakdownInput>;
  /** Failed refund amount - the portion of `requestedRefund` that failed. */
  failedRefundAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Whether at least one refund transaction is still in `"PENDING"` status. */
  pending?: InputMaybe<Scalars['Boolean']>;
  /** Pending refund amount - the portion of `requestedRefund` that is still pending. */
  pendingRefund?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Refunded amount - the portion of `requestedRefund` that refunded successfully. */
  refunded?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total amount requested for refund. */
  requestedRefund?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails = {
  __typename?: 'ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails';
  failureCode?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput = {
  failureCode?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationCapture = {
  __typename?: 'ComWixEcomOrdersPaymentsV1AuthorizationCapture';
  /** Amount of this capture */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Date and time the capture was initiated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: Maybe<Scalars['String']>;
  /** In case of status is FAILED may contain failure details */
  failureDetails?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails>;
  /** Capture ID. */
  id?: Maybe<Scalars['String']>;
  /** Status of this capture action */
  status?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationCaptureStatusEnumAuthorizationCaptureStatus>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationCaptureInput = {
  /** Amount of this capture */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Date and time the capture was initiated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** In case of status is FAILED may contain failure details */
  failureDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput>;
  /** Capture ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Status of this capture action */
  status?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationCaptureStatusEnumAuthorizationCaptureStatus>;
};

export enum ComWixEcomOrdersPaymentsV1AuthorizationCaptureStatusEnumAuthorizationCaptureStatus {
  /** Capture operation failed. */
  Failed = 'FAILED',
  /** Capture operation still in progress. */
  Pending = 'PENDING',
  /** Capture operation succeeded. */
  Succeeded = 'SUCCEEDED',
  UnknownStatus = 'UNKNOWN_STATUS'
}

export type ComWixEcomOrdersPaymentsV1AuthorizationDetails = {
  __typename?: 'ComWixEcomOrdersPaymentsV1AuthorizationDetails';
  /** Date and time the payment was authorized in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  authorizedDate?: Maybe<Scalars['String']>;
  /**
   * List of captures associated with payment
   * In case of failed it can be replaced with new one with PENDING or SUCCESS statuses
   */
  captures?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1AuthorizationCapture>>>;
  /** Whether the authorized payment is of a delayed capture. */
  delayedCapture?: Maybe<Scalars['Boolean']>;
  /** Scheduled action for this transaction */
  scheduledAction?: Maybe<ComWixEcomOrdersPaymentsV1ScheduledAction>;
  /** Void associated with payment */
  void?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationVoid>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationDetailsInput = {
  /** Date and time the payment was authorized in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  authorizedDate?: InputMaybe<Scalars['String']>;
  /**
   * List of captures associated with payment
   * In case of failed it can be replaced with new one with PENDING or SUCCESS statuses
   */
  captures?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationCaptureInput>>>;
  /** Whether the authorized payment is of a delayed capture. */
  delayedCapture?: InputMaybe<Scalars['Boolean']>;
  /** Scheduled action for this transaction */
  scheduledAction?: InputMaybe<ComWixEcomOrdersPaymentsV1ScheduledActionInput>;
  /** Void associated with payment */
  void?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationVoidInput>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationVoid = {
  __typename?: 'ComWixEcomOrdersPaymentsV1AuthorizationVoid';
  /** In case of status is FAILED may contain failure details */
  failureDetails?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails>;
  /** Reason of void action */
  reason?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationVoidReason>;
  /** Status of this void action */
  status?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationVoidStatusEnumAuthorizationVoidStatus>;
  /** Date and time the void was initiated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  voidedDate?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationVoidInput = {
  /** In case of status is FAILED may contain failure details */
  failureDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput>;
  /** Reason of void action */
  reason?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationVoidReason>;
  /** Status of this void action */
  status?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationVoidStatusEnumAuthorizationVoidStatus>;
  /** Date and time the void was initiated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  voidedDate?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomOrdersPaymentsV1AuthorizationVoidReason {
  /** Authorization was voided by user. */
  Manual = 'MANUAL',
  /** Authorization passed execution date. */
  Scheduled = 'SCHEDULED',
  UnknownReason = 'UNKNOWN_REASON'
}

export enum ComWixEcomOrdersPaymentsV1AuthorizationVoidStatusEnumAuthorizationVoidStatus {
  /** Void operation failed. */
  Failed = 'FAILED',
  /** Void operation still in progress. */
  Pending = 'PENDING',
  /** Void operation succeeded. */
  Succeeded = 'SUCCEEDED',
  UnknownStatus = 'UNKNOWN_STATUS'
}

export type ComWixEcomOrdersPaymentsV1BulkGenerateInvoicesRequestInput = {
  /** Order IDs. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsV1BulkGenerateInvoicesResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1BulkGenerateInvoicesResponse';
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1BulkInvoiceResult>>>;
};

export type ComWixEcomOrdersPaymentsV1BulkInvoiceResult = {
  __typename?: 'ComWixEcomOrdersPaymentsV1BulkInvoiceResult';
  item?: Maybe<ComWixEcomOrdersPaymentsV1InvoiceForOrder>;
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersPaymentsV1BulkPaymentResult = {
  __typename?: 'ComWixEcomOrdersPaymentsV1BulkPaymentResult';
  /** Updated payment. Returned if `return_full_entity` set to `true`. */
  item?: Maybe<ComWixEcomOrdersPaymentsV1Payment>;
  /** Item metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesRequestInput = {
  /** Order and payment IDs for which to update payment status. */
  paymentAndOrderIds?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1PaymentAndOrderIdInput>>>;
  /** Whether to return the full payment entity (`results.item`) in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
  /** Payment status. */
  status?: InputMaybe<WixPaymentApiPayV3TransactionTransactionStatus>;
  /**
   * *TBD** NOT IMPLEMENTED
   * Status update date
   * When defined -> the update will be applied only if it's newer than existing one, otherwise will throw 409
   * Not defined -> apply the update without any verification.
   */
  statusUpdatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesResponse';
  /** Bulk operation metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk operation results. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1BulkPaymentResult>>>;
};

export type ComWixEcomOrdersPaymentsV1CalculateRefundItemRequestInput = {
  /** ID of the line item being refunded */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** How much of that line item is being refunded */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Should this item be restocked (used for validation purposes) */
  restock?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1CalculateRefundItemResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1CalculateRefundItemResponse';
  /** Line item ID */
  lineItemId?: Maybe<Scalars['String']>;
  /** The line item's price */
  lineItemPrice?: Maybe<Scalars['Float']>;
};

export type ComWixEcomOrdersPaymentsV1CalculateRefundRequestInput = {
  /** Order ID */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refunded line items and quantity */
  refundItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1CalculateRefundItemRequestInput>>>;
  /** Should include shipping in refund calculation */
  refundShipping?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1CalculateRefundResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1CalculateRefundResponse';
  /** Discount given for this order */
  discount?: Maybe<Scalars['String']>;
  /** The refundable items of that order */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1CalculateRefundItemResponse>>>;
  /** Previous refund given on that order */
  previouslyRefundedAmount?: Maybe<Scalars['String']>;
  /** Total cost of the order (without tax) */
  subtotal?: Maybe<Scalars['String']>;
  /** Tax cost of the order */
  tax?: Maybe<Scalars['String']>;
  /** Total refundable amount */
  total?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1Chargeback = {
  __typename?: 'ComWixEcomOrdersPaymentsV1Chargeback';
  /** Amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Date and time the chargeback was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: Maybe<Scalars['String']>;
  /** External chargeback ID. */
  externalId?: Maybe<Scalars['String']>;
  /** Chargeback ID. */
  id?: Maybe<Scalars['String']>;
  /** Reversal amount. Present only when status is REVERSED. */
  reversalAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /**
   * Status.
   *
   * Default: `"APPROVED"`.
   */
  status?: Maybe<ComWixEcomOrdersPaymentsV1ChargebackStatus>;
  /** Date and time the chargeback was updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1ChargebackInput = {
  /** Amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Date and time the chargeback was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** External chargeback ID. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Chargeback ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Reversal amount. Present only when status is REVERSED. */
  reversalAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Status.
   *
   * Default: `"APPROVED"`.
   */
  status?: InputMaybe<ComWixEcomOrdersPaymentsV1ChargebackStatus>;
  /** Date and time the chargeback was updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomOrdersPaymentsV1ChargebackStatus {
  /** Chargeback was approved. */
  Approved = 'APPROVED',
  /** Chargeback was reversed. */
  Reversed = 'REVERSED',
  Unspecified = 'UNSPECIFIED'
}

export type ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails = {
  __typename?: 'ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails';
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetailsInput = {
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1ExternalReceiptInfo = {
  __typename?: 'ComWixEcomOrdersPaymentsV1ExternalReceiptInfo';
  /** ID of the app providing the receipt */
  appId?: Maybe<Scalars['String']>;
  /** Display number of receipt */
  displayNumber?: Maybe<Scalars['String']>;
  /** External receipt ID */
  receiptId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1ExternalReceiptInfoInput = {
  /** ID of the app providing the receipt */
  appId?: InputMaybe<Scalars['String']>;
  /** Display number of receipt */
  displayNumber?: InputMaybe<Scalars['String']>;
  /** External receipt ID */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1GenerateInvoiceRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1GenerateInvoiceResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1GenerateInvoiceResponse';
  /** Invoice ID. */
  invoiceId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1GetOrderTransactionsRequestInput = {
  id: Scalars['ID'];
};

export type ComWixEcomOrdersPaymentsV1GetRefundabilityStatusRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1GetRefundabilityStatusResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1GetRefundabilityStatusResponse';
  /** Refundability details. */
  refundabilities?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1Refundability>>>;
  /** Whether the order supports refunding per item. */
  refundablePerItem?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1GiftCardPaymentDetails = {
  __typename?: 'ComWixEcomOrdersPaymentsV1GiftCardPaymentDetails';
  /** ID of the app that created the gift card. */
  appId?: Maybe<Scalars['String']>;
  /** Gift card ID. */
  giftCardId?: Maybe<Scalars['String']>;
  /** Gift card payment ID. */
  giftCardPaymentId?: Maybe<Scalars['String']>;
  /** Gift card obfuscated code. */
  obfuscatedCode?: Maybe<Scalars['String']>;
  /** Whether the gift card is voided. */
  voided?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1GiftCardPaymentDetailsInput = {
  /** ID of the app that created the gift card. */
  appId?: InputMaybe<Scalars['String']>;
  /** Gift card ID. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /** Gift card payment ID. */
  giftCardPaymentId?: InputMaybe<Scalars['String']>;
  /** Gift card obfuscated code. */
  obfuscatedCode?: InputMaybe<Scalars['String']>;
  /** Whether the gift card is voided. */
  voided?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1InvoiceForOrder = {
  __typename?: 'ComWixEcomOrdersPaymentsV1InvoiceForOrder';
  /** Invoice ID. */
  invoiceId?: Maybe<Scalars['String']>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1InvoiceInfo = {
  __typename?: 'ComWixEcomOrdersPaymentsV1InvoiceInfo';
  /** ID of the app that set the invoice. */
  appId?: Maybe<Scalars['String']>;
  /** Invoice creation date and time. */
  createdDate?: Maybe<Scalars['String']>;
  /** Invoice ID. */
  id?: Maybe<Scalars['String']>;
  /** Invoice URL. */
  url?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1InvoiceInfoInput = {
  /** ID of the app that set the invoice. */
  appId?: InputMaybe<Scalars['String']>;
  /** Invoice creation date and time. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Invoice ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Invoice URL. */
  url?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1InvoicesForOrder = {
  __typename?: 'ComWixEcomOrdersPaymentsV1InvoicesForOrder';
  /** Invoices info. */
  invoicesInfo?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1InvoiceInfo>>>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1LineItemRefund = {
  __typename?: 'ComWixEcomOrdersPaymentsV1LineItemRefund';
  /** Line item ID. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Refund quantity. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1LineItemRefundInput = {
  /** Line item ID. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Refund quantity. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1LineItemRefundSummary = {
  __typename?: 'ComWixEcomOrdersPaymentsV1LineItemRefundSummary';
  /** ID of the refunded line item. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Total refunded amount for the line item. */
  totalRefundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsV1LineItemRefundSummaryInput = {
  /** ID of the refunded line item. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Total refunded amount for the line item. */
  totalRefundedAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersRequestInput = {
  /** Order IDs for which to retrieve invoices. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersResponse';
  /** List of order IDs and their associated invoices. */
  invoicesForOrder?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1InvoicesForOrder>>>;
};

export type ComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderResponse';
  /** List of invoices. */
  invoices?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1InvoiceInfo>>>;
};

export type ComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersRequestInput = {
  /** Order IDs for which to retrieve transactions. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersResponse';
  /** List of order IDs and their associated transactions. */
  orderTransactions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>>>;
};

export type ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderResponse';
  /** Order ID and its associated transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1MaskedPaymentInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Updated payment */
  payment?: InputMaybe<ComWixEcomOrdersPaymentsV1PaymentInput>;
  /**
   * Status update date
   * When defined -> the update will be applied only if it's newer than existing one, otherwise will throw error
   * Not defined -> apply the update without any verification.
   */
  statusUpdatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1MembershipPaymentDetails = {
  __typename?: 'ComWixEcomOrdersPaymentsV1MembershipPaymentDetails';
  /** The transaction ID in the membership system. Can be used to void the transaction. */
  externalTransactionId?: Maybe<Scalars['String']>;
  /** ID of the line item this membership applies to. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Membership ID. */
  membershipId?: Maybe<Scalars['String']>;
  /** Membership name. */
  name?: Maybe<ComWixEcomMembershipsSpiV1MembershipName>;
  /** ID of the application providing this payment option. */
  providerAppId?: Maybe<Scalars['String']>;
  /** Payment status. */
  status?: Maybe<ComWixEcomOrdersPaymentsV1MembershipPaymentStatus>;
  /** Whether the membership is voided. */
  voided?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1MembershipPaymentDetailsInput = {
  /** The transaction ID in the membership system. Can be used to void the transaction. */
  externalTransactionId?: InputMaybe<Scalars['String']>;
  /** ID of the line item this membership applies to. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Membership ID. */
  membershipId?: InputMaybe<Scalars['String']>;
  /** Membership name. */
  name?: InputMaybe<ComWixEcomMembershipsSpiV1MembershipNameInput>;
  /** ID of the application providing this payment option. */
  providerAppId?: InputMaybe<Scalars['String']>;
  /** Payment status. */
  status?: InputMaybe<ComWixEcomOrdersPaymentsV1MembershipPaymentStatus>;
  /** Whether the membership is voided. */
  voided?: InputMaybe<Scalars['Boolean']>;
};

export enum ComWixEcomOrdersPaymentsV1MembershipPaymentStatus {
  /** Payment was charged. */
  Charged = 'CHARGED',
  /** The attempt to charge the payment failed, for example, due to lack of credits. */
  ChargeFailed = 'CHARGE_FAILED'
}

export type ComWixEcomOrdersPaymentsV1OrderTransactions = {
  __typename?: 'ComWixEcomOrdersPaymentsV1OrderTransactions';
  /** Order ID. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
  /** Record of payments made to the merchant. */
  payments?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1Payment>>>;
  /** Record of refunds made to the buyer. */
  refunds?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1Refund>>>;
};

export type ComWixEcomOrdersPaymentsV1Payment = {
  __typename?: 'ComWixEcomOrdersPaymentsV1Payment';
  /** Payment amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Date and time the payment was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: Maybe<Scalars['String']>;
  /** Receipt created by an external system. */
  externalReceipt?: Maybe<ComWixEcomOrdersPaymentsV1ExternalReceiptInfo>;
  /** Gift card payment details. */
  giftcardPaymentDetails?: Maybe<ComWixEcomOrdersPaymentsV1GiftCardPaymentDetails>;
  /** Payment ID. */
  id?: Maybe<Scalars['String']>;
  /** Membership payment details. */
  membershipPaymentDetails?: Maybe<ComWixEcomOrdersPaymentsV1MembershipPaymentDetails>;
  /**
   * Whether refunds for this payment are disabled.
   * + `true`: This payment is not refundable.
   * + `false`: This payment may be refunded. However, this ultimately depends on the payment provider.
   */
  refundDisabled?: Maybe<Scalars['Boolean']>;
  /** Regular payment details. */
  regularPaymentDetails?: Maybe<ComWixEcomOrdersPaymentsV1RegularPaymentDetails>;
  /**
   * Whether receipt generation for this payment are allowed.
   * + `true`: This payment supports receipt generation.
   * + `false`: This payment not supports receipt generation, or receipt already generated
   */
  supportReceiptGeneration?: Maybe<Scalars['Boolean']>;
  /** Date and time the payment was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: Maybe<ComWixEcomOrdersPaymentsV1WixReceiptInfo>;
};

export type ComWixEcomOrdersPaymentsV1PaymentAndOrderIdInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /**
   * Payment ID.
   * todo: remove comment once UI will use BulkMarkOrderAsPaid
   */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1PaymentInput = {
  /** Payment amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Date and time the payment was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Receipt created by an external system. */
  externalReceipt?: InputMaybe<ComWixEcomOrdersPaymentsV1ExternalReceiptInfoInput>;
  /** Gift card payment details. */
  giftcardPaymentDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1GiftCardPaymentDetailsInput>;
  /** Payment ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Membership payment details. */
  membershipPaymentDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1MembershipPaymentDetailsInput>;
  /**
   * Whether refunds for this payment are disabled.
   * + `true`: This payment is not refundable.
   * + `false`: This payment may be refunded. However, this ultimately depends on the payment provider.
   */
  refundDisabled?: InputMaybe<Scalars['Boolean']>;
  /** Regular payment details. */
  regularPaymentDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1RegularPaymentDetailsInput>;
  /**
   * Whether receipt generation for this payment are allowed.
   * + `true`: This payment supports receipt generation.
   * + `false`: This payment not supports receipt generation, or receipt already generated
   */
  supportReceiptGeneration?: InputMaybe<Scalars['Boolean']>;
  /** Date and time the payment was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: InputMaybe<ComWixEcomOrdersPaymentsV1WixReceiptInfoInput>;
};

export type ComWixEcomOrdersPaymentsV1PaymentRefundInput = {
  /** Refund amount. Not relevant for membership and gift card refunds. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Whether refund is made externally and manually (on the payment provider's side)
   * When false (default), the payment gateway will be called in order to make an actual refund, and then the payment will be marked as refunded.
   * When true, the payment will only be *marked* as refunded, and no actual refund will be performed.
   */
  externalRefund?: InputMaybe<Scalars['Boolean']>;
  /**
   * Gateway refund id. When param is present, new refund is not created.
   * Instead if order has a refund transaction with given gateway refund id, this refund will be updated with details from request,
   * and all side effects from request will be executed.
   */
  gatewayRefundId?: InputMaybe<Scalars['String']>;
  /** Specific payment within the order to refund */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1QueryOrderTransactionsRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixEcomOrdersPaymentsV1QueryOrderTransactionsResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1QueryOrderTransactionsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixEcomOrdersPaymentsV1Refund = {
  __typename?: 'ComWixEcomOrdersPaymentsV1Refund';
  /** Date and time the refund was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: Maybe<Scalars['String']>;
  /** Refund business details. */
  details?: Maybe<ComWixEcomOrdersPaymentsV1RefundDetails>;
  /** Refund ID. */
  id?: Maybe<Scalars['String']>;
  /** ID of the app that initiated this refund. */
  requestingServiceAppId?: Maybe<Scalars['String']>;
  /** Aggregated refund summary. */
  summary?: Maybe<ComWixEcomOrdersPaymentsV1AggregatedRefundSummary>;
  /** List of transactions. */
  transactions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1RefundTransaction>>>;
};

export type ComWixEcomOrdersPaymentsV1RefundDetails = {
  __typename?: 'ComWixEcomOrdersPaymentsV1RefundDetails';
  /** Additional fees that were refunded. */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1AdditionalFeeRefund>>>;
  /** Order line item IDs and quantities that were refunded. */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1RefundItem>>>;
  /** Line items that were refunded. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1LineItemRefund>>>;
  /** Reason for the refund, provided by customer (optional). */
  reason?: Maybe<Scalars['String']>;
  /** Shipping amount that was refunded. */
  shipping?: Maybe<ComWixEcomOrdersPaymentsV1ShippingRefund>;
  /** Whether the shipping fee was also refunded. */
  shippingIncluded?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1RefundDetailsInput = {
  /** Additional fees that were refunded. */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1AdditionalFeeRefundInput>>>;
  /** Order line item IDs and quantities that were refunded. */
  items?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1RefundItemInput>>>;
  /** Line items that were refunded. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1LineItemRefundInput>>>;
  /** Reason for the refund, provided by customer (optional). */
  reason?: InputMaybe<Scalars['String']>;
  /** Shipping amount that was refunded. */
  shipping?: InputMaybe<ComWixEcomOrdersPaymentsV1ShippingRefundInput>;
  /** Whether the shipping fee was also refunded. */
  shippingIncluded?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1RefundInput = {
  /** Date and time the refund was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Refund business details. */
  details?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundDetailsInput>;
  /** Refund ID. */
  id?: InputMaybe<Scalars['String']>;
  /** ID of the app that initiated this refund. */
  requestingServiceAppId?: InputMaybe<Scalars['String']>;
  /** Aggregated refund summary. */
  summary?: InputMaybe<ComWixEcomOrdersPaymentsV1AggregatedRefundSummaryInput>;
  /** List of transactions. */
  transactions?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1RefundTransactionInput>>>;
};

export type ComWixEcomOrdersPaymentsV1RefundItem = {
  __typename?: 'ComWixEcomOrdersPaymentsV1RefundItem';
  /** Line item ID the refunded line item. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Line item quantity refunded. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1RefundItemInput = {
  /** Line item ID the refunded line item. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Line item quantity refunded. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1RefundItemsBreakdown = {
  __typename?: 'ComWixEcomOrdersPaymentsV1RefundItemsBreakdown';
  /** Refunded line items and the amount refunded for each. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1LineItemRefundSummary>>>;
};

export type ComWixEcomOrdersPaymentsV1RefundItemsBreakdownInput = {
  /** Refunded line items and the amount refunded for each. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1LineItemRefundSummaryInput>>>;
};

export type ComWixEcomOrdersPaymentsV1RefundSideEffectsInput = {
  /** Custom message added to the refund confirmation email. */
  customMessage?: InputMaybe<Scalars['String']>;
  /** Inventory restock details as part of this refund. */
  restockInfo?: InputMaybe<ComWixEcomOrdersPaymentsV1RestockInfoInput>;
  /** Whether to send a refund confirmation email to the customer. */
  sendOrderRefundedEmail?: InputMaybe<Scalars['Boolean']>;
};

export enum ComWixEcomOrdersPaymentsV1RefundStatus {
  /** Refund transaction failed. */
  Failed = 'FAILED',
  /** Refund was initiated on payment provider side. PENDING status was assigned by provider. */
  Pending = 'PENDING',
  /** Refund request acknowledged, and will be executed soon. */
  Scheduled = 'SCHEDULED',
  /** Refund was initiated on payment provider side. */
  Started = 'STARTED',
  /** Refund transaction succeeded. */
  Succeeded = 'SUCCEEDED'
}

export type ComWixEcomOrdersPaymentsV1RefundStatusInfo = {
  __typename?: 'ComWixEcomOrdersPaymentsV1RefundStatusInfo';
  /** Free text explanation of current refund status. */
  description?: Maybe<Scalars['String']>;
  /**
   * Reason code for the refund's current status.
   *
   * Learn more about [reason codes](https://dev.wix.com/docs/rest/business-management/payments/service-plugins/payment-service-provider-service-plugin/reason-codes).
   */
  paymentGatewayReasonCode?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1RefundStatusInfoInput = {
  /** Free text explanation of current refund status. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Reason code for the refund's current status.
   *
   * Learn more about [reason codes](https://dev.wix.com/docs/rest/business-management/payments/service-plugins/payment-service-provider-service-plugin/reason-codes).
   */
  paymentGatewayReasonCode?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1RefundTransaction = {
  __typename?: 'ComWixEcomOrdersPaymentsV1RefundTransaction';
  /** Refund amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Whether refund was made externally and manually on the payment provider's side. */
  externalRefund?: Maybe<Scalars['Boolean']>;
  /**
   * Payment gateway's refund ID.
   * This field is only returned when the value of `external_refund` is `false`.
   */
  gatewayRefundId?: Maybe<Scalars['String']>;
  /** ID of the payment associated with this refund. */
  paymentId?: Maybe<Scalars['String']>;
  /** ID of the refund in the payment provider's system. For example, at PayPal, Square, Stripe, etc. Not returned for external refunds. */
  providerRefundId?: Maybe<Scalars['String']>;
  /** Refund status. */
  refundStatus?: Maybe<ComWixEcomOrdersPaymentsV1RefundStatus>;
  /** Optional details of current refund status. */
  refundStatusInfo?: Maybe<ComWixEcomOrdersPaymentsV1RefundStatusInfo>;
};

export type ComWixEcomOrdersPaymentsV1RefundTransactionInput = {
  /** Refund amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Whether refund was made externally and manually on the payment provider's side. */
  externalRefund?: InputMaybe<Scalars['Boolean']>;
  /**
   * Payment gateway's refund ID.
   * This field is only returned when the value of `external_refund` is `false`.
   */
  gatewayRefundId?: InputMaybe<Scalars['String']>;
  /** ID of the payment associated with this refund. */
  paymentId?: InputMaybe<Scalars['String']>;
  /** ID of the refund in the payment provider's system. For example, at PayPal, Square, Stripe, etc. Not returned for external refunds. */
  providerRefundId?: InputMaybe<Scalars['String']>;
  /** Refund status. */
  refundStatus?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundStatus>;
  /** Optional details of current refund status. */
  refundStatusInfo?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundStatusInfoInput>;
};

export type ComWixEcomOrdersPaymentsV1Refundability = {
  __typename?: 'ComWixEcomOrdersPaymentsV1Refundability';
  /** Reason why payment is only refundable manually. */
  manuallyRefundableReason?: Maybe<ComWixEcomOrdersPaymentsV1RefundabilityManuallyRefundableReason>;
  /** Reason why payment is not refundable. */
  nonRefundableReason?: Maybe<ComWixEcomOrdersPaymentsV1RefundabilityNonRefundableReason>;
  /** Payment ID. */
  paymentId?: Maybe<Scalars['String']>;
  /** Link to payment provider dashboard. */
  providerLink?: Maybe<Scalars['String']>;
  /** Payment refundability status. */
  refundabilityStatus?: Maybe<ComWixEcomOrdersPaymentsV1RefundabilityRefundableStatus>;
};

export enum ComWixEcomOrdersPaymentsV1RefundabilityManuallyRefundableReason {
  /** Payment expired. */
  Expired = 'EXPIRED',
  /** Payment not found. */
  NotFound = 'NOT_FOUND',
  /** Payment method not supported. */
  NotSupported = 'NOT_SUPPORTED',
  /** Payment made offline. */
  Offline = 'OFFLINE',
  /** Refund requires interaction with card reader. */
  RequiresCardReader = 'REQUIRES_CARD_READER'
}

export enum ComWixEcomOrdersPaymentsV1RefundabilityNonRefundableReason {
  /** Access denied. */
  AccessDenied = 'ACCESS_DENIED',
  /** Payment already refunded. */
  AlreadyRefunded = 'ALREADY_REFUNDED',
  /** Deposit for online item. */
  DepositOnlineItem = 'DEPOSIT_ONLINE_ITEM',
  /** Disabled by provider. */
  DisabledByProvider = 'DISABLED_BY_PROVIDER',
  /** Action forbidden. */
  Forbidden = 'FORBIDDEN',
  /** Internal error occurred. */
  InternalError = 'INTERNAL_ERROR',
  /** No reason. */
  None = 'NONE',
  /** Payment not made. */
  NotPaid = 'NOT_PAID',
  /** Payment partially paid. */
  PartiallyPaid = 'PARTIALLY_PAID',
  /** Refund is pending. */
  PendingRefund = 'PENDING_REFUND',
  /** Payment provider is down. */
  ProviderIsDown = 'PROVIDER_IS_DOWN',
  /** Payment amount is zero. */
  ZeroPrice = 'ZERO_PRICE'
}

export enum ComWixEcomOrdersPaymentsV1RefundabilityRefundableStatus {
  /** Refundable manually. */
  Manual = 'MANUAL',
  /** Not refundable. */
  NotRefundable = 'NOT_REFUNDABLE',
  /** Refundable. */
  Refundable = 'REFUNDABLE'
}

export type ComWixEcomOrdersPaymentsV1RegularPaymentDetails = {
  __typename?: 'ComWixEcomOrdersPaymentsV1RegularPaymentDetails';
  /** Authorization details. */
  authorizationDetails?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationDetails>;
  /** Record of chargebacks made by the buyer. */
  chargebacks?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1Chargeback>>>;
  /** Whether regular card used */
  creditCardDetails?: Maybe<ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails>;
  /**
   * Payment gateway's transaction ID.
   * This field is only returned when the value of `offline_payment` is `false`.
   */
  gatewayTransactionId?: Maybe<Scalars['String']>;
  /** Whether the payment was made offline. For example, when using cash or when marked as paid in the Business Manager. */
  offlinePayment?: Maybe<Scalars['Boolean']>;
  /**
   * Payment method. Non-exhaustive list of supported values:
   * + `CreditCard`, `Alipay`, `AstropayCash`, `AstropayDBT`, `AstropayMBT`, `Bitcoin`, `BitPay`, `Cash`, `ConvenienceStore`, `EPay`, `Fake`, `Giropay`, `IDeal`, `InPerson`, `Klarna`, `MercadoPago`, `Netpay`, `NordeaSolo`, `Offline`, `PagSeguro`, `PayEasy`, `PayPal`, `Paysafecard`, `Paysafecash`, `PointOfSale`, `Poli`, `Privat24`, `Przelewy24`, `RapidTransfer`, `Sepa`, `Skrill`, `Sofort`, `Trustly`, `Neteller`, `Unionpay`, `UniPay`, `Yandex`
   */
  paymentMethod?: Maybe<Scalars['String']>;
  /** Wix Payments order ID. */
  paymentOrderId?: Maybe<Scalars['String']>;
  /** Payment service provider display name. Non-exhaustive list of supported values: Wix Payments, PayPal, Square, Stripe, etc. */
  paymentProvider?: Maybe<Scalars['String']>;
  /** Transaction ID in the payment provider's system. For example, at PayPal, Square, Stripe, etc. Not returned for offline payments. */
  providerTransactionId?: Maybe<Scalars['String']>;
  /** Whether there is a payment agreement that allows for future charges. */
  savedPaymentMethod?: Maybe<Scalars['Boolean']>;
  /** Payment status. */
  status?: Maybe<WixPaymentApiPayV3TransactionTransactionStatus>;
};

export type ComWixEcomOrdersPaymentsV1RegularPaymentDetailsInput = {
  /** Authorization details. */
  authorizationDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationDetailsInput>;
  /** Record of chargebacks made by the buyer. */
  chargebacks?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1ChargebackInput>>>;
  /** Whether regular card used */
  creditCardDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetailsInput>;
  /**
   * Payment gateway's transaction ID.
   * This field is only returned when the value of `offline_payment` is `false`.
   */
  gatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Whether the payment was made offline. For example, when using cash or when marked as paid in the Business Manager. */
  offlinePayment?: InputMaybe<Scalars['Boolean']>;
  /**
   * Payment method. Non-exhaustive list of supported values:
   * + `CreditCard`, `Alipay`, `AstropayCash`, `AstropayDBT`, `AstropayMBT`, `Bitcoin`, `BitPay`, `Cash`, `ConvenienceStore`, `EPay`, `Fake`, `Giropay`, `IDeal`, `InPerson`, `Klarna`, `MercadoPago`, `Netpay`, `NordeaSolo`, `Offline`, `PagSeguro`, `PayEasy`, `PayPal`, `Paysafecard`, `Paysafecash`, `PointOfSale`, `Poli`, `Privat24`, `Przelewy24`, `RapidTransfer`, `Sepa`, `Skrill`, `Sofort`, `Trustly`, `Neteller`, `Unionpay`, `UniPay`, `Yandex`
   */
  paymentMethod?: InputMaybe<Scalars['String']>;
  /** Wix Payments order ID. */
  paymentOrderId?: InputMaybe<Scalars['String']>;
  /** Payment service provider display name. Non-exhaustive list of supported values: Wix Payments, PayPal, Square, Stripe, etc. */
  paymentProvider?: InputMaybe<Scalars['String']>;
  /** Transaction ID in the payment provider's system. For example, at PayPal, Square, Stripe, etc. Not returned for offline payments. */
  providerTransactionId?: InputMaybe<Scalars['String']>;
  /** Whether there is a payment agreement that allows for future charges. */
  savedPaymentMethod?: InputMaybe<Scalars['Boolean']>;
  /** Payment status. */
  status?: InputMaybe<WixPaymentApiPayV3TransactionTransactionStatus>;
};

export type ComWixEcomOrdersPaymentsV1RestockInfoInput = {
  /** Restocked line items and quantities. Only relevant for `{"type": "SOME_ITEMS"}`. */
  items?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1RestockItemInput>>>;
  /** Deprecated, use items instead */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Restock type. */
  type?: InputMaybe<ComWixEcomOrdersPaymentsV1RestockInfoRestockType>;
};

export enum ComWixEcomOrdersPaymentsV1RestockInfoRestockType {
  AllItems = 'ALL_ITEMS',
  NoItems = 'NO_ITEMS',
  SomeItems = 'SOME_ITEMS'
}

export type ComWixEcomOrdersPaymentsV1RestockItemInput = {
  /** ID of the line item being restocked. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Line item quantity being restocked. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1ReverseChargebackRequestInput = {
  /** Chargeback ID. */
  chargebackId?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment ID. */
  paymentId?: InputMaybe<Scalars['String']>;
  /**
   * Reversal amount.
   *
   * Default: original chargeback amount.
   */
  reversalAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsV1ReverseChargebackResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1ReverseChargebackResponse';
  /** Updated order transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1ScheduledAction = {
  __typename?: 'ComWixEcomOrdersPaymentsV1ScheduledAction';
  /** Type of the action. */
  actionType?: Maybe<ComWixEcomOrdersPaymentsV1ScheduledActionActionType>;
  /** The date and time of the action. */
  executionDate?: Maybe<Scalars['String']>;
};

export enum ComWixEcomOrdersPaymentsV1ScheduledActionActionType {
  Capture = 'CAPTURE',
  UnknownActionType = 'UNKNOWN_ACTION_TYPE',
  Void = 'VOID'
}

export type ComWixEcomOrdersPaymentsV1ScheduledActionInput = {
  /** Type of the action. */
  actionType?: InputMaybe<ComWixEcomOrdersPaymentsV1ScheduledActionActionType>;
  /** The date and time of the action. */
  executionDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1SearchOrderTransactionsRequestInput = {
  /** Search options. */
  search?: InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorSearchInput>;
};

export type ComWixEcomOrdersPaymentsV1SearchOrderTransactionsResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1SearchOrderTransactionsResponse';
  /** Details on the paged set of results returned. */
  metadata?: Maybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingMetadata>;
  /** Order transactions */
  orderTransactions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>>>;
};

export type ComWixEcomOrdersPaymentsV1ShippingRefund = {
  __typename?: 'ComWixEcomOrdersPaymentsV1ShippingRefund';
  /** Refund amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsV1ShippingRefundInput = {
  /** Refund amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsV1TriggerRefundRequestInput = {
  /** Personal note added to the email */
  customMessage?: InputMaybe<Scalars['String']>;
  /** Business model of a refund */
  details?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundDetailsInput>;
  /** The order this refund related to */
  orderId?: InputMaybe<Scalars['String']>;
  /**
   * Refund operations information
   * Currently, only *one* payment refund is supported per request
   */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1PaymentRefundInput>>>;
  /** How to restock items as part of this refund */
  restockInfo?: InputMaybe<ComWixEcomOrdersPaymentsV1RestockInfoInput>;
  /** Should send a confirmation mail to the customer */
  sendOrderRefundedEmail?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1TriggerRefundResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1TriggerRefundResponse';
  /** Payment ID's that the refund execution had failed for */
  failedPaymentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** All order's transactions after the refunds were added */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Created refund ID */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1UpdateChargebackRequestInput = {
  /** Chargeback. */
  chargeback?: InputMaybe<ComWixEcomOrdersPaymentsV1ChargebackInput>;
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1UpdateChargebackResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1UpdateChargebackResponse';
  /** Updated order transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1UpdatePaymentStatusRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment ID. */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Payment status. */
  status?: InputMaybe<WixPaymentApiPayV3TransactionTransactionStatus>;
  /**
   * *TBD** NOT IMPLEMENTED
   * Status update date
   * When defined -> the update will be applied only if it's newer than existing one, otherwise will throw 409
   * Not defined -> apply the update without any verification.
   */
  statusUpdatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1UpdatePaymentStatusResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1UpdatePaymentStatusResponse';
  /** Order ID and its associated transactions after update. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1UpdatePaymentsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payments to be updated */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1MaskedPaymentInput>>>;
};

export type ComWixEcomOrdersPaymentsV1UpdatePaymentsResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1UpdatePaymentsResponse';
  /** OrderTransactions with updated payments */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1UpdateRefundRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund with updated field values. */
  refund?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundInput>;
};

export type ComWixEcomOrdersPaymentsV1UpdateRefundResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1UpdateRefundResponse';
  /** Order transactions after update. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Refund after update. */
  refund?: Maybe<ComWixEcomOrdersPaymentsV1Refund>;
};

export type ComWixEcomOrdersPaymentsV1UpdateRefundTransactionRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment ID. */
  refundId?: InputMaybe<Scalars['String']>;
  /** Updated refund transaction */
  transaction?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundTransactionInput>;
};

export type ComWixEcomOrdersPaymentsV1UpdateRefundTransactionResponse = {
  __typename?: 'ComWixEcomOrdersPaymentsV1UpdateRefundTransactionResponse';
  /** OrderTransactions with updated refund transaction */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput>;
  /** A filter object. See documentation [here](https://bo.wix.com/wix-docs/rnd/platformization-guidelines/api-query-language#platformization-guidelines_api-query-language_defining-in-protobuf) */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput>>>;
};

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorSearchInput = {
  /**
   * Cursor pointing to page of results.
   * When requesting 'cursor_paging.cursor', no `filter`, `sort` or `search` can be provided.
   */
  cursorPaging?: InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput>;
  /** A filter object. See documentation [here](https://bo.wix.com/wix-docs/rnd/platformization-guidelines/api-query-language#platformization-guidelines_api-query-language_defining-in-protobuf) */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Sort object in the form [{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}] */
  sort?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput>>>;
};

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursors = {
  __typename?: 'ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursors';
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export enum ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortOrder {
  /** Ascending order. */
  Asc = 'ASC',
  /** Descending order. */
  Desc = 'DESC'
}

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type ComWixEcomOrdersPaymentsV1WixReceiptInfo = {
  __typename?: 'ComWixEcomOrdersPaymentsV1WixReceiptInfo';
  /** Display number of receipt */
  displayNumber?: Maybe<Scalars['String']>;
  /** Receipt ID */
  receipt?: Maybe<WixReceiptsV1Receipt>;
  /** Receipt ID */
  receiptId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1WixReceiptInfoInput = {
  /** Display number of receipt */
  displayNumber?: InputMaybe<Scalars['String']>;
  /** Receipt ID */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersRolloutManagerV1CanMigrateResponse = {
  __typename?: 'ComWixEcomOrdersRolloutManagerV1CanMigrateResponse';
  canMigrate?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusRequestInput = {
  siteRolloutStatus?: InputMaybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatusInput>;
};

export type ComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusResponse = {
  __typename?: 'ComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusResponse';
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1GetSiteRolloutStatusResponse = {
  __typename?: 'ComWixEcomOrdersRolloutManagerV1GetSiteRolloutStatusResponse';
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemRequestInput = {
  /** Target metasite ID value that will be used to derive ecom instance ID for check. */
  metasiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemResponse = {
  __typename?: 'ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemResponse';
  /** True if any non zero number of orders exist in legacy system, false otherwise */
  hasOrdersInOldSystem?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1MarkEmptyAndOpenNewFlowResponse = {
  __typename?: 'ComWixEcomOrdersRolloutManagerV1MarkEmptyAndOpenNewFlowResponse';
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus = {
  __typename?: 'ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus';
  allowLazyMigration?: Maybe<Scalars['Boolean']>;
  comparisonModeOpen?: Maybe<Scalars['Boolean']>;
  migrationFailed?: Maybe<Scalars['Boolean']>;
  newFlowOpen?: Maybe<Scalars['Boolean']>;
  noDataToMigrate?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1SiteRolloutStatusInput = {
  allowLazyMigration?: InputMaybe<Scalars['Boolean']>;
  comparisonModeOpen?: InputMaybe<Scalars['Boolean']>;
  migrationFailed?: InputMaybe<Scalars['Boolean']>;
  newFlowOpen?: InputMaybe<Scalars['Boolean']>;
  noDataToMigrate?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationRequestInput = {
  allowLazyMigration?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationResponse = {
  __typename?: 'ComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationResponse';
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusRequestInput = {
  comparisonModeOpen?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusResponse = {
  __typename?: 'ComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusResponse';
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedRequestInput = {
  migrationFailed?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedResponse = {
  __typename?: 'ComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedResponse';
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenRequestInput = {
  newFlowOpen?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenResponse = {
  __typename?: 'ComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenResponse';
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateRequestInput = {
  noDataToMigrate?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateResponse = {
  __typename?: 'ComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateResponse';
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput = {
  enableRewrittenSideEffects?: InputMaybe<Scalars['Boolean']>;
  epCommitTax?: InputMaybe<Scalars['Boolean']>;
  moveBuyerOrderConfirmationEmailToEp?: InputMaybe<Scalars['Boolean']>;
  moveMerchantEmailToEp?: InputMaybe<Scalars['Boolean']>;
  producedByEpBridge?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersSideEffectsMigrationApiTriggerSideEffectsFromLegacyDataInput = {
  orderId?: InputMaybe<Scalars['String']>;
  ordersExperiments?: InputMaybe<ComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput>;
  storeId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1Activity = {
  __typename?: 'ComWixEcomOrdersV1Activity';
  /** Activity author's email. */
  authorEmail?: Maybe<Scalars['String']>;
  /** Details of an authorized payment captured. */
  authorizedPaymentCaptured?: Maybe<ComWixEcomOrdersV1AuthorizedPaymentCaptured>;
  /** Details of an authorized payment created. */
  authorizedPaymentCreated?: Maybe<ComWixEcomOrdersV1AuthorizedPaymentCreated>;
  /** Details of an authorized payment voided. */
  authorizedPaymentVoided?: Maybe<ComWixEcomOrdersV1AuthorizedPaymentVoided>;
  /** Order received a chargeback for one of its' payments. */
  chargebackCreated?: Maybe<ComWixEcomOrdersV1ChargebackCreated>;
  /** Chargeback reversed for one of the order's payments. */
  chargebackReversed?: Maybe<ComWixEcomOrdersV1ChargebackReversed>;
  /** Activity creation date and time. */
  createdDate?: Maybe<Scalars['String']>;
  /** Custom activity details (optional). `activity.type` must be `CUSTOM_ACTIVITY`. */
  customActivity?: Maybe<ComWixEcomOrdersV1CustomActivity>;
  /** Details of changes made by the Draft Orders API. */
  draftOrderChangesApplied?: Maybe<ComWixEcomOrdersV1DraftOrderChangesApplied>;
  /** Activity ID. */
  id?: Maybe<Scalars['String']>;
  /** Merchant comment details (optional). `activity.type` must be `MERCHANT_COMMENT`. */
  merchantComment?: Maybe<ComWixEcomOrdersV1MerchantComment>;
  /** Details of an order that was created as a result of an exchange of items in this order. `activity.type` must be `NEW_EXCHANGE_ORDER_CREATED`. */
  newExchangeOrderCreated?: Maybe<ComWixEcomOrdersV1NewExchangeOrderCreated>;
  /** Details of the original order for this exchange order. `activity.type` must be `ORDER_CREATED_FROM_EXCHANGE`. */
  orderCreatedFromExchange?: Maybe<ComWixEcomOrdersV1OrderCreatedFromExchange>;
  /** Additional info about order refunded activity (optional). `activity.type` must be `ORDER_REFUNDED`. */
  orderRefunded?: Maybe<ComWixEcomOrdersV1OrderRefunded>;
  /** Details of a canceled payment */
  paymentCanceled?: Maybe<ComWixEcomOrdersV1PaymentCanceled>;
  /** Details of a declined payment */
  paymentDeclined?: Maybe<ComWixEcomOrdersV1PaymentDeclined>;
  /** Details of a pending payment */
  paymentPending?: Maybe<ComWixEcomOrdersV1PaymentPending>;
  /**
   * Details of a failed payment refund.
   *
   * > **Note:** A single `refund_initiated` activity can result in multiple `payment_refunded` or `payment_refund_failed` activities.
   * > In these cases, the `refund_id` will be identical across the activities.
   */
  paymentRefundFailed?: Maybe<ComWixEcomOrdersV1PaymentRefundFailed>;
  /**
   * Details of a refunded payment.
   *
   * > **Note:** A single `refund_initiated` activity can result in multiple `payment_refunded` or `payment_refund_failed` activities.
   * > In these cases, the `refund_id` will be identical across the activities.
   */
  paymentRefunded?: Maybe<ComWixEcomOrdersV1PaymentRefunded>;
  /** Receipt was added for associated payment */
  receiptCreated?: Maybe<ComWixEcomOrdersV1ReceiptCreated>;
  /** Receipt sent to customer */
  receiptSent?: Maybe<ComWixEcomOrdersV1ReceiptSent>;
  /**
   * Details of an initiated refund process.
   *
   * > **Note:** A single `refund_initiated` activity can result in multiple `payment_refunded` or `payment_refund_failed` activities.
   * > In these cases, the `refund_id` will be identical across the activities.
   */
  refundInitiated?: Maybe<ComWixEcomOrdersV1RefundInitiated>;
  /** Details of refund to store credit. */
  refundedAsStoreCredit?: Maybe<ComWixEcomOrdersV1RefundedAsStoreCredit>;
  /** Details of the payment method saved for order */
  savedPaymentMethod?: Maybe<ComWixEcomOrdersV1SavedPaymentMethod>;
  /** Activity type. */
  type?: Maybe<ComWixEcomOrdersV1ActivityTypeEnumActivityType>;
};

export type ComWixEcomOrdersV1ActivityInput = {
  /** Activity author's email. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Details of an authorized payment captured. */
  authorizedPaymentCaptured?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentCapturedInput>;
  /** Details of an authorized payment created. */
  authorizedPaymentCreated?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentCreatedInput>;
  /** Details of an authorized payment voided. */
  authorizedPaymentVoided?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentVoidedInput>;
  /** Order received a chargeback for one of its' payments. */
  chargebackCreated?: InputMaybe<ComWixEcomOrdersV1ChargebackCreatedInput>;
  /** Chargeback reversed for one of the order's payments. */
  chargebackReversed?: InputMaybe<ComWixEcomOrdersV1ChargebackReversedInput>;
  /** Activity creation date and time. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Custom activity details (optional). `activity.type` must be `CUSTOM_ACTIVITY`. */
  customActivity?: InputMaybe<ComWixEcomOrdersV1CustomActivityInput>;
  /** Details of changes made by the Draft Orders API. */
  draftOrderChangesApplied?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedInput>;
  /** Activity ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Merchant comment details (optional). `activity.type` must be `MERCHANT_COMMENT`. */
  merchantComment?: InputMaybe<ComWixEcomOrdersV1MerchantCommentInput>;
  /** Details of an order that was created as a result of an exchange of items in this order. `activity.type` must be `NEW_EXCHANGE_ORDER_CREATED`. */
  newExchangeOrderCreated?: InputMaybe<ComWixEcomOrdersV1NewExchangeOrderCreatedInput>;
  /** Details of the original order for this exchange order. `activity.type` must be `ORDER_CREATED_FROM_EXCHANGE`. */
  orderCreatedFromExchange?: InputMaybe<ComWixEcomOrdersV1OrderCreatedFromExchangeInput>;
  /** Additional info about order refunded activity (optional). `activity.type` must be `ORDER_REFUNDED`. */
  orderRefunded?: InputMaybe<ComWixEcomOrdersV1OrderRefundedInput>;
  /** Details of a canceled payment */
  paymentCanceled?: InputMaybe<ComWixEcomOrdersV1PaymentCanceledInput>;
  /** Details of a declined payment */
  paymentDeclined?: InputMaybe<ComWixEcomOrdersV1PaymentDeclinedInput>;
  /** Details of a pending payment */
  paymentPending?: InputMaybe<ComWixEcomOrdersV1PaymentPendingInput>;
  /**
   * Details of a failed payment refund.
   *
   * > **Note:** A single `refund_initiated` activity can result in multiple `payment_refunded` or `payment_refund_failed` activities.
   * > In these cases, the `refund_id` will be identical across the activities.
   */
  paymentRefundFailed?: InputMaybe<ComWixEcomOrdersV1PaymentRefundFailedInput>;
  /**
   * Details of a refunded payment.
   *
   * > **Note:** A single `refund_initiated` activity can result in multiple `payment_refunded` or `payment_refund_failed` activities.
   * > In these cases, the `refund_id` will be identical across the activities.
   */
  paymentRefunded?: InputMaybe<ComWixEcomOrdersV1PaymentRefundedInput>;
  /** Receipt was added for associated payment */
  receiptCreated?: InputMaybe<ComWixEcomOrdersV1ReceiptCreatedInput>;
  /** Receipt sent to customer */
  receiptSent?: InputMaybe<ComWixEcomOrdersV1ReceiptSentInput>;
  /**
   * Details of an initiated refund process.
   *
   * > **Note:** A single `refund_initiated` activity can result in multiple `payment_refunded` or `payment_refund_failed` activities.
   * > In these cases, the `refund_id` will be identical across the activities.
   */
  refundInitiated?: InputMaybe<ComWixEcomOrdersV1RefundInitiatedInput>;
  /** Details of refund to store credit. */
  refundedAsStoreCredit?: InputMaybe<ComWixEcomOrdersV1RefundedAsStoreCreditInput>;
  /** Details of the payment method saved for order */
  savedPaymentMethod?: InputMaybe<ComWixEcomOrdersV1SavedPaymentMethodInput>;
  /** Activity type. */
  type?: InputMaybe<ComWixEcomOrdersV1ActivityTypeEnumActivityType>;
};

export enum ComWixEcomOrdersV1ActivityTypeEnumActivityType {
  AuthorizedPaymentCaptured = 'AUTHORIZED_PAYMENT_CAPTURED',
  AuthorizedPaymentCreated = 'AUTHORIZED_PAYMENT_CREATED',
  AuthorizedPaymentVoided = 'AUTHORIZED_PAYMENT_VOIDED',
  ChargebackCreated = 'CHARGEBACK_CREATED',
  ChargebackReversed = 'CHARGEBACK_REVERSED',
  CustomActivity = 'CUSTOM_ACTIVITY',
  DownloadLinkSent = 'DOWNLOAD_LINK_SENT',
  DraftOrderChangesApplied = 'DRAFT_ORDER_CHANGES_APPLIED',
  EmailEdited = 'EMAIL_EDITED',
  FulfillerEmailSent = 'FULFILLER_EMAIL_SENT',
  InvoiceAdded = 'INVOICE_ADDED',
  InvoiceRemoved = 'INVOICE_REMOVED',
  InvoiceSent = 'INVOICE_SENT',
  MerchantComment = 'MERCHANT_COMMENT',
  NewExchangeOrderCreated = 'NEW_EXCHANGE_ORDER_CREATED',
  OrderCanceled = 'ORDER_CANCELED',
  OrderCreatedFromExchange = 'ORDER_CREATED_FROM_EXCHANGE',
  OrderFulfilled = 'ORDER_FULFILLED',
  OrderNotFulfilled = 'ORDER_NOT_FULFILLED',
  OrderPaid = 'ORDER_PAID',
  OrderPartiallyPaid = 'ORDER_PARTIALLY_PAID',
  OrderPending = 'ORDER_PENDING',
  OrderPlaced = 'ORDER_PLACED',
  OrderRefunded = 'ORDER_REFUNDED',
  OrderRejected = 'ORDER_REJECTED',
  PaymentCanceled = 'PAYMENT_CANCELED',
  PaymentDeclined = 'PAYMENT_DECLINED',
  PaymentPending = 'PAYMENT_PENDING',
  PaymentRefunded = 'PAYMENT_REFUNDED',
  PaymentRefundFailed = 'PAYMENT_REFUND_FAILED',
  PickupReadyEmailSent = 'PICKUP_READY_EMAIL_SENT',
  ReceiptCreated = 'RECEIPT_CREATED',
  ReceiptSent = 'RECEIPT_SENT',
  RefundedAsStoreCredit = 'REFUNDED_AS_STORE_CREDIT',
  RefundInitiated = 'REFUND_INITIATED',
  SavedPaymentMethod = 'SAVED_PAYMENT_METHOD',
  ShippingAddressEdited = 'SHIPPING_ADDRESS_EDITED',
  ShippingConfirmationEmailSent = 'SHIPPING_CONFIRMATION_EMAIL_SENT',
  TrackingLinkAdded = 'TRACKING_LINK_ADDED',
  TrackingNumberAdded = 'TRACKING_NUMBER_ADDED',
  TrackingNumberEdited = 'TRACKING_NUMBER_EDITED'
}

export type ComWixEcomOrdersV1AddActivitiesRequestInput = {
  /** Activities to add. */
  activities?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1PublicActivityInput>>>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AddActivitiesResponse = {
  __typename?: 'ComWixEcomOrdersV1AddActivitiesResponse';
  /**
   * IDs of the added activities.
   * Use this IDs to either [update](https://bo.wix.com/wix-docs/rest/ecommerce/orders/update-activities) or [delete](https://bo.wix.com/wix-docs/rest/ecommerce/orders/delete-activities) the activities.
   */
  activityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1AddActivityRequestInput = {
  /** Activity info. */
  activity?: InputMaybe<ComWixEcomOrdersV1PublicActivityInput>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AddActivityResponse = {
  __typename?: 'ComWixEcomOrdersV1AddActivityResponse';
  /**
   * ID of the added activity.
   * Use this ID to either [update](https://bo.wix.com/wix-docs/rest/ecommerce/orders/update-activity) or [delete](https://bo.wix.com/wix-docs/rest/ecommerce/orders/delete-activity) the activity.
   */
  activityId?: Maybe<Scalars['String']>;
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1AddInternalActivityRequestInput = {
  /** Activity info. */
  activity?: InputMaybe<ComWixEcomOrdersV1InternalActivityInput>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AddInternalActivityResponse = {
  __typename?: 'ComWixEcomOrdersV1AddInternalActivityResponse';
  /**
   * ID of the added internal activity.
   * Use this ID to either [update](https://bo.wix.com/wix-docs/rest/ecommerce/orders/update-activity) or [delete](https://bo.wix.com/wix-docs/rest/ecommerce/orders/delete-activity) the activity.
   */
  activityId?: Maybe<Scalars['String']>;
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1AdditionalFee = {
  __typename?: 'ComWixEcomOrdersV1AdditionalFee';
  /** Additional fee's unique code for future processing. */
  code?: Maybe<Scalars['String']>;
  /** Additional fee's id. */
  id?: Maybe<Scalars['String']>;
  /**
   * Optional - Line items associated with this additional fee.
   * If no `lineItemIds` are provided, the fee will be associated with the whole cart/checkout/order.
   */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Name of additional fee. */
  name?: Maybe<Scalars['String']>;
  /** Additional fee's price. */
  price?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional fee's price after tax. */
  priceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional fee's price before tax. */
  priceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** SPI implementer's `appId`. */
  providerAppId?: Maybe<Scalars['String']>;
  /**
   * Number of subscription billing cycles the additional fee applies to.
   * If None and additional fee is linked to subscription line item, it applies to all cycles.
   */
  subscriptionCycles?: Maybe<Scalars['Int']>;
  /** Tax details. */
  taxDetails?: Maybe<ComWixEcomTaxApiItemTaxFullDetails>;
};

export type ComWixEcomOrdersV1AdditionalFeeDeltaInput = {
  /** Additional fee id. */
  additionalFeeId?: InputMaybe<Scalars['String']>;
  additionalFeeRemoved?: InputMaybe<Scalars['Boolean']>;
  editedAdditionalFee?: InputMaybe<ComWixEcomOrdersV1AdditionalFeeInput>;
};

export type ComWixEcomOrdersV1AdditionalFeeInput = {
  /** Additional fee's unique code for future processing. */
  code?: InputMaybe<Scalars['String']>;
  /** Additional fee's id. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Optional - Line items associated with this additional fee.
   * If no `lineItemIds` are provided, the fee will be associated with the whole cart/checkout/order.
   */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name of additional fee. */
  name?: InputMaybe<Scalars['String']>;
  /** Additional fee's price. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Additional fee's price after tax. */
  priceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Additional fee's price before tax. */
  priceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** SPI implementer's `appId`. */
  providerAppId?: InputMaybe<Scalars['String']>;
  /**
   * Number of subscription billing cycles the additional fee applies to.
   * If None and additional fee is linked to subscription line item, it applies to all cycles.
   */
  subscriptionCycles?: InputMaybe<Scalars['Int']>;
  /** Tax details. */
  taxDetails?: InputMaybe<ComWixEcomTaxApiItemTaxFullDetailsInput>;
};

export type ComWixEcomOrdersV1AggregateOrdersRequestInput = {
  /** This is an object defining aggregation itself */
  aggregation?: InputMaybe<Scalars['JSON']>;
  /** Filter applied to original data */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Optional custom separator string that can be used to override default separator value '|'
   * for hierarchical responses of multifaceted aggregation requests like:
   * '{"aggregation": {"example_request_key": {"$count" : ["deliveryMethod", "shippingRegion"]}}}'
   * with example response for default '|' separator like:
   * '{"aggregates" :{"example_request_key": {"(Mail|Region 1)": 5, "(Pickup|Region 2)": 10}}}'
   */
  hierarchySeparatorOverride?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AggregateOrdersResponse = {
  __typename?: 'ComWixEcomOrdersV1AggregateOrdersResponse';
  aggregates?: Maybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1AppliedDiscount = {
  __typename?: 'ComWixEcomOrdersV1AppliedDiscount';
  /** Applied coupon info. */
  coupon?: Maybe<ComWixEcomOrdersV1Coupon>;
  /** Automatic Discount */
  discountRule?: Maybe<ComWixEcomOrdersV1DiscountRule>;
  /**
   * Discount type.
   * * `"GLOBAL"` - discount applies to entire order.
   * * `"SPECIFIC-ITEMS"` - discount applies to specific items.
   * * `"SHIPPING"` - discount applies to shipping. For example, free shipping.
   */
  discountType?: Maybe<ComWixEcomOrdersV1AppliedDiscountDiscountType>;
  /** Discount id. */
  id?: Maybe<Scalars['String']>;
  /** Line items the discount applies to. */
  lineItemDiscounts?: Maybe<Array<Maybe<ComWixEcomOrdersV1LineItemDiscount>>>;
  /**
   * IDs of line items discount applies to.
   * Deprecated. Use `line_item_discounts` instead.
   * @deprecated IDs of line items discount applies to.
   * Deprecated. Use `line_item_discounts` instead. Replaced by: line_item_discounts. Removal date: 2024-10-30.
   */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Merchant discount. */
  merchantDiscount?: Maybe<ComWixEcomOrdersV1MerchantDiscount>;
  /**
   * Number of subscription billing cycles the discount applies to.
   * If None and discount is linked to subscription line item, it applies to all cycles.
   */
  subscriptionCycles?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1AppliedDiscountDeltaInput = {
  /** Discount id. */
  discountId?: InputMaybe<Scalars['String']>;
  discountRemoved?: InputMaybe<Scalars['Boolean']>;
  editedDiscount?: InputMaybe<ComWixEcomOrdersV1AppliedDiscountInput>;
};

export enum ComWixEcomOrdersV1AppliedDiscountDiscountType {
  Global = 'GLOBAL',
  Shipping = 'SHIPPING',
  SpecificItems = 'SPECIFIC_ITEMS'
}

export type ComWixEcomOrdersV1AppliedDiscountInput = {
  /** Applied coupon info. */
  coupon?: InputMaybe<ComWixEcomOrdersV1CouponInput>;
  /** Automatic Discount */
  discountRule?: InputMaybe<ComWixEcomOrdersV1DiscountRuleInput>;
  /**
   * Discount type.
   * * `"GLOBAL"` - discount applies to entire order.
   * * `"SPECIFIC-ITEMS"` - discount applies to specific items.
   * * `"SHIPPING"` - discount applies to shipping. For example, free shipping.
   */
  discountType?: InputMaybe<ComWixEcomOrdersV1AppliedDiscountDiscountType>;
  /** Discount id. */
  id?: InputMaybe<Scalars['String']>;
  /** Line items the discount applies to. */
  lineItemDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1LineItemDiscountInput>>>;
  /** Merchant discount. */
  merchantDiscount?: InputMaybe<ComWixEcomOrdersV1MerchantDiscountInput>;
  /**
   * Number of subscription billing cycles the discount applies to.
   * If None and discount is linked to subscription line item, it applies to all cycles.
   */
  subscriptionCycles?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1ArchiveOrderRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ArchiveOrderResponse = {
  __typename?: 'ComWixEcomOrdersV1ArchiveOrderResponse';
  /** Archived order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export enum ComWixEcomOrdersV1AttributionSourceEnumAttributionSource {
  FacebookAds = 'FACEBOOK_ADS',
  Unspecified = 'UNSPECIFIED'
}

export type ComWixEcomOrdersV1AuthorizedPaymentCaptured = {
  __typename?: 'ComWixEcomOrdersV1AuthorizedPaymentCaptured';
  /** Payment amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AuthorizedPaymentCapturedInput = {
  /** Payment amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AuthorizedPaymentCreated = {
  __typename?: 'ComWixEcomOrdersV1AuthorizedPaymentCreated';
  /** Payment amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AuthorizedPaymentCreatedInput = {
  /** Payment amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AuthorizedPaymentVoided = {
  __typename?: 'ComWixEcomOrdersV1AuthorizedPaymentVoided';
  /** Payment amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AuthorizedPaymentVoidedInput = {
  /** Payment amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1Balance = {
  __typename?: 'ComWixEcomOrdersV1Balance';
  /**
   * Balance amount.
   *
   * A negative `amount` represents the amount to be refunded. This can happen due to overcharging or the order being modified after a payment has been made.
   */
  amount?: Maybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1BalanceInput = {
  /**
   * Balance amount.
   *
   * A negative `amount` represents the amount to be refunded. This can happen due to overcharging or the order being modified after a payment has been made.
   */
  amount?: InputMaybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1BalanceSummary = {
  __typename?: 'ComWixEcomOrdersV1BalanceSummary';
  /** Sum of all authorized payments. */
  authorized?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Current amount left to pay. */
  balance?: Maybe<ComWixEcomOrdersV1Balance>;
  /** Sum of all transaction chargebacks. */
  chargeback?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Sum of all chargeback reversals. */
  chargebackReversal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /**
   * Sum of all approved and successful payments.
   *
   * The value includes payments that have subsequently been fully or partially refunded.
   */
  paid?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Sum of all pending transactions. */
  pending?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Sum of all pending refund transactions. */
  pendingRefund?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Sum of all successfully refunded payments. */
  refunded?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1BalanceSummaryInput = {
  /** Sum of all authorized payments. */
  authorized?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Current amount left to pay. */
  balance?: InputMaybe<ComWixEcomOrdersV1BalanceInput>;
  /** Sum of all transaction chargebacks. */
  chargeback?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Sum of all chargeback reversals. */
  chargebackReversal?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Sum of all approved and successful payments.
   *
   * The value includes payments that have subsequently been fully or partially refunded.
   */
  paid?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Sum of all pending transactions. */
  pending?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Sum of all pending refund transactions. */
  pendingRefund?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Sum of all successfully refunded payments. */
  refunded?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1BillingAdjustment = {
  __typename?: 'ComWixEcomOrdersV1BillingAdjustment';
  /** Summary of the prorated adjustment amount. */
  priceSummary?: Maybe<ComWixEcomOrdersV1BillingAdjustmentPriceSummary>;
  /** The type of adjustment. */
  type?: Maybe<ComWixEcomOrdersV1BillingAdjustmentAdjustmentType>;
};

export enum ComWixEcomOrdersV1BillingAdjustmentAdjustmentType {
  /** Adjustment reduces the total amount due to changes like covering fewer billing days. Typically results in a credit or discount. */
  Credit = 'CREDIT',
  /** Adjustment increases the total amount due to changes like covering extra billing days. Typically results in an additional fee. */
  ExtraCharge = 'EXTRA_CHARGE',
  UnknownAdjustmentType = 'UNKNOWN_ADJUSTMENT_TYPE'
}

export type ComWixEcomOrdersV1BillingAdjustmentInput = {
  /** Summary of the prorated adjustment amount. */
  priceSummary?: InputMaybe<ComWixEcomOrdersV1BillingAdjustmentPriceSummaryInput>;
  /** The type of adjustment. */
  type?: InputMaybe<ComWixEcomOrdersV1BillingAdjustmentAdjustmentType>;
};

export type ComWixEcomOrdersV1BillingAdjustmentPriceSummary = {
  __typename?: 'ComWixEcomOrdersV1BillingAdjustmentPriceSummary';
  /** Subtotal of adjustment, before tax. */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax on adjustment. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total price after tax. */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1BillingAdjustmentPriceSummaryInput = {
  /** Subtotal of adjustment, before tax. */
  subtotal?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Tax on adjustment. */
  tax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price after tax. */
  total?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1BulkArchiveOrdersByFilterRequestInput = {
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/ecommerce/orders/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1BulkArchiveOrdersByFilterResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkArchiveOrdersByFilterResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkArchiveOrdersRequestInput = {
  /** IDs of orders to archive. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to return the full updated order entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkArchiveOrdersResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkArchiveOrdersResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkMarkAsFulfilledByFilterRequestInput = {
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/ecommerce/orders/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1BulkMarkAsFulfilledByFilterResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkMarkAsFulfilledByFilterResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkMarkAsFulfilledRequestInput = {
  /** IDs of orders to be marked as fulfilled. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to return the full updated order entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkMarkAsFulfilledResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkMarkAsFulfilledResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterRequestInput = {
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/ecommerce/orders/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkMarkAsUnfulfilledRequestInput = {
  /** IDs of orders to be marked as not fulfilled. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to return the full updated order entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkMarkAsUnfulfilledResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkMarkAsUnfulfilledResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkMarkOrdersAsPaidRequestInput = {
  /** IDs of orders to mark as paid. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersV1BulkMarkOrdersAsPaidResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkMarkOrdersAsPaidResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /**
   * Items updated by the bulk action.
   * The Order entity within the results optimistically changes its payment status to paid, however this process is async.
   */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkOrderResult = {
  __typename?: 'ComWixEcomOrdersV1BulkOrderResult';
  /**
   * Updated order.
   *
   * Returned when `returnFullEntity = true`.
   */
  item?: Maybe<ComWixEcomOrdersV1Order>;
  /** Item metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersV1BulkSetBusinessLocationRequestInput = {
  /** Business location. */
  businessLocation?: InputMaybe<ComWixEcommercePlatformCommonApiLocationInput>;
  /** IDs of orders to update location for. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersV1BulkSetBusinessLocationResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkSetBusinessLocationResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk action results. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkSetBusinessLocationResponseBulkSetBusinessLocationResult>>>;
};

export type ComWixEcomOrdersV1BulkSetBusinessLocationResponseBulkSetBusinessLocationResult = {
  __typename?: 'ComWixEcomOrdersV1BulkSetBusinessLocationResponseBulkSetBusinessLocationResult';
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersV1BulkUnArchiveOrdersByFilterRequestInput = {
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/ecommerce/orders/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1BulkUnArchiveOrdersByFilterResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkUnArchiveOrdersByFilterResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkUnArchiveOrdersRequestInput = {
  /** IDs or orders to unarchive. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to return the full updated order entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkUnArchiveOrdersResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkUnArchiveOrdersResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkUpdateOrderRequestInput = {
  /** Orders to be updated. */
  orders?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1MaskedOrderInput>>>;
  /** Set to `true` if you wish to receive back the updated orders in the response */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkUpdateOrderResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkUpdateOrderResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk action results. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkUpdateOrderTagsRequestInput = {
  /** Tags to be added to orders */
  assignTags?: InputMaybe<WixCommonTagsTagsInput>;
  /** IDs of orders to update tags for. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Tags to be removed from orders */
  unassignTags?: InputMaybe<WixCommonTagsTagsInput>;
};

export type ComWixEcomOrdersV1BulkUpdateOrderTagsResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkUpdateOrderTagsResponse';
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkUpdateOrderTagsResponseBulkUpdateOrderTagsResult>>>;
};

export type ComWixEcomOrdersV1BulkUpdateOrderTagsResponseBulkUpdateOrderTagsResult = {
  __typename?: 'ComWixEcomOrdersV1BulkUpdateOrderTagsResponseBulkUpdateOrderTagsResult';
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersV1BulkUpdateOrdersRequestInput = {
  /** Orders to update. */
  orders?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1MaskedOrderInput>>>;
  /**
   * Whether to return the full order entities.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkUpdateOrdersResponse = {
  __typename?: 'ComWixEcomOrdersV1BulkUpdateOrdersResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk action results. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BuyerInfo = {
  __typename?: 'ComWixEcomOrdersV1BuyerInfo';
  /** Contact ID. Auto-created if one does not yet exist. For more information, see [Contacts API](https://dev.wix.com/api/rest/contacts/contacts/introduction). */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** Contact ID. Auto-created if one does not yet exist. For more information, see [Contacts API](https://dev.wix.com/api/rest/contacts/contacts/introduction). */
  contactId?: Maybe<Scalars['String']>;
  /** Buyer email address. */
  email?: Maybe<Scalars['String']>;
  /** Member ID (if site visitor is a site member). */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** Member ID (if site visitor is a site member). */
  memberId?: Maybe<Scalars['String']>;
  /** Visitor ID (if site visitor is not a member). */
  visitorId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1BuyerInfoInput = {
  /** Contact ID. Auto-created if one does not yet exist. For more information, see [Contacts API](https://dev.wix.com/api/rest/contacts/contacts/introduction). */
  contactId?: InputMaybe<Scalars['String']>;
  /** Buyer email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Member ID (if site visitor is a site member). */
  memberId?: InputMaybe<Scalars['String']>;
  /** Visitor ID (if site visitor is not a member). */
  visitorId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1BuyerInfoUpdateInput = {
  /** Contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Email associated with the buyer. */
  email?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CancelOrderRequestInput = {
  /** Custom note to be added to the email (optional). */
  customMessage?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether to restock all items in the order. This will only apply to products in the Wix Stores inventory. */
  restockAllItems?: InputMaybe<Scalars['Boolean']>;
  /** Whether to send an order canceled email to the buyer. */
  sendOrderCanceledEmail?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1CancelOrderResponse = {
  __typename?: 'ComWixEcomOrdersV1CancelOrderResponse';
  /** Canceled order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1ChannelInfo = {
  __typename?: 'ComWixEcomOrdersV1ChannelInfo';
  /** Reference to an order ID from an external system. */
  externalOrderId?: Maybe<Scalars['String']>;
  /** URL to the order in the external system. */
  externalOrderUrl?: Maybe<Scalars['String']>;
  /** Sales channel that submitted the order. */
  type?: Maybe<ComWixEcommercePlatformCommonApiChannelType>;
};

export type ComWixEcomOrdersV1ChannelInfoInput = {
  /** Reference to an order ID from an external system. */
  externalOrderId?: InputMaybe<Scalars['String']>;
  /** URL to the order in the external system. */
  externalOrderUrl?: InputMaybe<Scalars['String']>;
  /** Sales channel that submitted the order. */
  type?: InputMaybe<ComWixEcommercePlatformCommonApiChannelType>;
};

export type ComWixEcomOrdersV1ChargebackCreated = {
  __typename?: 'ComWixEcomOrdersV1ChargebackCreated';
  /** Chargeback amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Chargeback ID. */
  chargebackId?: Maybe<Scalars['String']>;
  /** Payment details. */
  paymentDetails?: Maybe<ComWixEcomOrdersV1RegularPayment>;
  /** ID of the payment that received a chargeback. */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ChargebackCreatedInput = {
  /** Chargeback amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Chargeback ID. */
  chargebackId?: InputMaybe<Scalars['String']>;
  /** Payment details. */
  paymentDetails?: InputMaybe<ComWixEcomOrdersV1RegularPaymentInput>;
  /** ID of the payment that received a chargeback. */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ChargebackReversed = {
  __typename?: 'ComWixEcomOrdersV1ChargebackReversed';
  /** Chargeback amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Chargeback ID. */
  chargebackId?: Maybe<Scalars['String']>;
  /** Payment details. */
  paymentDetails?: Maybe<ComWixEcomOrdersV1RegularPayment>;
  /** ID of the payment involved with the chargeback. */
  paymentId?: Maybe<Scalars['String']>;
  /** Chargeback reversal amount. */
  reversalAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1ChargebackReversedInput = {
  /** Chargeback amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Chargeback ID. */
  chargebackId?: InputMaybe<Scalars['String']>;
  /** Payment details. */
  paymentDetails?: InputMaybe<ComWixEcomOrdersV1RegularPaymentInput>;
  /** ID of the payment involved with the chargeback. */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Chargeback reversal amount. */
  reversalAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1CommitDeltasRequestInput = {
  /** Draft order changes to be applied */
  changes?: InputMaybe<ComWixEcomOrdersV1DraftOrderDiffsInput>;
  /** Side-effects to happen after order is updated */
  commitSettings?: InputMaybe<ComWixEcomOrdersV1DraftOrderCommitSettingsInput>;
  /**
   * Draft order Id representing this change.
   * Use this ID to get this specific draft content. call .../v1/draft-orders/{draft_order_id}/get
   */
  draftOrderId?: InputMaybe<Scalars['String']>;
  /** Order id to be updated */
  id?: InputMaybe<Scalars['String']>;
  /** Reason for edit, given by user (optional). */
  reason?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CommitDeltasResponse = {
  __typename?: 'ComWixEcomOrdersV1CommitDeltasResponse';
  /** Order after deltas are applied */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1Coupon = {
  __typename?: 'ComWixEcomOrdersV1Coupon';
  /** Coupon value. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Coupon code. */
  code?: Maybe<Scalars['String']>;
  /** Coupon ID. */
  id?: Maybe<Scalars['String']>;
  /** Coupon name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CouponInput = {
  /** Coupon value. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Coupon code. */
  code?: InputMaybe<Scalars['String']>;
  /** Coupon ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Coupon name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreateOrderRequestInput = {
  /** Order info. */
  order?: InputMaybe<ComWixEcomOrdersV1OrderInput>;
  /** Determine order lifecycle */
  settings?: InputMaybe<ComWixEcomOrdersV1OrderCreationSettingsInput>;
};

export type ComWixEcomOrdersV1CreateOrderResponse = {
  __typename?: 'ComWixEcomOrdersV1CreateOrderResponse';
  /** Newly created order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1CreatePaymentGatewayOrderRequestInput = {
  /** eCom Order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreatePaymentGatewayOrderResponse = {
  __typename?: 'ComWixEcomOrdersV1CreatePaymentGatewayOrderResponse';
  /** ID of the order created in the payment gateway */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreatedBy = {
  __typename?: 'ComWixEcomOrdersV1CreatedBy';
  /** App ID - when the order was created by an external application. */
  appId?: Maybe<Scalars['String']>;
  /** Member ID - when the order was created by a **logged in** site visitor. */
  memberId?: Maybe<Scalars['String']>;
  /**
   * User ID - when the order was created by a Wix user on behalf of a buyer.
   * For example, via POS (point of service).
   */
  userId?: Maybe<Scalars['String']>;
  /** Visitor ID - when the order was created by a site visitor that was **not** logged in. */
  visitorId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreatedByInput = {
  /** App ID - when the order was created by an external application. */
  appId?: InputMaybe<Scalars['String']>;
  /** Member ID - when the order was created by a **logged in** site visitor. */
  memberId?: InputMaybe<Scalars['String']>;
  /**
   * User ID - when the order was created by a Wix user on behalf of a buyer.
   * For example, via POS (point of service).
   */
  userId?: InputMaybe<Scalars['String']>;
  /** Visitor ID - when the order was created by a site visitor that was **not** logged in. */
  visitorId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreditCardDetails = {
  __typename?: 'ComWixEcomOrdersV1CreditCardDetails';
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreditCardDetailsInput = {
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CurrencyConversionDetails = {
  __typename?: 'ComWixEcomOrdersV1CurrencyConversionDetails';
  /** The rate used for converting the original currency to the currency used for payment. */
  conversionRate?: Maybe<Scalars['String']>;
  /**
   * Currency used for the pricing of this order, in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format.
   *
   * This currency is used to calculate the pricing before conversion to the buyer's payment currency.
   */
  originalCurrency?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CurrencyConversionDetailsInput = {
  /** The rate used for converting the original currency to the currency used for payment. */
  conversionRate?: InputMaybe<Scalars['String']>;
  /**
   * Currency used for the pricing of this order, in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format.
   *
   * This currency is used to calculate the pricing before conversion to the buyer's payment currency.
   */
  originalCurrency?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CustomActivity = {
  __typename?: 'ComWixEcomOrdersV1CustomActivity';
  /** Additional data in key-value form. For example, `{ "Ticket number": "123456" }`. */
  additionalData?: Maybe<Scalars['JSON']>;
  /** ID of the app that created the custom activity. */
  appId?: Maybe<Scalars['String']>;
  /** Custom activity type. For example, `"Ticket number set"`. */
  type?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CustomActivityInput = {
  /** Additional data in key-value form. For example, `{ "Ticket number": "123456" }`. */
  additionalData?: InputMaybe<Scalars['JSON']>;
  /** ID of the app that created the custom activity. */
  appId?: InputMaybe<Scalars['String']>;
  /** Custom activity type. For example, `"Ticket number set"`. */
  type?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CustomField = {
  __typename?: 'ComWixEcomOrdersV1CustomField';
  /** Custom field title. */
  title?: Maybe<Scalars['String']>;
  /** Translated custom field title. */
  translatedTitle?: Maybe<Scalars['String']>;
  /** Custom field value. */
  value?: Maybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1CustomFieldInput = {
  /** Custom field title. */
  title?: InputMaybe<Scalars['String']>;
  /** Translated custom field title. */
  translatedTitle?: InputMaybe<Scalars['String']>;
  /** Custom field value. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1DecrementDataInput = {
  /** Line item quantity being decremented. */
  decrementBy?: InputMaybe<Scalars['Int']>;
  /** ID of the line item being decremented. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Whether to restock the line item (triggers inventory update). */
  restock?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1DecrementItemsQuantityRequestInput = {
  /** Which items to decrement, and how much to decrement from each one */
  decrementData?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1DecrementDataInput>>>;
  /** Order ID */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DecrementItemsQuantityResponse = {
  __typename?: 'ComWixEcomOrdersV1DecrementItemsQuantityResponse';
  /** Updated order data */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1DeleteActivityRequestInput = {
  /** ID of the activity to delete. */
  activityId?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DeleteActivityResponse = {
  __typename?: 'ComWixEcomOrdersV1DeleteActivityResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1DeliveryLogistics = {
  __typename?: 'ComWixEcomOrdersV1DeliveryLogistics';
  /** Deprecated - Latest expected delivery date and time in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  deliverByDate?: Maybe<Scalars['String']>;
  /** Expected delivery time in free text. For example, `"3-5 business days"`. */
  deliveryTime?: Maybe<Scalars['String']>;
  /** Expected delivery time. */
  deliveryTimeSlot?: Maybe<ComWixEcomOrdersV1DeliveryTimeSlot>;
  /** Instructions for carrier. For example, `"Please knock on the door. If unanswered, please call contact number. Thanks."`. */
  instructions?: Maybe<Scalars['String']>;
  /** Pickup details. */
  pickupDetails?: Maybe<ComWixEcomOrdersV1PickupDetails>;
  /** Shipping address and contact details. */
  shippingDestination?: Maybe<ComWixEcommercePlatformCommonApiAddressWithContact>;
};

export type ComWixEcomOrdersV1DeliveryLogisticsInput = {
  /** Deprecated - Latest expected delivery date and time in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  deliverByDate?: InputMaybe<Scalars['String']>;
  /** Expected delivery time in free text. For example, `"3-5 business days"`. */
  deliveryTime?: InputMaybe<Scalars['String']>;
  /** Expected delivery time. */
  deliveryTimeSlot?: InputMaybe<ComWixEcomOrdersV1DeliveryTimeSlotInput>;
  /** Instructions for carrier. For example, `"Please knock on the door. If unanswered, please call contact number. Thanks."`. */
  instructions?: InputMaybe<Scalars['String']>;
  /** Pickup details. */
  pickupDetails?: InputMaybe<ComWixEcomOrdersV1PickupDetailsInput>;
  /** Shipping address and contact details. */
  shippingDestination?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
};

export type ComWixEcomOrdersV1DeliveryTimeSlot = {
  __typename?: 'ComWixEcomOrdersV1DeliveryTimeSlot';
  /** Delivery slot starting time. */
  from?: Maybe<Scalars['String']>;
  /** Delivery slot ending time. */
  to?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DeliveryTimeSlotInput = {
  /** Delivery slot starting time. */
  from?: InputMaybe<Scalars['String']>;
  /** Delivery slot ending time. */
  to?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomOrdersV1DeltaPaymentOptionType {
  /** The entire payment for the given item will happen after checkout. */
  FullPaymentOffline = 'FULL_PAYMENT_OFFLINE',
  /**
   * Payment for this item can only be done using a membership and must be manually redeemed in the dashboard by the site owner.
   * Note: when this option is used, the price will be 0.
   */
  MembershipOffline = 'MEMBERSHIP_OFFLINE',
  /** Irrelevant */
  UnknownPaymentOption = 'UNKNOWN_PAYMENT_OPTION'
}

export type ComWixEcomOrdersV1DigitalFile = {
  __typename?: 'ComWixEcomOrdersV1DigitalFile';
  /** Link expiration time and date. */
  expirationDate?: Maybe<Scalars['String']>;
  /** ID of the secure file in media. */
  fileId?: Maybe<Scalars['String']>;
  /** Link will exist after the digital links have been generated on the order. */
  link?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DigitalFileInput = {
  /** Link expiration time and date. */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** ID of the secure file in media. */
  fileId?: InputMaybe<Scalars['String']>;
  /** Link will exist after the digital links have been generated on the order. */
  link?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DiscountRule = {
  __typename?: 'ComWixEcomOrdersV1DiscountRule';
  /** Discount value. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Discount rule ID */
  discountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
  /** Discount rule ID */
  id?: Maybe<Scalars['String']>;
  /** Discount rule name */
  name?: Maybe<ComWixEcomOrdersV1DiscountRuleName>;
};

export type ComWixEcomOrdersV1DiscountRuleInput = {
  /** Discount value. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Discount rule ID */
  id?: InputMaybe<Scalars['String']>;
  /** Discount rule name */
  name?: InputMaybe<ComWixEcomOrdersV1DiscountRuleNameInput>;
};

export type ComWixEcomOrdersV1DiscountRuleName = {
  __typename?: 'ComWixEcomOrdersV1DiscountRuleName';
  /** Original discount rule name (in site's default language). */
  original?: Maybe<Scalars['String']>;
  /** Translated discount rule name according to buyer language. Defaults to `original` when not provided. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DiscountRuleNameInput = {
  /** Original discount rule name (in site's default language). */
  original?: InputMaybe<Scalars['String']>;
  /** Translated discount rule name according to buyer language. Defaults to `original` when not provided. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesApplied = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesApplied';
  /** Changes applied to order. */
  changes?: Maybe<Array<Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChange>>>;
  /** Draft order id. */
  draftOrderId?: Maybe<Scalars['String']>;
  /** Reason for edit, given by user (optional). */
  reason?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItem = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItem';
  descriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  quantity?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetails>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemInput = {
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  quantity?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetails = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetails';
  changeType?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsItemQuantityChangeType>;
  diff?: Maybe<Scalars['Int']>;
  newQuantity?: Maybe<Scalars['Int']>;
  originalQuantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsInput = {
  changeType?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsItemQuantityChangeType>;
  diff?: InputMaybe<Scalars['Int']>;
  newQuantity?: InputMaybe<Scalars['Int']>;
  originalQuantity?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsItemQuantityChangeType {
  ItemAdded = 'ITEM_ADDED',
  ItemRemoved = 'ITEM_REMOVED',
  QuantityDecreased = 'QUANTITY_DECREASED',
  QuantityIncreased = 'QUANTITY_INCREASED'
}

export type ComWixEcomOrdersV1DraftOrderChangesAppliedInput = {
  /** Changes applied to order. */
  changes?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChangeInput>>>;
  /** Draft order id. */
  draftOrderId?: InputMaybe<Scalars['String']>;
  /** Reason for edit, given by user (optional). */
  reason?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount';
  /** Amount associated with this item. (Discount amount for item / additional fee amount for item) */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Order line item id */
  id?: Maybe<Scalars['String']>;
  /** Item name. */
  name?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput = {
  /** Amount associated with this item. (Discount amount for item / additional fee amount for item) */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order line item id */
  id?: InputMaybe<Scalars['String']>;
  /** Item name. */
  name?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChanges = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChanges';
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /** Item name. */
  name?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  /** Item price change. */
  price?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChange>;
  /** Item quantity change. */
  quantity?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChange>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChangesInput = {
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Item name. */
  name?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /** Item price change. */
  price?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChangeInput>;
  /** Item quantity change. */
  quantity?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChange = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChange';
  /** Item price after update. */
  newPrice?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Item price before update. */
  originalPrice?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChangeInput = {
  /** Item price after update. */
  newPrice?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Item price before update. */
  originalPrice?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChange = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChange';
  /** Type of quantity change: increase or decrease. */
  deltaType?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeLineItemQuantityChangeType>;
  /** Difference between original and new quantity. Absolute value. */
  diff?: Maybe<Scalars['Int']>;
  /** Item quantity after update. */
  newQuantity?: Maybe<Scalars['Int']>;
  /** Item quantity before update. */
  originalQuantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeInput = {
  /** Type of quantity change: increase or decrease. */
  deltaType?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeLineItemQuantityChangeType>;
  /** Difference between original and new quantity. Absolute value. */
  diff?: InputMaybe<Scalars['Int']>;
  /** Item quantity after update. */
  newQuantity?: InputMaybe<Scalars['Int']>;
  /** Item quantity before update. */
  originalQuantity?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeLineItemQuantityChangeType {
  /** Quantity decreased. */
  QuantityDecreased = 'QUANTITY_DECREASED',
  /** Quantity increased. */
  QuantityIncreased = 'QUANTITY_INCREASED'
}

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee';
  /** Line items additional fee applies to. */
  affectedLineItems?: Maybe<Array<Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount>>>;
  /** Additional fee id. */
  id?: Maybe<Scalars['String']>;
  /** Additional fee name. */
  name?: Maybe<ComWixEcomOrdersV1TranslatedValue>;
  /** Additional fee amount. */
  totalAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput = {
  /** Line items additional fee applies to. */
  affectedLineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput>>>;
  /** Additional fee id. */
  id?: InputMaybe<Scalars['String']>;
  /** Additional fee name. */
  name?: InputMaybe<ComWixEcomOrdersV1TranslatedValueInput>;
  /** Additional fee amount. */
  totalAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount';
  /** Line items discount applies to. */
  affectedLineItems?: Maybe<Array<Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount>>>;
  /** Discount id. */
  id?: Maybe<Scalars['String']>;
  /** Discount name: coupon name / discount rule name / merchant discount description. */
  name?: Maybe<ComWixEcomOrdersV1TranslatedValue>;
  /** Discount amount. */
  totalAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput = {
  /** Line items discount applies to. */
  affectedLineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput>>>;
  /** Discount id. */
  id?: InputMaybe<Scalars['String']>;
  /** Discount name: coupon name / discount rule name / merchant discount description. */
  name?: InputMaybe<ComWixEcomOrdersV1TranslatedValueInput>;
  /** Discount amount. */
  totalAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem';
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /** Item name. */
  name?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  /** Added or removed item quantity. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput = {
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Item name. */
  name?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /** Added or removed item quantity. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChange = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChange';
  additionalFeeAdded?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee>;
  additionalFeeRemoved?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee>;
  discountAdded?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount>;
  discountRemoved?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount>;
  lineItemAdded?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem>;
  lineItemChanged?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChanges>;
  lineItemRemoved?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem>;
  shippingInformationChanged?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChange>;
  totalPriceChanged?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChange>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChangeInput = {
  additionalFeeAdded?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput>;
  additionalFeeRemoved?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput>;
  discountAdded?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput>;
  discountRemoved?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput>;
  lineItemAdded?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput>;
  lineItemChanged?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChangesInput>;
  lineItemRemoved?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput>;
  shippingInformationChanged?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeInput>;
  totalPriceChanged?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChangeInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChange = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChange';
  /** Order’s Shipping Information. After update */
  newShippingInfo?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation>;
  /** Order’s Shipping Information. Before update */
  originalShippingInfo?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeInput = {
  /** Order’s Shipping Information. After update */
  newShippingInfo?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput>;
  /** Order’s Shipping Information. Before update */
  originalShippingInfo?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation';
  /** Order’s shipping title. */
  shippingTitle?: Maybe<Scalars['String']>;
  /** Order’s shipping price. */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput = {
  /** Order’s shipping title. */
  shippingTitle?: InputMaybe<Scalars['String']>;
  /** Order’s shipping price. */
  total?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChange = {
  __typename?: 'ComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChange';
  /** Order’s total price after discounts and tax. After update */
  newTotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Order’s total price after discounts and tax. Before update */
  originalTotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChangeInput = {
  /** Order’s total price after discounts and tax. After update */
  newTotal?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order’s total price after discounts and tax. Before update */
  originalTotal?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1DraftOrderCommitSettingsInput = {
  /** If false, do not add activities to the order. Default is true. */
  addActivitiesToOrder?: InputMaybe<Scalars['Boolean']>;
  /** Inventory changes to be applied. Either to restock, or decrease. */
  inventoryUpdates?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1InventoryUpdateDetailsInput>>>;
  /** If false, do not send notifications to business. Default is true. */
  sendNotificationsToBusiness?: InputMaybe<Scalars['Boolean']>;
  /** If false, do not send notifications to buyer. Default is true. */
  sendNotificationsToBuyer?: InputMaybe<Scalars['Boolean']>;
  /** If false, do not send mails to custom fulfillers in case of a change of shippable items fulfilled by custom fulfillers. Default is true. */
  sendNotificationsToCustomFulfillers?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1DraftOrderDiffsInput = {
  /** Added/updated/removed additional fee. */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1AdditionalFeeDeltaInput>>>;
  /** Added/updated/removed discounts. */
  appliedDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1AppliedDiscountDeltaInput>>>;
  /** Remove existing billing info. */
  billingInfoRemoved?: InputMaybe<Scalars['Boolean']>;
  /** Remove existing buyer info. */
  buyerInfoRemoved?: InputMaybe<Scalars['Boolean']>;
  /** Updated billing info. */
  changedBillingInfo?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
  /** Buyer info and selected buyer option details. */
  changedBuyerInfo?: InputMaybe<ComWixEcomOrdersV1BuyerInfoInput>;
  /** Updated recipient info. */
  changedRecipientInfo?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
  /** Shipping info and selected shipping option details. */
  changedShippingInfo?: InputMaybe<ComWixEcomOrdersV1ShippingInformationInput>;
  /** Updated order extended fields. Overrides existing extended fields. todo fully? partially? */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Added/updated/removed order line items. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1LineItemDeltaInput>>>;
  /**
   * Updated order price summary. overwrites existing price summary.
   * balance will be updated automatically.
   */
  priceSummary?: InputMaybe<ComWixEcomOrdersV1PriceSummaryInput>;
  /** Remove existing recipient info. */
  recipientInfoRemoved?: InputMaybe<Scalars['Boolean']>;
  /** Remove existing shipping info. */
  shippingInfoRemoved?: InputMaybe<Scalars['Boolean']>;
  /** Tax information. */
  taxInfo?: InputMaybe<ComWixEcomOrdersV1OrderTaxInfoInput>;
};

export type ComWixEcomOrdersV1ExternalReceipt = {
  __typename?: 'ComWixEcomOrdersV1ExternalReceipt';
  /** Display number of receipt */
  displayNumber?: Maybe<Scalars['String']>;
  /** Receipt ID */
  receiptId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ExternalReceiptInput = {
  /** Display number of receipt */
  displayNumber?: InputMaybe<Scalars['String']>;
  /** Receipt ID */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1FreeTrialPeriod = {
  __typename?: 'ComWixEcomOrdersV1FreeTrialPeriod';
  /** Frequency of period. Values: DAY, WEEK, MONTH, YEAR */
  frequency?: Maybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** interval of period */
  interval?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1FreeTrialPeriodInput = {
  /** Frequency of period. Values: DAY, WEEK, MONTH, YEAR */
  frequency?: InputMaybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** interval of period */
  interval?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomOrdersV1FulfillmentStatus {
  /**
   * All of the order items are fulfilled or the order was manually marked as fulfilled.
   * Orders without shipping info are fulfilled automatically.
   */
  Fulfilled = 'FULFILLED',
  /** None of the order items are fulfilled or the order was manually marked as unfulfilled. */
  NotFulfilled = 'NOT_FULFILLED',
  /** Some, but not all, of the order items are fulfilled. */
  PartiallyFulfilled = 'PARTIALLY_FULFILLED'
}

export type ComWixEcomOrdersV1FulfillmentStatusesAggregate = {
  __typename?: 'ComWixEcomOrdersV1FulfillmentStatusesAggregate';
  /** Unique string values based on Fulfillment entities statuses */
  statuses?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersV1FulfillmentStatusesAggregateInput = {
  /** Unique string values based on Fulfillment entities statuses */
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersV1GetOrderRequestInput = {
  id: Scalars['ID'];
};

export type ComWixEcomOrdersV1GetShipmentsRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1GetShipmentsResponse = {
  __typename?: 'ComWixEcomOrdersV1GetShipmentsResponse';
  shipmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersV1GiftCardPaymentRefund = {
  __typename?: 'ComWixEcomOrdersV1GiftCardPaymentRefund';
  /** Refund amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Gift card payment ID */
  giftCardPaymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1GiftCardPaymentRefundInput = {
  /** Refund amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Gift card payment ID */
  giftCardPaymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1InternalActivityInput = {
  /** Internal activity author's email. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Details of an authorized payment captured. */
  authorizedPaymentCaptured?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentCapturedInput>;
  /** Details of an authorized payment created. */
  authorizedPaymentCreated?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentCreatedInput>;
  /** Details of an authorized payment voided. */
  authorizedPaymentVoided?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentVoidedInput>;
  /** Chargeback created for one of the order's payments. */
  chargebackCreated?: InputMaybe<ComWixEcomOrdersV1ChargebackCreatedInput>;
  /** Chargeback reversed for one of the order's payments. */
  chargebackReversed?: InputMaybe<ComWixEcomOrdersV1ChargebackReversedInput>;
  /** Internal activity creation date and time. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Download link was sent (relevant for orders with digital line items). */
  downloadLinkSent?: InputMaybe<Scalars['Void']>;
  /** Draft order changes applied */
  draftOrderChangesApplied?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedInput>;
  /** Order email was updated. */
  emailEdited?: InputMaybe<Scalars['Void']>;
  /** Email sent to fulfiller. */
  fulfillerEmailSent?: InputMaybe<Scalars['Void']>;
  /** Internal activity ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Invoice was added to order. */
  invoiceAdded?: InputMaybe<Scalars['Void']>;
  /** Invoice sent to customer via email. */
  invoiceSent?: InputMaybe<Scalars['Void']>;
  /** New exchange order created. */
  newExchangeOrderCreated?: InputMaybe<ComWixEcomOrdersV1NewExchangeOrderCreatedInput>;
  /** Order canceled. */
  orderCanceled?: InputMaybe<Scalars['Void']>;
  /** Order created as a result of items exchange. */
  orderCreatedFromExchange?: InputMaybe<ComWixEcomOrdersV1OrderCreatedFromExchangeInput>;
  /** Order shipping status set as fulfilled. */
  orderFulfilled?: InputMaybe<Scalars['Void']>;
  /** Order shipping status set as not fulfilled. */
  orderNotFulfilled?: InputMaybe<Scalars['Void']>;
  /** Order paid. Either by the store owner (for offline orders), or when an online transaction was confirmed. */
  orderPaid?: InputMaybe<Scalars['Void']>;
  /** Order partially paid. During the checkout for orders with deposit items. */
  orderPartiallyPaid?: InputMaybe<Scalars['Void']>;
  /** Order pending */
  orderPending?: InputMaybe<Scalars['Void']>;
  /** Order placed. */
  orderPlaced?: InputMaybe<Scalars['Void']>;
  /** Order refunded. */
  orderRefunded?: InputMaybe<ComWixEcomOrdersV1OrderRefundedInput>;
  /** Order rejected */
  orderRejected?: InputMaybe<Scalars['Void']>;
  /** Details of a canceled payment */
  paymentCanceled?: InputMaybe<ComWixEcomOrdersV1PaymentCanceledInput>;
  /** Details of a declined payment */
  paymentDeclined?: InputMaybe<ComWixEcomOrdersV1PaymentDeclinedInput>;
  /** Details of a pending payment */
  paymentPending?: InputMaybe<ComWixEcomOrdersV1PaymentPendingInput>;
  /**
   * Details of a failed payment refund.
   *
   * > **Note:** A single `refund_initiated` activity can result in multiple `payment_refunded` or `payment_refund_failed` activities.
   * > In these cases, the `refund_id` will be identical across the activities.
   */
  paymentRefundFailed?: InputMaybe<ComWixEcomOrdersV1PaymentRefundFailedInput>;
  /**
   * Details of a refunded payment.
   *
   * > **Note:** A single `refund_initiated` activity can result in multiple `payment_refunded` or `payment_refund_failed` activities.
   * > In these cases, the `refund_id` will be identical across the activities.
   */
  paymentRefunded?: InputMaybe<ComWixEcomOrdersV1PaymentRefundedInput>;
  /** Email notification for pickup sent. */
  pickupReadyEmailSent?: InputMaybe<Scalars['Void']>;
  /** Receipt was added for associated payment */
  receiptCreated?: InputMaybe<ComWixEcomOrdersV1ReceiptCreatedInput>;
  /** Receipt sent to customer */
  receiptSent?: InputMaybe<ComWixEcomOrdersV1ReceiptSentInput>;
  /**
   * Details of an initiated refund process.
   *
   * > **Note:** A single `refund_initiated` activity can result in multiple `payment_refunded` or `payment_refund_failed` activities.
   * > In these cases, the `refund_id` will be identical across the activities.
   */
  refundInitiated?: InputMaybe<ComWixEcomOrdersV1RefundInitiatedInput>;
  /** Details of refund to store credit. */
  refundedAsStoreCredit?: InputMaybe<ComWixEcomOrdersV1RefundedAsStoreCreditInput>;
  /** Payment method is saved for order */
  savedPaymentMethod?: InputMaybe<ComWixEcomOrdersV1SavedPaymentMethodInput>;
  /** Shipping address was updated. */
  shippingAddressEdited?: InputMaybe<Scalars['Void']>;
  /** An email confirmation of order shipment was sent. */
  shippingConfirmationEmailSent?: InputMaybe<Scalars['Void']>;
  /** Shipping tracking link added to order. */
  trackingLinkAdded?: InputMaybe<Scalars['Void']>;
  /** Shipping tracking number added to order. */
  trackingNumberAdded?: InputMaybe<Scalars['Void']>;
  /** Shipping tracking number was edited. */
  trackingNumberEdited?: InputMaybe<Scalars['Void']>;
};

export type ComWixEcomOrdersV1InternalQueryOrdersRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type ComWixEcomOrdersV1InternalQueryOrdersResponse = {
  __typename?: 'ComWixEcomOrdersV1InternalQueryOrdersResponse';
  /** Details on the paged set of results returned. */
  metadata?: Maybe<ComWixEcommerceCommonsApiPlatformPagingMetadata>;
  /** List of orders. */
  orders?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
};

export type ComWixEcomOrdersV1InventoryUpdateDetailsInput = {
  /** Action to be applied - decrease or restock */
  actionType?: InputMaybe<ComWixEcomOrdersV1InventoryUpdateDetailsInventoryAction>;
  /** Order line item id */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** The amount to be increased or restocked */
  quantityChange?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomOrdersV1InventoryUpdateDetailsInventoryAction {
  /** Decrease inventory. Without failing on negative inventory. */
  Decrease = 'DECREASE',
  /** Restock inventory */
  Restock = 'RESTOCK'
}

export type ComWixEcomOrdersV1ItemChangedDetailsInput = {
  /** The price before the change. */
  priceBeforeChange?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** The price description before the change */
  priceDescriptionBeforeChange?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput>;
  /** The quantity before the change. */
  quantityBeforeChange?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1ItemModifier = {
  __typename?: 'ComWixEcomOrdersV1ItemModifier';
  /** Optional additional details or clarification for the modifier. */
  details?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
  /** Modifier ID. */
  id?: Maybe<Scalars['String']>;
  /** Primary display label for the modifier. */
  label?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
  /** The price of the modifier. */
  price?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The quantity of this modifier. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1ItemModifierInput = {
  /** Optional additional details or clarification for the modifier. */
  details?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** Modifier ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Primary display label for the modifier. */
  label?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** The price of the modifier. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** The quantity of this modifier. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomOrdersV1JurisdictionType {
  City = 'CITY',
  Country = 'COUNTRY',
  County = 'COUNTY',
  Special = 'SPECIAL',
  State = 'STATE',
  Undefined = 'UNDEFINED'
}

export type ComWixEcomOrdersV1LineItemDeltaInput = {
  /** The line item was modified. */
  changedDetails?: InputMaybe<ComWixEcomOrdersV1ItemChangedDetailsInput>;
  lineItem?: InputMaybe<ComWixEcomOrdersV1OrderLineItemChangedDetailsInput>;
  /** The line item was added. */
  lineItemAdded?: InputMaybe<Scalars['Boolean']>;
  /** Line item ID. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** The line item was added. */
  lineItemRemoved?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1LineItemDiscount = {
  __typename?: 'ComWixEcomOrdersV1LineItemDiscount';
  /** ID of line item the discount applies to. */
  id?: Maybe<Scalars['String']>;
  /** Total discount for this line item. */
  totalDiscount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1LineItemDiscountInput = {
  /** ID of line item the discount applies to. */
  id?: InputMaybe<Scalars['String']>;
  /** Total discount for this line item. */
  totalDiscount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1LineItemExchangeData = {
  __typename?: 'ComWixEcomOrdersV1LineItemExchangeData';
  /** ID of the exchanged line item. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Line item quantity being exchanged. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1LineItemExchangeDataInput = {
  /** ID of the exchanged line item. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Line item quantity being exchanged. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1LineItemTaxBreakdown = {
  __typename?: 'ComWixEcomOrdersV1LineItemTaxBreakdown';
  /** Jurisdiction that taxes were calculated for. For example, "New York", or "Quebec". */
  jurisdiction?: Maybe<Scalars['String']>;
  /** Type of jurisdiction that taxes were calculated for. */
  jurisdictionType?: Maybe<ComWixEcomOrdersV1JurisdictionType>;
  /** Non-taxable amount of the line item price. */
  nonTaxableAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax rate used for this jurisdiction, as a decimal. For example, 10% tax is 0.1000. */
  rate?: Maybe<Scalars['String']>;
  /** Amount of tax calculated for this line item. */
  taxAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /**
   * The name of the tax against which this tax amount was calculated. For example, "NY State Sales Tax", "Quebec GST", etc.
   * This name should be explicit enough to allow the merchant to understand what tax was calculated.
   */
  taxName?: Maybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the jurisdiction's tax laws. For example, "Sales Tax", "Income Tax", "Value Added Tax", etc. */
  taxType?: Maybe<Scalars['String']>;
  /** Taxable amount of the line item price. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1LineItemTaxBreakdownInput = {
  /** Jurisdiction that taxes were calculated for. For example, "New York", or "Quebec". */
  jurisdiction?: InputMaybe<Scalars['String']>;
  /** Type of jurisdiction that taxes were calculated for. */
  jurisdictionType?: InputMaybe<ComWixEcomOrdersV1JurisdictionType>;
  /** Non-taxable amount of the line item price. */
  nonTaxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Tax rate used for this jurisdiction, as a decimal. For example, 10% tax is 0.1000. */
  rate?: InputMaybe<Scalars['String']>;
  /** Amount of tax calculated for this line item. */
  taxAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * The name of the tax against which this tax amount was calculated. For example, "NY State Sales Tax", "Quebec GST", etc.
   * This name should be explicit enough to allow the merchant to understand what tax was calculated.
   */
  taxName?: InputMaybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the jurisdiction's tax laws. For example, "Sales Tax", "Income Tax", "Value Added Tax", etc. */
  taxType?: InputMaybe<Scalars['String']>;
  /** Taxable amount of the line item price. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1LineItemTaxInfo = {
  __typename?: 'ComWixEcomOrdersV1LineItemTaxInfo';
  /** Calculated tax, based on `taxable_amount` and `tax_rate`. */
  taxAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax information for a line item. */
  taxBreakdown?: Maybe<Array<Maybe<ComWixEcomOrdersV1LineItemTaxBreakdown>>>;
  /** Tax group ID. */
  taxGroupId?: Maybe<Scalars['String']>;
  /** Indicates whether the price already includes tax. */
  taxIncludedInPrice?: Maybe<Scalars['Boolean']>;
  /** Tax rate %, as a decimal point. */
  taxRate?: Maybe<Scalars['String']>;
  /** Amount for which tax is calculated. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1LineItemTaxInfoInput = {
  /** Calculated tax, based on `taxable_amount` and `tax_rate`. */
  taxAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Tax information for a line item. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1LineItemTaxBreakdownInput>>>;
  /** Tax group ID. */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /** Indicates whether the price already includes tax. */
  taxIncludedInPrice?: InputMaybe<Scalars['Boolean']>;
  /** Tax rate %, as a decimal point. */
  taxRate?: InputMaybe<Scalars['String']>;
  /** Amount for which tax is calculated. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1LineItemUpdateInput = {
  /**
   * Description lines' info.
   * If description line already exists for this name, it will be replaced.
   */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Line item ID. */
  lineItemId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ListOrdersRequestInput = {
  /** ID of the order to retrieve. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Cursor token pointing to a page of results. Not used in the first request. */
  paging?: InputMaybe<ComWixEcommerceCommonsApiPlatformCursorPagingInput>;
};

export type ComWixEcomOrdersV1ListOrdersResponse = {
  __typename?: 'ComWixEcomOrdersV1ListOrdersResponse';
  /** The requested order. */
  orders?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<WixCommonCursorPagingMetadata>;
};

export type ComWixEcomOrdersV1MarkAsFulfilledRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MarkAsFulfilledResponse = {
  __typename?: 'ComWixEcomOrdersV1MarkAsFulfilledResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1MarkAsUnfulfilledRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MarkAsUnfulfilledResponse = {
  __typename?: 'ComWixEcomOrdersV1MarkAsUnfulfilledResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1MarkOrderAsPaidRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MarkOrderAsPaidResponse = {
  __typename?: 'ComWixEcomOrdersV1MarkOrderAsPaidResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1MarkOrderAsSeenByHumanRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MarkOrderAsSeenByHumanResponse = {
  __typename?: 'ComWixEcomOrdersV1MarkOrderAsSeenByHumanResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1MaskedOrderInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order to be updated. */
  order?: InputMaybe<ComWixEcomOrdersV1OrderInput>;
};

export type ComWixEcomOrdersV1MaskedOrderLineItemInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order line item to update */
  lineItem?: InputMaybe<ComWixEcomOrdersV1OrderLineItemInput>;
};

export type ComWixEcomOrdersV1MembershipPaymentRefund = {
  __typename?: 'ComWixEcomOrdersV1MembershipPaymentRefund';
  /** Membership ID */
  membershipId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MembershipPaymentRefundInput = {
  /** Membership ID */
  membershipId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MerchantComment = {
  __typename?: 'ComWixEcomOrdersV1MerchantComment';
  /** Merchant comment message. */
  message?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MerchantCommentInput = {
  /** Merchant comment message. */
  message?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MerchantDiscount = {
  __typename?: 'ComWixEcomOrdersV1MerchantDiscount';
  /** Discount amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Discount description as free text (optional). */
  description?: Maybe<Scalars['String']>;
  /**
   * Pre-defined discount reason (optional).
   * * `"ITEMS_EXCHANGE"` - exchange balance acquired as a result of items exchange.
   */
  discountReason?: Maybe<ComWixEcomOrdersV1MerchantDiscountDiscountReason>;
  /** Discount percentage. */
  percentage?: Maybe<Scalars['String']>;
};

export enum ComWixEcomOrdersV1MerchantDiscountDiscountReason {
  BillingAdjustment = 'BILLING_ADJUSTMENT',
  ExchangedItems = 'EXCHANGED_ITEMS',
  Unspecified = 'UNSPECIFIED'
}

export type ComWixEcomOrdersV1MerchantDiscountInput = {
  /** Discount amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Discount description as free text (optional). */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Pre-defined discount reason (optional).
   * * `"ITEMS_EXCHANGE"` - exchange balance acquired as a result of items exchange.
   */
  discountReason?: InputMaybe<ComWixEcomOrdersV1MerchantDiscountDiscountReason>;
  /** Discount percentage. */
  percentage?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ModifierGroup = {
  __typename?: 'ComWixEcomOrdersV1ModifierGroup';
  /** Modifier group id. */
  id?: Maybe<Scalars['String']>;
  /** List of modifiers in this group. */
  modifiers?: Maybe<Array<Maybe<ComWixEcomOrdersV1ItemModifier>>>;
  /** Modifier group name. */
  name?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
};

export type ComWixEcomOrdersV1ModifierGroupInput = {
  /** Modifier group id. */
  id?: InputMaybe<Scalars['String']>;
  /** List of modifiers in this group. */
  modifiers?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ItemModifierInput>>>;
  /** Modifier group name. */
  name?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
};

export type ComWixEcomOrdersV1NewExchangeOrderCreated = {
  __typename?: 'ComWixEcomOrdersV1NewExchangeOrderCreated';
  /** ID of the new order created as a result of an exchange of items. */
  exchangeOrderId?: Maybe<Scalars['String']>;
  /** IDs of the items that were exchanged. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersV1LineItemExchangeData>>>;
};

export type ComWixEcomOrdersV1NewExchangeOrderCreatedInput = {
  /** ID of the new order created as a result of an exchange of items. */
  exchangeOrderId?: InputMaybe<Scalars['String']>;
  /** IDs of the items that were exchanged. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1LineItemExchangeDataInput>>>;
};

export type ComWixEcomOrdersV1Order = {
  __typename?: 'ComWixEcomOrdersV1Order';
  /** Order activities. */
  activities?: Maybe<Array<Maybe<ComWixEcomOrdersV1Activity>>>;
  /** Additional fees applied to the order. */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomOrdersV1AdditionalFee>>>;
  /** Applied discounts. */
  appliedDiscounts?: Maybe<Array<Maybe<ComWixEcomOrdersV1AppliedDiscount>>>;
  /** Whether order is archived. */
  archived?: Maybe<Scalars['Boolean']>;
  /** Order attribution source. */
  attributionSource?: Maybe<ComWixEcomOrdersV1AttributionSourceEnumAttributionSource>;
  /** Balance summary. */
  balanceSummary?: Maybe<ComWixEcomOrdersV1BalanceSummary>;
  /** Billing address and contact details. */
  billingInfo?: Maybe<ComWixEcommercePlatformCommonApiAddressWithContact>;
  /** Order Location */
  businessLocation?: Maybe<ComWixEcommercePlatformCommonApiLocation>;
  /** Buyer information. */
  buyerInfo?: Maybe<ComWixEcomOrdersV1BuyerInfo>;
  /**
   * Language for communication with the buyer. Defaults to the site language.
   * For a site that supports multiple languages, this is the language the buyer selected.
   */
  buyerLanguage?: Maybe<Scalars['String']>;
  /** [Buyer note](https://support.wix.com/en/article/wix-stores-viewing-buyer-notes) left by the customer. */
  buyerNote?: Maybe<Scalars['String']>;
  /** Cart ID - required by TYP OOI for legacy orders. */
  cartId?: Maybe<Scalars['String']>;
  /** Information about the sales channel that submitted this order. */
  channelInfo?: Maybe<ComWixEcomOrdersV1ChannelInfo>;
  /** Checkout ID. */
  checkoutId?: Maybe<Scalars['String']>;
  /** ID of the order's initiator. */
  createdBy?: Maybe<ComWixEcomOrdersV1CreatedBy>;
  /** Date and time the order was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: Maybe<Scalars['String']>;
  /** Currency used for the pricing of this order in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format. */
  currency?: Maybe<Scalars['String']>;
  /** Currency conversion details. For use with multi-currency sites. */
  currencyConversionDetails?: Maybe<ComWixEcomOrdersV1CurrencyConversionDetails>;
  /** Custom fields. */
  customFields?: Maybe<Array<Maybe<ComWixEcomOrdersV1CustomField>>>;
  /**
   * Custom field data for the order object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  externalEnrichedLineItemsForOrderPage?: Maybe<ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForOrderPageResponse>;
  externalEnrichedLineItemsForTYP?: Maybe<ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForThankYouPageResponse>;
  externalFulfillments?: Maybe<Array<Maybe<ComWixEcomOrdersFulfillmentsV1Fulfillment>>>;
  externalInvoices?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1Invoice>>>;
  externalOrderRefundability?: Maybe<ComWixEcomOrdersBillingV1GetOrderRefundabilityResponse>;
  externalPaymentCollectabilityStatus?: Maybe<ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusResponse>;
  externalRefundOptions?: Maybe<ComWixEcomOrdersBillingV1GetRefundOptionsResponse>;
  externalTransactions?: Maybe<ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderResponse>;
  /** Order fulfillment status. */
  fulfillmentStatus?: Maybe<ComWixEcomOrdersV1FulfillmentStatus>;
  /** Custom string status values aggregated from every fulfillment entity associated with current order */
  fulfillmentStatusesAggregate?: Maybe<ComWixEcomOrdersV1FulfillmentStatusesAggregate>;
  /** Order ID. */
  id?: Maybe<Scalars['String']>;
  /** Private API flag that allows using read-only "id" during order creation. */
  isInternalOrderCreate?: Maybe<Scalars['Boolean']>;
  /** Order line items. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersV1OrderLineItem>>>;
  /** Order number displayed in the site owner's dashboard (auto-generated). */
  number?: Maybe<Scalars['Long']>;
  orderTransactionsVirtualReference?: Maybe<ComWixEcomOrdersPaymentsV1QueryOrderTransactionsResponse>;
  /** Pay after free trial price summary. Price summary that should be paid for subscriptions after free trial period. */
  payAfterFreeTrial?: Maybe<ComWixEcomOrdersV1PriceSummary>;
  /** Pay now price summary. Part of price_summary that must be payed at checkout */
  payNow?: Maybe<ComWixEcomOrdersV1PriceSummary>;
  /** Order payment status. */
  paymentStatus?: Maybe<ComWixEcomOrdersV1PaymentStatusEnumPaymentStatus>;
  /** Order price summary. */
  priceSummary?: Maybe<ComWixEcomOrdersV1PriceSummary>;
  /** Persistent ID that correlates between the various eCommerce elements: cart, checkout, and order. */
  purchaseFlowId?: Maybe<Scalars['String']>;
  /**
   * Date and time the order was originally purchased in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format.
   * Used for migration from external systems.
   */
  purchasedDate?: Maybe<Scalars['String']>;
  /**
   * Order recipient address and contact details.
   *
   * This field may differ from the address in `shippingInfo.logistics` when:
   * + The chosen shipping option is pickup point or store pickup.
   * + No shipping option is selected.
   */
  recipientInfo?: Maybe<ComWixEcommercePlatformCommonApiAddressWithContact>;
  /** Whether a human has seen the order. Set when an order is clicked on in the dashboard. */
  seenByAHuman?: Maybe<Scalars['Boolean']>;
  /** Shipping info and selected shipping option details. */
  shippingInfo?: Maybe<ComWixEcomOrdersV1ShippingInformation>;
  /** Site language in which original values are shown. */
  siteLanguage?: Maybe<Scalars['String']>;
  /** Order status. */
  status?: Maybe<ComWixEcomOrdersV1OrderStatus>;
  /**
   * Order tags.
   *
   * [Tags](https://dev.wix.com/docs/rest/business-management/tags/introduction) are labels attached to entities, allowing for flexible categorization and data management.
   */
  tags?: Maybe<WixCommonTagsTags>;
  /** Whether tax is included in line item prices. */
  taxIncludedInPrices?: Maybe<Scalars['Boolean']>;
  /** Tax information. */
  taxInfo?: Maybe<ComWixEcomOrdersV1OrderTaxInfo>;
  /**
   * Tax summary.
   * Deprecated. Use `taxInfo` instead.
   * This field will be removed on September 30, 2024.
   * @deprecated Tax summary.
   * Deprecated. Use `taxInfo` instead.
   * This field will be removed on September 30, 2024. Replaced by: tax_info. Removal date: 2024-09-30.
   */
  taxSummary?: Maybe<ComWixEcomTaxApiTaxSummary>;
  /** Date and time the order was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Weight measurement unit - defaults to site's weight unit. */
  weightUnit?: Maybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};


export type ComWixEcomOrdersV1OrderOrderTransactionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixEcomOrdersPaymentsV1QueryOrderTransactionsRequestInput>;
};

export enum ComWixEcomOrdersV1OrderApprovalStrategy {
  /** Order is automatically approved when `order.priceSummary.total = 0`, **or** after receiving payment. */
  Default = 'DEFAULT',
  /** Order is automatically approved when payment method is saved for it. */
  PaymentMethodSaved = 'PAYMENT_METHOD_SAVED',
  /** Order is automatically approved **only** after receiving payment. */
  PaymentReceived = 'PAYMENT_RECEIVED'
}

export type ComWixEcomOrdersV1OrderCreateNotificationsInput = {
  /**
   * Whether to send notification to the buyer.
   *
   * Default: `true`
   */
  sendNotificationToBuyer?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to send notifications to the business.
   *
   * Default: `true`
   */
  sendNotificationsToBusiness?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1OrderCreatedFromExchange = {
  __typename?: 'ComWixEcomOrdersV1OrderCreatedFromExchange';
  /** ID of the original order for which the exchange happened. */
  originalOrderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderCreatedFromExchangeInput = {
  /** ID of the original order for which the exchange happened. */
  originalOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderCreationSettingsInput = {
  /** Notification settings to be applied on order creation */
  notifications?: InputMaybe<ComWixEcomOrdersV1OrderCreateNotificationsInput>;
  /**
   * Condition for the order to be approved.
   * Default: `DEFAULT`
   */
  orderApprovalStrategy?: InputMaybe<ComWixEcomOrdersV1OrderApprovalStrategy>;
};

export type ComWixEcomOrdersV1OrderInput = {
  /** Order activities. */
  activities?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ActivityInput>>>;
  /** Additional fees applied to the order. */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1AdditionalFeeInput>>>;
  /** Applied discounts. */
  appliedDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1AppliedDiscountInput>>>;
  /** Whether order is archived. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Order attribution source. */
  attributionSource?: InputMaybe<ComWixEcomOrdersV1AttributionSourceEnumAttributionSource>;
  /** Balance summary. */
  balanceSummary?: InputMaybe<ComWixEcomOrdersV1BalanceSummaryInput>;
  /** Billing address and contact details. */
  billingInfo?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
  /** Order Location */
  businessLocation?: InputMaybe<ComWixEcommercePlatformCommonApiLocationInput>;
  /** Buyer information. */
  buyerInfo?: InputMaybe<ComWixEcomOrdersV1BuyerInfoInput>;
  /**
   * Language for communication with the buyer. Defaults to the site language.
   * For a site that supports multiple languages, this is the language the buyer selected.
   */
  buyerLanguage?: InputMaybe<Scalars['String']>;
  /** [Buyer note](https://support.wix.com/en/article/wix-stores-viewing-buyer-notes) left by the customer. */
  buyerNote?: InputMaybe<Scalars['String']>;
  /** Cart ID - required by TYP OOI for legacy orders. */
  cartId?: InputMaybe<Scalars['String']>;
  /** Information about the sales channel that submitted this order. */
  channelInfo?: InputMaybe<ComWixEcomOrdersV1ChannelInfoInput>;
  /** Checkout ID. */
  checkoutId?: InputMaybe<Scalars['String']>;
  /** ID of the order's initiator. */
  createdBy?: InputMaybe<ComWixEcomOrdersV1CreatedByInput>;
  /** Date and time the order was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Currency used for the pricing of this order in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format. */
  currency?: InputMaybe<Scalars['String']>;
  /** Currency conversion details. For use with multi-currency sites. */
  currencyConversionDetails?: InputMaybe<ComWixEcomOrdersV1CurrencyConversionDetailsInput>;
  /** Custom fields. */
  customFields?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1CustomFieldInput>>>;
  /**
   * Custom field data for the order object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Order fulfillment status. */
  fulfillmentStatus?: InputMaybe<ComWixEcomOrdersV1FulfillmentStatus>;
  /** Custom string status values aggregated from every fulfillment entity associated with current order */
  fulfillmentStatusesAggregate?: InputMaybe<ComWixEcomOrdersV1FulfillmentStatusesAggregateInput>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Private API flag that allows using read-only "id" during order creation. */
  isInternalOrderCreate?: InputMaybe<Scalars['Boolean']>;
  /** Order line items. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1OrderLineItemInput>>>;
  /** Order number displayed in the site owner's dashboard (auto-generated). */
  number?: InputMaybe<Scalars['Long']>;
  /** Pay after free trial price summary. Price summary that should be paid for subscriptions after free trial period. */
  payAfterFreeTrial?: InputMaybe<ComWixEcomOrdersV1PriceSummaryInput>;
  /** Pay now price summary. Part of price_summary that must be payed at checkout */
  payNow?: InputMaybe<ComWixEcomOrdersV1PriceSummaryInput>;
  /** Order payment status. */
  paymentStatus?: InputMaybe<ComWixEcomOrdersV1PaymentStatusEnumPaymentStatus>;
  /** Order price summary. */
  priceSummary?: InputMaybe<ComWixEcomOrdersV1PriceSummaryInput>;
  /** Persistent ID that correlates between the various eCommerce elements: cart, checkout, and order. */
  purchaseFlowId?: InputMaybe<Scalars['String']>;
  /**
   * Date and time the order was originally purchased in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format.
   * Used for migration from external systems.
   */
  purchasedDate?: InputMaybe<Scalars['String']>;
  /**
   * Order recipient address and contact details.
   *
   * This field may differ from the address in `shippingInfo.logistics` when:
   * + The chosen shipping option is pickup point or store pickup.
   * + No shipping option is selected.
   */
  recipientInfo?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
  /** Whether a human has seen the order. Set when an order is clicked on in the dashboard. */
  seenByAHuman?: InputMaybe<Scalars['Boolean']>;
  /** Shipping info and selected shipping option details. */
  shippingInfo?: InputMaybe<ComWixEcomOrdersV1ShippingInformationInput>;
  /** Site language in which original values are shown. */
  siteLanguage?: InputMaybe<Scalars['String']>;
  /** Order status. */
  status?: InputMaybe<ComWixEcomOrdersV1OrderStatus>;
  /**
   * Order tags.
   *
   * [Tags](https://dev.wix.com/docs/rest/business-management/tags/introduction) are labels attached to entities, allowing for flexible categorization and data management.
   */
  tags?: InputMaybe<WixCommonTagsTagsInput>;
  /** Whether tax is included in line item prices. */
  taxIncludedInPrices?: InputMaybe<Scalars['Boolean']>;
  /** Tax information. */
  taxInfo?: InputMaybe<ComWixEcomOrdersV1OrderTaxInfoInput>;
  /** Date and time the order was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Weight measurement unit - defaults to site's weight unit. */
  weightUnit?: InputMaybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};

export type ComWixEcomOrdersV1OrderLineItem = {
  __typename?: 'ComWixEcomOrdersV1OrderLineItem';
  /**
   * References to the line item's origin catalog.
   * This field may be empty in the case of a custom line item.
   */
  catalogReference?: Maybe<ComWixEcommerceCatalogSpiApiV1CatalogReference>;
  /** Whether the line item is a custom line item. Custom line items don't trigger the Catalog service plugin. */
  customLineItem?: Maybe<Scalars['Boolean']>;
  /** The Item's Delivery Profile Id */
  deliveryProfileId?: Maybe<Scalars['String']>;
  /** Item's price amount to be charged during checkout. Relevant for items with a `paymentOption` value of `"DEPOSIT_ONLINE"`. */
  depositAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
  /** Digital file identifier, relevant only for items with type DIGITAL. */
  digitalFile?: Maybe<ComWixEcomOrdersV1DigitalFile>;
  /**
   * Custom extended fields for the line item object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /**
   * Whether the line item quantity is fixed and cannot be changed.
   *
   * Default: `false`
   */
  fixedQuantity?: Maybe<Scalars['Boolean']>;
  /**
   * Fulfiller ID. Field is empty when the line item is self-fulfilled.
   * To get fulfillment information, pass the order ID to [List Fulfillments For Single Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/order-fulfillments/list-fulfillments-for-single-order).
   */
  fulfillerId?: Maybe<Scalars['String']>;
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /** Line item image. */
  image?: Maybe<WixCommonImage>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: Maybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: Maybe<ComWixEcommerceCatalogSpiApiV1ItemType>;
  /** Total price **after** catalog discounts and line item discounts. */
  lineItemPrice?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /**
   * Line item locations.
   *
   * The location's total quantity must not exceed the line item quantity.
   */
  locations?: Maybe<Array<Maybe<ComWixEcommercePlatformCommonApiLocationAndQuantity>>>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: Maybe<Array<Maybe<ComWixEcomOrdersV1ModifierGroup>>>;
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  paymentOption?: Maybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
  /** Physical properties of the item. When relevant, contains information such as SKU and item weight. */
  physicalProperties?: Maybe<ComWixEcommerceCatalogSpiApiV1PhysicalProperties>;
  /** Line item price after line item discounts for display purposes. */
  price?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Line item price before line item discounts for display purposes. Defaults to `price` when not provided. */
  priceBeforeDiscounts?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Line item price per unit before line item discounts and before tax. */
  priceBeforeDiscountsAndTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: Maybe<ComWixEcommerceCatalogSpiApiV1PriceDescription>;
  /**
   * Whether the price is not yet defined, and will be updated after the order is created.
   *
   * Default: `false`
   */
  priceUndetermined?: Maybe<Scalars['Boolean']>;
  /**
   * Item name.
   * + Stores - `product.name`
   * + Bookings - `service.info.name`
   * + Events - `ticket.name`
   */
  productName?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  /** Line item quantity. */
  quantity?: Maybe<Scalars['Int']>;
  /** Number of items that were refunded. */
  refundQuantity?: Maybe<Scalars['Int']>;
  /** Number of items restocked. */
  restockQuantity?: Maybe<Scalars['Int']>;
  /**
   * In cases where `catalogReference.catalogItemId` is NOT the actual catalog item ID, this field will return the true item's ID.
   * + For example, for Wix Bookings, `catalogReference.catalogItemId` is the booking ID. Therefore this value is set to the service ID.
   * + In most cases, this field has the same value as `catalogReference.catalogItemId`.
   */
  rootCatalogItemId?: Maybe<Scalars['String']>;
  shippingGroupId?: Maybe<Scalars['String']>;
  /** Subscription info. */
  subscriptionInfo?: Maybe<ComWixEcomOrdersV1SubscriptionInfo>;
  /**
   * Deprecated. Use `taxInfo` instead.
   * This field will be removed on September 30, 2024.
   * Tax details for this line item.
   * @deprecated Deprecated. Use `taxInfo` instead.
   * This field will be removed on September 30, 2024.
   * Tax details for this line item. Replaced by: tax_info. Removal date: 2024-09-30.
   */
  taxDetails?: Maybe<ComWixEcomTaxApiItemTaxFullDetails>;
  /** Represents all the relevant tax details for a specific line item. */
  taxInfo?: Maybe<ComWixEcomOrdersV1LineItemTaxInfo>;
  /** Address used for tax calculation. */
  taxableAddress?: Maybe<ComWixEcommercePlatformCommonApiTaxableAddress>;
  /** Total discount for this line item's entire quantity. */
  totalDiscount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total price after all discounts and tax. */
  totalPriceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total price after discounts, and before tax. */
  totalPriceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1OrderLineItemChangedDetailsInput = {
  /**
   * References to the line item's origin catalog.
   * This field may be empty in the case of a custom line item.
   */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** Whether the line item is a custom line item. Custom line items don't trigger the Catalog service plugin. */
  customLineItem?: InputMaybe<Scalars['Boolean']>;
  /** Line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Digital file identifier, relevant only for items with type DIGITAL. */
  digitalFile?: InputMaybe<ComWixEcomOrdersV1DigitalFileInput>;
  /**
   * Fulfiller ID. Field is empty when the line item is self-fulfilled.
   * To get fulfillment information, pass this order's ID to [List Fulfillments For Single Order](https://bo.wix.com/wix-docs/rest/ecommerce/order-fulfillments/list-fulfillments-for-single-order).
   */
  fulfillerId?: InputMaybe<Scalars['String']>;
  /** Line item image. */
  image?: InputMaybe<WixCommonImageInput>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: InputMaybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemTypeInput>;
  /** Total price **after** catalog-defined discount and line item discounts. */
  lineItemPrice?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Line item locations.
   *
   * The location's total quantity must not exceed the line item quantity.
   */
  locations?: InputMaybe<Array<InputMaybe<ComWixEcommercePlatformCommonApiLocationAndQuantityInput>>>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ModifierGroupInput>>>;
  /**
   * Type of selected payment option for current item. Defaults to `FULL_PAYMENT_ONLINE`.
   * + `FULL_PAYMENT_OFFLINE` - The entire payment for this item happens after the checkout. For example, when using cash, check, or other offline payment methods.
   * + `MEMBERSHIP` - Payment for this item is done by charging a membership. When this option is used, `lineItem.price.amount` is 0.
   */
  paymentOption?: InputMaybe<ComWixEcomOrdersV1DeltaPaymentOptionType>;
  /** Physical properties of the item. When relevant, contains information such as SKU and item weight. */
  physicalProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput>;
  /** Line item price after line item discounts for display purposes. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Line item price before line item discounts for display purposes. Defaults to `price` when not provided. */
  priceBeforeDiscounts?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Line item price per unit before line item discounts and before tax. */
  priceBeforeDiscountsAndTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput>;
  /**
   * Item name.
   * + Stores - `product.name`
   * + Bookings - `service.info.name`
   * + Events - `ticket.name`
   */
  productName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /** Line item quantity. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Subscription info. */
  subscriptionInfo?: InputMaybe<ComWixEcomOrdersV1SubscriptionInfoInput>;
  /** Represents all the relevant tax details for a specific line item. */
  taxInfo?: InputMaybe<ComWixEcomOrdersV1LineItemTaxInfoInput>;
  /** Total discount for this line item's entire quantity. */
  totalDiscount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price after all discounts and tax. */
  totalPriceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price after all discounts excluding tax. */
  totalPriceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1OrderLineItemInput = {
  /**
   * References to the line item's origin catalog.
   * This field may be empty in the case of a custom line item.
   */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** Whether the line item is a custom line item. Custom line items don't trigger the Catalog service plugin. */
  customLineItem?: InputMaybe<Scalars['Boolean']>;
  /** The Item's Delivery Profile Id */
  deliveryProfileId?: InputMaybe<Scalars['String']>;
  /** Item's price amount to be charged during checkout. Relevant for items with a `paymentOption` value of `"DEPOSIT_ONLINE"`. */
  depositAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Digital file identifier, relevant only for items with type DIGITAL. */
  digitalFile?: InputMaybe<ComWixEcomOrdersV1DigitalFileInput>;
  /**
   * Custom extended fields for the line item object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /**
   * Whether the line item quantity is fixed and cannot be changed.
   *
   * Default: `false`
   */
  fixedQuantity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Fulfiller ID. Field is empty when the line item is self-fulfilled.
   * To get fulfillment information, pass the order ID to [List Fulfillments For Single Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/order-fulfillments/list-fulfillments-for-single-order).
   */
  fulfillerId?: InputMaybe<Scalars['String']>;
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item image. */
  image?: InputMaybe<WixCommonImageInput>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: InputMaybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemTypeInput>;
  /** Total price **after** catalog discounts and line item discounts. */
  lineItemPrice?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Line item locations.
   *
   * The location's total quantity must not exceed the line item quantity.
   */
  locations?: InputMaybe<Array<InputMaybe<ComWixEcommercePlatformCommonApiLocationAndQuantityInput>>>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ModifierGroupInput>>>;
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  paymentOption?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
  /** Physical properties of the item. When relevant, contains information such as SKU and item weight. */
  physicalProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput>;
  /** Line item price after line item discounts for display purposes. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Line item price before line item discounts for display purposes. Defaults to `price` when not provided. */
  priceBeforeDiscounts?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Line item price per unit before line item discounts and before tax. */
  priceBeforeDiscountsAndTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput>;
  /**
   * Whether the price is not yet defined, and will be updated after the order is created.
   *
   * Default: `false`
   */
  priceUndetermined?: InputMaybe<Scalars['Boolean']>;
  /**
   * Item name.
   * + Stores - `product.name`
   * + Bookings - `service.info.name`
   * + Events - `ticket.name`
   */
  productName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /** Line item quantity. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Number of items that were refunded. */
  refundQuantity?: InputMaybe<Scalars['Int']>;
  /** Number of items restocked. */
  restockQuantity?: InputMaybe<Scalars['Int']>;
  /**
   * In cases where `catalogReference.catalogItemId` is NOT the actual catalog item ID, this field will return the true item's ID.
   * + For example, for Wix Bookings, `catalogReference.catalogItemId` is the booking ID. Therefore this value is set to the service ID.
   * + In most cases, this field has the same value as `catalogReference.catalogItemId`.
   */
  rootCatalogItemId?: InputMaybe<Scalars['String']>;
  shippingGroupId?: InputMaybe<Scalars['String']>;
  /** Subscription info. */
  subscriptionInfo?: InputMaybe<ComWixEcomOrdersV1SubscriptionInfoInput>;
  /** Represents all the relevant tax details for a specific line item. */
  taxInfo?: InputMaybe<ComWixEcomOrdersV1LineItemTaxInfoInput>;
  /** Address used for tax calculation. */
  taxableAddress?: InputMaybe<ComWixEcommercePlatformCommonApiTaxableAddressInput>;
  /** Total discount for this line item's entire quantity. */
  totalDiscount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price after all discounts and tax. */
  totalPriceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price after discounts, and before tax. */
  totalPriceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1OrderRefunded = {
  __typename?: 'ComWixEcomOrdersV1OrderRefunded';
  /** Refund amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Whether order was refunded manually. For example, via payment provider or using cash. */
  manual?: Maybe<Scalars['Boolean']>;
  /** Reason for refund. */
  reason?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderRefundedInput = {
  /** Refund amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Whether order was refunded manually. For example, via payment provider or using cash. */
  manual?: InputMaybe<Scalars['Boolean']>;
  /** Reason for refund. */
  reason?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderReindexRequestInput = {
  eventTime?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomOrdersV1OrderStatus {
  /**
   * Order approved.
   *
   * This happens when either an online payment is received **or** when `order.priceSummary.total = 0` (a zero-total order).
   * Offline orders (cash payment) are automatically approved.
   */
  Approved = 'APPROVED',
  /** Order canceled by the user. */
  Canceled = 'CANCELED',
  /** Order created, but not yet approved or canceled. */
  Initialized = 'INITIALIZED',
  /** Order pending. */
  Pending = 'PENDING',
  /**
   * Order rejected.
   *
   * This happens when pending payments fail.
   */
  Rejected = 'REJECTED'
}

export type ComWixEcomOrdersV1OrderTaxBreakdown = {
  __typename?: 'ComWixEcomOrdersV1OrderTaxBreakdown';
  /** The sum of all the tax from line items that calculated by the tax identifiers. */
  aggregatedTaxAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The sum of all the taxable amount from line items for tax identifiers. */
  aggregatedTaxableAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The name of the jurisdiction in which this tax detail applies. */
  jurisdiction?: Maybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies (e.g. Country,State,County,City,Special). */
  jurisdictionType?: Maybe<ComWixEcomOrdersV1JurisdictionType>;
  /** The rate at which this tax detail was calculated. */
  rate?: Maybe<Scalars['String']>;
  /** The name of the tax against which this tax amount was calculated. */
  taxName?: Maybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the company's nexus settings as well as the jurisdiction's tax laws. */
  taxType?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderTaxBreakdownInput = {
  /** The sum of all the tax from line items that calculated by the tax identifiers. */
  aggregatedTaxAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** The sum of all the taxable amount from line items for tax identifiers. */
  aggregatedTaxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** The name of the jurisdiction in which this tax detail applies. */
  jurisdiction?: InputMaybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies (e.g. Country,State,County,City,Special). */
  jurisdictionType?: InputMaybe<ComWixEcomOrdersV1JurisdictionType>;
  /** The rate at which this tax detail was calculated. */
  rate?: InputMaybe<Scalars['String']>;
  /** The name of the tax against which this tax amount was calculated. */
  taxName?: InputMaybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the company's nexus settings as well as the jurisdiction's tax laws. */
  taxType?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderTaxInfo = {
  __typename?: 'ComWixEcomOrdersV1OrderTaxInfo';
  /** Manual tax rate */
  manualTaxRate?: Maybe<Scalars['String']>;
  /** The summary of the tax breakdown for all the line items. It will hold for each tax name, the aggregated tax amount paid for it and the tax rate. */
  taxBreakdown?: Maybe<Array<Maybe<ComWixEcomOrdersV1OrderTaxBreakdown>>>;
  /**
   * Whether the order is exempt from tax calculations.
   *
   * Default: `false`
   */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** Calculated tax, added from line items. */
  totalTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1OrderTaxInfoInput = {
  /** Manual tax rate */
  manualTaxRate?: InputMaybe<Scalars['String']>;
  /** The summary of the tax breakdown for all the line items. It will hold for each tax name, the aggregated tax amount paid for it and the tax rate. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1OrderTaxBreakdownInput>>>;
  /**
   * Whether the order is exempt from tax calculations.
   *
   * Default: `false`
   */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** Calculated tax, added from line items. */
  totalTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1PaymentCanceled = {
  __typename?: 'ComWixEcomOrdersV1PaymentCanceled';
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
  /** Regular payment. */
  regular?: Maybe<ComWixEcomOrdersV1RegularPayment>;
};

export type ComWixEcomOrdersV1PaymentCanceledInput = {
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Regular payment. */
  regular?: InputMaybe<ComWixEcomOrdersV1RegularPaymentInput>;
};

export type ComWixEcomOrdersV1PaymentDeclined = {
  __typename?: 'ComWixEcomOrdersV1PaymentDeclined';
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
  /** Regular payment. */
  regular?: Maybe<ComWixEcomOrdersV1RegularPayment>;
};

export type ComWixEcomOrdersV1PaymentDeclinedInput = {
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Regular payment. */
  regular?: InputMaybe<ComWixEcomOrdersV1RegularPaymentInput>;
};

export type ComWixEcomOrdersV1PaymentPending = {
  __typename?: 'ComWixEcomOrdersV1PaymentPending';
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
  /** Regular payment. */
  regular?: Maybe<ComWixEcomOrdersV1RegularPayment>;
};

export type ComWixEcomOrdersV1PaymentPendingInput = {
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Regular payment. */
  regular?: InputMaybe<ComWixEcomOrdersV1RegularPaymentInput>;
};

export type ComWixEcomOrdersV1PaymentRefundFailed = {
  __typename?: 'ComWixEcomOrdersV1PaymentRefundFailed';
  /** Details about the failed payment refund. */
  payment?: Maybe<ComWixEcomOrdersV1RefundedPayment>;
  /** Refund ID. */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1PaymentRefundFailedInput = {
  /** Details about the failed payment refund. */
  payment?: InputMaybe<ComWixEcomOrdersV1RefundedPaymentInput>;
  /** Refund ID. */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1PaymentRefunded = {
  __typename?: 'ComWixEcomOrdersV1PaymentRefunded';
  /** Details about the refunded payment. */
  payment?: Maybe<ComWixEcomOrdersV1RefundedPayment>;
  /** Refund ID. */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1PaymentRefundedInput = {
  /** Details about the refunded payment. */
  payment?: InputMaybe<ComWixEcomOrdersV1RefundedPaymentInput>;
  /** Refund ID. */
  refundId?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomOrdersV1PaymentStatusEnumPaymentStatus {
  /** One or more payments canceled. */
  Canceled = 'CANCELED',
  /** One or more payments declined. */
  Declined = 'DECLINED',
  /** Order fully refunded. Refund amount equals total price. See `order.balanceSummary` for more details. */
  FullyRefunded = 'FULLY_REFUNDED',
  /**
   * `NOT_PAID` can apply to an order made online, but not yet paid. In such cases `order.status` will be `INITIALIZED`.
   * This status also applies when an offline order needs to be manually marked as paid. In such cases `order.status` will be `APPROVED`.
   */
  NotPaid = 'NOT_PAID',
  /** All required payments associated with this order are paid. */
  Paid = 'PAID',
  /** At least one payment received and approved, but it covers less than the order's total price. See `order.balanceSummary` for more details. */
  PartiallyPaid = 'PARTIALLY_PAID',
  /** Order partially refunded, but the refunded amount is less than the order's total price. See `order.balanceSummary` for more details. */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /**
   * All payments pending.
   *
   * This can happen with two-step payments, when a payment requires manual review, or when a payment is in progress and will be concluded shortly.
   * Learn more about [pending orders](https://support.wix.com/en/article/pending-orders).
   */
  Pending = 'PENDING',
  /**
   * Payment received, but not yet confirmed by the payment provider.
   *
   * In most cases, when a payment provider is holding payment it's because setup hasn't been successfully completed by the merchant/site owner.
   * To solve this, the merchant/site owner should log in to the payment provider's dashboard and make sure their account is set up correctly, or contact their support for further assistance.
   */
  PendingMerchant = 'PENDING_MERCHANT',
  Unspecified = 'UNSPECIFIED'
}

export type ComWixEcomOrdersV1PaymentStatusUpdatedInput = {
  /** The order that was updated */
  order?: InputMaybe<ComWixEcomOrdersV1OrderInput>;
  /** The previous status (before the update) */
  previousPaymentStatus?: InputMaybe<ComWixEcomOrdersV1PaymentStatusEnumPaymentStatus>;
};

export type ComWixEcomOrdersV1PickupDetails = {
  __typename?: 'ComWixEcomOrdersV1PickupDetails';
  /** Pickup address. */
  address?: Maybe<ComWixEcommercePlatformCommonApiPickupAddress>;
  /** Pickup method */
  pickupMethod?: Maybe<ComWixEcomOrdersV1PickupDetailsPickupMethod>;
};

export type ComWixEcomOrdersV1PickupDetailsInput = {
  /** Pickup address. */
  address?: InputMaybe<ComWixEcommercePlatformCommonApiPickupAddressInput>;
  /** Pickup method */
  pickupMethod?: InputMaybe<ComWixEcomOrdersV1PickupDetailsPickupMethod>;
};

export enum ComWixEcomOrdersV1PickupDetailsPickupMethod {
  PickupPoint = 'PICKUP_POINT',
  StorePickup = 'STORE_PICKUP',
  UnknownMethod = 'UNKNOWN_METHOD'
}

export type ComWixEcomOrdersV1PriceSummary = {
  __typename?: 'ComWixEcomOrdersV1PriceSummary';
  /** Total calculated discount value. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total shipping price, before discounts and before tax. */
  shipping?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Subtotal of all the line items, before discounts and before tax. */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total tax on this order. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Order’s total price after discounts and tax. */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total price of additional fees before tax. */
  totalAdditionalFees?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Deprecated - use `total` instead. */
  totalPrice?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Order's total price including gift card. */
  totalWithGiftCard?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Order's total price after without gift card. */
  totalWithoutGiftCard?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1PriceSummaryInput = {
  /** Total calculated discount value. */
  discount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total shipping price, before discounts and before tax. */
  shipping?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Subtotal of all the line items, before discounts and before tax. */
  subtotal?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total tax on this order. */
  tax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order’s total price after discounts and tax. */
  total?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price of additional fees before tax. */
  totalAdditionalFees?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Deprecated - use `total` instead. */
  totalPrice?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order's total price including gift card. */
  totalWithGiftCard?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order's total price after without gift card. */
  totalWithoutGiftCard?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1PublicActivityInput = {
  /** Custom activity details. */
  customActivity?: InputMaybe<ComWixEcomOrdersV1CustomActivityInput>;
  /** Merchant commment. */
  merchantComment?: InputMaybe<ComWixEcomOrdersV1MerchantCommentInput>;
};

export type ComWixEcomOrdersV1QueryOrderRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type ComWixEcomOrdersV1QueryOrderResponse = {
  __typename?: 'ComWixEcomOrdersV1QueryOrderResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixEcomOrdersV1ReceiptCreated = {
  __typename?: 'ComWixEcomOrdersV1ReceiptCreated';
  /** Receipt created by an external system. */
  externalReceipt?: Maybe<ComWixEcomOrdersV1ExternalReceipt>;
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: Maybe<ComWixEcomOrdersV1WixReceipt>;
};

export type ComWixEcomOrdersV1ReceiptCreatedInput = {
  /** Receipt created by an external system. */
  externalReceipt?: InputMaybe<ComWixEcomOrdersV1ExternalReceiptInput>;
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: InputMaybe<ComWixEcomOrdersV1WixReceiptInput>;
};

export type ComWixEcomOrdersV1ReceiptSent = {
  __typename?: 'ComWixEcomOrdersV1ReceiptSent';
  /** Receipt created by an external system. */
  externalReceipt?: Maybe<ComWixEcomOrdersV1ExternalReceipt>;
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: Maybe<ComWixEcomOrdersV1WixReceipt>;
};

export type ComWixEcomOrdersV1ReceiptSentInput = {
  /** Receipt created by an external system. */
  externalReceipt?: InputMaybe<ComWixEcomOrdersV1ExternalReceiptInput>;
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: InputMaybe<ComWixEcomOrdersV1WixReceiptInput>;
};

export type ComWixEcomOrdersV1RefundInitiated = {
  __typename?: 'ComWixEcomOrdersV1RefundInitiated';
  /** Refund amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Details about the payments being refunded. */
  payments?: Maybe<Array<Maybe<ComWixEcomOrdersV1RefundedPayment>>>;
  /** Reason for refund. */
  reason?: Maybe<Scalars['String']>;
  /** Refund ID. */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1RefundInitiatedInput = {
  /** Refund amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Details about the payments being refunded. */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1RefundedPaymentInput>>>;
  /** Reason for refund. */
  reason?: InputMaybe<Scalars['String']>;
  /** Refund ID. */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1RefundedAsStoreCredit = {
  __typename?: 'ComWixEcomOrdersV1RefundedAsStoreCredit';
  /** Refund amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Reason for refund */
  reason?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1RefundedAsStoreCreditInput = {
  /** Refund amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Reason for refund */
  reason?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1RefundedPayment = {
  __typename?: 'ComWixEcomOrdersV1RefundedPayment';
  /** Whether refund was made externally and manually on the payment provider's side. */
  externalRefund?: Maybe<Scalars['Boolean']>;
  /** Gift card payment refund. */
  giftCard?: Maybe<ComWixEcomOrdersV1GiftCardPaymentRefund>;
  /** Membership payment refund. */
  membership?: Maybe<ComWixEcomOrdersV1MembershipPaymentRefund>;
  /** Payment ID. */
  paymentId?: Maybe<Scalars['String']>;
  /** Regular payment refund. */
  regular?: Maybe<ComWixEcomOrdersV1RegularPaymentRefund>;
};

export type ComWixEcomOrdersV1RefundedPaymentInput = {
  /** Whether refund was made externally and manually on the payment provider's side. */
  externalRefund?: InputMaybe<Scalars['Boolean']>;
  /** Gift card payment refund. */
  giftCard?: InputMaybe<ComWixEcomOrdersV1GiftCardPaymentRefundInput>;
  /** Membership payment refund. */
  membership?: InputMaybe<ComWixEcomOrdersV1MembershipPaymentRefundInput>;
  /** Payment ID. */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Regular payment refund. */
  regular?: InputMaybe<ComWixEcomOrdersV1RegularPaymentRefundInput>;
};

export type ComWixEcomOrdersV1RegularPayment = {
  __typename?: 'ComWixEcomOrdersV1RegularPayment';
  /** Payment amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Whether regular card used */
  creditCardDetails?: Maybe<ComWixEcomOrdersV1CreditCardDetails>;
};

export type ComWixEcomOrdersV1RegularPaymentInput = {
  /** Payment amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Whether regular card used */
  creditCardDetails?: InputMaybe<ComWixEcomOrdersV1CreditCardDetailsInput>;
};

export type ComWixEcomOrdersV1RegularPaymentRefund = {
  __typename?: 'ComWixEcomOrdersV1RegularPaymentRefund';
  /** Refund amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1RegularPaymentRefundInput = {
  /** Refund amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SavedPaymentMethod = {
  __typename?: 'ComWixEcomOrdersV1SavedPaymentMethod';
  /** Payment method description */
  description?: Maybe<Scalars['String']>;
  /** Payment method name */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SavedPaymentMethodInput = {
  /** Payment method description */
  description?: InputMaybe<Scalars['String']>;
  /** Payment method name */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SearchOrdersRequestInput = {
  /** Search options. */
  search?: InputMaybe<ComWixEcomOrdersV1UpstreamWixQueryCursorSearchInput>;
};

export type ComWixEcomOrdersV1SearchOrdersResponse = {
  __typename?: 'ComWixEcomOrdersV1SearchOrdersResponse';
  /** Details on the paged set of results returned. */
  metadata?: Maybe<WixCommonCursorPagingMetadata>;
  /** List of orders. */
  orders?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
};

export type ComWixEcomOrdersV1ShippingInformation = {
  __typename?: 'ComWixEcomOrdersV1ShippingInformation';
  /** App Def Id of external provider which was a source of shipping info */
  carrierId?: Maybe<Scalars['String']>;
  /** Unique code (or ID) of selected shipping option. For example, `"usps_std_overnight"`. */
  code?: Maybe<Scalars['String']>;
  /** Shipping costs. */
  cost?: Maybe<ComWixEcomOrdersV1ShippingPrice>;
  /** Shipping logistics. */
  logistics?: Maybe<ComWixEcomOrdersV1DeliveryLogistics>;
  /** Shipping region. */
  region?: Maybe<ComWixEcomOrdersV1ShippingRegion>;
  /**
   * Shipping option title.
   * For example, `"USPS Standard Overnight Delivery"`, `"Standard"` or `"First-Class Package International"`.
   */
  title?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ShippingInformationInput = {
  /** App Def Id of external provider which was a source of shipping info */
  carrierId?: InputMaybe<Scalars['String']>;
  /** Unique code (or ID) of selected shipping option. For example, `"usps_std_overnight"`. */
  code?: InputMaybe<Scalars['String']>;
  /** Shipping costs. */
  cost?: InputMaybe<ComWixEcomOrdersV1ShippingPriceInput>;
  /** Shipping logistics. */
  logistics?: InputMaybe<ComWixEcomOrdersV1DeliveryLogisticsInput>;
  /** Shipping region. */
  region?: InputMaybe<ComWixEcomOrdersV1ShippingRegionInput>;
  /**
   * Shipping option title.
   * For example, `"USPS Standard Overnight Delivery"`, `"Standard"` or `"First-Class Package International"`.
   */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ShippingPrice = {
  __typename?: 'ComWixEcomOrdersV1ShippingPrice';
  /** Shipping discount before tax. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Shipping price for display purposes. */
  price?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax details. */
  taxDetails?: Maybe<ComWixEcomTaxApiItemTaxFullDetails>;
  /** Shipping price after all discounts (if any exist), and after tax. */
  totalPriceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total price of shipping after discounts (when relevant), and before tax. */
  totalPriceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1ShippingPriceInput = {
  /** Shipping discount before tax. */
  discount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Shipping price for display purposes. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Tax details. */
  taxDetails?: InputMaybe<ComWixEcomTaxApiItemTaxFullDetailsInput>;
  /** Shipping price after all discounts (if any exist), and after tax. */
  totalPriceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price of shipping after discounts (when relevant), and before tax. */
  totalPriceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1ShippingRegion = {
  __typename?: 'ComWixEcomOrdersV1ShippingRegion';
  /** Name of shipping region. For example, `"Metropolitan London"`, or `"Outer Melbourne suburbs"`. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ShippingRegionInput = {
  /** Name of shipping region. For example, `"Metropolitan London"`, or `"Outer Melbourne suburbs"`. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionDescription = {
  __typename?: 'ComWixEcomOrdersV1SubscriptionDescription';
  /** Subscription option description. */
  original?: Maybe<Scalars['String']>;
  /** Translated subscription option description. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionDescriptionInput = {
  /** Subscription option description. */
  original?: InputMaybe<Scalars['String']>;
  /** Translated subscription option description. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionInfo = {
  __typename?: 'ComWixEcomOrdersV1SubscriptionInfo';
  /** Details of the billing adjustment applied to the current subscription cycle due to a shift in the subscription’s billing date. */
  billingAdjustment?: Maybe<ComWixEcomOrdersV1BillingAdjustment>;
  /** Description of the charges that will be applied for subscription. */
  chargesDescription?: Maybe<Scalars['String']>;
  /** Subscription cycle. For example, if this order is for the 3rd cycle of a subscription, value will be `3`. */
  cycleNumber?: Maybe<Scalars['Int']>;
  /** Subscription description. For example, `"1kg of selected coffee, once a month"`. */
  description?: Maybe<ComWixEcomOrdersV1SubscriptionDescription>;
  /** Subscription ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Subscription option description. For example, `"1kg of selected coffee, once a month"`.
   * @deprecated Subscription option description. For example, `"1kg of selected coffee, once a month"`. Replaced by: description. Removal date: 2025-10-01.
   */
  subscriptionOptionDescription?: Maybe<Scalars['String']>;
  /**
   * Subscription option title. For example, `"Monthly coffee Subscription"`.
   * @deprecated Subscription option title. For example, `"Monthly coffee Subscription"`. Replaced by: title. Removal date: 2025-10-01.
   */
  subscriptionOptionTitle?: Maybe<Scalars['String']>;
  /** Subscription detailed information. */
  subscriptionSettings?: Maybe<ComWixEcomOrdersV1SubscriptionSettings>;
  /** Subscription title. For example, `"Monthly coffee Subscription"`. */
  title?: Maybe<ComWixEcomOrdersV1SubscriptionTitle>;
};

export type ComWixEcomOrdersV1SubscriptionInfoInput = {
  /** Details of the billing adjustment applied to the current subscription cycle due to a shift in the subscription’s billing date. */
  billingAdjustment?: InputMaybe<ComWixEcomOrdersV1BillingAdjustmentInput>;
  /** Description of the charges that will be applied for subscription. */
  chargesDescription?: InputMaybe<Scalars['String']>;
  /** Subscription cycle. For example, if this order is for the 3rd cycle of a subscription, value will be `3`. */
  cycleNumber?: InputMaybe<Scalars['Int']>;
  /** Subscription description. For example, `"1kg of selected coffee, once a month"`. */
  description?: InputMaybe<ComWixEcomOrdersV1SubscriptionDescriptionInput>;
  /** Subscription ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Subscription detailed information. */
  subscriptionSettings?: InputMaybe<ComWixEcomOrdersV1SubscriptionSettingsInput>;
  /** Subscription title. For example, `"Monthly coffee Subscription"`. */
  title?: InputMaybe<ComWixEcomOrdersV1SubscriptionTitleInput>;
};

export type ComWixEcomOrdersV1SubscriptionSettings = {
  __typename?: 'ComWixEcomOrdersV1SubscriptionSettings';
  /** Whether subscription is renewed automatically at the end of each period. */
  autoRenewal?: Maybe<Scalars['Boolean']>;
  /** Number of billing cycles before subscription ends. Ignored if `autoRenewal: true`. */
  billingCycles?: Maybe<Scalars['Int']>;
  /** Whether to allow the customer to cancel the subscription. */
  enableCustomerCancellation?: Maybe<Scalars['Boolean']>;
  /** Period until first cycle starts. If None => no free trial */
  freeTrialPeriod?: Maybe<ComWixEcomOrdersV1FreeTrialPeriod>;
  /** Frequency of recurring payment. */
  frequency?: Maybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** Interval of recurring payment. */
  interval?: Maybe<Scalars['Int']>;
  /** The date the subscription will start. The subscription will be charged either now or according to freeTrialDays. */
  startDate?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionSettingsInput = {
  /** Whether subscription is renewed automatically at the end of each period. */
  autoRenewal?: InputMaybe<Scalars['Boolean']>;
  /** Number of billing cycles before subscription ends. Ignored if `autoRenewal: true`. */
  billingCycles?: InputMaybe<Scalars['Int']>;
  /** Whether to allow the customer to cancel the subscription. */
  enableCustomerCancellation?: InputMaybe<Scalars['Boolean']>;
  /** Period until first cycle starts. If None => no free trial */
  freeTrialPeriod?: InputMaybe<ComWixEcomOrdersV1FreeTrialPeriodInput>;
  /** Frequency of recurring payment. */
  frequency?: InputMaybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** Interval of recurring payment. */
  interval?: InputMaybe<Scalars['Int']>;
  /** The date the subscription will start. The subscription will be charged either now or according to freeTrialDays. */
  startDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionTitle = {
  __typename?: 'ComWixEcomOrdersV1SubscriptionTitle';
  /** Subscription option name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Subscription option name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionTitleInput = {
  /** Subscription option name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Subscription option name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1TranslatedValue = {
  __typename?: 'ComWixEcomOrdersV1TranslatedValue';
  /** Value in site default language. */
  original?: Maybe<Scalars['String']>;
  /** Translated value. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1TranslatedValueInput = {
  /** Value in site default language. */
  original?: InputMaybe<Scalars['String']>;
  /** Translated value. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UnArchiveOrderRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UnArchiveOrderResponse = {
  __typename?: 'ComWixEcomOrdersV1UnArchiveOrderResponse';
  /** Unarchived order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateActivityRequestInput = {
  /** Activity info. */
  activity?: InputMaybe<ComWixEcomOrdersV1PublicActivityInput>;
  /** ID of the activity to update. */
  activityId?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UpdateActivityResponse = {
  __typename?: 'ComWixEcomOrdersV1UpdateActivityResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateBillingContactDetailsRequestInput = {
  /** Contact details. */
  addressContactDetails?: InputMaybe<ComWixEcommercePlatformCommonApiFullAddressContactDetailsInput>;
  /** mask of contact details fields to update */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UpdateBillingContactDetailsResponse = {
  __typename?: 'ComWixEcomOrdersV1UpdateBillingContactDetailsResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateBuyerEmailRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UpdateBuyerEmailResponse = {
  __typename?: 'ComWixEcomOrdersV1UpdateBuyerEmailResponse';
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateBuyerInfoRequestInput = {
  /** Buyer info. */
  buyerInfo?: InputMaybe<ComWixEcomOrdersV1BuyerInfoUpdateInput>;
  /** Field mask of buyerInfo fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UpdateBuyerInfoResponse = {
  __typename?: 'ComWixEcomOrdersV1UpdateBuyerInfoResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateLineItemsDescriptionLinesRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line items. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1LineItemUpdateInput>>>;
};

export type ComWixEcomOrdersV1UpdateLineItemsDescriptionLinesResponse = {
  __typename?: 'ComWixEcomOrdersV1UpdateLineItemsDescriptionLinesResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateOrderLineItemRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID */
  id?: InputMaybe<Scalars['String']>;
  /** Order line item to update */
  lineItem?: InputMaybe<ComWixEcomOrdersV1OrderLineItemInput>;
};

export type ComWixEcomOrdersV1UpdateOrderLineItemResponse = {
  __typename?: 'ComWixEcomOrdersV1UpdateOrderLineItemResponse';
  /** Updated order data */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateOrderLineItemsRequestInput = {
  /** Order line items to update */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1MaskedOrderLineItemInput>>>;
  /** Order ID */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UpdateOrderLineItemsResponse = {
  __typename?: 'ComWixEcomOrdersV1UpdateOrderLineItemsResponse';
  /** Updated order data */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateOrderRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order to be updated. */
  order?: InputMaybe<ComWixEcomOrdersV1OrderInput>;
};

export type ComWixEcomOrdersV1UpdateOrderResponse = {
  __typename?: 'ComWixEcomOrdersV1UpdateOrderResponse';
  /** Newly created order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateOrderShippingAddressRequestInput = {
  /** mask of shipping address fields to update */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Shipping address and contact details to be updated. */
  shippingAddress?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
};

export type ComWixEcomOrdersV1UpdateOrderShippingAddressResponse = {
  __typename?: 'ComWixEcomOrdersV1UpdateOrderShippingAddressResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateOrderStatusRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** New order status. */
  status?: InputMaybe<ComWixEcomOrdersV1OrderStatus>;
};

export type ComWixEcomOrdersV1UpdateOrderStatusResponse = {
  __typename?: 'ComWixEcomOrdersV1UpdateOrderStatusResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpstreamWixQueryCursorSearchInput = {
  /**
   * Cursor paging options.
   *
   * Learn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).
   */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about [filtering](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * List of sort objects.
   *
   * Learn more about [sorting](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixEcomOrdersV1WixReceipt = {
  __typename?: 'ComWixEcomOrdersV1WixReceipt';
  /** Display number of receipt */
  displayNumber?: Maybe<Scalars['String']>;
  /** Receipt ID */
  receipt?: Maybe<WixReceiptsV1Receipt>;
  /** Receipt ID */
  receiptId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1WixReceiptInput = {
  /** Display number of receipt */
  displayNumber?: InputMaybe<Scalars['String']>;
  /** Receipt ID */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTaxApiAutoTaxFallbackCalculationDetails = {
  __typename?: 'ComWixEcomTaxApiAutoTaxFallbackCalculationDetails';
  /** invalid request (i.e. address), timeout, internal error, license error, and others will be encoded here */
  error?: Maybe<WixApiApplicationError>;
  /** reason for fallback */
  fallbackReason?: Maybe<ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason>;
};

export enum ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason {
  /** auto-tax was temporarily deactivated on a system-level */
  AutoTaxDeactivated = 'AUTO_TAX_DEACTIVATED',
  /** auto-tax failed to be calculated */
  AutoTaxFailed = 'AUTO_TAX_FAILED'
}

export type ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsInput = {
  /** invalid request (i.e. address), timeout, internal error, license error, and others will be encoded here */
  error?: InputMaybe<WixApiApplicationErrorInput>;
  /** reason for fallback */
  fallbackReason?: InputMaybe<ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason>;
};

export type ComWixEcomTaxApiItemTaxFullDetails = {
  __typename?: 'ComWixEcomTaxApiItemTaxFullDetails';
  /** ID of the item's tax group, if specified. */
  taxGroupId?: Maybe<Scalars['String']>;
  /** Tax rate percentage, as a decimal numeral between 0 and 1. For example, `"0.13"`. */
  taxRate?: Maybe<Scalars['String']>;
  /** Taxable amount of this line item. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The calculated tax, based on the `taxableAmount` and `taxRate`. */
  totalTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomTaxApiItemTaxFullDetailsInput = {
  /** ID of the item's tax group, if specified. */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /** Tax rate percentage, as a decimal numeral between 0 and 1. For example, `"0.13"`. */
  taxRate?: InputMaybe<Scalars['String']>;
  /** Taxable amount of this line item. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** The calculated tax, based on the `taxableAmount` and `taxRate`. */
  totalTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export enum ComWixEcomTaxApiManualCalculationReason {
  /** user set calculator in Business Manager to be Manual */
  GlobalSettingToManual = 'GLOBAL_SETTING_TO_MANUAL',
  /** specific region is on manual even though Global setting is Auto-tax */
  RegionSettingToManual = 'REGION_SETTING_TO_MANUAL'
}

export enum ComWixEcomTaxApiRateType {
  /** autotax rate used for calculation */
  AutoRate = 'AUTO_RATE',
  /** fallback rate used for calculation */
  FallbackRate = 'FALLBACK_RATE',
  /** manual rate used for calculation */
  ManualRate = 'MANUAL_RATE',
  /** no tax being collected for this request due to location of purchase */
  NoTaxCollected = 'NO_TAX_COLLECTED'
}

export type ComWixEcomTaxApiTaxCalculationDetails = {
  __typename?: 'ComWixEcomTaxApiTaxCalculationDetails';
  /** Details of the fallback rate calculation. */
  autoTaxFallbackDetails?: Maybe<ComWixEcomTaxApiAutoTaxFallbackCalculationDetails>;
  /** Reason the manual calculation was used. */
  manualRateReason?: Maybe<ComWixEcomTaxApiManualCalculationReason>;
  /** Rate calculation type. */
  rateType?: Maybe<ComWixEcomTaxApiRateType>;
};

export type ComWixEcomTaxApiTaxCalculationDetailsInput = {
  /** Details of the fallback rate calculation. */
  autoTaxFallbackDetails?: InputMaybe<ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsInput>;
  /** Reason the manual calculation was used. */
  manualRateReason?: InputMaybe<ComWixEcomTaxApiManualCalculationReason>;
  /** Rate calculation type. */
  rateType?: InputMaybe<ComWixEcomTaxApiRateType>;
};

export type ComWixEcomTaxApiTaxSummary = {
  __typename?: 'ComWixEcomTaxApiTaxSummary';
  /** manual tax rate */
  manualTaxRate?: Maybe<Scalars['String']>;
  /** Total tax. */
  totalTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomTaxApiTaxSummaryInput = {
  /** manual tax rate */
  manualTaxRate?: InputMaybe<Scalars['String']>;
  /** Total tax. */
  totalTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1AdditionalFee = {
  __typename?: 'ComWixEcomTotalsCalculatorV1AdditionalFee';
  /** Additional fee's unique code (or ID) for future processing. */
  code?: Maybe<Scalars['String']>;
  /**
   * Optional - Line items associated with this additional fee.
   * If no `lineItemIds` are provided, the fee will be associated with the whole cart/checkout/order.
   */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Translated additional fee's name. */
  name?: Maybe<Scalars['String']>;
  /** Additional fee's price. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Additional fee's price after tax. */
  priceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Additional fee's price before tax. */
  priceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Provider's app id. */
  providerAppId?: Maybe<Scalars['String']>;
  /** the source the additional fee was added from */
  source?: Maybe<ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource>;
  /**
   * Number of subscription cycle this fee applies to
   * default None - all billing cycle
   */
  subscriptionCycles?: Maybe<Scalars['Int']>;
  /** Tax details. */
  taxDetails?: Maybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetails>;
  /** The translated name of the additional fee. The translation language is determined by the `languages` field in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  translatedName?: Maybe<Scalars['String']>;
};

export enum ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource {
  /** The additional fee was added on the item either via the catalog or on custom line item */
  Item = 'ITEM',
  /** The additional fee was added manually on the request */
  Manual = 'MANUAL',
  /** The additional fee was added by an additional fee service plugin */
  ServicePlugin = 'SERVICE_PLUGIN',
  /** The additional fee was added by the shipping provider */
  Shipping = 'SHIPPING',
  UnknownAdditionalFeeSource = 'UNKNOWN_ADDITIONAL_FEE_SOURCE'
}

export type ComWixEcomTotalsCalculatorV1AdditionalFeeInput = {
  /** Additional fee's unique code (or ID) for future processing. */
  code?: InputMaybe<Scalars['String']>;
  /**
   * Optional - Line items associated with this additional fee.
   * If no `lineItemIds` are provided, the fee will be associated with the whole cart/checkout/order.
   */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Translated additional fee's name. */
  name?: InputMaybe<Scalars['String']>;
  /** Additional fee's price. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Additional fee's price after tax. */
  priceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Additional fee's price before tax. */
  priceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Provider's app id. */
  providerAppId?: InputMaybe<Scalars['String']>;
  /** the source the additional fee was added from */
  source?: InputMaybe<ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource>;
  /**
   * Number of subscription cycle this fee applies to
   * default None - all billing cycle
   */
  subscriptionCycles?: InputMaybe<Scalars['Int']>;
  /** Tax details. */
  taxDetails?: InputMaybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput>;
  /** The translated name of the additional fee. The translation language is determined by the `languages` field in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  translatedName?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown = {
  __typename?: 'ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown';
  /** The sum of all the tax from line items that calculated by the tax identifiers. */
  aggregatedTaxAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The sum of all the taxable amount from line items for tax identifiers. */
  aggregatedTaxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The name of the jurisdiction in which this tax detail applies. */
  jurisdiction?: Maybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies (e.g. Country,State,County,City,Special). */
  jurisdictionTypeEnum?: Maybe<ComWixEcomTotalsCalculatorV1JurisdictionType>;
  /** The rate at which this tax detail was calculated, e.g 0.1000 signifies 10% tax and 2.000 signifies 200% tax. (Decimal value) */
  rate?: Maybe<Scalars['String']>;
  /** The name of the tax against which this tax amount was calculated. */
  taxName?: Maybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the company's nexus settings as well as the jurisdiction's tax laws. */
  taxType?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdownInput = {
  /** The sum of all the tax from line items that calculated by the tax identifiers. */
  aggregatedTaxAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The sum of all the taxable amount from line items for tax identifiers. */
  aggregatedTaxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The name of the jurisdiction in which this tax detail applies. */
  jurisdiction?: InputMaybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies (e.g. Country,State,County,City,Special). */
  jurisdictionTypeEnum?: InputMaybe<ComWixEcomTotalsCalculatorV1JurisdictionType>;
  /** The rate at which this tax detail was calculated, e.g 0.1000 signifies 10% tax and 2.000 signifies 200% tax. (Decimal value) */
  rate?: InputMaybe<Scalars['String']>;
  /** The name of the tax against which this tax amount was calculated. */
  taxName?: InputMaybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the company's nexus settings as well as the jurisdiction's tax laws. */
  taxType?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1ApplicableLineItems = {
  __typename?: 'ComWixEcomTotalsCalculatorV1ApplicableLineItems';
  /** Line items that the delivery solution is for. */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomTotalsCalculatorV1ApplicableLineItemsInput = {
  /** Line items that the delivery solution is for. */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomTotalsCalculatorV1AppliedDiscount = {
  __typename?: 'ComWixEcomTotalsCalculatorV1AppliedDiscount';
  /** Coupon details. */
  coupon?: Maybe<ComWixEcomTotalsCalculatorV1Coupon>;
  /** Discount rule */
  discountRule?: Maybe<ComWixEcomTotalsCalculatorV1DiscountRule>;
  /** Discount type. */
  discountType?: Maybe<ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType>;
  /** Discount ID. */
  id?: Maybe<Scalars['String']>;
  /** Line items the discount applies to. */
  lineItemDiscounts?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1LineItemDiscount>>>;
  /**
   * IDs of line items the discount applies to.
   * @deprecated IDs of line items the discount applies to. Replaced by: line_items_discounts. Removal date: 2024-06-01.
   */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Merchant discount. */
  merchantDiscount?: Maybe<ComWixEcomTotalsCalculatorV1MerchantDiscount>;
  /**
   * Number of subscription cycle this discount applies to
   * default None - all billing cycle
   */
  subscriptionCycles?: Maybe<Scalars['Int']>;
};

export enum ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType {
  Global = 'GLOBAL',
  Shipping = 'SHIPPING',
  SpecificItems = 'SPECIFIC_ITEMS'
}

export type ComWixEcomTotalsCalculatorV1AppliedDiscountInput = {
  /** Coupon details. */
  coupon?: InputMaybe<ComWixEcomTotalsCalculatorV1CouponInput>;
  /** Discount rule */
  discountRule?: InputMaybe<ComWixEcomTotalsCalculatorV1DiscountRuleInput>;
  /** Discount type. */
  discountType?: InputMaybe<ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType>;
  /** Discount ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line items the discount applies to. */
  lineItemDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1LineItemDiscountInput>>>;
  /** Merchant discount. */
  merchantDiscount?: InputMaybe<ComWixEcomTotalsCalculatorV1MerchantDiscountInput>;
  /**
   * Number of subscription cycle this discount applies to
   * default None - all billing cycle
   */
  subscriptionCycles?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomTotalsCalculatorV1CalculationErrors = {
  __typename?: 'ComWixEcomTotalsCalculatorV1CalculationErrors';
  /** Carrier errors. */
  carrierErrors?: Maybe<ComWixEcomTotalsCalculatorV1CarrierErrors>;
  /** Coupon calculation error. */
  couponCalculationError?: Maybe<WixApiDetails>;
  /** Discount Rule calculation error. */
  discountsCalculationError?: Maybe<WixApiDetails>;
  /** General shipping calculation error. */
  generalShippingCalculationError?: Maybe<WixApiDetails>;
  /** Gift card calculation error. */
  giftCardCalculationError?: Maybe<WixApiDetails>;
  /**
   * Membership payment methods calculation errors
   * For example, will indicate that a line item that must be paid with membership payment doesn't have one or selected memberships are invalid
   */
  membershipError?: Maybe<WixApiDetails>;
  /** Order validation errors. */
  orderValidationErrors?: Maybe<Array<Maybe<WixApiApplicationError>>>;
  /** Tax calculation error. */
  taxCalculationError?: Maybe<WixApiDetails>;
};

export type ComWixEcomTotalsCalculatorV1CalculationErrorsInput = {
  /** Carrier errors. */
  carrierErrors?: InputMaybe<ComWixEcomTotalsCalculatorV1CarrierErrorsInput>;
  /** Coupon calculation error. */
  couponCalculationError?: InputMaybe<WixApiDetailsInput>;
  /** Discount Rule calculation error. */
  discountsCalculationError?: InputMaybe<WixApiDetailsInput>;
  /** General shipping calculation error. */
  generalShippingCalculationError?: InputMaybe<WixApiDetailsInput>;
  /** Gift card calculation error. */
  giftCardCalculationError?: InputMaybe<WixApiDetailsInput>;
  /**
   * Membership payment methods calculation errors
   * For example, will indicate that a line item that must be paid with membership payment doesn't have one or selected memberships are invalid
   */
  membershipError?: InputMaybe<WixApiDetailsInput>;
  /** Order validation errors. */
  orderValidationErrors?: InputMaybe<Array<InputMaybe<WixApiApplicationErrorInput>>>;
  /** Tax calculation error. */
  taxCalculationError?: InputMaybe<WixApiDetailsInput>;
};

export type ComWixEcomTotalsCalculatorV1Carrier = {
  __typename?: 'ComWixEcomTotalsCalculatorV1Carrier';
  /** The carrier app id */
  appId?: Maybe<Scalars['String']>;
  /** Unique code that acts as an ID for a shipping rate. For example, `"usps_std_overnight"`. */
  code?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1CarrierError = {
  __typename?: 'ComWixEcomTotalsCalculatorV1CarrierError';
  /** Carrier ID. */
  carrierId?: Maybe<Scalars['String']>;
  /** Error details. */
  error?: Maybe<WixApiDetails>;
};

export type ComWixEcomTotalsCalculatorV1CarrierErrorInput = {
  /** Carrier ID. */
  carrierId?: InputMaybe<Scalars['String']>;
  /** Error details. */
  error?: InputMaybe<WixApiDetailsInput>;
};

export type ComWixEcomTotalsCalculatorV1CarrierErrors = {
  __typename?: 'ComWixEcomTotalsCalculatorV1CarrierErrors';
  /** Carrier errors. */
  errors?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1CarrierError>>>;
};

export type ComWixEcomTotalsCalculatorV1CarrierErrorsInput = {
  /** Carrier errors. */
  errors?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1CarrierErrorInput>>>;
};

export type ComWixEcomTotalsCalculatorV1CarrierInput = {
  /** The carrier app id */
  appId?: InputMaybe<Scalars['String']>;
  /** Unique code that acts as an ID for a shipping rate. For example, `"usps_std_overnight"`. */
  code?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1CarrierServiceOption = {
  __typename?: 'ComWixEcomTotalsCalculatorV1CarrierServiceOption';
  /** Carrier ID. */
  carrierId?: Maybe<Scalars['String']>;
  /** Shipping options offered by this carrier for this request. */
  shippingOptions?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1ShippingOption>>>;
};

export type ComWixEcomTotalsCalculatorV1CarrierServiceOptionInput = {
  /** Carrier ID. */
  carrierId?: InputMaybe<Scalars['String']>;
  /** Shipping options offered by this carrier for this request. */
  shippingOptions?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1ShippingOptionInput>>>;
};

export enum ComWixEcomTotalsCalculatorV1ChargeType {
  HandlingFee = 'HANDLING_FEE',
  Insurance = 'INSURANCE'
}

export type ComWixEcomTotalsCalculatorV1Coupon = {
  __typename?: 'ComWixEcomTotalsCalculatorV1Coupon';
  /** Coupon value. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Coupon code. */
  code?: Maybe<Scalars['String']>;
  /** Coupon type: We want it to be an enum and not a string but currently we have no time to do it so we leave it as is to be aligned with cart summary. */
  couponType?: Maybe<Scalars['String']>;
  /** Coupon ID. */
  id?: Maybe<Scalars['String']>;
  /** Coupon name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1CouponInput = {
  /** Coupon value. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Coupon code. */
  code?: InputMaybe<Scalars['String']>;
  /** Coupon type: We want it to be an enum and not a string but currently we have no time to do it so we leave it as is to be aligned with cart summary. */
  couponType?: InputMaybe<Scalars['String']>;
  /** Coupon ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Coupon name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryAllocation = {
  __typename?: 'ComWixEcomTotalsCalculatorV1DeliveryAllocation';
  /** Populated if the delivery solution is a partially supplied by this carrier. */
  applicableLineItems?: Maybe<ComWixEcomTotalsCalculatorV1ApplicableLineItems>;
  /** The delivery option's carrier details, could be multiple if the delivery option is a combination of multiple carriers */
  deliveryCarrier?: Maybe<ComWixEcomTotalsCalculatorV1Carrier>;
  /** The delivery region that are relevant for this delivery solution. */
  deliveryRegion?: Maybe<ComWixEcomTotalsCalculatorV1Region>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryAllocationInput = {
  /** Populated if the delivery solution is a partially supplied by this carrier. */
  applicableLineItems?: InputMaybe<ComWixEcomTotalsCalculatorV1ApplicableLineItemsInput>;
  /** The delivery option's carrier details, could be multiple if the delivery option is a combination of multiple carriers */
  deliveryCarrier?: InputMaybe<ComWixEcomTotalsCalculatorV1CarrierInput>;
  /** The delivery region that are relevant for this delivery solution. */
  deliveryRegion?: InputMaybe<ComWixEcomTotalsCalculatorV1RegionInput>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryLogistics = {
  __typename?: 'ComWixEcomTotalsCalculatorV1DeliveryLogistics';
  /** Expected delivery time, in free text. For example, "3-5 business days". */
  deliveryTime?: Maybe<Scalars['String']>;
  /** Expected delivery time slot (from and to time stamps representation) */
  deliveryTimeSlot?: Maybe<ComWixEcomTotalsCalculatorV1DeliveryTimeSlot>;
  /** Instructions for caller, e.g for pickup: "Please deliver during opening hours, and please don't park in disabled parking spot". */
  instructions?: Maybe<Scalars['String']>;
  /** Pickup details. */
  pickupDetails?: Maybe<ComWixEcomTotalsCalculatorV1PickupDetails>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryLogisticsInput = {
  /** Expected delivery time, in free text. For example, "3-5 business days". */
  deliveryTime?: InputMaybe<Scalars['String']>;
  /** Expected delivery time slot (from and to time stamps representation) */
  deliveryTimeSlot?: InputMaybe<ComWixEcomTotalsCalculatorV1DeliveryTimeSlotInput>;
  /** Instructions for caller, e.g for pickup: "Please deliver during opening hours, and please don't park in disabled parking spot". */
  instructions?: InputMaybe<Scalars['String']>;
  /** Pickup details. */
  pickupDetails?: InputMaybe<ComWixEcomTotalsCalculatorV1PickupDetailsInput>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryTimeSlot = {
  __typename?: 'ComWixEcomTotalsCalculatorV1DeliveryTimeSlot';
  /** starting time of the delivery time slot */
  from?: Maybe<Scalars['String']>;
  /** ending time of the delivery time slot */
  to?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryTimeSlotInput = {
  /** starting time of the delivery time slot */
  from?: InputMaybe<Scalars['String']>;
  /** ending time of the delivery time slot */
  to?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1DiscountRule = {
  __typename?: 'ComWixEcomTotalsCalculatorV1DiscountRule';
  /** Discount value. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Discount rule ID */
  discountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
  /** Discount rule ID */
  id?: Maybe<Scalars['String']>;
  /** Discount rule name */
  name?: Maybe<ComWixEcomTotalsCalculatorV1DiscountRuleName>;
};

export type ComWixEcomTotalsCalculatorV1DiscountRuleInput = {
  /** Discount value. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Discount rule ID */
  id?: InputMaybe<Scalars['String']>;
  /** Discount rule name */
  name?: InputMaybe<ComWixEcomTotalsCalculatorV1DiscountRuleNameInput>;
};

export type ComWixEcomTotalsCalculatorV1DiscountRuleName = {
  __typename?: 'ComWixEcomTotalsCalculatorV1DiscountRuleName';
  /** Original discount rule name (in site's default language). */
  original?: Maybe<Scalars['String']>;
  /** Translated discount rule name according to buyer language. Defaults to `original` when not provided. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1DiscountRuleNameInput = {
  /** Original discount rule name (in site's default language). */
  original?: InputMaybe<Scalars['String']>;
  /** Translated discount rule name according to buyer language. Defaults to `original` when not provided. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1GiftCard = {
  __typename?: 'ComWixEcomTotalsCalculatorV1GiftCard';
  /** Actual amount to be redeemed from the gift card. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** App ID of the gift card provider. */
  appId?: Maybe<Scalars['String']>;
  /**
   * External ID in the gift card provider's system.
   * Used for integration and tracking across different platforms.
   */
  externalId?: Maybe<Scalars['String']>;
  /** Gift Card ID. */
  id?: Maybe<Scalars['String']>;
  /** Gift card obfuscated code. */
  obfuscatedCode?: Maybe<Scalars['String']>;
  /** Requested amount to redeem from the gift card. */
  requestedAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1GiftCardInput = {
  /** Actual amount to be redeemed from the gift card. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** App ID of the gift card provider. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * External ID in the gift card provider's system.
   * Used for integration and tracking across different platforms.
   */
  externalId?: InputMaybe<Scalars['String']>;
  /** Gift Card ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Gift card obfuscated code. */
  obfuscatedCode?: InputMaybe<Scalars['String']>;
  /** Requested amount to redeem from the gift card. */
  requestedAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1ItemTaxFullDetails = {
  __typename?: 'ComWixEcomTotalsCalculatorV1ItemTaxFullDetails';
  /** The calculator that calculated this line tax */
  calculatorName?: Maybe<Scalars['String']>;
  /** The amount of this line item that was exempt. */
  exemptAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** True for items we have a tax applied on them */
  isItemTaxable?: Maybe<Scalars['Boolean']>;
  /** True if the lineAmount include tax in it. */
  isTaxIncluded?: Maybe<Scalars['Boolean']>;
  /** If breakdown exists, the sum of rates in the breakdown must equal `tax_rate`. Deprecated - use 'tax_breakdown' instead. */
  rateBreakdown?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1TaxRateBreakdown>>>;
  /** tax information for a line item. */
  taxBreakdown?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1TaxBreakdown>>>;
  /** Tax group ID, if specified. */
  taxGroupId?: Maybe<Scalars['String']>;
  /** Tax rate %, as a decimal point between 0 and 1. */
  taxRate?: Maybe<Scalars['String']>;
  /** Amount for which tax is calculated. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Calculated tax, based on `taxable_amount` and `tax_rate`. */
  totalTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput = {
  /** The calculator that calculated this line tax */
  calculatorName?: InputMaybe<Scalars['String']>;
  /** The amount of this line item that was exempt. */
  exemptAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** True for items we have a tax applied on them */
  isItemTaxable?: InputMaybe<Scalars['Boolean']>;
  /** True if the lineAmount include tax in it. */
  isTaxIncluded?: InputMaybe<Scalars['Boolean']>;
  /** If breakdown exists, the sum of rates in the breakdown must equal `tax_rate`. Deprecated - use 'tax_breakdown' instead. */
  rateBreakdown?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1TaxRateBreakdownInput>>>;
  /** tax information for a line item. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1TaxBreakdownInput>>>;
  /** Tax group ID, if specified. */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /** Tax rate %, as a decimal point between 0 and 1. */
  taxRate?: InputMaybe<Scalars['String']>;
  /** Amount for which tax is calculated. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Calculated tax, based on `taxable_amount` and `tax_rate`. */
  totalTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export enum ComWixEcomTotalsCalculatorV1JurisdictionType {
  City = 'CITY',
  Country = 'COUNTRY',
  County = 'COUNTY',
  Special = 'SPECIAL',
  State = 'STATE',
  Undefined = 'UNDEFINED'
}

export type ComWixEcomTotalsCalculatorV1LineItemDiscount = {
  __typename?: 'ComWixEcomTotalsCalculatorV1LineItemDiscount';
  /** ID of line item the discount applies to. */
  id?: Maybe<Scalars['String']>;
  /** Discount value. */
  totalDiscountAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1LineItemDiscountInput = {
  /** ID of line item the discount applies to. */
  id?: InputMaybe<Scalars['String']>;
  /** Discount value. */
  totalDiscountAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1MerchantDiscount = {
  __typename?: 'ComWixEcomTotalsCalculatorV1MerchantDiscount';
  /** Discount value. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Discount Percentage. Will be calculated from items price before other discounts. */
  percentage?: Maybe<Scalars['Float']>;
};

export type ComWixEcomTotalsCalculatorV1MerchantDiscountInput = {
  /** Discount value. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Discount Percentage. Will be calculated from items price before other discounts. */
  percentage?: InputMaybe<Scalars['Float']>;
};

export type ComWixEcomTotalsCalculatorV1MerchantDiscountInputInput = {
  /** Discount amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** IDs of line items the discount applies to. */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomTotalsCalculatorV1OtherCharge = {
  __typename?: 'ComWixEcomTotalsCalculatorV1OtherCharge';
  /** Description of the additional charge. For example, `"Handling fee of $5 applied for gift wrapping"`. */
  details?: Maybe<Scalars['String']>;
  /** Price of added cost. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Type of additional cost. */
  type?: Maybe<ComWixEcomTotalsCalculatorV1ChargeType>;
};

export type ComWixEcomTotalsCalculatorV1OtherChargeInput = {
  /** Description of the additional charge. For example, `"Handling fee of $5 applied for gift wrapping"`. */
  details?: InputMaybe<Scalars['String']>;
  /** Price of added cost. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Type of additional cost. */
  type?: InputMaybe<ComWixEcomTotalsCalculatorV1ChargeType>;
};

export type ComWixEcomTotalsCalculatorV1PickupDetails = {
  __typename?: 'ComWixEcomTotalsCalculatorV1PickupDetails';
  /** Pickup address. */
  address?: Maybe<ComWixEcommercePlatformCommonApiAddress>;
  /** Whether the pickup address is that of a business - this may effect tax calculation. */
  businessLocation?: Maybe<Scalars['Boolean']>;
  /** Pickup method */
  pickupMethod?: Maybe<ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod>;
};

export type ComWixEcomTotalsCalculatorV1PickupDetailsInput = {
  /** Pickup address. */
  address?: InputMaybe<ComWixEcommercePlatformCommonApiAddressInput>;
  /** Whether the pickup address is that of a business - this may effect tax calculation. */
  businessLocation?: InputMaybe<Scalars['Boolean']>;
  /** Pickup method */
  pickupMethod?: InputMaybe<ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod>;
};

export enum ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod {
  PickupPoint = 'PICKUP_POINT',
  StorePickup = 'STORE_PICKUP',
  UnknownMethod = 'UNKNOWN_METHOD'
}

export type ComWixEcomTotalsCalculatorV1PriceSummary = {
  __typename?: 'ComWixEcomTotalsCalculatorV1PriceSummary';
  /** Total additional fees price before tax. */
  additionalFees?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total calculated discount value. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total shipping price, before discounts and before tax. */
  shipping?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Subtotal of all line items, before discounts and before tax. */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total tax. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total price after discounts, gift cards, and tax. */
  total?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1PriceSummaryInput = {
  /** Total additional fees price before tax. */
  additionalFees?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total calculated discount value. */
  discount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total shipping price, before discounts and before tax. */
  shipping?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Subtotal of all line items, before discounts and before tax. */
  subtotal?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total tax. */
  tax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total price after discounts, gift cards, and tax. */
  total?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1Region = {
  __typename?: 'ComWixEcomTotalsCalculatorV1Region';
  /** The delivery region id. */
  id?: Maybe<Scalars['String']>;
  /** The delivery region name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1RegionInput = {
  /** The delivery region id. */
  id?: InputMaybe<Scalars['String']>;
  /** The delivery region name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption = {
  __typename?: 'ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption';
  /** This carrier's unique ID */
  carrierId?: Maybe<Scalars['String']>;
  /** Unique identifier of selected option. For example, "usps_std_overnight". */
  code?: Maybe<Scalars['String']>;
  /** Shipping costs. */
  cost?: Maybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices>;
  /** Delivery solution allocations to different delivery carriers and delivery regions */
  deliveryAllocations?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1DeliveryAllocation>>>;
  /** Delivery logistics. */
  logistics?: Maybe<ComWixEcomTotalsCalculatorV1DeliveryLogistics>;
  /**
   * Other charges
   * @deprecated Other charges. Replaced by: additional_fees. Removal date: 2025-10-01.
   */
  otherCharges?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge>>>;
  /** If the delivery solution is a partial and doesn't apply to all items. */
  partial?: Maybe<Scalars['Boolean']>;
  /** Were we able to find the requested shipping option, or otherwise we fallback to the default one (the first) */
  requestedShippingOption?: Maybe<Scalars['Boolean']>;
  /**
   * Title of the option, such as USPS Standard Overnight Delivery (in the requested locale).
   * For example, "Standard" or "First-Class Package International".
   */
  title?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionInput = {
  /** This carrier's unique ID */
  carrierId?: InputMaybe<Scalars['String']>;
  /** Unique identifier of selected option. For example, "usps_std_overnight". */
  code?: InputMaybe<Scalars['String']>;
  /** Shipping costs. */
  cost?: InputMaybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput>;
  /** Delivery solution allocations to different delivery carriers and delivery regions */
  deliveryAllocations?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1DeliveryAllocationInput>>>;
  /** Delivery logistics. */
  logistics?: InputMaybe<ComWixEcomTotalsCalculatorV1DeliveryLogisticsInput>;
  /** If the delivery solution is a partial and doesn't apply to all items. */
  partial?: InputMaybe<Scalars['Boolean']>;
  /** Were we able to find the requested shipping option, or otherwise we fallback to the default one (the first) */
  requestedShippingOption?: InputMaybe<Scalars['Boolean']>;
  /**
   * Title of the option, such as USPS Standard Overnight Delivery (in the requested locale).
   * For example, "Standard" or "First-Class Package International".
   */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge = {
  __typename?: 'ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge';
  /** Price of added charge. */
  cost?: Maybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices>;
  /** Details of the charge, such as 'Full Coverage Insurance of up to 80% of value of shipment'. */
  details?: Maybe<Scalars['String']>;
  /** Type of additional cost. */
  type?: Maybe<ComWixEcomTotalsCalculatorV1ChargeType>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherChargeInput = {
  /** Price of added charge. */
  cost?: InputMaybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput>;
  /** Details of the charge, such as 'Full Coverage Insurance of up to 80% of value of shipment'. */
  details?: InputMaybe<Scalars['String']>;
  /** Type of additional cost. */
  type?: InputMaybe<ComWixEcomTotalsCalculatorV1ChargeType>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices = {
  __typename?: 'ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices';
  /** Shipping price before discount and before tax. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Tax details. */
  taxDetails?: Maybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetails>;
  /** Shipping discount before tax. */
  totalDiscount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total shipping price, after discount and after tax. */
  totalPriceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total price of shipping after discounts (when relevant), and before tax. */
  totalPriceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput = {
  /** Shipping price before discount and before tax. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Tax details. */
  taxDetails?: InputMaybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput>;
  /** Shipping discount before tax. */
  totalDiscount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total shipping price, after discount and after tax. */
  totalPriceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total price of shipping after discounts (when relevant), and before tax. */
  totalPriceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1ShippingOption = {
  __typename?: 'ComWixEcomTotalsCalculatorV1ShippingOption';
  /**
   * Unique code of provided shipping option like "usps_std_overnight".
   * For legacy calculators this would be the UUID of the option.
   */
  code?: Maybe<Scalars['String']>;
  /** Sipping price information. */
  cost?: Maybe<ComWixEcomTotalsCalculatorV1ShippingPrice>;
  /** Delivery solution allocations to different delivery carriers and delivery regions */
  deliveryAllocations?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1DeliveryAllocation>>>;
  /** Delivery logistics. */
  logistics?: Maybe<ComWixEcomTotalsCalculatorV1DeliveryLogistics>;
  /** If the delivery solution is a partial and doesn't apply to all items. */
  partial?: Maybe<Scalars['Boolean']>;
  /**
   * Title of the option, such as USPS Standard Overnight Delivery (in the requested locale).
   * For example, "Standard" or "First-Class Package International".
   */
  title?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1ShippingOptionInput = {
  /**
   * Unique code of provided shipping option like "usps_std_overnight".
   * For legacy calculators this would be the UUID of the option.
   */
  code?: InputMaybe<Scalars['String']>;
  /** Sipping price information. */
  cost?: InputMaybe<ComWixEcomTotalsCalculatorV1ShippingPriceInput>;
  /** Delivery solution allocations to different delivery carriers and delivery regions */
  deliveryAllocations?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1DeliveryAllocationInput>>>;
  /** Delivery logistics. */
  logistics?: InputMaybe<ComWixEcomTotalsCalculatorV1DeliveryLogisticsInput>;
  /** If the delivery solution is a partial and doesn't apply to all items. */
  partial?: InputMaybe<Scalars['Boolean']>;
  /**
   * Title of the option, such as USPS Standard Overnight Delivery (in the requested locale).
   * For example, "Standard" or "First-Class Package International".
   */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1ShippingPrice = {
  __typename?: 'ComWixEcomTotalsCalculatorV1ShippingPrice';
  /** Other costs such as insurance, handling & packaging for fragile items, etc. */
  otherCharges?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1OtherCharge>>>;
  /** Shipping price. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1ShippingPriceInput = {
  /** Other costs such as insurance, handling & packaging for fragile items, etc. */
  otherCharges?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1OtherChargeInput>>>;
  /** Shipping price. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1ShippingRegion = {
  __typename?: 'ComWixEcomTotalsCalculatorV1ShippingRegion';
  /** Shipping region ID. */
  id?: Maybe<Scalars['String']>;
  /** Shipping region name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1ShippingRegionInput = {
  /** Shipping region ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Shipping region name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1TaxBreakdown = {
  __typename?: 'ComWixEcomTotalsCalculatorV1TaxBreakdown';
  /** The name of the jurisdiction to which this tax detail applies. For example, "New York" or "Quebec". */
  jurisdiction?: Maybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies. */
  jurisdictionType?: Maybe<ComWixEcomTotalsCalculatorV1JurisdictionType>;
  /** The amount of this line item price that was considered nontaxable. (Decimal value) */
  nonTaxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The rate at which this tax detail was calculated, e.g 0.1000 signifies 10% tax and 2.0000 signifies 200% tax. (Decimal value) */
  rate?: Maybe<Scalars['String']>;
  /** The amount of tax estimated for this line item. (Decimal value) */
  taxAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /**
   * The name of the tax against which this tax amount was calculated. For example, "NY State Sales Tax", "Quebec GST", etc.
   * This name should be explicit enough to allow the merchant to understand what tax was calculated.
   */
  taxName?: Maybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the jurisdiction's tax laws. For example, "Sales Tax", "Income Tax", "Value Added Tax", etc. */
  taxType?: Maybe<Scalars['String']>;
  /** The taxable amount of this line item. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1TaxBreakdownInput = {
  /** The name of the jurisdiction to which this tax detail applies. For example, "New York" or "Quebec". */
  jurisdiction?: InputMaybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies. */
  jurisdictionType?: InputMaybe<ComWixEcomTotalsCalculatorV1JurisdictionType>;
  /** The amount of this line item price that was considered nontaxable. (Decimal value) */
  nonTaxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The rate at which this tax detail was calculated, e.g 0.1000 signifies 10% tax and 2.0000 signifies 200% tax. (Decimal value) */
  rate?: InputMaybe<Scalars['String']>;
  /** The amount of tax estimated for this line item. (Decimal value) */
  taxAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /**
   * The name of the tax against which this tax amount was calculated. For example, "NY State Sales Tax", "Quebec GST", etc.
   * This name should be explicit enough to allow the merchant to understand what tax was calculated.
   */
  taxName?: InputMaybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the jurisdiction's tax laws. For example, "Sales Tax", "Income Tax", "Value Added Tax", etc. */
  taxType?: InputMaybe<Scalars['String']>;
  /** The taxable amount of this line item. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1TaxRateBreakdown = {
  __typename?: 'ComWixEcomTotalsCalculatorV1TaxRateBreakdown';
  /** The amount of this line item that was exempt from this authority. */
  exemptAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** ids of the used exemptions from the TaxEstimate exemptions array. */
  exemptionIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The Taxes/Fee component. True if the fee is applied. */
  isFee?: Maybe<Scalars['Boolean']>;
  /** The name of the jurisdiction in which this tax detail applies */
  jurisdiction?: Maybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies(Country,State,County,City,Special). */
  jurisdictionType?: Maybe<Scalars['String']>;
  /** Name of tax against which the calculation was performed. */
  name?: Maybe<Scalars['String']>;
  /** Rate at which this tax detail was calculated. */
  rate?: Maybe<Scalars['String']>;
  /** Amount of tax for this tax detail. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The type of tax that was calculated */
  taxType?: Maybe<Scalars['String']>;
  /** The taxable amount of this tax detail */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1TaxRateBreakdownInput = {
  /** The amount of this line item that was exempt from this authority. */
  exemptAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** ids of the used exemptions from the TaxEstimate exemptions array. */
  exemptionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The Taxes/Fee component. True if the fee is applied. */
  isFee?: InputMaybe<Scalars['Boolean']>;
  /** The name of the jurisdiction in which this tax detail applies */
  jurisdiction?: InputMaybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies(Country,State,County,City,Special). */
  jurisdictionType?: InputMaybe<Scalars['String']>;
  /** Name of tax against which the calculation was performed. */
  name?: InputMaybe<Scalars['String']>;
  /** Rate at which this tax detail was calculated. */
  rate?: InputMaybe<Scalars['String']>;
  /** Amount of tax for this tax detail. */
  tax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The type of tax that was calculated */
  taxType?: InputMaybe<Scalars['String']>;
  /** The taxable amount of this tax detail */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1TaxSummary = {
  __typename?: 'ComWixEcomTotalsCalculatorV1TaxSummary';
  /** The summary of the tax breakdown for all the line items. It will hold for each tax name, the aggregated tax amount paid for it and the tax rate. */
  aggregatedTaxBreakdown?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown>>>;
  /** Average Tax Rate */
  averageTaxRate?: Maybe<Scalars['String']>;
  /** Tax calculator that was active when the order was created. */
  calculationDetails?: Maybe<ComWixEcomTaxApiTaxCalculationDetails>;
  /** Manual tax rate */
  manualTaxRate?: Maybe<Scalars['String']>;
  /** Tax estimation id in tax service */
  taxEstimationId?: Maybe<Scalars['String']>;
  /** Amount for which tax is calculated, added from line items. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The amount of this estimate that was exempt (for all line items). */
  totalExempt?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Calculated tax, added from line items. */
  totalTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1TaxSummaryInput = {
  /** The summary of the tax breakdown for all the line items. It will hold for each tax name, the aggregated tax amount paid for it and the tax rate. */
  aggregatedTaxBreakdown?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdownInput>>>;
  /** Average Tax Rate */
  averageTaxRate?: InputMaybe<Scalars['String']>;
  /** Tax calculator that was active when the order was created. */
  calculationDetails?: InputMaybe<ComWixEcomTaxApiTaxCalculationDetailsInput>;
  /** Manual tax rate */
  manualTaxRate?: InputMaybe<Scalars['String']>;
  /** Tax estimation id in tax service */
  taxEstimationId?: InputMaybe<Scalars['String']>;
  /** Amount for which tax is calculated, added from line items. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The amount of this estimate that was exempt (for all line items). */
  totalExempt?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Calculated tax, added from line items. */
  totalTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcommerceCatalogSpiApiV1CatalogReference = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1CatalogReference';
  /**
   * ID of the app providing the catalog.
   *
   * You can get your app's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   *
   * For items from Wix catalogs, the following values always apply:
   * + Wix Stores: `"215238eb-22a5-4c36-9e7b-e7c08025e04e"`
   * + Wix Bookings: `"13d21c63-b5ec-5912-8397-c3a5ddb27a97"`
   * + Wix Restaurants: `"9a5d83fd-8570-482e-81ab-cfa88942ee60"`
   */
  appId?: Maybe<Scalars['String']>;
  /** ID of the item within the catalog it belongs to. */
  catalogItemId?: Maybe<Scalars['String']>;
  /**
   * Additional item details in key:value pairs. Use this optional field to provide more specificity with item selection. The `options` field values differ depending on which catalog is providing the items.
   *
   * For products and variants from a Wix Stores catalog, learn more about eCommerce integration ([SDK](https://dev.wix.com/docs/sdk/backend-modules/stores/catalog-v3/e-commerce-integration) | [REST](https://dev.wix.com/docs/rest/business-solutions/stores/catalog/e-commerce-integration)).
   */
  options?: Maybe<Scalars['JSON']>;
};

export type ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput = {
  /**
   * ID of the app providing the catalog.
   *
   * You can get your app's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   *
   * For items from Wix catalogs, the following values always apply:
   * + Wix Stores: `"215238eb-22a5-4c36-9e7b-e7c08025e04e"`
   * + Wix Bookings: `"13d21c63-b5ec-5912-8397-c3a5ddb27a97"`
   * + Wix Restaurants: `"9a5d83fd-8570-482e-81ab-cfa88942ee60"`
   */
  appId?: InputMaybe<Scalars['String']>;
  /** ID of the item within the catalog it belongs to. */
  catalogItemId?: InputMaybe<Scalars['String']>;
  /**
   * Additional item details in key:value pairs. Use this optional field to provide more specificity with item selection. The `options` field values differ depending on which catalog is providing the items.
   *
   * For products and variants from a Wix Stores catalog, learn more about eCommerce integration ([SDK](https://dev.wix.com/docs/sdk/backend-modules/stores/catalog-v3/e-commerce-integration) | [REST](https://dev.wix.com/docs/rest/business-solutions/stores/catalog/e-commerce-integration)).
   */
  options?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcommerceCatalogSpiApiV1Color = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1Color';
  /** HEX or RGB color code for display. */
  code?: Maybe<Scalars['String']>;
  /** Description line color name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Description line color name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1ColorInput = {
  /** HEX or RGB color code for display. */
  code?: InputMaybe<Scalars['String']>;
  /** Description line color name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Description line color name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1Description = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1Description';
  /** Subscription option description. */
  original?: Maybe<Scalars['String']>;
  /** Translated subscription option description. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1DescriptionInput = {
  /** Subscription option description. */
  original?: InputMaybe<Scalars['String']>;
  /** Translated subscription option description. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1DescriptionLine = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1DescriptionLine';
  /** Description line color. */
  color?: Maybe<Scalars['String']>;
  /** Description line color value. */
  colorInfo?: Maybe<ComWixEcommerceCatalogSpiApiV1Color>;
  /** Description line type. */
  lineType?: Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType>;
  /** Whether the description line originates from a modifier. */
  modifierDescriptionLine?: Maybe<Scalars['Boolean']>;
  /** Description line name. */
  name?: Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineName>;
  /** Description line plain text value. */
  plainText?: Maybe<ComWixEcommerceCatalogSpiApiV1PlainTextValue>;
  /** Description line plain text value. */
  plainTextValue?: Maybe<ComWixEcommerceCatalogSpiApiV1PlainTextValue>;
};

export enum ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType {
  /** Color type. */
  Color = 'COLOR',
  /** Plain text type. */
  PlainText = 'PLAIN_TEXT',
  /** Unrecognized type. */
  Unrecognised = 'UNRECOGNISED'
}

export type ComWixEcommerceCatalogSpiApiV1DescriptionLineInput = {
  /** Description line color. */
  color?: InputMaybe<Scalars['String']>;
  /** Description line color value. */
  colorInfo?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ColorInput>;
  /** Description line type. */
  lineType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType>;
  /** Whether the description line originates from a modifier. */
  modifierDescriptionLine?: InputMaybe<Scalars['Boolean']>;
  /** Description line name. */
  name?: InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineNameInput>;
  /** Description line plain text value. */
  plainText?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PlainTextValueInput>;
  /** Description line plain text value. */
  plainTextValue?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PlainTextValueInput>;
};

export type ComWixEcommerceCatalogSpiApiV1DescriptionLineName = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1DescriptionLineName';
  /** Description line name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Description line name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1DescriptionLineNameInput = {
  /** Description line name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Description line name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod';
  /** Frequency of period. Values: DAY, WEEK, MONTH, YEAR */
  frequency?: Maybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** interval of period */
  interval?: Maybe<Scalars['Int']>;
};

export type ComWixEcommerceCatalogSpiApiV1FreeTrialPeriodInput = {
  /** Frequency of period. Values: DAY, WEEK, MONTH, YEAR */
  frequency?: InputMaybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** interval of period */
  interval?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCatalogSpiApiV1ItemModifierInput = {
  /** Optional additional details or clarification for the modifier. */
  details?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** Modifier ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Primary display label for the modifier. */
  label?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** The price of the modifier. */
  price?: InputMaybe<Scalars['String']>;
  /** The quantity of this modifier. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCatalogSpiApiV1ItemType = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1ItemType';
  /** Custom item type. When none of the preset types are suitable, specifies the custom type. */
  custom?: Maybe<Scalars['String']>;
  /** Preset item type. */
  preset?: Maybe<ComWixEcommerceCatalogSpiApiV1ItemTypeItemType>;
};

export type ComWixEcommerceCatalogSpiApiV1ItemTypeInput = {
  /** Custom item type. When none of the preset types are suitable, specifies the custom type. */
  custom?: InputMaybe<Scalars['String']>;
  /** Preset item type. */
  preset?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemTypeItemType>;
};

export enum ComWixEcommerceCatalogSpiApiV1ItemTypeItemType {
  Digital = 'DIGITAL',
  GiftCard = 'GIFT_CARD',
  Physical = 'PHYSICAL',
  Service = 'SERVICE',
  Unrecognised = 'UNRECOGNISED'
}

export type ComWixEcommerceCatalogSpiApiV1ModifierGroupInput = {
  /** Modifier group id. */
  id?: InputMaybe<Scalars['String']>;
  /** List of modifiers in this group. */
  modifiers?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemModifierInput>>>;
  /** Modifier group name. */
  name?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
};

export type ComWixEcommerceCatalogSpiApiV1NumericPropertyRange = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1NumericPropertyRange';
  /** Maximum value. */
  maxValue?: Maybe<Scalars['Float']>;
  /** Minimum value. */
  minValue?: Maybe<Scalars['Float']>;
};

export type ComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput = {
  /** Maximum value. */
  maxValue?: InputMaybe<Scalars['Float']>;
  /** Minimum value. */
  minValue?: InputMaybe<Scalars['Float']>;
};

export enum ComWixEcommerceCatalogSpiApiV1PaymentOptionType {
  /** Partial payment to be paid upfront during checkout. The initial amount to be paid for each line item is specified in `depositAmount`. */
  DepositOnline = 'DEPOSIT_ONLINE',
  /** The entire payment for this item happens after checkout. For example, when using cash, check, or other offline payment methods. */
  FullPaymentOffline = 'FULL_PAYMENT_OFFLINE',
  /** The entire payment for this item happens as part of the checkout. */
  FullPaymentOnline = 'FULL_PAYMENT_ONLINE',
  /** Payment for this item is done by charging a membership. When selected, `price` is `0`. */
  Membership = 'MEMBERSHIP',
  /** Payment for this item can only be done by charging a membership and must be manually redeemed in the dashboard by the site admin. When selected, `price` is `0`. */
  MembershipOffline = 'MEMBERSHIP_OFFLINE',
  /** Item price is charged to online membership. Any remaining amount not covered by the membership, such as item modifiers, is paid offline. */
  MembershipOnlineWithOfflineRemainder = 'MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER'
}

export type ComWixEcommerceCatalogSpiApiV1PhysicalProperties = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1PhysicalProperties';
  /** Whether this line item is shippable. */
  shippable?: Maybe<Scalars['Boolean']>;
  /** Stock-keeping unit. Learn more about [SKUs](https://www.wix.com/encyclopedia/definition/stock-keeping-unit-sku). */
  sku?: Maybe<Scalars['String']>;
  /** Line item weight. Measurement unit matches the weight unit specified in `weightUnit` in the request. */
  weight?: Maybe<Scalars['Float']>;
};

export type ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput = {
  /** Whether this line item is shippable. */
  shippable?: InputMaybe<Scalars['Boolean']>;
  /** Stock-keeping unit. Learn more about [SKUs](https://www.wix.com/encyclopedia/definition/stock-keeping-unit-sku). */
  sku?: InputMaybe<Scalars['String']>;
  /** Line item weight. Measurement unit matches the weight unit specified in `weightUnit` in the request. */
  weight?: InputMaybe<Scalars['Float']>;
};

export type ComWixEcommerceCatalogSpiApiV1PlainTextValue = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1PlainTextValue';
  /** Description line plain text value in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Description line plain text value translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1PlainTextValueInput = {
  /** Description line plain text value in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Description line plain text value translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1Policy = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1Policy';
  /** Policy content - should be translated */
  content?: Maybe<Scalars['String']>;
  /** Policy title - should be translated */
  title?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1PolicyInput = {
  /** Policy content - should be translated */
  content?: InputMaybe<Scalars['String']>;
  /** Policy title - should be translated */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1PriceDescription = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1PriceDescription';
  /** __Required.__ Price description in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Price description translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput = {
  /** __Required.__ Price description in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Price description translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1ProductName = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1ProductName';
  /**
   * __Required.__ Item name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope).
   *
   * Min: 1 character.
   * Max: 200 characters.
   */
  original?: Maybe<Scalars['String']>;
  /**
   * Item name translated into the buyer's language.
   *
   * Min: 1 character.
   * Max: 400 characters.
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1ProductNameInput = {
  /**
   * __Required.__ Item name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope).
   *
   * Min: 1 character.
   * Max: 200 characters.
   */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Item name translated into the buyer's language.
   *
   * Min: 1 character.
   * Max: 400 characters.
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1SecuredMedia = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1SecuredMedia';
  /** Original filename. */
  fileName?: Maybe<Scalars['String']>;
  /** File type. */
  fileType?: Maybe<ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType>;
  /** Media ID in Wix Media Manager. */
  id?: Maybe<Scalars['String']>;
};

export enum ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType {
  SecureArchive = 'SECURE_ARCHIVE',
  SecureDocument = 'SECURE_DOCUMENT',
  SecureMusic = 'SECURE_MUSIC',
  SecurePicture = 'SECURE_PICTURE',
  SecureVideo = 'SECURE_VIDEO',
  Unspecified = 'UNSPECIFIED'
}

export type ComWixEcommerceCatalogSpiApiV1SecuredMediaInput = {
  /** Original filename. */
  fileName?: InputMaybe<Scalars['String']>;
  /** File type. */
  fileType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType>;
  /** Media ID in Wix Media Manager. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1ServiceProperties = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1ServiceProperties';
  /** The number of people participating in the service. For example, the number of people attending a class or the number of people per hotel room. */
  numberOfParticipants?: Maybe<Scalars['Int']>;
  /**
   * Date and time the service is to be provided, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format.
   * For example, the start time of a class.
   */
  scheduledDate?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1ServicePropertiesInput = {
  /** The number of people participating in the service. For example, the number of people attending a class or the number of people per hotel room. */
  numberOfParticipants?: InputMaybe<Scalars['Int']>;
  /**
   * Date and time the service is to be provided, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format.
   * For example, the start time of a class.
   */
  scheduledDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo';
  /** Subscription option description. */
  description?: Maybe<ComWixEcommerceCatalogSpiApiV1Description>;
  /** Subscription option settings. */
  subscriptionSettings?: Maybe<ComWixEcommerceCatalogSpiApiV1SubscriptionSettings>;
  /** Subscription option title. */
  title?: Maybe<ComWixEcommerceCatalogSpiApiV1Title>;
};

export type ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput = {
  /** Subscription option description. */
  description?: InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionInput>;
  /** Subscription option settings. */
  subscriptionSettings?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SubscriptionSettingsInput>;
  /** Subscription option title. */
  title?: InputMaybe<ComWixEcommerceCatalogSpiApiV1TitleInput>;
};

export type ComWixEcommerceCatalogSpiApiV1SubscriptionSettings = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1SubscriptionSettings';
  /** Whether subscription is renewed automatically at the end of each period. */
  autoRenewal?: Maybe<Scalars['Boolean']>;
  /** Number of billing cycles before subscription ends. Ignored if `autoRenewal` is `true`. */
  billingCycles?: Maybe<Scalars['Int']>;
  /** Whether to allow the customer to cancel the subscription.. */
  enableCustomerCancellation?: Maybe<Scalars['Boolean']>;
  /**
   * Period until first cycle starts. If applied payNow will be 0
   * If None => no free trial
   */
  freeTrialPeriod?: Maybe<ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod>;
  /** Frequency of recurring payment. */
  frequency?: Maybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /**
   * Interval of recurring payment.
   *
   * Default: `1`.
   * If SubscriptionFrequency is Day the minimum interval is 7
   */
  interval?: Maybe<Scalars['Int']>;
  /** The date the subscription will start. The subscription will be charged either now or according to freeTrialDays. */
  startDate?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1SubscriptionSettingsInput = {
  /** Whether subscription is renewed automatically at the end of each period. */
  autoRenewal?: InputMaybe<Scalars['Boolean']>;
  /** Number of billing cycles before subscription ends. Ignored if `autoRenewal` is `true`. */
  billingCycles?: InputMaybe<Scalars['Int']>;
  /** Whether to allow the customer to cancel the subscription.. */
  enableCustomerCancellation?: InputMaybe<Scalars['Boolean']>;
  /**
   * Period until first cycle starts. If applied payNow will be 0
   * If None => no free trial
   */
  freeTrialPeriod?: InputMaybe<ComWixEcommerceCatalogSpiApiV1FreeTrialPeriodInput>;
  /** Frequency of recurring payment. */
  frequency?: InputMaybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /**
   * Interval of recurring payment.
   *
   * Default: `1`.
   * If SubscriptionFrequency is Day the minimum interval is 7
   */
  interval?: InputMaybe<Scalars['Int']>;
  /** The date the subscription will start. The subscription will be charged either now or according to freeTrialDays. */
  startDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1Title = {
  __typename?: 'ComWixEcommerceCatalogSpiApiV1Title';
  /** Subscription option name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Subscription option name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1TitleInput = {
  /** Subscription option name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Subscription option name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCommonsApiAddressInput = {
  /** Address line 1 (free text) */
  addressLine1?: InputMaybe<Scalars['String']>;
  /** address line */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name */
  city?: InputMaybe<Scalars['String']>;
  /** Company name */
  company?: InputMaybe<Scalars['String']>;
  /** Country code (2 letters) */
  country?: InputMaybe<Scalars['String']>;
  /** Email address */
  email?: InputMaybe<Scalars['String']>;
  /** Addressee name */
  fullName?: InputMaybe<ComWixEcommerceCommonsApiFullNameInput>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']>;
  /** Address line 1 (street) */
  street?: InputMaybe<ComWixEcommerceCommonsApiStreetInput>;
  /** State or district */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Tax information (for Brazil only) */
  vatId?: InputMaybe<ComWixEcommerceCommonsApiVatIdInput>;
  /** ZIP/postal code */
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCommonsApiFullNameInput = {
  /** Customer's first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Customer's last name */
  lastName?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit {
  Cbm = 'CBM',
  Cl = 'CL',
  Cm = 'CM',
  Floz = 'FLOZ',
  Ft = 'FT',
  G = 'G',
  Gal = 'GAL',
  In = 'IN',
  Kg = 'KG',
  L = 'L',
  Lb = 'LB',
  M = 'M',
  Mg = 'MG',
  Ml = 'ML',
  Mm = 'MM',
  Oz = 'OZ',
  Pt = 'PT',
  Qt = 'QT',
  Sqft = 'SQFT',
  Sqm = 'SQM',
  Unspecified = 'UNSPECIFIED',
  Yd = 'YD'
}

export type ComWixEcommerceCommonsApiPlatformCursorPagingInput = {
  /** Cursor returned in last query response. Should not be provided on first page request */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * The number of items to load.
   * Cursor token returned in the query response. To be used on the next query request, but not the first query request.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCommonsApiPlatformMedia = {
  __typename?: 'ComWixEcommerceCommonsApiPlatformMedia';
  image?: Maybe<WixCommonImage>;
  video?: Maybe<WixCommonVideoV2>;
};

export type ComWixEcommerceCommonsApiPlatformPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCommonsApiPlatformPagingMetadata = {
  __typename?: 'ComWixEcommerceCommonsApiPlatformPagingMetadata';
  /** The number of items returned in this response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through result pages. Returned if cursor paging was used. */
  cursors?: Maybe<WixCommonCursors>;
  /** The offset which was requested. Returned if offset paging was used. */
  offset?: Maybe<Scalars['Int']>;
  /** The total number of items that match the query. Returned if offset paging was used. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixEcommerceCommonsApiPlatformQueryInput = {
  /** Cursor pointing to page of results. Cannot be used together with `paging`. `cursorPaging.cursor` can not be used together with `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /** Filter object. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pointer to page of results using offset. Cannot be used together with `cursorPaging`. */
  paging?: InputMaybe<ComWixEcommerceCommonsApiPlatformPagingInput>;
  /** Sorting options. For example, `[{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}]`. */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixEcommerceCommonsApiStreetInput = {
  /** Street name */
  name?: InputMaybe<Scalars['String']>;
  /** Street number */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCommonsApiUnlimitedPlatformCursorPagingInput = {
  /** Cursor returned in last query response. Should not be provided on first page request */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * The number of items to load.
   * Cursor token returned in the query response. To be used on the next query request, but not the first query request.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCommonsApiUnlimitedPlatformPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCommonsApiUnlimitedPlatformQueryInput = {
  /** Cursor pointing to page of results. Cannot be used together with `paging`. `cursorPaging.cursor` can not be used together with `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixEcommerceCommonsApiUnlimitedPlatformCursorPagingInput>;
  /** Filter object. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pointer to page of results using offset. Cannot be used together with `cursorPaging`. */
  paging?: InputMaybe<ComWixEcommerceCommonsApiUnlimitedPlatformPagingInput>;
  /** Sorting options. For example, `[{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}]`. */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixEcommerceCommonsApiVatIdInput = {
  /** Customer's tax ID. */
  number?: InputMaybe<Scalars['String']>;
  /**
   * Tax type.
   * + `CPF`: For individual tax payers.
   * + `CNPJ`: For corporations.
   */
  type?: InputMaybe<ComWixEcommerceCommonsApiVatType>;
};

export enum ComWixEcommerceCommonsApiVatType {
  /** CNPJ - for corporations */
  Cnpj = 'CNPJ',
  /** CPF - for individual tax payers */
  Cpf = 'CPF',
  /** When the tax info type can't be classified, due to an error */
  UnspecifiedTaxType = 'UNSPECIFIED_TAX_TYPE'
}

export type ComWixEcommercePlatformCommonApiAddress = {
  __typename?: 'ComWixEcommercePlatformCommonApiAddress';
  /** Main address line (usually street name and number). */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains apt, suite, floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Two-letter country code in [ISO-3166 alpha-2](https://www.iso.org/obp/ui/#search/code/) format. */
  country?: Maybe<Scalars['String']>;
  /** Country's full name. */
  countryFullname?: Maybe<Scalars['String']>;
  geocode?: Maybe<WixCommonAddressLocation>;
  /** Postal or zip code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street address. */
  streetAddress?: Maybe<WixCommonStreetAddress>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://www.iso.org/standard/72483.html) format. */
  subdivision?: Maybe<Scalars['String']>;
  /** Subdivision full-name. */
  subdivisionFullname?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiAddressInput = {
  /** Main address line (usually street name and number). */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains apt, suite, floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Two-letter country code in [ISO-3166 alpha-2](https://www.iso.org/obp/ui/#search/code/) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Country's full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  geocode?: InputMaybe<WixCommonAddressLocationInput>;
  /** Postal or zip code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street address. */
  streetAddress?: InputMaybe<WixCommonStreetAddressInput>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://www.iso.org/standard/72483.html) format. */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Subdivision full-name. */
  subdivisionFullname?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiAddressWithContact = {
  __typename?: 'ComWixEcommercePlatformCommonApiAddressWithContact';
  /** Address. */
  address?: Maybe<ComWixEcommercePlatformCommonApiAddress>;
  /** Contact details. */
  contactDetails?: Maybe<ComWixEcommercePlatformCommonApiFullAddressContactDetails>;
};

export type ComWixEcommercePlatformCommonApiAddressWithContactInput = {
  /** Address. */
  address?: InputMaybe<ComWixEcommercePlatformCommonApiAddressInput>;
  /** Contact details. */
  contactDetails?: InputMaybe<ComWixEcommercePlatformCommonApiFullAddressContactDetailsInput>;
};

export enum ComWixEcommercePlatformCommonApiAutoTaxFallbackCalculationDetailsFallbackReason {
  /** auto-tax was temporarily deactivated on a system-level */
  AutoTaxDeactivated = 'AUTO_TAX_DEACTIVATED',
  /** auto-tax failed to be calculated */
  AutoTaxFailed = 'AUTO_TAX_FAILED'
}

export enum ComWixEcommercePlatformCommonApiChannelType {
  /** [Amazon shop](https://support.wix.com/en/article/wix-stores-connecting-and-setting-up-an-amazon-shop). */
  Amazon = 'AMAZON',
  /** Wix merchant backoffice. */
  BackofficeMerchant = 'BACKOFFICE_MERCHANT',
  /** [ClassPass sales channel](https://support.wix.com/en/article/wix-bookings-letting-clients-book-your-services-with-classpass). */
  ClassPass = 'CLASS_PASS',
  /** [eBay shop](https://support.wix.com/en/article/wix-stores-connecting-and-setting-up-an-ebay-shop). */
  Ebay = 'EBAY',
  /** [Etsy sales channel](https://support.wix.com/en/article/wix-stores-request-adding-etsy-as-a-sales-channel). */
  Etsy = 'ETSY',
  /** [Facebook shop](https://support.wix.com/en/article/wix-stores-changes-to-facebook-shops). */
  Facebook = 'FACEBOOK',
  /** [Faire marketplace integration](https://support.wix.com/en/article/wix-stores-creating-a-faire-store-using-the-faire-integration-app). */
  FaireCom = 'FAIRE_COM',
  /** Global-E sales channel. */
  GlobalE = 'GLOBAL_E',
  /** Other sales platform. */
  OtherPlatform = 'OTHER_PLATFORM',
  /** [Point of sale solutions](https://support.wix.com/en/wix-mobile-pos-2196395). */
  Pos = 'POS',
  /** [TikTok sales channel](https://support.wix.com/en/article/wix-stores-request-adding-tiktok-as-a-sales-channel). */
  Tiktok = 'TIKTOK',
  /** Unspecified sales channel. This value is not supported. */
  Unspecified = 'UNSPECIFIED',
  /** A web client. */
  Web = 'WEB',
  /** Wish sales channel. */
  Wish = 'WISH',
  /** [Wix Owner app](https://support.wix.com/article/wix-owner-app-an-overview). */
  WixAppStore = 'WIX_APP_STORE',
  /** Wix Invoices app in [your dashboard](https://www.wix.com/my-account/site-selector/?buttonText=Select%20Site&title=Select%20a%20Site&autoSelectOnSingleSite=true&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Finvoices/settings/general-settings) */
  WixInvoices = 'WIX_INVOICES'
}

export enum ComWixEcommercePlatformCommonApiDurationDurationUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  UnknownDurationUnit = 'UNKNOWN_DURATION_UNIT'
}

export type ComWixEcommercePlatformCommonApiDurationInput = {
  /** Amount of units. For example, 30 MINUTES, 1 HOURS, 7 DAYS, etc */
  count?: InputMaybe<Scalars['Int']>;
  /** Duration unit: MINUTES, HOURS and DAYS */
  unit?: InputMaybe<ComWixEcommercePlatformCommonApiDurationDurationUnit>;
};

export type ComWixEcommercePlatformCommonApiExternalReference = {
  __typename?: 'ComWixEcommercePlatformCommonApiExternalReference';
  /**
   * ID of the app associated with the purchase flow.
   * For example, the Wix Pay Links app ID.
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * Reference to an external resource ID. Used to link the purchase flow to a specific entity in an external system.
   * For example, a Wix Pay Link ID.
   */
  resourceId?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiExternalReferenceInput = {
  /**
   * ID of the app associated with the purchase flow.
   * For example, the Wix Pay Links app ID.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Reference to an external resource ID. Used to link the purchase flow to a specific entity in an external system.
   * For example, a Wix Pay Link ID.
   */
  resourceId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiFullAddressContactDetails = {
  __typename?: 'ComWixEcommercePlatformCommonApiFullAddressContactDetails';
  /** Company name. */
  company?: Maybe<Scalars['String']>;
  /** First name. */
  firstName?: Maybe<Scalars['String']>;
  /** Last name. */
  lastName?: Maybe<Scalars['String']>;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /** Tax information (for Brazil only). If ID is provided, `vatId.type` must also be set, `UNSPECIFIED` is not allowed. */
  vatId?: Maybe<WixCommonVatId>;
};

export type ComWixEcommercePlatformCommonApiFullAddressContactDetailsInput = {
  /** Company name. */
  company?: InputMaybe<Scalars['String']>;
  /** First name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Tax information (for Brazil only). If ID is provided, `vatId.type` must also be set, `UNSPECIFIED` is not allowed. */
  vatId?: InputMaybe<WixCommonVatIdInput>;
};

export type ComWixEcommercePlatformCommonApiLocation = {
  __typename?: 'ComWixEcommercePlatformCommonApiLocation';
  /**
   * Location ID.
   * Learn more about the [Wix Locations API](https://dev.wix.com/docs/rest/business-management/locations/introduction).
   */
  id?: Maybe<Scalars['String']>;
  /**
   * Location ID.
   * Learn more about the [Wix Locations API](https://dev.wix.com/docs/rest/business-management/locations/introduction).
   */
  location?: Maybe<ComWixpressLocationsLocation>;
  /** Location name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiLocationAndQuantity = {
  __typename?: 'ComWixEcommercePlatformCommonApiLocationAndQuantity';
  /**
   * Location owner app, if not provided then the site business info locations will be used.
   * @deprecated Location owner app, if not provided then the site business info locations will be used. Removal date: 2025-03-01.
   */
  appId?: Maybe<Scalars['String']>;
  /** Location id in the associated owner app. */
  id?: Maybe<Scalars['String']>;
  /** Location name. */
  name?: Maybe<Scalars['String']>;
  /** Quantity for specific location. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcommercePlatformCommonApiLocationAndQuantityInput = {
  /** Location id in the associated owner app. */
  id?: InputMaybe<Scalars['String']>;
  /** Location name. */
  name?: InputMaybe<Scalars['String']>;
  /** Quantity for specific location. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommercePlatformCommonApiLocationInput = {
  /**
   * Location ID.
   * Learn more about the [Wix Locations API](https://dev.wix.com/docs/rest/business-management/locations/introduction).
   */
  id?: InputMaybe<Scalars['String']>;
  /** Location name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiMultiCurrencyPrice = {
  __typename?: 'ComWixEcommercePlatformCommonApiMultiCurrencyPrice';
  /** Amount. */
  amount?: Maybe<Scalars['String']>;
  /** Converted amount. */
  convertedAmount?: Maybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: Maybe<Scalars['String']>;
  /** Converted amount formatted with currency symbol. */
  formattedConvertedAmount?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput = {
  /** Amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Converted amount. */
  convertedAmount?: InputMaybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: InputMaybe<Scalars['String']>;
  /** Converted amount formatted with currency symbol. */
  formattedConvertedAmount?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiPickupAddress = {
  __typename?: 'ComWixEcommercePlatformCommonApiPickupAddress';
  /** Main address line (usually street name and number). */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains apt, suite, floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Two-letter country code in [ISO-3166 alpha-2](https://www.iso.org/obp/ui/#search/code/) format. */
  country?: Maybe<Scalars['String']>;
  /** Country's full name. */
  countryFullname?: Maybe<Scalars['String']>;
  geocode?: Maybe<WixCommonAddressLocation>;
  /** Postal or zip code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street address object, with number, name, and apartment number in separate fields. */
  streetAddress?: Maybe<WixCommonStreetAddress>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://www.iso.org/standard/72483.html) format. */
  subdivision?: Maybe<Scalars['String']>;
  /** Subdivision full-name. */
  subdivisionFullname?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiPickupAddressInput = {
  /** Main address line (usually street name and number). */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains apt, suite, floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Two-letter country code in [ISO-3166 alpha-2](https://www.iso.org/obp/ui/#search/code/) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Country's full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  geocode?: InputMaybe<WixCommonAddressLocationInput>;
  /** Postal or zip code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street address object, with number, name, and apartment number in separate fields. */
  streetAddress?: InputMaybe<WixCommonStreetAddressInput>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://www.iso.org/standard/72483.html) format. */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Subdivision full-name. */
  subdivisionFullname?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiPrice = {
  __typename?: 'ComWixEcommercePlatformCommonApiPrice';
  /** Amount. */
  amount?: Maybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiPriceInput = {
  /** Amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiTaxableAddress = {
  __typename?: 'ComWixEcommercePlatformCommonApiTaxableAddress';
  /** taxable address type. if this field is selected, the address is automatically resolved, and the tax is calculated accordingly. */
  addressType?: Maybe<ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType>;
};

export type ComWixEcommercePlatformCommonApiTaxableAddressInput = {
  /** taxable address type. if this field is selected, the address is automatically resolved, and the tax is calculated accordingly. */
  addressType?: InputMaybe<ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType>;
};

export enum ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType {
  Billing = 'BILLING',
  Business = 'BUSINESS',
  Shipping = 'SHIPPING',
  UnknownTaxableAddress = 'UNKNOWN_TAXABLE_ADDRESS'
}

export type ComWixEcommercePlatformCommonApiTranslatableString = {
  __typename?: 'ComWixEcommercePlatformCommonApiTranslatableString';
  /**
   * __Required.__ String in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope).
   *
   * Min: 1 character.
   * Max: 200 characters.
   */
  original?: Maybe<Scalars['String']>;
  /**
   * String translated into the buyer's language.
   *
   * Min: 1 character.
   * Max: 400 characters.
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiTranslatableStringInput = {
  /**
   * __Required.__ String in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope).
   *
   * Min: 1 character.
   * Max: 200 characters.
   */
  original?: InputMaybe<Scalars['String']>;
  /**
   * String translated into the buyer's language.
   *
   * Min: 1 character.
   * Max: 400 characters.
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcommercePlatformCommonApiWeightUnit {
  /** Kilograms. */
  Kg = 'KG',
  /** Pounds. */
  Lb = 'LB',
  /** Weight unit can't be classified due to an error. */
  UnspecifiedWeightUnit = 'UNSPECIFIED_WEIGHT_UNIT'
}

export type ComWixEcommerceValidationsSpiV1Target = {
  __typename?: 'ComWixEcommerceValidationsSpiV1Target';
  /** Specific line item violation. */
  lineItem?: Maybe<ComWixEcommerceValidationsSpiV1TargetLineItem>;
  /** General (other) violation. */
  other?: Maybe<ComWixEcommerceValidationsSpiV1TargetOther>;
};

export type ComWixEcommerceValidationsSpiV1TargetInput = {
  /** Specific line item violation. */
  lineItem?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetLineItemInput>;
  /** General (other) violation. */
  other?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetOtherInput>;
};

export type ComWixEcommerceValidationsSpiV1TargetLineItem = {
  __typename?: 'ComWixEcommerceValidationsSpiV1TargetLineItem';
  /** ID of the line item containing the violation. */
  id?: Maybe<Scalars['String']>;
  /** Location on a checkout or a cart page where the specific line item violation will be displayed. */
  name?: Maybe<ComWixEcommerceValidationsSpiV1TargetNameInLineItem>;
  /** Suggested fix for resolving the line item violation. */
  suggestedFix?: Maybe<ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix>;
};

export type ComWixEcommerceValidationsSpiV1TargetLineItemInput = {
  /** ID of the line item containing the violation. */
  id?: InputMaybe<Scalars['String']>;
  /** Location on a checkout or a cart page where the specific line item violation will be displayed. */
  name?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetNameInLineItem>;
  /** Suggested fix for resolving the line item violation. */
  suggestedFix?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix>;
};

export enum ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix {
  /** The line item should be removed from the cart or checkout to resolve the violation. */
  RemoveLineItem = 'REMOVE_LINE_ITEM',
  /** No suggested fix is specified. The user should refer to the violation description to resolve the issue. */
  UnknownSuggestedFix = 'UNKNOWN_SUGGESTED_FIX'
}

export enum ComWixEcommerceValidationsSpiV1TargetNameInLineItem {
  /** Default location, in case no specific location is specified. */
  LineItemDefault = 'LINE_ITEM_DEFAULT'
}

export enum ComWixEcommerceValidationsSpiV1TargetNameInOther {
  /** Delivery section. */
  Delivery = 'DELIVERY',
  /** Default location, in case no specific location is specified. */
  OtherDefault = 'OTHER_DEFAULT'
}

export type ComWixEcommerceValidationsSpiV1TargetOther = {
  __typename?: 'ComWixEcommerceValidationsSpiV1TargetOther';
  /** Location on a checkout or a cart page where a general (other) violation will be displayed. */
  name?: Maybe<ComWixEcommerceValidationsSpiV1TargetNameInOther>;
};

export type ComWixEcommerceValidationsSpiV1TargetOtherInput = {
  /** Location on a checkout or a cart page where a general (other) violation will be displayed. */
  name?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetNameInOther>;
};

export type ComWixEcommerceValidationsSpiV1Violation = {
  __typename?: 'ComWixEcommerceValidationsSpiV1Violation';
  /** Violation description. Can include rich text. Only HTTP or HTTPS links in the following format are allowed: `<a href="https://www.wix.com">Click me</a>`. */
  description?: Maybe<Scalars['String']>;
  /** Severity of the violation. The violations are shown on the cart and checkout pages. A warning is displayed as yellow, and allows a site visitor to proceed with caution. An error is displayed as red, and doesn't allow a site visitor to proceed with the eCommerce flow. */
  severity?: Maybe<ComWixEcommerceValidationsSpiV1ViolationSeverity>;
  /** Target location on a checkout or cart page where the violation will be displayed. */
  target?: Maybe<ComWixEcommerceValidationsSpiV1Target>;
};

export type ComWixEcommerceValidationsSpiV1ViolationInput = {
  /** Violation description. Can include rich text. Only HTTP or HTTPS links in the following format are allowed: `<a href="https://www.wix.com">Click me</a>`. */
  description?: InputMaybe<Scalars['String']>;
  /** Severity of the violation. The violations are shown on the cart and checkout pages. A warning is displayed as yellow, and allows a site visitor to proceed with caution. An error is displayed as red, and doesn't allow a site visitor to proceed with the eCommerce flow. */
  severity?: InputMaybe<ComWixEcommerceValidationsSpiV1ViolationSeverity>;
  /** Target location on a checkout or cart page where the violation will be displayed. */
  target?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetInput>;
};

export enum ComWixEcommerceValidationsSpiV1ViolationSeverity {
  /**
   * The user is blocked from moving forward in the flow.
   * For example, if callerContext is CART - moving to checkout is blocked. if callerContext is CHECKOUT, placing an order is blocked.
   */
  Error = 'ERROR',
  /** The user is allowed to move forward in the flow. */
  Warning = 'WARNING'
}

export type ComWixEventsUpstreamWixCommonAddress = {
  __typename?: 'ComWixEventsUpstreamWixCommonAddress';
  /** Main address line (usually street and number) as free text */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, Floor */
  addressLine2?: Maybe<Scalars['String']>;
  /** city name */
  city?: Maybe<Scalars['String']>;
  /** country code */
  country?: Maybe<Scalars['String']>;
  /** country full-name */
  countryFullname?: Maybe<Scalars['String']>;
  /** A string containing the human-readable address of this location */
  formattedAddress?: Maybe<Scalars['String']>;
  /** coordinates of the physical address */
  geocode?: Maybe<ComWixEventsUpstreamWixCommonAddressLocation>;
  /** Free text for human-to-human textual orientation aid purposes */
  hint?: Maybe<Scalars['String']>;
  /** zip/postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** a break down of the street to number and street name */
  streetAddress?: Maybe<ComWixEventsUpstreamWixCommonStreetAddress>;
  /** subdivision (usually state or region) code according to ISO 3166-2 */
  subdivision?: Maybe<Scalars['String']>;
  /** multi-level subdivisions from top to bottom */
  subdivisions?: Maybe<Array<Maybe<ComWixEventsUpstreamWixCommonSubdivision>>>;
};

export type ComWixEventsUpstreamWixCommonAddressInput = {
  /** Main address line (usually street and number) as free text */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, Floor */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** city name */
  city?: InputMaybe<Scalars['String']>;
  /** country code */
  country?: InputMaybe<Scalars['String']>;
  /** country full-name */
  countryFullname?: InputMaybe<Scalars['String']>;
  /** A string containing the human-readable address of this location */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** coordinates of the physical address */
  geocode?: InputMaybe<ComWixEventsUpstreamWixCommonAddressLocationInput>;
  /** Free text for human-to-human textual orientation aid purposes */
  hint?: InputMaybe<Scalars['String']>;
  /** zip/postal code */
  postalCode?: InputMaybe<Scalars['String']>;
  /** a break down of the street to number and street name */
  streetAddress?: InputMaybe<ComWixEventsUpstreamWixCommonStreetAddressInput>;
  /** subdivision (usually state or region) code according to ISO 3166-2 */
  subdivision?: InputMaybe<Scalars['String']>;
  /** multi-level subdivisions from top to bottom */
  subdivisions?: InputMaybe<Array<InputMaybe<ComWixEventsUpstreamWixCommonSubdivisionInput>>>;
};

export type ComWixEventsUpstreamWixCommonAddressLocation = {
  __typename?: 'ComWixEventsUpstreamWixCommonAddressLocation';
  /** address latitude coordinates */
  latitude?: Maybe<Scalars['Float']>;
  /** address longitude coordinates */
  longitude?: Maybe<Scalars['Float']>;
};

export type ComWixEventsUpstreamWixCommonAddressLocationInput = {
  /** address latitude coordinates */
  latitude?: InputMaybe<Scalars['Float']>;
  /** address longitude coordinates */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type ComWixEventsUpstreamWixCommonImage = {
  __typename?: 'ComWixEventsUpstreamWixCommonImage';
  /** Image alt text. Optional. */
  altText?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). Optional */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixEventsUpstreamWixCommonImageInput = {
  /** Image alt text. Optional. */
  altText?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). Optional */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixEventsUpstreamWixCommonPagingInput = {
  /** Number of items to load per page. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixEventsUpstreamWixCommonQueryV2Input = {
  /** Filter. See [supported fields and operators](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Pointer to page of results using offset.
   * See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination).
   */
  paging?: InputMaybe<ComWixEventsUpstreamWixCommonPagingInput>;
  /**
   * Sort object in the form [{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}]
   * See [supported fields](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixEventsUpstreamWixCommonSortingInput>>>;
};

export type ComWixEventsUpstreamWixCommonSortingInput = {
  /** Name of the field to sort by */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order (ASC/DESC). Defaults to ASC */
  order?: InputMaybe<WixCommonSortOrder>;
};

export type ComWixEventsUpstreamWixCommonStreetAddress = {
  __typename?: 'ComWixEventsUpstreamWixCommonStreetAddress';
  /** apartment number */
  apt?: Maybe<Scalars['String']>;
  /** street name */
  name?: Maybe<Scalars['String']>;
  /** street number */
  number?: Maybe<Scalars['String']>;
};

export type ComWixEventsUpstreamWixCommonStreetAddressInput = {
  /** apartment number */
  apt?: InputMaybe<Scalars['String']>;
  /** street name */
  name?: InputMaybe<Scalars['String']>;
  /** street number */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixEventsUpstreamWixCommonSubdivision = {
  __typename?: 'ComWixEventsUpstreamWixCommonSubdivision';
  /** subdivision short code */
  code?: Maybe<Scalars['String']>;
  /** subdivision full-name */
  name?: Maybe<Scalars['String']>;
  /** subdivision level */
  type?: Maybe<WixCommonSubdivisionSubdivisionType>;
  /** free text description of subdivision type */
  typeInfo?: Maybe<Scalars['String']>;
};

export type ComWixEventsUpstreamWixCommonSubdivisionInput = {
  /** subdivision short code */
  code?: InputMaybe<Scalars['String']>;
  /** subdivision full-name */
  name?: InputMaybe<Scalars['String']>;
  /** subdivision level */
  type?: InputMaybe<WixCommonSubdivisionSubdivisionType>;
  /** free text description of subdivision type */
  typeInfo?: InputMaybe<Scalars['String']>;
};

export type ComWixFormsUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixFormsUpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'ComWixFormsUpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<ComWixFormsUpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixFormsUpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixFormsUpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) for more information.
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Sort object. */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixFormsUpstreamWixCommonCursors = {
  __typename?: 'ComWixFormsUpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixFormsUpstreamWixCommonImage = {
  __typename?: 'ComWixFormsUpstreamWixCommonImage';
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixFormsUpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixPricingplansBenefitsApiV2BenefitBehaviorDiscountInput = {
  /** Absolute amount discount */
  moneyOffAmount?: InputMaybe<Scalars['String']>;
  /** Fixed-rate percent off discount */
  percentOffRate?: InputMaybe<Scalars['String']>;
};

export type ComWixPricingplansBenefitsApiV2BenefitBehaviorInput = {
  /** Entry pass for resources, e.g. a ticket for Bookings service or a ticket for Events. */
  defaultBehavior?: InputMaybe<Scalars['Void']>;
  /** Discount applied to paid resources */
  discount?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitBehaviorDiscountInput>;
};

export enum ComWixPricingplansBenefitsApiV2BenefitBenefitType {
  /** Limited benefit type */
  Limited = 'LIMITED',
  /** Should never be used */
  Undefined = 'UNDEFINED',
  /** Unlimited benefit type */
  Unlimited = 'UNLIMITED'
}

export type ComWixPricingplansBenefitsApiV2BenefitInput = {
  /** Id of the app associated with this benefit */
  appDefId?: InputMaybe<Scalars['String']>;
  /** Benefit behavior */
  behavior?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitBehaviorInput>;
  /** Benefit Type */
  benefitType?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitBenefitType>;
  /** Amount of credits that provided by this benefit */
  creditAmount?: InputMaybe<Scalars['Float']>;
  /** additional details related to benefit; limited to 20 entries, 20 symbols for key and 20 symbols for value */
  customFields?: InputMaybe<Scalars['JSON']>;
  /** return value only in case it required in the ListRequest, true means that benefit's type could be updated */
  editable?: InputMaybe<Scalars['Boolean']>;
  /** Benefit unique ID */
  id?: InputMaybe<Scalars['String']>;
  /** Resource IDs that serves by this benefit */
  resourceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum ComWixPricingplansBenefitsApiV2BenefitNotificationEvent {
  Created = 'Created',
  Deleted = 'Deleted',
  Updated = 'Updated'
}

export type ComWixPricingplansBenefitsApiV2BenefitNotificationInput = {
  /** App def ID */
  appDefId?: InputMaybe<Scalars['String']>;
  /** Current benefit details */
  benefit?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitInput>;
  /** Notification event */
  event?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitNotificationEvent>;
  /** Plan unique ID */
  planId?: InputMaybe<Scalars['String']>;
  /** Previous benefit */
  prevBenefit?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitInput>;
};

export type ComWixpressAdvancedSeoSeoSchema = {
  __typename?: 'ComWixpressAdvancedSeoSeoSchema';
  /** SEO general settings. */
  settings?: Maybe<ComWixpressAdvancedSeoSeoSchemaSettings>;
  /** SEO tag information. */
  tags?: Maybe<Array<Maybe<ComWixpressAdvancedSeoSeoSchemaTag>>>;
};

export type ComWixpressAdvancedSeoSeoSchemaInput = {
  /** SEO general settings. */
  settings?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaSettingsInput>;
  /** SEO tag information. */
  tags?: InputMaybe<Array<InputMaybe<ComWixpressAdvancedSeoSeoSchemaTagInput>>>;
};

export type ComWixpressAdvancedSeoSeoSchemaKeyword = {
  __typename?: 'ComWixpressAdvancedSeoSeoSchemaKeyword';
  /** Whether the keyword is the main focus keyword. */
  isMain?: Maybe<Scalars['Boolean']>;
  /** The source that added the keyword terms to the SEO settings. */
  origin?: Maybe<Scalars['String']>;
  /** Keyword value. */
  term?: Maybe<Scalars['String']>;
};

export type ComWixpressAdvancedSeoSeoSchemaKeywordInput = {
  /** Whether the keyword is the main focus keyword. */
  isMain?: InputMaybe<Scalars['Boolean']>;
  /** The source that added the keyword terms to the SEO settings. */
  origin?: InputMaybe<Scalars['String']>;
  /** Keyword value. */
  term?: InputMaybe<Scalars['String']>;
};

export type ComWixpressAdvancedSeoSeoSchemaSettings = {
  __typename?: 'ComWixpressAdvancedSeoSeoSchemaSettings';
  /** User-selected keyword terms for a specific page. */
  keywords?: Maybe<Array<Maybe<ComWixpressAdvancedSeoSeoSchemaKeyword>>>;
  /**
   * Whether the Auto Redirect feature, which creates `301 redirects` on a slug change, is enabled.
   *
   *
   * Default: `false` (Auto Redirect is enabled.)
   */
  preventAutoRedirect?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressAdvancedSeoSeoSchemaSettingsInput = {
  /** User-selected keyword terms for a specific page. */
  keywords?: InputMaybe<Array<InputMaybe<ComWixpressAdvancedSeoSeoSchemaKeywordInput>>>;
  /**
   * Whether the Auto Redirect feature, which creates `301 redirects` on a slug change, is enabled.
   *
   *
   * Default: `false` (Auto Redirect is enabled.)
   */
  preventAutoRedirect?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressAdvancedSeoSeoSchemaTag = {
  __typename?: 'ComWixpressAdvancedSeoSeoSchemaTag';
  /** SEO tag inner content. For example, `<title> inner content </title>`. */
  children?: Maybe<Scalars['String']>;
  /** Whether the tag is a custom tag. */
  custom?: Maybe<Scalars['Boolean']>;
  /** Whether the tag is disabled. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** SEO tag meta data. For example, `{"height": 300, "width": 240}`. */
  meta?: Maybe<Scalars['JSON']>;
  /**
   * A `{"key": "value"}` pair object where each SEO tag property (`"name"`, `"content"`, `"rel"`, `"href"`) contains a value.
   * For example: `{"name": "description", "content": "the description itself"}`.
   */
  props?: Maybe<Scalars['JSON']>;
  /**
   * SEO tag type.
   *
   *
   * Supported values: `title`, `meta`, `script`, `link`.
   */
  type?: Maybe<Scalars['String']>;
};

export type ComWixpressAdvancedSeoSeoSchemaTagInput = {
  /** SEO tag inner content. For example, `<title> inner content </title>`. */
  children?: InputMaybe<Scalars['String']>;
  /** Whether the tag is a custom tag. */
  custom?: InputMaybe<Scalars['Boolean']>;
  /** Whether the tag is disabled. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** SEO tag meta data. For example, `{"height": 300, "width": 240}`. */
  meta?: InputMaybe<Scalars['JSON']>;
  /**
   * A `{"key": "value"}` pair object where each SEO tag property (`"name"`, `"content"`, `"rel"`, `"href"`) contains a value.
   * For example: `{"name": "description", "content": "the description itself"}`.
   */
  props?: InputMaybe<Scalars['JSON']>;
  /**
   * SEO tag type.
   *
   *
   * Supported values: `title`, `meta`, `script`, `link`.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type ComWixpressAuthorizationAbacManagementEventsPolicyRemovedFromContributorInput = {
  accountId?: InputMaybe<Scalars['String']>;
  metaSiteId?: InputMaybe<Scalars['String']>;
  policyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressAuthorizationAbacManagementEventsPolicyUpdatedForContributorInput = {
  accountId?: InputMaybe<Scalars['String']>;
  metaSiteId?: InputMaybe<Scalars['String']>;
  newPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressBiOctopusApiV1BiEventInput = {
  eventType?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsAttendanceV2Attendance = {
  __typename?: 'ComWixpressBookingsAttendanceV2Attendance';
  /** Corresponding booking ID. */
  bookingId?: Maybe<Scalars['String']>;
  /** Corresponding event ID. */
  eventId?: Maybe<Scalars['String']>;
  /** ID of the `attendance` object. */
  id?: Maybe<Scalars['String']>;
  /**
   * Total number of participants that attended the session. By default, the number
   * of attendees is set to `1`, but you can set a number to greater than `1` if multiple
   * participants attended.
   *
   * Do not set to `0` to indicate that no one attended the session. Instead, set the `status` field to `NOT_ATTENDED`.
   *
   * Default: 1
   */
  numberOfAttendees?: Maybe<Scalars['Int']>;
  /** Corresponding session ID. */
  sessionId?: Maybe<Scalars['String']>;
  /** Status indicating if any participants attended the session. */
  status?: Maybe<ComWixpressBookingsAttendanceV2AttendanceAttendanceStatus>;
  /** Date and time the attendance status was updated. */
  statusUpdatedDate?: Maybe<Scalars['String']>;
  /** Date and time the attendance was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export enum ComWixpressBookingsAttendanceV2AttendanceAttendanceStatus {
  /** At least a single participant attended the session. */
  Attended = 'ATTENDED',
  /** No participants attended the session. */
  NotAttended = 'NOT_ATTENDED',
  /** There is no available attendance information. */
  NotSet = 'NOT_SET'
}

export type ComWixpressBookingsAttendanceV2AttendanceInput = {
  /** Corresponding booking ID. */
  bookingId?: InputMaybe<Scalars['String']>;
  /** Corresponding event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** ID of the `attendance` object. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Total number of participants that attended the session. By default, the number
   * of attendees is set to `1`, but you can set a number to greater than `1` if multiple
   * participants attended.
   *
   * Do not set to `0` to indicate that no one attended the session. Instead, set the `status` field to `NOT_ATTENDED`.
   *
   * Default: 1
   */
  numberOfAttendees?: InputMaybe<Scalars['Int']>;
  /** Corresponding session ID. */
  sessionId?: InputMaybe<Scalars['String']>;
  /** Status indicating if any participants attended the session. */
  status?: InputMaybe<ComWixpressBookingsAttendanceV2AttendanceAttendanceStatus>;
  /** Date and time the attendance status was updated. */
  statusUpdatedDate?: InputMaybe<Scalars['String']>;
  /** Date and time the attendance was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsAttendanceV2BulkAttendanceResult = {
  __typename?: 'ComWixpressBookingsAttendanceV2BulkAttendanceResult';
  /** Created or updated `attendance` object. */
  item?: Maybe<ComWixpressBookingsAttendanceV2Attendance>;
  /** Metadata for the created or updated `attendance` object. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestAttendanceDetailsInput = {
  /** Created or updated attendance information for a booking session. */
  attendance?: InputMaybe<ComWixpressBookingsAttendanceV2AttendanceInput>;
  /** Information about whether to send a message to the customer after their attendance was set. */
  participantNotification?: InputMaybe<ComWixpressBookingsAttendanceV2ParticipantNotificationInput>;
};

export type ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestInput = {
  /** List of attendance details for booking sessions to create or update. */
  attendanceDetails?: InputMaybe<Array<InputMaybe<ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestAttendanceDetailsInput>>>;
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsAttendanceV2BulkSetAttendanceResponse = {
  __typename?: 'ComWixpressBookingsAttendanceV2BulkSetAttendanceResponse';
  /** Information about the total number of successes and failures for the Bulk Set Attendance call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** List of created or updated `attendance` objects. */
  results?: Maybe<Array<Maybe<ComWixpressBookingsAttendanceV2BulkAttendanceResult>>>;
};

export type ComWixpressBookingsAttendanceV2CountAttendancesRequestInput = {
  /** Filter criteria for counting attendance records. If not provided, counts all attendance records for the contact. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressBookingsAttendanceV2CountAttendancesResponse = {
  __typename?: 'ComWixpressBookingsAttendanceV2CountAttendancesResponse';
  /** Total number of attendance records matching the filters. */
  count?: Maybe<Scalars['Int']>;
};

export type ComWixpressBookingsAttendanceV2GetAttendanceRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressBookingsAttendanceV2ParticipantNotificationInput = {
  /** Optional custom message to send to the participants about the changes to the booking. */
  message?: InputMaybe<Scalars['String']>;
  /**
   * Specify whether to send the message about the changes to the customer.
   *
   * Default: `false`
   */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsAttendanceV2QueryAttendanceRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressBookingsAttendanceV2UpstreamWixCommonQueryV2Input>;
};

export type ComWixpressBookingsAttendanceV2QueryAttendanceResponse = {
  __typename?: 'ComWixpressBookingsAttendanceV2QueryAttendanceResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressBookingsAttendanceV2Attendance>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressBookingsAttendanceV2SetAttendanceRequestInput = {
  /** Attendance to create or update. */
  attendance?: InputMaybe<ComWixpressBookingsAttendanceV2AttendanceInput>;
  /** Information about whether to send a message to a customer after their attendance was set. */
  participantNotification?: InputMaybe<ComWixpressBookingsAttendanceV2ParticipantNotificationInput>;
};

export type ComWixpressBookingsAttendanceV2SetAttendanceResponse = {
  __typename?: 'ComWixpressBookingsAttendanceV2SetAttendanceResponse';
  /** Created or updated attendance. */
  attendance?: Maybe<ComWixpressBookingsAttendanceV2Attendance>;
};

export type ComWixpressBookingsAttendanceV2UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   *
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of `Attendance` objects to return.
   *
   * Default: `50`
   * Maximum: `1000`
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressBookingsAttendanceV2UpstreamWixCommonQueryV2Input = {
  /**
   * Cursor token pointing to a page of results. In the first request,
   * specify `cursorPaging.limit`. For following requests, specify the
   * retrieved `cursorPaging.cursor` token and not `query.filter` or
   * `query.sort`.
   */
  cursorPaging?: InputMaybe<ComWixpressBookingsAttendanceV2UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object. See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) for more information.
   *
   * For a detailed list of supported fields and operators, see [Supported Filters and Sorting](https://dev.wix.com/api/rest/wix-bookings/attendance/supported-filters).
   *
   * Max: 1 filter
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[ {"fieldName":"sortField1","order":"ASC"}, {"fieldName":"sortField2","order":"DESC"} ]`
   *
   * For details about sorting, see [Supported Filters and Sorting](https://dev.wix.com/api/rest/wix-bookings/attendance/supported-filters).
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressBookingsAttendanceV2UpstreamWixCommonSortingInput>>>;
};

export enum ComWixpressBookingsAttendanceV2UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ComWixpressBookingsAttendanceV2UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<ComWixpressBookingsAttendanceV2UpstreamWixCommonSortOrder>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceRequestInput = {
  /** Optional. If provided, the resources field is ignored. */
  batchedResources?: InputMaybe<Array<InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceRequestInput>>>;
  /** List of resource entities to create. */
  resources?: InputMaybe<Array<InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceInput>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceResponse = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceResponse';
  /** List of the created resources. */
  resources?: Maybe<Array<Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceBatchDeleteResourceRequestInput = {
  /** List of resource IDs to delete. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocation = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocation';
  /** The ID of the business location. Has to be non-empty */
  locationId?: Maybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocationInput = {
  /** The ID of the business location. Has to be non-empty */
  locationId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceRequestInput = {
  /** Resource to create. */
  resource?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceInput>;
  /**
   * List of schedules to be assigned for the created resource. Currently only a single schedule is allowed.
   * If provided, any schedules in the resource entity will be ignored.
   */
  schedules?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceResponse = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceResponse';
  /** Created resource. */
  resource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceRequestInput = {
  /** ID of the resource to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceResponse = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceResponse';
  /** Deleted resource ID. */
  id?: Maybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceRequestInput = {
  excludeSchedule?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceResponse = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceResponse';
  /** The business resource. */
  resource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserRequestInput = {
  /** The id of the resource to link. */
  resourceId?: InputMaybe<Scalars['String']>;
  /** The email address of the Wix user to link. This field is only intended for internal as it is needed to proxy the request to StaffMembersService. */
  userEmail?: InputMaybe<Scalars['String']>;
  /** The id of Wix user to link. */
  userId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserResponse = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserResponse';
  /** The updated resource. */
  resource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceListResourcesRequestInput = {
  query?: InputMaybe<ComWixBookingsUpstreamWixCommonQueryInput>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceListResourcesResponse = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceListResourcesResponse';
  metadata?: Maybe<ComWixBookingsCommonApiV1QueryMetaData>;
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** List of resources matching the query object. */
  resources?: Maybe<Array<Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesRequestInput = {
  /** Whether to include resources with non-empty group in response. False by default. */
  includeResourcesWithGroups?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<ComWixBookingsUpstreamWixCommonQueryV2Input>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesResponse = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesResponse';
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** List of resources matching the query object. */
  resources?: Maybe<Array<Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceResource = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceResource';
  /**
   * True if the resource is available in all locations, false if the resource is available only in a specific business location. Empty if `has_working_hours_schedule` is true.
   * Information on the location(s) can then be found in the sessions of one of the connected schedules.
   */
  availableInAllLocations?: Maybe<Scalars['Boolean']>;
  /** Information about business location connected to the resource. Should be empty if `available_in_all_locations` is true or if no business location exists in OS. */
  businessLocation?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocation>;
  /** Resource description. */
  description?: Maybe<Scalars['String']>;
  /** Resource email address. */
  email?: Maybe<Scalars['String']>;
  /**
   * This schedule contains the sessions in which this resource is booked.
   * Equals to the first element of `schedules` array.
   */
  eventsSchedule?: Maybe<ComWixBookingsSchedulesApiV1Schedule>;
  /** The ID of the Resource Group that this resource belongs to. This is an optional field as not every resource is part of a group. */
  groupId?: Maybe<Scalars['String']>;
  /**
   * This field determines how to resolve the working hours of this resource. Defaults to `true` if was not set by the client.
   * When set to `true` then working hours (including location information) can be found in the sessions of a schedule that is connected to this resource.
   * If `false`, then the working hours are not specified as sessions of a connected schedule. Instead this resource is then by definition full-time available (7 x 24).
   */
  hasWorkingHoursSchedule?: Maybe<Scalars['Boolean']>;
  /** Resource ID. */
  id?: Maybe<Scalars['String']>;
  /** Resource images. */
  images?: Maybe<Array<Maybe<WixCommonImage>>>;
  /** Resource name. */
  name?: Maybe<Scalars['String']>;
  /** Resource phone number. */
  phone?: Maybe<Scalars['String']>;
  /** List of IDs of schedules owned by this resource. */
  scheduleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Deprecated. Please use scheduleIds. List of the schedules owned by this resource. Min size 1. */
  schedules?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Schedule>>>;
  /** Resource status. Default: `CREATED`. */
  status?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceResourceStatus>;
  /** Deprecated. Please use tags. */
  tag?: Maybe<Scalars['String']>;
  /** Resource tags. Tags are used to identify, group, and filter the different types of resources. For example, 'staff' or 'room'. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The type of of the resource. Currently this field is only filled for staff and will contain the ID as configured in the
   * BOOKINGS_RESOURCE_TYPES component of the Bookings app.
   */
  type?: Maybe<Scalars['String']>;
  /**
   * Wix user ID, if the resource is associated with the Wix user.
   * A staff member resource can be associated with a Wix user via assignment of a permissions role in the business manager.
   */
  wixUserId?: Maybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceResourceInput = {
  /**
   * True if the resource is available in all locations, false if the resource is available only in a specific business location. Empty if `has_working_hours_schedule` is true.
   * Information on the location(s) can then be found in the sessions of one of the connected schedules.
   */
  availableInAllLocations?: InputMaybe<Scalars['Boolean']>;
  /** Information about business location connected to the resource. Should be empty if `available_in_all_locations` is true or if no business location exists in OS. */
  businessLocation?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocationInput>;
  /** Resource description. */
  description?: InputMaybe<Scalars['String']>;
  /** Resource email address. */
  email?: InputMaybe<Scalars['String']>;
  /**
   * This schedule contains the sessions in which this resource is booked.
   * Equals to the first element of `schedules` array.
   */
  eventsSchedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  /** The ID of the Resource Group that this resource belongs to. This is an optional field as not every resource is part of a group. */
  groupId?: InputMaybe<Scalars['String']>;
  /**
   * This field determines how to resolve the working hours of this resource. Defaults to `true` if was not set by the client.
   * When set to `true` then working hours (including location information) can be found in the sessions of a schedule that is connected to this resource.
   * If `false`, then the working hours are not specified as sessions of a connected schedule. Instead this resource is then by definition full-time available (7 x 24).
   */
  hasWorkingHoursSchedule?: InputMaybe<Scalars['Boolean']>;
  /** Resource ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Resource images. */
  images?: InputMaybe<Array<InputMaybe<WixCommonImageInput>>>;
  /** Resource name. */
  name?: InputMaybe<Scalars['String']>;
  /** Resource phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** List of IDs of schedules owned by this resource. */
  scheduleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Deprecated. Please use scheduleIds. List of the schedules owned by this resource. Min size 1. */
  schedules?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>>>;
  /** Resource status. Default: `CREATED`. */
  status?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceResourceStatus>;
  /** Deprecated. Please use tags. */
  tag?: InputMaybe<Scalars['String']>;
  /** Resource tags. Tags are used to identify, group, and filter the different types of resources. For example, 'staff' or 'room'. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * The type of of the resource. Currently this field is only filled for staff and will contain the ID as configured in the
   * BOOKINGS_RESOURCE_TYPES component of the Bookings app.
   */
  type?: InputMaybe<Scalars['String']>;
  /**
   * Wix user ID, if the resource is associated with the Wix user.
   * A staff member resource can be associated with a Wix user via assignment of a permissions role in the business manager.
   */
  wixUserId?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationEvent {
  /** The resource was created. */
  Created = 'Created',
  /** The resource was deleted. */
  Deleted = 'Deleted',
  /** The schedule was updated. */
  ScheduleUpdated = 'Schedule_Updated',
  /** Undefined resource event. */
  Undefined = 'UNDEFINED',
  /** The resource was updated. */
  Updated = 'Updated'
}

export type ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationInput = {
  /** Event type. */
  event?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationEvent>;
  /**
   * Updated resource entity.
   * 'resource.schedules' is deprecated and will not be returned. Please use 'resource.scheduleIds' instead.
   */
  resource?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceInput>;
};

export enum ComWixpressBookingsResourcesCoreApiV1ResourceResourceResourceStatus {
  /** The resource was created. */
  Created = 'CREATED',
  /** The resource was deleted. */
  Deleted = 'DELETED',
  /** Undefined resource status. */
  Undefined = 'UNDEFINED',
  /** The resource was updated. */
  Updated = 'UPDATED'
}

export type ComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerRequestInput = {
  /** The id of the resource to unlink. */
  resourceId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerResponse = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerResponse';
  /** The updated resource. */
  resource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Resource to update. */
  resource?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceInput>;
  /**
   * Actions to perform on the resources schedules. Can contain schedules to create, update, and cancel.
   * Either the 'schedules' or 'schedule_actions' should be specified but not both. If both are provided, the schedules in the resource entity is ignored.
   */
  scheduleActions?: InputMaybe<ComWixBookingsSchedulesApiV1BatchRequestInput>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceResponse = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceResponse';
  /** Updated resource. */
  resource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>;
  /** Updated schedules. */
  schedules?: Maybe<ComWixBookingsSchedulesApiV1BatchResponse>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleRequestInput = {
  /** Fieldmask for schedule */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Resource ID to update. */
  resourceId?: InputMaybe<Scalars['String']>;
  /** Schedule to update. */
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleResponse = {
  __typename?: 'ComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleResponse';
  /** Updated schedule. */
  schedule?: Maybe<ComWixBookingsSchedulesApiV1Schedule>;
};

export type ComWixpressBookingsServicesApiV1BookingPolicyInput = {
  /** Minimum number of minutes before the start of a session that a booking can be made. For a schedule, this is relative to the start time of the next session, excluding past sessions. Default value is taken form BusinessServicesPolicy. */
  bookUpToXMinutesBefore?: InputMaybe<Scalars['Int']>;
  /** Bookings approval policy for the service. Empty by default. */
  bookingsApprovalPolicy?: InputMaybe<ComWixpressBookingsServicesApiV1BookingsApprovalPolicyInput>;
  /** Minimum number of minutes before the start of a session that a booking can be canceled or rescheduled. Default value is taken form BusinessServicesPolicy. */
  cancelRescheduleUpToXMinutesBefore?: InputMaybe<Scalars['Int']>;
  /** User defined cancellation policy message. */
  cancellationPolicy?: InputMaybe<Scalars['String']>;
  /** How far in advance a booking can be made. Default value is taken form BusinessServicesPolicy. */
  futureBookingsPolicy?: InputMaybe<ComWixpressBookingsServicesApiV1FutureBookingPolicyInput>;
  /** Whether online booking is available. Defaults to true. */
  isBookOnlineAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Whether bookings for the service can be canceled. Defaults to true. */
  isCancelAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Whether bookings for the service can be rescheduled. Defaults to true. */
  isRescheduleAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Maximum number of participants for a single booking. Defaults to 1. */
  maxParticipantsPerBooking?: InputMaybe<Scalars['Int']>;
  /**
   * A list of booking policy field names of fields that override the respective values of the default business booking policy.
   * Currently only 'service.policy.bookUpToXMinutesBefore' field is supported
   */
  overrideBusinessPolicyFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Waitlist policy for the service. Default value is taken form BusinessServicesPolicy. */
  waitingListPolicy?: InputMaybe<ComWixpressBookingsServicesApiV1WaitingListPolicyInput>;
};

export type ComWixpressBookingsServicesApiV1BookingsApprovalPolicyInput = {
  /** Whether bookings to the service require approval. */
  isBusinessApprovalRequired?: InputMaybe<Scalars['Boolean']>;
  /** Whether the booking requests affect the session or slot availability. For example, 3 booking requests for a 10-person session will cause the session to have 7 available spots, before the requests are approved. */
  requestsAffectsAvailability?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsServicesApiV1BusinessServicesPolicy = {
  __typename?: 'ComWixpressBookingsServicesApiV1BusinessServicesPolicy';
  /** Minimum amount of time to make a booking before the start of the booked item. For sessions, this is relative to the start time of the session. For schedules, this is relative to the start time of the first session, excluding past sessions. Defaults to 0. */
  bookUpToXMinutesBefore?: Maybe<Scalars['Int']>;
  /** Minimum time that a booking can be canceled or rescheduled before the session starts. Defaults to 0. */
  cancelRescheduleUpToXMinutesBefore?: Maybe<Scalars['Int']>;
  /** User defined cancellation policy message. */
  cancellationPolicy?: Maybe<Scalars['String']>;
  /** An object specifying how far in advance a booking can be made. */
  futureBookingsPolicy?: Maybe<ComWixpressBookingsServicesApiV1FutureBookingPolicy>;
  /** Waitlist policy for the service. Empty by default. */
  waitingListPolicy?: Maybe<ComWixpressBookingsServicesApiV1WaitingListPolicy>;
};

export type ComWixpressBookingsServicesApiV1BusinessServicesPolicyInput = {
  /** Minimum amount of time to make a booking before the start of the booked item. For sessions, this is relative to the start time of the session. For schedules, this is relative to the start time of the first session, excluding past sessions. Defaults to 0. */
  bookUpToXMinutesBefore?: InputMaybe<Scalars['Int']>;
  /** Minimum time that a booking can be canceled or rescheduled before the session starts. Defaults to 0. */
  cancelRescheduleUpToXMinutesBefore?: InputMaybe<Scalars['Int']>;
  /** User defined cancellation policy message. */
  cancellationPolicy?: InputMaybe<Scalars['String']>;
  /** An object specifying how far in advance a booking can be made. */
  futureBookingsPolicy?: InputMaybe<ComWixpressBookingsServicesApiV1FutureBookingPolicyInput>;
  /** Waitlist policy for the service. Empty by default. */
  waitingListPolicy?: InputMaybe<ComWixpressBookingsServicesApiV1WaitingListPolicyInput>;
};

export type ComWixpressBookingsServicesApiV1CategoryInput = {
  /** Custom properties that can be associated with the category. */
  customProperties?: InputMaybe<Scalars['JSON']>;
  /** Category ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Category name. */
  name?: InputMaybe<Scalars['String']>;
  /** Sort order of the category in the live site and dashboard. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /**
   * Category status.
   *
   * Default: `CREATED`
   */
  status?: InputMaybe<ComWixpressBookingsServicesApiV1CategoryStatus>;
};

export enum ComWixpressBookingsServicesApiV1CategoryNotificationEvent {
  /** Category was created. */
  Created = 'Created',
  /** Category was deleted. */
  Deleted = 'Deleted',
  /** Category was updated. */
  Updated = 'Updated'
}

export type ComWixpressBookingsServicesApiV1CategoryNotificationInput = {
  category?: InputMaybe<ComWixpressBookingsServicesApiV1CategoryInput>;
  event?: InputMaybe<ComWixpressBookingsServicesApiV1CategoryNotificationEvent>;
};

export enum ComWixpressBookingsServicesApiV1CategoryStatus {
  /** The category was created. */
  Created = 'CREATED',
  /** The category was deleted. */
  Deleted = 'DELETED'
}

export type ComWixpressBookingsServicesApiV1DeleteMetadataInput = {
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsServicesApiV1FutureBookingPolicy = {
  __typename?: 'ComWixpressBookingsServicesApiV1FutureBookingPolicy';
  /** How far in advance, in minutes, a session can be booked. Defaults to 10,080 minutes (3 days). */
  limitXMinutesToTheFuture?: Maybe<Scalars['Int']>;
  /** Whether a limit is imposed on advance bookings. */
  shouldLimit?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsServicesApiV1FutureBookingPolicyInput = {
  /** How far in advance, in minutes, a session can be booked. Defaults to 10,080 minutes (3 days). */
  limitXMinutesToTheFuture?: InputMaybe<Scalars['Int']>;
  /** Whether a limit is imposed on advance bookings. */
  shouldLimit?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsServicesApiV1GetPolicyResponse = {
  __typename?: 'ComWixpressBookingsServicesApiV1GetPolicyResponse';
  /** Service policy. */
  policy?: Maybe<ComWixpressBookingsServicesApiV1BusinessServicesPolicy>;
};

export type ComWixpressBookingsServicesApiV1MediaInput = {
  /** Cover image associated with the service. */
  coverMedia?: InputMaybe<ComWixpressBookingsServicesApiV1MediaItemInput>;
  /** Images associated with the service. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressBookingsServicesApiV1MediaItemInput>>>;
  /** Primary image associated with the service. */
  mainMedia?: InputMaybe<ComWixpressBookingsServicesApiV1MediaItemInput>;
};

export type ComWixpressBookingsServicesApiV1MediaItemInput = {
  /** Image metadata. */
  image?: InputMaybe<WixCommonImageInput>;
};

export type ComWixpressBookingsServicesApiV1PaymentOptionsInput = {
  /** Whether a booking made for the service can be paid in a customized way, defined by the API. */
  custom?: InputMaybe<Scalars['Boolean']>;
  /** Whether a booking made for the service can be paid using Wix Pricing Plans. */
  wixPaidPlan?: InputMaybe<Scalars['Boolean']>;
  /** Whether a booking made for the service can be paid in person. */
  wixPayInPerson?: InputMaybe<Scalars['Boolean']>;
  /** Whether a booking made for the service can be paid online through Wix. */
  wixPayOnline?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsServicesApiV1ServiceInfoInput = {
  /** Service description. */
  description?: InputMaybe<Scalars['String']>;
  /** Images associated with the service. Deprecated. */
  images?: InputMaybe<Array<InputMaybe<WixCommonImageInput>>>;
  /** Images associated with the service. Optional. Not supported yet. */
  media?: InputMaybe<ComWixpressBookingsServicesApiV1MediaInput>;
  /** Service name. */
  name?: InputMaybe<Scalars['String']>;
  /** Short service description. */
  tagLine?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsServicesApiV1ServiceInput = {
  /** Advanced SEO data */
  advancedSeoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** ID of the form that visitors fill out when booking the service. */
  bookingFormId?: InputMaybe<Scalars['String']>;
  /** ID of the category to which the service belongs. */
  categoryId?: InputMaybe<Scalars['String']>;
  /** Set of custom properties for the service. */
  customProperties?: InputMaybe<Scalars['JSON']>;
  /** Service ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether a conference is to be generated for the service. */
  includeConferenceOption?: InputMaybe<Scalars['Boolean']>;
  /** Information about the service. */
  info?: InputMaybe<ComWixpressBookingsServicesApiV1ServiceInfoInput>;
  /** Payment options available for use when booking the service. */
  paymentOptions?: InputMaybe<ComWixpressBookingsServicesApiV1PaymentOptionsInput>;
  /** Description of the bookings policy for the service. */
  policy?: InputMaybe<ComWixpressBookingsServicesApiV1BookingPolicyInput>;
  /**
   * List of schedule IDs for the sessions and slots that can be booked for the service.
   * The list can include schedules with any `status` values, however the Bookings application only uses the schedules with a `status` of `"CREATED"`. There is only one schedule with a status of `"CREATED"` per service. The ID of that schedule must always be the first in the list.
   */
  scheduleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** SEO data */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Sort order of the service within its category. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Service status. */
  status?: InputMaybe<ComWixpressBookingsServicesApiV1ServiceStatus>;
};

export enum ComWixpressBookingsServicesApiV1ServiceNotificationEvent {
  Created = 'Created',
  Deleted = 'Deleted',
  Unspecified = 'Unspecified',
  Updated = 'Updated'
}

export type ComWixpressBookingsServicesApiV1ServiceNotificationInput = {
  deleteMetadata?: InputMaybe<ComWixpressBookingsServicesApiV1DeleteMetadataInput>;
  event?: InputMaybe<ComWixpressBookingsServicesApiV1ServiceNotificationEvent>;
  policy?: InputMaybe<ComWixpressBookingsServicesApiV1BusinessServicesPolicyInput>;
  /** Updated service entity. */
  service?: InputMaybe<ComWixpressBookingsServicesApiV1ServiceInput>;
};

export enum ComWixpressBookingsServicesApiV1ServiceStatus {
  /** The default service status. */
  Created = 'CREATED',
  /** The service is deleted. */
  Deleted = 'DELETED'
}

export type ComWixpressBookingsServicesApiV1UpdatePolicyRequestInput = {
  /** Service policy. */
  policy?: InputMaybe<ComWixpressBookingsServicesApiV1BusinessServicesPolicyInput>;
};

export type ComWixpressBookingsServicesApiV1WaitingListPolicy = {
  __typename?: 'ComWixpressBookingsServicesApiV1WaitingListPolicy';
  /** Number of spots available in the waitlist. Defaults to 10 spots. */
  capacity?: Maybe<Scalars['Int']>;
  /** Whether waitlisting is enabled for the service. */
  isEnabled?: Maybe<Scalars['Boolean']>;
  /** Amount of time a participant is given to book, once notified that a spot is available. Defaults to 10 minutes. */
  timeWindowMinutes?: Maybe<Scalars['Int']>;
};

export type ComWixpressBookingsServicesApiV1WaitingListPolicyInput = {
  /** Number of spots available in the waitlist. Defaults to 10 spots. */
  capacity?: InputMaybe<Scalars['Int']>;
  /** Whether waitlisting is enabled for the service. */
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Amount of time a participant is given to book, once notified that a spot is available. Defaults to 10 minutes. */
  timeWindowMinutes?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationInput = {
  /** Fields by which to group items for the aggregation. If empty, the aggregation is carried out on all items in the collection. */
  groupingFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Operations to carry out on the data in each grouping. */
  operations?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationInput>>>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationAverageInput = {
  /** Name of the field for which to calculate the average value. */
  itemFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationInput = {
  /** Calculate the average value of a specified field for all items in the grouping. */
  average?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationAverageInput>;
  /** Calculate the number of items in the grouping. */
  itemCount?: InputMaybe<Scalars['Void']>;
  /** Calculate the maximum value of a specified field for all items in the grouping. */
  max?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMaxInput>;
  /** Calculate the minimum value of a specified field for all items in the grouping. */
  min?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMinInput>;
  /** Name of the field containing results of the operation. */
  resultFieldName?: InputMaybe<Scalars['String']>;
  /** Calculate the sum of values of a specified field for all items in the grouping. */
  sum?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationSumInput>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMaxInput = {
  /** Name of the field for which to calculate the maximum value. */
  itemFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMinInput = {
  /** Name of the field for which to calculate the minimum value. */
  itemFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationSumInput = {
  /** Name of the field for which to calculate the sum. */
  itemFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestInput = {
  /** Aggregation applied to the data. */
  aggregation?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationInput>;
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /** ID of the collection on which to run the aggregation. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Filter applied to the processed data following the aggregation. See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_the-filter-section) for information on how to structure a filter object.
   * **Note:** The values you provide for each filter field must adhere to that field's type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).
   */
  finalFilter?: InputMaybe<Scalars['JSON']>;
  /**
   * Filter applied to the collection's data prior to running the aggregation. See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_the-filter-section) for information on how to structure a filter object.
   *
   * **Note:** The values you provide for each filter field must adhere to that field's type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).
   */
  initialFilter?: InputMaybe<Scalars['JSON']>;
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the total count in the response for a query with offset paging.
   * When `true`, the `pagingMetadata` object in the response contains a `total` field.
   *
   * Default: `false`
   */
  returnTotalCount?: InputMaybe<Scalars['Boolean']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortingInput>>>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsResponse = {
  __typename?: 'ComWixpressCloudDataApiDataAggregateDataItemsResponse';
  /** Paging information. */
  pagingMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2>;
  /** Aggregation results. */
  results?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorAvgInput = {
  /** Expression to be evaluated and used for calculating the average value in the grouping. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorFirstInput = {
  /** Expression to be evaluated and used as the first value in the grouping. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorInput = {
  /** Calculate the average value of a specified field for all items in the grouping. */
  avg?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorAvgInput>;
  /** Use first result from calculated grouping. */
  first?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorFirstInput>;
  /** Use last result from calculated grouping. */
  last?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorLastInput>;
  /** Calculate the maximum value of a specified field for all items in the grouping. */
  max?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMaxInput>;
  /** Calculate the minimum value of a specified field for all items in the grouping. */
  min?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMinInput>;
  /** Execute calculation by group & push result to resulting group document. */
  push?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorPushInput>;
  /** Accumulator result field name. */
  resultFieldName?: InputMaybe<Scalars['String']>;
  /** Calculate the sum of values of a specified field for all items in the grouping. */
  sum?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorSumInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorLastInput = {
  /** Expression to be evaluated and used as the last value in the grouping. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMaxInput = {
  /** Expression to be evaluated and used as the maximum value in the grouping. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMinInput = {
  /** Expression to be evaluated and used as the minimum value in the grouping. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorPushInput = {
  /** Expression to be evaluated and pushed to the resulting document. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorSumInput = {
  /** Expression to be evaluated and used as the sum value in the grouping. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAbsOperationInput = {
  /** Expression to calculate absolute value of. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAddOperationInput = {
  /** Add expressions. */
  expressions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionCeilOperationInput = {
  /** Expression to calculate ceil value of. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionConcatOperationInput = {
  /** Expression to concatenate. */
  expressions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionDivideOperationInput = {
  /** Expression to divide from */
  firstExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /** Expression to divide by */
  secondExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionFloorOperationInput = {
  /** Expression to calculate floor value of. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput = {
  /** Abs expression */
  abs?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAbsOperationInput>;
  /** Add expression */
  add?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAddOperationInput>;
  /** Ceil expression */
  ceil?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionCeilOperationInput>;
  /** Concat expression */
  concat?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionConcatOperationInput>;
  /** Divide expression */
  divide?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionDivideOperationInput>;
  /** Field path to the value of field in the document. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Floor expression */
  floor?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionFloorOperationInput>;
  /** Length expression */
  length?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionLengthOperationInput>;
  /** Mod expression */
  mod?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionModOperationInput>;
  /** Multiply expression */
  multiply?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionMultiplyOperationInput>;
  /** Numeric constant value. */
  numericValue?: InputMaybe<Scalars['Float']>;
  /** String constant value. */
  stringValue?: InputMaybe<Scalars['String']>;
  /** Stringify expression */
  stringify?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionStringifyOperationInput>;
  /** Substring expression */
  substring?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubstringOperationInput>;
  /** Subtract expression */
  subtract?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubtractOperationInput>;
  /** Sum expression */
  sum?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSumOperationInput>;
  /** ToLower expression */
  toLower?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToLowerOperationInput>;
  /** ToUpper expression */
  toUpper?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToUpperOperationInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionLengthOperationInput = {
  /** Expression to calculate length of. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionModOperationInput = {
  /** Expression to calculate modulo from */
  firstExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /** Expression to calculate modulo by */
  secondExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionMultiplyOperationInput = {
  /** Multiply expressions. */
  expressions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionStringifyOperationInput = {
  /** Expression to convert to string. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubstringOperationInput = {
  /** Expression to extract substring from. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /** Number expression of length of substring. */
  lengthExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /** Number expression of start index of substring. */
  startExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubtractOperationInput = {
  /** Expression to subtract from */
  firstExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /** Expression to subtract by */
  secondExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSumOperationInput = {
  /** Sum expressions. */
  expressions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToLowerOperationInput = {
  /** Expression to convert to lower case. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToUpperOperationInput = {
  /** Expression to convert to upper case. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupIdInput = {
  /** Group expression value. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /** Group identifier key. */
  key?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupInput = {
  /** Operations to carry out on the data in each grouping. */
  accumulators?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorInput>>>;
  /** Fields by which to group items for the aggregation. If empty, the aggregation is carried out on all items in the collection. */
  ids?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupIdInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /** ID of the collection on which to run the aggregation. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the total count in the response for a query with offset paging.
   * When `true`, the `pagingMetadata` object in the response contains a `total` field.
   *
   * Default: `false`
   */
  returnTotalCount?: InputMaybe<Scalars['Boolean']>;
  /** Aggregation operations applied (in order) to the data. */
  stages?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestStageInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestObjectToArrayInput = {
  /** Field name of source document array field */
  arrayFieldName?: InputMaybe<Scalars['String']>;
  /** Target field name for the projected document. */
  destinationFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionExcludeInput = {
  /** Field name of the field to be excluded from the resulting document. */
  fieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput = {
  /** When used all fields are included in resulting document except specified fields. */
  exclude?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionExcludeInput>;
  /** When used include only specified field in resulting document. */
  include?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionIncludeInput>;
  /** When used new fields created based on underlying arithmetic operations. */
  projectionExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionExpressionInput>;
  /** Nested fields to be projected in the resulting document. */
  projectionFields?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionFieldsInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionIncludeInput = {
  /** Field name of the field to be included in the resulting document. */
  fieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionInput = {
  /** Field transformation projections. */
  fields?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionExpressionInput = {
  /** Expression to be evaluated. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /** Field name of resulting expression */
  fieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionFieldsInput = {
  /** Field name of resulting document */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Fields to be included in the resulting document. */
  fields?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestSortingInput = {
  /** Sort by one or more fields. */
  values?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortingInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestStageInput = {
  /**
   * Filtering stage. See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_the-filter-section) for information on how to structure a filter object.
   *
   * **Note:** The values you provide for each filter field must adhere to that field's type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Grouping stage. */
  group?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupInput>;
  /** Limit the number of resulting documents. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Transform object to array. */
  objectToArray?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestObjectToArrayInput>;
  /** Project document to include specific fields with possibility of renaming them. */
  projection?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionInput>;
  /** Skip resulting documents. */
  skip?: InputMaybe<Scalars['Int']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestSortingInput>;
  /** Unwind array field. */
  unwindArray?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestUnwindArrayInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestUnwindArrayInput = {
  /** Field name of source document array field */
  arrayFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsResponse = {
  __typename?: 'ComWixpressCloudDataApiDataAggregatePipelineDataItemsResponse';
  /** Paging information. */
  pagingMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2>;
  /** Aggregation results. */
  results?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type ComWixpressCloudDataApiDataBulkDataItemReferenceResult = {
  __typename?: 'ComWixpressCloudDataApiDataBulkDataItemReferenceResult';
  /** The action attempted for the reference. */
  action?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionType>;
  /** The reference for which the action was attempted. Only returned if `returnEntity` is `true` in the request and the action is successful. */
  dataItemReference?: Maybe<ComWixpressCloudDataApiDataDataItemReference>;
  /** Metadata related to the reference for which the action was attempted. */
  referenceMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata>;
};

export type ComWixpressCloudDataApiDataBulkDataItemResult = {
  __typename?: 'ComWixpressCloudDataApiDataBulkDataItemResult';
  /** Action attempted for the data item. */
  action?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionType>;
  /**
   * Updated data item.
   *
   * Returned if `returnEntity` is set to `true` and the action is successful.
   */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
  /** Item metadata. */
  itemMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata>;
};

export type ComWixpressCloudDataApiDataBulkInsertDataItemReferencesRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection containing the referring items. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** References to insert. */
  dataItemReferences?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataDataItemReferenceInput>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Whether to return the inserted data item references.
   * When `true`, the `results` objects contain a `dataItemReference` field.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkInsertDataItemReferencesResponse = {
  __typename?: 'ComWixpressCloudDataApiDataBulkInsertDataItemReferencesResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the inserted references. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemReferenceResult>>>;
};

export type ComWixpressCloudDataApiDataBulkInsertDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection in which to insert the items. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Data items to insert. */
  dataItems?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataDataItemInput>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options. */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Whether to return the inserted data items.
   * When `true`, the `results` objects contain a `dataItem` field.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkInsertDataItemsResponse = {
  __typename?: 'ComWixpressCloudDataApiDataBulkInsertDataItemsResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the inserted items. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemResult>>>;
};

export type ComWixpressCloudDataApiDataBulkPatchDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional options specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * Learn more about [querying Wix app collections](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-app-collections/querying-wix-app-collections).
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection that contains the items to patch. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /**
   * [Collection environment](https://support.wix.com/en/article/cms-about-sandbox-and-live-collections-and-syncing) from which to delete item.
   *
   * Default: `LIVE`.
   */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Patches to apply to the items. */
  patches?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataPatchInput>>>;
  /**
   * Options for the [Publish plugin](https://support.wix.com/en/article/cms-controlling-live-site-item-visibility-from-your-collection).
   *
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the patched data items. When `true`, each item in the `results` array contains a `dataItem` field with the full patched data item.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * > **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkPatchDataItemsResponse = {
  __typename?: 'ComWixpressCloudDataApiDataBulkPatchDataItemsResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Patched items. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemResult>>>;
};

export type ComWixpressCloudDataApiDataBulkRemoveDataItemReferencesRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection containing the referring items. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** References to remove. */
  dataItemReferences?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataDataItemReferenceInput>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
};

export type ComWixpressCloudDataApiDataBulkRemoveDataItemReferencesResponse = {
  __typename?: 'ComWixpressCloudDataApiDataBulkRemoveDataItemReferencesResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the removed references. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemReferenceResult>>>;
};

export type ComWixpressCloudDataApiDataBulkRemoveDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection from which to remove the item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** IDs of data items to remove. */
  dataItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkRemoveDataItemsResponse = {
  __typename?: 'ComWixpressCloudDataApiDataBulkRemoveDataItemsResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the removed data items. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemResult>>>;
};

export type ComWixpressCloudDataApiDataBulkSaveDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection in which to insert or update the items. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Data items to insert or update. */
  dataItems?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataDataItemInput>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the saved data item.
   * When `true`, the `results` objects contain a `dataItem` field.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkSaveDataItemsResponse = {
  __typename?: 'ComWixpressCloudDataApiDataBulkSaveDataItemsResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the saved items. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemResult>>>;
};

export type ComWixpressCloudDataApiDataBulkUpdateDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection in which to update items. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Data items to update. */
  dataItems?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataDataItemInput>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the updated data items.
   * When `true`, the `results` objects contain a `dataItem` field.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkUpdateDataItemsResponse = {
  __typename?: 'ComWixpressCloudDataApiDataBulkUpdateDataItemsResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the updated items. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemResult>>>;
};

export type ComWixpressCloudDataApiDataCountDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** ID of the collection for which to count query results. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Filter object in the following format:
   *
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`.
   *
   * Examples of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`.
   *
   * **Note:** The values you provide for each field must adhere to that field's type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataCountDataItemsResponse = {
  __typename?: 'ComWixpressCloudDataApiDataCountDataItemsResponse';
  /** Number of items matching the query. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataDataItem = {
  __typename?: 'ComWixpressCloudDataApiDataDataItem';
  /**
   * Data item contents.
   *
   * Property-value pairs representing the data item's payload. When retrieving a data item, it also includes the following read-only fields:
   *
   * + `_id`: Item ID.
   * + `_createdDate`: Date and time the item was added to the collection.
   * + `_updatedDate`: Date and time the item was last modified. When the item is first inserted, `_createdDate` and `_updatedDate` have the same value.
   * + `_ownerId`: ID of the user who created the item. Can be modified with site owner permissions.
   */
  data?: Maybe<Scalars['JSON']>;
  /** ID of the collection this item belongs to */
  dataCollectionId?: Maybe<Scalars['String']>;
  /** Data item ID. */
  id?: Maybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataDataItemInput = {
  /**
   * Data item contents.
   *
   * Property-value pairs representing the data item's payload. When retrieving a data item, it also includes the following read-only fields:
   *
   * + `_id`: Item ID.
   * + `_createdDate`: Date and time the item was added to the collection.
   * + `_updatedDate`: Date and time the item was last modified. When the item is first inserted, `_createdDate` and `_updatedDate` have the same value.
   * + `_ownerId`: ID of the user who created the item. Can be modified with site owner permissions.
   */
  data?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection this item belongs to */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Data item ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataDataItemReference = {
  __typename?: 'ComWixpressCloudDataApiDataDataItemReference';
  /** ID of the referenced item. */
  referencedItemId?: Maybe<Scalars['String']>;
  /** Referring item field containing the references to the referenced items. */
  referringItemFieldName?: Maybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: Maybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataDataItemReferenceInput = {
  /** ID of the referenced item. */
  referencedItemId?: InputMaybe<Scalars['String']>;
  /** Referring item field containing the references to the referenced items. */
  referringItemFieldName?: InputMaybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressCloudDataApiDataFieldModificationAction {
  /**
   * Appends the specified value to the array.
   *
   * Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).
   */
  AppendToArray = 'APPEND_TO_ARRAY',
  /** Increments the specified field by the specified value. To decrement, specify a negative value. */
  IncrementField = 'INCREMENT_FIELD',
  /** Clears the specified field. */
  RemoveField = 'REMOVE_FIELD',
  /**
   * Removes the first instance of the specified value from the array.
   *
   * Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).
   */
  RemoveFromArray = 'REMOVE_FROM_ARRAY',
  /** Sets the specified field to the specified value. */
  SetField = 'SET_FIELD',
  UnknownAction = 'UNKNOWN_ACTION'
}

export type ComWixpressCloudDataApiDataFieldModificationAppendToArrayOptionsInput = {
  /** Value to append to the specified array. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressCloudDataApiDataFieldModificationIncrementFieldOptionsInput = {
  /** Numerical value by which to increment the field value. To decrement, specify a negative value. */
  value?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressCloudDataApiDataFieldModificationInput = {
  /** Patch action to apply to the specified field. */
  action?: InputMaybe<ComWixpressCloudDataApiDataFieldModificationAction>;
  /** Options for appending a value to the specified array. Required when `action` is `APPEND_TO_ARRAY`. */
  appendToArrayOptions?: InputMaybe<ComWixpressCloudDataApiDataFieldModificationAppendToArrayOptionsInput>;
  /**
   * Path of the field to be modified. For example: `title`.
   *
   * Nested fields can be specified using dot notation. For example: `address.street`.
   */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Options for incrementing the value of the specified field. Required when `action` is `INCREMENT_FIELD`. */
  incrementFieldOptions?: InputMaybe<ComWixpressCloudDataApiDataFieldModificationIncrementFieldOptionsInput>;
  /** Options for removing a value from the specified array. Required when `action` is `REMOVE_FROM_ARRAY`. */
  removeFromArrayOptions?: InputMaybe<ComWixpressCloudDataApiDataFieldModificationRemoveFromArrayOptionsInput>;
  /** Options for setting the value of the specified field. Required when `action` is `SET_FIELD`. */
  setFieldOptions?: InputMaybe<ComWixpressCloudDataApiDataFieldModificationSetFieldOptionsInput>;
};

export type ComWixpressCloudDataApiDataFieldModificationRemoveFromArrayOptionsInput = {
  /** Value whose first instance is removed from the specified array. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressCloudDataApiDataFieldModificationSetFieldOptionsInput = {
  /** Value to set for the specified field. This replaces the existing value. */
  value?: InputMaybe<Scalars['JSON']>;
};

export enum ComWixpressCloudDataApiDataFieldUpdateAction {
  AppendToArray = 'APPEND_TO_ARRAY',
  IncrementField = 'INCREMENT_FIELD',
  RemoveField = 'REMOVE_FIELD',
  RemoveFromArray = 'REMOVE_FROM_ARRAY',
  SetField = 'SET_FIELD',
  UnknownAction = 'UNKNOWN_ACTION'
}

export type ComWixpressCloudDataApiDataFieldUpdateAppendToArrayInput = {
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressCloudDataApiDataFieldUpdateIncrementFieldInput = {
  value?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressCloudDataApiDataFieldUpdateRemoveFromArrayInput = {
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressCloudDataApiDataFieldUpdateSetFieldInput = {
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressCloudDataApiDataGetDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** ID of the collection from which to retrieve the data item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Fields to return for the item. Only fields specified in the array are included in the response. If the array is empty, all fields are returned.
   * **Note:** The `_id` system field is always returned.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataInsertDataItemReferenceRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection in which to insert the reference. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Reference to insert */
  dataItemReference?: InputMaybe<ComWixpressCloudDataApiDataDataItemReferenceInput>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
};

export type ComWixpressCloudDataApiDataInsertDataItemReferenceResponse = {
  __typename?: 'ComWixpressCloudDataApiDataInsertDataItemReferenceResponse';
  /** Inserted reference. */
  dataItemReference?: Maybe<ComWixpressCloudDataApiDataDataItemReference>;
};

export type ComWixpressCloudDataApiDataInsertDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection in which to insert the item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Item to insert. */
  dataItem?: InputMaybe<ComWixpressCloudDataApiDataDataItemInput>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** If true, referenced items will be included. */
  includeReferencedItems?: InputMaybe<Scalars['Boolean']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataInsertDataItemResponse = {
  __typename?: 'ComWixpressCloudDataApiDataInsertDataItemResponse';
  /** Inserted data item. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
};

export type ComWixpressCloudDataApiDataIsReferencedDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** ID of the collection containing the referring data item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /** ID of the item that may be referenced. */
  referencedItemId?: InputMaybe<Scalars['String']>;
  /** Field to check for a reference to the item that may be referenced. */
  referringItemFieldName?: InputMaybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataIsReferencedDataItemResponse = {
  __typename?: 'ComWixpressCloudDataApiDataIsReferencedDataItemResponse';
  /** Whether the specified reference exists. */
  isReferenced?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataOptionsInput = {
  appOptions?: InputMaybe<Scalars['JSON']>;
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataOptionsPublishPluginOptionsInput>;
  /**
   * Should hooks execution be suppressed.
   * This option can only be used with Corvid backend
   * code identity.
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataOptionsPublishPluginOptionsInput = {
  showDraftItems?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataPatchDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional options specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * Learn more about [querying Wix app collections](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-app-collections/querying-wix-app-collections).
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection that contains the item to patch. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /**
   * [Collection environment](https://support.wix.com/en/article/cms-about-sandbox-and-live-collections-and-syncing) from which to delete item.
   *
   * Default: `LIVE`.
   */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Patch to apply to the item. */
  patch?: InputMaybe<ComWixpressCloudDataApiDataPatchInput>;
  /**
   * Options for the [Publish plugin](https://support.wix.com/en/article/cms-controlling-live-site-item-visibility-from-your-collection).
   *
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks. When `true`, data hooks typically triggered by this method don't run.
   *
   * > **Note:** This can only be used in code that runs in a [Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`.
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataPatchDataItemResponse = {
  __typename?: 'ComWixpressCloudDataApiDataPatchDataItemResponse';
  /** Patched data item. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
};

export type ComWixpressCloudDataApiDataPatchInput = {
  /** ID of the item to patch. */
  dataItemId?: InputMaybe<Scalars['String']>;
  /** Modifications to apply. */
  fieldModifications?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataFieldModificationInput>>>;
};

export type ComWixpressCloudDataApiDataPublishPluginOptionsInput = {
  /**
   * Whether to include draft items.
   *
   * When `true`, both published and draft items are affected. Default: `false`.
   */
  includeDraftItems?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataQueryDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** ID of the collection to query. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Properties for which to include referenced items in the query's results.
   * Up to 50 referenced items can be included for each item that matches the query.
   */
  includeReferencedItems?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /** Query preferences. For more details on using queries, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language). */
  query?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonQueryV2Input>;
  /** Options for retrieving referenced items. */
  referencedItemOptions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataQueryDataItemsRequestReferencedItemOptionsInput>>>;
  /** Request information about this collection caching */
  requestCachingInfo?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to return the total count in the response for a query with offset paging.
   * When `true`, the `pagingMetadata` object in the response contains a `total` field.
   *
   * Default: `false`
   */
  returnTotalCount?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataQueryDataItemsRequestReferencedItemOptionsInput = {
  /** Field containing references in the queried item. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Maximum number of referenced items to include for each queried item. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataQueryDataItemsResponse = {
  __typename?: 'ComWixpressCloudDataApiDataQueryDataItemsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataDataItem>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressCloudDataApiDataQueryDistinctValuesRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /** ID of the collection to query. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Item field name for which to return all distinct values. */
  fieldName?: InputMaybe<Scalars['String']>;
  /**
   * Filter object in the following format:
   *
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`.
   *
   * Examples of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`.
   *
   * **Note:** The values you provide for each field must adhere to that field's type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /** Sort order. */
  order?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortOrder>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the total count in the response for a query with offset paging.
   * When `true`, the `pagingMetadata` object in the response contains a `total` field.
   *
   * Default: `false`
   */
  returnTotalCount?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataQueryDistinctValuesResponse = {
  __typename?: 'ComWixpressCloudDataApiDataQueryDistinctValuesResponse';
  /** List of distinct values contained in the field specified in `fieldName`. */
  distinctValues?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  /** Paging information. */
  pagingMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2>;
};

export type ComWixpressCloudDataApiDataQueryReferencedDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying:
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /** ID of the collection containing the referring item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Fields to return for each referenced item. Only fields specified in the array are included in the response. If the array is empty, all fields are returned.
   * **Note:** The `_id` system field is always returned.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /** Order of the returned referenced items. Sorted by the date each item was referenced. */
  order?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortOrder>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /** Field containing references in the referring item. */
  referringItemFieldName?: InputMaybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: InputMaybe<Scalars['String']>;
  /** IDs of the referring items. */
  referringItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Whether to return the total count in the response.
   * When `true`, the `pagingMetadata` object in the response contains a `total` field.
   *
   * Default: `false`
   */
  returnTotalCount?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataQueryReferencedDataItemsResponse = {
  __typename?: 'ComWixpressCloudDataApiDataQueryReferencedDataItemsResponse';
  /** Paging information. */
  pagingMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2>;
  /** Referenced items and/or IDs. For successfully resolved references, the referenced data item is returned. For references that can't be resolved, the ID is returned. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseReferencedResult>>>;
};

export type ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseReferencedResult = {
  __typename?: 'ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseReferencedResult';
  /** Data item referenced. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
  /** ID of the referring item. */
  referringItemId?: Maybe<Scalars['String']>;
  /** Unresolved reference. Appears instead of the data item when the reference doesn't resolve, for example, when an ID isn't found or if an item is in draft state. */
  unresolvedReference?: Maybe<ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseUnresolvedReference>;
};

export type ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseUnresolvedReference = {
  __typename?: 'ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseUnresolvedReference';
  /** ID of unresolved referenced item */
  referencedItemId?: Maybe<Scalars['String']>;
  /** Field specified to query for references. */
  referringItemFieldName?: Maybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: Maybe<Scalars['String']>;
  /** Flag is set if item exists, but user is not authorized to read it */
  unauthorized?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataRemoveDataItemReferenceRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection containing the referring item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Reference to remove. */
  dataItemReference?: InputMaybe<ComWixpressCloudDataApiDataDataItemReferenceInput>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
};

export type ComWixpressCloudDataApiDataRemoveDataItemReferenceResponse = {
  __typename?: 'ComWixpressCloudDataApiDataRemoveDataItemReferenceResponse';
  /** Removed reference. */
  dataItemReference?: Maybe<ComWixpressCloudDataApiDataDataItemReference>;
};

export type ComWixpressCloudDataApiDataRemoveDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection from which to remove the item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** ID of the item to remove. */
  dataItemId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataRemoveDataItemResponse = {
  __typename?: 'ComWixpressCloudDataApiDataRemoveDataItemResponse';
  /** Removed item. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
};

export type ComWixpressCloudDataApiDataReplaceDataItemReferencesRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection containing the referring item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** List of new referenced item IDs to replace the existing ones. */
  newReferencedItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /** Field containing references in the referring item. */
  referringItemFieldName?: InputMaybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataReplaceDataItemReferencesResponse = {
  __typename?: 'ComWixpressCloudDataApiDataReplaceDataItemReferencesResponse';
  /** Updated references. */
  dataItemReferences?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataDataItemReference>>>;
};

export type ComWixpressCloudDataApiDataSaveDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection in which to insert or update the item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Data item to insert or update. */
  dataItem?: InputMaybe<ComWixpressCloudDataApiDataDataItemInput>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** If true, referenced items will be included. */
  includeReferencedItems?: InputMaybe<Scalars['Boolean']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataSaveDataItemResponse = {
  __typename?: 'ComWixpressCloudDataApiDataSaveDataItemResponse';
  /** The action carried out for the item. */
  action?: Maybe<ComWixpressCloudDataApiDataSaveDataItemResponseAction>;
  /** Inserted or updated data item. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
};

export enum ComWixpressCloudDataApiDataSaveDataItemResponseAction {
  /** A new item was added to the collection. */
  Inserted = 'INSERTED',
  /** Undefined action. */
  UnknownAction = 'UNKNOWN_ACTION',
  /** An existing item in the collection was updated. */
  Updated = 'UPDATED'
}

export type ComWixpressCloudDataApiDataSearchDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /** ID of the collection to search. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: `LIVE` or `SANDBOX`. */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * NOT IMPLEMENTED!
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language. If not provided, result text is not translated.
   *
   * > **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   */
  language?: InputMaybe<Scalars['String']>;
  /**
   * Options for the Publish plugin.
   *
   * This plugin allows items to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Options for retrieving referenced items.
   *
   * Learn more about [using reference fields](https://support.wix.com/en/article/cms-using-reference-fields-to-display-content-from-multiple-collections).
   */
  referencedItemOptions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataSearchDataItemsRequestReferencedItemOptionsInput>>>;
  /** Search query configuration. */
  search?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSearchInput>;
  /**
   * Whether to suppress data hooks.
   *
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * Default: `false`.
   *
   * > **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataSearchDataItemsRequestReferencedItemOptionsInput = {
  /** Field in the retrieved item that contains references. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Maximum number of referenced items to include for each retrieved item. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataSearchDataItemsResponse = {
  __typename?: 'ComWixpressCloudDataApiDataSearchDataItemsResponse';
  /** Retrieved items. */
  dataItems?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataDataItem>>>;
  /** Paging configuration. */
  pagingMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2>;
};

export type ComWixpressCloudDataApiDataTruncateDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /** ID of the collection to truncate. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
};

export type ComWixpressCloudDataApiDataUpdateDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection containing the existing item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Updated data item content. The existing data item's content is replaced entirely. */
  dataItem?: InputMaybe<ComWixpressCloudDataApiDataDataItemInput>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** If true, referenced items will be included. */
  includeReferencedItems?: InputMaybe<Scalars['Boolean']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataUpdateDataItemResponse = {
  __typename?: 'ComWixpressCloudDataApiDataUpdateDataItemResponse';
  /** Updated data item. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata = {
  __typename?: 'ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata';
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
};

export enum ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionType {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Patch = 'PATCH',
  UnknownActionType = 'UNKNOWN_ACTION_TYPE',
  Update = 'UPDATE'
}

export type ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonCursors = {
  __typename?: 'ComWixpressCloudDataApiDataUpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata = {
  __typename?: 'ComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata';
  /** In case of failure, the error details. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Does not appear if the item ID is missing. For example, when item creation fails. */
  id?: Maybe<Scalars['String']>;
  /** Original index of the item in the array specified in the request. Use this to match items in the request with those in the response. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2 = {
  __typename?: 'ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Whether the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used, `returnTotalCount` is `true` in the request, and `tooManyToCount` is false. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonQueryV2Input = {
  /**
   * Cursor pointing to a page of results. Not used in the first request.
   *
   * Subsequent requests use the cursor and ignore `filter` and `sort`.
   */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /**
   * Fields to include for each retrieved item. Only fields specified in the array are included in the response. If the array is empty, all fields are returned.
   *
   * > **Note:** The `_id` system field is always returned.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Learn more about filters in [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of retrieved items. */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /**
   * Sort object.
   *
   * Learn more about sorting in [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortingInput>>>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsInput = {
  /** Search query. Search terms are separated by whitespace. */
  expression?: InputMaybe<Scalars['String']>;
  /**
   * Whether to use fuzzy search to accommodate typos and partial matches.
   *
   * Default: `false`.
   */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /**
   * Determines how multiple search terms are handled.
   *
   * Default: `OR`.
   */
  mode?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsMode>;
};

export enum ComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsMode {
  /** Logical **AND** relationship. All search terms must exist for an item to be retrieved. */
  And = 'AND',
  /** Logical **OR** relationship. Any search term must exist for an item to be retrieved. */
  Or = 'OR'
}

export type ComWixpressCloudDataApiDataUpstreamWixCommonSearchInput = {
  /**
   * Cursor pointing to a page of results. Not used in the first request.
   *
   * Subsequent requests use this cursor and ignore `filter` and `sort`.
   */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /**
   * Fields to include for each retrieved item. Only fields specified in the array are included in the response. If the array is empty, all fields are returned.
   *
   * > **Note:** The `_id` system field is always returned.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Learn more about filters in [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Options for limiting and skipping the number of retrieved items. */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /** Text to search in the specified collection. */
  search?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsInput>;
  /**
   * Sort object.
   *
   * Learn more about sorting in [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortingInput>>>;
};

export enum ComWixpressCloudDataApiDataUpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ComWixpressCloudDataApiDataUpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortOrder>;
};

export enum ComWixpressCloudDataApiEnvironment {
  /** Collection [live environment](https://support.wix.com/en/article/cms-about-sandbox-and-live-collections-and-syncing#live-collections). */
  Live = 'LIVE',
  /** Collection [sandbox environment](https://support.wix.com/en/article/cms-about-sandbox-and-live-collections-and-syncing#sandbox-collections). */
  Sandbox = 'SANDBOX',
  /** If the [collection's sandbox environment is enabled](https://support.wix.com/en/article/cms-accessing-and-syncing-your-sandbox-and-live-collections#enabling-sandbox-collections), run the task in the collection's sandbox environment. If not, run the task in the collection's live environment. */
  SandboxPreferred = 'SANDBOX_PREFERRED',
  /** Place holder. Never returned by the service. */
  UnknownEnvironment = 'UNKNOWN_ENVIRONMENT'
}

export type ComWixpressContactsCoreApiV4ActivityIcon = {
  __typename?: 'ComWixpressContactsCoreApiV4ActivityIcon';
  /** Icon name */
  name?: Maybe<Scalars['String']>;
  /** Icon url */
  url?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4ActivityIconInput = {
  /** Icon name */
  name?: InputMaybe<Scalars['String']>;
  /** Icon url */
  url?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4AssigneesWrapper = {
  __typename?: 'ComWixpressContactsCoreApiV4AssigneesWrapper';
  /** List of site contributor user IDs. */
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4AssigneesWrapperInput = {
  /** List of site contributor user IDs. */
  items?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4BulkAddSegmentToContactsRequestInput = {
  /** List of Contact ids */
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of existing segment ids */
  existsSegmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Segment id */
  segmentId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkAddSegmentToContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4BulkAddSegmentToContactsResponse';
  /** Metadata on the bulk action */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** List of action results */
  results?: Maybe<Array<Maybe<WixCommonItemMetadata>>>;
};

export type ComWixpressContactsCoreApiV4BulkDeleteContactsRequestInput = {
  /**
   * Indicates whether to delete the contact that is a member. If set to `true`, the contact is deleted even
   * if it is a member and the member is also deleted. Default: `false`
   */
  deleteMember?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filter object.
   *
   * Possible filters:
   * `$eq`, `$exists`, `$gt`, `$gte`, `$hasAll`, `$hasSome`, `$in`, `$lt`, `$lte`, `$ne`, `$startsWith`.
   *
   * See [Sort, Filter, and Search](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search)
   * for a detailed list of supported filters for contact properties, extended fields, and custom fields.
   *
   *
   * Example:
   * `{ "filter": { "info.name.last": "Smith" } }`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Plain text search for an exact match, up to 100 characters.
   *
   * Searchable fields:
   *
   * - `info.name.first`
   * - `info.name.last`
   * - `info.emails.email`
   * - `info.phones.phone`
   */
  search?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkDeleteContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4BulkDeleteContactsResponse';
  /**
   * Bulk job ID.
   * The job's status can be retrieved with Get Bulk Job.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsRequestInput = {
  /**
   * Filter options.
   * Labels will be removed from contacts that meet the `filter` and `search` criteria.
   *
   * See
   * [Field Support for Filtering, Sorting, and Searching](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search)
   * for a list of supported filters and fields.
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * List of label keys to add to the contacts.
   *
   * Label keys must exist to be added to the contact.
   * Contact labels can be created or retrieved with
   * [Find or Create Label](https://dev.wix.com/api/rest/contacts/labels/find-or-create-label)
   * or
   * [List Labels](https://dev.wix.com/api/rest/contacts/labels/list-labels)
   */
  labelKeysToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of label keys to remove from the contacts. */
  labelKeysToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Plain text search for an exact match, up to 100 characters.
   * Labels will be removed from contacts that meet the `filter` and `search` criteria.
   *
   * See
   * [Field Support for Filtering, Sorting, and Searching](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search)
   * for a list of searchable fields.
   */
  search?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsResponse';
  /**
   * Bulk job ID.
   * The job's status can be retrieved with Get Bulk Job.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsRequestInput = {
  /** List of Contact ids */
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Segment id */
  segmentId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsResponse';
  /** Metadata on the bulk action */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** List of action results */
  results?: Maybe<Array<Maybe<WixCommonItemMetadata>>>;
};

export type ComWixpressContactsCoreApiV4BulkUpdateContactsRequestInput = {
  /**
   * Set of fields to update.
   * Fields that aren't included in `fieldMask.paths` are ignored.
   * See
   * [Field Masks in Update Requests](https://dev.wix.com/api/rest/contacts/contacts/field-masks-in-update-requests)
   * for details on working with field masks.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Possible filters:
   * `$eq`, `$exists`, `$gt`, `$gte`, `$hasAll`, `$hasSome`, `$in`, `$lt`, `$lte`, `$ne`, `$startsWith`.
   *
   * See [Sort, Filter, and Search](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search)
   * for a detailed list of supported filters for contact properties, extended fields, and custom fields.
   *
   *
   * Example:
   * `{ "filter": { "info.name.last": "Smith" } }`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Contact info. */
  info?: InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>;
  /**
   * Plain text search for an exact match, up to 100 characters.
   *
   * Searchable fields:
   *
   * - `info.name.first`
   * - `info.name.last`
   * - `info.emails.email`
   * - `info.phones.phone`
   */
  search?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkUpdateContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4BulkUpdateContactsResponse';
  /**
   * Bulk job ID.
   * The job's status can be retrieved with Get Bulk Job.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkUpsertContactsRequestInput = {
  info?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>>>;
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressContactsCoreApiV4BulkUpsertContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4BulkUpsertContactsResponse';
  metadata?: Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseMetadata>;
  results?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItem>>>;
};

export type ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItem = {
  __typename?: 'ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItem';
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  metadata?: Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadata>;
};

export type ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadata = {
  __typename?: 'ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadata';
  action?: Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataAction>;
  error?: Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataError>;
  id?: Maybe<Scalars['String']>;
  originalIndex?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataAction {
  Created = 'CREATED',
  Unknown = 'UNKNOWN',
  Updated = 'UPDATED'
}

export type ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataError = {
  __typename?: 'ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataError';
  /** Error code. */
  code?: Maybe<Scalars['String']>;
  /** Error details. */
  message?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkUpsertContactsResponseMetadata = {
  __typename?: 'ComWixpressContactsCoreApiV4BulkUpsertContactsResponseMetadata';
  totalCreated?: Maybe<Scalars['Int']>;
  totalFailure?: Maybe<Scalars['Int']>;
  totalSuccess?: Maybe<Scalars['Int']>;
  totalUpdated?: Maybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4Contact = {
  __typename?: 'ComWixpressContactsCoreApiV4Contact';
  /** Date and time the contact was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Contact ID. */
  id?: Maybe<Scalars['String']>;
  /** Contact's details. */
  info?: Maybe<ComWixpressContactsCoreApiV4ContactInfo>;
  /** Details about the contact's last action in the site. */
  lastActivity?: Maybe<ComWixpressContactsCoreApiV4ContactActivity>;
  /** Contact's member info. */
  memberInfo?: Maybe<ComWixpressContactsCoreApiV4MemberInfo>;
  /**
   * Contact's profile picture.
   * This can contain an image URL and a Wix Media image ID.
   *
   * > **Deprecation Notice:**
   * > This property has been replaced with
   * > `info.picture`
   * > and will be removed on March 31, 2022. If your app uses this property,
   * > we recommend updating your code as soon as possible.
   */
  picture?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonImage>;
  /** Contact's primary email details. */
  primaryEmail?: Maybe<ComWixpressContactsCoreApiV4PrimaryEmail>;
  /** Contact's primary phone and email. */
  primaryInfo?: Maybe<ComWixpressContactsCoreApiV4PrimaryContactInfo>;
  /** Contact's primary phone details. */
  primaryPhone?: Maybe<ComWixpressContactsCoreApiV4PrimaryPhone>;
  /**
   * Revision number, which increments by 1 each time the contact is updated.
   * To prevent conflicting changes,
   * the existing `revision` must be specified when updating a contact.
   */
  revision?: Maybe<Scalars['Int']>;
  /** Contact's segment IDs */
  segments?: Maybe<ComWixpressContactsCoreApiV4SegmentsWrapper>;
  /** Details about the contact's source. */
  source?: Maybe<ComWixpressContactsCoreApiV4ContactSource>;
  /** Date and time the contact was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  walletsVirtualReference?: Maybe<WixRiseV1QueryWalletsResponse>;
};


export type ComWixpressContactsCoreApiV4ContactWalletsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryWalletsRequestInput>;
};

export type ComWixpressContactsCoreApiV4ContactActivity = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactActivity';
  /** Date and time of the last action. */
  activityDate?: Maybe<Scalars['String']>;
  /** Contact's last action in the site. */
  activityType?: Maybe<ComWixpressContactsCoreApiV4ContactActivityContactActivityType>;
  /** Date and time of the activity. */
  date?: Maybe<Scalars['String']>;
  /** Activity description. Translated. */
  description?: Maybe<Scalars['String']>;
  /** Activity Icon */
  icon?: Maybe<ComWixpressContactsCoreApiV4ActivityIcon>;
};

export enum ComWixpressContactsCoreApiV4ContactActivityContactActivityType {
  /** Became a new Wix Marketplace lead. */
  ArenaNewLead = 'ARENA_NEW_LEAD',
  /** Booked an appointment. */
  BookingsAppointment = 'BOOKINGS_APPOINTMENT',
  /** Made a purchase with a pay button. */
  CashierButtonPurchase = 'CASHIER_BUTTON_PURCHASE',
  /** Became a new contact. */
  ContactCreated = 'CONTACT_CREATED',
  /** Merged with another contact. */
  ContactMerged = 'CONTACT_MERGED',
  /** Abandoned a shopping cart. */
  EcomCartAbandon = 'ECOM_CART_ABANDON',
  /** Checked out shopping cart and submitted buyer info (but didn’t complete the purchase yet). */
  EcomCheckoutBuyer = 'ECOM_CHECKOUT_BUYER',
  /** Made a purchase. */
  EcomPurchase = 'ECOM_PURCHASE',
  /** RSVP'd to an event. */
  EventsRsvp = 'EVENTS_RSVP',
  /** Submitted a form. */
  FormSubmitted = 'FORM_SUBMITTED',
  /** Visited the site. */
  General = 'GENERAL',
  /** Canceled a Wix Hotels reservation. */
  HotelsCancel = 'HOTELS_CANCEL',
  /** Confirmed a Wix Hotels reservation. */
  HotelsConfirmation = 'HOTELS_CONFIRMATION',
  /** Paid for a Wix Hotels reservation. */
  HotelsPurchase = 'HOTELS_PURCHASE',
  /** Made a Wix Hotels reservation. */
  HotelsReservation = 'HOTELS_RESERVATION',
  /** Started a chat. */
  InboxFormSubmitted = 'INBOX_FORM_SUBMITTED',
  /** Sent a new message to the site. */
  InboxMessageFromCustomer = 'INBOX_MESSAGE_FROM_CUSTOMER',
  /** Received a message from the site. */
  InboxMessageToCustomer = 'INBOX_MESSAGE_TO_CUSTOMER',
  /** Paid a payment request. */
  InboxPaymentRequestPaid = 'INBOX_PAYMENT_REQUEST_PAID',
  /** An invoice is now overdue. */
  InvoiceOverdue = 'INVOICE_OVERDUE',
  /** Paid an invoice. */
  InvoicePay = 'INVOICE_PAY',
  /** Logged in. */
  MemberLogin = 'MEMBER_LOGIN',
  /** Requested a site membership. */
  MemberRegister = 'MEMBER_REGISTER',
  /** Was approved, blocked, or unblocked. */
  MemberStatusChanged = 'MEMBER_STATUS_CHANGED',
  /** Subscribed to a site newsletter through a form. */
  NewsletterSubscriptionFormSubmitted = 'NEWSLETTER_SUBSCRIPTION_FORM_SUBMITTED',
  /** Subscription status to site newsletters is not set. */
  NewsletterSubscriptionNotSet = 'NEWSLETTER_SUBSCRIPTION_NOT_SET',
  /** Subscription status to site newsletters is pending confirmation. */
  NewsletterSubscriptionPending = 'NEWSLETTER_SUBSCRIPTION_PENDING',
  /** Subscribed to a site newsletter. */
  NewsletterSubscriptionSubscribe = 'NEWSLETTER_SUBSCRIPTION_SUBSCRIBE',
  /** Unsubscribed from a site newsletter. */
  NewsletterSubscriptionUnsubscribe = 'NEWSLETTER_SUBSCRIPTION_UNSUBSCRIBE',
  /** Subscription to phone notificatons is not set. */
  PhoneSubscriptionNotSet = 'PHONE_SUBSCRIPTION_NOT_SET',
  /** Subscription to phone notificatons is pending confirmation. */
  PhoneSubscriptionPending = 'PHONE_SUBSCRIPTION_PENDING',
  /** Subscribed to phone notifications. */
  PhoneSubscriptionSubscribe = 'PHONE_SUBSCRIPTION_SUBSCRIBE',
  /** Subscribed to phone notifications. */
  PhoneSubscriptionUnsubscribe = 'PHONE_SUBSCRIPTION_UNSUBSCRIBE',
  /** Accepted a price quote. */
  PriceQuoteAccept = 'PRICE_QUOTE_ACCEPT',
  /** A price quote has expired. */
  PriceQuoteExpire = 'PRICE_QUOTE_EXPIRE',
  /** Ordered food with Wix Restaurants. */
  RestaurantsOrder = 'RESTAURANTS_ORDER',
  /** Made a Wix Restaurants reservation. */
  RestaurantsReservation = 'RESTAURANTS_RESERVATION',
  /** Clicked a link in an email from the site. */
  ShoutoutClick = 'SHOUTOUT_CLICK',
  /** Opened an email from the site. */
  ShoutoutOpen = 'SHOUTOUT_OPEN',
  /** Purchased a video. */
  VideoPurchase = 'VIDEO_PURCHASE',
  /** Rented a video. */
  VideoRent = 'VIDEO_RENT'
}

export type ComWixpressContactsCoreApiV4ContactActivityInput = {
  /** Date and time of the last action. */
  activityDate?: InputMaybe<Scalars['String']>;
  /** Contact's last action in the site. */
  activityType?: InputMaybe<ComWixpressContactsCoreApiV4ContactActivityContactActivityType>;
  /** Date and time of the activity. */
  date?: InputMaybe<Scalars['String']>;
  /** Activity description. Translated. */
  description?: InputMaybe<Scalars['String']>;
  /** Activity Icon */
  icon?: InputMaybe<ComWixpressContactsCoreApiV4ActivityIconInput>;
};

export type ComWixpressContactsCoreApiV4ContactAddress = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactAddress';
  /** Street address. */
  address?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonAddress>;
  /** Street address ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Address type.
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: Maybe<ComWixpressContactsCoreApiV4ContactAddressAddressTag>;
};

export enum ComWixpressContactsCoreApiV4ContactAddressAddressTag {
  Billing = 'BILLING',
  Home = 'HOME',
  Shipping = 'SHIPPING',
  Untagged = 'UNTAGGED',
  Work = 'WORK'
}

export type ComWixpressContactsCoreApiV4ContactAddressInput = {
  /** Street address. */
  address?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonAddressInput>;
  /** Street address ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Address type.
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: InputMaybe<ComWixpressContactsCoreApiV4ContactAddressAddressTag>;
};

export type ComWixpressContactsCoreApiV4ContactAddressesWrapper = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactAddressesWrapper';
  /** List of up to 50 addresses. */
  items?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4ContactAddress>>>;
};

export type ComWixpressContactsCoreApiV4ContactAddressesWrapperInput = {
  /** List of up to 50 addresses. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactAddressInput>>>;
};

export type ComWixpressContactsCoreApiV4ContactEmail = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactEmail';
  /** Email address. */
  email?: Maybe<Scalars['String']>;
  /** Email ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Indicates whether this is the contact's primary email address.
   * When changing `primary` to `true` for an email,
   * the contact's other emails become `false`.
   * Changing the primary email of a contact also affects the subscription status to marketing emails that are decided based on the primary email.
   */
  primary?: Maybe<Scalars['Boolean']>;
  /**
   * Email type.
   *
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: Maybe<ComWixpressContactsCoreApiV4ContactEmailEmailTag>;
};

export enum ComWixpressContactsCoreApiV4ContactEmailEmailTag {
  Home = 'HOME',
  Main = 'MAIN',
  Untagged = 'UNTAGGED',
  Work = 'WORK'
}

export type ComWixpressContactsCoreApiV4ContactEmailInput = {
  /** Email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Email ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Indicates whether this is the contact's primary email address.
   * When changing `primary` to `true` for an email,
   * the contact's other emails become `false`.
   * Changing the primary email of a contact also affects the subscription status to marketing emails that are decided based on the primary email.
   */
  primary?: InputMaybe<Scalars['Boolean']>;
  /**
   * Email type.
   *
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: InputMaybe<ComWixpressContactsCoreApiV4ContactEmailEmailTag>;
};

export type ComWixpressContactsCoreApiV4ContactEmailsWrapper = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactEmailsWrapper';
  /** List of up to 50 email addresses. */
  items?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4ContactEmail>>>;
};

export type ComWixpressContactsCoreApiV4ContactEmailsWrapperInput = {
  /** List of up to 50 email addresses. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactEmailInput>>>;
};

export enum ComWixpressContactsCoreApiV4ContactFieldSet {
  /** name, primaryEmail, primaryPhone */
  Basic = 'BASIC',
  /** name, phones, emails, addresses */
  CommunicationDetails = 'COMMUNICATION_DETAILS',
  /** name, primaryInfo(email, phone), extendedFields */
  Extended = 'EXTENDED',
  /** Full contact object */
  Full = 'FULL'
}

export type ComWixpressContactsCoreApiV4ContactInfo = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactInfo';
  /** Contact's street addresses. */
  addresses?: Maybe<ComWixpressContactsCoreApiV4ContactAddressesWrapper>;
  /**
   * Site contributors
   * who are assigned to manage communication with the contact.
   */
  assignedUserIds?: Maybe<ComWixpressContactsCoreApiV4AssigneesWrapper>;
  /** Birth date in `YYYY-MM-DD` format. For example, `2020-03-15`. */
  birthdate?: Maybe<Scalars['String']>;
  /** Contact's company name. */
  company?: Maybe<Scalars['String']>;
  /**
   * List of contact's labels.
   *
   * Labels are used to organize contacts. Labels can be
   * added and removed using Label Contact and Unlabel Contact, respectively.
   *
   * To view or manage contact labels, use the Labels API.
   */
  contactLabel?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
  /** Contact's email addresses. */
  emails?: Maybe<ComWixpressContactsCoreApiV4ContactEmailsWrapper>;
  /**
   * Additional custom fields.
   *
   * Empty fields are not returned.
   */
  extendedFields?: Maybe<ComWixpressContactsCoreApiV4ExtendedFieldsWrapper>;
  /** Contact's job title. */
  jobTitle?: Maybe<Scalars['String']>;
  /**
   * List of contact's labels.
   *
   * Labels are used to organize contacts. Labels can be
   * added and removed using Label Contact and Unlabel Contact, respectively.
   *
   * To view or manage contact labels, use the Labels API.
   */
  labelKeys?: Maybe<ComWixpressContactsCoreApiV4LabelsWrapper>;
  /**
   * Locale in
   * [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Typically, this is a lowercase 2-letter language code,
   * followed by a hyphen, followed by an uppercase 2-letter country code.
   * For example, `en-US` for U.S. English, and `de-DE` for Germany German.
   */
  locale?: Maybe<Scalars['String']>;
  /** Contact locations. */
  locations?: Maybe<ComWixpressContactsCoreApiV4LocationsWrapper>;
  /** Contact's first and last name. */
  name?: Maybe<ComWixpressContactsCoreApiV4ContactName>;
  /** Contact's phone numbers. */
  phones?: Maybe<ComWixpressContactsCoreApiV4ContactPhonesWrapper>;
  /** Contact's profile picture. */
  picture?: Maybe<ComWixpressContactsCoreApiV4ContactPicture>;
};

export type ComWixpressContactsCoreApiV4ContactInfoInput = {
  /** Contact's street addresses. */
  addresses?: InputMaybe<ComWixpressContactsCoreApiV4ContactAddressesWrapperInput>;
  /**
   * Site contributors
   * who are assigned to manage communication with the contact.
   */
  assignedUserIds?: InputMaybe<ComWixpressContactsCoreApiV4AssigneesWrapperInput>;
  /** Birth date in `YYYY-MM-DD` format. For example, `2020-03-15`. */
  birthdate?: InputMaybe<Scalars['String']>;
  /** Contact's company name. */
  company?: InputMaybe<Scalars['String']>;
  /** Contact's email addresses. */
  emails?: InputMaybe<ComWixpressContactsCoreApiV4ContactEmailsWrapperInput>;
  /**
   * Additional custom fields.
   *
   * Empty fields are not returned.
   */
  extendedFields?: InputMaybe<ComWixpressContactsCoreApiV4ExtendedFieldsWrapperInput>;
  /** Contact's job title. */
  jobTitle?: InputMaybe<Scalars['String']>;
  /**
   * List of contact's labels.
   *
   * Labels are used to organize contacts. Labels can be
   * added and removed using Label Contact and Unlabel Contact, respectively.
   *
   * To view or manage contact labels, use the Labels API.
   */
  labelKeys?: InputMaybe<ComWixpressContactsCoreApiV4LabelsWrapperInput>;
  /**
   * Locale in
   * [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Typically, this is a lowercase 2-letter language code,
   * followed by a hyphen, followed by an uppercase 2-letter country code.
   * For example, `en-US` for U.S. English, and `de-DE` for Germany German.
   */
  locale?: InputMaybe<Scalars['String']>;
  /** Contact locations. */
  locations?: InputMaybe<ComWixpressContactsCoreApiV4LocationsWrapperInput>;
  /** Contact's first and last name. */
  name?: InputMaybe<ComWixpressContactsCoreApiV4ContactNameInput>;
  /** Contact's phone numbers. */
  phones?: InputMaybe<ComWixpressContactsCoreApiV4ContactPhonesWrapperInput>;
  /** Contact's profile picture. */
  picture?: InputMaybe<ComWixpressContactsCoreApiV4ContactPictureInput>;
};

export type ComWixpressContactsCoreApiV4ContactName = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactName';
  /** Contact's first name. */
  first?: Maybe<Scalars['String']>;
  /** Contact's last name. */
  last?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4ContactNameInput = {
  /** Contact's first name. */
  first?: InputMaybe<Scalars['String']>;
  /** Contact's last name. */
  last?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4ContactPhone = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactPhone';
  /** [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) country code. */
  countryCode?: Maybe<Scalars['String']>;
  /**
   * [ITU E.164-formatted](https://www.itu.int/rec/T-REC-E.164/)
   * phone number.
   * Automatically generated using `phone` and `countryCode`, pending both values are valid.
   */
  e164Phone?: Maybe<Scalars['String']>;
  /** Formatted phone. Automatically generated using phone and countryCode. */
  formattedPhone?: Maybe<Scalars['String']>;
  /** Phone ID. */
  id?: Maybe<Scalars['String']>;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /**
   * Indicates whether this is the contact's primary phone number.
   * When changing `primary` to `true` for a phone,
   * the contact's `primary` field for other phones becomes `false`.
   * Changing the primary phone number also affects the subscription status to SMS messages that are decided based on the primary phone.
   */
  primary?: Maybe<Scalars['Boolean']>;
  /**
   * Phone type.
   *
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: Maybe<ComWixpressContactsCoreApiV4ContactPhonePhoneTag>;
};

export type ComWixpressContactsCoreApiV4ContactPhoneInput = {
  /** [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) country code. */
  countryCode?: InputMaybe<Scalars['String']>;
  /**
   * [ITU E.164-formatted](https://www.itu.int/rec/T-REC-E.164/)
   * phone number.
   * Automatically generated using `phone` and `countryCode`, pending both values are valid.
   */
  e164Phone?: InputMaybe<Scalars['String']>;
  /** Formatted phone. Automatically generated using phone and countryCode. */
  formattedPhone?: InputMaybe<Scalars['String']>;
  /** Phone ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /**
   * Indicates whether this is the contact's primary phone number.
   * When changing `primary` to `true` for a phone,
   * the contact's `primary` field for other phones becomes `false`.
   * Changing the primary phone number also affects the subscription status to SMS messages that are decided based on the primary phone.
   */
  primary?: InputMaybe<Scalars['Boolean']>;
  /**
   * Phone type.
   *
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: InputMaybe<ComWixpressContactsCoreApiV4ContactPhonePhoneTag>;
};

export enum ComWixpressContactsCoreApiV4ContactPhonePhoneTag {
  Fax = 'FAX',
  Home = 'HOME',
  Main = 'MAIN',
  Mobile = 'MOBILE',
  Untagged = 'UNTAGGED',
  Work = 'WORK'
}

export type ComWixpressContactsCoreApiV4ContactPhonesWrapper = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactPhonesWrapper';
  /** List of up to 50 phone numbers. */
  items?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4ContactPhone>>>;
};

export type ComWixpressContactsCoreApiV4ContactPhonesWrapperInput = {
  /** List of up to 50 phone numbers. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactPhoneInput>>>;
};

export type ComWixpressContactsCoreApiV4ContactPicture = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactPicture';
  /**
   * Image.
   * This can contain an image URL or a Wix Media image ID.
   */
  image?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonImage>;
  /**
   * Indicates whether the image is retrieved from Wix Media
   * or an external provider.
   *
   * - `EXTERNAL`: The image is retrieved from an external provider.
   * - `WIX_MEDIA`: The image is retrieved from Wix Media.
   */
  imageProvider?: Maybe<ComWixpressContactsCoreApiV4ContactPictureImageProvider>;
};

export enum ComWixpressContactsCoreApiV4ContactPictureImageProvider {
  /** Image stored outside Wix */
  External = 'EXTERNAL',
  Unknown = 'UNKNOWN',
  /** Stored in wix media platform, Must be uploaded by using `GeneratePictureUploadUrl` */
  WixMedia = 'WIX_MEDIA'
}

export type ComWixpressContactsCoreApiV4ContactPictureInput = {
  /**
   * Image.
   * This can contain an image URL or a Wix Media image ID.
   */
  image?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonImageInput>;
  /**
   * Indicates whether the image is retrieved from Wix Media
   * or an external provider.
   *
   * - `EXTERNAL`: The image is retrieved from an external provider.
   * - `WIX_MEDIA`: The image is retrieved from Wix Media.
   */
  imageProvider?: InputMaybe<ComWixpressContactsCoreApiV4ContactPictureImageProvider>;
};

export type ComWixpressContactsCoreApiV4ContactSource = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactSource';
  /** App ID, if the contact was created by an app. */
  appId?: Maybe<Scalars['String']>;
  /** Source type. */
  sourceType?: Maybe<ComWixpressContactsCoreApiV4ContactSourceContactSourceType>;
  /**
   * App ID, if the contact was created by a Wix app.
   *
   * > **Deprecation Notice:**
   * > This property has been replaced with
   * > `appId`
   * > and will be removed on March 31, 2022. If your app uses this property,
   * > we recommend updating your code as soon as possible.
   */
  wixAppId?: Maybe<Scalars['String']>;
};

export enum ComWixpressContactsCoreApiV4ContactSourceContactSourceType {
  Admin = 'ADMIN',
  Hopp = 'HOPP',
  Import = 'IMPORT',
  Other = 'OTHER',
  ThirdParty = 'THIRD_PARTY',
  WixApp = 'WIX_APP',
  WixBookings = 'WIX_BOOKINGS',
  WixChat = 'WIX_CHAT',
  WixCode = 'WIX_CODE',
  WixEmailMarketing = 'WIX_EMAIL_MARKETING',
  WixEvents = 'WIX_EVENTS',
  WixForms = 'WIX_FORMS',
  WixGroups = 'WIX_GROUPS',
  WixHotels = 'WIX_HOTELS',
  WixMarketPlace = 'WIX_MARKET_PLACE',
  WixMusic = 'WIX_MUSIC',
  WixRestaurants = 'WIX_RESTAURANTS',
  WixSiteMembers = 'WIX_SITE_MEMBERS',
  WixStores = 'WIX_STORES'
}

export type ComWixpressContactsCoreApiV4ContactsFacet = {
  __typename?: 'ComWixpressContactsCoreApiV4ContactsFacet';
  /** Number of contacts the facet applies to. */
  count?: Maybe<Scalars['Int']>;
  /** Human-readable name. Shown in the Wix UI. */
  facetDisplayName?: Maybe<Scalars['String']>;
  /** Facet key, automatically generated. */
  facetKey?: Maybe<Scalars['String']>;
  /** Type of facet. */
  facetType?: Maybe<ComWixpressContactsCoreApiV4ContactsFacetContactsFacetType>;
  /** Legacy ID of the facet label */
  legacyId?: Maybe<Scalars['String']>;
  /**
   * Scope for facet keys.
   * When a facet key exists in a namespace,
   * each key is unique within that namespace.
   *
   * Currently, facets not created by Wix are in the `custom` namespace.
   */
  namespace?: Maybe<Scalars['String']>;
  /** Human-readable display name. */
  namespaceDisplayName?: Maybe<Scalars['String']>;
  /** Filter used to query contacts of this facet. */
  queryFilter?: Maybe<Scalars['JSON']>;
};

export enum ComWixpressContactsCoreApiV4ContactsFacetContactsFacetType {
  AllContacts = 'ALL_CONTACTS',
  Label = 'LABEL',
  MembershipStatus = 'MEMBERSHIP_STATUS',
  NotLabeled = 'NOT_LABELED',
  SubscriptionStatus = 'SUBSCRIPTION_STATUS',
  Unknown = 'UNKNOWN'
}

export type ComWixpressContactsCoreApiV4CountContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4CountContactsResponse';
  count?: Maybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4CreateContactRequestInput = {
  /**
   * Controls whether the call will succeed
   * if the new contact information contains an email or a phone number already used by another contact.
   *
   * If set to `true`,
   * the call will succeed even if an email address or phone number is used by another contact.
   * If set to `false`,
   * the call will fail if the given email address is used by another contact or,
   * if the email address is not given and the given phone number is used by another contact.
   *
   * Default: `false`
   */
  allowDuplicates?: InputMaybe<Scalars['Boolean']>;
  /** Contact info. */
  info?: InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4CreateContactResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4CreateContactResponse';
  /** Contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4DeleteContactRequestInput = {
  /** ID of the contact to delete. */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * Indicates whether to delete the contact that is a member. If set to `true`, the contact is deleted even
   * if it is a member and the member is also deleted. Default: `false`
   */
  deleteMember?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressContactsCoreApiV4ExtendedFieldsWrapper = {
  __typename?: 'ComWixpressContactsCoreApiV4ExtendedFieldsWrapper';
  /**
   * Contact's extended fields,
   * where each key is the field key,
   * and each value is the field's value for the contact.
   *
   * To view and manage extended fields, use the Extended Fields API.
   */
  items?: Maybe<Scalars['JSON']>;
};

export type ComWixpressContactsCoreApiV4ExtendedFieldsWrapperInput = {
  /**
   * Contact's extended fields,
   * where each key is the field key,
   * and each value is the field's value for the contact.
   *
   * To view and manage extended fields, use the Extended Fields API.
   */
  items?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressContactsCoreApiV4GeneratePictureUploadUrlRequestInput = {
  /** ID of the contact whose picture is being updated. */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * Mime Type. Must be one of:
   * `image/png`, `image/jpeg`.
   * Defaults to `image/png`.
   */
  mimeType?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4GeneratePictureUploadUrlResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4GeneratePictureUploadUrlResponse';
  uploadId?: Maybe<Scalars['String']>;
  /** URL to upload the image */
  uploadUrl?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4GetContactRequestInput = {
  /**
   * List of projected fields to return.
   * If both `fields` and `fieldsets` are sent in the request,
   * the union of both lists is returned.
   * `id` and `revision` are always returned.
   *
   * Supported properties:
   * `source`, `createdDate`, `updatedDate`, `lastActivity`, `primaryInfo`,
   * `info.name`, `info.emails`, `info.phones`, `info.addresses`, `info.company`,
   * `info.jobTitle`, `info.picture`, `info.birthdate`, `info.locale`,
   * `info.labelKeys`, `info.locations`, `info.extendedFields`
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Predefined sets of fields to return.
   * If both `fields` and `fieldsets` are sent in the request,
   * the union of both lists is returned.
   *
   * - `BASIC`: Returns `id`, `revision`, `primaryInfo`, `info.name`.
   * - `COMMUNICATION_DETAILS`: Returns `id`, `revision`, `primaryInfo`, `info.name`, `info.emails`, `info.phones`, `info.addresses`.
   * - `EXTENDED`: Returns `id`, `revision`, `primaryInfo`, `info.name`, `info.extendedFields`.
   * - `FULL`: Returns all fields.
   *
   * Default: If `fields` is omitted from the request, `FULL`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactFieldSet>>>;
  id: Scalars['ID'];
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4GroupInfo = {
  __typename?: 'ComWixpressContactsCoreApiV4GroupInfo';
  /** Group IDs */
  groupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum ComWixpressContactsCoreApiV4IdentityInfoIdentityStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Deleted = 'DELETED',
  Offline = 'OFFLINE',
  PendingAdminApproval = 'PENDING_ADMIN_APPROVAL',
  UnknownIdentityStatus = 'UNKNOWN_IDENTITY_STATUS'
}

export type ComWixpressContactsCoreApiV4LabelAndUnlabelContactRequestInput = {
  /** Contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * List of label keys to add to the contact.
   *
   * Label keys must exist to be added to the contact.
   * Contact labels can be created or retrieved with
   * [Find or Create Label](https://dev.wix.com/api/rest/contacts/labels/find-or-create-label)
   * or
   * [List Labels](https://dev.wix.com/api/rest/contacts/labels/list-labels).
   */
  labelKeysToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of label keys to remove from the contact. */
  labelKeysToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4LabelAndUnlabelContactResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4LabelAndUnlabelContactResponse';
  /** Updated contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4LabelContactRequestInput = {
  /** ID of the contact to add labels to. */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * List of label keys to add to the contact.
   *
   * Label keys must exist to be added to the contact.
   * Use the Labels API to create or retrieve labels.
   */
  labelKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4LabelContactResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4LabelContactResponse';
  /** Updated contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4LabelsWrapper = {
  __typename?: 'ComWixpressContactsCoreApiV4LabelsWrapper';
  /**
   * List of contact label keys.
   *
   * Contact labels help categorize contacts. Label keys must exist to be added to the contact.
   * Contact labels can be created or retrieved with Find or Create Label or List Labels.
   */
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * List of contact label keys.
   *
   * Contact labels help categorize contacts. Label keys must exist to be added to the contact.
   * Contact labels can be created or retrieved with Find or Create Label or List Labels.
   */
  labels?: Maybe<ComWixpressContactsLabelsV4QueryLabelsResponse>;
};


export type ComWixpressContactsCoreApiV4LabelsWrapperLabelsArgs = {
  queryInput?: InputMaybe<ComWixpressContactsLabelsV4QueryLabelsRequestInput>;
};

export type ComWixpressContactsCoreApiV4LabelsWrapperInput = {
  /**
   * List of contact label keys.
   *
   * Contact labels help categorize contacts. Label keys must exist to be added to the contact.
   * Contact labels can be created or retrieved with Find or Create Label or List Labels.
   */
  items?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4ListContactIdsBySegmentRequestInput = {
  /** Cursor paging. */
  cursorPaging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput>;
  /** Segment id */
  segmentId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4ListContactIdsBySegmentResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4ListContactIdsBySegmentResponse';
  /** List of contact IDs */
  contactIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of contact IDs */
  contacts?: Maybe<ComWixpressContactsCoreApiV4QueryContactsResponse>;
  /** Paging metadata */
  cursorPagingMetadata?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata>;
};


export type ComWixpressContactsCoreApiV4ListContactIdsBySegmentResponseContactsArgs = {
  queryInput?: InputMaybe<ComWixpressContactsCoreApiV4QueryContactsRequestInput>;
};

export type ComWixpressContactsCoreApiV4ListContactsRequestInput = {
  /**
   * List of projected fields to return.
   * If both `fields` and `fieldsets` are sent in the request,
   * the union of both lists is returned.
   * `id` and `revision` are always returned.
   *
   * Supported properties:
   * `source`, `createdDate`, `updatedDate`, `lastActivity`, `primaryInfo`,
   * `info.name`, `info.emails`, `info.phones`, `info.addresses`, `info.company`,
   * `info.jobTitle`, `info.picture`, `info.birthdate`, `info.locale`,
   * `info.labelKeys`, `info.locations`, `info.extendedFields`
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactFieldSet>>>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /** [Pagination](https://dev.wix.com/api/rest/getting-started/pagination), defaults to offset = 0 and limit = 50 (max limit 1,000). */
  paging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput>;
  /** [Sort order](https://dev.wix.com/api/rest/contacts/contacts/sort-and-filter). */
  sort?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput>;
};

export type ComWixpressContactsCoreApiV4ListContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4ListContactsResponse';
  /** List of contacts. */
  contacts?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4Contact>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata>;
};

export type ComWixpressContactsCoreApiV4ListFacetsRequestInput = {
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /** Whether to count the number of contacts per facet */
  omitCount?: InputMaybe<Scalars['Boolean']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput>;
};

export type ComWixpressContactsCoreApiV4ListFacetsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4ListFacetsResponse';
  /** List of facets. */
  facets?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4ContactsFacet>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata>;
};

export type ComWixpressContactsCoreApiV4LocationsWrapper = {
  __typename?: 'ComWixpressContactsCoreApiV4LocationsWrapper';
  /** List of location ids. */
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4LocationsWrapperInput = {
  /** List of location ids. */
  items?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4MemberInfo = {
  __typename?: 'ComWixpressContactsCoreApiV4MemberInfo';
  /** Login email */
  email?: Maybe<Scalars['String']>;
  /** Indicates whether the member is required to verify their email */
  emailVerificationRequired?: Maybe<Scalars['Boolean']>;
  /** Indicate whether the email is verified */
  emailVerified?: Maybe<Scalars['Boolean']>;
  /** Group info */
  groupInfo?: Maybe<ComWixpressContactsCoreApiV4GroupInfo>;
  /** Member ID */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** Member ID */
  memberId?: Maybe<Scalars['String']>;
  /** Profile info */
  profileInfo?: Maybe<ComWixpressContactsCoreApiV4ProfileInfo>;
  /** Session info */
  sessionInfo?: Maybe<ComWixpressContactsCoreApiV4SessionInfo>;
  /** Signup date */
  signupDate?: Maybe<Scalars['String']>;
  /**
   * Member status.
   * - `PENDING`: Member created and is waiting for approval by site owner.
   * - `ACTIVE`: Member can log in to the site.
   * - `OFFLINE`: Member is a [managed writer](https://support.wix.com/en/article/wix-blog-adding-managed-writers-to-your-blog) for the site blog and cannot log in to the site.
   * - `BLOCKED': Member is blocked and cannot log in to the site.
   */
  status?: Maybe<ComWixpressContactsCoreApiV4MemberInfoMemberStatus>;
  /** User info */
  userInfo?: Maybe<ComWixpressContactsCoreApiV4UserInfo>;
};

export enum ComWixpressContactsCoreApiV4MemberInfoMemberStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Deleted = 'DELETED',
  Offline = 'OFFLINE',
  Pending = 'PENDING',
  UnknownMemberStatus = 'UNKNOWN_MEMBER_STATUS'
}

export type ComWixpressContactsCoreApiV4MergeContactsRequestInput = {
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /**
   * IDs of up to 5 contacts to merge into the target contact.
   * When you merge more than one source contact,
   * the first source is given precedence, then the second, and so on.
   */
  sourceContactIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Target contact ID. */
  targetContactId?: InputMaybe<Scalars['String']>;
  /**
   * Target contact revision number, which increments by 1 each time the contact is updated.
   * To prevent conflicting changes,
   * the target contact's current `revision` must be specified.
   */
  targetContactRevision?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4MergeContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4MergeContactsResponse';
  /** Updated target contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4PreviewMergeContactsRequestInput = {
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /**
   * IDs of up to 5 contacts to merge into the target contact.
   * When you merge more than one source contact,
   * the first source is given precedence, then the second, and so on.
   */
  sourceContactIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Target contact ID. */
  targetContactId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4PreviewMergeContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4PreviewMergeContactsResponse';
  /** Preview of the updated target contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4PrimaryContactInfo = {
  __typename?: 'ComWixpressContactsCoreApiV4PrimaryContactInfo';
  /**
   * Primary email address.
   *
   * This property reflects the email address in `info.emails`
   * where `primary` is `true`.
   */
  email?: Maybe<Scalars['String']>;
  /**
   * Primary phone number.
   *
   * This property reflects the phone number in `info.phones`
   * where `primary` is `true`.
   */
  phone?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4PrimaryEmail = {
  __typename?: 'ComWixpressContactsCoreApiV4PrimaryEmail';
  /**
   * Indicates last reported status of sent emails.
   *
   * Default: `NOT_SET`
   */
  deliverabilityStatus?: Maybe<ComWixpressContactsCoreApiV4PrimaryEmailEmailDeliverabilityStatus>;
  /**
   * Primary email address.
   *
   * This field reflects the email address in `info.emails`
   * where `primary` is `true`.
   */
  email?: Maybe<Scalars['String']>;
  /**
   * Indicates the recipient's opt-in or opt-out status for marketing emails.
   *
   * Default: `NOT_SET`
   */
  subscriptionStatus?: Maybe<ComWixpressContactsCoreApiV4SubscriptionStatus>;
};

export enum ComWixpressContactsCoreApiV4PrimaryEmailEmailDeliverabilityStatus {
  /** The last email to the recipient bounced or was rejected. */
  Bounced = 'BOUNCED',
  /** Multiple emails have been delivered without any kind of engagement from the recipient. */
  Inactive = 'INACTIVE',
  /** No status reported. */
  NotSet = 'NOT_SET',
  /** Recipient registered a spam complaint with their email provider. */
  SpamComplaint = 'SPAM_COMPLAINT',
  /** Unknown email deliverability status. */
  UnknownEmailDeliverabilityStatus = 'UNKNOWN_EMAIL_DELIVERABILITY_STATUS',
  /** Emails are being successfully delivered. */
  Valid = 'VALID'
}

export type ComWixpressContactsCoreApiV4PrimaryPhone = {
  __typename?: 'ComWixpressContactsCoreApiV4PrimaryPhone';
  /** Country code of the primary phone number in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  countryCode?: Maybe<Scalars['String']>;
  /**
   * Indicates last reported status of sent SMS messages.
   *
   * Default:
   * - `NO_PHONE_DELIVERABILITY_STATUS` when the phone is not a valid E164 phone.
   * - `NOT_SET` when the phone is a valid E164 phone.
   */
  deliverabilityStatus?: Maybe<ComWixpressContactsCoreApiV4PrimaryPhonePhoneDeliverabilityStatus>;
  /**
   * Phone number in [ITU E.164](https://www.itu.int/rec/T-REC-E.164/) format.
   * Automatically generated using `phone` and `countryCode` when both values are valid.
   */
  e164Phone?: Maybe<Scalars['String']>;
  /** Formatted phone. Automatically generated using `phone` and `countryCode`. */
  formattedPhone?: Maybe<Scalars['String']>;
  /**
   * Primary phone number.
   *
   * This field reflects the phone number in `info.phones`
   * where `primary` is `true`.
   */
  phone?: Maybe<Scalars['String']>;
  /**
   * Indicates the recipient's opt-in or opt-out status for SMS messages.
   *
   * Default:
   * - `NOT_SET` when the phone is a valid E164 phone.
   * - `NO_SUBSCRIPTION_STATUS` when the phone is not a valid E164 phone.
   */
  subscriptionStatus?: Maybe<ComWixpressContactsCoreApiV4SubscriptionStatus>;
};

export enum ComWixpressContactsCoreApiV4PrimaryPhonePhoneDeliverabilityStatus {
  /** No status reported. */
  NotSet = 'NOT_SET',
  /** No status exists. */
  NoPhoneDeliverabilityStatus = 'NO_PHONE_DELIVERABILITY_STATUS'
}

export type ComWixpressContactsCoreApiV4ProfileInfo = {
  __typename?: 'ComWixpressContactsCoreApiV4ProfileInfo';
  /** Indicate whether the member is muted */
  muted?: Maybe<Scalars['Boolean']>;
  /** Nickname */
  nickname?: Maybe<Scalars['String']>;
  /** Profile photo */
  photo?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonImage>;
  /** Privacy status */
  privacyStatus?: Maybe<ComWixpressContactsCoreApiV4ProfileInfoPrivacyStatus>;
  /** Indicate whether the member is reported */
  reported?: Maybe<Scalars['Boolean']>;
};

export enum ComWixpressContactsCoreApiV4ProfileInfoPrivacyStatus {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  UnknownPrivacyStatus = 'UNKNOWN_PRIVACY_STATUS'
}

export type ComWixpressContactsCoreApiV4QueryContactsRequestInput = {
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /** Whether to calculate the total count the number of contacts */
  omitTotal?: InputMaybe<Scalars['Boolean']>;
  /** Query options. */
  query?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixQueryQueryInput>;
  /**
   * Plain text search for an exact match.
   *
   * Supported properties:
   * `info.name.first`, `info.name.last`, `info.emails.email`, `info.phones.phone`
   *
   * Max: 100 characters
   */
  search?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4QueryContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4QueryContactsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4Contact>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressContactsCoreApiV4QueryFacetsRequestInput = {
  /**
   * Filterable fields:
   * - `'info.extendedFields.emailSubscriptions.effectiveEmail'` (`$exists`).
   * - `'info.extendedFields.emailSubscriptions.subscriptionStatus'` (`$eq`, `$ne`, `$in`, `$nin`).
   * - `'info.extendedFields.emailSubscriptions.deliverabilityStatus'` (`$eq`, `$ne`, `$in`, `$nin`).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /** Whether to count the number of contacts per facet */
  omitCount?: InputMaybe<Scalars['Boolean']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput>;
};

export type ComWixpressContactsCoreApiV4QueryFacetsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4QueryFacetsResponse';
  /** List of facets. */
  facets?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4ContactsFacet>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata>;
};

export type ComWixpressContactsCoreApiV4SearchContactsRequestInput = {
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /** Search object. Encapsulates filter, sorting, paging and other details */
  search?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixQuerySearchInput>;
};

export type ComWixpressContactsCoreApiV4SearchContactsResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4SearchContactsResponse';
  /** List of contacts. */
  contacts?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4Contact>>>;
  /** Details on the paged set of results returned. */
  cursorPagingMetadata?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressContactsCoreApiV4SegmentsWrapper = {
  __typename?: 'ComWixpressContactsCoreApiV4SegmentsWrapper';
  /** List of Contact segment IDs */
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4SessionInfo = {
  __typename?: 'ComWixpressContactsCoreApiV4SessionInfo';
  /** Last time the member logged in to one of the mobile apps */
  lastMobileLogin?: Maybe<Scalars['String']>;
  /** Last time the member logged in to the website */
  lastWebLogin?: Maybe<Scalars['String']>;
  /** List of mobile apps that the member has ever logged in to */
  mobileAppNames?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum ComWixpressContactsCoreApiV4SubscriptionStatus {
  /** No status specified. */
  NotSet = 'NOT_SET',
  /** No status exists. */
  NoSubscriptionStatus = 'NO_SUBSCRIPTION_STATUS',
  /** Subscription confirmation was requested, but recipient hasn't confirmed yet. */
  Pending = 'PENDING',
  /** Recipient has opted in to marketing emails or SMS messages. */
  Subscribed = 'SUBSCRIBED',
  /** Recipient has opted out of marketing emails or SMS messages. */
  Unsubscribed = 'UNSUBSCRIBED'
}

export type ComWixpressContactsCoreApiV4SyncSubmitContactRequestInput = {
  activity?: InputMaybe<ComWixpressContactsCoreApiV4ContactActivityInput>;
  contactId?: InputMaybe<Scalars['String']>;
  contactInfo?: InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>;
  hideFromContactList?: InputMaybe<Scalars['Boolean']>;
  passThroughData?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  /** Need to resolve source in allocator, because of server sign */
  sourceType?: InputMaybe<ComWixpressContactsCoreApiV4ContactSourceContactSourceType>;
  submitOperation?: InputMaybe<ComWixpressContactsCoreApiV4SyncSubmitContactRequestSubmitOperation>;
};

export enum ComWixpressContactsCoreApiV4SyncSubmitContactRequestSubmitOperation {
  Create = 'CREATE',
  Unknown = 'UNKNOWN',
  Update = 'UPDATE'
}

export type ComWixpressContactsCoreApiV4UnlabelContactRequestInput = {
  /** ID of the contact to remove labels from. */
  contactId?: InputMaybe<Scalars['String']>;
  /** List of label keys to remove from the contact. */
  labelKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4UnlabelContactResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4UnlabelContactResponse';
  /** Updated contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4UpdateContactRequestInput = {
  /**
   * Controls whether the call will succeed
   * if the new contact information contains an email or a phone number already used by another contact.
   *
   * If set to `true`,
   * the call will succeed even if an email address or phone number is used by another contact.
   * If set to `false`,
   * the call will fail if the given email address is used by another contact or,
   * if the email address is not given and the given phone number is used by another contact.
   *
   * Default: `false`
   */
  allowDuplicates?: InputMaybe<Scalars['Boolean']>;
  /** ID of the contact to update. */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * Set of fields to update.
   * Fields that aren't included in `fieldMask.paths` are ignored.
   * See
   * [Field Masks in Update Requests](https://dev.wix.com/api/rest/contacts/contacts/field-masks-in-update-requests)
   * for details on working with field masks.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contact info. */
  info?: InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /**
   * Revision number.
   * When updating, include the existing `revision`
   * to prevent conflicting updates.
   */
  revision?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4UpdateContactResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4UpdateContactResponse';
  /** Updated contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4UpsertContactRequestInput = {
  info?: InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>;
};

export type ComWixpressContactsCoreApiV4UpsertContactResponse = {
  __typename?: 'ComWixpressContactsCoreApiV4UpsertContactResponse';
  action?: Maybe<ComWixpressContactsCoreApiV4UpsertContactResponseAction>;
  /** Upserted contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export enum ComWixpressContactsCoreApiV4UpsertContactResponseAction {
  Created = 'CREATED',
  Unknown = 'UNKNOWN',
  Updated = 'UPDATED'
}

export type ComWixpressContactsCoreApiV4UpstreamWixCommonAddress = {
  __typename?: 'ComWixpressContactsCoreApiV4UpstreamWixCommonAddress';
  /** Main address line, usually street and number, as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /**
   * Free text providing more detailed address information,
   * such as apartment, suite, or floor.
   */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /**
   * 2-letter country code in an
   * [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format.
   */
  country?: Maybe<Scalars['String']>;
  /** Full country name. */
  countryFullname?: Maybe<Scalars['String']>;
  /**
   * Human-readable address string.
   * If not provided, the value is generated from the available address data.
   */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocation>;
  /** Instructions to help someone find the address, such as landmarks or where the entrance is. */
  hint?: Maybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street address object, with number and name in separate fields. */
  streetAddress?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddress>;
  /**
   * Code for a subdivision (such as state, prefecture, or province) in an
   * [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format.
   */
  subdivision?: Maybe<Scalars['String']>;
  /** Hierarchical list of subdivisions, where the first array item is the highest level of hierarchy, and so on. */
  subdivisions?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivision>>>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonAddressInput = {
  /** Main address line, usually street and number, as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /**
   * Free text providing more detailed address information,
   * such as apartment, suite, or floor.
   */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /**
   * 2-letter country code in an
   * [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format.
   */
  country?: InputMaybe<Scalars['String']>;
  /** Full country name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  /**
   * Human-readable address string.
   * If not provided, the value is generated from the available address data.
   */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocationInput>;
  /** Instructions to help someone find the address, such as landmarks or where the entrance is. */
  hint?: InputMaybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street address object, with number and name in separate fields. */
  streetAddress?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddressInput>;
  /**
   * Code for a subdivision (such as state, prefecture, or province) in an
   * [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format.
   */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Hierarchical list of subdivisions, where the first array item is the highest level of hierarchy, and so on. */
  subdivisions?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionInput>>>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocation = {
  __typename?: 'ComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocation';
  /** Address's latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address's longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocationInput = {
  /** Address's latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address's longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput = {
  /** Cursor returned in last query response. Should not be provided on first page request */
  cursor?: InputMaybe<Scalars['String']>;
  /** The number of contacts to load (default = 50, max = 1000) */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonCursors = {
  __typename?: 'ComWixpressContactsCoreApiV4UpstreamWixCommonCursors';
  /** Cursor pointing to next result page */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous result page */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonImage = {
  __typename?: 'ComWixpressContactsCoreApiV4UpstreamWixCommonImage';
  /** Image alt text (optional). */
  altText?: Maybe<Scalars['String']>;
  /** Height of the original image. */
  height?: Maybe<Scalars['Int']>;
  /**
   * WixMedia image ID.
   * This property is written by Wix when an image is uploaded to the Wix Media Manager.
   */
  id?: Maybe<Scalars['String']>;
  /** Image source: Either a Media Manager URL or external URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (optional). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Width of the original image. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonImageInput = {
  /** Image alt text (optional). */
  altText?: InputMaybe<Scalars['String']>;
  /** Height of the original image. */
  height?: InputMaybe<Scalars['Int']>;
  /**
   * WixMedia image ID.
   * This property is written by Wix when an image is uploaded to the Wix Media Manager.
   */
  id?: InputMaybe<Scalars['String']>;
  /** Image source: Either a Media Manager URL or external URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (optional). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Width of the original image. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput = {
  /**
   * Number of items to return. Learn more about pagination in API Query Language([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language)|[REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#paging).
   *
   * Default: `50`. <br>
   * Maximum: `1000`.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata = {
  __typename?: 'ComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata';
  /** The number of items returned in this response. */
  count?: Maybe<Scalars['Int']>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** The offset which was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** A flag that indicates the server failed to calculate 'total' field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** The total number of items that match the query. */
  total?: Maybe<Scalars['Int']>;
};

export enum ComWixpressContactsCoreApiV4UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput = {
  /**
   * Field to sort by.
   *
   * Supported properties:
   * `createdDate`, `lastActivity.activityDate`, `primaryInfo.email`, `info.name.first`, `info.name.last`, `info.company`,
   * `info.jobTitle`, `info.birthdate`
   */
  fieldName?: InputMaybe<Scalars['String']>;
  /**
   * Sort order.
   * Use `ASC` for ascending order or `DESC` for descending order.
   *
   * Defaults to `ASC`.
   */
  order?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSortOrder>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddress = {
  __typename?: 'ComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddress';
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivision = {
  __typename?: 'ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivision';
  /** subdivision short code */
  code?: Maybe<Scalars['String']>;
  /** Full subdivision name. */
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionSubdivisionType>;
  /**
   * Free text that describes the subdivision type.
   *
   * Examples: `"state"`, `"province"`, `"prefecture"`.
   */
  typeInfo?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionInput = {
  /** subdivision short code */
  code?: InputMaybe<Scalars['String']>;
  /** Full subdivision name. */
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionSubdivisionType>;
  /**
   * Free text that describes the subdivision type.
   *
   * Examples: `"state"`, `"province"`, `"prefecture"`.
   */
  typeInfo?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionSubdivisionType {
  /** State */
  AdministrativeAreaLevel_1 = 'ADMINISTRATIVE_AREA_LEVEL_1',
  /** County */
  AdministrativeAreaLevel_2 = 'ADMINISTRATIVE_AREA_LEVEL_2',
  /** City/town */
  AdministrativeAreaLevel_3 = 'ADMINISTRATIVE_AREA_LEVEL_3',
  /** Neighborhood/quarter */
  AdministrativeAreaLevel_4 = 'ADMINISTRATIVE_AREA_LEVEL_4',
  /** Street/block */
  AdministrativeAreaLevel_5 = 'ADMINISTRATIVE_AREA_LEVEL_5',
  /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
  Country = 'COUNTRY',
  UnknownSubdivisionType = 'UNKNOWN_SUBDIVISION_TYPE'
}

export type ComWixpressContactsCoreApiV4UpstreamWixQueryQueryInput = {
  /**
   * List of projected fields to return.
   * If both `fields` and `fieldsets` are sent in the request,
   * the union of both lists is returned.
   * `id` and `revision` are always returned.
   *
   * Supported properties:
   * `source`, `createdDate`, `updatedDate`, `lastActivity`, `primaryInfo`,
   * `info.name`, `info.emails`, `info.phones`, `info.addresses`, `info.company`,
   * `info.jobTitle`, `info.picture`, `info.birthdate`, `info.locale`,
   * `info.labelKeys`, `info.locations`, `info.extendedFields`
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Predefined sets of fields to return.
   * If both `fields` and `fieldsets` are sent in the request,
   * the union of both lists is returned.
   *
   * - `BASIC`: Returns `id`, `revision`, `primaryInfo`, `info.name`.
   * - `COMMUNICATION_DETAILS`: Returns `id`, `revision`, `primaryInfo`, `info.name`, `info.emails`, `info.phones`, `info.addresses`.
   * - `EXTENDED`: Returns `id`, `revision`, `primaryInfo`, `info.name`, `info.extendedFields`.
   * - `FULL`: Returns all fields.
   *
   * Default: If `fields` is omitted from the request, `FULL`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactFieldSet>>>;
  /**
   * Filter object.
   * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * for more information.
   *
   * For a detailed list of supported filters, see
   * [Supported Filters](https://dev.wix.com/api/rest/contacts/contacts/supported-filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput>;
  /**
   * Sorting options.
   * See [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination)
   * for more information.
   *
   * Max: 1 sort object
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput>>>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsInput = {
  /** search term or expression */
  expression?: InputMaybe<Scalars['String']>;
  /**
   * fields to search in. if empty - server will search in own default fieldsDefault searchable fields:
   *
   * - `info.name.first`
   * - `info.name.last`
   * - `info.emails.email`
   * - `info.phones.phone`
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** flag if should use auto fuzzy search (allowing typos by a managed proximity algorithm) */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** boolean search mode. Default is `OR` */
  mode?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsMode>;
};

export enum ComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsMode {
  /** all */
  And = 'AND',
  /** any */
  Or = 'OR'
}

export type ComWixpressContactsCoreApiV4UpstreamWixQuerySearchInput = {
  /** Cursor pointing to page of results. 'cursorPaging.cursor' can not be used together with 'filter' or 'sort' */
  cursorPaging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput>;
  /**
   * List of projected fields to return.
   *
   * If used in the request,
   * all the fields contained in `fields` and `fieldsets` are returned.
   * If left blank, `fieldsets` is used to determine which fields to return.
   *
   * For a list of valid projected fields, see
   * [Valid Contact Projection Fields](https://dev.wix.com/api/rest/contacts/contacts/fieldsets-and-projected-fields#contacts_contacts_fieldsets-and-projected-fields_valid-contact-projection-fields).
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Predefined sets of fields to return.
   *
   * Defaults to `FULL`.
   * Ignored if left empty when `fields` is used in the request.
   *
   * For more information,
   * see [Contact Fieldsets](https://dev.wix.com/api/rest/contacts/contacts/fieldsets-and-projected-fields#contacts_contacts_fieldsets-and-projected-fields_contact-fieldsets).
   */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A filter object. See documentation [here](https://bo.wix.com/wix-docs/rnd/platformization-guidelines/api-query-language#platformization-guidelines_api-query-language_defining-in-protobuf) */
  filter?: InputMaybe<Scalars['JSON']>;
  /** free text to match in searchable fields */
  search?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsInput>;
  /** Sort object in the form [{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}] */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput>>>;
};

export type ComWixpressContactsCoreApiV4UserInfo = {
  __typename?: 'ComWixpressContactsCoreApiV4UserInfo';
  /** The user's role on the website */
  role?: Maybe<ComWixpressContactsCoreApiV4UserInfoRole>;
  /** User ID */
  userId?: Maybe<Scalars['String']>;
};

export enum ComWixpressContactsCoreApiV4UserInfoRole {
  Contributor = 'CONTRIBUTOR',
  Owner = 'OWNER',
  UnspecifiedRole = 'UNSPECIFIED_ROLE'
}

export type ComWixpressContactsFieldsV4DeleteExtendedFieldRequestInput = {
  /** Extended field key. */
  key?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4ExtendedField = {
  __typename?: 'ComWixpressContactsFieldsV4ExtendedField';
  /** Date and time the field was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Type of data the field holds. */
  dataType?: Maybe<ComWixpressContactsFieldsV4ExtendedFieldFieldDataType>;
  /** Field description, if the field is a system field. */
  description?: Maybe<Scalars['String']>;
  /** Display name shown in the contact list. */
  displayName?: Maybe<Scalars['String']>;
  /** Indicates whether the extended field is a system field or custom field. */
  fieldType?: Maybe<ComWixpressContactsFieldsV4ExtendedFieldFieldType>;
  /**
   * Extended field key.
   *
   * When accessing contact data,
   * extended field data is available at `extendedFields[key]`.
   * For example, if the key is "custom.notes",
   * the value can be accessed at `extendedFields["custom.notes"]`.
   *
   * `key` is generated when the extended field is created
   * and can't be modified, even if `displayName` changes.
   */
  key?: Maybe<Scalars['String']>;
  /** Legacy Id of field. For internal use. */
  legacyId?: Maybe<Scalars['String']>;
  /**
   * Extended field namespace.
   *
   * Extended fields created through by calling the Find Or Create Extended Field method
   * are automatically assigned to the `custom` namespace.
   */
  namespace?: Maybe<Scalars['String']>;
  /** Data Extensions Schema Field Id. Available only for v5 sites. For internal use. */
  schemaFieldId?: Maybe<Scalars['String']>;
  /** Date and time the field was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Wix search field name. For internal use. */
  wixSearchColumn?: Maybe<Scalars['String']>;
};

export enum ComWixpressContactsFieldsV4ExtendedFieldFieldDataType {
  /** Accepts dates formatted as `YYYY-MM-DD`. */
  Date = 'DATE',
  /** Accepts floats. */
  Number = 'NUMBER',
  /** Accepts strings. */
  Text = 'TEXT',
  /** Undefined data type. */
  UnknownDataType = 'UNKNOWN_DATA_TYPE',
  /** Accepts strings. Prepends `https://` if no protocol is included. */
  Url = 'URL'
}

export enum ComWixpressContactsFieldsV4ExtendedFieldFieldType {
  /** Field is a system field managed by Wix. System fields can't be modified by calling the Update Extended Field method. */
  System = 'SYSTEM',
  /** Undefined field type. */
  Unknown = 'UNKNOWN',
  /** Field is a custom field and can be modified by calling the Update Extended Field method. */
  UserDefined = 'USER_DEFINED'
}

export type ComWixpressContactsFieldsV4ExtendedFieldInput = {
  /** Date and time the field was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Type of data the field holds. */
  dataType?: InputMaybe<ComWixpressContactsFieldsV4ExtendedFieldFieldDataType>;
  /** Field description, if the field is a system field. */
  description?: InputMaybe<Scalars['String']>;
  /** Display name shown in the contact list. */
  displayName?: InputMaybe<Scalars['String']>;
  /** Indicates whether the extended field is a system field or custom field. */
  fieldType?: InputMaybe<ComWixpressContactsFieldsV4ExtendedFieldFieldType>;
  /**
   * Extended field key.
   *
   * When accessing contact data,
   * extended field data is available at `extendedFields[key]`.
   * For example, if the key is "custom.notes",
   * the value can be accessed at `extendedFields["custom.notes"]`.
   *
   * `key` is generated when the extended field is created
   * and can't be modified, even if `displayName` changes.
   */
  key?: InputMaybe<Scalars['String']>;
  /** Legacy Id of field. For internal use. */
  legacyId?: InputMaybe<Scalars['String']>;
  /**
   * Extended field namespace.
   *
   * Extended fields created through by calling the Find Or Create Extended Field method
   * are automatically assigned to the `custom` namespace.
   */
  namespace?: InputMaybe<Scalars['String']>;
  /** Data Extensions Schema Field Id. Available only for v5 sites. For internal use. */
  schemaFieldId?: InputMaybe<Scalars['String']>;
  /** Date and time the field was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Wix search field name. For internal use. */
  wixSearchColumn?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4FindOrCreateExtendedFieldRequestInput = {
  /**
   * Type of data the field holds.
   * Ignored if an existing field is an exact match
   * for the specified display name.
   */
  dataType?: InputMaybe<ComWixpressContactsFieldsV4ExtendedFieldFieldDataType>;
  /**
   * Display name to retrieve or create.
   *
   * If an existing custom field is an exact match
   * for the specified display name,
   * the existing field is returned.
   * If not, a new field is created and returned.
   */
  displayName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4FindOrCreateExtendedFieldResponse = {
  __typename?: 'ComWixpressContactsFieldsV4FindOrCreateExtendedFieldResponse';
  /** Extended field that was found or created. */
  field?: Maybe<ComWixpressContactsFieldsV4ExtendedField>;
  /**
   * Indicates whether the extended field was just created or already existed.
   *
   * Returns `true` if the field was just created.
   */
  newField?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressContactsFieldsV4GdprListRequestInput = {
  /** Instance ID of the site. */
  instanceId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4GdprListResponse = {
  __typename?: 'ComWixpressContactsFieldsV4GdprListResponse';
  /** List of extended fields. */
  fields?: Maybe<Array<Maybe<ComWixpressContactsFieldsV4ExtendedField>>>;
};

export type ComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdRequestInput = {
  /** Legacy ID of the extended field. */
  legacyId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdResponse = {
  __typename?: 'ComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdResponse';
  /** The requested extended field. */
  field?: Maybe<ComWixpressContactsFieldsV4ExtendedField>;
};

export type ComWixpressContactsFieldsV4GetExtendedFieldRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressContactsFieldsV4ListExtendedFieldsRequestInput = {
  /** Filter for fields of the specified type. */
  fieldType?: InputMaybe<ComWixpressContactsFieldsV4ExtendedFieldFieldType>;
  /**
   * Filter for fields in the specified namespace.
   * Fields created by calling the Find Or Create Extended Field method
   * are automatically assigned to the `custom` namespace.
   */
  namespace?: InputMaybe<Scalars['String']>;
  /** Paging options. */
  paging?: InputMaybe<ComWixpressContactsFieldsV4UpstreamWixCommonPagingInput>;
  /** Sorting options. */
  sort?: InputMaybe<ComWixpressContactsFieldsV4UpstreamWixCommonSortingInput>;
  /** Filter for fields where `displayName` starts with the specified case-sensitive string. */
  startsWith?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4ListExtendedFieldsResponse = {
  __typename?: 'ComWixpressContactsFieldsV4ListExtendedFieldsResponse';
  /** List of extended fields. */
  fields?: Maybe<Array<Maybe<ComWixpressContactsFieldsV4ExtendedField>>>;
  /** Metadata for the page of results. */
  metadata?: Maybe<ComWixpressContactsFieldsV4UpstreamWixCommonPagingMetadata>;
};

export type ComWixpressContactsFieldsV4PurgeRequestInput = {
  /** Instance ID of the site. */
  instanceId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4PurgeResponse = {
  __typename?: 'ComWixpressContactsFieldsV4PurgeResponse';
  /** Number of items deleted. */
  deletedItems?: Maybe<Scalars['Int']>;
};

export type ComWixpressContactsFieldsV4QueryExtendedFieldsRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressContactsFieldsV4UpstreamWixQueryQueryInput>;
};

export type ComWixpressContactsFieldsV4QueryExtendedFieldsResponse = {
  __typename?: 'ComWixpressContactsFieldsV4QueryExtendedFieldsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressContactsFieldsV4ExtendedField>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressContactsFieldsV4UpdateExtendedFieldRequestInput = {
  /** Extended field to rename. */
  field?: InputMaybe<ComWixpressContactsFieldsV4ExtendedFieldInput>;
};

export type ComWixpressContactsFieldsV4UpdateExtendedFieldResponse = {
  __typename?: 'ComWixpressContactsFieldsV4UpdateExtendedFieldResponse';
  /** Renamed extended field. */
  field?: Maybe<ComWixpressContactsFieldsV4ExtendedField>;
};

export type ComWixpressContactsFieldsV4UpstreamWixCommonPagingInput = {
  /**
   * Number of items to return.
   *
   * Defaults to `100`.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Number of items to skip in the current sort order.
   *
   * Defaults to `0`.
   */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsFieldsV4UpstreamWixCommonPagingMetadata = {
  __typename?: 'ComWixpressContactsFieldsV4UpstreamWixCommonPagingMetadata';
  /** Number of items returned. */
  count?: Maybe<Scalars['Int']>;
  /** Requested offset. */
  offset?: Maybe<Scalars['Int']>;
  /**
   * Indicates if `total` calculation timed out before the response was sent.
   * Typically this happens if there is a large set of results.
   */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Number of items that matched the query. */
  total?: Maybe<Scalars['Int']>;
};

export enum ComWixpressContactsFieldsV4UpstreamWixCommonSortOrder {
  /** Sort by ascending order. */
  Asc = 'ASC',
  /** Sort by descending order. */
  Desc = 'DESC'
}

export type ComWixpressContactsFieldsV4UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /**
   * Sort order.
   *
   * Default: `ASC`.
   */
  order?: InputMaybe<ComWixpressContactsFieldsV4UpstreamWixCommonSortOrder>;
};

export type ComWixpressContactsFieldsV4UpstreamWixQueryQueryInput = {
  /**
   * ilter object.
   *
   * Possible filters: `$eq`, `$gt`, `$gte`, `$in`, `$lt`, `$lte`, `$ne`, `$startsWith`.
   *
   * For a detailed list of supported filters, see [sorting and filtering for extended fields](https://dev.wix.com/api/rest/contacts/extended-fields/sort-and-filter).
   *
   * Example: `{ "filter": {
   * "displayName": {
   * "$startsWith": "Referral"
   * }
   * }
   * }`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressContactsFieldsV4UpstreamWixCommonPagingInput>;
  /**
   * Sorting options. Currently supports sorting on one field only.
   *
   * Example: `{ "sort": [{"fieldName": "displayName", "order": "DESC"}] }`
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressContactsFieldsV4UpstreamWixCommonSortingInput>>>;
};

export type ComWixpressContactsLabelsV4ContactLabel = {
  __typename?: 'ComWixpressContactsLabelsV4ContactLabel';
  /** Date and time the label was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Label display name shown in the dashboard. */
  displayName?: Maybe<Scalars['String']>;
  /**
   * Label key.
   *
   * `key` is generated when the label is created.
   * It can't be modified, even if `displayName` is updated.
   */
  key?: Maybe<Scalars['String']>;
  /** Label type indicating how the label was created. */
  labelType?: Maybe<ComWixpressContactsLabelsV4ContactLabelLabelType>;
  /** Legacy ID of label. For internal use only. */
  legacyId?: Maybe<Scalars['String']>;
  /**
   * Label namespace.
   *
   * Labels created by calling the Find Or Create Label method
   * are automatically assigned to the `custom` namespace.
   */
  namespace?: Maybe<Scalars['String']>;
  /**
   * Display name for the namespace,
   * used to organize the list of labels in the site dashboard.
   */
  namespaceDisplayName?: Maybe<Scalars['String']>;
  /** ID of the parallel contacts-v5 tag. For internal use only. */
  tagId?: Maybe<Scalars['String']>;
  /** Date and time the label was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4ContactLabelInput = {
  /** Date and time the label was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Label display name shown in the dashboard. */
  displayName?: InputMaybe<Scalars['String']>;
  /**
   * Label key.
   *
   * `key` is generated when the label is created.
   * It can't be modified, even if `displayName` is updated.
   */
  key?: InputMaybe<Scalars['String']>;
  /** Label type indicating how the label was created. */
  labelType?: InputMaybe<ComWixpressContactsLabelsV4ContactLabelLabelType>;
  /** Legacy ID of label. For internal use only. */
  legacyId?: InputMaybe<Scalars['String']>;
  /**
   * Label namespace.
   *
   * Labels created by calling the Find Or Create Label method
   * are automatically assigned to the `custom` namespace.
   */
  namespace?: InputMaybe<Scalars['String']>;
  /**
   * Display name for the namespace,
   * used to organize the list of labels in the site dashboard.
   */
  namespaceDisplayName?: InputMaybe<Scalars['String']>;
  /** ID of the parallel contacts-v5 tag. For internal use only. */
  tagId?: InputMaybe<Scalars['String']>;
  /** Date and time the label was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressContactsLabelsV4ContactLabelLabelType {
  /** Default system label for the contact list. */
  System = 'SYSTEM',
  /** Fetch all labels. */
  Unknown = 'UNKNOWN',
  /** Label created by calling the Find Or Create Label method. */
  UserDefined = 'USER_DEFINED',
  /** Label created by an app built by Wix. */
  WixAppDefined = 'WIX_APP_DEFINED'
}

export type ComWixpressContactsLabelsV4ContactLabelNamespace = {
  __typename?: 'ComWixpressContactsLabelsV4ContactLabelNamespace';
  /** Namespace display name */
  displayName?: Maybe<Scalars['String']>;
  /** Namespace key */
  key?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4DeleteLabelRequestInput = {
  /** Label key to delete. */
  key?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4FindOrCreateLabelRequestInput = {
  /**
   * Display name to retrieve or create.
   *
   * If an existing label is an exact match
   * for the specified display name,
   * the existing label is returned.
   * If not, a new label is created and returned.
   */
  displayName?: InputMaybe<Scalars['String']>;
  /**
   * Label type.
   *
   * - `SYSTEM`: The label is a default system label for the Contact List.
   * - `USER_DEFINED`: The label was created by a site contributor or 3rd-party app.
   * - `WIX_APP_DEFINED`: The label was created by a Wix app.
   *
   * This field is read-only and will be ignored when creating a label.
   */
  labelType?: InputMaybe<ComWixpressContactsLabelsV4ContactLabelLabelType>;
  /**
   * Language for localization.
   * 2-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /**
   * Label namespace.
   * Labels created by calling the Find Or Create Label method
   * are automatically assigned to the `custom` namespace.
   *
   * This field is read-only and is ignored when creating a label.
   */
  namespace?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4FindOrCreateLabelResponse = {
  __typename?: 'ComWixpressContactsLabelsV4FindOrCreateLabelResponse';
  /** Label that was found or created. */
  label?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
  /**
   * Indicates whether the label was just created or already existed.
   *
   * Returns `true` if the label was just created.
   */
  newLabel?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressContactsLabelsV4GdprListRequestInput = {
  /** Contacts Instance ID of the site. */
  instanceId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4GdprListResponse = {
  __typename?: 'ComWixpressContactsLabelsV4GdprListResponse';
  /** List of labels */
  labels?: Maybe<Array<Maybe<ComWixpressContactsLabelsV4ContactLabel>>>;
};

export type ComWixpressContactsLabelsV4GetContactLabelRequestInput = {
  id: Scalars['ID'];
  /**
   * Language for localization.
   * 2-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes) format.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4GetLabelByLegacyIdRequestInput = {
  /** Language for localization */
  language?: InputMaybe<Scalars['String']>;
  /** Legacy id of the label */
  legacyId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4GetLabelByLegacyIdResponse = {
  __typename?: 'ComWixpressContactsLabelsV4GetLabelByLegacyIdResponse';
  /** Requested label */
  label?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
};

export type ComWixpressContactsLabelsV4ListLabelNamespacesRequestInput = {
  /** Language for localization */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4ListLabelNamespacesResponse = {
  __typename?: 'ComWixpressContactsLabelsV4ListLabelNamespacesResponse';
  /** List of namespaces */
  namespaces?: Maybe<Array<Maybe<ComWixpressContactsLabelsV4ContactLabelNamespace>>>;
};

export type ComWixpressContactsLabelsV4ListLabelsRequestInput = {
  /** Filter for labels of the specified type. */
  labelType?: InputMaybe<ComWixpressContactsLabelsV4ContactLabelLabelType>;
  language?: InputMaybe<Scalars['String']>;
  /** Filter for labels in the specified namespace. */
  namespace?: InputMaybe<Scalars['String']>;
  /** Paging options. */
  paging?: InputMaybe<ComWixpressContactsLabelsV4UpstreamWixCommonPagingInput>;
  /** Sorting options. */
  sort?: InputMaybe<ComWixpressContactsLabelsV4UpstreamWixCommonSortingInput>;
  /** Filter for labels where `displayName` starts with the specified case-sensitive string. */
  startsWith?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4ListLabelsResponse = {
  __typename?: 'ComWixpressContactsLabelsV4ListLabelsResponse';
  /** List of labels. */
  labels?: Maybe<Array<Maybe<ComWixpressContactsLabelsV4ContactLabel>>>;
  /** Metadata for the page of results. */
  metadata?: Maybe<ComWixpressContactsLabelsV4UpstreamWixCommonPagingMetadata>;
};

export type ComWixpressContactsLabelsV4PurgeRequestInput = {
  /** Labels to exclude from the purge. */
  exludingLabelKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contacts Instance ID of the site. */
  instanceId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4PurgeResponse = {
  __typename?: 'ComWixpressContactsLabelsV4PurgeResponse';
  /** Number of deleted items */
  deletedItems?: Maybe<Scalars['Int']>;
};

export type ComWixpressContactsLabelsV4QueryLabelsRequestInput = {
  /**
   * Language for localization.
   * 2-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Query options. */
  query?: InputMaybe<ComWixpressContactsLabelsV4UpstreamWixQueryQueryInput>;
};

export type ComWixpressContactsLabelsV4QueryLabelsResponse = {
  __typename?: 'ComWixpressContactsLabelsV4QueryLabelsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressContactsLabelsV4ContactLabel>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressContactsLabelsV4UpdateLabelRequestInput = {
  /** Label to rename. */
  label?: InputMaybe<ComWixpressContactsLabelsV4ContactLabelInput>;
  /**
   * Language for localization.
   * 2-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes) format.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4UpdateLabelResponse = {
  __typename?: 'ComWixpressContactsLabelsV4UpdateLabelResponse';
  /** Renamed label. */
  label?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
};

export type ComWixpressContactsLabelsV4UpstreamWixCommonPagingInput = {
  /**
   * Number of items to return.
   *
   * Defaults to `1000`. <br>
   * Maximum: `2000`.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsLabelsV4UpstreamWixCommonPagingMetadata = {
  __typename?: 'ComWixpressContactsLabelsV4UpstreamWixCommonPagingMetadata';
  /** Number of items returned. */
  count?: Maybe<Scalars['Int']>;
  /** Requested offset. */
  offset?: Maybe<Scalars['Int']>;
  /**
   * Indicates if `total` calculation timed out before the response was sent.
   * Typically this happens if there is a large set of results.
   */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Number of items that matched the query. */
  total?: Maybe<Scalars['Int']>;
};

export enum ComWixpressContactsLabelsV4UpstreamWixCommonSortOrder {
  /** Sort by ascending order. */
  Asc = 'ASC',
  /** Sort by descending order. */
  Desc = 'DESC'
}

export type ComWixpressContactsLabelsV4UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /**
   * Sort order.
   *
   * Default: `ASC`.
   */
  order?: InputMaybe<ComWixpressContactsLabelsV4UpstreamWixCommonSortOrder>;
};

export type ComWixpressContactsLabelsV4UpstreamWixQueryQueryInput = {
  /**
   * ilter object.
   *
   * Possible filters: `$eq`, `$gt`, `$gte`, `$in`, `$lt`, `$lte`, `$ne`, `$startsWith`.
   *
   * For a detailed list of supported filters, see [sorting and filtering for labels](https://dev.wix.com/api/rest/contacts/labels/sort-and-filter).
   *
   * Example: `{ "filter": {
   * "displayName": {
   * "$startsWith": "Referral"
   * }
   * }
   * }`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressContactsLabelsV4UpstreamWixCommonPagingInput>;
  /**
   * Sorting options. For a list of fields that can be sorted, see [sorting and filtering for labels](https://dev.wix.com/api/rest/contacts/labels/sort-and-filter).
   *
   * Example: `{ "sort": [{"fieldName": "displayName", "order": "DESC"}] }`
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressContactsLabelsV4UpstreamWixCommonSortingInput>>>;
};

export enum ComWixpressCrmFinancialCommonApiV1CustomFieldGroup {
  BusinessDetails = 'BUSINESS_DETAILS',
  CustomerDetails = 'CUSTOMER_DETAILS',
  Document = 'DOCUMENT',
  Footer = 'FOOTER',
  Other = 'OTHER',
  UnknownCustomFieldGroup = 'UNKNOWN_CUSTOM_FIELD_GROUP'
}

export type ComWixpressCrmFinancialCommonApiV1CustomFieldValueInput = {
  /** The display name of the custom field value */
  displayName?: InputMaybe<Scalars['String']>;
  /** The group of the custom field indicates its intended placement in the financial document */
  group?: InputMaybe<ComWixpressCrmFinancialCommonApiV1CustomFieldGroup>;
  /** The unique id of the custom field value */
  id?: InputMaybe<Scalars['String']>;
  /** The optional namespace of the custom field value. This field may be used to indicate intended usage or source. */
  namespace?: InputMaybe<Scalars['String']>;
  /** The optional key of the custom field definition on which the custom field value is based */
  originCustomFieldKey?: InputMaybe<Scalars['String']>;
  /** The value of the custom field */
  value?: InputMaybe<ComWixpressCrmFinancialCommonApiV1ValueInput>;
};

export type ComWixpressCrmFinancialCommonApiV1ValueInput = {
  value?: InputMaybe<Scalars['String']>;
  valueType?: InputMaybe<ComWixpressCrmFinancialCommonApiV1ValueValueType>;
};

export enum ComWixpressCrmFinancialCommonApiV1ValueValueType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  String = 'STRING',
  UnknownValueType = 'UNKNOWN_VALUE_TYPE'
}

export type ComWixpressHtmlEditorApiEventsHtmlSitePublishedInput = {
  /** Application instance ID */
  appInstanceId?: InputMaybe<Scalars['String']>;
  /** Application type */
  appType?: InputMaybe<Scalars['String']>;
  /** optional branch id if publish is done from branch */
  branchId?: InputMaybe<Scalars['String']>;
  /** The site's last transactionId */
  lastTransactionId?: InputMaybe<Scalars['Long']>;
  /** MSID */
  metaSiteId?: InputMaybe<Scalars['String']>;
  /** A list of the site's pages */
  pages?: InputMaybe<Array<InputMaybe<ComWixpressHtmlEditorApiEventsPageInput>>>;
  /** Site's publish date */
  publishDate?: InputMaybe<Scalars['Long']>;
  /** Revision */
  revision?: InputMaybe<Scalars['Long']>;
};

export type ComWixpressHtmlEditorApiEventsPageInput = {
  /** Page's Id */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsAddLocationTypeRequestInput = {
  /** Location id to add type */
  id?: InputMaybe<Scalars['String']>;
  locationType?: InputMaybe<ComWixpressLocationsLocationType>;
};

export type ComWixpressLocationsAddLocationTypeResponse = {
  __typename?: 'ComWixpressLocationsAddLocationTypeResponse';
  /** Full location with the new type */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsAddTypeToLocationRequestInput = {
  /** ID of the location where the type will be added. */
  id?: InputMaybe<Scalars['String']>;
  /** Location type to add. */
  locationType?: InputMaybe<ComWixpressLocationsLocationType>;
};

export type ComWixpressLocationsAddTypeToLocationResponse = {
  __typename?: 'ComWixpressLocationsAddTypeToLocationResponse';
  /** Updated location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsAddress = {
  __typename?: 'ComWixpressLocationsAddress';
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** 2-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: Maybe<Scalars['String']>;
  /** Full address of the location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Geographic coordinates of location. */
  geocode?: Maybe<ComWixpressLocationsAddressLocation>;
  /** Extra information that helps finding the location. */
  hint?: Maybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street address. Includes street name, number, and apartment number in separate fields. */
  streetAddress?: Maybe<ComWixpressLocationsStreetAddress>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format. */
  subdivision?: Maybe<Scalars['String']>;
};

export type ComWixpressLocationsAddressInput = {
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** 2-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Full address of the location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Geographic coordinates of location. */
  geocode?: InputMaybe<ComWixpressLocationsAddressLocationInput>;
  /** Extra information that helps finding the location. */
  hint?: InputMaybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street address. Includes street name, number, and apartment number in separate fields. */
  streetAddress?: InputMaybe<ComWixpressLocationsStreetAddressInput>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format. */
  subdivision?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsAddressLocation = {
  __typename?: 'ComWixpressLocationsAddressLocation';
  /** Latitude of the location. Must be between -90 and 90. */
  latitude?: Maybe<Scalars['Float']>;
  /** Longitude of the location. Must be between -180 and 180. */
  longitude?: Maybe<Scalars['Float']>;
};

export type ComWixpressLocationsAddressLocationInput = {
  /** Latitude of the location. Must be between -90 and 90. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Longitude of the location. Must be between -180 and 180. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressLocationsArchiveLocationRequestInput = {
  /** ID of the location to archive. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsArchiveLocationResponse = {
  __typename?: 'ComWixpressLocationsArchiveLocationResponse';
  /** Archived location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsBulkCreateLocationRequestInput = {
  /** Locations to create. */
  locations?: InputMaybe<Array<InputMaybe<ComWixpressLocationsLocationInput>>>;
};

export type ComWixpressLocationsBulkCreateLocationResponse = {
  __typename?: 'ComWixpressLocationsBulkCreateLocationResponse';
  /** Locations that failed. */
  failedLocations?: Maybe<Array<Maybe<ComWixpressLocationsFailedCreateLocation>>>;
  /** Locations that were created. */
  successfulLocations?: Maybe<Array<Maybe<ComWixpressLocationsLocation>>>;
};

export type ComWixpressLocationsBulkUpdateLocationRequestInput = {
  /** Locations to update. */
  locations?: InputMaybe<Array<InputMaybe<ComWixpressLocationsLocationInput>>>;
};

export type ComWixpressLocationsBulkUpdateLocationResponse = {
  __typename?: 'ComWixpressLocationsBulkUpdateLocationResponse';
  /** Locations that failed. */
  failedLocations?: Maybe<Array<Maybe<ComWixpressLocationsFailedUpdateLocation>>>;
  /** Locations that were updated. */
  successfulLocations?: Maybe<Array<Maybe<ComWixpressLocationsLocation>>>;
};

export type ComWixpressLocationsCreateLocationRequestInput = {
  /** Location to create. */
  location?: InputMaybe<ComWixpressLocationsLocationInput>;
};

export type ComWixpressLocationsCreateLocationResponse = {
  __typename?: 'ComWixpressLocationsCreateLocationResponse';
  /** Created location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsFailedCreateLocation = {
  __typename?: 'ComWixpressLocationsFailedCreateLocation';
  /** Error message. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Location that couldn't be created. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsFailedUpdateLocation = {
  __typename?: 'ComWixpressLocationsFailedUpdateLocation';
  /** Error message. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Location that couldn't be updated. */
  id?: Maybe<Scalars['String']>;
};

export type ComWixpressLocationsGetLocationRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressLocationsListLocationsRequestInput = {
  /** Whether to filter only authorized locations */
  filterAuthorizedLocationEntities?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to include `archived` locations in the response.
   *
   * Default: `false`
   */
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  /**
   * Pagination.
   *
   * Default values:
   * `offset`: 0
   * `limit`: 50 (Max: 1000)
   */
  paging?: InputMaybe<WixCommonPagingInput>;
  /** Sort order. */
  sort?: InputMaybe<WixCommonSortingInput>;
};

export type ComWixpressLocationsListLocationsResponse = {
  __typename?: 'ComWixpressLocationsListLocationsResponse';
  /** Ids of the locations that the requesting entity can manage */
  authorizedLocationEntities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Retrieved locations. */
  locations?: Maybe<Array<Maybe<ComWixpressLocationsLocation>>>;
  /** Paging info. */
  pagingMetadata?: Maybe<ComWixpressLocationsPagingMetadata>;
};

export type ComWixpressLocationsLocation = {
  __typename?: 'ComWixpressLocationsLocation';
  /** Address. */
  address?: Maybe<ComWixpressLocationsAddress>;
  /**
   * Whether the location is archived. Archived locations can't be updated.
   * __Note:__ [Archiving a location](https://dev.wix.com/api/rest/business-info/locations/archive-location)
   * doesn't affect its `status`.
   */
  archived?: Maybe<Scalars['Boolean']>;
  /**
   * Business schedule. Array of weekly recurring time periods when the location is open for business. Limited to 100 time periods.
   *
   * __Note:__ Not supported by Wix Bookings.
   */
  businessSchedule?: Maybe<ComWixpressSitepropertiesApiV4BusinessSchedule>;
  /** Whether this is the default location. There can only be one default location per site. The default location can't be archived. */
  default?: Maybe<Scalars['Boolean']>;
  /** Location description. */
  description?: Maybe<Scalars['String']>;
  /** Email address. */
  email?: Maybe<Scalars['String']>;
  /** Fax number. */
  fax?: Maybe<Scalars['String']>;
  /** Location ID. */
  id?: Maybe<Scalars['String']>;
  itemsVirtualReference?: Maybe<ComWixpressRestaurantsMenusItemV1QueryItemsResponse>;
  /**
   * Location type.
   *
   * **Note:** Currently not supported.
   */
  locationType?: Maybe<ComWixpressLocationsLocationType>;
  /** Location types. */
  locationTypes?: Maybe<Array<Maybe<ComWixpressLocationsLocationType>>>;
  modifierGroupsVirtualReference?: Maybe<WixRestaurantsMenusV1QueryModifierGroupsResponse>;
  modifiersVirtualReference?: Maybe<WixRestaurantsMenusItemModifierV1QueryModifiersResponse>;
  /** Location name. */
  name?: Maybe<Scalars['String']>;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the location is updated.
   * To prevent conflicting changes, the existing revision must be used when updating a location.
   */
  revision?: Maybe<Scalars['Long']>;
  sectionsVirtualReference?: Maybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse>;
  /**
   * Location status. Defaults to `ACTIVE`.
   * __Notes:__
   * - [Archiving a location](https://dev.wix.com/api/rest/business-info/locations/archive-location)
   * doesn't affect the location's status.
   * - `INACTIVE` status is currently not supported.
   */
  status?: Maybe<ComWixpressLocationsLocationStatus>;
  /** Timezone in `America/New_York` format. */
  timeZone?: Maybe<Scalars['String']>;
  variantsVirtualReference?: Maybe<WixRestaurantsMenusItemVariantV1QueryVariantsResponse>;
};


export type ComWixpressLocationsLocationItemsVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemV1QueryItemsRequestInput>;
};


export type ComWixpressLocationsLocationModifierGroupsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusV1QueryModifierGroupsRequestInput>;
};


export type ComWixpressLocationsLocationModifiersVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemModifierV1QueryModifiersRequestInput>;
};


export type ComWixpressLocationsLocationSectionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput>;
};


export type ComWixpressLocationsLocationVariantsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemVariantV1QueryVariantsRequestInput>;
};

export type ComWixpressLocationsLocationInput = {
  /** Address. */
  address?: InputMaybe<ComWixpressLocationsAddressInput>;
  /**
   * Whether the location is archived. Archived locations can't be updated.
   * __Note:__ [Archiving a location](https://dev.wix.com/api/rest/business-info/locations/archive-location)
   * doesn't affect its `status`.
   */
  archived?: InputMaybe<Scalars['Boolean']>;
  /**
   * Business schedule. Array of weekly recurring time periods when the location is open for business. Limited to 100 time periods.
   *
   * __Note:__ Not supported by Wix Bookings.
   */
  businessSchedule?: InputMaybe<ComWixpressSitepropertiesApiV4BusinessScheduleInput>;
  /** Whether this is the default location. There can only be one default location per site. The default location can't be archived. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Location description. */
  description?: InputMaybe<Scalars['String']>;
  /** Email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Fax number. */
  fax?: InputMaybe<Scalars['String']>;
  /** Location ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Location type.
   *
   * **Note:** Currently not supported.
   */
  locationType?: InputMaybe<ComWixpressLocationsLocationType>;
  /** Location types. */
  locationTypes?: InputMaybe<Array<InputMaybe<ComWixpressLocationsLocationType>>>;
  /** Location name. */
  name?: InputMaybe<Scalars['String']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the location is updated.
   * To prevent conflicting changes, the existing revision must be used when updating a location.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Location status. Defaults to `ACTIVE`.
   * __Notes:__
   * - [Archiving a location](https://dev.wix.com/api/rest/business-info/locations/archive-location)
   * doesn't affect the location's status.
   * - `INACTIVE` status is currently not supported.
   */
  status?: InputMaybe<ComWixpressLocationsLocationStatus>;
  /** Timezone in `America/New_York` format. */
  timeZone?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressLocationsLocationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum ComWixpressLocationsLocationType {
  Branch = 'BRANCH',
  Headquarters = 'HEADQUARTERS',
  Inventory = 'INVENTORY',
  Offices = 'OFFICES',
  Reception = 'RECEPTION',
  Unknown = 'UNKNOWN'
}

export type ComWixpressLocationsPagingMetadata = {
  __typename?: 'ComWixpressLocationsPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
};

export type ComWixpressLocationsQueryLocationsRequestInput = {
  /** Whether to filter only authorized locations */
  filterAuthorizedLocationEntities?: InputMaybe<Scalars['Boolean']>;
  /** Information about the filters, sorting, and paging. */
  query?: InputMaybe<WixCommonQueryInput>;
};

export type ComWixpressLocationsQueryLocationsResponse = {
  __typename?: 'ComWixpressLocationsQueryLocationsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressLocationsLocation>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressLocationsRemoveLocationTypeRequestInput = {
  /** Location id to add type */
  id?: InputMaybe<Scalars['String']>;
  locationType?: InputMaybe<ComWixpressLocationsLocationType>;
};

export type ComWixpressLocationsRemoveLocationTypeResponse = {
  __typename?: 'ComWixpressLocationsRemoveLocationTypeResponse';
  /** Full location with the new type */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsRemoveTypeFromLocationRequestInput = {
  /** ID of the location where the type will be removed. */
  id?: InputMaybe<Scalars['String']>;
  /** Location type to remove. */
  locationType?: InputMaybe<ComWixpressLocationsLocationType>;
};

export type ComWixpressLocationsRemoveTypeFromLocationResponse = {
  __typename?: 'ComWixpressLocationsRemoveTypeFromLocationResponse';
  /** Updated location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsSetDefaultLocationRequestInput = {
  /** ID of the location to set as the default location. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsSetDefaultLocationResponse = {
  __typename?: 'ComWixpressLocationsSetDefaultLocationResponse';
  /** New default location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsStreetAddress = {
  __typename?: 'ComWixpressLocationsStreetAddress';
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type ComWixpressLocationsStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsUnarchiveLocationRequestInput = {
  /** ID of the location to unarchive. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsUnarchiveLocationResponse = {
  __typename?: 'ComWixpressLocationsUnarchiveLocationResponse';
  /** Unarchived location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsUpdateLocationRequestInput = {
  /** Location to update. */
  location?: InputMaybe<ComWixpressLocationsLocationInput>;
};

export type ComWixpressLocationsUpdateLocationResponse = {
  __typename?: 'ComWixpressLocationsUpdateLocationResponse';
  /** Updated location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export enum ComWixpressMembersApiAccessStatusStatus {
  /** Member can log in to the site. */
  Approved = 'APPROVED',
  /** Member is blocked and can't log in to the site. */
  Blocked = 'BLOCKED',
  /** Member is a [guest author](https://support.wix.com/en/article/wix-blog-adding-managed-writers-to-your-blog) for the site blog and can't log in to the site. */
  Offline = 'OFFLINE',
  /** Member is created and is waiting for approval by a Wix user. */
  Pending = 'PENDING',
  /** Insufficient permissions to get the status. */
  Unknown = 'UNKNOWN'
}

export enum ComWixpressMembersApiActivityStatusStatus {
  /** Member can write forum posts and blog comments. */
  Active = 'ACTIVE',
  /** Member can't write forum posts or blog comments. */
  Muted = 'MUTED',
  /** Insufficient permissions to get the status. */
  Unknown = 'UNKNOWN'
}

export type ComWixpressMembersApiAddress = {
  __typename?: 'ComWixpressMembersApiAddress';
  /** Main address line, usually street and number, as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /**
   * Free text providing more detailed address information,
   * such as apartment, suite, or floor.
   */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /**
   * 2-letter country code in an
   * [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format.
   */
  country?: Maybe<Scalars['String']>;
  /** Street address ID. */
  id?: Maybe<Scalars['String']>;
  /** Postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street address object, with number and name in separate fields. */
  streetAddress?: Maybe<ComWixpressMembersApiStreetAddress>;
  /**
   * Code for a subdivision (such as state, prefecture, or province) in an
   * [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format.
   */
  subdivision?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiAddressInput = {
  /** Main address line, usually street and number, as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /**
   * Free text providing more detailed address information,
   * such as apartment, suite, or floor.
   */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /**
   * 2-letter country code in an
   * [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format.
   */
  country?: InputMaybe<Scalars['String']>;
  /** Street address ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street address object, with number and name in separate fields. */
  streetAddress?: InputMaybe<ComWixpressMembersApiStreetAddressInput>;
  /**
   * Code for a subdivision (such as state, prefecture, or province) in an
   * [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format.
   */
  subdivision?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiApproveMemberRequestInput = {
  /** ID of the member to approve. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiApproveMemberResponse = {
  __typename?: 'ComWixpressMembersApiApproveMemberResponse';
  /** Approved member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiBlockMemberRequestInput = {
  /** ID of a member to block. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiBlockMemberResponse = {
  __typename?: 'ComWixpressMembersApiBlockMemberResponse';
  /** Blocked member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiBulkApproveMembersRequestInput = {
  /** Query options. See API Query Language ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)) for more details. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressMembersApiBulkApproveMembersResponse = {
  __typename?: 'ComWixpressMembersApiBulkApproveMembersResponse';
  /**
   * Job ID.
   * Specify this ID when calling Get Async Job ([SDK](https://dev.wix.com/docs/sdk/backend-modules/async-jobs/get-async-job) | [REST](https://dev.wix.com/docs/rest/business-management/async-job/introduction)) to retrieve job details and metadata.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiBulkBlockMembersRequestInput = {
  /** Query options. See API Query Language ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)) for more details. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressMembersApiBulkBlockMembersResponse = {
  __typename?: 'ComWixpressMembersApiBulkBlockMembersResponse';
  /**
   * Job ID.
   * Specify this ID when calling Get Async Job ([SDK](https://dev.wix.com/docs/sdk/backend-modules/async-jobs/get-async-job) | [REST](https://dev.wix.com/docs/rest/business-management/async-job/introduction)) to retrieve job details and metadata.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiBulkDeleteMembersByFilterRequestInput = {
  /** ID of a member receiving the deleted member's content. */
  contentAssigneeId?: InputMaybe<Scalars['String']>;
  /** Query options. See API Query Language ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)) for more details. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Plain text search. */
  search?: InputMaybe<ComWixpressMembersApiSearchInput>;
};

export type ComWixpressMembersApiBulkDeleteMembersByFilterResponse = {
  __typename?: 'ComWixpressMembersApiBulkDeleteMembersByFilterResponse';
  /**
   * Job ID.
   * Specify this ID when calling Get Async Job ([SDK](https://dev.wix.com/docs/sdk/backend-modules/async-jobs/get-async-job) | [REST](https://dev.wix.com/docs/rest/business-management/async-job/introduction)) to retrieve job details and metadata.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiBulkDeleteMembersRequestInput = {
  /** IDs of members to be deleted. */
  memberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMembersApiBulkDeleteMembersResponse = {
  __typename?: 'ComWixpressMembersApiBulkDeleteMembersResponse';
  /** Bulk action result metadata. */
  bulkActionMetadata?: Maybe<ComWixpressMembersApiUpstreamWixCommonBulkActionMetadata>;
  /** Result. */
  results?: Maybe<Array<Maybe<ComWixpressMembersApiBulkDeleteMembersResponseBulkMemberResult>>>;
};

export type ComWixpressMembersApiBulkDeleteMembersResponseBulkMemberResult = {
  __typename?: 'ComWixpressMembersApiBulkDeleteMembersResponseBulkMemberResult';
  itemMetadata?: Maybe<ComWixpressMembersApiUpstreamWixCommonItemMetadata>;
};

export type ComWixpressMembersApiContact = {
  __typename?: 'ComWixpressMembersApiContact';
  /** List of street addresses. */
  addresses?: Maybe<Array<Maybe<ComWixpressMembersApiAddress>>>;
  /**
   * Contact's birthdate, formatted as `"YYYY-MM-DD"`.
   *
   * Example: `"2020-03-15"` for March 15, 2020.
   */
  birthdate?: Maybe<Scalars['String']>;
  /** Contact's company name. */
  company?: Maybe<Scalars['String']>;
  /**
   * Contact ID.
   *
   * > **Deprecation notice:**
   * > This property has been replaced with `member.contactId`
   * > and will be removed on June 11, 2021.
   */
  contactId?: Maybe<Scalars['String']>;
  /**
   * Custom fields,
   * where each key is the field key,
   * and each value is the field's value for the member.
   */
  customFields?: Maybe<ComWixpressMembersApiCustomField>;
  /** List of email addresses. */
  emails?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Contact's first name. */
  firstName?: Maybe<Scalars['String']>;
  /** Contact's job title. */
  jobTitle?: Maybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: Maybe<Scalars['String']>;
  /** List of phone numbers. */
  phones?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressMembersApiContactInput = {
  /** List of street addresses. */
  addresses?: InputMaybe<Array<InputMaybe<ComWixpressMembersApiAddressInput>>>;
  /**
   * Contact's birthdate, formatted as `"YYYY-MM-DD"`.
   *
   * Example: `"2020-03-15"` for March 15, 2020.
   */
  birthdate?: InputMaybe<Scalars['String']>;
  /** Contact's company name. */
  company?: InputMaybe<Scalars['String']>;
  /**
   * Contact ID.
   *
   * > **Deprecation notice:**
   * > This property has been replaced with `member.contactId`
   * > and will be removed on June 11, 2021.
   */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * Custom fields,
   * where each key is the field key,
   * and each value is the field's value for the member.
   */
  customFields?: InputMaybe<ComWixpressMembersApiCustomFieldInput>;
  /** List of email addresses. */
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contact's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Contact's job title. */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** List of phone numbers. */
  phones?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMembersApiCreateMemberRequestInput = {
  /** Member to create. */
  member?: InputMaybe<ComWixpressMembersApiMemberInput>;
};

export type ComWixpressMembersApiCreateMemberResponse = {
  __typename?: 'ComWixpressMembersApiCreateMemberResponse';
  /** New member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiCustomField = {
  __typename?: 'ComWixpressMembersApiCustomField';
  /** Custom field name. */
  name?: Maybe<Scalars['String']>;
  /** Custom field value. */
  value?: Maybe<Scalars['JSON']>;
};

export type ComWixpressMembersApiCustomFieldInput = {
  /** Custom field name. */
  name?: InputMaybe<Scalars['String']>;
  /** Custom field value. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressMembersApiDeleteMemberAddressesRequestInput = {
  /** ID of the member whose street addresses will be deleted. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDeleteMemberAddressesResponse = {
  __typename?: 'ComWixpressMembersApiDeleteMemberAddressesResponse';
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiDeleteMemberEmailsRequestInput = {
  /** ID of the member whose email addresses will be deleted. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDeleteMemberEmailsResponse = {
  __typename?: 'ComWixpressMembersApiDeleteMemberEmailsResponse';
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiDeleteMemberPhonesRequestInput = {
  /** ID of the member whose phone numbers will be deleted. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDeleteMemberPhonesResponse = {
  __typename?: 'ComWixpressMembersApiDeleteMemberPhonesResponse';
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiDeleteMemberRequestInput = {
  /** ID of a member receiving the deleted member's content. */
  contentAssigneeId?: InputMaybe<Scalars['String']>;
  /** ID of a member to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDeleteMyMemberRequestInput = {
  /** ID of a member receiving the deleted member's content. */
  contentAssigneeId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDisconnectMemberRequestInput = {
  /** ID of a member to disconnect. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDisconnectMemberResponse = {
  __typename?: 'ComWixpressMembersApiDisconnectMemberResponse';
  /** Disconnected member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export enum ComWixpressMembersApiFieldSetSet {
  /** Includes `id`, `loginEmail`, `status`, `contactId`, `createdDate`, `updatedDate`, `privacyStatus`, `activityStatus` and the `profile` object. */
  Extended = 'EXTENDED',
  /** Includes all fields. */
  Full = 'FULL',
  /**
   * Includes `id`, `contactId`, `createdDate`, `updatedDate` and the `profile` object.
   * `status`, `privacyStatus`, and `activityStatus` are returned as `UNKNOWN`.
   */
  Public = 'PUBLIC'
}

export type ComWixpressMembersApiGetMemberRequestInput = {
  /**
   * Predefined set of fields to return.
   *
   * Defaults to `"PUBLIC"`.
   *
   * __Deprecated.__ Use `fieldsets` instead.
   * This property will be removed on March 31, 2023.
   */
  fieldSet?: InputMaybe<ComWixpressMembersApiFieldSetSet>;
  /**
   * Predefined set of fields to return.
   *
   * Defaults to `"PUBLIC"`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressMembersApiFieldSetSet>>>;
  id: Scalars['ID'];
};

export type ComWixpressMembersApiGetMyMemberRequestInput = {
  /**
   * *Deprecated:** Use `fieldsets` instead.
   *
   * Predefined set of fields to return.
   */
  fieldSet?: InputMaybe<ComWixpressMembersApiFieldSetSet>;
  /**
   * Predefined set of fields to return.
   *
   * Default: `"PUBLIC"`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressMembersApiFieldSetSet>>>;
};

export type ComWixpressMembersApiGetMyMemberResponse = {
  __typename?: 'ComWixpressMembersApiGetMyMemberResponse';
  /** The retrieved member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiJoinCommunityResponse = {
  __typename?: 'ComWixpressMembersApiJoinCommunityResponse';
  /** The updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiLeaveCommunityResponse = {
  __typename?: 'ComWixpressMembersApiLeaveCommunityResponse';
  /** The updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiListMembersRequestInput = {
  /**
   * Cursor paging.
   *
   * Priority over paging property
   */
  cursorPaging?: InputMaybe<ComWixpressMembersApiUpstreamWixCommonCursorPagingInput>;
  /**
   * Predefined sets of fields to return.
   *
   * Defaults to `"PUBLIC"`.
   *
   * __Deprecated.__ Use `fieldsets` instead.
   * This property will be removed on March 31, 2023.
   */
  fieldSet?: InputMaybe<ComWixpressMembersApiFieldSetSet>;
  /**
   * Predefined sets of fields to return.
   *
   * Default: `"PUBLIC"`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressMembersApiFieldSetSet>>>;
  paging?: InputMaybe<WixCommonPagingInput>;
  sorting?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressMembersApiListMembersResponse = {
  __typename?: 'ComWixpressMembersApiListMembersResponse';
  /** Cursor metadata for paginated results. */
  cursorPagingMetadata?: Maybe<ComWixpressMembersApiUpstreamWixCommonCursorPagingMetadata>;
  /** List of members. */
  members?: Maybe<Array<Maybe<ComWixpressMembersApiMember>>>;
  /** Metadata for the paginated results. */
  metadata?: Maybe<WixCommonPagingMetadata>;
};

export type ComWixpressMembersApiMember = {
  __typename?: 'ComWixpressMembersApiMember';
  /** Member activity status. */
  activityStatus?: Maybe<ComWixpressMembersApiActivityStatusStatus>;
  /**
   * Member's contact information. Contact information is stored in the
   * [Contact List](https://www.wix.com/my-account/site-selector/?buttonText=Select%20Site&title=Select%20a%20Site&autoSelectOnSingleSite=true&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Fcontacts).
   *
   * The full set of contact data can be accessed and managed with the
   * Contacts API ([SDK](https://dev.wix.com/docs/sdk/backend-modules/crm/contacts/introduction) | [REST](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/introduction)).
   */
  contact?: Maybe<ComWixpressMembersApiContact>;
  /** Contact ID. */
  contactId?: Maybe<Scalars['String']>;
  /** Date and time when the member was created. */
  createdDate?: Maybe<Scalars['String']>;
  /**
   * Extended fields.
   * @deprecated Extended fields. Removal date: 2024-06-01.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Member ID. */
  id?: Maybe<Scalars['String']>;
  /** Date and time when the member last logged in to the site. */
  lastLoginDate?: Maybe<Scalars['String']>;
  /** Email used by a member to log in to the site. */
  loginEmail?: Maybe<Scalars['String']>;
  /** Whether the email used by a member has been verified. */
  loginEmailVerified?: Maybe<Scalars['Boolean']>;
  participantsVirtualReference?: Maybe<WixOnlineprogramsParticipantsV3QueryParticipantsResponse>;
  /** Member privacy status. */
  privacyStatus?: Maybe<ComWixpressMembersApiPrivacyStatusStatus>;
  /** Profile display details. */
  profile?: Maybe<ComWixpressMembersApiProfile>;
  /** Member site access status. */
  status?: Maybe<ComWixpressMembersApiAccessStatusStatus>;
  /** Date and time when the member was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type ComWixpressMembersApiMemberParticipantsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsParticipantsV3QueryParticipantsRequestInput>;
};

export type ComWixpressMembersApiMemberInput = {
  /** Member activity status. */
  activityStatus?: InputMaybe<ComWixpressMembersApiActivityStatusStatus>;
  /**
   * Member's contact information. Contact information is stored in the
   * [Contact List](https://www.wix.com/my-account/site-selector/?buttonText=Select%20Site&title=Select%20a%20Site&autoSelectOnSingleSite=true&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Fcontacts).
   *
   * The full set of contact data can be accessed and managed with the
   * Contacts API ([SDK](https://dev.wix.com/docs/sdk/backend-modules/crm/contacts/introduction) | [REST](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/introduction)).
   */
  contact?: InputMaybe<ComWixpressMembersApiContactInput>;
  /** Contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Date and time when the member was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Member ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Date and time when the member last logged in to the site. */
  lastLoginDate?: InputMaybe<Scalars['String']>;
  /** Email used by a member to log in to the site. */
  loginEmail?: InputMaybe<Scalars['String']>;
  /** Whether the email used by a member has been verified. */
  loginEmailVerified?: InputMaybe<Scalars['Boolean']>;
  /** Member privacy status. */
  privacyStatus?: InputMaybe<ComWixpressMembersApiPrivacyStatusStatus>;
  /** Profile display details. */
  profile?: InputMaybe<ComWixpressMembersApiProfileInput>;
  /** Member site access status. */
  status?: InputMaybe<ComWixpressMembersApiAccessStatusStatus>;
  /** Date and time when the member was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiMuteMemberRequestInput = {
  /** ID of the member to mute. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiMuteMemberResponse = {
  __typename?: 'ComWixpressMembersApiMuteMemberResponse';
  /** Muted member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export enum ComWixpressMembersApiPrivacyStatusStatus {
  /** Member is hidden from site visitors and other site members. Member is returned only to Wix users. */
  Private = 'PRIVATE',
  /** Member is visible to everyone. */
  Public = 'PUBLIC',
  /** Insufficient permissions to get the status. */
  Unknown = 'UNKNOWN'
}

export type ComWixpressMembersApiProfile = {
  __typename?: 'ComWixpressMembersApiProfile';
  /**
   * Member's cover photo,
   * used as a background picture in a member's profile page.
   *
   * Cover positioning can be altered with `cover.offsetX` and `cover.offsetY`.
   * When left empty, the values default to `0`.
   */
  cover?: Maybe<ComWixpressMembersCommonImage>;
  /**
   * Name that identifies the member to other members.
   * Displayed on the member's profile page
   * and interactions in the forum or blog.
   */
  nickname?: Maybe<Scalars['String']>;
  /** Member's profile photo. */
  photo?: Maybe<ComWixpressMembersCommonImage>;
  /** Slug that determines the member's profile page URL. */
  slug?: Maybe<Scalars['String']>;
  /** Member title. */
  title?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiProfileInput = {
  /**
   * Member's cover photo,
   * used as a background picture in a member's profile page.
   *
   * Cover positioning can be altered with `cover.offsetX` and `cover.offsetY`.
   * When left empty, the values default to `0`.
   */
  cover?: InputMaybe<ComWixpressMembersCommonImageInput>;
  /**
   * Name that identifies the member to other members.
   * Displayed on the member's profile page
   * and interactions in the forum or blog.
   */
  nickname?: InputMaybe<Scalars['String']>;
  /** Member's profile photo. */
  photo?: InputMaybe<ComWixpressMembersCommonImageInput>;
  /** Slug that determines the member's profile page URL. */
  slug?: InputMaybe<Scalars['String']>;
  /** Member title. */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiQueryInput = {
  /**
   * Cursor paging.
   *
   * Priority over paging property
   */
  cursorPaging?: InputMaybe<ComWixpressMembersApiUpstreamWixCommonCursorPagingInput>;
  /** Query options. See [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language) for more details. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Limit number of results */
  paging?: InputMaybe<WixCommonPagingInput>;
  /** Sort the results */
  sorting?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressMembersApiQueryMembersRequestInput = {
  /**
   * Predefined sets of fields to return.
   *
   * Defaults to `"PUBLIC"`.
   *
   * __Deprecated.__ Use `fieldsets` instead.
   * This property will be removed on March 31, 2023.
   */
  fieldSet?: InputMaybe<ComWixpressMembersApiFieldSetSet>;
  /**
   * Predefined sets of fields to return.
   *
   * Default: `"PUBLIC"`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressMembersApiFieldSetSet>>>;
  /** Query options. */
  query?: InputMaybe<ComWixpressMembersApiQueryInput>;
  /** Plain text search. */
  search?: InputMaybe<ComWixpressMembersApiSearchInput>;
};

export type ComWixpressMembersApiQueryMembersResponse = {
  __typename?: 'ComWixpressMembersApiQueryMembersResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressMembersApiMember>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressMembersApiSearchInput = {
  /** Search term or expression. */
  expression?: InputMaybe<Scalars['String']>;
  /**
   * Currently supported fields for search:
   *
   * - `loginEmail`
   * - `contact.firstName`
   * - `contact.lastName`
   * - `profile.title`
   * - `profile.nickname`
   * - `profile.slug`
   *
   * Default: `profile.nickname`.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMembersApiStreetAddress = {
  __typename?: 'ComWixpressMembersApiStreetAddress';
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiStreetAddressInput = {
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiUnmuteMemberRequestInput = {
  /** ID of the member to unmute. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiUnmuteMemberResponse = {
  __typename?: 'ComWixpressMembersApiUnmuteMemberResponse';
  /** Unmuted member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiUpdateMemberRequestInput = {
  /** Member info to update. */
  member?: InputMaybe<ComWixpressMembersApiMemberInput>;
};

export type ComWixpressMembersApiUpdateMemberResponse = {
  __typename?: 'ComWixpressMembersApiUpdateMemberResponse';
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiUpdateMemberSlugRequestInput = {
  /** Member ID. */
  id?: InputMaybe<Scalars['String']>;
  /** New slug. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiUpdateMemberSlugResponse = {
  __typename?: 'ComWixpressMembersApiUpdateMemberSlugResponse';
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiUpdateMySlugRequestInput = {
  /** New slug. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiUpdateMySlugResponse = {
  __typename?: 'ComWixpressMembersApiUpdateMySlugResponse';
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiUpstreamWixCommonBulkActionMetadata = {
  __typename?: 'ComWixpressMembersApiUpstreamWixCommonBulkActionMetadata';
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export type ComWixpressMembersApiUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressMembersApiUpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'ComWixpressMembersApiUpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<ComWixpressMembersApiUpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressMembersApiUpstreamWixCommonCursors = {
  __typename?: 'ComWixpressMembersApiUpstreamWixCommonCursors';
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiUpstreamWixCommonItemMetadata = {
  __typename?: 'ComWixpressMembersApiUpstreamWixCommonItemMetadata';
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressMembersCommonImage = {
  __typename?: 'ComWixpressMembersCommonImage';
  /** Original image width. */
  height?: Maybe<Scalars['Int']>;
  /**
   * Wix Media image ID,
   * set when the member selects an image from Wix Media.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * X-axis offset.
   *
   * Default: `0`.
   */
  offsetX?: Maybe<Scalars['Int']>;
  /**
   * Y-axis offset.
   *
   * Default: `0`.
   */
  offsetY?: Maybe<Scalars['Int']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Original image height. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressMembersCommonImageInput = {
  /** Original image width. */
  height?: InputMaybe<Scalars['Int']>;
  /**
   * Wix Media image ID,
   * set when the member selects an image from Wix Media.
   */
  id?: InputMaybe<Scalars['String']>;
  /**
   * X-axis offset.
   *
   * Default: `0`.
   */
  offsetX?: InputMaybe<Scalars['Int']>;
  /**
   * Y-axis offset.
   *
   * Default: `0`.
   */
  offsetY?: InputMaybe<Scalars['Int']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressMembershipV1MoneyInput = {
  /** Monetary amount i.e. 3.99. */
  amount?: InputMaybe<Scalars['String']>;
  /** Currency in ISO 4217 format i.e. USD. */
  currency?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembershipV1PeriodInput = {
  /** The amount of Days, Months, Weeks or Years. */
  amount?: InputMaybe<Scalars['Int']>;
  unit?: InputMaybe<ComWixpressMembershipV1PeriodUnit>;
};

export enum ComWixpressMembershipV1PeriodUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type ComWixpressMembershipV1PlansPaymentOptionsInput = {
  /** Free trial period for the plan is in days only. It’s available only for recurring plans. */
  freeTrialDays?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<ComWixpressMembershipV1MoneyInput>;
  /** Recurring payments are payments billed Weekly, Monthly or Yearly. False - payment is one time; true - price is deducted from UoU every week, month or year. */
  recurring?: InputMaybe<Scalars['Boolean']>;
  validFor?: InputMaybe<ComWixpressMembershipV1ValidityInput>;
};

export type ComWixpressMembershipV1PlansPlanArchivedInput = {
  plan?: InputMaybe<ComWixpressMembershipV1PlansPlanInput>;
};

export type ComWixpressMembershipV1PlansPlanCreatedInput = {
  plan?: InputMaybe<ComWixpressMembershipV1PlansPlanInput>;
};

export type ComWixpressMembershipV1PlansPlanDetailsInput = {
  /** Plan benefits. */
  benefits?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clientData?: InputMaybe<Scalars['JSON']>;
  /** Plan description. */
  description?: InputMaybe<Scalars['String']>;
  /** Any terms & conditions that apply to the plan. This information will be displayed on the plan’s checkout screen. */
  disclaimer?: InputMaybe<Scalars['String']>;
  /** Plan name. */
  name?: InputMaybe<Scalars['String']>;
  /** Plan ribbon allows to show additional information for the plan i.e. ‘Best deal’. */
  ribbon?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembershipV1PlansPlanEventInput = {
  archived?: InputMaybe<ComWixpressMembershipV1PlansPlanArchivedInput>;
  created?: InputMaybe<ComWixpressMembershipV1PlansPlanCreatedInput>;
  updated?: InputMaybe<ComWixpressMembershipV1PlansPlanUpdatedInput>;
};

export type ComWixpressMembershipV1PlansPlanInput = {
  /** Indicates whether plan is archived. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Buyer can pick a later start date than the time of purchase. */
  buyerCanPickFutureStartDate?: InputMaybe<Scalars['Boolean']>;
  /** Date when plan was created. */
  dateCreated?: InputMaybe<Scalars['String']>;
  /** Date when plan was last updated. */
  dateUpdated?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<ComWixpressMembershipV1PlansPlanDetailsInput>;
  /** Indicates whether plan has orders. */
  hasOrders?: InputMaybe<Scalars['Boolean']>;
  /** Plan id. */
  id?: InputMaybe<Scalars['String']>;
  /** Member is allowed to cancel his/her plan. If no value is given it's set to true. */
  memberCanCancel?: InputMaybe<Scalars['Boolean']>;
  paymentOptions?: InputMaybe<ComWixpressMembershipV1PlansPaymentOptionsInput>;
  /** If true, the plan is marked as primary. */
  primary?: InputMaybe<Scalars['Boolean']>;
  /** Limits on the possible purchase */
  purchaseLimitations?: InputMaybe<ComWixpressMembershipV1PurchaseLimitationsInput>;
  /** Id of role/group in groups and permissions for service that is provided for the plan subscriber. */
  roleId?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  /** The plan is created from the templates (meaning it was created automatically with the site’s creation, not by the site owner). */
  template?: InputMaybe<Scalars['Boolean']>;
  /** If true, the plan is visible. */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressMembershipV1PlansPlanUpdatedInput = {
  plan?: InputMaybe<ComWixpressMembershipV1PlansPlanInput>;
  previousPlan?: InputMaybe<ComWixpressMembershipV1PlansPlanInput>;
};

export type ComWixpressMembershipV1PurchaseLimitationsInput = {
  /** Number of times plan can be purchased. If plan has no limits value should be NULL */
  amount?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressMembershipV1ValidityInput = {
  /** If true, plan is valid until canceled. */
  forever?: InputMaybe<Scalars['Boolean']>;
  period?: InputMaybe<ComWixpressMembershipV1PeriodInput>;
};

export type ComWixpressMembershipV2CommonMoney = {
  __typename?: 'ComWixpressMembershipV2CommonMoney';
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  value?: Maybe<Scalars['String']>;
};

export type ComWixpressMembershipV2CommonMoneyInput = {
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  value?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembershipV2CommonQueryV2Input = {
  /** A filter object. See [supported fields and operators](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/filter-and-sort#wix-pricing-plans_pricing-plans_plans_filter-and-sort_query-public-plans) */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pointer to page of results using offset. Can not be used together with 'cursorPaging' */
  paging?: InputMaybe<WixCommonPagingInput>;
  /** Sort object in the form [{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}] */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressMembershipV2Duration = {
  __typename?: 'ComWixpressMembershipV2Duration';
  /**
   * The amount of a duration `unit` in a single payment cycle.
   *
   * Currently limited to support only `1`.
   */
  count?: Maybe<Scalars['Int']>;
  /** Unit of time for the cycle duration. */
  unit?: Maybe<ComWixpressMembershipV2PeriodUnitEnumPeriodUnit>;
};

export type ComWixpressMembershipV2DurationInput = {
  /**
   * The amount of a duration `unit` in a single payment cycle.
   *
   * Currently limited to support only `1`.
   */
  count?: InputMaybe<Scalars['Int']>;
  /** Unit of time for the cycle duration. */
  unit?: InputMaybe<ComWixpressMembershipV2PeriodUnitEnumPeriodUnit>;
};

export type ComWixpressMembershipV2Fee = {
  __typename?: 'ComWixpressMembershipV2Fee';
  /** Amount of fee to be charged */
  amount?: Maybe<Scalars['String']>;
  /** Fee name */
  name?: Maybe<Scalars['String']>;
};

export type ComWixpressMembershipV2FeeConfig = {
  __typename?: 'ComWixpressMembershipV2FeeConfig';
  /** The time this fee will be charged */
  appliedAt?: Maybe<ComWixpressMembershipV2FeeConfigAppliedAt>;
  fee?: Maybe<ComWixpressMembershipV2Fee>;
};

export enum ComWixpressMembershipV2FeeConfigAppliedAt {
  /** Will charge the fee on first payment. If order has a free trial meaning it will charge after the free trial. */
  FirstPayment = 'FIRST_PAYMENT',
  UnknownChargeEvent = 'UNKNOWN_CHARGE_EVENT'
}

export type ComWixpressMembershipV2FeeConfigInput = {
  /** The time this fee will be charged */
  appliedAt?: InputMaybe<ComWixpressMembershipV2FeeConfigAppliedAt>;
  fee?: InputMaybe<ComWixpressMembershipV2FeeInput>;
};

export type ComWixpressMembershipV2FeeInput = {
  /** Amount of fee to be charged */
  amount?: InputMaybe<Scalars['String']>;
  /** Fee name */
  name?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressMembershipV2PeriodUnitEnumPeriodUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Undefined = 'UNDEFINED',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type ComWixpressMembershipV2PlansArchivePlanRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembershipV2PlansArchivePlanResponse = {
  __typename?: 'ComWixpressMembershipV2PlansArchivePlanResponse';
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export enum ComWixpressMembershipV2PlansArchivedFilterEnumArchivedFilter {
  /** Returns all plans that are active. */
  Active = 'ACTIVE',
  /** Returns all plans that are archived. */
  Archived = 'ARCHIVED',
  /** Returns all plans that are active and archived. */
  ArchivedAndActive = 'ARCHIVED_AND_ACTIVE'
}

export type ComWixpressMembershipV2PlansArrangePlansRequestInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMembershipV2PlansBulkArchivePlanRequestInput = {
  /** List of Plan IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Set to true to return Plan entity in response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressMembershipV2PlansBulkArchivePlanResponse = {
  __typename?: 'ComWixpressMembershipV2PlansBulkArchivePlanResponse';
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<ComWixpressMembershipV2PlansBulkPlanResult>>>;
};

export type ComWixpressMembershipV2PlansBulkPlanResult = {
  __typename?: 'ComWixpressMembershipV2PlansBulkPlanResult';
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export type ComWixpressMembershipV2PlansCreatePlanRequestInput = {
  plan?: InputMaybe<ComWixpressMembershipV2PlansPlanInput>;
};

export type ComWixpressMembershipV2PlansCreatePlanResponse = {
  __typename?: 'ComWixpressMembershipV2PlansCreatePlanResponse';
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export type ComWixpressMembershipV2PlansGetPlanRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressMembershipV2PlansGetPlanStatsResponse = {
  __typename?: 'ComWixpressMembershipV2PlansGetPlanStatsResponse';
  /** Total number of plans created, including active plans (both public and hidden) and archived plans. */
  totalPlans?: Maybe<Scalars['Int']>;
};

export type ComWixpressMembershipV2PlansListPlansRequestInput = {
  /** Archived filter. Defaults to ACTIVE (not archived) only. */
  archived?: InputMaybe<ComWixpressMembershipV2PlansArchivedFilterEnumArchivedFilter>;
  /** Number of pricing plans to list. Defaults to 75. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of pricing plans to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']>;
  /** Plan ID filter. Non-existent IDs are ignored, and won't cause errors. You can pass a maximum of 100 IDs. */
  planIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Visibility filter. Defaults to PUBLIC_AND_HIDDEN (meaning, both are listed). */
  public?: InputMaybe<ComWixpressMembershipV2PlansPublicFilterEnumPublicFilter>;
};

export type ComWixpressMembershipV2PlansListPlansResponse = {
  __typename?: 'ComWixpressMembershipV2PlansListPlansResponse';
  /** Object containing paging-related data (number of plans returned, offset). */
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** List of all public and hidden pricing plans. */
  plans?: Maybe<Array<Maybe<ComWixpressMembershipV2PlansPlan>>>;
};

export type ComWixpressMembershipV2PlansListPublicPlansRequestInput = {
  /** Number of items to list. Defaults to 75. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination). */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip. Defaults to 0. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination). */
  offset?: InputMaybe<Scalars['Int']>;
  /** IDs of plans to list. Non-existent IDs will be ignored and won't cause errors. You can pass a maximum of 100 IDs. */
  planIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMembershipV2PlansListPublicPlansResponse = {
  __typename?: 'ComWixpressMembershipV2PlansListPublicPlansResponse';
  /** Object containing paging-related data (number of plans returned, offset). */
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** List of public pricing plans. */
  plans?: Maybe<Array<Maybe<ComWixpressMembershipV2PlansPublicPlan>>>;
};

export type ComWixpressMembershipV2PlansMakePlanPrimaryRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembershipV2PlansMakePlanPrimaryResponse = {
  __typename?: 'ComWixpressMembershipV2PlansMakePlanPrimaryResponse';
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export type ComWixpressMembershipV2PlansPlan = {
  __typename?: 'ComWixpressMembershipV2PlansPlan';
  /** Whether the buyer can start the plan at a later date. Defaults to false. */
  allowFutureStartDate?: Maybe<Scalars['Boolean']>;
  /** Whether the plan is archived. Archived plans are not visible and can't be purchased anymore, but existing purchases remain in effect. */
  archived?: Maybe<Scalars['Boolean']>;
  /** Whether the buyer is allowed to cancel their plan. Defaults to false. */
  buyerCanCancel?: Maybe<Scalars['Boolean']>;
  clientData?: Maybe<Scalars['JSON']>;
  /** Date plan was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Plan description. */
  description?: Maybe<Scalars['String']>;
  /**
   * ID of the form associated with the plan at checkout.
   *
   * Learn more about [forms](https://support.wix.com/en/article/wix-forms-an-overview).
   */
  form?: Maybe<WixFormsV4Form>;
  /**
   * ID of the form associated with the plan at checkout.
   *
   * Learn more about [forms](https://support.wix.com/en/article/wix-forms-an-overview).
   */
  formId?: Maybe<Scalars['String']>;
  /** Whether the plan has any orders (including pending and unpaid orders). */
  hasOrders?: Maybe<Scalars['Boolean']>;
  /** Plan ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Number of times the same buyer can purchase the plan. Currently limited to support:
   * - Empty value or a value of `0`, meaning no limitation.
   * - Value of `1`, meaning limited to one purchase per buyer.
   */
  maxPurchasesPerBuyer?: Maybe<Scalars['Int']>;
  /** Plan name. */
  name?: Maybe<Scalars['String']>;
  /** What is included with this plan (e.g., 1 weekly entrance to a specific class). */
  perks?: Maybe<ComWixpressMembershipV2StringList>;
  /** Plan price, payment schedule, and expiration. */
  pricing?: Maybe<ComWixpressMembershipV2Pricing>;
  /** Whether the plan is marked as primary. */
  primary?: Maybe<Scalars['Boolean']>;
  /** Whether the plan is public (visible to site visitors and members). */
  public?: Maybe<Scalars['Boolean']>;
  /** URL-friendly version of plan name. Unique across all plans in the same site. */
  slug?: Maybe<Scalars['String']>;
  /** Any terms and conditions that apply to the plan. This information will be displayed during checkout. */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Date plan was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type ComWixpressMembershipV2PlansPlanInput = {
  /** Whether the buyer can start the plan at a later date. Defaults to false. */
  allowFutureStartDate?: InputMaybe<Scalars['Boolean']>;
  /** Whether the plan is archived. Archived plans are not visible and can't be purchased anymore, but existing purchases remain in effect. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Whether the buyer is allowed to cancel their plan. Defaults to false. */
  buyerCanCancel?: InputMaybe<Scalars['Boolean']>;
  clientData?: InputMaybe<Scalars['JSON']>;
  /** Date plan was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Plan description. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * ID of the form associated with the plan at checkout.
   *
   * Learn more about [forms](https://support.wix.com/en/article/wix-forms-an-overview).
   */
  formId?: InputMaybe<Scalars['String']>;
  /** Whether the plan has any orders (including pending and unpaid orders). */
  hasOrders?: InputMaybe<Scalars['Boolean']>;
  /** Plan ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Number of times the same buyer can purchase the plan. Currently limited to support:
   * - Empty value or a value of `0`, meaning no limitation.
   * - Value of `1`, meaning limited to one purchase per buyer.
   */
  maxPurchasesPerBuyer?: InputMaybe<Scalars['Int']>;
  /** Plan name. */
  name?: InputMaybe<Scalars['String']>;
  /** What is included with this plan (e.g., 1 weekly entrance to a specific class). */
  perks?: InputMaybe<ComWixpressMembershipV2StringListInput>;
  /** Plan price, payment schedule, and expiration. */
  pricing?: InputMaybe<ComWixpressMembershipV2PricingInput>;
  /** Whether the plan is marked as primary. */
  primary?: InputMaybe<Scalars['Boolean']>;
  /** Whether the plan is public (visible to site visitors and members). */
  public?: InputMaybe<Scalars['Boolean']>;
  /** URL-friendly version of plan name. Unique across all plans in the same site. */
  slug?: InputMaybe<Scalars['String']>;
  /** Any terms and conditions that apply to the plan. This information will be displayed during checkout. */
  termsAndConditions?: InputMaybe<Scalars['String']>;
  /** Date plan was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressMembershipV2PlansPublicFilterEnumPublicFilter {
  /** Returns only hidden plans. */
  Hidden = 'HIDDEN',
  /** Returns only public plans. */
  Public = 'PUBLIC',
  /** Returns all public and hidden plans. */
  PublicAndHidden = 'PUBLIC_AND_HIDDEN'
}

export type ComWixpressMembershipV2PlansPublicPlan = {
  __typename?: 'ComWixpressMembershipV2PlansPublicPlan';
  /** Whether the buyer can start the plan at a later date. Defaults to false. */
  allowFutureStartDate?: Maybe<Scalars['Boolean']>;
  /** Whether the buyer is allowed to cancel their plan. Defaults to false. */
  buyerCanCancel?: Maybe<Scalars['Boolean']>;
  clientData?: Maybe<Scalars['JSON']>;
  /** Date plan was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Plan description. */
  description?: Maybe<Scalars['String']>;
  /**
   * ID of the form associated with the plan at checkout.
   *
   * Learn more about [forms](https://support.wix.com/en/article/wix-forms-an-overview).
   */
  form?: Maybe<WixFormsV4Form>;
  /**
   * ID of the form associated with the plan at checkout.
   *
   * Learn more about [forms](https://support.wix.com/en/article/wix-forms-an-overview).
   */
  formId?: Maybe<Scalars['String']>;
  /** Plan ID. */
  id?: Maybe<Scalars['String']>;
  /** Number of times the same buyer can purchase the plan. An empty value or a value of zero means no limitation. */
  maxPurchasesPerBuyer?: Maybe<Scalars['Int']>;
  /** Plan name. */
  name?: Maybe<Scalars['String']>;
  /** What is included with this plan (e.g., 1 weekly entrance to a specific class). */
  perks?: Maybe<ComWixpressMembershipV2StringList>;
  /** Plan price, payment schedule, and expiration. */
  pricing?: Maybe<ComWixpressMembershipV2Pricing>;
  /** Whether the plan is marked as primary. */
  primary?: Maybe<Scalars['Boolean']>;
  /** URL-friendly version of plan name. Unique across all plans in the same site. */
  slug?: Maybe<Scalars['String']>;
  /** Any terms and conditions that apply to the plan. This information will be displayed during checkout. */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Date plan was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type ComWixpressMembershipV2PlansQueryPublicPlansRequestInput = {
  query?: InputMaybe<ComWixpressMembershipV2CommonQueryV2Input>;
};

export type ComWixpressMembershipV2PlansQueryPublicPlansResponse = {
  __typename?: 'ComWixpressMembershipV2PlansQueryPublicPlansResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressMembershipV2PlansPlan>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressMembershipV2PlansSetPlanVisibilityRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressMembershipV2PlansSetPlanVisibilityResponse = {
  __typename?: 'ComWixpressMembershipV2PlansSetPlanVisibilityResponse';
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export type ComWixpressMembershipV2PlansUpdatePlanRequestInput = {
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  plan?: InputMaybe<ComWixpressMembershipV2PlansPlanInput>;
};

export type ComWixpressMembershipV2PlansUpdatePlanResponse = {
  __typename?: 'ComWixpressMembershipV2PlansUpdatePlanResponse';
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export type ComWixpressMembershipV2Pricing = {
  __typename?: 'ComWixpressMembershipV2Pricing';
  /** Additional fees that would apply to the order. One of which could be a setup fee. */
  feeConfigs?: Maybe<Array<Maybe<ComWixpressMembershipV2FeeConfig>>>;
  /** Free trial period for the plan in days. It’s available only for recurring plans. Set to 0 to remove free trial. */
  freeTrialDays?: Maybe<Scalars['Int']>;
  /** Amount for a single payment (or the whole subscription if it's not a recurring plan) */
  price?: Maybe<ComWixpressMembershipV2CommonMoney>;
  /** One time payment, plan is valid for the specified duration. */
  singlePaymentForDuration?: Maybe<ComWixpressMembershipV2Duration>;
  /** One time payment, plan is valid until it is canceled. */
  singlePaymentUnlimited?: Maybe<Scalars['Boolean']>;
  /** Plan has recurring payments. */
  subscription?: Maybe<ComWixpressMembershipV2Recurrence>;
};

export type ComWixpressMembershipV2PricingInput = {
  /** Additional fees that would apply to the order. One of which could be a setup fee. */
  feeConfigs?: InputMaybe<Array<InputMaybe<ComWixpressMembershipV2FeeConfigInput>>>;
  /** Free trial period for the plan in days. It’s available only for recurring plans. Set to 0 to remove free trial. */
  freeTrialDays?: InputMaybe<Scalars['Int']>;
  /** Amount for a single payment (or the whole subscription if it's not a recurring plan) */
  price?: InputMaybe<ComWixpressMembershipV2CommonMoneyInput>;
  /** One time payment, plan is valid for the specified duration. */
  singlePaymentForDuration?: InputMaybe<ComWixpressMembershipV2DurationInput>;
  /** One time payment, plan is valid until it is canceled. */
  singlePaymentUnlimited?: InputMaybe<Scalars['Boolean']>;
  /** Plan has recurring payments. */
  subscription?: InputMaybe<ComWixpressMembershipV2RecurrenceInput>;
};

export type ComWixpressMembershipV2Recurrence = {
  __typename?: 'ComWixpressMembershipV2Recurrence';
  /**
   * Amount of payment cycles this subscription is valid for.
   *
   * `0` for unlimited or until-canceled.
   */
  cycleCount?: Maybe<Scalars['Int']>;
  /** Length of one payment cycle. */
  cycleDuration?: Maybe<ComWixpressMembershipV2Duration>;
};

export type ComWixpressMembershipV2RecurrenceInput = {
  /**
   * Amount of payment cycles this subscription is valid for.
   *
   * `0` for unlimited or until-canceled.
   */
  cycleCount?: InputMaybe<Scalars['Int']>;
  /** Length of one payment cycle. */
  cycleDuration?: InputMaybe<ComWixpressMembershipV2DurationInput>;
};

export type ComWixpressMembershipV2StringList = {
  __typename?: 'ComWixpressMembershipV2StringList';
  /** List of strings */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressMembershipV2StringListInput = {
  /** List of strings */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMetasiteApiV1App = {
  __typename?: 'ComWixpressMetasiteApiV1App';
  /**
   * Identifier of application type (application definition id).
   *
   * Can be both UUID and non-UUID, for example: SiteMembers, Onboarding, CloudSiteExtension etc.
   */
  appDefId?: Maybe<Scalars['String']>;
  /**
   * Identifier of the instance (concrete application, installed on a site).
   *
   * Mostly UUID, but for some specific legacy cases might be something else.
   */
  instanceId?: Maybe<Scalars['String']>;
  /**
   * Identifier of the originating application. For example, if this app was part of a template,
   * then an app will get instance_id of that app as origin instance id.
   *
   * If application was provisioned not from some template, it should be empty.
   *
   * Note, it could be == to instance_id (for old sites).
   */
  originInstanceId?: Maybe<Scalars['String']>;
  /** State of this app (see docs for state). */
  state?: Maybe<ComWixpressMetasiteApiV1AppState>;
};

export enum ComWixpressMetasiteApiV1AppState {
  /** App is removed from a site (but we preserve it just in case). */
  Disabled = 'DISABLED',
  /** App is installed on a site. */
  Enabled = 'ENABLED',
  /** App is not installed, there is a user intention for it only (user will see the pimpl in the editor). */
  Pending = 'PENDING',
  /** App is in "demo" mode, meaning that it's in read-only mode (it's in a template OR not installed yet). */
  Template = 'TEMPLATE',
  Unknown = 'UNKNOWN'
}

export type ComWixpressMetasiteApiV1HtmlApplication = {
  __typename?: 'ComWixpressMetasiteApiV1HtmlApplication';
  /** Indicates whether this site is managed by EditorX. */
  editorX?: Maybe<Scalars['Boolean']>;
  /** Identifier of the instance. */
  instanceId?: Maybe<Scalars['String']>;
  /** Legacy, don't use it if you can. */
  intId?: Maybe<Scalars['Int']>;
  /** Language of this site. */
  languageCode?: Maybe<Scalars['String']>;
  /** Indicates that site is managed by Odeditor */
  odeditor?: Maybe<Scalars['Boolean']>;
  /** Indicates that site is managed by Picasso */
  picasso?: Maybe<Scalars['Boolean']>;
  seoData?: Maybe<ComWixpressMetasiteEventApiSeoData>;
  /** Indicates whether this site is managed by Wix Studio. */
  studio?: Maybe<Scalars['Boolean']>;
  /** File name for thumbnail. */
  thumbnail?: Maybe<Scalars['String']>;
};

export type ComWixpressMetasiteApiV1MetaSite = {
  __typename?: 'ComWixpressMetasiteApiV1MetaSite';
  /** Date and time when the account that owns this meta site was created. */
  accountCreatedDate?: Maybe<Scalars['String']>;
  /**
   * Indicates whether this site is managed by ADI editor
   *
   * Values:
   * None - not managed.
   * Some(false) - site was created via ADI editor, but later on user switched to regular editor.
   * Some(true) - site was created and still is managed by ADI editor.
   *
   * In old MetaSiteDTO: embeddedService[embeddedServiceType=Onboarding].attributes.isInUse.
   */
  adi?: Maybe<Scalars['Boolean']>;
  /**
   * All "applications" of this meta site.
   *
   * In old MetaSiteDTO -- embeddedServices.
   */
  apps?: Maybe<Array<Maybe<ComWixpressMetasiteApiV1App>>>;
  /** Indicates meta site blocked from publishing and added additional filtering in listing API (MSS). READ_ONLY. */
  blocked?: Maybe<Scalars['Boolean']>;
  /** Indicates the site is used as critical asset and as such is protected. You would be only able to provision applications to this meta site. READ_ONLY. */
  criticalAsset?: Maybe<Scalars['Boolean']>;
  /** Date and time when meta site was created. */
  dateCreated?: Maybe<Scalars['String']>;
  /** Date and time when meta site was updated for the last time. */
  dateUpdated?: Maybe<Scalars['String']>;
  defaultSeoData?: Maybe<ComWixpressMetasiteEventApiSeoData>;
  /**
   * If true - default meta site routing (connected domains, free url, ML) is not used for this meta site.
   *
   * Meaning, that if `example.org` is connected to this meta site, `router-server` will return 404 for `example.org`
   * anyway.
   *
   * This flag is set for some sites that have custom mapping in Routes API / wix-pages-bo.
   */
  dontUseDefaultRouting?: Maybe<Scalars['Boolean']>;
  externalUriMappings?: Maybe<Array<Maybe<ComWixpressMetasiteEventApiExternalUriMapping>>>;
  /**
   * Information about HTML application.
   *
   * In old MetaSiteDTO -- appplications.find(_.applicationType == HtmlWeb).
   */
  htmlApp?: Maybe<ComWixpressMetasiteApiV1HtmlApplication>;
  /** Identifier of meta site. */
  metaSiteId?: Maybe<Scalars['String']>;
  /**
   * The name of meta site.
   *
   * Matches this regular expression: [a-z0-9_\-]{4,20} (but for some legacy sites might be shorted/longer).
   */
  name?: Maybe<Scalars['String']>;
  /** Namespace of meta site. */
  namespace?: Maybe<ComWixpressMetasiteEventApiMetaSiteNamespace>;
  /**
   * Identifier of a template (meta site) from which this site was created.
   *
   * If it's empty it either means that site wasn't created from a template OR it's very old, so we didn't store
   * it back then.
   *
   * For example, if "site" was created from "template", then "template"'s id will be in origin_template_id.
   * When "site" is cloned, clone will also have "template"'s id in origin_instance_id.
   */
  originTemplateId?: Maybe<Scalars['String']>;
  /** Identifier of account that owns this meta site. */
  ownerId?: Maybe<Scalars['String']>;
  /** Indicates whether meta site was published. If true - site should be accessible for viewing. */
  published?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether this meta site is template.
   *
   * In old MetaSiteDTO: documentType == Template.
   */
  template?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether https should be used for viewing a site.
   *
   * In old MetaSiteDTO -- flags.UseHttps.
   */
  useHttps?: Maybe<Scalars['Boolean']>;
  /**
   * Internal version of meta site. Monotonically increasing number.
   *
   * If passed within update request, it will be used for optimistic locking. In this case,
   * StaleStateException will be thrown if current version doesn't match.
   *
   * In old MetaSiteDTO -- revision.
   */
  version?: Maybe<Scalars['Long']>;
};

export type ComWixpressMetasiteEventApiAssetInput = {
  /** An application definition id (app_id in dev-center). For legacy reasons may be UUID or a string (from Java Enum). */
  appDefId?: InputMaybe<Scalars['String']>;
  /** An instance id. For legacy reasons may be UUID or a string. */
  instanceId?: InputMaybe<Scalars['String']>;
  /** An application state. */
  state?: InputMaybe<ComWixpressMetasiteEventApiAssetState>;
};

export enum ComWixpressMetasiteEventApiAssetState {
  Demo = 'DEMO',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export enum ComWixpressMetasiteEventApiDeleteContextDeleteStatus {
  Deleted = 'DELETED',
  PendingPurge = 'PENDING_PURGE',
  PurgedExternally = 'PURGED_EXTERNALLY',
  Trash = 'TRASH',
  Unknown = 'UNKNOWN'
}

export type ComWixpressMetasiteEventApiDeleteContextInput = {
  /** When the meta site was deleted. */
  dateDeleted?: InputMaybe<Scalars['String']>;
  /** A reason (flow). */
  deleteOrigin?: InputMaybe<Scalars['String']>;
  /** A status. */
  deleteStatus?: InputMaybe<ComWixpressMetasiteEventApiDeleteContextDeleteStatus>;
  /** A service that deleted it. */
  initiatorId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiExternalUriMapping = {
  __typename?: 'ComWixpressMetasiteEventApiExternalUriMapping';
  /** Deprecated. */
  fromExternalUri?: Maybe<Scalars['String']>;
  /** Deprecated. */
  oldToWixUri?: Maybe<Scalars['String']>;
  /** Deprecated. */
  requireDomain?: Maybe<Scalars['Boolean']>;
  /** Deprecated. */
  toWixUri?: Maybe<Scalars['String']>;
};

export enum ComWixpressMetasiteEventApiMetaSiteNamespace {
  /**
   * Namespace for master site that will exist in parent account that will be referenced by subaccounts
   * The site will be used for account level CSM feature for enterprise
   */
  AccountMasterCms = 'ACCOUNT_MASTER_CMS',
  /** MetaSites created by the Albums product, they appear as part of the Albums app. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  Albums = 'ALBUMS',
  /** Bookings business flow with no site. */
  Anywhere = 'ANYWHERE',
  /**
   * As part of the branded app new funnel, users now can create a meta site that will be branded app first.
   * There's a blank site behind the scene but it's blank).
   * The Mobile company will be the owner of this namespace.
   */
  BrandedFirst = 'BRANDED_FIRST',
  /** Clubs siteless MetaSites, a club without a wix website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  Clubs = 'CLUBS',
  /** Codux Headless Sites */
  Codux = 'CODUX',
  /** Belongs to "strategic products" company. Supports new product in the creator's economy space. */
  CreatorEconomy = 'CREATOR_ECONOMY',
  /** It is to be used in the Business First efforts. */
  DashboardFirst = 'DASHBOARD_FIRST',
  /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
  DevCenterCompany = 'DEV_CENTER_COMPANY',
  /** AppBuilder for AppStudio / shmite (c). MetaSites with this namespace will *not* be shown in a user's site list by default. */
  DevSite = 'DEV_SITE',
  /** Namespace for Headless Backoffice with no editor */
  Headless = 'HEADLESS',
  /** Hotels standalone (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
  Hotels = 'HOTELS',
  /**
   * A draft created by HTML editor on open. Upon "first save" it will be moved to be of WIX domain.
   *
   * Meta site with this namespace will *not* be shown in a user's site list by default.
   */
  HtmlDraft = 'HTML_DRAFT',
  /** LogoMaker websites offered to the user after logo purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  Logos = 'LOGOS',
  /** Bobb - AI Design Creator. */
  MediaDesignCreator = 'MEDIA_DESIGN_CREATOR',
  /** MIMIR - Siteless account for MIMIR Ai Job runner. */
  Mimir = 'MIMIR',
  /** Nownia.com Siteless account management for Ai Scheduling Assistant. */
  Nownia = 'NOWNIA',
  /** A partially created ADI website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  OnboardingDraft = 'ONBOARDING_DRAFT',
  /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
  PartnerDashboard = 'PARTNER_DASHBOARD',
  /** Rise.ai Siteless account management for Gift Cards and Store Credit. */
  Rise = 'RISE',
  /**
   * Shared Blog Site is a unique single site across Enterprise account,
   * This site will hold all Blog posts related to the Marketing product.
   */
  SharedBlogEnterprise = 'SHARED_BLOG_ENTERPRISE',
  /** ShoutOut stand alone product. These are siteless (no actual Wix site, no HtmlWeb). MetaSites with this namespace will *not* be shown in a user's site list by default. */
  ShoutOut = 'SHOUT_OUT',
  /**
   * the user-journey for Fitness users who want to start from managing their business instead of designing their website.
   * Will be accessible from Site List and will not have a website app.
   * Once the user attaches a site, the site will become a regular wixsite.
   */
  SitelessBusiness = 'SITELESS_BUSINESS',
  /** Standalone events (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
  StandaloneEvents = 'STANDALONE_EVENTS',
  /** Standalone forms (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
  StandaloneForms = 'STANDALONE_FORMS',
  /**
   * UGC Templates are templates that are created by users for personal use and to sale to other users.
   * The Partners company owns this namespace.
   */
  UgcTemplate = 'UGC_TEMPLATE',
  UnknownNamespace = 'UNKNOWN_NAMESPACE',
  /** VideoMaker websites offered to the user after video purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  VideoMaker = 'VIDEO_MAKER',
  /** Default namespace for UGC sites. MetaSites with this namespace will be shown in a user's site list by default. */
  Wix = 'WIX',
  /** Part of the WixStores migration flow, a user tries to migrate and gets this site to view and if the user likes it then stores removes this namespace and deletes the old site with the old stores. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  WixStoresTestDrive = 'WIX_STORES_TEST_DRIVE'
}

export type ComWixpressMetasiteEventApiMetaSiteSpecialEventInput = {
  /**
   * TODO(meta-site): Change validation once validations are disabled for consumers
   * More context: https://wix.slack.com/archives/C0UHEBPFT/p1720957844413149 and https://wix.slack.com/archives/CFWKX325T/p1728892152855659
   */
  assets?: InputMaybe<Array<InputMaybe<ComWixpressMetasiteEventApiAssetInput>>>;
  /** Emitted when meta site was permanently deleted. */
  hardDeleted?: InputMaybe<ComWixpressMetasiteEventApiSiteHardDeletedInput>;
  /** A meta site id. */
  metaSiteId?: InputMaybe<Scalars['String']>;
  /** Emitted on a namespace change. */
  namespaceChanged?: InputMaybe<ComWixpressMetasiteEventApiNamespaceChangedInput>;
  /** Emitted when Odeditor is attached. */
  odeditorAssigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when Odeditor is detached. */
  odeditorUnassigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when Picasso is attached. */
  picassoAssigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when Picasso is detached. */
  picassoUnassigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when an application is provisioned (installed). */
  serviceProvisioned?: InputMaybe<ComWixpressMetasiteEventApiServiceProvisionedInput>;
  /** Emitted when an application is removed (uninstalled). */
  serviceRemoved?: InputMaybe<ComWixpressMetasiteEventApiServiceRemovedInput>;
  /** Emitted on a meta site creation. */
  siteCreated?: InputMaybe<ComWixpressMetasiteEventApiSiteCreatedInput>;
  /** Emitted on a meta site deletion. */
  siteDeleted?: InputMaybe<ComWixpressMetasiteEventApiSiteDeletedInput>;
  /** Emitted when meta site is marked as template. */
  siteMarkedAsTemplate?: InputMaybe<Scalars['Void']>;
  /** Emitted when meta site is marked as a WixSite. */
  siteMarkedAsWixSite?: InputMaybe<Scalars['Void']>;
  /** Emitted on the first* publish of the meta site (* switching from unpublished to published state). */
  sitePublished?: InputMaybe<Scalars['Void']>;
  /** Site is marked as PurgedExternally */
  sitePurgedExternally?: InputMaybe<ComWixpressMetasiteEventApiSitePurgedExternallyInput>;
  /** Emitted when meta site name (URL slug) is changed. */
  siteRenamedPayload?: InputMaybe<ComWixpressMetasiteEventApiSiteRenamedInput>;
  /** Emitted on a meta site transfer completion. */
  siteTransferred?: InputMaybe<ComWixpressMetasiteEventApiSiteTransferredInput>;
  /** Emitted on a meta site restoration. */
  siteUndeleted?: InputMaybe<Scalars['Void']>;
  /** Emitted on a meta site unpublish. */
  siteUnpublished?: InputMaybe<ComWixpressMetasiteEventApiSiteUnpublishedInput>;
  /** Emitted when Studio is attached. */
  studioAssigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when Studio is detached. */
  studioUnassigned?: InputMaybe<Scalars['Void']>;
  /** A timestamp of the event. */
  timestamp?: InputMaybe<Scalars['Long']>;
  /**
   * Emitted when one of the URLs is changed. After this event you may call `urls-server` to fetch
   * the actual URL.
   *
   * See: https://wix.slack.com/archives/C0UHEBPFT/p1732520791210559?thread_ts=1732027914.294059&cid=C0UHEBPFT
   * See: https://wix.slack.com/archives/C0UHEBPFT/p1744115197619459
   */
  urlChanged?: InputMaybe<Scalars['Void']>;
  /** A meta site version. Monotonically increasing. */
  version?: InputMaybe<Scalars['Long']>;
};

export type ComWixpressMetasiteEventApiMetaTag = {
  __typename?: 'ComWixpressMetasiteEventApiMetaTag';
  /** A name. */
  name?: Maybe<Scalars['String']>;
  /** Indicates whether should be rendered as property. */
  property?: Maybe<Scalars['Boolean']>;
  /** A value. */
  value?: Maybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiNamespaceChangedInput = {
  /** A new namespace. */
  newNamespace?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteNamespace>;
  /** A previous namespace. */
  oldNamespace?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteNamespace>;
};

export type ComWixpressMetasiteEventApiSeoData = {
  __typename?: 'ComWixpressMetasiteEventApiSeoData';
  /** A canonical URL for a site. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** Indicates whether the site should be indexable by bots. */
  indexable?: Maybe<Scalars['Boolean']>;
  /** A list of meta tags. */
  metaTags?: Maybe<Array<Maybe<ComWixpressMetasiteEventApiMetaTag>>>;
  /** TDB. */
  ogImage?: Maybe<Scalars['String']>;
  /** TDB. */
  suppressTrackingCookies?: Maybe<Scalars['Boolean']>;
  /** A title. */
  title?: Maybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiServiceProvisionedInput = {
  /** Either UUID or EmbeddedServiceType. */
  appDefId?: InputMaybe<Scalars['String']>;
  /** Not only UUID. Something here could be something weird. */
  instanceId?: InputMaybe<Scalars['String']>;
  /** An instance id from which this instance is originated. */
  originInstanceId?: InputMaybe<Scalars['String']>;
  /** The origin meta site id */
  originMetaSiteId?: InputMaybe<Scalars['String']>;
  /** A version. */
  version?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiServiceRemovedInput = {
  /** Either UUID or EmbeddedServiceType. */
  appDefId?: InputMaybe<Scalars['String']>;
  /** Not only UUID. Something here could be something weird. */
  instanceId?: InputMaybe<Scalars['String']>;
  /** A version. */
  version?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressMetasiteEventApiSiteCreatedContext {
  /** A copy of existing meta site. */
  Duplicate = 'DUPLICATE',
  /** A meta site was created by copying of the transfferred meta site. */
  DuplicateBySiteTransfer = 'DUPLICATE_BY_SITE_TRANSFER',
  /** deprecated A meta site was created for Flash editor. */
  Flash = 'FLASH',
  /** A meta site was created from template. */
  FromTemplate = 'FROM_TEMPLATE',
  /** A meta site was created as a transfferred site (copy of the original), old flow, should die soon. */
  OldSiteTransfer = 'OLD_SITE_TRANSFER',
  /** A valid option, we don't expose all reasons why site might be created. */
  Other = 'OTHER'
}

export type ComWixpressMetasiteEventApiSiteCreatedInput = {
  /** A context in which meta site was created. */
  context?: InputMaybe<ComWixpressMetasiteEventApiSiteCreatedContext>;
  /** A namespace. */
  namespace?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteNamespace>;
  /**
   * A meta site id from which this site was created.
   *
   * In case of a creation from a template it's a template id.
   * In case of a site duplication ("Save As" in dashboard or duplicate in UM) it's an id of a source site.
   */
  originMetaSiteId?: InputMaybe<Scalars['String']>;
  /** A template identifier (empty if not created from a template). */
  originTemplateId?: InputMaybe<Scalars['String']>;
  /** An account id of the owner. */
  ownerId?: InputMaybe<Scalars['String']>;
  /** A meta site name (URL slug). */
  siteName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiSiteDeletedInput = {
  /** A deletion context. */
  deleteContext?: InputMaybe<ComWixpressMetasiteEventApiDeleteContextInput>;
};

export type ComWixpressMetasiteEventApiSiteHardDeletedInput = {
  /** A deletion context. */
  deleteContext?: InputMaybe<ComWixpressMetasiteEventApiDeleteContextInput>;
};

export type ComWixpressMetasiteEventApiSitePurgedExternallyInput = {
  appDefId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMetasiteEventApiSiteRenamedInput = {
  /** A new meta site name (URL slug). */
  newSiteName?: InputMaybe<Scalars['String']>;
  /** A previous meta site name (URL slug). */
  oldSiteName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiSiteTransferredInput = {
  /** A new owner id (user that accepts meta site). */
  newOwnerId?: InputMaybe<Scalars['String']>;
  /** A previous owner id (user that transfers meta site). */
  oldOwnerId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiSiteUnpublishedInput = {
  /** A list of URLs previously associated with the meta site. */
  urls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput = {
  /** Pointer to the next or previous page in the list of results. */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of items to return.
   *
   *
   * Default:`50`
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Number of items to skip in the current sort order.
   *
   *
   * Default: `0`
   */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsRequestInput = {
  /**
   * List of tag fields to be included if entities are present in the response.
   * Base fieldset, which is default, will return all core tag properties.
   * Example: When URL fieldset is selected, returned tag will have a set of base properties and tag url.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Whether to return the full created tag entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
  /** Tags to create. */
  tags?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagInput>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Tags created by bulk action. */
  results?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogBulkTagResult>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogBulkDeleteTagRequestInput = {
  /** Should delete bypassing the trash-bin. */
  permanent?: InputMaybe<Scalars['Boolean']>;
  /** Tag IDs. */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogBulkTagResult = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogBulkTagResult';
  /** Optional created tag. */
  item?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
  /** Bulk actions metadata for tag. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogCoverMedia = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogCoverMedia';
  /** Media alternative text. */
  altText?: Maybe<Scalars['String']>;
  /** Whether cover media is custom. If `false` the cover image is set to the first media item that appears in the content. */
  custom?: Maybe<Scalars['Boolean']>;
  /** Whether cover media is displayed. */
  displayed?: Maybe<Scalars['Boolean']>;
  /**
   * Is cover media enabled.
   * Selected by user whether to display cover media on the feed
   * @deprecated Is cover media enabled.
   * Selected by user whether to display cover media on the feed. Replaced by: displayed. Removal date: 2024-06-30.
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Image url. */
  image?: Maybe<WixCommonImage>;
  /** Video url. */
  video?: Maybe<WixCommonVideo>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogCreateTagRequestInput = {
  /**
   * List of additional tag fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the tag's base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the tag's base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Tag label. The label for each tag in a blog must be unique. */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Tag language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** SEO data. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Preferred tag slug. For example, `'tag-slug'`. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogCreateTagResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogCreateTagResponse';
  /** Created tag. */
  tag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogDeleteTagRequestInput = {
  /** Tag ID. */
  tagId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogEmbedMedia = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogEmbedMedia';
  /** Thumbnail details. */
  thumbnail?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogEmbedThumbnail>;
  /** Video details. */
  video?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogEmbedVideo>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogEmbedThumbnail = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogEmbedThumbnail';
  /** Thumbnail height. */
  height?: Maybe<Scalars['Int']>;
  /** Thumbnail url. */
  url?: Maybe<Scalars['String']>;
  /** Thumbnail width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogEmbedVideo = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogEmbedVideo';
  /** Video height. */
  height?: Maybe<Scalars['Int']>;
  /** Video url. */
  url?: Maybe<Scalars['String']>;
  /** Video width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagRequestInput = {
  /**
   * List of tag fields to be included if entities are present in the response.
   * Base fieldset, which is default, will return all core tag properties.
   * Example: When URL fieldset is selected, returned tag will have a set of base properties and tag url.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Tag name. Unique per blog. */
  label?: InputMaybe<Scalars['String']>;
  /** Tag language. */
  language?: InputMaybe<Scalars['String']>;
  /** SEO data. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagResponse';
  /** Tag info. */
  tag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelRequestInput = {
  /**
   * List of additional tag fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the tag's base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the tag's base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Tag label. */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Tag language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If omitted, tags in all languages are returned.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelResponse';
  /** Retrieved tag. */
  tag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugRequestInput = {
  /**
   * List of additional tag fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the tag's base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the tag's base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /**
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Language of the tag to retrieve.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Slug of the tag to retrieve. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugResponse';
  /** Retrieved tag. */
  tag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagRequestInput = {
  /**
   * List of additional tag fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the tag's base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the tag's base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  id: Scalars['ID'];
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagsCountByLanguageResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogGetTagsCountByLanguageResponse';
  /** The language and it's count. */
  tagsLanguageCount?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTagLanguageCount>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsRequestInput = {
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to receive the total amount of posts in that specified language.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsResponse';
  /** Total amount of published posts. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsRequestInput = {
  /** Language filter */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsResponse';
  /** Total amount of publications. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogListTagsRequestInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `sort`. */
  cursorPaging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamTagCursorPagingInput>;
  /**
   * List of tag fields to be included if entities are present in the response.
   * Base fieldset, which is default, will return all core tag properties.
   * Example: When URL fieldset is selected, returned tag will have a set of base properties and tag url.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamTagPagingInput>;
  /** Sorting options. For a list of sortable fields, see [Field Support for Filtering and Sorting](https://dev.wix.com/api/rest/community/blog/filter-and-sort). */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogListTagsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogListTagsResponse';
  /** Details on the paged set of results returned. */
  metaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
  /** List of tags. */
  tags?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogMedia = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogMedia';
  /** Media alternative text. */
  altText?: Maybe<Scalars['String']>;
  /** Whether custom cover media has been specified. If `false`, the first media item in the post's content serves as cover media. */
  custom?: Maybe<Scalars['Boolean']>;
  /** Whether cover media is displayed. */
  displayed?: Maybe<Scalars['Boolean']>;
  /** Embed media details. */
  embedMedia?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogEmbedMedia>;
  /** Wix Media details. */
  wixMedia?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogWixMedia>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogMetaData = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogMetaData';
  /** Number of items returned in this response. */
  count?: Maybe<Scalars['Int']>;
  /** Pointer to the next or previous page in the list of results. */
  cursor?: Maybe<Scalars['String']>;
  /** Requested offset. */
  offset?: Maybe<Scalars['Int']>;
  /** Total number of items that match the query. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogPeriodPostCount = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogPeriodPostCount';
  /** Start of time range in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) date and time format. */
  periodStart?: Maybe<Scalars['String']>;
  /** Number of posts published during this month. */
  postCount?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogPeriodPublicationsCount = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogPeriodPublicationsCount';
  /** Start of time range in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) date and time format. */
  periodStart?: Maybe<Scalars['String']>;
  /** Number of posts published during this month. */
  publicationsCount?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsRequestInput = {
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to only receive the period post count for that specified language.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Number of months to include in response. */
  months?: InputMaybe<Scalars['Int']>;
  /**
   * Order of returned results.
   *
   * - `OLDEST`: posts by date in ascending order.
   * - `NEWEST`: posts by date in descending order.
   *
   * Default: `OLDEST`
   */
  order?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsRequestOrder>;
  /** Start of time range to return, in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) date and time format. */
  rangeStart?: InputMaybe<Scalars['String']>;
  /**
   * Time zone to use when calculating the start of the month.
   *
   * [UTC timezone offset](https://en.wikipedia.org/wiki/List_of_UTC_offsets) format. For example, New York time zone is `-05`.
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsRequestOrder {
  Newest = 'NEWEST',
  Oldest = 'OLDEST',
  Unknown = 'UNKNOWN'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsResponse';
  /** List of published post counts by month. */
  stats?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogPeriodPostCount>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsRequestInput = {
  /**
   * Language filter
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Number of months to include in the response. */
  months?: InputMaybe<Scalars['Int']>;
  /** Order of the returned results. */
  order?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsRequestOrder>;
  /** Non-inclusive end of time range to return, in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) date and time format. */
  rangeEnd?: InputMaybe<Scalars['String']>;
  /** Start of time range to return, in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) date and time format. */
  rangeStart?: InputMaybe<Scalars['String']>;
  /** Timezone of the client. */
  timeZone?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsRequestOrder {
  Newest = 'NEWEST',
  Oldest = 'OLDEST',
  Unknown = 'UNKNOWN'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsResponse';
  /** Chronologically ordered list of publications. */
  stats?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogPeriodPublicationsCount>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryTagsRequestInput = {
  /**
   * List of additional tag fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the tag's base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the tag's base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Query options. */
  query?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryTagsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogQueryTagsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogTag = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogTag';
  /** Date the tag was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Tag ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Tag label.
   *
   * A blog can't have two tags with the same label.
   */
  label?: Maybe<Scalars['String']>;
  /**
   * Tag language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Number of posts with this tag. Includes unpublished draft posts. */
  postCount?: Maybe<Scalars['Int']>;
  /** Number of published posts with this tag. */
  publishedPostCount?: Maybe<Scalars['Int']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /**
   * Part of a tag's URL that refers to a specific tag.
   *
   * For example, `'https:/example.com/tags/{my-tag-slug}'`
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * ID of the tag's translations when [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-translating-your-blog) is installed on a site.
   *
   * All translations of a single tag share the same `translationId`.
   */
  translationId?: Maybe<Scalars['String']>;
  /** Date the tag was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /**
   * Tag URL.
   *
   * The `url` directs you to a page that lists every post with the specified tag.
   */
  url?: Maybe<WixCommonPageUrl>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField {
  /** Includes SEO data. */
  Seo = 'SEO',
  Unknown = 'UNKNOWN',
  /** Includes Tag URL when present. */
  Url = 'URL'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogTagInput = {
  /** Date the tag was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Tag ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Tag label.
   *
   * A blog can't have two tags with the same label.
   */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Tag language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Number of posts with this tag. Includes unpublished draft posts. */
  postCount?: InputMaybe<Scalars['Int']>;
  /** Number of published posts with this tag. */
  publishedPostCount?: InputMaybe<Scalars['Int']>;
  /** SEO data. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /**
   * Part of a tag's URL that refers to a specific tag.
   *
   * For example, `'https:/example.com/tags/{my-tag-slug}'`
   */
  slug?: InputMaybe<Scalars['String']>;
  /**
   * ID of the tag's translations when [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-translating-your-blog) is installed on a site.
   *
   * All translations of a single tag share the same `translationId`.
   */
  translationId?: InputMaybe<Scalars['String']>;
  /** Date the tag was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /**
   * Tag URL.
   *
   * The `url` directs you to a page that lists every post with the specified tag.
   */
  url?: InputMaybe<WixCommonPageUrlInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogTagLanguageCount = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogTagLanguageCount';
  /** 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format. */
  languageCode?: Maybe<Scalars['String']>;
  /** The count of tags for the language. */
  tagCount?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogUpdateTagRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * List of tag fields to be included if entities are present in the response.
   * Base fieldset, which is default, will return all core tag properties.
   * Example: When URL fieldset is selected, returned tag will have a set of base properties and tag url.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Tag info to update. */
  tag?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogUpdateTagResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogUpdateTagResponse';
  /** Updated tag. */
  tag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult';
  /** Optional created category. */
  item?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
  /** Bulk actions metadata for category. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesRequestInput = {
  /** Categories to create. */
  categories?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput>>>;
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  /** Whether to return the full created category entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Categories created by bulk action. */
  results?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkDeleteCategoryRequestInput = {
  /** Category IDs. */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Should delete bypassing the trash-bin. */
  permanent?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsRequestInput = {
  /** Post IDs. */
  postIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsResponse';
  /** Map of post.id to metrics */
  metrics?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Metrics>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsRequestInput = {
  /** Post IDs. */
  postIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsResponse';
  /** Map of post.id to reactions */
  reactionsMap?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Reactions>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesRequestInput = {
  /** Categories to update. */
  categories?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3MaskedCategoryInput>>>;
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  /** Whether to return the full created category entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Categories updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3Category = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3Category';
  /** Category cover image. */
  coverImage?: Maybe<WixCommonImage>;
  /** Category description. */
  description?: Maybe<Scalars['String']>;
  /**
   * Position of the category in the [Category Menu](https://support.wix.com/en/article/wix-blog-adding-and-customizing-a-category-menu).
   * Categories are displayed in ascending order. Categories with a position of `-1` appear at the end of the sequence.
   *
   * Default: `-1`
   */
  displayPosition?: Maybe<Scalars['Int']>;
  /** Category ID. */
  id?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  internalId?: Maybe<Scalars['String']>;
  /** Category label. Displayed in the Category Menu. */
  label?: Maybe<Scalars['String']>;
  /**
   * Category language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Number of posts in the category. */
  postCount?: Maybe<Scalars['Int']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Part of a category's URL that refers to a specific category. For example, the slug of `https:/example.com/blog/category/famous-cats` is `famous-cats`. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Category title.
   * @deprecated Category title. Removal date: 2025-07-16.
   */
  title?: Maybe<Scalars['String']>;
  /** ID of the category's translations. All translations of a single category share the same `translationId`. */
  translationId?: Maybe<Scalars['String']>;
  /** Category translations. */
  translations?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslation>>>;
  /** Date and time the Category was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** The `url` of the page that lists every post with the specified category. */
  url?: Maybe<WixCommonPageUrl>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField {
  /**
   * Includes internal id field.
   * Reserved for internal use
   */
  InternalId = 'INTERNAL_ID',
  /** Includes SEO data. */
  Seo = 'SEO',
  /** Includes translations. */
  Translations = 'TRANSLATIONS',
  Unknown = 'UNKNOWN',
  /** Includes category URL. */
  Url = 'URL'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput = {
  /** Category cover image. */
  coverImage?: InputMaybe<WixCommonImageInput>;
  /** Category description. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Position of the category in the [Category Menu](https://support.wix.com/en/article/wix-blog-adding-and-customizing-a-category-menu).
   * Categories are displayed in ascending order. Categories with a position of `-1` appear at the end of the sequence.
   *
   * Default: `-1`
   */
  displayPosition?: InputMaybe<Scalars['Int']>;
  /** Category ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Reserved for internal use. */
  internalId?: InputMaybe<Scalars['String']>;
  /** Category label. Displayed in the Category Menu. */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Category language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Number of posts in the category. */
  postCount?: InputMaybe<Scalars['Int']>;
  /** SEO data. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Part of a category's URL that refers to a specific category. For example, the slug of `https:/example.com/blog/category/famous-cats` is `famous-cats`. */
  slug?: InputMaybe<Scalars['String']>;
  /** ID of the category's translations. All translations of a single category share the same `translationId`. */
  translationId?: InputMaybe<Scalars['String']>;
  /** Category translations. */
  translations?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslationInput>>>;
  /** Date and time the Category was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** The `url` of the page that lists every post with the specified category. */
  url?: InputMaybe<WixCommonPageUrlInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryLanguageCount = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryLanguageCount';
  /** The count of Categories for the language. */
  categoryCount?: Maybe<Scalars['Int']>;
  /** 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format. */
  languageCode?: Maybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslation = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslation';
  /** Category ID. */
  id?: Maybe<Scalars['String']>;
  /** Label displayed in the categories menu on the site. */
  label?: Maybe<Scalars['String']>;
  /** Language of the category. */
  language?: Maybe<Scalars['String']>;
  /** URL of this category page. */
  url?: Maybe<WixCommonPageUrl>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslationInput = {
  /** Category ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Label displayed in the categories menu on the site. */
  label?: InputMaybe<Scalars['String']>;
  /** Language of the category. */
  language?: InputMaybe<Scalars['String']>;
  /** URL of this category page. */
  url?: InputMaybe<WixCommonPageUrlInput>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3ChangeOriginOrigin {
  /** Categories were changed */
  AddCategories = 'ADD_CATEGORIES',
  /** Changed by admin */
  Admin = 'ADMIN',
  /** Saved automatically by AI tool. */
  AiAutoSave = 'AI_AUTO_SAVE',
  /** Was approved in moderation */
  ApproveInModeration = 'APPROVE_IN_MODERATION',
  /** Saved automatically */
  AutoSave = 'AUTO_SAVE',
  /** Copied from template */
  CopyTemplate = 'COPY_TEMPLATE',
  /** Tag was deleted */
  DeleteTag = 'DELETE_TAG',
  /** Imported */
  Import = 'IMPORT',
  /** Imported in bulk */
  ImportBulk = 'IMPORT_BULK',
  /** Imported with html import */
  ImportHtml = 'IMPORT_HTML',
  /** Patch import */
  ImportPatch = 'IMPORT_PATCH',
  /** Changed language */
  LanguageChange = 'LANGUAGE_CHANGE',
  /** Saved manually */
  ManualSave = 'MANUAL_SAVE',
  /** Affected by migration */
  Migration = 'MIGRATION',
  /** Affected by moderation */
  Moderation = 'MODERATION',
  /** Moved to trash */
  MoveToTrash = 'MOVE_TO_TRASH',
  /** New edit session started which updated editing_session_id id */
  NewEditSession = 'NEW_EDIT_SESSION',
  /** Post was pinned */
  Pin = 'PIN',
  /** Pricing plans were changed */
  PricingPlansChange = 'PRICING_PLANS_CHANGE',
  /** Was provisioned */
  Provision = 'PROVISION',
  /** Was published */
  Publish = 'PUBLISH',
  /** Owner was reassigned */
  ReassignOwner = 'REASSIGN_OWNER',
  /** Was reblogged */
  Reblog = 'REBLOG',
  /** Was rejected from moderation */
  RejectFromModeration = 'REJECT_FROM_MODERATION',
  /** Was removed from moderation */
  RemoveFromModeration = 'REMOVE_FROM_MODERATION',
  /** Was restored */
  Restore = 'RESTORE',
  /** Reverted to draft */
  RevertToDraft = 'REVERT_TO_DRAFT',
  /** Was scheduled */
  Schedule = 'SCHEDULE',
  /** Was published by Later */
  SchedulingServicePublish = 'SCHEDULING_SERVICE_PUBLISH',
  /** Was scheduled by Later */
  SchedulingServiceSchedule = 'SCHEDULING_SERVICE_SCHEDULE',
  /** Was unscheduled by Later */
  SchedulingServiceUnschedule = 'SCHEDULING_SERVICE_UNSCHEDULE',
  /** Was translated */
  Translation = 'TRANSLATION',
  Unknown = 'UNKNOWN',
  /** Post was unpinned */
  Unpin = 'UNPIN',
  /** Was unpublished */
  Unpublish = 'UNPUBLISH',
  /** Was unscheduled */
  Unschedule = 'UNSCHEDULE'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentRequestInput = {
  /** DraftJs content to convert to Rich content. */
  content?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentResponse';
  /** Rich content converted from DraftJs content. */
  richContent?: Maybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsRequestInput = {
  /** Rich content to convert to DraftJs content. */
  richContent?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsResponse';
  /** DraftJs content converted from Rich content. */
  content?: Maybe<Scalars['JSON']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryRequestInput = {
  /** Category info. */
  category?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput>;
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryResponse';
  /** Category info. */
  category?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateRequestInput = {
  /** Post template id */
  postTemplateId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateResponse';
  /** Created draft post */
  draftPost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPost>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3DeleteCategoryRequestInput = {
  /** Category ID. */
  categoryId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPost = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPost';
  /** Category IDs of the draft post. */
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reserved for internal use. */
  changeOrigin?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ChangeOriginOrigin>;
  /** Whether commenting on the draft post is enabled. */
  commentingEnabled?: Maybe<Scalars['Boolean']>;
  /** Reserved for internal use. */
  content?: Maybe<Scalars['JSON']>;
  /** Reserved for internal use. */
  contentId?: Maybe<Scalars['String']>;
  /**
   * __Deprecated.__ Use `media` instead.
   * This property will be removed on June 6, 2023.
   *
   * Draft post cover media.
   */
  coverMedia?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogCoverMedia>;
  /** Date the draft post was first created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Date the draft post was last edited. */
  editedDate?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  editingSessionId?: Maybe<Scalars['String']>;
  /**
   * Draft post excerpt.
   *
   * If no excerpt has been manually set, an excerpt is automatically generated from the post's text.
   * This can be retrieved using the `GENERATED_EXCERPT` fieldset.
   */
  excerpt?: Maybe<Scalars['String']>;
  /** Whether the draft post is marked as featured. */
  featured?: Maybe<Scalars['Boolean']>;
  /** Date the post was first published. */
  firstPublishedDate?: Maybe<Scalars['String']>;
  /** Indicates if there are changes made to the draft post that have not yet been published. */
  hasUnpublishedChanges?: Maybe<Scalars['Boolean']>;
  /** Hashtags in the post. */
  hashtags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Image placed at the top of the blog page. */
  heroImage?: Maybe<WixCommonImage>;
  /** Draft post ID. */
  id?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  internalId?: Maybe<Scalars['String']>;
  /**
   * Language the draft post is written in.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Post cover media. */
  media?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMedia>;
  /** Draft post owner's member ID. */
  memberId?: Maybe<Scalars['String']>;
  /** Estimated reading time of the draft post (calculated automatically). */
  minutesToRead?: Maybe<Scalars['Int']>;
  /** Details of the draft post in review. Only relevant to posts submitted by guest writers. */
  moderationDetails?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails>;
  /** Reserved for internal use. */
  mostRecentContributorId?: Maybe<Scalars['String']>;
  /** Reserved for internal use, not included in base response. */
  originPostId?: Maybe<Scalars['String']>;
  /** Reserved for internal use, not included in base response. */
  originPostInstanceId?: Maybe<Scalars['String']>;
  /** Number of paragraphs to display in a paid content preview for non-paying users. */
  previewTextParagraph?: Maybe<Scalars['Int']>;
  /** Pricing plan IDs. Only relevant if a post is assigned to a specific pricing plan. See the Pricing Plans API for more info. */
  pricingPlanIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** IDs of posts related to this draft post. */
  relatedPostIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Draft Post rich content.
   *
   * <widget src="https://apps.wix.com/_serverless/ricos-playground-services/goto/api-component" plugins="image.gallery.video.audio.divider.linkButton.html.giphy.codeBlock.file.hashtag.lineSpacing.indent.link.textColor.textHighlight.heading.verticalEmbed.table.collapsibleList.poll" exampleid="72c23a25-524f-4f70-a260-4a2777b6f5d5">
   * <a href="https://dev.wix.com/docs/ricos/api-reference/ricos-document">See Ricos document reference</a>
   * </widget>
   */
  richContent?: Maybe<WixRichContentV1RichContent>;
  /** Date the draft post is scheduled to be published. */
  scheduledPublishDate?: Maybe<Scalars['String']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** SEO slug. */
  seoSlug?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  slugs?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Status of the draft post. */
  status?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostStatusStatus>;
  /** Tag IDs the draft post is tagged with. */
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Draft post title. */
  title?: Maybe<Scalars['String']>;
  /**
   * ID of the draft post's translations.
   *
   * All translations of a single post share the same `translationId`.
   * Available only if the [Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) app is installed.
   */
  translationId?: Maybe<Scalars['String']>;
  /** List of the post's translated posts. */
  translations?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostTranslation>>>;
  /** Draft post URL preview. What the URL will look like once the post is published. */
  url?: Maybe<WixCommonPageUrl>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostStatusStatus {
  /** Status indicating the draft post is deleted. */
  Deleted = 'DELETED',
  /**
   * Deprecated. Use `IN_REVIEW` instead. Status indicating the draft post is in review.
   * Target removal date 2024-06-30
   * Reserved for internal use.
   */
  InModeration = 'IN_MODERATION',
  /** Status indicating the draft post is in review. */
  InReview = 'IN_REVIEW',
  /** Status indicating the draft post is published. */
  Published = 'PUBLISHED',
  /** Status indicating the draft post is scheduled for publication. */
  Scheduled = 'SCHEDULED',
  Unknown = 'UNKNOWN',
  /** Status indicating the draft post is unpublished. */
  Unpublished = 'UNPUBLISHED'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostTranslation = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostTranslation';
  /** Post ID. */
  id?: Maybe<Scalars['String']>;
  /** Language the post is written in. */
  language?: Maybe<Scalars['String']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Post slug. For example, 'post-slug'. */
  slug?: Maybe<Scalars['String']>;
  /** Post status. */
  status?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostStatusStatus>;
  /** Post URL. */
  url?: Maybe<WixCommonPageUrl>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoriesCountByLanguageResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoriesCountByLanguageResponse';
  /** The language and it's count. */
  categoriesLanguageCount?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryLanguageCount>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugRequestInput = {
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  /**
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Language of the category to retrieve.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Slug of the category to retrieve. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugResponse';
  /** Category info. */
  category?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryRequestInput = {
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  id: Scalars['ID'];
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Slug of the post to retrieve. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugResponse';
  /** Retrieved post info. */
  post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsRequestInput = {
  /** Post ID to retrieve metrics for. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsResponse';
  /** Retrieved post metrics. */
  metrics?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Metrics>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  id: Scalars['ID'];
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostsSort {
  /** Ordered by `firstPublishedDate` in descending order with pinned posts first. */
  Feed = 'FEED',
  /** Ordered by total number of likes in descending order. */
  LikeCount = 'LIKE_COUNT',
  /** Ordered by `firstPublishedDate` in ascending order. */
  PublishedDateAsc = 'PUBLISHED_DATE_ASC',
  /** Ordered by `firstPublishedDate` in descending order. */
  PublishedDateDesc = 'PUBLISHED_DATE_DESC',
  /** Sorting by post rating descending. */
  Rating = 'RATING',
  /** Ordered by `title` in ascening order. */
  TitleAsc = 'TITLE_ASC',
  /** Ordered by `title` in descending order. */
  TitleDesc = 'TITLE_DESC',
  /** Ordered by total number of views in descending order. */
  ViewCount = 'VIEW_COUNT'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateRequestInput = {
  /** Post template id */
  postTemplateId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateResponse';
  /** Post template */
  postTemplate?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberRequestInput = {
  /** Member ID. */
  memberId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberResponse';
  /** The total number of likes of the member. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3LikePostRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Post ID. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3LikePostResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3LikePostResponse';
  /** Post info. */
  post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesRequestInput = {
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to only receive categories that are in that language.
   * If omitted, categories in all languages are returned.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesResponse';
  /** List of categories. */
  categories?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>>>;
  /** Details on the paged set of results returned. */
  metaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsRequestInput = {
  /**
   * Category filter.
   *
   * Pass an array of category IDs to return only posts with any of the provided categories.
   * If omitted, all posts with or without associated categories are returned.
   */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Whether to return only featured posts.
   *
   * Default: `false`
   */
  featured?: InputMaybe<Scalars['Boolean']>;
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /**
   * Hashtag filter.
   *
   * Pass an array of hashtags to return only posts containing any of the provided hashtags.
   * If omitted, all posts with or without hashtags are returned.
   */
  hashtags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to only receive posts that are in that language.
   * If omitted, posts in all languages are returned.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Post owner's member ID. */
  memberId?: InputMaybe<Scalars['String']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput>;
  /**
   * Sorting options.
   *
   * - `FEED`: Ordered by `firstPublishedDate` in descending order with pinned posts first.
   * - `VIEW_COUNT`: Ordered by total number of views in descending order.
   * - `LIKE_COUNT`: Ordered by total number of likes in descending order.
   * - `PUBLISHED_DATE_ASC`: Ordered by `firstPublishedDate` in ascending order.
   * - `PUBLISHED_DATE_DESC`: Ordered by `firstPublishedDate` in descending order.
   * - `TITLE_ASC`: Ordered by `title` in ascening order.
   * - `TITLE_DESC`: Ordered by `title` in descending order.
   * - `RATING`: reserved for internal use.
   *
   * Default: `FEED`
   */
  sort?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostsSort>;
  /**
   * Tag filter.
   *
   * Pass an array of tag IDs to return only posts with any of the provided tags.
   * If omitted, all posts with or without tags are returned.
   */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsResponse';
  /** Details on the paged set of results returned. */
  metaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
  /** List of posts. */
  posts?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to only receive posts that are in that language.
   * If omitted, posts in all languages are returned.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Month */
  month?: InputMaybe<Scalars['Int']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput>;
  /** Time zone */
  timeZone?: InputMaybe<Scalars['String']>;
  /** Year */
  year?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveResponse';
  /** Details on the paged set of results returned. */
  metaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingMetadataV2>;
  /** List of posts. */
  posts?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsRequestInput = {
  /**
   * Category filter.
   *
   * Pass an array of category IDs to return only posts with any of the provided categories.
   * If omitted, all posts with or without associated categories are returned.
   */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Whether to return only featured posts.
   *
   * Default: `false`
   */
  featured?: InputMaybe<Scalars['Boolean']>;
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /**
   * Hashtag filter.
   *
   * Pass an array of hashtags to return only posts containing any of the provided hashtags.
   * If omitted, all posts with or without hashtags are returned.
   */
  hashtags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to only receive posts that are in that language.
   * If omitted, posts in all languages are returned.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Post owner's member ID. */
  memberId?: InputMaybe<Scalars['String']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput>;
  /**
   * Sorting options.
   *
   * Default: `FEED`
   */
  sort?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostsSort>;
  /**
   * Tag filter.
   *
   * Pass an array of tag IDs to return only posts with any of the provided tags.
   * If omitted, all posts with or without tags are returned.
   */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsResponse';
  /** Details on the paged set of results returned. */
  metaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
  /** List of retrieved posts. */
  posts?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>>>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesRequestGetPostTemplatesSort {
  /** Sort by ascending publishing date. */
  PublishedDateAsc = 'PUBLISHED_DATE_ASC',
  /** Sort by descending publishing date. */
  PublishedDateDesc = 'PUBLISHED_DATE_DESC'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesRequestInput = {
  /** Filter post templates by given template category ids */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter post templates by provided language */
  language?: InputMaybe<Scalars['String']>;
  /** Returns post template categories when set to TRUE */
  listTemplateCategories?: InputMaybe<Scalars['Boolean']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput>;
  /** Sort order by ascending/descending publish date. Default is ascending publish date sort */
  sort?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesRequestGetPostTemplatesSort>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesResponse';
  /** Available post templates */
  postTemplates?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>>>;
  /** Details on the paged set of posts templates returned. */
  postTemplatesMetaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
  /** Post template categories. This value is returned empty unless asked explicitly */
  templateCategories?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3MaskedCategoryInput = {
  /** Category */
  category?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput>;
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3Metrics = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3Metrics';
  /** Average rating of post from 1 to 5. */
  averageRating?: Maybe<Scalars['Float']>;
  /** Total number of post comments. */
  comments?: Maybe<Scalars['Int']>;
  /** Total number of post likes. */
  likes?: Maybe<Scalars['Int']>;
  /** Total number of post ratings. */
  totalRatings?: Maybe<Scalars['Int']>;
  /** Total number of post views. */
  views?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails';
  /** Member ID of the person who approved or rejected the post. */
  moderatedBy?: Maybe<Scalars['String']>;
  /** Date the post was approved or rejected. */
  moderationDate?: Maybe<Scalars['String']>;
  /** Status indicating whether the submission was approved or rejected by the moderator. */
  status?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationStatusStatus>;
  /** Member ID of the person submitting the draft post for review. */
  submittedBy?: Maybe<Scalars['String']>;
  /** Date the post was submitted for review. */
  submittedDate?: Maybe<Scalars['String']>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationStatusStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PinPostRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Post ID. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PinPostResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3PinPostResponse';
  /** Post info. */
  post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3Post = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3Post';
  /** [Category IDs](https://dev.wix.com/docs/rest/business-solutions/blog/category/introduction) of the post. */
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether commenting on the post is enabled. */
  commentingEnabled?: Maybe<Scalars['Boolean']>;
  /** Post owner's [contact ID](https://dev.wix.com/api/rest/contacts). */
  contactId?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  content?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  contentId?: Maybe<Scalars['String']>;
  /** The post's content in plain text. */
  contentText?: Maybe<Scalars['String']>;
  /**
   * __Deprecated.__ Use `media` instead.
   * This property will be removed on June 30, 2023.
   *
   * Post cover media.
   */
  coverMedia?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogCoverMedia>;
  /**
   * Identifies whether excerpt was set by contributor.
   * True - excerpt was set by contributor.
   * False - excerpt was generated from content.
   */
  customExcerpt?: Maybe<Scalars['Boolean']>;
  /**
   * Post excerpt.
   * Can be selected by a site contributor. By default, it is extracted from the content text's first characters.
   *
   * Max: 500 characters
   */
  excerpt?: Maybe<Scalars['String']>;
  /** Whether the post is marked as featured. */
  featured?: Maybe<Scalars['Boolean']>;
  /** Date the post was first published. */
  firstPublishedDate?: Maybe<Scalars['String']>;
  /** Indicates if there is a draft post with changes that have not yet been published. */
  hasUnpublishedChanges?: Maybe<Scalars['Boolean']>;
  /** Hashtags in the post. */
  hashtags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Image placed at the top of the blog page. */
  heroImage?: Maybe<WixCommonImage>;
  /** Post ID. */
  id?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  internalCategoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reserved for internal use. */
  internalId?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  internalRelatedPostIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Identifies if post is created from template
   * Reserved for internal use.
   */
  isDemo?: Maybe<Scalars['Boolean']>;
  /**
   * Language the post is written in.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Date the post was last published. */
  lastPublishedDate?: Maybe<Scalars['String']>;
  /** Post cover media. */
  media?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMedia>;
  /** Post owner's [member ID](https://dev.wix.com/api/rest/members). */
  memberId?: Maybe<Scalars['String']>;
  /**
   * Post metrics.
   * Deprecated on '2022-02-15', data can be inconsistent, for consistent data please use 'PostService#GetPostMetrics' API instead
   */
  metrics?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Metrics>;
  /** Estimated reading time (calculated automatically). */
  minutesToRead?: Maybe<Scalars['Int']>;
  /** Post moderation details. Only relevant to posts submitted by [guest writers](https://support.wix.com/en/article/wix-blog-moderating-blog-posts-from-your-guest-writers). */
  moderationDetails?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails>;
  /** Reserved for internal use. */
  mostRecentContributorId?: Maybe<Scalars['String']>;
  /** Whether the post is pinned. If `true`, the post is placed at the top of the post list. */
  pinned?: Maybe<Scalars['Boolean']>;
  /**
   * Dynamic post count info Comment Count, Like Count, View Count.
   * @deprecated Dynamic post count info Comment Count, Like Count, View Count. Replaced by: metrics. Removal date: 2024-06-30.
   */
  postCountInfo?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountInfo>;
  /**
   * Whether the returned content is a preview of premium content. Defaults to `false`.
   * A preview displays a limited number of paragraphs of paid content to non-subscribed users.
   */
  preview?: Maybe<Scalars['Boolean']>;
  /** [Pricing plan IDs](https://dev.wix.com/api/rest/wix-pricing-plans). Only relevant if a post is assigned to a specific pricing plan. */
  pricingPlanIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Post reference ID. You can reference the post from other entities, for example, comments. */
  referenceId?: Maybe<Scalars['String']>;
  /** IDs of posts related to the post. */
  relatedPostIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Post rich content
   *
   * <widget src="https://apps.wix.com/_serverless/ricos-playground-services/goto/api-component" plugins="image.gallery.video.audio.divider.linkButton.html.giphy.codeBlock.file.hashtag.lineSpacing.indent.link.textColor.textHighlight.heading.verticalEmbed.table.collapsibleList.poll" exampleid="72c23a25-524f-4f70-a260-4a2777b6f5d5">
   * <a href="https://dev.wix.com/docs/ricos/api-reference/ricos-document">See Ricos document reference</a>
   * </widget>
   */
  richContent?: Maybe<WixRichContentV1RichContent>;
  /** Post rich content as compressed binary data */
  richContentCompressed?: Maybe<Array<Maybe<Scalars['Byte']>>>;
  /** Post rich content as a string */
  richContentString?: Maybe<Scalars['String']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Post slug. For example, `'post-slug'`. */
  slug?: Maybe<Scalars['String']>;
  /** IDs of [tags](https://dev.wix.com/docs/rest/business-solutions/blog/tags) the post is tagged with. */
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Post title. */
  title?: Maybe<Scalars['String']>;
  /** ID of the translations of this post. All translations of a single post share the same `translationId`. */
  translationId?: Maybe<Scalars['String']>;
  /** List of the post's translated posts. */
  translations?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostTranslation>>>;
  /** Post URL. */
  url?: Maybe<WixCommonPageUrl>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountInfo = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountInfo';
  /** Total number of post comments */
  comments?: Maybe<Scalars['Int']>;
  /** Total number of post likes */
  likes?: Maybe<Scalars['Int']>;
  /** Total number of post views */
  views?: Maybe<Scalars['Int']>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedFieldField {
  /** Like count field. */
  LikeCount = 'LIKE_COUNT',
  /** Rating count field */
  RatingCount = 'RATING_COUNT',
  /** Total comments field. */
  TotalComments = 'TOTAL_COMMENTS',
  Unknown = 'UNKNOWN',
  /** View count field. */
  ViewCount = 'VIEW_COUNT'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedInput = {
  /** Visitor ID if person that liked the post is not logged in */
  anonymousVisitorId?: InputMaybe<Scalars['String']>;
  /** New counter value. */
  counter?: InputMaybe<Scalars['Int']>;
  /** Member ID of person who triggered the counter update */
  memberId?: InputMaybe<Scalars['String']>;
  /** ID of the post which counters were updated. */
  postId?: InputMaybe<Scalars['String']>;
  /** Internal ID of the post which counters were updated. */
  postInternalId?: InputMaybe<Scalars['String']>;
  /** Field of the updated counter. */
  updatedCounterField?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedFieldField>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField {
  /** Includes post owner's contact ID. */
  ContactId = 'CONTACT_ID',
  /**
   * Includes post content as a stringified DraftJS document.
   * Reserved for internal use.
   */
  Content = 'CONTENT',
  /** Includes post content text string when present. */
  ContentText = 'CONTENT_TEXT',
  /** Deprecated use `METRICS` instead. */
  Counters = 'COUNTERS',
  /** If provided, all content fields exclude paid content. */
  ExcludePaidContent = 'EXCLUDE_PAID_CONTENT',
  /**
   * Includes internal ID field.
   * Reserved for internal use.
   */
  InternalId = 'INTERNAL_ID',
  /** Includes post metrics when present. */
  Metrics = 'METRICS',
  /** Includes post reference ID field. */
  ReferenceId = 'REFERENCE_ID',
  /** Includes post rich content. */
  RichContent = 'RICH_CONTENT',
  /** Includes compressed post rich content string. */
  RichContentCompressed = 'RICH_CONTENT_COMPRESSED',
  /** Includes post rich content string. */
  RichContentString = 'RICH_CONTENT_STRING',
  /** Includes SEO data. */
  Seo = 'SEO',
  /** Includes post translations. */
  Translations = 'TRANSLATIONS',
  Unknown = 'UNKNOWN',
  /** Includes post URL when present. */
  Url = 'URL'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PostLikedInput = {
  /** Visitor ID of person who liked the post when they are not logged in. */
  anonymousVisitorId?: InputMaybe<Scalars['String']>;
  /** Member ID of person who liked the post (only returned when the member was logged in when liking the post). */
  memberId?: InputMaybe<Scalars['String']>;
  /** ID of the liked post. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PostTranslation = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3PostTranslation';
  /** Post ID. */
  id?: Maybe<Scalars['String']>;
  /** Language the post is written in. */
  language?: Maybe<Scalars['String']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Post slug. For example, 'post-slug'. */
  slug?: Maybe<Scalars['String']>;
  /** Post URL. */
  url?: Maybe<WixCommonPageUrl>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesRequestInput = {
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  /** Query options. */
  query?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Query options. */
  query?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3Reactions = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3Reactions';
  /** Is post liked by the current user */
  liked?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Post ID. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostResponse';
  /** Post info. */
  post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Post ID. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostResponse';
  /** Post info. */
  post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryRequestInput = {
  /** Category info. */
  category?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput>;
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryResponse';
  /** Category info. */
  category?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostRequestInput = {
  /** Post ID. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostResponse = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostResponse';
  /** Total number of post views */
  views?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogWixMedia = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedBlogWixMedia';
  /** Image details. */
  image?: Maybe<WixCommonImage>;
  /** Video details. */
  videoV2?: Maybe<WixCommonVideoV2>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamTagCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamTagPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursors = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingMetadataV2 = {
  __typename?: 'ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingMetadataV2';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressPortfolioCollectionsCollection = {
  __typename?: 'ComWixpressPortfolioCollectionsCollection';
  /** Collection's cover photo */
  coverImage?: Maybe<ComWixpressPortfolioCommonImage>;
  /** Represents the time this Collection was created */
  createdDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** Indicates if the collection is hidden from Portfolio */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Collection ID */
  id?: Maybe<Scalars['String']>;
  projectVirtualReference?: Maybe<Array<Maybe<ComWixpressPortfolioProjectsProject>>>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision */
  revision?: Maybe<Scalars['Int']>;
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Url of Collection */
  slug?: Maybe<Scalars['String']>;
  /** if not present in an update it means the collection will be added as currentTimestamp - as the last collection */
  sortOrder?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  /** Represents the time this Collection was last updated */
  updatedDate?: Maybe<Scalars['String']>;
  /** Url and relative url of Collection - in order to receive this field in READ requests you will need to pass the `include_page_url` field as part of request */
  url?: Maybe<WixCommonPageUrlV2>;
};

export type ComWixpressPortfolioCollectionsCollectionInput = {
  /** Collection's cover photo */
  coverImage?: InputMaybe<ComWixpressPortfolioCommonImageInput>;
  /** Represents the time this Collection was created */
  createdDate?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** Indicates if the collection is hidden from Portfolio */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Collection ID */
  id?: InputMaybe<Scalars['String']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision */
  revision?: InputMaybe<Scalars['Int']>;
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Url of Collection */
  slug?: InputMaybe<Scalars['String']>;
  /** if not present in an update it means the collection will be added as currentTimestamp - as the last collection */
  sortOrder?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  /** Represents the time this Collection was last updated */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Url and relative url of Collection - in order to receive this field in READ requests you will need to pass the `include_page_url` field as part of request */
  url?: InputMaybe<WixCommonPageUrlV2Input>;
};

export type ComWixpressPortfolioCollectionsCreateCollectionRequestInput = {
  /** Collection to be created */
  collection?: InputMaybe<ComWixpressPortfolioCollectionsCollectionInput>;
};

export type ComWixpressPortfolioCollectionsCreateCollectionResponse = {
  __typename?: 'ComWixpressPortfolioCollectionsCreateCollectionResponse';
  /** The created Collection */
  collection?: Maybe<ComWixpressPortfolioCollectionsCollection>;
};

export type ComWixpressPortfolioCollectionsDeleteCollectionRequestInput = {
  /** Id of the Collection to delete */
  collectionId?: InputMaybe<Scalars['String']>;
  /** The revision of the Collection */
  revision?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressPortfolioCollectionsDeleteCollectionResponse = {
  __typename?: 'ComWixpressPortfolioCollectionsDeleteCollectionResponse';
  /** Id of the Deleted Collection */
  collectionId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioCollectionsListCollectionsRequestInput = {
  includePageUrl?: InputMaybe<Scalars['Boolean']>;
  /** Maximum limit per response is 100, in first request cursor is None */
  paging?: InputMaybe<WixCommonCursorPagingInput>;
};

export type ComWixpressPortfolioCollectionsListCollectionsResponse = {
  __typename?: 'ComWixpressPortfolioCollectionsListCollectionsResponse';
  /** Retrieved Collections */
  collections?: Maybe<Array<Maybe<ComWixpressPortfolioCollectionsCollection>>>;
  /** Paging metadata */
  metadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Paging metadata */
  pagingMetadataV2?: Maybe<WixCommonPagingMetadataV2>;
};

export type ComWixpressPortfolioCollectionsQueryCollectionsResponse = {
  __typename?: 'ComWixpressPortfolioCollectionsQueryCollectionsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressPortfolioCollectionsCollection>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressPortfolioCollectionsUpdateCollectionRequestInput = {
  /** Collection to be updated, may be partial */
  collection?: InputMaybe<ComWixpressPortfolioCollectionsCollectionInput>;
  /** Explicit list of fields to update */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressPortfolioCollectionsUpdateCollectionResponse = {
  __typename?: 'ComWixpressPortfolioCollectionsUpdateCollectionResponse';
  /** The updated Collection */
  collection?: Maybe<ComWixpressPortfolioCollectionsCollection>;
};

export type ComWixpressPortfolioCommonImage = {
  __typename?: 'ComWixpressPortfolioCommonImage';
  /** Set of key-value pairs describing the media in [Exchangeable Image File format](https://en.wikipedia.org/wiki/Exif). */
  exif?: Maybe<Scalars['JSON']>;
  /** Focal point of the image. */
  focalPoint?: Maybe<ComWixpressPortfolioCommonPoint>;
  /** Image info - Wix Media Image. */
  imageInfo?: Maybe<UpstreamWixCommonPortfolioCommonImage>;
  /**
   * Image compression level. <br />
   *
   * Min: `30` <br />
   * Max: `100`
   */
  quality?: Maybe<Scalars['Int']>;
  /** Whether the image is saved in secure media. */
  secure?: Maybe<Scalars['Boolean']>;
  /** When image is saved in secure media, token is generated. */
  token?: Maybe<Scalars['String']>;
  type?: Maybe<ComWixpressPortfolioCommonImageImageType>;
  /** [Unsharp masking](https://en.wikipedia.org/wiki/Unsharp_masking) values of the image. */
  unsharpMasking?: Maybe<ComWixpressPortfolioCommonUnsharpMasking>;
};

export enum ComWixpressPortfolioCommonImageImageType {
  External = 'EXTERNAL',
  Undefined = 'UNDEFINED',
  WixMedia = 'WIX_MEDIA'
}

export type ComWixpressPortfolioCommonImageInput = {
  /** Set of key-value pairs describing the media in [Exchangeable Image File format](https://en.wikipedia.org/wiki/Exif). */
  exif?: InputMaybe<Scalars['JSON']>;
  /** Focal point of the image. */
  focalPoint?: InputMaybe<ComWixpressPortfolioCommonPointInput>;
  /** Image info - Wix Media Image. */
  imageInfo?: InputMaybe<UpstreamWixCommonPortfolioCommonImageInput>;
  /**
   * Image compression level. <br />
   *
   * Min: `30` <br />
   * Max: `100`
   */
  quality?: InputMaybe<Scalars['Int']>;
  /** Whether the image is saved in secure media. */
  secure?: InputMaybe<Scalars['Boolean']>;
  /** When image is saved in secure media, token is generated. */
  token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ComWixpressPortfolioCommonImageImageType>;
  /** [Unsharp masking](https://en.wikipedia.org/wiki/Unsharp_masking) values of the image. */
  unsharpMasking?: InputMaybe<ComWixpressPortfolioCommonUnsharpMaskingInput>;
};

export type ComWixpressPortfolioCommonPoint = {
  __typename?: 'ComWixpressPortfolioCommonPoint';
  /** X-coordinate of the focal point. */
  x?: Maybe<Scalars['Float']>;
  /** Y-coordinate of the focal point. */
  y?: Maybe<Scalars['Float']>;
};

export type ComWixpressPortfolioCommonPointInput = {
  /** X-coordinate of the focal point. */
  x?: InputMaybe<Scalars['Float']>;
  /** Y-coordinate of the focal point. */
  y?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressPortfolioCommonUnsharpMasking = {
  __typename?: 'ComWixpressPortfolioCommonUnsharpMasking';
  /**
   * Unsharp masking amount. Controls the sharpening strength. <br />
   *
   * Min: `0` <br />
   * Max: `5`
   */
  amount?: Maybe<Scalars['Float']>;
  /** Unsharp masking radius in pixels. Controls the sharpening width. */
  radius?: Maybe<Scalars['Float']>;
  /**
   * Unsharp masking threshold. Controls how different neighboring pixels must be for shapening to apply. <br />
   *
   * Min: `0` <br />
   * Max: `1`
   */
  threshold?: Maybe<Scalars['Float']>;
};

export type ComWixpressPortfolioCommonUnsharpMaskingInput = {
  /**
   * Unsharp masking amount. Controls the sharpening strength. <br />
   *
   * Min: `0` <br />
   * Max: `5`
   */
  amount?: InputMaybe<Scalars['Float']>;
  /** Unsharp masking radius in pixels. Controls the sharpening width. */
  radius?: InputMaybe<Scalars['Float']>;
  /**
   * Unsharp masking threshold. Controls how different neighboring pixels must be for shapening to apply. <br />
   *
   * Min: `0` <br />
   * Max: `1`
   */
  threshold?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressPortfolioCommonVideo = {
  __typename?: 'ComWixpressPortfolioCommonVideo';
  /** Manually defined Video duration in milliseconds. */
  durationInMillis?: Maybe<Scalars['Int']>;
  /** Video info - Wix Media Image. */
  videoInfo?: Maybe<UpstreamWixCommonPortfolioCommonVideoV2>;
};

export type ComWixpressPortfolioCommonVideoInput = {
  /** Manually defined Video duration in milliseconds. */
  durationInMillis?: InputMaybe<Scalars['Int']>;
  /** Video info - Wix Media Image. */
  videoInfo?: InputMaybe<UpstreamWixCommonPortfolioCommonVideoV2Input>;
};

export type ComWixpressPortfolioPortfolioappAdminRemoveMenuItemsResponse = {
  __typename?: 'ComWixpressPortfolioPortfolioappAdminRemoveMenuItemsResponse';
  /** number of items queried for deletion */
  numItems?: Maybe<Scalars['Int']>;
  /** number of items sucessfully deleted */
  numItemsSuccessfullyDeleted?: Maybe<Scalars['Int']>;
};

export type ComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsRequestInput = {
  /** Media ids of requested project items */
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsResponse = {
  __typename?: 'ComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsResponse';
  mediaTokens?: Maybe<Array<Maybe<ComWixpressPortfolioPortfolioappProjectItemMediaToken>>>;
};

export type ComWixpressPortfolioPortfolioappGetProjectPageDataRequestInput = {
  /** Slug of the project's current collection */
  collectionSlug?: InputMaybe<Scalars['String']>;
  /** Project's slug */
  projectSlug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioPortfolioappGetProjectPageDataResponse = {
  __typename?: 'ComWixpressPortfolioPortfolioappGetProjectPageDataResponse';
  nextProject?: Maybe<ComWixpressPortfolioPortfolioappProjectSlug>;
  previousProject?: Maybe<ComWixpressPortfolioPortfolioappProjectSlug>;
  project?: Maybe<ComWixpressPortfolioProjectsProject>;
};

export type ComWixpressPortfolioPortfolioappProjectItemMediaToken = {
  __typename?: 'ComWixpressPortfolioPortfolioappProjectItemMediaToken';
  /** Media id of project item */
  mediaId?: Maybe<Scalars['String']>;
  /** Generated media token for project item */
  mediaToken?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioPortfolioappProjectSlug = {
  __typename?: 'ComWixpressPortfolioPortfolioappProjectSlug';
  /** Project id */
  projectId?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsBulkCreateProjectItemResult = {
  __typename?: 'ComWixpressPortfolioProjectitemsBulkCreateProjectItemResult';
  item?: Maybe<ComWixpressPortfolioProjectitemsItem>;
  /** Holds information about an item in bulk create - id, index in original request array, action successful, error (if failed) */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressPortfolioProjectitemsBulkCreateProjectItemsRequestInput = {
  /** items to be created. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressPortfolioProjectitemsItemInput>>>;
  /**
   * Id of the Project the items are part of
   * Project must exist before adding items to it. project can be created/updated/deleted using this //TODO
   */
  projectId?: InputMaybe<Scalars['String']>;
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressPortfolioProjectitemsBulkCreateProjectItemsResponse = {
  __typename?: 'ComWixpressPortfolioProjectitemsBulkCreateProjectItemsResponse';
  /** Holds metadata of the entire bulk create operation */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
  /** Array with all created items results. */
  results?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsBulkCreateProjectItemResult>>>;
};

export type ComWixpressPortfolioProjectitemsBulkDeleteProjectItemResult = {
  __typename?: 'ComWixpressPortfolioProjectitemsBulkDeleteProjectItemResult';
  /** Id of the ProjectItem */
  itemId?: Maybe<Scalars['String']>;
  /** Holds information about an item in bulk delete - id, index in original request array, action successful, error (if failed) */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressPortfolioProjectitemsBulkDeleteProjectItemsRequestInput = {
  /** Ids of the items to be deleted */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Id of the project */
  projectId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsBulkDeleteProjectItemsResponse = {
  __typename?: 'ComWixpressPortfolioProjectitemsBulkDeleteProjectItemsResponse';
  /** Holds metadata of the entire bulk delete operation */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
  /** Array with all deleted items results */
  results?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsBulkDeleteProjectItemResult>>>;
};

export type ComWixpressPortfolioProjectitemsBulkUpdateProjectItemResult = {
  __typename?: 'ComWixpressPortfolioProjectitemsBulkUpdateProjectItemResult';
  item?: Maybe<ComWixpressPortfolioProjectitemsItem>;
  /** Holds information about an item in bulk update - id, index in original request array, action successful, error (if failed). */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressPortfolioProjectitemsBulkUpdateProjectItemsRequestInput = {
  /** items to be updated. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressPortfolioProjectitemsMaskedItemInput>>>;
  /** Id of the Project the items are part of */
  projectId?: InputMaybe<Scalars['String']>;
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressPortfolioProjectitemsBulkUpdateProjectItemsResponse = {
  __typename?: 'ComWixpressPortfolioProjectitemsBulkUpdateProjectItemsResponse';
  /** Holds metadata of the entire bulk update operation */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
  /** Array with all updated items results. */
  results?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsBulkUpdateProjectItemResult>>>;
};

export type ComWixpressPortfolioProjectitemsCreateProjectGalleryRequestInput = {
  /** Id of Project to create */
  projectId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsCreateProjectGalleryResponse = {
  __typename?: 'ComWixpressPortfolioProjectitemsCreateProjectGalleryResponse';
  /** Id of created gallery */
  galleryId?: Maybe<Scalars['String']>;
  /** Id of created Project */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsCreateProjectItemRequestInput = {
  /** Item to be created */
  item?: InputMaybe<ComWixpressPortfolioProjectitemsItemInput>;
};

export type ComWixpressPortfolioProjectitemsCreateProjectItemResponse = {
  __typename?: 'ComWixpressPortfolioProjectitemsCreateProjectItemResponse';
  /** The created item */
  item?: Maybe<ComWixpressPortfolioProjectitemsItem>;
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsDeleteProjectItemRequestInput = {
  /** Id of the Item to delete */
  itemId?: InputMaybe<Scalars['String']>;
  /** Id of the Project the item is part of */
  projectId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsDeleteProjectItemResponse = {
  __typename?: 'ComWixpressPortfolioProjectitemsDeleteProjectItemResponse';
  /** Id of deleted item */
  itemId?: Maybe<Scalars['String']>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsDuplicateProjectItemsRequestInput = {
  /** Id of Project to duplicate */
  originProjectId?: InputMaybe<Scalars['String']>;
  /** Target project ID to duplicate to (same instance as request) */
  targetProjectId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsDuplicateProjectItemsResponse = {
  __typename?: 'ComWixpressPortfolioProjectitemsDuplicateProjectItemsResponse';
  /** Result metadata */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Id of target project */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsItem = {
  __typename?: 'ComWixpressPortfolioProjectitemsItem';
  /** Date and time the item was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Item description. */
  description?: Maybe<Scalars['String']>;
  /** Item ID. */
  id?: Maybe<Scalars['String']>;
  /** Information about the image. */
  image?: Maybe<ComWixpressPortfolioCommonImage>;
  /** Link from the item. */
  link?: Maybe<ComWixpressPortfolioProjectitemsLink>;
  /**
   * Id of the Project the items are part of
   * Project must exist before adding items to it. project can be created/updated/deleted using this //TODO
   */
  project?: Maybe<ComWixpressPortfolioProjectsProject>;
  /**
   * Id of the Project the items are part of
   * Project must exist before adding items to it. project can be created/updated/deleted using this //TODO
   */
  projectId?: Maybe<Scalars['String']>;
  /**
   * Index that determines which position a media item is displayed in the gallery. <br />
   *
   * Default: [Epoch](https://www.epoch101.com/) timestamp. <br /> //TODO: decide if needed, what happens if user add an item without sortOrder? do we give it the default timestamp? if not, does sorting by sortOrder will work when no sortOrder?
   */
  sortOrder?: Maybe<Scalars['Float']>;
  /** Item tags. */
  tags?: Maybe<ComWixpressPortfolioProjectitemsTags>;
  /** Item title. */
  title?: Maybe<Scalars['String']>;
  /**
   * Item data type. One of:
   * <br />
   * +`"IMAGE"`
   * <br />
   * +`"VIDEO"`
   */
  type?: Maybe<ComWixpressPortfolioProjectitemsItemType>;
  /** Date and time the item was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Information about the video. */
  video?: Maybe<ComWixpressPortfolioCommonVideo>;
};

export type ComWixpressPortfolioProjectitemsItemInput = {
  /** Date and time the item was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Item description. */
  description?: InputMaybe<Scalars['String']>;
  /** Item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Information about the image. */
  image?: InputMaybe<ComWixpressPortfolioCommonImageInput>;
  /** Link from the item. */
  link?: InputMaybe<ComWixpressPortfolioProjectitemsLinkInput>;
  /**
   * Id of the Project the items are part of
   * Project must exist before adding items to it. project can be created/updated/deleted using this //TODO
   */
  projectId?: InputMaybe<Scalars['String']>;
  /**
   * Index that determines which position a media item is displayed in the gallery. <br />
   *
   * Default: [Epoch](https://www.epoch101.com/) timestamp. <br /> //TODO: decide if needed, what happens if user add an item without sortOrder? do we give it the default timestamp? if not, does sorting by sortOrder will work when no sortOrder?
   */
  sortOrder?: InputMaybe<Scalars['Float']>;
  /** Item tags. */
  tags?: InputMaybe<ComWixpressPortfolioProjectitemsTagsInput>;
  /** Item title. */
  title?: InputMaybe<Scalars['String']>;
  /**
   * Item data type. One of:
   * <br />
   * +`"IMAGE"`
   * <br />
   * +`"VIDEO"`
   */
  type?: InputMaybe<ComWixpressPortfolioProjectitemsItemType>;
  /** Date and time the item was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Information about the video. */
  video?: InputMaybe<ComWixpressPortfolioCommonVideoInput>;
};

export enum ComWixpressPortfolioProjectitemsItemType {
  Image = 'IMAGE',
  Undefined = 'UNDEFINED',
  Video = 'VIDEO'
}

export type ComWixpressPortfolioProjectitemsLink = {
  __typename?: 'ComWixpressPortfolioProjectitemsLink';
  /**
   * Whether the link opens in a new tab or window. One of:
   * * `'_blank'`: The link opens in a new tab or window.
   * * `'_self'`: The link opens in the same tab or window.
   */
  target?: Maybe<Scalars['String']>;
  /** Display text of the link. */
  text?: Maybe<Scalars['String']>;
  /** Target URL of the link. */
  url?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsLinkInput = {
  /**
   * Whether the link opens in a new tab or window. One of:
   * * `'_blank'`: The link opens in a new tab or window.
   * * `'_self'`: The link opens in the same tab or window.
   */
  target?: InputMaybe<Scalars['String']>;
  /** Display text of the link. */
  text?: InputMaybe<Scalars['String']>;
  /** Target URL of the link. */
  url?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsListProjectItemsRequestInput = {
  /** limit and offset for ProjectItems - maximum limit is 200 per request, default is 50 */
  paging?: InputMaybe<WixCommonPagingInput>;
  /** Id of the Project the item is part of */
  projectId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsListProjectItemsResponse = {
  __typename?: 'ComWixpressPortfolioProjectitemsListProjectItemsResponse';
  /** ProjectItems retrieved */
  items?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsItem>>>;
  /** Paging metadata */
  metadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Paging metadata */
  pagingMetadataV2?: Maybe<WixCommonPagingMetadataV2>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsMaskedItemInput = {
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  item?: InputMaybe<ComWixpressPortfolioProjectitemsItemInput>;
};

export type ComWixpressPortfolioProjectitemsQueryProjectItemsResponse = {
  __typename?: 'ComWixpressPortfolioProjectitemsQueryProjectItemsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsItem>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressPortfolioProjectitemsTags = {
  __typename?: 'ComWixpressPortfolioProjectitemsTags';
  /** List of tags assigned to the media item. */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressPortfolioProjectitemsTagsInput = {
  /** List of tags assigned to the media item. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressPortfolioProjectitemsUpdateProjectItemRequestInput = {
  /** ProjectItem to be updated, may be partial */
  item?: InputMaybe<ComWixpressPortfolioProjectitemsItemInput>;
  /** Explicit list of fields to update */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressPortfolioProjectitemsUpdateProjectItemResponse = {
  __typename?: 'ComWixpressPortfolioProjectitemsUpdateProjectItemResponse';
  /** The updated ProjectItem */
  item?: Maybe<ComWixpressPortfolioProjectitemsItem>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsCreateProjectRequestInput = {
  /** Project to be created */
  project?: InputMaybe<ComWixpressPortfolioProjectsProjectInput>;
};

export type ComWixpressPortfolioProjectsCreateProjectResponse = {
  __typename?: 'ComWixpressPortfolioProjectsCreateProjectResponse';
  /** The created Project */
  project?: Maybe<ComWixpressPortfolioProjectsProject>;
};

export type ComWixpressPortfolioProjectsDeleteProjectRequestInput = {
  /** Id of the Project to delete */
  projectId?: InputMaybe<Scalars['String']>;
  /** The revision of the Project */
  revision?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressPortfolioProjectsDeleteProjectResponse = {
  __typename?: 'ComWixpressPortfolioProjectsDeleteProjectResponse';
  /** Id of the deleted Project */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsDetailsLink = {
  __typename?: 'ComWixpressPortfolioProjectsDetailsLink';
  /**
   * Whether the link opens in a new tab or window. One of:
   * * `'_blank'`: The link opens in a new tab or window.
   * * `'_self'`: The link opens in the same tab or window.
   */
  target?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  /** link to external source */
  url?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsDetailsLinkInput = {
  /**
   * Whether the link opens in a new tab or window. One of:
   * * `'_blank'`: The link opens in a new tab or window.
   * * `'_self'`: The link opens in the same tab or window.
   */
  target?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  /** link to external source */
  url?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsListProjectsRequestInput = {
  includePageUrl?: InputMaybe<Scalars['Boolean']>;
  /** Projects limit per response is maximum 100, In the first request the cursor is None */
  paging?: InputMaybe<WixCommonCursorPagingInput>;
};

export type ComWixpressPortfolioProjectsListProjectsResponse = {
  __typename?: 'ComWixpressPortfolioProjectsListProjectsResponse';
  /** Paging metadata */
  metadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Paging metadata */
  pagingMetadataV2?: Maybe<WixCommonPagingMetadataV2>;
  /** The retrieved Projects */
  projects?: Maybe<Array<Maybe<ComWixpressPortfolioProjectsProject>>>;
};

export type ComWixpressPortfolioProjectsProject = {
  __typename?: 'ComWixpressPortfolioProjectsProject';
  /** Collections must exist to be added to a project. can be created/updated/deleted using this //TODO */
  collectionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Collections must exist to be added to a project. can be created/updated/deleted using this //TODO */
  collections?: Maybe<Array<Maybe<ComWixpressPortfolioCollectionsCollection>>>;
  /** project's cover photo */
  coverImage?: Maybe<ComWixpressPortfolioCommonImage>;
  /** project's cover video */
  coverVideo?: Maybe<ComWixpressPortfolioCommonVideo>;
  /** Represents the time this Project was created */
  createdDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** Custom project details */
  details?: Maybe<Array<Maybe<ComWixpressPortfolioProjectsProjectDetail>>>;
  /** indicates if the project should be hidden from Portfolio */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Project ID */
  id?: Maybe<Scalars['String']>;
  itemsVirtualReference?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsItem>>>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision */
  revision?: Maybe<Scalars['Int']>;
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  slug?: Maybe<Scalars['String']>;
  /** project source - When project is synced from external platform, this field will represent the app & source the projects synced from. */
  source?: Maybe<ComWixpressPortfolioProjectsProjectSource>;
  /** indicates if the project is synced from external platform (via integration page) and therefore will be updated from the external platform on daily basis */
  syncedProject?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  /** Represents the time this Project was last updated */
  updatedDate?: Maybe<Scalars['String']>;
  /** Url and relative url of Project - in order to receive this field in READ requests you will need to pass the `include_page_url` field as part of request */
  url?: Maybe<WixCommonPageUrlV2>;
};


export type ComWixpressPortfolioProjectsProjectCollectionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type ComWixpressPortfolioProjectsProjectDetail = {
  __typename?: 'ComWixpressPortfolioProjectsProjectDetail';
  label?: Maybe<Scalars['String']>;
  link?: Maybe<ComWixpressPortfolioProjectsDetailsLink>;
  text?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsProjectDetailInput = {
  label?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<ComWixpressPortfolioProjectsDetailsLinkInput>;
  text?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsProjectInCollection = {
  __typename?: 'ComWixpressPortfolioProjectsProjectInCollection';
  /** Collection ID */
  collectionId?: Maybe<Scalars['String']>;
  /** Project */
  project?: Maybe<ComWixpressPortfolioProjectsProject>;
  /** The sort order of the project in the given Collection */
  sortOrder?: Maybe<Scalars['Float']>;
};

export type ComWixpressPortfolioProjectsProjectInput = {
  /** Collections must exist to be added to a project. can be created/updated/deleted using this //TODO */
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** project's cover photo */
  coverImage?: InputMaybe<ComWixpressPortfolioCommonImageInput>;
  /** project's cover video */
  coverVideo?: InputMaybe<ComWixpressPortfolioCommonVideoInput>;
  /** Represents the time this Project was created */
  createdDate?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** Custom project details */
  details?: InputMaybe<Array<InputMaybe<ComWixpressPortfolioProjectsProjectDetailInput>>>;
  /** indicates if the project should be hidden from Portfolio */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Project ID */
  id?: InputMaybe<Scalars['String']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision */
  revision?: InputMaybe<Scalars['Int']>;
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** project source - When project is synced from external platform, this field will represent the app & source the projects synced from. */
  source?: InputMaybe<ComWixpressPortfolioProjectsProjectSourceInput>;
  /** indicates if the project is synced from external platform (via integration page) and therefore will be updated from the external platform on daily basis */
  syncedProject?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  /** Represents the time this Project was last updated */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Url and relative url of Project - in order to receive this field in READ requests you will need to pass the `include_page_url` field as part of request */
  url?: InputMaybe<WixCommonPageUrlV2Input>;
};

export type ComWixpressPortfolioProjectsProjectSource = {
  __typename?: 'ComWixpressPortfolioProjectsProjectSource';
  appDefId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  /** last date the project was synced */
  lastSync?: Maybe<Scalars['String']>;
  /** link to external source */
  link?: Maybe<Scalars['String']>;
  /** fields that are synced from external source, should be blocked to update in UI */
  notEditableFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceName?: Maybe<Scalars['String']>;
  syncStatus?: Maybe<ComWixpressPortfolioProjectsProjectSourceSyncStatus>;
};

export type ComWixpressPortfolioProjectsProjectSourceInput = {
  appDefId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  /** last date the project was synced */
  lastSync?: InputMaybe<Scalars['String']>;
  /** link to external source */
  link?: InputMaybe<Scalars['String']>;
  /** fields that are synced from external source, should be blocked to update in UI */
  notEditableFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceName?: InputMaybe<Scalars['String']>;
  syncStatus?: InputMaybe<ComWixpressPortfolioProjectsProjectSourceSyncStatus>;
};

export enum ComWixpressPortfolioProjectsProjectSourceSyncStatus {
  NotSynced = 'NOT_SYNCED',
  Synced = 'SYNCED',
  Syncing = 'SYNCING'
}

export type ComWixpressPortfolioProjectsQueryProjectWithCollectionInfoRequestInput = {
  includePageUrl?: InputMaybe<Scalars['Boolean']>;
  /** WQL expression */
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type ComWixpressPortfolioProjectsQueryProjectWithCollectionInfoResponse = {
  __typename?: 'ComWixpressPortfolioProjectsQueryProjectWithCollectionInfoResponse';
  /** Paging metadata */
  metadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Paging metadata */
  pagingMetadataV2?: Maybe<WixCommonPagingMetadataV2>;
  /** The retrieved Projects in Collection */
  projects?: Maybe<Array<Maybe<ComWixpressPortfolioProjectsProjectInCollection>>>;
};

export type ComWixpressPortfolioProjectsQueryProjectsResponse = {
  __typename?: 'ComWixpressPortfolioProjectsQueryProjectsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressPortfolioProjectsProject>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressPortfolioProjectsUpdateProjectOrderInCollectionRequestInput = {
  /** Id of the collection in which the project will be re-ordered */
  collectionId?: InputMaybe<Scalars['String']>;
  /** Id of the Project to update its order */
  projectId?: InputMaybe<Scalars['String']>;
  /** The new sort order of the project in the given collection */
  sortOrder?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressPortfolioProjectsUpdateProjectOrderInCollectionResponse = {
  __typename?: 'ComWixpressPortfolioProjectsUpdateProjectOrderInCollectionResponse';
  project?: Maybe<ComWixpressPortfolioProjectsProjectInCollection>;
  /** project with new sort order set */
  projectInCollection?: Maybe<ComWixpressPortfolioProjectsProjectInCollection>;
};

export type ComWixpressPortfolioProjectsUpdateProjectRequestInput = {
  /** Explicit list of fields to update */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Project to be updated, may be partial */
  project?: InputMaybe<ComWixpressPortfolioProjectsProjectInput>;
};

export type ComWixpressPortfolioProjectsUpdateProjectResponse = {
  __typename?: 'ComWixpressPortfolioProjectsUpdateProjectResponse';
  /** The updated Project */
  project?: Maybe<ComWixpressPortfolioProjectsProject>;
};

export enum ComWixpressPremiumDomainsNotificationsCrudType {
  Create = 'CREATE',
  /** Unfortunately this action is used by hibernate save in wix-war */
  CreateOrUpdate = 'CREATE_OR_UPDATE',
  Delete = 'DELETE',
  InvalidCrudType = 'INVALID_CRUD_TYPE',
  Update = 'UPDATE'
}

export type ComWixpressPremiumDomainsNotificationsUserDomainInfoChangedEventInput = {
  changeTime?: InputMaybe<Scalars['String']>;
  crudType?: InputMaybe<ComWixpressPremiumDomainsNotificationsCrudType>;
  domainName?: InputMaybe<Scalars['String']>;
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesAddressDescriptionInput = {
  content?: InputMaybe<Scalars['String']>;
  placement?: InputMaybe<ComWixpressQuotesAddressDescriptionPlacement>;
};

export enum ComWixpressQuotesAddressDescriptionPlacement {
  After = 'After',
  Before = 'Before',
  Replace = 'Replace',
  Unknown = 'Unknown'
}

export type ComWixpressQuotesAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<ComWixpressQuotesAddressDescriptionInput>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesApiEventsInvoicePaidEventInput = {
  data?: InputMaybe<ComWixpressQuotesInvoicesInvoiceFieldsInput>;
  id?: InputMaybe<ComWixpressQuotesIdAndVersionInput>;
  status?: InputMaybe<ComWixpressQuotesInvoicesInvoiceStatus>;
};

export type ComWixpressQuotesApiEventsInvoiceSentEventInput = {
  data?: InputMaybe<ComWixpressQuotesInvoicesInvoiceFieldsInput>;
  id?: InputMaybe<ComWixpressQuotesIdAndVersionInput>;
  status?: InputMaybe<ComWixpressQuotesInvoicesInvoiceStatus>;
};

export type ComWixpressQuotesBigDecimalWrapperInput = {
  serializedValue?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressQuotesCalculatedTaxInput = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  /** the costs on which the taxes are applied */
  taxable?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  /** the taxes as a result of the */
  taxed?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressQuotesCalculatedTaxesInput = {
  /** consider calculated or not - cannot enforce set */
  taxes?: InputMaybe<Array<InputMaybe<ComWixpressQuotesCalculatedTaxInput>>>;
};

export type ComWixpressQuotesCompanyInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesCustomerInput = {
  address?: InputMaybe<ComWixpressQuotesAddressInput>;
  billingAddress?: InputMaybe<WixCommonAddressInput>;
  company?: InputMaybe<ComWixpressQuotesCompanyInput>;
  contactId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<ComWixpressQuotesEmailInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<ComWixpressQuotesPhoneInput>;
  shippingAddress?: InputMaybe<WixCommonAddressInput>;
};

export type ComWixpressQuotesDiscountInput = {
  /** Discount as fixed value. Currently only for internal use. */
  fixed?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  /** Discount as percentage value. */
  percentage?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressQuotesEmailInput = {
  address?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesIdAndVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

export enum ComWixpressQuotesInvoicesDepositDepositType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE',
  Unknown = 'UNKNOWN'
}

export type ComWixpressQuotesInvoicesDepositInput = {
  /** The flat amount of the deposit. The flat amount of the deposit must be less than the invoice total. */
  flatAmount?: InputMaybe<Scalars['String']>;
  /**
   * The read-only percentage value of the deposit.
   * It is computed according to the flat_amount and the invoice total and is rounded to 2 digits precision.
   */
  percentage?: InputMaybe<Scalars['String']>;
  /** The type of the deposit. The default is FLAT. */
  type?: InputMaybe<ComWixpressQuotesInvoicesDepositDepositType>;
};

export type ComWixpressQuotesInvoicesInvoiceDatesInput = {
  /** use UTC midnight date to set the due date according to the site time zone */
  dueDate?: InputMaybe<Scalars['String']>;
  /** use UTC midnight date to set the issue date according to the site time zone */
  issueDate?: InputMaybe<Scalars['String']>;
  /** ignored in request use in response to get the site time zone */
  lastSeenDate?: InputMaybe<Scalars['String']>;
  /** <a href="http://joda-time.sourceforge.net/timezones.html">Valid time zones</a> */
  timeZoneCode?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesInvoicesInvoiceDynamicPriceTotalsInput = {
  balance?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  paidAmount?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressQuotesInvoicesInvoiceFieldsInput = {
  /** Not used */
  createOrder?: InputMaybe<Scalars['Boolean']>;
  /** Not used */
  creationAdditional_BIInformation?: InputMaybe<Scalars['String']>;
  /** The invoice 3-letter currency code in [ISO-4217 alphabetic](https://www.iso.org/iso-4217-currency-codes.html) format. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Invoice custom fields */
  customFields?: InputMaybe<Array<InputMaybe<ComWixpressCrmFinancialCommonApiV1CustomFieldValueInput>>>;
  /** The invoice customer. The customer must be a contact of the site, with an email. */
  customer?: InputMaybe<ComWixpressQuotesCustomerInput>;
  /**
   * Invoice dates: issue date and due date are mandatory and provided when the invoice is created.
   * Last seen date is the optional date when the invoice was last seen be UoU.
   */
  dates?: InputMaybe<ComWixpressQuotesInvoicesInvoiceDatesInput>;
  /**
   * Deduct taxes from line items.
   * Used in cases where line items already include taxes.
   */
  deductTaxes?: InputMaybe<Scalars['Boolean']>;
  /** The optional deposit of the invoice */
  deposit?: InputMaybe<ComWixpressQuotesInvoicesDepositInput>;
  /** Not used */
  designTemplateId?: InputMaybe<Scalars['String']>;
  /** An optional discount on the invoice. */
  discount?: InputMaybe<ComWixpressQuotesDiscountInput>;
  /**
   * The balance and amount paid on the invoice.
   * This read-only field is calculated based on the invoice totals and payments.
   */
  dynamicTotals?: InputMaybe<ComWixpressQuotesInvoicesInvoiceDynamicPriceTotalsInput>;
  /** Associated checkout for this invoice */
  ecomCheckoutId?: InputMaybe<Scalars['String']>;
  /**
   * Line items containing the details of the products or services relevant to the invoice, with their name, prices,
   * and quantity. There must be at least one line item on the invoice.
   */
  lineItems?: InputMaybe<ComWixpressQuotesLineItemsInput>;
  /**
   * Locale of the invoice, containing the language.
   * This field is not mandatory but is used for display purposes, to determine the appearance of numbers and dates
   * on the invoice.
   */
  locale?: InputMaybe<ComWixpressQuotesLocaleInput>;
  /** Invoice metadata */
  metaData?: InputMaybe<ComWixpressQuotesMetaDataInput>;
  /** The invoice number allocated the invoice by the server. The number is limited to at most 11 digits. */
  number?: InputMaybe<Scalars['String']>;
  /** The payments on the invoice. The invoice has status paid if its payments cover the invoice total. */
  payments?: InputMaybe<ComWixpressQuotesInvoicesPaymentsInput>;
  /** The taxes of the invoice. */
  taxes?: InputMaybe<ComWixpressQuotesCalculatedTaxesInput>;
  /** The invoice title */
  title?: InputMaybe<Scalars['String']>;
  /**
   * The totals on the invoice.
   * The totals.subtotal, totals.total and totals.taxed_amount are calculated by the server based on the line items.
   * Alternatively, these fields can be provided in the invoice creation request, in this case, these values are fixed.
   * The totals contain fees and a discount, that apply to the invoice.
   */
  totals?: InputMaybe<ComWixpressQuotesTotalPriceInput>;
};

export enum ComWixpressQuotesInvoicesInvoiceStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Overdue = 'Overdue',
  Paid = 'Paid',
  PartialAndOverdue = 'PartialAndOverdue',
  PartiallyPaid = 'PartiallyPaid',
  Processing = 'Processing',
  Sent = 'Sent',
  Void = 'Void'
}

export type ComWixpressQuotesInvoicesPaymentInput = {
  amount?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  date?: InputMaybe<Scalars['String']>;
  /** document */
  id?: InputMaybe<Scalars['String']>;
  /**
   * The orderId of the order in cashier associated with the payment.
   * This field is populated for external payments that are charged by invoices via AddPayment endpoint.
   */
  orderId?: InputMaybe<Scalars['String']>;
  /**
   * The transactionId corresponding to the orderId of the payment which are returned by cashier.
   * This field is populated for external payments that are charged by invoices via AddPayment endpoint as well.
   */
  transactionId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesInvoicesPaymentsInput = {
  payments?: InputMaybe<Array<InputMaybe<ComWixpressQuotesInvoicesPaymentInput>>>;
};

export type ComWixpressQuotesItemizedFeeInput = {
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressQuotesLineItemInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** The line-item level metadata. */
  metadata?: InputMaybe<ComWixpressQuotesLineItemMetaDataInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  quantity?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  /** The source of the line item */
  source?: InputMaybe<WixCrmCommonSourceInput>;
  taxedTotal?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  taxes?: InputMaybe<Array<InputMaybe<ComWixpressQuotesLineItemTaxInput>>>;
};

export type ComWixpressQuotesLineItemMetaDataInput = {
  metadata?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressQuotesLineItemTaxInput = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressQuotesLineItemsInput = {
  lineItems?: InputMaybe<Array<InputMaybe<ComWixpressQuotesLineItemInput>>>;
};

export type ComWixpressQuotesLocaleInput = {
  /** An ISO 3166 alpha-2 country code or a UN M.49 numeric-3 area code. */
  country?: InputMaybe<Scalars['String']>;
  invariant?: InputMaybe<Scalars['String']>;
  /** ISO 639 alpha-2 or alpha-3 language code, or a language subtag */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesMetaDataInput = {
  /** Optional indicator whether to allow editing of the invoice by other applications other than the source. Default is true. */
  allowEditByOthers?: InputMaybe<Scalars['Boolean']>;
  legalTerms?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceProperties?: InputMaybe<Scalars['JSON']>;
  sourceRefId?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesPhoneInput = {
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesTotalPriceInput = {
  discountAmount?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  fees?: InputMaybe<Array<InputMaybe<ComWixpressQuotesItemizedFeeInput>>>;
  /** the subtotal of the line items without the tax reduction */
  subtotal?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  taxedAmount?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  /** the total price taking into account the itemized fees and the taxes */
  total?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressRestHeadersEntry = {
  __typename?: 'ComWixpressRestHeadersEntry';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ComWixpressRestRawHttpResponse = {
  __typename?: 'ComWixpressRestRawHttpResponse';
  body?: Maybe<Array<Maybe<Scalars['Byte']>>>;
  headers?: Maybe<Array<Maybe<ComWixpressRestHeadersEntry>>>;
  statusCode?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsRequestInput = {
  /** Item Label IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonBulkActionMetadata>;
  /** Information about the deleted labels. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResult>>>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResult = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResult';
  /** Metadata for labels deletion. */
  itemMetadata?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1CloneLabelsRequestInput = {
  /** The MetaSiteId to clone from. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1CountLabelsRequestInput = {
  /** Filter for counting labels. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1CountLabelsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1CountLabelsResponse';
  /** Counted labels. */
  count?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1CreateLabelRequestInput = {
  /** Item label details. */
  label?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1LabelInput>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1CreateLabelResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1CreateLabelResponse';
  /** Item label. */
  label?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1DeleteLabelRequestInput = {
  /** ID of the item label. */
  labelId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfo = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfo';
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this item label was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfoInput = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this item label was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1GetLabelRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressRestaurantsMenusItemLabelsV1Label = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1Label';
  /** Date and time the item label was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfo>;
  /** Item label icon. */
  icon?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImage>;
  /** Item label ID. */
  id?: Maybe<Scalars['String']>;
  /** Item label name. */
  name?: Maybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the item label is updated. To prevent conflicting changes, the current revision must be passed when updating the item label. Ignored when creating a item label. */
  revision?: Maybe<Scalars['Long']>;
  /** Date and time the item label was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1LabelInput = {
  /** Date and time the item label was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfoInput>;
  /** Item label icon. */
  icon?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImageInput>;
  /** Item label ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Item label name. */
  name?: InputMaybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the item label is updated. To prevent conflicting changes, the current revision must be passed when updating the item label. Ignored when creating a item label. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the item label was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1ListLabelsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1ListLabelsResponse';
  /** Retrieved item labels. */
  labels?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>>>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1QueryLabelsRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1QueryLabelsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1QueryLabelsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpdateLabelRequestInput = {
  /** Item label to update. */
  label?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1LabelInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpdateLabelResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1UpdateLabelResponse';
  /** Updated item label. */
  label?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonBulkActionMetadata = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonBulkActionMetadata';
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImage = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImage';
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonItemMetadata = {
  __typename?: 'ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonItemMetadata';
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusItemV1BulkCreateItemResult = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1BulkCreateItemResult';
  /** Created item. */
  item?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1BulkCreateItemsRequestInput = {
  /** Items details. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1ItemInput>>>;
  /** Whether to return entity in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1BulkCreateItemsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1BulkCreateItemsResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created items. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1BulkCreateItemResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkDeleteItemResult = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1BulkDeleteItemResult';
  /** Metadata for item delete. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1BulkDeleteItemsRequestInput = {
  /** Item IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1BulkDeleteItemsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1BulkDeleteItemsResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the deleted items. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1BulkDeleteItemResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = {
  itemIdLocationIds?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1ItemIdLocationIdsInput>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponse';
  /** Information about the updated items. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsRequestInput = {
  /** Business Location Ids. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** item ids */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponse';
  /** Information about the updated items. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestInput = {
  /** Items to update. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestMaskedItemInput>>>;
  /** Whether to return entity in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestMaskedItemInput = {
  /** Item to update. */
  item?: InputMaybe<ComWixpressRestaurantsMenusItemV1ItemInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the updated items. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponseBulkItemResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponseBulkItemResult = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponseBulkItemResult';
  /** Updated item. Only returned if `returnEntity` is set to `true`. */
  item?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1CloneItemsRequestInput = {
  /** The MetaSiteId to clone from. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1CountItemsRequestInput = {
  /** Filter for counting items. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Search details. */
  searchDetails?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput>;
};

export type ComWixpressRestaurantsMenusItemV1CountItemsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1CountItemsResponse';
  /** Counted items. */
  count?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemV1CreateItemRequestInput = {
  /** Item details. */
  item?: InputMaybe<ComWixpressRestaurantsMenusItemV1ItemInput>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1CreateItemResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1CreateItemResponse';
  /** Item. */
  item?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
};

export type ComWixpressRestaurantsMenusItemV1DeleteItemRequestInput = {
  /** Item ID. */
  itemId?: InputMaybe<Scalars['String']>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromModifierGroupsInput = {
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifierGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromVariantsInput = {
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemV1ExternalReferenceInfo = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1ExternalReferenceInfo';
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this item was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1ExternalReferenceInfoInput = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this item was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1GetItemRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressRestaurantsMenusItemV1Item = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1Item';
  /** Additional item images. */
  additionalImages?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage>>>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these items are available. */
  businessLocationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Date and time the item was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Item description. */
  description?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<ComWixpressRestaurantsMenusItemV1ExternalReferenceInfo>;
  /**
   * Whether the item is marked as featured/best seller.
   * Default: `false`.
   */
  featured?: Maybe<Scalars['Boolean']>;
  /** Item ID. */
  id?: Maybe<Scalars['String']>;
  /** Main item image. */
  image?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage>;
  /** Item labels. */
  labels?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1Label>>>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these items are available. */
  locations?: Maybe<ComWixpressLocationsQueryLocationsResponse>;
  /** Item modifier groups. */
  modifierGroups?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1ModifierGroup>>>;
  /** Item name. */
  name?: Maybe<Scalars['String']>;
  oloMigrationItemId?: Maybe<Scalars['String']>;
  /** Online order settings. */
  orderSettings?: Maybe<ComWixpressRestaurantsMenusItemV1OrderSettings>;
  /** Item price info. */
  priceInfo?: Maybe<ComWixpressRestaurantsMenusItemV1PriceInfo>;
  /** Item price variants. */
  priceVariants?: Maybe<ComWixpressRestaurantsMenusItemV1PriceVariants>;
  /** Revision number, which increments by 1 each time the item is updated. To prevent conflicting changes, the current revision must be passed when updating the item. Ignored when creating a item. */
  revision?: Maybe<Scalars['Long']>;
  sectionsVirtualReference?: Maybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse>;
  /** Date and time the item was updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Whether the item is visible in the menu for site visitors. */
  visible?: Maybe<Scalars['Boolean']>;
};


export type ComWixpressRestaurantsMenusItemV1ItemLocationsArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsQueryLocationsRequestInput>;
};


export type ComWixpressRestaurantsMenusItemV1ItemSectionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput>;
};

export type ComWixpressRestaurantsMenusItemV1ItemIdLocationIdsInput = {
  /** Business Location IDs */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** item ID */
  itemId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1ItemInput = {
  /** Additional item images. */
  additionalImages?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput>>>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these items are available. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Date and time the item was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Item description. */
  description?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<ComWixpressRestaurantsMenusItemV1ExternalReferenceInfoInput>;
  /**
   * Whether the item is marked as featured/best seller.
   * Default: `false`.
   */
  featured?: InputMaybe<Scalars['Boolean']>;
  /** Item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Main item image. */
  image?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput>;
  /** Item labels. */
  labels?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1LabelInput>>>;
  /** Item modifier groups. */
  modifierGroups?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1ModifierGroupInput>>>;
  /** Item name. */
  name?: InputMaybe<Scalars['String']>;
  oloMigrationItemId?: InputMaybe<Scalars['String']>;
  /** Online order settings. */
  orderSettings?: InputMaybe<ComWixpressRestaurantsMenusItemV1OrderSettingsInput>;
  /** Item price info. */
  priceInfo?: InputMaybe<ComWixpressRestaurantsMenusItemV1PriceInfoInput>;
  /** Item price variants. */
  priceVariants?: InputMaybe<ComWixpressRestaurantsMenusItemV1PriceVariantsInput>;
  /** Revision number, which increments by 1 each time the item is updated. To prevent conflicting changes, the current revision must be passed when updating the item. Ignored when creating a item. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the item was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Whether the item is visible in the menu for site visitors. */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusItemV1Label = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1Label';
  /** Item label ID. */
  id?: Maybe<Scalars['String']>;
  /** Item label ID. */
  label?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>;
};

export type ComWixpressRestaurantsMenusItemV1LabelInput = {
  /** Item label ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1ListItemsRequestInput = {
  /** Item IDs. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to return only items that are visible to site visitors. */
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
  /** The metadata of the paginated results. */
  paging?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput>;
};

export type ComWixpressRestaurantsMenusItemV1ListItemsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1ListItemsResponse';
  /** Items. */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1Item>>>;
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1ModifierGroup = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1ModifierGroup';
  /** Modifier group ID. */
  id?: Maybe<Scalars['String']>;
  /** Modifier group ID. */
  modifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
};

export type ComWixpressRestaurantsMenusItemV1ModifierGroupInput = {
  /** Modifier group ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1OrderSettings = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1OrderSettings';
  /**
   * Whether a customer can add a special request when ordering this item.
   * Default: `true`.
   */
  acceptSpecialRequests?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the item is in stock.
   * Default: `true`.
   */
  inStock?: Maybe<Scalars['Boolean']>;
  /** E-com defined tax group for the product. */
  taxGroupId?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1OrderSettingsInput = {
  /**
   * Whether a customer can add a special request when ordering this item.
   * Default: `true`.
   */
  acceptSpecialRequests?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the item is in stock.
   * Default: `true`.
   */
  inStock?: InputMaybe<Scalars['Boolean']>;
  /** E-com defined tax group for the product. */
  taxGroupId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1PriceInfo = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1PriceInfo';
  /** Formatted price. */
  formattedPrice?: Maybe<Scalars['String']>;
  /** Price. */
  price?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1PriceInfoInput = {
  /** Formatted price. */
  formattedPrice?: InputMaybe<Scalars['String']>;
  /** Price. */
  price?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1PriceVariant = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1PriceVariant';
  /**
   * Price of a variant.
   * @deprecated Price of a variant. Replaced by: pricing.price_variants.variants.price_info. Removal date: 2024-08-01.
   */
  price?: Maybe<Scalars['String']>;
  /** Price info of a variant. */
  priceInfo?: Maybe<ComWixpressRestaurantsMenusItemV1PriceInfo>;
  /** Price variant ID. */
  variant?: Maybe<WixRestaurantsMenusItemVariantV1Variant>;
  /** Price variant ID. */
  variantId?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1PriceVariantInput = {
  /** Price info of a variant. */
  priceInfo?: InputMaybe<ComWixpressRestaurantsMenusItemV1PriceInfoInput>;
  /** Price variant ID. */
  variantId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1PriceVariants = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1PriceVariants';
  /** List of price variants. */
  variants?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1PriceVariant>>>;
};

export type ComWixpressRestaurantsMenusItemV1PriceVariantsInput = {
  /** List of price variants. */
  variants?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1PriceVariantInput>>>;
};

export type ComWixpressRestaurantsMenusItemV1QueryItemsRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixpressRestaurantsMenusItemV1QueryItemsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1QueryItemsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1Item>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemRequestInput = {
  /** Business location ids to duplicate the item to. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item id to be duplicated. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemResponse';
  itemId?: Maybe<Array<Maybe<Scalars['String']>>>;
  items?: Maybe<ComWixpressRestaurantsMenusItemV1QueryItemsResponse>;
};


export type ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemResponseItemsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemV1QueryItemsRequestInput>;
};

export type ComWixpressRestaurantsMenusItemV1SearchItemsRequestInput = {
  /** Search options. */
  search?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorSearchInput>;
};

export type ComWixpressRestaurantsMenusItemV1SearchItemsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1SearchItemsResponse';
  /** The metadata of the search results. */
  aggregationData?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationData>;
  /** Retrieved items. */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1Item>>>;
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1UpdateItemRequestInput = {
  /** Item to update. */
  item?: InputMaybe<ComWixpressRestaurantsMenusItemV1ItemInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1UpdateItemResponse = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1UpdateItemResponse';
  /** Updated item. */
  item?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationData = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationData';
  /** List of the aggregated data results. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResults>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResults = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResults';
  /** Aggregation name, returned in `aggregations.results.name`. */
  name?: Maybe<Scalars['String']>;
  /** Range aggregation results. */
  ranges?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation to perform. Must align with the corresponding aggregation field. */
  type?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults';
  /** List of ranges returned in the same order as requested. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult';
  /** Total number of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult';
  /** Type of scalar aggregation. */
  type?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonScalarType>;
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResults = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResults';
  /** List of value aggregations. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult';
  /** Number of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationInput = {
  /** Field to aggreg   ate by. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Aggregation name, returned in `aggregations.results.name`. */
  name?: InputMaybe<Scalars['String']>;
  /** A range aggregation calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. For example, use a range aggregation to compare the number of reservations made for parties of 4 or less to the number of reservations made for parties with 5 or more. */
  range?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationInput>;
  /** A scalar aggregation calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  scalar?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation to perform. Must align with the corresponding aggregation field. */
  type?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationType>;
  /** A value aggregation calculates metrics such as count for specific fields within a dataset, providing insights into the overall distribution and key statistics of those values. For example, use a value aggregation to get the number (count) of products for each price listed in the store. */
  value?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationInput>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationInput = {
  /** List of range buckets. During aggregation each entity is placed in the first bucket its value falls into, based on the provided range bounds. */
  buckets?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = {
  /** Inclusive lower bound of the range. Required if `to` is not provided. */
  from?: InputMaybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. Required if `from` is not provided. */
  to?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationScalarAggregationInput = {
  /** Type of scalar aggregation. */
  type?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonScalarType>;
};

export enum ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationType {
  /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
  Range = 'RANGE',
  /** Calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  Scalar = 'SCALAR',
  UnknownAggregationType = 'UNKNOWN_AGGREGATION_TYPE',
  /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
  Value = 'VALUE'
}

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationInput = {
  /**
   * Number of aggregation results to return.
   * Min: `1`
   * Max: `250`
   * Default: `10`
   */
  limit?: InputMaybe<Scalars['Int']>;
  /** Sort direction. */
  sortDirection?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationSortDirection>;
  /** Sort type. */
  sortType?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationSortType>;
};

export enum ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationSortDirection {
  /** Ascending order. */
  Asc = 'ASC',
  /** Descending order. */
  Desc = 'DESC'
}

export enum ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationSortType {
  /** Number of matches in the results. */
  Count = 'COUNT',
  /** Alphabetically by the field value. */
  Value = 'VALUE'
}

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorSearchInput = {
  /** Logical groupings of data into facets, with summaries for each facet. For example, use aggregations to allow site visitors to narrow down their search results by selecting specific categories. */
  aggregations?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationInput>>>;
  /**
   * Cursor paging options.
   *
   * Learn more about cursor paging ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language#cursor-paging) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging)).
   */
  cursorPaging?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about filtering ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language#the-filter-object) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters)).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Free text to match in searchable fields. */
  search?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput>;
  /**
   * Sort object.
   *
   * Learn more about sorting ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language#the-sort-array) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#sorting)).
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursors = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage = {
  __typename?: 'ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage';
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export enum ComWixpressRestaurantsMenusItemV1UpstreamWixCommonScalarType {
  /** Average of values. */
  Avg = 'AVG',
  /** Total number of distinct values. */
  CountDistinct = 'COUNT_DISTINCT',
  /** Maximum value. */
  Max = 'MAX',
  /** Minimum value. */
  Min = 'MIN',
  /** Sum of values. */
  Sum = 'SUM',
  UnknownScalarType = 'UNKNOWN_SCALAR_TYPE'
}

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput = {
  /** Search term or expression. */
  expression?: InputMaybe<Scalars['String']>;
  /** Fields to search in. If the array is empty, all searchable fields are searched. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to enable the search function to use an algorithm to automatically find results that are close to the search expression, such as typos and declensions. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Search mode. Defines the search logic for combining multiple terms in the `expression`. */
  mode?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsMode>;
};

export enum ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsMode {
  /** All search terms must be present. */
  And = 'AND',
  /** At least one of the search terms must be present. */
  Or = 'OR'
}

export type ComWixpressRestaurantsMenusMenuV1BulkCreateMenuResult = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1BulkCreateMenuResult';
  /** Created menu. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
  /** Whether to receive the created menus in the response. */
  menuMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkCreateMenusRequestInput = {
  /** Menu details. */
  menus?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusMenuV1MenuInput>>>;
  /** Whether to receive the created menus in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkCreateMenusResponse = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1BulkCreateMenusResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created menus. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1BulkCreateMenuResult>>>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestInput = {
  /** Menus to update. */
  menus?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestMaskedMenuInput>>>;
  /** Whether to receive the entity in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestMaskedMenuInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Menu to updated. */
  menu?: InputMaybe<ComWixpressRestaurantsMenusMenuV1MenuInput>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponse = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Results of bulk menu update. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponseBulkMenuResult>>>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponseBulkMenuResult = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponseBulkMenuResult';
  /** Updated menu. Only returned if `returnEntity` is set to `true`. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
  /** Metadata for menu update. */
  menuMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusMenuV1CloneMenusRequestInput = {
  /** The MetaSiteId to clone from. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusMenuV1CreateMenuRequestInput = {
  /** Menu details. */
  menu?: InputMaybe<ComWixpressRestaurantsMenusMenuV1MenuInput>;
};

export type ComWixpressRestaurantsMenusMenuV1CreateMenuResponse = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1CreateMenuResponse';
  /** Menu. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
};

export type ComWixpressRestaurantsMenusMenuV1DeleteMenuRequestInput = {
  /** Menu ID. */
  menuId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusMenuV1DeleteOrphanSectionsInput = {
  /** Menu id */
  menuId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusMenuV1GetMenuRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressRestaurantsMenusMenuV1GetMenuResponse = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1GetMenuResponse';
  /** Menu. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
};

export type ComWixpressRestaurantsMenusMenuV1ListMenusRequestInput = {
  /** Menu IDs. */
  menuIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The metadata of the paginated results. */
  paging?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput>;
};

export type ComWixpressRestaurantsMenusMenuV1ListMenusResponse = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1ListMenusResponse';
  /** Retrieved menus. */
  menus?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1Menu>>>;
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressRestaurantsMenusMenuV1Menu = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1Menu';
  /** Date and time the menu was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Menu description. */
  description?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Menu ID. */
  id?: Maybe<Scalars['String']>;
  /** Menu name. */
  name?: Maybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the menu is updated. To prevent conflicting changes, the current revision must be passed when updating the menu. Ignored when creating a menu. */
  revision?: Maybe<Scalars['Long']>;
  /** Menu section IDs. */
  sectionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Menu section IDs. */
  sections?: Maybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse>;
  /** Date and time the menu was updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Part of the site URL, that redirects to the menu. For example, in the URL `www.mywebsite.com/our-menus/dinner-menu`, `dinner-menu` is the field value. */
  urlQueryParam?: Maybe<Scalars['String']>;
  /** Is the menu visible to site visitors. */
  visible?: Maybe<Scalars['Boolean']>;
};


export type ComWixpressRestaurantsMenusMenuV1MenuSectionsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput>;
};

export type ComWixpressRestaurantsMenusMenuV1MenuInput = {
  /** Date and time the menu was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Menu description. */
  description?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Menu ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Menu name. */
  name?: InputMaybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the menu is updated. To prevent conflicting changes, the current revision must be passed when updating the menu. Ignored when creating a menu. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Menu section IDs. */
  sectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Date and time the menu was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Part of the site URL, that redirects to the menu. For example, in the URL `www.mywebsite.com/our-menus/dinner-menu`, `dinner-menu` is the field value. */
  urlQueryParam?: InputMaybe<Scalars['String']>;
  /** Is the menu visible to site visitors. */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1QueryMenusRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixpressRestaurantsMenusMenuV1QueryMenusResponse = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1QueryMenusResponse';
  /** Retrieved menus. */
  menus?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1Menu>>>;
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlRequestInput = {
  /** Menu ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether the full Menu entity is returned. Defaults to `false`. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlResponse = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlResponse';
  /** Retrieved menuInfo with path url. */
  menuSiteUrl?: Maybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlRequestInput = {
  /** The query by which to select menus. */
  paging?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput>;
  /** Whether the full Menu entity is returned. Defaults to `false`. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlResponse = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlResponse';
  /** The retrieved menu site info. */
  menusSiteUrls?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl>>>;
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl';
  /** Menu ID. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
  /** Menu ID. */
  menuId?: Maybe<Scalars['String']>;
  /** Path URL. */
  path?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlRequestInput = {
  /** Query options */
  query?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlResponse = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1Menu>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressRestaurantsMenusMenuV1UpdateExtendedFieldsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1UpdateExtendedFieldsResponse';
  /** Namespace of the app. */
  namespace?: Maybe<Scalars['String']>;
  /** Updated extended fields data. */
  namespaceData?: Maybe<Scalars['JSON']>;
};

export type ComWixpressRestaurantsMenusMenuV1UpdateMenuRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Menu to update. */
  menu?: InputMaybe<ComWixpressRestaurantsMenusMenuV1MenuInput>;
};

export type ComWixpressRestaurantsMenusMenuV1UpdateMenuResponse = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1UpdateMenuResponse';
  /** Updated menu. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
};

export type ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursors = {
  __typename?: 'ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkCreateSectionResult = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1BulkCreateSectionResult';
  /** Created section. Only returned if `returnEntity` is set to `true`. */
  item?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
  /** Metadata for created sections. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkCreateSectionsRequestInput = {
  /** Whether to receive the created sections in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Sections details. */
  sections?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusSectionV1SectionInput>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkCreateSectionsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1BulkCreateSectionsResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created sections. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1BulkCreateSectionResult>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionResult = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionResult';
  /** Metadata for deleted sections. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsRequestInput = {
  /** Section IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the deleted sections. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionResult>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdRequestInput = {
  /** Business Location Id. */
  businessLocationId?: InputMaybe<Scalars['String']>;
  /** section ids */
  sectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponse = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponse';
  /** Information about the updated sections. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponseBulkItemResult>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponseBulkItemResult = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestInput = {
  /** Whether to receive the updated sections in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Sections to update. */
  sections?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestMaskedSectionInput>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestMaskedSectionInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Section update. */
  section?: InputMaybe<ComWixpressRestaurantsMenusSectionV1SectionInput>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponse = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the updated sections. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponseBulkSectionResult>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponseBulkSectionResult = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponseBulkSectionResult';
  /** Updated section. Only returned if `returnEntity` is set to `true`. */
  section?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
  /** Whether to receive the updated sections in the response. */
  sectionMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusSectionV1CloneSectionsRequestInput = {
  /** The MetaSiteId to clone from. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1CreateSectionRequestInput = {
  /** Section details. */
  section?: InputMaybe<ComWixpressRestaurantsMenusSectionV1SectionInput>;
};

export type ComWixpressRestaurantsMenusSectionV1CreateSectionResponse = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1CreateSectionResponse';
  /** Section. */
  section?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
};

export type ComWixpressRestaurantsMenusSectionV1DeleteLocationIdFromItemsInput = {
  businessLocationId?: InputMaybe<Scalars['String']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusSectionV1DeleteOrphanItemsInput = {
  sectionId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1DeleteSectionRequestInput = {
  /** Section ID. */
  sectionId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1ExternalReferenceInfo = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1ExternalReferenceInfo';
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this section was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1ExternalReferenceInfoInput = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this section was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1GetSectionRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressRestaurantsMenusSectionV1ListSectionsRequestInput = {
  /** Whether to return only sections that are visible to site visitors. */
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
  /** The metadata of the paginated results. */
  paging?: InputMaybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput>;
  /** Section IDs. */
  sectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusSectionV1ListSectionsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1ListSectionsResponse';
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingMetadata>;
  /** Retrieved sections. */
  sections?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1Section>>>;
};

export type ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1Section>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionRequestInput = {
  /** Business location ids to duplicate the section to. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Indicates whether sub-entities (such as items) should be duplicated as well. */
  duplicateSubEntities?: InputMaybe<Scalars['Boolean']>;
  /** Section id to be duplicated. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionResponse = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionResponse';
  sectionId?: Maybe<Array<Maybe<Scalars['String']>>>;
  sections?: Maybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse>;
};


export type ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionResponseSectionsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput>;
};

export type ComWixpressRestaurantsMenusSectionV1Section = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1Section';
  /** Additional section images. */
  additionalImages?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage>>>;
  /** ID of the business location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where this section is available. */
  businessLocationId?: Maybe<Scalars['String']>;
  /** Date and time the section was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Section description. */
  description?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<ComWixpressRestaurantsMenusSectionV1ExternalReferenceInfo>;
  /** Section ID. */
  id?: Maybe<Scalars['String']>;
  /** Main section image. */
  image?: Maybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage>;
  /** Item IDs. */
  itemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Item IDs. */
  items?: Maybe<ComWixpressRestaurantsMenusItemV1QueryItemsResponse>;
  /** ID of the business location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where this section is available. */
  location?: Maybe<ComWixpressLocationsLocation>;
  menusVirtualReference?: Maybe<ComWixpressRestaurantsMenusMenuV1QueryMenusResponse>;
  /** Section name. */
  name?: Maybe<Scalars['String']>;
  oloMigrationSectionId?: Maybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the section is updated. To prevent conflicting changes, the current revision must be passed when updating the section. Ignored when creating a section. */
  revision?: Maybe<Scalars['Long']>;
  /** Date and time the section was updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Whether the section is visible in the menu for site visitors. */
  visible?: Maybe<Scalars['Boolean']>;
};


export type ComWixpressRestaurantsMenusSectionV1SectionItemsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemV1QueryItemsRequestInput>;
};


export type ComWixpressRestaurantsMenusSectionV1SectionMenusVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusMenuV1QueryMenusRequestInput>;
};

export type ComWixpressRestaurantsMenusSectionV1SectionInput = {
  /** Additional section images. */
  additionalImages?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput>>>;
  /** ID of the business location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where this section is available. */
  businessLocationId?: InputMaybe<Scalars['String']>;
  /** Date and time the section was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Section description. */
  description?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<ComWixpressRestaurantsMenusSectionV1ExternalReferenceInfoInput>;
  /** Section ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Main section image. */
  image?: InputMaybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput>;
  /** Item IDs. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Section name. */
  name?: InputMaybe<Scalars['String']>;
  oloMigrationSectionId?: InputMaybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the section is updated. To prevent conflicting changes, the current revision must be passed when updating the section. Ignored when creating a section. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the section was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Whether the section is visible in the menu for site visitors. */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusSectionV1UpdateSectionRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Section update. */
  section?: InputMaybe<ComWixpressRestaurantsMenusSectionV1SectionInput>;
};

export type ComWixpressRestaurantsMenusSectionV1UpdateSectionResponse = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1UpdateSectionResponse';
  /** Updated section. */
  section?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursors = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage = {
  __typename?: 'ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage';
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressSitepropertiesApiV4Address = {
  __typename?: 'ComWixpressSitepropertiesApiV4Address';
  /** Apartment number. */
  apartmentNumber?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Geographic coordinates of location. */
  coordinates?: Maybe<ComWixpressSitepropertiesApiV4GeoCoordinates>;
  /** Two-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: Maybe<Scalars['String']>;
  /** Google-formatted version of this address. */
  googleFormattedAddress?: Maybe<Scalars['String']>;
  /** Extra information to be displayed in the address. */
  hint?: Maybe<ComWixpressSitepropertiesApiV4AddressHint>;
  /** Whether this address represents a physical location. */
  isPhysical?: Maybe<Scalars['Boolean']>;
  /** State. */
  state?: Maybe<Scalars['String']>;
  /** Street name. */
  street?: Maybe<Scalars['String']>;
  /** Street number. */
  streetNumber?: Maybe<Scalars['String']>;
  /** Zip or postal code. */
  zip?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4AddressHint = {
  __typename?: 'ComWixpressSitepropertiesApiV4AddressHint';
  /** Where the extra text should be displayed. */
  placement?: Maybe<ComWixpressSitepropertiesApiV4PlacementType>;
  /** Extra text displayed next to, or instead of, the actual address. */
  text?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4AddressHintInput = {
  /** Where the extra text should be displayed. */
  placement?: InputMaybe<ComWixpressSitepropertiesApiV4PlacementType>;
  /** Extra text displayed next to, or instead of, the actual address. */
  text?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4AddressInput = {
  /** Apartment number. */
  apartmentNumber?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Geographic coordinates of location. */
  coordinates?: InputMaybe<ComWixpressSitepropertiesApiV4GeoCoordinatesInput>;
  /** Two-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Google-formatted version of this address. */
  googleFormattedAddress?: InputMaybe<Scalars['String']>;
  /** Extra information to be displayed in the address. */
  hint?: InputMaybe<ComWixpressSitepropertiesApiV4AddressHintInput>;
  /** Whether this address represents a physical location. */
  isPhysical?: InputMaybe<Scalars['Boolean']>;
  /** State. */
  state?: InputMaybe<Scalars['String']>;
  /** Street name. */
  street?: InputMaybe<Scalars['String']>;
  /** Street number. */
  streetNumber?: InputMaybe<Scalars['String']>;
  /** Zip or postal code. */
  zip?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4BulkPropertiesReadRequestInput = {
  /** Site IDs. */
  sites?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4BulkPropertiesReadResponse = {
  __typename?: 'ComWixpressSitepropertiesApiV4BulkPropertiesReadResponse';
  /** The ID of the resolved MetaSite for the request. */
  sites?: Maybe<ComWixpressSitepropertiesApiV4PropertiesReadResponse>;
};

export type ComWixpressSitepropertiesApiV4BusinessContactDataInput = {
  /** Publicly-available business address. */
  address?: InputMaybe<ComWixpressSitepropertiesApiV4AddressInput>;
  /** Publicly-available business email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Publicly-available business fax number. */
  fax?: InputMaybe<Scalars['String']>;
  /** Publicly-available business phone number. */
  phone?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4BusinessProfileDataInput = {
  /** Business name. */
  businessName?: InputMaybe<Scalars['String']>;
  /** Site description. */
  description?: InputMaybe<Scalars['String']>;
  /** Path to the site's logo in Wix Media (without Wix Media base URL). */
  logo?: InputMaybe<Scalars['String']>;
  /** Site display name. */
  siteDisplayName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4BusinessSchedule = {
  __typename?: 'ComWixpressSitepropertiesApiV4BusinessSchedule';
  /** Weekly recurring time periods when the business is regularly open or the service is available. Limited to 100 time periods. */
  periods?: Maybe<Array<Maybe<ComWixpressSitepropertiesApiV4TimePeriod>>>;
  /** Exceptions to the business's regular hours. The business can be open or closed during the exception. */
  specialHourPeriod?: Maybe<Array<Maybe<ComWixpressSitepropertiesApiV4SpecialHourPeriod>>>;
};

export type ComWixpressSitepropertiesApiV4BusinessScheduleInput = {
  /** Weekly recurring time periods when the business is regularly open or the service is available. Limited to 100 time periods. */
  periods?: InputMaybe<Array<InputMaybe<ComWixpressSitepropertiesApiV4TimePeriodInput>>>;
  /** Exceptions to the business's regular hours. The business can be open or closed during the exception. */
  specialHourPeriod?: InputMaybe<Array<InputMaybe<ComWixpressSitepropertiesApiV4SpecialHourPeriodInput>>>;
};

export type ComWixpressSitepropertiesApiV4Categories = {
  __typename?: 'ComWixpressSitepropertiesApiV4Categories';
  /** Business Term Id */
  businessTermId?: Maybe<Scalars['String']>;
  /** Primary site category. */
  primary?: Maybe<Scalars['String']>;
  /** Secondary site category. */
  secondary?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4CategoriesInput = {
  /** Business Term Id */
  businessTermId?: InputMaybe<Scalars['String']>;
  /** Primary site category. */
  primary?: InputMaybe<Scalars['String']>;
  /** Secondary site category. */
  secondary?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4ChangeContextInput = {
  /** Properties were updated. */
  propertiesChange?: InputMaybe<Scalars['Void']>;
  /** Properties were cloned on site cloning. */
  siteCloned?: InputMaybe<ComWixpressSitepropertiesApiV4SiteClonedInput>;
  /** Default properties were created on site creation. */
  siteCreated?: InputMaybe<ComWixpressSitepropertiesApiV4SiteCreatedInput>;
};

export type ComWixpressSitepropertiesApiV4ConsentPolicy = {
  __typename?: 'ComWixpressSitepropertiesApiV4ConsentPolicy';
  /** Whether the site uses cookies that collect information allowing better customization of the experience for a current visitor. */
  advertising?: Maybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that collect analytics about how the site is used (in order to improve it). */
  analytics?: Maybe<Scalars['Boolean']>;
  /** CCPA compliance flag. */
  dataToThirdParty?: Maybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that are essential to site operation. Always `true`. */
  essential?: Maybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that affect site performance and other functional measurements. */
  functional?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressSitepropertiesApiV4ConsentPolicyInput = {
  /** Whether the site uses cookies that collect information allowing better customization of the experience for a current visitor. */
  advertising?: InputMaybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that collect analytics about how the site is used (in order to improve it). */
  analytics?: InputMaybe<Scalars['Boolean']>;
  /** CCPA compliance flag. */
  dataToThirdParty?: InputMaybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that are essential to site operation. Always `true`. */
  essential?: InputMaybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that affect site performance and other functional measurements. */
  functional?: InputMaybe<Scalars['Boolean']>;
};

export enum ComWixpressSitepropertiesApiV4DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type ComWixpressSitepropertiesApiV4GeoCoordinates = {
  __typename?: 'ComWixpressSitepropertiesApiV4GeoCoordinates';
  /** Latitude of the location. Must be between -90 and 90. */
  latitude?: Maybe<Scalars['Float']>;
  /** Longitude of the location. Must be between -180 and 180. */
  longitude?: Maybe<Scalars['Float']>;
};

export type ComWixpressSitepropertiesApiV4GeoCoordinatesInput = {
  /** Latitude of the location. Must be between -90 and 90. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Longitude of the location. Must be between -180 and 180. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressSitepropertiesApiV4Locale = {
  __typename?: 'ComWixpressSitepropertiesApiV4Locale';
  /** Two-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements) format. */
  country?: Maybe<Scalars['String']>;
  /** Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format. */
  languageCode?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4LocaleInput = {
  /** Two-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format. */
  languageCode?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4Multilingual = {
  __typename?: 'ComWixpressSitepropertiesApiV4Multilingual';
  /** Whether to redirect to user language. */
  autoRedirect?: Maybe<Scalars['Boolean']>;
  /** Supported languages list. */
  supportedLanguages?: Maybe<Array<Maybe<ComWixpressSitepropertiesApiV4SupportedLanguage>>>;
};

export type ComWixpressSitepropertiesApiV4MultilingualInput = {
  /** Whether to redirect to user language. */
  autoRedirect?: InputMaybe<Scalars['Boolean']>;
  /** Supported languages list. */
  supportedLanguages?: InputMaybe<Array<InputMaybe<ComWixpressSitepropertiesApiV4SupportedLanguageInput>>>;
};

export enum ComWixpressSitepropertiesApiV4PlacementType {
  After = 'AFTER',
  Before = 'BEFORE',
  Replace = 'REPLACE'
}

export type ComWixpressSitepropertiesApiV4Properties = {
  __typename?: 'ComWixpressSitepropertiesApiV4Properties';
  /** Address. */
  address?: Maybe<ComWixpressSitepropertiesApiV4Address>;
  /**
   * Supported values: `FITNESS SERVICE`, `RESTAURANT`, `BLOG`, `STORE`, `EVENT`, `UNKNOWN`.
   *
   * Site business type.
   */
  businessConfig?: Maybe<Scalars['String']>;
  /** Business name. */
  businessName?: Maybe<Scalars['String']>;
  /**
   * Business schedule. Regular and exceptional time periods when the business is open or the service is available.
   *
   * __Note:__ Not supported by Wix Bookings.
   */
  businessSchedule?: Maybe<ComWixpressSitepropertiesApiV4BusinessSchedule>;
  /** Site categories. */
  categories?: Maybe<ComWixpressSitepropertiesApiV4Categories>;
  /** Cookie policy the Wix user defined for their site (before the site visitor interacts with/limits it). */
  consentPolicy?: Maybe<ComWixpressSitepropertiesApiV4ConsentPolicy>;
  /** Site description. */
  description?: Maybe<Scalars['String']>;
  /** Email address. */
  email?: Maybe<Scalars['String']>;
  /** External site URL that uses Wix as its headless business solution. */
  externalSiteUrl?: Maybe<Scalars['String']>;
  /** Fax number. */
  fax?: Maybe<Scalars['String']>;
  /**
   * Site language.
   *
   * Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Site locale. */
  locale?: Maybe<ComWixpressSitepropertiesApiV4Locale>;
  /** Path to the site's logo in Wix Media (without Wix Media base URL). */
  logo?: Maybe<Scalars['String']>;
  /** Supported languages of a site and the primary language. */
  multilingual?: Maybe<ComWixpressSitepropertiesApiV4Multilingual>;
  /**
   * Site currency format used to bill customers.
   *
   * Three-letter currency code in [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format.
   */
  paymentCurrency?: Maybe<Scalars['String']>;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /** Site display name. */
  siteDisplayName?: Maybe<Scalars['String']>;
  /** Timezone in `America/New_York` format. */
  timeZone?: Maybe<Scalars['String']>;
  /** Track clicks analytics. */
  trackClicksAnalytics?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressSitepropertiesApiV4PropertiesInput = {
  /** Address. */
  address?: InputMaybe<ComWixpressSitepropertiesApiV4AddressInput>;
  /**
   * Supported values: `FITNESS SERVICE`, `RESTAURANT`, `BLOG`, `STORE`, `EVENT`, `UNKNOWN`.
   *
   * Site business type.
   */
  businessConfig?: InputMaybe<Scalars['String']>;
  /** Business name. */
  businessName?: InputMaybe<Scalars['String']>;
  /**
   * Business schedule. Regular and exceptional time periods when the business is open or the service is available.
   *
   * __Note:__ Not supported by Wix Bookings.
   */
  businessSchedule?: InputMaybe<ComWixpressSitepropertiesApiV4BusinessScheduleInput>;
  /** Site categories. */
  categories?: InputMaybe<ComWixpressSitepropertiesApiV4CategoriesInput>;
  /** Cookie policy the Wix user defined for their site (before the site visitor interacts with/limits it). */
  consentPolicy?: InputMaybe<ComWixpressSitepropertiesApiV4ConsentPolicyInput>;
  /** Site description. */
  description?: InputMaybe<Scalars['String']>;
  /** Email address. */
  email?: InputMaybe<Scalars['String']>;
  /** External site URL that uses Wix as its headless business solution. */
  externalSiteUrl?: InputMaybe<Scalars['String']>;
  /** Fax number. */
  fax?: InputMaybe<Scalars['String']>;
  /**
   * Site language.
   *
   * Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Site locale. */
  locale?: InputMaybe<ComWixpressSitepropertiesApiV4LocaleInput>;
  /** Path to the site's logo in Wix Media (without Wix Media base URL). */
  logo?: InputMaybe<Scalars['String']>;
  /** Supported languages of a site and the primary language. */
  multilingual?: InputMaybe<ComWixpressSitepropertiesApiV4MultilingualInput>;
  /**
   * Site currency format used to bill customers.
   *
   * Three-letter currency code in [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format.
   */
  paymentCurrency?: InputMaybe<Scalars['String']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Site display name. */
  siteDisplayName?: InputMaybe<Scalars['String']>;
  /** Timezone in `America/New_York` format. */
  timeZone?: InputMaybe<Scalars['String']>;
  /** Track clicks analytics. */
  trackClicksAnalytics?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressSitepropertiesApiV4PropertiesReadRequestInput = {
  /**
   * List of fields to return.
   * If omitted, all fields are returned.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4PropertiesReadResponse = {
  __typename?: 'ComWixpressSitepropertiesApiV4PropertiesReadResponse';
  /** Properties for the requested site. */
  properties?: Maybe<ComWixpressSitepropertiesApiV4Properties>;
  /** Current version of the stored property site. For internal use. */
  version?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4PropertiesUpdateRequestInput = {
  /** The properties to be updated. Properties not explicitly specified here are ignored. Properties included here but excluded from `properties` are cleared. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  properties?: InputMaybe<ComWixpressSitepropertiesApiV4PropertiesInput>;
};

export type ComWixpressSitepropertiesApiV4PropertiesUpdateResponse = {
  __typename?: 'ComWixpressSitepropertiesApiV4PropertiesUpdateResponse';
  /** The new version of the stored properties after the update. For internal use. */
  version?: Maybe<Scalars['String']>;
};

export enum ComWixpressSitepropertiesApiV4ResolutionMethod {
  QueryParam = 'QUERY_PARAM',
  Subdirectory = 'SUBDIRECTORY',
  Subdomain = 'SUBDOMAIN'
}

export type ComWixpressSitepropertiesApiV4SiteClonedInput = {
  /** Origin site id. */
  originMetaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4SiteCreatedInput = {
  /** Origin template site id. */
  originTemplateId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4SitePropertiesEventInput = {
  /** Set of properties that were updated - corresponds to the fields in "properties". */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Updated properties. */
  properties?: InputMaybe<ComWixpressSitepropertiesApiV4PropertiesInput>;
  /** Version of the site's properties represented by this update. */
  version?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput = {
  /** Context of the notification */
  changeContext?: InputMaybe<ComWixpressSitepropertiesApiV4ChangeContextInput>;
  /** The actual update event. */
  event?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesEventInput>;
  /** The site ID for which this update notification applies. */
  metasiteId?: InputMaybe<Scalars['String']>;
  /** A convenience set of mappings from the MetaSite ID to its constituent services. */
  translations?: InputMaybe<Array<InputMaybe<ComWixpressSitepropertiesApiV4TranslationInput>>>;
};

export type ComWixpressSitepropertiesApiV4SpecialHourPeriod = {
  __typename?: 'ComWixpressSitepropertiesApiV4SpecialHourPeriod';
  /** Additional info about the exception. For example, "We close earlier on New Year's Eve." */
  comment?: Maybe<Scalars['String']>;
  /** End date and time of the exception in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format and [Coordinated Universal Time (UTC)](https://en.wikipedia.org/wiki/Coordinated_Universal_Time). */
  endDate?: Maybe<Scalars['String']>;
  /**
   * Whether the business is closed (or the service is not available) during the exception.
   *
   * Default: `true`.
   */
  isClosed?: Maybe<Scalars['Boolean']>;
  /** Start date and time of the exception in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format and [Coordinated Universal Time (UTC)](https://en.wikipedia.org/wiki/Coordinated_Universal_Time). */
  startDate?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4SpecialHourPeriodInput = {
  /** Additional info about the exception. For example, "We close earlier on New Year's Eve." */
  comment?: InputMaybe<Scalars['String']>;
  /** End date and time of the exception in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format and [Coordinated Universal Time (UTC)](https://en.wikipedia.org/wiki/Coordinated_Universal_Time). */
  endDate?: InputMaybe<Scalars['String']>;
  /**
   * Whether the business is closed (or the service is not available) during the exception.
   *
   * Default: `true`.
   */
  isClosed?: InputMaybe<Scalars['Boolean']>;
  /** Start date and time of the exception in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format and [Coordinated Universal Time (UTC)](https://en.wikipedia.org/wiki/Coordinated_Universal_Time). */
  startDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4SupportedLanguage = {
  __typename?: 'ComWixpressSitepropertiesApiV4SupportedLanguage';
  /** Language icon. */
  countryCode?: Maybe<Scalars['String']>;
  /** Whether the supported language is the primary language for the site. */
  isPrimary?: Maybe<Scalars['Boolean']>;
  /** Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format. */
  languageCode?: Maybe<Scalars['String']>;
  /** Locale. */
  locale?: Maybe<ComWixpressSitepropertiesApiV4Locale>;
  /** How the language will be resolved. For internal use. */
  resolutionMethod?: Maybe<ComWixpressSitepropertiesApiV4ResolutionMethod>;
};

export type ComWixpressSitepropertiesApiV4SupportedLanguageInput = {
  /** Language icon. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Whether the supported language is the primary language for the site. */
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  /** Whether the supported language is the primary language for site visitors. */
  isVisitorPrimary?: InputMaybe<Scalars['Boolean']>;
  /** Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format. */
  languageCode?: InputMaybe<Scalars['String']>;
  /** Locale. */
  locale?: InputMaybe<ComWixpressSitepropertiesApiV4LocaleInput>;
  /** How the language will be resolved. For internal use. */
  resolutionMethod?: InputMaybe<ComWixpressSitepropertiesApiV4ResolutionMethod>;
};

export type ComWixpressSitepropertiesApiV4TimePeriod = {
  __typename?: 'ComWixpressSitepropertiesApiV4TimePeriod';
  /** Day of the week the period ends on. */
  closeDay?: Maybe<ComWixpressSitepropertiesApiV4DayOfWeek>;
  /**
   * Time the period ends in 24-hour [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) extended format. Valid values are `00:00` to `24:00`, where `24:00` represents
   * midnight at the end of the specified day.
   *
   * __Note:__ If `openDay` and `closeDay` specify the same day of the week `closeTime` must be later than `openTime`.
   */
  closeTime?: Maybe<Scalars['String']>;
  /** Day of the week the period starts on. */
  openDay?: Maybe<ComWixpressSitepropertiesApiV4DayOfWeek>;
  /**
   * Time the period starts in 24-hour [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) extended format. Valid values are `00:00` to `24:00`, where `24:00` represents
   * midnight at the end of the specified day.
   */
  openTime?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4TimePeriodInput = {
  /** Day of the week the period ends on. */
  closeDay?: InputMaybe<ComWixpressSitepropertiesApiV4DayOfWeek>;
  /**
   * Time the period ends in 24-hour [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) extended format. Valid values are `00:00` to `24:00`, where `24:00` represents
   * midnight at the end of the specified day.
   *
   * __Note:__ If `openDay` and `closeDay` specify the same day of the week `closeTime` must be later than `openTime`.
   */
  closeTime?: InputMaybe<Scalars['String']>;
  /** Day of the week the period starts on. */
  openDay?: InputMaybe<ComWixpressSitepropertiesApiV4DayOfWeek>;
  /**
   * Time the period starts in 24-hour [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) extended format. Valid values are `00:00` to `24:00`, where `24:00` represents
   * midnight at the end of the specified day.
   */
  openTime?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4TranslationInput = {
  /** The application definition ID; this only applies to services of type ThirdPartyApps. */
  appDefId?: InputMaybe<Scalars['String']>;
  /** The instance ID of the service. */
  instanceId?: InputMaybe<Scalars['String']>;
  /** The service type. */
  serviceType?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4UpdateBusinessContactRequestInput = {
  /** The site's business contact information. */
  businessContact?: InputMaybe<ComWixpressSitepropertiesApiV4BusinessContactDataInput>;
  /** The properties of `businessContact` to be updated. Properties not explicitly specified here are ignored. Properties included here but excluded from `businessContact` are cleared. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4UpdateBusinessProfileRequestInput = {
  /** The site's business profile. */
  businessProfile?: InputMaybe<ComWixpressSitepropertiesApiV4BusinessProfileDataInput>;
  /** The properties of `businessProfile` to be updated. Properties not explicitly specified here are ignored. Properties included here but excluded from `businessProfile` are cleared. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4UpdateBusinessScheduleRequestInput = {
  /** The site's business schedule in the site time zone. */
  businessSchedule?: InputMaybe<ComWixpressSitepropertiesApiV4BusinessScheduleInput>;
};

export type ComWixpressSitepropertiesApiV4UpdateConsentPolicyRequestInput = {
  /** Default consent policy defined by the Wix user. Can be further limited by site visitors. */
  consentPolicy?: InputMaybe<ComWixpressSitepropertiesApiV4ConsentPolicyInput>;
};

export type EcomCheckoutV1AddToCheckoutRequestInput = {
  /**
   * Custom line items. Custom line items don't trigger the Catalog service plugin.
   *
   * To access and manage custom line items, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customLineItems?: InputMaybe<Array<InputMaybe<ComWixEcomCartCheckoutCommonApiV1CustomLineItemInput>>>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Catalog line items. */
  lineItems?: InputMaybe<Array<InputMaybe<EcomCheckoutV1LineItemInput>>>;
};

export type EcomCheckoutV1AddToCheckoutResponse = {
  __typename?: 'EcomCheckoutV1AddToCheckoutResponse';
  /** Updated checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1AddressWithContact = {
  __typename?: 'EcomCheckoutV1AddressWithContact';
  /** Address. */
  address?: Maybe<ComWixEcommercePlatformCommonApiAddress>;
  /** Reference to address service. */
  addressesServiceId?: Maybe<Scalars['String']>;
  /** Contact details. */
  contactDetails?: Maybe<ComWixEcommercePlatformCommonApiFullAddressContactDetails>;
};

export type EcomCheckoutV1AddressWithContactInput = {
  /** Address. */
  address?: InputMaybe<ComWixEcommercePlatformCommonApiAddressInput>;
  /** Reference to address service. */
  addressesServiceId?: InputMaybe<Scalars['String']>;
  /** Contact details. */
  contactDetails?: InputMaybe<ComWixEcommercePlatformCommonApiFullAddressContactDetailsInput>;
};

export type EcomCheckoutV1BuyerInfo = {
  __typename?: 'EcomCheckoutV1BuyerInfo';
  /** Contact ID. Auto-created if one does not yet exist. For more information, see the Contacts API. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** Contact ID. Auto-created if one does not yet exist. For more information, see the Contacts API. */
  contactId?: Maybe<Scalars['String']>;
  /** Buyer email address. */
  email?: Maybe<Scalars['String']>;
  /** Member ID (if site visitor is a site member). */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** Member ID (if site visitor is a site member). */
  memberId?: Maybe<Scalars['String']>;
  /**
   * + If `true`, the checkout doesn't have an owner yet and anyone can access it. The first to access it will be the new owner.
   * + If `false`, the value in `checkout.createdBy` is the owner.
   */
  openAccess?: Maybe<Scalars['Boolean']>;
  /** Visitor ID (if site visitor is **not** a member). */
  visitorId?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1BuyerInfoInput = {
  /** Contact ID. Auto-created if one does not yet exist. For more information, see the Contacts API. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Buyer email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Member ID (if site visitor is a site member). */
  memberId?: InputMaybe<Scalars['String']>;
  /**
   * + If `true`, the checkout doesn't have an owner yet and anyone can access it. The first to access it will be the new owner.
   * + If `false`, the value in `checkout.createdBy` is the owner.
   */
  openAccess?: InputMaybe<Scalars['Boolean']>;
  /** Visitor ID (if site visitor is **not** a member). */
  visitorId?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1Charge = {
  __typename?: 'EcomCheckoutV1Charge';
  /** The billing date from which the charge starts. */
  cycleBillingDate?: Maybe<Scalars['String']>;
  /** The number of cycles for which the charge is applicable. */
  cycleCount?: Maybe<Scalars['Int']>;
  /** The cycle number from which the charge starts. */
  cycleFrom?: Maybe<Scalars['Int']>;
  /** Charge summary. */
  priceSummary?: Maybe<ComWixEcomTotalsCalculatorV1PriceSummary>;
};

export type EcomCheckoutV1ChargeInput = {
  /** The billing date from which the charge starts. */
  cycleBillingDate?: InputMaybe<Scalars['String']>;
  /** The number of cycles for which the charge is applicable. */
  cycleCount?: InputMaybe<Scalars['Int']>;
  /** The cycle number from which the charge starts. */
  cycleFrom?: InputMaybe<Scalars['Int']>;
  /** Charge summary. */
  priceSummary?: InputMaybe<ComWixEcomTotalsCalculatorV1PriceSummaryInput>;
};

export type EcomCheckoutV1Checkout = {
  __typename?: 'EcomCheckoutV1Checkout';
  /** Additional Fees. */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1AdditionalFee>>>;
  /** Applied discounts. */
  appliedDiscounts?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1AppliedDiscount>>>;
  /** Billing information. */
  billingInfo?: Maybe<EcomCheckoutV1AddressWithContact>;
  /**
   * The business location ID associated with the checkout.
   *
   * To learn more, see the Locations API.
   */
  businessLocationId?: Maybe<Scalars['String']>;
  /** Buyer information. */
  buyerInfo?: Maybe<EcomCheckoutV1BuyerInfo>;
  /**
   * Language for communication with the buyer. Defaults to the site language.
   *
   * For a site that supports multiple languages, this is the language the buyer selected.
   */
  buyerLanguage?: Maybe<Scalars['String']>;
  /** [Buyer note](https://support.wix.com/en/article/collecting-and-viewing-buyer-notes) left by the customer. */
  buyerNote?: Maybe<Scalars['String']>;
  /** Errors when calculating totals. */
  calculationErrors?: Maybe<ComWixEcomTotalsCalculatorV1CalculationErrors>;
  /** Cart ID that this checkout was created from. Empty if this checkout wasn't created from a cart. */
  cartId?: Maybe<Scalars['String']>;
  /** Sales channel that submitted the order. */
  channelType?: Maybe<ComWixEcommercePlatformCommonApiChannelType>;
  /**
   * Whether an order was successfully created from this checkout.
   *
   * For an order to be successful, it must be successfully paid for (unless the total is 0).
   */
  completed?: Maybe<Scalars['Boolean']>;
  /** The currency selected by the buyer during the purchase flow, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. */
  conversionCurrency?: Maybe<Scalars['String']>;
  /** Information about the currency conversion that took place if at all. Empty if no conversion took place. */
  conversionInfo?: Maybe<EcomCheckoutV1ConversionInfo>;
  /** ID of the checkout's initiator. */
  createdBy?: Maybe<EcomCheckoutV1CreatedBy>;
  /** Date and time the checkout was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** The site's default currency, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. */
  currency?: Maybe<Scalars['String']>;
  /**
   * Reference IDs for the app and component providing custom checkout page content.
   *
   * To access and manage custom checkout page content, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customContentReference?: Maybe<ComWixEcomCartCheckoutCommonApiV1CustomContentReference>;
  /** Custom fields. */
  customFields?: Maybe<Array<Maybe<ComWixEcomOrdersV1CustomField>>>;
  /**
   * Additional settings for customization of the checkout process.
   *
   * > **Notes:**
   * > * Custom settings can only be set when creating a checkout.
   * > * To access and manage custom checkout page content, your app must have the permission scope named "Manage eCommerce - Admin Permissions". Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customSettings?: Maybe<EcomCheckoutV1CustomSettings>;
  /**
   * __Deprecated.__ Use `purchaseFlowId` instead.
   * @deprecated __Deprecated.__ Use `purchaseFlowId` instead. Removal date: 2025-04-01.
   */
  ecomId?: Maybe<Scalars['String']>;
  /**
   * Custom field data for the checkout object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  externalEnrichedLineItems?: Maybe<ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForCheckoutResponse>;
  /**
   * References to an external app and resource associated with this checkout.
   * Used for integration and tracking across different platforms.
   */
  externalReference?: Maybe<ComWixEcommercePlatformCommonApiExternalReference>;
  /**
   * Applied gift card details.
   *
   * >**Note:** Gift cards are supported through the Wix UI, though the service plugin is not currently available. Learn more about [Wix Gift Cards](https://support.wix.com/en/article/setting-up-wix-gift-cards-9451439).
   */
  giftCard?: Maybe<ComWixEcomTotalsCalculatorV1GiftCard>;
  /** Checkout ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Line items.
   *
   * Max: 300 items
   */
  lineItems?: Maybe<Array<Maybe<EcomCheckoutV1LineItem>>>;
  /**
   * The business location ID associated with the checkout.
   *
   * To learn more, see the Locations API.
   */
  location?: Maybe<ComWixpressLocationsLocation>;
  /** Indicates whether this cart is managed by Cart V2. */
  managedByV2?: Maybe<Scalars['Boolean']>;
  /** Memberships to apply when creating the order. */
  membershipOptions?: Maybe<EcomCheckoutV1MembershipOptions>;
  /**
   * Order ID.
   *
   * This field is empty until the checkout completes and becomes an order.
   */
  orderId?: Maybe<Scalars['String']>;
  /** Payment for subscriptions after free trial period. */
  payAfterFreeTrial?: Maybe<ComWixEcomTotalsCalculatorV1PriceSummary>;
  /** Remaining amount for the order to be fully paid. */
  payLater?: Maybe<ComWixEcomTotalsCalculatorV1PriceSummary>;
  /** Minimal amount to pay in order to place the order. */
  payNow?: Maybe<ComWixEcomTotalsCalculatorV1PriceSummary>;
  /** The pay now total amount after gift card reduction */
  payNowTotalAfterGiftCard?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Currency used for payment, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. */
  paymentCurrency?: Maybe<Scalars['String']>;
  /**
   * Whether payment is required to create an order.
   *
   * Payment is required if any of the following conditions are met:
   * 1. At least one item requires a payment method. This can be because the item has the `savePaymentMethod` field set to `true`, or the item is a subscription with a price greater than zero.
   * 2. The calculated total amount due for immediate payment is greater than zero - `checkout.payNow > 0`.
   */
  paymentRequired?: Maybe<Scalars['Boolean']>;
  /** Calculated price summary for the checkout. */
  priceSummary?: Maybe<ComWixEcomTotalsCalculatorV1PriceSummary>;
  /** Persistent ID that correlates between the various eCommerce elements: cart, checkout, and order. */
  purchaseFlowId?: Maybe<Scalars['String']>;
  /** Shipping information. */
  shippingInfo?: Maybe<EcomCheckoutV1ShippingInfo>;
  /** Site language in which original values are shown. */
  siteLanguage?: Maybe<Scalars['String']>;
  /** Charges information for each subscription in the checkout. */
  subscriptionCharges?: Maybe<Array<Maybe<EcomCheckoutV1SubscriptionCharges>>>;
  /** Whether tax is included in line item prices. */
  taxIncludedInPrice?: Maybe<Scalars['Boolean']>;
  /** Tax summary. */
  taxSummary?: Maybe<ComWixEcomTotalsCalculatorV1TaxSummary>;
  /** The total payment amount after gift card reduction */
  totalAfterGiftCard?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Date and time the checkout was updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** List of validation violations raised by the Validations service plugin ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/service-plugins/validations/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/validations-integration-service-plugin/introduction)). */
  violations?: Maybe<Array<Maybe<ComWixEcommerceValidationsSpiV1Violation>>>;
  /** Weight measurement unit. Defaults to a site's weight unit. */
  weightUnit?: Maybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};

export type EcomCheckoutV1CheckoutInput = {
  /** Additional Fees. */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1AdditionalFeeInput>>>;
  /** Applied discounts. */
  appliedDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1AppliedDiscountInput>>>;
  /** Billing information. */
  billingInfo?: InputMaybe<EcomCheckoutV1AddressWithContactInput>;
  /**
   * The business location ID associated with the checkout.
   *
   * To learn more, see the Locations API.
   */
  businessLocationId?: InputMaybe<Scalars['String']>;
  /** Buyer information. */
  buyerInfo?: InputMaybe<EcomCheckoutV1BuyerInfoInput>;
  /**
   * Language for communication with the buyer. Defaults to the site language.
   *
   * For a site that supports multiple languages, this is the language the buyer selected.
   */
  buyerLanguage?: InputMaybe<Scalars['String']>;
  /** [Buyer note](https://support.wix.com/en/article/collecting-and-viewing-buyer-notes) left by the customer. */
  buyerNote?: InputMaybe<Scalars['String']>;
  /** Errors when calculating totals. */
  calculationErrors?: InputMaybe<ComWixEcomTotalsCalculatorV1CalculationErrorsInput>;
  /** Cart ID that this checkout was created from. Empty if this checkout wasn't created from a cart. */
  cartId?: InputMaybe<Scalars['String']>;
  /** Sales channel that submitted the order. */
  channelType?: InputMaybe<ComWixEcommercePlatformCommonApiChannelType>;
  /**
   * Whether an order was successfully created from this checkout.
   *
   * For an order to be successful, it must be successfully paid for (unless the total is 0).
   */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** The currency selected by the buyer during the purchase flow, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. */
  conversionCurrency?: InputMaybe<Scalars['String']>;
  /** Information about the currency conversion that took place if at all. Empty if no conversion took place. */
  conversionInfo?: InputMaybe<EcomCheckoutV1ConversionInfoInput>;
  /** ID of the checkout's initiator. */
  createdBy?: InputMaybe<EcomCheckoutV1CreatedByInput>;
  /** Date and time the checkout was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** The site's default currency, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. */
  currency?: InputMaybe<Scalars['String']>;
  /**
   * Reference IDs for the app and component providing custom checkout page content.
   *
   * To access and manage custom checkout page content, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customContentReference?: InputMaybe<ComWixEcomCartCheckoutCommonApiV1CustomContentReferenceInput>;
  /** Custom fields. */
  customFields?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1CustomFieldInput>>>;
  /**
   * Additional settings for customization of the checkout process.
   *
   * > **Notes:**
   * > * Custom settings can only be set when creating a checkout.
   * > * To access and manage custom checkout page content, your app must have the permission scope named "Manage eCommerce - Admin Permissions". Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customSettings?: InputMaybe<EcomCheckoutV1CustomSettingsInput>;
  /**
   * Custom field data for the checkout object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /**
   * References to an external app and resource associated with this checkout.
   * Used for integration and tracking across different platforms.
   */
  externalReference?: InputMaybe<ComWixEcommercePlatformCommonApiExternalReferenceInput>;
  /**
   * Applied gift card details.
   *
   * >**Note:** Gift cards are supported through the Wix UI, though the service plugin is not currently available. Learn more about [Wix Gift Cards](https://support.wix.com/en/article/setting-up-wix-gift-cards-9451439).
   */
  giftCard?: InputMaybe<ComWixEcomTotalsCalculatorV1GiftCardInput>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Line items.
   *
   * Max: 300 items
   */
  lineItems?: InputMaybe<Array<InputMaybe<EcomCheckoutV1LineItemInput>>>;
  /** Indicates whether this cart is managed by Cart V2. */
  managedByV2?: InputMaybe<Scalars['Boolean']>;
  /** Memberships to apply when creating the order. */
  membershipOptions?: InputMaybe<EcomCheckoutV1MembershipOptionsInput>;
  /**
   * Order ID.
   *
   * This field is empty until the checkout completes and becomes an order.
   */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment for subscriptions after free trial period. */
  payAfterFreeTrial?: InputMaybe<ComWixEcomTotalsCalculatorV1PriceSummaryInput>;
  /** Remaining amount for the order to be fully paid. */
  payLater?: InputMaybe<ComWixEcomTotalsCalculatorV1PriceSummaryInput>;
  /** Minimal amount to pay in order to place the order. */
  payNow?: InputMaybe<ComWixEcomTotalsCalculatorV1PriceSummaryInput>;
  /** The pay now total amount after gift card reduction */
  payNowTotalAfterGiftCard?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Currency used for payment, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. */
  paymentCurrency?: InputMaybe<Scalars['String']>;
  /**
   * Whether payment is required to create an order.
   *
   * Payment is required if any of the following conditions are met:
   * 1. At least one item requires a payment method. This can be because the item has the `savePaymentMethod` field set to `true`, or the item is a subscription with a price greater than zero.
   * 2. The calculated total amount due for immediate payment is greater than zero - `checkout.payNow > 0`.
   */
  paymentRequired?: InputMaybe<Scalars['Boolean']>;
  /** Calculated price summary for the checkout. */
  priceSummary?: InputMaybe<ComWixEcomTotalsCalculatorV1PriceSummaryInput>;
  /** Persistent ID that correlates between the various eCommerce elements: cart, checkout, and order. */
  purchaseFlowId?: InputMaybe<Scalars['String']>;
  /** Shipping information. */
  shippingInfo?: InputMaybe<EcomCheckoutV1ShippingInfoInput>;
  /** Site language in which original values are shown. */
  siteLanguage?: InputMaybe<Scalars['String']>;
  /** Charges information for each subscription in the checkout. */
  subscriptionCharges?: InputMaybe<Array<InputMaybe<EcomCheckoutV1SubscriptionChargesInput>>>;
  /** Whether tax is included in line item prices. */
  taxIncludedInPrice?: InputMaybe<Scalars['Boolean']>;
  /** Tax summary. */
  taxSummary?: InputMaybe<ComWixEcomTotalsCalculatorV1TaxSummaryInput>;
  /** The total payment amount after gift card reduction */
  totalAfterGiftCard?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Date and time the checkout was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** List of validation violations raised by the Validations service plugin ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/service-plugins/validations/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/validations-integration-service-plugin/introduction)). */
  violations?: InputMaybe<Array<InputMaybe<ComWixEcommerceValidationsSpiV1ViolationInput>>>;
  /** Weight measurement unit. Defaults to a site's weight unit. */
  weightUnit?: InputMaybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};

export type EcomCheckoutV1ConversionInfo = {
  __typename?: 'EcomCheckoutV1ConversionInfo';
  /** The rate used when converting from the site currency to the checkout currency. */
  conversionRate?: Maybe<Scalars['String']>;
  /** The site currency. */
  siteCurrency?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1ConversionInfoInput = {
  /** The rate used when converting from the site currency to the checkout currency. */
  conversionRate?: InputMaybe<Scalars['String']>;
  /** The site currency. */
  siteCurrency?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1CreateCheckoutRequestInput = {
  /** Sales channel that submitted the order. */
  channelType?: InputMaybe<ComWixEcommercePlatformCommonApiChannelType>;
  /** Checkout information. */
  checkoutInfo?: InputMaybe<EcomCheckoutV1CheckoutInput>;
  /** Coupon code. */
  couponCode?: InputMaybe<Scalars['String']>;
  /**
   * Custom line items to add to the checkout. Custom line items don't trigger the Catalog service plugin.
   *
   * To access and manage custom line items, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customLineItems?: InputMaybe<Array<InputMaybe<ComWixEcomCartCheckoutCommonApiV1CustomLineItemInput>>>;
  /**
   * Gift card code.
   *
   * The checkout can only hold 1 `giftCardCode` at a time. If an additional `giftCardCode` is added, it will override the existing `giftCardCode`.
   *
   * >**Note:** Gift cards are supported through the Wix UI, though the service plugin is not currently available. Learn more about [Wix Gift Cards](https://support.wix.com/en/article/setting-up-wix-gift-cards-9451439).
   */
  giftCardCode?: InputMaybe<Scalars['String']>;
  /** Amount to redeem from the gift card referenced in `gift_card_code`. */
  giftCardRedeemAmount?: InputMaybe<Scalars['String']>;
  /** Catalog line items to add to the checkout. */
  lineItems?: InputMaybe<Array<InputMaybe<EcomCheckoutV1LineItemInput>>>;
  /**
   * Merchant discounts to manually apply to specific line items.
   *
   * If no `lineItemIds` are passed, the discount will be applied to the entire checkout.
   */
  merchantDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1MerchantDiscountInputInput>>>;
  /**
   * `overrideCheckoutUrl` allows the flexibility to redirect customers to a customized checkout page.
   *
   * This field overrides the `checkoutUrl` in a cart or checkout. `checkoutUrl` is used in the Abandoned Checkout API
   * to send customers back to their checkouts. By default, a `checkoutUrl` generates for a checkout and directs to a
   * standard Wix checkout page. When `overrideCheckoutUrl` has a value, it will replace and set the value of `checkoutUrl`.
   */
  overrideCheckoutUrl?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1CreateCheckoutResponse = {
  __typename?: 'EcomCheckoutV1CreateCheckoutResponse';
  /** Newly created checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1CreateOrderAndChargeRequestInput = {
  /** Whether to authorize the payment and delay the capture. */
  delayCapture?: InputMaybe<Scalars['Boolean']>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Payment token. */
  paymentToken?: InputMaybe<Scalars['String']>;
  /** Whether the payment method should be saved on the order. */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
  /** Custom URL params to be added to redirect URLs. */
  urlParams?: InputMaybe<Scalars['JSON']>;
};

export type EcomCheckoutV1CreateOrderAndChargeResponse = {
  __typename?: 'EcomCheckoutV1CreateOrderAndChargeResponse';
  /** Whether an order was successfully created from this checkout and the payment transaction was completed */
  checkoutCompleted?: Maybe<Scalars['Boolean']>;
  /** ID of newly created order. */
  orderId?: Maybe<Scalars['String']>;
  /**
   * The payment gateway is cashier.
   * payment_gateway_order_id will be returned given that money was charged.
   * In some cases, money will not be charged:
   * If the total price is 0 - For example, could be a free item or a an item with 100% discount
   * If the total price is not 0, but the payment is covered by alternative payment methods such as gift card
   */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
  /** Payment response token. */
  paymentResponseToken?: Maybe<Scalars['String']>;
  /** ID of newly created subscription. */
  subscriptionId?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1CreateOrderRequestInput = {
  /** Whether to authorize the payment and delay the capture. */
  delayCapture?: InputMaybe<Scalars['Boolean']>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether the payment method should be saved on the order. */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
  /** Custom URL params to be added to redirect URLs. */
  urlParams?: InputMaybe<Scalars['JSON']>;
};

export type EcomCheckoutV1CreateOrderResponse = {
  __typename?: 'EcomCheckoutV1CreateOrderResponse';
  /** ID of newly created order. */
  orderId?: Maybe<Scalars['String']>;
  /**
   * Payment gateway order ID.
   *
   * For online orders, pass this value as the `paymentId` parameter to the Wix Pay [`startPayment()`](https://www.wix.com/velo/reference/wix-pay-frontend/startpayment) function so your customer can pay for the order.
   * `paymentGatewayOrderId` will be returned if money needs to be charged.
   *
   * In some cases, money cannot be charged:
   * + When the total price (the `priceSummary.total.amount` field in the checkout/order objects) is `0`. For example, in the case of a free item or an item with a 100% discount.
   * + If the total price is not `0`, but the payment is covered by alternative payment methods, such as a gift card.
   */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
  /** ID of newly created subscription. Learn more about your site's [Subscriptions](https://support.wix.com/en/article/wix-stores-managing-product-subscriptions). */
  subscriptionId?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1CreatedBy = {
  __typename?: 'EcomCheckoutV1CreatedBy';
  /** App ID. When the order was created by an external application or Wix service. */
  appId?: Maybe<Scalars['String']>;
  /** Member ID. When the order was created by a **logged in** site visitor. */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** Member ID. When the order was created by a **logged in** site visitor. */
  memberId?: Maybe<Scalars['String']>;
  /**
   * User ID. When the order was created by a Wix user on behalf of a buyer.
   * For example, via POS (point of service).
   */
  userId?: Maybe<Scalars['String']>;
  /** Visitor ID. When the order was created by a site visitor that was **not** logged in. */
  visitorId?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1CreatedByInput = {
  /** App ID. When the order was created by an external application or Wix service. */
  appId?: InputMaybe<Scalars['String']>;
  /** Member ID. When the order was created by a **logged in** site visitor. */
  memberId?: InputMaybe<Scalars['String']>;
  /**
   * User ID. When the order was created by a Wix user on behalf of a buyer.
   * For example, via POS (point of service).
   */
  userId?: InputMaybe<Scalars['String']>;
  /** Visitor ID. When the order was created by a site visitor that was **not** logged in. */
  visitorId?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1CustomSettings = {
  __typename?: 'EcomCheckoutV1CustomSettings';
  /**
   * Whether to disable manual payment option for this checkout.
   *
   * Default: `false`
   */
  disabledManualPayment?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to disable policy agreement checkout in the checkout page
   *
   * Default: `false`
   */
  disabledPolicyAgreementCheckbox?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to restrict the option to add or remove a coupon code on the checkout page.
   *
   * Default: `false`
   */
  lockCouponCode?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to restrict the option to add or remove a gift card on the checkout page.
   *
   * Default: `false`
   */
  lockGiftCard?: Maybe<Scalars['Boolean']>;
};

export type EcomCheckoutV1CustomSettingsInput = {
  /**
   * Whether to disable manual payment option for this checkout.
   *
   * Default: `false`
   */
  disabledManualPayment?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to disable policy agreement checkout in the checkout page
   *
   * Default: `false`
   */
  disabledPolicyAgreementCheckbox?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to restrict the option to add or remove a coupon code on the checkout page.
   *
   * Default: `false`
   */
  lockCouponCode?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to restrict the option to add or remove a gift card on the checkout page.
   *
   * Default: `false`
   */
  lockGiftCard?: InputMaybe<Scalars['Boolean']>;
};

export type EcomCheckoutV1DeleteCheckoutRequestInput = {
  /** ID of the checkout to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1GetCheckoutByCartIdRequestInput = {
  /** Cart ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1GetCheckoutByCartIdResponse = {
  __typename?: 'EcomCheckoutV1GetCheckoutByCartIdResponse';
  /** Retrieved checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1GetCheckoutPaymentSettingsRequestInput = {
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1GetCheckoutPaymentSettingsResponse = {
  __typename?: 'EcomCheckoutV1GetCheckoutPaymentSettingsResponse';
  blockedPaymentOptions?: Maybe<Array<Maybe<EcomCheckoutV1PaymentOption>>>;
};

export type EcomCheckoutV1GetCheckoutRequestInput = {
  id: Scalars['ID'];
  /** Whether to refresh the checkout from external sources. Defaults to true. */
  refresh?: InputMaybe<Scalars['Boolean']>;
};

export type EcomCheckoutV1GetCheckoutResponse = {
  __typename?: 'EcomCheckoutV1GetCheckoutResponse';
  /** The requested checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1GetCheckoutUrlRequestInput = {
  /** Checkout currency parameter to append as a query param */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1GetCheckoutUrlResponse = {
  __typename?: 'EcomCheckoutV1GetCheckoutURLResponse';
  /** Checkout URL. */
  checkoutUrl?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1GetCheckoutWithAllExtendedFieldsRequestInput = {
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether to refresh the checkout from external sources. Defaults to true. */
  refresh?: InputMaybe<Scalars['Boolean']>;
};

export type EcomCheckoutV1GetCheckoutWithAllExtendedFieldsResponse = {
  __typename?: 'EcomCheckoutV1GetCheckoutWithAllExtendedFieldsResponse';
  /** Retrieved checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1GetWixCheckoutUrlRequestInput = {
  /** cart id to compare with for migration period */
  cartId?: InputMaybe<Scalars['String']>;
  /** checkout currency parameter to append */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1GetWixCheckoutUrlResponse = {
  __typename?: 'EcomCheckoutV1GetWixCheckoutURLResponse';
  /** Checkout URL. */
  checkoutUrl?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1ItemAvailabilityInfo = {
  __typename?: 'EcomCheckoutV1ItemAvailabilityInfo';
  /** Quantity available. */
  quantityAvailable?: Maybe<Scalars['Int']>;
  /** Item availability status. */
  status?: Maybe<EcomCheckoutV1ItemAvailabilityStatus>;
};

export type EcomCheckoutV1ItemAvailabilityInfoInput = {
  /** Quantity available. */
  quantityAvailable?: InputMaybe<Scalars['Int']>;
  /** Item availability status. */
  status?: InputMaybe<EcomCheckoutV1ItemAvailabilityStatus>;
};

export enum EcomCheckoutV1ItemAvailabilityStatus {
  Available = 'AVAILABLE',
  /** Item is not in stock. */
  NotAvailable = 'NOT_AVAILABLE',
  /** Item does not exist. */
  NotFound = 'NOT_FOUND',
  /** Available quantity is less than requested. */
  PartiallyAvailable = 'PARTIALLY_AVAILABLE'
}

export type EcomCheckoutV1LineItem = {
  __typename?: 'EcomCheckoutV1LineItem';
  /** Item availability details. */
  availability?: Maybe<EcomCheckoutV1ItemAvailabilityInfo>;
  /**
   * Overriding values for catalog item properties.
   *
   * To override catalog fields, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  catalogOverrideFields?: Maybe<ComWixEcomCartCheckoutCommonApiV1CatalogOverrideFields>;
  /** Catalog and item reference. Includes IDs for the item and the catalog it came from, as well as further optional info. Optional for custom line items, which don't trigger the Catalog service plugin. */
  catalogReference?: Maybe<ComWixEcommerceCatalogSpiApiV1CatalogReference>;
  /** Item payment policy that requires customer consent to complete purchase. The payment policy will be displayed on the checkout page. */
  consentRequiredPaymentPolicy?: Maybe<Scalars['String']>;
  /**
   * Coupon scopes - which app and items a coupon applies to.
   * This field is internal to Wix, and should be used by Bookings, Stores and Events as used by the Coupons API.
   */
  couponScopes?: Maybe<Array<Maybe<WixCouponsApiV2Scope>>>;
  /** Whether the line item is a custom line item. Custom line items don't trigger the Catalog service plugin. */
  customLineItem?: Maybe<Scalars['Boolean']>;
  /** Delivery profile ID. */
  deliveryProfileId?: Maybe<Scalars['String']>;
  /** Partial payment to be paid upfront during the checkout. Eligible for catalog items with `lineItem.paymentOption` type `DEPOSIT_ONLINE` only. */
  depositAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
  /** Digital file identifier, relevant only for items with type `DIGITAL`. */
  digitalFile?: Maybe<ComWixEcommerceCatalogSpiApiV1SecuredMedia>;
  /** Discount for this line item's entire quantity. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /**
   * Custom extended fields for the line item object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Whether the line item quantity is fixed and cannot be changed. */
  fixedQuantity?: Maybe<Scalars['Boolean']>;
  /** Fulfiller ID for this item. Field is empty when the item is self-fulfilled. */
  fulfillerId?: Maybe<Scalars['String']>;
  /** Item price **before** catalog-defined discount. Defaults to `price` when not provided. */
  fullPrice?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: Maybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: Maybe<ComWixEcommerceCatalogSpiApiV1ItemType>;
  /** Total line item price **after** catalog-defined discount and line item discounts. */
  lineItemPrice?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Line item image details. */
  media?: Maybe<WixCommonImage>;
  /**
   * Whether the item can only be purchased by site members.
   *
   * Default: `false`
   */
  membersOnly?: Maybe<Scalars['Boolean']>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: Maybe<Array<Maybe<ComWixEcomCartCheckoutCommonApiV1ModifierGroup>>>;
  /** Total price of all item modifiers. Included in the item price. */
  modifiersTotalPrice?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Original item full price. */
  originalFullPrice?: Maybe<Scalars['String']>;
  /** Original item price. */
  originalPrice?: Maybe<Scalars['String']>;
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  paymentOption?: Maybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
  /** Physical properties of the item. When relevant, contains information such as SKU, item weight, and shippability. */
  physicalProperties?: Maybe<ComWixEcommerceCatalogSpiApiV1PhysicalProperties>;
  /** Policies to be displayed to the customer on the checkout page. */
  policies?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1Policy>>>;
  /** Item price **after** catalog-defined discount and line item discounts. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Item price **before** line item discounts and **after** catalog-defined discount. Defaults to `price` when not provided. */
  priceBeforeDiscounts?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Item price before line item discounts and tax. */
  priceBeforeDiscountsAndTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: Maybe<ComWixEcommerceCatalogSpiApiV1PriceDescription>;
  /** Whether the price is not yet defined, and will be updated after the order is created. */
  priceUndetermined?: Maybe<Scalars['Boolean']>;
  /**
   * Item name.
   * + Stores - `product.name`
   * + Bookings - `service.info.name`
   * + Events - `ticket.name`
   */
  productName?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  /**
   * Item quantity.
   *
   * Min: `"1"`
   * Max: `"100000"`
   */
  quantity?: Maybe<Scalars['Int']>;
  /**
   * In cases where `catalogReference.catalogItemId` is NOT the actual catalog item ID, this field will return the true item's ID.
   * + For example, for Wix Bookings, `catalogReference.catalogItemId` is the booking ID. Therefore this value is set to the service ID.
   * + In most cases, this field has the same value as `catalogReference.catalogItemId`.
   * + Used in membership validation.
   */
  rootCatalogItemId?: Maybe<Scalars['String']>;
  /**
   * Whether to save the payment method on the order.
   *
   * Default: `false`
   */
  savePaymentMethod?: Maybe<Scalars['Boolean']>;
  /** Service properties. When relevant, this contains information such as date and number of participants. */
  serviceProperties?: Maybe<ComWixEcommerceCatalogSpiApiV1ServiceProperties>;
  /** Shipping group ID. */
  shippingGroupId?: Maybe<Scalars['String']>;
  /** Subscription option information. */
  subscriptionOptionInfo?: Maybe<ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo>;
  /** Tax details for this line item. */
  taxDetails?: Maybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetails>;
  /** Address to use for tax calculation purposes. */
  taxableAddress?: Maybe<ComWixEcommercePlatformCommonApiTaxableAddress>;
  /** Total price after all discounts and tax. */
  totalPriceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total price after discounts, and before tax. */
  totalPriceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** URL to the item's page on the site. */
  url?: Maybe<WixCommonPageUrlV2>;
};

export type EcomCheckoutV1LineItemInput = {
  /** Item availability details. */
  availability?: InputMaybe<EcomCheckoutV1ItemAvailabilityInfoInput>;
  /**
   * Overriding values for catalog item properties.
   *
   * To override catalog fields, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  catalogOverrideFields?: InputMaybe<ComWixEcomCartCheckoutCommonApiV1CatalogOverrideFieldsInput>;
  /** Catalog and item reference. Includes IDs for the item and the catalog it came from, as well as further optional info. Optional for custom line items, which don't trigger the Catalog service plugin. */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** Item payment policy that requires customer consent to complete purchase. The payment policy will be displayed on the checkout page. */
  consentRequiredPaymentPolicy?: InputMaybe<Scalars['String']>;
  /**
   * Coupon scopes - which app and items a coupon applies to.
   * This field is internal to Wix, and should be used by Bookings, Stores and Events as used by the Coupons API.
   */
  couponScopes?: InputMaybe<Array<InputMaybe<WixCouponsApiV2ScopeInput>>>;
  /** Whether the line item is a custom line item. Custom line items don't trigger the Catalog service plugin. */
  customLineItem?: InputMaybe<Scalars['Boolean']>;
  /** Delivery profile ID. */
  deliveryProfileId?: InputMaybe<Scalars['String']>;
  /** Partial payment to be paid upfront during the checkout. Eligible for catalog items with `lineItem.paymentOption` type `DEPOSIT_ONLINE` only. */
  depositAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Digital file identifier, relevant only for items with type `DIGITAL`. */
  digitalFile?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SecuredMediaInput>;
  /** Discount for this line item's entire quantity. */
  discount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /**
   * Custom extended fields for the line item object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Whether the line item quantity is fixed and cannot be changed. */
  fixedQuantity?: InputMaybe<Scalars['Boolean']>;
  /** Fulfiller ID for this item. Field is empty when the item is self-fulfilled. */
  fulfillerId?: InputMaybe<Scalars['String']>;
  /** Item price **before** catalog-defined discount. Defaults to `price` when not provided. */
  fullPrice?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: InputMaybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemTypeInput>;
  /** Total line item price **after** catalog-defined discount and line item discounts. */
  lineItemPrice?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Line item image details. */
  media?: InputMaybe<WixCommonImageInput>;
  /**
   * Whether the item can only be purchased by site members.
   *
   * Default: `false`
   */
  membersOnly?: InputMaybe<Scalars['Boolean']>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: InputMaybe<Array<InputMaybe<ComWixEcomCartCheckoutCommonApiV1ModifierGroupInput>>>;
  /** Total price of all item modifiers. Included in the item price. */
  modifiersTotalPrice?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Original item full price. */
  originalFullPrice?: InputMaybe<Scalars['String']>;
  /** Original item price. */
  originalPrice?: InputMaybe<Scalars['String']>;
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  paymentOption?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
  /** Physical properties of the item. When relevant, contains information such as SKU, item weight, and shippability. */
  physicalProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput>;
  /** Policies to be displayed to the customer on the checkout page. */
  policies?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1PolicyInput>>>;
  /** Item price **after** catalog-defined discount and line item discounts. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Item price **before** line item discounts and **after** catalog-defined discount. Defaults to `price` when not provided. */
  priceBeforeDiscounts?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Item price before line item discounts and tax. */
  priceBeforeDiscountsAndTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput>;
  /** Whether the price is not yet defined, and will be updated after the order is created. */
  priceUndetermined?: InputMaybe<Scalars['Boolean']>;
  /**
   * Item name.
   * + Stores - `product.name`
   * + Bookings - `service.info.name`
   * + Events - `ticket.name`
   */
  productName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /**
   * Item quantity.
   *
   * Min: `"1"`
   * Max: `"100000"`
   */
  quantity?: InputMaybe<Scalars['Int']>;
  /**
   * In cases where `catalogReference.catalogItemId` is NOT the actual catalog item ID, this field will return the true item's ID.
   * + For example, for Wix Bookings, `catalogReference.catalogItemId` is the booking ID. Therefore this value is set to the service ID.
   * + In most cases, this field has the same value as `catalogReference.catalogItemId`.
   * + Used in membership validation.
   */
  rootCatalogItemId?: InputMaybe<Scalars['String']>;
  /**
   * Whether to save the payment method on the order.
   *
   * Default: `false`
   */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
  /** Service properties. When relevant, this contains information such as date and number of participants. */
  serviceProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ServicePropertiesInput>;
  /** Shipping group ID. */
  shippingGroupId?: InputMaybe<Scalars['String']>;
  /** Subscription option information. */
  subscriptionOptionInfo?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput>;
  /** Tax details for this line item. */
  taxDetails?: InputMaybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput>;
  /** Address to use for tax calculation purposes. */
  taxableAddress?: InputMaybe<ComWixEcommercePlatformCommonApiTaxableAddressInput>;
  /** Total price after all discounts and tax. */
  totalPriceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total price after discounts, and before tax. */
  totalPriceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** URL to the item's page on the site. */
  url?: InputMaybe<WixCommonPageUrlV2Input>;
};

export type EcomCheckoutV1LineItemQuantityUpdateInput = {
  /** ID of the line item to update. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * New total amount of the line item,
   * not the amount to add to the current `quantity`.
   *
   * Min: `1`
   *
   * Max: `100000`
   */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type EcomCheckoutV1MarkCheckoutAsCompletedAndRedirectToUrlRequestInput = {
  /** Server-signed JWT token with required information to complete checkout */
  token?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1MarkCheckoutAsCompletedRequestInput = {
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1MembershipOptions = {
  __typename?: 'EcomCheckoutV1MembershipOptions';
  /** Reserved for internal use. */
  eligibleMemberships?: Maybe<Array<Maybe<ComWixEcomMembershipsSpiV1HostMembership>>>;
  /** Reserved for internal use. */
  invalidMemberships?: Maybe<Array<Maybe<ComWixEcomMembershipsSpiV1HostInvalidMembership>>>;
  /** Selected membership to apply to this checkout. */
  selectedMemberships?: Maybe<ComWixEcomMembershipsSpiV1HostSelectedMemberships>;
};

export type EcomCheckoutV1MembershipOptionsInput = {
  /** Reserved for internal use. */
  eligibleMemberships?: InputMaybe<Array<InputMaybe<ComWixEcomMembershipsSpiV1HostMembershipInput>>>;
  /** Reserved for internal use. */
  invalidMemberships?: InputMaybe<Array<InputMaybe<ComWixEcomMembershipsSpiV1HostInvalidMembershipInput>>>;
  /** Selected membership to apply to this checkout. */
  selectedMemberships?: InputMaybe<ComWixEcomMembershipsSpiV1HostSelectedMembershipsInput>;
};

export enum EcomCheckoutV1PaymentOption {
  Manual = 'MANUAL',
  UnknownPaymentOption = 'UNKNOWN_PAYMENT_OPTION'
}

export type EcomCheckoutV1RemoveCouponRequestInput = {
  /** ID of the checkout to remove the coupon from. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1RemoveCouponResponse = {
  __typename?: 'EcomCheckoutV1RemoveCouponResponse';
  /** Updated checkout after removal of coupon. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1RemoveGiftCardRequestInput = {
  /** ID of the checkout to remove the gift card from. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1RemoveGiftCardResponse = {
  __typename?: 'EcomCheckoutV1RemoveGiftCardResponse';
  /** Updated checkout after removal of gift card. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1RemoveLineItemsRequestInput = {
  /** ID of the checkout to remove line items from. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * IDs of the line items to remove from the checkout.
   *
   * To find the IDs of the checkout line items you'd like to remove,
   * pass the checkout ID to Get Checkout and look for the IDs under
   * `lineItems`.
   */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EcomCheckoutV1RemoveLineItemsResponse = {
  __typename?: 'EcomCheckoutV1RemoveLineItemsResponse';
  /** Updated checkout after removal of line items. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1RemoveOverrideCheckoutUrlRequestInput = {
  /** ID of the checkout to remove the override checkout url from. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1RemoveOverrideCheckoutUrlResponse = {
  __typename?: 'EcomCheckoutV1RemoveOverrideCheckoutUrlResponse';
  /** Updated checkout after removal of override checkout url. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1ShippingInfo = {
  __typename?: 'EcomCheckoutV1ShippingInfo';
  /** All carrier options for this shipping rule. */
  carrierServiceOptions?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1CarrierServiceOption>>>;
  /** Shipping region. Based on the address provided. */
  region?: Maybe<ComWixEcomTotalsCalculatorV1ShippingRegion>;
  /** Selected option out of the options allowed for the `region`. */
  selectedCarrierServiceOption?: Maybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption>;
  /** Shipping address and contact details. */
  shippingDestination?: Maybe<EcomCheckoutV1AddressWithContact>;
};

export type EcomCheckoutV1ShippingInfoInput = {
  /** All carrier options for this shipping rule. */
  carrierServiceOptions?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1CarrierServiceOptionInput>>>;
  /** Shipping region. Based on the address provided. */
  region?: InputMaybe<ComWixEcomTotalsCalculatorV1ShippingRegionInput>;
  /** Selected option out of the options allowed for the `region`. */
  selectedCarrierServiceOption?: InputMaybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionInput>;
  /** Shipping address and contact details. */
  shippingDestination?: InputMaybe<EcomCheckoutV1AddressWithContactInput>;
};

export type EcomCheckoutV1SubscriptionCharges = {
  __typename?: 'EcomCheckoutV1SubscriptionCharges';
  /** Charges for subscription. */
  charges?: Maybe<Array<Maybe<EcomCheckoutV1Charge>>>;
  /**
   * Generated description explaining future charges amount and schedule.
   * Translated to subscription order buyer language, or to site language if was not provided.
   */
  description?: Maybe<Scalars['String']>;
  /** ids of the items the subscription is defined on */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type EcomCheckoutV1SubscriptionChargesInput = {
  /** Charges for subscription. */
  charges?: InputMaybe<Array<InputMaybe<EcomCheckoutV1ChargeInput>>>;
  /**
   * Generated description explaining future charges amount and schedule.
   * Translated to subscription order buyer language, or to site language if was not provided.
   */
  description?: InputMaybe<Scalars['String']>;
  /** ids of the items the subscription is defined on */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EcomCheckoutV1UpdateCheckoutRequestInput = {
  /** Checkout information. */
  checkout?: InputMaybe<EcomCheckoutV1CheckoutInput>;
  /**
   * Coupon code.
   *
   * The checkout can only hold 1 `couponCode` at a time. If an additional `couponCode` is added, it will override the existing `couponCode`.
   */
  couponCode?: InputMaybe<Scalars['String']>;
  /**
   * Custom line items. Custom line items don't trigger the Catalog service plugin.
   *
   * To access and manage custom line items, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customLineItems?: InputMaybe<Array<InputMaybe<ComWixEcomCartCheckoutCommonApiV1CustomLineItemInput>>>;
  /** Set of fields to update. Fields are inferred. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Gift card code. */
  giftCardCode?: InputMaybe<Scalars['String']>;
  /** Amount to redeem from the gift card referenced in `gift_card_code`. */
  giftCardRedeemAmount?: InputMaybe<Scalars['String']>;
  /** When true, calculation errors won't fail the update request. When empty or false, the update won't happen and relevant error will return */
  ignoreCalculationErrors?: InputMaybe<Scalars['Boolean']>;
  /** Catalog line items. */
  lineItems?: InputMaybe<Array<InputMaybe<EcomCheckoutV1LineItemInput>>>;
  /**
   * Merchant discounts to manually apply to specific line items.
   *
   * If no `lineItemIds` are passed, the discount will be applied to the entire checkout.
   */
  merchantDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1MerchantDiscountInputInput>>>;
  /**
   * `overrideCheckoutUrl` allows the flexibility to redirect customers to a customized checkout page.
   *
   * This field overrides the `checkoutUrl` in a cart or checkout. `checkoutUrl` is used in the Abandoned Checkout API
   * to send customers back to their checkouts. By default, a `checkoutUrl` generates for a checkout and directs to a
   * standard Wix checkout page. When `overrideCheckoutUrl` has a value, it will replace and set the value of `checkoutUrl`.
   */
  overrideCheckoutUrl?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1UpdateCheckoutResponse = {
  __typename?: 'EcomCheckoutV1UpdateCheckoutResponse';
  /** Updated checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1UpdateLineItemsQuantityRequestInput = {
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item info to update. */
  lineItems?: InputMaybe<Array<InputMaybe<EcomCheckoutV1LineItemQuantityUpdateInput>>>;
};

export type EcomCheckoutV1UpdateLineItemsQuantityResponse = {
  __typename?: 'EcomCheckoutV1UpdateLineItemsQuantityResponse';
  /** Updated checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1UpdatedCheckoutMessageInput = {
  /** Previous checkout. */
  oldCheckout?: InputMaybe<EcomCheckoutV1CheckoutInput>;
  /** Updated checkout. */
  updatedCheckout?: InputMaybe<EcomCheckoutV1CheckoutInput>;
};

export type ExternalEchoInput = {
  /** 2nd part of the message */
  arg2?: InputMaybe<Scalars['String']>;
};

export type GoogleProtobufStructInput = {
  fields?: InputMaybe<Scalars['JSON']>;
};

export type MetroinspectorV1CollectionsCollection = {
  __typename?: 'MetroinspectorV1CollectionsCollection';
  id?: Maybe<Scalars['String']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<MetroinspectorV1ProductsQueryProductsResponse>;
  title?: Maybe<Scalars['String']>;
};


export type MetroinspectorV1CollectionsCollectionProductsArgs = {
  queryInput?: InputMaybe<MetroinspectorV1ProductsQueryProductsRequestInput>;
};

export type MetroinspectorV1CollectionsGetCollectionRequestInput = {
  id: Scalars['ID'];
};

export type MetroinspectorV1CollectionsQueryCollectionsRequestInput = {
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type MetroinspectorV1CollectionsQueryCollectionsResponse = {
  __typename?: 'MetroinspectorV1CollectionsQueryCollectionsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<MetroinspectorV1CollectionsCollection>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type MetroinspectorV1ProductsBulkCreateProductsRequestInput = {
  products?: InputMaybe<Array<InputMaybe<MetroinspectorV1ProductsProductInput>>>;
  /** set to `true` if you wish to receive back the created products in the response */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type MetroinspectorV1ProductsBulkCreateProductsResponse = {
  __typename?: 'MetroinspectorV1ProductsBulkCreateProductsResponse';
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<MetroinspectorV1ProductsBulkProductResult>>>;
};

export type MetroinspectorV1ProductsBulkDeleteProductsRequestInput = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MetroinspectorV1ProductsBulkDeleteProductsResponse = {
  __typename?: 'MetroinspectorV1ProductsBulkDeleteProductsResponse';
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<MetroinspectorV1ProductsBulkProductResult>>>;
};

export type MetroinspectorV1ProductsBulkProductResult = {
  __typename?: 'MetroinspectorV1ProductsBulkProductResult';
  /** Only exists if `returnEntity` was set to true in the request */
  item?: Maybe<MetroinspectorV1ProductsProduct>;
  /** Defined in wix.commons */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type MetroinspectorV1ProductsBulkUpdateProductsRequestInput = {
  products?: InputMaybe<Array<InputMaybe<MetroinspectorV1ProductsMaskedProductInput>>>;
  /** set to `true` if you wish to receive back the updated products in the response */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type MetroinspectorV1ProductsBulkUpdateProductsResponse = {
  __typename?: 'MetroinspectorV1ProductsBulkUpdateProductsResponse';
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<MetroinspectorV1ProductsBulkProductResult>>>;
};

export type MetroinspectorV1ProductsCountProductsRequestInput = {
  filter?: InputMaybe<Scalars['JSON']>;
  /** Whether hidden products should be included in the response. Requires permissions to manage products. */
  includeHiddenProducts?: InputMaybe<Scalars['Boolean']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
  /** Whether variants should be included in the response. */
  includeVariants?: InputMaybe<Scalars['Boolean']>;
};

export type MetroinspectorV1ProductsCountProductsResponse = {
  __typename?: 'MetroinspectorV1ProductsCountProductsResponse';
  count?: Maybe<Scalars['Int']>;
};

export type MetroinspectorV1ProductsCreateProductRequestInput = {
  product?: InputMaybe<MetroinspectorV1ProductsProductInput>;
};

export type MetroinspectorV1ProductsCreateProductResponse = {
  __typename?: 'MetroinspectorV1ProductsCreateProductResponse';
  product?: Maybe<MetroinspectorV1ProductsProduct>;
};

export type MetroinspectorV1ProductsDeleteProductRequestInput = {
  productId?: InputMaybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsGetProductRequestInput = {
  id: Scalars['ID'];
};

export type MetroinspectorV1ProductsGetProductsStartWithRequestInput = {
  addressLine2?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsGetProductsStartWithResponse = {
  __typename?: 'MetroinspectorV1ProductsGetProductsStartWithResponse';
  products?: Maybe<Array<Maybe<MetroinspectorV1ProductsProduct>>>;
};

export type MetroinspectorV1ProductsMaskedProductInput = {
  /** Explicit list of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Product to be updated, may be partial */
  product?: InputMaybe<MetroinspectorV1ProductsProductInput>;
};

export type MetroinspectorV1ProductsMyAddress = {
  __typename?: 'MetroinspectorV1ProductsMyAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  formattedAddress?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<WixCommonStreetAddress>;
  subdivision?: Maybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsMyAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  formattedAddress?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<WixCommonStreetAddressInput>;
  subdivision?: InputMaybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsProduct = {
  __typename?: 'MetroinspectorV1ProductsProduct';
  address?: Maybe<WixCommonAddress>;
  audio?: Maybe<WixCommonAudio>;
  collection?: Maybe<MetroinspectorV1CollectionsCollection>;
  collectionId?: Maybe<Scalars['String']>;
  collectionsVirtualReference?: Maybe<MetroinspectorV1CollectionsQueryCollectionsResponse>;
  color?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  customAddress?: Maybe<MetroinspectorV1ProductsMyAddress>;
  document?: Maybe<WixCommonDocument>;
  externalEcho?: Maybe<WixCoreservicesMetroinspectorV1EchoResponse>;
  guid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<WixCommonImage>;
  localDate?: Maybe<Scalars['String']>;
  localDateTime?: Maybe<Scalars['String']>;
  localTime?: Maybe<Scalars['String']>;
  mainVariant?: Maybe<MetroinspectorV1ProductsVariant>;
  modifiedDate?: Maybe<Scalars['String']>;
  pageLink?: Maybe<WixCommonPageLink>;
  title?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<Maybe<MetroinspectorV1ProductsVariant>>>;
  video?: Maybe<WixCommonVideoV2>;
};


export type MetroinspectorV1ProductsProductCollectionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<MetroinspectorV1CollectionsQueryCollectionsRequestInput>;
};


export type MetroinspectorV1ProductsProductExternalEchoArgs = {
  input?: InputMaybe<ExternalEchoInput>;
};

export type MetroinspectorV1ProductsProductInput = {
  address?: InputMaybe<WixCommonAddressInput>;
  audio?: InputMaybe<WixCommonAudioInput>;
  collectionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  createdDate?: InputMaybe<Scalars['String']>;
  customAddress?: InputMaybe<MetroinspectorV1ProductsMyAddressInput>;
  document?: InputMaybe<WixCommonDocumentInput>;
  guid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<WixCommonImageInput>;
  localDate?: InputMaybe<Scalars['String']>;
  localDateTime?: InputMaybe<Scalars['String']>;
  localTime?: InputMaybe<Scalars['String']>;
  mainVariant?: InputMaybe<MetroinspectorV1ProductsVariantInput>;
  modifiedDate?: InputMaybe<Scalars['String']>;
  pageLink?: InputMaybe<WixCommonPageLinkInput>;
  title?: InputMaybe<Scalars['String']>;
  variants?: InputMaybe<Array<InputMaybe<MetroinspectorV1ProductsVariantInput>>>;
  video?: InputMaybe<WixCommonVideoV2Input>;
};

export type MetroinspectorV1ProductsQueryProductsRequestInput = {
  /** Whether hidden products should be included in the response. Requires permissions to manage products. */
  includeHiddenProducts?: InputMaybe<Scalars['Boolean']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
  /** Whether variants should be included in the response. */
  includeVariants?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type MetroinspectorV1ProductsQueryProductsResponse = {
  __typename?: 'MetroinspectorV1ProductsQueryProductsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<MetroinspectorV1ProductsProduct>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type MetroinspectorV1ProductsUpdateProductRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  product?: InputMaybe<MetroinspectorV1ProductsProductInput>;
  productId?: InputMaybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsUpdateProductResponse = {
  __typename?: 'MetroinspectorV1ProductsUpdateProductResponse';
  product?: Maybe<MetroinspectorV1ProductsProduct>;
};

export type MetroinspectorV1ProductsVariant = {
  __typename?: 'MetroinspectorV1ProductsVariant';
  image?: Maybe<WixCommonImage>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsVariantInput = {
  image?: InputMaybe<WixCommonImageInput>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  comWixBookingsSchedulesApiV1Cache?: Maybe<WixBookingsCalendarV2CacheResponse>;
  /**
   * Creates a session.
   *
   * A session is one of the following:
   * + `"EVENT"`: Reserved period of time on any [schedule](wix-bookings-backend.sessions/introduction#schedules). For example, an appointment, class, or course. Events are visible in the Dashboard in the Bookings app's [**Booking Calendar**](https://support.wix.com/en/article/wix-bookings-about-the-wix-bookings-calendar) page. Set `type` to `"EVENT"` when creating sessions that reserve time on a service's schedule, or when creating a blocked time for a resource.
   * + `"WORKING_HOURS"`: Placeholder for available time on a resource’s schedule. Set `type` to `"WORKING_HOURS"` when creating sessions for resource availability.
   *
   * Sessions belong to a schedule. Schedules are owned by a resource or a service.
   *
   * A session may be an individual session or a recurring session.
   * An individual session has a discrete start and end date, while a recurring session defines a series of repeating sessions. An instance of a recurring session is a specific session in a series of repeating sessions, generated according to the recurrence rule.
   * The `start` and `end` properties set the time and duration of the session. For non-recurring sessions, you can use either the `timestamp` or `localDateTime` properties.
   * For recurring sessions, use the `localDateTime` property only. For recurring sessions, the `start` property sets the date and time of the first recurring session, subject to the recurrence rule. For example, if you set the `start` to Saturday, May 1 and your recurrence rule says every second Monday, then the first session will only be on Monday, May 10.
   *
   * The `year`, `monthOfYear` and `dayOfMonth` properties in the `end` property are used with the `hourOfDay` and `minutesOfHour` properties to set the duration of each session relative to the `start`.
   * The `UNTIL` keyword in the `recurrence` property sets the date for the last recurring session.
   *
   * You can create a session that blocks hours on the resource's calendar, making the resource unavailable.
   * Create a non-recurring session of type `"EVENT"`, and add `"Blocked"` to the `tags` array.
   *
   * >**Notes:**
   * > + For properties where there is no explicit time zone information, the time zone used is the business’s time zone.
   * > + Only users with **[Bookings Admin](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin)** permissions can create a session. You can override the permissions by setting the `suppressAuth` option to `true`.
   */
  comWixBookingsSchedulesApiV1CreateSession?: Maybe<ComWixBookingsSchedulesVeloV2CreateSessionResponse>;
  /**
   * Deletes a session.
   *
   * Use the `participantNotification` property to send an email to the participants when the session is deleted.
   * When deleting a session of type `"EVENT"` where a booking exists, the booking's status is updated to `"CANCELED"`.
   * To delete a set of recurring sessions, specify the session's `recurringSessionId` in the `sessionId` property in the parameters.
   * When deleting a recurrence, only future instances of the recurrence are deleted.
   *
   * >**Note:** Only users with **[Bookings Admin](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin)** permissions can delete a session. You can override the permissions by setting the `suppressAuth` option to `true`.
   */
  comWixBookingsSchedulesApiV1DeleteSession?: Maybe<Scalars['Void']>;
  comWixBookingsSchedulesApiV1GetCacheInfo?: Maybe<WixBookingsCalendarV2GetCacheInfoResponse>;
  /** Calendar Feed handler. */
  comWixBookingsSchedulesApiV1HandleFeedMessage?: Maybe<Scalars['Void']>;
  /** Calendar Feed handler. */
  comWixBookingsSchedulesApiV1HandleFeedReplayMessage?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a list of sessions by their IDs.
   *
   *
   * By default, session objects are returned with the fields specified in the `NO_PI` fieldset. This means they don't contain personal information.
   * To retrieve full session objects including all personal information, use the `ALL_PI` fieldset. This requires the CALENDAR.SESSION_READ_PI permission scope.
   */
  comWixBookingsSchedulesApiV1ListSessions?: Maybe<WixBookingsCalendarV2ListSessionsResponse>;
  /**
   * Retrieves a list of event session instances, given the provided paging and filtering.
   *
   *
   * By default session objects without any personal information are returned.
   * This means without `participants`, `location`, `calendarConference`, and
   * `externalCalendarOverrides`. You can retrieve full session objects by passing
   * `ALL_PI` in the `fieldsets` array. It isn't possible to retrieve sessions
   * with personal information just for specific participants.
   *
   * > __Note:__ Sessions are sorted by `start.timestamp`, in ascending order.
   * > Other sorting options aren't supported.
   *
   *
   * For a detailed list of supported operations in the Bookings Calendar V2 API, see
   * [filtering](https://dev.wix.com/api/rest/wix-bookings/calendar-v2/filters).
   *
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging).
   */
  comWixBookingsSchedulesApiV1QueryEventSessionInstances?: Maybe<WixBookingsCalendarV2QueryEventSessionInstancesResponse>;
  comWixBookingsSchedulesApiV1ShortenCache?: Maybe<WixBookingsCalendarV2ShortenCacheResponse>;
  comWixBookingsSchedulesApiV1Uncache?: Maybe<Scalars['Void']>;
  /**
   * Updates a session.
   *
   * When you update a recurring session, only the future instances of the recurrence will be updated. Changing an individual instance's `start` or `end` time will change the way updates to `start` and `end` on the recurring session affect the session instance:
   * |Change made to the instance | Effect of changes made to the recurrence
   * |--|--|
   * |Instance `start` time changed.|Changes to the recurring session's `start` or `end` time will not update the instance.|
   * |Instance `end` time changed, changing the session's duration| Changes made to the recurring session's start time will be updated on the instance while keeping the new duration, but changes to the recurring session's `end` time not be updated on the instance.
   * |Updating a changed `start` time for an instance back to the recurring session's value.|Future changes to the recurring session `start` and `end` times will update the instance's `starts` and `end` time.
   *
   * Changes to properties on the recurring session, other than `start` and `end`, are always updated on the recurrence instance.
   *
   * Use the `options.participantNotification` object to notify participants if the session has been booked.
   *
   * >**Notes:**
   * > + Where there is no explicit timezone information, the timezone used is the business’s timezone.
   * > + Only users with **[Bookings Admin](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin)** permissions can update a session. You can override the permissions by setting the `suppressAuth` option to `true`.
   */
  comWixBookingsSchedulesApiV1UpdateSession?: Maybe<ComWixBookingsSchedulesVeloV2UpdateSessionResponse>;
  /** ML: once multilingual installed on store, we'd like to create the relevant keys */
  comWixEcomDiscountsConsumeLocaleCreated?: Maybe<Scalars['Void']>;
  /** Discount rule usage counter is incremented once an order with discount rules is approved */
  comWixEcomDiscountsConsumeOrderPaid?: Maybe<Scalars['Void']>;
  /** Creates a new discount rule. */
  comWixEcomDiscountsCreateDiscountRule?: Maybe<ComWixEcomDiscountsCreateDiscountRuleResponse>;
  /** Deletes a discount rule. */
  comWixEcomDiscountsDeleteDiscountRule?: Maybe<Scalars['Void']>;
  /** Retrieve all discounts that can be applied to the given line items. */
  comWixEcomDiscountsGetAppliedDiscounts?: Maybe<ComWixEcomDiscountsGetAppliedDiscountsResponse>;
  /**
   * Updates a discount rule.
   *
   * Each time the discount rule is updated, `revision` increments by 1. The existing `revision` must be included when updating the discount rule.
   * This ensures you're working with the latest discount rule information, and it prevents unintended overwrites.
   */
  comWixEcomDiscountsUpdateDiscountRule?: Maybe<ComWixEcomDiscountsUpdateDiscountRuleResponse>;
  /**
   * Authorizes a payment using an order's saved payment method.
   *
   * Use the `delayedCaptureSettings` field to specify whether the payment should also be captured/voided immediately or at a later time.
   * Alternatively, the payment can be manually captured or voided using the Capture Authorized Payments or Void Authorized Payments methods.
   */
  comWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethod?: Maybe<ComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodResponse>;
  /**
   * Creates an authorized payment with requested amount using saved payment method associated with order.
   * Later this payment can be:
   * - Captured, using CaptureAuthorizedPayments endpoint.
   * - Voided, using VoidAuthorizedPayments endpoint.
   * If none of these actions is performed manually, after some period of time (determined either by request.delayed_capture_settings.delay_duration, or by provider defaults), one of them will be performed automatically.
   */
  comWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethod?: Maybe<ComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodResponse>;
  /** Calculates refund amounts for a given list of an order's line items, shipping, and additional fees. */
  comWixEcomOrdersBillingV1CalculateRefund?: Maybe<ComWixEcomOrdersBillingV1CalculateRefundResponse>;
  /** Captures an order's authorized payments. */
  comWixEcomOrdersBillingV1CaptureAuthorizedPayments?: Maybe<ComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsResponse>;
  /** Generates receipts for an order's specified payments. */
  comWixEcomOrdersBillingV1GenerateReceipts?: Maybe<ComWixEcomOrdersBillingV1GenerateReceiptsResponse>;
  /**
   * Retrieves refund information about an order's payments, line items, shipping, and additional fees.
   *
   * The following information is returned:
   * - Whether a payment is refundable; previously refunded amounts; possible refund amounts for each payment.
   * - Refundable and previously refunded quantities for each line item, as well as shipping and additional fees.
   */
  comWixEcomOrdersBillingV1GetOrderRefundability?: Maybe<ComWixEcomOrdersBillingV1GetOrderRefundabilityResponse>;
  /**
   * *DEPRECATED** - Use GetOrderRefundability instead.
   *
   * Provides refund related information about order, such as:
   * - refundability status, previously refunded amount, possible refund amount for each payment
   * - previously refunded quantity and available for refund quantities for each line item
   * - previously refunded amount and available for refund amount for shipping and each additional fee
   */
  comWixEcomOrdersBillingV1GetRefundOptions?: Maybe<ComWixEcomOrdersBillingV1GetRefundOptionsResponse>;
  /**
   * Calls relevant payment providers and creates refund transactions for the requested payments.
   *
   * Refunds marked with `paymentRefunds.externalRefund = true` do not call payment providers and
   * only update the order's transactions records.
   */
  comWixEcomOrdersBillingV1RefundPayments?: Maybe<ComWixEcomOrdersBillingV1RefundPaymentsResponse>;
  /** Voids an order's authorized payments. */
  comWixEcomOrdersBillingV1VoidAuthorizedPayments?: Maybe<ComWixEcomOrdersBillingV1VoidAuthorizedPaymentsResponse>;
  /** Creates multiple fulfillments for one or more orders. */
  comWixEcomOrdersFulfillmentsV1BulkCreateFulfillment?: Maybe<ComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentResponse>;
  /** Creates an order fulfillment. */
  comWixEcomOrdersFulfillmentsV1CreateFulfillment?: Maybe<ComWixEcomOrdersFulfillmentsV1CreateFulfillmentResponse>;
  /** Deletes an existing order fulfillment. */
  comWixEcomOrdersFulfillmentsV1DeleteFulfillment?: Maybe<ComWixEcomOrdersFulfillmentsV1DeleteFulfillmentResponse>;
  /** Retrieves fulfillments associated with multiple specified orders. */
  comWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrders?: Maybe<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersResponse>;
  /** Retrieves fulfillments associated with a specified order. */
  comWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrder?: Maybe<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderResponse>;
  /**
   * Updates a fulfillment's properties.
   *
   * To update a field's value, include the new value in the `fulfillment` field in the body params.
   * To remove a field's value, pass `null`.
   *
   * > **Note:** Updating line item IDs or fulfilled quantities is not allowed. To update line item IDs or quantities, delete the fulfillment and create it again.
   */
  comWixEcomOrdersFulfillmentsV1UpdateFulfillment?: Maybe<ComWixEcomOrdersFulfillmentsV1UpdateFulfillmentResponse>;
  /** Adds an invoice to a specified order. */
  comWixEcomOrdersInvoicesV1AddInvoiceToOrder?: Maybe<ComWixEcomOrdersInvoicesV1AddInvoiceToOrderResponse>;
  /** Generates and adds invoices to all specified orders. */
  comWixEcomOrdersInvoicesV1BulkGenerateInvoices?: Maybe<ComWixEcomOrdersInvoicesV1BulkGenerateInvoicesResponse>;
  comWixEcomOrdersInvoicesV1ConsumeOrderDomainEvents?: Maybe<Scalars['Void']>;
  /** Generates and adds an invoice to a specified order. */
  comWixEcomOrdersInvoicesV1GenerateInvoice?: Maybe<ComWixEcomOrdersInvoicesV1GenerateInvoiceResponse>;
  /** Generates and adds an invoice to a specified order. */
  comWixEcomOrdersInvoicesV1GenerateInvoiceWithNumber?: Maybe<ComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberResponse>;
  comWixEcomOrdersInvoicesV1GetOrderInvoice?: Maybe<ComWixEcomOrdersInvoicesV1GetOrderInvoiceResponse>;
  /** Retrieves the IDs of invoices associated with all specified orders. */
  comWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrders?: Maybe<ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersResponse>;
  /**
   * Retrieves invoices associated with all specified orders.
   * !!! Deprecated !!!
   */
  comWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersOld?: Maybe<ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersResponse>;
  /** Retrieves the IDs of invoices associated with a specified order. */
  comWixEcomOrdersInvoicesV1ListInvoicesForSingleOrder?: Maybe<ComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderResponse>;
  /** Adds chargeback for payment to order transactions and updates payment status accordingly. */
  comWixEcomOrdersPaymentsV1AddChargeback?: Maybe<ComWixEcomOrdersPaymentsV1AddChargebackResponse>;
  /** Adds an invoice to a specified order. */
  comWixEcomOrdersPaymentsV1AddInvoiceToOrder?: Maybe<ComWixEcomOrdersPaymentsV1AddInvoiceToOrderResponse>;
  /**
   * Adds up to 50 payment records to an order.
   *
   * > **Note:** This does **NOT** perform the actual charging - the order is only updated with records of the payments.
   */
  comWixEcomOrdersPaymentsV1AddPayments?: Maybe<ComWixEcomOrdersPaymentsV1AddPaymentsResponse>;
  /** Add refunds for payments for an order and changes payments statuses accordingly */
  comWixEcomOrdersPaymentsV1AddRefund?: Maybe<ComWixEcomOrdersPaymentsV1AddRefundResponse>;
  /** Generates and adds invoices to all specified orders. */
  comWixEcomOrdersPaymentsV1BulkGenerateInvoices?: Maybe<ComWixEcomOrdersPaymentsV1BulkGenerateInvoicesResponse>;
  /** Updates multiple order payments with a specified status. */
  comWixEcomOrdersPaymentsV1BulkUpdatePaymentStatuses?: Maybe<ComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesResponse>;
  /** Calculates what amount can still be refunded on this order. */
  comWixEcomOrdersPaymentsV1CalculateRefund?: Maybe<ComWixEcomOrdersPaymentsV1CalculateRefundResponse>;
  /** Generates and adds an invoice to a specified order. */
  comWixEcomOrdersPaymentsV1GenerateInvoice?: Maybe<ComWixEcomOrdersPaymentsV1GenerateInvoiceResponse>;
  /** Checks whether this order can be refunded. */
  comWixEcomOrdersPaymentsV1GetRefundabilityStatus?: Maybe<ComWixEcomOrdersPaymentsV1GetRefundabilityStatusResponse>;
  /**
   * Retrieves invoices associated with all specified orders.
   * !!! Deprecated !!!
   */
  comWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrders?: Maybe<ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersResponse>;
  /**
   * Retrieves invoices associated with all specified orders.
   * !!! Deprecated !!!
   */
  comWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersOld?: Maybe<ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersResponse>;
  /**
   * Retrieves invoices associated with a specified order.
   * !!! Deprecated !!!
   */
  comWixEcomOrdersPaymentsV1ListInvoicesForSingleOrder?: Maybe<ComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderResponse>;
  /** Retrieves information about payments and refunds associated with all specified orders. */
  comWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrders?: Maybe<ComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersResponse>;
  /** Retrieves information about payments and refunds associated with a specified order. */
  comWixEcomOrdersPaymentsV1ListTransactionsForSingleOrder?: Maybe<ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderResponse>;
  /** Reverses chargeback. */
  comWixEcomOrdersPaymentsV1ReverseChargeback?: Maybe<ComWixEcomOrdersPaymentsV1ReverseChargebackResponse>;
  /**
   * Retrieves a list of order transactions, given the provided paging, filtering, and sorting.
   *
   * To learn about working with _Search_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), and
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  comWixEcomOrdersPaymentsV1SearchOrderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1SearchOrderTransactionsResponse>;
  /** Triggers one or more refunds on an order and updates the order's transactions record. */
  comWixEcomOrdersPaymentsV1TriggerRefund?: Maybe<ComWixEcomOrdersPaymentsV1TriggerRefundResponse>;
  /** Updates chargeback. */
  comWixEcomOrdersPaymentsV1UpdateChargeback?: Maybe<ComWixEcomOrdersPaymentsV1UpdateChargebackResponse>;
  /** Updates the status of an order's payment. */
  comWixEcomOrdersPaymentsV1UpdatePaymentStatus?: Maybe<ComWixEcomOrdersPaymentsV1UpdatePaymentStatusResponse>;
  /**
   * Updates properties of payments associated to order.
   *
   * Currently, the following fields can be updated:
   * + `payment.payment_details.regular_payment_details.provider_transaction_id`
   * + `payment.payment_details.regular_payment_details.status`
   * + `payment.payment_details.regular_payment_details.payment_method_details.credit_card_details`
   * + `payment.payment_details.regular_payment_details.authorization_details`
   * + `payment.payment_details.regular_payment_details.authorization_details.scheduled_action`
   * + `payment.payment_details.regular_payment_details.authorization_details.authorized_date`
   * + `payment.payment_details.regular_payment_details.authorization_details.captures`
   * + `payment.payment_details.regular_payment_details.authorization_details.captures.status`
   * + `payment.payment_details.regular_payment_details.authorization_details.captures.created_date`
   * + `payment.payment_details.regular_payment_details.authorization_details.captures.failure_details`
   * + `payment.payment_details.regular_payment_details.authorization_details.void`
   * + `payment.payment_details.regular_payment_details.authorization_details.void.status`
   * + `payment.payment_details.regular_payment_details.authorization_details.void.voided_date`
   * + `payment.payment_details.regular_payment_details.authorization_details.void.reason`
   * + `payment.payment_details.regular_payment_details.authorization_details.void.failure_details`
   * + `payment.receipt_info`
   * + `payment.receipt_info.wix_receipt`
   * + `payment.receipt_info.wix_receipt.receipt_id`
   * + `payment.receipt_info.wix_receipt.display_number`
   * + `payment.receipt_info.external_receipt`
   * + `payment.receipt_info.external_receipt.receipt_id`
   * + `payment.receipt_info.external_receipt.display_number`
   * + `payment.receipt_info.external_receipt.app_id`
   *
   * To update a field's value, include the new value in the `payment` object in the body params.
   *
   * > **Note:** Removing fields value results in an error.
   */
  comWixEcomOrdersPaymentsV1UpdatePayments?: Maybe<ComWixEcomOrdersPaymentsV1UpdatePaymentsResponse>;
  /**
   * Updates OrderTransactions.refunds properties, except OrderTransactions.refunds.transactions, which are updated
   * via UpdateRefundTransaction endpoint
   */
  comWixEcomOrdersPaymentsV1UpdateRefund?: Maybe<ComWixEcomOrdersPaymentsV1UpdateRefundResponse>;
  /** Updates OrderTransactions.refunds.transactions properties */
  comWixEcomOrdersPaymentsV1UpdateRefundTransaction?: Maybe<ComWixEcomOrdersPaymentsV1UpdateRefundTransactionResponse>;
  /**
   * Adds merchant comments to an order.
   * > **Note:** Activities with type CustomActivity not supported
   */
  comWixEcomOrdersV1AddActivities?: Maybe<ComWixEcomOrdersV1AddActivitiesResponse>;
  /**
   * Adds a merchant comment to an order.
   * > **Note:** Activities with type CustomActivity not supported
   */
  comWixEcomOrdersV1AddActivity?: Maybe<ComWixEcomOrdersV1AddActivityResponse>;
  comWixEcomOrdersV1AddInternalActivity?: Maybe<ComWixEcomOrdersV1AddInternalActivityResponse>;
  comWixEcomOrdersV1AggregateOrders?: Maybe<ComWixEcomOrdersV1AggregateOrdersResponse>;
  /** Archives an order. `order.archived` field changes to `true`. */
  comWixEcomOrdersV1ArchiveOrder?: Maybe<ComWixEcomOrdersV1ArchiveOrderResponse>;
  /** Archives multiple orders. `order.archived` field changes to `true`. */
  comWixEcomOrdersV1BulkArchiveOrders?: Maybe<ComWixEcomOrdersV1BulkArchiveOrdersResponse>;
  /** Archives multiple orders, selected by filter. `order.archived` field changes to `true`. */
  comWixEcomOrdersV1BulkArchiveOrdersByFilter?: Maybe<ComWixEcomOrdersV1BulkArchiveOrdersByFilterResponse>;
  /** Marks multiple orders as fulfilled. `order.fulfillmentStatus` field changes to `FULFILLED`. */
  comWixEcomOrdersV1BulkMarkAsFulfilled?: Maybe<ComWixEcomOrdersV1BulkMarkAsFulfilledResponse>;
  /** Marks multiple orders as fulfilled, selected by filter. `order.fulfillmentStatus` field changes to `FULFILLED`. */
  comWixEcomOrdersV1BulkMarkAsFulfilledByFilter?: Maybe<ComWixEcomOrdersV1BulkMarkAsFulfilledByFilterResponse>;
  /** Marks multiple orders as not fulfilled. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
  comWixEcomOrdersV1BulkMarkAsUnfulfilled?: Maybe<ComWixEcomOrdersV1BulkMarkAsUnfulfilledResponse>;
  /** Marks multiple orders as not fulfilled, selected by filter. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
  comWixEcomOrdersV1BulkMarkAsUnfulfilledByFilter?: Maybe<ComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterResponse>;
  /** Marks multiple orders as paid. `order.paymentStatus` field *eventually* changes to `PAID`. */
  comWixEcomOrdersV1BulkMarkOrdersAsPaid?: Maybe<ComWixEcomOrdersV1BulkMarkOrdersAsPaidResponse>;
  comWixEcomOrdersV1BulkSendBuyerPickupConfirmationEmails?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1BulkSendBuyerShippingConfirmationEmails?: Maybe<Scalars['Void']>;
  /**
   * For INTERNAL use only.
   * Set business location for the multiple orders
   */
  comWixEcomOrdersV1BulkSetBusinessLocation?: Maybe<ComWixEcomOrdersV1BulkSetBusinessLocationResponse>;
  /** Unarchives multiple orders. `order.archived` field changes to `false`. */
  comWixEcomOrdersV1BulkUnArchiveOrders?: Maybe<ComWixEcomOrdersV1BulkUnArchiveOrdersResponse>;
  /** Unarchives multiple orders, selected by filter. `order.archived` field changes to `false`. */
  comWixEcomOrdersV1BulkUnArchiveOrdersByFilter?: Maybe<ComWixEcomOrdersV1BulkUnArchiveOrdersByFilterResponse>;
  comWixEcomOrdersV1BulkUpdateOrder?: Maybe<ComWixEcomOrdersV1BulkUpdateOrderResponse>;
  /**
   * Synchronously update tags on multiple orders, by list of order IDs.
   *
   * > **Note:** If the same tag is passed to both the `assignTags` and `unassignTags` fields, it will be assigned.
   */
  comWixEcomOrdersV1BulkUpdateOrderTags?: Maybe<ComWixEcomOrdersV1BulkUpdateOrderTagsResponse>;
  /**
   * Updates properties of up to 100 orders.
   *
   * <blockquote class="important">
   *
   * __Currently, only the following fields can be updated:__
   * + `order.buyerInfo.email`
   * + `order.buyerLanguage`
   * + `order.weightUnit`
   * + `order.billingInfo.address`
   * + `order.billingInfo.contactDetails`
   * + `order.archived`
   * + `order.attributionSource`
   * + `order.seenByAHuman`
   * + `order.recipientInfo.address`
   * + `order.recipientInfo.contactDetails`
   * + `order.shippingInfo.logistics.shippingDestination.address`
   * + `order.shippingInfo.logistics.shippingDestination.contactDetails`
   * + `order.extendedFields`
   *
   * </blockquote>
   *
   *
   * To update a field's value, include the new value in the `order` object in the body params.
   * To remove a field's value, pass `null`.
   *
   * > **Note:** Removing (passing `null` to) `buyerInfo` or `contactDetails` results in an error.
   *
   * To update an order's payment status, use [Update Payment Status](https://dev.wix.com/docs/rest/business-solutions/e-commerce/order-transactions/update-payment-status).
   */
  comWixEcomOrdersV1BulkUpdateOrders?: Maybe<ComWixEcomOrdersV1BulkUpdateOrdersResponse>;
  /** Calculates refundable amount for order items specified in request. */
  comWixEcomOrdersV1CalculateRefund?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundResponse>;
  /**
   * Calculates refundable amount for order items specified in request.
   * This is a copy of existing CalculateRefund endpoint.
   * Later "CalculateRefund" endpoint name will be used for V2 refund.
   * Clients of existing CalculateRefund will be migrated to CalculateRefundV1
   */
  comWixEcomOrdersV1CalculateRefundV1?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1Response>;
  /** Calculates refund amount for given list of order line items, shipping and additional fees. */
  comWixEcomOrdersV1CalculateRefundV2?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2Response>;
  comWixEcomOrdersV1CanMigrate?: Maybe<ComWixEcomOrdersRolloutManagerV1CanMigrateResponse>;
  /** Cancels an order. The `order.status` field changes to `CANCELED`. */
  comWixEcomOrdersV1CancelOrder?: Maybe<ComWixEcomOrdersV1CancelOrderResponse>;
  /** Capture authorized payment */
  comWixEcomOrdersV1CaptureAuthorizedPayment?: Maybe<Scalars['Void']>;
  /**
   * Capture authorized payments
   * Transaction statuses for related payments will be updated in async way
   */
  comWixEcomOrdersV1CaptureAuthorizedPayments?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsResponse>;
  comWixEcomOrdersV1ChargeMemberships?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ChargeSavedPaymentMethod?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodResponse>;
  comWixEcomOrdersV1CommitDeltas?: Maybe<ComWixEcomOrdersV1CommitDeltasResponse>;
  comWixEcomOrdersV1ConsumeBiAnalyticsTransactionSourceEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeBiTransactionSourceEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeBiTransactionSourceReviveEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeFileDescriptorEvent?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeFulfillmentEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeFulfillmentWrapperEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeGiftCardTransactionVoidedV1?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeInternalSideEffectsProduceDomainEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeInvoicePaidEvent?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeInvoiceSentEvent?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeMergeContactsFilteredEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeMetaSiteSpecialEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeOrderDomainEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeOrderEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeOrderReindexRequest?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumePaymentEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumePaymentStatusUpdateEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumePaymentsEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeTriggerReindexRequest?: Maybe<Scalars['Void']>;
  /**
   * Creates an order.
   *
   *
   * > **Notes:**
   * > + If an item is digital - `lineItems[i].itemType.preset: DIGITAL` - then `lineItems[i].digitalFile` must be provided.
   * > + If `lineItems[i].id` is passed, it must be either a valid GUID, or empty.
   */
  comWixEcomOrdersV1CreateOrder?: Maybe<ComWixEcomOrdersV1CreateOrderResponse>;
  /**
   * Call this endpoint to create an order in the payment gateway system. The amount of the order would be either:
   * 1. An explicit amount provided in the request, or;
   * 2. If an explicit amount is not provided - the remaining amount to complete the payment of that eCom order.
   * As a result, an ID of the created payment gateway order would be returned.
   * You can then use Wix Payments APIs to approve that order or collect payment, which will eventually change the eCom order state (e.g mark it as paid).
   */
  comWixEcomOrdersV1CreatePaymentGatewayOrder?: Maybe<ComWixEcomOrdersV1CreatePaymentGatewayOrderResponse>;
  comWixEcomOrdersV1CreateSiteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusResponse>;
  /** Restock items on order - temporary solution for POS */
  comWixEcomOrdersV1DecrementItemsQuantity?: Maybe<ComWixEcomOrdersV1DecrementItemsQuantityResponse>;
  /**
   * Delete's an order's activity.
   *
   * Only custom activities and merchant comments can be deleted.
   */
  comWixEcomOrdersV1DeleteActivity?: Maybe<ComWixEcomOrdersV1DeleteActivityResponse>;
  comWixEcomOrdersV1EpBackofficeTestUrlAdditionalBindings?: Maybe<WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsResponse>;
  comWixEcomOrdersV1EpBackofficeUpdateOrder?: Maybe<WixEcomOrdersBackofficeV1UpdateOrderResponse>;
  comWixEcomOrdersV1EpBackofficeUpsertRefund?: Maybe<WixEcomOrdersBackofficeV1UpsertRefundResponse>;
  /** ******** SUBSCRIPTIONS ********* */
  comWixEcomOrdersV1EpOrdersIndexerConsumeOrderEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1EpOrdersIndexerConsumePaymentsEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1EpOrdersIndexerConsumeTriggerReindexRequest?: Maybe<Scalars['Void']>;
  /**
   * Uses explicitly provided metasite ID or implicit ecom instance ID from Callscope
   * to query legacy v1 Orders service and verify if any amount of ecom orders are present in an old (event-source based) system.
   */
  comWixEcomOrdersV1EpOrdersRolloutManagerHasOrdersInOldSystem?: Maybe<ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemResponse>;
  /**
   * Retrieves metadata for given metasiteID using metasiteReadApi get RPC call
   * Target msid must be provided
   */
  comWixEcomOrdersV1GetMetasiteData?: Maybe<WixEcomOrdersBackofficeV1GetMetasiteDataResponse>;
  comWixEcomOrdersV1GetOrderAgc?: Maybe<WixEcomOrdersBackofficeV1GetOrderAgcResponse>;
  /**
   * Retrieves order for given metasiteId and orderId using ep-orders getOrder RPC call
   * Target msid and orderId must be provided
   */
  comWixEcomOrdersV1GetOrderForMetasite?: Maybe<WixEcomOrdersBackofficeV1GetOrderForMetasiteResponse>;
  comWixEcomOrdersV1GetOrderOutOfBox?: Maybe<WixEcomOrdersBackofficeV1GetOrderOutOfBoxResponse>;
  comWixEcomOrdersV1GetOrderWithFilterByLocation?: Maybe<WixEcomOrdersBackofficeV1GetOrderWithFilterByLocationResponse>;
  /**
   * Provides payment collectability status for given order. If payment collection is possible
   * response will contain collectable amount for given ecom order. If not - response will contain
   * reason why payment collection is not possible.
   */
  comWixEcomOrdersV1GetPaymentCollectabilityStatus?: Maybe<ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusResponse>;
  /**
   * Provides refund related information about order, such as:
   * - refundability status, previously refunded amount, possible refund amount for each payment
   * - previously refunded quantity and available for refund quantities for each line item
   * - previously refunded amount and available for refund amount for shipping and each additional fee
   */
  comWixEcomOrdersV1GetRefundOptions?: Maybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsResponse>;
  /** Checks whether this order can be refunded. */
  comWixEcomOrdersV1GetRefundabilityStatus?: Maybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusResponse>;
  /** returns shipping label ids - temporarily until fully modeled in fulfillments service */
  comWixEcomOrdersV1GetShipments?: Maybe<ComWixEcomOrdersV1GetShipmentsResponse>;
  comWixEcomOrdersV1GetSiteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1GetSiteRolloutStatusResponse>;
  comWixEcomOrdersV1HandleRetryMergeContactsTask?: Maybe<WixApiLoomTimecapsuleTaskAction>;
  /**
   * Uses explicitly provided metasite ID to query legacy v1 Orders service
   * and verify if any amount of ecom orders are present in an old (event-source based) system.
   */
  comWixEcomOrdersV1HasOrdersInOldSystem?: Maybe<ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemResponse>;
  /**
   * <!--ONLY:REST-->
   * Internal query orders endpoint without additional logic to hide INIT orders.
   * Returns a list of up to 100 orders, given the provided paging, filtering and sorting.
   *
   * To learn how to query orders, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   * <!--END:ONLY:REST-->
   */
  comWixEcomOrdersV1InternalQueryOrders?: Maybe<ComWixEcomOrdersV1InternalQueryOrdersResponse>;
  /**
   * Retrieves order transactions for given metasiteId and orderId using ep-payments listTransactionsForSingleOrder RPC call
   * Target msid and orderId must be provided
   */
  comWixEcomOrdersV1ListOrderTransactionsForMetasite?: Maybe<WixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteResponse>;
  /**
   * Retrieves orders for store sorted by createdDate ASC.
   * If ListOrdersRequest.ids is empty will return list of all orders
   * else will be filtered by ids
   */
  comWixEcomOrdersV1ListOrders?: Maybe<ComWixEcomOrdersV1ListOrdersResponse>;
  /**
   * Retrieves orders for given metasiteID using ep-orders listOrders RPC call
   * Target msid must be provided
   * TODO: deprecated, remove me!
   */
  comWixEcomOrdersV1ListOrdersForMetasite?: Maybe<WixEcomOrdersBackofficeV1ListOrdersForMetasiteResponse>;
  /** Marks an order as fulfilled. `order.fulfillmentStatus` field changes to `FULFILLED`. */
  comWixEcomOrdersV1MarkAsFulfilled?: Maybe<ComWixEcomOrdersV1MarkAsFulfilledResponse>;
  /** Marks an order as not fulfilled. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
  comWixEcomOrdersV1MarkAsUnfulfilled?: Maybe<ComWixEcomOrdersV1MarkAsUnfulfilledResponse>;
  comWixEcomOrdersV1MarkEmptyAndOpenNewFlow?: Maybe<ComWixEcomOrdersRolloutManagerV1MarkEmptyAndOpenNewFlowResponse>;
  /**
   * Marks the order as paid. `order.paymentStatus` field *eventually* changes to `PAID`.
   * In case the order already has an offline payment transaction associated with it (usually when manual payment method is chosen at checkout) - This transaction will become approved.
   * In case the order has no payment transactions associated with it (usually when the item is set to be paid offline after checkout or when an order is created from the backoffice) - A payment transaction will be created and approved.
   */
  comWixEcomOrdersV1MarkOrderAsPaid?: Maybe<ComWixEcomOrdersV1MarkOrderAsPaidResponse>;
  /** Marks an order as read in the dashboard. `order.seenByAHuman` field changes to `true`. */
  comWixEcomOrdersV1MarkOrderAsSeenByHuman?: Maybe<ComWixEcomOrdersV1MarkOrderAsSeenByHumanResponse>;
  comWixEcomOrdersV1OnTriggerSideEffectsFromLegacy?: Maybe<Scalars['Void']>;
  /** Marks multiple orders as paid. `order.paymentStatus` field *eventually* changes to `PAID`. */
  comWixEcomOrdersV1PaymentCollectionBulkMarkOrdersAsPaid?: Maybe<ComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidResponse>;
  /**
   * Calculates refundable amount for order items specified in request.
   * This is a copy of existing CalculateRefund endpoint.
   * Later "CalculateRefund" endpoint name will be used for V2 refund.
   * Clients of existing CalculateRefund will be migrated to CalculateRefundV1
   */
  comWixEcomOrdersV1PaymentCollectionCalculateRefundV1?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1Response>;
  /** Calculates refund amount for given list of order line items, shipping and additional fees. */
  comWixEcomOrdersV1PaymentCollectionCalculateRefundV2?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2Response>;
  /** Capture authorized payment */
  comWixEcomOrdersV1PaymentCollectionCaptureAuthorizedPayment?: Maybe<Scalars['Void']>;
  /**
   * Capture authorized payments
   * Transaction statuses for related payments will be updated in async way
   */
  comWixEcomOrdersV1PaymentCollectionCaptureAuthorizedPayments?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsResponse>;
  comWixEcomOrdersV1PaymentCollectionConsumeGiftCardTransactionVoidedV2?: Maybe<Scalars['Void']>;
  /**
   * Call this endpoint to create an order in the payment gateway system. The amount of the order would be either:
   * 1. An explicit amount provided in the request, or;
   * 2. If an explicit amount is not provided - the remaining amount to complete the payment of that eCom order.
   * As a result, an ID of the created payment gateway order would be returned.
   * You can then use Wix Payments APIs to approve that order or collect payment, which will eventually change the eCom order state (e.g mark it as paid).
   */
  comWixEcomOrdersV1PaymentCollectionCreatePaymentGatewayOrder?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderResponse>;
  /**
   * Provides refund related information about order, such as:
   * - refundability status, previously refunded amount, possible refund amount for each payment
   * - previously refunded quantity and available for refund quantities for each line item
   * - previously refunded amount and available for refund amount for shipping and each additional fee
   */
  comWixEcomOrdersV1PaymentCollectionGetRefundOptions?: Maybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsResponse>;
  /**
   * Marks the order as paid. `order.paymentStatus` field *eventually* changes to `PAID`.
   * In case the order already has an offline payment transaction associated with it
   * (usually when manual payment method is chosen at checkout) - This transaction will become approved.
   * In case the order has no payment transactions associated with it
   * (usually when the item is set to be paid offline after checkout or when an order is created from the backoffice) - A payment transaction
   * will be created and approved.
   */
  comWixEcomOrdersV1PaymentCollectionMarkOrderAsPaid?: Maybe<ComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidResponse>;
  /**
   * Calls corresponding payment providers and creates refund transactions for requested payments.
   * Updates order transactions based on refund results.
   * For requested payments with `RefundRequest.payments.external_refund = true` will not call payment providers and
   * will only update order transactions.
   */
  comWixEcomOrdersV1PaymentCollectionRefund?: Maybe<ComWixEcomOrdersPaymentsCollectorV1RefundResponse>;
  /** Void authorized payment */
  comWixEcomOrdersV1PaymentCollectionVoidAuthorizedPayment?: Maybe<Scalars['Void']>;
  /**
   * Void authorized payments
   * Transaction statuses for related payments will be updated in async way
   */
  comWixEcomOrdersV1PaymentCollectionVoidAuthorizedPayments?: Maybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsResponse>;
  /**
   * Prepares payment collection for given ecom order. This is the first of 2-step process of payment collection.
   * Here we ensure that payment collection is possible for given order and store and prepare payment gateway order for future charge.
   * 2nd step is an actual charge of prepared payment gateway order. This could be done either
   * via Wix-Cashier's API (https://bo.wix.com/wix-docs/rest/wix-cashier/pay/charge/charge-for-order)
   * or using Cashier Payments Widget (https://github.com/wix-private/cashier-client/tree/master/packages/cashier-payments-widget)
   */
  comWixEcomOrdersV1PreparePaymentCollection?: Maybe<ComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionResponse>;
  /** Deprecated, use PreviewEmailByType with ORDER_PLACED type instead */
  comWixEcomOrdersV1PreviewBuyerConfirmationEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewBuyerConfirmationEmailResponse>;
  comWixEcomOrdersV1PreviewBuyerPaymentsReceivedEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewBuyerPaymentsReceivedEmailResponse>;
  /** Deprecated, use PreviewEmailByType with ORDER_READY_FOR_PICKUP type instead */
  comWixEcomOrdersV1PreviewBuyerPickupConfirmationEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewBuyerPickupConfirmationEmailResponse>;
  comWixEcomOrdersV1PreviewCancelEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewCancelEmailResponse>;
  comWixEcomOrdersV1PreviewCancelRefundEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailResponse>;
  comWixEcomOrdersV1PreviewEmailByType?: Maybe<ComWixEcomOrdersNotificationsV1PreviewEmailByTypeResponse>;
  comWixEcomOrdersV1PreviewRefundEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewRefundEmailResponse>;
  /** Deprecated, use PreviewEmailByType with DOWNLOAD_LINKS type instead */
  comWixEcomOrdersV1PreviewResendDownloadLinksEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewResendDownloadLinksEmailResponse>;
  /** Deprecated, use PreviewEmailByType with ORDER_SHIPPED type instead */
  comWixEcomOrdersV1PreviewShippingConfirmationEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewShippingConfirmationEmailResponse>;
  /**
   * Retrieves orders for given metasiteID using ep-orders internalQueryOrders RPC call
   * Target msid must be provided
   */
  comWixEcomOrdersV1QueryOrdersForMetasite?: Maybe<WixEcomOrdersBackofficeV1QueryOrdersForMetasiteResponse>;
  /**
   * Records and approves new manual payment with provided custom amount on given order.
   * Existing pending payments are ignored.
   * Custom amount is expected to be less or equal remaining amount to be paid on order (affected by approved payments, refunds and gift card payments)
   */
  comWixEcomOrdersV1RecordManuallyCollectedPayment?: Maybe<Scalars['Void']>;
  /**
   * Calls corresponding payment providers and creates refund transactions for requested payments.
   * Updates order transactions based on refund results.
   * For requested payments with `RefundRequest.payments.external_refund = true` will not call payment providers and
   * will only update order transactions.
   */
  comWixEcomOrdersV1Refund?: Maybe<ComWixEcomOrdersPaymentsCollectorV1RefundResponse>;
  /**
   * Retrieves a list of orders, given the provided paging, filtering, and sorting.
   *
   *
   * Search Orders runs with these defaults, which you can override:
   *
   * - `createdDate` is sorted in `DESC` order
   * - `cursorPaging.limit` is `100`
   * - `filter: {"status": {"$ne": "INITIALIZED"}}` - other order statuses can be queried, but orders with `status: "INITIALIZED"` are never returned
   *
   * For field support for filters and sorting, see [Orders: Supported Filters and Sorting](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/supported-filters-and-sorting).
   *
   * To learn about working with _Search_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), and
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  comWixEcomOrdersV1SearchOrders?: Maybe<ComWixEcomOrdersV1SearchOrdersResponse>;
  comWixEcomOrdersV1SendBuyerConfirmationEmail?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1SendBuyerPaymentsReceivedEmail?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1SendBuyerPickupConfirmationEmail?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1SendBuyerShippingConfirmationEmail?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1SendCancelRefundEmail?: Maybe<Scalars['Void']>;
  /** this will send notification to merchant via both email and via Notification Hub */
  comWixEcomOrdersV1SendMerchantOrderReceivedNotification?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1SendMerchantOrderReceivedPush?: Maybe<Scalars['Void']>;
  /** Sends "order refunded" buyer email. */
  comWixEcomOrdersV1SendRefundEmail?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1TestUrlAdditionalBindings?: Maybe<WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsResponse>;
  /**
   * Calls corresponding payment providers and creates refund transactions for requested payments.
   * Updates order transactions based on refund results.
   * For requested payments with `TriggerRefundRequest.payments.external_refund = true` will not call payment providers and
   * will only update order transactions.
   */
  comWixEcomOrdersV1TriggerRefund?: Maybe<ComWixEcomOrdersPaymentsCollectorV1TriggerRefundResponse>;
  comWixEcomOrdersV1TriggerReindex?: Maybe<Scalars['Void']>;
  /** Unarchives an order. `order.archived` field changes to `false`. */
  comWixEcomOrdersV1UnArchiveOrder?: Maybe<ComWixEcomOrdersV1UnArchiveOrderResponse>;
  /** Updates an order's activity. */
  comWixEcomOrdersV1UpdateActivity?: Maybe<ComWixEcomOrdersV1UpdateActivityResponse>;
  comWixEcomOrdersV1UpdateAllowLazyMigration?: Maybe<ComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationResponse>;
  /** Updates an order's billing contact details. */
  comWixEcomOrdersV1UpdateBillingContactDetails?: Maybe<ComWixEcomOrdersV1UpdateBillingContactDetailsResponse>;
  comWixEcomOrdersV1UpdateBuyerEmail?: Maybe<ComWixEcomOrdersV1UpdateBuyerEmailResponse>;
  /**
   * Updates an order's contact ID and/or email.
   * > **Note:** Neither `email`, nor `contactId` can be removed, only updated.
   */
  comWixEcomOrdersV1UpdateBuyerInfo?: Maybe<ComWixEcomOrdersV1UpdateBuyerInfoResponse>;
  comWixEcomOrdersV1UpdateComparisonStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusResponse>;
  /** Updates an order's line item descriptions. */
  comWixEcomOrdersV1UpdateLineItemsDescriptionLines?: Maybe<ComWixEcomOrdersV1UpdateLineItemsDescriptionLinesResponse>;
  comWixEcomOrdersV1UpdateMigrationFailed?: Maybe<ComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedResponse>;
  comWixEcomOrdersV1UpdateNewFlowOpen?: Maybe<ComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenResponse>;
  comWixEcomOrdersV1UpdateNoDataToMigrate?: Maybe<ComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateResponse>;
  /**
   * Updates an order's properties.
   *
   * <blockquote class="important">
   *
   * <strong>Currently, only the following fields can be updated:</strong>
   * + `order.buyerInfo.email`
   * + `order.buyerLanguage`
   * + `order.weightUnit`
   * + `order.billingInfo.address`
   * + `order.billingInfo.contactDetails`
   * + `order.archived`
   * + `order.attributionSource`
   * + `order.seenByAHuman`
   * + `order.recipientInfo.address`
   * + `order.recipientInfo.contactDetails`
   * + `order.shippingInfo.logistics.shippingDestination.address`
   * + `order.shippingInfo.logistics.shippingDestination.contactDetails`
   * + `order.extendedFields`
   *
   * </blockquote>
   *
   * To update a field's value, include the new value in the `order` object in the body params.
   * To remove a field's value, pass `null`.
   *
   * > **Note:** Removing `buyerInfo` or `contactDetails` results in an error.
   *
   * To update an order's payment status, use [Update Payment Status](https://dev.wix.com/docs/rest/business-solutions/e-commerce/order-transactions/update-payment-status).
   */
  comWixEcomOrdersV1UpdateOrder?: Maybe<ComWixEcomOrdersV1UpdateOrderResponse>;
  comWixEcomOrdersV1UpdateOrderLineItem?: Maybe<ComWixEcomOrdersV1UpdateOrderLineItemResponse>;
  /**
   * Updates multiple items of an order.
   * Currently, the following fields can be updated:
   * + `lineItem.productName`
   * + `lineItem.descriptionLines` (full replacement)
   * + `lineItem.digitalFile`
   * + `lineItem.priceDescription`
   */
  comWixEcomOrdersV1UpdateOrderLineItems?: Maybe<ComWixEcomOrdersV1UpdateOrderLineItemsResponse>;
  /**
   * Updates an order's shipping address and/or contact details.
   * > **Notes:**
   * > + Original order must have existing address to update - `order.shippingInfo.logistics.shippingDestination.address` must have existing value.
   * > + Neither `address`, nor `contactDetails` can be removed, only updated.
   */
  comWixEcomOrdersV1UpdateOrderShippingAddress?: Maybe<ComWixEcomOrdersV1UpdateOrderShippingAddressResponse>;
  /**
   * Updates order status.
   *
   * >CANCELED and REJECTED are final statuses. Update from either of those will fail.
   * >Updates into INITIALIZED are not supported.
   *
   * Approving order:
   * APPROVED status can be set while order has one of [INITIALIZED, PENDING] statuses.
   *
   * Approving an order which was created with CreateOrderRequest.settings.order_approval_strategy = PAYMENT_METHOD_SAVED
   * will cause an error.
   *
   * Setting PENDING status:
   * Only orders in INITIALIZED status can be updated into PENDING.
   */
  comWixEcomOrdersV1UpdateOrderStatus?: Maybe<ComWixEcomOrdersV1UpdateOrderStatusResponse>;
  comWixEcomOrdersV1UpsertRefund?: Maybe<WixEcomOrdersBackofficeV1UpsertRefundResponse>;
  /** Void authorized payment */
  comWixEcomOrdersV1VoidAuthorizedPayment?: Maybe<Scalars['Void']>;
  /**
   * Void authorized payments
   * Transaction statuses for related payments will be updated in async way
   */
  comWixEcomOrdersV1VoidAuthorizedPayments?: Maybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsResponse>;
  /**
   * Sets information about whether a booking's session was attended for multiple bookings
   *
   *
   * See [SetAttendance](https://dev.wix.com/docs/rest/api-reference/wix-bookings/attendance/set-attendance) documentation for more information.
   *
   * If any of the attendance list required fields were not passed on the request or if the caller doesn't have the required permissions to set the attendance, the call fails.
   * If the request contains attendance info for unavailable sessions, the call completes successfully but the attendance info for the unavailable sessions are not created and are not considered as failures in the response.
   */
  comWixpressBookingsAttendanceV2AttendanceBulkSetAttendance?: Maybe<ComWixpressBookingsAttendanceV2BulkSetAttendanceResponse>;
  /**
   * Sets or updates attendance information for multiple booking sessions.
   *
   *
   * Refer to Set Attendance for detailed behavior of individual attendance
   * entries.
   *
   * The call fails entirely if any entry in `attendanceDetails` is missing a
   * required field.
   *
   * If attendance details are provided for a non-existent session, the call
   * succeeds for valid sessions while marking the unavailable session as a
   * failure in the response.
   */
  comWixpressBookingsAttendanceV2BulkSetAttendance?: Maybe<ComWixpressBookingsAttendanceV2BulkSetAttendanceResponse>;
  /**
   * Counts attendance records by contact.
   *
   * Returns the total number of attendance records for the contact,
   * with optional filtering by attendance status and service IDs.
   *
   * Filtering options:
   * + **attendance_status**: Filter by attendance status (ATTENDED, NOT_ATTENDED)
   * + **service_id**: Filter by one or more service IDs from the bookings
   *
   * If no filters are provided, returns the total count of all attendance records
   * for the contact.
   */
  comWixpressBookingsAttendanceV2CountAttendances?: Maybe<ComWixpressBookingsAttendanceV2CountAttendancesResponse>;
  /**
   * Sets or updates attendance information for a booking session. This
   * information is stored in an `attendance` object.
   *
   * If an `attendance` object already exists for the session, it's updated.
   * Otherwise, a new object is created.
   *
   * By default, `numberOfAttendees` is set to `1`, but you can specify a higher
   * number if multiple participants attended. Do not set `numberOfAttendees` to
   * `0` to indicate no attendance, instead specify `{"status": "NOT_ATTENDED"}`.
   *
   * Validation guidelines:
   *
   * + The call succeeds for mismatches between `numberOfAttendees`
   * and `status`. For example, make sure that your code doesn't specify
   * `{"status": "NOT_ATTENDED"}` with `{"numberOfAttendees": 5}`.
   * + The API also allows `numberOfAttendees` to exceed the booking's
   * `numberOfParticipants`. Use higher values only when scenarios like
   * walk-ins justify the exception.
   */
  comWixpressBookingsAttendanceV2SetAttendance?: Maybe<ComWixpressBookingsAttendanceV2SetAttendanceResponse>;
  /** Creates multiple resources with corresponding schedules. */
  comWixpressBookingsResourcesCoreApiV1ResourceBatchCreate?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceResponse>;
  comWixpressBookingsResourcesCoreApiV1ResourceBatchDelete?: Maybe<Scalars['Void']>;
  comWixpressBookingsResourcesCoreApiV1ResourceBatchForceDelete?: Maybe<Scalars['Void']>;
  /**
   * Creates a resource.
   *
   *
   * Bookings resources are created with a schedule. The schedule and its sessions determine the resource's availability. Note that the schedule must contain a start date in the `availability.start` property.
   * For resources that are available during the business's default hours, add the business's schedule as a linked schedule in the resource's schedule. For resources that have their own hours, create sessions with type `"WORKING_HOURS"` using the resource's schedule.
   * You can use both individual and recurring sessions to define resource availability. You cannot use availability constraints for resource schedules.
   *
   * Use the following steps to create resources:
   * - Create the resource using including schedule information.
   * - If the resource uses the default business hours, get the business resource's schedule ID  and include it in the `scheduleInfo.availability.linkedSchedules` array in the schedule parameters.
   * - If the resource has its own custom working hours, create sessions of type `"WORKING_HOURS"`. Use the `scheduleId` of the new resource when creating the sessions. These session can be single sessions or recurring sessions. You can have both business hours and custom hours for the same resource schedule.
   *
   * >**Notes:**
   * > + A resource can have one schedule only.
   * > + You can have up to 135 active resources and an additional 135 deleted resources.
   * > + The `businessLocation.businessSchedule` object in the `schedule.location` object is not supported.
   *
   * >**Permissions:**
   * > This endpoint requires the Manage Bookings [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  comWixpressBookingsResourcesCoreApiV1ResourceCreate?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceResponse>;
  /**
   * Deletes a resource.
   *
   * Deleting a resource updates its `status` to `"DELETED"`.
   *
   * You cannot delete a resource if it has booked sessions.
   *
   * >**Notes:**
   * > + The Bookings app creates a resource with `"business"` in name and tag values. This resource is used for the business's schedule and working hours and cannot be deleted.
   * > + You can have up to 135 active resources and an additional 135 deleted resources.
   *
   * >**Permissions:**
   * > This endpoint requires the Manage Bookings [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  comWixpressBookingsResourcesCoreApiV1ResourceDelete?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceResponse>;
  /**
   * Returns the Business Resource.
   *
   * This endpoint is only implemented in the Resources V2 proxy.
   * When called for a site that is not rolled out to V2 an error is returned.
   */
  comWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceResponse>;
  /**
   * Links a resource to a Wix user.
   * The user will be assigned with the `Bookings Staff Member` role, via the `SitePoliciesManagement.AssignPolicies` API.
   *
   * Preconditions:
   * - The resource must not be linked to a user, or an active invite.
   * - The user must be a site contributor
   * - The user must not be linked to another resource.
   *
   * Note:
   * The site owner may be linked to a resource, but will not be assigned with the 'Bookings Staff Member' role.
   */
  comWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUser?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with [Query Resource](https://dev.wix.com/api/rest/wix-bookings/resources/list-resources/query-resource) and will be removed on March 31, 2022.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Retrieves a list of the resources according to the provided filters and paging.
   * Resources that are in a resource group (i.e. the group_id property contains an ID) are excluded from the result for backwards compatibility.
   * This query is optional. If no query is provided than all non-deleted resources are returned.
   *
   * |Property|Is supported|
   * |--|--|
   * |filter | supports `resource.id`, `resource.tag`, `resource.status`|
   * |paging | supported |
   * |fields | supported |
   * |fieldsets | **not supported** |
   * |sort| **not supported** |
   *
   * > **Permissions**
   * > This endpoint requires the Read Bookings Calendar, Read Bookings - Public Data, Read Bookings - Including Participants or Manage Bookings permission scope.
   */
  comWixpressBookingsResourcesCoreApiV1ResourceList?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceListResourcesResponse>;
  /**
   * Retrieves a list of the resources according to the specified filters and paging.
   *
   * The query parameter is optional. If no query is provided then all non-deleted resources are returned.
   * Resources that are in a resource group (i.e. the group_id property contains an ID) are excluded from the result for backwards compatibility unless the `include_resources_with_groups` request field is set to true.
   *
   * |Property|Is supported|
   * |--|--|
   * |filter | supported fields: `resource.id`, `resource.tags`, `resource.status`|
   * |paging | supported |
   * |fields | supported |
   * |fieldsets | **not supported**  |
   * |sort | **not supported**  |
   *
   *
   * >**Notes:**
   * > + The following objects in the `query` parameter are not supported for this query:
   * >    - `sort`
   * >    - `fieldsets`
   *
   * > **Permissions**
   * > This endpoint requires the Read Bookings Calendar, Read Bookings - Public Data, Read Bookings - Including Participants or Manage Bookings permission scope.
   */
  comWixpressBookingsResourcesCoreApiV1ResourceQuery?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesResponse>;
  /** Unlink a resource from the site owner. */
  comWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwner?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerResponse>;
  /**
   * Updates a resource.
   *
   *
   * Use this endpoint to update all resource information except for the resource's schedule. To update a resource's schedule use
   * the [Update Schedule](https://dev.wix.com/api/rest/wix-bookings/resources/update-schedule) endpoint.
   *
   * >**Notes:**
   * > + When updating a resource you cannot change the system tags used by the Wix Bookings app. Tags used by the app have the values `"business"` and `"staff"`.
   * > + When updating a resource's schedule you cannot change the resource tag used by the Wix Bookings app. Tags used by the app have the values `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE”`.
   * > + The `businessLocation.businessSchedule` object in the `schedule.location` object is not supported.
   *
   * >**Permissions:**
   * > This endpoint requires the Manage Bookings [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  comWixpressBookingsResourcesCoreApiV1ResourceUpdate?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceResponse>;
  /**
   * Updates a resource's schedule
   *
   *
   * To update a resource's schedule to remove business hours and add custom hours:
   * + Update the resource's schedule to remove the business's `scheduleId` from the `availability.linkedSchedules` array.
   * + Create a set of recurring sessions of type `"WORKING_HOURS"` to define the resource's new hours.
   *
   *
   *
   * To update a resource's schedule to add default business hours, and keep or remove custom hours:
   * + Update the resource's schedule to add the business resource's `scheduleId` to the `availability.linkedSchedules` array.
   * + If you want to remove the custom sessions, delete the resource's sessions of type `"WORKING_HOURS"`.
   * You do not have to delete exiting custom sessions. Custom session that are not deleted will continue to be included in availability  calculations and can still be booked.
   *
   * >**Notes:**
   * > + A resource can have one schedule only.
   * > + A resource can have both default business hours and custom hours in its schedule.
   * > + When updating a resource's schedule you cannot change the system tags used by the Wix Bookings app. Tags used by the app have the   values `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE”`.
   * > + The `businessLocation.businessSchedule` object in the `schedule.location` object is not supported.
   *
   * >**Permissions:**
   * > This endpoint requires the Manage Bookings [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  comWixpressBookingsResourcesCoreApiV1ResourceUpdateSchedule?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleResponse>;
  /**
   * Runs an aggregation on a data collection and returns the resulting list of items.
   *
   *
   * An aggregation enables you to perform certain calculations on your collection data, or on groups of items that you define, to retrieve meaningful summaries.
   * You can also add paging, filtering, and sorting preferences to your aggregation to retrieve exactly what you need.
   */
  comWixpressCloudDataApiDataAggregateDataItems?: Maybe<ComWixpressCloudDataApiDataAggregateDataItemsResponse>;
  /**
   * Runs an aggregation with advanced pipeline capability on a data collection and returns the resulting list of items.
   *
   *
   * An aggregation enables you to perform certain calculations on your collection data, or on groups of items that you define, to retrieve meaningful summaries.
   * You can also add paging, filtering, and sorting preferences to your aggregation to retrieve exactly what you need.
   */
  comWixpressCloudDataApiDataAggregatePipelineDataItems?: Maybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsResponse>;
  /**
   * Inserts one or more references in the specified fields of items in a collection.
   *
   *
   * This method adds one or more references to a collection.
   * Each new reference in the `dataItemReferences` field specifies a referring item's ID, the field in which to insert the reference, and the ID of the referenced item.
   */
  comWixpressCloudDataApiDataBulkInsertDataItemReferences?: Maybe<ComWixpressCloudDataApiDataBulkInsertDataItemReferencesResponse>;
  /**
   * Adds multiple items to a collection.
   *
   *
   * To add a single item, call Insert Data Item instead.
   *
   * When each item is inserted into a collection, its ID is automatically assigned a random value.
   * You can optionally provide your own ID when inserting the item. If you specify an ID that already exists in the collection, the insertion will fail.
   */
  comWixpressCloudDataApiDataBulkInsertDataItems?: Maybe<ComWixpressCloudDataApiDataBulkInsertDataItemsResponse>;
  /**
   * Patches one or more items in a collection.
   *
   *
   * This method modifies the existing data of one or more items. Unlike [`Bulk Update Data Item`](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/bulk-update-data-items), only the fields specified in the request are modified. Data that isn't explicitly modified remains unchanged.
   *
   * To patch items, specify the ID of the collection that contains them. For each item, specify its ID and the modifications you want to apply. If the item is found in the specified collection with the specified ID, that item is patched. If no such item is found, the response's `results` array contains a corresponding item whose `itemMetadata.error` property contains details about the error.
   *
   * Learn more about [Wix Data error codes](https://dev.wix.com/docs/rest/business-solutions/cms/wix-data-error-codes).
   *
   * > **Notes**:
   * > - When an item is patched, its `data._updatedDate` property is updated to the current date and time.
   * > - You can only patch items in [collections created by Wix users](https://support.wix.com/en/article/cms-formerly-content-manager-creating-a-collection). Items in [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code) cannot be patched.
   * > - Calling the `Bulk Patch Data Items` method triggers the [`Data Item Updated`](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-item-updated) event for each patched item.
   */
  comWixpressCloudDataApiDataBulkPatchDataItems?: Maybe<ComWixpressCloudDataApiDataBulkPatchDataItemsResponse>;
  /** Removes one or more references. */
  comWixpressCloudDataApiDataBulkRemoveDataItemReferences?: Maybe<ComWixpressCloudDataApiDataBulkRemoveDataItemReferencesResponse>;
  /**
   * Removes multiple items from a collection.
   *
   *
   * If any items in other collections reference the removed items in reference or multi-reference fields, those fields are cleared.
   *
   * > **Note:** Once an item has been removed from a collection, it can't be restored.
   */
  comWixpressCloudDataApiDataBulkRemoveDataItems?: Maybe<ComWixpressCloudDataApiDataBulkRemoveDataItemsResponse>;
  /**
   * Inserts or updates multiple items in a collection.
   *
   *
   * The Bulk Save Data Items method inserts or updates each item provided, depending on whether it already exists in the collection. For each item:
   *
   * + If you don't provide an ID, a new item is created.
   *
   * + If you provide an ID that doesn't exist in the collection, a new item is created with that ID.
   *
   * + If an item with the ID you provide already exists in the collection, that item is updated. When an item is updated, its `data._updatedDate` field is changed to the current date and time.
   *
   * > **Note:** When you provide an item with an ID that already exists in the collection, the item you provide completely replaces the existing item with that ID.
   * > This means that all of the item's previous fields and values are lost.
   */
  comWixpressCloudDataApiDataBulkSaveDataItems?: Maybe<ComWixpressCloudDataApiDataBulkSaveDataItemsResponse>;
  /**
   * Updates multiple items in a collection.
   *
   *
   * This method replaces each specified data item's existing data with the payload provided in the request.
   *
   * Each item in the request must include an ID. If an item is found in the specified collection with
   * the same ID, that item is updated. If the collection doesn't contain an item with that ID, the update fails.
   *
   * When an item is updated, its `data._updatedDate` field is changed to the current date and time.
   *
   * > **Note:**
   * > After each item is updated, it only contains the fields included in the request. If the existing item has fields with values and those fields
   * > aren't included in the updated item, their values are lost.
   */
  comWixpressCloudDataApiDataBulkUpdateDataItems?: Maybe<ComWixpressCloudDataApiDataBulkUpdateDataItemsResponse>;
  /** Counts the number of items in a data collection that match the provided filtering preferences. */
  comWixpressCloudDataApiDataCountDataItems?: Maybe<ComWixpressCloudDataApiDataCountDataItemsResponse>;
  /**
   * Adds an item to a collection.
   *
   *
   * To add multiple items, call Bulk Insert Data Items instead.
   *
   * An item can only be inserted into an existing collection.
   * You can create a new collection using the [Data Collections API](https://dev.wix.com/api/rest/wix-data/wix-data/data-collections).
   *
   * When an item is inserted into a collection, the item's ID is automatically assigned a random value.
   * You can optionally provide a custom ID in `dataItem.id` when inserting the item.
   * If you specify an ID that already exists in the collection, the insertion will fail.
   *
   * If `dataItem.data` is empty, a new item is created with no data fields.
   */
  comWixpressCloudDataApiDataInsertDataItem?: Maybe<ComWixpressCloudDataApiDataInsertDataItemResponse>;
  /**
   * Inserts a reference in the specified field in an item in a collection.
   *
   *
   * A reference in the `dataItemReference` field specifies a referring item's ID, the field in which to insert the reference, and the ID of the referenced item.
   */
  comWixpressCloudDataApiDataInsertDataItemReference?: Maybe<ComWixpressCloudDataApiDataInsertDataItemReferenceResponse>;
  /** Checks whether a field in a referring item contains a reference to a specified item. */
  comWixpressCloudDataApiDataIsReferencedDataItem?: Maybe<ComWixpressCloudDataApiDataIsReferencedDataItemResponse>;
  /**
   * Patches an item in a collection.
   *
   * This method modifies the specified item's existing data. Unlike [`Update Data Item`](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/update-data-item), only the fields specified in the request are modified. Data that isn't explicitly modified remains unchanged.
   *
   * To patch an item, specify its ID, the ID of the collection that contains it, and the modifications you want to apply. If an item is found in the specified collection with the specified ID, that item is patched. If the collection doesn't contain an item with that ID, the request fails.
   *
   * > **Notes**:
   * > - When an item is patched, its `data._updatedDate` property is updated to the current date and time.
   * > - You can only patch items in [collections created by Wix users](https://support.wix.com/en/article/cms-formerly-content-manager-creating-a-collection). Items in [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code) cannot be patched.
   */
  comWixpressCloudDataApiDataPatchDataItem?: Maybe<ComWixpressCloudDataApiDataPatchDataItemResponse>;
  /**
   * Retrieves a list of distinct values for a given field in all items that match a query, without duplicates.
   *
   *
   * As with the [Query Data Items](https://dev.wix.com/api/rest/wix-data/wix-data/data-items/query-data-items) method, this method retrieves items based on the filtering, sorting, and paging preferences you provide.
   * However, the Query Distinct Values method doesn't return all of the full items that match the query.
   * Rather, it returns all unique values of the field you specify in `fieldName` for items that match the query.
   * If more than one item has the same value for that field, that value appears only once.
   *
   * Learn more about [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressCloudDataApiDataQueryDistinctValues?: Maybe<ComWixpressCloudDataApiDataQueryDistinctValuesResponse>;
  /**
   * Retrieves the full items referenced in the specified field of an item.
   *
   *
   * Reference and multi-reference fields refer to items in different collections.
   * Use this method to retrieve the full details of the referenced items themselves.
   *
   * For example, suppose you have a **Movies** collection with an **Actors** field that contains references to items in a **People** collection.
   * Querying the **Movies** collection using the Query Referenced Data Items method returns the relevant **People** items referenced in the **Actors** field of the specified **Movie** item.
   * This gives you information from the **People** collection about each of the actors in the specified movie.
   */
  comWixpressCloudDataApiDataQueryReferencedDataItems?: Maybe<ComWixpressCloudDataApiDataQueryReferencedDataItemsResponse>;
  /**
   * Removes an item from a collection.
   *
   *
   * If any items in other collections reference the removed item in reference or multi-reference fields, those fields are cleared.
   *
   * > **Note:**
   * > Once an item has been removed from a collection, it can't be restored.
   */
  comWixpressCloudDataApiDataRemoveDataItem?: Maybe<ComWixpressCloudDataApiDataRemoveDataItemResponse>;
  /** Removes the specified reference from the specified field. */
  comWixpressCloudDataApiDataRemoveDataItemReference?: Maybe<ComWixpressCloudDataApiDataRemoveDataItemReferenceResponse>;
  /**
   * Replaces references in a specified field of a specified data item.
   *
   *
   * This method replaces the existing reference or references contained in the field specified in `referringItemFieldName` within the data item specified in `referringItemId`.
   * The method removes existing references and in their place it adds references to the items specified in `newReferencedItemIds`.
   *
   * > **Note:** If you pass an empty array in `newReferencedItemIds`, all existing references are removed.
   */
  comWixpressCloudDataApiDataReplaceDataItemReferences?: Maybe<ComWixpressCloudDataApiDataReplaceDataItemReferencesResponse>;
  /**
   * Inserts or updates an item in a collection.
   *
   *
   * The Save Data Item method inserts or updates the specified item, depending on whether it already exists in the collection.
   *
   * + If you don't provide an ID, a new item is created.
   *
   * + If you provide an ID that does not exist in the collection, a new item is created with that ID.
   *
   * + If an item with the ID you provide already exists in the collection, that item is updated. When an item is updated, its `data._updatedDate` field is changed to the current date and time.
   *
   * > **Note:** When you provide an item with an ID that already exists in the collection, the payload you provide in `dataItem.data` replaces the existing item with that ID.
   * > This means that the item's previous fields and values are lost.
   */
  comWixpressCloudDataApiDataSaveDataItem?: Maybe<ComWixpressCloudDataApiDataSaveDataItemResponse>;
  /**
   * Searches for items in a collection on the basis of the filtering, sorting, searching, and paging preferences you provide.
   *
   * Learn more about [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   *
   * > **Notes:**
   * > - You can only search collections [created in the CMS](https://support.wix.com/en/article/cms-formerly-content-manager-creating-a-collection) or with the [Data Collections API](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/introduction). Searching isn't currently supported for [Wix app collections](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) or [external collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site).
   * > - Filtering is only supported for fields explicitly defined in the [data collection structure](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/introduction#data-collections-and-their-structure). Fields not defined in the collection structure cannot be used for filtering.
   * > - Searching for data items is always [eventually consistent](https://dev.wix.com/docs/rest/business-solutions/cms/eventual-consistency).
   *
   * ### Supported filter operators by field type
   *
   * Each [field type](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-type) supports a specific set of [filter operators](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#operators). Using a filter operator that's not supported for a given field type causes the search to fail.
   *
   * | Field Type | Supported Filter Operators |
   * |------------|----------------------------|
   * | Text, Image, Document, URL, Video, Audio, Time, Reference, [Page Link](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#page-link-fields), [Rich Text](https://dev.wix.com/docs/rest/articles/get-started/rich-text), [Rich Content](https://dev.wix.com/docs/ricos/getting-started/introduction), Address | `$in`, `$eq`, `$ne`, `$gt`, `$gte`, `$lt`, `$lte`, `$isEmpty`, `$startsWith` |
   * | Number, Date, Date and Time | `$eq`, `$ne`, `$gt`, `$gte`, `$lt`, `$lte`, `$exists` |
   * | Boolean | `$eq`, `$ne`, `$exists` |
   * | Array of strings | `$hasSome`, `$hasAll`, `$exists` |
   * | Array, Document Array, Object, Any, Media Gallery | `$exists` |
   *
   * Learn more about [data types in Wix Data](https://dev.wix.com/docs/sdk/backend-modules/data/data-types-in-wix-data).
   */
  comWixpressCloudDataApiDataSearchDataItems?: Maybe<ComWixpressCloudDataApiDataSearchDataItemsResponse>;
  /**
   * Removes all items from a collection.
   *
   *
   * If any items in other collections reference the removed items in reference or multi-reference fields, those fields are cleared.
   *
   * > **Note:**
   * > Once items have been removed from a collection, they can't be restored.
   */
  comWixpressCloudDataApiDataTruncateDataItems?: Maybe<Scalars['Void']>;
  /**
   * Updates an item in a collection.
   *
   *
   * This method replaces the data item's existing data with the payload provided in `dataItem.data` in the request.
   *
   * To update an item, you need to specify an item ID and a collection ID.
   * If an item is found in the specified collection with the specified ID, that item is updated.
   * If the collection doesn't contain an item with that ID, the request fails.
   *
   * When an item is updated, its `data._updatedDate` field is changed to the current date and time.
   *
   * > **Note:**
   * > After an item is updated, it only contains the fields included in the `dataItem.data` payload in Update Data Item request. If the existing item has fields with values and those fields aren't included in the updated item, their values are lost.
   */
  comWixpressCloudDataApiDataUpdateDataItem?: Maybe<ComWixpressCloudDataApiDataUpdateDataItemResponse>;
  /** Add a segment to contacts */
  comWixpressContactsCoreApiV4BulkAddSegmentToContacts?: Maybe<ComWixpressContactsCoreApiV4BulkAddSegmentToContactsResponse>;
  /**
   * Deletes multiple contacts.
   *
   * All contacts that meet the specified `filter` and `search` criteria are deleted.
   * The request should contain a `filter` value or a `search` value, or both.
   * To perform a dry run, call Query Contacts with the intended filter options.
   *
   * When this method is called, a bulk job is started and the job ID is returned.
   * The job might not complete right away, depending on its size.
   * The job's status can be retrieved with Get Bulk Job.
   *
   * The following errors might occur during the bulk processing and will appear in the bulk job:
   * - `CANNOT_DELETE_SITE_MEMBERS` - Contact is a site member and can't be deleted. Member must be deleted first.
   * - `CANNOT_DELETE_CONTACT_WITH_BILLING_SUBSCRIPTION` - Contact has a valid billing subscription and can't be deleted.
   * - `CANNOT_DELETE_MEMBER_OWNER_OR_CONTRIBUTOR` - Member is a Wix user and can't be deleted. This can happen only if the request indicated to delete the member.
   * - `FAILED_DELETE_CONTACT_AFTER_MEMBER_DELETION` - Member was deleted, but contact was not. This can happen only if the request indicated to delete the member.
   * - `FAILED_DELETE_CONTACT` - Contact could not be deleted.
   */
  comWixpressContactsCoreApiV4BulkDeleteContacts?: Maybe<ComWixpressContactsCoreApiV4BulkDeleteContactsResponse>;
  /**
   * Adds and removes labels from multiple contacts.
   *
   * Labels are added to and removed from all contacts that meet the specified
   * `filter` and `search` criteria.
   * The request should specify a `filter` value, a `search` value, or both.
   * To perform a dry run, call Query Contacts with the intended filter options.
   *
   * When this method is used, a bulk job is started and the job ID is returned.
   * The job might not complete right away, depending on its size.
   * The job's status can be retrieved with Get Bulk Job.
   */
  comWixpressContactsCoreApiV4BulkLabelAndUnlabelContacts?: Maybe<ComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsResponse>;
  /** Remove a segment from contacts */
  comWixpressContactsCoreApiV4BulkRemoveSegmentFromContacts?: Maybe<ComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsResponse>;
  /**
   * Updates the specified properties for multiple contacts.
   * Fields that are included in fieldMask.paths are updated,
   * while all other fields stay the same.
   *
   * All contacts that meet the specified `filter` and `search` criteria are updated.
   * To perform a dry run, call Query Contacts with the intended filter options.
   *
   * When this method is used, a bulk job is started and the job ID is returned.
   * The job may not complete right away, depending on its size.
   * The job's status can be retrieved with Get Bulk Job.
   */
  comWixpressContactsCoreApiV4BulkUpdateContacts?: Maybe<ComWixpressContactsCoreApiV4BulkUpdateContactsResponse>;
  /** Upserts multiple contacts. */
  comWixpressContactsCoreApiV4BulkUpsertContacts?: Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponse>;
  comWixpressContactsCoreApiV4CountContacts?: Maybe<ComWixpressContactsCoreApiV4CountContactsResponse>;
  /**
   * Creates a new contact.
   *
   * The `info` object must include at least one of the following:
   * - Name
   * - Phone number
   * - Email address
   *
   * By default, if the call contains an email already in use by another contact,
   * the new contact won't be created. To override this behavior, set `allowDuplicates` to `true`.
   */
  comWixpressContactsCoreApiV4CreateContact?: Maybe<ComWixpressContactsCoreApiV4CreateContactResponse>;
  /**
   * Deletes a contact.
   *
   * Deleting a contact permanently removes it from the contact list.
   * If a contact is also a site member or Wix user, or has a valid billing subscription,
   * the contact can't be deleted. The related site member or Wix user must first be deleted
   * and any valid billing subscriptions must be canceled, before the contact can be deleted.
   *
   * Members are typically linked to contacts, and while they share a relationship, the member ID and contact ID are distinct identifiers.
   * Make sure to specify the contact ID when calling Delete Contact.
   */
  comWixpressContactsCoreApiV4DeleteContact?: Maybe<Scalars['Void']>;
  /** Generates an URL that can be used to upload a contact picture */
  comWixpressContactsCoreApiV4GeneratePictureUploadUrl?: Maybe<ComWixpressContactsCoreApiV4GeneratePictureUploadUrlResponse>;
  /**
   * Adds and removes labels from a contact.
   * The requested labels must already exist for the site.
   * To create new labels, use
   * [Find or Create Label](https://dev.wix.com/api/rest/contacts/labels/find-or-create-label)
   * (in the Contact Labels API) before running this request.
   */
  comWixpressContactsCoreApiV4LabelAndUnlabelContact?: Maybe<ComWixpressContactsCoreApiV4LabelAndUnlabelContactResponse>;
  /**
   * Adds labels to a contact.
   *
   * Use the Labels API to create or retrieve labels.
   *
   * Members are typically linked to contacts, and while they share a relationship, the member ID and contact ID are distinct identifiers.
   * Make sure to specify the contact ID when calling Label Contact.
   */
  comWixpressContactsCoreApiV4LabelContact?: Maybe<ComWixpressContactsCoreApiV4LabelContactResponse>;
  /** Query contact ids by segment id */
  comWixpressContactsCoreApiV4ListContactIdsBySegment?: Maybe<ComWixpressContactsCoreApiV4ListContactIdsBySegmentResponse>;
  /** Retrieves a list of up to 1,000 contacts per request. */
  comWixpressContactsCoreApiV4ListContacts?: Maybe<ComWixpressContactsCoreApiV4ListContactsResponse>;
  /**
   * Lists facets from the site’s contact list.
   * Facets include labels and subscription statuses.
   */
  comWixpressContactsCoreApiV4ListFacets?: Maybe<ComWixpressContactsCoreApiV4ListFacetsResponse>;
  /**
   * Merges source contacts into a target contact.
   *
   * Merging contacts has the following effects on the target contact:
   *
   * - No target contact data is overwritten or deleted.
   * - Arrays (emails, phone numbers, addresses, and labels) from the source contacts are added to the target contact's arrays.
   * - If you merge more than one source contact, the 1st source contact specified is added first, then the 2nd, and so on.
   * - If there is duplicate information between the target contact and the source contact, the information isn't duplicated in the target contact's arrays.
   *
   * <blockquote class="important">
   *
   * __Important:__
   * Merges cannot be undone.
   * In REST, call Preview Merge Contacts to test before merging.
   *
   * </blockquote>
   *
   * When you merge contacts, source contacts are typically deleted.
   * However, if a source contact is a site member or a Wix user,
   * the merge will fail because site members and Wix users can't be deleted.
   * This means that site members and Wix users can only be specified as target contacts in a merge.
   *
   * After merging, calling Get Contact with a deleted source contact ID returns the target contact ID.
   * Specifying a deleted source contact ID is not supported on any other method.
   *
   * When contacts are merged:
   *
   * - The Contact Merged event is triggered.
   * - The Contact Updated event is triggered for the target contact. `originatedFrom` is set to `merge`.
   * - The Contact Deleted event is triggered for each source contact. `originatedFrom` is set to `merge`.
   */
  comWixpressContactsCoreApiV4MergeContacts?: Maybe<ComWixpressContactsCoreApiV4MergeContactsResponse>;
  /**
   * Previews merging source contacts into a target contact.
   *
   * This method performs a dry run without deleting or updating any contacts.
   * A preview of the updated target contact is returned,
   * but no data is changed in the contact list.
   *
   * To perform the actual merge, use Merge Contacts.
   */
  comWixpressContactsCoreApiV4PreviewMergeContacts?: Maybe<ComWixpressContactsCoreApiV4PreviewMergeContactsResponse>;
  /**
   * Retrieves facets from the site’s contact list by filter.
   * Facets include labels and subscription statuses.
   */
  comWixpressContactsCoreApiV4QueryFacets?: Maybe<ComWixpressContactsCoreApiV4QueryFacetsResponse>;
  /**
   * Retrieves a list of contacts, given the provided cursorPaging, [filtering, and sorting](https://dev.wix.com/api/rest/contacts/contacts/sorting,-filtering,-and-searching).
   * Up to 1,000 contacts can be returned per request.
   *
   * For a detailed list of supported operations, see
   * filtering and sorting for
   * [contact properties](https://dev.wix.com/api/rest/contacts/contacts/sorting,-filtering,-and-searching#contact-properties-filtering-sorting-and-searching),
   * [extended fields](https://dev.wix.com/api/rest/contacts/contacts/sorting,-filtering,-and-searching#extended-fields-filtering-sorting-and-searching),
   * and [custom fields](https://dev.wix.com/api/rest/contacts/contacts/sorting,-filtering,-and-searching#custom-fields-filtering-sorting-and-searching).
   * To learn how to query contacts, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressContactsCoreApiV4SearchContacts?: Maybe<ComWixpressContactsCoreApiV4SearchContactsResponse>;
  comWixpressContactsCoreApiV4SyncSubmitContact?: Maybe<Scalars['Void']>;
  /**
   * Removes labels from a contact.
   *
   * If a label is no longer needed
   * and you want to remove it from all contacts,
   * you can delete by calling Delete Label from the Labels API.
   *
   * Members are typically linked to contacts, and while they share a relationship, the member ID and contact ID are distinct identifiers.
   * Make sure to specify the contact ID when calling Unlabel Contact.
   */
  comWixpressContactsCoreApiV4UnlabelContact?: Maybe<ComWixpressContactsCoreApiV4UnlabelContactResponse>;
  /**
   * Updates a contact.
   *
   * Each time the contact is updated,
   * `revision` increments by 1.
   * The existing `revision` must be included when updating the contact.
   * This ensures you're working with the latest contact information,
   * and it prevents unintended overwrites.
   *
   * You can't call Update Contact to update the `primaryEmail` of a contact who is also a member.
   * Instead, use the Members API to update the member's login email, which will also update the contact's primary email.
   *
   * Members are typically linked to contacts, and while they share a relationship, the member ID and contact ID are distinct identifiers. Make sure to specify the contact ID when calling Update Contact.
   */
  comWixpressContactsCoreApiV4UpdateContact?: Maybe<ComWixpressContactsCoreApiV4UpdateContactResponse>;
  /** Update the requested contact, when found by given email and/or phone, otherwise create the contact. */
  comWixpressContactsCoreApiV4UpsertContact?: Maybe<ComWixpressContactsCoreApiV4UpsertContactResponse>;
  /**
   * Deletes an extended field.
   *
   * When an extended field is deleted,
   * any contact data stored in the field is also permanently deleted.
   */
  comWixpressContactsFieldsV4DeleteExtendedField?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a custom field with a specified name, or creates one if it doesn't exist.
   * The number of custom fields is limited to 100.
   *
   * Successful calls to this method always return a field,
   * which can be specified in subsequent calls.
   *
   * To find an existing custom field without potentially creating a new one, call Get Extended Field or
   * Query Extended Fields.
   */
  comWixpressContactsFieldsV4FindOrCreateExtendedField?: Maybe<ComWixpressContactsFieldsV4FindOrCreateExtendedFieldResponse>;
  comWixpressContactsFieldsV4GdprList?: Maybe<ComWixpressContactsFieldsV4GdprListResponse>;
  /** Get field by legacy id. */
  comWixpressContactsFieldsV4GetExtendedFieldByLegacyId?: Maybe<ComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdResponse>;
  /** Retrieves a list of extended fields. */
  comWixpressContactsFieldsV4ListExtendedFields?: Maybe<ComWixpressContactsFieldsV4ListExtendedFieldsResponse>;
  comWixpressContactsFieldsV4Purge?: Maybe<ComWixpressContactsFieldsV4PurgeResponse>;
  /** Renames an extended field. */
  comWixpressContactsFieldsV4UpdateExtendedField?: Maybe<ComWixpressContactsFieldsV4UpdateExtendedFieldResponse>;
  /** Deletes the specified label from a site and removes it from the contacts it applies to. */
  comWixpressContactsLabelsV4DeleteLabel?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a label with a specified name, or creates one if it doesn't exist.
   *
   * Successful calls to this method always return a label,
   * which can be specified in subsequent calls.
   *
   * For example, in the Contacts API, Label Contact and Unlabel Contact
   * calls will fail if you include a non-existent label.
   * To ensure successful calls, you can call this method first,
   * and then use the response in the Label Contact and Unlabel Contact calls.
   *
   * To find an existing label without potentially creating a new one, call
   * Get Label or Query Labels.
   */
  comWixpressContactsLabelsV4FindOrCreateLabel?: Maybe<ComWixpressContactsLabelsV4FindOrCreateLabelResponse>;
  comWixpressContactsLabelsV4GdprList?: Maybe<ComWixpressContactsLabelsV4GdprListResponse>;
  /** Get label */
  comWixpressContactsLabelsV4GetLabelByLegacyId?: Maybe<ComWixpressContactsLabelsV4GetLabelByLegacyIdResponse>;
  /** Lists Namespaces. */
  comWixpressContactsLabelsV4ListLabelNamespaces?: Maybe<ComWixpressContactsLabelsV4ListLabelNamespacesResponse>;
  /** Lists all contact labels for a site. */
  comWixpressContactsLabelsV4ListLabels?: Maybe<ComWixpressContactsLabelsV4ListLabelsResponse>;
  comWixpressContactsLabelsV4Purge?: Maybe<ComWixpressContactsLabelsV4PurgeResponse>;
  /** Renames a label. */
  comWixpressContactsLabelsV4UpdateLabel?: Maybe<ComWixpressContactsLabelsV4UpdateLabelResponse>;
  /**
   * Add location type to a specific location.
   *
   * > **Notes:**
   * > + Add one the location type (UNKNOWN, BRANCH, OFFICES, RECEPTION, HEADQUARTERS, INVENTORY) to a specific location by id.
   * > + This EP is deprecated - Please use AddTypeFromLocation instead.
   */
  comWixpressLocationsAddLocationType?: Maybe<ComWixpressLocationsAddLocationTypeResponse>;
  /** Adds a location type to the specified location. */
  comWixpressLocationsAddTypeToLocation?: Maybe<ComWixpressLocationsAddTypeToLocationResponse>;
  /**
   * Archives a location.
   *
   *
   * > **Notes:**
   * > + Changes the `archived` boolean of a location to `true`.
   * > + You can't change a location's `status` using this endpoint.
   * > + Archived locations can't be updated.
   * > + The `default` location can't be archived.
   */
  comWixpressLocationsArchiveLocation?: Maybe<ComWixpressLocationsArchiveLocationResponse>;
  /** Creates locations in bulk. */
  comWixpressLocationsBulkCreateLocation?: Maybe<ComWixpressLocationsBulkCreateLocationResponse>;
  /**
   * Replaces locations in bulk.
   *
   *
   * > **Note:** Currently, it isn't possible to partially update a location. Therefore, you'll need to pass the full location object in the body of the call.
   */
  comWixpressLocationsBulkUpdateLocation?: Maybe<ComWixpressLocationsBulkUpdateLocationResponse>;
  /** Creates a location. */
  comWixpressLocationsCreateLocation?: Maybe<ComWixpressLocationsCreateLocationResponse>;
  /** Retrieves locations, given the specified filters, sorting, and paging. */
  comWixpressLocationsListLocations?: Maybe<ComWixpressLocationsListLocationsResponse>;
  /**
   * Remove location type from a specific location.
   *
   * > **Notes:**
   * > + Remove location type (UNKNOWN, BRANCH, OFFICES, RECEPTION, HEADQUARTERS, INVENTORY) from a specific location by id.
   * > + This EP is deprecated - Please use RemoveTypeFromLocation instead.
   */
  comWixpressLocationsRemoveLocationType?: Maybe<ComWixpressLocationsRemoveLocationTypeResponse>;
  /** Removes a location type from the specified location. */
  comWixpressLocationsRemoveTypeFromLocation?: Maybe<ComWixpressLocationsRemoveTypeFromLocationResponse>;
  /**
   * Sets a new default location.
   *
   *
   * > **Notes:**
   * > + There can only be one default location per site.
   * > + The default location can't be archived.
   */
  comWixpressLocationsSetDefaultLocation?: Maybe<ComWixpressLocationsSetDefaultLocationResponse>;
  /**
   * Unarchives a location.
   *
   * > **Notes:**
   * > + Changes the `archived` boolean of a location to `false`.
   * > + You can't change a location's `status` using this endpoint.
   */
  comWixpressLocationsUnarchiveLocation?: Maybe<ComWixpressLocationsUnarchiveLocationResponse>;
  /**
   * Overrides an existing location.
   *
   *
   * > **Note:** Currently, it isn't possible to partially update a location. Therefore, you'll need to pass the full location object in the body of the call.
   */
  comWixpressLocationsUpdateLocation?: Maybe<ComWixpressLocationsUpdateLocationResponse>;
  /**
   * Changes member status to `"APPROVED"` and gives access to members-only pages.
   *
   * Call this API to:
   * - Approve a pending member.
   * - Unblock a blocked member.
   */
  comWixpressMembersApiApproveMember?: Maybe<ComWixpressMembersApiApproveMemberResponse>;
  /**
   * Blocks a member.
   *
   * A blocked member can't log in to members-only pages.
   *
   * To unblock a member, call Approve Member.
   */
  comWixpressMembersApiBlockMember?: Maybe<ComWixpressMembersApiBlockMemberResponse>;
  /**
   * Changes status of multiple members to `"APPROVED"`, and gives access to members-only pages.
   *
   * Call this API to:
   * - Approve pending members.
   * - Unblock blocked members.
   */
  comWixpressMembersApiBulkApproveMembers?: Maybe<ComWixpressMembersApiBulkApproveMembersResponse>;
  /**
   * Blocks multiple members by a specified filter.
   *
   * Blocked members can't log in to members-only pages.
   *
   * To unblock multiple members, call Bulk Approve Members.
   */
  comWixpressMembersApiBulkBlockMembers?: Maybe<ComWixpressMembersApiBulkBlockMembersResponse>;
  /**
   * Deletes multiple members by `memberId`.
   *
   * All content created by these members is transferred to a site owner's account. For example, if Wix users had blog posts, those posts are transferred to the site owner's account, which then becomes the owner of those posts.
   */
  comWixpressMembersApiBulkDeleteMembers?: Maybe<ComWixpressMembersApiBulkDeleteMembersResponse>;
  /**
   * Deletes multiple members by the specified filter.
   *
   * All content created by these members is transferred to a site owner's account. For example, if Wix users had blog posts, those posts are transferred to the site owner's account, which then becomes the owner of those posts.
   */
  comWixpressMembersApiBulkDeleteMembersByFilter?: Maybe<ComWixpressMembersApiBulkDeleteMembersByFilterResponse>;
  comWixpressMembersApiConsumeAddActivityToContactMessageV2?: Maybe<Scalars['Void']>;
  comWixpressMembersApiConsumeIdentityDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressMembersApiConsumeMemberPiiDataExchangeDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressMembersApiConsumeMetaSiteSpecialNoProvisioningEvents?: Maybe<Scalars['Void']>;
  comWixpressMembersApiConsumeProfileDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressMembersApiConsumeSiteMemberProfileUpdate?: Maybe<Scalars['Void']>;
  /**
   * Creates a site member.
   *
   * After creation, you can call
   * [Send Set Password Email ([SDK](https://dev.wix.com/docs/sdk/backend-modules/members/authentication/send-set-password-email) | [REST](https://dev.wix.com/docs/rest/crm/members-contacts/members/member-authentication/send-set-password-email))
   * to email the member with a link to set their password.
   * The member can log in to the site
   * when they set their password for the first time.
   *
   * > **Note:**
   * > When creating multiple members,
   * > set your requests at least 1 second apart to keep below rate limits.
   */
  comWixpressMembersApiCreateMember?: Maybe<ComWixpressMembersApiCreateMemberResponse>;
  /**
   * Deletes a member by ID.
   *
   * All content created by this member is transferred to a site owner's account. For example, if a Wix user had blog posts, those posts are transferred to the site owner's account, which then becomes the owner of those posts.
   */
  comWixpressMembersApiDeleteMember?: Maybe<Scalars['Void']>;
  /**
   * Clears a member's street addresses.
   *
   * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
   */
  comWixpressMembersApiDeleteMemberAddresses?: Maybe<ComWixpressMembersApiDeleteMemberAddressesResponse>;
  /**
   * Clears a member's email addresses.
   *
   * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
   *
   * > Note: A member can still log in with their `loginEmail`, which is not cleared when this method is called.
   */
  comWixpressMembersApiDeleteMemberEmails?: Maybe<ComWixpressMembersApiDeleteMemberEmailsResponse>;
  /**
   * Clears a member's phone numbers.
   *
   * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
   */
  comWixpressMembersApiDeleteMemberPhones?: Maybe<ComWixpressMembersApiDeleteMemberPhonesResponse>;
  /**
   * Deletes the current member.
   *
   * After calling this method, the member is logged out of the site.
   *
   * All content created by this member is transferred to another account. For example, if a Wix user had blog posts, those posts are transferred to the account specified in `contentAssignedId`, which then becomes the owner of those posts.
   *
   * >**Note:**
   * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
   */
  comWixpressMembersApiDeleteMyMember?: Maybe<Scalars['Void']>;
  /**
   * Disconnects a member.
   *
   * A disconnected member can't log in to members-only pages, and the member isn't visible in the dashboard.
   *
   * >**Note:** This action is irreversible. To connect the same member again, you have to create a member with a new slug.
   */
  comWixpressMembersApiDisconnectMember?: Maybe<ComWixpressMembersApiDisconnectMemberResponse>;
  /**
   * Retrieves the current member.
   *
   * >**Note:**
   * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
   */
  comWixpressMembersApiGetMyMember?: Maybe<ComWixpressMembersApiGetMyMemberResponse>;
  /**
   * Joins the currently logged-in member to the site community and sets their profile to public.
   *
   * When a member's profile is public, they have access to the site's
   * [Members Area](https://support.wix.com/en/article/about-members-area)
   * features — such as chat, forum, and followers —
   * and their profile is visible to other members and site visitors.
   *
   * >**Note:**
   * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
   */
  comWixpressMembersApiJoinCommunity?: Maybe<ComWixpressMembersApiJoinCommunityResponse>;
  /**
   * Removes the currently logged-in member from the site community and sets their profile to private.
   *
   * When a member's profile is private,
   * they do not have access to the site's
   * [Members Area](https://support.wix.com/en/article/about-members-area)
   * features — such as chat, forum, and followers —
   * and their profile is hidden from other members and site visitors.
   *
   * > **Notes:**
   * > - If a member leaves the site's community, their content (such as forum posts and blog comments) remain publicly visible.
   * > - This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
   */
  comWixpressMembersApiLeaveCommunity?: Maybe<ComWixpressMembersApiLeaveCommunityResponse>;
  /** Lists site members, given the provided paging and fieldsets. */
  comWixpressMembersApiListMembers?: Maybe<ComWixpressMembersApiListMembersResponse>;
  /**
   * Mutes a member.
   *
   * Muted members can't engage with a community. For example, they can't leave comments, like posts or comments, or share content.
   *
   * You can mute members in [Wix Blog](https://dev.wix.com/docs/rest/business-solutions/blog/introduction) and [Wix Forum](https://dev.wix.com/docs/rest/business-solutions/forum/introduction).
   */
  comWixpressMembersApiMuteMember?: Maybe<ComWixpressMembersApiMuteMemberResponse>;
  /**
   * Unmutes a member.
   *
   * Unmuted members can engage with the community. For example, leave comments, like posts or comments, and share content.
   *
   * You can unmute members in [Wix Blog](https://dev.wix.com/docs/rest/business-solutions/blog/introduction) and [Wix Forum](https://dev.wix.com/docs/rest/business-solutions/forum/introduction).
   */
  comWixpressMembersApiUnmuteMember?: Maybe<ComWixpressMembersApiUnmuteMemberResponse>;
  /**
   * Updates a member's properties.
   *
   * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
   *
   * `privacyStatus` can't be updated with Update Member. A member can call Leave Community or Join Community to update their `privacyStatus`.
   *
   * To clear a field's value, set an empty value with an empty string `""`.
   *
   * Note that updating the `contact.addresses`, `contact.emails`, or `contact.phones` array overwrites
   * the entire array, so any existing values you want to retain should be specified in the Update Member call
   * along with the new values to add. However, passing an empty array will have no effect and the following
   * methods must be called to clear all the data from these respective arrays:
   * - To clear `contact.addresses`, call Delete Member Addresses.
   * - To clear `contact.emails`, call Delete Member Emails.
   * - To clear `contact.phones`, call Delete Member Phones.
   */
  comWixpressMembersApiUpdateMember?: Maybe<ComWixpressMembersApiUpdateMemberResponse>;
  /** Updates a member's slug. */
  comWixpressMembersApiUpdateMemberSlug?: Maybe<ComWixpressMembersApiUpdateMemberSlugResponse>;
  /**
   * Updates the current member's slug.
   *
   * >**Note:**
   * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
   */
  comWixpressMembersApiUpdateMySlug?: Maybe<ComWixpressMembersApiUpdateMySlugResponse>;
  /**
   * Archives a single plan.
   * When a plan is archived, it is no longer visible as a public plan that can be chosen by site members or visitors. Archived plans cannot be purchased.
   * An archived plan cannot be made active again.
   * Plan archiving does not impact existing orders made for the plan. All orders for the plan are still active and keep their perks.
   * Site owners can see archived plans in the Dashboard under Pricing Plans -> Archived Plans.
   */
  comWixpressMembershipV2PlansArchivePlan?: Maybe<ComWixpressMembershipV2PlansArchivePlanResponse>;
  /**
   * Changes the display order of the plans on the site. To rearrange the order of the plans, provide a list of plan IDs in the desired order.
   * Include all public and hidden plans in the list you provide.
   * Make sure to provide all non-archived plan IDs to avoid unpredictable results
   */
  comWixpressMembershipV2PlansArrangePlans?: Maybe<Scalars['Void']>;
  /**
   * Archives multiple plans.
   * See "Archives a single plan" for more information.
   */
  comWixpressMembershipV2PlansBulkArchivePlan?: Maybe<ComWixpressMembershipV2PlansBulkArchivePlanResponse>;
  /** Sets all pricing plans as not primary. When viewing pricing plans on the site, no plan is highlighted with a customizable ribbon. */
  comWixpressMembershipV2PlansClearPrimary?: Maybe<Scalars['Void']>;
  /** Creates a pricing plan. */
  comWixpressMembershipV2PlansCreatePlan?: Maybe<ComWixpressMembershipV2PlansCreatePlanResponse>;
  /** Gets statistics about the pricing plans. Currently providing only the total number of pricing plans. */
  comWixpressMembershipV2PlansGetPlanStats?: Maybe<ComWixpressMembershipV2PlansGetPlanStatsResponse>;
  /** Retrieves a list of up to 100 pricing plans (including public, hidden, and archived plans). */
  comWixpressMembershipV2PlansListPlans?: Maybe<ComWixpressMembershipV2PlansListPlansResponse>;
  /** Retrieves a list of up to 100 public pricing plans. */
  comWixpressMembershipV2PlansListPublicPlans?: Maybe<ComWixpressMembershipV2PlansListPublicPlansResponse>;
  /** Marks a pricing plan as the primary pricing plan. When viewing pricing plans on the site, the primary plan is highlighted with a customizable ribbon. */
  comWixpressMembershipV2PlansMakePlanPrimary?: Maybe<ComWixpressMembershipV2PlansMakePlanPrimaryResponse>;
  /**
   * Sets visibility for pricing plans. Visible plans are considered public plans.
   * By default, pricing plans are public, meaning they are visible. Plans can be hidden so that site members and visitors cannot choose them.
   * As opposed to archiving, setting visibility can be reversed. This means that a public plan can be hidden, and a hidden plan can be made public (visible). (An archived plan always remains archived and cannot be made active again.)
   * Changing a plan’s visibility does not impact existing orders for the plan. All orders for hidden plans are still active and keep their perks.
   */
  comWixpressMembershipV2PlansSetPlanVisibility?: Maybe<ComWixpressMembershipV2PlansSetPlanVisibilityResponse>;
  /**
   * Updates a pricing plan.
   * Updating a plan does not impact existing orders made for the plan. All orders keep the details of the original plan that was active at the time of purchase.
   */
  comWixpressMembershipV2PlansUpdatePlan?: Maybe<ComWixpressMembershipV2PlansUpdatePlanResponse>;
  /** Creates multiple tags. */
  comWixpressNpmCommunitiesPlatformizedBlogBulkCreateTags?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsResponse>;
  /** Bulk delete for tags */
  comWixpressNpmCommunitiesPlatformizedBlogBulkDeleteTag?: Maybe<Scalars['Void']>;
  /** Creates a new tag with the provided label if a tag with the same label doesn't already exist. */
  comWixpressNpmCommunitiesPlatformizedBlogCreateTag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogCreateTagResponse>;
  /** Deletes a tag. Deleting a tag removes that tag from all blog posts that contain it. */
  comWixpressNpmCommunitiesPlatformizedBlogDeleteTag?: Maybe<Scalars['Void']>;
  /** If a tag already exists with the provided label, returns this tag. Otherwise, the request creates a new tag with the provided label. */
  comWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagResponse>;
  /**
   * Retrieves a tag by the provided label.
   *
   * Sub-labels can also be specified using a `/`. For example, you can have `'dessert/icecream'` and `'dessert/pie'` as two different tag labels.
   *
   * > **Note:** The full URL path following `labels/` is counted as 1 label. Adding a `/` to a label does _not_ create multiple labels. This means that `'dessert/icecream'` is a single label.
   */
  comWixpressNpmCommunitiesPlatformizedBlogGetTagByLabel?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelResponse>;
  /**
   * Retrieves a tag with the provided slug.
   *
   * The `slug` is the end of a tag's URL that refers to a specific tag.
   * For example, if a tag's URL is `https://example.com/blog/tag/{my-tag-slug}`,
   * the slug is `my-tag-slug`. The `slug` is case-sensitive and derived from the tag's `label`.
   */
  comWixpressNpmCommunitiesPlatformizedBlogGetTagBySlug?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugResponse>;
  /** Retrieves a count of tags for every site language. */
  comWixpressNpmCommunitiesPlatformizedBlogGetTagsCountByLanguage?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagsCountByLanguageResponse>;
  /** Lists tags. Default sort is descending by post count and default tag size is 50. */
  comWixpressNpmCommunitiesPlatformizedBlogListTags?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogListTagsResponse>;
  /** Updates a tag. */
  comWixpressNpmCommunitiesPlatformizedBlogUpdateTag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogUpdateTagResponse>;
  /** Creates multiple categories. */
  comWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategories?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesResponse>;
  /** Bulk delete for categories */
  comWixpressNpmCommunitiesPlatformizedBlogV3BulkDeleteCategory?: Maybe<Scalars['Void']>;
  /** Retrieves metrics for specified posts. */
  comWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetrics?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsResponse>;
  /** Retrieves reactions of the current user for specified posts. */
  comWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactions?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsResponse>;
  /** Updates multiple categories. */
  comWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategories?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesResponse>;
  /** Converts DraftJs content to Rich content. */
  comWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContent?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentResponse>;
  /** Converts Rich content to DraftJs content. */
  comWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJs?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsResponse>;
  /** Creates a category. */
  comWixpressNpmCommunitiesPlatformizedBlogV3CreateCategory?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryResponse>;
  /** Creates draft post from specified post template */
  comWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplate?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateResponse>;
  /** Deletes a category. */
  comWixpressNpmCommunitiesPlatformizedBlogV3DeleteCategory?: Maybe<Scalars['Void']>;
  /** Retrieves a count of categories for every site language. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetCategoriesCountByLanguage?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoriesCountByLanguageResponse>;
  /**
   * Gets a category with the specified slug.
   *
   * The slug is at the end of the URL of a specific category.
   * For example, if a category's URL is `https://example.com/blog/categories/famous-cats`, the slug is `famous-cats`.
   * The slug is a case-sensitive string that is derived from the category's label, unless specified otherwise.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlug?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugResponse>;
  /**
   * Retrieves a post with the provided slug.
   *
   * The slug is the end of a post's URL that refers to a specific post.
   * For example, if a post's URL is `https:/example.com/blog/post/my-post-slug`,
   * the slug is `my-post-slug`. The slug is case-sensitive, and is generally derived from the post title,
   * unless specified otherwise.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlug?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugResponse>;
  /**
   * Retrieves a post's metrics.
   *
   * A post's metrics include the comments, likes, and views the post receives.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetrics?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsResponse>;
  /** Gets post template by given id */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetTemplate?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateResponse>;
  /** Retrieves total likes of a member. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMember?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberResponse>;
  /** Retrieves the total amount of published posts of the blog. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetTotalPosts?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsResponse>;
  /** Retrieves the amount of published posts for the current blog. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetTotalPublications?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsResponse>;
  /** Likes a post. */
  comWixpressNpmCommunitiesPlatformizedBlogV3LikePost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3LikePostResponse>;
  /**
   * Retrieves a list of up to 100 categories per request.
   *
   * If you pass a language filter to the method, it returns a list of up to 100 categories in the requested language.
   *
   * The categoies are displayed in order of their `displayPosition`, starting with `0`. The `displayPosition` is the position in which the categories
   * are displayed in the Category Menu page. By default, categories get added to the bottom of the Category Menu page with a `displayPosition` of `-1`.
   *
   * List Categories runs with these defaults, which you can override:
   * - `paging.limit` is `50`.
   * - `paging.offset` is `0`.
   *
   * List Categories is sorted by `displayPosition` in descending order. This cannot be overridden.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3ListCategories?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesResponse>;
  /** Retrieves a list of published demo posts. */
  comWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPosts?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsResponse>;
  /**
   * Retrieves a list of up to 100 published posts per request.
   *
   * List Posts runs with these defaults, which you can override:
   * - `firstPublishedDate` is sorted in descending order, with pinned posts first.
   * - `paging.limit` is `50`.
   * - `paging.offset` is `0`.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3ListPosts?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsResponse>;
  /** Retrieves a post's archive. */
  comWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchive?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveResponse>;
  /** Retrieves available post templates and template categories if asked */
  comWixpressNpmCommunitiesPlatformizedBlogV3ListTemplates?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesResponse>;
  /** Pins a post in the feed. */
  comWixpressNpmCommunitiesPlatformizedBlogV3PinPost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PinPostResponse>;
  /**
   * Retrieves the number of published posts per month within a specified time range.
   *
   * The time range is set using the `rangeStart` and `months` properties.
   * The time range always starts on the 1st day of the month set in `rangeStart` and
   * includes the number of `months` following `rangeStart`.
   * For example, if `rangeStart` is set to `'2022-03-13'` and `months` is set to `4`,
   * the time range will be from `'2022-03-01'` until `'2022-06-30'`. The time range always ends on the last day of the month.
   * > Note: If there are no published posts in a month within the time range, that month is not included in the response. For example, let's say a blog has `0` posts dated in February 2022. If `rangeStart` is set to `'2022-01-01'` and `months` is set to `3`, the response includes `postCount` values for January and March, but not February.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3QueryPostCountStats?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsResponse>;
  /**
   * Retrieves the number of posts per month published within a specified time span, from first day of a month - ignoring days value in period start field.
   * If `periodStart` value is set to `2018-11-10` and `months` value is set to `1`, the day value is ignored and statistic are returned for one month from
   * `2018-11-01` until `2018-11-30` and not between `2018-11-10` and `2018-12-10`.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3QueryPublicationsCountStats?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsResponse>;
  comWixpressNpmCommunitiesPlatformizedBlogV3SendActionEvent?: Maybe<Scalars['Void']>;
  /** Unlikes a post. */
  comWixpressNpmCommunitiesPlatformizedBlogV3UnlikePost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostResponse>;
  /** Unpins a post in the feed. */
  comWixpressNpmCommunitiesPlatformizedBlogV3UnpinPost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostResponse>;
  /** Updates a category. */
  comWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategory?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryResponse>;
  /** Increment view counter of a post. */
  comWixpressNpmCommunitiesPlatformizedBlogV3ViewPost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostResponse>;
  comWixpressPortfolioCollectionsAdminRemoveMenuItems?: Maybe<ComWixpressPortfolioPortfolioappAdminRemoveMenuItemsResponse>;
  comWixpressPortfolioCollectionsConsumeCollectionDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressPortfolioCollectionsConsumeLocaleEvent?: Maybe<Scalars['Void']>;
  /** Creates a new Collection */
  comWixpressPortfolioCollectionsCreateCollection?: Maybe<ComWixpressPortfolioCollectionsCreateCollectionResponse>;
  /** Delete a Collection */
  comWixpressPortfolioCollectionsDeleteCollection?: Maybe<ComWixpressPortfolioCollectionsDeleteCollectionResponse>;
  /** List all Collections in portfolio */
  comWixpressPortfolioCollectionsListCollections?: Maybe<ComWixpressPortfolioCollectionsListCollectionsResponse>;
  /**
   * Update a Collection, supports partial update
   * Pass the latest `revision` for a successful update
   */
  comWixpressPortfolioCollectionsUpdateCollection?: Maybe<ComWixpressPortfolioCollectionsUpdateCollectionResponse>;
  /** Create items in bulk */
  comWixpressPortfolioProjectitemsBulkCreateProjectItems?: Maybe<ComWixpressPortfolioProjectitemsBulkCreateProjectItemsResponse>;
  /** Delete items in bulk */
  comWixpressPortfolioProjectitemsBulkDeleteProjectItems?: Maybe<ComWixpressPortfolioProjectitemsBulkDeleteProjectItemsResponse>;
  /** Update ProjectItems in bulk */
  comWixpressPortfolioProjectitemsBulkUpdateProjectItems?: Maybe<ComWixpressPortfolioProjectitemsBulkUpdateProjectItemsResponse>;
  comWixpressPortfolioProjectitemsConsumeLocaleEvent?: Maybe<Scalars['Void']>;
  /**
   * Consume Project (wix.portfolio.projects.v1.project) DomainEvent in order to delete any ProjectItems in a deleted
   * project.
   */
  comWixpressPortfolioProjectitemsConsumeProjectDomainEvents?: Maybe<Scalars['Void']>;
  /** Creates a default gallery */
  comWixpressPortfolioProjectitemsCreateProjectGallery?: Maybe<ComWixpressPortfolioProjectitemsCreateProjectGalleryResponse>;
  /** Creates a new ProjectItem */
  comWixpressPortfolioProjectitemsCreateProjectItem?: Maybe<ComWixpressPortfolioProjectitemsCreateProjectItemResponse>;
  /** Delete a ProjectItem */
  comWixpressPortfolioProjectitemsDeleteProjectItem?: Maybe<ComWixpressPortfolioProjectitemsDeleteProjectItemResponse>;
  /** Given an 'origin' Project and 'target' Project, copy all ProjectItems in 'origin' Project to 'target' Project. */
  comWixpressPortfolioProjectitemsDuplicateProjectItems?: Maybe<ComWixpressPortfolioProjectitemsDuplicateProjectItemsResponse>;
  comWixpressPortfolioProjectitemsGenerateTokenForProjectItems?: Maybe<ComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsResponse>;
  /** List all items in project */
  comWixpressPortfolioProjectitemsListProjectItems?: Maybe<ComWixpressPortfolioProjectitemsListProjectItemsResponse>;
  /** Update a ProjectItem, supports partial update */
  comWixpressPortfolioProjectitemsUpdateProjectItem?: Maybe<ComWixpressPortfolioProjectitemsUpdateProjectItemResponse>;
  /**
   * Consume Collection (wix.portfolio.collections.v1.collection) DomainEvent in order to delete any projects assigned to
   * a deleted collection.
   */
  comWixpressPortfolioProjectsConsumeCollectionDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressPortfolioProjectsConsumeLocaleEvent?: Maybe<Scalars['Void']>;
  comWixpressPortfolioProjectsConsumeMetaSiteSpecialEvent?: Maybe<Scalars['Void']>;
  /** create default Portfolio data */
  comWixpressPortfolioProjectsCreateNewPortfolioApp?: Maybe<Scalars['Void']>;
  /** Creates a new Project */
  comWixpressPortfolioProjectsCreateProject?: Maybe<ComWixpressPortfolioProjectsCreateProjectResponse>;
  /** Delete a Project */
  comWixpressPortfolioProjectsDeleteProject?: Maybe<ComWixpressPortfolioProjectsDeleteProjectResponse>;
  comWixpressPortfolioProjectsGetProjectPageData?: Maybe<ComWixpressPortfolioPortfolioappGetProjectPageDataResponse>;
  /** List all projects in portfolio by creation date */
  comWixpressPortfolioProjectsListProjects?: Maybe<ComWixpressPortfolioProjectsListProjectsResponse>;
  /**
   * Deprecated - please use ProjectsInCollectionsService.QueryProjectsInCollections instead
   * our Client still use it
   */
  comWixpressPortfolioProjectsQueryProjectsWithCollectionInfo?: Maybe<ComWixpressPortfolioProjectsQueryProjectWithCollectionInfoResponse>;
  /**
   * Update a Project, supports partial update
   * Pass the latest `revision` for a successful update
   */
  comWixpressPortfolioProjectsUpdateProject?: Maybe<ComWixpressPortfolioProjectsUpdateProjectResponse>;
  /**
   * Deprecated - please use ProjectsInCollectionsService.UpdateProjectOrderInCollection instead
   * our Client still use it
   */
  comWixpressPortfolioProjectsUpdateProjectOrderInCollection?: Maybe<ComWixpressPortfolioProjectsUpdateProjectOrderInCollectionResponse>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes multiple item labels at once.
   */
  comWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabels?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResponse>;
  /** Clone labels from a different metasite */
  comWixpressRestaurantsMenusItemLabelsV1CloneLabels?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemLabelsV1ConsumeLabelDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves the number of labels that match a specified filter.
   *
   * If a filter isn't passed in the request, the endpoint returns the count of all labels.
   */
  comWixpressRestaurantsMenusItemLabelsV1CountLabels?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1CountLabelsResponse>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates an item label.
   */
  comWixpressRestaurantsMenusItemLabelsV1CreateLabel?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1CreateLabelResponse>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes an item label.
   */
  comWixpressRestaurantsMenusItemLabelsV1DeleteLabel?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 item labels.
   */
  comWixpressRestaurantsMenusItemLabelsV1ListLabels?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1ListLabelsResponse>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates an item Label.
   *
   * Each time an item label is updated, its revision increments by 1. The existing revision must be included when updating the item labels. This ensures you're working with the latest item labels information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusItemLabelsV1UpdateLabel?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1UpdateLabelResponse>;
  /**
   * > **Note:** The Items API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple items at once.
   */
  comWixpressRestaurantsMenusItemV1BulkCreateItems?: Maybe<ComWixpressRestaurantsMenusItemV1BulkCreateItemsResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes multiple items at once.
   */
  comWixpressRestaurantsMenusItemV1BulkDeleteItems?: Maybe<ComWixpressRestaurantsMenusItemV1BulkDeleteItemsResponse>;
  /** update business location ids */
  comWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIds?: Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponse>;
  /** update business location ids per entity */
  comWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntity?: Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates up to 100 multiple items at once.
   *
   * Each time an item is updated, its revision increments by 1. The existing revision must be included when updating item. This ensures you're working with the latest item information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusItemV1BulkUpdateItem?: Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponse>;
  /** Clone items from a different metasite. */
  comWixpressRestaurantsMenusItemV1CloneItems?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1ConsumeDeleteLocationIdsFromModifierGroups?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1ConsumeDeleteLocationIdsFromVariants?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1ConsumeItemDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1ConsumeItemLabelDomainEvents?: Maybe<Scalars['Void']>;
  /** Reindex menus items to Site Search upon SearchIndexingNotification event */
  comWixpressRestaurantsMenusItemV1ConsumeSearchServicesNotificationEvents?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1ConsumeTaxGroupsDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves the number of items that match a specified filter.
   *
   * If a filter isn't passed in the request, the endpoint returns the count of all items.
   */
  comWixpressRestaurantsMenusItemV1CountItems?: Maybe<ComWixpressRestaurantsMenusItemV1CountItemsResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates an item.
   *
   * To create multiple items at once, use [Bulk Create Items](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item/bulk-create-items).
   */
  comWixpressRestaurantsMenusItemV1CreateItem?: Maybe<ComWixpressRestaurantsMenusItemV1CreateItemResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes an item.
   */
  comWixpressRestaurantsMenusItemV1DeleteItem?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1DuplicateItem?: Maybe<ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 items.
   */
  comWixpressRestaurantsMenusItemV1ListItems?: Maybe<ComWixpressRestaurantsMenusItemV1ListItemsResponse>;
  /** Index menus item to Site Search upon sitePropertiesUpdated event */
  comWixpressRestaurantsMenusItemV1MenusItemsSiteSearchConsumeSitePropertiesUpdatedEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of items given the provided filtering, paging, and sorting.
   *
   * ## Defaults
   * Search Items has the following default settings, which you can override:
   *
   * - Sorted by `createdDate` in ascending order.
   * - `paging.limit` set to `500`.
   * - `paging.offset` set to `0`.
   */
  comWixpressRestaurantsMenusItemV1SearchItems?: Maybe<ComWixpressRestaurantsMenusItemV1SearchItemsResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates an item.
   *
   * To update multiple items at once, use [Bulk Update Item](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item/bulk-update-item)
   *
   * Each time an item is updated, its revision increments by 1. The existing revision must be included when updating the item. This ensures you're working with the latest item information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusItemV1UpdateItem?: Maybe<ComWixpressRestaurantsMenusItemV1UpdateItemResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple menus at once.
   */
  comWixpressRestaurantsMenusMenuV1BulkCreateMenus?: Maybe<ComWixpressRestaurantsMenusMenuV1BulkCreateMenusResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates multiple menus at once.
   *
   * Each time a menu is updated, revision increments by 1. The existing revision must be included when updating the menu. This ensures you're working with the latest menu information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusMenuV1BulkUpdateMenu?: Maybe<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponse>;
  /** Clone menus from a different metasite */
  comWixpressRestaurantsMenusMenuV1CloneMenus?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusMenuV1ConsumeDeleteOrphanSections?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusMenuV1ConsumeMenuDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusMenuV1ConsumeSectionDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Menus API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates a menu.
   *
   * To create multiple menus at once, use [Bulk Create Menus](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menu/bulk-create-menus).
   */
  comWixpressRestaurantsMenusMenuV1CreateMenu?: Maybe<ComWixpressRestaurantsMenusMenuV1CreateMenuResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes a menu.
   */
  comWixpressRestaurantsMenusMenuV1DeleteMenu?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieve a menu by ID.
   */
  comWixpressRestaurantsMenusMenuV1GetMenu?: Maybe<ComWixpressRestaurantsMenusMenuV1GetMenuResponse>;
  /** Get menu details and path URL by menu ID. */
  comWixpressRestaurantsMenusMenuV1GetMenuSiteUrl?: Maybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 menus.
   */
  comWixpressRestaurantsMenusMenuV1ListMenus?: Maybe<ComWixpressRestaurantsMenusMenuV1ListMenusResponse>;
  /** Retrieve a list of menu details along with their corresponding path URLs. */
  comWixpressRestaurantsMenusMenuV1ListMenusSiteUrl?: Maybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of menus given the provided paging, filtering, and sorting. Up to 500 menus can be returned per request.
   *
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menu/supported-filters-and-sorting) article. To learn how to query menus, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  comWixpressRestaurantsMenusMenuV1QueryMenus?: Maybe<ComWixpressRestaurantsMenusMenuV1QueryMenusResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates only the `extendedFields` field.
   *
   * Updates only the `extendedFields` field.
   */
  comWixpressRestaurantsMenusMenuV1UpdateExtendedFields?: Maybe<ComWixpressRestaurantsMenusMenuV1UpdateExtendedFieldsResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates a menu.
   *
   * To update multiple menus at once, use [Bulk Update Menu](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menu/bulk-update-menu).
   *
   * Each time a menu is updated, revision increments by 1. The existing revision must be included when updating a menu. This ensures you're working with the latest menu information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusMenuV1UpdateMenu?: Maybe<ComWixpressRestaurantsMenusMenuV1UpdateMenuResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple sections at once.
   */
  comWixpressRestaurantsMenusSectionV1BulkCreateSections?: Maybe<ComWixpressRestaurantsMenusSectionV1BulkCreateSectionsResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes multiple sections at once.
   */
  comWixpressRestaurantsMenusSectionV1BulkDeleteSections?: Maybe<ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsResponse>;
  comWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationId?: Maybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates multiple sections at once.
   *
   * Each time a section is updated, its revision increments by 1. The existing revision must be included when updating a section. This ensures you're working with the latest section information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusSectionV1BulkUpdateSection?: Maybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponse>;
  /** Clone sections from a different metasite */
  comWixpressRestaurantsMenusSectionV1CloneSections?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusSectionV1ConsumeDeleteLocationIdFromItems?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusSectionV1ConsumeDeleteOrphanItems?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusSectionV1ConsumeItemDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusSectionV1ConsumeSectionDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Sections API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates a section.
   *
   * To create multiple sections at once, use [Bulk Create Sections](/sections/bulk-create-sections).
   */
  comWixpressRestaurantsMenusSectionV1CreateSection?: Maybe<ComWixpressRestaurantsMenusSectionV1CreateSectionResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes a section.
   */
  comWixpressRestaurantsMenusSectionV1DeleteSection?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusSectionV1DuplicateSection?: Maybe<ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 sections.
   */
  comWixpressRestaurantsMenusSectionV1ListSections?: Maybe<ComWixpressRestaurantsMenusSectionV1ListSectionsResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates a section.
   *
   * Each time a section is updated, its revision increments by 1. The existing revision must be included when updating a section. This ensures you're working with the latest section information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusSectionV1UpdateSection?: Maybe<ComWixpressRestaurantsMenusSectionV1UpdateSectionResponse>;
  /** Retrieves a current snapshot of a site's properties. */
  comWixpressSitepropertiesApiV4Read?: Maybe<ComWixpressSitepropertiesApiV4PropertiesReadResponse>;
  /** Retrieves current snapshots of multiple sites' properties. */
  comWixpressSitepropertiesApiV4ReadWithoutDefaultProperties?: Maybe<ComWixpressSitepropertiesApiV4BulkPropertiesReadResponse>;
  /** Updates one or more of a site's properties. The site ID is resolved via the Identification Service. */
  comWixpressSitepropertiesApiV4Update?: Maybe<ComWixpressSitepropertiesApiV4PropertiesUpdateResponse>;
  /** Updates a site's business contact information. */
  comWixpressSitepropertiesApiV4UpdateBusinessContact?: Maybe<Scalars['Void']>;
  /** Updates a site's business profile. */
  comWixpressSitepropertiesApiV4UpdateBusinessProfile?: Maybe<Scalars['Void']>;
  /**
   * Updates a site's business schedule.
   *
   * > **Note:** This method overwrites the current business schedule. `businessSchedule` is an array, so it must be written in its entirety. Therefore, you must modify the existing array and specify it in the API call.
   */
  comWixpressSitepropertiesApiV4UpdateBusinessSchedule?: Maybe<Scalars['Void']>;
  /** Updates a site's default consent policy. */
  comWixpressSitepropertiesApiV4UpdateConsentPolicy?: Maybe<Scalars['Void']>;
  /**
   * Adds catalog line items and/or custom line items to a checkout.
   *
   * When adding catalog ([SDK](https://dev.wix.com/docs/sdk/backend-modules/stores/catalog-v3/e-commerce-integration) | [REST](https://dev.wix.com/docs/rest/business-solutions/stores/catalog/e-commerce-integration)) items
   * to a checkout, the `lineItems.catalogReference.appId` and `lineItems.catalogReference.catalogItemId` fields are required.
   */
  ecomCheckoutV1AddToCheckout?: Maybe<EcomCheckoutV1AddToCheckoutResponse>;
  ecomCheckoutV1ConsumeCheckoutDomainEvents?: Maybe<Scalars['Void']>;
  ecomCheckoutV1ConsumeOrderApprovedEvents?: Maybe<Scalars['Void']>;
  ecomCheckoutV1ConsumeOrderCreatedV2Events?: Maybe<Scalars['Void']>;
  ecomCheckoutV1ConsumeSubscriptionCreatedEvents?: Maybe<Scalars['Void']>;
  ecomCheckoutV1ConsumeUpdatedCheckoutEvents?: Maybe<Scalars['Void']>;
  /**
   * Creates a checkout.
   *
   * A checkout must include at least 1 item in `lineItems` or `customLineItems`.
   *
   * If passing `checkoutInfo.customFields`, then `checkoutInfo.customFields.value` is a required field.
   */
  ecomCheckoutV1CreateCheckout?: Maybe<EcomCheckoutV1CreateCheckoutResponse>;
  ecomCheckoutV1CreateCheckoutStream?: Maybe<EcomCheckoutV1CreateCheckoutResponse>;
  /**
   * Creates an order from a specified checkout.
   *
   * For an order to be created from a checkout, the following requirements must be met:
   * + A checkout cannot have calculation errors. Pass the checkout ID to Get Checkout and review the `calculationErrors` field.
   * + A checkout must have at least 1 line item or custom line item.
   * + All of the line Items have an `availability.status` of `"AVAILABLE"` or `"PARTIALLY_AVAILABLE"`.
   * + If there is a payment to be made, meaning that `priceSummary.total` is greater than `0`, the `billingInfo.address` field are required.
   * + When a checkout has line items to be shipped, the `shippingInfo.shippingDestination.address` and `shippingInfo.selectedCarrierServiceOption` fields are required.
   * + When a checkout has line items for pickup, the `shippingInfo.selectedCarrierServiceOption.logistics.pickupDetails` field are required.
   */
  ecomCheckoutV1CreateOrder?: Maybe<EcomCheckoutV1CreateOrderResponse>;
  /** Deprecated (use createOrder instead) */
  ecomCheckoutV1CreateOrderAndCharge?: Maybe<EcomCheckoutV1CreateOrderAndChargeResponse>;
  /** Deletes a checkout. */
  ecomCheckoutV1DeleteCheckout?: Maybe<Scalars['Void']>;
  /** Retrieves a checkout. */
  ecomCheckoutV1GetCheckout?: Maybe<EcomCheckoutV1GetCheckoutResponse>;
  /** Retrieves the checkout associated with a specified cart. */
  ecomCheckoutV1GetCheckoutByCartId?: Maybe<EcomCheckoutV1GetCheckoutByCartIdResponse>;
  ecomCheckoutV1GetCheckoutPaymentSettings?: Maybe<EcomCheckoutV1GetCheckoutPaymentSettingsResponse>;
  /**
   * Retrieves the checkout page URL of a specified checkout.
   *
   * By default, a `checkoutUrl` generates for a checkout and directs to a standard Wix checkout page.
   * However, if `overrideCheckoutUrl` has a value, it will replace and set the value of `checkoutUrl`.
   */
  ecomCheckoutV1GetCheckoutUrl?: Maybe<EcomCheckoutV1GetCheckoutUrlResponse>;
  /** Retrieves a checkout with all extended fields. This is temporarily to solve the subscription bug. for use by ecom subscriptions only */
  ecomCheckoutV1GetCheckoutWithAllExtendedFields?: Maybe<EcomCheckoutV1GetCheckoutWithAllExtendedFieldsResponse>;
  /** Deprecated and will be removed soon, use GetCheckoutURL */
  ecomCheckoutV1GetWixCheckoutUrl?: Maybe<EcomCheckoutV1GetWixCheckoutUrlResponse>;
  /**
   * Sets `completed` to `true` to mark a checkout as completed.
   *
   * When an order is completed through Wix, the `completed` field in the associated checkout object
   * will automatically be updated to `true`. If an order is completed through a separate system,
   * use this method to manually mark the checkout as completed.
   */
  ecomCheckoutV1MarkCheckoutAsCompleted?: Maybe<Scalars['Void']>;
  /** Marks a checkout as completed and redirects to a specified URL. */
  ecomCheckoutV1MarkCheckoutAsCompletedAndRedirectToUrl?: Maybe<ComWixpressRestRawHttpResponse>;
  /** Removes the coupon from a specified checkout. */
  ecomCheckoutV1RemoveCoupon?: Maybe<EcomCheckoutV1RemoveCouponResponse>;
  /**
   * Removes the gift card from a specified checkout.
   *
   * A checkout can only hold 1 gift card.
   */
  ecomCheckoutV1RemoveGiftCard?: Maybe<EcomCheckoutV1RemoveGiftCardResponse>;
  /** Removes line items from the specified checkout. */
  ecomCheckoutV1RemoveLineItems?: Maybe<EcomCheckoutV1RemoveLineItemsResponse>;
  /**
   * Removes the `overrideCheckoutUrl` from a specified checkout.
   *
   * When `overrideCheckoutUrl` is removed, the `checkoutUrl` will be set to the default, standard
   * Wix checkout page URL.
   */
  ecomCheckoutV1RemoveOverrideCheckoutUrl?: Maybe<EcomCheckoutV1RemoveOverrideCheckoutUrlResponse>;
  /**
   * Updates a checkout.
   *
   * Use this method to update checkout fields such as billing and shipping info, or to add a coupon code or gift card.
   *
   * To update a checkout's `lineItems`, `completed` status, or to remove coupons and gift cards, see these methods:
   * + Add to Checkout: Add line items to the checkout.
   * + Update Line Items Quantity: Update the quantity of 1 or more line items in the checkout.
   * + Remove Line Items: Remove a line item from the checkout.
   * + Mark Checkout As Completed: To update `completed` to `true` if the checkout was completed through a non-Wix orders or payments system.
   * + Remove Coupon: To remove an applied coupon from the checkout.
   * + Remove Gift Card: To remove an applied gift card from the checkout.
   *
   * >**Notes:**
   * > + If nothing is passed in the request, the call will fail.
   * > + The `checkout.buyerInfo.email` may not be removed once it is set.
   */
  ecomCheckoutV1UpdateCheckout?: Maybe<EcomCheckoutV1UpdateCheckoutResponse>;
  /**
   * Updates the quantity of one or more line items in a checkout.
   *
   * This method is only for updating the quantity of line items. To entirely remove a line item from
   * the checkout, use the Remove Line Items method.
   * To add a new line item to the checkout, use the Add to Checkout method.
   *
   * This method checks the amount of stock remaining for this line item. If the specified `quantity`
   * is greater than the remaining stock, then the `quantity` returned in the response is the total amount
   * of remaining stock.
   */
  ecomCheckoutV1UpdateLineItemsQuantity?: Maybe<EcomCheckoutV1UpdateLineItemsQuantityResponse>;
  /** create multiple products in a single request. Works synchronously */
  metroinspectorV1ProductsBulkCreateProducts?: Maybe<MetroinspectorV1ProductsBulkCreateProductsResponse>;
  /** deletes multiple products in a single request. Works synchronously. */
  metroinspectorV1ProductsBulkDeleteProducts?: Maybe<MetroinspectorV1ProductsBulkDeleteProductsResponse>;
  /** update multiple products in a single request. Works synchronously. */
  metroinspectorV1ProductsBulkUpdateProducts?: Maybe<MetroinspectorV1ProductsBulkUpdateProductsResponse>;
  metroinspectorV1ProductsCountProducts?: Maybe<MetroinspectorV1ProductsCountProductsResponse>;
  /** Creating a product */
  metroinspectorV1ProductsCreateProduct?: Maybe<MetroinspectorV1ProductsCreateProductResponse>;
  metroinspectorV1ProductsDeleteProduct?: Maybe<Scalars['Void']>;
  metroinspectorV1ProductsGetProductsStartWith?: Maybe<MetroinspectorV1ProductsGetProductsStartWithResponse>;
  metroinspectorV1ProductsResetProductsDb?: Maybe<Scalars['Void']>;
  metroinspectorV1ProductsUpdateProduct?: Maybe<MetroinspectorV1ProductsUpdateProductResponse>;
  /**
   * Clones a `serviceOptionsAndVariants` object and connects it to a *service*
   * ([SDK](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/introduction) | [REST](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/introduction)).
   *
   *
   * The call fails if the service already has a connected
   * `serviceOptionsAndVariants` object.
   *
   * The cloned `serviceOptionsAndVariants` object gets a new, unique option ID.
   * The option ID of the existing `serviceOptionsAndVariants` object isn't reused.
   *
   * For example, you may call this method after *cloning a service*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/clone-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/clone-service)).
   */
  wixBookingsCatalogV1CloneServiceOptionsAndVariants?: Maybe<WixBookingsCatalogV1CloneServiceOptionsAndVariantsResponse>;
  /** Consume Internal Events For Bi */
  wixBookingsCatalogV1ConsumeInternalEventsForBi?: Maybe<Scalars['Void']>;
  /** Consume Resource notification */
  wixBookingsCatalogV1ConsumeResourceNotification?: Maybe<Scalars['Void']>;
  /** Consume schedules notification that updates options and variants */
  wixBookingsCatalogV1ConsumeScheduleNotification?: Maybe<Scalars['Void']>;
  /** Consume schedules notification that deletes options and variants */
  wixBookingsCatalogV1ConsumeScheduleNotificationWithDeleteEffect?: Maybe<Scalars['Void']>;
  /** Consume Services notification */
  wixBookingsCatalogV1ConsumeServicesNotification?: Maybe<Scalars['Void']>;
  /** Consume site-properties notification */
  wixBookingsCatalogV1ConsumeSitePropertiesNotification?: Maybe<Scalars['Void']>;
  /**
   * Creates a `serviceOptionsAndVariants` object and for a service.
   *
   *
   * ## Calculate variants
   *
   * Before creating a `serviceOptionsAndVariants` object, you need to
   * anticipate and manually define all its variants, since Wix Bookings doesn't
   * automatically calculate them. For the actual
   * Create Service Options And Variants* call, specify both the `options` and
   * `variants` arrays.
   *
   * ## Limitations
   *
   * Wix Bookings allows you to connect only a single `serviceOptionsAndVariants`
   * object to a service. *Create Service Options And Variants* fails, if the
   * service already has a connected `serviceOptionsAndVariants` object.
   *
   * Currently, you can include only a single option per
   * `serviceOptionsAndVariants` object. Taken together, this means that services
   * are limited to a single option.
   *
   * ## Option ID
   *
   * When creating a`serviceOptionsAndVariants` object, you must specify an ID in
   * [UUID format](https://en.wikipedia.org/wiki/Universally_unique_identifier)
   * for its only option. You must reference this option ID for each variant as
   * `variants.values.choices.optionId`.
   *
   * ## Staff member option
   *
   * To creating an option based on the *staff member*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction))
   * providing the service, you need to specify `STAFF_MEMBER` as `options.values.type`.
   * Also, specify all staff member IDs as `variants.values.choices.staffMemberId`.
   * You could follow this *sample flow*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/sample-flows#create-staff-member-based-service-variants) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/sample-flows#create-staff-member-based-service-variants)).
   *
   * ## Custom option
   *
   * To create an option based on a custom parameter, specify `CUSTOM` as
   * `options.values.type`. Provide descriptive names for all custom choices as
   * `variants.values.choices.custom`. These names are displayed to customers
   * during the book flow. You could follow this *sample flow*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/sample-flows#create-service-variants-based-on-the-booked-equipment) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/sample-flows#create-service-variants-based-on-the-booked-equipment)).
   *
   * ## Duration option
   *
   * To create an option based on appointment duration, specify `DURATION` as
   * `options.values.type` and set a descriptive name in `options.values.durationData.name`.
   * Also, indicate the appointment length in `minutes` and provide a descriptive
   * `name` for each duration choice in `variants.values.choices.duration`.
   */
  wixBookingsCatalogV1CreateServiceOptionsAndVariants?: Maybe<WixBookingsCatalogV1CreateServiceOptionsAndVariantsResponse>;
  /**
   * Deletes a `serviceOptionsAndVariants` object.
   *
   *
   * Because each service can be connected to only a single `serviceOptionsAndVariants`
   * object, the service doesn't support *varied pricing*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-payments) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-payments#service-rates))
   * after deleting a `serviceOptionsAndVariants` object. Instead, Wix Bookings
   * uses its standard price calculation.
   */
  wixBookingsCatalogV1DeleteServiceOptionsAndVariants?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a `serviceOptionsAndVariants` object by *service ID*
   * ([SDK](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/introduction) | [REST](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/introduction)).
   */
  wixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceId?: Maybe<WixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdResponse>;
  /**
   * Updates a `serviceOptionsAndVariants` object.
   *
   *
   * Currently, only a single option is supported per `serviceOptionsAndVariants` object.
   *
   * If you want to update `variants`, you must pass the entire list of supported
   * variants, not only newly added variants.
   *
   * If you want to update `options`, you must pass the entire list of supported
   * options, not only newly added options.
   */
  wixBookingsCatalogV1UpdateServiceOptionsAndVariants?: Maybe<WixBookingsCatalogV1UpdateServiceOptionsAndVariantsResponse>;
  wixBookingsCategoriesV2ConsumeMetaSiteSpecialEvent?: Maybe<Scalars['Void']>;
  wixBookingsCategoriesV2ConsumePopulationElementCreatedDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * Counts categories according to given criteria.
   * Use [WQL
   * filter](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section)
   * to define the criteria.
   */
  wixBookingsCategoriesV2CountCategories?: Maybe<WixBookingsCategoriesV2CountCategoriesResponse>;
  /**
   * Creates a Category.
   *
   *
   * The request body must include category name.
   */
  wixBookingsCategoriesV2CreateCategory?: Maybe<WixBookingsCategoriesV2CreateCategoryResponse>;
  /**
   * Deletes a Category.
   *
   *
   * Deleting a Category permanently removes them from the Category List.
   */
  wixBookingsCategoriesV2DeleteCategory?: Maybe<Scalars['Void']>;
  /** Bulk create v2 categories from v1 preserving the IDs */
  wixBookingsCategoriesV2ImportCategories?: Maybe<Scalars['Void']>;
  /** Moves a category to a different position in the list */
  wixBookingsCategoriesV2MoveCategory?: Maybe<WixBookingsCategoriesV2MoveCategoryResponse>;
  /** Publish "updated" domain events for all categories of the site to trigger a re-fetch of materialized data */
  wixBookingsCategoriesV2PublishCategoriesUpdated?: Maybe<Scalars['Void']>;
  /**
   * Updates a Category.
   *
   *
   * Each time the Category is updated,
   * `revision` increments by 1.
   * The current `revision` must be passed when updating the Category.
   * This ensures you're working with the latest Category
   * and prevents unintended overwrites.
   */
  wixBookingsCategoriesV2UpdateCategory?: Maybe<WixBookingsCategoriesV2UpdateCategoryResponse>;
  /**
   * Create a new AddOns group.
   * An AddOns group defines a collection of AddOns that can be linked to a Service,
   * with constraints such as minimum and maximum selections.
   */
  wixBookingsServicesV2AddOnGroupsServiceCreateAddOnGroup?: Maybe<WixBookingsServicesV2CreateAddOnGroupResponse>;
  /**
   * Delete an existing AddOns group.
   * This will remove the group and unlink all associated AddOns.
   */
  wixBookingsServicesV2AddOnGroupsServiceDeleteAddOnGroup?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a list of AddOnGroups including enriched AddOn details in the correct order.
   * If the group_id is specified, only the AddOns for the specified group will be returned,
   * otherwise all groups will be returned.
   */
  wixBookingsServicesV2AddOnGroupsServiceListAddOnGroupsByServiceId?: Maybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdResponse>;
  /**
   * Sets the AddOns for a specific group.
   * The order of the AddOns in the list will be used to determine their display order.
   */
  wixBookingsServicesV2AddOnGroupsServiceSetAddOnsForGroup?: Maybe<WixBookingsServicesV2SetAddOnsForGroupResponse>;
  /**
   * Update an existing AddOns group.
   * This allows modifying group settings such as its name, constraints, or associated AddOns.
   */
  wixBookingsServicesV2AddOnGroupsServiceUpdateAddOnGroup?: Maybe<WixBookingsServicesV2UpdateAddOnGroupResponse>;
  /** Validates the selection of AddOns for a given group based on the group's settings. */
  wixBookingsServicesV2AddOnGroupsServiceValidateAddOnsSelection?: Maybe<WixBookingsServicesV2ValidateAddOnsSelectionResponse>;
  /**
   * Creates multiple services.
   *
   *
   * See *Create Service*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/create-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/create-service))
   * for more details.
   */
  wixBookingsServicesV2BulkCreateServices?: Maybe<WixBookingsServicesV2BulkCreateServicesResponse>;
  /**
   * Deletes multiple services.
   *
   *
   * See *Delete Service*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/delete-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/delete-service))
   * for more details about deleting a service.
   *
   * The call succeeds even if one or more individual services can't be deleted.
   * Information about failures is returned in `bulkActionMetadata`.
   */
  wixBookingsServicesV2BulkDeleteServices?: Maybe<WixBookingsServicesV2BulkDeleteServicesResponse>;
  /**
   * Deletes multiple services by filter.
   *
   *
   * See *Delete Service*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/delete-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/delete-service))
   * for more details about deleting a service.
   *
   * The call succeeds even if one or more individual services can't be deleted.
   * Information about failures is returned in `bulkActionMetadata`.
   *
   * Refer to the supported filters article
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
   * for more details.
   *
   * To learn about working with filters in general, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).
   */
  wixBookingsServicesV2BulkDeleteServicesByFilter?: Maybe<WixBookingsServicesV2BulkDeleteServicesByFilterResponse>;
  /**
   * Updates up to 100 services.
   *
   *
   * See *Update Service*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/update-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/update-service))
   * for more details.
   *
   * The call succeeds even if one or more individual services can't be updated.
   * Information about failures is returned in `bulkActionMetadata`.
   */
  wixBookingsServicesV2BulkUpdateServices?: Maybe<WixBookingsServicesV2BulkUpdateServicesResponse>;
  /**
   * Updates multiple services by filter.
   *
   *
   * Refer to the supported filters article
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
   * for more details.
   *
   * See *Update Service*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/update-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/update-service))
   * for more details about updating a service.
   *
   * The call succeeds even if one or more individual services can't be updated.
   * Information about failures is returned in `bulkActionMetadata`.
   */
  wixBookingsServicesV2BulkUpdateServicesByFilter?: Maybe<WixBookingsServicesV2BulkUpdateServicesByFilterResponse>;
  /**
   * Clones a service.
   *
   *
   * ## Connected entities
   *
   * By default, not all entities connected to the service are cloned.
   *
   * ### Schedule
   *
   * Wix Bookings automatically creates a new active *schedule*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/schedules/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/introduction))
   * for the cloned service. If Wix Bookings can't create this schedule, the
   * Clone Service* call fails.
   *
   * - __For appointment-based services__: Future appointments aren't added to the
   * cloned service's schedule. Use the *Events API*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/events/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction))
   * to add them as needed.
   * - __For classes and courses__: Future one-time events aren't added to the
   * cloned service's schedule, while future recurring events are added
   * asynchronously. The *Clone Service* call always succeeds, whether or not
   * recurring events are added.
   * If the response includes `RECURRING_EVENTS` in the `errors` array, it means the
   * cloned service doesn't have future recurring events, even though the original
   * service does. You can either delete the cloned service and try again or use
   * the *Events API*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/events/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction))
   * to add missing events to the schedule.
   *
   * Wix Bookings never adds past events to the cloned service's schedule.
   *
   * ### Service options and variants
   *
   * If the original service has *variants*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction)),
   * they're cloned asynchronously. The *Clone Service* call always succeeds,
   * regardless of whether variants were cloned.
   *
   * If the response includes `OPTIONS_AND_VARIANTS` in the `errors` array, the cloned
   * service doesn't have variants, even though the original service does. You can
   * delete the cloned service and call *Clone Service* again, or use the
   * _Service Options And Variants API_
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction))
   * to add variants.
   *
   * ### Booking form
   *
   * The original service's booking form isn't cloned, whether it's
   * the default or a custom booking form.
   *
   * ### Pricing plans
   *
   * If the original service's accepts payments via *pricing plans*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/pricing-plans/plans/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/pricing-plans/pricing-plans/plans/introduction)),
   * the cloned service's `payment.options.pricingPlan` is also set to `true`. To
   * accept specific pricing plans, call *Enable Pricing Plans For Service*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/enable-pricing-plans-for-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/enable-pricing-plans-for-service)),
   * after cloning the service. If the original service accepts only
   * pricing plan payments and you don't call *Enable Pricing Plans For Service*
   * after cloning the service, customers will be unable to book the service.
   */
  wixBookingsServicesV2CloneService?: Maybe<WixBookingsServicesV2CloneServiceResponse>;
  /** Consumes benefits notification. */
  wixBookingsServicesV2ConsumeBenefitNotification?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeCalendarEventDomainEvents?: Maybe<Scalars['Void']>;
  /** Consumes category notification. */
  wixBookingsServicesV2ConsumeCategoryNotification?: Maybe<Scalars['Void']>;
  /** Consume duplicate slugs notification */
  wixBookingsServicesV2ConsumeDuplicateSlugsNotification?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeHtmlSitePublished?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeLocationDomainEvents?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeMembershipPlanDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * Workaround for beauty flow - re-fetches services whenever multi service
   * appointments are enabled
   */
  wixBookingsServicesV2ConsumeMultiServiceEnabledEvent?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumePaidPlanEvent?: Maybe<Scalars['Void']>;
  /** Consumes Booking policy notification. */
  wixBookingsServicesV2ConsumePolicyNotification?: Maybe<Scalars['Void']>;
  /** Consumes resources (V1) notification. */
  wixBookingsServicesV2ConsumeResourceNotification?: Maybe<Scalars['Void']>;
  /** Consumes resource type notification. */
  wixBookingsServicesV2ConsumeResourceTypeNotification?: Maybe<Scalars['Void']>;
  /** Consumes schedules notification. */
  wixBookingsServicesV2ConsumeScheduleNotification?: Maybe<Scalars['Void']>;
  /** Consumes ScheduleTimeFrame notifications. */
  wixBookingsServicesV2ConsumeScheduleTimeFrameNotifications?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeServiceDomainEvents?: Maybe<Scalars['Void']>;
  /** Consumes service options and variant notification. */
  wixBookingsServicesV2ConsumeServiceOptionsAndVariantsNotification?: Maybe<Scalars['Void']>;
  /** Consume site-properties notification */
  wixBookingsServicesV2ConsumeSitePropertiesNotification?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeUserDomainInfoChangedEvent?: Maybe<Scalars['Void']>;
  /**
   * Counts how many services match the given filter.
   *
   *
   * Refer to the supported filters article
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
   * for more details.
   *
   * To learn about working with filters in general, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters)
   */
  wixBookingsServicesV2CountServices?: Maybe<WixBookingsServicesV2CountServicesResponse>;
  /**
   * Create a new AddOns group.
   * An AddOns group defines a collection of AddOns that can be linked to a Service,
   * with constraints such as minimum and maximum selections.
   */
  wixBookingsServicesV2CreateAddOnGroup?: Maybe<WixBookingsServicesV2CreateAddOnGroupResponse>;
  /**
   * Create a new AddOns group.
   * An AddOns group defines a collection of AddOns that can be linked to a Service,
   * with constraints such as minimum and maximum selections.
   */
  wixBookingsServicesV2CreateAddOnsGroup?: Maybe<WixBookingsServicesV2CreateAddOnsGroupResponse>;
  /**
   * Creates a service.
   *
   *
   * ## Required fields
   *
   * When creating a service you must specify the following fields:
   * - `type`
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-types) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-types)):
   * Whether it's an appointment-based service, class, or course.
   * - `name`: Service name that's displayed to customers.
   * - `onlineBooking`:
   * Settings determining whether customers can book online, whether the business
   * must manually confirm bookings, and whether customers can request to book an
   * appointment time slot that already has a booking request awaiting business
   * confirmation.
   * - `payment`
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-payments) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-payments)):
   * How customers can pay when signing up for the service.
   *
   * ### Session durations
   *
   * Depending on which type of service you're creating, you may also need to specify
   * supported session durations.
   *
   * __Classes and courses__
   *
   * Don't specify `schedule.availabilityConstraints.sessionDurations`.
   *
   * __Appointment-based services without varied pricing based on session length__
   *
   * Specify the single supported session duration in the
   * `schedule.availabilityConstraints.sessionDurations` array.
   *
   * __Appointment-based services with varied pricing based on session length__
   *
   * - Specify all supported session durations in `schedule.availabilityConstraints.sessionDurations`.
   * - Note that Wix Bookings doesn't display these values to customers and
   * ignores them in pricing and availability calculations. Instead session
   * durations are retrieved from the relevant service *variants*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction)).
   * - It is mandatory to specify `schedule.availabilityConstraints.sessionDurations`,
   * even though these values are ignored.
   */
  wixBookingsServicesV2CreateService?: Maybe<WixBookingsServicesV2CreateServiceResponse>;
  /**
   * Delete an existing AddOns group.
   * This will remove the group and unlink all associated AddOns.
   */
  wixBookingsServicesV2DeleteAddOnGroup?: Maybe<Scalars['Void']>;
  /**
   * Delete an existing AddOns group.
   * This will remove the group and unlink all associated AddOns.
   */
  wixBookingsServicesV2DeleteAddOnsGroup?: Maybe<Scalars['Void']>;
  /**
   * Deletes a service.
   *
   *
   * Specify `{"preserveFutureSessionsWithParticipants": true}` to retain all
   * future sessions for the service. By default, all future sessions are canceled.
   */
  wixBookingsServicesV2DeleteService?: Maybe<Scalars['Void']>;
  /**
   * Removes a list of *pricing plan IDs*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/pricing-plans/plans/introduction) | [REST](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object))
   * from a service's `payment.pricingPlanIds` array.
   *
   *
   * If you remove all pricing plan IDs from `payment.pricingPlanIds` and the
   * service supports only payments by pricing plan, customers will no longer be
   * able to book the service, as they will have no payment options available.
   */
  wixBookingsServicesV2DisablePricingPlansForService?: Maybe<WixBookingsServicesV2DisablePricingPlansForServiceResponse>;
  /**
   * Adds a list of *pricing plan IDs*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/pricing-plans/plans/introduction) | [REST](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object))
   * to a service's `payment.pricingPlanIds` array.
   *
   *
   * The call doesn't validate whether the service's `payment.options.pricingPlan`
   * is set to `true`. If it's set to `false`, customers aren't able to pay
   * for their bookings using pricing plans. You can call *Update Service*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/update-service) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/update-service))
   * to change a service's supported payment methods.
   */
  wixBookingsServicesV2EnablePricingPlansForService?: Maybe<WixBookingsServicesV2EnablePricingPlansForServiceResponse>;
  /** Retrieves the service constraints for availability calculation */
  wixBookingsServicesV2GetServiceAvailabilityConstraints?: Maybe<WixBookingsServicesV2GetServiceAvailabilityConstraintsResponse>;
  /**
   * Retrieves a list of AddOnGroups including enriched AddOn details in the correct order.
   * If the group_id is specified, only the AddOns for the specified group will be returned,
   * otherwise all groups will be returned.
   */
  wixBookingsServicesV2ListAddOnGroupsByServiceId?: Maybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdResponse>;
  /**
   * Retrieves a list of AddOnsGroups including enriched AddOn details in the correct order.
   * If the group_id is specified, only the AddOns for the specified group will be returned,
   * otherwise all groups will be returned.
   */
  wixBookingsServicesV2ListAddOnsGroupsByServiceId?: Maybe<WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponse>;
  /**
   * Retrieves a list of up to 100 *booking forms*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/forms/forms/introduction) | [REST](https://dev.wix.com/docs/rest/crm/forms/forms/introduction)),
   * and information about the services that are connected to them,
   * given the provided filtering, paging, and sorting.
   *
   *
   * ## Defaults
   *
   * Query Booking Forms has the following default settings, which you can override:
   *
   * + Sorted by `id` in ascending order.
   * + `cursorPaging.limit` set to `100`.
   *
   * ## Filters
   *
   * For a complete list of supported filters, refer to **Forms API: Supported Filters**
   * ([REST](https://dev.wix.com/docs/rest/crm/forms/forms/introduction/supported-filters)).
   *
   * When using date filters, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * ## Returned services
   *
   * If a booking policy is connected to more than 5 services, only a subset of
   * these service IDs and names is returned. The `bookingForms.totalServiceCount`
   * values indicate the total number of services linked to each form. You can call *Query Services*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/query-services) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/query-services))
   * and specify the relevant form ID in the filter to retrieve all services
   * connected to the booking form.
   *
   * ## Default booking forms
   *
   * By default, all Wix Bookings services use a standard booking form. To retrieve
   * a site's default booking form with Query Booking Forms, specify
   * `{"conditionalFields": ["DEFAULT_BOOKING_FORM"]}`.
   *
   * ## See also
   *
   * To learn about working with *Query* endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  wixBookingsServicesV2QueryBookingForms?: Maybe<WixBookingsServicesV2QueryBookingFormsResponse>;
  /**
   * Retrieves a list of service *categories*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/categories/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/categories-v2/introduction)),
   * given the provided filtering.
   *
   *
   * ## Defaults
   *
   * Query Categories has the following default setting, which you can't override:
   * Sorted by `id` in ascending order.
   *
   * ## Filters
   *
   * For a complete list of supported filters, refer to the supported filters article
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering)).
   *
   * When using date filters, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * ## See also
   *
   * To learn about working with *Query* endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  wixBookingsServicesV2QueryCategories?: Maybe<WixBookingsServicesV2QueryCategoriesResponse>;
  /**
   * Retrieves 3 separate lists of business, custom, and customer *locations*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction)),
   * given the provided filtering, and whether each location is connected to at
   * least one of the site's services.
   *
   *
   * ## Defaults
   *
   * Query Locations has the following default setting, which you can't override:
   * Sorted by `id` in ascending order.
   *
   * ## Filters
   *
   * For a complete list of supported filters, refer to the `location` object
   * ([REST](https://dev.wix.com/docs/rest/business-management/locations/location-object)).
   *
   * When using date filters, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * ## See also
   *
   * To learn about working with *Query* endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  wixBookingsServicesV2QueryLocations?: Maybe<WixBookingsServicesV2QueryLocationsResponse>;
  /**
   * Retrieves a list of up to 100 *booking policies*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/booking-policies/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/introduction)),
   * and information about the services that are connected to them,
   * given the provided filtering, paging, and sorting.
   *
   * ## Defaults
   *
   * Query Policies has the following default settings, which you can override:
   *
   * + Sorted by `id` in ascending order.
   * + `cursorPaging.limit` set to `100`.
   *
   * ## Filters
   *
   * For a complete list of supported filters, refer to **Booking Policies API: Supported Filters**
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/supported-filters)).
   *
   * When using date filters, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * ## Returned services
   *
   * If a booking policy is connected to more than 5 services, only a subset of
   * those services is returned. The `bookingPolicies.totalServiceCount` values
   * indicate the total number of services linked to each policy. You can call *Search Services*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/search-services) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/search-services))
   * and specify the relevant policy ID in the filter to retrieve all services
   * connected to the booking policy.
   *
   * ## See also
   *
   * To learn about working with *Query* endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  wixBookingsServicesV2QueryPolicies?: Maybe<WixBookingsServicesV2QueryPoliciesResponse>;
  /** Query services in both the main language and the provided language according to the linguist aspect. */
  wixBookingsServicesV2QueryServicesMultiLanguage?: Maybe<WixBookingsServicesV2QueryServicesMultiLanguageResponse>;
  /**
   * Retrieves a list of up to 100 services, given the provided filtering, paging,
   * and sorting.
   *
   *
   * ## Defaults
   *
   * Search Services has the following default settings, which you can override:
   * + Sorted by `createdDate` in ascending order.
   * + `paging.limit` set to `100`.
   * + `paging.offset` set to `0`.
   *
   * ## Filters
   *
   * When using filters for dates, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * Refer to the supported filters article
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting))
   * for a complete list of supported filters and sorting options.
   *
   * ## See also
   *
   * To learn about working with *Search* methods, see
   * _API Query Language_
   * ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language))
   * and *Sorting and Paging*
   * ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language#the-sort-array) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging)).
   */
  wixBookingsServicesV2SearchServices?: Maybe<WixBookingsServicesV2SearchServicesResponse>;
  /**
   * Sets the AddOns for a specific group.
   * The order of the AddOns in the list will be used to determine their display order.
   */
  wixBookingsServicesV2SetAddOnsForGroup?: Maybe<WixBookingsServicesV2SetAddOnsForGroupResponse>;
  /**
   * Sets a new active slug for the service.
   *
   *
   * The call fails if at least one of these conditions is met:
   * - The slug doesn't adheres to the supported format.
   * - Another service is currently using the slug.
   * - Another service has used the slug in the past.
   */
  wixBookingsServicesV2SetCustomSlug?: Maybe<WixBookingsServicesV2SetCustomSlugResponse>;
  /**
   * Replaces the list of the *locations*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction))
   * where the business offers the service.
   *
   *
   * ## Consequences for customers
   *
   * Removing a service location may impact existing sessions and their
   * participants. If you remove at least one service location, you must
   * specify `removedLocationSessionsAction` to indicate what happens to all
   * future sessions scheduled at this location.
   *
   * - **Keep existing location**: If you want to retain future sessions at their
   * originally scheduled location, specify
   * `{"removedLocationSessionsAction.action": "KEEP_AT_CURRENT_LOCATION"}`.
   * This ensures nothing changes for the customer, but the business must be
   * able to provide access to the removed location in the future.
   * - **Update location**: If you want to update the location for future sessions
   * scheduled at the removed location, specify
   * `{"removedLocationSessionsAction.action": "MOVE_TO_LOCATION"}` and
   * `moveToLocationOptions.newLocation`.
   *
   * You can't mix and match to keep some sessions at the previous location while
   * moving other sessions to an updated location.
   *
   * Past session details aren't changed, no matter which option you choose for
   * future sessions.
   *
   * Future sessions scheduled for a location defined by the customer are also not
   * updated.
   *
   * ## Specify location details
   *
   * Depending on whether the new or updated location is a business or custom location,
   * you need to specify different fields.
   *
   * - **Business location**: Specify the relevant *location ID*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction))
   * in `locations.business.id`.
   * - **Custom location**: Specify the complete address object as
   * `locations.custom.address`.
   *
   * ## Participant notifications
   *
   * You can specify a `participantNotification.message` that's immediately send
   * to all customers who had booked at a changed location. Ensure
   * `participantNotification.notifyParticipants` is set to `true` to send the
   * message.
   */
  wixBookingsServicesV2SetServiceLocations?: Maybe<WixBookingsServicesV2SetServiceLocationsResponse>;
  /**
   * Update an existing AddOns group.
   * This allows modifying group settings such as its name, constraints, or associated AddOns.
   */
  wixBookingsServicesV2UpdateAddOnGroup?: Maybe<WixBookingsServicesV2UpdateAddOnGroupResponse>;
  /**
   * Update an existing AddOns group.
   * This allows modifying group settings such as its name, constraints, or associated AddOns.
   */
  wixBookingsServicesV2UpdateAddOnsGroup?: Maybe<WixBookingsServicesV2UpdateAddOnsGroupResponse>;
  /**
   * Updates a service.
   *
   *
   * Each time the service is updated, `revision` increments by 1. You must
   * include the number of the existing revision when updating the service.
   * This ensures you're working with the latest service information and
   * prevents unintended overwrites.
   *
   * ## Session durations
   *
   * Specify `schedule.availabilityConstraints.sessionDurations`
   * only if you want to update it for appointment-based services without varied
   * pricing based on session length. Don't specify `schedule.availabilityConstraints.sessionDurations`
   * for all other appointment-based services, classes, or courses. See *Create Service*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/create-service#session-durations) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/create-service#session-durations))
   * for more details.
   */
  wixBookingsServicesV2UpdateService?: Maybe<WixBookingsServicesV2UpdateServiceResponse>;
  /** Validates the selection of AddOns for a given group based on the group's settings. */
  wixBookingsServicesV2ValidateAddOnsSelection?: Maybe<WixBookingsServicesV2ValidateAddOnsSelectionResponse>;
  /**
   * Validates a service.
   *
   *
   * ## Required fields
   *
   * A valid service must include the following fields:
   * - `type`
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-types) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-types)):
   * Whether it's an appointment-based service, class, or course.
   * - `name`: Service name that's displayed to customers.
   * - `onlineBooking`:
   * Settings determining whether customer can book online, whether the business
   * must manually confirm bookings,
   * and whether customers can request to book an appointment time slot that
   * already has a booking request awaiting business confirmation.
   * - `payment`
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-payments) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-payments)):
   * How customers can pay when signing up for the service.
   */
  wixBookingsServicesV2ValidateService?: Maybe<WixBookingsServicesV2ValidateServiceResponse>;
  /**
   * Checks whether a custom slug is validate for the service.
   *
   *
   * The checks include:
   * - The slug adheres to the supported format.
   * - No other service is currently using the slug.
   * - No other service has used the slug in the past.
   *
   * The call fails if at least one of the checks fails.
   */
  wixBookingsServicesV2ValidateSlug?: Maybe<WixBookingsServicesV2ValidateSlugResponse>;
  /** Assigns the business schedule to the StaffMember */
  wixBookingsStaffV1AssignBusinessSchedule?: Maybe<WixBookingsStaffV1AssignBusinessScheduleResponse>;
  /** Assigns the provided schedule to the StaffMember */
  wixBookingsStaffV1AssignCustomSchedule?: Maybe<WixBookingsStaffV1AssignCustomScheduleResponse>;
  /** Connects staff member to a Wix user */
  wixBookingsStaffV1ConnectStaffMemberToUser?: Maybe<WixBookingsStaffV1ConnectStaffMemberToUserResponse>;
  /** Connects staff member to a Wix user */
  wixBookingsStaffV1ConnectToUser?: Maybe<WixBookingsStaffV1ConnectToUserResponse>;
  /** Counts staff members according to given criteria. */
  wixBookingsStaffV1CountStaffMembers?: Maybe<WixBookingsStaffV1CountStaffMembersResponse>;
  /** Creates a StaffMember. */
  wixBookingsStaffV1CreateStaffMember?: Maybe<WixBookingsStaffV1CreateStaffMemberResponse>;
  /** Deletes a StaffMember. */
  wixBookingsStaffV1DeleteStaffMember?: Maybe<Scalars['Void']>;
  /** Disconnects a staff member from the Wix user. */
  wixBookingsStaffV1DisconnectStaffMemberFromUser?: Maybe<WixBookingsStaffV1DisconnectStaffMemberFromUserResponse>;
  /** Connects staff member to a Wix user */
  wixBookingsStaffV1DisconnectUser?: Maybe<WixBookingsStaffV1DisconnectUserResponse>;
  wixBookingsStaffV1HandleFileDescriptorDomainEvent?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandleMemberDomainEvent?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandlePolicyRemovedFromContributor?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandlePolicyUpdatedForContributor?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandleResourceDomainEvent?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandleScheduleNotification?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandleStaffConnectedToUser?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandleStaffDomainEvent?: Maybe<Scalars['Void']>;
  /**
   * This is a private, temporary endpoint to import a staff member.
   * It should only be used for migration from Resources V1 or when cloning from a Resources V1 site.
   *
   * Callers should provide the Resource ID, working hours schedule ID and the events schedule ID in the `resource` field
   * of staff member. If the staff member works according to the business hours then the working hours schedule ID
   * must be set to the business schedule ID. Otherwise the working hours schedule ID must have the same value as the
   * events schedule ID.
   */
  wixBookingsStaffV1ImportStaffMember?: Maybe<WixBookingsStaffV1ImportStaffMemberResponse>;
  /**
   * For internal use only
   * Restores a deleted StaffMember
   */
  wixBookingsStaffV1RestoreStaff?: Maybe<WixBookingsStaffV1RestoreStaffResponse>;
  /**
   * Update a StaffMember, supports partial update
   * Pass the latest `revision` for a successful update
   */
  wixBookingsStaffV1UpdateStaffMember?: Maybe<WixBookingsStaffV1UpdateStaffMemberResponse>;
  wixBookingsV1ConsumeBookingPolicyDomainEvents?: Maybe<Scalars['Void']>;
  wixBookingsV1ConsumeMetaSiteSpecialEvent?: Maybe<Scalars['Void']>;
  /** Consume site-properties notification */
  wixBookingsV1ConsumeSitePropertiesNotification?: Maybe<Scalars['Void']>;
  /**
   * Counts booking policies, given the provided filtering.
   *
   *
   * See *supported filters*
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/supported-filters))
   * for a complete list of supported filters.
   */
  wixBookingsV1CountBookingPolicies?: Maybe<WixBookingsV1CountBookingPoliciesResponse>;
  /** Creates a booking policy. */
  wixBookingsV1CreateBookingPolicy?: Maybe<WixBookingsV1CreateBookingPolicyResponse>;
  /** Create a default policy if it does not exist yet */
  wixBookingsV1CreateMissingDefaultPolicy?: Maybe<WixBookingsV1CreateMissingDefaultPolicyResponse>;
  /**
   * Deletes a booking policy.
   *
   *
   * You can't delete the default policy without first *setting a different policy as default*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/booking-policies/set-default-booking-policy) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/set-default-booking-policy)).
   */
  wixBookingsV1DeleteBookingPolicy?: Maybe<Scalars['Void']>;
  wixBookingsV1Get?: Maybe<ComWixpressBookingsServicesApiV1GetPolicyResponse>;
  /**
   * Retrieves the strictest version of each policy rule from a list of booking
   * policies.
   *
   *
   * Returns a hypothetical `bookingPolicy` object that combines the strictest
   * version of each rule. The `id` of the returned policy is `null` and no
   * corresponding `bookingPolicy` object is created. To create a new policy, you
   * can call *Create Booking Policy*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/booking-policies/create-booking-policy) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/create-booking-policy)).
   */
  wixBookingsV1GetStrictestBookingPolicy?: Maybe<WixBookingsV1GetStrictestBookingPolicyResponse>;
  /**
   * Sets a booking policy as the default.
   *
   *
   * Also updates the site's current default policy by setting its `default`
   * attribute to `false`. If the provided policy is already the site's
   * default, the call succeeds without changing any `bookingPolicy` object.
   */
  wixBookingsV1SetDefaultBookingPolicy?: Maybe<WixBookingsV1SetDefaultBookingPolicyResponse>;
  wixBookingsV1Update?: Maybe<Scalars['Void']>;
  /**
   * Updates all policies of the meta site with requested fields. Used for migration only.
   * Supported fields (including nested fields): `customPolicyDescription`, `limitEarlyBookingPolicy`, `limitLateBookingPolicy`,
   * `bookAfterStartPolicy`, `cancellationPolicy`, `reschedulePolicy`, `waitlistPolicy`, `participantsPolicy`.
   */
  wixBookingsV1UpdateAllPolicies?: Maybe<Scalars['Void']>;
  /**
   * Updates a booking policy.
   *
   *
   * Each time the booking policy is updated, `revision` increments by 1.
   * The current `revision` must be specified when updating the booking policy.
   * This ensures you're working with the latest booking policy and prevents unintended overwrites.
   */
  wixBookingsV1UpdateBookingPolicy?: Maybe<WixBookingsV1UpdateBookingPolicyResponse>;
  /** Cancels multiple events in bulk. */
  wixCalendarEventsV3BulkCancelEvent?: Maybe<WixCalendarEventsV3BulkCancelEventResponse>;
  /**
   * Creates multiple events in bulk.
   *
   *
   * If you provide `recurrenceRule`, an event with `{"recurrenceType": "MASTER"}` is
   * created. Then, you can't set `start.localDate` to a past date, though the time can be
   * earlier on the same day. You can, however, create single-occurrence events for
   * past dates.
   *
   * You can't create an event with `recurrenceType` set to `INSTANCE` or `EXCEPTION`.
   * `INSTANCE` events are generated automatically based on the recurrence rule in the
   * relevant `MASTER` event. `EXCEPTION` events are automatically created when you
   * [update](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/update-event)
   * an `INSTANCE` event, which changes its `recurrenceType` to `EXCEPTION`.
   */
  wixCalendarEventsV3BulkCreateEvent?: Maybe<WixCalendarEventsV3BulkCreateEventResponse>;
  /**
   * Updates multiple events in bulk.
   *
   *
   * When updating an event with `{"recurrenceType": "INSTANCE"}`, the
   * `recurrenceType` automatically changes to `EXCEPTION`.
   *
   * When updating an event with `{"recurrenceType": "MASTER"}`:
   * + Past `INSTANCE` and `EXCEPTION` events remain unchanged.
   * + For future `INSTANCE` events, all relevant fields are updated.
   * + For future `EXCEPTION` events, only changes to the `inheritedFields` are
   * applied, while other fields remain unchanged.
   */
  wixCalendarEventsV3BulkUpdateEvent?: Maybe<WixCalendarEventsV3BulkUpdateEventResponse>;
  /** Cancels an event. */
  wixCalendarEventsV3CancelEvent?: Maybe<WixCalendarEventsV3CancelEventResponse>;
  /**
   * Creates an event.
   *
   *
   * If you provide `recurrenceRule`, an event with `{"recurrenceType": "MASTER"}` is
   * created. Then, you can't set `start.localDate` to a past date, though the time can be
   * earlier on the same day. You can, however, create single-occurrence events for
   * past dates.
   *
   * You can't create an event with `recurrenceType` set to `INSTANCE` or `EXCEPTION`.
   * `INSTANCE` events are generated automatically based on the recurrence rule in the
   * relevant `MASTER` event. `EXCEPTION` events are automatically created when you
   * [update](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/update-event)
   * an `INSTANCE` event, which changes its `recurrenceType` to `EXCEPTION`.
   */
  wixCalendarEventsV3CreateEvent?: Maybe<WixCalendarEventsV3CreateEventResponse>;
  /**
   * Deletes the target DBs given a list of Meta Site IDs.
   * Sites which were already rolled out will not be deleted.
   *
   * By default:
   * - Nothing is deleted unless requested.
   * - Concurrency limit is 1.
   */
  wixCalendarEventsV3DeleteTargets?: Maybe<Scalars['Void']>;
  /** Being used by Immigrator. If you wish to delete this endpoint, first delete the immigrator task to avoid breaking velocity-infra. */
  wixCalendarEventsV3FixSched38956?: Maybe<WixCalendarMigrationV3FixSched38956Response>;
  wixCalendarEventsV3HandleBusinessLocationDomainEvents?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleContactMergedDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleEventDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleGdprUoUAccessRequest?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleGdprUoUDeleteRequest?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleMetaSiteEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleParticipationDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleResourceDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleScheduleDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleScheduleTimeFrameDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleSelfDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleSitePropertiesNotification?: Maybe<Scalars['Void']>;
  /** Retrieves a list of events by their IDs. */
  wixCalendarEventsV3ListEvents?: Maybe<WixCalendarEventsV3ListEventsResponse>;
  /**
   * Retrieves a list of events filtered by the participant's
   * [contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/introduction)
   * ID.
   *
   *
   * You can't set `toLocalDate` to a value that's more than a full year after
   * `fromLocalDate`.
   */
  wixCalendarEventsV3ListEventsByContactId?: Maybe<WixCalendarParticipanteventsV3ListEventsByContactIdResponse>;
  /**
   * Retrieves a list of events filtered by the participant's
   * [member](https://dev.wix.com/docs/rest/crm/members-contacts/members/members/introduction)
   * ID.
   *
   *
   * You can't set `toLocalDate` to a value that's more than a full year after
   * `fromLocalDate`.
   */
  wixCalendarEventsV3ListEventsByMemberId?: Maybe<WixCalendarParticipanteventsV3ListEventsByMemberIdResponse>;
  /**
   * Retrieves a list of a participant's events by time.
   *
   * Limits:
   * - Max time range is 1 year.
   */
  wixCalendarEventsV3ListParticipantEvents?: Maybe<WixCalendarParticipanteventsV3ListParticipantEventsResponse>;
  /**
   * Lists the non exceptional instances of a recurring event by revision,
   * to enable a consumer to determine the changes made to the instances of a recurring event.
   *
   * Currently this API is `PRIVATE` and restricted to the Events View service!
   * Consumers which wish to determine changes made to the Calendar should use the Events View service.
   *
   * Why only non exceptional instances?
   * Since the Events service will send domain events for changes made to exceptional recurring instances.
   *
   * The default `cursorPaging.limit` is 50.
   * Instances are always sorted by their start date.
   *
   * > **Note**
   * > The response is eventually consistent. A `NOT_FOUND` error will be thrown in case a revision was yet to be replicated. Consumers are expected to retry.
   */
  wixCalendarEventsV3ListRecurringEventInstancesHistory?: Maybe<WixCalendarEventsV3ListRecurringEventInstancesHistoryResponse>;
  wixCalendarEventsV3MigrateSite?: Maybe<WixCalendarMigrationV3MigrateSiteResponse>;
  wixCalendarEventsV3ParticipantEventsHandleMetaSiteEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3ParticipantEventsHandleSitePropertiesNotification?: Maybe<Scalars['Void']>;
  /**
   * Restores the event's default values from the relevant schedule or `MASTER`
   * event.
   *
   *
   * You must provide `fields` to specify which `inheritedFields` are restored.
   *
   * For example, if you've created an event that takes place in a non-default
   * location with a custom title and capacity, but you want to reset only title
   * and capacity to default values without affecting the location, provide the
   * event ID and set `fields` to `["TITLE", "CAPACITY"]`.
   *
   * Refer to the [default values article](https://dev.wix.com/docs/rest/business-management/calendar/default-values)
   * for more information.
   */
  wixCalendarEventsV3RestoreEventDefaults?: Maybe<WixCalendarEventsV3RestoreEventDefaultsResponse>;
  /**
   * Splits a recurring `MASTER` event into 2 separate `MASTER` events.
   *
   *
   * You must provide a `splitLocalDate` that's in the future and after the `start`
   * date of the next `INSTANCE` or `EXCEPTION` event in the series. Additionally,
   * there must be another `INSTANCE` or `EXCEPTION` event following this next event,
   * as the changes wouldn't affect any event without a subsequent occurrence.
   *
   * If you want to modify a `MASTER` event with the changes already applying to
   * the very next event, use
   * [Update Event](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/update-event)
   * instead, as this preserves past events and only modifies future events.
   *
   * The main consequences are:
   * - **The original `MASTER` event is shortened**. Its `recurrenceRule.until.localDate`
   * is updated to `end.localDate` of the latest `INSTANCE` or `EXCEPTION`
   * event starting before `splitLocalDate`. If an `INSTANCE` or `EXCEPTION` event
   * starts before but ends after `splitLocalDate`, `until.localDate` is set
   * to value that's later than `splitLocalDate`.
   * - **A new `MASTER` event is created**, starting from the first event that
   * begins after `splitLocalDate`.
   * - **Existing `INSTANCE` and `EXCEPTION` events that occur after the split are updated**.
   * Their `recurringEventId` is set to the ID of the newly created `MASTER` event.
   */
  wixCalendarEventsV3SplitRecurringEvent?: Maybe<WixCalendarEventsV3SplitRecurringEventResponse>;
  /**
   * Updates an event.
   *
   *
   * When updating an event with `{"recurrenceType": "INSTANCE"}`, the
   * `recurrenceType` automatically changes to `EXCEPTION`.
   *
   * When updating an event with `{"recurrenceType": "MASTER"}`:
   * + Past `INSTANCE` and `EXCEPTION` events remain unchanged.
   * + For future `INSTANCE` events, all relevant fields are updated.
   * + For future `EXCEPTION` events, only changes to the `inheritedFields` are
   * applied, while other fields remain unchanged.
   */
  wixCalendarEventsV3UpdateEvent?: Maybe<WixCalendarEventsV3UpdateEventResponse>;
  /**
   * Updates an event participants.
   *
   * Currently this API is `PRIVATE`.
   * Consumers wishing to update an event participants should use the Participations API.
   */
  wixCalendarEventsV3UpdateEventParticipants?: Maybe<WixCalendarEventsV3UpdateEventParticipantsResponse>;
  /**
   * Sets a schedule's `status` to `CANCELLED`.
   *
   *
   * Also cancels future events belonging to the schedule.
   *
   * Once a schedule is marked as `CANCELLED`, you can't reactivate it, update it,
   * or assign new events.
   */
  wixCalendarSchedulesV3CancelSchedule?: Maybe<WixCalendarSchedulesV3CancelScheduleResponse>;
  /** Clones a schedule. */
  wixCalendarSchedulesV3CloneSchedule?: Maybe<WixCalendarSchedulesV3CloneScheduleResponse>;
  /** subscription to location changes */
  wixCalendarSchedulesV3ConsumeLocationDomainEvents?: Maybe<Scalars['Void']>;
  /** subscription to site Properties changes */
  wixCalendarSchedulesV3ConsumeSitePropertiesEvents?: Maybe<Scalars['Void']>;
  /**
   * Creates a schedule.
   *
   *
   * If you want the schedule's events to appear in the
   * [Bookings calendar](https://support.wix.com/en/article/wix-bookings-about-the-wix-booking-calendar),
   * you must set `appId` to the ID of the Wix Bookings app by providing
   * `{"appId": "13d21c63-b5ec-5912-8397-c3a5ddb27a97"}`.
   */
  wixCalendarSchedulesV3CreateSchedule?: Maybe<WixCalendarSchedulesV3CreateScheduleResponse>;
  /** subscription to meta-site-special events to deal with provisioning */
  wixCalendarSchedulesV3HandleMetaSiteEvent?: Maybe<Scalars['Void']>;
  /**
   * Updates a schedule.
   *
   *
   * Each time the schedule is updated,
   * `revision` increments by 1.
   * The current `revision` must be passed when updating the schedule.
   * This ensures you're working with the latest schedule
   * and prevents unintended overwrites.
   */
  wixCalendarSchedulesV3UpdateSchedule?: Maybe<WixCalendarSchedulesV3UpdateScheduleResponse>;
  /** Adds media items to a specified product, either via URL or existing media ID. */
  wixCatalogApiV1AddProductMedia?: Maybe<Scalars['Void']>;
  /**
   * Links media items that are already associated with a specific product to a choice within the same product.
   *
   * Media items can only be set for choices within one option at a time - e.g., if you set media items for some or all of the choices within the Colors option (blue, green, and red), you won't be able to also assign media items to choices within the Size option (S, M, and L).
   *
   * To remove all existing media items, call the [Remove Product Media From Choices](https://dev.wix.com/api/rest/wix-stores/catalog/products/remove-product-media-from-choices) endpoint.
   */
  wixCatalogApiV1AddProductMediaToChoices?: Maybe<Scalars['Void']>;
  /** Adds products to a specified collection. */
  wixCatalogApiV1AddProductsToCollection?: Maybe<Scalars['Void']>;
  /**
   * Before open to users we should support group by field which will impact all aggregations
   * Group by field is optional, in case you want to count all, max on all etc
   * Issue: for count we allow 2-dimensional aggregation which will not be supported when group by single field
   * To support group by we need to add support of it in object-search library
   * This is exposed only to internal since it has limitations and there isn't an aggregate spec yet
   */
  wixCatalogApiV1AggregateProducts?: Maybe<WixCatalogApiV1AggregateProductsResponse>;
  /**
   * Adjusts a specified numerical property for up to 100 products at a time.
   * The property can be increased or decreased either by percentage or amount.
   */
  wixCatalogApiV1BulkAdjustProductProperties?: Maybe<WixCatalogApiV1BulkAdjustProductPropertiesResponse>;
  /**
   * Adjust property for multiple products, selected by filter.
   * The number of products that can be updated by filter is limited to 1000.
   * Internal only. Will be replaced at some point.
   */
  wixCatalogApiV1BulkAdjustProductPropertiesByFilterSync?: Maybe<WixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncResponse>;
  /** Deletes a bulk of products. */
  wixCatalogApiV1BulkDeleteProducts?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a list of up to 100 productId to CustomFields, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   * This is exposed only to internal since it's a partial solution that doesn't cover the data extensions use case
   */
  wixCatalogApiV1BulkQueryCustomFields?: Maybe<WixCatalogApiV1BulkQueryCustomFieldsResponse>;
  wixCatalogApiV1BulkRemoveCustomFields?: Maybe<Scalars['Void']>;
  wixCatalogApiV1BulkSetCustomFields?: Maybe<Scalars['Void']>;
  /** Updates a specified property for up to 100 products at a time. */
  wixCatalogApiV1BulkUpdateProducts?: Maybe<WixCatalogApiV1BulkUpdateProductsResponse>;
  /**
   * Updates a bulk of products, selected by filter.
   * The number of products that can be updated by filter is limited to 1000.
   * Internal only. Will be replaced in some point.
   */
  wixCatalogApiV1BulkUpdateProductsByFilterSync?: Maybe<WixCatalogApiV1BulkUpdateProductsByFilterSyncResponse>;
  /** Creates a new collection. */
  wixCatalogApiV1CreateCollection?: Maybe<WixCatalogApiV1CreateCollectionResponse>;
  /** Creates a new digital product. */
  wixCatalogApiV1CreateDigitalProduct?: Maybe<WixCatalogApiV1CreateDigitalProductResponse>;
  /** Creates a new product. */
  wixCatalogApiV1CreateProduct?: Maybe<WixCatalogApiV1CreateProductResponse>;
  /** Creates a new product. */
  wixCatalogApiV1CreateProductPlatformized?: Maybe<WixCatalogApiV1CreateProductPlatformizedResponse>;
  /** Deletes a collection. */
  wixCatalogApiV1DeleteCollection?: Maybe<Scalars['Void']>;
  /** Deletes a product. */
  wixCatalogApiV1DeleteProduct?: Maybe<Scalars['Void']>;
  /** Delete all options from a specific product. Only available when [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is disabled. */
  wixCatalogApiV1DeleteProductOptions?: Maybe<Scalars['Void']>;
  /** Deletes a product. */
  wixCatalogApiV1DeleteProductPlatformized?: Maybe<Scalars['Void']>;
  /** Retrieves a collection with the provided ID. */
  wixCatalogApiV1GetCollection?: Maybe<WixCatalogApiV1GetCollectionResponse>;
  /** Retrieves a collection with the provided slug. */
  wixCatalogApiV1GetCollectionBySlug?: Maybe<WixCatalogApiV1GetCollectionBySlugResponse>;
  /** Retrieves a product with the provided ID. */
  wixCatalogApiV1GetProduct?: Maybe<WixCatalogApiV1GetProductResponse>;
  /** Returns a list of up to 250 products, given the provided ids. */
  wixCatalogApiV1GetProducts?: Maybe<WixCatalogApiV1GetProductsResponse>;
  /** Retrieves a store variant with the provided ID. */
  wixCatalogApiV1GetStoreVariant?: Maybe<WixCatalogApiV1GetStoreVariantResponse>;
  /** Gets the availability of relevant product variants based on the product ID and selections provided. See [Use Cases](https://dev.wix.com/api/rest/wix-stores/catalog/use-cases) for an example. */
  wixCatalogApiV1ProductOptionsAvailability?: Maybe<WixCatalogApiV1ProductOptionsAvailabilityResponse>;
  /**
   * Retrieves a list of up to 100 collections, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1QueryCollections?: Maybe<WixCatalogApiV1QueryCollectionsResponse>;
  /**
   * Retrieves a list of up to 100 collections, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1QueryCollectionsPlatformized?: Maybe<WixCatalogApiV1QueryCollectionsPlatformizedResponse>;
  wixCatalogApiV1QueryCustomFields?: Maybe<WixCatalogApiV1QueryCustomFieldsResponse>;
  /**
   * Retrieves product variants, based on either choices (option-choice key-value pairs) or variant IDs.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1QueryProductVariants?: Maybe<WixCatalogApiV1QueryProductVariantsResponse>;
  /**
   * Returns a list of up to 100 products, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1QueryProducts?: Maybe<WixCatalogApiV1QueryProductsResponse>;
  /**
   * Returns a list of up to 600 products, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1QueryProductsWithBigPageLimit?: Maybe<WixCatalogApiV1QueryProductsResponse>;
  /** Retrieves up to 100 store variants, given the provided paging, filtering, and sorting. */
  wixCatalogApiV1QueryStoreVariants?: Maybe<WixCatalogApiV1QueryStoreVariantsResponse>;
  /** Retrieves up to 1000 store variants, given the provided paging, filtering, and sorting. */
  wixCatalogApiV1QueryStoreVariantsWithBigLimit?: Maybe<WixCatalogApiV1QueryStoreVariantsResponse>;
  wixCatalogApiV1ReCloneStore?: Maybe<Scalars['Void']>;
  /** Deletes a product's brand. */
  wixCatalogApiV1RemoveBrand?: Maybe<Scalars['Void']>;
  wixCatalogApiV1RemoveCustomFields?: Maybe<Scalars['Void']>;
  /**
   * Removes specified media items from a product.
   * Pass an empty array to remove all media items.
   */
  wixCatalogApiV1RemoveProductMedia?: Maybe<Scalars['Void']>;
  /**
   * Removes media items from all or some of a product's choices.
   * (Media items can only be set for choices within one option at a time - e.g., if you set media items for some or all of the choices within the Colors option (blue, green, and red), you won't be able to also assign media items to choices within the Size option (S, M, and L).)
   */
  wixCatalogApiV1RemoveProductMediaFromChoices?: Maybe<Scalars['Void']>;
  /** Deletes products from a specified collection. */
  wixCatalogApiV1RemoveProductsFromCollection?: Maybe<Scalars['Void']>;
  /** Deletes a product's ribbon. */
  wixCatalogApiV1RemoveRibbon?: Maybe<Scalars['Void']>;
  /** Resets the data (such as the price and the weight) of all variants for a given product to their default values. */
  wixCatalogApiV1ResetAllVariantData?: Maybe<Scalars['Void']>;
  wixCatalogApiV1SetCustomFields?: Maybe<Scalars['Void']>;
  /**
   * Updates specified properties of a collection.
   * To add products to a collection, call the [Add Products to Collection](https://dev.wix.com/api/rest/wix-stores/catalog/collections/add-products-to-collection) endpoint.
   */
  wixCatalogApiV1UpdateCollection?: Maybe<WixCatalogApiV1UpdateCollectionResponse>;
  /**
   * Updates specified fields in a product.
   *
   * To update a single field across multiple products, use [Bulk Update Product Property](https://dev.wix.com/docs/rest/business-solutions/stores/catalog/bulk-update-product-property).
   */
  wixCatalogApiV1UpdateProduct?: Maybe<WixCatalogApiV1UpdateProductResponse>;
  /** Updates specified fields in a product. */
  wixCatalogApiV1UpdateProductPlatformized?: Maybe<WixCatalogApiV1UpdateProductPlatformizedResponse>;
  /** Updates variants of a specified product. */
  wixCatalogApiV1UpdateVariants?: Maybe<WixCatalogApiV1UpdateVariantsResponse>;
  /** Creates a new product. */
  wixCatalogApiV1WriteProxyCreateProductPlatformized?: Maybe<WixCatalogWriteProxyV1CreateProductPlatformizedResponse>;
  /** Deletes a product. */
  wixCatalogApiV1WriteProxyDeleteProductPlatformized?: Maybe<Scalars['Void']>;
  /** Updates specified fields in a product. */
  wixCatalogApiV1WriteProxyUpdateProductPlatformized?: Maybe<WixCatalogWriteProxyV1UpdateProductPlatformizedResponse>;
  /** echo given arg1 and arg2 */
  wixCoreservicesMetroinspectorV1Echo?: Maybe<WixCoreservicesMetroinspectorV1EchoResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Bulk Cancel Events By Filter](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/bulk-cancel-events-by-filter) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Cancels events by filter.
   * If event cancellation notifications are enabled, canceling an event automatically sends cancellation emails and/or push notifications to registered guests.
   *
   * > **Note:**
   * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsBulkCancelEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Bulk Delete Events By Filter](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/bulk-delete-events-by-filter) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Deletes events by filter.
   * Deleted events are not returned via API. The only way to retrieve them is via GDPR access request.
   *
   * > **Note:**
   * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsBulkDeleteEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Cancel Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/cancel-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Cancels an event and closes registration.
   * If event cancellation notifications are enabled, canceling an event automatically sends cancellation emails and/or push notifications to registered guests.
   */
  wixEventsCancelEvent?: Maybe<WixEventsCancelEventResponse>;
  /**
   * Copies an event, including its registration form, notifications and tickets configuration - scheduled two weeks from the original event.
   * Multilingual translations are also copied to the new event.
   *
   * When an event with same title already exists, appends (1), (2), ... to it. For example, copying an event titled "My Event" creates "My Event (1)".
   * Very long event titles are cropped: "Daily stand-up ev... (2)".
   */
  wixEventsCopy?: Maybe<WixEventsCopyEventResponse>;
  /**
   * Copies event from other site.
   * The event id is changed. This action is not idempotent - every call results in a new event.
   * Dedicated for lite events
   */
  wixEventsCopyEventFromOtherSite?: Maybe<WixEventsCopyEventFromOtherSiteResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Clone Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/clone-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Copies an event, including its registration form, notifications and tickets configuration - scheduled two weeks from the original event.
   * Multilingual translations are also copied to the new event.
   * Supports partial update of the original event fields. See [Partial Updates](https://dev.wix.com/api/rest/wix-events/wix-events/partial-updates) for more information.
   *
   * When an event with same title already exists, appends (1), (2), ... to it. For example, copying an event titled "My Event" creates "My Event (1)".
   * Very long event titles are cropped: "Daily stand-up ev... (2)".
   */
  wixEventsCopyEventV2?: Maybe<WixEventsCopyEventV2Response>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Create Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/create-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Creates a new event, with a default registration form in the given language.
   * Default registration form includes first name, last name, and email inputs.
   * To learn more about registration form and customize it, see [Registration Form](https://dev.wix.com/api/rest/wix-events/wix-events/registration-form/about-the-registration-form-api).
   * The event is automatically configured to send daily summary reports of new registrations to site business email.
   * RegistrationConfig.initialType is required - allowed value when creating is RSVP or TICKETS.
   */
  wixEventsCreateEventV2?: Maybe<WixEventsCreateEventV2Response>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Delete Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/delete-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Deletes an event.
   * Deleted events are not returned via API. The only way to retrieve them is via GDPR access request.
   */
  wixEventsDeleteEvent?: Maybe<WixEventsDeleteEventResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Get Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/get-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Finds an event by ID or URL slug. In contrast to Get Event endpoint which returns not found error,
   * Find Event returns empty response when an event is not found.
   *
   * > **Note:**
   * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsFindEvent?: Maybe<WixEventsFindEventResponse>;
  wixEventsFindOnlineConferenceSession?: Maybe<WixEventsFindOnlineConferenceSessionResponse>;
  wixEventsGetRecurringEventState?: Maybe<WixEventsGetRecurringEventStateResponse>;
  wixEventsGetTicketingSummary?: Maybe<WixEventsGetTicketingSummaryResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Query Events](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/query-events) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Retrieves a list of up to 100 events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination) and category_id.
   * Events are sorted by the sort index defined by CategoryManagement.
   * > **Note:**
   * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsListCategoryEvents?: Maybe<WixEventsListCategoryEventsResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Query Events](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/query-events) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Retrieves a list of up to 100 events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering & sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   *
   * > **Note:**
   * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsListEvents?: Maybe<WixEventsListEventsResponse>;
  /** Retrieves a list of up to 100 user related events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering & sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  wixEventsListUserEvents?: Maybe<WixEventsListUserEventsResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Update Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/publish-draft-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Publishes draft event so that it becomes available to site visitors.
   * If recurring events are set, category with state RECURRING_EVENT will be created.
   * All recurring events will be assigned to this category.
   *
   * >**Note:**
   * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsPublishDraftEvent?: Maybe<WixEventsPublishDraftEventResponse>;
  /** Retrieves a list of up to 1,000 events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  wixEventsQuery?: Maybe<WixEventsQueryEventsResponse>;
  /** Adds schedule item to the draft schedule. Draft items are not publicly available unless published. */
  wixEventsScheduleAddScheduleItem?: Maybe<WixEventsScheduleAddScheduleItemResponse>;
  /** Bookmarks schedule item for current member. */
  wixEventsScheduleCreateBookmark?: Maybe<Scalars['Void']>;
  /** Removes schedule item bookmark from current member. */
  wixEventsScheduleDeleteBookmark?: Maybe<Scalars['Void']>;
  /** Deletes schedule item from draft schedule. */
  wixEventsScheduleDeleteScheduleItem?: Maybe<Scalars['Void']>;
  /** Clears all changes to the draft schedule. (Does not affect the published schedule.) */
  wixEventsScheduleDiscardDraft?: Maybe<Scalars['Void']>;
  /** Retrieves schedule item by ID. */
  wixEventsScheduleGetScheduleItem?: Maybe<WixEventsScheduleGetScheduleItemResponse>;
  /** Retrieves a list of bookmarked schedule items for current member. */
  wixEventsScheduleListBookmarks?: Maybe<WixEventsScheduleListBookmarksResponse>;
  /** Retrieves a list of up to 100 schedule items, with basic filter support. */
  wixEventsScheduleListScheduleItems?: Maybe<WixEventsScheduleListScheduleItemsResponse>;
  /** Publishes the draft schedule. */
  wixEventsSchedulePublishDraft?: Maybe<Scalars['Void']>;
  /** Adjusts time of all draft schedule items (per event). */
  wixEventsScheduleRescheduleDraft?: Maybe<Scalars['Void']>;
  /**
   * Updates existing schedule item.
   * All modifications are performed on a draft schedule, even if schedule item has already been published.
   */
  wixEventsScheduleUpdateScheduleItem?: Maybe<WixEventsScheduleUpdateScheduleItemResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Update Event](https://dev.wix.com/docs/rest/business-solutions/events/events/event/update-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Updates an event's parameters. See [Partial Updates](https://dev.wix.com/api/rest/wix-events/wix-events/partial-updates) for more information.
   */
  wixEventsUpdateEvent?: Maybe<WixEventsUpdateEventResponse>;
  wixEventsUpdateRecurringStatus?: Maybe<Scalars['Void']>;
  /** Consumes EventCopied event and clones policies */
  wixEventsV2ConsumeEventCopied?: Maybe<Scalars['Void']>;
  /**
   * Creates a policy.
   *
   * An event may have up to 3 policies.
   * Attempts to create more than 3 returns a `"POLICIES_LIMIT_REACHED"` error.
   */
  wixEventsV2CreatePolicy?: Maybe<WixEventsV2CreatePolicyResponse>;
  /**
   * Permanently deletes a policy.
   *
   * Deleted policies are not returned by the Get Policy or Query Policy methods.
   */
  wixEventsV2DeletePolicy?: Maybe<Scalars['Void']>;
  /** Retrieves a deleted policy. Used in bg-service. */
  wixEventsV2GetPolicyFromTrashBin?: Maybe<WixEventsV2GetPolicyFromTrashBinResponse>;
  /**
   * Changes policy order in an event dashboard and agreement checkbox on the checkout form.
   * By default, policies are arranged by the created date in descending order.
   *
   * > **Note:** It is possible to use both `beforePolicyId` and `afterPolicyId` at the same time but only the last one defined will be executed.
   */
  wixEventsV2ReorderEventPolicies?: Maybe<WixEventsV2ReorderEventPoliciesResponse>;
  /**
   * Updates a policy.
   *
   * Each time the policy is updated, `revision` increments by 1. The existing `revision` must be included when updating the policy.
   * This ensures you're working with the latest policy and prevents unintended overwrites.
   */
  wixEventsV2UpdatePolicy?: Maybe<WixEventsV2UpdatePolicyResponse>;
  wixEventsV2UpdatePolicySortIndex?: Maybe<WixEventsV2UpdatePolicySortIndexResponse>;
  /** Creates multiple new forms. */
  wixFormsV4BulkCreateForm?: Maybe<WixFormsV4BulkCreateFormResponse>;
  /** Remove delete field by its target */
  wixFormsV4BulkRemoveDeletedField?: Maybe<WixFormsV4BulkRemoveDeletedFieldResponse>;
  /** Clones an existing form. */
  wixFormsV4CloneForm?: Maybe<WixFormsV4CloneFormResponse>;
  /** Consume form domain events. */
  wixFormsV4ConsumeFormDomainEvents?: Maybe<Scalars['Void']>;
  /** Consume form template domain events. */
  wixFormsV4ConsumeFormTemplateDomainEvents?: Maybe<Scalars['Void']>;
  /** Counts forms. */
  wixFormsV4CountForms?: Maybe<WixFormsV4CountFormsResponse>;
  /** Creates a new form. */
  wixFormsV4CreateForm?: Maybe<WixFormsV4CreateFormResponse>;
  /**
   * Deletes a form. It is stored in trash for 90 days.
   * On form permanent deletion, all submissions are also deleted.
   */
  wixFormsV4DeleteForm?: Maybe<Scalars['Void']>;
  /**
   * Deletes a form. It is stored in trash for 90 days.
   * On form permanent deletion, all submissions are also deleted.
   */
  wixFormsV4DeleteFormFromTrashBin?: Maybe<Scalars['Void']>;
  /** Get a deleted Form by id */
  wixFormsV4GetDeletedForm?: Maybe<WixFormsV4GetDeletedFormResponse>;
  /** List deleted Forms */
  wixFormsV4ListDeletedForms?: Maybe<WixFormsV4ListDeletedFormsResponse>;
  /**
   * Lists forms, filtered by namespace and its disabled status. If specified, sorts forms in the desired order.
   * Provides a subset of QueryForms supported capabilities.
   */
  wixFormsV4ListForms?: Maybe<WixFormsV4ListFormsResponse>;
  /** Query forms using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language). */
  wixFormsV4QueryForms?: Maybe<WixFormsV4QueryFormsResponse>;
  /** Restores a form from trash. */
  wixFormsV4RestoreFromTrashBin?: Maybe<WixFormsV4RestoreFromTrashBinResponse>;
  /** Update Extended Fields of the Form */
  wixFormsV4UpdateExtendedFields?: Maybe<WixFormsV4UpdateExtendedFieldsResponse>;
  /**
   * Updates a form, supports partial update.
   * Pass the latest `revision` for a successful update.
   */
  wixFormsV4UpdateForm?: Maybe<WixFormsV4UpdateFormResponse>;
  /** Consume Gift Cards & Store Credit Apps Provisioned events */
  wixGiftCardsGiftCardV1ConsumeGiftCardsAndStoreCreditAppsProvisionedEvents?: Maybe<Scalars['Void']>;
  /** Consume Gift Cards App Provisioned events */
  wixGiftCardsGiftCardV1ConsumeGiftCardsAppProvisionedEvents?: Maybe<Scalars['Void']>;
  /** Consume site currency updates */
  wixGiftCardsGiftCardV1ConsumeSiteCurrencyUpdates?: Maybe<Scalars['Void']>;
  /** Consume site properties updates */
  wixGiftCardsGiftCardV1ConsumeSitePropertiesUpdates?: Maybe<Scalars['Void']>;
  /** Consume requests for triggering gift cards app installation flow */
  wixGiftCardsGiftCardV1ConsumeTriggerGiftCardsAppInstallationFlowEvents?: Maybe<Scalars['Void']>;
  /**
   * Counts the total number of gift cards matching the specified filter criteria.
   *
   * Use this method to get gift card statistics, generate dashboard metrics,
   * or implement pagination counters for large gift card datasets.
   */
  wixGiftCardsGiftCardV1CountGiftCards?: Maybe<WixGiftCardsGiftCardV1CountGiftCardsResponse>;
  /**
   * Creates a gift card with an initial value, and optional recipient notification settings.
   *
   * Use this method to issue new gift cards for promotional campaigns, manual customer service actions,
   * or when integrating gift card functionality into custom workflows.
   */
  wixGiftCardsGiftCardV1CreateGiftCard?: Maybe<WixGiftCardsGiftCardV1CreateGiftCardResponse>;
  /**
   * Disables a gift card, preventing it from being used for purchases.
   *
   * Use this method for customer service actions, fraud prevention, or when
   * gift cards need to be deactivated due to policy violations. Disabled
   * gift cards cannot be re-enabled and their balance becomes inaccessible.
   */
  wixGiftCardsGiftCardV1DisableGiftCard?: Maybe<WixGiftCardsGiftCardV1DisableGiftCardResponse>;
  wixGiftCardsGiftCardV1FulfillGiftCardOrder?: Maybe<Scalars['Void']>;
  /**
   * Retrieves gift cards associated with a specific email address.
   *
   * Use this method to help customers find their gift cards when they only
   * remember the email address used as sender or recipient. Returns up to 50
   * gift cards sorted by creation date in descending order.
   */
  wixGiftCardsGiftCardV1ListGiftCardsByEmail?: Maybe<WixGiftCardsGiftCardV1ListGiftCardsByEmailResponse>;
  /**
   * Searches gift cards by code or code suffix with ranking and aggregation features.
   *
   * Use this method to implement gift card lookup functionality where customers
   * can search for their gift cards, or for admin interfaces that need to quickly
   * locate specific gift cards by partial code matching.
   *
   * To learn how to search gift cards, see [API Query Language][2].
   *
   * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
   * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
   */
  wixGiftCardsGiftCardV1SearchGiftCards?: Maybe<WixGiftCardsGiftCardV1SearchGiftCardsResponse>;
  /**
   * Sends a gift card notification email to the recipient.
   *
   * Use this method to deliver gift cards via email, either immediately after creation
   * or at a scheduled time. The recipient email can be specified in the request to
   * override the gift card's stored recipient information.
   */
  wixGiftCardsGiftCardV1SendGiftCardEmail?: Maybe<Scalars['Void']>;
  /**
   * Creates a new OAuth app for a Wix Headless client.
   *
   * Use this API to enable headless functionality for a Wix site. An OAuth app allows external sites or apps to securely access your site's data and services using Wix APIs.
   */
  wixHeadlessV1CreateOAuthApp?: Maybe<WixHeadlessV1CreateOAuthAppResponse>;
  /**
   * Deletes an OAuth app by ID.
   *
   *
   * > **Note:** After you delete an OAuth app, an external client can no longer make API calls by authenticating with its client ID.
   */
  wixHeadlessV1DeleteOAuthApp?: Maybe<Scalars['Void']>;
  /**
   * Generates a secret for an existing OAuth app.
   *
   *
   * > **Note:** You can only generate a secret once for each OAuth app, and the secret can't be retrieved later. Store the secret securely.
   */
  wixHeadlessV1GenerateOAuthAppSecret?: Maybe<WixHeadlessV1GenerateOAuthAppSecretResponse>;
  wixHeadlessV1QueryOAuthApp?: Maybe<WixHeadlessV1QueryOAuthAppsResponse>;
  wixHeadlessV1SiteCloned?: Maybe<Scalars['Void']>;
  wixHeadlessV1SitePublished?: Maybe<Scalars['Void']>;
  /**
   * Updates an OAuth app.
   *
   *
   * Only fields provided in `mask.paths` are updated.
   *
   * You can update the following fields:
   * + `name`
   * + `description`
   * + `allowedDomain`
   * + `loginUrl`
   * + `logoutUrl`
   * + `technology`
   */
  wixHeadlessV1UpdateOAuthApp?: Maybe<WixHeadlessV1UpdateOAuthAppResponse>;
  /** Apply coupon to order */
  wixOnlineprogramsParticipantsV3ApplyCoupon?: Maybe<WixOnlineprogramsParticipantsV3ApplyCouponResponse>;
  /**
   * Bulk adds all site members to program, but not more then 1000.
   * Participant will be either created in state Joined, or updated to that state
   * from pending one.
   */
  wixOnlineprogramsParticipantsV3BulkAddAllToProgram?: Maybe<WixOnlineprogramsParticipantsV3BulkAddAllToProgramResponse>;
  /**
   * Bulk adds participants to program.
   * Participant will be either created in state Joined, or updated to that state
   * from pending one.
   */
  wixOnlineprogramsParticipantsV3BulkAddToProgram?: Maybe<WixOnlineprogramsParticipantsV3BulkAddToProgramResponse>;
  /**
   * Bulk approves all pending participants, who asked to join private program (aka
   * in state `APPROVAL_PENDING`).
   */
  wixOnlineprogramsParticipantsV3BulkApproveAllParticipant?: Maybe<WixOnlineprogramsParticipantsV3BulkApproveAllParticipantResponse>;
  /**
   * Bulk approves participants, who asked to join private program (aka in
   * state `APPROVAL_PENDING`). If participant was in other state, no effect and
   * error returned.
   */
  wixOnlineprogramsParticipantsV3BulkApproveParticipant?: Maybe<WixOnlineprogramsParticipantsV3BulkApproveParticipantResponse>;
  /** Create resolved steps in batches, needed for migration of participant steps from v1 */
  wixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigration?: Maybe<WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponse>;
  /**
   * Bulk invites all participants to program, but not more then 1000.
   * For each member participant in Invited state is created.
   */
  wixOnlineprogramsParticipantsV3BulkInviteAllToProgram?: Maybe<WixOnlineprogramsParticipantsV3BulkInviteAllToProgramResponse>;
  /**
   * Bulk invites participants to program.
   * For each member participant in Invited state is created.
   */
  wixOnlineprogramsParticipantsV3BulkInviteToProgram?: Maybe<WixOnlineprogramsParticipantsV3BulkInviteToProgramResponse>;
  /** Complete participant */
  wixOnlineprogramsParticipantsV3CompleteParticipant?: Maybe<WixOnlineprogramsParticipantsV3CompleteParticipantResponse>;
  /** Handle events from benefits (settings of paid plan). */
  wixOnlineprogramsParticipantsV3ConsumeBenefitsEvents?: Maybe<Scalars['Void']>;
  wixOnlineprogramsParticipantsV3ConsumeParticipantsBulkCompleteEvent?: Maybe<Scalars['Void']>;
  wixOnlineprogramsParticipantsV3ConsumeParticipantsBulkDeleteEvent?: Maybe<Scalars['Void']>;
  /** Handle payment events. */
  wixOnlineprogramsParticipantsV3ConsumePaymentEvents?: Maybe<Scalars['Void']>;
  wixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedSteps?: Maybe<WixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsResponse>;
  /**
   * Delete participant from program by owner will. Removes participant from member
   * group. Leaves him in Social Group.
   */
  wixOnlineprogramsParticipantsV3DeleteParticipant?: Maybe<Scalars['Void']>;
  /** Exports data about participants as well as resolved steps in program. */
  wixOnlineprogramsParticipantsV3ExportParticipantsStats?: Maybe<Scalars['Void']>;
  /** Get access status */
  wixOnlineprogramsParticipantsV3GetAccessStatus?: Maybe<WixOnlineprogramsParticipantsV3GetAccessStatusResponse>;
  /** Get program's completion stats */
  wixOnlineprogramsParticipantsV3GetCompletionStats?: Maybe<WixOnlineprogramsParticipantsV3GetCompletionStatsResponse>;
  /** Get premium stats */
  wixOnlineprogramsParticipantsV3GetPremiumStats?: Maybe<WixOnlineprogramsParticipantsV3GetPremiumStatsResponse>;
  /** Get summary about participants interacting with the program */
  wixOnlineprogramsParticipantsV3GetProgramSummaries?: Maybe<WixOnlineprogramsParticipantsV3GetProgramSummariesResponse>;
  wixOnlineprogramsParticipantsV3GetResolvedStep?: Maybe<WixOnlineprogramsParticipantsV3GetResolvedStepResponse>;
  /** Get statistics about participants interacting with the program */
  wixOnlineprogramsParticipantsV3GetStatistics?: Maybe<WixOnlineprogramsParticipantsV3GetStatisticsResponse>;
  /** Issue certificate by site admin */
  wixOnlineprogramsParticipantsV3IssueCertificate?: Maybe<WixOnlineprogramsParticipantsV3IssueCertificateResponse>;
  /**
   * Member joins the program. By the type of program, participant in corresponding
   * state will be created.
   */
  wixOnlineprogramsParticipantsV3JoinProgram?: Maybe<WixOnlineprogramsParticipantsV3JoinProgramResponse>;
  /** Participant leaves program. Entity will be deleted. Idempotent call. */
  wixOnlineprogramsParticipantsV3LeaveProgram?: Maybe<Scalars['Void']>;
  wixOnlineprogramsParticipantsV3ListResolvedSteps?: Maybe<WixOnlineprogramsParticipantsV3ListResolvedStepsResponse>;
  wixOnlineprogramsParticipantsV3QueryProgramSummaries?: Maybe<WixOnlineprogramsParticipantsV3QueryProgramSummariesResponse>;
  wixOnlineprogramsParticipantsV3QueryResolvedSteps?: Maybe<WixOnlineprogramsParticipantsV3QueryResolvedStepsResponse>;
  wixOnlineprogramsParticipantsV3ResolveStep?: Maybe<WixOnlineprogramsParticipantsV3ResolveStepResponse>;
  /** Remove coupon from order */
  wixOnlineprogramsParticipantsV3RevertCoupon?: Maybe<WixOnlineprogramsParticipantsV3RevertCouponResponse>;
  wixOnlineprogramsParticipantsV3UndoStep?: Maybe<Scalars['Void']>;
  /** Archives program */
  wixOnlineprogramsProgramsV3ArchiveProgram?: Maybe<WixOnlineprogramsProgramsV3ArchiveProgramResponse>;
  /** Internal endpoint to create program for data migration */
  wixOnlineprogramsProgramsV3BulkCreateProgramsMigration?: Maybe<WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationResponse>;
  /** Update multiple Programs in a single request. Works synchronously. */
  wixOnlineprogramsProgramsV3BulkUpdatePrograms?: Maybe<WixOnlineprogramsProgramsV3BulkUpdateProgramsResponse>;
  /** Consumes meta site special events for service provisioning */
  wixOnlineprogramsProgramsV3ConsumeMetaSiteSpecialEvents?: Maybe<Scalars['Void']>;
  wixOnlineprogramsProgramsV3ConsumeSiteSearchIndexingEvents?: Maybe<Scalars['Void']>;
  /** Counts programs matching the filter */
  wixOnlineprogramsProgramsV3CountPrograms?: Maybe<WixOnlineprogramsProgramsV3CountProgramsResponse>;
  /** Creates a Program. */
  wixOnlineprogramsProgramsV3CreateProgram?: Maybe<WixOnlineprogramsProgramsV3CreateProgramResponse>;
  /**
   * Deletes a Program.
   * Deleting a Program permanently removes them from the Program List.
   */
  wixOnlineprogramsProgramsV3DeleteProgram?: Maybe<Scalars['Void']>;
  /** Duplicates the Program. Leaves certificate template, but removes social group. */
  wixOnlineprogramsProgramsV3DuplicateProgram?: Maybe<WixOnlineprogramsProgramsV3DuplicateProgramResponse>;
  /** Ends program. */
  wixOnlineprogramsProgramsV3EndProgram?: Maybe<WixOnlineprogramsProgramsV3EndProgramResponse>;
  /** Get program membership for UoU. */
  wixOnlineprogramsProgramsV3GetProgramMembership?: Maybe<WixOnlineprogramsProgramsV3GetProgramMembershipResponse>;
  /** List program membership for UoU. */
  wixOnlineprogramsProgramsV3ListProgramMemberships?: Maybe<WixOnlineprogramsProgramsV3ListProgramMembershipsResponse>;
  /** Returns list of sample programs. */
  wixOnlineprogramsProgramsV3ListSamplePrograms?: Maybe<WixOnlineprogramsProgramsV3ListSampleProgramsResponse>;
  /** Publishes draft program. In other state returns program as is. */
  wixOnlineprogramsProgramsV3PublishProgram?: Maybe<WixOnlineprogramsProgramsV3PublishProgramResponse>;
  /** Retrieve program id given slug */
  wixOnlineprogramsProgramsV3ResolveProgramSlug?: Maybe<WixOnlineprogramsProgramsV3ResolveProgramSlugResponse>;
  /** Retrieves a list of programs according to search criteria */
  wixOnlineprogramsProgramsV3SearchPrograms?: Maybe<WixOnlineprogramsProgramsV3SearchProgramsResponse>;
  /** Updates a Program. */
  wixOnlineprogramsProgramsV3UpdateProgram?: Maybe<WixOnlineprogramsProgramsV3UpdateProgramResponse>;
  /** Clones all steps of prototype program */
  wixOnlineprogramsStepsV3BulkCloneStep?: Maybe<WixOnlineprogramsStepsV3BulkCloneStepResponse>;
  /** Creates steps in bulk. */
  wixOnlineprogramsStepsV3BulkCreateStep?: Maybe<WixOnlineprogramsStepsV3BulkCreateStepResponse>;
  /** Internal endpoint to create steps in bulk for migration. Need to supply full entities which will be inserted in db as is. */
  wixOnlineprogramsStepsV3BulkCreateStepMigration?: Maybe<WixOnlineprogramsStepsV3BulkCreateStepMigrationResponse>;
  /** Clone Step. */
  wixOnlineprogramsStepsV3CloneStep?: Maybe<WixOnlineprogramsStepsV3CloneStepResponse>;
  /** Creates a Step. */
  wixOnlineprogramsStepsV3CreateStep?: Maybe<WixOnlineprogramsStepsV3CreateStepResponse>;
  /** Delete all program steps */
  wixOnlineprogramsStepsV3DeleteAllProgramSteps?: Maybe<WixOnlineprogramsStepsV3DeleteAllProgramStepsResponse>;
  /**
   * Deletes a Step.
   * Deleting a Step permanently removes them from the Step List.
   */
  wixOnlineprogramsStepsV3DeleteStep?: Maybe<Scalars['Void']>;
  /** List all program steps without paging */
  wixOnlineprogramsStepsV3ListAllProgramSteps?: Maybe<WixOnlineprogramsStepsV3ListAllProgramStepsResponse>;
  /** Change Step position. */
  wixOnlineprogramsStepsV3MoveStep?: Maybe<WixOnlineprogramsStepsV3MoveStepResponse>;
  /** Query steps. */
  wixOnlineprogramsStepsV3QuerySteps?: Maybe<WixOnlineprogramsStepsV3QueryStepsResponse>;
  /** Query steps without paging */
  wixOnlineprogramsStepsV3QueryStepsWithoutPaging?: Maybe<WixOnlineprogramsStepsV3QueryStepsWithoutPagingResponse>;
  /** Update Step. */
  wixOnlineprogramsStepsV3UpdateStep?: Maybe<WixOnlineprogramsStepsV3UpdateStepResponse>;
  /**
   * Creates a PaymentAgreement.
   *
   * The request body must include lorem_uppercase and business address. Ipsum is optional.
   */
  wixPaymentsPaymentAgreementsV1CreatePaymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1CreatePaymentAgreementResponse>;
  /**
   * Deletes a PaymentAgreement.
   *
   *
   * Deleting a PaymentAgreement permanently removes them from the PaymentAgreement List.
   */
  wixPaymentsPaymentAgreementsV1DeletePaymentAgreement?: Maybe<Scalars['Void']>;
  /** Finalizes payment agreement. */
  wixPaymentsPaymentAgreementsV1FinalizePaymentAgreement?: Maybe<Scalars['Void']>;
  /** Updates extended fields of a PaymentAgreement without incrementing revision */
  wixPaymentsPaymentAgreementsV1UpdateExtendedFields?: Maybe<WixPaymentsPaymentAgreementsV1UpdateExtendedFieldsResponse>;
  /**
   * Updates a PaymentAgreement.
   *
   *
   * Each time the PaymentAgreement is updated,
   * `revision` increments by 1.
   * The current `revision` must be passed when updating the PaymentAgreement.
   * This ensures you're working with the latest PaymentAgreement
   * and prevents unintended overwrites.
   */
  wixPaymentsPaymentAgreementsV1UpdatePaymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1UpdatePaymentAgreementResponse>;
  /**
   * Creates a refund.
   *
   * The refunding process starts immediately after a refund entity is created.
   *
   * If you specify an `amount`, you must also specify a `currency_code`. This currency should be the same as the currency of the charge.
   * If `amount` and `currency_code` are not specified, the refund is created for the full charge amount. If the charge was already partially refunded, this refund will fail.
   *
   * The refund is initially created with a status of `STARTING`. However, the call does not return a response until the refund status transitions away from `STARTING`. Lean more about the [refund lifecycle](https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#refund-lifecycle).
   */
  wixPaymentsRefundsV1CreateRefund?: Maybe<WixPaymentsRefundsV1CreateRefundResponse>;
  /**
   * Calculates the refundability of a charge.
   *
   * Learn more about [refundability](https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#refundability).
   */
  wixPaymentsRefundsV1GetRefundability?: Maybe<WixPaymentsRefundsV1GetRefundabilityResponse>;
  /**
   * Handles webhooks from PSP.
   * Called by payment-services-web when it receives a webhook.
   * Creates provider-initiated refund or updates existing refund.
   */
  wixPaymentsRefundsV1SyncRefund?: Maybe<WixPaymentsRefundsV1InternalSyncRefundResponse>;
  /** Updates the extended fields of a refund without incrementing the revision number. */
  wixPaymentsRefundsV1UpdateExtendedFields?: Maybe<WixPaymentsRefundsV1UpdateExtendedFieldsResponse>;
  /** Deletes SavedPaymentMethod by ID. */
  wixPaymentsSavedPaymentMethodsV1DeleteSavedPaymentMethod?: Maybe<Scalars['Void']>;
  wixPaymentsSavedPaymentMethodsV1FindSavedCreditCard?: Maybe<WixPaymentsSavedPaymentMethodsV1FindSavedCreditCardResponse>;
  /** Lists SavedPaymentMethods ordered by update date descending. */
  wixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethods?: Maybe<WixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsResponse>;
  /**
   * Marks SavedPaymentMethod as primary for site member who's the owner of this SavedPaymentMethod.
   * Primary SavedPaymentMethod is selected by default during the checkout.
   * For every site member there can be at most one primary SavedPaymentMethod,
   * so when one SavedPaymentMethod is marked as primary previous one is automatically unmarked.
   */
  wixPaymentsSavedPaymentMethodsV1MarkSavedPaymentMethodPrimary?: Maybe<Scalars['Void']>;
  /** Updates SavedPaymentMethod. Only fields listed in field_mask are updated. */
  wixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodResponse>;
  /**
   * Creates a new SavedPaymentMethod or updates existing one if SavedPaymentMethod already exists for the same site member.
   * To check uniqueness SavedPaymentMethods are compared by credit card expiration year/month, last four digits and bin.
   * If sensitiveInfo.cardSensitiveInfo.temporaryToken was passed than service will eventually create a persi from it.
   */
  wixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodResponse>;
  /**
   * Retrieves a list of payment method types.
   *
   * If an `ids` array is specified, only payment method types with matching IDs or legacy IDs are returned.
   * If no `ids` are specified, all payment method types available in the caller's country are returned, with some fields localized according to the caller's language and country.
   *
   * The caller's language and country are taken from the `languageCode` or `countryCode` parameters in the request.
   * If `languageCode` or `countryCode` are not specified, the values are taken from context of the call if possible. For example, if this method is called from a Wix site, the selected language on that site will be used.
   * If language or country can't be determined, the method doesn't perform any filtering or localization.
   *
   * Language and country are used to determine localized values for the `displayName`, `description` fields.
   * Country is used to determine localized values for the `priority` and `promoted` fields in `merchantFlow` and `buyerFlow`.
   * `currencyCode` is used to determine the eligibility of payment method types for the provided currency.
   */
  wixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypes?: Maybe<WixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesResponse>;
  /** Consumes GenerateReceiptDocument events. */
  wixReceiptsV1ConsumeGenerateReceiptDocumentEvents?: Maybe<Scalars['Void']>;
  /** Consumes ReceiptDocumentHandled events. */
  wixReceiptsV1ConsumeReceiptDocumentHandledEvents?: Maybe<Scalars['Void']>;
  /** Consumes ReceiptNumberingProcess events. */
  wixReceiptsV1ConsumeReceiptNumberingProcessEvents?: Maybe<Scalars['Void']>;
  /**
   * Creates a receipt.
   *
   * Receipt number is assigned later and will be provided in the Get Receipt response.
   */
  wixReceiptsV1CreateReceipt?: Maybe<WixReceiptsV1CreateReceiptResponse>;
  /**
   * Retrieves the highest receipt number currently in use (the sequential identifier displayed between the prefix and suffix in receipt display numbers).
   * Can be filtered by prefix.
   *
   * Receipt numbering is managed in the Receipts Settings API.
   */
  wixReceiptsV1GetLatestReceiptNumber?: Maybe<WixReceiptsV1GetLatestReceiptNumberResponse>;
  /**
   * Retries generating a receipt document that has a `FAILED` status.
   *
   * Note that you can access a receipt document with an `AVAILABLE` status with the URL provided in `document.downloadUrl` without regenerating.
   */
  wixReceiptsV1RegenerateReceiptDocument?: Maybe<Scalars['Void']>;
  /**
   * Sends the receipt to the specified recipient in an email.
   *
   * Specifying a contact ID is required only when no contact ID was specified upon receipt creation.
   *
   * Note that if the specified contact ID doesn't have an associated email address, the call will fail.
   */
  wixReceiptsV1SendReceiptEmail?: Maybe<Scalars['Void']>;
  /** Updates extended fields of a receipt, without incrementing revision. */
  wixReceiptsV1UpdateExtendedFields?: Maybe<WixReceiptsV1UpdateExtendedFieldsResponse>;
  /** Receipts Management Backoffice */
  wixReceiptsV1UpdateReceipt?: Maybe<WixReceiptsV1BackofficeUpdateReceiptResponse>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple item modifiers.
   */
  wixRestaurantsMenusItemModifierV1BulkCreateModifiers?: Maybe<WixRestaurantsMenusItemModifierV1BulkCreateModifiersResponse>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes multiple item Modifiers at once.
   */
  wixRestaurantsMenusItemModifierV1BulkDeleteModifiers?: Maybe<WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResponse>;
  /** update attached to orphan item */
  wixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItem?: Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponse>;
  /** Update business location ids */
  wixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIds?: Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponse>;
  /** update business location ids per entity */
  wixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntity?: Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponse>;
  /**
   * > **Note:** The Item modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates multiple item modifiers at once.
   * Each time an item modifier is updated, its revision increments by 1. The existing revision must be included when updating the item modifier. This ensures you're working with the latest item modifier information, and prevents unintended overwrites.
   */
  wixRestaurantsMenusItemModifierV1BulkUpdateModifiers?: Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateModifiersResponse>;
  /** Clone item modifiers from a different metasite. */
  wixRestaurantsMenusItemModifierV1CloneModifiers?: Maybe<Scalars['Void']>;
  wixRestaurantsMenusItemModifierV1ConsumeModifiersDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves the number of modifiers that match a specified filter.
   *
   * If a filter isn't passed in the request, the endpoint returns the count of all modifiers.
   */
  wixRestaurantsMenusItemModifierV1CountModifiers?: Maybe<WixRestaurantsMenusItemModifierV1CountModifiersResponse>;
  /**
   * > **Note:** The Item Modifiers API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates an item modifier.
   *
   * To create multiple item modifiers at once, use [Bulk Create Modifiers](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifiers/bulk-create-modifiers).
   */
  wixRestaurantsMenusItemModifierV1CreateModifier?: Maybe<WixRestaurantsMenusItemModifierV1CreateModifierResponse>;
  /**
   * > **Note:** The Item modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   * Deletes an item modifier.
   */
  wixRestaurantsMenusItemModifierV1DeleteModifier?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 item modifiers.
   */
  wixRestaurantsMenusItemModifierV1ListModifiers?: Maybe<WixRestaurantsMenusItemModifierV1ListModifiersResponse>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates an item modifier.
   *
   * To update multiple item modifiers at once, use [Bulk Update Item Modifiers](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifiers/bulk-update-modifiers).
   *
   * Each time an item modifier is updated, its revision increments by 1. The existing revision must be included when updating an item modifier. This ensures you're working with the latest item modifier information, and it prevents unintended overwrites.
   */
  wixRestaurantsMenusItemModifierV1UpdateModifier?: Maybe<WixRestaurantsMenusItemModifierV1UpdateModifierResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple item variants.
   */
  wixRestaurantsMenusItemVariantV1BulkCreateVariants?: Maybe<WixRestaurantsMenusItemVariantV1BulkCreateVariantsResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes multiple item variants at once.
   */
  wixRestaurantsMenusItemVariantV1BulkDeleteVariants?: Maybe<WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResponse>;
  /** update attached to orphan item */
  wixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItem?: Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponse>;
  /** update business location ids */
  wixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIds?: Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponse>;
  /** update business location ids per entity */
  wixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntity?: Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates multiple item variants.
   *
   * Each time an item variant is updated, its revision increments by 1. The existing revision must be included when updating variant. This ensures you're working with the latest item information, and it prevents unintended overwrites.
   *
   * Up to 100 item variants can be returned per request.
   */
  wixRestaurantsMenusItemVariantV1BulkUpdateVariants?: Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateVariantsResponse>;
  /** Clone item variants from a different metasite. */
  wixRestaurantsMenusItemVariantV1CloneVariants?: Maybe<Scalars['Void']>;
  wixRestaurantsMenusItemVariantV1ConsumeVariantsDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves the number of item variants that match a specified filter.
   *
   * If a filter isn't passed in the request, the endpoint returns the count of all item variants.
   */
  wixRestaurantsMenusItemVariantV1CountVariants?: Maybe<WixRestaurantsMenusItemVariantV1CountVariantsResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates an item variant.
   *
   * To create multiple item variants at once, use [Bulk Create Variants](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-variant/bulk-create-variants).
   */
  wixRestaurantsMenusItemVariantV1CreateVariant?: Maybe<WixRestaurantsMenusItemVariantV1CreateVariantResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Permanently deletes an item variant.
   */
  wixRestaurantsMenusItemVariantV1DeleteVariant?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 item variants.
   */
  wixRestaurantsMenusItemVariantV1ListVariants?: Maybe<WixRestaurantsMenusItemVariantV1ListVariantsResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates an item variant.
   *
   * To update multiple item variants at once, use [Bulk Update Variants](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-variant/bulk-update-variants).
   *
   * Each time an item variant is updated, its revision increments by 1. The existing revision must be included when updating the variant. This ensures you're working with the latest variant information, and it prevents unintended overwrites.
   */
  wixRestaurantsMenusItemVariantV1UpdateVariant?: Maybe<WixRestaurantsMenusItemVariantV1UpdateVariantResponse>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple modifier groups.
   */
  wixRestaurantsMenusV1BulkCreateModifierGroups?: Maybe<WixRestaurantsMenusV1BulkCreateModifierGroupsResponse>;
  wixRestaurantsMenusV1BulkDeleteModifierGroups?: Maybe<WixRestaurantsMenusV1BulkDeleteModifierGroupsResponse>;
  /** update attached to orphan item */
  wixRestaurantsMenusV1BulkUpdateAttachedToOrphanItem?: Maybe<WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponse>;
  /** update business location ids */
  wixRestaurantsMenusV1BulkUpdateBusinessLocationIds?: Maybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponse>;
  /** update business location ids per entity */
  wixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntity?: Maybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponse>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates multiple item modifier groups at once. This function supports partial updates.
   * Each time a modifier group is updated, its revision increments by 1. The existing revision must be included when updating an item modifier group. This ensures you're working with the latest item information, and prevents unintended overwrites.
   * Up to 100 modifier groups can be returned per request.
   */
  wixRestaurantsMenusV1BulkUpdateModifierGroups?: Maybe<WixRestaurantsMenusV1BulkUpdateModifierGroupsResponse>;
  /** Clone modifier groups from a different metasite. */
  wixRestaurantsMenusV1CloneModifierGroups?: Maybe<Scalars['Void']>;
  wixRestaurantsMenusV1ConsumeDeleteLocationIdsFromModifiers?: Maybe<Scalars['Void']>;
  wixRestaurantsMenusV1ConsumeModifierGroupsDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves the number of modifier groups that match a specified filter.
   *
   * If a filter isn't passed in the request, the endpoint returns the count of all modifier groups.
   */
  wixRestaurantsMenusV1CountModifierGroups?: Maybe<WixRestaurantsMenusV1CountModifierGroupsResponse>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates a modifier group.
   *
   * To create multiple modifier groups at once, use [Bulk Create Modifiers](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifier-groups/bulk-create-modifier-groups).
   */
  wixRestaurantsMenusV1CreateModifierGroup?: Maybe<WixRestaurantsMenusV1CreateModifierGroupResponse>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes a modifier group.
   */
  wixRestaurantsMenusV1DeleteModifierGroup?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 modifier groups.
   */
  wixRestaurantsMenusV1ListModifierGroups?: Maybe<WixRestaurantsMenusV1ListModifierGroupResponse>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates a modifier group.
   *
   * Each time a modifier group is updated, its revision increments by 1. The existing revision must be included when updating the modifier group. This ensures you're working with the latest modifier group information, and it prevents unintended overwrites.
   */
  wixRestaurantsMenusV1UpdateModifierGroup?: Maybe<WixRestaurantsMenusV1UpdateModifierGroupResponse>;
  /** Add a new CustomerReference to an existing wallet. */
  wixRiseV1AddCustomerReference?: Maybe<WixRiseV1AddCustomerReferenceResponse>;
  wixRiseV1BulkDeleteGiftCardsByFilter?: Maybe<WixRiseV1BulkDeleteGiftCardsByFilterResponse>;
  wixRiseV1ConsumeGiftCardEvent?: Maybe<Scalars['Void']>;
  /** Consumes WalletAction wallet_actions, creating matching BI wallet_actions. */
  wixRiseV1ConsumeWalletActionEvent?: Maybe<Scalars['Void']>;
  wixRiseV1ConsumeWalletEvent?: Maybe<Scalars['Void']>;
  /**
   * TODO: change to Rise domain when it's ready
   * Count GiftCards that match the given [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language) filter.
   */
  wixRiseV1CountGiftCards?: Maybe<WixRiseV1CountGiftCardsResponse>;
  /** Count wallets based on the given filter. */
  wixRiseV1CountWallets?: Maybe<WixRiseV1CountWalletsResponse>;
  /**
   * Creates a new CustomerReference.
   * - If a wallet with the provided email address already exists - adds the customer reference to the wallet.
   * - If a wallet with the provided email address doesn't exist - creates a new wallet with the provided customer reference.
   */
  wixRiseV1CreateCustomerReference?: Maybe<WixRiseV1CreateCustomerReferenceResponse>;
  /** Creates a new GiftCard. */
  wixRiseV1CreateGiftCard?: Maybe<WixRiseV1CreateGiftCardResponse>;
  /** Creates a gift card. Must be used for migration purposes only. */
  wixRiseV1CreateMigrationGiftCard?: Maybe<WixRiseV1CreateMigrationGiftCardResponse>;
  /** Creates a transaction associated with some gift card. Must be used for migration purposes only. */
  wixRiseV1CreateMigrationTransaction?: Maybe<WixRiseV1CreateMigrationTransactionResponse>;
  /** Create a wallet action. Must be used for migration purposes only. */
  wixRiseV1CreateMigrationWalletAction?: Maybe<WixRiseV1CreateMigrationWalletActionResponse>;
  /** Creates a new Wallet. */
  wixRiseV1CreateWallet?: Maybe<WixRiseV1CreateWalletResponse>;
  /** Creates a new WalletAction. */
  wixRiseV1CreateWalletAction?: Maybe<WixRiseV1CreateWalletActionResponse>;
  /**
   * Creates a new WalletAction by customer reference instead of wallet ID.
   * If the customer already has a wallet, the action will be created on that wallet.
   * If the customer does not have a wallet, a new wallet will be created for them.
   */
  wixRiseV1CreateWalletActionByCustomerReference?: Maybe<WixRiseV1CreateWalletActionByCustomerReferenceResponse>;
  /** Subtracts from the GiftCard balance and creates a balance Transaction. */
  wixRiseV1DecreaseBalance?: Maybe<WixRiseV1DecreaseBalanceResponse>;
  /** Delete a CustomerReference. The customer reference is identified by source (i.e. source channel, tenant, and customer IDs). */
  wixRiseV1DeleteCustomerReference?: Maybe<Scalars['Void']>;
  /** Delete a WalletAction. Only available for walletActions that are not active. */
  wixRiseV1DeleteWalletAction?: Maybe<Scalars['Void']>;
  /** Disable a GiftCard. It cannot be re-enabled. */
  wixRiseV1DisableGiftCard?: Maybe<WixRiseV1DisableGiftCardResponse>;
  /** Disable a WalletAction immediately and deduct the remaining balance from the wallet. */
  wixRiseV1DisableWalletAction?: Maybe<WixRiseV1DisableWalletActionResponse>;
  /** End a migration wallet action that should be expired or disabled. */
  wixRiseV1EndMigrationWalletAction?: Maybe<WixRiseV1EndMigrationWalletActionResponse>;
  /** Get a CustomerReference by source (i.e. source channel, tenant, and customer IDs). */
  wixRiseV1GetCustomerReference?: Maybe<WixRiseV1GetCustomerReferenceResponse>;
  /** Get a GiftCard by ID using consistent read. */
  wixRiseV1GetGiftCardConsistent?: Maybe<WixRiseV1GetGiftCardConsistentResponse>;
  /**
   * Retrieves or creates a Wallet for the provided customer reference.
   *
   * - In case the Wallet doesn't exist - creates a new Wallet with the provided customer reference.
   * - In case the Wallet already exists - returns the existing Wallet.
   * - If the provided customer reference doesn't exist yet - adds it to the wallet.
   * - If the provided customer reference already exists - doesn't update anything.
   */
  wixRiseV1GetOrCreateWallet?: Maybe<WixRiseV1GetOrCreateWalletResponse>;
  wixRiseV1GetRefundableAmounts?: Maybe<WixRiseV1GetRefundableAmountsResponse>;
  /** Get a Wallet by ID, email, or a customer reference in the wallet. */
  wixRiseV1GetWallet?: Maybe<WixRiseV1GetWalletResponse>;
  /** Get a Wallet's Gift Card by ID, email, or a customer reference in the wallet. */
  wixRiseV1GetWalletGiftCard?: Maybe<WixRiseV1GetWalletGiftCardResponse>;
  /** Handle wallet_action expiration tasks from TimeCapsule. */
  wixRiseV1HandleEvenExpirationTask?: Maybe<Scalars['Void']>;
  /** Handle wallet_action start tasks from TimeCapsule. */
  wixRiseV1HandleEvenStartTask?: Maybe<Scalars['Void']>;
  /** Handles WalletAction wallet_actions, creating matching BI wallet_actions. */
  wixRiseV1HandleWalletActionEvent?: Maybe<Scalars['Void']>;
  /** Adds to the GiftCard balance and creates a balance Transaction. */
  wixRiseV1IncreaseBalance?: Maybe<WixRiseV1IncreaseBalanceResponse>;
  /** Migrate a new wallet */
  wixRiseV1MigrateWallet?: Maybe<WixRiseV1MigrateWalletResponse>;
  /**
   * Re-triggers Transaction Added Action event
   * [For Internal Rise use only, use with caution]
   */
  wixRiseV1ProduceTransactionAddedEvent?: Maybe<Scalars['Void']>;
  /** Query GiftCards using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  wixRiseV1QueryGiftCards?: Maybe<WixRiseV1QueryGiftCardsResponse>;
  /** Query Transactions using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  wixRiseV1QueryTransactions?: Maybe<WixRiseV1QueryTransactionsResponse>;
  wixRiseV1QueryTransactionsInternal?: Maybe<WixRiseV1QueryTransactionsInternalResponse>;
  /**
   * Query wallet actions that have not been entirely redeemed using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language).
   * Results are enriched with the remaining balance of each wallet action.
   * Note:
   * The returned result may contain fewer items than the requested page limit—or even be empty—while still providing a next cursor, because of in memory filtering.
   * Always check the next cursor to determine if there are more items to fetch.
   */
  wixRiseV1QueryUnredeemedWalletActions?: Maybe<WixRiseV1QueryUnredeemedWalletActionsResponse>;
  /** Query WalletActions using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  wixRiseV1QueryWalletActions?: Maybe<WixRiseV1QueryWalletActionResponse>;
  /**
   * Query all WalletActions using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language).
   * Results are enriched with the remaining balance of each WalletAction.
   */
  wixRiseV1QueryWalletActionsBalances?: Maybe<WixRiseV1QueryWalletActionBalancesResponse>;
  /**
   * Query wallets by contact using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language).
   * The result is a list of wallets with gift card and contact information.
   */
  wixRiseV1QueryWalletsByContact?: Maybe<WixRiseV1QueryWalletsByContactResponse>;
  wixRiseV1RefundTransaction?: Maybe<Scalars['Void']>;
  /** Search for GiftCards by field. */
  wixRiseV1SearchGiftCards?: Maybe<WixRiseV1SearchGiftCardsResponse>;
  /** Update PII of a CustomerReference. The customer reference is identified by rise ID or source (i.e. source channel, tenant, and customer IDs). */
  wixRiseV1UpdateCustomerReference?: Maybe<WixRiseV1UpdateCustomerReferenceResponse>;
  /**
   * Update a GiftCard, supports partial update.
   * Pass the latest `revision` for a successful update.
   */
  wixRiseV1UpdateGiftCard?: Maybe<WixRiseV1UpdateGiftCardResponse>;
  wixRiseV1UpdateLastActivityForReminders?: Maybe<WixRiseV1UpdateLastActivityForRemindersResponse>;
  /**
   * Update a WalletAction, supports partial update.
   * Pass the latest `revision` for a successful update.
   */
  wixRiseV1UpdateWalletAction?: Maybe<WixRiseV1UpdateWalletActionResponse>;
  wixRiseV1VoidTransaction?: Maybe<WixRiseV1VoidTransactionResponse>;
  /** Creates a Workflow. */
  wixRiseWorkflowV1CreateWorkflow?: Maybe<WixRiseWorkflowV1CreateWorkflowResponse>;
  /** Deletes a Workflow. */
  wixRiseWorkflowV1DeleteWorkflow?: Maybe<Scalars['Void']>;
  /** Retrieves a list of Workflows, given the provided [paging, filtering, and sorting][1]. */
  wixRiseWorkflowV1ListTriggers?: Maybe<WixRiseWorkflowV1ListTriggersResponse>;
  /** Report a Trigger. */
  wixRiseWorkflowV1ReportTrigger?: Maybe<Scalars['Void']>;
  /**
   * Updates a Workflow.
   *
   * Each time the Workflow is updated,
   * `revision` increments by 1.
   * The current `revision` must be passed when updating the Workflow.
   * This ensures you're working with the latest Workflow
   * and prevents unintended overwrites.
   */
  wixRiseWorkflowV1UpdateWorkflow?: Maybe<WixRiseWorkflowV1UpdateWorkflowResponse>;
};


export type MutationComWixBookingsSchedulesApiV1CacheArgs = {
  input?: InputMaybe<WixBookingsCalendarV2CacheRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1CreateSessionArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesVeloV2CreateSessionRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1DeleteSessionArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesVeloV2DeleteSessionRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1GetCacheInfoArgs = {
  input?: InputMaybe<WixBookingsCalendarV2GetCacheInfoRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1HandleFeedMessageArgs = {
  input?: InputMaybe<WixBookingsCalendarfeedV2FeedEventInput>;
};


export type MutationComWixBookingsSchedulesApiV1HandleFeedReplayMessageArgs = {
  input?: InputMaybe<WixBookingsCalendarfeedV2FeedReplayEventInput>;
};


export type MutationComWixBookingsSchedulesApiV1ListSessionsArgs = {
  input?: InputMaybe<WixBookingsCalendarV2ListSessionsRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1QueryEventSessionInstancesArgs = {
  input?: InputMaybe<WixBookingsCalendarV2QueryEventSessionInstancesRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1ShortenCacheArgs = {
  input?: InputMaybe<WixBookingsCalendarV2ShortenCacheRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1UncacheArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixBookingsSchedulesApiV1UpdateSessionArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesVeloV2UpdateSessionRequestInput>;
};


export type MutationComWixEcomDiscountsConsumeLocaleCreatedArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomDiscountsConsumeOrderPaidArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomDiscountsCreateDiscountRuleArgs = {
  input?: InputMaybe<ComWixEcomDiscountsCreateDiscountRuleRequestInput>;
};


export type MutationComWixEcomDiscountsDeleteDiscountRuleArgs = {
  input?: InputMaybe<ComWixEcomDiscountsDeleteDiscountRuleRequestInput>;
};


export type MutationComWixEcomDiscountsGetAppliedDiscountsArgs = {
  input?: InputMaybe<ComWixEcomDiscountsGetAppliedDiscountsRequestInput>;
};


export type MutationComWixEcomDiscountsUpdateDiscountRuleArgs = {
  input?: InputMaybe<ComWixEcomDiscountsUpdateDiscountRuleRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1CalculateRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1CalculateRefundRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1GenerateReceiptsArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1GenerateReceiptsRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1GetOrderRefundabilityArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1GetOrderRefundabilityRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1GetRefundOptionsArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1GetRefundOptionsRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1RefundPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1RefundPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1VoidAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1VoidAuthorizedPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1CreateFulfillmentArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1CreateFulfillmentRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1DeleteFulfillmentArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1DeleteFulfillmentRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1UpdateFulfillmentArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1UpdateFulfillmentRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1AddInvoiceToOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1AddInvoiceToOrderRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1BulkGenerateInvoicesArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1BulkGenerateInvoicesRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1ConsumeOrderDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersInvoicesV1GenerateInvoiceArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1GenerateInvoiceRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1GetOrderInvoiceArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1GetOrderInvoiceRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersOldArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1AddChargebackArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1AddChargebackRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1AddInvoiceToOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1AddInvoiceToOrderRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1AddPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1AddPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1AddRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1AddRefundRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1BulkGenerateInvoicesArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1BulkGenerateInvoicesRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1CalculateRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1CalculateRefundRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1GenerateInvoiceArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1GenerateInvoiceRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1GetRefundabilityStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1GetRefundabilityStatusRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersOldArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ReverseChargebackArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ReverseChargebackRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1SearchOrderTransactionsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1SearchOrderTransactionsRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1TriggerRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1TriggerRefundRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1UpdateChargebackArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1UpdateChargebackRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1UpdatePaymentStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1UpdatePaymentStatusRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1UpdatePaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1UpdatePaymentsRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1UpdateRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1UpdateRefundRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1UpdateRefundTransactionArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1UpdateRefundTransactionRequestInput>;
};


export type MutationComWixEcomOrdersV1AddActivitiesArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1AddActivitiesRequestInput>;
};


export type MutationComWixEcomOrdersV1AddActivityArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1AddActivityRequestInput>;
};


export type MutationComWixEcomOrdersV1AddInternalActivityArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1AddInternalActivityRequestInput>;
};


export type MutationComWixEcomOrdersV1AggregateOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1AggregateOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1ArchiveOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1ArchiveOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkArchiveOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkArchiveOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkArchiveOrdersByFilterArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkArchiveOrdersByFilterRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkMarkAsFulfilledArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkMarkAsFulfilledRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkMarkAsFulfilledByFilterArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkMarkAsFulfilledByFilterRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkMarkAsUnfulfilledArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkMarkAsUnfulfilledRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkMarkOrdersAsPaidArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkMarkOrdersAsPaidRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkSendBuyerPickupConfirmationEmailsArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1BulkSendBuyerPickupConfirmationEmailsRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkSendBuyerShippingConfirmationEmailsArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1BulkSendBuyerShippingConfirmationEmailsRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkSetBusinessLocationArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkSetBusinessLocationRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkUnArchiveOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkUnArchiveOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkUnArchiveOrdersByFilterArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkUnArchiveOrdersByFilterRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkUpdateOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkUpdateOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkUpdateOrderTagsArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkUpdateOrderTagsRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkUpdateOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkUpdateOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1CalculateRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundRequestInput>;
};


export type MutationComWixEcomOrdersV1CalculateRefundV1Args = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1RequestInput>;
};


export type MutationComWixEcomOrdersV1CalculateRefundV2Args = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2RequestInput>;
};


export type MutationComWixEcomOrdersV1CanMigrateArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1CancelOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1CancelOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1CaptureAuthorizedPaymentArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentRequestInput>;
};


export type MutationComWixEcomOrdersV1CaptureAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersV1ChargeMembershipsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1ChargeMembershipsRequestInput>;
};


export type MutationComWixEcomOrdersV1ChargeSavedPaymentMethodArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodRequestInput>;
};


export type MutationComWixEcomOrdersV1CommitDeltasArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1CommitDeltasRequestInput>;
};


export type MutationComWixEcomOrdersV1ConsumeBiAnalyticsTransactionSourceEventsArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationComWixEcomOrdersV1ConsumeBiTransactionSourceEventsArgs = {
  input?: InputMaybe<ComWixpressBiOctopusApiV1BiEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeBiTransactionSourceReviveEventsArgs = {
  input?: InputMaybe<ComWixpressBiOctopusApiV1BiEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeFileDescriptorEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeFulfillmentEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeFulfillmentWrapperEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeGiftCardTransactionVoidedV1Args = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeInternalSideEffectsProduceDomainEventsArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1PaymentStatusUpdatedInput>;
};


export type MutationComWixEcomOrdersV1ConsumeInvoicePaidEventArgs = {
  input?: InputMaybe<ComWixpressQuotesApiEventsInvoicePaidEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeInvoiceSentEventArgs = {
  input?: InputMaybe<ComWixpressQuotesApiEventsInvoiceSentEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeMergeContactsFilteredEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeMetaSiteSpecialEventsArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeOrderDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeOrderEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeOrderReindexRequestArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1OrderReindexRequestInput>;
};


export type MutationComWixEcomOrdersV1ConsumePaymentEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumePaymentStatusUpdateEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumePaymentsEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeTriggerReindexRequestArgs = {
  input?: InputMaybe<ComWixEcomOrdersIndexerV1BatchOfTriggerReindexOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1CreateOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1CreateOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1CreatePaymentGatewayOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1CreatePaymentGatewayOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1CreateSiteRolloutStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusRequestInput>;
};


export type MutationComWixEcomOrdersV1DecrementItemsQuantityArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1DecrementItemsQuantityRequestInput>;
};


export type MutationComWixEcomOrdersV1DeleteActivityArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1DeleteActivityRequestInput>;
};


export type MutationComWixEcomOrdersV1EpBackofficeTestUrlAdditionalBindingsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1EpBackofficeUpdateOrderArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1UpdateOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1EpBackofficeUpsertRefundArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1UpsertRefundRequestInput>;
};


export type MutationComWixEcomOrdersV1EpOrdersIndexerConsumeOrderEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1EpOrdersIndexerConsumePaymentsEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1EpOrdersIndexerConsumeTriggerReindexRequestArgs = {
  input?: InputMaybe<ComWixEcomOrdersIndexerV1TriggerReindexRequestInput>;
};


export type MutationComWixEcomOrdersV1EpOrdersRolloutManagerHasOrdersInOldSystemArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemRequestInput>;
};


export type MutationComWixEcomOrdersV1GetMetasiteDataArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1GetMetasiteDataRequestInput>;
};


export type MutationComWixEcomOrdersV1GetOrderAgcArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1GetOrderAgcRequestInput>;
};


export type MutationComWixEcomOrdersV1GetOrderForMetasiteArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1GetOrderForMetasiteRequestInput>;
};


export type MutationComWixEcomOrdersV1GetOrderOutOfBoxArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1GetOrderOutOfBoxRequestInput>;
};


export type MutationComWixEcomOrdersV1GetOrderWithFilterByLocationArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1GetOrderWithFilterByLocationRequestInput>;
};


export type MutationComWixEcomOrdersV1GetPaymentCollectabilityStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusRequestInput>;
};


export type MutationComWixEcomOrdersV1GetRefundOptionsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsRequestInput>;
};


export type MutationComWixEcomOrdersV1GetRefundabilityStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusRequestInput>;
};


export type MutationComWixEcomOrdersV1GetShipmentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1GetShipmentsRequestInput>;
};


export type MutationComWixEcomOrdersV1GetSiteRolloutStatusArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1HandleRetryMergeContactsTaskArgs = {
  input?: InputMaybe<WixApiLoomTimecapsuleTaskInput>;
};


export type MutationComWixEcomOrdersV1HasOrdersInOldSystemArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemRequestInput>;
};


export type MutationComWixEcomOrdersV1InternalQueryOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1InternalQueryOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1ListOrderTransactionsForMetasiteArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteRequestInput>;
};


export type MutationComWixEcomOrdersV1ListOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1ListOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1ListOrdersForMetasiteArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1ListOrdersForMetasiteRequestInput>;
};


export type MutationComWixEcomOrdersV1MarkAsFulfilledArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1MarkAsFulfilledRequestInput>;
};


export type MutationComWixEcomOrdersV1MarkAsUnfulfilledArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1MarkAsUnfulfilledRequestInput>;
};


export type MutationComWixEcomOrdersV1MarkEmptyAndOpenNewFlowArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1MarkOrderAsPaidArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1MarkOrderAsPaidRequestInput>;
};


export type MutationComWixEcomOrdersV1MarkOrderAsSeenByHumanArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1MarkOrderAsSeenByHumanRequestInput>;
};


export type MutationComWixEcomOrdersV1OnTriggerSideEffectsFromLegacyArgs = {
  input?: InputMaybe<ComWixEcomOrdersSideEffectsMigrationApiTriggerSideEffectsFromLegacyDataInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionBulkMarkOrdersAsPaidArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionCalculateRefundV1Args = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1RequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionCalculateRefundV2Args = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2RequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionCaptureAuthorizedPaymentArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionCaptureAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionConsumeGiftCardTransactionVoidedV2Args = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionCreatePaymentGatewayOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionGetRefundOptionsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionMarkOrderAsPaidArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionVoidAuthorizedPaymentArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionVoidAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersV1PreparePaymentCollectionArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionRequestInput>;
};


export type MutationComWixEcomOrdersV1PreviewBuyerConfirmationEmailArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1PreviewBuyerPaymentsReceivedEmailArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1PreviewBuyerPickupConfirmationEmailArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1PreviewCancelEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1PreviewCancelEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1PreviewCancelRefundEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1PreviewEmailByTypeArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1PreviewEmailByTypeRequestInput>;
};


export type MutationComWixEcomOrdersV1PreviewRefundEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1PreviewRefundEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1PreviewResendDownloadLinksEmailArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1PreviewShippingConfirmationEmailArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1QueryOrdersForMetasiteArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1QueryOrdersForMetasiteRequestInput>;
};


export type MutationComWixEcomOrdersV1RecordManuallyCollectedPaymentArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RecordManuallyCollectedPaymentRequestInput>;
};


export type MutationComWixEcomOrdersV1RefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundRequestInput>;
};


export type MutationComWixEcomOrdersV1SearchOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1SearchOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1SendBuyerConfirmationEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendBuyerConfirmationEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1SendBuyerPaymentsReceivedEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendBuyerPaymentsReceivedEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1SendBuyerPickupConfirmationEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendBuyerPickupConfirmationEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1SendBuyerShippingConfirmationEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendBuyerShippingConfirmationEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1SendCancelRefundEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendCancelRefundEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1SendMerchantOrderReceivedNotificationArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedNotificationRequestInput>;
};


export type MutationComWixEcomOrdersV1SendMerchantOrderReceivedPushArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedPushRequestInput>;
};


export type MutationComWixEcomOrdersV1SendRefundEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendRefundEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1TestUrlAdditionalBindingsArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsRequestInput>;
};


export type MutationComWixEcomOrdersV1TriggerRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1TriggerRefundRequestInput>;
};


export type MutationComWixEcomOrdersV1TriggerReindexArgs = {
  input?: InputMaybe<ComWixEcomOrdersIndexerV1TriggerReindexRequestInput>;
};


export type MutationComWixEcomOrdersV1UnArchiveOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UnArchiveOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateActivityArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateActivityRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateAllowLazyMigrationArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateBillingContactDetailsArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateBillingContactDetailsRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateBuyerEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateBuyerEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateBuyerInfoArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateBuyerInfoRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateComparisonStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateLineItemsDescriptionLinesArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateLineItemsDescriptionLinesRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateMigrationFailedArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateNewFlowOpenArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateNoDataToMigrateArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateOrderLineItemArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateOrderLineItemRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateOrderLineItemsArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateOrderLineItemsRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateOrderShippingAddressArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateOrderShippingAddressRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateOrderStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateOrderStatusRequestInput>;
};


export type MutationComWixEcomOrdersV1UpsertRefundArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1UpsertRefundRequestInput>;
};


export type MutationComWixEcomOrdersV1VoidAuthorizedPaymentArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentRequestInput>;
};


export type MutationComWixEcomOrdersV1VoidAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsRequestInput>;
};


export type MutationComWixpressBookingsAttendanceV2AttendanceBulkSetAttendanceArgs = {
  input?: InputMaybe<ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestInput>;
};


export type MutationComWixpressBookingsAttendanceV2BulkSetAttendanceArgs = {
  input?: InputMaybe<ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestInput>;
};


export type MutationComWixpressBookingsAttendanceV2CountAttendancesArgs = {
  input?: InputMaybe<ComWixpressBookingsAttendanceV2CountAttendancesRequestInput>;
};


export type MutationComWixpressBookingsAttendanceV2SetAttendanceArgs = {
  input?: InputMaybe<ComWixpressBookingsAttendanceV2SetAttendanceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceBatchDeleteArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceBatchDeleteResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceBatchForceDeleteArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceBatchDeleteResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceCreateArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceDeleteArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceListArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceListResourcesRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceQueryArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceUpdateArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleRequestInput>;
};


export type MutationComWixpressCloudDataApiDataAggregateDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataAggregatePipelineDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkInsertDataItemReferencesArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkInsertDataItemReferencesRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkInsertDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkInsertDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkPatchDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkPatchDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkRemoveDataItemReferencesArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkRemoveDataItemReferencesRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkRemoveDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkRemoveDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkSaveDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkSaveDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkUpdateDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkUpdateDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataCountDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataCountDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataInsertDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataInsertDataItemRequestInput>;
};


export type MutationComWixpressCloudDataApiDataInsertDataItemReferenceArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataInsertDataItemReferenceRequestInput>;
};


export type MutationComWixpressCloudDataApiDataIsReferencedDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataIsReferencedDataItemRequestInput>;
};


export type MutationComWixpressCloudDataApiDataPatchDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataPatchDataItemRequestInput>;
};


export type MutationComWixpressCloudDataApiDataQueryDistinctValuesArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataQueryDistinctValuesRequestInput>;
};


export type MutationComWixpressCloudDataApiDataQueryReferencedDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataQueryReferencedDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataRemoveDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataRemoveDataItemRequestInput>;
};


export type MutationComWixpressCloudDataApiDataRemoveDataItemReferenceArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataRemoveDataItemReferenceRequestInput>;
};


export type MutationComWixpressCloudDataApiDataReplaceDataItemReferencesArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataReplaceDataItemReferencesRequestInput>;
};


export type MutationComWixpressCloudDataApiDataSaveDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataSaveDataItemRequestInput>;
};


export type MutationComWixpressCloudDataApiDataSearchDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataSearchDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataTruncateDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataTruncateDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataUpdateDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataUpdateDataItemRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkAddSegmentToContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkAddSegmentToContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkDeleteContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkDeleteContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkUpdateContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkUpdateContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkUpsertContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkUpsertContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4CountContactsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressContactsCoreApiV4CreateContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4CreateContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4DeleteContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4DeleteContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4GeneratePictureUploadUrlArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4GeneratePictureUploadUrlRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4LabelAndUnlabelContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4LabelAndUnlabelContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4LabelContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4LabelContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4ListContactIdsBySegmentArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4ListContactIdsBySegmentRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4ListContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4ListContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4ListFacetsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4ListFacetsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4MergeContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4MergeContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4PreviewMergeContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4PreviewMergeContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4QueryFacetsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4QueryFacetsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4SearchContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4SearchContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4SyncSubmitContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4SyncSubmitContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4UnlabelContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4UnlabelContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4UpdateContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4UpdateContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4UpsertContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4UpsertContactRequestInput>;
};


export type MutationComWixpressContactsFieldsV4DeleteExtendedFieldArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4DeleteExtendedFieldRequestInput>;
};


export type MutationComWixpressContactsFieldsV4FindOrCreateExtendedFieldArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4FindOrCreateExtendedFieldRequestInput>;
};


export type MutationComWixpressContactsFieldsV4GdprListArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4GdprListRequestInput>;
};


export type MutationComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdRequestInput>;
};


export type MutationComWixpressContactsFieldsV4ListExtendedFieldsArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4ListExtendedFieldsRequestInput>;
};


export type MutationComWixpressContactsFieldsV4PurgeArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4PurgeRequestInput>;
};


export type MutationComWixpressContactsFieldsV4UpdateExtendedFieldArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4UpdateExtendedFieldRequestInput>;
};


export type MutationComWixpressContactsLabelsV4DeleteLabelArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4DeleteLabelRequestInput>;
};


export type MutationComWixpressContactsLabelsV4FindOrCreateLabelArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4FindOrCreateLabelRequestInput>;
};


export type MutationComWixpressContactsLabelsV4GdprListArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4GdprListRequestInput>;
};


export type MutationComWixpressContactsLabelsV4GetLabelByLegacyIdArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4GetLabelByLegacyIdRequestInput>;
};


export type MutationComWixpressContactsLabelsV4ListLabelNamespacesArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4ListLabelNamespacesRequestInput>;
};


export type MutationComWixpressContactsLabelsV4ListLabelsArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4ListLabelsRequestInput>;
};


export type MutationComWixpressContactsLabelsV4PurgeArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4PurgeRequestInput>;
};


export type MutationComWixpressContactsLabelsV4UpdateLabelArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4UpdateLabelRequestInput>;
};


export type MutationComWixpressLocationsAddLocationTypeArgs = {
  input?: InputMaybe<ComWixpressLocationsAddLocationTypeRequestInput>;
};


export type MutationComWixpressLocationsAddTypeToLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsAddTypeToLocationRequestInput>;
};


export type MutationComWixpressLocationsArchiveLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsArchiveLocationRequestInput>;
};


export type MutationComWixpressLocationsBulkCreateLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsBulkCreateLocationRequestInput>;
};


export type MutationComWixpressLocationsBulkUpdateLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsBulkUpdateLocationRequestInput>;
};


export type MutationComWixpressLocationsCreateLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsCreateLocationRequestInput>;
};


export type MutationComWixpressLocationsListLocationsArgs = {
  input?: InputMaybe<ComWixpressLocationsListLocationsRequestInput>;
};


export type MutationComWixpressLocationsRemoveLocationTypeArgs = {
  input?: InputMaybe<ComWixpressLocationsRemoveLocationTypeRequestInput>;
};


export type MutationComWixpressLocationsRemoveTypeFromLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsRemoveTypeFromLocationRequestInput>;
};


export type MutationComWixpressLocationsSetDefaultLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsSetDefaultLocationRequestInput>;
};


export type MutationComWixpressLocationsUnarchiveLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsUnarchiveLocationRequestInput>;
};


export type MutationComWixpressLocationsUpdateLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsUpdateLocationRequestInput>;
};


export type MutationComWixpressMembersApiApproveMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiApproveMemberRequestInput>;
};


export type MutationComWixpressMembersApiBlockMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiBlockMemberRequestInput>;
};


export type MutationComWixpressMembersApiBulkApproveMembersArgs = {
  input?: InputMaybe<ComWixpressMembersApiBulkApproveMembersRequestInput>;
};


export type MutationComWixpressMembersApiBulkBlockMembersArgs = {
  input?: InputMaybe<ComWixpressMembersApiBulkBlockMembersRequestInput>;
};


export type MutationComWixpressMembersApiBulkDeleteMembersArgs = {
  input?: InputMaybe<ComWixpressMembersApiBulkDeleteMembersRequestInput>;
};


export type MutationComWixpressMembersApiBulkDeleteMembersByFilterArgs = {
  input?: InputMaybe<ComWixpressMembersApiBulkDeleteMembersByFilterRequestInput>;
};


export type MutationComWixpressMembersApiConsumeAddActivityToContactMessageV2Args = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationComWixpressMembersApiConsumeIdentityDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressMembersApiConsumeMemberPiiDataExchangeDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressMembersApiConsumeMetaSiteSpecialNoProvisioningEventsArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationComWixpressMembersApiConsumeProfileDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressMembersApiConsumeSiteMemberProfileUpdateArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationComWixpressMembersApiCreateMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiCreateMemberRequestInput>;
};


export type MutationComWixpressMembersApiDeleteMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiDeleteMemberRequestInput>;
};


export type MutationComWixpressMembersApiDeleteMemberAddressesArgs = {
  input?: InputMaybe<ComWixpressMembersApiDeleteMemberAddressesRequestInput>;
};


export type MutationComWixpressMembersApiDeleteMemberEmailsArgs = {
  input?: InputMaybe<ComWixpressMembersApiDeleteMemberEmailsRequestInput>;
};


export type MutationComWixpressMembersApiDeleteMemberPhonesArgs = {
  input?: InputMaybe<ComWixpressMembersApiDeleteMemberPhonesRequestInput>;
};


export type MutationComWixpressMembersApiDeleteMyMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiDeleteMyMemberRequestInput>;
};


export type MutationComWixpressMembersApiDisconnectMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiDisconnectMemberRequestInput>;
};


export type MutationComWixpressMembersApiGetMyMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiGetMyMemberRequestInput>;
};


export type MutationComWixpressMembersApiJoinCommunityArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressMembersApiLeaveCommunityArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressMembersApiListMembersArgs = {
  input?: InputMaybe<ComWixpressMembersApiListMembersRequestInput>;
};


export type MutationComWixpressMembersApiMuteMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiMuteMemberRequestInput>;
};


export type MutationComWixpressMembersApiUnmuteMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiUnmuteMemberRequestInput>;
};


export type MutationComWixpressMembersApiUpdateMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiUpdateMemberRequestInput>;
};


export type MutationComWixpressMembersApiUpdateMemberSlugArgs = {
  input?: InputMaybe<ComWixpressMembersApiUpdateMemberSlugRequestInput>;
};


export type MutationComWixpressMembersApiUpdateMySlugArgs = {
  input?: InputMaybe<ComWixpressMembersApiUpdateMySlugRequestInput>;
};


export type MutationComWixpressMembershipV2PlansArchivePlanArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansArchivePlanRequestInput>;
};


export type MutationComWixpressMembershipV2PlansArrangePlansArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansArrangePlansRequestInput>;
};


export type MutationComWixpressMembershipV2PlansBulkArchivePlanArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansBulkArchivePlanRequestInput>;
};


export type MutationComWixpressMembershipV2PlansClearPrimaryArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressMembershipV2PlansCreatePlanArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansCreatePlanRequestInput>;
};


export type MutationComWixpressMembershipV2PlansGetPlanStatsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressMembershipV2PlansListPlansArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansListPlansRequestInput>;
};


export type MutationComWixpressMembershipV2PlansListPublicPlansArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansListPublicPlansRequestInput>;
};


export type MutationComWixpressMembershipV2PlansMakePlanPrimaryArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansMakePlanPrimaryRequestInput>;
};


export type MutationComWixpressMembershipV2PlansSetPlanVisibilityArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansSetPlanVisibilityRequestInput>;
};


export type MutationComWixpressMembershipV2PlansUpdatePlanArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansUpdatePlanRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogBulkDeleteTagArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBulkDeleteTagRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogCreateTagArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogCreateTagRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogDeleteTagArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogDeleteTagRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogGetTagsCountByLanguageArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogListTagsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogListTagsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogUpdateTagArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogUpdateTagRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3BulkDeleteCategoryArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkDeleteCategoryRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3DeleteCategoryArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3DeleteCategoryRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoriesCountByLanguageArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalPostsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalPublicationsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3LikePostArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3LikePostRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3PinPostArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PinPostRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostCountStatsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3QueryPublicationsCountStatsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3SendActionEventArgs = {
  input?: InputMaybe<WixBlogKafkaProducerV1SendActionEventRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostRequestInput>;
};


export type MutationComWixpressPortfolioCollectionsAdminRemoveMenuItemsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressPortfolioCollectionsConsumeCollectionDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioCollectionsConsumeLocaleEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioCollectionsCreateCollectionArgs = {
  input?: InputMaybe<ComWixpressPortfolioCollectionsCreateCollectionRequestInput>;
};


export type MutationComWixpressPortfolioCollectionsDeleteCollectionArgs = {
  input?: InputMaybe<ComWixpressPortfolioCollectionsDeleteCollectionRequestInput>;
};


export type MutationComWixpressPortfolioCollectionsListCollectionsArgs = {
  input?: InputMaybe<ComWixpressPortfolioCollectionsListCollectionsRequestInput>;
};


export type MutationComWixpressPortfolioCollectionsUpdateCollectionArgs = {
  input?: InputMaybe<ComWixpressPortfolioCollectionsUpdateCollectionRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsBulkCreateProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsBulkCreateProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsBulkDeleteProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsBulkDeleteProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsBulkUpdateProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsBulkUpdateProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsConsumeLocaleEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioProjectitemsConsumeProjectDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioProjectitemsCreateProjectGalleryArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsCreateProjectGalleryRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsCreateProjectItemArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsCreateProjectItemRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsDeleteProjectItemArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsDeleteProjectItemRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsDuplicateProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsDuplicateProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsGenerateTokenForProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsListProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsListProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsUpdateProjectItemArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsUpdateProjectItemRequestInput>;
};


export type MutationComWixpressPortfolioProjectsConsumeCollectionDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioProjectsConsumeLocaleEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioProjectsConsumeMetaSiteSpecialEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationComWixpressPortfolioProjectsCreateNewPortfolioAppArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressPortfolioProjectsCreateProjectArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsCreateProjectRequestInput>;
};


export type MutationComWixpressPortfolioProjectsDeleteProjectArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsDeleteProjectRequestInput>;
};


export type MutationComWixpressPortfolioProjectsGetProjectPageDataArgs = {
  input?: InputMaybe<ComWixpressPortfolioPortfolioappGetProjectPageDataRequestInput>;
};


export type MutationComWixpressPortfolioProjectsListProjectsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsListProjectsRequestInput>;
};


export type MutationComWixpressPortfolioProjectsQueryProjectsWithCollectionInfoArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsQueryProjectWithCollectionInfoRequestInput>;
};


export type MutationComWixpressPortfolioProjectsUpdateProjectArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsUpdateProjectRequestInput>;
};


export type MutationComWixpressPortfolioProjectsUpdateProjectOrderInCollectionArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsUpdateProjectOrderInCollectionRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1CloneLabelsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1CloneLabelsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1ConsumeLabelDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1CountLabelsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1CountLabelsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1CreateLabelArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1CreateLabelRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1DeleteLabelArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1DeleteLabelRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1ListLabelsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1UpdateLabelArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1UpdateLabelRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1BulkCreateItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1BulkCreateItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1BulkDeleteItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1BulkDeleteItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1BulkUpdateItemArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1CloneItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1CloneItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeDeleteLocationIdsFromModifierGroupsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromModifierGroupsInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeDeleteLocationIdsFromVariantsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromVariantsInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeItemDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeItemLabelDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeSearchServicesNotificationEventsArgs = {
  input?: InputMaybe<WixSearchV1SearchIndexingNotificationInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeTaxGroupsDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1CountItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1CountItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1CreateItemArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1CreateItemRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1DeleteItemArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1DeleteItemRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1DuplicateItemArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ListItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1ListItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1MenusItemsSiteSearchConsumeSitePropertiesUpdatedEventsArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1SearchItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1SearchItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1UpdateItemArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpdateItemRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1BulkCreateMenusArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1BulkCreateMenusRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1BulkUpdateMenuArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1CloneMenusArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1CloneMenusRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1ConsumeDeleteOrphanSectionsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1DeleteOrphanSectionsInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1ConsumeMenuDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1ConsumeSectionDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1CreateMenuArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1CreateMenuRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1DeleteMenuArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1DeleteMenuRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1GetMenuArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1GetMenuRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1GetMenuSiteUrlArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1ListMenusArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1ListMenusRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1ListMenusSiteUrlArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1QueryMenusArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1QueryMenusRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1UpdateExtendedFieldsArgs = {
  input?: InputMaybe<WixCommonDataDataextensionsUpdateExtendedFieldsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1UpdateMenuArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpdateMenuRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1BulkCreateSectionsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1BulkCreateSectionsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1BulkUpdateSectionArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1CloneSectionsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1CloneSectionsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1ConsumeDeleteLocationIdFromItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1DeleteLocationIdFromItemsInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1ConsumeDeleteOrphanItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1DeleteOrphanItemsInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1ConsumeItemDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1ConsumeSectionDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1CreateSectionArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1CreateSectionRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1DeleteSectionArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1DeleteSectionRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1DuplicateSectionArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1ListSectionsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1ListSectionsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1UpdateSectionArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1UpdateSectionRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4ReadArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4PropertiesReadRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4ReadWithoutDefaultPropertiesArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4BulkPropertiesReadRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4UpdateArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4PropertiesUpdateRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4UpdateBusinessContactArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4UpdateBusinessContactRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4UpdateBusinessProfileArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4UpdateBusinessProfileRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4UpdateBusinessScheduleArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4UpdateBusinessScheduleRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4UpdateConsentPolicyArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4UpdateConsentPolicyRequestInput>;
};


export type MutationEcomCheckoutV1AddToCheckoutArgs = {
  input?: InputMaybe<EcomCheckoutV1AddToCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1ConsumeCheckoutDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationEcomCheckoutV1ConsumeOrderApprovedEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationEcomCheckoutV1ConsumeOrderCreatedV2EventsArgs = {
  input?: InputMaybe<WixOrdersApiV2OrderCreatedInput>;
};


export type MutationEcomCheckoutV1ConsumeSubscriptionCreatedEventsArgs = {
  input?: InputMaybe<WixSubscriptionsApiV1SubscriptionCreatedInput>;
};


export type MutationEcomCheckoutV1ConsumeUpdatedCheckoutEventsArgs = {
  input?: InputMaybe<EcomCheckoutV1UpdatedCheckoutMessageInput>;
};


export type MutationEcomCheckoutV1CreateCheckoutArgs = {
  input?: InputMaybe<EcomCheckoutV1CreateCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1CreateCheckoutStreamArgs = {
  input?: InputMaybe<EcomCheckoutV1CreateCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1CreateOrderArgs = {
  input?: InputMaybe<EcomCheckoutV1CreateOrderRequestInput>;
};


export type MutationEcomCheckoutV1CreateOrderAndChargeArgs = {
  input?: InputMaybe<EcomCheckoutV1CreateOrderAndChargeRequestInput>;
};


export type MutationEcomCheckoutV1DeleteCheckoutArgs = {
  input?: InputMaybe<EcomCheckoutV1DeleteCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1GetCheckoutArgs = {
  input?: InputMaybe<EcomCheckoutV1GetCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1GetCheckoutByCartIdArgs = {
  input?: InputMaybe<EcomCheckoutV1GetCheckoutByCartIdRequestInput>;
};


export type MutationEcomCheckoutV1GetCheckoutPaymentSettingsArgs = {
  input?: InputMaybe<EcomCheckoutV1GetCheckoutPaymentSettingsRequestInput>;
};


export type MutationEcomCheckoutV1GetCheckoutUrlArgs = {
  input?: InputMaybe<EcomCheckoutV1GetCheckoutUrlRequestInput>;
};


export type MutationEcomCheckoutV1GetCheckoutWithAllExtendedFieldsArgs = {
  input?: InputMaybe<EcomCheckoutV1GetCheckoutWithAllExtendedFieldsRequestInput>;
};


export type MutationEcomCheckoutV1GetWixCheckoutUrlArgs = {
  input?: InputMaybe<EcomCheckoutV1GetWixCheckoutUrlRequestInput>;
};


export type MutationEcomCheckoutV1MarkCheckoutAsCompletedArgs = {
  input?: InputMaybe<EcomCheckoutV1MarkCheckoutAsCompletedRequestInput>;
};


export type MutationEcomCheckoutV1MarkCheckoutAsCompletedAndRedirectToUrlArgs = {
  input?: InputMaybe<EcomCheckoutV1MarkCheckoutAsCompletedAndRedirectToUrlRequestInput>;
};


export type MutationEcomCheckoutV1RemoveCouponArgs = {
  input?: InputMaybe<EcomCheckoutV1RemoveCouponRequestInput>;
};


export type MutationEcomCheckoutV1RemoveGiftCardArgs = {
  input?: InputMaybe<EcomCheckoutV1RemoveGiftCardRequestInput>;
};


export type MutationEcomCheckoutV1RemoveLineItemsArgs = {
  input?: InputMaybe<EcomCheckoutV1RemoveLineItemsRequestInput>;
};


export type MutationEcomCheckoutV1RemoveOverrideCheckoutUrlArgs = {
  input?: InputMaybe<EcomCheckoutV1RemoveOverrideCheckoutUrlRequestInput>;
};


export type MutationEcomCheckoutV1UpdateCheckoutArgs = {
  input?: InputMaybe<EcomCheckoutV1UpdateCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1UpdateLineItemsQuantityArgs = {
  input?: InputMaybe<EcomCheckoutV1UpdateLineItemsQuantityRequestInput>;
};


export type MutationMetroinspectorV1ProductsBulkCreateProductsArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsBulkCreateProductsRequestInput>;
};


export type MutationMetroinspectorV1ProductsBulkDeleteProductsArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsBulkDeleteProductsRequestInput>;
};


export type MutationMetroinspectorV1ProductsBulkUpdateProductsArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsBulkUpdateProductsRequestInput>;
};


export type MutationMetroinspectorV1ProductsCountProductsArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsCountProductsRequestInput>;
};


export type MutationMetroinspectorV1ProductsCreateProductArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsCreateProductRequestInput>;
};


export type MutationMetroinspectorV1ProductsDeleteProductArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsDeleteProductRequestInput>;
};


export type MutationMetroinspectorV1ProductsGetProductsStartWithArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsGetProductsStartWithRequestInput>;
};


export type MutationMetroinspectorV1ProductsResetProductsDbArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationMetroinspectorV1ProductsUpdateProductArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsUpdateProductRequestInput>;
};


export type MutationWixBookingsCatalogV1CloneServiceOptionsAndVariantsArgs = {
  input?: InputMaybe<WixBookingsCatalogV1CloneServiceOptionsAndVariantsRequestInput>;
};


export type MutationWixBookingsCatalogV1ConsumeInternalEventsForBiArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsCatalogV1ConsumeResourceNotificationArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationInput>;
};


export type MutationWixBookingsCatalogV1ConsumeScheduleNotificationArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleNotificationInput>;
};


export type MutationWixBookingsCatalogV1ConsumeScheduleNotificationWithDeleteEffectArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleNotificationInput>;
};


export type MutationWixBookingsCatalogV1ConsumeServicesNotificationArgs = {
  input?: InputMaybe<ComWixpressBookingsServicesApiV1ServiceNotificationInput>;
};


export type MutationWixBookingsCatalogV1ConsumeSitePropertiesNotificationArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixBookingsCatalogV1CreateServiceOptionsAndVariantsArgs = {
  input?: InputMaybe<WixBookingsCatalogV1CreateServiceOptionsAndVariantsRequestInput>;
};


export type MutationWixBookingsCatalogV1DeleteServiceOptionsAndVariantsArgs = {
  input?: InputMaybe<WixBookingsCatalogV1DeleteServiceOptionsAndVariantsRequestInput>;
};


export type MutationWixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdArgs = {
  input?: InputMaybe<WixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdRequestInput>;
};


export type MutationWixBookingsCatalogV1UpdateServiceOptionsAndVariantsArgs = {
  input?: InputMaybe<WixBookingsCatalogV1UpdateServiceOptionsAndVariantsRequestInput>;
};


export type MutationWixBookingsCategoriesV2ConsumeMetaSiteSpecialEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixBookingsCategoriesV2ConsumePopulationElementCreatedDomainEventsArgs = {
  input?: InputMaybe<WixPopulationV2CreatedElementsEventInput>;
};


export type MutationWixBookingsCategoriesV2CountCategoriesArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2CountCategoriesRequestInput>;
};


export type MutationWixBookingsCategoriesV2CreateCategoryArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2CreateCategoryRequestInput>;
};


export type MutationWixBookingsCategoriesV2DeleteCategoryArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2DeleteCategoryRequestInput>;
};


export type MutationWixBookingsCategoriesV2ImportCategoriesArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2ImportCategoriesRequestInput>;
};


export type MutationWixBookingsCategoriesV2MoveCategoryArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2MoveCategoryRequestInput>;
};


export type MutationWixBookingsCategoriesV2PublishCategoriesUpdatedArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixBookingsCategoriesV2UpdateCategoryArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2UpdateCategoryRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceCreateAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2CreateAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceDeleteAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2DeleteAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceListAddOnGroupsByServiceIdArgs = {
  input?: InputMaybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceSetAddOnsForGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2SetAddOnsForGroupRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceUpdateAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2UpdateAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceValidateAddOnsSelectionArgs = {
  input?: InputMaybe<WixBookingsServicesV2ValidateAddOnsSelectionRequestInput>;
};


export type MutationWixBookingsServicesV2BulkCreateServicesArgs = {
  input?: InputMaybe<WixBookingsServicesV2BulkCreateServicesRequestInput>;
};


export type MutationWixBookingsServicesV2BulkDeleteServicesArgs = {
  input?: InputMaybe<WixBookingsServicesV2BulkDeleteServicesRequestInput>;
};


export type MutationWixBookingsServicesV2BulkDeleteServicesByFilterArgs = {
  input?: InputMaybe<WixBookingsServicesV2BulkDeleteServicesByFilterRequestInput>;
};


export type MutationWixBookingsServicesV2BulkUpdateServicesArgs = {
  input?: InputMaybe<WixBookingsServicesV2BulkUpdateServicesRequestInput>;
};


export type MutationWixBookingsServicesV2BulkUpdateServicesByFilterArgs = {
  input?: InputMaybe<WixBookingsServicesV2BulkUpdateServicesByFilterRequestInput>;
};


export type MutationWixBookingsServicesV2CloneServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2CloneServiceRequestInput>;
};


export type MutationWixBookingsServicesV2ConsumeBenefitNotificationArgs = {
  input?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitNotificationInput>;
};


export type MutationWixBookingsServicesV2ConsumeCalendarEventDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeCategoryNotificationArgs = {
  input?: InputMaybe<ComWixpressBookingsServicesApiV1CategoryNotificationInput>;
};


export type MutationWixBookingsServicesV2ConsumeDuplicateSlugsNotificationArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationWixBookingsServicesV2ConsumeHtmlSitePublishedArgs = {
  input?: InputMaybe<ComWixpressHtmlEditorApiEventsHtmlSitePublishedInput>;
};


export type MutationWixBookingsServicesV2ConsumeLocationDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeMembershipPlanDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeMultiServiceEnabledEventArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixBookingsServicesV2ConsumePaidPlanEventArgs = {
  input?: InputMaybe<ComWixpressMembershipV1PlansPlanEventInput>;
};


export type MutationWixBookingsServicesV2ConsumePolicyNotificationArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeResourceNotificationArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationInput>;
};


export type MutationWixBookingsServicesV2ConsumeResourceTypeNotificationArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeScheduleNotificationArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleNotificationInput>;
};


export type MutationWixBookingsServicesV2ConsumeScheduleTimeFrameNotificationsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeServiceDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeServiceOptionsAndVariantsNotificationArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeSitePropertiesNotificationArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixBookingsServicesV2ConsumeUserDomainInfoChangedEventArgs = {
  input?: InputMaybe<ComWixpressPremiumDomainsNotificationsUserDomainInfoChangedEventInput>;
};


export type MutationWixBookingsServicesV2CountServicesArgs = {
  input?: InputMaybe<WixBookingsServicesV2CountServicesRequestInput>;
};


export type MutationWixBookingsServicesV2CreateAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2CreateAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2CreateAddOnsGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2CreateAddOnsGroupRequestInput>;
};


export type MutationWixBookingsServicesV2CreateServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2CreateServiceRequestInput>;
};


export type MutationWixBookingsServicesV2DeleteAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2DeleteAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2DeleteAddOnsGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2DeleteAddOnsGroupRequestInput>;
};


export type MutationWixBookingsServicesV2DeleteServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2DeleteServiceRequestInput>;
};


export type MutationWixBookingsServicesV2DisablePricingPlansForServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2DisablePricingPlansForServiceRequestInput>;
};


export type MutationWixBookingsServicesV2EnablePricingPlansForServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2EnablePricingPlansForServiceRequestInput>;
};


export type MutationWixBookingsServicesV2GetServiceAvailabilityConstraintsArgs = {
  input?: InputMaybe<WixBookingsServicesV2GetServiceAvailabilityConstraintsRequestInput>;
};


export type MutationWixBookingsServicesV2ListAddOnGroupsByServiceIdArgs = {
  input?: InputMaybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdRequestInput>;
};


export type MutationWixBookingsServicesV2ListAddOnsGroupsByServiceIdArgs = {
  input?: InputMaybe<WixBookingsServicesV2ListAddOnsGroupsByServiceIdRequestInput>;
};


export type MutationWixBookingsServicesV2QueryBookingFormsArgs = {
  input?: InputMaybe<WixBookingsServicesV2QueryBookingFormsRequestInput>;
};


export type MutationWixBookingsServicesV2QueryCategoriesArgs = {
  input?: InputMaybe<WixBookingsServicesV2QueryCategoriesRequestInput>;
};


export type MutationWixBookingsServicesV2QueryLocationsArgs = {
  input?: InputMaybe<WixBookingsServicesV2QueryLocationsRequestInput>;
};


export type MutationWixBookingsServicesV2QueryPoliciesArgs = {
  input?: InputMaybe<WixBookingsServicesV2QueryPoliciesRequestInput>;
};


export type MutationWixBookingsServicesV2QueryServicesMultiLanguageArgs = {
  input?: InputMaybe<WixBookingsServicesV2QueryServicesMultiLanguageRequestInput>;
};


export type MutationWixBookingsServicesV2SearchServicesArgs = {
  input?: InputMaybe<WixBookingsServicesV2SearchServicesRequestInput>;
};


export type MutationWixBookingsServicesV2SetAddOnsForGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2SetAddOnsForGroupRequestInput>;
};


export type MutationWixBookingsServicesV2SetCustomSlugArgs = {
  input?: InputMaybe<WixBookingsServicesV2SetCustomSlugRequestInput>;
};


export type MutationWixBookingsServicesV2SetServiceLocationsArgs = {
  input?: InputMaybe<WixBookingsServicesV2SetServiceLocationsRequestInput>;
};


export type MutationWixBookingsServicesV2UpdateAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2UpdateAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2UpdateAddOnsGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2UpdateAddOnsGroupRequestInput>;
};


export type MutationWixBookingsServicesV2UpdateServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2UpdateServiceRequestInput>;
};


export type MutationWixBookingsServicesV2ValidateAddOnsSelectionArgs = {
  input?: InputMaybe<WixBookingsServicesV2ValidateAddOnsSelectionRequestInput>;
};


export type MutationWixBookingsServicesV2ValidateServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2ValidateServiceRequestInput>;
};


export type MutationWixBookingsServicesV2ValidateSlugArgs = {
  input?: InputMaybe<WixBookingsServicesV2ValidateSlugRequestInput>;
};


export type MutationWixBookingsStaffV1AssignBusinessScheduleArgs = {
  input?: InputMaybe<WixBookingsStaffV1AssignBusinessScheduleRequestInput>;
};


export type MutationWixBookingsStaffV1AssignCustomScheduleArgs = {
  input?: InputMaybe<WixBookingsStaffV1AssignCustomScheduleRequestInput>;
};


export type MutationWixBookingsStaffV1ConnectStaffMemberToUserArgs = {
  input?: InputMaybe<WixBookingsStaffV1ConnectStaffMemberToUserRequestInput>;
};


export type MutationWixBookingsStaffV1ConnectToUserArgs = {
  input?: InputMaybe<WixBookingsStaffV1ConnectToUserRequestInput>;
};


export type MutationWixBookingsStaffV1CountStaffMembersArgs = {
  input?: InputMaybe<WixBookingsStaffV1CountStaffMembersRequestInput>;
};


export type MutationWixBookingsStaffV1CreateStaffMemberArgs = {
  input?: InputMaybe<WixBookingsStaffV1CreateStaffMemberRequestInput>;
};


export type MutationWixBookingsStaffV1DeleteStaffMemberArgs = {
  input?: InputMaybe<WixBookingsStaffV1DeleteStaffMemberRequestInput>;
};


export type MutationWixBookingsStaffV1DisconnectStaffMemberFromUserArgs = {
  input?: InputMaybe<WixBookingsStaffV1DisconnectStaffMemberFromUserRequestInput>;
};


export type MutationWixBookingsStaffV1DisconnectUserArgs = {
  input?: InputMaybe<WixBookingsStaffV1DisconnectUserRequestInput>;
};


export type MutationWixBookingsStaffV1HandleFileDescriptorDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsStaffV1HandleMemberDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsStaffV1HandlePolicyRemovedFromContributorArgs = {
  input?: InputMaybe<ComWixpressAuthorizationAbacManagementEventsPolicyRemovedFromContributorInput>;
};


export type MutationWixBookingsStaffV1HandlePolicyUpdatedForContributorArgs = {
  input?: InputMaybe<ComWixpressAuthorizationAbacManagementEventsPolicyUpdatedForContributorInput>;
};


export type MutationWixBookingsStaffV1HandleResourceDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsStaffV1HandleScheduleNotificationArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleNotificationInput>;
};


export type MutationWixBookingsStaffV1HandleStaffConnectedToUserArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationWixBookingsStaffV1HandleStaffDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsStaffV1ImportStaffMemberArgs = {
  input?: InputMaybe<WixBookingsStaffV1ImportStaffMemberRequestInput>;
};


export type MutationWixBookingsStaffV1RestoreStaffArgs = {
  input?: InputMaybe<WixBookingsStaffV1RestoreStaffRequestInput>;
};


export type MutationWixBookingsStaffV1UpdateStaffMemberArgs = {
  input?: InputMaybe<WixBookingsStaffV1UpdateStaffMemberRequestInput>;
};


export type MutationWixBookingsV1ConsumeBookingPolicyDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsV1ConsumeMetaSiteSpecialEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixBookingsV1ConsumeSitePropertiesNotificationArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixBookingsV1CountBookingPoliciesArgs = {
  input?: InputMaybe<WixBookingsV1CountBookingPoliciesRequestInput>;
};


export type MutationWixBookingsV1CreateBookingPolicyArgs = {
  input?: InputMaybe<WixBookingsV1CreateBookingPolicyRequestInput>;
};


export type MutationWixBookingsV1CreateMissingDefaultPolicyArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixBookingsV1DeleteBookingPolicyArgs = {
  input?: InputMaybe<WixBookingsV1DeleteBookingPolicyRequestInput>;
};


export type MutationWixBookingsV1GetArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixBookingsV1GetStrictestBookingPolicyArgs = {
  input?: InputMaybe<WixBookingsV1GetStrictestBookingPolicyRequestInput>;
};


export type MutationWixBookingsV1SetDefaultBookingPolicyArgs = {
  input?: InputMaybe<WixBookingsV1SetDefaultBookingPolicyRequestInput>;
};


export type MutationWixBookingsV1UpdateArgs = {
  input?: InputMaybe<ComWixpressBookingsServicesApiV1UpdatePolicyRequestInput>;
};


export type MutationWixBookingsV1UpdateAllPoliciesArgs = {
  input?: InputMaybe<WixBookingsV1UpdateAllPoliciesRequestInput>;
};


export type MutationWixBookingsV1UpdateBookingPolicyArgs = {
  input?: InputMaybe<WixBookingsV1UpdateBookingPolicyRequestInput>;
};


export type MutationWixCalendarEventsV3BulkCancelEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3BulkCancelEventRequestInput>;
};


export type MutationWixCalendarEventsV3BulkCreateEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3BulkCreateEventRequestInput>;
};


export type MutationWixCalendarEventsV3BulkUpdateEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3BulkUpdateEventRequestInput>;
};


export type MutationWixCalendarEventsV3CancelEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3CancelEventRequestInput>;
};


export type MutationWixCalendarEventsV3CreateEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3CreateEventRequestInput>;
};


export type MutationWixCalendarEventsV3DeleteTargetsArgs = {
  input?: InputMaybe<WixCalendarMigrationV3DeleteTargetsRequestInput>;
};


export type MutationWixCalendarEventsV3FixSched38956Args = {
  input?: InputMaybe<WixCalendarMigrationV3FixSched38956RequestInput>;
};


export type MutationWixCalendarEventsV3HandleBusinessLocationDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleContactMergedDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleEventDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleGdprUoUAccessRequestArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationWixCalendarEventsV3HandleGdprUoUDeleteRequestArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationWixCalendarEventsV3HandleMetaSiteEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixCalendarEventsV3HandleParticipationDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleResourceDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleScheduleDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleScheduleTimeFrameDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleSelfDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleSitePropertiesNotificationArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixCalendarEventsV3ListEventsArgs = {
  input?: InputMaybe<WixCalendarEventsV3ListEventsRequestInput>;
};


export type MutationWixCalendarEventsV3ListEventsByContactIdArgs = {
  input?: InputMaybe<WixCalendarParticipanteventsV3ListEventsByContactIdRequestInput>;
};


export type MutationWixCalendarEventsV3ListEventsByMemberIdArgs = {
  input?: InputMaybe<WixCalendarParticipanteventsV3ListEventsByMemberIdRequestInput>;
};


export type MutationWixCalendarEventsV3ListParticipantEventsArgs = {
  input?: InputMaybe<WixCalendarParticipanteventsV3ListParticipantEventsRequestInput>;
};


export type MutationWixCalendarEventsV3ListRecurringEventInstancesHistoryArgs = {
  input?: InputMaybe<WixCalendarEventsV3ListRecurringEventInstancesHistoryRequestInput>;
};


export type MutationWixCalendarEventsV3MigrateSiteArgs = {
  input?: InputMaybe<WixCalendarMigrationV3MigrateSiteRequestInput>;
};


export type MutationWixCalendarEventsV3ParticipantEventsHandleMetaSiteEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixCalendarEventsV3ParticipantEventsHandleSitePropertiesNotificationArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixCalendarEventsV3RestoreEventDefaultsArgs = {
  input?: InputMaybe<WixCalendarEventsV3RestoreEventDefaultsRequestInput>;
};


export type MutationWixCalendarEventsV3SplitRecurringEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3SplitRecurringEventRequestInput>;
};


export type MutationWixCalendarEventsV3UpdateEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3UpdateEventRequestInput>;
};


export type MutationWixCalendarEventsV3UpdateEventParticipantsArgs = {
  input?: InputMaybe<WixCalendarEventsV3UpdateEventParticipantsRequestInput>;
};


export type MutationWixCalendarSchedulesV3CancelScheduleArgs = {
  input?: InputMaybe<WixCalendarSchedulesV3CancelScheduleRequestInput>;
};


export type MutationWixCalendarSchedulesV3CloneScheduleArgs = {
  input?: InputMaybe<WixCalendarSchedulesV3CloneScheduleRequestInput>;
};


export type MutationWixCalendarSchedulesV3ConsumeLocationDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarSchedulesV3ConsumeSitePropertiesEventsArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixCalendarSchedulesV3CreateScheduleArgs = {
  input?: InputMaybe<WixCalendarSchedulesV3CreateScheduleRequestInput>;
};


export type MutationWixCalendarSchedulesV3HandleMetaSiteEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixCalendarSchedulesV3UpdateScheduleArgs = {
  input?: InputMaybe<WixCalendarSchedulesV3UpdateScheduleRequestInput>;
};


export type MutationWixCatalogApiV1AddProductMediaArgs = {
  input?: InputMaybe<WixCatalogApiV1AddProductMediaRequestInput>;
};


export type MutationWixCatalogApiV1AddProductMediaToChoicesArgs = {
  input?: InputMaybe<WixCatalogApiV1AddProductMediaToChoicesRequestInput>;
};


export type MutationWixCatalogApiV1AddProductsToCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1AddProductsToCollectionRequestInput>;
};


export type MutationWixCatalogApiV1AggregateProductsArgs = {
  input?: InputMaybe<WixCatalogApiV1AggregateProductsRequestInput>;
};


export type MutationWixCatalogApiV1BulkAdjustProductPropertiesArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkAdjustProductPropertiesRequestInput>;
};


export type MutationWixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncRequestInput>;
};


export type MutationWixCatalogApiV1BulkDeleteProductsArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkDeleteProductsRequestInput>;
};


export type MutationWixCatalogApiV1BulkQueryCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkQueryCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1BulkRemoveCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkRemoveCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1BulkSetCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkSetCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1BulkUpdateProductsArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkUpdateProductsRequestInput>;
};


export type MutationWixCatalogApiV1BulkUpdateProductsByFilterSyncArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkUpdateProductsByFilterSyncRequestInput>;
};


export type MutationWixCatalogApiV1CreateCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1CreateCollectionRequestInput>;
};


export type MutationWixCatalogApiV1CreateDigitalProductArgs = {
  input?: InputMaybe<WixCatalogApiV1CreateDigitalProductRequestInput>;
};


export type MutationWixCatalogApiV1CreateProductArgs = {
  input?: InputMaybe<WixCatalogApiV1CreateProductRequestInput>;
};


export type MutationWixCatalogApiV1CreateProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogApiV1CreateProductPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1DeleteCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1DeleteCollectionRequestInput>;
};


export type MutationWixCatalogApiV1DeleteProductArgs = {
  input?: InputMaybe<WixCatalogApiV1DeleteProductRequestInput>;
};


export type MutationWixCatalogApiV1DeleteProductOptionsArgs = {
  input?: InputMaybe<WixCatalogApiV1DeleteProductOptionsRequestInput>;
};


export type MutationWixCatalogApiV1DeleteProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogApiV1DeleteProductPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1GetCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1GetCollectionRequestInput>;
};


export type MutationWixCatalogApiV1GetCollectionBySlugArgs = {
  input?: InputMaybe<WixCatalogApiV1GetCollectionBySlugRequestInput>;
};


export type MutationWixCatalogApiV1GetProductArgs = {
  input?: InputMaybe<WixCatalogApiV1GetProductRequestInput>;
};


export type MutationWixCatalogApiV1GetProductsArgs = {
  input?: InputMaybe<WixCatalogApiV1GetProductsRequestInput>;
};


export type MutationWixCatalogApiV1GetStoreVariantArgs = {
  input?: InputMaybe<WixCatalogApiV1GetStoreVariantRequestInput>;
};


export type MutationWixCatalogApiV1ProductOptionsAvailabilityArgs = {
  input?: InputMaybe<WixCatalogApiV1ProductOptionsAvailabilityRequestInput>;
};


export type MutationWixCatalogApiV1QueryCollectionsArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryCollectionsRequestInput>;
};


export type MutationWixCatalogApiV1QueryCollectionsPlatformizedArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryCollectionsPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1QueryCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1QueryProductVariantsArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryProductVariantsRequestInput>;
};


export type MutationWixCatalogApiV1QueryProductsArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryProductsRequestInput>;
};


export type MutationWixCatalogApiV1QueryProductsWithBigPageLimitArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryProductsWithBigPageLimitRequestInput>;
};


export type MutationWixCatalogApiV1QueryStoreVariantsArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryStoreVariantsRequestInput>;
};


export type MutationWixCatalogApiV1QueryStoreVariantsWithBigLimitArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryStoreVariantsWithBigLimitRequestInput>;
};


export type MutationWixCatalogApiV1ReCloneStoreArgs = {
  input?: InputMaybe<WixCatalogApiV1ReCloneStoreRequestInput>;
};


export type MutationWixCatalogApiV1RemoveBrandArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveProductBrandRequestInput>;
};


export type MutationWixCatalogApiV1RemoveCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1RemoveProductMediaArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveProductMediaRequestInput>;
};


export type MutationWixCatalogApiV1RemoveProductMediaFromChoicesArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveProductMediaFromChoicesRequestInput>;
};


export type MutationWixCatalogApiV1RemoveProductsFromCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveProductsFromCollectionRequestInput>;
};


export type MutationWixCatalogApiV1RemoveRibbonArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveProductRibbonRequestInput>;
};


export type MutationWixCatalogApiV1ResetAllVariantDataArgs = {
  input?: InputMaybe<WixCatalogApiV1ResetAllVariantDataRequestInput>;
};


export type MutationWixCatalogApiV1SetCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1SetCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1UpdateCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1UpdateCollectionRequestInput>;
};


export type MutationWixCatalogApiV1UpdateProductArgs = {
  input?: InputMaybe<WixCatalogApiV1UpdateProductRequestInput>;
};


export type MutationWixCatalogApiV1UpdateProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogApiV1UpdateProductPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1UpdateVariantsArgs = {
  input?: InputMaybe<WixCatalogApiV1UpdateVariantsRequestInput>;
};


export type MutationWixCatalogApiV1WriteProxyCreateProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogWriteProxyV1CreateProductPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1WriteProxyDeleteProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogWriteProxyV1DeleteProductPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1WriteProxyUpdateProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogWriteProxyV1UpdateProductPlatformizedRequestInput>;
};


export type MutationWixCoreservicesMetroinspectorV1EchoArgs = {
  input?: InputMaybe<WixCoreservicesMetroinspectorV1EchoRequestInput>;
};


export type MutationWixEventsBulkCancelEventsArgs = {
  input?: InputMaybe<WixEventsBulkCancelEventsRequestInput>;
};


export type MutationWixEventsBulkDeleteEventsArgs = {
  input?: InputMaybe<WixEventsBulkDeleteEventsRequestInput>;
};


export type MutationWixEventsCancelEventArgs = {
  input?: InputMaybe<WixEventsCancelEventRequestInput>;
};


export type MutationWixEventsCopyArgs = {
  input?: InputMaybe<WixEventsCopyEventRequestInput>;
};


export type MutationWixEventsCopyEventFromOtherSiteArgs = {
  input?: InputMaybe<WixEventsCopyEventFromOtherSiteRequestInput>;
};


export type MutationWixEventsCopyEventV2Args = {
  input?: InputMaybe<WixEventsCopyEventV2RequestInput>;
};


export type MutationWixEventsCreateEventV2Args = {
  input?: InputMaybe<WixEventsCreateEventV2RequestInput>;
};


export type MutationWixEventsDeleteEventArgs = {
  input?: InputMaybe<WixEventsDeleteEventRequestInput>;
};


export type MutationWixEventsFindEventArgs = {
  input?: InputMaybe<WixEventsFindEventRequestInput>;
};


export type MutationWixEventsFindOnlineConferenceSessionArgs = {
  input?: InputMaybe<WixEventsFindOnlineConferenceSessionRequestInput>;
};


export type MutationWixEventsGetRecurringEventStateArgs = {
  input?: InputMaybe<WixEventsGetRecurringEventStateRequestInput>;
};


export type MutationWixEventsGetTicketingSummaryArgs = {
  input?: InputMaybe<WixEventsGetTicketingSummaryRequestInput>;
};


export type MutationWixEventsListCategoryEventsArgs = {
  input?: InputMaybe<WixEventsListCategoryEventsRequestInput>;
};


export type MutationWixEventsListEventsArgs = {
  input?: InputMaybe<WixEventsListEventsRequestInput>;
};


export type MutationWixEventsListUserEventsArgs = {
  input?: InputMaybe<WixEventsListUserEventsRequestInput>;
};


export type MutationWixEventsPublishDraftEventArgs = {
  input?: InputMaybe<WixEventsPublishDraftEventRequestInput>;
};


export type MutationWixEventsQueryArgs = {
  input?: InputMaybe<WixEventsQueryEventsRequestInput>;
};


export type MutationWixEventsScheduleAddScheduleItemArgs = {
  input?: InputMaybe<WixEventsScheduleAddScheduleItemRequestInput>;
};


export type MutationWixEventsScheduleCreateBookmarkArgs = {
  input?: InputMaybe<WixEventsScheduleCreateBookmarkRequestInput>;
};


export type MutationWixEventsScheduleDeleteBookmarkArgs = {
  input?: InputMaybe<WixEventsScheduleDeleteBookmarkRequestInput>;
};


export type MutationWixEventsScheduleDeleteScheduleItemArgs = {
  input?: InputMaybe<WixEventsScheduleDeleteScheduleItemRequestInput>;
};


export type MutationWixEventsScheduleDiscardDraftArgs = {
  input?: InputMaybe<WixEventsScheduleDiscardDraftRequestInput>;
};


export type MutationWixEventsScheduleGetScheduleItemArgs = {
  input?: InputMaybe<WixEventsScheduleGetScheduleItemRequestInput>;
};


export type MutationWixEventsScheduleListBookmarksArgs = {
  input?: InputMaybe<WixEventsScheduleListBookmarksRequestInput>;
};


export type MutationWixEventsScheduleListScheduleItemsArgs = {
  input?: InputMaybe<WixEventsScheduleListScheduleItemsRequestInput>;
};


export type MutationWixEventsSchedulePublishDraftArgs = {
  input?: InputMaybe<WixEventsSchedulePublishDraftRequestInput>;
};


export type MutationWixEventsScheduleRescheduleDraftArgs = {
  input?: InputMaybe<WixEventsScheduleRescheduleDraftRequestInput>;
};


export type MutationWixEventsScheduleUpdateScheduleItemArgs = {
  input?: InputMaybe<WixEventsScheduleUpdateScheduleItemRequestInput>;
};


export type MutationWixEventsUpdateEventArgs = {
  input?: InputMaybe<WixEventsUpdateEventRequestInput>;
};


export type MutationWixEventsUpdateRecurringStatusArgs = {
  input?: InputMaybe<WixEventsUpdateRecurringStatusRequestInput>;
};


export type MutationWixEventsV2ConsumeEventCopiedArgs = {
  input?: InputMaybe<WixEventsEventsEventCopiedInput>;
};


export type MutationWixEventsV2CreatePolicyArgs = {
  input?: InputMaybe<WixEventsV2CreatePolicyRequestInput>;
};


export type MutationWixEventsV2DeletePolicyArgs = {
  input?: InputMaybe<WixEventsV2DeletePolicyRequestInput>;
};


export type MutationWixEventsV2GetPolicyFromTrashBinArgs = {
  input?: InputMaybe<WixEventsV2GetPolicyFromTrashBinRequestInput>;
};


export type MutationWixEventsV2ReorderEventPoliciesArgs = {
  input?: InputMaybe<WixEventsV2ReorderEventPoliciesRequestInput>;
};


export type MutationWixEventsV2UpdatePolicyArgs = {
  input?: InputMaybe<WixEventsV2UpdatePolicyRequestInput>;
};


export type MutationWixEventsV2UpdatePolicySortIndexArgs = {
  input?: InputMaybe<WixEventsV2UpdatePolicySortIndexRequestInput>;
};


export type MutationWixFormsV4BulkCreateFormArgs = {
  input?: InputMaybe<WixFormsV4BulkCreateFormRequestInput>;
};


export type MutationWixFormsV4BulkRemoveDeletedFieldArgs = {
  input?: InputMaybe<WixFormsV4BulkRemoveDeletedFieldRequestInput>;
};


export type MutationWixFormsV4CloneFormArgs = {
  input?: InputMaybe<WixFormsV4CloneFormRequestInput>;
};


export type MutationWixFormsV4ConsumeFormDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixFormsV4ConsumeFormTemplateDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixFormsV4CountFormsArgs = {
  input?: InputMaybe<WixFormsV4CountFormsRequestInput>;
};


export type MutationWixFormsV4CreateFormArgs = {
  input?: InputMaybe<WixFormsV4CreateFormRequestInput>;
};


export type MutationWixFormsV4DeleteFormArgs = {
  input?: InputMaybe<WixFormsV4DeleteFormRequestInput>;
};


export type MutationWixFormsV4DeleteFormFromTrashBinArgs = {
  input?: InputMaybe<WixFormsV4DeleteFormFromTrashBinRequestInput>;
};


export type MutationWixFormsV4GetDeletedFormArgs = {
  input?: InputMaybe<WixFormsV4GetDeletedFormRequestInput>;
};


export type MutationWixFormsV4ListDeletedFormsArgs = {
  input?: InputMaybe<WixFormsV4ListDeletedFormsRequestInput>;
};


export type MutationWixFormsV4ListFormsArgs = {
  input?: InputMaybe<WixFormsV4ListFormsRequestInput>;
};


export type MutationWixFormsV4QueryFormsArgs = {
  input?: InputMaybe<WixFormsV4QueryFormsRequestInput>;
};


export type MutationWixFormsV4RestoreFromTrashBinArgs = {
  input?: InputMaybe<WixFormsV4RestoreFromTrashBinRequestInput>;
};


export type MutationWixFormsV4UpdateExtendedFieldsArgs = {
  input?: InputMaybe<WixCommonDataDataextensionsUpdateExtendedFieldsRequestInput>;
};


export type MutationWixFormsV4UpdateFormArgs = {
  input?: InputMaybe<WixFormsV4UpdateFormRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1ConsumeGiftCardsAndStoreCreditAppsProvisionedEventsArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixGiftCardsGiftCardV1ConsumeGiftCardsAppProvisionedEventsArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixGiftCardsGiftCardV1ConsumeSiteCurrencyUpdatesArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixGiftCardsGiftCardV1ConsumeSitePropertiesUpdatesArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixGiftCardsGiftCardV1ConsumeTriggerGiftCardsAppInstallationFlowEventsArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1TriggerGiftCardsAppInstallationFlowEventInput>;
};


export type MutationWixGiftCardsGiftCardV1CountGiftCardsArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1CountGiftCardsRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1CreateGiftCardArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1CreateGiftCardRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1DisableGiftCardArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1DisableGiftCardRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1FulfillGiftCardOrderArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1FulfillGiftCardOrderRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1ListGiftCardsByEmailArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1ListGiftCardsByEmailRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1SearchGiftCardsArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1SearchGiftCardsRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1SendGiftCardEmailArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1SendGiftCardEmailRequestInput>;
};


export type MutationWixHeadlessV1CreateOAuthAppArgs = {
  input?: InputMaybe<WixHeadlessV1CreateOAuthAppRequestInput>;
};


export type MutationWixHeadlessV1DeleteOAuthAppArgs = {
  input?: InputMaybe<WixHeadlessV1DeleteOAuthAppRequestInput>;
};


export type MutationWixHeadlessV1GenerateOAuthAppSecretArgs = {
  input?: InputMaybe<WixHeadlessV1GenerateOAuthAppSecretRequestInput>;
};


export type MutationWixHeadlessV1QueryOAuthAppArgs = {
  input?: InputMaybe<WixHeadlessV1QueryOAuthAppsRequestInput>;
};


export type MutationWixHeadlessV1SiteClonedArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixHeadlessV1SitePublishedArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixHeadlessV1UpdateOAuthAppArgs = {
  input?: InputMaybe<WixHeadlessV1UpdateOAuthAppRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ApplyCouponArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ApplyCouponRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkAddAllToProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkAddAllToProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkAddToProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkAddToProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkApproveAllParticipantArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkApproveAllParticipantRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkApproveParticipantArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkApproveParticipantRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkInviteAllToProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkInviteAllToProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkInviteToProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkInviteToProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3CompleteParticipantArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3CompleteParticipantRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ConsumeBenefitsEventsArgs = {
  input?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitNotificationInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ConsumeParticipantsBulkCompleteEventArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ParticipantsBulkCompleteEventInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ConsumeParticipantsBulkDeleteEventArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ParticipantsBulkDeleteEventInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ConsumePaymentEventsArgs = {
  input?: InputMaybe<WixPaymentApiPayV3PaymentEventInput>;
};


export type MutationWixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3DeleteParticipantArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3DeleteParticipantRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ExportParticipantsStatsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ExportParticipantsStatsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3GetAccessStatusArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixOnlineprogramsParticipantsV3GetCompletionStatsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3GetCompletionStatsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3GetPremiumStatsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixOnlineprogramsParticipantsV3GetProgramSummariesArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3GetProgramSummariesRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3GetResolvedStepArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3GetResolvedStepRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3GetStatisticsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3GetStatisticsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3IssueCertificateArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3IssueCertificateRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3JoinProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3JoinProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3LeaveProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3LeaveProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ListResolvedStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ListResolvedStepsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3QueryProgramSummariesArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3QueryProgramSummariesRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3QueryResolvedStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3QueryResolvedStepsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ResolveStepArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ResolveStepRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3RevertCouponArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3RevertCouponRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3UndoStepArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3UndoStepRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3ArchiveProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3ArchiveProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3BulkCreateProgramsMigrationArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3BulkUpdateProgramsArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3BulkUpdateProgramsRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3ConsumeMetaSiteSpecialEventsArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixOnlineprogramsProgramsV3ConsumeSiteSearchIndexingEventsArgs = {
  input?: InputMaybe<WixSearchV1SearchIndexingNotificationInput>;
};


export type MutationWixOnlineprogramsProgramsV3CountProgramsArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3CountProgramsRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3CreateProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3CreateProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3DeleteProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3DeleteProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3DuplicateProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3DuplicateProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3EndProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3EndProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3GetProgramMembershipArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3GetProgramMembershipRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3ListProgramMembershipsArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3ListProgramMembershipsRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3ListSampleProgramsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixOnlineprogramsProgramsV3PublishProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3PublishProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3ResolveProgramSlugArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3ResolveProgramSlugRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3SearchProgramsArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3SearchProgramsRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3UpdateProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3UpdateProgramRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3BulkCloneStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3BulkCloneStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3BulkCreateStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3BulkCreateStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3BulkCreateStepMigrationArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3BulkCreateStepMigrationRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3CloneStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3CloneStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3CreateStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3CreateStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3DeleteAllProgramStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3DeleteAllProgramStepsRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3DeleteStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3DeleteStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3ListAllProgramStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3ListAllProgramStepsRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3MoveStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3MoveStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3QueryStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3QueryStepsRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3QueryStepsWithoutPagingArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3QueryStepsWithoutPagingRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3UpdateStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3UpdateStepRequestInput>;
};


export type MutationWixPaymentsPaymentAgreementsV1CreatePaymentAgreementArgs = {
  input?: InputMaybe<WixPaymentsPaymentAgreementsV1CreatePaymentAgreementRequestInput>;
};


export type MutationWixPaymentsPaymentAgreementsV1DeletePaymentAgreementArgs = {
  input?: InputMaybe<WixPaymentsPaymentAgreementsV1DeletePaymentAgreementRequestInput>;
};


export type MutationWixPaymentsPaymentAgreementsV1FinalizePaymentAgreementArgs = {
  input?: InputMaybe<WixPaymentsPaymentAgreementsV1FinalizePaymentAgreementRequestInput>;
};


export type MutationWixPaymentsPaymentAgreementsV1UpdateExtendedFieldsArgs = {
  input?: InputMaybe<WixPaymentsPaymentAgreementsV1UpdateExtendedFieldsRequestInput>;
};


export type MutationWixPaymentsPaymentAgreementsV1UpdatePaymentAgreementArgs = {
  input?: InputMaybe<WixPaymentsPaymentAgreementsV1UpdatePaymentAgreementRequestInput>;
};


export type MutationWixPaymentsRefundsV1CreateRefundArgs = {
  input?: InputMaybe<WixPaymentsRefundsV1CreateRefundRequestInput>;
};


export type MutationWixPaymentsRefundsV1GetRefundabilityArgs = {
  input?: InputMaybe<WixPaymentsRefundsV1GetRefundabilityRequestInput>;
};


export type MutationWixPaymentsRefundsV1SyncRefundArgs = {
  input?: InputMaybe<WixPaymentsRefundsV1InternalSyncRefundRequestInput>;
};


export type MutationWixPaymentsRefundsV1UpdateExtendedFieldsArgs = {
  input?: InputMaybe<WixCommonDataDataextensionsUpdateExtendedFieldsRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1DeleteSavedPaymentMethodArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1DeleteSavedPaymentMethodRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1FindSavedCreditCardArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1FindSavedCreditCardRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1MarkSavedPaymentMethodPrimaryArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1MarkSavedPaymentMethodPrimaryRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodRequestInput>;
};


export type MutationWixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesArgs = {
  input?: InputMaybe<WixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesRequestInput>;
};


export type MutationWixReceiptsV1ConsumeGenerateReceiptDocumentEventsArgs = {
  input?: InputMaybe<WixReceiptsV1EventsGenerateReceiptDocumentInput>;
};


export type MutationWixReceiptsV1ConsumeReceiptDocumentHandledEventsArgs = {
  input?: InputMaybe<WixReceiptsV1EventsReceiptDocumentHandledInput>;
};


export type MutationWixReceiptsV1ConsumeReceiptNumberingProcessEventsArgs = {
  input?: InputMaybe<WixReceiptsV1EventsReceiptNumberingProcessInput>;
};


export type MutationWixReceiptsV1CreateReceiptArgs = {
  input?: InputMaybe<WixReceiptsV1CreateReceiptRequestInput>;
};


export type MutationWixReceiptsV1GetLatestReceiptNumberArgs = {
  input?: InputMaybe<WixReceiptsV1GetLatestReceiptNumberRequestInput>;
};


export type MutationWixReceiptsV1RegenerateReceiptDocumentArgs = {
  input?: InputMaybe<WixReceiptsV1RegenerateReceiptDocumentRequestInput>;
};


export type MutationWixReceiptsV1SendReceiptEmailArgs = {
  input?: InputMaybe<WixReceiptsV1SendReceiptEmailRequestInput>;
};


export type MutationWixReceiptsV1UpdateExtendedFieldsArgs = {
  input?: InputMaybe<WixCommonDataDataextensionsUpdateExtendedFieldsRequestInput>;
};


export type MutationWixReceiptsV1UpdateReceiptArgs = {
  input?: InputMaybe<WixReceiptsV1BackofficeUpdateReceiptRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkCreateModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkCreateModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkDeleteModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkDeleteModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkUpdateModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkUpdateModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1CloneModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1CloneModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1ConsumeModifiersDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1CountModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1CountModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1CreateModifierArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1CreateModifierRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1DeleteModifierArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1DeleteModifierRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1ListModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1ListModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1UpdateModifierArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1UpdateModifierRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkCreateVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkCreateVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkDeleteVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkDeleteVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkUpdateVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkUpdateVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1CloneVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1CloneVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1ConsumeVariantsDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1CountVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1CountVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1CreateVariantArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1CreateVariantRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1DeleteVariantArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1DeleteVariantRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1ListVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1ListVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1UpdateVariantArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1UpdateVariantRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkCreateModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkCreateModifierGroupsRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkDeleteModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkDeleteModifierGroupsRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkUpdateModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkUpdateModifierGroupsRequestInput>;
};


export type MutationWixRestaurantsMenusV1CloneModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1CloneModifierGroupsRequestInput>;
};


export type MutationWixRestaurantsMenusV1ConsumeDeleteLocationIdsFromModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1DeleteLocationIdsFromModifiersInput>;
};


export type MutationWixRestaurantsMenusV1ConsumeModifierGroupsDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRestaurantsMenusV1CountModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1CountModifierGroupsRequestInput>;
};


export type MutationWixRestaurantsMenusV1CreateModifierGroupArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1CreateModifierGroupRequestInput>;
};


export type MutationWixRestaurantsMenusV1DeleteModifierGroupArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1DeleteModifierGroupRequestInput>;
};


export type MutationWixRestaurantsMenusV1ListModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1ListModifierGroupRequestInput>;
};


export type MutationWixRestaurantsMenusV1UpdateModifierGroupArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1UpdateModifierGroupRequestInput>;
};


export type MutationWixRiseV1AddCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1AddCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1BulkDeleteGiftCardsByFilterArgs = {
  input?: InputMaybe<WixRiseV1BulkDeleteGiftCardsByFilterRequestInput>;
};


export type MutationWixRiseV1ConsumeGiftCardEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRiseV1ConsumeWalletActionEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRiseV1ConsumeWalletEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRiseV1CountGiftCardsArgs = {
  input?: InputMaybe<WixRiseV1CountGiftCardsRequestInput>;
};


export type MutationWixRiseV1CountWalletsArgs = {
  input?: InputMaybe<WixRiseV1CountWalletsRequestInput>;
};


export type MutationWixRiseV1CreateCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1CreateCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1CreateGiftCardArgs = {
  input?: InputMaybe<WixRiseV1CreateGiftCardRequestInput>;
};


export type MutationWixRiseV1CreateMigrationGiftCardArgs = {
  input?: InputMaybe<WixRiseV1CreateMigrationGiftCardRequestInput>;
};


export type MutationWixRiseV1CreateMigrationTransactionArgs = {
  input?: InputMaybe<WixRiseV1CreateMigrationTransactionRequestInput>;
};


export type MutationWixRiseV1CreateMigrationWalletActionArgs = {
  input?: InputMaybe<WixRiseV1CreateMigrationWalletActionRequestInput>;
};


export type MutationWixRiseV1CreateWalletArgs = {
  input?: InputMaybe<WixRiseV1CreateWalletRequestInput>;
};


export type MutationWixRiseV1CreateWalletActionArgs = {
  input?: InputMaybe<WixRiseV1CreateWalletActionRequestInput>;
};


export type MutationWixRiseV1CreateWalletActionByCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1CreateWalletActionByCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1DecreaseBalanceArgs = {
  input?: InputMaybe<WixRiseV1DecreaseBalanceRequestInput>;
};


export type MutationWixRiseV1DeleteCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1DeleteCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1DeleteWalletActionArgs = {
  input?: InputMaybe<WixRiseV1DeleteWalletActionRequestInput>;
};


export type MutationWixRiseV1DisableGiftCardArgs = {
  input?: InputMaybe<WixRiseV1DisableGiftCardRequestInput>;
};


export type MutationWixRiseV1DisableWalletActionArgs = {
  input?: InputMaybe<WixRiseV1DisableWalletActionRequestInput>;
};


export type MutationWixRiseV1EndMigrationWalletActionArgs = {
  input?: InputMaybe<WixRiseV1EndMigrationWalletActionRequestInput>;
};


export type MutationWixRiseV1GetCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1GetCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1GetGiftCardConsistentArgs = {
  input?: InputMaybe<WixRiseV1GetGiftCardConsistentRequestInput>;
};


export type MutationWixRiseV1GetOrCreateWalletArgs = {
  input?: InputMaybe<WixRiseV1GetOrCreateWalletRequestInput>;
};


export type MutationWixRiseV1GetRefundableAmountsArgs = {
  input?: InputMaybe<WixRiseV1GetRefundableAmountsRequestInput>;
};


export type MutationWixRiseV1GetWalletArgs = {
  input?: InputMaybe<WixRiseV1GetWalletRequestInput>;
};


export type MutationWixRiseV1GetWalletGiftCardArgs = {
  input?: InputMaybe<WixRiseV1GetWalletGiftCardRequestInput>;
};


export type MutationWixRiseV1HandleEvenExpirationTaskArgs = {
  input?: InputMaybe<WixInfraTimecapsuleV2TaskInput>;
};


export type MutationWixRiseV1HandleEvenStartTaskArgs = {
  input?: InputMaybe<WixInfraTimecapsuleV2TaskInput>;
};


export type MutationWixRiseV1HandleWalletActionEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRiseV1IncreaseBalanceArgs = {
  input?: InputMaybe<WixRiseV1IncreaseBalanceRequestInput>;
};


export type MutationWixRiseV1MigrateWalletArgs = {
  input?: InputMaybe<WixRiseV1MigrateWalletRequestInput>;
};


export type MutationWixRiseV1ProduceTransactionAddedEventArgs = {
  input?: InputMaybe<WixRiseV1ProduceTransactionAddedEventRequestInput>;
};


export type MutationWixRiseV1QueryGiftCardsArgs = {
  input?: InputMaybe<WixRiseV1QueryGiftCardsRequestInput>;
};


export type MutationWixRiseV1QueryTransactionsArgs = {
  input?: InputMaybe<WixRiseV1QueryTransactionsRequestInput>;
};


export type MutationWixRiseV1QueryTransactionsInternalArgs = {
  input?: InputMaybe<WixRiseV1QueryTransactionsInternalRequestInput>;
};


export type MutationWixRiseV1QueryUnredeemedWalletActionsArgs = {
  input?: InputMaybe<WixRiseV1QueryUnredeemedWalletActionsRequestInput>;
};


export type MutationWixRiseV1QueryWalletActionsArgs = {
  input?: InputMaybe<WixRiseV1QueryWalletActionRequestInput>;
};


export type MutationWixRiseV1QueryWalletActionsBalancesArgs = {
  input?: InputMaybe<WixRiseV1QueryWalletActionBalancesRequestInput>;
};


export type MutationWixRiseV1QueryWalletsByContactArgs = {
  input?: InputMaybe<WixRiseV1QueryWalletsByContactRequestInput>;
};


export type MutationWixRiseV1RefundTransactionArgs = {
  input?: InputMaybe<WixRiseV1RefundTransactionRequestInput>;
};


export type MutationWixRiseV1SearchGiftCardsArgs = {
  input?: InputMaybe<WixRiseV1SearchGiftCardsRequestInput>;
};


export type MutationWixRiseV1UpdateCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1UpdateCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1UpdateGiftCardArgs = {
  input?: InputMaybe<WixRiseV1UpdateGiftCardRequestInput>;
};


export type MutationWixRiseV1UpdateLastActivityForRemindersArgs = {
  input?: InputMaybe<WixRiseV1UpdateLastActivityForRemindersRequestInput>;
};


export type MutationWixRiseV1UpdateWalletActionArgs = {
  input?: InputMaybe<WixRiseV1UpdateWalletActionRequestInput>;
};


export type MutationWixRiseV1VoidTransactionArgs = {
  input?: InputMaybe<WixRiseV1VoidTransactionRequestInput>;
};


export type MutationWixRiseWorkflowV1CreateWorkflowArgs = {
  input?: InputMaybe<WixRiseWorkflowV1CreateWorkflowRequestInput>;
};


export type MutationWixRiseWorkflowV1DeleteWorkflowArgs = {
  input?: InputMaybe<WixRiseWorkflowV1DeleteWorkflowRequestInput>;
};


export type MutationWixRiseWorkflowV1ListTriggersArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixRiseWorkflowV1ReportTriggerArgs = {
  input?: InputMaybe<WixRiseWorkflowV1ReportTriggerRequestInput>;
};


export type MutationWixRiseWorkflowV1UpdateWorkflowArgs = {
  input?: InputMaybe<WixRiseWorkflowV1UpdateWorkflowRequestInput>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of items returned in the response */
  count?: Maybe<Scalars['Int']>;
  /** An indication if we have next page */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Cursor to next */
  nextCursor?: Maybe<Scalars['String']>;
  /** Offset that was requested */
  offset?: Maybe<Scalars['Int']>;
  /** Cursor to prev */
  prevCursor?: Maybe<Scalars['String']>;
  /** Flag that indicates the server failed to calculate the `total` field */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set */
  total?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  /**
   * Retrieves a session by ID.
   *
   *
   * By default, a session object is returned with the fields specified in the `NO_PI` fieldset. This means it doesn't contain personal information.
   * To retrieve a full session object including all personal information, use the `ALL_PI` fieldset. This requires the CALENDAR.SESSION_READ_PI permission scope.
   * @deprecated Deprecated
   */
  comWixBookingsSchedulesApiV1GetSession?: Maybe<ComWixBookingsSchedulesApiV1Session>;
  /**
   * Retrieves a session by ID.
   *
   *
   * By default, a session object is returned with the fields specified in the `NO_PI` fieldset. This means it doesn't contain personal information.
   * To retrieve a full session object including all personal information, use the `ALL_PI` fieldset. This requires the CALENDAR.SESSION_READ_PI permission scope.
   */
  comWixBookingsSchedulesApiV1Session?: Maybe<ComWixBookingsSchedulesApiV1Session>;
  /**
   * Retrieves a list of sessions, given the provided time range, filtering, and paging.
   *
   *
   * <blockquote class='warning'>
   *
   * __Deprecation Notice:__
   *
   * This endpoint has been replaced with
   * Calendar V3 [Query Events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/query-events)
   * and External Calendar V2 [List Events](https://dev.wix.com/docs/rest/business-solutions/bookings/calendar/external-calendar-v2/list-events)
   * and will be removed on June 30, 2025.
   *
   * </blockquote>
   *
   * To query for event instances within a specified time range of up to 1 year, provide a `startDate` and `endDate`.
   *
   * Query Sessions runs with these defaults, which you can override:
   * - Only sessions of type `EVENT` are returned. An event is a single or recurring session that appears in a calendar, for example an appointment or a class.
   * - `instances` is true. This means only single session instances and instances of recurring sessions are returned.
   * - `includeExternal` is false. This means that sessions imported from connected external calendars are not returned.
   * - Session objects are returned with the fields specified in the `NO_PI` fieldset. This means they don't contain personal information.
   * - `query.cursorPaging.limit` is `100`.
   *
   * Note the following limitations, which you can't override:
   * - Sessions are always sorted by `start.timestamp` in `ASC` order.
   * - The maximum time range you can query for session instances is 1 year. If you are querying for recurring session definitions, rather than session instances, this limit doesn't apply.
   * - Pagination is not supported for recurring session definition queries.
   *
   * To query only for working hours sessions, set `type` to `WORKING_HOURS`. A working hours session is a single or recurring session that defines availability in a schedule.
   *
   * To query for all session types, including events and working hours sessions, set `type` to `ALL`.
   *
   * To query for recurring session pattern definitions, set `instances` to `false`. In this case, `fromDate` and `toDate` may be more than 1 year apart.
   *
   * To return session objects including personal information, use the `ALL_PI` fieldset. This requires the Read Bookings Calendar - Including Participants or the Manage Bookings Services and Settings or the Manage Business Calendar [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   *
   * For details on fieldsets, see [Sessions: Supported Fieldsets](https://dev.wix.com/api/rest/wix-bookings/calendar/supported-fieldsets).
   *
   * For field support for filters, see [Sessions: Supported Filters](https://dev.wix.com/api/rest/wix-bookings/calendar/supported-filters).
   *
   * To learn about working with _Query_ endpoints in general, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) and
   * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   * @deprecated Deprecated
   */
  comWixBookingsSchedulesApiV1Sessions?: Maybe<ComWixBookingsCalendarApiV2QuerySessionsResponse>;
  /** Retrieves a discount rule. */
  comWixEcomDiscountsDiscountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
  /**
   * Query discount rules using [WQL (Wix Query Language)](https://dev.wix.com/api/rest/getting-started/api-query-language).
   * Total entries (`pagingMetadata.total`) will be returned only for the first page.
   *
   * > **Note:** `discountRule.status` can't be used for querying.
   */
  comWixEcomDiscountsDiscountRules?: Maybe<ComWixEcomDiscountsQueryDiscountRulesResponse>;
  /** Retrieves a discount rule. */
  comWixEcomDiscountsGetDiscountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
  comWixEcomOrdersPaymentsV1GetOrderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /**
   * Retrieves a list of order transactions, given the provided paging, filtering, and sorting.
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), and
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  comWixEcomOrdersPaymentsV1OrderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1QueryOrderTransactionsResponse>;
  /**
   * Retrieves an order with the provided ID.
   *
   * To retrieve an order's payment and refund details, including amounts, payment methods, and payment statuses,
   * pass the order ID to [List Transactions For Single Order](https://dev.wix.com/docs/rest/business-solutions/e-commerce/order-transactions/list-transactions-for-single-order).
   */
  comWixEcomOrdersV1GetOrder?: Maybe<ComWixEcomOrdersV1Order>;
  /** Retrieves an order with the provided ID. */
  comWixEcomOrdersV1Order?: Maybe<ComWixEcomOrdersV1Order>;
  /**
   * > **Note:** Use SearchOrders instead
   * Retrieves a list of orders, given the provided paging, filtering, and sorting.
   *
   *
   * Query Orders runs with these defaults, which you can override:
   *
   * - `createdDate` is sorted in `DESC` order
   * - `paging.limit` is `100`
   * - `paging.offset` is `0`
   * - `filter: {"status": {"$ne": "INITIALIZED"}}` - other order statuses can be queried, but orders with `status: "INITIALIZED"` are never returned
   *
   * For field support for filters and sorting, see [Orders: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/supported-filters-and-sorting).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), and
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   * @deprecated Deprecated
   */
  comWixEcomOrdersV1Orders?: Maybe<ComWixEcomOrdersV1QueryOrderResponse>;
  /** Retrieves attendance information by ID. */
  comWixpressBookingsAttendanceV2Attendance?: Maybe<ComWixpressBookingsAttendanceV2Attendance>;
  /**
   * Retrieves up to 100 `attendance` objects, given the specified
   * paging, filtering, and sorting.
   *
   *
   * When querying attendance information, you can query from the perspective of:
   * + **A booking.** Specify a booking ID to retrieve attendance information
   * for all sessions related to that booking. For example, query by `bookingId`
   * for a course booking to retrieve a participant's attendance for all course
   * sessions.
   * + **A session.** Specify a session ID to retrieve attendance information
   * for all bookings related to that session.
   *
   * Query Attendance runs with the following defaults, which you can override:
   * - `id` sorted in `ASC` order.
   * - `cursorPaging.limit` set to `50`.
   *
   * For field support, see [supported filters](https://dev.wix.com/api/rest/wix-bookings/attendance/supported-filters).
   *
   * Only a single filter is supported per query. If you define multiple filters
   * in the same query, only the first is processed.
   *
   * To learn about working with query methods, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressBookingsAttendanceV2Attendances?: Maybe<ComWixpressBookingsAttendanceV2QueryAttendanceResponse>;
  /** Retrieves attendance information. */
  comWixpressBookingsAttendanceV2GetAttendance?: Maybe<ComWixpressBookingsAttendanceV2Attendance>;
  /** Retrieves an item from a collection. */
  comWixpressCloudDataApiDataDataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
  /**
   * Retrieves a list of items, on the basis of the filtering, sorting, and paging preferences you provide.
   *
   *
   * Learn more about [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressCloudDataApiDataDataItems?: Maybe<ComWixpressCloudDataApiDataQueryDataItemsResponse>;
  /** Retrieves an item from a collection. */
  comWixpressCloudDataApiDataGetDataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
  /**
   * Retrieves a list of contacts, given the provided [paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging#getting-started_sorting-and-paging_paging), [filtering, and sorting](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search).
   *
   * Up to 1,000 contacts can be returned per request.
   * Query Contacts runs with these defaults, which you can override:
   *
   * - `createdDate` is sorted in `ASC` order
   * - `paging.limit` is `50`
   * - `paging.offset` is `0`
   *
   *
   * For field support for filters and sorting, see
   * [Contacts: Supported Filters and Sorting](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search).
   *
   * To learn about working with _Query_ methods, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
   * and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
   */
  comWixpressContactsCoreApiV4Contacts?: Maybe<ComWixpressContactsCoreApiV4QueryContactsResponse>;
  /**
   * Retrieves a contact.
   *
   * #### Getting Merged Contacts
   *
   * When a source contact is merged
   * with a target contact, the source contact is deleted.
   * When calling Get Contact for a merged contact,
   * you can use the source or target contact ID.
   * In both bases, the target contact is returned.
   *
   * This is supported only when calling Get Contact on merged contacts.
   * Previously deleted source contact IDs can't be used for any other method.
   */
  comWixpressContactsCoreApiV4GetContact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** Retrieves an extended field. */
  comWixpressContactsFieldsV4ExtendedField?: Maybe<ComWixpressContactsFieldsV4ExtendedField>;
  /**
   * Retrieves a list of extended fields.
   *
   * For a detailed list of supported operations, see [sorting and filtering for extended fields](https://dev.wix.com/api/rest/contacts/extended-fields/sort-and-filter). To learn more about query language, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressContactsFieldsV4Fields?: Maybe<ComWixpressContactsFieldsV4QueryExtendedFieldsResponse>;
  /** Retrieves an extended field by the specified extended field key. */
  comWixpressContactsFieldsV4GetExtendedField?: Maybe<ComWixpressContactsFieldsV4ExtendedField>;
  /** Retrieves a label. */
  comWixpressContactsLabelsV4ContactLabel?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
  /** Retrieves a label by the specified label key. */
  comWixpressContactsLabelsV4GetContactLabel?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
  /**
   * Retrieves a list of contact labels. Up to 1,000 labels can be returned per request.
   *
   * For a detailed list of supported operations, see [sorting and filtering for labels](https://dev.wix.com/api/rest/contacts/labels/sort-and-filter). To learn how to query labels, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressContactsLabelsV4Labels?: Maybe<ComWixpressContactsLabelsV4QueryLabelsResponse>;
  /** Retrieves a location. */
  comWixpressLocationsGetLocation?: Maybe<ComWixpressLocationsLocation>;
  /** Retrieves a location. */
  comWixpressLocationsLocation?: Maybe<ComWixpressLocationsLocation>;
  /** Retrieves locations, given the specified filters, sorting, and paging. */
  comWixpressLocationsLocations?: Maybe<ComWixpressLocationsQueryLocationsResponse>;
  /**
   * Retrieves a member by ID.
   *
   * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
   */
  comWixpressMembersApiGetMember?: Maybe<ComWixpressMembersApiMember>;
  /**
   * Retrieves a member by ID.
   *
   * - `PUBLIC` fieldset returns `id`, `contactId`, and the `profile` object. `status`, `privacyStatus` and `activityStatus` are returned as `UNKNOWN`.
   * - `EXTENDED` fieldset returns `id`, `loginEmail`, `status`, `contactId`, `privacyStatus`, `activityStatus`, and the `profile` object.
   * - `FULL` fieldset returns all fields.
   */
  comWixpressMembersApiMember?: Maybe<ComWixpressMembersApiMember>;
  /**
   * Retrieves a list of up to 100 members, given the specified filters, fieldsets, sorting, and paging.
   *
   * For field support for filters and sorting, see [Members: Supported Filters and Sorting](https://dev.wix.com/docs/rest/crm/members-contacts/members/members/filter-and-sort).
   *
   * To learn about working with _Query_ methods, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
   * and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
   */
  comWixpressMembersApiMembers?: Maybe<ComWixpressMembersApiQueryMembersResponse>;
  /** Retrieves a pricing plan by ID. */
  comWixpressMembershipV2PlansGetPlan?: Maybe<ComWixpressMembershipV2PlansPlan>;
  /** Retrieves a pricing plan by ID. */
  comWixpressMembershipV2PlansPlan?: Maybe<ComWixpressMembershipV2PlansPlan>;
  /** Retrieves a list of up to 1,000 public pricing plans, given the provided pagination, [sorting, and filtering](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/filter-and-sort). */
  comWixpressMembershipV2PlansPlans?: Maybe<ComWixpressMembershipV2PlansQueryPublicPlansResponse>;
  /** Retrieves a tag with the provided ID. */
  comWixpressNpmCommunitiesPlatformizedBlogGetTag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
  /** Gets a tag with the provided ID. */
  comWixpressNpmCommunitiesPlatformizedBlogTag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
  /**
   * Retrieves a list of up to 500 tags, given the provided paging, filtering, and sorting.
   *
   * Query Posts runs with these defaults, which you can override:
   * - `postCount` is sorted in `DESC` order.
   * - `paging.limit` is `50`.
   * - `paging.offset` is `0`.
   *
   * For field support for filters and sorting, see
   * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/tags/filter-and-sort).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging), and
   * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   * For a detailed list of supported filters and sortable fields, see
   * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/posts-stats/filter-and-sort).
   */
  comWixpressNpmCommunitiesPlatformizedBlogTags?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryTagsResponse>;
  /**
   * Retrieves a list of up to 100 categories, given the provided paging, filtering, and sorting.
   * Query Categories runs with these defaults, which you can override.
   * - `displayPosition` is sorted in `DESC` order.
   * - `paging.limit` is `50`.
   * - `paging.offset` is `0`.
   *
   * For field support for filters and sorting, see
   * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/category/filter-and-sort).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging), and
   * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3Categories?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesResponse>;
  /** Gets a category with the provided ID. */
  comWixpressNpmCommunitiesPlatformizedBlogV3Category?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
  /** Gets a category with the specified ID. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetCategory?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
  /** Retrieves a post by the specified ID. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetPost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
  /** Gets a post by the specified ID. */
  comWixpressNpmCommunitiesPlatformizedBlogV3Post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
  /**
   * Retrieves a list of up to 100 posts, given the provided paging, filtering, and sorting.
   *
   * Query Posts runs with these defaults, which you can override:
   * - `firstPublishedDate` is sorted in descending order, with pinned posts first.
   * - `paging.limit` is `50`.
   * - `paging.offset` is `0`.
   *
   * For field support for filters and sorting, see
   * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/posts-stats/filter-and-sort).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging), and
   * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   * For a detailed list of supported filters and sortable fields, see
   * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/posts-stats/filter-and-sort).
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3Posts?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsResponse>;
  /** Get a Collection by id */
  comWixpressPortfolioCollectionsCollection?: Maybe<ComWixpressPortfolioCollectionsCollection>;
  /** Query Collections using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  comWixpressPortfolioCollectionsCollections?: Maybe<ComWixpressPortfolioCollectionsQueryCollectionsResponse>;
  /** Get a ProjectItem by id */
  comWixpressPortfolioProjectitemsItem?: Maybe<ComWixpressPortfolioProjectitemsItem>;
  /**
   * Query Collections using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * supported only by projectId & id
   * internal usage only - should not be used, created for auto-db-driver only
   */
  comWixpressPortfolioProjectitemsItems?: Maybe<ComWixpressPortfolioProjectitemsQueryProjectItemsResponse>;
  /** Get a Project by id */
  comWixpressPortfolioProjectsProject?: Maybe<ComWixpressPortfolioProjectsProject>;
  /** Query Projects using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  comWixpressPortfolioProjectsProjects?: Maybe<ComWixpressPortfolioProjectsQueryProjectsResponse>;
  /**
   * > **Note:** The Labels API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves an item label by ID.
   */
  comWixpressRestaurantsMenusItemLabelsV1GetLabel?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>;
  /** Get a Label by id */
  comWixpressRestaurantsMenusItemLabelsV1Label?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of item labels given the provided paging, filtering, and sorting. Up to 500 labels can be returned per request.
   *
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-label/supported-filters-and-sorting) article. To learn how to query menus, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  comWixpressRestaurantsMenusItemLabelsV1Labels?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1QueryLabelsResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves an item by ID.
   */
  comWixpressRestaurantsMenusItemV1GetItem?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
  /** Get an Item by id */
  comWixpressRestaurantsMenusItemV1Item?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of items given the provided paging, filtering, and sorting. Up to 500 items can be returned per request.
   *
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item/supported-filters-and-sorting) article. To learn how to query items, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  comWixpressRestaurantsMenusItemV1Items?: Maybe<ComWixpressRestaurantsMenusItemV1QueryItemsResponse>;
  /** Get menu details and path URL by menu ID. */
  comWixpressRestaurantsMenusMenuV1GetMenu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
  /** Get a Menu by id */
  comWixpressRestaurantsMenusMenuV1Menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
  /** Query menu details and path URL */
  comWixpressRestaurantsMenusMenuV1MenuSiteUrls?: Maybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlResponse>;
  /**
   * Retrieves a list of menus by a given query.
   *
   * To learn how to query menus, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   *
   * Up to 500 menus can be returned per request.
   */
  comWixpressRestaurantsMenusMenuV1Menus?: Maybe<ComWixpressRestaurantsMenusMenuV1QueryMenusResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a section by ID.
   */
  comWixpressRestaurantsMenusSectionV1GetSection?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
  /** Get a Section by id */
  comWixpressRestaurantsMenusSectionV1Section?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of sections given the provided paging, filtering, and sorting. Up to 500 sections can be returned per request.
   *
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](/sections/supported-filters-and-sorting) article. To learn how to query sections, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  comWixpressRestaurantsMenusSectionV1Sections?: Maybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse>;
  /** Retrieves a checkout. */
  ecomCheckoutV1Checkout?: Maybe<EcomCheckoutV1Checkout>;
  /** Retrieves a checkout. */
  ecomCheckoutV1GetCheckout?: Maybe<EcomCheckoutV1Checkout>;
  metroinspectorV1CollectionsCollection?: Maybe<MetroinspectorV1CollectionsCollection>;
  metroinspectorV1CollectionsCollections?: Maybe<MetroinspectorV1CollectionsQueryCollectionsResponse>;
  metroinspectorV1CollectionsGetCollection?: Maybe<MetroinspectorV1CollectionsCollection>;
  metroinspectorV1ProductsGetProduct?: Maybe<MetroinspectorV1ProductsProduct>;
  metroinspectorV1ProductsProduct?: Maybe<MetroinspectorV1ProductsProduct>;
  metroinspectorV1ProductsProducts?: Maybe<MetroinspectorV1ProductsQueryProductsResponse>;
  /** Retrieves a `serviceOptionsAndVariants` object by its ID. */
  wixBookingsCatalogV1GetServiceOptionsAndVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
  /** Retrieves a `serviceOptionsAndVariants` object by `service_options_and_variants_id`. */
  wixBookingsCatalogV1ServiceOptionsAndVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
  /**
   * Retrieves a list of `serviceOptionsAndVariants` objects, given the provided
   * paging, filtering, and sorting.
   *
   *
   * Query Service Options And Variants* runs with these defaults, which you can override:
   *
   * - `id` sorted in `ASC` order.
   * - `cursorPaging.limit` set to `100`.
   *
   * For a detailed list of supported filtering operations refer to the *supported filters article*
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/supported-filters)).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
   * and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
   */
  wixBookingsCatalogV1ServiceOptionsAndVariantsList?: Maybe<WixBookingsCatalogV1QueryServiceOptionsAndVariantsResponse>;
  /**
   * Retrieves a list of Categories, given the provided [paging, filtering, and sorting][1].
   *
   * Up to 1,000 Categories can be returned per request.
   *
   * To learn how to query Categories, see [API Query Language][2].
   *
   * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
   * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
   */
  wixBookingsCategoriesV2Categories?: Maybe<WixBookingsCategoriesV2QueryCategoriesResponse>;
  /** Retrieves a Category. */
  wixBookingsCategoriesV2GetCategory?: Maybe<WixBookingsCategoriesV2Category>;
  /** Retrieves a service. */
  wixBookingsServicesV2GetService?: Maybe<WixBookingsServicesV2Service>;
  /** Retrieves a service. */
  wixBookingsServicesV2Service?: Maybe<WixBookingsServicesV2Service>;
  /**
   * Retrieves a list of up to 100 services, given the provided paging,
   * filtering, and sorting.
   *
   *
   * ## Defaults
   *
   * Query Services has the following default settings, which you can override:
   * + Sorted by `createdDate` in ascending order.
   * + `paging.limit` set to `100`.
   * + `paging.offset` set to `0`.
   *
   * ## Filters
   *
   * When using filters for dates, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * Refer to the supported filters article
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting))
   * for a complete list of supported filters and sorting options.
   *
   * ## See also
   *
   * To learn about working with *Query* methods, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  wixBookingsServicesV2Services?: Maybe<WixBookingsServicesV2QueryServicesResponse>;
  /** Retrieves a StaffMember by id. */
  wixBookingsStaffV1GetStaffMember?: Maybe<WixBookingsStaffV1StaffMember>;
  /** Query StaffMembers using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  wixBookingsStaffV1StaffMembers?: Maybe<WixBookingsStaffV1QueryStaffMembersResponse>;
  /**
   * Retrieves a list of booking policies, given the provided paging, filtering, and sorting.
   *
   *
   * Query Booking Policies runs with these defaults, which you can override:
   *
   * - Sorted by `createdDate` in ascending order.
   * - `cursorPaging.limit` set to `100`.
   *
   * For details about all supported filters and sorting options, see
   * [supported filters](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/supported-filters).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination),
   * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   */
  wixBookingsV1BookingPolicies?: Maybe<WixBookingsV1QueryBookingPoliciesResponse>;
  /** Retrieves a booking policy. */
  wixBookingsV1GetBookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
  /** Retrieves an event by ID. */
  wixCalendarEventsV3Event?: Maybe<WixCalendarEventsV3Event>;
  /**
   * Retrieves a list of events, given the provided paging, filtering, and sorting.
   *
   *
   * Query Events runs with these defaults, which you can override:
   * - sorted by `start` in `ASC` order
   * - `cursorPaging.limit` is `50`
   *
   * You can't filter by event ID. To query by event ID, use
   * [Get Event](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/get-event)
   * or [List Events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/list-events).
   *
   * You can't filter by contact or member ID. To query by a participant's contact
   * or member ID, use
   * [List Events by Contact ID](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/list-events-by-contact-id)
   * or [List Events by Member ID](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/list-events-by-member-id).
   *
   * For field support for filters and sorting,
   * see [Calendar Events V3: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/supported-filters-and-sorting).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
   * and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
   */
  wixCalendarEventsV3Events?: Maybe<WixCalendarEventsV3QueryEventsResponse>;
  /** Retrieves an event. */
  wixCalendarEventsV3GetEvent?: Maybe<WixCalendarEventsV3Event>;
  /** Retrieves a schedule. */
  wixCalendarSchedulesV3GetSchedule?: Maybe<WixCalendarSchedulesV3Schedule>;
  /** Retrieves a schedule by ID. */
  wixCalendarSchedulesV3Schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
  /**
   * Retrieves a list of schedules, given the provided paging and filtering.
   *
   *
   *
   * By default only `ACTIVE` schedules are returned, unless you provide a different
   * `status` filter.
   *
   * Currently, you can't sort the response.
   *
   * Query schedules runs with these defaults, which you can override:
   * - `cursorPaging.limit` is `50`
   *
   * For field support for filters, see
   * [Schedules V3: Supported Filters](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/supported-filters).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  wixCalendarSchedulesV3Schedules?: Maybe<WixCalendarSchedulesV3QuerySchedulesResponse>;
  /** Retrieves a collection with the provided ID. */
  wixCatalogApiV1Collection?: Maybe<WixCatalogApiV1Collection>;
  /**
   * Retrieves a list of up to 100 collections, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1Collections?: Maybe<WixCatalogApiV2QueryCollectionsResponse>;
  /** Retrieves a product with the provided ID. */
  wixCatalogApiV1GetProduct?: Maybe<WixCatalogApiV1Product>;
  wixCatalogApiV1Product?: Maybe<WixCatalogApiV1Product>;
  /** Returns a list of up to 100 products, given the provided paging, sorting and filtering. */
  wixCatalogApiV1Products?: Maybe<WixCatalogApiV1QueryProductsPlatformizedResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Query Events](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/query-events) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Retrieves a list of up to 1,000 events, given the provided paging, filtering and sorting.
   *
   * ** Important **:
   * - All results are for one specific business, resolved from the request context.
   *
   * Query object support:
   * - `filter` - supported, see [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   * - `sort` - supported, see [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   * - `paging` - supported, see [paging](https://dev.wix.com/api/rest/getting-started/pagination).
   * - `fields` - not supported.
   * - `fieldsets` - not supported, use request-level `fieldset` instead.
   * - `cursorPaging` - not supported, use offset pagination instead.
   *
   * Defaults:
   * - When filter is not specified, returns all events that caller is authorized to read.
   * - When sorting is not specified, defaults to `created` in `DESC` order.
   * - When limit is not specified, defaults to 0.
   */
  wixEventsEvents?: Maybe<WixEventsQueryEventsV2Response>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Get Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/get-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Retrieves an event by ID or URL slug.
   */
  wixEventsGetEvent?: Maybe<WixEventsEvent>;
  /** Retrieves schedule item by ID. */
  wixEventsScheduleGetScheduleItem?: Maybe<WixEventsScheduleScheduleItem>;
  /**
   * Retrieves a list of up to 100 schedule items, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), filtering.
   *
   * * Important **:
   * - All results are for one specific business, resolved from the request context.
   *
   * Query object support:
   * - `filter` - supported, see filtering and sorting.
   * - `sort` - supported, see filtering and sorting.
   * - `paging` - supported, see [paging](https://dev.wix.com/api/rest/getting-started/pagination).
   * - `fields` - not supported.
   * - `fieldsets` - not supported.
   * - `cursorPaging` - not supported, use offset pagination instead.
   *
   * Defaults:
   * - When filter is not specified, returns all schedule items that caller is authorized to read.
   * - When sorting is not specified, defaults to `time_slot.start` and `time_slot.end` in `ASC` order.
   */
  wixEventsScheduleItems?: Maybe<WixEventsScheduleQueryScheduleItemsResponse>;
  wixEventsScheduleScheduleItem?: Maybe<WixEventsScheduleScheduleItem>;
  /** Retrieves a policy. */
  wixEventsV2GetPolicy?: Maybe<WixEventsV2Policy>;
  /** Retrieves a list of policies according to the provided filters and paging. */
  wixEventsV2Policies?: Maybe<WixEventsV2QueryPoliciesResponse>;
  /** Retrieves a policy. */
  wixEventsV2Policy?: Maybe<WixEventsV2Policy>;
  /** Gets a form by id. */
  wixFormsV4Form?: Maybe<WixFormsV4Form>;
  /** Query deleted Forms using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  wixFormsV4Forms?: Maybe<WixFormsV4QueryDeletedFormsResponse>;
  /** Gets a form by id. */
  wixFormsV4GetForm?: Maybe<WixFormsV4Form>;
  /**
   * Retrieves a gift card by ID.
   *
   * Use this method to get current gift card details including balance, status, and metadata.
   * The gift card code will be obfuscated in the response for security.
   */
  wixGiftCardsGiftCardV1GetGiftCard?: Maybe<WixGiftCardsGiftCardV1GiftCard>;
  wixGiftCardsGiftCardV1GetTransaction?: Maybe<WixGiftCardsGiftCardV1Transaction>;
  /**
   * Retrieves a list of gift cards with filtering, sorting, and paging options.
   *
   * Use this method to display gift card lists in admin interfaces, generate reports,
   * or implement gift card management dashboards. Supports advanced filtering by
   * creation date, balance, expiration status, and gift card codes.
   *
   * To learn how to query gift cards, see [API Query Language][2].
   *
   * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
   * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
   */
  wixGiftCardsGiftCardV1GiftCards?: Maybe<WixGiftCardsGiftCardV1QueryGiftCardsResponse>;
  /**
   * Retrieves the transaction history for a specific gift card with filtering, sorting, and paging options.
   *
   * Use this method to implement transaction history displays, generate audit reports,
   * or investigate gift card balance changes. Transactions are automatically created
   * for all gift card activities including redemptions, refunds, and manual adjustments.
   *
   * To learn how to query gift card transactions, see [API Query Language][2].
   *
   * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
   * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
   */
  wixGiftCardsGiftCardV1Transactions?: Maybe<WixGiftCardsGiftCardV1QueryGiftCardTransactionsResponse>;
  /** Retrieves an OAuth app by ID. */
  wixHeadlessV1GetOAuthApp?: Maybe<WixHeadlessV1OAuthApp>;
  /** Retrieves an OAuth app by ID. */
  wixHeadlessV1OAuthApp?: Maybe<WixHeadlessV1OAuthApp>;
  /**
   * Retrieves a list of OAuth apps, given the provided paging, filtering, and sorting.
   *
   *
   * Query OAuth Apps runs with these defaults, which you can override:
   * + Results are sorted by `id` in descending order.
   * + `paging.offset` is `0`.
   *
   * For field support for filters and sorting, see [OAuth Apps: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/headless-authentication/oauth-apps/filters-sorting)
   *
   * To learn about working with _Query_ endpoints in general, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  wixHeadlessV1OAuthApps?: Maybe<WixHeadlessV1QueryOAuthAppsResponse>;
  /** Returns participant. */
  wixOnlineprogramsParticipantsV3GetParticipant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** Query existing participants */
  wixOnlineprogramsParticipantsV3Participants?: Maybe<WixOnlineprogramsParticipantsV3QueryParticipantsResponse>;
  /** Retrieves a Program. */
  wixOnlineprogramsProgramsV3GetProgram?: Maybe<WixOnlineprogramsProgramsV3Program>;
  /** Retrieves a list of Programs */
  wixOnlineprogramsProgramsV3Programs?: Maybe<WixOnlineprogramsProgramsV3QueryProgramsResponse>;
  /** Retrieves a Step. */
  wixOnlineprogramsStepsV3GetStep?: Maybe<WixOnlineprogramsStepsV3Step>;
  /** Query steps. */
  wixOnlineprogramsStepsV3Steps?: Maybe<WixOnlineprogramsStepsV3QueryStepsResponse>;
  /** Retrieves a PaymentAgreement. */
  wixPaymentsPaymentAgreementsV1GetPaymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreement>;
  /**
   * Retrieves a list of PaymentAgreements, given the provided [paging, filtering, and sorting][1].
   *
   * Up to 1,000 PaymentAgreements can be returned per request.
   *
   * To learn how to query PaymentAgreements, see [API Query Language][2].
   *
   * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
   * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
   */
  wixPaymentsPaymentAgreementsV1PaymentAgreements?: Maybe<WixPaymentsPaymentAgreementsV1QueryPaymentAgreementsResponse>;
  /** Retrieves a refund. */
  wixPaymentsRefundsV1GetRefund?: Maybe<WixPaymentsRefundsV1Refund>;
  /**
   * Retrieves a list of refunds given the provided paging, filtering, and sorting. Up to 100 Refunds can be returned per request.
   *
   * For a detailed list of supported operations, see the [Sorting and Filtering](https://dev.wix.com/docs/rest/business-management/payments/refunds/sorting-and-filtering) article.
   * To learn how to query refunds, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  wixPaymentsRefundsV1Refunds?: Maybe<WixPaymentsRefundsV1QueryRefundsResponse>;
  /** Returns SavedPaymentMethod by ID. */
  wixPaymentsSavedPaymentMethodsV1GetSavedPaymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod>;
  /**
   * Retrieves a payment method type, with some fields localized according to the caller's language and country.
   *
   * The callers language and country are taken from the `languageCode` or `countryCode` parameters in the request.
   * If these parameters are not specified, the values are taken from context of the call if possible. For example, if this method is called from a Wix site, the selected language on that site will be used.
   * If language or country can't be determined, the method doesn't perform any filtering or localization.
   *
   * Language and country are used to determine localized values for the `displayName`, `description` fields.
   * Country is used to determine localized values for the `priority` and `promoted` fields in `merchantFlow` and `buyerFlow`.
   * `currencyCode` is used to determine the eligibility of payment method types for the provided currency.
   */
  wixPaymentsSitePaymentMethodTypesV1GetSitePaymentMethodType?: Maybe<WixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType>;
  /** Retrieves a receipt. */
  wixReceiptsV1GetReceipt?: Maybe<WixReceiptsV1Receipt>;
  /** Retrieves a list of up to 100 receipts, given the specified filtering, paging, and sorting ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/api/rest/getting-started/api-query-language)). */
  wixReceiptsV1Receipts?: Maybe<WixReceiptsV1QueryReceiptsResponse>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves an item modifier by ID.
   */
  wixRestaurantsMenusItemModifierV1GetModifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
  /** Get a Modifier by id */
  wixRestaurantsMenusItemModifierV1Modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of item modifiers given the provided paging, filtering, and sorting. Up to 500 item modifiers can be returned per request.
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifiers/supported-filters-and-sorting) article. To learn how to query menus, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  wixRestaurantsMenusItemModifierV1Modifiers?: Maybe<WixRestaurantsMenusItemModifierV1QueryModifiersResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves an item variant by ID.
   */
  wixRestaurantsMenusItemVariantV1GetVariant?: Maybe<WixRestaurantsMenusItemVariantV1Variant>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of item variants given the provided paging, filtering, and sorting. Up to 500 item variants can be returned per request.
   *
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-variant/supported-filters-and-sorting) article. To learn how to query item variants, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   */
  wixRestaurantsMenusItemVariantV1Variants?: Maybe<WixRestaurantsMenusItemVariantV1QueryVariantsResponse>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a modifier group by the ID.
   */
  wixRestaurantsMenusV1GetModifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
  /** Query ModifierGroups */
  wixRestaurantsMenusV1Items?: Maybe<WixRestaurantsMenusV1QueryModifierGroupsResponse>;
  /** Get a ModifierGroup by id */
  wixRestaurantsMenusV1ModifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of modifier groups given the provided paging, filtering, and sorting. Up to 500 modifier groups can be returned per request.
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifier-groups/supported-filters-and-sorting) article. To learn how to query modifier groups, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  wixRestaurantsMenusV1ModifierGroups?: Maybe<WixRestaurantsMenusV1QueryModifierGroupsResponse>;
  /** Get a GiftCard by ID. */
  wixRiseV1GetGiftCard?: Maybe<WixRiseV1GiftCard>;
  wixRiseV1GetTransaction?: Maybe<WixRiseV1Transaction>;
  wixRiseV1GetWallet?: Maybe<WixRiseV1Wallet>;
  /** Retrieve a WalletAction by ID. */
  wixRiseV1GetWalletAction?: Maybe<WixRiseV1WalletAction>;
  /** Query GiftCards using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language). */
  wixRiseV1GiftCards?: Maybe<WixRiseV1QueryGiftCardsResponse>;
  /** Query Transactions using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language). */
  wixRiseV1Transactions?: Maybe<WixRiseV1QueryTransactionsResponse>;
  /** Query WalletActions using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language). */
  wixRiseV1WalletActions?: Maybe<WixRiseV1QueryWalletActionResponse>;
  /** Query wallets enriched with gift card and contact information. See [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language). */
  wixRiseV1Wallets?: Maybe<WixRiseV1QueryWalletsResponse>;
  /** Retrieves a Workflow. */
  wixRiseWorkflowV1GetWorkflow?: Maybe<WixRiseWorkflowV1Workflow>;
  /** Retrieves a list of Workflows, given the provided [paging, filtering, and sorting][1]. */
  wixRiseWorkflowV1Workflows?: Maybe<WixRiseWorkflowV1QueryWorkflowsResponse>;
};


export type QueryComWixBookingsSchedulesApiV1GetSessionArgs = {
  queryInput?: InputMaybe<ComWixBookingsSchedulesApiV1GetSessionRequestInput>;
};


export type QueryComWixBookingsSchedulesApiV1SessionArgs = {
  id: Scalars['ID'];
};


export type QueryComWixBookingsSchedulesApiV1SessionsArgs = {
  queryInput?: InputMaybe<ComWixBookingsCalendarApiV2QuerySessionsRequestInput>;
};


export type QueryComWixEcomDiscountsDiscountRuleArgs = {
  id: Scalars['ID'];
};


export type QueryComWixEcomDiscountsDiscountRulesArgs = {
  queryInput?: InputMaybe<ComWixEcomDiscountsQueryDiscountRulesRequestInput>;
};


export type QueryComWixEcomDiscountsGetDiscountRuleArgs = {
  queryInput?: InputMaybe<ComWixEcomDiscountsGetDiscountRuleRequestInput>;
};


export type QueryComWixEcomOrdersPaymentsV1GetOrderTransactionsArgs = {
  queryInput?: InputMaybe<ComWixEcomOrdersPaymentsV1GetOrderTransactionsRequestInput>;
};


export type QueryComWixEcomOrdersPaymentsV1OrderTransactionsArgs = {
  queryInput?: InputMaybe<ComWixEcomOrdersPaymentsV1QueryOrderTransactionsRequestInput>;
};


export type QueryComWixEcomOrdersV1GetOrderArgs = {
  queryInput?: InputMaybe<ComWixEcomOrdersV1GetOrderRequestInput>;
};


export type QueryComWixEcomOrdersV1OrderArgs = {
  id: Scalars['ID'];
};


export type QueryComWixEcomOrdersV1OrdersArgs = {
  queryInput?: InputMaybe<ComWixEcomOrdersV1QueryOrderRequestInput>;
};


export type QueryComWixpressBookingsAttendanceV2AttendanceArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressBookingsAttendanceV2AttendancesArgs = {
  queryInput?: InputMaybe<ComWixpressBookingsAttendanceV2QueryAttendanceRequestInput>;
};


export type QueryComWixpressBookingsAttendanceV2GetAttendanceArgs = {
  queryInput?: InputMaybe<ComWixpressBookingsAttendanceV2GetAttendanceRequestInput>;
};


export type QueryComWixpressCloudDataApiDataDataItemArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressCloudDataApiDataDataItemsArgs = {
  queryInput?: InputMaybe<ComWixpressCloudDataApiDataQueryDataItemsRequestInput>;
};


export type QueryComWixpressCloudDataApiDataGetDataItemArgs = {
  queryInput?: InputMaybe<ComWixpressCloudDataApiDataGetDataItemRequestInput>;
};


export type QueryComWixpressContactsCoreApiV4ContactsArgs = {
  queryInput?: InputMaybe<ComWixpressContactsCoreApiV4QueryContactsRequestInput>;
};


export type QueryComWixpressContactsCoreApiV4GetContactArgs = {
  queryInput?: InputMaybe<ComWixpressContactsCoreApiV4GetContactRequestInput>;
};


export type QueryComWixpressContactsFieldsV4ExtendedFieldArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressContactsFieldsV4FieldsArgs = {
  queryInput?: InputMaybe<ComWixpressContactsFieldsV4QueryExtendedFieldsRequestInput>;
};


export type QueryComWixpressContactsFieldsV4GetExtendedFieldArgs = {
  queryInput?: InputMaybe<ComWixpressContactsFieldsV4GetExtendedFieldRequestInput>;
};


export type QueryComWixpressContactsLabelsV4ContactLabelArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressContactsLabelsV4GetContactLabelArgs = {
  queryInput?: InputMaybe<ComWixpressContactsLabelsV4GetContactLabelRequestInput>;
};


export type QueryComWixpressContactsLabelsV4LabelsArgs = {
  queryInput?: InputMaybe<ComWixpressContactsLabelsV4QueryLabelsRequestInput>;
};


export type QueryComWixpressLocationsGetLocationArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsGetLocationRequestInput>;
};


export type QueryComWixpressLocationsLocationArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressLocationsLocationsArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsQueryLocationsRequestInput>;
};


export type QueryComWixpressMembersApiGetMemberArgs = {
  queryInput?: InputMaybe<ComWixpressMembersApiGetMemberRequestInput>;
};


export type QueryComWixpressMembersApiMemberArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressMembersApiMembersArgs = {
  queryInput?: InputMaybe<ComWixpressMembersApiQueryMembersRequestInput>;
};


export type QueryComWixpressMembershipV2PlansGetPlanArgs = {
  queryInput?: InputMaybe<ComWixpressMembershipV2PlansGetPlanRequestInput>;
};


export type QueryComWixpressMembershipV2PlansPlanArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressMembershipV2PlansPlansArgs = {
  queryInput?: InputMaybe<ComWixpressMembershipV2PlansQueryPublicPlansRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogGetTagArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogTagArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogTagsArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryTagsRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3CategoriesArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3CategoryArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3GetPostArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3PostArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3PostsArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsRequestInput>;
};


export type QueryComWixpressPortfolioCollectionsCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressPortfolioCollectionsCollectionsArgs = {
  query?: InputMaybe<WixCommonQueryV2Input>;
};


export type QueryComWixpressPortfolioProjectitemsItemArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressPortfolioProjectitemsItemsArgs = {
  query?: InputMaybe<WixCommonQueryV2Input>;
};


export type QueryComWixpressPortfolioProjectsProjectArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressPortfolioProjectsProjectsArgs = {
  query?: InputMaybe<WixCommonQueryV2Input>;
};


export type QueryComWixpressRestaurantsMenusItemLabelsV1GetLabelArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1GetLabelRequestInput>;
};


export type QueryComWixpressRestaurantsMenusItemLabelsV1LabelArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressRestaurantsMenusItemLabelsV1LabelsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1QueryLabelsRequestInput>;
};


export type QueryComWixpressRestaurantsMenusItemV1GetItemArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemV1GetItemRequestInput>;
};


export type QueryComWixpressRestaurantsMenusItemV1ItemArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressRestaurantsMenusItemV1ItemsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemV1QueryItemsRequestInput>;
};


export type QueryComWixpressRestaurantsMenusMenuV1GetMenuArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusMenuV1GetMenuRequestInput>;
};


export type QueryComWixpressRestaurantsMenusMenuV1MenuArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressRestaurantsMenusMenuV1MenuSiteUrlsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlRequestInput>;
};


export type QueryComWixpressRestaurantsMenusMenuV1MenusArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusMenuV1QueryMenusRequestInput>;
};


export type QueryComWixpressRestaurantsMenusSectionV1GetSectionArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1GetSectionRequestInput>;
};


export type QueryComWixpressRestaurantsMenusSectionV1SectionArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressRestaurantsMenusSectionV1SectionsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput>;
};


export type QueryEcomCheckoutV1CheckoutArgs = {
  id: Scalars['ID'];
};


export type QueryEcomCheckoutV1GetCheckoutArgs = {
  queryInput?: InputMaybe<EcomCheckoutV1GetCheckoutRequestInput>;
};


export type QueryMetroinspectorV1CollectionsCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryMetroinspectorV1CollectionsCollectionsArgs = {
  queryInput?: InputMaybe<MetroinspectorV1CollectionsQueryCollectionsRequestInput>;
};


export type QueryMetroinspectorV1CollectionsGetCollectionArgs = {
  queryInput?: InputMaybe<MetroinspectorV1CollectionsGetCollectionRequestInput>;
};


export type QueryMetroinspectorV1ProductsGetProductArgs = {
  queryInput?: InputMaybe<MetroinspectorV1ProductsGetProductRequestInput>;
};


export type QueryMetroinspectorV1ProductsProductArgs = {
  id: Scalars['ID'];
};


export type QueryMetroinspectorV1ProductsProductsArgs = {
  queryInput?: InputMaybe<MetroinspectorV1ProductsQueryProductsRequestInput>;
};


export type QueryWixBookingsCatalogV1GetServiceOptionsAndVariantsArgs = {
  queryInput?: InputMaybe<WixBookingsCatalogV1GetServiceOptionsAndVariantsRequestInput>;
};


export type QueryWixBookingsCatalogV1ServiceOptionsAndVariantsArgs = {
  id: Scalars['ID'];
};


export type QueryWixBookingsCatalogV1ServiceOptionsAndVariantsListArgs = {
  queryInput?: InputMaybe<WixBookingsCatalogV1QueryServiceOptionsAndVariantsRequestInput>;
};


export type QueryWixBookingsCategoriesV2CategoriesArgs = {
  queryInput?: InputMaybe<WixBookingsCategoriesV2QueryCategoriesRequestInput>;
};


export type QueryWixBookingsCategoriesV2GetCategoryArgs = {
  queryInput?: InputMaybe<WixBookingsCategoriesV2GetCategoryRequestInput>;
};


export type QueryWixBookingsServicesV2GetServiceArgs = {
  queryInput?: InputMaybe<WixBookingsServicesV2GetServiceRequestInput>;
};


export type QueryWixBookingsServicesV2ServiceArgs = {
  id: Scalars['ID'];
};


export type QueryWixBookingsServicesV2ServicesArgs = {
  queryInput?: InputMaybe<WixBookingsServicesV2QueryServicesRequestInput>;
};


export type QueryWixBookingsStaffV1GetStaffMemberArgs = {
  queryInput?: InputMaybe<WixBookingsStaffV1GetStaffMemberRequestInput>;
};


export type QueryWixBookingsStaffV1StaffMembersArgs = {
  queryInput?: InputMaybe<WixBookingsStaffV1QueryStaffMembersRequestInput>;
};


export type QueryWixBookingsV1BookingPoliciesArgs = {
  queryInput?: InputMaybe<WixBookingsV1QueryBookingPoliciesRequestInput>;
};


export type QueryWixBookingsV1GetBookingPolicyArgs = {
  queryInput?: InputMaybe<WixBookingsV1GetBookingPolicyRequestInput>;
};


export type QueryWixCalendarEventsV3EventArgs = {
  id: Scalars['ID'];
};


export type QueryWixCalendarEventsV3EventsArgs = {
  queryInput?: InputMaybe<WixCalendarEventsV3QueryEventsRequestInput>;
};


export type QueryWixCalendarEventsV3GetEventArgs = {
  queryInput?: InputMaybe<WixCalendarEventsV3GetEventRequestInput>;
};


export type QueryWixCalendarSchedulesV3GetScheduleArgs = {
  queryInput?: InputMaybe<WixCalendarSchedulesV3GetScheduleRequestInput>;
};


export type QueryWixCalendarSchedulesV3ScheduleArgs = {
  id: Scalars['ID'];
};


export type QueryWixCalendarSchedulesV3SchedulesArgs = {
  queryInput?: InputMaybe<WixCalendarSchedulesV3QuerySchedulesRequestInput>;
};


export type QueryWixCatalogApiV1CollectionArgs = {
  id: Scalars['ID'];
};


export type QueryWixCatalogApiV1CollectionsArgs = {
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};


export type QueryWixCatalogApiV1GetProductArgs = {
  queryInput?: InputMaybe<WixCatalogApiV1GetProductRequestInput>;
};


export type QueryWixCatalogApiV1ProductArgs = {
  id: Scalars['ID'];
};


export type QueryWixCatalogApiV1ProductsArgs = {
  queryInput?: InputMaybe<WixCatalogApiV1QueryProductsPlatformizedRequestInput>;
};


export type QueryWixEventsEventsArgs = {
  queryInput?: InputMaybe<WixEventsQueryEventsV2RequestInput>;
};


export type QueryWixEventsGetEventArgs = {
  queryInput?: InputMaybe<WixEventsGetEventRequestInput>;
};


export type QueryWixEventsScheduleGetScheduleItemArgs = {
  queryInput?: InputMaybe<WixEventsScheduleGetScheduleItemRequestInput>;
};


export type QueryWixEventsScheduleItemsArgs = {
  queryInput?: InputMaybe<WixEventsScheduleQueryScheduleItemsRequestInput>;
};


export type QueryWixEventsScheduleScheduleItemArgs = {
  id: Scalars['ID'];
};


export type QueryWixEventsV2GetPolicyArgs = {
  queryInput?: InputMaybe<WixEventsV2GetPolicyRequestInput>;
};


export type QueryWixEventsV2PoliciesArgs = {
  queryInput?: InputMaybe<WixEventsV2QueryPoliciesRequestInput>;
};


export type QueryWixEventsV2PolicyArgs = {
  id: Scalars['ID'];
};


export type QueryWixFormsV4FormArgs = {
  id: Scalars['ID'];
};


export type QueryWixFormsV4FormsArgs = {
  queryInput?: InputMaybe<WixFormsV4QueryDeletedFormsRequestInput>;
};


export type QueryWixFormsV4GetFormArgs = {
  queryInput?: InputMaybe<WixFormsV4GetFormRequestInput>;
};


export type QueryWixGiftCardsGiftCardV1GetGiftCardArgs = {
  queryInput?: InputMaybe<WixGiftCardsGiftCardV1GetGiftCardRequestInput>;
};


export type QueryWixGiftCardsGiftCardV1GetTransactionArgs = {
  queryInput?: InputMaybe<WixGiftCardsGiftCardV1GetTransactionRequestInput>;
};


export type QueryWixGiftCardsGiftCardV1GiftCardsArgs = {
  queryInput?: InputMaybe<WixGiftCardsGiftCardV1QueryGiftCardsRequestInput>;
};


export type QueryWixGiftCardsGiftCardV1TransactionsArgs = {
  queryInput?: InputMaybe<WixGiftCardsGiftCardV1QueryGiftCardTransactionsRequestInput>;
};


export type QueryWixHeadlessV1GetOAuthAppArgs = {
  queryInput?: InputMaybe<WixHeadlessV1GetOAuthAppRequestInput>;
};


export type QueryWixHeadlessV1OAuthAppArgs = {
  id: Scalars['ID'];
};


export type QueryWixHeadlessV1OAuthAppsArgs = {
  queryInput?: InputMaybe<WixHeadlessV1QueryOAuthAppsRequestInput>;
};


export type QueryWixOnlineprogramsParticipantsV3GetParticipantArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsParticipantsV3GetParticipantRequestInput>;
};


export type QueryWixOnlineprogramsParticipantsV3ParticipantsArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsParticipantsV3QueryParticipantsRequestInput>;
};


export type QueryWixOnlineprogramsProgramsV3GetProgramArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsProgramsV3GetProgramRequestInput>;
};


export type QueryWixOnlineprogramsProgramsV3ProgramsArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsProgramsV3QueryProgramsRequestInput>;
};


export type QueryWixOnlineprogramsStepsV3GetStepArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsStepsV3GetStepRequestInput>;
};


export type QueryWixOnlineprogramsStepsV3StepsArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsStepsV3QueryStepsRequestInput>;
};


export type QueryWixPaymentsPaymentAgreementsV1GetPaymentAgreementArgs = {
  queryInput?: InputMaybe<WixPaymentsPaymentAgreementsV1GetPaymentAgreementRequestInput>;
};


export type QueryWixPaymentsPaymentAgreementsV1PaymentAgreementsArgs = {
  queryInput?: InputMaybe<WixPaymentsPaymentAgreementsV1QueryPaymentAgreementsRequestInput>;
};


export type QueryWixPaymentsRefundsV1GetRefundArgs = {
  queryInput?: InputMaybe<WixPaymentsRefundsV1GetRefundRequestInput>;
};


export type QueryWixPaymentsRefundsV1RefundsArgs = {
  queryInput?: InputMaybe<WixPaymentsRefundsV1QueryRefundsRequestInput>;
};


export type QueryWixPaymentsSavedPaymentMethodsV1GetSavedPaymentMethodArgs = {
  queryInput?: InputMaybe<WixPaymentsSavedPaymentMethodsV1GetSavedPaymentMethodRequestInput>;
};


export type QueryWixPaymentsSitePaymentMethodTypesV1GetSitePaymentMethodTypeArgs = {
  queryInput?: InputMaybe<WixPaymentsSitePaymentMethodTypesV1GetSitePaymentMethodTypeRequestInput>;
};


export type QueryWixReceiptsV1GetReceiptArgs = {
  queryInput?: InputMaybe<WixReceiptsV1GetReceiptRequestInput>;
};


export type QueryWixReceiptsV1ReceiptsArgs = {
  queryInput?: InputMaybe<WixReceiptsV1QueryReceiptsRequestInput>;
};


export type QueryWixRestaurantsMenusItemModifierV1GetModifierArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemModifierV1GetModifierRequestInput>;
};


export type QueryWixRestaurantsMenusItemModifierV1ModifierArgs = {
  id: Scalars['ID'];
};


export type QueryWixRestaurantsMenusItemModifierV1ModifiersArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemModifierV1QueryModifiersRequestInput>;
};


export type QueryWixRestaurantsMenusItemVariantV1GetVariantArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemVariantV1GetVariantRequestInput>;
};


export type QueryWixRestaurantsMenusItemVariantV1VariantsArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemVariantV1QueryVariantsRequestInput>;
};


export type QueryWixRestaurantsMenusV1GetModifierGroupArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusV1GetModifierGroupRequestInput>;
};


export type QueryWixRestaurantsMenusV1ItemsArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusV1QueryModifierGroupsRequestInput>;
};


export type QueryWixRestaurantsMenusV1ModifierGroupArgs = {
  id: Scalars['ID'];
};


export type QueryWixRestaurantsMenusV1ModifierGroupsArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusV1QueryModifierGroupsRequestInput>;
};


export type QueryWixRiseV1GetGiftCardArgs = {
  queryInput?: InputMaybe<WixRiseV1GetGiftCardRequestInput>;
};


export type QueryWixRiseV1GetTransactionArgs = {
  queryInput?: InputMaybe<WixRiseV1GetTransactionRequestInput>;
};


export type QueryWixRiseV1GetWalletArgs = {
  queryInput?: InputMaybe<WixRiseV1GetWalletRequestInput>;
};


export type QueryWixRiseV1GetWalletActionArgs = {
  queryInput?: InputMaybe<WixRiseV1GetWalletActionRequestInput>;
};


export type QueryWixRiseV1GiftCardsArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryGiftCardsRequestInput>;
};


export type QueryWixRiseV1TransactionsArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryTransactionsRequestInput>;
};


export type QueryWixRiseV1WalletActionsArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryWalletActionRequestInput>;
};


export type QueryWixRiseV1WalletsArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryWalletsRequestInput>;
};


export type QueryWixRiseWorkflowV1GetWorkflowArgs = {
  queryInput?: InputMaybe<WixRiseWorkflowV1GetWorkflowRequestInput>;
};


export type QueryWixRiseWorkflowV1WorkflowsArgs = {
  queryInput?: InputMaybe<WixRiseWorkflowV1QueryWorkflowsRequestInput>;
};

/** SpectaQL directive options */
export type SpectaQlOption = {
  /** key to use, for example "undocumented" */
  key: Scalars['String'];
  /** key value to set, for example "true" */
  value: Scalars['String'];
};

export type UpstreamWixCommonPortfolioCommonImage = {
  __typename?: 'UpstreamWixCommonPortfolioCommonImage';
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. Required. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. Required. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. Required. */
  width?: Maybe<Scalars['Int']>;
};

export type UpstreamWixCommonPortfolioCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. Required. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. Required. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. Required. */
  width?: InputMaybe<Scalars['Int']>;
};

export type UpstreamWixCommonPortfolioCommonVideoResolution = {
  __typename?: 'UpstreamWixCommonPortfolioCommonVideoResolution';
  /** Video filename. */
  filename?: Maybe<Scalars['String']>;
  /** Video format for example, mp4, hls.  Required. */
  format?: Maybe<Scalars['String']>;
  /** Video height. Required. */
  height?: Maybe<Scalars['Int']>;
  /** Video poster. Deprecated, please use the `posters` property in the parent entity */
  poster?: Maybe<UpstreamWixCommonPortfolioCommonImage>;
  /** Video quality for example 480p, 720p. */
  quality?: Maybe<Scalars['String']>;
  /** Video URL.  Required. */
  url?: Maybe<Scalars['String']>;
  /** Video width.  Required. */
  width?: Maybe<Scalars['Int']>;
};

export type UpstreamWixCommonPortfolioCommonVideoResolutionInput = {
  /** Video filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Video format for example, mp4, hls.  Required. */
  format?: InputMaybe<Scalars['String']>;
  /** Video height. Required. */
  height?: InputMaybe<Scalars['Int']>;
  /** Video poster. Deprecated, please use the `posters` property in the parent entity */
  poster?: InputMaybe<UpstreamWixCommonPortfolioCommonImageInput>;
  /** Video quality for example 480p, 720p. */
  quality?: InputMaybe<Scalars['String']>;
  /** Video URL.  Required. */
  url?: InputMaybe<Scalars['String']>;
  /** Video width.  Required. */
  width?: InputMaybe<Scalars['Int']>;
};

export type UpstreamWixCommonPortfolioCommonVideoV2 = {
  __typename?: 'UpstreamWixCommonPortfolioCommonVideoV2';
  /** Video filename. */
  filename?: Maybe<Scalars['String']>;
  /** WixMedia ID. Required. */
  id?: Maybe<Scalars['String']>;
  /** Video posters. */
  posters?: Maybe<Array<Maybe<UpstreamWixCommonPortfolioCommonImage>>>;
  /** Available resolutions for the video, starting with the optimal resolution. */
  resolutions?: Maybe<Array<Maybe<UpstreamWixCommonPortfolioCommonVideoResolution>>>;
  /** Original video size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Video URL. */
  url?: Maybe<Scalars['String']>;
  /** Video URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
};

export type UpstreamWixCommonPortfolioCommonVideoV2Input = {
  /** Video filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** WixMedia ID. Required. */
  id?: InputMaybe<Scalars['String']>;
  /** Video posters. */
  posters?: InputMaybe<Array<InputMaybe<UpstreamWixCommonPortfolioCommonImageInput>>>;
  /** Available resolutions for the video, starting with the optimal resolution. */
  resolutions?: InputMaybe<Array<InputMaybe<UpstreamWixCommonPortfolioCommonVideoResolutionInput>>>;
  /** Original video size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Video URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Video URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
};

export type WixApiApplicationError = {
  __typename?: 'WixApiApplicationError';
  /** Error code. */
  code?: Maybe<Scalars['String']>;
  /** Data related to the error. */
  data?: Maybe<Scalars['JSON']>;
  /** Description of the error. */
  description?: Maybe<Scalars['String']>;
};

export type WixApiApplicationErrorInput = {
  /** Error code. */
  code?: InputMaybe<Scalars['String']>;
  /** Data related to the error. */
  data?: InputMaybe<Scalars['JSON']>;
  /** Description of the error. */
  description?: InputMaybe<Scalars['String']>;
};

export type WixApiDetails = {
  __typename?: 'WixApiDetails';
  applicationError?: Maybe<WixApiApplicationError>;
  systemError?: Maybe<WixApiSystemError>;
  /** deprecated in API's - to enable migration from rendering arbitrary tracing to rest response */
  tracing?: Maybe<Scalars['JSON']>;
  validationError?: Maybe<WixApiValidationError>;
};

export type WixApiDetailsInput = {
  applicationError?: InputMaybe<WixApiApplicationErrorInput>;
  systemError?: InputMaybe<WixApiSystemErrorInput>;
  /** deprecated in API's - to enable migration from rendering arbitrary tracing to rest response */
  tracing?: InputMaybe<Scalars['JSON']>;
  validationError?: InputMaybe<WixApiValidationErrorInput>;
};

export type WixApiLoomTimecapsuleReschedule = {
  __typename?: 'WixApiLoomTimecapsuleReschedule';
  executeAt?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
};

export type WixApiLoomTimecapsuleTaskAction = {
  __typename?: 'WixApiLoomTimecapsuleTaskAction';
  cancel?: Maybe<Scalars['Void']>;
  complete?: Maybe<Scalars['Void']>;
  reschedule?: Maybe<WixApiLoomTimecapsuleReschedule>;
};

export type WixApiLoomTimecapsuleTaskInput = {
  executeAt?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<WixApiLoomTimecapsuleTaskKeyInput>;
  payload?: InputMaybe<Scalars['String']>;
};

export type WixApiLoomTimecapsuleTaskKeyInput = {
  appId?: InputMaybe<Scalars['String']>;
  instanceId?: InputMaybe<Scalars['String']>;
  subjectId?: InputMaybe<Scalars['String']>;
};

export type WixApiSystemError = {
  __typename?: 'WixApiSystemError';
  /** Error code. */
  errorCode?: Maybe<Scalars['String']>;
};

export type WixApiSystemErrorInput = {
  /** Error code. */
  errorCode?: InputMaybe<Scalars['String']>;
};

export type WixApiValidationError = {
  __typename?: 'WixApiValidationError';
  fieldViolations?: Maybe<Array<Maybe<WixApiValidationErrorFieldViolation>>>;
};

export type WixApiValidationErrorFieldViolation = {
  __typename?: 'WixApiValidationErrorFieldViolation';
  data?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  /** applicable when violated_rule=OTHER */
  ruleName?: Maybe<Scalars['String']>;
  violatedRule?: Maybe<WixApiValidationErrorRuleType>;
};

export type WixApiValidationErrorFieldViolationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['String']>;
  /** applicable when violated_rule=OTHER */
  ruleName?: InputMaybe<Scalars['String']>;
  violatedRule?: InputMaybe<WixApiValidationErrorRuleType>;
};

export type WixApiValidationErrorInput = {
  fieldViolations?: InputMaybe<Array<InputMaybe<WixApiValidationErrorFieldViolationInput>>>;
};

export enum WixApiValidationErrorRuleType {
  DecimalGt = 'DECIMAL_GT',
  DecimalGte = 'DECIMAL_GTE',
  DecimalLt = 'DECIMAL_LT',
  DecimalLte = 'DECIMAL_LTE',
  DecimalMaxScale = 'DECIMAL_MAX_SCALE',
  ExactLength = 'EXACT_LENGTH',
  ExactSize = 'EXACT_SIZE',
  FieldNotAllowed = 'FIELD_NOT_ALLOWED',
  Format = 'FORMAT',
  InvalidEnumValue = 'INVALID_ENUM_VALUE',
  Max = 'MAX',
  MaxLength = 'MAX_LENGTH',
  MaxSize = 'MAX_SIZE',
  Min = 'MIN',
  MinLength = 'MIN_LENGTH',
  MinSize = 'MIN_SIZE',
  OneOfAlignment = 'ONE_OF_ALIGNMENT',
  Other = 'OTHER',
  RequiredField = 'REQUIRED_FIELD',
  RequiredOneOfField = 'REQUIRED_ONE_OF_FIELD',
  Validation = 'VALIDATION'
}

export type WixBlogKafkaProducerV1SendActionEventRequestInput = {
  entityId?: InputMaybe<Scalars['String']>;
  postCountersUpdated?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedInput>;
  postLikedAction?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostLikedInput>;
};

export type WixBookingsCalendarUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of sessions to return.
   * Defaults to `50`. Maximum `1000`.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCalendarUpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `query.filter`. */
  cursorPaging?: InputMaybe<WixBookingsCalendarUpstreamWixCommonCursorPagingInput>;
  /**
   * Supported values: `ALL_PI`.
   *
   * Predefined sets of fields to return.
   *
   * - `ALL_PI`: Returns complete session objects.
   *
   * If you don't pass a value in the `fieldsets` array, session objects without
   * personal information are returned by default. This means without `participants`,
   * `location`, `calendarConference`, and `externalCalendarOverrides`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * for more information.
   *
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`.
   *
   * For a detailed list of supported filters, see
   * [Supported Filters](https://dev.wix.com/api/rest/wix-bookings/calendar-v2/filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsCalendarV2CacheInfo = {
  __typename?: 'WixBookingsCalendarV2CacheInfo';
  cachedDate?: Maybe<Scalars['String']>;
  feedReplayId?: Maybe<Scalars['String']>;
  fromDate?: Maybe<Scalars['String']>;
  sessionCount?: Maybe<Scalars['Int']>;
  status?: Maybe<WixBookingsCalendarV2CacheInfoStatus>;
  toDate?: Maybe<Scalars['String']>;
};

export enum WixBookingsCalendarV2CacheInfoStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  InProgress = 'IN_PROGRESS',
  Undefined = 'UNDEFINED'
}

export type WixBookingsCalendarV2CacheRequestInput = {
  fromDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCalendarV2CacheResponse = {
  __typename?: 'WixBookingsCalendarV2CacheResponse';
  cacheInfo?: Maybe<WixBookingsCalendarV2CacheInfo>;
};

export type WixBookingsCalendarV2GetCacheInfoRequestInput = {
  includeSessionCount?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsCalendarV2GetCacheInfoResponse = {
  __typename?: 'WixBookingsCalendarV2GetCacheInfoResponse';
  cacheInfo?: Maybe<WixBookingsCalendarV2CacheInfo>;
};

export type WixBookingsCalendarV2ListSessionsRequestInput = {
  /**
   * Predefined sets of fields to return.
   * - `NO_PI`: Returns session objects without personal information.
   * - `ALL_PI`: Returns complete session objects, including personal information. Requires the CALENDAR.SESSION_READ_PI permission scope.
   *
   * Default: `NO_PI`
   */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** IDs of the sessions to retrieve. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsCalendarV2ListSessionsResponse = {
  __typename?: 'WixBookingsCalendarV2ListSessionsResponse';
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Retrieved sessions. */
  sessions?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Session>>>;
};

export type WixBookingsCalendarV2QueryEventSessionInstancesRequestInput = {
  /**
   * Start of the time range for which sessions are returned
   * in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)).
   * Required, if `query.cursorPaging` is omitted.
   * `end.timestamp` of all returned sessions is greater than or equal to `fromDate`.
   */
  fromDate?: InputMaybe<Scalars['String']>;
  /** Information about filters, paging, and returned fields. */
  query?: InputMaybe<WixBookingsCalendarUpstreamWixCommonQueryV2Input>;
  /**
   * End of the time range for which sessions are returned
   * in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)).
   * Required, if `query.cursorPaging` is omitted.
   * `start.timestamp` of all returned sessions is less than or equal to `toDate`.
   */
  toDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCalendarV2QueryEventSessionInstancesResponse = {
  __typename?: 'WixBookingsCalendarV2QueryEventSessionInstancesResponse';
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Retrieved sessions. */
  sessions?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Session>>>;
};

export type WixBookingsCalendarV2ShortenCacheRequestInput = {
  /**
   * The new cache from date to set.
   * Must be after than the current from date.
   */
  fromDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCalendarV2ShortenCacheResponse = {
  __typename?: 'WixBookingsCalendarV2ShortenCacheResponse';
  /** The updated cache. */
  cacheInfo?: Maybe<WixBookingsCalendarV2CacheInfo>;
};

export type WixBookingsCalendarfeedV2FeedEventInput = {
  /** Session has been added or updated within the feed window. */
  sessionAddedOrUpdated?: InputMaybe<WixBookingsCalendarfeedV2SessionAddedOrUpdatedInput>;
  /** Session has been removed from the feed. */
  sessionRemoved?: InputMaybe<WixBookingsCalendarfeedV2SessionRemovedInput>;
  /** The feed window has been extended. */
  windowExtended?: InputMaybe<WixBookingsCalendarfeedV2WindowExtendedInput>;
  /** Deprecated. Please use `window_extended` instead. */
  windowMoved?: InputMaybe<WixBookingsCalendarfeedV2WindowMovedInput>;
};

export type WixBookingsCalendarfeedV2FeedReplayEventInput = {
  /** Sessions replay completed. */
  replayCompleted?: InputMaybe<WixBookingsCalendarfeedV2ReplayCompletedInput>;
  replayId?: InputMaybe<Scalars['String']>;
  /** Session has been added within the feed window. */
  sessionAdded?: InputMaybe<WixBookingsCalendarfeedV2SessionAddedInput>;
};

export type WixBookingsCalendarfeedV2ReplayCompletedInput = {
  /** The (minimum) number of sessions that were replayed. */
  totalSessions?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCalendarfeedV2SessionAddedInput = {
  /** The session which was added within the feed window. */
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** Deprecated. Please use `session.version.number` instead. */
  sessionVersion?: InputMaybe<Scalars['Long']>;
};

export type WixBookingsCalendarfeedV2SessionAddedOrUpdatedInput = {
  /** Deprecated. Please use `previous_session.affected_schedules[*].schedule_id` instead. */
  previousAffectedScheduleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optionally, the previous session. */
  previousSession?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** The session which was added or updated within the view. */
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** Deprecated. Please use `session.version.number` instead. */
  sessionVersion?: InputMaybe<Scalars['Long']>;
};

export type WixBookingsCalendarfeedV2SessionRemovedInput = {
  /** Deprecated. Please use `session.affectedSchedules[*].scheduleId` instead. */
  affectedScheduleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optionally, the previous session. */
  previousSession?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** Deprecated. Please use `session.schedule_id` instead. */
  scheduleId?: InputMaybe<Scalars['String']>;
  /** The updated session which was removed from the view. */
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** Deprecated. Please use `session.id` instead. */
  sessionId?: InputMaybe<Scalars['String']>;
  /** Deprecated. Please use `session_version.number` instead. */
  sessionVersion?: InputMaybe<Scalars['Long']>;
};

export type WixBookingsCalendarfeedV2WindowExtendedInput = {
  /** The updated window end date. */
  windowEndDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCalendarfeedV2WindowMovedInput = {
  /** The updated window edge. */
  edge?: InputMaybe<Scalars['String']>;
  /** The window version. */
  windowVersion?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCatalogV1CloneServiceOptionsAndVariantsRequestInput = {
  /** ID of the `serviceOptionsAndVariants` object to clone. */
  cloneFromId?: InputMaybe<Scalars['String']>;
  /**
   * ID of the service to which the cloned `serviceOptionsAndVariants` are
   * connected.
   */
  targetServiceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1CloneServiceOptionsAndVariantsResponse = {
  __typename?: 'WixBookingsCatalogV1CloneServiceOptionsAndVariantsResponse';
  /** Cloned `serviceOptionsAndVariants` object. */
  serviceOptionsAndVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
};

export type WixBookingsCatalogV1CreateServiceOptionsAndVariantsRequestInput = {
  /** Service options and variants to create. */
  serviceOptionsAndVariants?: InputMaybe<WixBookingsCatalogV1ServiceOptionsAndVariantsInput>;
};

export type WixBookingsCatalogV1CreateServiceOptionsAndVariantsResponse = {
  __typename?: 'WixBookingsCatalogV1CreateServiceOptionsAndVariantsResponse';
  /** Information about the created service options and variants. */
  serviceOptionsAndVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
};

export type WixBookingsCatalogV1CustomServiceOption = {
  __typename?: 'WixBookingsCatalogV1CustomServiceOption';
  /**
   * Available choices for the service option. For example, `child`, `student`,
   * `adult`, and `senior` for a service option named `Age group`. Each value must
   * be unique. The value's case is ignored, meaning `Child` and `child` are
   * considered to be identical. Currently, only a single choice is supported
   * because a service can have only a single option.
   *
   * Max: 1 choice
   */
  choices?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Name of the service option. For example, `Age group`, `Location`, `Equipment`,
   * or `Time`.
   */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsCatalogV1CustomServiceOptionInput = {
  /**
   * Available choices for the service option. For example, `child`, `student`,
   * `adult`, and `senior` for a service option named `Age group`. Each value must
   * be unique. The value's case is ignored, meaning `Child` and `child` are
   * considered to be identical. Currently, only a single choice is supported
   * because a service can have only a single option.
   *
   * Max: 1 choice
   */
  choices?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Name of the service option. For example, `Age group`, `Location`, `Equipment`,
   * or `Time`.
   */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1DeleteServiceOptionsAndVariantsRequestInput = {
  /** Revision of the `serviceOptionsAndVariants` object to delete. */
  revision?: InputMaybe<Scalars['Long']>;
  /** ID of the `serviceOptionsAndVariants` object to delete. */
  serviceOptionsAndVariantsId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1Duration = {
  __typename?: 'WixBookingsCatalogV1Duration';
  /**
   * Duration of the service in minutes.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  minutes?: Maybe<Scalars['Int']>;
  /**
   * Name of the duration option.
   *
   * Default: Human-readable text of `minutes`. For example, `1 hr 30 min`.
   */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsCatalogV1DurationInput = {
  /**
   * Duration of the service in minutes.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  minutes?: InputMaybe<Scalars['Int']>;
  /**
   * Name of the duration option.
   *
   * Default: Human-readable text of `minutes`. For example, `1 hr 30 min`.
   */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1DurationServiceOption = {
  __typename?: 'WixBookingsCatalogV1DurationServiceOption';
  /**
   * Optional name of the duration option. For example, `Short Class`, or
   * `Extended Class`.
   */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsCatalogV1DurationServiceOptionInput = {
  /**
   * Optional name of the duration option. For example, `Short Class`, or
   * `Extended Class`.
   */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdRequestInput = {
  /** ID of the service to retrieve options and variants for. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdResponse = {
  __typename?: 'WixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdResponse';
  /** Retrieved `serviceOptionsAndVariants` object. */
  serviceVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
};

export type WixBookingsCatalogV1GetServiceOptionsAndVariantsRequestInput = {
  id: Scalars['ID'];
};

export type WixBookingsCatalogV1QueryServiceOptionsAndVariantsRequestInput = {
  /** Information about filters, paging, and returned fields. */
  query?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonQueryV2Input>;
};

export type WixBookingsCatalogV1QueryServiceOptionsAndVariantsResponse = {
  __typename?: 'WixBookingsCatalogV1QueryServiceOptionsAndVariantsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixBookingsCatalogV1ServiceChoice = {
  __typename?: 'WixBookingsCatalogV1ServiceChoice';
  /** Name of the custom choice. */
  custom?: Maybe<Scalars['String']>;
  /** Information about the option's duration. */
  duration?: Maybe<WixBookingsCatalogV1Duration>;
  /**
   * ID of the service choice.
   * Used by multilingual translations.
   */
  id?: Maybe<Scalars['String']>;
  /** ID of the service option. */
  optionId?: Maybe<Scalars['String']>;
  /**
   * ID of the *staff member*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction))
   * providing the service.
   */
  staffMemberId?: Maybe<Scalars['String']>;
};

export type WixBookingsCatalogV1ServiceChoiceInput = {
  /** Name of the custom choice. */
  custom?: InputMaybe<Scalars['String']>;
  /** Information about the option's duration. */
  duration?: InputMaybe<WixBookingsCatalogV1DurationInput>;
  /**
   * ID of the service choice.
   * Used by multilingual translations.
   */
  id?: InputMaybe<Scalars['String']>;
  /** ID of the service option. */
  optionId?: InputMaybe<Scalars['String']>;
  /**
   * ID of the *staff member*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction))
   * providing the service.
   */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1ServiceOption = {
  __typename?: 'WixBookingsCatalogV1ServiceOption';
  /** Details about the custom option. Available only for `CUSTOM` options. */
  customData?: Maybe<WixBookingsCatalogV1CustomServiceOption>;
  durationData?: Maybe<WixBookingsCatalogV1DurationServiceOption>;
  /** ID of the service option. */
  id?: Maybe<Scalars['String']>;
  /** Type of the service option. */
  type?: Maybe<WixBookingsCatalogV1ServiceOptionTypeEnumServiceOptionType>;
};

export type WixBookingsCatalogV1ServiceOptionInput = {
  /** Details about the custom option. Available only for `CUSTOM` options. */
  customData?: InputMaybe<WixBookingsCatalogV1CustomServiceOptionInput>;
  durationData?: InputMaybe<WixBookingsCatalogV1DurationServiceOptionInput>;
  /** ID of the service option. */
  id?: InputMaybe<Scalars['String']>;
  /** Type of the service option. */
  type?: InputMaybe<WixBookingsCatalogV1ServiceOptionTypeEnumServiceOptionType>;
};

export enum WixBookingsCatalogV1ServiceOptionTypeEnumServiceOptionType {
  /**
   * The service option is based on a custom parameter. For example, age group,
   * booked equipment, or appointment timing.
   */
  Custom = 'CUSTOM',
  /** It's a duration-based option. */
  Duration = 'DURATION',
  /**
   * It's a *staff member*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction))
   * based option.
   */
  StaffMember = 'STAFF_MEMBER',
  /** There is no information about the option type. */
  Unknown = 'UNKNOWN'
}

export type WixBookingsCatalogV1ServiceOptionsAndVariants = {
  __typename?: 'WixBookingsCatalogV1ServiceOptionsAndVariants';
  /** Extensions enabling users to save custom data related to service options and variants. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** ID of the `serviceOptionsAndVariants` object. */
  id?: Maybe<Scalars['String']>;
  /** Price of the most expensive service variant. */
  maxPrice?: Maybe<WixBookingsCatalogV1UpstreamWixCommonMoney>;
  /** Price of the cheapest service variant. */
  minPrice?: Maybe<WixBookingsCatalogV1UpstreamWixCommonMoney>;
  /** Service options. Note that currently only a single option is supported per service. */
  options?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptions>;
  /**
   * Revision number, which increments by 1 each time the `serviceOptionsAndVariants` object is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating and deleting the `serviceOptionsAndVariants` object.
   *
   * Ignored when creating a `serviceOptionsAndVariants` object.
   */
  revision?: Maybe<Scalars['Long']>;
  /** ID of the service related to these options and variants. */
  serviceId?: Maybe<Scalars['String']>;
  /** Information about the service's variants. */
  variants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariants>;
};

export type WixBookingsCatalogV1ServiceOptionsAndVariantsInput = {
  /** Extensions enabling users to save custom data related to service options and variants. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** ID of the `serviceOptionsAndVariants` object. */
  id?: InputMaybe<Scalars['String']>;
  /** Price of the most expensive service variant. */
  maxPrice?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonMoneyInput>;
  /** Price of the cheapest service variant. */
  minPrice?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonMoneyInput>;
  /** Service options. Note that currently only a single option is supported per service. */
  options?: InputMaybe<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptionsInput>;
  /**
   * Revision number, which increments by 1 each time the `serviceOptionsAndVariants` object is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating and deleting the `serviceOptionsAndVariants` object.
   *
   * Ignored when creating a `serviceOptionsAndVariants` object.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** ID of the service related to these options and variants. */
  serviceId?: InputMaybe<Scalars['String']>;
  /** Information about the service's variants. */
  variants?: InputMaybe<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariantsInput>;
};

export type WixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptions = {
  __typename?: 'WixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptions';
  /**
   * Values of the service options.
   *
   * Max: 1 service option
   */
  values?: Maybe<Array<Maybe<WixBookingsCatalogV1ServiceOption>>>;
};

export type WixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptionsInput = {
  /**
   * Values of the service options.
   *
   * Max: 1 service option
   */
  values?: InputMaybe<Array<InputMaybe<WixBookingsCatalogV1ServiceOptionInput>>>;
};

export type WixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariants = {
  __typename?: 'WixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariants';
  /** Values of the service variants. */
  values?: Maybe<Array<Maybe<WixBookingsCatalogV1ServiceVariant>>>;
};

export type WixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariantsInput = {
  /** Values of the service variants. */
  values?: InputMaybe<Array<InputMaybe<WixBookingsCatalogV1ServiceVariantInput>>>;
};

export type WixBookingsCatalogV1ServiceVariant = {
  __typename?: 'WixBookingsCatalogV1ServiceVariant';
  /**
   * Choices for the service option. Currently, only a single choice is supported
   * because a service can have only a single option.
   *
   * Max: 1 choice
   */
  choices?: Maybe<Array<Maybe<WixBookingsCatalogV1ServiceChoice>>>;
  /**
   * ID of the service variant.
   * Used by multilingual translations.
   */
  id?: Maybe<Scalars['String']>;
  /** Information about the service variant's price. */
  price?: Maybe<WixBookingsCatalogV1UpstreamWixCommonMoney>;
};

export type WixBookingsCatalogV1ServiceVariantInput = {
  /**
   * Choices for the service option. Currently, only a single choice is supported
   * because a service can have only a single option.
   *
   * Max: 1 choice
   */
  choices?: InputMaybe<Array<InputMaybe<WixBookingsCatalogV1ServiceChoiceInput>>>;
  /**
   * ID of the service variant.
   * Used by multilingual translations.
   */
  id?: InputMaybe<Scalars['String']>;
  /** Information about the service variant's price. */
  price?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonMoneyInput>;
};

export type WixBookingsCatalogV1UpdateServiceOptionsAndVariantsRequestInput = {
  /** Field mask containing information about the fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** `ServiceOptionsAndVariants` object to update. */
  serviceOptionsAndVariants?: InputMaybe<WixBookingsCatalogV1ServiceOptionsAndVariantsInput>;
};

export type WixBookingsCatalogV1UpdateServiceOptionsAndVariantsResponse = {
  __typename?: 'WixBookingsCatalogV1UpdateServiceOptionsAndVariantsResponse';
  /** Updated `serviceOptionsAndVariants` object. */
  serviceOptionsAndVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
};

export type WixBookingsCatalogV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCatalogV1UpstreamWixCommonMoney = {
  __typename?: 'WixBookingsCatalogV1UpstreamWixCommonMoney';
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format (e.g., 1 000,30). Optionally, a single (-), to indicate that the amount is negative. */
  formattedValue?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, a single (-), to indicate that the amount is negative. */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsCatalogV1UpstreamWixCommonMoneyInput = {
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format (e.g., 1 000,30). Optionally, a single (-), to indicate that the amount is negative. */
  formattedValue?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, a single (-), to indicate that the amount is negative. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1UpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCatalogV1UpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Learn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonPagingInput>;
  /**
   * Sort object.
   *
   * Learn more about the [sort section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-sort-section).
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsCatalogV1UpstreamWixCommonSortingInput>>>;
};

export enum WixBookingsCatalogV1UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixBookingsCatalogV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type WixBookingsCategoriesV2Category = {
  __typename?: 'WixBookingsCategoriesV2Category';
  /** Date and time the Category was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Category ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Category name
   * Max: 100 characters
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the Category is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the Category.
   *
   * Ignored when creating a Category.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * Sort order of the category.
   * The sort order determines the relative position of a category in the categories list.
   * There could be gaps in the sort order of 2 adjacent categories.
   */
  sortOrder?: Maybe<Scalars['Int']>;
  /** Date and time the Category was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixBookingsCategoriesV2CategoryInput = {
  /** Date and time the Category was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Category ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Category name
   * Max: 100 characters
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the Category is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the Category.
   *
   * Ignored when creating a Category.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Sort order of the category.
   * The sort order determines the relative position of a category in the categories list.
   * There could be gaps in the sort order of 2 adjacent categories.
   */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Date and time the Category was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCategoriesV2CountCategoriesRequestInput = {
  /** Filter to apply on categories to count */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsCategoriesV2CountCategoriesResponse = {
  __typename?: 'WixBookingsCategoriesV2CountCategoriesResponse';
  /** The number of categories matching the given filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixBookingsCategoriesV2CreateCategoryRequestInput = {
  /** Category to be created. */
  category?: InputMaybe<WixBookingsCategoriesV2CategoryInput>;
};

export type WixBookingsCategoriesV2CreateCategoryResponse = {
  __typename?: 'WixBookingsCategoriesV2CreateCategoryResponse';
  /** The created Category. */
  category?: Maybe<WixBookingsCategoriesV2Category>;
};

export type WixBookingsCategoriesV2DeleteCategoryRequestInput = {
  /** Id of the Category to delete. */
  categoryId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCategoriesV2GetCategoryRequestInput = {
  id: Scalars['ID'];
};

export type WixBookingsCategoriesV2ImportCategoriesRequestInput = {
  /** List of Categories to import */
  categories?: InputMaybe<Array<InputMaybe<WixBookingsCategoriesV2CategoryInput>>>;
};

export type WixBookingsCategoriesV2MoveCategoryRequestInput = {
  /**
   * If `position` is set to `AFTER_CATEGORY`, `after_category_id` must be provided, otherwise it must be empty
   * If `after_category_id` is provided with a position other than `AFTER_CATEGORY`, a validation error is returned
   */
  afterCategoryId?: InputMaybe<Scalars['String']>;
  /** Id of the category to move */
  categoryId?: InputMaybe<Scalars['String']>;
  /** The new position to move the category to */
  position?: InputMaybe<WixBookingsCategoriesV2MoveCategoryRequestPosition>;
};

export enum WixBookingsCategoriesV2MoveCategoryRequestPosition {
  /** After another category */
  AfterCategory = 'AFTER_CATEGORY',
  /** First position in the list */
  First = 'FIRST',
  /** Last position in the list */
  Last = 'LAST',
  UnknownPosition = 'UNKNOWN_POSITION'
}

export type WixBookingsCategoriesV2MoveCategoryResponse = {
  __typename?: 'WixBookingsCategoriesV2MoveCategoryResponse';
  /** The category that was moved */
  category?: Maybe<WixBookingsCategoriesV2Category>;
};

export type WixBookingsCategoriesV2QueryCategoriesRequestInput = {
  /** WQL expression. */
  query?: InputMaybe<WixBookingsCategoriesV2UpstreamWixCommonCursorQueryInput>;
};

export type WixBookingsCategoriesV2QueryCategoriesResponse = {
  __typename?: 'WixBookingsCategoriesV2QueryCategoriesResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixBookingsCategoriesV2Category>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixBookingsCategoriesV2UpdateCategoryRequestInput = {
  /** Category to be updated, may be partial. */
  category?: InputMaybe<WixBookingsCategoriesV2CategoryInput>;
  /**
   * Set of fields to update.
   *
   * Fields that aren't included in `fieldMask.paths` are ignored.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsCategoriesV2UpdateCategoryResponse = {
  __typename?: 'WixBookingsCategoriesV2UpdateCategoryResponse';
  /** Updated Category. */
  category?: Maybe<WixBookingsCategoriesV2Category>;
};

export type WixBookingsCategoriesV2UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCategoriesV2UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsCategoriesV2UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsCategoriesV2UpstreamWixCommonSortingInput>>>;
};

export enum WixBookingsCategoriesV2UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixBookingsCategoriesV2UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixBookingsCategoriesV2UpstreamWixCommonSortOrder>;
};

export type WixBookingsServicesV2AddOnDetails = {
  __typename?: 'WixBookingsServicesV2AddOnDetails';
  /** ID of the AddOn. */
  addOnId?: Maybe<Scalars['String']>;
  /**
   * The duration of the AddOn in minutes.
   * This field can be empty if the AddOn has no specific duration.
   */
  durationInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2AddOnDetailsInput = {
  /** ID of the AddOn. */
  addOnId?: InputMaybe<Scalars['String']>;
  /**
   * The duration of the AddOn in minutes.
   * This field can be empty if the AddOn has no specific duration.
   */
  durationInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2AddOnGroup = {
  __typename?: 'WixBookingsServicesV2AddOnGroup';
  /** List of AddOn IDs that are part of this group. */
  addOnIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** ID of the group. */
  id?: Maybe<Scalars['String']>;
  /**
   * The maximum number of AddOns that can be selected from this group.
   * If not set, there is no upper limit.
   */
  maxNumberOfAddOns?: Maybe<Scalars['Int']>;
  /** The name of the group. */
  name?: Maybe<Scalars['String']>;
  /** The group prompt. */
  prompt?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2AddOnGroupInput = {
  /** List of AddOn IDs that are part of this group. */
  addOnIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the group. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * The maximum number of AddOns that can be selected from this group.
   * If not set, there is no upper limit.
   */
  maxNumberOfAddOns?: InputMaybe<Scalars['Int']>;
  /** The name of the group. */
  name?: InputMaybe<Scalars['String']>;
  /** The group prompt. */
  prompt?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2AddOnsGroup = {
  __typename?: 'WixBookingsServicesV2AddOnsGroup';
  /** List of AddOn IDs that are part of this group. */
  addOnIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** ID of the group. */
  id?: Maybe<Scalars['String']>;
  /**
   * The maximum number of AddOns that can be selected from this group.
   * If not set, there is no upper limit.
   */
  maxNumberOfAddOns?: Maybe<Scalars['Int']>;
  /** The name of the group. */
  name?: Maybe<Scalars['String']>;
  /** The group prompt. */
  prompt?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2AddOnsGroupInput = {
  /** List of AddOn IDs that are part of this group. */
  addOnIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the group. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * The maximum number of AddOns that can be selected from this group.
   * If not set, there is no upper limit.
   */
  maxNumberOfAddOns?: InputMaybe<Scalars['Int']>;
  /** The name of the group. */
  name?: InputMaybe<Scalars['String']>;
  /** The group prompt. */
  prompt?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2AvailabilityConstraints = {
  __typename?: 'WixBookingsServicesV2AvailabilityConstraints';
  /**
   * Calculated list of all supported session durations for the service. For
   * appointment-based services without varied pricing based on session length, it
   * matches the single value in the `sessionDurations` array. For appointment-based
   * services with varied pricing based on session length, it includes session
   * durations for all *variants*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction)),
   * while ignoring `sessionDurations`.
   * For courses and classes, it includes durations for all future
   * recurring sessions but excludes durations for one-off or past recurring sessions.
   */
  durations?: Maybe<Array<Maybe<WixBookingsServicesV2Duration>>>;
  /**
   * List of supported session durations in minutes. Specify `sessionDurations` only
   * for appointment-based services. Do not specify it for classes or courses. Note that
   * session durations for appointment-based services with varied pricing based on
   * session length are retrieved from service *variants*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction)),
   * while this array is ignored.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  sessionDurations?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /**
   * The number of minutes between the end of a session and the start of the next.
   *
   *
   * Min: `0` minutes
   * Max: `720` minutes
   */
  timeBetweenSessions?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2AvailabilityConstraintsInput = {
  /**
   * Calculated list of all supported session durations for the service. For
   * appointment-based services without varied pricing based on session length, it
   * matches the single value in the `sessionDurations` array. For appointment-based
   * services with varied pricing based on session length, it includes session
   * durations for all *variants*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction)),
   * while ignoring `sessionDurations`.
   * For courses and classes, it includes durations for all future
   * recurring sessions but excludes durations for one-off or past recurring sessions.
   */
  durations?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2DurationInput>>>;
  /**
   * List of supported session durations in minutes. Specify `sessionDurations` only
   * for appointment-based services. Do not specify it for classes or courses. Note that
   * session durations for appointment-based services with varied pricing based on
   * session length are retrieved from service *variants*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction)),
   * while this array is ignored.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  sessionDurations?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /**
   * The number of minutes between the end of a session and the start of the next.
   *
   *
   * Min: `0` minutes
   * Max: `720` minutes
   */
  timeBetweenSessions?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2BookingForm = {
  __typename?: 'WixBookingsServicesV2BookingForm';
  /**
   * Up to 5 services connected to the booking form. If `totalServiceCount` is
   * greater than 5, there are additional services connected to the policy.
   * You can call *Search Services*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/search-services) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/search-services))
   * specifying the relevant policy ID in the filter, to retrieve all services that are
   * connected to a booking policy.
   */
  connectedServices?: Maybe<Array<Maybe<WixBookingsServicesV2BookingFormConnectedService>>>;
  /** Information about the retrieved booking form. */
  formDetails?: Maybe<WixBookingsServicesV2BookingFormFormDetails>;
  /** Total number of services connected to the booking form. */
  totalServiceCount?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2BookingFormConnectedService = {
  __typename?: 'WixBookingsServicesV2BookingFormConnectedService';
  /** ID of the service connected to the booking form. */
  id?: Maybe<Scalars['String']>;
  /** Name of the service connected to the booking form. */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2BookingFormFormDetails = {
  __typename?: 'WixBookingsServicesV2BookingFormFormDetails';
  /** Form ID. */
  formId?: Maybe<Scalars['String']>;
  /** Form name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the form is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the form.
   */
  revision?: Maybe<Scalars['Long']>;
};

export type WixBookingsServicesV2BookingPolicyWithServices = {
  __typename?: 'WixBookingsServicesV2BookingPolicyWithServices';
  /** Retrieved booking policy. */
  bookingPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy>;
  /**
   * Up to 5 services connected to the booking policy. If `totalServiceCount` is
   * greater than 5, there are additional services connected to the policy.
   * You can call *Search Services*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/search-services) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/search-services))
   * specifying the relevant policy ID in the filter, to retrieve all services that are
   * connected to a booking policy.
   */
  connectedServices?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
  /**
   * The number of services connected to the booking policy.
   * @deprecated The number of services connected to the booking policy. Replaced by: total_service_count. Removal date: 2025-03-01.
   */
  countOfServices?: Maybe<Scalars['Int']>;
  /**
   * Whether there are more services associated with the booking policy.
   * @deprecated Whether there are more services associated with the booking policy. Removal date: 2025-03-01.
   */
  hasMoreServices?: Maybe<Scalars['Boolean']>;
  /**
   * The services connected to the booking policy. Up to 5 services are returned per policy.
   * @deprecated The services connected to the booking policy. Up to 5 services are returned per policy. Replaced by: connected_services. Removal date: 2025-03-01.
   */
  services?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
  /** Total number of services connected to the booking policy. */
  totalServiceCount?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2BulkCreateServicesRequestInput = {
  /** Whether to return the created service objects. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Services to create. */
  services?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2ServiceInput>>>;
  /**
   * Used to provision services from V1, Should be removed
   * when deprecating services V1
   */
  skipScheduleCreation?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2BulkCreateServicesResponse = {
  __typename?: 'WixBookingsServicesV2BulkCreateServicesResponse';
  /** Create statistics. */
  bulkActionMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonBulkActionMetadata>;
  /** The result of each service creation. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2BulkServiceResult>>>;
};

export type WixBookingsServicesV2BulkDeleteServicesByFilterRequestInput = {
  /** Filter to identify the services that need to be deleted. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Whether to notify participants about the change and an optional custom message. */
  participantNotification?: InputMaybe<WixBookingsServicesV2ParticipantNotificationInput>;
  /**
   * Whether to preserve future sessions with participants.
   *
   * Default: `false`.
   */
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2BulkDeleteServicesByFilterResponse = {
  __typename?: 'WixBookingsServicesV2BulkDeleteServicesByFilterResponse';
  /**
   * ID of the service deletion job.
   *
   * Pass this ID to [Get Async Job](https://dev.wix.com/docs/rest/business-management/async-job/introduction) to retrieve job details and metadata.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2BulkDeleteServicesRequestInput = {
  /** IDs of the services to delete. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Whether to notify participants about the change and an optional
   * custom message.
   */
  participantNotification?: InputMaybe<WixBookingsServicesV2ParticipantNotificationInput>;
  /**
   * Whether to preserve future sessions with participants.
   *
   * Default: `false`.
   */
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2BulkDeleteServicesResponse = {
  __typename?: 'WixBookingsServicesV2BulkDeleteServicesResponse';
  /** Delete statistics. */
  bulkActionMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonBulkActionMetadata>;
  /** The result of each service removal. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2BulkServiceResult>>>;
};

export type WixBookingsServicesV2BulkServiceResult = {
  __typename?: 'WixBookingsServicesV2BulkServiceResult';
  /** Updated service. */
  item?: Maybe<WixBookingsServicesV2Service>;
  /** Update metadata. */
  itemMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonItemMetadata>;
};

export type WixBookingsServicesV2BulkUpdateServicesByFilterRequestInput = {
  /** Filter to identify the services to update. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Service to update. */
  service?: InputMaybe<WixBookingsServicesV2ServiceInput>;
};

export type WixBookingsServicesV2BulkUpdateServicesByFilterResponse = {
  __typename?: 'WixBookingsServicesV2BulkUpdateServicesByFilterResponse';
  /**
   * ID of the service update job.
   *
   * Pass this ID to [Get Async Job](https://dev.wix.com/docs/rest/business-management/async-job/introduction) to retrieve job details and metadata.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2BulkUpdateServicesRequestInput = {
  /** Whether to include the updated services in the response. Default: `false` */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Services to update. */
  services?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2BulkUpdateServicesRequestMaskedServiceInput>>>;
};

export type WixBookingsServicesV2BulkUpdateServicesRequestMaskedServiceInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Service to update. */
  service?: InputMaybe<WixBookingsServicesV2ServiceInput>;
};

export type WixBookingsServicesV2BulkUpdateServicesResponse = {
  __typename?: 'WixBookingsServicesV2BulkUpdateServicesResponse';
  /** Update statistics. */
  bulkActionMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonBulkActionMetadata>;
  /** The result of each service update. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2BulkServiceResult>>>;
};

export type WixBookingsServicesV2BusinessLocationOptions = {
  __typename?: 'WixBookingsServicesV2BusinessLocationOptions';
  /** Business location address. */
  address?: Maybe<WixBookingsServicesV2UpstreamWixCommonAddress>;
  /** Whether this is the default location. There can only be a single default location per site. */
  default?: Maybe<Scalars['Boolean']>;
  /** Business location email. */
  email?: Maybe<Scalars['String']>;
  /**
   * ID of the business *location*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction)).
   * When setting a business location, specify only the location ID. Other location details are overwritten.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * ID of the business *location*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction)).
   * When setting a business location, specify only the location ID. Other location details are overwritten.
   */
  location?: Maybe<ComWixpressLocationsLocation>;
  /** Business location name. */
  name?: Maybe<Scalars['String']>;
  /** Business location phone. */
  phone?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2BusinessLocationOptionsInput = {
  /** Business location address. */
  address?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAddressInput>;
  /** Whether this is the default location. There can only be a single default location per site. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Business location email. */
  email?: InputMaybe<Scalars['String']>;
  /**
   * ID of the business *location*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction)).
   * When setting a business location, specify only the location ID. Other location details are overwritten.
   */
  id?: InputMaybe<Scalars['String']>;
  /** Business location name. */
  name?: InputMaybe<Scalars['String']>;
  /** Business location phone. */
  phone?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2BusinessLocations = {
  __typename?: 'WixBookingsServicesV2BusinessLocations';
  /**
   * Whether at least one service matching the filter is connected to any of the
   * retrieved business locations.
   */
  exists?: Maybe<Scalars['Boolean']>;
  /** Retrieved business locations. */
  locations?: Maybe<Array<Maybe<WixBookingsServicesV2Location>>>;
};

export type WixBookingsServicesV2Category = {
  __typename?: 'WixBookingsServicesV2Category';
  /** Category ID. */
  category?: Maybe<WixBookingsCategoriesV2Category>;
  /** Category ID. */
  id?: Maybe<Scalars['String']>;
  /** Category name. */
  name?: Maybe<Scalars['String']>;
  /** Order of a category within a category list. */
  sortOrder?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2CategoryInput = {
  /** Category ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Category name. */
  name?: InputMaybe<Scalars['String']>;
  /** Order of a category within a category list. */
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export enum WixBookingsServicesV2CloneErrorsEnumCloneErrors {
  /** Failed to clone the original service's *booking form*. */
  Form = 'FORM',
  /**
   * Failed to clone the original service's *options and variants*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/service-options-and-variants/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/introduction)).
   */
  OptionsAndVariants = 'OPTIONS_AND_VARIANTS',
  /**
   * Failed to add *pricing plans*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/pricing-plans/plans/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/pricing-plans/pricing-plans/plans/introduction))
   * as supported payment methods for the cloned service.
   */
  PricingPlans = 'PRICING_PLANS',
  /**
   * Failed to clone sessions belonging to the original service's active
   * schedule.
   */
  Sessions = 'SESSIONS',
  /** Unknown error. */
  UnknownCloneError = 'UNKNOWN_CLONE_ERROR'
}

export type WixBookingsServicesV2CloneServiceRequestInput = {
  /**
   * Name of the cloned service.
   * The `title` of cloned service's active *schedule*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/schedules/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/introduction))
   * is also set to this name.
   * The default name and schedule title of the cloned service are exact matches
   * of the corresponding fields from the service to clone.
   */
  cloneServiceName?: InputMaybe<Scalars['String']>;
  /**
   * Whether to copy the original service's `payment.pricingPlanIds` array.
   * A maximum of 120 pricing plans is copied.
   */
  copyPricingPlans?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to copy future recurring *events*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/events/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction))
   * belonging to the service's active schedule. Relevant only for classes and
   * courses.
   */
  copyRecurringSessions?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to hide the cloned service from customers. Specifying an
   * empty value means that the original service's `hidden` value is used.
   */
  hideService?: InputMaybe<Scalars['Boolean']>;
  /** ID of the service to clone. */
  sourceServiceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2CloneServiceResponse = {
  __typename?: 'WixBookingsServicesV2CloneServiceResponse';
  /**
   * Information about connected entities that couldn't be cloned. For example,
   * future recurring events, the booking form, service variants, and connected
   * pricing plans.
   */
  errors?: Maybe<Array<Maybe<WixBookingsServicesV2CloneErrorsEnumCloneErrors>>>;
  /** Cloned service. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2Conferencing = {
  __typename?: 'WixBookingsServicesV2Conferencing';
  /** Whether a conference link is generated for the service's sessions. */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ConferencingInput = {
  /** Whether a conference link is generated for the service's sessions. */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2CountServicesRequestInput = {
  /**
   * Query filter to base the count on. See supported filters
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
   * for more details.
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsServicesV2CountServicesResponse = {
  __typename?: 'WixBookingsServicesV2CountServicesResponse';
  /** Number of services matching the specified filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2CreateAddOnGroupRequestInput = {
  /** AddOnGroup to create. */
  addOnGroup?: InputMaybe<WixBookingsServicesV2AddOnGroupInput>;
  /** ID of the service to create the AddOnGroup for. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2CreateAddOnGroupResponse = {
  __typename?: 'WixBookingsServicesV2CreateAddOnGroupResponse';
  /** Created AddOnGroup. */
  addOnGroup?: Maybe<WixBookingsServicesV2AddOnGroup>;
};

export type WixBookingsServicesV2CreateAddOnsGroupRequestInput = {
  /** AddOnsGroup to create. */
  addOnsGroup?: InputMaybe<WixBookingsServicesV2AddOnsGroupInput>;
  /** ID of the service to create the AddOnsGroup for. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2CreateAddOnsGroupResponse = {
  __typename?: 'WixBookingsServicesV2CreateAddOnsGroupResponse';
  /** Created AddOnsGroup. */
  addOnsGroup?: Maybe<WixBookingsServicesV2AddOnsGroup>;
};

export type WixBookingsServicesV2CreateServiceRequestInput = {
  /** Service to create. */
  service?: InputMaybe<WixBookingsServicesV2ServiceInput>;
};

export type WixBookingsServicesV2CreateServiceResponse = {
  __typename?: 'WixBookingsServicesV2CreateServiceResponse';
  /** Created service. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2CustomLocationOptions = {
  __typename?: 'WixBookingsServicesV2CustomLocationOptions';
  /** Address of the custom location. */
  address?: Maybe<WixBookingsServicesV2UpstreamWixCommonAddress>;
  /** ID of the custom location. */
  id?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2CustomLocationOptionsInput = {
  /** Address of the custom location. */
  address?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAddressInput>;
  /** ID of the custom location. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2CustomLocations = {
  __typename?: 'WixBookingsServicesV2CustomLocations';
  /**
   * Whether at least one service matching the filter is connected to any of the
   * retrieved custom locations.
   */
  exists?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2CustomPayment = {
  __typename?: 'WixBookingsServicesV2CustomPayment';
  /** A custom description explaining to the customer how to pay for the service. */
  description?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2CustomPaymentInput = {
  /** A custom description explaining to the customer how to pay for the service. */
  description?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2CustomerLocations = {
  __typename?: 'WixBookingsServicesV2CustomerLocations';
  /**
   * Whether at least one service matching the filter is connected to any of the
   * retrieved customer locations.
   */
  exists?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2DeleteAddOnGroupRequestInput = {
  /** ID of the AddOnGroup to delete. */
  addOnGroupId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2DeleteAddOnsGroupRequestInput = {
  /** ID of the AddOnsGroup to delete. */
  addOnsGroupId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2DeleteServiceRequestInput = {
  /**
   * Whether to notify participants about the change and an optional
   * custom message.
   */
  participantNotification?: InputMaybe<WixBookingsServicesV2ParticipantNotificationInput>;
  /**
   * Whether to preserve future sessions with participants.
   *
   * Default: `false`
   */
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
  /** ID of the service to delete. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2DisablePricingPlansForServiceRequestInput = {
  /**
   * IDs of the *pricing plans*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/pricing-plans/plans/introduction) | [REST](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object))
   * to remove from the service's `payment.pricingPlanIds` array.
   */
  pricingPlanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the service to update. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2DisablePricingPlansForServiceResponse = {
  __typename?: 'WixBookingsServicesV2DisablePricingPlansForServiceResponse';
  /** Updated service. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2Duration = {
  __typename?: 'WixBookingsServicesV2Duration';
  /**
   * The duration of the service in minutes.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  minutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2DurationInput = {
  /**
   * The duration of the service in minutes.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  minutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2EnablePricingPlansForServiceRequestInput = {
  /**
   * IDs of the *pricing plans*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/pricing-plans/plans/introduction) | [REST](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object))
   * to add to the service's `payment.pricingPlanIds` array.
   */
  pricingPlanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the service to update. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2EnablePricingPlansForServiceResponse = {
  __typename?: 'WixBookingsServicesV2EnablePricingPlansForServiceResponse';
  /** Updated service. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2FieldViolation = {
  __typename?: 'WixBookingsServicesV2FieldViolation';
  /** Description of the error. */
  description?: Maybe<Scalars['String']>;
  /** Path to the invalid field. */
  fieldName?: Maybe<Scalars['String']>;
  /** Rule name of the violation */
  ruleName?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2FixedPayment = {
  __typename?: 'WixBookingsServicesV2FixedPayment';
  /**
   * The deposit price required to book the service.
   *
   * Required when: `rateType` is `FIXED` and `paymentOptions.deposit` is `true`
   */
  deposit?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
  /**
   * The fixed price required to book the service.
   *
   * Required when: `rateType` is `FIXED`
   */
  price?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
};

export type WixBookingsServicesV2FixedPaymentInput = {
  /**
   * The deposit price required to book the service.
   *
   * Required when: `rateType` is `FIXED` and `paymentOptions.deposit` is `true`
   */
  deposit?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
  /**
   * The fixed price required to book the service.
   *
   * Required when: `rateType` is `FIXED`
   */
  price?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
};

export type WixBookingsServicesV2Form = {
  __typename?: 'WixBookingsServicesV2Form';
  /**
   * ID of the form associated with the service.
   * The form information that you submit when booking includes contact details, participants, and other form fields set up for the service.
   * You can manage the service booking form fields using the Bookings Forms API.
   */
  id?: Maybe<Scalars['String']>;
  /** Settings that apply to the service booking form on mobile clients. */
  mobileSettings?: Maybe<WixBookingsServicesV2FormSettings>;
};

export type WixBookingsServicesV2FormInput = {
  /**
   * ID of the form associated with the service.
   * The form information that you submit when booking includes contact details, participants, and other form fields set up for the service.
   * You can manage the service booking form fields using the Bookings Forms API.
   */
  id?: InputMaybe<Scalars['String']>;
  /** Settings that apply to the service booking form on mobile clients. */
  mobileSettings?: InputMaybe<WixBookingsServicesV2FormSettingsInput>;
};

export type WixBookingsServicesV2FormSettings = {
  __typename?: 'WixBookingsServicesV2FormSettings';
  /** Whether the service booking form should be hidden from the site. */
  hidden?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2FormSettingsInput = {
  /** Whether the service booking form should be hidden from the site. */
  hidden?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2GetServiceAvailabilityConstraintsRequestInput = {
  /** ID of the service to retrieve. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2GetServiceAvailabilityConstraintsResponse = {
  __typename?: 'WixBookingsServicesV2GetServiceAvailabilityConstraintsResponse';
  /** The retrieved availability constraints of the service. */
  constraints?: Maybe<WixBookingsServicesV2ServiceAvailabilityConstraints>;
};

export type WixBookingsServicesV2GetServiceRequestInput = {
  /** Conditional fields to return. Currently only 1 is supported */
  conditionalFields?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2RequestedFields>>>;
  /**
   * Whether to perform an eventually consistent call using
   * catalog reader (only for dbV1)
   */
  eventuallyConsistent?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export enum WixBookingsServicesV2InvalidSlugErrorEnumInvalidSlugError {
  /** Slug is already associated with another service. */
  SlugAlreadyExists = 'SLUG_ALREADY_EXISTS',
  /** Slug contains illegal characters. */
  SlugContainsIllegalCharacters = 'SLUG_CONTAINS_ILLEGAL_CHARACTERS',
  /** Unknown slug error. */
  UnknownSlugError = 'UNKNOWN_SLUG_ERROR'
}

export type WixBookingsServicesV2ListAddOnGroupsByServiceIdRequestInput = {
  /** List of group ids to return. If not provided, all groups are returned. */
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the service to retrieve AddOnGroups for. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2ListAddOnGroupsByServiceIdResponse = {
  __typename?: 'WixBookingsServicesV2ListAddOnGroupsByServiceIdResponse';
  /** List of group IDs and their linked AddOns. */
  addOnGroupsDetails?: Maybe<Array<Maybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOnGroupDetail>>>;
};

export type WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOn = {
  __typename?: 'WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOn';
  /** The AddOn ID. */
  addOnId?: Maybe<Scalars['String']>;
  /** The AddOn description. */
  durationInMinutes?: Maybe<Scalars['Int']>;
  /** The AddOn price. */
  formattedAmount?: Maybe<Scalars['String']>;
  /** The AddOn max quantity. */
  maxQuantity?: Maybe<Scalars['Int']>;
  /** The AddOn name. */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOnGroupDetail = {
  __typename?: 'WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOnGroupDetail';
  /** The AddOns information linked to the group. */
  addOns?: Maybe<Array<Maybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOn>>>;
  /** The group ID. */
  groupId?: Maybe<Scalars['String']>;
  /** The group name. */
  groupName?: Maybe<Scalars['String']>;
  /** The group max number of AddOns. */
  maxNumberOfAddOns?: Maybe<Scalars['Int']>;
  /** The group prompt. */
  prompt?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2ListAddOnsGroupsByServiceIdRequestInput = {
  /** List of group ids to return. If not provided, all groups are returned. */
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the service to retrieve AddOns for. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponse = {
  __typename?: 'WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponse';
  /** List of group IDs and their linked AddOns. */
  addOnsGroupsDetails?: Maybe<Array<Maybe<WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOnsGroupDetail>>>;
};

export type WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOn = {
  __typename?: 'WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOn';
  /** The AddOn ID. */
  addOnId?: Maybe<Scalars['String']>;
  /** The AddOn description. */
  durationInMinutes?: Maybe<Scalars['Int']>;
  /** The AddOn price. */
  formattedAmount?: Maybe<Scalars['String']>;
  /** The AddOn max quantity. */
  maxQuantity?: Maybe<Scalars['Int']>;
  /** The AddOn name. */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOnsGroupDetail = {
  __typename?: 'WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOnsGroupDetail';
  /** The AddOns information linked to the group. */
  addOns?: Maybe<Array<Maybe<WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOn>>>;
  /** The group ID. */
  groupId?: Maybe<Scalars['String']>;
  /** The group name. */
  groupName?: Maybe<Scalars['String']>;
  /** The group max number of AddOns. */
  maxNumberOfAddOns?: Maybe<Scalars['Int']>;
  /** The group prompt. */
  prompt?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2Location = {
  __typename?: 'WixBookingsServicesV2Location';
  /** Information about business locations. */
  business?: Maybe<WixBookingsServicesV2BusinessLocationOptions>;
  /** Location address. Empty for `{"type": "CUSTOMER"}`. */
  calculatedAddress?: Maybe<WixBookingsServicesV2UpstreamWixCommonAddress>;
  /** Information about custom locations. */
  custom?: Maybe<WixBookingsServicesV2CustomLocationOptions>;
  /** Location ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Location type.
   *
   * Default: `CUSTOM`
   */
  type?: Maybe<WixBookingsServicesV2LocationTypeEnumLocationType>;
};

export type WixBookingsServicesV2LocationInput = {
  /** Information about business locations. */
  business?: InputMaybe<WixBookingsServicesV2BusinessLocationOptionsInput>;
  /** Location address. Empty for `{"type": "CUSTOMER"}`. */
  calculatedAddress?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAddressInput>;
  /** Information about custom locations. */
  custom?: InputMaybe<WixBookingsServicesV2CustomLocationOptionsInput>;
  /** Location ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Location type.
   *
   * Default: `CUSTOM`
   */
  type?: InputMaybe<WixBookingsServicesV2LocationTypeEnumLocationType>;
};

export enum WixBookingsServicesV2LocationTypeEnumLocationType {
  /**
   * Business *location*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction)).
   */
  Business = 'BUSINESS',
  /**
   * Location set by the business that is not a standard business *location*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/business-tools/locations/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/locations/introduction)).
   */
  Custom = 'CUSTOM',
  /**
   * The customer specifies any address when booking. Available only for
   * appointment-based services.
   */
  Customer = 'CUSTOMER',
  UnknownLocationType = 'UNKNOWN_LOCATION_TYPE'
}

export type WixBookingsServicesV2Media = {
  __typename?: 'WixBookingsServicesV2Media';
  /** Cover media associated with the service. */
  coverMedia?: Maybe<WixBookingsServicesV2MediaItem>;
  /** Media items associated with the service. */
  items?: Maybe<Array<Maybe<WixBookingsServicesV2MediaItem>>>;
  /** Primary media associated with the service. */
  mainMedia?: Maybe<WixBookingsServicesV2MediaItem>;
};

export type WixBookingsServicesV2MediaInput = {
  /** Cover media associated with the service. */
  coverMedia?: InputMaybe<WixBookingsServicesV2MediaItemInput>;
  /** Media items associated with the service. */
  items?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2MediaItemInput>>>;
  /** Primary media associated with the service. */
  mainMedia?: InputMaybe<WixBookingsServicesV2MediaItemInput>;
};

export type WixBookingsServicesV2MediaItem = {
  __typename?: 'WixBookingsServicesV2MediaItem';
  /** Details of the image associated with the service, such as URL and size. */
  image?: Maybe<WixBookingsServicesV2UpstreamWixCommonImage>;
};

export type WixBookingsServicesV2MediaItemInput = {
  /** Details of the image associated with the service, such as URL and size. */
  image?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonImageInput>;
};

export type WixBookingsServicesV2MoveToNewLocationsOptionsInput = {
  /** The new location to move existing sessions currently set to a removed location, used when `action` is `MOVE_TO_LOCATION`. */
  newLocation?: InputMaybe<WixBookingsServicesV2LocationInput>;
};

export type WixBookingsServicesV2OnlineBooking = {
  __typename?: 'WixBookingsServicesV2OnlineBooking';
  /** Multiple customers can request to book the same time slot. This is relevant when `requireManualApproval` is `true`. */
  allowMultipleRequests?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the service can be booked online.
   * When set to `true`, customers can book the service online. Configure the payment options via the `service.payment` property.
   * When set to `false`, customers cannot book the service online, and the service can only be paid for in person.
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Booking the service requires approval by the Wix user. */
  requireManualApproval?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2OnlineBookingInput = {
  /** Multiple customers can request to book the same time slot. This is relevant when `requireManualApproval` is `true`. */
  allowMultipleRequests?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the service can be booked online.
   * When set to `true`, customers can book the service online. Configure the payment options via the `service.payment` property.
   * When set to `false`, customers cannot book the service online, and the service can only be paid for in person.
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Booking the service requires approval by the Wix user. */
  requireManualApproval?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ParticipantNotificationInput = {
  /** Custom message to send to the participants about the changes to the booking. */
  message?: InputMaybe<Scalars['String']>;
  /**
   * Whether to send the message about the changes to the customer.
   *
   * Default: `false`
   */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2Payment = {
  __typename?: 'WixBookingsServicesV2Payment';
  /**
   * The details for the custom price of the service.
   *
   * Required when: `rateType` is `CUSTOM`
   */
  custom?: Maybe<WixBookingsServicesV2CustomPayment>;
  /**
   * The details for the fixed price of the service.
   *
   * Required when: `rateType` is `FIXED`
   */
  fixed?: Maybe<WixBookingsServicesV2FixedPayment>;
  /** The payment options a customer can use to pay for the service. */
  options?: Maybe<WixBookingsServicesV2PaymentOptions>;
  /** IDs of pricing plans that can be used as payment for the service. */
  pricingPlanIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The rate the customer is expected to pay for the service. */
  rateType?: Maybe<WixBookingsServicesV2RateTypeEnumRateType>;
  /**
   * The details for the varied pricing of the service.
   * Read more about [varied price options](https://support.wix.com/en/article/wix-bookings-about-getting-paid-online#offering-varied-price-options).
   *
   * Required when: `rateType` is `VARIED`
   */
  varied?: Maybe<WixBookingsServicesV2VariedPayment>;
};

export type WixBookingsServicesV2PaymentInput = {
  /**
   * The details for the custom price of the service.
   *
   * Required when: `rateType` is `CUSTOM`
   */
  custom?: InputMaybe<WixBookingsServicesV2CustomPaymentInput>;
  /**
   * The details for the fixed price of the service.
   *
   * Required when: `rateType` is `FIXED`
   */
  fixed?: InputMaybe<WixBookingsServicesV2FixedPaymentInput>;
  /** The payment options a customer can use to pay for the service. */
  options?: InputMaybe<WixBookingsServicesV2PaymentOptionsInput>;
  /** IDs of pricing plans that can be used as payment for the service. */
  pricingPlanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The rate the customer is expected to pay for the service. */
  rateType?: InputMaybe<WixBookingsServicesV2RateTypeEnumRateType>;
  /**
   * The details for the varied pricing of the service.
   * Read more about [varied price options](https://support.wix.com/en/article/wix-bookings-about-getting-paid-online#offering-varied-price-options).
   *
   * Required when: `rateType` is `VARIED`
   */
  varied?: InputMaybe<WixBookingsServicesV2VariedPaymentInput>;
};

export type WixBookingsServicesV2PaymentOptions = {
  __typename?: 'WixBookingsServicesV2PaymentOptions';
  /**
   * This service requires a deposit to be made online in order to book it.
   * When `true`:
   * + `rateType` must be `VARIED` or `FIXED`.
   * + A `deposit` must be specified.
   */
  deposit?: Maybe<Scalars['Boolean']>;
  /** Customers can pay for the service in person. */
  inPerson?: Maybe<Scalars['Boolean']>;
  /**
   * Customers can pay for the service online.
   * When `true`:
   * + `rateType` must be either `FIXED` or `VARIED`.
   * + `fixed.price` or `varied.default_price` must be specified respectively. Read more about [getting paid online](https://support.wix.com/en/article/wix-bookings-about-getting-paid-online).
   */
  online?: Maybe<Scalars['Boolean']>;
  /** Customers can pay for the service using a pricing plan. */
  pricingPlan?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2PaymentOptionsInput = {
  /**
   * This service requires a deposit to be made online in order to book it.
   * When `true`:
   * + `rateType` must be `VARIED` or `FIXED`.
   * + A `deposit` must be specified.
   */
  deposit?: InputMaybe<Scalars['Boolean']>;
  /** Customers can pay for the service in person. */
  inPerson?: InputMaybe<Scalars['Boolean']>;
  /**
   * Customers can pay for the service online.
   * When `true`:
   * + `rateType` must be either `FIXED` or `VARIED`.
   * + `fixed.price` or `varied.default_price` must be specified respectively. Read more about [getting paid online](https://support.wix.com/en/article/wix-bookings-about-getting-paid-online).
   */
  online?: InputMaybe<Scalars['Boolean']>;
  /** Customers can pay for the service using a pricing plan. */
  pricingPlan?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2QueryBookingFormsRequestInput = {
  /** Conditional fields to return. */
  conditionalFields?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2QueryBookingFormsRequestRequestedFields>>>;
  /**
   * Information about filters, paging, and sorting. See the article about
   * form filters ([REST](https://dev.wix.com/docs/rest/crm/forms/forms/introduction/supported-filters))
   * for all supported filters and sorting options.
   */
  query?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorQueryInput>;
};

export enum WixBookingsServicesV2QueryBookingFormsRequestRequestedFields {
  /** Whether to return the site's default booking form. */
  DefaultBookingForm = 'DEFAULT_BOOKING_FORM',
  /** Unknown requested conditional field. */
  UnknownRequestedField = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixBookingsServicesV2QueryBookingFormsResponse = {
  __typename?: 'WixBookingsServicesV2QueryBookingFormsResponse';
  /** Retrieved booking forms and information about connected services. */
  bookingForms?: Maybe<Array<Maybe<WixBookingsServicesV2BookingForm>>>;
  /** The site's default booking form and information about connected services. */
  defaultBookingForm?: Maybe<WixBookingsServicesV2BookingForm>;
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata>;
};

export type WixBookingsServicesV2QueryCategoriesFilterInput = {
  /** List of category IDs to filter by. */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Service filter. See supported filters
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
   * for more details.
   */
  services?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsServicesV2QueryCategoriesRequestInput = {
  /** Filter. */
  filter?: InputMaybe<WixBookingsServicesV2QueryCategoriesFilterInput>;
};

export type WixBookingsServicesV2QueryCategoriesResponse = {
  __typename?: 'WixBookingsServicesV2QueryCategoriesResponse';
  /** Retrieved categories. */
  categories?: Maybe<Array<Maybe<WixBookingsServicesV2Category>>>;
};

export type WixBookingsServicesV2QueryLocationsFilterInput = {
  /** List of business IDs to filter by. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Service filter. See supported filters
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
   * for more details.
   */
  services?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsServicesV2QueryLocationsRequestInput = {
  /** Filter. */
  filter?: InputMaybe<WixBookingsServicesV2QueryLocationsFilterInput>;
};

export type WixBookingsServicesV2QueryLocationsResponse = {
  __typename?: 'WixBookingsServicesV2QueryLocationsResponse';
  /**
   * Retrieved business locations and whether each location is connected to at
   * least one service.
   */
  businessLocations?: Maybe<WixBookingsServicesV2BusinessLocations>;
  /**
   * Retrieved custom locations and whether each location is connected to at
   * least one service.
   */
  customLocations?: Maybe<WixBookingsServicesV2CustomLocations>;
  /**
   * Retrieved customer locations and whether each location is connected to at
   * least one service.
   */
  customerLocations?: Maybe<WixBookingsServicesV2CustomerLocations>;
};

export type WixBookingsServicesV2QueryPoliciesRequestInput = {
  /**
   * Information about filters, paging, and sorting. See the article about
   * booking policy filters
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/supported-filters))
   * for all supported filters and sorting options.
   */
  query?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorQueryInput>;
};

export type WixBookingsServicesV2QueryPoliciesResponse = {
  __typename?: 'WixBookingsServicesV2QueryPoliciesResponse';
  /** Retrieved booking policies and information about the services using them. */
  bookingPolicies?: Maybe<Array<Maybe<WixBookingsServicesV2BookingPolicyWithServices>>>;
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata>;
};

export type WixBookingsServicesV2QueryServicesMultiLanguageRequestInput = {
  /** Conditional fields to return. Currently only 1 is supported. */
  conditionalFields?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2RequestedFields>>>;
  /** WQL expression. */
  query?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonQueryV2Input>;
};

export type WixBookingsServicesV2QueryServicesMultiLanguageResponse = {
  __typename?: 'WixBookingsServicesV2QueryServicesMultiLanguageResponse';
  /** Paging metadata, including offset and count. */
  pagingMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonPagingMetadataV2>;
  /** The retrieved services in the main language */
  services?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
  /**
   * the retrieved services in the requested language according to the
   * provided linguist aspect
   */
  translatedServices?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
};

export type WixBookingsServicesV2QueryServicesRequestInput = {
  /** Conditional fields to return. Currently only 1 is supported */
  conditionalFields?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2RequestedFields>>>;
  /**
   * Whether to perform an eventually consistent call using
   * catalog reader (only for dbV1)
   */
  eventuallyConsistent?: InputMaybe<Scalars['Boolean']>;
  /** WQL expression. */
  query?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonQueryV2Input>;
};

export type WixBookingsServicesV2QueryServicesResponse = {
  __typename?: 'WixBookingsServicesV2QueryServicesResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixBookingsServicesV2RateTypeEnumRateType {
  /** The service has a custom price, expressed as a price description. */
  Custom = 'CUSTOM',
  /** The service has a fixed price. */
  Fixed = 'FIXED',
  /** This service is offered free of charge. */
  NoFee = 'NO_FEE',
  /** Unknown rate type. */
  UnknownRateType = 'UNKNOWN_RATE_TYPE',
  /** This service is offered with a set of different prices based on different terms. */
  Varied = 'VARIED'
}

export enum WixBookingsServicesV2RemovedLocationSessionsActionAction {
  /**
   * Cancel all future events at the removed location.
   * Currently not supported.
   */
  Delete = 'DELETE',
  /** Retain all future sessions at their current location. This is the default. */
  KeepAtCurrentLocation = 'KEEP_AT_CURRENT_LOCATION',
  /** Move future events to a new location. */
  MoveToLocation = 'MOVE_TO_LOCATION',
  UnknownActionType = 'UNKNOWN_ACTION_TYPE'
}

export type WixBookingsServicesV2RemovedLocationSessionsActionInput = {
  /** Information about what to do with future events at the removed location. */
  action?: InputMaybe<WixBookingsServicesV2RemovedLocationSessionsActionAction>;
  /**
   * Details about the new location of future events that were scheduled to take
   * place at a removed location.
   */
  moveToLocationOptions?: InputMaybe<WixBookingsServicesV2MoveToNewLocationsOptionsInput>;
};

export enum WixBookingsServicesV2RequestedFields {
  /** When passed, `service.service_resources.resource_type.name` is returned. */
  ResourceTypeDetails = 'RESOURCE_TYPE_DETAILS',
  /** When passed, `service.staff_members` is returned. */
  StaffMemberDetails = 'STAFF_MEMBER_DETAILS',
  /** Unknown requested field. */
  UnknownRequestedField = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixBookingsServicesV2ResourceGroup = {
  __typename?: 'WixBookingsServicesV2ResourceGroup';
  /**
   * Specifies how many resources in the group / resource IDs are required to book the service.
   * Defaults to 1.
   */
  requiredResourcesNumber?: Maybe<Scalars['Int']>;
  /**
   * An optional resource group ID. If specified, it references a resource group in the resource groups API.
   * TODO - referenced_entity annotation
   */
  resourceGroupId?: Maybe<Scalars['String']>;
  /**
   * Resource IDs. Each ID references a resource in the resources API and may be a subset of resources within a resource group.
   * TODO - referenced_entity annotation
   */
  resourceIds?: Maybe<WixBookingsServicesV2ResourceIds>;
  /**
   * If set to `true`, the customer can select the specific resources while booking the service.
   * If set to `false`, the resources required to book the service will be auto-selected at the time of the booking.
   * Defaults to false.
   */
  selectableResource?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ResourceGroupInput = {
  /**
   * Specifies how many resources in the group / resource IDs are required to book the service.
   * Defaults to 1.
   */
  requiredResourcesNumber?: InputMaybe<Scalars['Int']>;
  /**
   * An optional resource group ID. If specified, it references a resource group in the resource groups API.
   * TODO - referenced_entity annotation
   */
  resourceGroupId?: InputMaybe<Scalars['String']>;
  /**
   * Resource IDs. Each ID references a resource in the resources API and may be a subset of resources within a resource group.
   * TODO - referenced_entity annotation
   */
  resourceIds?: InputMaybe<WixBookingsServicesV2ResourceIdsInput>;
  /**
   * If set to `true`, the customer can select the specific resources while booking the service.
   * If set to `false`, the resources required to book the service will be auto-selected at the time of the booking.
   * Defaults to false.
   */
  selectableResource?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ResourceIds = {
  __typename?: 'WixBookingsServicesV2ResourceIds';
  /** Values of the resource IDs. */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixBookingsServicesV2ResourceIdsInput = {
  /** Values of the resource IDs. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsServicesV2ResourceType = {
  __typename?: 'WixBookingsServicesV2ResourceType';
  /** The type of the resource. */
  id?: Maybe<Scalars['String']>;
  /** The name of the resource type. */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2ResourceTypeInput = {
  /** The type of the resource. */
  id?: InputMaybe<Scalars['String']>;
  /** The name of the resource type. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2Schedule = {
  __typename?: 'WixBookingsServicesV2Schedule';
  /** Limitations affecting the service availability. */
  availabilityConstraints?: Maybe<WixBookingsServicesV2AvailabilityConstraints>;
  /** Start time of the first session in the schedule. For courses only. */
  firstSessionStart?: Maybe<Scalars['String']>;
  /**
   * ID of the *schedule*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/schedules/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/introduction))
   * to which the service's events belong.
   */
  id?: Maybe<Scalars['String']>;
  /** End time of the last session in the schedule. For courses only. */
  lastSessionEnd?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2ScheduleInput = {
  /** Limitations affecting the service availability. */
  availabilityConstraints?: InputMaybe<WixBookingsServicesV2AvailabilityConstraintsInput>;
  /** Start time of the first session in the schedule. For courses only. */
  firstSessionStart?: InputMaybe<Scalars['String']>;
  /**
   * ID of the *schedule*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/schedules/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/introduction))
   * to which the service's events belong.
   */
  id?: InputMaybe<Scalars['String']>;
  /** End time of the last session in the schedule. For courses only. */
  lastSessionEnd?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2SearchServicesRequestInput = {
  /** WQL, search or aggregation expression. */
  search?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorSearchInput>;
};

export type WixBookingsServicesV2SearchServicesResponse = {
  __typename?: 'WixBookingsServicesV2SearchServicesResponse';
  /** Response aggregation data */
  aggregationData?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationData>;
  /** Cursor paging metadata */
  pagingMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata>;
  /** The retrieved services. */
  services?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
};

export type WixBookingsServicesV2Service = {
  __typename?: 'WixBookingsServicesV2Service';
  /** A list of details for individual AddOns related to this service. */
  addOnDetails?: Maybe<Array<Maybe<WixBookingsServicesV2AddOnDetails>>>;
  /**
   * A collection of AddOn groups associated with this service.
   * Each group defines a set of AddOns that can be selected together with specific constraints.
   */
  addOnGroups?: Maybe<Array<Maybe<WixBookingsServicesV2AddOnGroup>>>;
  /**
   * ID of the app that's associated with the service. You can't update `appId`.
   * If the app ID is not specified, the service will be associated with the [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) by default.
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * _Policy_
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/booking-policies/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/introduction))
   * determining under what conditions this service can be booked. For example, whether the service can only be booked up to 30 minutes before it begins.
   */
  bookingPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy>;
  /**
   * _Category_
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/categories/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/categories-v1/category-object))
   * the service is associated with.
   */
  category?: Maybe<WixBookingsServicesV2Category>;
  /** Conferencing options for the service. */
  conferencing?: Maybe<WixBookingsServicesV2Conferencing>;
  /** Date and time the service was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: Maybe<Scalars['String']>;
  /** Default maximum number of customers that can book the service. The service cannot be booked beyond this capacity. */
  defaultCapacity?: Maybe<Scalars['Int']>;
  /** Service description. For example, `High-class hair styling, cuts, straightening and color`. */
  description?: Maybe<Scalars['String']>;
  /** Extensions enabling users to save custom data related to the service. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Form the customer filled out when booking the service. */
  form?: Maybe<WixBookingsServicesV2Form>;
  /** Whether the service is hidden from the site. */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Service ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * The locations this service is offered at. Read more about *service locations*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-locations)).
   */
  locations?: Maybe<Array<Maybe<WixBookingsServicesV2Location>>>;
  /**
   * Active slug for the service.
   * Learn more about *service slugs*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-slugs) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-slugs)).
   */
  mainSlug?: Maybe<WixBookingsServicesV2Slug>;
  /** Media associated with the service. */
  media?: Maybe<WixBookingsServicesV2Media>;
  /** Service name. */
  name?: Maybe<Scalars['String']>;
  /** Online booking settings. */
  onlineBooking?: Maybe<WixBookingsServicesV2OnlineBooking>;
  /**
   * Payment options for booking the service.
   * Learn more about *service payments*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-payments) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-payments)).
   */
  payment?: Maybe<WixBookingsServicesV2Payment>;
  /**
   * Resource groups required to book the service. For example, to book this service, you must book a room out of the resource group named "rooms".
   * @deprecated Resource groups required to book the service. For example, to book this service, you must book a room out of the resource group named "rooms". Replaced by: service_resources. Removal date: 2024-08-19.
   */
  resourceGroups?: Maybe<Array<Maybe<WixBookingsServicesV2ResourceGroup>>>;
  /**
   * Revision number, which increments by 1 each time the service is updated. To
   * prevent conflicting changes, the existing revision must be used when updating
   * a service.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * The service's *schedule*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/schedules/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/introduction)),
   * which can be used to manage the service's *events*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/events/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction)).
   */
  schedule?: Maybe<WixBookingsServicesV2Schedule>;
  /** Custom SEO data for the service. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /**
   * Information about which resources must be available so customers can book the service.
   * For example, a meeting room or equipment.
   */
  serviceResources?: Maybe<Array<Maybe<WixBookingsServicesV2ServiceResource>>>;
  /**
   * Order of the service within a *category*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/categories/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/categories-v1/category-object)).
   */
  sortOrder?: Maybe<Scalars['Int']>;
  /** Staff members details. Returned only if `STAFF_MEMBER_DETAILS` conditional field was specified. */
  staffMemberDetails?: Maybe<WixBookingsServicesV2StaffMemberDetails>;
  /**
   * IDs of the *staff members*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction))
   * providing the service. Available only for appointment-based services.
   */
  staffMemberIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Staff members providing the service. For appointments only. Returned only if `STAFF_MEMBER_DETAILS` conditional field was specified.
   * @deprecated Staff members providing the service. For appointments only. Returned only if `STAFF_MEMBER_DETAILS` conditional field was specified. Replaced by: staff_member_details.staff_members. Removal date: 2025-01-01.
   */
  staffMembers?: Maybe<Array<Maybe<WixBookingsServicesV2StaffMember>>>;
  /**
   * A slug is the last part of the URL address that serves as a unique identifier of the service.
   * The list of supported slugs includes past service names for backwards compatibility, and a custom slug if one was set by the business owner.
   */
  supportedSlugs?: Maybe<Array<Maybe<WixBookingsServicesV2Slug>>>;
  /** Short service description, such as `Hair styling`. */
  tagLine?: Maybe<Scalars['String']>;
  /**
   * Service type.
   * Learn more about *service types*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-types) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-types)).
   */
  type?: Maybe<WixBookingsServicesV2ServiceTypeEnumServiceType>;
  /** Date and time the service was updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: Maybe<Scalars['String']>;
  /** URLs to various service-related pages, such as the calendar page and the booking page. */
  urls?: Maybe<WixBookingsServicesV2UrLs>;
};

export type WixBookingsServicesV2ServiceAvailabilityConstraints = {
  __typename?: 'WixBookingsServicesV2ServiceAvailabilityConstraints';
  /** The booking policy. */
  bookingPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy>;
  /**
   * The locations this service is offered at.
   * Only multiple locations of type `BUSINESS` are supported. Multiple locations of type `CUSTOM` or `CUSTOMER` are not supported.
   * For courses only: Currently, only one location is supported for all location types.
   * Use the `Set Service Locations` method to change the locations this service is offered at.
   */
  locations?: Maybe<Array<Maybe<WixBookingsServicesV2Location>>>;
  /** Online booking settings. */
  onlineBooking?: Maybe<WixBookingsServicesV2OnlineBooking>;
  /**
   * Resource groups required to book the service. For backward compatibility only. Use `Service Resources` instead.
   * @deprecated Resource groups required to book the service. For backward compatibility only. Use `Service Resources` instead. Replaced by: service_resources. Removal date: 2024-08-19.
   */
  resourceGroups?: Maybe<Array<Maybe<WixBookingsServicesV2ResourceGroup>>>;
  /** The service schedule, including the schedule ID and availability constraints. */
  schedule?: Maybe<WixBookingsServicesV2Schedule>;
  /** Resource groups required to book the service. */
  serviceResources?: Maybe<Array<Maybe<WixBookingsServicesV2ServiceResource>>>;
  /**
   * The time between available slots' start times.
   * For example, for 5-minute slots: 3:00, 3:05, 3:10 etc. For 1-hour slots: 3:00, 4:00, 5:00 etc.
   * Applied to all schedules of the site.
   * For appointments only.
   */
  slotsSplitInterval?: Maybe<WixBookingsServicesV2UpstreamWixBookingsSchedulesV1SplitInterval>;
};

export type WixBookingsServicesV2ServiceInput = {
  /** A list of details for individual AddOns related to this service. */
  addOnDetails?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2AddOnDetailsInput>>>;
  /**
   * A collection of AddOn groups associated with this service.
   * Each group defines a set of AddOns that can be selected together with specific constraints.
   */
  addOnGroups?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2AddOnGroupInput>>>;
  /**
   * ID of the app that's associated with the service. You can't update `appId`.
   * If the app ID is not specified, the service will be associated with the [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) by default.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * _Policy_
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/booking-policies/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/introduction))
   * determining under what conditions this service can be booked. For example, whether the service can only be booked up to 30 minutes before it begins.
   */
  bookingPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicyInput>;
  /**
   * _Category_
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/categories/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/categories-v1/category-object))
   * the service is associated with.
   */
  category?: InputMaybe<WixBookingsServicesV2CategoryInput>;
  /** Conferencing options for the service. */
  conferencing?: InputMaybe<WixBookingsServicesV2ConferencingInput>;
  /** Date and time the service was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Default maximum number of customers that can book the service. The service cannot be booked beyond this capacity. */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  /** Service description. For example, `High-class hair styling, cuts, straightening and color`. */
  description?: InputMaybe<Scalars['String']>;
  /** Extensions enabling users to save custom data related to the service. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Form the customer filled out when booking the service. */
  form?: InputMaybe<WixBookingsServicesV2FormInput>;
  /** Whether the service is hidden from the site. */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Service ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * The locations this service is offered at. Read more about *service locations*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-locations)).
   */
  locations?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2LocationInput>>>;
  /**
   * Active slug for the service.
   * Learn more about *service slugs*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-slugs) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-slugs)).
   */
  mainSlug?: InputMaybe<WixBookingsServicesV2SlugInput>;
  /** Media associated with the service. */
  media?: InputMaybe<WixBookingsServicesV2MediaInput>;
  /** Service name. */
  name?: InputMaybe<Scalars['String']>;
  /** Online booking settings. */
  onlineBooking?: InputMaybe<WixBookingsServicesV2OnlineBookingInput>;
  /**
   * Payment options for booking the service.
   * Learn more about *service payments*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-payments) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-payments)).
   */
  payment?: InputMaybe<WixBookingsServicesV2PaymentInput>;
  /**
   * Revision number, which increments by 1 each time the service is updated. To
   * prevent conflicting changes, the existing revision must be used when updating
   * a service.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * The service's *schedule*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/schedules/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/introduction)),
   * which can be used to manage the service's *events*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/calendar/events/introduction) | [REST](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction)).
   */
  schedule?: InputMaybe<WixBookingsServicesV2ScheduleInput>;
  /** Custom SEO data for the service. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /**
   * Information about which resources must be available so customers can book the service.
   * For example, a meeting room or equipment.
   */
  serviceResources?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2ServiceResourceInput>>>;
  /**
   * Order of the service within a *category*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/categories/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/categories-v1/category-object)).
   */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Staff members details. Returned only if `STAFF_MEMBER_DETAILS` conditional field was specified. */
  staffMemberDetails?: InputMaybe<WixBookingsServicesV2StaffMemberDetailsInput>;
  /**
   * IDs of the *staff members*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction))
   * providing the service. Available only for appointment-based services.
   */
  staffMemberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * A slug is the last part of the URL address that serves as a unique identifier of the service.
   * The list of supported slugs includes past service names for backwards compatibility, and a custom slug if one was set by the business owner.
   */
  supportedSlugs?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2SlugInput>>>;
  /** Short service description, such as `Hair styling`. */
  tagLine?: InputMaybe<Scalars['String']>;
  /**
   * Service type.
   * Learn more about *service types*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/services/about-service-types) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-types)).
   */
  type?: InputMaybe<WixBookingsServicesV2ServiceTypeEnumServiceType>;
  /** Date and time the service was updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** URLs to various service-related pages, such as the calendar page and the booking page. */
  urls?: InputMaybe<WixBookingsServicesV2UrLsInput>;
};

export type WixBookingsServicesV2ServiceResource = {
  __typename?: 'WixBookingsServicesV2ServiceResource';
  /** The unique identifier for the service resource. If not specified, it defaults to the resource type ID. */
  id?: Maybe<Scalars['String']>;
  /** The number of resources required to book the service. Defaults to 1. */
  requiredResourcesNumber?: Maybe<Scalars['Int']>;
  /** Resource IDs, each referencing a resource in the Resources API. Must be a subset of resources within the specified resource type. */
  resourceIds?: Maybe<WixBookingsServicesV2ResourceIds>;
  /**
   * Details about the required *resource type*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/resource-types/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/resources/resource-types-v2/introduction)).
   */
  resourceType?: Maybe<WixBookingsServicesV2ResourceType>;
  /**
   * If set to `true`, the customer can select specific resources while booking the service.
   * If set to `false`, the resources required to book the service will be auto-selected at the time of booking. Defaults to false.
   */
  selectableResource?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ServiceResourceInput = {
  /** The unique identifier for the service resource. If not specified, it defaults to the resource type ID. */
  id?: InputMaybe<Scalars['String']>;
  /** The number of resources required to book the service. Defaults to 1. */
  requiredResourcesNumber?: InputMaybe<Scalars['Int']>;
  /** Resource IDs, each referencing a resource in the Resources API. Must be a subset of resources within the specified resource type. */
  resourceIds?: InputMaybe<WixBookingsServicesV2ResourceIdsInput>;
  /**
   * Details about the required *resource type*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/resource-types/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/resources/resource-types-v2/introduction)).
   */
  resourceType?: InputMaybe<WixBookingsServicesV2ResourceTypeInput>;
  /**
   * If set to `true`, the customer can select specific resources while booking the service.
   * If set to `false`, the resources required to book the service will be auto-selected at the time of booking. Defaults to false.
   */
  selectableResource?: InputMaybe<Scalars['Boolean']>;
};

export enum WixBookingsServicesV2ServiceTypeEnumServiceType {
  /** Appointment-based service. */
  Appointment = 'APPOINTMENT',
  /** Class service. */
  Class = 'CLASS',
  /** Course service. */
  Course = 'COURSE',
  UnknownServiceType = 'UNKNOWN_SERVICE_TYPE'
}

export type WixBookingsServicesV2SetAddOnsForGroupRequestInput = {
  /** The IDs of AddOns to set. */
  addOnIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The group ID to set AddOns for. */
  groupId?: InputMaybe<Scalars['String']>;
  /** The service ID to set AddOns for. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2SetAddOnsForGroupResponse = {
  __typename?: 'WixBookingsServicesV2SetAddOnsForGroupResponse';
  /** The updated AddOnGroup. */
  addOnGroup?: Maybe<WixBookingsServicesV2AddOnGroup>;
};

export type WixBookingsServicesV2SetCustomSlugRequestInput = {
  /** ID of the service for which to update the active slug. */
  serviceId?: InputMaybe<Scalars['String']>;
  /** Slug to set as the active service slug. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2SetCustomSlugResponse = {
  __typename?: 'WixBookingsServicesV2SetCustomSlugResponse';
  /** Updated service. */
  service?: Maybe<WixBookingsServicesV2Service>;
  /** Updated active service slug. */
  slug?: Maybe<WixBookingsServicesV2Slug>;
};

export type WixBookingsServicesV2SetServiceLocationsRequestInput = {
  /** List of locations replacing existing service locations. Omitting an existing location removes it from the service. Specify `removedLocationSessionsAction` to determine the handling of future sessions scheduled at that location. */
  locations?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2LocationInput>>>;
  /**
   * Whether to notify participants about the change of location, and an
   * Optional custom message. The notification is sent only to participants of sessions that are affected by the change.
   */
  participantNotification?: InputMaybe<WixBookingsServicesV2ParticipantNotificationInput>;
  /**
   * The action to perform on sessions currently set to a removed location. For
   * example, move existing sessions to a new specified location.
   * If not specified, sessions will not be moved to a new location.
   */
  removedLocationSessionsAction?: InputMaybe<WixBookingsServicesV2RemovedLocationSessionsActionInput>;
  /** ID of the service. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2SetServiceLocationsResponse = {
  __typename?: 'WixBookingsServicesV2SetServiceLocationsResponse';
  /** The updated service with the newly set locations. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2Slug = {
  __typename?: 'WixBookingsServicesV2Slug';
  /** Date and time the slug was created. This is a system field. */
  createdDate?: Maybe<Scalars['String']>;
  /** Whether the slug was generated or customized. If `true`, the slug was customized manually by the business owner. Otherwise, the slug was automatically generated from the service name. */
  custom?: Maybe<Scalars['Boolean']>;
  /** The unique part of service's URL that identifies the service's information page. For example, `service-1` in `https:/example.com/services/service-1`. */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2SlugInput = {
  /** Date and time the slug was created. This is a system field. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Whether the slug was generated or customized. If `true`, the slug was customized manually by the business owner. Otherwise, the slug was automatically generated from the service name. */
  custom?: InputMaybe<Scalars['Boolean']>;
  /** The unique part of service's URL that identifies the service's information page. For example, `service-1` in `https:/example.com/services/service-1`. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2StaffMediaItem = {
  __typename?: 'WixBookingsServicesV2StaffMediaItem';
  /** Details of the image associated with the staff, such as URL and size. */
  image?: Maybe<WixBookingsServicesV2UpstreamWixCommonImage>;
};

export type WixBookingsServicesV2StaffMediaItemInput = {
  /** Details of the image associated with the staff, such as URL and size. */
  image?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonImageInput>;
};

export type WixBookingsServicesV2StaffMember = {
  __typename?: 'WixBookingsServicesV2StaffMember';
  /** ID of the staff member events schedule, can be used to retrieve schedule information using wix-bookings-backend schedules API. */
  eventsScheduleId?: Maybe<Scalars['String']>;
  /** Main media associated with the service. */
  mainMedia?: Maybe<WixBookingsServicesV2StaffMediaItem>;
  /** Name of the staff member */
  name?: Maybe<Scalars['String']>;
  /** ID of the staff member providing the service, can be used to retrieve resource information using wix-bookings-backend resources API. */
  staffMemberId?: Maybe<Scalars['String']>;
  /** IDs of the staff member working hours schedules, can be used to retrieve schedule information using wix-bookings-backend schedules API. */
  workingHoursScheduleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixBookingsServicesV2StaffMemberDetails = {
  __typename?: 'WixBookingsServicesV2StaffMemberDetails';
  /** Staff members providing the service. For appointments only. */
  staffMembers?: Maybe<Array<Maybe<WixBookingsServicesV2StaffMember>>>;
};

export type WixBookingsServicesV2StaffMemberDetailsInput = {
  /** Staff members providing the service. For appointments only. */
  staffMembers?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2StaffMemberInput>>>;
};

export type WixBookingsServicesV2StaffMemberInput = {
  /** ID of the staff member events schedule, can be used to retrieve schedule information using wix-bookings-backend schedules API. */
  eventsScheduleId?: InputMaybe<Scalars['String']>;
  /** Main media associated with the service. */
  mainMedia?: InputMaybe<WixBookingsServicesV2StaffMediaItemInput>;
  /** Name of the staff member */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the staff member providing the service, can be used to retrieve resource information using wix-bookings-backend resources API. */
  staffMemberId?: InputMaybe<Scalars['String']>;
  /** IDs of the staff member working hours schedules, can be used to retrieve schedule information using wix-bookings-backend schedules API. */
  workingHoursScheduleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsServicesV2UrLs = {
  __typename?: 'WixBookingsServicesV2URLs';
  /** The URL for the booking entry point. It can be either to the calendar or to the service page. */
  bookingPage?: Maybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2>;
  /** The URL for the calendar. Can be empty if no calendar exists. */
  calendarPage?: Maybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2>;
  /** The URL for the service page. */
  servicePage?: Maybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2>;
};

export type WixBookingsServicesV2UrLsInput = {
  /** The URL for the booking entry point. It can be either to the calendar or to the service page. */
  bookingPage?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2Input>;
  /** The URL for the calendar. Can be empty if no calendar exists. */
  calendarPage?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2Input>;
  /** The URL for the service page. */
  servicePage?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2Input>;
};

export type WixBookingsServicesV2UpdateAddOnGroupRequestInput = {
  /** AddOnGroup to update. */
  addOnGroup?: InputMaybe<WixBookingsServicesV2AddOnGroupInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsServicesV2UpdateAddOnGroupResponse = {
  __typename?: 'WixBookingsServicesV2UpdateAddOnGroupResponse';
  /** Updated AddOnGroup */
  addOnGroup?: Maybe<WixBookingsServicesV2AddOnGroup>;
};

export type WixBookingsServicesV2UpdateAddOnsGroupRequestInput = {
  /** AddOnsGroup to update. */
  addOnsGroup?: InputMaybe<WixBookingsServicesV2AddOnsGroupInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsServicesV2UpdateAddOnsGroupResponse = {
  __typename?: 'WixBookingsServicesV2UpdateAddOnsGroupResponse';
  /** Updated AddOnsGroup */
  addOnsGroup?: Maybe<WixBookingsServicesV2AddOnsGroup>;
};

export type WixBookingsServicesV2UpdateServiceRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Service to update. */
  service?: InputMaybe<WixBookingsServicesV2ServiceInput>;
};

export type WixBookingsServicesV2UpdateServiceResponse = {
  __typename?: 'WixBookingsServicesV2UpdateServiceResponse';
  /** Updated service. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2UpstreamWixBookingsSchedulesV1SplitInterval = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsSchedulesV1SplitInterval';
  /**
   * Whether the slot duration is used as the split interval value.
   * If `same_as_duration` is `true`, the `value_in_minutes` is the sum of the first duration in
   * `schedule.availabilityConstraints.SlotDurations` field, and `schedule.availabilityConstraints.TimeBetweenSlots` field.
   */
  sameAsDuration?: Maybe<Scalars['Boolean']>;
  /** Number of minutes between available slots' start times when `same_as_duration` is `false`. */
  valueInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicy = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicy';
  /**
   * Whether booking is allowed after the start of the schedule. When `true`,
   * customers can book after the start of the schedule.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicyInput = {
  /**
   * Whether booking is allowed after the start of the schedule. When `true`,
   * customers can book after the start of the schedule.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy';
  /** ID of the app that's associated with the service. */
  appId?: Maybe<Scalars['String']>;
  /** Policy on booking an entity after the start of the schedule. */
  bookAfterStartPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicy>;
  /** The ID to the policy for the booking. */
  bookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
  /** Rules for cancellation fees. */
  cancellationFeePolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicy>;
  /** Policy for canceling a booked entity. */
  cancellationPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicy>;
  /** Date and time the policy was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Custom description for the policy. This policy is displayed to the participant. */
  customPolicyDescription?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1PolicyDescription>;
  /** Whether the policy is the default for the meta site. */
  default?: Maybe<Scalars['Boolean']>;
  /** The ID to the policy for the booking. */
  id?: Maybe<Scalars['String']>;
  /** Policy for limiting early bookings. */
  limitEarlyBookingPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicy>;
  /** Policy for limiting late bookings. */
  limitLateBookingPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicy>;
  /** Name of the policy. */
  name?: Maybe<Scalars['String']>;
  /** Policy regarding the participants per booking. */
  participantsPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicy>;
  /** Policy for rescheduling a booked entity. */
  reschedulePolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicy>;
  /** Policy for allocating resources. */
  resourcesPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicy>;
  /** Revision number, which increments by 1 each time the policy is updated. To prevent conflicting changes, the existing revision must be used when updating a policy. Can be empty after the service was cloned as part of site clone. */
  revision?: Maybe<Scalars['Long']>;
  /** Rule for saving credit card. */
  saveCreditCardPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicy>;
  /** Date and time the policy was updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Waitlist policy for the service. */
  waitlistPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicy>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicyInput = {
  /** ID of the app that's associated with the service. */
  appId?: InputMaybe<Scalars['String']>;
  /** Policy on booking an entity after the start of the schedule. */
  bookAfterStartPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicyInput>;
  /** Rules for cancellation fees. */
  cancellationFeePolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyInput>;
  /** Policy for canceling a booked entity. */
  cancellationPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicyInput>;
  /** Date and time the policy was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Custom description for the policy. This policy is displayed to the participant. */
  customPolicyDescription?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1PolicyDescriptionInput>;
  /** Whether the policy is the default for the meta site. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** The ID to the policy for the booking. */
  id?: InputMaybe<Scalars['String']>;
  /** Policy for limiting early bookings. */
  limitEarlyBookingPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicyInput>;
  /** Policy for limiting late bookings. */
  limitLateBookingPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicyInput>;
  /** Name of the policy. */
  name?: InputMaybe<Scalars['String']>;
  /** Policy regarding the participants per booking. */
  participantsPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicyInput>;
  /** Policy for rescheduling a booked entity. */
  reschedulePolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicyInput>;
  /** Policy for allocating resources. */
  resourcesPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicyInput>;
  /** Revision number, which increments by 1 each time the policy is updated. To prevent conflicting changes, the existing revision must be used when updating a policy. Can be empty after the service was cloned as part of site clone. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Rule for saving credit card. */
  saveCreditCardPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicyInput>;
  /** Date and time the policy was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Waitlist policy for the service. */
  waitlistPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicyInput>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicy = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicy';
  /**
   * Whether the cancellation fee should not be automatically collected when customer cancels the booking.
   *
   * Default: `true`
   */
  autoCollectFeeEnabled?: Maybe<Scalars['Boolean']>;
  /** Cancellation windows describing the time of cancellation and the fee to charge. */
  cancellationWindows?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindow>>>;
  /**
   * Whether canceling a booking will result in a cancellation fee
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindow = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindow';
  /** Amount to be charged as a cancellation fee. */
  amount?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
  /** Percentage of the original price to be charged as a cancellation fee. */
  percentage?: Maybe<Scalars['String']>;
  /** The fee will be applied if the booked session starts within this start time in minutes. */
  startInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindowInput = {
  /** Amount to be charged as a cancellation fee. */
  amount?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
  /** Percentage of the original price to be charged as a cancellation fee. */
  percentage?: InputMaybe<Scalars['String']>;
  /** The fee will be applied if the booked session starts within this start time in minutes. */
  startInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyInput = {
  /**
   * Whether the cancellation fee should not be automatically collected when customer cancels the booking.
   *
   * Default: `true`
   */
  autoCollectFeeEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Cancellation windows describing the time of cancellation and the fee to charge. */
  cancellationWindows?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindowInput>>>;
  /**
   * Whether canceling a booking will result in a cancellation fee
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicy = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicy';
  /**
   * Whether canceling a booking is allowed. When `true`, customers
   * can cancel the booking.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the booked session that the booking can be canceled.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestCancellationInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there is a limit on the latest cancellation time. When `true`,
   * a time limit is enforced.
   *
   * Default: `false`
   */
  limitLatestCancellation?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicyInput = {
  /**
   * Whether canceling a booking is allowed. When `true`, customers
   * can cancel the booking.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the booked session that the booking can be canceled.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestCancellationInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there is a limit on the latest cancellation time. When `true`,
   * a time limit is enforced.
   *
   * Default: `false`
   */
  limitLatestCancellation?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicy = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicy';
  /**
   * Maximum number of minutes before the start of the session that a booking can be made. This value must be greater
   * than `latest_booking_in_minutes` in the `LimitLateBookingPolicy` policy.
   *
   * Default: 10080 minutes (7 days)
   * Min: 1 minute
   */
  earliestBookingInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there is a limit on how early a customer
   * can book. When `false`, there is no limit on the earliest
   * booking time and customers can book in advance, as early as they like.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicyInput = {
  /**
   * Maximum number of minutes before the start of the session that a booking can be made. This value must be greater
   * than `latest_booking_in_minutes` in the `LimitLateBookingPolicy` policy.
   *
   * Default: 10080 minutes (7 days)
   * Min: 1 minute
   */
  earliestBookingInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there is a limit on how early a customer
   * can book. When `false`, there is no limit on the earliest
   * booking time and customers can book in advance, as early as they like.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicy = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicy';
  /**
   * Whether there is a limit on how late a customer
   * can book. When `false`, there is no limit on the latest
   * booking time and customers can book up to the last minute.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session that a booking can be made.
   * For a schedule, this is relative to the start time of the next booked session, excluding past-booked sessions.
   * This value must be less than `earliest_booking_in_minutes` in the `LimitEarlyBookingPolicy` policy.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestBookingInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicyInput = {
  /**
   * Whether there is a limit on how late a customer
   * can book. When `false`, there is no limit on the latest
   * booking time and customers can book up to the last minute.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session that a booking can be made.
   * For a schedule, this is relative to the start time of the next booked session, excluding past-booked sessions.
   * This value must be less than `earliest_booking_in_minutes` in the `LimitEarlyBookingPolicy` policy.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestBookingInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicy = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicy';
  /**
   * Whether the maximum number of participants applies. When `false`, there is
   * no maximum.
   *
   * Default: `false`
   * Private because not limiting participants per booking is not supported by Bookings flows today
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Maximum number of participants allowed.
   *
   * Default: 1 participant
   * Min: 1 participant
   */
  maxParticipantsPerBooking?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicyInput = {
  /**
   * Whether the maximum number of participants applies. When `false`, there is
   * no maximum.
   *
   * Default: `false`
   * Private because not limiting participants per booking is not supported by Bookings flows today
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Maximum number of participants allowed.
   *
   * Default: 1 participant
   * Min: 1 participant
   */
  maxParticipantsPerBooking?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1PolicyDescription = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1PolicyDescription';
  /**
   * The description to display.
   *
   * Default: Empty
   * Max length: 2500 characters
   */
  description?: Maybe<Scalars['String']>;
  /**
   * Whether the description should be displayed. If `true`, the description is displayed.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1PolicyDescriptionInput = {
  /**
   * The description to display.
   *
   * Default: Empty
   * Max length: 2500 characters
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Whether the description should be displayed. If `true`, the description is displayed.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicy = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicy';
  /**
   * Whether rescheduling a booking is allowed. When `true`, customers
   * can reschedule the booking.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the booked session that the booking can be rescheduled.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestRescheduleInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there is a limit on the latest reschedule time. When `true`,
   * a time limit is enforced.
   *
   * Default: `false`
   */
  limitLatestReschedule?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicyInput = {
  /**
   * Whether rescheduling a booking is allowed. When `true`, customers
   * can reschedule the booking.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the booked session that the booking can be rescheduled.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestRescheduleInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there is a limit on the latest reschedule time. When `true`,
   * a time limit is enforced.
   *
   * Default: `false`
   */
  limitLatestReschedule?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicy = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicy';
  /**
   * `true`, if it is allowed to automatically assign a resource when booking an appointment,
   * `false`, if the client must always select a resource.
   *
   * Default: `false`
   */
  autoAssignAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * `true` if this policy is enabled, `false` otherwise.
   * When `false` then the client must always select a resource when booking an appointment.
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicyInput = {
  /**
   * `true`, if it is allowed to automatically assign a resource when booking an appointment,
   * `false`, if the client must always select a resource.
   *
   * Default: `false`
   */
  autoAssignAllowed?: InputMaybe<Scalars['Boolean']>;
  /**
   * `true` if this policy is enabled, `false` otherwise.
   * When `false` then the client must always select a resource when booking an appointment.
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicy = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicy';
  /** Default: `false` */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicyInput = {
  /** Default: `false` */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicy = {
  __typename?: 'WixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicy';
  /**
   * Number of spots available in the waitlist.
   *
   * Default: 10 spots
   * Min: 1 spot
   */
  capacity?: Maybe<Scalars['Int']>;
  /**
   * Whether the session has a waitlist. If `true`, there is a waitlist.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Amount of time a participant is given to book, once notified that a spot is available.
   *
   * Default: 10 minutes
   * Min: 1 spot
   */
  reservationTimeInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicyInput = {
  /**
   * Number of spots available in the waitlist.
   *
   * Default: 10 spots
   * Min: 1 spot
   */
  capacity?: InputMaybe<Scalars['Int']>;
  /**
   * Whether the session has a waitlist. If `true`, there is a waitlist.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Amount of time a participant is given to book, once notified that a spot is available.
   *
   * Default: 10 minutes
   * Min: 1 spot
   */
  reservationTimeInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAddress = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAddress';
  addressLine?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** 2-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: Maybe<Scalars['String']>;
  /** Full address of the location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<WixBookingsServicesV2UpstreamWixCommonAddressLocation>;
  /** Free text to help find the address. */
  hint?: Maybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: Maybe<WixBookingsServicesV2UpstreamWixCommonStreetAddress>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format. */
  subdivision?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAddressInput = {
  addressLine?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** 2-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Full address of the location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAddressLocationInput>;
  /** Free text to help find the address. */
  hint?: InputMaybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonStreetAddressInput>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format. */
  subdivision?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAddressLocation = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAddressLocation';
  /** Address latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAddressLocationInput = {
  /** Address latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationData = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationData';
  /** key = aggregation name (as derived from search request) */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResults>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResults = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResults';
  /** Date histogram aggregation results */
  dateHistogram?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults>;
  /** Field to aggregate by as derived from search request */
  fieldPath?: Maybe<Scalars['String']>;
  /** Group by value aggregation results */
  groupedByValue?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults>;
  /** User-defined name of aggregation as derived from search request */
  name?: Maybe<Scalars['String']>;
  /** Nested aggregation results */
  nested?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResults>;
  /** Range aggregation results */
  ranges?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results */
  scalar?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that must match provided kind as derived from search request */
  type?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationType>;
  /** Value aggregation results */
  values?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults';
  /** List of date histogram aggregations */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult';
  /** Count of documents in the bucket */
  count?: Maybe<Scalars['Int']>;
  /** Date in ISO 8601 format */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults';
  /** List of value aggregations */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult';
  /** Nested aggregations */
  nestedResults?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults>;
  /** Value of the field */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults';
  /** Field to aggregate by, matches the one provided in request */
  fieldPath?: Maybe<Scalars['String']>;
  /** User-defined name of aggregation, matches the one provided in request */
  name?: Maybe<Scalars['String']>;
  /** Range aggregation results */
  ranges?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results */
  scalar?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that matches result */
  type?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationType>;
  /** Value aggregation results */
  values?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResults = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResults';
  /** List of nested aggregations */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue';
  /** Date histogram aggregation result */
  dateHistogram?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
  /** Range aggregation result */
  range?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult>;
  /** Scalar aggregation result */
  scalar?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult>;
  /** Value aggregation result */
  value?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult';
  /** Count of entities in this range */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range */
  to?: Maybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults';
  /** List of nested aggregations */
  results?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult';
  /** Value of the scalar aggregation */
  value?: Maybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult';
  /** Count of entities with this value */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults';
  /** List of ranges returned in same order as requested */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult';
  /** Count of entities in this range */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range */
  to?: Maybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult';
  /** Type of scalar aggregation */
  type?: Maybe<WixBookingsServicesV2UpstreamWixCommonScalarType>;
  /** Value of the scalar aggregation */
  value?: Maybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults';
  /** List of value aggregations */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult';
  /** Count of entities with this value */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput = {
  /** Interval for date histogram aggregation */
  interval?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInterval>;
};

export enum WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInterval {
  /** Daily interval. */
  Day = 'DAY',
  /** Hourly interval. */
  Hour = 'HOUR',
  /** Minute interval. */
  Minute = 'MINUTE',
  /** Monthly interval. */
  Month = 'MONTH',
  /** Second interval. */
  Second = 'SECOND',
  /** Unknown interval. */
  UnknownInterval = 'UNKNOWN_INTERVAL',
  /** Weekly interval. */
  Week = 'WEEK',
  /** Yearly interval. */
  Year = 'YEAR'
}

export type WixBookingsServicesV2UpstreamWixCommonAggregationGroupByAggregationInput = {
  /** Field to aggregate by */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results */
  name?: InputMaybe<Scalars['String']>;
  /** Value aggregation configuration */
  value?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationInput = {
  /** Date histogram aggregation */
  dateHistogram?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by, use dot notation to specify json path */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results */
  name?: InputMaybe<Scalars['String']>;
  /** Nested aggregation */
  nested?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationInput>;
  /** Range aggregation */
  range?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation */
  scalar?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation, client must provide matching aggregation field below */
  type?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationType>;
  /** Value aggregation */
  value?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationInput = {
  /** Flattened list of aggregations, where each next aggregation is nested within previous one */
  nestedAggregations?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput = {
  /** Date histogram aggregation */
  dateHistogram?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by, use dont notation to specify json path */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results */
  name?: InputMaybe<Scalars['String']>;
  /** Range aggregation */
  range?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation */
  scalar?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation, client must provide matching aggregation field below */
  type?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationType>;
  /** Value aggregation */
  value?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput>;
};

export enum WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationType {
  DateHistogram = 'DATE_HISTOGRAM',
  Range = 'RANGE',
  Scalar = 'SCALAR',
  UnknownAggregationType = 'UNKNOWN_AGGREGATION_TYPE',
  Value = 'VALUE'
}

export type WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput = {
  /** Range buckets */
  buckets?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = {
  /** Inclusive lower bound of the range. Required if to is not given. */
  from?: InputMaybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. Required if from is not given. */
  to?: InputMaybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput = {
  /** Define the operator for the scalar aggregation */
  type?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonScalarType>;
};

export enum WixBookingsServicesV2UpstreamWixCommonAggregationType {
  DateHistogram = 'DATE_HISTOGRAM',
  Nested = 'NESTED',
  Range = 'RANGE',
  Scalar = 'SCALAR',
  UnknownAggregationType = 'UNKNOWN_AGGREGATION_TYPE',
  Value = 'VALUE'
}

export type WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = {
  /** can specify custom bucket name. Defaults are [string -> "N/A"], [int -> "0"], [bool -> "false"] ... */
  addToBucket?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput = {
  /** options for including missing values */
  includeOptions?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>;
  /** How many aggregations would you like to return? Can be between 1 and 250. 10 is the default. */
  limit?: InputMaybe<Scalars['Int']>;
  /** should missing values be included or excluded from the aggregation results. Default is EXCLUDE */
  missingValues?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationMissingValues>;
  /** Should sort in ascending or descending order */
  sortDirection?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationSortDirection>;
  /** Should sort by number of matches or value of the field */
  sortType?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationSortType>;
};

export enum WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationMissingValues {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export enum WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationSortType {
  Count = 'COUNT',
  Value = 'VALUE'
}

export type WixBookingsServicesV2UpstreamWixCommonBulkActionMetadata = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonBulkActionMetadata';
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Use these cursor to paginate between results. [Read more](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_cursor-paging). */
  cursors?: Maybe<WixBookingsServicesV2UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonSortingInput>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonCursorSearchInput = {
  /** Aggregations | Faceted search: refers to a way to explore large amounts of data by displaying summaries about various partitions of the data and later allowing to narrow the navigation to a specific partition. */
  aggregations?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationInput>>>;
  /**
   * Cursor pointing to page of results.
   * When requesting 'cursor_paging.cursor', no `filter`, `sort` or `search` can be provided.
   */
  cursorPaging?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingInput>;
  /** A filter object. See documentation [here](https://bo.wix.com/wix-docs/rnd/platformization-guidelines/api-query-language#platformization-guidelines_api-query-language_defining-in-protobuf) */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Free text to match in searchable fields */
  search?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonSearchDetailsInput>;
  /** Sort object in the form [{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}] */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonSortingInput>>>;
  /**
   * UTC offset or IANA time zone. Valid values are
   * ISO 8601 UTC offsets, such as +02:00 or -06:00,
   * and IANA time zone IDs, such as Europe/Rome
   *
   * Affects all filters and aggregations returned values.
   * You may override this behavior in a specific filter by providing
   * timestamps including time zone. e.g. `"2023-12-20T10:52:34.795Z"`
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonCursors = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonImage = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonImage';
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image file name. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. (e.g. "4b3901ffcb8d7ad81a613779d92c9702.jpg") */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. (similar to image.id e.g. "4b3901ffcb8d7ad81a613779d92c9702.jpg") */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image file name. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. (e.g. "4b3901ffcb8d7ad81a613779d92c9702.jpg") */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. (similar to image.id e.g. "4b3901ffcb8d7ad81a613779d92c9702.jpg") */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonItemMetadata = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonItemMetadata';
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixCommonMoney = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonMoney';
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format (e.g., 1 000,30). Optionally, a single (-), to indicate that the amount is negative. */
  formattedValue?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, a single (-), to indicate that the amount is negative. */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonMoneyInput = {
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format (e.g., 1 000,30). Optionally, a single (-), to indicate that the amount is negative. */
  formattedValue?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, a single (-), to indicate that the amount is negative. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonPageUrlV2 = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonPageUrlV2';
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  relativePath?: Maybe<Scalars['String']>;
  /** The page's full URL. For example, `https://mysite.com/product-page/a-product`. */
  url?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonPageUrlV2Input = {
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  relativePath?: InputMaybe<Scalars['String']>;
  /** The page's full URL. For example, `https://mysite.com/product-page/a-product`. */
  url?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonPagingMetadataV2 = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonPagingMetadataV2';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<WixBookingsServicesV2UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set. */
  total?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   *
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   *
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`
   *
   * Read more about [supported fields and operators](https://dev.wix.com/api/rest/wix-bookings/services-v2/filtering-and-sorting).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[ {"fieldName":"sortField1","order":"ASC"},
   * {"fieldName":"sortField2","order":"DESC"} ]`
   *
   * Read more about [sorting](https://dev.wix.com/api/rest/wix-bookings/services-v2/filtering-and-sorting#wix-bookings_services-v2_filtering-and-sorting_sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonSortingInput>>>;
};

export enum WixBookingsServicesV2UpstreamWixCommonScalarType {
  Avg = 'AVG',
  CountDistinct = 'COUNT_DISTINCT',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM',
  UnknownScalarType = 'UNKNOWN_SCALAR_TYPE'
}

export type WixBookingsServicesV2UpstreamWixCommonSearchDetailsInput = {
  /** Search term or expression */
  expression?: InputMaybe<Scalars['String']>;
  /** Fields to search in. If empty - server will search in own default fields */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Flag if should use auto fuzzy search (allowing typos by a managed proximity algorithm) */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Boolean search mode */
  mode?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonSearchDetailsMode>;
};

export enum WixBookingsServicesV2UpstreamWixCommonSearchDetailsMode {
  /** All */
  And = 'AND',
  /** Any */
  Or = 'OR'
}

export enum WixBookingsServicesV2UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixBookingsServicesV2UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonSortOrder>;
};

export type WixBookingsServicesV2UpstreamWixCommonStreetAddress = {
  __typename?: 'WixBookingsServicesV2UpstreamWixCommonStreetAddress';
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2ValidateAddOnsSelectionRequestInput = {
  /** The IDs of AddOns to validate. */
  addOnIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The group ID to validate AddOns against. */
  groupId?: InputMaybe<Scalars['String']>;
  /** The service ID to validate AddOns against. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2ValidateAddOnsSelectionResponse = {
  __typename?: 'WixBookingsServicesV2ValidateAddOnsSelectionResponse';
  /** The validation result. */
  result?: Maybe<WixBookingsServicesV2ValidateAddOnsSelectionResponseValidationResult>;
};

export type WixBookingsServicesV2ValidateAddOnsSelectionResponseValidationResult = {
  __typename?: 'WixBookingsServicesV2ValidateAddOnsSelectionResponseValidationResult';
  /**
   * A validation error message.
   * This field should populated when `valid` is `false`.
   */
  message?: Maybe<Scalars['String']>;
  /** Whether the AddOns selection is valid. */
  valid?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ValidateServiceRequestInput = {
  /** Service to validate. */
  service?: InputMaybe<WixBookingsServicesV2ServiceInput>;
};

export type WixBookingsServicesV2ValidateServiceResponse = {
  __typename?: 'WixBookingsServicesV2ValidateServiceResponse';
  /** Field violations. */
  fieldViolations?: Maybe<Array<Maybe<WixBookingsServicesV2FieldViolation>>>;
  /** Whether the service is valid. */
  valid?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ValidateSlugRequestInput = {
  /** IO of the service to check custom slug validity for. */
  serviceId?: InputMaybe<Scalars['String']>;
  /** Custom slug to validate. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2ValidateSlugResponse = {
  __typename?: 'WixBookingsServicesV2ValidateSlugResponse';
  /** Reasons why the slug is invalid. Available only if `{"valid": false}`. */
  errors?: Maybe<Array<Maybe<WixBookingsServicesV2InvalidSlugErrorEnumInvalidSlugError>>>;
  /** Valid slug. Available only if `{"valid": true}`. */
  slug?: Maybe<Scalars['String']>;
  /**
   * The requested custom slug name to validate. If valid, the slug name can
   * be set as a slug for the service and is populated with the requested
   * slug. Otherwise, `slugName` is empty.
   * @deprecated The requested custom slug name to validate. If valid, the slug name can
   * be set as a slug for the service and is populated with the requested
   * slug. Otherwise, `slugName` is empty. Replaced by: slug. Removal date: 2025-03-01.
   */
  slugName?: Maybe<Scalars['String']>;
  /** Whether the slug is valid. */
  valid?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2VariedPayment = {
  __typename?: 'WixBookingsServicesV2VariedPayment';
  /** The default price for the service without any variants. It will also be used as the default price for any new variant. */
  defaultPrice?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
  /**
   * The deposit price required to book the service.
   *
   * Required when: `rateType` is `VARIED` and `paymentOptions.deposit` is `true`
   */
  deposit?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
  /** The maximum price a customer may pay for this service, based on its variants. */
  maxPrice?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
  /** The minimal price a customer may pay for this service, based on its variants. */
  minPrice?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
};

export type WixBookingsServicesV2VariedPaymentInput = {
  /** The default price for the service without any variants. It will also be used as the default price for any new variant. */
  defaultPrice?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
  /**
   * The deposit price required to book the service.
   *
   * Required when: `rateType` is `VARIED` and `paymentOptions.deposit` is `true`
   */
  deposit?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
  /** The maximum price a customer may pay for this service, based on its variants. */
  maxPrice?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
  /** The minimal price a customer may pay for this service, based on its variants. */
  minPrice?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
};

export type WixBookingsStaffV1AssignBusinessScheduleRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to assign to. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1AssignBusinessScheduleResponse = {
  __typename?: 'WixBookingsStaffV1AssignBusinessScheduleResponse';
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1AssignCustomScheduleRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of a schedule to assign. */
  scheduleId?: InputMaybe<Scalars['String']>;
  /** Id of the StaffMember to assign to. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1AssignCustomScheduleResponse = {
  __typename?: 'WixBookingsStaffV1AssignCustomScheduleResponse';
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1AssociatedConferencingProvider = {
  __typename?: 'WixBookingsStaffV1AssociatedConferencingProvider';
  /** Conferencing account email. Might not match staff email. */
  accountEmail?: Maybe<Scalars['String']>;
  /** Connection status. */
  connectionStatus?: Maybe<WixBookingsStaffV1AssociatedConferencingProviderConnectionStatusStatusEnumConnectionStatus>;
  /** Conferencing provider id, e.g. Zoom integration identifier. */
  id?: Maybe<Scalars['String']>;
  /** Provider name, e.g. Zoom. */
  name?: Maybe<Scalars['String']>;
};

export enum WixBookingsStaffV1AssociatedConferencingProviderConnectionStatusStatusEnumConnectionStatus {
  /** Provider is connected to site and user is authenticated. */
  Connected = 'CONNECTED',
  /** Provider is not connected to site or user is not authenticated. */
  Disconnected = 'DISCONNECTED',
  Unknown = 'UNKNOWN'
}

export type WixBookingsStaffV1AssociatedConferencingProviderInput = {
  /** Conferencing account email. Might not match staff email. */
  accountEmail?: InputMaybe<Scalars['String']>;
  /** Connection status. */
  connectionStatus?: InputMaybe<WixBookingsStaffV1AssociatedConferencingProviderConnectionStatusStatusEnumConnectionStatus>;
  /** Conferencing provider id, e.g. Zoom integration identifier. */
  id?: InputMaybe<Scalars['String']>;
  /** Provider name, e.g. Zoom. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1AssociatedConferencingProviders = {
  __typename?: 'WixBookingsStaffV1AssociatedConferencingProviders';
  /** Conferencing accounts that are connected to this staff. */
  items?: Maybe<Array<Maybe<WixBookingsStaffV1AssociatedConferencingProvider>>>;
};

export type WixBookingsStaffV1AssociatedConferencingProvidersInput = {
  /** Conferencing accounts that are connected to this staff. */
  items?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1AssociatedConferencingProviderInput>>>;
};

export type WixBookingsStaffV1AssociatedWixIdentity = {
  __typename?: 'WixBookingsStaffV1AssociatedWixIdentity';
  /** Staff members connection status to the user. */
  connectionStatus?: Maybe<WixBookingsStaffV1AssociatedWixIdentityConnectionStatusEnumConnectionStatus>;
  /** Users identification data, if the resource is associated with the user. */
  identificationData?: Maybe<WixBookingsStaffV1UpstreamWixCommonIdentificationData>;
};

export enum WixBookingsStaffV1AssociatedWixIdentityConnectionStatusEnumConnectionStatus {
  /** User is connected to the staff member. */
  Connected = 'CONNECTED',
  /** User is disconnected from the staff member. */
  Disconnected = 'DISCONNECTED',
  /** Pending connections invite has expired. */
  Expired = 'EXPIRED',
  /** User connection is pending. */
  Pending = 'PENDING',
  /** User connection status is unknown. Only returned when conditional field for status is not selected. */
  Unknown = 'UNKNOWN'
}

export type WixBookingsStaffV1AssociatedWixIdentityInput = {
  /** Staff members connection status to the user. */
  connectionStatus?: InputMaybe<WixBookingsStaffV1AssociatedWixIdentityConnectionStatusEnumConnectionStatus>;
  /** Users identification data, if the resource is associated with the user. */
  identificationData?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonIdentificationDataInput>;
};

export type WixBookingsStaffV1ConnectStaffMemberToUserRequestInput = {
  /** Email of the user to send invitation to. The staff existing email would be used if not provided. */
  email?: InputMaybe<Scalars['String']>;
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to connect to. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1ConnectStaffMemberToUserResponse = {
  __typename?: 'WixBookingsStaffV1ConnectStaffMemberToUserResponse';
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1ConnectToUserRequestInput = {
  /** Email of the user to send invitation to. The staff existing email would be used if not provided. */
  email?: InputMaybe<Scalars['String']>;
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to connect to. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1ConnectToUserResponse = {
  __typename?: 'WixBookingsStaffV1ConnectToUserResponse';
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1CountStaffMembersRequestInput = {
  /** Filter to apply on staff members to count */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsStaffV1CountStaffMembersResponse = {
  __typename?: 'WixBookingsStaffV1CountStaffMembersResponse';
  /** The number of staff members matching the given filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixBookingsStaffV1CreateStaffMemberRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** StaffMember to be created. */
  staffMember?: InputMaybe<WixBookingsStaffV1StaffMemberInput>;
};

export type WixBookingsStaffV1CreateStaffMemberResponse = {
  __typename?: 'WixBookingsStaffV1CreateStaffMemberResponse';
  /** The created StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1DeleteStaffMemberRequestInput = {
  /** Id of the StaffMember to delete. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1DisconnectStaffMemberFromUserRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to disconnect. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1DisconnectStaffMemberFromUserResponse = {
  __typename?: 'WixBookingsStaffV1DisconnectStaffMemberFromUserResponse';
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1DisconnectUserRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to disconnect. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1DisconnectUserResponse = {
  __typename?: 'WixBookingsStaffV1DisconnectUserResponse';
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1EventSchedule = {
  __typename?: 'WixBookingsStaffV1EventSchedule';
  /** The related schedule ID */
  id?: Maybe<Scalars['String']>;
  /** The related schedule ID */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
};

export type WixBookingsStaffV1EventScheduleInput = {
  /** The related schedule ID */
  id?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1GetStaffMemberRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  id: Scalars['ID'];
};

export type WixBookingsStaffV1ImportStaffMemberRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** StaffMember to be created. */
  staffMember?: InputMaybe<WixBookingsStaffV1StaffMemberInput>;
};

export type WixBookingsStaffV1ImportStaffMemberResponse = {
  __typename?: 'WixBookingsStaffV1ImportStaffMemberResponse';
  /** The imported StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1MediaItem = {
  __typename?: 'WixBookingsStaffV1MediaItem';
  /** Staff members cover image. */
  image?: Maybe<WixBookingsStaffV1UpstreamWixCommonImage>;
};

export type WixBookingsStaffV1MediaItemInput = {
  /** Staff members cover image. */
  image?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonImageInput>;
};

export type WixBookingsStaffV1QueryStaffMembersRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** WQL expression. */
  query?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonCursorQueryInput>;
};

export type WixBookingsStaffV1QueryStaffMembersResponse = {
  __typename?: 'WixBookingsStaffV1QueryStaffMembersResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixBookingsStaffV1StaffMember>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixBookingsStaffV1RequestedFieldsEnumRequestedFields {
  /** Fields inside `associatedConferencingProviders` */
  AssociatedConferencingProviders = 'ASSOCIATED_CONFERENCING_PROVIDERS',
  /** `associatedWixIdentity.connectionStatus` */
  AssociatedIdentityStatus = 'ASSOCIATED_IDENTITY_STATUS',
  /** Fields inside `resource` */
  ResourceDetails = 'RESOURCE_DETAILS',
  UnknownRequestedField = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixBookingsStaffV1Resource = {
  __typename?: 'WixBookingsStaffV1Resource';
  /** this schedule contains the sessions in which this resource is booked. */
  eventsSchedule?: Maybe<WixBookingsStaffV1EventSchedule>;
  /** The related calendar resource id, same as `resourceId`. */
  id?: Maybe<Scalars['String']>;
  /** True if any `resource.workingHoursSchedules.shared` is true */
  usesDefaultWorkingHours?: Maybe<Scalars['Boolean']>;
  /** this schedule contains the sessions in which this resource is available for booking. */
  workingHoursSchedules?: Maybe<Array<Maybe<WixBookingsStaffV1WorkingHoursSchedule>>>;
};

export type WixBookingsStaffV1ResourceInput = {
  /** this schedule contains the sessions in which this resource is booked. */
  eventsSchedule?: InputMaybe<WixBookingsStaffV1EventScheduleInput>;
  /** The related calendar resource id, same as `resourceId`. */
  id?: InputMaybe<Scalars['String']>;
  /** True if any `resource.workingHoursSchedules.shared` is true */
  usesDefaultWorkingHours?: InputMaybe<Scalars['Boolean']>;
  /** this schedule contains the sessions in which this resource is available for booking. */
  workingHoursSchedules?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1WorkingHoursScheduleInput>>>;
};

export type WixBookingsStaffV1RestoreStaffRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to restore. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1RestoreStaffResponse = {
  __typename?: 'WixBookingsStaffV1RestoreStaffResponse';
  /** Restored staff member. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1StaffMember = {
  __typename?: 'WixBookingsStaffV1StaffMember';
  /** A staff member conferencing providers */
  associatedConferencingProviders?: Maybe<WixBookingsStaffV1AssociatedConferencingProviders>;
  /**
   * Wix user details, if the resource is associated with the Wix user.
   * A staff member resource can be associated with a Wix user via assignment of a permissions role in the business manager.
   */
  associatedWixIdentity?: Maybe<WixBookingsStaffV1AssociatedWixIdentity>;
  /** Represents the time this StaffMember was created */
  createdDate?: Maybe<Scalars['String']>;
  /** `true` - if staff was auto created default staff */
  default?: Maybe<Scalars['Boolean']>;
  /** Description, For example: "The best masseuse in all of the land" */
  description?: Maybe<Scalars['String']>;
  /** Staff member's email address. */
  email?: Maybe<Scalars['String']>;
  /** Extensions enabling users to save custom data related to the staff members. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** StaffMember ID */
  id?: Maybe<Scalars['String']>;
  /** Main media of the staff */
  mainMedia?: Maybe<WixBookingsStaffV1MediaItem>;
  /** Staff member's name. */
  name?: Maybe<Scalars['String']>;
  /** Staff member's phone number. */
  phone?: Maybe<Scalars['String']>;
  /** The related calendar resource */
  resource?: Maybe<WixBookingsStaffV1Resource>;
  /** The related calendar resource id, same as `resource.id` */
  resourceId?: Maybe<Scalars['String']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes by the server. for an update operation to succeed, you MUST pass the latest revision */
  revision?: Maybe<Scalars['Int']>;
  /** Represents the time this StaffMember was last updated */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixBookingsStaffV1StaffMemberInput = {
  /** A staff member conferencing providers */
  associatedConferencingProviders?: InputMaybe<WixBookingsStaffV1AssociatedConferencingProvidersInput>;
  /**
   * Wix user details, if the resource is associated with the Wix user.
   * A staff member resource can be associated with a Wix user via assignment of a permissions role in the business manager.
   */
  associatedWixIdentity?: InputMaybe<WixBookingsStaffV1AssociatedWixIdentityInput>;
  /** Represents the time this StaffMember was created */
  createdDate?: InputMaybe<Scalars['String']>;
  /** `true` - if staff was auto created default staff */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Description, For example: "The best masseuse in all of the land" */
  description?: InputMaybe<Scalars['String']>;
  /** Staff member's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Extensions enabling users to save custom data related to the staff members. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** StaffMember ID */
  id?: InputMaybe<Scalars['String']>;
  /** Main media of the staff */
  mainMedia?: InputMaybe<WixBookingsStaffV1MediaItemInput>;
  /** Staff member's name. */
  name?: InputMaybe<Scalars['String']>;
  /** Staff member's phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** The related calendar resource */
  resource?: InputMaybe<WixBookingsStaffV1ResourceInput>;
  /** The related calendar resource id, same as `resource.id` */
  resourceId?: InputMaybe<Scalars['String']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes by the server. for an update operation to succeed, you MUST pass the latest revision */
  revision?: InputMaybe<Scalars['Int']>;
  /** Represents the time this StaffMember was last updated */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1UpdateStaffMemberRequestInput = {
  /**
   * Set of fields to update.
   *
   * Fields that aren't included in `fieldMask.paths` are ignored.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** StaffMember to be updated, may be partial. */
  staffMember?: InputMaybe<WixBookingsStaffV1StaffMemberInput>;
};

export type WixBookingsStaffV1UpdateStaffMemberResponse = {
  __typename?: 'WixBookingsStaffV1UpdateStaffMemberResponse';
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsStaffV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1UpstreamWixCommonSortingInput>>>;
};

export type WixBookingsStaffV1UpstreamWixCommonIdentificationData = {
  __typename?: 'WixBookingsStaffV1UpstreamWixCommonIdentificationData';
  /** ID of a site visitor that has not logged in to the site. */
  anonymousVisitorId?: Maybe<Scalars['String']>;
  /** ID of an app. */
  appId?: Maybe<Scalars['String']>;
  /** ID of of a contact in the site's [CRM by Ascend](https://www.wix.com/ascend/crm) system. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** ID of of a contact in the site's [CRM by Ascend](https://www.wix.com/ascend/crm) system. */
  contactId?: Maybe<Scalars['String']>;
  identityType?: Maybe<WixBookingsStaffV1UpstreamWixCommonIdentificationDataIdentityType>;
  /** ID of a site visitor that has logged in to the site. */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** ID of a site visitor that has logged in to the site. */
  memberId?: Maybe<Scalars['String']>;
  /** ID of a Wix user (site owner, contributor, etc.). */
  wixUserId?: Maybe<Scalars['String']>;
};

export enum WixBookingsStaffV1UpstreamWixCommonIdentificationDataIdentityType {
  AnonymousVisitor = 'ANONYMOUS_VISITOR',
  App = 'APP',
  Member = 'MEMBER',
  Unknown = 'UNKNOWN',
  WixUser = 'WIX_USER'
}

export type WixBookingsStaffV1UpstreamWixCommonIdentificationDataInput = {
  /** ID of a site visitor that has not logged in to the site. */
  anonymousVisitorId?: InputMaybe<Scalars['String']>;
  /** ID of an app. */
  appId?: InputMaybe<Scalars['String']>;
  /** ID of of a contact in the site's [CRM by Ascend](https://www.wix.com/ascend/crm) system. */
  contactId?: InputMaybe<Scalars['String']>;
  identityType?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonIdentificationDataIdentityType>;
  /** ID of a site visitor that has logged in to the site. */
  memberId?: InputMaybe<Scalars['String']>;
  /** ID of a Wix user (site owner, contributor, etc.). */
  wixUserId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1UpstreamWixCommonImage = {
  __typename?: 'WixBookingsStaffV1UpstreamWixCommonImage';
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixBookingsStaffV1UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export enum WixBookingsStaffV1UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixBookingsStaffV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonSortOrder>;
};

export type WixBookingsStaffV1WorkingHoursSchedule = {
  __typename?: 'WixBookingsStaffV1WorkingHoursSchedule';
  /** The related schedule ID */
  id?: Maybe<Scalars['String']>;
  /** The related schedule ID */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
  /** `true` if it is a shared schedule (e.g. from a business or location), `false` or empty if this is a custom schedule specific to the resource. */
  shared?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsStaffV1WorkingHoursScheduleInput = {
  /** The related schedule ID */
  id?: InputMaybe<Scalars['String']>;
  /** `true` if it is a shared schedule (e.g. from a business or location), `false` or empty if this is a custom schedule specific to the resource. */
  shared?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1BookAfterStartPolicy = {
  __typename?: 'WixBookingsV1BookAfterStartPolicy';
  /**
   * Whether customers can book after the session has started. `true` means
   * customers can book after the session has started. For courses, this refers to
   * the start of the last course session. If specified as `true`,
   * `limitLateBookingPolicy.enabled` must be `false`.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1BookAfterStartPolicyInput = {
  /**
   * Whether customers can book after the session has started. `true` means
   * customers can book after the session has started. For courses, this refers to
   * the start of the last course session. If specified as `true`,
   * `limitLateBookingPolicy.enabled` must be `false`.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1BookingPolicy = {
  __typename?: 'WixBookingsV1BookingPolicy';
  /**
   * ID of the app that's associated with the service. You can't update `appId`.
   * If you don't specify an app ID, the service is associated with the
   * [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * by default.
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * Rule for booking after the start of a session or course. This rule and
   * `limitLateBookingPolicy` can't be both enabled at the same time.
   */
  bookAfterStartPolicy?: Maybe<WixBookingsV1BookAfterStartPolicy>;
  /** Rules for cancellation fees. */
  cancellationFeePolicy?: Maybe<WixBookingsV1CancellationFeePolicy>;
  /** Rule for canceling a booking. */
  cancellationPolicy?: Maybe<WixBookingsV1CancellationPolicy>;
  /** Date and time the booking policy was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: Maybe<Scalars['String']>;
  /**
   * Custom description for the booking policy and whether it's displayed to the
   * participant.
   */
  customPolicyDescription?: Maybe<WixBookingsV1PolicyDescription>;
  /** Whether the booking policy is the default. */
  default?: Maybe<Scalars['Boolean']>;
  /** Extensions enabling users to save custom data related to the booking policies. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** ID of the booking policy. */
  id?: Maybe<Scalars['String']>;
  /** Rule for limiting early bookings. */
  limitEarlyBookingPolicy?: Maybe<WixBookingsV1LimitEarlyBookingPolicy>;
  /**
   * Rule for limiting late bookings. This rule and `bookAfterStartPolicy` can't
   * be both enabled at the same time.
   */
  limitLateBookingPolicy?: Maybe<WixBookingsV1LimitLateBookingPolicy>;
  /** Name of the booking policy. */
  name?: Maybe<Scalars['String']>;
  /** Rule for participants per booking. */
  participantsPolicy?: Maybe<WixBookingsV1ParticipantsPolicy>;
  /** Rule for rescheduling a booking. */
  reschedulePolicy?: Maybe<WixBookingsV1ReschedulePolicy>;
  /** Rule for allocating resources. */
  resourcesPolicy?: Maybe<WixBookingsV1ResourcesPolicy>;
  /**
   * Revision number, which increments by 1 each time the booking policy is updated.
   * To prevent conflicting changes, the current `revision` must be passed when
   * updating the booking policy.
   */
  revision?: Maybe<Scalars['Long']>;
  /** Rule for saving credit card details. */
  saveCreditCardPolicy?: Maybe<WixBookingsV1SaveCreditCardPolicy>;
  /** Date and time the booking policy was updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Waitlist rule for the service. */
  waitlistPolicy?: Maybe<WixBookingsV1WaitlistPolicy>;
};

export type WixBookingsV1BookingPolicyInput = {
  /**
   * ID of the app that's associated with the service. You can't update `appId`.
   * If you don't specify an app ID, the service is associated with the
   * [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * by default.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Rule for booking after the start of a session or course. This rule and
   * `limitLateBookingPolicy` can't be both enabled at the same time.
   */
  bookAfterStartPolicy?: InputMaybe<WixBookingsV1BookAfterStartPolicyInput>;
  /** Rules for cancellation fees. */
  cancellationFeePolicy?: InputMaybe<WixBookingsV1CancellationFeePolicyInput>;
  /** Rule for canceling a booking. */
  cancellationPolicy?: InputMaybe<WixBookingsV1CancellationPolicyInput>;
  /** Date and time the booking policy was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /**
   * Custom description for the booking policy and whether it's displayed to the
   * participant.
   */
  customPolicyDescription?: InputMaybe<WixBookingsV1PolicyDescriptionInput>;
  /** Whether the booking policy is the default. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Extensions enabling users to save custom data related to the booking policies. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** ID of the booking policy. */
  id?: InputMaybe<Scalars['String']>;
  /** Rule for limiting early bookings. */
  limitEarlyBookingPolicy?: InputMaybe<WixBookingsV1LimitEarlyBookingPolicyInput>;
  /**
   * Rule for limiting late bookings. This rule and `bookAfterStartPolicy` can't
   * be both enabled at the same time.
   */
  limitLateBookingPolicy?: InputMaybe<WixBookingsV1LimitLateBookingPolicyInput>;
  /** Name of the booking policy. */
  name?: InputMaybe<Scalars['String']>;
  /** Rule for participants per booking. */
  participantsPolicy?: InputMaybe<WixBookingsV1ParticipantsPolicyInput>;
  /** Rule for rescheduling a booking. */
  reschedulePolicy?: InputMaybe<WixBookingsV1ReschedulePolicyInput>;
  /** Rule for allocating resources. */
  resourcesPolicy?: InputMaybe<WixBookingsV1ResourcesPolicyInput>;
  /**
   * Revision number, which increments by 1 each time the booking policy is updated.
   * To prevent conflicting changes, the current `revision` must be passed when
   * updating the booking policy.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** Rule for saving credit card details. */
  saveCreditCardPolicy?: InputMaybe<WixBookingsV1SaveCreditCardPolicyInput>;
  /** Date and time the booking policy was updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Waitlist rule for the service. */
  waitlistPolicy?: InputMaybe<WixBookingsV1WaitlistPolicyInput>;
};

export type WixBookingsV1CancellationFeePolicy = {
  __typename?: 'WixBookingsV1CancellationFeePolicy';
  /**
   * Whether Wix automatically charges the cancellation fee from the customer once
   * they cancel their booking.
   *
   * Default: `true`
   */
  autoCollectFeeEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Time windows relative to the session start during which customers can cancel
   * their booking. Each window includes details about the fee for canceling within it.
   */
  cancellationWindows?: Maybe<Array<Maybe<WixBookingsV1CancellationFeePolicyCancellationWindow>>>;
  /**
   * Whether customers must pay a cancellation fee when canceling a booking.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1CancellationFeePolicyCancellationWindow = {
  __typename?: 'WixBookingsV1CancellationFeePolicyCancellationWindow';
  /** Fixed amount customers must pay when canceling the booking within this window. */
  amount?: Maybe<WixBookingsV1UpstreamWixCommonMoney>;
  /**
   * Percentage of the booking price customers must pay when canceling within
   * this window.
   *
   * Min: `0.01` percent
   * Max: `100` percent
   */
  percentage?: Maybe<Scalars['String']>;
  /**
   * Start of the cancellation window in minutes before the session start. For
   * courses, this refers to the start of the first course session.
   */
  startInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsV1CancellationFeePolicyCancellationWindowInput = {
  /** Fixed amount customers must pay when canceling the booking within this window. */
  amount?: InputMaybe<WixBookingsV1UpstreamWixCommonMoneyInput>;
  /**
   * Percentage of the booking price customers must pay when canceling within
   * this window.
   *
   * Min: `0.01` percent
   * Max: `100` percent
   */
  percentage?: InputMaybe<Scalars['String']>;
  /**
   * Start of the cancellation window in minutes before the session start. For
   * courses, this refers to the start of the first course session.
   */
  startInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsV1CancellationFeePolicyInput = {
  /**
   * Whether Wix automatically charges the cancellation fee from the customer once
   * they cancel their booking.
   *
   * Default: `true`
   */
  autoCollectFeeEnabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Time windows relative to the session start during which customers can cancel
   * their booking. Each window includes details about the fee for canceling within it.
   */
  cancellationWindows?: InputMaybe<Array<InputMaybe<WixBookingsV1CancellationFeePolicyCancellationWindowInput>>>;
  /**
   * Whether customers must pay a cancellation fee when canceling a booking.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1CancellationPolicy = {
  __typename?: 'WixBookingsV1CancellationPolicy';
  /**
   * Whether customers can cancel the booking. `true` means customers can cancel
   * the booking.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session customers can cancel.
   * For courses, this refers to the start of the first course session.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestCancellationInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there's a limit on the latest cancellation time. `false` means customers
   * can cancel the booking until the last minute before the course or session starts.
   *
   * Default: `false`
   */
  limitLatestCancellation?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1CancellationPolicyInput = {
  /**
   * Whether customers can cancel the booking. `true` means customers can cancel
   * the booking.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session customers can cancel.
   * For courses, this refers to the start of the first course session.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestCancellationInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there's a limit on the latest cancellation time. `false` means customers
   * can cancel the booking until the last minute before the course or session starts.
   *
   * Default: `false`
   */
  limitLatestCancellation?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1CountBookingPoliciesRequestInput = {
  /**
   * Filter to base the count on. See
   * supported filters*
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/supported-filters))
   * for details.
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsV1CountBookingPoliciesResponse = {
  __typename?: 'WixBookingsV1CountBookingPoliciesResponse';
  /** Number of booking policies matching the provided filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixBookingsV1CreateBookingPolicyRequestInput = {
  /** Booking policy to create. */
  bookingPolicy?: InputMaybe<WixBookingsV1BookingPolicyInput>;
};

export type WixBookingsV1CreateBookingPolicyResponse = {
  __typename?: 'WixBookingsV1CreateBookingPolicyResponse';
  /** Created booking policy. */
  bookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
};

export type WixBookingsV1CreateMissingDefaultPolicyResponse = {
  __typename?: 'WixBookingsV1CreateMissingDefaultPolicyResponse';
  /** The default booking policy. */
  defaultBookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
  /** Whether a new default policy was created. */
  wasANewPolicyCreated?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1DeleteBookingPolicyRequestInput = {
  /** ID of the booking policy to delete. */
  bookingPolicyId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsV1GetBookingPolicyRequestInput = {
  id: Scalars['ID'];
};

export type WixBookingsV1GetStrictestBookingPolicyRequestInput = {
  /** IDs of the booking policies for which to retrieve the strictest rules for. */
  bookingPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsV1GetStrictestBookingPolicyResponse = {
  __typename?: 'WixBookingsV1GetStrictestBookingPolicyResponse';
  /**
   * Hypothetical `bookingPolicy` object that combines the strictest version of
   * each rule. `bookingPolicy.id` is `null` and the returned object isn't actually
   * created. To create a new policy, you can call *Create Booking Policy*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/booking-policies/create-booking-policy) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/create-booking-policy)).
   */
  bookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
};

export type WixBookingsV1LimitEarlyBookingPolicy = {
  __typename?: 'WixBookingsV1LimitEarlyBookingPolicy';
  /**
   * Maximum number of minutes before the start of a session or course customers can book.
   * Must be greater than `limitLateBookingPolicy.latestBookingInMinutes`.
   *
   * Default: `10080` minutes (7 days)
   * Min: `1` minute
   */
  earliestBookingInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there's a limit about how early a customer can book. `false` means there's
   * no limit to the earliest supported booking time.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1LimitEarlyBookingPolicyInput = {
  /**
   * Maximum number of minutes before the start of a session or course customers can book.
   * Must be greater than `limitLateBookingPolicy.latestBookingInMinutes`.
   *
   * Default: `10080` minutes (7 days)
   * Min: `1` minute
   */
  earliestBookingInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there's a limit about how early a customer can book. `false` means there's
   * no limit to the earliest supported booking time.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1LimitLateBookingPolicy = {
  __typename?: 'WixBookingsV1LimitLateBookingPolicy';
  /**
   * Whether there's a limit about how late customers can book. `false` means
   * customers can book up to the last minute. If specified as `true`,
   * `bookAfterStartPolicy.enabled` must be `false`.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session customers can book.
   * For courses, this is relative to the start time of the next session and doesn't
   * consider course sessions in the past. This value must be less than
   * `limitEarlyBookingPolicy.earliestBookingInMinutes`.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestBookingInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsV1LimitLateBookingPolicyInput = {
  /**
   * Whether there's a limit about how late customers can book. `false` means
   * customers can book up to the last minute. If specified as `true`,
   * `bookAfterStartPolicy.enabled` must be `false`.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session customers can book.
   * For courses, this is relative to the start time of the next session and doesn't
   * consider course sessions in the past. This value must be less than
   * `limitEarlyBookingPolicy.earliestBookingInMinutes`.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestBookingInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsV1ParticipantsPolicy = {
  __typename?: 'WixBookingsV1ParticipantsPolicy';
  /**
   * Whether there's a maximum number of participants per booking. `false` means
   * there is no maximum.
   *
   * Default: `false`
   * Private because not limiting participants per booking is not supported by Bookings flows today
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Maximum number of participants per booking.
   *
   * Default: `1` participant
   * Min: `1` participant
   */
  maxParticipantsPerBooking?: Maybe<Scalars['Int']>;
};

export type WixBookingsV1ParticipantsPolicyInput = {
  /**
   * Whether there's a maximum number of participants per booking. `false` means
   * there is no maximum.
   *
   * Default: `false`
   * Private because not limiting participants per booking is not supported by Bookings flows today
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Maximum number of participants per booking.
   *
   * Default: `1` participant
   * Min: `1` participant
   */
  maxParticipantsPerBooking?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsV1PolicyDescription = {
  __typename?: 'WixBookingsV1PolicyDescription';
  /**
   * Description of the booking policy.
   *
   * Default: Empty
   * Max length: 2500 characters
   */
  description?: Maybe<Scalars['String']>;
  /**
   * Whether the description is displayed to the participant. `true` means the
   * description is displayed.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1PolicyDescriptionInput = {
  /**
   * Description of the booking policy.
   *
   * Default: Empty
   * Max length: 2500 characters
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Whether the description is displayed to the participant. `true` means the
   * description is displayed.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1QueryBookingPoliciesRequestInput = {
  /**
   * The query by which to select booking policies. See
   * [the supported filters article](https://dev.wix.com/docs/rest/business-solutions/bookings/services/booking-policy/supported-filters)
   * for details.
   */
  query?: InputMaybe<WixBookingsV1UpstreamWixCommonCursorQueryInput>;
};

export type WixBookingsV1QueryBookingPoliciesResponse = {
  __typename?: 'WixBookingsV1QueryBookingPoliciesResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixBookingsV1BookingPolicy>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixBookingsV1ReschedulePolicy = {
  __typename?: 'WixBookingsV1ReschedulePolicy';
  /**
   * Whether customers can reschedule a booking for an appointment-based service.
   * `true` means customers can reschedule.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the session start session customers can
   * reschedule their booking.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestRescheduleInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there's a limit on the latest supported rescheduling time. `false`
   * means customers can reschedule until the last minute before the session start.
   *
   * Default: `false`
   */
  limitLatestReschedule?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1ReschedulePolicyInput = {
  /**
   * Whether customers can reschedule a booking for an appointment-based service.
   * `true` means customers can reschedule.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the session start session customers can
   * reschedule their booking.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestRescheduleInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there's a limit on the latest supported rescheduling time. `false`
   * means customers can reschedule until the last minute before the session start.
   *
   * Default: `false`
   */
  limitLatestReschedule?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1ResourcesPolicy = {
  __typename?: 'WixBookingsV1ResourcesPolicy';
  /**
   * Whether Wix Bookings automatically assigns a resource, for example a *staff member*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction)),
   * to the booking. `false` means the customer must select the resource
   * themselves and Wix Bookings doesn't assign it automatically.
   *
   * Default: `false`
   */
  autoAssignAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the customer must select a resource, for example a staff member, when
   * booking. `false` means the customer can book without selecting a resource.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1ResourcesPolicyInput = {
  /**
   * Whether Wix Bookings automatically assigns a resource, for example a *staff member*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction)),
   * to the booking. `false` means the customer must select the resource
   * themselves and Wix Bookings doesn't assign it automatically.
   *
   * Default: `false`
   */
  autoAssignAllowed?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the customer must select a resource, for example a staff member, when
   * booking. `false` means the customer can book without selecting a resource.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1SaveCreditCardPolicy = {
  __typename?: 'WixBookingsV1SaveCreditCardPolicy';
  /**
   * Whether Wix stores credit card details of the customer. Storing the details
   * allows Wix to prefill the *eCommerce checkout*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction))
   * and thus increases the likelihood that the customer completes the booking
   * process.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1SaveCreditCardPolicyInput = {
  /**
   * Whether Wix stores credit card details of the customer. Storing the details
   * allows Wix to prefill the *eCommerce checkout*
   * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/ecom/checkout/setup) | [REST](https://dev.wix.com/docs/rest/business-solutions/e-commerce/checkout/introduction))
   * and thus increases the likelihood that the customer completes the booking
   * process.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1SetDefaultBookingPolicyRequestInput = {
  /** ID of the booking policy that's set as default. */
  bookingPolicyId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsV1SetDefaultBookingPolicyResponse = {
  __typename?: 'WixBookingsV1SetDefaultBookingPolicyResponse';
  /** New default booking policy. */
  currentDefaultBookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
  /**
   * Previous default booking policy. Not available if the provided booking policy
   * was already the default.
   */
  previousDefaultBookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
};

export type WixBookingsV1UpdateAllPoliciesRequestInput = {
  /** Fields to set to all booking policies. */
  bookingPolicy?: InputMaybe<WixBookingsV1BookingPolicyInput>;
  /** List of fields to update */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsV1UpdateBookingPolicyRequestInput = {
  /** Booking policy to update. */
  bookingPolicy?: InputMaybe<WixBookingsV1BookingPolicyInput>;
  /** Explicit list of fields to update */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsV1UpdateBookingPolicyResponse = {
  __typename?: 'WixBookingsV1UpdateBookingPolicyResponse';
  /** Updated booking policy. */
  bookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
};

export type WixBookingsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsV1UpstreamWixCommonSortingInput>>>;
};

export type WixBookingsV1UpstreamWixCommonMoney = {
  __typename?: 'WixBookingsV1UpstreamWixCommonMoney';
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format (e.g., 1 000,30). Optionally, a single (-), to indicate that the amount is negative. */
  formattedValue?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, a single (-), to indicate that the amount is negative. */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsV1UpstreamWixCommonMoneyInput = {
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format (e.g., 1 000,30). Optionally, a single (-), to indicate that the amount is negative. */
  formattedValue?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, a single (-), to indicate that the amount is negative. */
  value?: InputMaybe<Scalars['String']>;
};

export enum WixBookingsV1UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixBookingsV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixBookingsV1UpstreamWixCommonSortOrder>;
};

export type WixBookingsV1WaitlistPolicy = {
  __typename?: 'WixBookingsV1WaitlistPolicy';
  /**
   * Number of spots in the waitlist.
   *
   * Default: `10` spots
   * Min: `1` spot
   */
  capacity?: Maybe<Scalars['Int']>;
  /**
   * Whether the service has a waitlist. `true` means there's a waitlist.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Time in minutes the potential customer is given to book after they've been
   * notified that a spot has opened up for them. If they don't respond in time,
   * the open spot is offered to the next potential customer on the waitlist.
   *
   * Default: `10` minutes
   * Min: `1` minute
   */
  reservationTimeInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsV1WaitlistPolicyInput = {
  /**
   * Number of spots in the waitlist.
   *
   * Default: `10` spots
   * Min: `1` spot
   */
  capacity?: InputMaybe<Scalars['Int']>;
  /**
   * Whether the service has a waitlist. `true` means there's a waitlist.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Time in minutes the potential customer is given to book after they've been
   * notified that a spot has opened up for them. If they don't respond in time,
   * the open spot is offered to the next potential customer on the waitlist.
   *
   * Default: `10` minutes
   * Min: `1` minute
   */
  reservationTimeInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixCalendarEventsV3BulkCancelEventRequestInput = {
  /** IDs of the events to cancel. */
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Information about whether participants of the canceled events are notified and
   * the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Whether to return the canceled events.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3BulkCancelEventResponse = {
  __typename?: 'WixCalendarEventsV3BulkCancelEventResponse';
  /** Total successes and failures. */
  bulkActionMetadata?: Maybe<WixCalendarEventsV3UpstreamWixCommonBulkActionMetadata>;
  /** The result for each event, containing the event and whether the action was successful. */
  results?: Maybe<Array<Maybe<WixCalendarEventsV3BulkEventResult>>>;
};

export type WixCalendarEventsV3BulkCreateEventRequestInput = {
  /** Events to create. */
  events?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3BulkCreateEventRequestMaskedEventInput>>>;
  /**
   * Whether to return created events.
   *
   * Default: `false`.
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3BulkCreateEventRequestMaskedEventInput = {
  /** Event to create. */
  event?: InputMaybe<WixCalendarEventsV3EventInput>;
  /**
   * Optional list of fields to create or override.
   *
   * For example, to set empty values for fields that would otherwise be inherited from the schedule.
   */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCalendarEventsV3BulkCreateEventResponse = {
  __typename?: 'WixCalendarEventsV3BulkCreateEventResponse';
  /** Total successes and failures. */
  bulkActionMetadata?: Maybe<WixCalendarEventsV3UpstreamWixCommonBulkActionMetadata>;
  /** The result for each event, containing the event and whether the action was successful. */
  results?: Maybe<Array<Maybe<WixCalendarEventsV3BulkEventResult>>>;
};

export type WixCalendarEventsV3BulkEventResult = {
  __typename?: 'WixCalendarEventsV3BulkEventResult';
  /** The event. */
  item?: Maybe<WixCalendarEventsV3Event>;
  /** Whether the requested action was successful. */
  itemMetadata?: Maybe<WixCalendarEventsV3UpstreamWixCommonItemMetadata>;
};

export type WixCalendarEventsV3BulkUpdateEventRequestInput = {
  /**
   * Events to update.
   *
   * Min: 1 event
   * Max: 50 events
   */
  events?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3BulkUpdateEventRequestMaskedEventInput>>>;
  /**
   * Information about whether participants of the updated event are notified and
   * the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Whether to return the updated events.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3BulkUpdateEventRequestMaskedEventInput = {
  /** Event to update. */
  event?: InputMaybe<WixCalendarEventsV3EventInput>;
  /**
   * Optional list of fields to update or override.
   *
   * For example, to set empty values for fields that would otherwise be inherited from the schedule.
   */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCalendarEventsV3BulkUpdateEventResponse = {
  __typename?: 'WixCalendarEventsV3BulkUpdateEventResponse';
  /** Total successes and failures. */
  bulkActionMetadata?: Maybe<WixCalendarEventsV3UpstreamWixCommonBulkActionMetadata>;
  /** The result for each event, containing the event and whether the action was successful. */
  results?: Maybe<Array<Maybe<WixCalendarEventsV3BulkEventResult>>>;
};

export type WixCalendarEventsV3CancelEventRequestInput = {
  /** ID of the event to cancel. */
  eventId?: InputMaybe<Scalars['String']>;
  /**
   * Information about whether participants of the canceled event are notified and
   * the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3CancelEventResponse = {
  __typename?: 'WixCalendarEventsV3CancelEventResponse';
  /** Canceled event. */
  event?: Maybe<WixCalendarEventsV3Event>;
};

export type WixCalendarEventsV3CreateEventRequestInput = {
  /** Event to create. */
  event?: InputMaybe<WixCalendarEventsV3EventInput>;
  /**
   * Optional list of fields to create or override.
   *
   * For example, to set empty values for fields that would otherwise be inherited from the schedule.
   */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Idempotency key guaranteeing that you don't create the same event more
   * than once.
   */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3CreateEventResponse = {
  __typename?: 'WixCalendarEventsV3CreateEventResponse';
  /** Created event. */
  event?: Maybe<WixCalendarEventsV3Event>;
};

export type WixCalendarEventsV3Event = {
  __typename?: 'WixCalendarEventsV3Event';
  /**
   * Information about when the event ends adjusted to the `timeZone` of the
   * business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedEnd?: Maybe<WixCalendarEventsV3ZonedDate>;
  /**
   * Information about when the event starts adjusted to the `timeZone` of the
   * business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedStart?: Maybe<WixCalendarEventsV3ZonedDate>;
  /**
   * ID of the app that owns the event. Identical to `appId` of the
   * [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object)
   * to which the event belongs.
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * Information about the event's online conferencing.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   *
   * Default: `defaultConferencingDetails` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  conferencingDetails?: Maybe<WixCalendarSchedulesV3ConferencingDetails>;
  /** Date the event was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: Maybe<Scalars['String']>;
  /**
   * Information about when the event ends.
   *
   * Maximum allowed date: Year 2100, or up to 100 years from the event's start date (whichever comes first).
   */
  end?: Maybe<WixCalendarEventsV3ZonedDate>;
  /** Extensions enabling applications or users to save custom data related to the event. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /**
   * ID of the external schedule the event belongs to.
   *
   * For example, if the event belongs to a Bookings staff member, identical to
   * the ID of the [resource](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object).
   * If the schedule belongs to a Bookings service,
   * identical to the ID of the [service](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/service-object).
   */
  externalScheduleId?: Maybe<Scalars['String']>;
  /** Event ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * List of fields whose values are inherited.
   * + For single-occurrence events, values are inherited from the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object).
   * + For `INSTANCE` and `EXCEPTION` events, values are inherited from the related `MASTER` event.
   */
  inheritedFields?: Maybe<Array<Maybe<WixCalendarEventsV3FieldEnumField>>>;
  /**
   * Event location.
   *
   * Default: `defaultLocation` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  location?: Maybe<WixCalendarSchedulesV3Location>;
  /**
   * Additional notes about the event.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   *
   * Min: 1 character
   * Max: 5000 characters
   */
  notes?: Maybe<Scalars['String']>;
  /**
   * Information about the event's participants.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   */
  participants?: Maybe<WixCalendarEventsV3Participants>;
  /**
   * List of permissions associated with the event. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   */
  permissions?: Maybe<Array<Maybe<WixCalendarSchedulesV3Permission>>>;
  /**
   * Recurrence pattern for a series of events. This field is required when
   * creating a `MASTER` event and isn't available for non-recurring events.
   * You can't update the recurrence rule for `INSTANCE` or `EXCEPTION` events.
   *
   * For example, an event that repeats every second Monday until January 7, 2026,
   * at 8:00 AM has the following `recurrenceRule`:
   * - `frequency = WEEKLY`
   * - `interval = 2`
   * - `days = [MONDAY]`
   * - `until = 20260107T08:00:00Z`
   */
  recurrenceRule?: Maybe<WixCalendarEventsV3RecurrenceRule>;
  /**
   * Information about whether the event is a single occurrence or part of a
   * recurring series.
   *
   * Supported values:
   * + `NONE`: The event occurs only once and doesn't repeat.
   * + `MASTER`: Defines the recurrence pattern for a series of recurring events.
   * + `INSTANCE`: A specific occurrence of a recurring event. You can't create an event with `{"recurrenceType": "INSTANCE"}`, instead it's automatically generated based on the recurrence rule. If you update an `INSTANCE` event, `recurrenceType` automatically changes to `EXCEPTION`.
   * + `EXCEPTION`: A modified instance of a recurring event that differs from the recurrence pattern. For example, an event with a different time or location. You can't create an `EXCEPTION` event directly, instead it's set automatically when you update an `INSTANCE` event.
   *
   * Default: `NONE`
   */
  recurrenceType?: Maybe<WixCalendarEventsV3RecurrenceTypeEnumRecurrenceType>;
  /**
   * ID of the `MASTER` event the event belongs to. Available only for `INSTANCE`
   * and `EXCEPTION` events.
   */
  recurringEventId?: Maybe<Scalars['String']>;
  /** Number of participants who can still be added to the event. */
  remainingCapacity?: Maybe<Scalars['Int']>;
  /**
   * List of [Wix Bookings resources](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object)
   * affected by the event. This could include, for example, the
   * [Wix Bookings staff member](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/staff-member-v1/staff-member-object)
   * providing the service or the room where the appointment takes place.
   *
   * Max: 100 resources
   */
  resources?: Maybe<Array<Maybe<WixCalendarEventsV3Resource>>>;
  /**
   * Revision number, which increments each time the event is updated.
   * To prevent conflicting changes, the current revision must be passed when updating the event.
   * Ignored when creating an event.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * ID of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object)
   * the event belongs to.
   * After creating an event, you can't assign it to a different schedule.
   */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
  /**
   * ID of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object)
   * the event belongs to.
   * After creating an event, you can't assign it to a different schedule.
   */
  scheduleId?: Maybe<Scalars['String']>;
  /** Schedule name. */
  scheduleName?: Maybe<Scalars['String']>;
  sessionsVirtualReference?: Maybe<ComWixBookingsCalendarApiV2QuerySessionsResponse>;
  /** Information about when the event starts. */
  start?: Maybe<WixCalendarEventsV3ZonedDate>;
  /**
   * Event status.
   *
   * Supported values:
   * + `CONFIRMED`: Event is scheduled to happen or has happened.
   * + `CANCELLED`: Event has been canceled.
   *
   * Default: `CONFIRMED`
   */
  status?: Maybe<WixCalendarEventsV3EventStatus>;
  /**
   * Time zone the event is associated with in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * Only regional time zones and UTC are supported.
   * For example, `America/New_York` or `UTC`.
   *
   * Default: `timeZone` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object).
   */
  timeZone?: Maybe<Scalars['String']>;
  /**
   * Event title.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  title?: Maybe<Scalars['String']>;
  /**
   * Maximum number of participants who can participate in the event.
   *
   * Default: `defaultCapacity` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  totalCapacity?: Maybe<Scalars['Int']>;
  /**
   * Specifies whether the event blocks time in the schedule it belongs to.
   *
   * Supported values:
   * + `OPAQUE`:  The schedule is blocked during the event, preventing other events that involve the same entities (for example, Booking staff members) from being scheduled at the same time.
   * + `TRANSPARENT`: The schedule remains open during the event, allowing other events to be scheduled concurrently.
   *
   * Default: `OPAQUE`
   */
  transparency?: Maybe<WixCalendarEventsV3Transparency>;
  /**
   * Event type. You can set the event type but you can't update it.
   *
   * Supported values:
   * + `DEFAULT`: A standard event that's not further specified.
   * + `WORKING_HOURS`: The event adds working hours to a schedule. By default not returned in [Query Events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/query-events).
   *
   * Additional supported values, if Wix Bookings is installed:
   * + `APPOINTMENT`: Bookings appointment event.
   * + `CLASS`: Bookings class event.
   * + `COURSE`: Bookings course event.
   */
  type?: Maybe<Scalars['String']>;
  /** Date the event was last updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixCalendarEventsV3EventSessionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixBookingsCalendarApiV2QuerySessionsRequestInput>;
};

export type WixCalendarEventsV3EventInput = {
  /**
   * Information about when the event ends adjusted to the `timeZone` of the
   * business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedEnd?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
  /**
   * Information about when the event starts adjusted to the `timeZone` of the
   * business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedStart?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
  /**
   * ID of the app that owns the event. Identical to `appId` of the
   * [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object)
   * to which the event belongs.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Information about the event's online conferencing.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   *
   * Default: `defaultConferencingDetails` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  conferencingDetails?: InputMaybe<WixCalendarSchedulesV3ConferencingDetailsInput>;
  /** Date the event was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /**
   * Information about when the event ends.
   *
   * Maximum allowed date: Year 2100, or up to 100 years from the event's start date (whichever comes first).
   */
  end?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
  /** Extensions enabling applications or users to save custom data related to the event. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /**
   * ID of the external schedule the event belongs to.
   *
   * For example, if the event belongs to a Bookings staff member, identical to
   * the ID of the [resource](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object).
   * If the schedule belongs to a Bookings service,
   * identical to the ID of the [service](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/service-object).
   */
  externalScheduleId?: InputMaybe<Scalars['String']>;
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * List of fields whose values are inherited.
   * + For single-occurrence events, values are inherited from the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object).
   * + For `INSTANCE` and `EXCEPTION` events, values are inherited from the related `MASTER` event.
   */
  inheritedFields?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3FieldEnumField>>>;
  /**
   * Event location.
   *
   * Default: `defaultLocation` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  location?: InputMaybe<WixCalendarSchedulesV3LocationInput>;
  /**
   * Additional notes about the event.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   *
   * Min: 1 character
   * Max: 5000 characters
   */
  notes?: InputMaybe<Scalars['String']>;
  /**
   * Information about the event's participants.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   */
  participants?: InputMaybe<WixCalendarEventsV3ParticipantsInput>;
  /**
   * List of permissions associated with the event. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   */
  permissions?: InputMaybe<Array<InputMaybe<WixCalendarSchedulesV3PermissionInput>>>;
  /**
   * Recurrence pattern for a series of events. This field is required when
   * creating a `MASTER` event and isn't available for non-recurring events.
   * You can't update the recurrence rule for `INSTANCE` or `EXCEPTION` events.
   *
   * For example, an event that repeats every second Monday until January 7, 2026,
   * at 8:00 AM has the following `recurrenceRule`:
   * - `frequency = WEEKLY`
   * - `interval = 2`
   * - `days = [MONDAY]`
   * - `until = 20260107T08:00:00Z`
   */
  recurrenceRule?: InputMaybe<WixCalendarEventsV3RecurrenceRuleInput>;
  /**
   * Information about whether the event is a single occurrence or part of a
   * recurring series.
   *
   * Supported values:
   * + `NONE`: The event occurs only once and doesn't repeat.
   * + `MASTER`: Defines the recurrence pattern for a series of recurring events.
   * + `INSTANCE`: A specific occurrence of a recurring event. You can't create an event with `{"recurrenceType": "INSTANCE"}`, instead it's automatically generated based on the recurrence rule. If you update an `INSTANCE` event, `recurrenceType` automatically changes to `EXCEPTION`.
   * + `EXCEPTION`: A modified instance of a recurring event that differs from the recurrence pattern. For example, an event with a different time or location. You can't create an `EXCEPTION` event directly, instead it's set automatically when you update an `INSTANCE` event.
   *
   * Default: `NONE`
   */
  recurrenceType?: InputMaybe<WixCalendarEventsV3RecurrenceTypeEnumRecurrenceType>;
  /**
   * ID of the `MASTER` event the event belongs to. Available only for `INSTANCE`
   * and `EXCEPTION` events.
   */
  recurringEventId?: InputMaybe<Scalars['String']>;
  /** Number of participants who can still be added to the event. */
  remainingCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * List of [Wix Bookings resources](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object)
   * affected by the event. This could include, for example, the
   * [Wix Bookings staff member](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/staff-member-v1/staff-member-object)
   * providing the service or the room where the appointment takes place.
   *
   * Max: 100 resources
   */
  resources?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3ResourceInput>>>;
  /**
   * Revision number, which increments each time the event is updated.
   * To prevent conflicting changes, the current revision must be passed when updating the event.
   * Ignored when creating an event.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * ID of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object)
   * the event belongs to.
   * After creating an event, you can't assign it to a different schedule.
   */
  scheduleId?: InputMaybe<Scalars['String']>;
  /** Schedule name. */
  scheduleName?: InputMaybe<Scalars['String']>;
  /** Information about when the event starts. */
  start?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
  /**
   * Event status.
   *
   * Supported values:
   * + `CONFIRMED`: Event is scheduled to happen or has happened.
   * + `CANCELLED`: Event has been canceled.
   *
   * Default: `CONFIRMED`
   */
  status?: InputMaybe<WixCalendarEventsV3EventStatus>;
  /**
   * Time zone the event is associated with in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * Only regional time zones and UTC are supported.
   * For example, `America/New_York` or `UTC`.
   *
   * Default: `timeZone` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object).
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * Event title.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  title?: InputMaybe<Scalars['String']>;
  /**
   * Maximum number of participants who can participate in the event.
   *
   * Default: `defaultCapacity` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  totalCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * Specifies whether the event blocks time in the schedule it belongs to.
   *
   * Supported values:
   * + `OPAQUE`:  The schedule is blocked during the event, preventing other events that involve the same entities (for example, Booking staff members) from being scheduled at the same time.
   * + `TRANSPARENT`: The schedule remains open during the event, allowing other events to be scheduled concurrently.
   *
   * Default: `OPAQUE`
   */
  transparency?: InputMaybe<WixCalendarEventsV3Transparency>;
  /**
   * Event type. You can set the event type but you can't update it.
   *
   * Supported values:
   * + `DEFAULT`: A standard event that's not further specified.
   * + `WORKING_HOURS`: The event adds working hours to a schedule. By default not returned in [Query Events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/query-events).
   *
   * Additional supported values, if Wix Bookings is installed:
   * + `APPOINTMENT`: Bookings appointment event.
   * + `CLASS`: Bookings class event.
   * + `COURSE`: Bookings course event.
   */
  type?: InputMaybe<Scalars['String']>;
  /** Date the event was last updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixCalendarEventsV3EventStatus {
  /** Event has been canceled. */
  Cancelled = 'CANCELLED',
  /** Event is scheduled to happen or has happened. */
  Confirmed = 'CONFIRMED',
  /** DEPRECATED! AND WILL BE REMOVED SOON */
  PendingConfirmation = 'PENDING_CONFIRMATION',
  UnknownStatus = 'UNKNOWN_STATUS'
}

export enum WixCalendarEventsV3FieldEnumField {
  /** `capacity` is inherited from the schedule or `MASTER` event. */
  Capacity = 'CAPACITY',
  /** `conferencingDetails` is inherited from the schedule or `MASTER` event. */
  ConferencingDetails = 'CONFERENCING_DETAILS',
  /** `location` is inherited from the schedule or `MASTER` event. */
  Location = 'LOCATION',
  /** `participants` is inherited from the `MASTER` event. */
  Participants = 'PARTICIPANTS',
  /** `resources` is inherited from the `MASTER` event. */
  Resources = 'RESOURCES',
  /** `start` and `end` are inherited from the `MASTER` event. */
  Time = 'TIME',
  /** `timeZone` is inherited from the schedule or `MASTER` event. */
  TimeZone = 'TIME_ZONE',
  /** `title` is inherited from the schedule or `MASTER` event. */
  Title = 'TITLE',
  UnknownField = 'UNKNOWN_FIELD'
}

export type WixCalendarEventsV3GetEventRequestInput = {
  /**
   * Whether to return consistent response.
   * Please consult with us at #bookings-calendar-platform if you think your case requires consistent reads.
   */
  consistent?: InputMaybe<Scalars['Boolean']>;
  /**
   * Information about which fields containing personal data to return. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions)
   * for more information.
   *
   * Supported values:
   * + `PI_FIELDS`: Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope.
   * + `OWN_PI_FIELDS`: Returns only fields containing your own personal data.
   *
   * Max: 1 field
   * Default: No personal data is returned.
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3RequestedFieldsEnumRequestedFields>>>;
  id: Scalars['ID'];
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3ListEventsRequestInput = {
  /**
   * Whether to return consistent response.
   * Please consult with us at #bookings-calendar-platform if you think your case requires consistent reads.
   */
  consistent?: InputMaybe<Scalars['Boolean']>;
  /**
   * IDs of the events to retrieve.
   *
   * Min: 1 event ID
   * Min: 100 event IDs
   */
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Information about which fields containing personal data to return. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions)
   * for more information.
   *
   * Supported values:
   * + `PI_FIELDS`: Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope.
   * + `OWN_PI_FIELDS`: Returns only fields containing your own personal data.
   *
   * Max: 1 field
   * Default: No personal data is returned.
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3RequestedFieldsEnumRequestedFields>>>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3ListEventsResponse = {
  __typename?: 'WixCalendarEventsV3ListEventsResponse';
  /** Retrieved events matching the provided IDs. */
  events?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
};

export type WixCalendarEventsV3ListRecurringEventInstancesHistoryRequestInput = {
  /** Optional cursor pointing to the next page of events. */
  cursorPaging?: InputMaybe<WixCalendarEventsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Inclusive start date for which events are returned, in ISO-8601 format.
   * Events that begin at or after the `fromDate` are included in the results.
   * Required, unless `cursorPaging` is provided.
   */
  fromDate?: InputMaybe<Scalars['String']>;
  /**
   * The ID of the recurring event.
   * Required, unless `cursorPaging` is provided.
   */
  recurringEventId?: InputMaybe<Scalars['String']>;
  /**
   * The revision of the recurring event.
   * Required, unless `cursorPaging` is provided.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Exclusive end date for which events are returned, in ISO-8601 format.
   * Events that begin before the `toDate` are included in the results.
   * Required, unless `cursorPaging` is provided.
   */
  toDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3ListRecurringEventInstancesHistoryResponse = {
  __typename?: 'WixCalendarEventsV3ListRecurringEventInstancesHistoryResponse';
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCalendarEventsV3UpstreamWixCommonCursorPagingMetadata>;
  /** The recurring event instances. */
  recurringEventInstances?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
};

export type WixCalendarEventsV3Participant = {
  __typename?: 'WixCalendarEventsV3Participant';
  /**
   * [Contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/contact-object)
   * ID of the participant.
   */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /**
   * [Contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/contact-object)
   * ID of the participant.
   */
  contactId?: Maybe<Scalars['String']>;
  /** Participant's email address. */
  email?: Maybe<Scalars['String']>;
  /**
   * Participant name.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  name?: Maybe<Scalars['String']>;
  /** Participant's phone number. */
  phone?: Maybe<Scalars['String']>;
};

export type WixCalendarEventsV3ParticipantInput = {
  /**
   * [Contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/contact-object)
   * ID of the participant.
   */
  contactId?: InputMaybe<Scalars['String']>;
  /** Participant's email address. */
  email?: InputMaybe<Scalars['String']>;
  /**
   * Participant name.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  name?: InputMaybe<Scalars['String']>;
  /** Participant's phone number. */
  phone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3Participants = {
  __typename?: 'WixCalendarEventsV3Participants';
  /**
   * Whether there are more participants for the event than listed.
   *
   * + `false`: The list includes all participants.
   * + `true`: The list doesn't include all participants.
   */
  hasMore?: Maybe<Scalars['Boolean']>;
  /**
   * Full or partial list of the participants.
   *
   * Max: 50 participants
   */
  list?: Maybe<Array<Maybe<WixCalendarEventsV3Participant>>>;
  /**
   * Participant's status.
   *
   * Supported values:
   * + `CONFIRMED`: All participants are confirmed.
   * + `PENDING_CONFIRMATION`: At least one participant isn't confirmed yet.
   */
  status?: Maybe<WixCalendarEventsV3ParticipantsStatus>;
  /**
   * Total number of participants.
   *
   * Min: `0`
   */
  total?: Maybe<Scalars['Int']>;
};

export type WixCalendarEventsV3ParticipantsInput = {
  /**
   * Whether there are more participants for the event than listed.
   *
   * + `false`: The list includes all participants.
   * + `true`: The list doesn't include all participants.
   */
  hasMore?: InputMaybe<Scalars['Boolean']>;
  /**
   * Full or partial list of the participants.
   *
   * Max: 50 participants
   */
  list?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3ParticipantInput>>>;
  /**
   * Participant's status.
   *
   * Supported values:
   * + `CONFIRMED`: All participants are confirmed.
   * + `PENDING_CONFIRMATION`: At least one participant isn't confirmed yet.
   */
  status?: InputMaybe<WixCalendarEventsV3ParticipantsStatus>;
  /**
   * Total number of participants.
   *
   * Min: `0`
   */
  total?: InputMaybe<Scalars['Int']>;
};

export enum WixCalendarEventsV3ParticipantsStatus {
  /** All participants are confirmed. */
  Confirmed = 'CONFIRMED',
  /** At least one participant isn't confirmed yet. */
  PendingConfirmation = 'PENDING_CONFIRMATION',
  UnknownStatus = 'UNKNOWN_STATUS'
}

export type WixCalendarEventsV3QueryEventsRequestInput = {
  /**
   * Whether to return consistent response.
   * Please consult with us at #bookings-calendar-platform if you think your case requires consistent reads.
   */
  consistent?: InputMaybe<Scalars['Boolean']>;
  /**
   * Information about which fields containing personal data to return. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions)
   * for more information.
   *
   * Supported values:
   * + `PI_FIELDS`: Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope.
   * + `OWN_PI_FIELDS`: Returns only fields containing your own personal data.
   *
   * Max: 1 field
   * Default: No personal data is returned.
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3RequestedFieldsEnumRequestedFields>>>;
  /**
   * Local start date and time from which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`.
   *
   * Events that start before the `fromLocalDate` but end after it are included in
   * the results. Must be earlier than `toLocalDate` unless the sort order is
   * descending.
   */
  fromLocalDate?: InputMaybe<Scalars['String']>;
  /** Query containing filters and paging. */
  query?: InputMaybe<WixCalendarEventsV3UpstreamWixCommonCursorQueryInput>;
  /**
   * Filters events based on their `recurrenceType`.
   *
   * Max: 5 recurrence types can be specified.
   * Default: Events with `recurrenceType` of `NONE`, `INSTANCE`, and `EXCEPTION` are returned.
   */
  recurrenceType?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3RecurrenceTypeEnumRecurrenceType>>>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for `fromLocalDate`, `toLocalDate`, and for calculating `adjustedStart` and
   * `adjustedEnd`. For example, `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * Local end date and time up to which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`.
   *
   * Events that start before `toLocalDate` but end after it are included in the
   * results. Must be later than `fromLocalDate` unless the sort order is
   * descending.
   */
  toLocalDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3QueryEventsResponse = {
  __typename?: 'WixCalendarEventsV3QueryEventsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixCalendarEventsV3RecurrenceEnumRecurrence {
  /** The event is an exceptional instance of a recurring event. Read only. */
  Exception = 'EXCEPTION',
  /** The event is an instance of a recurring event. Read only. */
  Instance = 'INSTANCE',
  /** The event is the recurrence master defining the recurrence rule, which is the repeat pattern for the events. */
  Master = 'MASTER',
  /** No recurrence, i.e the event is a single event instance. Default. */
  None = 'NONE',
  UnknownRecurrence = 'UNKNOWN_RECURRENCE'
}

export type WixCalendarEventsV3RecurrenceRule = {
  __typename?: 'WixCalendarEventsV3RecurrenceRule';
  /**
   * Date until when the event repeats
   * adjusted to the `timeZone` of the business
   * [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedUntil?: Maybe<WixCalendarEventsV3ZonedDate>;
  /**
   * Days of the week when the recurring event takes place.
   * Currently, only a single day is supported.
   *
   * Min: 1 day
   * Max: 1 day
   */
  days?: Maybe<Array<Maybe<WixCalendarEventsV3RecurrenceRuleDay>>>;
  /**
   * Frequency how often the event repeats. Works together with `interval`.
   *
   * Supported values:
   * + `WEEKLY`: The event's recurrence pattern is based on weeks.
   */
  frequency?: Maybe<WixCalendarEventsV3RecurrenceRuleFrequency>;
  /**
   * Interval how often the event repeats. Works together with `frequency`.
   * For example, `frequency` set to `WEEKLY`  and `interval` set to `2` means
   * the event repeats every 2 weeks.
   *
   * Min: `1`
   * Max: `4`
   * Default: `1`
   */
  interval?: Maybe<Scalars['Int']>;
  /**
   * Date until when the event repeats.
   * If not specified, the event repeats forever.
   */
  until?: Maybe<WixCalendarEventsV3ZonedDate>;
};

export enum WixCalendarEventsV3RecurrenceRuleDay {
  /** The recurring event takes place on Fridays. */
  Friday = 'FRIDAY',
  /** The recurring event takes place on Mondays. */
  Monday = 'MONDAY',
  /** The recurring event takes place on Saturdays. */
  Saturday = 'SATURDAY',
  /** The recurring event takes place on Sundays. */
  Sunday = 'SUNDAY',
  /** The recurring event takes place on Thursdays. */
  Thursday = 'THURSDAY',
  /** The recurring event takes place on Tuesdays. */
  Tuesday = 'TUESDAY',
  /** The recurring event takes place on Wednesday. */
  Wednesday = 'WEDNESDAY'
}

export enum WixCalendarEventsV3RecurrenceRuleFrequency {
  UnknownFrequency = 'UNKNOWN_FREQUENCY',
  /** The event's recurrence pattern is based on weeks. */
  Weekly = 'WEEKLY'
}

export type WixCalendarEventsV3RecurrenceRuleInput = {
  /**
   * Date until when the event repeats
   * adjusted to the `timeZone` of the business
   * [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedUntil?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
  /**
   * Days of the week when the recurring event takes place.
   * Currently, only a single day is supported.
   *
   * Min: 1 day
   * Max: 1 day
   */
  days?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3RecurrenceRuleDay>>>;
  /**
   * Frequency how often the event repeats. Works together with `interval`.
   *
   * Supported values:
   * + `WEEKLY`: The event's recurrence pattern is based on weeks.
   */
  frequency?: InputMaybe<WixCalendarEventsV3RecurrenceRuleFrequency>;
  /**
   * Interval how often the event repeats. Works together with `frequency`.
   * For example, `frequency` set to `WEEKLY`  and `interval` set to `2` means
   * the event repeats every 2 weeks.
   *
   * Min: `1`
   * Max: `4`
   * Default: `1`
   */
  interval?: InputMaybe<Scalars['Int']>;
  /**
   * Date until when the event repeats.
   * If not specified, the event repeats forever.
   */
  until?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
};

export enum WixCalendarEventsV3RecurrenceTypeEnumRecurrenceType {
  /** A modified instance of a recurring event that differs from the recurrence pattern. For example, an event with a different time or location. You can't create an `EXCEPTION` event directly, instead it's set automatically when you update an `INSTANCE` event. */
  Exception = 'EXCEPTION',
  /** A specific occurrence of a recurring event. You can't create an event with `{"recurrenceType": "INSTANCE"}`, instead it's automatically generated based on the recurrence rule. If you update an `INSTANCE` event, `recurrenceType` automatically changes to `EXCEPTION`. */
  Instance = 'INSTANCE',
  /** Defines the recurrence pattern for a series of recurring events. */
  Master = 'MASTER',
  /** The event occurs only once and doesn't repeat. */
  None = 'NONE',
  UnknownRecurrenceType = 'UNKNOWN_RECURRENCE_TYPE'
}

export enum WixCalendarEventsV3RequestedFieldsEnumRequestedFields {
  /** Returns only fields containing your own personal data. */
  OwnPiFields = 'OWN_PI_FIELDS',
  /** Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope. */
  PiFields = 'PI_FIELDS',
  UnknownRequestedFields = 'UNKNOWN_REQUESTED_FIELDS'
}

export type WixCalendarEventsV3Resource = {
  __typename?: 'WixCalendarEventsV3Resource';
  /** Resource ID. */
  id?: Maybe<Scalars['String']>;
  /** Resource name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Permission role associated with the resource. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   */
  permissionRole?: Maybe<WixCalendarSchedulesV3PermissionRole>;
  /** ID of the resource's [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object). */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
  /** ID of the resource's [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object). */
  scheduleId?: Maybe<Scalars['String']>;
  /**
   * Specifies whether the event blocks time in the resource's schedule.
   *
   * Supported values:
   * + `OPAQUE`: The schedule is blocked during the event, preventing other events that involve the same resource from being scheduled at the same time.
   * + `TRANSPARENT`: The schedule remains open during the event, allowing other events to be scheduled concurrently.
   *
   * Default: `OPAQUE`.
   */
  transparency?: Maybe<WixCalendarEventsV3Transparency>;
  /** Resource type. */
  type?: Maybe<Scalars['String']>;
};

export type WixCalendarEventsV3ResourceInput = {
  /** Resource ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Resource name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Permission role associated with the resource. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   */
  permissionRole?: InputMaybe<WixCalendarSchedulesV3PermissionRole>;
  /** ID of the resource's [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object). */
  scheduleId?: InputMaybe<Scalars['String']>;
  /**
   * Specifies whether the event blocks time in the resource's schedule.
   *
   * Supported values:
   * + `OPAQUE`: The schedule is blocked during the event, preventing other events that involve the same resource from being scheduled at the same time.
   * + `TRANSPARENT`: The schedule remains open during the event, allowing other events to be scheduled concurrently.
   *
   * Default: `OPAQUE`.
   */
  transparency?: InputMaybe<WixCalendarEventsV3Transparency>;
  /** Resource type. */
  type?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3RestoreEventDefaultsRequestInput = {
  /** ID of the event for which to restore default values. */
  eventId?: InputMaybe<Scalars['String']>;
  /**
   * Fields for which to restore default values.
   *
   * `TIME` restores default values for `start` and `end`.
   *
   * Min: 1 field
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3FieldEnumField>>>;
  /**
   * Information about whether participants of the updated event are notified and
   * the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3RestoreEventDefaultsResponse = {
  __typename?: 'WixCalendarEventsV3RestoreEventDefaultsResponse';
  /** Updated event. */
  event?: Maybe<WixCalendarEventsV3Event>;
};

export type WixCalendarEventsV3SplitRecurringEventRequestInput = {
  /** ID of the `MASTER` event to split. */
  recurringEventId?: InputMaybe<Scalars['String']>;
  /**
   * Local date and time at which the `MASTER` event is split in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2025-03-11T09:00:00`.
   * Must be a future date that's after the `start` date of the next `INSTANCE` or
   * `EXCEPTION` event in the series. Additionally, there must be another
   * `INSTANCE` or `EXCEPTION` event following this next event, as the changes
   * wouldn't affect any event without a subsequent occurrence.
   */
  splitLocalDate?: InputMaybe<Scalars['String']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3SplitRecurringEventResponse = {
  __typename?: 'WixCalendarEventsV3SplitRecurringEventResponse';
  /** New `MASTER` event starting with the first event after the split date. */
  newRecurringEventStartingFromSplit?: Maybe<WixCalendarEventsV3Event>;
  /** Original `MASTER` event that was shortened. */
  updatedRecurringEventEndingBeforeSplit?: Maybe<WixCalendarEventsV3Event>;
};

export enum WixCalendarEventsV3Transparency {
  /** The schedule is blocked during the event, preventing other events that involve the same entities (for example, Booking staff members) from being scheduled at the same time. */
  Opaque = 'OPAQUE',
  /** The schedule remains open during the event, allowing other events to be scheduled concurrently. */
  Transparent = 'TRANSPARENT',
  UnknownTransparency = 'UNKNOWN_TRANSPARENCY'
}

export type WixCalendarEventsV3UpdateEventParticipantsRequestInput = {
  /**
   * ID of the event to update.
   *
   * Min: 36 characters
   * Max: 250 characters
   */
  eventId?: InputMaybe<Scalars['String']>;
  /** The participants to update. */
  participants?: InputMaybe<WixCalendarEventsV3ParticipantsInput>;
};

export type WixCalendarEventsV3UpdateEventParticipantsResponse = {
  __typename?: 'WixCalendarEventsV3UpdateEventParticipantsResponse';
  /** Updated event. */
  event?: Maybe<WixCalendarEventsV3Event>;
};

export type WixCalendarEventsV3UpdateEventRequestInput = {
  /** Event to update. */
  event?: InputMaybe<WixCalendarEventsV3EventInput>;
  /**
   * Optional list of fields to update or override.
   *
   * For example, to set empty values for fields that would otherwise be inherited from the schedule.
   */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Information about whether participants of the updated event are notified and
   * the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3UpdateEventResponse = {
  __typename?: 'WixCalendarEventsV3UpdateEventResponse';
  /** Updated event. */
  event?: Maybe<WixCalendarEventsV3Event>;
};

export type WixCalendarEventsV3UpstreamWixCommonBulkActionMetadata = {
  __typename?: 'WixCalendarEventsV3UpstreamWixCommonBulkActionMetadata';
  /** Number of events that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of events that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
};

export type WixCalendarEventsV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of events to return.
   * Defaults to `50`. Maximum `1000`.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixCalendarEventsV3UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'WixCalendarEventsV3UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Use these cursor to paginate between results. [Read more](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_cursor-paging). */
  cursors?: Maybe<WixCalendarEventsV3UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixCalendarEventsV3UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter`. */
  cursorPaging?: InputMaybe<WixCalendarEventsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * for more information.
   *
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`.
   *
   * For a detailed list of supported filters, see Supported Filters.
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to sort events by their start date in ascending order or by their end date in descending order.
   * Default is start ascending.
   */
  sort?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3UpstreamWixCommonSortingInput>>>;
};

export type WixCalendarEventsV3UpstreamWixCommonCursors = {
  __typename?: 'WixCalendarEventsV3UpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
};

export type WixCalendarEventsV3UpstreamWixCommonItemMetadata = {
  __typename?: 'WixCalendarEventsV3UpstreamWixCommonItemMetadata';
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /**
   * Event ID.
   * Should always be available, unless it's impossible (for example, when failing to create an event).
   */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array, for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /**
   * Whether the requested action was successful for this event.
   * When `false`, the `error` field is populated.
   */
  success?: Maybe<Scalars['Boolean']>;
};

export enum WixCalendarEventsV3UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixCalendarEventsV3UpstreamWixCommonSortingInput = {
  /**
   * The field to sort by.
   * Either `start` or `end`.
   * Default is `start`.
   */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixCalendarEventsV3UpstreamWixCommonSortOrder>;
};

export type WixCalendarEventsV3ZonedDate = {
  __typename?: 'WixCalendarEventsV3ZonedDate';
  /**
   * Local date time in [ISO-8601 format](https://en.wikipedia.org/wiki/ISO_8601).
   * For example, `2024-01-30T13:30:00`.
   * Wix Calendar APIs ignore seconds.
   */
  localDate?: Maybe<Scalars['String']>;
  /**
   * Time zone in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * For example, `America/New_York`.
   */
  timeZone?: Maybe<Scalars['String']>;
  /**
   * UTC date time in [ISO-8601 format](https://en.wikipedia.org/wiki/ISO_8601).
   * For example, `2024-01-30T13:30:00`.
   * Not available for adjusted date fields.
   */
  utcDate?: Maybe<Scalars['String']>;
};

export type WixCalendarEventsV3ZonedDateInput = {
  /**
   * Local date time in [ISO-8601 format](https://en.wikipedia.org/wiki/ISO_8601).
   * For example, `2024-01-30T13:30:00`.
   * Wix Calendar APIs ignore seconds.
   */
  localDate?: InputMaybe<Scalars['String']>;
  /**
   * Time zone in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * For example, `America/New_York`.
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * UTC date time in [ISO-8601 format](https://en.wikipedia.org/wiki/ISO_8601).
   * For example, `2024-01-30T13:30:00`.
   * Not available for adjusted date fields.
   */
  utcDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarMigrationV3DeleteTargetsRequestInput = {
  concurrencyLimit?: InputMaybe<Scalars['Int']>;
  deleteEvents?: InputMaybe<Scalars['Boolean']>;
  deleteParticipantEvents?: InputMaybe<Scalars['Boolean']>;
  deleteParticipations?: InputMaybe<Scalars['Boolean']>;
  deleteScheduleTimeframes?: InputMaybe<Scalars['Boolean']>;
  deleteSchedules?: InputMaybe<Scalars['Boolean']>;
  metaSiteIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCalendarMigrationV3FixSched38956RequestInput = {
  /**
   * Whether to run in safe, dry run mode, and only print logs without applying any changes.
   * Default to `true`!.
   */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixCalendarMigrationV3FixSched38956Response = {
  __typename?: 'WixCalendarMigrationV3FixSCHED38956Response';
  affectedEventCount?: Maybe<Scalars['Int']>;
  dryRun?: Maybe<Scalars['Boolean']>;
  fixedEventCount?: Maybe<Scalars['Int']>;
};

export type WixCalendarMigrationV3MigrateSiteRequestInput = {
  /**
   * Whether to run in safe, dry run mode, and only print logs without applying any changes.
   * Default to `true`.
   */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  metaSiteId?: InputMaybe<Scalars['String']>;
  /**
   * Whether to skip the migration if target data is already present.
   * Default to `true`.
   */
  skipIfTargetDataPresent?: InputMaybe<Scalars['Boolean']>;
};

export type WixCalendarMigrationV3MigrateSiteResponse = {
  __typename?: 'WixCalendarMigrationV3MigrateSiteResponse';
  dryRun?: Maybe<Scalars['Boolean']>;
  skipped?: Maybe<Scalars['Boolean']>;
};

export type WixCalendarParticipanteventsV3ListEventsByContactIdRequestInput = {
  /**
   * [App ID](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * to filter events by.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * ID of the [contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/contact-object)
   * to retrieve events for. Required, unless you provide `cursorPaging`.
   */
  contactId?: InputMaybe<Scalars['String']>;
  /** Cursor to retrieve the next page of the results. */
  cursorPaging?: InputMaybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Local start date and time from which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`. Required if `cursorPaging` isn't provided.
   *
   * Events that start before the `fromLocalDate` but end after it are included in
   * the results. Must be earlier than `toLocalDate`.
   */
  fromLocalDate?: InputMaybe<Scalars['String']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for `fromLocalDate`, `toLocalDate`, and for calculating `adjustedStart` and
   * `adjustedEnd`. For example, `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * Local end date and time up to which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`. Can't be more than a full year after
   * `2024-01-30T13:30:00`. Required if `cursorPaging` isn't provided.
   *
   * Events that start before `toLocalDate` but end after it are included in the
   * results. Must be later than `fromLocalDate`.
   */
  toLocalDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarParticipanteventsV3ListEventsByContactIdResponse = {
  __typename?: 'WixCalendarParticipanteventsV3ListEventsByContactIdResponse';
  /** Retrieved events. */
  events?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata>;
};

export type WixCalendarParticipanteventsV3ListEventsByMemberIdRequestInput = {
  /**
   * [App ID](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * to filter events by.
   */
  appId?: InputMaybe<Scalars['String']>;
  /** Cursor to retrieve the next page of the results. */
  cursorPaging?: InputMaybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * IDs of the events to retrieve.
   * If you provide a list of IDs, all other filters are ignored.
   *
   * Max: 100 `eventId`s
   */
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Local start date and time from which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`. Required if neither `cursorPaging` is provided nor a non-empty `eventIds` array.
   *
   * Events that start before the `fromLocalDate` but end after it are included in
   * the results. Must be earlier than `toLocalDate`.
   */
  fromLocalDate?: InputMaybe<Scalars['String']>;
  /**
   * ID of the [member](https://dev.wix.com/docs/rest/crm/members-contacts/members/members/member-object)
   * to retrieve events for. Required, unless you provide `cursorPaging`.
   * Provide `me` to retrieve events for the currently logged-in member.
   * You must have the `Read Calendars - Including PI`
   * [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/configure-permissions-for-your-app)
   * to retrieve events for members who aren't the currently logged in member.
   */
  memberId?: InputMaybe<Scalars['String']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for `fromLocalDate`, `toLocalDate`, and for calculating `adjustedStart` and
   * `adjustedEnd`. For example, `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * Local end date and time up to which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`. Can't be more than a full year after
   * `fromLocalDate`. Required if neither `cursorPaging` is provided nor a non-empty `eventIds` array.
   *
   * Events that start before `toLocalDate` but end after it are included in the
   * results. Must be later than `fromLocalDate`.
   */
  toLocalDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarParticipanteventsV3ListEventsByMemberIdResponse = {
  __typename?: 'WixCalendarParticipanteventsV3ListEventsByMemberIdResponse';
  /** Retrieved events. */
  events?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata>;
};

export type WixCalendarParticipanteventsV3ListParticipantEventsRequestInput = {
  /** Optional Wix app ID to filter events by. */
  appId?: InputMaybe<Scalars['String']>;
  /** The ID of the contact participating in the events. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Optional cursor to the next events page. */
  cursorPaging?: InputMaybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Local start date for which events are returned, in ISO-8601 format.
   * E.g, `2024-01-01T00:00:00`.
   *
   * Required, unless `cursorPaging` is provided.
   */
  fromLocalDate?: InputMaybe<Scalars['String']>;
  /**
   * The ID of the member participating in the events.
   * Can be `me` for the currently logged-in member ID.
   */
  memberId?: InputMaybe<Scalars['String']>;
  /**
   * The time zone, in IANA time zone format.
   * Default is the Wix Business time zone.
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * Local end date for which events are returned, in ISO-8601 format.
   * E.g, `2024-01-7T00:00:00`.
   *
   * Required, unless `cursorPaging` is provided.
   * Max: 1 year after `fromLocalDate`.
   */
  toLocalDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarParticipanteventsV3ListParticipantEventsResponse = {
  __typename?: 'WixCalendarParticipanteventsV3ListParticipantEventsResponse';
  /** The participant events. */
  events?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata>;
};

export type WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of events to return.
   * Defaults to `50`. Maximum `100`.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Use these cursor to paginate between results. [Read more](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_cursor-paging). */
  cursors?: Maybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixCalendarParticipanteventsV3UpstreamWixCommonCursors = {
  __typename?: 'WixCalendarParticipanteventsV3UpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
};

export type WixCalendarSchedulesV3CancelScheduleRequestInput = {
  /**
   * Information about whether participants of the schedule's updated events are
   * notified and the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Whether to preserve future events with participants.
   * Default: `false`.
   */
  preserveFutureEventsWithParticipants?: InputMaybe<Scalars['Boolean']>;
  /** ID of the schedule to cancel. */
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type WixCalendarSchedulesV3CancelScheduleResponse = {
  __typename?: 'WixCalendarSchedulesV3CancelScheduleResponse';
  /** Canceled schedule. */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
};

export type WixCalendarSchedulesV3CloneScheduleRequestInput = {
  /**
   * Optional fields to override.
   * For example, to set empty values for fields that would otherwise be cloned.
   */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Fields to override in the cloned schedule. */
  schedule?: InputMaybe<WixCalendarSchedulesV3ScheduleInput>;
  /** ID of the schedule to clone. */
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type WixCalendarSchedulesV3CloneScheduleResponse = {
  __typename?: 'WixCalendarSchedulesV3CloneScheduleResponse';
  /** Cloned schedule. */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
};

export enum WixCalendarSchedulesV3ConferenceType {
  Custom = 'CUSTOM',
  UnknownType = 'UNKNOWN_TYPE',
  Zoom = 'ZOOM'
}

export type WixCalendarSchedulesV3ConferencingDetails = {
  __typename?: 'WixCalendarSchedulesV3ConferencingDetails';
  /**
   * Conference description.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  description?: Maybe<Scalars['String']>;
  /**
   * Conference ID in an external system.
   *
   * Min: 1 character
   * Max: 150 characters
   */
  externalId?: Maybe<Scalars['String']>;
  /**
   * URL used by a guest to join the conference.
   *
   * Min: 1 character
   * Max: 2000 characters
   */
  guestUrl?: Maybe<Scalars['String']>;
  /**
   * URL used by the host to start the conference.
   *
   * Min: 1 character
   * Max: 2000 characters
   */
  hostUrl?: Maybe<Scalars['String']>;
  /**
   * Conference password.
   *
   * Min: 1 character
   * Max: 100 characters
   */
  password?: Maybe<Scalars['String']>;
  /** Conference type. For example, `Zoom`. */
  type?: Maybe<WixCalendarSchedulesV3ConferencingDetailsType>;
};

export type WixCalendarSchedulesV3ConferencingDetailsInput = {
  /**
   * Conference description.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Conference ID in an external system.
   *
   * Min: 1 character
   * Max: 150 characters
   */
  externalId?: InputMaybe<Scalars['String']>;
  /**
   * URL used by a guest to join the conference.
   *
   * Min: 1 character
   * Max: 2000 characters
   */
  guestUrl?: InputMaybe<Scalars['String']>;
  /**
   * URL used by the host to start the conference.
   *
   * Min: 1 character
   * Max: 2000 characters
   */
  hostUrl?: InputMaybe<Scalars['String']>;
  /**
   * Conference password.
   *
   * Min: 1 character
   * Max: 100 characters
   */
  password?: InputMaybe<Scalars['String']>;
  /** Conference type. For example, `Zoom`. */
  type?: InputMaybe<WixCalendarSchedulesV3ConferencingDetailsType>;
};

export enum WixCalendarSchedulesV3ConferencingDetailsType {
  Custom = 'CUSTOM',
  UnknownType = 'UNKNOWN_TYPE',
  Zoom = 'ZOOM'
}

export type WixCalendarSchedulesV3CreateScheduleRequestInput = {
  /**
   * Idempotency key guaranteeing that you don't create the same schedule more
   * than once.
   */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Schedule to create. */
  schedule?: InputMaybe<WixCalendarSchedulesV3ScheduleInput>;
};

export type WixCalendarSchedulesV3CreateScheduleResponse = {
  __typename?: 'WixCalendarSchedulesV3CreateScheduleResponse';
  /** Created schedule. */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
};

export type WixCalendarSchedulesV3GetScheduleRequestInput = {
  /**
   * Information about which fields containing personal data to return. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions)
   * for more information.
   *
   * Supported values:
   * + `PI_FIELDS`: Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope.
   * + `OWN_PI_FIELDS`: Returns only fields containing your own personal data.
   *
   * Max: 1 field
   * Default: No personal data is returned.
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarSchedulesV3RequestedFieldsEnumRequestedFields>>>;
  id: Scalars['ID'];
};

export type WixCalendarSchedulesV3Location = {
  __typename?: 'WixCalendarSchedulesV3Location';
  /**
   * Location address. For `BUSINESS` locations, it's identical to the
   * [location](https://dev.wix.com/docs/rest/business-management/locations/location-object)'s
   * `formattedAddress`.
   */
  address?: Maybe<Scalars['String']>;
  /**
   * [Location](https://dev.wix.com/docs/rest/business-management/locations/location-object)
   * ID. Available only for `BUSINESS` locations.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * [Location](https://dev.wix.com/docs/rest/business-management/locations/location-object)
   * ID. Available only for `BUSINESS` locations.
   */
  location?: Maybe<ComWixpressLocationsLocation>;
  /**
   * Location name. For `BUSINESS` locations, it's identical to the
   * [location](https://dev.wix.com/docs/rest/business-management/locations/location-object)
   * `name`.
   *
   * Min: 1 character
   * Max: 150 characters
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Location type.
   *
   * Supported values:
   * + `BUSINESS`: The event is held at a business location.
   * + `CUSTOMER`: The event is held at the customer's location, such as their home or office.
   * + `CUSTOM`: The event is held at an address or venue not tied to the business or customer.
   */
  type?: Maybe<WixCalendarSchedulesV3LocationType>;
};

export type WixCalendarSchedulesV3LocationInput = {
  /**
   * Location address. For `BUSINESS` locations, it's identical to the
   * [location](https://dev.wix.com/docs/rest/business-management/locations/location-object)'s
   * `formattedAddress`.
   */
  address?: InputMaybe<Scalars['String']>;
  /**
   * [Location](https://dev.wix.com/docs/rest/business-management/locations/location-object)
   * ID. Available only for `BUSINESS` locations.
   */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Location name. For `BUSINESS` locations, it's identical to the
   * [location](https://dev.wix.com/docs/rest/business-management/locations/location-object)
   * `name`.
   *
   * Min: 1 character
   * Max: 150 characters
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Location type.
   *
   * Supported values:
   * + `BUSINESS`: The event is held at a business location.
   * + `CUSTOMER`: The event is held at the customer's location, such as their home or office.
   * + `CUSTOM`: The event is held at an address or venue not tied to the business or customer.
   */
  type?: InputMaybe<WixCalendarSchedulesV3LocationType>;
};

export enum WixCalendarSchedulesV3LocationType {
  /** The event is held at a business location. */
  Business = 'BUSINESS',
  /** The event is held at an address or venue not tied to the business or customer. */
  Custom = 'CUSTOM',
  /** The event is held at the customer's location, such as their home or office. */
  Customer = 'CUSTOMER',
  UnknownType = 'UNKNOWN_TYPE'
}

export type WixCalendarSchedulesV3ParticipantNotificationInput = {
  /**
   * Message to send.
   *
   * Min: 1 character
   * Max: 5000 characters
   */
  message?: InputMaybe<Scalars['String']>;
  /**
   * Optional additional metadata.
   * Limits: max keys: `10`, max key length: `64`, max value length: `1000`.
   */
  metadata?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to notify the participants about changes made to the schedule or event.
   *
   * Default: `false`
   */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type WixCalendarSchedulesV3Permission = {
  __typename?: 'WixCalendarSchedulesV3Permission';
  /**
   * [Wix user](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities#wix-users)
   * granted the permission.
   */
  identity?: Maybe<WixCalendarSchedulesV3UpstreamWixCommonIdentificationData>;
  /**
   * Permission role.
   *
   * Supported values:
   * + `WRITER`: Full read and write access.
   * + `COMMENTER`: Full read access, write access limited to `event.notes`.
   */
  role?: Maybe<WixCalendarSchedulesV3PermissionRole>;
};

export type WixCalendarSchedulesV3PermissionInput = {
  /**
   * [Wix user](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities#wix-users)
   * granted the permission.
   */
  identity?: InputMaybe<WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataInput>;
  /**
   * Permission role.
   *
   * Supported values:
   * + `WRITER`: Full read and write access.
   * + `COMMENTER`: Full read access, write access limited to `event.notes`.
   */
  role?: InputMaybe<WixCalendarSchedulesV3PermissionRole>;
};

export enum WixCalendarSchedulesV3PermissionRole {
  /** Full read access, write access limited to `event.notes`. */
  Commenter = 'COMMENTER',
  UnknownRole = 'UNKNOWN_ROLE',
  /** Full read and write access. */
  Writer = 'WRITER'
}

export type WixCalendarSchedulesV3QuerySchedulesRequestInput = {
  /**
   * Whether to return consistent response.
   * Please consult with us at #bookings-calendar-platform if you think your case requires consistent reads.
   */
  consistent?: InputMaybe<Scalars['Boolean']>;
  /**
   * Information about which fields containing personal data to return. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions)
   * for more information.
   *
   * Supported values:
   * + `PI_FIELDS`: Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope.
   * + `OWN_PI_FIELDS`: Returns only fields containing your own personal data.
   *
   * Max: 1 field
   * Default: No personal data is returned.
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarSchedulesV3RequestedFieldsEnumRequestedFields>>>;
  /** Query containing filters and paging. */
  query?: InputMaybe<WixCalendarSchedulesV3UpstreamWixCommonCursorQueryInput>;
};

export type WixCalendarSchedulesV3QuerySchedulesResponse = {
  __typename?: 'WixCalendarSchedulesV3QuerySchedulesResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixCalendarSchedulesV3Schedule>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixCalendarSchedulesV3RequestedFieldsEnumRequestedFields {
  /** Returns only fields containing your own personal data. */
  OwnPiFields = 'OWN_PI_FIELDS',
  /** Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope. */
  PiFields = 'PI_FIELDS',
  UnknownRequestedFields = 'UNKNOWN_REQUESTED_FIELDS'
}

export type WixCalendarSchedulesV3Schedule = {
  __typename?: 'WixCalendarSchedulesV3Schedule';
  /**
   * ID of the app that's associated with the schedule. You can't update `appId`.
   * If you want to create a schedule and ensure its associated events appear
   * in the [Bookings calendar](https://support.wix.com/en/article/wix-bookings-about-the-wix-booking-calendar),
   * you must provide the [Wix Bookings app ID](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * `13d21c63-b5ec-5912-8397-c3a5ddb27a97`.
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * Whether the schedule's `timeZone` is automatically synced from
   * `timeZone` of the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   *
   * Default: `true`
   */
  businessTimeZoneEnabled?: Maybe<Scalars['Boolean']>;
  /** Date the schedule was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: Maybe<Scalars['String']>;
  /**
   * Default `totalCapacity` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   *
   * Min: `0`
   */
  defaultCapacity?: Maybe<Scalars['Int']>;
  /**
   * Default `conferencingDetails` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   */
  defaultConferencingDetails?: Maybe<WixCalendarSchedulesV3ConferencingDetails>;
  /**
   * Default `location` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   */
  defaultLocation?: Maybe<WixCalendarSchedulesV3Location>;
  /**
   * Default `title` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  defaultTitle?: Maybe<Scalars['String']>;
  eventsVirtualReference?: Maybe<WixCalendarEventsV3QueryEventsResponse>;
  /** Extensions enabling applications or users to save custom data related to the schedule. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /**
   * External ID. You can't update the external ID.
   *
   * If the schedule belongs to a Bookings staff member, identical to the ID of
   * the [resource](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object).
   * If the schedule belongs to a Bookings service, identical to the ID of
   * the [service](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/service-object).
   */
  externalId?: Maybe<Scalars['String']>;
  /** Schedule ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Schedule name.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  name?: Maybe<Scalars['String']>;
  /**
   * List of permissions associated with the schedule. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   *
   * Max: 1 permission
   */
  permissions?: Maybe<Array<Maybe<WixCalendarSchedulesV3Permission>>>;
  /**
   * Revision number, which increments by 1 each time the schedule is updated.
   * To prevent conflicting changes, the current revision must be passed when updating the schedule.
   * Ignored when creating a schedule.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * Schedule status.
   *
   * Supported values:
   * - `ACTIVE`: You can add events to the schedule or update its fields.
   * - `CANCELLED`: You can't add events to the schedule or update its fields.
   *
   * Default: `ACTIVE`
   */
  status?: Maybe<WixCalendarSchedulesV3ScheduleStatus>;
  /**
   * Time zone the schedule is associated with in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * For example, `America/New_York`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   *
   * Min: 1 character
   * Max: 150 characters
   */
  timeZone?: Maybe<Scalars['String']>;
  /** Date the schedule was last updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixCalendarSchedulesV3ScheduleEventsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixCalendarEventsV3QueryEventsRequestInput>;
};

export type WixCalendarSchedulesV3ScheduleInput = {
  /**
   * ID of the app that's associated with the schedule. You can't update `appId`.
   * If you want to create a schedule and ensure its associated events appear
   * in the [Bookings calendar](https://support.wix.com/en/article/wix-bookings-about-the-wix-booking-calendar),
   * you must provide the [Wix Bookings app ID](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * `13d21c63-b5ec-5912-8397-c3a5ddb27a97`.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Whether the schedule's `timeZone` is automatically synced from
   * `timeZone` of the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   *
   * Default: `true`
   */
  businessTimeZoneEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Date the schedule was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /**
   * Default `totalCapacity` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   *
   * Min: `0`
   */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * Default `conferencingDetails` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   */
  defaultConferencingDetails?: InputMaybe<WixCalendarSchedulesV3ConferencingDetailsInput>;
  /**
   * Default `location` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   */
  defaultLocation?: InputMaybe<WixCalendarSchedulesV3LocationInput>;
  /**
   * Default `title` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  defaultTitle?: InputMaybe<Scalars['String']>;
  /** Extensions enabling applications or users to save custom data related to the schedule. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /**
   * External ID. You can't update the external ID.
   *
   * If the schedule belongs to a Bookings staff member, identical to the ID of
   * the [resource](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object).
   * If the schedule belongs to a Bookings service, identical to the ID of
   * the [service](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/service-object).
   */
  externalId?: InputMaybe<Scalars['String']>;
  /** Schedule ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Schedule name.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * List of permissions associated with the schedule. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   *
   * Max: 1 permission
   */
  permissions?: InputMaybe<Array<InputMaybe<WixCalendarSchedulesV3PermissionInput>>>;
  /**
   * Revision number, which increments by 1 each time the schedule is updated.
   * To prevent conflicting changes, the current revision must be passed when updating the schedule.
   * Ignored when creating a schedule.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Schedule status.
   *
   * Supported values:
   * - `ACTIVE`: You can add events to the schedule or update its fields.
   * - `CANCELLED`: You can't add events to the schedule or update its fields.
   *
   * Default: `ACTIVE`
   */
  status?: InputMaybe<WixCalendarSchedulesV3ScheduleStatus>;
  /**
   * Time zone the schedule is associated with in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * For example, `America/New_York`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   *
   * Min: 1 character
   * Max: 150 characters
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /** Date the schedule was last updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixCalendarSchedulesV3ScheduleStatus {
  /** You can add events to the schedule or update its fields. */
  Active = 'ACTIVE',
  /** You can't add events to the schedule or update its fields. */
  Cancelled = 'CANCELLED',
  UnknownStatus = 'UNKNOWN_STATUS'
}

export type WixCalendarSchedulesV3UpdateScheduleRequestInput = {
  /** Optional list of fields to update. */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Information about whether participants of the schedule's updated events are
   * notified and the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /** Schedule to update. */
  schedule?: InputMaybe<WixCalendarSchedulesV3ScheduleInput>;
};

export type WixCalendarSchedulesV3UpdateScheduleResponse = {
  __typename?: 'WixCalendarSchedulesV3UpdateScheduleResponse';
  /** Updated schedule. */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
};

export type WixCalendarSchedulesV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of schedules to return.
   *
   * Min: `1`
   * Max: `100`
   * Default: `50`
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixCalendarSchedulesV3UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter`. */
  cursorPaging?: InputMaybe<WixCalendarSchedulesV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   * See [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * for more information.
   *
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`.
   *
   * For a detailed list of supported filters, see Supported Filters.
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixCalendarSchedulesV3UpstreamWixCommonIdentificationData = {
  __typename?: 'WixCalendarSchedulesV3UpstreamWixCommonIdentificationData';
  identityType?: Maybe<WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataIdentityType>;
  /**
   * ID of a Wix user. For example, the site owner or a
   * [site collaborator](https://support.wix.com/en/article/inviting-people-to-contribute-to-your-site).
   */
  wixUserId?: Maybe<Scalars['String']>;
};

export enum WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataIdentityType {
  Unknown = 'UNKNOWN',
  WixUser = 'WIX_USER'
}

export type WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataInput = {
  identityType?: InputMaybe<WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataIdentityType>;
  /**
   * ID of a Wix user. For example, the site owner or a
   * [site collaborator](https://support.wix.com/en/article/inviting-people-to-contribute-to-your-site).
   */
  wixUserId?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1AddProductMediaRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Sources of media items already uploaded to the Wix site. */
  media?: InputMaybe<Array<InputMaybe<WixCatalogApiV1MediaDataForWriteInput>>>;
};

export type WixCatalogApiV1AddProductMediaToChoicesRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Product media items and the choices to add the media to. */
  media?: InputMaybe<Array<InputMaybe<WixCatalogApiV1MediaAssignmentToChoiceInput>>>;
};

export type WixCatalogApiV1AddProductsToCollectionRequestInput = {
  /** Collection ID. */
  id?: InputMaybe<Scalars['String']>;
  /** IDs of the products to add to the collection, separated by commas. */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1AdditionalInfoSection = {
  __typename?: 'WixCatalogApiV1AdditionalInfoSection';
  /** Product info section description */
  description?: Maybe<Scalars['String']>;
  /** Product info section title */
  title?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1AdditionalInfoSectionInput = {
  /** Product info section description */
  description?: InputMaybe<Scalars['String']>;
  /** Product info section title */
  title?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1AdjustValueInput = {
  /**
   * Adjust product cost of goods.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * cost of goods will be adjusted per variant.
   */
  cost?: InputMaybe<WixCatalogApiV1PropertyAdjustmentDataInput>;
  /**
   * Adjust product price.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * variants prices will be calculated according to the adjusted price.
   * If variant price is negative after the adjustment, the update will fail.
   */
  price?: InputMaybe<WixCatalogApiV1PropertyAdjustmentDataInput>;
  /**
   * Adjust product weight.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * weight will be adjusted per variant.
   */
  weight?: InputMaybe<WixCatalogApiV1PropertyAdjustmentDataInput>;
};

export type WixCatalogApiV1AggregateProductsRequestInput = {
  /** This is an object defining aggregation itself */
  aggregation?: InputMaybe<Scalars['JSON']>;
  /** Filter applied to original data */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Whether hidden products should be considered. Requires permissions to manage products. */
  includeHiddenProducts?: InputMaybe<Scalars['Boolean']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1AggregateProductsResponse = {
  __typename?: 'WixCatalogApiV1AggregateProductsResponse';
  aggregates?: Maybe<Scalars['JSON']>;
};

export type WixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncRequestInput = {
  /** Numerical property to adjust. */
  adjust?: InputMaybe<WixCatalogApiV1AdjustValueInput>;
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/stores/stores-catalog/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncResponse = {
  __typename?: 'WixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<WixCatalogApiV1BulkProductResult>>>;
};

export type WixCatalogApiV1BulkAdjustProductPropertiesRequestInput = {
  /** Numerical property to adjust. */
  adjust?: InputMaybe<WixCatalogApiV1AdjustValueInput>;
  /** Product IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1BulkAdjustProductPropertiesResponse = {
  __typename?: 'WixCatalogApiV1BulkAdjustProductPropertiesResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk action results. */
  results?: Maybe<Array<Maybe<WixCatalogApiV1BulkProductResult>>>;
};

export type WixCatalogApiV1BulkDeleteProductsRequestInput = {
  /** IDs of the products to be deleted. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1BulkProductResult = {
  __typename?: 'WixCatalogApiV1BulkProductResult';
  /** Item metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixCatalogApiV1BulkQueryCustomFieldsRequestInput = {
  /** Requested field names. */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter string. */
  query?: InputMaybe<WixCatalogApiV1QueryInput>;
};

export type WixCatalogApiV1BulkQueryCustomFieldsResponse = {
  __typename?: 'WixCatalogApiV1BulkQueryCustomFieldsResponse';
  metadata?: Maybe<WixCatalogApiV1PagingMetadata>;
  /** ProductId to Custom Fields Map packed in container. */
  productIdToCustomFields?: Maybe<WixCatalogApiV1CustomFieldsContainer>;
  totalResults?: Maybe<Scalars['Int']>;
};

export type WixCatalogApiV1BulkRemoveCustomFieldsRequestInput = {
  /** Filter string. */
  filter?: InputMaybe<Scalars['String']>;
  /** Custom fields names. */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1BulkSetCustomFieldsRequestInput = {
  /** Custom field that will be added, if a custom field with same name already exists, the value of the custom field will be overridden. */
  customFields?: InputMaybe<Scalars['JSON']>;
  /** Filter string. */
  filter?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1BulkUpdateProductsByFilterSyncRequestInput = {
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/stores/stores-catalog/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
  /** The field to update. */
  set?: InputMaybe<WixCatalogApiV1SetValueInput>;
};

export type WixCatalogApiV1BulkUpdateProductsByFilterSyncResponse = {
  __typename?: 'WixCatalogApiV1BulkUpdateProductsByFilterSyncResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<WixCatalogApiV1BulkProductResult>>>;
};

export type WixCatalogApiV1BulkUpdateProductsRequestInput = {
  /** Product IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field to update. */
  set?: InputMaybe<WixCatalogApiV1SetValueInput>;
};

export type WixCatalogApiV1BulkUpdateProductsResponse = {
  __typename?: 'WixCatalogApiV1BulkUpdateProductsResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk action results. */
  results?: Maybe<Array<Maybe<WixCatalogApiV1BulkProductResult>>>;
};

export type WixCatalogApiV1Choice = {
  __typename?: 'WixCatalogApiV1Choice';
  /** Choice description. */
  description?: Maybe<Scalars['String']>;
  /** Based on the customer’s choices, which (if any) variants that include the selected choices are in stock */
  inStock?: Maybe<Scalars['Boolean']>;
  /** Media items (images, videos) associated with this choice */
  media?: Maybe<WixCatalogApiV1Media>;
  /** Choice value. */
  value?: Maybe<Scalars['String']>;
  /** Based on the customer’s choices, which (if any) variants that include the selected choices are visible */
  visible?: Maybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1ChoiceInput = {
  /** Choice description. */
  description?: InputMaybe<Scalars['String']>;
  /** Based on the customer’s choices, which (if any) variants that include the selected choices are in stock */
  inStock?: InputMaybe<Scalars['Boolean']>;
  /** Media items (images, videos) associated with this choice */
  media?: InputMaybe<WixCatalogApiV1MediaInput>;
  /** Choice value. */
  value?: InputMaybe<Scalars['String']>;
  /** Based on the customer’s choices, which (if any) variants that include the selected choices are visible */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1Collection = {
  __typename?: 'WixCatalogApiV1Collection';
  /** Collection description. */
  description?: Maybe<Scalars['String']>;
  /** Collection ID (generated automatically by the catalog). */
  id?: Maybe<Scalars['String']>;
  /** Date and time the collection was updated. */
  lastUpdated?: Maybe<Scalars['String']>;
  /** Media items (images, videos etc) associated with this collection. Read only. */
  media?: Maybe<WixCatalogApiV1Media>;
  /** Collection name. */
  name?: Maybe<Scalars['String']>;
  /** Number of products in the collection. Read only. */
  numberOfProducts?: Maybe<Scalars['Int']>;
  productsVirtualReference?: Maybe<WixCatalogApiV1QueryProductsPlatformizedResponse>;
  /** Custom SEO data for the collection. */
  seoSchema?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Collection slug. */
  slug?: Maybe<Scalars['String']>;
  /** Collection visibility. Only impacts dynamic pages, no impact on static pages. Default: `true`. */
  visible?: Maybe<Scalars['Boolean']>;
};


export type WixCatalogApiV1CollectionProductsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixCatalogApiV1QueryProductsPlatformizedRequestInput>;
};

export type WixCatalogApiV1CollectionInput = {
  /** Collection description. */
  description?: InputMaybe<Scalars['String']>;
  /** Collection ID (generated automatically by the catalog). */
  id?: InputMaybe<Scalars['String']>;
  /** Date and time the collection was updated. */
  lastUpdated?: InputMaybe<Scalars['String']>;
  /** Media items (images, videos etc) associated with this collection. Read only. */
  media?: InputMaybe<WixCatalogApiV1MediaInput>;
  /** Collection name. */
  name?: InputMaybe<Scalars['String']>;
  /** Number of products in the collection. Read only. */
  numberOfProducts?: InputMaybe<Scalars['Int']>;
  /** Custom SEO data for the collection. */
  seoSchema?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Collection slug. */
  slug?: InputMaybe<Scalars['String']>;
  /** Collection visibility. Only impacts dynamic pages, no impact on static pages. Default: `true`. */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1CostAndProfitData = {
  __typename?: 'WixCatalogApiV1CostAndProfitData';
  /** Item cost formatted with currency symbol. */
  formattedItemCost?: Maybe<Scalars['String']>;
  /** Profit formatted with currency symbol. */
  formattedProfit?: Maybe<Scalars['String']>;
  /** Item cost. */
  itemCost?: Maybe<Scalars['Float']>;
  /** Profit. Calculated by reducing `cost` from `discounted_price`. */
  profit?: Maybe<Scalars['Float']>;
  /**
   * Profit Margin. Calculated by dividing `profit` by `discounted_price`.
   * The result is rounded to 4 decimal places.
   */
  profitMargin?: Maybe<Scalars['Float']>;
};

export type WixCatalogApiV1CostAndProfitDataInput = {
  /** Item cost formatted with currency symbol. */
  formattedItemCost?: InputMaybe<Scalars['String']>;
  /** Profit formatted with currency symbol. */
  formattedProfit?: InputMaybe<Scalars['String']>;
  /** Item cost. */
  itemCost?: InputMaybe<Scalars['Float']>;
  /** Profit. Calculated by reducing `cost` from `discounted_price`. */
  profit?: InputMaybe<Scalars['Float']>;
  /**
   * Profit Margin. Calculated by dividing `profit` by `discounted_price`.
   * The result is rounded to 4 decimal places.
   */
  profitMargin?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1CreateCollectionRequestInput = {
  /** Collection info. */
  collection?: InputMaybe<WixCatalogApiV1CollectionInput>;
};

export type WixCatalogApiV1CreateCollectionResponse = {
  __typename?: 'WixCatalogApiV1CreateCollectionResponse';
  /** Collection. */
  collection?: Maybe<WixCatalogApiV1Collection>;
};

export type WixCatalogApiV1CreateDigitalProductRequestInput = {
  /** Product information. */
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogApiV1CreateDigitalProductResponse = {
  __typename?: 'WixCatalogApiV1CreateDigitalProductResponse';
  /** Created product. */
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1CreateProductPlatformizedRequestInput = {
  /** Product information. */
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogApiV1CreateProductPlatformizedResponse = {
  __typename?: 'WixCatalogApiV1CreateProductPlatformizedResponse';
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1CreateProductRequestInput = {
  /** Product information. */
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogApiV1CreateProductResponse = {
  __typename?: 'WixCatalogApiV1CreateProductResponse';
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1CustomFieldsContainer = {
  __typename?: 'WixCatalogApiV1CustomFieldsContainer';
  customFields?: Maybe<Scalars['JSON']>;
};

export type WixCatalogApiV1CustomTextField = {
  __typename?: 'WixCatalogApiV1CustomTextField';
  /** Whether this text box is mandatory */
  mandatory?: Maybe<Scalars['Boolean']>;
  /** Text box input max length */
  maxLength?: Maybe<Scalars['Int']>;
  /** Text box title */
  title?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1CustomTextFieldInput = {
  /** Whether this text box is mandatory */
  mandatory?: InputMaybe<Scalars['Boolean']>;
  /** Text box input max length */
  maxLength?: InputMaybe<Scalars['Int']>;
  /** Text box title */
  title?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1DeleteCollectionRequestInput = {
  /** ID of the collection to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1DeleteProductOptionsRequestInput = {
  /** ID of the product with options to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1DeleteProductPlatformizedRequestInput = {
  /** ID of the product to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1DeleteProductRequestInput = {
  /** ID of the product to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1Discount = {
  __typename?: 'WixCatalogApiV1Discount';
  /**
   * Discount type:
   * + `"AMOUNT"`
   * + `"PERCENT"`
   */
  type?: Maybe<WixCatalogApiV1DiscountDiscountType>;
  /** Discount value */
  value?: Maybe<Scalars['Float']>;
};

export enum WixCatalogApiV1DiscountDiscountType {
  /** Discount by a fixed amount */
  Amount = 'AMOUNT',
  /** No discount */
  None = 'NONE',
  /** Discount by a percentage */
  Percent = 'PERCENT',
  Undefined = 'UNDEFINED'
}

export type WixCatalogApiV1DiscountInput = {
  /**
   * Discount type:
   * + `"AMOUNT"`
   * + `"PERCENT"`
   */
  type?: InputMaybe<WixCatalogApiV1DiscountDiscountType>;
  /** Discount value */
  value?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1FormattedPrice = {
  __typename?: 'WixCatalogApiV1FormattedPrice';
  /** Discounted product price formatted with the currency (if no discounted price is set, the product formatted price is returned) */
  discountedPrice?: Maybe<Scalars['String']>;
  /** Product price formatted with the currency */
  price?: Maybe<Scalars['String']>;
  /** Price per unit */
  pricePerUnit?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1FormattedPriceInput = {
  /** Discounted product price formatted with the currency (if no discounted price is set, the product formatted price is returned) */
  discountedPrice?: InputMaybe<Scalars['String']>;
  /** Product price formatted with the currency */
  price?: InputMaybe<Scalars['String']>;
  /** Price per unit */
  pricePerUnit?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1GetCollectionBySlugRequestInput = {
  /** Slug of the collection to retrieve. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1GetCollectionBySlugResponse = {
  __typename?: 'WixCatalogApiV1GetCollectionBySlugResponse';
  /** The requested collection. */
  collection?: Maybe<WixCatalogApiV1Collection>;
};

export type WixCatalogApiV1GetCollectionRequestInput = {
  /** Requested collection ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Whether to return the `collection.numberOfProducts` field in the response.
   * Defaults to `false`, in which case the value of `collection.numberOfProducts` will be `0`.
   */
  includeNumberOfProducts?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1GetCollectionResponse = {
  __typename?: 'WixCatalogApiV1GetCollectionResponse';
  /** The requested collection. */
  collection?: Maybe<WixCatalogApiV1Collection>;
};

export type WixCatalogApiV1GetProductRequestInput = {
  id: Scalars['ID'];
  /** Whether merchant specific data, such as cost and profit data, should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1GetProductResponse = {
  __typename?: 'WixCatalogApiV1GetProductResponse';
  /** Requested product data. */
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1GetProductsRequestInput = {
  /** Requested product IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1GetProductsResponse = {
  __typename?: 'WixCatalogApiV1GetProductsResponse';
  products?: Maybe<Array<Maybe<WixCatalogApiV1Product>>>;
};

export type WixCatalogApiV1GetStoreVariantRequestInput = {
  /** Store variant ID. Comprised of the `productId` and the `variantId`, separated by a hyphen. For example, `{productId}-{variantId}`. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1GetStoreVariantResponse = {
  __typename?: 'WixCatalogApiV1GetStoreVariantResponse';
  /** The requested store variant. */
  variant?: Maybe<WixCatalogApiV1StoreVariant>;
};

export type WixCatalogApiV1Media = {
  __typename?: 'WixCatalogApiV1Media';
  /** Media (images, videos etc) associated with this product. */
  items?: Maybe<Array<Maybe<WixCatalogApiV1MediaItem>>>;
  /** Primary media (image, video etc) associated with this product. */
  mainMedia?: Maybe<WixCatalogApiV1MediaItem>;
};

export type WixCatalogApiV1MediaAssignmentToChoiceInput = {
  /** Choice name. */
  choice?: InputMaybe<Scalars['String']>;
  /** Media IDs (available via the Query Product endpoint). */
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Option name. */
  option?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1MediaDataForWriteInput = {
  /**
   * Assign this media item to a specific product choice.
   * Note that you may set media items for choices under only one option (e.g., if Colors blue, green, and red have media items, Sizes S, M, and L can't have media items assigned to them).
   * You may clear existing media from choices with the [Remove Product Media From Choices](/catalog/products/remove-product-media-from-choices).
   */
  choice?: InputMaybe<WixCatalogApiV1MediaDataForWriteOptionAndChoiceInput>;
  /** Media ID. For media items previously saved in Wix Media, the media ID is returned in the Query Product response. */
  mediaId?: InputMaybe<Scalars['String']>;
  /** Media external URL (for new media items). */
  url?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1MediaDataForWriteOptionAndChoiceInput = {
  /** Choice to add the media to. */
  choice?: InputMaybe<Scalars['String']>;
  /** Option to add the media to. */
  option?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1MediaInput = {
  /** Media (images, videos etc) associated with this product. */
  items?: InputMaybe<Array<InputMaybe<WixCatalogApiV1MediaItemInput>>>;
  /** Primary media (image, video etc) associated with this product. */
  mainMedia?: InputMaybe<WixCatalogApiV1MediaItemInput>;
};

export type WixCatalogApiV1MediaItem = {
  __typename?: 'WixCatalogApiV1MediaItem';
  /** Media ID (for example, `"nsplsh_306d666a123a4a74306459~mv2_d_4517_2992_s_4_2.jpg"`). */
  id?: Maybe<Scalars['String']>;
  /** Image data (URL, size). */
  image?: Maybe<WixCatalogApiV1MediaItemUrlAndSize>;
  /** Media item type (image, video, etc.). */
  mediaType?: Maybe<WixCatalogApiV1MediaItemType>;
  /** Media item thumbnail details. */
  thumbnail?: Maybe<WixCatalogApiV1MediaItemUrlAndSize>;
  /** Media item title. */
  title?: Maybe<Scalars['String']>;
  /** Video data (URL, size). */
  video?: Maybe<WixCatalogApiV1MediaItemVideo>;
};

export type WixCatalogApiV1MediaItemInput = {
  /** Media ID (for example, `"nsplsh_306d666a123a4a74306459~mv2_d_4517_2992_s_4_2.jpg"`). */
  id?: InputMaybe<Scalars['String']>;
  /** Image data (URL, size). */
  image?: InputMaybe<WixCatalogApiV1MediaItemUrlAndSizeInput>;
  /** Media item type (image, video, etc.). */
  mediaType?: InputMaybe<WixCatalogApiV1MediaItemType>;
  /** Media item thumbnail details. */
  thumbnail?: InputMaybe<WixCatalogApiV1MediaItemUrlAndSizeInput>;
  /** Media item title. */
  title?: InputMaybe<Scalars['String']>;
  /** Video data (URL, size). */
  video?: InputMaybe<WixCatalogApiV1MediaItemVideoInput>;
};

export enum WixCatalogApiV1MediaItemType {
  /** Audio media type. */
  Audio = 'audio',
  /** Document media type. */
  Document = 'document',
  /** Image media type. */
  Image = 'image',
  UnspecifiedMediaItemType = 'unspecified_media_item_type',
  /** Video media type. */
  Video = 'video',
  /** Zip media type. */
  Zip = 'zip'
}

export type WixCatalogApiV1MediaItemUrlAndSize = {
  __typename?: 'WixCatalogApiV1MediaItemUrlAndSize';
  /** Alt text. This text will be shown in case the image is not available. */
  altText?: Maybe<Scalars['String']>;
  /** Media format (mp4, png, etc.). */
  format?: Maybe<Scalars['String']>;
  /** Media item height. */
  height?: Maybe<Scalars['Int']>;
  /** Media item URL. */
  url?: Maybe<Scalars['String']>;
  /** Media item width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixCatalogApiV1MediaItemUrlAndSizeInput = {
  /** Alt text. This text will be shown in case the image is not available. */
  altText?: InputMaybe<Scalars['String']>;
  /** Media format (mp4, png, etc.). */
  format?: InputMaybe<Scalars['String']>;
  /** Media item height. */
  height?: InputMaybe<Scalars['Int']>;
  /** Media item URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Media item width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixCatalogApiV1MediaItemVideo = {
  __typename?: 'WixCatalogApiV1MediaItemVideo';
  /** Data (URL, size) about each resolution for which this video is available. */
  files?: Maybe<Array<Maybe<WixCatalogApiV1MediaItemUrlAndSize>>>;
  /** ID of an image taken from the video. Used primarily for Wix Search indexing. For example, `"nsplsh_306d666a123a4a74306459~mv2_d_4517_2992_s_4_2.jpg"`. */
  stillFrameMediaId?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1MediaItemVideoInput = {
  /** Data (URL, size) about each resolution for which this video is available. */
  files?: InputMaybe<Array<InputMaybe<WixCatalogApiV1MediaItemUrlAndSizeInput>>>;
  /** ID of an image taken from the video. Used primarily for Wix Search indexing. For example, `"nsplsh_306d666a123a4a74306459~mv2_d_4517_2992_s_4_2.jpg"`. */
  stillFrameMediaId?: InputMaybe<Scalars['String']>;
};

export enum WixCatalogApiV1OptionType {
  /** Color. */
  Color = 'color',
  /** Drop down. */
  DropDown = 'drop_down',
  /** Unspecified option type. */
  UnspecifiedOptionType = 'unspecified_option_type'
}

export type WixCatalogApiV1PageUrl = {
  __typename?: 'WixCatalogApiV1PageUrl';
  /** Base URL. For premium sites, this is the domain. For free sites, this is the site URL (e.g mysite.wixsite.com/mysite). */
  base?: Maybe<Scalars['String']>;
  /** Path to the product page - e.g /product-page/a-product. */
  path?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1PageUrlInput = {
  /** Base URL. For premium sites, this is the domain. For free sites, this is the site URL (e.g mysite.wixsite.com/mysite). */
  base?: InputMaybe<Scalars['String']>;
  /** Path to the product page - e.g /product-page/a-product. */
  path?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1PagingInput = {
  /** Amount of items to load per page */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the display (relevant for all pages after the first) */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixCatalogApiV1PagingMetadata = {
  __typename?: 'WixCatalogApiV1PagingMetadata';
  /** Amount of items to load per page */
  items?: Maybe<Scalars['Int']>;
  /** Number of items to skip in the display (relevant for all pages after the first) */
  offset?: Maybe<Scalars['Int']>;
};

export type WixCatalogApiV1PagingWithBigLimitInput = {
  /** Amount of items to load per page */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the display (relevant for all pages after the first) */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixCatalogApiV1PercentageDataInput = {
  /**
   * Percentage value, as a whole number (integer) between `-100` and `1000`.
   *
   * For example:
   * + Pass `100` to increase value by 100% (multiply original value by 2).
   * + Pass `1000` to increase value by 1000% (multiply original value by 10).
   * + Pass `-50` to decrease value by 50% (original value is halved).
   */
  rate?: InputMaybe<Scalars['Int']>;
  /**
   * If `true`, result will be rounded to the nearest whole number.
   * If `false`, result will be rounded to 2 places after the decimal point.
   */
  roundToInt?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1PriceData = {
  __typename?: 'WixCatalogApiV1PriceData';
  /** Product price currency */
  currency?: Maybe<Scalars['String']>;
  /** Discounted product price (if no discounted price is set, the product price is returned) */
  discountedPrice?: Maybe<Scalars['Float']>;
  /** The product price and discounted price, formatted with the currency */
  formatted?: Maybe<WixCatalogApiV1FormattedPrice>;
  /** Product price */
  price?: Maybe<Scalars['Float']>;
  /** Price per unit */
  pricePerUnit?: Maybe<Scalars['Float']>;
};

export type WixCatalogApiV1PriceDataInput = {
  /** Product price currency */
  currency?: InputMaybe<Scalars['String']>;
  /** Discounted product price (if no discounted price is set, the product price is returned) */
  discountedPrice?: InputMaybe<Scalars['Float']>;
  /** The product price and discounted price, formatted with the currency */
  formatted?: InputMaybe<WixCatalogApiV1FormattedPriceInput>;
  /** Product price */
  price?: InputMaybe<Scalars['Float']>;
  /** Price per unit */
  pricePerUnit?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1PricePerUnitData = {
  __typename?: 'WixCatalogApiV1PricePerUnitData';
  /** Base measurement unit */
  baseMeasurementUnit?: Maybe<ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit>;
  /** Base quantity */
  baseQuantity?: Maybe<Scalars['Float']>;
  /** Total measurement unit */
  totalMeasurementUnit?: Maybe<ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit>;
  /** Total quantity */
  totalQuantity?: Maybe<Scalars['Float']>;
};

export type WixCatalogApiV1PricePerUnitDataInput = {
  /** Base measurement unit */
  baseMeasurementUnit?: InputMaybe<ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit>;
  /** Base quantity */
  baseQuantity?: InputMaybe<Scalars['Float']>;
  /** Total measurement unit */
  totalMeasurementUnit?: InputMaybe<ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit>;
  /** Total quantity */
  totalQuantity?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1Product = {
  __typename?: 'WixCatalogApiV1Product';
  /** Additional text that the store owner can assign to the product (e.g. shipping details, refund policy, etc.). */
  additionalInfoSections?: Maybe<Array<Maybe<WixCatalogApiV1AdditionalInfoSection>>>;
  /** Product brand. Including a brand name can help improve site and product [visibility on search engines](https://support.wix.com/en/article/adding-brand-names-to-boost-product-page-seo-in-wix-stores). */
  brand?: Maybe<Scalars['String']>;
  /** A list of all collection IDs that this product is included in (writable via the Catalog > Collection APIs). */
  collectionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of all collection IDs that this product is included in (writable via the Catalog > Collection APIs). */
  collections?: Maybe<WixCatalogApiV2QueryCollectionsResponse>;
  /** Price data, converted to the currency specified in request header. */
  convertedPriceData?: Maybe<WixCatalogApiV1PriceData>;
  /** Cost and profit data. */
  costAndProfitData?: Maybe<WixCatalogApiV1CostAndProfitData>;
  /** Product cost range. The minimum and maximum costs of all the variants. */
  costRange?: Maybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRange>;
  /** Date and time the product was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Text box for the customer to add a message to their order (e.g., customization request). Currently writable only from the UI. */
  customTextFields?: Maybe<Array<Maybe<WixCatalogApiV1CustomTextField>>>;
  /** Product description. Accepts [rich text](https://dev.wix.com/api/rest/wix-stores/rich-text). */
  description?: Maybe<Scalars['String']>;
  /** Digital file which will be downloaded by buyer after successful purchase. */
  digitalFile?: Maybe<ComWixEcommerceCatalogSpiApiV1SecuredMedia>;
  /** Discount deducted from the product's original price. */
  discount?: Maybe<WixCatalogApiV1Discount>;
  /** internal field used by import/export to know how to link products in csv file to product ids */
  exportProductId?: Maybe<Scalars['String']>;
  /** Product ID (generated automatically by the catalog). */
  id?: Maybe<Scalars['String']>;
  /** Inventory item ID - ID referencing the inventory system. */
  inventoryItemId?: Maybe<Scalars['String']>;
  /** Date and time the product was last updated. */
  lastUpdated?: Maybe<Scalars['String']>;
  /** Whether variants are being managed for this product - enables unique SKU, price and weight per variant. Also affects inventory data. */
  manageVariants?: Maybe<Scalars['Boolean']>;
  /** Media items (images, videos etc) associated with this product (writable via [Add Product Media](https://dev.wix.com/api/rest/wix-stores/catalog/products/add-product-media) endpoint). */
  media?: Maybe<WixCatalogApiV1Media>;
  /**
   * Product name.
   *
   * Min: 1 character
   * Max: 80 characters
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Product’s unique numeric ID (assigned in ascending order).
   * Primarily used for sorting and filtering when crawling all products.
   */
  numericId?: Maybe<Scalars['Long']>;
  /** Deprecated (use `priceData` instead). */
  price?: Maybe<WixCatalogApiV1PriceData>;
  /** Price data. */
  priceData?: Maybe<WixCatalogApiV1PriceData>;
  /** Price per unit data. */
  pricePerUnitData?: Maybe<WixCatalogApiV1PricePerUnitData>;
  /** Product price range. The minimum and maximum prices of all the variants. */
  priceRange?: Maybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRange>;
  /** Options for this product. */
  productOptions?: Maybe<Array<Maybe<WixCatalogApiV1ProductOption>>>;
  /** Product page URL for this product (generated automatically by the server). */
  productPageUrl?: Maybe<WixCatalogApiV1PageUrl>;
  /** Currently, only creating physical products ( `"productType": "physical"` ) is supported via the API. */
  productType?: Maybe<WixCatalogApiV1ProductType>;
  /** Product ribbon. Used to highlight relevant information about a product. For example, "Sale", "New Arrival", "Sold Out". */
  ribbon?: Maybe<Scalars['String']>;
  /** Deprecated (use `ribbon` instead). */
  ribbons?: Maybe<Array<Maybe<WixCatalogApiV1Ribbon>>>;
  /** Custom SEO data for the product. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Stock keeping unit. If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled, SKUs will be set per variant, and this field will be empty. */
  sku?: Maybe<Scalars['String']>;
  /** A friendly URL name (generated automatically by the catalog when a product is created), can be updated. */
  slug?: Maybe<Scalars['String']>;
  /** Product inventory status (in future this will be writable via Inventory API). */
  stock?: Maybe<WixCatalogApiV1Stock>;
  /** tax group id */
  taxGroupId?: Maybe<Scalars['String']>;
  /**
   * Product variants, will be provided if the request was sent with the `includeVariants: true`.
   *
   * Max: 1,000 variants
   */
  variants?: Maybe<Array<Maybe<WixCatalogApiV1Variant>>>;
  /** Whether the product is visible to site visitors. */
  visible?: Maybe<Scalars['Boolean']>;
  /** Product weight. If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled, weight will be set per variant, and this field will be empty. */
  weight?: Maybe<Scalars['Float']>;
  /** Product weight range. The minimum and maximum weights of all the variants. */
  weightRange?: Maybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRange>;
};


export type WixCatalogApiV1ProductCollectionsArgs = {
  queryInput?: InputMaybe<WixCatalogApiV2QueryCollectionsRequestInput>;
};

export type WixCatalogApiV1ProductInput = {
  /** Additional text that the store owner can assign to the product (e.g. shipping details, refund policy, etc.). */
  additionalInfoSections?: InputMaybe<Array<InputMaybe<WixCatalogApiV1AdditionalInfoSectionInput>>>;
  /** Product brand. Including a brand name can help improve site and product [visibility on search engines](https://support.wix.com/en/article/adding-brand-names-to-boost-product-page-seo-in-wix-stores). */
  brand?: InputMaybe<Scalars['String']>;
  /** A list of all collection IDs that this product is included in (writable via the Catalog > Collection APIs). */
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Price data, converted to the currency specified in request header. */
  convertedPriceData?: InputMaybe<WixCatalogApiV1PriceDataInput>;
  /** Cost and profit data. */
  costAndProfitData?: InputMaybe<WixCatalogApiV1CostAndProfitDataInput>;
  /** Product cost range. The minimum and maximum costs of all the variants. */
  costRange?: InputMaybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput>;
  /** Date and time the product was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Text box for the customer to add a message to their order (e.g., customization request). Currently writable only from the UI. */
  customTextFields?: InputMaybe<Array<InputMaybe<WixCatalogApiV1CustomTextFieldInput>>>;
  /** Product description. Accepts [rich text](https://dev.wix.com/api/rest/wix-stores/rich-text). */
  description?: InputMaybe<Scalars['String']>;
  /** Digital file which will be downloaded by buyer after successful purchase. */
  digitalFile?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SecuredMediaInput>;
  /** Discount deducted from the product's original price. */
  discount?: InputMaybe<WixCatalogApiV1DiscountInput>;
  /** internal field used by import/export to know how to link products in csv file to product ids */
  exportProductId?: InputMaybe<Scalars['String']>;
  /** Product ID (generated automatically by the catalog). */
  id?: InputMaybe<Scalars['String']>;
  /** Inventory item ID - ID referencing the inventory system. */
  inventoryItemId?: InputMaybe<Scalars['String']>;
  /** Date and time the product was last updated. */
  lastUpdated?: InputMaybe<Scalars['String']>;
  /** Whether variants are being managed for this product - enables unique SKU, price and weight per variant. Also affects inventory data. */
  manageVariants?: InputMaybe<Scalars['Boolean']>;
  /** Media items (images, videos etc) associated with this product (writable via [Add Product Media](https://dev.wix.com/api/rest/wix-stores/catalog/products/add-product-media) endpoint). */
  media?: InputMaybe<WixCatalogApiV1MediaInput>;
  /**
   * Product name.
   *
   * Min: 1 character
   * Max: 80 characters
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Product’s unique numeric ID (assigned in ascending order).
   * Primarily used for sorting and filtering when crawling all products.
   */
  numericId?: InputMaybe<Scalars['Long']>;
  /** Deprecated (use `priceData` instead). */
  price?: InputMaybe<WixCatalogApiV1PriceDataInput>;
  /** Price data. */
  priceData?: InputMaybe<WixCatalogApiV1PriceDataInput>;
  /** Price per unit data. */
  pricePerUnitData?: InputMaybe<WixCatalogApiV1PricePerUnitDataInput>;
  /** Product price range. The minimum and maximum prices of all the variants. */
  priceRange?: InputMaybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput>;
  /** Options for this product. */
  productOptions?: InputMaybe<Array<InputMaybe<WixCatalogApiV1ProductOptionInput>>>;
  /** Product page URL for this product (generated automatically by the server). */
  productPageUrl?: InputMaybe<WixCatalogApiV1PageUrlInput>;
  /** Currently, only creating physical products ( `"productType": "physical"` ) is supported via the API. */
  productType?: InputMaybe<WixCatalogApiV1ProductType>;
  /** Product ribbon. Used to highlight relevant information about a product. For example, "Sale", "New Arrival", "Sold Out". */
  ribbon?: InputMaybe<Scalars['String']>;
  /** Deprecated (use `ribbon` instead). */
  ribbons?: InputMaybe<Array<InputMaybe<WixCatalogApiV1RibbonInput>>>;
  /** Custom SEO data for the product. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Stock keeping unit. If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled, SKUs will be set per variant, and this field will be empty. */
  sku?: InputMaybe<Scalars['String']>;
  /** A friendly URL name (generated automatically by the catalog when a product is created), can be updated. */
  slug?: InputMaybe<Scalars['String']>;
  /** Product inventory status (in future this will be writable via Inventory API). */
  stock?: InputMaybe<WixCatalogApiV1StockInput>;
  /** tax group id */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /**
   * Product variants, will be provided if the request was sent with the `includeVariants: true`.
   *
   * Max: 1,000 variants
   */
  variants?: InputMaybe<Array<InputMaybe<WixCatalogApiV1VariantInput>>>;
  /** Whether the product is visible to site visitors. */
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Product weight. If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled, weight will be set per variant, and this field will be empty. */
  weight?: InputMaybe<Scalars['Float']>;
  /** Product weight range. The minimum and maximum weights of all the variants. */
  weightRange?: InputMaybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput>;
};

export type WixCatalogApiV1ProductOption = {
  __typename?: 'WixCatalogApiV1ProductOption';
  /** Choices available for this option. */
  choices?: Maybe<Array<Maybe<WixCatalogApiV1Choice>>>;
  /** Option name. */
  name?: Maybe<Scalars['String']>;
  /** Option type. */
  optionType?: Maybe<WixCatalogApiV1OptionType>;
};

export type WixCatalogApiV1ProductOptionInput = {
  /** Choices available for this option. */
  choices?: InputMaybe<Array<InputMaybe<WixCatalogApiV1ChoiceInput>>>;
  /** Option name. */
  name?: InputMaybe<Scalars['String']>;
  /** Option type. */
  optionType?: InputMaybe<WixCatalogApiV1OptionType>;
};

export type WixCatalogApiV1ProductOptionsAvailabilityRequestInput = {
  /** Requested product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Array containing the selected options. For example, `["color": "Blue", "size": "Large"]`. */
  options?: InputMaybe<Scalars['JSON']>;
};

export type WixCatalogApiV1ProductOptionsAvailabilityResponse = {
  __typename?: 'WixCatalogApiV1ProductOptionsAvailabilityResponse';
  /** Whether all the selected choices result in a visible, in-stock variant. */
  availableForPurchase?: Maybe<Scalars['Boolean']>;
  /** Whether the variant is managed or represents a product. */
  managedProduct?: Maybe<Scalars['Boolean']>;
  /** Information about media items (images, videos, etc.) associated with this choice. */
  media?: Maybe<WixCatalogApiV1Media>;
  /** Options information (color, size, etc.) for this product, with the inventory and visibility fields updated based on the provided choices. */
  productOptions?: Maybe<Array<Maybe<WixCatalogApiV1ProductOption>>>;
  /** Variant information, given that all the choices were provided. */
  selectedVariant?: Maybe<WixCatalogApiV1VariantData>;
};

export enum WixCatalogApiV1ProductType {
  Digital = 'digital',
  Physical = 'physical',
  UnspecifiedProductType = 'unspecified_product_type'
}

export type WixCatalogApiV1PropertyAdjustmentDataInput = {
  /** Adjust by amount. */
  amount?: InputMaybe<Scalars['Float']>;
  /** Adjust by percentage. */
  percentage?: InputMaybe<WixCatalogApiV1PercentageDataInput>;
};

export type WixCatalogApiV1QueryCollectionsPlatformizedRequestInput = {
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type WixCatalogApiV1QueryCollectionsPlatformizedResponse = {
  __typename?: 'WixCatalogApiV1QueryCollectionsPlatformizedResponse';
  collections?: Maybe<Array<Maybe<WixCatalogApiV1Collection>>>;
  metadata?: Maybe<ComWixEcommerceCommonsApiPlatformPagingMetadata>;
};

export type WixCatalogApiV1QueryCollectionsRequestInput = {
  /** Wether to include collection description in the response. When `false` is passed, `collection.description` will return null. */
  includeDescription?: InputMaybe<Scalars['Boolean']>;
  /** Whether number of products should be included in the response. */
  includeNumberOfProducts?: InputMaybe<Scalars['Boolean']>;
  /** Include SeoSchema in response. When False, SeoSchema will be null */
  includeSeoSchema?: InputMaybe<Scalars['Boolean']>;
  /** Query options. */
  query?: InputMaybe<WixCatalogApiV1QueryInput>;
};

export type WixCatalogApiV1QueryCollectionsResponse = {
  __typename?: 'WixCatalogApiV1QueryCollectionsResponse';
  /** List of collections. */
  collections?: Maybe<Array<Maybe<WixCatalogApiV1Collection>>>;
  /** Details on the paged set of results returned. */
  metadata?: Maybe<WixCatalogApiV1PagingMetadata>;
  /** Total number of results returned. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type WixCatalogApiV1QueryCustomFieldsRequestInput = {
  /** Requested product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Requested field names. */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1QueryCustomFieldsResponse = {
  __typename?: 'WixCatalogApiV1QueryCustomFieldsResponse';
  customFields?: Maybe<Scalars['JSON']>;
};

export type WixCatalogApiV1QueryInput = {
  /** Filter string */
  filter?: InputMaybe<Scalars['String']>;
  paging?: InputMaybe<WixCatalogApiV1PagingInput>;
  /** Sort string */
  sort?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1QueryProductVariantsRequestInput = {
  /**
   * The specific choices available or chosen from within a selection (e.g., choosing the red Selection triggers the red Choice).
   * You may specify all the relevant choices for a specific variant, or only some of the options, which will return all corresponding variants (not relevant when passing variant IDs).
   */
  choices?: InputMaybe<Scalars['JSON']>;
  /** Requested product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
  paging?: InputMaybe<WixCatalogApiV1PagingInput>;
  /** List of variant IDs (not relevant when passing choices). */
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1QueryProductVariantsResponse = {
  __typename?: 'WixCatalogApiV1QueryProductVariantsResponse';
  metadata?: Maybe<WixCatalogApiV1PagingMetadata>;
  totalResults?: Maybe<Scalars['Int']>;
  /** List of variants based on the specified filters and sorting. */
  variants?: Maybe<Array<Maybe<WixCatalogApiV1Variant>>>;
};

export type WixCatalogApiV1QueryProductsPlatformizedRequestInput = {
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type WixCatalogApiV1QueryProductsPlatformizedResponse = {
  __typename?: 'WixCatalogApiV1QueryProductsPlatformizedResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixCatalogApiV1Product>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixCatalogApiV1QueryProductsRequestInput = {
  /** Whether hidden products should be included in the response. Requires permissions to manage products. */
  includeHiddenProducts?: InputMaybe<Scalars['Boolean']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
  /** Whether variants should be included in the response. */
  includeVariants?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<WixCatalogApiV1QueryInput>;
};

export type WixCatalogApiV1QueryProductsResponse = {
  __typename?: 'WixCatalogApiV1QueryProductsResponse';
  metadata?: Maybe<WixCatalogApiV1PagingMetadata>;
  products?: Maybe<Array<Maybe<WixCatalogApiV1Product>>>;
  totalResults?: Maybe<Scalars['Int']>;
};

export type WixCatalogApiV1QueryProductsWithBigPageLimitRequestInput = {
  /** Whether hidden products should be included in the response. Requires permissions to manage products. */
  includeHiddenProducts?: InputMaybe<Scalars['Boolean']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
  /** Whether variants should be included in the response. */
  includeVariants?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<WixCatalogApiV1QueryWithBigPageLimitInput>;
};

export type WixCatalogApiV1QueryStoreVariantsRequestInput = {
  /** Requested custom field names. */
  customFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Include variants for different locations */
  includeLocationVariants?: InputMaybe<Scalars['Boolean']>;
  /** Query options. */
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type WixCatalogApiV1QueryStoreVariantsResponse = {
  __typename?: 'WixCatalogApiV1QueryStoreVariantsResponse';
  /** Details on the paged set of results returned. */
  metadata?: Maybe<ComWixEcommerceCommonsApiPlatformPagingMetadata>;
  /** List of variants based on the specified filters and sorting. */
  variants?: Maybe<Array<Maybe<WixCatalogApiV1StoreVariant>>>;
};

export type WixCatalogApiV1QueryStoreVariantsWithBigLimitRequestInput = {
  /** Requested custom field names. */
  customFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Include variants for different locations */
  includeLocationVariants?: InputMaybe<Scalars['Boolean']>;
  /** Query options. */
  query?: InputMaybe<ComWixEcommerceCommonsApiUnlimitedPlatformQueryInput>;
};

export type WixCatalogApiV1QueryWithBigPageLimitInput = {
  /** Filter string */
  filter?: InputMaybe<Scalars['String']>;
  paging?: InputMaybe<WixCatalogApiV1PagingWithBigLimitInput>;
  /** Sort string */
  sort?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1ReCloneStoreRequestInput = {
  /** Description of value */
  metasiteId?: InputMaybe<Scalars['String']>;
  originalMetasiteId?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1RemoveCustomFieldsRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Custom fields to be removed (by name). */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1RemoveProductBrandRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1RemoveProductMediaFromChoicesRequestInput = {
  /** Product ID from whose choices to remove media items. */
  id?: InputMaybe<Scalars['String']>;
  /** Media to remove from choices. If an empty array is passed, all media will be removed from all choices for the given product. */
  media?: InputMaybe<Array<InputMaybe<WixCatalogApiV1MediaAssignmentToChoiceInput>>>;
};

export type WixCatalogApiV1RemoveProductMediaRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** List of media IDs to remove. Pass an empty array to delete all media items for the product. */
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1RemoveProductRibbonRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1RemoveProductsFromCollectionRequestInput = {
  /** Collection ID. */
  id?: InputMaybe<Scalars['String']>;
  /** IDs of the products to remove from the collection. */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1ResetAllVariantDataRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1Ribbon = {
  __typename?: 'WixCatalogApiV1Ribbon';
  /** Ribbon text */
  text?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1RibbonInput = {
  /** Ribbon text */
  text?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1SetCustomFieldsRequestInput = {
  /** Custom field that will be added, if a custom field with the same name already exists, the value of the custom field will be overridden. */
  customFields?: InputMaybe<Scalars['JSON']>;
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1SetValueInput = {
  /** Set product brand. Pass empty string to remove existing brand. */
  brand?: InputMaybe<Scalars['String']>;
  /**
   * Set product cost of goods.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * cost of goods will be set per variant.
   */
  cost?: InputMaybe<Scalars['Float']>;
  /**
   * Set product price.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * variant prices will be calculated according to the set product price.
   * If variant price is negative after setting new price, the update will fail.
   */
  price?: InputMaybe<Scalars['Float']>;
  /** Set product ribbon. Pass empty string to remove existing ribbon. */
  ribbon?: InputMaybe<Scalars['String']>;
  /**
   * Set product weight.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * weight will be set per variant.
   */
  weight?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1Stock = {
  __typename?: 'WixCatalogApiV1Stock';
  /**
   * Whether the product is currently in stock (relevant only when tracking manually)
   * Deprecated (use `inventoryStatus` instead)
   */
  inStock?: Maybe<Scalars['Boolean']>;
  /**
   * The current status of the inventory
   * + `IN_STOCK` - In stock
   * + `OUT_OF_STOCK` - Not in stock
   * + `PARTIALLY_OUT_OF_STOCK` - Some of the variants are not in stock
   */
  inventoryStatus?: Maybe<WixCatalogApiV1StockInventoryStatus>;
  /** Quantity currently left in inventory */
  quantity?: Maybe<Scalars['Int']>;
  /** Whether inventory is being tracked */
  trackInventory?: Maybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1StockInput = {
  /**
   * Whether the product is currently in stock (relevant only when tracking manually)
   * Deprecated (use `inventoryStatus` instead)
   */
  inStock?: InputMaybe<Scalars['Boolean']>;
  /**
   * The current status of the inventory
   * + `IN_STOCK` - In stock
   * + `OUT_OF_STOCK` - Not in stock
   * + `PARTIALLY_OUT_OF_STOCK` - Some of the variants are not in stock
   */
  inventoryStatus?: InputMaybe<WixCatalogApiV1StockInventoryStatus>;
  /** Quantity currently left in inventory */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Whether inventory is being tracked */
  trackInventory?: InputMaybe<Scalars['Boolean']>;
};

export enum WixCatalogApiV1StockInventoryStatus {
  /** In stock */
  InStock = 'IN_STOCK',
  /** Not in stock */
  OutOfStock = 'OUT_OF_STOCK',
  /** Some of the variants are not in stock */
  PartiallyOutOfStock = 'PARTIALLY_OUT_OF_STOCK'
}

export type WixCatalogApiV1StoreVariant = {
  __typename?: 'WixCatalogApiV1StoreVariant';
  /** The selected options of this variant. For example, `{"Color": "Blue", "Size": "Large"}`. */
  choices?: Maybe<Scalars['JSON']>;
  /** Collections that include this variant. */
  collectionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Collections that include this variant. */
  collections?: Maybe<WixCatalogApiV2QueryCollectionsResponse>;
  customFields?: Maybe<Scalars['JSON']>;
  /** Store variant ID. Comprised of the `productId` and the `variantId`, separated by a hyphen: {productId}.{variantId}. */
  id?: Maybe<Scalars['String']>;
  /** Whether the variant is managed or represents a product. */
  managedVariant?: Maybe<Scalars['Boolean']>;
  /** Media items (images, videos) associated with this variant. */
  media?: Maybe<ComWixEcommerceCommonsApiPlatformMedia>;
  /** Preorder information. */
  preorderInfo?: Maybe<WixInventoryApiV1PreorderInfo>;
  /** Product ID. */
  product?: Maybe<WixCatalogApiV1Product>;
  /** Product ID. */
  productId?: Maybe<Scalars['String']>;
  /** Product name. */
  productName?: Maybe<Scalars['String']>;
  /** Variant SKU (stock keeping unit). */
  sku?: Maybe<Scalars['String']>;
  /** Variant inventory status. */
  stock?: Maybe<WixCatalogApiV1VariantStock>;
  /** Variant ID. */
  variantId?: Maybe<Scalars['String']>;
  /** Variant name. */
  variantName?: Maybe<Scalars['String']>;
};


export type WixCatalogApiV1StoreVariantCollectionsArgs = {
  queryInput?: InputMaybe<WixCatalogApiV2QueryCollectionsRequestInput>;
};

export type WixCatalogApiV1UpdateCollectionRequestInput = {
  /** Collection info. */
  collection?: InputMaybe<WixCatalogApiV1CollectionInput>;
};

export type WixCatalogApiV1UpdateCollectionResponse = {
  __typename?: 'WixCatalogApiV1UpdateCollectionResponse';
  /** Updated collection. */
  collection?: Maybe<WixCatalogApiV1Collection>;
};

export type WixCatalogApiV1UpdateProductPlatformizedRequestInput = {
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogApiV1UpdateProductPlatformizedResponse = {
  __typename?: 'WixCatalogApiV1UpdateProductPlatformizedResponse';
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1UpdateProductRequestInput = {
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogApiV1UpdateProductResponse = {
  __typename?: 'WixCatalogApiV1UpdateProductResponse';
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1UpdateVariantsRequestInput = {
  /** ID of the product with managed variants. */
  id?: InputMaybe<Scalars['String']>;
  /** Variant info to update. */
  variants?: InputMaybe<Array<InputMaybe<WixCatalogApiV1VariantOverrideInput>>>;
};

export type WixCatalogApiV1UpdateVariantsResponse = {
  __typename?: 'WixCatalogApiV1UpdateVariantsResponse';
  /** List of the product's variants. */
  variants?: Maybe<Array<Maybe<WixCatalogApiV1Variant>>>;
};

export type WixCatalogApiV1Variant = {
  __typename?: 'WixCatalogApiV1Variant';
  /** Specific choices within a selection, as option-choice key-value pairs */
  choices?: Maybe<Scalars['JSON']>;
  /** Requested Variant ID */
  id?: Maybe<Scalars['String']>;
  /** Variant inventory status. */
  stock?: Maybe<WixCatalogApiV1VariantStock>;
  variant?: Maybe<WixCatalogApiV1VariantDataWithNoStock>;
};

export type WixCatalogApiV1VariantData = {
  __typename?: 'WixCatalogApiV1VariantData';
  /** Variant price data converted to currency provided in header. */
  convertedPriceData?: Maybe<WixCatalogApiV1PriceData>;
  /** Whether the product is currently in stock (relevant only when tracking manually). */
  inStock?: Maybe<Scalars['Boolean']>;
  /** Variant price. */
  price?: Maybe<WixCatalogApiV1PriceData>;
  /** Quantity currently in inventory (relevant only when tracking by inventory). */
  quantity?: Maybe<Scalars['Int']>;
  /** Variant SKU (stock keeping unit). */
  sku?: Maybe<Scalars['String']>;
  /** Variant ID. */
  variantId?: Maybe<Scalars['String']>;
  /** Whether the variant is visible to customers. */
  visible?: Maybe<Scalars['Boolean']>;
  /** Variant weight. */
  weight?: Maybe<Scalars['Float']>;
};

export type WixCatalogApiV1VariantDataWithNoStock = {
  __typename?: 'WixCatalogApiV1VariantDataWithNoStock';
  /** Variant price data, converted to currency requested in header. */
  convertedPriceData?: Maybe<WixCatalogApiV1PriceData>;
  /** Cost and profit data. */
  costAndProfitData?: Maybe<WixCatalogApiV1CostAndProfitData>;
  /** Variant price. */
  priceData?: Maybe<WixCatalogApiV1PriceData>;
  /** Variant SKU (stock keeping unit). */
  sku?: Maybe<Scalars['String']>;
  /** Whether the variant is visible to customers. */
  visible?: Maybe<Scalars['Boolean']>;
  /** Variant weight. */
  weight?: Maybe<Scalars['Float']>;
};

export type WixCatalogApiV1VariantDataWithNoStockInput = {
  /** Variant price data, converted to currency requested in header. */
  convertedPriceData?: InputMaybe<WixCatalogApiV1PriceDataInput>;
  /** Cost and profit data. */
  costAndProfitData?: InputMaybe<WixCatalogApiV1CostAndProfitDataInput>;
  /** Variant price. */
  priceData?: InputMaybe<WixCatalogApiV1PriceDataInput>;
  /** Variant SKU (stock keeping unit). */
  sku?: InputMaybe<Scalars['String']>;
  /** Whether the variant is visible to customers. */
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Variant weight. */
  weight?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1VariantInput = {
  /** Specific choices within a selection, as option-choice key-value pairs */
  choices?: InputMaybe<Scalars['JSON']>;
  /** Requested Variant ID */
  id?: InputMaybe<Scalars['String']>;
  /** Variant inventory status. */
  stock?: InputMaybe<WixCatalogApiV1VariantStockInput>;
  variant?: InputMaybe<WixCatalogApiV1VariantDataWithNoStockInput>;
};

export type WixCatalogApiV1VariantOverrideInput = {
  /** The specific choices available or chosen from within a selection (e.g., choosing the red Selection triggers the red Choice). You may specify all the relevant choices for a specific variant, or only some of the options, which will return all corresponding variants (Not relevant when passing variant IDs) */
  choices?: InputMaybe<Scalars['JSON']>;
  /** Variant cost of goods */
  cost?: InputMaybe<Scalars['Float']>;
  /** Variant price */
  price?: InputMaybe<Scalars['Float']>;
  /** Variant SKU (stock keeping unit) */
  sku?: InputMaybe<Scalars['String']>;
  /**
   * List of variant IDs
   * (Not relevant when passing choices)
   */
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether the variant is visible to  customers */
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Variant weight */
  weight?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1VariantStock = {
  __typename?: 'WixCatalogApiV1VariantStock';
  /** Whether the product is currently in stock (relevant only when tracking manually). */
  inStock?: Maybe<Scalars['Boolean']>;
  /** The location of the inventory in question. None indicates the online-store default location. */
  locationId?: Maybe<Scalars['String']>;
  /** Quantity currently left in inventory. */
  quantity?: Maybe<Scalars['Int']>;
  /** Whether inventory is being tracked. */
  trackQuantity?: Maybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1VariantStockInput = {
  /** Whether the product is currently in stock (relevant only when tracking manually). */
  inStock?: InputMaybe<Scalars['Boolean']>;
  /** The location of the inventory in question. None indicates the online-store default location. */
  locationId?: InputMaybe<Scalars['String']>;
  /** Quantity currently left in inventory. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Whether inventory is being tracked. */
  trackQuantity?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV2QueryCollectionsRequestInput = {
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type WixCatalogApiV2QueryCollectionsResponse = {
  __typename?: 'WixCatalogApiV2QueryCollectionsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixCatalogApiV1Collection>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixCatalogWriteProxyV1CreateProductPlatformizedRequestInput = {
  /** Product information. */
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogWriteProxyV1CreateProductPlatformizedResponse = {
  __typename?: 'WixCatalogWriteProxyV1CreateProductPlatformizedResponse';
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogWriteProxyV1DeleteProductPlatformizedRequestInput = {
  /** ID of the product to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogWriteProxyV1UpdateProductPlatformizedRequestInput = {
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogWriteProxyV1UpdateProductPlatformizedResponse = {
  __typename?: 'WixCatalogWriteProxyV1UpdateProductPlatformizedResponse';
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCommonAddress = {
  __typename?: 'WixCommonAddress';
  /** Main address line, usually street and number as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Country code. */
  country?: Maybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: Maybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<WixCommonAddressLocation>;
  /** Free text to help find the address. */
  hint?: Maybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: Maybe<WixCommonStreetAddress>;
  /** Subdivision shorthand. Usually, a short code (2 or 3 letters) that represents a state, region, prefecture, or province. e.g. NY */
  subdivision?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: Maybe<Scalars['String']>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2), e.g. US-NY */
  subdivisionIso31662?: Maybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: Maybe<Array<Maybe<WixCommonSubdivision>>>;
};

export type WixCommonAddressInput = {
  /** Main address line, usually street and number as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Country code. */
  country?: InputMaybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<WixCommonAddressLocationInput>;
  /** Free text to help find the address. */
  hint?: InputMaybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: InputMaybe<WixCommonStreetAddressInput>;
  /** Subdivision shorthand. Usually, a short code (2 or 3 letters) that represents a state, region, prefecture, or province. e.g. NY */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: InputMaybe<Scalars['String']>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2), e.g. US-NY */
  subdivisionIso31662?: InputMaybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: InputMaybe<Array<InputMaybe<WixCommonSubdivisionInput>>>;
};

export type WixCommonAddressLocation = {
  __typename?: 'WixCommonAddressLocation';
  /** Address latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type WixCommonAddressLocationInput = {
  /** Address latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type WixCommonAggregationData = {
  __typename?: 'WixCommonAggregationData';
  /** List of the aggregated data results. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResults>>>;
};

export type WixCommonAggregationDataAggregationResults = {
  __typename?: 'WixCommonAggregationDataAggregationResults';
  /** Date histogram aggregation results. */
  dateHistogram?: Maybe<WixCommonAggregationDataAggregationResultsDateHistogramResults>;
  /** Field to aggregate by. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fieldPath?: Maybe<Scalars['String']>;
  /** Group by value aggregation results. */
  groupedByValue?: Maybe<WixCommonAggregationDataAggregationResultsGroupByValueResults>;
  /** Aggregation name, returned in `aggregations.results.name`. */
  name?: Maybe<Scalars['String']>;
  /** Nested aggregation results. */
  nested?: Maybe<WixCommonAggregationDataAggregationResultsNestedResults>;
  /** Range aggregation results. */
  ranges?: Maybe<WixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<WixCommonAggregationDataAggregationResultsScalarResult>;
  /** Aggregation type. Must align with the corresponding aggregation field. */
  type?: Maybe<WixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<WixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixCommonAggregationDataAggregationResultsDateHistogramResults = {
  __typename?: 'WixCommonAggregationDataAggregationResultsDateHistogramResults';
  /** List of date histogram aggregations. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>>;
};

export type WixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = {
  __typename?: 'WixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult';
  /** Number of entities in the bucket. */
  count?: Maybe<Scalars['Int']>;
  /** Date in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format. */
  value?: Maybe<Scalars['String']>;
};

export type WixCommonAggregationDataAggregationResultsGroupByValueResults = {
  __typename?: 'WixCommonAggregationDataAggregationResultsGroupByValueResults';
  /** List of value aggregations. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>>;
};

export type WixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = {
  __typename?: 'WixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult';
  /** Nested aggregations. */
  nestedResults?: Maybe<WixCommonAggregationDataAggregationResultsNestedAggregationResults>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixCommonAggregationDataAggregationResultsNestedAggregationResults = {
  __typename?: 'WixCommonAggregationDataAggregationResultsNestedAggregationResults';
  /** Field which the data was aggregated by. */
  fieldPath?: Maybe<Scalars['String']>;
  /** Unique, caller-defined aggregation name, identifiable by the requested aggregation `name`. */
  name?: Maybe<Scalars['String']>;
  /** Range aggregation results. */
  ranges?: Maybe<WixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<WixCommonAggregationDataAggregationResultsScalarResult>;
  /** Aggregation type. */
  type?: Maybe<WixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<WixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixCommonAggregationDataAggregationResultsNestedResults = {
  __typename?: 'WixCommonAggregationDataAggregationResultsNestedResults';
  /** List of nested aggregations. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResultsNestedResultsResults>>>;
};

export type WixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = {
  __typename?: 'WixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue';
  /** Date histogram aggregation result. */
  dateHistogram?: Maybe<WixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
  /** Range aggregation result. */
  range?: Maybe<WixCommonAggregationDataAggregationResultsNestedResultsRangeResult>;
  /** Scalar aggregation result. */
  scalar?: Maybe<WixCommonAggregationDataAggregationResultsNestedResultsScalarResult>;
  /** Value aggregation result. */
  value?: Maybe<WixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
};

export type WixCommonAggregationDataAggregationResultsNestedResultsRangeResult = {
  __typename?: 'WixCommonAggregationDataAggregationResultsNestedResultsRangeResult';
  /** Number of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type WixCommonAggregationDataAggregationResultsNestedResultsResults = {
  __typename?: 'WixCommonAggregationDataAggregationResultsNestedResultsResults';
  /** List of nested aggregations. */
  results?: Maybe<WixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>;
};

export type WixCommonAggregationDataAggregationResultsNestedResultsScalarResult = {
  __typename?: 'WixCommonAggregationDataAggregationResultsNestedResultsScalarResult';
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type WixCommonAggregationDataAggregationResultsNestedResultsValueResult = {
  __typename?: 'WixCommonAggregationDataAggregationResultsNestedResultsValueResult';
  /** Number of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixCommonAggregationDataAggregationResultsRangeResults = {
  __typename?: 'WixCommonAggregationDataAggregationResultsRangeResults';
  /** List of ranges returned in the same order as requested. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>>;
};

export type WixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = {
  __typename?: 'WixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult';
  /** Total number of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type WixCommonAggregationDataAggregationResultsScalarResult = {
  __typename?: 'WixCommonAggregationDataAggregationResultsScalarResult';
  /** Type of scalar aggregation. */
  type?: Maybe<WixCommonScalarType>;
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type WixCommonAggregationDataAggregationResultsValueResults = {
  __typename?: 'WixCommonAggregationDataAggregationResultsValueResults';
  /** List of value aggregations. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>>;
};

export type WixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = {
  __typename?: 'WixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult';
  /** Number of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixCommonAggregationDateHistogramAggregationInput = {
  /** Interval for date histogram aggregation. */
  interval?: InputMaybe<WixCommonAggregationDateHistogramAggregationInterval>;
};

export enum WixCommonAggregationDateHistogramAggregationInterval {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Second = 'SECOND',
  UnknownInterval = 'UNKNOWN_INTERVAL',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type WixCommonAggregationGroupByAggregationInput = {
  /** Field to aggregate by. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Unique, caller-defined aggregation name, returned in `aggregations.results`. */
  name?: InputMaybe<Scalars['String']>;
  /** Value aggregation configuration. */
  value?: InputMaybe<WixCommonAggregationValueAggregationInput>;
};

export type WixCommonAggregationInput = {
  /** A date histogram calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.) For example, use a date histogram to find how many reservations have been made at a restaurant each week. */
  dateHistogram?: InputMaybe<WixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Aggregation name, returned in `aggregations.results.name`. */
  name?: InputMaybe<Scalars['String']>;
  /** A nested aggregation is applied within the results of another aggregation. Rather than aggregating directly on the primary dataset, first group data using one aggregation and then apply another aggregation within each group. It allows for more complex analyses where you can summarize data at different levels of detail or hierarchy. For example, to get the number of products that are in stock and out of stock for each price listed, first perform a value aggregation on `discountedPriceNumeric`, and a second value aggregation on `inStock`. */
  nested?: InputMaybe<WixCommonAggregationNestedAggregationInput>;
  /** A range aggregation calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. For example, use a range aggregation to compare the number of reservations made for parties of 4 or less to the number of reservations made for parties with 5 or more. */
  range?: InputMaybe<WixCommonAggregationRangeAggregationInput>;
  /** A scalar aggregation calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  scalar?: InputMaybe<WixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation to perform. Must align with the corresponding aggregation field. */
  type?: InputMaybe<WixCommonAggregationType>;
  /** A value aggregation calculates metrics such as count for specific fields within a dataset, providing insights into the overall distribution and key statistics of those values. For example, use a value aggregation to get the number (count) of products for each price listed in the store. */
  value?: InputMaybe<WixCommonAggregationValueAggregationInput>;
};

export type WixCommonAggregationNestedAggregationInput = {
  /** Flattened list of aggregations, where each aggregation is nested within previous one. */
  nestedAggregations?: InputMaybe<Array<InputMaybe<WixCommonAggregationNestedAggregationNestedAggregationItemInput>>>;
};

export type WixCommonAggregationNestedAggregationNestedAggregationItemInput = {
  /** A date histogram calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). For example, use a date histogram to determine how many reservations have been made at a restaurant each week. If ranges overlap, a record that fits more than one range will only be counted in the first range that matches the criteria. */
  dateHistogram?: InputMaybe<WixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Unique, caller-defined aggregation name, returned in `aggregations.results`. */
  name?: InputMaybe<Scalars['String']>;
  /** A range aggregation calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. For example, use a range aggregation to compare the number of reservations made for parties of 4 or less to the number of reservations made for parties with 5 or more. If ranges overlap, a record that fits more than one range will only be counted in the first range that matches the criteria. */
  range?: InputMaybe<WixCommonAggregationRangeAggregationInput>;
  /** A scalar aggregation calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  scalar?: InputMaybe<WixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation to perform. The matching aggregation field must be passed. */
  type?: InputMaybe<WixCommonAggregationNestedAggregationNestedAggregationType>;
  /** A value aggregation calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. For example, use a value aggregation to get the number (count) of orders for each order status. */
  value?: InputMaybe<WixCommonAggregationValueAggregationInput>;
};

export enum WixCommonAggregationNestedAggregationNestedAggregationType {
  /** Calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). */
  DateHistogram = 'DATE_HISTOGRAM',
  /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
  Range = 'RANGE',
  /** Calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  Scalar = 'SCALAR',
  UnknownAggregationType = 'UNKNOWN_AGGREGATION_TYPE',
  /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
  Value = 'VALUE'
}

export type WixCommonAggregationRangeAggregationInput = {
  /** List of range buckets. During aggregation each entity is placed in the first bucket its value falls into, based on the provided range bounds. */
  buckets?: InputMaybe<Array<InputMaybe<WixCommonAggregationRangeAggregationRangeBucketInput>>>;
};

export type WixCommonAggregationRangeAggregationRangeBucketInput = {
  /** Inclusive lower bound of the range. Required if `to` is not provided. */
  from?: InputMaybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. Required if `from` is not provided. */
  to?: InputMaybe<Scalars['Float']>;
};

export type WixCommonAggregationScalarAggregationInput = {
  /** Operator type for the scalar aggregation. */
  type?: InputMaybe<WixCommonScalarType>;
};

export enum WixCommonAggregationType {
  /** Calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). */
  DateHistogram = 'DATE_HISTOGRAM',
  /** Flattened list of aggregations, where each aggregation is nested within previous one. */
  Nested = 'NESTED',
  /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
  Range = 'RANGE',
  /** Calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  Scalar = 'SCALAR',
  UnknownAggregationType = 'UNKNOWN_AGGREGATION_TYPE',
  /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
  Value = 'VALUE'
}

export type WixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = {
  /** Specify a custom name for the bucket containing the missing values. Defaults are `"N/A"` for strings, `0` for integers, and `false` for booleans. */
  addToBucket?: InputMaybe<Scalars['String']>;
};

export type WixCommonAggregationValueAggregationInput = {
  /** Options for including missing values in results. */
  includeOptions?: InputMaybe<WixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>;
  /**
   * Number of aggregation results to return.
   * Min: `1`
   * Max: `250`
   * Default: `10`
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Whether to include or exclude missing values in the aggregation results.
   * Default: `EXCLUDE`.
   */
  missingValues?: InputMaybe<WixCommonAggregationValueAggregationMissingValues>;
  /** Sort direction. */
  sortDirection?: InputMaybe<WixCommonAggregationValueAggregationSortDirection>;
  /** Sort type. */
  sortType?: InputMaybe<WixCommonAggregationValueAggregationSortType>;
};

export enum WixCommonAggregationValueAggregationMissingValues {
  /** Exclude missing values from the aggregation results. */
  Exclude = 'EXCLUDE',
  /** Include missing values in the aggregation results. */
  Include = 'INCLUDE'
}

export enum WixCommonAggregationValueAggregationSortDirection {
  /** Ascending order. */
  Asc = 'ASC',
  /** Descending order. */
  Desc = 'DESC'
}

export enum WixCommonAggregationValueAggregationSortType {
  /** Number of matches in the results. */
  Count = 'COUNT',
  /** Alphabetically by the field value. */
  Value = 'VALUE'
}

export type WixCommonAudio = {
  __typename?: 'WixCommonAudio';
  /**
   * Key to identify the object relationship to the original media in WixMedia.
   * Can be used to request a download for the specific asset.
   * For example: 128-30kbs.mp3, 320kbs.mp3, 128kbs.mp3
   */
  assetKey?: Maybe<Scalars['String']>;
  /** Audio duration in milliseconds. */
  duration?: Maybe<Scalars['Int']>;
  /** Audio filename. */
  filename?: Maybe<Scalars['String']>;
  /** Audio format. */
  format?: Maybe<Scalars['String']>;
  /** WixMedia ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * When true, this is a protected asset, and calling the URL will return a 403 error.
   * In order to access private assets, make a request to:
   * `GenerateFileDownloadUrl` with the WixMedia id and specify the asset_key in the request
   */
  private?: Maybe<Scalars['Boolean']>;
  /** Audio quality. */
  quality?: Maybe<Scalars['String']>;
  /** Audio size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Audio URL. */
  url?: Maybe<Scalars['String']>;
  /** Audio URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
};

export type WixCommonAudioInput = {
  /**
   * Key to identify the object relationship to the original media in WixMedia.
   * Can be used to request a download for the specific asset.
   * For example: 128-30kbs.mp3, 320kbs.mp3, 128kbs.mp3
   */
  assetKey?: InputMaybe<Scalars['String']>;
  /** Audio duration in milliseconds. */
  duration?: InputMaybe<Scalars['Int']>;
  /** Audio filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Audio format. */
  format?: InputMaybe<Scalars['String']>;
  /** WixMedia ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * When true, this is a protected asset, and calling the URL will return a 403 error.
   * In order to access private assets, make a request to:
   * `GenerateFileDownloadUrl` with the WixMedia id and specify the asset_key in the request
   */
  private?: InputMaybe<Scalars['Boolean']>;
  /** Audio quality. */
  quality?: InputMaybe<Scalars['String']>;
  /** Audio size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Audio URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Audio URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
};

export type WixCommonBulkActionMetadata = {
  __typename?: 'WixCommonBulkActionMetadata';
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export enum WixCommonBulkActionType {
  Delete = 'DELETE',
  Insert = 'INSERT',
  UnknownActionType = 'UNKNOWN_ACTION_TYPE',
  Update = 'UPDATE'
}

export type WixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixCommonCursorPagingMetadata = {
  __typename?: 'WixCommonCursorPagingMetadata';
  /** Number of items returned in current page. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<WixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /**
   * Total number of items matching the filter.
   * Available only on the first page of *Search* results, not included in *Query* or *List* results.
   * If the Search results span multiple pages, the value of `total` will exceed the number of items returned on the first page.
   */
  total?: Maybe<Scalars['Int']>;
};

export type WixCommonCursorSearchInput = {
  /** Logical groupings of data into facets, with summaries for each facet. For example, use aggregations to allow site visitors to narrow down their search results by selecting specific categories. */
  aggregations?: InputMaybe<Array<InputMaybe<WixCommonAggregationInput>>>;
  /**
   * Cursor paging options.
   *
   * Learn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).
   */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about [filtering](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Free text to match in searchable fields. */
  search?: InputMaybe<WixCommonSearchDetailsInput>;
  /**
   * List of sort objects.
   *
   * Learn more about [sorting](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
  /**
   * Time zone to adjust date-time-based filters and aggregations, in ISO 8601 (including offsets) or IANA time zone database (including time zone IDs) format.
   * Applies to all relevant filters and aggregations, unless overridden by providing timestamps including time zone. For example, "2023-12-20T10:52:34.795Z".
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCommonCursors = {
  __typename?: 'WixCommonCursors';
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixCommonDataDataextensionsExtendedFields = {
  __typename?: 'WixCommonDataDataextensionsExtendedFields';
  /**
   * Extended field data. Each key corresponds to the namespace of the app that created the extended fields.
   * The value of each key is structured according to the schema defined when the extended fields were configured.
   *
   * You can only access fields for which you have the appropriate permissions.
   *
   * Learn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).
   */
  namespaces?: Maybe<Scalars['JSON']>;
};

export type WixCommonDataDataextensionsExtendedFieldsInput = {
  /**
   * Extended field data. Each key corresponds to the namespace of the app that created the extended fields.
   * The value of each key is structured according to the schema defined when the extended fields were configured.
   *
   * You can only access fields for which you have the appropriate permissions.
   *
   * Learn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).
   */
  namespaces?: InputMaybe<Scalars['JSON']>;
};

export type WixCommonDataDataextensionsUpdateExtendedFieldsRequestInput = {
  /** ID of the entity to update. */
  id?: InputMaybe<Scalars['String']>;
  /** Identifier for the app whose extended fields are being updated. */
  namespace?: InputMaybe<Scalars['String']>;
  /** Data to update. Structured according to the [schema](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields#json-schema-for-extended-fields) defined when the extended fields were configured. */
  namespaceData?: InputMaybe<Scalars['JSON']>;
};

export type WixCommonDocument = {
  __typename?: 'WixCommonDocument';
  /** Document filename. */
  filename?: Maybe<Scalars['String']>;
  /** WixMedia ID. */
  id?: Maybe<Scalars['String']>;
  /** Document size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Document thumbnail. */
  thumbnail?: Maybe<WixCommonImage>;
  /** Document URL. */
  url?: Maybe<Scalars['String']>;
  /** Document URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
};

export type WixCommonDocumentInput = {
  /** Document filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** WixMedia ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Document size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Document thumbnail. */
  thumbnail?: InputMaybe<WixCommonImageInput>;
  /** Document URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Document URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
};

export type WixCommonDomaineventsActionEventInput = {
  bodyAsJson?: InputMaybe<Scalars['String']>;
};

export type WixCommonDomaineventsDomainEventInput = {
  actionEvent?: InputMaybe<WixCommonDomaineventsActionEventInput>;
  createdEvent?: InputMaybe<WixCommonDomaineventsEntityCreatedEventInput>;
  deletedEvent?: InputMaybe<WixCommonDomaineventsEntityDeletedEventInput>;
  /**
   * A sequence number defining the order of updates to the underlying entity.
   * For example, given that some entity was updated at 16:00 and than again at 16:01,
   * it is guaranteed that the sequence number of the second update is strictly higher than the first.
   * As the consumer, you can use this value to ensure that you handle messages in the correct order.
   * To do so, you will need to persist this number on your end, and compare the sequence number from the
   * message against the one you have stored. Given that the stored number is higher, you should ignore the message.
   */
  entityEventSequence?: InputMaybe<Scalars['Long']>;
  /**
   * Assumes actions are also always typed to an entity_type
   * Example: wix.stores.catalog.product, wix.bookings.session, wix.payments.transaction
   */
  entityFqdn?: InputMaybe<Scalars['String']>;
  /** ID of the entity associated with the event. */
  entityId?: InputMaybe<Scalars['String']>;
  /** Event timestamp. */
  eventTime?: InputMaybe<Scalars['String']>;
  /**
   * Unique event ID.
   * Allows clients to ignore duplicate webhooks.
   */
  id?: InputMaybe<Scalars['String']>;
  /** If present, indicates the action that triggered the event. */
  originatedFrom?: InputMaybe<Scalars['String']>;
  /**
   * This is top level to ease client code dispatching of messages (switch on entity_fqdn+slug)
   * This is although the created/updated/deleted notion is duplication of the oneof types
   * Example: created/updated/deleted/started/completed/email_opened
   */
  slug?: InputMaybe<Scalars['String']>;
  /**
   * Whether the event was triggered as a result of a privacy regulation application
   * (for example, GDPR).
   */
  triggeredByAnonymizeRequest?: InputMaybe<Scalars['Boolean']>;
  updatedEvent?: InputMaybe<WixCommonDomaineventsEntityUpdatedEventInput>;
};

export type WixCommonDomaineventsEntityCreatedEventInput = {
  entityAsJson?: InputMaybe<Scalars['String']>;
  /** Indicates the event was triggered by a restore-from-trashbin operation for a previously deleted entity */
  triggeredByUndelete?: InputMaybe<Scalars['Boolean']>;
};

export type WixCommonDomaineventsEntityDeletedEventInput = {
  /** Entity that was deleted */
  deletedEntityAsJson?: InputMaybe<Scalars['String']>;
  /** Indicates if the entity is sent to trash-bin. only available when trash-bin is enabled */
  movedToTrash?: InputMaybe<Scalars['Boolean']>;
};

export type WixCommonDomaineventsEntityUpdatedEventInput = {
  /**
   * Since platformized APIs only expose PATCH and not PUT we can't assume that the fields sent from the client are the actual diff.
   * This means that to generate a list of changed fields (as opposed to sent fields) one needs to traverse both objects.
   * We don't want to impose this on all developers and so we leave this traversal to the notification recipients which need it.
   */
  currentEntityAsJson?: InputMaybe<Scalars['String']>;
  /**
   * WIP - This property will hold both names and values of the updated fields of the entity.
   * For more details please see [adr](https://docs.google.com/document/d/1PdqsOM20Ph2HAkmx8zvUnzzk3Sekp3BR9h34wSvsRnI/edit#heading=h.phlw87mh2imx) or [issue](https://github.com/wix-private/nile-tracker/issues/363)
   */
  modifiedFields?: InputMaybe<Scalars['JSON']>;
  /**
   * This field is currently part of the of the EntityUpdatedEvent msg, but scala/node libraries which implements the domain events standard
   * wont populate it / have any reference to it in the API.
   * The main reason for it is that fetching the old entity from the DB will have a performance hit on an update operation so unless truly needed,
   * the developer should send only the new (current) entity.
   * An additional reason is not wanting to send this additional entity over the wire (kafka) since in some cases it can be really big
   * Developers that must reflect the old entity will have to implement their own domain event sender mechanism which will follow the DomainEvent proto message.
   */
  previousEntityAsJson?: InputMaybe<Scalars['String']>;
};

export type WixCommonFocalPoint = {
  __typename?: 'WixCommonFocalPoint';
  /** crop by height */
  height?: Maybe<Scalars['Int']>;
  /** crop by width */
  width?: Maybe<Scalars['Int']>;
  /** X-coordinate of the focal point. */
  x?: Maybe<Scalars['Float']>;
  /** Y-coordinate of the focal point. */
  y?: Maybe<Scalars['Float']>;
};

export type WixCommonFocalPointInput = {
  /** crop by height */
  height?: InputMaybe<Scalars['Int']>;
  /** crop by width */
  width?: InputMaybe<Scalars['Int']>;
  /** X-coordinate of the focal point. */
  x?: InputMaybe<Scalars['Float']>;
  /** Y-coordinate of the focal point. */
  y?: InputMaybe<Scalars['Float']>;
};

export type WixCommonFullAddressContactDetailsInput = {
  /** Contact's company name. */
  company?: InputMaybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: InputMaybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Tax info. Currently usable only in Brazil. */
  vatId?: InputMaybe<WixCommonVatIdInput>;
};

export type WixCommonImage = {
  __typename?: 'WixCommonImage';
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Focal point of the image. */
  focalPoint?: Maybe<WixCommonFocalPoint>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Focal point of the image. */
  focalPoint?: InputMaybe<WixCommonFocalPointInput>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixCommonItemMetadata = {
  __typename?: 'WixCommonItemMetadata';
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export enum WixCommonLinkRel {
  /** Indicates that the current document's original author or publisher does not endorse the referenced document. */
  Nofollow = 'nofollow',
  /** Instructs the browser to navigate to the target resource without granting the new browsing context access to the document that opened it. */
  Noopener = 'noopener',
  /** No Referer header will be included. Additionally, has the same effect as noopener. */
  Noreferrer = 'noreferrer',
  /** Indicates a link that resulted from advertisements or paid placements. */
  Sponsored = 'sponsored',
  /** default (not implemented) */
  UnknownLinkRel = 'unknown_link_rel'
}

export type WixCommonPageLink = {
  __typename?: 'WixCommonPageLink';
  /** The page id we want from the site */
  pageId?: Maybe<Scalars['String']>;
  /** rel of link */
  rel?: Maybe<Array<Maybe<WixCommonLinkRel>>>;
  /** Where this link should open, supports _self and _blank or any name the user chooses. _self means same page, _blank means new page. */
  target?: Maybe<Scalars['String']>;
};

export type WixCommonPageLinkInput = {
  /** The page id we want from the site */
  pageId?: InputMaybe<Scalars['String']>;
  /** rel of link */
  rel?: InputMaybe<Array<InputMaybe<WixCommonLinkRel>>>;
  /** Where this link should open, supports _self and _blank or any name the user chooses. _self means same page, _blank means new page. */
  target?: InputMaybe<Scalars['String']>;
};

export type WixCommonPageUrl = {
  __typename?: 'WixCommonPageUrl';
  /** The base URL. For premium sites, this is the domain. For free sites, this is the site URL. For example, `mysite.wixsite.com/mysite`. */
  base?: Maybe<Scalars['String']>;
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  path?: Maybe<Scalars['String']>;
};

export type WixCommonPageUrlInput = {
  /** The base URL. For premium sites, this is the domain. For free sites, this is the site URL. For example, `mysite.wixsite.com/mysite`. */
  base?: InputMaybe<Scalars['String']>;
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  path?: InputMaybe<Scalars['String']>;
};

export type WixCommonPageUrlV2 = {
  __typename?: 'WixCommonPageUrlV2';
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  relativePath?: Maybe<Scalars['String']>;
  /** The page's full URL. For example, `https://mysite.com/product-page/a-product`. */
  url?: Maybe<Scalars['String']>;
};

export type WixCommonPageUrlV2Input = {
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  relativePath?: InputMaybe<Scalars['String']>;
  /** The page's full URL. For example, `https://mysite.com/product-page/a-product`. */
  url?: InputMaybe<Scalars['String']>;
};

export type WixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixCommonPagingMetadata = {
  __typename?: 'WixCommonPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. */
  total?: Maybe<Scalars['Int']>;
};

export type WixCommonPagingMetadataV2 = {
  __typename?: 'WixCommonPagingMetadataV2';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<WixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set. */
  total?: Maybe<Scalars['Int']>;
};

export type WixCommonQueryInput = {
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type WixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Learn more about [filtering](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and offset the number of items. */
  paging?: InputMaybe<WixCommonPagingInput>;
  /**
   * Sort object.
   *
   * Learn more about [sorting](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export enum WixCommonScalarType {
  /** Average of values. */
  Avg = 'AVG',
  /** Total number of distinct values. */
  CountDistinct = 'COUNT_DISTINCT',
  /** Maximum value. */
  Max = 'MAX',
  /** Minimum value. */
  Min = 'MIN',
  /** Sum of values. */
  Sum = 'SUM',
  UnknownScalarType = 'UNKNOWN_SCALAR_TYPE'
}

export type WixCommonSearchDetailsInput = {
  /** Search term or expression. */
  expression?: InputMaybe<Scalars['String']>;
  /** Fields to search in. If the array is empty, all searchable fields are searched. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to enable the search function to use an algorithm to automatically find results that are close to the search expression, such as typos and declensions. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Search mode. Defines the search logic for combining multiple terms in the `expression`. */
  mode?: InputMaybe<WixCommonSearchDetailsMode>;
};

export enum WixCommonSearchDetailsMode {
  /** All search terms must be present. */
  And = 'AND',
  /** At least one of the search terms must be present. */
  Or = 'OR'
}

export enum WixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type WixCommonStreetAddress = {
  __typename?: 'WixCommonStreetAddress';
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type WixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type WixCommonSubdivision = {
  __typename?: 'WixCommonSubdivision';
  /** Short subdivision code. */
  code?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: Maybe<Scalars['String']>;
  /** Standard organizations details (e.g. ISO). */
  standardDetails?: Maybe<WixCommonSubdivisionStandardDetails>;
  /** Subdivision level */
  type?: Maybe<WixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: Maybe<Scalars['String']>;
};

export type WixCommonSubdivisionInput = {
  /** Short subdivision code. */
  code?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: InputMaybe<Scalars['String']>;
  /** Standard organizations details (e.g. ISO). */
  standardDetails?: InputMaybe<WixCommonSubdivisionStandardDetailsInput>;
  /** Subdivision level */
  type?: InputMaybe<WixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: InputMaybe<Scalars['String']>;
};

export type WixCommonSubdivisionStandardDetails = {
  __typename?: 'WixCommonSubdivisionStandardDetails';
  /** subdivision iso-3166-2 code according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). e.g. US-NY, GB-SCT, NO-30 */
  iso31662?: Maybe<Scalars['String']>;
};

export type WixCommonSubdivisionStandardDetailsInput = {
  /** subdivision iso-3166-2 code according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). e.g. US-NY, GB-SCT, NO-30 */
  iso31662?: InputMaybe<Scalars['String']>;
};

export enum WixCommonSubdivisionSubdivisionType {
  /** State */
  AdministrativeAreaLevel_1 = 'ADMINISTRATIVE_AREA_LEVEL_1',
  /** County */
  AdministrativeAreaLevel_2 = 'ADMINISTRATIVE_AREA_LEVEL_2',
  /** City/town */
  AdministrativeAreaLevel_3 = 'ADMINISTRATIVE_AREA_LEVEL_3',
  /** Neighborhood/quarter */
  AdministrativeAreaLevel_4 = 'ADMINISTRATIVE_AREA_LEVEL_4',
  /** Street/block */
  AdministrativeAreaLevel_5 = 'ADMINISTRATIVE_AREA_LEVEL_5',
  /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
  Country = 'COUNTRY',
  UnknownSubdivisionType = 'UNKNOWN_SUBDIVISION_TYPE'
}

export type WixCommonTagsTags = {
  __typename?: 'WixCommonTagsTags';
  /** Tags that require an additional permission in order to access them, normally not given to site members or visitors. */
  privateTags?: Maybe<WixCommonTagsTagsTagList>;
  /** Tags that are exposed to anyone who has access to the labeled entity itself, including site members and visitors. */
  tags?: Maybe<WixCommonTagsTagsTagList>;
};

export type WixCommonTagsTagsInput = {
  /** Tags that require an additional permission in order to access them, normally not given to site members or visitors. */
  privateTags?: InputMaybe<WixCommonTagsTagsTagListInput>;
  /** Tags that are exposed to anyone who has access to the labeled entity itself, including site members and visitors. */
  tags?: InputMaybe<WixCommonTagsTagsTagListInput>;
};

export type WixCommonTagsTagsTagList = {
  __typename?: 'WixCommonTagsTagsTagList';
  /** List of tag IDs */
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixCommonTagsTagsTagListInput = {
  /** List of tag IDs */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCommonVatId = {
  __typename?: 'WixCommonVatId';
  /** Customer's tax ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: Maybe<WixCommonVatType>;
};

export type WixCommonVatIdInput = {
  /** Customer's tax ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: InputMaybe<WixCommonVatType>;
};

export enum WixCommonVatType {
  /** CNPJ - for corporations */
  Cnpj = 'CNPJ',
  /** CPF - for individual tax payers. */
  Cpf = 'CPF',
  Unspecified = 'UNSPECIFIED'
}

export type WixCommonVideo = {
  __typename?: 'WixCommonVideo';
  /** Original image height */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia ID */
  id?: Maybe<Scalars['String']>;
  /** Video poster */
  thumbnail?: Maybe<WixCommonImage>;
  /** URL of video */
  url?: Maybe<Scalars['String']>;
  /** Original image width */
  width?: Maybe<Scalars['Int']>;
};

export type WixCommonVideoResolution = {
  __typename?: 'WixCommonVideoResolution';
  /**
   * Key to identify the video resolution's relationship to the original media in WixMedia.
   * Can be used to request a download for the specific video resolution.
   * For example: 480p.mp4, 720p.mp4, 1080p.mp4, trailer-720p.mp4, clip-720p.mp4
   */
  assetKey?: Maybe<Scalars['String']>;
  /** Video duration in milliseconds. */
  durationInMilliseconds?: Maybe<Scalars['Int']>;
  /**
   * Video duration in seconds.
   * @deprecated Video duration in seconds. Replaced by: duration_in_milliseconds. Removal date: 2024-08-01.
   */
  durationInSeconds?: Maybe<Scalars['Int']>;
  /** Video filename. */
  filename?: Maybe<Scalars['String']>;
  /** Video format for example, mp4, hls. */
  format?: Maybe<Scalars['String']>;
  /** Video height. */
  height?: Maybe<Scalars['Int']>;
  /** Deprecated. Use the `posters` property in the parent entity instead. */
  poster?: Maybe<WixCommonImage>;
  /**
   * When true, this is a protected asset, and calling the URL will return a 403 error.
   * In order to access private assets, make a request to:
   * `GenerateFileDownloadUrl` with the WixMedia id and specify the asset_key in the request
   */
  private?: Maybe<Scalars['Boolean']>;
  /** Video quality. For example: 480p, 720p. */
  quality?: Maybe<Scalars['String']>;
  /** Deprecated. Use the `sizeInBytes` property in the parent entity instead. Size cannot be provided per resolution. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Video URL. */
  url?: Maybe<Scalars['String']>;
  /** Deprecated. Use the `urlExpirationDate` property in the parent entity instead. */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Video width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixCommonVideoResolutionInput = {
  /**
   * Key to identify the video resolution's relationship to the original media in WixMedia.
   * Can be used to request a download for the specific video resolution.
   * For example: 480p.mp4, 720p.mp4, 1080p.mp4, trailer-720p.mp4, clip-720p.mp4
   */
  assetKey?: InputMaybe<Scalars['String']>;
  /** Video duration in milliseconds. */
  durationInMilliseconds?: InputMaybe<Scalars['Int']>;
  /** Video filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Video format for example, mp4, hls. */
  format?: InputMaybe<Scalars['String']>;
  /** Video height. */
  height?: InputMaybe<Scalars['Int']>;
  /** Deprecated. Use the `posters` property in the parent entity instead. */
  poster?: InputMaybe<WixCommonImageInput>;
  /**
   * When true, this is a protected asset, and calling the URL will return a 403 error.
   * In order to access private assets, make a request to:
   * `GenerateFileDownloadUrl` with the WixMedia id and specify the asset_key in the request
   */
  private?: InputMaybe<Scalars['Boolean']>;
  /** Video quality. For example: 480p, 720p. */
  quality?: InputMaybe<Scalars['String']>;
  /** Deprecated. Use the `sizeInBytes` property in the parent entity instead. Size cannot be provided per resolution. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Video URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Deprecated. Use the `urlExpirationDate` property in the parent entity instead. */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Video width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixCommonVideoV2 = {
  __typename?: 'WixCommonVideoV2';
  /** A long description for the video. will be used for SEO purposes. */
  description?: Maybe<Scalars['String']>;
  /** Original video duration in milliseconds. */
  durationInMilliseconds?: Maybe<Scalars['Int']>;
  /** Video filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original video height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia ID. */
  id?: Maybe<Scalars['String']>;
  /** Video posters. */
  posters?: Maybe<Array<Maybe<WixCommonImage>>>;
  /** Available resolutions for the video, starting with the optimal resolution. */
  resolutions?: Maybe<Array<Maybe<WixCommonVideoResolution>>>;
  /** Original video size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** A short title for the video. will be used for SEO purposes. */
  title?: Maybe<Scalars['String']>;
  /** Original video URL. */
  url?: Maybe<Scalars['String']>;
  /** Video URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original video width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixCommonVideoV2Input = {
  /** A long description for the video. will be used for SEO purposes. */
  description?: InputMaybe<Scalars['String']>;
  /** Original video duration in milliseconds. */
  durationInMilliseconds?: InputMaybe<Scalars['Int']>;
  /** Video filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original video height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Video posters. */
  posters?: InputMaybe<Array<InputMaybe<WixCommonImageInput>>>;
  /** Available resolutions for the video, starting with the optimal resolution. */
  resolutions?: InputMaybe<Array<InputMaybe<WixCommonVideoResolutionInput>>>;
  /** Original video size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** A short title for the video. will be used for SEO purposes. */
  title?: InputMaybe<Scalars['String']>;
  /** Original video URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Video URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original video width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixCoreservicesMetroinspectorV1EchoMessage = {
  __typename?: 'WixCoreservicesMetroinspectorV1EchoMessage';
  id?: Maybe<Scalars['String']>;
  /** message comment from EchoMessage proto def, with special comment */
  message?: Maybe<Scalars['String']>;
  /** messages_list comment from EchoMessage proto def */
  messagesList?: Maybe<Array<Maybe<WixCoreservicesMetroinspectorV1MessageItem>>>;
};

export type WixCoreservicesMetroinspectorV1EchoRequestInput = {
  /** 1st part of the message */
  arg1?: InputMaybe<Scalars['String']>;
  /** 2nd part of the message */
  arg2?: InputMaybe<Scalars['String']>;
  someDate?: InputMaybe<Scalars['String']>;
  someInt32?: InputMaybe<Scalars['Int']>;
  /** this field test translatable annotation */
  titleField?: InputMaybe<Scalars['String']>;
};

export type WixCoreservicesMetroinspectorV1EchoResponse = {
  __typename?: 'WixCoreservicesMetroinspectorV1EchoResponse';
  /** message result as EchoMessage */
  echoMessage?: Maybe<WixCoreservicesMetroinspectorV1EchoMessage>;
  /** messge reseult as string */
  message?: Maybe<Scalars['String']>;
};

export type WixCoreservicesMetroinspectorV1MessageItem = {
  __typename?: 'WixCoreservicesMetroinspectorV1MessageItem';
  /** inner_message comment from EchoMessage proto def */
  innerMessage?: Maybe<Scalars['String']>;
};

export type WixCouponsApiV2Scope = {
  __typename?: 'WixCouponsApiV2Scope';
  /** Coupon scope's applied group (e.g., event or ticket in Wix Events) */
  group?: Maybe<WixCouponsApiV2ScopeGroup>;
  /** Scope namespace (Wix Stores, Wix Bookings, Wix Events, Wix Pricing Plans) */
  namespace?: Maybe<Scalars['String']>;
};

export type WixCouponsApiV2ScopeGroup = {
  __typename?: 'WixCouponsApiV2ScopeGroup';
  /** Item ID (when the coupon scope is limited to just one item). */
  entityId?: Maybe<Scalars['String']>;
  /** Coupon scope's group (e.g., product or collection in Wix Stores). See [valid scope values](https://dev.wix.com/api/rest/coupons/coupons/valid-scope-values). */
  name?: Maybe<Scalars['String']>;
};

export type WixCouponsApiV2ScopeGroupInput = {
  /** Item ID (when the coupon scope is limited to just one item). */
  entityId?: InputMaybe<Scalars['String']>;
  /** Coupon scope's group (e.g., product or collection in Wix Stores). See [valid scope values](https://dev.wix.com/api/rest/coupons/coupons/valid-scope-values). */
  name?: InputMaybe<Scalars['String']>;
};

export type WixCouponsApiV2ScopeInput = {
  /** Coupon scope's applied group (e.g., event or ticket in Wix Events) */
  group?: InputMaybe<WixCouponsApiV2ScopeGroupInput>;
  /** Scope namespace (Wix Stores, Wix Bookings, Wix Events, Wix Pricing Plans) */
  namespace?: InputMaybe<Scalars['String']>;
};

export type WixCrmCommonSourceInput = {
  /** Source app or service ID. */
  sourceId?: InputMaybe<Scalars['String']>;
  /** App or service type. */
  sourceType?: InputMaybe<WixCrmCommonSourceSourceType>;
};

export enum WixCrmCommonSourceSourceType {
  Admin = 'ADMIN',
  External = 'EXTERNAL',
  Other = 'OTHER',
  UnknownSourceType = 'UNKNOWN_SOURCE_TYPE',
  WixApp = 'WIX_APP'
}

export type WixEcomOrdersBackofficeV1GetMetasiteDataRequestInput = {
  /** meta site Id for data to retrieve */
  metasiteId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetMetasiteDataResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1GetMetasiteDataResponse';
  /** is metasite added to new SDL population via population manager */
  isInNewPopulation?: Maybe<Scalars['Boolean']>;
  /** meta site data */
  metasite?: Maybe<ComWixpressMetasiteApiV1MetaSite>;
  /** metasite url */
  metasiteUrl?: Maybe<Scalars['String']>;
  /** owner data */
  userDataResponse?: Maybe<WixEcomOrdersBackofficeV1UserDataResponse>;
};

export type WixEcomOrdersBackofficeV1GetOrderAgcRequestInput = {
  /** Order Id for EP order to retrieve */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderAgcResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1GetOrderAgcResponse';
  /** Order id if found */
  orderId?: Maybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderForMetasiteRequestInput = {
  /** meta site Id for EP order to retrieve */
  metasiteId?: InputMaybe<Scalars['String']>;
  /** Order Id for EP order to retrieve */
  orderId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderForMetasiteResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1GetOrderForMetasiteResponse';
  /** Existing EP order */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type WixEcomOrdersBackofficeV1GetOrderOutOfBoxRequestInput = {
  /** Order Id for EP order to retrieve */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderOutOfBoxResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1GetOrderOutOfBoxResponse';
  /** Order id if found */
  orderId?: Maybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderWithFilterByLocationRequestInput = {
  /** Order Id for EP order to retrieve */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderWithFilterByLocationResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1GetOrderWithFilterByLocationResponse';
  /** Order id if found */
  orderId?: Maybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteRequestInput = {
  /** meta site Id for EP order transactions to retrieve */
  metasiteId?: InputMaybe<Scalars['String']>;
  /** Order Id for EP order transactions to retrieve */
  orderId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteResponse';
  /** Order ID and its associated transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type WixEcomOrdersBackofficeV1ListOrdersForMetasiteRequestInput = {
  /** paginated orders request */
  listOrderRequest?: InputMaybe<ComWixEcomOrdersV1ListOrdersRequestInput>;
  /** meta site Id for EP orders to retrieve */
  metasiteId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1ListOrdersForMetasiteResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1ListOrdersForMetasiteResponse';
  /** found exisitng orders according to pagination provided. */
  orders?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<WixCommonCursorPagingMetadata>;
};

export type WixEcomOrdersBackofficeV1QueryOrdersForMetasiteRequestInput = {
  /** paginated internal orders query request */
  internalQueryOrdersRequest?: InputMaybe<ComWixEcomOrdersV1InternalQueryOrdersRequestInput>;
  /** meta site Id for EP orders to retrieve */
  metasiteId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1QueryOrdersForMetasiteResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1QueryOrdersForMetasiteResponse';
  /** found exisitng orders according to pagination and query provided. */
  orders?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixEcommerceCommonsApiPlatformPagingMetadata>;
};

export type WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsRequestInput = {
  testId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsResponse';
  responseString?: Maybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1UpdateOrderRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order to be updated. */
  order?: InputMaybe<ComWixEcomOrdersV1OrderInput>;
};

export type WixEcomOrdersBackofficeV1UpdateOrderResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1UpdateOrderResponse';
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type WixEcomOrdersBackofficeV1UpsertRefundRequestInput = {
  /** Meta site ID. */
  metasiteId?: InputMaybe<Scalars['String']>;
  /** Order ID associated with refund. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund to upsert. */
  refund?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundInput>;
};

export type WixEcomOrdersBackofficeV1UpsertRefundResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1UpsertRefundResponse';
  /** Updated order transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type WixEcomOrdersBackofficeV1UserDataResponse = {
  __typename?: 'WixEcomOrdersBackofficeV1UserDataResponse';
  userEmail?: Maybe<Scalars['String']>;
  /** owner language */
  userLanguage?: Maybe<Scalars['String']>;
  /** owner name */
  userName?: Maybe<Scalars['String']>;
  /** owner status */
  userStatus?: Maybe<Scalars['String']>;
};

export enum WixEcommerceSubscriptionOptionApiV1DiscountDiscountType {
  /** No discount */
  Amount = 'AMOUNT',
  Percent = 'PERCENT',
  Undefined = 'UNDEFINED'
}

export type WixEcommerceSubscriptionOptionApiV1DiscountInput = {
  /** Discount type. */
  type?: InputMaybe<WixEcommerceSubscriptionOptionApiV1DiscountDiscountType>;
  /** Discount value. */
  value?: InputMaybe<Scalars['Float']>;
};

export type WixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput = {
  /** Whether subscription is renewed automatically at the end of each period. */
  autoRenewal?: InputMaybe<Scalars['Boolean']>;
  /** Number of billing cycles before subscription ends. Ignored if `autoRenewal: true`. */
  billingCycles?: InputMaybe<Scalars['Int']>;
  /** Frequency of recurring payment. */
  frequency?: InputMaybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** Interval of recurring payment (optional: default value 1 will be used if not provided) */
  interval?: InputMaybe<Scalars['Int']>;
};

export type WixEventsAgenda = {
  __typename?: 'WixEventsAgenda';
  /** Whether the schedule is enabled for the event. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Agenda page URL. */
  pageUrl?: Maybe<WixEventsSiteUrl>;
};

export type WixEventsAgendaInput = {
  /** Whether the schedule is enabled for the event. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Agenda page URL. */
  pageUrl?: InputMaybe<WixEventsSiteUrlInput>;
};

export type WixEventsBadge = {
  __typename?: 'WixEventsBadge';
  /**
   * The date when function that yielded this badge was last edited.
   * Used to resolve priority when two or more badges have the same type.
   */
  functionUpdateDate?: Maybe<Scalars['String']>;
  /** Badge text. */
  text?: Maybe<Scalars['String']>;
  /** Badge type. */
  type?: Maybe<WixEventsBadgeTypeType>;
};

export enum WixEventsBadgeTypeType {
  /** 1st priority badge type. */
  FirstPriority = 'FIRST_PRIORITY',
  /** 2nd priority badge type. */
  SecondPriority = 'SECOND_PRIORITY',
  /** 3rd priority badge type. */
  ThirdPriority = 'THIRD_PRIORITY',
  /** Unknown badge type. */
  UnknownBadgeType = 'UNKNOWN_BADGE_TYPE'
}

export type WixEventsBulkCancelEventsRequestInput = {
  /** Filter. See [supported fields and operators](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixEventsBulkDeleteEventsRequestInput = {
  /** Filter. See [supported fields and operators](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixEventsCalendarLinks = {
  __typename?: 'WixEventsCalendarLinks';
  /** "Add to Google calendar" URL. */
  google?: Maybe<Scalars['String']>;
  /** "Download ICS calendar file" URL. */
  ics?: Maybe<Scalars['String']>;
};

export type WixEventsCancelEventRequestInput = {
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEventsCancelEventResponse = {
  __typename?: 'WixEventsCancelEventResponse';
  /** Canceled event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsCategoriesCategory = {
  __typename?: 'WixEventsCategoriesCategory';
  /** Assigned events count. Deleted events are excluded. */
  assignedEventsCount?: Maybe<Scalars['Int']>;
  /** The total number of draft and published events assigned to the category. */
  counts?: Maybe<WixEventsCategoriesCategoryCounts>;
  /** Date and time when category was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Optionally client defined external ID. */
  externalId?: Maybe<Scalars['String']>;
  /** Category ID. */
  id?: Maybe<Scalars['String']>;
  /** Category name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Category state. Possible values:
   *
   * `MANUAL`: Category is created manually by the user.
   * `AUTO`: Category is created automatically.
   * `RECURRING_EVENT`: Category is created automatically when publishing recurring events.
   * `HIDDEN`: Category can't be seen.
   *
   * Default: `MANUAL`.
   *
   * **Note:** The WIX_EVENTS.MANAGE_AUTO_CATEGORIES permission scope is required to use states other than `MANUAL`.
   */
  states?: Maybe<Array<Maybe<WixEventsCategoryStateState>>>;
};

export type WixEventsCategoriesCategoryCounts = {
  __typename?: 'WixEventsCategoriesCategoryCounts';
  /** Total number of published events assigned to the category. Deleted events are excluded. */
  assignedDraftEventsCount?: Maybe<Scalars['Int']>;
  /** Total number of draft events assigned to the category. */
  assignedEventsCount?: Maybe<Scalars['Int']>;
};

export type WixEventsCategoryFilterInput = {
  /**
   * If true - only categorised events will be returned.
   * If false - only not categorised events will be returned.
   */
  categorised?: InputMaybe<Scalars['Boolean']>;
  /** Category id filter. */
  categoryId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Category states filter. Default - any state. */
  states?: InputMaybe<Array<InputMaybe<WixEventsCategoryStateState>>>;
};

export enum WixEventsCategoryStateState {
  /** Created automatically. */
  Auto = 'AUTO',
  /** Category is used to store component events. */
  Component = 'COMPONENT',
  /** Category is hidden. */
  Hidden = 'HIDDEN',
  /** Created manually by the user. */
  Manual = 'MANUAL',
  /** Created when publishing recurring events. */
  RecurringEvent = 'RECURRING_EVENT'
}

export enum WixEventsConferenceType {
  /** Everyone in the meeting can publish and subscribe video and audio. */
  Meeting = 'MEETING',
  /** Guests can only subscribe to video and audio. */
  Webinar = 'WEBINAR'
}

export type WixEventsCopyEventFromOtherSiteRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  /** Wix Events Instance ID. */
  instanceId?: InputMaybe<Scalars['String']>;
};

export type WixEventsCopyEventFromOtherSiteResponse = {
  __typename?: 'WixEventsCopyEventFromOtherSiteResponse';
  /** Copied event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsCopyEventRequestInput = {
  /**
   * If true, event will be copied as draft.
   * Otherwise copied event will be published, unless it is draft.
   */
  draft?: InputMaybe<Scalars['Boolean']>;
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
};

export type WixEventsCopyEventResponse = {
  __typename?: 'WixEventsCopyEventResponse';
  /** Copied event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsCopyEventV2RequestInput = {
  /**
   * If true, event will be copied as draft.
   * Otherwise copied event will be published, unless it is draft.
   */
  draft?: InputMaybe<Scalars['Boolean']>;
  /** Event data to update (partial) */
  event?: InputMaybe<WixEventsEventDataInput>;
  /**
   * Set of field paths to update.
   * <!--ONLY:REST-->
   * Fields will be auto-populated from the `event` entity unless added to the request explicitly.
   * <!--END:ONLY:REST-->
   * Behavior follows [google.protobuf.FieldMask](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.FieldMask) semantics.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEventsCopyEventV2Response = {
  __typename?: 'WixEventsCopyEventV2Response';
  /** Copied event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsCreateEventV2RequestInput = {
  /** Whether event should be created as draft. Draft events are hidden from site visitors. */
  draft?: InputMaybe<Scalars['Boolean']>;
  /** Event data. */
  event?: InputMaybe<WixEventsEventDataInput>;
  /**
   * Content language code in ISO 639-1 format.
   * Used for translating ticket PDF labels, registration form, automatic emails, etc.
   * Supported languages: ar, bg, cs, da, de, el, en, es, fi, fr, he, hi, hu, id, it, ja, ko, ms, nl, no, pl, pt, ro, ru, sv, th, tl, tr, uk, zh.
   * Defaults to en.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type WixEventsCreateEventV2Response = {
  __typename?: 'WixEventsCreateEventV2Response';
  /** Created event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsDashboard = {
  __typename?: 'WixEventsDashboard';
  /** Guest RSVP summary. */
  rsvpSummary?: Maybe<WixEventsDashboardRsvpSummary>;
  /**
   * Summary of revenue and tickets sold.
   * (Archived orders are not included).
   */
  ticketingSummary?: Maybe<WixEventsDashboardTicketingSummary>;
};

export type WixEventsDashboardRsvpSummary = {
  __typename?: 'WixEventsDashboardRsvpSummary';
  /** Number of RSVPs with status `NO`. */
  no?: Maybe<Scalars['Int']>;
  /** Total number of RSVPs. */
  total?: Maybe<Scalars['Int']>;
  /** Number of RSVPs in waitlist. */
  waitlist?: Maybe<Scalars['Int']>;
  /** Number of RSVPs with status `YES`. */
  yes?: Maybe<Scalars['Int']>;
};

export type WixEventsDashboardTicketingSummary = {
  __typename?: 'WixEventsDashboardTicketingSummary';
  /** Whether currency is locked and cannot be changed (generally occurs after the first order in the specified currency has been created). */
  currencyLocked?: Maybe<Scalars['Boolean']>;
  /** Number of orders placed. */
  orders?: Maybe<Scalars['Int']>;
  /**
   * Total revenue, excluding fees.
   * (taxes and payment provider fees are not deducted.)
   */
  revenue?: Maybe<WixEventsMoney>;
  /** Number of tickets sold. */
  tickets?: Maybe<Scalars['Int']>;
  /** Total balance of confirmed transactions. */
  totalSales?: Maybe<WixEventsMoney>;
};

export type WixEventsDeleteEventRequestInput = {
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEventsDeleteEventResponse = {
  __typename?: 'WixEventsDeleteEventResponse';
  /** Deleted event ID. */
  id?: Maybe<Scalars['String']>;
};

export type WixEventsEvent = {
  __typename?: 'WixEventsEvent';
  /** Rich-text content that are displayed in a site's "About Event" section (HTML). */
  about?: Maybe<Scalars['String']>;
  /** Agenda details. */
  agenda?: Maybe<WixEventsAgenda>;
  /** Assigned contacts label key. */
  assignedContactsLabel?: Maybe<Scalars['String']>;
  /** Event badges. */
  badges?: Maybe<Array<Maybe<WixEventsBadge>>>;
  /** "Add to calendar" URLs. */
  calendarLinks?: Maybe<WixEventsCalendarLinks>;
  /** Categories this event is assigned to. */
  categories?: Maybe<Array<Maybe<WixEventsCategoriesCategory>>>;
  /** Event creation timestamp. */
  created?: Maybe<Scalars['String']>;
  customizableTickets?: Maybe<Scalars['Boolean']>;
  /** Event dashboard summary of RSVP / ticket sales. */
  dashboard?: Maybe<WixEventsDashboard>;
  /** Event description. */
  description?: Maybe<Scalars['String']>;
  /** Visual settings for event. */
  eventDisplaySettings?: Maybe<WixEventsEventDisplaySettings>;
  /** Event page URL components. */
  eventPageUrl?: Maybe<WixEventsSiteUrl>;
  /** Event discussion feed. For internal use. */
  feed?: Maybe<WixEventsFeed>;
  /** Event registration form. */
  form?: Maybe<WixEventsFormForm>;
  /** Guest list configuration. */
  guestListConfig?: Maybe<WixEventsGuestListConfig>;
  /** Event ID. */
  id?: Maybe<Scalars['String']>;
  /** Instance ID of the site where event is hosted. */
  instanceId?: Maybe<Scalars['String']>;
  /** Labelling related data. */
  labellingSettings?: Maybe<WixEventsLabellingSettings>;
  /** ISO 639-1 language code of the event (used in content translations). */
  language?: Maybe<Scalars['String']>;
  /** Event location. */
  location?: Maybe<WixEventsLocation>;
  /** Rich content that are displayed in a site's "About Event" section. Successor to `about` field. */
  longDescription?: Maybe<WixRichContentV1RichContent>;
  /** Main event image. */
  mainImage?: Maybe<ComWixEventsUpstreamWixCommonImage>;
  /** Event modified timestamp. */
  modified?: Maybe<Scalars['String']>;
  /** Online conferencing details. */
  onlineConferencing?: Maybe<WixEventsOnlineConferencing>;
  policiesVirtualReference?: Maybe<WixEventsV2QueryPoliciesResponse>;
  /** Event publish timestamp. */
  publishedDate?: Maybe<Scalars['String']>;
  /** RSVP or ticketing registration details. */
  registration?: Maybe<WixEventsRegistration>;
  /** Event scheduling. */
  scheduling?: Maybe<WixEventsScheduling>;
  /** SEO settings. */
  seoSettings?: Maybe<WixEventsSeoSettings>;
  /** Event slug URL (generated from event title). */
  slug?: Maybe<Scalars['String']>;
  /** Event status. */
  status?: Maybe<WixEventsEventStatus>;
  /** Event title. */
  title?: Maybe<Scalars['String']>;
  /** Event creator user ID. */
  userId?: Maybe<Scalars['String']>;
};


export type WixEventsEventPoliciesVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixEventsV2QueryPoliciesRequestInput>;
};

export type WixEventsEventDataInput = {
  /** Rich-text content for About Event section (HTML). */
  about?: InputMaybe<Scalars['String']>;
  /** Agenda configuration */
  agenda?: InputMaybe<WixEventsAgendaInput>;
  customizableTickets?: InputMaybe<Scalars['Boolean']>;
  /** Event description. */
  description?: InputMaybe<Scalars['String']>;
  /** Visual settings for event. */
  eventDisplaySettings?: InputMaybe<WixEventsEventDisplaySettingsInput>;
  /** Guest list configuration */
  guestListConfig?: InputMaybe<WixEventsGuestListConfigInput>;
  /**
   * Event location.
   * Address is required for non TBD event.
   * Location name is required for TBD event.
   */
  location?: InputMaybe<WixEventsLocationInput>;
  /** Rich content for About Event section. Successor to `about` field. */
  longDescription?: InputMaybe<WixRichContentV1RichContentInput>;
  /**
   * Main event image. Printed in ticket PDF.
   * Currently, only images previously saved in Wix Media are supported.
   */
  mainImage?: InputMaybe<ComWixEventsUpstreamWixCommonImageInput>;
  /** Online conferencing configuration */
  onlineConferencingConfig?: InputMaybe<WixEventsOnlineConferencingConfigInput>;
  /** Registration configuration */
  registrationConfig?: InputMaybe<WixEventsRegistrationConfigInput>;
  /** RSVP collection configuration. Can be used to set limits. */
  rsvpCollectionConfig?: InputMaybe<WixEventsRsvpCollectionConfigInput>;
  /** Event schedule configuration */
  scheduleConfig?: InputMaybe<WixEventsScheduleConfigInput>;
  /** SEO settings */
  seoSettings?: InputMaybe<WixEventsSeoSettingsInput>;
  /** Event title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixEventsEventDisplaySettings = {
  __typename?: 'WixEventsEventDisplaySettings';
  /** Whether event details button is hidden. Only available for events with no registration. */
  hideEventDetailsButton?: Maybe<Scalars['Boolean']>;
  /** Disables event details page visibility. If event has an external registration configured visitors will be redirected from this page. */
  hideEventDetailsPage?: Maybe<Scalars['Boolean']>;
};

export type WixEventsEventDisplaySettingsInput = {
  /** Whether event details button is hidden. Only available for events with no registration. */
  hideEventDetailsButton?: InputMaybe<Scalars['Boolean']>;
  /** Disables event details page visibility. If event has an external registration configured visitors will be redirected from this page. */
  hideEventDetailsPage?: InputMaybe<Scalars['Boolean']>;
};

export enum WixEventsEventFieldset {
  /** Include `agendaSettings` in the response. */
  Agenda = 'AGENDA',
  /** Include badges in the response. */
  Badges = 'BADGES',
  /** Include `categories` in the response. */
  Categories = 'CATEGORIES',
  CustomizableTickets = 'CUSTOMIZABLE_TICKETS',
  /** Include `dashboard` in the response. */
  Dashboard = 'DASHBOARD',
  /** Include `description`, `mainImage` and `calendarLinks` in the response. */
  Details = 'DETAILS',
  /** Include `feed` in the response. */
  Feed = 'FEED',
  /** Include `form` in the response. */
  Form = 'FORM',
  Full = 'FULL',
  /** Include `onlineConferencing` in the response. */
  OnlineConferencingSession = 'ONLINE_CONFERENCING_SESSION',
  /** Include `registration` in the response. */
  Registration = 'REGISTRATION',
  /** Include `seoSettings` in the response. */
  SeoSettings = 'SEO_SETTINGS',
  /** Include `about` event rich text in the response. */
  Texts = 'TEXTS',
  /** Include `eventPageUrl` in the response. */
  Urls = 'URLS'
}

export enum WixEventsEventStatus {
  /** Event was canceled */
  Canceled = 'CANCELED',
  /** Event is not public and needs to be published */
  Draft = 'DRAFT',
  /** Event has ended */
  Ended = 'ENDED',
  /** Event is public and scheduled to start */
  Scheduled = 'SCHEDULED',
  /** Event has started */
  Started = 'STARTED'
}

export enum WixEventsEventType {
  /** External registration */
  External = 'EXTERNAL',
  /** Type not available for this request fieldset */
  NaEventType = 'NA_EVENT_TYPE',
  /** Registration not available */
  NoRegistration = 'NO_REGISTRATION',
  /** Registration via RSVP */
  Rsvp = 'RSVP',
  /** Registration via ticket purchase */
  Tickets = 'TICKETS'
}

export type WixEventsEventsEventCopiedInput = {
  /** Event ID. Indicates the original event which current event was derived from. */
  derivedFromEventId?: InputMaybe<Scalars['String']>;
  /** Instance ID. Indicates the original app instance which current event was derived from. */
  derivedFromInstanceId?: InputMaybe<Scalars['String']>;
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Event location. */
  location?: InputMaybe<WixEventsLocationInput>;
  /** Event schedule configuration. */
  scheduleConfig?: InputMaybe<WixEventsScheduleConfigInput>;
  /** Event status. */
  status?: InputMaybe<WixEventsEventStatus>;
  /**
   * Map of copied ticket definitions from original event.
   * Key represents ticket def id in the original event.
   * Value represents ticket def id in the newly created event.
   */
  ticketDefinitions?: InputMaybe<Scalars['JSON']>;
  /** Event created timestamp in ISO UTC format. */
  timestamp?: InputMaybe<Scalars['String']>;
  /** Event title. */
  title?: InputMaybe<Scalars['String']>;
  /** Event creator user ID. */
  userId?: InputMaybe<Scalars['String']>;
};

export type WixEventsExternalEvent = {
  __typename?: 'WixEventsExternalEvent';
  /** External event registration URL. */
  registration?: Maybe<Scalars['String']>;
};

export type WixEventsFacetCounts = {
  __typename?: 'WixEventsFacetCounts';
  /** Facet counts aggregated per value. */
  counts?: Maybe<Scalars['JSON']>;
};

export type WixEventsFeed = {
  __typename?: 'WixEventsFeed';
  /** Event discussion feed token. */
  token?: Maybe<Scalars['String']>;
};

export type WixEventsFindEventRequestInput = {
  /** Consistent read. */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
  /** URL slug. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixEventsFindEventResponse = {
  __typename?: 'WixEventsFindEventResponse';
  /** Event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsFindOnlineConferenceSessionRequestInput = {
  /** Event id. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Provider id. */
  providerId?: InputMaybe<Scalars['String']>;
};

export type WixEventsFindOnlineConferenceSessionResponse = {
  __typename?: 'WixEventsFindOnlineConferenceSessionResponse';
  /** Online Conferencing Session. */
  session?: Maybe<WixEventsOnlineConferencingSession>;
};

export type WixEventsFormCheckoutFormMessages = {
  __typename?: 'WixEventsFormCheckoutFormMessages';
  /** Confirmation messages shown after checkout. */
  confirmation?: Maybe<WixEventsFormCheckoutFormMessagesResponseConfirmation>;
  /** Submit form call-to-action label text. */
  submitActionLabel?: Maybe<Scalars['String']>;
  /** Main form title for response. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormCheckoutFormMessagesResponseConfirmation = {
  __typename?: 'WixEventsFormCheckoutFormMessagesResponseConfirmation';
  /** "Add to calendar" call-to-action label text. */
  addToCalendarLabel?: Maybe<Scalars['String']>;
  /** "Download tickets" call-to-action label text. */
  downloadTicketsLabel?: Maybe<Scalars['String']>;
  /** Confirmation message text. */
  message?: Maybe<Scalars['String']>;
  /** "Share event" call-to-action label text. */
  shareEventLabel?: Maybe<Scalars['String']>;
  /** Confirmation message title. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormForm = {
  __typename?: 'WixEventsFormForm';
  /** Nested fields as an ordered list. */
  controls?: Maybe<Array<Maybe<WixEventsFormInputControl>>>;
  /**
   * Set of defined form messages displayed in the UI before, during, and after a registration flow.
   * Includes the configuration of form titles, response labels, "thank you" messages, and call-to-action texts.
   */
  messages?: Maybe<WixEventsFormFormMessages>;
};

export type WixEventsFormFormMessages = {
  __typename?: 'WixEventsFormFormMessages';
  /** Checkout form messages. */
  checkout?: Maybe<WixEventsFormCheckoutFormMessages>;
  /** Messages shown when event registration is closed. */
  registrationClosed?: Maybe<WixEventsFormRegistrationClosedMessages>;
  /** RSVP form ([SDK](https://dev.wix.com/docs/sdk/backend-modules/events/rsvp-v2/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/events/rsvp-v2/introduction)) messages. */
  rsvp?: Maybe<WixEventsFormRsvpFormMessages>;
  /** Messages shown when event tickets are unavailable. */
  ticketsUnavailable?: Maybe<WixEventsFormTicketsUnavailableMessages>;
};

export type WixEventsFormInput = {
  __typename?: 'WixEventsFormInput';
  /** Additional labels for multi-valued fields such as address. */
  additionalLabels?: Maybe<Scalars['JSON']>;
  /** *Deprecated:** Use `controls.inputs.type.TEXT_ARRAY`. */
  array?: Maybe<Scalars['Boolean']>;
  /**
   * Default option initially selected when an input has multiple choices.
   *
   * Defaults to first (0th) option, if not configured.
   * Currently only applicable for `type.dropdown`.
   */
  defaultOptionSelection?: Maybe<WixEventsFormOptionSelection>;
  /** Main field label. */
  label?: Maybe<Scalars['String']>;
  /** Additional labels for multi-valued fields, such as address. */
  labels?: Maybe<Array<Maybe<WixEventsFormLabel>>>;
  /** Whether field is mandatory. */
  mandatory?: Maybe<Scalars['Boolean']>;
  /** Maximum number of accepted characters (relevant for text fields). */
  maxLength?: Maybe<Scalars['Int']>;
  /**
   * The maximum number of accepted values for array input.
   *
   * **Note:** Only applicable for `TEXT_ARRAY` input fields.
   */
  maxSize?: Maybe<Scalars['Int']>;
  /** Field name. */
  name?: Maybe<Scalars['String']>;
  /** Predefined choice options for fields, such as dropdown. */
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Type which determines field format.
   * Used to validate submitted response.
   */
  type?: Maybe<WixEventsFormValueType>;
};

export type WixEventsFormInputControl = {
  __typename?: 'WixEventsFormInputControl';
  /** Whether the input control is deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Unique control ID. */
  id?: Maybe<Scalars['String']>;
  /** Child inputs. */
  inputs?: Maybe<Array<Maybe<WixEventsFormInput>>>;
  /** *Deprecated:** Use `controls.inputs.label`. */
  label?: Maybe<Scalars['String']>;
  /** Deprecated: Use `id` or `_id`. */
  name?: Maybe<Scalars['String']>;
  /** Field controls are sorted by this value in ascending order. */
  orderIndex?: Maybe<Scalars['Int']>;
  /** Whether the control is mandatory (such as `name` & `email`). When `true`, only the label can be changed. */
  system?: Maybe<Scalars['Boolean']>;
  /** Field control type. */
  type?: Maybe<WixEventsFormInputControlType>;
};

export enum WixEventsFormInputControlType {
  /** Full address field with multiple lines. */
  AddressFull = 'ADDRESS_FULL',
  /** Single-line address field. */
  AddressShort = 'ADDRESS_SHORT',
  /** Multiple-choice field with predefined values. */
  Checkbox = 'CHECKBOX',
  /** Fields for entering year, month, and day. */
  Date = 'DATE',
  /** Single-choice field with predefined values. */
  Dropdown = 'DROPDOWN',
  /** Fields for additional guests and their respective names. */
  GuestControl = 'GUEST_CONTROL',
  /** Single text value field. */
  Input = 'INPUT',
  /** Fields for entering first and last names. */
  Name = 'NAME',
  /** Single-choice field with predefined values. */
  Radio = 'RADIO',
  /** Single text value field with multiple lines. */
  Textarea = 'TEXTAREA'
}

export type WixEventsFormLabel = {
  __typename?: 'WixEventsFormLabel';
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Field name. */
  name?: Maybe<Scalars['String']>;
};

export type WixEventsFormOptionSelection = {
  __typename?: 'WixEventsFormOptionSelection';
  /** 0-based index from predefined `controls.inputs.options` which is initial selection. */
  optionIndex?: Maybe<Scalars['Int']>;
  /**
   * Placeholder hint describing expected choices, such as "Please select".
   * Considered an empty choice.
   */
  placeholderText?: Maybe<Scalars['String']>;
};

export type WixEventsFormRegistrationClosedMessages = {
  __typename?: 'WixEventsFormRegistrationClosedMessages';
  /** "Explore other events" call-to-action label text. */
  exploreEventsActionLabel?: Maybe<Scalars['String']>;
  /** Message shown when event registration is closed. */
  message?: Maybe<Scalars['String']>;
};

export type WixEventsFormRsvpFormMessages = {
  __typename?: 'WixEventsFormRsvpFormMessages';
  /** Messages displayed when an RSVP's `status` is set to `"NO"`. */
  negativeMessages?: Maybe<WixEventsFormRsvpFormMessagesNegative>;
  /** Messages displayed when an RSVP's `status` is set to `"YES"`. */
  positiveMessages?: Maybe<WixEventsFormRsvpFormMessagesPositive>;
  /** Label text indicating RSVP's `status` is `"NO"`. */
  rsvpNoOption?: Maybe<Scalars['String']>;
  /** Label text indicating RSVP's `status` is `"YES"`. */
  rsvpYesOption?: Maybe<Scalars['String']>;
  /** "Submit form" call-to-action label text. */
  submitActionLabel?: Maybe<Scalars['String']>;
  /** Messages displayed when an RSVP's `status` is set to `"WAITLIST"`, for when the event is full and a waitlist is available). */
  waitlistMessages?: Maybe<WixEventsFormRsvpFormMessagesPositive>;
};

export type WixEventsFormRsvpFormMessagesNegative = {
  __typename?: 'WixEventsFormRsvpFormMessagesNegative';
  /** Confirmation messages shown after registration. */
  confirmation?: Maybe<WixEventsFormRsvpFormMessagesNegativeResponseConfirmation>;
  /** Main form title for negative response. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormRsvpFormMessagesNegativeResponseConfirmation = {
  __typename?: 'WixEventsFormRsvpFormMessagesNegativeResponseConfirmation';
  /** "Share event" call-to-action label text. */
  shareActionLabel?: Maybe<Scalars['String']>;
  /** Confirmation message title. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormRsvpFormMessagesPositive = {
  __typename?: 'WixEventsFormRsvpFormMessagesPositive';
  /** Confirmation messages shown after registration. */
  confirmation?: Maybe<WixEventsFormRsvpFormMessagesPositiveResponseConfirmation>;
  /** Main form title for positive response. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormRsvpFormMessagesPositiveResponseConfirmation = {
  __typename?: 'WixEventsFormRsvpFormMessagesPositiveResponseConfirmation';
  /** "Add to calendar" call-to-action label text. */
  addToCalendarActionLabel?: Maybe<Scalars['String']>;
  /** Confirmation message text. */
  message?: Maybe<Scalars['String']>;
  /** "Share event" call-to-action label text. */
  shareActionLabel?: Maybe<Scalars['String']>;
  /** Confirmation message title. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormTicketsUnavailableMessages = {
  __typename?: 'WixEventsFormTicketsUnavailableMessages';
  /** "Explore other events" call-to-action label text. */
  exploreEventsActionLabel?: Maybe<Scalars['String']>;
  /** Message shown when event tickets are unavailable. */
  message?: Maybe<Scalars['String']>;
};

export enum WixEventsFormValueType {
  Address = 'ADDRESS',
  DateTime = 'DATE_TIME',
  Number = 'NUMBER',
  Text = 'TEXT',
  TextArray = 'TEXT_ARRAY'
}

export type WixEventsGetEventRequestInput = {
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  id: Scalars['ID'];
  /** indicates whether full_address should be resolved */
  resolveFullAddress?: InputMaybe<Scalars['Boolean']>;
  /** URL slug. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixEventsGetRecurringEventStateRequestInput = {
  /** Recurring event category id. */
  categoryId?: InputMaybe<Scalars['String']>;
};

export type WixEventsGetRecurringEventStateResponse = {
  __typename?: 'WixEventsGetRecurringEventStateResponse';
  actual?: Maybe<WixEventsRecurringEventState>;
  /** Recurring event category id. */
  categoryId?: Maybe<Scalars['String']>;
  desired?: Maybe<WixEventsRecurringEventState>;
  inconsistentState?: Maybe<Scalars['Boolean']>;
};

export type WixEventsGetTicketingSummaryRequestInput = {
  eventId?: InputMaybe<Scalars['String']>;
};

export type WixEventsGetTicketingSummaryResponse = {
  __typename?: 'WixEventsGetTicketingSummaryResponse';
  summary?: Maybe<WixEventsTicketing>;
};

export type WixEventsGuestListConfig = {
  __typename?: 'WixEventsGuestListConfig';
  /** Whether members can see other members attending the event (defaults to true). */
  publicGuestList?: Maybe<Scalars['Boolean']>;
};

export type WixEventsGuestListConfigInput = {
  /** Whether members can see other members attending the event (defaults to true). */
  publicGuestList?: InputMaybe<Scalars['Boolean']>;
};

export type WixEventsLabellingSettings = {
  __typename?: 'WixEventsLabellingSettings';
  assignedContactsLabelDeleted?: Maybe<Scalars['Boolean']>;
  assignedContactsLegacyLabelId?: Maybe<Scalars['String']>;
};

export type WixEventsListCategoryEventsRequestInput = {
  /** Category ID */
  categoryId?: InputMaybe<Scalars['String']>;
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency of the service.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  paging?: InputMaybe<ComWixEventsUpstreamWixCommonPagingInput>;
};

export type WixEventsListCategoryEventsResponse = {
  __typename?: 'WixEventsListCategoryEventsResponse';
  /** Events list. */
  events?: Maybe<Array<Maybe<WixEventsEvent>>>;
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
};

export type WixEventsListEventsRequestInput = {
  /** Category filter. */
  categoryFilter?: InputMaybe<WixEventsCategoryFilterInput>;
  /**
   * Filter facets to include in the response.
   * See [supported facets](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency of the service.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  /**
   * Whether draft events should be returned in the response.
   * Requires WIX_EVENTS.READ_DRAFT_EVENTS permission.
   */
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  /** Number of items to load per page. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination). */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination). */
  offset?: InputMaybe<Scalars['Int']>;
  /** Recurrence status filter. */
  recurrenceStatus?: InputMaybe<Array<InputMaybe<WixEventsRecurrenceStatusStatus>>>;
  /** Recurring group id filter. */
  recurringGroupId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Event URL slug. */
  slug?: InputMaybe<Scalars['String']>;
  /**
   * Sort order, defaults to `"created:asc"`.
   * See [supported fields](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  sort?: InputMaybe<Scalars['String']>;
  /** Event status. */
  status?: InputMaybe<Array<InputMaybe<WixEventsEventStatus>>>;
  /**
   * Wix user filter, by default any.
   * Allows to filter events by user relation to the event (within the site).
   */
  userFilter?: InputMaybe<WixEventsUserFilterInput>;
  /** User ID filter, by default any */
  userId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixEventsListEventsResponse = {
  __typename?: 'WixEventsListEventsResponse';
  /** Events list. */
  events?: Maybe<Array<Maybe<WixEventsEvent>>>;
  /** Filter facets. */
  facets?: Maybe<WixEventsFacetCounts>;
  /** Limit. */
  limit?: Maybe<Scalars['Int']>;
  /** Offset. */
  offset?: Maybe<Scalars['Int']>;
  /** Total number of events that match the given filters. */
  total?: Maybe<Scalars['Int']>;
};

export type WixEventsListUserEventsRequestInput = {
  /**
   * Filter facets to include in the response.
   * See [supported facets](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paging?: InputMaybe<ComWixEventsUpstreamWixCommonPagingInput>;
  /**
   * Sort order, defaults to `"created:asc"`.
   * See [supported fields](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixEventsUpstreamWixCommonSortingInput>>>;
  /** Event status. */
  status?: InputMaybe<Array<InputMaybe<WixEventsEventStatus>>>;
  /**
   * Wix user filter, by default any.
   * Allows to filter events by user relation to the event among all wix sites.
   */
  userFilter?: InputMaybe<WixEventsUserFilterInput>;
};

export type WixEventsListUserEventsResponse = {
  __typename?: 'WixEventsListUserEventsResponse';
  /** Events list. */
  events?: Maybe<Array<Maybe<WixEventsEvent>>>;
  /** Filter facets. */
  facets?: Maybe<WixEventsFacetCounts>;
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
};

export type WixEventsLocation = {
  __typename?: 'WixEventsLocation';
  /** Single line address representation. */
  address?: Maybe<Scalars['String']>;
  /** Location map coordinates. */
  coordinates?: Maybe<WixEventsMapCoordinates>;
  /**
   * Full address derived from formatted single line `address`.
   * When `full_address` is used to create or update the event, deprecated `address` and `coordinates` are ignored.
   * If provided `full_address` has empty `formatted_address` or `coordinates`, it will be auto-completed using Atlas service.
   *
   * Migration notes:
   * - `full_address.formatted_address` is equivalent to `address`.
   * - `full_address.geocode` is equivalent to `coordinates`.
   */
  fullAddress?: Maybe<ComWixEventsUpstreamWixCommonAddress>;
  /** Location name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Defines event location as TBD (To Be Determined).
   * When event location is not yet defined, `name` is displayed instead of location address.
   * `coordinates`, `address`, `type` and `full_address` are not required when location is TBD.
   */
  tbd?: Maybe<Scalars['Boolean']>;
  /** Location type. */
  type?: Maybe<WixEventsLocationLocationType>;
};

export type WixEventsLocationInput = {
  /** Single line address representation. */
  address?: InputMaybe<Scalars['String']>;
  /** Location map coordinates. */
  coordinates?: InputMaybe<WixEventsMapCoordinatesInput>;
  /**
   * Full address derived from formatted single line `address`.
   * When `full_address` is used to create or update the event, deprecated `address` and `coordinates` are ignored.
   * If provided `full_address` has empty `formatted_address` or `coordinates`, it will be auto-completed using Atlas service.
   *
   * Migration notes:
   * - `full_address.formatted_address` is equivalent to `address`.
   * - `full_address.geocode` is equivalent to `coordinates`.
   */
  fullAddress?: InputMaybe<ComWixEventsUpstreamWixCommonAddressInput>;
  /** Location name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Defines event location as TBD (To Be Determined).
   * When event location is not yet defined, `name` is displayed instead of location address.
   * `coordinates`, `address`, `type` and `full_address` are not required when location is TBD.
   */
  tbd?: InputMaybe<Scalars['Boolean']>;
  /** Location type. */
  type?: InputMaybe<WixEventsLocationLocationType>;
};

export enum WixEventsLocationLocationType {
  Online = 'ONLINE',
  Venue = 'VENUE'
}

export type WixEventsMapCoordinates = {
  __typename?: 'WixEventsMapCoordinates';
  /** Latitude. */
  lat?: Maybe<Scalars['Float']>;
  /** Longitude. */
  lng?: Maybe<Scalars['Float']>;
};

export type WixEventsMapCoordinatesInput = {
  /** Latitude. */
  lat?: InputMaybe<Scalars['Float']>;
  /** Longitude. */
  lng?: InputMaybe<Scalars['Float']>;
};

export type WixEventsMoney = {
  __typename?: 'WixEventsMoney';
  /** *Deprecated:** Use `value` instead. */
  amount?: Maybe<Scalars['String']>;
  /** Three-letter currency code in [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, starts with a single (-), to indicate that the amount is negative. */
  value?: Maybe<Scalars['String']>;
};

export type WixEventsOccurrence = {
  __typename?: 'WixEventsOccurrence';
  /** Event end timestamp. */
  endDate?: Maybe<Scalars['String']>;
  /** Whether time zone is displayed in formatted schedule. */
  showTimeZone?: Maybe<Scalars['Boolean']>;
  /** Event start timestamp. */
  startDate?: Maybe<Scalars['String']>;
  /** Event time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`. */
  timeZoneId?: Maybe<Scalars['String']>;
};

export type WixEventsOccurrenceInput = {
  /** Event end timestamp. */
  endDate?: InputMaybe<Scalars['String']>;
  /** Whether time zone is displayed in formatted schedule. */
  showTimeZone?: InputMaybe<Scalars['Boolean']>;
  /** Event start timestamp. */
  startDate?: InputMaybe<Scalars['String']>;
  /** Event time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`. */
  timeZoneId?: InputMaybe<Scalars['String']>;
};

export type WixEventsOnlineConferencing = {
  __typename?: 'WixEventsOnlineConferencing';
  config?: Maybe<WixEventsOnlineConferencingConfig>;
  /** Configured conferencing provider name. */
  providerName?: Maybe<Scalars['String']>;
  session?: Maybe<WixEventsOnlineConferencingSession>;
};

export type WixEventsOnlineConferencingConfig = {
  __typename?: 'WixEventsOnlineConferencingConfig';
  /** Conference type */
  conferenceType?: Maybe<WixEventsConferenceType>;
  /**
   * Whether online conferencing is enabled (not supported for TBD schedules).
   * When enabled, links to join conferencing are generated and provided to guests.
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Conferencing provider ID. */
  providerId?: Maybe<Scalars['String']>;
};

export type WixEventsOnlineConferencingConfigInput = {
  /** Conference type */
  conferenceType?: InputMaybe<WixEventsConferenceType>;
  /**
   * Whether online conferencing is enabled (not supported for TBD schedules).
   * When enabled, links to join conferencing are generated and provided to guests.
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Conferencing provider ID. */
  providerId?: InputMaybe<Scalars['String']>;
};

export type WixEventsOnlineConferencingSession = {
  __typename?: 'WixEventsOnlineConferencingSession';
  /** Link for guests to join the online conference session. */
  guestLink?: Maybe<Scalars['String']>;
  /** Link for event host to start the online conference session. */
  hostLink?: Maybe<Scalars['String']>;
  /** The password required to join online conferencing session (when relevant). */
  password?: Maybe<Scalars['String']>;
  /** Indicates that session was created successfully on providers side. */
  sessionCreated?: Maybe<Scalars['Boolean']>;
  /** Unique session id */
  sessionId?: Maybe<Scalars['String']>;
};

export type WixEventsPublishDraftEventRequestInput = {
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEventsPublishDraftEventResponse = {
  __typename?: 'WixEventsPublishDraftEventResponse';
  /** Published event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsQueryEventsRequestInput = {
  /**
   * Filter facets to include in the response.
   * See [supported facets](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  /** Filter. See [supported fields and operators](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether draft events should be returned in the response.
   * Requires WIX_EVENTS.READ_DRAFT_EVENTS permission.
   */
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  /** Number of items to load per page. Default 0. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination). */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination). */
  offset?: InputMaybe<Scalars['Int']>;
  /**
   * Sort order, defaults to `"created:asc"`.
   * See [supported fields](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  sort?: InputMaybe<Scalars['String']>;
  /** User ID filter, by default any */
  userId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixEventsQueryEventsResponse = {
  __typename?: 'WixEventsQueryEventsResponse';
  /** Events list */
  events?: Maybe<Array<Maybe<WixEventsEvent>>>;
  /** Filter facets. */
  facets?: Maybe<WixEventsFacetCounts>;
  /** Limit. */
  limit?: Maybe<Scalars['Int']>;
  /** Offset. */
  offset?: Maybe<Scalars['Int']>;
  /** Total number of events that match the given filters. */
  total?: Maybe<Scalars['Int']>;
};

export type WixEventsQueryEventsV2RequestInput = {
  /**
   * Filter facets to include in the response.
   * See [supported facets](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  /**
   * Whether draft events should be returned in the response.
   * Requires WIX_EVENTS.READ_DRAFT_EVENTS permission.
   */
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<ComWixEventsUpstreamWixCommonQueryV2Input>;
};

export type WixEventsQueryEventsV2Response = {
  __typename?: 'WixEventsQueryEventsV2Response';
  /** Query results */
  items?: Maybe<Array<Maybe<WixEventsEvent>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixEventsRecurrenceStatusStatus {
  /** Event occurs only once. */
  OneTime = 'ONE_TIME',
  /** Event is recurring. */
  Recurring = 'RECURRING',
  /** Marks the most recent canceled occurrence of the recurring event. */
  RecurringLastCanceled = 'RECURRING_LAST_CANCELED',
  /** Marks the most recent ended occurrence of the recurring event. */
  RecurringLastEnded = 'RECURRING_LAST_ENDED',
  /** Marks the next upcoming occurrence of the recurring event. */
  RecurringNext = 'RECURRING_NEXT'
}

export type WixEventsRecurrences = {
  __typename?: 'WixEventsRecurrences';
  /** Recurring event category ID. */
  categoryId?: Maybe<Scalars['String']>;
  /** Event occurrences. */
  occurrences?: Maybe<Array<Maybe<WixEventsOccurrence>>>;
  /** Recurrence status. */
  status?: Maybe<WixEventsRecurrenceStatusStatus>;
};

export type WixEventsRecurrencesInput = {
  /** Recurring event category ID. */
  categoryId?: InputMaybe<Scalars['String']>;
  /** Event occurrences. */
  occurrences?: InputMaybe<Array<InputMaybe<WixEventsOccurrenceInput>>>;
  /** Recurrence status. */
  status?: InputMaybe<WixEventsRecurrenceStatusStatus>;
};

export type WixEventsRecurringEventDetails = {
  __typename?: 'WixEventsRecurringEventDetails';
  /** Event end timestamp. */
  endDate?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  recurrenceStatus?: Maybe<WixEventsRecurrenceStatusStatus>;
  /** Event slug */
  slug?: Maybe<Scalars['String']>;
  /** Event start timestamp. */
  startDate?: Maybe<Scalars['String']>;
};

export type WixEventsRecurringEventState = {
  __typename?: 'WixEventsRecurringEventState';
  recurringLastCanceled?: Maybe<WixEventsRecurringEventDetails>;
  recurringLastEnded?: Maybe<WixEventsRecurringEventDetails>;
  recurringNext?: Maybe<WixEventsRecurringEventDetails>;
};

export type WixEventsRegistration = {
  __typename?: 'WixEventsRegistration';
  /** External registration details. */
  external?: Maybe<WixEventsExternalEvent>;
  /** Initial event type which was set when creating an event. */
  initialType?: Maybe<WixEventsEventType>;
  /** Types of users allowed to register. */
  restrictedTo?: Maybe<WixEventsVisitorType>;
  /** RSVP collection details. */
  rsvpCollection?: Maybe<WixEventsRsvpCollection>;
  /** Event registration status. */
  status?: Maybe<WixEventsRegistrationStatus>;
  /** Ticketing details. */
  ticketing?: Maybe<WixEventsTicketing>;
  /** Event type. */
  type?: Maybe<WixEventsEventType>;
};

export type WixEventsRegistrationConfigInput = {
  /** Whether registration is disabled. */
  disabledRegistration?: InputMaybe<Scalars['Boolean']>;
  /** External event registration URL (for external events only). */
  externalRegistrationUrl?: InputMaybe<Scalars['String']>;
  /**
   * Initial event type. Only RSVP and TICKETS are allowed when creating an event.
   * Updating this field is not allowed.
   */
  initialType?: InputMaybe<WixEventsEventType>;
  /** Whether registration is closed. */
  pausedRegistration?: InputMaybe<Scalars['Boolean']>;
  /** Types of users allowed to register. */
  restrictedTo?: InputMaybe<WixEventsVisitorType>;
  /** Ticketing configuration. */
  ticketingConfig?: InputMaybe<WixEventsTicketingConfigInput>;
};

export enum WixEventsRegistrationStatus {
  /** Registration to event is closed */
  Closed = 'CLOSED',
  /** Registration to event is closed manually */
  ClosedManually = 'CLOSED_MANUALLY',
  /** Registration status is not applicable */
  NaRegistrationStatus = 'NA_REGISTRATION_STATUS',
  /** Registration is open via external URL */
  OpenExternal = 'OPEN_EXTERNAL',
  /** Registration is open via RSVP */
  OpenRsvp = 'OPEN_RSVP',
  /** Registration to event waitlist is open via RSVP */
  OpenRsvpWaitlist = 'OPEN_RSVP_WAITLIST',
  /** Registration is open via ticket purchase */
  OpenTickets = 'OPEN_TICKETS',
  /** Registration will be open via RSVP */
  ScheduledRsvp = 'SCHEDULED_RSVP'
}

export type WixEventsRsvpCollection = {
  __typename?: 'WixEventsRsvpCollection';
  /** RSVP collection configuration. */
  config?: Maybe<WixEventsRsvpCollectionConfig>;
};

export type WixEventsRsvpCollectionConfig = {
  __typename?: 'WixEventsRsvpCollectionConfig';
  /** Registration end timestamp. */
  endDate?: Maybe<Scalars['String']>;
  /**
   * Total guest limit available to register to the event.
   * Additional guests per RSVP are counted towards total guests.
   */
  limit?: Maybe<Scalars['Int']>;
  /** Defines the supported RSVP statuses. */
  rsvpStatusOptions?: Maybe<WixEventsRsvpCollectionConfigRsvpStatusOptions>;
  /** Registration start timestamp. */
  startDate?: Maybe<Scalars['String']>;
  /** Whether a waitlist is opened when total guest limit is reached, allowing guests to create RSVP with WAITING RSVP status. */
  waitlist?: Maybe<Scalars['Boolean']>;
};

export type WixEventsRsvpCollectionConfigInput = {
  /** Registration end timestamp. */
  endDate?: InputMaybe<Scalars['String']>;
  /**
   * Total guest limit available to register to the event.
   * Additional guests per RSVP are counted towards total guests.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /** Defines the supported RSVP statuses. */
  rsvpStatusOptions?: InputMaybe<WixEventsRsvpCollectionConfigRsvpStatusOptions>;
  /** Registration start timestamp. */
  startDate?: InputMaybe<Scalars['String']>;
  /** Whether a waitlist is opened when total guest limit is reached, allowing guests to create RSVP with WAITING RSVP status. */
  waitlist?: InputMaybe<Scalars['Boolean']>;
};

export enum WixEventsRsvpCollectionConfigRsvpStatusOptions {
  /** YES and NO RSVP status options are available for the registration */
  YesAndNo = 'YES_AND_NO',
  /** Only YES RSVP status is available for RSVP registration */
  YesOnly = 'YES_ONLY'
}

export type WixEventsScheduleAddScheduleItemRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Schedule item. */
  item?: InputMaybe<WixEventsScheduleScheduleItemDataInput>;
};

export type WixEventsScheduleAddScheduleItemResponse = {
  __typename?: 'WixEventsScheduleAddScheduleItemResponse';
  /** Schedule item. */
  item?: Maybe<WixEventsScheduleScheduleItem>;
};

export type WixEventsScheduleConfig = {
  __typename?: 'WixEventsScheduleConfig';
  /** Event end timestamp. */
  endDate?: Maybe<Scalars['String']>;
  /** Whether end date is hidden in the formatted schedule. */
  endDateHidden?: Maybe<Scalars['Boolean']>;
  /** Event recurrences. */
  recurrences?: Maybe<WixEventsRecurrences>;
  /**
   * Defines event as TBD (To Be Determined) schedule.
   * When event time is not yet defined, TBD message is displayed instead of event start and end times.
   * `startDate`, `endDate` and `timeZoneId` are not required when schedule is TBD.
   */
  scheduleTbd?: Maybe<Scalars['Boolean']>;
  /** TBD message. */
  scheduleTbdMessage?: Maybe<Scalars['String']>;
  /** Whether time zone is displayed in formatted schedule. */
  showTimeZone?: Maybe<Scalars['Boolean']>;
  /** Event start timestamp. */
  startDate?: Maybe<Scalars['String']>;
  /** Event time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`. */
  timeZoneId?: Maybe<Scalars['String']>;
};

export type WixEventsScheduleConfigInput = {
  /** Event end timestamp. */
  endDate?: InputMaybe<Scalars['String']>;
  /** Whether end date is hidden in the formatted schedule. */
  endDateHidden?: InputMaybe<Scalars['Boolean']>;
  /** Event recurrences. */
  recurrences?: InputMaybe<WixEventsRecurrencesInput>;
  /**
   * Defines event as TBD (To Be Determined) schedule.
   * When event time is not yet defined, TBD message is displayed instead of event start and end times.
   * `startDate`, `endDate` and `timeZoneId` are not required when schedule is TBD.
   */
  scheduleTbd?: InputMaybe<Scalars['Boolean']>;
  /** TBD message. */
  scheduleTbdMessage?: InputMaybe<Scalars['String']>;
  /** Whether time zone is displayed in formatted schedule. */
  showTimeZone?: InputMaybe<Scalars['Boolean']>;
  /** Event start timestamp. */
  startDate?: InputMaybe<Scalars['String']>;
  /** Event time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`. */
  timeZoneId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleCreateBookmarkRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Schedule item ID. */
  itemId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleDeleteBookmarkRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Schedule item ID. */
  itemId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleDeleteScheduleItemRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Schedule items to delete. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixEventsScheduleDiscardDraftRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleGetScheduleItemRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  includeDraft?: InputMaybe<Scalars['Boolean']>;
};

export type WixEventsScheduleGetScheduleItemResponse = {
  __typename?: 'WixEventsScheduleGetScheduleItemResponse';
  /** Draft of the Schedule item. */
  draft?: Maybe<WixEventsScheduleScheduleItem>;
  /** Schedule item. */
  item?: Maybe<WixEventsScheduleScheduleItem>;
};

export type WixEventsScheduleListBookmarksRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleListBookmarksResponse = {
  __typename?: 'WixEventsScheduleListBookmarksResponse';
  /** Schedule items. */
  items?: Maybe<Array<Maybe<WixEventsScheduleScheduleItem>>>;
};

export type WixEventsScheduleListScheduleItemsRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter facets.
   * See [supported facets](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-schedule-items).
   */
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item IDs filter. */
  itemId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Deprecated, use `paging`.
   * Number of items to load per page. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination).
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Deprecated, use `paging`.
   * Number of items to skip. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination).
   */
  offset?: InputMaybe<Scalars['Int']>;
  /**
   * Pointer to page of results using offset.
   * See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination).
   */
  paging?: InputMaybe<ComWixEventsUpstreamWixCommonPagingInput>;
  /** Stage names filter. */
  stageName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filters schedule items starting before specified point in time. Non-inclusive. */
  startingBefore?: InputMaybe<Scalars['String']>;
  /** Filters schedule items starting on or after specified point in time. Inclusive. */
  startingFrom?: InputMaybe<Scalars['String']>;
  /**
   * Schedule item state filter.
   * Defaults to `[PUBLISHED, VISIBLE]` when no filters are specified.
   * If neither `PUBLISHED` nor `DRAFT` are specified, assumes `PUBLISHED`, for example: `[HIDDEN]` becomes `[HIDDEN, PUBLISHED]`.
   * If neither `VISIBLE` nor `HIDDEN` are specified, assumes `VISIBLE`, for example: `[DRAFT]` becomes `[DRAFT, VISIBLE]`.
   */
  state?: InputMaybe<Array<InputMaybe<WixEventsScheduleStateFilter>>>;
  /** Tags filter. */
  tag?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixEventsScheduleListScheduleItemsResponse = {
  __typename?: 'WixEventsScheduleListScheduleItemsResponse';
  /**
   * Whether there are draft changes which have not been published yet.
   * Returned only when filtering by single `event_id` with `WIX_EVENTS.MANAGE_AGENDA` permission.
   */
  draftNotPublished?: Maybe<Scalars['Boolean']>;
  /** Facets. */
  facets?: Maybe<WixEventsFacetCounts>;
  /** Schedule items. */
  items?: Maybe<Array<Maybe<WixEventsScheduleScheduleItem>>>;
  /**
   * Deprecated.
   * Limit.
   */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Deprecated, use `paging_metadata.offset`.
   * Offset.
   */
  offset?: Maybe<Scalars['Int']>;
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /**
   * Deprecated, use `paging_metadata.total`.
   * Total schedule items matching the given filters.
   */
  total?: Maybe<Scalars['Int']>;
};

export type WixEventsSchedulePublishDraftRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleQueryScheduleItemsRequestInput = {
  query?: InputMaybe<ComWixEventsUpstreamWixCommonQueryV2Input>;
};

export type WixEventsScheduleQueryScheduleItemsResponse = {
  __typename?: 'WixEventsScheduleQueryScheduleItemsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixEventsScheduleScheduleItem>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixEventsScheduleRescheduleDraftRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Offset added or subtracted from schedule item start & end times. */
  timeSlotOffset?: InputMaybe<Scalars['JSON']>;
  /** Time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`. */
  timeZoneId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleScheduleItem = {
  __typename?: 'WixEventsScheduleScheduleItem';
  /** Schedule item created timestamp. */
  createdDate?: Maybe<Scalars['String']>;
  /** Rich-text content displayed in Wix UI when viewing schedule item details (HTML). */
  description?: Maybe<Scalars['String']>;
  /** Whether schedule item is draft. */
  draft?: Maybe<Scalars['Boolean']>;
  /** Event ID. */
  eventId?: Maybe<Scalars['String']>;
  /** Whether schedule item is hidden from guests. */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Schedule item ID. */
  id?: Maybe<Scalars['String']>;
  /** Schedule item name. */
  name?: Maybe<Scalars['String']>;
  /** Stage or room name in which session takes place. */
  stageName?: Maybe<Scalars['String']>;
  /** Schedule item status. */
  status?: Maybe<WixEventsScheduleScheduleStatus>;
  /** Tags are used to organize schedule items by assigning them to a general theme or field of study. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Time slot of an schedule item. */
  timeSlot?: Maybe<WixEventsTimeInterval>;
  /** Schedule item modified timestamp. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixEventsScheduleScheduleItemDataInput = {
  /** Rich-text content displayed in Wix UI when viewing schedule item details (HTML). */
  description?: InputMaybe<Scalars['String']>;
  /** Whether schedule item is hidden from guests. */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Schedule item name. */
  name?: InputMaybe<Scalars['String']>;
  /** Stage or room name in which session takes place. */
  stageName?: InputMaybe<Scalars['String']>;
  /** Schedule item status. */
  status?: InputMaybe<WixEventsScheduleScheduleStatus>;
  /** Tags are used to organize schedule items by assigning them to a general theme or field of study. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Time slot */
  timeSlot?: InputMaybe<WixEventsTimeIntervalInput>;
};

export enum WixEventsScheduleScheduleStatus {
  /** Item is canceled. */
  Canceled = 'CANCELED',
  /** Item is scheduled for a future date. */
  Scheduled = 'SCHEDULED'
}

export enum WixEventsScheduleStateFilter {
  /** Opposite of `PUBLISHED`. Requires `WIX_EVENTS.READ_HIDDEN_AGENDA` permission. */
  Draft = 'DRAFT',
  /** Opposite of `VISIBLE`. Requires `WIX_EVENTS.READ_HIDDEN_AGENDA` permission. */
  Hidden = 'HIDDEN',
  /** Schedule item is published. */
  Published = 'PUBLISHED',
  /** Schedule item is visible to the public. */
  Visible = 'VISIBLE'
}

export type WixEventsScheduleUpdateScheduleItemRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /**
   * Set of field paths to update.
   * When fields are empty, request is interpreted as full update.
   * Behavior follows [google.protobuf.FieldMask](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.FieldMask) semantics.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Schedule item. */
  item?: InputMaybe<WixEventsScheduleScheduleItemDataInput>;
  /** Schedule item ID. */
  itemId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleUpdateScheduleItemResponse = {
  __typename?: 'WixEventsScheduleUpdateScheduleItemResponse';
  /** Schedule item. */
  item?: Maybe<WixEventsScheduleScheduleItem>;
};

export type WixEventsScheduling = {
  __typename?: 'WixEventsScheduling';
  /** Schedule configuration. */
  config?: Maybe<WixEventsScheduleConfig>;
  /** Formatted end date of the event (empty for TBD schedules or when end date is hidden). */
  endDateFormatted?: Maybe<Scalars['String']>;
  /** Formatted end time of the event (empty for TBD schedules or when end date is hidden). */
  endTimeFormatted?: Maybe<Scalars['String']>;
  /** Formatted schedule representation. */
  formatted?: Maybe<Scalars['String']>;
  /** Formatted start date of the event (empty for TBD schedules). */
  startDateFormatted?: Maybe<Scalars['String']>;
  /** Formatted start time of the event (empty for TBD schedules). */
  startTimeFormatted?: Maybe<Scalars['String']>;
};

export type WixEventsSeoSettings = {
  __typename?: 'WixEventsSeoSettings';
  /** Advanced SEO data */
  advancedSeoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Hidden from SEO Site Map */
  hidden?: Maybe<Scalars['Boolean']>;
  /** URL slug */
  slug?: Maybe<Scalars['String']>;
};

export type WixEventsSeoSettingsInput = {
  /** Advanced SEO data */
  advancedSeoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Hidden from SEO Site Map */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** URL slug */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixEventsSiteUrl = {
  __typename?: 'WixEventsSiteUrl';
  /**
   * Base URL. For premium sites, this will be the domain.
   * For free sites, this would be site URL (e.g `mysite.wixsite.com/mysite`)
   */
  base?: Maybe<Scalars['String']>;
  /** The path to that page - e.g `/my-events/weekly-meetup-2` */
  path?: Maybe<Scalars['String']>;
};

export type WixEventsSiteUrlInput = {
  /**
   * Base URL. For premium sites, this will be the domain.
   * For free sites, this would be site URL (e.g `mysite.wixsite.com/mysite`)
   */
  base?: InputMaybe<Scalars['String']>;
  /** The path to that page - e.g `/my-events/weekly-meetup-2` */
  path?: InputMaybe<Scalars['String']>;
};

export type WixEventsTaxConfig = {
  __typename?: 'WixEventsTaxConfig';
  /** Applies taxes for donations, default true. */
  appliesToDonations?: Maybe<Scalars['Boolean']>;
  /** Tax name. */
  name?: Maybe<Scalars['String']>;
  /** Tax rate (e.g.,`21.55`). */
  rate?: Maybe<Scalars['String']>;
  /** Tax application settings. */
  type?: Maybe<WixEventsTaxType>;
};

export type WixEventsTaxConfigInput = {
  /** Applies taxes for donations, default true. */
  appliesToDonations?: InputMaybe<Scalars['Boolean']>;
  /** Tax name. */
  name?: InputMaybe<Scalars['String']>;
  /** Tax rate (e.g.,`21.55`). */
  rate?: InputMaybe<Scalars['String']>;
  /** Tax application settings. */
  type?: InputMaybe<WixEventsTaxType>;
};

export enum WixEventsTaxType {
  /** Tax is added to the order at the checkout. */
  Added = 'ADDED',
  /** Tax is added to the final total at the checkout. */
  AddedAtCheckout = 'ADDED_AT_CHECKOUT',
  /** Tax is included in the ticket price. */
  Included = 'INCLUDED'
}

export type WixEventsTicketing = {
  __typename?: 'WixEventsTicketing';
  /** Ticketing configuration. */
  config?: Maybe<WixEventsTicketingConfig>;
  /** Currency used in event transactions. */
  currency?: Maybe<Scalars['String']>;
  /** Deprecated. */
  highestPrice?: Maybe<Scalars['String']>;
  /** Price of highest priced ticket. */
  highestTicketPrice?: Maybe<WixEventsMoney>;
  /** Formatted price of highest priced ticket. */
  highestTicketPriceFormatted?: Maybe<Scalars['String']>;
  /** Deprecated. */
  lowestPrice?: Maybe<Scalars['String']>;
  /** Price of lowest priced ticket. */
  lowestTicketPrice?: Maybe<WixEventsMoney>;
  /** Formatted price of lowest priced ticket. */
  lowestTicketPriceFormatted?: Maybe<Scalars['String']>;
  /** Whether all tickets are sold for this event. */
  soldOut?: Maybe<Scalars['Boolean']>;
};

export type WixEventsTicketingConfig = {
  __typename?: 'WixEventsTicketingConfig';
  /** Grace period for which ticket reservation is extended. */
  gracePeriodInMinutes?: Maybe<Scalars['Int']>;
  /** Whether the form must be filled out separately for each ticket. */
  guestAssignedTickets?: Maybe<Scalars['Boolean']>;
  /** Duration for which the tickets being bought are reserved. */
  reservationDurationInMinutes?: Maybe<Scalars['Int']>;
  /**
   * App Id for external ticket stock management.
   * By default tickets stock is defined in TicketDefinition object.
   * If defined then limitation from TicketDefinition is ignored.
   */
  stockManagerAppId?: Maybe<Scalars['String']>;
  /** Tax configuration. */
  taxConfig?: Maybe<WixEventsTaxConfig>;
  /** Limit of tickets that can be purchased per order, default 20. */
  ticketLimitPerOrder?: Maybe<Scalars['Int']>;
};

export type WixEventsTicketingConfigInput = {
  /** Grace period for which ticket reservation is extended. */
  gracePeriodInMinutes?: InputMaybe<Scalars['Int']>;
  /** Whether the form must be filled out separately for each ticket. */
  guestAssignedTickets?: InputMaybe<Scalars['Boolean']>;
  /** Duration for which the tickets being bought are reserved. */
  reservationDurationInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * App Id for external ticket stock management.
   * By default tickets stock is defined in TicketDefinition object.
   * If defined then limitation from TicketDefinition is ignored.
   */
  stockManagerAppId?: InputMaybe<Scalars['String']>;
  /** Tax configuration. */
  taxConfig?: InputMaybe<WixEventsTaxConfigInput>;
  /** Limit of tickets that can be purchased per order, default 20. */
  ticketLimitPerOrder?: InputMaybe<Scalars['Int']>;
};

export type WixEventsTimeInterval = {
  __typename?: 'WixEventsTimeInterval';
  /** End of the interval. Non-inclusive. */
  end?: Maybe<Scalars['String']>;
  /** Start of the interval. Inclusive. */
  start?: Maybe<Scalars['String']>;
  /**
   * Time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`.
   * Defaults to `Etc/UTC` when not set.
   */
  timeZoneId?: Maybe<Scalars['String']>;
};

export type WixEventsTimeIntervalInput = {
  /** End of the interval. Non-inclusive. */
  end?: InputMaybe<Scalars['String']>;
  /** Start of the interval. Inclusive. */
  start?: InputMaybe<Scalars['String']>;
  /**
   * Time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`.
   * Defaults to `Etc/UTC` when not set.
   */
  timeZoneId?: InputMaybe<Scalars['String']>;
};

export type WixEventsUpdateEventRequestInput = {
  /** Event data to update (partial) */
  event?: InputMaybe<WixEventsEventDataInput>;
  /**
   * Set of field paths to update.
   * <!--ONLY:REST-->
   * Fields will be auto-populated from the `event` entity unless added to the request explicitly.
   * <!--END:ONLY:REST-->
   * Behavior follows [google.protobuf.FieldMask](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.FieldMask) semantics.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Content language code in ISO 639-1 format.
   * Used for translating ticket PDF labels, registration form, automatic emails, etc.
   * Supported languages: ar, bg, cs, da, de, el, en, es, fi, fr, he, hi, hu, id, it, ja, ko, ms, nl, no, pl, pt, ro, ru, sv, th, tl, tr, uk, zh.
   * Defaults to en.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type WixEventsUpdateEventResponse = {
  __typename?: 'WixEventsUpdateEventResponse';
  /** Updated event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsUpdateRecurringStatusRequestInput = {
  /** Recurring event category id. */
  categoryId?: InputMaybe<Scalars['String']>;
};

export type WixEventsUserFilterInput = {
  /** Relation of user to event */
  relation?: InputMaybe<Array<InputMaybe<WixEventsUserFilterRelation>>>;
  /** User who is related to event */
  userId?: InputMaybe<Scalars['String']>;
};

export enum WixEventsUserFilterRelation {
  /**
   * User is attending the event.
   * User has RSVP with status YES or has ordered tickets.
   */
  Attending = 'ATTENDING'
}

export type WixEventsV2CreatePolicyRequestInput = {
  /** Policy info. */
  policy?: InputMaybe<WixEventsV2PolicyInput>;
};

export type WixEventsV2CreatePolicyResponse = {
  __typename?: 'WixEventsV2CreatePolicyResponse';
  /** Created policy. */
  policy?: Maybe<WixEventsV2Policy>;
};

export type WixEventsV2DeletePolicyRequestInput = {
  /** ID of the policy to delete. */
  policyId?: InputMaybe<Scalars['String']>;
};

export type WixEventsV2GetPolicyFromTrashBinRequestInput = {
  /** Policy ID. */
  policyId?: InputMaybe<Scalars['String']>;
};

export type WixEventsV2GetPolicyFromTrashBinResponse = {
  __typename?: 'WixEventsV2GetPolicyFromTrashBinResponse';
  /** The requested policy. */
  policy?: Maybe<WixEventsV2Policy>;
};

export type WixEventsV2GetPolicyRequestInput = {
  id: Scalars['ID'];
};

export type WixEventsV2Policy = {
  __typename?: 'WixEventsV2Policy';
  /**
   * Policy body. Usually contains various terms and conditions.
   *
   * Min: 1 character
   * Max: 50,000 characters
   *
   * <b>Note:</b> You can format text using various HTML tags such as `<p>`, `<b>`, `<ul>`, etc.
   */
  body?: Maybe<Scalars['String']>;
  /** Date and time the policy was created in `yyyy-mm-ddThh:mm:sssZ` format. */
  createdDate?: Maybe<Scalars['String']>;
  /** ID of the event to which the policy belongs. */
  event?: Maybe<WixEventsEvent>;
  /** ID of the event to which the policy belongs. */
  eventId?: Maybe<Scalars['String']>;
  /** Policy ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Policy name that is visible in the dashboard and checkout form.
   *
   * Min: 1 character  <br/>
   * Max: 40 characters
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the policy is updated.
   *
   * To prevent conflicting changes, the current revision must be used when updating a policy.
   */
  revision?: Maybe<Scalars['Long']>;
  /** Date and time the policy was updated in `yyyy-mm-ddThh:mm:sssZ` format. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixEventsV2PolicyInput = {
  /**
   * Policy body. Usually contains various terms and conditions.
   *
   * Min: 1 character
   * Max: 50,000 characters
   *
   * <b>Note:</b> You can format text using various HTML tags such as `<p>`, `<b>`, `<ul>`, etc.
   */
  body?: InputMaybe<Scalars['String']>;
  /** Date and time the policy was created in `yyyy-mm-ddThh:mm:sssZ` format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** ID of the event to which the policy belongs. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Policy ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Policy name that is visible in the dashboard and checkout form.
   *
   * Min: 1 character  <br/>
   * Max: 40 characters
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the policy is updated.
   *
   * To prevent conflicting changes, the current revision must be used when updating a policy.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the policy was updated in `yyyy-mm-ddThh:mm:sssZ` format. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixEventsV2PolicyUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load per page. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixEventsV2PolicyUpstreamWixCommonPagingInput = {
  /** Number of items to load per page. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixEventsV2PolicyUpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixEventsV2PolicyUpstreamWixCommonCursorPagingInput>;
  /** Filter object in the following format: <br/> `"filter" : { "fieldName1": "value1", "fieldName2":{"$operator":"value2"} }`. <br/> <br/> **Example:** <br/> `"filter" : { "id": "2224a9d1-79e6-4549-a5c5-bf7ce5aac1a5", "revision": {"$ne":"1"} }` <br/> <br/> See [supported fields and operators](https://dev.wix.com/api/rest/wix-events/policy-v2/filter-and-sort) for more information. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pagination options. */
  paging?: InputMaybe<WixEventsV2PolicyUpstreamWixCommonPagingInput>;
  /** Sort object in the following format: <br/> `[{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}]` <br/> <br/> **Example:** <br/> `[{"fieldName":"createdDate","direction":"DESC"}]` <br/> <br/> See [supported fields](https://dev.wix.com/api/rest/wix-events/policy-v2/filter-and-sort) for more information. */
  sort?: InputMaybe<Array<InputMaybe<WixEventsV2PolicyUpstreamWixCommonSortingInput>>>;
};

export type WixEventsV2PolicyUpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order (ASC/DESC). Defaults to ASC */
  order?: InputMaybe<WixCommonSortOrder>;
};

export type WixEventsV2QueryPoliciesRequestInput = {
  /** Query options. See [API Query Langauge](https://dev.wix.com/api/rest/getting-started/api-query-language) for more details. */
  query?: InputMaybe<WixEventsV2PolicyUpstreamWixCommonQueryV2Input>;
};

export type WixEventsV2QueryPoliciesResponse = {
  __typename?: 'WixEventsV2QueryPoliciesResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixEventsV2Policy>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixEventsV2ReorderEventPoliciesRequestInput = {
  /** Move the given policy after this specified policy. */
  afterPolicyId?: InputMaybe<Scalars['String']>;
  /** Move the given policy before this specified policy. */
  beforePolicyId?: InputMaybe<Scalars['String']>;
  /** Event ID to which the policy belongs. */
  eventId?: InputMaybe<Scalars['String']>;
  /** ID of the policy to reorder. */
  policyId?: InputMaybe<Scalars['String']>;
};

export type WixEventsV2ReorderEventPoliciesResponse = {
  __typename?: 'WixEventsV2ReorderEventPoliciesResponse';
  /** Policies in the new order. */
  policies?: Maybe<Array<Maybe<WixEventsV2Policy>>>;
};

export type WixEventsV2UpdatePolicyRequestInput = {
  /** List of exact fields to update. For example, if you define only `name`, then all other fields will be ignored. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Policy info to update. */
  policy?: InputMaybe<WixEventsV2PolicyInput>;
};

export type WixEventsV2UpdatePolicyResponse = {
  __typename?: 'WixEventsV2UpdatePolicyResponse';
  /** Updated policy. */
  policy?: Maybe<WixEventsV2Policy>;
};

export type WixEventsV2UpdatePolicySortIndexRequestInput = {
  /** ID of the policy. */
  policyId?: InputMaybe<Scalars['String']>;
  /** Current revision number of the policy. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Index to sort of a policy. */
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type WixEventsV2UpdatePolicySortIndexResponse = {
  __typename?: 'WixEventsV2UpdatePolicySortIndexResponse';
  /** Updated policy. */
  policy?: Maybe<WixEventsV2Policy>;
};

export enum WixEventsVisitorType {
  /** Site member */
  Member = 'MEMBER',
  /** Site visitor (including member) */
  Visitor = 'VISITOR',
  /** Site visitor or member */
  VisitorOrMember = 'VISITOR_OR_MEMBER'
}

export type WixFormsV4BreakPoint = {
  __typename?: 'WixFormsV4BreakPoint';
  /** Amount of columns of layout grid. */
  columns?: Maybe<Scalars['Int']>;
  /** Description of layouts for items. */
  items?: Maybe<Array<Maybe<WixFormsV4ItemLayout>>>;
  /** Description of elements margins. */
  margin?: Maybe<WixFormsV4BreakPointMargin>;
  /** Description of elements paddings. */
  padding?: Maybe<WixFormsV4BreakPointMargin>;
  /** Row height of layout grid. */
  rowHeight?: Maybe<Scalars['Int']>;
  /** Sections of the layout, which allow manage fields */
  sections?: Maybe<Array<Maybe<WixFormsV4BreakPointSection>>>;
};

export type WixFormsV4BreakPointInput = {
  /** Amount of columns of layout grid. */
  columns?: InputMaybe<Scalars['Int']>;
  /** Description of layouts for items. */
  items?: InputMaybe<Array<InputMaybe<WixFormsV4ItemLayoutInput>>>;
  /** Description of elements margins. */
  margin?: InputMaybe<WixFormsV4BreakPointMarginInput>;
  /** Description of elements paddings. */
  padding?: InputMaybe<WixFormsV4BreakPointMarginInput>;
  /** Row height of layout grid. */
  rowHeight?: InputMaybe<Scalars['Int']>;
  /** Sections of the layout, which allow manage fields */
  sections?: InputMaybe<Array<InputMaybe<WixFormsV4BreakPointSectionInput>>>;
};

export type WixFormsV4BreakPointMargin = {
  __typename?: 'WixFormsV4BreakPointMargin';
  /** Horizontal value. */
  horizontal?: Maybe<Scalars['Int']>;
  /** Vertical value. */
  vertical?: Maybe<Scalars['Int']>;
};

export type WixFormsV4BreakPointMarginInput = {
  /** Horizontal value. */
  horizontal?: InputMaybe<Scalars['Int']>;
  /** Vertical value. */
  vertical?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4BreakPointSection = {
  __typename?: 'WixFormsV4BreakPointSection';
  /**
   * A list of field identifiers that are permitted to be placed within a section.
   * The section will only accept fields with IDs specified in this list.
   * If the section encounters the $new key within the list,
   * it allows the inclusion of fields not explicitly listed,
   * enabling dynamic addition of new fields.
   */
  allowedFieldIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Id of the section */
  id?: Maybe<Scalars['String']>;
  /** Horizontal coordinate in the grid. */
  row?: Maybe<Scalars['Int']>;
};

export type WixFormsV4BreakPointSectionInput = {
  /**
   * A list of field identifiers that are permitted to be placed within a section.
   * The section will only accept fields with IDs specified in this list.
   * If the section encounters the $new key within the list,
   * it allows the inclusion of fields not explicitly listed,
   * enabling dynamic addition of new fields.
   */
  allowedFieldIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Id of the section */
  id?: InputMaybe<Scalars['String']>;
  /** Horizontal coordinate in the grid. */
  row?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4BulkCreateFormRequestInput = {
  /** Forms to be created. */
  forms?: InputMaybe<Array<InputMaybe<WixFormsV4FormInput>>>;
  /** When set, items will be returned on successful create */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4BulkCreateFormResponse = {
  __typename?: 'WixFormsV4BulkCreateFormResponse';
  /** Metadata of request */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Created forms with metadata */
  results?: Maybe<Array<Maybe<WixFormsV4BulkFormResult>>>;
};

export type WixFormsV4BulkFormResult = {
  __typename?: 'WixFormsV4BulkFormResult';
  /** Created form */
  item?: Maybe<WixFormsV4Form>;
  /** Created form metadata */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixFormsV4BulkRemoveDeletedFieldRequestInput = {
  /** Ids of the deleted fields to remove. */
  fieldsIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Id of the form to delete. */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4BulkRemoveDeletedFieldResponse = {
  __typename?: 'WixFormsV4BulkRemoveDeletedFieldResponse';
  /** Form with the deleted fields. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4CloneFormRequestInput = {
  /** Id of the form to clone. */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4CloneFormResponse = {
  __typename?: 'WixFormsV4CloneFormResponse';
  /** The cloned form. */
  form?: Maybe<WixFormsV4Form>;
};

export enum WixFormsV4CountFormsRequestCountFormsFieldset {
  /** Include deleted forms count. */
  Deleted = 'DELETED',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4CountFormsRequestInput = {
  /** Fieldsets. */
  fieldsets?: InputMaybe<Array<InputMaybe<WixFormsV4CountFormsRequestCountFormsFieldset>>>;
  /** Namespace name. */
  namespace?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4CountFormsResponse = {
  __typename?: 'WixFormsV4CountFormsResponse';
  /** Active forms count. */
  activeCount?: Maybe<Scalars['Int']>;
  /** Deleted forms count. */
  deletedCount?: Maybe<Scalars['Int']>;
};

export type WixFormsV4CreateFormRequestInput = {
  /** Form to be created. */
  form?: InputMaybe<WixFormsV4FormInput>;
};

export type WixFormsV4CreateFormResponse = {
  __typename?: 'WixFormsV4CreateFormResponse';
  /** The created form. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4DeleteFormFromTrashBinRequestInput = {
  /** Id of the form to delete. */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4DeleteFormRequestInput = {
  /** Id of the form to delete. */
  formId?: InputMaybe<Scalars['String']>;
  /** The revision of the form. */
  revision?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4Form = {
  __typename?: 'WixFormsV4Form';
  /** Date of creation. */
  createdDate?: Maybe<Scalars['String']>;
  /** Fields which were soft deleted. */
  deletedFields?: Maybe<Array<Maybe<WixFormsV4FormField>>>;
  /** List of form fields that represent input elements. */
  deletedFieldsV2?: Maybe<Array<Maybe<WixFormsV4FormFieldV2>>>;
  /** Data extensions ExtendedFields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** List of form fields that represent input elements. */
  fields?: Maybe<Array<Maybe<WixFormsV4FormField>>>;
  /** List of form fields that represent input elements. */
  fieldsV2?: Maybe<Array<Maybe<WixFormsV4FormFieldV2>>>;
  /** Form ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Regular forms can be freely modified.
   * Extensions are copied from templates and might have restrictions.
   */
  kind?: Maybe<WixFormsV4FormKindKind>;
  /** Media folder ID. */
  mediaFolderId?: Maybe<Scalars['String']>;
  /** Identifies the namespace that the form belongs to. */
  namespace?: Maybe<Scalars['String']>;
  /** Nested forms. */
  nestedForms?: Maybe<Array<Maybe<WixFormsV4FormNestedForm>>>;
  plansVirtualReference?: Maybe<ComWixpressMembershipV2PlansQueryPublicPlansResponse>;
  /**
   * Defines triggers that will be executed after the submission, for the submissions based on this schema.
   * Forms provide a set of predefined triggers that allow it to assign specific business cases to created forms.
   */
  postSubmissionTriggers?: Maybe<WixFormsV4PostSubmissionTriggers>;
  /** Properties of the form. */
  properties?: Maybe<WixFormsV4FormFormProperties>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. For an update operation to succeed, you MUST pass the latest revision. */
  revision?: Maybe<Scalars['Int']>;
  /** Form rules, can be applied to layout and items properties. */
  rules?: Maybe<Array<Maybe<WixFormsV4FormRule>>>;
  /** Defines the layout for form fields in each submission step. */
  steps?: Maybe<Array<Maybe<WixFormsV4Step>>>;
  /** Date of last update. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixFormsV4FormPlansVirtualReferenceArgs = {
  query?: InputMaybe<ComWixpressMembershipV2CommonQueryV2Input>;
};

export type WixFormsV4FormField = {
  __typename?: 'WixFormsV4FormField';
  /** Details identifying field, which is extension of other entity */
  dataExtensionsDetails?: Maybe<WixFormsV4FormFieldDataExtensionsDetails>;
  /** Whether the field is hidden. */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Item ID. */
  id?: Maybe<Scalars['String']>;
  /** Nested form ID. */
  nestedFormId?: Maybe<Scalars['String']>;
  /** Nested form overrides. */
  nestedFormOverrides?: Maybe<WixFormsV4FormFieldNestedFormOverrides>;
  /** Mark the field as containing personal information. This will encrypt user data when storing it. */
  pii?: Maybe<Scalars['Boolean']>;
  /** Definition of a target where the value of field belongs. */
  target?: Maybe<Scalars['String']>;
  /** Validation of field output value. */
  validation?: Maybe<WixFormsV4FormFieldValidation>;
  /** Field view properties. */
  view?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4FormFieldArrayErrorMessages = {
  __typename?: 'WixFormsV4FormFieldArrayErrorMessages';
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldArrayErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldArrayType = {
  __typename?: 'WixFormsV4FormFieldArrayType';
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldArrayErrorMessages>;
  /** Type of items allowed in array. */
  items?: Maybe<WixFormsV4FormFieldArrayTypeArrayItems>;
  /** Maximum amount of array elements. */
  maxItems?: Maybe<Scalars['Int']>;
  /** Minimum amount of array elements. */
  minItems?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldArrayTypeArrayItems = {
  __typename?: 'WixFormsV4FormFieldArrayTypeArrayItems';
  /** Boolean type validation for items. */
  boolean?: Maybe<WixFormsV4FormFieldBooleanType>;
  /** Integer type validation for items. */
  integer?: Maybe<WixFormsV4FormFieldIntegerType>;
  /** Number type validation for items. */
  number?: Maybe<WixFormsV4FormFieldNumberType>;
  /** Object type validation for items */
  object?: Maybe<WixFormsV4FormFieldObjectType>;
  /** String type validation for items. */
  string?: Maybe<WixFormsV4FormFieldStringType>;
};

export type WixFormsV4FormFieldArrayTypeArrayItemsInput = {
  /** Boolean type validation for items. */
  boolean?: InputMaybe<WixFormsV4FormFieldBooleanTypeInput>;
  /** Integer type validation for items. */
  integer?: InputMaybe<WixFormsV4FormFieldIntegerTypeInput>;
  /** Number type validation for items. */
  number?: InputMaybe<WixFormsV4FormFieldNumberTypeInput>;
  /** Object type validation for items */
  object?: InputMaybe<WixFormsV4FormFieldObjectTypeInput>;
  /** String type validation for items. */
  string?: InputMaybe<WixFormsV4FormFieldStringTypeInput>;
};

export type WixFormsV4FormFieldArrayTypeInput = {
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldArrayErrorMessagesInput>;
  /** Type of items allowed in array. */
  items?: InputMaybe<WixFormsV4FormFieldArrayTypeArrayItemsInput>;
  /** Maximum amount of array elements. */
  maxItems?: InputMaybe<Scalars['Int']>;
  /** Minimum amount of array elements. */
  minItems?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldBooleanErrorMessages = {
  __typename?: 'WixFormsV4FormFieldBooleanErrorMessages';
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldBooleanErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldBooleanType = {
  __typename?: 'WixFormsV4FormFieldBooleanType';
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldBooleanErrorMessages>;
};

export type WixFormsV4FormFieldBooleanTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldBooleanErrorMessagesInput>;
};

export type WixFormsV4FormFieldContactInfo = {
  __typename?: 'WixFormsV4FormFieldContactInfo';
  /** Address info. */
  addressInfo?: Maybe<WixFormsV4FormFieldContactInfoAddressInfo>;
  /** Field mapped to contacts. */
  contactField?: Maybe<WixFormsV4FormFieldContactInfoContactField>;
  /** Custom field info. */
  customFieldInfo?: Maybe<WixFormsV4FormFieldContactInfoCustomFieldInfo>;
  /** Email info. */
  emailInfo?: Maybe<WixFormsV4FormFieldContactInfoEmailInfo>;
  /** Phone info. */
  phoneInfo?: Maybe<WixFormsV4FormFieldContactInfoPhoneInfo>;
};

export type WixFormsV4FormFieldContactInfoAddressInfo = {
  __typename?: 'WixFormsV4FormFieldContactInfoAddressInfo';
  /** Address tag. */
  tag?: Maybe<WixFormsV4FormFieldContactInfoAddressInfoTag>;
};

export type WixFormsV4FormFieldContactInfoAddressInfoInput = {
  /** Address tag. */
  tag?: InputMaybe<WixFormsV4FormFieldContactInfoAddressInfoTag>;
};

export enum WixFormsV4FormFieldContactInfoAddressInfoTag {
  Home = 'HOME',
  Untagged = 'UNTAGGED'
}

export enum WixFormsV4FormFieldContactInfoContactField {
  Address = 'ADDRESS',
  Birthdate = 'BIRTHDATE',
  Company = 'COMPANY',
  CustomField = 'CUSTOM_FIELD',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Phone = 'PHONE',
  Position = 'POSITION',
  Subscription = 'SUBSCRIPTION',
  Undefined = 'UNDEFINED',
  VatId = 'VAT_ID'
}

export type WixFormsV4FormFieldContactInfoCustomFieldInfo = {
  __typename?: 'WixFormsV4FormFieldContactInfoCustomFieldInfo';
  /** Custom field key. */
  key?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldContactInfoCustomFieldInfoInput = {
  /** Custom field key. */
  key?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldContactInfoEmailInfo = {
  __typename?: 'WixFormsV4FormFieldContactInfoEmailInfo';
  /** Email tag. */
  tag?: Maybe<WixFormsV4FormFieldContactInfoEmailInfoTag>;
};

export type WixFormsV4FormFieldContactInfoEmailInfoInput = {
  /** Email tag. */
  tag?: InputMaybe<WixFormsV4FormFieldContactInfoEmailInfoTag>;
};

export enum WixFormsV4FormFieldContactInfoEmailInfoTag {
  Main = 'MAIN',
  Untagged = 'UNTAGGED'
}

export type WixFormsV4FormFieldContactInfoInput = {
  /** Address info. */
  addressInfo?: InputMaybe<WixFormsV4FormFieldContactInfoAddressInfoInput>;
  /** Field mapped to contacts. */
  contactField?: InputMaybe<WixFormsV4FormFieldContactInfoContactField>;
  /** Custom field info. */
  customFieldInfo?: InputMaybe<WixFormsV4FormFieldContactInfoCustomFieldInfoInput>;
  /** Email info. */
  emailInfo?: InputMaybe<WixFormsV4FormFieldContactInfoEmailInfoInput>;
  /** Phone info. */
  phoneInfo?: InputMaybe<WixFormsV4FormFieldContactInfoPhoneInfoInput>;
};

export type WixFormsV4FormFieldContactInfoPhoneInfo = {
  __typename?: 'WixFormsV4FormFieldContactInfoPhoneInfo';
  /** Phone tag. */
  tag?: Maybe<WixFormsV4FormFieldContactInfoPhoneInfoTag>;
};

export type WixFormsV4FormFieldContactInfoPhoneInfoInput = {
  /** Phone tag. */
  tag?: InputMaybe<WixFormsV4FormFieldContactInfoPhoneInfoTag>;
};

export enum WixFormsV4FormFieldContactInfoPhoneInfoTag {
  Main = 'MAIN',
  Untagged = 'UNTAGGED'
}

export type WixFormsV4FormFieldDataExtensionsDetails = {
  __typename?: 'WixFormsV4FormFieldDataExtensionsDetails';
  /** FQDNS which can be extended with this field */
  fqdns?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixFormsV4FormFieldDataExtensionsDetailsInput = {
  /** FQDNS which can be extended with this field */
  fqdns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixFormsV4FormFieldInput = {
  /** Details identifying field, which is extension of other entity */
  dataExtensionsDetails?: InputMaybe<WixFormsV4FormFieldDataExtensionsDetailsInput>;
  /** Whether the field is hidden. */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Nested form ID. */
  nestedFormId?: InputMaybe<Scalars['String']>;
  /** Nested form overrides. */
  nestedFormOverrides?: InputMaybe<WixFormsV4FormFieldNestedFormOverridesInput>;
  /** Mark the field as containing personal information. This will encrypt user data when storing it. */
  pii?: InputMaybe<Scalars['Boolean']>;
  /** Definition of a target where the value of field belongs. */
  target?: InputMaybe<Scalars['String']>;
  /** Validation of field output value. */
  validation?: InputMaybe<WixFormsV4FormFieldValidationInput>;
  /** Field view properties. */
  view?: InputMaybe<Scalars['JSON']>;
};

export type WixFormsV4FormFieldIntegerType = {
  __typename?: 'WixFormsV4FormFieldIntegerType';
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldNumberErrorMessages>;
  /** Minimum value. */
  maximum?: Maybe<Scalars['Int']>;
  /** Maximum value. */
  minimum?: Maybe<Scalars['Int']>;
  /** Multiple of value. */
  multipleOf?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldIntegerTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldNumberErrorMessagesInput>;
  /** Minimum value. */
  maximum?: InputMaybe<Scalars['Int']>;
  /** Maximum value. */
  minimum?: InputMaybe<Scalars['Int']>;
  /** Multiple of value. */
  multipleOf?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldNestedFormOverrides = {
  __typename?: 'WixFormsV4FormFieldNestedFormOverrides';
  /** Field overrides by field ID */
  fieldOverrides?: Maybe<WixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverrides>;
};

export type WixFormsV4FormFieldNestedFormOverridesInput = {
  /** Field overrides by field ID */
  fieldOverrides?: InputMaybe<WixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverridesInput>;
};

export type WixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverrides = {
  __typename?: 'WixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverrides';
  /** Whether the field is hidden. Leave blank for no override. */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Whether the field is required. Leave blank for no override. */
  required?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverridesInput = {
  /** Whether the field is hidden. Leave blank for no override. */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Whether the field is required. Leave blank for no override. */
  required?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldNumberErrorMessages = {
  __typename?: 'WixFormsV4FormFieldNumberErrorMessages';
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldNumberErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldNumberType = {
  __typename?: 'WixFormsV4FormFieldNumberType';
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldNumberErrorMessages>;
  /** Inclusive maximum value. */
  maximum?: Maybe<Scalars['Float']>;
  /** Inclusive minimum value. */
  minimum?: Maybe<Scalars['Float']>;
  /** Multiple of value. */
  multipleOf?: Maybe<Scalars['Float']>;
};

export type WixFormsV4FormFieldNumberTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldNumberErrorMessagesInput>;
  /** Inclusive maximum value. */
  maximum?: InputMaybe<Scalars['Float']>;
  /** Inclusive minimum value. */
  minimum?: InputMaybe<Scalars['Float']>;
  /** Multiple of value. */
  multipleOf?: InputMaybe<Scalars['Float']>;
};

export type WixFormsV4FormFieldObjectErrorMessages = {
  __typename?: 'WixFormsV4FormFieldObjectErrorMessages';
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldObjectErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldObjectType = {
  __typename?: 'WixFormsV4FormFieldObjectType';
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldObjectErrorMessages>;
  /** Description of object properties. */
  properties?: Maybe<WixFormsV4FormFieldObjectTypePropertiesType>;
};

export type WixFormsV4FormFieldObjectTypeInput = {
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldObjectErrorMessagesInput>;
  /** Description of object properties. */
  properties?: InputMaybe<WixFormsV4FormFieldObjectTypePropertiesTypeInput>;
};

export type WixFormsV4FormFieldObjectTypePropertiesType = {
  __typename?: 'WixFormsV4FormFieldObjectTypePropertiesType';
  /** Array type validation for property. */
  array?: Maybe<WixFormsV4FormFieldArrayType>;
  /** Boolean type validation for property. */
  boolean?: Maybe<WixFormsV4FormFieldBooleanType>;
  /** Integer type validation for property. */
  integer?: Maybe<WixFormsV4FormFieldIntegerType>;
  /** Number type validation for property. */
  number?: Maybe<WixFormsV4FormFieldNumberType>;
  /** Whether the property is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** String type validation for property. */
  string?: Maybe<WixFormsV4FormFieldStringType>;
};

export type WixFormsV4FormFieldObjectTypePropertiesTypeInput = {
  /** Array type validation for property. */
  array?: InputMaybe<WixFormsV4FormFieldArrayTypeInput>;
  /** Boolean type validation for property. */
  boolean?: InputMaybe<WixFormsV4FormFieldBooleanTypeInput>;
  /** Integer type validation for property. */
  integer?: InputMaybe<WixFormsV4FormFieldIntegerTypeInput>;
  /** Number type validation for property. */
  number?: InputMaybe<WixFormsV4FormFieldNumberTypeInput>;
  /** Whether the property is required. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** String type validation for property. */
  string?: InputMaybe<WixFormsV4FormFieldStringTypeInput>;
};

export type WixFormsV4FormFieldPaymentInfoProduct = {
  __typename?: 'WixFormsV4FormFieldPaymentInfoProduct';
  /** Dynamic price options. */
  dynamicPriceOptions?: Maybe<WixFormsV4FormFieldPaymentInfoProductDynamicPriceOptions>;
  /** Fixed price options. */
  fixedPriceOptions?: Maybe<WixFormsV4FormFieldPaymentInfoProductFixedPriceOptions>;
  /** Product ID. */
  id?: Maybe<Scalars['String']>;
  /** Price type. */
  priceType?: Maybe<WixFormsV4FormFieldPaymentInfoProductPriceTypeEnumPriceType>;
  /** Product type. */
  productType?: Maybe<WixFormsV4FormFieldPaymentInfoProductProductTypeEnumProductType>;
  /** Quantity limit. */
  quantityLimit?: Maybe<WixFormsV4FormFieldPaymentInfoProductQuantityLimit>;
};

export type WixFormsV4FormFieldPaymentInfoProductDynamicPriceOptions = {
  __typename?: 'WixFormsV4FormFieldPaymentInfoProductDynamicPriceOptions';
  /** Maximal price monetary amount. */
  maxPrice?: Maybe<Scalars['String']>;
  /** Minimal price monetary amount. */
  minPrice?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldPaymentInfoProductDynamicPriceOptionsInput = {
  /** Maximal price monetary amount. */
  maxPrice?: InputMaybe<Scalars['String']>;
  /** Minimal price monetary amount. */
  minPrice?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldPaymentInfoProductFixedPriceOptions = {
  __typename?: 'WixFormsV4FormFieldPaymentInfoProductFixedPriceOptions';
  /** Fixed price monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  price?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldPaymentInfoProductFixedPriceOptionsInput = {
  /** Fixed price monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  price?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldPaymentInfoProductInput = {
  /** Dynamic price options. */
  dynamicPriceOptions?: InputMaybe<WixFormsV4FormFieldPaymentInfoProductDynamicPriceOptionsInput>;
  /** Fixed price options. */
  fixedPriceOptions?: InputMaybe<WixFormsV4FormFieldPaymentInfoProductFixedPriceOptionsInput>;
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Price type. */
  priceType?: InputMaybe<WixFormsV4FormFieldPaymentInfoProductPriceTypeEnumPriceType>;
  /** Product type. */
  productType?: InputMaybe<WixFormsV4FormFieldPaymentInfoProductProductTypeEnumProductType>;
  /** Quantity limit. */
  quantityLimit?: InputMaybe<WixFormsV4FormFieldPaymentInfoProductQuantityLimitInput>;
};

export enum WixFormsV4FormFieldPaymentInfoProductPriceTypeEnumPriceType {
  /** Dynamic price from price range. */
  DynamicPrice = 'DYNAMIC_PRICE',
  /** Fixed price. */
  FixedPrice = 'FIXED_PRICE',
  Unknown = 'UNKNOWN'
}

export enum WixFormsV4FormFieldPaymentInfoProductProductTypeEnumProductType {
  /** Digital. */
  Digital = 'DIGITAL',
  /** Shippable (physical). */
  Shippable = 'SHIPPABLE',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormFieldPaymentInfoProductQuantityLimit = {
  __typename?: 'WixFormsV4FormFieldPaymentInfoProductQuantityLimit';
  /** Maximum quantity. */
  maximum?: Maybe<Scalars['Int']>;
  /** Minimum quantity. */
  minimum?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldPaymentInfoProductQuantityLimitInput = {
  /** Maximum quantity. */
  maximum?: InputMaybe<Scalars['Int']>;
  /** Minimum quantity. */
  minimum?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldPredefinedValidation = {
  __typename?: 'WixFormsV4FormFieldPredefinedValidation';
  /** Format of predefined validation. */
  format?: Maybe<WixFormsV4FormFieldPredefinedValidationValidationFormat>;
  /** Payment input field. */
  paymentOptions?: Maybe<WixFormsV4PaymentType>;
};

export type WixFormsV4FormFieldPredefinedValidationInput = {
  /** Format of predefined validation. */
  format?: InputMaybe<WixFormsV4FormFieldPredefinedValidationValidationFormat>;
  /** Payment input field. */
  paymentOptions?: InputMaybe<WixFormsV4PaymentTypeInput>;
};

export enum WixFormsV4FormFieldPredefinedValidationValidationFormat {
  /** Payment validation. */
  Payment = 'PAYMENT',
  Undefined = 'UNDEFINED',
  /** File upload validation. */
  WixFile = 'WIX_FILE'
}

export type WixFormsV4FormFieldStringErrorMessages = {
  __typename?: 'WixFormsV4FormFieldStringErrorMessages';
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldStringErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldStringType = {
  __typename?: 'WixFormsV4FormFieldStringType';
  /** DATE_OPTIONAL_TIME format options */
  dateOptionalTimeOptions?: Maybe<WixFormsV4FormFieldStringTypeDateTimeConstraints>;
  /** DATE format options */
  dateOptions?: Maybe<WixFormsV4FormFieldStringTypeDateTimeConstraints>;
  /** DATE_TIME format options */
  dateTimeOptions?: Maybe<WixFormsV4FormFieldStringTypeDateTimeConstraints>;
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Custom error messages when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldStringErrorMessages>;
  /** Format of a string. */
  format?: Maybe<WixFormsV4FormFieldStringTypeFormatEnumFormat>;
  /** Maximum length. */
  maxLength?: Maybe<Scalars['Int']>;
  /** Minimum length. */
  minLength?: Maybe<Scalars['Int']>;
  /** Pattern for a regular expression match. */
  pattern?: Maybe<Scalars['String']>;
  /** TIME format options */
  timeOptions?: Maybe<WixFormsV4FormFieldStringTypeDateTimeConstraints>;
};

export type WixFormsV4FormFieldStringTypeDateTimeConstraints = {
  __typename?: 'WixFormsV4FormFieldStringTypeDateTimeConstraints';
  /**
   * Support static constrains defined as ISO date/time format, as well as
   * dynamic calculations can be performed using special keywords such as "$now" to represent the current date and time.
   * The dynamic calculation supports expressions like "$now+2d" (2 days in the future), "$now-1h" (1 hour in the past), etc.
   * The regex pattern for dynamic calculations is: \$now([+-]\d{1,2})([yMdmh])
   */
  maximum?: Maybe<Scalars['String']>;
  /**
   * Support static constrains defined as ISO date/time format, as well as
   * dynamic calculations can be performed using special keywords such as "$now" to represent the current date and time.
   * The dynamic calculation supports expressions like "$now+2d" (2 days in the future), "$now-1h" (1 hour in the past), etc.
   * The regex pattern for dynamic calculations is: \$now([+-]\d{1,2})([yMdmh])
   */
  minimum?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldStringTypeDateTimeConstraintsInput = {
  /**
   * Support static constrains defined as ISO date/time format, as well as
   * dynamic calculations can be performed using special keywords such as "$now" to represent the current date and time.
   * The dynamic calculation supports expressions like "$now+2d" (2 days in the future), "$now-1h" (1 hour in the past), etc.
   * The regex pattern for dynamic calculations is: \$now([+-]\d{1,2})([yMdmh])
   */
  maximum?: InputMaybe<Scalars['String']>;
  /**
   * Support static constrains defined as ISO date/time format, as well as
   * dynamic calculations can be performed using special keywords such as "$now" to represent the current date and time.
   * The dynamic calculation supports expressions like "$now+2d" (2 days in the future), "$now-1h" (1 hour in the past), etc.
   * The regex pattern for dynamic calculations is: \$now([+-]\d{1,2})([yMdmh])
   */
  minimum?: InputMaybe<Scalars['String']>;
};

export enum WixFormsV4FormFieldStringTypeFormatEnumFormat {
  ColorHex = 'COLOR_HEX',
  Currency = 'CURRENCY',
  Date = 'DATE',
  DateOptionalTime = 'DATE_OPTIONAL_TIME',
  DateTime = 'DATE_TIME',
  Email = 'EMAIL',
  Hostname = 'HOSTNAME',
  Language = 'LANGUAGE',
  Phone = 'PHONE',
  Time = 'TIME',
  Undefined = 'UNDEFINED',
  Uri = 'URI',
  Url = 'URL',
  Uuid = 'UUID'
}

export type WixFormsV4FormFieldStringTypeInput = {
  /** DATE_OPTIONAL_TIME format options */
  dateOptionalTimeOptions?: InputMaybe<WixFormsV4FormFieldStringTypeDateTimeConstraintsInput>;
  /** DATE format options */
  dateOptions?: InputMaybe<WixFormsV4FormFieldStringTypeDateTimeConstraintsInput>;
  /** DATE_TIME format options */
  dateTimeOptions?: InputMaybe<WixFormsV4FormFieldStringTypeDateTimeConstraintsInput>;
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Custom error messages when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldStringErrorMessagesInput>;
  /** Format of a string. */
  format?: InputMaybe<WixFormsV4FormFieldStringTypeFormatEnumFormat>;
  /** Maximum length. */
  maxLength?: InputMaybe<Scalars['Int']>;
  /** Minimum length. */
  minLength?: InputMaybe<Scalars['Int']>;
  /** Pattern for a regular expression match. */
  pattern?: InputMaybe<Scalars['String']>;
  /** TIME format options */
  timeOptions?: InputMaybe<WixFormsV4FormFieldStringTypeDateTimeConstraintsInput>;
};

export type WixFormsV4FormFieldV2 = {
  __typename?: 'WixFormsV4FormFieldV2';
  /** Field for displaying information */
  displayOptions?: Maybe<WixFormsV4FormFieldV2DisplayField>;
  /** Type of the field */
  fieldType?: Maybe<WixFormsV4FormFieldV2FieldType>;
  /**
   * Whether the field is hidden.
   * Default: false
   */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Field id. */
  id?: Maybe<Scalars['String']>;
  /** Custom identification of field, can be used to specify exceptional behaviour of client for specific field */
  identifier?: Maybe<Scalars['String']>;
  /** Field accept input of data */
  inputOptions?: Maybe<WixFormsV4FormFieldV2InputField>;
  /** Submit button of the form */
  submitOptions?: Maybe<WixFormsV4FormFieldV2SubmitButton>;
};

export type WixFormsV4FormFieldV2DisplayField = {
  __typename?: 'WixFormsV4FormFieldV2DisplayField';
  /** Header field */
  header?: Maybe<WixFormsV4FormFieldV2DisplayFieldHeader>;
  /** Rich text field */
  richText?: Maybe<WixFormsV4FormFieldV2DisplayFieldRichText>;
};

export type WixFormsV4FormFieldV2DisplayFieldHeader = {
  __typename?: 'WixFormsV4FormFieldV2DisplayFieldHeader';
  /** Content of the header */
  content?: Maybe<WixRichContentV1RichContent>;
};

export type WixFormsV4FormFieldV2DisplayFieldHeaderInput = {
  /** Content of the header */
  content?: InputMaybe<WixRichContentV1RichContentInput>;
};

export type WixFormsV4FormFieldV2DisplayFieldInput = {
  /** Header field */
  header?: InputMaybe<WixFormsV4FormFieldV2DisplayFieldHeaderInput>;
  /** Rich text field */
  richText?: InputMaybe<WixFormsV4FormFieldV2DisplayFieldRichTextInput>;
};

export type WixFormsV4FormFieldV2DisplayFieldRichText = {
  __typename?: 'WixFormsV4FormFieldV2DisplayFieldRichText';
  /** Content of the rich text field */
  content?: Maybe<WixRichContentV1RichContent>;
};

export type WixFormsV4FormFieldV2DisplayFieldRichTextInput = {
  /** Content of the rich text field */
  content?: InputMaybe<WixRichContentV1RichContentInput>;
};

export enum WixFormsV4FormFieldV2FieldType {
  Display = 'DISPLAY',
  Input = 'INPUT',
  Submit = 'SUBMIT',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2Input = {
  /** Field for displaying information */
  displayOptions?: InputMaybe<WixFormsV4FormFieldV2DisplayFieldInput>;
  /** Type of the field */
  fieldType?: InputMaybe<WixFormsV4FormFieldV2FieldType>;
  /**
   * Whether the field is hidden.
   * Default: false
   */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Field id. */
  id?: InputMaybe<Scalars['String']>;
  /** Custom identification of field, can be used to specify exceptional behaviour of client for specific field */
  identifier?: InputMaybe<Scalars['String']>;
  /** Field accept input of data */
  inputOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldInput>;
  /** Submit button of the form */
  submitOptions?: InputMaybe<WixFormsV4FormFieldV2SubmitButtonInput>;
};

export type WixFormsV4FormFieldV2InputField = {
  __typename?: 'WixFormsV4FormFieldV2InputField';
  /** Input return array as value */
  arrayOptions?: Maybe<WixFormsV4FormFieldV2InputFieldArray>;
  /** Input return boolean as value */
  booleanOptions?: Maybe<WixFormsV4FormFieldV2InputFieldBoolean>;
  /** Type of the input field */
  inputType?: Maybe<WixFormsV4FormFieldV2InputFieldInputType>;
  /** Input return number as value */
  numberOptions?: Maybe<WixFormsV4FormFieldV2InputFieldNumber>;
  /** Input return object as value */
  objectOptions?: Maybe<WixFormsV4FormFieldV2InputFieldObject>;
  /** Input returns selected products as value. */
  paymentOptions?: Maybe<WixFormsV4FormFieldV2InputFieldPayment>;
  /**
   * Mark the field as containing personal information. This will encrypt user data when storing it.
   * Default: false
   */
  pii?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the field is required.
   * Default: false
   */
  required?: Maybe<Scalars['Boolean']>;
  /** Input return string as value */
  stringOptions?: Maybe<WixFormsV4FormFieldV2InputFieldString>;
  /** Definition of a target where the value of field belongs. */
  target?: Maybe<Scalars['String']>;
  /** Input return "Wix file" as value */
  wixFileOptions?: Maybe<WixFormsV4FormFieldV2InputFieldWixFile>;
};

export type WixFormsV4FormFieldV2InputFieldArray = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldArray';
  /** Checkbox group input field */
  checkboxGroupOptions?: Maybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroup>;
  /** Component type of the array input field */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldArrayComponentType>;
  /** Validation of array type. */
  validation?: Maybe<WixFormsV4FormFieldV2InputFieldArrayType>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroup = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldArrayCheckboxGroup';
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: Maybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOption>;
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field */
  label?: Maybe<Scalars['String']>;
  /** List of options to select from */
  options?: Maybe<Array<Maybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOption>>>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOption = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOption';
  /** Label of custom option input */
  label?: Maybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOptionInput = {
  /** Label of custom option input */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupInput = {
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOptionInput>;
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field */
  label?: InputMaybe<Scalars['String']>;
  /** List of options to select from */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOptionInput>>>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOption = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOption';
  /** Flag identifying that option should be selected by default */
  default?: Maybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label */
  label?: Maybe<Scalars['String']>;
  /** Media item. Media, associated with option, like image. */
  media?: Maybe<WixFormsV4FormFieldV2MediaItem>;
  /** Selectable option value, which is saved to DB. */
  value?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOptionInput = {
  /** Flag identifying that option should be selected by default */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label */
  label?: InputMaybe<Scalars['String']>;
  /** Media item. Media, associated with option, like image. */
  media?: InputMaybe<WixFormsV4FormFieldV2MediaItemInput>;
  /** Selectable option value, which is saved to DB. */
  value?: InputMaybe<Scalars['JSON']>;
};

export enum WixFormsV4FormFieldV2InputFieldArrayComponentType {
  CheckboxGroup = 'CHECKBOX_GROUP',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldArrayErrorMessages = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldArrayErrorMessages';
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayInput = {
  /** Checkbox group input field */
  checkboxGroupOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupInput>;
  /** Component type of the array input field */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayComponentType>;
  /** Validation of array type. */
  validation?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldArrayType = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldArrayType';
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldArrayErrorMessages>;
  /** Type of items allowed in array. */
  items?: Maybe<WixFormsV4FormFieldV2InputFieldArrayTypeArrayItems>;
  /** Maximum amount of array elements. */
  maxItems?: Maybe<Scalars['Int']>;
  /** Minimum amount of array elements. */
  minItems?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayTypeArrayItems = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldArrayTypeArrayItems';
  /** Boolean type validation for items. */
  booleanOptions?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanType>;
  /** Integer type validation for items. */
  integerOptions?: Maybe<WixFormsV4FormFieldV2InputFieldIntegerType>;
  /** Type of array items */
  itemType?: Maybe<WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsItemType>;
  /** Number type validation for items. */
  numberOptions?: Maybe<WixFormsV4FormFieldV2InputFieldNumberType>;
  /** Object type validation for items */
  objectOptions?: Maybe<WixFormsV4FormFieldV2InputFieldObjectType>;
  /** String type validation for items. */
  stringOptions?: Maybe<WixFormsV4FormFieldV2InputFieldStringType>;
};

export type WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsInput = {
  /** Boolean type validation for items. */
  booleanOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanTypeInput>;
  /** Integer type validation for items. */
  integerOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldIntegerTypeInput>;
  /** Type of array items */
  itemType?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsItemType>;
  /** Number type validation for items. */
  numberOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberTypeInput>;
  /** Object type validation for items */
  objectOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectTypeInput>;
  /** String type validation for items. */
  stringOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringTypeInput>;
};

export enum WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsItemType {
  Boolean = 'BOOLEAN',
  Integer = 'INTEGER',
  Number = 'NUMBER',
  Object = 'OBJECT',
  String = 'STRING',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldArrayTypeInput = {
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayErrorMessagesInput>;
  /** Type of items allowed in array. */
  items?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsInput>;
  /** Maximum amount of array elements. */
  maxItems?: InputMaybe<Scalars['Int']>;
  /** Minimum amount of array elements. */
  minItems?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldV2InputFieldBoolean = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldBoolean';
  /** Checkbox input field */
  checkboxOptions?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanCheckbox>;
  /** Component type of the boolean input field */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanComponentType>;
  /** Validation of field output value. */
  validation?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanType>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanCheckbox = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldBooleanCheckbox';
  /** Label of the field */
  label?: Maybe<WixRichContentV1RichContent>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanCheckboxInput = {
  /** Label of the field */
  label?: InputMaybe<WixRichContentV1RichContentInput>;
};

export enum WixFormsV4FormFieldV2InputFieldBooleanComponentType {
  Checkbox = 'CHECKBOX',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldBooleanErrorMessages = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldBooleanErrorMessages';
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanInput = {
  /** Checkbox input field */
  checkboxOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanCheckboxInput>;
  /** Component type of the boolean input field */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanComponentType>;
  /** Validation of field output value. */
  validation?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanType = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldBooleanType';
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanErrorMessages>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanErrorMessagesInput>;
};

export type WixFormsV4FormFieldV2InputFieldInput = {
  /** Input return array as value */
  arrayOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayInput>;
  /** Input return boolean as value */
  booleanOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanInput>;
  /** Type of the input field */
  inputType?: InputMaybe<WixFormsV4FormFieldV2InputFieldInputType>;
  /** Input return number as value */
  numberOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberInput>;
  /** Input return object as value */
  objectOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectInput>;
  /** Input returns selected products as value. */
  paymentOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldPaymentInput>;
  /**
   * Mark the field as containing personal information. This will encrypt user data when storing it.
   * Default: false
   */
  pii?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the field is required.
   * Default: false
   */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Input return string as value */
  stringOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringInput>;
  /** Definition of a target where the value of field belongs. */
  target?: InputMaybe<Scalars['String']>;
  /** Input return "Wix file" as value */
  wixFileOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldWixFileInput>;
};

export enum WixFormsV4FormFieldV2InputFieldInputType {
  Array = 'ARRAY',
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  Object = 'OBJECT',
  Payment = 'PAYMENT',
  String = 'STRING',
  Unknown = 'UNKNOWN',
  WixFile = 'WIX_FILE'
}

export type WixFormsV4FormFieldV2InputFieldIntegerType = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldIntegerType';
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldNumberErrorMessages>;
  /** Maximum value. */
  maximum?: Maybe<Scalars['Int']>;
  /** Minimum value. */
  minimum?: Maybe<Scalars['Int']>;
  /** Multiple of value. */
  multipleOf?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldV2InputFieldIntegerTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput>;
  /** Maximum value. */
  maximum?: InputMaybe<Scalars['Int']>;
  /** Minimum value. */
  minimum?: InputMaybe<Scalars['Int']>;
  /** Multiple of value. */
  multipleOf?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldV2InputFieldNumber = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldNumber';
  /** Component type of the number input field */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldNumberComponentType>;
  /** Number value input field */
  numberInputOptions?: Maybe<WixFormsV4FormFieldV2InputFieldNumberNumberInput>;
  /** Validation of field output value. */
  validation?: Maybe<WixFormsV4FormFieldV2InputFieldNumberType>;
};

export enum WixFormsV4FormFieldV2InputFieldNumberComponentType {
  NumberInput = 'NUMBER_INPUT',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldNumberErrorMessages = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldNumberErrorMessages';
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldNumberInput = {
  /** Component type of the number input field */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberComponentType>;
  /** Number value input field */
  numberInputOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberNumberInputInput>;
  /** Validation of field output value. */
  validation?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldNumberNumberInput = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldNumberNumberInput';
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field */
  label?: Maybe<Scalars['String']>;
  /** Placeholder for the value input */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldNumberNumberInputInput = {
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder for the value input */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldNumberType = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldNumberType';
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldNumberErrorMessages>;
  /** Inclusive maximum value. */
  maximum?: Maybe<Scalars['Float']>;
  /** Inclusive minimum value. */
  minimum?: Maybe<Scalars['Float']>;
  /** Multiple of value. */
  multipleOf?: Maybe<Scalars['Float']>;
};

export type WixFormsV4FormFieldV2InputFieldNumberTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput>;
  /** Inclusive maximum value. */
  maximum?: InputMaybe<Scalars['Float']>;
  /** Inclusive minimum value. */
  minimum?: InputMaybe<Scalars['Float']>;
  /** Multiple of value. */
  multipleOf?: InputMaybe<Scalars['Float']>;
};

export type WixFormsV4FormFieldV2InputFieldObject = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldObject';
  /** Nested form ID. */
  nestedFormId?: Maybe<Scalars['String']>;
  /** Validation of object type. */
  object?: Maybe<WixFormsV4FormFieldV2InputFieldObjectType>;
};

export type WixFormsV4FormFieldV2InputFieldObjectErrorMessages = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldObjectErrorMessages';
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldObjectErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldObjectInput = {
  /** Nested form ID. */
  nestedFormId?: InputMaybe<Scalars['String']>;
  /** Validation of object type. */
  object?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldObjectType = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldObjectType';
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldObjectErrorMessages>;
  /** Description of object properties. */
  properties?: Maybe<WixFormsV4FormFieldV2InputFieldObjectTypePropertiesType>;
};

export type WixFormsV4FormFieldV2InputFieldObjectTypeInput = {
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectErrorMessagesInput>;
  /** Description of object properties. */
  properties?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldObjectTypePropertiesType = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldObjectTypePropertiesType';
  /** Array type validation for property. */
  arrayOptions?: Maybe<WixFormsV4FormFieldV2InputFieldArrayType>;
  /** Boolean type validation for property. */
  booleanOptions?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanType>;
  /** Integer type validation for property. */
  integerOptions?: Maybe<WixFormsV4FormFieldV2InputFieldIntegerType>;
  /** Number type validation for property. */
  numberOptions?: Maybe<WixFormsV4FormFieldV2InputFieldNumberType>;
  /** Type of object properties */
  propertiesType?: Maybe<WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypePropertiesType>;
  /** Whether the property is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** String type validation for property. */
  stringOptions?: Maybe<WixFormsV4FormFieldV2InputFieldStringType>;
};

export type WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypeInput = {
  /** Array type validation for property. */
  arrayOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayTypeInput>;
  /** Boolean type validation for property. */
  booleanOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanTypeInput>;
  /** Integer type validation for property. */
  integerOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldIntegerTypeInput>;
  /** Number type validation for property. */
  numberOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberTypeInput>;
  /** Type of object properties */
  propertiesType?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypePropertiesType>;
  /** Whether the property is required. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** String type validation for property. */
  stringOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringTypeInput>;
};

export enum WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypePropertiesType {
  Array = 'ARRAY',
  Boolean = 'BOOLEAN',
  Integer = 'INTEGER',
  Number = 'NUMBER',
  String = 'STRING',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldPayment = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldPayment';
  /** Checkbox group input field. */
  checkboxGroupOptions?: Maybe<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroup>;
  /** Component type of the payment input field. */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldPaymentComponentType>;
  /** Validation of payment type. */
  validation?: Maybe<WixFormsV4PaymentType>;
};

export type WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroup = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroup';
  /** Description of the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field. */
  label?: Maybe<Scalars['String']>;
  /** List of options to select from. */
  options?: Maybe<Array<Maybe<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOption>>>;
};

export type WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupInput = {
  /** Description of the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field. */
  label?: InputMaybe<Scalars['String']>;
  /** List of options to select from. */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOptionInput>>>;
};

export type WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOption = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOption';
  /** Option id. Used as binding for translations. */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label. */
  label?: Maybe<Scalars['String']>;
  /** Media item. Media, associated with option, like image. */
  media?: Maybe<WixFormsV4FormFieldV2MediaItem>;
  /** Selectable option value, which is saved to DB. Corresponds to product id, found in field's products list. */
  value?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOptionInput = {
  /** Option id. Used as binding for translations. */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media item. Media, associated with option, like image. */
  media?: InputMaybe<WixFormsV4FormFieldV2MediaItemInput>;
  /** Selectable option value, which is saved to DB. Corresponds to product id, found in field's products list. */
  value?: InputMaybe<Scalars['JSON']>;
};

export enum WixFormsV4FormFieldV2InputFieldPaymentComponentType {
  CheckboxGroup = 'CHECKBOX_GROUP',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldPaymentInput = {
  /** Checkbox group input field. */
  checkboxGroupOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupInput>;
  /** Component type of the payment input field. */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldPaymentComponentType>;
  /** Validation of payment type. */
  validation?: InputMaybe<WixFormsV4PaymentTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldString = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldString';
  /** Component type of the string input field */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldStringComponentType>;
  /** Selection field as drop down */
  dropdownOptions?: Maybe<WixFormsV4FormFieldV2InputFieldStringDropdown>;
  /** Selection field as radio group */
  radioGroupOptions?: Maybe<WixFormsV4FormFieldV2InputFieldStringRadioGroup>;
  /** Text input field */
  textInputOptions?: Maybe<WixFormsV4FormFieldV2InputFieldStringTextInput>;
  /** Validation of field output value. */
  validation?: Maybe<WixFormsV4FormFieldV2InputFieldStringType>;
};

export enum WixFormsV4FormFieldV2InputFieldStringComponentType {
  Dropdown = 'DROPDOWN',
  RadioGroup = 'RADIO_GROUP',
  TextInput = 'TEXT_INPUT',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldStringDropDownCustomOption = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldStringDropDownCustomOption';
  /** Label of custom option input */
  label?: Maybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropDownCustomOptionInput = {
  /** Label of custom option input */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropDownOption = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldStringDropDownOption';
  /** Flag identifying that option should be selected by default */
  default?: Maybe<Scalars['Boolean']>;
  /** Selectable option label */
  label?: Maybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropDownOptionInput = {
  /** Flag identifying that option should be selected by default */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Selectable option label */
  label?: InputMaybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdown = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldStringDropdown';
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: Maybe<WixFormsV4FormFieldV2InputFieldStringDropdownCustomOption>;
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field */
  label?: Maybe<Scalars['String']>;
  /** List of options to select from */
  options?: Maybe<Array<Maybe<WixFormsV4FormFieldV2InputFieldStringDropdownOption>>>;
  /** Placeholder of dropdown input */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdownCustomOption = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldStringDropdownCustomOption';
  /** Label of custom option input */
  label?: Maybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdownCustomOptionInput = {
  /** Label of custom option input */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdownInput = {
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringDropdownCustomOptionInput>;
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field */
  label?: InputMaybe<Scalars['String']>;
  /** List of options to select from */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2InputFieldStringDropdownOptionInput>>>;
  /** Placeholder of dropdown input */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdownOption = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldStringDropdownOption';
  /** Flag identifying that option should be selected by default */
  default?: Maybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label */
  label?: Maybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdownOptionInput = {
  /** Flag identifying that option should be selected by default */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label */
  label?: InputMaybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringErrorMessages = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldStringErrorMessages';
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringInput = {
  /** Component type of the string input field */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringComponentType>;
  /** Selection field as drop down */
  dropdownOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringDropdownInput>;
  /** Selection field as radio group */
  radioGroupOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringRadioGroupInput>;
  /** Text input field */
  textInputOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringTextInputInput>;
  /** Validation of field output value. */
  validation?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroup = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldStringRadioGroup';
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: Maybe<WixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOption>;
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field */
  label?: Maybe<Scalars['String']>;
  /**
   * Flag identifying to show option allowing input custom value
   * List of options to select from
   */
  options?: Maybe<Array<Maybe<WixFormsV4FormFieldV2InputFieldStringRadioGroupOption>>>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOption = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOption';
  /** Label of custom option input */
  label?: Maybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOptionInput = {
  /** Label of custom option input */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroupInput = {
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOptionInput>;
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Flag identifying to show option allowing input custom value
   * List of options to select from
   */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2InputFieldStringRadioGroupOptionInput>>>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroupOption = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldStringRadioGroupOption';
  /** Flag identifying that option should be selected by default */
  default?: Maybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label */
  label?: Maybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroupOptionInput = {
  /** Flag identifying that option should be selected by default */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label */
  label?: InputMaybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringTextInput = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldStringTextInput';
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field */
  label?: Maybe<Scalars['String']>;
  /** Placeholder for the value input */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringTextInputInput = {
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder for the value input */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringType = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldStringType';
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Custom error messages when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldStringErrorMessages>;
  /** Format of a string. */
  format?: Maybe<WixFormsV4FormFieldV2InputFieldStringTypeFormatEnumFormat>;
  /** Maximum length. */
  maxLength?: Maybe<Scalars['Int']>;
  /** Minimum length. */
  minLength?: Maybe<Scalars['Int']>;
  /** Pattern for a regular expression match. */
  pattern?: Maybe<Scalars['String']>;
};

export enum WixFormsV4FormFieldV2InputFieldStringTypeFormatEnumFormat {
  ColorHex = 'COLOR_HEX',
  Currency = 'CURRENCY',
  Date = 'DATE',
  DateOptionalTime = 'DATE_OPTIONAL_TIME',
  DateTime = 'DATE_TIME',
  Email = 'EMAIL',
  Hostname = 'HOSTNAME',
  Language = 'LANGUAGE',
  Phone = 'PHONE',
  Time = 'TIME',
  Undefined = 'UNDEFINED',
  Uri = 'URI',
  Url = 'URL',
  Uuid = 'UUID'
}

export type WixFormsV4FormFieldV2InputFieldStringTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Custom error messages when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringErrorMessagesInput>;
  /** Format of a string. */
  format?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringTypeFormatEnumFormat>;
  /** Maximum length. */
  maxLength?: InputMaybe<Scalars['Int']>;
  /** Minimum length. */
  minLength?: InputMaybe<Scalars['Int']>;
  /** Pattern for a regular expression match. */
  pattern?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldWixFile = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldWixFile';
  /** Component type of the array input field */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldWixFileComponentType>;
  /** File upload input field */
  fileUploadOptions?: Maybe<WixFormsV4FormFieldV2InputFieldWixFileFileUpload>;
};

export enum WixFormsV4FormFieldV2InputFieldWixFileComponentType {
  FileUpload = 'FILE_UPLOAD',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldWixFileFileUpload = {
  __typename?: 'WixFormsV4FormFieldV2InputFieldWixFileFileUpload';
  /** Text on upload button */
  buttonText?: Maybe<Scalars['String']>;
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Custom text which appears when file is uploaded, if missing file name will be shown */
  explanationText?: Maybe<Scalars['String']>;
  /** Amount of files allowed to upload */
  fileLimit?: Maybe<Scalars['Int']>;
  /** Selectable option label */
  label?: Maybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
  /** Supported file formats for upload */
  uploadFileFormats?: Maybe<Array<Maybe<WixFormsV4FormFieldV2InputFieldWixFileFileUploadUploadFileFormatEnumUploadFileFormat>>>;
};

export type WixFormsV4FormFieldV2InputFieldWixFileFileUploadInput = {
  /** Text on upload button */
  buttonText?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Custom text which appears when file is uploaded, if missing file name will be shown */
  explanationText?: InputMaybe<Scalars['String']>;
  /** Amount of files allowed to upload */
  fileLimit?: InputMaybe<Scalars['Int']>;
  /** Selectable option label */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
  /** Supported file formats for upload */
  uploadFileFormats?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2InputFieldWixFileFileUploadUploadFileFormatEnumUploadFileFormat>>>;
};

export enum WixFormsV4FormFieldV2InputFieldWixFileFileUploadUploadFileFormatEnumUploadFileFormat {
  /** Audio files */
  Audio = 'AUDIO',
  /** Document files */
  Document = 'DOCUMENT',
  /** Image files */
  Image = 'IMAGE',
  Undefined = 'UNDEFINED',
  /** Video files */
  Video = 'VIDEO'
}

export type WixFormsV4FormFieldV2InputFieldWixFileInput = {
  /** Component type of the array input field */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldWixFileComponentType>;
  /** File upload input field */
  fileUploadOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldWixFileFileUploadInput>;
};

export type WixFormsV4FormFieldV2MediaItem = {
  __typename?: 'WixFormsV4FormFieldV2MediaItem';
  /** WixMedia image. */
  image?: Maybe<ComWixFormsUpstreamWixCommonImage>;
};

export type WixFormsV4FormFieldV2MediaItemInput = {
  /** WixMedia image. */
  image?: InputMaybe<ComWixFormsUpstreamWixCommonImageInput>;
};

export type WixFormsV4FormFieldV2SubmitButton = {
  __typename?: 'WixFormsV4FormFieldV2SubmitButton';
  /** When button is not on last page it behaves as switch between pages page, text of label to go to next page. */
  nextText?: Maybe<Scalars['String']>;
  /** When button is not on last page it behaves as switch between pages page, text of label to go to previous page. */
  previousText?: Maybe<Scalars['String']>;
  /** Submit action effect is to redirect to */
  redirect?: Maybe<WixFormsV4FormFieldV2SubmitButtonRedirect>;
  /** Text on the button when button is submitting a form */
  submitText?: Maybe<Scalars['String']>;
  /** Submit action effect is to show message */
  thankYouMessage?: Maybe<WixFormsV4FormFieldV2SubmitButtonThankYouMessage>;
};

export enum WixFormsV4FormFieldV2SubmitButtonExternalUrlExternalUrlTargetEnumExternalUrlTarget {
  /** Url open in new tab */
  Blank = 'BLANK',
  /** Opened in same browser tab */
  Self = 'SELF',
  Undefined = 'UNDEFINED'
}

export type WixFormsV4FormFieldV2SubmitButtonInput = {
  /** When button is not on last page it behaves as switch between pages page, text of label to go to next page. */
  nextText?: InputMaybe<Scalars['String']>;
  /** When button is not on last page it behaves as switch between pages page, text of label to go to previous page. */
  previousText?: InputMaybe<Scalars['String']>;
  /** Submit action effect is to redirect to */
  redirect?: InputMaybe<WixFormsV4FormFieldV2SubmitButtonRedirectInput>;
  /** Text on the button when button is submitting a form */
  submitText?: InputMaybe<Scalars['String']>;
  /** Submit action effect is to show message */
  thankYouMessage?: InputMaybe<WixFormsV4FormFieldV2SubmitButtonThankYouMessageInput>;
};

export type WixFormsV4FormFieldV2SubmitButtonRedirect = {
  __typename?: 'WixFormsV4FormFieldV2SubmitButtonRedirect';
  /** How should url be opened */
  target?: Maybe<WixFormsV4FormFieldV2SubmitButtonRedirectTargetEnumTarget>;
  /** Url to which UoU should be redirected after successful submit of form */
  url?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2SubmitButtonRedirectInput = {
  /** How should url be opened */
  target?: InputMaybe<WixFormsV4FormFieldV2SubmitButtonRedirectTargetEnumTarget>;
  /** Url to which UoU should be redirected after successful submit of form */
  url?: InputMaybe<Scalars['String']>;
};

export enum WixFormsV4FormFieldV2SubmitButtonRedirectTargetEnumTarget {
  /** Url open in new tab */
  Blank = 'BLANK',
  /** Opened in same browser tab */
  Self = 'SELF',
  Undefined = 'UNDEFINED'
}

export type WixFormsV4FormFieldV2SubmitButtonThankYouMessage = {
  __typename?: 'WixFormsV4FormFieldV2SubmitButtonThankYouMessage';
  /**
   * Duration after how much second it should disappear. If 0, will stay forever.
   * Default: false
   */
  duration?: Maybe<Scalars['Int']>;
  /** Message show after form submission */
  text?: Maybe<WixRichContentV1RichContent>;
};

export type WixFormsV4FormFieldV2SubmitButtonThankYouMessageInput = {
  /**
   * Duration after how much second it should disappear. If 0, will stay forever.
   * Default: false
   */
  duration?: InputMaybe<Scalars['Int']>;
  /** Message show after form submission */
  text?: InputMaybe<WixRichContentV1RichContentInput>;
};

export type WixFormsV4FormFieldValidation = {
  __typename?: 'WixFormsV4FormFieldValidation';
  /** Validation of array type. */
  array?: Maybe<WixFormsV4FormFieldArrayType>;
  /** Validation of boolean type. */
  boolean?: Maybe<WixFormsV4FormFieldBooleanType>;
  /** Validation of integer type. */
  integer?: Maybe<WixFormsV4FormFieldIntegerType>;
  /** Validation of number type. */
  number?: Maybe<WixFormsV4FormFieldNumberType>;
  /** Validation of object type. */
  object?: Maybe<WixFormsV4FormFieldObjectType>;
  /** Predefined validation of specific format */
  predefined?: Maybe<WixFormsV4FormFieldPredefinedValidation>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** Validation of string type. */
  string?: Maybe<WixFormsV4FormFieldStringType>;
};

export type WixFormsV4FormFieldValidationInput = {
  /** Validation of array type. */
  array?: InputMaybe<WixFormsV4FormFieldArrayTypeInput>;
  /** Validation of boolean type. */
  boolean?: InputMaybe<WixFormsV4FormFieldBooleanTypeInput>;
  /** Validation of integer type. */
  integer?: InputMaybe<WixFormsV4FormFieldIntegerTypeInput>;
  /** Validation of number type. */
  number?: InputMaybe<WixFormsV4FormFieldNumberTypeInput>;
  /** Validation of object type. */
  object?: InputMaybe<WixFormsV4FormFieldObjectTypeInput>;
  /** Predefined validation of specific format */
  predefined?: InputMaybe<WixFormsV4FormFieldPredefinedValidationInput>;
  /** Whether the field is required. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Validation of string type. */
  string?: InputMaybe<WixFormsV4FormFieldStringTypeInput>;
};

export enum WixFormsV4FormFieldsetFieldset {
  /** Includes nested forms when present. */
  NestedForms = 'NESTED_FORMS',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormFormProperties = {
  __typename?: 'WixFormsV4FormFormProperties';
  /** Identifies if the form is disabled. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** Form name. */
  name?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFormPropertiesInput = {
  /** Identifies if the form is disabled. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** Form name. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormInput = {
  /** Date of creation. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Fields which were soft deleted. */
  deletedFields?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldInput>>>;
  /** List of form fields that represent input elements. */
  deletedFieldsV2?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2Input>>>;
  /** Data extensions ExtendedFields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** List of form fields that represent input elements. */
  fields?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldInput>>>;
  /** List of form fields that represent input elements. */
  fieldsV2?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2Input>>>;
  /** Form ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Regular forms can be freely modified.
   * Extensions are copied from templates and might have restrictions.
   */
  kind?: InputMaybe<WixFormsV4FormKindKind>;
  /** Media folder ID. */
  mediaFolderId?: InputMaybe<Scalars['String']>;
  /** Identifies the namespace that the form belongs to. */
  namespace?: InputMaybe<Scalars['String']>;
  /** Nested forms. */
  nestedForms?: InputMaybe<Array<InputMaybe<WixFormsV4FormNestedFormInput>>>;
  /**
   * Defines triggers that will be executed after the submission, for the submissions based on this schema.
   * Forms provide a set of predefined triggers that allow it to assign specific business cases to created forms.
   */
  postSubmissionTriggers?: InputMaybe<WixFormsV4PostSubmissionTriggersInput>;
  /** Properties of the form. */
  properties?: InputMaybe<WixFormsV4FormFormPropertiesInput>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. For an update operation to succeed, you MUST pass the latest revision. */
  revision?: InputMaybe<Scalars['Int']>;
  /** Form rules, can be applied to layout and items properties. */
  rules?: InputMaybe<Array<InputMaybe<WixFormsV4FormRuleInput>>>;
  /** Defines the layout for form fields in each submission step. */
  steps?: InputMaybe<Array<InputMaybe<WixFormsV4StepInput>>>;
  /** Date of last update. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixFormsV4FormKindKind {
  Extension = 'EXTENSION',
  Regular = 'REGULAR'
}

export type WixFormsV4FormLayout = {
  __typename?: 'WixFormsV4FormLayout';
  /** Layout for large break point. */
  large?: Maybe<WixFormsV4BreakPoint>;
  /** Layout for medium break point. */
  medium?: Maybe<WixFormsV4BreakPoint>;
  /** Layout for small break point. */
  small?: Maybe<WixFormsV4BreakPoint>;
};

export type WixFormsV4FormLayoutInput = {
  /** Layout for large break point. */
  large?: InputMaybe<WixFormsV4BreakPointInput>;
  /** Layout for medium break point. */
  medium?: InputMaybe<WixFormsV4BreakPointInput>;
  /** Layout for small break point. */
  small?: InputMaybe<WixFormsV4BreakPointInput>;
};

export type WixFormsV4FormNestedForm = {
  __typename?: 'WixFormsV4FormNestedForm';
  /** Nested form. */
  form?: Maybe<WixFormsV4Form>;
  /** Targets which have this form. */
  targets?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixFormsV4FormNestedFormInput = {
  /** Nested form. */
  form?: InputMaybe<WixFormsV4FormInput>;
  /** Targets which have this form. */
  targets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixFormsV4FormRule = {
  __typename?: 'WixFormsV4FormRule';
  /** Rule on which item properties or layouts will be changed. */
  condition?: Maybe<Scalars['JSON']>;
  /** Id of the rule */
  id?: Maybe<Scalars['String']>;
  /** Name of the rule */
  name?: Maybe<Scalars['String']>;
  /**
   * Form items with defined properties that will be
   * changed when given condition is resolved to true.
   */
  overrides?: Maybe<Array<Maybe<WixFormsV4FormRuleFormOverride>>>;
};

export type WixFormsV4FormRuleFormOverride = {
  __typename?: 'WixFormsV4FormRuleFormOverride';
  /** Overridden entity id. Either fieldId, or "{fieldIdWithNestedForm}/{nestedFormFieldId}" */
  entityId?: Maybe<Scalars['String']>;
  /** Override entity type. */
  entityType?: Maybe<WixFormsV4FormRuleFormOverrideOverrideEntityTypeEnumOverrideEntityType>;
  /** Form entity properties path with new value, that will be changed on condition. */
  valueChanges?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4FormRuleFormOverrideInput = {
  /** Overridden entity id. Either fieldId, or "{fieldIdWithNestedForm}/{nestedFormFieldId}" */
  entityId?: InputMaybe<Scalars['String']>;
  /** Override entity type. */
  entityType?: InputMaybe<WixFormsV4FormRuleFormOverrideOverrideEntityTypeEnumOverrideEntityType>;
  /** Form entity properties path with new value, that will be changed on condition. */
  valueChanges?: InputMaybe<Scalars['JSON']>;
};

export enum WixFormsV4FormRuleFormOverrideOverrideEntityTypeEnumOverrideEntityType {
  Field = 'FIELD',
  Form = 'FORM',
  NestedFormField = 'NESTED_FORM_FIELD',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4FormRuleInput = {
  /** Rule on which item properties or layouts will be changed. */
  condition?: InputMaybe<Scalars['JSON']>;
  /** Id of the rule */
  id?: InputMaybe<Scalars['String']>;
  /** Name of the rule */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Form items with defined properties that will be
   * changed when given condition is resolved to true.
   */
  overrides?: InputMaybe<Array<InputMaybe<WixFormsV4FormRuleFormOverrideInput>>>;
};

export type WixFormsV4GetDeletedFormRequestInput = {
  /** Id of the Form to retrieve */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4GetDeletedFormResponse = {
  __typename?: 'WixFormsV4GetDeletedFormResponse';
  /** The retrieved Form */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4GetFormRequestInput = {
  /**
   * List of additional form fields to include in the response. For example, use the `NESTED_FORMS` fieldset to retrieve the nested forms field in
   * the response in addition to the form’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the form’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldsetFieldset>>>;
  id: Scalars['ID'];
};

export type WixFormsV4ItemLayout = {
  __typename?: 'WixFormsV4ItemLayout';
  /** Vertical coordinate in the grid. */
  column?: Maybe<Scalars['Int']>;
  /** Form field reference id. */
  fieldId?: Maybe<Scalars['String']>;
  /** Width. */
  height?: Maybe<Scalars['Int']>;
  /** Horizontal coordinate in the grid. */
  row?: Maybe<Scalars['Int']>;
  /** Height. */
  width?: Maybe<Scalars['Int']>;
};

export type WixFormsV4ItemLayoutInput = {
  /** Vertical coordinate in the grid. */
  column?: InputMaybe<Scalars['Int']>;
  /** Form field reference id. */
  fieldId?: InputMaybe<Scalars['String']>;
  /** Width. */
  height?: InputMaybe<Scalars['Int']>;
  /** Horizontal coordinate in the grid. */
  row?: InputMaybe<Scalars['Int']>;
  /** Height. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4ListDeletedFormsRequestInput = {
  /** Identifies if the form is disabled. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** Form ids. */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Kind of forms. */
  kind?: InputMaybe<WixFormsV4FormKindKind>;
  /** Namespace name. */
  namespace?: InputMaybe<Scalars['String']>;
  /**
   * Ordering options.
   *
   * - `UPDATED_DATE_ASC`: Ordered by `updatedDate` in ascending order.
   * - `UPDATED_DATE_DESC`: Ordered by `updatedDate` in descending order.
   * - `NAME_ASC`: Ordered by `properties.name` in ascending order.
   * - `NAME_DESC`: Ordered by `properties.name` in descending order.
   *
   * Default: `UPDATED_DATE_DESC`
   */
  order?: InputMaybe<WixFormsV4ListDeletedFormsRequestListDeletedFormsOrder>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not filter or `order`. */
  paging?: InputMaybe<WixCommonCursorPagingInput>;
};

export enum WixFormsV4ListDeletedFormsRequestListDeletedFormsOrder {
  /** Sorting by name ascending. */
  NameAsc = 'NAME_ASC',
  /** Sorting by name descending. */
  NameDesc = 'NAME_DESC',
  /** Sorting by updated date ascending. */
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  /** Sorting by updated date descending. The default value. */
  UpdatedDateDesc = 'UPDATED_DATE_DESC'
}

export type WixFormsV4ListDeletedFormsResponse = {
  __typename?: 'WixFormsV4ListDeletedFormsResponse';
  /** The retrieved forms. */
  forms?: Maybe<Array<Maybe<WixFormsV4Form>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<WixCommonCursorPagingMetadata>;
};

export type WixFormsV4ListFormsRequestInput = {
  /** Identifies if the form is disabled. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * List of additional form fields to include in the response. For example, use the `NESTED_FORMS` fieldset to retrieve the nested forms field in
   * the response in addition to the form’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the form’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldsetFieldset>>>;
  /** Form ids. */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Kind of forms. */
  kind?: InputMaybe<WixFormsV4FormKindKind>;
  /** Namespace name. */
  namespace?: InputMaybe<Scalars['String']>;
  /**
   * Ordering options.
   *
   * - `UPDATED_DATE_DESC`: Ordered by `updatedDate` in descending order.
   * - `UPDATED_DATE_ASC`: Ordered by `updatedDate` in ascending order.
   * - `CREATED_DATE_ASC`: Ordered by `createdDate` in ascending order.
   * - `CREATED_DATE_DESC`: Ordered by `createdDate` in descending order.
   * - `NAME_ASC`: Ordered by `properties.name` in ascending order.
   * - `NAME_DESC`: Ordered by `properties.name` in descending order.
   *
   * Default: `UPDATED_DATE_DESC`
   */
  order?: InputMaybe<WixFormsV4ListFormsRequestListFormsOrder>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not filter or `order`. */
  paging?: InputMaybe<WixCommonCursorPagingInput>;
};

export enum WixFormsV4ListFormsRequestListFormsOrder {
  /** Sorting by created date ascending. */
  CreatedDateAsc = 'CREATED_DATE_ASC',
  /** Sorting by created date descending. */
  CreatedDateDesc = 'CREATED_DATE_DESC',
  /** Sorting by name ascending. */
  NameAsc = 'NAME_ASC',
  /** Sorting by name descending. */
  NameDesc = 'NAME_DESC',
  /** Sorting by updated date ascending. */
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  /** Sorting by updated date descending. The default value. */
  UpdatedDateDesc = 'UPDATED_DATE_DESC'
}

export type WixFormsV4ListFormsResponse = {
  __typename?: 'WixFormsV4ListFormsResponse';
  /** The retrieved forms. */
  forms?: Maybe<Array<Maybe<WixFormsV4Form>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixFormsUpstreamWixCommonCursorPagingMetadata>;
};

export type WixFormsV4PaymentType = {
  __typename?: 'WixFormsV4PaymentType';
  /** Maximum amount of different products. */
  maxItems?: Maybe<Scalars['Int']>;
  /** Minimum amount of different products. */
  minItems?: Maybe<Scalars['Int']>;
  /** Field mapped to products. */
  products?: Maybe<Array<Maybe<WixFormsV4PaymentTypeProduct>>>;
};

export type WixFormsV4PaymentTypeInput = {
  /** Maximum amount of different products. */
  maxItems?: InputMaybe<Scalars['Int']>;
  /** Minimum amount of different products. */
  minItems?: InputMaybe<Scalars['Int']>;
  /** Field mapped to products. */
  products?: InputMaybe<Array<InputMaybe<WixFormsV4PaymentTypeProductInput>>>;
};

export type WixFormsV4PaymentTypeProduct = {
  __typename?: 'WixFormsV4PaymentTypeProduct';
  /** Dynamic price options. */
  dynamicPriceOptions?: Maybe<WixFormsV4PaymentTypeProductDynamicPriceOptions>;
  /** Fixed price options. */
  fixedPriceOptions?: Maybe<WixFormsV4PaymentTypeProductFixedPriceOptions>;
  /** Product ID. */
  id?: Maybe<Scalars['String']>;
  /** Price type. */
  priceType?: Maybe<WixFormsV4PaymentTypeProductPriceTypeEnumPriceType>;
  /** Product type. */
  productType?: Maybe<WixFormsV4PaymentTypeProductProductTypeEnumProductType>;
  /** Quantity limit. */
  quantityLimit?: Maybe<WixFormsV4PaymentTypeProductQuantityLimit>;
};

export type WixFormsV4PaymentTypeProductDynamicPriceOptions = {
  __typename?: 'WixFormsV4PaymentTypeProductDynamicPriceOptions';
  /** Maximal price monetary amount. */
  maxPrice?: Maybe<Scalars['String']>;
  /** Minimal price monetary amount. */
  minPrice?: Maybe<Scalars['String']>;
};

export type WixFormsV4PaymentTypeProductDynamicPriceOptionsInput = {
  /** Maximal price monetary amount. */
  maxPrice?: InputMaybe<Scalars['String']>;
  /** Minimal price monetary amount. */
  minPrice?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4PaymentTypeProductFixedPriceOptions = {
  __typename?: 'WixFormsV4PaymentTypeProductFixedPriceOptions';
  /** Fixed price monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  price?: Maybe<Scalars['String']>;
};

export type WixFormsV4PaymentTypeProductFixedPriceOptionsInput = {
  /** Fixed price monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  price?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4PaymentTypeProductInput = {
  /** Dynamic price options. */
  dynamicPriceOptions?: InputMaybe<WixFormsV4PaymentTypeProductDynamicPriceOptionsInput>;
  /** Fixed price options. */
  fixedPriceOptions?: InputMaybe<WixFormsV4PaymentTypeProductFixedPriceOptionsInput>;
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Price type. */
  priceType?: InputMaybe<WixFormsV4PaymentTypeProductPriceTypeEnumPriceType>;
  /** Product type. */
  productType?: InputMaybe<WixFormsV4PaymentTypeProductProductTypeEnumProductType>;
  /** Quantity limit. */
  quantityLimit?: InputMaybe<WixFormsV4PaymentTypeProductQuantityLimitInput>;
};

export enum WixFormsV4PaymentTypeProductPriceTypeEnumPriceType {
  /** Dynamic price from price range. */
  DynamicPrice = 'DYNAMIC_PRICE',
  /** Fixed price. */
  FixedPrice = 'FIXED_PRICE',
  Unknown = 'UNKNOWN'
}

export enum WixFormsV4PaymentTypeProductProductTypeEnumProductType {
  /** Digital. */
  Digital = 'DIGITAL',
  /** Shippable (physical). */
  Shippable = 'SHIPPABLE',
  Unknown = 'UNKNOWN'
}

export type WixFormsV4PaymentTypeProductQuantityLimit = {
  __typename?: 'WixFormsV4PaymentTypeProductQuantityLimit';
  /** Maximum quantity. */
  maximum?: Maybe<Scalars['Int']>;
  /** Minimum quantity. */
  minimum?: Maybe<Scalars['Int']>;
};

export type WixFormsV4PaymentTypeProductQuantityLimitInput = {
  /** Maximum quantity. */
  maximum?: InputMaybe<Scalars['Int']>;
  /** Minimum quantity. */
  minimum?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4PostSubmissionTriggers = {
  __typename?: 'WixFormsV4PostSubmissionTriggers';
  /** Upserts a contact from the submission data. */
  upsertContact?: Maybe<WixFormsV4UpsertContact>;
};

export type WixFormsV4PostSubmissionTriggersInput = {
  /** Upserts a contact from the submission data. */
  upsertContact?: InputMaybe<WixFormsV4UpsertContactInput>;
};

export type WixFormsV4QueryDeletedFormsRequestInput = {
  /** WQL expression, namespace equality filter is required. */
  query?: InputMaybe<ComWixFormsUpstreamWixCommonCursorQueryInput>;
};

export type WixFormsV4QueryDeletedFormsResponse = {
  __typename?: 'WixFormsV4QueryDeletedFormsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixFormsV4Form>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixFormsV4QueryFormsRequestInput = {
  /**
   * List of additional form fields to include in the response. For example, use the `NESTED_FORMS` fieldset to retrieve the nested forms field in
   * the response in addition to the form’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the form’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldsetFieldset>>>;
  /** Kind of queried forms. */
  kind?: InputMaybe<WixFormsV4FormKindKind>;
  /** WQL expression, namespace equality filter is required. */
  query?: InputMaybe<ComWixFormsUpstreamWixCommonCursorQueryInput>;
};

export type WixFormsV4QueryFormsResponse = {
  __typename?: 'WixFormsV4QueryFormsResponse';
  /** The retrieved forms */
  forms?: Maybe<Array<Maybe<WixFormsV4Form>>>;
  /** Details on the paged set of results returned. */
  metadata?: Maybe<ComWixFormsUpstreamWixCommonCursorPagingMetadata>;
};

export type WixFormsV4RestoreFromTrashBinRequestInput = {
  /** Id of the form to restore. */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4RestoreFromTrashBinResponse = {
  __typename?: 'WixFormsV4RestoreFromTrashBinResponse';
  /** The restored form. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4Step = {
  __typename?: 'WixFormsV4Step';
  /** Is step hidden */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Step ID. */
  id?: Maybe<Scalars['String']>;
  /** Form step properties */
  layout?: Maybe<WixFormsV4FormLayout>;
  /** Name of the step. */
  name?: Maybe<Scalars['String']>;
};

export type WixFormsV4StepInput = {
  /** Is step hidden */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Step ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Form step properties */
  layout?: InputMaybe<WixFormsV4FormLayoutInput>;
  /** Name of the step. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4UpdateExtendedFieldsResponse = {
  __typename?: 'WixFormsV4UpdateExtendedFieldsResponse';
  /** namespace that was updated */
  namespace?: Maybe<Scalars['String']>;
  /** only data from UpdateExtendedFieldsRequest namespace_data */
  namespaceData?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4UpdateFormRequestInput = {
  /** Form to be updated, may be partial. */
  form?: InputMaybe<WixFormsV4FormInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixFormsV4UpdateFormResponse = {
  __typename?: 'WixFormsV4UpdateFormResponse';
  /** The updated form. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4UpsertContact = {
  __typename?: 'WixFormsV4UpsertContact';
  /** Fields mapping (target field mapped to corresponding contact field). */
  fieldsMapping?: Maybe<WixFormsV4FormFieldContactInfo>;
  /**
   * List of contact label keys.
   * [Contact labels](https://support.wix.com/en/article/adding-labels-to-contacts-in-your-contact-list)
   * help categorize contacts.
   */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixFormsV4UpsertContactInput = {
  /** Fields mapping (target field mapped to corresponding contact field). */
  fieldsMapping?: InputMaybe<WixFormsV4FormFieldContactInfoInput>;
  /**
   * List of contact label keys.
   * [Contact labels](https://support.wix.com/en/article/adding-labels-to-contacts-in-your-contact-list)
   * help categorize contacts.
   */
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixGiftCardsGiftCardV1Amount = {
  __typename?: 'WixGiftCardsGiftCardV1Amount';
  /**
   * Monetary amount as a decimal string.
   * For example, `"10.50"` for $10.50 or `"100"` for $100.00.
   */
  amount?: Maybe<Scalars['String']>;
  /**
   * Amount formatted with currency symbol for display purposes.
   * For example, `"$10.50"` or `"€25.00"`.
   */
  formattedAmount?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1AmountInput = {
  /**
   * Monetary amount as a decimal string.
   * For example, `"10.50"` for $10.50 or `"100"` for $100.00.
   */
  amount?: InputMaybe<Scalars['String']>;
  /**
   * Amount formatted with currency symbol for display purposes.
   * For example, `"$10.50"` or `"€25.00"`.
   */
  formattedAmount?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1CountGiftCardsRequestInput = {
  /**
   * Filter criteria to count specific gift cards.
   * Use the same filter format as Query Gift Cards.
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixGiftCardsGiftCardV1CountGiftCardsResponse = {
  __typename?: 'WixGiftCardsGiftCardV1CountGiftCardsResponse';
  /** Total number of gift cards matching the filter criteria. */
  count?: Maybe<Scalars['Int']>;
};

export type WixGiftCardsGiftCardV1CreateGiftCardRequestInput = {
  /** Gift card information to create. Must include `initialValue`, `currency`, and `source`. */
  giftCard?: InputMaybe<WixGiftCardsGiftCardV1GiftCardInput>;
  /**
   * Unique identifier to prevent duplicate gift card creation.
   * Use this to safely retry gift card creation requests.
   */
  idempotencyKey?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1CreateGiftCardResponse = {
  __typename?: 'WixGiftCardsGiftCardV1CreateGiftCardResponse';
  /** The newly created gift card with full code visible (not obfuscated). */
  giftCard?: Maybe<WixGiftCardsGiftCardV1GiftCard>;
};

export type WixGiftCardsGiftCardV1DisableGiftCardRequestInput = {
  /** Gift card ID. */
  giftCardId?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1DisableGiftCardResponse = {
  __typename?: 'WixGiftCardsGiftCardV1DisableGiftCardResponse';
  /** The disabled gift card with updated status and disable date. */
  giftCard?: Maybe<WixGiftCardsGiftCardV1GiftCard>;
};

export type WixGiftCardsGiftCardV1FulfillGiftCardOrderRequestInput = {
  /** eCommerce order ID containing gift cards to fulfill. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1GetGiftCardRequestInput = {
  id: Scalars['ID'];
};

export type WixGiftCardsGiftCardV1GetTransactionRequestInput = {
  id: Scalars['ID'];
};

export type WixGiftCardsGiftCardV1GiftCard = {
  __typename?: 'WixGiftCardsGiftCardV1GiftCard';
  /**
   * Current available balance that can be spent.
   * Decreases when the gift card is used for purchases and increases with refunds.
   */
  balance?: Maybe<WixGiftCardsGiftCardV1Amount>;
  /**
   * Gift card code used for redemption.
   *
   * >**Notes:**
   * + The gift card code can be customized on creation, or it can be auto-generated by the system.
   * + The `code` field contains the **full** gift card code, for example, `1111-2222-3333-4444`.
   * + In any other API response, as well as in the Gift Card Created domain event, the `code` field contains the **obfuscated** gift card code, for example, `****-****-****-4444`.
   */
  code?: Maybe<Scalars['String']>;
  /** Last 4 characters of the gift card code for search and identification purposes. */
  codeSuffix?: Maybe<Scalars['String']>;
  /** Date and time the gift card was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Three-letter currency code in ISO-4217 alphabetic format. */
  currency?: Maybe<Scalars['String']>;
  /** Date and time the gift card was disabled, if applicable. */
  disabledDate?: Maybe<Scalars['String']>;
  /** Date and time when the gift card expires and becomes unusable. */
  expirationDate?: Maybe<Scalars['String']>;
  /** Gift card ID. */
  id?: Maybe<Scalars['String']>;
  /** Initial monetary value assigned to the gift card when created. */
  initialValue?: Maybe<WixGiftCardsGiftCardV1Amount>;
  /**
   * Email notification settings including recipient, sender, and delivery options.
   * Required only when the gift card should be sent via email.
   */
  notificationInfo?: Maybe<WixGiftCardsGiftCardV1NotificationInfo>;
  /** Order details when the gift card was purchased through an eCommerce order. */
  orderInfo?: Maybe<WixGiftCardsGiftCardV1OrderInfo>;
  /** How the gift card was created. */
  source?: Maybe<WixGiftCardsGiftCardV1Source>;
  /** Date and time the gift card was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1GiftCardInput = {
  /**
   * Current available balance that can be spent.
   * Decreases when the gift card is used for purchases and increases with refunds.
   */
  balance?: InputMaybe<WixGiftCardsGiftCardV1AmountInput>;
  /**
   * Gift card code used for redemption.
   *
   * >**Notes:**
   * + The gift card code can be customized on creation, or it can be auto-generated by the system.
   * + The `code` field contains the **full** gift card code, for example, `1111-2222-3333-4444`.
   * + In any other API response, as well as in the Gift Card Created domain event, the `code` field contains the **obfuscated** gift card code, for example, `****-****-****-4444`.
   */
  code?: InputMaybe<Scalars['String']>;
  /** Last 4 characters of the gift card code for search and identification purposes. */
  codeSuffix?: InputMaybe<Scalars['String']>;
  /** Date and time the gift card was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Three-letter currency code in ISO-4217 alphabetic format. */
  currency?: InputMaybe<Scalars['String']>;
  /** Date and time the gift card was disabled, if applicable. */
  disabledDate?: InputMaybe<Scalars['String']>;
  /** Date and time when the gift card expires and becomes unusable. */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** Gift card ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Initial monetary value assigned to the gift card when created. */
  initialValue?: InputMaybe<WixGiftCardsGiftCardV1AmountInput>;
  /**
   * Email notification settings including recipient, sender, and delivery options.
   * Required only when the gift card should be sent via email.
   */
  notificationInfo?: InputMaybe<WixGiftCardsGiftCardV1NotificationInfoInput>;
  /** Order details when the gift card was purchased through an eCommerce order. */
  orderInfo?: InputMaybe<WixGiftCardsGiftCardV1OrderInfoInput>;
  /** How the gift card was created. */
  source?: InputMaybe<WixGiftCardsGiftCardV1Source>;
  /** Date and time the gift card was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1ListGiftCardsByEmailRequestInput = {
  /** Email address to search for in sender or recipient information. */
  email?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1ListGiftCardsByEmailResponse = {
  __typename?: 'WixGiftCardsGiftCardV1ListGiftCardsByEmailResponse';
  /**
   * Gift cards associated with the specified email address.
   *
   * Returns up to 50 gift cards sorted by creation date in descending order.
   */
  giftCards?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1GiftCard>>>;
};

export type WixGiftCardsGiftCardV1NotificationInfo = {
  __typename?: 'WixGiftCardsGiftCardV1NotificationInfo';
  /**
   * URL of the image to display in the gift card email.
   * Use this to customize the visual appearance of the gift card.
   */
  imageUrl?: Maybe<Scalars['String']>;
  /**
   * Scheduled date and time to send the gift card email notification.
   * Leave empty to send the email immediately.
   */
  notificationDate?: Maybe<Scalars['String']>;
  /**
   * Custom message to include in the gift card email.
   * This personalizes the gift card for the recipient.
   */
  personalizedMessage?: Maybe<Scalars['String']>;
  /** Gift card recipient information for email delivery. */
  recipient?: Maybe<WixGiftCardsGiftCardV1Recipient>;
  /** Gift card sender information for email display. */
  sender?: Maybe<WixGiftCardsGiftCardV1Sender>;
};

export type WixGiftCardsGiftCardV1NotificationInfoInput = {
  /**
   * URL of the image to display in the gift card email.
   * Use this to customize the visual appearance of the gift card.
   */
  imageUrl?: InputMaybe<Scalars['String']>;
  /**
   * Scheduled date and time to send the gift card email notification.
   * Leave empty to send the email immediately.
   */
  notificationDate?: InputMaybe<Scalars['String']>;
  /**
   * Custom message to include in the gift card email.
   * This personalizes the gift card for the recipient.
   */
  personalizedMessage?: InputMaybe<Scalars['String']>;
  /** Gift card recipient information for email delivery. */
  recipient?: InputMaybe<WixGiftCardsGiftCardV1RecipientInput>;
  /** Gift card sender information for email display. */
  sender?: InputMaybe<WixGiftCardsGiftCardV1SenderInput>;
};

export type WixGiftCardsGiftCardV1OrderInfo = {
  __typename?: 'WixGiftCardsGiftCardV1OrderInfo';
  /** eCommerce order ID associated with the gift card purchase. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
  /** eCommerce order ID associated with the gift card purchase. */
  orderId?: Maybe<Scalars['String']>;
  /**
   * Human-readable order number displayed to customers.
   * For example, `"1001"`.
   */
  orderNumber?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1OrderInfoInput = {
  /** eCommerce order ID associated with the gift card purchase. */
  orderId?: InputMaybe<Scalars['String']>;
  /**
   * Human-readable order number displayed to customers.
   * For example, `"1001"`.
   */
  orderNumber?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1QueryGiftCardTransactionsRequestInput = {
  /** Gift card ID to retrieve transactions for. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /**
   * Query expression to filter, sort, and page through transactions.
   * Use to search by transaction type, creation date, or operation type.
   */
  query?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput>;
};

export type WixGiftCardsGiftCardV1QueryGiftCardTransactionsResponse = {
  __typename?: 'WixGiftCardsGiftCardV1QueryGiftCardTransactionsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1Transaction>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixGiftCardsGiftCardV1QueryGiftCardsRequestInput = {
  /**
   * Query expression to filter, sort, and page through gift cards.
   * Use to search by creation date, balance, expiration date, code, or code suffix.
   */
  query?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput>;
};

export type WixGiftCardsGiftCardV1QueryGiftCardsResponse = {
  __typename?: 'WixGiftCardsGiftCardV1QueryGiftCardsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1GiftCard>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixGiftCardsGiftCardV1Recipient = {
  __typename?: 'WixGiftCardsGiftCardV1Recipient';
  /** Recipient's email address where the gift card will be sent. */
  email?: Maybe<Scalars['String']>;
  /** Recipient's display name shown in the gift card email. */
  name?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1RecipientInput = {
  /** Recipient's email address where the gift card will be sent. */
  email?: InputMaybe<Scalars['String']>;
  /** Recipient's display name shown in the gift card email. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1SearchGiftCardsRequestInput = {
  /**
   * Search expression with text matching, filtering, and aggregation options.
   * Supports searching by gift card code and code suffix.
   */
  search?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorSearchInput>;
};

export type WixGiftCardsGiftCardV1SearchGiftCardsResponse = {
  __typename?: 'WixGiftCardsGiftCardV1SearchGiftCardsResponse';
  /** Aggregation data providing insights about the search results. */
  aggregationData?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationData>;
  /** The retrieved gift cards matching the search criteria. */
  giftCards?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1GiftCard>>>;
  /** Paging information for navigating through large result sets. */
  pagingMetadata?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingMetadata>;
};

export type WixGiftCardsGiftCardV1SendGiftCardEmailRequestInput = {
  /** Gift card ID. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /**
   * Recipient email address to send the gift card notification.
   * If not provided, uses the recipient email stored in the gift card's notification info.
   */
  recipientEmail?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1Sender = {
  __typename?: 'WixGiftCardsGiftCardV1Sender';
  /** Sender's email address displayed in the gift card notification. */
  email?: Maybe<Scalars['String']>;
  /** Sender's display name shown in the gift card email. */
  name?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1SenderInput = {
  /** Sender's email address displayed in the gift card notification. */
  email?: InputMaybe<Scalars['String']>;
  /** Sender's display name shown in the gift card email. */
  name?: InputMaybe<Scalars['String']>;
};

export enum WixGiftCardsGiftCardV1Source {
  /** Gift card was created manually via API. */
  Manual = 'MANUAL',
  /** Gift card was purchased through an eCommerce order. */
  Order = 'ORDER',
  UnknownSource = 'UNKNOWN_SOURCE'
}

export type WixGiftCardsGiftCardV1Transaction = {
  __typename?: 'WixGiftCardsGiftCardV1Transaction';
  /**
   * Monetary amount of the transaction.
   * Positive values represent credits, negative values represent debits.
   */
  amount?: Maybe<WixGiftCardsGiftCardV1Amount>;
  /** Date and time the transaction was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Gift card ID associated with this transaction. */
  giftCardId?: Maybe<Scalars['String']>;
  /** Transaction ID. */
  id?: Maybe<Scalars['String']>;
  /** Whether the transaction adds to or subtracts from the gift card balance. */
  operationType?: Maybe<WixGiftCardsGiftCardV1TransactionOperationType>;
  /** Order details when the transaction is related to an eCommerce purchase or refund. */
  orderInfo?: Maybe<WixGiftCardsGiftCardV1OrderInfo>;
  /** Type of transaction indicating the reason for the balance change. */
  type?: Maybe<WixGiftCardsGiftCardV1TransactionTransactionType>;
  /** Gift card balance after this transaction was applied. */
  updatedBalance?: Maybe<WixGiftCardsGiftCardV1Amount>;
};

export enum WixGiftCardsGiftCardV1TransactionOperationType {
  /** Transaction adds value to the gift card balance. */
  Add = 'ADD',
  /** Transaction subtracts value from the gift card balance. */
  Subtract = 'SUBTRACT'
}

export enum WixGiftCardsGiftCardV1TransactionTransactionType {
  /** Initial value was assigned when the gift card was created. */
  Initial = 'INITIAL',
  /** Manual adjustment made via admin interface or API. */
  Manual = 'MANUAL',
  /** Refund was processed, adding value back to the gift card. */
  PaymentMethodRefund = 'PAYMENT_METHOD_REFUND',
  /** Gift card was used to pay for a purchase. */
  Redeem = 'REDEEM',
  UnknownTransactionType = 'UNKNOWN_TRANSACTION_TYPE',
  /** Previous redemption was cancelled, restoring the gift card balance. */
  Void = 'VOID'
}

export type WixGiftCardsGiftCardV1TriggerGiftCardsAppInstallationFlowEventInput = {
  /** The meta site ID to trigger installation flow for. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationData = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationData';
  /** key = aggregation name (as derived from search request) */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResults>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResults = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResults';
  /** Date histogram aggregation results */
  dateHistogram?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults>;
  /** Field to aggregate by as derived from search request */
  fieldPath?: Maybe<Scalars['String']>;
  /** Group by value aggregation results */
  groupedByValue?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults>;
  /** User-defined name of aggregation as derived from search request */
  name?: Maybe<Scalars['String']>;
  /** Nested aggregation results */
  nested?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResults>;
  /** Range aggregation results */
  ranges?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results */
  scalar?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that must match provided kind as derived from search request */
  type?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationType>;
  /** Value aggregation results */
  values?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults';
  /** List of date histogram aggregations */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult';
  /** Count of documents in the bucket */
  count?: Maybe<Scalars['Int']>;
  /** Date in ISO 8601 format */
  value?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults';
  /** List of value aggregations */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult';
  /** Nested aggregations */
  nestedResults?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults>;
  /** Value of the field */
  value?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults';
  /** Field to aggregate by, matches the one provided in request */
  fieldPath?: Maybe<Scalars['String']>;
  /** User-defined name of aggregation, matches the one provided in request */
  name?: Maybe<Scalars['String']>;
  /** Range aggregation results */
  ranges?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results */
  scalar?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that matches result */
  type?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationType>;
  /** Value aggregation results */
  values?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResults = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResults';
  /** List of nested aggregations */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue';
  /** Date histogram aggregation result */
  dateHistogram?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
  /** Range aggregation result */
  range?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult>;
  /** Scalar aggregation result */
  scalar?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult>;
  /** Value aggregation result */
  value?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult';
  /** Count of entities in this range */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range */
  to?: Maybe<Scalars['Float']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults';
  /** List of nested aggregations */
  results?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult';
  /** Value of the scalar aggregation */
  value?: Maybe<Scalars['Float']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult';
  /** Count of entities with this value */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field */
  value?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults';
  /** List of ranges returned in same order as requested */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult';
  /** Count of entities in this range */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range */
  to?: Maybe<Scalars['Float']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult';
  /** Type of scalar aggregation */
  type?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonScalarType>;
  /** Value of the scalar aggregation */
  value?: Maybe<Scalars['Float']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults';
  /** List of value aggregations */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult';
  /** Count of entities with this value */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field */
  value?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput = {
  /** Interval for date histogram aggregation */
  interval?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInterval>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInterval {
  /** Daily interval */
  Day = 'DAY',
  /** Hourly interval */
  Hour = 'HOUR',
  /** Minute interval */
  Minute = 'MINUTE',
  /** Monthly interval */
  Month = 'MONTH',
  /** Second interval */
  Second = 'SECOND',
  UnknownInterval = 'UNKNOWN_INTERVAL',
  /** Weekly interval */
  Week = 'WEEK',
  /** Yearly interval */
  Year = 'YEAR'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationInput = {
  /** Date histogram aggregation */
  dateHistogram?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by, use dot notation to specify json path */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results */
  name?: InputMaybe<Scalars['String']>;
  /** Nested aggregation */
  nested?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationInput>;
  /** Range aggregation */
  range?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation */
  scalar?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation, client must provide matching aggregation field below */
  type?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationType>;
  /** Value aggregation */
  value?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationInput = {
  /** Flattened list of aggregations, where each next aggregation is nested within previous one */
  nestedAggregations?: InputMaybe<Array<InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput = {
  /** Date histogram aggregation */
  dateHistogram?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by, use dont notation to specify json path */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results */
  name?: InputMaybe<Scalars['String']>;
  /** Range aggregation */
  range?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation */
  scalar?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation, client must provide matching aggregation field below */
  type?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationType>;
  /** Value aggregation */
  value?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationType {
  /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
  DateHistogram = 'DATE_HISTOGRAM',
  /** An aggregation, where user can define set of ranges - each representing a bucket */
  Range = 'RANGE',
  /** A single-value metric aggregation - e.g. min, max, sum, avg */
  Scalar = 'SCALAR',
  UnknownAggregationType = 'UNKNOWN_AGGREGATION_TYPE',
  /** An aggregation where result buckets are dynamically built - one per unique value */
  Value = 'VALUE'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput = {
  /** List of range buckets, where during aggregation each entity will be placed in the first bucket where its value falls into based on provided range bounds */
  buckets?: InputMaybe<Array<InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = {
  /** Inclusive lower bound of the range. Required if to is not given */
  from?: InputMaybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. Required if from is not given */
  to?: InputMaybe<Scalars['Float']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput = {
  /** Define the operator for the scalar aggregation */
  type?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonScalarType>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationType {
  /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
  DateHistogram = 'DATE_HISTOGRAM',
  /** Multi-level aggregation, where each next aggregation is nested within previous one */
  Nested = 'NESTED',
  /** An aggregation, where user can define set of ranges - each representing a bucket */
  Range = 'RANGE',
  /** A single-value metric aggregation - e.g. min, max, sum, avg */
  Scalar = 'SCALAR',
  UnknownAggregationType = 'UNKNOWN_AGGREGATION_TYPE',
  /** An aggregation where result buckets are dynamically built - one per unique value */
  Value = 'VALUE'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = {
  /** Can specify custom bucket name. Defaults are [string -> "N/A"], [int -> "0"], [bool -> "false"] ... */
  addToBucket?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput = {
  /** Options for including missing values */
  includeOptions?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>;
  /** How many aggregations would you like to return? Can be between 1 and 250. 10 is the default. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Should missing values be included or excluded from the aggregation results. Default is EXCLUDE */
  missingValues?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationMissingValues>;
  /** Should sort in ascending or descending order */
  sortDirection?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationSortDirection>;
  /** Should sort by number of matches or value of the field */
  sortType?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationSortType>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationMissingValues {
  /** Should missing values be excluded from the aggregation results */
  Exclude = 'EXCLUDE',
  /** Should missing values be included in the aggregation results */
  Include = 'INCLUDE'
}

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationSortDirection {
  /** Should sort in ascending order */
  Asc = 'ASC',
  /** Should sort in descending order */
  Desc = 'DESC'
}

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationSortType {
  /** Should sort by number of matches */
  Count = 'COUNT',
  /** Should sort by value of the field alphabetically */
  Value = 'VALUE'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput = {
  /**
   * Cursor paging options.
   *
   * Learn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).
   */
  cursorPaging?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object.
   *
   * Learn more about the [sort section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-sort-section).
   */
  sort?: InputMaybe<Array<InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonSortingInput>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonCursorSearchInput = {
  /** Aggregations | Faceted search: refers to a way to explore large amounts of data by displaying summaries about various partitions of the data and later allowing to narrow the navigation to a specific partition. */
  aggregations?: InputMaybe<Array<InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationInput>>>;
  /**
   * Cursor paging options.
   *
   * Learn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).
   */
  cursorPaging?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Free text to match in searchable fields. */
  search?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsInput>;
  /**
   * List of sort objects.
   *
   * Learn more about the [sort section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-sort-section).
   */
  sort?: InputMaybe<Array<InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonSortingInput>>>;
  /**
   * UTC offset or IANA time zone. Valid values are
   * ISO 8601 UTC offsets, such as +02:00 or -06:00,
   * and IANA time zone IDs, such as Europe/Rome
   *
   * Affects all filters and aggregations returned values.
   * You may override this behavior in a specific filter by providing
   * timestamps including time zone. e.g. `"2023-12-20T10:52:34.795Z"`
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonCursors = {
  __typename?: 'WixGiftCardsGiftCardV1UpstreamWixCommonCursors';
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonScalarType {
  /** Average of values */
  Avg = 'AVG',
  /** Count of distinct values */
  CountDistinct = 'COUNT_DISTINCT',
  /** Maximum value */
  Max = 'MAX',
  /** Minimum value */
  Min = 'MIN',
  /** Sum of values */
  Sum = 'SUM',
  UnknownScalarType = 'UNKNOWN_SCALAR_TYPE'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsInput = {
  /** Search term or expression */
  expression?: InputMaybe<Scalars['String']>;
  /** Fields to search in. If empty - will search in all searchable fields. Use dot notation to specify json path */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Flag if should use auto fuzzy search (allowing typos by a managed proximity algorithm) */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Defines how separate search terms in `expression` are combined */
  mode?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsMode>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsMode {
  /** All search terms must be present */
  And = 'AND',
  /** Any of the search terms must be present */
  Or = 'OR'
}

export enum WixGiftCardsGiftCardV1UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type WixHeadlessV1CreateOAuthAppRequestInput = {
  /** OAuth app to create. */
  oAuthApp?: InputMaybe<WixHeadlessV1OAuthAppInput>;
};

export type WixHeadlessV1CreateOAuthAppResponse = {
  __typename?: 'WixHeadlessV1CreateOAuthAppResponse';
  /** Created OAuth app info. */
  oAuthApp?: Maybe<WixHeadlessV1OAuthApp>;
};

export type WixHeadlessV1DeleteOAuthAppRequestInput = {
  /** ID of the OAuth app to delete. */
  oAuthAppId?: InputMaybe<Scalars['String']>;
};

export type WixHeadlessV1GenerateOAuthAppSecretRequestInput = {
  /** ID of the OAuth app to generate a secret for. */
  oAuthAppId?: InputMaybe<Scalars['String']>;
};

export type WixHeadlessV1GenerateOAuthAppSecretResponse = {
  __typename?: 'WixHeadlessV1GenerateOAuthAppSecretResponse';
  /** Secret generated. */
  oAuthAppSecret?: Maybe<Scalars['String']>;
};

export type WixHeadlessV1GetOAuthAppRequestInput = {
  id: Scalars['ID'];
};

export type WixHeadlessV1OAuthApp = {
  __typename?: 'WixHeadlessV1OAuthApp';
  /** For internal use only. */
  allowSecretGeneration?: Maybe<Scalars['Boolean']>;
  /**
   * List of domains to which redirection from Wix is allowed after processes other than authentication.
   *
   * When a client redirects a user to a Wix page (for example, for checkout), the client provides a URL to redirect the user back to.
   * Wix only redirects the user if the URL is in one of the specified domains.
   * @deprecated List of domains to which redirection from Wix is allowed after processes other than authentication.
   *
   * When a client redirects a user to a Wix page (for example, for checkout), the client provides a URL to redirect the user back to.
   * Wix only redirects the user if the URL is in one of the specified domains. Replaced by: allowed_redirect_domains. Removal date: 2023-05-01.
   */
  allowedDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * List of domains to which redirection from Wix is allowed after processes other than authentication.
   *
   * When a client redirects a user to a Wix page (for example, for checkout), the client provides a URL to redirect the user back to.
   * Wix only redirects the user if the URL is in one of the specified domains.
   */
  allowedRedirectDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * List of URIs to which redirection from Wix is allowed after authentication.
   *
   * When a client redirects a user to Wix for authentication, the client provides a URI to redirect the user back to after the user has been authenticated.
   * Wix only redirects the user if the exact URI is contained in this array.
   */
  allowedRedirectUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** OAuth application type. */
  applicationType?: Maybe<WixHeadlessV1OAuthAppType>;
  /** Date and time the OAuth app was created, in ISO 8601 format. */
  createdDate?: Maybe<Scalars['String']>;
  /** Description of the OAuth app, as it appears in the dashboard. */
  description?: Maybe<Scalars['String']>;
  /** ID of the OAuth app. */
  id?: Maybe<Scalars['String']>;
  /** External login URL to which users are redirected automatically to authenticate. If no login URL is specified, the user is redirected to Wix to authenticate. */
  loginUrl?: Maybe<Scalars['String']>;
  /** External logout URL to which we invoke when user logout at wix. If no logout URL is specified, the user is logged out only at Wix. */
  logoutUrl?: Maybe<Scalars['String']>;
  /** Display name of the OAuth app, as it appears in the dashboard. */
  name?: Maybe<Scalars['String']>;
  /** Redirect url for Wix-hosted pages. */
  redirectUrlWixPages?: Maybe<Scalars['String']>;
  /** For internal use only. */
  secret?: Maybe<Scalars['String']>;
  /** OAuth technology used by the oauth application. */
  technology?: Maybe<WixHeadlessV1OAuthTechnologies>;
  /**
   * List of domain mappings from external domains to Wix domains.
   * When a user accesses a non-Wix domain, they can be automatically forwarded to the corresponding
   * Wix domain based on these mappings. This enables domain-level redirection from
   * external domains to Wix-hosted pages.
   */
  wixPagesDomainsMappings?: Maybe<Array<Maybe<WixHeadlessV1WixPagesDomainMapping>>>;
};

export type WixHeadlessV1OAuthAppInput = {
  /** For internal use only. */
  allowSecretGeneration?: InputMaybe<Scalars['Boolean']>;
  /**
   * List of domains to which redirection from Wix is allowed after processes other than authentication.
   *
   * When a client redirects a user to a Wix page (for example, for checkout), the client provides a URL to redirect the user back to.
   * Wix only redirects the user if the URL is in one of the specified domains.
   */
  allowedRedirectDomains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * List of URIs to which redirection from Wix is allowed after authentication.
   *
   * When a client redirects a user to Wix for authentication, the client provides a URI to redirect the user back to after the user has been authenticated.
   * Wix only redirects the user if the exact URI is contained in this array.
   */
  allowedRedirectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** OAuth application type. */
  applicationType?: InputMaybe<WixHeadlessV1OAuthAppType>;
  /** Date and time the OAuth app was created, in ISO 8601 format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Description of the OAuth app, as it appears in the dashboard. */
  description?: InputMaybe<Scalars['String']>;
  /** ID of the OAuth app. */
  id?: InputMaybe<Scalars['String']>;
  /** External login URL to which users are redirected automatically to authenticate. If no login URL is specified, the user is redirected to Wix to authenticate. */
  loginUrl?: InputMaybe<Scalars['String']>;
  /** External logout URL to which we invoke when user logout at wix. If no logout URL is specified, the user is logged out only at Wix. */
  logoutUrl?: InputMaybe<Scalars['String']>;
  /** Display name of the OAuth app, as it appears in the dashboard. */
  name?: InputMaybe<Scalars['String']>;
  /** Redirect url for Wix-hosted pages. */
  redirectUrlWixPages?: InputMaybe<Scalars['String']>;
  /** For internal use only. */
  secret?: InputMaybe<Scalars['String']>;
  /** OAuth technology used by the oauth application. */
  technology?: InputMaybe<WixHeadlessV1OAuthTechnologies>;
  /**
   * List of domain mappings from external domains to Wix domains.
   * When a user accesses a non-Wix domain, they can be automatically forwarded to the corresponding
   * Wix domain based on these mappings. This enables domain-level redirection from
   * external domains to Wix-hosted pages.
   */
  wixPagesDomainsMappings?: InputMaybe<Array<InputMaybe<WixHeadlessV1WixPagesDomainMappingInput>>>;
};

export enum WixHeadlessV1OAuthAppType {
  /** OAuth app type is a mobile application. */
  Mobile = 'MOBILE',
  /** OAuth app type is not specified. */
  OauthAppTypeUnspecified = 'OAUTH_APP_TYPE_UNSPECIFIED',
  /** OAuth app type is some other type of application. */
  Other = 'OTHER',
  /** OAuth app type is a web application. */
  WebApp = 'WEB_APP'
}

export enum WixHeadlessV1OAuthTechnologies {
  /** OAuth technology using Android. */
  Android = 'ANDROID',
  /** OAuth technology using Angular. */
  Angular = 'ANGULAR',
  /** OAuth technology using iOS. */
  Ios = 'IOS',
  /** OAuth technology using JavaScript. */
  Javascript = 'JAVASCRIPT',
  /** The OAuth technology is not specified. */
  OauthTechnologyUnspecified = 'OAUTH_TECHNOLOGY_UNSPECIFIED',
  /** OAuth technology using some other kind of technology. */
  OtherTechnology = 'OTHER_TECHNOLOGY',
  /** OAuth technology using React. */
  React = 'REACT',
  /** OAuth technology using React Native. */
  ReactNative = 'REACT_NATIVE',
  /** OAuth technology using Vue.js. */
  Vue = 'VUE'
}

export type WixHeadlessV1PlatformQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"name","order":"ASC"},{"fieldName":"created_date","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type WixHeadlessV1QueryOAuthAppsRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixHeadlessV1PlatformQueryInput>;
};

export type WixHeadlessV1QueryOAuthAppsResponse = {
  __typename?: 'WixHeadlessV1QueryOAuthAppsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixHeadlessV1OAuthApp>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixHeadlessV1UpdateOAuthAppRequestInput = {
  /** Explicit list of fields to update. Only fields listed are updated. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Updated OAuth app details. May include some or all fields. */
  oAuthApp?: InputMaybe<WixHeadlessV1OAuthAppInput>;
};

export type WixHeadlessV1UpdateOAuthAppResponse = {
  __typename?: 'WixHeadlessV1UpdateOAuthAppResponse';
  /** Updated OAuth app info. */
  oAuthApp?: Maybe<WixHeadlessV1OAuthApp>;
};

export type WixHeadlessV1WixPagesDomainMapping = {
  __typename?: 'WixHeadlessV1WixPagesDomainMapping';
  destination?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
};

export type WixHeadlessV1WixPagesDomainMappingInput = {
  destination?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
};

export type WixInfraTimecapsuleV2CronTzInput = {
  /**
   * Cron expression is a string of five space-separated sub-expressions.
   *
   * * * * * *
   * | | | | |
   * minute of hour | | | day of week
   * hour of day | month of year
   * day of month
   *
   * Field            Accepted values
   * ---------------  -------------------------------------
   * minute of hour   `0..59` `/` `*` `,`
   * hour of day      `0..23` `/` `*` `,`
   * day of month     `1..31` `/` `*` `,` `L` `W`
   * month of year    `1..12` `/` `*` `,`
   * day of week      `0..7` `MON..SUN` `/` `*` `,` `#` `L`
   *
   * Coma separates multiple values:
   * 0,20,40 * * * * => on 0th, 20th and 40th minute
   * Slash selects every Nth value:
   * * /20 * * * * => equivalent to 0,20,40
   * 5/20 * * * * => on 5th, 25th and 45th minute
   * `L` selects the last day of ...
   * 0 0 L * *    => last day of each month
   * 0 0 * * FRIL => the last Friday of the month
   * `W` modifies day of month to be a working day
   * 0 0 15W * * => working day around 15th day of the month (14th if 15th is SAT, 16th if 15th is SUN)
   * 0 0 LW * * => last working day of each month
   * `#` selects Nth occurrence of the day of week in the month
   * 0 0 * * Mon#1 => the first Monday of the month
   *
   * Following aliases are supported: @hourly, @daily, @weekly, @monthly
   *
   * The first execution time will be evaluated based on the client invocation time (approximately the moment the
   * client call returns).
   * All executions will be evaluated in UTC.
   *
   * Example:
   * 00:19:59 - client schedules a task with cron = 0/20 * * * * (every 20-th minute of the hour)
   * 00:20:02 - task reaches Time Capsule database
   * 00:21:00 - task is executed by Time Capsule, the client is triggered with a ~1 minute delay
   * 00:40:00 - task is executed by Time Capsule according to the schedule with no delay
   */
  expression?: InputMaybe<Scalars['String']>;
  /**
   * IANA regional time zone ID.
   * For example "America/New_York", "Asia/Jerusalem", "Europe/Kyiv", "Europe/Vilnius", etc..
   * Equivalent to "UTC" if omitted.
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixInfraTimecapsuleV2TaskIdInput = {
  /**
   * A free-form string that together with `namespace` and `task_type` uniquely identifies a task.
   * When there is an entity involved, setting this to be equal to the ID of an entity related to the task is a good option.
   */
  key?: InputMaybe<Scalars['String']>;
  /**
   * A unique identifier of an application or a source that define the task. In most cases this would be the appDefId or
   * Artifact.fullId
   */
  namespace?: InputMaybe<Scalars['String']>;
  /**
   * A free-form string distinguishing different families of tasks within a namespace.
   * For example: "send-promo-email", "ClearTrashBin", "premium expiration reminder"
   */
  taskType?: InputMaybe<Scalars['String']>;
};

export type WixInfraTimecapsuleV2TaskInput = {
  /** A free-form string used to classify tasks. Each task is assigned a topic based on its classifier, and tasks with the same classifier will be routed to the same topic. */
  classifier?: InputMaybe<Scalars['String']>;
  /** Deprecated. Equivalent to cronTz(cron, "UTC") */
  cron?: InputMaybe<Scalars['String']>;
  /** A trigger defined by a cron expression and an optional time zone */
  cronTz?: InputMaybe<WixInfraTimecapsuleV2CronTzInput>;
  /** Task id */
  id?: InputMaybe<WixInfraTimecapsuleV2TaskIdInput>;
  /** A trigger which will fire once at a specified timestamp */
  oneTime?: InputMaybe<Scalars['String']>;
  /** Task payload */
  payload?: InputMaybe<Scalars['JSON']>;
  /** The time when this task is scheduled to trigger. For reoccurring tasks, this will be hold the next time this task will run and will be updated after every run */
  scheduledFor?: InputMaybe<Scalars['String']>;
  /** A Greyhound topic to which the task will be produced when triggered */
  topic?: InputMaybe<Scalars['String']>;
};

export type WixInventoryApiV1PreorderInfo = {
  __typename?: 'WixInventoryApiV1PreorderInfo';
  /** Whether the item is available for preorder. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Number of products that can be preordered after stock reaches zero. */
  limit?: Maybe<Scalars['Int']>;
  /** A message the buyer will see when the item is out of stock and preorder is enabled. */
  message?: Maybe<Scalars['String']>;
};

export enum WixOnlineprogramsCommonV3ProgramAccessType {
  /** send a join request to the owner and get an approval from him. */
  Private = 'PRIVATE',
  /** join without approvals */
  Public = 'PUBLIC',
  /** join possible only after owner invite. */
  Secret = 'SECRET'
}

export type WixOnlineprogramsCommonV3ProgramDescription = {
  __typename?: 'WixOnlineprogramsCommonV3ProgramDescription';
  /** step additional details */
  details?: Maybe<Scalars['String']>;
  /** WixMedia image */
  image?: Maybe<WixCommonImage>;
  /** step title */
  title?: Maybe<Scalars['String']>;
  /** WixMedia video */
  video?: Maybe<WixCommonVideoV2>;
};

export type WixOnlineprogramsCommonV3ProgramDescriptionInput = {
  /** step additional details */
  details?: InputMaybe<Scalars['String']>;
  /** WixMedia image */
  image?: InputMaybe<WixCommonImageInput>;
  /** step title */
  title?: InputMaybe<Scalars['String']>;
  /** WixMedia video */
  video?: InputMaybe<WixCommonVideoV2Input>;
};

export type WixOnlineprogramsCommonV3ProgramRestrictions = {
  __typename?: 'WixOnlineprogramsCommonV3ProgramRestrictions';
  /** hide steps in the Pending state. */
  hideFutureSteps?: Maybe<Scalars['Boolean']>;
  /** limit of active participants in the program. */
  maxParticipants?: Maybe<Scalars['Int']>;
  /** allow participants complete steps in the certain order. */
  resolveStepsInOrder?: Maybe<Scalars['Boolean']>;
  /** allow program participants to share their progress in group */
  shareProgress?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsCommonV3ProgramRestrictionsInput = {
  /** hide steps in the Pending state. */
  hideFutureSteps?: InputMaybe<Scalars['Boolean']>;
  /** limit of active participants in the program. */
  maxParticipants?: InputMaybe<Scalars['Int']>;
  /** allow participants complete steps in the certain order. */
  resolveStepsInOrder?: InputMaybe<Scalars['Boolean']>;
  /** allow program participants to share their progress in group */
  shareProgress?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsCommonV3ProgramReward = {
  __typename?: 'WixOnlineprogramsCommonV3ProgramReward';
  /** badges participant will get on program complete */
  badgeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** certificate for program. Currently is program GUID */
  certificate?: Maybe<WixOnlineprogramsCommonV3ProgramRewardCertificate>;
  /** on which action rewards must be assigned. */
  trigger?: Maybe<WixOnlineprogramsCommonV3ProgramRewardTrigger>;
};

export type WixOnlineprogramsCommonV3ProgramRewardCertificate = {
  __typename?: 'WixOnlineprogramsCommonV3ProgramRewardCertificate';
  /** date it was connected to program */
  connectedDate?: Maybe<Scalars['String']>;
  /** Certificate for program completion. Currently is program GUID */
  id?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsCommonV3ProgramRewardCertificateInput = {
  /** date it was connected to program */
  connectedDate?: InputMaybe<Scalars['String']>;
  /** Certificate for program completion. Currently is program GUID */
  id?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsCommonV3ProgramRewardInput = {
  /** badges participant will get on program complete */
  badgeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** certificate for program. Currently is program GUID */
  certificate?: InputMaybe<WixOnlineprogramsCommonV3ProgramRewardCertificateInput>;
  /** on which action rewards must be assigned. */
  trigger?: InputMaybe<WixOnlineprogramsCommonV3ProgramRewardTrigger>;
};

export enum WixOnlineprogramsCommonV3ProgramRewardTrigger {
  /** all steps are completed. */
  AllStepsCompleted = 'ALL_STEPS_COMPLETED',
  /** member joins the program */
  JoinedToProgram = 'JOINED_TO_PROGRAM',
  /** at least one step completed */
  StepCompleted = 'STEP_COMPLETED'
}

export type WixOnlineprogramsCommonV3ProgramSeo = {
  __typename?: 'WixOnlineprogramsCommonV3ProgramSeo';
  /** image url from description media */
  imageUrl?: Maybe<Scalars['String']>;
  /** schema used by Seo team */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** challenge slug expression. */
  slug?: Maybe<Scalars['String']>;
  /** program url */
  url?: Maybe<WixCommonPageUrl>;
};

export type WixOnlineprogramsCommonV3ProgramSeoInput = {
  /** image url from description media */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** schema used by Seo team */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** challenge slug expression. */
  slug?: InputMaybe<Scalars['String']>;
  /** program url */
  url?: InputMaybe<WixCommonPageUrlInput>;
};

export enum WixOnlineprogramsCommonV3ProgramState {
  /** closed program. Joins and sections/steps are not available for participants. */
  Archived = 'ARCHIVED',
  /** not published program, visible only on BM */
  Draft = 'DRAFT',
  /** program isn't available to join. */
  Ended = 'ENDED',
  /** program visible regarding to restrictions */
  Published = 'PUBLISHED'
}

export type WixOnlineprogramsCommonV3ProgramTimeline = {
  __typename?: 'WixOnlineprogramsCommonV3ProgramTimeline';
  /** condition on which the program is completed */
  finishCondition?: Maybe<WixOnlineprogramsCommonV3ProgramTimelineFinishCondition>;
  /** are sections/steps evaluated every day? Or can UoU participate in a self paced mode? */
  selfPaced?: Maybe<Scalars['Boolean']>;
  /** everyone starts on this day */
  startDate?: Maybe<Scalars['String']>;
  /** evaluate after some period of time in days. */
  timeEvaluationOptions?: Maybe<WixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptions>;
};

export enum WixOnlineprogramsCommonV3ProgramTimelineFinishCondition {
  /** finish participation when all steps are resolved. */
  AllStepsCompleted = 'ALL_STEPS_COMPLETED',
  /** finish participation after some time. */
  TimeEvaluation = 'TIME_EVALUATION',
  UnknownFinishCondition = 'UNKNOWN_FINISH_CONDITION'
}

export type WixOnlineprogramsCommonV3ProgramTimelineInput = {
  /** condition on which the program is completed */
  finishCondition?: InputMaybe<WixOnlineprogramsCommonV3ProgramTimelineFinishCondition>;
  /** are sections/steps evaluated every day? Or can UoU participate in a self paced mode? */
  selfPaced?: InputMaybe<Scalars['Boolean']>;
  /** everyone starts on this day */
  startDate?: InputMaybe<Scalars['String']>;
  /** evaluate after some period of time in days. */
  timeEvaluationOptions?: InputMaybe<WixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptionsInput>;
};

export type WixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptions = {
  __typename?: 'WixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptions';
  /** duration in days */
  durationInDays?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptionsInput = {
  /** duration in days */
  durationInDays?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3ApplyCouponRequestInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ApplyCouponResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3ApplyCouponResponse';
  couponId?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsParticipantsV3BulkAddAllToProgramRequestInput = {
  /** Exclude site members. */
  excludeMemberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to which bulk add participants. */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3BulkAddAllToProgramResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3BulkAddAllToProgramResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
};

export type WixOnlineprogramsParticipantsV3BulkAddToProgramRequestInput = {
  /** Site members. */
  memberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to which bulk add participants. */
  programId?: InputMaybe<Scalars['String']>;
  /** Return added participants in the response or not. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3BulkAddToProgramResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3BulkAddToProgramResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Participants created by bulk action */
  results?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3BulkAddToProgramResponseBulkAddToProgramResult>>>;
};

export type WixOnlineprogramsParticipantsV3BulkAddToProgramResponseBulkAddToProgramResult = {
  __typename?: 'WixOnlineprogramsParticipantsV3BulkAddToProgramResponseBulkAddToProgramResult';
  /** Added participant */
  item?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** Added participant metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixOnlineprogramsParticipantsV3BulkApproveAllParticipantRequestInput = {
  /** Exclude site members. */
  excludeParticipantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to approve all participants. */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3BulkApproveAllParticipantResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3BulkApproveAllParticipantResponse';
  /** Job id with async process */
  jobId?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3BulkApproveParticipantRequestInput = {
  /** Participants to add */
  participantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** program to approve participant */
  programId?: InputMaybe<Scalars['String']>;
  /** Return approved participants in the response or not */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3BulkApproveParticipantResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3BulkApproveParticipantResponse';
  /** Bulk action metadata */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Participants approved by bulk action */
  results?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3BulkApproveParticipantResponseBulkApproveParticipantResult>>>;
};

export type WixOnlineprogramsParticipantsV3BulkApproveParticipantResponseBulkApproveParticipantResult = {
  __typename?: 'WixOnlineprogramsParticipantsV3BulkApproveParticipantResponseBulkApproveParticipantResult';
  /** Approved or existing participant */
  item?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** Approved participant metadata */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationRequestInput = {
  /** resolved steps to create */
  resolvedSteps?: InputMaybe<Array<InputMaybe<WixOnlineprogramsParticipantsV3ResolvedStepInput>>>;
};

export type WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponse';
  /** metadata about resolved steps that were to insert */
  bulkActionMetadata?: Maybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonBulkActionMetadata>;
  /** results of bulk insertion */
  results?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponseBulkResolvedStepResult>>>;
};

export type WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponseBulkResolvedStepResult = {
  __typename?: 'WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponseBulkResolvedStepResult';
  /** resolved step itself */
  item?: Maybe<WixOnlineprogramsParticipantsV3ResolvedStep>;
  /** info about whether resolved step was inserted etc */
  itemMetadata?: Maybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonItemMetadata>;
};

export type WixOnlineprogramsParticipantsV3BulkInviteAllToProgramRequestInput = {
  /** Exclude site members. */
  excludeMemberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to which bulk add participants. */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3BulkInviteAllToProgramResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3BulkInviteAllToProgramResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
};

export type WixOnlineprogramsParticipantsV3BulkInviteToProgramRequestInput = {
  /** Return added participants in the response or not. */
  memberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to which bulk invite participants. */
  programId?: InputMaybe<Scalars['String']>;
  /** Return invited participants in the response or not. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3BulkInviteToProgramResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3BulkInviteToProgramResponse';
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Participants created by bulk action */
  results?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3BulkInviteToProgramResponseBulkInviteToProgramResult>>>;
};

export type WixOnlineprogramsParticipantsV3BulkInviteToProgramResponseBulkInviteToProgramResult = {
  __typename?: 'WixOnlineprogramsParticipantsV3BulkInviteToProgramResponseBulkInviteToProgramResult';
  /** Invited participant */
  item?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** Invited participant metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixOnlineprogramsParticipantsV3CompleteParticipantRequestInput = {
  /** ID of participant */
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3CompleteParticipantResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3CompleteParticipantResponse';
  /** Updated participant */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
};

export type WixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsRequestInput = {
  /** participant id to remove all steps */
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsResponse';
  /** Count of resolved steps that failed to be deleted */
  failedCount?: Maybe<Scalars['Int']>;
  /** Total count of resolved steps for participant */
  resolvedStepsTotal?: Maybe<Scalars['Int']>;
  /** Count of successfully deleted resolved steps */
  successfulCount?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3DeleteParticipantRequestInput = {
  /** Participants to delete */
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ExportParticipantsStatsRequestInput = {
  /** program id to export data from */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3GetAccessStatusResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3GetAccessStatusResponse';
  /** True if participants cannot access online programs due to some limitations */
  isBlocked?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3GetCompletionStatsRequestInput = {
  /** program id to get stats for */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3GetCompletionStatsResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3GetCompletionStatsResponse';
  /** Number of participants that completed the program */
  completedAll?: Maybe<Scalars['Int']>;
  /** Percentage of participants that completed the program */
  completionRate?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsParticipantsV3GetParticipantRequestInput = {
  id: Scalars['ID'];
};

export type WixOnlineprogramsParticipantsV3GetPremiumStatsResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3GetPremiumStatsResponse';
  /** Count of active participants on the site */
  activeParticipantsCount?: Maybe<Scalars['Int']>;
  /** Limit of active participants on a site without premium */
  activeParticipantsLimit?: Maybe<Scalars['Int']>;
  /** True if site has Online Programs premium feature */
  hasPremium?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3GetProgramSummariesRequestInput = {
  /** Programs to get summary about */
  programIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixOnlineprogramsParticipantsV3GetProgramSummariesResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3GetProgramSummariesResponse';
  /** summaries for each program in the same order as program_ids */
  summaries?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3ParticipantsSummary>>>;
};

export type WixOnlineprogramsParticipantsV3GetResolvedStepRequestInput = {
  participantId?: InputMaybe<Scalars['String']>;
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3GetResolvedStepResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3GetResolvedStepResponse';
  resolvedStep?: Maybe<WixOnlineprogramsParticipantsV3ResolvedStep>;
};

export type WixOnlineprogramsParticipantsV3GetStatisticsRequestInput = {
  /** Program to get statistics about */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3GetStatisticsResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3GetStatisticsResponse';
  /** number of participants waiting for the owner payment confirmation. */
  totalApprovalWaiting?: Maybe<Scalars['Int']>;
  /** number of pending join requests */
  totalCompleted?: Maybe<Scalars['Int']>;
  /** number of invited members. */
  totalFailed?: Maybe<Scalars['Int']>;
  /** number of active and finished participants. */
  totalJoined?: Maybe<Scalars['Int']>;
  /** number of participant who started progress on program */
  totalWithProgress?: Maybe<Scalars['Int']>;
  /** number of participants who not started progress on program */
  totalWithoutProgress?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3IssueCertificateRequestInput = {
  /** Participant to get certificate */
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3IssueCertificateResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3IssueCertificateResponse';
  /** Updated participant */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
};

export type WixOnlineprogramsParticipantsV3JoinProgramRequestInput = {
  /** Program to join */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3JoinProgramResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3JoinProgramResponse';
  /** Created participant with corresponding state */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
};

export type WixOnlineprogramsParticipantsV3LeaveProgramRequestInput = {
  /** Participant id to leave program */
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ListResolvedStepsRequestInput = {
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ListResolvedStepsResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3ListResolvedStepsResponse';
  resolvedSteps?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3ResolvedStep>>>;
};

export type WixOnlineprogramsParticipantsV3Membership = {
  __typename?: 'WixOnlineprogramsParticipantsV3Membership';
  /** number of completed steps */
  completedStepsCount?: Maybe<Scalars['Int']>;
  /** Referenced participant id */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** Referenced participant id */
  participantId?: Maybe<Scalars['String']>;
  /** state of the participant */
  state?: Maybe<WixOnlineprogramsParticipantsV3ParticipantState>;
};

export type WixOnlineprogramsParticipantsV3Participant = {
  __typename?: 'WixOnlineprogramsParticipantsV3Participant';
  /** options for auto removed participant */
  autoRemovedOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantAutoRemovedOptions>;
  /** Certificate issued to participant */
  certificate?: Maybe<WixOnlineprogramsParticipantsV3ParticipantCertificate>;
  completedOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantCompletedOptions>;
  createdDate?: Maybe<Scalars['String']>;
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  failedOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantFailedOptions>;
  /** Participant ID. */
  id?: Maybe<Scalars['String']>;
  joinedOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantJoinedOptions>;
  /** Member ID of participant on site */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** Member ID of participant on site */
  memberId?: Maybe<Scalars['String']>;
  paymentPendingOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantPaymentPendingOptions>;
  /** Program ID which participant participates in */
  programId?: Maybe<Scalars['String']>;
  /** Program completion progress */
  progress?: Maybe<WixOnlineprogramsParticipantsV3Progress>;
  revision?: Maybe<Scalars['Long']>;
  /** state of participation in the program */
  state?: Maybe<WixOnlineprogramsParticipantsV3ParticipantState>;
  suspendedOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantSuspendedOptions>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantAutoRemovedOptions = {
  __typename?: 'WixOnlineprogramsParticipantsV3ParticipantAutoRemovedOptions';
  /** date participant started the program */
  startDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantCertificate = {
  __typename?: 'WixOnlineprogramsParticipantsV3ParticipantCertificate';
  /** when certificate was issued, UTC */
  issuedDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantCompletedOptions = {
  __typename?: 'WixOnlineprogramsParticipantsV3ParticipantCompletedOptions';
  /** date participant started the program */
  startDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantFailedOptions = {
  __typename?: 'WixOnlineprogramsParticipantsV3ParticipantFailedOptions';
  /** date participant started the program */
  startDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantJoinedOptions = {
  __typename?: 'WixOnlineprogramsParticipantsV3ParticipantJoinedOptions';
  freeCouponOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsFreeCouponOptions>;
  joinPath?: Maybe<WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsJoinPath>;
  paidPlanOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsPaidPlanOptions>;
  singlePaymentOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsSinglePaymentOptions>;
  startDate?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsFreeCouponOptions = {
  __typename?: 'WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsFreeCouponOptions';
  couponId?: Maybe<Scalars['String']>;
};

export enum WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsJoinPath {
  /** Member was added to the program by site owner */
  Added = 'ADDED',
  /** Member joined to the program for free */
  Free = 'FREE',
  /** Member joined with the Free Coupon */
  FreeCoupon = 'FREE_COUPON',
  /** Member has Paid Plan to join */
  PaidPlan = 'PAID_PLAN',
  /** Member paid once to join the program */
  SinglePayment = 'SINGLE_PAYMENT',
  UnknownJoinPath = 'UNKNOWN_JOIN_PATH'
}

export type WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsPaidPlanOptions = {
  __typename?: 'WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsPaidPlanOptions';
  planIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsSinglePaymentOptions = {
  __typename?: 'WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsSinglePaymentOptions';
  orderId?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantPaymentPendingOptions = {
  __typename?: 'WixOnlineprogramsParticipantsV3ParticipantPaymentPendingOptions';
  /** Offline payment transaction */
  offlineTrxId?: Maybe<Scalars['String']>;
  /** Pricing plans */
  paidPlanIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Payment order */
  paymentOrderId?: Maybe<Scalars['String']>;
};

export enum WixOnlineprogramsParticipantsV3ParticipantState {
  /** Member asked owner to participate in program */
  ApprovalPending = 'APPROVAL_PENDING',
  /** Participant removed automatically after some program condition */
  AutoRemoved = 'AUTO_REMOVED',
  /** Participant completed the program, and could join again */
  Completed = 'COMPLETED',
  /** Participant failed to complete the program, and could join again */
  Failed = 'FAILED',
  /** Member invited to participate in program */
  Invited = 'INVITED',
  /** Member joined the program and became participant */
  Joined = 'JOINED',
  PaymentPending = 'PAYMENT_PENDING',
  /** Participant with ended pricing plan (PP), will be joined as renew PP */
  Suspended = 'SUSPENDED',
  /** Unknown state */
  UnknownState = 'UNKNOWN_STATE'
}

export type WixOnlineprogramsParticipantsV3ParticipantSuspendedOptions = {
  __typename?: 'WixOnlineprogramsParticipantsV3ParticipantSuspendedOptions';
  /** date participant started the program */
  startDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantsBulkCompleteEventInput = {
  /** Optional cursor for the next result page */
  cursorNext?: InputMaybe<Scalars['String']>;
  /** Program ID */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantsBulkDeleteEventInput = {
  /** Optional cursor for the next result page */
  cursorNext?: InputMaybe<Scalars['String']>;
  /** Program ID */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantsSummary = {
  __typename?: 'WixOnlineprogramsParticipantsV3ParticipantsSummary';
  /** Membership of the participant; if participant is not in the program, this field will be empty */
  membership?: Maybe<WixOnlineprogramsParticipantsV3Membership>;
  /** Referenced program id */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
  /** Referenced program id */
  programId?: Maybe<Scalars['String']>;
  /** Statistics for the program */
  statistic?: Maybe<WixOnlineprogramsParticipantsV3Statistic>;
};

export type WixOnlineprogramsParticipantsV3ProgramSummary = {
  __typename?: 'WixOnlineprogramsParticipantsV3ProgramSummary';
  /** Membership of the participant; if participant is not in the program, this field will be empty */
  membership?: Maybe<WixOnlineprogramsParticipantsV3Membership>;
  /** Program */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
  /** Statistic for the program */
  statistic?: Maybe<WixOnlineprogramsParticipantsV3Statistic>;
};

export type WixOnlineprogramsParticipantsV3Progress = {
  __typename?: 'WixOnlineprogramsParticipantsV3Progress';
  /** Completion percentage */
  completionPercentage?: Maybe<Scalars['Float']>;
  /** Total number of program steps available to resolve */
  totalStepsAvailable?: Maybe<Scalars['Int']>;
  /** Number of program steps completed by member */
  totalStepsCompleted?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3QueryParticipantsRequestInput = {
  /** Platformized query */
  query?: InputMaybe<WixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput>;
};

export type WixOnlineprogramsParticipantsV3QueryParticipantsResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3QueryParticipantsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3Participant>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixOnlineprogramsParticipantsV3QueryProgramSummariesRequestInput = {
  /**
   * Basically the query to sort and query the programs;
   * Works exactly the same as the query in QueryPrograms request
   */
  query?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input>;
};

export type WixOnlineprogramsParticipantsV3QueryProgramSummariesResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3QueryProgramSummariesResponse';
  /** paging metadata */
  pagingMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonPagingMetadataV2>;
  /** summaries */
  summaries?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3ProgramSummary>>>;
};

export type WixOnlineprogramsParticipantsV3QueryResolvedStepsRequestInput = {
  query?: InputMaybe<WixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput>;
};

export type WixOnlineprogramsParticipantsV3QueryResolvedStepsResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3QueryResolvedStepsResponse';
  pagingMetadata?: Maybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingMetadata>;
  resolvedSteps?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3ResolvedStep>>>;
};

export type WixOnlineprogramsParticipantsV3ResolveStepRequestInput = {
  participantId?: InputMaybe<Scalars['String']>;
  quizSubmissionId?: InputMaybe<Scalars['String']>;
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ResolveStepResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3ResolveStepResponse';
  resolvedStep?: Maybe<WixOnlineprogramsParticipantsV3ResolvedStep>;
};

export type WixOnlineprogramsParticipantsV3ResolvedStep = {
  __typename?: 'WixOnlineprogramsParticipantsV3ResolvedStep';
  /** created date of resolved step */
  createdDate?: Maybe<Scalars['String']>;
  /** earned score for resolved step */
  earnedScore?: Maybe<Scalars['Int']>;
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** participant who resolved step */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** participant who resolved step */
  participantId?: Maybe<Scalars['String']>;
  /** step passing grade */
  passingGrade?: Maybe<Scalars['Int']>;
  /** program step been resolve */
  programStepId?: Maybe<Scalars['String']>;
  /** quiz submission */
  quizSubmissionId?: Maybe<Scalars['String']>;
  /** resolved step status */
  status?: Maybe<WixOnlineprogramsParticipantsV3ResolvedStepStatus>;
  /** program step been resolve */
  step?: Maybe<WixOnlineprogramsStepsV3Step>;
  /** updated date of resolved step */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ResolvedStepInput = {
  /** created date of resolved step */
  createdDate?: InputMaybe<Scalars['String']>;
  /** earned score for resolved step */
  earnedScore?: InputMaybe<Scalars['Int']>;
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** participant who resolved step */
  participantId?: InputMaybe<Scalars['String']>;
  /** step passing grade */
  passingGrade?: InputMaybe<Scalars['Int']>;
  /** program step been resolve */
  programStepId?: InputMaybe<Scalars['String']>;
  /** quiz submission */
  quizSubmissionId?: InputMaybe<Scalars['String']>;
  /** resolved step status */
  status?: InputMaybe<WixOnlineprogramsParticipantsV3ResolvedStepStatus>;
  /** updated date of resolved step */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixOnlineprogramsParticipantsV3ResolvedStepStatus {
  /** step completed */
  Completed = 'COMPLETED',
  /** participant failed to resolve step */
  Failed = 'FAILED'
}

export type WixOnlineprogramsParticipantsV3RevertCouponRequestInput = {
  couponId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3RevertCouponResponse = {
  __typename?: 'WixOnlineprogramsParticipantsV3RevertCouponResponse';
  total?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsParticipantsV3Statistic = {
  __typename?: 'WixOnlineprogramsParticipantsV3Statistic';
  /** number of join requests */
  approvalPending?: Maybe<Scalars['Long']>;
  /** number of finished participants */
  completed?: Maybe<Scalars['Long']>;
  /** number of failed participants */
  failed?: Maybe<Scalars['Long']>;
  /** number of participants who started the program */
  inProgress?: Maybe<Scalars['Long']>;
  /** number of invited members */
  invited?: Maybe<Scalars['Long']>;
  /** number of joined participants */
  joined?: Maybe<Scalars['Long']>;
  /** number of participants waiting for the owner payment confirmation */
  paymentPending?: Maybe<Scalars['Long']>;
  /** number of suspended participants */
  suspended?: Maybe<Scalars['Long']>;
};

export type WixOnlineprogramsParticipantsV3UndoStepRequestInput = {
  participantId?: InputMaybe<Scalars['String']>;
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonBulkActionMetadata = {
  __typename?: 'WixOnlineprogramsParticipantsV3UpstreamWixCommonBulkActionMetadata';
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'WixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonCursors = {
  __typename?: 'WixOnlineprogramsParticipantsV3UpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonItemMetadata = {
  __typename?: 'WixOnlineprogramsParticipantsV3UpstreamWixCommonItemMetadata';
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export enum WixOnlineprogramsParticipantsV3UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonSortOrder>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonSortingInput>>>;
};

export enum WixOnlineprogramsProgramsV3AccessType {
  /** send a join request to the owner and get an approval from him. */
  Private = 'PRIVATE',
  /** join without approvals */
  Public = 'PUBLIC',
  /** join possible only after owner invite. */
  Secret = 'SECRET'
}

export type WixOnlineprogramsProgramsV3ArchiveProgramRequestInput = {
  /** Program to archive */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3ArchiveProgramResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3ArchiveProgramResponse';
  /** Archived program */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestInput = {
  /** List of programs you want to create */
  programs?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestProgramMigrationInput>>>;
};

export type WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestProgramMigrationInput = {
  /** program to create */
  program?: InputMaybe<WixOnlineprogramsProgramsV3ProgramInput>;
  /** section ids in program */
  sectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** step ids in program */
  stepIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationResponse';
  /** Metadata about whole bulk action. */
  bulkActionMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata>;
  /** Results of bulk action. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3BulkProgramResult>>>;
};

export type WixOnlineprogramsProgramsV3BulkProgramResult = {
  __typename?: 'WixOnlineprogramsProgramsV3BulkProgramResult';
  /** Action type of bulk action (INSERT OR UPDATE) for that endpoint. */
  action?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionType>;
  /** Item itself (empty if return_entity in request is false). */
  item?: Maybe<WixOnlineprogramsProgramsV3Program>;
  /** Metadata of item. */
  itemMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata>;
};

export type WixOnlineprogramsProgramsV3BulkUpdateProgramsRequestInput = {
  /** List of programs you want to update */
  programs?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3BulkUpdateProgramsRequestMaskedProgramInput>>>;
  /** set to `true` if you wish to receive back the created programs in the response */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsProgramsV3BulkUpdateProgramsRequestMaskedProgramInput = {
  /** Explicit list of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to be updated, may be partial */
  program?: InputMaybe<WixOnlineprogramsProgramsV3ProgramInput>;
};

export type WixOnlineprogramsProgramsV3BulkUpdateProgramsResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3BulkUpdateProgramsResponse';
  /** metadata */
  bulkActionMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3BulkUpdateProgramsResponseBulkUpdateProgramResult>>>;
};

export type WixOnlineprogramsProgramsV3BulkUpdateProgramsResponseBulkUpdateProgramResult = {
  __typename?: 'WixOnlineprogramsProgramsV3BulkUpdateProgramsResponseBulkUpdateProgramResult';
  /** Only exists if `returnEntity` was set to true in the request */
  item?: Maybe<WixOnlineprogramsProgramsV3Program>;
  /** item metadata */
  itemMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata>;
};

export type WixOnlineprogramsProgramsV3ContentSummary = {
  __typename?: 'WixOnlineprogramsProgramsV3ContentSummary';
  /** number of sections in program */
  sectionCount?: Maybe<Scalars['Int']>;
  /** number of steps in program */
  stepCount?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3ContentSummaryInput = {
  /** number of sections in program */
  sectionCount?: InputMaybe<Scalars['Int']>;
  /** number of steps in program */
  stepCount?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3CountProgramsRequestInput = {
  /** filter for which count is requested */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixOnlineprogramsProgramsV3CountProgramsResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3CountProgramsResponse';
  /** count of programs matching filter */
  count?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3CreateProgramRequestInput = {
  /** Program to be created. */
  program?: InputMaybe<WixOnlineprogramsProgramsV3ProgramInput>;
};

export type WixOnlineprogramsProgramsV3CreateProgramResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3CreateProgramResponse';
  /** The created Program. */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3DeleteProgramRequestInput = {
  /** Id of the Program to delete. */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3Description = {
  __typename?: 'WixOnlineprogramsProgramsV3Description';
  details?: Maybe<Scalars['String']>;
  /** WixMedia image */
  image?: Maybe<WixCommonImage>;
  title?: Maybe<Scalars['String']>;
  /** WixMedia video */
  video?: Maybe<WixCommonVideoV2>;
};

export type WixOnlineprogramsProgramsV3DescriptionInput = {
  details?: InputMaybe<Scalars['String']>;
  /** WixMedia image */
  image?: InputMaybe<WixCommonImageInput>;
  title?: InputMaybe<Scalars['String']>;
  /** WixMedia video */
  video?: InputMaybe<WixCommonVideoV2Input>;
};

export type WixOnlineprogramsProgramsV3DuplicateProgramRequestInput = {
  /** Program to be duplicated from. */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3DuplicateProgramResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3DuplicateProgramResponse';
  /** The created Program. */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3EndProgramRequestInput = {
  /** Program to finish */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3EndProgramResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3EndProgramResponse';
  /** Finished program */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3GetProgramMembershipRequestInput = {
  /** program to get membership */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3GetProgramMembershipResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3GetProgramMembershipResponse';
  /** membership */
  programMembership?: Maybe<WixOnlineprogramsProgramsV3ProgramMembership>;
};

export type WixOnlineprogramsProgramsV3GetProgramRequestInput = {
  id: Scalars['ID'];
};

export type WixOnlineprogramsProgramsV3ListProgramMembershipsRequestInput = {
  /** paging */
  paging?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput>;
};

export type WixOnlineprogramsProgramsV3ListProgramMembershipsResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3ListProgramMembershipsResponse';
  /** metadata */
  pagingMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata>;
  /** memberships */
  programMemberships?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3ProgramMembership>>>;
};

export type WixOnlineprogramsProgramsV3ListSampleProgramsResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3ListSampleProgramsResponse';
  /** sample programs */
  programs?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3Program>>>;
};

export type WixOnlineprogramsProgramsV3Membership = {
  __typename?: 'WixOnlineprogramsProgramsV3Membership';
  /** participant in this program */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** participant in this program */
  participantId?: Maybe<Scalars['String']>;
  /** participant's state */
  participantState?: Maybe<WixOnlineprogramsProgramsV3MembershipParticipantState>;
};

export enum WixOnlineprogramsProgramsV3MembershipParticipantState {
  /** participant completed program */
  Completed = 'COMPLETED',
  /** participant failed to complete program in time */
  Failed = 'FAILED',
  /** participant invited to program */
  Invited = 'INVITED',
  /** participant joined program */
  Joined = 'JOINED',
  /** participant asked to join the program */
  JoinRequested = 'JOIN_REQUESTED'
}

export type WixOnlineprogramsProgramsV3Program = {
  __typename?: 'WixOnlineprogramsProgramsV3Program';
  /** join flow options. */
  accessType?: Maybe<WixOnlineprogramsProgramsV3AccessType>;
  /** assigned categories */
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** number of content entities in program */
  contentSummary?: Maybe<WixOnlineprogramsProgramsV3ContentSummary>;
  createdDate?: Maybe<Scalars['String']>;
  /** general program info. */
  description?: Maybe<WixOnlineprogramsProgramsV3Description>;
  /** extensible field */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Program ID. */
  id?: Maybe<Scalars['String']>;
  /** user id of owner, who created this program */
  ownerUserId?: Maybe<Scalars['String']>;
  participantsVirtualReference?: Maybe<WixOnlineprogramsParticipantsV3QueryParticipantsResponse>;
  /** single-payment price. */
  price?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonMoney>;
  /** participant limitation, step-completion pace and etc. */
  restrictions?: Maybe<WixOnlineprogramsProgramsV3Restrictions>;
  revision?: Maybe<Scalars['Long']>;
  /** rewards to be assigned after reaching some of the program milestones. */
  rewards?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3Reward>>>;
  /** seo settings. */
  seo?: Maybe<WixOnlineprogramsProgramsV3Seo>;
  /** if true -> invoice is sent to the customer who purchased the program via single payment; else -> payment confirmation email is sent */
  shouldSendInvoice?: Maybe<Scalars['Boolean']>;
  /** connected social group. */
  socialGroupId?: Maybe<Scalars['String']>;
  /** current program state / does participant need it? */
  state?: Maybe<WixOnlineprogramsProgramsV3State>;
  /** date of the last state update */
  stateUpdatedDate?: Maybe<Scalars['String']>;
  /** timeline type -> Self-paced, time-restricted. */
  timeline?: Maybe<WixOnlineprogramsProgramsV3Timeline>;
  updatedDate?: Maybe<Scalars['String']>;
  /** settings related to video steps in programs */
  videoStepsSettings?: Maybe<WixOnlineprogramsProgramsV3VideoStepsSettings>;
};


export type WixOnlineprogramsProgramsV3ProgramParticipantsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsParticipantsV3QueryParticipantsRequestInput>;
};

export type WixOnlineprogramsProgramsV3ProgramInput = {
  /** join flow options. */
  accessType?: InputMaybe<WixOnlineprogramsProgramsV3AccessType>;
  /** assigned categories */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** number of content entities in program */
  contentSummary?: InputMaybe<WixOnlineprogramsProgramsV3ContentSummaryInput>;
  createdDate?: InputMaybe<Scalars['String']>;
  /** general program info. */
  description?: InputMaybe<WixOnlineprogramsProgramsV3DescriptionInput>;
  /** extensible field */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Program ID. */
  id?: InputMaybe<Scalars['String']>;
  /** user id of owner, who created this program */
  ownerUserId?: InputMaybe<Scalars['String']>;
  /** single-payment price. */
  price?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonMoneyInput>;
  /** participant limitation, step-completion pace and etc. */
  restrictions?: InputMaybe<WixOnlineprogramsProgramsV3RestrictionsInput>;
  revision?: InputMaybe<Scalars['Long']>;
  /** rewards to be assigned after reaching some of the program milestones. */
  rewards?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3RewardInput>>>;
  /** seo settings. */
  seo?: InputMaybe<WixOnlineprogramsProgramsV3SeoInput>;
  /** if true -> invoice is sent to the customer who purchased the program via single payment; else -> payment confirmation email is sent */
  shouldSendInvoice?: InputMaybe<Scalars['Boolean']>;
  /** connected social group. */
  socialGroupId?: InputMaybe<Scalars['String']>;
  /** current program state / does participant need it? */
  state?: InputMaybe<WixOnlineprogramsProgramsV3State>;
  /** date of the last state update */
  stateUpdatedDate?: InputMaybe<Scalars['String']>;
  /** timeline type -> Self-paced, time-restricted. */
  timeline?: InputMaybe<WixOnlineprogramsProgramsV3TimelineInput>;
  updatedDate?: InputMaybe<Scalars['String']>;
  /** settings related to video steps in programs */
  videoStepsSettings?: InputMaybe<WixOnlineprogramsProgramsV3VideoStepsSettingsInput>;
};

export type WixOnlineprogramsProgramsV3ProgramMembership = {
  __typename?: 'WixOnlineprogramsProgramsV3ProgramMembership';
  /** participant's membership */
  membership?: Maybe<WixOnlineprogramsProgramsV3Membership>;
  /** program */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3PublishProgramRequestInput = {
  /** Program to publish */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3PublishProgramResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3PublishProgramResponse';
  /** Published program */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3QueryProgramsRequestInput = {
  /** Query to filter programs */
  query?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input>;
};

export type WixOnlineprogramsProgramsV3QueryProgramsResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3QueryProgramsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3Program>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixOnlineprogramsProgramsV3ResolveProgramSlugRequestInput = {
  /** seo slug of online program. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3ResolveProgramSlugResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3ResolveProgramSlugResponse';
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
  programId?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3Restrictions = {
  __typename?: 'WixOnlineprogramsProgramsV3Restrictions';
  /** hide steps in the Pending state. */
  hideFutureSteps?: Maybe<Scalars['Boolean']>;
  /** limit of active participants in the program. */
  maxParticipants?: Maybe<Scalars['Int']>;
  /** allow participants complete steps in the certain order. */
  resolveStepsInOrder?: Maybe<Scalars['Boolean']>;
  /** allow program participants to share their progress in group */
  shareProgress?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsProgramsV3RestrictionsInput = {
  /** hide steps in the Pending state. */
  hideFutureSteps?: InputMaybe<Scalars['Boolean']>;
  /** limit of active participants in the program. */
  maxParticipants?: InputMaybe<Scalars['Int']>;
  /** allow participants complete steps in the certain order. */
  resolveStepsInOrder?: InputMaybe<Scalars['Boolean']>;
  /** allow program participants to share their progress in group */
  shareProgress?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsProgramsV3Reward = {
  __typename?: 'WixOnlineprogramsProgramsV3Reward';
  /** badges participant will get on program complete */
  badgeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** certificate for program. Currently is program GUID */
  certificate?: Maybe<WixOnlineprogramsProgramsV3RewardCertificate>;
  /** on which action rewards must be assigned. */
  trigger?: Maybe<WixOnlineprogramsProgramsV3RewardTrigger>;
};

export type WixOnlineprogramsProgramsV3RewardCertificate = {
  __typename?: 'WixOnlineprogramsProgramsV3RewardCertificate';
  /** date it was connected to program */
  connectedDate?: Maybe<Scalars['String']>;
  /** Certificate for program completion. Currently is program GUID */
  id?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3RewardCertificateInput = {
  /** date it was connected to program */
  connectedDate?: InputMaybe<Scalars['String']>;
  /** Certificate for program completion. Currently is program GUID */
  id?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3RewardInput = {
  /** badges participant will get on program complete */
  badgeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** certificate for program. Currently is program GUID */
  certificate?: InputMaybe<WixOnlineprogramsProgramsV3RewardCertificateInput>;
  /** on which action rewards must be assigned. */
  trigger?: InputMaybe<WixOnlineprogramsProgramsV3RewardTrigger>;
};

export enum WixOnlineprogramsProgramsV3RewardTrigger {
  /** all steps are completed. */
  AllStepsCompleted = 'ALL_STEPS_COMPLETED',
  /** member joins the program */
  JoinedToProgram = 'JOINED_TO_PROGRAM',
  /** at least one step completed */
  StepCompleted = 'STEP_COMPLETED'
}

export type WixOnlineprogramsProgramsV3SearchProgramsRequestInput = {
  /** Query to search programs */
  search?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorSearchInput>;
};

export type WixOnlineprogramsProgramsV3SearchProgramsResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3SearchProgramsResponse';
  /** aggregation */
  aggregationData?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationData>;
  /** paging */
  pagingMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata>;
  /** Found programs */
  programs?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3Program>>>;
};

export type WixOnlineprogramsProgramsV3Seo = {
  __typename?: 'WixOnlineprogramsProgramsV3Seo';
  /** Approximate SEO program duration in Iso-8601 */
  courseWorkload?: Maybe<Scalars['String']>;
  /** alt text of image */
  imageAlt?: Maybe<Scalars['String']>;
  /** image url from description media */
  imageUrl?: Maybe<Scalars['String']>;
  /** schema used by Seo team */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /**
   * Temporary removed URL_SLUG validation for data migration
   * string slug = 1 [(wix.api.format) = URL_SLUG]; //challenge slug expression
   */
  slug?: Maybe<Scalars['String']>;
  /** program url */
  url?: Maybe<WixCommonPageUrl>;
};

export type WixOnlineprogramsProgramsV3SeoInput = {
  /** Approximate SEO program duration in Iso-8601 */
  courseWorkload?: InputMaybe<Scalars['String']>;
  /** alt text of image */
  imageAlt?: InputMaybe<Scalars['String']>;
  /** image url from description media */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** schema used by Seo team */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /**
   * Temporary removed URL_SLUG validation for data migration
   * string slug = 1 [(wix.api.format) = URL_SLUG]; //challenge slug expression
   */
  slug?: InputMaybe<Scalars['String']>;
  /** program url */
  url?: InputMaybe<WixCommonPageUrlInput>;
};

export enum WixOnlineprogramsProgramsV3State {
  /** closed program. Joins and sections/steps are not available for participants. */
  Archived = 'ARCHIVED',
  /** not published program, visible only on BM */
  Draft = 'DRAFT',
  /** program isn't available to join. */
  Ended = 'ENDED',
  /** program visible regarding to restrictions */
  Published = 'PUBLISHED'
}

export type WixOnlineprogramsProgramsV3Timeline = {
  __typename?: 'WixOnlineprogramsProgramsV3Timeline';
  /** duration of program in days (if applicable). */
  durationInDays?: Maybe<Scalars['Int']>;
  /** are sections/steps evaluated every day? Or can UoU participate in a self paced mode? */
  selfPaced?: Maybe<Scalars['Boolean']>;
  /** everyone starts on this day */
  startDate?: Maybe<Scalars['String']>;
};

export enum WixOnlineprogramsProgramsV3TimelineFinishCondition {
  /** finish participation when all steps are resolved. */
  AllStepsCompleted = 'ALL_STEPS_COMPLETED',
  /** finish participation after some time. */
  TimeEvaluation = 'TIME_EVALUATION',
  UnknownFinishCondition = 'UNKNOWN_FINISH_CONDITION'
}

export type WixOnlineprogramsProgramsV3TimelineInput = {
  /** duration of program in days (if applicable). */
  durationInDays?: InputMaybe<Scalars['Int']>;
  /** are sections/steps evaluated every day? Or can UoU participate in a self paced mode? */
  selfPaced?: InputMaybe<Scalars['Boolean']>;
  /** everyone starts on this day */
  startDate?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3TimelineTimeEvaluationOptions = {
  __typename?: 'WixOnlineprogramsProgramsV3TimelineTimeEvaluationOptions';
  /** duration in days */
  durationInDays?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3TimelineTimeEvaluationOptionsInput = {
  /** duration in days */
  durationInDays?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3UpdateProgramRequestInput = {
  /**
   * Set of fields to update.
   *
   * Fields that aren't included in `fieldMask.paths` are ignored.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to be updated, may be partial. */
  program?: InputMaybe<WixOnlineprogramsProgramsV3ProgramInput>;
};

export type WixOnlineprogramsProgramsV3UpdateProgramResponse = {
  __typename?: 'WixOnlineprogramsProgramsV3UpdateProgramResponse';
  /** Updated Program. */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationData = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationData';
  /** key = aggregation name (as derived from search request). */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResults>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResults = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResults';
  /** Date histogram aggregation results. */
  dateHistogram?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults>;
  /** Field to aggregate by as derived from search request. */
  fieldPath?: Maybe<Scalars['String']>;
  /** Group by value aggregation results. */
  groupedByValue?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults>;
  /** User-defined name of aggregation as derived from search request. */
  name?: Maybe<Scalars['String']>;
  /** Nested aggregation results. */
  nested?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResults>;
  /** Range aggregation results. */
  ranges?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that must match provided kind as derived from search request. */
  type?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults';
  /** List of date histogram aggregations. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult';
  /** Count of documents in the bucket. */
  count?: Maybe<Scalars['Int']>;
  /** Date in ISO 8601 format. */
  value?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults';
  /** List of value aggregations. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult';
  /** Nested aggregations. */
  nestedResults?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults';
  /** Field to aggregate by, matches the one provided in request. */
  fieldPath?: Maybe<Scalars['String']>;
  /** User-defined name of aggregation, matches the one provided in request. */
  name?: Maybe<Scalars['String']>;
  /** Range aggregation results. */
  ranges?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that matches result. */
  type?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResults = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResults';
  /** List of nested aggregations. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue';
  /** Date histogram aggregation result. */
  dateHistogram?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
  /** Range aggregation result. */
  range?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult>;
  /** Scalar aggregation result. */
  scalar?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult>;
  /** Value aggregation result. */
  value?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult';
  /** Count of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults';
  /** List of nested aggregations. */
  results?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult';
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult';
  /** Count of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults';
  /** List of ranges returned in same order as requested. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult';
  /** Count of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult';
  /** Type of scalar aggregation. */
  type?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonScalarType>;
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults';
  /** List of value aggregations. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult';
  /** Count of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput = {
  /** Interval for date histogram aggregation. */
  interval?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInterval>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInterval {
  /** Daily interval */
  Day = 'DAY',
  /** Hourly interval */
  Hour = 'HOUR',
  /** Minute interval */
  Minute = 'MINUTE',
  /** Monthly interval */
  Month = 'MONTH',
  /** Second interval */
  Second = 'SECOND',
  UnknownInterval = 'UNKNOWN_INTERVAL',
  /** Weekly interval */
  Week = 'WEEK',
  /** Yearly interval */
  Year = 'YEAR'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationGroupByAggregationInput = {
  /** Field to aggregate by. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results. */
  name?: InputMaybe<Scalars['String']>;
  /** Value aggregation configuration. */
  value?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationInput = {
  /** Date histogram aggregation. */
  dateHistogram?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by, use dot notation to specify json path. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results. */
  name?: InputMaybe<Scalars['String']>;
  /** Nested aggregation. */
  nested?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationInput>;
  /** Range aggregation. */
  range?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation. */
  scalar?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation, client must provide matching aggregation field below. */
  type?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationType>;
  /** Value aggregation. */
  value?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationInput = {
  /** Flattened list of aggregations, where each next aggregation is nested within previous one. */
  nestedAggregations?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput = {
  /** Date histogram aggregation. */
  dateHistogram?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by, use dot notation to specify json path. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results. */
  name?: InputMaybe<Scalars['String']>;
  /** Range aggregation. */
  range?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation. */
  scalar?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation, client must provide matching aggregation field below. */
  type?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationType>;
  /** Value aggregation. */
  value?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationType {
  /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.). */
  DateHistogram = 'DATE_HISTOGRAM',
  /** An aggregation, where user can define set of ranges - each representing a bucket. */
  Range = 'RANGE',
  /** A single-value metric aggregation. For example, min, max, sum, avg. */
  Scalar = 'SCALAR',
  UnknownAggregationType = 'UNKNOWN_AGGREGATION_TYPE',
  /** An aggregation where result buckets are dynamically built - one per unique value. */
  Value = 'VALUE'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput = {
  /** List of range buckets, where during aggregation each entity will be placed in the first bucket its value falls into, based on the provided range bounds. */
  buckets?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = {
  /** Inclusive lower bound of the range. Required if `to` is not provided. */
  from?: InputMaybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. Required if `from` is not provided. */
  to?: InputMaybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput = {
  /** Define the operator for the scalar aggregation. */
  type?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonScalarType>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationType {
  /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
  DateHistogram = 'DATE_HISTOGRAM',
  /** Multi-level aggregation, where each next aggregation is nested within previous one. */
  Nested = 'NESTED',
  /** An aggregation, where user can define set of ranges - each representing a bucket. */
  Range = 'RANGE',
  /** A single-value metric aggregation. For example, min, max, sum, avg. */
  Scalar = 'SCALAR',
  UnknownAggregationType = 'UNKNOWN_AGGREGATION_TYPE',
  /** An aggregation where result buckets are dynamically built - one per unique value. */
  Value = 'VALUE'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = {
  /** Specify custom bucket name. Defaults are [string -> "N/A"], [int -> "0"], [bool -> "false"] ... */
  addToBucket?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput = {
  /** Options for including missing values. */
  includeOptions?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>;
  /** How many aggregations to return. Can be between 1 and 250. 10 is the default. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Whether to include or exclude missing values from the aggregation results. Default: `EXCLUDE`. */
  missingValues?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationMissingValues>;
  /** Whether to sort in ascending or descending order. */
  sortDirection?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationSortDirection>;
  /** Whether to sort by number of matches or value of the field. */
  sortType?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationSortType>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationMissingValues {
  /** Exclude missing values from the aggregation results. */
  Exclude = 'EXCLUDE',
  /** Include missing values in the aggregation results. */
  Include = 'INCLUDE'
}

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationSortDirection {
  /** Sort in ascending order. */
  Asc = 'ASC',
  /** Sort in descending order. */
  Desc = 'DESC'
}

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationSortType {
  /** Sort by number of matches. */
  Count = 'COUNT',
  /** Sort by value of the field alphabetically. */
  Value = 'VALUE'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata';
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionType {
  /** DELETE */
  Delete = 'DELETE',
  /** INSERT */
  Insert = 'INSERT',
  /** UNKNOWN_ACTION_TYPE */
  UnknownActionType = 'UNKNOWN_ACTION_TYPE',
  /** UPDATE */
  Update = 'UPDATE'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in current page. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /**
   * Total number of items matching the filter.
   * Available only on the first page of *Search* results, not included in *Query* or *List* results.
   * If the Search results span multiple pages, the value of `total` will exceed the number of items returned on the first page.
   */
  total?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonCursorSearchInput = {
  /** Aggregations are a way to explore large amounts of data by displaying summaries about various partitions of the data and later allowing to narrow the navigation to a specific partition. */
  aggregations?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationInput>>>;
  /**
   * Cursor paging options.
   *
   * Learn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).
   */
  cursorPaging?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Free text to match in searchable fields. */
  search?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsInput>;
  /**
   * List of sort objects.
   *
   * Learn more about the [sort section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-sort-section).
   */
  sort?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput>>>;
  /**
   * UTC offset or IANA time zone. Valid values are
   * ISO 8601 UTC offsets, such as +02:00 or -06:00,
   * and IANA time zone IDs, such as Europe/Rome.
   *
   * Affects all filters and aggregations returned values.
   * You may override this behavior in a specific filter by providing
   * timestamps including time zone. For example, `"2023-12-20T10:52:34.795Z"`.
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonCursors = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonCursors';
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata';
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonMoney = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonMoney';
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  value?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonMoneyInput = {
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  value?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonPagingMetadataV2 = {
  __typename?: 'WixOnlineprogramsProgramsV3UpstreamWixCommonPagingMetadataV2';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set. */
  total?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Learn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonPagingInput>;
  /**
   * Sort object.
   *
   * Learn more about the [sort section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-sort-section).
   */
  sort?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput>>>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonScalarType {
  /** Average of values. */
  Avg = 'AVG',
  /** Count of distinct values. */
  CountDistinct = 'COUNT_DISTINCT',
  /** Maximum value. */
  Max = 'MAX',
  /** Minimum value. */
  Min = 'MIN',
  /** Sum of values. */
  Sum = 'SUM',
  UnknownScalarType = 'UNKNOWN_SCALAR_TYPE'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsInput = {
  /** Search term or expression. */
  expression?: InputMaybe<Scalars['String']>;
  /** Fields to search in. If empty - will search in all searchable fields. Use dot notation to specify json path. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to use auto fuzzy search (allowing typos by a managed proximity algorithm). */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Defines how separate search terms in `expression` are combined. */
  mode?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsMode>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsMode {
  /** All search terms must be present. */
  And = 'AND',
  /** Any of the search terms must be present. */
  Or = 'OR'
}

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type WixOnlineprogramsProgramsV3VideoStepsSettings = {
  __typename?: 'WixOnlineprogramsProgramsV3VideoStepsSettings';
  /** automatically switch to next video step after finishing current one */
  autoNavigate?: Maybe<Scalars['Boolean']>;
  /** how many percents of video need to be watched to complete step */
  requiredCompletionPercentage?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3VideoStepsSettingsInput = {
  /** automatically switch to next video step after finishing current one */
  autoNavigate?: InputMaybe<Scalars['Boolean']>;
  /** how many percents of video need to be watched to complete step */
  requiredCompletionPercentage?: InputMaybe<Scalars['Float']>;
};

export type WixOnlineprogramsStepsV3BulkCloneStepRequestInput = {
  /** id of program which was cloned */
  clonedProgramId?: InputMaybe<Scalars['String']>;
  /** mapping of original to cloned section ids */
  prototypeIdToClonedId?: InputMaybe<Scalars['JSON']>;
  /** id of program which was cloned */
  prototypeProgramId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3BulkCloneStepResponse = {
  __typename?: 'WixOnlineprogramsStepsV3BulkCloneStepResponse';
  /** ids of newly created steps */
  createdStepIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixOnlineprogramsStepsV3BulkCreateStepMigrationRequestInput = {
  /** Program in which steps are to be created. */
  programId?: InputMaybe<Scalars['String']>;
  /** List of steps you want to create */
  steps?: InputMaybe<Array<InputMaybe<WixOnlineprogramsStepsV3StepInput>>>;
};

export type WixOnlineprogramsStepsV3BulkCreateStepMigrationResponse = {
  __typename?: 'WixOnlineprogramsStepsV3BulkCreateStepMigrationResponse';
  /** Metadata about whole bulk action. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Results of bulk action. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsStepsV3BulkStepResult>>>;
};

export type WixOnlineprogramsStepsV3BulkCreateStepRequestInput = {
  /** Program id in which steps are to be created. */
  programId?: InputMaybe<Scalars['String']>;
  /** Whether to return entities in response or not. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** List of steps you want to create */
  steps?: InputMaybe<Array<InputMaybe<WixOnlineprogramsStepsV3StepInput>>>;
};

export type WixOnlineprogramsStepsV3BulkCreateStepResponse = {
  __typename?: 'WixOnlineprogramsStepsV3BulkCreateStepResponse';
  /** Metadata about whole bulk action. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Results of bulk action. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsStepsV3BulkStepResult>>>;
};

export type WixOnlineprogramsStepsV3BulkStepResult = {
  __typename?: 'WixOnlineprogramsStepsV3BulkStepResult';
  /** Action type of bulk action (INSERT OR UPDATE) for that endpoint. */
  action?: Maybe<WixCommonBulkActionType>;
  /** Item itself (empty if return_entity in request is false). */
  item?: Maybe<WixOnlineprogramsStepsV3Step>;
  /** Metadata of item. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixOnlineprogramsStepsV3CloneStepRequestInput = {
  /** what step to clone */
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3CloneStepResponse = {
  __typename?: 'WixOnlineprogramsStepsV3CloneStepResponse';
  /** created step. */
  step?: Maybe<WixOnlineprogramsStepsV3Step>;
};

export type WixOnlineprogramsStepsV3CreateStepRequestInput = {
  /** Program id in which step is to be created. */
  programId?: InputMaybe<Scalars['String']>;
  /** Step to be created. */
  step?: InputMaybe<WixOnlineprogramsStepsV3StepInput>;
};

export type WixOnlineprogramsStepsV3CreateStepResponse = {
  __typename?: 'WixOnlineprogramsStepsV3CreateStepResponse';
  /** The created Step. */
  step?: Maybe<WixOnlineprogramsStepsV3Step>;
};

export type WixOnlineprogramsStepsV3DeleteAllProgramStepsRequestInput = {
  /** Program id to delete steps from */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3DeleteAllProgramStepsResponse = {
  __typename?: 'WixOnlineprogramsStepsV3DeleteAllProgramStepsResponse';
  /** Count of steps that failed to be deleted */
  failedCount?: Maybe<Scalars['Int']>;
  /** Total count of steps in the program */
  stepsTotal?: Maybe<Scalars['Int']>;
  /** Count of successfully deleted steps */
  successfulCount?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsStepsV3DeleteStepRequestInput = {
  /** Id of the Step to delete. */
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3Description = {
  __typename?: 'WixOnlineprogramsStepsV3Description';
  details?: Maybe<Scalars['String']>;
  /** WixMedia image */
  image?: Maybe<WixCommonImage>;
  title?: Maybe<Scalars['String']>;
  /** WixMedia video */
  video?: Maybe<WixCommonVideoV2>;
};

export type WixOnlineprogramsStepsV3DescriptionInput = {
  details?: InputMaybe<Scalars['String']>;
  /** WixMedia image */
  image?: InputMaybe<WixCommonImageInput>;
  title?: InputMaybe<Scalars['String']>;
  /** WixMedia video */
  video?: InputMaybe<WixCommonVideoV2Input>;
};

export type WixOnlineprogramsStepsV3GetStepRequestInput = {
  /** Whenever to return description only with title or with details as well */
  descriptionFieldSet?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet>;
  id: Scalars['ID'];
};

export type WixOnlineprogramsStepsV3ListAllProgramStepsRequestInput = {
  /** Whenever to return description only with title or with details as well */
  descriptionFieldSet?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet>;
  /** program id of requested steps */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3ListAllProgramStepsResponse = {
  __typename?: 'WixOnlineprogramsStepsV3ListAllProgramStepsResponse';
  /** List of Steps. */
  steps?: Maybe<Array<Maybe<WixOnlineprogramsStepsV3Step>>>;
};

export type WixOnlineprogramsStepsV3MoveStepRequestInput = {
  /** insert after this step id (can be empty if it's the first position in the section) */
  afterStepId?: InputMaybe<Scalars['String']>;
  revision?: InputMaybe<Scalars['Long']>;
  /** target section (keep the same or move step to a different one) */
  sectionId?: InputMaybe<Scalars['String']>;
  /** what step to move */
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3MoveStepResponse = {
  __typename?: 'WixOnlineprogramsStepsV3MoveStepResponse';
  /** Moved step with updated ordering. */
  step?: Maybe<WixOnlineprogramsStepsV3Step>;
};

export type WixOnlineprogramsStepsV3QueryStepsRequestInput = {
  /** Whenever to return description only with title or with details as well */
  descriptionFieldSet?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet>;
  /** Program id to query steps */
  programId?: InputMaybe<Scalars['String']>;
  /** WQL expression. */
  query?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput>;
};

export type WixOnlineprogramsStepsV3QueryStepsResponse = {
  __typename?: 'WixOnlineprogramsStepsV3QueryStepsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixOnlineprogramsStepsV3Step>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixOnlineprogramsStepsV3QueryStepsWithoutPagingRequestInput = {
  /** Whenever to return description only with title or with details as well */
  descriptionFieldSet?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet>;
  /** Program id to query steps */
  programId?: InputMaybe<Scalars['String']>;
  /** WQL expression. Cursor paging is not supported in this endpoint. */
  query?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput>;
};

export type WixOnlineprogramsStepsV3QueryStepsWithoutPagingResponse = {
  __typename?: 'WixOnlineprogramsStepsV3QueryStepsWithoutPagingResponse';
  /** List of Steps. */
  steps?: Maybe<Array<Maybe<WixOnlineprogramsStepsV3Step>>>;
};

export type WixOnlineprogramsStepsV3Step = {
  __typename?: 'WixOnlineprogramsStepsV3Step';
  /** Represents the time this Task was created */
  createdDate?: Maybe<Scalars['String']>;
  /** title, description and media content. */
  description?: Maybe<WixOnlineprogramsStepsV3Description>;
  /** extensible field */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Program Task ID */
  id?: Maybe<Scalars['String']>;
  /** field for manual ordering of steps */
  ordering?: Maybe<Scalars['Float']>;
  /** id of the owning program. */
  programId?: Maybe<Scalars['String']>;
  /** options of quiz step. */
  quizOptions?: Maybe<WixOnlineprogramsStepsV3StepQuizOptions>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes by the server. for an update operation to succeed, you MUST pass the latest revision */
  revision?: Maybe<Scalars['Long']>;
  /** id of the owning section. */
  sectionId?: Maybe<Scalars['String']>;
  /** Content type of a step, can be article, quiz or video. */
  stepType?: Maybe<WixOnlineprogramsStepsV3StepStepType>;
  /** Represents the time this Task was last updated */
  updatedDate?: Maybe<Scalars['String']>;
  /** options of video step. */
  videoOptions?: Maybe<WixOnlineprogramsStepsV3StepVideoOptions>;
};

export type WixOnlineprogramsStepsV3StepInput = {
  /** Represents the time this Task was created */
  createdDate?: InputMaybe<Scalars['String']>;
  /** title, description and media content. */
  description?: InputMaybe<WixOnlineprogramsStepsV3DescriptionInput>;
  /** extensible field */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Program Task ID */
  id?: InputMaybe<Scalars['String']>;
  /** field for manual ordering of steps */
  ordering?: InputMaybe<Scalars['Float']>;
  /** id of the owning program. */
  programId?: InputMaybe<Scalars['String']>;
  /** options of quiz step. */
  quizOptions?: InputMaybe<WixOnlineprogramsStepsV3StepQuizOptionsInput>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes by the server. for an update operation to succeed, you MUST pass the latest revision */
  revision?: InputMaybe<Scalars['Long']>;
  /** id of the owning section. */
  sectionId?: InputMaybe<Scalars['String']>;
  /** Content type of a step, can be article, quiz or video. */
  stepType?: InputMaybe<WixOnlineprogramsStepsV3StepStepType>;
  /** Represents the time this Task was last updated */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** options of video step. */
  videoOptions?: InputMaybe<WixOnlineprogramsStepsV3StepVideoOptionsInput>;
};

export type WixOnlineprogramsStepsV3StepQuizOptions = {
  __typename?: 'WixOnlineprogramsStepsV3StepQuizOptions';
  /** quiz id */
  id?: Maybe<Scalars['String']>;
  /** percentage of right answers to complete the quiz. */
  passingGrade?: Maybe<Scalars['Float']>;
  /** number of questions inside the quiz */
  totalQuestions?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsStepsV3StepQuizOptionsInput = {
  /** quiz id */
  id?: InputMaybe<Scalars['String']>;
  /** percentage of right answers to complete the quiz. */
  passingGrade?: InputMaybe<Scalars['Float']>;
  /** number of questions inside the quiz */
  totalQuestions?: InputMaybe<Scalars['Int']>;
};

export enum WixOnlineprogramsStepsV3StepStepType {
  /** text-based step. */
  Article = 'ARTICLE',
  /** step containing quiz. */
  Quiz = 'QUIZ',
  /** step with video content. */
  Video = 'VIDEO'
}

export type WixOnlineprogramsStepsV3StepVideoOptions = {
  __typename?: 'WixOnlineprogramsStepsV3StepVideoOptions';
  /** Cover image of video. */
  coverImage?: Maybe<WixCommonImage>;
  /** Shows if video is deleted or not (only for videos uploaded via Media Manager). */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Duration of video in milliseconds. */
  durationInMilliseconds?: Maybe<Scalars['Int']>;
  /** How many percent you need to watch to complete step. */
  requiredCompletionPercentage?: Maybe<Scalars['Float']>;
  /** Video uploaded via Media Manager. */
  video?: Maybe<WixCommonVideoV2>;
  /** Video from Wix Video product. */
  wixVideo?: Maybe<WixOnlineprogramsStepsV3StepVideoOptionsWixVideo>;
};

export type WixOnlineprogramsStepsV3StepVideoOptionsInput = {
  /** Cover image of video. */
  coverImage?: InputMaybe<WixCommonImageInput>;
  /** Shows if video is deleted or not (only for videos uploaded via Media Manager). */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Duration of video in milliseconds. */
  durationInMilliseconds?: InputMaybe<Scalars['Int']>;
  /** How many percent you need to watch to complete step. */
  requiredCompletionPercentage?: InputMaybe<Scalars['Float']>;
  /** Video uploaded via Media Manager. */
  video?: InputMaybe<WixCommonVideoV2Input>;
  /** Video from Wix Video product. */
  wixVideo?: InputMaybe<WixOnlineprogramsStepsV3StepVideoOptionsWixVideoInput>;
};

export type WixOnlineprogramsStepsV3StepVideoOptionsWixVideo = {
  __typename?: 'WixOnlineprogramsStepsV3StepVideoOptionsWixVideo';
  /** Id of Wix Video. */
  id?: Maybe<Scalars['String']>;
  /** Is Wix Video paid or not. */
  paid?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsStepsV3StepVideoOptionsWixVideoInput = {
  /** Id of Wix Video. */
  id?: InputMaybe<Scalars['String']>;
  /** Is Wix Video paid or not. */
  paid?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsStepsV3UpdateStepRequestInput = {
  /**
   * Set of fields to update.
   *
   * Fields that aren't included in `fieldMask.paths` are ignored.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Step to be updated, may be partial. */
  step?: InputMaybe<WixOnlineprogramsStepsV3StepInput>;
};

export type WixOnlineprogramsStepsV3UpdateStepResponse = {
  __typename?: 'WixOnlineprogramsStepsV3UpdateStepResponse';
  /** Updated Step. */
  step?: Maybe<WixOnlineprogramsStepsV3Step>;
};

export type WixOnlineprogramsStepsV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export enum WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet {
  Extended = 'EXTENDED',
  Standard = 'STANDARD'
}

export type WixOrdersApiV2AppliedCouponInput = {
  /** Coupon code */
  code?: InputMaybe<Scalars['String']>;
  /** Coupon ID */
  couponId?: InputMaybe<Scalars['String']>;
  /** Coupon name */
  name?: InputMaybe<Scalars['String']>;
};

export type WixOrdersApiV2BillingInfoInput = {
  /** Deprecated (use paymentProviderTransactionId instead) */
  externalTransactionId?: InputMaybe<Scalars['String']>;
  /** Payment date */
  paidDate?: InputMaybe<Scalars['String']>;
  /** Transaction ID from payment gateway (e.g., Wix Payments) */
  paymentGatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Payment method used for this order */
  paymentMethod?: InputMaybe<Scalars['String']>;
  /** Transaction ID from payment provider (e.g., PayPal, Square, Stripe) transaction ID */
  paymentProviderTransactionId?: InputMaybe<Scalars['String']>;
  /** Whether order can be refunded by payment provider (manually or automatic) */
  refundableByPaymentProvider?: InputMaybe<Scalars['Boolean']>;
};

export type WixOrdersApiV2BuyerInfoInput = {
  /** Contact Id. needed for cases where the user is the buyer and so it doesn't exist on the buyer info */
  contactId?: InputMaybe<Scalars['String']>;
  /** Customer's email address */
  email?: InputMaybe<Scalars['String']>;
  /** Customer's first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Wix customer ID */
  id?: InputMaybe<Scalars['String']>;
  /** Customer type */
  identityType?: InputMaybe<WixOrdersApiV2IdentityType>;
  /** Customer's last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Customer's phone number */
  phone?: InputMaybe<Scalars['String']>;
  /** Deprecated (use identityType instead) */
  type?: InputMaybe<WixOrdersApiV2IdentityType>;
};

export enum WixOrdersApiV2FulfillmentStatus {
  /** Order is canceled */
  Canceled = 'CANCELED',
  /**
   * All of the order items are fulfilled
   * Orders without shipping info are fulfilled automatically
   */
  Fulfilled = 'FULFILLED',
  /** None of the order items are fulfilled */
  NotFulfilled = 'NOT_FULFILLED',
  /** Some, but not all of the order items are fulfilled */
  PartiallyFulfilled = 'PARTIALLY_FULFILLED'
}

export enum WixOrdersApiV2IdentityType {
  /** Contact */
  Contact = 'CONTACT',
  /** Site member */
  Member = 'MEMBER',
  UnspecifiedIdentityType = 'UNSPECIFIED_IDENTITY_TYPE'
}

export type WixOrdersApiV2OrderCreatedInput = {
  /** Applied coupon */
  appliedCoupon?: InputMaybe<WixOrdersApiV2AppliedCouponInput>;
  /** Order archive status */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Billing information. */
  billingInfo?: InputMaybe<WixOrdersApiV2BillingInfoInput>;
  /** Customer information */
  buyerInfo?: InputMaybe<WixOrdersApiV2BuyerInfoInput>;
  cartId?: InputMaybe<Scalars['String']>;
  /** Checkout id */
  checkoutId?: InputMaybe<Scalars['String']>;
  /** Currency used for pricing in this store */
  currency?: InputMaybe<Scalars['String']>;
  /** Order creation date */
  dateCreated?: InputMaybe<Scalars['String']>;
  /** Order fulfillment status */
  fulfillmentStatus?: InputMaybe<WixOrdersApiV2FulfillmentStatus>;
  /** ID displayed in the owner's store (auto generated) */
  number?: InputMaybe<Scalars['Int']>;
  /** Order ID (auto generated upon order creation) */
  orderId?: InputMaybe<Scalars['String']>;
  ordersExperiments?: InputMaybe<ComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput>;
  /** Order payment status */
  paymentStatus?: InputMaybe<WixOrdersApiV2PaymentStatus>;
  /** Whether the order was read by the store owner */
  read?: InputMaybe<Scalars['Boolean']>;
  /** Subscription information */
  subscriptionInfo?: InputMaybe<WixOrdersApiV2SubscriptionInfoInput>;
  /** Totals for order's line items */
  totals?: InputMaybe<WixOrdersApiV2TotalsInput>;
  /** Weight unit used in this store */
  weightUnit?: InputMaybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};

export enum WixOrdersApiV2PaymentStatus {
  /** Full order total price was refunded */
  FullyRefunded = 'FULLY_REFUNDED',
  /** Order is marked as not paid, and can be marked as paid later on. This is relevant for POS and offline orders */
  NotPaid = 'NOT_PAID',
  /** The order is marked as paid */
  Paid = 'PAID',
  /** At least one payment was received and approved, covering less than total price amount */
  PartiallyPaid = 'PARTIALLY_PAID',
  /** Order was refunded, refund amount less than order total price */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** Order is pending response from the payment provider */
  Pending = 'PENDING',
  /** Payment status can't be classified, due to an error */
  UnspecifiedPaymentStatus = 'UNSPECIFIED_PAYMENT_STATUS'
}

export type WixOrdersApiV2SubscriptionInfoInput = {
  /** Current cycle number. For example, if the subscription is in the 3rd month of a 4-month subscription, the value will be `3`. */
  cycleNumber?: InputMaybe<Scalars['Int']>;
  /** Subscription ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Subscription options info. */
  subscriptionOptionInfo?: InputMaybe<WixOrdersApiV2SubscriptionOptionInfoInput>;
  /** Subscription settings. */
  subscriptionSettings?: InputMaybe<WixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput>;
};

export type WixOrdersApiV2SubscriptionOptionInfoInput = {
  /** Subscription option description. */
  description?: InputMaybe<Scalars['String']>;
  /** Subscription option ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Subscription option title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixOrdersApiV2TotalsInput = {
  /** Total calculated discount value. */
  discount?: InputMaybe<Scalars['String']>;
  /** Total calculated gift card value. */
  giftCard?: InputMaybe<Scalars['String']>;
  /** Total number of line items. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Total refund. */
  refund?: InputMaybe<Scalars['String']>;
  /** Total shipping price, before tax. */
  shipping?: InputMaybe<Scalars['String']>;
  /** Subtotal of all the line items, before tax. */
  subtotal?: InputMaybe<Scalars['String']>;
  /** Total tax. */
  tax?: InputMaybe<Scalars['String']>;
  /** Total price charged. */
  total?: InputMaybe<Scalars['String']>;
  /** Total items weight. */
  weight?: InputMaybe<Scalars['String']>;
};

export enum WixPaymentApiPayV2SubscriptionFrequency {
  Day = 'DAY',
  Month = 'MONTH',
  Undefined = 'UNDEFINED',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type WixPaymentApiPayV3AccountInfoInput = {
  /** The email of an Account used by Payment Method */
  email?: InputMaybe<Scalars['String']>;
};

export type WixPaymentApiPayV3CreditCardPaymentMethodDataInput = {
  /** Card expiration month. */
  expiryMonth?: InputMaybe<Scalars['String']>;
  /** Card holder's full name specified on the card. */
  holderName?: InputMaybe<Scalars['String']>;
  /** Card last 4 digits. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
  /** Card number with only bin and last4 positions showed (non-PCI data) */
  maskedCreditCard?: InputMaybe<Scalars['String']>;
  /** Card issuing network */
  network?: InputMaybe<Scalars['String']>;
};

export type WixPaymentApiPayV3CurrencyAmountInput = {
  /** Amount */
  amount?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<Scalars['String']>;
};

export type WixPaymentApiPayV3OrderAdditionalChargesInput = {
  /** Application fee */
  applicationFee?: InputMaybe<Scalars['Float']>;
  /** Discount amount applied to the order */
  discount?: InputMaybe<Scalars['Float']>;
  /** Shipping cost charged to the order */
  shipping?: InputMaybe<Scalars['Float']>;
  /** Absolute taxes charged to the order */
  tax?: InputMaybe<Scalars['Float']>;
};

export type WixPaymentApiPayV3OrderInput = {
  /** Additional charges to the order - e.g., tax, shipping or discount (optional) */
  additionalCharges?: InputMaybe<WixPaymentApiPayV3OrderAdditionalChargesInput>;
  /** Order creation date */
  createdAt?: InputMaybe<Scalars['String']>;
  externalData?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  /** Items included in the order */
  items?: InputMaybe<Array<InputMaybe<WixPaymentApiPayV3OrderItemInput>>>;
  /**
   * total number of items in order
   * items_total_count > `items`.size if `items` doesn't contain all items
   */
  itemsTotalCount?: InputMaybe<Scalars['Int']>;
  /** Customer's shipping address (optional) */
  shippingAddress?: InputMaybe<WixCommonAddressInput>;
  /** Customer's shipping address details (optional) */
  shippingAddressContacts?: InputMaybe<WixCommonFullAddressContactDetailsInput>;
  /** Wix app buyer ID */
  wixAppBuyerId?: InputMaybe<Scalars['String']>;
  /** Wix app order ID */
  wixAppOrderId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentApiPayV3OrderItemInput = {
  /** Whether the item is a physical a digital product */
  category?: InputMaybe<WixPaymentApiPayV3OrderItemOrderItemCategory>;
  /** Order item description */
  description?: InputMaybe<Scalars['String']>;
  /** Order item ID (required) */
  id?: InputMaybe<Scalars['String']>;
  /** Order item name (required) */
  name?: InputMaybe<Scalars['String']>;
  /** Total price charged for this item in the order - quantity * price (required) */
  price?: InputMaybe<Scalars['Float']>;
  /** Quantity (required) */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Weight of one item */
  weightInKg?: InputMaybe<Scalars['Float']>;
};

export enum WixPaymentApiPayV3OrderItemOrderItemCategory {
  /** Digital product */
  Digital = 'DIGITAL',
  /** Physical product */
  Physical = 'PHYSICAL',
  Undefined = 'UNDEFINED'
}

export enum WixPaymentApiPayV3PaymentEventEventType {
  RecurringPaymentStatusChanged = 'RECURRING_PAYMENT_STATUS_CHANGED',
  RefundStatusChanged = 'REFUND_STATUS_CHANGED',
  TransactionCreated = 'TRANSACTION_CREATED',
  TransactionStatusChanged = 'TRANSACTION_STATUS_CHANGED',
  TransactionUpdated = 'TRANSACTION_UPDATED',
  Undefined = 'UNDEFINED'
}

export type WixPaymentApiPayV3PaymentEventInput = {
  /** Event timestamp */
  eventTime?: InputMaybe<Scalars['String']>;
  /** Event type. */
  eventType?: InputMaybe<WixPaymentApiPayV3PaymentEventEventType>;
  /** Unique event ID. */
  id?: InputMaybe<Scalars['String']>;
  /** ID of Wix app that mediated between Wix Payments and the Wix app that triggered the event (if relevant). */
  managingWixAppId?: InputMaybe<Scalars['String']>;
  recurringPaymentStatusChangedEvent?: InputMaybe<WixPaymentApiPayV3RecurringPaymentStatusChangedEventInput>;
  refundStatusChangedEvent?: InputMaybe<WixPaymentApiPayV3RefundStatusChangedEventInput>;
  transactionCreatedEvent?: InputMaybe<WixPaymentApiPayV3TransactionCreatedEventInput>;
  transactionStatusChangedEvent?: InputMaybe<WixPaymentApiPayV3TransactionStatusChangedEventInput>;
  transactionUpdatedEvent?: InputMaybe<WixPaymentApiPayV3TransactionUpdatedEventInput>;
  /** ID of the [Wix app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) that triggered this event. */
  wixAppId?: InputMaybe<Scalars['String']>;
  /** Unique ID assigned to each Wix app in each site. */
  wixAppInstanceId?: InputMaybe<Scalars['String']>;
};

export enum WixPaymentApiPayV3RecurringPaymentCancellationDetailsInitiator {
  Buyer = 'BUYER',
  Merchant = 'MERCHANT',
  Payment = 'PAYMENT',
  Setup = 'SETUP',
  Undefined = 'UNDEFINED'
}

export type WixPaymentApiPayV3RecurringPaymentCancellationDetailsInput = {
  /** Initiator of cancellation */
  initiator?: InputMaybe<WixPaymentApiPayV3RecurringPaymentCancellationDetailsInitiator>;
  /** Successfully paid recurring cycles count before the cancellation */
  paidRegularCycleCount?: InputMaybe<Scalars['Int']>;
};

export type WixPaymentApiPayV3RecurringPaymentDetailsInput = {
  /** Current cycle number (Recurring payments only) */
  cycleNumber?: InputMaybe<Scalars['Int']>;
};

export type WixPaymentApiPayV3RecurringPaymentStatusChangedEventInput = {
  /** Details of RecurringPayment cancellation (empty if `status` is not CANCELLED). */
  cancellationDetails?: InputMaybe<WixPaymentApiPayV3RecurringPaymentCancellationDetailsInput>;
  /** Order details(limited to 30 items). */
  order?: InputMaybe<WixPaymentApiPayV3OrderInput>;
  /** Previous recurring payment status. */
  previousStatus?: InputMaybe<WixPaymentApiPayV3RecurringPaymentStatusStatus>;
  /** Recurring payment status. */
  status?: InputMaybe<WixPaymentApiPayV3RecurringPaymentStatusStatus>;
};

export enum WixPaymentApiPayV3RecurringPaymentStatusStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED',
  Undefined = 'UNDEFINED'
}

export type WixPaymentApiPayV3RefundInput = {
  /** Amount and currency of refund */
  amount?: InputMaybe<WixPaymentApiPayV3CurrencyAmountInput>;
  /** Refund creation date */
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** Reason provided for status change */
  reasonCode?: InputMaybe<Scalars['String']>;
  /** Updated refund status */
  status?: InputMaybe<WixPaymentApiPayV3RefundRefundStatus>;
};

export enum WixPaymentApiPayV3RefundRefundStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Undefined = 'UNDEFINED'
}

export type WixPaymentApiPayV3RefundStatusChangedEventInput = {
  /** Order details (limited to 30 items). */
  order?: InputMaybe<WixPaymentApiPayV3OrderInput>;
  /** Previous refund status. */
  previousStatus?: InputMaybe<WixPaymentApiPayV3RefundRefundStatus>;
  /** Updated refund details. */
  refund?: InputMaybe<WixPaymentApiPayV3RefundInput>;
  /** Updated transaction details. */
  transaction?: InputMaybe<WixPaymentApiPayV3TransactionInput>;
};

export type WixPaymentApiPayV3ScheduledActionInput = {
  /** the date and time of the action */
  executionDate?: InputMaybe<Scalars['String']>;
  /** type of the action */
  type?: InputMaybe<WixPaymentApiPayV3ScheduledActionScheduledActionType>;
};

export enum WixPaymentApiPayV3ScheduledActionScheduledActionType {
  Capture = 'CAPTURE',
  Void = 'VOID'
}

export type WixPaymentApiPayV3TransactionCreatedEventInput = {
  /** Order details (limited to 30 items). */
  order?: InputMaybe<WixPaymentApiPayV3OrderInput>;
  /** Updated transaction details. */
  transaction?: InputMaybe<WixPaymentApiPayV3TransactionInput>;
};

export type WixPaymentApiPayV3TransactionInput = {
  /** Amount and currency of transaction */
  amount?: InputMaybe<WixPaymentApiPayV3CurrencyAmountInput>;
  /** Customer's billing address (optional) */
  billingAddress?: InputMaybe<WixCommonAddressInput>;
  /** Customer's billing address - contact details (optional) */
  billingAddressContacts?: InputMaybe<WixCommonFullAddressContactDetailsInput>;
  /** Transaction creation date */
  createdAt?: InputMaybe<Scalars['String']>;
  creditCardPaymentMethodData?: InputMaybe<WixPaymentApiPayV3CreditCardPaymentMethodDataInput>;
  /** Transaction ID */
  id?: InputMaybe<Scalars['String']>;
  /** Total number of installments */
  installments?: InputMaybe<Scalars['Int']>;
  /** Payment method */
  paymentMethod?: InputMaybe<Scalars['String']>;
  /** The details of a payment method account. */
  paymentMethodAccountInfo?: InputMaybe<WixPaymentApiPayV3AccountInfoInput>;
  /** Payment service provider */
  paymentProvider?: InputMaybe<Scalars['String']>;
  /** Provider transaction ID */
  providerTransactionId?: InputMaybe<Scalars['String']>;
  /** Reason provided for status change */
  reasonCode?: InputMaybe<Scalars['String']>;
  /** Details of subscription, which (if) the transaction is a part of */
  recurringPaymentDetails?: InputMaybe<WixPaymentApiPayV3RecurringPaymentDetailsInput>;
  /** Refunded amount and currency of transaction */
  refundedAmount?: InputMaybe<WixPaymentApiPayV3CurrencyAmountInput>;
  /** Scheduled action for this transaction */
  scheduledAction?: InputMaybe<WixPaymentApiPayV3ScheduledActionInput>;
  /** Updated transaction status */
  status?: InputMaybe<WixPaymentApiPayV3TransactionTransactionStatus>;
  /** order id associated with the transaction on the vertical side */
  verticalOrderId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentApiPayV3TransactionStatusChangedEventInput = {
  /** Order details (limited to 30 items). */
  order?: InputMaybe<WixPaymentApiPayV3OrderInput>;
  /** Previous transaction status. */
  previousStatus?: InputMaybe<WixPaymentApiPayV3TransactionTransactionStatus>;
  /** New transaction details. */
  transaction?: InputMaybe<WixPaymentApiPayV3TransactionInput>;
};

export enum WixPaymentApiPayV3TransactionTransactionStatus {
  Approved = 'APPROVED',
  Authorized = 'AUTHORIZED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  PendingMerchant = 'PENDING_MERCHANT',
  Refunded = 'REFUNDED',
  Undefined = 'UNDEFINED',
  Voided = 'VOIDED'
}

export type WixPaymentApiPayV3TransactionUpdatedEventInput = {
  /** Order details (limited to 30 items). */
  order?: InputMaybe<WixPaymentApiPayV3OrderInput>;
  /** Updated transaction details. */
  transaction?: InputMaybe<WixPaymentApiPayV3TransactionInput>;
  /** Is event triggered by request to clean user data */
  triggeredByAnonymizeRequest?: InputMaybe<Scalars['Boolean']>;
};

export type WixPaymentsPaymentAgreementsV1CreatePaymentAgreementRequestInput = {
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in RequestedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1RequestedFields>>>;
  /** Idempotency key. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** PaymentAgreement to be created. */
  paymentAgreement?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementInput>;
  /** Temporary token of credit card tokenized by Wix. This token is used to create a persistent token */
  temporaryCardToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1CreatePaymentAgreementResponse = {
  __typename?: 'WixPaymentsPaymentAgreementsV1CreatePaymentAgreementResponse';
  /** The created PaymentAgreement. */
  paymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreement>;
};

export type WixPaymentsPaymentAgreementsV1DeletePaymentAgreementRequestInput = {
  /** Id of the PaymentAgreement to delete. */
  paymentAgreementId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1FinalizePaymentAgreementRequestInput = {
  /** Payment agreement ID. */
  paymentAgreementId?: InputMaybe<Scalars['String']>;
  /** Meta-site ID. */
  siteId?: InputMaybe<Scalars['String']>;
  /**
   * Temporary token for the payment agreement finalization,
   * by default temporary token is taken from the payment agreement.
   */
  temporaryToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1GetPaymentAgreementRequestInput = {
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in RequestedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1RequestedFields>>>;
  id: Scalars['ID'];
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreement = {
  __typename?: 'WixPaymentsPaymentAgreementsV1PaymentAgreement';
  /** Billing address of the PaymentAgreement's owner. */
  billingAddress?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddress>;
  /** The ID of a Charge if it was an origin of this PaymentAgreement. */
  chargeId?: Maybe<Scalars['String']>;
  /** Date and time the PaymentAgreement was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  id?: Maybe<Scalars['String']>;
  /** Indicates whether the PaymentAgreement was created by a Merchant during MOTO payment or by a customer. */
  merchantCreated?: Maybe<Scalars['Boolean']>;
  /** PaymentAgreement's owner identities. */
  owner?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementOwner>;
  /** The ID of a Payment Intent if it was an origin of this PaymentAgreement. */
  paymentIntentId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethod>;
  /**
   * Payment service provider ID that was used to create a PaymentAgreement.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  providerId?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the PaymentAgreement is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the PaymentAgreement.
   *
   * Ignored when creating a PaymentAgreement.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * Indicates whether the PaymentAgreement is in sandbox mode.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  sandbox?: Maybe<Scalars['Boolean']>;
  /**
   * Saved payment method which is used to charge customer within a PaymentAgreement.
   * Empty when PaymentAgreement was created without creation of a SavedPaymentMethod, e.g. the Recurring Setup flow
   */
  savedPaymentMethodId?: Maybe<Scalars['String']>;
  sensitiveInfo?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfo>;
  /** Date and time the PaymentAgreement was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfo = {
  __typename?: 'WixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfo';
  /** Country code as 2 letters ISO-3166-1 */
  countryCode?: Maybe<Scalars['String']>;
  /** The email of an Account used by Payment Method */
  email?: Maybe<Scalars['String']>;
  /** International bank account number. */
  iban?: Maybe<Scalars['String']>;
  /** Owner name associated with the account. */
  ownerName?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfoInput = {
  /** Country code as 2 letters ISO-3166-1 */
  countryCode?: InputMaybe<Scalars['String']>;
  /** The email of an Account used by Payment Method */
  email?: InputMaybe<Scalars['String']>;
  /** International bank account number. */
  iban?: InputMaybe<Scalars['String']>;
  /** Owner name associated with the account. */
  ownerName?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddress = {
  __typename?: 'WixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddress';
  /** todo: remove unused fields from decomposition and remove validations */
  address?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddress>;
  /** todo: remove unused fields from decomposition and remove validations */
  contactDetails?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetails>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddressInput = {
  /** todo: remove unused fields from decomposition and remove validations */
  address?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressInput>;
  /** todo: remove unused fields from decomposition and remove validations */
  contactDetails?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetailsInput>;
};

export enum WixPaymentsPaymentAgreementsV1PaymentAgreementCardBrandEnumCardBrand {
  Amex = 'AMEX',
  Dankort = 'DANKORT',
  Diners = 'DINERS',
  Discover = 'DISCOVER',
  Isracard = 'ISRACARD',
  Jcb = 'JCB',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Rupay = 'RUPAY',
  Unionpay = 'UNIONPAY',
  UnknownCardBrand = 'UNKNOWN_CARD_BRAND',
  Visa = 'VISA'
}

export type WixPaymentsPaymentAgreementsV1PaymentAgreementCardInfo = {
  __typename?: 'WixPaymentsPaymentAgreementsV1PaymentAgreementCardInfo';
  /** Card BIN (Bank Identification Number). It's the first 4-8 digits of a card number. */
  bin?: Maybe<Scalars['String']>;
  /**
   * Card brand.
   * *INTERNAL* as it's not platformized yet.
   */
  brand?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementCardBrandEnumCardBrand>;
  /** Card holder's full name specified on the card. */
  cardholderName?: Maybe<Scalars['String']>;
  /** Card expiration month. */
  expirationMonth?: Maybe<Scalars['Int']>;
  /** Card expiration year. */
  expirationYear?: Maybe<Scalars['Int']>;
  /** Card last 4 digits. */
  lastFourDigits?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementCardInfoInput = {
  /** Card BIN (Bank Identification Number). It's the first 4-8 digits of a card number. */
  bin?: InputMaybe<Scalars['String']>;
  /**
   * Card brand.
   * *INTERNAL* as it's not platformized yet.
   */
  brand?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementCardBrandEnumCardBrand>;
  /** Card holder's full name specified on the card. */
  cardholderName?: InputMaybe<Scalars['String']>;
  /** Card expiration month. */
  expirationMonth?: InputMaybe<Scalars['Int']>;
  /** Card expiration year. */
  expirationYear?: InputMaybe<Scalars['Int']>;
  /** Card last 4 digits. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementInput = {
  /** Billing address of the PaymentAgreement's owner. */
  billingAddress?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddressInput>;
  /** The ID of a Charge if it was an origin of this PaymentAgreement. */
  chargeId?: InputMaybe<Scalars['String']>;
  /** Date and time the PaymentAgreement was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  id?: InputMaybe<Scalars['String']>;
  /** Indicates whether the PaymentAgreement was created by a Merchant during MOTO payment or by a customer. */
  merchantCreated?: InputMaybe<Scalars['Boolean']>;
  /** PaymentAgreement's owner identities. */
  owner?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementOwnerInput>;
  /** The ID of a Payment Intent if it was an origin of this PaymentAgreement. */
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethodInput>;
  /**
   * Payment service provider ID that was used to create a PaymentAgreement.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  providerId?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the PaymentAgreement is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the PaymentAgreement.
   *
   * Ignored when creating a PaymentAgreement.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Indicates whether the PaymentAgreement is in sandbox mode.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  sandbox?: InputMaybe<Scalars['Boolean']>;
  /**
   * Saved payment method which is used to charge customer within a PaymentAgreement.
   * Empty when PaymentAgreement was created without creation of a SavedPaymentMethod, e.g. the Recurring Setup flow
   */
  savedPaymentMethodId?: InputMaybe<Scalars['String']>;
  sensitiveInfo?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfoInput>;
  /** Date and time the PaymentAgreement was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReference = {
  __typename?: 'WixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReference';
  /** Transaction ID assigned by 3D Secure 2 directory server. */
  dsTransactionId?: Maybe<Scalars['String']>;
  /** Transaction ID assigned by a card scheme (Trace ID for Mastercard or Transaction ID for Visa). */
  networkTransactionId?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReferenceInput = {
  /** Transaction ID assigned by 3D Secure 2 directory server. */
  dsTransactionId?: InputMaybe<Scalars['String']>;
  /** Transaction ID assigned by a card scheme (Trace ID for Mastercard or Transaction ID for Visa). */
  networkTransactionId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementOwner = {
  __typename?: 'WixPaymentsPaymentAgreementsV1PaymentAgreementOwner';
  contactId?: Maybe<Scalars['String']>;
  siteMemberId?: Maybe<Scalars['String']>;
  siteVisitorId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementOwnerInput = {
  contactId?: InputMaybe<Scalars['String']>;
  siteMemberId?: InputMaybe<Scalars['String']>;
  siteVisitorId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethod = {
  __typename?: 'WixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethod';
  /** The details of an account. */
  accountInfo?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfo>;
  /** The details of a card. */
  cardInfo?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementCardInfo>;
  /** Payment method type id. Supported values are `creditCard`, `payPal`, `applePay`. */
  typeId?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethodInput = {
  /** The details of an account. */
  accountInfo?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfoInput>;
  /** The details of a card. */
  cardInfo?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementCardInfoInput>;
  /** Payment method type id. Supported values are `creditCard`, `payPal`, `applePay`. */
  typeId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfo = {
  __typename?: 'WixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfo';
  /**
   * Merchant credentials of payment provider that was used to create a payment agreement.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  merchantCredentials?: Maybe<Scalars['String']>;
  /** Transaction reference provided by a payment network. */
  networkReference?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReference>;
  /**
   * Token of Card which is stored in PCI environment
   * Intended to generate a new instance of temporary Card token for payments by this Payment Agreement
   */
  persistentCardToken?: Maybe<Scalars['String']>;
  /** Tokens that are used to reference a payment agreement in external payment provider. */
  providerToken?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfoInput = {
  /**
   * Merchant credentials of payment provider that was used to create a payment agreement.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  merchantCredentials?: InputMaybe<Scalars['String']>;
  /** Transaction reference provided by a payment network. */
  networkReference?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReferenceInput>;
  /**
   * Token of Card which is stored in PCI environment
   * Intended to generate a new instance of temporary Card token for payments by this Payment Agreement
   */
  persistentCardToken?: InputMaybe<Scalars['String']>;
  /** Tokens that are used to reference a payment agreement in external payment provider. */
  providerToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1QueryPaymentAgreementsRequestInput = {
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in RequestedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1RequestedFields>>>;
  /** WQL expression. */
  query?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixQueryCursorQueryInput>;
};

export type WixPaymentsPaymentAgreementsV1QueryPaymentAgreementsResponse = {
  __typename?: 'WixPaymentsPaymentAgreementsV1QueryPaymentAgreementsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreement>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixPaymentsPaymentAgreementsV1RequestedFields {
  SensitiveInfo = 'SENSITIVE_INFO',
  /** Default value. This value is unused. */
  UnknownRequestedField = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixPaymentsPaymentAgreementsV1UpdateExtendedFieldsRequestInput = {
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in RequestedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1RequestedFields>>>;
  /** ID of the PaymentAgreement to update. */
  id?: InputMaybe<Scalars['String']>;
  /** Identifier for the app whose extended fields are being updated. */
  namespace?: InputMaybe<Scalars['String']>;
  /** Data to update. Structured according to the [schema](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields#json-schema-for-extended-fields) defined when the extended fields were configured. */
  namespaceData?: InputMaybe<Scalars['JSON']>;
};

export type WixPaymentsPaymentAgreementsV1UpdateExtendedFieldsResponse = {
  __typename?: 'WixPaymentsPaymentAgreementsV1UpdateExtendedFieldsResponse';
  /** Updated PaymentAgreement. */
  paymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreement>;
};

export type WixPaymentsPaymentAgreementsV1UpdatePaymentAgreementRequestInput = {
  /**
   * Set of fields to update.
   *
   * Fields that aren't included in `fieldMask.paths` are ignored.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in RequestedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1RequestedFields>>>;
  /** PaymentAgreement to be updated, may be partial. */
  paymentAgreement?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementInput>;
};

export type WixPaymentsPaymentAgreementsV1UpdatePaymentAgreementResponse = {
  __typename?: 'WixPaymentsPaymentAgreementsV1UpdatePaymentAgreementResponse';
  /** Updated PaymentAgreement. */
  paymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreement>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddress = {
  __typename?: 'WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddress';
  /** Main address line, usually street and number as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Country code. */
  country?: Maybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: Maybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocation>;
  /** Free text to help find the address. */
  hint?: Maybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddress>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  subdivision?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: Maybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: Maybe<Array<Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivision>>>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressInput = {
  /** Main address line, usually street and number as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Country code. */
  country?: InputMaybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocationInput>;
  /** Free text to help find the address. */
  hint?: InputMaybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddressInput>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: InputMaybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionInput>>>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocation = {
  __typename?: 'WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocation';
  /** Address latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocationInput = {
  /** Address latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetails = {
  __typename?: 'WixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetails';
  /** Contact's company name. */
  company?: Maybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: Maybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: Maybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: Maybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: Maybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: Maybe<Scalars['String']>;
  /** Tax info. Currently usable only in Brazil. */
  vatId?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatId>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetailsInput = {
  /** Contact's company name. */
  company?: InputMaybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: InputMaybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Tax info. Currently usable only in Brazil. */
  vatId?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatIdInput>;
};

export enum WixPaymentsPaymentAgreementsV1UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSortOrder>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddress = {
  __typename?: 'WixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddress';
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivision = {
  __typename?: 'WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivision';
  /** Short subdivision code. */
  code?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: Maybe<Scalars['String']>;
  /** Subdivision level */
  type?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionInput = {
  /** Short subdivision code. */
  code?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: InputMaybe<Scalars['String']>;
  /** Subdivision level */
  type?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: InputMaybe<Scalars['String']>;
};

export enum WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionSubdivisionType {
  /** State */
  AdministrativeAreaLevel_1 = 'ADMINISTRATIVE_AREA_LEVEL_1',
  /** County */
  AdministrativeAreaLevel_2 = 'ADMINISTRATIVE_AREA_LEVEL_2',
  /** City/town */
  AdministrativeAreaLevel_3 = 'ADMINISTRATIVE_AREA_LEVEL_3',
  /** Neighborhood/quarter */
  AdministrativeAreaLevel_4 = 'ADMINISTRATIVE_AREA_LEVEL_4',
  /** Street/block */
  AdministrativeAreaLevel_5 = 'ADMINISTRATIVE_AREA_LEVEL_5',
  /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
  Country = 'COUNTRY',
  UnknownSubdivisionType = 'UNKNOWN_SUBDIVISION_TYPE'
}

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatId = {
  __typename?: 'WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatId';
  /** Customer's tax ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatType>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatIdInput = {
  /** Customer's tax ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatType>;
};

export enum WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatType {
  /** CNPJ - for corporations */
  Cnpj = 'CNPJ',
  /** CPF - for individual tax payers. */
  Cpf = 'CPF',
  Unspecified = 'UNSPECIFIED'
}

export type WixPaymentsPaymentAgreementsV1UpstreamWixQueryCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSortingInput>>>;
};

export type WixPaymentsRefundsV1CreateRefundRequestInput = {
  /**
   * Amount of the charge that was previously refunded.
   *
   * Specify this to compare your records of previously refunded amounts against those on the server. If they don't match, this method will return an error with the code `PREVIOUSLY_REFUNDED_AMOUNT_MISMATCH`.
   *
   * Learn more about [preventing unintended refunds](https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#preventing-unintended-refunds).
   */
  previouslyRefundedAmount?: InputMaybe<Scalars['String']>;
  /** Refund to be created. */
  refund?: InputMaybe<WixPaymentsRefundsV1RefundInput>;
  /**
   * _INTERNAL_
   * True means processing fee for the refunded charge should be returned to the merchant.
   * Applies only to Wix Payments charges.
   * `PAYMENTS.REFUND_RETURN_PROCESSING_FEE` permission is required.
   */
  returnProcessingFee?: InputMaybe<Scalars['Boolean']>;
};

export type WixPaymentsRefundsV1CreateRefundResponse = {
  __typename?: 'WixPaymentsRefundsV1CreateRefundResponse';
  /** The created refund. */
  refund?: Maybe<WixPaymentsRefundsV1Refund>;
};

export type WixPaymentsRefundsV1GetRefundRequestInput = {
  id: Scalars['ID'];
};

export type WixPaymentsRefundsV1GetRefundabilityRequestInput = {
  /** ID of the charge to calculate refundability for. */
  chargeId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsRefundsV1GetRefundabilityResponse = {
  __typename?: 'WixPaymentsRefundsV1GetRefundabilityResponse';
  /** Refundability of the charge. */
  refundability?: Maybe<WixPaymentsRefundsV1Refundability>;
};

export type WixPaymentsRefundsV1InternalSyncRefundRequestInput = {
  /** Unique number assigned to a refund. This number is shared across all parties involved in processing the refund. It allows the merchant to track the refund with their bank. */
  acquirerReferenceNumber?: InputMaybe<Scalars['String']>;
  /**
   * Amount of refund in base units, what's returned to the buyer.
   * E.g. "12.95".
   */
  amount?: InputMaybe<Scalars['String']>;
  /** ID of charge for which the funds are returned by this refund. */
  chargeId?: InputMaybe<Scalars['String']>;
  /** Currency of refund, should be the same as currency of charge. */
  currency?: InputMaybe<Scalars['String']>;
  /** Currency of refund, should be the same as currency of charge. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Optional free-text note about this refund. */
  note?: InputMaybe<Scalars['String']>;
  /** ID of the refund on the PSP side. */
  providerRefundId?: InputMaybe<Scalars['String']>;
  /** Reason why this refund was issued. */
  reason?: InputMaybe<Scalars['String']>;
  /** Refund ID. */
  refundId?: InputMaybe<Scalars['String']>;
  /**
   * Application fee returned to merchant from Wix.
   * Having this as a separate field since Refund.returned_application_fee is readOnly.
   */
  returnedApplicationFee?: InputMaybe<Scalars['String']>;
  /**
   * Processing fee returned to merchant from Wix.
   * Having this as a separate field since Refund.returned_processing_fee is readOnly.
   */
  returnedProcessingFee?: InputMaybe<Scalars['String']>;
  /**
   * Status of the refund.
   * Read more about statuses in this [article](<https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#lifecycle-of-a-refund>).
   */
  status?: InputMaybe<WixPaymentsRefundsV1RefundStatus>;
  /**
   * Status code.
   * [Read more about reason codes.](https://dev.wix.com/docs/rest/api-reference/payment-provider-spi/reason-codes)
   */
  statusCode?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsRefundsV1InternalSyncRefundResponse = {
  __typename?: 'WixPaymentsRefundsV1InternalSyncRefundResponse';
  /** Created/updated refund. */
  refund?: Maybe<WixPaymentsRefundsV1Refund>;
};

export type WixPaymentsRefundsV1QueryRefundsRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixPaymentsRefundsV1UpstreamWixQueryCursorQueryInput>;
};

export type WixPaymentsRefundsV1QueryRefundsResponse = {
  __typename?: 'WixPaymentsRefundsV1QueryRefundsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixPaymentsRefundsV1Refund>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixPaymentsRefundsV1Refund = {
  __typename?: 'WixPaymentsRefundsV1Refund';
  /** Unique number assigned to a refund. This number is shared across all parties involved in processing the refund. It allows the merchant to track the refund with their bank. */
  acquirerReferenceNumber?: Maybe<Scalars['String']>;
  /**
   * Amount being returned to the buyer in the refund currency's main units (such as dollars or euros).
   * For example, `"12.95"`.
   */
  amount?: Maybe<Scalars['String']>;
  /** ID of the charge to refund. */
  chargeId?: Maybe<Scalars['String']>;
  /** Date and time the refund was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#coordinated_Universal_Time_(UTC)) format. For example, "2024-01-30T13:30:00". */
  createdDate?: Maybe<Scalars['String']>;
  /** Refund currency. Should be the same as the charge currency. */
  currency?: Maybe<Scalars['String']>;
  /** Refund currency. Should be the same as the charge currency. */
  currencyCode?: Maybe<Scalars['String']>;
  /**
   * Custom field data for the refund object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Whether the refund is for the entire amount of the charge. */
  full?: Maybe<Scalars['Boolean']>;
  /** Refund ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * _INTERNAL_
   * Who initiated this refund. Setting this field requires PAYMENTS.REFUND_SET_INITIATOR permission.
   */
  initiator?: Maybe<WixPaymentsRefundsV1RefundInitiator>;
  /** Note providing additional information about this refund. */
  note?: Maybe<Scalars['String']>;
  /** Payment service provider's ID for the refund. */
  providerRefundId?: Maybe<Scalars['String']>;
  /** Reason this refund was issued. */
  reason?: Maybe<Scalars['String']>;
  /**
   * Application fee returned to the merchant from Wix in the refund currency's main units (such as dollars or euros). For example, `"12.95"`.
   *
   * Only included if an application fee was returned.
   */
  returnedApplicationFee?: Maybe<Scalars['String']>;
  /**
   * Processing fee returned to the merchant from the payment service provider in the refund currency's main units (such as dollars or euros). For example, `"12.95"`.
   *
   * This field is empty when the processing fee is unknown.
   */
  returnedProcessingFee?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the refund is updated.
   *
   * Ignored when creating a refund.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * Status of the refund.
   *
   * Learn more about the [refund lifecycle](https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#lifecycle-of-a-refund>).
   */
  status?: Maybe<WixPaymentsRefundsV1RefundStatus>;
  /**
   * Details about the refund status.
   * Used to provide additional information about why a refund was given its status.
   */
  statusInfo?: Maybe<WixPaymentsRefundsV1StatusInfo>;
  /** Date and time the refund was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#coordinated_Universal_Time_(UTC)) format. For example, "2024-01-30T13:30:00". */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixPaymentsRefundsV1RefundDetails = {
  __typename?: 'WixPaymentsRefundsV1RefundDetails';
  /** Maximum allowed refund amount in the refund currency's main units (such as dollars or euros). For example, `"12.95"`. */
  maxRefundAmount?: Maybe<Scalars['String']>;
  /** Minimum allowed refund amount in the refund currency's main units (such as dollars or euros). For example, `"0.50"`. */
  minRefundAmount?: Maybe<Scalars['String']>;
};

export enum WixPaymentsRefundsV1RefundInitiator {
  Api = 'API',
  Provider = 'PROVIDER',
  UnknownInitiator = 'UNKNOWN_INITIATOR',
  Wix = 'WIX'
}

export type WixPaymentsRefundsV1RefundInput = {
  /** Unique number assigned to a refund. This number is shared across all parties involved in processing the refund. It allows the merchant to track the refund with their bank. */
  acquirerReferenceNumber?: InputMaybe<Scalars['String']>;
  /**
   * Amount being returned to the buyer in the refund currency's main units (such as dollars or euros).
   * For example, `"12.95"`.
   */
  amount?: InputMaybe<Scalars['String']>;
  /** ID of the charge to refund. */
  chargeId?: InputMaybe<Scalars['String']>;
  /** Date and time the refund was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#coordinated_Universal_Time_(UTC)) format. For example, "2024-01-30T13:30:00". */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Refund currency. Should be the same as the charge currency. */
  currency?: InputMaybe<Scalars['String']>;
  /** Refund currency. Should be the same as the charge currency. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /**
   * Custom field data for the refund object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Whether the refund is for the entire amount of the charge. */
  full?: InputMaybe<Scalars['Boolean']>;
  /** Refund ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * _INTERNAL_
   * Who initiated this refund. Setting this field requires PAYMENTS.REFUND_SET_INITIATOR permission.
   */
  initiator?: InputMaybe<WixPaymentsRefundsV1RefundInitiator>;
  /** Note providing additional information about this refund. */
  note?: InputMaybe<Scalars['String']>;
  /** Payment service provider's ID for the refund. */
  providerRefundId?: InputMaybe<Scalars['String']>;
  /** Reason this refund was issued. */
  reason?: InputMaybe<Scalars['String']>;
  /**
   * Application fee returned to the merchant from Wix in the refund currency's main units (such as dollars or euros). For example, `"12.95"`.
   *
   * Only included if an application fee was returned.
   */
  returnedApplicationFee?: InputMaybe<Scalars['String']>;
  /**
   * Processing fee returned to the merchant from the payment service provider in the refund currency's main units (such as dollars or euros). For example, `"12.95"`.
   *
   * This field is empty when the processing fee is unknown.
   */
  returnedProcessingFee?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the refund is updated.
   *
   * Ignored when creating a refund.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Status of the refund.
   *
   * Learn more about the [refund lifecycle](https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#lifecycle-of-a-refund>).
   */
  status?: InputMaybe<WixPaymentsRefundsV1RefundStatus>;
  /**
   * Details about the refund status.
   * Used to provide additional information about why a refund was given its status.
   */
  statusInfo?: InputMaybe<WixPaymentsRefundsV1StatusInfoInput>;
  /** Date and time the refund was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#coordinated_Universal_Time_(UTC)) format. For example, "2024-01-30T13:30:00". */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixPaymentsRefundsV1RefundStatus {
  /** Refund failed. */
  Failed = 'FAILED',
  /** Refund is being processed asynchronously. */
  Pending = 'PENDING',
  /** Refund had succeeded, but has since been reversed. */
  Reversed = 'REVERSED',
  /** Refund was recently created. */
  Starting = 'STARTING',
  /** Refund succeeded. */
  Succeeded = 'SUCCEEDED',
  UnknownStatus = 'UNKNOWN_STATUS'
}

export type WixPaymentsRefundsV1Refundability = {
  __typename?: 'WixPaymentsRefundsV1Refundability';
  /** Charge currency. */
  currency?: Maybe<Scalars['String']>;
  /** Charge currency. */
  currencyCode?: Maybe<Scalars['String']>;
  /**
   * Sum of amounts of previous refunds for this charge with the `SUCCEEDED` status in the charge currency's main units (such as dollars or euros). For example, `"6.47"`.
   * Used to [prevent unintended refunds](https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#preventing-unintended-refunds).
   */
  previouslyRefundedAmount?: Maybe<Scalars['String']>;
  /** When the charge is refundable, specifies the allowed range for the refund amount. */
  refundDetails?: Maybe<WixPaymentsRefundsV1RefundDetails>;
  /** Whether you can refund the charge. This depends on your app's permissions, and the permissions of the user checking the refundability. */
  refundable?: Maybe<Scalars['Boolean']>;
  /** When charge is not refundable, specifies why the refund is not allowed. */
  rejectionDetails?: Maybe<WixPaymentsRefundsV1RejectionDetails>;
};

export type WixPaymentsRefundsV1RejectionDetails = {
  __typename?: 'WixPaymentsRefundsV1RejectionDetails';
  /** Reason the refund was rejected. */
  reason?: Maybe<WixPaymentsRefundsV1RejectionDetailsRejectionReason>;
};

export enum WixPaymentsRefundsV1RejectionDetailsRejectionReason {
  /** Charge was disputed. */
  ChargeDisputed = 'CHARGE_DISPUTED',
  /** Charge was fully refunded. */
  ChargeRefunded = 'CHARGE_REFUNDED',
  /** Another refund was initiated for this charge and is waiting for confirmation from the provider. */
  ChargeRefundInProgress = 'CHARGE_REFUND_IN_PROGRESS',
  /** Charge is too old to be refunded. */
  ChargeRefundPeriodEnded = 'CHARGE_REFUND_PERIOD_ENDED',
  /** Charge is unpaid. */
  ChargeUnpaid = 'CHARGE_UNPAID',
  /** Merchant doesn't have enough balance to issue a refund for the charge. */
  MerchantBalanceInsufficient = 'MERCHANT_BALANCE_INSUFFICIENT',
  /** The identity requesting the refund doesn't have the required permissions. This can occur if a site collaborator attempts to create a refund on behalf of the merchant. */
  NotAuthorized = 'NOT_AUTHORIZED',
  /** Charges done via POS terminal and should be refunded on that POS terminal. */
  OnlineRefundNotSupported = 'ONLINE_REFUND_NOT_SUPPORTED',
  /** Partial refunds not supported. */
  PartialRefundNotSupported = 'PARTIAL_REFUND_NOT_SUPPORTED',
  /** Payment method used for the charge doesn't support refunds. */
  PaymentMethodNotSupported = 'PAYMENT_METHOD_NOT_SUPPORTED',
  /** PSP is temporarily unavailable. */
  ProviderDown = 'PROVIDER_DOWN',
  /**
   * PSP doesn't support the refund for one of the following reasons:
   * - The PSP doesn't currently support refunds.
   * - The charge is in an invalid state.
   * - The PSP does not have the required information for this transaction.
   */
  ProviderNotSupported = 'PROVIDER_NOT_SUPPORTED',
  UnknownRejectionReason = 'UNKNOWN_REJECTION_REASON'
}

export enum WixPaymentsRefundsV1RejectionRejectionReason {
  /** Charge was disputed. */
  ChargeDisputed = 'CHARGE_DISPUTED',
  /** Charge is already fully refunded. */
  ChargeRefunded = 'CHARGE_REFUNDED',
  /** Another refund was initiated for this charge and is waiting for confirmation from the provider. */
  ChargeRefundInProgress = 'CHARGE_REFUND_IN_PROGRESS',
  /** Charge is too old to be refunded. */
  ChargeRefundPeriodEnded = 'CHARGE_REFUND_PERIOD_ENDED',
  /** Charge is unpaid. */
  ChargeUnpaid = 'CHARGE_UNPAID',
  /** Merchant account doesn't support refunds at the moment. */
  MerchantAccountNotSupported = 'MERCHANT_ACCOUNT_NOT_SUPPORTED',
  /** Merchant doesn't have enough balance to issue a refund for this charge. */
  MerchantBalanceInsufficient = 'MERCHANT_BALANCE_INSUFFICIENT',
  /** Logged in merchant has no permission to refund this charge. */
  NotAuthorized = 'NOT_AUTHORIZED',
  /** Payment method of a charge doesn't support refunds. */
  PaymentMethodNotSupported = 'PAYMENT_METHOD_NOT_SUPPORTED',
  /** PSP is temporarily down. */
  ProviderDown = 'PROVIDER_DOWN',
  /**
   * Provider doesn't support refunds at the moment, transaction in a wrong state or we don't
   * have required information for this transaction.
   */
  ProviderNotSupported = 'PROVIDER_NOT_SUPPORTED',
  UnknownRejectionReason = 'UNKNOWN_REJECTION_REASON'
}

export type WixPaymentsRefundsV1StatusInfo = {
  __typename?: 'WixPaymentsRefundsV1StatusInfo';
  /**
   * Reason code with detailed information about the refund status.
   * See the full list of [reason codes](https://dev.wix.com/docs/rest/business-management/payments/service-plugins/payment-service-provider-service-plugin/reason-codes#refund-declined).
   */
  code?: Maybe<Scalars['String']>;
  /** Description of the status. */
  description?: Maybe<Scalars['String']>;
};

export type WixPaymentsRefundsV1StatusInfoInput = {
  /**
   * Reason code with detailed information about the refund status.
   * See the full list of [reason codes](https://dev.wix.com/docs/rest/business-management/payments/service-plugins/payment-service-provider-service-plugin/reason-codes#refund-declined).
   */
  code?: InputMaybe<Scalars['String']>;
  /** Description of the status. */
  description?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsRefundsV1UpdateExtendedFieldsResponse = {
  __typename?: 'WixPaymentsRefundsV1UpdateExtendedFieldsResponse';
  /** Updated refund. */
  refund?: Maybe<WixPaymentsRefundsV1Refund>;
};

export type WixPaymentsRefundsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export enum WixPaymentsRefundsV1UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixPaymentsRefundsV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixPaymentsRefundsV1UpstreamWixCommonSortOrder>;
};

export type WixPaymentsRefundsV1UpstreamWixQueryCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixPaymentsRefundsV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixPaymentsRefundsV1UpstreamWixCommonSortingInput>>>;
};

export type WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursors = {
  __typename?: 'WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursors';
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export enum WixPaymentsSavedPaymentMethodsV1CardBrandEnumCardBrand {
  Amex = 'AMEX',
  Dankort = 'DANKORT',
  Diners = 'DINERS',
  Discover = 'DISCOVER',
  Isracard = 'ISRACARD',
  Jcb = 'JCB',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Rupay = 'RUPAY',
  Unionpay = 'UNIONPAY',
  UnknownCardBrand = 'UNKNOWN_CARD_BRAND',
  Visa = 'VISA'
}

export type WixPaymentsSavedPaymentMethodsV1DeleteSavedPaymentMethodRequestInput = {
  /** Unique identifier of a saved payment method. */
  savedPaymentMethodId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1FindSavedCreditCardRequestInput = {
  /** expiration month */
  expirationMonth?: InputMaybe<Scalars['Int']>;
  /** expiration year */
  expirationYear?: InputMaybe<Scalars['Int']>;
  /** site member id */
  siteMemberId?: InputMaybe<Scalars['String']>;
  /** temporary card token */
  temporaryCardToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1FindSavedCreditCardResponse = {
  __typename?: 'WixPaymentsSavedPaymentMethodsV1FindSavedCreditCardResponse';
  /** saved payment method id */
  savedPaymentMethodId?: Maybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1GetSavedPaymentMethodRequestInput = {
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in HidedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsSavedPaymentMethodsV1RequestedFields>>>;
  id: Scalars['ID'];
};

export type WixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsRequestInput = {
  /**
   * List of requested fields that will be returned.
   * Supported values:
   * SENSITIVE_INFO - Sensitive information of a SavedPaymentMethod like credit card tokens that's needed to process payments with it.
   * In order to receive it you should have `PAYMENTS.SAVED_PAYMENT_METHOD_READ_SENSITIVE_INFO` permission
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsSavedPaymentMethodsV1RequestedFields>>>;
  /**
   * Defines whether this payment method can be used by the merchant for making unscheduled payments.
   * Even if it's set to `false` payment method still can be used for scheduled payments e.g. subscription renewal without the buyer being present.
   */
  merchantUseAllowed?: InputMaybe<Scalars['Boolean']>;
  /**
   * Paging for limit the response size.
   * If no paging provider default response limit 100 will be used.
   */
  paging?: InputMaybe<WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingInput>;
  /** Payment method type id. Supported values are `creditCard`, `payPal`. */
  paymentMethodTypeId?: InputMaybe<Scalars['String']>;
  /**
   * Site member that owns saved payment methods.
   * Pass `me` to list saved payment method of the current site member.
   */
  siteMemberId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsResponse = {
  __typename?: 'WixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsResponse';
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingMetadata>;
  /** List of saved payment methods. */
  savedPaymentMethods?: Maybe<Array<Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod>>>;
};

export type WixPaymentsSavedPaymentMethodsV1MarkSavedPaymentMethodPrimaryRequestInput = {
  /** Unique identifier of a saved payment method. */
  savedPaymentMethodId?: InputMaybe<Scalars['String']>;
};

export enum WixPaymentsSavedPaymentMethodsV1RequestedFields {
  SensitiveInfo = 'SENSITIVE_INFO',
  /** Default value. This value is unused. */
  UnknownRequestedField = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod = {
  __typename?: 'WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod';
  /** SavedPaymentMethod creation time. */
  createdDate?: Maybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Unique identifier of a saved payment method. */
  id?: Maybe<Scalars['String']>;
  /** Saved payment method owner's member ID. */
  member?: Maybe<ComWixpressMembersApiMember>;
  /**
   * Defines whether this payment method can be used by the merchant for making unscheduled payments.
   * Even if it's set to `false` payment method still can be used for scheduled payments e.g. subscription renewal without the buyer being present.
   */
  merchantUseAllowed?: Maybe<Scalars['Boolean']>;
  /** Payment method details. */
  paymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethod>;
  /** Defines whether this payment method is primary for the member. Member can only have at most one primary saved payment method. */
  primary?: Maybe<Scalars['Boolean']>;
  /** Represents the current state of a saved payment method. Each time saved payment method is modified, its `revision` changes. For an update operation to succeed, you MUST pass the latest revision. */
  revision?: Maybe<Scalars['Long']>;
  /** Saved payment method sensitive information. */
  sensitiveInfo?: Maybe<WixPaymentsSavedPaymentMethodsV1SensitiveInfo>;
  /** Saved payment method owner's member ID. */
  siteMemberId?: Maybe<Scalars['String']>;
  /** SavedPaymentMethod last update time. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfo = {
  __typename?: 'WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfo';
  /** Credit card's BIN (Bank Identification Number). It's first 4-6 digits of card's number. */
  bin?: Maybe<Scalars['String']>;
  /** INTERNAL* Card brand. */
  brand?: Maybe<WixPaymentsSavedPaymentMethodsV1CardBrandEnumCardBrand>;
  /** Card holder's full name specified on the card. */
  cardholderName?: Maybe<Scalars['String']>;
  /** Credit card's expiration month. */
  expirationMonth?: Maybe<Scalars['Int']>;
  /** Credit card's expiration year. */
  expirationYear?: Maybe<Scalars['Int']>;
  /** Credit card's last 4 digits. */
  lastFourDigits?: Maybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfoInput = {
  /** Credit card's BIN (Bank Identification Number). It's first 4-6 digits of card's number. */
  bin?: InputMaybe<Scalars['String']>;
  /** INTERNAL* Card brand. */
  brand?: InputMaybe<WixPaymentsSavedPaymentMethodsV1CardBrandEnumCardBrand>;
  /** Card holder's full name specified on the card. */
  cardholderName?: InputMaybe<Scalars['String']>;
  /** Credit card's expiration month. */
  expirationMonth?: InputMaybe<Scalars['Int']>;
  /** Credit card's expiration year. */
  expirationYear?: InputMaybe<Scalars['Int']>;
  /** Credit card's last 4 digits. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput = {
  /** SavedPaymentMethod creation time. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Unique identifier of a saved payment method. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Defines whether this payment method can be used by the merchant for making unscheduled payments.
   * Even if it's set to `false` payment method still can be used for scheduled payments e.g. subscription renewal without the buyer being present.
   */
  merchantUseAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Payment method details. */
  paymentMethod?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethodInput>;
  /** Defines whether this payment method is primary for the member. Member can only have at most one primary saved payment method. */
  primary?: InputMaybe<Scalars['Boolean']>;
  /** Represents the current state of a saved payment method. Each time saved payment method is modified, its `revision` changes. For an update operation to succeed, you MUST pass the latest revision. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Saved payment method sensitive information. */
  sensitiveInfo?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SensitiveInfoInput>;
  /** Saved payment method owner's member ID. */
  siteMemberId?: InputMaybe<Scalars['String']>;
  /** SavedPaymentMethod last update time. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethod = {
  __typename?: 'WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethod';
  /** Details of credit card. */
  cardInfo?: Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfo>;
  /** Payment method brand ID. */
  paymentMethodBrandId?: Maybe<Scalars['String']>;
  /** Payment method type ID. */
  paymentMethodTypeId?: Maybe<Scalars['String']>;
  /** Legacy payment method type ID. Supported values are `creditCard`, `payPal`. */
  typeId?: Maybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethodInput = {
  /** Details of credit card. */
  cardInfo?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfoInput>;
  /** Payment method brand ID. */
  paymentMethodBrandId?: InputMaybe<Scalars['String']>;
  /** Payment method type ID. */
  paymentMethodTypeId?: InputMaybe<Scalars['String']>;
  /** Legacy payment method type ID. Supported values are `creditCard`, `payPal`. */
  typeId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SensitiveInfo = {
  __typename?: 'WixPaymentsSavedPaymentMethodsV1SensitiveInfo';
  /** Sensitive details of credit card like card token. */
  cardSensitiveInfo?: Maybe<WixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfo>;
};

export type WixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfo = {
  __typename?: 'WixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfo';
  /** Persistent token of credit card tokenized by Wix. */
  persistentToken?: Maybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfoInput = {
  /** Persistent token of credit card tokenized by Wix. */
  persistentToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SensitiveInfoInput = {
  /** Sensitive details of credit card like card token. */
  cardSensitiveInfo?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfoInput>;
};

export type WixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodRequestInput = {
  /** Explicit list of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Saved payment method to update. */
  savedPaymentMethod?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput>;
};

export type WixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodResponse = {
  __typename?: 'WixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodResponse';
  /** Updated saved payment method. */
  savedPaymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod>;
};

export type WixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodRequestInput = {
  /** Saved payment method. */
  savedPaymentMethod?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput>;
  /** Temporary token of credit card tokenized by Wix. This token is used to create a persistent token */
  temporaryCardToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodResponse = {
  __typename?: 'WixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodResponse';
  /** Saved payment method. */
  savedPaymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod>;
};

export type WixPaymentsSitePaymentMethodTypesV1BuyerFlow = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1BuyerFlow';
  /** Indicates that payment method type is restricted in provided country. */
  countryRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the merchant cannot choose to accept payments from this payment method type. */
  hidden?: Maybe<Scalars['Boolean']>;
  /**
   * Details about the icons to display for this payment method type on a site's checkout page. Icons are localized according to the locale of the call.
   *
   * Define a locale by specifying a `countryCode` and `languageCode` when calling `Get Payment Method Type` or `List Payment Method Types`.
   * For more detailed information, see the method descriptions.
   */
  icons?: Maybe<Array<Maybe<WixPaymentsSitePaymentMethodTypesV1Icon>>>;
  /**
   * Minimum payment amount that can be made with this payment method type.
   * If the request omits `currencyCode`, the field is not set because its value depends on the currency.
   */
  minPaymentAmount?: Maybe<Scalars['String']>;
  /**
   * The priority given to this payment method type in the list of payment method types shown to the buyer.
   * A lower value relative to other payment method types means a higher position on the list.
   */
  priority?: Maybe<Scalars['Int']>;
};

export type WixPaymentsSitePaymentMethodTypesV1Features = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1Features';
  /** Authorize and capture configuration. */
  authCapture?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesAuthCapture>;
  /** Credential-on-File (CoF) configuration. */
  credentialOnFile?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesCredentialOnFile>;
  /** Custom tokenization configuration. */
  customTokenization?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesCustomTokenization>;
  /** Disputes configuration. */
  disputes?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesDisputes>;
  /** Express flow configuration. */
  expressFlow?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesExpressFlow>;
  /** Installments configuration. */
  installments?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesInstallments>;
  /** Mail Order/Telephone Order (MOTO) configuration. */
  moto?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesMoto>;
  /** Next action configuration. */
  nextAction?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextAction>;
  /** Promotional message configuration. */
  promotionalMessages?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesPromotionalMessages>;
  /** Refunds configuration. */
  refunds?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesRefunds>;
  /** Regular flow configuration. */
  regularFlow?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesRegularFlow>;
  /** Regular tokenization configuration. */
  regularTokenization?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesRegularTokenization>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesAuthCapture = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesAuthCapture';
  /** Period to wait for the auth capture to be completed before canceling the transaction. */
  maxCapturePeriodInDays?: Maybe<Scalars['Int']>;
  /** Whether the authorize and capture flow is supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesCredentialOnFile = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesCredentialOnFile';
  /** Whether the Credential-on-File (CoF) feature is supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesCustomTokenization = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesCustomTokenization';
  /** Whether a custom tokenization mechanism can be configured for this payment method type, such as a provider-specific tokenization method. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesDisputes = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesDisputes';
  /** Whether disputes are supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesExpressFlow = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesExpressFlow';
  /** Whether this payment method type can be used in an express flow on checkout. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesInstallments = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesInstallments';
  /**
   * Countries for which installments can be enabled.
   * @deprecated Countries for which installments can be enabled. Replaced by: allowed_country_codes. Removal date: 2025-12-31.
   */
  allowedCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Countries for which installments can be enabled. */
  allowedCountryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Max number of installments that can be configured by a provider. */
  maxInstallmentLimit?: Maybe<Scalars['Int']>;
  /** Whether installments are supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesMoto = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesMoto';
  /** Whether Mail Order/Telephone Order (MOTO) is supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextAction = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesNextAction';
  /** Barcode configuration. */
  barcode?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionBarcode>;
  /** Full page redirect configuration. */
  fullPageRedirect?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionFullPageRedirect>;
  /** iframe configuration. */
  iframe?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionIFrame>;
  /** New tab configuration. */
  newTab?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionNewTab>;
  /** QR code configuration. */
  qrCode?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionQrCode>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionBarcode = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionBarcode';
  /** Whether the next payment action can be shown as a barcode to scan. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionFullPageRedirect = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionFullPageRedirect';
  /** Whether the next payment action can be shown by redirecting to a new page. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionIFrame = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionIFrame';
  /** Whether the next payment action can be shown in an iframe. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionNewTab = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionNewTab';
  /** Whether the next payment action can be shown in a new tab. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionQrCode = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionQrCode';
  /** Whether the next payment action can be shown as a QR code to scan. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesPromotionalMessages = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesPromotionalMessages';
  /** Whether promotional messages is supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesRefunds = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesRefunds';
  /** Maximum period in which payments made using this payment method type can be refunded. */
  maxRefundabilityPeriodInDays?: Maybe<Scalars['Int']>;
  /** Whether refunds are supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesRegularFlow = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesRegularFlow';
  /** Whether this payment method type can be used in a regular flow on checkout. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesRegularTokenization = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1FeaturesRegularTokenization';
  /** Whether the default tokenization mechanism can be configured for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1GetSitePaymentMethodTypeRequestInput = {
  /**
   * Country used to determine localized values for fields in the response.
   *
   * Must be a 2-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#officially_assigned_code_elements) format.
   */
  countryCode?: InputMaybe<Scalars['String']>;
  /**
   * Currency used to determine localized values for fields in the response.
   *
   * Must be a 3-letter currency code in [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) format.
   */
  currencyCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Language used to determine localized values for fields in the response.
   *
   * Must be a 2-letter language code in [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.
   */
  languageCode?: InputMaybe<Scalars['String']>;
  /** Requested additional fields */
  requestedFields?: InputMaybe<Array<InputMaybe<WixPaymentsSitePaymentMethodTypesV1RequestedFields>>>;
};

export type WixPaymentsSitePaymentMethodTypesV1Icon = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1Icon';
  /** Icon image format. */
  format?: Maybe<WixPaymentsSitePaymentMethodTypesV1IconFormat>;
  /** Icon image. */
  image?: Maybe<WixPaymentsSitePaymentMethodTypesV1UpstreamWixCommonImage>;
  /**
   * Icon tag. Payment method types can have multiple icons, and tags are used to differentiate between them.
   * For example, the UI design for multiple payment method types is upgraded, and now they each have an old icon tagged "v1" and a new icon tagged "v2". Developers can then easily choose to display all the original "v1" style of icons, or all the new "v2" style.
   */
  tag?: Maybe<Scalars['String']>;
};

export enum WixPaymentsSitePaymentMethodTypesV1IconFormat {
  Png = 'PNG',
  Svg = 'SVG',
  UnknownFormat = 'UNKNOWN_FORMAT'
}

export type WixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesRequestInput = {
  /**
   * Country used to filter payment method types and determine localized values for fields in the response.
   *
   * Must be a 2-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#officially_assigned_code_elements) format.
   */
  countryCode?: InputMaybe<Scalars['String']>;
  /**
   * Currency used to determine localized values for fields in the response.
   *
   * Must be a 3-letter currency code in [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) format.
   */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** IDs or legacy IDs of site payment method types to retrieve. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Language used to determine localized values for fields in the response.
   *
   * Must be a 2-letter language code in [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.
   */
  languageCode?: InputMaybe<Scalars['String']>;
  /** Requested additional fields */
  requestedFields?: InputMaybe<Array<InputMaybe<WixPaymentsSitePaymentMethodTypesV1RequestedFields>>>;
};

export type WixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesResponse = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesResponse';
  /** List of site payment method types. */
  sitePaymentMethodTypes?: Maybe<Array<Maybe<WixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType>>>;
};

export type WixPaymentsSitePaymentMethodTypesV1MerchantFlow = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1MerchantFlow';
  /** Indicates that payment method type is restricted in provided country. */
  countryRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the merchant cannot choose to accept payments from this payment method type. */
  hidden?: Maybe<Scalars['Boolean']>;
  /**
   * Details about the icons to display for this payment method type on the merchant's Accept Payments page in the site dashboard. Icons are localized according to the locale of the call.
   *
   * Define a locale by specifying a `countryCode` and `languageCode` when calling `Get Payment Method Type` or `List Payment Method Types`.
   * For more detailed information, see the method descriptions.
   */
  icons?: Maybe<Array<Maybe<WixPaymentsSitePaymentMethodTypesV1Icon>>>;
  /**
   * Priority given to this payment method type in the list shown to the merchant.
   * A lower value relative to other payment method types means a higher position on the list.
   */
  priority?: Maybe<Scalars['Int']>;
  /** Whether the payment method type is promoted. Promoted payment method types are displayed more prominently on the Accept Payments page. */
  promoted?: Maybe<Scalars['Boolean']>;
};

export enum WixPaymentsSitePaymentMethodTypesV1RequestedFields {
  /** Return `allowedCurrencyCodes`. */
  AllowedCurrencies = 'ALLOWED_CURRENCIES',
  UnknownRequestedField = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType';
  /**
   * _INTERNAL_: Allowed currencies
   * @deprecated _INTERNAL_: Allowed currencies. Replaced by: allowed_currency_codes. Removal date: 2025-12-31.
   */
  allowedCurrencies?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Allowed currencies */
  allowedCurrencyCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Whether this payment method type is only used to represent a supported payment brand for another payment method type.
   *
   * For example, a Visa payment method is used to indicate that Visa can be used for credit card transactions. But the Visa payment method type is not used to accept payments. Instead, the credit card payment method type is used.
   *
   * Brand-only payment method types cannot be used to accept payments, and are not listed as a payment method type in a site's dashboard.
   */
  brandOnly?: Maybe<Scalars['Boolean']>;
  /** Settings that determine if and how to display this payment method type in the buyer flow. The buyer flow is the process a buyer goes through to make a purchase att checkout. */
  buyerFlow?: Maybe<WixPaymentsSitePaymentMethodTypesV1BuyerFlow>;
  /** Indicates that payment method type is restricted for the provided `currencyCode`. */
  currencyRestricted?: Maybe<Scalars['Boolean']>;
  /** Indicates the payment method type has currency restriction and it is enabled. */
  currencyRestrictionEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Payment method type description, based on locale.
   *
   * Used by Wix when displaying the payment method type, such as in the payment settings page for merchants, or the checkout page for buyers.
   *
   * Define your locale by specifying a `countryCode` and `languageCode` when calling `Get Payment Method Type` or `List Payment Method Types`.
   * For more detailed information, see the descriptions for the `countryCode` and `languageCode` parameters for those methods.
   */
  description?: Maybe<Scalars['String']>;
  /**
   * Payment method type display name, based on locale.
   *
   * Used by Wix when displaying the payment method type, such as in the payment settings page for merchants, or the checkout page for buyers.
   *
   * Define your locale by specifying a `countryCode` and `languageCode` when calling `Get Payment Method Type` or `List Payment Method Types`.
   * For more detailed information, see the descriptions for the `countryCode` and `languageCode` parameters for those methods.
   */
  displayName?: Maybe<Scalars['String']>;
  /** Features supported for this payment method type. */
  features?: Maybe<WixPaymentsSitePaymentMethodTypesV1Features>;
  /** Payment method type ID. */
  id?: Maybe<Scalars['String']>;
  /** Whether the payment method type can only be used for in-person payments, such as cash, point-of-sale payments, and card readers. */
  inPerson?: Maybe<Scalars['Boolean']>;
  /** Value used buy some legacy APIs to refer to this payment method type. Can be empty. */
  legacyId?: Maybe<Scalars['String']>;
  /** Settings that determine if and how to display this payment method type in the merchant flow. The merchant flow is the process a merchant goes through to configure which payment method types they accept on their site. */
  merchantFlow?: Maybe<WixPaymentsSitePaymentMethodTypesV1MerchantFlow>;
  /**
   * Time (in seconds after which a transaction is marked as expired if it is not completed.
   *
   * Max: `15552000` (180 days)
   */
  transactionExpirationDelayInSeconds?: Maybe<Scalars['Int']>;
  /** Indicates that this payment method type comes from [Velo integration](https://dev.wix.com/docs/develop-websites/articles/code-tutorials/wix-pay/tutorial-payment-provider-service-plugin). */
  velo?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1UpstreamWixCommonImage = {
  __typename?: 'WixPaymentsSitePaymentMethodTypesV1UpstreamWixCommonImage';
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixPopulationV2CreatedElementsEventInput = {
  /** list of elements created */
  created?: InputMaybe<Array<InputMaybe<WixPopulationV2ElementInput>>>;
  /** The population ID */
  populationId?: InputMaybe<Scalars['String']>;
};

export type WixPopulationV2ElementInput = {
  /** Represents the time this Element was created */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Element ID */
  id?: InputMaybe<Scalars['String']>;
  /** Note you can add */
  note?: InputMaybe<Scalars['String']>;
  /** Population ID */
  populationId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1AdditionalFee = {
  __typename?: 'WixReceiptsV1AdditionalFee';
  /** Additional fee name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Additional fee amount after taxes.
   * If no taxes apply to this fee, this will be the same as `priceBeforeTax`.
   */
  priceAfterTax?: Maybe<Scalars['String']>;
  /** Additional fee price before taxes. */
  priceBeforeTax?: Maybe<Scalars['String']>;
  /** Additional fee tax breakdown. */
  taxBreakdown?: Maybe<Array<Maybe<WixReceiptsV1AdditionalFeeTax>>>;
};

export type WixReceiptsV1AdditionalFeeInput = {
  /** Additional fee name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Additional fee amount after taxes.
   * If no taxes apply to this fee, this will be the same as `priceBeforeTax`.
   */
  priceAfterTax?: InputMaybe<Scalars['String']>;
  /** Additional fee price before taxes. */
  priceBeforeTax?: InputMaybe<Scalars['String']>;
  /** Additional fee tax breakdown. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<WixReceiptsV1AdditionalFeeTaxInput>>>;
};

export type WixReceiptsV1AdditionalFeeTax = {
  __typename?: 'WixReceiptsV1AdditionalFeeTax';
  /** Tax amount. */
  amount?: Maybe<Scalars['String']>;
  /** Tax name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Tax rate.
   * Example: 0.1000 signifies 10% tax and 2.1000 signifies 210% tax.
   */
  rate?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1AdditionalFeeTaxInput = {
  /** Tax amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Tax name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Tax rate.
   * Example: 0.1000 signifies 10% tax and 2.1000 signifies 210% tax.
   */
  rate?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1BackofficeUpdateReceiptRequestInput = {
  /** Fields that aren't included in `fieldMask.paths` are ignored. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Receipt. */
  receipt?: InputMaybe<WixReceiptsV1ReceiptInput>;
};

export type WixReceiptsV1BackofficeUpdateReceiptResponse = {
  __typename?: 'WixReceiptsV1BackofficeUpdateReceiptResponse';
  /** Receipt. */
  receipt?: Maybe<WixReceiptsV1Receipt>;
};

export type WixReceiptsV1BusinessDetails = {
  __typename?: 'WixReceiptsV1BusinessDetails';
  /** Business address. */
  address?: Maybe<WixReceiptsV1UpstreamWixCommonAddress>;
  /** Business email. */
  email?: Maybe<Scalars['String']>;
  /** Business logo. */
  logo?: Maybe<WixReceiptsV1UpstreamWixCommonImage>;
  /** Business name. */
  name?: Maybe<Scalars['String']>;
  /** Business phone. */
  phone?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1BusinessDetailsInput = {
  /** Business address. */
  address?: InputMaybe<WixReceiptsV1UpstreamWixCommonAddressInput>;
  /** Business email. */
  email?: InputMaybe<Scalars['String']>;
  /** Business logo. */
  logo?: InputMaybe<WixReceiptsV1UpstreamWixCommonImageInput>;
  /** Business name. */
  name?: InputMaybe<Scalars['String']>;
  /** Business phone. */
  phone?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1CreateReceiptRequestInput = {
  /** Receipt to create. */
  receipt?: InputMaybe<WixReceiptsV1ReceiptInput>;
};

export type WixReceiptsV1CreateReceiptResponse = {
  __typename?: 'WixReceiptsV1CreateReceiptResponse';
  /** Created receipt. */
  receipt?: Maybe<WixReceiptsV1Receipt>;
};

export type WixReceiptsV1CustomField = {
  __typename?: 'WixReceiptsV1CustomField';
  /** Title. */
  title?: Maybe<Scalars['String']>;
  /** Value. */
  value?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1CustomFieldInput = {
  /** Title. */
  title?: InputMaybe<Scalars['String']>;
  /** Value. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1CustomFields = {
  __typename?: 'WixReceiptsV1CustomFields';
  /** Business custom fields. */
  businessCustomFields?: Maybe<Array<Maybe<WixReceiptsV1CustomField>>>;
  /** Customer custom fields. */
  customerCustomFields?: Maybe<Array<Maybe<WixReceiptsV1CustomField>>>;
  /** Footer custom fields. */
  footerCustomFields?: Maybe<Array<Maybe<WixReceiptsV1FooterCustomField>>>;
  /** Header custom fields. */
  headerCustomFields?: Maybe<Array<Maybe<WixReceiptsV1CustomField>>>;
};

export type WixReceiptsV1CustomFieldsInput = {
  /** Business custom fields. */
  businessCustomFields?: InputMaybe<Array<InputMaybe<WixReceiptsV1CustomFieldInput>>>;
  /** Customer custom fields. */
  customerCustomFields?: InputMaybe<Array<InputMaybe<WixReceiptsV1CustomFieldInput>>>;
  /** Footer custom fields. */
  footerCustomFields?: InputMaybe<Array<InputMaybe<WixReceiptsV1FooterCustomFieldInput>>>;
  /** Header custom fields. */
  headerCustomFields?: InputMaybe<Array<InputMaybe<WixReceiptsV1CustomFieldInput>>>;
};

export type WixReceiptsV1Customer = {
  __typename?: 'WixReceiptsV1Customer';
  /** Customer's billing address. */
  billingAddress?: Maybe<WixReceiptsV1UpstreamWixCommonAddress>;
  /** Customer's contact ID. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** Customer's contact details. */
  contactDetails?: Maybe<WixReceiptsV1UpstreamWixCommonFullAddressContactDetails>;
  /** Customer's contact ID. */
  contactId?: Maybe<Scalars['String']>;
  /** Customer's shipping address. */
  shippingAddress?: Maybe<WixReceiptsV1UpstreamWixCommonAddress>;
};

export type WixReceiptsV1CustomerInput = {
  /** Customer's billing address. */
  billingAddress?: InputMaybe<WixReceiptsV1UpstreamWixCommonAddressInput>;
  /** Customer's contact details. */
  contactDetails?: InputMaybe<WixReceiptsV1UpstreamWixCommonFullAddressContactDetailsInput>;
  /** Customer's contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Customer's shipping address. */
  shippingAddress?: InputMaybe<WixReceiptsV1UpstreamWixCommonAddressInput>;
};

export type WixReceiptsV1Discount = {
  __typename?: 'WixReceiptsV1Discount';
  /** Discount amount. */
  amount?: Maybe<Scalars['String']>;
  /** Discount name. */
  displayName?: Maybe<Scalars['String']>;
  /**
   * Deprecated: Use `display_name` instead.
   * @deprecated Deprecated: Use `display_name` instead. Replaced by: display_name. Removal date: 2025-06-01.
   */
  name?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1DiscountInput = {
  /** Discount amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Discount name. */
  displayName?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1Document = {
  __typename?: 'WixReceiptsV1Document';
  /** Document download URL. */
  downloadUrl?: Maybe<Scalars['String']>;
  /** Document status. */
  status?: Maybe<WixReceiptsV1DocumentDocumentStatus>;
};

export enum WixReceiptsV1DocumentDocumentStatus {
  /** Generation was successful. You can downloaded the document using the `downloadUrl`. */
  Available = 'AVAILABLE',
  /** Generation has failed. You can retrigger document generation by calling Regenerate Receipt Document. */
  Failed = 'FAILED',
  /** Generation is in progress. Call Get Receipt after 6-10 seconds to check the updated status. */
  Processing = 'PROCESSING',
  /** Generation status is unknown. */
  UnknownDocumentStatus = 'UNKNOWN_DOCUMENT_STATUS'
}

export type WixReceiptsV1DocumentInput = {
  /** Document download URL. */
  downloadUrl?: InputMaybe<Scalars['String']>;
  /** Document status. */
  status?: InputMaybe<WixReceiptsV1DocumentDocumentStatus>;
};

export type WixReceiptsV1EventsGenerateReceiptDocumentInput = {
  /** Receipt Id. */
  receiptId?: InputMaybe<Scalars['String']>;
  /** Shows how request for document generation was made. */
  requestOrigin?: InputMaybe<WixReceiptsV1EventsGenerateReceiptDocumentRequestOrigin>;
};

export enum WixReceiptsV1EventsGenerateReceiptDocumentRequestOrigin {
  Initial = 'INITIAL',
  Manual = 'MANUAL'
}

export type WixReceiptsV1EventsReceiptDocumentHandledFailedInput = {
  /** Receipt Id. */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1EventsReceiptDocumentHandledInput = {
  /** Populated only if receipt document handling has failed. */
  failed?: InputMaybe<WixReceiptsV1EventsReceiptDocumentHandledFailedInput>;
  /** Populated only if receipt document handling has succeeded. */
  succeeded?: InputMaybe<WixReceiptsV1EventsReceiptDocumentHandledSucceededInput>;
};

export type WixReceiptsV1EventsReceiptDocumentHandledSucceededInput = {
  /** Download URL. */
  downloadUrl?: InputMaybe<Scalars['String']>;
  /** Media file Id. */
  mediaFileId?: InputMaybe<Scalars['String']>;
  /** Receipt Id. */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1EventsReceiptNumberingProcessInput = {
  /** Receipt Id. */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1FooterCustomField = {
  __typename?: 'WixReceiptsV1FooterCustomField';
  /** Title. */
  title?: Maybe<Scalars['String']>;
  /** Value. */
  value?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1FooterCustomFieldInput = {
  /** Title. */
  title?: InputMaybe<Scalars['String']>;
  /** Value. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1GetLatestReceiptNumberRequestInput = {
  /** Receipt prefix to filter by. */
  prefix?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1GetLatestReceiptNumberResponse = {
  __typename?: 'WixReceiptsV1GetLatestReceiptNumberResponse';
  /** Receipt number. */
  number?: Maybe<Scalars['Int']>;
};

export type WixReceiptsV1GetReceiptRequestInput = {
  id: Scalars['ID'];
};

export type WixReceiptsV1LineItem = {
  __typename?: 'WixReceiptsV1LineItem';
  /** Line item description. */
  description?: Maybe<Scalars['String']>;
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /** Line item name. */
  name?: Maybe<Scalars['String']>;
  /** Line item unit price per unit after discounts. */
  price?: Maybe<Scalars['String']>;
  /** Line item price per unit before discounts. */
  priceBeforeDiscounts?: Maybe<Scalars['String']>;
  /** Line item quantity. */
  quantity?: Maybe<Scalars['String']>;
  /** Line item tax breakdown. */
  taxBreakdown?: Maybe<Array<Maybe<WixReceiptsV1LineItemTax>>>;
  /** Line item totals. */
  totals?: Maybe<WixReceiptsV1LineItemTotals>;
};

export type WixReceiptsV1LineItemInput = {
  /** Line item description. */
  description?: InputMaybe<Scalars['String']>;
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item name. */
  name?: InputMaybe<Scalars['String']>;
  /** Line item unit price per unit after discounts. */
  price?: InputMaybe<Scalars['String']>;
  /** Line item price per unit before discounts. */
  priceBeforeDiscounts?: InputMaybe<Scalars['String']>;
  /** Line item quantity. */
  quantity?: InputMaybe<Scalars['String']>;
  /** Line item tax breakdown. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<WixReceiptsV1LineItemTaxInput>>>;
  /** Line item totals. */
  totals?: InputMaybe<WixReceiptsV1LineItemTotalsInput>;
};

export type WixReceiptsV1LineItemTax = {
  __typename?: 'WixReceiptsV1LineItemTax';
  /** Amount of tax calculated for this line item. */
  taxAmount?: Maybe<Scalars['String']>;
  /** Tax name. */
  taxName?: Maybe<Scalars['String']>;
  /**
   * Tax rate percentage.
   * For example: 0.1000 means 10% tax, and 2.1000 means 210% tax.
   */
  taxRate?: Maybe<Scalars['String']>;
  /** Amount of the line item price that is taxable. */
  taxableAmount?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1LineItemTaxInput = {
  /** Amount of tax calculated for this line item. */
  taxAmount?: InputMaybe<Scalars['String']>;
  /** Tax name. */
  taxName?: InputMaybe<Scalars['String']>;
  /**
   * Tax rate percentage.
   * For example: 0.1000 means 10% tax, and 2.1000 means 210% tax.
   */
  taxRate?: InputMaybe<Scalars['String']>;
  /** Amount of the line item price that is taxable. */
  taxableAmount?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1LineItemTotals = {
  __typename?: 'WixReceiptsV1LineItemTotals';
  /** Line item total discount. */
  totalDiscount?: Maybe<Scalars['String']>;
  /** Line item total price after taxes and discounts. */
  totalPriceAfterTax?: Maybe<Scalars['String']>;
  /** Line item total price after discounts and before taxes. */
  totalPriceBeforeTax?: Maybe<Scalars['String']>;
  /** Line item total applied tax. */
  totalTax?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1LineItemTotalsInput = {
  /** Line item total discount. */
  totalDiscount?: InputMaybe<Scalars['String']>;
  /** Line item total price after taxes and discounts. */
  totalPriceAfterTax?: InputMaybe<Scalars['String']>;
  /** Line item total price after discounts and before taxes. */
  totalPriceBeforeTax?: InputMaybe<Scalars['String']>;
  /** Line item total applied tax. */
  totalTax?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1Locale = {
  __typename?: 'WixReceiptsV1Locale';
  /**
   * Two-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#officially_assigned_code_elements) format.
   * For example: `US`, `DE`, `JP`.
   */
  country?: Maybe<Scalars['String']>;
  /**
   * Two-letter language code in [ISO-639-1 alpha-2](https://en.wikipedia.org/wiki/ISO_639-1) format.
   * For example: `en`, `de`, `ja`.
   */
  languageCode?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1LocaleInput = {
  /**
   * Two-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#officially_assigned_code_elements) format.
   * For example: `US`, `DE`, `JP`.
   */
  country?: InputMaybe<Scalars['String']>;
  /**
   * Two-letter language code in [ISO-639-1 alpha-2](https://en.wikipedia.org/wiki/ISO_639-1) format.
   * For example: `en`, `de`, `ja`.
   */
  languageCode?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1Payment = {
  __typename?: 'WixReceiptsV1Payment';
  /** Payment amount. */
  amount?: Maybe<Scalars['String']>;
  /** Payment method. */
  paymentMethod?: Maybe<Scalars['String']>;
  /** Payment details. */
  paymentMethodDetails?: Maybe<Scalars['String']>;
  /** Payment transaction date. */
  transactionDate?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1PaymentInput = {
  /** Payment amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Payment method. */
  paymentMethod?: InputMaybe<Scalars['String']>;
  /** Payment details. */
  paymentMethodDetails?: InputMaybe<Scalars['String']>;
  /** Payment transaction date. */
  transactionDate?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1QueryReceiptsRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixReceiptsV1UpstreamWixCommonCursorQueryInput>;
};

export type WixReceiptsV1QueryReceiptsResponse = {
  __typename?: 'WixReceiptsV1QueryReceiptsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixReceiptsV1Receipt>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixReceiptsV1Receipt = {
  __typename?: 'WixReceiptsV1Receipt';
  /** Additional fees. */
  additionalFees?: Maybe<Array<Maybe<WixReceiptsV1AdditionalFee>>>;
  /**
   * Business details.
   * When business properties are not provided, defaults are taken from the site's properties, available in the Site Properties API.
   */
  businessDetails?: Maybe<WixReceiptsV1BusinessDetails>;
  /** Date and time the receipt was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Currency code in [ISO-4217 alphabetic](https://www.iso.org/iso-4217-currency-codes.html) format. */
  currency?: Maybe<Scalars['String']>;
  /**
   * Custom fields for this receipt.
   * Values appear on the receipt in the specified order.
   */
  customFields?: Maybe<WixReceiptsV1CustomFields>;
  /** Customer details. */
  customer?: Maybe<WixReceiptsV1Customer>;
  /** Discounts. */
  discounts?: Maybe<Array<Maybe<WixReceiptsV1Discount>>>;
  /** Document details. */
  document?: Maybe<WixReceiptsV1Document>;
  /**
   * Custom field data for the receipt.
   * Extended fields must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Receipt ID. */
  id?: Maybe<Scalars['String']>;
  /** Line item details. */
  lineItems?: Maybe<Array<Maybe<WixReceiptsV1LineItem>>>;
  /** Receipt numbering. */
  numbering?: Maybe<WixReceiptsV1ReceiptNumbering>;
  /** Payment details. */
  payment?: Maybe<WixReceiptsV1Payment>;
  /**
   * Receipt preset ID.
   * Defaults to the default receipt preset ID, available with Get Default Receipt Preset ID.
   */
  presetId?: Maybe<Scalars['String']>;
  /**
   * Regional properties pertaining to the receipt.
   * When regional properties are not provided, defaults are taken from the site's properties, available in the Site Properties API.
   */
  regionalProperties?: Maybe<WixReceiptsV1RegionalProperties>;
  /**
   * Revision number, which increments by 1 each time the receipt is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the receipt.
   */
  revision?: Maybe<Scalars['Long']>;
  /** Shipping info. */
  shippingInfo?: Maybe<WixReceiptsV1ShippingInfo>;
  /** Details about the associated Wix eCommerce or Wix Payments order. */
  sourceReference?: Maybe<WixReceiptsV1SourceReference>;
  /** Tax and taxable amounts breakdowns. */
  taxBreakdown?: Maybe<Array<Maybe<WixReceiptsV1Tax>>>;
  /** Summaries of totals including tax, shipping, additional fees and discounts. */
  totals?: Maybe<WixReceiptsV1Totals>;
  /**
   * Date and time the receipt was last updated.
   * Relevant updates include receipt regeneratation and number allocation changes. Updates to financial information are not stored.
   */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1ReceiptInput = {
  /** Additional fees. */
  additionalFees?: InputMaybe<Array<InputMaybe<WixReceiptsV1AdditionalFeeInput>>>;
  /**
   * Business details.
   * When business properties are not provided, defaults are taken from the site's properties, available in the Site Properties API.
   */
  businessDetails?: InputMaybe<WixReceiptsV1BusinessDetailsInput>;
  /** Date and time the receipt was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Currency code in [ISO-4217 alphabetic](https://www.iso.org/iso-4217-currency-codes.html) format. */
  currency?: InputMaybe<Scalars['String']>;
  /**
   * Custom fields for this receipt.
   * Values appear on the receipt in the specified order.
   */
  customFields?: InputMaybe<WixReceiptsV1CustomFieldsInput>;
  /** Customer details. */
  customer?: InputMaybe<WixReceiptsV1CustomerInput>;
  /** Discounts. */
  discounts?: InputMaybe<Array<InputMaybe<WixReceiptsV1DiscountInput>>>;
  /** Document details. */
  document?: InputMaybe<WixReceiptsV1DocumentInput>;
  /**
   * Custom field data for the receipt.
   * Extended fields must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Receipt ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item details. */
  lineItems?: InputMaybe<Array<InputMaybe<WixReceiptsV1LineItemInput>>>;
  /** Receipt numbering. */
  numbering?: InputMaybe<WixReceiptsV1ReceiptNumberingInput>;
  /** Payment details. */
  payment?: InputMaybe<WixReceiptsV1PaymentInput>;
  /**
   * Receipt preset ID.
   * Defaults to the default receipt preset ID, available with Get Default Receipt Preset ID.
   */
  presetId?: InputMaybe<Scalars['String']>;
  /**
   * Regional properties pertaining to the receipt.
   * When regional properties are not provided, defaults are taken from the site's properties, available in the Site Properties API.
   */
  regionalProperties?: InputMaybe<WixReceiptsV1RegionalPropertiesInput>;
  /**
   * Revision number, which increments by 1 each time the receipt is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the receipt.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** Shipping info. */
  shippingInfo?: InputMaybe<WixReceiptsV1ShippingInfoInput>;
  /** Details about the associated Wix eCommerce or Wix Payments order. */
  sourceReference?: InputMaybe<WixReceiptsV1SourceReferenceInput>;
  /** Tax and taxable amounts breakdowns. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<WixReceiptsV1TaxInput>>>;
  /** Summaries of totals including tax, shipping, additional fees and discounts. */
  totals?: InputMaybe<WixReceiptsV1TotalsInput>;
  /**
   * Date and time the receipt was last updated.
   * Relevant updates include receipt regeneratation and number allocation changes. Updates to financial information are not stored.
   */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1ReceiptNumbering = {
  __typename?: 'WixReceiptsV1ReceiptNumbering';
  /** Full receipt display number, in [prefix][number][suffix] format. */
  displayNumber?: Maybe<Scalars['String']>;
  /** Receipt number. */
  number?: Maybe<Scalars['Int']>;
  /** Receipt prefix that will be displayed before the receipt number. */
  prefix?: Maybe<Scalars['String']>;
  /** Receipt suffix that will be displayed after the receipt number. */
  suffix?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1ReceiptNumberingInput = {
  /** Full receipt display number, in [prefix][number][suffix] format. */
  displayNumber?: InputMaybe<Scalars['String']>;
  /** Receipt number. */
  number?: InputMaybe<Scalars['Int']>;
  /** Receipt prefix that will be displayed before the receipt number. */
  prefix?: InputMaybe<Scalars['String']>;
  /** Receipt suffix that will be displayed after the receipt number. */
  suffix?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1RegenerateReceiptDocumentRequestInput = {
  /** Receipt ID. */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1RegionalProperties = {
  __typename?: 'WixReceiptsV1RegionalProperties';
  /**
   * Receipt language. Determines the language of receipt static content (i.e. field and column titles). If not provided, defaults to locale's language.
   * Two-letter language code in [ISO-639-1 alpha-2](https://en.wikipedia.org/wiki/ISO_639-1) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Locale. Determines formating of numbers, dates and times. */
  locale?: Maybe<WixReceiptsV1Locale>;
  /** Time zone. Determines offset of dates and times. */
  timeZone?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1RegionalPropertiesInput = {
  /**
   * Receipt language. Determines the language of receipt static content (i.e. field and column titles). If not provided, defaults to locale's language.
   * Two-letter language code in [ISO-639-1 alpha-2](https://en.wikipedia.org/wiki/ISO_639-1) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Locale. Determines formating of numbers, dates and times. */
  locale?: InputMaybe<WixReceiptsV1LocaleInput>;
  /** Time zone. Determines offset of dates and times. */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1SendReceiptEmailRequestInput = {
  /** Recipient contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Receipt ID to send. */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1ShippingInfo = {
  __typename?: 'WixReceiptsV1ShippingInfo';
  /** Shipping price after all discounts (if any exist), and after tax. */
  priceAfterTax?: Maybe<Scalars['String']>;
  /** Shipping amount after discounts (when relevant), and before tax. */
  priceBeforeTax?: Maybe<Scalars['String']>;
  /** Shipping tax breakdown. */
  taxBreakdown?: Maybe<Array<Maybe<WixReceiptsV1ShippingTax>>>;
  /** Shipping title. */
  title?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1ShippingInfoInput = {
  /** Shipping price after all discounts (if any exist), and after tax. */
  priceAfterTax?: InputMaybe<Scalars['String']>;
  /** Shipping amount after discounts (when relevant), and before tax. */
  priceBeforeTax?: InputMaybe<Scalars['String']>;
  /** Shipping tax breakdown. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<WixReceiptsV1ShippingTaxInput>>>;
  /** Shipping title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1ShippingTax = {
  __typename?: 'WixReceiptsV1ShippingTax';
  /** Tax amount. */
  amount?: Maybe<Scalars['String']>;
  /** Tax name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Tax rate percentage.
   * Example: 0.1000 signifies 10% tax and 2.1000 signifies 210% tax.
   */
  rate?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1ShippingTaxInput = {
  /** Tax amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Tax name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Tax rate percentage.
   * Example: 0.1000 signifies 10% tax and 2.1000 signifies 210% tax.
   */
  rate?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1SourceReference = {
  __typename?: 'WixReceiptsV1SourceReference';
  /** ID of the app that generated the receipt. */
  appId?: Maybe<Scalars['String']>;
  /**
   * External reference ID.
   * For example: Wix eCommerce `orderId`, Wix Events `eventId`.
   */
  externalReferenceId?: Maybe<Scalars['String']>;
  /** Order type. */
  receiptOrderType?: Maybe<WixReceiptsV1SourceReferenceReceiptOrderType>;
  /** Wix eCommerce order. */
  wixEcomOrder?: Maybe<WixReceiptsV1SourceReferenceWixEcom>;
  /** Wix Payments order. */
  wixPaymentOrder?: Maybe<WixReceiptsV1SourceReferenceWixPayment>;
};

export type WixReceiptsV1SourceReferenceInput = {
  /** ID of the app that generated the receipt. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * External reference ID.
   * For example: Wix eCommerce `orderId`, Wix Events `eventId`.
   */
  externalReferenceId?: InputMaybe<Scalars['String']>;
  /** Order type. */
  receiptOrderType?: InputMaybe<WixReceiptsV1SourceReferenceReceiptOrderType>;
  /** Wix eCommerce order. */
  wixEcomOrder?: InputMaybe<WixReceiptsV1SourceReferenceWixEcomInput>;
  /** Wix Payments order. */
  wixPaymentOrder?: InputMaybe<WixReceiptsV1SourceReferenceWixPaymentInput>;
};

export enum WixReceiptsV1SourceReferenceReceiptOrderType {
  UnknownOrderType = 'UNKNOWN_ORDER_TYPE',
  WixEcom = 'WIX_ECOM',
  WixPayment = 'WIX_PAYMENT'
}

export type WixReceiptsV1SourceReferenceWixEcom = {
  __typename?: 'WixReceiptsV1SourceReferenceWixEcom';
  /** Wix eCommerce order ID. */
  orderId?: Maybe<Scalars['String']>;
  /** Wix eCommerce transaction ID. */
  transactionId?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1SourceReferenceWixEcomInput = {
  /** Wix eCommerce order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Wix eCommerce transaction ID. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1SourceReferenceWixPayment = {
  __typename?: 'WixReceiptsV1SourceReferenceWixPayment';
  /** Wix Payments order ID. */
  orderId?: Maybe<Scalars['String']>;
  /** Wix Payments transaction ID. */
  transactionId?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1SourceReferenceWixPaymentInput = {
  /** Wix Payments order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Wix Payments transaction ID. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1Tax = {
  __typename?: 'WixReceiptsV1Tax';
  /** Tax name. */
  name?: Maybe<Scalars['String']>;
  /** Tax rate percentage, as a positive decimal numeral. For example, "0.13". */
  rate?: Maybe<Scalars['String']>;
  /** Tax amount. */
  taxAmount?: Maybe<Scalars['String']>;
  /** Taxable amount this tax applies to. */
  taxableAmount?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1TaxInput = {
  /** Tax name. */
  name?: InputMaybe<Scalars['String']>;
  /** Tax rate percentage, as a positive decimal numeral. For example, "0.13". */
  rate?: InputMaybe<Scalars['String']>;
  /** Tax amount. */
  taxAmount?: InputMaybe<Scalars['String']>;
  /** Taxable amount this tax applies to. */
  taxableAmount?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1Totals = {
  __typename?: 'WixReceiptsV1Totals';
  /** Additional fee amount, before discounts and tax. */
  additionalFees?: Maybe<Scalars['String']>;
  /** Discount amount. */
  discount?: Maybe<Scalars['String']>;
  /** Shipping price, before discounts and tax. */
  shipping?: Maybe<Scalars['String']>;
  /** Subtotal of all line items, before discounts and before taxes. */
  subtotal?: Maybe<Scalars['String']>;
  /** Tax amount. */
  tax?: Maybe<Scalars['String']>;
  /** Total amount after all calculations. Equates to: subtotal - discounts + taxes + shipping + additional_fees. */
  total?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1TotalsInput = {
  /** Additional fee amount, before discounts and tax. */
  additionalFees?: InputMaybe<Scalars['String']>;
  /** Discount amount. */
  discount?: InputMaybe<Scalars['String']>;
  /** Shipping price, before discounts and tax. */
  shipping?: InputMaybe<Scalars['String']>;
  /** Subtotal of all line items, before discounts and before taxes. */
  subtotal?: InputMaybe<Scalars['String']>;
  /** Tax amount. */
  tax?: InputMaybe<Scalars['String']>;
  /** Total amount after all calculations. Equates to: subtotal - discounts + taxes + shipping + additional_fees. */
  total?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1UpdateExtendedFieldsResponse = {
  __typename?: 'WixReceiptsV1UpdateExtendedFieldsResponse';
  /** Updated receipt. */
  receipt?: Maybe<WixReceiptsV1Receipt>;
};

export type WixReceiptsV1UpstreamWixCommonAddress = {
  __typename?: 'WixReceiptsV1UpstreamWixCommonAddress';
  /** Main address line, usually street and number as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Country code. */
  country?: Maybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: Maybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<WixReceiptsV1UpstreamWixCommonAddressLocation>;
  /** Free text to help find the address. */
  hint?: Maybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: Maybe<WixReceiptsV1UpstreamWixCommonStreetAddress>;
  /** Subdivision shorthand. Usually, a short code (2 or 3 letters) that represents a state, region, prefecture, or province. e.g. NY */
  subdivision?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: Maybe<Scalars['String']>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2), e.g. US-NY */
  subdivisionIso31662?: Maybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: Maybe<Array<Maybe<WixReceiptsV1UpstreamWixCommonSubdivision>>>;
};

export type WixReceiptsV1UpstreamWixCommonAddressInput = {
  /** Main address line, usually street and number as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Country code. */
  country?: InputMaybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<WixReceiptsV1UpstreamWixCommonAddressLocationInput>;
  /** Free text to help find the address. */
  hint?: InputMaybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: InputMaybe<WixReceiptsV1UpstreamWixCommonStreetAddressInput>;
  /** Subdivision shorthand. Usually, a short code (2 or 3 letters) that represents a state, region, prefecture, or province. e.g. NY */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: InputMaybe<Scalars['String']>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2), e.g. US-NY */
  subdivisionIso31662?: InputMaybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: InputMaybe<Array<InputMaybe<WixReceiptsV1UpstreamWixCommonSubdivisionInput>>>;
};

export type WixReceiptsV1UpstreamWixCommonAddressLocation = {
  __typename?: 'WixReceiptsV1UpstreamWixCommonAddressLocation';
  /** Address latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type WixReceiptsV1UpstreamWixCommonAddressLocationInput = {
  /** Address latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type WixReceiptsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixReceiptsV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixReceiptsV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixReceiptsV1UpstreamWixCommonSortingInput>>>;
};

export type WixReceiptsV1UpstreamWixCommonFullAddressContactDetails = {
  __typename?: 'WixReceiptsV1UpstreamWixCommonFullAddressContactDetails';
  /** Contact's company name. */
  company?: Maybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: Maybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: Maybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: Maybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: Maybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: Maybe<Scalars['String']>;
  /** Tax info. Currently usable only in Brazil. */
  vatId?: Maybe<WixReceiptsV1UpstreamWixCommonVatId>;
};

export type WixReceiptsV1UpstreamWixCommonFullAddressContactDetailsInput = {
  /** Contact's company name. */
  company?: InputMaybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: InputMaybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Tax info. Currently usable only in Brazil. */
  vatId?: InputMaybe<WixReceiptsV1UpstreamWixCommonVatIdInput>;
};

export type WixReceiptsV1UpstreamWixCommonImage = {
  __typename?: 'WixReceiptsV1UpstreamWixCommonImage';
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixReceiptsV1UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export enum WixReceiptsV1UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixReceiptsV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixReceiptsV1UpstreamWixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type WixReceiptsV1UpstreamWixCommonStreetAddress = {
  __typename?: 'WixReceiptsV1UpstreamWixCommonStreetAddress';
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1UpstreamWixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1UpstreamWixCommonSubdivision = {
  __typename?: 'WixReceiptsV1UpstreamWixCommonSubdivision';
  /** Short subdivision code. */
  code?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: Maybe<Scalars['String']>;
  /** Standard organizations details (e.g. ISO). */
  standardDetails?: Maybe<WixReceiptsV1UpstreamWixCommonSubdivisionStandardDetails>;
  /** Subdivision level */
  type?: Maybe<WixReceiptsV1UpstreamWixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1UpstreamWixCommonSubdivisionInput = {
  /** Short subdivision code. */
  code?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: InputMaybe<Scalars['String']>;
  /** Standard organizations details (e.g. ISO). */
  standardDetails?: InputMaybe<WixReceiptsV1UpstreamWixCommonSubdivisionStandardDetailsInput>;
  /** Subdivision level */
  type?: InputMaybe<WixReceiptsV1UpstreamWixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1UpstreamWixCommonSubdivisionStandardDetails = {
  __typename?: 'WixReceiptsV1UpstreamWixCommonSubdivisionStandardDetails';
  /** subdivision iso-3166-2 code according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). e.g. US-NY, GB-SCT, NO-30 */
  iso31662?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1UpstreamWixCommonSubdivisionStandardDetailsInput = {
  /** subdivision iso-3166-2 code according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). e.g. US-NY, GB-SCT, NO-30 */
  iso31662?: InputMaybe<Scalars['String']>;
};

export enum WixReceiptsV1UpstreamWixCommonSubdivisionSubdivisionType {
  /** State */
  AdministrativeAreaLevel_1 = 'ADMINISTRATIVE_AREA_LEVEL_1',
  /** County */
  AdministrativeAreaLevel_2 = 'ADMINISTRATIVE_AREA_LEVEL_2',
  /** City/town */
  AdministrativeAreaLevel_3 = 'ADMINISTRATIVE_AREA_LEVEL_3',
  /** Neighborhood/quarter */
  AdministrativeAreaLevel_4 = 'ADMINISTRATIVE_AREA_LEVEL_4',
  /** Street/block */
  AdministrativeAreaLevel_5 = 'ADMINISTRATIVE_AREA_LEVEL_5',
  /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
  Country = 'COUNTRY',
  UnknownSubdivisionType = 'UNKNOWN_SUBDIVISION_TYPE'
}

export type WixReceiptsV1UpstreamWixCommonVatId = {
  __typename?: 'WixReceiptsV1UpstreamWixCommonVatId';
  /** Customer's tax ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: Maybe<WixReceiptsV1UpstreamWixCommonVatType>;
};

export type WixReceiptsV1UpstreamWixCommonVatIdInput = {
  /** Customer's tax ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: InputMaybe<WixReceiptsV1UpstreamWixCommonVatType>;
};

export enum WixReceiptsV1UpstreamWixCommonVatType {
  /** CNPJ - for corporations */
  Cnpj = 'CNPJ',
  /** CPF - for individual tax payers. */
  Cpf = 'CPF',
  Unspecified = 'UNSPECIFIED'
}

export type WixRestaurantsMenusItemModifierV1BulkCreateModifierResult = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkCreateModifierResult';
  /** Metadata for creation of the item modifer. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  /** Created item modifier. */
  modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
};

export type WixRestaurantsMenusItemModifierV1BulkCreateModifiersRequestInput = {
  /** List of item modifiers to create. */
  modifiers?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemModifierV1ModifierInput>>>;
  /**
   * Whether the created item modifiers are included in the response. <br />
   * Default: `false`.
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusItemModifierV1BulkCreateModifiersResponse = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkCreateModifiersResponse';
  /** Metadata for Bulk Create Modifiers API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created item modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkCreateModifierResult>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkDeleteModifiersRequestInput = {
  /** Item Modifier IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResponse = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the deleted modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResult>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResult = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResult';
  /** Metadata for modifiers deletion. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemRequestInput = {
  modifierIdAttachedToOrphanItem?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemModifierV1ModifierIdAttachedToOrphanItemInput>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponse = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponse';
  /** Information about the updated modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = {
  modifierIdLocationIds?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemModifierV1ModifierIdLocationIdsInput>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponse = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponse';
  /** Information about the updated modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsRequestInput = {
  /** Business Location Ids. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** modifier ids */
  modifierIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponse = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponse';
  /** Information about the updated modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateModifierResult = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkUpdateModifierResult';
  /** Metadata for the update of the item modifer. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  /** Updated item modifier. */
  modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateModifiersRequestInput = {
  /** List of item modifiers to update. */
  modifiers?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemModifierV1MaskedModifierInput>>>;
  /** Whether the updated item modifiers are included in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateModifiersResponse = {
  __typename?: 'WixRestaurantsMenusItemModifierV1BulkUpdateModifiersResponse';
  /** Metadata for Bulk Update Modifiers API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the updated item modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateModifierResult>>>;
};

export type WixRestaurantsMenusItemModifierV1CloneModifiersRequestInput = {
  /** The MetaSiteId to clone from */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1CountModifiersRequestInput = {
  /** Filter for counting modifiers. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixRestaurantsMenusItemModifierV1CountModifiersResponse = {
  __typename?: 'WixRestaurantsMenusItemModifierV1CountModifiersResponse';
  /** Counted modifiers. */
  count?: Maybe<Scalars['Int']>;
};

export type WixRestaurantsMenusItemModifierV1CreateModifierRequestInput = {
  /** Item modifier to create. */
  modifier?: InputMaybe<WixRestaurantsMenusItemModifierV1ModifierInput>;
};

export type WixRestaurantsMenusItemModifierV1CreateModifierResponse = {
  __typename?: 'WixRestaurantsMenusItemModifierV1CreateModifierResponse';
  /** Created item modifier. */
  modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
};

export type WixRestaurantsMenusItemModifierV1DeleteModifierRequestInput = {
  /** ID of the item modifier to delete. */
  modifierId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1ExternalReferenceInfo = {
  __typename?: 'WixRestaurantsMenusItemModifierV1ExternalReferenceInfo';
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this item modifier was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1ExternalReferenceInfoInput = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this item modifier was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1GetModifierRequestInput = {
  id: Scalars['ID'];
};

export type WixRestaurantsMenusItemModifierV1ListModifiersRequestInput = {
  /** IDs of the item modifiers to retrieve. */
  modifierIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Metadata of the paginated results. */
  paging?: InputMaybe<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput>;
};

export type WixRestaurantsMenusItemModifierV1ListModifiersResponse = {
  __typename?: 'WixRestaurantsMenusItemModifierV1ListModifiersResponse';
  /** Metadata of the paginated results. */
  metadata?: Maybe<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingMetadata>;
  /** Retrieved item modifiers. */
  modifiers?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1Modifier>>>;
};

export type WixRestaurantsMenusItemModifierV1MaskedModifierInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item modifier to update. */
  modifier?: InputMaybe<WixRestaurantsMenusItemModifierV1ModifierInput>;
};

export type WixRestaurantsMenusItemModifierV1Modifier = {
  __typename?: 'WixRestaurantsMenusItemModifierV1Modifier';
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: Maybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifiers are available. */
  businessLocationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Date and time the item modifier was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<WixRestaurantsMenusItemModifierV1ExternalReferenceInfo>;
  /** Item modifier ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Whether the modifier is in stock.
   * Default: `true`.
   */
  inStock?: Maybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifiers are available. */
  locations?: Maybe<ComWixpressLocationsQueryLocationsResponse>;
  /** Item modifier display name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the item modifier is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the item modifier. <br />
   *
   * Ignored when creating an item modifier.
   */
  revision?: Maybe<Scalars['Long']>;
  /** Date and time the item modifier was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixRestaurantsMenusItemModifierV1ModifierLocationsArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsQueryLocationsRequestInput>;
};

export type WixRestaurantsMenusItemModifierV1ModifierIdAttachedToOrphanItemInput = {
  /** Attached to orphan item */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** Modifier ID */
  modifierId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1ModifierIdLocationIdsInput = {
  /** Business Location IDs */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** modifier ID */
  modifierId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1ModifierInput = {
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifiers are available. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Date and time the item modifier was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<WixRestaurantsMenusItemModifierV1ExternalReferenceInfoInput>;
  /** Item modifier ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Whether the modifier is in stock.
   * Default: `true`.
   */
  inStock?: InputMaybe<Scalars['Boolean']>;
  /** Item modifier display name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the item modifier is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the item modifier. <br />
   *
   * Ignored when creating an item modifier.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the item modifier was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixRestaurantsMenusItemModifierV1ModifierType {
  Modifier = 'MODIFIER',
  UnknownVariationAndModifier = 'UNKNOWN_VARIATION_AND_MODIFIER',
  Variant = 'VARIANT'
}

export type WixRestaurantsMenusItemModifierV1QueryModifiersRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorQueryInput>;
};

export type WixRestaurantsMenusItemModifierV1QueryModifiersResponse = {
  __typename?: 'WixRestaurantsMenusItemModifierV1QueryModifiersResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1Modifier>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRestaurantsMenusItemModifierV1UpdateModifierRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item Modifier with updated properties. */
  modifier?: InputMaybe<WixRestaurantsMenusItemModifierV1ModifierInput>;
};

export type WixRestaurantsMenusItemModifierV1UpdateModifierResponse = {
  __typename?: 'WixRestaurantsMenusItemModifierV1UpdateModifierResponse';
  /** Updated item modifier. */
  modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
};

export type WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor pointing to the next page and the previous page in the list of results. */
  cursors?: Maybe<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursors>;
  /**
   * Whether there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * for more information.
   *
   * For a detailed list of supported filters, see
   * [Supported Filters](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifiers/supported-filters-and-sorting).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Sort object. */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursors = {
  __typename?: 'WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1BulkCreateVariantsRequestInput = {
  /** Whether to receive the created item variants in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Item variants details. */
  variants?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemVariantV1VariantInput>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkCreateVariantsResponse = {
  __typename?: 'WixRestaurantsMenusItemVariantV1BulkCreateVariantsResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created item variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkVariantResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkDeleteVariantsRequestInput = {
  /** Item variant IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResponse = {
  __typename?: 'WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the deleted variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResult = {
  __typename?: 'WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResult';
  /** Metadata for variants deletion. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemRequestInput = {
  variantIdAttachedToOrphanItem?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemVariantV1VariantIdAttachedToOrphanItemInput>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponse = {
  __typename?: 'WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponse';
  /** Information about the updated variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult = {
  __typename?: 'WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = {
  variantIdLocationIds?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemVariantV1VariantIdLocationIdsInput>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponse = {
  __typename?: 'WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponse';
  /** Information about the updated variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = {
  __typename?: 'WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsRequestInput = {
  /** Business Location Ids. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** variant ids */
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponse = {
  __typename?: 'WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponse';
  /** Information about the updated variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = {
  __typename?: 'WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateVariantsRequestInput = {
  /** Whether to receive the updated item variants in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Item variants to be updated. */
  variants?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemVariantV1MaskedVariantInput>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateVariantsResponse = {
  __typename?: 'WixRestaurantsMenusItemVariantV1BulkUpdateVariantsResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the updated item variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkVariantResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkVariantResult = {
  __typename?: 'WixRestaurantsMenusItemVariantV1BulkVariantResult';
  /** Metadata for creation of item variants. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  /** Created item variants. Only returned if the `returnEntity` value is `true`. */
  variant?: Maybe<WixRestaurantsMenusItemVariantV1Variant>;
};

export type WixRestaurantsMenusItemVariantV1CloneVariantsRequestInput = {
  /** The MetaSiteId to clone from */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1CountVariantsRequestInput = {
  /** Filter for counting variants. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixRestaurantsMenusItemVariantV1CountVariantsResponse = {
  __typename?: 'WixRestaurantsMenusItemVariantV1CountVariantsResponse';
  /** Counted variants. */
  count?: Maybe<Scalars['Int']>;
};

export type WixRestaurantsMenusItemVariantV1CreateVariantRequestInput = {
  /** Item variant info. */
  variant?: InputMaybe<WixRestaurantsMenusItemVariantV1VariantInput>;
};

export type WixRestaurantsMenusItemVariantV1CreateVariantResponse = {
  __typename?: 'WixRestaurantsMenusItemVariantV1CreateVariantResponse';
  /** Item variant. */
  variant?: Maybe<WixRestaurantsMenusItemVariantV1Variant>;
};

export type WixRestaurantsMenusItemVariantV1DeleteVariantRequestInput = {
  /** Item variant ID. */
  variantId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1ExternalReferenceInfo = {
  __typename?: 'WixRestaurantsMenusItemVariantV1ExternalReferenceInfo';
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this item variant was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1ExternalReferenceInfoInput = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this item variant was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1GetVariantRequestInput = {
  id: Scalars['ID'];
};

export type WixRestaurantsMenusItemVariantV1ListVariantsRequestInput = {
  /** The metadata of the paginated results. */
  paging?: InputMaybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput>;
  /** Item variant IDs. */
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusItemVariantV1ListVariantsResponse = {
  __typename?: 'WixRestaurantsMenusItemVariantV1ListVariantsResponse';
  /** The metadata of the paginated results. */
  metadata?: Maybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingMetadata>;
  /** The retrieved item variants. */
  variants?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1Variant>>>;
};

export type WixRestaurantsMenusItemVariantV1MaskedVariantInput = {
  /** Explicit list of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item variant to update. */
  variant?: InputMaybe<WixRestaurantsMenusItemVariantV1VariantInput>;
};

export type WixRestaurantsMenusItemVariantV1QueryVariantsRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixRestaurantsMenusItemVariantV1UpstreamWixQueryCursorQueryInput>;
};

export type WixRestaurantsMenusItemVariantV1QueryVariantsResponse = {
  __typename?: 'WixRestaurantsMenusItemVariantV1QueryVariantsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1Variant>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRestaurantsMenusItemVariantV1UpdateVariantRequestInput = {
  /** Set of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item variant to update. */
  variant?: InputMaybe<WixRestaurantsMenusItemVariantV1VariantInput>;
};

export type WixRestaurantsMenusItemVariantV1UpdateVariantResponse = {
  __typename?: 'WixRestaurantsMenusItemVariantV1UpdateVariantResponse';
  /** Updated item variant. */
  variant?: Maybe<WixRestaurantsMenusItemVariantV1Variant>;
};

export type WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursors = {
  __typename?: 'WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export enum WixRestaurantsMenusItemVariantV1UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixRestaurantsMenusItemVariantV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonSortOrder>;
};

export type WixRestaurantsMenusItemVariantV1UpstreamWixQueryCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonSortingInput>>>;
};

export type WixRestaurantsMenusItemVariantV1Variant = {
  __typename?: 'WixRestaurantsMenusItemVariantV1Variant';
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: Maybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item variants are available. */
  businessLocationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Date and time the item variant was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<WixRestaurantsMenusItemVariantV1ExternalReferenceInfo>;
  /** Item variant ID. */
  id?: Maybe<Scalars['String']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item variants are available. */
  locations?: Maybe<ComWixpressLocationsQueryLocationsResponse>;
  /** Item variant name. */
  name?: Maybe<Scalars['String']>;
  oloMigrationVariantId?: Maybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the item variant is updated. To prevent conflicting changes, the current revision must be passed when updating the item variant. Ignored when creating an item variant. */
  revision?: Maybe<Scalars['Long']>;
  /** Date and time the item variant was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixRestaurantsMenusItemVariantV1VariantLocationsArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsQueryLocationsRequestInput>;
};

export type WixRestaurantsMenusItemVariantV1VariantIdAttachedToOrphanItemInput = {
  /** Attached to orphan item */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** variant ID */
  variantId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1VariantIdLocationIdsInput = {
  /** Business Location IDs */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** variant ID */
  variantId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1VariantInput = {
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item variants are available. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Date and time the item variant was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<WixRestaurantsMenusItemVariantV1ExternalReferenceInfoInput>;
  /** Item variant ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Item variant name. */
  name?: InputMaybe<Scalars['String']>;
  oloMigrationVariantId?: InputMaybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the item variant is updated. To prevent conflicting changes, the current revision must be passed when updating the item variant. Ignored when creating an item variant. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the item variant was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1AdditionalChargeInfo = {
  __typename?: 'WixRestaurantsMenusV1AdditionalChargeInfo';
  /** Additional charge for the item modifier. A value of `0` means the item modifier is free. */
  additionalCharge?: Maybe<Scalars['String']>;
  /** Formatted additional charge. */
  formattedAdditionalCharge?: Maybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1AdditionalChargeInfoInput = {
  /** Additional charge for the item modifier. A value of `0` means the item modifier is free. */
  additionalCharge?: InputMaybe<Scalars['String']>;
  /** Formatted additional charge. */
  formattedAdditionalCharge?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1BulkCreateModifierGroupsRequestInput = {
  /** Modifier groups details. */
  modifierGroups?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusV1ModifierGroupInput>>>;
  /** Whether to receive the created modifier groups in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1BulkCreateModifierGroupsResponse = {
  __typename?: 'WixRestaurantsMenusV1BulkCreateModifierGroupsResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created modifier groups. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkCreateModifierGroupsResult>>>;
};

export type WixRestaurantsMenusV1BulkCreateModifierGroupsResult = {
  __typename?: 'WixRestaurantsMenusV1BulkCreateModifierGroupsResult';
  /** Metadata for group modifier creation. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  /** Created modifier group. */
  modifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
};

export type WixRestaurantsMenusV1BulkDeleteModifierGroupsRequestInput = {
  /** Modifier Group IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusV1BulkDeleteModifierGroupsResponse = {
  __typename?: 'WixRestaurantsMenusV1BulkDeleteModifierGroupsResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the deleted modifier group. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkDeleteModifierGroupsResult>>>;
};

export type WixRestaurantsMenusV1BulkDeleteModifierGroupsResult = {
  __typename?: 'WixRestaurantsMenusV1BulkDeleteModifierGroupsResult';
  /** Metadata for group modifier deletion. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemRequestInput = {
  modifierGroupIdAttachedToOrphanItem?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusV1ModifierGroupIdAttachedToOrphanItemInput>>>;
};

export type WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponse = {
  __typename?: 'WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponse';
  /** Information about the updated modifier groups. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult = {
  __typename?: 'WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = {
  modifierGroupIdLocationIds?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusV1ModifierGroupIdLocationIdsInput>>>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponse = {
  __typename?: 'WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponse';
  /** Information about the updated modifier groups. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = {
  __typename?: 'WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsRequestInput = {
  /** Business Location IDs. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Modifier group IDs */
  modifierGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponse = {
  __typename?: 'WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponse';
  /** Information about the updated modifier groups. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = {
  __typename?: 'WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponseBulkItemResult';
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusV1BulkUpdateModifierGroupsRequestInput = {
  /** Modifier groups to update. */
  modifierGroups?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusV1MaskedModifierGroupInput>>>;
  /** Whether to receive the updated modifier groups in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1BulkUpdateModifierGroupsResponse = {
  __typename?: 'WixRestaurantsMenusV1BulkUpdateModifierGroupsResponse';
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the updated modifier groups. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkUpdateModifierGroupsResult>>>;
};

export type WixRestaurantsMenusV1BulkUpdateModifierGroupsResult = {
  __typename?: 'WixRestaurantsMenusV1BulkUpdateModifierGroupsResult';
  /** Metadata for group modifier update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  /** Updated modifier group. Only returned if `returnEntity` is set to `true`. */
  modifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
};

export type WixRestaurantsMenusV1CloneModifierGroupsRequestInput = {
  /** The MetaSiteId to clone from. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1CountModifierGroupsRequestInput = {
  /** Filter for counting modifier groups. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixRestaurantsMenusV1CountModifierGroupsResponse = {
  __typename?: 'WixRestaurantsMenusV1CountModifierGroupsResponse';
  /** Counted modifier groups. */
  count?: Maybe<Scalars['Int']>;
};

export type WixRestaurantsMenusV1CreateModifierGroupRequestInput = {
  /** Modifier group details. */
  modifierGroup?: InputMaybe<WixRestaurantsMenusV1ModifierGroupInput>;
};

export type WixRestaurantsMenusV1CreateModifierGroupResponse = {
  __typename?: 'WixRestaurantsMenusV1CreateModifierGroupResponse';
  /** Modifier group. */
  modifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
};

export type WixRestaurantsMenusV1DeleteLocationIdsFromModifiersInput = {
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifierIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusV1DeleteModifierGroupRequestInput = {
  /** Modifier group ID. */
  modifierGroupId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1ExternalReferenceInfo = {
  __typename?: 'WixRestaurantsMenusV1ExternalReferenceInfo';
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this modifier group was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1ExternalReferenceInfoInput = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this modifier group was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1GetModifierGroupRequestInput = {
  id: Scalars['ID'];
};

export type WixRestaurantsMenusV1ListModifierGroupRequestInput = {
  /** Modifier group IDs. */
  modifierGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The metadata of the paginated results. */
  paging?: InputMaybe<WixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput>;
};

export type WixRestaurantsMenusV1ListModifierGroupResponse = {
  __typename?: 'WixRestaurantsMenusV1ListModifierGroupResponse';
  /** The metadata of the paginated results. */
  metadata?: Maybe<WixRestaurantsMenusV1UpstreamWixCommonCursorPagingMetadata>;
  /** Retrieved modifier groups. */
  modifierGroups?: Maybe<Array<Maybe<WixRestaurantsMenusV1ModifierGroup>>>;
};

export type WixRestaurantsMenusV1MaskedModifierGroupInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Modifier group to update. */
  modifierGroup?: InputMaybe<WixRestaurantsMenusV1ModifierGroupInput>;
};

export type WixRestaurantsMenusV1Modifier = {
  __typename?: 'WixRestaurantsMenusV1Modifier';
  /**
   * Deprecated, modifier additional charge. Can be 0 to represent free.
   * @deprecated Deprecated, modifier additional charge. Can be 0 to represent free. Replaced by: AdditionalChargeInfo.additional_charge. Removal date: 2024-06-30.
   */
  additionalCharge?: Maybe<Scalars['String']>;
  /** Item modifier price details. */
  additionalChargeInfo?: Maybe<WixRestaurantsMenusV1AdditionalChargeInfo>;
  /** Item modifier ID. */
  id?: Maybe<Scalars['String']>;
  /** Item modifier ID. */
  modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
  /**
   * Whether the item modifier is pre-selected.
   * Default: `false`.
   */
  preSelected?: Maybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1ModifierGroup = {
  __typename?: 'WixRestaurantsMenusV1ModifierGroup';
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: Maybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifier groups are available. */
  businessLocationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Date and time the modifier group was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<WixRestaurantsMenusV1ExternalReferenceInfo>;
  /** Modifier group ID. */
  id?: Maybe<Scalars['String']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifier groups are available. */
  locations?: Maybe<ComWixpressLocationsQueryLocationsResponse>;
  /** Group of item modifiers. */
  modifiers?: Maybe<Array<Maybe<WixRestaurantsMenusV1Modifier>>>;
  /** Modifier group name. */
  name?: Maybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the modifier group is updated. To prevent conflicting changes, the current revision must be passed when updating the modifier group. Ignored when creating a modifier group. */
  revision?: Maybe<Scalars['Long']>;
  /** Modifier group details. */
  rule?: Maybe<WixRestaurantsMenusV1Rule>;
  /** Date and time the modifier group was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixRestaurantsMenusV1ModifierGroupLocationsArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsQueryLocationsRequestInput>;
};

export type WixRestaurantsMenusV1ModifierGroupIdAttachedToOrphanItemInput = {
  /** Attached to orphan item */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** Modifier group ID */
  modifierGroupId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1ModifierGroupIdLocationIdsInput = {
  /** Business Location IDs */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Modifier group ID */
  modifierGroupId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1ModifierGroupInput = {
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifier groups are available. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Date and time the modifier group was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<WixRestaurantsMenusV1ExternalReferenceInfoInput>;
  /** Modifier group ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Group of item modifiers. */
  modifiers?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusV1ModifierInput>>>;
  /** Modifier group name. */
  name?: InputMaybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the modifier group is updated. To prevent conflicting changes, the current revision must be passed when updating the modifier group. Ignored when creating a modifier group. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Modifier group details. */
  rule?: InputMaybe<WixRestaurantsMenusV1RuleInput>;
  /** Date and time the modifier group was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1ModifierInput = {
  /** Item modifier price details. */
  additionalChargeInfo?: InputMaybe<WixRestaurantsMenusV1AdditionalChargeInfoInput>;
  /** Item modifier ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Whether the item modifier is pre-selected.
   * Default: `false`.
   */
  preSelected?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1QueryModifierGroupsRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixRestaurantsMenusV1UpstreamWixCommonCursorQueryInput>;
};

export type WixRestaurantsMenusV1QueryModifierGroupsResponse = {
  __typename?: 'WixRestaurantsMenusV1QueryModifierGroupsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixRestaurantsMenusV1ModifierGroup>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRestaurantsMenusV1Rule = {
  __typename?: 'WixRestaurantsMenusV1Rule';
  /** Maximum number of item modifiers a site visitor may select. Must be greater than or equal to the value of `minSelections`. */
  maxSelections?: Maybe<Scalars['Int']>;
  /**
   * Minimum number of item modifiers a site visitor must select. The value must be lower or equal to the available item modifiers in the group.
   * Default: `0`.
   */
  minSelections?: Maybe<Scalars['Int']>;
  /** Whether the items from the modifier group must be selected. */
  required?: Maybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1RuleInput = {
  /** Maximum number of item modifiers a site visitor may select. Must be greater than or equal to the value of `minSelections`. */
  maxSelections?: InputMaybe<Scalars['Int']>;
  /**
   * Minimum number of item modifiers a site visitor must select. The value must be lower or equal to the available item modifiers in the group.
   * Default: `0`.
   */
  minSelections?: InputMaybe<Scalars['Int']>;
  /** Whether the items from the modifier group must be selected. */
  required?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1RuleMultiSelect = {
  __typename?: 'WixRestaurantsMenusV1RuleMultiSelect';
  /** Number of selections given to the customer for free. */
  freeSelections?: Maybe<Scalars['Int']>;
  /** Maximum number of extras a customer can choose. Must be greater than or equal to the value of `minSelections`. */
  maxSelections?: Maybe<Scalars['Int']>;
  /** Minimum number of extras a customer must choose. Defaults to `0`. Must be lower or equal to the available modifiers in the group */
  minSelections?: Maybe<Scalars['Int']>;
};

export type WixRestaurantsMenusV1RuleMultiSelectInput = {
  /** Number of selections given to the customer for free. */
  freeSelections?: InputMaybe<Scalars['Int']>;
  /** Maximum number of extras a customer can choose. Must be greater than or equal to the value of `minSelections`. */
  maxSelections?: InputMaybe<Scalars['Int']>;
  /** Minimum number of extras a customer must choose. Defaults to `0`. Must be lower or equal to the available modifiers in the group */
  minSelections?: InputMaybe<Scalars['Int']>;
};

export enum WixRestaurantsMenusV1RuleType {
  MultiSelect = 'MULTI_SELECT',
  SingleSelect = 'SINGLE_SELECT',
  UnspecifiedRule = 'UNSPECIFIED_RULE'
}

export type WixRestaurantsMenusV1UpdateModifierGroupRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Modifier group to update. */
  modifierGroup?: InputMaybe<WixRestaurantsMenusV1ModifierGroupInput>;
};

export type WixRestaurantsMenusV1UpdateModifierGroupResponse = {
  __typename?: 'WixRestaurantsMenusV1UpdateModifierGroupResponse';
  /** Updated modifier group. */
  modifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
};

export type WixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixRestaurantsMenusV1UpstreamWixCommonCursorPagingMetadata = {
  __typename?: 'WixRestaurantsMenusV1UpstreamWixCommonCursorPagingMetadata';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<WixRestaurantsMenusV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type WixRestaurantsMenusV1UpstreamWixCommonCursors = {
  __typename?: 'WixRestaurantsMenusV1UpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AnchorData = {
  __typename?: 'WixRichContentV1AnchorData';
  /** The target node's ID. */
  anchor?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AnchorDataInput = {
  /** The target node's ID. */
  anchor?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedData = {
  __typename?: 'WixRichContentV1AppEmbedData';
  /** Data for embedded Wix Bookings content. */
  bookingData?: Maybe<WixRichContentV1AppEmbedDataBookingData>;
  /** Data for embedded Wix Events content. */
  eventData?: Maybe<WixRichContentV1AppEmbedDataEventData>;
  /** An image for the embedded content. */
  image?: Maybe<WixRichContentV1Media>;
  /** Deprecated: Use `image` instead. */
  imageSrc?: Maybe<Scalars['String']>;
  /** The ID of the embedded content. */
  itemId?: Maybe<Scalars['String']>;
  /** The name of the embedded content. */
  name?: Maybe<Scalars['String']>;
  /** The type of Wix App content being embedded. */
  type?: Maybe<WixRichContentV1AppEmbedDataAppType>;
  /** The URL for the embedded content. */
  url?: Maybe<Scalars['String']>;
};

export enum WixRichContentV1AppEmbedDataAppType {
  Booking = 'BOOKING',
  Event = 'EVENT',
  Product = 'PRODUCT'
}

export type WixRichContentV1AppEmbedDataBookingData = {
  __typename?: 'WixRichContentV1AppEmbedDataBookingData';
  /** Booking duration in minutes. */
  durations?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataBookingDataInput = {
  /** Booking duration in minutes. */
  durations?: InputMaybe<Scalars['String']>;
};

export enum WixRichContentV1AppEmbedDataCardStylesAlignment {
  /** Content centered */
  Center = 'CENTER',
  /** Content aligned to end (right in LTR layouts, left in RTL layouts) */
  End = 'END',
  /** Content aligned to start (left in LTR layouts, right in RTL layouts) */
  Start = 'START'
}

export enum WixRichContentV1AppEmbedDataCardStylesLayout {
  /** Elements arranged horizontally */
  SideBySide = 'SIDE_BY_SIDE',
  /** Elements stacked vertically */
  Stacked = 'STACKED'
}

export enum WixRichContentV1AppEmbedDataCardStylesType {
  /** Card with visible border and background */
  Contained = 'CONTAINED',
  /** Card without visible border */
  Frameless = 'FRAMELESS'
}

export type WixRichContentV1AppEmbedDataEventData = {
  __typename?: 'WixRichContentV1AppEmbedDataEventData';
  /** Event location. */
  location?: Maybe<Scalars['String']>;
  /** Event schedule. */
  scheduling?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataEventDataInput = {
  /** Event location. */
  location?: InputMaybe<Scalars['String']>;
  /** Event schedule. */
  scheduling?: InputMaybe<Scalars['String']>;
};

export enum WixRichContentV1AppEmbedDataImageStylesAspectRatio {
  /** 16:9 aspect ratio */
  Rectangle = 'RECTANGLE',
  /** 1:1 aspect ratio */
  Square = 'SQUARE'
}

export enum WixRichContentV1AppEmbedDataImageStylesPosition {
  /** Image positioned at the end (right in LTR layouts, left in RTL layouts) */
  End = 'END',
  /** Image positioned at the start (left in LTR layouts, right in RTL layouts) */
  Start = 'START',
  /** Image positioned at the top */
  Top = 'TOP'
}

export enum WixRichContentV1AppEmbedDataImageStylesResizing {
  /** Fill the container, may crop the image */
  Fill = 'FILL',
  /** Fit the image within the container */
  Fit = 'FIT'
}

export type WixRichContentV1AppEmbedDataInput = {
  /** Data for embedded Wix Bookings content. */
  bookingData?: InputMaybe<WixRichContentV1AppEmbedDataBookingDataInput>;
  /** Data for embedded Wix Events content. */
  eventData?: InputMaybe<WixRichContentV1AppEmbedDataEventDataInput>;
  /** An image for the embedded content. */
  image?: InputMaybe<WixRichContentV1MediaInput>;
  /** Deprecated: Use `image` instead. */
  imageSrc?: InputMaybe<Scalars['String']>;
  /** The ID of the embedded content. */
  itemId?: InputMaybe<Scalars['String']>;
  /** The name of the embedded content. */
  name?: InputMaybe<Scalars['String']>;
  /** The type of Wix App content being embedded. */
  type?: InputMaybe<WixRichContentV1AppEmbedDataAppType>;
  /** The URL for the embedded content. */
  url?: InputMaybe<Scalars['String']>;
};

export enum WixRichContentV1AppEmbedDataRibbonStylesPlacement {
  /** Ribbon placed on the image */
  Image = 'IMAGE',
  /** Ribbon placed on the product information */
  ProductInfo = 'PRODUCT_INFO'
}

export type WixRichContentV1AudioData = {
  __typename?: 'WixRichContentV1AudioData';
  /** Audio file details. */
  audio?: Maybe<WixRichContentV1Media>;
  /** Author name. */
  authorName?: Maybe<Scalars['String']>;
  /** Styling for the audio node's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Cover image. */
  coverImage?: Maybe<WixRichContentV1Media>;
  /** Sets whether the audio node's download button is disabled. Defaults to `false`. */
  disableDownload?: Maybe<Scalars['Boolean']>;
  /** An HTML version of the audio node. */
  html?: Maybe<Scalars['String']>;
  /** Track name. */
  name?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AudioDataInput = {
  /** Audio file details. */
  audio?: InputMaybe<WixRichContentV1MediaInput>;
  /** Author name. */
  authorName?: InputMaybe<Scalars['String']>;
  /** Styling for the audio node's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Cover image. */
  coverImage?: InputMaybe<WixRichContentV1MediaInput>;
  /** Sets whether the audio node's download button is disabled. Defaults to `false`. */
  disableDownload?: InputMaybe<Scalars['Boolean']>;
  /** An HTML version of the audio node. */
  html?: InputMaybe<Scalars['String']>;
  /** Track name. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1BlockquoteData = {
  __typename?: 'WixRichContentV1BlockquoteData';
  /** Indentation level from 1-4. */
  indentation?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1BlockquoteDataInput = {
  /** Indentation level from 1-4. */
  indentation?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1BulletedListData = {
  __typename?: 'WixRichContentV1BulletedListData';
  /** Indentation level from 0-4. */
  indentation?: Maybe<Scalars['Int']>;
  /** Offset level from 0-4. */
  offset?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1BulletedListDataInput = {
  /** Indentation level from 0-4. */
  indentation?: InputMaybe<Scalars['Int']>;
  /** Offset level from 0-4. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1ButtonData = {
  __typename?: 'WixRichContentV1ButtonData';
  /** Styling for the button's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Button link details. */
  link?: Maybe<WixRichContentV1Link>;
  /** Styling for the button. */
  styles?: Maybe<WixRichContentV1ButtonDataStyles>;
  /** The text to display on the button. */
  text?: Maybe<Scalars['String']>;
  /** The button type. */
  type?: Maybe<WixRichContentV1ButtonDataType>;
};

export type WixRichContentV1ButtonDataInput = {
  /** Styling for the button's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Button link details. */
  link?: InputMaybe<WixRichContentV1LinkInput>;
  /** Styling for the button. */
  styles?: InputMaybe<WixRichContentV1ButtonDataStylesInput>;
  /** The text to display on the button. */
  text?: InputMaybe<Scalars['String']>;
  /** The button type. */
  type?: InputMaybe<WixRichContentV1ButtonDataType>;
};

export type WixRichContentV1ButtonDataStyles = {
  __typename?: 'WixRichContentV1ButtonDataStyles';
  /** Border attributes. */
  border?: Maybe<WixRichContentV1ButtonDataStylesBorder>;
  /** Color attributes. */
  colors?: Maybe<WixRichContentV1ButtonDataStylesColors>;
};

export type WixRichContentV1ButtonDataStylesBorder = {
  __typename?: 'WixRichContentV1ButtonDataStylesBorder';
  /** Border radius in pixels. */
  radius?: Maybe<Scalars['Int']>;
  /** Border width in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1ButtonDataStylesBorderInput = {
  /** Deprecated: Use `borderRadius` in `styles` instead. */
  radius?: InputMaybe<Scalars['Int']>;
  /** Deprecated: Use `borderWidth` in `styles` instead. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1ButtonDataStylesColors = {
  __typename?: 'WixRichContentV1ButtonDataStylesColors';
  /** The background color as a hexadecimal value. */
  background?: Maybe<Scalars['String']>;
  /** The border color as a hexadecimal value. */
  border?: Maybe<Scalars['String']>;
  /** The text color as a hexadecimal value. */
  text?: Maybe<Scalars['String']>;
};

export type WixRichContentV1ButtonDataStylesColorsInput = {
  /** Deprecated: Use `backgroundColor` in `styles` instead. */
  background?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `borderColor` in `styles` instead. */
  border?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `textColor` in `styles` instead. */
  text?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1ButtonDataStylesInput = {
  /** Background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Background color as a hexadecimal value (hover state). */
  backgroundColorHover?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `borderWidth` and `borderRadius` instead. */
  border?: InputMaybe<WixRichContentV1ButtonDataStylesBorderInput>;
  /** Border color as a hexadecimal value. */
  borderColor?: InputMaybe<Scalars['String']>;
  /** Border color as a hexadecimal value (hover state). */
  borderColorHover?: InputMaybe<Scalars['String']>;
  /** Border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
  /** Border width in pixels. */
  borderWidth?: InputMaybe<Scalars['Int']>;
  /** Deprecated: Use `borderWidth` for normal/hover states instead. */
  borderWidthHover?: InputMaybe<Scalars['Int']>;
  /** Button size option, one of `SMALL`, `MEDIUM` or `LARGE`. Defaults to `MEDIUM`. */
  buttonSize?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `textColor`, `borderColor` and `backgroundColor` instead. */
  colors?: InputMaybe<WixRichContentV1ButtonDataStylesColorsInput>;
  /** Text color as a hexadecimal value. */
  textColor?: InputMaybe<Scalars['String']>;
  /** Text color as a hexadecimal value (hover state). */
  textColorHover?: InputMaybe<Scalars['String']>;
};

export enum WixRichContentV1ButtonDataType {
  /** Triggers custom action that is defined in plugin configuration by the consumer */
  Action = 'ACTION',
  /** Regular link button */
  Link = 'LINK'
}

export type WixRichContentV1CaptionData = {
  __typename?: 'WixRichContentV1CaptionData';
  textStyle?: Maybe<WixRichContentV1TextStyle>;
};

export type WixRichContentV1CaptionDataInput = {
  textStyle?: InputMaybe<WixRichContentV1TextStyleInput>;
};

export type WixRichContentV1CodeBlockData = {
  __typename?: 'WixRichContentV1CodeBlockData';
  /** Styling for the code block's text. */
  textStyle?: Maybe<WixRichContentV1TextStyle>;
};

export type WixRichContentV1CodeBlockDataInput = {
  /** Styling for the code block's text. */
  textStyle?: InputMaybe<WixRichContentV1TextStyleInput>;
};

export type WixRichContentV1CollapsibleListData = {
  __typename?: 'WixRichContentV1CollapsibleListData';
  /** Styling for the collapsible list's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** The direction of the text in the list. Either left-to-right or right-to-left. */
  direction?: Maybe<WixRichContentV1CollapsibleListDataDirection>;
  /** If `true`, only one item can be expanded at a time. Defaults to `false`. */
  expandOnlyOne?: Maybe<Scalars['Boolean']>;
  /** Sets which items are expanded when the page loads. */
  initialExpandedItems?: Maybe<WixRichContentV1CollapsibleListDataInitialExpandedItems>;
  /** If `true`, The collapsible item will appear in search results as an FAQ. */
  isQapageData?: Maybe<Scalars['Boolean']>;
};

export enum WixRichContentV1CollapsibleListDataDirection {
  /** Left-to-right */
  Ltr = 'LTR',
  /** Right-to-left */
  Rtl = 'RTL'
}

export enum WixRichContentV1CollapsibleListDataInitialExpandedItems {
  /** All items will expended initally */
  All = 'ALL',
  /** First item will be expended initally */
  First = 'FIRST',
  /** All items collapsed initally */
  None = 'NONE'
}

export type WixRichContentV1CollapsibleListDataInput = {
  /** Styling for the collapsible list's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** The direction of the text in the list. Either left-to-right or right-to-left. */
  direction?: InputMaybe<WixRichContentV1CollapsibleListDataDirection>;
  /** If `true`, only one item can be expanded at a time. Defaults to `false`. */
  expandOnlyOne?: InputMaybe<Scalars['Boolean']>;
  /** Sets which items are expanded when the page loads. */
  initialExpandedItems?: InputMaybe<WixRichContentV1CollapsibleListDataInitialExpandedItems>;
  /** If `true`, The collapsible item will appear in search results as an FAQ. */
  isQapageData?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1ColorData = {
  __typename?: 'WixRichContentV1ColorData';
  /** The text's background color as a hexadecimal value. */
  background?: Maybe<Scalars['String']>;
  /** The text's foreground color as a hexadecimal value. */
  foreground?: Maybe<Scalars['String']>;
};

export type WixRichContentV1ColorDataInput = {
  /** The text's background color as a hexadecimal value. */
  background?: InputMaybe<Scalars['String']>;
  /** The text's foreground color as a hexadecimal value. */
  foreground?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1Decoration = {
  __typename?: 'WixRichContentV1Decoration';
  /** Data for an anchor link decoration. */
  anchorData?: Maybe<WixRichContentV1AnchorData>;
  /** Data for a color decoration. */
  colorData?: Maybe<WixRichContentV1ColorData>;
  /** Data for a font size decoration. */
  fontSizeData?: Maybe<WixRichContentV1FontSizeData>;
  /** Font weight for a bold decoration. */
  fontWeightValue?: Maybe<Scalars['Int']>;
  /** Data for an italic decoration. Defaults to `true`. */
  italicData?: Maybe<Scalars['Boolean']>;
  /** Data for an external link decoration. */
  linkData?: Maybe<WixRichContentV1LinkData>;
  /** Data for a mention decoration. */
  mentionData?: Maybe<WixRichContentV1MentionData>;
  /** Data for a spoiler decoration. */
  spoilerData?: Maybe<WixRichContentV1SpoilerData>;
  /** The type of decoration to apply. */
  type?: Maybe<WixRichContentV1DecorationType>;
  /** Data for an underline decoration. Defaults to `true`. */
  underlineData?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1DecorationInput = {
  /** Data for an anchor link decoration. */
  anchorData?: InputMaybe<WixRichContentV1AnchorDataInput>;
  /** Data for a color decoration. */
  colorData?: InputMaybe<WixRichContentV1ColorDataInput>;
  /** Data for a font size decoration. */
  fontSizeData?: InputMaybe<WixRichContentV1FontSizeDataInput>;
  /** Font weight for a bold decoration. */
  fontWeightValue?: InputMaybe<Scalars['Int']>;
  /** Data for an italic decoration. Defaults to `true`. */
  italicData?: InputMaybe<Scalars['Boolean']>;
  /** Data for an external link decoration. */
  linkData?: InputMaybe<WixRichContentV1LinkDataInput>;
  /** Data for a mention decoration. */
  mentionData?: InputMaybe<WixRichContentV1MentionDataInput>;
  /** Data for a spoiler decoration. */
  spoilerData?: InputMaybe<WixRichContentV1SpoilerDataInput>;
  /** Data for a strikethrough decoration. Defaults to `true`. */
  strikethroughData?: InputMaybe<Scalars['Boolean']>;
  /** The type of decoration to apply. */
  type?: InputMaybe<WixRichContentV1DecorationType>;
  /** Data for an underline decoration. Defaults to `true`. */
  underlineData?: InputMaybe<Scalars['Boolean']>;
};

export enum WixRichContentV1DecorationType {
  Anchor = 'ANCHOR',
  Bold = 'BOLD',
  Color = 'COLOR',
  External = 'EXTERNAL',
  FontSize = 'FONT_SIZE',
  Italic = 'ITALIC',
  Link = 'LINK',
  Mention = 'MENTION',
  Spoiler = 'SPOILER',
  Underline = 'UNDERLINE'
}

export type WixRichContentV1DividerData = {
  __typename?: 'WixRichContentV1DividerData';
  /** Divider alignment. */
  alignment?: Maybe<WixRichContentV1DividerDataAlignment>;
  /** Styling for the divider's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Divider line style. */
  lineStyle?: Maybe<WixRichContentV1DividerDataLineStyle>;
  /** Divider width. */
  width?: Maybe<WixRichContentV1DividerDataWidth>;
};

export enum WixRichContentV1DividerDataAlignment {
  /** Center alignment */
  Center = 'CENTER',
  /** Left alignment */
  Left = 'LEFT',
  /** Right alignment */
  Right = 'RIGHT'
}

export type WixRichContentV1DividerDataInput = {
  /** Divider alignment. */
  alignment?: InputMaybe<WixRichContentV1DividerDataAlignment>;
  /** Styling for the divider's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Divider line style. */
  lineStyle?: InputMaybe<WixRichContentV1DividerDataLineStyle>;
  /** Divider width. */
  width?: InputMaybe<WixRichContentV1DividerDataWidth>;
};

export enum WixRichContentV1DividerDataLineStyle {
  /** Dashed Line */
  Dashed = 'DASHED',
  /** Dotted Line */
  Dotted = 'DOTTED',
  /** Double Line */
  Double = 'DOUBLE',
  /** Single Line */
  Single = 'SINGLE'
}

export enum WixRichContentV1DividerDataWidth {
  /** Large line */
  Large = 'LARGE',
  /** Medium line */
  Medium = 'MEDIUM',
  /** Small line */
  Small = 'SMALL'
}

export type WixRichContentV1DocumentStyle = {
  __typename?: 'WixRichContentV1DocumentStyle';
  /** Styling for block quote nodes. */
  blockquote?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for code block nodes. */
  codeBlock?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H5 nodes. */
  headerFive?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H4 nodes. */
  headerFour?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H1 nodes. */
  headerOne?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H6 nodes. */
  headerSix?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H3 nodes. */
  headerThree?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H2 nodes. */
  headerTwo?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for paragraph nodes. */
  paragraph?: Maybe<WixRichContentV1TextNodeStyle>;
};

export type WixRichContentV1DocumentStyleInput = {
  /** Styling for block quote nodes. */
  blockquote?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for code block nodes. */
  codeBlock?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H5 nodes. */
  headerFive?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H4 nodes. */
  headerFour?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H1 nodes. */
  headerOne?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H6 nodes. */
  headerSix?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H3 nodes. */
  headerThree?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H2 nodes. */
  headerTwo?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for paragraph nodes. */
  paragraph?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
};

export type WixRichContentV1EmbedData = {
  __typename?: 'WixRichContentV1EmbedData';
  /** Styling for the oEmbed node's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** An [oEmbed](https://www.oembed.com) object. */
  oembed?: Maybe<WixRichContentV1Oembed>;
  /** Origin asset source. */
  src?: Maybe<Scalars['String']>;
};

export type WixRichContentV1EmbedDataInput = {
  /** Styling for the oEmbed node's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** An [oEmbed](https://www.oembed.com) object. */
  oembed?: InputMaybe<WixRichContentV1OembedInput>;
  /** Origin asset source. */
  src?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1FileData = {
  __typename?: 'WixRichContentV1FileData';
  /** Styling for the file's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** File MIME type. */
  mimeType?: Maybe<Scalars['String']>;
  /** File name. */
  name?: Maybe<Scalars['String']>;
  /** File path. */
  path?: Maybe<Scalars['String']>;
  /** Settings for PDF files. */
  pdfSettings?: Maybe<WixRichContentV1FileDataPdfSettings>;
  /** Use `sizeInKb` instead. */
  size?: Maybe<Scalars['Int']>;
  /** File size in KB. */
  sizeInKb?: Maybe<Scalars['String']>;
  /** The source for the file's data. */
  src?: Maybe<WixRichContentV1FileSource>;
  /** File type. */
  type?: Maybe<Scalars['String']>;
};

export type WixRichContentV1FileDataInput = {
  /** Styling for the file's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** File MIME type. */
  mimeType?: InputMaybe<Scalars['String']>;
  /** File name. */
  name?: InputMaybe<Scalars['String']>;
  /** File path. */
  path?: InputMaybe<Scalars['String']>;
  /** Settings for PDF files. */
  pdfSettings?: InputMaybe<WixRichContentV1FileDataPdfSettingsInput>;
  /** Use `sizeInKb` instead. */
  size?: InputMaybe<Scalars['Int']>;
  /** File size in KB. */
  sizeInKb?: InputMaybe<Scalars['String']>;
  /** The source for the file's data. */
  src?: InputMaybe<WixRichContentV1FileSourceInput>;
  /** File type. */
  type?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1FileDataPdfSettings = {
  __typename?: 'WixRichContentV1FileDataPDFSettings';
  /** Sets whether the PDF download button is disabled. Defaults to `false`. */
  disableDownload?: Maybe<Scalars['Boolean']>;
  /** Sets whether the PDF print button is disabled. Defaults to `false`. */
  disablePrint?: Maybe<Scalars['Boolean']>;
  /**
   * PDF view mode. One of the following:
   * `NONE` : The PDF isn't displayed.
   * `FULL` : A full page view of the PDF is displayed.
   * `MINI` : A mini view of the PDF is displayed.
   */
  viewMode?: Maybe<WixRichContentV1FileDataPdfSettingsViewMode>;
};

export type WixRichContentV1FileDataPdfSettingsInput = {
  /** Sets whether the PDF download button is disabled. Defaults to `false`. */
  disableDownload?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the PDF print button is disabled. Defaults to `false`. */
  disablePrint?: InputMaybe<Scalars['Boolean']>;
  /**
   * PDF view mode. One of the following:
   * `NONE` : The PDF isn't displayed.
   * `FULL` : A full page view of the PDF is displayed.
   * `MINI` : A mini view of the PDF is displayed.
   */
  viewMode?: InputMaybe<WixRichContentV1FileDataPdfSettingsViewMode>;
};

export enum WixRichContentV1FileDataPdfSettingsViewMode {
  /** Full PDF view */
  Full = 'FULL',
  /** Mini PDF view */
  Mini = 'MINI',
  /** No PDF view */
  None = 'NONE'
}

export type WixRichContentV1FileSource = {
  __typename?: 'WixRichContentV1FileSource';
  /** Custom ID. Use `id` instead. */
  custom?: Maybe<Scalars['String']>;
  /** An ID that's resolved to a URL by a resolver function. */
  id?: Maybe<Scalars['String']>;
  /** Indicates whether the file's source is private. Defaults to `false`. */
  private?: Maybe<Scalars['Boolean']>;
  /** The absolute URL for the file's source. */
  url?: Maybe<Scalars['String']>;
};

export type WixRichContentV1FileSourceInput = {
  /** Custom ID. Use `id` instead. */
  custom?: InputMaybe<Scalars['String']>;
  /** An ID that's resolved to a URL by a resolver function. */
  id?: InputMaybe<Scalars['String']>;
  /** Indicates whether the file's source is private. Defaults to `false`. */
  private?: InputMaybe<Scalars['Boolean']>;
  /** The absolute URL for the file's source. */
  url?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1FontSizeData = {
  __typename?: 'WixRichContentV1FontSizeData';
  /** The units used for the font size. */
  unit?: Maybe<WixRichContentV1FontSizeDatafontType>;
  /** Font size value. */
  value?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1FontSizeDataInput = {
  /** The units used for the font size. */
  unit?: InputMaybe<WixRichContentV1FontSizeDatafontType>;
  /** Font size value. */
  value?: InputMaybe<Scalars['Int']>;
};

export enum WixRichContentV1FontSizeDatafontType {
  Em = 'EM',
  Px = 'PX'
}

export type WixRichContentV1Gif = {
  __typename?: 'WixRichContentV1GIF';
  /** GIF format URL. */
  gif?: Maybe<Scalars['String']>;
  /** MP4 format URL. */
  mp4?: Maybe<Scalars['String']>;
  /** Thumbnail URL. */
  still?: Maybe<Scalars['String']>;
};

export type WixRichContentV1GifData = {
  __typename?: 'WixRichContentV1GIFData';
  /** Styling for the GIF's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** The source of the downsized GIF. */
  downsized?: Maybe<WixRichContentV1Gif>;
  /** Type of GIF (Sticker or GIF). Defaults to `GIF`. */
  gifType?: Maybe<WixRichContentV1GifDataGifType>;
  /** Height in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** The source of the full size GIF. */
  original?: Maybe<WixRichContentV1Gif>;
  /** Width in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1GifDataInput = {
  /** Styling for the GIF's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** The source of the downsized GIF. */
  downsized?: InputMaybe<WixRichContentV1GifInput>;
  /** Type of GIF (Sticker or NORMAL). Defaults to `NORMAL`. */
  gifType?: InputMaybe<WixRichContentV1GifDataGifType>;
  /** Height in pixels. */
  height?: InputMaybe<Scalars['Int']>;
  /** The source of the full size GIF. */
  original?: InputMaybe<WixRichContentV1GifInput>;
  /** Width in pixels. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1GifInput = {
  /** GIF format URL. */
  gif?: InputMaybe<Scalars['String']>;
  /** MP4 format URL. */
  mp4?: InputMaybe<Scalars['String']>;
  /** Thumbnail URL. */
  still?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1GalleryData = {
  __typename?: 'WixRichContentV1GalleryData';
  /** Styling for the gallery's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Sets whether the gallery's download button is disabled. Defaults to `false`. */
  disableDownload?: Maybe<Scalars['Boolean']>;
  /** Sets whether the gallery's expand button is disabled. Defaults to `false`. */
  disableExpand?: Maybe<Scalars['Boolean']>;
  /** The items in the gallery. */
  items?: Maybe<Array<Maybe<WixRichContentV1GalleryDataItem>>>;
  /** Options for defining the gallery's appearance. */
  options?: Maybe<WixRichContentV1GalleryOptions>;
};

export type WixRichContentV1GalleryDataInput = {
  /** Styling for the gallery's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Sets whether the gallery's download button is disabled. Defaults to `false`. */
  disableDownload?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the gallery's expand button is disabled. Defaults to `false`. */
  disableExpand?: InputMaybe<Scalars['Boolean']>;
  /** The items in the gallery. */
  items?: InputMaybe<Array<InputMaybe<WixRichContentV1GalleryDataItemInput>>>;
  /** Options for defining the gallery's appearance. */
  options?: InputMaybe<WixRichContentV1GalleryOptionsInput>;
};

export type WixRichContentV1GalleryDataItem = {
  __typename?: 'WixRichContentV1GalleryDataItem';
  /** Item's alternative text. */
  altText?: Maybe<Scalars['String']>;
  /** An image item. */
  image?: Maybe<WixRichContentV1GalleryDataItemImage>;
  /** Item title. */
  title?: Maybe<Scalars['String']>;
  /** A video item. */
  video?: Maybe<WixRichContentV1GalleryDataItemVideo>;
};

export type WixRichContentV1GalleryDataItemImage = {
  __typename?: 'WixRichContentV1GalleryDataItemImage';
  /** Link details for images that are links. */
  link?: Maybe<WixRichContentV1Link>;
  /** Image file details. */
  media?: Maybe<WixRichContentV1Media>;
};

export type WixRichContentV1GalleryDataItemImageInput = {
  /** Link details for images that are links. */
  link?: InputMaybe<WixRichContentV1LinkInput>;
  /** Image file details. */
  media?: InputMaybe<WixRichContentV1MediaInput>;
};

export type WixRichContentV1GalleryDataItemInput = {
  /** Item's alternative text. */
  altText?: InputMaybe<Scalars['String']>;
  /** An image item. */
  image?: InputMaybe<WixRichContentV1GalleryDataItemImageInput>;
  /** Item title. */
  title?: InputMaybe<Scalars['String']>;
  /** A video item. */
  video?: InputMaybe<WixRichContentV1GalleryDataItemVideoInput>;
};

export type WixRichContentV1GalleryDataItemVideo = {
  __typename?: 'WixRichContentV1GalleryDataItemVideo';
  /** Video file details. */
  media?: Maybe<WixRichContentV1Media>;
  /** Video thumbnail file details. */
  thumbnail?: Maybe<WixRichContentV1Media>;
};

export type WixRichContentV1GalleryDataItemVideoInput = {
  /** Video file details. */
  media?: InputMaybe<WixRichContentV1MediaInput>;
  /** Video thumbnail file details. */
  thumbnail?: InputMaybe<WixRichContentV1MediaInput>;
};

export type WixRichContentV1GalleryOptions = {
  __typename?: 'WixRichContentV1GalleryOptions';
  /** Styling for gallery items. */
  item?: Maybe<WixRichContentV1GalleryOptionsItemStyle>;
  /** Gallery layout. */
  layout?: Maybe<WixRichContentV1GalleryOptionsLayout>;
  /** Styling for gallery thumbnail images. */
  thumbnails?: Maybe<WixRichContentV1GalleryOptionsThumbnails>;
};

export type WixRichContentV1GalleryOptionsInput = {
  /** Styling for gallery items. */
  item?: InputMaybe<WixRichContentV1GalleryOptionsItemStyleInput>;
  /** Gallery layout. */
  layout?: InputMaybe<WixRichContentV1GalleryOptionsLayoutInput>;
  /** Styling for gallery thumbnail images. */
  thumbnails?: InputMaybe<WixRichContentV1GalleryOptionsThumbnailsInput>;
};

export type WixRichContentV1GalleryOptionsItemStyle = {
  __typename?: 'WixRichContentV1GalleryOptionsItemStyle';
  /** Sets how item images are cropped. */
  crop?: Maybe<WixRichContentV1GalleryOptionsItemStyleCrop>;
  /** Item ratio */
  ratio?: Maybe<Scalars['Float']>;
  /** The spacing between items in pixels. */
  spacing?: Maybe<Scalars['Int']>;
  /** Desirable dimension for each item in pixels (behvaior changes according to gallery type) */
  targetSize?: Maybe<Scalars['Int']>;
};

export enum WixRichContentV1GalleryOptionsItemStyleCrop {
  /** Crop to fill */
  Fill = 'FILL',
  /** Crop to fit */
  Fit = 'FIT'
}

export type WixRichContentV1GalleryOptionsItemStyleInput = {
  /** Sets how item images are cropped. */
  crop?: InputMaybe<WixRichContentV1GalleryOptionsItemStyleCrop>;
  /** Item ratio */
  ratio?: InputMaybe<Scalars['Float']>;
  /** The spacing between items in pixels. */
  spacing?: InputMaybe<Scalars['Int']>;
  /** Desirable dimension for each item in pixels (behvaior changes according to gallery type) */
  targetSize?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1GalleryOptionsLayout = {
  __typename?: 'WixRichContentV1GalleryOptionsLayout';
  /** Sets whether horizontal scroll is enabled. Defaults to `true` unless the layout `type` is set to `GRID` or `COLLAGE`. */
  horizontalScroll?: Maybe<Scalars['Boolean']>;
  /** The number of columns to display on mobile screens. */
  mobileNumberOfColumns?: Maybe<Scalars['Int']>;
  /** The number of columns to display on full size screens. */
  numberOfColumns?: Maybe<Scalars['Int']>;
  /** Gallery orientation. */
  orientation?: Maybe<WixRichContentV1GalleryOptionsLayoutOrientation>;
  /** Gallery layout type. */
  type?: Maybe<WixRichContentV1GalleryOptionsLayoutType>;
};

export type WixRichContentV1GalleryOptionsLayoutInput = {
  /** Sets whether horizontal scroll is enabled. Defaults to `true` unless the layout `type` is set to `GRID` or `COLLAGE`. */
  horizontalScroll?: InputMaybe<Scalars['Boolean']>;
  /** The number of columns to display on mobile screens. */
  mobileNumberOfColumns?: InputMaybe<Scalars['Int']>;
  /** The number of columns to display on full size screens. */
  numberOfColumns?: InputMaybe<Scalars['Int']>;
  /** Gallery orientation. */
  orientation?: InputMaybe<WixRichContentV1GalleryOptionsLayoutOrientation>;
  /** Gallery layout type. */
  type?: InputMaybe<WixRichContentV1GalleryOptionsLayoutType>;
};

export enum WixRichContentV1GalleryOptionsLayoutOrientation {
  /** Columns Orientation */
  Columns = 'COLUMNS',
  /** Rows Orientation */
  Rows = 'ROWS'
}

export enum WixRichContentV1GalleryOptionsLayoutType {
  /** Collage type */
  Collage = 'COLLAGE',
  /** Column type */
  Column = 'COLUMN',
  /** Fullsize images type */
  Fullsize = 'FULLSIZE',
  /** Grid type */
  Grid = 'GRID',
  /** Magic type */
  Magic = 'MAGIC',
  /** Masonry type */
  Masonry = 'MASONRY',
  /** Panorama type */
  Panorama = 'PANORAMA',
  /** Slider type */
  Slider = 'SLIDER',
  /** Slideshow type */
  Slideshow = 'SLIDESHOW',
  /** Thumbnail type */
  Thumbnail = 'THUMBNAIL'
}

export type WixRichContentV1GalleryOptionsThumbnails = {
  __typename?: 'WixRichContentV1GalleryOptionsThumbnails';
  /** Thumbnail alignment. */
  placement?: Maybe<WixRichContentV1GalleryOptionsThumbnailsAlignment>;
  /** Spacing between thumbnails in pixels. */
  spacing?: Maybe<Scalars['Int']>;
};

export enum WixRichContentV1GalleryOptionsThumbnailsAlignment {
  /** Bottom alignment */
  Bottom = 'BOTTOM',
  /** Left alignment */
  Left = 'LEFT',
  /** No thumbnail */
  None = 'NONE',
  /** Right alignment */
  Right = 'RIGHT',
  /** Top alignment */
  Top = 'TOP'
}

export type WixRichContentV1GalleryOptionsThumbnailsInput = {
  /** Thumbnail alignment. */
  placement?: InputMaybe<WixRichContentV1GalleryOptionsThumbnailsAlignment>;
  /** Spacing between thumbnails in pixels. */
  spacing?: InputMaybe<Scalars['Int']>;
};

export enum WixRichContentV1GifDataGifType {
  Gif = 'GIF',
  Sticker = 'STICKER'
}

export type WixRichContentV1HtmlData = {
  __typename?: 'WixRichContentV1HTMLData';
  /** If container height is aligned with its content height. Defaults to `true`. */
  autoHeight?: Maybe<Scalars['Boolean']>;
  /** Styling for the HTML node's container. Height property is irrelevant for HTML embeds when autoHeight is set to `true`. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** The HTML code for the node. */
  html?: Maybe<Scalars['String']>;
  /** Whether this is an AdSense element. Use `source` instead. */
  isAdsense?: Maybe<Scalars['Boolean']>;
  /** The type of HTML code. */
  source?: Maybe<WixRichContentV1HtmlDataSource>;
  /** The URL for the HTML code for the node. */
  url?: Maybe<Scalars['String']>;
};

export type WixRichContentV1HtmlDataInput = {
  /** If container height is aligned with its content height. Defaults to `true`. */
  autoHeight?: InputMaybe<Scalars['Boolean']>;
  /** Styling for the HTML node's container. Height property is irrelevant for HTML embeds when autoHeight is set to `true`. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** The HTML code for the node. */
  html?: InputMaybe<Scalars['String']>;
  /** Whether this is an AdSense element. Use `source` instead. */
  isAdsense?: InputMaybe<Scalars['Boolean']>;
  /** The type of HTML code. */
  source?: InputMaybe<WixRichContentV1HtmlDataSource>;
  /** The URL for the HTML code for the node. */
  url?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1HeadingData = {
  __typename?: 'WixRichContentV1HeadingData';
  /** Indentation level from 1-4. */
  indentation?: Maybe<Scalars['Int']>;
  /** Heading level from 1-6. */
  level?: Maybe<Scalars['Int']>;
  /** Styling for the heading text. */
  textStyle?: Maybe<WixRichContentV1TextStyle>;
};

export type WixRichContentV1HeadingDataInput = {
  /** Indentation level from 1-4. */
  indentation?: InputMaybe<Scalars['Int']>;
  /** Heading level from 1-6. */
  level?: InputMaybe<Scalars['Int']>;
  /** Styling for the heading text. */
  textStyle?: InputMaybe<WixRichContentV1TextStyleInput>;
};

export enum WixRichContentV1HtmlDataSource {
  Adsense = 'ADSENSE',
  Html = 'HTML'
}

export type WixRichContentV1ImageData = {
  __typename?: 'WixRichContentV1ImageData';
  /** Image's alternative text. */
  altText?: Maybe<Scalars['String']>;
  /** Deprecated: use Caption node instead. */
  caption?: Maybe<Scalars['String']>;
  /** Styling for the image's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Sets whether the image's download button is disabled. Defaults to `false`. */
  disableDownload?: Maybe<Scalars['Boolean']>;
  /** Sets whether the image expands to full screen when clicked. Defaults to `false`. */
  disableExpand?: Maybe<Scalars['Boolean']>;
  /** Image file details. */
  image?: Maybe<WixRichContentV1Media>;
  /** Link details for images that are links. */
  link?: Maybe<WixRichContentV1Link>;
};

export type WixRichContentV1ImageDataInput = {
  /** Image's alternative text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Deprecated: use Caption node instead. */
  caption?: InputMaybe<Scalars['String']>;
  /** Styling for the image's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Sets whether the image is decorative and does not need an explanation. Defaults to `false`. */
  decorative?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the image's download button is disabled. Defaults to `false`. */
  disableDownload?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the image expands to full screen when clicked. Defaults to `false`. */
  disableExpand?: InputMaybe<Scalars['Boolean']>;
  /** Image file details. */
  image?: InputMaybe<WixRichContentV1MediaInput>;
  /** Link details for images that are links. */
  link?: InputMaybe<WixRichContentV1LinkInput>;
  /** Styling for the image. */
  styles?: InputMaybe<WixRichContentV1ImageDataStylesInput>;
};

export type WixRichContentV1ImageDataStyles = {
  __typename?: 'WixRichContentV1ImageDataStyles';
  /** Border attributes. */
  border?: Maybe<WixRichContentV1ImageDataStylesBorder>;
};

export type WixRichContentV1ImageDataStylesBorder = {
  __typename?: 'WixRichContentV1ImageDataStylesBorder';
  /** Border color as a hexadecimal value. */
  color?: Maybe<Scalars['String']>;
  /** Border radius in pixels. */
  radius?: Maybe<Scalars['Int']>;
  /** Border width in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1ImageDataStylesBorderInput = {
  /** Border color as a hexadecimal value. */
  color?: InputMaybe<Scalars['String']>;
  /** Border radius in pixels. */
  radius?: InputMaybe<Scalars['Int']>;
  /** Border width in pixels. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1ImageDataStylesInput = {
  /** Border attributes. */
  border?: InputMaybe<WixRichContentV1ImageDataStylesBorderInput>;
};

export type WixRichContentV1LayoutCellData = {
  __typename?: 'WixRichContentV1LayoutCellData';
  /** Size of the cell in 12 columns grid. */
  colSpan?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1LayoutCellDataInput = {
  /** Size of the cell in 12 columns grid. */
  colSpan?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1Link = {
  __typename?: 'WixRichContentV1Link';
  /** The target node's ID. Used for linking to another node in this object. */
  anchor?: Maybe<Scalars['String']>;
  /** A serialized object used for a custom or external link panel. */
  customData?: Maybe<Scalars['String']>;
  /** The HTML `rel` attribute value for the link. This object specifies the relationship between the current document and the linked document. */
  rel?: Maybe<WixRichContentV1LinkRel>;
  /**
   * he HTML `target` attribute value for the link. This property defines where the linked document opens as follows:
   * `SELF` - Default. Opens the linked document in the same frame as the link.
   * `BLANK` - Opens the linked document in a new browser tab or window.
   * `PARENT` - Opens the linked document in the link's parent frame.
   * `TOP` - Opens the linked document in the full body of the link's browser tab or window.
   */
  target?: Maybe<WixRichContentV1LinkTarget>;
  /** The absolute URL for the linked document. */
  url?: Maybe<Scalars['String']>;
};

export type WixRichContentV1LinkData = {
  __typename?: 'WixRichContentV1LinkData';
  /** Link details. */
  link?: Maybe<WixRichContentV1Link>;
};

export type WixRichContentV1LinkDataInput = {
  /** Link details. */
  link?: InputMaybe<WixRichContentV1LinkInput>;
};

export type WixRichContentV1LinkInput = {
  /** The target node's ID. Used for linking to another node in this object. */
  anchor?: InputMaybe<Scalars['String']>;
  /** A serialized object used for a custom or external link panel. */
  customData?: InputMaybe<Scalars['String']>;
  /** The HTML `rel` attribute value for the link. This object specifies the relationship between the current document and the linked document. */
  rel?: InputMaybe<WixRichContentV1LinkRelInput>;
  /**
   * he HTML `target` attribute value for the link. This property defines where the linked document opens as follows:
   * `SELF` - Default. Opens the linked document in the same frame as the link.
   * `BLANK` - Opens the linked document in a new browser tab or window.
   * `PARENT` - Opens the linked document in the link's parent frame.
   * `TOP` - Opens the linked document in the full body of the link's browser tab or window.
   */
  target?: InputMaybe<WixRichContentV1LinkTarget>;
  /** The absolute URL for the linked document. */
  url?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1LinkPreviewData = {
  __typename?: 'WixRichContentV1LinkPreviewData';
  /** Styling for the link preview's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Preview description. */
  description?: Maybe<Scalars['String']>;
  /** The preview content as HTML. */
  html?: Maybe<Scalars['String']>;
  /** Link details. */
  link?: Maybe<WixRichContentV1Link>;
  /** Preview thumbnail URL. */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** Preview title. */
  title?: Maybe<Scalars['String']>;
};

export type WixRichContentV1LinkPreviewDataInput = {
  /** Styling for the link preview's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Preview description. */
  description?: InputMaybe<Scalars['String']>;
  /** The preview content as HTML. */
  html?: InputMaybe<Scalars['String']>;
  /** Link details. */
  link?: InputMaybe<WixRichContentV1LinkInput>;
  /** Styling for the link preview. */
  styles?: InputMaybe<WixRichContentV1LinkPreviewDataStylesInput>;
  /** Preview thumbnail URL. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  /** Preview title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1LinkPreviewDataStyles = {
  __typename?: 'WixRichContentV1LinkPreviewDataStyles';
  /** Background color as a hexadecimal value. */
  backgroundColor?: Maybe<Scalars['String']>;
  /** Border color as a hexadecimal value. */
  borderColor?: Maybe<Scalars['String']>;
  /** Border radius in pixels. */
  borderRadius?: Maybe<Scalars['Int']>;
  /** Border width in pixels. */
  borderWidth?: Maybe<Scalars['Int']>;
  /** Link color as a hexadecimal value. */
  linkColor?: Maybe<Scalars['String']>;
  /** Subtitle color as a hexadecimal value. */
  subtitleColor?: Maybe<Scalars['String']>;
  /** Position of thumbnail. Defaults to `START`. */
  thumbnailPosition?: Maybe<WixRichContentV1LinkPreviewDataStylesPosition>;
  /** Title color as a hexadecimal value. */
  titleColor?: Maybe<Scalars['String']>;
};

export type WixRichContentV1LinkPreviewDataStylesInput = {
  /** Background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Border color as a hexadecimal value. */
  borderColor?: InputMaybe<Scalars['String']>;
  /** Border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
  /** Border width in pixels. */
  borderWidth?: InputMaybe<Scalars['Int']>;
  /** Link color as a hexadecimal value. */
  linkColor?: InputMaybe<Scalars['String']>;
  /** Subtitle color as a hexadecimal value. */
  subtitleColor?: InputMaybe<Scalars['String']>;
  /** Position of thumbnail. Defaults to `START`. */
  thumbnailPosition?: InputMaybe<WixRichContentV1LinkPreviewDataStylesPosition>;
  /** Title color as a hexadecimal value. */
  titleColor?: InputMaybe<Scalars['String']>;
};

export enum WixRichContentV1LinkPreviewDataStylesPosition {
  /** Thumbnail positioned at the end (right in LTR layouts, left in RTL layouts) */
  End = 'END',
  /** Thumbnail hidden and not displayed */
  Hidden = 'HIDDEN',
  /** Thumbnail positioned at the start (left in LTR layouts, right in RTL layouts) */
  Start = 'START',
  /** Thumbnail positioned at the top */
  Top = 'TOP'
}

export type WixRichContentV1LinkRel = {
  __typename?: 'WixRichContentV1LinkRel';
  /** Indicates to search engine crawlers not to follow the link. Defaults to `false`. */
  nofollow?: Maybe<Scalars['Boolean']>;
  /** Indicates that this link protect referral information from being passed to the target website. */
  noreferrer?: Maybe<Scalars['Boolean']>;
  /** Indicates to search engine crawlers that the link is a paid placement such as sponsored content or an advertisement. Defaults to `false`. */
  sponsored?: Maybe<Scalars['Boolean']>;
  /** Indicates that this link is user-generated content and isn't necessarily trusted or endorsed by the page’s author. For example, a link in a fourm post. Defaults to `false`. */
  ugc?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1LinkRelInput = {
  /** Indicates to search engine crawlers not to follow the link. Defaults to `false`. */
  nofollow?: InputMaybe<Scalars['Boolean']>;
  /** Indicates that this link protect referral information from being passed to the target website. */
  noreferrer?: InputMaybe<Scalars['Boolean']>;
  /** Indicates to search engine crawlers that the link is a paid placement such as sponsored content or an advertisement. Defaults to `false`. */
  sponsored?: InputMaybe<Scalars['Boolean']>;
  /** Indicates that this link is user-generated content and isn't necessarily trusted or endorsed by the page’s author. For example, a link in a fourm post. Defaults to `false`. */
  ugc?: InputMaybe<Scalars['Boolean']>;
};

export enum WixRichContentV1LinkTarget {
  /** Opens the linked document in a new window or tab */
  Blank = 'BLANK',
  /** Opens the linked document in the parent frame */
  Parent = 'PARENT',
  /** Opens the linked document in the same frame as it was clicked (this is default) */
  Self = 'SELF',
  /** Opens the linked document in the full body of the window */
  Top = 'TOP'
}

export type WixRichContentV1ListValue = {
  __typename?: 'WixRichContentV1ListValue';
  /** Repeated field of dynamically typed values. */
  values?: Maybe<Array<Maybe<WixRichContentV1Value>>>;
};

export type WixRichContentV1ListValueInput = {
  /** Repeated field of dynamically typed values. */
  values?: InputMaybe<Array<InputMaybe<WixRichContentV1ValueInput>>>;
};

export type WixRichContentV1MapData = {
  __typename?: 'WixRichContentV1MapData';
  /** Styling for the map's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Map settings. */
  mapSettings?: Maybe<WixRichContentV1MapSettings>;
};

export type WixRichContentV1MapDataInput = {
  /** Styling for the map's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Map settings. */
  mapSettings?: InputMaybe<WixRichContentV1MapSettingsInput>;
};

export type WixRichContentV1MapSettings = {
  __typename?: 'WixRichContentV1MapSettings';
  /** The address to display on the map. */
  address?: Maybe<Scalars['String']>;
  /** Sets whether the map is draggable. */
  draggable?: Maybe<Scalars['Boolean']>;
  /** Initial zoom value. */
  initialZoom?: Maybe<Scalars['Int']>;
  /** Location latitude. */
  lat?: Maybe<Scalars['Float']>;
  /** Location longitude. */
  lng?: Maybe<Scalars['Float']>;
  /** Location name. */
  locationName?: Maybe<Scalars['String']>;
  /** Map type. `HYBRID` is a combination of the `ROADMAP` and `SATELLITE` map types. */
  mapType?: Maybe<WixRichContentV1MapType>;
  /** Sets whether the location marker is visible. */
  marker?: Maybe<Scalars['Boolean']>;
  /** Sets whether street view control is enabled. */
  streetViewControl?: Maybe<Scalars['Boolean']>;
  /** Sets whether view mode control is enabled. */
  viewModeControl?: Maybe<Scalars['Boolean']>;
  /** Sets whether zoom control is enabled. */
  zoomControl?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1MapSettingsInput = {
  /** The address to display on the map. */
  address?: InputMaybe<Scalars['String']>;
  /** Sets whether the map is draggable. */
  draggable?: InputMaybe<Scalars['Boolean']>;
  /** Initial zoom value. */
  initialZoom?: InputMaybe<Scalars['Int']>;
  /** Location latitude. */
  lat?: InputMaybe<Scalars['Float']>;
  /** Location longitude. */
  lng?: InputMaybe<Scalars['Float']>;
  /** Location name. */
  locationName?: InputMaybe<Scalars['String']>;
  /** Map type. `HYBRID` is a combination of the `ROADMAP` and `SATELLITE` map types. */
  mapType?: InputMaybe<WixRichContentV1MapType>;
  /** Sets whether the location marker is visible. */
  marker?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether street view control is enabled. */
  streetViewControl?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether view mode control is enabled. */
  viewModeControl?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether zoom control is enabled. */
  zoomControl?: InputMaybe<Scalars['Boolean']>;
};

export enum WixRichContentV1MapType {
  /** Hybrid map type */
  Hybrid = 'HYBRID',
  /** Roadmap map type */
  Roadmap = 'ROADMAP',
  /** Satellite map type */
  Satelite = 'SATELITE',
  /** Terrain map type */
  Terrain = 'TERRAIN'
}

export type WixRichContentV1Media = {
  __typename?: 'WixRichContentV1Media';
  /** Media duration in seconds. Only relevant for audio and video files. */
  duration?: Maybe<Scalars['Float']>;
  /** Media height in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** The source for the media's data. */
  src?: Maybe<WixRichContentV1FileSource>;
  /** Media width in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1MediaInput = {
  /** Media duration in seconds. Only relevant for audio and video files. */
  duration?: InputMaybe<Scalars['Float']>;
  /** Media height in pixels. */
  height?: InputMaybe<Scalars['Int']>;
  /** The source for the media's data. */
  src?: InputMaybe<WixRichContentV1FileSourceInput>;
  /** Media width in pixels. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1MentionData = {
  __typename?: 'WixRichContentV1MentionData';
  /** Mentioned user's ID. */
  id?: Maybe<Scalars['String']>;
  /** The mentioned user's name. */
  name?: Maybe<Scalars['String']>;
  /** The version of the user's name that appears after the `@` character in the mention. */
  slug?: Maybe<Scalars['String']>;
};

export type WixRichContentV1MentionDataInput = {
  /** Mentioned user's ID. */
  id?: InputMaybe<Scalars['String']>;
  /** The mentioned user's name. */
  name?: InputMaybe<Scalars['String']>;
  /** The version of the user's name that appears after the `@` character in the mention. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1Metadata = {
  __typename?: 'WixRichContentV1Metadata';
  /** When the object was created. */
  createdTimestamp?: Maybe<Scalars['String']>;
  /** Object ID. */
  id?: Maybe<Scalars['String']>;
  /** When the object was most recently updated. */
  updatedTimestamp?: Maybe<Scalars['String']>;
  /** Schema version. */
  version?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1MetadataInput = {
  /** When the object was created. */
  createdTimestamp?: InputMaybe<Scalars['String']>;
  /** Object ID. */
  id?: InputMaybe<Scalars['String']>;
  /** When the object was most recently updated. */
  updatedTimestamp?: InputMaybe<Scalars['String']>;
  /** Schema version. */
  version?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1Node = {
  __typename?: 'WixRichContentV1Node';
  /** Data for an app embed node. */
  appEmbedData?: Maybe<WixRichContentV1AppEmbedData>;
  /** Data for an audio node. */
  audioData?: Maybe<WixRichContentV1AudioData>;
  /** Data for a block quote node. */
  blockquoteData?: Maybe<WixRichContentV1BlockquoteData>;
  /** Data for a bulleted list node. */
  bulletedListData?: Maybe<WixRichContentV1BulletedListData>;
  /** Data for a button node. */
  buttonData?: Maybe<WixRichContentV1ButtonData>;
  /** Data for a caption node. */
  captionData?: Maybe<WixRichContentV1CaptionData>;
  /** Data for a code block node. */
  codeBlockData?: Maybe<WixRichContentV1CodeBlockData>;
  /** Data for a collapsible list node. */
  collapsibleListData?: Maybe<WixRichContentV1CollapsibleListData>;
  /** Data for a divider node. */
  dividerData?: Maybe<WixRichContentV1DividerData>;
  /** Data for an oEmbed node. */
  embedData?: Maybe<WixRichContentV1EmbedData>;
  /** Data for a custom external node. */
  externalData?: Maybe<WixRichContentV1Struct>;
  /** Data for a file node. */
  fileData?: Maybe<WixRichContentV1FileData>;
  /** Data for a gallery node. */
  galleryData?: Maybe<WixRichContentV1GalleryData>;
  /** Data for a GIF node. */
  gifData?: Maybe<WixRichContentV1GifData>;
  /** Data for a heading node. */
  headingData?: Maybe<WixRichContentV1HeadingData>;
  /** Data for an embedded HTML node. */
  htmlData?: Maybe<WixRichContentV1HtmlData>;
  /** Node ID. */
  id?: Maybe<Scalars['String']>;
  /** Data for an image node. */
  imageData?: Maybe<WixRichContentV1ImageData>;
  /** LayoutData layout_data = 31; // Data for a layout node. Reserved for future use. */
  layoutCellData?: Maybe<WixRichContentV1LayoutCellData>;
  /** Data for a link preview node. */
  linkPreviewData?: Maybe<WixRichContentV1LinkPreviewData>;
  mapData?: Maybe<WixRichContentV1MapData>;
  /** A list of child nodes. */
  nodes?: Maybe<Array<Maybe<WixRichContentV1Node>>>;
  /** Data for an ordered list node. */
  orderedListData?: Maybe<WixRichContentV1OrderedListData>;
  /** Data for a paragraph node. */
  paragraphData?: Maybe<WixRichContentV1ParagraphData>;
  /** Data for a poll node. */
  pollData?: Maybe<WixRichContentV1PollData>;
  /** Padding and background color styling for the node. */
  style?: Maybe<WixRichContentV1NodeStyle>;
  /** Data for a table cell node. */
  tableCellData?: Maybe<WixRichContentV1TableCellData>;
  /** Data for a table node. */
  tableData?: Maybe<WixRichContentV1TableData>;
  /** Data for a text node. Used to apply decorations to text. */
  textData?: Maybe<WixRichContentV1TextData>;
  /** Node type. Use `APP_EMBED` for nodes that embed content from other Wix apps. Use `EMBED` to embed content in [oEmbed](https://oembed.com/) format. */
  type?: Maybe<WixRichContentV1NodeType>;
  /** Data for a video node. */
  videoData?: Maybe<WixRichContentV1VideoData>;
};

export type WixRichContentV1NodeInput = {
  /** Data for an app embed node. */
  appEmbedData?: InputMaybe<WixRichContentV1AppEmbedDataInput>;
  /** Data for an audio node. */
  audioData?: InputMaybe<WixRichContentV1AudioDataInput>;
  /** Data for a block quote node. */
  blockquoteData?: InputMaybe<WixRichContentV1BlockquoteDataInput>;
  /** Data for a bulleted list node. */
  bulletedListData?: InputMaybe<WixRichContentV1BulletedListDataInput>;
  /** Data for a button node. */
  buttonData?: InputMaybe<WixRichContentV1ButtonDataInput>;
  /** Data for a caption node. */
  captionData?: InputMaybe<WixRichContentV1CaptionDataInput>;
  /** Data for a code block node. */
  codeBlockData?: InputMaybe<WixRichContentV1CodeBlockDataInput>;
  /** Data for a collapsible list node. */
  collapsibleListData?: InputMaybe<WixRichContentV1CollapsibleListDataInput>;
  /** Data for a divider node. */
  dividerData?: InputMaybe<WixRichContentV1DividerDataInput>;
  /** Data for an oEmbed node. */
  embedData?: InputMaybe<WixRichContentV1EmbedDataInput>;
  /** Data for a custom external node. */
  externalData?: InputMaybe<WixRichContentV1StructInput>;
  /** Data for a file node. */
  fileData?: InputMaybe<WixRichContentV1FileDataInput>;
  /** Data for a gallery node. */
  galleryData?: InputMaybe<WixRichContentV1GalleryDataInput>;
  /** Data for a GIF node. */
  gifData?: InputMaybe<WixRichContentV1GifDataInput>;
  /** Data for a heading node. */
  headingData?: InputMaybe<WixRichContentV1HeadingDataInput>;
  /** Data for an embedded HTML node. */
  htmlData?: InputMaybe<WixRichContentV1HtmlDataInput>;
  /** Node ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Data for an image node. */
  imageData?: InputMaybe<WixRichContentV1ImageDataInput>;
  /** LayoutData layout_data = 31; // Data for a layout node. Reserved for future use. */
  layoutCellData?: InputMaybe<WixRichContentV1LayoutCellDataInput>;
  /** Data for a link preview node. */
  linkPreviewData?: InputMaybe<WixRichContentV1LinkPreviewDataInput>;
  mapData?: InputMaybe<WixRichContentV1MapDataInput>;
  /** A list of child nodes. */
  nodes?: InputMaybe<Array<InputMaybe<WixRichContentV1NodeInput>>>;
  /** Data for an ordered list node. */
  orderedListData?: InputMaybe<WixRichContentV1OrderedListDataInput>;
  /** Data for a paragraph node. */
  paragraphData?: InputMaybe<WixRichContentV1ParagraphDataInput>;
  /** Data for a poll node. */
  pollData?: InputMaybe<WixRichContentV1PollDataInput>;
  /** Padding and background color styling for the node. */
  style?: InputMaybe<WixRichContentV1NodeStyleInput>;
  /** Data for a table cell node. */
  tableCellData?: InputMaybe<WixRichContentV1TableCellDataInput>;
  /** Data for a table node. */
  tableData?: InputMaybe<WixRichContentV1TableDataInput>;
  /** Data for a text node. Used to apply decorations to text. */
  textData?: InputMaybe<WixRichContentV1TextDataInput>;
  /** Node type. Use `APP_EMBED` for nodes that embed content from other Wix apps. Use `EMBED` to embed content in [oEmbed](https://oembed.com/) format. */
  type?: InputMaybe<WixRichContentV1NodeType>;
  /** Data for a video node. */
  videoData?: InputMaybe<WixRichContentV1VideoDataInput>;
};

export type WixRichContentV1NodeStyle = {
  __typename?: 'WixRichContentV1NodeStyle';
  /** The background color as a hexadecimal value. */
  backgroundColor?: Maybe<Scalars['String']>;
  /** The bottom padding value in pixels. */
  paddingBottom?: Maybe<Scalars['String']>;
  /** The top padding value in pixels. */
  paddingTop?: Maybe<Scalars['String']>;
};

export type WixRichContentV1NodeStyleInput = {
  /** The background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** The bottom padding value in pixels. */
  paddingBottom?: InputMaybe<Scalars['String']>;
  /** The top padding value in pixels. */
  paddingTop?: InputMaybe<Scalars['String']>;
};

export enum WixRichContentV1NodeType {
  AppEmbed = 'APP_EMBED',
  Audio = 'AUDIO',
  Blockquote = 'BLOCKQUOTE',
  BulletedList = 'BULLETED_LIST',
  Button = 'BUTTON',
  Caption = 'CAPTION',
  CodeBlock = 'CODE_BLOCK',
  CollapsibleItem = 'COLLAPSIBLE_ITEM',
  CollapsibleItemBody = 'COLLAPSIBLE_ITEM_BODY',
  CollapsibleItemTitle = 'COLLAPSIBLE_ITEM_TITLE',
  CollapsibleList = 'COLLAPSIBLE_LIST',
  Divider = 'DIVIDER',
  Embed = 'EMBED',
  External = 'EXTERNAL',
  File = 'FILE',
  Gallery = 'GALLERY',
  Gif = 'GIF',
  Heading = 'HEADING',
  Html = 'HTML',
  Image = 'IMAGE',
  Layout = 'LAYOUT',
  LayoutCell = 'LAYOUT_CELL',
  LinkPreview = 'LINK_PREVIEW',
  ListItem = 'LIST_ITEM',
  /** @deprecated */
  Map = 'MAP',
  OrderedList = 'ORDERED_LIST',
  Paragraph = 'PARAGRAPH',
  Poll = 'POLL',
  Table = 'TABLE',
  TableCell = 'TABLE_CELL',
  TableRow = 'TABLE_ROW',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export enum WixRichContentV1NullValue {
  /** Null value. */
  NullValue = 'NULL_VALUE'
}

export type WixRichContentV1Oembed = {
  __typename?: 'WixRichContentV1Oembed';
  /** The name of the author or owner of the resource. */
  authorName?: Maybe<Scalars['String']>;
  /** The URL for the author or owner of the resource. */
  authorUrl?: Maybe<Scalars['String']>;
  /** The height of the resource specified in the `url` property in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** HTML for embedding a video player. The HTML should have no padding or margins. */
  html?: Maybe<Scalars['String']>;
  /** The name of the resource provider. */
  providerName?: Maybe<Scalars['String']>;
  /** The URL for the resource provider. */
  providerUrl?: Maybe<Scalars['String']>;
  /** The height of the resource's thumbnail image. If this property is defined, `thumbnailUrl` and `thumbnailWidth`must also be defined. */
  thumbnailHeight?: Maybe<Scalars['String']>;
  /** The URL for a thumbnail image for the resource. If this property is defined, `thumbnailWidth` and `thumbnailHeight` must also be defined. */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** The width of the resource's thumbnail image. If this property is defined, `thumbnailUrl` and `thumbnailHeight` must also be defined. */
  thumbnailWidth?: Maybe<Scalars['String']>;
  /** Resource title. */
  title?: Maybe<Scalars['String']>;
  /** The resource type. */
  type?: Maybe<Scalars['String']>;
  /** The source URL for the resource. */
  url?: Maybe<Scalars['String']>;
  /** The oEmbed version number.  This value must be `1.0`. */
  version?: Maybe<Scalars['String']>;
  /** The URL for an embedded viedo. */
  videoUrl?: Maybe<Scalars['String']>;
  /** The width of the resource specified in the `url` property in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1OembedInput = {
  /** The name of the author or owner of the resource. */
  authorName?: InputMaybe<Scalars['String']>;
  /** The URL for the author or owner of the resource. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** The height of the resource specified in the `url` property in pixels. */
  height?: InputMaybe<Scalars['Int']>;
  /** HTML for embedding a video player. The HTML should have no padding or margins. */
  html?: InputMaybe<Scalars['String']>;
  /** The name of the resource provider. */
  providerName?: InputMaybe<Scalars['String']>;
  /** The URL for the resource provider. */
  providerUrl?: InputMaybe<Scalars['String']>;
  /** The height of the resource's thumbnail image. If this property is defined, `thumbnailUrl` and `thumbnailWidth`must also be defined. */
  thumbnailHeight?: InputMaybe<Scalars['String']>;
  /** The URL for a thumbnail image for the resource. If this property is defined, `thumbnailWidth` and `thumbnailHeight` must also be defined. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  /** The width of the resource's thumbnail image. If this property is defined, `thumbnailUrl` and `thumbnailHeight` must also be defined. */
  thumbnailWidth?: InputMaybe<Scalars['String']>;
  /** Resource title. */
  title?: InputMaybe<Scalars['String']>;
  /** The resource type. */
  type?: InputMaybe<Scalars['String']>;
  /** The source URL for the resource. */
  url?: InputMaybe<Scalars['String']>;
  /** The oEmbed version number.  This value must be `1.0`. */
  version?: InputMaybe<Scalars['String']>;
  /** The URL for an embedded viedo. */
  videoUrl?: InputMaybe<Scalars['String']>;
  /** The width of the resource specified in the `url` property in pixels. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1OrderedListData = {
  __typename?: 'WixRichContentV1OrderedListData';
  /** Indentation level from 0-4. */
  indentation?: Maybe<Scalars['Int']>;
  /** Offset level from 0-4. */
  offset?: Maybe<Scalars['Int']>;
  /** List start number. */
  start?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1OrderedListDataInput = {
  /** Indentation level from 0-4. */
  indentation?: InputMaybe<Scalars['Int']>;
  /** Offset level from 0-4. */
  offset?: InputMaybe<Scalars['Int']>;
  /** List start number. */
  start?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1ParagraphData = {
  __typename?: 'WixRichContentV1ParagraphData';
  /** Indentation level from 1-4. */
  indentation?: Maybe<Scalars['Int']>;
  /** Paragraph level */
  level?: Maybe<Scalars['Int']>;
  /** Styling for the paragraph text. */
  textStyle?: Maybe<WixRichContentV1TextStyle>;
};

export type WixRichContentV1ParagraphDataInput = {
  /** Indentation level from 1-4. */
  indentation?: InputMaybe<Scalars['Int']>;
  /** Paragraph level */
  level?: InputMaybe<Scalars['Int']>;
  /** Styling for the paragraph text. */
  textStyle?: InputMaybe<WixRichContentV1TextStyleInput>;
};

export type WixRichContentV1PlaybackOptions = {
  __typename?: 'WixRichContentV1PlaybackOptions';
  /** Sets whether the media will automatically start playing. */
  autoPlay?: Maybe<Scalars['Boolean']>;
  /** Sets whether media's will be looped. */
  playInLoop?: Maybe<Scalars['Boolean']>;
  /** Sets whether media's controls will be shown. */
  showControls?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1PlaybackOptionsInput = {
  /** Sets whether the media will automatically start playing. */
  autoPlay?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether media's will be looped. */
  playInLoop?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether media's controls will be shown. */
  showControls?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1PluginContainerData = {
  __typename?: 'WixRichContentV1PluginContainerData';
  /** The node's alignment within its container. */
  alignment?: Maybe<WixRichContentV1PluginContainerDataAlignment>;
  /** The height of the node when it's displayed. */
  height?: Maybe<WixRichContentV1PluginContainerDataHeight>;
  /** Spoiler cover settings for the node. */
  spoiler?: Maybe<WixRichContentV1PluginContainerDataSpoiler>;
  /** Sets whether text should wrap around this node when it's displayed. If `textWrap` is `false`, the node takes up the width of its container. Defaults to `true` for all node types except 'DIVIVDER' where it defaults to `false`. */
  textWrap?: Maybe<Scalars['Boolean']>;
  /** The width of the node when it's displayed. */
  width?: Maybe<WixRichContentV1PluginContainerDataWidth>;
};

export enum WixRichContentV1PluginContainerDataAlignment {
  /** Center Alignment */
  Center = 'CENTER',
  /** Left Alignment */
  Left = 'LEFT',
  /** Right Alignment */
  Right = 'RIGHT'
}

export type WixRichContentV1PluginContainerDataHeight = {
  __typename?: 'WixRichContentV1PluginContainerDataHeight';
  /** A custom height value in pixels. */
  custom?: Maybe<Scalars['String']>;
};

export type WixRichContentV1PluginContainerDataHeightInput = {
  /** A custom height value in pixels. */
  custom?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1PluginContainerDataInput = {
  /** The node's alignment within its container. */
  alignment?: InputMaybe<WixRichContentV1PluginContainerDataAlignment>;
  /** The height of the node when it's displayed. */
  height?: InputMaybe<WixRichContentV1PluginContainerDataHeightInput>;
  /** Spoiler cover settings for the node. */
  spoiler?: InputMaybe<WixRichContentV1PluginContainerDataSpoilerInput>;
  /** Sets whether text should wrap around this node when it's displayed. If `textWrap` is `false`, the node takes up the width of its container. Defaults to `true` for all node types except 'DIVIVDER' where it defaults to `false`. */
  textWrap?: InputMaybe<Scalars['Boolean']>;
  /** The width of the node when it's displayed. */
  width?: InputMaybe<WixRichContentV1PluginContainerDataWidthInput>;
};

export type WixRichContentV1PluginContainerDataSpoiler = {
  __typename?: 'WixRichContentV1PluginContainerDataSpoiler';
  /** The text for the button used to remove the spoiler cover. */
  buttonText?: Maybe<Scalars['String']>;
  /** The description displayed on top of the spoiler cover. */
  description?: Maybe<Scalars['String']>;
  /** Sets whether the spoiler cover is enabled for this node. Defaults to `false`. */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1PluginContainerDataSpoilerInput = {
  /** The text for the button used to remove the spoiler cover. */
  buttonText?: InputMaybe<Scalars['String']>;
  /** The description displayed on top of the spoiler cover. */
  description?: InputMaybe<Scalars['String']>;
  /** Sets whether the spoiler cover is enabled for this node. Defaults to `false`. */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1PluginContainerDataWidth = {
  __typename?: 'WixRichContentV1PluginContainerDataWidth';
  /** A custom width value in pixels. */
  custom?: Maybe<Scalars['String']>;
  /**
   * One of the following predefined width options:
   * `CONTENT`: The width of the container matches the content width.
   * `SMALL`: A small width.
   * `ORIGINAL`: For `imageData` containers only. The width of the container matches the original image width.
   * `FULL_WIDTH`: For `imageData` containers only. The image container takes up the full width of the screen.
   */
  size?: Maybe<WixRichContentV1PluginContainerDataWidthType>;
};

export type WixRichContentV1PluginContainerDataWidthInput = {
  /** A custom width value in pixels. */
  custom?: InputMaybe<Scalars['String']>;
  /**
   * One of the following predefined width options:
   * `CONTENT`: The width of the container matches the content width.
   * `SMALL`: A small width.
   * `ORIGINAL`: For `imageData` containers only. The width of the container matches the original image width.
   * `FULL_WIDTH`: For `imageData` containers only. The image container takes up the full width of the screen.
   */
  size?: InputMaybe<WixRichContentV1PluginContainerDataWidthType>;
};

export enum WixRichContentV1PluginContainerDataWidthType {
  /** Width matches the content width */
  Content = 'CONTENT',
  /** coast-to-coast display */
  FullWidth = 'FULL_WIDTH',
  /** Width will match the original asset width */
  Original = 'ORIGINAL',
  /** Small Width */
  Small = 'SMALL'
}

export type WixRichContentV1PollData = {
  __typename?: 'WixRichContentV1PollData';
  /** Styling for the poll's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Styling for the poll and voting options. */
  design?: Maybe<WixRichContentV1PollDataDesign>;
  /** Layout settings for the poll and voting options. */
  layout?: Maybe<WixRichContentV1PollDataLayout>;
  /** Poll data. */
  poll?: Maybe<WixRichContentV1PollDataPoll>;
};

export type WixRichContentV1PollDataDesign = {
  __typename?: 'WixRichContentV1PollDataDesign';
  /** Styling for voting options. */
  options?: Maybe<WixRichContentV1PollDataDesignOptionDesign>;
  /** Styling for the poll. */
  poll?: Maybe<WixRichContentV1PollDataDesignPollDesign>;
};

export type WixRichContentV1PollDataDesignInput = {
  /** Styling for voting options. */
  options?: InputMaybe<WixRichContentV1PollDataDesignOptionDesignInput>;
  /** Styling for the poll. */
  poll?: InputMaybe<WixRichContentV1PollDataDesignPollDesignInput>;
};

export type WixRichContentV1PollDataDesignOptionDesign = {
  __typename?: 'WixRichContentV1PollDataDesignOptionDesign';
  /** Border radius in pixels. */
  borderRadius?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1PollDataDesignOptionDesignInput = {
  /** Border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1PollDataDesignPollDesign = {
  __typename?: 'WixRichContentV1PollDataDesignPollDesign';
  /** Background styling. */
  background?: Maybe<WixRichContentV1PollDataDesignPollDesignBackground>;
  /** Border radius in pixels. */
  borderRadius?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1PollDataDesignPollDesignBackground = {
  __typename?: 'WixRichContentV1PollDataDesignPollDesignBackground';
  /** The background color as a hexademical value. */
  color?: Maybe<Scalars['String']>;
  /** Details for a gradient background. */
  gradient?: Maybe<WixRichContentV1PollDataDesignPollDesignBackgroundGradient>;
  /** An image to use for the background. */
  image?: Maybe<WixRichContentV1Media>;
  /** Background type. For each option, include the relevant details. */
  type?: Maybe<WixRichContentV1PollDataDesignPollDesignBackgroundType>;
};

export type WixRichContentV1PollDataDesignPollDesignBackgroundGradient = {
  __typename?: 'WixRichContentV1PollDataDesignPollDesignBackgroundGradient';
  /** The gradient angle in degrees. */
  angle?: Maybe<Scalars['Int']>;
  /** The end color as a hexademical value. */
  lastColor?: Maybe<Scalars['String']>;
  /** The start color as a hexademical value. */
  startColor?: Maybe<Scalars['String']>;
};

export type WixRichContentV1PollDataDesignPollDesignBackgroundGradientInput = {
  /** The gradient angle in degrees. */
  angle?: InputMaybe<Scalars['Int']>;
  /** The end color as a hexademical value. */
  lastColor?: InputMaybe<Scalars['String']>;
  /** The start color as a hexademical value. */
  startColor?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1PollDataDesignPollDesignBackgroundInput = {
  /** The background color as a hexademical value. */
  color?: InputMaybe<Scalars['String']>;
  /** Details for a gradient background. */
  gradient?: InputMaybe<WixRichContentV1PollDataDesignPollDesignBackgroundGradientInput>;
  /** An image to use for the background. */
  image?: InputMaybe<WixRichContentV1MediaInput>;
  /** Background type. For each option, include the relevant details. */
  type?: InputMaybe<WixRichContentV1PollDataDesignPollDesignBackgroundType>;
};

export enum WixRichContentV1PollDataDesignPollDesignBackgroundType {
  /** Color background type */
  Color = 'COLOR',
  /** Gradiant background type */
  Gradient = 'GRADIENT',
  /** Image background type */
  Image = 'IMAGE'
}

export type WixRichContentV1PollDataDesignPollDesignInput = {
  /** Background styling. */
  background?: InputMaybe<WixRichContentV1PollDataDesignPollDesignBackgroundInput>;
  /** Border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1PollDataInput = {
  /** Styling for the poll's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Styling for the poll and voting options. */
  design?: InputMaybe<WixRichContentV1PollDataDesignInput>;
  /** Layout settings for the poll and voting options. */
  layout?: InputMaybe<WixRichContentV1PollDataLayoutInput>;
  /** Poll data. */
  poll?: InputMaybe<WixRichContentV1PollDataPollInput>;
};

export type WixRichContentV1PollDataLayout = {
  __typename?: 'WixRichContentV1PollDataLayout';
  /** Voting otpions layout settings. */
  options?: Maybe<WixRichContentV1PollDataLayoutOptionLayout>;
  /** Poll layout settings. */
  poll?: Maybe<WixRichContentV1PollDataLayoutPollLayout>;
};

export type WixRichContentV1PollDataLayoutInput = {
  /** Voting otpions layout settings. */
  options?: InputMaybe<WixRichContentV1PollDataLayoutOptionLayoutInput>;
  /** Poll layout settings. */
  poll?: InputMaybe<WixRichContentV1PollDataLayoutPollLayoutInput>;
};

export type WixRichContentV1PollDataLayoutOptionLayout = {
  __typename?: 'WixRichContentV1PollDataLayoutOptionLayout';
  /** Sets whether to display option images. Defaults to `false`. */
  enableImage?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1PollDataLayoutOptionLayoutInput = {
  /** Sets whether to display option images. Defaults to `false`. */
  enableImage?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1PollDataLayoutPollLayout = {
  __typename?: 'WixRichContentV1PollDataLayoutPollLayout';
  /** The direction of the text displayed in the voting options. Text can be displayed either right-to-left or left-to-right. */
  direction?: Maybe<WixRichContentV1PollDataLayoutPollLayoutDirection>;
  /** Sets whether to display the main poll image. Defaults to `false`. */
  enableImage?: Maybe<Scalars['Boolean']>;
  /** The layout for displaying the voting options. */
  type?: Maybe<WixRichContentV1PollDataLayoutPollLayoutType>;
};

export enum WixRichContentV1PollDataLayoutPollLayoutDirection {
  /** Left-to-right */
  Ltr = 'LTR',
  /** Right-to-left */
  Rtl = 'RTL'
}

export type WixRichContentV1PollDataLayoutPollLayoutInput = {
  /** The direction of the text displayed in the voting options. Text can be displayed either right-to-left or left-to-right. */
  direction?: InputMaybe<WixRichContentV1PollDataLayoutPollLayoutDirection>;
  /** Sets whether to display the main poll image. Defaults to `false`. */
  enableImage?: InputMaybe<Scalars['Boolean']>;
  /** The layout for displaying the voting options. */
  type?: InputMaybe<WixRichContentV1PollDataLayoutPollLayoutType>;
};

export enum WixRichContentV1PollDataLayoutPollLayoutType {
  /** Grid */
  Grid = 'GRID',
  /** List */
  List = 'LIST'
}

export type WixRichContentV1PollDataPoll = {
  __typename?: 'WixRichContentV1PollDataPoll';
  /** Poll creator ID. */
  creatorId?: Maybe<Scalars['String']>;
  /** Poll ID. */
  id?: Maybe<Scalars['String']>;
  /** Main poll image. */
  image?: Maybe<WixRichContentV1Media>;
  /** Voting options. */
  options?: Maybe<Array<Maybe<WixRichContentV1PollDataPollOption>>>;
  /** The poll's permissions and display settings. */
  settings?: Maybe<WixRichContentV1PollDataPollSettings>;
  /** Poll title. */
  title?: Maybe<Scalars['String']>;
};

export type WixRichContentV1PollDataPollInput = {
  /** Poll creator ID. */
  creatorId?: InputMaybe<Scalars['String']>;
  /** Poll ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Main poll image. */
  image?: InputMaybe<WixRichContentV1MediaInput>;
  /** Voting options. */
  options?: InputMaybe<Array<InputMaybe<WixRichContentV1PollDataPollOptionInput>>>;
  /** The poll's permissions and display settings. */
  settings?: InputMaybe<WixRichContentV1PollDataPollSettingsInput>;
  /** Poll title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1PollDataPollOption = {
  __typename?: 'WixRichContentV1PollDataPollOption';
  /** Option ID. */
  id?: Maybe<Scalars['String']>;
  /** The image displayed with the option. */
  image?: Maybe<WixRichContentV1Media>;
  /** Option title. */
  title?: Maybe<Scalars['String']>;
};

export type WixRichContentV1PollDataPollOptionInput = {
  /** Option ID. */
  id?: InputMaybe<Scalars['String']>;
  /** The image displayed with the option. */
  image?: InputMaybe<WixRichContentV1MediaInput>;
  /** Option title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1PollDataPollSettings = {
  __typename?: 'WixRichContentV1PollDataPollSettings';
  /** Permissions settings for voting. */
  permissions?: Maybe<WixRichContentV1PollDataPollSettingsPermissions>;
  /** Sets whether voters are displayed in the vote results. Defaults to `true`. */
  showVoters?: Maybe<Scalars['Boolean']>;
  /** Sets whether the vote count is displayed. Defaults to `true`. */
  showVotesCount?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1PollDataPollSettingsInput = {
  /** Permissions settings for voting. */
  permissions?: InputMaybe<WixRichContentV1PollDataPollSettingsPermissionsInput>;
  /** Sets whether voters are displayed in the vote results. Defaults to `true`. */
  showVoters?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the vote count is displayed. Defaults to `true`. */
  showVotesCount?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1PollDataPollSettingsPermissions = {
  __typename?: 'WixRichContentV1PollDataPollSettingsPermissions';
  /** Sets whether one voter can vote multiple times. Defaults to `false`. */
  allowMultipleVotes?: Maybe<Scalars['Boolean']>;
  /** Sets who can view the poll results. */
  view?: Maybe<WixRichContentV1PollDataPollSettingsPermissionsViewRole>;
  /** Sets who can vote. */
  vote?: Maybe<WixRichContentV1PollDataPollSettingsPermissionsVoteRole>;
};

export type WixRichContentV1PollDataPollSettingsPermissionsInput = {
  /** Sets whether one voter can vote multiple times. Defaults to `false`. */
  allowMultipleVotes?: InputMaybe<Scalars['Boolean']>;
  /** Sets who can view the poll results. */
  view?: InputMaybe<WixRichContentV1PollDataPollSettingsPermissionsViewRole>;
  /** Sets who can vote. */
  vote?: InputMaybe<WixRichContentV1PollDataPollSettingsPermissionsVoteRole>;
};

export enum WixRichContentV1PollDataPollSettingsPermissionsViewRole {
  /** Only Poll creator can view the results */
  Creator = 'CREATOR',
  /** Anyone can see the results, even if one didn't vote */
  Everyone = 'EVERYONE',
  /** Anyone who voted can see the results */
  Voters = 'VOTERS'
}

export enum WixRichContentV1PollDataPollSettingsPermissionsVoteRole {
  /** Anyone */
  All = 'ALL',
  /** Logged in member */
  SiteMembers = 'SITE_MEMBERS'
}

export type WixRichContentV1RichContent = {
  __typename?: 'WixRichContentV1RichContent';
  /** Global styling for header, paragraph, block quote, and code block nodes in the object. */
  documentStyle?: Maybe<WixRichContentV1DocumentStyle>;
  /** Object metadata. */
  metadata?: Maybe<WixRichContentV1Metadata>;
  /** Node objects representing a rich content document. */
  nodes?: Maybe<Array<Maybe<WixRichContentV1Node>>>;
};

export type WixRichContentV1RichContentInput = {
  /** Global styling for header, paragraph, block quote, and code block nodes in the object. */
  documentStyle?: InputMaybe<WixRichContentV1DocumentStyleInput>;
  /** Object metadata. */
  metadata?: InputMaybe<WixRichContentV1MetadataInput>;
  /** Node objects representing a rich content document. */
  nodes?: InputMaybe<Array<InputMaybe<WixRichContentV1NodeInput>>>;
};

export type WixRichContentV1SpoilerData = {
  __typename?: 'WixRichContentV1SpoilerData';
  /** Spoiler ID. */
  id?: Maybe<Scalars['String']>;
};

export type WixRichContentV1SpoilerDataInput = {
  /** Spoiler ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1Struct = {
  __typename?: 'WixRichContentV1Struct';
  /** An unordered map of dynamically typed values. */
  fields?: Maybe<WixRichContentV1Value>;
};

export type WixRichContentV1StructInput = {
  /** An unordered map of dynamically typed values. */
  fields?: InputMaybe<WixRichContentV1ValueInput>;
};

export type WixRichContentV1TableCellData = {
  __typename?: 'WixRichContentV1TableCellData';
  /** The cell's border colors. */
  borderColors?: Maybe<WixRichContentV1TableCellDataBorderColors>;
  /** Styling for the cell's background color and text alignment. */
  cellStyle?: Maybe<WixRichContentV1TableCellDataCellStyle>;
};

export type WixRichContentV1TableCellDataBorderColors = {
  __typename?: 'WixRichContentV1TableCellDataBorderColors';
  /** Bottom border color as a hexadecimal value. */
  bottom?: Maybe<Scalars['String']>;
  /** Left border color as a hexadecimal value. */
  left?: Maybe<Scalars['String']>;
  /** Right border color as a hexadecimal value. */
  right?: Maybe<Scalars['String']>;
  /** Top border color as a hexadecimal value. */
  top?: Maybe<Scalars['String']>;
};

export type WixRichContentV1TableCellDataBorderColorsInput = {
  /** Bottom border color as a hexadecimal value. */
  bottom?: InputMaybe<Scalars['String']>;
  /** Left border color as a hexadecimal value. */
  left?: InputMaybe<Scalars['String']>;
  /** Right border color as a hexadecimal value. */
  right?: InputMaybe<Scalars['String']>;
  /** Top border color as a hexadecimal value. */
  top?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1TableCellDataCellStyle = {
  __typename?: 'WixRichContentV1TableCellDataCellStyle';
  /** Cell background color as a hexadecimal value. */
  backgroundColor?: Maybe<Scalars['String']>;
  /** Vertical alignment for the cell's text. */
  verticalAlignment?: Maybe<WixRichContentV1TableCellDataVerticalAlignment>;
};

export type WixRichContentV1TableCellDataCellStyleInput = {
  /** Cell background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Vertical alignment for the cell's text. */
  verticalAlignment?: InputMaybe<WixRichContentV1TableCellDataVerticalAlignment>;
};

export type WixRichContentV1TableCellDataInput = {
  /** The cell's border colors. */
  borderColors?: InputMaybe<WixRichContentV1TableCellDataBorderColorsInput>;
  /** Styling for the cell's background color and text alignment. */
  cellStyle?: InputMaybe<WixRichContentV1TableCellDataCellStyleInput>;
};

export enum WixRichContentV1TableCellDataVerticalAlignment {
  /** Bottom alignment */
  Bottom = 'BOTTOM',
  /** Middle alignment */
  Middle = 'MIDDLE',
  /** Top alignment */
  Top = 'TOP'
}

export type WixRichContentV1TableData = {
  __typename?: 'WixRichContentV1TableData';
  /** Sets whether the table's first column is a header. Defaults to `false`. */
  columnHeader?: Maybe<Scalars['Boolean']>;
  /** Styling for the table's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** The table's dimensions. */
  dimensions?: Maybe<WixRichContentV1TableDataDimensions>;
  /** Deprecated: Use `rowHeader` and `columnHeader` instead. */
  header?: Maybe<Scalars['Boolean']>;
  /** Sets whether the table's first row is a header. Defaults to `false`. */
  rowHeader?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1TableDataDimensions = {
  __typename?: 'WixRichContentV1TableDataDimensions';
  /** An array representing the minimum width of each column in pixels. */
  colsMinWidth?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** An array representing relative width of each column in relation to the other columns. */
  colsWidthRatio?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** An array representing the height of each row in pixels. */
  rowsHeight?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type WixRichContentV1TableDataDimensionsInput = {
  /** An array representing the minimum width of each column in pixels. */
  colsMinWidth?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** An array representing relative width of each column in relation to the other columns. */
  colsWidthRatio?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** An array representing the height of each row in pixels. */
  rowsHeight?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type WixRichContentV1TableDataInput = {
  /** Sets whether the table's first column is a header. Defaults to `false`. */
  columnHeader?: InputMaybe<Scalars['Boolean']>;
  /** Styling for the table's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** The table's dimensions. */
  dimensions?: InputMaybe<WixRichContentV1TableDataDimensionsInput>;
  /** Deprecated: Use `rowHeader` and `columnHeader` instead. */
  header?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the table's first row is a header. Defaults to `false`. */
  rowHeader?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1TextData = {
  __typename?: 'WixRichContentV1TextData';
  /** The decorations to apply. */
  decorations?: Maybe<Array<Maybe<WixRichContentV1Decoration>>>;
  /** The text to apply decorations to. */
  text?: Maybe<Scalars['String']>;
};

export type WixRichContentV1TextDataInput = {
  /** The decorations to apply. */
  decorations?: InputMaybe<Array<InputMaybe<WixRichContentV1DecorationInput>>>;
  /** The text to apply decorations to. */
  text?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1TextNodeStyle = {
  __typename?: 'WixRichContentV1TextNodeStyle';
  /** The decorations to apply to the node. */
  decorations?: Maybe<Array<Maybe<WixRichContentV1Decoration>>>;
  /** Line height for text in the node. */
  lineHeight?: Maybe<Scalars['String']>;
  /** Padding and background color for the node. */
  nodeStyle?: Maybe<WixRichContentV1NodeStyle>;
};

export type WixRichContentV1TextNodeStyleInput = {
  /** The decorations to apply to the node. */
  decorations?: InputMaybe<Array<InputMaybe<WixRichContentV1DecorationInput>>>;
  /** Line height for text in the node. */
  lineHeight?: InputMaybe<Scalars['String']>;
  /** Padding and background color for the node. */
  nodeStyle?: InputMaybe<WixRichContentV1NodeStyleInput>;
};

export type WixRichContentV1TextStyle = {
  __typename?: 'WixRichContentV1TextStyle';
  /** A CSS `line-height` value for the text expressed as a ratio relative to the font size. For example, if the font size is 20px, a `lineHeight` value of `'1.5'`` results in a line height of 30px. */
  lineHeight?: Maybe<Scalars['String']>;
  /** Text alignment. Defaults to `AUTO`. */
  textAlignment?: Maybe<WixRichContentV1TextStyleTextAlignment>;
};

export type WixRichContentV1TextStyleInput = {
  /** A CSS `line-height` value for the text expressed as a ratio relative to the font size. For example, if the font size is 20px, a `lineHeight` value of `'1.5'`` results in a line height of 30px. */
  lineHeight?: InputMaybe<Scalars['String']>;
  /** Text alignment. Defaults to `AUTO`. */
  textAlignment?: InputMaybe<WixRichContentV1TextStyleTextAlignment>;
};

export enum WixRichContentV1TextStyleTextAlignment {
  /** browser default, eqivalent to `initial` */
  Auto = 'AUTO',
  /** Center align */
  Center = 'CENTER',
  /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
  Justify = 'JUSTIFY',
  /** Left align */
  Left = 'LEFT',
  /** Right align */
  Right = 'RIGHT'
}

export type WixRichContentV1Value = {
  __typename?: 'WixRichContentV1Value';
  /** A boolean value. */
  boolValue?: Maybe<Scalars['Boolean']>;
  /** An array of `value` objects. */
  listValue?: Maybe<WixRichContentV1ListValue>;
  /** A null value. */
  nullValue?: Maybe<WixRichContentV1NullValue>;
  /** A double value. */
  numberValue?: Maybe<Scalars['Float']>;
  /** A string value. */
  stringValue?: Maybe<Scalars['String']>;
  /** A structured value. */
  structValue?: Maybe<WixRichContentV1Struct>;
};

export type WixRichContentV1ValueInput = {
  /** A boolean value. */
  boolValue?: InputMaybe<Scalars['Boolean']>;
  /** An array of `value` objects. */
  listValue?: InputMaybe<WixRichContentV1ListValueInput>;
  /** A null value. */
  nullValue?: InputMaybe<WixRichContentV1NullValue>;
  /** A double value. */
  numberValue?: InputMaybe<Scalars['Float']>;
  /** A string value. */
  stringValue?: InputMaybe<Scalars['String']>;
  /** A structured value. */
  structValue?: InputMaybe<WixRichContentV1StructInput>;
};

export type WixRichContentV1VideoData = {
  __typename?: 'WixRichContentV1VideoData';
  /** Styling for the video's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Sets whether the video's download button is disabled. Defaults to `false`. */
  disableDownload?: Maybe<Scalars['Boolean']>;
  /** Video options. */
  options?: Maybe<WixRichContentV1PlaybackOptions>;
  /** Video thumbnail details. */
  thumbnail?: Maybe<WixRichContentV1Media>;
  /** Video title. */
  title?: Maybe<Scalars['String']>;
  /** Video details. */
  video?: Maybe<WixRichContentV1Media>;
};

export type WixRichContentV1VideoDataInput = {
  /** Styling for the video's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Sets whether the video's download button is disabled. Defaults to `false`. */
  disableDownload?: InputMaybe<Scalars['Boolean']>;
  /** Video options. */
  options?: InputMaybe<WixRichContentV1PlaybackOptionsInput>;
  /** Video thumbnail details. */
  thumbnail?: InputMaybe<WixRichContentV1MediaInput>;
  /** Video title. */
  title?: InputMaybe<Scalars['String']>;
  /** Video details. */
  video?: InputMaybe<WixRichContentV1MediaInput>;
};

export type WixRiseV1ActionInitiator = {
  __typename?: 'WixRiseV1ActionInitiator';
  /** ID of the initiator */
  id?: Maybe<Scalars['String']>;
  /** The type of the initiator (e.g., app, user) */
  type?: Maybe<WixRiseV1ActionInitiatorInitiatorType>;
};

export enum WixRiseV1ActionInitiatorInitiatorType {
  App = 'APP',
  UnknownInitiator = 'UNKNOWN_INITIATOR',
  User = 'USER'
}

export type WixRiseV1ActionInitiatorInput = {
  /** ID of the initiator */
  id?: InputMaybe<Scalars['String']>;
  /** The type of the initiator (e.g., app, user) */
  type?: InputMaybe<WixRiseV1ActionInitiatorInitiatorType>;
};

export type WixRiseV1AddCustomerReferenceRequestInput = {
  /** Customer reference */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
  /** Wallet ID */
  walletId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1AddCustomerReferenceResponse = {
  __typename?: 'WixRiseV1AddCustomerReferenceResponse';
  /** Customer reference */
  customerReference?: Maybe<WixRiseV1CustomerReference>;
};

export type WixRiseV1BulkDeleteGiftCardsByFilterRequestInput = {
  /** Expected gift card amount to delete */
  expectedAmount?: InputMaybe<Scalars['Int']>;
  /** MSID from which to delete the gift cards */
  metaSiteId?: InputMaybe<Scalars['String']>;
  /** WQL expression */
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type WixRiseV1BulkDeleteGiftCardsByFilterResponse = {
  __typename?: 'WixRiseV1BulkDeleteGiftCardsByFilterResponse';
  jobId?: Maybe<Scalars['String']>;
};

export type WixRiseV1BulkOptions = {
  __typename?: 'WixRiseV1BulkOptions';
  /** ID of the bulk that issued the gift card or transaction. */
  bulkId?: Maybe<Scalars['String']>;
  /** Indicates whether the gift card or transaction is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** Internal note about the bulk */
  note?: Maybe<Scalars['String']>;
};

export type WixRiseV1BulkOptionsInput = {
  /** ID of the bulk that issued the gift card or transaction. */
  bulkId?: InputMaybe<Scalars['String']>;
  /** Indicates whether the gift card or transaction is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** Internal note about the bulk */
  note?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1CampaignOptions = {
  __typename?: 'WixRiseV1CampaignOptions';
  campaignId?: Maybe<Scalars['String']>;
  liability?: Maybe<Scalars['Boolean']>;
};

export type WixRiseV1CampaignOptionsInput = {
  campaignId?: InputMaybe<Scalars['String']>;
  liability?: InputMaybe<Scalars['Boolean']>;
};

export type WixRiseV1CountGiftCardsRequestInput = {
  /** [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language) filter to count gift cards. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixRiseV1CountGiftCardsResponse = {
  __typename?: 'WixRiseV1CountGiftCardsResponse';
  /** The number of gift cards that match the provided filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixRiseV1CountWalletsRequestInput = {
  /** Filter by which to count wallets. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixRiseV1CountWalletsResponse = {
  __typename?: 'WixRiseV1CountWalletsResponse';
  /** Number of wallets matching the filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixRiseV1CreateCustomerReferenceRequestInput = {
  /** Customer reference */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
};

export type WixRiseV1CreateCustomerReferenceResponse = {
  __typename?: 'WixRiseV1CreateCustomerReferenceResponse';
  /** Customer reference */
  customerReference?: Maybe<WixRiseV1CustomerReference>;
};

export type WixRiseV1CreateGiftCardRequestInput = {
  /** The GiftCard to create. */
  giftCard?: InputMaybe<WixRiseV1GiftCardInput>;
};

export type WixRiseV1CreateGiftCardResponse = {
  __typename?: 'WixRiseV1CreateGiftCardResponse';
  /** The created GiftCard. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1CreateMigrationGiftCardRequestInput = {
  /** The gift card to create. */
  giftCard?: InputMaybe<WixRiseV1GiftCardInput>;
};

export type WixRiseV1CreateMigrationGiftCardResponse = {
  __typename?: 'WixRiseV1CreateMigrationGiftCardResponse';
  /** The created gift card. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1CreateMigrationTransactionRequestInput = {
  /** The transaction to create. */
  transaction?: InputMaybe<WixRiseV1TransactionInput>;
};

export type WixRiseV1CreateMigrationTransactionResponse = {
  __typename?: 'WixRiseV1CreateMigrationTransactionResponse';
  /** The created transaction. */
  transaction?: Maybe<WixRiseV1Transaction>;
};

export type WixRiseV1CreateMigrationWalletActionRequestInput = {
  /** ID of the giftcard that belongs to the wallet. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /** WalletAction to be created. */
  walletAction?: InputMaybe<WixRiseV1WalletActionInput>;
};

export type WixRiseV1CreateMigrationWalletActionResponse = {
  __typename?: 'WixRiseV1CreateMigrationWalletActionResponse';
  /** The created WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1CreateWalletActionByCustomerReferenceRequestInput = {
  /** CustomerReference of the customer for which to create the wallet action. */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
  /** The currency for the new wallet, if no wallet already exists. */
  newWalletCurrency?: InputMaybe<Scalars['String']>;
  /** WalletAction to be created. */
  walletAction?: InputMaybe<WixRiseV1WalletActionInput>;
};

export type WixRiseV1CreateWalletActionByCustomerReferenceResponse = {
  __typename?: 'WixRiseV1CreateWalletActionByCustomerReferenceResponse';
  /** The wallet to which the wallet action was added. */
  wallet?: Maybe<WixRiseV1Wallet>;
  /** The created WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1CreateWalletActionRequestInput = {
  /** WalletAction to be created. */
  walletAction?: InputMaybe<WixRiseV1WalletActionInput>;
};

export type WixRiseV1CreateWalletActionResponse = {
  __typename?: 'WixRiseV1CreateWalletActionResponse';
  /** The created WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1CreateWalletRequestInput = {
  /** Currency of the wallet. */
  currency?: InputMaybe<Scalars['String']>;
  /** Initial Customer Reference for the wallet. */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
  /** Initial amount of store credit. */
  initialValue?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1CreateWalletResponse = {
  __typename?: 'WixRiseV1CreateWalletResponse';
  /** Created wallet. */
  wallet?: Maybe<WixRiseV1Wallet>;
  /** ID of the walletAction (store credit) created by this request. */
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1CustomerReference = {
  __typename?: 'WixRiseV1CustomerReference';
  /** Internal Rise id. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** Email address. */
  email?: Maybe<Scalars['String']>;
  /** First name. */
  firstName?: Maybe<Scalars['String']>;
  /** Internal Rise id. */
  id?: Maybe<Scalars['String']>;
  /** Last name. */
  lastName?: Maybe<Scalars['String']>;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /** Source channel, i.e. Shopify. */
  sourceChannelId?: Maybe<Scalars['String']>;
  /** Customer ID in Source. */
  sourceCustomerId?: Maybe<Scalars['String']>;
  /** Tenant ID in Source, i.e. shop ID. */
  sourceTenantId?: Maybe<Scalars['String']>;
};

export type WixRiseV1CustomerReferenceInput = {
  /** Email address. */
  email?: InputMaybe<Scalars['String']>;
  /** First name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Internal Rise id. */
  id?: InputMaybe<Scalars['String']>;
  /** Last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Source channel, i.e. Shopify. */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** Customer ID in Source. */
  sourceCustomerId?: InputMaybe<Scalars['String']>;
  /** Tenant ID in Source, i.e. shop ID. */
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1CustomerReferenceQueryInput = {
  /** CustomerReference source (i.e. source channel, tenant, and customer IDs) */
  customerReferenceSource?: InputMaybe<WixRiseV1SourceInput>;
};

export type WixRiseV1DecreaseBalanceRequestInput = {
  /** The Transaction to be created. */
  transaction?: InputMaybe<WixRiseV1TransactionInput>;
};

export type WixRiseV1DecreaseBalanceResponse = {
  __typename?: 'WixRiseV1DecreaseBalanceResponse';
  /** GiftCard balance after Transaction. */
  balance?: Maybe<Scalars['String']>;
  /** Transaction Currency. */
  currency?: Maybe<Scalars['String']>;
  /** The created Transaction. */
  transaction?: Maybe<WixRiseV1Transaction>;
};

export type WixRiseV1DeleteCustomerReferenceRequestInput = {
  /** Query by customer reference source (i.e. source channel, tenant, and customer IDs) */
  query?: InputMaybe<WixRiseV1CustomerReferenceQueryInput>;
};

export type WixRiseV1DeleteWalletActionRequestInput = {
  /** The revision of the WalletAction. */
  revision?: InputMaybe<Scalars['Long']>;
  /** ID of the WalletAction to delete. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1DisableGiftCardRequestInput = {
  /** The ID of the GiftCard to disable. */
  giftCardId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1DisableGiftCardResponse = {
  __typename?: 'WixRiseV1DisableGiftCardResponse';
  /** The disabled GiftCard. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1DisableWalletActionRequestInput = {
  /** The revision of the WalletAction. */
  revision?: InputMaybe<Scalars['Long']>;
  /** ID of the WalletAction to delete. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1DisableWalletActionResponse = {
  __typename?: 'WixRiseV1DisableWalletActionResponse';
  /** The disabled WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1EndMigrationWalletActionRequestInput = {
  /** Amount of the WalletAction to subtract from the wallet. */
  amountToSubtract?: InputMaybe<Scalars['String']>;
  /** ID of the giftcard that belongs to the wallet. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /** ID of the WalletAction to be ended. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1EndMigrationWalletActionResponse = {
  __typename?: 'WixRiseV1EndMigrationWalletActionResponse';
  /** The ended WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1ExternalEvent = {
  __typename?: 'WixRiseV1ExternalEvent';
  /** Short description or identifier of the event */
  description?: Maybe<Scalars['String']>;
  /** Event type indicator */
  name?: Maybe<WixRiseV1ExternalEventExternalEventType>;
};

export enum WixRiseV1ExternalEventExternalEventType {
  Compensation = 'COMPENSATION',
  Membership = 'MEMBERSHIP',
  Order = 'ORDER',
  Other = 'OTHER',
  Referral = 'REFERRAL',
  Refund = 'REFUND',
  SignUp = 'SIGN_UP',
  UnknownEventType = 'UNKNOWN_EVENT_TYPE'
}

export type WixRiseV1ExternalEventInput = {
  /** Short description or identifier of the event */
  description?: InputMaybe<Scalars['String']>;
  /** Event type indicator */
  name?: InputMaybe<WixRiseV1ExternalEventExternalEventType>;
};

export type WixRiseV1GetCustomerReferenceRequestInput = {
  /** Customer Reference query object. */
  query?: InputMaybe<WixRiseV1CustomerReferenceQueryInput>;
};

export type WixRiseV1GetCustomerReferenceResponse = {
  __typename?: 'WixRiseV1GetCustomerReferenceResponse';
  /** Retrieved Customer reference. */
  customerReference?: Maybe<WixRiseV1CustomerReference>;
};

export type WixRiseV1GetGiftCardConsistentRequestInput = {
  /** The ID of the GiftCard to retrieve. */
  giftCardId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1GetGiftCardConsistentResponse = {
  __typename?: 'WixRiseV1GetGiftCardConsistentResponse';
  /** The retrieved GiftCard. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1GetGiftCardRequestInput = {
  id: Scalars['ID'];
};

export type WixRiseV1GetOrCreateWalletRequestInput = {
  /** Currency of the wallet. */
  currency?: InputMaybe<Scalars['String']>;
  /** The customer reference with which to create or retrieve the wallet. */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
};

export type WixRiseV1GetOrCreateWalletResponse = {
  __typename?: 'WixRiseV1GetOrCreateWalletResponse';
  /** The retrieved or created wallet. */
  wallet?: Maybe<WixRiseV1Wallet>;
};

export type WixRiseV1GetRefundableAmountsRequestInput = {
  /** ID of the transaction to get refundable amounts for */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1GetRefundableAmountsResponse = {
  __typename?: 'WixRiseV1GetRefundableAmountsResponse';
  amounts?: Maybe<Array<Maybe<WixRiseV1RefundableAmount>>>;
};

export type WixRiseV1GetTransactionRequestInput = {
  id: Scalars['ID'];
};

export type WixRiseV1GetWalletActionRequestInput = {
  id: Scalars['ID'];
};

export type WixRiseV1GetWalletGiftCardRequestInput = {
  /** Wallet ID, email, or customer reference source by which to retrieve the gift card. */
  query?: InputMaybe<WixRiseV1WalletQueryInput>;
};

export type WixRiseV1GetWalletGiftCardResponse = {
  __typename?: 'WixRiseV1GetWalletGiftCardResponse';
  /** The retrieved Gift Card. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1GetWalletRequestInput = {
  id: Scalars['ID'];
};

export type WixRiseV1GetWalletResponse = {
  __typename?: 'WixRiseV1GetWalletResponse';
  /** The retrieved Wallet. */
  wallet?: Maybe<WixRiseV1Wallet>;
};

export type WixRiseV1GiftCard = {
  __typename?: 'WixRiseV1GiftCard';
  /** Current balance of the Gift Card. */
  balance?: Maybe<Scalars['String']>;
  /** Gift Card code for redemption. */
  code?: Maybe<Scalars['String']>;
  /** Last 4 characters of the gift card code for easier reference and searching. */
  codeSuffix?: Maybe<Scalars['String']>;
  /** Gift Card creation date. */
  createdDate?: Maybe<Scalars['String']>;
  /** Gift Card currency. */
  currency?: Maybe<Scalars['String']>;
  /** Gift Card disable date, if the gift card was disabled. */
  disableDate?: Maybe<Scalars['String']>;
  /** Gift Card expiration date. */
  expirationDate?: Maybe<Scalars['String']>;
  /** Unique ID of the Gift Card. */
  id?: Maybe<Scalars['String']>;
  /** Gift Card idempotency key, to prevent duplicate creation. */
  idempotencyKey?: Maybe<Scalars['String']>;
  /** Initial value of the Gift Card. */
  initialValue?: Maybe<Scalars['String']>;
  /** Internal field to optimize the logic of Reminders feature. */
  lastActivityForReminders?: Maybe<Scalars['String']>;
  /**
   * ID of the last transaction that modified the gift card balance.
   * @deprecated ID of the last transaction that modified the gift card balance. Replaced by: transaction_details.last_transaction.id. Removal date: 2026-03-01.
   */
  lastTransactionId?: Maybe<Scalars['String']>;
  /** Gift Card revision. */
  revision?: Maybe<Scalars['Long']>;
  /** Information about the source of the gift card. */
  sourceInfo?: Maybe<WixRiseV1GiftCardSourceInfo>;
  /** Transaction details related to the gift card. */
  transactionDetails?: Maybe<WixRiseV1TransactionDetails>;
  /** Gift Card last update date. */
  updatedDate?: Maybe<Scalars['String']>;
  walletsVirtualReference?: Maybe<WixRiseV1QueryWalletsResponse>;
};


export type WixRiseV1GiftCardWalletsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryWalletsRequestInput>;
};

export type WixRiseV1GiftCardInfo = {
  __typename?: 'WixRiseV1GiftCardInfo';
  /** Current Gift Card Balance */
  balance?: Maybe<Scalars['String']>;
  /** Gift Card Code */
  code?: Maybe<Scalars['String']>;
  /** Gift Card Code Suffix */
  codeSuffix?: Maybe<Scalars['String']>;
  /** Gift Card Currency */
  currency?: Maybe<Scalars['String']>;
};

export type WixRiseV1GiftCardInput = {
  /** Current balance of the Gift Card. */
  balance?: InputMaybe<Scalars['String']>;
  /** Gift Card code for redemption. */
  code?: InputMaybe<Scalars['String']>;
  /** Last 4 characters of the gift card code for easier reference and searching. */
  codeSuffix?: InputMaybe<Scalars['String']>;
  /** Gift Card creation date. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Gift Card currency. */
  currency?: InputMaybe<Scalars['String']>;
  /** Gift Card disable date, if the gift card was disabled. */
  disableDate?: InputMaybe<Scalars['String']>;
  /** Gift Card expiration date. */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** Unique ID of the Gift Card. */
  id?: InputMaybe<Scalars['String']>;
  /** Gift Card idempotency key, to prevent duplicate creation. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Initial value of the Gift Card. */
  initialValue?: InputMaybe<Scalars['String']>;
  /** Internal field to optimize the logic of Reminders feature. */
  lastActivityForReminders?: InputMaybe<Scalars['String']>;
  /** Gift Card revision. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Information about the source of the gift card. */
  sourceInfo?: InputMaybe<WixRiseV1GiftCardSourceInfoInput>;
  /** Transaction details related to the gift card. */
  transactionDetails?: InputMaybe<WixRiseV1TransactionDetailsInput>;
  /** Gift Card last update date. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1GiftCardSourceInfo = {
  __typename?: 'WixRiseV1GiftCardSourceInfo';
  /** Detailed information about a Gift Card or Gift Card transaction issued from a bulk. */
  bulkOptions?: Maybe<WixRiseV1BulkOptions>;
  /** Bulk Options (deprecated) */
  campaignOptions?: Maybe<WixRiseV1CampaignOptions>;
  /** Details of the API client creating this Gift Card. */
  initiator?: Maybe<WixRiseV1ActionInitiator>;
  /** Detailed information about a Gift Card that was created manually. */
  manualOptions?: Maybe<WixRiseV1ManualOptions>;
  /** Detailed information about a Gift Card or Gift Card Transaction whose source is a migration from Rise V1 or another platform. */
  migrationOptions?: Maybe<WixRiseV1MigrationOptions>;
  /** Detailed information about a Gift Card issued from an order. */
  orderOptions?: Maybe<WixRiseV1OrderOptions>;
  /** The Channel ID of the sales channel that is associated with the gift card creation (e.g. Shopify channel id). */
  sourceChannelId?: Maybe<Scalars['String']>;
  /** The location ID that is associated with the action (supports POS cases). */
  sourceLocationId?: Maybe<Scalars['String']>;
  /** The Tenant ID of the sales channel that is associated with the gift card creation (e.g. Shopify shop id). */
  sourceTenantId?: Maybe<Scalars['String']>;
  /** Detailed information about a Gift Card that belongs to a Store Credit Wallet. */
  storeCreditOptions?: Maybe<WixRiseV1StoreCreditOptions>;
  /** The source type of the gift card. */
  type?: Maybe<WixRiseV1GiftCardType>;
  /** Detailed information about a Gift Card issued from a workflow. */
  workflowOptions?: Maybe<WixRiseV1WorkflowOptions>;
};

export enum WixRiseV1GiftCardSourceInfoGiftCardType {
  Campaign = 'CAMPAIGN',
  Manual = 'MANUAL',
  Migration = 'MIGRATION',
  Order = 'ORDER',
  StoreCredit = 'STORE_CREDIT',
  Unknown = 'UNKNOWN'
}

export type WixRiseV1GiftCardSourceInfoInput = {
  /** Detailed information about a Gift Card or Gift Card transaction issued from a bulk. */
  bulkOptions?: InputMaybe<WixRiseV1BulkOptionsInput>;
  /** Bulk Options (deprecated) */
  campaignOptions?: InputMaybe<WixRiseV1CampaignOptionsInput>;
  /** Details of the API client creating this Gift Card. */
  initiator?: InputMaybe<WixRiseV1ActionInitiatorInput>;
  /** Detailed information about a Gift Card that was created manually. */
  manualOptions?: InputMaybe<WixRiseV1ManualOptionsInput>;
  /** Detailed information about a Gift Card or Gift Card Transaction whose source is a migration from Rise V1 or another platform. */
  migrationOptions?: InputMaybe<WixRiseV1MigrationOptionsInput>;
  /** Detailed information about a Gift Card issued from an order. */
  orderOptions?: InputMaybe<WixRiseV1OrderOptionsInput>;
  /** The Channel ID of the sales channel that is associated with the gift card creation (e.g. Shopify channel id). */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** The location ID that is associated with the action (supports POS cases). */
  sourceLocationId?: InputMaybe<Scalars['String']>;
  /** The Tenant ID of the sales channel that is associated with the gift card creation (e.g. Shopify shop id). */
  sourceTenantId?: InputMaybe<Scalars['String']>;
  /** Detailed information about a Gift Card that belongs to a Store Credit Wallet. */
  storeCreditOptions?: InputMaybe<WixRiseV1StoreCreditOptionsInput>;
  /** The source type of the gift card. */
  type?: InputMaybe<WixRiseV1GiftCardType>;
  /** Detailed information about a Gift Card issued from a workflow. */
  workflowOptions?: InputMaybe<WixRiseV1WorkflowOptionsInput>;
};

export enum WixRiseV1GiftCardType {
  /** Issued from a bulk operation. */
  Bulk = 'BULK',
  Campaign = 'CAMPAIGN',
  /** Issued from the dashboard. */
  Manual = 'MANUAL',
  /** Migrated from Rise V1 or another platform. */
  Migration = 'MIGRATION',
  /** Issued from an order. */
  Order = 'ORDER',
  /** Belongs to a Store Credit Wallet. */
  StoreCredit = 'STORE_CREDIT',
  UnknownGiftCardType = 'UNKNOWN_GIFT_CARD_TYPE',
  /** Issued from a workflow. */
  Workflow = 'WORKFLOW'
}

export type WixRiseV1IncreaseBalanceRequestInput = {
  /** The Transaction to be created. */
  transaction?: InputMaybe<WixRiseV1TransactionInput>;
};

export type WixRiseV1IncreaseBalanceResponse = {
  __typename?: 'WixRiseV1IncreaseBalanceResponse';
  /** GiftCard balance after transaction. */
  balance?: Maybe<Scalars['String']>;
  /** Transaction Currency. */
  currency?: Maybe<Scalars['String']>;
  /** The created Transaction. */
  transaction?: Maybe<WixRiseV1Transaction>;
};

export type WixRiseV1InitialOptions = {
  __typename?: 'WixRiseV1InitialOptions';
  /** Type of the gift card being initialized. */
  giftCardType?: Maybe<WixRiseV1GiftCardType>;
};

export type WixRiseV1InitialOptionsInput = {
  /** Type of the gift card being initialized. */
  giftCardType?: InputMaybe<WixRiseV1GiftCardType>;
};

export type WixRiseV1ManualOptions = {
  __typename?: 'WixRiseV1ManualOptions';
  /** Internal note about the Transaction/Gift Card. */
  note?: Maybe<Scalars['String']>;
};

export type WixRiseV1ManualOptionsInput = {
  /** Internal note about the Transaction/Gift Card. */
  note?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1MigrateWalletRequestInput = {
  /** channel id */
  channelId?: InputMaybe<Scalars['String']>;
  /** Customer reference */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
  /** gift card id */
  giftCard?: InputMaybe<WixRiseV1GiftCardInput>;
  /** tenant id */
  tenantId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1MigrateWalletResponse = {
  __typename?: 'WixRiseV1MigrateWalletResponse';
  /** giftCard */
  giftCard?: Maybe<WixRiseV1GiftCard>;
  /** wallet */
  wallet?: Maybe<WixRiseV1Wallet>;
};

export type WixRiseV1MigrationOptions = {
  __typename?: 'WixRiseV1MigrationOptions';
  /** Indicates whether the gift card or transaction is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** Note about the gift card or transaction being migrated. */
  note?: Maybe<Scalars['String']>;
  /** ID of the gift card or transaction in Rise V1. */
  previousId?: Maybe<Scalars['String']>;
};

export type WixRiseV1MigrationOptionsInput = {
  /** Indicates whether the gift card or transaction is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** Note about the gift card or transaction being migrated. */
  note?: InputMaybe<Scalars['String']>;
  /** ID of the gift card or transaction in Rise V1. */
  previousId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1OrderOptions = {
  __typename?: 'WixRiseV1OrderOptions';
  /** Indicates whether the gift card order is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** ID of the gift card order. */
  orderId?: Maybe<Scalars['String']>;
  /** Order number of the gift card order. */
  orderNumber?: Maybe<Scalars['String']>;
};

export type WixRiseV1OrderOptionsInput = {
  /** Indicates whether the gift card order is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** ID of the gift card order. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Order number of the gift card order. */
  orderNumber?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1PaymentMethodRefundOptions = {
  __typename?: 'WixRiseV1PaymentMethodRefundOptions';
  /** Optional details for the refund that is based of a specific store credit. */
  activeFundingTransaction?: Maybe<WixRiseV1PaymentMethodRefundWalletActionDetails>;
  /** Indicates whether the payment method refund is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** ID of the order associated with the refund. */
  orderId?: Maybe<Scalars['String']>;
  /** Order number associated with the refund. */
  orderNumber?: Maybe<Scalars['String']>;
};

export type WixRiseV1PaymentMethodRefundOptionsInput = {
  /** Optional details for the refund that is based of a specific store credit. */
  activeFundingTransaction?: InputMaybe<WixRiseV1PaymentMethodRefundWalletActionDetailsInput>;
  /** Indicates whether the payment method refund is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** ID of the order associated with the refund. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Order number associated with the refund. */
  orderNumber?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1PaymentMethodRefundWalletActionDetails = {
  __typename?: 'WixRiseV1PaymentMethodRefundWalletActionDetails';
  fundingTransactionId?: Maybe<Scalars['String']>;
  transaction?: Maybe<WixRiseV1Transaction>;
  walletAction?: Maybe<WixRiseV1WalletAction>;
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1PaymentMethodRefundWalletActionDetailsInput = {
  fundingTransactionId?: InputMaybe<Scalars['String']>;
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1ProduceTransactionAddedEventRequestInput = {
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1QueryByContactInput = {
  /** Contact filter object. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Limit for the number of wallets to return. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Sort object. */
  sort?: InputMaybe<Array<InputMaybe<WixRiseV1UpstreamWixCommonSortingInput>>>;
};

export type WixRiseV1QueryGiftCardsRequestInput = {
  /** API Query Language expression. */
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type WixRiseV1QueryGiftCardsResponse = {
  __typename?: 'WixRiseV1QueryGiftCardsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixRiseV1GiftCard>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRiseV1QueryTransactionsInternalRequestInput = {
  /** WQL expression. */
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type WixRiseV1QueryTransactionsInternalResponse = {
  __typename?: 'WixRiseV1QueryTransactionsInternalResponse';
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** The retrieved Transactions. */
  transactions?: Maybe<Array<Maybe<WixRiseV1Transaction>>>;
};

export type WixRiseV1QueryTransactionsRequestInput = {
  /** WQL expression. */
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type WixRiseV1QueryTransactionsResponse = {
  __typename?: 'WixRiseV1QueryTransactionsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixRiseV1Transaction>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRiseV1QueryUnredeemedWalletActionsRequestInput = {
  /** API Query Language expression. */
  query?: InputMaybe<WixRiseWalletActionV1UpstreamWixQueryQueryV2Input>;
};

export type WixRiseV1QueryUnredeemedWalletActionsResponse = {
  __typename?: 'WixRiseV1QueryUnredeemedWalletActionsResponse';
  pagingMetadata?: Maybe<WixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2>;
  /** The retrieved unredeemed WalletActions with their balances. */
  walletActions?: Maybe<Array<Maybe<WixRiseV1WalletActionWithBalance>>>;
};

export type WixRiseV1QueryWalletActionBalancesRequestInput = {
  /** API Query Language expression. */
  query?: InputMaybe<WixRiseWalletActionV1UpstreamWixQueryQueryV2Input>;
};

export type WixRiseV1QueryWalletActionBalancesResponse = {
  __typename?: 'WixRiseV1QueryWalletActionBalancesResponse';
  pagingMetadata?: Maybe<WixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2>;
  /** The retrieved WalletActions with their balances. */
  walletActions?: Maybe<Array<Maybe<WixRiseV1WalletActionWithBalance>>>;
};

export type WixRiseV1QueryWalletActionBalancesResponseWalletActionWithBalance = {
  __typename?: 'WixRiseV1QueryWalletActionBalancesResponseWalletActionWithBalance';
  /** WalletAction balance */
  balance?: Maybe<Scalars['String']>;
  /** WalletAction */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1QueryWalletActionRequestInput = {
  /** API Query Language expression. */
  query?: InputMaybe<WixRiseWalletActionV1UpstreamWixQueryQueryV2Input>;
};

export type WixRiseV1QueryWalletActionResponse = {
  __typename?: 'WixRiseV1QueryWalletActionResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixRiseV1WalletAction>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRiseV1QueryWalletsByContactRequestInput = {
  /** Contact query object. */
  query?: InputMaybe<WixRiseV1QueryByContactInput>;
};

export type WixRiseV1QueryWalletsByContactResponse = {
  __typename?: 'WixRiseV1QueryWalletsByContactResponse';
  /** List of retrieved wallets with gift card information. */
  wallets?: Maybe<Array<Maybe<WixRiseV1Wallet>>>;
};

export type WixRiseV1QueryWalletsRequestInput = {
  /** API Query Language expression. */
  query?: InputMaybe<WixRiseV1UpstreamWixQueryQueryV2Input>;
};

export type WixRiseV1QueryWalletsResponse = {
  __typename?: 'WixRiseV1QueryWalletsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixRiseV1Wallet>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRiseV1RedeemOptions = {
  __typename?: 'WixRiseV1RedeemOptions';
  /** Indicates whether the redemption is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** ID of the order associated with the redemption. */
  orderId?: Maybe<Scalars['String']>;
  /** Order number associated with the redemption. */
  orderNumber?: Maybe<Scalars['String']>;
  /** Total price of the order. */
  totalPrice?: Maybe<Scalars['String']>;
};

export type WixRiseV1RedeemOptionsInput = {
  /** Indicates whether the redemption is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** ID of the order associated with the redemption. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Order number associated with the redemption. */
  orderNumber?: InputMaybe<Scalars['String']>;
  /** Total price of the order. */
  totalPrice?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1RefundTransactionContextInput = {
  sourceChannelId?: InputMaybe<Scalars['String']>;
  sourceLocationId?: InputMaybe<Scalars['String']>;
  sourceOrderId?: InputMaybe<Scalars['String']>;
  sourceOrderNumber?: InputMaybe<Scalars['String']>;
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1RefundTransactionRequestInput = {
  /** Optional custom amount to refund. If not provided, the full amount of the transaction will be refunded. */
  amount?: InputMaybe<Scalars['String']>;
  context?: InputMaybe<WixRiseV1RefundTransactionContextInput>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1RefundableAmount = {
  __typename?: 'WixRiseV1RefundableAmount';
  amount?: Maybe<Scalars['String']>;
  fundingTransactionId?: Maybe<Scalars['String']>;
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1RewardOptions = {
  __typename?: 'WixRiseV1RewardOptions';
  liability?: Maybe<Scalars['Boolean']>;
  walletAction?: Maybe<WixRiseV1WalletAction>;
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1RewardOptionsInput = {
  liability?: InputMaybe<Scalars['Boolean']>;
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1SearchGiftCardsRequestInput = {
  search?: InputMaybe<WixCommonCursorSearchInput>;
};

export type WixRiseV1SearchGiftCardsResponse = {
  __typename?: 'WixRiseV1SearchGiftCardsResponse';
  /** Aggregation data. */
  aggregationData?: Maybe<WixCommonAggregationData>;
  /** Gift Cards which satisfy the provided query. */
  giftCards?: Maybe<Array<Maybe<WixRiseV1GiftCard>>>;
  /** Paging metadata. Contains cursor which can be used in next query. */
  pagingMetadata?: Maybe<WixCommonCursorPagingMetadata>;
};

export type WixRiseV1SourceInput = {
  /** Source channel, i.e. Shopify. */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** Customer ID in Source. */
  sourceCustomerId?: InputMaybe<Scalars['String']>;
  /** Tenant ID in Source, i.e. shop ID. */
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1StoreCreditContext = {
  __typename?: 'WixRiseV1StoreCreditContext';
  /** The issuer type of the store credit (e.g., workflow, bulk, manual) */
  issuer?: Maybe<WixRiseV1StoreCreditContextStoreCreditIssuerType>;
  /** Indicates a specific instance of the issuer (relevant for workflow/bulk) */
  issuerId?: Maybe<Scalars['String']>;
  /** An internal note associated with the store credit */
  note?: Maybe<Scalars['String']>;
  /** The Channel ID of the sales channel that is associated with the store credit (e.g. Shopify channel id) */
  sourceChannelId?: Maybe<Scalars['String']>;
  /** The Tenant ID of the sales channel that is associated with the store credit (e.g. Shopify shop id) */
  sourceTenantId?: Maybe<Scalars['String']>;
};

export type WixRiseV1StoreCreditContextInput = {
  /** The issuer type of the store credit (e.g., workflow, bulk, manual) */
  issuer?: InputMaybe<WixRiseV1StoreCreditContextStoreCreditIssuerType>;
  /** Indicates a specific instance of the issuer (relevant for workflow/bulk) */
  issuerId?: InputMaybe<Scalars['String']>;
  /** An internal note associated with the store credit */
  note?: InputMaybe<Scalars['String']>;
  /** The Channel ID of the sales channel that is associated with the store credit (e.g. Shopify channel id) */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** The Tenant ID of the sales channel that is associated with the store credit (e.g. Shopify shop id) */
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export enum WixRiseV1StoreCreditContextStoreCreditIssuerType {
  /** Issued from a bulk */
  Bulk = 'BULK',
  /** Issued from the Rise dashboard */
  Manual = 'MANUAL',
  /** Issued from another source */
  Other = 'OTHER',
  /** Issued from a refund */
  Refund = 'REFUND',
  UnknownIssuer = 'UNKNOWN_ISSUER',
  /** Issued from a workflow */
  Workflow = 'WORKFLOW'
}

export type WixRiseV1StoreCreditOptions = {
  __typename?: 'WixRiseV1StoreCreditOptions';
  /** ID of the store credit wallet. */
  wallet?: Maybe<WixRiseV1Wallet>;
  /** ID of the store credit wallet. */
  walletId?: Maybe<Scalars['String']>;
};

export type WixRiseV1StoreCreditOptionsInput = {
  /** ID of the store credit wallet. */
  walletId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1StoreCreditRefundOptions = {
  __typename?: 'WixRiseV1StoreCreditRefundOptions';
  /** Indicates whether the store credit refund is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** ID of the wallet action (store credit) given as a refund. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
  /** ID of the wallet action (store credit) given as a refund. */
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1StoreCreditRefundOptionsInput = {
  /** Indicates whether the store credit refund is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** ID of the wallet action (store credit) given as a refund. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1Transaction = {
  __typename?: 'WixRiseV1Transaction';
  /** Transaction amount. */
  amount?: Maybe<Scalars['String']>;
  /**
   * Bulk Options.
   * @deprecated Bulk Options. Replaced by: wallet_action_start_options. Removal date: 2024-12-22.
   */
  bulkOptions?: Maybe<WixRiseV1BulkOptions>;
  /** Bulk Options. */
  campaignOptions?: Maybe<WixRiseV1CampaignOptions>;
  /** Transaction creation date. */
  createdDate?: Maybe<Scalars['String']>;
  /** Information about an external event that lead to the transaction. */
  externalEvent?: Maybe<WixRiseV1ExternalEvent>;
  /** ID of the transaction in a 3rd party system if created there. */
  externalId?: Maybe<Scalars['String']>;
  /** Unique ID of the gift card associated with this transaction. */
  giftCardId?: Maybe<Scalars['String']>;
  /** Transaction unique id. */
  id?: Maybe<Scalars['String']>;
  /** Idempotency key, to prevent duplicate creation. */
  idempotencyKey?: Maybe<Scalars['String']>;
  /** Information about the first transaction that initializes a gift card. */
  initialOptions?: Maybe<WixRiseV1InitialOptions>;
  /** Information about a transaction issued manually from the Rise dashboard. */
  manualOptions?: Maybe<WixRiseV1ManualOptions>;
  /** Information about a transaction whose source is a migration from Rise V1 or another platform. */
  migrationOptions?: Maybe<WixRiseV1MigrationOptions>;
  /** Indicates whether the transaction adds or subtracts from the GiftCard balance. */
  operationType?: Maybe<WixRiseV1TransactionOperationType>;
  /** Information about a transaction whose source is a refunding a payment method. */
  paymentMethodRefundOptions?: Maybe<WixRiseV1PaymentMethodRefundOptions>;
  /** Information about a transaction whose source is a gift card redemption. */
  redeemOptions?: Maybe<WixRiseV1RedeemOptions>;
  /** Reward Options. */
  rewardOptions?: Maybe<WixRiseV1RewardOptions>;
  /** Information about the source of the transaction. */
  sourceInfo?: Maybe<WixRiseV1TransactionSourceInfo>;
  /** Information about a transaction whose source is a store credit refund. */
  storeCreditRefundOptions?: Maybe<WixRiseV1StoreCreditRefundOptions>;
  /** Type of transaction. */
  type?: Maybe<WixRiseV1TransactionTransactionType>;
  /** Gift card Balance after this transaction operation. */
  updatedBalance?: Maybe<Scalars['String']>;
  /** Information about a transaction that comes to void a previous transaction. */
  voidOptions?: Maybe<WixRiseV1VoidOptions>;
  /** Information about a transaction whose source is the end of a wallet action (store credit). */
  walletActionEndOptions?: Maybe<WixRiseV1WalletActionEndOptions>;
  /** Information about a transaction whose source is a wallet action (store credit) to a customer. */
  walletActionStartOptions?: Maybe<WixRiseV1WalletActionStartOptions>;
};

export type WixRiseV1TransactionDetails = {
  __typename?: 'WixRiseV1TransactionDetails';
  /** The last transaction that decreased the gift card balance, such as redemption or refund. */
  lastDecreasingTransaction?: Maybe<WixRiseV1TransactionDetailsTransactionWrapper>;
  /** ID of the last transaction that increased the gift card balance. */
  lastIncreasingTransaction?: Maybe<WixRiseV1TransactionDetailsTransactionWrapper>;
  /** The last transaction that modified the gift card balance. */
  lastTransaction?: Maybe<WixRiseV1TransactionDetailsTransactionWrapper>;
};

export type WixRiseV1TransactionDetailsInput = {
  /** The last transaction that decreased the gift card balance, such as redemption or refund. */
  lastDecreasingTransaction?: InputMaybe<WixRiseV1TransactionDetailsTransactionWrapperInput>;
  /** ID of the last transaction that increased the gift card balance. */
  lastIncreasingTransaction?: InputMaybe<WixRiseV1TransactionDetailsTransactionWrapperInput>;
  /** The last transaction that modified the gift card balance. */
  lastTransaction?: InputMaybe<WixRiseV1TransactionDetailsTransactionWrapperInput>;
};

export type WixRiseV1TransactionDetailsTransactionWrapper = {
  __typename?: 'WixRiseV1TransactionDetailsTransactionWrapper';
  /** Date and time the Transaction was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Transaction ID. */
  id?: Maybe<Scalars['String']>;
  /** Transaction ID. */
  transaction?: Maybe<WixRiseV1Transaction>;
};

export type WixRiseV1TransactionDetailsTransactionWrapperInput = {
  /** Date and time the Transaction was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Transaction ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1TransactionInput = {
  /** Transaction amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Bulk Options. */
  campaignOptions?: InputMaybe<WixRiseV1CampaignOptionsInput>;
  /** Transaction creation date. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Information about an external event that lead to the transaction. */
  externalEvent?: InputMaybe<WixRiseV1ExternalEventInput>;
  /** ID of the transaction in a 3rd party system if created there. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Unique ID of the gift card associated with this transaction. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /** Transaction unique id. */
  id?: InputMaybe<Scalars['String']>;
  /** Idempotency key, to prevent duplicate creation. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Information about the first transaction that initializes a gift card. */
  initialOptions?: InputMaybe<WixRiseV1InitialOptionsInput>;
  /** Information about a transaction issued manually from the Rise dashboard. */
  manualOptions?: InputMaybe<WixRiseV1ManualOptionsInput>;
  /** Information about a transaction whose source is a migration from Rise V1 or another platform. */
  migrationOptions?: InputMaybe<WixRiseV1MigrationOptionsInput>;
  /** Indicates whether the transaction adds or subtracts from the GiftCard balance. */
  operationType?: InputMaybe<WixRiseV1TransactionOperationType>;
  /** Information about a transaction whose source is a refunding a payment method. */
  paymentMethodRefundOptions?: InputMaybe<WixRiseV1PaymentMethodRefundOptionsInput>;
  /** Information about a transaction whose source is a gift card redemption. */
  redeemOptions?: InputMaybe<WixRiseV1RedeemOptionsInput>;
  /** Reward Options. */
  rewardOptions?: InputMaybe<WixRiseV1RewardOptionsInput>;
  /** Information about the source of the transaction. */
  sourceInfo?: InputMaybe<WixRiseV1TransactionSourceInfoInput>;
  /** Information about a transaction whose source is a store credit refund. */
  storeCreditRefundOptions?: InputMaybe<WixRiseV1StoreCreditRefundOptionsInput>;
  /** Type of transaction. */
  type?: InputMaybe<WixRiseV1TransactionTransactionType>;
  /** Gift card Balance after this transaction operation. */
  updatedBalance?: InputMaybe<Scalars['String']>;
  /** Information about a transaction that comes to void a previous transaction. */
  voidOptions?: InputMaybe<WixRiseV1VoidOptionsInput>;
  /** Information about a transaction whose source is the end of a wallet action (store credit). */
  walletActionEndOptions?: InputMaybe<WixRiseV1WalletActionEndOptionsInput>;
  /** Information about a transaction whose source is a wallet action (store credit) to a customer. */
  walletActionStartOptions?: InputMaybe<WixRiseV1WalletActionStartOptionsInput>;
};

export enum WixRiseV1TransactionOperationType {
  Add = 'ADD',
  Subtract = 'SUBTRACT'
}

export type WixRiseV1TransactionSourceInfo = {
  __typename?: 'WixRiseV1TransactionSourceInfo';
  /** Details of the API client creating this Transaction. */
  initiator?: Maybe<WixRiseV1ActionInitiator>;
  /** The Channel ID that is associated with the action. */
  sourceChannelId?: Maybe<Scalars['String']>;
  /** The location ID that is associated with the action (supports POS cases). */
  sourceLocationId?: Maybe<Scalars['String']>;
  /** The Tenant ID that is associated with the action. */
  sourceTenantId?: Maybe<Scalars['String']>;
};

export type WixRiseV1TransactionSourceInfoInput = {
  /** Details of the API client creating this Transaction. */
  initiator?: InputMaybe<WixRiseV1ActionInitiatorInput>;
  /** The Channel ID that is associated with the action. */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** The location ID that is associated with the action (supports POS cases). */
  sourceLocationId?: InputMaybe<Scalars['String']>;
  /** The Tenant ID that is associated with the action. */
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export enum WixRiseV1TransactionTransactionType {
  Bulk = 'BULK',
  Campaign = 'CAMPAIGN',
  /** Initial transaction for a gift card. */
  Initial = 'INITIAL',
  /** Issued from the dashboard. */
  Manual = 'MANUAL',
  /** Migration from Rise V1 or another platform. */
  Migration = 'MIGRATION',
  /** Refunding a payment method. */
  PaymentMethodRefund = 'PAYMENT_METHOD_REFUND',
  Redeem = 'REDEEM',
  Reward = 'REWARD',
  StoreCreditRefund = 'STORE_CREDIT_REFUND',
  UnknownTransactionType = 'UNKNOWN_TRANSACTION_TYPE',
  /** Void of a previous transaction. */
  Void = 'VOID',
  /** End of a wallet action (store credit). */
  WalletActionEnd = 'WALLET_ACTION_END',
  /** Start of a wallet action (store credit). */
  WalletActionStart = 'WALLET_ACTION_START'
}

export type WixRiseV1UpdateCustomerReferenceRequestInput = {
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
};

export type WixRiseV1UpdateCustomerReferenceResponse = {
  __typename?: 'WixRiseV1UpdateCustomerReferenceResponse';
  /** Customer reference */
  customerReference?: Maybe<WixRiseV1CustomerReference>;
};

export type WixRiseV1UpdateGiftCardRequestInput = {
  /** The fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The GiftCard to update. */
  giftCard?: InputMaybe<WixRiseV1GiftCardInput>;
  /** The ID of the GiftCard to update. */
  giftCardId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1UpdateGiftCardResponse = {
  __typename?: 'WixRiseV1UpdateGiftCardResponse';
  /** The updated GiftCard. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1UpdateLastActivityForRemindersRequestInput = {
  /** Gift Card ID */
  giftCardId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1UpdateLastActivityForRemindersResponse = {
  __typename?: 'WixRiseV1UpdateLastActivityForRemindersResponse';
  /** Updated Gift Card */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1UpdateWalletActionRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** WalletAction to be updated, may be partial. */
  walletAction?: InputMaybe<WixRiseV1WalletActionInput>;
};

export type WixRiseV1UpdateWalletActionResponse = {
  __typename?: 'WixRiseV1UpdateWalletActionResponse';
  /** The updated WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixRiseV1UpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export enum WixRiseV1UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixRiseV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixRiseV1UpstreamWixCommonSortOrder>;
};

export type WixRiseV1UpstreamWixQueryQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRiseV1UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixRiseV1UpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixRiseV1UpstreamWixCommonSortingInput>>>;
};

export type WixRiseV1VoidOptions = {
  __typename?: 'WixRiseV1VoidOptions';
  /** ID of the transaction being voided. */
  transaction?: Maybe<WixRiseV1Transaction>;
  /** ID of the transaction being voided. */
  transactionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1VoidOptionsInput = {
  /** ID of the transaction being voided. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1VoidTransactionRequestInput = {
  sourceChannelId?: InputMaybe<Scalars['String']>;
  sourceTenantId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1VoidTransactionResponse = {
  __typename?: 'WixRiseV1VoidTransactionResponse';
  /** GiftCard balance after transaction. */
  balance?: Maybe<Scalars['String']>;
  /** GiftCard Currency. */
  currency?: Maybe<Scalars['String']>;
  transaction?: Maybe<WixRiseV1Transaction>;
};

export type WixRiseV1Wallet = {
  __typename?: 'WixRiseV1Wallet';
  /** ID of the primary customer reference, which is the customer reference with the most contact fields defined. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** The time this Wallet was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** List of references to the customer in specific source channels. See definition below. */
  customerReferences?: Maybe<Array<Maybe<WixRiseV1CustomerReference>>>;
  /** ID of the Gift Card associated with this Wallet. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
  /** ID of the Gift Card associated with this Wallet. */
  giftCardId?: Maybe<Scalars['String']>;
  /** Information about the Gift Card associated with this Wallet. */
  giftCardInfo?: Maybe<WixRiseV1GiftCardInfo>;
  /** Wallet ID. */
  id?: Maybe<Scalars['String']>;
  /** ID of the primary customer reference, which is the customer reference with the most contact fields defined. */
  primaryCustomerReferenceId?: Maybe<Scalars['String']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision. */
  revision?: Maybe<Scalars['Long']>;
  /** The time this Wallet was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixRiseV1WalletAction = {
  __typename?: 'WixRiseV1WalletAction';
  /** The amount to be added to the Wallet. */
  amount?: Maybe<Scalars['String']>;
  /** Represents the time this WalletAction was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Represents the time at which the WalletAction was manually disabled, if applicable. */
  disableDate?: Maybe<Scalars['String']>;
  /** Represents the time at which the unused balance of the WalletAction will be deducted from the account. Defaults to never. */
  expirationDate?: Maybe<Scalars['String']>;
  /** Information about the external event that triggered the WalletAction, such as type of event and a short description or identifier of the event. */
  externalEvent?: Maybe<WixRiseV1ExternalEvent>;
  /** WalletAction ID. */
  id?: Maybe<Scalars['String']>;
  /** Unique key to identify the WalletAction, used to prevent duplicate WalletActions from being created in case of retries or network issues. The key should be unique for each WalletAction and should not be reused. */
  idempotencyKey?: Maybe<Scalars['String']>;
  /** Indicates whether the WalletAction is a liability. The default is false. */
  liability?: Maybe<Scalars['Boolean']>;
  /** Free text comment regarding the WalletAction context */
  note?: Maybe<Scalars['String']>;
  /** Settings of the notifications related to the WalletAction. This field is used to specify whether to skip email dispatch or override the template ID for email notifications. */
  notifications?: Maybe<WixRiseV1WalletActionNotifications>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. For an update operation to succeed, you MUST pass the latest revision. */
  revision?: Maybe<Scalars['Long']>;
  /** Information about the initiator of the WalletAction, such as the app or user that initiated the action. Set when the WalletAction is created. */
  source?: Maybe<WixRiseV1ActionInitiator>;
  /** Represents the time at which the WalletAction's amount will be added to the account. Defaults to immediately. */
  startDate?: Maybe<Scalars['String']>;
  /** The current status of the WalletAction. Set to PENDING when the WalletAction is created and updated to ACTIVE when the amount is added to the wallet. */
  status?: Maybe<WixRiseV1WalletActionWalletActionStatus>;
  /** Detailed information about the context of a store credit, such as the issuer type and sales channel. */
  storeCreditContext?: Maybe<WixRiseV1StoreCreditContext>;
  /** Indicates the kind of the specific WalletAction */
  type?: Maybe<WixRiseV1WalletActionWalletActionType>;
  /** Represents the time this WalletAction was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Details about the execution of the ending of the wallet action (due to expiration, disabling, etc), such as transaction ID and execution date. Set when the WalletAction is ended (i.e. when the amount is deducted from the account). */
  walletActionEnded?: Maybe<WixRiseV1WalletActionWalletActionExecutionDetails>;
  /** Details about the WalletAction's execution, such as transaction ID and execution date. Set when the WalletAction is executed (e.g., when the amount is added to the account). */
  walletActionStarted?: Maybe<WixRiseV1WalletActionWalletActionExecutionDetails>;
  /** ID of the wallet to which the WalletAction belongs. */
  walletId?: Maybe<Scalars['String']>;
};

export type WixRiseV1WalletActionEmailParams = {
  __typename?: 'WixRiseV1WalletActionEmailParams';
  /** ID of the email template to be used for the WalletAction, if default template is to be overridden. */
  overrideTemplateId?: Maybe<Scalars['String']>;
  /** Indicates whether to skip email dispatch for the WalletAction. The default is false. */
  skipEmailDispatch?: Maybe<Scalars['Boolean']>;
};

export type WixRiseV1WalletActionEmailParamsInput = {
  /** ID of the email template to be used for the WalletAction, if default template is to be overridden. */
  overrideTemplateId?: InputMaybe<Scalars['String']>;
  /** Indicates whether to skip email dispatch for the WalletAction. The default is false. */
  skipEmailDispatch?: InputMaybe<Scalars['Boolean']>;
};

export type WixRiseV1WalletActionEndOptions = {
  __typename?: 'WixRiseV1WalletActionEndOptions';
  /** Indicates whether the wallet action end is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** Reason the wallet action is ending. */
  reason?: Maybe<WixRiseV1WalletActionEndOptionsWalletActionEndReason>;
  /** ID of the transaction being reversed. */
  transaction?: Maybe<WixRiseV1Transaction>;
  /** ID of the transaction being reversed. */
  transactionId?: Maybe<Scalars['String']>;
  /** ID of the wallet action being ended. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
  /** ID of the wallet action being ended. */
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1WalletActionEndOptionsInput = {
  /** Indicates whether the wallet action end is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** Reason the wallet action is ending. */
  reason?: InputMaybe<WixRiseV1WalletActionEndOptionsWalletActionEndReason>;
  /** ID of the transaction being reversed. */
  transactionId?: InputMaybe<Scalars['String']>;
  /** ID of the wallet action being ended. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export enum WixRiseV1WalletActionEndOptionsWalletActionEndReason {
  Cancel = 'CANCEL',
  Expiration = 'EXPIRATION',
  UnknownReason = 'UNKNOWN_REASON'
}

export type WixRiseV1WalletActionInput = {
  /** The amount to be added to the Wallet. */
  amount?: InputMaybe<Scalars['String']>;
  /** Represents the time this WalletAction was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Represents the time at which the WalletAction was manually disabled, if applicable. */
  disableDate?: InputMaybe<Scalars['String']>;
  /** Represents the time at which the unused balance of the WalletAction will be deducted from the account. Defaults to never. */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** Information about the external event that triggered the WalletAction, such as type of event and a short description or identifier of the event. */
  externalEvent?: InputMaybe<WixRiseV1ExternalEventInput>;
  /** WalletAction ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Unique key to identify the WalletAction, used to prevent duplicate WalletActions from being created in case of retries or network issues. The key should be unique for each WalletAction and should not be reused. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Indicates whether the WalletAction is a liability. The default is false. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** Free text comment regarding the WalletAction context */
  note?: InputMaybe<Scalars['String']>;
  /** Settings of the notifications related to the WalletAction. This field is used to specify whether to skip email dispatch or override the template ID for email notifications. */
  notifications?: InputMaybe<WixRiseV1WalletActionNotificationsInput>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. For an update operation to succeed, you MUST pass the latest revision. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Information about the initiator of the WalletAction, such as the app or user that initiated the action. Set when the WalletAction is created. */
  source?: InputMaybe<WixRiseV1ActionInitiatorInput>;
  /** Represents the time at which the WalletAction's amount will be added to the account. Defaults to immediately. */
  startDate?: InputMaybe<Scalars['String']>;
  /** The current status of the WalletAction. Set to PENDING when the WalletAction is created and updated to ACTIVE when the amount is added to the wallet. */
  status?: InputMaybe<WixRiseV1WalletActionWalletActionStatus>;
  /** Detailed information about the context of a store credit, such as the issuer type and sales channel. */
  storeCreditContext?: InputMaybe<WixRiseV1StoreCreditContextInput>;
  /** Indicates the kind of the specific WalletAction */
  type?: InputMaybe<WixRiseV1WalletActionWalletActionType>;
  /** Represents the time this WalletAction was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Details about the execution of the ending of the wallet action (due to expiration, disabling, etc), such as transaction ID and execution date. Set when the WalletAction is ended (i.e. when the amount is deducted from the account). */
  walletActionEnded?: InputMaybe<WixRiseV1WalletActionWalletActionExecutionDetailsInput>;
  /** Details about the WalletAction's execution, such as transaction ID and execution date. Set when the WalletAction is executed (e.g., when the amount is added to the account). */
  walletActionStarted?: InputMaybe<WixRiseV1WalletActionWalletActionExecutionDetailsInput>;
  /** ID of the wallet to which the WalletAction belongs. */
  walletId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1WalletActionNotifications = {
  __typename?: 'WixRiseV1WalletActionNotifications';
  /** Settings for email notifications related to the WalletAction. This field is used to specify whether to skip email dispatch or override the template ID for email notifications. */
  emailParams?: Maybe<WixRiseV1WalletActionEmailParams>;
};

export type WixRiseV1WalletActionNotificationsInput = {
  /** Settings for email notifications related to the WalletAction. This field is used to specify whether to skip email dispatch or override the template ID for email notifications. */
  emailParams?: InputMaybe<WixRiseV1WalletActionEmailParamsInput>;
};

export type WixRiseV1WalletActionStartOptions = {
  __typename?: 'WixRiseV1WalletActionStartOptions';
  /** Detailed information about the context of a store credit, such as the issuer type and sales channel. */
  context?: Maybe<WixRiseV1StoreCreditContext>;
  /** Indicates whether the wallet action is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** ID of the wallet action. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
  /** ID of the wallet action. */
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1WalletActionStartOptionsInput = {
  /** Detailed information about the context of a store credit, such as the issuer type and sales channel. */
  context?: InputMaybe<WixRiseV1StoreCreditContextInput>;
  /** Indicates whether the wallet action is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** ID of the wallet action. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export enum WixRiseV1WalletActionWalletActionContextContextType {
  UnknownContext = 'UNKNOWN_CONTEXT',
  Workflow = 'WORKFLOW'
}

export type WixRiseV1WalletActionWalletActionContextWorkflowPayload = {
  __typename?: 'WixRiseV1WalletActionWalletActionContextWorkflowPayload';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type WixRiseV1WalletActionWalletActionContextWorkflowPayloadInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1WalletActionWalletActionExecutionDetails = {
  __typename?: 'WixRiseV1WalletActionWalletActionExecutionDetails';
  /** Represents the time at which the WalletAction was executed. */
  executionDate?: Maybe<Scalars['String']>;
  /** ID of the Gift Card Transaction created by the WalletAction. */
  transactionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1WalletActionWalletActionExecutionDetailsInput = {
  /** Represents the time at which the WalletAction was executed. */
  executionDate?: InputMaybe<Scalars['String']>;
  /** ID of the Gift Card Transaction created by the WalletAction. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export enum WixRiseV1WalletActionWalletActionSourceSourceType {
  App = 'APP',
  UnknownSource = 'UNKNOWN_SOURCE',
  User = 'USER'
}

export enum WixRiseV1WalletActionWalletActionStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum WixRiseV1WalletActionWalletActionType {
  Refund = 'REFUND',
  Reward = 'REWARD',
  Unknown = 'UNKNOWN'
}

export type WixRiseV1WalletActionWithBalance = {
  __typename?: 'WixRiseV1WalletActionWithBalance';
  /** Remaining balance of the WalletAction. */
  balance?: Maybe<Scalars['String']>;
  /** WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1WalletQueryInput = {
  /** CustomerReference source (i.e. source channel, tenant, and customer IDs). */
  customerReferenceSource?: InputMaybe<WixRiseV1SourceInput>;
  /** Email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Wallet ID. */
  walletId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1WorkflowOptions = {
  __typename?: 'WixRiseV1WorkflowOptions';
  /** ID of the workflow that issued the gift card. */
  workflowId?: Maybe<Scalars['String']>;
};

export type WixRiseV1WorkflowOptionsInput = {
  /** ID of the workflow that issued the gift card. */
  workflowId?: InputMaybe<Scalars['String']>;
};

export type WixRiseWalletActionV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixRiseWalletActionV1UpstreamWixCommonCursors = {
  __typename?: 'WixRiseWalletActionV1UpstreamWixCommonCursors';
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixRiseWalletActionV1UpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2 = {
  __typename?: 'WixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2';
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<WixRiseWalletActionV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set. */
  total?: Maybe<Scalars['Int']>;
};

export enum WixRiseWalletActionV1UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixRiseWalletActionV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonSortOrder>;
};

export type WixRiseWalletActionV1UpstreamWixQueryQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixRiseWalletActionV1UpstreamWixCommonSortingInput>>>;
};

export type WixRiseWorkflowV1Action = {
  __typename?: 'WixRiseWorkflowV1Action';
  conditionOptions?: Maybe<WixRiseWorkflowV1ConditionOptions>;
  fieldsReferences?: Maybe<WixRiseWorkflowV1FieldValueMapper>;
  id?: Maybe<Scalars['String']>;
  /** Issue store credit */
  issueStoreCreditOptions?: Maybe<WixRiseWorkflowV1IssueStoreCreditOptions>;
  type?: Maybe<WixRiseWorkflowV1ActionActionType>;
};

export enum WixRiseWorkflowV1ActionActionType {
  Condition = 'CONDITION',
  IssueStoreCredit = 'ISSUE_STORE_CREDIT',
  UnknownActionType = 'UNKNOWN_ACTION_TYPE'
}

export type WixRiseWorkflowV1ActionInput = {
  conditionOptions?: InputMaybe<WixRiseWorkflowV1ConditionOptionsInput>;
  fieldsReferences?: InputMaybe<WixRiseWorkflowV1FieldValueMapperInput>;
  id?: InputMaybe<Scalars['String']>;
  /** Issue store credit */
  issueStoreCreditOptions?: InputMaybe<WixRiseWorkflowV1IssueStoreCreditOptionsInput>;
  type?: InputMaybe<WixRiseWorkflowV1ActionActionType>;
};

export type WixRiseWorkflowV1ConditionOptions = {
  __typename?: 'WixRiseWorkflowV1ConditionOptions';
  actions?: Maybe<Array<Maybe<WixRiseWorkflowV1Action>>>;
  conditions?: Maybe<Array<Maybe<WixRiseWorkflowV1LogicalCondition>>>;
  operator?: Maybe<WixRiseWorkflowV1ConditionOptionsCompoundOperator>;
};

export enum WixRiseWorkflowV1ConditionOptionsCompoundOperator {
  And = 'AND',
  Or = 'OR',
  UnknownCompoundOperatorType = 'UNKNOWN_COMPOUND_OPERATOR_TYPE'
}

export type WixRiseWorkflowV1ConditionOptionsInput = {
  actions?: InputMaybe<Array<InputMaybe<WixRiseWorkflowV1ActionInput>>>;
  conditions?: InputMaybe<Array<InputMaybe<WixRiseWorkflowV1LogicalConditionInput>>>;
  operator?: InputMaybe<WixRiseWorkflowV1ConditionOptionsCompoundOperator>;
};

export type WixRiseWorkflowV1CreateWorkflowRequestInput = {
  /** Workflow to be created. */
  workflow?: InputMaybe<WixRiseWorkflowV1WorkflowInput>;
};

export type WixRiseWorkflowV1CreateWorkflowResponse = {
  __typename?: 'WixRiseWorkflowV1CreateWorkflowResponse';
  /** The created Workflow. */
  workflow?: Maybe<WixRiseWorkflowV1Workflow>;
};

export type WixRiseWorkflowV1CustomerReferenceInput = {
  /** Email */
  email?: InputMaybe<Scalars['String']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Internal id */
  id?: InputMaybe<Scalars['String']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone */
  phone?: InputMaybe<Scalars['String']>;
  /** Source channel, i.e. Shopify */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** Customer ID in Source */
  sourceCustomerId?: InputMaybe<Scalars['String']>;
  /** Tenant ID in Source, i.e. shop ID */
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export type WixRiseWorkflowV1DeleteWorkflowRequestInput = {
  revision?: InputMaybe<Scalars['Long']>;
  /** Id of the Workflow to delete. */
  workflowId?: InputMaybe<Scalars['String']>;
};

export type WixRiseWorkflowV1FieldValueMapper = {
  __typename?: 'WixRiseWorkflowV1FieldValueMapper';
  type?: Maybe<WixRiseWorkflowV1FieldValueMapperMappingType>;
  value?: Maybe<Scalars['String']>;
};

export type WixRiseWorkflowV1FieldValueMapperInput = {
  type?: InputMaybe<WixRiseWorkflowV1FieldValueMapperMappingType>;
  value?: InputMaybe<Scalars['String']>;
};

export enum WixRiseWorkflowV1FieldValueMapperMappingType {
  Fixed = 'FIXED',
  Path = 'PATH',
  UnknownMappingType = 'UNKNOWN_MAPPING_TYPE'
}

export type WixRiseWorkflowV1GetWorkflowRequestInput = {
  id: Scalars['ID'];
};

export type WixRiseWorkflowV1IssueStoreCreditOptions = {
  __typename?: 'WixRiseWorkflowV1IssueStoreCreditOptions';
  settings?: Maybe<WixRiseWorkflowV1IssueStoreCreditSettings>;
};

export type WixRiseWorkflowV1IssueStoreCreditOptionsInput = {
  settings?: InputMaybe<WixRiseWorkflowV1IssueStoreCreditSettingsInput>;
};

export type WixRiseWorkflowV1IssueStoreCreditSettings = {
  __typename?: 'WixRiseWorkflowV1IssueStoreCreditSettings';
  amount?: Maybe<Scalars['String']>;
  type?: Maybe<WixRiseWorkflowV1IssueStoreCreditSettingsType>;
};

export type WixRiseWorkflowV1IssueStoreCreditSettingsInput = {
  amount?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<WixRiseWorkflowV1IssueStoreCreditSettingsType>;
};

export enum WixRiseWorkflowV1IssueStoreCreditSettingsType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE',
  UnknownType = 'UNKNOWN_TYPE'
}

export type WixRiseWorkflowV1ListTriggersResponse = {
  __typename?: 'WixRiseWorkflowV1ListTriggersResponse';
  /** The created Workflow. */
  triggers?: Maybe<Array<Maybe<WixRiseWorkflowV1Trigger>>>;
};

export type WixRiseWorkflowV1LogicalCondition = {
  __typename?: 'WixRiseWorkflowV1LogicalCondition';
  /** i.e: orderTotal */
  fieldReference?: Maybe<Scalars['String']>;
  operator?: Maybe<WixRiseWorkflowV1LogicalConditionLogicalOperator>;
  /** i.e: 100 (USD) */
  value?: Maybe<Scalars['String']>;
};

export type WixRiseWorkflowV1LogicalConditionInput = {
  /** i.e: orderTotal */
  fieldReference?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<WixRiseWorkflowV1LogicalConditionLogicalOperator>;
  /** i.e: 100 (USD) */
  value?: InputMaybe<Scalars['String']>;
};

export enum WixRiseWorkflowV1LogicalConditionLogicalOperator {
  Eq = 'EQ',
  NumberEq = 'NUMBER_EQ',
  NumberGt = 'NUMBER_GT',
  NumberGte = 'NUMBER_GTE',
  NumberLt = 'NUMBER_LT',
  NumberLte = 'NUMBER_LTE',
  UnknownLogicalOperatorType = 'UNKNOWN_LOGICAL_OPERATOR_TYPE'
}

export type WixRiseWorkflowV1OrderPaidOptionsInput = {
  payload?: InputMaybe<WixRiseWorkflowV1OrderPaidPayloadInput>;
};

export type WixRiseWorkflowV1OrderPaidPayloadInput = {
  currency?: InputMaybe<Scalars['String']>;
  customerReference?: InputMaybe<WixRiseWorkflowV1CustomerReferenceInput>;
  orderId?: InputMaybe<Scalars['String']>;
  orderTotal?: InputMaybe<Scalars['String']>;
};

export type WixRiseWorkflowV1QueryWorkflowsRequestInput = {
  /** WQL expression. */
  query?: InputMaybe<WixRiseWorkflowV1UpstreamWixQueryCursorQueryInput>;
};

export type WixRiseWorkflowV1QueryWorkflowsResponse = {
  __typename?: 'WixRiseWorkflowV1QueryWorkflowsResponse';
  /** Query results */
  items?: Maybe<Array<Maybe<WixRiseWorkflowV1Workflow>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRiseWorkflowV1ReportTriggerRequestInput = {
  orderPaidOptions?: InputMaybe<WixRiseWorkflowV1OrderPaidOptionsInput>;
  type?: InputMaybe<WixRiseWorkflowV1ReportTriggerRequestTriggerType>;
};

export enum WixRiseWorkflowV1ReportTriggerRequestTriggerType {
  OrderPaid = 'ORDER_PAID',
  Unknown = 'UNKNOWN'
}

export type WixRiseWorkflowV1Trigger = {
  __typename?: 'WixRiseWorkflowV1Trigger';
  /** Id of the trigger */
  id?: Maybe<Scalars['String']>;
  /** Friendly name of the trigger */
  name?: Maybe<Scalars['String']>;
};

export type WixRiseWorkflowV1UpdateWorkflowRequestInput = {
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Workflow to be updated, may be partial. */
  workflow?: InputMaybe<WixRiseWorkflowV1WorkflowInput>;
};

export type WixRiseWorkflowV1UpdateWorkflowResponse = {
  __typename?: 'WixRiseWorkflowV1UpdateWorkflowResponse';
  /** Updated Workflow. */
  workflow?: Maybe<WixRiseWorkflowV1Workflow>;
};

export type WixRiseWorkflowV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export enum WixRiseWorkflowV1UpstreamWixCommonSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type WixRiseWorkflowV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixRiseWorkflowV1UpstreamWixCommonSortOrder>;
};

export type WixRiseWorkflowV1UpstreamWixQueryCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRiseWorkflowV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixRiseWorkflowV1UpstreamWixCommonSortingInput>>>;
};

export type WixRiseWorkflowV1Workflow = {
  __typename?: 'WixRiseWorkflowV1Workflow';
  /** List of all the actions that will be executed in this workflow. */
  actions?: Maybe<Array<Maybe<WixRiseWorkflowV1Action>>>;
  /** Date and time the Workflow was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Description of the workflow */
  description?: Maybe<Scalars['String']>;
  esbConfigurationId?: Maybe<Scalars['String']>;
  /** Workflow ID. */
  id?: Maybe<Scalars['String']>;
  /** Name of the workflow */
  name?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['Long']>;
  /** Status of the workflow */
  status?: Maybe<WixRiseWorkflowV1WorkflowStatus>;
  /** The initial trigger that starts the workflow */
  triggerId?: Maybe<Scalars['String']>;
  /** Date and time the Workflow was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixRiseWorkflowV1WorkflowInput = {
  /** List of all the actions that will be executed in this workflow. */
  actions?: InputMaybe<Array<InputMaybe<WixRiseWorkflowV1ActionInput>>>;
  /** Date and time the Workflow was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Description of the workflow */
  description?: InputMaybe<Scalars['String']>;
  esbConfigurationId?: InputMaybe<Scalars['String']>;
  /** Workflow ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Name of the workflow */
  name?: InputMaybe<Scalars['String']>;
  revision?: InputMaybe<Scalars['Long']>;
  /** Status of the workflow */
  status?: InputMaybe<WixRiseWorkflowV1WorkflowStatus>;
  /** The initial trigger that starts the workflow */
  triggerId?: InputMaybe<Scalars['String']>;
  /** Date and time the Workflow was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixRiseWorkflowV1WorkflowStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  UnknownStatus = 'UNKNOWN_STATUS'
}

export type WixSearchV1SearchIndexingNotificationInput = {
  /** type of the document the notification is targeted for. Applies to all types if not provided */
  documentType?: InputMaybe<Scalars['String']>;
  /** new state of indexing for the site specified in ms_id */
  indexState?: InputMaybe<WixSearchV1SearchIndexingNotificationState>;
  /** languaInternalDocumentUpdateByFilterOperationge the notification is targeted for. Applies to all languages if not provided */
  language?: InputMaybe<Scalars['String']>;
  /** site for which notification is targeted */
  msId?: InputMaybe<Scalars['String']>;
};

export enum WixSearchV1SearchIndexingNotificationState {
  /** metasite does not require site search indexing */
  Off = 'Off',
  /** metasite requires site search indexing */
  On = 'On',
  /** default state */
  Unknown = 'Unknown'
}

export type WixSubscriptionsApiV1AppliedCouponInput = {
  /** Coupon code */
  code?: InputMaybe<Scalars['String']>;
  /** Coupon ID */
  couponId?: InputMaybe<Scalars['String']>;
  /** Coupon name */
  name?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1BillingInfoInput = {
  /** Order ID from payment gateway (e.g., Wix Payments) */
  paymentGatewayOrderId?: InputMaybe<Scalars['String']>;
  /** Transaction ID from payment gateway (e.g., Wix Payments) */
  paymentGatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Payment method used for this order */
  paymentMethod?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1BuyerInfoInput = {
  /** Wix customer ID */
  id?: InputMaybe<Scalars['String']>;
  /** Customer type */
  identityType?: InputMaybe<WixSubscriptionsApiV1IdentityType>;
  visitorId?: InputMaybe<Scalars['String']>;
};

export enum WixSubscriptionsApiV1ChannelInfoChannelType {
  OtherPlatform = 'OTHER_PLATFORM',
  Unspecified = 'UNSPECIFIED',
  Web = 'WEB',
  WixAppStore = 'WIX_APP_STORE'
}

export type WixSubscriptionsApiV1ChannelInfoInput = {
  /** Sales channel that submitted the subscription */
  type?: InputMaybe<WixSubscriptionsApiV1ChannelInfoChannelType>;
};

export type WixSubscriptionsApiV1ChargeDetailsInput = {
  /** Discount applied for this line item */
  discount?: InputMaybe<Scalars['Float']>;
  /** price of line item (depends on subscription option) */
  price?: InputMaybe<Scalars['Float']>;
  /** Tax applied for this line item */
  tax?: InputMaybe<Scalars['Float']>;
  /** Is tax applied for this line item */
  taxIncludedInPrice?: InputMaybe<Scalars['Boolean']>;
  /** Tax rate %, as a decimal point >= 0 */
  taxRate?: InputMaybe<Scalars['String']>;
  /** Total price charged to the customer (for this line items) after computation of quantity and discount */
  totalPrice?: InputMaybe<Scalars['Float']>;
};

export type WixSubscriptionsApiV1CustomFieldInput = {
  /** Title for the custom field */
  title?: InputMaybe<Scalars['String']>;
  /** The title translated according to the buyer language */
  translatedTitle?: InputMaybe<Scalars['String']>;
  /** Free text that the customer entered in the custom field during the checkout process */
  value?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1CustomTextFieldSelectionInput = {
  /** Custom text field name */
  title?: InputMaybe<Scalars['String']>;
  /** Custom text field value */
  value?: InputMaybe<Scalars['String']>;
};

export enum WixSubscriptionsApiV1IdentityType {
  /** Contact */
  Contact = 'CONTACT',
  /** Site member */
  Member = 'MEMBER',
  UnspecifiedIdentityType = 'UNSPECIFIED_IDENTITY_TYPE'
}

export type WixSubscriptionsApiV1LineItemInput = {
  /** Charges details */
  chargeDetails?: InputMaybe<WixSubscriptionsApiV1ChargeDetailsInput>;
  /** Line item custom text field selections */
  customTextFields?: InputMaybe<Array<InputMaybe<WixSubscriptionsApiV1CustomTextFieldSelectionInput>>>;
  /** Line item ID (auto-generated) */
  index?: InputMaybe<Scalars['Int']>;
  /** Line item options ordered */
  options?: InputMaybe<Array<InputMaybe<WixSubscriptionsApiV1OptionSelectionInput>>>;
  /** Product details */
  productDetails?: InputMaybe<WixSubscriptionsApiV1ProductDetailsInput>;
  /** Line item quantity */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Line item variantId (from Stores Catalog) */
  variantId?: InputMaybe<Scalars['String']>;
};

export enum WixSubscriptionsApiV1LineItemType {
  /** Custom item price */
  CustomAmountItem = 'CUSTOM_AMOUNT_ITEM',
  /** Digital item type */
  Digital = 'DIGITAL',
  /** Physical item type */
  Physical = 'PHYSICAL',
  /** Line item type can't be classified, due to an error */
  UnspecifiedLineItemType = 'UNSPECIFIED_LINE_ITEM_TYPE'
}

export type WixSubscriptionsApiV1MediaItemInput = {
  /** Alternative text for presentation when media cannot be displayed */
  altText?: InputMaybe<Scalars['String']>;
  /** Media external URL */
  externalImageUrl?: InputMaybe<Scalars['String']>;
  /** Media item height */
  height?: InputMaybe<Scalars['Int']>;
  /** Media ID (for media items previously saved in Wix Media) */
  id?: InputMaybe<Scalars['String']>;
  /** Media type */
  mediaType?: InputMaybe<WixSubscriptionsApiV1MediaItemType>;
  /** Media URL */
  url?: InputMaybe<Scalars['String']>;
  /** Media item width */
  width?: InputMaybe<Scalars['Int']>;
};

export enum WixSubscriptionsApiV1MediaItemType {
  /** Image item type */
  Image = 'IMAGE',
  /** Media item type can't be classified, due to an error */
  UnspecifiedMediaTypeItem = 'UNSPECIFIED_MEDIA_TYPE_ITEM'
}

export type WixSubscriptionsApiV1OptionSelectionInput = {
  /** Option name */
  option?: InputMaybe<Scalars['String']>;
  /** Selected choice for this option */
  selection?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1PickupAddressInput = {
  /** Address */
  addressLine?: InputMaybe<Scalars['String']>;
  /** City */
  city?: InputMaybe<Scalars['String']>;
  /** Country code (2 letters) */
  country?: InputMaybe<Scalars['String']>;
  /** State/District */
  subdivision?: InputMaybe<Scalars['String']>;
  /** ZIP/postal code */
  zipCode?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1PickupDetailsInput = {
  /** Pickup address */
  address?: InputMaybe<WixSubscriptionsApiV1PickupAddressInput>;
  /** Store owner's pickup instructions */
  pickupInstructions?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1ProductDetailsInput = {
  /** App id from the catalog reference */
  appId?: InputMaybe<Scalars['String']>;
  /** Line item fulfillerId from stores fulfillers. No value means self fulfilled */
  fulfillerId?: InputMaybe<Scalars['String']>;
  /** Line item type (may be extended) */
  lineItemType?: InputMaybe<WixSubscriptionsApiV1LineItemType>;
  /** Line item primary media for preview */
  mediaItem?: InputMaybe<WixSubscriptionsApiV1MediaItemInput>;
  /** Line item name */
  name?: InputMaybe<Scalars['String']>;
  /** Line item notes */
  notes?: InputMaybe<Scalars['String']>;
  /** Line item product ID (optional for POS orders) */
  productId?: InputMaybe<Scalars['String']>;
  /** Line item SKU */
  sku?: InputMaybe<Scalars['String']>;
  /** Tax group id */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /** Line item name translated to buyer's language */
  translatedName?: InputMaybe<Scalars['String']>;
  /** Line item weight */
  weight?: InputMaybe<Scalars['Float']>;
};

export type WixSubscriptionsApiV1ShipmentDetailsInput = {
  /** Shipping destination address */
  address?: InputMaybe<ComWixEcommerceCommonsApiAddressInput>;
  /** Discount applied for shipping */
  discount?: InputMaybe<Scalars['Float']>;
  /** Tax applied for shipping */
  tax?: InputMaybe<Scalars['Float']>;
  /** Whether tax is included in the price */
  taxIncludedInPrice?: InputMaybe<Scalars['Boolean']>;
  /** Tax rate % for shipping, as a decimal point >= 0 */
  taxRate?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1ShippingInfoInput = {
  /** Delivery option name */
  deliveryOption?: InputMaybe<Scalars['String']>;
  /** Delivery option delivery time */
  estimatedDeliveryTime?: InputMaybe<Scalars['String']>;
  /** Pickup details (when this object describes pickup) */
  pickupDetails?: InputMaybe<WixSubscriptionsApiV1PickupDetailsInput>;
  /** Shipment details (when this object describes shipment) */
  shipmentDetails?: InputMaybe<WixSubscriptionsApiV1ShipmentDetailsInput>;
};

export type WixSubscriptionsApiV1StoreSettingsInput = {
  /**
   * The language to be used when communicating with the buyer
   * For a site that support multiple languages, this would be the language the buyer selected
   * Otherwise this would be the site language
   */
  buyerLanguage?: InputMaybe<Scalars['String']>;
  /** Currency used for pricing in this store */
  currency?: InputMaybe<Scalars['String']>;
  /** Weight unit used in this store */
  weightUnit?: InputMaybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};

export type WixSubscriptionsApiV1SubscriptionCreatedInput = {
  subscription?: InputMaybe<WixSubscriptionsApiV1SubscriptionInput>;
};

export type WixSubscriptionsApiV1SubscriptionInput = {
  /** Coupon that was applied to subscription */
  appliedCoupon?: InputMaybe<WixSubscriptionsApiV1AppliedCouponInput>;
  /** Full billing address */
  billingAddress?: InputMaybe<ComWixEcommerceCommonsApiAddressInput>;
  /** information about first subscription payment */
  billingInfo?: InputMaybe<WixSubscriptionsApiV1BillingInfoInput>;
  /** member or contact */
  buyerInfo?: InputMaybe<WixSubscriptionsApiV1BuyerInfoInput>;
  /** Message from the customer (e.g., customization request) */
  buyerNote?: InputMaybe<Scalars['String']>;
  /** The id of the cart this order was created from */
  cartId?: InputMaybe<Scalars['String']>;
  /** Sales channel that submitted this subscription */
  channelInfo?: InputMaybe<WixSubscriptionsApiV1ChannelInfoInput>;
  /** The id of the checkout this subscriptions was created from */
  checkoutId?: InputMaybe<Scalars['String']>;
  /** Custom field */
  customField?: InputMaybe<WixSubscriptionsApiV1CustomFieldInput>;
  /** Subscription creation date */
  dateCreated?: InputMaybe<Scalars['String']>;
  /** id of subscription in external system */
  externalId?: InputMaybe<Scalars['String']>;
  /** Subscription id (auto-generated upon subscription creation) */
  id?: InputMaybe<Scalars['String']>;
  /** Line items ordered */
  lineItems?: InputMaybe<Array<InputMaybe<WixSubscriptionsApiV1LineItemInput>>>;
  /** Delivery information */
  shippingInfo?: InputMaybe<WixSubscriptionsApiV1ShippingInfoInput>;
  /** site settings at the moment when subscription created */
  storeSettings?: InputMaybe<WixSubscriptionsApiV1StoreSettingsInput>;
  /** Information about subscription option from which subscription was created */
  subscriptionOptionInfo?: InputMaybe<WixSubscriptionsApiV1SubscriptionOptionInfoInput>;
  /** defines when subscriber will be charged: for frequency=MONTH, billingCycles=6, interval=2 payment will be done every 2 month during one year */
  subscriptionSettings?: InputMaybe<WixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput>;
  /** Totals for subscription's line items */
  totals?: InputMaybe<WixSubscriptionsApiV1TotalsInput>;
};

export type WixSubscriptionsApiV1SubscriptionOptionInfoInput = {
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<WixEcommerceSubscriptionOptionApiV1DiscountInput>;
  id?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1TotalsInput = {
  /** Total calculated discount value */
  discount?: InputMaybe<Scalars['Float']>;
  /** Total line items quantity */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Total shipping price, including tax */
  shipping?: InputMaybe<Scalars['Float']>;
  /** Total shipping price, after tax (identical to shipping) */
  shippingAfterTax?: InputMaybe<Scalars['Float']>;
  /** Total shipping price, before tax */
  shippingBeforeTax?: InputMaybe<Scalars['Float']>;
  /** Subtotal of all line items, before tax */
  subtotal?: InputMaybe<Scalars['Float']>;
  /** Total tax */
  tax?: InputMaybe<Scalars['Float']>;
  /** Total price */
  total?: InputMaybe<Scalars['Float']>;
  /** Total weight */
  weight?: InputMaybe<Scalars['Float']>;
};

export type QueryEventsQueryVariables = Exact<{
  input?: InputMaybe<WixCalendarEventsV3QueryEventsRequestInput>;
}>;


export type QueryEventsQuery = { __typename?: 'Query', wixCalendarEventsV3Events?: { __typename?: 'WixCalendarEventsV3QueryEventsResponse', items?: Array<{ __typename?: 'WixCalendarEventsV3Event', scheduleId?: string | null, recurrenceRule?: { __typename?: 'WixCalendarEventsV3RecurrenceRule', days?: Array<WixCalendarEventsV3RecurrenceRuleDay | null> | null } | null } | null> | null } | null };


export const QueryEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"queryEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WixCalendarEventsV3QueryEventsRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wixCalendarEventsV3Events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queryInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleId"}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QueryEventsQuery, QueryEventsQueryVariables>;

type PickedFields = Map<string, PickedFields | undefined>;

type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

type Head<T extends string> = T extends `${infer First}.${string}` ? First : T;

type Tail<T extends string> = T extends `${string}.${infer Rest}`
  ? Rest
  : never;

type RestOf<T extends Record<string, string>> = {
  [P in keyof T as `${Tail<string & P>}`]: T[P];
};

export type OptionalArrayElementType<T> = T extends (infer U)[]
  ? NonNullable<U>
  : never;

type DeepPick<T, K extends string> = T extends object
  ? {
      [P in Head<K> & keyof T]?: T[P] extends
        | readonly unknown[]
        | null
        | undefined
        ? DeepPick<
            OptionalArrayElementType<T[P]>,
            Tail<Extract<K, `${P}.${string}`>>
          >[]
        : DeepPick<T[P], Tail<Extract<K, `${P}.${string}`>>>;
    }
  : T;

type DeepMapKeys<T, Mappings extends Record<string, string>> = T extends object
  ? {
      [P in keyof T as P extends keyof Mappings
        ? Mappings[P]
        : P]?: T[P] extends readonly unknown[] | null | undefined
        ? DeepMapKeys<OptionalArrayElementType<T[P]>, RestOf<Mappings>>[]
        : DeepMapKeys<T[P], RestOf<Mappings>>;
    }
  : T;

export type PropertyType<T, Path extends keyof any> = Path extends `${infer First}.${infer Rest}`
  ? First extends keyof T
    ? PropertyType<T[First], Rest>
    : never
  : Path extends keyof T
  ? T[Path]
  : never;

export const aComWixBookingsCalendarApiV2QuerySessionsRequestInput = <T extends Partial<ComWixBookingsCalendarApiV2QuerySessionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fromDate')) {
        result.fromDate = overrides && overrides.hasOwnProperty('fromDate') ? overrides.fromDate! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('includeExternal')) {
        result.includeExternal = overrides && overrides.hasOwnProperty('includeExternal') ? overrides.includeExternal! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('instances')) {
        result.instances = overrides && overrides.hasOwnProperty('instances') ? overrides.instances! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixBookingsCalendarApiV2UpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aComWixBookingsCalendarApiV2UpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }
    if (pickedFields.size === 0 || pickedFields.has('toDate')) {
        result.toDate = overrides && overrides.hasOwnProperty('toDate') ? overrides.toDate! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixBookingsCalendarApiV2QuerySessionsRequestSessionTypeFilter.All;
    }

    return result;
};

export const aComWixBookingsCalendarApiV2QuerySessionsResponse = <T extends Partial<ComWixBookingsCalendarApiV2QuerySessionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixBookingsSchedulesApiV1Session(x ?? {}, pickedFields.get('items'))) : [aComWixBookingsSchedulesApiV1Session({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixBookingsCalendarApiV2UpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixBookingsCalendarApiV2UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 8411;
    }

    return result;
};

export const aComWixBookingsCalendarApiV2UpstreamWixCommonQueryV2Input = <T extends Partial<ComWixBookingsCalendarApiV2UpstreamWixCommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixBookingsCalendarApiV2UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixBookingsCalendarApiV2UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['ratione'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'adipisci';
    }

    return result;
};

export const aComWixBookingsCommonApiV1Location = <T extends Partial<ComWixBookingsCommonApiV1Location>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? overrides.address! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocation')) {
        result.businessLocation = overrides && overrides.hasOwnProperty('businessLocation') ? aComWixpressLocationsLocation(overrides.businessLocation ?? {}, pickedFields.get('businessLocation')) : aComWixpressLocationsLocation({}, pickedFields.get('businessLocation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customAddress')) {
        result.customAddress = overrides && overrides.hasOwnProperty('customAddress') ? aComWixBookingsUpstreamWixCommonAddress(overrides.customAddress ?? {}, pickedFields.get('customAddress')) : aComWixBookingsUpstreamWixCommonAddress({}, pickedFields.get('customAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('locationType')) {
        result.locationType = overrides && overrides.hasOwnProperty('locationType') ? overrides.locationType! : ComWixBookingsCommonApiV1LocationLocationType.Custom;
    }

    return result;
};

export const aComWixBookingsCommonApiV1LocationInput = <T extends Partial<ComWixBookingsCommonApiV1LocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? overrides.address! : 'hic';
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocation')) {
        result.businessLocation = overrides && overrides.hasOwnProperty('businessLocation') ? aComWixpressLocationsLocationInput(overrides.businessLocation ?? {}, pickedFields.get('businessLocation')) : aComWixpressLocationsLocationInput({}, pickedFields.get('businessLocation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customAddress')) {
        result.customAddress = overrides && overrides.hasOwnProperty('customAddress') ? aComWixBookingsUpstreamWixCommonAddressInput(overrides.customAddress ?? {}, pickedFields.get('customAddress')) : aComWixBookingsUpstreamWixCommonAddressInput({}, pickedFields.get('customAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('locationType')) {
        result.locationType = overrides && overrides.hasOwnProperty('locationType') ? overrides.locationType! : ComWixBookingsCommonApiV1LocationLocationType.Custom;
    }

    return result;
};

export const aComWixBookingsCommonApiV1Price = <T extends Partial<ComWixBookingsCommonApiV1Price>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('downPayAmount')) {
        result.downPayAmount = overrides && overrides.hasOwnProperty('downPayAmount') ? overrides.downPayAmount! : 'modi';
    }

    return result;
};

export const aComWixBookingsCommonApiV1PriceInput = <T extends Partial<ComWixBookingsCommonApiV1PriceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('downPayAmount')) {
        result.downPayAmount = overrides && overrides.hasOwnProperty('downPayAmount') ? overrides.downPayAmount! : 'rem';
    }

    return result;
};

export const aComWixBookingsCommonApiV1QueryMetaData = <T extends Partial<ComWixBookingsCommonApiV1QueryMetaData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items! : 8905;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 4483;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalCount')) {
        result.totalCount = overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 8135;
    }

    return result;
};

export const aComWixBookingsCommonApiV1Rate = <T extends Partial<ComWixBookingsCommonApiV1Rate>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('defaultVariedPrice')) {
        result.defaultVariedPrice = overrides && overrides.hasOwnProperty('defaultVariedPrice') ? aComWixBookingsCommonApiV1Price(overrides.defaultVariedPrice ?? {}, pickedFields.get('defaultVariedPrice')) : aComWixBookingsCommonApiV1Price({}, pickedFields.get('defaultVariedPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('labeledPriceOptions')) {
        result.labeledPriceOptions = overrides && overrides.hasOwnProperty('labeledPriceOptions') ? aComWixBookingsCommonApiV1Price(overrides.labeledPriceOptions ?? {}, pickedFields.get('labeledPriceOptions')) : aComWixBookingsCommonApiV1Price({}, pickedFields.get('labeledPriceOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceText')) {
        result.priceText = overrides && overrides.hasOwnProperty('priceText') ? overrides.priceText! : 'est';
    }

    return result;
};

export const aComWixBookingsCommonApiV1RateInput = <T extends Partial<ComWixBookingsCommonApiV1RateInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('defaultVariedPrice')) {
        result.defaultVariedPrice = overrides && overrides.hasOwnProperty('defaultVariedPrice') ? aComWixBookingsCommonApiV1PriceInput(overrides.defaultVariedPrice ?? {}, pickedFields.get('defaultVariedPrice')) : aComWixBookingsCommonApiV1PriceInput({}, pickedFields.get('defaultVariedPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('labeledPriceOptions')) {
        result.labeledPriceOptions = overrides && overrides.hasOwnProperty('labeledPriceOptions') ? aComWixBookingsCommonApiV1PriceInput(overrides.labeledPriceOptions ?? {}, pickedFields.get('labeledPriceOptions')) : aComWixBookingsCommonApiV1PriceInput({}, pickedFields.get('labeledPriceOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceText')) {
        result.priceText = overrides && overrides.hasOwnProperty('priceText') ? overrides.priceText! : 'nihil';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1Availability = <T extends Partial<ComWixBookingsSchedulesApiV1Availability>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('constraints')) {
        result.constraints = overrides && overrides.hasOwnProperty('constraints') ? aComWixBookingsSchedulesApiV1AvailabilityConstraints(overrides.constraints ?? {}, pickedFields.get('constraints')) : aComWixBookingsSchedulesApiV1AvailabilityConstraints({}, pickedFields.get('constraints'));
    }
    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? overrides.end! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('linkedSchedules')) {
        result.linkedSchedules = overrides && overrides.hasOwnProperty('linkedSchedules') ? overrides.linkedSchedules!.map((x) => aComWixBookingsSchedulesApiV1LinkedSchedule(x ?? {}, pickedFields.get('linkedSchedules'))) : [aComWixBookingsSchedulesApiV1LinkedSchedule({}, pickedFields.get('linkedSchedules'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aComWixBookingsCommonApiV1Location(x ?? {}, pickedFields.get('locations'))) : [aComWixBookingsCommonApiV1Location({}, pickedFields.get('locations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? overrides.start! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('useDefaultLocation')) {
        result.useDefaultLocation = overrides && overrides.hasOwnProperty('useDefaultLocation') ? overrides.useDefaultLocation! : false;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1AvailabilityConstraints = <T extends Partial<ComWixBookingsSchedulesApiV1AvailabilityConstraints>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('slotDurations')) {
        result.slotDurations = overrides && overrides.hasOwnProperty('slotDurations') ? overrides.slotDurations! : [699];
    }
    if (pickedFields.size === 0 || pickedFields.has('slotsSplitInterval')) {
        result.slotsSplitInterval = overrides && overrides.hasOwnProperty('slotsSplitInterval') ? aComWixBookingsSchedulesApiV1SplitInterval(overrides.slotsSplitInterval ?? {}, pickedFields.get('slotsSplitInterval')) : aComWixBookingsSchedulesApiV1SplitInterval({}, pickedFields.get('slotsSplitInterval'));
    }
    if (pickedFields.size === 0 || pickedFields.has('splitInterval')) {
        result.splitInterval = overrides && overrides.hasOwnProperty('splitInterval') ? overrides.splitInterval! : 7046;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeBetweenSlots')) {
        result.timeBetweenSlots = overrides && overrides.hasOwnProperty('timeBetweenSlots') ? overrides.timeBetweenSlots! : 1121;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1AvailabilityConstraintsInput = <T extends Partial<ComWixBookingsSchedulesApiV1AvailabilityConstraintsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('slotDurations')) {
        result.slotDurations = overrides && overrides.hasOwnProperty('slotDurations') ? overrides.slotDurations! : [7250];
    }
    if (pickedFields.size === 0 || pickedFields.has('slotsSplitInterval')) {
        result.slotsSplitInterval = overrides && overrides.hasOwnProperty('slotsSplitInterval') ? aComWixBookingsSchedulesApiV1SplitIntervalInput(overrides.slotsSplitInterval ?? {}, pickedFields.get('slotsSplitInterval')) : aComWixBookingsSchedulesApiV1SplitIntervalInput({}, pickedFields.get('slotsSplitInterval'));
    }
    if (pickedFields.size === 0 || pickedFields.has('splitInterval')) {
        result.splitInterval = overrides && overrides.hasOwnProperty('splitInterval') ? overrides.splitInterval! : 679;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeBetweenSlots')) {
        result.timeBetweenSlots = overrides && overrides.hasOwnProperty('timeBetweenSlots') ? overrides.timeBetweenSlots! : 3981;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1AvailabilityInput = <T extends Partial<ComWixBookingsSchedulesApiV1AvailabilityInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('constraints')) {
        result.constraints = overrides && overrides.hasOwnProperty('constraints') ? aComWixBookingsSchedulesApiV1AvailabilityConstraintsInput(overrides.constraints ?? {}, pickedFields.get('constraints')) : aComWixBookingsSchedulesApiV1AvailabilityConstraintsInput({}, pickedFields.get('constraints'));
    }
    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? overrides.end! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('linkedSchedules')) {
        result.linkedSchedules = overrides && overrides.hasOwnProperty('linkedSchedules') ? overrides.linkedSchedules!.map((x) => aComWixBookingsSchedulesApiV1LinkedScheduleInput({}, pickedFields.get('linkedSchedules'))) : [aComWixBookingsSchedulesApiV1LinkedScheduleInput({}, pickedFields.get('linkedSchedules'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aComWixBookingsCommonApiV1LocationInput({}, pickedFields.get('locations'))) : [aComWixBookingsCommonApiV1LocationInput({}, pickedFields.get('locations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? overrides.start! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('useDefaultLocation')) {
        result.useDefaultLocation = overrides && overrides.hasOwnProperty('useDefaultLocation') ? overrides.useDefaultLocation! : false;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1AvailabilityPolicyInput = <T extends Partial<ComWixBookingsSchedulesApiV1AvailabilityPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('splitInterval')) {
        result.splitInterval = overrides && overrides.hasOwnProperty('splitInterval') ? aComWixBookingsSchedulesApiV1SplitIntervalInput(overrides.splitInterval ?? {}, pickedFields.get('splitInterval')) : aComWixBookingsSchedulesApiV1SplitIntervalInput({}, pickedFields.get('splitInterval'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1AvailabilityPolicyUpdatedInput = <T extends Partial<ComWixBookingsSchedulesApiV1AvailabilityPolicyUpdatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availabilityPolicy')) {
        result.availabilityPolicy = overrides && overrides.hasOwnProperty('availabilityPolicy') ? aComWixBookingsSchedulesApiV1AvailabilityPolicyInput(overrides.availabilityPolicy ?? {}, pickedFields.get('availabilityPolicy')) : aComWixBookingsSchedulesApiV1AvailabilityPolicyInput({}, pickedFields.get('availabilityPolicy'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1BatchRequestInput = <T extends Partial<ComWixBookingsSchedulesApiV1BatchRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cancelRequests')) {
        result.cancelRequests = overrides && overrides.hasOwnProperty('cancelRequests') ? overrides.cancelRequests!.map((x) => aComWixBookingsSchedulesApiV1CancelScheduleRequestInput({}, pickedFields.get('cancelRequests'))) : [aComWixBookingsSchedulesApiV1CancelScheduleRequestInput({}, pickedFields.get('cancelRequests'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('createRequests')) {
        result.createRequests = overrides && overrides.hasOwnProperty('createRequests') ? overrides.createRequests!.map((x) => aComWixBookingsSchedulesApiV1CreateScheduleRequestInput({}, pickedFields.get('createRequests'))) : [aComWixBookingsSchedulesApiV1CreateScheduleRequestInput({}, pickedFields.get('createRequests'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('updateRequests')) {
        result.updateRequests = overrides && overrides.hasOwnProperty('updateRequests') ? overrides.updateRequests!.map((x) => aComWixBookingsSchedulesApiV1UpdateScheduleRequestInput({}, pickedFields.get('updateRequests'))) : [aComWixBookingsSchedulesApiV1UpdateScheduleRequestInput({}, pickedFields.get('updateRequests'))];
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1BatchResponse = <T extends Partial<ComWixBookingsSchedulesApiV1BatchResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cancelled')) {
        result.cancelled = overrides && overrides.hasOwnProperty('cancelled') ? overrides.cancelled!.map((x) => aComWixBookingsSchedulesApiV1Schedule(x ?? {}, pickedFields.get('cancelled'))) : [aComWixBookingsSchedulesApiV1Schedule({}, pickedFields.get('cancelled'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('created')) {
        result.created = overrides && overrides.hasOwnProperty('created') ? overrides.created!.map((x) => aComWixBookingsSchedulesApiV1Schedule(x ?? {}, pickedFields.get('created'))) : [aComWixBookingsSchedulesApiV1Schedule({}, pickedFields.get('created'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('updated')) {
        result.updated = overrides && overrides.hasOwnProperty('updated') ? overrides.updated!.map((x) => aComWixBookingsSchedulesApiV1Schedule(x ?? {}, pickedFields.get('updated'))) : [aComWixBookingsSchedulesApiV1Schedule({}, pickedFields.get('updated'))];
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1CalendarConference = <T extends Partial<ComWixBookingsSchedulesApiV1CalendarConference>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accountOwnerId')) {
        result.accountOwnerId = overrides && overrides.hasOwnProperty('accountOwnerId') ? overrides.accountOwnerId! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('conferenceId')) {
        result.conferenceId = overrides && overrides.hasOwnProperty('conferenceId') ? overrides.conferenceId! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('conferenceType')) {
        result.conferenceType = overrides && overrides.hasOwnProperty('conferenceType') ? overrides.conferenceType! : ComWixBookingsSchedulesApiV1CalendarConferenceConferenceType.Custom;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('guestUrl')) {
        result.guestUrl = overrides && overrides.hasOwnProperty('guestUrl') ? overrides.guestUrl! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('hostUrl')) {
        result.hostUrl = overrides && overrides.hasOwnProperty('hostUrl') ? overrides.hostUrl! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('password')) {
        result.password = overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerId')) {
        result.providerId = overrides && overrides.hasOwnProperty('providerId') ? overrides.providerId! : 'quas';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1CalendarConferenceInput = <T extends Partial<ComWixBookingsSchedulesApiV1CalendarConferenceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accountOwnerId')) {
        result.accountOwnerId = overrides && overrides.hasOwnProperty('accountOwnerId') ? overrides.accountOwnerId! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('conferenceId')) {
        result.conferenceId = overrides && overrides.hasOwnProperty('conferenceId') ? overrides.conferenceId! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('conferenceType')) {
        result.conferenceType = overrides && overrides.hasOwnProperty('conferenceType') ? overrides.conferenceType! : ComWixBookingsSchedulesApiV1CalendarConferenceConferenceType.Custom;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('guestUrl')) {
        result.guestUrl = overrides && overrides.hasOwnProperty('guestUrl') ? overrides.guestUrl! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('hostUrl')) {
        result.hostUrl = overrides && overrides.hasOwnProperty('hostUrl') ? overrides.hostUrl! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('password')) {
        result.password = overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerId')) {
        result.providerId = overrides && overrides.hasOwnProperty('providerId') ? overrides.providerId! : 'exercitationem';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1CalendarDateTime = <T extends Partial<ComWixBookingsSchedulesApiV1CalendarDateTime>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('localDateTime')) {
        result.localDateTime = overrides && overrides.hasOwnProperty('localDateTime') ? aComWixBookingsSchedulesApiV1LocalDateTime(overrides.localDateTime ?? {}, pickedFields.get('localDateTime')) : aComWixBookingsSchedulesApiV1LocalDateTime({}, pickedFields.get('localDateTime'));
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('timestamp')) {
        result.timestamp = overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : 'dolor';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1CalendarDateTimeInput = <T extends Partial<ComWixBookingsSchedulesApiV1CalendarDateTimeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('localDateTime')) {
        result.localDateTime = overrides && overrides.hasOwnProperty('localDateTime') ? aComWixBookingsSchedulesApiV1LocalDateTimeInput(overrides.localDateTime ?? {}, pickedFields.get('localDateTime')) : aComWixBookingsSchedulesApiV1LocalDateTimeInput({}, pickedFields.get('localDateTime'));
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('timestamp')) {
        result.timestamp = overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : 'saepe';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1CancelScheduleRequestInput = <T extends Partial<ComWixBookingsSchedulesApiV1CancelScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('notifyParticipants')) {
        result.notifyParticipants = overrides && overrides.hasOwnProperty('notifyParticipants') ? overrides.notifyParticipants! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aComWixBookingsSchedulesApiV1ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aComWixBookingsSchedulesApiV1ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('preserveFutureSessionsWithParticipants')) {
        result.preserveFutureSessionsWithParticipants = overrides && overrides.hasOwnProperty('preserveFutureSessionsWithParticipants') ? overrides.preserveFutureSessionsWithParticipants! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'quod';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ConferenceProvider = <T extends Partial<ComWixBookingsSchedulesApiV1ConferenceProvider>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('providerId')) {
        result.providerId = overrides && overrides.hasOwnProperty('providerId') ? overrides.providerId! : 'veritatis';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ConferenceProviderInput = <T extends Partial<ComWixBookingsSchedulesApiV1ConferenceProviderInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('providerId')) {
        result.providerId = overrides && overrides.hasOwnProperty('providerId') ? overrides.providerId! : 'ab';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1CreateScheduleRequestInput = <T extends Partial<ComWixBookingsSchedulesApiV1CreateScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('idempotencyKey')) {
        result.idempotencyKey = overrides && overrides.hasOwnProperty('idempotencyKey') ? overrides.idempotencyKey! : 'nisi';
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aComWixBookingsSchedulesApiV1ScheduleInput(overrides.schedule ?? {}, pickedFields.get('schedule')) : aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ExternalCalendarInfo = <T extends Partial<ComWixBookingsSchedulesApiV1ExternalCalendarInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('calendarType')) {
        result.calendarType = overrides && overrides.hasOwnProperty('calendarType') ? overrides.calendarType! : ComWixBookingsExternalcalendarSpiV1CalendarTypeEnumCalendarType.Google;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ExternalCalendarInfoInput = <T extends Partial<ComWixBookingsSchedulesApiV1ExternalCalendarInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('calendarType')) {
        result.calendarType = overrides && overrides.hasOwnProperty('calendarType') ? overrides.calendarType! : ComWixBookingsExternalcalendarSpiV1CalendarTypeEnumCalendarType.Google;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ExternalCalendarOverrides = <T extends Partial<ComWixBookingsSchedulesApiV1ExternalCalendarOverrides>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'aut';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput = <T extends Partial<ComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'deleniti';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1Frequency = <T extends Partial<ComWixBookingsSchedulesApiV1Frequency>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('repetition')) {
        result.repetition = overrides && overrides.hasOwnProperty('repetition') ? overrides.repetition! : 2717;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1FrequencyInput = <T extends Partial<ComWixBookingsSchedulesApiV1FrequencyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('repetition')) {
        result.repetition = overrides && overrides.hasOwnProperty('repetition') ? overrides.repetition! : 7161;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1GetSessionRequestInput = <T extends Partial<ComWixBookingsSchedulesApiV1GetSessionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['qui'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '804834db-b33a-4916-a2af-9bfcab44ff35';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1Interval = <T extends Partial<ComWixBookingsSchedulesApiV1Interval>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('daysOfWeek')) {
        result.daysOfWeek = overrides && overrides.hasOwnProperty('daysOfWeek') ? overrides.daysOfWeek! : ComWixBookingsSchedulesApiV1IntervalDay.Fri;
    }
    if (pickedFields.size === 0 || pickedFields.has('duration')) {
        result.duration = overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 4729;
    }
    if (pickedFields.size === 0 || pickedFields.has('hourOfDay')) {
        result.hourOfDay = overrides && overrides.hasOwnProperty('hourOfDay') ? overrides.hourOfDay! : 8545;
    }
    if (pickedFields.size === 0 || pickedFields.has('minuteOfHour')) {
        result.minuteOfHour = overrides && overrides.hasOwnProperty('minuteOfHour') ? overrides.minuteOfHour! : 3009;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1IntervalInput = <T extends Partial<ComWixBookingsSchedulesApiV1IntervalInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('daysOfWeek')) {
        result.daysOfWeek = overrides && overrides.hasOwnProperty('daysOfWeek') ? overrides.daysOfWeek! : ComWixBookingsSchedulesApiV1IntervalDay.Fri;
    }
    if (pickedFields.size === 0 || pickedFields.has('duration')) {
        result.duration = overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 9212;
    }
    if (pickedFields.size === 0 || pickedFields.has('hourOfDay')) {
        result.hourOfDay = overrides && overrides.hasOwnProperty('hourOfDay') ? overrides.hourOfDay! : 7905;
    }
    if (pickedFields.size === 0 || pickedFields.has('minuteOfHour')) {
        result.minuteOfHour = overrides && overrides.hasOwnProperty('minuteOfHour') ? overrides.minuteOfHour! : 5082;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1IntervalSplitInput = <T extends Partial<ComWixBookingsSchedulesApiV1IntervalSplitInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('intervals')) {
        result.intervals = overrides && overrides.hasOwnProperty('intervals') ? overrides.intervals!.map((x) => aComWixBookingsSchedulesApiV1RecurringIntervalInput({}, pickedFields.get('intervals'))) : [aComWixBookingsSchedulesApiV1RecurringIntervalInput({}, pickedFields.get('intervals'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('newScheduleVersion')) {
        result.newScheduleVersion = overrides && overrides.hasOwnProperty('newScheduleVersion') ? overrides.newScheduleVersion! : 4397;
    }
    if (pickedFields.size === 0 || pickedFields.has('oldScheduleVersion')) {
        result.oldScheduleVersion = overrides && overrides.hasOwnProperty('oldScheduleVersion') ? overrides.oldScheduleVersion! : 731;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'qui';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1LinkedSchedule = <T extends Partial<ComWixBookingsSchedulesApiV1LinkedSchedule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerId')) {
        result.scheduleOwnerId = overrides && overrides.hasOwnProperty('scheduleOwnerId') ? overrides.scheduleOwnerId! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerName')) {
        result.scheduleOwnerName = overrides && overrides.hasOwnProperty('scheduleOwnerName') ? overrides.scheduleOwnerName! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerUserId')) {
        result.scheduleOwnerUserId = overrides && overrides.hasOwnProperty('scheduleOwnerUserId') ? overrides.scheduleOwnerUserId! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('transparency')) {
        result.transparency = overrides && overrides.hasOwnProperty('transparency') ? overrides.transparency! : ComWixBookingsSchedulesApiV1LinkedScheduleTransparency.Busy;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1LinkedScheduleInput = <T extends Partial<ComWixBookingsSchedulesApiV1LinkedScheduleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerId')) {
        result.scheduleOwnerId = overrides && overrides.hasOwnProperty('scheduleOwnerId') ? overrides.scheduleOwnerId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerName')) {
        result.scheduleOwnerName = overrides && overrides.hasOwnProperty('scheduleOwnerName') ? overrides.scheduleOwnerName! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerUserId')) {
        result.scheduleOwnerUserId = overrides && overrides.hasOwnProperty('scheduleOwnerUserId') ? overrides.scheduleOwnerUserId! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('transparency')) {
        result.transparency = overrides && overrides.hasOwnProperty('transparency') ? overrides.transparency! : ComWixBookingsSchedulesApiV1LinkedScheduleTransparency.Busy;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1LocalDateTime = <T extends Partial<ComWixBookingsSchedulesApiV1LocalDateTime>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dayOfMonth')) {
        result.dayOfMonth = overrides && overrides.hasOwnProperty('dayOfMonth') ? overrides.dayOfMonth! : 2016;
    }
    if (pickedFields.size === 0 || pickedFields.has('hourOfDay')) {
        result.hourOfDay = overrides && overrides.hasOwnProperty('hourOfDay') ? overrides.hourOfDay! : 1160;
    }
    if (pickedFields.size === 0 || pickedFields.has('minutesOfHour')) {
        result.minutesOfHour = overrides && overrides.hasOwnProperty('minutesOfHour') ? overrides.minutesOfHour! : 5135;
    }
    if (pickedFields.size === 0 || pickedFields.has('monthOfYear')) {
        result.monthOfYear = overrides && overrides.hasOwnProperty('monthOfYear') ? overrides.monthOfYear! : 8306;
    }
    if (pickedFields.size === 0 || pickedFields.has('year')) {
        result.year = overrides && overrides.hasOwnProperty('year') ? overrides.year! : 7227;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1LocalDateTimeInput = <T extends Partial<ComWixBookingsSchedulesApiV1LocalDateTimeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dayOfMonth')) {
        result.dayOfMonth = overrides && overrides.hasOwnProperty('dayOfMonth') ? overrides.dayOfMonth! : 3097;
    }
    if (pickedFields.size === 0 || pickedFields.has('hourOfDay')) {
        result.hourOfDay = overrides && overrides.hasOwnProperty('hourOfDay') ? overrides.hourOfDay! : 9030;
    }
    if (pickedFields.size === 0 || pickedFields.has('minutesOfHour')) {
        result.minutesOfHour = overrides && overrides.hasOwnProperty('minutesOfHour') ? overrides.minutesOfHour! : 9787;
    }
    if (pickedFields.size === 0 || pickedFields.has('monthOfYear')) {
        result.monthOfYear = overrides && overrides.hasOwnProperty('monthOfYear') ? overrides.monthOfYear! : 9759;
    }
    if (pickedFields.size === 0 || pickedFields.has('year')) {
        result.year = overrides && overrides.hasOwnProperty('year') ? overrides.year! : 6353;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1MigrationDataInput = <T extends Partial<ComWixBookingsSchedulesApiV1MigrationDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessId')) {
        result.businessId = overrides && overrides.hasOwnProperty('businessId') ? overrides.businessId! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('staffs')) {
        result.staffs = overrides && overrides.hasOwnProperty('staffs') ? overrides.staffs!.map((x) => aComWixBookingsSchedulesApiV1MigrationDataStaffDataInput({}, pickedFields.get('staffs'))) : [aComWixBookingsSchedulesApiV1MigrationDataStaffDataInput({}, pickedFields.get('staffs'))];
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1MigrationDataStaffDataInput = <T extends Partial<ComWixBookingsSchedulesApiV1MigrationDataStaffDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('refreshToken')) {
        result.refreshToken = overrides && overrides.hasOwnProperty('refreshToken') ? overrides.refreshToken! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceId')) {
        result.resourceId = overrides && overrides.hasOwnProperty('resourceId') ? overrides.resourceId! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('syncRequestEmail')) {
        result.syncRequestEmail = overrides && overrides.hasOwnProperty('syncRequestEmail') ? overrides.syncRequestEmail! : 'veritatis';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1MigrationEventInput = <T extends Partial<ComWixBookingsSchedulesApiV1MigrationEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('migrationData')) {
        result.migrationData = overrides && overrides.hasOwnProperty('migrationData') ? aComWixBookingsSchedulesApiV1MigrationDataInput(overrides.migrationData ?? {}, pickedFields.get('migrationData')) : aComWixBookingsSchedulesApiV1MigrationDataInput({}, pickedFields.get('migrationData'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1MultipleSessionsCreatedInput = <T extends Partial<ComWixBookingsSchedulesApiV1MultipleSessionsCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('schedulesWithSessions')) {
        result.schedulesWithSessions = overrides && overrides.hasOwnProperty('schedulesWithSessions') ? overrides.schedulesWithSessions!.map((x) => aComWixBookingsSchedulesApiV1ScheduleWithSessionsInput({}, pickedFields.get('schedulesWithSessions'))) : [aComWixBookingsSchedulesApiV1ScheduleWithSessionsInput({}, pickedFields.get('schedulesWithSessions'))];
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1Participant = <T extends Partial<ComWixBookingsSchedulesApiV1Participant>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('approvalStatus')) {
        result.approvalStatus = overrides && overrides.hasOwnProperty('approvalStatus') ? overrides.approvalStatus! : ComWixBookingsSchedulesApiV1ParticipantApprovalStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('inherited')) {
        result.inherited = overrides && overrides.hasOwnProperty('inherited') ? overrides.inherited! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('partySize')) {
        result.partySize = overrides && overrides.hasOwnProperty('partySize') ? overrides.partySize! : 9950;
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'vitae';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ParticipantInput = <T extends Partial<ComWixBookingsSchedulesApiV1ParticipantInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('approvalStatus')) {
        result.approvalStatus = overrides && overrides.hasOwnProperty('approvalStatus') ? overrides.approvalStatus! : ComWixBookingsSchedulesApiV1ParticipantApprovalStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('inherited')) {
        result.inherited = overrides && overrides.hasOwnProperty('inherited') ? overrides.inherited! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('partySize')) {
        result.partySize = overrides && overrides.hasOwnProperty('partySize') ? overrides.partySize! : 3517;
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'voluptatem';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ParticipantNotificationInput = <T extends Partial<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? overrides.metadata! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('notifyParticipants')) {
        result.notifyParticipants = overrides && overrides.hasOwnProperty('notifyParticipants') ? overrides.notifyParticipants! : false;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1RecurringInterval = <T extends Partial<ComWixBookingsSchedulesApiV1RecurringInterval>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('affectedSchedules')) {
        result.affectedSchedules = overrides && overrides.hasOwnProperty('affectedSchedules') ? overrides.affectedSchedules!.map((x) => aComWixBookingsSchedulesApiV1LinkedSchedule(x ?? {}, pickedFields.get('affectedSchedules'))) : [aComWixBookingsSchedulesApiV1LinkedSchedule({}, pickedFields.get('affectedSchedules'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? overrides.end! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? aComWixBookingsSchedulesApiV1Frequency(overrides.frequency ?? {}, pickedFields.get('frequency')) : aComWixBookingsSchedulesApiV1Frequency({}, pickedFields.get('frequency'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? aComWixBookingsSchedulesApiV1Interval(overrides.interval ?? {}, pickedFields.get('interval')) : aComWixBookingsSchedulesApiV1Interval({}, pickedFields.get('interval'));
    }
    if (pickedFields.size === 0 || pickedFields.has('intervalType')) {
        result.intervalType = overrides && overrides.hasOwnProperty('intervalType') ? overrides.intervalType! : ComWixBookingsSchedulesApiV1RecurringIntervalRecurringIntervalType.Availability;
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? overrides.start! : 'sunt';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1RecurringIntervalInput = <T extends Partial<ComWixBookingsSchedulesApiV1RecurringIntervalInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('affectedSchedules')) {
        result.affectedSchedules = overrides && overrides.hasOwnProperty('affectedSchedules') ? overrides.affectedSchedules!.map((x) => aComWixBookingsSchedulesApiV1LinkedScheduleInput({}, pickedFields.get('affectedSchedules'))) : [aComWixBookingsSchedulesApiV1LinkedScheduleInput({}, pickedFields.get('affectedSchedules'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? overrides.end! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? aComWixBookingsSchedulesApiV1FrequencyInput(overrides.frequency ?? {}, pickedFields.get('frequency')) : aComWixBookingsSchedulesApiV1FrequencyInput({}, pickedFields.get('frequency'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? aComWixBookingsSchedulesApiV1IntervalInput(overrides.interval ?? {}, pickedFields.get('interval')) : aComWixBookingsSchedulesApiV1IntervalInput({}, pickedFields.get('interval'));
    }
    if (pickedFields.size === 0 || pickedFields.has('intervalType')) {
        result.intervalType = overrides && overrides.hasOwnProperty('intervalType') ? overrides.intervalType! : ComWixBookingsSchedulesApiV1RecurringIntervalRecurringIntervalType.Availability;
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? overrides.start! : 'esse';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1RecurringSessionSplitInput = <T extends Partial<ComWixBookingsSchedulesApiV1RecurringSessionSplitInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newScheduleVersion')) {
        result.newScheduleVersion = overrides && overrides.hasOwnProperty('newScheduleVersion') ? overrides.newScheduleVersion! : 3995;
    }
    if (pickedFields.size === 0 || pickedFields.has('oldScheduleVersion')) {
        result.oldScheduleVersion = overrides && overrides.hasOwnProperty('oldScheduleVersion') ? overrides.oldScheduleVersion! : 9436;
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringSessions')) {
        result.recurringSessions = overrides && overrides.hasOwnProperty('recurringSessions') ? overrides.recurringSessions!.map((x) => aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('recurringSessions'))) : [aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('recurringSessions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'aliquam';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1RecurringSessionsUpdatedInput = <T extends Partial<ComWixBookingsSchedulesApiV1RecurringSessionsUpdatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newRecurringSessions')) {
        result.newRecurringSessions = overrides && overrides.hasOwnProperty('newRecurringSessions') ? overrides.newRecurringSessions!.map((x) => aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('newRecurringSessions'))) : [aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('newRecurringSessions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('oldRecurringSessions')) {
        result.oldRecurringSessions = overrides && overrides.hasOwnProperty('oldRecurringSessions') ? overrides.oldRecurringSessions!.map((x) => aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('oldRecurringSessions'))) : [aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('oldRecurringSessions'))];
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1Schedule = <T extends Partial<ComWixBookingsSchedulesApiV1Schedule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availability')) {
        result.availability = overrides && overrides.hasOwnProperty('availability') ? aComWixBookingsSchedulesApiV1Availability(overrides.availability ?? {}, pickedFields.get('availability')) : aComWixBookingsSchedulesApiV1Availability({}, pickedFields.get('availability'));
    }
    if (pickedFields.size === 0 || pickedFields.has('calendarConference')) {
        result.calendarConference = overrides && overrides.hasOwnProperty('calendarConference') ? aComWixBookingsSchedulesApiV1CalendarConference(overrides.calendarConference ?? {}, pickedFields.get('calendarConference')) : aComWixBookingsSchedulesApiV1CalendarConference({}, pickedFields.get('calendarConference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('capacity')) {
        result.capacity = overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 392;
    }
    if (pickedFields.size === 0 || pickedFields.has('conferenceProvider')) {
        result.conferenceProvider = overrides && overrides.hasOwnProperty('conferenceProvider') ? aComWixBookingsSchedulesApiV1ConferenceProvider(overrides.conferenceProvider ?? {}, pickedFields.get('conferenceProvider')) : aComWixBookingsSchedulesApiV1ConferenceProvider({}, pickedFields.get('conferenceProvider'));
    }
    if (pickedFields.size === 0 || pickedFields.has('created')) {
        result.created = overrides && overrides.hasOwnProperty('created') ? overrides.created! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalCalendarOverrides')) {
        result.externalCalendarOverrides = overrides && overrides.hasOwnProperty('externalCalendarOverrides') ? aComWixBookingsSchedulesApiV1ExternalCalendarOverrides(overrides.externalCalendarOverrides ?? {}, pickedFields.get('externalCalendarOverrides')) : aComWixBookingsSchedulesApiV1ExternalCalendarOverrides({}, pickedFields.get('externalCalendarOverrides'));
    }
    if (pickedFields.size === 0 || pickedFields.has('firstSessionStart')) {
        result.firstSessionStart = overrides && overrides.hasOwnProperty('firstSessionStart') ? overrides.firstSessionStart! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('inheritedFields')) {
        result.inheritedFields = overrides && overrides.hasOwnProperty('inheritedFields') ? overrides.inheritedFields! : ['amet'];
    }
    if (pickedFields.size === 0 || pickedFields.has('intervals')) {
        result.intervals = overrides && overrides.hasOwnProperty('intervals') ? overrides.intervals!.map((x) => aComWixBookingsSchedulesApiV1RecurringInterval(x ?? {}, pickedFields.get('intervals'))) : [aComWixBookingsSchedulesApiV1RecurringInterval({}, pickedFields.get('intervals'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSessionEnd')) {
        result.lastSessionEnd = overrides && overrides.hasOwnProperty('lastSessionEnd') ? overrides.lastSessionEnd! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixBookingsCommonApiV1Location(overrides.location ?? {}, pickedFields.get('location')) : aComWixBookingsCommonApiV1Location({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participants')) {
        result.participants = overrides && overrides.hasOwnProperty('participants') ? overrides.participants!.map((x) => aComWixBookingsSchedulesApiV1Participant(x ?? {}, pickedFields.get('participants'))) : [aComWixBookingsSchedulesApiV1Participant({}, pickedFields.get('participants'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? aComWixBookingsCommonApiV1Rate(overrides.rate ?? {}, pickedFields.get('rate')) : aComWixBookingsCommonApiV1Rate({}, pickedFields.get('rate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerId')) {
        result.scheduleOwnerId = overrides && overrides.hasOwnProperty('scheduleOwnerId') ? overrides.scheduleOwnerId! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerName')) {
        result.scheduleOwnerName = overrides && overrides.hasOwnProperty('scheduleOwnerName') ? overrides.scheduleOwnerName! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerUserId')) {
        result.scheduleOwnerUserId = overrides && overrides.hasOwnProperty('scheduleOwnerUserId') ? overrides.scheduleOwnerUserId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixBookingsSchedulesApiV1ScheduleScheduleStatus.Cancelled;
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['adipisci'];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'vero';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalNumberOfParticipants')) {
        result.totalNumberOfParticipants = overrides && overrides.hasOwnProperty('totalNumberOfParticipants') ? overrides.totalNumberOfParticipants! : 3417;
    }
    if (pickedFields.size === 0 || pickedFields.has('updated')) {
        result.updated = overrides && overrides.hasOwnProperty('updated') ? overrides.updated! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 3260;
    }
    if (pickedFields.size === 0 || pickedFields.has('versions')) {
        result.versions = overrides && overrides.hasOwnProperty('versions') ? aComWixBookingsSchedulesApiV1ScheduleVersion(overrides.versions ?? {}, pickedFields.get('versions')) : aComWixBookingsSchedulesApiV1ScheduleVersion({}, pickedFields.get('versions'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ScheduleCancelledInput = <T extends Partial<ComWixBookingsSchedulesApiV1ScheduleCancelledInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('oldSchedule')) {
        result.oldSchedule = overrides && overrides.hasOwnProperty('oldSchedule') ? aComWixBookingsSchedulesApiV1ScheduleInput(overrides.oldSchedule ?? {}, pickedFields.get('oldSchedule')) : aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('oldSchedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aComWixBookingsSchedulesApiV1ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aComWixBookingsSchedulesApiV1ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aComWixBookingsSchedulesApiV1ScheduleInput(overrides.schedule ?? {}, pickedFields.get('schedule')) : aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ScheduleCreatedInput = <T extends Partial<ComWixBookingsSchedulesApiV1ScheduleCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aComWixBookingsSchedulesApiV1ScheduleInput(overrides.schedule ?? {}, pickedFields.get('schedule')) : aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ScheduleInput = <T extends Partial<ComWixBookingsSchedulesApiV1ScheduleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availability')) {
        result.availability = overrides && overrides.hasOwnProperty('availability') ? aComWixBookingsSchedulesApiV1AvailabilityInput(overrides.availability ?? {}, pickedFields.get('availability')) : aComWixBookingsSchedulesApiV1AvailabilityInput({}, pickedFields.get('availability'));
    }
    if (pickedFields.size === 0 || pickedFields.has('calendarConference')) {
        result.calendarConference = overrides && overrides.hasOwnProperty('calendarConference') ? aComWixBookingsSchedulesApiV1CalendarConferenceInput(overrides.calendarConference ?? {}, pickedFields.get('calendarConference')) : aComWixBookingsSchedulesApiV1CalendarConferenceInput({}, pickedFields.get('calendarConference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('capacity')) {
        result.capacity = overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 3833;
    }
    if (pickedFields.size === 0 || pickedFields.has('conferenceProvider')) {
        result.conferenceProvider = overrides && overrides.hasOwnProperty('conferenceProvider') ? aComWixBookingsSchedulesApiV1ConferenceProviderInput(overrides.conferenceProvider ?? {}, pickedFields.get('conferenceProvider')) : aComWixBookingsSchedulesApiV1ConferenceProviderInput({}, pickedFields.get('conferenceProvider'));
    }
    if (pickedFields.size === 0 || pickedFields.has('created')) {
        result.created = overrides && overrides.hasOwnProperty('created') ? overrides.created! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalCalendarOverrides')) {
        result.externalCalendarOverrides = overrides && overrides.hasOwnProperty('externalCalendarOverrides') ? aComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput(overrides.externalCalendarOverrides ?? {}, pickedFields.get('externalCalendarOverrides')) : aComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput({}, pickedFields.get('externalCalendarOverrides'));
    }
    if (pickedFields.size === 0 || pickedFields.has('firstSessionStart')) {
        result.firstSessionStart = overrides && overrides.hasOwnProperty('firstSessionStart') ? overrides.firstSessionStart! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('inheritedFields')) {
        result.inheritedFields = overrides && overrides.hasOwnProperty('inheritedFields') ? overrides.inheritedFields! : ['vel'];
    }
    if (pickedFields.size === 0 || pickedFields.has('intervals')) {
        result.intervals = overrides && overrides.hasOwnProperty('intervals') ? overrides.intervals!.map((x) => aComWixBookingsSchedulesApiV1RecurringIntervalInput({}, pickedFields.get('intervals'))) : [aComWixBookingsSchedulesApiV1RecurringIntervalInput({}, pickedFields.get('intervals'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSessionEnd')) {
        result.lastSessionEnd = overrides && overrides.hasOwnProperty('lastSessionEnd') ? overrides.lastSessionEnd! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixBookingsCommonApiV1LocationInput(overrides.location ?? {}, pickedFields.get('location')) : aComWixBookingsCommonApiV1LocationInput({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participants')) {
        result.participants = overrides && overrides.hasOwnProperty('participants') ? overrides.participants!.map((x) => aComWixBookingsSchedulesApiV1ParticipantInput({}, pickedFields.get('participants'))) : [aComWixBookingsSchedulesApiV1ParticipantInput({}, pickedFields.get('participants'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? aComWixBookingsCommonApiV1RateInput(overrides.rate ?? {}, pickedFields.get('rate')) : aComWixBookingsCommonApiV1RateInput({}, pickedFields.get('rate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerId')) {
        result.scheduleOwnerId = overrides && overrides.hasOwnProperty('scheduleOwnerId') ? overrides.scheduleOwnerId! : 'sequi';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerName')) {
        result.scheduleOwnerName = overrides && overrides.hasOwnProperty('scheduleOwnerName') ? overrides.scheduleOwnerName! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerUserId')) {
        result.scheduleOwnerUserId = overrides && overrides.hasOwnProperty('scheduleOwnerUserId') ? overrides.scheduleOwnerUserId! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixBookingsSchedulesApiV1ScheduleScheduleStatus.Cancelled;
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['sit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalNumberOfParticipants')) {
        result.totalNumberOfParticipants = overrides && overrides.hasOwnProperty('totalNumberOfParticipants') ? overrides.totalNumberOfParticipants! : 8018;
    }
    if (pickedFields.size === 0 || pickedFields.has('updated')) {
        result.updated = overrides && overrides.hasOwnProperty('updated') ? overrides.updated! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 2736;
    }
    if (pickedFields.size === 0 || pickedFields.has('versions')) {
        result.versions = overrides && overrides.hasOwnProperty('versions') ? aComWixBookingsSchedulesApiV1ScheduleVersionInput(overrides.versions ?? {}, pickedFields.get('versions')) : aComWixBookingsSchedulesApiV1ScheduleVersionInput({}, pickedFields.get('versions'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ScheduleNotificationInput = <T extends Partial<ComWixBookingsSchedulesApiV1ScheduleNotificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availabilityPolicyUpdated')) {
        result.availabilityPolicyUpdated = overrides && overrides.hasOwnProperty('availabilityPolicyUpdated') ? aComWixBookingsSchedulesApiV1AvailabilityPolicyUpdatedInput(overrides.availabilityPolicyUpdated ?? {}, pickedFields.get('availabilityPolicyUpdated')) : aComWixBookingsSchedulesApiV1AvailabilityPolicyUpdatedInput({}, pickedFields.get('availabilityPolicyUpdated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('intervalSplit')) {
        result.intervalSplit = overrides && overrides.hasOwnProperty('intervalSplit') ? aComWixBookingsSchedulesApiV1IntervalSplitInput(overrides.intervalSplit ?? {}, pickedFields.get('intervalSplit')) : aComWixBookingsSchedulesApiV1IntervalSplitInput({}, pickedFields.get('intervalSplit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('migrationEvent')) {
        result.migrationEvent = overrides && overrides.hasOwnProperty('migrationEvent') ? aComWixBookingsSchedulesApiV1MigrationEventInput(overrides.migrationEvent ?? {}, pickedFields.get('migrationEvent')) : aComWixBookingsSchedulesApiV1MigrationEventInput({}, pickedFields.get('migrationEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('multipleSessionsCreated')) {
        result.multipleSessionsCreated = overrides && overrides.hasOwnProperty('multipleSessionsCreated') ? aComWixBookingsSchedulesApiV1MultipleSessionsCreatedInput(overrides.multipleSessionsCreated ?? {}, pickedFields.get('multipleSessionsCreated')) : aComWixBookingsSchedulesApiV1MultipleSessionsCreatedInput({}, pickedFields.get('multipleSessionsCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('notifyParticipants')) {
        result.notifyParticipants = overrides && overrides.hasOwnProperty('notifyParticipants') ? overrides.notifyParticipants! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('preserveFutureSessionsWithParticipants')) {
        result.preserveFutureSessionsWithParticipants = overrides && overrides.hasOwnProperty('preserveFutureSessionsWithParticipants') ? overrides.preserveFutureSessionsWithParticipants! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringSessionSplit')) {
        result.recurringSessionSplit = overrides && overrides.hasOwnProperty('recurringSessionSplit') ? aComWixBookingsSchedulesApiV1RecurringSessionSplitInput(overrides.recurringSessionSplit ?? {}, pickedFields.get('recurringSessionSplit')) : aComWixBookingsSchedulesApiV1RecurringSessionSplitInput({}, pickedFields.get('recurringSessionSplit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rolledOut')) {
        result.rolledOut = overrides && overrides.hasOwnProperty('rolledOut') ? overrides.rolledOut! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleCancelled')) {
        result.scheduleCancelled = overrides && overrides.hasOwnProperty('scheduleCancelled') ? aComWixBookingsSchedulesApiV1ScheduleCancelledInput(overrides.scheduleCancelled ?? {}, pickedFields.get('scheduleCancelled')) : aComWixBookingsSchedulesApiV1ScheduleCancelledInput({}, pickedFields.get('scheduleCancelled'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleCreated')) {
        result.scheduleCreated = overrides && overrides.hasOwnProperty('scheduleCreated') ? aComWixBookingsSchedulesApiV1ScheduleCreatedInput(overrides.scheduleCreated ?? {}, pickedFields.get('scheduleCreated')) : aComWixBookingsSchedulesApiV1ScheduleCreatedInput({}, pickedFields.get('scheduleCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleUnassignedFromUser')) {
        result.scheduleUnassignedFromUser = overrides && overrides.hasOwnProperty('scheduleUnassignedFromUser') ? aComWixBookingsSchedulesApiV1ScheduleUnassignedFromUserInput(overrides.scheduleUnassignedFromUser ?? {}, pickedFields.get('scheduleUnassignedFromUser')) : aComWixBookingsSchedulesApiV1ScheduleUnassignedFromUserInput({}, pickedFields.get('scheduleUnassignedFromUser'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleUpdated')) {
        result.scheduleUpdated = overrides && overrides.hasOwnProperty('scheduleUpdated') ? aComWixBookingsSchedulesApiV1ScheduleUpdatedInput(overrides.scheduleUpdated ?? {}, pickedFields.get('scheduleUpdated')) : aComWixBookingsSchedulesApiV1ScheduleUpdatedInput({}, pickedFields.get('scheduleUpdated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionCancelled')) {
        result.sessionCancelled = overrides && overrides.hasOwnProperty('sessionCancelled') ? aComWixBookingsSchedulesApiV1SessionCancelledInput(overrides.sessionCancelled ?? {}, pickedFields.get('sessionCancelled')) : aComWixBookingsSchedulesApiV1SessionCancelledInput({}, pickedFields.get('sessionCancelled'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionCreated')) {
        result.sessionCreated = overrides && overrides.hasOwnProperty('sessionCreated') ? aComWixBookingsSchedulesApiV1SessionCreatedInput(overrides.sessionCreated ?? {}, pickedFields.get('sessionCreated')) : aComWixBookingsSchedulesApiV1SessionCreatedInput({}, pickedFields.get('sessionCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionUpdated')) {
        result.sessionUpdated = overrides && overrides.hasOwnProperty('sessionUpdated') ? aComWixBookingsSchedulesApiV1SessionUpdatedInput(overrides.sessionUpdated ?? {}, pickedFields.get('sessionUpdated')) : aComWixBookingsSchedulesApiV1SessionUpdatedInput({}, pickedFields.get('sessionUpdated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteProperties')) {
        result.siteProperties = overrides && overrides.hasOwnProperty('siteProperties') ? aComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput(overrides.siteProperties ?? {}, pickedFields.get('siteProperties')) : aComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput({}, pickedFields.get('siteProperties'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ScheduleUnassignedFromUserInput = <T extends Partial<ComWixBookingsSchedulesApiV1ScheduleUnassignedFromUserInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aComWixBookingsSchedulesApiV1ScheduleInput(overrides.schedule ?? {}, pickedFields.get('schedule')) : aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('schedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'sit';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ScheduleUpdatedInput = <T extends Partial<ComWixBookingsSchedulesApiV1ScheduleUpdatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newSchedule')) {
        result.newSchedule = overrides && overrides.hasOwnProperty('newSchedule') ? aComWixBookingsSchedulesApiV1ScheduleInput(overrides.newSchedule ?? {}, pickedFields.get('newSchedule')) : aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('newSchedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('oldSchedule')) {
        result.oldSchedule = overrides && overrides.hasOwnProperty('oldSchedule') ? aComWixBookingsSchedulesApiV1ScheduleInput(overrides.oldSchedule ?? {}, pickedFields.get('oldSchedule')) : aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('oldSchedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aComWixBookingsSchedulesApiV1ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aComWixBookingsSchedulesApiV1ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringSessions')) {
        result.recurringSessions = overrides && overrides.hasOwnProperty('recurringSessions') ? aComWixBookingsSchedulesApiV1RecurringSessionsUpdatedInput(overrides.recurringSessions ?? {}, pickedFields.get('recurringSessions')) : aComWixBookingsSchedulesApiV1RecurringSessionsUpdatedInput({}, pickedFields.get('recurringSessions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('triggeredByAnonymizeRequest')) {
        result.triggeredByAnonymizeRequest = overrides && overrides.hasOwnProperty('triggeredByAnonymizeRequest') ? overrides.triggeredByAnonymizeRequest! : true;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ScheduleVersion = <T extends Partial<ComWixBookingsSchedulesApiV1ScheduleVersion>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantsVersion')) {
        result.participantsVersion = overrides && overrides.hasOwnProperty('participantsVersion') ? overrides.participantsVersion! : 2467;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleVersion')) {
        result.scheduleVersion = overrides && overrides.hasOwnProperty('scheduleVersion') ? overrides.scheduleVersion! : 7704;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ScheduleVersionInput = <T extends Partial<ComWixBookingsSchedulesApiV1ScheduleVersionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantsVersion')) {
        result.participantsVersion = overrides && overrides.hasOwnProperty('participantsVersion') ? overrides.participantsVersion! : 3319;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleVersion')) {
        result.scheduleVersion = overrides && overrides.hasOwnProperty('scheduleVersion') ? overrides.scheduleVersion! : 5496;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1ScheduleWithSessionsInput = <T extends Partial<ComWixBookingsSchedulesApiV1ScheduleWithSessionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aComWixBookingsSchedulesApiV1ScheduleInput(overrides.schedule ?? {}, pickedFields.get('schedule')) : aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('schedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessions')) {
        result.sessions = overrides && overrides.hasOwnProperty('sessions') ? overrides.sessions!.map((x) => aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('sessions'))) : [aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('sessions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('siteProperties')) {
        result.siteProperties = overrides && overrides.hasOwnProperty('siteProperties') ? aComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput(overrides.siteProperties ?? {}, pickedFields.get('siteProperties')) : aComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput({}, pickedFields.get('siteProperties'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1Session = <T extends Partial<ComWixBookingsSchedulesApiV1Session>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('affectedSchedules')) {
        result.affectedSchedules = overrides && overrides.hasOwnProperty('affectedSchedules') ? overrides.affectedSchedules!.map((x) => aComWixBookingsSchedulesApiV1LinkedSchedule(x ?? {}, pickedFields.get('affectedSchedules'))) : [aComWixBookingsSchedulesApiV1LinkedSchedule({}, pickedFields.get('affectedSchedules'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('calendarConference')) {
        result.calendarConference = overrides && overrides.hasOwnProperty('calendarConference') ? aComWixBookingsSchedulesApiV1CalendarConference(overrides.calendarConference ?? {}, pickedFields.get('calendarConference')) : aComWixBookingsSchedulesApiV1CalendarConference({}, pickedFields.get('calendarConference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('capacity')) {
        result.capacity = overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 9;
    }
    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? aComWixBookingsSchedulesApiV1CalendarDateTime(overrides.end ?? {}, pickedFields.get('end')) : aComWixBookingsSchedulesApiV1CalendarDateTime({}, pickedFields.get('end'));
    }
    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixCalendarEventsV3Event(overrides.event ?? {}, pickedFields.get('event')) : aWixCalendarEventsV3Event({}, pickedFields.get('event'));
    }
    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalCalendarInfo')) {
        result.externalCalendarInfo = overrides && overrides.hasOwnProperty('externalCalendarInfo') ? aComWixBookingsSchedulesApiV1ExternalCalendarInfo(overrides.externalCalendarInfo ?? {}, pickedFields.get('externalCalendarInfo')) : aComWixBookingsSchedulesApiV1ExternalCalendarInfo({}, pickedFields.get('externalCalendarInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalCalendarOverrides')) {
        result.externalCalendarOverrides = overrides && overrides.hasOwnProperty('externalCalendarOverrides') ? aComWixBookingsSchedulesApiV1ExternalCalendarOverrides(overrides.externalCalendarOverrides ?? {}, pickedFields.get('externalCalendarOverrides')) : aComWixBookingsSchedulesApiV1ExternalCalendarOverrides({}, pickedFields.get('externalCalendarOverrides'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('inheritedFields')) {
        result.inheritedFields = overrides && overrides.hasOwnProperty('inheritedFields') ? overrides.inheritedFields! : ['aspernatur'];
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceOfRecurrence')) {
        result.instanceOfRecurrence = overrides && overrides.hasOwnProperty('instanceOfRecurrence') ? overrides.instanceOfRecurrence! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixBookingsCommonApiV1Location(overrides.location ?? {}, pickedFields.get('location')) : aComWixBookingsCommonApiV1Location({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('notes')) {
        result.notes = overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalStart')) {
        result.originalStart = overrides && overrides.hasOwnProperty('originalStart') ? overrides.originalStart! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('participants')) {
        result.participants = overrides && overrides.hasOwnProperty('participants') ? overrides.participants!.map((x) => aComWixBookingsSchedulesApiV1Participant(x ?? {}, pickedFields.get('participants'))) : [aComWixBookingsSchedulesApiV1Participant({}, pickedFields.get('participants'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? aComWixBookingsCommonApiV1Rate(overrides.rate ?? {}, pickedFields.get('rate')) : aComWixBookingsCommonApiV1Rate({}, pickedFields.get('rate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('recurrence')) {
        result.recurrence = overrides && overrides.hasOwnProperty('recurrence') ? overrides.recurrence! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringIntervalId')) {
        result.recurringIntervalId = overrides && overrides.hasOwnProperty('recurringIntervalId') ? overrides.recurringIntervalId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringSessionId')) {
        result.recurringSessionId = overrides && overrides.hasOwnProperty('recurringSessionId') ? overrides.recurringSessionId! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('remainingCapacity')) {
        result.remainingCapacity = overrides && overrides.hasOwnProperty('remainingCapacity') ? overrides.remainingCapacity! : 6553;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerId')) {
        result.scheduleOwnerId = overrides && overrides.hasOwnProperty('scheduleOwnerId') ? overrides.scheduleOwnerId! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerName')) {
        result.scheduleOwnerName = overrides && overrides.hasOwnProperty('scheduleOwnerName') ? overrides.scheduleOwnerName! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerUserId')) {
        result.scheduleOwnerUserId = overrides && overrides.hasOwnProperty('scheduleOwnerUserId') ? overrides.scheduleOwnerUserId! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? aComWixBookingsSchedulesApiV1CalendarDateTime(overrides.start ?? {}, pickedFields.get('start')) : aComWixBookingsSchedulesApiV1CalendarDateTime({}, pickedFields.get('start'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixBookingsSchedulesApiV1SessionStatus.Cancelled;
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['voluptatem'];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeReservedAfter')) {
        result.timeReservedAfter = overrides && overrides.hasOwnProperty('timeReservedAfter') ? overrides.timeReservedAfter! : 5073;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalNumberOfParticipants')) {
        result.totalNumberOfParticipants = overrides && overrides.hasOwnProperty('totalNumberOfParticipants') ? overrides.totalNumberOfParticipants! : 940;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixBookingsSchedulesApiV1SessionType.Availability;
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? aComWixBookingsSchedulesApiV1SessionVersion(overrides.version ?? {}, pickedFields.get('version')) : aComWixBookingsSchedulesApiV1SessionVersion({}, pickedFields.get('version'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1SessionCancelledInput = <T extends Partial<ComWixBookingsSchedulesApiV1SessionCancelledInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aComWixBookingsSchedulesApiV1ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aComWixBookingsSchedulesApiV1ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('session')) {
        result.session = overrides && overrides.hasOwnProperty('session') ? aComWixBookingsSchedulesApiV1SessionInput(overrides.session ?? {}, pickedFields.get('session')) : aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('session'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1SessionCreatedInput = <T extends Partial<ComWixBookingsSchedulesApiV1SessionCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('session')) {
        result.session = overrides && overrides.hasOwnProperty('session') ? aComWixBookingsSchedulesApiV1SessionInput(overrides.session ?? {}, pickedFields.get('session')) : aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('session'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1SessionInput = <T extends Partial<ComWixBookingsSchedulesApiV1SessionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('affectedSchedules')) {
        result.affectedSchedules = overrides && overrides.hasOwnProperty('affectedSchedules') ? overrides.affectedSchedules!.map((x) => aComWixBookingsSchedulesApiV1LinkedScheduleInput({}, pickedFields.get('affectedSchedules'))) : [aComWixBookingsSchedulesApiV1LinkedScheduleInput({}, pickedFields.get('affectedSchedules'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('calendarConference')) {
        result.calendarConference = overrides && overrides.hasOwnProperty('calendarConference') ? aComWixBookingsSchedulesApiV1CalendarConferenceInput(overrides.calendarConference ?? {}, pickedFields.get('calendarConference')) : aComWixBookingsSchedulesApiV1CalendarConferenceInput({}, pickedFields.get('calendarConference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('capacity')) {
        result.capacity = overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 8584;
    }
    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? aComWixBookingsSchedulesApiV1CalendarDateTimeInput(overrides.end ?? {}, pickedFields.get('end')) : aComWixBookingsSchedulesApiV1CalendarDateTimeInput({}, pickedFields.get('end'));
    }
    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalCalendarInfo')) {
        result.externalCalendarInfo = overrides && overrides.hasOwnProperty('externalCalendarInfo') ? aComWixBookingsSchedulesApiV1ExternalCalendarInfoInput(overrides.externalCalendarInfo ?? {}, pickedFields.get('externalCalendarInfo')) : aComWixBookingsSchedulesApiV1ExternalCalendarInfoInput({}, pickedFields.get('externalCalendarInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalCalendarOverrides')) {
        result.externalCalendarOverrides = overrides && overrides.hasOwnProperty('externalCalendarOverrides') ? aComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput(overrides.externalCalendarOverrides ?? {}, pickedFields.get('externalCalendarOverrides')) : aComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput({}, pickedFields.get('externalCalendarOverrides'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('inheritedFields')) {
        result.inheritedFields = overrides && overrides.hasOwnProperty('inheritedFields') ? overrides.inheritedFields! : ['rerum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceOfRecurrence')) {
        result.instanceOfRecurrence = overrides && overrides.hasOwnProperty('instanceOfRecurrence') ? overrides.instanceOfRecurrence! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixBookingsCommonApiV1LocationInput(overrides.location ?? {}, pickedFields.get('location')) : aComWixBookingsCommonApiV1LocationInput({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('notes')) {
        result.notes = overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalStart')) {
        result.originalStart = overrides && overrides.hasOwnProperty('originalStart') ? overrides.originalStart! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('participants')) {
        result.participants = overrides && overrides.hasOwnProperty('participants') ? overrides.participants!.map((x) => aComWixBookingsSchedulesApiV1ParticipantInput({}, pickedFields.get('participants'))) : [aComWixBookingsSchedulesApiV1ParticipantInput({}, pickedFields.get('participants'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? aComWixBookingsCommonApiV1RateInput(overrides.rate ?? {}, pickedFields.get('rate')) : aComWixBookingsCommonApiV1RateInput({}, pickedFields.get('rate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('recurrence')) {
        result.recurrence = overrides && overrides.hasOwnProperty('recurrence') ? overrides.recurrence! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringIntervalId')) {
        result.recurringIntervalId = overrides && overrides.hasOwnProperty('recurringIntervalId') ? overrides.recurringIntervalId! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringSessionId')) {
        result.recurringSessionId = overrides && overrides.hasOwnProperty('recurringSessionId') ? overrides.recurringSessionId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('remainingCapacity')) {
        result.remainingCapacity = overrides && overrides.hasOwnProperty('remainingCapacity') ? overrides.remainingCapacity! : 4685;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerId')) {
        result.scheduleOwnerId = overrides && overrides.hasOwnProperty('scheduleOwnerId') ? overrides.scheduleOwnerId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerName')) {
        result.scheduleOwnerName = overrides && overrides.hasOwnProperty('scheduleOwnerName') ? overrides.scheduleOwnerName! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleOwnerUserId')) {
        result.scheduleOwnerUserId = overrides && overrides.hasOwnProperty('scheduleOwnerUserId') ? overrides.scheduleOwnerUserId! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? aComWixBookingsSchedulesApiV1CalendarDateTimeInput(overrides.start ?? {}, pickedFields.get('start')) : aComWixBookingsSchedulesApiV1CalendarDateTimeInput({}, pickedFields.get('start'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixBookingsSchedulesApiV1SessionStatus.Cancelled;
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['deserunt'];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeReservedAfter')) {
        result.timeReservedAfter = overrides && overrides.hasOwnProperty('timeReservedAfter') ? overrides.timeReservedAfter! : 7492;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalNumberOfParticipants')) {
        result.totalNumberOfParticipants = overrides && overrides.hasOwnProperty('totalNumberOfParticipants') ? overrides.totalNumberOfParticipants! : 6614;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixBookingsSchedulesApiV1SessionType.Availability;
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? aComWixBookingsSchedulesApiV1SessionVersionInput(overrides.version ?? {}, pickedFields.get('version')) : aComWixBookingsSchedulesApiV1SessionVersionInput({}, pickedFields.get('version'));
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1SessionUpdatedInput = <T extends Partial<ComWixBookingsSchedulesApiV1SessionUpdatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newSession')) {
        result.newSession = overrides && overrides.hasOwnProperty('newSession') ? aComWixBookingsSchedulesApiV1SessionInput(overrides.newSession ?? {}, pickedFields.get('newSession')) : aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('newSession'));
    }
    if (pickedFields.size === 0 || pickedFields.has('oldSession')) {
        result.oldSession = overrides && overrides.hasOwnProperty('oldSession') ? aComWixBookingsSchedulesApiV1SessionInput(overrides.oldSession ?? {}, pickedFields.get('oldSession')) : aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('oldSession'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aComWixBookingsSchedulesApiV1ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aComWixBookingsSchedulesApiV1ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('triggeredByAnonymizeRequest')) {
        result.triggeredByAnonymizeRequest = overrides && overrides.hasOwnProperty('triggeredByAnonymizeRequest') ? overrides.triggeredByAnonymizeRequest! : true;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1SessionVersion = <T extends Partial<ComWixBookingsSchedulesApiV1SessionVersion>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantsVersion')) {
        result.participantsVersion = overrides && overrides.hasOwnProperty('participantsVersion') ? overrides.participantsVersion! : 1915;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleVersion')) {
        result.scheduleVersion = overrides && overrides.hasOwnProperty('scheduleVersion') ? overrides.scheduleVersion! : 1021;
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionVersion')) {
        result.sessionVersion = overrides && overrides.hasOwnProperty('sessionVersion') ? overrides.sessionVersion! : 6981;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1SessionVersionInput = <T extends Partial<ComWixBookingsSchedulesApiV1SessionVersionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantsVersion')) {
        result.participantsVersion = overrides && overrides.hasOwnProperty('participantsVersion') ? overrides.participantsVersion! : 1526;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleVersion')) {
        result.scheduleVersion = overrides && overrides.hasOwnProperty('scheduleVersion') ? overrides.scheduleVersion! : 3808;
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionVersion')) {
        result.sessionVersion = overrides && overrides.hasOwnProperty('sessionVersion') ? overrides.sessionVersion! : 3392;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput = <T extends Partial<ComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'omnis';
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1SplitInterval = <T extends Partial<ComWixBookingsSchedulesApiV1SplitInterval>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sameAsDuration')) {
        result.sameAsDuration = overrides && overrides.hasOwnProperty('sameAsDuration') ? overrides.sameAsDuration! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('valueInMinutes')) {
        result.valueInMinutes = overrides && overrides.hasOwnProperty('valueInMinutes') ? overrides.valueInMinutes! : 1762;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1SplitIntervalInput = <T extends Partial<ComWixBookingsSchedulesApiV1SplitIntervalInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sameAsDuration')) {
        result.sameAsDuration = overrides && overrides.hasOwnProperty('sameAsDuration') ? overrides.sameAsDuration! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('valueInMinutes')) {
        result.valueInMinutes = overrides && overrides.hasOwnProperty('valueInMinutes') ? overrides.valueInMinutes! : 6392;
    }

    return result;
};

export const aComWixBookingsSchedulesApiV1UpdateScheduleRequestInput = <T extends Partial<ComWixBookingsSchedulesApiV1UpdateScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('alignTimeExceptions')) {
        result.alignTimeExceptions = overrides && overrides.hasOwnProperty('alignTimeExceptions') ? overrides.alignTimeExceptions! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['impedit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('notifyParticipants')) {
        result.notifyParticipants = overrides && overrides.hasOwnProperty('notifyParticipants') ? overrides.notifyParticipants! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aComWixBookingsSchedulesApiV1ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aComWixBookingsSchedulesApiV1ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aComWixBookingsSchedulesApiV1ScheduleInput(overrides.schedule ?? {}, pickedFields.get('schedule')) : aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aComWixBookingsSchedulesVeloV2CreateSessionRequestInput = <T extends Partial<ComWixBookingsSchedulesVeloV2CreateSessionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('session')) {
        result.session = overrides && overrides.hasOwnProperty('session') ? aComWixBookingsSchedulesApiV1SessionInput(overrides.session ?? {}, pickedFields.get('session')) : aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('session'));
    }

    return result;
};

export const aComWixBookingsSchedulesVeloV2CreateSessionResponse = <T extends Partial<ComWixBookingsSchedulesVeloV2CreateSessionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('session')) {
        result.session = overrides && overrides.hasOwnProperty('session') ? aComWixBookingsSchedulesApiV1Session(overrides.session ?? {}, pickedFields.get('session')) : aComWixBookingsSchedulesApiV1Session({}, pickedFields.get('session'));
    }

    return result;
};

export const aComWixBookingsSchedulesVeloV2DeleteSessionRequestInput = <T extends Partial<ComWixBookingsSchedulesVeloV2DeleteSessionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aComWixBookingsSchedulesApiV1ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aComWixBookingsSchedulesApiV1ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionId')) {
        result.sessionId = overrides && overrides.hasOwnProperty('sessionId') ? overrides.sessionId! : 'suscipit';
    }

    return result;
};

export const aComWixBookingsSchedulesVeloV2UpdateSessionRequestInput = <T extends Partial<ComWixBookingsSchedulesVeloV2UpdateSessionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldmask')) {
        result.fieldmask = overrides && overrides.hasOwnProperty('fieldmask') ? overrides.fieldmask! : ['totam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aComWixBookingsSchedulesApiV1ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aComWixBookingsSchedulesApiV1ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('session')) {
        result.session = overrides && overrides.hasOwnProperty('session') ? aComWixBookingsSchedulesApiV1SessionInput(overrides.session ?? {}, pickedFields.get('session')) : aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('session'));
    }

    return result;
};

export const aComWixBookingsSchedulesVeloV2UpdateSessionResponse = <T extends Partial<ComWixBookingsSchedulesVeloV2UpdateSessionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('session')) {
        result.session = overrides && overrides.hasOwnProperty('session') ? aComWixBookingsSchedulesApiV1Session(overrides.session ?? {}, pickedFields.get('session')) : aComWixBookingsSchedulesApiV1Session({}, pickedFields.get('session'));
    }

    return result;
};

export const aComWixBookingsUpstreamWixCommonAddress = <T extends Partial<ComWixBookingsUpstreamWixCommonAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aComWixBookingsUpstreamWixCommonAddressLocation(overrides.geocode ?? {}, pickedFields.get('geocode')) : aComWixBookingsUpstreamWixCommonAddressLocation({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aComWixBookingsUpstreamWixCommonStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aComWixBookingsUpstreamWixCommonStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aComWixBookingsUpstreamWixCommonSubdivision(x ?? {}, pickedFields.get('subdivisions'))) : [aComWixBookingsUpstreamWixCommonSubdivision({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aComWixBookingsUpstreamWixCommonAddressInput = <T extends Partial<ComWixBookingsUpstreamWixCommonAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aComWixBookingsUpstreamWixCommonAddressLocationInput(overrides.geocode ?? {}, pickedFields.get('geocode')) : aComWixBookingsUpstreamWixCommonAddressLocationInput({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aComWixBookingsUpstreamWixCommonStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aComWixBookingsUpstreamWixCommonStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aComWixBookingsUpstreamWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))) : [aComWixBookingsUpstreamWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aComWixBookingsUpstreamWixCommonAddressLocation = <T extends Partial<ComWixBookingsUpstreamWixCommonAddressLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 4.14;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 3.01;
    }

    return result;
};

export const aComWixBookingsUpstreamWixCommonAddressLocationInput = <T extends Partial<ComWixBookingsUpstreamWixCommonAddressLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 8.57;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 1.56;
    }

    return result;
};

export const aComWixBookingsUpstreamWixCommonPagingInput = <T extends Partial<ComWixBookingsUpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 4924;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 7086;
    }

    return result;
};

export const aComWixBookingsUpstreamWixCommonQueryInput = <T extends Partial<ComWixBookingsUpstreamWixCommonQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['reprehenderit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['veniam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixBookingsUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixBookingsUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixBookingsUpstreamWixCommonQueryV2Input = <T extends Partial<ComWixBookingsUpstreamWixCommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['dicta'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['beatae'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixBookingsUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixBookingsUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixBookingsUpstreamWixCommonStreetAddress = <T extends Partial<ComWixBookingsUpstreamWixCommonStreetAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'sunt';
    }

    return result;
};

export const aComWixBookingsUpstreamWixCommonStreetAddressInput = <T extends Partial<ComWixBookingsUpstreamWixCommonStreetAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'ut';
    }

    return result;
};

export const aComWixBookingsUpstreamWixCommonSubdivision = <T extends Partial<ComWixBookingsUpstreamWixCommonSubdivision>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tempora';
    }

    return result;
};

export const aComWixBookingsUpstreamWixCommonSubdivisionInput = <T extends Partial<ComWixBookingsUpstreamWixCommonSubdivisionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'iure';
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1CatalogOverrideFields = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1CatalogOverrideFields>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('depositAmount')) {
        result.depositAmount = overrides && overrides.hasOwnProperty('depositAmount') ? overrides.depositAmount! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLine(x ?? {}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLine({}, pickedFields.get('descriptionLines'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('fullPrice')) {
        result.fullPrice = overrides && overrides.hasOwnProperty('fullPrice') ? overrides.fullPrice! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixEcomCartCheckoutCommonApiV1Image(overrides.image ?? {}, pickedFields.get('image')) : aComWixEcomCartCheckoutCommonApiV1Image({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOption')) {
        result.paymentOption = overrides && overrides.hasOwnProperty('paymentOption') ? aComWixEcomCartCheckoutCommonApiV1PaymentOption(overrides.paymentOption ?? {}, pickedFields.get('paymentOption')) : aComWixEcomCartCheckoutCommonApiV1PaymentOption({}, pickedFields.get('paymentOption'));
    }
    if (pickedFields.size === 0 || pickedFields.has('physicalProperties')) {
        result.physicalProperties = overrides && overrides.hasOwnProperty('physicalProperties') ? aComWixEcommerceCatalogSpiApiV1PhysicalProperties(overrides.physicalProperties ?? {}, pickedFields.get('physicalProperties')) : aComWixEcommerceCatalogSpiApiV1PhysicalProperties({}, pickedFields.get('physicalProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('productName')) {
        result.productName = overrides && overrides.hasOwnProperty('productName') ? aComWixEcommerceCatalogSpiApiV1ProductName(overrides.productName ?? {}, pickedFields.get('productName')) : aComWixEcommerceCatalogSpiApiV1ProductName({}, pickedFields.get('productName'));
    }
    if (pickedFields.size === 0 || pickedFields.has('savePaymentMethod')) {
        result.savePaymentMethod = overrides && overrides.hasOwnProperty('savePaymentMethod') ? overrides.savePaymentMethod! : false;
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1CatalogOverrideFieldsInput = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1CatalogOverrideFieldsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('depositAmount')) {
        result.depositAmount = overrides && overrides.hasOwnProperty('depositAmount') ? overrides.depositAmount! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('fullPrice')) {
        result.fullPrice = overrides && overrides.hasOwnProperty('fullPrice') ? overrides.fullPrice! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixEcomCartCheckoutCommonApiV1ImageInput(overrides.image ?? {}, pickedFields.get('image')) : aComWixEcomCartCheckoutCommonApiV1ImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOption')) {
        result.paymentOption = overrides && overrides.hasOwnProperty('paymentOption') ? aComWixEcomCartCheckoutCommonApiV1PaymentOptionInput(overrides.paymentOption ?? {}, pickedFields.get('paymentOption')) : aComWixEcomCartCheckoutCommonApiV1PaymentOptionInput({}, pickedFields.get('paymentOption'));
    }
    if (pickedFields.size === 0 || pickedFields.has('physicalProperties')) {
        result.physicalProperties = overrides && overrides.hasOwnProperty('physicalProperties') ? aComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput(overrides.physicalProperties ?? {}, pickedFields.get('physicalProperties')) : aComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput({}, pickedFields.get('physicalProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('productName')) {
        result.productName = overrides && overrides.hasOwnProperty('productName') ? aComWixEcommerceCatalogSpiApiV1ProductNameInput(overrides.productName ?? {}, pickedFields.get('productName')) : aComWixEcommerceCatalogSpiApiV1ProductNameInput({}, pickedFields.get('productName'));
    }
    if (pickedFields.size === 0 || pickedFields.has('savePaymentMethod')) {
        result.savePaymentMethod = overrides && overrides.hasOwnProperty('savePaymentMethod') ? overrides.savePaymentMethod! : false;
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1CustomContentReference = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1CustomContentReference>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('componentId')) {
        result.componentId = overrides && overrides.hasOwnProperty('componentId') ? overrides.componentId! : 'illum';
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1CustomContentReferenceInput = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1CustomContentReferenceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('componentId')) {
        result.componentId = overrides && overrides.hasOwnProperty('componentId') ? overrides.componentId! : 'omnis';
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1CustomLineItemInput = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1CustomLineItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('catalogReference')) {
        result.catalogReference = overrides && overrides.hasOwnProperty('catalogReference') ? aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput(overrides.catalogReference ?? {}, pickedFields.get('catalogReference')) : aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput({}, pickedFields.get('catalogReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('consentRequiredPaymentPolicy')) {
        result.consentRequiredPaymentPolicy = overrides && overrides.hasOwnProperty('consentRequiredPaymentPolicy') ? overrides.consentRequiredPaymentPolicy! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryProfileId')) {
        result.deliveryProfileId = overrides && overrides.hasOwnProperty('deliveryProfileId') ? overrides.deliveryProfileId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('depositAmount')) {
        result.depositAmount = overrides && overrides.hasOwnProperty('depositAmount') ? overrides.depositAmount! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('digitalFile')) {
        result.digitalFile = overrides && overrides.hasOwnProperty('digitalFile') ? aComWixEcommerceCatalogSpiApiV1SecuredMediaInput(overrides.digitalFile ?? {}, pickedFields.get('digitalFile')) : aComWixEcommerceCatalogSpiApiV1SecuredMediaInput({}, pickedFields.get('digitalFile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedQuantity')) {
        result.fixedQuantity = overrides && overrides.hasOwnProperty('fixedQuantity') ? overrides.fixedQuantity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('fullPrice')) {
        result.fullPrice = overrides && overrides.hasOwnProperty('fullPrice') ? overrides.fullPrice! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('inventoryAppId')) {
        result.inventoryAppId = overrides && overrides.hasOwnProperty('inventoryAppId') ? overrides.inventoryAppId! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemType')) {
        result.itemType = overrides && overrides.hasOwnProperty('itemType') ? aComWixEcommerceCatalogSpiApiV1ItemTypeInput(overrides.itemType ?? {}, pickedFields.get('itemType')) : aComWixEcommerceCatalogSpiApiV1ItemTypeInput({}, pickedFields.get('itemType'));
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aComWixEcomCartCheckoutCommonApiV1ImageInput(overrides.media ?? {}, pickedFields.get('media')) : aComWixEcomCartCheckoutCommonApiV1ImageInput({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('membersOnly')) {
        result.membersOnly = overrides && overrides.hasOwnProperty('membersOnly') ? overrides.membersOnly! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroups')) {
        result.modifierGroups = overrides && overrides.hasOwnProperty('modifierGroups') ? overrides.modifierGroups!.map((x) => aComWixEcommerceCatalogSpiApiV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))) : [aComWixEcommerceCatalogSpiApiV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOption')) {
        result.paymentOption = overrides && overrides.hasOwnProperty('paymentOption') ? overrides.paymentOption! : ComWixEcommerceCatalogSpiApiV1PaymentOptionType.DepositOnline;
    }
    if (pickedFields.size === 0 || pickedFields.has('physicalProperties')) {
        result.physicalProperties = overrides && overrides.hasOwnProperty('physicalProperties') ? aComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput(overrides.physicalProperties ?? {}, pickedFields.get('physicalProperties')) : aComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput({}, pickedFields.get('physicalProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('policies')) {
        result.policies = overrides && overrides.hasOwnProperty('policies') ? overrides.policies!.map((x) => aComWixEcommerceCatalogSpiApiV1PolicyInput({}, pickedFields.get('policies'))) : [aComWixEcommerceCatalogSpiApiV1PolicyInput({}, pickedFields.get('policies'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceDescription')) {
        result.priceDescription = overrides && overrides.hasOwnProperty('priceDescription') ? aComWixEcommerceCatalogSpiApiV1PriceDescriptionInput(overrides.priceDescription ?? {}, pickedFields.get('priceDescription')) : aComWixEcommerceCatalogSpiApiV1PriceDescriptionInput({}, pickedFields.get('priceDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceUndetermined')) {
        result.priceUndetermined = overrides && overrides.hasOwnProperty('priceUndetermined') ? overrides.priceUndetermined! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('productName')) {
        result.productName = overrides && overrides.hasOwnProperty('productName') ? aComWixEcommerceCatalogSpiApiV1ProductNameInput(overrides.productName ?? {}, pickedFields.get('productName')) : aComWixEcommerceCatalogSpiApiV1ProductNameInput({}, pickedFields.get('productName'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8882;
    }
    if (pickedFields.size === 0 || pickedFields.has('quantityAvailable')) {
        result.quantityAvailable = overrides && overrides.hasOwnProperty('quantityAvailable') ? overrides.quantityAvailable! : 7130;
    }
    if (pickedFields.size === 0 || pickedFields.has('rootCatalogItemId')) {
        result.rootCatalogItemId = overrides && overrides.hasOwnProperty('rootCatalogItemId') ? overrides.rootCatalogItemId! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('savePaymentMethod')) {
        result.savePaymentMethod = overrides && overrides.hasOwnProperty('savePaymentMethod') ? overrides.savePaymentMethod! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceProperties')) {
        result.serviceProperties = overrides && overrides.hasOwnProperty('serviceProperties') ? aComWixEcommerceCatalogSpiApiV1ServicePropertiesInput(overrides.serviceProperties ?? {}, pickedFields.get('serviceProperties')) : aComWixEcommerceCatalogSpiApiV1ServicePropertiesInput({}, pickedFields.get('serviceProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionOptionInfo')) {
        result.subscriptionOptionInfo = overrides && overrides.hasOwnProperty('subscriptionOptionInfo') ? aComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput(overrides.subscriptionOptionInfo ?? {}, pickedFields.get('subscriptionOptionInfo')) : aComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput({}, pickedFields.get('subscriptionOptionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAddress')) {
        result.taxableAddress = overrides && overrides.hasOwnProperty('taxableAddress') ? aComWixEcommercePlatformCommonApiTaxableAddressInput(overrides.taxableAddress ?? {}, pickedFields.get('taxableAddress')) : aComWixEcommercePlatformCommonApiTaxableAddressInput({}, pickedFields.get('taxableAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlV2Input(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlV2Input({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1Image = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1Image>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 1766;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 3604;
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1ImageInput = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1ImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 171;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 2835;
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1ItemModifier = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1ItemModifier>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcommercePlatformCommonApiTranslatableString(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcommercePlatformCommonApiTranslatableString({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixEcommercePlatformCommonApiTranslatableString(overrides.label ?? {}, pickedFields.get('label')) : aComWixEcommercePlatformCommonApiTranslatableString({}, pickedFields.get('label'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8414;
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1ItemModifierInput = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1ItemModifierInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcommercePlatformCommonApiTranslatableStringInput(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcommercePlatformCommonApiTranslatableStringInput({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixEcommercePlatformCommonApiTranslatableStringInput(overrides.label ?? {}, pickedFields.get('label')) : aComWixEcommercePlatformCommonApiTranslatableStringInput({}, pickedFields.get('label'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 2192;
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1ModifierGroup = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1ModifierGroup>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiers')) {
        result.modifiers = overrides && overrides.hasOwnProperty('modifiers') ? overrides.modifiers!.map((x) => aComWixEcomCartCheckoutCommonApiV1ItemModifier(x ?? {}, pickedFields.get('modifiers'))) : [aComWixEcomCartCheckoutCommonApiV1ItemModifier({}, pickedFields.get('modifiers'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommercePlatformCommonApiTranslatableString(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommercePlatformCommonApiTranslatableString({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1ModifierGroupInput = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1ModifierGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiers')) {
        result.modifiers = overrides && overrides.hasOwnProperty('modifiers') ? overrides.modifiers!.map((x) => aComWixEcomCartCheckoutCommonApiV1ItemModifierInput({}, pickedFields.get('modifiers'))) : [aComWixEcomCartCheckoutCommonApiV1ItemModifierInput({}, pickedFields.get('modifiers'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommercePlatformCommonApiTranslatableStringInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommercePlatformCommonApiTranslatableStringInput({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1PaymentOption = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1PaymentOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : ComWixEcommerceCatalogSpiApiV1PaymentOptionType.DepositOnline;
    }

    return result;
};

export const aComWixEcomCartCheckoutCommonApiV1PaymentOptionInput = <T extends Partial<ComWixEcomCartCheckoutCommonApiV1PaymentOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : ComWixEcommerceCatalogSpiApiV1PaymentOptionType.DepositOnline;
    }

    return result;
};

export const aComWixEcomDiscountsActiveTimeInfo = <T extends Partial<ComWixEcomDiscountsActiveTimeInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? overrides.end! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? overrides.start! : 'non';
    }

    return result;
};

export const aComWixEcomDiscountsActiveTimeInfoInput = <T extends Partial<ComWixEcomDiscountsActiveTimeInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? overrides.end! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? overrides.start! : 'ratione';
    }

    return result;
};

export const aComWixEcomDiscountsAppliedDiscount = <T extends Partial<ComWixEcomDiscountsAppliedDiscount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appliedDiscountRule')) {
        result.appliedDiscountRule = overrides && overrides.hasOwnProperty('appliedDiscountRule') ? aComWixEcomDiscountsAppliedDiscountRule(overrides.appliedDiscountRule ?? {}, pickedFields.get('appliedDiscountRule')) : aComWixEcomDiscountsAppliedDiscountRule({}, pickedFields.get('appliedDiscountRule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountType')) {
        result.discountType = overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : ComWixEcomDiscountsDiscountTargetType.BuyXGetY;
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['qui'];
    }

    return result;
};

export const aComWixEcomDiscountsAppliedDiscountRule = <T extends Partial<ComWixEcomDiscountsAppliedDiscountRule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountRule')) {
        result.discountRule = overrides && overrides.hasOwnProperty('discountRule') ? aComWixEcomDiscountsDiscountRule(overrides.discountRule ?? {}, pickedFields.get('discountRule')) : aComWixEcomDiscountsDiscountRule({}, pickedFields.get('discountRule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountRuleType')) {
        result.discountRuleType = overrides && overrides.hasOwnProperty('discountRuleType') ? overrides.discountRuleType! : ComWixEcomDiscountsDiscountDiscountType.FixedAmount;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomDiscountsDiscountRuleName(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomDiscountsDiscountRuleName({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomDiscountsBuyXGetYInfo = <T extends Partial<ComWixEcomDiscountsBuyXGetYInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerBuys')) {
        result.customerBuys = overrides && overrides.hasOwnProperty('customerBuys') ? aComWixEcomDiscountsCustomerBuy(overrides.customerBuys ?? {}, pickedFields.get('customerBuys')) : aComWixEcomDiscountsCustomerBuy({}, pickedFields.get('customerBuys'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customerGets')) {
        result.customerGets = overrides && overrides.hasOwnProperty('customerGets') ? aComWixEcomDiscountsCustomerGet(overrides.customerGets ?? {}, pickedFields.get('customerGets')) : aComWixEcomDiscountsCustomerGet({}, pickedFields.get('customerGets'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 7848;
    }

    return result;
};

export const aComWixEcomDiscountsBuyXGetYInfoInput = <T extends Partial<ComWixEcomDiscountsBuyXGetYInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerBuys')) {
        result.customerBuys = overrides && overrides.hasOwnProperty('customerBuys') ? aComWixEcomDiscountsCustomerBuyInput(overrides.customerBuys ?? {}, pickedFields.get('customerBuys')) : aComWixEcomDiscountsCustomerBuyInput({}, pickedFields.get('customerBuys'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customerGets')) {
        result.customerGets = overrides && overrides.hasOwnProperty('customerGets') ? aComWixEcomDiscountsCustomerGetInput(overrides.customerGets ?? {}, pickedFields.get('customerGets')) : aComWixEcomDiscountsCustomerGetInput({}, pickedFields.get('customerGets'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2318;
    }

    return result;
};

export const aComWixEcomDiscountsCatalogItemFilter = <T extends Partial<ComWixEcomDiscountsCatalogItemFilter>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('catalogAppId')) {
        result.catalogAppId = overrides && overrides.hasOwnProperty('catalogAppId') ? overrides.catalogAppId! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('catalogItemIds')) {
        result.catalogItemIds = overrides && overrides.hasOwnProperty('catalogItemIds') ? overrides.catalogItemIds! : ['et'];
    }

    return result;
};

export const aComWixEcomDiscountsCatalogItemFilterInput = <T extends Partial<ComWixEcomDiscountsCatalogItemFilterInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('catalogAppId')) {
        result.catalogAppId = overrides && overrides.hasOwnProperty('catalogAppId') ? overrides.catalogAppId! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('catalogItemIds')) {
        result.catalogItemIds = overrides && overrides.hasOwnProperty('catalogItemIds') ? overrides.catalogItemIds! : ['magnam'];
    }

    return result;
};

export const aComWixEcomDiscountsCreateDiscountRuleRequestInput = <T extends Partial<ComWixEcomDiscountsCreateDiscountRuleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discountRule')) {
        result.discountRule = overrides && overrides.hasOwnProperty('discountRule') ? aComWixEcomDiscountsDiscountRuleInput(overrides.discountRule ?? {}, pickedFields.get('discountRule')) : aComWixEcomDiscountsDiscountRuleInput({}, pickedFields.get('discountRule'));
    }

    return result;
};

export const aComWixEcomDiscountsCreateDiscountRuleResponse = <T extends Partial<ComWixEcomDiscountsCreateDiscountRuleResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discountRule')) {
        result.discountRule = overrides && overrides.hasOwnProperty('discountRule') ? aComWixEcomDiscountsDiscountRule(overrides.discountRule ?? {}, pickedFields.get('discountRule')) : aComWixEcomDiscountsDiscountRule({}, pickedFields.get('discountRule'));
    }

    return result;
};

export const aComWixEcomDiscountsCustomFilter = <T extends Partial<ComWixEcomDiscountsCustomFilter>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('params')) {
        result.params = overrides && overrides.hasOwnProperty('params') ? overrides.params! : 'veritatis';
    }

    return result;
};

export const aComWixEcomDiscountsCustomFilterInput = <T extends Partial<ComWixEcomDiscountsCustomFilterInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('params')) {
        result.params = overrides && overrides.hasOwnProperty('params') ? overrides.params! : 'nemo';
    }

    return result;
};

export const aComWixEcomDiscountsCustomerBuy = <T extends Partial<ComWixEcomDiscountsCustomerBuy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('minimumQuantity')) {
        result.minimumQuantity = overrides && overrides.hasOwnProperty('minimumQuantity') ? overrides.minimumQuantity! : 8895;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimumSpend')) {
        result.minimumSpend = overrides && overrides.hasOwnProperty('minimumSpend') ? overrides.minimumSpend! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('scopes')) {
        result.scopes = overrides && overrides.hasOwnProperty('scopes') ? overrides.scopes!.map((x) => aComWixEcomDiscountsScope(x ?? {}, pickedFields.get('scopes'))) : [aComWixEcomDiscountsScope({}, pickedFields.get('scopes'))];
    }

    return result;
};

export const aComWixEcomDiscountsCustomerBuyInput = <T extends Partial<ComWixEcomDiscountsCustomerBuyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('minimumQuantity')) {
        result.minimumQuantity = overrides && overrides.hasOwnProperty('minimumQuantity') ? overrides.minimumQuantity! : 2640;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimumSpend')) {
        result.minimumSpend = overrides && overrides.hasOwnProperty('minimumSpend') ? overrides.minimumSpend! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('scopes')) {
        result.scopes = overrides && overrides.hasOwnProperty('scopes') ? overrides.scopes!.map((x) => aComWixEcomDiscountsScopeInput({}, pickedFields.get('scopes'))) : [aComWixEcomDiscountsScopeInput({}, pickedFields.get('scopes'))];
    }

    return result;
};

export const aComWixEcomDiscountsCustomerGet = <T extends Partial<ComWixEcomDiscountsCustomerGet>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 6842;
    }
    if (pickedFields.size === 0 || pickedFields.has('scopes')) {
        result.scopes = overrides && overrides.hasOwnProperty('scopes') ? overrides.scopes!.map((x) => aComWixEcomDiscountsScope(x ?? {}, pickedFields.get('scopes'))) : [aComWixEcomDiscountsScope({}, pickedFields.get('scopes'))];
    }

    return result;
};

export const aComWixEcomDiscountsCustomerGetInput = <T extends Partial<ComWixEcomDiscountsCustomerGetInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 1256;
    }
    if (pickedFields.size === 0 || pickedFields.has('scopes')) {
        result.scopes = overrides && overrides.hasOwnProperty('scopes') ? overrides.scopes!.map((x) => aComWixEcomDiscountsScopeInput({}, pickedFields.get('scopes'))) : [aComWixEcomDiscountsScopeInput({}, pickedFields.get('scopes'))];
    }

    return result;
};

export const aComWixEcomDiscountsDeleteDiscountRuleRequestInput = <T extends Partial<ComWixEcomDiscountsDeleteDiscountRuleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discountRuleId')) {
        result.discountRuleId = overrides && overrides.hasOwnProperty('discountRuleId') ? overrides.discountRuleId! : 'natus';
    }

    return result;
};

export const aComWixEcomDiscountsDiscount = <T extends Partial<ComWixEcomDiscountsDiscount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buyXGetYInfo')) {
        result.buyXGetYInfo = overrides && overrides.hasOwnProperty('buyXGetYInfo') ? aComWixEcomDiscountsBuyXGetYInfo(overrides.buyXGetYInfo ?? {}, pickedFields.get('buyXGetYInfo')) : aComWixEcomDiscountsBuyXGetYInfo({}, pickedFields.get('buyXGetYInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountType')) {
        result.discountType = overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : ComWixEcomDiscountsDiscountDiscountType.FixedAmount;
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedAmount')) {
        result.fixedAmount = overrides && overrides.hasOwnProperty('fixedAmount') ? overrides.fixedAmount! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedPrice')) {
        result.fixedPrice = overrides && overrides.hasOwnProperty('fixedPrice') ? overrides.fixedPrice! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 2.55;
    }
    if (pickedFields.size === 0 || pickedFields.has('specificItemsInfo')) {
        result.specificItemsInfo = overrides && overrides.hasOwnProperty('specificItemsInfo') ? aComWixEcomDiscountsSpecificItemsInfo(overrides.specificItemsInfo ?? {}, pickedFields.get('specificItemsInfo')) : aComWixEcomDiscountsSpecificItemsInfo({}, pickedFields.get('specificItemsInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('targetType')) {
        result.targetType = overrides && overrides.hasOwnProperty('targetType') ? overrides.targetType! : ComWixEcomDiscountsDiscountTargetType.BuyXGetY;
    }

    return result;
};

export const aComWixEcomDiscountsDiscountInput = <T extends Partial<ComWixEcomDiscountsDiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buyXGetYInfo')) {
        result.buyXGetYInfo = overrides && overrides.hasOwnProperty('buyXGetYInfo') ? aComWixEcomDiscountsBuyXGetYInfoInput(overrides.buyXGetYInfo ?? {}, pickedFields.get('buyXGetYInfo')) : aComWixEcomDiscountsBuyXGetYInfoInput({}, pickedFields.get('buyXGetYInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountType')) {
        result.discountType = overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : ComWixEcomDiscountsDiscountDiscountType.FixedAmount;
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedAmount')) {
        result.fixedAmount = overrides && overrides.hasOwnProperty('fixedAmount') ? overrides.fixedAmount! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedPrice')) {
        result.fixedPrice = overrides && overrides.hasOwnProperty('fixedPrice') ? overrides.fixedPrice! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 6.35;
    }
    if (pickedFields.size === 0 || pickedFields.has('specificItemsInfo')) {
        result.specificItemsInfo = overrides && overrides.hasOwnProperty('specificItemsInfo') ? aComWixEcomDiscountsSpecificItemsInfoInput(overrides.specificItemsInfo ?? {}, pickedFields.get('specificItemsInfo')) : aComWixEcomDiscountsSpecificItemsInfoInput({}, pickedFields.get('specificItemsInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('targetType')) {
        result.targetType = overrides && overrides.hasOwnProperty('targetType') ? overrides.targetType! : ComWixEcomDiscountsDiscountTargetType.BuyXGetY;
    }

    return result;
};

export const aComWixEcomDiscountsDiscountRule = <T extends Partial<ComWixEcomDiscountsDiscountRule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('active')) {
        result.active = overrides && overrides.hasOwnProperty('active') ? overrides.active! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('activeTimeInfo')) {
        result.activeTimeInfo = overrides && overrides.hasOwnProperty('activeTimeInfo') ? aComWixEcomDiscountsActiveTimeInfo(overrides.activeTimeInfo ?? {}, pickedFields.get('activeTimeInfo')) : aComWixEcomDiscountsActiveTimeInfo({}, pickedFields.get('activeTimeInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('discounts')) {
        result.discounts = overrides && overrides.hasOwnProperty('discounts') ? aComWixEcomDiscountsDiscounts(overrides.discounts ?? {}, pickedFields.get('discounts')) : aComWixEcomDiscountsDiscounts({}, pickedFields.get('discounts'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('offer')) {
        result.offer = overrides && overrides.hasOwnProperty('offer') ? overrides.offer! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('settings')) {
        result.settings = overrides && overrides.hasOwnProperty('settings') ? aComWixEcomDiscountsDiscountSettings(overrides.settings ?? {}, pickedFields.get('settings')) : aComWixEcomDiscountsDiscountSettings({}, pickedFields.get('settings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomDiscountsDiscountRuleStatus.Expired;
    }
    if (pickedFields.size === 0 || pickedFields.has('trigger')) {
        result.trigger = overrides && overrides.hasOwnProperty('trigger') ? aComWixEcomDiscountsDiscountTrigger(overrides.trigger ?? {}, pickedFields.get('trigger')) : aComWixEcomDiscountsDiscountTrigger({}, pickedFields.get('trigger'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('usageCount')) {
        result.usageCount = overrides && overrides.hasOwnProperty('usageCount') ? overrides.usageCount! : 7404;
    }

    return result;
};

export const aComWixEcomDiscountsDiscountRuleInput = <T extends Partial<ComWixEcomDiscountsDiscountRuleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('active')) {
        result.active = overrides && overrides.hasOwnProperty('active') ? overrides.active! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('activeTimeInfo')) {
        result.activeTimeInfo = overrides && overrides.hasOwnProperty('activeTimeInfo') ? aComWixEcomDiscountsActiveTimeInfoInput(overrides.activeTimeInfo ?? {}, pickedFields.get('activeTimeInfo')) : aComWixEcomDiscountsActiveTimeInfoInput({}, pickedFields.get('activeTimeInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('discounts')) {
        result.discounts = overrides && overrides.hasOwnProperty('discounts') ? aComWixEcomDiscountsDiscountsInput(overrides.discounts ?? {}, pickedFields.get('discounts')) : aComWixEcomDiscountsDiscountsInput({}, pickedFields.get('discounts'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('offer')) {
        result.offer = overrides && overrides.hasOwnProperty('offer') ? overrides.offer! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('settings')) {
        result.settings = overrides && overrides.hasOwnProperty('settings') ? aComWixEcomDiscountsDiscountSettingsInput(overrides.settings ?? {}, pickedFields.get('settings')) : aComWixEcomDiscountsDiscountSettingsInput({}, pickedFields.get('settings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomDiscountsDiscountRuleStatus.Expired;
    }
    if (pickedFields.size === 0 || pickedFields.has('trigger')) {
        result.trigger = overrides && overrides.hasOwnProperty('trigger') ? aComWixEcomDiscountsDiscountTriggerInput(overrides.trigger ?? {}, pickedFields.get('trigger')) : aComWixEcomDiscountsDiscountTriggerInput({}, pickedFields.get('trigger'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('usageCount')) {
        result.usageCount = overrides && overrides.hasOwnProperty('usageCount') ? overrides.usageCount! : 673;
    }

    return result;
};

export const aComWixEcomDiscountsDiscountRuleName = <T extends Partial<ComWixEcomDiscountsDiscountRuleName>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'cupiditate';
    }

    return result;
};

export const aComWixEcomDiscountsDiscountSettings = <T extends Partial<ComWixEcomDiscountsDiscountSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appliesTo')) {
        result.appliesTo = overrides && overrides.hasOwnProperty('appliesTo') ? overrides.appliesTo! : ComWixEcomDiscountsDiscountSettingsAppliedSubjectType.AllItems;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeSubscription')) {
        result.includeSubscription = overrides && overrides.hasOwnProperty('includeSubscription') ? overrides.includeSubscription! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('indexOptIn')) {
        result.indexOptIn = overrides && overrides.hasOwnProperty('indexOptIn') ? overrides.indexOptIn! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('usageLimit')) {
        result.usageLimit = overrides && overrides.hasOwnProperty('usageLimit') ? overrides.usageLimit! : 6338;
    }
    if (pickedFields.size === 0 || pickedFields.has('usageLimitPerUser')) {
        result.usageLimitPerUser = overrides && overrides.hasOwnProperty('usageLimitPerUser') ? overrides.usageLimitPerUser! : 9488;
    }

    return result;
};

export const aComWixEcomDiscountsDiscountSettingsInput = <T extends Partial<ComWixEcomDiscountsDiscountSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appliesTo')) {
        result.appliesTo = overrides && overrides.hasOwnProperty('appliesTo') ? overrides.appliesTo! : ComWixEcomDiscountsDiscountSettingsAppliedSubjectType.AllItems;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeSubscription')) {
        result.includeSubscription = overrides && overrides.hasOwnProperty('includeSubscription') ? overrides.includeSubscription! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('indexOptIn')) {
        result.indexOptIn = overrides && overrides.hasOwnProperty('indexOptIn') ? overrides.indexOptIn! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('usageLimit')) {
        result.usageLimit = overrides && overrides.hasOwnProperty('usageLimit') ? overrides.usageLimit! : 4003;
    }
    if (pickedFields.size === 0 || pickedFields.has('usageLimitPerUser')) {
        result.usageLimitPerUser = overrides && overrides.hasOwnProperty('usageLimitPerUser') ? overrides.usageLimitPerUser! : 8086;
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTrigger = <T extends Partial<ComWixEcomDiscountsDiscountTrigger>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('and')) {
        result.and = overrides && overrides.hasOwnProperty('and') ? aComWixEcomDiscountsDiscountTriggerAnd(overrides.and ?? {}, pickedFields.get('and')) : aComWixEcomDiscountsDiscountTriggerAnd({}, pickedFields.get('and'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customTrigger')) {
        result.customTrigger = overrides && overrides.hasOwnProperty('customTrigger') ? aComWixEcomDiscountsDiscountTriggerCustom(overrides.customTrigger ?? {}, pickedFields.get('customTrigger')) : aComWixEcomDiscountsDiscountTriggerCustom({}, pickedFields.get('customTrigger'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemQuantityRange')) {
        result.itemQuantityRange = overrides && overrides.hasOwnProperty('itemQuantityRange') ? aComWixEcomDiscountsDiscountTriggerItemQuantityRange(overrides.itemQuantityRange ?? {}, pickedFields.get('itemQuantityRange')) : aComWixEcomDiscountsDiscountTriggerItemQuantityRange({}, pickedFields.get('itemQuantityRange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('or')) {
        result.or = overrides && overrides.hasOwnProperty('or') ? aComWixEcomDiscountsDiscountTriggerOr(overrides.or ?? {}, pickedFields.get('or')) : aComWixEcomDiscountsDiscountTriggerOr({}, pickedFields.get('or'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotalRange')) {
        result.subtotalRange = overrides && overrides.hasOwnProperty('subtotalRange') ? aComWixEcomDiscountsDiscountTriggerSubtotalRange(overrides.subtotalRange ?? {}, pickedFields.get('subtotalRange')) : aComWixEcomDiscountsDiscountTriggerSubtotalRange({}, pickedFields.get('subtotalRange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('triggerType')) {
        result.triggerType = overrides && overrides.hasOwnProperty('triggerType') ? overrides.triggerType! : ComWixEcomDiscountsDiscountTriggerTriggerType.And;
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTriggerAnd = <T extends Partial<ComWixEcomDiscountsDiscountTriggerAnd>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('triggers')) {
        result.triggers = overrides && overrides.hasOwnProperty('triggers') ? overrides.triggers!.map((x) => aComWixEcomDiscountsDiscountTrigger(x ?? {}, pickedFields.get('triggers'))) : [aComWixEcomDiscountsDiscountTrigger({}, pickedFields.get('triggers'))];
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTriggerAndInput = <T extends Partial<ComWixEcomDiscountsDiscountTriggerAndInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('triggers')) {
        result.triggers = overrides && overrides.hasOwnProperty('triggers') ? overrides.triggers!.map((x) => aComWixEcomDiscountsDiscountTriggerInput({}, pickedFields.get('triggers'))) : [aComWixEcomDiscountsDiscountTriggerInput({}, pickedFields.get('triggers'))];
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTriggerCustom = <T extends Partial<ComWixEcomDiscountsDiscountTriggerCustom>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('params')) {
        result.params = overrides && overrides.hasOwnProperty('params') ? overrides.params! : 'omnis';
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTriggerCustomInput = <T extends Partial<ComWixEcomDiscountsDiscountTriggerCustomInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('params')) {
        result.params = overrides && overrides.hasOwnProperty('params') ? overrides.params! : 'debitis';
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTriggerInput = <T extends Partial<ComWixEcomDiscountsDiscountTriggerInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('and')) {
        result.and = overrides && overrides.hasOwnProperty('and') ? aComWixEcomDiscountsDiscountTriggerAndInput(overrides.and ?? {}, pickedFields.get('and')) : aComWixEcomDiscountsDiscountTriggerAndInput({}, pickedFields.get('and'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customTrigger')) {
        result.customTrigger = overrides && overrides.hasOwnProperty('customTrigger') ? aComWixEcomDiscountsDiscountTriggerCustomInput(overrides.customTrigger ?? {}, pickedFields.get('customTrigger')) : aComWixEcomDiscountsDiscountTriggerCustomInput({}, pickedFields.get('customTrigger'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemQuantityRange')) {
        result.itemQuantityRange = overrides && overrides.hasOwnProperty('itemQuantityRange') ? aComWixEcomDiscountsDiscountTriggerItemQuantityRangeInput(overrides.itemQuantityRange ?? {}, pickedFields.get('itemQuantityRange')) : aComWixEcomDiscountsDiscountTriggerItemQuantityRangeInput({}, pickedFields.get('itemQuantityRange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('or')) {
        result.or = overrides && overrides.hasOwnProperty('or') ? aComWixEcomDiscountsDiscountTriggerOrInput(overrides.or ?? {}, pickedFields.get('or')) : aComWixEcomDiscountsDiscountTriggerOrInput({}, pickedFields.get('or'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotalRange')) {
        result.subtotalRange = overrides && overrides.hasOwnProperty('subtotalRange') ? aComWixEcomDiscountsDiscountTriggerSubtotalRangeInput(overrides.subtotalRange ?? {}, pickedFields.get('subtotalRange')) : aComWixEcomDiscountsDiscountTriggerSubtotalRangeInput({}, pickedFields.get('subtotalRange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('triggerType')) {
        result.triggerType = overrides && overrides.hasOwnProperty('triggerType') ? overrides.triggerType! : ComWixEcomDiscountsDiscountTriggerTriggerType.And;
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTriggerItemQuantityRange = <T extends Partial<ComWixEcomDiscountsDiscountTriggerItemQuantityRange>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 9528;
    }
    if (pickedFields.size === 0 || pickedFields.has('scopes')) {
        result.scopes = overrides && overrides.hasOwnProperty('scopes') ? overrides.scopes!.map((x) => aComWixEcomDiscountsScope(x ?? {}, pickedFields.get('scopes'))) : [aComWixEcomDiscountsScope({}, pickedFields.get('scopes'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 5245;
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTriggerItemQuantityRangeInput = <T extends Partial<ComWixEcomDiscountsDiscountTriggerItemQuantityRangeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 8603;
    }
    if (pickedFields.size === 0 || pickedFields.has('scopes')) {
        result.scopes = overrides && overrides.hasOwnProperty('scopes') ? overrides.scopes!.map((x) => aComWixEcomDiscountsScopeInput({}, pickedFields.get('scopes'))) : [aComWixEcomDiscountsScopeInput({}, pickedFields.get('scopes'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 1834;
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTriggerOr = <T extends Partial<ComWixEcomDiscountsDiscountTriggerOr>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('triggers')) {
        result.triggers = overrides && overrides.hasOwnProperty('triggers') ? overrides.triggers!.map((x) => aComWixEcomDiscountsDiscountTrigger(x ?? {}, pickedFields.get('triggers'))) : [aComWixEcomDiscountsDiscountTrigger({}, pickedFields.get('triggers'))];
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTriggerOrInput = <T extends Partial<ComWixEcomDiscountsDiscountTriggerOrInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('triggers')) {
        result.triggers = overrides && overrides.hasOwnProperty('triggers') ? overrides.triggers!.map((x) => aComWixEcomDiscountsDiscountTriggerInput({}, pickedFields.get('triggers'))) : [aComWixEcomDiscountsDiscountTriggerInput({}, pickedFields.get('triggers'))];
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTriggerSubtotalRange = <T extends Partial<ComWixEcomDiscountsDiscountTriggerSubtotalRange>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 'natus';
    }
    if (pickedFields.size === 0 || pickedFields.has('scopes')) {
        result.scopes = overrides && overrides.hasOwnProperty('scopes') ? overrides.scopes!.map((x) => aComWixEcomDiscountsScope(x ?? {}, pickedFields.get('scopes'))) : [aComWixEcomDiscountsScope({}, pickedFields.get('scopes'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 'eos';
    }

    return result;
};

export const aComWixEcomDiscountsDiscountTriggerSubtotalRangeInput = <T extends Partial<ComWixEcomDiscountsDiscountTriggerSubtotalRangeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('scopes')) {
        result.scopes = overrides && overrides.hasOwnProperty('scopes') ? overrides.scopes!.map((x) => aComWixEcomDiscountsScopeInput({}, pickedFields.get('scopes'))) : [aComWixEcomDiscountsScopeInput({}, pickedFields.get('scopes'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 'aut';
    }

    return result;
};

export const aComWixEcomDiscountsDiscounts = <T extends Partial<ComWixEcomDiscountsDiscounts>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values!.map((x) => aComWixEcomDiscountsDiscount(x ?? {}, pickedFields.get('values'))) : [aComWixEcomDiscountsDiscount({}, pickedFields.get('values'))];
    }

    return result;
};

export const aComWixEcomDiscountsDiscountsInput = <T extends Partial<ComWixEcomDiscountsDiscountsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values!.map((x) => aComWixEcomDiscountsDiscountInput({}, pickedFields.get('values'))) : [aComWixEcomDiscountsDiscountInput({}, pickedFields.get('values'))];
    }

    return result;
};

export const aComWixEcomDiscountsGetAppliedDiscountsRequestInput = <T extends Partial<ComWixEcomDiscountsGetAppliedDiscountsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomDiscountsLineItemInput({}, pickedFields.get('lineItems'))) : [aComWixEcomDiscountsLineItemInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('purchaseFlowId')) {
        result.purchaseFlowId = overrides && overrides.hasOwnProperty('purchaseFlowId') ? overrides.purchaseFlowId! : 'sunt';
    }

    return result;
};

export const aComWixEcomDiscountsGetAppliedDiscountsResponse = <T extends Partial<ComWixEcomDiscountsGetAppliedDiscountsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appliedDiscounts')) {
        result.appliedDiscounts = overrides && overrides.hasOwnProperty('appliedDiscounts') ? overrides.appliedDiscounts!.map((x) => aComWixEcomDiscountsAppliedDiscount(x ?? {}, pickedFields.get('appliedDiscounts'))) : [aComWixEcomDiscountsAppliedDiscount({}, pickedFields.get('appliedDiscounts'))];
    }

    return result;
};

export const aComWixEcomDiscountsGetDiscountRuleRequestInput = <T extends Partial<ComWixEcomDiscountsGetDiscountRuleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '995fb81e-c952-4f27-b400-ee6feb0ea301';
    }

    return result;
};

export const aComWixEcomDiscountsLineItemInput = <T extends Partial<ComWixEcomDiscountsLineItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('catalogReference')) {
        result.catalogReference = overrides && overrides.hasOwnProperty('catalogReference') ? aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput(overrides.catalogReference ?? {}, pickedFields.get('catalogReference')) : aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput({}, pickedFields.get('catalogReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 552;
    }

    return result;
};

export const aComWixEcomDiscountsQueryDiscountRulesRequestInput = <T extends Partial<ComWixEcomDiscountsQueryDiscountRulesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixEcommerceCommonsApiPlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixEcommerceCommonsApiPlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixEcomDiscountsQueryDiscountRulesResponse = <T extends Partial<ComWixEcomDiscountsQueryDiscountRulesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixEcomDiscountsDiscountRule(x ?? {}, pickedFields.get('items'))) : [aComWixEcomDiscountsDiscountRule({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixEcomDiscountsScope = <T extends Partial<ComWixEcomDiscountsScope>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('catalogItemFilter')) {
        result.catalogItemFilter = overrides && overrides.hasOwnProperty('catalogItemFilter') ? aComWixEcomDiscountsCatalogItemFilter(overrides.catalogItemFilter ?? {}, pickedFields.get('catalogItemFilter')) : aComWixEcomDiscountsCatalogItemFilter({}, pickedFields.get('catalogItemFilter'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customFilter')) {
        result.customFilter = overrides && overrides.hasOwnProperty('customFilter') ? aComWixEcomDiscountsCustomFilter(overrides.customFilter ?? {}, pickedFields.get('customFilter')) : aComWixEcomDiscountsCustomFilter({}, pickedFields.get('customFilter'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcomDiscountsScopeType.CatalogItem;
    }

    return result;
};

export const aComWixEcomDiscountsScopeInput = <T extends Partial<ComWixEcomDiscountsScopeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('catalogItemFilter')) {
        result.catalogItemFilter = overrides && overrides.hasOwnProperty('catalogItemFilter') ? aComWixEcomDiscountsCatalogItemFilterInput(overrides.catalogItemFilter ?? {}, pickedFields.get('catalogItemFilter')) : aComWixEcomDiscountsCatalogItemFilterInput({}, pickedFields.get('catalogItemFilter'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customFilter')) {
        result.customFilter = overrides && overrides.hasOwnProperty('customFilter') ? aComWixEcomDiscountsCustomFilterInput(overrides.customFilter ?? {}, pickedFields.get('customFilter')) : aComWixEcomDiscountsCustomFilterInput({}, pickedFields.get('customFilter'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcomDiscountsScopeType.CatalogItem;
    }

    return result;
};

export const aComWixEcomDiscountsSpecificItemsInfo = <T extends Partial<ComWixEcomDiscountsSpecificItemsInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 4551;
    }
    if (pickedFields.size === 0 || pickedFields.has('scopes')) {
        result.scopes = overrides && overrides.hasOwnProperty('scopes') ? overrides.scopes!.map((x) => aComWixEcomDiscountsScope(x ?? {}, pickedFields.get('scopes'))) : [aComWixEcomDiscountsScope({}, pickedFields.get('scopes'))];
    }

    return result;
};

export const aComWixEcomDiscountsSpecificItemsInfoInput = <T extends Partial<ComWixEcomDiscountsSpecificItemsInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 8112;
    }
    if (pickedFields.size === 0 || pickedFields.has('scopes')) {
        result.scopes = overrides && overrides.hasOwnProperty('scopes') ? overrides.scopes!.map((x) => aComWixEcomDiscountsScopeInput({}, pickedFields.get('scopes'))) : [aComWixEcomDiscountsScopeInput({}, pickedFields.get('scopes'))];
    }

    return result;
};

export const aComWixEcomDiscountsUpdateDiscountRuleRequestInput = <T extends Partial<ComWixEcomDiscountsUpdateDiscountRuleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discountRule')) {
        result.discountRule = overrides && overrides.hasOwnProperty('discountRule') ? aComWixEcomDiscountsDiscountRuleInput(overrides.discountRule ?? {}, pickedFields.get('discountRule')) : aComWixEcomDiscountsDiscountRuleInput({}, pickedFields.get('discountRule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['veritatis'];
    }

    return result;
};

export const aComWixEcomDiscountsUpdateDiscountRuleResponse = <T extends Partial<ComWixEcomDiscountsUpdateDiscountRuleResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discountRule')) {
        result.discountRule = overrides && overrides.hasOwnProperty('discountRule') ? aComWixEcomDiscountsDiscountRule(overrides.discountRule ?? {}, pickedFields.get('discountRule')) : aComWixEcomDiscountsDiscountRule({}, pickedFields.get('discountRule'));
    }

    return result;
};

export const aComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem = <T extends Partial<ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('overriddenDescriptionLines')) {
        result.overriddenDescriptionLines = overrides && overrides.hasOwnProperty('overriddenDescriptionLines') ? aComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines(overrides.overriddenDescriptionLines ?? {}, pickedFields.get('overriddenDescriptionLines')) : aComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines({}, pickedFields.get('overriddenDescriptionLines'));
    }
    if (pickedFields.size === 0 || pickedFields.has('renderingConfig')) {
        result.renderingConfig = overrides && overrides.hasOwnProperty('renderingConfig') ? aComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig(overrides.renderingConfig ?? {}, pickedFields.get('renderingConfig')) : aComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig({}, pickedFields.get('renderingConfig'));
    }

    return result;
};

export const aComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItemWithActions = <T extends Partial<ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItemWithActions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('actions')) {
        result.actions = overrides && overrides.hasOwnProperty('actions') ? overrides.actions!.map((x) => aComWixEcomLineItemsEnricherSpiApiV1LineItemAction(x ?? {}, pickedFields.get('actions'))) : [aComWixEcomLineItemsEnricherSpiApiV1LineItemAction({}, pickedFields.get('actions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('overriddenDescriptionLines')) {
        result.overriddenDescriptionLines = overrides && overrides.hasOwnProperty('overriddenDescriptionLines') ? aComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines(overrides.overriddenDescriptionLines ?? {}, pickedFields.get('overriddenDescriptionLines')) : aComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines({}, pickedFields.get('overriddenDescriptionLines'));
    }
    if (pickedFields.size === 0 || pickedFields.has('renderingConfig')) {
        result.renderingConfig = overrides && overrides.hasOwnProperty('renderingConfig') ? aComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig(overrides.renderingConfig ?? {}, pickedFields.get('renderingConfig')) : aComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig({}, pickedFields.get('renderingConfig'));
    }

    return result;
};

export const aComWixEcomLineItemsEnricherSpiApiV1LineItemAction = <T extends Partial<ComWixEcomLineItemsEnricherSpiApiV1LineItemAction>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('actionId')) {
        result.actionId = overrides && overrides.hasOwnProperty('actionId') ? overrides.actionId! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('actionParameters')) {
        result.actionParameters = overrides && overrides.hasOwnProperty('actionParameters') ? overrides.actionParameters! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('settingsKey')) {
        result.settingsKey = overrides && overrides.hasOwnProperty('settingsKey') ? overrides.settingsKey! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'voluptatem';
    }

    return result;
};

export const aComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig = <T extends Partial<ComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hidePrice')) {
        result.hidePrice = overrides && overrides.hasOwnProperty('hidePrice') ? overrides.hidePrice! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('hideQuantity')) {
        result.hideQuantity = overrides && overrides.hasOwnProperty('hideQuantity') ? overrides.hideQuantity! : true;
    }

    return result;
};

export const aComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines = <T extends Partial<ComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLine(x ?? {}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLine({}, pickedFields.get('descriptionLines'))];
    }

    return result;
};

export const aComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForCheckoutResponse = <T extends Partial<ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForCheckoutResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enrichedLineItems')) {
        result.enrichedLineItems = overrides && overrides.hasOwnProperty('enrichedLineItems') ? overrides.enrichedLineItems!.map((x) => aComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem(x ?? {}, pickedFields.get('enrichedLineItems'))) : [aComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem({}, pickedFields.get('enrichedLineItems'))];
    }

    return result;
};

export const aComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForOrderPageResponse = <T extends Partial<ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForOrderPageResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enrichedLineItems')) {
        result.enrichedLineItems = overrides && overrides.hasOwnProperty('enrichedLineItems') ? overrides.enrichedLineItems!.map((x) => aComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem(x ?? {}, pickedFields.get('enrichedLineItems'))) : [aComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem({}, pickedFields.get('enrichedLineItems'))];
    }

    return result;
};

export const aComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForThankYouPageResponse = <T extends Partial<ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForThankYouPageResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enrichedLineItems')) {
        result.enrichedLineItems = overrides && overrides.hasOwnProperty('enrichedLineItems') ? overrides.enrichedLineItems!.map((x) => aComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItemWithActions(x ?? {}, pickedFields.get('enrichedLineItems'))) : [aComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItemWithActions({}, pickedFields.get('enrichedLineItems'))];
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1HostInvalidMembership = <T extends Partial<ComWixEcomMembershipsSpiV1HostInvalidMembership>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('membership')) {
        result.membership = overrides && overrides.hasOwnProperty('membership') ? aComWixEcomMembershipsSpiV1HostMembership(overrides.membership ?? {}, pickedFields.get('membership')) : aComWixEcomMembershipsSpiV1HostMembership({}, pickedFields.get('membership'));
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'culpa';
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1HostInvalidMembershipInput = <T extends Partial<ComWixEcomMembershipsSpiV1HostInvalidMembershipInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('membership')) {
        result.membership = overrides && overrides.hasOwnProperty('membership') ? aComWixEcomMembershipsSpiV1HostMembershipInput(overrides.membership ?? {}, pickedFields.get('membership')) : aComWixEcomMembershipsSpiV1HostMembershipInput({}, pickedFields.get('membership'));
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'qui';
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1HostMembership = <T extends Partial<ComWixEcomMembershipsSpiV1HostMembership>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalData')) {
        result.additionalData = overrides && overrides.hasOwnProperty('additionalData') ? overrides.additionalData! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('credits')) {
        result.credits = overrides && overrides.hasOwnProperty('credits') ? aComWixEcomMembershipsSpiV1MembershipPaymentCredits(overrides.credits ?? {}, pickedFields.get('credits')) : aComWixEcomMembershipsSpiV1MembershipPaymentCredits({}, pickedFields.get('credits'));
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationDate')) {
        result.expirationDate = overrides && overrides.hasOwnProperty('expirationDate') ? overrides.expirationDate! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['qui'];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomMembershipsSpiV1MembershipName(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomMembershipsSpiV1MembershipName({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1HostMembershipInput = <T extends Partial<ComWixEcomMembershipsSpiV1HostMembershipInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalData')) {
        result.additionalData = overrides && overrides.hasOwnProperty('additionalData') ? overrides.additionalData! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('credits')) {
        result.credits = overrides && overrides.hasOwnProperty('credits') ? aComWixEcomMembershipsSpiV1MembershipPaymentCreditsInput(overrides.credits ?? {}, pickedFields.get('credits')) : aComWixEcomMembershipsSpiV1MembershipPaymentCreditsInput({}, pickedFields.get('credits'));
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationDate')) {
        result.expirationDate = overrides && overrides.hasOwnProperty('expirationDate') ? overrides.expirationDate! : 'hic';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['dolorem'];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomMembershipsSpiV1MembershipNameInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomMembershipsSpiV1MembershipNameInput({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1HostSelectedMembership = <T extends Partial<ComWixEcomMembershipsSpiV1HostSelectedMembership>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['dignissimos'];
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1HostSelectedMembershipInput = <T extends Partial<ComWixEcomMembershipsSpiV1HostSelectedMembershipInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['quibusdam'];
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1HostSelectedMemberships = <T extends Partial<ComWixEcomMembershipsSpiV1HostSelectedMemberships>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('memberships')) {
        result.memberships = overrides && overrides.hasOwnProperty('memberships') ? overrides.memberships!.map((x) => aComWixEcomMembershipsSpiV1HostSelectedMembership(x ?? {}, pickedFields.get('memberships'))) : [aComWixEcomMembershipsSpiV1HostSelectedMembership({}, pickedFields.get('memberships'))];
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1HostSelectedMembershipsInput = <T extends Partial<ComWixEcomMembershipsSpiV1HostSelectedMembershipsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('memberships')) {
        result.memberships = overrides && overrides.hasOwnProperty('memberships') ? overrides.memberships!.map((x) => aComWixEcomMembershipsSpiV1HostSelectedMembershipInput({}, pickedFields.get('memberships'))) : [aComWixEcomMembershipsSpiV1HostSelectedMembershipInput({}, pickedFields.get('memberships'))];
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1MembershipName = <T extends Partial<ComWixEcomMembershipsSpiV1MembershipName>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'dolor';
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1MembershipNameInput = <T extends Partial<ComWixEcomMembershipsSpiV1MembershipNameInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'et';
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1MembershipPaymentCredits = <T extends Partial<ComWixEcomMembershipsSpiV1MembershipPaymentCredits>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('remaining')) {
        result.remaining = overrides && overrides.hasOwnProperty('remaining') ? overrides.remaining! : 3005;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 4314;
    }

    return result;
};

export const aComWixEcomMembershipsSpiV1MembershipPaymentCreditsInput = <T extends Partial<ComWixEcomMembershipsSpiV1MembershipPaymentCreditsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('remaining')) {
        result.remaining = overrides && overrides.hasOwnProperty('remaining') ? overrides.remaining! : 2577;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 7626;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1AdditionalFeeRefund = <T extends Partial<ComWixEcomOrdersBillingV1AdditionalFeeRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeId')) {
        result.additionalFeeId = overrides && overrides.hasOwnProperty('additionalFeeId') ? overrides.additionalFeeId! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1AdditionalFeeRefundInput = <T extends Partial<ComWixEcomOrdersBillingV1AdditionalFeeRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeId')) {
        result.additionalFeeId = overrides && overrides.hasOwnProperty('additionalFeeId') ? overrides.additionalFeeId! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1AdditionalFeeRefundOption = <T extends Partial<ComWixEcomOrdersBillingV1AdditionalFeeRefundOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeId')) {
        result.additionalFeeId = overrides && overrides.hasOwnProperty('additionalFeeId') ? overrides.additionalFeeId! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('availableRefundAmount')) {
        result.availableRefundAmount = overrides && overrides.hasOwnProperty('availableRefundAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.availableRefundAmount ?? {}, pickedFields.get('availableRefundAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('availableRefundAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedAmount')) {
        result.refundedAmount = overrides && overrides.hasOwnProperty('refundedAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.refundedAmount ?? {}, pickedFields.get('refundedAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refundedAmount'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1AdditionalFeeRefundability = <T extends Partial<ComWixEcomOrdersBillingV1AdditionalFeeRefundability>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeId')) {
        result.additionalFeeId = overrides && overrides.hasOwnProperty('additionalFeeId') ? overrides.additionalFeeId! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('availableRefundAmount')) {
        result.availableRefundAmount = overrides && overrides.hasOwnProperty('availableRefundAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.availableRefundAmount ?? {}, pickedFields.get('availableRefundAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('availableRefundAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedAmount')) {
        result.refundedAmount = overrides && overrides.hasOwnProperty('refundedAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.refundedAmount ?? {}, pickedFields.get('refundedAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refundedAmount'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1AggregatedRefundSummary = <T extends Partial<ComWixEcomOrdersBillingV1AggregatedRefundSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeesTotal')) {
        result.additionalFeesTotal = overrides && overrides.hasOwnProperty('additionalFeesTotal') ? aComWixEcommercePlatformCommonApiPrice(overrides.additionalFeesTotal ?? {}, pickedFields.get('additionalFeesTotal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('additionalFeesTotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiPrice(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemsSubtotal')) {
        result.lineItemsSubtotal = overrides && overrides.hasOwnProperty('lineItemsSubtotal') ? aComWixEcommercePlatformCommonApiPrice(overrides.lineItemsSubtotal ?? {}, pickedFields.get('lineItemsSubtotal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('lineItemsSubtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixEcommercePlatformCommonApiPrice(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiPrice(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiPrice(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodRequestInput = <T extends Partial<ComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('delayedCaptureSettings')) {
        result.delayedCaptureSettings = overrides && overrides.hasOwnProperty('delayedCaptureSettings') ? aComWixEcomOrdersBillingV1DelayedCaptureSettingsInput(overrides.delayedCaptureSettings ?? {}, pickedFields.get('delayedCaptureSettings')) : aComWixEcomOrdersBillingV1DelayedCaptureSettingsInput({}, pickedFields.get('delayedCaptureSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'velit';
    }

    return result;
};

export const aComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodResponse = <T extends Partial<ComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aComWixEcomOrdersPaymentsV1Payment(overrides.payment ?? {}, pickedFields.get('payment')) : aComWixEcomOrdersPaymentsV1Payment({}, pickedFields.get('payment'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodRequestInput = <T extends Partial<ComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('delayedCaptureSettings')) {
        result.delayedCaptureSettings = overrides && overrides.hasOwnProperty('delayedCaptureSettings') ? aComWixEcomOrdersBillingV1DelayedCaptureSettingsInput(overrides.delayedCaptureSettings ?? {}, pickedFields.get('delayedCaptureSettings')) : aComWixEcomOrdersBillingV1DelayedCaptureSettingsInput({}, pickedFields.get('delayedCaptureSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'maiores';
    }

    return result;
};

export const aComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodResponse = <T extends Partial<ComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aComWixEcomOrdersPaymentsV1Payment(overrides.payment ?? {}, pickedFields.get('payment')) : aComWixEcomOrdersPaymentsV1Payment({}, pickedFields.get('payment'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1CalculateRefundRequestInput = <T extends Partial<ComWixEcomOrdersBillingV1CalculateRefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundItems')) {
        result.refundItems = overrides && overrides.hasOwnProperty('refundItems') ? aComWixEcomOrdersBillingV1RefundItemsInput(overrides.refundItems ?? {}, pickedFields.get('refundItems')) : aComWixEcomOrdersBillingV1RefundItemsInput({}, pickedFields.get('refundItems'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1CalculateRefundResponse = <T extends Partial<ComWixEcomOrdersBillingV1CalculateRefundResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('available')) {
        result.available = overrides && overrides.hasOwnProperty('available') ? overrides.available! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('calculatedRefundItems')) {
        result.calculatedRefundItems = overrides && overrides.hasOwnProperty('calculatedRefundItems') ? aComWixEcomOrdersBillingV1CalculatedRefundItems(overrides.calculatedRefundItems ?? {}, pickedFields.get('calculatedRefundItems')) : aComWixEcomOrdersBillingV1CalculatedRefundItems({}, pickedFields.get('calculatedRefundItems'));
    }
    if (pickedFields.size === 0 || pickedFields.has('notAvailable')) {
        result.notAvailable = overrides && overrides.hasOwnProperty('notAvailable') ? aComWixEcomOrdersBillingV1CalculatedRefundNotAvailableStatus(overrides.notAvailable ?? {}, pickedFields.get('notAvailable')) : aComWixEcomOrdersBillingV1CalculatedRefundNotAvailableStatus({}, pickedFields.get('notAvailable'));
    }
    if (pickedFields.size === 0 || pickedFields.has('summary')) {
        result.summary = overrides && overrides.hasOwnProperty('summary') ? aComWixEcomOrdersBillingV1AggregatedRefundSummary(overrides.summary ?? {}, pickedFields.get('summary')) : aComWixEcomOrdersBillingV1AggregatedRefundSummary({}, pickedFields.get('summary'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1CalculatedAdditionalFeeRefund = <T extends Partial<ComWixEcomOrdersBillingV1CalculatedAdditionalFeeRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFee')) {
        result.additionalFee = overrides && overrides.hasOwnProperty('additionalFee') ? aComWixEcomOrdersBillingV1AdditionalFeeRefund(overrides.additionalFee ?? {}, pickedFields.get('additionalFee')) : aComWixEcomOrdersBillingV1AdditionalFeeRefund({}, pickedFields.get('additionalFee'));
    }
    if (pickedFields.size === 0 || pickedFields.has('summary')) {
        result.summary = overrides && overrides.hasOwnProperty('summary') ? aComWixEcomOrdersBillingV1CalculatedRefundSummary(overrides.summary ?? {}, pickedFields.get('summary')) : aComWixEcomOrdersBillingV1CalculatedRefundSummary({}, pickedFields.get('summary'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1CalculatedLineItemRefund = <T extends Partial<ComWixEcomOrdersBillingV1CalculatedLineItemRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixEcomOrdersBillingV1LineItemRefund(overrides.item ?? {}, pickedFields.get('item')) : aComWixEcomOrdersBillingV1LineItemRefund({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('summary')) {
        result.summary = overrides && overrides.hasOwnProperty('summary') ? aComWixEcomOrdersBillingV1CalculatedRefundSummary(overrides.summary ?? {}, pickedFields.get('summary')) : aComWixEcomOrdersBillingV1CalculatedRefundSummary({}, pickedFields.get('summary'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1CalculatedRefundItems = <T extends Partial<ComWixEcomOrdersBillingV1CalculatedRefundItems>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomOrdersBillingV1CalculatedAdditionalFeeRefund(x ?? {}, pickedFields.get('additionalFees'))) : [aComWixEcomOrdersBillingV1CalculatedAdditionalFeeRefund({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersBillingV1CalculatedLineItemRefund(x ?? {}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersBillingV1CalculatedLineItemRefund({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcomOrdersBillingV1CalculatedShippingRefund(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcomOrdersBillingV1CalculatedShippingRefund({}, pickedFields.get('shipping'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1CalculatedRefundNotAvailableStatus = <T extends Partial<ComWixEcomOrdersBillingV1CalculatedRefundNotAvailableStatus>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errors')) {
        result.errors = overrides && overrides.hasOwnProperty('errors') ? overrides.errors!.map((x) => aComWixEcomOrdersBillingV1CalculationError(x ?? {}, pickedFields.get('errors'))) : [aComWixEcomOrdersBillingV1CalculationError({}, pickedFields.get('errors'))];
    }

    return result;
};

export const aComWixEcomOrdersBillingV1CalculatedRefundSummary = <T extends Partial<ComWixEcomOrdersBillingV1CalculatedRefundSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiPrice(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixEcommercePlatformCommonApiPrice(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiPrice(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiPrice(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1CalculatedShippingRefund = <T extends Partial<ComWixEcomOrdersBillingV1CalculatedShippingRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcomOrdersBillingV1ShippingRefund(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcomOrdersBillingV1ShippingRefund({}, pickedFields.get('shipping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('summary')) {
        result.summary = overrides && overrides.hasOwnProperty('summary') ? aComWixEcomOrdersBillingV1CalculatedRefundSummary(overrides.summary ?? {}, pickedFields.get('summary')) : aComWixEcomOrdersBillingV1CalculatedRefundSummary({}, pickedFields.get('summary'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1CalculationError = <T extends Partial<ComWixEcomOrdersBillingV1CalculationError>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFee')) {
        result.additionalFee = overrides && overrides.hasOwnProperty('additionalFee') ? aComWixEcomOrdersBillingV1AdditionalFeeRefund(overrides.additionalFee ?? {}, pickedFields.get('additionalFee')) : aComWixEcomOrdersBillingV1AdditionalFeeRefund({}, pickedFields.get('additionalFee'));
    }
    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiDetails(overrides.error ?? {}, pickedFields.get('error')) : aWixApiDetails({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItem')) {
        result.lineItem = overrides && overrides.hasOwnProperty('lineItem') ? aComWixEcomOrdersBillingV1LineItemRefund(overrides.lineItem ?? {}, pickedFields.get('lineItem')) : aComWixEcomOrdersBillingV1LineItemRefund({}, pickedFields.get('lineItem'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcomOrdersBillingV1ShippingRefund(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcomOrdersBillingV1ShippingRefund({}, pickedFields.get('shipping'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsRequestInput = <T extends Partial<ComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? overrides.payments!.map((x) => aComWixEcomOrdersBillingV1PaymentCaptureInput({}, pickedFields.get('payments'))) : [aComWixEcomOrdersBillingV1PaymentCaptureInput({}, pickedFields.get('payments'))];
    }

    return result;
};

export const aComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsResponse = <T extends Partial<ComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1DelayedCaptureSettingsInput = <T extends Partial<ComWixEcomOrdersBillingV1DelayedCaptureSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('delayDuration')) {
        result.delayDuration = overrides && overrides.hasOwnProperty('delayDuration') ? aComWixEcommercePlatformCommonApiDurationInput(overrides.delayDuration ?? {}, pickedFields.get('delayDuration')) : aComWixEcommercePlatformCommonApiDurationInput({}, pickedFields.get('delayDuration'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduledAction')) {
        result.scheduledAction = overrides && overrides.hasOwnProperty('scheduledAction') ? overrides.scheduledAction! : ComWixEcomOrdersBillingV1DelayedCaptureSettingsScheduledAction.Capture;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1GenerateReceiptsRequestInput = <T extends Partial<ComWixEcomOrdersBillingV1GenerateReceiptsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentIds')) {
        result.paymentIds = overrides && overrides.hasOwnProperty('paymentIds') ? overrides.paymentIds! : ['harum'];
    }

    return result;
};

export const aComWixEcomOrdersBillingV1GenerateReceiptsResponse = <T extends Partial<ComWixEcomOrdersBillingV1GenerateReceiptsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('receipts')) {
        result.receipts = overrides && overrides.hasOwnProperty('receipts') ? overrides.receipts!.map((x) => aComWixEcomOrdersBillingV1ReceiptInfo(x ?? {}, pickedFields.get('receipts'))) : [aComWixEcomOrdersBillingV1ReceiptInfo({}, pickedFields.get('receipts'))];
    }

    return result;
};

export const aComWixEcomOrdersBillingV1GetOrderRefundabilityRequestInput = <T extends Partial<ComWixEcomOrdersBillingV1GetOrderRefundabilityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'vel';
    }

    return result;
};

export const aComWixEcomOrdersBillingV1GetOrderRefundabilityResponse = <T extends Partial<ComWixEcomOrdersBillingV1GetOrderRefundabilityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomOrdersBillingV1AdditionalFeeRefundability(x ?? {}, pickedFields.get('additionalFees'))) : [aComWixEcomOrdersBillingV1AdditionalFeeRefundability({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersBillingV1LineItemRefundability(x ?? {}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersBillingV1LineItemRefundability({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? overrides.payments!.map((x) => aComWixEcomOrdersBillingV1PaymentRefundability(x ?? {}, pickedFields.get('payments'))) : [aComWixEcomOrdersBillingV1PaymentRefundability({}, pickedFields.get('payments'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentsSummary')) {
        result.paymentsSummary = overrides && overrides.hasOwnProperty('paymentsSummary') ? aComWixEcomOrdersBillingV1PaymentsSummary(overrides.paymentsSummary ?? {}, pickedFields.get('paymentsSummary')) : aComWixEcomOrdersBillingV1PaymentsSummary({}, pickedFields.get('paymentsSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcomOrdersBillingV1ShippingRefundability(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcomOrdersBillingV1ShippingRefundability({}, pickedFields.get('shipping'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1GetRefundOptionsRequestInput = <T extends Partial<ComWixEcomOrdersBillingV1GetRefundOptionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'rem';
    }

    return result;
};

export const aComWixEcomOrdersBillingV1GetRefundOptionsResponse = <T extends Partial<ComWixEcomOrdersBillingV1GetRefundOptionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeRefundOptions')) {
        result.additionalFeeRefundOptions = overrides && overrides.hasOwnProperty('additionalFeeRefundOptions') ? overrides.additionalFeeRefundOptions!.map((x) => aComWixEcomOrdersBillingV1AdditionalFeeRefundOption(x ?? {}, pickedFields.get('additionalFeeRefundOptions'))) : [aComWixEcomOrdersBillingV1AdditionalFeeRefundOption({}, pickedFields.get('additionalFeeRefundOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemRefundOptions')) {
        result.lineItemRefundOptions = overrides && overrides.hasOwnProperty('lineItemRefundOptions') ? overrides.lineItemRefundOptions!.map((x) => aComWixEcomOrdersBillingV1LineItemRefundOption(x ?? {}, pickedFields.get('lineItemRefundOptions'))) : [aComWixEcomOrdersBillingV1LineItemRefundOption({}, pickedFields.get('lineItemRefundOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRefundOptions')) {
        result.paymentRefundOptions = overrides && overrides.hasOwnProperty('paymentRefundOptions') ? overrides.paymentRefundOptions!.map((x) => aComWixEcomOrdersBillingV1PaymentRefundOption(x ?? {}, pickedFields.get('paymentRefundOptions'))) : [aComWixEcomOrdersBillingV1PaymentRefundOption({}, pickedFields.get('paymentRefundOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentsSummary')) {
        result.paymentsSummary = overrides && overrides.hasOwnProperty('paymentsSummary') ? aComWixEcomOrdersBillingV1PaymentsSummary(overrides.paymentsSummary ?? {}, pickedFields.get('paymentsSummary')) : aComWixEcomOrdersBillingV1PaymentsSummary({}, pickedFields.get('paymentsSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingRefundOption')) {
        result.shippingRefundOption = overrides && overrides.hasOwnProperty('shippingRefundOption') ? aComWixEcomOrdersBillingV1ShippingRefundOption(overrides.shippingRefundOption ?? {}, pickedFields.get('shippingRefundOption')) : aComWixEcomOrdersBillingV1ShippingRefundOption({}, pickedFields.get('shippingRefundOption'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1LineItemRefund = <T extends Partial<ComWixEcomOrdersBillingV1LineItemRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 3213;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1LineItemRefundInput = <T extends Partial<ComWixEcomOrdersBillingV1LineItemRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 7087;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1LineItemRefundOption = <T extends Partial<ComWixEcomOrdersBillingV1LineItemRefundOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availableRefundQuantity')) {
        result.availableRefundQuantity = overrides && overrides.hasOwnProperty('availableRefundQuantity') ? overrides.availableRefundQuantity! : 8552;
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalQuantity')) {
        result.originalQuantity = overrides && overrides.hasOwnProperty('originalQuantity') ? overrides.originalQuantity! : 9756;
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedQuantity')) {
        result.refundedQuantity = overrides && overrides.hasOwnProperty('refundedQuantity') ? overrides.refundedQuantity! : 6163;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1LineItemRefundability = <T extends Partial<ComWixEcomOrdersBillingV1LineItemRefundability>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availableRefundQuantity')) {
        result.availableRefundQuantity = overrides && overrides.hasOwnProperty('availableRefundQuantity') ? overrides.availableRefundQuantity! : 2837;
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalQuantity')) {
        result.originalQuantity = overrides && overrides.hasOwnProperty('originalQuantity') ? overrides.originalQuantity! : 2484;
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedQuantity')) {
        result.refundedQuantity = overrides && overrides.hasOwnProperty('refundedQuantity') ? overrides.refundedQuantity! : 1045;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus = <T extends Partial<ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatusManuallyRefundableReason.Expired;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1MembershipPaymentSummary = <T extends Partial<ComWixEcomOrdersBillingV1MembershipPaymentSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paidLineItemIds')) {
        result.paidLineItemIds = overrides && overrides.hasOwnProperty('paidLineItemIds') ? overrides.paidLineItemIds! : ['quam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('refundableLineItemIds')) {
        result.refundableLineItemIds = overrides && overrides.hasOwnProperty('refundableLineItemIds') ? overrides.refundableLineItemIds! : ['voluptatum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedLineItemIds')) {
        result.refundedLineItemIds = overrides && overrides.hasOwnProperty('refundedLineItemIds') ? overrides.refundedLineItemIds! : ['et'];
    }

    return result;
};

export const aComWixEcomOrdersBillingV1MonetaryPaymentSummary = <T extends Partial<ComWixEcomOrdersBillingV1MonetaryPaymentSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxRefund')) {
        result.maxRefund = overrides && overrides.hasOwnProperty('maxRefund') ? aComWixEcommercePlatformCommonApiPrice(overrides.maxRefund ?? {}, pickedFields.get('maxRefund')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('maxRefund'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paid')) {
        result.paid = overrides && overrides.hasOwnProperty('paid') ? aComWixEcommercePlatformCommonApiPrice(overrides.paid ?? {}, pickedFields.get('paid')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('paid'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundPending')) {
        result.refundPending = overrides && overrides.hasOwnProperty('refundPending') ? aComWixEcommercePlatformCommonApiPrice(overrides.refundPending ?? {}, pickedFields.get('refundPending')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refundPending'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refunded')) {
        result.refunded = overrides && overrides.hasOwnProperty('refunded') ? aComWixEcommercePlatformCommonApiPrice(overrides.refunded ?? {}, pickedFields.get('refunded')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refunded'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1NonRefundablePaymentStatus = <T extends Partial<ComWixEcomOrdersBillingV1NonRefundablePaymentStatus>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : ComWixEcomOrdersBillingV1NonRefundablePaymentStatusNonRefundableReason.AlreadyRefunded;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1PaymentCaptureInput = <T extends Partial<ComWixEcomOrdersBillingV1PaymentCaptureInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'deleniti';
    }

    return result;
};

export const aComWixEcomOrdersBillingV1PaymentInfo = <T extends Partial<ComWixEcomOrdersBillingV1PaymentInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('creditCardDetails')) {
        result.creditCardDetails = overrides && overrides.hasOwnProperty('creditCardDetails') ? aComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails(overrides.creditCardDetails ?? {}, pickedFields.get('creditCardDetails')) : aComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails({}, pickedFields.get('creditCardDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('membership')) {
        result.membership = overrides && overrides.hasOwnProperty('membership') ? aComWixEcomOrdersBillingV1MembershipPaymentSummary(overrides.membership ?? {}, pickedFields.get('membership')) : aComWixEcomOrdersBillingV1MembershipPaymentSummary({}, pickedFields.get('membership'));
    }
    if (pickedFields.size === 0 || pickedFields.has('monetary')) {
        result.monetary = overrides && overrides.hasOwnProperty('monetary') ? aComWixEcomOrdersBillingV1MonetaryPaymentSummary(overrides.monetary ?? {}, pickedFields.get('monetary')) : aComWixEcomOrdersBillingV1MonetaryPaymentSummary({}, pickedFields.get('monetary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('offlinePayment')) {
        result.offlinePayment = overrides && overrides.hasOwnProperty('offlinePayment') ? overrides.offlinePayment! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? overrides.paymentMethod! : 'minima';
    }

    return result;
};

export const aComWixEcomOrdersBillingV1PaymentRefundInput = <T extends Partial<ComWixEcomOrdersBillingV1PaymentRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalRefund')) {
        result.externalRefund = overrides && overrides.hasOwnProperty('externalRefund') ? overrides.externalRefund! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'numquam';
    }

    return result;
};

export const aComWixEcomOrdersBillingV1PaymentRefundOption = <T extends Partial<ComWixEcomOrdersBillingV1PaymentRefundOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('manuallyRefundable')) {
        result.manuallyRefundable = overrides && overrides.hasOwnProperty('manuallyRefundable') ? aComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus(overrides.manuallyRefundable ?? {}, pickedFields.get('manuallyRefundable')) : aComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus({}, pickedFields.get('manuallyRefundable'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nonRefundable')) {
        result.nonRefundable = overrides && overrides.hasOwnProperty('nonRefundable') ? aComWixEcomOrdersBillingV1NonRefundablePaymentStatus(overrides.nonRefundable ?? {}, pickedFields.get('nonRefundable')) : aComWixEcomOrdersBillingV1NonRefundablePaymentStatus({}, pickedFields.get('nonRefundable'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aComWixEcomOrdersBillingV1PaymentInfo(overrides.payment ?? {}, pickedFields.get('payment')) : aComWixEcomOrdersBillingV1PaymentInfo({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerLink')) {
        result.providerLink = overrides && overrides.hasOwnProperty('providerLink') ? overrides.providerLink! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundable')) {
        result.refundable = overrides && overrides.hasOwnProperty('refundable') ? overrides.refundable! : true;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1PaymentRefundability = <T extends Partial<ComWixEcomOrdersBillingV1PaymentRefundability>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('manuallyRefundable')) {
        result.manuallyRefundable = overrides && overrides.hasOwnProperty('manuallyRefundable') ? aComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus(overrides.manuallyRefundable ?? {}, pickedFields.get('manuallyRefundable')) : aComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus({}, pickedFields.get('manuallyRefundable'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nonRefundable')) {
        result.nonRefundable = overrides && overrides.hasOwnProperty('nonRefundable') ? aComWixEcomOrdersBillingV1NonRefundablePaymentStatus(overrides.nonRefundable ?? {}, pickedFields.get('nonRefundable')) : aComWixEcomOrdersBillingV1NonRefundablePaymentStatus({}, pickedFields.get('nonRefundable'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aComWixEcomOrdersBillingV1PaymentInfo(overrides.payment ?? {}, pickedFields.get('payment')) : aComWixEcomOrdersBillingV1PaymentInfo({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerLink')) {
        result.providerLink = overrides && overrides.hasOwnProperty('providerLink') ? overrides.providerLink! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundable')) {
        result.refundable = overrides && overrides.hasOwnProperty('refundable') ? overrides.refundable! : false;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1PaymentsSummary = <T extends Partial<ComWixEcomOrdersBillingV1PaymentsSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('membership')) {
        result.membership = overrides && overrides.hasOwnProperty('membership') ? aComWixEcomOrdersBillingV1MembershipPaymentSummary(overrides.membership ?? {}, pickedFields.get('membership')) : aComWixEcomOrdersBillingV1MembershipPaymentSummary({}, pickedFields.get('membership'));
    }
    if (pickedFields.size === 0 || pickedFields.has('monetary')) {
        result.monetary = overrides && overrides.hasOwnProperty('monetary') ? aComWixEcomOrdersBillingV1MonetaryPaymentSummary(overrides.monetary ?? {}, pickedFields.get('monetary')) : aComWixEcomOrdersBillingV1MonetaryPaymentSummary({}, pickedFields.get('monetary'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1ReceiptInfo = <T extends Partial<ComWixEcomOrdersBillingV1ReceiptInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('receipt')) {
        result.receipt = overrides && overrides.hasOwnProperty('receipt') ? aWixReceiptsV1Receipt(overrides.receipt ?? {}, pickedFields.get('receipt')) : aWixReceiptsV1Receipt({}, pickedFields.get('receipt'));
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'eum';
    }

    return result;
};

export const aComWixEcomOrdersBillingV1RefundItemsInput = <T extends Partial<ComWixEcomOrdersBillingV1RefundItemsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomOrdersBillingV1AdditionalFeeRefundInput({}, pickedFields.get('additionalFees'))) : [aComWixEcomOrdersBillingV1AdditionalFeeRefundInput({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersBillingV1LineItemRefundInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersBillingV1LineItemRefundInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcomOrdersBillingV1ShippingRefundInput(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcomOrdersBillingV1ShippingRefundInput({}, pickedFields.get('shipping'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1RefundPaymentsRequestInput = <T extends Partial<ComWixEcomOrdersBillingV1RefundPaymentsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerReason')) {
        result.customerReason = overrides && overrides.hasOwnProperty('customerReason') ? overrides.customerReason! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRefunds')) {
        result.paymentRefunds = overrides && overrides.hasOwnProperty('paymentRefunds') ? overrides.paymentRefunds!.map((x) => aComWixEcomOrdersBillingV1PaymentRefundInput({}, pickedFields.get('paymentRefunds'))) : [aComWixEcomOrdersBillingV1PaymentRefundInput({}, pickedFields.get('paymentRefunds'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('refundItems')) {
        result.refundItems = overrides && overrides.hasOwnProperty('refundItems') ? aComWixEcomOrdersBillingV1RefundItemsInput(overrides.refundItems ?? {}, pickedFields.get('refundItems')) : aComWixEcomOrdersBillingV1RefundItemsInput({}, pickedFields.get('refundItems'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sideEffects')) {
        result.sideEffects = overrides && overrides.hasOwnProperty('sideEffects') ? aComWixEcomOrdersBillingV1RefundSideEffectsInput(overrides.sideEffects ?? {}, pickedFields.get('sideEffects')) : aComWixEcomOrdersBillingV1RefundSideEffectsInput({}, pickedFields.get('sideEffects'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1RefundPaymentsResponse = <T extends Partial<ComWixEcomOrdersBillingV1RefundPaymentsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? aComWixEcomOrdersPaymentsV1Refund(overrides.refund ?? {}, pickedFields.get('refund')) : aComWixEcomOrdersPaymentsV1Refund({}, pickedFields.get('refund'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1RefundSideEffectsInput = <T extends Partial<ComWixEcomOrdersBillingV1RefundSideEffectsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('notifications')) {
        result.notifications = overrides && overrides.hasOwnProperty('notifications') ? aComWixEcomOrdersBillingV1RefundSideEffectsNotificationSideEffectsInput(overrides.notifications ?? {}, pickedFields.get('notifications')) : aComWixEcomOrdersBillingV1RefundSideEffectsNotificationSideEffectsInput({}, pickedFields.get('notifications'));
    }
    if (pickedFields.size === 0 || pickedFields.has('restock')) {
        result.restock = overrides && overrides.hasOwnProperty('restock') ? aComWixEcomOrdersBillingV1RefundSideEffectsRestockSideEffectsInput(overrides.restock ?? {}, pickedFields.get('restock')) : aComWixEcomOrdersBillingV1RefundSideEffectsRestockSideEffectsInput({}, pickedFields.get('restock'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1RefundSideEffectsNotificationSideEffectsInput = <T extends Partial<ComWixEcomOrdersBillingV1RefundSideEffectsNotificationSideEffectsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customMessage')) {
        result.customMessage = overrides && overrides.hasOwnProperty('customMessage') ? overrides.customMessage! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('sendCustomerEmail')) {
        result.sendCustomerEmail = overrides && overrides.hasOwnProperty('sendCustomerEmail') ? overrides.sendCustomerEmail! : false;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1RefundSideEffectsRestockItemInput = <T extends Partial<ComWixEcomOrdersBillingV1RefundSideEffectsRestockItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 1451;
    }

    return result;
};

export const aComWixEcomOrdersBillingV1RefundSideEffectsRestockSideEffectsInput = <T extends Partial<ComWixEcomOrdersBillingV1RefundSideEffectsRestockSideEffectsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersBillingV1RefundSideEffectsRestockItemInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersBillingV1RefundSideEffectsRestockItemInput({}, pickedFields.get('lineItems'))];
    }

    return result;
};

export const aComWixEcomOrdersBillingV1ShippingRefund = <T extends Partial<ComWixEcomOrdersBillingV1ShippingRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1ShippingRefundInput = <T extends Partial<ComWixEcomOrdersBillingV1ShippingRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1ShippingRefundOption = <T extends Partial<ComWixEcomOrdersBillingV1ShippingRefundOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('availableRefundAmount')) {
        result.availableRefundAmount = overrides && overrides.hasOwnProperty('availableRefundAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.availableRefundAmount ?? {}, pickedFields.get('availableRefundAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('availableRefundAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedAmount')) {
        result.refundedAmount = overrides && overrides.hasOwnProperty('refundedAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.refundedAmount ?? {}, pickedFields.get('refundedAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refundedAmount'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1ShippingRefundability = <T extends Partial<ComWixEcomOrdersBillingV1ShippingRefundability>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('availableRefundAmount')) {
        result.availableRefundAmount = overrides && overrides.hasOwnProperty('availableRefundAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.availableRefundAmount ?? {}, pickedFields.get('availableRefundAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('availableRefundAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedAmount')) {
        result.refundedAmount = overrides && overrides.hasOwnProperty('refundedAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.refundedAmount ?? {}, pickedFields.get('refundedAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refundedAmount'));
    }

    return result;
};

export const aComWixEcomOrdersBillingV1VoidAuthorizedPaymentsRequestInput = <T extends Partial<ComWixEcomOrdersBillingV1VoidAuthorizedPaymentsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentIds')) {
        result.paymentIds = overrides && overrides.hasOwnProperty('paymentIds') ? overrides.paymentIds! : ['eum'];
    }

    return result;
};

export const aComWixEcomOrdersBillingV1VoidAuthorizedPaymentsResponse = <T extends Partial<ComWixEcomOrdersBillingV1VoidAuthorizedPaymentsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentRequestInput = <T extends Partial<ComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ordersWithFulfillments')) {
        result.ordersWithFulfillments = overrides && overrides.hasOwnProperty('ordersWithFulfillments') ? overrides.ordersWithFulfillments!.map((x) => aComWixEcomOrdersFulfillmentsV1BulkCreateOrderWithFulfillmentsInput({}, pickedFields.get('ordersWithFulfillments'))) : [aComWixEcomOrdersFulfillmentsV1BulkCreateOrderWithFulfillmentsInput({}, pickedFields.get('ordersWithFulfillments'))];
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentResponse = <T extends Partial<ComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersFulfillmentsV1BulkOrderFulfillmentsResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersFulfillmentsV1BulkOrderFulfillmentsResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1BulkCreateOrderWithFulfillmentsInput = <T extends Partial<ComWixEcomOrdersFulfillmentsV1BulkCreateOrderWithFulfillmentsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fulfillments')) {
        result.fulfillments = overrides && overrides.hasOwnProperty('fulfillments') ? overrides.fulfillments!.map((x) => aComWixEcomOrdersFulfillmentsV1FulfillmentInput({}, pickedFields.get('fulfillments'))) : [aComWixEcomOrdersFulfillmentsV1FulfillmentInput({}, pickedFields.get('fulfillments'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'odit';
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1BulkOrderFulfillmentsResult = <T extends Partial<ComWixEcomOrdersFulfillmentsV1BulkOrderFulfillmentsResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ordersWithFulfillments')) {
        result.ordersWithFulfillments = overrides && overrides.hasOwnProperty('ordersWithFulfillments') ? aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments(overrides.ordersWithFulfillments ?? {}, pickedFields.get('ordersWithFulfillments')) : aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments({}, pickedFields.get('ordersWithFulfillments'));
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1CreateFulfillmentRequestInput = <T extends Partial<ComWixEcomOrdersFulfillmentsV1CreateFulfillmentRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fulfillment')) {
        result.fulfillment = overrides && overrides.hasOwnProperty('fulfillment') ? aComWixEcomOrdersFulfillmentsV1FulfillmentInput(overrides.fulfillment ?? {}, pickedFields.get('fulfillment')) : aComWixEcomOrdersFulfillmentsV1FulfillmentInput({}, pickedFields.get('fulfillment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'et';
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1CreateFulfillmentResponse = <T extends Partial<ComWixEcomOrdersFulfillmentsV1CreateFulfillmentResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fulfillmentId')) {
        result.fulfillmentId = overrides && overrides.hasOwnProperty('fulfillmentId') ? overrides.fulfillmentId! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderWithFulfillments')) {
        result.orderWithFulfillments = overrides && overrides.hasOwnProperty('orderWithFulfillments') ? aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments(overrides.orderWithFulfillments ?? {}, pickedFields.get('orderWithFulfillments')) : aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments({}, pickedFields.get('orderWithFulfillments'));
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfo = <T extends Partial<ComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsData')) {
        result.fieldsData = overrides && overrides.hasOwnProperty('fieldsData') ? overrides.fieldsData! : 'at';
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfoInput = <T extends Partial<ComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsData')) {
        result.fieldsData = overrides && overrides.hasOwnProperty('fieldsData') ? overrides.fieldsData! : 'enim';
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1DeleteFulfillmentRequestInput = <T extends Partial<ComWixEcomOrdersFulfillmentsV1DeleteFulfillmentRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fulfillmentId')) {
        result.fulfillmentId = overrides && overrides.hasOwnProperty('fulfillmentId') ? overrides.fulfillmentId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'laborum';
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1DeleteFulfillmentResponse = <T extends Partial<ComWixEcomOrdersFulfillmentsV1DeleteFulfillmentResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderWithFulfillments')) {
        result.orderWithFulfillments = overrides && overrides.hasOwnProperty('orderWithFulfillments') ? aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments(overrides.orderWithFulfillments ?? {}, pickedFields.get('orderWithFulfillments')) : aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments({}, pickedFields.get('orderWithFulfillments'));
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1Fulfillment = <T extends Partial<ComWixEcomOrdersFulfillmentsV1Fulfillment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('completed')) {
        result.completed = overrides && overrides.hasOwnProperty('completed') ? overrides.completed! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('customInfo')) {
        result.customInfo = overrides && overrides.hasOwnProperty('customInfo') ? aComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfo(overrides.customInfo ?? {}, pickedFields.get('customInfo')) : aComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfo({}, pickedFields.get('customInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersFulfillmentsV1FulfillmentLineItem(x ?? {}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersFulfillmentsV1FulfillmentLineItem({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('trackingInfo')) {
        result.trackingInfo = overrides && overrides.hasOwnProperty('trackingInfo') ? aComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfo(overrides.trackingInfo ?? {}, pickedFields.get('trackingInfo')) : aComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfo({}, pickedFields.get('trackingInfo'));
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1FulfillmentInput = <T extends Partial<ComWixEcomOrdersFulfillmentsV1FulfillmentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('completed')) {
        result.completed = overrides && overrides.hasOwnProperty('completed') ? overrides.completed! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('customInfo')) {
        result.customInfo = overrides && overrides.hasOwnProperty('customInfo') ? aComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfoInput(overrides.customInfo ?? {}, pickedFields.get('customInfo')) : aComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfoInput({}, pickedFields.get('customInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersFulfillmentsV1FulfillmentLineItemInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersFulfillmentsV1FulfillmentLineItemInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('trackingInfo')) {
        result.trackingInfo = overrides && overrides.hasOwnProperty('trackingInfo') ? aComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfoInput(overrides.trackingInfo ?? {}, pickedFields.get('trackingInfo')) : aComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfoInput({}, pickedFields.get('trackingInfo'));
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1FulfillmentLineItem = <T extends Partial<ComWixEcomOrdersFulfillmentsV1FulfillmentLineItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 6355;
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1FulfillmentLineItemInput = <T extends Partial<ComWixEcomOrdersFulfillmentsV1FulfillmentLineItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 6039;
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfo = <T extends Partial<ComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('shippingProvider')) {
        result.shippingProvider = overrides && overrides.hasOwnProperty('shippingProvider') ? overrides.shippingProvider! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('trackingLink')) {
        result.trackingLink = overrides && overrides.hasOwnProperty('trackingLink') ? overrides.trackingLink! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('trackingNumber')) {
        result.trackingNumber = overrides && overrides.hasOwnProperty('trackingNumber') ? overrides.trackingNumber! : 'fugiat';
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfoInput = <T extends Partial<ComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('shippingProvider')) {
        result.shippingProvider = overrides && overrides.hasOwnProperty('shippingProvider') ? overrides.shippingProvider! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('trackingLink')) {
        result.trackingLink = overrides && overrides.hasOwnProperty('trackingLink') ? overrides.trackingLink! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('trackingNumber')) {
        result.trackingNumber = overrides && overrides.hasOwnProperty('trackingNumber') ? overrides.trackingNumber! : 'impedit';
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersRequestInput = <T extends Partial<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderIds')) {
        result.orderIds = overrides && overrides.hasOwnProperty('orderIds') ? overrides.orderIds! : ['iure'];
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersResponse = <T extends Partial<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ordersWithFulfillments')) {
        result.ordersWithFulfillments = overrides && overrides.hasOwnProperty('ordersWithFulfillments') ? overrides.ordersWithFulfillments!.map((x) => aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments(x ?? {}, pickedFields.get('ordersWithFulfillments'))) : [aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments({}, pickedFields.get('ordersWithFulfillments'))];
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderRequestInput = <T extends Partial<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'sapiente';
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderResponse = <T extends Partial<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderWithFulfillments')) {
        result.orderWithFulfillments = overrides && overrides.hasOwnProperty('orderWithFulfillments') ? aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments(overrides.orderWithFulfillments ?? {}, pickedFields.get('orderWithFulfillments')) : aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments({}, pickedFields.get('orderWithFulfillments'));
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments = <T extends Partial<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fulfillments')) {
        result.fulfillments = overrides && overrides.hasOwnProperty('fulfillments') ? overrides.fulfillments!.map((x) => aComWixEcomOrdersFulfillmentsV1Fulfillment(x ?? {}, pickedFields.get('fulfillments'))) : [aComWixEcomOrdersFulfillmentsV1Fulfillment({}, pickedFields.get('fulfillments'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'quis';
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1UpdateFulfillmentRequestInput = <T extends Partial<ComWixEcomOrdersFulfillmentsV1UpdateFulfillmentRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['quas'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillment')) {
        result.fulfillment = overrides && overrides.hasOwnProperty('fulfillment') ? aComWixEcomOrdersFulfillmentsV1FulfillmentInput(overrides.fulfillment ?? {}, pickedFields.get('fulfillment')) : aComWixEcomOrdersFulfillmentsV1FulfillmentInput({}, pickedFields.get('fulfillment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'quis';
    }

    return result;
};

export const aComWixEcomOrdersFulfillmentsV1UpdateFulfillmentResponse = <T extends Partial<ComWixEcomOrdersFulfillmentsV1UpdateFulfillmentResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderWithFulfillments')) {
        result.orderWithFulfillments = overrides && overrides.hasOwnProperty('orderWithFulfillments') ? aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments(overrides.orderWithFulfillments ?? {}, pickedFields.get('orderWithFulfillments')) : aComWixEcomOrdersFulfillmentsV1OrderWithFulfillments({}, pickedFields.get('orderWithFulfillments'));
    }

    return result;
};

export const aComWixEcomOrdersIndexerV1BatchOfTriggerReindexOrderRequestInput = <T extends Partial<ComWixEcomOrdersIndexerV1BatchOfTriggerReindexOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('requests')) {
        result.requests = overrides && overrides.hasOwnProperty('requests') ? overrides.requests!.map((x) => aComWixEcomOrdersIndexerV1TriggerReindexOrderRequestInput({}, pickedFields.get('requests'))) : [aComWixEcomOrdersIndexerV1TriggerReindexOrderRequestInput({}, pickedFields.get('requests'))];
    }

    return result;
};

export const aComWixEcomOrdersIndexerV1TriggerReindexOrderRequestInput = <T extends Partial<ComWixEcomOrdersIndexerV1TriggerReindexOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metasiteId')) {
        result.metasiteId = overrides && overrides.hasOwnProperty('metasiteId') ? overrides.metasiteId! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'maiores';
    }

    return result;
};

export const aComWixEcomOrdersIndexerV1TriggerReindexRequestInput = <T extends Partial<ComWixEcomOrdersIndexerV1TriggerReindexRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metasiteId')) {
        result.metasiteId = overrides && overrides.hasOwnProperty('metasiteId') ? overrides.metasiteId! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderIds')) {
        result.orderIds = overrides && overrides.hasOwnProperty('orderIds') ? overrides.orderIds! : ['eius'];
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1AddInvoiceToOrderRequestInput = <T extends Partial<ComWixEcomOrdersInvoicesV1AddInvoiceToOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoiceInfo')) {
        result.invoiceInfo = overrides && overrides.hasOwnProperty('invoiceInfo') ? aComWixEcomOrdersInvoicesV1InvoiceInput(overrides.invoiceInfo ?? {}, pickedFields.get('invoiceInfo')) : aComWixEcomOrdersInvoicesV1InvoiceInput({}, pickedFields.get('invoiceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'veniam';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1AddInvoiceToOrderResponse = <T extends Partial<ComWixEcomOrdersInvoicesV1AddInvoiceToOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderInvoices')) {
        result.orderInvoices = overrides && overrides.hasOwnProperty('orderInvoices') ? overrides.orderInvoices!.map((x) => aComWixEcomOrdersInvoicesV1Invoice(x ?? {}, pickedFields.get('orderInvoices'))) : [aComWixEcomOrdersInvoicesV1Invoice({}, pickedFields.get('orderInvoices'))];
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1BulkGenerateInvoicesRequestInput = <T extends Partial<ComWixEcomOrdersInvoicesV1BulkGenerateInvoicesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderIds')) {
        result.orderIds = overrides && overrides.hasOwnProperty('orderIds') ? overrides.orderIds! : ['distinctio'];
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1BulkGenerateInvoicesResponse = <T extends Partial<ComWixEcomOrdersInvoicesV1BulkGenerateInvoicesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersInvoicesV1BulkInvoiceResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersInvoicesV1BulkInvoiceResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1BulkInvoiceResult = <T extends Partial<ComWixEcomOrdersInvoicesV1BulkInvoiceResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixEcomOrdersInvoicesV1InvoiceForOrder(overrides.item ?? {}, pickedFields.get('item')) : aComWixEcomOrdersInvoicesV1InvoiceForOrder({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1GenerateInvoiceRequestInput = <T extends Partial<ComWixEcomOrdersInvoicesV1GenerateInvoiceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'est';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1GenerateInvoiceResponse = <T extends Partial<ComWixEcomOrdersInvoicesV1GenerateInvoiceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoiceId')) {
        result.invoiceId = overrides && overrides.hasOwnProperty('invoiceId') ? overrides.invoiceId! : 'eos';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberRequestInput = <T extends Partial<ComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoiceNumber')) {
        result.invoiceNumber = overrides && overrides.hasOwnProperty('invoiceNumber') ? overrides.invoiceNumber! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('issueDate')) {
        result.issueDate = overrides && overrides.hasOwnProperty('issueDate') ? overrides.issueDate! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'nam';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberResponse = <T extends Partial<ComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoiceId')) {
        result.invoiceId = overrides && overrides.hasOwnProperty('invoiceId') ? overrides.invoiceId! : 'voluptas';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1GetOrderInvoiceRequestInput = <T extends Partial<ComWixEcomOrdersInvoicesV1GetOrderInvoiceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoiceId')) {
        result.invoiceId = overrides && overrides.hasOwnProperty('invoiceId') ? overrides.invoiceId! : 'modi';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1GetOrderInvoiceResponse = <T extends Partial<ComWixEcomOrdersInvoicesV1GetOrderInvoiceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoiceInfo')) {
        result.invoiceInfo = overrides && overrides.hasOwnProperty('invoiceInfo') ? aComWixEcomOrdersInvoicesV1Invoice(overrides.invoiceInfo ?? {}, pickedFields.get('invoiceInfo')) : aComWixEcomOrdersInvoicesV1Invoice({}, pickedFields.get('invoiceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'enim';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1Invoice = <T extends Partial<ComWixEcomOrdersInvoicesV1Invoice>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'adipisci';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1InvoiceForOrder = <T extends Partial<ComWixEcomOrdersInvoicesV1InvoiceForOrder>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoiceId')) {
        result.invoiceId = overrides && overrides.hasOwnProperty('invoiceId') ? overrides.invoiceId! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'similique';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1InvoiceInput = <T extends Partial<ComWixEcomOrdersInvoicesV1InvoiceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'qui';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1InvoicesForOrder = <T extends Partial<ComWixEcomOrdersInvoicesV1InvoicesForOrder>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoices')) {
        result.invoices = overrides && overrides.hasOwnProperty('invoices') ? overrides.invoices!.map((x) => aComWixEcomOrdersInvoicesV1Invoice(x ?? {}, pickedFields.get('invoices'))) : [aComWixEcomOrdersInvoicesV1Invoice({}, pickedFields.get('invoices'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('invoicesInfo')) {
        result.invoicesInfo = overrides && overrides.hasOwnProperty('invoicesInfo') ? overrides.invoicesInfo!.map((x) => aComWixEcomOrdersInvoicesV1Invoice(x ?? {}, pickedFields.get('invoicesInfo'))) : [aComWixEcomOrdersInvoicesV1Invoice({}, pickedFields.get('invoicesInfo'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'voluptas';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersRequestInput = <T extends Partial<ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderIds')) {
        result.orderIds = overrides && overrides.hasOwnProperty('orderIds') ? overrides.orderIds! : ['molestiae'];
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersResponse = <T extends Partial<ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoicesForOrder')) {
        result.invoicesForOrder = overrides && overrides.hasOwnProperty('invoicesForOrder') ? overrides.invoicesForOrder!.map((x) => aComWixEcomOrdersInvoicesV1InvoicesForOrder(x ?? {}, pickedFields.get('invoicesForOrder'))) : [aComWixEcomOrdersInvoicesV1InvoicesForOrder({}, pickedFields.get('invoicesForOrder'))];
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderRequestInput = <T extends Partial<ComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'neque';
    }

    return result;
};

export const aComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderResponse = <T extends Partial<ComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoices')) {
        result.invoices = overrides && overrides.hasOwnProperty('invoices') ? overrides.invoices!.map((x) => aComWixEcomOrdersInvoicesV1Invoice(x ?? {}, pickedFields.get('invoices'))) : [aComWixEcomOrdersInvoicesV1Invoice({}, pickedFields.get('invoices'))];
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1BulkSendBuyerPickupConfirmationEmailsRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1BulkSendBuyerPickupConfirmationEmailsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderIds')) {
        result.orderIds = overrides && overrides.hasOwnProperty('orderIds') ? overrides.orderIds! : ['omnis'];
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1BulkSendBuyerShippingConfirmationEmailsRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1BulkSendBuyerShippingConfirmationEmailsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderIds')) {
        result.orderIds = overrides && overrides.hasOwnProperty('orderIds') ? overrides.orderIds! : ['minus'];
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewBuyerConfirmationEmailResponse = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewBuyerConfirmationEmailResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailPreview')) {
        result.emailPreview = overrides && overrides.hasOwnProperty('emailPreview') ? overrides.emailPreview! : 'et';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewBuyerPaymentsReceivedEmailResponse = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewBuyerPaymentsReceivedEmailResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailPreview')) {
        result.emailPreview = overrides && overrides.hasOwnProperty('emailPreview') ? overrides.emailPreview! : 'a';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewBuyerPickupConfirmationEmailResponse = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewBuyerPickupConfirmationEmailResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailPreview')) {
        result.emailPreview = overrides && overrides.hasOwnProperty('emailPreview') ? overrides.emailPreview! : 'quo';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewCancelEmailRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewCancelEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customMessage')) {
        result.customMessage = overrides && overrides.hasOwnProperty('customMessage') ? overrides.customMessage! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'excepturi';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewCancelEmailResponse = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewCancelEmailResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailPreview')) {
        result.emailPreview = overrides && overrides.hasOwnProperty('emailPreview') ? overrides.emailPreview! : 'consequatur';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customMessage')) {
        result.customMessage = overrides && overrides.hasOwnProperty('customMessage') ? overrides.customMessage! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundAmount')) {
        result.refundAmount = overrides && overrides.hasOwnProperty('refundAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.refundAmount ?? {}, pickedFields.get('refundAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('refundAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'dolorem';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailResponse = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailPreview')) {
        result.emailPreview = overrides && overrides.hasOwnProperty('emailPreview') ? overrides.emailPreview! : 'et';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewEmailByTypeRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewEmailByTypeRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailType')) {
        result.emailType = overrides && overrides.hasOwnProperty('emailType') ? overrides.emailType! : ComWixEcomOrdersNotificationsV1PreviewEmailType.DownloadLinks;
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewEmailByTypeResponse = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewEmailByTypeResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailPreview')) {
        result.emailPreview = overrides && overrides.hasOwnProperty('emailPreview') ? overrides.emailPreview! : 'aspernatur';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewRefundEmailRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewRefundEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customMessage')) {
        result.customMessage = overrides && overrides.hasOwnProperty('customMessage') ? overrides.customMessage! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcomOrdersPaymentsV1RefundDetailsInput(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcomOrdersPaymentsV1RefundDetailsInput({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundAmount')) {
        result.refundAmount = overrides && overrides.hasOwnProperty('refundAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.refundAmount ?? {}, pickedFields.get('refundAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('refundAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'ullam';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewRefundEmailResponse = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewRefundEmailResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailPreview')) {
        result.emailPreview = overrides && overrides.hasOwnProperty('emailPreview') ? overrides.emailPreview! : 'delectus';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewResendDownloadLinksEmailResponse = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewResendDownloadLinksEmailResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailPreview')) {
        result.emailPreview = overrides && overrides.hasOwnProperty('emailPreview') ? overrides.emailPreview! : 'est';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1PreviewShippingConfirmationEmailResponse = <T extends Partial<ComWixEcomOrdersNotificationsV1PreviewShippingConfirmationEmailResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailPreview')) {
        result.emailPreview = overrides && overrides.hasOwnProperty('emailPreview') ? overrides.emailPreview! : 'illo';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1SendBuyerConfirmationEmailRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1SendBuyerConfirmationEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'velit';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1SendBuyerPaymentsReceivedEmailRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1SendBuyerPaymentsReceivedEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'magni';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1SendBuyerPickupConfirmationEmailRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1SendBuyerPickupConfirmationEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'non';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1SendBuyerShippingConfirmationEmailRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1SendBuyerShippingConfirmationEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'odit';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1SendCancelRefundEmailRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1SendCancelRefundEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customMessage')) {
        result.customMessage = overrides && overrides.hasOwnProperty('customMessage') ? overrides.customMessage! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundAmount')) {
        result.refundAmount = overrides && overrides.hasOwnProperty('refundAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.refundAmount ?? {}, pickedFields.get('refundAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('refundAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'aut';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedNotificationRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedNotificationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'nemo';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedPushRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedPushRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'voluptatem';
    }

    return result;
};

export const aComWixEcomOrdersNotificationsV1SendRefundEmailRequestInput = <T extends Partial<ComWixEcomOrdersNotificationsV1SendRefundEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customMessage')) {
        result.customMessage = overrides && overrides.hasOwnProperty('customMessage') ? overrides.customMessage! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'exercitationem';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeId')) {
        result.additionalFeeId = overrides && overrides.hasOwnProperty('additionalFeeId') ? overrides.additionalFeeId! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeId')) {
        result.additionalFeeId = overrides && overrides.hasOwnProperty('additionalFeeId') ? overrides.additionalFeeId! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundOption = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeId')) {
        result.additionalFeeId = overrides && overrides.hasOwnProperty('additionalFeeId') ? overrides.additionalFeeId! : 'vero';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('availableRefundAmount')) {
        result.availableRefundAmount = overrides && overrides.hasOwnProperty('availableRefundAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.availableRefundAmount ?? {}, pickedFields.get('availableRefundAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('availableRefundAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedAmount')) {
        result.refundedAmount = overrides && overrides.hasOwnProperty('refundedAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.refundedAmount ?? {}, pickedFields.get('refundedAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refundedAmount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ecomOrderIds')) {
        result.ecomOrderIds = overrides && overrides.hasOwnProperty('ecomOrderIds') ? overrides.ecomOrderIds! : ['ea'];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 9528;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiPrice(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('price'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculateRefundRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundItems')) {
        result.refundItems = overrides && overrides.hasOwnProperty('refundItems') ? overrides.refundItems!.map((x) => aComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput({}, pickedFields.get('refundItems'))) : [aComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput({}, pickedFields.get('refundItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('refundShipping')) {
        result.refundShipping = overrides && overrides.hasOwnProperty('refundShipping') ? overrides.refundShipping! : false;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculateRefundResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiPrice(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse(x ?? {}, pickedFields.get('items'))) : [aComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('previouslyRefundedAmount')) {
        result.previouslyRefundedAmount = overrides && overrides.hasOwnProperty('previouslyRefundedAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.previouslyRefundedAmount ?? {}, pickedFields.get('previouslyRefundedAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('previouslyRefundedAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcommercePlatformCommonApiPrice(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('shipping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixEcommercePlatformCommonApiPrice(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiPrice(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiPrice(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1RequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1RequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundItems')) {
        result.refundItems = overrides && overrides.hasOwnProperty('refundItems') ? overrides.refundItems!.map((x) => aComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput({}, pickedFields.get('refundItems'))) : [aComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput({}, pickedFields.get('refundItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('refundShipping')) {
        result.refundShipping = overrides && overrides.hasOwnProperty('refundShipping') ? overrides.refundShipping! : false;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1Response = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1Response>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiPrice(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse(x ?? {}, pickedFields.get('items'))) : [aComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('previouslyRefundedAmount')) {
        result.previouslyRefundedAmount = overrides && overrides.hasOwnProperty('previouslyRefundedAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.previouslyRefundedAmount ?? {}, pickedFields.get('previouslyRefundedAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('previouslyRefundedAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcommercePlatformCommonApiPrice(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('shipping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixEcommercePlatformCommonApiPrice(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiPrice(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiPrice(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2RequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2RequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'voluptas';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2Response = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2Response>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('available')) {
        result.available = overrides && overrides.hasOwnProperty('available') ? overrides.available! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('calculatedDetails')) {
        result.calculatedDetails = overrides && overrides.hasOwnProperty('calculatedDetails') ? aComWixEcomOrdersPaymentsCollectorV1CalculatedRefundDetails(overrides.calculatedDetails ?? {}, pickedFields.get('calculatedDetails')) : aComWixEcomOrdersPaymentsCollectorV1CalculatedRefundDetails({}, pickedFields.get('calculatedDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('notAvailable')) {
        result.notAvailable = overrides && overrides.hasOwnProperty('notAvailable') ? aComWixEcomOrdersPaymentsCollectorV1CalculatedRefundNotAvailableStatus(overrides.notAvailable ?? {}, pickedFields.get('notAvailable')) : aComWixEcomOrdersPaymentsCollectorV1CalculatedRefundNotAvailableStatus({}, pickedFields.get('notAvailable'));
    }
    if (pickedFields.size === 0 || pickedFields.has('summary')) {
        result.summary = overrides && overrides.hasOwnProperty('summary') ? aComWixEcomOrdersPaymentsCollectorV1CalculatedRefundSummary(overrides.summary ?? {}, pickedFields.get('summary')) : aComWixEcomOrdersPaymentsCollectorV1CalculatedRefundSummary({}, pickedFields.get('summary'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculatedAdditionalFeeRefund = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculatedAdditionalFeeRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFee')) {
        result.additionalFee = overrides && overrides.hasOwnProperty('additionalFee') ? aComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund(overrides.additionalFee ?? {}, pickedFields.get('additionalFee')) : aComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund({}, pickedFields.get('additionalFee'));
    }
    if (pickedFields.size === 0 || pickedFields.has('available')) {
        result.available = overrides && overrides.hasOwnProperty('available') ? overrides.available! : true;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculatedLineItemRefund = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculatedLineItemRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixEcomOrdersPaymentsCollectorV1LineItemRefund(overrides.item ?? {}, pickedFields.get('item')) : aComWixEcomOrdersPaymentsCollectorV1LineItemRefund({}, pickedFields.get('item'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculatedRefundDetails = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomOrdersPaymentsCollectorV1CalculatedAdditionalFeeRefund(x ?? {}, pickedFields.get('additionalFees'))) : [aComWixEcomOrdersPaymentsCollectorV1CalculatedAdditionalFeeRefund({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersPaymentsCollectorV1CalculatedLineItemRefund(x ?? {}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersPaymentsCollectorV1CalculatedLineItemRefund({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcomOrdersPaymentsCollectorV1CalculatedShippingRefund(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcomOrdersPaymentsCollectorV1CalculatedShippingRefund({}, pickedFields.get('shipping'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculatedRefundNotAvailableStatus = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundNotAvailableStatus>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errors')) {
        result.errors = overrides && overrides.hasOwnProperty('errors') ? overrides.errors!.map((x) => aComWixEcomOrdersPaymentsCollectorV1CalculationError(x ?? {}, pickedFields.get('errors'))) : [aComWixEcomOrdersPaymentsCollectorV1CalculationError({}, pickedFields.get('errors'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculatedRefundSummary = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiPrice(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('previouslyRefundedAmount')) {
        result.previouslyRefundedAmount = overrides && overrides.hasOwnProperty('previouslyRefundedAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.previouslyRefundedAmount ?? {}, pickedFields.get('previouslyRefundedAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('previouslyRefundedAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcommercePlatformCommonApiPrice(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('shipping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixEcommercePlatformCommonApiPrice(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiPrice(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiPrice(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculatedShippingRefund = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculatedShippingRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('available')) {
        result.available = overrides && overrides.hasOwnProperty('available') ? overrides.available! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcomOrdersPaymentsCollectorV1ShippingRefund(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcomOrdersPaymentsCollectorV1ShippingRefund({}, pickedFields.get('shipping'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CalculationError = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CalculationError>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFee')) {
        result.additionalFee = overrides && overrides.hasOwnProperty('additionalFee') ? aComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund(overrides.additionalFee ?? {}, pickedFields.get('additionalFee')) : aComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund({}, pickedFields.get('additionalFee'));
    }
    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiDetails(overrides.error ?? {}, pickedFields.get('error')) : aWixApiDetails({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItem')) {
        result.lineItem = overrides && overrides.hasOwnProperty('lineItem') ? aComWixEcomOrdersPaymentsCollectorV1LineItemRefund(overrides.lineItem ?? {}, pickedFields.get('lineItem')) : aComWixEcomOrdersPaymentsCollectorV1LineItemRefund({}, pickedFields.get('lineItem'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcomOrdersPaymentsCollectorV1ShippingRefund(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcomOrdersPaymentsCollectorV1ShippingRefund({}, pickedFields.get('shipping'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'repellat';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? overrides.payments!.map((x) => aComWixEcomOrdersPaymentsCollectorV1PaymentCaptureInput({}, pickedFields.get('payments'))) : [aComWixEcomOrdersPaymentsCollectorV1PaymentCaptureInput({}, pickedFields.get('payments'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1ChargeMembershipsRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1ChargeMembershipsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipCharges')) {
        result.membershipCharges = overrides && overrides.hasOwnProperty('membershipCharges') ? overrides.membershipCharges!.map((x) => aComWixEcomOrdersPaymentsCollectorV1MembershipChargeItemInput({}, pickedFields.get('membershipCharges'))) : [aComWixEcomOrdersPaymentsCollectorV1MembershipChargeItemInput({}, pickedFields.get('membershipCharges'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'nesciunt';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayOrderId')) {
        result.paymentGatewayOrderId = overrides && overrides.hasOwnProperty('paymentGatewayOrderId') ? overrides.paymentGatewayOrderId! : 'ut';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1ChargedByInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1ChargedByInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fullName')) {
        result.fullName = overrides && overrides.hasOwnProperty('fullName') ? overrides.fullName! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'placeat';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('chargedBy')) {
        result.chargedBy = overrides && overrides.hasOwnProperty('chargedBy') ? aComWixEcomOrdersPaymentsCollectorV1ChargedByInput(overrides.chargedBy ?? {}, pickedFields.get('chargedBy')) : aComWixEcomOrdersPaymentsCollectorV1ChargedByInput({}, pickedFields.get('chargedBy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('delayedCapture')) {
        result.delayedCapture = overrides && overrides.hasOwnProperty('delayedCapture') ? overrides.delayedCapture! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'ab';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayOrderId')) {
        result.paymentGatewayOrderId = overrides && overrides.hasOwnProperty('paymentGatewayOrderId') ? overrides.paymentGatewayOrderId! : 'maxime';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('delayDuration')) {
        result.delayDuration = overrides && overrides.hasOwnProperty('delayDuration') ? aComWixEcommercePlatformCommonApiDurationInput(overrides.delayDuration ?? {}, pickedFields.get('delayDuration')) : aComWixEcommercePlatformCommonApiDurationInput({}, pickedFields.get('delayDuration'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduledAction')) {
        result.scheduledAction = overrides && overrides.hasOwnProperty('scheduledAction') ? overrides.scheduledAction! : ComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsScheduledAction.Capture;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'voluptatem';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('authorizationSupported')) {
        result.authorizationSupported = overrides && overrides.hasOwnProperty('authorizationSupported') ? overrides.authorizationSupported! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersPaymentsCollectorV1PaymentCollectabilityStatusEnumPaymentCollectabilityStatus.Collectable;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'quos';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeRefundOptions')) {
        result.additionalFeeRefundOptions = overrides && overrides.hasOwnProperty('additionalFeeRefundOptions') ? overrides.additionalFeeRefundOptions!.map((x) => aComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundOption(x ?? {}, pickedFields.get('additionalFeeRefundOptions'))) : [aComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundOption({}, pickedFields.get('additionalFeeRefundOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemRefundOptions')) {
        result.lineItemRefundOptions = overrides && overrides.hasOwnProperty('lineItemRefundOptions') ? overrides.lineItemRefundOptions!.map((x) => aComWixEcomOrdersPaymentsCollectorV1LineItemRefundOption(x ?? {}, pickedFields.get('lineItemRefundOptions'))) : [aComWixEcomOrdersPaymentsCollectorV1LineItemRefundOption({}, pickedFields.get('lineItemRefundOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRefundOptions')) {
        result.paymentRefundOptions = overrides && overrides.hasOwnProperty('paymentRefundOptions') ? overrides.paymentRefundOptions!.map((x) => aComWixEcomOrdersPaymentsCollectorV1PaymentRefundOption(x ?? {}, pickedFields.get('paymentRefundOptions'))) : [aComWixEcomOrdersPaymentsCollectorV1PaymentRefundOption({}, pickedFields.get('paymentRefundOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentsSummary')) {
        result.paymentsSummary = overrides && overrides.hasOwnProperty('paymentsSummary') ? aComWixEcomOrdersPaymentsCollectorV1PaymentsSummary(overrides.paymentsSummary ?? {}, pickedFields.get('paymentsSummary')) : aComWixEcomOrdersPaymentsCollectorV1PaymentsSummary({}, pickedFields.get('paymentsSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingRefundOption')) {
        result.shippingRefundOption = overrides && overrides.hasOwnProperty('shippingRefundOption') ? aComWixEcomOrdersPaymentsCollectorV1ShippingRefundOption(overrides.shippingRefundOption ?? {}, pickedFields.get('shippingRefundOption')) : aComWixEcomOrdersPaymentsCollectorV1ShippingRefundOption({}, pickedFields.get('shippingRefundOption'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'qui';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('refundabilities')) {
        result.refundabilities = overrides && overrides.hasOwnProperty('refundabilities') ? overrides.refundabilities!.map((x) => aComWixEcomOrdersPaymentsCollectorV1Refundability(x ?? {}, pickedFields.get('refundabilities'))) : [aComWixEcomOrdersPaymentsCollectorV1Refundability({}, pickedFields.get('refundabilities'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('refundablePerItem')) {
        result.refundablePerItem = overrides && overrides.hasOwnProperty('refundablePerItem') ? overrides.refundablePerItem! : false;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1LineItemRefund = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1LineItemRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 4251;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1LineItemRefundInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1LineItemRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 6851;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1LineItemRefundOption = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1LineItemRefundOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availableRefundQuantity')) {
        result.availableRefundQuantity = overrides && overrides.hasOwnProperty('availableRefundQuantity') ? overrides.availableRefundQuantity! : 1462;
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalQuantity')) {
        result.originalQuantity = overrides && overrides.hasOwnProperty('originalQuantity') ? overrides.originalQuantity! : 7848;
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedQuantity')) {
        result.refundedQuantity = overrides && overrides.hasOwnProperty('refundedQuantity') ? overrides.refundedQuantity! : 9093;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatus = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatus>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : ComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatusManuallyRefundableReason.Expired;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'a';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1MembershipChargeItemInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1MembershipChargeItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('catalogReference')) {
        result.catalogReference = overrides && overrides.hasOwnProperty('catalogReference') ? aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput(overrides.catalogReference ?? {}, pickedFields.get('catalogReference')) : aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput({}, pickedFields.get('catalogReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipAdditionalData')) {
        result.membershipAdditionalData = overrides && overrides.hasOwnProperty('membershipAdditionalData') ? overrides.membershipAdditionalData! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipId')) {
        result.membershipId = overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipName')) {
        result.membershipName = overrides && overrides.hasOwnProperty('membershipName') ? aComWixEcomMembershipsSpiV1MembershipNameInput(overrides.membershipName ?? {}, pickedFields.get('membershipName')) : aComWixEcomMembershipsSpiV1MembershipNameInput({}, pickedFields.get('membershipName'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rootCatalogItemId')) {
        result.rootCatalogItemId = overrides && overrides.hasOwnProperty('rootCatalogItemId') ? overrides.rootCatalogItemId! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceProperties')) {
        result.serviceProperties = overrides && overrides.hasOwnProperty('serviceProperties') ? aComWixEcommerceCatalogSpiApiV1ServicePropertiesInput(overrides.serviceProperties ?? {}, pickedFields.get('serviceProperties')) : aComWixEcommerceCatalogSpiApiV1ServicePropertiesInput({}, pickedFields.get('serviceProperties'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paidLineItemIds')) {
        result.paidLineItemIds = overrides && overrides.hasOwnProperty('paidLineItemIds') ? overrides.paidLineItemIds! : ['saepe'];
    }
    if (pickedFields.size === 0 || pickedFields.has('refundableLineItemIds')) {
        result.refundableLineItemIds = overrides && overrides.hasOwnProperty('refundableLineItemIds') ? overrides.refundableLineItemIds! : ['quos'];
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedLineItemIds')) {
        result.refundedLineItemIds = overrides && overrides.hasOwnProperty('refundedLineItemIds') ? overrides.refundedLineItemIds! : ['accusamus'];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxRefund')) {
        result.maxRefund = overrides && overrides.hasOwnProperty('maxRefund') ? aComWixEcommercePlatformCommonApiPrice(overrides.maxRefund ?? {}, pickedFields.get('maxRefund')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('maxRefund'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paid')) {
        result.paid = overrides && overrides.hasOwnProperty('paid') ? aComWixEcommercePlatformCommonApiPrice(overrides.paid ?? {}, pickedFields.get('paid')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('paid'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundPending')) {
        result.refundPending = overrides && overrides.hasOwnProperty('refundPending') ? aComWixEcommercePlatformCommonApiPrice(overrides.refundPending ?? {}, pickedFields.get('refundPending')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refundPending'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refunded')) {
        result.refunded = overrides && overrides.hasOwnProperty('refunded') ? aComWixEcommercePlatformCommonApiPrice(overrides.refunded ?? {}, pickedFields.get('refunded')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refunded'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatus = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatus>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : ComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatusNonRefundableReason.AlreadyRefunded;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1PaymentCaptureInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1PaymentCaptureInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'error';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1PaymentInfo = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1PaymentInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('creditCardDetails')) {
        result.creditCardDetails = overrides && overrides.hasOwnProperty('creditCardDetails') ? aComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails(overrides.creditCardDetails ?? {}, pickedFields.get('creditCardDetails')) : aComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails({}, pickedFields.get('creditCardDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('membership')) {
        result.membership = overrides && overrides.hasOwnProperty('membership') ? aComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary(overrides.membership ?? {}, pickedFields.get('membership')) : aComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary({}, pickedFields.get('membership'));
    }
    if (pickedFields.size === 0 || pickedFields.has('monetary')) {
        result.monetary = overrides && overrides.hasOwnProperty('monetary') ? aComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary(overrides.monetary ?? {}, pickedFields.get('monetary')) : aComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary({}, pickedFields.get('monetary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'praesentium';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1PaymentRefundInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1PaymentRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalRefund')) {
        result.externalRefund = overrides && overrides.hasOwnProperty('externalRefund') ? overrides.externalRefund! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'nulla';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1PaymentRefundOption = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1PaymentRefundOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('manuallyRefundable')) {
        result.manuallyRefundable = overrides && overrides.hasOwnProperty('manuallyRefundable') ? aComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatus(overrides.manuallyRefundable ?? {}, pickedFields.get('manuallyRefundable')) : aComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatus({}, pickedFields.get('manuallyRefundable'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nonRefundable')) {
        result.nonRefundable = overrides && overrides.hasOwnProperty('nonRefundable') ? aComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatus(overrides.nonRefundable ?? {}, pickedFields.get('nonRefundable')) : aComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatus({}, pickedFields.get('nonRefundable'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aComWixEcomOrdersPaymentsCollectorV1PaymentInfo(overrides.payment ?? {}, pickedFields.get('payment')) : aComWixEcomOrdersPaymentsCollectorV1PaymentInfo({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerLink')) {
        result.providerLink = overrides && overrides.hasOwnProperty('providerLink') ? overrides.providerLink! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundable')) {
        result.refundable = overrides && overrides.hasOwnProperty('refundable') ? overrides.refundable! : true;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1PaymentsSummary = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1PaymentsSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('membership')) {
        result.membership = overrides && overrides.hasOwnProperty('membership') ? aComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary(overrides.membership ?? {}, pickedFields.get('membership')) : aComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary({}, pickedFields.get('membership'));
    }
    if (pickedFields.size === 0 || pickedFields.has('monetary')) {
        result.monetary = overrides && overrides.hasOwnProperty('monetary') ? aComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary(overrides.monetary ?? {}, pickedFields.get('monetary')) : aComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary({}, pickedFields.get('monetary'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('delayedCaptureSettings')) {
        result.delayedCaptureSettings = overrides && overrides.hasOwnProperty('delayedCaptureSettings') ? aComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsInput(overrides.delayedCaptureSettings ?? {}, pickedFields.get('delayedCaptureSettings')) : aComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsInput({}, pickedFields.get('delayedCaptureSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantInitiated')) {
        result.merchantInitiated = overrides && overrides.hasOwnProperty('merchantInitiated') ? overrides.merchantInitiated! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayOrderId')) {
        result.paymentGatewayOrderId = overrides && overrides.hasOwnProperty('paymentGatewayOrderId') ? overrides.paymentGatewayOrderId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('redirectUrls')) {
        result.redirectUrls = overrides && overrides.hasOwnProperty('redirectUrls') ? aComWixEcomOrdersPaymentsCollectorV1RedirectUrlsInput(overrides.redirectUrls ?? {}, pickedFields.get('redirectUrls')) : aComWixEcomOrdersPaymentsCollectorV1RedirectUrlsInput({}, pickedFields.get('redirectUrls'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayOrderId')) {
        result.paymentGatewayOrderId = overrides && overrides.hasOwnProperty('paymentGatewayOrderId') ? overrides.paymentGatewayOrderId! : 'optio';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1RecordManuallyCollectedPaymentRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1RecordManuallyCollectedPaymentRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'autem';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1RedirectUrlsInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1RedirectUrlsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cancelUrl')) {
        result.cancelUrl = overrides && overrides.hasOwnProperty('cancelUrl') ? overrides.cancelUrl! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('errorUrl')) {
        result.errorUrl = overrides && overrides.hasOwnProperty('errorUrl') ? overrides.errorUrl! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('pendingUrl')) {
        result.pendingUrl = overrides && overrides.hasOwnProperty('pendingUrl') ? overrides.pendingUrl! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('successUrl')) {
        result.successUrl = overrides && overrides.hasOwnProperty('successUrl') ? overrides.successUrl! : 'ducimus';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundInput({}, pickedFields.get('additionalFees'))) : [aComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundInput({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('customerReason')) {
        result.customerReason = overrides && overrides.hasOwnProperty('customerReason') ? overrides.customerReason! : 'delectus';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersPaymentsCollectorV1LineItemRefundInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersPaymentsCollectorV1LineItemRefundInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcomOrdersPaymentsCollectorV1ShippingRefundInput(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcomOrdersPaymentsCollectorV1ShippingRefundInput({}, pickedFields.get('shipping'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1RefundRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1RefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRefunds')) {
        result.paymentRefunds = overrides && overrides.hasOwnProperty('paymentRefunds') ? overrides.paymentRefunds!.map((x) => aComWixEcomOrdersPaymentsCollectorV1PaymentRefundInput({}, pickedFields.get('paymentRefunds'))) : [aComWixEcomOrdersPaymentsCollectorV1PaymentRefundInput({}, pickedFields.get('paymentRefunds'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('sideEffects')) {
        result.sideEffects = overrides && overrides.hasOwnProperty('sideEffects') ? aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsInput(overrides.sideEffects ?? {}, pickedFields.get('sideEffects')) : aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsInput({}, pickedFields.get('sideEffects'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1RefundResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1RefundResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? overrides.refund!.map((x) => aComWixEcomOrdersPaymentsV1Refund(x ?? {}, pickedFields.get('refund'))) : [aComWixEcomOrdersPaymentsV1Refund({}, pickedFields.get('refund'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('notifications')) {
        result.notifications = overrides && overrides.hasOwnProperty('notifications') ? aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsNotificationSideEffectsInput(overrides.notifications ?? {}, pickedFields.get('notifications')) : aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsNotificationSideEffectsInput({}, pickedFields.get('notifications'));
    }
    if (pickedFields.size === 0 || pickedFields.has('restock')) {
        result.restock = overrides && overrides.hasOwnProperty('restock') ? aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockSideEffectsInput(overrides.restock ?? {}, pickedFields.get('restock')) : aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockSideEffectsInput({}, pickedFields.get('restock'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsNotificationSideEffectsInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsNotificationSideEffectsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customMessage')) {
        result.customMessage = overrides && overrides.hasOwnProperty('customMessage') ? overrides.customMessage! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('sendCustomerEmail')) {
        result.sendCustomerEmail = overrides && overrides.hasOwnProperty('sendCustomerEmail') ? overrides.sendCustomerEmail! : false;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockItemInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 9148;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockSideEffectsInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockSideEffectsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockItemInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockItemInput({}, pickedFields.get('lineItems'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1Refundability = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1Refundability>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('manuallyRefundableReason')) {
        result.manuallyRefundableReason = overrides && overrides.hasOwnProperty('manuallyRefundableReason') ? overrides.manuallyRefundableReason! : ComWixEcomOrdersPaymentsCollectorV1RefundabilityManuallyRefundableReason.Expired;
    }
    if (pickedFields.size === 0 || pickedFields.has('nonRefundableReason')) {
        result.nonRefundableReason = overrides && overrides.hasOwnProperty('nonRefundableReason') ? overrides.nonRefundableReason! : ComWixEcomOrdersPaymentsCollectorV1RefundabilityNonRefundableReason.AccessDenied;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerLink')) {
        result.providerLink = overrides && overrides.hasOwnProperty('providerLink') ? overrides.providerLink! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundabilityStatus')) {
        result.refundabilityStatus = overrides && overrides.hasOwnProperty('refundabilityStatus') ? overrides.refundabilityStatus! : ComWixEcomOrdersPaymentsCollectorV1RefundabilityRefundableStatus.Manual;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1ShippingRefund = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1ShippingRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1ShippingRefundInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1ShippingRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1ShippingRefundOption = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1ShippingRefundOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('availableRefundAmount')) {
        result.availableRefundAmount = overrides && overrides.hasOwnProperty('availableRefundAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.availableRefundAmount ?? {}, pickedFields.get('availableRefundAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('availableRefundAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedAmount')) {
        result.refundedAmount = overrides && overrides.hasOwnProperty('refundedAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.refundedAmount ?? {}, pickedFields.get('refundedAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refundedAmount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1TriggerRefundRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1TriggerRefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcomOrdersPaymentsV1RefundDetailsInput(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcomOrdersPaymentsV1RefundDetailsInput({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? overrides.payments!.map((x) => aComWixEcomOrdersPaymentsV1PaymentRefundInput({}, pickedFields.get('payments'))) : [aComWixEcomOrdersPaymentsV1PaymentRefundInput({}, pickedFields.get('payments'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('sideEffects')) {
        result.sideEffects = overrides && overrides.hasOwnProperty('sideEffects') ? aComWixEcomOrdersPaymentsV1RefundSideEffectsInput(overrides.sideEffects ?? {}, pickedFields.get('sideEffects')) : aComWixEcomOrdersPaymentsV1RefundSideEffectsInput({}, pickedFields.get('sideEffects'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1TriggerRefundResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1TriggerRefundResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('failedPaymentIds')) {
        result.failedPaymentIds = overrides && overrides.hasOwnProperty('failedPaymentIds') ? overrides.failedPaymentIds!.map((x) => aWixCommonItemMetadata(x ?? {}, pickedFields.get('failedPaymentIds'))) : [aWixCommonItemMetadata({}, pickedFields.get('failedPaymentIds'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'tempora';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'quis';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentIds')) {
        result.paymentIds = overrides && overrides.hasOwnProperty('paymentIds') ? overrides.paymentIds! : ['minima'];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsResponse = <T extends Partial<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AddChargebackRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1AddChargebackRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('chargeback')) {
        result.chargeback = overrides && overrides.hasOwnProperty('chargeback') ? aComWixEcomOrdersPaymentsV1ChargebackInput(overrides.chargeback ?? {}, pickedFields.get('chargeback')) : aComWixEcomOrdersPaymentsV1ChargebackInput({}, pickedFields.get('chargeback'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'et';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AddChargebackResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1AddChargebackResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('chargeback')) {
        result.chargeback = overrides && overrides.hasOwnProperty('chargeback') ? aComWixEcomOrdersPaymentsV1Chargeback(overrides.chargeback ?? {}, pickedFields.get('chargeback')) : aComWixEcomOrdersPaymentsV1Chargeback({}, pickedFields.get('chargeback'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'consequatur';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AddInvoiceToOrderRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1AddInvoiceToOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoiceInfo')) {
        result.invoiceInfo = overrides && overrides.hasOwnProperty('invoiceInfo') ? aComWixEcomOrdersPaymentsV1InvoiceInfoInput(overrides.invoiceInfo ?? {}, pickedFields.get('invoiceInfo')) : aComWixEcomOrdersPaymentsV1InvoiceInfoInput({}, pickedFields.get('invoiceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'eos';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AddInvoiceToOrderResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1AddInvoiceToOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderInvoices')) {
        result.orderInvoices = overrides && overrides.hasOwnProperty('orderInvoices') ? overrides.orderInvoices!.map((x) => aComWixEcomOrdersPaymentsV1InvoiceInfo(x ?? {}, pickedFields.get('orderInvoices'))) : [aComWixEcomOrdersPaymentsV1InvoiceInfo({}, pickedFields.get('orderInvoices'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AddPaymentsRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1AddPaymentsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? overrides.payments!.map((x) => aComWixEcomOrdersPaymentsV1PaymentInput({}, pickedFields.get('payments'))) : [aComWixEcomOrdersPaymentsV1PaymentInput({}, pickedFields.get('payments'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AddPaymentsResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1AddPaymentsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentsIds')) {
        result.paymentsIds = overrides && overrides.hasOwnProperty('paymentsIds') ? overrides.paymentsIds! : ['qui'];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AddRefundRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1AddRefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? aComWixEcomOrdersPaymentsV1RefundInput(overrides.refund ?? {}, pickedFields.get('refund')) : aComWixEcomOrdersPaymentsV1RefundInput({}, pickedFields.get('refund'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sideEffects')) {
        result.sideEffects = overrides && overrides.hasOwnProperty('sideEffects') ? aComWixEcomOrdersPaymentsV1RefundSideEffectsInput(overrides.sideEffects ?? {}, pickedFields.get('sideEffects')) : aComWixEcomOrdersPaymentsV1RefundSideEffectsInput({}, pickedFields.get('sideEffects'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AddRefundResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1AddRefundResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'totam';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AdditionalFeeRefund = <T extends Partial<ComWixEcomOrdersPaymentsV1AdditionalFeeRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeId')) {
        result.additionalFeeId = overrides && overrides.hasOwnProperty('additionalFeeId') ? overrides.additionalFeeId! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AdditionalFeeRefundInput = <T extends Partial<ComWixEcomOrdersPaymentsV1AdditionalFeeRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeId')) {
        result.additionalFeeId = overrides && overrides.hasOwnProperty('additionalFeeId') ? overrides.additionalFeeId! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AggregatedRefundSummary = <T extends Partial<ComWixEcomOrdersPaymentsV1AggregatedRefundSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('breakdown')) {
        result.breakdown = overrides && overrides.hasOwnProperty('breakdown') ? aComWixEcomOrdersPaymentsV1RefundItemsBreakdown(overrides.breakdown ?? {}, pickedFields.get('breakdown')) : aComWixEcomOrdersPaymentsV1RefundItemsBreakdown({}, pickedFields.get('breakdown'));
    }
    if (pickedFields.size === 0 || pickedFields.has('failedRefundAmount')) {
        result.failedRefundAmount = overrides && overrides.hasOwnProperty('failedRefundAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.failedRefundAmount ?? {}, pickedFields.get('failedRefundAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('failedRefundAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pending')) {
        result.pending = overrides && overrides.hasOwnProperty('pending') ? overrides.pending! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('pendingRefund')) {
        result.pendingRefund = overrides && overrides.hasOwnProperty('pendingRefund') ? aComWixEcommercePlatformCommonApiPrice(overrides.pendingRefund ?? {}, pickedFields.get('pendingRefund')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('pendingRefund'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refunded')) {
        result.refunded = overrides && overrides.hasOwnProperty('refunded') ? aComWixEcommercePlatformCommonApiPrice(overrides.refunded ?? {}, pickedFields.get('refunded')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refunded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('requestedRefund')) {
        result.requestedRefund = overrides && overrides.hasOwnProperty('requestedRefund') ? aComWixEcommercePlatformCommonApiPrice(overrides.requestedRefund ?? {}, pickedFields.get('requestedRefund')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('requestedRefund'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AggregatedRefundSummaryInput = <T extends Partial<ComWixEcomOrdersPaymentsV1AggregatedRefundSummaryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('breakdown')) {
        result.breakdown = overrides && overrides.hasOwnProperty('breakdown') ? aComWixEcomOrdersPaymentsV1RefundItemsBreakdownInput(overrides.breakdown ?? {}, pickedFields.get('breakdown')) : aComWixEcomOrdersPaymentsV1RefundItemsBreakdownInput({}, pickedFields.get('breakdown'));
    }
    if (pickedFields.size === 0 || pickedFields.has('failedRefundAmount')) {
        result.failedRefundAmount = overrides && overrides.hasOwnProperty('failedRefundAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.failedRefundAmount ?? {}, pickedFields.get('failedRefundAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('failedRefundAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pending')) {
        result.pending = overrides && overrides.hasOwnProperty('pending') ? overrides.pending! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('pendingRefund')) {
        result.pendingRefund = overrides && overrides.hasOwnProperty('pendingRefund') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.pendingRefund ?? {}, pickedFields.get('pendingRefund')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('pendingRefund'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refunded')) {
        result.refunded = overrides && overrides.hasOwnProperty('refunded') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.refunded ?? {}, pickedFields.get('refunded')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('refunded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('requestedRefund')) {
        result.requestedRefund = overrides && overrides.hasOwnProperty('requestedRefund') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.requestedRefund ?? {}, pickedFields.get('requestedRefund')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('requestedRefund'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails = <T extends Partial<ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('failureCode')) {
        result.failureCode = overrides && overrides.hasOwnProperty('failureCode') ? overrides.failureCode! : 'non';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput = <T extends Partial<ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('failureCode')) {
        result.failureCode = overrides && overrides.hasOwnProperty('failureCode') ? overrides.failureCode! : 'excepturi';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AuthorizationCapture = <T extends Partial<ComWixEcomOrdersPaymentsV1AuthorizationCapture>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('failureDetails')) {
        result.failureDetails = overrides && overrides.hasOwnProperty('failureDetails') ? aComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails(overrides.failureDetails ?? {}, pickedFields.get('failureDetails')) : aComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails({}, pickedFields.get('failureDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersPaymentsV1AuthorizationCaptureStatusEnumAuthorizationCaptureStatus.Failed;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AuthorizationCaptureInput = <T extends Partial<ComWixEcomOrdersPaymentsV1AuthorizationCaptureInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('failureDetails')) {
        result.failureDetails = overrides && overrides.hasOwnProperty('failureDetails') ? aComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput(overrides.failureDetails ?? {}, pickedFields.get('failureDetails')) : aComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput({}, pickedFields.get('failureDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersPaymentsV1AuthorizationCaptureStatusEnumAuthorizationCaptureStatus.Failed;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AuthorizationDetails = <T extends Partial<ComWixEcomOrdersPaymentsV1AuthorizationDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorizedDate')) {
        result.authorizedDate = overrides && overrides.hasOwnProperty('authorizedDate') ? overrides.authorizedDate! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('captures')) {
        result.captures = overrides && overrides.hasOwnProperty('captures') ? overrides.captures!.map((x) => aComWixEcomOrdersPaymentsV1AuthorizationCapture(x ?? {}, pickedFields.get('captures'))) : [aComWixEcomOrdersPaymentsV1AuthorizationCapture({}, pickedFields.get('captures'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('delayedCapture')) {
        result.delayedCapture = overrides && overrides.hasOwnProperty('delayedCapture') ? overrides.delayedCapture! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduledAction')) {
        result.scheduledAction = overrides && overrides.hasOwnProperty('scheduledAction') ? aComWixEcomOrdersPaymentsV1ScheduledAction(overrides.scheduledAction ?? {}, pickedFields.get('scheduledAction')) : aComWixEcomOrdersPaymentsV1ScheduledAction({}, pickedFields.get('scheduledAction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('void')) {
        result.void = overrides && overrides.hasOwnProperty('void') ? aComWixEcomOrdersPaymentsV1AuthorizationVoid(overrides.void ?? {}, pickedFields.get('void')) : aComWixEcomOrdersPaymentsV1AuthorizationVoid({}, pickedFields.get('void'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AuthorizationDetailsInput = <T extends Partial<ComWixEcomOrdersPaymentsV1AuthorizationDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorizedDate')) {
        result.authorizedDate = overrides && overrides.hasOwnProperty('authorizedDate') ? overrides.authorizedDate! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('captures')) {
        result.captures = overrides && overrides.hasOwnProperty('captures') ? overrides.captures!.map((x) => aComWixEcomOrdersPaymentsV1AuthorizationCaptureInput({}, pickedFields.get('captures'))) : [aComWixEcomOrdersPaymentsV1AuthorizationCaptureInput({}, pickedFields.get('captures'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('delayedCapture')) {
        result.delayedCapture = overrides && overrides.hasOwnProperty('delayedCapture') ? overrides.delayedCapture! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduledAction')) {
        result.scheduledAction = overrides && overrides.hasOwnProperty('scheduledAction') ? aComWixEcomOrdersPaymentsV1ScheduledActionInput(overrides.scheduledAction ?? {}, pickedFields.get('scheduledAction')) : aComWixEcomOrdersPaymentsV1ScheduledActionInput({}, pickedFields.get('scheduledAction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('void')) {
        result.void = overrides && overrides.hasOwnProperty('void') ? aComWixEcomOrdersPaymentsV1AuthorizationVoidInput(overrides.void ?? {}, pickedFields.get('void')) : aComWixEcomOrdersPaymentsV1AuthorizationVoidInput({}, pickedFields.get('void'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AuthorizationVoid = <T extends Partial<ComWixEcomOrdersPaymentsV1AuthorizationVoid>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('failureDetails')) {
        result.failureDetails = overrides && overrides.hasOwnProperty('failureDetails') ? aComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails(overrides.failureDetails ?? {}, pickedFields.get('failureDetails')) : aComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails({}, pickedFields.get('failureDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : ComWixEcomOrdersPaymentsV1AuthorizationVoidReason.Manual;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersPaymentsV1AuthorizationVoidStatusEnumAuthorizationVoidStatus.Failed;
    }
    if (pickedFields.size === 0 || pickedFields.has('voidedDate')) {
        result.voidedDate = overrides && overrides.hasOwnProperty('voidedDate') ? overrides.voidedDate! : 'aspernatur';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1AuthorizationVoidInput = <T extends Partial<ComWixEcomOrdersPaymentsV1AuthorizationVoidInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('failureDetails')) {
        result.failureDetails = overrides && overrides.hasOwnProperty('failureDetails') ? aComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput(overrides.failureDetails ?? {}, pickedFields.get('failureDetails')) : aComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput({}, pickedFields.get('failureDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : ComWixEcomOrdersPaymentsV1AuthorizationVoidReason.Manual;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersPaymentsV1AuthorizationVoidStatusEnumAuthorizationVoidStatus.Failed;
    }
    if (pickedFields.size === 0 || pickedFields.has('voidedDate')) {
        result.voidedDate = overrides && overrides.hasOwnProperty('voidedDate') ? overrides.voidedDate! : 'voluptatem';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1BulkGenerateInvoicesRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1BulkGenerateInvoicesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderIds')) {
        result.orderIds = overrides && overrides.hasOwnProperty('orderIds') ? overrides.orderIds! : ['commodi'];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1BulkGenerateInvoicesResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1BulkGenerateInvoicesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersPaymentsV1BulkInvoiceResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersPaymentsV1BulkInvoiceResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1BulkInvoiceResult = <T extends Partial<ComWixEcomOrdersPaymentsV1BulkInvoiceResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixEcomOrdersPaymentsV1InvoiceForOrder(overrides.item ?? {}, pickedFields.get('item')) : aComWixEcomOrdersPaymentsV1InvoiceForOrder({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1BulkPaymentResult = <T extends Partial<ComWixEcomOrdersPaymentsV1BulkPaymentResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixEcomOrdersPaymentsV1Payment(overrides.item ?? {}, pickedFields.get('item')) : aComWixEcomOrdersPaymentsV1Payment({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentAndOrderIds')) {
        result.paymentAndOrderIds = overrides && overrides.hasOwnProperty('paymentAndOrderIds') ? overrides.paymentAndOrderIds!.map((x) => aComWixEcomOrdersPaymentsV1PaymentAndOrderIdInput({}, pickedFields.get('paymentAndOrderIds'))) : [aComWixEcomOrdersPaymentsV1PaymentAndOrderIdInput({}, pickedFields.get('paymentAndOrderIds'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixPaymentApiPayV3TransactionTransactionStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('statusUpdatedDate')) {
        result.statusUpdatedDate = overrides && overrides.hasOwnProperty('statusUpdatedDate') ? overrides.statusUpdatedDate! : 'ducimus';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersPaymentsV1BulkPaymentResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersPaymentsV1BulkPaymentResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1CalculateRefundItemRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1CalculateRefundItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 5019;
    }
    if (pickedFields.size === 0 || pickedFields.has('restock')) {
        result.restock = overrides && overrides.hasOwnProperty('restock') ? overrides.restock! : false;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1CalculateRefundItemResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1CalculateRefundItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemPrice')) {
        result.lineItemPrice = overrides && overrides.hasOwnProperty('lineItemPrice') ? overrides.lineItemPrice! : 1.1;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1CalculateRefundRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1CalculateRefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundItems')) {
        result.refundItems = overrides && overrides.hasOwnProperty('refundItems') ? overrides.refundItems!.map((x) => aComWixEcomOrdersPaymentsV1CalculateRefundItemRequestInput({}, pickedFields.get('refundItems'))) : [aComWixEcomOrdersPaymentsV1CalculateRefundItemRequestInput({}, pickedFields.get('refundItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('refundShipping')) {
        result.refundShipping = overrides && overrides.hasOwnProperty('refundShipping') ? overrides.refundShipping! : true;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1CalculateRefundResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1CalculateRefundResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? overrides.discount! : 'hic';
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixEcomOrdersPaymentsV1CalculateRefundItemResponse(x ?? {}, pickedFields.get('items'))) : [aComWixEcomOrdersPaymentsV1CalculateRefundItemResponse({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('previouslyRefundedAmount')) {
        result.previouslyRefundedAmount = overrides && overrides.hasOwnProperty('previouslyRefundedAmount') ? overrides.previouslyRefundedAmount! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? overrides.subtotal! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 'qui';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1Chargeback = <T extends Partial<ComWixEcomOrdersPaymentsV1Chargeback>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('reversalAmount')) {
        result.reversalAmount = overrides && overrides.hasOwnProperty('reversalAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.reversalAmount ?? {}, pickedFields.get('reversalAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('reversalAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersPaymentsV1ChargebackStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'ut';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ChargebackInput = <T extends Partial<ComWixEcomOrdersPaymentsV1ChargebackInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('reversalAmount')) {
        result.reversalAmount = overrides && overrides.hasOwnProperty('reversalAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.reversalAmount ?? {}, pickedFields.get('reversalAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('reversalAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersPaymentsV1ChargebackStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'nostrum';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails = <T extends Partial<ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'aliquam';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetailsInput = <T extends Partial<ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'non';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ExternalReceiptInfo = <T extends Partial<ComWixEcomOrdersPaymentsV1ExternalReceiptInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('displayNumber')) {
        result.displayNumber = overrides && overrides.hasOwnProperty('displayNumber') ? overrides.displayNumber! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'recusandae';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ExternalReceiptInfoInput = <T extends Partial<ComWixEcomOrdersPaymentsV1ExternalReceiptInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('displayNumber')) {
        result.displayNumber = overrides && overrides.hasOwnProperty('displayNumber') ? overrides.displayNumber! : 'nisi';
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'et';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1GenerateInvoiceRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1GenerateInvoiceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'id';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1GenerateInvoiceResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1GenerateInvoiceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoiceId')) {
        result.invoiceId = overrides && overrides.hasOwnProperty('invoiceId') ? overrides.invoiceId! : 'aspernatur';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1GetOrderTransactionsRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1GetOrderTransactionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e52377df-2781-4dd9-87ec-ba16cf99092c';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1GetRefundabilityStatusRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1GetRefundabilityStatusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'fuga';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1GetRefundabilityStatusResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1GetRefundabilityStatusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('refundabilities')) {
        result.refundabilities = overrides && overrides.hasOwnProperty('refundabilities') ? overrides.refundabilities!.map((x) => aComWixEcomOrdersPaymentsV1Refundability(x ?? {}, pickedFields.get('refundabilities'))) : [aComWixEcomOrdersPaymentsV1Refundability({}, pickedFields.get('refundabilities'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('refundablePerItem')) {
        result.refundablePerItem = overrides && overrides.hasOwnProperty('refundablePerItem') ? overrides.refundablePerItem! : true;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1GiftCardPaymentDetails = <T extends Partial<ComWixEcomOrdersPaymentsV1GiftCardPaymentDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardPaymentId')) {
        result.giftCardPaymentId = overrides && overrides.hasOwnProperty('giftCardPaymentId') ? overrides.giftCardPaymentId! : 'nisi';
    }
    if (pickedFields.size === 0 || pickedFields.has('obfuscatedCode')) {
        result.obfuscatedCode = overrides && overrides.hasOwnProperty('obfuscatedCode') ? overrides.obfuscatedCode! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('voided')) {
        result.voided = overrides && overrides.hasOwnProperty('voided') ? overrides.voided! : false;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1GiftCardPaymentDetailsInput = <T extends Partial<ComWixEcomOrdersPaymentsV1GiftCardPaymentDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardPaymentId')) {
        result.giftCardPaymentId = overrides && overrides.hasOwnProperty('giftCardPaymentId') ? overrides.giftCardPaymentId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('obfuscatedCode')) {
        result.obfuscatedCode = overrides && overrides.hasOwnProperty('obfuscatedCode') ? overrides.obfuscatedCode! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('voided')) {
        result.voided = overrides && overrides.hasOwnProperty('voided') ? overrides.voided! : true;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1InvoiceForOrder = <T extends Partial<ComWixEcomOrdersPaymentsV1InvoiceForOrder>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoiceId')) {
        result.invoiceId = overrides && overrides.hasOwnProperty('invoiceId') ? overrides.invoiceId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'ad';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1InvoiceInfo = <T extends Partial<ComWixEcomOrdersPaymentsV1InvoiceInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'molestias';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1InvoiceInfoInput = <T extends Partial<ComWixEcomOrdersPaymentsV1InvoiceInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'in';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1InvoicesForOrder = <T extends Partial<ComWixEcomOrdersPaymentsV1InvoicesForOrder>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoicesInfo')) {
        result.invoicesInfo = overrides && overrides.hasOwnProperty('invoicesInfo') ? overrides.invoicesInfo!.map((x) => aComWixEcomOrdersPaymentsV1InvoiceInfo(x ?? {}, pickedFields.get('invoicesInfo'))) : [aComWixEcomOrdersPaymentsV1InvoiceInfo({}, pickedFields.get('invoicesInfo'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'harum';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1LineItemRefund = <T extends Partial<ComWixEcomOrdersPaymentsV1LineItemRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 5310;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1LineItemRefundInput = <T extends Partial<ComWixEcomOrdersPaymentsV1LineItemRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'natus';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 1180;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1LineItemRefundSummary = <T extends Partial<ComWixEcomOrdersPaymentsV1LineItemRefundSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalRefundedAmount')) {
        result.totalRefundedAmount = overrides && overrides.hasOwnProperty('totalRefundedAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalRefundedAmount ?? {}, pickedFields.get('totalRefundedAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalRefundedAmount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1LineItemRefundSummaryInput = <T extends Partial<ComWixEcomOrdersPaymentsV1LineItemRefundSummaryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalRefundedAmount')) {
        result.totalRefundedAmount = overrides && overrides.hasOwnProperty('totalRefundedAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalRefundedAmount ?? {}, pickedFields.get('totalRefundedAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalRefundedAmount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderIds')) {
        result.orderIds = overrides && overrides.hasOwnProperty('orderIds') ? overrides.orderIds! : ['illum'];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoicesForOrder')) {
        result.invoicesForOrder = overrides && overrides.hasOwnProperty('invoicesForOrder') ? overrides.invoicesForOrder!.map((x) => aComWixEcomOrdersPaymentsV1InvoicesForOrder(x ?? {}, pickedFields.get('invoicesForOrder'))) : [aComWixEcomOrdersPaymentsV1InvoicesForOrder({}, pickedFields.get('invoicesForOrder'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'accusamus';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('invoices')) {
        result.invoices = overrides && overrides.hasOwnProperty('invoices') ? overrides.invoices!.map((x) => aComWixEcomOrdersPaymentsV1InvoiceInfo(x ?? {}, pickedFields.get('invoices'))) : [aComWixEcomOrdersPaymentsV1InvoiceInfo({}, pickedFields.get('invoices'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderIds')) {
        result.orderIds = overrides && overrides.hasOwnProperty('orderIds') ? overrides.orderIds! : ['reprehenderit'];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? overrides.orderTransactions!.map((x) => aComWixEcomOrdersPaymentsV1OrderTransactions(x ?? {}, pickedFields.get('orderTransactions'))) : [aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'architecto';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1MaskedPaymentInput = <T extends Partial<ComWixEcomOrdersPaymentsV1MaskedPaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['iste'];
    }
    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aComWixEcomOrdersPaymentsV1PaymentInput(overrides.payment ?? {}, pickedFields.get('payment')) : aComWixEcomOrdersPaymentsV1PaymentInput({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('statusUpdatedDate')) {
        result.statusUpdatedDate = overrides && overrides.hasOwnProperty('statusUpdatedDate') ? overrides.statusUpdatedDate! : 'voluptates';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1MembershipPaymentDetails = <T extends Partial<ComWixEcomOrdersPaymentsV1MembershipPaymentDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalTransactionId')) {
        result.externalTransactionId = overrides && overrides.hasOwnProperty('externalTransactionId') ? overrides.externalTransactionId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipId')) {
        result.membershipId = overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomMembershipsSpiV1MembershipName(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomMembershipsSpiV1MembershipName({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerAppId')) {
        result.providerAppId = overrides && overrides.hasOwnProperty('providerAppId') ? overrides.providerAppId! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersPaymentsV1MembershipPaymentStatus.Charged;
    }
    if (pickedFields.size === 0 || pickedFields.has('voided')) {
        result.voided = overrides && overrides.hasOwnProperty('voided') ? overrides.voided! : false;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1MembershipPaymentDetailsInput = <T extends Partial<ComWixEcomOrdersPaymentsV1MembershipPaymentDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalTransactionId')) {
        result.externalTransactionId = overrides && overrides.hasOwnProperty('externalTransactionId') ? overrides.externalTransactionId! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'debitis';
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipId')) {
        result.membershipId = overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomMembershipsSpiV1MembershipNameInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomMembershipsSpiV1MembershipNameInput({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerAppId')) {
        result.providerAppId = overrides && overrides.hasOwnProperty('providerAppId') ? overrides.providerAppId! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersPaymentsV1MembershipPaymentStatus.Charged;
    }
    if (pickedFields.size === 0 || pickedFields.has('voided')) {
        result.voided = overrides && overrides.hasOwnProperty('voided') ? overrides.voided! : true;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1OrderTransactions = <T extends Partial<ComWixEcomOrdersPaymentsV1OrderTransactions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? overrides.payments!.map((x) => aComWixEcomOrdersPaymentsV1Payment(x ?? {}, pickedFields.get('payments'))) : [aComWixEcomOrdersPaymentsV1Payment({}, pickedFields.get('payments'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('refunds')) {
        result.refunds = overrides && overrides.hasOwnProperty('refunds') ? overrides.refunds!.map((x) => aComWixEcomOrdersPaymentsV1Refund(x ?? {}, pickedFields.get('refunds'))) : [aComWixEcomOrdersPaymentsV1Refund({}, pickedFields.get('refunds'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1Payment = <T extends Partial<ComWixEcomOrdersPaymentsV1Payment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReceipt')) {
        result.externalReceipt = overrides && overrides.hasOwnProperty('externalReceipt') ? aComWixEcomOrdersPaymentsV1ExternalReceiptInfo(overrides.externalReceipt ?? {}, pickedFields.get('externalReceipt')) : aComWixEcomOrdersPaymentsV1ExternalReceiptInfo({}, pickedFields.get('externalReceipt'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftcardPaymentDetails')) {
        result.giftcardPaymentDetails = overrides && overrides.hasOwnProperty('giftcardPaymentDetails') ? aComWixEcomOrdersPaymentsV1GiftCardPaymentDetails(overrides.giftcardPaymentDetails ?? {}, pickedFields.get('giftcardPaymentDetails')) : aComWixEcomOrdersPaymentsV1GiftCardPaymentDetails({}, pickedFields.get('giftcardPaymentDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipPaymentDetails')) {
        result.membershipPaymentDetails = overrides && overrides.hasOwnProperty('membershipPaymentDetails') ? aComWixEcomOrdersPaymentsV1MembershipPaymentDetails(overrides.membershipPaymentDetails ?? {}, pickedFields.get('membershipPaymentDetails')) : aComWixEcomOrdersPaymentsV1MembershipPaymentDetails({}, pickedFields.get('membershipPaymentDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundDisabled')) {
        result.refundDisabled = overrides && overrides.hasOwnProperty('refundDisabled') ? overrides.refundDisabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('regularPaymentDetails')) {
        result.regularPaymentDetails = overrides && overrides.hasOwnProperty('regularPaymentDetails') ? aComWixEcomOrdersPaymentsV1RegularPaymentDetails(overrides.regularPaymentDetails ?? {}, pickedFields.get('regularPaymentDetails')) : aComWixEcomOrdersPaymentsV1RegularPaymentDetails({}, pickedFields.get('regularPaymentDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('supportReceiptGeneration')) {
        result.supportReceiptGeneration = overrides && overrides.hasOwnProperty('supportReceiptGeneration') ? overrides.supportReceiptGeneration! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixReceipt')) {
        result.wixReceipt = overrides && overrides.hasOwnProperty('wixReceipt') ? aComWixEcomOrdersPaymentsV1WixReceiptInfo(overrides.wixReceipt ?? {}, pickedFields.get('wixReceipt')) : aComWixEcomOrdersPaymentsV1WixReceiptInfo({}, pickedFields.get('wixReceipt'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1PaymentAndOrderIdInput = <T extends Partial<ComWixEcomOrdersPaymentsV1PaymentAndOrderIdInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'quia';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1PaymentInput = <T extends Partial<ComWixEcomOrdersPaymentsV1PaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReceipt')) {
        result.externalReceipt = overrides && overrides.hasOwnProperty('externalReceipt') ? aComWixEcomOrdersPaymentsV1ExternalReceiptInfoInput(overrides.externalReceipt ?? {}, pickedFields.get('externalReceipt')) : aComWixEcomOrdersPaymentsV1ExternalReceiptInfoInput({}, pickedFields.get('externalReceipt'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftcardPaymentDetails')) {
        result.giftcardPaymentDetails = overrides && overrides.hasOwnProperty('giftcardPaymentDetails') ? aComWixEcomOrdersPaymentsV1GiftCardPaymentDetailsInput(overrides.giftcardPaymentDetails ?? {}, pickedFields.get('giftcardPaymentDetails')) : aComWixEcomOrdersPaymentsV1GiftCardPaymentDetailsInput({}, pickedFields.get('giftcardPaymentDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipPaymentDetails')) {
        result.membershipPaymentDetails = overrides && overrides.hasOwnProperty('membershipPaymentDetails') ? aComWixEcomOrdersPaymentsV1MembershipPaymentDetailsInput(overrides.membershipPaymentDetails ?? {}, pickedFields.get('membershipPaymentDetails')) : aComWixEcomOrdersPaymentsV1MembershipPaymentDetailsInput({}, pickedFields.get('membershipPaymentDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundDisabled')) {
        result.refundDisabled = overrides && overrides.hasOwnProperty('refundDisabled') ? overrides.refundDisabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('regularPaymentDetails')) {
        result.regularPaymentDetails = overrides && overrides.hasOwnProperty('regularPaymentDetails') ? aComWixEcomOrdersPaymentsV1RegularPaymentDetailsInput(overrides.regularPaymentDetails ?? {}, pickedFields.get('regularPaymentDetails')) : aComWixEcomOrdersPaymentsV1RegularPaymentDetailsInput({}, pickedFields.get('regularPaymentDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('supportReceiptGeneration')) {
        result.supportReceiptGeneration = overrides && overrides.hasOwnProperty('supportReceiptGeneration') ? overrides.supportReceiptGeneration! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixReceipt')) {
        result.wixReceipt = overrides && overrides.hasOwnProperty('wixReceipt') ? aComWixEcomOrdersPaymentsV1WixReceiptInfoInput(overrides.wixReceipt ?? {}, pickedFields.get('wixReceipt')) : aComWixEcomOrdersPaymentsV1WixReceiptInfoInput({}, pickedFields.get('wixReceipt'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1PaymentRefundInput = <T extends Partial<ComWixEcomOrdersPaymentsV1PaymentRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalRefund')) {
        result.externalRefund = overrides && overrides.hasOwnProperty('externalRefund') ? overrides.externalRefund! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('gatewayRefundId')) {
        result.gatewayRefundId = overrides && overrides.hasOwnProperty('gatewayRefundId') ? overrides.gatewayRefundId! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'est';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1QueryOrderTransactionsRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1QueryOrderTransactionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1QueryOrderTransactionsResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1QueryOrderTransactionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixEcomOrdersPaymentsV1OrderTransactions(x ?? {}, pickedFields.get('items'))) : [aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1Refund = <T extends Partial<ComWixEcomOrdersPaymentsV1Refund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'sequi';
    }
    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcomOrdersPaymentsV1RefundDetails(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcomOrdersPaymentsV1RefundDetails({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('requestingServiceAppId')) {
        result.requestingServiceAppId = overrides && overrides.hasOwnProperty('requestingServiceAppId') ? overrides.requestingServiceAppId! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('summary')) {
        result.summary = overrides && overrides.hasOwnProperty('summary') ? aComWixEcomOrdersPaymentsV1AggregatedRefundSummary(overrides.summary ?? {}, pickedFields.get('summary')) : aComWixEcomOrdersPaymentsV1AggregatedRefundSummary({}, pickedFields.get('summary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactions')) {
        result.transactions = overrides && overrides.hasOwnProperty('transactions') ? overrides.transactions!.map((x) => aComWixEcomOrdersPaymentsV1RefundTransaction(x ?? {}, pickedFields.get('transactions'))) : [aComWixEcomOrdersPaymentsV1RefundTransaction({}, pickedFields.get('transactions'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundDetails = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomOrdersPaymentsV1AdditionalFeeRefund(x ?? {}, pickedFields.get('additionalFees'))) : [aComWixEcomOrdersPaymentsV1AdditionalFeeRefund({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixEcomOrdersPaymentsV1RefundItem(x ?? {}, pickedFields.get('items'))) : [aComWixEcomOrdersPaymentsV1RefundItem({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersPaymentsV1LineItemRefund(x ?? {}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersPaymentsV1LineItemRefund({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcomOrdersPaymentsV1ShippingRefund(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcomOrdersPaymentsV1ShippingRefund({}, pickedFields.get('shipping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingIncluded')) {
        result.shippingIncluded = overrides && overrides.hasOwnProperty('shippingIncluded') ? overrides.shippingIncluded! : false;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundDetailsInput = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomOrdersPaymentsV1AdditionalFeeRefundInput({}, pickedFields.get('additionalFees'))) : [aComWixEcomOrdersPaymentsV1AdditionalFeeRefundInput({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixEcomOrdersPaymentsV1RefundItemInput({}, pickedFields.get('items'))) : [aComWixEcomOrdersPaymentsV1RefundItemInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersPaymentsV1LineItemRefundInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersPaymentsV1LineItemRefundInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcomOrdersPaymentsV1ShippingRefundInput(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcomOrdersPaymentsV1ShippingRefundInput({}, pickedFields.get('shipping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingIncluded')) {
        result.shippingIncluded = overrides && overrides.hasOwnProperty('shippingIncluded') ? overrides.shippingIncluded! : true;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundInput = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcomOrdersPaymentsV1RefundDetailsInput(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcomOrdersPaymentsV1RefundDetailsInput({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('requestingServiceAppId')) {
        result.requestingServiceAppId = overrides && overrides.hasOwnProperty('requestingServiceAppId') ? overrides.requestingServiceAppId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('summary')) {
        result.summary = overrides && overrides.hasOwnProperty('summary') ? aComWixEcomOrdersPaymentsV1AggregatedRefundSummaryInput(overrides.summary ?? {}, pickedFields.get('summary')) : aComWixEcomOrdersPaymentsV1AggregatedRefundSummaryInput({}, pickedFields.get('summary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactions')) {
        result.transactions = overrides && overrides.hasOwnProperty('transactions') ? overrides.transactions!.map((x) => aComWixEcomOrdersPaymentsV1RefundTransactionInput({}, pickedFields.get('transactions'))) : [aComWixEcomOrdersPaymentsV1RefundTransactionInput({}, pickedFields.get('transactions'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundItem = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 4622;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundItemInput = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 6601;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundItemsBreakdown = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundItemsBreakdown>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersPaymentsV1LineItemRefundSummary(x ?? {}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersPaymentsV1LineItemRefundSummary({}, pickedFields.get('lineItems'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundItemsBreakdownInput = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundItemsBreakdownInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersPaymentsV1LineItemRefundSummaryInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersPaymentsV1LineItemRefundSummaryInput({}, pickedFields.get('lineItems'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundSideEffectsInput = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundSideEffectsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customMessage')) {
        result.customMessage = overrides && overrides.hasOwnProperty('customMessage') ? overrides.customMessage! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('restockInfo')) {
        result.restockInfo = overrides && overrides.hasOwnProperty('restockInfo') ? aComWixEcomOrdersPaymentsV1RestockInfoInput(overrides.restockInfo ?? {}, pickedFields.get('restockInfo')) : aComWixEcomOrdersPaymentsV1RestockInfoInput({}, pickedFields.get('restockInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sendOrderRefundedEmail')) {
        result.sendOrderRefundedEmail = overrides && overrides.hasOwnProperty('sendOrderRefundedEmail') ? overrides.sendOrderRefundedEmail! : true;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundStatusInfo = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundStatusInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayReasonCode')) {
        result.paymentGatewayReasonCode = overrides && overrides.hasOwnProperty('paymentGatewayReasonCode') ? overrides.paymentGatewayReasonCode! : 'est';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundStatusInfoInput = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundStatusInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayReasonCode')) {
        result.paymentGatewayReasonCode = overrides && overrides.hasOwnProperty('paymentGatewayReasonCode') ? overrides.paymentGatewayReasonCode! : 'iusto';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundTransaction = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundTransaction>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalRefund')) {
        result.externalRefund = overrides && overrides.hasOwnProperty('externalRefund') ? overrides.externalRefund! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('gatewayRefundId')) {
        result.gatewayRefundId = overrides && overrides.hasOwnProperty('gatewayRefundId') ? overrides.gatewayRefundId! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerRefundId')) {
        result.providerRefundId = overrides && overrides.hasOwnProperty('providerRefundId') ? overrides.providerRefundId! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundStatus')) {
        result.refundStatus = overrides && overrides.hasOwnProperty('refundStatus') ? overrides.refundStatus! : ComWixEcomOrdersPaymentsV1RefundStatus.Failed;
    }
    if (pickedFields.size === 0 || pickedFields.has('refundStatusInfo')) {
        result.refundStatusInfo = overrides && overrides.hasOwnProperty('refundStatusInfo') ? aComWixEcomOrdersPaymentsV1RefundStatusInfo(overrides.refundStatusInfo ?? {}, pickedFields.get('refundStatusInfo')) : aComWixEcomOrdersPaymentsV1RefundStatusInfo({}, pickedFields.get('refundStatusInfo'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RefundTransactionInput = <T extends Partial<ComWixEcomOrdersPaymentsV1RefundTransactionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalRefund')) {
        result.externalRefund = overrides && overrides.hasOwnProperty('externalRefund') ? overrides.externalRefund! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('gatewayRefundId')) {
        result.gatewayRefundId = overrides && overrides.hasOwnProperty('gatewayRefundId') ? overrides.gatewayRefundId! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerRefundId')) {
        result.providerRefundId = overrides && overrides.hasOwnProperty('providerRefundId') ? overrides.providerRefundId! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundStatus')) {
        result.refundStatus = overrides && overrides.hasOwnProperty('refundStatus') ? overrides.refundStatus! : ComWixEcomOrdersPaymentsV1RefundStatus.Failed;
    }
    if (pickedFields.size === 0 || pickedFields.has('refundStatusInfo')) {
        result.refundStatusInfo = overrides && overrides.hasOwnProperty('refundStatusInfo') ? aComWixEcomOrdersPaymentsV1RefundStatusInfoInput(overrides.refundStatusInfo ?? {}, pickedFields.get('refundStatusInfo')) : aComWixEcomOrdersPaymentsV1RefundStatusInfoInput({}, pickedFields.get('refundStatusInfo'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1Refundability = <T extends Partial<ComWixEcomOrdersPaymentsV1Refundability>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('manuallyRefundableReason')) {
        result.manuallyRefundableReason = overrides && overrides.hasOwnProperty('manuallyRefundableReason') ? overrides.manuallyRefundableReason! : ComWixEcomOrdersPaymentsV1RefundabilityManuallyRefundableReason.Expired;
    }
    if (pickedFields.size === 0 || pickedFields.has('nonRefundableReason')) {
        result.nonRefundableReason = overrides && overrides.hasOwnProperty('nonRefundableReason') ? overrides.nonRefundableReason! : ComWixEcomOrdersPaymentsV1RefundabilityNonRefundableReason.AccessDenied;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerLink')) {
        result.providerLink = overrides && overrides.hasOwnProperty('providerLink') ? overrides.providerLink! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundabilityStatus')) {
        result.refundabilityStatus = overrides && overrides.hasOwnProperty('refundabilityStatus') ? overrides.refundabilityStatus! : ComWixEcomOrdersPaymentsV1RefundabilityRefundableStatus.Manual;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RegularPaymentDetails = <T extends Partial<ComWixEcomOrdersPaymentsV1RegularPaymentDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorizationDetails')) {
        result.authorizationDetails = overrides && overrides.hasOwnProperty('authorizationDetails') ? aComWixEcomOrdersPaymentsV1AuthorizationDetails(overrides.authorizationDetails ?? {}, pickedFields.get('authorizationDetails')) : aComWixEcomOrdersPaymentsV1AuthorizationDetails({}, pickedFields.get('authorizationDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebacks')) {
        result.chargebacks = overrides && overrides.hasOwnProperty('chargebacks') ? overrides.chargebacks!.map((x) => aComWixEcomOrdersPaymentsV1Chargeback(x ?? {}, pickedFields.get('chargebacks'))) : [aComWixEcomOrdersPaymentsV1Chargeback({}, pickedFields.get('chargebacks'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('creditCardDetails')) {
        result.creditCardDetails = overrides && overrides.hasOwnProperty('creditCardDetails') ? aComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails(overrides.creditCardDetails ?? {}, pickedFields.get('creditCardDetails')) : aComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails({}, pickedFields.get('creditCardDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('gatewayTransactionId')) {
        result.gatewayTransactionId = overrides && overrides.hasOwnProperty('gatewayTransactionId') ? overrides.gatewayTransactionId! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('offlinePayment')) {
        result.offlinePayment = overrides && overrides.hasOwnProperty('offlinePayment') ? overrides.offlinePayment! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? overrides.paymentMethod! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOrderId')) {
        result.paymentOrderId = overrides && overrides.hasOwnProperty('paymentOrderId') ? overrides.paymentOrderId! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentProvider')) {
        result.paymentProvider = overrides && overrides.hasOwnProperty('paymentProvider') ? overrides.paymentProvider! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerTransactionId')) {
        result.providerTransactionId = overrides && overrides.hasOwnProperty('providerTransactionId') ? overrides.providerTransactionId! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethod')) {
        result.savedPaymentMethod = overrides && overrides.hasOwnProperty('savedPaymentMethod') ? overrides.savedPaymentMethod! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixPaymentApiPayV3TransactionTransactionStatus.Approved;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RegularPaymentDetailsInput = <T extends Partial<ComWixEcomOrdersPaymentsV1RegularPaymentDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorizationDetails')) {
        result.authorizationDetails = overrides && overrides.hasOwnProperty('authorizationDetails') ? aComWixEcomOrdersPaymentsV1AuthorizationDetailsInput(overrides.authorizationDetails ?? {}, pickedFields.get('authorizationDetails')) : aComWixEcomOrdersPaymentsV1AuthorizationDetailsInput({}, pickedFields.get('authorizationDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebacks')) {
        result.chargebacks = overrides && overrides.hasOwnProperty('chargebacks') ? overrides.chargebacks!.map((x) => aComWixEcomOrdersPaymentsV1ChargebackInput({}, pickedFields.get('chargebacks'))) : [aComWixEcomOrdersPaymentsV1ChargebackInput({}, pickedFields.get('chargebacks'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('creditCardDetails')) {
        result.creditCardDetails = overrides && overrides.hasOwnProperty('creditCardDetails') ? aComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetailsInput(overrides.creditCardDetails ?? {}, pickedFields.get('creditCardDetails')) : aComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetailsInput({}, pickedFields.get('creditCardDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('gatewayTransactionId')) {
        result.gatewayTransactionId = overrides && overrides.hasOwnProperty('gatewayTransactionId') ? overrides.gatewayTransactionId! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('offlinePayment')) {
        result.offlinePayment = overrides && overrides.hasOwnProperty('offlinePayment') ? overrides.offlinePayment! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? overrides.paymentMethod! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOrderId')) {
        result.paymentOrderId = overrides && overrides.hasOwnProperty('paymentOrderId') ? overrides.paymentOrderId! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentProvider')) {
        result.paymentProvider = overrides && overrides.hasOwnProperty('paymentProvider') ? overrides.paymentProvider! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerTransactionId')) {
        result.providerTransactionId = overrides && overrides.hasOwnProperty('providerTransactionId') ? overrides.providerTransactionId! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethod')) {
        result.savedPaymentMethod = overrides && overrides.hasOwnProperty('savedPaymentMethod') ? overrides.savedPaymentMethod! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixPaymentApiPayV3TransactionTransactionStatus.Approved;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RestockInfoInput = <T extends Partial<ComWixEcomOrdersPaymentsV1RestockInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixEcomOrdersPaymentsV1RestockItemInput({}, pickedFields.get('items'))) : [aComWixEcomOrdersPaymentsV1RestockItemInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['illum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcomOrdersPaymentsV1RestockInfoRestockType.AllItems;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1RestockItemInput = <T extends Partial<ComWixEcomOrdersPaymentsV1RestockItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8786;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ReverseChargebackRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1ReverseChargebackRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('chargebackId')) {
        result.chargebackId = overrides && overrides.hasOwnProperty('chargebackId') ? overrides.chargebackId! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('reversalAmount')) {
        result.reversalAmount = overrides && overrides.hasOwnProperty('reversalAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.reversalAmount ?? {}, pickedFields.get('reversalAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('reversalAmount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ReverseChargebackResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1ReverseChargebackResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ScheduledAction = <T extends Partial<ComWixEcomOrdersPaymentsV1ScheduledAction>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('actionType')) {
        result.actionType = overrides && overrides.hasOwnProperty('actionType') ? overrides.actionType! : ComWixEcomOrdersPaymentsV1ScheduledActionActionType.Capture;
    }
    if (pickedFields.size === 0 || pickedFields.has('executionDate')) {
        result.executionDate = overrides && overrides.hasOwnProperty('executionDate') ? overrides.executionDate! : 'cumque';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ScheduledActionInput = <T extends Partial<ComWixEcomOrdersPaymentsV1ScheduledActionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('actionType')) {
        result.actionType = overrides && overrides.hasOwnProperty('actionType') ? overrides.actionType! : ComWixEcomOrdersPaymentsV1ScheduledActionActionType.Capture;
    }
    if (pickedFields.size === 0 || pickedFields.has('executionDate')) {
        result.executionDate = overrides && overrides.hasOwnProperty('executionDate') ? overrides.executionDate! : 'ipsam';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1SearchOrderTransactionsRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1SearchOrderTransactionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorSearchInput(overrides.search ?? {}, pickedFields.get('search')) : aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorSearchInput({}, pickedFields.get('search'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1SearchOrderTransactionsResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1SearchOrderTransactionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? overrides.orderTransactions!.map((x) => aComWixEcomOrdersPaymentsV1OrderTransactions(x ?? {}, pickedFields.get('orderTransactions'))) : [aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ShippingRefund = <T extends Partial<ComWixEcomOrdersPaymentsV1ShippingRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1ShippingRefundInput = <T extends Partial<ComWixEcomOrdersPaymentsV1ShippingRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1TriggerRefundRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1TriggerRefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customMessage')) {
        result.customMessage = overrides && overrides.hasOwnProperty('customMessage') ? overrides.customMessage! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcomOrdersPaymentsV1RefundDetailsInput(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcomOrdersPaymentsV1RefundDetailsInput({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? overrides.payments!.map((x) => aComWixEcomOrdersPaymentsV1PaymentRefundInput({}, pickedFields.get('payments'))) : [aComWixEcomOrdersPaymentsV1PaymentRefundInput({}, pickedFields.get('payments'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('restockInfo')) {
        result.restockInfo = overrides && overrides.hasOwnProperty('restockInfo') ? aComWixEcomOrdersPaymentsV1RestockInfoInput(overrides.restockInfo ?? {}, pickedFields.get('restockInfo')) : aComWixEcomOrdersPaymentsV1RestockInfoInput({}, pickedFields.get('restockInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sendOrderRefundedEmail')) {
        result.sendOrderRefundedEmail = overrides && overrides.hasOwnProperty('sendOrderRefundedEmail') ? overrides.sendOrderRefundedEmail! : false;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1TriggerRefundResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1TriggerRefundResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('failedPaymentIds')) {
        result.failedPaymentIds = overrides && overrides.hasOwnProperty('failedPaymentIds') ? overrides.failedPaymentIds! : ['non'];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'necessitatibus';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpdateChargebackRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1UpdateChargebackRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('chargeback')) {
        result.chargeback = overrides && overrides.hasOwnProperty('chargeback') ? aComWixEcomOrdersPaymentsV1ChargebackInput(overrides.chargeback ?? {}, pickedFields.get('chargeback')) : aComWixEcomOrdersPaymentsV1ChargebackInput({}, pickedFields.get('chargeback'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['excepturi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'sapiente';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpdateChargebackResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1UpdateChargebackResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpdatePaymentStatusRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1UpdatePaymentStatusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixPaymentApiPayV3TransactionTransactionStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('statusUpdatedDate')) {
        result.statusUpdatedDate = overrides && overrides.hasOwnProperty('statusUpdatedDate') ? overrides.statusUpdatedDate! : 'minus';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpdatePaymentStatusResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1UpdatePaymentStatusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpdatePaymentsRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1UpdatePaymentsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? overrides.payments!.map((x) => aComWixEcomOrdersPaymentsV1MaskedPaymentInput({}, pickedFields.get('payments'))) : [aComWixEcomOrdersPaymentsV1MaskedPaymentInput({}, pickedFields.get('payments'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpdatePaymentsResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1UpdatePaymentsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpdateRefundRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1UpdateRefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['aliquam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? aComWixEcomOrdersPaymentsV1RefundInput(overrides.refund ?? {}, pickedFields.get('refund')) : aComWixEcomOrdersPaymentsV1RefundInput({}, pickedFields.get('refund'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpdateRefundResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1UpdateRefundResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? aComWixEcomOrdersPaymentsV1Refund(overrides.refund ?? {}, pickedFields.get('refund')) : aComWixEcomOrdersPaymentsV1Refund({}, pickedFields.get('refund'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpdateRefundTransactionRequestInput = <T extends Partial<ComWixEcomOrdersPaymentsV1UpdateRefundTransactionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['ullam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aComWixEcomOrdersPaymentsV1RefundTransactionInput(overrides.transaction ?? {}, pickedFields.get('transaction')) : aComWixEcomOrdersPaymentsV1RefundTransactionInput({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpdateRefundTransactionResponse = <T extends Partial<ComWixEcomOrdersPaymentsV1UpdateRefundTransactionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 9439;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingMetadata = <T extends Partial<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 9741;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorQueryInput = <T extends Partial<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorSearchInput = <T extends Partial<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorSearchInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpstreamWixCommonCursors = <T extends Partial<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'voluptatem';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput = <T extends Partial<ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortOrder.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('selectItemsBy')) {
        result.selectItemsBy = overrides && overrides.hasOwnProperty('selectItemsBy') ? overrides.selectItemsBy! : ['suscipit'];
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1WixReceiptInfo = <T extends Partial<ComWixEcomOrdersPaymentsV1WixReceiptInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayNumber')) {
        result.displayNumber = overrides && overrides.hasOwnProperty('displayNumber') ? overrides.displayNumber! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('receipt')) {
        result.receipt = overrides && overrides.hasOwnProperty('receipt') ? aWixReceiptsV1Receipt(overrides.receipt ?? {}, pickedFields.get('receipt')) : aWixReceiptsV1Receipt({}, pickedFields.get('receipt'));
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'deleniti';
    }

    return result;
};

export const aComWixEcomOrdersPaymentsV1WixReceiptInfoInput = <T extends Partial<ComWixEcomOrdersPaymentsV1WixReceiptInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayNumber')) {
        result.displayNumber = overrides && overrides.hasOwnProperty('displayNumber') ? overrides.displayNumber! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'in';
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1CanMigrateResponse = <T extends Partial<ComWixEcomOrdersRolloutManagerV1CanMigrateResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('canMigrate')) {
        result.canMigrate = overrides && overrides.hasOwnProperty('canMigrate') ? overrides.canMigrate! : false;
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusRequestInput = <T extends Partial<ComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('siteRolloutStatus')) {
        result.siteRolloutStatus = overrides && overrides.hasOwnProperty('siteRolloutStatus') ? aComWixEcomOrdersRolloutManagerV1SiteRolloutStatusInput(overrides.siteRolloutStatus ?? {}, pickedFields.get('siteRolloutStatus')) : aComWixEcomOrdersRolloutManagerV1SiteRolloutStatusInput({}, pickedFields.get('siteRolloutStatus'));
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusResponse = <T extends Partial<ComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('siteRolloutStatus')) {
        result.siteRolloutStatus = overrides && overrides.hasOwnProperty('siteRolloutStatus') ? aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus(overrides.siteRolloutStatus ?? {}, pickedFields.get('siteRolloutStatus')) : aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus({}, pickedFields.get('siteRolloutStatus'));
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1GetSiteRolloutStatusResponse = <T extends Partial<ComWixEcomOrdersRolloutManagerV1GetSiteRolloutStatusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('siteRolloutStatus')) {
        result.siteRolloutStatus = overrides && overrides.hasOwnProperty('siteRolloutStatus') ? aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus(overrides.siteRolloutStatus ?? {}, pickedFields.get('siteRolloutStatus')) : aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus({}, pickedFields.get('siteRolloutStatus'));
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemRequestInput = <T extends Partial<ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metasiteId')) {
        result.metasiteId = overrides && overrides.hasOwnProperty('metasiteId') ? overrides.metasiteId! : 'voluptatibus';
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemResponse = <T extends Partial<ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hasOrdersInOldSystem')) {
        result.hasOrdersInOldSystem = overrides && overrides.hasOwnProperty('hasOrdersInOldSystem') ? overrides.hasOrdersInOldSystem! : false;
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1MarkEmptyAndOpenNewFlowResponse = <T extends Partial<ComWixEcomOrdersRolloutManagerV1MarkEmptyAndOpenNewFlowResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('siteRolloutStatus')) {
        result.siteRolloutStatus = overrides && overrides.hasOwnProperty('siteRolloutStatus') ? aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus(overrides.siteRolloutStatus ?? {}, pickedFields.get('siteRolloutStatus')) : aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus({}, pickedFields.get('siteRolloutStatus'));
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus = <T extends Partial<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowLazyMigration')) {
        result.allowLazyMigration = overrides && overrides.hasOwnProperty('allowLazyMigration') ? overrides.allowLazyMigration! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('comparisonModeOpen')) {
        result.comparisonModeOpen = overrides && overrides.hasOwnProperty('comparisonModeOpen') ? overrides.comparisonModeOpen! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('migrationFailed')) {
        result.migrationFailed = overrides && overrides.hasOwnProperty('migrationFailed') ? overrides.migrationFailed! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('newFlowOpen')) {
        result.newFlowOpen = overrides && overrides.hasOwnProperty('newFlowOpen') ? overrides.newFlowOpen! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('noDataToMigrate')) {
        result.noDataToMigrate = overrides && overrides.hasOwnProperty('noDataToMigrate') ? overrides.noDataToMigrate! : false;
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1SiteRolloutStatusInput = <T extends Partial<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatusInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowLazyMigration')) {
        result.allowLazyMigration = overrides && overrides.hasOwnProperty('allowLazyMigration') ? overrides.allowLazyMigration! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('comparisonModeOpen')) {
        result.comparisonModeOpen = overrides && overrides.hasOwnProperty('comparisonModeOpen') ? overrides.comparisonModeOpen! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('migrationFailed')) {
        result.migrationFailed = overrides && overrides.hasOwnProperty('migrationFailed') ? overrides.migrationFailed! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('newFlowOpen')) {
        result.newFlowOpen = overrides && overrides.hasOwnProperty('newFlowOpen') ? overrides.newFlowOpen! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('noDataToMigrate')) {
        result.noDataToMigrate = overrides && overrides.hasOwnProperty('noDataToMigrate') ? overrides.noDataToMigrate! : false;
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationRequestInput = <T extends Partial<ComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowLazyMigration')) {
        result.allowLazyMigration = overrides && overrides.hasOwnProperty('allowLazyMigration') ? overrides.allowLazyMigration! : true;
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationResponse = <T extends Partial<ComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('siteRolloutStatus')) {
        result.siteRolloutStatus = overrides && overrides.hasOwnProperty('siteRolloutStatus') ? aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus(overrides.siteRolloutStatus ?? {}, pickedFields.get('siteRolloutStatus')) : aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus({}, pickedFields.get('siteRolloutStatus'));
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusRequestInput = <T extends Partial<ComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('comparisonModeOpen')) {
        result.comparisonModeOpen = overrides && overrides.hasOwnProperty('comparisonModeOpen') ? overrides.comparisonModeOpen! : true;
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusResponse = <T extends Partial<ComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('siteRolloutStatus')) {
        result.siteRolloutStatus = overrides && overrides.hasOwnProperty('siteRolloutStatus') ? aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus(overrides.siteRolloutStatus ?? {}, pickedFields.get('siteRolloutStatus')) : aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus({}, pickedFields.get('siteRolloutStatus'));
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedRequestInput = <T extends Partial<ComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('migrationFailed')) {
        result.migrationFailed = overrides && overrides.hasOwnProperty('migrationFailed') ? overrides.migrationFailed! : true;
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedResponse = <T extends Partial<ComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('siteRolloutStatus')) {
        result.siteRolloutStatus = overrides && overrides.hasOwnProperty('siteRolloutStatus') ? aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus(overrides.siteRolloutStatus ?? {}, pickedFields.get('siteRolloutStatus')) : aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus({}, pickedFields.get('siteRolloutStatus'));
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenRequestInput = <T extends Partial<ComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newFlowOpen')) {
        result.newFlowOpen = overrides && overrides.hasOwnProperty('newFlowOpen') ? overrides.newFlowOpen! : false;
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenResponse = <T extends Partial<ComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('siteRolloutStatus')) {
        result.siteRolloutStatus = overrides && overrides.hasOwnProperty('siteRolloutStatus') ? aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus(overrides.siteRolloutStatus ?? {}, pickedFields.get('siteRolloutStatus')) : aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus({}, pickedFields.get('siteRolloutStatus'));
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateRequestInput = <T extends Partial<ComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('noDataToMigrate')) {
        result.noDataToMigrate = overrides && overrides.hasOwnProperty('noDataToMigrate') ? overrides.noDataToMigrate! : false;
    }

    return result;
};

export const aComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateResponse = <T extends Partial<ComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('siteRolloutStatus')) {
        result.siteRolloutStatus = overrides && overrides.hasOwnProperty('siteRolloutStatus') ? aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus(overrides.siteRolloutStatus ?? {}, pickedFields.get('siteRolloutStatus')) : aComWixEcomOrdersRolloutManagerV1SiteRolloutStatus({}, pickedFields.get('siteRolloutStatus'));
    }

    return result;
};

export const aComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput = <T extends Partial<ComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enableRewrittenSideEffects')) {
        result.enableRewrittenSideEffects = overrides && overrides.hasOwnProperty('enableRewrittenSideEffects') ? overrides.enableRewrittenSideEffects! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('epCommitTax')) {
        result.epCommitTax = overrides && overrides.hasOwnProperty('epCommitTax') ? overrides.epCommitTax! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('moveBuyerOrderConfirmationEmailToEp')) {
        result.moveBuyerOrderConfirmationEmailToEp = overrides && overrides.hasOwnProperty('moveBuyerOrderConfirmationEmailToEp') ? overrides.moveBuyerOrderConfirmationEmailToEp! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('moveMerchantEmailToEp')) {
        result.moveMerchantEmailToEp = overrides && overrides.hasOwnProperty('moveMerchantEmailToEp') ? overrides.moveMerchantEmailToEp! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('producedByEpBridge')) {
        result.producedByEpBridge = overrides && overrides.hasOwnProperty('producedByEpBridge') ? overrides.producedByEpBridge! : false;
    }

    return result;
};

export const aComWixEcomOrdersSideEffectsMigrationApiTriggerSideEffectsFromLegacyDataInput = <T extends Partial<ComWixEcomOrdersSideEffectsMigrationApiTriggerSideEffectsFromLegacyDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('ordersExperiments')) {
        result.ordersExperiments = overrides && overrides.hasOwnProperty('ordersExperiments') ? aComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput(overrides.ordersExperiments ?? {}, pickedFields.get('ordersExperiments')) : aComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput({}, pickedFields.get('ordersExperiments'));
    }
    if (pickedFields.size === 0 || pickedFields.has('storeId')) {
        result.storeId = overrides && overrides.hasOwnProperty('storeId') ? overrides.storeId! : 'voluptatem';
    }

    return result;
};

export const aComWixEcomOrdersV1Activity = <T extends Partial<ComWixEcomOrdersV1Activity>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorEmail')) {
        result.authorEmail = overrides && overrides.hasOwnProperty('authorEmail') ? overrides.authorEmail! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('authorizedPaymentCaptured')) {
        result.authorizedPaymentCaptured = overrides && overrides.hasOwnProperty('authorizedPaymentCaptured') ? aComWixEcomOrdersV1AuthorizedPaymentCaptured(overrides.authorizedPaymentCaptured ?? {}, pickedFields.get('authorizedPaymentCaptured')) : aComWixEcomOrdersV1AuthorizedPaymentCaptured({}, pickedFields.get('authorizedPaymentCaptured'));
    }
    if (pickedFields.size === 0 || pickedFields.has('authorizedPaymentCreated')) {
        result.authorizedPaymentCreated = overrides && overrides.hasOwnProperty('authorizedPaymentCreated') ? aComWixEcomOrdersV1AuthorizedPaymentCreated(overrides.authorizedPaymentCreated ?? {}, pickedFields.get('authorizedPaymentCreated')) : aComWixEcomOrdersV1AuthorizedPaymentCreated({}, pickedFields.get('authorizedPaymentCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('authorizedPaymentVoided')) {
        result.authorizedPaymentVoided = overrides && overrides.hasOwnProperty('authorizedPaymentVoided') ? aComWixEcomOrdersV1AuthorizedPaymentVoided(overrides.authorizedPaymentVoided ?? {}, pickedFields.get('authorizedPaymentVoided')) : aComWixEcomOrdersV1AuthorizedPaymentVoided({}, pickedFields.get('authorizedPaymentVoided'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackCreated')) {
        result.chargebackCreated = overrides && overrides.hasOwnProperty('chargebackCreated') ? aComWixEcomOrdersV1ChargebackCreated(overrides.chargebackCreated ?? {}, pickedFields.get('chargebackCreated')) : aComWixEcomOrdersV1ChargebackCreated({}, pickedFields.get('chargebackCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackReversed')) {
        result.chargebackReversed = overrides && overrides.hasOwnProperty('chargebackReversed') ? aComWixEcomOrdersV1ChargebackReversed(overrides.chargebackReversed ?? {}, pickedFields.get('chargebackReversed')) : aComWixEcomOrdersV1ChargebackReversed({}, pickedFields.get('chargebackReversed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('customActivity')) {
        result.customActivity = overrides && overrides.hasOwnProperty('customActivity') ? aComWixEcomOrdersV1CustomActivity(overrides.customActivity ?? {}, pickedFields.get('customActivity')) : aComWixEcomOrdersV1CustomActivity({}, pickedFields.get('customActivity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('draftOrderChangesApplied')) {
        result.draftOrderChangesApplied = overrides && overrides.hasOwnProperty('draftOrderChangesApplied') ? aComWixEcomOrdersV1DraftOrderChangesApplied(overrides.draftOrderChangesApplied ?? {}, pickedFields.get('draftOrderChangesApplied')) : aComWixEcomOrdersV1DraftOrderChangesApplied({}, pickedFields.get('draftOrderChangesApplied'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantComment')) {
        result.merchantComment = overrides && overrides.hasOwnProperty('merchantComment') ? aComWixEcomOrdersV1MerchantComment(overrides.merchantComment ?? {}, pickedFields.get('merchantComment')) : aComWixEcomOrdersV1MerchantComment({}, pickedFields.get('merchantComment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('newExchangeOrderCreated')) {
        result.newExchangeOrderCreated = overrides && overrides.hasOwnProperty('newExchangeOrderCreated') ? aComWixEcomOrdersV1NewExchangeOrderCreated(overrides.newExchangeOrderCreated ?? {}, pickedFields.get('newExchangeOrderCreated')) : aComWixEcomOrdersV1NewExchangeOrderCreated({}, pickedFields.get('newExchangeOrderCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderCreatedFromExchange')) {
        result.orderCreatedFromExchange = overrides && overrides.hasOwnProperty('orderCreatedFromExchange') ? aComWixEcomOrdersV1OrderCreatedFromExchange(overrides.orderCreatedFromExchange ?? {}, pickedFields.get('orderCreatedFromExchange')) : aComWixEcomOrdersV1OrderCreatedFromExchange({}, pickedFields.get('orderCreatedFromExchange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderRefunded')) {
        result.orderRefunded = overrides && overrides.hasOwnProperty('orderRefunded') ? aComWixEcomOrdersV1OrderRefunded(overrides.orderRefunded ?? {}, pickedFields.get('orderRefunded')) : aComWixEcomOrdersV1OrderRefunded({}, pickedFields.get('orderRefunded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentCanceled')) {
        result.paymentCanceled = overrides && overrides.hasOwnProperty('paymentCanceled') ? aComWixEcomOrdersV1PaymentCanceled(overrides.paymentCanceled ?? {}, pickedFields.get('paymentCanceled')) : aComWixEcomOrdersV1PaymentCanceled({}, pickedFields.get('paymentCanceled'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentDeclined')) {
        result.paymentDeclined = overrides && overrides.hasOwnProperty('paymentDeclined') ? aComWixEcomOrdersV1PaymentDeclined(overrides.paymentDeclined ?? {}, pickedFields.get('paymentDeclined')) : aComWixEcomOrdersV1PaymentDeclined({}, pickedFields.get('paymentDeclined'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentPending')) {
        result.paymentPending = overrides && overrides.hasOwnProperty('paymentPending') ? aComWixEcomOrdersV1PaymentPending(overrides.paymentPending ?? {}, pickedFields.get('paymentPending')) : aComWixEcomOrdersV1PaymentPending({}, pickedFields.get('paymentPending'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRefundFailed')) {
        result.paymentRefundFailed = overrides && overrides.hasOwnProperty('paymentRefundFailed') ? aComWixEcomOrdersV1PaymentRefundFailed(overrides.paymentRefundFailed ?? {}, pickedFields.get('paymentRefundFailed')) : aComWixEcomOrdersV1PaymentRefundFailed({}, pickedFields.get('paymentRefundFailed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRefunded')) {
        result.paymentRefunded = overrides && overrides.hasOwnProperty('paymentRefunded') ? aComWixEcomOrdersV1PaymentRefunded(overrides.paymentRefunded ?? {}, pickedFields.get('paymentRefunded')) : aComWixEcomOrdersV1PaymentRefunded({}, pickedFields.get('paymentRefunded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptCreated')) {
        result.receiptCreated = overrides && overrides.hasOwnProperty('receiptCreated') ? aComWixEcomOrdersV1ReceiptCreated(overrides.receiptCreated ?? {}, pickedFields.get('receiptCreated')) : aComWixEcomOrdersV1ReceiptCreated({}, pickedFields.get('receiptCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptSent')) {
        result.receiptSent = overrides && overrides.hasOwnProperty('receiptSent') ? aComWixEcomOrdersV1ReceiptSent(overrides.receiptSent ?? {}, pickedFields.get('receiptSent')) : aComWixEcomOrdersV1ReceiptSent({}, pickedFields.get('receiptSent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundInitiated')) {
        result.refundInitiated = overrides && overrides.hasOwnProperty('refundInitiated') ? aComWixEcomOrdersV1RefundInitiated(overrides.refundInitiated ?? {}, pickedFields.get('refundInitiated')) : aComWixEcomOrdersV1RefundInitiated({}, pickedFields.get('refundInitiated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedAsStoreCredit')) {
        result.refundedAsStoreCredit = overrides && overrides.hasOwnProperty('refundedAsStoreCredit') ? aComWixEcomOrdersV1RefundedAsStoreCredit(overrides.refundedAsStoreCredit ?? {}, pickedFields.get('refundedAsStoreCredit')) : aComWixEcomOrdersV1RefundedAsStoreCredit({}, pickedFields.get('refundedAsStoreCredit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethod')) {
        result.savedPaymentMethod = overrides && overrides.hasOwnProperty('savedPaymentMethod') ? aComWixEcomOrdersV1SavedPaymentMethod(overrides.savedPaymentMethod ?? {}, pickedFields.get('savedPaymentMethod')) : aComWixEcomOrdersV1SavedPaymentMethod({}, pickedFields.get('savedPaymentMethod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcomOrdersV1ActivityTypeEnumActivityType.AuthorizedPaymentCaptured;
    }

    return result;
};

export const aComWixEcomOrdersV1ActivityInput = <T extends Partial<ComWixEcomOrdersV1ActivityInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorEmail')) {
        result.authorEmail = overrides && overrides.hasOwnProperty('authorEmail') ? overrides.authorEmail! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('authorizedPaymentCaptured')) {
        result.authorizedPaymentCaptured = overrides && overrides.hasOwnProperty('authorizedPaymentCaptured') ? aComWixEcomOrdersV1AuthorizedPaymentCapturedInput(overrides.authorizedPaymentCaptured ?? {}, pickedFields.get('authorizedPaymentCaptured')) : aComWixEcomOrdersV1AuthorizedPaymentCapturedInput({}, pickedFields.get('authorizedPaymentCaptured'));
    }
    if (pickedFields.size === 0 || pickedFields.has('authorizedPaymentCreated')) {
        result.authorizedPaymentCreated = overrides && overrides.hasOwnProperty('authorizedPaymentCreated') ? aComWixEcomOrdersV1AuthorizedPaymentCreatedInput(overrides.authorizedPaymentCreated ?? {}, pickedFields.get('authorizedPaymentCreated')) : aComWixEcomOrdersV1AuthorizedPaymentCreatedInput({}, pickedFields.get('authorizedPaymentCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('authorizedPaymentVoided')) {
        result.authorizedPaymentVoided = overrides && overrides.hasOwnProperty('authorizedPaymentVoided') ? aComWixEcomOrdersV1AuthorizedPaymentVoidedInput(overrides.authorizedPaymentVoided ?? {}, pickedFields.get('authorizedPaymentVoided')) : aComWixEcomOrdersV1AuthorizedPaymentVoidedInput({}, pickedFields.get('authorizedPaymentVoided'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackCreated')) {
        result.chargebackCreated = overrides && overrides.hasOwnProperty('chargebackCreated') ? aComWixEcomOrdersV1ChargebackCreatedInput(overrides.chargebackCreated ?? {}, pickedFields.get('chargebackCreated')) : aComWixEcomOrdersV1ChargebackCreatedInput({}, pickedFields.get('chargebackCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackReversed')) {
        result.chargebackReversed = overrides && overrides.hasOwnProperty('chargebackReversed') ? aComWixEcomOrdersV1ChargebackReversedInput(overrides.chargebackReversed ?? {}, pickedFields.get('chargebackReversed')) : aComWixEcomOrdersV1ChargebackReversedInput({}, pickedFields.get('chargebackReversed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('customActivity')) {
        result.customActivity = overrides && overrides.hasOwnProperty('customActivity') ? aComWixEcomOrdersV1CustomActivityInput(overrides.customActivity ?? {}, pickedFields.get('customActivity')) : aComWixEcomOrdersV1CustomActivityInput({}, pickedFields.get('customActivity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('draftOrderChangesApplied')) {
        result.draftOrderChangesApplied = overrides && overrides.hasOwnProperty('draftOrderChangesApplied') ? aComWixEcomOrdersV1DraftOrderChangesAppliedInput(overrides.draftOrderChangesApplied ?? {}, pickedFields.get('draftOrderChangesApplied')) : aComWixEcomOrdersV1DraftOrderChangesAppliedInput({}, pickedFields.get('draftOrderChangesApplied'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantComment')) {
        result.merchantComment = overrides && overrides.hasOwnProperty('merchantComment') ? aComWixEcomOrdersV1MerchantCommentInput(overrides.merchantComment ?? {}, pickedFields.get('merchantComment')) : aComWixEcomOrdersV1MerchantCommentInput({}, pickedFields.get('merchantComment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('newExchangeOrderCreated')) {
        result.newExchangeOrderCreated = overrides && overrides.hasOwnProperty('newExchangeOrderCreated') ? aComWixEcomOrdersV1NewExchangeOrderCreatedInput(overrides.newExchangeOrderCreated ?? {}, pickedFields.get('newExchangeOrderCreated')) : aComWixEcomOrdersV1NewExchangeOrderCreatedInput({}, pickedFields.get('newExchangeOrderCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderCreatedFromExchange')) {
        result.orderCreatedFromExchange = overrides && overrides.hasOwnProperty('orderCreatedFromExchange') ? aComWixEcomOrdersV1OrderCreatedFromExchangeInput(overrides.orderCreatedFromExchange ?? {}, pickedFields.get('orderCreatedFromExchange')) : aComWixEcomOrdersV1OrderCreatedFromExchangeInput({}, pickedFields.get('orderCreatedFromExchange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderRefunded')) {
        result.orderRefunded = overrides && overrides.hasOwnProperty('orderRefunded') ? aComWixEcomOrdersV1OrderRefundedInput(overrides.orderRefunded ?? {}, pickedFields.get('orderRefunded')) : aComWixEcomOrdersV1OrderRefundedInput({}, pickedFields.get('orderRefunded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentCanceled')) {
        result.paymentCanceled = overrides && overrides.hasOwnProperty('paymentCanceled') ? aComWixEcomOrdersV1PaymentCanceledInput(overrides.paymentCanceled ?? {}, pickedFields.get('paymentCanceled')) : aComWixEcomOrdersV1PaymentCanceledInput({}, pickedFields.get('paymentCanceled'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentDeclined')) {
        result.paymentDeclined = overrides && overrides.hasOwnProperty('paymentDeclined') ? aComWixEcomOrdersV1PaymentDeclinedInput(overrides.paymentDeclined ?? {}, pickedFields.get('paymentDeclined')) : aComWixEcomOrdersV1PaymentDeclinedInput({}, pickedFields.get('paymentDeclined'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentPending')) {
        result.paymentPending = overrides && overrides.hasOwnProperty('paymentPending') ? aComWixEcomOrdersV1PaymentPendingInput(overrides.paymentPending ?? {}, pickedFields.get('paymentPending')) : aComWixEcomOrdersV1PaymentPendingInput({}, pickedFields.get('paymentPending'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRefundFailed')) {
        result.paymentRefundFailed = overrides && overrides.hasOwnProperty('paymentRefundFailed') ? aComWixEcomOrdersV1PaymentRefundFailedInput(overrides.paymentRefundFailed ?? {}, pickedFields.get('paymentRefundFailed')) : aComWixEcomOrdersV1PaymentRefundFailedInput({}, pickedFields.get('paymentRefundFailed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRefunded')) {
        result.paymentRefunded = overrides && overrides.hasOwnProperty('paymentRefunded') ? aComWixEcomOrdersV1PaymentRefundedInput(overrides.paymentRefunded ?? {}, pickedFields.get('paymentRefunded')) : aComWixEcomOrdersV1PaymentRefundedInput({}, pickedFields.get('paymentRefunded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptCreated')) {
        result.receiptCreated = overrides && overrides.hasOwnProperty('receiptCreated') ? aComWixEcomOrdersV1ReceiptCreatedInput(overrides.receiptCreated ?? {}, pickedFields.get('receiptCreated')) : aComWixEcomOrdersV1ReceiptCreatedInput({}, pickedFields.get('receiptCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptSent')) {
        result.receiptSent = overrides && overrides.hasOwnProperty('receiptSent') ? aComWixEcomOrdersV1ReceiptSentInput(overrides.receiptSent ?? {}, pickedFields.get('receiptSent')) : aComWixEcomOrdersV1ReceiptSentInput({}, pickedFields.get('receiptSent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundInitiated')) {
        result.refundInitiated = overrides && overrides.hasOwnProperty('refundInitiated') ? aComWixEcomOrdersV1RefundInitiatedInput(overrides.refundInitiated ?? {}, pickedFields.get('refundInitiated')) : aComWixEcomOrdersV1RefundInitiatedInput({}, pickedFields.get('refundInitiated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedAsStoreCredit')) {
        result.refundedAsStoreCredit = overrides && overrides.hasOwnProperty('refundedAsStoreCredit') ? aComWixEcomOrdersV1RefundedAsStoreCreditInput(overrides.refundedAsStoreCredit ?? {}, pickedFields.get('refundedAsStoreCredit')) : aComWixEcomOrdersV1RefundedAsStoreCreditInput({}, pickedFields.get('refundedAsStoreCredit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethod')) {
        result.savedPaymentMethod = overrides && overrides.hasOwnProperty('savedPaymentMethod') ? aComWixEcomOrdersV1SavedPaymentMethodInput(overrides.savedPaymentMethod ?? {}, pickedFields.get('savedPaymentMethod')) : aComWixEcomOrdersV1SavedPaymentMethodInput({}, pickedFields.get('savedPaymentMethod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcomOrdersV1ActivityTypeEnumActivityType.AuthorizedPaymentCaptured;
    }

    return result;
};

export const aComWixEcomOrdersV1AddActivitiesRequestInput = <T extends Partial<ComWixEcomOrdersV1AddActivitiesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activities')) {
        result.activities = overrides && overrides.hasOwnProperty('activities') ? overrides.activities!.map((x) => aComWixEcomOrdersV1PublicActivityInput({}, pickedFields.get('activities'))) : [aComWixEcomOrdersV1PublicActivityInput({}, pickedFields.get('activities'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'quidem';
    }

    return result;
};

export const aComWixEcomOrdersV1AddActivitiesResponse = <T extends Partial<ComWixEcomOrdersV1AddActivitiesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activityIds')) {
        result.activityIds = overrides && overrides.hasOwnProperty('activityIds') ? overrides.activityIds! : ['tenetur'];
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1AddActivityRequestInput = <T extends Partial<ComWixEcomOrdersV1AddActivityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activity')) {
        result.activity = overrides && overrides.hasOwnProperty('activity') ? aComWixEcomOrdersV1PublicActivityInput(overrides.activity ?? {}, pickedFields.get('activity')) : aComWixEcomOrdersV1PublicActivityInput({}, pickedFields.get('activity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'omnis';
    }

    return result;
};

export const aComWixEcomOrdersV1AddActivityResponse = <T extends Partial<ComWixEcomOrdersV1AddActivityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activityId')) {
        result.activityId = overrides && overrides.hasOwnProperty('activityId') ? overrides.activityId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1AddInternalActivityRequestInput = <T extends Partial<ComWixEcomOrdersV1AddInternalActivityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activity')) {
        result.activity = overrides && overrides.hasOwnProperty('activity') ? aComWixEcomOrdersV1InternalActivityInput(overrides.activity ?? {}, pickedFields.get('activity')) : aComWixEcomOrdersV1InternalActivityInput({}, pickedFields.get('activity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }

    return result;
};

export const aComWixEcomOrdersV1AddInternalActivityResponse = <T extends Partial<ComWixEcomOrdersV1AddInternalActivityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activityId')) {
        result.activityId = overrides && overrides.hasOwnProperty('activityId') ? overrides.activityId! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1AdditionalFee = <T extends Partial<ComWixEcomOrdersV1AdditionalFee>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['esse'];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiPrice(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceAfterTax')) {
        result.priceAfterTax = overrides && overrides.hasOwnProperty('priceAfterTax') ? aComWixEcommercePlatformCommonApiPrice(overrides.priceAfterTax ?? {}, pickedFields.get('priceAfterTax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('priceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeTax')) {
        result.priceBeforeTax = overrides && overrides.hasOwnProperty('priceBeforeTax') ? aComWixEcommercePlatformCommonApiPrice(overrides.priceBeforeTax ?? {}, pickedFields.get('priceBeforeTax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('priceBeforeTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerAppId')) {
        result.providerAppId = overrides && overrides.hasOwnProperty('providerAppId') ? overrides.providerAppId! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionCycles')) {
        result.subscriptionCycles = overrides && overrides.hasOwnProperty('subscriptionCycles') ? overrides.subscriptionCycles! : 4499;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxDetails')) {
        result.taxDetails = overrides && overrides.hasOwnProperty('taxDetails') ? aComWixEcomTaxApiItemTaxFullDetails(overrides.taxDetails ?? {}, pickedFields.get('taxDetails')) : aComWixEcomTaxApiItemTaxFullDetails({}, pickedFields.get('taxDetails'));
    }

    return result;
};

export const aComWixEcomOrdersV1AdditionalFeeDeltaInput = <T extends Partial<ComWixEcomOrdersV1AdditionalFeeDeltaInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeId')) {
        result.additionalFeeId = overrides && overrides.hasOwnProperty('additionalFeeId') ? overrides.additionalFeeId! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('additionalFeeRemoved')) {
        result.additionalFeeRemoved = overrides && overrides.hasOwnProperty('additionalFeeRemoved') ? overrides.additionalFeeRemoved! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('editedAdditionalFee')) {
        result.editedAdditionalFee = overrides && overrides.hasOwnProperty('editedAdditionalFee') ? aComWixEcomOrdersV1AdditionalFeeInput(overrides.editedAdditionalFee ?? {}, pickedFields.get('editedAdditionalFee')) : aComWixEcomOrdersV1AdditionalFeeInput({}, pickedFields.get('editedAdditionalFee'));
    }

    return result;
};

export const aComWixEcomOrdersV1AdditionalFeeInput = <T extends Partial<ComWixEcomOrdersV1AdditionalFeeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['ipsa'];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceAfterTax')) {
        result.priceAfterTax = overrides && overrides.hasOwnProperty('priceAfterTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.priceAfterTax ?? {}, pickedFields.get('priceAfterTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('priceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeTax')) {
        result.priceBeforeTax = overrides && overrides.hasOwnProperty('priceBeforeTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.priceBeforeTax ?? {}, pickedFields.get('priceBeforeTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('priceBeforeTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerAppId')) {
        result.providerAppId = overrides && overrides.hasOwnProperty('providerAppId') ? overrides.providerAppId! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionCycles')) {
        result.subscriptionCycles = overrides && overrides.hasOwnProperty('subscriptionCycles') ? overrides.subscriptionCycles! : 1;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxDetails')) {
        result.taxDetails = overrides && overrides.hasOwnProperty('taxDetails') ? aComWixEcomTaxApiItemTaxFullDetailsInput(overrides.taxDetails ?? {}, pickedFields.get('taxDetails')) : aComWixEcomTaxApiItemTaxFullDetailsInput({}, pickedFields.get('taxDetails'));
    }

    return result;
};

export const aComWixEcomOrdersV1AggregateOrdersRequestInput = <T extends Partial<ComWixEcomOrdersV1AggregateOrdersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregation')) {
        result.aggregation = overrides && overrides.hasOwnProperty('aggregation') ? overrides.aggregation! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('hierarchySeparatorOverride')) {
        result.hierarchySeparatorOverride = overrides && overrides.hasOwnProperty('hierarchySeparatorOverride') ? overrides.hierarchySeparatorOverride! : 'ut';
    }

    return result;
};

export const aComWixEcomOrdersV1AggregateOrdersResponse = <T extends Partial<ComWixEcomOrdersV1AggregateOrdersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregates')) {
        result.aggregates = overrides && overrides.hasOwnProperty('aggregates') ? overrides.aggregates! : 'consequatur';
    }

    return result;
};

export const aComWixEcomOrdersV1AppliedDiscount = <T extends Partial<ComWixEcomOrdersV1AppliedDiscount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coupon')) {
        result.coupon = overrides && overrides.hasOwnProperty('coupon') ? aComWixEcomOrdersV1Coupon(overrides.coupon ?? {}, pickedFields.get('coupon')) : aComWixEcomOrdersV1Coupon({}, pickedFields.get('coupon'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountRule')) {
        result.discountRule = overrides && overrides.hasOwnProperty('discountRule') ? aComWixEcomOrdersV1DiscountRule(overrides.discountRule ?? {}, pickedFields.get('discountRule')) : aComWixEcomOrdersV1DiscountRule({}, pickedFields.get('discountRule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountType')) {
        result.discountType = overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : ComWixEcomOrdersV1AppliedDiscountDiscountType.Global;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemDiscounts')) {
        result.lineItemDiscounts = overrides && overrides.hasOwnProperty('lineItemDiscounts') ? overrides.lineItemDiscounts!.map((x) => aComWixEcomOrdersV1LineItemDiscount(x ?? {}, pickedFields.get('lineItemDiscounts'))) : [aComWixEcomOrdersV1LineItemDiscount({}, pickedFields.get('lineItemDiscounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['dignissimos'];
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantDiscount')) {
        result.merchantDiscount = overrides && overrides.hasOwnProperty('merchantDiscount') ? aComWixEcomOrdersV1MerchantDiscount(overrides.merchantDiscount ?? {}, pickedFields.get('merchantDiscount')) : aComWixEcomOrdersV1MerchantDiscount({}, pickedFields.get('merchantDiscount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionCycles')) {
        result.subscriptionCycles = overrides && overrides.hasOwnProperty('subscriptionCycles') ? overrides.subscriptionCycles! : 5070;
    }

    return result;
};

export const aComWixEcomOrdersV1AppliedDiscountDeltaInput = <T extends Partial<ComWixEcomOrdersV1AppliedDiscountDeltaInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discountId')) {
        result.discountId = overrides && overrides.hasOwnProperty('discountId') ? overrides.discountId! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('discountRemoved')) {
        result.discountRemoved = overrides && overrides.hasOwnProperty('discountRemoved') ? overrides.discountRemoved! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('editedDiscount')) {
        result.editedDiscount = overrides && overrides.hasOwnProperty('editedDiscount') ? aComWixEcomOrdersV1AppliedDiscountInput(overrides.editedDiscount ?? {}, pickedFields.get('editedDiscount')) : aComWixEcomOrdersV1AppliedDiscountInput({}, pickedFields.get('editedDiscount'));
    }

    return result;
};

export const aComWixEcomOrdersV1AppliedDiscountInput = <T extends Partial<ComWixEcomOrdersV1AppliedDiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coupon')) {
        result.coupon = overrides && overrides.hasOwnProperty('coupon') ? aComWixEcomOrdersV1CouponInput(overrides.coupon ?? {}, pickedFields.get('coupon')) : aComWixEcomOrdersV1CouponInput({}, pickedFields.get('coupon'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountRule')) {
        result.discountRule = overrides && overrides.hasOwnProperty('discountRule') ? aComWixEcomOrdersV1DiscountRuleInput(overrides.discountRule ?? {}, pickedFields.get('discountRule')) : aComWixEcomOrdersV1DiscountRuleInput({}, pickedFields.get('discountRule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountType')) {
        result.discountType = overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : ComWixEcomOrdersV1AppliedDiscountDiscountType.Global;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemDiscounts')) {
        result.lineItemDiscounts = overrides && overrides.hasOwnProperty('lineItemDiscounts') ? overrides.lineItemDiscounts!.map((x) => aComWixEcomOrdersV1LineItemDiscountInput({}, pickedFields.get('lineItemDiscounts'))) : [aComWixEcomOrdersV1LineItemDiscountInput({}, pickedFields.get('lineItemDiscounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantDiscount')) {
        result.merchantDiscount = overrides && overrides.hasOwnProperty('merchantDiscount') ? aComWixEcomOrdersV1MerchantDiscountInput(overrides.merchantDiscount ?? {}, pickedFields.get('merchantDiscount')) : aComWixEcomOrdersV1MerchantDiscountInput({}, pickedFields.get('merchantDiscount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionCycles')) {
        result.subscriptionCycles = overrides && overrides.hasOwnProperty('subscriptionCycles') ? overrides.subscriptionCycles! : 7733;
    }

    return result;
};

export const aComWixEcomOrdersV1ArchiveOrderRequestInput = <T extends Partial<ComWixEcomOrdersV1ArchiveOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'omnis';
    }

    return result;
};

export const aComWixEcomOrdersV1ArchiveOrderResponse = <T extends Partial<ComWixEcomOrdersV1ArchiveOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1AuthorizedPaymentCaptured = <T extends Partial<ComWixEcomOrdersV1AuthorizedPaymentCaptured>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'molestias';
    }

    return result;
};

export const aComWixEcomOrdersV1AuthorizedPaymentCapturedInput = <T extends Partial<ComWixEcomOrdersV1AuthorizedPaymentCapturedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'repellat';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'ut';
    }

    return result;
};

export const aComWixEcomOrdersV1AuthorizedPaymentCreated = <T extends Partial<ComWixEcomOrdersV1AuthorizedPaymentCreated>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'voluptas';
    }

    return result;
};

export const aComWixEcomOrdersV1AuthorizedPaymentCreatedInput = <T extends Partial<ComWixEcomOrdersV1AuthorizedPaymentCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'eius';
    }

    return result;
};

export const aComWixEcomOrdersV1AuthorizedPaymentVoided = <T extends Partial<ComWixEcomOrdersV1AuthorizedPaymentVoided>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'quae';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'ea';
    }

    return result;
};

export const aComWixEcomOrdersV1AuthorizedPaymentVoidedInput = <T extends Partial<ComWixEcomOrdersV1AuthorizedPaymentVoidedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'omnis';
    }

    return result;
};

export const aComWixEcomOrdersV1Balance = <T extends Partial<ComWixEcomOrdersV1Balance>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAmount')) {
        result.formattedAmount = overrides && overrides.hasOwnProperty('formattedAmount') ? overrides.formattedAmount! : 'nobis';
    }

    return result;
};

export const aComWixEcomOrdersV1BalanceInput = <T extends Partial<ComWixEcomOrdersV1BalanceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAmount')) {
        result.formattedAmount = overrides && overrides.hasOwnProperty('formattedAmount') ? overrides.formattedAmount! : 'neque';
    }

    return result;
};

export const aComWixEcomOrdersV1BalanceSummary = <T extends Partial<ComWixEcomOrdersV1BalanceSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorized')) {
        result.authorized = overrides && overrides.hasOwnProperty('authorized') ? aComWixEcommercePlatformCommonApiPrice(overrides.authorized ?? {}, pickedFields.get('authorized')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('authorized'));
    }
    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? aComWixEcomOrdersV1Balance(overrides.balance ?? {}, pickedFields.get('balance')) : aComWixEcomOrdersV1Balance({}, pickedFields.get('balance'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargeback')) {
        result.chargeback = overrides && overrides.hasOwnProperty('chargeback') ? aComWixEcommercePlatformCommonApiPrice(overrides.chargeback ?? {}, pickedFields.get('chargeback')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('chargeback'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackReversal')) {
        result.chargebackReversal = overrides && overrides.hasOwnProperty('chargebackReversal') ? aComWixEcommercePlatformCommonApiPrice(overrides.chargebackReversal ?? {}, pickedFields.get('chargebackReversal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('chargebackReversal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paid')) {
        result.paid = overrides && overrides.hasOwnProperty('paid') ? aComWixEcommercePlatformCommonApiPrice(overrides.paid ?? {}, pickedFields.get('paid')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('paid'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pending')) {
        result.pending = overrides && overrides.hasOwnProperty('pending') ? aComWixEcommercePlatformCommonApiPrice(overrides.pending ?? {}, pickedFields.get('pending')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('pending'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pendingRefund')) {
        result.pendingRefund = overrides && overrides.hasOwnProperty('pendingRefund') ? aComWixEcommercePlatformCommonApiPrice(overrides.pendingRefund ?? {}, pickedFields.get('pendingRefund')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('pendingRefund'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refunded')) {
        result.refunded = overrides && overrides.hasOwnProperty('refunded') ? aComWixEcommercePlatformCommonApiPrice(overrides.refunded ?? {}, pickedFields.get('refunded')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('refunded'));
    }

    return result;
};

export const aComWixEcomOrdersV1BalanceSummaryInput = <T extends Partial<ComWixEcomOrdersV1BalanceSummaryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorized')) {
        result.authorized = overrides && overrides.hasOwnProperty('authorized') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.authorized ?? {}, pickedFields.get('authorized')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('authorized'));
    }
    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? aComWixEcomOrdersV1BalanceInput(overrides.balance ?? {}, pickedFields.get('balance')) : aComWixEcomOrdersV1BalanceInput({}, pickedFields.get('balance'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargeback')) {
        result.chargeback = overrides && overrides.hasOwnProperty('chargeback') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.chargeback ?? {}, pickedFields.get('chargeback')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('chargeback'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackReversal')) {
        result.chargebackReversal = overrides && overrides.hasOwnProperty('chargebackReversal') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.chargebackReversal ?? {}, pickedFields.get('chargebackReversal')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('chargebackReversal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paid')) {
        result.paid = overrides && overrides.hasOwnProperty('paid') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.paid ?? {}, pickedFields.get('paid')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('paid'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pending')) {
        result.pending = overrides && overrides.hasOwnProperty('pending') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.pending ?? {}, pickedFields.get('pending')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('pending'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pendingRefund')) {
        result.pendingRefund = overrides && overrides.hasOwnProperty('pendingRefund') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.pendingRefund ?? {}, pickedFields.get('pendingRefund')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('pendingRefund'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refunded')) {
        result.refunded = overrides && overrides.hasOwnProperty('refunded') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.refunded ?? {}, pickedFields.get('refunded')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('refunded'));
    }

    return result;
};

export const aComWixEcomOrdersV1BillingAdjustment = <T extends Partial<ComWixEcomOrdersV1BillingAdjustment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('priceSummary')) {
        result.priceSummary = overrides && overrides.hasOwnProperty('priceSummary') ? aComWixEcomOrdersV1BillingAdjustmentPriceSummary(overrides.priceSummary ?? {}, pickedFields.get('priceSummary')) : aComWixEcomOrdersV1BillingAdjustmentPriceSummary({}, pickedFields.get('priceSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcomOrdersV1BillingAdjustmentAdjustmentType.Credit;
    }

    return result;
};

export const aComWixEcomOrdersV1BillingAdjustmentInput = <T extends Partial<ComWixEcomOrdersV1BillingAdjustmentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('priceSummary')) {
        result.priceSummary = overrides && overrides.hasOwnProperty('priceSummary') ? aComWixEcomOrdersV1BillingAdjustmentPriceSummaryInput(overrides.priceSummary ?? {}, pickedFields.get('priceSummary')) : aComWixEcomOrdersV1BillingAdjustmentPriceSummaryInput({}, pickedFields.get('priceSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcomOrdersV1BillingAdjustmentAdjustmentType.Credit;
    }

    return result;
};

export const aComWixEcomOrdersV1BillingAdjustmentPriceSummary = <T extends Partial<ComWixEcomOrdersV1BillingAdjustmentPriceSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixEcommercePlatformCommonApiPrice(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiPrice(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiPrice(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixEcomOrdersV1BillingAdjustmentPriceSummaryInput = <T extends Partial<ComWixEcomOrdersV1BillingAdjustmentPriceSummaryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixEcomOrdersV1BulkArchiveOrdersByFilterRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkArchiveOrdersByFilterRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'illo';
    }

    return result;
};

export const aComWixEcomOrdersV1BulkArchiveOrdersByFilterResponse = <T extends Partial<ComWixEcomOrdersV1BulkArchiveOrdersByFilterResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkArchiveOrdersRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkArchiveOrdersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['facere'];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : true;
    }

    return result;
};

export const aComWixEcomOrdersV1BulkArchiveOrdersResponse = <T extends Partial<ComWixEcomOrdersV1BulkArchiveOrdersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkMarkAsFulfilledByFilterRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkMarkAsFulfilledByFilterRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'nemo';
    }

    return result;
};

export const aComWixEcomOrdersV1BulkMarkAsFulfilledByFilterResponse = <T extends Partial<ComWixEcomOrdersV1BulkMarkAsFulfilledByFilterResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkMarkAsFulfilledRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkMarkAsFulfilledRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['et'];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : false;
    }

    return result;
};

export const aComWixEcomOrdersV1BulkMarkAsFulfilledResponse = <T extends Partial<ComWixEcomOrdersV1BulkMarkAsFulfilledResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'sed';
    }

    return result;
};

export const aComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterResponse = <T extends Partial<ComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkMarkAsUnfulfilledRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkMarkAsUnfulfilledRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['et'];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : false;
    }

    return result;
};

export const aComWixEcomOrdersV1BulkMarkAsUnfulfilledResponse = <T extends Partial<ComWixEcomOrdersV1BulkMarkAsUnfulfilledResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkMarkOrdersAsPaidRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkMarkOrdersAsPaidRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['tenetur'];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkMarkOrdersAsPaidResponse = <T extends Partial<ComWixEcomOrdersV1BulkMarkOrdersAsPaidResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkOrderResult = <T extends Partial<ComWixEcomOrdersV1BulkOrderResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixEcomOrdersV1Order(overrides.item ?? {}, pickedFields.get('item')) : aComWixEcomOrdersV1Order({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixEcomOrdersV1BulkSetBusinessLocationRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkSetBusinessLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocation')) {
        result.businessLocation = overrides && overrides.hasOwnProperty('businessLocation') ? aComWixEcommercePlatformCommonApiLocationInput(overrides.businessLocation ?? {}, pickedFields.get('businessLocation')) : aComWixEcommercePlatformCommonApiLocationInput({}, pickedFields.get('businessLocation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderIds')) {
        result.orderIds = overrides && overrides.hasOwnProperty('orderIds') ? overrides.orderIds! : ['et'];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkSetBusinessLocationResponse = <T extends Partial<ComWixEcomOrdersV1BulkSetBusinessLocationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkSetBusinessLocationResponseBulkSetBusinessLocationResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkSetBusinessLocationResponseBulkSetBusinessLocationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkSetBusinessLocationResponseBulkSetBusinessLocationResult = <T extends Partial<ComWixEcomOrdersV1BulkSetBusinessLocationResponseBulkSetBusinessLocationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixEcomOrdersV1BulkUnArchiveOrdersByFilterRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkUnArchiveOrdersByFilterRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'ut';
    }

    return result;
};

export const aComWixEcomOrdersV1BulkUnArchiveOrdersByFilterResponse = <T extends Partial<ComWixEcomOrdersV1BulkUnArchiveOrdersByFilterResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkUnArchiveOrdersRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkUnArchiveOrdersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['blanditiis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : true;
    }

    return result;
};

export const aComWixEcomOrdersV1BulkUnArchiveOrdersResponse = <T extends Partial<ComWixEcomOrdersV1BulkUnArchiveOrdersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkUpdateOrderRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkUpdateOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orders')) {
        result.orders = overrides && overrides.hasOwnProperty('orders') ? overrides.orders!.map((x) => aComWixEcomOrdersV1MaskedOrderInput({}, pickedFields.get('orders'))) : [aComWixEcomOrdersV1MaskedOrderInput({}, pickedFields.get('orders'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }

    return result;
};

export const aComWixEcomOrdersV1BulkUpdateOrderResponse = <T extends Partial<ComWixEcomOrdersV1BulkUpdateOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkUpdateOrderTagsRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkUpdateOrderTagsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('assignTags')) {
        result.assignTags = overrides && overrides.hasOwnProperty('assignTags') ? aWixCommonTagsTagsInput(overrides.assignTags ?? {}, pickedFields.get('assignTags')) : aWixCommonTagsTagsInput({}, pickedFields.get('assignTags'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderIds')) {
        result.orderIds = overrides && overrides.hasOwnProperty('orderIds') ? overrides.orderIds! : ['porro'];
    }
    if (pickedFields.size === 0 || pickedFields.has('unassignTags')) {
        result.unassignTags = overrides && overrides.hasOwnProperty('unassignTags') ? aWixCommonTagsTagsInput(overrides.unassignTags ?? {}, pickedFields.get('unassignTags')) : aWixCommonTagsTagsInput({}, pickedFields.get('unassignTags'));
    }

    return result;
};

export const aComWixEcomOrdersV1BulkUpdateOrderTagsResponse = <T extends Partial<ComWixEcomOrdersV1BulkUpdateOrderTagsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkUpdateOrderTagsResponseBulkUpdateOrderTagsResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkUpdateOrderTagsResponseBulkUpdateOrderTagsResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BulkUpdateOrderTagsResponseBulkUpdateOrderTagsResult = <T extends Partial<ComWixEcomOrdersV1BulkUpdateOrderTagsResponseBulkUpdateOrderTagsResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixEcomOrdersV1BulkUpdateOrdersRequestInput = <T extends Partial<ComWixEcomOrdersV1BulkUpdateOrdersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orders')) {
        result.orders = overrides && overrides.hasOwnProperty('orders') ? overrides.orders!.map((x) => aComWixEcomOrdersV1MaskedOrderInput({}, pickedFields.get('orders'))) : [aComWixEcomOrdersV1MaskedOrderInput({}, pickedFields.get('orders'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }

    return result;
};

export const aComWixEcomOrdersV1BulkUpdateOrdersResponse = <T extends Partial<ComWixEcomOrdersV1BulkUpdateOrdersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixEcomOrdersV1BulkOrderResult(x ?? {}, pickedFields.get('results'))) : [aComWixEcomOrdersV1BulkOrderResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixEcomOrdersV1BuyerInfo = <T extends Partial<ComWixEcomOrdersV1BuyerInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('visitorId')) {
        result.visitorId = overrides && overrides.hasOwnProperty('visitorId') ? overrides.visitorId! : 'aliquid';
    }

    return result;
};

export const aComWixEcomOrdersV1BuyerInfoInput = <T extends Partial<ComWixEcomOrdersV1BuyerInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('visitorId')) {
        result.visitorId = overrides && overrides.hasOwnProperty('visitorId') ? overrides.visitorId! : 'possimus';
    }

    return result;
};

export const aComWixEcomOrdersV1BuyerInfoUpdateInput = <T extends Partial<ComWixEcomOrdersV1BuyerInfoUpdateInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'et';
    }

    return result;
};

export const aComWixEcomOrdersV1CancelOrderRequestInput = <T extends Partial<ComWixEcomOrdersV1CancelOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customMessage')) {
        result.customMessage = overrides && overrides.hasOwnProperty('customMessage') ? overrides.customMessage! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('restockAllItems')) {
        result.restockAllItems = overrides && overrides.hasOwnProperty('restockAllItems') ? overrides.restockAllItems! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('sendOrderCanceledEmail')) {
        result.sendOrderCanceledEmail = overrides && overrides.hasOwnProperty('sendOrderCanceledEmail') ? overrides.sendOrderCanceledEmail! : false;
    }

    return result;
};

export const aComWixEcomOrdersV1CancelOrderResponse = <T extends Partial<ComWixEcomOrdersV1CancelOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1ChannelInfo = <T extends Partial<ComWixEcomOrdersV1ChannelInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalOrderId')) {
        result.externalOrderId = overrides && overrides.hasOwnProperty('externalOrderId') ? overrides.externalOrderId! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalOrderUrl')) {
        result.externalOrderUrl = overrides && overrides.hasOwnProperty('externalOrderUrl') ? overrides.externalOrderUrl! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcommercePlatformCommonApiChannelType.Amazon;
    }

    return result;
};

export const aComWixEcomOrdersV1ChannelInfoInput = <T extends Partial<ComWixEcomOrdersV1ChannelInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalOrderId')) {
        result.externalOrderId = overrides && overrides.hasOwnProperty('externalOrderId') ? overrides.externalOrderId! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalOrderUrl')) {
        result.externalOrderUrl = overrides && overrides.hasOwnProperty('externalOrderUrl') ? overrides.externalOrderUrl! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcommercePlatformCommonApiChannelType.Amazon;
    }

    return result;
};

export const aComWixEcomOrdersV1ChargebackCreated = <T extends Partial<ComWixEcomOrdersV1ChargebackCreated>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackId')) {
        result.chargebackId = overrides && overrides.hasOwnProperty('chargebackId') ? overrides.chargebackId! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentDetails')) {
        result.paymentDetails = overrides && overrides.hasOwnProperty('paymentDetails') ? aComWixEcomOrdersV1RegularPayment(overrides.paymentDetails ?? {}, pickedFields.get('paymentDetails')) : aComWixEcomOrdersV1RegularPayment({}, pickedFields.get('paymentDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'ab';
    }

    return result;
};

export const aComWixEcomOrdersV1ChargebackCreatedInput = <T extends Partial<ComWixEcomOrdersV1ChargebackCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackId')) {
        result.chargebackId = overrides && overrides.hasOwnProperty('chargebackId') ? overrides.chargebackId! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentDetails')) {
        result.paymentDetails = overrides && overrides.hasOwnProperty('paymentDetails') ? aComWixEcomOrdersV1RegularPaymentInput(overrides.paymentDetails ?? {}, pickedFields.get('paymentDetails')) : aComWixEcomOrdersV1RegularPaymentInput({}, pickedFields.get('paymentDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'consequuntur';
    }

    return result;
};

export const aComWixEcomOrdersV1ChargebackReversed = <T extends Partial<ComWixEcomOrdersV1ChargebackReversed>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackId')) {
        result.chargebackId = overrides && overrides.hasOwnProperty('chargebackId') ? overrides.chargebackId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentDetails')) {
        result.paymentDetails = overrides && overrides.hasOwnProperty('paymentDetails') ? aComWixEcomOrdersV1RegularPayment(overrides.paymentDetails ?? {}, pickedFields.get('paymentDetails')) : aComWixEcomOrdersV1RegularPayment({}, pickedFields.get('paymentDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('reversalAmount')) {
        result.reversalAmount = overrides && overrides.hasOwnProperty('reversalAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.reversalAmount ?? {}, pickedFields.get('reversalAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('reversalAmount'));
    }

    return result;
};

export const aComWixEcomOrdersV1ChargebackReversedInput = <T extends Partial<ComWixEcomOrdersV1ChargebackReversedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackId')) {
        result.chargebackId = overrides && overrides.hasOwnProperty('chargebackId') ? overrides.chargebackId! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentDetails')) {
        result.paymentDetails = overrides && overrides.hasOwnProperty('paymentDetails') ? aComWixEcomOrdersV1RegularPaymentInput(overrides.paymentDetails ?? {}, pickedFields.get('paymentDetails')) : aComWixEcomOrdersV1RegularPaymentInput({}, pickedFields.get('paymentDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('reversalAmount')) {
        result.reversalAmount = overrides && overrides.hasOwnProperty('reversalAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.reversalAmount ?? {}, pickedFields.get('reversalAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('reversalAmount'));
    }

    return result;
};

export const aComWixEcomOrdersV1CommitDeltasRequestInput = <T extends Partial<ComWixEcomOrdersV1CommitDeltasRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('changes')) {
        result.changes = overrides && overrides.hasOwnProperty('changes') ? aComWixEcomOrdersV1DraftOrderDiffsInput(overrides.changes ?? {}, pickedFields.get('changes')) : aComWixEcomOrdersV1DraftOrderDiffsInput({}, pickedFields.get('changes'));
    }
    if (pickedFields.size === 0 || pickedFields.has('commitSettings')) {
        result.commitSettings = overrides && overrides.hasOwnProperty('commitSettings') ? aComWixEcomOrdersV1DraftOrderCommitSettingsInput(overrides.commitSettings ?? {}, pickedFields.get('commitSettings')) : aComWixEcomOrdersV1DraftOrderCommitSettingsInput({}, pickedFields.get('commitSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('draftOrderId')) {
        result.draftOrderId = overrides && overrides.hasOwnProperty('draftOrderId') ? overrides.draftOrderId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'explicabo';
    }

    return result;
};

export const aComWixEcomOrdersV1CommitDeltasResponse = <T extends Partial<ComWixEcomOrdersV1CommitDeltasResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1Coupon = <T extends Partial<ComWixEcomOrdersV1Coupon>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dolorum';
    }

    return result;
};

export const aComWixEcomOrdersV1CouponInput = <T extends Partial<ComWixEcomOrdersV1CouponInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'neque';
    }

    return result;
};

export const aComWixEcomOrdersV1CreateOrderRequestInput = <T extends Partial<ComWixEcomOrdersV1CreateOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1OrderInput(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1OrderInput({}, pickedFields.get('order'));
    }
    if (pickedFields.size === 0 || pickedFields.has('settings')) {
        result.settings = overrides && overrides.hasOwnProperty('settings') ? aComWixEcomOrdersV1OrderCreationSettingsInput(overrides.settings ?? {}, pickedFields.get('settings')) : aComWixEcomOrdersV1OrderCreationSettingsInput({}, pickedFields.get('settings'));
    }

    return result;
};

export const aComWixEcomOrdersV1CreateOrderResponse = <T extends Partial<ComWixEcomOrdersV1CreateOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1CreatePaymentGatewayOrderRequestInput = <T extends Partial<ComWixEcomOrdersV1CreatePaymentGatewayOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ecomOrderId')) {
        result.ecomOrderId = overrides && overrides.hasOwnProperty('ecomOrderId') ? overrides.ecomOrderId! : 'amet';
    }

    return result;
};

export const aComWixEcomOrdersV1CreatePaymentGatewayOrderResponse = <T extends Partial<ComWixEcomOrdersV1CreatePaymentGatewayOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayOrderId')) {
        result.paymentGatewayOrderId = overrides && overrides.hasOwnProperty('paymentGatewayOrderId') ? overrides.paymentGatewayOrderId! : 'et';
    }

    return result;
};

export const aComWixEcomOrdersV1CreatedBy = <T extends Partial<ComWixEcomOrdersV1CreatedBy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('visitorId')) {
        result.visitorId = overrides && overrides.hasOwnProperty('visitorId') ? overrides.visitorId! : 'animi';
    }

    return result;
};

export const aComWixEcomOrdersV1CreatedByInput = <T extends Partial<ComWixEcomOrdersV1CreatedByInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('visitorId')) {
        result.visitorId = overrides && overrides.hasOwnProperty('visitorId') ? overrides.visitorId! : 'voluptatem';
    }

    return result;
};

export const aComWixEcomOrdersV1CreditCardDetails = <T extends Partial<ComWixEcomOrdersV1CreditCardDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'pariatur';
    }

    return result;
};

export const aComWixEcomOrdersV1CreditCardDetailsInput = <T extends Partial<ComWixEcomOrdersV1CreditCardDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'odio';
    }

    return result;
};

export const aComWixEcomOrdersV1CurrencyConversionDetails = <T extends Partial<ComWixEcomOrdersV1CurrencyConversionDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conversionRate')) {
        result.conversionRate = overrides && overrides.hasOwnProperty('conversionRate') ? overrides.conversionRate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalCurrency')) {
        result.originalCurrency = overrides && overrides.hasOwnProperty('originalCurrency') ? overrides.originalCurrency! : 'quis';
    }

    return result;
};

export const aComWixEcomOrdersV1CurrencyConversionDetailsInput = <T extends Partial<ComWixEcomOrdersV1CurrencyConversionDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conversionRate')) {
        result.conversionRate = overrides && overrides.hasOwnProperty('conversionRate') ? overrides.conversionRate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalCurrency')) {
        result.originalCurrency = overrides && overrides.hasOwnProperty('originalCurrency') ? overrides.originalCurrency! : 'mollitia';
    }

    return result;
};

export const aComWixEcomOrdersV1CustomActivity = <T extends Partial<ComWixEcomOrdersV1CustomActivity>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalData')) {
        result.additionalData = overrides && overrides.hasOwnProperty('additionalData') ? overrides.additionalData! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'sit';
    }

    return result;
};

export const aComWixEcomOrdersV1CustomActivityInput = <T extends Partial<ComWixEcomOrdersV1CustomActivityInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalData')) {
        result.additionalData = overrides && overrides.hasOwnProperty('additionalData') ? overrides.additionalData! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'possimus';
    }

    return result;
};

export const aComWixEcomOrdersV1CustomField = <T extends Partial<ComWixEcomOrdersV1CustomField>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('translatedTitle')) {
        result.translatedTitle = overrides && overrides.hasOwnProperty('translatedTitle') ? overrides.translatedTitle! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'delectus';
    }

    return result;
};

export const aComWixEcomOrdersV1CustomFieldInput = <T extends Partial<ComWixEcomOrdersV1CustomFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('translatedTitle')) {
        result.translatedTitle = overrides && overrides.hasOwnProperty('translatedTitle') ? overrides.translatedTitle! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'est';
    }

    return result;
};

export const aComWixEcomOrdersV1DecrementDataInput = <T extends Partial<ComWixEcomOrdersV1DecrementDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('decrementBy')) {
        result.decrementBy = overrides && overrides.hasOwnProperty('decrementBy') ? overrides.decrementBy! : 1004;
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('restock')) {
        result.restock = overrides && overrides.hasOwnProperty('restock') ? overrides.restock! : true;
    }

    return result;
};

export const aComWixEcomOrdersV1DecrementItemsQuantityRequestInput = <T extends Partial<ComWixEcomOrdersV1DecrementItemsQuantityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('decrementData')) {
        result.decrementData = overrides && overrides.hasOwnProperty('decrementData') ? overrides.decrementData!.map((x) => aComWixEcomOrdersV1DecrementDataInput({}, pickedFields.get('decrementData'))) : [aComWixEcomOrdersV1DecrementDataInput({}, pickedFields.get('decrementData'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'beatae';
    }

    return result;
};

export const aComWixEcomOrdersV1DecrementItemsQuantityResponse = <T extends Partial<ComWixEcomOrdersV1DecrementItemsQuantityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1DeleteActivityRequestInput = <T extends Partial<ComWixEcomOrdersV1DeleteActivityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activityId')) {
        result.activityId = overrides && overrides.hasOwnProperty('activityId') ? overrides.activityId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'non';
    }

    return result;
};

export const aComWixEcomOrdersV1DeleteActivityResponse = <T extends Partial<ComWixEcomOrdersV1DeleteActivityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1DeliveryLogistics = <T extends Partial<ComWixEcomOrdersV1DeliveryLogistics>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deliverByDate')) {
        result.deliverByDate = overrides && overrides.hasOwnProperty('deliverByDate') ? overrides.deliverByDate! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryTime')) {
        result.deliveryTime = overrides && overrides.hasOwnProperty('deliveryTime') ? overrides.deliveryTime! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryTimeSlot')) {
        result.deliveryTimeSlot = overrides && overrides.hasOwnProperty('deliveryTimeSlot') ? aComWixEcomOrdersV1DeliveryTimeSlot(overrides.deliveryTimeSlot ?? {}, pickedFields.get('deliveryTimeSlot')) : aComWixEcomOrdersV1DeliveryTimeSlot({}, pickedFields.get('deliveryTimeSlot'));
    }
    if (pickedFields.size === 0 || pickedFields.has('instructions')) {
        result.instructions = overrides && overrides.hasOwnProperty('instructions') ? overrides.instructions! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('pickupDetails')) {
        result.pickupDetails = overrides && overrides.hasOwnProperty('pickupDetails') ? aComWixEcomOrdersV1PickupDetails(overrides.pickupDetails ?? {}, pickedFields.get('pickupDetails')) : aComWixEcomOrdersV1PickupDetails({}, pickedFields.get('pickupDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingDestination')) {
        result.shippingDestination = overrides && overrides.hasOwnProperty('shippingDestination') ? aComWixEcommercePlatformCommonApiAddressWithContact(overrides.shippingDestination ?? {}, pickedFields.get('shippingDestination')) : aComWixEcommercePlatformCommonApiAddressWithContact({}, pickedFields.get('shippingDestination'));
    }

    return result;
};

export const aComWixEcomOrdersV1DeliveryLogisticsInput = <T extends Partial<ComWixEcomOrdersV1DeliveryLogisticsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deliverByDate')) {
        result.deliverByDate = overrides && overrides.hasOwnProperty('deliverByDate') ? overrides.deliverByDate! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryTime')) {
        result.deliveryTime = overrides && overrides.hasOwnProperty('deliveryTime') ? overrides.deliveryTime! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryTimeSlot')) {
        result.deliveryTimeSlot = overrides && overrides.hasOwnProperty('deliveryTimeSlot') ? aComWixEcomOrdersV1DeliveryTimeSlotInput(overrides.deliveryTimeSlot ?? {}, pickedFields.get('deliveryTimeSlot')) : aComWixEcomOrdersV1DeliveryTimeSlotInput({}, pickedFields.get('deliveryTimeSlot'));
    }
    if (pickedFields.size === 0 || pickedFields.has('instructions')) {
        result.instructions = overrides && overrides.hasOwnProperty('instructions') ? overrides.instructions! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('pickupDetails')) {
        result.pickupDetails = overrides && overrides.hasOwnProperty('pickupDetails') ? aComWixEcomOrdersV1PickupDetailsInput(overrides.pickupDetails ?? {}, pickedFields.get('pickupDetails')) : aComWixEcomOrdersV1PickupDetailsInput({}, pickedFields.get('pickupDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingDestination')) {
        result.shippingDestination = overrides && overrides.hasOwnProperty('shippingDestination') ? aComWixEcommercePlatformCommonApiAddressWithContactInput(overrides.shippingDestination ?? {}, pickedFields.get('shippingDestination')) : aComWixEcommercePlatformCommonApiAddressWithContactInput({}, pickedFields.get('shippingDestination'));
    }

    return result;
};

export const aComWixEcomOrdersV1DeliveryTimeSlot = <T extends Partial<ComWixEcomOrdersV1DeliveryTimeSlot>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 'molestias';
    }

    return result;
};

export const aComWixEcomOrdersV1DeliveryTimeSlotInput = <T extends Partial<ComWixEcomOrdersV1DeliveryTimeSlotInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 'est';
    }

    return result;
};

export const aComWixEcomOrdersV1DigitalFile = <T extends Partial<ComWixEcomOrdersV1DigitalFile>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expirationDate')) {
        result.expirationDate = overrides && overrides.hasOwnProperty('expirationDate') ? overrides.expirationDate! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('fileId')) {
        result.fileId = overrides && overrides.hasOwnProperty('fileId') ? overrides.fileId! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'quam';
    }

    return result;
};

export const aComWixEcomOrdersV1DigitalFileInput = <T extends Partial<ComWixEcomOrdersV1DigitalFileInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expirationDate')) {
        result.expirationDate = overrides && overrides.hasOwnProperty('expirationDate') ? overrides.expirationDate! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('fileId')) {
        result.fileId = overrides && overrides.hasOwnProperty('fileId') ? overrides.fileId! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'aut';
    }

    return result;
};

export const aComWixEcomOrdersV1DiscountRule = <T extends Partial<ComWixEcomOrdersV1DiscountRule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountRule')) {
        result.discountRule = overrides && overrides.hasOwnProperty('discountRule') ? aComWixEcomDiscountsDiscountRule(overrides.discountRule ?? {}, pickedFields.get('discountRule')) : aComWixEcomDiscountsDiscountRule({}, pickedFields.get('discountRule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomOrdersV1DiscountRuleName(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomOrdersV1DiscountRuleName({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomOrdersV1DiscountRuleInput = <T extends Partial<ComWixEcomOrdersV1DiscountRuleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomOrdersV1DiscountRuleNameInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomOrdersV1DiscountRuleNameInput({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomOrdersV1DiscountRuleName = <T extends Partial<ComWixEcomOrdersV1DiscountRuleName>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'corrupti';
    }

    return result;
};

export const aComWixEcomOrdersV1DiscountRuleNameInput = <T extends Partial<ComWixEcomOrdersV1DiscountRuleNameInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'natus';
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesApplied = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesApplied>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('changes')) {
        result.changes = overrides && overrides.hasOwnProperty('changes') ? overrides.changes!.map((x) => aComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChange(x ?? {}, pickedFields.get('changes'))) : [aComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChange({}, pickedFields.get('changes'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('draftOrderId')) {
        result.draftOrderId = overrides && overrides.hasOwnProperty('draftOrderId') ? overrides.draftOrderId! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'quis';
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItem = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLine(x ?? {}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLine({}, pickedFields.get('descriptionLines'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommerceCatalogSpiApiV1ProductName(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommerceCatalogSpiApiV1ProductName({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? aComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetails(overrides.quantity ?? {}, pickedFields.get('quantity')) : aComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetails({}, pickedFields.get('quantity'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommerceCatalogSpiApiV1ProductNameInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommerceCatalogSpiApiV1ProductNameInput({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? aComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsInput(overrides.quantity ?? {}, pickedFields.get('quantity')) : aComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsInput({}, pickedFields.get('quantity'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetails = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('changeType')) {
        result.changeType = overrides && overrides.hasOwnProperty('changeType') ? overrides.changeType! : ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsItemQuantityChangeType.ItemAdded;
    }
    if (pickedFields.size === 0 || pickedFields.has('diff')) {
        result.diff = overrides && overrides.hasOwnProperty('diff') ? overrides.diff! : 981;
    }
    if (pickedFields.size === 0 || pickedFields.has('newQuantity')) {
        result.newQuantity = overrides && overrides.hasOwnProperty('newQuantity') ? overrides.newQuantity! : 8067;
    }
    if (pickedFields.size === 0 || pickedFields.has('originalQuantity')) {
        result.originalQuantity = overrides && overrides.hasOwnProperty('originalQuantity') ? overrides.originalQuantity! : 947;
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('changeType')) {
        result.changeType = overrides && overrides.hasOwnProperty('changeType') ? overrides.changeType! : ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsItemQuantityChangeType.ItemAdded;
    }
    if (pickedFields.size === 0 || pickedFields.has('diff')) {
        result.diff = overrides && overrides.hasOwnProperty('diff') ? overrides.diff! : 4928;
    }
    if (pickedFields.size === 0 || pickedFields.has('newQuantity')) {
        result.newQuantity = overrides && overrides.hasOwnProperty('newQuantity') ? overrides.newQuantity! : 8324;
    }
    if (pickedFields.size === 0 || pickedFields.has('originalQuantity')) {
        result.originalQuantity = overrides && overrides.hasOwnProperty('originalQuantity') ? overrides.originalQuantity! : 9112;
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('changes')) {
        result.changes = overrides && overrides.hasOwnProperty('changes') ? overrides.changes!.map((x) => aComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChangeInput({}, pickedFields.get('changes'))) : [aComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChangeInput({}, pickedFields.get('changes'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('draftOrderId')) {
        result.draftOrderId = overrides && overrides.hasOwnProperty('draftOrderId') ? overrides.draftOrderId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'quisquam';
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommerceCatalogSpiApiV1ProductName(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommerceCatalogSpiApiV1ProductName({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommerceCatalogSpiApiV1ProductNameInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommerceCatalogSpiApiV1ProductNameInput({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChanges = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChanges>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommerceCatalogSpiApiV1ProductName(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommerceCatalogSpiApiV1ProductName({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChange(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChange({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChange(overrides.quantity ?? {}, pickedFields.get('quantity')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChange({}, pickedFields.get('quantity'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChangesInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChangesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommerceCatalogSpiApiV1ProductNameInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommerceCatalogSpiApiV1ProductNameInput({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChangeInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChangeInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeInput(overrides.quantity ?? {}, pickedFields.get('quantity')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeInput({}, pickedFields.get('quantity'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChange = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChange>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newPrice')) {
        result.newPrice = overrides && overrides.hasOwnProperty('newPrice') ? aComWixEcommercePlatformCommonApiPrice(overrides.newPrice ?? {}, pickedFields.get('newPrice')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('newPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('originalPrice')) {
        result.originalPrice = overrides && overrides.hasOwnProperty('originalPrice') ? aComWixEcommercePlatformCommonApiPrice(overrides.originalPrice ?? {}, pickedFields.get('originalPrice')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('originalPrice'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChangeInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChangeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newPrice')) {
        result.newPrice = overrides && overrides.hasOwnProperty('newPrice') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.newPrice ?? {}, pickedFields.get('newPrice')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('newPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('originalPrice')) {
        result.originalPrice = overrides && overrides.hasOwnProperty('originalPrice') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.originalPrice ?? {}, pickedFields.get('originalPrice')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('originalPrice'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChange = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChange>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deltaType')) {
        result.deltaType = overrides && overrides.hasOwnProperty('deltaType') ? overrides.deltaType! : ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeLineItemQuantityChangeType.QuantityDecreased;
    }
    if (pickedFields.size === 0 || pickedFields.has('diff')) {
        result.diff = overrides && overrides.hasOwnProperty('diff') ? overrides.diff! : 1754;
    }
    if (pickedFields.size === 0 || pickedFields.has('newQuantity')) {
        result.newQuantity = overrides && overrides.hasOwnProperty('newQuantity') ? overrides.newQuantity! : 5216;
    }
    if (pickedFields.size === 0 || pickedFields.has('originalQuantity')) {
        result.originalQuantity = overrides && overrides.hasOwnProperty('originalQuantity') ? overrides.originalQuantity! : 131;
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deltaType')) {
        result.deltaType = overrides && overrides.hasOwnProperty('deltaType') ? overrides.deltaType! : ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeLineItemQuantityChangeType.QuantityDecreased;
    }
    if (pickedFields.size === 0 || pickedFields.has('diff')) {
        result.diff = overrides && overrides.hasOwnProperty('diff') ? overrides.diff! : 1707;
    }
    if (pickedFields.size === 0 || pickedFields.has('newQuantity')) {
        result.newQuantity = overrides && overrides.hasOwnProperty('newQuantity') ? overrides.newQuantity! : 1447;
    }
    if (pickedFields.size === 0 || pickedFields.has('originalQuantity')) {
        result.originalQuantity = overrides && overrides.hasOwnProperty('originalQuantity') ? overrides.originalQuantity! : 545;
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('affectedLineItems')) {
        result.affectedLineItems = overrides && overrides.hasOwnProperty('affectedLineItems') ? overrides.affectedLineItems!.map((x) => aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount(x ?? {}, pickedFields.get('affectedLineItems'))) : [aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount({}, pickedFields.get('affectedLineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomOrdersV1TranslatedValue(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomOrdersV1TranslatedValue({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalAmount')) {
        result.totalAmount = overrides && overrides.hasOwnProperty('totalAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalAmount ?? {}, pickedFields.get('totalAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalAmount'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('affectedLineItems')) {
        result.affectedLineItems = overrides && overrides.hasOwnProperty('affectedLineItems') ? overrides.affectedLineItems!.map((x) => aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput({}, pickedFields.get('affectedLineItems'))) : [aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput({}, pickedFields.get('affectedLineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'debitis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomOrdersV1TranslatedValueInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomOrdersV1TranslatedValueInput({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalAmount')) {
        result.totalAmount = overrides && overrides.hasOwnProperty('totalAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalAmount ?? {}, pickedFields.get('totalAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalAmount'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('affectedLineItems')) {
        result.affectedLineItems = overrides && overrides.hasOwnProperty('affectedLineItems') ? overrides.affectedLineItems!.map((x) => aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount(x ?? {}, pickedFields.get('affectedLineItems'))) : [aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount({}, pickedFields.get('affectedLineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomOrdersV1TranslatedValue(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomOrdersV1TranslatedValue({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalAmount')) {
        result.totalAmount = overrides && overrides.hasOwnProperty('totalAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalAmount ?? {}, pickedFields.get('totalAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalAmount'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('affectedLineItems')) {
        result.affectedLineItems = overrides && overrides.hasOwnProperty('affectedLineItems') ? overrides.affectedLineItems!.map((x) => aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput({}, pickedFields.get('affectedLineItems'))) : [aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput({}, pickedFields.get('affectedLineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomOrdersV1TranslatedValueInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomOrdersV1TranslatedValueInput({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalAmount')) {
        result.totalAmount = overrides && overrides.hasOwnProperty('totalAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalAmount ?? {}, pickedFields.get('totalAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalAmount'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommerceCatalogSpiApiV1ProductName(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommerceCatalogSpiApiV1ProductName({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 3658;
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vero';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommerceCatalogSpiApiV1ProductNameInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommerceCatalogSpiApiV1ProductNameInput({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 226;
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChange = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChange>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeAdded')) {
        result.additionalFeeAdded = overrides && overrides.hasOwnProperty('additionalFeeAdded') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee(overrides.additionalFeeAdded ?? {}, pickedFields.get('additionalFeeAdded')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee({}, pickedFields.get('additionalFeeAdded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('additionalFeeRemoved')) {
        result.additionalFeeRemoved = overrides && overrides.hasOwnProperty('additionalFeeRemoved') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee(overrides.additionalFeeRemoved ?? {}, pickedFields.get('additionalFeeRemoved')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee({}, pickedFields.get('additionalFeeRemoved'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountAdded')) {
        result.discountAdded = overrides && overrides.hasOwnProperty('discountAdded') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount(overrides.discountAdded ?? {}, pickedFields.get('discountAdded')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount({}, pickedFields.get('discountAdded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountRemoved')) {
        result.discountRemoved = overrides && overrides.hasOwnProperty('discountRemoved') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount(overrides.discountRemoved ?? {}, pickedFields.get('discountRemoved')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount({}, pickedFields.get('discountRemoved'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemAdded')) {
        result.lineItemAdded = overrides && overrides.hasOwnProperty('lineItemAdded') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem(overrides.lineItemAdded ?? {}, pickedFields.get('lineItemAdded')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem({}, pickedFields.get('lineItemAdded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemChanged')) {
        result.lineItemChanged = overrides && overrides.hasOwnProperty('lineItemChanged') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChanges(overrides.lineItemChanged ?? {}, pickedFields.get('lineItemChanged')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChanges({}, pickedFields.get('lineItemChanged'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemRemoved')) {
        result.lineItemRemoved = overrides && overrides.hasOwnProperty('lineItemRemoved') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem(overrides.lineItemRemoved ?? {}, pickedFields.get('lineItemRemoved')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem({}, pickedFields.get('lineItemRemoved'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingInformationChanged')) {
        result.shippingInformationChanged = overrides && overrides.hasOwnProperty('shippingInformationChanged') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChange(overrides.shippingInformationChanged ?? {}, pickedFields.get('shippingInformationChanged')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChange({}, pickedFields.get('shippingInformationChanged'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceChanged')) {
        result.totalPriceChanged = overrides && overrides.hasOwnProperty('totalPriceChanged') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChange(overrides.totalPriceChanged ?? {}, pickedFields.get('totalPriceChanged')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChange({}, pickedFields.get('totalPriceChanged'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChangeInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChangeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFeeAdded')) {
        result.additionalFeeAdded = overrides && overrides.hasOwnProperty('additionalFeeAdded') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput(overrides.additionalFeeAdded ?? {}, pickedFields.get('additionalFeeAdded')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput({}, pickedFields.get('additionalFeeAdded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('additionalFeeRemoved')) {
        result.additionalFeeRemoved = overrides && overrides.hasOwnProperty('additionalFeeRemoved') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput(overrides.additionalFeeRemoved ?? {}, pickedFields.get('additionalFeeRemoved')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput({}, pickedFields.get('additionalFeeRemoved'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountAdded')) {
        result.discountAdded = overrides && overrides.hasOwnProperty('discountAdded') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput(overrides.discountAdded ?? {}, pickedFields.get('discountAdded')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput({}, pickedFields.get('discountAdded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountRemoved')) {
        result.discountRemoved = overrides && overrides.hasOwnProperty('discountRemoved') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput(overrides.discountRemoved ?? {}, pickedFields.get('discountRemoved')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput({}, pickedFields.get('discountRemoved'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemAdded')) {
        result.lineItemAdded = overrides && overrides.hasOwnProperty('lineItemAdded') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput(overrides.lineItemAdded ?? {}, pickedFields.get('lineItemAdded')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput({}, pickedFields.get('lineItemAdded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemChanged')) {
        result.lineItemChanged = overrides && overrides.hasOwnProperty('lineItemChanged') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChangesInput(overrides.lineItemChanged ?? {}, pickedFields.get('lineItemChanged')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChangesInput({}, pickedFields.get('lineItemChanged'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemRemoved')) {
        result.lineItemRemoved = overrides && overrides.hasOwnProperty('lineItemRemoved') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput(overrides.lineItemRemoved ?? {}, pickedFields.get('lineItemRemoved')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput({}, pickedFields.get('lineItemRemoved'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingInformationChanged')) {
        result.shippingInformationChanged = overrides && overrides.hasOwnProperty('shippingInformationChanged') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeInput(overrides.shippingInformationChanged ?? {}, pickedFields.get('shippingInformationChanged')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeInput({}, pickedFields.get('shippingInformationChanged'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceChanged')) {
        result.totalPriceChanged = overrides && overrides.hasOwnProperty('totalPriceChanged') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChangeInput(overrides.totalPriceChanged ?? {}, pickedFields.get('totalPriceChanged')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChangeInput({}, pickedFields.get('totalPriceChanged'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChange = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChange>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newShippingInfo')) {
        result.newShippingInfo = overrides && overrides.hasOwnProperty('newShippingInfo') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation(overrides.newShippingInfo ?? {}, pickedFields.get('newShippingInfo')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation({}, pickedFields.get('newShippingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('originalShippingInfo')) {
        result.originalShippingInfo = overrides && overrides.hasOwnProperty('originalShippingInfo') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation(overrides.originalShippingInfo ?? {}, pickedFields.get('originalShippingInfo')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation({}, pickedFields.get('originalShippingInfo'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newShippingInfo')) {
        result.newShippingInfo = overrides && overrides.hasOwnProperty('newShippingInfo') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput(overrides.newShippingInfo ?? {}, pickedFields.get('newShippingInfo')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput({}, pickedFields.get('newShippingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('originalShippingInfo')) {
        result.originalShippingInfo = overrides && overrides.hasOwnProperty('originalShippingInfo') ? aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput(overrides.originalShippingInfo ?? {}, pickedFields.get('originalShippingInfo')) : aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput({}, pickedFields.get('originalShippingInfo'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('shippingTitle')) {
        result.shippingTitle = overrides && overrides.hasOwnProperty('shippingTitle') ? overrides.shippingTitle! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiPrice(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('shippingTitle')) {
        result.shippingTitle = overrides && overrides.hasOwnProperty('shippingTitle') ? overrides.shippingTitle! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChange = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChange>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newTotal')) {
        result.newTotal = overrides && overrides.hasOwnProperty('newTotal') ? aComWixEcommercePlatformCommonApiPrice(overrides.newTotal ?? {}, pickedFields.get('newTotal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('newTotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('originalTotal')) {
        result.originalTotal = overrides && overrides.hasOwnProperty('originalTotal') ? aComWixEcommercePlatformCommonApiPrice(overrides.originalTotal ?? {}, pickedFields.get('originalTotal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('originalTotal'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChangeInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChangeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newTotal')) {
        result.newTotal = overrides && overrides.hasOwnProperty('newTotal') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.newTotal ?? {}, pickedFields.get('newTotal')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('newTotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('originalTotal')) {
        result.originalTotal = overrides && overrides.hasOwnProperty('originalTotal') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.originalTotal ?? {}, pickedFields.get('originalTotal')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('originalTotal'));
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderCommitSettingsInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderCommitSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addActivitiesToOrder')) {
        result.addActivitiesToOrder = overrides && overrides.hasOwnProperty('addActivitiesToOrder') ? overrides.addActivitiesToOrder! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('inventoryUpdates')) {
        result.inventoryUpdates = overrides && overrides.hasOwnProperty('inventoryUpdates') ? overrides.inventoryUpdates!.map((x) => aComWixEcomOrdersV1InventoryUpdateDetailsInput({}, pickedFields.get('inventoryUpdates'))) : [aComWixEcomOrdersV1InventoryUpdateDetailsInput({}, pickedFields.get('inventoryUpdates'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('sendNotificationsToBusiness')) {
        result.sendNotificationsToBusiness = overrides && overrides.hasOwnProperty('sendNotificationsToBusiness') ? overrides.sendNotificationsToBusiness! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('sendNotificationsToBuyer')) {
        result.sendNotificationsToBuyer = overrides && overrides.hasOwnProperty('sendNotificationsToBuyer') ? overrides.sendNotificationsToBuyer! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('sendNotificationsToCustomFulfillers')) {
        result.sendNotificationsToCustomFulfillers = overrides && overrides.hasOwnProperty('sendNotificationsToCustomFulfillers') ? overrides.sendNotificationsToCustomFulfillers! : false;
    }

    return result;
};

export const aComWixEcomOrdersV1DraftOrderDiffsInput = <T extends Partial<ComWixEcomOrdersV1DraftOrderDiffsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomOrdersV1AdditionalFeeDeltaInput({}, pickedFields.get('additionalFees'))) : [aComWixEcomOrdersV1AdditionalFeeDeltaInput({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('appliedDiscounts')) {
        result.appliedDiscounts = overrides && overrides.hasOwnProperty('appliedDiscounts') ? overrides.appliedDiscounts!.map((x) => aComWixEcomOrdersV1AppliedDiscountDeltaInput({}, pickedFields.get('appliedDiscounts'))) : [aComWixEcomOrdersV1AppliedDiscountDeltaInput({}, pickedFields.get('appliedDiscounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('billingInfoRemoved')) {
        result.billingInfoRemoved = overrides && overrides.hasOwnProperty('billingInfoRemoved') ? overrides.billingInfoRemoved! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerInfoRemoved')) {
        result.buyerInfoRemoved = overrides && overrides.hasOwnProperty('buyerInfoRemoved') ? overrides.buyerInfoRemoved! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('changedBillingInfo')) {
        result.changedBillingInfo = overrides && overrides.hasOwnProperty('changedBillingInfo') ? aComWixEcommercePlatformCommonApiAddressWithContactInput(overrides.changedBillingInfo ?? {}, pickedFields.get('changedBillingInfo')) : aComWixEcommercePlatformCommonApiAddressWithContactInput({}, pickedFields.get('changedBillingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('changedBuyerInfo')) {
        result.changedBuyerInfo = overrides && overrides.hasOwnProperty('changedBuyerInfo') ? aComWixEcomOrdersV1BuyerInfoInput(overrides.changedBuyerInfo ?? {}, pickedFields.get('changedBuyerInfo')) : aComWixEcomOrdersV1BuyerInfoInput({}, pickedFields.get('changedBuyerInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('changedRecipientInfo')) {
        result.changedRecipientInfo = overrides && overrides.hasOwnProperty('changedRecipientInfo') ? aComWixEcommercePlatformCommonApiAddressWithContactInput(overrides.changedRecipientInfo ?? {}, pickedFields.get('changedRecipientInfo')) : aComWixEcommercePlatformCommonApiAddressWithContactInput({}, pickedFields.get('changedRecipientInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('changedShippingInfo')) {
        result.changedShippingInfo = overrides && overrides.hasOwnProperty('changedShippingInfo') ? aComWixEcomOrdersV1ShippingInformationInput(overrides.changedShippingInfo ?? {}, pickedFields.get('changedShippingInfo')) : aComWixEcomOrdersV1ShippingInformationInput({}, pickedFields.get('changedShippingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersV1LineItemDeltaInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersV1LineItemDeltaInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('priceSummary')) {
        result.priceSummary = overrides && overrides.hasOwnProperty('priceSummary') ? aComWixEcomOrdersV1PriceSummaryInput(overrides.priceSummary ?? {}, pickedFields.get('priceSummary')) : aComWixEcomOrdersV1PriceSummaryInput({}, pickedFields.get('priceSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('recipientInfoRemoved')) {
        result.recipientInfoRemoved = overrides && overrides.hasOwnProperty('recipientInfoRemoved') ? overrides.recipientInfoRemoved! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingInfoRemoved')) {
        result.shippingInfoRemoved = overrides && overrides.hasOwnProperty('shippingInfoRemoved') ? overrides.shippingInfoRemoved! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxInfo')) {
        result.taxInfo = overrides && overrides.hasOwnProperty('taxInfo') ? aComWixEcomOrdersV1OrderTaxInfoInput(overrides.taxInfo ?? {}, pickedFields.get('taxInfo')) : aComWixEcomOrdersV1OrderTaxInfoInput({}, pickedFields.get('taxInfo'));
    }

    return result;
};

export const aComWixEcomOrdersV1ExternalReceipt = <T extends Partial<ComWixEcomOrdersV1ExternalReceipt>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayNumber')) {
        result.displayNumber = overrides && overrides.hasOwnProperty('displayNumber') ? overrides.displayNumber! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'odio';
    }

    return result;
};

export const aComWixEcomOrdersV1ExternalReceiptInput = <T extends Partial<ComWixEcomOrdersV1ExternalReceiptInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayNumber')) {
        result.displayNumber = overrides && overrides.hasOwnProperty('displayNumber') ? overrides.displayNumber! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'et';
    }

    return result;
};

export const aComWixEcomOrdersV1FreeTrialPeriod = <T extends Partial<ComWixEcomOrdersV1FreeTrialPeriod>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : WixPaymentApiPayV2SubscriptionFrequency.Day;
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : 178;
    }

    return result;
};

export const aComWixEcomOrdersV1FreeTrialPeriodInput = <T extends Partial<ComWixEcomOrdersV1FreeTrialPeriodInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : WixPaymentApiPayV2SubscriptionFrequency.Day;
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : 4250;
    }

    return result;
};

export const aComWixEcomOrdersV1FulfillmentStatusesAggregate = <T extends Partial<ComWixEcomOrdersV1FulfillmentStatusesAggregate>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('statuses')) {
        result.statuses = overrides && overrides.hasOwnProperty('statuses') ? overrides.statuses! : ['quo'];
    }

    return result;
};

export const aComWixEcomOrdersV1FulfillmentStatusesAggregateInput = <T extends Partial<ComWixEcomOrdersV1FulfillmentStatusesAggregateInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('statuses')) {
        result.statuses = overrides && overrides.hasOwnProperty('statuses') ? overrides.statuses! : ['vitae'];
    }

    return result;
};

export const aComWixEcomOrdersV1GetOrderRequestInput = <T extends Partial<ComWixEcomOrdersV1GetOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a1da3c33-a9d7-4d68-84ff-3bd0828367d7';
    }

    return result;
};

export const aComWixEcomOrdersV1GetShipmentsRequestInput = <T extends Partial<ComWixEcomOrdersV1GetShipmentsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cupiditate';
    }

    return result;
};

export const aComWixEcomOrdersV1GetShipmentsResponse = <T extends Partial<ComWixEcomOrdersV1GetShipmentsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('shipmentIds')) {
        result.shipmentIds = overrides && overrides.hasOwnProperty('shipmentIds') ? overrides.shipmentIds! : ['omnis'];
    }

    return result;
};

export const aComWixEcomOrdersV1GiftCardPaymentRefund = <T extends Partial<ComWixEcomOrdersV1GiftCardPaymentRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardPaymentId')) {
        result.giftCardPaymentId = overrides && overrides.hasOwnProperty('giftCardPaymentId') ? overrides.giftCardPaymentId! : 'exercitationem';
    }

    return result;
};

export const aComWixEcomOrdersV1GiftCardPaymentRefundInput = <T extends Partial<ComWixEcomOrdersV1GiftCardPaymentRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardPaymentId')) {
        result.giftCardPaymentId = overrides && overrides.hasOwnProperty('giftCardPaymentId') ? overrides.giftCardPaymentId! : 'explicabo';
    }

    return result;
};

export const aComWixEcomOrdersV1InternalActivityInput = <T extends Partial<ComWixEcomOrdersV1InternalActivityInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorEmail')) {
        result.authorEmail = overrides && overrides.hasOwnProperty('authorEmail') ? overrides.authorEmail! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('authorizedPaymentCaptured')) {
        result.authorizedPaymentCaptured = overrides && overrides.hasOwnProperty('authorizedPaymentCaptured') ? aComWixEcomOrdersV1AuthorizedPaymentCapturedInput(overrides.authorizedPaymentCaptured ?? {}, pickedFields.get('authorizedPaymentCaptured')) : aComWixEcomOrdersV1AuthorizedPaymentCapturedInput({}, pickedFields.get('authorizedPaymentCaptured'));
    }
    if (pickedFields.size === 0 || pickedFields.has('authorizedPaymentCreated')) {
        result.authorizedPaymentCreated = overrides && overrides.hasOwnProperty('authorizedPaymentCreated') ? aComWixEcomOrdersV1AuthorizedPaymentCreatedInput(overrides.authorizedPaymentCreated ?? {}, pickedFields.get('authorizedPaymentCreated')) : aComWixEcomOrdersV1AuthorizedPaymentCreatedInput({}, pickedFields.get('authorizedPaymentCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('authorizedPaymentVoided')) {
        result.authorizedPaymentVoided = overrides && overrides.hasOwnProperty('authorizedPaymentVoided') ? aComWixEcomOrdersV1AuthorizedPaymentVoidedInput(overrides.authorizedPaymentVoided ?? {}, pickedFields.get('authorizedPaymentVoided')) : aComWixEcomOrdersV1AuthorizedPaymentVoidedInput({}, pickedFields.get('authorizedPaymentVoided'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackCreated')) {
        result.chargebackCreated = overrides && overrides.hasOwnProperty('chargebackCreated') ? aComWixEcomOrdersV1ChargebackCreatedInput(overrides.chargebackCreated ?? {}, pickedFields.get('chargebackCreated')) : aComWixEcomOrdersV1ChargebackCreatedInput({}, pickedFields.get('chargebackCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargebackReversed')) {
        result.chargebackReversed = overrides && overrides.hasOwnProperty('chargebackReversed') ? aComWixEcomOrdersV1ChargebackReversedInput(overrides.chargebackReversed ?? {}, pickedFields.get('chargebackReversed')) : aComWixEcomOrdersV1ChargebackReversedInput({}, pickedFields.get('chargebackReversed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('downloadLinkSent')) {
        result.downloadLinkSent = overrides && overrides.hasOwnProperty('downloadLinkSent') ? overrides.downloadLinkSent! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('draftOrderChangesApplied')) {
        result.draftOrderChangesApplied = overrides && overrides.hasOwnProperty('draftOrderChangesApplied') ? aComWixEcomOrdersV1DraftOrderChangesAppliedInput(overrides.draftOrderChangesApplied ?? {}, pickedFields.get('draftOrderChangesApplied')) : aComWixEcomOrdersV1DraftOrderChangesAppliedInput({}, pickedFields.get('draftOrderChangesApplied'));
    }
    if (pickedFields.size === 0 || pickedFields.has('emailEdited')) {
        result.emailEdited = overrides && overrides.hasOwnProperty('emailEdited') ? overrides.emailEdited! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillerEmailSent')) {
        result.fulfillerEmailSent = overrides && overrides.hasOwnProperty('fulfillerEmailSent') ? overrides.fulfillerEmailSent! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('invoiceAdded')) {
        result.invoiceAdded = overrides && overrides.hasOwnProperty('invoiceAdded') ? overrides.invoiceAdded! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('invoiceSent')) {
        result.invoiceSent = overrides && overrides.hasOwnProperty('invoiceSent') ? overrides.invoiceSent! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('newExchangeOrderCreated')) {
        result.newExchangeOrderCreated = overrides && overrides.hasOwnProperty('newExchangeOrderCreated') ? aComWixEcomOrdersV1NewExchangeOrderCreatedInput(overrides.newExchangeOrderCreated ?? {}, pickedFields.get('newExchangeOrderCreated')) : aComWixEcomOrdersV1NewExchangeOrderCreatedInput({}, pickedFields.get('newExchangeOrderCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderCanceled')) {
        result.orderCanceled = overrides && overrides.hasOwnProperty('orderCanceled') ? overrides.orderCanceled! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderCreatedFromExchange')) {
        result.orderCreatedFromExchange = overrides && overrides.hasOwnProperty('orderCreatedFromExchange') ? aComWixEcomOrdersV1OrderCreatedFromExchangeInput(overrides.orderCreatedFromExchange ?? {}, pickedFields.get('orderCreatedFromExchange')) : aComWixEcomOrdersV1OrderCreatedFromExchangeInput({}, pickedFields.get('orderCreatedFromExchange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderFulfilled')) {
        result.orderFulfilled = overrides && overrides.hasOwnProperty('orderFulfilled') ? overrides.orderFulfilled! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderNotFulfilled')) {
        result.orderNotFulfilled = overrides && overrides.hasOwnProperty('orderNotFulfilled') ? overrides.orderNotFulfilled! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderPaid')) {
        result.orderPaid = overrides && overrides.hasOwnProperty('orderPaid') ? overrides.orderPaid! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderPartiallyPaid')) {
        result.orderPartiallyPaid = overrides && overrides.hasOwnProperty('orderPartiallyPaid') ? overrides.orderPartiallyPaid! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderPending')) {
        result.orderPending = overrides && overrides.hasOwnProperty('orderPending') ? overrides.orderPending! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderPlaced')) {
        result.orderPlaced = overrides && overrides.hasOwnProperty('orderPlaced') ? overrides.orderPlaced! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderRefunded')) {
        result.orderRefunded = overrides && overrides.hasOwnProperty('orderRefunded') ? aComWixEcomOrdersV1OrderRefundedInput(overrides.orderRefunded ?? {}, pickedFields.get('orderRefunded')) : aComWixEcomOrdersV1OrderRefundedInput({}, pickedFields.get('orderRefunded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderRejected')) {
        result.orderRejected = overrides && overrides.hasOwnProperty('orderRejected') ? overrides.orderRejected! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentCanceled')) {
        result.paymentCanceled = overrides && overrides.hasOwnProperty('paymentCanceled') ? aComWixEcomOrdersV1PaymentCanceledInput(overrides.paymentCanceled ?? {}, pickedFields.get('paymentCanceled')) : aComWixEcomOrdersV1PaymentCanceledInput({}, pickedFields.get('paymentCanceled'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentDeclined')) {
        result.paymentDeclined = overrides && overrides.hasOwnProperty('paymentDeclined') ? aComWixEcomOrdersV1PaymentDeclinedInput(overrides.paymentDeclined ?? {}, pickedFields.get('paymentDeclined')) : aComWixEcomOrdersV1PaymentDeclinedInput({}, pickedFields.get('paymentDeclined'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentPending')) {
        result.paymentPending = overrides && overrides.hasOwnProperty('paymentPending') ? aComWixEcomOrdersV1PaymentPendingInput(overrides.paymentPending ?? {}, pickedFields.get('paymentPending')) : aComWixEcomOrdersV1PaymentPendingInput({}, pickedFields.get('paymentPending'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRefundFailed')) {
        result.paymentRefundFailed = overrides && overrides.hasOwnProperty('paymentRefundFailed') ? aComWixEcomOrdersV1PaymentRefundFailedInput(overrides.paymentRefundFailed ?? {}, pickedFields.get('paymentRefundFailed')) : aComWixEcomOrdersV1PaymentRefundFailedInput({}, pickedFields.get('paymentRefundFailed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRefunded')) {
        result.paymentRefunded = overrides && overrides.hasOwnProperty('paymentRefunded') ? aComWixEcomOrdersV1PaymentRefundedInput(overrides.paymentRefunded ?? {}, pickedFields.get('paymentRefunded')) : aComWixEcomOrdersV1PaymentRefundedInput({}, pickedFields.get('paymentRefunded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pickupReadyEmailSent')) {
        result.pickupReadyEmailSent = overrides && overrides.hasOwnProperty('pickupReadyEmailSent') ? overrides.pickupReadyEmailSent! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptCreated')) {
        result.receiptCreated = overrides && overrides.hasOwnProperty('receiptCreated') ? aComWixEcomOrdersV1ReceiptCreatedInput(overrides.receiptCreated ?? {}, pickedFields.get('receiptCreated')) : aComWixEcomOrdersV1ReceiptCreatedInput({}, pickedFields.get('receiptCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptSent')) {
        result.receiptSent = overrides && overrides.hasOwnProperty('receiptSent') ? aComWixEcomOrdersV1ReceiptSentInput(overrides.receiptSent ?? {}, pickedFields.get('receiptSent')) : aComWixEcomOrdersV1ReceiptSentInput({}, pickedFields.get('receiptSent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundInitiated')) {
        result.refundInitiated = overrides && overrides.hasOwnProperty('refundInitiated') ? aComWixEcomOrdersV1RefundInitiatedInput(overrides.refundInitiated ?? {}, pickedFields.get('refundInitiated')) : aComWixEcomOrdersV1RefundInitiatedInput({}, pickedFields.get('refundInitiated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedAsStoreCredit')) {
        result.refundedAsStoreCredit = overrides && overrides.hasOwnProperty('refundedAsStoreCredit') ? aComWixEcomOrdersV1RefundedAsStoreCreditInput(overrides.refundedAsStoreCredit ?? {}, pickedFields.get('refundedAsStoreCredit')) : aComWixEcomOrdersV1RefundedAsStoreCreditInput({}, pickedFields.get('refundedAsStoreCredit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethod')) {
        result.savedPaymentMethod = overrides && overrides.hasOwnProperty('savedPaymentMethod') ? aComWixEcomOrdersV1SavedPaymentMethodInput(overrides.savedPaymentMethod ?? {}, pickedFields.get('savedPaymentMethod')) : aComWixEcomOrdersV1SavedPaymentMethodInput({}, pickedFields.get('savedPaymentMethod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingAddressEdited')) {
        result.shippingAddressEdited = overrides && overrides.hasOwnProperty('shippingAddressEdited') ? overrides.shippingAddressEdited! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingConfirmationEmailSent')) {
        result.shippingConfirmationEmailSent = overrides && overrides.hasOwnProperty('shippingConfirmationEmailSent') ? overrides.shippingConfirmationEmailSent! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('trackingLinkAdded')) {
        result.trackingLinkAdded = overrides && overrides.hasOwnProperty('trackingLinkAdded') ? overrides.trackingLinkAdded! : 'sequi';
    }
    if (pickedFields.size === 0 || pickedFields.has('trackingNumberAdded')) {
        result.trackingNumberAdded = overrides && overrides.hasOwnProperty('trackingNumberAdded') ? overrides.trackingNumberAdded! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('trackingNumberEdited')) {
        result.trackingNumberEdited = overrides && overrides.hasOwnProperty('trackingNumberEdited') ? overrides.trackingNumberEdited! : 'doloremque';
    }

    return result;
};

export const aComWixEcomOrdersV1InternalQueryOrdersRequestInput = <T extends Partial<ComWixEcomOrdersV1InternalQueryOrdersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixEcommerceCommonsApiPlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixEcommerceCommonsApiPlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixEcomOrdersV1InternalQueryOrdersResponse = <T extends Partial<ComWixEcomOrdersV1InternalQueryOrdersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aComWixEcommerceCommonsApiPlatformPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aComWixEcommerceCommonsApiPlatformPagingMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orders')) {
        result.orders = overrides && overrides.hasOwnProperty('orders') ? overrides.orders!.map((x) => aComWixEcomOrdersV1Order(x ?? {}, pickedFields.get('orders'))) : [aComWixEcomOrdersV1Order({}, pickedFields.get('orders'))];
    }

    return result;
};

export const aComWixEcomOrdersV1InventoryUpdateDetailsInput = <T extends Partial<ComWixEcomOrdersV1InventoryUpdateDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('actionType')) {
        result.actionType = overrides && overrides.hasOwnProperty('actionType') ? overrides.actionType! : ComWixEcomOrdersV1InventoryUpdateDetailsInventoryAction.Decrease;
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantityChange')) {
        result.quantityChange = overrides && overrides.hasOwnProperty('quantityChange') ? overrides.quantityChange! : 7198;
    }

    return result;
};

export const aComWixEcomOrdersV1ItemChangedDetailsInput = <T extends Partial<ComWixEcomOrdersV1ItemChangedDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('priceBeforeChange')) {
        result.priceBeforeChange = overrides && overrides.hasOwnProperty('priceBeforeChange') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.priceBeforeChange ?? {}, pickedFields.get('priceBeforeChange')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('priceBeforeChange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceDescriptionBeforeChange')) {
        result.priceDescriptionBeforeChange = overrides && overrides.hasOwnProperty('priceDescriptionBeforeChange') ? aComWixEcommerceCatalogSpiApiV1PriceDescriptionInput(overrides.priceDescriptionBeforeChange ?? {}, pickedFields.get('priceDescriptionBeforeChange')) : aComWixEcommerceCatalogSpiApiV1PriceDescriptionInput({}, pickedFields.get('priceDescriptionBeforeChange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantityBeforeChange')) {
        result.quantityBeforeChange = overrides && overrides.hasOwnProperty('quantityBeforeChange') ? overrides.quantityBeforeChange! : 8785;
    }

    return result;
};

export const aComWixEcomOrdersV1ItemModifier = <T extends Partial<ComWixEcomOrdersV1ItemModifier>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcommercePlatformCommonApiTranslatableString(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcommercePlatformCommonApiTranslatableString({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixEcommercePlatformCommonApiTranslatableString(overrides.label ?? {}, pickedFields.get('label')) : aComWixEcommercePlatformCommonApiTranslatableString({}, pickedFields.get('label'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiPrice(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 2370;
    }

    return result;
};

export const aComWixEcomOrdersV1ItemModifierInput = <T extends Partial<ComWixEcomOrdersV1ItemModifierInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcommercePlatformCommonApiTranslatableStringInput(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcommercePlatformCommonApiTranslatableStringInput({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixEcommercePlatformCommonApiTranslatableStringInput(overrides.label ?? {}, pickedFields.get('label')) : aComWixEcommercePlatformCommonApiTranslatableStringInput({}, pickedFields.get('label'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 5886;
    }

    return result;
};

export const aComWixEcomOrdersV1LineItemDeltaInput = <T extends Partial<ComWixEcomOrdersV1LineItemDeltaInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('changedDetails')) {
        result.changedDetails = overrides && overrides.hasOwnProperty('changedDetails') ? aComWixEcomOrdersV1ItemChangedDetailsInput(overrides.changedDetails ?? {}, pickedFields.get('changedDetails')) : aComWixEcomOrdersV1ItemChangedDetailsInput({}, pickedFields.get('changedDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItem')) {
        result.lineItem = overrides && overrides.hasOwnProperty('lineItem') ? aComWixEcomOrdersV1OrderLineItemChangedDetailsInput(overrides.lineItem ?? {}, pickedFields.get('lineItem')) : aComWixEcomOrdersV1OrderLineItemChangedDetailsInput({}, pickedFields.get('lineItem'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemAdded')) {
        result.lineItemAdded = overrides && overrides.hasOwnProperty('lineItemAdded') ? overrides.lineItemAdded! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemRemoved')) {
        result.lineItemRemoved = overrides && overrides.hasOwnProperty('lineItemRemoved') ? overrides.lineItemRemoved! : false;
    }

    return result;
};

export const aComWixEcomOrdersV1LineItemDiscount = <T extends Partial<ComWixEcomOrdersV1LineItemDiscount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalDiscount')) {
        result.totalDiscount = overrides && overrides.hasOwnProperty('totalDiscount') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalDiscount ?? {}, pickedFields.get('totalDiscount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalDiscount'));
    }

    return result;
};

export const aComWixEcomOrdersV1LineItemDiscountInput = <T extends Partial<ComWixEcomOrdersV1LineItemDiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalDiscount')) {
        result.totalDiscount = overrides && overrides.hasOwnProperty('totalDiscount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalDiscount ?? {}, pickedFields.get('totalDiscount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalDiscount'));
    }

    return result;
};

export const aComWixEcomOrdersV1LineItemExchangeData = <T extends Partial<ComWixEcomOrdersV1LineItemExchangeData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 3225;
    }

    return result;
};

export const aComWixEcomOrdersV1LineItemExchangeDataInput = <T extends Partial<ComWixEcomOrdersV1LineItemExchangeDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 4158;
    }

    return result;
};

export const aComWixEcomOrdersV1LineItemTaxBreakdown = <T extends Partial<ComWixEcomOrdersV1LineItemTaxBreakdown>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jurisdiction')) {
        result.jurisdiction = overrides && overrides.hasOwnProperty('jurisdiction') ? overrides.jurisdiction! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdictionType')) {
        result.jurisdictionType = overrides && overrides.hasOwnProperty('jurisdictionType') ? overrides.jurisdictionType! : ComWixEcomOrdersV1JurisdictionType.City;
    }
    if (pickedFields.size === 0 || pickedFields.has('nonTaxableAmount')) {
        result.nonTaxableAmount = overrides && overrides.hasOwnProperty('nonTaxableAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.nonTaxableAmount ?? {}, pickedFields.get('nonTaxableAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('nonTaxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'cupiditate';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxAmount')) {
        result.taxAmount = overrides && overrides.hasOwnProperty('taxAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.taxAmount ?? {}, pickedFields.get('taxAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('taxAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxName')) {
        result.taxName = overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxType')) {
        result.taxType = overrides && overrides.hasOwnProperty('taxType') ? overrides.taxType! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('taxableAmount'));
    }

    return result;
};

export const aComWixEcomOrdersV1LineItemTaxBreakdownInput = <T extends Partial<ComWixEcomOrdersV1LineItemTaxBreakdownInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jurisdiction')) {
        result.jurisdiction = overrides && overrides.hasOwnProperty('jurisdiction') ? overrides.jurisdiction! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdictionType')) {
        result.jurisdictionType = overrides && overrides.hasOwnProperty('jurisdictionType') ? overrides.jurisdictionType! : ComWixEcomOrdersV1JurisdictionType.City;
    }
    if (pickedFields.size === 0 || pickedFields.has('nonTaxableAmount')) {
        result.nonTaxableAmount = overrides && overrides.hasOwnProperty('nonTaxableAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.nonTaxableAmount ?? {}, pickedFields.get('nonTaxableAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('nonTaxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxAmount')) {
        result.taxAmount = overrides && overrides.hasOwnProperty('taxAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.taxAmount ?? {}, pickedFields.get('taxAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('taxAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxName')) {
        result.taxName = overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxType')) {
        result.taxType = overrides && overrides.hasOwnProperty('taxType') ? overrides.taxType! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('taxableAmount'));
    }

    return result;
};

export const aComWixEcomOrdersV1LineItemTaxInfo = <T extends Partial<ComWixEcomOrdersV1LineItemTaxInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('taxAmount')) {
        result.taxAmount = overrides && overrides.hasOwnProperty('taxAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.taxAmount ?? {}, pickedFields.get('taxAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('taxAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aComWixEcomOrdersV1LineItemTaxBreakdown(x ?? {}, pickedFields.get('taxBreakdown'))) : [aComWixEcomOrdersV1LineItemTaxBreakdown({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxIncludedInPrice')) {
        result.taxIncludedInPrice = overrides && overrides.hasOwnProperty('taxIncludedInPrice') ? overrides.taxIncludedInPrice! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxRate')) {
        result.taxRate = overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('taxableAmount'));
    }

    return result;
};

export const aComWixEcomOrdersV1LineItemTaxInfoInput = <T extends Partial<ComWixEcomOrdersV1LineItemTaxInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('taxAmount')) {
        result.taxAmount = overrides && overrides.hasOwnProperty('taxAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.taxAmount ?? {}, pickedFields.get('taxAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('taxAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aComWixEcomOrdersV1LineItemTaxBreakdownInput({}, pickedFields.get('taxBreakdown'))) : [aComWixEcomOrdersV1LineItemTaxBreakdownInput({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxIncludedInPrice')) {
        result.taxIncludedInPrice = overrides && overrides.hasOwnProperty('taxIncludedInPrice') ? overrides.taxIncludedInPrice! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxRate')) {
        result.taxRate = overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('taxableAmount'));
    }

    return result;
};

export const aComWixEcomOrdersV1LineItemUpdateInput = <T extends Partial<ComWixEcomOrdersV1LineItemUpdateInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemId')) {
        result.lineItemId = overrides && overrides.hasOwnProperty('lineItemId') ? overrides.lineItemId! : 'aut';
    }

    return result;
};

export const aComWixEcomOrdersV1ListOrdersRequestInput = <T extends Partial<ComWixEcomOrdersV1ListOrdersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['sed'];
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixEcommerceCommonsApiPlatformCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixEcommerceCommonsApiPlatformCursorPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aComWixEcomOrdersV1ListOrdersResponse = <T extends Partial<ComWixEcomOrdersV1ListOrdersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orders')) {
        result.orders = overrides && overrides.hasOwnProperty('orders') ? overrides.orders!.map((x) => aComWixEcomOrdersV1Order(x ?? {}, pickedFields.get('orders'))) : [aComWixEcomOrdersV1Order({}, pickedFields.get('orders'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixEcomOrdersV1MarkAsFulfilledRequestInput = <T extends Partial<ComWixEcomOrdersV1MarkAsFulfilledRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'optio';
    }

    return result;
};

export const aComWixEcomOrdersV1MarkAsFulfilledResponse = <T extends Partial<ComWixEcomOrdersV1MarkAsFulfilledResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1MarkAsUnfulfilledRequestInput = <T extends Partial<ComWixEcomOrdersV1MarkAsUnfulfilledRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sequi';
    }

    return result;
};

export const aComWixEcomOrdersV1MarkAsUnfulfilledResponse = <T extends Partial<ComWixEcomOrdersV1MarkAsUnfulfilledResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1MarkOrderAsPaidRequestInput = <T extends Partial<ComWixEcomOrdersV1MarkOrderAsPaidRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'rem';
    }

    return result;
};

export const aComWixEcomOrdersV1MarkOrderAsPaidResponse = <T extends Partial<ComWixEcomOrdersV1MarkOrderAsPaidResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1MarkOrderAsSeenByHumanRequestInput = <T extends Partial<ComWixEcomOrdersV1MarkOrderAsSeenByHumanRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }

    return result;
};

export const aComWixEcomOrdersV1MarkOrderAsSeenByHumanResponse = <T extends Partial<ComWixEcomOrdersV1MarkOrderAsSeenByHumanResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1MaskedOrderInput = <T extends Partial<ComWixEcomOrdersV1MaskedOrderInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['officiis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1OrderInput(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1OrderInput({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1MaskedOrderLineItemInput = <T extends Partial<ComWixEcomOrdersV1MaskedOrderLineItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['dolore'];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItem')) {
        result.lineItem = overrides && overrides.hasOwnProperty('lineItem') ? aComWixEcomOrdersV1OrderLineItemInput(overrides.lineItem ?? {}, pickedFields.get('lineItem')) : aComWixEcomOrdersV1OrderLineItemInput({}, pickedFields.get('lineItem'));
    }

    return result;
};

export const aComWixEcomOrdersV1MembershipPaymentRefund = <T extends Partial<ComWixEcomOrdersV1MembershipPaymentRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('membershipId')) {
        result.membershipId = overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'aut';
    }

    return result;
};

export const aComWixEcomOrdersV1MembershipPaymentRefundInput = <T extends Partial<ComWixEcomOrdersV1MembershipPaymentRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('membershipId')) {
        result.membershipId = overrides && overrides.hasOwnProperty('membershipId') ? overrides.membershipId! : 'rerum';
    }

    return result;
};

export const aComWixEcomOrdersV1MerchantComment = <T extends Partial<ComWixEcomOrdersV1MerchantComment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'quo';
    }

    return result;
};

export const aComWixEcomOrdersV1MerchantCommentInput = <T extends Partial<ComWixEcomOrdersV1MerchantCommentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'dolores';
    }

    return result;
};

export const aComWixEcomOrdersV1MerchantDiscount = <T extends Partial<ComWixEcomOrdersV1MerchantDiscount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('discountReason')) {
        result.discountReason = overrides && overrides.hasOwnProperty('discountReason') ? overrides.discountReason! : ComWixEcomOrdersV1MerchantDiscountDiscountReason.BillingAdjustment;
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 'quibusdam';
    }

    return result;
};

export const aComWixEcomOrdersV1MerchantDiscountInput = <T extends Partial<ComWixEcomOrdersV1MerchantDiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('discountReason')) {
        result.discountReason = overrides && overrides.hasOwnProperty('discountReason') ? overrides.discountReason! : ComWixEcomOrdersV1MerchantDiscountDiscountReason.BillingAdjustment;
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 'ipsam';
    }

    return result;
};

export const aComWixEcomOrdersV1ModifierGroup = <T extends Partial<ComWixEcomOrdersV1ModifierGroup>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiers')) {
        result.modifiers = overrides && overrides.hasOwnProperty('modifiers') ? overrides.modifiers!.map((x) => aComWixEcomOrdersV1ItemModifier(x ?? {}, pickedFields.get('modifiers'))) : [aComWixEcomOrdersV1ItemModifier({}, pickedFields.get('modifiers'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommercePlatformCommonApiTranslatableString(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommercePlatformCommonApiTranslatableString({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomOrdersV1ModifierGroupInput = <T extends Partial<ComWixEcomOrdersV1ModifierGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiers')) {
        result.modifiers = overrides && overrides.hasOwnProperty('modifiers') ? overrides.modifiers!.map((x) => aComWixEcomOrdersV1ItemModifierInput({}, pickedFields.get('modifiers'))) : [aComWixEcomOrdersV1ItemModifierInput({}, pickedFields.get('modifiers'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommercePlatformCommonApiTranslatableStringInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommercePlatformCommonApiTranslatableStringInput({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomOrdersV1NewExchangeOrderCreated = <T extends Partial<ComWixEcomOrdersV1NewExchangeOrderCreated>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exchangeOrderId')) {
        result.exchangeOrderId = overrides && overrides.hasOwnProperty('exchangeOrderId') ? overrides.exchangeOrderId! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersV1LineItemExchangeData(x ?? {}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersV1LineItemExchangeData({}, pickedFields.get('lineItems'))];
    }

    return result;
};

export const aComWixEcomOrdersV1NewExchangeOrderCreatedInput = <T extends Partial<ComWixEcomOrdersV1NewExchangeOrderCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exchangeOrderId')) {
        result.exchangeOrderId = overrides && overrides.hasOwnProperty('exchangeOrderId') ? overrides.exchangeOrderId! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersV1LineItemExchangeDataInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersV1LineItemExchangeDataInput({}, pickedFields.get('lineItems'))];
    }

    return result;
};

export const aComWixEcomOrdersV1Order = <T extends Partial<ComWixEcomOrdersV1Order>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activities')) {
        result.activities = overrides && overrides.hasOwnProperty('activities') ? overrides.activities!.map((x) => aComWixEcomOrdersV1Activity(x ?? {}, pickedFields.get('activities'))) : [aComWixEcomOrdersV1Activity({}, pickedFields.get('activities'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomOrdersV1AdditionalFee(x ?? {}, pickedFields.get('additionalFees'))) : [aComWixEcomOrdersV1AdditionalFee({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('appliedDiscounts')) {
        result.appliedDiscounts = overrides && overrides.hasOwnProperty('appliedDiscounts') ? overrides.appliedDiscounts!.map((x) => aComWixEcomOrdersV1AppliedDiscount(x ?? {}, pickedFields.get('appliedDiscounts'))) : [aComWixEcomOrdersV1AppliedDiscount({}, pickedFields.get('appliedDiscounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('archived')) {
        result.archived = overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('attributionSource')) {
        result.attributionSource = overrides && overrides.hasOwnProperty('attributionSource') ? overrides.attributionSource! : ComWixEcomOrdersV1AttributionSourceEnumAttributionSource.FacebookAds;
    }
    if (pickedFields.size === 0 || pickedFields.has('balanceSummary')) {
        result.balanceSummary = overrides && overrides.hasOwnProperty('balanceSummary') ? aComWixEcomOrdersV1BalanceSummary(overrides.balanceSummary ?? {}, pickedFields.get('balanceSummary')) : aComWixEcomOrdersV1BalanceSummary({}, pickedFields.get('balanceSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('billingInfo')) {
        result.billingInfo = overrides && overrides.hasOwnProperty('billingInfo') ? aComWixEcommercePlatformCommonApiAddressWithContact(overrides.billingInfo ?? {}, pickedFields.get('billingInfo')) : aComWixEcommercePlatformCommonApiAddressWithContact({}, pickedFields.get('billingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocation')) {
        result.businessLocation = overrides && overrides.hasOwnProperty('businessLocation') ? aComWixEcommercePlatformCommonApiLocation(overrides.businessLocation ?? {}, pickedFields.get('businessLocation')) : aComWixEcommercePlatformCommonApiLocation({}, pickedFields.get('businessLocation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerInfo')) {
        result.buyerInfo = overrides && overrides.hasOwnProperty('buyerInfo') ? aComWixEcomOrdersV1BuyerInfo(overrides.buyerInfo ?? {}, pickedFields.get('buyerInfo')) : aComWixEcomOrdersV1BuyerInfo({}, pickedFields.get('buyerInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerLanguage')) {
        result.buyerLanguage = overrides && overrides.hasOwnProperty('buyerLanguage') ? overrides.buyerLanguage! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerNote')) {
        result.buyerNote = overrides && overrides.hasOwnProperty('buyerNote') ? overrides.buyerNote! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('cartId')) {
        result.cartId = overrides && overrides.hasOwnProperty('cartId') ? overrides.cartId! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('channelInfo')) {
        result.channelInfo = overrides && overrides.hasOwnProperty('channelInfo') ? aComWixEcomOrdersV1ChannelInfo(overrides.channelInfo ?? {}, pickedFields.get('channelInfo')) : aComWixEcomOrdersV1ChannelInfo({}, pickedFields.get('channelInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('checkoutId')) {
        result.checkoutId = overrides && overrides.hasOwnProperty('checkoutId') ? overrides.checkoutId! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdBy')) {
        result.createdBy = overrides && overrides.hasOwnProperty('createdBy') ? aComWixEcomOrdersV1CreatedBy(overrides.createdBy ?? {}, pickedFields.get('createdBy')) : aComWixEcomOrdersV1CreatedBy({}, pickedFields.get('createdBy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyConversionDetails')) {
        result.currencyConversionDetails = overrides && overrides.hasOwnProperty('currencyConversionDetails') ? aComWixEcomOrdersV1CurrencyConversionDetails(overrides.currencyConversionDetails ?? {}, pickedFields.get('currencyConversionDetails')) : aComWixEcomOrdersV1CurrencyConversionDetails({}, pickedFields.get('currencyConversionDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields!.map((x) => aComWixEcomOrdersV1CustomField(x ?? {}, pickedFields.get('customFields'))) : [aComWixEcomOrdersV1CustomField({}, pickedFields.get('customFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEnrichedLineItemsForOrderPage')) {
        result.externalEnrichedLineItemsForOrderPage = overrides && overrides.hasOwnProperty('externalEnrichedLineItemsForOrderPage') ? aComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForOrderPageResponse(overrides.externalEnrichedLineItemsForOrderPage ?? {}, pickedFields.get('externalEnrichedLineItemsForOrderPage')) : aComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForOrderPageResponse({}, pickedFields.get('externalEnrichedLineItemsForOrderPage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEnrichedLineItemsForTYP')) {
        result.externalEnrichedLineItemsForTYP = overrides && overrides.hasOwnProperty('externalEnrichedLineItemsForTYP') ? aComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForThankYouPageResponse(overrides.externalEnrichedLineItemsForTYP ?? {}, pickedFields.get('externalEnrichedLineItemsForTYP')) : aComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForThankYouPageResponse({}, pickedFields.get('externalEnrichedLineItemsForTYP'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalFulfillments')) {
        result.externalFulfillments = overrides && overrides.hasOwnProperty('externalFulfillments') ? overrides.externalFulfillments!.map((x) => aComWixEcomOrdersFulfillmentsV1Fulfillment(x ?? {}, pickedFields.get('externalFulfillments'))) : [aComWixEcomOrdersFulfillmentsV1Fulfillment({}, pickedFields.get('externalFulfillments'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('externalInvoices')) {
        result.externalInvoices = overrides && overrides.hasOwnProperty('externalInvoices') ? overrides.externalInvoices!.map((x) => aComWixEcomOrdersInvoicesV1Invoice(x ?? {}, pickedFields.get('externalInvoices'))) : [aComWixEcomOrdersInvoicesV1Invoice({}, pickedFields.get('externalInvoices'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('externalOrderRefundability')) {
        result.externalOrderRefundability = overrides && overrides.hasOwnProperty('externalOrderRefundability') ? aComWixEcomOrdersBillingV1GetOrderRefundabilityResponse(overrides.externalOrderRefundability ?? {}, pickedFields.get('externalOrderRefundability')) : aComWixEcomOrdersBillingV1GetOrderRefundabilityResponse({}, pickedFields.get('externalOrderRefundability'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalPaymentCollectabilityStatus')) {
        result.externalPaymentCollectabilityStatus = overrides && overrides.hasOwnProperty('externalPaymentCollectabilityStatus') ? aComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusResponse(overrides.externalPaymentCollectabilityStatus ?? {}, pickedFields.get('externalPaymentCollectabilityStatus')) : aComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusResponse({}, pickedFields.get('externalPaymentCollectabilityStatus'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalRefundOptions')) {
        result.externalRefundOptions = overrides && overrides.hasOwnProperty('externalRefundOptions') ? aComWixEcomOrdersBillingV1GetRefundOptionsResponse(overrides.externalRefundOptions ?? {}, pickedFields.get('externalRefundOptions')) : aComWixEcomOrdersBillingV1GetRefundOptionsResponse({}, pickedFields.get('externalRefundOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalTransactions')) {
        result.externalTransactions = overrides && overrides.hasOwnProperty('externalTransactions') ? aComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderResponse(overrides.externalTransactions ?? {}, pickedFields.get('externalTransactions')) : aComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderResponse({}, pickedFields.get('externalTransactions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillmentStatus')) {
        result.fulfillmentStatus = overrides && overrides.hasOwnProperty('fulfillmentStatus') ? overrides.fulfillmentStatus! : ComWixEcomOrdersV1FulfillmentStatus.Fulfilled;
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillmentStatusesAggregate')) {
        result.fulfillmentStatusesAggregate = overrides && overrides.hasOwnProperty('fulfillmentStatusesAggregate') ? aComWixEcomOrdersV1FulfillmentStatusesAggregate(overrides.fulfillmentStatusesAggregate ?? {}, pickedFields.get('fulfillmentStatusesAggregate')) : aComWixEcomOrdersV1FulfillmentStatusesAggregate({}, pickedFields.get('fulfillmentStatusesAggregate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('isInternalOrderCreate')) {
        result.isInternalOrderCreate = overrides && overrides.hasOwnProperty('isInternalOrderCreate') ? overrides.isInternalOrderCreate! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersV1OrderLineItem(x ?? {}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersV1OrderLineItem({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderTransactionsVirtualReference')) {
        result.orderTransactionsVirtualReference = overrides && overrides.hasOwnProperty('orderTransactionsVirtualReference') ? aComWixEcomOrdersPaymentsV1QueryOrderTransactionsResponse(overrides.orderTransactionsVirtualReference ?? {}, pickedFields.get('orderTransactionsVirtualReference')) : aComWixEcomOrdersPaymentsV1QueryOrderTransactionsResponse({}, pickedFields.get('orderTransactionsVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payAfterFreeTrial')) {
        result.payAfterFreeTrial = overrides && overrides.hasOwnProperty('payAfterFreeTrial') ? aComWixEcomOrdersV1PriceSummary(overrides.payAfterFreeTrial ?? {}, pickedFields.get('payAfterFreeTrial')) : aComWixEcomOrdersV1PriceSummary({}, pickedFields.get('payAfterFreeTrial'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payNow')) {
        result.payNow = overrides && overrides.hasOwnProperty('payNow') ? aComWixEcomOrdersV1PriceSummary(overrides.payNow ?? {}, pickedFields.get('payNow')) : aComWixEcomOrdersV1PriceSummary({}, pickedFields.get('payNow'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentStatus')) {
        result.paymentStatus = overrides && overrides.hasOwnProperty('paymentStatus') ? overrides.paymentStatus! : ComWixEcomOrdersV1PaymentStatusEnumPaymentStatus.Canceled;
    }
    if (pickedFields.size === 0 || pickedFields.has('priceSummary')) {
        result.priceSummary = overrides && overrides.hasOwnProperty('priceSummary') ? aComWixEcomOrdersV1PriceSummary(overrides.priceSummary ?? {}, pickedFields.get('priceSummary')) : aComWixEcomOrdersV1PriceSummary({}, pickedFields.get('priceSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('purchaseFlowId')) {
        result.purchaseFlowId = overrides && overrides.hasOwnProperty('purchaseFlowId') ? overrides.purchaseFlowId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('purchasedDate')) {
        result.purchasedDate = overrides && overrides.hasOwnProperty('purchasedDate') ? overrides.purchasedDate! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('recipientInfo')) {
        result.recipientInfo = overrides && overrides.hasOwnProperty('recipientInfo') ? aComWixEcommercePlatformCommonApiAddressWithContact(overrides.recipientInfo ?? {}, pickedFields.get('recipientInfo')) : aComWixEcommercePlatformCommonApiAddressWithContact({}, pickedFields.get('recipientInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('seenByAHuman')) {
        result.seenByAHuman = overrides && overrides.hasOwnProperty('seenByAHuman') ? overrides.seenByAHuman! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingInfo')) {
        result.shippingInfo = overrides && overrides.hasOwnProperty('shippingInfo') ? aComWixEcomOrdersV1ShippingInformation(overrides.shippingInfo ?? {}, pickedFields.get('shippingInfo')) : aComWixEcomOrdersV1ShippingInformation({}, pickedFields.get('shippingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteLanguage')) {
        result.siteLanguage = overrides && overrides.hasOwnProperty('siteLanguage') ? overrides.siteLanguage! : 'hic';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersV1OrderStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? aWixCommonTagsTags(overrides.tags ?? {}, pickedFields.get('tags')) : aWixCommonTagsTags({}, pickedFields.get('tags'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxIncludedInPrices')) {
        result.taxIncludedInPrices = overrides && overrides.hasOwnProperty('taxIncludedInPrices') ? overrides.taxIncludedInPrices! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxInfo')) {
        result.taxInfo = overrides && overrides.hasOwnProperty('taxInfo') ? aComWixEcomOrdersV1OrderTaxInfo(overrides.taxInfo ?? {}, pickedFields.get('taxInfo')) : aComWixEcomOrdersV1OrderTaxInfo({}, pickedFields.get('taxInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxSummary')) {
        result.taxSummary = overrides && overrides.hasOwnProperty('taxSummary') ? aComWixEcomTaxApiTaxSummary(overrides.taxSummary ?? {}, pickedFields.get('taxSummary')) : aComWixEcomTaxApiTaxSummary({}, pickedFields.get('taxSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('weightUnit')) {
        result.weightUnit = overrides && overrides.hasOwnProperty('weightUnit') ? overrides.weightUnit! : ComWixEcommercePlatformCommonApiWeightUnit.Kg;
    }

    return result;
};

export const aComWixEcomOrdersV1OrderCreateNotificationsInput = <T extends Partial<ComWixEcomOrdersV1OrderCreateNotificationsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sendNotificationToBuyer')) {
        result.sendNotificationToBuyer = overrides && overrides.hasOwnProperty('sendNotificationToBuyer') ? overrides.sendNotificationToBuyer! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('sendNotificationsToBusiness')) {
        result.sendNotificationsToBusiness = overrides && overrides.hasOwnProperty('sendNotificationsToBusiness') ? overrides.sendNotificationsToBusiness! : false;
    }

    return result;
};

export const aComWixEcomOrdersV1OrderCreatedFromExchange = <T extends Partial<ComWixEcomOrdersV1OrderCreatedFromExchange>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('originalOrderId')) {
        result.originalOrderId = overrides && overrides.hasOwnProperty('originalOrderId') ? overrides.originalOrderId! : 'et';
    }

    return result;
};

export const aComWixEcomOrdersV1OrderCreatedFromExchangeInput = <T extends Partial<ComWixEcomOrdersV1OrderCreatedFromExchangeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('originalOrderId')) {
        result.originalOrderId = overrides && overrides.hasOwnProperty('originalOrderId') ? overrides.originalOrderId! : 'temporibus';
    }

    return result;
};

export const aComWixEcomOrdersV1OrderCreationSettingsInput = <T extends Partial<ComWixEcomOrdersV1OrderCreationSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('notifications')) {
        result.notifications = overrides && overrides.hasOwnProperty('notifications') ? aComWixEcomOrdersV1OrderCreateNotificationsInput(overrides.notifications ?? {}, pickedFields.get('notifications')) : aComWixEcomOrdersV1OrderCreateNotificationsInput({}, pickedFields.get('notifications'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderApprovalStrategy')) {
        result.orderApprovalStrategy = overrides && overrides.hasOwnProperty('orderApprovalStrategy') ? overrides.orderApprovalStrategy! : ComWixEcomOrdersV1OrderApprovalStrategy.Default;
    }

    return result;
};

export const aComWixEcomOrdersV1OrderInput = <T extends Partial<ComWixEcomOrdersV1OrderInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activities')) {
        result.activities = overrides && overrides.hasOwnProperty('activities') ? overrides.activities!.map((x) => aComWixEcomOrdersV1ActivityInput({}, pickedFields.get('activities'))) : [aComWixEcomOrdersV1ActivityInput({}, pickedFields.get('activities'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomOrdersV1AdditionalFeeInput({}, pickedFields.get('additionalFees'))) : [aComWixEcomOrdersV1AdditionalFeeInput({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('appliedDiscounts')) {
        result.appliedDiscounts = overrides && overrides.hasOwnProperty('appliedDiscounts') ? overrides.appliedDiscounts!.map((x) => aComWixEcomOrdersV1AppliedDiscountInput({}, pickedFields.get('appliedDiscounts'))) : [aComWixEcomOrdersV1AppliedDiscountInput({}, pickedFields.get('appliedDiscounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('archived')) {
        result.archived = overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('attributionSource')) {
        result.attributionSource = overrides && overrides.hasOwnProperty('attributionSource') ? overrides.attributionSource! : ComWixEcomOrdersV1AttributionSourceEnumAttributionSource.FacebookAds;
    }
    if (pickedFields.size === 0 || pickedFields.has('balanceSummary')) {
        result.balanceSummary = overrides && overrides.hasOwnProperty('balanceSummary') ? aComWixEcomOrdersV1BalanceSummaryInput(overrides.balanceSummary ?? {}, pickedFields.get('balanceSummary')) : aComWixEcomOrdersV1BalanceSummaryInput({}, pickedFields.get('balanceSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('billingInfo')) {
        result.billingInfo = overrides && overrides.hasOwnProperty('billingInfo') ? aComWixEcommercePlatformCommonApiAddressWithContactInput(overrides.billingInfo ?? {}, pickedFields.get('billingInfo')) : aComWixEcommercePlatformCommonApiAddressWithContactInput({}, pickedFields.get('billingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocation')) {
        result.businessLocation = overrides && overrides.hasOwnProperty('businessLocation') ? aComWixEcommercePlatformCommonApiLocationInput(overrides.businessLocation ?? {}, pickedFields.get('businessLocation')) : aComWixEcommercePlatformCommonApiLocationInput({}, pickedFields.get('businessLocation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerInfo')) {
        result.buyerInfo = overrides && overrides.hasOwnProperty('buyerInfo') ? aComWixEcomOrdersV1BuyerInfoInput(overrides.buyerInfo ?? {}, pickedFields.get('buyerInfo')) : aComWixEcomOrdersV1BuyerInfoInput({}, pickedFields.get('buyerInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerLanguage')) {
        result.buyerLanguage = overrides && overrides.hasOwnProperty('buyerLanguage') ? overrides.buyerLanguage! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerNote')) {
        result.buyerNote = overrides && overrides.hasOwnProperty('buyerNote') ? overrides.buyerNote! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('cartId')) {
        result.cartId = overrides && overrides.hasOwnProperty('cartId') ? overrides.cartId! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('channelInfo')) {
        result.channelInfo = overrides && overrides.hasOwnProperty('channelInfo') ? aComWixEcomOrdersV1ChannelInfoInput(overrides.channelInfo ?? {}, pickedFields.get('channelInfo')) : aComWixEcomOrdersV1ChannelInfoInput({}, pickedFields.get('channelInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('checkoutId')) {
        result.checkoutId = overrides && overrides.hasOwnProperty('checkoutId') ? overrides.checkoutId! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdBy')) {
        result.createdBy = overrides && overrides.hasOwnProperty('createdBy') ? aComWixEcomOrdersV1CreatedByInput(overrides.createdBy ?? {}, pickedFields.get('createdBy')) : aComWixEcomOrdersV1CreatedByInput({}, pickedFields.get('createdBy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyConversionDetails')) {
        result.currencyConversionDetails = overrides && overrides.hasOwnProperty('currencyConversionDetails') ? aComWixEcomOrdersV1CurrencyConversionDetailsInput(overrides.currencyConversionDetails ?? {}, pickedFields.get('currencyConversionDetails')) : aComWixEcomOrdersV1CurrencyConversionDetailsInput({}, pickedFields.get('currencyConversionDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields!.map((x) => aComWixEcomOrdersV1CustomFieldInput({}, pickedFields.get('customFields'))) : [aComWixEcomOrdersV1CustomFieldInput({}, pickedFields.get('customFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillmentStatus')) {
        result.fulfillmentStatus = overrides && overrides.hasOwnProperty('fulfillmentStatus') ? overrides.fulfillmentStatus! : ComWixEcomOrdersV1FulfillmentStatus.Fulfilled;
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillmentStatusesAggregate')) {
        result.fulfillmentStatusesAggregate = overrides && overrides.hasOwnProperty('fulfillmentStatusesAggregate') ? aComWixEcomOrdersV1FulfillmentStatusesAggregateInput(overrides.fulfillmentStatusesAggregate ?? {}, pickedFields.get('fulfillmentStatusesAggregate')) : aComWixEcomOrdersV1FulfillmentStatusesAggregateInput({}, pickedFields.get('fulfillmentStatusesAggregate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('isInternalOrderCreate')) {
        result.isInternalOrderCreate = overrides && overrides.hasOwnProperty('isInternalOrderCreate') ? overrides.isInternalOrderCreate! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersV1OrderLineItemInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersV1OrderLineItemInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('payAfterFreeTrial')) {
        result.payAfterFreeTrial = overrides && overrides.hasOwnProperty('payAfterFreeTrial') ? aComWixEcomOrdersV1PriceSummaryInput(overrides.payAfterFreeTrial ?? {}, pickedFields.get('payAfterFreeTrial')) : aComWixEcomOrdersV1PriceSummaryInput({}, pickedFields.get('payAfterFreeTrial'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payNow')) {
        result.payNow = overrides && overrides.hasOwnProperty('payNow') ? aComWixEcomOrdersV1PriceSummaryInput(overrides.payNow ?? {}, pickedFields.get('payNow')) : aComWixEcomOrdersV1PriceSummaryInput({}, pickedFields.get('payNow'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentStatus')) {
        result.paymentStatus = overrides && overrides.hasOwnProperty('paymentStatus') ? overrides.paymentStatus! : ComWixEcomOrdersV1PaymentStatusEnumPaymentStatus.Canceled;
    }
    if (pickedFields.size === 0 || pickedFields.has('priceSummary')) {
        result.priceSummary = overrides && overrides.hasOwnProperty('priceSummary') ? aComWixEcomOrdersV1PriceSummaryInput(overrides.priceSummary ?? {}, pickedFields.get('priceSummary')) : aComWixEcomOrdersV1PriceSummaryInput({}, pickedFields.get('priceSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('purchaseFlowId')) {
        result.purchaseFlowId = overrides && overrides.hasOwnProperty('purchaseFlowId') ? overrides.purchaseFlowId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('purchasedDate')) {
        result.purchasedDate = overrides && overrides.hasOwnProperty('purchasedDate') ? overrides.purchasedDate! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('recipientInfo')) {
        result.recipientInfo = overrides && overrides.hasOwnProperty('recipientInfo') ? aComWixEcommercePlatformCommonApiAddressWithContactInput(overrides.recipientInfo ?? {}, pickedFields.get('recipientInfo')) : aComWixEcommercePlatformCommonApiAddressWithContactInput({}, pickedFields.get('recipientInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('seenByAHuman')) {
        result.seenByAHuman = overrides && overrides.hasOwnProperty('seenByAHuman') ? overrides.seenByAHuman! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingInfo')) {
        result.shippingInfo = overrides && overrides.hasOwnProperty('shippingInfo') ? aComWixEcomOrdersV1ShippingInformationInput(overrides.shippingInfo ?? {}, pickedFields.get('shippingInfo')) : aComWixEcomOrdersV1ShippingInformationInput({}, pickedFields.get('shippingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteLanguage')) {
        result.siteLanguage = overrides && overrides.hasOwnProperty('siteLanguage') ? overrides.siteLanguage! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersV1OrderStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? aWixCommonTagsTagsInput(overrides.tags ?? {}, pickedFields.get('tags')) : aWixCommonTagsTagsInput({}, pickedFields.get('tags'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxIncludedInPrices')) {
        result.taxIncludedInPrices = overrides && overrides.hasOwnProperty('taxIncludedInPrices') ? overrides.taxIncludedInPrices! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxInfo')) {
        result.taxInfo = overrides && overrides.hasOwnProperty('taxInfo') ? aComWixEcomOrdersV1OrderTaxInfoInput(overrides.taxInfo ?? {}, pickedFields.get('taxInfo')) : aComWixEcomOrdersV1OrderTaxInfoInput({}, pickedFields.get('taxInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('weightUnit')) {
        result.weightUnit = overrides && overrides.hasOwnProperty('weightUnit') ? overrides.weightUnit! : ComWixEcommercePlatformCommonApiWeightUnit.Kg;
    }

    return result;
};

export const aComWixEcomOrdersV1OrderLineItem = <T extends Partial<ComWixEcomOrdersV1OrderLineItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('catalogReference')) {
        result.catalogReference = overrides && overrides.hasOwnProperty('catalogReference') ? aComWixEcommerceCatalogSpiApiV1CatalogReference(overrides.catalogReference ?? {}, pickedFields.get('catalogReference')) : aComWixEcommerceCatalogSpiApiV1CatalogReference({}, pickedFields.get('catalogReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customLineItem')) {
        result.customLineItem = overrides && overrides.hasOwnProperty('customLineItem') ? overrides.customLineItem! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryProfileId')) {
        result.deliveryProfileId = overrides && overrides.hasOwnProperty('deliveryProfileId') ? overrides.deliveryProfileId! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('depositAmount')) {
        result.depositAmount = overrides && overrides.hasOwnProperty('depositAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.depositAmount ?? {}, pickedFields.get('depositAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('depositAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLine(x ?? {}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLine({}, pickedFields.get('descriptionLines'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('digitalFile')) {
        result.digitalFile = overrides && overrides.hasOwnProperty('digitalFile') ? aComWixEcomOrdersV1DigitalFile(overrides.digitalFile ?? {}, pickedFields.get('digitalFile')) : aComWixEcomOrdersV1DigitalFile({}, pickedFields.get('digitalFile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedQuantity')) {
        result.fixedQuantity = overrides && overrides.hasOwnProperty('fixedQuantity') ? overrides.fixedQuantity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillerId')) {
        result.fulfillerId = overrides && overrides.hasOwnProperty('fulfillerId') ? overrides.fulfillerId! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('inventoryAppId')) {
        result.inventoryAppId = overrides && overrides.hasOwnProperty('inventoryAppId') ? overrides.inventoryAppId! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemType')) {
        result.itemType = overrides && overrides.hasOwnProperty('itemType') ? aComWixEcommerceCatalogSpiApiV1ItemType(overrides.itemType ?? {}, pickedFields.get('itemType')) : aComWixEcommerceCatalogSpiApiV1ItemType({}, pickedFields.get('itemType'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemPrice')) {
        result.lineItemPrice = overrides && overrides.hasOwnProperty('lineItemPrice') ? aComWixEcommercePlatformCommonApiPrice(overrides.lineItemPrice ?? {}, pickedFields.get('lineItemPrice')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('lineItemPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aComWixEcommercePlatformCommonApiLocationAndQuantity(x ?? {}, pickedFields.get('locations'))) : [aComWixEcommercePlatformCommonApiLocationAndQuantity({}, pickedFields.get('locations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroups')) {
        result.modifierGroups = overrides && overrides.hasOwnProperty('modifierGroups') ? overrides.modifierGroups!.map((x) => aComWixEcomOrdersV1ModifierGroup(x ?? {}, pickedFields.get('modifierGroups'))) : [aComWixEcomOrdersV1ModifierGroup({}, pickedFields.get('modifierGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOption')) {
        result.paymentOption = overrides && overrides.hasOwnProperty('paymentOption') ? overrides.paymentOption! : ComWixEcommerceCatalogSpiApiV1PaymentOptionType.DepositOnline;
    }
    if (pickedFields.size === 0 || pickedFields.has('physicalProperties')) {
        result.physicalProperties = overrides && overrides.hasOwnProperty('physicalProperties') ? aComWixEcommerceCatalogSpiApiV1PhysicalProperties(overrides.physicalProperties ?? {}, pickedFields.get('physicalProperties')) : aComWixEcommerceCatalogSpiApiV1PhysicalProperties({}, pickedFields.get('physicalProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiPrice(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscounts')) {
        result.priceBeforeDiscounts = overrides && overrides.hasOwnProperty('priceBeforeDiscounts') ? aComWixEcommercePlatformCommonApiPrice(overrides.priceBeforeDiscounts ?? {}, pickedFields.get('priceBeforeDiscounts')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('priceBeforeDiscounts'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscountsAndTax')) {
        result.priceBeforeDiscountsAndTax = overrides && overrides.hasOwnProperty('priceBeforeDiscountsAndTax') ? aComWixEcommercePlatformCommonApiPrice(overrides.priceBeforeDiscountsAndTax ?? {}, pickedFields.get('priceBeforeDiscountsAndTax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('priceBeforeDiscountsAndTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceDescription')) {
        result.priceDescription = overrides && overrides.hasOwnProperty('priceDescription') ? aComWixEcommerceCatalogSpiApiV1PriceDescription(overrides.priceDescription ?? {}, pickedFields.get('priceDescription')) : aComWixEcommerceCatalogSpiApiV1PriceDescription({}, pickedFields.get('priceDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceUndetermined')) {
        result.priceUndetermined = overrides && overrides.hasOwnProperty('priceUndetermined') ? overrides.priceUndetermined! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('productName')) {
        result.productName = overrides && overrides.hasOwnProperty('productName') ? aComWixEcommerceCatalogSpiApiV1ProductName(overrides.productName ?? {}, pickedFields.get('productName')) : aComWixEcommerceCatalogSpiApiV1ProductName({}, pickedFields.get('productName'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 9748;
    }
    if (pickedFields.size === 0 || pickedFields.has('refundQuantity')) {
        result.refundQuantity = overrides && overrides.hasOwnProperty('refundQuantity') ? overrides.refundQuantity! : 5570;
    }
    if (pickedFields.size === 0 || pickedFields.has('restockQuantity')) {
        result.restockQuantity = overrides && overrides.hasOwnProperty('restockQuantity') ? overrides.restockQuantity! : 4351;
    }
    if (pickedFields.size === 0 || pickedFields.has('rootCatalogItemId')) {
        result.rootCatalogItemId = overrides && overrides.hasOwnProperty('rootCatalogItemId') ? overrides.rootCatalogItemId! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingGroupId')) {
        result.shippingGroupId = overrides && overrides.hasOwnProperty('shippingGroupId') ? overrides.shippingGroupId! : 'repellat';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionInfo')) {
        result.subscriptionInfo = overrides && overrides.hasOwnProperty('subscriptionInfo') ? aComWixEcomOrdersV1SubscriptionInfo(overrides.subscriptionInfo ?? {}, pickedFields.get('subscriptionInfo')) : aComWixEcomOrdersV1SubscriptionInfo({}, pickedFields.get('subscriptionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxDetails')) {
        result.taxDetails = overrides && overrides.hasOwnProperty('taxDetails') ? aComWixEcomTaxApiItemTaxFullDetails(overrides.taxDetails ?? {}, pickedFields.get('taxDetails')) : aComWixEcomTaxApiItemTaxFullDetails({}, pickedFields.get('taxDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxInfo')) {
        result.taxInfo = overrides && overrides.hasOwnProperty('taxInfo') ? aComWixEcomOrdersV1LineItemTaxInfo(overrides.taxInfo ?? {}, pickedFields.get('taxInfo')) : aComWixEcomOrdersV1LineItemTaxInfo({}, pickedFields.get('taxInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAddress')) {
        result.taxableAddress = overrides && overrides.hasOwnProperty('taxableAddress') ? aComWixEcommercePlatformCommonApiTaxableAddress(overrides.taxableAddress ?? {}, pickedFields.get('taxableAddress')) : aComWixEcommercePlatformCommonApiTaxableAddress({}, pickedFields.get('taxableAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalDiscount')) {
        result.totalDiscount = overrides && overrides.hasOwnProperty('totalDiscount') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalDiscount ?? {}, pickedFields.get('totalDiscount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalDiscount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceAfterTax')) {
        result.totalPriceAfterTax = overrides && overrides.hasOwnProperty('totalPriceAfterTax') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalPriceAfterTax ?? {}, pickedFields.get('totalPriceAfterTax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalPriceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceBeforeTax')) {
        result.totalPriceBeforeTax = overrides && overrides.hasOwnProperty('totalPriceBeforeTax') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalPriceBeforeTax ?? {}, pickedFields.get('totalPriceBeforeTax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalPriceBeforeTax'));
    }

    return result;
};

export const aComWixEcomOrdersV1OrderLineItemChangedDetailsInput = <T extends Partial<ComWixEcomOrdersV1OrderLineItemChangedDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('catalogReference')) {
        result.catalogReference = overrides && overrides.hasOwnProperty('catalogReference') ? aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput(overrides.catalogReference ?? {}, pickedFields.get('catalogReference')) : aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput({}, pickedFields.get('catalogReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customLineItem')) {
        result.customLineItem = overrides && overrides.hasOwnProperty('customLineItem') ? overrides.customLineItem! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('digitalFile')) {
        result.digitalFile = overrides && overrides.hasOwnProperty('digitalFile') ? aComWixEcomOrdersV1DigitalFileInput(overrides.digitalFile ?? {}, pickedFields.get('digitalFile')) : aComWixEcomOrdersV1DigitalFileInput({}, pickedFields.get('digitalFile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillerId')) {
        result.fulfillerId = overrides && overrides.hasOwnProperty('fulfillerId') ? overrides.fulfillerId! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('inventoryAppId')) {
        result.inventoryAppId = overrides && overrides.hasOwnProperty('inventoryAppId') ? overrides.inventoryAppId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemType')) {
        result.itemType = overrides && overrides.hasOwnProperty('itemType') ? aComWixEcommerceCatalogSpiApiV1ItemTypeInput(overrides.itemType ?? {}, pickedFields.get('itemType')) : aComWixEcommerceCatalogSpiApiV1ItemTypeInput({}, pickedFields.get('itemType'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemPrice')) {
        result.lineItemPrice = overrides && overrides.hasOwnProperty('lineItemPrice') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.lineItemPrice ?? {}, pickedFields.get('lineItemPrice')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('lineItemPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aComWixEcommercePlatformCommonApiLocationAndQuantityInput({}, pickedFields.get('locations'))) : [aComWixEcommercePlatformCommonApiLocationAndQuantityInput({}, pickedFields.get('locations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroups')) {
        result.modifierGroups = overrides && overrides.hasOwnProperty('modifierGroups') ? overrides.modifierGroups!.map((x) => aComWixEcomOrdersV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))) : [aComWixEcomOrdersV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOption')) {
        result.paymentOption = overrides && overrides.hasOwnProperty('paymentOption') ? overrides.paymentOption! : ComWixEcomOrdersV1DeltaPaymentOptionType.FullPaymentOffline;
    }
    if (pickedFields.size === 0 || pickedFields.has('physicalProperties')) {
        result.physicalProperties = overrides && overrides.hasOwnProperty('physicalProperties') ? aComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput(overrides.physicalProperties ?? {}, pickedFields.get('physicalProperties')) : aComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput({}, pickedFields.get('physicalProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscounts')) {
        result.priceBeforeDiscounts = overrides && overrides.hasOwnProperty('priceBeforeDiscounts') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.priceBeforeDiscounts ?? {}, pickedFields.get('priceBeforeDiscounts')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('priceBeforeDiscounts'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscountsAndTax')) {
        result.priceBeforeDiscountsAndTax = overrides && overrides.hasOwnProperty('priceBeforeDiscountsAndTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.priceBeforeDiscountsAndTax ?? {}, pickedFields.get('priceBeforeDiscountsAndTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('priceBeforeDiscountsAndTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceDescription')) {
        result.priceDescription = overrides && overrides.hasOwnProperty('priceDescription') ? aComWixEcommerceCatalogSpiApiV1PriceDescriptionInput(overrides.priceDescription ?? {}, pickedFields.get('priceDescription')) : aComWixEcommerceCatalogSpiApiV1PriceDescriptionInput({}, pickedFields.get('priceDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('productName')) {
        result.productName = overrides && overrides.hasOwnProperty('productName') ? aComWixEcommerceCatalogSpiApiV1ProductNameInput(overrides.productName ?? {}, pickedFields.get('productName')) : aComWixEcommerceCatalogSpiApiV1ProductNameInput({}, pickedFields.get('productName'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 9044;
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionInfo')) {
        result.subscriptionInfo = overrides && overrides.hasOwnProperty('subscriptionInfo') ? aComWixEcomOrdersV1SubscriptionInfoInput(overrides.subscriptionInfo ?? {}, pickedFields.get('subscriptionInfo')) : aComWixEcomOrdersV1SubscriptionInfoInput({}, pickedFields.get('subscriptionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxInfo')) {
        result.taxInfo = overrides && overrides.hasOwnProperty('taxInfo') ? aComWixEcomOrdersV1LineItemTaxInfoInput(overrides.taxInfo ?? {}, pickedFields.get('taxInfo')) : aComWixEcomOrdersV1LineItemTaxInfoInput({}, pickedFields.get('taxInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalDiscount')) {
        result.totalDiscount = overrides && overrides.hasOwnProperty('totalDiscount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalDiscount ?? {}, pickedFields.get('totalDiscount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalDiscount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceAfterTax')) {
        result.totalPriceAfterTax = overrides && overrides.hasOwnProperty('totalPriceAfterTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalPriceAfterTax ?? {}, pickedFields.get('totalPriceAfterTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalPriceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceBeforeTax')) {
        result.totalPriceBeforeTax = overrides && overrides.hasOwnProperty('totalPriceBeforeTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalPriceBeforeTax ?? {}, pickedFields.get('totalPriceBeforeTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalPriceBeforeTax'));
    }

    return result;
};

export const aComWixEcomOrdersV1OrderLineItemInput = <T extends Partial<ComWixEcomOrdersV1OrderLineItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('catalogReference')) {
        result.catalogReference = overrides && overrides.hasOwnProperty('catalogReference') ? aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput(overrides.catalogReference ?? {}, pickedFields.get('catalogReference')) : aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput({}, pickedFields.get('catalogReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customLineItem')) {
        result.customLineItem = overrides && overrides.hasOwnProperty('customLineItem') ? overrides.customLineItem! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryProfileId')) {
        result.deliveryProfileId = overrides && overrides.hasOwnProperty('deliveryProfileId') ? overrides.deliveryProfileId! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('depositAmount')) {
        result.depositAmount = overrides && overrides.hasOwnProperty('depositAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.depositAmount ?? {}, pickedFields.get('depositAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('depositAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('digitalFile')) {
        result.digitalFile = overrides && overrides.hasOwnProperty('digitalFile') ? aComWixEcomOrdersV1DigitalFileInput(overrides.digitalFile ?? {}, pickedFields.get('digitalFile')) : aComWixEcomOrdersV1DigitalFileInput({}, pickedFields.get('digitalFile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedQuantity')) {
        result.fixedQuantity = overrides && overrides.hasOwnProperty('fixedQuantity') ? overrides.fixedQuantity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillerId')) {
        result.fulfillerId = overrides && overrides.hasOwnProperty('fulfillerId') ? overrides.fulfillerId! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('inventoryAppId')) {
        result.inventoryAppId = overrides && overrides.hasOwnProperty('inventoryAppId') ? overrides.inventoryAppId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemType')) {
        result.itemType = overrides && overrides.hasOwnProperty('itemType') ? aComWixEcommerceCatalogSpiApiV1ItemTypeInput(overrides.itemType ?? {}, pickedFields.get('itemType')) : aComWixEcommerceCatalogSpiApiV1ItemTypeInput({}, pickedFields.get('itemType'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemPrice')) {
        result.lineItemPrice = overrides && overrides.hasOwnProperty('lineItemPrice') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.lineItemPrice ?? {}, pickedFields.get('lineItemPrice')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('lineItemPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aComWixEcommercePlatformCommonApiLocationAndQuantityInput({}, pickedFields.get('locations'))) : [aComWixEcommercePlatformCommonApiLocationAndQuantityInput({}, pickedFields.get('locations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroups')) {
        result.modifierGroups = overrides && overrides.hasOwnProperty('modifierGroups') ? overrides.modifierGroups!.map((x) => aComWixEcomOrdersV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))) : [aComWixEcomOrdersV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOption')) {
        result.paymentOption = overrides && overrides.hasOwnProperty('paymentOption') ? overrides.paymentOption! : ComWixEcommerceCatalogSpiApiV1PaymentOptionType.DepositOnline;
    }
    if (pickedFields.size === 0 || pickedFields.has('physicalProperties')) {
        result.physicalProperties = overrides && overrides.hasOwnProperty('physicalProperties') ? aComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput(overrides.physicalProperties ?? {}, pickedFields.get('physicalProperties')) : aComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput({}, pickedFields.get('physicalProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscounts')) {
        result.priceBeforeDiscounts = overrides && overrides.hasOwnProperty('priceBeforeDiscounts') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.priceBeforeDiscounts ?? {}, pickedFields.get('priceBeforeDiscounts')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('priceBeforeDiscounts'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscountsAndTax')) {
        result.priceBeforeDiscountsAndTax = overrides && overrides.hasOwnProperty('priceBeforeDiscountsAndTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.priceBeforeDiscountsAndTax ?? {}, pickedFields.get('priceBeforeDiscountsAndTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('priceBeforeDiscountsAndTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceDescription')) {
        result.priceDescription = overrides && overrides.hasOwnProperty('priceDescription') ? aComWixEcommerceCatalogSpiApiV1PriceDescriptionInput(overrides.priceDescription ?? {}, pickedFields.get('priceDescription')) : aComWixEcommerceCatalogSpiApiV1PriceDescriptionInput({}, pickedFields.get('priceDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceUndetermined')) {
        result.priceUndetermined = overrides && overrides.hasOwnProperty('priceUndetermined') ? overrides.priceUndetermined! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('productName')) {
        result.productName = overrides && overrides.hasOwnProperty('productName') ? aComWixEcommerceCatalogSpiApiV1ProductNameInput(overrides.productName ?? {}, pickedFields.get('productName')) : aComWixEcommerceCatalogSpiApiV1ProductNameInput({}, pickedFields.get('productName'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 4359;
    }
    if (pickedFields.size === 0 || pickedFields.has('refundQuantity')) {
        result.refundQuantity = overrides && overrides.hasOwnProperty('refundQuantity') ? overrides.refundQuantity! : 8524;
    }
    if (pickedFields.size === 0 || pickedFields.has('restockQuantity')) {
        result.restockQuantity = overrides && overrides.hasOwnProperty('restockQuantity') ? overrides.restockQuantity! : 1232;
    }
    if (pickedFields.size === 0 || pickedFields.has('rootCatalogItemId')) {
        result.rootCatalogItemId = overrides && overrides.hasOwnProperty('rootCatalogItemId') ? overrides.rootCatalogItemId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingGroupId')) {
        result.shippingGroupId = overrides && overrides.hasOwnProperty('shippingGroupId') ? overrides.shippingGroupId! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionInfo')) {
        result.subscriptionInfo = overrides && overrides.hasOwnProperty('subscriptionInfo') ? aComWixEcomOrdersV1SubscriptionInfoInput(overrides.subscriptionInfo ?? {}, pickedFields.get('subscriptionInfo')) : aComWixEcomOrdersV1SubscriptionInfoInput({}, pickedFields.get('subscriptionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxInfo')) {
        result.taxInfo = overrides && overrides.hasOwnProperty('taxInfo') ? aComWixEcomOrdersV1LineItemTaxInfoInput(overrides.taxInfo ?? {}, pickedFields.get('taxInfo')) : aComWixEcomOrdersV1LineItemTaxInfoInput({}, pickedFields.get('taxInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAddress')) {
        result.taxableAddress = overrides && overrides.hasOwnProperty('taxableAddress') ? aComWixEcommercePlatformCommonApiTaxableAddressInput(overrides.taxableAddress ?? {}, pickedFields.get('taxableAddress')) : aComWixEcommercePlatformCommonApiTaxableAddressInput({}, pickedFields.get('taxableAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalDiscount')) {
        result.totalDiscount = overrides && overrides.hasOwnProperty('totalDiscount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalDiscount ?? {}, pickedFields.get('totalDiscount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalDiscount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceAfterTax')) {
        result.totalPriceAfterTax = overrides && overrides.hasOwnProperty('totalPriceAfterTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalPriceAfterTax ?? {}, pickedFields.get('totalPriceAfterTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalPriceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceBeforeTax')) {
        result.totalPriceBeforeTax = overrides && overrides.hasOwnProperty('totalPriceBeforeTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalPriceBeforeTax ?? {}, pickedFields.get('totalPriceBeforeTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalPriceBeforeTax'));
    }

    return result;
};

export const aComWixEcomOrdersV1OrderRefunded = <T extends Partial<ComWixEcomOrdersV1OrderRefunded>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('manual')) {
        result.manual = overrides && overrides.hasOwnProperty('manual') ? overrides.manual! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'animi';
    }

    return result;
};

export const aComWixEcomOrdersV1OrderRefundedInput = <T extends Partial<ComWixEcomOrdersV1OrderRefundedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('manual')) {
        result.manual = overrides && overrides.hasOwnProperty('manual') ? overrides.manual! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'dolores';
    }

    return result;
};

export const aComWixEcomOrdersV1OrderReindexRequestInput = <T extends Partial<ComWixEcomOrdersV1OrderReindexRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventTime')) {
        result.eventTime = overrides && overrides.hasOwnProperty('eventTime') ? overrides.eventTime! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'rem';
    }

    return result;
};

export const aComWixEcomOrdersV1OrderTaxBreakdown = <T extends Partial<ComWixEcomOrdersV1OrderTaxBreakdown>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregatedTaxAmount')) {
        result.aggregatedTaxAmount = overrides && overrides.hasOwnProperty('aggregatedTaxAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.aggregatedTaxAmount ?? {}, pickedFields.get('aggregatedTaxAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('aggregatedTaxAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('aggregatedTaxableAmount')) {
        result.aggregatedTaxableAmount = overrides && overrides.hasOwnProperty('aggregatedTaxableAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.aggregatedTaxableAmount ?? {}, pickedFields.get('aggregatedTaxableAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('aggregatedTaxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdiction')) {
        result.jurisdiction = overrides && overrides.hasOwnProperty('jurisdiction') ? overrides.jurisdiction! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdictionType')) {
        result.jurisdictionType = overrides && overrides.hasOwnProperty('jurisdictionType') ? overrides.jurisdictionType! : ComWixEcomOrdersV1JurisdictionType.City;
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxName')) {
        result.taxName = overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxType')) {
        result.taxType = overrides && overrides.hasOwnProperty('taxType') ? overrides.taxType! : 'cum';
    }

    return result;
};

export const aComWixEcomOrdersV1OrderTaxBreakdownInput = <T extends Partial<ComWixEcomOrdersV1OrderTaxBreakdownInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregatedTaxAmount')) {
        result.aggregatedTaxAmount = overrides && overrides.hasOwnProperty('aggregatedTaxAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.aggregatedTaxAmount ?? {}, pickedFields.get('aggregatedTaxAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('aggregatedTaxAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('aggregatedTaxableAmount')) {
        result.aggregatedTaxableAmount = overrides && overrides.hasOwnProperty('aggregatedTaxableAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.aggregatedTaxableAmount ?? {}, pickedFields.get('aggregatedTaxableAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('aggregatedTaxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdiction')) {
        result.jurisdiction = overrides && overrides.hasOwnProperty('jurisdiction') ? overrides.jurisdiction! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdictionType')) {
        result.jurisdictionType = overrides && overrides.hasOwnProperty('jurisdictionType') ? overrides.jurisdictionType! : ComWixEcomOrdersV1JurisdictionType.City;
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxName')) {
        result.taxName = overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'repudiandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxType')) {
        result.taxType = overrides && overrides.hasOwnProperty('taxType') ? overrides.taxType! : 'doloremque';
    }

    return result;
};

export const aComWixEcomOrdersV1OrderTaxInfo = <T extends Partial<ComWixEcomOrdersV1OrderTaxInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('manualTaxRate')) {
        result.manualTaxRate = overrides && overrides.hasOwnProperty('manualTaxRate') ? overrides.manualTaxRate! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aComWixEcomOrdersV1OrderTaxBreakdown(x ?? {}, pickedFields.get('taxBreakdown'))) : [aComWixEcomOrdersV1OrderTaxBreakdown({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxExempt')) {
        result.taxExempt = overrides && overrides.hasOwnProperty('taxExempt') ? overrides.taxExempt! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalTax ?? {}, pickedFields.get('totalTax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalTax'));
    }

    return result;
};

export const aComWixEcomOrdersV1OrderTaxInfoInput = <T extends Partial<ComWixEcomOrdersV1OrderTaxInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('manualTaxRate')) {
        result.manualTaxRate = overrides && overrides.hasOwnProperty('manualTaxRate') ? overrides.manualTaxRate! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aComWixEcomOrdersV1OrderTaxBreakdownInput({}, pickedFields.get('taxBreakdown'))) : [aComWixEcomOrdersV1OrderTaxBreakdownInput({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxExempt')) {
        result.taxExempt = overrides && overrides.hasOwnProperty('taxExempt') ? overrides.taxExempt! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalTax ?? {}, pickedFields.get('totalTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalTax'));
    }

    return result;
};

export const aComWixEcomOrdersV1PaymentCanceled = <T extends Partial<ComWixEcomOrdersV1PaymentCanceled>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('regular')) {
        result.regular = overrides && overrides.hasOwnProperty('regular') ? aComWixEcomOrdersV1RegularPayment(overrides.regular ?? {}, pickedFields.get('regular')) : aComWixEcomOrdersV1RegularPayment({}, pickedFields.get('regular'));
    }

    return result;
};

export const aComWixEcomOrdersV1PaymentCanceledInput = <T extends Partial<ComWixEcomOrdersV1PaymentCanceledInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('regular')) {
        result.regular = overrides && overrides.hasOwnProperty('regular') ? aComWixEcomOrdersV1RegularPaymentInput(overrides.regular ?? {}, pickedFields.get('regular')) : aComWixEcomOrdersV1RegularPaymentInput({}, pickedFields.get('regular'));
    }

    return result;
};

export const aComWixEcomOrdersV1PaymentDeclined = <T extends Partial<ComWixEcomOrdersV1PaymentDeclined>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('regular')) {
        result.regular = overrides && overrides.hasOwnProperty('regular') ? aComWixEcomOrdersV1RegularPayment(overrides.regular ?? {}, pickedFields.get('regular')) : aComWixEcomOrdersV1RegularPayment({}, pickedFields.get('regular'));
    }

    return result;
};

export const aComWixEcomOrdersV1PaymentDeclinedInput = <T extends Partial<ComWixEcomOrdersV1PaymentDeclinedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('regular')) {
        result.regular = overrides && overrides.hasOwnProperty('regular') ? aComWixEcomOrdersV1RegularPaymentInput(overrides.regular ?? {}, pickedFields.get('regular')) : aComWixEcomOrdersV1RegularPaymentInput({}, pickedFields.get('regular'));
    }

    return result;
};

export const aComWixEcomOrdersV1PaymentPending = <T extends Partial<ComWixEcomOrdersV1PaymentPending>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('regular')) {
        result.regular = overrides && overrides.hasOwnProperty('regular') ? aComWixEcomOrdersV1RegularPayment(overrides.regular ?? {}, pickedFields.get('regular')) : aComWixEcomOrdersV1RegularPayment({}, pickedFields.get('regular'));
    }

    return result;
};

export const aComWixEcomOrdersV1PaymentPendingInput = <T extends Partial<ComWixEcomOrdersV1PaymentPendingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('regular')) {
        result.regular = overrides && overrides.hasOwnProperty('regular') ? aComWixEcomOrdersV1RegularPaymentInput(overrides.regular ?? {}, pickedFields.get('regular')) : aComWixEcomOrdersV1RegularPaymentInput({}, pickedFields.get('regular'));
    }

    return result;
};

export const aComWixEcomOrdersV1PaymentRefundFailed = <T extends Partial<ComWixEcomOrdersV1PaymentRefundFailed>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aComWixEcomOrdersV1RefundedPayment(overrides.payment ?? {}, pickedFields.get('payment')) : aComWixEcomOrdersV1RefundedPayment({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'dolorum';
    }

    return result;
};

export const aComWixEcomOrdersV1PaymentRefundFailedInput = <T extends Partial<ComWixEcomOrdersV1PaymentRefundFailedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aComWixEcomOrdersV1RefundedPaymentInput(overrides.payment ?? {}, pickedFields.get('payment')) : aComWixEcomOrdersV1RefundedPaymentInput({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'nemo';
    }

    return result;
};

export const aComWixEcomOrdersV1PaymentRefunded = <T extends Partial<ComWixEcomOrdersV1PaymentRefunded>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aComWixEcomOrdersV1RefundedPayment(overrides.payment ?? {}, pickedFields.get('payment')) : aComWixEcomOrdersV1RefundedPayment({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'deserunt';
    }

    return result;
};

export const aComWixEcomOrdersV1PaymentRefundedInput = <T extends Partial<ComWixEcomOrdersV1PaymentRefundedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aComWixEcomOrdersV1RefundedPaymentInput(overrides.payment ?? {}, pickedFields.get('payment')) : aComWixEcomOrdersV1RefundedPaymentInput({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'qui';
    }

    return result;
};

export const aComWixEcomOrdersV1PaymentStatusUpdatedInput = <T extends Partial<ComWixEcomOrdersV1PaymentStatusUpdatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1OrderInput(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1OrderInput({}, pickedFields.get('order'));
    }
    if (pickedFields.size === 0 || pickedFields.has('previousPaymentStatus')) {
        result.previousPaymentStatus = overrides && overrides.hasOwnProperty('previousPaymentStatus') ? overrides.previousPaymentStatus! : ComWixEcomOrdersV1PaymentStatusEnumPaymentStatus.Canceled;
    }

    return result;
};

export const aComWixEcomOrdersV1PickupDetails = <T extends Partial<ComWixEcomOrdersV1PickupDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixEcommercePlatformCommonApiPickupAddress(overrides.address ?? {}, pickedFields.get('address')) : aComWixEcommercePlatformCommonApiPickupAddress({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pickupMethod')) {
        result.pickupMethod = overrides && overrides.hasOwnProperty('pickupMethod') ? overrides.pickupMethod! : ComWixEcomOrdersV1PickupDetailsPickupMethod.PickupPoint;
    }

    return result;
};

export const aComWixEcomOrdersV1PickupDetailsInput = <T extends Partial<ComWixEcomOrdersV1PickupDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixEcommercePlatformCommonApiPickupAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aComWixEcommercePlatformCommonApiPickupAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pickupMethod')) {
        result.pickupMethod = overrides && overrides.hasOwnProperty('pickupMethod') ? overrides.pickupMethod! : ComWixEcomOrdersV1PickupDetailsPickupMethod.PickupPoint;
    }

    return result;
};

export const aComWixEcomOrdersV1PriceSummary = <T extends Partial<ComWixEcomOrdersV1PriceSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiPrice(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcommercePlatformCommonApiPrice(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('shipping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixEcommercePlatformCommonApiPrice(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiPrice(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiPrice(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('total'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalAdditionalFees')) {
        result.totalAdditionalFees = overrides && overrides.hasOwnProperty('totalAdditionalFees') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalAdditionalFees ?? {}, pickedFields.get('totalAdditionalFees')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalAdditionalFees'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPrice')) {
        result.totalPrice = overrides && overrides.hasOwnProperty('totalPrice') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalPrice ?? {}, pickedFields.get('totalPrice')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalWithGiftCard')) {
        result.totalWithGiftCard = overrides && overrides.hasOwnProperty('totalWithGiftCard') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalWithGiftCard ?? {}, pickedFields.get('totalWithGiftCard')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalWithGiftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalWithoutGiftCard')) {
        result.totalWithoutGiftCard = overrides && overrides.hasOwnProperty('totalWithoutGiftCard') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalWithoutGiftCard ?? {}, pickedFields.get('totalWithoutGiftCard')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalWithoutGiftCard'));
    }

    return result;
};

export const aComWixEcomOrdersV1PriceSummaryInput = <T extends Partial<ComWixEcomOrdersV1PriceSummaryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('shipping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('total'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalAdditionalFees')) {
        result.totalAdditionalFees = overrides && overrides.hasOwnProperty('totalAdditionalFees') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalAdditionalFees ?? {}, pickedFields.get('totalAdditionalFees')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalAdditionalFees'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPrice')) {
        result.totalPrice = overrides && overrides.hasOwnProperty('totalPrice') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalPrice ?? {}, pickedFields.get('totalPrice')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalWithGiftCard')) {
        result.totalWithGiftCard = overrides && overrides.hasOwnProperty('totalWithGiftCard') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalWithGiftCard ?? {}, pickedFields.get('totalWithGiftCard')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalWithGiftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalWithoutGiftCard')) {
        result.totalWithoutGiftCard = overrides && overrides.hasOwnProperty('totalWithoutGiftCard') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalWithoutGiftCard ?? {}, pickedFields.get('totalWithoutGiftCard')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalWithoutGiftCard'));
    }

    return result;
};

export const aComWixEcomOrdersV1PublicActivityInput = <T extends Partial<ComWixEcomOrdersV1PublicActivityInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customActivity')) {
        result.customActivity = overrides && overrides.hasOwnProperty('customActivity') ? aComWixEcomOrdersV1CustomActivityInput(overrides.customActivity ?? {}, pickedFields.get('customActivity')) : aComWixEcomOrdersV1CustomActivityInput({}, pickedFields.get('customActivity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantComment')) {
        result.merchantComment = overrides && overrides.hasOwnProperty('merchantComment') ? aComWixEcomOrdersV1MerchantCommentInput(overrides.merchantComment ?? {}, pickedFields.get('merchantComment')) : aComWixEcomOrdersV1MerchantCommentInput({}, pickedFields.get('merchantComment'));
    }

    return result;
};

export const aComWixEcomOrdersV1QueryOrderRequestInput = <T extends Partial<ComWixEcomOrdersV1QueryOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixEcommerceCommonsApiPlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixEcommerceCommonsApiPlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixEcomOrdersV1QueryOrderResponse = <T extends Partial<ComWixEcomOrdersV1QueryOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixEcomOrdersV1Order(x ?? {}, pickedFields.get('items'))) : [aComWixEcomOrdersV1Order({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixEcomOrdersV1ReceiptCreated = <T extends Partial<ComWixEcomOrdersV1ReceiptCreated>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalReceipt')) {
        result.externalReceipt = overrides && overrides.hasOwnProperty('externalReceipt') ? aComWixEcomOrdersV1ExternalReceipt(overrides.externalReceipt ?? {}, pickedFields.get('externalReceipt')) : aComWixEcomOrdersV1ExternalReceipt({}, pickedFields.get('externalReceipt'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixReceipt')) {
        result.wixReceipt = overrides && overrides.hasOwnProperty('wixReceipt') ? aComWixEcomOrdersV1WixReceipt(overrides.wixReceipt ?? {}, pickedFields.get('wixReceipt')) : aComWixEcomOrdersV1WixReceipt({}, pickedFields.get('wixReceipt'));
    }

    return result;
};

export const aComWixEcomOrdersV1ReceiptCreatedInput = <T extends Partial<ComWixEcomOrdersV1ReceiptCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalReceipt')) {
        result.externalReceipt = overrides && overrides.hasOwnProperty('externalReceipt') ? aComWixEcomOrdersV1ExternalReceiptInput(overrides.externalReceipt ?? {}, pickedFields.get('externalReceipt')) : aComWixEcomOrdersV1ExternalReceiptInput({}, pickedFields.get('externalReceipt'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixReceipt')) {
        result.wixReceipt = overrides && overrides.hasOwnProperty('wixReceipt') ? aComWixEcomOrdersV1WixReceiptInput(overrides.wixReceipt ?? {}, pickedFields.get('wixReceipt')) : aComWixEcomOrdersV1WixReceiptInput({}, pickedFields.get('wixReceipt'));
    }

    return result;
};

export const aComWixEcomOrdersV1ReceiptSent = <T extends Partial<ComWixEcomOrdersV1ReceiptSent>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalReceipt')) {
        result.externalReceipt = overrides && overrides.hasOwnProperty('externalReceipt') ? aComWixEcomOrdersV1ExternalReceipt(overrides.externalReceipt ?? {}, pickedFields.get('externalReceipt')) : aComWixEcomOrdersV1ExternalReceipt({}, pickedFields.get('externalReceipt'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixReceipt')) {
        result.wixReceipt = overrides && overrides.hasOwnProperty('wixReceipt') ? aComWixEcomOrdersV1WixReceipt(overrides.wixReceipt ?? {}, pickedFields.get('wixReceipt')) : aComWixEcomOrdersV1WixReceipt({}, pickedFields.get('wixReceipt'));
    }

    return result;
};

export const aComWixEcomOrdersV1ReceiptSentInput = <T extends Partial<ComWixEcomOrdersV1ReceiptSentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalReceipt')) {
        result.externalReceipt = overrides && overrides.hasOwnProperty('externalReceipt') ? aComWixEcomOrdersV1ExternalReceiptInput(overrides.externalReceipt ?? {}, pickedFields.get('externalReceipt')) : aComWixEcomOrdersV1ExternalReceiptInput({}, pickedFields.get('externalReceipt'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixReceipt')) {
        result.wixReceipt = overrides && overrides.hasOwnProperty('wixReceipt') ? aComWixEcomOrdersV1WixReceiptInput(overrides.wixReceipt ?? {}, pickedFields.get('wixReceipt')) : aComWixEcomOrdersV1WixReceiptInput({}, pickedFields.get('wixReceipt'));
    }

    return result;
};

export const aComWixEcomOrdersV1RefundInitiated = <T extends Partial<ComWixEcomOrdersV1RefundInitiated>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? overrides.payments!.map((x) => aComWixEcomOrdersV1RefundedPayment(x ?? {}, pickedFields.get('payments'))) : [aComWixEcomOrdersV1RefundedPayment({}, pickedFields.get('payments'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'ut';
    }

    return result;
};

export const aComWixEcomOrdersV1RefundInitiatedInput = <T extends Partial<ComWixEcomOrdersV1RefundInitiatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? overrides.payments!.map((x) => aComWixEcomOrdersV1RefundedPaymentInput({}, pickedFields.get('payments'))) : [aComWixEcomOrdersV1RefundedPaymentInput({}, pickedFields.get('payments'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'vitae';
    }

    return result;
};

export const aComWixEcomOrdersV1RefundedAsStoreCredit = <T extends Partial<ComWixEcomOrdersV1RefundedAsStoreCredit>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'officiis';
    }

    return result;
};

export const aComWixEcomOrdersV1RefundedAsStoreCreditInput = <T extends Partial<ComWixEcomOrdersV1RefundedAsStoreCreditInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'aspernatur';
    }

    return result;
};

export const aComWixEcomOrdersV1RefundedPayment = <T extends Partial<ComWixEcomOrdersV1RefundedPayment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalRefund')) {
        result.externalRefund = overrides && overrides.hasOwnProperty('externalRefund') ? overrides.externalRefund! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aComWixEcomOrdersV1GiftCardPaymentRefund(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aComWixEcomOrdersV1GiftCardPaymentRefund({}, pickedFields.get('giftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('membership')) {
        result.membership = overrides && overrides.hasOwnProperty('membership') ? aComWixEcomOrdersV1MembershipPaymentRefund(overrides.membership ?? {}, pickedFields.get('membership')) : aComWixEcomOrdersV1MembershipPaymentRefund({}, pickedFields.get('membership'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('regular')) {
        result.regular = overrides && overrides.hasOwnProperty('regular') ? aComWixEcomOrdersV1RegularPaymentRefund(overrides.regular ?? {}, pickedFields.get('regular')) : aComWixEcomOrdersV1RegularPaymentRefund({}, pickedFields.get('regular'));
    }

    return result;
};

export const aComWixEcomOrdersV1RefundedPaymentInput = <T extends Partial<ComWixEcomOrdersV1RefundedPaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalRefund')) {
        result.externalRefund = overrides && overrides.hasOwnProperty('externalRefund') ? overrides.externalRefund! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aComWixEcomOrdersV1GiftCardPaymentRefundInput(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aComWixEcomOrdersV1GiftCardPaymentRefundInput({}, pickedFields.get('giftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('membership')) {
        result.membership = overrides && overrides.hasOwnProperty('membership') ? aComWixEcomOrdersV1MembershipPaymentRefundInput(overrides.membership ?? {}, pickedFields.get('membership')) : aComWixEcomOrdersV1MembershipPaymentRefundInput({}, pickedFields.get('membership'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentId')) {
        result.paymentId = overrides && overrides.hasOwnProperty('paymentId') ? overrides.paymentId! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('regular')) {
        result.regular = overrides && overrides.hasOwnProperty('regular') ? aComWixEcomOrdersV1RegularPaymentRefundInput(overrides.regular ?? {}, pickedFields.get('regular')) : aComWixEcomOrdersV1RegularPaymentRefundInput({}, pickedFields.get('regular'));
    }

    return result;
};

export const aComWixEcomOrdersV1RegularPayment = <T extends Partial<ComWixEcomOrdersV1RegularPayment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('creditCardDetails')) {
        result.creditCardDetails = overrides && overrides.hasOwnProperty('creditCardDetails') ? aComWixEcomOrdersV1CreditCardDetails(overrides.creditCardDetails ?? {}, pickedFields.get('creditCardDetails')) : aComWixEcomOrdersV1CreditCardDetails({}, pickedFields.get('creditCardDetails'));
    }

    return result;
};

export const aComWixEcomOrdersV1RegularPaymentInput = <T extends Partial<ComWixEcomOrdersV1RegularPaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('creditCardDetails')) {
        result.creditCardDetails = overrides && overrides.hasOwnProperty('creditCardDetails') ? aComWixEcomOrdersV1CreditCardDetailsInput(overrides.creditCardDetails ?? {}, pickedFields.get('creditCardDetails')) : aComWixEcomOrdersV1CreditCardDetailsInput({}, pickedFields.get('creditCardDetails'));
    }

    return result;
};

export const aComWixEcomOrdersV1RegularPaymentRefund = <T extends Partial<ComWixEcomOrdersV1RegularPaymentRefund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'sed';
    }

    return result;
};

export const aComWixEcomOrdersV1RegularPaymentRefundInput = <T extends Partial<ComWixEcomOrdersV1RegularPaymentRefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'qui';
    }

    return result;
};

export const aComWixEcomOrdersV1SavedPaymentMethod = <T extends Partial<ComWixEcomOrdersV1SavedPaymentMethod>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'veritatis';
    }

    return result;
};

export const aComWixEcomOrdersV1SavedPaymentMethodInput = <T extends Partial<ComWixEcomOrdersV1SavedPaymentMethodInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'adipisci';
    }

    return result;
};

export const aComWixEcomOrdersV1SearchOrdersRequestInput = <T extends Partial<ComWixEcomOrdersV1SearchOrdersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aComWixEcomOrdersV1UpstreamWixQueryCursorSearchInput(overrides.search ?? {}, pickedFields.get('search')) : aComWixEcomOrdersV1UpstreamWixQueryCursorSearchInput({}, pickedFields.get('search'));
    }

    return result;
};

export const aComWixEcomOrdersV1SearchOrdersResponse = <T extends Partial<ComWixEcomOrdersV1SearchOrdersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixCommonCursorPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixCommonCursorPagingMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orders')) {
        result.orders = overrides && overrides.hasOwnProperty('orders') ? overrides.orders!.map((x) => aComWixEcomOrdersV1Order(x ?? {}, pickedFields.get('orders'))) : [aComWixEcomOrdersV1Order({}, pickedFields.get('orders'))];
    }

    return result;
};

export const aComWixEcomOrdersV1ShippingInformation = <T extends Partial<ComWixEcomOrdersV1ShippingInformation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierId')) {
        result.carrierId = overrides && overrides.hasOwnProperty('carrierId') ? overrides.carrierId! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('cost')) {
        result.cost = overrides && overrides.hasOwnProperty('cost') ? aComWixEcomOrdersV1ShippingPrice(overrides.cost ?? {}, pickedFields.get('cost')) : aComWixEcomOrdersV1ShippingPrice({}, pickedFields.get('cost'));
    }
    if (pickedFields.size === 0 || pickedFields.has('logistics')) {
        result.logistics = overrides && overrides.hasOwnProperty('logistics') ? aComWixEcomOrdersV1DeliveryLogistics(overrides.logistics ?? {}, pickedFields.get('logistics')) : aComWixEcomOrdersV1DeliveryLogistics({}, pickedFields.get('logistics'));
    }
    if (pickedFields.size === 0 || pickedFields.has('region')) {
        result.region = overrides && overrides.hasOwnProperty('region') ? aComWixEcomOrdersV1ShippingRegion(overrides.region ?? {}, pickedFields.get('region')) : aComWixEcomOrdersV1ShippingRegion({}, pickedFields.get('region'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'reprehenderit';
    }

    return result;
};

export const aComWixEcomOrdersV1ShippingInformationInput = <T extends Partial<ComWixEcomOrdersV1ShippingInformationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierId')) {
        result.carrierId = overrides && overrides.hasOwnProperty('carrierId') ? overrides.carrierId! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('cost')) {
        result.cost = overrides && overrides.hasOwnProperty('cost') ? aComWixEcomOrdersV1ShippingPriceInput(overrides.cost ?? {}, pickedFields.get('cost')) : aComWixEcomOrdersV1ShippingPriceInput({}, pickedFields.get('cost'));
    }
    if (pickedFields.size === 0 || pickedFields.has('logistics')) {
        result.logistics = overrides && overrides.hasOwnProperty('logistics') ? aComWixEcomOrdersV1DeliveryLogisticsInput(overrides.logistics ?? {}, pickedFields.get('logistics')) : aComWixEcomOrdersV1DeliveryLogisticsInput({}, pickedFields.get('logistics'));
    }
    if (pickedFields.size === 0 || pickedFields.has('region')) {
        result.region = overrides && overrides.hasOwnProperty('region') ? aComWixEcomOrdersV1ShippingRegionInput(overrides.region ?? {}, pickedFields.get('region')) : aComWixEcomOrdersV1ShippingRegionInput({}, pickedFields.get('region'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'dolor';
    }

    return result;
};

export const aComWixEcomOrdersV1ShippingPrice = <T extends Partial<ComWixEcomOrdersV1ShippingPrice>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiPrice(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiPrice(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxDetails')) {
        result.taxDetails = overrides && overrides.hasOwnProperty('taxDetails') ? aComWixEcomTaxApiItemTaxFullDetails(overrides.taxDetails ?? {}, pickedFields.get('taxDetails')) : aComWixEcomTaxApiItemTaxFullDetails({}, pickedFields.get('taxDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceAfterTax')) {
        result.totalPriceAfterTax = overrides && overrides.hasOwnProperty('totalPriceAfterTax') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalPriceAfterTax ?? {}, pickedFields.get('totalPriceAfterTax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalPriceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceBeforeTax')) {
        result.totalPriceBeforeTax = overrides && overrides.hasOwnProperty('totalPriceBeforeTax') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalPriceBeforeTax ?? {}, pickedFields.get('totalPriceBeforeTax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalPriceBeforeTax'));
    }

    return result;
};

export const aComWixEcomOrdersV1ShippingPriceInput = <T extends Partial<ComWixEcomOrdersV1ShippingPriceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxDetails')) {
        result.taxDetails = overrides && overrides.hasOwnProperty('taxDetails') ? aComWixEcomTaxApiItemTaxFullDetailsInput(overrides.taxDetails ?? {}, pickedFields.get('taxDetails')) : aComWixEcomTaxApiItemTaxFullDetailsInput({}, pickedFields.get('taxDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceAfterTax')) {
        result.totalPriceAfterTax = overrides && overrides.hasOwnProperty('totalPriceAfterTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalPriceAfterTax ?? {}, pickedFields.get('totalPriceAfterTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalPriceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceBeforeTax')) {
        result.totalPriceBeforeTax = overrides && overrides.hasOwnProperty('totalPriceBeforeTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalPriceBeforeTax ?? {}, pickedFields.get('totalPriceBeforeTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalPriceBeforeTax'));
    }

    return result;
};

export const aComWixEcomOrdersV1ShippingRegion = <T extends Partial<ComWixEcomOrdersV1ShippingRegion>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'molestiae';
    }

    return result;
};

export const aComWixEcomOrdersV1ShippingRegionInput = <T extends Partial<ComWixEcomOrdersV1ShippingRegionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'accusamus';
    }

    return result;
};

export const aComWixEcomOrdersV1SubscriptionDescription = <T extends Partial<ComWixEcomOrdersV1SubscriptionDescription>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'dolores';
    }

    return result;
};

export const aComWixEcomOrdersV1SubscriptionDescriptionInput = <T extends Partial<ComWixEcomOrdersV1SubscriptionDescriptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'reprehenderit';
    }

    return result;
};

export const aComWixEcomOrdersV1SubscriptionInfo = <T extends Partial<ComWixEcomOrdersV1SubscriptionInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('billingAdjustment')) {
        result.billingAdjustment = overrides && overrides.hasOwnProperty('billingAdjustment') ? aComWixEcomOrdersV1BillingAdjustment(overrides.billingAdjustment ?? {}, pickedFields.get('billingAdjustment')) : aComWixEcomOrdersV1BillingAdjustment({}, pickedFields.get('billingAdjustment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargesDescription')) {
        result.chargesDescription = overrides && overrides.hasOwnProperty('chargesDescription') ? overrides.chargesDescription! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('cycleNumber')) {
        result.cycleNumber = overrides && overrides.hasOwnProperty('cycleNumber') ? overrides.cycleNumber! : 7430;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aComWixEcomOrdersV1SubscriptionDescription(overrides.description ?? {}, pickedFields.get('description')) : aComWixEcomOrdersV1SubscriptionDescription({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'commodi';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionOptionDescription')) {
        result.subscriptionOptionDescription = overrides && overrides.hasOwnProperty('subscriptionOptionDescription') ? overrides.subscriptionOptionDescription! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionOptionTitle')) {
        result.subscriptionOptionTitle = overrides && overrides.hasOwnProperty('subscriptionOptionTitle') ? overrides.subscriptionOptionTitle! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionSettings')) {
        result.subscriptionSettings = overrides && overrides.hasOwnProperty('subscriptionSettings') ? aComWixEcomOrdersV1SubscriptionSettings(overrides.subscriptionSettings ?? {}, pickedFields.get('subscriptionSettings')) : aComWixEcomOrdersV1SubscriptionSettings({}, pickedFields.get('subscriptionSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? aComWixEcomOrdersV1SubscriptionTitle(overrides.title ?? {}, pickedFields.get('title')) : aComWixEcomOrdersV1SubscriptionTitle({}, pickedFields.get('title'));
    }

    return result;
};

export const aComWixEcomOrdersV1SubscriptionInfoInput = <T extends Partial<ComWixEcomOrdersV1SubscriptionInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('billingAdjustment')) {
        result.billingAdjustment = overrides && overrides.hasOwnProperty('billingAdjustment') ? aComWixEcomOrdersV1BillingAdjustmentInput(overrides.billingAdjustment ?? {}, pickedFields.get('billingAdjustment')) : aComWixEcomOrdersV1BillingAdjustmentInput({}, pickedFields.get('billingAdjustment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargesDescription')) {
        result.chargesDescription = overrides && overrides.hasOwnProperty('chargesDescription') ? overrides.chargesDescription! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('cycleNumber')) {
        result.cycleNumber = overrides && overrides.hasOwnProperty('cycleNumber') ? overrides.cycleNumber! : 136;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aComWixEcomOrdersV1SubscriptionDescriptionInput(overrides.description ?? {}, pickedFields.get('description')) : aComWixEcomOrdersV1SubscriptionDescriptionInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionSettings')) {
        result.subscriptionSettings = overrides && overrides.hasOwnProperty('subscriptionSettings') ? aComWixEcomOrdersV1SubscriptionSettingsInput(overrides.subscriptionSettings ?? {}, pickedFields.get('subscriptionSettings')) : aComWixEcomOrdersV1SubscriptionSettingsInput({}, pickedFields.get('subscriptionSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? aComWixEcomOrdersV1SubscriptionTitleInput(overrides.title ?? {}, pickedFields.get('title')) : aComWixEcomOrdersV1SubscriptionTitleInput({}, pickedFields.get('title'));
    }

    return result;
};

export const aComWixEcomOrdersV1SubscriptionSettings = <T extends Partial<ComWixEcomOrdersV1SubscriptionSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoRenewal')) {
        result.autoRenewal = overrides && overrides.hasOwnProperty('autoRenewal') ? overrides.autoRenewal! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('billingCycles')) {
        result.billingCycles = overrides && overrides.hasOwnProperty('billingCycles') ? overrides.billingCycles! : 8805;
    }
    if (pickedFields.size === 0 || pickedFields.has('enableCustomerCancellation')) {
        result.enableCustomerCancellation = overrides && overrides.hasOwnProperty('enableCustomerCancellation') ? overrides.enableCustomerCancellation! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('freeTrialPeriod')) {
        result.freeTrialPeriod = overrides && overrides.hasOwnProperty('freeTrialPeriod') ? aComWixEcomOrdersV1FreeTrialPeriod(overrides.freeTrialPeriod ?? {}, pickedFields.get('freeTrialPeriod')) : aComWixEcomOrdersV1FreeTrialPeriod({}, pickedFields.get('freeTrialPeriod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : WixPaymentApiPayV2SubscriptionFrequency.Day;
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : 6987;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'quisquam';
    }

    return result;
};

export const aComWixEcomOrdersV1SubscriptionSettingsInput = <T extends Partial<ComWixEcomOrdersV1SubscriptionSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoRenewal')) {
        result.autoRenewal = overrides && overrides.hasOwnProperty('autoRenewal') ? overrides.autoRenewal! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('billingCycles')) {
        result.billingCycles = overrides && overrides.hasOwnProperty('billingCycles') ? overrides.billingCycles! : 7675;
    }
    if (pickedFields.size === 0 || pickedFields.has('enableCustomerCancellation')) {
        result.enableCustomerCancellation = overrides && overrides.hasOwnProperty('enableCustomerCancellation') ? overrides.enableCustomerCancellation! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('freeTrialPeriod')) {
        result.freeTrialPeriod = overrides && overrides.hasOwnProperty('freeTrialPeriod') ? aComWixEcomOrdersV1FreeTrialPeriodInput(overrides.freeTrialPeriod ?? {}, pickedFields.get('freeTrialPeriod')) : aComWixEcomOrdersV1FreeTrialPeriodInput({}, pickedFields.get('freeTrialPeriod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : WixPaymentApiPayV2SubscriptionFrequency.Day;
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : 7903;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'quia';
    }

    return result;
};

export const aComWixEcomOrdersV1SubscriptionTitle = <T extends Partial<ComWixEcomOrdersV1SubscriptionTitle>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'doloribus';
    }

    return result;
};

export const aComWixEcomOrdersV1SubscriptionTitleInput = <T extends Partial<ComWixEcomOrdersV1SubscriptionTitleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'nostrum';
    }

    return result;
};

export const aComWixEcomOrdersV1TranslatedValue = <T extends Partial<ComWixEcomOrdersV1TranslatedValue>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'magni';
    }

    return result;
};

export const aComWixEcomOrdersV1TranslatedValueInput = <T extends Partial<ComWixEcomOrdersV1TranslatedValueInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'vitae';
    }

    return result;
};

export const aComWixEcomOrdersV1UnArchiveOrderRequestInput = <T extends Partial<ComWixEcomOrdersV1UnArchiveOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }

    return result;
};

export const aComWixEcomOrdersV1UnArchiveOrderResponse = <T extends Partial<ComWixEcomOrdersV1UnArchiveOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateActivityRequestInput = <T extends Partial<ComWixEcomOrdersV1UpdateActivityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activity')) {
        result.activity = overrides && overrides.hasOwnProperty('activity') ? aComWixEcomOrdersV1PublicActivityInput(overrides.activity ?? {}, pickedFields.get('activity')) : aComWixEcomOrdersV1PublicActivityInput({}, pickedFields.get('activity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('activityId')) {
        result.activityId = overrides && overrides.hasOwnProperty('activityId') ? overrides.activityId! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'magnam';
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateActivityResponse = <T extends Partial<ComWixEcomOrdersV1UpdateActivityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateBillingContactDetailsRequestInput = <T extends Partial<ComWixEcomOrdersV1UpdateBillingContactDetailsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressContactDetails')) {
        result.addressContactDetails = overrides && overrides.hasOwnProperty('addressContactDetails') ? aComWixEcommercePlatformCommonApiFullAddressContactDetailsInput(overrides.addressContactDetails ?? {}, pickedFields.get('addressContactDetails')) : aComWixEcommercePlatformCommonApiFullAddressContactDetailsInput({}, pickedFields.get('addressContactDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['quaerat'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'illo';
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateBillingContactDetailsResponse = <T extends Partial<ComWixEcomOrdersV1UpdateBillingContactDetailsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateBuyerEmailRequestInput = <T extends Partial<ComWixEcomOrdersV1UpdateBuyerEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eius';
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateBuyerEmailResponse = <T extends Partial<ComWixEcomOrdersV1UpdateBuyerEmailResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateBuyerInfoRequestInput = <T extends Partial<ComWixEcomOrdersV1UpdateBuyerInfoRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buyerInfo')) {
        result.buyerInfo = overrides && overrides.hasOwnProperty('buyerInfo') ? aComWixEcomOrdersV1BuyerInfoUpdateInput(overrides.buyerInfo ?? {}, pickedFields.get('buyerInfo')) : aComWixEcomOrdersV1BuyerInfoUpdateInput({}, pickedFields.get('buyerInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['ea'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'iure';
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateBuyerInfoResponse = <T extends Partial<ComWixEcomOrdersV1UpdateBuyerInfoResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateLineItemsDescriptionLinesRequestInput = <T extends Partial<ComWixEcomOrdersV1UpdateLineItemsDescriptionLinesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersV1LineItemUpdateInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersV1LineItemUpdateInput({}, pickedFields.get('lineItems'))];
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateLineItemsDescriptionLinesResponse = <T extends Partial<ComWixEcomOrdersV1UpdateLineItemsDescriptionLinesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateOrderLineItemRequestInput = <T extends Partial<ComWixEcomOrdersV1UpdateOrderLineItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['molestias'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItem')) {
        result.lineItem = overrides && overrides.hasOwnProperty('lineItem') ? aComWixEcomOrdersV1OrderLineItemInput(overrides.lineItem ?? {}, pickedFields.get('lineItem')) : aComWixEcomOrdersV1OrderLineItemInput({}, pickedFields.get('lineItem'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateOrderLineItemResponse = <T extends Partial<ComWixEcomOrdersV1UpdateOrderLineItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateOrderLineItemsRequestInput = <T extends Partial<ComWixEcomOrdersV1UpdateOrderLineItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixEcomOrdersV1MaskedOrderLineItemInput({}, pickedFields.get('lineItems'))) : [aComWixEcomOrdersV1MaskedOrderLineItemInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'consequuntur';
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateOrderLineItemsResponse = <T extends Partial<ComWixEcomOrdersV1UpdateOrderLineItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateOrderRequestInput = <T extends Partial<ComWixEcomOrdersV1UpdateOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['voluptatem'];
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1OrderInput(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1OrderInput({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateOrderResponse = <T extends Partial<ComWixEcomOrdersV1UpdateOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateOrderShippingAddressRequestInput = <T extends Partial<ComWixEcomOrdersV1UpdateOrderShippingAddressRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['quis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingAddress')) {
        result.shippingAddress = overrides && overrides.hasOwnProperty('shippingAddress') ? aComWixEcommercePlatformCommonApiAddressWithContactInput(overrides.shippingAddress ?? {}, pickedFields.get('shippingAddress')) : aComWixEcommercePlatformCommonApiAddressWithContactInput({}, pickedFields.get('shippingAddress'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateOrderShippingAddressResponse = <T extends Partial<ComWixEcomOrdersV1UpdateOrderShippingAddressResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateOrderStatusRequestInput = <T extends Partial<ComWixEcomOrdersV1UpdateOrderStatusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixEcomOrdersV1OrderStatus.Approved;
    }

    return result;
};

export const aComWixEcomOrdersV1UpdateOrderStatusResponse = <T extends Partial<ComWixEcomOrdersV1UpdateOrderStatusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aComWixEcomOrdersV1UpstreamWixQueryCursorSearchInput = <T extends Partial<ComWixEcomOrdersV1UpstreamWixQueryCursorSearchInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixEcomOrdersV1WixReceipt = <T extends Partial<ComWixEcomOrdersV1WixReceipt>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayNumber')) {
        result.displayNumber = overrides && overrides.hasOwnProperty('displayNumber') ? overrides.displayNumber! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('receipt')) {
        result.receipt = overrides && overrides.hasOwnProperty('receipt') ? aWixReceiptsV1Receipt(overrides.receipt ?? {}, pickedFields.get('receipt')) : aWixReceiptsV1Receipt({}, pickedFields.get('receipt'));
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'saepe';
    }

    return result;
};

export const aComWixEcomOrdersV1WixReceiptInput = <T extends Partial<ComWixEcomOrdersV1WixReceiptInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayNumber')) {
        result.displayNumber = overrides && overrides.hasOwnProperty('displayNumber') ? overrides.displayNumber! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'ad';
    }

    return result;
};

export const aComWixEcomTaxApiAutoTaxFallbackCalculationDetails = <T extends Partial<ComWixEcomTaxApiAutoTaxFallbackCalculationDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiApplicationError(overrides.error ?? {}, pickedFields.get('error')) : aWixApiApplicationError({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fallbackReason')) {
        result.fallbackReason = overrides && overrides.hasOwnProperty('fallbackReason') ? overrides.fallbackReason! : ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason.AutoTaxDeactivated;
    }

    return result;
};

export const aComWixEcomTaxApiAutoTaxFallbackCalculationDetailsInput = <T extends Partial<ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiApplicationErrorInput(overrides.error ?? {}, pickedFields.get('error')) : aWixApiApplicationErrorInput({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fallbackReason')) {
        result.fallbackReason = overrides && overrides.hasOwnProperty('fallbackReason') ? overrides.fallbackReason! : ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason.AutoTaxDeactivated;
    }

    return result;
};

export const aComWixEcomTaxApiItemTaxFullDetails = <T extends Partial<ComWixEcomTaxApiItemTaxFullDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxRate')) {
        result.taxRate = overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiPrice(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('taxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalTax ?? {}, pickedFields.get('totalTax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalTax'));
    }

    return result;
};

export const aComWixEcomTaxApiItemTaxFullDetailsInput = <T extends Partial<ComWixEcomTaxApiItemTaxFullDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxRate')) {
        result.taxRate = overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('taxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalTax ?? {}, pickedFields.get('totalTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalTax'));
    }

    return result;
};

export const aComWixEcomTaxApiTaxCalculationDetails = <T extends Partial<ComWixEcomTaxApiTaxCalculationDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoTaxFallbackDetails')) {
        result.autoTaxFallbackDetails = overrides && overrides.hasOwnProperty('autoTaxFallbackDetails') ? aComWixEcomTaxApiAutoTaxFallbackCalculationDetails(overrides.autoTaxFallbackDetails ?? {}, pickedFields.get('autoTaxFallbackDetails')) : aComWixEcomTaxApiAutoTaxFallbackCalculationDetails({}, pickedFields.get('autoTaxFallbackDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('manualRateReason')) {
        result.manualRateReason = overrides && overrides.hasOwnProperty('manualRateReason') ? overrides.manualRateReason! : ComWixEcomTaxApiManualCalculationReason.GlobalSettingToManual;
    }
    if (pickedFields.size === 0 || pickedFields.has('rateType')) {
        result.rateType = overrides && overrides.hasOwnProperty('rateType') ? overrides.rateType! : ComWixEcomTaxApiRateType.AutoRate;
    }

    return result;
};

export const aComWixEcomTaxApiTaxCalculationDetailsInput = <T extends Partial<ComWixEcomTaxApiTaxCalculationDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoTaxFallbackDetails')) {
        result.autoTaxFallbackDetails = overrides && overrides.hasOwnProperty('autoTaxFallbackDetails') ? aComWixEcomTaxApiAutoTaxFallbackCalculationDetailsInput(overrides.autoTaxFallbackDetails ?? {}, pickedFields.get('autoTaxFallbackDetails')) : aComWixEcomTaxApiAutoTaxFallbackCalculationDetailsInput({}, pickedFields.get('autoTaxFallbackDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('manualRateReason')) {
        result.manualRateReason = overrides && overrides.hasOwnProperty('manualRateReason') ? overrides.manualRateReason! : ComWixEcomTaxApiManualCalculationReason.GlobalSettingToManual;
    }
    if (pickedFields.size === 0 || pickedFields.has('rateType')) {
        result.rateType = overrides && overrides.hasOwnProperty('rateType') ? overrides.rateType! : ComWixEcomTaxApiRateType.AutoRate;
    }

    return result;
};

export const aComWixEcomTaxApiTaxSummary = <T extends Partial<ComWixEcomTaxApiTaxSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('manualTaxRate')) {
        result.manualTaxRate = overrides && overrides.hasOwnProperty('manualTaxRate') ? overrides.manualTaxRate! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? aComWixEcommercePlatformCommonApiPrice(overrides.totalTax ?? {}, pickedFields.get('totalTax')) : aComWixEcommercePlatformCommonApiPrice({}, pickedFields.get('totalTax'));
    }

    return result;
};

export const aComWixEcomTaxApiTaxSummaryInput = <T extends Partial<ComWixEcomTaxApiTaxSummaryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('manualTaxRate')) {
        result.manualTaxRate = overrides && overrides.hasOwnProperty('manualTaxRate') ? overrides.manualTaxRate! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? aComWixEcommercePlatformCommonApiPriceInput(overrides.totalTax ?? {}, pickedFields.get('totalTax')) : aComWixEcommercePlatformCommonApiPriceInput({}, pickedFields.get('totalTax'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1AdditionalFee = <T extends Partial<ComWixEcomTotalsCalculatorV1AdditionalFee>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['sit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceAfterTax')) {
        result.priceAfterTax = overrides && overrides.hasOwnProperty('priceAfterTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.priceAfterTax ?? {}, pickedFields.get('priceAfterTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('priceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeTax')) {
        result.priceBeforeTax = overrides && overrides.hasOwnProperty('priceBeforeTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.priceBeforeTax ?? {}, pickedFields.get('priceBeforeTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('priceBeforeTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerAppId')) {
        result.providerAppId = overrides && overrides.hasOwnProperty('providerAppId') ? overrides.providerAppId! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource.Item;
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionCycles')) {
        result.subscriptionCycles = overrides && overrides.hasOwnProperty('subscriptionCycles') ? overrides.subscriptionCycles! : 6795;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxDetails')) {
        result.taxDetails = overrides && overrides.hasOwnProperty('taxDetails') ? aComWixEcomTotalsCalculatorV1ItemTaxFullDetails(overrides.taxDetails ?? {}, pickedFields.get('taxDetails')) : aComWixEcomTotalsCalculatorV1ItemTaxFullDetails({}, pickedFields.get('taxDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('translatedName')) {
        result.translatedName = overrides && overrides.hasOwnProperty('translatedName') ? overrides.translatedName! : 'nisi';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1AdditionalFeeInput = <T extends Partial<ComWixEcomTotalsCalculatorV1AdditionalFeeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['qui'];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceAfterTax')) {
        result.priceAfterTax = overrides && overrides.hasOwnProperty('priceAfterTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.priceAfterTax ?? {}, pickedFields.get('priceAfterTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('priceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeTax')) {
        result.priceBeforeTax = overrides && overrides.hasOwnProperty('priceBeforeTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.priceBeforeTax ?? {}, pickedFields.get('priceBeforeTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('priceBeforeTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerAppId')) {
        result.providerAppId = overrides && overrides.hasOwnProperty('providerAppId') ? overrides.providerAppId! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource.Item;
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionCycles')) {
        result.subscriptionCycles = overrides && overrides.hasOwnProperty('subscriptionCycles') ? overrides.subscriptionCycles! : 6208;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxDetails')) {
        result.taxDetails = overrides && overrides.hasOwnProperty('taxDetails') ? aComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput(overrides.taxDetails ?? {}, pickedFields.get('taxDetails')) : aComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput({}, pickedFields.get('taxDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('translatedName')) {
        result.translatedName = overrides && overrides.hasOwnProperty('translatedName') ? overrides.translatedName! : 'expedita';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown = <T extends Partial<ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregatedTaxAmount')) {
        result.aggregatedTaxAmount = overrides && overrides.hasOwnProperty('aggregatedTaxAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.aggregatedTaxAmount ?? {}, pickedFields.get('aggregatedTaxAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('aggregatedTaxAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('aggregatedTaxableAmount')) {
        result.aggregatedTaxableAmount = overrides && overrides.hasOwnProperty('aggregatedTaxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.aggregatedTaxableAmount ?? {}, pickedFields.get('aggregatedTaxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('aggregatedTaxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdiction')) {
        result.jurisdiction = overrides && overrides.hasOwnProperty('jurisdiction') ? overrides.jurisdiction! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdictionTypeEnum')) {
        result.jurisdictionTypeEnum = overrides && overrides.hasOwnProperty('jurisdictionTypeEnum') ? overrides.jurisdictionTypeEnum! : ComWixEcomTotalsCalculatorV1JurisdictionType.City;
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxName')) {
        result.taxName = overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxType')) {
        result.taxType = overrides && overrides.hasOwnProperty('taxType') ? overrides.taxType! : 'dolores';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1AggregatedTaxBreakdownInput = <T extends Partial<ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdownInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregatedTaxAmount')) {
        result.aggregatedTaxAmount = overrides && overrides.hasOwnProperty('aggregatedTaxAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.aggregatedTaxAmount ?? {}, pickedFields.get('aggregatedTaxAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('aggregatedTaxAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('aggregatedTaxableAmount')) {
        result.aggregatedTaxableAmount = overrides && overrides.hasOwnProperty('aggregatedTaxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.aggregatedTaxableAmount ?? {}, pickedFields.get('aggregatedTaxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('aggregatedTaxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdiction')) {
        result.jurisdiction = overrides && overrides.hasOwnProperty('jurisdiction') ? overrides.jurisdiction! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdictionTypeEnum')) {
        result.jurisdictionTypeEnum = overrides && overrides.hasOwnProperty('jurisdictionTypeEnum') ? overrides.jurisdictionTypeEnum! : ComWixEcomTotalsCalculatorV1JurisdictionType.City;
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxName')) {
        result.taxName = overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxType')) {
        result.taxType = overrides && overrides.hasOwnProperty('taxType') ? overrides.taxType! : 'reprehenderit';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1ApplicableLineItems = <T extends Partial<ComWixEcomTotalsCalculatorV1ApplicableLineItems>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['et'];
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1ApplicableLineItemsInput = <T extends Partial<ComWixEcomTotalsCalculatorV1ApplicableLineItemsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['saepe'];
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1AppliedDiscount = <T extends Partial<ComWixEcomTotalsCalculatorV1AppliedDiscount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coupon')) {
        result.coupon = overrides && overrides.hasOwnProperty('coupon') ? aComWixEcomTotalsCalculatorV1Coupon(overrides.coupon ?? {}, pickedFields.get('coupon')) : aComWixEcomTotalsCalculatorV1Coupon({}, pickedFields.get('coupon'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountRule')) {
        result.discountRule = overrides && overrides.hasOwnProperty('discountRule') ? aComWixEcomTotalsCalculatorV1DiscountRule(overrides.discountRule ?? {}, pickedFields.get('discountRule')) : aComWixEcomTotalsCalculatorV1DiscountRule({}, pickedFields.get('discountRule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountType')) {
        result.discountType = overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType.Global;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemDiscounts')) {
        result.lineItemDiscounts = overrides && overrides.hasOwnProperty('lineItemDiscounts') ? overrides.lineItemDiscounts!.map((x) => aComWixEcomTotalsCalculatorV1LineItemDiscount(x ?? {}, pickedFields.get('lineItemDiscounts'))) : [aComWixEcomTotalsCalculatorV1LineItemDiscount({}, pickedFields.get('lineItemDiscounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['inventore'];
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantDiscount')) {
        result.merchantDiscount = overrides && overrides.hasOwnProperty('merchantDiscount') ? aComWixEcomTotalsCalculatorV1MerchantDiscount(overrides.merchantDiscount ?? {}, pickedFields.get('merchantDiscount')) : aComWixEcomTotalsCalculatorV1MerchantDiscount({}, pickedFields.get('merchantDiscount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionCycles')) {
        result.subscriptionCycles = overrides && overrides.hasOwnProperty('subscriptionCycles') ? overrides.subscriptionCycles! : 2557;
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1AppliedDiscountInput = <T extends Partial<ComWixEcomTotalsCalculatorV1AppliedDiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coupon')) {
        result.coupon = overrides && overrides.hasOwnProperty('coupon') ? aComWixEcomTotalsCalculatorV1CouponInput(overrides.coupon ?? {}, pickedFields.get('coupon')) : aComWixEcomTotalsCalculatorV1CouponInput({}, pickedFields.get('coupon'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountRule')) {
        result.discountRule = overrides && overrides.hasOwnProperty('discountRule') ? aComWixEcomTotalsCalculatorV1DiscountRuleInput(overrides.discountRule ?? {}, pickedFields.get('discountRule')) : aComWixEcomTotalsCalculatorV1DiscountRuleInput({}, pickedFields.get('discountRule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountType')) {
        result.discountType = overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType.Global;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemDiscounts')) {
        result.lineItemDiscounts = overrides && overrides.hasOwnProperty('lineItemDiscounts') ? overrides.lineItemDiscounts!.map((x) => aComWixEcomTotalsCalculatorV1LineItemDiscountInput({}, pickedFields.get('lineItemDiscounts'))) : [aComWixEcomTotalsCalculatorV1LineItemDiscountInput({}, pickedFields.get('lineItemDiscounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantDiscount')) {
        result.merchantDiscount = overrides && overrides.hasOwnProperty('merchantDiscount') ? aComWixEcomTotalsCalculatorV1MerchantDiscountInput(overrides.merchantDiscount ?? {}, pickedFields.get('merchantDiscount')) : aComWixEcomTotalsCalculatorV1MerchantDiscountInput({}, pickedFields.get('merchantDiscount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionCycles')) {
        result.subscriptionCycles = overrides && overrides.hasOwnProperty('subscriptionCycles') ? overrides.subscriptionCycles! : 4021;
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1CalculationErrors = <T extends Partial<ComWixEcomTotalsCalculatorV1CalculationErrors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierErrors')) {
        result.carrierErrors = overrides && overrides.hasOwnProperty('carrierErrors') ? aComWixEcomTotalsCalculatorV1CarrierErrors(overrides.carrierErrors ?? {}, pickedFields.get('carrierErrors')) : aComWixEcomTotalsCalculatorV1CarrierErrors({}, pickedFields.get('carrierErrors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('couponCalculationError')) {
        result.couponCalculationError = overrides && overrides.hasOwnProperty('couponCalculationError') ? aWixApiDetails(overrides.couponCalculationError ?? {}, pickedFields.get('couponCalculationError')) : aWixApiDetails({}, pickedFields.get('couponCalculationError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountsCalculationError')) {
        result.discountsCalculationError = overrides && overrides.hasOwnProperty('discountsCalculationError') ? aWixApiDetails(overrides.discountsCalculationError ?? {}, pickedFields.get('discountsCalculationError')) : aWixApiDetails({}, pickedFields.get('discountsCalculationError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('generalShippingCalculationError')) {
        result.generalShippingCalculationError = overrides && overrides.hasOwnProperty('generalShippingCalculationError') ? aWixApiDetails(overrides.generalShippingCalculationError ?? {}, pickedFields.get('generalShippingCalculationError')) : aWixApiDetails({}, pickedFields.get('generalShippingCalculationError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardCalculationError')) {
        result.giftCardCalculationError = overrides && overrides.hasOwnProperty('giftCardCalculationError') ? aWixApiDetails(overrides.giftCardCalculationError ?? {}, pickedFields.get('giftCardCalculationError')) : aWixApiDetails({}, pickedFields.get('giftCardCalculationError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipError')) {
        result.membershipError = overrides && overrides.hasOwnProperty('membershipError') ? aWixApiDetails(overrides.membershipError ?? {}, pickedFields.get('membershipError')) : aWixApiDetails({}, pickedFields.get('membershipError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderValidationErrors')) {
        result.orderValidationErrors = overrides && overrides.hasOwnProperty('orderValidationErrors') ? overrides.orderValidationErrors!.map((x) => aWixApiApplicationError(x ?? {}, pickedFields.get('orderValidationErrors'))) : [aWixApiApplicationError({}, pickedFields.get('orderValidationErrors'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxCalculationError')) {
        result.taxCalculationError = overrides && overrides.hasOwnProperty('taxCalculationError') ? aWixApiDetails(overrides.taxCalculationError ?? {}, pickedFields.get('taxCalculationError')) : aWixApiDetails({}, pickedFields.get('taxCalculationError'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1CalculationErrorsInput = <T extends Partial<ComWixEcomTotalsCalculatorV1CalculationErrorsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierErrors')) {
        result.carrierErrors = overrides && overrides.hasOwnProperty('carrierErrors') ? aComWixEcomTotalsCalculatorV1CarrierErrorsInput(overrides.carrierErrors ?? {}, pickedFields.get('carrierErrors')) : aComWixEcomTotalsCalculatorV1CarrierErrorsInput({}, pickedFields.get('carrierErrors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('couponCalculationError')) {
        result.couponCalculationError = overrides && overrides.hasOwnProperty('couponCalculationError') ? aWixApiDetailsInput(overrides.couponCalculationError ?? {}, pickedFields.get('couponCalculationError')) : aWixApiDetailsInput({}, pickedFields.get('couponCalculationError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountsCalculationError')) {
        result.discountsCalculationError = overrides && overrides.hasOwnProperty('discountsCalculationError') ? aWixApiDetailsInput(overrides.discountsCalculationError ?? {}, pickedFields.get('discountsCalculationError')) : aWixApiDetailsInput({}, pickedFields.get('discountsCalculationError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('generalShippingCalculationError')) {
        result.generalShippingCalculationError = overrides && overrides.hasOwnProperty('generalShippingCalculationError') ? aWixApiDetailsInput(overrides.generalShippingCalculationError ?? {}, pickedFields.get('generalShippingCalculationError')) : aWixApiDetailsInput({}, pickedFields.get('generalShippingCalculationError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardCalculationError')) {
        result.giftCardCalculationError = overrides && overrides.hasOwnProperty('giftCardCalculationError') ? aWixApiDetailsInput(overrides.giftCardCalculationError ?? {}, pickedFields.get('giftCardCalculationError')) : aWixApiDetailsInput({}, pickedFields.get('giftCardCalculationError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipError')) {
        result.membershipError = overrides && overrides.hasOwnProperty('membershipError') ? aWixApiDetailsInput(overrides.membershipError ?? {}, pickedFields.get('membershipError')) : aWixApiDetailsInput({}, pickedFields.get('membershipError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderValidationErrors')) {
        result.orderValidationErrors = overrides && overrides.hasOwnProperty('orderValidationErrors') ? overrides.orderValidationErrors!.map((x) => aWixApiApplicationErrorInput({}, pickedFields.get('orderValidationErrors'))) : [aWixApiApplicationErrorInput({}, pickedFields.get('orderValidationErrors'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxCalculationError')) {
        result.taxCalculationError = overrides && overrides.hasOwnProperty('taxCalculationError') ? aWixApiDetailsInput(overrides.taxCalculationError ?? {}, pickedFields.get('taxCalculationError')) : aWixApiDetailsInput({}, pickedFields.get('taxCalculationError'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1Carrier = <T extends Partial<ComWixEcomTotalsCalculatorV1Carrier>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'a';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1CarrierError = <T extends Partial<ComWixEcomTotalsCalculatorV1CarrierError>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierId')) {
        result.carrierId = overrides && overrides.hasOwnProperty('carrierId') ? overrides.carrierId! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiDetails(overrides.error ?? {}, pickedFields.get('error')) : aWixApiDetails({}, pickedFields.get('error'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1CarrierErrorInput = <T extends Partial<ComWixEcomTotalsCalculatorV1CarrierErrorInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierId')) {
        result.carrierId = overrides && overrides.hasOwnProperty('carrierId') ? overrides.carrierId! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiDetailsInput(overrides.error ?? {}, pickedFields.get('error')) : aWixApiDetailsInput({}, pickedFields.get('error'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1CarrierErrors = <T extends Partial<ComWixEcomTotalsCalculatorV1CarrierErrors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errors')) {
        result.errors = overrides && overrides.hasOwnProperty('errors') ? overrides.errors!.map((x) => aComWixEcomTotalsCalculatorV1CarrierError(x ?? {}, pickedFields.get('errors'))) : [aComWixEcomTotalsCalculatorV1CarrierError({}, pickedFields.get('errors'))];
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1CarrierErrorsInput = <T extends Partial<ComWixEcomTotalsCalculatorV1CarrierErrorsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errors')) {
        result.errors = overrides && overrides.hasOwnProperty('errors') ? overrides.errors!.map((x) => aComWixEcomTotalsCalculatorV1CarrierErrorInput({}, pickedFields.get('errors'))) : [aComWixEcomTotalsCalculatorV1CarrierErrorInput({}, pickedFields.get('errors'))];
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1CarrierInput = <T extends Partial<ComWixEcomTotalsCalculatorV1CarrierInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'omnis';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1CarrierServiceOption = <T extends Partial<ComWixEcomTotalsCalculatorV1CarrierServiceOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierId')) {
        result.carrierId = overrides && overrides.hasOwnProperty('carrierId') ? overrides.carrierId! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingOptions')) {
        result.shippingOptions = overrides && overrides.hasOwnProperty('shippingOptions') ? overrides.shippingOptions!.map((x) => aComWixEcomTotalsCalculatorV1ShippingOption(x ?? {}, pickedFields.get('shippingOptions'))) : [aComWixEcomTotalsCalculatorV1ShippingOption({}, pickedFields.get('shippingOptions'))];
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1CarrierServiceOptionInput = <T extends Partial<ComWixEcomTotalsCalculatorV1CarrierServiceOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierId')) {
        result.carrierId = overrides && overrides.hasOwnProperty('carrierId') ? overrides.carrierId! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingOptions')) {
        result.shippingOptions = overrides && overrides.hasOwnProperty('shippingOptions') ? overrides.shippingOptions!.map((x) => aComWixEcomTotalsCalculatorV1ShippingOptionInput({}, pickedFields.get('shippingOptions'))) : [aComWixEcomTotalsCalculatorV1ShippingOptionInput({}, pickedFields.get('shippingOptions'))];
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1Coupon = <T extends Partial<ComWixEcomTotalsCalculatorV1Coupon>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('couponType')) {
        result.couponType = overrides && overrides.hasOwnProperty('couponType') ? overrides.couponType! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'animi';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1CouponInput = <T extends Partial<ComWixEcomTotalsCalculatorV1CouponInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('couponType')) {
        result.couponType = overrides && overrides.hasOwnProperty('couponType') ? overrides.couponType! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'consequatur';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1DeliveryAllocation = <T extends Partial<ComWixEcomTotalsCalculatorV1DeliveryAllocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('applicableLineItems')) {
        result.applicableLineItems = overrides && overrides.hasOwnProperty('applicableLineItems') ? aComWixEcomTotalsCalculatorV1ApplicableLineItems(overrides.applicableLineItems ?? {}, pickedFields.get('applicableLineItems')) : aComWixEcomTotalsCalculatorV1ApplicableLineItems({}, pickedFields.get('applicableLineItems'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryCarrier')) {
        result.deliveryCarrier = overrides && overrides.hasOwnProperty('deliveryCarrier') ? aComWixEcomTotalsCalculatorV1Carrier(overrides.deliveryCarrier ?? {}, pickedFields.get('deliveryCarrier')) : aComWixEcomTotalsCalculatorV1Carrier({}, pickedFields.get('deliveryCarrier'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryRegion')) {
        result.deliveryRegion = overrides && overrides.hasOwnProperty('deliveryRegion') ? aComWixEcomTotalsCalculatorV1Region(overrides.deliveryRegion ?? {}, pickedFields.get('deliveryRegion')) : aComWixEcomTotalsCalculatorV1Region({}, pickedFields.get('deliveryRegion'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1DeliveryAllocationInput = <T extends Partial<ComWixEcomTotalsCalculatorV1DeliveryAllocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('applicableLineItems')) {
        result.applicableLineItems = overrides && overrides.hasOwnProperty('applicableLineItems') ? aComWixEcomTotalsCalculatorV1ApplicableLineItemsInput(overrides.applicableLineItems ?? {}, pickedFields.get('applicableLineItems')) : aComWixEcomTotalsCalculatorV1ApplicableLineItemsInput({}, pickedFields.get('applicableLineItems'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryCarrier')) {
        result.deliveryCarrier = overrides && overrides.hasOwnProperty('deliveryCarrier') ? aComWixEcomTotalsCalculatorV1CarrierInput(overrides.deliveryCarrier ?? {}, pickedFields.get('deliveryCarrier')) : aComWixEcomTotalsCalculatorV1CarrierInput({}, pickedFields.get('deliveryCarrier'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryRegion')) {
        result.deliveryRegion = overrides && overrides.hasOwnProperty('deliveryRegion') ? aComWixEcomTotalsCalculatorV1RegionInput(overrides.deliveryRegion ?? {}, pickedFields.get('deliveryRegion')) : aComWixEcomTotalsCalculatorV1RegionInput({}, pickedFields.get('deliveryRegion'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1DeliveryLogistics = <T extends Partial<ComWixEcomTotalsCalculatorV1DeliveryLogistics>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deliveryTime')) {
        result.deliveryTime = overrides && overrides.hasOwnProperty('deliveryTime') ? overrides.deliveryTime! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryTimeSlot')) {
        result.deliveryTimeSlot = overrides && overrides.hasOwnProperty('deliveryTimeSlot') ? aComWixEcomTotalsCalculatorV1DeliveryTimeSlot(overrides.deliveryTimeSlot ?? {}, pickedFields.get('deliveryTimeSlot')) : aComWixEcomTotalsCalculatorV1DeliveryTimeSlot({}, pickedFields.get('deliveryTimeSlot'));
    }
    if (pickedFields.size === 0 || pickedFields.has('instructions')) {
        result.instructions = overrides && overrides.hasOwnProperty('instructions') ? overrides.instructions! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('pickupDetails')) {
        result.pickupDetails = overrides && overrides.hasOwnProperty('pickupDetails') ? aComWixEcomTotalsCalculatorV1PickupDetails(overrides.pickupDetails ?? {}, pickedFields.get('pickupDetails')) : aComWixEcomTotalsCalculatorV1PickupDetails({}, pickedFields.get('pickupDetails'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1DeliveryLogisticsInput = <T extends Partial<ComWixEcomTotalsCalculatorV1DeliveryLogisticsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deliveryTime')) {
        result.deliveryTime = overrides && overrides.hasOwnProperty('deliveryTime') ? overrides.deliveryTime! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryTimeSlot')) {
        result.deliveryTimeSlot = overrides && overrides.hasOwnProperty('deliveryTimeSlot') ? aComWixEcomTotalsCalculatorV1DeliveryTimeSlotInput(overrides.deliveryTimeSlot ?? {}, pickedFields.get('deliveryTimeSlot')) : aComWixEcomTotalsCalculatorV1DeliveryTimeSlotInput({}, pickedFields.get('deliveryTimeSlot'));
    }
    if (pickedFields.size === 0 || pickedFields.has('instructions')) {
        result.instructions = overrides && overrides.hasOwnProperty('instructions') ? overrides.instructions! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('pickupDetails')) {
        result.pickupDetails = overrides && overrides.hasOwnProperty('pickupDetails') ? aComWixEcomTotalsCalculatorV1PickupDetailsInput(overrides.pickupDetails ?? {}, pickedFields.get('pickupDetails')) : aComWixEcomTotalsCalculatorV1PickupDetailsInput({}, pickedFields.get('pickupDetails'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1DeliveryTimeSlot = <T extends Partial<ComWixEcomTotalsCalculatorV1DeliveryTimeSlot>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 'nulla';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1DeliveryTimeSlotInput = <T extends Partial<ComWixEcomTotalsCalculatorV1DeliveryTimeSlotInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 'sequi';
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 'vel';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1DiscountRule = <T extends Partial<ComWixEcomTotalsCalculatorV1DiscountRule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discountRule')) {
        result.discountRule = overrides && overrides.hasOwnProperty('discountRule') ? aComWixEcomDiscountsDiscountRule(overrides.discountRule ?? {}, pickedFields.get('discountRule')) : aComWixEcomDiscountsDiscountRule({}, pickedFields.get('discountRule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomTotalsCalculatorV1DiscountRuleName(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomTotalsCalculatorV1DiscountRuleName({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1DiscountRuleInput = <T extends Partial<ComWixEcomTotalsCalculatorV1DiscountRuleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcomTotalsCalculatorV1DiscountRuleNameInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcomTotalsCalculatorV1DiscountRuleNameInput({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1DiscountRuleName = <T extends Partial<ComWixEcomTotalsCalculatorV1DiscountRuleName>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'accusantium';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1DiscountRuleNameInput = <T extends Partial<ComWixEcomTotalsCalculatorV1DiscountRuleNameInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'sint';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1GiftCard = <T extends Partial<ComWixEcomTotalsCalculatorV1GiftCard>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('obfuscatedCode')) {
        result.obfuscatedCode = overrides && overrides.hasOwnProperty('obfuscatedCode') ? overrides.obfuscatedCode! : 'quae';
    }
    if (pickedFields.size === 0 || pickedFields.has('requestedAmount')) {
        result.requestedAmount = overrides && overrides.hasOwnProperty('requestedAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.requestedAmount ?? {}, pickedFields.get('requestedAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('requestedAmount'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1GiftCardInput = <T extends Partial<ComWixEcomTotalsCalculatorV1GiftCardInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('obfuscatedCode')) {
        result.obfuscatedCode = overrides && overrides.hasOwnProperty('obfuscatedCode') ? overrides.obfuscatedCode! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('requestedAmount')) {
        result.requestedAmount = overrides && overrides.hasOwnProperty('requestedAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.requestedAmount ?? {}, pickedFields.get('requestedAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('requestedAmount'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1ItemTaxFullDetails = <T extends Partial<ComWixEcomTotalsCalculatorV1ItemTaxFullDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('calculatorName')) {
        result.calculatorName = overrides && overrides.hasOwnProperty('calculatorName') ? overrides.calculatorName! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('exemptAmount')) {
        result.exemptAmount = overrides && overrides.hasOwnProperty('exemptAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.exemptAmount ?? {}, pickedFields.get('exemptAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('exemptAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('isItemTaxable')) {
        result.isItemTaxable = overrides && overrides.hasOwnProperty('isItemTaxable') ? overrides.isItemTaxable! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('isTaxIncluded')) {
        result.isTaxIncluded = overrides && overrides.hasOwnProperty('isTaxIncluded') ? overrides.isTaxIncluded! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('rateBreakdown')) {
        result.rateBreakdown = overrides && overrides.hasOwnProperty('rateBreakdown') ? overrides.rateBreakdown!.map((x) => aComWixEcomTotalsCalculatorV1TaxRateBreakdown(x ?? {}, pickedFields.get('rateBreakdown'))) : [aComWixEcomTotalsCalculatorV1TaxRateBreakdown({}, pickedFields.get('rateBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aComWixEcomTotalsCalculatorV1TaxBreakdown(x ?? {}, pickedFields.get('taxBreakdown'))) : [aComWixEcomTotalsCalculatorV1TaxBreakdown({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxRate')) {
        result.taxRate = overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('taxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.totalTax ?? {}, pickedFields.get('totalTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('totalTax'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput = <T extends Partial<ComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('calculatorName')) {
        result.calculatorName = overrides && overrides.hasOwnProperty('calculatorName') ? overrides.calculatorName! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('exemptAmount')) {
        result.exemptAmount = overrides && overrides.hasOwnProperty('exemptAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.exemptAmount ?? {}, pickedFields.get('exemptAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('exemptAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('isItemTaxable')) {
        result.isItemTaxable = overrides && overrides.hasOwnProperty('isItemTaxable') ? overrides.isItemTaxable! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('isTaxIncluded')) {
        result.isTaxIncluded = overrides && overrides.hasOwnProperty('isTaxIncluded') ? overrides.isTaxIncluded! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('rateBreakdown')) {
        result.rateBreakdown = overrides && overrides.hasOwnProperty('rateBreakdown') ? overrides.rateBreakdown!.map((x) => aComWixEcomTotalsCalculatorV1TaxRateBreakdownInput({}, pickedFields.get('rateBreakdown'))) : [aComWixEcomTotalsCalculatorV1TaxRateBreakdownInput({}, pickedFields.get('rateBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aComWixEcomTotalsCalculatorV1TaxBreakdownInput({}, pickedFields.get('taxBreakdown'))) : [aComWixEcomTotalsCalculatorV1TaxBreakdownInput({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxRate')) {
        result.taxRate = overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('taxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.totalTax ?? {}, pickedFields.get('totalTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('totalTax'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1LineItemDiscount = <T extends Partial<ComWixEcomTotalsCalculatorV1LineItemDiscount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalDiscountAmount')) {
        result.totalDiscountAmount = overrides && overrides.hasOwnProperty('totalDiscountAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.totalDiscountAmount ?? {}, pickedFields.get('totalDiscountAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('totalDiscountAmount'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1LineItemDiscountInput = <T extends Partial<ComWixEcomTotalsCalculatorV1LineItemDiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalDiscountAmount')) {
        result.totalDiscountAmount = overrides && overrides.hasOwnProperty('totalDiscountAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.totalDiscountAmount ?? {}, pickedFields.get('totalDiscountAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('totalDiscountAmount'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1MerchantDiscount = <T extends Partial<ComWixEcomTotalsCalculatorV1MerchantDiscount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 0.84;
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1MerchantDiscountInput = <T extends Partial<ComWixEcomTotalsCalculatorV1MerchantDiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 1.68;
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1MerchantDiscountInputInput = <T extends Partial<ComWixEcomTotalsCalculatorV1MerchantDiscountInputInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['et'];
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1OtherCharge = <T extends Partial<ComWixEcomTotalsCalculatorV1OtherCharge>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcomTotalsCalculatorV1ChargeType.HandlingFee;
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1OtherChargeInput = <T extends Partial<ComWixEcomTotalsCalculatorV1OtherChargeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcomTotalsCalculatorV1ChargeType.HandlingFee;
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1PickupDetails = <T extends Partial<ComWixEcomTotalsCalculatorV1PickupDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixEcommercePlatformCommonApiAddress(overrides.address ?? {}, pickedFields.get('address')) : aComWixEcommercePlatformCommonApiAddress({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocation')) {
        result.businessLocation = overrides && overrides.hasOwnProperty('businessLocation') ? overrides.businessLocation! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('pickupMethod')) {
        result.pickupMethod = overrides && overrides.hasOwnProperty('pickupMethod') ? overrides.pickupMethod! : ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod.PickupPoint;
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1PickupDetailsInput = <T extends Partial<ComWixEcomTotalsCalculatorV1PickupDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixEcommercePlatformCommonApiAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aComWixEcommercePlatformCommonApiAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocation')) {
        result.businessLocation = overrides && overrides.hasOwnProperty('businessLocation') ? overrides.businessLocation! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('pickupMethod')) {
        result.pickupMethod = overrides && overrides.hasOwnProperty('pickupMethod') ? overrides.pickupMethod! : ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod.PickupPoint;
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1PriceSummary = <T extends Partial<ComWixEcomTotalsCalculatorV1PriceSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.additionalFees ?? {}, pickedFields.get('additionalFees')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('additionalFees'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('shipping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1PriceSummaryInput = <T extends Partial<ComWixEcomTotalsCalculatorV1PriceSummaryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.additionalFees ?? {}, pickedFields.get('additionalFees')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('additionalFees'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.shipping ?? {}, pickedFields.get('shipping')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('shipping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.total ?? {}, pickedFields.get('total')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1Region = <T extends Partial<ComWixEcomTotalsCalculatorV1Region>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'blanditiis';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1RegionInput = <T extends Partial<ComWixEcomTotalsCalculatorV1RegionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ea';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption = <T extends Partial<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierId')) {
        result.carrierId = overrides && overrides.hasOwnProperty('carrierId') ? overrides.carrierId! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('cost')) {
        result.cost = overrides && overrides.hasOwnProperty('cost') ? aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices(overrides.cost ?? {}, pickedFields.get('cost')) : aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices({}, pickedFields.get('cost'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryAllocations')) {
        result.deliveryAllocations = overrides && overrides.hasOwnProperty('deliveryAllocations') ? overrides.deliveryAllocations!.map((x) => aComWixEcomTotalsCalculatorV1DeliveryAllocation(x ?? {}, pickedFields.get('deliveryAllocations'))) : [aComWixEcomTotalsCalculatorV1DeliveryAllocation({}, pickedFields.get('deliveryAllocations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('logistics')) {
        result.logistics = overrides && overrides.hasOwnProperty('logistics') ? aComWixEcomTotalsCalculatorV1DeliveryLogistics(overrides.logistics ?? {}, pickedFields.get('logistics')) : aComWixEcomTotalsCalculatorV1DeliveryLogistics({}, pickedFields.get('logistics'));
    }
    if (pickedFields.size === 0 || pickedFields.has('otherCharges')) {
        result.otherCharges = overrides && overrides.hasOwnProperty('otherCharges') ? overrides.otherCharges!.map((x) => aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge(x ?? {}, pickedFields.get('otherCharges'))) : [aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge({}, pickedFields.get('otherCharges'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('partial')) {
        result.partial = overrides && overrides.hasOwnProperty('partial') ? overrides.partial! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('requestedShippingOption')) {
        result.requestedShippingOption = overrides && overrides.hasOwnProperty('requestedShippingOption') ? overrides.requestedShippingOption! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'velit';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionInput = <T extends Partial<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierId')) {
        result.carrierId = overrides && overrides.hasOwnProperty('carrierId') ? overrides.carrierId! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('cost')) {
        result.cost = overrides && overrides.hasOwnProperty('cost') ? aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput(overrides.cost ?? {}, pickedFields.get('cost')) : aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput({}, pickedFields.get('cost'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryAllocations')) {
        result.deliveryAllocations = overrides && overrides.hasOwnProperty('deliveryAllocations') ? overrides.deliveryAllocations!.map((x) => aComWixEcomTotalsCalculatorV1DeliveryAllocationInput({}, pickedFields.get('deliveryAllocations'))) : [aComWixEcomTotalsCalculatorV1DeliveryAllocationInput({}, pickedFields.get('deliveryAllocations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('logistics')) {
        result.logistics = overrides && overrides.hasOwnProperty('logistics') ? aComWixEcomTotalsCalculatorV1DeliveryLogisticsInput(overrides.logistics ?? {}, pickedFields.get('logistics')) : aComWixEcomTotalsCalculatorV1DeliveryLogisticsInput({}, pickedFields.get('logistics'));
    }
    if (pickedFields.size === 0 || pickedFields.has('partial')) {
        result.partial = overrides && overrides.hasOwnProperty('partial') ? overrides.partial! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('requestedShippingOption')) {
        result.requestedShippingOption = overrides && overrides.hasOwnProperty('requestedShippingOption') ? overrides.requestedShippingOption! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'et';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge = <T extends Partial<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cost')) {
        result.cost = overrides && overrides.hasOwnProperty('cost') ? aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices(overrides.cost ?? {}, pickedFields.get('cost')) : aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices({}, pickedFields.get('cost'));
    }
    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcomTotalsCalculatorV1ChargeType.HandlingFee;
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherChargeInput = <T extends Partial<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherChargeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cost')) {
        result.cost = overrides && overrides.hasOwnProperty('cost') ? aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput(overrides.cost ?? {}, pickedFields.get('cost')) : aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput({}, pickedFields.get('cost'));
    }
    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcomTotalsCalculatorV1ChargeType.HandlingFee;
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices = <T extends Partial<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxDetails')) {
        result.taxDetails = overrides && overrides.hasOwnProperty('taxDetails') ? aComWixEcomTotalsCalculatorV1ItemTaxFullDetails(overrides.taxDetails ?? {}, pickedFields.get('taxDetails')) : aComWixEcomTotalsCalculatorV1ItemTaxFullDetails({}, pickedFields.get('taxDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalDiscount')) {
        result.totalDiscount = overrides && overrides.hasOwnProperty('totalDiscount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.totalDiscount ?? {}, pickedFields.get('totalDiscount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('totalDiscount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceAfterTax')) {
        result.totalPriceAfterTax = overrides && overrides.hasOwnProperty('totalPriceAfterTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.totalPriceAfterTax ?? {}, pickedFields.get('totalPriceAfterTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('totalPriceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceBeforeTax')) {
        result.totalPriceBeforeTax = overrides && overrides.hasOwnProperty('totalPriceBeforeTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.totalPriceBeforeTax ?? {}, pickedFields.get('totalPriceBeforeTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('totalPriceBeforeTax'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput = <T extends Partial<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxDetails')) {
        result.taxDetails = overrides && overrides.hasOwnProperty('taxDetails') ? aComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput(overrides.taxDetails ?? {}, pickedFields.get('taxDetails')) : aComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput({}, pickedFields.get('taxDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalDiscount')) {
        result.totalDiscount = overrides && overrides.hasOwnProperty('totalDiscount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.totalDiscount ?? {}, pickedFields.get('totalDiscount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('totalDiscount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceAfterTax')) {
        result.totalPriceAfterTax = overrides && overrides.hasOwnProperty('totalPriceAfterTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.totalPriceAfterTax ?? {}, pickedFields.get('totalPriceAfterTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('totalPriceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceBeforeTax')) {
        result.totalPriceBeforeTax = overrides && overrides.hasOwnProperty('totalPriceBeforeTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.totalPriceBeforeTax ?? {}, pickedFields.get('totalPriceBeforeTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('totalPriceBeforeTax'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1ShippingOption = <T extends Partial<ComWixEcomTotalsCalculatorV1ShippingOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('cost')) {
        result.cost = overrides && overrides.hasOwnProperty('cost') ? aComWixEcomTotalsCalculatorV1ShippingPrice(overrides.cost ?? {}, pickedFields.get('cost')) : aComWixEcomTotalsCalculatorV1ShippingPrice({}, pickedFields.get('cost'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryAllocations')) {
        result.deliveryAllocations = overrides && overrides.hasOwnProperty('deliveryAllocations') ? overrides.deliveryAllocations!.map((x) => aComWixEcomTotalsCalculatorV1DeliveryAllocation(x ?? {}, pickedFields.get('deliveryAllocations'))) : [aComWixEcomTotalsCalculatorV1DeliveryAllocation({}, pickedFields.get('deliveryAllocations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('logistics')) {
        result.logistics = overrides && overrides.hasOwnProperty('logistics') ? aComWixEcomTotalsCalculatorV1DeliveryLogistics(overrides.logistics ?? {}, pickedFields.get('logistics')) : aComWixEcomTotalsCalculatorV1DeliveryLogistics({}, pickedFields.get('logistics'));
    }
    if (pickedFields.size === 0 || pickedFields.has('partial')) {
        result.partial = overrides && overrides.hasOwnProperty('partial') ? overrides.partial! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'nesciunt';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1ShippingOptionInput = <T extends Partial<ComWixEcomTotalsCalculatorV1ShippingOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('cost')) {
        result.cost = overrides && overrides.hasOwnProperty('cost') ? aComWixEcomTotalsCalculatorV1ShippingPriceInput(overrides.cost ?? {}, pickedFields.get('cost')) : aComWixEcomTotalsCalculatorV1ShippingPriceInput({}, pickedFields.get('cost'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryAllocations')) {
        result.deliveryAllocations = overrides && overrides.hasOwnProperty('deliveryAllocations') ? overrides.deliveryAllocations!.map((x) => aComWixEcomTotalsCalculatorV1DeliveryAllocationInput({}, pickedFields.get('deliveryAllocations'))) : [aComWixEcomTotalsCalculatorV1DeliveryAllocationInput({}, pickedFields.get('deliveryAllocations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('logistics')) {
        result.logistics = overrides && overrides.hasOwnProperty('logistics') ? aComWixEcomTotalsCalculatorV1DeliveryLogisticsInput(overrides.logistics ?? {}, pickedFields.get('logistics')) : aComWixEcomTotalsCalculatorV1DeliveryLogisticsInput({}, pickedFields.get('logistics'));
    }
    if (pickedFields.size === 0 || pickedFields.has('partial')) {
        result.partial = overrides && overrides.hasOwnProperty('partial') ? overrides.partial! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'laborum';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1ShippingPrice = <T extends Partial<ComWixEcomTotalsCalculatorV1ShippingPrice>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('otherCharges')) {
        result.otherCharges = overrides && overrides.hasOwnProperty('otherCharges') ? overrides.otherCharges!.map((x) => aComWixEcomTotalsCalculatorV1OtherCharge(x ?? {}, pickedFields.get('otherCharges'))) : [aComWixEcomTotalsCalculatorV1OtherCharge({}, pickedFields.get('otherCharges'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('price'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1ShippingPriceInput = <T extends Partial<ComWixEcomTotalsCalculatorV1ShippingPriceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('otherCharges')) {
        result.otherCharges = overrides && overrides.hasOwnProperty('otherCharges') ? overrides.otherCharges!.map((x) => aComWixEcomTotalsCalculatorV1OtherChargeInput({}, pickedFields.get('otherCharges'))) : [aComWixEcomTotalsCalculatorV1OtherChargeInput({}, pickedFields.get('otherCharges'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('price'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1ShippingRegion = <T extends Partial<ComWixEcomTotalsCalculatorV1ShippingRegion>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'minus';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1ShippingRegionInput = <T extends Partial<ComWixEcomTotalsCalculatorV1ShippingRegionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aliquid';
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1TaxBreakdown = <T extends Partial<ComWixEcomTotalsCalculatorV1TaxBreakdown>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jurisdiction')) {
        result.jurisdiction = overrides && overrides.hasOwnProperty('jurisdiction') ? overrides.jurisdiction! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdictionType')) {
        result.jurisdictionType = overrides && overrides.hasOwnProperty('jurisdictionType') ? overrides.jurisdictionType! : ComWixEcomTotalsCalculatorV1JurisdictionType.City;
    }
    if (pickedFields.size === 0 || pickedFields.has('nonTaxableAmount')) {
        result.nonTaxableAmount = overrides && overrides.hasOwnProperty('nonTaxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.nonTaxableAmount ?? {}, pickedFields.get('nonTaxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('nonTaxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxAmount')) {
        result.taxAmount = overrides && overrides.hasOwnProperty('taxAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.taxAmount ?? {}, pickedFields.get('taxAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('taxAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxName')) {
        result.taxName = overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxType')) {
        result.taxType = overrides && overrides.hasOwnProperty('taxType') ? overrides.taxType! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('taxableAmount'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1TaxBreakdownInput = <T extends Partial<ComWixEcomTotalsCalculatorV1TaxBreakdownInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jurisdiction')) {
        result.jurisdiction = overrides && overrides.hasOwnProperty('jurisdiction') ? overrides.jurisdiction! : 'repellat';
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdictionType')) {
        result.jurisdictionType = overrides && overrides.hasOwnProperty('jurisdictionType') ? overrides.jurisdictionType! : ComWixEcomTotalsCalculatorV1JurisdictionType.City;
    }
    if (pickedFields.size === 0 || pickedFields.has('nonTaxableAmount')) {
        result.nonTaxableAmount = overrides && overrides.hasOwnProperty('nonTaxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.nonTaxableAmount ?? {}, pickedFields.get('nonTaxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('nonTaxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxAmount')) {
        result.taxAmount = overrides && overrides.hasOwnProperty('taxAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.taxAmount ?? {}, pickedFields.get('taxAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('taxAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxName')) {
        result.taxName = overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxType')) {
        result.taxType = overrides && overrides.hasOwnProperty('taxType') ? overrides.taxType! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('taxableAmount'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1TaxRateBreakdown = <T extends Partial<ComWixEcomTotalsCalculatorV1TaxRateBreakdown>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exemptAmount')) {
        result.exemptAmount = overrides && overrides.hasOwnProperty('exemptAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.exemptAmount ?? {}, pickedFields.get('exemptAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('exemptAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('exemptionIds')) {
        result.exemptionIds = overrides && overrides.hasOwnProperty('exemptionIds') ? overrides.exemptionIds! : [9879];
    }
    if (pickedFields.size === 0 || pickedFields.has('isFee')) {
        result.isFee = overrides && overrides.hasOwnProperty('isFee') ? overrides.isFee! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdiction')) {
        result.jurisdiction = overrides && overrides.hasOwnProperty('jurisdiction') ? overrides.jurisdiction! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdictionType')) {
        result.jurisdictionType = overrides && overrides.hasOwnProperty('jurisdictionType') ? overrides.jurisdictionType! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxType')) {
        result.taxType = overrides && overrides.hasOwnProperty('taxType') ? overrides.taxType! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('taxableAmount'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1TaxRateBreakdownInput = <T extends Partial<ComWixEcomTotalsCalculatorV1TaxRateBreakdownInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exemptAmount')) {
        result.exemptAmount = overrides && overrides.hasOwnProperty('exemptAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.exemptAmount ?? {}, pickedFields.get('exemptAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('exemptAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('exemptionIds')) {
        result.exemptionIds = overrides && overrides.hasOwnProperty('exemptionIds') ? overrides.exemptionIds! : [7607];
    }
    if (pickedFields.size === 0 || pickedFields.has('isFee')) {
        result.isFee = overrides && overrides.hasOwnProperty('isFee') ? overrides.isFee! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdiction')) {
        result.jurisdiction = overrides && overrides.hasOwnProperty('jurisdiction') ? overrides.jurisdiction! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('jurisdictionType')) {
        result.jurisdictionType = overrides && overrides.hasOwnProperty('jurisdictionType') ? overrides.jurisdictionType! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.tax ?? {}, pickedFields.get('tax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('tax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxType')) {
        result.taxType = overrides && overrides.hasOwnProperty('taxType') ? overrides.taxType! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('taxableAmount'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1TaxSummary = <T extends Partial<ComWixEcomTotalsCalculatorV1TaxSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregatedTaxBreakdown')) {
        result.aggregatedTaxBreakdown = overrides && overrides.hasOwnProperty('aggregatedTaxBreakdown') ? overrides.aggregatedTaxBreakdown!.map((x) => aComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown(x ?? {}, pickedFields.get('aggregatedTaxBreakdown'))) : [aComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown({}, pickedFields.get('aggregatedTaxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('averageTaxRate')) {
        result.averageTaxRate = overrides && overrides.hasOwnProperty('averageTaxRate') ? overrides.averageTaxRate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('calculationDetails')) {
        result.calculationDetails = overrides && overrides.hasOwnProperty('calculationDetails') ? aComWixEcomTaxApiTaxCalculationDetails(overrides.calculationDetails ?? {}, pickedFields.get('calculationDetails')) : aComWixEcomTaxApiTaxCalculationDetails({}, pickedFields.get('calculationDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('manualTaxRate')) {
        result.manualTaxRate = overrides && overrides.hasOwnProperty('manualTaxRate') ? overrides.manualTaxRate! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxEstimationId')) {
        result.taxEstimationId = overrides && overrides.hasOwnProperty('taxEstimationId') ? overrides.taxEstimationId! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('taxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalExempt')) {
        result.totalExempt = overrides && overrides.hasOwnProperty('totalExempt') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.totalExempt ?? {}, pickedFields.get('totalExempt')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('totalExempt'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.totalTax ?? {}, pickedFields.get('totalTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('totalTax'));
    }

    return result;
};

export const aComWixEcomTotalsCalculatorV1TaxSummaryInput = <T extends Partial<ComWixEcomTotalsCalculatorV1TaxSummaryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregatedTaxBreakdown')) {
        result.aggregatedTaxBreakdown = overrides && overrides.hasOwnProperty('aggregatedTaxBreakdown') ? overrides.aggregatedTaxBreakdown!.map((x) => aComWixEcomTotalsCalculatorV1AggregatedTaxBreakdownInput({}, pickedFields.get('aggregatedTaxBreakdown'))) : [aComWixEcomTotalsCalculatorV1AggregatedTaxBreakdownInput({}, pickedFields.get('aggregatedTaxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('averageTaxRate')) {
        result.averageTaxRate = overrides && overrides.hasOwnProperty('averageTaxRate') ? overrides.averageTaxRate! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('calculationDetails')) {
        result.calculationDetails = overrides && overrides.hasOwnProperty('calculationDetails') ? aComWixEcomTaxApiTaxCalculationDetailsInput(overrides.calculationDetails ?? {}, pickedFields.get('calculationDetails')) : aComWixEcomTaxApiTaxCalculationDetailsInput({}, pickedFields.get('calculationDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('manualTaxRate')) {
        result.manualTaxRate = overrides && overrides.hasOwnProperty('manualTaxRate') ? overrides.manualTaxRate! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxEstimationId')) {
        result.taxEstimationId = overrides && overrides.hasOwnProperty('taxEstimationId') ? overrides.taxEstimationId! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.taxableAmount ?? {}, pickedFields.get('taxableAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('taxableAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalExempt')) {
        result.totalExempt = overrides && overrides.hasOwnProperty('totalExempt') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.totalExempt ?? {}, pickedFields.get('totalExempt')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('totalExempt'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.totalTax ?? {}, pickedFields.get('totalTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('totalTax'));
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1CatalogReference = <T extends Partial<ComWixEcommerceCatalogSpiApiV1CatalogReference>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('catalogItemId')) {
        result.catalogItemId = overrides && overrides.hasOwnProperty('catalogItemId') ? overrides.catalogItemId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options! : 'blanditiis';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('catalogItemId')) {
        result.catalogItemId = overrides && overrides.hasOwnProperty('catalogItemId') ? overrides.catalogItemId! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options! : 'ea';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1Color = <T extends Partial<ComWixEcommerceCatalogSpiApiV1Color>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'quaerat';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1ColorInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1ColorInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'ex';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1Description = <T extends Partial<ComWixEcommerceCatalogSpiApiV1Description>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'at';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'facilis';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1DescriptionInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1DescriptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'impedit';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1DescriptionLine = <T extends Partial<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('color')) {
        result.color = overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('colorInfo')) {
        result.colorInfo = overrides && overrides.hasOwnProperty('colorInfo') ? aComWixEcommerceCatalogSpiApiV1Color(overrides.colorInfo ?? {}, pickedFields.get('colorInfo')) : aComWixEcommerceCatalogSpiApiV1Color({}, pickedFields.get('colorInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineType')) {
        result.lineType = overrides && overrides.hasOwnProperty('lineType') ? overrides.lineType! : ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType.Color;
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierDescriptionLine')) {
        result.modifierDescriptionLine = overrides && overrides.hasOwnProperty('modifierDescriptionLine') ? overrides.modifierDescriptionLine! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommerceCatalogSpiApiV1DescriptionLineName(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommerceCatalogSpiApiV1DescriptionLineName({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('plainText')) {
        result.plainText = overrides && overrides.hasOwnProperty('plainText') ? aComWixEcommerceCatalogSpiApiV1PlainTextValue(overrides.plainText ?? {}, pickedFields.get('plainText')) : aComWixEcommerceCatalogSpiApiV1PlainTextValue({}, pickedFields.get('plainText'));
    }
    if (pickedFields.size === 0 || pickedFields.has('plainTextValue')) {
        result.plainTextValue = overrides && overrides.hasOwnProperty('plainTextValue') ? aComWixEcommerceCatalogSpiApiV1PlainTextValue(overrides.plainTextValue ?? {}, pickedFields.get('plainTextValue')) : aComWixEcommerceCatalogSpiApiV1PlainTextValue({}, pickedFields.get('plainTextValue'));
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1DescriptionLineInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('color')) {
        result.color = overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('colorInfo')) {
        result.colorInfo = overrides && overrides.hasOwnProperty('colorInfo') ? aComWixEcommerceCatalogSpiApiV1ColorInput(overrides.colorInfo ?? {}, pickedFields.get('colorInfo')) : aComWixEcommerceCatalogSpiApiV1ColorInput({}, pickedFields.get('colorInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineType')) {
        result.lineType = overrides && overrides.hasOwnProperty('lineType') ? overrides.lineType! : ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType.Color;
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierDescriptionLine')) {
        result.modifierDescriptionLine = overrides && overrides.hasOwnProperty('modifierDescriptionLine') ? overrides.modifierDescriptionLine! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommerceCatalogSpiApiV1DescriptionLineNameInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommerceCatalogSpiApiV1DescriptionLineNameInput({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('plainText')) {
        result.plainText = overrides && overrides.hasOwnProperty('plainText') ? aComWixEcommerceCatalogSpiApiV1PlainTextValueInput(overrides.plainText ?? {}, pickedFields.get('plainText')) : aComWixEcommerceCatalogSpiApiV1PlainTextValueInput({}, pickedFields.get('plainText'));
    }
    if (pickedFields.size === 0 || pickedFields.has('plainTextValue')) {
        result.plainTextValue = overrides && overrides.hasOwnProperty('plainTextValue') ? aComWixEcommerceCatalogSpiApiV1PlainTextValueInput(overrides.plainTextValue ?? {}, pickedFields.get('plainTextValue')) : aComWixEcommerceCatalogSpiApiV1PlainTextValueInput({}, pickedFields.get('plainTextValue'));
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1DescriptionLineName = <T extends Partial<ComWixEcommerceCatalogSpiApiV1DescriptionLineName>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'aut';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1DescriptionLineNameInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1DescriptionLineNameInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'accusantium';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1FreeTrialPeriod = <T extends Partial<ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : WixPaymentApiPayV2SubscriptionFrequency.Day;
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : 4634;
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1FreeTrialPeriodInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1FreeTrialPeriodInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : WixPaymentApiPayV2SubscriptionFrequency.Day;
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : 5910;
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1ItemModifierInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1ItemModifierInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixEcommercePlatformCommonApiTranslatableStringInput(overrides.details ?? {}, pickedFields.get('details')) : aComWixEcommercePlatformCommonApiTranslatableStringInput({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixEcommercePlatformCommonApiTranslatableStringInput(overrides.label ?? {}, pickedFields.get('label')) : aComWixEcommercePlatformCommonApiTranslatableStringInput({}, pickedFields.get('label'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 5854;
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1ItemType = <T extends Partial<ComWixEcommerceCatalogSpiApiV1ItemType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('preset')) {
        result.preset = overrides && overrides.hasOwnProperty('preset') ? overrides.preset! : ComWixEcommerceCatalogSpiApiV1ItemTypeItemType.Digital;
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1ItemTypeInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1ItemTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('preset')) {
        result.preset = overrides && overrides.hasOwnProperty('preset') ? overrides.preset! : ComWixEcommerceCatalogSpiApiV1ItemTypeItemType.Digital;
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1ModifierGroupInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1ModifierGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiers')) {
        result.modifiers = overrides && overrides.hasOwnProperty('modifiers') ? overrides.modifiers!.map((x) => aComWixEcommerceCatalogSpiApiV1ItemModifierInput({}, pickedFields.get('modifiers'))) : [aComWixEcommerceCatalogSpiApiV1ItemModifierInput({}, pickedFields.get('modifiers'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixEcommercePlatformCommonApiTranslatableStringInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixEcommercePlatformCommonApiTranslatableStringInput({}, pickedFields.get('name'));
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1NumericPropertyRange = <T extends Partial<ComWixEcommerceCatalogSpiApiV1NumericPropertyRange>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxValue')) {
        result.maxValue = overrides && overrides.hasOwnProperty('maxValue') ? overrides.maxValue! : 3.51;
    }
    if (pickedFields.size === 0 || pickedFields.has('minValue')) {
        result.minValue = overrides && overrides.hasOwnProperty('minValue') ? overrides.minValue! : 4.63;
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxValue')) {
        result.maxValue = overrides && overrides.hasOwnProperty('maxValue') ? overrides.maxValue! : 0.56;
    }
    if (pickedFields.size === 0 || pickedFields.has('minValue')) {
        result.minValue = overrides && overrides.hasOwnProperty('minValue') ? overrides.minValue! : 4.16;
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1PhysicalProperties = <T extends Partial<ComWixEcommerceCatalogSpiApiV1PhysicalProperties>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('shippable')) {
        result.shippable = overrides && overrides.hasOwnProperty('shippable') ? overrides.shippable! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('sku')) {
        result.sku = overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 7.24;
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('shippable')) {
        result.shippable = overrides && overrides.hasOwnProperty('shippable') ? overrides.shippable! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('sku')) {
        result.sku = overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 6.77;
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1PlainTextValue = <T extends Partial<ComWixEcommerceCatalogSpiApiV1PlainTextValue>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'facere';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1PlainTextValueInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1PlainTextValueInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'molestiae';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1Policy = <T extends Partial<ComWixEcommerceCatalogSpiApiV1Policy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('content')) {
        result.content = overrides && overrides.hasOwnProperty('content') ? overrides.content! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'et';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1PolicyInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1PolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('content')) {
        result.content = overrides && overrides.hasOwnProperty('content') ? overrides.content! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'nam';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1PriceDescription = <T extends Partial<ComWixEcommerceCatalogSpiApiV1PriceDescription>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'ea';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1PriceDescriptionInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'qui';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1ProductName = <T extends Partial<ComWixEcommerceCatalogSpiApiV1ProductName>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'tempore';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1ProductNameInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1ProductNameInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'qui';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1SecuredMedia = <T extends Partial<ComWixEcommerceCatalogSpiApiV1SecuredMedia>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fileName')) {
        result.fileName = overrides && overrides.hasOwnProperty('fileName') ? overrides.fileName! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('fileType')) {
        result.fileType = overrides && overrides.hasOwnProperty('fileType') ? overrides.fileType! : ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType.SecureArchive;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'facere';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1SecuredMediaInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1SecuredMediaInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fileName')) {
        result.fileName = overrides && overrides.hasOwnProperty('fileName') ? overrides.fileName! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('fileType')) {
        result.fileType = overrides && overrides.hasOwnProperty('fileType') ? overrides.fileType! : ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType.SecureArchive;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ad';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1ServiceProperties = <T extends Partial<ComWixEcommerceCatalogSpiApiV1ServiceProperties>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('numberOfParticipants')) {
        result.numberOfParticipants = overrides && overrides.hasOwnProperty('numberOfParticipants') ? overrides.numberOfParticipants! : 921;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduledDate')) {
        result.scheduledDate = overrides && overrides.hasOwnProperty('scheduledDate') ? overrides.scheduledDate! : 'autem';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1ServicePropertiesInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1ServicePropertiesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('numberOfParticipants')) {
        result.numberOfParticipants = overrides && overrides.hasOwnProperty('numberOfParticipants') ? overrides.numberOfParticipants! : 6564;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduledDate')) {
        result.scheduledDate = overrides && overrides.hasOwnProperty('scheduledDate') ? overrides.scheduledDate! : 'sit';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo = <T extends Partial<ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aComWixEcommerceCatalogSpiApiV1Description(overrides.description ?? {}, pickedFields.get('description')) : aComWixEcommerceCatalogSpiApiV1Description({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionSettings')) {
        result.subscriptionSettings = overrides && overrides.hasOwnProperty('subscriptionSettings') ? aComWixEcommerceCatalogSpiApiV1SubscriptionSettings(overrides.subscriptionSettings ?? {}, pickedFields.get('subscriptionSettings')) : aComWixEcommerceCatalogSpiApiV1SubscriptionSettings({}, pickedFields.get('subscriptionSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? aComWixEcommerceCatalogSpiApiV1Title(overrides.title ?? {}, pickedFields.get('title')) : aComWixEcommerceCatalogSpiApiV1Title({}, pickedFields.get('title'));
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aComWixEcommerceCatalogSpiApiV1DescriptionInput(overrides.description ?? {}, pickedFields.get('description')) : aComWixEcommerceCatalogSpiApiV1DescriptionInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionSettings')) {
        result.subscriptionSettings = overrides && overrides.hasOwnProperty('subscriptionSettings') ? aComWixEcommerceCatalogSpiApiV1SubscriptionSettingsInput(overrides.subscriptionSettings ?? {}, pickedFields.get('subscriptionSettings')) : aComWixEcommerceCatalogSpiApiV1SubscriptionSettingsInput({}, pickedFields.get('subscriptionSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? aComWixEcommerceCatalogSpiApiV1TitleInput(overrides.title ?? {}, pickedFields.get('title')) : aComWixEcommerceCatalogSpiApiV1TitleInput({}, pickedFields.get('title'));
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1SubscriptionSettings = <T extends Partial<ComWixEcommerceCatalogSpiApiV1SubscriptionSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoRenewal')) {
        result.autoRenewal = overrides && overrides.hasOwnProperty('autoRenewal') ? overrides.autoRenewal! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('billingCycles')) {
        result.billingCycles = overrides && overrides.hasOwnProperty('billingCycles') ? overrides.billingCycles! : 9804;
    }
    if (pickedFields.size === 0 || pickedFields.has('enableCustomerCancellation')) {
        result.enableCustomerCancellation = overrides && overrides.hasOwnProperty('enableCustomerCancellation') ? overrides.enableCustomerCancellation! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('freeTrialPeriod')) {
        result.freeTrialPeriod = overrides && overrides.hasOwnProperty('freeTrialPeriod') ? aComWixEcommerceCatalogSpiApiV1FreeTrialPeriod(overrides.freeTrialPeriod ?? {}, pickedFields.get('freeTrialPeriod')) : aComWixEcommerceCatalogSpiApiV1FreeTrialPeriod({}, pickedFields.get('freeTrialPeriod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : WixPaymentApiPayV2SubscriptionFrequency.Day;
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : 6310;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'facere';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1SubscriptionSettingsInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1SubscriptionSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoRenewal')) {
        result.autoRenewal = overrides && overrides.hasOwnProperty('autoRenewal') ? overrides.autoRenewal! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('billingCycles')) {
        result.billingCycles = overrides && overrides.hasOwnProperty('billingCycles') ? overrides.billingCycles! : 5070;
    }
    if (pickedFields.size === 0 || pickedFields.has('enableCustomerCancellation')) {
        result.enableCustomerCancellation = overrides && overrides.hasOwnProperty('enableCustomerCancellation') ? overrides.enableCustomerCancellation! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('freeTrialPeriod')) {
        result.freeTrialPeriod = overrides && overrides.hasOwnProperty('freeTrialPeriod') ? aComWixEcommerceCatalogSpiApiV1FreeTrialPeriodInput(overrides.freeTrialPeriod ?? {}, pickedFields.get('freeTrialPeriod')) : aComWixEcommerceCatalogSpiApiV1FreeTrialPeriodInput({}, pickedFields.get('freeTrialPeriod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : WixPaymentApiPayV2SubscriptionFrequency.Day;
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : 6924;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'ea';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1Title = <T extends Partial<ComWixEcommerceCatalogSpiApiV1Title>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'sint';
    }

    return result;
};

export const aComWixEcommerceCatalogSpiApiV1TitleInput = <T extends Partial<ComWixEcommerceCatalogSpiApiV1TitleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'id';
    }

    return result;
};

export const aComWixEcommerceCommonsApiAddressInput = <T extends Partial<ComWixEcommerceCommonsApiAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine1')) {
        result.addressLine1 = overrides && overrides.hasOwnProperty('addressLine1') ? overrides.addressLine1! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'delectus';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('fullName')) {
        result.fullName = overrides && overrides.hasOwnProperty('fullName') ? aComWixEcommerceCommonsApiFullNameInput(overrides.fullName ?? {}, pickedFields.get('fullName')) : aComWixEcommerceCommonsApiFullNameInput({}, pickedFields.get('fullName'));
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('street')) {
        result.street = overrides && overrides.hasOwnProperty('street') ? aComWixEcommerceCommonsApiStreetInput(overrides.street ?? {}, pickedFields.get('street')) : aComWixEcommerceCommonsApiStreetInput({}, pickedFields.get('street'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('vatId')) {
        result.vatId = overrides && overrides.hasOwnProperty('vatId') ? aComWixEcommerceCommonsApiVatIdInput(overrides.vatId ?? {}, pickedFields.get('vatId')) : aComWixEcommerceCommonsApiVatIdInput({}, pickedFields.get('vatId'));
    }
    if (pickedFields.size === 0 || pickedFields.has('zipCode')) {
        result.zipCode = overrides && overrides.hasOwnProperty('zipCode') ? overrides.zipCode! : 'dolores';
    }

    return result;
};

export const aComWixEcommerceCommonsApiFullNameInput = <T extends Partial<ComWixEcommerceCommonsApiFullNameInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'repudiandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'mollitia';
    }

    return result;
};

export const aComWixEcommerceCommonsApiPlatformCursorPagingInput = <T extends Partial<ComWixEcommerceCommonsApiPlatformCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'expedita';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2568;
    }

    return result;
};

export const aComWixEcommerceCommonsApiPlatformMedia = <T extends Partial<ComWixEcommerceCommonsApiPlatformMedia>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideoV2(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideoV2({}, pickedFields.get('video'));
    }

    return result;
};

export const aComWixEcommerceCommonsApiPlatformPagingInput = <T extends Partial<ComWixEcommerceCommonsApiPlatformPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2194;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 9804;
    }

    return result;
};

export const aComWixEcommerceCommonsApiPlatformPagingMetadata = <T extends Partial<ComWixEcommerceCommonsApiPlatformPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 1409;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 6186;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 3742;
    }

    return result;
};

export const aComWixEcommerceCommonsApiPlatformQueryInput = <T extends Partial<ComWixEcommerceCommonsApiPlatformQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixEcommerceCommonsApiPlatformPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixEcommerceCommonsApiPlatformPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixEcommerceCommonsApiStreetInput = <T extends Partial<ComWixEcommerceCommonsApiStreetInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'quasi';
    }

    return result;
};

export const aComWixEcommerceCommonsApiUnlimitedPlatformCursorPagingInput = <T extends Partial<ComWixEcommerceCommonsApiUnlimitedPlatformCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 763;
    }

    return result;
};

export const aComWixEcommerceCommonsApiUnlimitedPlatformPagingInput = <T extends Partial<ComWixEcommerceCommonsApiUnlimitedPlatformPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 5183;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 1709;
    }

    return result;
};

export const aComWixEcommerceCommonsApiUnlimitedPlatformQueryInput = <T extends Partial<ComWixEcommerceCommonsApiUnlimitedPlatformQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixEcommerceCommonsApiUnlimitedPlatformCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixEcommerceCommonsApiUnlimitedPlatformCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixEcommerceCommonsApiUnlimitedPlatformPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixEcommerceCommonsApiUnlimitedPlatformPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixEcommerceCommonsApiVatIdInput = <T extends Partial<ComWixEcommerceCommonsApiVatIdInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixEcommerceCommonsApiVatType.Cnpj;
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiAddress = <T extends Partial<ComWixEcommercePlatformCommonApiAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'vero';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixCommonAddressLocation(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixCommonAddressLocation({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixCommonStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixCommonStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionFullname')) {
        result.subdivisionFullname = overrides && overrides.hasOwnProperty('subdivisionFullname') ? overrides.subdivisionFullname! : 'ut';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiAddressInput = <T extends Partial<ComWixEcommercePlatformCommonApiAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixCommonAddressLocationInput(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixCommonAddressLocationInput({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixCommonStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixCommonStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionFullname')) {
        result.subdivisionFullname = overrides && overrides.hasOwnProperty('subdivisionFullname') ? overrides.subdivisionFullname! : 'rerum';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiAddressWithContact = <T extends Partial<ComWixEcommercePlatformCommonApiAddressWithContact>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixEcommercePlatformCommonApiAddress(overrides.address ?? {}, pickedFields.get('address')) : aComWixEcommercePlatformCommonApiAddress({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactDetails')) {
        result.contactDetails = overrides && overrides.hasOwnProperty('contactDetails') ? aComWixEcommercePlatformCommonApiFullAddressContactDetails(overrides.contactDetails ?? {}, pickedFields.get('contactDetails')) : aComWixEcommercePlatformCommonApiFullAddressContactDetails({}, pickedFields.get('contactDetails'));
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiAddressWithContactInput = <T extends Partial<ComWixEcommercePlatformCommonApiAddressWithContactInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixEcommercePlatformCommonApiAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aComWixEcommercePlatformCommonApiAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactDetails')) {
        result.contactDetails = overrides && overrides.hasOwnProperty('contactDetails') ? aComWixEcommercePlatformCommonApiFullAddressContactDetailsInput(overrides.contactDetails ?? {}, pickedFields.get('contactDetails')) : aComWixEcommercePlatformCommonApiFullAddressContactDetailsInput({}, pickedFields.get('contactDetails'));
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiDurationInput = <T extends Partial<ComWixEcommercePlatformCommonApiDurationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3078;
    }
    if (pickedFields.size === 0 || pickedFields.has('unit')) {
        result.unit = overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : ComWixEcommercePlatformCommonApiDurationDurationUnit.Days;
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiExternalReference = <T extends Partial<ComWixEcommercePlatformCommonApiExternalReference>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceId')) {
        result.resourceId = overrides && overrides.hasOwnProperty('resourceId') ? overrides.resourceId! : 'architecto';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiExternalReferenceInput = <T extends Partial<ComWixEcommercePlatformCommonApiExternalReferenceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceId')) {
        result.resourceId = overrides && overrides.hasOwnProperty('resourceId') ? overrides.resourceId! : 'adipisci';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiFullAddressContactDetails = <T extends Partial<ComWixEcommercePlatformCommonApiFullAddressContactDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('vatId')) {
        result.vatId = overrides && overrides.hasOwnProperty('vatId') ? aWixCommonVatId(overrides.vatId ?? {}, pickedFields.get('vatId')) : aWixCommonVatId({}, pickedFields.get('vatId'));
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiFullAddressContactDetailsInput = <T extends Partial<ComWixEcommercePlatformCommonApiFullAddressContactDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('vatId')) {
        result.vatId = overrides && overrides.hasOwnProperty('vatId') ? aWixCommonVatIdInput(overrides.vatId ?? {}, pickedFields.get('vatId')) : aWixCommonVatIdInput({}, pickedFields.get('vatId'));
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiLocation = <T extends Partial<ComWixEcommercePlatformCommonApiLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cum';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiLocationAndQuantity = <T extends Partial<ComWixEcommercePlatformCommonApiLocationAndQuantity>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'natus';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 4925;
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiLocationAndQuantityInput = <T extends Partial<ComWixEcommercePlatformCommonApiLocationAndQuantityInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 2136;
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiLocationInput = <T extends Partial<ComWixEcommercePlatformCommonApiLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dignissimos';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiMultiCurrencyPrice = <T extends Partial<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('convertedAmount')) {
        result.convertedAmount = overrides && overrides.hasOwnProperty('convertedAmount') ? overrides.convertedAmount! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAmount')) {
        result.formattedAmount = overrides && overrides.hasOwnProperty('formattedAmount') ? overrides.formattedAmount! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedConvertedAmount')) {
        result.formattedConvertedAmount = overrides && overrides.hasOwnProperty('formattedConvertedAmount') ? overrides.formattedConvertedAmount! : 'quia';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput = <T extends Partial<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('convertedAmount')) {
        result.convertedAmount = overrides && overrides.hasOwnProperty('convertedAmount') ? overrides.convertedAmount! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAmount')) {
        result.formattedAmount = overrides && overrides.hasOwnProperty('formattedAmount') ? overrides.formattedAmount! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedConvertedAmount')) {
        result.formattedConvertedAmount = overrides && overrides.hasOwnProperty('formattedConvertedAmount') ? overrides.formattedConvertedAmount! : 'quo';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiPickupAddress = <T extends Partial<ComWixEcommercePlatformCommonApiPickupAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixCommonAddressLocation(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixCommonAddressLocation({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixCommonStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixCommonStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionFullname')) {
        result.subdivisionFullname = overrides && overrides.hasOwnProperty('subdivisionFullname') ? overrides.subdivisionFullname! : 'officia';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiPickupAddressInput = <T extends Partial<ComWixEcommercePlatformCommonApiPickupAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixCommonAddressLocationInput(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixCommonAddressLocationInput({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixCommonStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixCommonStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionFullname')) {
        result.subdivisionFullname = overrides && overrides.hasOwnProperty('subdivisionFullname') ? overrides.subdivisionFullname! : 'voluptatem';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiPrice = <T extends Partial<ComWixEcommercePlatformCommonApiPrice>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAmount')) {
        result.formattedAmount = overrides && overrides.hasOwnProperty('formattedAmount') ? overrides.formattedAmount! : 'est';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiPriceInput = <T extends Partial<ComWixEcommercePlatformCommonApiPriceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAmount')) {
        result.formattedAmount = overrides && overrides.hasOwnProperty('formattedAmount') ? overrides.formattedAmount! : 'consequuntur';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiTaxableAddress = <T extends Partial<ComWixEcommercePlatformCommonApiTaxableAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressType')) {
        result.addressType = overrides && overrides.hasOwnProperty('addressType') ? overrides.addressType! : ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType.Billing;
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiTaxableAddressInput = <T extends Partial<ComWixEcommercePlatformCommonApiTaxableAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressType')) {
        result.addressType = overrides && overrides.hasOwnProperty('addressType') ? overrides.addressType! : ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType.Billing;
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiTranslatableString = <T extends Partial<ComWixEcommercePlatformCommonApiTranslatableString>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'impedit';
    }

    return result;
};

export const aComWixEcommercePlatformCommonApiTranslatableStringInput = <T extends Partial<ComWixEcommercePlatformCommonApiTranslatableStringInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('translated')) {
        result.translated = overrides && overrides.hasOwnProperty('translated') ? overrides.translated! : 'quia';
    }

    return result;
};

export const aComWixEcommerceValidationsSpiV1Target = <T extends Partial<ComWixEcommerceValidationsSpiV1Target>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItem')) {
        result.lineItem = overrides && overrides.hasOwnProperty('lineItem') ? aComWixEcommerceValidationsSpiV1TargetLineItem(overrides.lineItem ?? {}, pickedFields.get('lineItem')) : aComWixEcommerceValidationsSpiV1TargetLineItem({}, pickedFields.get('lineItem'));
    }
    if (pickedFields.size === 0 || pickedFields.has('other')) {
        result.other = overrides && overrides.hasOwnProperty('other') ? aComWixEcommerceValidationsSpiV1TargetOther(overrides.other ?? {}, pickedFields.get('other')) : aComWixEcommerceValidationsSpiV1TargetOther({}, pickedFields.get('other'));
    }

    return result;
};

export const aComWixEcommerceValidationsSpiV1TargetInput = <T extends Partial<ComWixEcommerceValidationsSpiV1TargetInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItem')) {
        result.lineItem = overrides && overrides.hasOwnProperty('lineItem') ? aComWixEcommerceValidationsSpiV1TargetLineItemInput(overrides.lineItem ?? {}, pickedFields.get('lineItem')) : aComWixEcommerceValidationsSpiV1TargetLineItemInput({}, pickedFields.get('lineItem'));
    }
    if (pickedFields.size === 0 || pickedFields.has('other')) {
        result.other = overrides && overrides.hasOwnProperty('other') ? aComWixEcommerceValidationsSpiV1TargetOtherInput(overrides.other ?? {}, pickedFields.get('other')) : aComWixEcommerceValidationsSpiV1TargetOtherInput({}, pickedFields.get('other'));
    }

    return result;
};

export const aComWixEcommerceValidationsSpiV1TargetLineItem = <T extends Partial<ComWixEcommerceValidationsSpiV1TargetLineItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : ComWixEcommerceValidationsSpiV1TargetNameInLineItem.LineItemDefault;
    }
    if (pickedFields.size === 0 || pickedFields.has('suggestedFix')) {
        result.suggestedFix = overrides && overrides.hasOwnProperty('suggestedFix') ? overrides.suggestedFix! : ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix.RemoveLineItem;
    }

    return result;
};

export const aComWixEcommerceValidationsSpiV1TargetLineItemInput = <T extends Partial<ComWixEcommerceValidationsSpiV1TargetLineItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : ComWixEcommerceValidationsSpiV1TargetNameInLineItem.LineItemDefault;
    }
    if (pickedFields.size === 0 || pickedFields.has('suggestedFix')) {
        result.suggestedFix = overrides && overrides.hasOwnProperty('suggestedFix') ? overrides.suggestedFix! : ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix.RemoveLineItem;
    }

    return result;
};

export const aComWixEcommerceValidationsSpiV1TargetOther = <T extends Partial<ComWixEcommerceValidationsSpiV1TargetOther>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : ComWixEcommerceValidationsSpiV1TargetNameInOther.Delivery;
    }

    return result;
};

export const aComWixEcommerceValidationsSpiV1TargetOtherInput = <T extends Partial<ComWixEcommerceValidationsSpiV1TargetOtherInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : ComWixEcommerceValidationsSpiV1TargetNameInOther.Delivery;
    }

    return result;
};

export const aComWixEcommerceValidationsSpiV1Violation = <T extends Partial<ComWixEcommerceValidationsSpiV1Violation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('severity')) {
        result.severity = overrides && overrides.hasOwnProperty('severity') ? overrides.severity! : ComWixEcommerceValidationsSpiV1ViolationSeverity.Error;
    }
    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? aComWixEcommerceValidationsSpiV1Target(overrides.target ?? {}, pickedFields.get('target')) : aComWixEcommerceValidationsSpiV1Target({}, pickedFields.get('target'));
    }

    return result;
};

export const aComWixEcommerceValidationsSpiV1ViolationInput = <T extends Partial<ComWixEcommerceValidationsSpiV1ViolationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('severity')) {
        result.severity = overrides && overrides.hasOwnProperty('severity') ? overrides.severity! : ComWixEcommerceValidationsSpiV1ViolationSeverity.Error;
    }
    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? aComWixEcommerceValidationsSpiV1TargetInput(overrides.target ?? {}, pickedFields.get('target')) : aComWixEcommerceValidationsSpiV1TargetInput({}, pickedFields.get('target'));
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonAddress = <T extends Partial<ComWixEventsUpstreamWixCommonAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aComWixEventsUpstreamWixCommonAddressLocation(overrides.geocode ?? {}, pickedFields.get('geocode')) : aComWixEventsUpstreamWixCommonAddressLocation({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aComWixEventsUpstreamWixCommonStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aComWixEventsUpstreamWixCommonStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aComWixEventsUpstreamWixCommonSubdivision(x ?? {}, pickedFields.get('subdivisions'))) : [aComWixEventsUpstreamWixCommonSubdivision({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonAddressInput = <T extends Partial<ComWixEventsUpstreamWixCommonAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aComWixEventsUpstreamWixCommonAddressLocationInput(overrides.geocode ?? {}, pickedFields.get('geocode')) : aComWixEventsUpstreamWixCommonAddressLocationInput({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aComWixEventsUpstreamWixCommonStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aComWixEventsUpstreamWixCommonStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aComWixEventsUpstreamWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))) : [aComWixEventsUpstreamWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonAddressLocation = <T extends Partial<ComWixEventsUpstreamWixCommonAddressLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 2.67;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 2.57;
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonAddressLocationInput = <T extends Partial<ComWixEventsUpstreamWixCommonAddressLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 6.54;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 9.96;
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonImage = <T extends Partial<ComWixEventsUpstreamWixCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 1121;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 1866;
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonImageInput = <T extends Partial<ComWixEventsUpstreamWixCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 5592;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'commodi';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 4323;
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonPagingInput = <T extends Partial<ComWixEventsUpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1124;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 8956;
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonQueryV2Input = <T extends Partial<ComWixEventsUpstreamWixCommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixEventsUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixEventsUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixEventsUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixEventsUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonSortingInput = <T extends Partial<ComWixEventsUpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixCommonSortOrder.Asc;
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonStreetAddress = <T extends Partial<ComWixEventsUpstreamWixCommonStreetAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'quo';
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonStreetAddressInput = <T extends Partial<ComWixEventsUpstreamWixCommonStreetAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'voluptatibus';
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonSubdivision = <T extends Partial<ComWixEventsUpstreamWixCommonSubdivision>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonSubdivisionSubdivisionType.AdministrativeAreaLevel_1;
    }
    if (pickedFields.size === 0 || pickedFields.has('typeInfo')) {
        result.typeInfo = overrides && overrides.hasOwnProperty('typeInfo') ? overrides.typeInfo! : 'soluta';
    }

    return result;
};

export const aComWixEventsUpstreamWixCommonSubdivisionInput = <T extends Partial<ComWixEventsUpstreamWixCommonSubdivisionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonSubdivisionSubdivisionType.AdministrativeAreaLevel_1;
    }
    if (pickedFields.size === 0 || pickedFields.has('typeInfo')) {
        result.typeInfo = overrides && overrides.hasOwnProperty('typeInfo') ? overrides.typeInfo! : 'laborum';
    }

    return result;
};

export const aComWixFormsUpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixFormsUpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3551;
    }

    return result;
};

export const aComWixFormsUpstreamWixCommonCursorPagingMetadata = <T extends Partial<ComWixFormsUpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 8227;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aComWixFormsUpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aComWixFormsUpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }

    return result;
};

export const aComWixFormsUpstreamWixCommonCursorQueryInput = <T extends Partial<ComWixFormsUpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixFormsUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixFormsUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixFormsUpstreamWixCommonCursors = <T extends Partial<ComWixFormsUpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'sunt';
    }

    return result;
};

export const aComWixFormsUpstreamWixCommonImage = <T extends Partial<ComWixFormsUpstreamWixCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 5278;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 5871;
    }

    return result;
};

export const aComWixFormsUpstreamWixCommonImageInput = <T extends Partial<ComWixFormsUpstreamWixCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 7804;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 5155;
    }

    return result;
};

export const aComWixPricingplansBenefitsApiV2BenefitBehaviorDiscountInput = <T extends Partial<ComWixPricingplansBenefitsApiV2BenefitBehaviorDiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('moneyOffAmount')) {
        result.moneyOffAmount = overrides && overrides.hasOwnProperty('moneyOffAmount') ? overrides.moneyOffAmount! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('percentOffRate')) {
        result.percentOffRate = overrides && overrides.hasOwnProperty('percentOffRate') ? overrides.percentOffRate! : 'eligendi';
    }

    return result;
};

export const aComWixPricingplansBenefitsApiV2BenefitBehaviorInput = <T extends Partial<ComWixPricingplansBenefitsApiV2BenefitBehaviorInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('defaultBehavior')) {
        result.defaultBehavior = overrides && overrides.hasOwnProperty('defaultBehavior') ? overrides.defaultBehavior! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixPricingplansBenefitsApiV2BenefitBehaviorDiscountInput(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixPricingplansBenefitsApiV2BenefitBehaviorDiscountInput({}, pickedFields.get('discount'));
    }

    return result;
};

export const aComWixPricingplansBenefitsApiV2BenefitInput = <T extends Partial<ComWixPricingplansBenefitsApiV2BenefitInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appDefId')) {
        result.appDefId = overrides && overrides.hasOwnProperty('appDefId') ? overrides.appDefId! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('behavior')) {
        result.behavior = overrides && overrides.hasOwnProperty('behavior') ? aComWixPricingplansBenefitsApiV2BenefitBehaviorInput(overrides.behavior ?? {}, pickedFields.get('behavior')) : aComWixPricingplansBenefitsApiV2BenefitBehaviorInput({}, pickedFields.get('behavior'));
    }
    if (pickedFields.size === 0 || pickedFields.has('benefitType')) {
        result.benefitType = overrides && overrides.hasOwnProperty('benefitType') ? overrides.benefitType! : ComWixPricingplansBenefitsApiV2BenefitBenefitType.Limited;
    }
    if (pickedFields.size === 0 || pickedFields.has('creditAmount')) {
        result.creditAmount = overrides && overrides.hasOwnProperty('creditAmount') ? overrides.creditAmount! : 6.84;
    }
    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('editable')) {
        result.editable = overrides && overrides.hasOwnProperty('editable') ? overrides.editable! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceIds')) {
        result.resourceIds = overrides && overrides.hasOwnProperty('resourceIds') ? overrides.resourceIds! : ['consectetur'];
    }

    return result;
};

export const aComWixPricingplansBenefitsApiV2BenefitNotificationInput = <T extends Partial<ComWixPricingplansBenefitsApiV2BenefitNotificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appDefId')) {
        result.appDefId = overrides && overrides.hasOwnProperty('appDefId') ? overrides.appDefId! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('benefit')) {
        result.benefit = overrides && overrides.hasOwnProperty('benefit') ? aComWixPricingplansBenefitsApiV2BenefitInput(overrides.benefit ?? {}, pickedFields.get('benefit')) : aComWixPricingplansBenefitsApiV2BenefitInput({}, pickedFields.get('benefit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? overrides.event! : ComWixPricingplansBenefitsApiV2BenefitNotificationEvent.Created;
    }
    if (pickedFields.size === 0 || pickedFields.has('planId')) {
        result.planId = overrides && overrides.hasOwnProperty('planId') ? overrides.planId! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('prevBenefit')) {
        result.prevBenefit = overrides && overrides.hasOwnProperty('prevBenefit') ? aComWixPricingplansBenefitsApiV2BenefitInput(overrides.prevBenefit ?? {}, pickedFields.get('prevBenefit')) : aComWixPricingplansBenefitsApiV2BenefitInput({}, pickedFields.get('prevBenefit'));
    }

    return result;
};

export const aComWixpressAdvancedSeoSeoSchema = <T extends Partial<ComWixpressAdvancedSeoSeoSchema>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('settings')) {
        result.settings = overrides && overrides.hasOwnProperty('settings') ? aComWixpressAdvancedSeoSeoSchemaSettings(overrides.settings ?? {}, pickedFields.get('settings')) : aComWixpressAdvancedSeoSeoSchemaSettings({}, pickedFields.get('settings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags!.map((x) => aComWixpressAdvancedSeoSeoSchemaTag(x ?? {}, pickedFields.get('tags'))) : [aComWixpressAdvancedSeoSeoSchemaTag({}, pickedFields.get('tags'))];
    }

    return result;
};

export const aComWixpressAdvancedSeoSeoSchemaInput = <T extends Partial<ComWixpressAdvancedSeoSeoSchemaInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('settings')) {
        result.settings = overrides && overrides.hasOwnProperty('settings') ? aComWixpressAdvancedSeoSeoSchemaSettingsInput(overrides.settings ?? {}, pickedFields.get('settings')) : aComWixpressAdvancedSeoSeoSchemaSettingsInput({}, pickedFields.get('settings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags!.map((x) => aComWixpressAdvancedSeoSeoSchemaTagInput({}, pickedFields.get('tags'))) : [aComWixpressAdvancedSeoSeoSchemaTagInput({}, pickedFields.get('tags'))];
    }

    return result;
};

export const aComWixpressAdvancedSeoSeoSchemaKeyword = <T extends Partial<ComWixpressAdvancedSeoSeoSchemaKeyword>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('isMain')) {
        result.isMain = overrides && overrides.hasOwnProperty('isMain') ? overrides.isMain! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('origin')) {
        result.origin = overrides && overrides.hasOwnProperty('origin') ? overrides.origin! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('term')) {
        result.term = overrides && overrides.hasOwnProperty('term') ? overrides.term! : 'minus';
    }

    return result;
};

export const aComWixpressAdvancedSeoSeoSchemaKeywordInput = <T extends Partial<ComWixpressAdvancedSeoSeoSchemaKeywordInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('isMain')) {
        result.isMain = overrides && overrides.hasOwnProperty('isMain') ? overrides.isMain! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('origin')) {
        result.origin = overrides && overrides.hasOwnProperty('origin') ? overrides.origin! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('term')) {
        result.term = overrides && overrides.hasOwnProperty('term') ? overrides.term! : 'cum';
    }

    return result;
};

export const aComWixpressAdvancedSeoSeoSchemaSettings = <T extends Partial<ComWixpressAdvancedSeoSeoSchemaSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('keywords')) {
        result.keywords = overrides && overrides.hasOwnProperty('keywords') ? overrides.keywords!.map((x) => aComWixpressAdvancedSeoSeoSchemaKeyword(x ?? {}, pickedFields.get('keywords'))) : [aComWixpressAdvancedSeoSeoSchemaKeyword({}, pickedFields.get('keywords'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('preventAutoRedirect')) {
        result.preventAutoRedirect = overrides && overrides.hasOwnProperty('preventAutoRedirect') ? overrides.preventAutoRedirect! : false;
    }

    return result;
};

export const aComWixpressAdvancedSeoSeoSchemaSettingsInput = <T extends Partial<ComWixpressAdvancedSeoSeoSchemaSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('keywords')) {
        result.keywords = overrides && overrides.hasOwnProperty('keywords') ? overrides.keywords!.map((x) => aComWixpressAdvancedSeoSeoSchemaKeywordInput({}, pickedFields.get('keywords'))) : [aComWixpressAdvancedSeoSeoSchemaKeywordInput({}, pickedFields.get('keywords'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('preventAutoRedirect')) {
        result.preventAutoRedirect = overrides && overrides.hasOwnProperty('preventAutoRedirect') ? overrides.preventAutoRedirect! : false;
    }

    return result;
};

export const aComWixpressAdvancedSeoSeoSchemaTag = <T extends Partial<ComWixpressAdvancedSeoSeoSchemaTag>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('children')) {
        result.children = overrides && overrides.hasOwnProperty('children') ? overrides.children! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('disabled')) {
        result.disabled = overrides && overrides.hasOwnProperty('disabled') ? overrides.disabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('meta')) {
        result.meta = overrides && overrides.hasOwnProperty('meta') ? overrides.meta! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('props')) {
        result.props = overrides && overrides.hasOwnProperty('props') ? overrides.props! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'et';
    }

    return result;
};

export const aComWixpressAdvancedSeoSeoSchemaTagInput = <T extends Partial<ComWixpressAdvancedSeoSeoSchemaTagInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('children')) {
        result.children = overrides && overrides.hasOwnProperty('children') ? overrides.children! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('disabled')) {
        result.disabled = overrides && overrides.hasOwnProperty('disabled') ? overrides.disabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('meta')) {
        result.meta = overrides && overrides.hasOwnProperty('meta') ? overrides.meta! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('props')) {
        result.props = overrides && overrides.hasOwnProperty('props') ? overrides.props! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'perferendis';
    }

    return result;
};

export const aComWixpressAuthorizationAbacManagementEventsPolicyRemovedFromContributorInput = <T extends Partial<ComWixpressAuthorizationAbacManagementEventsPolicyRemovedFromContributorInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accountId')) {
        result.accountId = overrides && overrides.hasOwnProperty('accountId') ? overrides.accountId! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('policyIds')) {
        result.policyIds = overrides && overrides.hasOwnProperty('policyIds') ? overrides.policyIds! : ['quidem'];
    }

    return result;
};

export const aComWixpressAuthorizationAbacManagementEventsPolicyUpdatedForContributorInput = <T extends Partial<ComWixpressAuthorizationAbacManagementEventsPolicyUpdatedForContributorInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accountId')) {
        result.accountId = overrides && overrides.hasOwnProperty('accountId') ? overrides.accountId! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('newPolicyIds')) {
        result.newPolicyIds = overrides && overrides.hasOwnProperty('newPolicyIds') ? overrides.newPolicyIds! : ['dolor'];
    }
    if (pickedFields.size === 0 || pickedFields.has('oldPolicyIds')) {
        result.oldPolicyIds = overrides && overrides.hasOwnProperty('oldPolicyIds') ? overrides.oldPolicyIds! : ['eum'];
    }

    return result;
};

export const aComWixpressBiOctopusApiV1BiEventInput = <T extends Partial<ComWixpressBiOctopusApiV1BiEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventType')) {
        result.eventType = overrides && overrides.hasOwnProperty('eventType') ? overrides.eventType! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('payload')) {
        result.payload = overrides && overrides.hasOwnProperty('payload') ? overrides.payload! : 'distinctio';
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2Attendance = <T extends Partial<ComWixpressBookingsAttendanceV2Attendance>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingId')) {
        result.bookingId = overrides && overrides.hasOwnProperty('bookingId') ? overrides.bookingId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOfAttendees')) {
        result.numberOfAttendees = overrides && overrides.hasOwnProperty('numberOfAttendees') ? overrides.numberOfAttendees! : 5087;
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionId')) {
        result.sessionId = overrides && overrides.hasOwnProperty('sessionId') ? overrides.sessionId! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressBookingsAttendanceV2AttendanceAttendanceStatus.Attended;
    }
    if (pickedFields.size === 0 || pickedFields.has('statusUpdatedDate')) {
        result.statusUpdatedDate = overrides && overrides.hasOwnProperty('statusUpdatedDate') ? overrides.statusUpdatedDate! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'iste';
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2AttendanceInput = <T extends Partial<ComWixpressBookingsAttendanceV2AttendanceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingId')) {
        result.bookingId = overrides && overrides.hasOwnProperty('bookingId') ? overrides.bookingId! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOfAttendees')) {
        result.numberOfAttendees = overrides && overrides.hasOwnProperty('numberOfAttendees') ? overrides.numberOfAttendees! : 8608;
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionId')) {
        result.sessionId = overrides && overrides.hasOwnProperty('sessionId') ? overrides.sessionId! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressBookingsAttendanceV2AttendanceAttendanceStatus.Attended;
    }
    if (pickedFields.size === 0 || pickedFields.has('statusUpdatedDate')) {
        result.statusUpdatedDate = overrides && overrides.hasOwnProperty('statusUpdatedDate') ? overrides.statusUpdatedDate! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'est';
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2BulkAttendanceResult = <T extends Partial<ComWixpressBookingsAttendanceV2BulkAttendanceResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressBookingsAttendanceV2Attendance(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressBookingsAttendanceV2Attendance({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2BulkSetAttendanceRequestAttendanceDetailsInput = <T extends Partial<ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestAttendanceDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attendance')) {
        result.attendance = overrides && overrides.hasOwnProperty('attendance') ? aComWixpressBookingsAttendanceV2AttendanceInput(overrides.attendance ?? {}, pickedFields.get('attendance')) : aComWixpressBookingsAttendanceV2AttendanceInput({}, pickedFields.get('attendance'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aComWixpressBookingsAttendanceV2ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aComWixpressBookingsAttendanceV2ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2BulkSetAttendanceRequestInput = <T extends Partial<ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attendanceDetails')) {
        result.attendanceDetails = overrides && overrides.hasOwnProperty('attendanceDetails') ? overrides.attendanceDetails!.map((x) => aComWixpressBookingsAttendanceV2BulkSetAttendanceRequestAttendanceDetailsInput({}, pickedFields.get('attendanceDetails'))) : [aComWixpressBookingsAttendanceV2BulkSetAttendanceRequestAttendanceDetailsInput({}, pickedFields.get('attendanceDetails'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : true;
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2BulkSetAttendanceResponse = <T extends Partial<ComWixpressBookingsAttendanceV2BulkSetAttendanceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressBookingsAttendanceV2BulkAttendanceResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressBookingsAttendanceV2BulkAttendanceResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2CountAttendancesRequestInput = <T extends Partial<ComWixpressBookingsAttendanceV2CountAttendancesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'similique';
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2CountAttendancesResponse = <T extends Partial<ComWixpressBookingsAttendanceV2CountAttendancesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 6726;
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2GetAttendanceRequestInput = <T extends Partial<ComWixpressBookingsAttendanceV2GetAttendanceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1a6a6ace-8bdc-476f-82bc-d650259295e8';
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2ParticipantNotificationInput = <T extends Partial<ComWixpressBookingsAttendanceV2ParticipantNotificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('notifyParticipants')) {
        result.notifyParticipants = overrides && overrides.hasOwnProperty('notifyParticipants') ? overrides.notifyParticipants! : false;
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2QueryAttendanceRequestInput = <T extends Partial<ComWixpressBookingsAttendanceV2QueryAttendanceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressBookingsAttendanceV2UpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressBookingsAttendanceV2UpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2QueryAttendanceResponse = <T extends Partial<ComWixpressBookingsAttendanceV2QueryAttendanceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressBookingsAttendanceV2Attendance(x ?? {}, pickedFields.get('items'))) : [aComWixpressBookingsAttendanceV2Attendance({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2SetAttendanceRequestInput = <T extends Partial<ComWixpressBookingsAttendanceV2SetAttendanceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attendance')) {
        result.attendance = overrides && overrides.hasOwnProperty('attendance') ? aComWixpressBookingsAttendanceV2AttendanceInput(overrides.attendance ?? {}, pickedFields.get('attendance')) : aComWixpressBookingsAttendanceV2AttendanceInput({}, pickedFields.get('attendance'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aComWixpressBookingsAttendanceV2ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aComWixpressBookingsAttendanceV2ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2SetAttendanceResponse = <T extends Partial<ComWixpressBookingsAttendanceV2SetAttendanceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attendance')) {
        result.attendance = overrides && overrides.hasOwnProperty('attendance') ? aComWixpressBookingsAttendanceV2Attendance(overrides.attendance ?? {}, pickedFields.get('attendance')) : aComWixpressBookingsAttendanceV2Attendance({}, pickedFields.get('attendance'));
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2UpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixpressBookingsAttendanceV2UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 977;
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2UpstreamWixCommonQueryV2Input = <T extends Partial<ComWixpressBookingsAttendanceV2UpstreamWixCommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressBookingsAttendanceV2UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressBookingsAttendanceV2UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['perferendis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['sed'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'commodi';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixpressBookingsAttendanceV2UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixpressBookingsAttendanceV2UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressBookingsAttendanceV2UpstreamWixCommonSortingInput = <T extends Partial<ComWixpressBookingsAttendanceV2UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : ComWixpressBookingsAttendanceV2UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceRequestInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('batchedResources')) {
        result.batchedResources = overrides && overrides.hasOwnProperty('batchedResources') ? overrides.batchedResources!.map((x) => aComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceRequestInput({}, pickedFields.get('batchedResources'))) : [aComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceRequestInput({}, pickedFields.get('batchedResources'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('resources')) {
        result.resources = overrides && overrides.hasOwnProperty('resources') ? overrides.resources!.map((x) => aComWixpressBookingsResourcesCoreApiV1ResourceResourceInput({}, pickedFields.get('resources'))) : [aComWixpressBookingsResourcesCoreApiV1ResourceResourceInput({}, pickedFields.get('resources'))];
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceResponse = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resources')) {
        result.resources = overrides && overrides.hasOwnProperty('resources') ? overrides.resources!.map((x) => aComWixpressBookingsResourcesCoreApiV1ResourceResource(x ?? {}, pickedFields.get('resources'))) : [aComWixpressBookingsResourcesCoreApiV1ResourceResource({}, pickedFields.get('resources'))];
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceBatchDeleteResourceRequestInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceBatchDeleteResourceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['est'];
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocation = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('locationId')) {
        result.locationId = overrides && overrides.hasOwnProperty('locationId') ? overrides.locationId! : 'corporis';
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocationInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('locationId')) {
        result.locationId = overrides && overrides.hasOwnProperty('locationId') ? overrides.locationId! : 'quia';
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceRequestInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resource')) {
        result.resource = overrides && overrides.hasOwnProperty('resource') ? aComWixpressBookingsResourcesCoreApiV1ResourceResourceInput(overrides.resource ?? {}, pickedFields.get('resource')) : aComWixpressBookingsResourcesCoreApiV1ResourceResourceInput({}, pickedFields.get('resource'));
    }
    if (pickedFields.size === 0 || pickedFields.has('schedules')) {
        result.schedules = overrides && overrides.hasOwnProperty('schedules') ? overrides.schedules!.map((x) => aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('schedules'))) : [aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('schedules'))];
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceResponse = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resource')) {
        result.resource = overrides && overrides.hasOwnProperty('resource') ? aComWixpressBookingsResourcesCoreApiV1ResourceResource(overrides.resource ?? {}, pickedFields.get('resource')) : aComWixpressBookingsResourcesCoreApiV1ResourceResource({}, pickedFields.get('resource'));
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceRequestInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vero';
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceResponse = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceRequestInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('excludeSchedule')) {
        result.excludeSchedule = overrides && overrides.hasOwnProperty('excludeSchedule') ? overrides.excludeSchedule! : false;
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceResponse = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resource')) {
        result.resource = overrides && overrides.hasOwnProperty('resource') ? aComWixpressBookingsResourcesCoreApiV1ResourceResource(overrides.resource ?? {}, pickedFields.get('resource')) : aComWixpressBookingsResourcesCoreApiV1ResourceResource({}, pickedFields.get('resource'));
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserRequestInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resourceId')) {
        result.resourceId = overrides && overrides.hasOwnProperty('resourceId') ? overrides.resourceId! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('userEmail')) {
        result.userEmail = overrides && overrides.hasOwnProperty('userEmail') ? overrides.userEmail! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'eligendi';
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserResponse = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resource')) {
        result.resource = overrides && overrides.hasOwnProperty('resource') ? aComWixpressBookingsResourcesCoreApiV1ResourceResource(overrides.resource ?? {}, pickedFields.get('resource')) : aComWixpressBookingsResourcesCoreApiV1ResourceResource({}, pickedFields.get('resource'));
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceListResourcesRequestInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceListResourcesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixBookingsUpstreamWixCommonQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixBookingsUpstreamWixCommonQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceListResourcesResponse = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceListResourcesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aComWixBookingsCommonApiV1QueryMetaData(overrides.metadata ?? {}, pickedFields.get('metadata')) : aComWixBookingsCommonApiV1QueryMetaData({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resources')) {
        result.resources = overrides && overrides.hasOwnProperty('resources') ? overrides.resources!.map((x) => aComWixpressBookingsResourcesCoreApiV1ResourceResource(x ?? {}, pickedFields.get('resources'))) : [aComWixpressBookingsResourcesCoreApiV1ResourceResource({}, pickedFields.get('resources'))];
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesRequestInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includeResourcesWithGroups')) {
        result.includeResourcesWithGroups = overrides && overrides.hasOwnProperty('includeResourcesWithGroups') ? overrides.includeResourcesWithGroups! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixBookingsUpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aComWixBookingsUpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesResponse = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resources')) {
        result.resources = overrides && overrides.hasOwnProperty('resources') ? overrides.resources!.map((x) => aComWixpressBookingsResourcesCoreApiV1ResourceResource(x ?? {}, pickedFields.get('resources'))) : [aComWixpressBookingsResourcesCoreApiV1ResourceResource({}, pickedFields.get('resources'))];
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceResource = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceResource>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availableInAllLocations')) {
        result.availableInAllLocations = overrides && overrides.hasOwnProperty('availableInAllLocations') ? overrides.availableInAllLocations! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocation')) {
        result.businessLocation = overrides && overrides.hasOwnProperty('businessLocation') ? aComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocation(overrides.businessLocation ?? {}, pickedFields.get('businessLocation')) : aComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocation({}, pickedFields.get('businessLocation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventsSchedule')) {
        result.eventsSchedule = overrides && overrides.hasOwnProperty('eventsSchedule') ? aComWixBookingsSchedulesApiV1Schedule(overrides.eventsSchedule ?? {}, pickedFields.get('eventsSchedule')) : aComWixBookingsSchedulesApiV1Schedule({}, pickedFields.get('eventsSchedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('groupId')) {
        result.groupId = overrides && overrides.hasOwnProperty('groupId') ? overrides.groupId! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('hasWorkingHoursSchedule')) {
        result.hasWorkingHoursSchedule = overrides && overrides.hasOwnProperty('hasWorkingHoursSchedule') ? overrides.hasWorkingHoursSchedule! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('images')) {
        result.images = overrides && overrides.hasOwnProperty('images') ? overrides.images!.map((x) => aWixCommonImage(x ?? {}, pickedFields.get('images'))) : [aWixCommonImage({}, pickedFields.get('images'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleIds')) {
        result.scheduleIds = overrides && overrides.hasOwnProperty('scheduleIds') ? overrides.scheduleIds! : ['iusto'];
    }
    if (pickedFields.size === 0 || pickedFields.has('schedules')) {
        result.schedules = overrides && overrides.hasOwnProperty('schedules') ? overrides.schedules!.map((x) => aComWixBookingsSchedulesApiV1Schedule(x ?? {}, pickedFields.get('schedules'))) : [aComWixBookingsSchedulesApiV1Schedule({}, pickedFields.get('schedules'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressBookingsResourcesCoreApiV1ResourceResourceResourceStatus.Created;
    }
    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['ut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixUserId')) {
        result.wixUserId = overrides && overrides.hasOwnProperty('wixUserId') ? overrides.wixUserId! : 'voluptatem';
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceResourceInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceResourceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availableInAllLocations')) {
        result.availableInAllLocations = overrides && overrides.hasOwnProperty('availableInAllLocations') ? overrides.availableInAllLocations! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocation')) {
        result.businessLocation = overrides && overrides.hasOwnProperty('businessLocation') ? aComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocationInput(overrides.businessLocation ?? {}, pickedFields.get('businessLocation')) : aComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocationInput({}, pickedFields.get('businessLocation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventsSchedule')) {
        result.eventsSchedule = overrides && overrides.hasOwnProperty('eventsSchedule') ? aComWixBookingsSchedulesApiV1ScheduleInput(overrides.eventsSchedule ?? {}, pickedFields.get('eventsSchedule')) : aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('eventsSchedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('groupId')) {
        result.groupId = overrides && overrides.hasOwnProperty('groupId') ? overrides.groupId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('hasWorkingHoursSchedule')) {
        result.hasWorkingHoursSchedule = overrides && overrides.hasOwnProperty('hasWorkingHoursSchedule') ? overrides.hasWorkingHoursSchedule! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('images')) {
        result.images = overrides && overrides.hasOwnProperty('images') ? overrides.images!.map((x) => aWixCommonImageInput({}, pickedFields.get('images'))) : [aWixCommonImageInput({}, pickedFields.get('images'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleIds')) {
        result.scheduleIds = overrides && overrides.hasOwnProperty('scheduleIds') ? overrides.scheduleIds! : ['voluptatem'];
    }
    if (pickedFields.size === 0 || pickedFields.has('schedules')) {
        result.schedules = overrides && overrides.hasOwnProperty('schedules') ? overrides.schedules!.map((x) => aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('schedules'))) : [aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('schedules'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressBookingsResourcesCoreApiV1ResourceResourceResourceStatus.Created;
    }
    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['esse'];
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixUserId')) {
        result.wixUserId = overrides && overrides.hasOwnProperty('wixUserId') ? overrides.wixUserId! : 'aut';
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? overrides.event! : ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationEvent.Created;
    }
    if (pickedFields.size === 0 || pickedFields.has('resource')) {
        result.resource = overrides && overrides.hasOwnProperty('resource') ? aComWixpressBookingsResourcesCoreApiV1ResourceResourceInput(overrides.resource ?? {}, pickedFields.get('resource')) : aComWixpressBookingsResourcesCoreApiV1ResourceResourceInput({}, pickedFields.get('resource'));
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerRequestInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resourceId')) {
        result.resourceId = overrides && overrides.hasOwnProperty('resourceId') ? overrides.resourceId! : 'et';
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerResponse = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resource')) {
        result.resource = overrides && overrides.hasOwnProperty('resource') ? aComWixpressBookingsResourcesCoreApiV1ResourceResource(overrides.resource ?? {}, pickedFields.get('resource')) : aComWixpressBookingsResourcesCoreApiV1ResourceResource({}, pickedFields.get('resource'));
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceRequestInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['ab'];
    }
    if (pickedFields.size === 0 || pickedFields.has('resource')) {
        result.resource = overrides && overrides.hasOwnProperty('resource') ? aComWixpressBookingsResourcesCoreApiV1ResourceResourceInput(overrides.resource ?? {}, pickedFields.get('resource')) : aComWixpressBookingsResourcesCoreApiV1ResourceResourceInput({}, pickedFields.get('resource'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleActions')) {
        result.scheduleActions = overrides && overrides.hasOwnProperty('scheduleActions') ? aComWixBookingsSchedulesApiV1BatchRequestInput(overrides.scheduleActions ?? {}, pickedFields.get('scheduleActions')) : aComWixBookingsSchedulesApiV1BatchRequestInput({}, pickedFields.get('scheduleActions'));
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceResponse = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resource')) {
        result.resource = overrides && overrides.hasOwnProperty('resource') ? aComWixpressBookingsResourcesCoreApiV1ResourceResource(overrides.resource ?? {}, pickedFields.get('resource')) : aComWixpressBookingsResourcesCoreApiV1ResourceResource({}, pickedFields.get('resource'));
    }
    if (pickedFields.size === 0 || pickedFields.has('schedules')) {
        result.schedules = overrides && overrides.hasOwnProperty('schedules') ? aComWixBookingsSchedulesApiV1BatchResponse(overrides.schedules ?? {}, pickedFields.get('schedules')) : aComWixBookingsSchedulesApiV1BatchResponse({}, pickedFields.get('schedules'));
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleRequestInput = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldmask')) {
        result.fieldmask = overrides && overrides.hasOwnProperty('fieldmask') ? overrides.fieldmask! : ['rerum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceId')) {
        result.resourceId = overrides && overrides.hasOwnProperty('resourceId') ? overrides.resourceId! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aComWixBookingsSchedulesApiV1ScheduleInput(overrides.schedule ?? {}, pickedFields.get('schedule')) : aComWixBookingsSchedulesApiV1ScheduleInput({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleResponse = <T extends Partial<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aComWixBookingsSchedulesApiV1Schedule(overrides.schedule ?? {}, pickedFields.get('schedule')) : aComWixBookingsSchedulesApiV1Schedule({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1BookingPolicyInput = <T extends Partial<ComWixpressBookingsServicesApiV1BookingPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookUpToXMinutesBefore')) {
        result.bookUpToXMinutesBefore = overrides && overrides.hasOwnProperty('bookUpToXMinutesBefore') ? overrides.bookUpToXMinutesBefore! : 9715;
    }
    if (pickedFields.size === 0 || pickedFields.has('bookingsApprovalPolicy')) {
        result.bookingsApprovalPolicy = overrides && overrides.hasOwnProperty('bookingsApprovalPolicy') ? aComWixpressBookingsServicesApiV1BookingsApprovalPolicyInput(overrides.bookingsApprovalPolicy ?? {}, pickedFields.get('bookingsApprovalPolicy')) : aComWixpressBookingsServicesApiV1BookingsApprovalPolicyInput({}, pickedFields.get('bookingsApprovalPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cancelRescheduleUpToXMinutesBefore')) {
        result.cancelRescheduleUpToXMinutesBefore = overrides && overrides.hasOwnProperty('cancelRescheduleUpToXMinutesBefore') ? overrides.cancelRescheduleUpToXMinutesBefore! : 1699;
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationPolicy')) {
        result.cancellationPolicy = overrides && overrides.hasOwnProperty('cancellationPolicy') ? overrides.cancellationPolicy! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('futureBookingsPolicy')) {
        result.futureBookingsPolicy = overrides && overrides.hasOwnProperty('futureBookingsPolicy') ? aComWixpressBookingsServicesApiV1FutureBookingPolicyInput(overrides.futureBookingsPolicy ?? {}, pickedFields.get('futureBookingsPolicy')) : aComWixpressBookingsServicesApiV1FutureBookingPolicyInput({}, pickedFields.get('futureBookingsPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('isBookOnlineAllowed')) {
        result.isBookOnlineAllowed = overrides && overrides.hasOwnProperty('isBookOnlineAllowed') ? overrides.isBookOnlineAllowed! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('isCancelAllowed')) {
        result.isCancelAllowed = overrides && overrides.hasOwnProperty('isCancelAllowed') ? overrides.isCancelAllowed! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('isRescheduleAllowed')) {
        result.isRescheduleAllowed = overrides && overrides.hasOwnProperty('isRescheduleAllowed') ? overrides.isRescheduleAllowed! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxParticipantsPerBooking')) {
        result.maxParticipantsPerBooking = overrides && overrides.hasOwnProperty('maxParticipantsPerBooking') ? overrides.maxParticipantsPerBooking! : 6332;
    }
    if (pickedFields.size === 0 || pickedFields.has('overrideBusinessPolicyFields')) {
        result.overrideBusinessPolicyFields = overrides && overrides.hasOwnProperty('overrideBusinessPolicyFields') ? overrides.overrideBusinessPolicyFields! : ['nostrum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('waitingListPolicy')) {
        result.waitingListPolicy = overrides && overrides.hasOwnProperty('waitingListPolicy') ? aComWixpressBookingsServicesApiV1WaitingListPolicyInput(overrides.waitingListPolicy ?? {}, pickedFields.get('waitingListPolicy')) : aComWixpressBookingsServicesApiV1WaitingListPolicyInput({}, pickedFields.get('waitingListPolicy'));
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1BookingsApprovalPolicyInput = <T extends Partial<ComWixpressBookingsServicesApiV1BookingsApprovalPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('isBusinessApprovalRequired')) {
        result.isBusinessApprovalRequired = overrides && overrides.hasOwnProperty('isBusinessApprovalRequired') ? overrides.isBusinessApprovalRequired! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('requestsAffectsAvailability')) {
        result.requestsAffectsAvailability = overrides && overrides.hasOwnProperty('requestsAffectsAvailability') ? overrides.requestsAffectsAvailability! : true;
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1BusinessServicesPolicy = <T extends Partial<ComWixpressBookingsServicesApiV1BusinessServicesPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookUpToXMinutesBefore')) {
        result.bookUpToXMinutesBefore = overrides && overrides.hasOwnProperty('bookUpToXMinutesBefore') ? overrides.bookUpToXMinutesBefore! : 2656;
    }
    if (pickedFields.size === 0 || pickedFields.has('cancelRescheduleUpToXMinutesBefore')) {
        result.cancelRescheduleUpToXMinutesBefore = overrides && overrides.hasOwnProperty('cancelRescheduleUpToXMinutesBefore') ? overrides.cancelRescheduleUpToXMinutesBefore! : 1106;
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationPolicy')) {
        result.cancellationPolicy = overrides && overrides.hasOwnProperty('cancellationPolicy') ? overrides.cancellationPolicy! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('futureBookingsPolicy')) {
        result.futureBookingsPolicy = overrides && overrides.hasOwnProperty('futureBookingsPolicy') ? aComWixpressBookingsServicesApiV1FutureBookingPolicy(overrides.futureBookingsPolicy ?? {}, pickedFields.get('futureBookingsPolicy')) : aComWixpressBookingsServicesApiV1FutureBookingPolicy({}, pickedFields.get('futureBookingsPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('waitingListPolicy')) {
        result.waitingListPolicy = overrides && overrides.hasOwnProperty('waitingListPolicy') ? aComWixpressBookingsServicesApiV1WaitingListPolicy(overrides.waitingListPolicy ?? {}, pickedFields.get('waitingListPolicy')) : aComWixpressBookingsServicesApiV1WaitingListPolicy({}, pickedFields.get('waitingListPolicy'));
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1BusinessServicesPolicyInput = <T extends Partial<ComWixpressBookingsServicesApiV1BusinessServicesPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookUpToXMinutesBefore')) {
        result.bookUpToXMinutesBefore = overrides && overrides.hasOwnProperty('bookUpToXMinutesBefore') ? overrides.bookUpToXMinutesBefore! : 128;
    }
    if (pickedFields.size === 0 || pickedFields.has('cancelRescheduleUpToXMinutesBefore')) {
        result.cancelRescheduleUpToXMinutesBefore = overrides && overrides.hasOwnProperty('cancelRescheduleUpToXMinutesBefore') ? overrides.cancelRescheduleUpToXMinutesBefore! : 752;
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationPolicy')) {
        result.cancellationPolicy = overrides && overrides.hasOwnProperty('cancellationPolicy') ? overrides.cancellationPolicy! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('futureBookingsPolicy')) {
        result.futureBookingsPolicy = overrides && overrides.hasOwnProperty('futureBookingsPolicy') ? aComWixpressBookingsServicesApiV1FutureBookingPolicyInput(overrides.futureBookingsPolicy ?? {}, pickedFields.get('futureBookingsPolicy')) : aComWixpressBookingsServicesApiV1FutureBookingPolicyInput({}, pickedFields.get('futureBookingsPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('waitingListPolicy')) {
        result.waitingListPolicy = overrides && overrides.hasOwnProperty('waitingListPolicy') ? aComWixpressBookingsServicesApiV1WaitingListPolicyInput(overrides.waitingListPolicy ?? {}, pickedFields.get('waitingListPolicy')) : aComWixpressBookingsServicesApiV1WaitingListPolicyInput({}, pickedFields.get('waitingListPolicy'));
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1CategoryInput = <T extends Partial<ComWixpressBookingsServicesApiV1CategoryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customProperties')) {
        result.customProperties = overrides && overrides.hasOwnProperty('customProperties') ? overrides.customProperties! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 2416;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressBookingsServicesApiV1CategoryStatus.Created;
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1CategoryNotificationInput = <T extends Partial<ComWixpressBookingsServicesApiV1CategoryNotificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aComWixpressBookingsServicesApiV1CategoryInput(overrides.category ?? {}, pickedFields.get('category')) : aComWixpressBookingsServicesApiV1CategoryInput({}, pickedFields.get('category'));
    }
    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? overrides.event! : ComWixpressBookingsServicesApiV1CategoryNotificationEvent.Created;
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1DeleteMetadataInput = <T extends Partial<ComWixpressBookingsServicesApiV1DeleteMetadataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aComWixBookingsSchedulesApiV1ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aComWixBookingsSchedulesApiV1ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('preserveFutureSessionsWithParticipants')) {
        result.preserveFutureSessionsWithParticipants = overrides && overrides.hasOwnProperty('preserveFutureSessionsWithParticipants') ? overrides.preserveFutureSessionsWithParticipants! : false;
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1FutureBookingPolicy = <T extends Partial<ComWixpressBookingsServicesApiV1FutureBookingPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limitXMinutesToTheFuture')) {
        result.limitXMinutesToTheFuture = overrides && overrides.hasOwnProperty('limitXMinutesToTheFuture') ? overrides.limitXMinutesToTheFuture! : 7782;
    }
    if (pickedFields.size === 0 || pickedFields.has('shouldLimit')) {
        result.shouldLimit = overrides && overrides.hasOwnProperty('shouldLimit') ? overrides.shouldLimit! : true;
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1FutureBookingPolicyInput = <T extends Partial<ComWixpressBookingsServicesApiV1FutureBookingPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limitXMinutesToTheFuture')) {
        result.limitXMinutesToTheFuture = overrides && overrides.hasOwnProperty('limitXMinutesToTheFuture') ? overrides.limitXMinutesToTheFuture! : 7679;
    }
    if (pickedFields.size === 0 || pickedFields.has('shouldLimit')) {
        result.shouldLimit = overrides && overrides.hasOwnProperty('shouldLimit') ? overrides.shouldLimit! : true;
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1GetPolicyResponse = <T extends Partial<ComWixpressBookingsServicesApiV1GetPolicyResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('policy')) {
        result.policy = overrides && overrides.hasOwnProperty('policy') ? aComWixpressBookingsServicesApiV1BusinessServicesPolicy(overrides.policy ?? {}, pickedFields.get('policy')) : aComWixpressBookingsServicesApiV1BusinessServicesPolicy({}, pickedFields.get('policy'));
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1MediaInput = <T extends Partial<ComWixpressBookingsServicesApiV1MediaInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coverMedia')) {
        result.coverMedia = overrides && overrides.hasOwnProperty('coverMedia') ? aComWixpressBookingsServicesApiV1MediaItemInput(overrides.coverMedia ?? {}, pickedFields.get('coverMedia')) : aComWixpressBookingsServicesApiV1MediaItemInput({}, pickedFields.get('coverMedia'));
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressBookingsServicesApiV1MediaItemInput({}, pickedFields.get('items'))) : [aComWixpressBookingsServicesApiV1MediaItemInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('mainMedia')) {
        result.mainMedia = overrides && overrides.hasOwnProperty('mainMedia') ? aComWixpressBookingsServicesApiV1MediaItemInput(overrides.mainMedia ?? {}, pickedFields.get('mainMedia')) : aComWixpressBookingsServicesApiV1MediaItemInput({}, pickedFields.get('mainMedia'));
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1MediaItemInput = <T extends Partial<ComWixpressBookingsServicesApiV1MediaItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImageInput({}, pickedFields.get('image'));
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1PaymentOptionsInput = <T extends Partial<ComWixpressBookingsServicesApiV1PaymentOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('wixPaidPlan')) {
        result.wixPaidPlan = overrides && overrides.hasOwnProperty('wixPaidPlan') ? overrides.wixPaidPlan! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('wixPayInPerson')) {
        result.wixPayInPerson = overrides && overrides.hasOwnProperty('wixPayInPerson') ? overrides.wixPayInPerson! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('wixPayOnline')) {
        result.wixPayOnline = overrides && overrides.hasOwnProperty('wixPayOnline') ? overrides.wixPayOnline! : false;
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1ServiceInfoInput = <T extends Partial<ComWixpressBookingsServicesApiV1ServiceInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('images')) {
        result.images = overrides && overrides.hasOwnProperty('images') ? overrides.images!.map((x) => aWixCommonImageInput({}, pickedFields.get('images'))) : [aWixCommonImageInput({}, pickedFields.get('images'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aComWixpressBookingsServicesApiV1MediaInput(overrides.media ?? {}, pickedFields.get('media')) : aComWixpressBookingsServicesApiV1MediaInput({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('tagLine')) {
        result.tagLine = overrides && overrides.hasOwnProperty('tagLine') ? overrides.tagLine! : 'sed';
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1ServiceInput = <T extends Partial<ComWixpressBookingsServicesApiV1ServiceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('advancedSeoData')) {
        result.advancedSeoData = overrides && overrides.hasOwnProperty('advancedSeoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.advancedSeoData ?? {}, pickedFields.get('advancedSeoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('advancedSeoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('bookingFormId')) {
        result.bookingFormId = overrides && overrides.hasOwnProperty('bookingFormId') ? overrides.bookingFormId! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('categoryId')) {
        result.categoryId = overrides && overrides.hasOwnProperty('categoryId') ? overrides.categoryId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('customProperties')) {
        result.customProperties = overrides && overrides.hasOwnProperty('customProperties') ? overrides.customProperties! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('includeConferenceOption')) {
        result.includeConferenceOption = overrides && overrides.hasOwnProperty('includeConferenceOption') ? overrides.includeConferenceOption! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('info')) {
        result.info = overrides && overrides.hasOwnProperty('info') ? aComWixpressBookingsServicesApiV1ServiceInfoInput(overrides.info ?? {}, pickedFields.get('info')) : aComWixpressBookingsServicesApiV1ServiceInfoInput({}, pickedFields.get('info'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOptions')) {
        result.paymentOptions = overrides && overrides.hasOwnProperty('paymentOptions') ? aComWixpressBookingsServicesApiV1PaymentOptionsInput(overrides.paymentOptions ?? {}, pickedFields.get('paymentOptions')) : aComWixpressBookingsServicesApiV1PaymentOptionsInput({}, pickedFields.get('paymentOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('policy')) {
        result.policy = overrides && overrides.hasOwnProperty('policy') ? aComWixpressBookingsServicesApiV1BookingPolicyInput(overrides.policy ?? {}, pickedFields.get('policy')) : aComWixpressBookingsServicesApiV1BookingPolicyInput({}, pickedFields.get('policy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleIds')) {
        result.scheduleIds = overrides && overrides.hasOwnProperty('scheduleIds') ? overrides.scheduleIds! : ['aut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 2637;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressBookingsServicesApiV1ServiceStatus.Created;
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1ServiceNotificationInput = <T extends Partial<ComWixpressBookingsServicesApiV1ServiceNotificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deleteMetadata')) {
        result.deleteMetadata = overrides && overrides.hasOwnProperty('deleteMetadata') ? aComWixpressBookingsServicesApiV1DeleteMetadataInput(overrides.deleteMetadata ?? {}, pickedFields.get('deleteMetadata')) : aComWixpressBookingsServicesApiV1DeleteMetadataInput({}, pickedFields.get('deleteMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? overrides.event! : ComWixpressBookingsServicesApiV1ServiceNotificationEvent.Created;
    }
    if (pickedFields.size === 0 || pickedFields.has('policy')) {
        result.policy = overrides && overrides.hasOwnProperty('policy') ? aComWixpressBookingsServicesApiV1BusinessServicesPolicyInput(overrides.policy ?? {}, pickedFields.get('policy')) : aComWixpressBookingsServicesApiV1BusinessServicesPolicyInput({}, pickedFields.get('policy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aComWixpressBookingsServicesApiV1ServiceInput(overrides.service ?? {}, pickedFields.get('service')) : aComWixpressBookingsServicesApiV1ServiceInput({}, pickedFields.get('service'));
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1UpdatePolicyRequestInput = <T extends Partial<ComWixpressBookingsServicesApiV1UpdatePolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('policy')) {
        result.policy = overrides && overrides.hasOwnProperty('policy') ? aComWixpressBookingsServicesApiV1BusinessServicesPolicyInput(overrides.policy ?? {}, pickedFields.get('policy')) : aComWixpressBookingsServicesApiV1BusinessServicesPolicyInput({}, pickedFields.get('policy'));
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1WaitingListPolicy = <T extends Partial<ComWixpressBookingsServicesApiV1WaitingListPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('capacity')) {
        result.capacity = overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 2436;
    }
    if (pickedFields.size === 0 || pickedFields.has('isEnabled')) {
        result.isEnabled = overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeWindowMinutes')) {
        result.timeWindowMinutes = overrides && overrides.hasOwnProperty('timeWindowMinutes') ? overrides.timeWindowMinutes! : 2059;
    }

    return result;
};

export const aComWixpressBookingsServicesApiV1WaitingListPolicyInput = <T extends Partial<ComWixpressBookingsServicesApiV1WaitingListPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('capacity')) {
        result.capacity = overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 7451;
    }
    if (pickedFields.size === 0 || pickedFields.has('isEnabled')) {
        result.isEnabled = overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeWindowMinutes')) {
        result.timeWindowMinutes = overrides && overrides.hasOwnProperty('timeWindowMinutes') ? overrides.timeWindowMinutes! : 4568;
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('groupingFields')) {
        result.groupingFields = overrides && overrides.hasOwnProperty('groupingFields') ? overrides.groupingFields! : ['sit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('operations')) {
        result.operations = overrides && overrides.hasOwnProperty('operations') ? overrides.operations!.map((x) => aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationInput({}, pickedFields.get('operations'))) : [aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationInput({}, pickedFields.get('operations'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationAverageInput = <T extends Partial<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationAverageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemFieldName')) {
        result.itemFieldName = overrides && overrides.hasOwnProperty('itemFieldName') ? overrides.itemFieldName! : 'quas';
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('average')) {
        result.average = overrides && overrides.hasOwnProperty('average') ? aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationAverageInput(overrides.average ?? {}, pickedFields.get('average')) : aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationAverageInput({}, pickedFields.get('average'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemCount')) {
        result.itemCount = overrides && overrides.hasOwnProperty('itemCount') ? overrides.itemCount! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('max')) {
        result.max = overrides && overrides.hasOwnProperty('max') ? aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMaxInput(overrides.max ?? {}, pickedFields.get('max')) : aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMaxInput({}, pickedFields.get('max'));
    }
    if (pickedFields.size === 0 || pickedFields.has('min')) {
        result.min = overrides && overrides.hasOwnProperty('min') ? aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMinInput(overrides.min ?? {}, pickedFields.get('min')) : aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMinInput({}, pickedFields.get('min'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resultFieldName')) {
        result.resultFieldName = overrides && overrides.hasOwnProperty('resultFieldName') ? overrides.resultFieldName! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('sum')) {
        result.sum = overrides && overrides.hasOwnProperty('sum') ? aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationSumInput(overrides.sum ?? {}, pickedFields.get('sum')) : aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationSumInput({}, pickedFields.get('sum'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMaxInput = <T extends Partial<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMaxInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemFieldName')) {
        result.itemFieldName = overrides && overrides.hasOwnProperty('itemFieldName') ? overrides.itemFieldName! : 'quis';
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMinInput = <T extends Partial<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMinInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemFieldName')) {
        result.itemFieldName = overrides && overrides.hasOwnProperty('itemFieldName') ? overrides.itemFieldName! : 'sequi';
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationSumInput = <T extends Partial<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationSumInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemFieldName')) {
        result.itemFieldName = overrides && overrides.hasOwnProperty('itemFieldName') ? overrides.itemFieldName! : 'inventore';
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregateDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataAggregateDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregation')) {
        result.aggregation = overrides && overrides.hasOwnProperty('aggregation') ? aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationInput(overrides.aggregation ?? {}, pickedFields.get('aggregation')) : aComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationInput({}, pickedFields.get('aggregation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('consistentRead')) {
        result.consistentRead = overrides && overrides.hasOwnProperty('consistentRead') ? overrides.consistentRead! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('finalFilter')) {
        result.finalFilter = overrides && overrides.hasOwnProperty('finalFilter') ? overrides.finalFilter! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('initialFilter')) {
        result.initialFilter = overrides && overrides.hasOwnProperty('initialFilter') ? overrides.initialFilter! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnTotalCount')) {
        result.returnTotalCount = overrides && overrides.hasOwnProperty('returnTotalCount') ? overrides.returnTotalCount! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixpressCloudDataApiDataUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixpressCloudDataApiDataUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregateDataItemsResponse = <T extends Partial<ComWixpressCloudDataApiDataAggregateDataItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results! : ['minima'];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorAvgInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorAvgInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorFirstInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorFirstInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('avg')) {
        result.avg = overrides && overrides.hasOwnProperty('avg') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorAvgInput(overrides.avg ?? {}, pickedFields.get('avg')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorAvgInput({}, pickedFields.get('avg'));
    }
    if (pickedFields.size === 0 || pickedFields.has('first')) {
        result.first = overrides && overrides.hasOwnProperty('first') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorFirstInput(overrides.first ?? {}, pickedFields.get('first')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorFirstInput({}, pickedFields.get('first'));
    }
    if (pickedFields.size === 0 || pickedFields.has('last')) {
        result.last = overrides && overrides.hasOwnProperty('last') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorLastInput(overrides.last ?? {}, pickedFields.get('last')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorLastInput({}, pickedFields.get('last'));
    }
    if (pickedFields.size === 0 || pickedFields.has('max')) {
        result.max = overrides && overrides.hasOwnProperty('max') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMaxInput(overrides.max ?? {}, pickedFields.get('max')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMaxInput({}, pickedFields.get('max'));
    }
    if (pickedFields.size === 0 || pickedFields.has('min')) {
        result.min = overrides && overrides.hasOwnProperty('min') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMinInput(overrides.min ?? {}, pickedFields.get('min')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMinInput({}, pickedFields.get('min'));
    }
    if (pickedFields.size === 0 || pickedFields.has('push')) {
        result.push = overrides && overrides.hasOwnProperty('push') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorPushInput(overrides.push ?? {}, pickedFields.get('push')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorPushInput({}, pickedFields.get('push'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resultFieldName')) {
        result.resultFieldName = overrides && overrides.hasOwnProperty('resultFieldName') ? overrides.resultFieldName! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('sum')) {
        result.sum = overrides && overrides.hasOwnProperty('sum') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorSumInput(overrides.sum ?? {}, pickedFields.get('sum')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorSumInput({}, pickedFields.get('sum'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorLastInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorLastInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMaxInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMaxInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMinInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMinInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorPushInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorPushInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorSumInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorSumInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAbsOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAbsOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAddOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAddOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expressions')) {
        result.expressions = overrides && overrides.hasOwnProperty('expressions') ? overrides.expressions!.map((x) => aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expressions'))) : [aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expressions'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionCeilOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionCeilOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionConcatOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionConcatOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expressions')) {
        result.expressions = overrides && overrides.hasOwnProperty('expressions') ? overrides.expressions!.map((x) => aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expressions'))) : [aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expressions'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionDivideOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionDivideOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('firstExpression')) {
        result.firstExpression = overrides && overrides.hasOwnProperty('firstExpression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.firstExpression ?? {}, pickedFields.get('firstExpression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('firstExpression'));
    }
    if (pickedFields.size === 0 || pickedFields.has('secondExpression')) {
        result.secondExpression = overrides && overrides.hasOwnProperty('secondExpression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.secondExpression ?? {}, pickedFields.get('secondExpression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('secondExpression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionFloorOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionFloorOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('abs')) {
        result.abs = overrides && overrides.hasOwnProperty('abs') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAbsOperationInput(overrides.abs ?? {}, pickedFields.get('abs')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAbsOperationInput({}, pickedFields.get('abs'));
    }
    if (pickedFields.size === 0 || pickedFields.has('add')) {
        result.add = overrides && overrides.hasOwnProperty('add') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAddOperationInput(overrides.add ?? {}, pickedFields.get('add')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAddOperationInput({}, pickedFields.get('add'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ceil')) {
        result.ceil = overrides && overrides.hasOwnProperty('ceil') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionCeilOperationInput(overrides.ceil ?? {}, pickedFields.get('ceil')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionCeilOperationInput({}, pickedFields.get('ceil'));
    }
    if (pickedFields.size === 0 || pickedFields.has('concat')) {
        result.concat = overrides && overrides.hasOwnProperty('concat') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionConcatOperationInput(overrides.concat ?? {}, pickedFields.get('concat')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionConcatOperationInput({}, pickedFields.get('concat'));
    }
    if (pickedFields.size === 0 || pickedFields.has('divide')) {
        result.divide = overrides && overrides.hasOwnProperty('divide') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionDivideOperationInput(overrides.divide ?? {}, pickedFields.get('divide')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionDivideOperationInput({}, pickedFields.get('divide'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('floor')) {
        result.floor = overrides && overrides.hasOwnProperty('floor') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionFloorOperationInput(overrides.floor ?? {}, pickedFields.get('floor')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionFloorOperationInput({}, pickedFields.get('floor'));
    }
    if (pickedFields.size === 0 || pickedFields.has('length')) {
        result.length = overrides && overrides.hasOwnProperty('length') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionLengthOperationInput(overrides.length ?? {}, pickedFields.get('length')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionLengthOperationInput({}, pickedFields.get('length'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mod')) {
        result.mod = overrides && overrides.hasOwnProperty('mod') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionModOperationInput(overrides.mod ?? {}, pickedFields.get('mod')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionModOperationInput({}, pickedFields.get('mod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('multiply')) {
        result.multiply = overrides && overrides.hasOwnProperty('multiply') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionMultiplyOperationInput(overrides.multiply ?? {}, pickedFields.get('multiply')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionMultiplyOperationInput({}, pickedFields.get('multiply'));
    }
    if (pickedFields.size === 0 || pickedFields.has('numericValue')) {
        result.numericValue = overrides && overrides.hasOwnProperty('numericValue') ? overrides.numericValue! : 1.2;
    }
    if (pickedFields.size === 0 || pickedFields.has('stringValue')) {
        result.stringValue = overrides && overrides.hasOwnProperty('stringValue') ? overrides.stringValue! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('stringify')) {
        result.stringify = overrides && overrides.hasOwnProperty('stringify') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionStringifyOperationInput(overrides.stringify ?? {}, pickedFields.get('stringify')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionStringifyOperationInput({}, pickedFields.get('stringify'));
    }
    if (pickedFields.size === 0 || pickedFields.has('substring')) {
        result.substring = overrides && overrides.hasOwnProperty('substring') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubstringOperationInput(overrides.substring ?? {}, pickedFields.get('substring')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubstringOperationInput({}, pickedFields.get('substring'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subtract')) {
        result.subtract = overrides && overrides.hasOwnProperty('subtract') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubtractOperationInput(overrides.subtract ?? {}, pickedFields.get('subtract')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubtractOperationInput({}, pickedFields.get('subtract'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sum')) {
        result.sum = overrides && overrides.hasOwnProperty('sum') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSumOperationInput(overrides.sum ?? {}, pickedFields.get('sum')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSumOperationInput({}, pickedFields.get('sum'));
    }
    if (pickedFields.size === 0 || pickedFields.has('toLower')) {
        result.toLower = overrides && overrides.hasOwnProperty('toLower') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToLowerOperationInput(overrides.toLower ?? {}, pickedFields.get('toLower')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToLowerOperationInput({}, pickedFields.get('toLower'));
    }
    if (pickedFields.size === 0 || pickedFields.has('toUpper')) {
        result.toUpper = overrides && overrides.hasOwnProperty('toUpper') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToUpperOperationInput(overrides.toUpper ?? {}, pickedFields.get('toUpper')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToUpperOperationInput({}, pickedFields.get('toUpper'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionLengthOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionLengthOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionModOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionModOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('firstExpression')) {
        result.firstExpression = overrides && overrides.hasOwnProperty('firstExpression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.firstExpression ?? {}, pickedFields.get('firstExpression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('firstExpression'));
    }
    if (pickedFields.size === 0 || pickedFields.has('secondExpression')) {
        result.secondExpression = overrides && overrides.hasOwnProperty('secondExpression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.secondExpression ?? {}, pickedFields.get('secondExpression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('secondExpression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionMultiplyOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionMultiplyOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expressions')) {
        result.expressions = overrides && overrides.hasOwnProperty('expressions') ? overrides.expressions!.map((x) => aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expressions'))) : [aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expressions'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionStringifyOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionStringifyOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubstringOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubstringOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lengthExpression')) {
        result.lengthExpression = overrides && overrides.hasOwnProperty('lengthExpression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.lengthExpression ?? {}, pickedFields.get('lengthExpression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('lengthExpression'));
    }
    if (pickedFields.size === 0 || pickedFields.has('startExpression')) {
        result.startExpression = overrides && overrides.hasOwnProperty('startExpression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.startExpression ?? {}, pickedFields.get('startExpression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('startExpression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubtractOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubtractOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('firstExpression')) {
        result.firstExpression = overrides && overrides.hasOwnProperty('firstExpression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.firstExpression ?? {}, pickedFields.get('firstExpression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('firstExpression'));
    }
    if (pickedFields.size === 0 || pickedFields.has('secondExpression')) {
        result.secondExpression = overrides && overrides.hasOwnProperty('secondExpression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.secondExpression ?? {}, pickedFields.get('secondExpression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('secondExpression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSumOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSumOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expressions')) {
        result.expressions = overrides && overrides.hasOwnProperty('expressions') ? overrides.expressions!.map((x) => aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expressions'))) : [aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expressions'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToLowerOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToLowerOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToUpperOperationInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToUpperOperationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupIdInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupIdInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }
    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'et';
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accumulators')) {
        result.accumulators = overrides && overrides.hasOwnProperty('accumulators') ? overrides.accumulators!.map((x) => aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorInput({}, pickedFields.get('accumulators'))) : [aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorInput({}, pickedFields.get('accumulators'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids!.map((x) => aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupIdInput({}, pickedFields.get('ids'))) : [aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupIdInput({}, pickedFields.get('ids'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('consistentRead')) {
        result.consistentRead = overrides && overrides.hasOwnProperty('consistentRead') ? overrides.consistentRead! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnTotalCount')) {
        result.returnTotalCount = overrides && overrides.hasOwnProperty('returnTotalCount') ? overrides.returnTotalCount! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('stages')) {
        result.stages = overrides && overrides.hasOwnProperty('stages') ? overrides.stages!.map((x) => aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestStageInput({}, pickedFields.get('stages'))) : [aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestStageInput({}, pickedFields.get('stages'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestObjectToArrayInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestObjectToArrayInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('arrayFieldName')) {
        result.arrayFieldName = overrides && overrides.hasOwnProperty('arrayFieldName') ? overrides.arrayFieldName! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('destinationFieldName')) {
        result.destinationFieldName = overrides && overrides.hasOwnProperty('destinationFieldName') ? overrides.destinationFieldName! : 'occaecati';
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionExcludeInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionExcludeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'doloribus';
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exclude')) {
        result.exclude = overrides && overrides.hasOwnProperty('exclude') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionExcludeInput(overrides.exclude ?? {}, pickedFields.get('exclude')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionExcludeInput({}, pickedFields.get('exclude'));
    }
    if (pickedFields.size === 0 || pickedFields.has('include')) {
        result.include = overrides && overrides.hasOwnProperty('include') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionIncludeInput(overrides.include ?? {}, pickedFields.get('include')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionIncludeInput({}, pickedFields.get('include'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectionExpression')) {
        result.projectionExpression = overrides && overrides.hasOwnProperty('projectionExpression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionExpressionInput(overrides.projectionExpression ?? {}, pickedFields.get('projectionExpression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionExpressionInput({}, pickedFields.get('projectionExpression'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectionFields')) {
        result.projectionFields = overrides && overrides.hasOwnProperty('projectionFields') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionFieldsInput(overrides.projectionFields ?? {}, pickedFields.get('projectionFields')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionFieldsInput({}, pickedFields.get('projectionFields'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionIncludeInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionIncludeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'nulla';
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields!.map((x) => aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput({}, pickedFields.get('fields'))) : [aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput({}, pickedFields.get('fields'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionExpressionInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionExpressionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput(overrides.expression ?? {}, pickedFields.get('expression')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput({}, pickedFields.get('expression'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'autem';
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionFieldsInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectionFieldsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields!.map((x) => aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput({}, pickedFields.get('fields'))) : [aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput({}, pickedFields.get('fields'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestSortingInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values!.map((x) => aComWixpressCloudDataApiDataUpstreamWixCommonSortingInput({}, pickedFields.get('values'))) : [aComWixpressCloudDataApiDataUpstreamWixCommonSortingInput({}, pickedFields.get('values'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestStageInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestStageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('group')) {
        result.group = overrides && overrides.hasOwnProperty('group') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupInput(overrides.group ?? {}, pickedFields.get('group')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupInput({}, pickedFields.get('group'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1574;
    }
    if (pickedFields.size === 0 || pickedFields.has('objectToArray')) {
        result.objectToArray = overrides && overrides.hasOwnProperty('objectToArray') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestObjectToArrayInput(overrides.objectToArray ?? {}, pickedFields.get('objectToArray')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestObjectToArrayInput({}, pickedFields.get('objectToArray'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projection')) {
        result.projection = overrides && overrides.hasOwnProperty('projection') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionInput(overrides.projection ?? {}, pickedFields.get('projection')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionInput({}, pickedFields.get('projection'));
    }
    if (pickedFields.size === 0 || pickedFields.has('skip')) {
        result.skip = overrides && overrides.hasOwnProperty('skip') ? overrides.skip! : 7013;
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestSortingInput(overrides.sort ?? {}, pickedFields.get('sort')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestSortingInput({}, pickedFields.get('sort'));
    }
    if (pickedFields.size === 0 || pickedFields.has('unwindArray')) {
        result.unwindArray = overrides && overrides.hasOwnProperty('unwindArray') ? aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestUnwindArrayInput(overrides.unwindArray ?? {}, pickedFields.get('unwindArray')) : aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestUnwindArrayInput({}, pickedFields.get('unwindArray'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestUnwindArrayInput = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestUnwindArrayInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('arrayFieldName')) {
        result.arrayFieldName = overrides && overrides.hasOwnProperty('arrayFieldName') ? overrides.arrayFieldName! : 'dolorem';
    }

    return result;
};

export const aComWixpressCloudDataApiDataAggregatePipelineDataItemsResponse = <T extends Partial<ComWixpressCloudDataApiDataAggregatePipelineDataItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results! : ['quos'];
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkDataItemReferenceResult = <T extends Partial<ComWixpressCloudDataApiDataBulkDataItemReferenceResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('action')) {
        result.action = overrides && overrides.hasOwnProperty('action') ? overrides.action! : ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionType.Delete;
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItemReference')) {
        result.dataItemReference = overrides && overrides.hasOwnProperty('dataItemReference') ? aComWixpressCloudDataApiDataDataItemReference(overrides.dataItemReference ?? {}, pickedFields.get('dataItemReference')) : aComWixpressCloudDataApiDataDataItemReference({}, pickedFields.get('dataItemReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('referenceMetadata')) {
        result.referenceMetadata = overrides && overrides.hasOwnProperty('referenceMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata(overrides.referenceMetadata ?? {}, pickedFields.get('referenceMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata({}, pickedFields.get('referenceMetadata'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkDataItemResult = <T extends Partial<ComWixpressCloudDataApiDataBulkDataItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('action')) {
        result.action = overrides && overrides.hasOwnProperty('action') ? overrides.action! : ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionType.Delete;
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItem')) {
        result.dataItem = overrides && overrides.hasOwnProperty('dataItem') ? aComWixpressCloudDataApiDataDataItem(overrides.dataItem ?? {}, pickedFields.get('dataItem')) : aComWixpressCloudDataApiDataDataItem({}, pickedFields.get('dataItem'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkInsertDataItemReferencesRequestInput = <T extends Partial<ComWixpressCloudDataApiDataBulkInsertDataItemReferencesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItemReferences')) {
        result.dataItemReferences = overrides && overrides.hasOwnProperty('dataItemReferences') ? overrides.dataItemReferences!.map((x) => aComWixpressCloudDataApiDataDataItemReferenceInput({}, pickedFields.get('dataItemReferences'))) : [aComWixpressCloudDataApiDataDataItemReferenceInput({}, pickedFields.get('dataItemReferences'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkInsertDataItemReferencesResponse = <T extends Partial<ComWixpressCloudDataApiDataBulkInsertDataItemReferencesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressCloudDataApiDataBulkDataItemReferenceResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressCloudDataApiDataBulkDataItemReferenceResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkInsertDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataBulkInsertDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItems')) {
        result.dataItems = overrides && overrides.hasOwnProperty('dataItems') ? overrides.dataItems!.map((x) => aComWixpressCloudDataApiDataDataItemInput({}, pickedFields.get('dataItems'))) : [aComWixpressCloudDataApiDataDataItemInput({}, pickedFields.get('dataItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkInsertDataItemsResponse = <T extends Partial<ComWixpressCloudDataApiDataBulkInsertDataItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressCloudDataApiDataBulkDataItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressCloudDataApiDataBulkDataItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkPatchDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataBulkPatchDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('patches')) {
        result.patches = overrides && overrides.hasOwnProperty('patches') ? overrides.patches!.map((x) => aComWixpressCloudDataApiDataPatchInput({}, pickedFields.get('patches'))) : [aComWixpressCloudDataApiDataPatchInput({}, pickedFields.get('patches'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : true;
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkPatchDataItemsResponse = <T extends Partial<ComWixpressCloudDataApiDataBulkPatchDataItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressCloudDataApiDataBulkDataItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressCloudDataApiDataBulkDataItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkRemoveDataItemReferencesRequestInput = <T extends Partial<ComWixpressCloudDataApiDataBulkRemoveDataItemReferencesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItemReferences')) {
        result.dataItemReferences = overrides && overrides.hasOwnProperty('dataItemReferences') ? overrides.dataItemReferences!.map((x) => aComWixpressCloudDataApiDataDataItemReferenceInput({}, pickedFields.get('dataItemReferences'))) : [aComWixpressCloudDataApiDataDataItemReferenceInput({}, pickedFields.get('dataItemReferences'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkRemoveDataItemReferencesResponse = <T extends Partial<ComWixpressCloudDataApiDataBulkRemoveDataItemReferencesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressCloudDataApiDataBulkDataItemReferenceResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressCloudDataApiDataBulkDataItemReferenceResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkRemoveDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataBulkRemoveDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItemIds')) {
        result.dataItemIds = overrides && overrides.hasOwnProperty('dataItemIds') ? overrides.dataItemIds! : ['nihil'];
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkRemoveDataItemsResponse = <T extends Partial<ComWixpressCloudDataApiDataBulkRemoveDataItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressCloudDataApiDataBulkDataItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressCloudDataApiDataBulkDataItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkSaveDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataBulkSaveDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItems')) {
        result.dataItems = overrides && overrides.hasOwnProperty('dataItems') ? overrides.dataItems!.map((x) => aComWixpressCloudDataApiDataDataItemInput({}, pickedFields.get('dataItems'))) : [aComWixpressCloudDataApiDataDataItemInput({}, pickedFields.get('dataItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkSaveDataItemsResponse = <T extends Partial<ComWixpressCloudDataApiDataBulkSaveDataItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressCloudDataApiDataBulkDataItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressCloudDataApiDataBulkDataItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkUpdateDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataBulkUpdateDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItems')) {
        result.dataItems = overrides && overrides.hasOwnProperty('dataItems') ? overrides.dataItems!.map((x) => aComWixpressCloudDataApiDataDataItemInput({}, pickedFields.get('dataItems'))) : [aComWixpressCloudDataApiDataDataItemInput({}, pickedFields.get('dataItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataBulkUpdateDataItemsResponse = <T extends Partial<ComWixpressCloudDataApiDataBulkUpdateDataItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressCloudDataApiDataBulkDataItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressCloudDataApiDataBulkDataItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataCountDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataCountDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('consistentRead')) {
        result.consistentRead = overrides && overrides.hasOwnProperty('consistentRead') ? overrides.consistentRead! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : true;
    }

    return result;
};

export const aComWixpressCloudDataApiDataCountDataItemsResponse = <T extends Partial<ComWixpressCloudDataApiDataCountDataItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalCount')) {
        result.totalCount = overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 3569;
    }

    return result;
};

export const aComWixpressCloudDataApiDataDataItem = <T extends Partial<ComWixpressCloudDataApiDataDataItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('data')) {
        result.data = overrides && overrides.hasOwnProperty('data') ? overrides.data! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'in';
    }

    return result;
};

export const aComWixpressCloudDataApiDataDataItemInput = <T extends Partial<ComWixpressCloudDataApiDataDataItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('data')) {
        result.data = overrides && overrides.hasOwnProperty('data') ? overrides.data! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }

    return result;
};

export const aComWixpressCloudDataApiDataDataItemReference = <T extends Partial<ComWixpressCloudDataApiDataDataItemReference>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('referencedItemId')) {
        result.referencedItemId = overrides && overrides.hasOwnProperty('referencedItemId') ? overrides.referencedItemId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemFieldName')) {
        result.referringItemFieldName = overrides && overrides.hasOwnProperty('referringItemFieldName') ? overrides.referringItemFieldName! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemId')) {
        result.referringItemId = overrides && overrides.hasOwnProperty('referringItemId') ? overrides.referringItemId! : 'id';
    }

    return result;
};

export const aComWixpressCloudDataApiDataDataItemReferenceInput = <T extends Partial<ComWixpressCloudDataApiDataDataItemReferenceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('referencedItemId')) {
        result.referencedItemId = overrides && overrides.hasOwnProperty('referencedItemId') ? overrides.referencedItemId! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemFieldName')) {
        result.referringItemFieldName = overrides && overrides.hasOwnProperty('referringItemFieldName') ? overrides.referringItemFieldName! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemId')) {
        result.referringItemId = overrides && overrides.hasOwnProperty('referringItemId') ? overrides.referringItemId! : 'deleniti';
    }

    return result;
};

export const aComWixpressCloudDataApiDataFieldModificationAppendToArrayOptionsInput = <T extends Partial<ComWixpressCloudDataApiDataFieldModificationAppendToArrayOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'nobis';
    }

    return result;
};

export const aComWixpressCloudDataApiDataFieldModificationIncrementFieldOptionsInput = <T extends Partial<ComWixpressCloudDataApiDataFieldModificationIncrementFieldOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 3.54;
    }

    return result;
};

export const aComWixpressCloudDataApiDataFieldModificationInput = <T extends Partial<ComWixpressCloudDataApiDataFieldModificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('action')) {
        result.action = overrides && overrides.hasOwnProperty('action') ? overrides.action! : ComWixpressCloudDataApiDataFieldModificationAction.AppendToArray;
    }
    if (pickedFields.size === 0 || pickedFields.has('appendToArrayOptions')) {
        result.appendToArrayOptions = overrides && overrides.hasOwnProperty('appendToArrayOptions') ? aComWixpressCloudDataApiDataFieldModificationAppendToArrayOptionsInput(overrides.appendToArrayOptions ?? {}, pickedFields.get('appendToArrayOptions')) : aComWixpressCloudDataApiDataFieldModificationAppendToArrayOptionsInput({}, pickedFields.get('appendToArrayOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'vero';
    }
    if (pickedFields.size === 0 || pickedFields.has('incrementFieldOptions')) {
        result.incrementFieldOptions = overrides && overrides.hasOwnProperty('incrementFieldOptions') ? aComWixpressCloudDataApiDataFieldModificationIncrementFieldOptionsInput(overrides.incrementFieldOptions ?? {}, pickedFields.get('incrementFieldOptions')) : aComWixpressCloudDataApiDataFieldModificationIncrementFieldOptionsInput({}, pickedFields.get('incrementFieldOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('removeFromArrayOptions')) {
        result.removeFromArrayOptions = overrides && overrides.hasOwnProperty('removeFromArrayOptions') ? aComWixpressCloudDataApiDataFieldModificationRemoveFromArrayOptionsInput(overrides.removeFromArrayOptions ?? {}, pickedFields.get('removeFromArrayOptions')) : aComWixpressCloudDataApiDataFieldModificationRemoveFromArrayOptionsInput({}, pickedFields.get('removeFromArrayOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('setFieldOptions')) {
        result.setFieldOptions = overrides && overrides.hasOwnProperty('setFieldOptions') ? aComWixpressCloudDataApiDataFieldModificationSetFieldOptionsInput(overrides.setFieldOptions ?? {}, pickedFields.get('setFieldOptions')) : aComWixpressCloudDataApiDataFieldModificationSetFieldOptionsInput({}, pickedFields.get('setFieldOptions'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataFieldModificationRemoveFromArrayOptionsInput = <T extends Partial<ComWixpressCloudDataApiDataFieldModificationRemoveFromArrayOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'qui';
    }

    return result;
};

export const aComWixpressCloudDataApiDataFieldModificationSetFieldOptionsInput = <T extends Partial<ComWixpressCloudDataApiDataFieldModificationSetFieldOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'inventore';
    }

    return result;
};

export const aComWixpressCloudDataApiDataFieldUpdateAppendToArrayInput = <T extends Partial<ComWixpressCloudDataApiDataFieldUpdateAppendToArrayInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'enim';
    }

    return result;
};

export const aComWixpressCloudDataApiDataFieldUpdateIncrementFieldInput = <T extends Partial<ComWixpressCloudDataApiDataFieldUpdateIncrementFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 6.63;
    }

    return result;
};

export const aComWixpressCloudDataApiDataFieldUpdateRemoveFromArrayInput = <T extends Partial<ComWixpressCloudDataApiDataFieldUpdateRemoveFromArrayInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'velit';
    }

    return result;
};

export const aComWixpressCloudDataApiDataFieldUpdateSetFieldInput = <T extends Partial<ComWixpressCloudDataApiDataFieldUpdateSetFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'distinctio';
    }

    return result;
};

export const aComWixpressCloudDataApiDataGetDataItemRequestInput = <T extends Partial<ComWixpressCloudDataApiDataGetDataItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('consistentRead')) {
        result.consistentRead = overrides && overrides.hasOwnProperty('consistentRead') ? overrides.consistentRead! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['cum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '73ee57f6-17da-497f-ae0b-38f66e7ce852';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : true;
    }

    return result;
};

export const aComWixpressCloudDataApiDataInsertDataItemReferenceRequestInput = <T extends Partial<ComWixpressCloudDataApiDataInsertDataItemReferenceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItemReference')) {
        result.dataItemReference = overrides && overrides.hasOwnProperty('dataItemReference') ? aComWixpressCloudDataApiDataDataItemReferenceInput(overrides.dataItemReference ?? {}, pickedFields.get('dataItemReference')) : aComWixpressCloudDataApiDataDataItemReferenceInput({}, pickedFields.get('dataItemReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataInsertDataItemReferenceResponse = <T extends Partial<ComWixpressCloudDataApiDataInsertDataItemReferenceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataItemReference')) {
        result.dataItemReference = overrides && overrides.hasOwnProperty('dataItemReference') ? aComWixpressCloudDataApiDataDataItemReference(overrides.dataItemReference ?? {}, pickedFields.get('dataItemReference')) : aComWixpressCloudDataApiDataDataItemReference({}, pickedFields.get('dataItemReference'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataInsertDataItemRequestInput = <T extends Partial<ComWixpressCloudDataApiDataInsertDataItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItem')) {
        result.dataItem = overrides && overrides.hasOwnProperty('dataItem') ? aComWixpressCloudDataApiDataDataItemInput(overrides.dataItem ?? {}, pickedFields.get('dataItem')) : aComWixpressCloudDataApiDataDataItemInput({}, pickedFields.get('dataItem'));
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeReferencedItems')) {
        result.includeReferencedItems = overrides && overrides.hasOwnProperty('includeReferencedItems') ? overrides.includeReferencedItems! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataInsertDataItemResponse = <T extends Partial<ComWixpressCloudDataApiDataInsertDataItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataItem')) {
        result.dataItem = overrides && overrides.hasOwnProperty('dataItem') ? aComWixpressCloudDataApiDataDataItem(overrides.dataItem ?? {}, pickedFields.get('dataItem')) : aComWixpressCloudDataApiDataDataItem({}, pickedFields.get('dataItem'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataIsReferencedDataItemRequestInput = <T extends Partial<ComWixpressCloudDataApiDataIsReferencedDataItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('consistentRead')) {
        result.consistentRead = overrides && overrides.hasOwnProperty('consistentRead') ? overrides.consistentRead! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('referencedItemId')) {
        result.referencedItemId = overrides && overrides.hasOwnProperty('referencedItemId') ? overrides.referencedItemId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemFieldName')) {
        result.referringItemFieldName = overrides && overrides.hasOwnProperty('referringItemFieldName') ? overrides.referringItemFieldName! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemId')) {
        result.referringItemId = overrides && overrides.hasOwnProperty('referringItemId') ? overrides.referringItemId! : 'ea';
    }

    return result;
};

export const aComWixpressCloudDataApiDataIsReferencedDataItemResponse = <T extends Partial<ComWixpressCloudDataApiDataIsReferencedDataItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('isReferenced')) {
        result.isReferenced = overrides && overrides.hasOwnProperty('isReferenced') ? overrides.isReferenced! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataOptionsInput = <T extends Partial<ComWixpressCloudDataApiDataOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataOptionsPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataOptionsPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : true;
    }

    return result;
};

export const aComWixpressCloudDataApiDataOptionsPublishPluginOptionsInput = <T extends Partial<ComWixpressCloudDataApiDataOptionsPublishPluginOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('showDraftItems')) {
        result.showDraftItems = overrides && overrides.hasOwnProperty('showDraftItems') ? overrides.showDraftItems! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataPatchDataItemRequestInput = <T extends Partial<ComWixpressCloudDataApiDataPatchDataItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('patch')) {
        result.patch = overrides && overrides.hasOwnProperty('patch') ? aComWixpressCloudDataApiDataPatchInput(overrides.patch ?? {}, pickedFields.get('patch')) : aComWixpressCloudDataApiDataPatchInput({}, pickedFields.get('patch'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataPatchDataItemResponse = <T extends Partial<ComWixpressCloudDataApiDataPatchDataItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataItem')) {
        result.dataItem = overrides && overrides.hasOwnProperty('dataItem') ? aComWixpressCloudDataApiDataDataItem(overrides.dataItem ?? {}, pickedFields.get('dataItem')) : aComWixpressCloudDataApiDataDataItem({}, pickedFields.get('dataItem'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataPatchInput = <T extends Partial<ComWixpressCloudDataApiDataPatchInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataItemId')) {
        result.dataItemId = overrides && overrides.hasOwnProperty('dataItemId') ? overrides.dataItemId! : 'expedita';
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldModifications')) {
        result.fieldModifications = overrides && overrides.hasOwnProperty('fieldModifications') ? overrides.fieldModifications!.map((x) => aComWixpressCloudDataApiDataFieldModificationInput({}, pickedFields.get('fieldModifications'))) : [aComWixpressCloudDataApiDataFieldModificationInput({}, pickedFields.get('fieldModifications'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataPublishPluginOptionsInput = <T extends Partial<ComWixpressCloudDataApiDataPublishPluginOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includeDraftItems')) {
        result.includeDraftItems = overrides && overrides.hasOwnProperty('includeDraftItems') ? overrides.includeDraftItems! : true;
    }

    return result;
};

export const aComWixpressCloudDataApiDataQueryDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataQueryDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('consistentRead')) {
        result.consistentRead = overrides && overrides.hasOwnProperty('consistentRead') ? overrides.consistentRead! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeReferencedItems')) {
        result.includeReferencedItems = overrides && overrides.hasOwnProperty('includeReferencedItems') ? overrides.includeReferencedItems! : ['aliquam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressCloudDataApiDataUpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressCloudDataApiDataUpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }
    if (pickedFields.size === 0 || pickedFields.has('referencedItemOptions')) {
        result.referencedItemOptions = overrides && overrides.hasOwnProperty('referencedItemOptions') ? overrides.referencedItemOptions!.map((x) => aComWixpressCloudDataApiDataQueryDataItemsRequestReferencedItemOptionsInput({}, pickedFields.get('referencedItemOptions'))) : [aComWixpressCloudDataApiDataQueryDataItemsRequestReferencedItemOptionsInput({}, pickedFields.get('referencedItemOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('requestCachingInfo')) {
        result.requestCachingInfo = overrides && overrides.hasOwnProperty('requestCachingInfo') ? overrides.requestCachingInfo! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('returnTotalCount')) {
        result.returnTotalCount = overrides && overrides.hasOwnProperty('returnTotalCount') ? overrides.returnTotalCount! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataQueryDataItemsRequestReferencedItemOptionsInput = <T extends Partial<ComWixpressCloudDataApiDataQueryDataItemsRequestReferencedItemOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 5839;
    }

    return result;
};

export const aComWixpressCloudDataApiDataQueryDataItemsResponse = <T extends Partial<ComWixpressCloudDataApiDataQueryDataItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressCloudDataApiDataDataItem(x ?? {}, pickedFields.get('items'))) : [aComWixpressCloudDataApiDataDataItem({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataQueryDistinctValuesRequestInput = <T extends Partial<ComWixpressCloudDataApiDataQueryDistinctValuesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('consistentRead')) {
        result.consistentRead = overrides && overrides.hasOwnProperty('consistentRead') ? overrides.consistentRead! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : ComWixpressCloudDataApiDataUpstreamWixCommonSortOrder.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnTotalCount')) {
        result.returnTotalCount = overrides && overrides.hasOwnProperty('returnTotalCount') ? overrides.returnTotalCount! : true;
    }

    return result;
};

export const aComWixpressCloudDataApiDataQueryDistinctValuesResponse = <T extends Partial<ComWixpressCloudDataApiDataQueryDistinctValuesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('distinctValues')) {
        result.distinctValues = overrides && overrides.hasOwnProperty('distinctValues') ? overrides.distinctValues! : ['rerum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataQueryReferencedDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataQueryReferencedDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('consistentRead')) {
        result.consistentRead = overrides && overrides.hasOwnProperty('consistentRead') ? overrides.consistentRead! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['est'];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : ComWixpressCloudDataApiDataUpstreamWixCommonSortOrder.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemFieldName')) {
        result.referringItemFieldName = overrides && overrides.hasOwnProperty('referringItemFieldName') ? overrides.referringItemFieldName! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemId')) {
        result.referringItemId = overrides && overrides.hasOwnProperty('referringItemId') ? overrides.referringItemId! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemIds')) {
        result.referringItemIds = overrides && overrides.hasOwnProperty('referringItemIds') ? overrides.referringItemIds! : ['repellendus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnTotalCount')) {
        result.returnTotalCount = overrides && overrides.hasOwnProperty('returnTotalCount') ? overrides.returnTotalCount! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataQueryReferencedDataItemsResponse = <T extends Partial<ComWixpressCloudDataApiDataQueryReferencedDataItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressCloudDataApiDataQueryReferencedDataItemsResponseReferencedResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressCloudDataApiDataQueryReferencedDataItemsResponseReferencedResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataQueryReferencedDataItemsResponseReferencedResult = <T extends Partial<ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseReferencedResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataItem')) {
        result.dataItem = overrides && overrides.hasOwnProperty('dataItem') ? aComWixpressCloudDataApiDataDataItem(overrides.dataItem ?? {}, pickedFields.get('dataItem')) : aComWixpressCloudDataApiDataDataItem({}, pickedFields.get('dataItem'));
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemId')) {
        result.referringItemId = overrides && overrides.hasOwnProperty('referringItemId') ? overrides.referringItemId! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('unresolvedReference')) {
        result.unresolvedReference = overrides && overrides.hasOwnProperty('unresolvedReference') ? aComWixpressCloudDataApiDataQueryReferencedDataItemsResponseUnresolvedReference(overrides.unresolvedReference ?? {}, pickedFields.get('unresolvedReference')) : aComWixpressCloudDataApiDataQueryReferencedDataItemsResponseUnresolvedReference({}, pickedFields.get('unresolvedReference'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataQueryReferencedDataItemsResponseUnresolvedReference = <T extends Partial<ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseUnresolvedReference>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('referencedItemId')) {
        result.referencedItemId = overrides && overrides.hasOwnProperty('referencedItemId') ? overrides.referencedItemId! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemFieldName')) {
        result.referringItemFieldName = overrides && overrides.hasOwnProperty('referringItemFieldName') ? overrides.referringItemFieldName! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemId')) {
        result.referringItemId = overrides && overrides.hasOwnProperty('referringItemId') ? overrides.referringItemId! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('unauthorized')) {
        result.unauthorized = overrides && overrides.hasOwnProperty('unauthorized') ? overrides.unauthorized! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataRemoveDataItemReferenceRequestInput = <T extends Partial<ComWixpressCloudDataApiDataRemoveDataItemReferenceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItemReference')) {
        result.dataItemReference = overrides && overrides.hasOwnProperty('dataItemReference') ? aComWixpressCloudDataApiDataDataItemReferenceInput(overrides.dataItemReference ?? {}, pickedFields.get('dataItemReference')) : aComWixpressCloudDataApiDataDataItemReferenceInput({}, pickedFields.get('dataItemReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataRemoveDataItemReferenceResponse = <T extends Partial<ComWixpressCloudDataApiDataRemoveDataItemReferenceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataItemReference')) {
        result.dataItemReference = overrides && overrides.hasOwnProperty('dataItemReference') ? aComWixpressCloudDataApiDataDataItemReference(overrides.dataItemReference ?? {}, pickedFields.get('dataItemReference')) : aComWixpressCloudDataApiDataDataItemReference({}, pickedFields.get('dataItemReference'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataRemoveDataItemRequestInput = <T extends Partial<ComWixpressCloudDataApiDataRemoveDataItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItemId')) {
        result.dataItemId = overrides && overrides.hasOwnProperty('dataItemId') ? overrides.dataItemId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataRemoveDataItemResponse = <T extends Partial<ComWixpressCloudDataApiDataRemoveDataItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataItem')) {
        result.dataItem = overrides && overrides.hasOwnProperty('dataItem') ? aComWixpressCloudDataApiDataDataItem(overrides.dataItem ?? {}, pickedFields.get('dataItem')) : aComWixpressCloudDataApiDataDataItem({}, pickedFields.get('dataItem'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataReplaceDataItemReferencesRequestInput = <T extends Partial<ComWixpressCloudDataApiDataReplaceDataItemReferencesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('newReferencedItemIds')) {
        result.newReferencedItemIds = overrides && overrides.hasOwnProperty('newReferencedItemIds') ? overrides.newReferencedItemIds! : ['nulla'];
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemFieldName')) {
        result.referringItemFieldName = overrides && overrides.hasOwnProperty('referringItemFieldName') ? overrides.referringItemFieldName! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('referringItemId')) {
        result.referringItemId = overrides && overrides.hasOwnProperty('referringItemId') ? overrides.referringItemId! : 'eligendi';
    }

    return result;
};

export const aComWixpressCloudDataApiDataReplaceDataItemReferencesResponse = <T extends Partial<ComWixpressCloudDataApiDataReplaceDataItemReferencesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataItemReferences')) {
        result.dataItemReferences = overrides && overrides.hasOwnProperty('dataItemReferences') ? overrides.dataItemReferences!.map((x) => aComWixpressCloudDataApiDataDataItemReference(x ?? {}, pickedFields.get('dataItemReferences'))) : [aComWixpressCloudDataApiDataDataItemReference({}, pickedFields.get('dataItemReferences'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataSaveDataItemRequestInput = <T extends Partial<ComWixpressCloudDataApiDataSaveDataItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItem')) {
        result.dataItem = overrides && overrides.hasOwnProperty('dataItem') ? aComWixpressCloudDataApiDataDataItemInput(overrides.dataItem ?? {}, pickedFields.get('dataItem')) : aComWixpressCloudDataApiDataDataItemInput({}, pickedFields.get('dataItem'));
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeReferencedItems')) {
        result.includeReferencedItems = overrides && overrides.hasOwnProperty('includeReferencedItems') ? overrides.includeReferencedItems! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataSaveDataItemResponse = <T extends Partial<ComWixpressCloudDataApiDataSaveDataItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('action')) {
        result.action = overrides && overrides.hasOwnProperty('action') ? overrides.action! : ComWixpressCloudDataApiDataSaveDataItemResponseAction.Inserted;
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItem')) {
        result.dataItem = overrides && overrides.hasOwnProperty('dataItem') ? aComWixpressCloudDataApiDataDataItem(overrides.dataItem ?? {}, pickedFields.get('dataItem')) : aComWixpressCloudDataApiDataDataItem({}, pickedFields.get('dataItem'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataSearchDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataSearchDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('referencedItemOptions')) {
        result.referencedItemOptions = overrides && overrides.hasOwnProperty('referencedItemOptions') ? overrides.referencedItemOptions!.map((x) => aComWixpressCloudDataApiDataSearchDataItemsRequestReferencedItemOptionsInput({}, pickedFields.get('referencedItemOptions'))) : [aComWixpressCloudDataApiDataSearchDataItemsRequestReferencedItemOptionsInput({}, pickedFields.get('referencedItemOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aComWixpressCloudDataApiDataUpstreamWixCommonSearchInput(overrides.search ?? {}, pickedFields.get('search')) : aComWixpressCloudDataApiDataUpstreamWixCommonSearchInput({}, pickedFields.get('search'));
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataSearchDataItemsRequestReferencedItemOptionsInput = <T extends Partial<ComWixpressCloudDataApiDataSearchDataItemsRequestReferencedItemOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 949;
    }

    return result;
};

export const aComWixpressCloudDataApiDataSearchDataItemsResponse = <T extends Partial<ComWixpressCloudDataApiDataSearchDataItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataItems')) {
        result.dataItems = overrides && overrides.hasOwnProperty('dataItems') ? overrides.dataItems!.map((x) => aComWixpressCloudDataApiDataDataItem(x ?? {}, pickedFields.get('dataItems'))) : [aComWixpressCloudDataApiDataDataItem({}, pickedFields.get('dataItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataTruncateDataItemsRequestInput = <T extends Partial<ComWixpressCloudDataApiDataTruncateDataItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'vero';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpdateDataItemRequestInput = <T extends Partial<ComWixpressCloudDataApiDataUpdateDataItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('appOptions')) {
        result.appOptions = overrides && overrides.hasOwnProperty('appOptions') ? overrides.appOptions! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataCollectionId')) {
        result.dataCollectionId = overrides && overrides.hasOwnProperty('dataCollectionId') ? overrides.dataCollectionId! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataItem')) {
        result.dataItem = overrides && overrides.hasOwnProperty('dataItem') ? aComWixpressCloudDataApiDataDataItemInput(overrides.dataItem ?? {}, pickedFields.get('dataItem')) : aComWixpressCloudDataApiDataDataItemInput({}, pickedFields.get('dataItem'));
    }
    if (pickedFields.size === 0 || pickedFields.has('environment')) {
        result.environment = overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : ComWixpressCloudDataApiEnvironment.Live;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeReferencedItems')) {
        result.includeReferencedItems = overrides && overrides.hasOwnProperty('includeReferencedItems') ? overrides.includeReferencedItems! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aComWixpressCloudDataApiDataOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aComWixpressCloudDataApiDataOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishPluginOptions')) {
        result.publishPluginOptions = overrides && overrides.hasOwnProperty('publishPluginOptions') ? aComWixpressCloudDataApiDataPublishPluginOptionsInput(overrides.publishPluginOptions ?? {}, pickedFields.get('publishPluginOptions')) : aComWixpressCloudDataApiDataPublishPluginOptionsInput({}, pickedFields.get('publishPluginOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressHooks')) {
        result.suppressHooks = overrides && overrides.hasOwnProperty('suppressHooks') ? overrides.suppressHooks! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpdateDataItemResponse = <T extends Partial<ComWixpressCloudDataApiDataUpdateDataItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataItem')) {
        result.dataItem = overrides && overrides.hasOwnProperty('dataItem') ? aComWixpressCloudDataApiDataDataItem(overrides.dataItem ?? {}, pickedFields.get('dataItem')) : aComWixpressCloudDataApiDataDataItem({}, pickedFields.get('dataItem'));
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata = <T extends Partial<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalFailures')) {
        result.totalFailures = overrides && overrides.hasOwnProperty('totalFailures') ? overrides.totalFailures! : 6523;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalSuccesses')) {
        result.totalSuccesses = overrides && overrides.hasOwnProperty('totalSuccesses') ? overrides.totalSuccesses! : 7036;
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1667;
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpstreamWixCommonCursors = <T extends Partial<ComWixpressCloudDataApiDataUpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'delectus';
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata = <T extends Partial<ComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiApplicationError(overrides.error ?? {}, pickedFields.get('error')) : aWixApiApplicationError({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalIndex')) {
        result.originalIndex = overrides && overrides.hasOwnProperty('originalIndex') ? overrides.originalIndex! : 9196;
    }
    if (pickedFields.size === 0 || pickedFields.has('success')) {
        result.success = overrides && overrides.hasOwnProperty('success') ? overrides.success! : false;
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput = <T extends Partial<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 7349;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 6204;
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2 = <T extends Partial<ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 6211;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aComWixpressCloudDataApiDataUpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aComWixpressCloudDataApiDataUpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 9595;
    }
    if (pickedFields.size === 0 || pickedFields.has('tooManyToCount')) {
        result.tooManyToCount = overrides && overrides.hasOwnProperty('tooManyToCount') ? overrides.tooManyToCount! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 3036;
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpstreamWixCommonQueryV2Input = <T extends Partial<ComWixpressCloudDataApiDataUpstreamWixCommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['veniam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixpressCloudDataApiDataUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixpressCloudDataApiDataUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsInput = <T extends Partial<ComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('fuzzy')) {
        result.fuzzy = overrides && overrides.hasOwnProperty('fuzzy') ? overrides.fuzzy! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('mode')) {
        result.mode = overrides && overrides.hasOwnProperty('mode') ? overrides.mode! : ComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsMode.And;
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpstreamWixCommonSearchInput = <T extends Partial<ComWixpressCloudDataApiDataUpstreamWixCommonSearchInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['labore'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressCloudDataApiDataUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsInput(overrides.search ?? {}, pickedFields.get('search')) : aComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsInput({}, pickedFields.get('search'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixpressCloudDataApiDataUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixpressCloudDataApiDataUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressCloudDataApiDataUpstreamWixCommonSortingInput = <T extends Partial<ComWixpressCloudDataApiDataUpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : ComWixpressCloudDataApiDataUpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ActivityIcon = <T extends Partial<ComWixpressContactsCoreApiV4ActivityIcon>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'non';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ActivityIconInput = <T extends Partial<ComWixpressContactsCoreApiV4ActivityIconInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'cumque';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4AssigneesWrapper = <T extends Partial<ComWixpressContactsCoreApiV4AssigneesWrapper>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items! : ['corrupti'];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4AssigneesWrapperInput = <T extends Partial<ComWixpressContactsCoreApiV4AssigneesWrapperInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items! : ['delectus'];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkAddSegmentToContactsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4BulkAddSegmentToContactsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactIds')) {
        result.contactIds = overrides && overrides.hasOwnProperty('contactIds') ? overrides.contactIds! : ['explicabo'];
    }
    if (pickedFields.size === 0 || pickedFields.has('existsSegmentIds')) {
        result.existsSegmentIds = overrides && overrides.hasOwnProperty('existsSegmentIds') ? overrides.existsSegmentIds! : ['aperiam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('segmentId')) {
        result.segmentId = overrides && overrides.hasOwnProperty('segmentId') ? overrides.segmentId! : 'consequatur';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkAddSegmentToContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4BulkAddSegmentToContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCommonItemMetadata(x ?? {}, pickedFields.get('results'))) : [aWixCommonItemMetadata({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkDeleteContactsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4BulkDeleteContactsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deleteMember')) {
        result.deleteMember = overrides && overrides.hasOwnProperty('deleteMember') ? overrides.deleteMember! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? overrides.search! : 'et';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkDeleteContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4BulkDeleteContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jobId')) {
        result.jobId = overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'accusamus';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('labelKeysToAdd')) {
        result.labelKeysToAdd = overrides && overrides.hasOwnProperty('labelKeysToAdd') ? overrides.labelKeysToAdd! : ['facere'];
    }
    if (pickedFields.size === 0 || pickedFields.has('labelKeysToRemove')) {
        result.labelKeysToRemove = overrides && overrides.hasOwnProperty('labelKeysToRemove') ? overrides.labelKeysToRemove! : ['dolores'];
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? overrides.search! : 'non';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jobId')) {
        result.jobId = overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'tempora';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactIds')) {
        result.contactIds = overrides && overrides.hasOwnProperty('contactIds') ? overrides.contactIds! : ['sed'];
    }
    if (pickedFields.size === 0 || pickedFields.has('segmentId')) {
        result.segmentId = overrides && overrides.hasOwnProperty('segmentId') ? overrides.segmentId! : 'minima';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCommonItemMetadata(x ?? {}, pickedFields.get('results'))) : [aWixCommonItemMetadata({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkUpdateContactsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4BulkUpdateContactsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['quae'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('info')) {
        result.info = overrides && overrides.hasOwnProperty('info') ? aComWixpressContactsCoreApiV4ContactInfoInput(overrides.info ?? {}, pickedFields.get('info')) : aComWixpressContactsCoreApiV4ContactInfoInput({}, pickedFields.get('info'));
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? overrides.search! : 'dignissimos';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkUpdateContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4BulkUpdateContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jobId')) {
        result.jobId = overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'dolore';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkUpsertContactsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4BulkUpsertContactsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('info')) {
        result.info = overrides && overrides.hasOwnProperty('info') ? overrides.info!.map((x) => aComWixpressContactsCoreApiV4ContactInfoInput({}, pickedFields.get('info'))) : [aComWixpressContactsCoreApiV4ContactInfoInput({}, pickedFields.get('info'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : true;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkUpsertContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4BulkUpsertContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aComWixpressContactsCoreApiV4BulkUpsertContactsResponseMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aComWixpressContactsCoreApiV4BulkUpsertContactsResponseMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressContactsCoreApiV4BulkUpsertContactsResponseItem(x ?? {}, pickedFields.get('results'))) : [aComWixpressContactsCoreApiV4BulkUpsertContactsResponseItem({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkUpsertContactsResponseItem = <T extends Partial<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadata({}, pickedFields.get('metadata'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadata = <T extends Partial<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('action')) {
        result.action = overrides && overrides.hasOwnProperty('action') ? overrides.action! : ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataAction.Created;
    }
    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataError(overrides.error ?? {}, pickedFields.get('error')) : aComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataError({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalIndex')) {
        result.originalIndex = overrides && overrides.hasOwnProperty('originalIndex') ? overrides.originalIndex! : 4425;
    }
    if (pickedFields.size === 0 || pickedFields.has('success')) {
        result.success = overrides && overrides.hasOwnProperty('success') ? overrides.success! : true;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataError = <T extends Partial<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataError>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'deleniti';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4BulkUpsertContactsResponseMetadata = <T extends Partial<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalCreated')) {
        result.totalCreated = overrides && overrides.hasOwnProperty('totalCreated') ? overrides.totalCreated! : 5645;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalFailure')) {
        result.totalFailure = overrides && overrides.hasOwnProperty('totalFailure') ? overrides.totalFailure! : 712;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalSuccess')) {
        result.totalSuccess = overrides && overrides.hasOwnProperty('totalSuccess') ? overrides.totalSuccess! : 6724;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalUpdated')) {
        result.totalUpdated = overrides && overrides.hasOwnProperty('totalUpdated') ? overrides.totalUpdated! : 7478;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4Contact = <T extends Partial<ComWixpressContactsCoreApiV4Contact>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('info')) {
        result.info = overrides && overrides.hasOwnProperty('info') ? aComWixpressContactsCoreApiV4ContactInfo(overrides.info ?? {}, pickedFields.get('info')) : aComWixpressContactsCoreApiV4ContactInfo({}, pickedFields.get('info'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lastActivity')) {
        result.lastActivity = overrides && overrides.hasOwnProperty('lastActivity') ? aComWixpressContactsCoreApiV4ContactActivity(overrides.lastActivity ?? {}, pickedFields.get('lastActivity')) : aComWixpressContactsCoreApiV4ContactActivity({}, pickedFields.get('lastActivity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('memberInfo')) {
        result.memberInfo = overrides && overrides.hasOwnProperty('memberInfo') ? aComWixpressContactsCoreApiV4MemberInfo(overrides.memberInfo ?? {}, pickedFields.get('memberInfo')) : aComWixpressContactsCoreApiV4MemberInfo({}, pickedFields.get('memberInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('picture')) {
        result.picture = overrides && overrides.hasOwnProperty('picture') ? aComWixpressContactsCoreApiV4UpstreamWixCommonImage(overrides.picture ?? {}, pickedFields.get('picture')) : aComWixpressContactsCoreApiV4UpstreamWixCommonImage({}, pickedFields.get('picture'));
    }
    if (pickedFields.size === 0 || pickedFields.has('primaryEmail')) {
        result.primaryEmail = overrides && overrides.hasOwnProperty('primaryEmail') ? aComWixpressContactsCoreApiV4PrimaryEmail(overrides.primaryEmail ?? {}, pickedFields.get('primaryEmail')) : aComWixpressContactsCoreApiV4PrimaryEmail({}, pickedFields.get('primaryEmail'));
    }
    if (pickedFields.size === 0 || pickedFields.has('primaryInfo')) {
        result.primaryInfo = overrides && overrides.hasOwnProperty('primaryInfo') ? aComWixpressContactsCoreApiV4PrimaryContactInfo(overrides.primaryInfo ?? {}, pickedFields.get('primaryInfo')) : aComWixpressContactsCoreApiV4PrimaryContactInfo({}, pickedFields.get('primaryInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('primaryPhone')) {
        result.primaryPhone = overrides && overrides.hasOwnProperty('primaryPhone') ? aComWixpressContactsCoreApiV4PrimaryPhone(overrides.primaryPhone ?? {}, pickedFields.get('primaryPhone')) : aComWixpressContactsCoreApiV4PrimaryPhone({}, pickedFields.get('primaryPhone'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 67;
    }
    if (pickedFields.size === 0 || pickedFields.has('segments')) {
        result.segments = overrides && overrides.hasOwnProperty('segments') ? aComWixpressContactsCoreApiV4SegmentsWrapper(overrides.segments ?? {}, pickedFields.get('segments')) : aComWixpressContactsCoreApiV4SegmentsWrapper({}, pickedFields.get('segments'));
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? aComWixpressContactsCoreApiV4ContactSource(overrides.source ?? {}, pickedFields.get('source')) : aComWixpressContactsCoreApiV4ContactSource({}, pickedFields.get('source'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletsVirtualReference')) {
        result.walletsVirtualReference = overrides && overrides.hasOwnProperty('walletsVirtualReference') ? aWixRiseV1QueryWalletsResponse(overrides.walletsVirtualReference ?? {}, pickedFields.get('walletsVirtualReference')) : aWixRiseV1QueryWalletsResponse({}, pickedFields.get('walletsVirtualReference'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactActivity = <T extends Partial<ComWixpressContactsCoreApiV4ContactActivity>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activityDate')) {
        result.activityDate = overrides && overrides.hasOwnProperty('activityDate') ? overrides.activityDate! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('activityType')) {
        result.activityType = overrides && overrides.hasOwnProperty('activityType') ? overrides.activityType! : ComWixpressContactsCoreApiV4ContactActivityContactActivityType.ArenaNewLead;
    }
    if (pickedFields.size === 0 || pickedFields.has('date')) {
        result.date = overrides && overrides.hasOwnProperty('date') ? overrides.date! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('icon')) {
        result.icon = overrides && overrides.hasOwnProperty('icon') ? aComWixpressContactsCoreApiV4ActivityIcon(overrides.icon ?? {}, pickedFields.get('icon')) : aComWixpressContactsCoreApiV4ActivityIcon({}, pickedFields.get('icon'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactActivityInput = <T extends Partial<ComWixpressContactsCoreApiV4ContactActivityInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activityDate')) {
        result.activityDate = overrides && overrides.hasOwnProperty('activityDate') ? overrides.activityDate! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('activityType')) {
        result.activityType = overrides && overrides.hasOwnProperty('activityType') ? overrides.activityType! : ComWixpressContactsCoreApiV4ContactActivityContactActivityType.ArenaNewLead;
    }
    if (pickedFields.size === 0 || pickedFields.has('date')) {
        result.date = overrides && overrides.hasOwnProperty('date') ? overrides.date! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('icon')) {
        result.icon = overrides && overrides.hasOwnProperty('icon') ? aComWixpressContactsCoreApiV4ActivityIconInput(overrides.icon ?? {}, pickedFields.get('icon')) : aComWixpressContactsCoreApiV4ActivityIconInput({}, pickedFields.get('icon'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactAddress = <T extends Partial<ComWixpressContactsCoreApiV4ContactAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixpressContactsCoreApiV4UpstreamWixCommonAddress(overrides.address ?? {}, pickedFields.get('address')) : aComWixpressContactsCoreApiV4UpstreamWixCommonAddress({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : ComWixpressContactsCoreApiV4ContactAddressAddressTag.Billing;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactAddressInput = <T extends Partial<ComWixpressContactsCoreApiV4ContactAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixpressContactsCoreApiV4UpstreamWixCommonAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aComWixpressContactsCoreApiV4UpstreamWixCommonAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : ComWixpressContactsCoreApiV4ContactAddressAddressTag.Billing;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactAddressesWrapper = <T extends Partial<ComWixpressContactsCoreApiV4ContactAddressesWrapper>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressContactsCoreApiV4ContactAddress(x ?? {}, pickedFields.get('items'))) : [aComWixpressContactsCoreApiV4ContactAddress({}, pickedFields.get('items'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactAddressesWrapperInput = <T extends Partial<ComWixpressContactsCoreApiV4ContactAddressesWrapperInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressContactsCoreApiV4ContactAddressInput({}, pickedFields.get('items'))) : [aComWixpressContactsCoreApiV4ContactAddressInput({}, pickedFields.get('items'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactEmail = <T extends Partial<ComWixpressContactsCoreApiV4ContactEmail>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : ComWixpressContactsCoreApiV4ContactEmailEmailTag.Home;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactEmailInput = <T extends Partial<ComWixpressContactsCoreApiV4ContactEmailInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'debitis';
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : ComWixpressContactsCoreApiV4ContactEmailEmailTag.Home;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactEmailsWrapper = <T extends Partial<ComWixpressContactsCoreApiV4ContactEmailsWrapper>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressContactsCoreApiV4ContactEmail(x ?? {}, pickedFields.get('items'))) : [aComWixpressContactsCoreApiV4ContactEmail({}, pickedFields.get('items'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactEmailsWrapperInput = <T extends Partial<ComWixpressContactsCoreApiV4ContactEmailsWrapperInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressContactsCoreApiV4ContactEmailInput({}, pickedFields.get('items'))) : [aComWixpressContactsCoreApiV4ContactEmailInput({}, pickedFields.get('items'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactInfo = <T extends Partial<ComWixpressContactsCoreApiV4ContactInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addresses')) {
        result.addresses = overrides && overrides.hasOwnProperty('addresses') ? aComWixpressContactsCoreApiV4ContactAddressesWrapper(overrides.addresses ?? {}, pickedFields.get('addresses')) : aComWixpressContactsCoreApiV4ContactAddressesWrapper({}, pickedFields.get('addresses'));
    }
    if (pickedFields.size === 0 || pickedFields.has('assignedUserIds')) {
        result.assignedUserIds = overrides && overrides.hasOwnProperty('assignedUserIds') ? aComWixpressContactsCoreApiV4AssigneesWrapper(overrides.assignedUserIds ?? {}, pickedFields.get('assignedUserIds')) : aComWixpressContactsCoreApiV4AssigneesWrapper({}, pickedFields.get('assignedUserIds'));
    }
    if (pickedFields.size === 0 || pickedFields.has('birthdate')) {
        result.birthdate = overrides && overrides.hasOwnProperty('birthdate') ? overrides.birthdate! : 'repellat';
    }
    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('contactLabel')) {
        result.contactLabel = overrides && overrides.hasOwnProperty('contactLabel') ? aComWixpressContactsLabelsV4ContactLabel(overrides.contactLabel ?? {}, pickedFields.get('contactLabel')) : aComWixpressContactsLabelsV4ContactLabel({}, pickedFields.get('contactLabel'));
    }
    if (pickedFields.size === 0 || pickedFields.has('emails')) {
        result.emails = overrides && overrides.hasOwnProperty('emails') ? aComWixpressContactsCoreApiV4ContactEmailsWrapper(overrides.emails ?? {}, pickedFields.get('emails')) : aComWixpressContactsCoreApiV4ContactEmailsWrapper({}, pickedFields.get('emails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aComWixpressContactsCoreApiV4ExtendedFieldsWrapper(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aComWixpressContactsCoreApiV4ExtendedFieldsWrapper({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('jobTitle')) {
        result.jobTitle = overrides && overrides.hasOwnProperty('jobTitle') ? overrides.jobTitle! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('labelKeys')) {
        result.labelKeys = overrides && overrides.hasOwnProperty('labelKeys') ? aComWixpressContactsCoreApiV4LabelsWrapper(overrides.labelKeys ?? {}, pickedFields.get('labelKeys')) : aComWixpressContactsCoreApiV4LabelsWrapper({}, pickedFields.get('labelKeys'));
    }
    if (pickedFields.size === 0 || pickedFields.has('locale')) {
        result.locale = overrides && overrides.hasOwnProperty('locale') ? overrides.locale! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? aComWixpressContactsCoreApiV4LocationsWrapper(overrides.locations ?? {}, pickedFields.get('locations')) : aComWixpressContactsCoreApiV4LocationsWrapper({}, pickedFields.get('locations'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixpressContactsCoreApiV4ContactName(overrides.name ?? {}, pickedFields.get('name')) : aComWixpressContactsCoreApiV4ContactName({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('phones')) {
        result.phones = overrides && overrides.hasOwnProperty('phones') ? aComWixpressContactsCoreApiV4ContactPhonesWrapper(overrides.phones ?? {}, pickedFields.get('phones')) : aComWixpressContactsCoreApiV4ContactPhonesWrapper({}, pickedFields.get('phones'));
    }
    if (pickedFields.size === 0 || pickedFields.has('picture')) {
        result.picture = overrides && overrides.hasOwnProperty('picture') ? aComWixpressContactsCoreApiV4ContactPicture(overrides.picture ?? {}, pickedFields.get('picture')) : aComWixpressContactsCoreApiV4ContactPicture({}, pickedFields.get('picture'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactInfoInput = <T extends Partial<ComWixpressContactsCoreApiV4ContactInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addresses')) {
        result.addresses = overrides && overrides.hasOwnProperty('addresses') ? aComWixpressContactsCoreApiV4ContactAddressesWrapperInput(overrides.addresses ?? {}, pickedFields.get('addresses')) : aComWixpressContactsCoreApiV4ContactAddressesWrapperInput({}, pickedFields.get('addresses'));
    }
    if (pickedFields.size === 0 || pickedFields.has('assignedUserIds')) {
        result.assignedUserIds = overrides && overrides.hasOwnProperty('assignedUserIds') ? aComWixpressContactsCoreApiV4AssigneesWrapperInput(overrides.assignedUserIds ?? {}, pickedFields.get('assignedUserIds')) : aComWixpressContactsCoreApiV4AssigneesWrapperInput({}, pickedFields.get('assignedUserIds'));
    }
    if (pickedFields.size === 0 || pickedFields.has('birthdate')) {
        result.birthdate = overrides && overrides.hasOwnProperty('birthdate') ? overrides.birthdate! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('emails')) {
        result.emails = overrides && overrides.hasOwnProperty('emails') ? aComWixpressContactsCoreApiV4ContactEmailsWrapperInput(overrides.emails ?? {}, pickedFields.get('emails')) : aComWixpressContactsCoreApiV4ContactEmailsWrapperInput({}, pickedFields.get('emails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aComWixpressContactsCoreApiV4ExtendedFieldsWrapperInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aComWixpressContactsCoreApiV4ExtendedFieldsWrapperInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('jobTitle')) {
        result.jobTitle = overrides && overrides.hasOwnProperty('jobTitle') ? overrides.jobTitle! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('labelKeys')) {
        result.labelKeys = overrides && overrides.hasOwnProperty('labelKeys') ? aComWixpressContactsCoreApiV4LabelsWrapperInput(overrides.labelKeys ?? {}, pickedFields.get('labelKeys')) : aComWixpressContactsCoreApiV4LabelsWrapperInput({}, pickedFields.get('labelKeys'));
    }
    if (pickedFields.size === 0 || pickedFields.has('locale')) {
        result.locale = overrides && overrides.hasOwnProperty('locale') ? overrides.locale! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? aComWixpressContactsCoreApiV4LocationsWrapperInput(overrides.locations ?? {}, pickedFields.get('locations')) : aComWixpressContactsCoreApiV4LocationsWrapperInput({}, pickedFields.get('locations'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? aComWixpressContactsCoreApiV4ContactNameInput(overrides.name ?? {}, pickedFields.get('name')) : aComWixpressContactsCoreApiV4ContactNameInput({}, pickedFields.get('name'));
    }
    if (pickedFields.size === 0 || pickedFields.has('phones')) {
        result.phones = overrides && overrides.hasOwnProperty('phones') ? aComWixpressContactsCoreApiV4ContactPhonesWrapperInput(overrides.phones ?? {}, pickedFields.get('phones')) : aComWixpressContactsCoreApiV4ContactPhonesWrapperInput({}, pickedFields.get('phones'));
    }
    if (pickedFields.size === 0 || pickedFields.has('picture')) {
        result.picture = overrides && overrides.hasOwnProperty('picture') ? aComWixpressContactsCoreApiV4ContactPictureInput(overrides.picture ?? {}, pickedFields.get('picture')) : aComWixpressContactsCoreApiV4ContactPictureInput({}, pickedFields.get('picture'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactName = <T extends Partial<ComWixpressContactsCoreApiV4ContactName>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('first')) {
        result.first = overrides && overrides.hasOwnProperty('first') ? overrides.first! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('last')) {
        result.last = overrides && overrides.hasOwnProperty('last') ? overrides.last! : 'eveniet';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactNameInput = <T extends Partial<ComWixpressContactsCoreApiV4ContactNameInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('first')) {
        result.first = overrides && overrides.hasOwnProperty('first') ? overrides.first! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('last')) {
        result.last = overrides && overrides.hasOwnProperty('last') ? overrides.last! : 'aut';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactPhone = <T extends Partial<ComWixpressContactsCoreApiV4ContactPhone>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('countryCode')) {
        result.countryCode = overrides && overrides.hasOwnProperty('countryCode') ? overrides.countryCode! : 'commodi';
    }
    if (pickedFields.size === 0 || pickedFields.has('e164Phone')) {
        result.e164Phone = overrides && overrides.hasOwnProperty('e164Phone') ? overrides.e164Phone! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedPhone')) {
        result.formattedPhone = overrides && overrides.hasOwnProperty('formattedPhone') ? overrides.formattedPhone! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : ComWixpressContactsCoreApiV4ContactPhonePhoneTag.Fax;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactPhoneInput = <T extends Partial<ComWixpressContactsCoreApiV4ContactPhoneInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('countryCode')) {
        result.countryCode = overrides && overrides.hasOwnProperty('countryCode') ? overrides.countryCode! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('e164Phone')) {
        result.e164Phone = overrides && overrides.hasOwnProperty('e164Phone') ? overrides.e164Phone! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedPhone')) {
        result.formattedPhone = overrides && overrides.hasOwnProperty('formattedPhone') ? overrides.formattedPhone! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : ComWixpressContactsCoreApiV4ContactPhonePhoneTag.Fax;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactPhonesWrapper = <T extends Partial<ComWixpressContactsCoreApiV4ContactPhonesWrapper>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressContactsCoreApiV4ContactPhone(x ?? {}, pickedFields.get('items'))) : [aComWixpressContactsCoreApiV4ContactPhone({}, pickedFields.get('items'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactPhonesWrapperInput = <T extends Partial<ComWixpressContactsCoreApiV4ContactPhonesWrapperInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressContactsCoreApiV4ContactPhoneInput({}, pickedFields.get('items'))) : [aComWixpressContactsCoreApiV4ContactPhoneInput({}, pickedFields.get('items'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactPicture = <T extends Partial<ComWixpressContactsCoreApiV4ContactPicture>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixpressContactsCoreApiV4UpstreamWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aComWixpressContactsCoreApiV4UpstreamWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('imageProvider')) {
        result.imageProvider = overrides && overrides.hasOwnProperty('imageProvider') ? overrides.imageProvider! : ComWixpressContactsCoreApiV4ContactPictureImageProvider.External;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactPictureInput = <T extends Partial<ComWixpressContactsCoreApiV4ContactPictureInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixpressContactsCoreApiV4UpstreamWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aComWixpressContactsCoreApiV4UpstreamWixCommonImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('imageProvider')) {
        result.imageProvider = overrides && overrides.hasOwnProperty('imageProvider') ? overrides.imageProvider! : ComWixpressContactsCoreApiV4ContactPictureImageProvider.External;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactSource = <T extends Partial<ComWixpressContactsCoreApiV4ContactSource>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceType')) {
        result.sourceType = overrides && overrides.hasOwnProperty('sourceType') ? overrides.sourceType! : ComWixpressContactsCoreApiV4ContactSourceContactSourceType.Admin;
    }
    if (pickedFields.size === 0 || pickedFields.has('wixAppId')) {
        result.wixAppId = overrides && overrides.hasOwnProperty('wixAppId') ? overrides.wixAppId! : 'cupiditate';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ContactsFacet = <T extends Partial<ComWixpressContactsCoreApiV4ContactsFacet>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3633;
    }
    if (pickedFields.size === 0 || pickedFields.has('facetDisplayName')) {
        result.facetDisplayName = overrides && overrides.hasOwnProperty('facetDisplayName') ? overrides.facetDisplayName! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('facetKey')) {
        result.facetKey = overrides && overrides.hasOwnProperty('facetKey') ? overrides.facetKey! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('facetType')) {
        result.facetType = overrides && overrides.hasOwnProperty('facetType') ? overrides.facetType! : ComWixpressContactsCoreApiV4ContactsFacetContactsFacetType.AllContacts;
    }
    if (pickedFields.size === 0 || pickedFields.has('legacyId')) {
        result.legacyId = overrides && overrides.hasOwnProperty('legacyId') ? overrides.legacyId! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespaceDisplayName')) {
        result.namespaceDisplayName = overrides && overrides.hasOwnProperty('namespaceDisplayName') ? overrides.namespaceDisplayName! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('queryFilter')) {
        result.queryFilter = overrides && overrides.hasOwnProperty('queryFilter') ? overrides.queryFilter! : 'facilis';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4CountContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4CountContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 8692;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4CreateContactRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4CreateContactRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowDuplicates')) {
        result.allowDuplicates = overrides && overrides.hasOwnProperty('allowDuplicates') ? overrides.allowDuplicates! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('info')) {
        result.info = overrides && overrides.hasOwnProperty('info') ? aComWixpressContactsCoreApiV4ContactInfoInput(overrides.info ?? {}, pickedFields.get('info')) : aComWixpressContactsCoreApiV4ContactInfoInput({}, pickedFields.get('info'));
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'et';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4CreateContactResponse = <T extends Partial<ComWixpressContactsCoreApiV4CreateContactResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4DeleteContactRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4DeleteContactRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('deleteMember')) {
        result.deleteMember = overrides && overrides.hasOwnProperty('deleteMember') ? overrides.deleteMember! : false;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ExtendedFieldsWrapper = <T extends Partial<ComWixpressContactsCoreApiV4ExtendedFieldsWrapper>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items! : 'consequuntur';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ExtendedFieldsWrapperInput = <T extends Partial<ComWixpressContactsCoreApiV4ExtendedFieldsWrapperInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items! : 'ipsum';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4GeneratePictureUploadUrlRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4GeneratePictureUploadUrlRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('mimeType')) {
        result.mimeType = overrides && overrides.hasOwnProperty('mimeType') ? overrides.mimeType! : 'aspernatur';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4GeneratePictureUploadUrlResponse = <T extends Partial<ComWixpressContactsCoreApiV4GeneratePictureUploadUrlResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('uploadId')) {
        result.uploadId = overrides && overrides.hasOwnProperty('uploadId') ? overrides.uploadId! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('uploadUrl')) {
        result.uploadUrl = overrides && overrides.hasOwnProperty('uploadUrl') ? overrides.uploadUrl! : 'modi';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4GetContactRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4GetContactRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['voluptate'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressContactsCoreApiV4ContactFieldSet.Basic];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0ae5d127-5e1e-461e-9dd5-e9c34dbef37d';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'tenetur';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4GroupInfo = <T extends Partial<ComWixpressContactsCoreApiV4GroupInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('groupIds')) {
        result.groupIds = overrides && overrides.hasOwnProperty('groupIds') ? overrides.groupIds! : ['rerum'];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4LabelAndUnlabelContactRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4LabelAndUnlabelContactRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('labelKeysToAdd')) {
        result.labelKeysToAdd = overrides && overrides.hasOwnProperty('labelKeysToAdd') ? overrides.labelKeysToAdd! : ['a'];
    }
    if (pickedFields.size === 0 || pickedFields.has('labelKeysToRemove')) {
        result.labelKeysToRemove = overrides && overrides.hasOwnProperty('labelKeysToRemove') ? overrides.labelKeysToRemove! : ['non'];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'dolores';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4LabelAndUnlabelContactResponse = <T extends Partial<ComWixpressContactsCoreApiV4LabelAndUnlabelContactResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4LabelContactRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4LabelContactRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('labelKeys')) {
        result.labelKeys = overrides && overrides.hasOwnProperty('labelKeys') ? overrides.labelKeys! : ['qui'];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'aliquid';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4LabelContactResponse = <T extends Partial<ComWixpressContactsCoreApiV4LabelContactResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4LabelsWrapper = <T extends Partial<ComWixpressContactsCoreApiV4LabelsWrapper>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items! : ['omnis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('labels')) {
        result.labels = overrides && overrides.hasOwnProperty('labels') ? aComWixpressContactsLabelsV4QueryLabelsResponse(overrides.labels ?? {}, pickedFields.get('labels')) : aComWixpressContactsLabelsV4QueryLabelsResponse({}, pickedFields.get('labels'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4LabelsWrapperInput = <T extends Partial<ComWixpressContactsCoreApiV4LabelsWrapperInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items! : ['magni'];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ListContactIdsBySegmentRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4ListContactIdsBySegmentRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('segmentId')) {
        result.segmentId = overrides && overrides.hasOwnProperty('segmentId') ? overrides.segmentId! : 'eaque';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ListContactIdsBySegmentResponse = <T extends Partial<ComWixpressContactsCoreApiV4ListContactIdsBySegmentResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactIds')) {
        result.contactIds = overrides && overrides.hasOwnProperty('contactIds') ? overrides.contactIds! : ['odio'];
    }
    if (pickedFields.size === 0 || pickedFields.has('contacts')) {
        result.contacts = overrides && overrides.hasOwnProperty('contacts') ? aComWixpressContactsCoreApiV4QueryContactsResponse(overrides.contacts ?? {}, pickedFields.get('contacts')) : aComWixpressContactsCoreApiV4QueryContactsResponse({}, pickedFields.get('contacts'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPagingMetadata')) {
        result.cursorPagingMetadata = overrides && overrides.hasOwnProperty('cursorPagingMetadata') ? aComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata(overrides.cursorPagingMetadata ?? {}, pickedFields.get('cursorPagingMetadata')) : aComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('cursorPagingMetadata'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ListContactsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4ListContactsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['quis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressContactsCoreApiV4ContactFieldSet.Basic];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? aComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput(overrides.sort ?? {}, pickedFields.get('sort')) : aComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput({}, pickedFields.get('sort'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ListContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4ListContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contacts')) {
        result.contacts = overrides && overrides.hasOwnProperty('contacts') ? overrides.contacts!.map((x) => aComWixpressContactsCoreApiV4Contact(x ?? {}, pickedFields.get('contacts'))) : [aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contacts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ListFacetsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4ListFacetsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('omitCount')) {
        result.omitCount = overrides && overrides.hasOwnProperty('omitCount') ? overrides.omitCount! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ListFacetsResponse = <T extends Partial<ComWixpressContactsCoreApiV4ListFacetsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('facets')) {
        result.facets = overrides && overrides.hasOwnProperty('facets') ? overrides.facets!.map((x) => aComWixpressContactsCoreApiV4ContactsFacet(x ?? {}, pickedFields.get('facets'))) : [aComWixpressContactsCoreApiV4ContactsFacet({}, pickedFields.get('facets'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4LocationsWrapper = <T extends Partial<ComWixpressContactsCoreApiV4LocationsWrapper>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items! : ['quos'];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4LocationsWrapperInput = <T extends Partial<ComWixpressContactsCoreApiV4LocationsWrapperInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items! : ['a'];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4MemberInfo = <T extends Partial<ComWixpressContactsCoreApiV4MemberInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('emailVerificationRequired')) {
        result.emailVerificationRequired = overrides && overrides.hasOwnProperty('emailVerificationRequired') ? overrides.emailVerificationRequired! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('emailVerified')) {
        result.emailVerified = overrides && overrides.hasOwnProperty('emailVerified') ? overrides.emailVerified! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('groupInfo')) {
        result.groupInfo = overrides && overrides.hasOwnProperty('groupInfo') ? aComWixpressContactsCoreApiV4GroupInfo(overrides.groupInfo ?? {}, pickedFields.get('groupInfo')) : aComWixpressContactsCoreApiV4GroupInfo({}, pickedFields.get('groupInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('profileInfo')) {
        result.profileInfo = overrides && overrides.hasOwnProperty('profileInfo') ? aComWixpressContactsCoreApiV4ProfileInfo(overrides.profileInfo ?? {}, pickedFields.get('profileInfo')) : aComWixpressContactsCoreApiV4ProfileInfo({}, pickedFields.get('profileInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionInfo')) {
        result.sessionInfo = overrides && overrides.hasOwnProperty('sessionInfo') ? aComWixpressContactsCoreApiV4SessionInfo(overrides.sessionInfo ?? {}, pickedFields.get('sessionInfo')) : aComWixpressContactsCoreApiV4SessionInfo({}, pickedFields.get('sessionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('signupDate')) {
        result.signupDate = overrides && overrides.hasOwnProperty('signupDate') ? overrides.signupDate! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressContactsCoreApiV4MemberInfoMemberStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('userInfo')) {
        result.userInfo = overrides && overrides.hasOwnProperty('userInfo') ? aComWixpressContactsCoreApiV4UserInfo(overrides.userInfo ?? {}, pickedFields.get('userInfo')) : aComWixpressContactsCoreApiV4UserInfo({}, pickedFields.get('userInfo'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4MergeContactsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4MergeContactsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceContactIds')) {
        result.sourceContactIds = overrides && overrides.hasOwnProperty('sourceContactIds') ? overrides.sourceContactIds! : ['est'];
    }
    if (pickedFields.size === 0 || pickedFields.has('targetContactId')) {
        result.targetContactId = overrides && overrides.hasOwnProperty('targetContactId') ? overrides.targetContactId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('targetContactRevision')) {
        result.targetContactRevision = overrides && overrides.hasOwnProperty('targetContactRevision') ? overrides.targetContactRevision! : 6976;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4MergeContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4MergeContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4PreviewMergeContactsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4PreviewMergeContactsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceContactIds')) {
        result.sourceContactIds = overrides && overrides.hasOwnProperty('sourceContactIds') ? overrides.sourceContactIds! : ['totam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('targetContactId')) {
        result.targetContactId = overrides && overrides.hasOwnProperty('targetContactId') ? overrides.targetContactId! : 'quia';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4PreviewMergeContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4PreviewMergeContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4PrimaryContactInfo = <T extends Partial<ComWixpressContactsCoreApiV4PrimaryContactInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'ducimus';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4PrimaryEmail = <T extends Partial<ComWixpressContactsCoreApiV4PrimaryEmail>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deliverabilityStatus')) {
        result.deliverabilityStatus = overrides && overrides.hasOwnProperty('deliverabilityStatus') ? overrides.deliverabilityStatus! : ComWixpressContactsCoreApiV4PrimaryEmailEmailDeliverabilityStatus.Bounced;
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionStatus')) {
        result.subscriptionStatus = overrides && overrides.hasOwnProperty('subscriptionStatus') ? overrides.subscriptionStatus! : ComWixpressContactsCoreApiV4SubscriptionStatus.NotSet;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4PrimaryPhone = <T extends Partial<ComWixpressContactsCoreApiV4PrimaryPhone>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('countryCode')) {
        result.countryCode = overrides && overrides.hasOwnProperty('countryCode') ? overrides.countryCode! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('deliverabilityStatus')) {
        result.deliverabilityStatus = overrides && overrides.hasOwnProperty('deliverabilityStatus') ? overrides.deliverabilityStatus! : ComWixpressContactsCoreApiV4PrimaryPhonePhoneDeliverabilityStatus.NotSet;
    }
    if (pickedFields.size === 0 || pickedFields.has('e164Phone')) {
        result.e164Phone = overrides && overrides.hasOwnProperty('e164Phone') ? overrides.e164Phone! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedPhone')) {
        result.formattedPhone = overrides && overrides.hasOwnProperty('formattedPhone') ? overrides.formattedPhone! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionStatus')) {
        result.subscriptionStatus = overrides && overrides.hasOwnProperty('subscriptionStatus') ? overrides.subscriptionStatus! : ComWixpressContactsCoreApiV4SubscriptionStatus.NotSet;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4ProfileInfo = <T extends Partial<ComWixpressContactsCoreApiV4ProfileInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('muted')) {
        result.muted = overrides && overrides.hasOwnProperty('muted') ? overrides.muted! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('nickname')) {
        result.nickname = overrides && overrides.hasOwnProperty('nickname') ? overrides.nickname! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('photo')) {
        result.photo = overrides && overrides.hasOwnProperty('photo') ? aComWixpressContactsCoreApiV4UpstreamWixCommonImage(overrides.photo ?? {}, pickedFields.get('photo')) : aComWixpressContactsCoreApiV4UpstreamWixCommonImage({}, pickedFields.get('photo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('privacyStatus')) {
        result.privacyStatus = overrides && overrides.hasOwnProperty('privacyStatus') ? overrides.privacyStatus! : ComWixpressContactsCoreApiV4ProfileInfoPrivacyStatus.Private;
    }
    if (pickedFields.size === 0 || pickedFields.has('reported')) {
        result.reported = overrides && overrides.hasOwnProperty('reported') ? overrides.reported! : true;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4QueryContactsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4QueryContactsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('omitTotal')) {
        result.omitTotal = overrides && overrides.hasOwnProperty('omitTotal') ? overrides.omitTotal! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressContactsCoreApiV4UpstreamWixQueryQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressContactsCoreApiV4UpstreamWixQueryQueryInput({}, pickedFields.get('query'));
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? overrides.search! : 'deserunt';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4QueryContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4QueryContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressContactsCoreApiV4Contact(x ?? {}, pickedFields.get('items'))) : [aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4QueryFacetsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4QueryFacetsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('omitCount')) {
        result.omitCount = overrides && overrides.hasOwnProperty('omitCount') ? overrides.omitCount! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4QueryFacetsResponse = <T extends Partial<ComWixpressContactsCoreApiV4QueryFacetsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('facets')) {
        result.facets = overrides && overrides.hasOwnProperty('facets') ? overrides.facets!.map((x) => aComWixpressContactsCoreApiV4ContactsFacet(x ?? {}, pickedFields.get('facets'))) : [aComWixpressContactsCoreApiV4ContactsFacet({}, pickedFields.get('facets'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4SearchContactsRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4SearchContactsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aComWixpressContactsCoreApiV4UpstreamWixQuerySearchInput(overrides.search ?? {}, pickedFields.get('search')) : aComWixpressContactsCoreApiV4UpstreamWixQuerySearchInput({}, pickedFields.get('search'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4SearchContactsResponse = <T extends Partial<ComWixpressContactsCoreApiV4SearchContactsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contacts')) {
        result.contacts = overrides && overrides.hasOwnProperty('contacts') ? overrides.contacts!.map((x) => aComWixpressContactsCoreApiV4Contact(x ?? {}, pickedFields.get('contacts'))) : [aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contacts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPagingMetadata')) {
        result.cursorPagingMetadata = overrides && overrides.hasOwnProperty('cursorPagingMetadata') ? aComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata(overrides.cursorPagingMetadata ?? {}, pickedFields.get('cursorPagingMetadata')) : aComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('cursorPagingMetadata'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4SegmentsWrapper = <T extends Partial<ComWixpressContactsCoreApiV4SegmentsWrapper>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items! : ['repellat'];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4SessionInfo = <T extends Partial<ComWixpressContactsCoreApiV4SessionInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lastMobileLogin')) {
        result.lastMobileLogin = overrides && overrides.hasOwnProperty('lastMobileLogin') ? overrides.lastMobileLogin! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastWebLogin')) {
        result.lastWebLogin = overrides && overrides.hasOwnProperty('lastWebLogin') ? overrides.lastWebLogin! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('mobileAppNames')) {
        result.mobileAppNames = overrides && overrides.hasOwnProperty('mobileAppNames') ? overrides.mobileAppNames! : ['et'];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4SyncSubmitContactRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4SyncSubmitContactRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activity')) {
        result.activity = overrides && overrides.hasOwnProperty('activity') ? aComWixpressContactsCoreApiV4ContactActivityInput(overrides.activity ?? {}, pickedFields.get('activity')) : aComWixpressContactsCoreApiV4ContactActivityInput({}, pickedFields.get('activity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('contactInfo')) {
        result.contactInfo = overrides && overrides.hasOwnProperty('contactInfo') ? aComWixpressContactsCoreApiV4ContactInfoInput(overrides.contactInfo ?? {}, pickedFields.get('contactInfo')) : aComWixpressContactsCoreApiV4ContactInfoInput({}, pickedFields.get('contactInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hideFromContactList')) {
        result.hideFromContactList = overrides && overrides.hasOwnProperty('hideFromContactList') ? overrides.hideFromContactList! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('passThroughData')) {
        result.passThroughData = overrides && overrides.hasOwnProperty('passThroughData') ? overrides.passThroughData! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceId')) {
        result.sourceId = overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceType')) {
        result.sourceType = overrides && overrides.hasOwnProperty('sourceType') ? overrides.sourceType! : ComWixpressContactsCoreApiV4ContactSourceContactSourceType.Admin;
    }
    if (pickedFields.size === 0 || pickedFields.has('submitOperation')) {
        result.submitOperation = overrides && overrides.hasOwnProperty('submitOperation') ? overrides.submitOperation! : ComWixpressContactsCoreApiV4SyncSubmitContactRequestSubmitOperation.Create;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UnlabelContactRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4UnlabelContactRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('labelKeys')) {
        result.labelKeys = overrides && overrides.hasOwnProperty('labelKeys') ? overrides.labelKeys! : ['excepturi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'hic';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UnlabelContactResponse = <T extends Partial<ComWixpressContactsCoreApiV4UnlabelContactResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpdateContactRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4UpdateContactRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowDuplicates')) {
        result.allowDuplicates = overrides && overrides.hasOwnProperty('allowDuplicates') ? overrides.allowDuplicates! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'cupiditate';
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['saepe'];
    }
    if (pickedFields.size === 0 || pickedFields.has('info')) {
        result.info = overrides && overrides.hasOwnProperty('info') ? aComWixpressContactsCoreApiV4ContactInfoInput(overrides.info ?? {}, pickedFields.get('info')) : aComWixpressContactsCoreApiV4ContactInfoInput({}, pickedFields.get('info'));
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 5330;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpdateContactResponse = <T extends Partial<ComWixpressContactsCoreApiV4UpdateContactResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpsertContactRequestInput = <T extends Partial<ComWixpressContactsCoreApiV4UpsertContactRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('info')) {
        result.info = overrides && overrides.hasOwnProperty('info') ? aComWixpressContactsCoreApiV4ContactInfoInput(overrides.info ?? {}, pickedFields.get('info')) : aComWixpressContactsCoreApiV4ContactInfoInput({}, pickedFields.get('info'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpsertContactResponse = <T extends Partial<ComWixpressContactsCoreApiV4UpsertContactResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('action')) {
        result.action = overrides && overrides.hasOwnProperty('action') ? overrides.action! : ComWixpressContactsCoreApiV4UpsertContactResponseAction.Created;
    }
    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonAddress = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocation(overrides.geocode ?? {}, pickedFields.get('geocode')) : aComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocation({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aComWixpressContactsCoreApiV4UpstreamWixCommonSubdivision(x ?? {}, pickedFields.get('subdivisions'))) : [aComWixpressContactsCoreApiV4UpstreamWixCommonSubdivision({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonAddressInput = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocationInput(overrides.geocode ?? {}, pickedFields.get('geocode')) : aComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocationInput({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))) : [aComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocation = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 4.36;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 2.35;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocationInput = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 6.38;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 1.86;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3771;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 2927;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aComWixpressContactsCoreApiV4UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aComWixpressContactsCoreApiV4UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonCursors = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'eligendi';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonImage = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 1154;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 4451;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonImageInput = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 8678;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 3817;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1605;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 3671;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 6895;
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 7948;
    }
    if (pickedFields.size === 0 || pickedFields.has('tooManyToCount')) {
        result.tooManyToCount = overrides && overrides.hasOwnProperty('tooManyToCount') ? overrides.tooManyToCount! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 8396;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : ComWixpressContactsCoreApiV4UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddress = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddressLine')) {
        result.formattedAddressLine = overrides && overrides.hasOwnProperty('formattedAddressLine') ? overrides.formattedAddressLine! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'nisi';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddressInput = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddressLine')) {
        result.formattedAddressLine = overrides && overrides.hasOwnProperty('formattedAddressLine') ? overrides.formattedAddressLine! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'ipsam';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonSubdivision = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivision>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionSubdivisionType.AdministrativeAreaLevel_1;
    }
    if (pickedFields.size === 0 || pickedFields.has('typeInfo')) {
        result.typeInfo = overrides && overrides.hasOwnProperty('typeInfo') ? overrides.typeInfo! : 'consequatur';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionInput = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionSubdivisionType.AdministrativeAreaLevel_1;
    }
    if (pickedFields.size === 0 || pickedFields.has('typeInfo')) {
        result.typeInfo = overrides && overrides.hasOwnProperty('typeInfo') ? overrides.typeInfo! : 'velit';
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixQueryQueryInput = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixQueryQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['sit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressContactsCoreApiV4ContactFieldSet.Basic];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsInput = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['est'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fuzzy')) {
        result.fuzzy = overrides && overrides.hasOwnProperty('fuzzy') ? overrides.fuzzy! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('mode')) {
        result.mode = overrides && overrides.hasOwnProperty('mode') ? overrides.mode! : ComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsMode.And;
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UpstreamWixQuerySearchInput = <T extends Partial<ComWixpressContactsCoreApiV4UpstreamWixQuerySearchInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['inventore'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['tempora'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsInput(overrides.search ?? {}, pickedFields.get('search')) : aComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsInput({}, pickedFields.get('search'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressContactsCoreApiV4UserInfo = <T extends Partial<ComWixpressContactsCoreApiV4UserInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('role')) {
        result.role = overrides && overrides.hasOwnProperty('role') ? overrides.role! : ComWixpressContactsCoreApiV4UserInfoRole.Contributor;
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'aut';
    }

    return result;
};

export const aComWixpressContactsFieldsV4DeleteExtendedFieldRequestInput = <T extends Partial<ComWixpressContactsFieldsV4DeleteExtendedFieldRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'vel';
    }

    return result;
};

export const aComWixpressContactsFieldsV4ExtendedField = <T extends Partial<ComWixpressContactsFieldsV4ExtendedField>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataType')) {
        result.dataType = overrides && overrides.hasOwnProperty('dataType') ? overrides.dataType! : ComWixpressContactsFieldsV4ExtendedFieldFieldDataType.Date;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('displayName')) {
        result.displayName = overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldType')) {
        result.fieldType = overrides && overrides.hasOwnProperty('fieldType') ? overrides.fieldType! : ComWixpressContactsFieldsV4ExtendedFieldFieldType.System;
    }
    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('legacyId')) {
        result.legacyId = overrides && overrides.hasOwnProperty('legacyId') ? overrides.legacyId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('schemaFieldId')) {
        result.schemaFieldId = overrides && overrides.hasOwnProperty('schemaFieldId') ? overrides.schemaFieldId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixSearchColumn')) {
        result.wixSearchColumn = overrides && overrides.hasOwnProperty('wixSearchColumn') ? overrides.wixSearchColumn! : 'dolores';
    }

    return result;
};

export const aComWixpressContactsFieldsV4ExtendedFieldInput = <T extends Partial<ComWixpressContactsFieldsV4ExtendedFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('dataType')) {
        result.dataType = overrides && overrides.hasOwnProperty('dataType') ? overrides.dataType! : ComWixpressContactsFieldsV4ExtendedFieldFieldDataType.Date;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('displayName')) {
        result.displayName = overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldType')) {
        result.fieldType = overrides && overrides.hasOwnProperty('fieldType') ? overrides.fieldType! : ComWixpressContactsFieldsV4ExtendedFieldFieldType.System;
    }
    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('legacyId')) {
        result.legacyId = overrides && overrides.hasOwnProperty('legacyId') ? overrides.legacyId! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('schemaFieldId')) {
        result.schemaFieldId = overrides && overrides.hasOwnProperty('schemaFieldId') ? overrides.schemaFieldId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixSearchColumn')) {
        result.wixSearchColumn = overrides && overrides.hasOwnProperty('wixSearchColumn') ? overrides.wixSearchColumn! : 'doloremque';
    }

    return result;
};

export const aComWixpressContactsFieldsV4FindOrCreateExtendedFieldRequestInput = <T extends Partial<ComWixpressContactsFieldsV4FindOrCreateExtendedFieldRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataType')) {
        result.dataType = overrides && overrides.hasOwnProperty('dataType') ? overrides.dataType! : ComWixpressContactsFieldsV4ExtendedFieldFieldDataType.Date;
    }
    if (pickedFields.size === 0 || pickedFields.has('displayName')) {
        result.displayName = overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'tempora';
    }

    return result;
};

export const aComWixpressContactsFieldsV4FindOrCreateExtendedFieldResponse = <T extends Partial<ComWixpressContactsFieldsV4FindOrCreateExtendedFieldResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('field')) {
        result.field = overrides && overrides.hasOwnProperty('field') ? aComWixpressContactsFieldsV4ExtendedField(overrides.field ?? {}, pickedFields.get('field')) : aComWixpressContactsFieldsV4ExtendedField({}, pickedFields.get('field'));
    }
    if (pickedFields.size === 0 || pickedFields.has('newField')) {
        result.newField = overrides && overrides.hasOwnProperty('newField') ? overrides.newField! : true;
    }

    return result;
};

export const aComWixpressContactsFieldsV4GdprListRequestInput = <T extends Partial<ComWixpressContactsFieldsV4GdprListRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'consectetur';
    }

    return result;
};

export const aComWixpressContactsFieldsV4GdprListResponse = <T extends Partial<ComWixpressContactsFieldsV4GdprListResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields!.map((x) => aComWixpressContactsFieldsV4ExtendedField(x ?? {}, pickedFields.get('fields'))) : [aComWixpressContactsFieldsV4ExtendedField({}, pickedFields.get('fields'))];
    }

    return result;
};

export const aComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdRequestInput = <T extends Partial<ComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('legacyId')) {
        result.legacyId = overrides && overrides.hasOwnProperty('legacyId') ? overrides.legacyId! : 'aspernatur';
    }

    return result;
};

export const aComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdResponse = <T extends Partial<ComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('field')) {
        result.field = overrides && overrides.hasOwnProperty('field') ? aComWixpressContactsFieldsV4ExtendedField(overrides.field ?? {}, pickedFields.get('field')) : aComWixpressContactsFieldsV4ExtendedField({}, pickedFields.get('field'));
    }

    return result;
};

export const aComWixpressContactsFieldsV4GetExtendedFieldRequestInput = <T extends Partial<ComWixpressContactsFieldsV4GetExtendedFieldRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '22ffebd3-ea47-4c48-98ee-e40c51c8f348';
    }

    return result;
};

export const aComWixpressContactsFieldsV4ListExtendedFieldsRequestInput = <T extends Partial<ComWixpressContactsFieldsV4ListExtendedFieldsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldType')) {
        result.fieldType = overrides && overrides.hasOwnProperty('fieldType') ? overrides.fieldType! : ComWixpressContactsFieldsV4ExtendedFieldFieldType.System;
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressContactsFieldsV4UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressContactsFieldsV4UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? aComWixpressContactsFieldsV4UpstreamWixCommonSortingInput(overrides.sort ?? {}, pickedFields.get('sort')) : aComWixpressContactsFieldsV4UpstreamWixCommonSortingInput({}, pickedFields.get('sort'));
    }
    if (pickedFields.size === 0 || pickedFields.has('startsWith')) {
        result.startsWith = overrides && overrides.hasOwnProperty('startsWith') ? overrides.startsWith! : 'laborum';
    }

    return result;
};

export const aComWixpressContactsFieldsV4ListExtendedFieldsResponse = <T extends Partial<ComWixpressContactsFieldsV4ListExtendedFieldsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields!.map((x) => aComWixpressContactsFieldsV4ExtendedField(x ?? {}, pickedFields.get('fields'))) : [aComWixpressContactsFieldsV4ExtendedField({}, pickedFields.get('fields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aComWixpressContactsFieldsV4UpstreamWixCommonPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aComWixpressContactsFieldsV4UpstreamWixCommonPagingMetadata({}, pickedFields.get('metadata'));
    }

    return result;
};

export const aComWixpressContactsFieldsV4PurgeRequestInput = <T extends Partial<ComWixpressContactsFieldsV4PurgeRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'sed';
    }

    return result;
};

export const aComWixpressContactsFieldsV4PurgeResponse = <T extends Partial<ComWixpressContactsFieldsV4PurgeResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deletedItems')) {
        result.deletedItems = overrides && overrides.hasOwnProperty('deletedItems') ? overrides.deletedItems! : 5655;
    }

    return result;
};

export const aComWixpressContactsFieldsV4QueryExtendedFieldsRequestInput = <T extends Partial<ComWixpressContactsFieldsV4QueryExtendedFieldsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressContactsFieldsV4UpstreamWixQueryQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressContactsFieldsV4UpstreamWixQueryQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressContactsFieldsV4QueryExtendedFieldsResponse = <T extends Partial<ComWixpressContactsFieldsV4QueryExtendedFieldsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressContactsFieldsV4ExtendedField(x ?? {}, pickedFields.get('items'))) : [aComWixpressContactsFieldsV4ExtendedField({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressContactsFieldsV4UpdateExtendedFieldRequestInput = <T extends Partial<ComWixpressContactsFieldsV4UpdateExtendedFieldRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('field')) {
        result.field = overrides && overrides.hasOwnProperty('field') ? aComWixpressContactsFieldsV4ExtendedFieldInput(overrides.field ?? {}, pickedFields.get('field')) : aComWixpressContactsFieldsV4ExtendedFieldInput({}, pickedFields.get('field'));
    }

    return result;
};

export const aComWixpressContactsFieldsV4UpdateExtendedFieldResponse = <T extends Partial<ComWixpressContactsFieldsV4UpdateExtendedFieldResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('field')) {
        result.field = overrides && overrides.hasOwnProperty('field') ? aComWixpressContactsFieldsV4ExtendedField(overrides.field ?? {}, pickedFields.get('field')) : aComWixpressContactsFieldsV4ExtendedField({}, pickedFields.get('field'));
    }

    return result;
};

export const aComWixpressContactsFieldsV4UpstreamWixCommonPagingInput = <T extends Partial<ComWixpressContactsFieldsV4UpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3257;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 6426;
    }

    return result;
};

export const aComWixpressContactsFieldsV4UpstreamWixCommonPagingMetadata = <T extends Partial<ComWixpressContactsFieldsV4UpstreamWixCommonPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3597;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 2007;
    }
    if (pickedFields.size === 0 || pickedFields.has('tooManyToCount')) {
        result.tooManyToCount = overrides && overrides.hasOwnProperty('tooManyToCount') ? overrides.tooManyToCount! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 8232;
    }

    return result;
};

export const aComWixpressContactsFieldsV4UpstreamWixCommonSortingInput = <T extends Partial<ComWixpressContactsFieldsV4UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : ComWixpressContactsFieldsV4UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aComWixpressContactsFieldsV4UpstreamWixQueryQueryInput = <T extends Partial<ComWixpressContactsFieldsV4UpstreamWixQueryQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressContactsFieldsV4UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressContactsFieldsV4UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixpressContactsFieldsV4UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixpressContactsFieldsV4UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressContactsLabelsV4ContactLabel = <T extends Partial<ComWixpressContactsLabelsV4ContactLabel>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'sequi';
    }
    if (pickedFields.size === 0 || pickedFields.has('displayName')) {
        result.displayName = overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'repudiandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('labelType')) {
        result.labelType = overrides && overrides.hasOwnProperty('labelType') ? overrides.labelType! : ComWixpressContactsLabelsV4ContactLabelLabelType.System;
    }
    if (pickedFields.size === 0 || pickedFields.has('legacyId')) {
        result.legacyId = overrides && overrides.hasOwnProperty('legacyId') ? overrides.legacyId! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespaceDisplayName')) {
        result.namespaceDisplayName = overrides && overrides.hasOwnProperty('namespaceDisplayName') ? overrides.namespaceDisplayName! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('tagId')) {
        result.tagId = overrides && overrides.hasOwnProperty('tagId') ? overrides.tagId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'amet';
    }

    return result;
};

export const aComWixpressContactsLabelsV4ContactLabelInput = <T extends Partial<ComWixpressContactsLabelsV4ContactLabelInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('displayName')) {
        result.displayName = overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('labelType')) {
        result.labelType = overrides && overrides.hasOwnProperty('labelType') ? overrides.labelType! : ComWixpressContactsLabelsV4ContactLabelLabelType.System;
    }
    if (pickedFields.size === 0 || pickedFields.has('legacyId')) {
        result.legacyId = overrides && overrides.hasOwnProperty('legacyId') ? overrides.legacyId! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespaceDisplayName')) {
        result.namespaceDisplayName = overrides && overrides.hasOwnProperty('namespaceDisplayName') ? overrides.namespaceDisplayName! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('tagId')) {
        result.tagId = overrides && overrides.hasOwnProperty('tagId') ? overrides.tagId! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'non';
    }

    return result;
};

export const aComWixpressContactsLabelsV4ContactLabelNamespace = <T extends Partial<ComWixpressContactsLabelsV4ContactLabelNamespace>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayName')) {
        result.displayName = overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'amet';
    }

    return result;
};

export const aComWixpressContactsLabelsV4DeleteLabelRequestInput = <T extends Partial<ComWixpressContactsLabelsV4DeleteLabelRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'voluptate';
    }

    return result;
};

export const aComWixpressContactsLabelsV4FindOrCreateLabelRequestInput = <T extends Partial<ComWixpressContactsLabelsV4FindOrCreateLabelRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayName')) {
        result.displayName = overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('labelType')) {
        result.labelType = overrides && overrides.hasOwnProperty('labelType') ? overrides.labelType! : ComWixpressContactsLabelsV4ContactLabelLabelType.System;
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'non';
    }

    return result;
};

export const aComWixpressContactsLabelsV4FindOrCreateLabelResponse = <T extends Partial<ComWixpressContactsLabelsV4FindOrCreateLabelResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixpressContactsLabelsV4ContactLabel(overrides.label ?? {}, pickedFields.get('label')) : aComWixpressContactsLabelsV4ContactLabel({}, pickedFields.get('label'));
    }
    if (pickedFields.size === 0 || pickedFields.has('newLabel')) {
        result.newLabel = overrides && overrides.hasOwnProperty('newLabel') ? overrides.newLabel! : true;
    }

    return result;
};

export const aComWixpressContactsLabelsV4GdprListRequestInput = <T extends Partial<ComWixpressContactsLabelsV4GdprListRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'minima';
    }

    return result;
};

export const aComWixpressContactsLabelsV4GdprListResponse = <T extends Partial<ComWixpressContactsLabelsV4GdprListResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('labels')) {
        result.labels = overrides && overrides.hasOwnProperty('labels') ? overrides.labels!.map((x) => aComWixpressContactsLabelsV4ContactLabel(x ?? {}, pickedFields.get('labels'))) : [aComWixpressContactsLabelsV4ContactLabel({}, pickedFields.get('labels'))];
    }

    return result;
};

export const aComWixpressContactsLabelsV4GetContactLabelRequestInput = <T extends Partial<ComWixpressContactsLabelsV4GetContactLabelRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '81626cef-5758-4761-b2e6-75e08270d98e';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'tenetur';
    }

    return result;
};

export const aComWixpressContactsLabelsV4GetLabelByLegacyIdRequestInput = <T extends Partial<ComWixpressContactsLabelsV4GetLabelByLegacyIdRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('legacyId')) {
        result.legacyId = overrides && overrides.hasOwnProperty('legacyId') ? overrides.legacyId! : 'quibusdam';
    }

    return result;
};

export const aComWixpressContactsLabelsV4GetLabelByLegacyIdResponse = <T extends Partial<ComWixpressContactsLabelsV4GetLabelByLegacyIdResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixpressContactsLabelsV4ContactLabel(overrides.label ?? {}, pickedFields.get('label')) : aComWixpressContactsLabelsV4ContactLabel({}, pickedFields.get('label'));
    }

    return result;
};

export const aComWixpressContactsLabelsV4ListLabelNamespacesRequestInput = <T extends Partial<ComWixpressContactsLabelsV4ListLabelNamespacesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'deleniti';
    }

    return result;
};

export const aComWixpressContactsLabelsV4ListLabelNamespacesResponse = <T extends Partial<ComWixpressContactsLabelsV4ListLabelNamespacesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('namespaces')) {
        result.namespaces = overrides && overrides.hasOwnProperty('namespaces') ? overrides.namespaces!.map((x) => aComWixpressContactsLabelsV4ContactLabelNamespace(x ?? {}, pickedFields.get('namespaces'))) : [aComWixpressContactsLabelsV4ContactLabelNamespace({}, pickedFields.get('namespaces'))];
    }

    return result;
};

export const aComWixpressContactsLabelsV4ListLabelsRequestInput = <T extends Partial<ComWixpressContactsLabelsV4ListLabelsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('labelType')) {
        result.labelType = overrides && overrides.hasOwnProperty('labelType') ? overrides.labelType! : ComWixpressContactsLabelsV4ContactLabelLabelType.System;
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressContactsLabelsV4UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressContactsLabelsV4UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? aComWixpressContactsLabelsV4UpstreamWixCommonSortingInput(overrides.sort ?? {}, pickedFields.get('sort')) : aComWixpressContactsLabelsV4UpstreamWixCommonSortingInput({}, pickedFields.get('sort'));
    }
    if (pickedFields.size === 0 || pickedFields.has('startsWith')) {
        result.startsWith = overrides && overrides.hasOwnProperty('startsWith') ? overrides.startsWith! : 'quisquam';
    }

    return result;
};

export const aComWixpressContactsLabelsV4ListLabelsResponse = <T extends Partial<ComWixpressContactsLabelsV4ListLabelsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('labels')) {
        result.labels = overrides && overrides.hasOwnProperty('labels') ? overrides.labels!.map((x) => aComWixpressContactsLabelsV4ContactLabel(x ?? {}, pickedFields.get('labels'))) : [aComWixpressContactsLabelsV4ContactLabel({}, pickedFields.get('labels'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aComWixpressContactsLabelsV4UpstreamWixCommonPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aComWixpressContactsLabelsV4UpstreamWixCommonPagingMetadata({}, pickedFields.get('metadata'));
    }

    return result;
};

export const aComWixpressContactsLabelsV4PurgeRequestInput = <T extends Partial<ComWixpressContactsLabelsV4PurgeRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exludingLabelKeys')) {
        result.exludingLabelKeys = overrides && overrides.hasOwnProperty('exludingLabelKeys') ? overrides.exludingLabelKeys! : ['tempore'];
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'ut';
    }

    return result;
};

export const aComWixpressContactsLabelsV4PurgeResponse = <T extends Partial<ComWixpressContactsLabelsV4PurgeResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deletedItems')) {
        result.deletedItems = overrides && overrides.hasOwnProperty('deletedItems') ? overrides.deletedItems! : 4921;
    }

    return result;
};

export const aComWixpressContactsLabelsV4QueryLabelsRequestInput = <T extends Partial<ComWixpressContactsLabelsV4QueryLabelsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressContactsLabelsV4UpstreamWixQueryQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressContactsLabelsV4UpstreamWixQueryQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressContactsLabelsV4QueryLabelsResponse = <T extends Partial<ComWixpressContactsLabelsV4QueryLabelsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressContactsLabelsV4ContactLabel(x ?? {}, pickedFields.get('items'))) : [aComWixpressContactsLabelsV4ContactLabel({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressContactsLabelsV4UpdateLabelRequestInput = <T extends Partial<ComWixpressContactsLabelsV4UpdateLabelRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixpressContactsLabelsV4ContactLabelInput(overrides.label ?? {}, pickedFields.get('label')) : aComWixpressContactsLabelsV4ContactLabelInput({}, pickedFields.get('label'));
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'atque';
    }

    return result;
};

export const aComWixpressContactsLabelsV4UpdateLabelResponse = <T extends Partial<ComWixpressContactsLabelsV4UpdateLabelResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixpressContactsLabelsV4ContactLabel(overrides.label ?? {}, pickedFields.get('label')) : aComWixpressContactsLabelsV4ContactLabel({}, pickedFields.get('label'));
    }

    return result;
};

export const aComWixpressContactsLabelsV4UpstreamWixCommonPagingInput = <T extends Partial<ComWixpressContactsLabelsV4UpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 5023;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 3672;
    }

    return result;
};

export const aComWixpressContactsLabelsV4UpstreamWixCommonPagingMetadata = <T extends Partial<ComWixpressContactsLabelsV4UpstreamWixCommonPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 5752;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 6716;
    }
    if (pickedFields.size === 0 || pickedFields.has('tooManyToCount')) {
        result.tooManyToCount = overrides && overrides.hasOwnProperty('tooManyToCount') ? overrides.tooManyToCount! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 139;
    }

    return result;
};

export const aComWixpressContactsLabelsV4UpstreamWixCommonSortingInput = <T extends Partial<ComWixpressContactsLabelsV4UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : ComWixpressContactsLabelsV4UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aComWixpressContactsLabelsV4UpstreamWixQueryQueryInput = <T extends Partial<ComWixpressContactsLabelsV4UpstreamWixQueryQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressContactsLabelsV4UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressContactsLabelsV4UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixpressContactsLabelsV4UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixpressContactsLabelsV4UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressCrmFinancialCommonApiV1CustomFieldValueInput = <T extends Partial<ComWixpressCrmFinancialCommonApiV1CustomFieldValueInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayName')) {
        result.displayName = overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('group')) {
        result.group = overrides && overrides.hasOwnProperty('group') ? overrides.group! : ComWixpressCrmFinancialCommonApiV1CustomFieldGroup.BusinessDetails;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('originCustomFieldKey')) {
        result.originCustomFieldKey = overrides && overrides.hasOwnProperty('originCustomFieldKey') ? overrides.originCustomFieldKey! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aComWixpressCrmFinancialCommonApiV1ValueInput(overrides.value ?? {}, pickedFields.get('value')) : aComWixpressCrmFinancialCommonApiV1ValueInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aComWixpressCrmFinancialCommonApiV1ValueInput = <T extends Partial<ComWixpressCrmFinancialCommonApiV1ValueInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('valueType')) {
        result.valueType = overrides && overrides.hasOwnProperty('valueType') ? overrides.valueType! : ComWixpressCrmFinancialCommonApiV1ValueValueType.Boolean;
    }

    return result;
};

export const aComWixpressHtmlEditorApiEventsHtmlSitePublishedInput = <T extends Partial<ComWixpressHtmlEditorApiEventsHtmlSitePublishedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appInstanceId')) {
        result.appInstanceId = overrides && overrides.hasOwnProperty('appInstanceId') ? overrides.appInstanceId! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('appType')) {
        result.appType = overrides && overrides.hasOwnProperty('appType') ? overrides.appType! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('branchId')) {
        result.branchId = overrides && overrides.hasOwnProperty('branchId') ? overrides.branchId! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastTransactionId')) {
        result.lastTransactionId = overrides && overrides.hasOwnProperty('lastTransactionId') ? overrides.lastTransactionId! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('pages')) {
        result.pages = overrides && overrides.hasOwnProperty('pages') ? overrides.pages!.map((x) => aComWixpressHtmlEditorApiEventsPageInput({}, pickedFields.get('pages'))) : [aComWixpressHtmlEditorApiEventsPageInput({}, pickedFields.get('pages'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('publishDate')) {
        result.publishDate = overrides && overrides.hasOwnProperty('publishDate') ? overrides.publishDate! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'et';
    }

    return result;
};

export const aComWixpressHtmlEditorApiEventsPageInput = <T extends Partial<ComWixpressHtmlEditorApiEventsPageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatum';
    }

    return result;
};

export const aComWixpressLocationsAddLocationTypeRequestInput = <T extends Partial<ComWixpressLocationsAddLocationTypeRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('locationType')) {
        result.locationType = overrides && overrides.hasOwnProperty('locationType') ? overrides.locationType! : ComWixpressLocationsLocationType.Branch;
    }

    return result;
};

export const aComWixpressLocationsAddLocationTypeResponse = <T extends Partial<ComWixpressLocationsAddLocationTypeResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressLocationsAddTypeToLocationRequestInput = <T extends Partial<ComWixpressLocationsAddTypeToLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('locationType')) {
        result.locationType = overrides && overrides.hasOwnProperty('locationType') ? overrides.locationType! : ComWixpressLocationsLocationType.Branch;
    }

    return result;
};

export const aComWixpressLocationsAddTypeToLocationResponse = <T extends Partial<ComWixpressLocationsAddTypeToLocationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressLocationsAddress = <T extends Partial<ComWixpressLocationsAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'sequi';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aComWixpressLocationsAddressLocation(overrides.geocode ?? {}, pickedFields.get('geocode')) : aComWixpressLocationsAddressLocation({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aComWixpressLocationsStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aComWixpressLocationsStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'esse';
    }

    return result;
};

export const aComWixpressLocationsAddressInput = <T extends Partial<ComWixpressLocationsAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aComWixpressLocationsAddressLocationInput(overrides.geocode ?? {}, pickedFields.get('geocode')) : aComWixpressLocationsAddressLocationInput({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aComWixpressLocationsStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aComWixpressLocationsStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'sit';
    }

    return result;
};

export const aComWixpressLocationsAddressLocation = <T extends Partial<ComWixpressLocationsAddressLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 2.7;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 6.88;
    }

    return result;
};

export const aComWixpressLocationsAddressLocationInput = <T extends Partial<ComWixpressLocationsAddressLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 9.32;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 6.17;
    }

    return result;
};

export const aComWixpressLocationsArchiveLocationRequestInput = <T extends Partial<ComWixpressLocationsArchiveLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'in';
    }

    return result;
};

export const aComWixpressLocationsArchiveLocationResponse = <T extends Partial<ComWixpressLocationsArchiveLocationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressLocationsBulkCreateLocationRequestInput = <T extends Partial<ComWixpressLocationsBulkCreateLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aComWixpressLocationsLocationInput({}, pickedFields.get('locations'))) : [aComWixpressLocationsLocationInput({}, pickedFields.get('locations'))];
    }

    return result;
};

export const aComWixpressLocationsBulkCreateLocationResponse = <T extends Partial<ComWixpressLocationsBulkCreateLocationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('failedLocations')) {
        result.failedLocations = overrides && overrides.hasOwnProperty('failedLocations') ? overrides.failedLocations!.map((x) => aComWixpressLocationsFailedCreateLocation(x ?? {}, pickedFields.get('failedLocations'))) : [aComWixpressLocationsFailedCreateLocation({}, pickedFields.get('failedLocations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('successfulLocations')) {
        result.successfulLocations = overrides && overrides.hasOwnProperty('successfulLocations') ? overrides.successfulLocations!.map((x) => aComWixpressLocationsLocation(x ?? {}, pickedFields.get('successfulLocations'))) : [aComWixpressLocationsLocation({}, pickedFields.get('successfulLocations'))];
    }

    return result;
};

export const aComWixpressLocationsBulkUpdateLocationRequestInput = <T extends Partial<ComWixpressLocationsBulkUpdateLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aComWixpressLocationsLocationInput({}, pickedFields.get('locations'))) : [aComWixpressLocationsLocationInput({}, pickedFields.get('locations'))];
    }

    return result;
};

export const aComWixpressLocationsBulkUpdateLocationResponse = <T extends Partial<ComWixpressLocationsBulkUpdateLocationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('failedLocations')) {
        result.failedLocations = overrides && overrides.hasOwnProperty('failedLocations') ? overrides.failedLocations!.map((x) => aComWixpressLocationsFailedUpdateLocation(x ?? {}, pickedFields.get('failedLocations'))) : [aComWixpressLocationsFailedUpdateLocation({}, pickedFields.get('failedLocations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('successfulLocations')) {
        result.successfulLocations = overrides && overrides.hasOwnProperty('successfulLocations') ? overrides.successfulLocations!.map((x) => aComWixpressLocationsLocation(x ?? {}, pickedFields.get('successfulLocations'))) : [aComWixpressLocationsLocation({}, pickedFields.get('successfulLocations'))];
    }

    return result;
};

export const aComWixpressLocationsCreateLocationRequestInput = <T extends Partial<ComWixpressLocationsCreateLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocationInput(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocationInput({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressLocationsCreateLocationResponse = <T extends Partial<ComWixpressLocationsCreateLocationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressLocationsFailedCreateLocation = <T extends Partial<ComWixpressLocationsFailedCreateLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorMessage')) {
        result.errorMessage = overrides && overrides.hasOwnProperty('errorMessage') ? overrides.errorMessage! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressLocationsFailedUpdateLocation = <T extends Partial<ComWixpressLocationsFailedUpdateLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorMessage')) {
        result.errorMessage = overrides && overrides.hasOwnProperty('errorMessage') ? overrides.errorMessage! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'adipisci';
    }

    return result;
};

export const aComWixpressLocationsGetLocationRequestInput = <T extends Partial<ComWixpressLocationsGetLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a3c54b51-647b-411c-a65d-8143599fa6b4';
    }

    return result;
};

export const aComWixpressLocationsListLocationsRequestInput = <T extends Partial<ComWixpressLocationsListLocationsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filterAuthorizedLocationEntities')) {
        result.filterAuthorizedLocationEntities = overrides && overrides.hasOwnProperty('filterAuthorizedLocationEntities') ? overrides.filterAuthorizedLocationEntities! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeArchived')) {
        result.includeArchived = overrides && overrides.hasOwnProperty('includeArchived') ? overrides.includeArchived! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? aWixCommonSortingInput(overrides.sort ?? {}, pickedFields.get('sort')) : aWixCommonSortingInput({}, pickedFields.get('sort'));
    }

    return result;
};

export const aComWixpressLocationsListLocationsResponse = <T extends Partial<ComWixpressLocationsListLocationsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorizedLocationEntities')) {
        result.authorizedLocationEntities = overrides && overrides.hasOwnProperty('authorizedLocationEntities') ? overrides.authorizedLocationEntities! : ['nisi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aComWixpressLocationsLocation(x ?? {}, pickedFields.get('locations'))) : [aComWixpressLocationsLocation({}, pickedFields.get('locations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressLocationsPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressLocationsPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixpressLocationsLocation = <T extends Partial<ComWixpressLocationsLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixpressLocationsAddress(overrides.address ?? {}, pickedFields.get('address')) : aComWixpressLocationsAddress({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('archived')) {
        result.archived = overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('businessSchedule')) {
        result.businessSchedule = overrides && overrides.hasOwnProperty('businessSchedule') ? aComWixpressSitepropertiesApiV4BusinessSchedule(overrides.businessSchedule ?? {}, pickedFields.get('businessSchedule')) : aComWixpressSitepropertiesApiV4BusinessSchedule({}, pickedFields.get('businessSchedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('fax')) {
        result.fax = overrides && overrides.hasOwnProperty('fax') ? overrides.fax! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemsVirtualReference')) {
        result.itemsVirtualReference = overrides && overrides.hasOwnProperty('itemsVirtualReference') ? aComWixpressRestaurantsMenusItemV1QueryItemsResponse(overrides.itemsVirtualReference ?? {}, pickedFields.get('itemsVirtualReference')) : aComWixpressRestaurantsMenusItemV1QueryItemsResponse({}, pickedFields.get('itemsVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('locationType')) {
        result.locationType = overrides && overrides.hasOwnProperty('locationType') ? overrides.locationType! : ComWixpressLocationsLocationType.Branch;
    }
    if (pickedFields.size === 0 || pickedFields.has('locationTypes')) {
        result.locationTypes = overrides && overrides.hasOwnProperty('locationTypes') ? overrides.locationTypes! : [ComWixpressLocationsLocationType.Branch];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroupsVirtualReference')) {
        result.modifierGroupsVirtualReference = overrides && overrides.hasOwnProperty('modifierGroupsVirtualReference') ? aWixRestaurantsMenusV1QueryModifierGroupsResponse(overrides.modifierGroupsVirtualReference ?? {}, pickedFields.get('modifierGroupsVirtualReference')) : aWixRestaurantsMenusV1QueryModifierGroupsResponse({}, pickedFields.get('modifierGroupsVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiersVirtualReference')) {
        result.modifiersVirtualReference = overrides && overrides.hasOwnProperty('modifiersVirtualReference') ? aWixRestaurantsMenusItemModifierV1QueryModifiersResponse(overrides.modifiersVirtualReference ?? {}, pickedFields.get('modifiersVirtualReference')) : aWixRestaurantsMenusItemModifierV1QueryModifiersResponse({}, pickedFields.get('modifiersVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('sectionsVirtualReference')) {
        result.sectionsVirtualReference = overrides && overrides.hasOwnProperty('sectionsVirtualReference') ? aComWixpressRestaurantsMenusSectionV1QuerySectionsResponse(overrides.sectionsVirtualReference ?? {}, pickedFields.get('sectionsVirtualReference')) : aComWixpressRestaurantsMenusSectionV1QuerySectionsResponse({}, pickedFields.get('sectionsVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressLocationsLocationStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('variantsVirtualReference')) {
        result.variantsVirtualReference = overrides && overrides.hasOwnProperty('variantsVirtualReference') ? aWixRestaurantsMenusItemVariantV1QueryVariantsResponse(overrides.variantsVirtualReference ?? {}, pickedFields.get('variantsVirtualReference')) : aWixRestaurantsMenusItemVariantV1QueryVariantsResponse({}, pickedFields.get('variantsVirtualReference'));
    }

    return result;
};

export const aComWixpressLocationsLocationInput = <T extends Partial<ComWixpressLocationsLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixpressLocationsAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aComWixpressLocationsAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('archived')) {
        result.archived = overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('businessSchedule')) {
        result.businessSchedule = overrides && overrides.hasOwnProperty('businessSchedule') ? aComWixpressSitepropertiesApiV4BusinessScheduleInput(overrides.businessSchedule ?? {}, pickedFields.get('businessSchedule')) : aComWixpressSitepropertiesApiV4BusinessScheduleInput({}, pickedFields.get('businessSchedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('fax')) {
        result.fax = overrides && overrides.hasOwnProperty('fax') ? overrides.fax! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('locationType')) {
        result.locationType = overrides && overrides.hasOwnProperty('locationType') ? overrides.locationType! : ComWixpressLocationsLocationType.Branch;
    }
    if (pickedFields.size === 0 || pickedFields.has('locationTypes')) {
        result.locationTypes = overrides && overrides.hasOwnProperty('locationTypes') ? overrides.locationTypes! : [ComWixpressLocationsLocationType.Branch];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressLocationsLocationStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'nostrum';
    }

    return result;
};

export const aComWixpressLocationsPagingMetadata = <T extends Partial<ComWixpressLocationsPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 2858;
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 6119;
    }

    return result;
};

export const aComWixpressLocationsQueryLocationsRequestInput = <T extends Partial<ComWixpressLocationsQueryLocationsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filterAuthorizedLocationEntities')) {
        result.filterAuthorizedLocationEntities = overrides && overrides.hasOwnProperty('filterAuthorizedLocationEntities') ? overrides.filterAuthorizedLocationEntities! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCommonQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixCommonQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressLocationsQueryLocationsResponse = <T extends Partial<ComWixpressLocationsQueryLocationsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressLocationsLocation(x ?? {}, pickedFields.get('items'))) : [aComWixpressLocationsLocation({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressLocationsRemoveLocationTypeRequestInput = <T extends Partial<ComWixpressLocationsRemoveLocationTypeRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('locationType')) {
        result.locationType = overrides && overrides.hasOwnProperty('locationType') ? overrides.locationType! : ComWixpressLocationsLocationType.Branch;
    }

    return result;
};

export const aComWixpressLocationsRemoveLocationTypeResponse = <T extends Partial<ComWixpressLocationsRemoveLocationTypeResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressLocationsRemoveTypeFromLocationRequestInput = <T extends Partial<ComWixpressLocationsRemoveTypeFromLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('locationType')) {
        result.locationType = overrides && overrides.hasOwnProperty('locationType') ? overrides.locationType! : ComWixpressLocationsLocationType.Branch;
    }

    return result;
};

export const aComWixpressLocationsRemoveTypeFromLocationResponse = <T extends Partial<ComWixpressLocationsRemoveTypeFromLocationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressLocationsSetDefaultLocationRequestInput = <T extends Partial<ComWixpressLocationsSetDefaultLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quos';
    }

    return result;
};

export const aComWixpressLocationsSetDefaultLocationResponse = <T extends Partial<ComWixpressLocationsSetDefaultLocationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressLocationsStreetAddress = <T extends Partial<ComWixpressLocationsStreetAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'nesciunt';
    }

    return result;
};

export const aComWixpressLocationsStreetAddressInput = <T extends Partial<ComWixpressLocationsStreetAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'magnam';
    }

    return result;
};

export const aComWixpressLocationsUnarchiveLocationRequestInput = <T extends Partial<ComWixpressLocationsUnarchiveLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }

    return result;
};

export const aComWixpressLocationsUnarchiveLocationResponse = <T extends Partial<ComWixpressLocationsUnarchiveLocationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressLocationsUpdateLocationRequestInput = <T extends Partial<ComWixpressLocationsUpdateLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocationInput(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocationInput({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressLocationsUpdateLocationResponse = <T extends Partial<ComWixpressLocationsUpdateLocationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }

    return result;
};

export const aComWixpressMembersApiAddress = <T extends Partial<ComWixpressMembersApiAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aComWixpressMembersApiStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aComWixpressMembersApiStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'hic';
    }

    return result;
};

export const aComWixpressMembersApiAddressInput = <T extends Partial<ComWixpressMembersApiAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aComWixpressMembersApiStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aComWixpressMembersApiStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'quae';
    }

    return result;
};

export const aComWixpressMembersApiApproveMemberRequestInput = <T extends Partial<ComWixpressMembersApiApproveMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'commodi';
    }

    return result;
};

export const aComWixpressMembersApiApproveMemberResponse = <T extends Partial<ComWixpressMembersApiApproveMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiBlockMemberRequestInput = <T extends Partial<ComWixpressMembersApiBlockMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'fugiat';
    }

    return result;
};

export const aComWixpressMembersApiBlockMemberResponse = <T extends Partial<ComWixpressMembersApiBlockMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiBulkApproveMembersRequestInput = <T extends Partial<ComWixpressMembersApiBulkApproveMembersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'officia';
    }

    return result;
};

export const aComWixpressMembersApiBulkApproveMembersResponse = <T extends Partial<ComWixpressMembersApiBulkApproveMembersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jobId')) {
        result.jobId = overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'at';
    }

    return result;
};

export const aComWixpressMembersApiBulkBlockMembersRequestInput = <T extends Partial<ComWixpressMembersApiBulkBlockMembersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'vitae';
    }

    return result;
};

export const aComWixpressMembersApiBulkBlockMembersResponse = <T extends Partial<ComWixpressMembersApiBulkBlockMembersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jobId')) {
        result.jobId = overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'culpa';
    }

    return result;
};

export const aComWixpressMembersApiBulkDeleteMembersByFilterRequestInput = <T extends Partial<ComWixpressMembersApiBulkDeleteMembersByFilterRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contentAssigneeId')) {
        result.contentAssigneeId = overrides && overrides.hasOwnProperty('contentAssigneeId') ? overrides.contentAssigneeId! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aComWixpressMembersApiSearchInput(overrides.search ?? {}, pickedFields.get('search')) : aComWixpressMembersApiSearchInput({}, pickedFields.get('search'));
    }

    return result;
};

export const aComWixpressMembersApiBulkDeleteMembersByFilterResponse = <T extends Partial<ComWixpressMembersApiBulkDeleteMembersByFilterResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jobId')) {
        result.jobId = overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'iusto';
    }

    return result;
};

export const aComWixpressMembersApiBulkDeleteMembersRequestInput = <T extends Partial<ComWixpressMembersApiBulkDeleteMembersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('memberIds')) {
        result.memberIds = overrides && overrides.hasOwnProperty('memberIds') ? overrides.memberIds! : ['exercitationem'];
    }

    return result;
};

export const aComWixpressMembersApiBulkDeleteMembersResponse = <T extends Partial<ComWixpressMembersApiBulkDeleteMembersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aComWixpressMembersApiUpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aComWixpressMembersApiUpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressMembersApiBulkDeleteMembersResponseBulkMemberResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressMembersApiBulkDeleteMembersResponseBulkMemberResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressMembersApiBulkDeleteMembersResponseBulkMemberResult = <T extends Partial<ComWixpressMembersApiBulkDeleteMembersResponseBulkMemberResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aComWixpressMembersApiUpstreamWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aComWixpressMembersApiUpstreamWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressMembersApiContact = <T extends Partial<ComWixpressMembersApiContact>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addresses')) {
        result.addresses = overrides && overrides.hasOwnProperty('addresses') ? overrides.addresses!.map((x) => aComWixpressMembersApiAddress(x ?? {}, pickedFields.get('addresses'))) : [aComWixpressMembersApiAddress({}, pickedFields.get('addresses'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('birthdate')) {
        result.birthdate = overrides && overrides.hasOwnProperty('birthdate') ? overrides.birthdate! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? aComWixpressMembersApiCustomField(overrides.customFields ?? {}, pickedFields.get('customFields')) : aComWixpressMembersApiCustomField({}, pickedFields.get('customFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('emails')) {
        result.emails = overrides && overrides.hasOwnProperty('emails') ? overrides.emails! : ['placeat'];
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('jobTitle')) {
        result.jobTitle = overrides && overrides.hasOwnProperty('jobTitle') ? overrides.jobTitle! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('phones')) {
        result.phones = overrides && overrides.hasOwnProperty('phones') ? overrides.phones! : ['dolor'];
    }

    return result;
};

export const aComWixpressMembersApiContactInput = <T extends Partial<ComWixpressMembersApiContactInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addresses')) {
        result.addresses = overrides && overrides.hasOwnProperty('addresses') ? overrides.addresses!.map((x) => aComWixpressMembersApiAddressInput({}, pickedFields.get('addresses'))) : [aComWixpressMembersApiAddressInput({}, pickedFields.get('addresses'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('birthdate')) {
        result.birthdate = overrides && overrides.hasOwnProperty('birthdate') ? overrides.birthdate! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? aComWixpressMembersApiCustomFieldInput(overrides.customFields ?? {}, pickedFields.get('customFields')) : aComWixpressMembersApiCustomFieldInput({}, pickedFields.get('customFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('emails')) {
        result.emails = overrides && overrides.hasOwnProperty('emails') ? overrides.emails! : ['esse'];
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('jobTitle')) {
        result.jobTitle = overrides && overrides.hasOwnProperty('jobTitle') ? overrides.jobTitle! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('phones')) {
        result.phones = overrides && overrides.hasOwnProperty('phones') ? overrides.phones! : ['omnis'];
    }

    return result;
};

export const aComWixpressMembersApiCreateMemberRequestInput = <T extends Partial<ComWixpressMembersApiCreateMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMemberInput(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMemberInput({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiCreateMemberResponse = <T extends Partial<ComWixpressMembersApiCreateMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiCustomField = <T extends Partial<ComWixpressMembersApiCustomField>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'similique';
    }

    return result;
};

export const aComWixpressMembersApiCustomFieldInput = <T extends Partial<ComWixpressMembersApiCustomFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'eos';
    }

    return result;
};

export const aComWixpressMembersApiDeleteMemberAddressesRequestInput = <T extends Partial<ComWixpressMembersApiDeleteMemberAddressesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'placeat';
    }

    return result;
};

export const aComWixpressMembersApiDeleteMemberAddressesResponse = <T extends Partial<ComWixpressMembersApiDeleteMemberAddressesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiDeleteMemberEmailsRequestInput = <T extends Partial<ComWixpressMembersApiDeleteMemberEmailsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolorum';
    }

    return result;
};

export const aComWixpressMembersApiDeleteMemberEmailsResponse = <T extends Partial<ComWixpressMembersApiDeleteMemberEmailsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiDeleteMemberPhonesRequestInput = <T extends Partial<ComWixpressMembersApiDeleteMemberPhonesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quia';
    }

    return result;
};

export const aComWixpressMembersApiDeleteMemberPhonesResponse = <T extends Partial<ComWixpressMembersApiDeleteMemberPhonesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiDeleteMemberRequestInput = <T extends Partial<ComWixpressMembersApiDeleteMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contentAssigneeId')) {
        result.contentAssigneeId = overrides && overrides.hasOwnProperty('contentAssigneeId') ? overrides.contentAssigneeId! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dignissimos';
    }

    return result;
};

export const aComWixpressMembersApiDeleteMyMemberRequestInput = <T extends Partial<ComWixpressMembersApiDeleteMyMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contentAssigneeId')) {
        result.contentAssigneeId = overrides && overrides.hasOwnProperty('contentAssigneeId') ? overrides.contentAssigneeId! : 'esse';
    }

    return result;
};

export const aComWixpressMembersApiDisconnectMemberRequestInput = <T extends Partial<ComWixpressMembersApiDisconnectMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consequatur';
    }

    return result;
};

export const aComWixpressMembersApiDisconnectMemberResponse = <T extends Partial<ComWixpressMembersApiDisconnectMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiGetMemberRequestInput = <T extends Partial<ComWixpressMembersApiGetMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldSet')) {
        result.fieldSet = overrides && overrides.hasOwnProperty('fieldSet') ? overrides.fieldSet! : ComWixpressMembersApiFieldSetSet.Extended;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressMembersApiFieldSetSet.Extended];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8e8ec098-e3ce-44d2-be4c-aa014c3cdb95';
    }

    return result;
};

export const aComWixpressMembersApiGetMyMemberRequestInput = <T extends Partial<ComWixpressMembersApiGetMyMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldSet')) {
        result.fieldSet = overrides && overrides.hasOwnProperty('fieldSet') ? overrides.fieldSet! : ComWixpressMembersApiFieldSetSet.Extended;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressMembersApiFieldSetSet.Extended];
    }

    return result;
};

export const aComWixpressMembersApiGetMyMemberResponse = <T extends Partial<ComWixpressMembersApiGetMyMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiJoinCommunityResponse = <T extends Partial<ComWixpressMembersApiJoinCommunityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiLeaveCommunityResponse = <T extends Partial<ComWixpressMembersApiLeaveCommunityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiListMembersRequestInput = <T extends Partial<ComWixpressMembersApiListMembersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressMembersApiUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressMembersApiUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldSet')) {
        result.fieldSet = overrides && overrides.hasOwnProperty('fieldSet') ? overrides.fieldSet! : ComWixpressMembersApiFieldSetSet.Extended;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressMembersApiFieldSetSet.Extended];
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sorting')) {
        result.sorting = overrides && overrides.hasOwnProperty('sorting') ? overrides.sorting!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sorting'))) : [aWixCommonSortingInput({}, pickedFields.get('sorting'))];
    }

    return result;
};

export const aComWixpressMembersApiListMembersResponse = <T extends Partial<ComWixpressMembersApiListMembersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPagingMetadata')) {
        result.cursorPagingMetadata = overrides && overrides.hasOwnProperty('cursorPagingMetadata') ? aComWixpressMembersApiUpstreamWixCommonCursorPagingMetadata(overrides.cursorPagingMetadata ?? {}, pickedFields.get('cursorPagingMetadata')) : aComWixpressMembersApiUpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('cursorPagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('members')) {
        result.members = overrides && overrides.hasOwnProperty('members') ? overrides.members!.map((x) => aComWixpressMembersApiMember(x ?? {}, pickedFields.get('members'))) : [aComWixpressMembersApiMember({}, pickedFields.get('members'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixCommonPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixCommonPagingMetadata({}, pickedFields.get('metadata'));
    }

    return result;
};

export const aComWixpressMembersApiMember = <T extends Partial<ComWixpressMembersApiMember>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activityStatus')) {
        result.activityStatus = overrides && overrides.hasOwnProperty('activityStatus') ? overrides.activityStatus! : ComWixpressMembersApiActivityStatusStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressMembersApiContact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressMembersApiContact({}, pickedFields.get('contact'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'vero';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastLoginDate')) {
        result.lastLoginDate = overrides && overrides.hasOwnProperty('lastLoginDate') ? overrides.lastLoginDate! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('loginEmail')) {
        result.loginEmail = overrides && overrides.hasOwnProperty('loginEmail') ? overrides.loginEmail! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('loginEmailVerified')) {
        result.loginEmailVerified = overrides && overrides.hasOwnProperty('loginEmailVerified') ? overrides.loginEmailVerified! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('participantsVirtualReference')) {
        result.participantsVirtualReference = overrides && overrides.hasOwnProperty('participantsVirtualReference') ? aWixOnlineprogramsParticipantsV3QueryParticipantsResponse(overrides.participantsVirtualReference ?? {}, pickedFields.get('participantsVirtualReference')) : aWixOnlineprogramsParticipantsV3QueryParticipantsResponse({}, pickedFields.get('participantsVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('privacyStatus')) {
        result.privacyStatus = overrides && overrides.hasOwnProperty('privacyStatus') ? overrides.privacyStatus! : ComWixpressMembersApiPrivacyStatusStatus.Private;
    }
    if (pickedFields.size === 0 || pickedFields.has('profile')) {
        result.profile = overrides && overrides.hasOwnProperty('profile') ? aComWixpressMembersApiProfile(overrides.profile ?? {}, pickedFields.get('profile')) : aComWixpressMembersApiProfile({}, pickedFields.get('profile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressMembersApiAccessStatusStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'ut';
    }

    return result;
};

export const aComWixpressMembersApiMemberInput = <T extends Partial<ComWixpressMembersApiMemberInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activityStatus')) {
        result.activityStatus = overrides && overrides.hasOwnProperty('activityStatus') ? overrides.activityStatus! : ComWixpressMembersApiActivityStatusStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressMembersApiContactInput(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressMembersApiContactInput({}, pickedFields.get('contact'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastLoginDate')) {
        result.lastLoginDate = overrides && overrides.hasOwnProperty('lastLoginDate') ? overrides.lastLoginDate! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('loginEmail')) {
        result.loginEmail = overrides && overrides.hasOwnProperty('loginEmail') ? overrides.loginEmail! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('loginEmailVerified')) {
        result.loginEmailVerified = overrides && overrides.hasOwnProperty('loginEmailVerified') ? overrides.loginEmailVerified! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('privacyStatus')) {
        result.privacyStatus = overrides && overrides.hasOwnProperty('privacyStatus') ? overrides.privacyStatus! : ComWixpressMembersApiPrivacyStatusStatus.Private;
    }
    if (pickedFields.size === 0 || pickedFields.has('profile')) {
        result.profile = overrides && overrides.hasOwnProperty('profile') ? aComWixpressMembersApiProfileInput(overrides.profile ?? {}, pickedFields.get('profile')) : aComWixpressMembersApiProfileInput({}, pickedFields.get('profile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressMembersApiAccessStatusStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'labore';
    }

    return result;
};

export const aComWixpressMembersApiMuteMemberRequestInput = <T extends Partial<ComWixpressMembersApiMuteMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }

    return result;
};

export const aComWixpressMembersApiMuteMemberResponse = <T extends Partial<ComWixpressMembersApiMuteMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiProfile = <T extends Partial<ComWixpressMembersApiProfile>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cover')) {
        result.cover = overrides && overrides.hasOwnProperty('cover') ? aComWixpressMembersCommonImage(overrides.cover ?? {}, pickedFields.get('cover')) : aComWixpressMembersCommonImage({}, pickedFields.get('cover'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nickname')) {
        result.nickname = overrides && overrides.hasOwnProperty('nickname') ? overrides.nickname! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('photo')) {
        result.photo = overrides && overrides.hasOwnProperty('photo') ? aComWixpressMembersCommonImage(overrides.photo ?? {}, pickedFields.get('photo')) : aComWixpressMembersCommonImage({}, pickedFields.get('photo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'numquam';
    }

    return result;
};

export const aComWixpressMembersApiProfileInput = <T extends Partial<ComWixpressMembersApiProfileInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cover')) {
        result.cover = overrides && overrides.hasOwnProperty('cover') ? aComWixpressMembersCommonImageInput(overrides.cover ?? {}, pickedFields.get('cover')) : aComWixpressMembersCommonImageInput({}, pickedFields.get('cover'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nickname')) {
        result.nickname = overrides && overrides.hasOwnProperty('nickname') ? overrides.nickname! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('photo')) {
        result.photo = overrides && overrides.hasOwnProperty('photo') ? aComWixpressMembersCommonImageInput(overrides.photo ?? {}, pickedFields.get('photo')) : aComWixpressMembersCommonImageInput({}, pickedFields.get('photo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'perferendis';
    }

    return result;
};

export const aComWixpressMembersApiQueryInput = <T extends Partial<ComWixpressMembersApiQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressMembersApiUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressMembersApiUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sorting')) {
        result.sorting = overrides && overrides.hasOwnProperty('sorting') ? overrides.sorting!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sorting'))) : [aWixCommonSortingInput({}, pickedFields.get('sorting'))];
    }

    return result;
};

export const aComWixpressMembersApiQueryMembersRequestInput = <T extends Partial<ComWixpressMembersApiQueryMembersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldSet')) {
        result.fieldSet = overrides && overrides.hasOwnProperty('fieldSet') ? overrides.fieldSet! : ComWixpressMembersApiFieldSetSet.Extended;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressMembersApiFieldSetSet.Extended];
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressMembersApiQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressMembersApiQueryInput({}, pickedFields.get('query'));
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aComWixpressMembersApiSearchInput(overrides.search ?? {}, pickedFields.get('search')) : aComWixpressMembersApiSearchInput({}, pickedFields.get('search'));
    }

    return result;
};

export const aComWixpressMembersApiQueryMembersResponse = <T extends Partial<ComWixpressMembersApiQueryMembersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressMembersApiMember(x ?? {}, pickedFields.get('items'))) : [aComWixpressMembersApiMember({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressMembersApiSearchInput = <T extends Partial<ComWixpressMembersApiSearchInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['rerum'];
    }

    return result;
};

export const aComWixpressMembersApiStreetAddress = <T extends Partial<ComWixpressMembersApiStreetAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'tenetur';
    }

    return result;
};

export const aComWixpressMembersApiStreetAddressInput = <T extends Partial<ComWixpressMembersApiStreetAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'consequatur';
    }

    return result;
};

export const aComWixpressMembersApiUnmuteMemberRequestInput = <T extends Partial<ComWixpressMembersApiUnmuteMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'velit';
    }

    return result;
};

export const aComWixpressMembersApiUnmuteMemberResponse = <T extends Partial<ComWixpressMembersApiUnmuteMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiUpdateMemberRequestInput = <T extends Partial<ComWixpressMembersApiUpdateMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMemberInput(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMemberInput({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiUpdateMemberResponse = <T extends Partial<ComWixpressMembersApiUpdateMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiUpdateMemberSlugRequestInput = <T extends Partial<ComWixpressMembersApiUpdateMemberSlugRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'sint';
    }

    return result;
};

export const aComWixpressMembersApiUpdateMemberSlugResponse = <T extends Partial<ComWixpressMembersApiUpdateMemberSlugResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiUpdateMySlugRequestInput = <T extends Partial<ComWixpressMembersApiUpdateMySlugRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'ut';
    }

    return result;
};

export const aComWixpressMembersApiUpdateMySlugResponse = <T extends Partial<ComWixpressMembersApiUpdateMySlugResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }

    return result;
};

export const aComWixpressMembersApiUpstreamWixCommonBulkActionMetadata = <T extends Partial<ComWixpressMembersApiUpstreamWixCommonBulkActionMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalFailures')) {
        result.totalFailures = overrides && overrides.hasOwnProperty('totalFailures') ? overrides.totalFailures! : 7910;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalSuccesses')) {
        result.totalSuccesses = overrides && overrides.hasOwnProperty('totalSuccesses') ? overrides.totalSuccesses! : 4262;
    }
    if (pickedFields.size === 0 || pickedFields.has('undetailedFailures')) {
        result.undetailedFailures = overrides && overrides.hasOwnProperty('undetailedFailures') ? overrides.undetailedFailures! : 3963;
    }

    return result;
};

export const aComWixpressMembersApiUpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixpressMembersApiUpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1233;
    }

    return result;
};

export const aComWixpressMembersApiUpstreamWixCommonCursorPagingMetadata = <T extends Partial<ComWixpressMembersApiUpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 9140;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aComWixpressMembersApiUpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aComWixpressMembersApiUpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }

    return result;
};

export const aComWixpressMembersApiUpstreamWixCommonCursors = <T extends Partial<ComWixpressMembersApiUpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'neque';
    }

    return result;
};

export const aComWixpressMembersApiUpstreamWixCommonItemMetadata = <T extends Partial<ComWixpressMembersApiUpstreamWixCommonItemMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiApplicationError(overrides.error ?? {}, pickedFields.get('error')) : aWixApiApplicationError({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalIndex')) {
        result.originalIndex = overrides && overrides.hasOwnProperty('originalIndex') ? overrides.originalIndex! : 3932;
    }
    if (pickedFields.size === 0 || pickedFields.has('success')) {
        result.success = overrides && overrides.hasOwnProperty('success') ? overrides.success! : true;
    }

    return result;
};

export const aComWixpressMembersCommonImage = <T extends Partial<ComWixpressMembersCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 7612;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('offsetX')) {
        result.offsetX = overrides && overrides.hasOwnProperty('offsetX') ? overrides.offsetX! : 1583;
    }
    if (pickedFields.size === 0 || pickedFields.has('offsetY')) {
        result.offsetY = overrides && overrides.hasOwnProperty('offsetY') ? overrides.offsetY! : 476;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 4323;
    }

    return result;
};

export const aComWixpressMembersCommonImageInput = <T extends Partial<ComWixpressMembersCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 945;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('offsetX')) {
        result.offsetX = overrides && overrides.hasOwnProperty('offsetX') ? overrides.offsetX! : 7205;
    }
    if (pickedFields.size === 0 || pickedFields.has('offsetY')) {
        result.offsetY = overrides && overrides.hasOwnProperty('offsetY') ? overrides.offsetY! : 4458;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 8565;
    }

    return result;
};

export const aComWixpressMembershipV1MoneyInput = <T extends Partial<ComWixpressMembershipV1MoneyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'illum';
    }

    return result;
};

export const aComWixpressMembershipV1PeriodInput = <T extends Partial<ComWixpressMembershipV1PeriodInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 5655;
    }
    if (pickedFields.size === 0 || pickedFields.has('unit')) {
        result.unit = overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : ComWixpressMembershipV1PeriodUnit.Day;
    }

    return result;
};

export const aComWixpressMembershipV1PlansPaymentOptionsInput = <T extends Partial<ComWixpressMembershipV1PlansPaymentOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('freeTrialDays')) {
        result.freeTrialDays = overrides && overrides.hasOwnProperty('freeTrialDays') ? overrides.freeTrialDays! : 9144;
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixpressMembershipV1MoneyInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixpressMembershipV1MoneyInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('recurring')) {
        result.recurring = overrides && overrides.hasOwnProperty('recurring') ? overrides.recurring! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('validFor')) {
        result.validFor = overrides && overrides.hasOwnProperty('validFor') ? aComWixpressMembershipV1ValidityInput(overrides.validFor ?? {}, pickedFields.get('validFor')) : aComWixpressMembershipV1ValidityInput({}, pickedFields.get('validFor'));
    }

    return result;
};

export const aComWixpressMembershipV1PlansPlanArchivedInput = <T extends Partial<ComWixpressMembershipV1PlansPlanArchivedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('plan')) {
        result.plan = overrides && overrides.hasOwnProperty('plan') ? aComWixpressMembershipV1PlansPlanInput(overrides.plan ?? {}, pickedFields.get('plan')) : aComWixpressMembershipV1PlansPlanInput({}, pickedFields.get('plan'));
    }

    return result;
};

export const aComWixpressMembershipV1PlansPlanCreatedInput = <T extends Partial<ComWixpressMembershipV1PlansPlanCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('plan')) {
        result.plan = overrides && overrides.hasOwnProperty('plan') ? aComWixpressMembershipV1PlansPlanInput(overrides.plan ?? {}, pickedFields.get('plan')) : aComWixpressMembershipV1PlansPlanInput({}, pickedFields.get('plan'));
    }

    return result;
};

export const aComWixpressMembershipV1PlansPlanDetailsInput = <T extends Partial<ComWixpressMembershipV1PlansPlanDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('benefits')) {
        result.benefits = overrides && overrides.hasOwnProperty('benefits') ? overrides.benefits! : ['hic'];
    }
    if (pickedFields.size === 0 || pickedFields.has('clientData')) {
        result.clientData = overrides && overrides.hasOwnProperty('clientData') ? overrides.clientData! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('disclaimer')) {
        result.disclaimer = overrides && overrides.hasOwnProperty('disclaimer') ? overrides.disclaimer! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('ribbon')) {
        result.ribbon = overrides && overrides.hasOwnProperty('ribbon') ? overrides.ribbon! : 'qui';
    }

    return result;
};

export const aComWixpressMembershipV1PlansPlanEventInput = <T extends Partial<ComWixpressMembershipV1PlansPlanEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('archived')) {
        result.archived = overrides && overrides.hasOwnProperty('archived') ? aComWixpressMembershipV1PlansPlanArchivedInput(overrides.archived ?? {}, pickedFields.get('archived')) : aComWixpressMembershipV1PlansPlanArchivedInput({}, pickedFields.get('archived'));
    }
    if (pickedFields.size === 0 || pickedFields.has('created')) {
        result.created = overrides && overrides.hasOwnProperty('created') ? aComWixpressMembershipV1PlansPlanCreatedInput(overrides.created ?? {}, pickedFields.get('created')) : aComWixpressMembershipV1PlansPlanCreatedInput({}, pickedFields.get('created'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updated')) {
        result.updated = overrides && overrides.hasOwnProperty('updated') ? aComWixpressMembershipV1PlansPlanUpdatedInput(overrides.updated ?? {}, pickedFields.get('updated')) : aComWixpressMembershipV1PlansPlanUpdatedInput({}, pickedFields.get('updated'));
    }

    return result;
};

export const aComWixpressMembershipV1PlansPlanInput = <T extends Partial<ComWixpressMembershipV1PlansPlanInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('archived')) {
        result.archived = overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerCanPickFutureStartDate')) {
        result.buyerCanPickFutureStartDate = overrides && overrides.hasOwnProperty('buyerCanPickFutureStartDate') ? overrides.buyerCanPickFutureStartDate! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('dateCreated')) {
        result.dateCreated = overrides && overrides.hasOwnProperty('dateCreated') ? overrides.dateCreated! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('dateUpdated')) {
        result.dateUpdated = overrides && overrides.hasOwnProperty('dateUpdated') ? overrides.dateUpdated! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? aComWixpressMembershipV1PlansPlanDetailsInput(overrides.details ?? {}, pickedFields.get('details')) : aComWixpressMembershipV1PlansPlanDetailsInput({}, pickedFields.get('details'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasOrders')) {
        result.hasOrders = overrides && overrides.hasOwnProperty('hasOrders') ? overrides.hasOrders! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberCanCancel')) {
        result.memberCanCancel = overrides && overrides.hasOwnProperty('memberCanCancel') ? overrides.memberCanCancel! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOptions')) {
        result.paymentOptions = overrides && overrides.hasOwnProperty('paymentOptions') ? aComWixpressMembershipV1PlansPaymentOptionsInput(overrides.paymentOptions ?? {}, pickedFields.get('paymentOptions')) : aComWixpressMembershipV1PlansPaymentOptionsInput({}, pickedFields.get('paymentOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('purchaseLimitations')) {
        result.purchaseLimitations = overrides && overrides.hasOwnProperty('purchaseLimitations') ? aComWixpressMembershipV1PurchaseLimitationsInput(overrides.purchaseLimitations ?? {}, pickedFields.get('purchaseLimitations')) : aComWixpressMembershipV1PurchaseLimitationsInput({}, pickedFields.get('purchaseLimitations'));
    }
    if (pickedFields.size === 0 || pickedFields.has('roleId')) {
        result.roleId = overrides && overrides.hasOwnProperty('roleId') ? overrides.roleId! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('template')) {
        result.template = overrides && overrides.hasOwnProperty('template') ? overrides.template! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : true;
    }

    return result;
};

export const aComWixpressMembershipV1PlansPlanUpdatedInput = <T extends Partial<ComWixpressMembershipV1PlansPlanUpdatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('plan')) {
        result.plan = overrides && overrides.hasOwnProperty('plan') ? aComWixpressMembershipV1PlansPlanInput(overrides.plan ?? {}, pickedFields.get('plan')) : aComWixpressMembershipV1PlansPlanInput({}, pickedFields.get('plan'));
    }
    if (pickedFields.size === 0 || pickedFields.has('previousPlan')) {
        result.previousPlan = overrides && overrides.hasOwnProperty('previousPlan') ? aComWixpressMembershipV1PlansPlanInput(overrides.previousPlan ?? {}, pickedFields.get('previousPlan')) : aComWixpressMembershipV1PlansPlanInput({}, pickedFields.get('previousPlan'));
    }

    return result;
};

export const aComWixpressMembershipV1PurchaseLimitationsInput = <T extends Partial<ComWixpressMembershipV1PurchaseLimitationsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 2593;
    }

    return result;
};

export const aComWixpressMembershipV1ValidityInput = <T extends Partial<ComWixpressMembershipV1ValidityInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('forever')) {
        result.forever = overrides && overrides.hasOwnProperty('forever') ? overrides.forever! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('period')) {
        result.period = overrides && overrides.hasOwnProperty('period') ? aComWixpressMembershipV1PeriodInput(overrides.period ?? {}, pickedFields.get('period')) : aComWixpressMembershipV1PeriodInput({}, pickedFields.get('period'));
    }

    return result;
};

export const aComWixpressMembershipV2CommonMoney = <T extends Partial<ComWixpressMembershipV2CommonMoney>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'veritatis';
    }

    return result;
};

export const aComWixpressMembershipV2CommonMoneyInput = <T extends Partial<ComWixpressMembershipV2CommonMoneyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'maiores';
    }

    return result;
};

export const aComWixpressMembershipV2CommonQueryV2Input = <T extends Partial<ComWixpressMembershipV2CommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressMembershipV2Duration = <T extends Partial<ComWixpressMembershipV2Duration>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 8047;
    }
    if (pickedFields.size === 0 || pickedFields.has('unit')) {
        result.unit = overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : ComWixpressMembershipV2PeriodUnitEnumPeriodUnit.Day;
    }

    return result;
};

export const aComWixpressMembershipV2DurationInput = <T extends Partial<ComWixpressMembershipV2DurationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 2575;
    }
    if (pickedFields.size === 0 || pickedFields.has('unit')) {
        result.unit = overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : ComWixpressMembershipV2PeriodUnitEnumPeriodUnit.Day;
    }

    return result;
};

export const aComWixpressMembershipV2Fee = <T extends Partial<ComWixpressMembershipV2Fee>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'et';
    }

    return result;
};

export const aComWixpressMembershipV2FeeConfig = <T extends Partial<ComWixpressMembershipV2FeeConfig>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appliedAt')) {
        result.appliedAt = overrides && overrides.hasOwnProperty('appliedAt') ? overrides.appliedAt! : ComWixpressMembershipV2FeeConfigAppliedAt.FirstPayment;
    }
    if (pickedFields.size === 0 || pickedFields.has('fee')) {
        result.fee = overrides && overrides.hasOwnProperty('fee') ? aComWixpressMembershipV2Fee(overrides.fee ?? {}, pickedFields.get('fee')) : aComWixpressMembershipV2Fee({}, pickedFields.get('fee'));
    }

    return result;
};

export const aComWixpressMembershipV2FeeConfigInput = <T extends Partial<ComWixpressMembershipV2FeeConfigInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appliedAt')) {
        result.appliedAt = overrides && overrides.hasOwnProperty('appliedAt') ? overrides.appliedAt! : ComWixpressMembershipV2FeeConfigAppliedAt.FirstPayment;
    }
    if (pickedFields.size === 0 || pickedFields.has('fee')) {
        result.fee = overrides && overrides.hasOwnProperty('fee') ? aComWixpressMembershipV2FeeInput(overrides.fee ?? {}, pickedFields.get('fee')) : aComWixpressMembershipV2FeeInput({}, pickedFields.get('fee'));
    }

    return result;
};

export const aComWixpressMembershipV2FeeInput = <T extends Partial<ComWixpressMembershipV2FeeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ea';
    }

    return result;
};

export const aComWixpressMembershipV2PlansArchivePlanRequestInput = <T extends Partial<ComWixpressMembershipV2PlansArchivePlanRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ipsam';
    }

    return result;
};

export const aComWixpressMembershipV2PlansArchivePlanResponse = <T extends Partial<ComWixpressMembershipV2PlansArchivePlanResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('plan')) {
        result.plan = overrides && overrides.hasOwnProperty('plan') ? aComWixpressMembershipV2PlansPlan(overrides.plan ?? {}, pickedFields.get('plan')) : aComWixpressMembershipV2PlansPlan({}, pickedFields.get('plan'));
    }

    return result;
};

export const aComWixpressMembershipV2PlansArrangePlansRequestInput = <T extends Partial<ComWixpressMembershipV2PlansArrangePlansRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['voluptatibus'];
    }

    return result;
};

export const aComWixpressMembershipV2PlansBulkArchivePlanRequestInput = <T extends Partial<ComWixpressMembershipV2PlansBulkArchivePlanRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['alias'];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : false;
    }

    return result;
};

export const aComWixpressMembershipV2PlansBulkArchivePlanResponse = <T extends Partial<ComWixpressMembershipV2PlansBulkArchivePlanResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressMembershipV2PlansBulkPlanResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressMembershipV2PlansBulkPlanResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressMembershipV2PlansBulkPlanResult = <T extends Partial<ComWixpressMembershipV2PlansBulkPlanResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('plan')) {
        result.plan = overrides && overrides.hasOwnProperty('plan') ? aComWixpressMembershipV2PlansPlan(overrides.plan ?? {}, pickedFields.get('plan')) : aComWixpressMembershipV2PlansPlan({}, pickedFields.get('plan'));
    }

    return result;
};

export const aComWixpressMembershipV2PlansCreatePlanRequestInput = <T extends Partial<ComWixpressMembershipV2PlansCreatePlanRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('plan')) {
        result.plan = overrides && overrides.hasOwnProperty('plan') ? aComWixpressMembershipV2PlansPlanInput(overrides.plan ?? {}, pickedFields.get('plan')) : aComWixpressMembershipV2PlansPlanInput({}, pickedFields.get('plan'));
    }

    return result;
};

export const aComWixpressMembershipV2PlansCreatePlanResponse = <T extends Partial<ComWixpressMembershipV2PlansCreatePlanResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('plan')) {
        result.plan = overrides && overrides.hasOwnProperty('plan') ? aComWixpressMembershipV2PlansPlan(overrides.plan ?? {}, pickedFields.get('plan')) : aComWixpressMembershipV2PlansPlan({}, pickedFields.get('plan'));
    }

    return result;
};

export const aComWixpressMembershipV2PlansGetPlanRequestInput = <T extends Partial<ComWixpressMembershipV2PlansGetPlanRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cac4d277-a893-4644-b02b-5f875e587953';
    }

    return result;
};

export const aComWixpressMembershipV2PlansGetPlanStatsResponse = <T extends Partial<ComWixpressMembershipV2PlansGetPlanStatsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalPlans')) {
        result.totalPlans = overrides && overrides.hasOwnProperty('totalPlans') ? overrides.totalPlans! : 7603;
    }

    return result;
};

export const aComWixpressMembershipV2PlansListPlansRequestInput = <T extends Partial<ComWixpressMembershipV2PlansListPlansRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('archived')) {
        result.archived = overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : ComWixpressMembershipV2PlansArchivedFilterEnumArchivedFilter.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 7734;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 910;
    }
    if (pickedFields.size === 0 || pickedFields.has('planIds')) {
        result.planIds = overrides && overrides.hasOwnProperty('planIds') ? overrides.planIds! : ['praesentium'];
    }
    if (pickedFields.size === 0 || pickedFields.has('public')) {
        result.public = overrides && overrides.hasOwnProperty('public') ? overrides.public! : ComWixpressMembershipV2PlansPublicFilterEnumPublicFilter.Hidden;
    }

    return result;
};

export const aComWixpressMembershipV2PlansListPlansResponse = <T extends Partial<ComWixpressMembershipV2PlansListPlansResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('plans')) {
        result.plans = overrides && overrides.hasOwnProperty('plans') ? overrides.plans!.map((x) => aComWixpressMembershipV2PlansPlan(x ?? {}, pickedFields.get('plans'))) : [aComWixpressMembershipV2PlansPlan({}, pickedFields.get('plans'))];
    }

    return result;
};

export const aComWixpressMembershipV2PlansListPublicPlansRequestInput = <T extends Partial<ComWixpressMembershipV2PlansListPublicPlansRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2443;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 1118;
    }
    if (pickedFields.size === 0 || pickedFields.has('planIds')) {
        result.planIds = overrides && overrides.hasOwnProperty('planIds') ? overrides.planIds! : ['consequatur'];
    }

    return result;
};

export const aComWixpressMembershipV2PlansListPublicPlansResponse = <T extends Partial<ComWixpressMembershipV2PlansListPublicPlansResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('plans')) {
        result.plans = overrides && overrides.hasOwnProperty('plans') ? overrides.plans!.map((x) => aComWixpressMembershipV2PlansPublicPlan(x ?? {}, pickedFields.get('plans'))) : [aComWixpressMembershipV2PlansPublicPlan({}, pickedFields.get('plans'))];
    }

    return result;
};

export const aComWixpressMembershipV2PlansMakePlanPrimaryRequestInput = <T extends Partial<ComWixpressMembershipV2PlansMakePlanPrimaryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ipsum';
    }

    return result;
};

export const aComWixpressMembershipV2PlansMakePlanPrimaryResponse = <T extends Partial<ComWixpressMembershipV2PlansMakePlanPrimaryResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('plan')) {
        result.plan = overrides && overrides.hasOwnProperty('plan') ? aComWixpressMembershipV2PlansPlan(overrides.plan ?? {}, pickedFields.get('plan')) : aComWixpressMembershipV2PlansPlan({}, pickedFields.get('plan'));
    }

    return result;
};

export const aComWixpressMembershipV2PlansPlan = <T extends Partial<ComWixpressMembershipV2PlansPlan>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowFutureStartDate')) {
        result.allowFutureStartDate = overrides && overrides.hasOwnProperty('allowFutureStartDate') ? overrides.allowFutureStartDate! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('archived')) {
        result.archived = overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerCanCancel')) {
        result.buyerCanCancel = overrides && overrides.hasOwnProperty('buyerCanCancel') ? overrides.buyerCanCancel! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('clientData')) {
        result.clientData = overrides && overrides.hasOwnProperty('clientData') ? overrides.clientData! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4Form(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4Form({}, pickedFields.get('form'));
    }
    if (pickedFields.size === 0 || pickedFields.has('formId')) {
        result.formId = overrides && overrides.hasOwnProperty('formId') ? overrides.formId! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('hasOrders')) {
        result.hasOrders = overrides && overrides.hasOwnProperty('hasOrders') ? overrides.hasOrders! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxPurchasesPerBuyer')) {
        result.maxPurchasesPerBuyer = overrides && overrides.hasOwnProperty('maxPurchasesPerBuyer') ? overrides.maxPurchasesPerBuyer! : 5873;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('perks')) {
        result.perks = overrides && overrides.hasOwnProperty('perks') ? aComWixpressMembershipV2StringList(overrides.perks ?? {}, pickedFields.get('perks')) : aComWixpressMembershipV2StringList({}, pickedFields.get('perks'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pricing')) {
        result.pricing = overrides && overrides.hasOwnProperty('pricing') ? aComWixpressMembershipV2Pricing(overrides.pricing ?? {}, pickedFields.get('pricing')) : aComWixpressMembershipV2Pricing({}, pickedFields.get('pricing'));
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('public')) {
        result.public = overrides && overrides.hasOwnProperty('public') ? overrides.public! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('termsAndConditions')) {
        result.termsAndConditions = overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'qui';
    }

    return result;
};

export const aComWixpressMembershipV2PlansPlanInput = <T extends Partial<ComWixpressMembershipV2PlansPlanInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowFutureStartDate')) {
        result.allowFutureStartDate = overrides && overrides.hasOwnProperty('allowFutureStartDate') ? overrides.allowFutureStartDate! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('archived')) {
        result.archived = overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerCanCancel')) {
        result.buyerCanCancel = overrides && overrides.hasOwnProperty('buyerCanCancel') ? overrides.buyerCanCancel! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('clientData')) {
        result.clientData = overrides && overrides.hasOwnProperty('clientData') ? overrides.clientData! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('formId')) {
        result.formId = overrides && overrides.hasOwnProperty('formId') ? overrides.formId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('hasOrders')) {
        result.hasOrders = overrides && overrides.hasOwnProperty('hasOrders') ? overrides.hasOrders! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxPurchasesPerBuyer')) {
        result.maxPurchasesPerBuyer = overrides && overrides.hasOwnProperty('maxPurchasesPerBuyer') ? overrides.maxPurchasesPerBuyer! : 8769;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('perks')) {
        result.perks = overrides && overrides.hasOwnProperty('perks') ? aComWixpressMembershipV2StringListInput(overrides.perks ?? {}, pickedFields.get('perks')) : aComWixpressMembershipV2StringListInput({}, pickedFields.get('perks'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pricing')) {
        result.pricing = overrides && overrides.hasOwnProperty('pricing') ? aComWixpressMembershipV2PricingInput(overrides.pricing ?? {}, pickedFields.get('pricing')) : aComWixpressMembershipV2PricingInput({}, pickedFields.get('pricing'));
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('public')) {
        result.public = overrides && overrides.hasOwnProperty('public') ? overrides.public! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('termsAndConditions')) {
        result.termsAndConditions = overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'nisi';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'in';
    }

    return result;
};

export const aComWixpressMembershipV2PlansPublicPlan = <T extends Partial<ComWixpressMembershipV2PlansPublicPlan>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowFutureStartDate')) {
        result.allowFutureStartDate = overrides && overrides.hasOwnProperty('allowFutureStartDate') ? overrides.allowFutureStartDate! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerCanCancel')) {
        result.buyerCanCancel = overrides && overrides.hasOwnProperty('buyerCanCancel') ? overrides.buyerCanCancel! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('clientData')) {
        result.clientData = overrides && overrides.hasOwnProperty('clientData') ? overrides.clientData! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4Form(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4Form({}, pickedFields.get('form'));
    }
    if (pickedFields.size === 0 || pickedFields.has('formId')) {
        result.formId = overrides && overrides.hasOwnProperty('formId') ? overrides.formId! : 'debitis';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxPurchasesPerBuyer')) {
        result.maxPurchasesPerBuyer = overrides && overrides.hasOwnProperty('maxPurchasesPerBuyer') ? overrides.maxPurchasesPerBuyer! : 5695;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('perks')) {
        result.perks = overrides && overrides.hasOwnProperty('perks') ? aComWixpressMembershipV2StringList(overrides.perks ?? {}, pickedFields.get('perks')) : aComWixpressMembershipV2StringList({}, pickedFields.get('perks'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pricing')) {
        result.pricing = overrides && overrides.hasOwnProperty('pricing') ? aComWixpressMembershipV2Pricing(overrides.pricing ?? {}, pickedFields.get('pricing')) : aComWixpressMembershipV2Pricing({}, pickedFields.get('pricing'));
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('termsAndConditions')) {
        result.termsAndConditions = overrides && overrides.hasOwnProperty('termsAndConditions') ? overrides.termsAndConditions! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'eos';
    }

    return result;
};

export const aComWixpressMembershipV2PlansQueryPublicPlansRequestInput = <T extends Partial<ComWixpressMembershipV2PlansQueryPublicPlansRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressMembershipV2CommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressMembershipV2CommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressMembershipV2PlansQueryPublicPlansResponse = <T extends Partial<ComWixpressMembershipV2PlansQueryPublicPlansResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressMembershipV2PlansPlan(x ?? {}, pickedFields.get('items'))) : [aComWixpressMembershipV2PlansPlan({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressMembershipV2PlansSetPlanVisibilityRequestInput = <T extends Partial<ComWixpressMembershipV2PlansSetPlanVisibilityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : false;
    }

    return result;
};

export const aComWixpressMembershipV2PlansSetPlanVisibilityResponse = <T extends Partial<ComWixpressMembershipV2PlansSetPlanVisibilityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('plan')) {
        result.plan = overrides && overrides.hasOwnProperty('plan') ? aComWixpressMembershipV2PlansPlan(overrides.plan ?? {}, pickedFields.get('plan')) : aComWixpressMembershipV2PlansPlan({}, pickedFields.get('plan'));
    }

    return result;
};

export const aComWixpressMembershipV2PlansUpdatePlanRequestInput = <T extends Partial<ComWixpressMembershipV2PlansUpdatePlanRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['sed'];
    }
    if (pickedFields.size === 0 || pickedFields.has('plan')) {
        result.plan = overrides && overrides.hasOwnProperty('plan') ? aComWixpressMembershipV2PlansPlanInput(overrides.plan ?? {}, pickedFields.get('plan')) : aComWixpressMembershipV2PlansPlanInput({}, pickedFields.get('plan'));
    }

    return result;
};

export const aComWixpressMembershipV2PlansUpdatePlanResponse = <T extends Partial<ComWixpressMembershipV2PlansUpdatePlanResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('plan')) {
        result.plan = overrides && overrides.hasOwnProperty('plan') ? aComWixpressMembershipV2PlansPlan(overrides.plan ?? {}, pickedFields.get('plan')) : aComWixpressMembershipV2PlansPlan({}, pickedFields.get('plan'));
    }

    return result;
};

export const aComWixpressMembershipV2Pricing = <T extends Partial<ComWixpressMembershipV2Pricing>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('feeConfigs')) {
        result.feeConfigs = overrides && overrides.hasOwnProperty('feeConfigs') ? overrides.feeConfigs!.map((x) => aComWixpressMembershipV2FeeConfig(x ?? {}, pickedFields.get('feeConfigs'))) : [aComWixpressMembershipV2FeeConfig({}, pickedFields.get('feeConfigs'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('freeTrialDays')) {
        result.freeTrialDays = overrides && overrides.hasOwnProperty('freeTrialDays') ? overrides.freeTrialDays! : 6673;
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixpressMembershipV2CommonMoney(overrides.price ?? {}, pickedFields.get('price')) : aComWixpressMembershipV2CommonMoney({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('singlePaymentForDuration')) {
        result.singlePaymentForDuration = overrides && overrides.hasOwnProperty('singlePaymentForDuration') ? aComWixpressMembershipV2Duration(overrides.singlePaymentForDuration ?? {}, pickedFields.get('singlePaymentForDuration')) : aComWixpressMembershipV2Duration({}, pickedFields.get('singlePaymentForDuration'));
    }
    if (pickedFields.size === 0 || pickedFields.has('singlePaymentUnlimited')) {
        result.singlePaymentUnlimited = overrides && overrides.hasOwnProperty('singlePaymentUnlimited') ? overrides.singlePaymentUnlimited! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('subscription')) {
        result.subscription = overrides && overrides.hasOwnProperty('subscription') ? aComWixpressMembershipV2Recurrence(overrides.subscription ?? {}, pickedFields.get('subscription')) : aComWixpressMembershipV2Recurrence({}, pickedFields.get('subscription'));
    }

    return result;
};

export const aComWixpressMembershipV2PricingInput = <T extends Partial<ComWixpressMembershipV2PricingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('feeConfigs')) {
        result.feeConfigs = overrides && overrides.hasOwnProperty('feeConfigs') ? overrides.feeConfigs!.map((x) => aComWixpressMembershipV2FeeConfigInput({}, pickedFields.get('feeConfigs'))) : [aComWixpressMembershipV2FeeConfigInput({}, pickedFields.get('feeConfigs'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('freeTrialDays')) {
        result.freeTrialDays = overrides && overrides.hasOwnProperty('freeTrialDays') ? overrides.freeTrialDays! : 5222;
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixpressMembershipV2CommonMoneyInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixpressMembershipV2CommonMoneyInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('singlePaymentForDuration')) {
        result.singlePaymentForDuration = overrides && overrides.hasOwnProperty('singlePaymentForDuration') ? aComWixpressMembershipV2DurationInput(overrides.singlePaymentForDuration ?? {}, pickedFields.get('singlePaymentForDuration')) : aComWixpressMembershipV2DurationInput({}, pickedFields.get('singlePaymentForDuration'));
    }
    if (pickedFields.size === 0 || pickedFields.has('singlePaymentUnlimited')) {
        result.singlePaymentUnlimited = overrides && overrides.hasOwnProperty('singlePaymentUnlimited') ? overrides.singlePaymentUnlimited! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('subscription')) {
        result.subscription = overrides && overrides.hasOwnProperty('subscription') ? aComWixpressMembershipV2RecurrenceInput(overrides.subscription ?? {}, pickedFields.get('subscription')) : aComWixpressMembershipV2RecurrenceInput({}, pickedFields.get('subscription'));
    }

    return result;
};

export const aComWixpressMembershipV2Recurrence = <T extends Partial<ComWixpressMembershipV2Recurrence>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cycleCount')) {
        result.cycleCount = overrides && overrides.hasOwnProperty('cycleCount') ? overrides.cycleCount! : 8051;
    }
    if (pickedFields.size === 0 || pickedFields.has('cycleDuration')) {
        result.cycleDuration = overrides && overrides.hasOwnProperty('cycleDuration') ? aComWixpressMembershipV2Duration(overrides.cycleDuration ?? {}, pickedFields.get('cycleDuration')) : aComWixpressMembershipV2Duration({}, pickedFields.get('cycleDuration'));
    }

    return result;
};

export const aComWixpressMembershipV2RecurrenceInput = <T extends Partial<ComWixpressMembershipV2RecurrenceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cycleCount')) {
        result.cycleCount = overrides && overrides.hasOwnProperty('cycleCount') ? overrides.cycleCount! : 2372;
    }
    if (pickedFields.size === 0 || pickedFields.has('cycleDuration')) {
        result.cycleDuration = overrides && overrides.hasOwnProperty('cycleDuration') ? aComWixpressMembershipV2DurationInput(overrides.cycleDuration ?? {}, pickedFields.get('cycleDuration')) : aComWixpressMembershipV2DurationInput({}, pickedFields.get('cycleDuration'));
    }

    return result;
};

export const aComWixpressMembershipV2StringList = <T extends Partial<ComWixpressMembershipV2StringList>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values! : ['earum'];
    }

    return result;
};

export const aComWixpressMembershipV2StringListInput = <T extends Partial<ComWixpressMembershipV2StringListInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values! : ['qui'];
    }

    return result;
};

export const aComWixpressMetasiteApiV1App = <T extends Partial<ComWixpressMetasiteApiV1App>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appDefId')) {
        result.appDefId = overrides && overrides.hasOwnProperty('appDefId') ? overrides.appDefId! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('originInstanceId')) {
        result.originInstanceId = overrides && overrides.hasOwnProperty('originInstanceId') ? overrides.originInstanceId! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('state')) {
        result.state = overrides && overrides.hasOwnProperty('state') ? overrides.state! : ComWixpressMetasiteApiV1AppState.Disabled;
    }

    return result;
};

export const aComWixpressMetasiteApiV1HtmlApplication = <T extends Partial<ComWixpressMetasiteApiV1HtmlApplication>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('editorX')) {
        result.editorX = overrides && overrides.hasOwnProperty('editorX') ? overrides.editorX! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('intId')) {
        result.intId = overrides && overrides.hasOwnProperty('intId') ? overrides.intId! : 5;
    }
    if (pickedFields.size === 0 || pickedFields.has('languageCode')) {
        result.languageCode = overrides && overrides.hasOwnProperty('languageCode') ? overrides.languageCode! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('odeditor')) {
        result.odeditor = overrides && overrides.hasOwnProperty('odeditor') ? overrides.odeditor! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('picasso')) {
        result.picasso = overrides && overrides.hasOwnProperty('picasso') ? overrides.picasso! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressMetasiteEventApiSeoData(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressMetasiteEventApiSeoData({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('studio')) {
        result.studio = overrides && overrides.hasOwnProperty('studio') ? overrides.studio! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnail')) {
        result.thumbnail = overrides && overrides.hasOwnProperty('thumbnail') ? overrides.thumbnail! : 'quia';
    }

    return result;
};

export const aComWixpressMetasiteApiV1MetaSite = <T extends Partial<ComWixpressMetasiteApiV1MetaSite>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accountCreatedDate')) {
        result.accountCreatedDate = overrides && overrides.hasOwnProperty('accountCreatedDate') ? overrides.accountCreatedDate! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('adi')) {
        result.adi = overrides && overrides.hasOwnProperty('adi') ? overrides.adi! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('apps')) {
        result.apps = overrides && overrides.hasOwnProperty('apps') ? overrides.apps!.map((x) => aComWixpressMetasiteApiV1App(x ?? {}, pickedFields.get('apps'))) : [aComWixpressMetasiteApiV1App({}, pickedFields.get('apps'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('blocked')) {
        result.blocked = overrides && overrides.hasOwnProperty('blocked') ? overrides.blocked! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('criticalAsset')) {
        result.criticalAsset = overrides && overrides.hasOwnProperty('criticalAsset') ? overrides.criticalAsset! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('dateCreated')) {
        result.dateCreated = overrides && overrides.hasOwnProperty('dateCreated') ? overrides.dateCreated! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('dateUpdated')) {
        result.dateUpdated = overrides && overrides.hasOwnProperty('dateUpdated') ? overrides.dateUpdated! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultSeoData')) {
        result.defaultSeoData = overrides && overrides.hasOwnProperty('defaultSeoData') ? aComWixpressMetasiteEventApiSeoData(overrides.defaultSeoData ?? {}, pickedFields.get('defaultSeoData')) : aComWixpressMetasiteEventApiSeoData({}, pickedFields.get('defaultSeoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dontUseDefaultRouting')) {
        result.dontUseDefaultRouting = overrides && overrides.hasOwnProperty('dontUseDefaultRouting') ? overrides.dontUseDefaultRouting! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('externalUriMappings')) {
        result.externalUriMappings = overrides && overrides.hasOwnProperty('externalUriMappings') ? overrides.externalUriMappings!.map((x) => aComWixpressMetasiteEventApiExternalUriMapping(x ?? {}, pickedFields.get('externalUriMappings'))) : [aComWixpressMetasiteEventApiExternalUriMapping({}, pickedFields.get('externalUriMappings'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('htmlApp')) {
        result.htmlApp = overrides && overrides.hasOwnProperty('htmlApp') ? aComWixpressMetasiteApiV1HtmlApplication(overrides.htmlApp ?? {}, pickedFields.get('htmlApp')) : aComWixpressMetasiteApiV1HtmlApplication({}, pickedFields.get('htmlApp'));
    }
    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : ComWixpressMetasiteEventApiMetaSiteNamespace.AccountMasterCms;
    }
    if (pickedFields.size === 0 || pickedFields.has('originTemplateId')) {
        result.originTemplateId = overrides && overrides.hasOwnProperty('originTemplateId') ? overrides.originTemplateId! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('ownerId')) {
        result.ownerId = overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('published')) {
        result.published = overrides && overrides.hasOwnProperty('published') ? overrides.published! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('template')) {
        result.template = overrides && overrides.hasOwnProperty('template') ? overrides.template! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('useHttps')) {
        result.useHttps = overrides && overrides.hasOwnProperty('useHttps') ? overrides.useHttps! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 'consectetur';
    }

    return result;
};

export const aComWixpressMetasiteEventApiAssetInput = <T extends Partial<ComWixpressMetasiteEventApiAssetInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appDefId')) {
        result.appDefId = overrides && overrides.hasOwnProperty('appDefId') ? overrides.appDefId! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('state')) {
        result.state = overrides && overrides.hasOwnProperty('state') ? overrides.state! : ComWixpressMetasiteEventApiAssetState.Demo;
    }

    return result;
};

export const aComWixpressMetasiteEventApiDeleteContextInput = <T extends Partial<ComWixpressMetasiteEventApiDeleteContextInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateDeleted')) {
        result.dateDeleted = overrides && overrides.hasOwnProperty('dateDeleted') ? overrides.dateDeleted! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('deleteOrigin')) {
        result.deleteOrigin = overrides && overrides.hasOwnProperty('deleteOrigin') ? overrides.deleteOrigin! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('deleteStatus')) {
        result.deleteStatus = overrides && overrides.hasOwnProperty('deleteStatus') ? overrides.deleteStatus! : ComWixpressMetasiteEventApiDeleteContextDeleteStatus.Deleted;
    }
    if (pickedFields.size === 0 || pickedFields.has('initiatorId')) {
        result.initiatorId = overrides && overrides.hasOwnProperty('initiatorId') ? overrides.initiatorId! : 'aut';
    }

    return result;
};

export const aComWixpressMetasiteEventApiExternalUriMapping = <T extends Partial<ComWixpressMetasiteEventApiExternalUriMapping>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fromExternalUri')) {
        result.fromExternalUri = overrides && overrides.hasOwnProperty('fromExternalUri') ? overrides.fromExternalUri! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('oldToWixUri')) {
        result.oldToWixUri = overrides && overrides.hasOwnProperty('oldToWixUri') ? overrides.oldToWixUri! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('requireDomain')) {
        result.requireDomain = overrides && overrides.hasOwnProperty('requireDomain') ? overrides.requireDomain! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('toWixUri')) {
        result.toWixUri = overrides && overrides.hasOwnProperty('toWixUri') ? overrides.toWixUri! : 'hic';
    }

    return result;
};

export const aComWixpressMetasiteEventApiMetaSiteSpecialEventInput = <T extends Partial<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('assets')) {
        result.assets = overrides && overrides.hasOwnProperty('assets') ? overrides.assets!.map((x) => aComWixpressMetasiteEventApiAssetInput({}, pickedFields.get('assets'))) : [aComWixpressMetasiteEventApiAssetInput({}, pickedFields.get('assets'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('hardDeleted')) {
        result.hardDeleted = overrides && overrides.hasOwnProperty('hardDeleted') ? aComWixpressMetasiteEventApiSiteHardDeletedInput(overrides.hardDeleted ?? {}, pickedFields.get('hardDeleted')) : aComWixpressMetasiteEventApiSiteHardDeletedInput({}, pickedFields.get('hardDeleted'));
    }
    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespaceChanged')) {
        result.namespaceChanged = overrides && overrides.hasOwnProperty('namespaceChanged') ? aComWixpressMetasiteEventApiNamespaceChangedInput(overrides.namespaceChanged ?? {}, pickedFields.get('namespaceChanged')) : aComWixpressMetasiteEventApiNamespaceChangedInput({}, pickedFields.get('namespaceChanged'));
    }
    if (pickedFields.size === 0 || pickedFields.has('odeditorAssigned')) {
        result.odeditorAssigned = overrides && overrides.hasOwnProperty('odeditorAssigned') ? overrides.odeditorAssigned! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('odeditorUnassigned')) {
        result.odeditorUnassigned = overrides && overrides.hasOwnProperty('odeditorUnassigned') ? overrides.odeditorUnassigned! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('picassoAssigned')) {
        result.picassoAssigned = overrides && overrides.hasOwnProperty('picassoAssigned') ? overrides.picassoAssigned! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('picassoUnassigned')) {
        result.picassoUnassigned = overrides && overrides.hasOwnProperty('picassoUnassigned') ? overrides.picassoUnassigned! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceProvisioned')) {
        result.serviceProvisioned = overrides && overrides.hasOwnProperty('serviceProvisioned') ? aComWixpressMetasiteEventApiServiceProvisionedInput(overrides.serviceProvisioned ?? {}, pickedFields.get('serviceProvisioned')) : aComWixpressMetasiteEventApiServiceProvisionedInput({}, pickedFields.get('serviceProvisioned'));
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceRemoved')) {
        result.serviceRemoved = overrides && overrides.hasOwnProperty('serviceRemoved') ? aComWixpressMetasiteEventApiServiceRemovedInput(overrides.serviceRemoved ?? {}, pickedFields.get('serviceRemoved')) : aComWixpressMetasiteEventApiServiceRemovedInput({}, pickedFields.get('serviceRemoved'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteCreated')) {
        result.siteCreated = overrides && overrides.hasOwnProperty('siteCreated') ? aComWixpressMetasiteEventApiSiteCreatedInput(overrides.siteCreated ?? {}, pickedFields.get('siteCreated')) : aComWixpressMetasiteEventApiSiteCreatedInput({}, pickedFields.get('siteCreated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteDeleted')) {
        result.siteDeleted = overrides && overrides.hasOwnProperty('siteDeleted') ? aComWixpressMetasiteEventApiSiteDeletedInput(overrides.siteDeleted ?? {}, pickedFields.get('siteDeleted')) : aComWixpressMetasiteEventApiSiteDeletedInput({}, pickedFields.get('siteDeleted'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteMarkedAsTemplate')) {
        result.siteMarkedAsTemplate = overrides && overrides.hasOwnProperty('siteMarkedAsTemplate') ? overrides.siteMarkedAsTemplate! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteMarkedAsWixSite')) {
        result.siteMarkedAsWixSite = overrides && overrides.hasOwnProperty('siteMarkedAsWixSite') ? overrides.siteMarkedAsWixSite! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('sitePublished')) {
        result.sitePublished = overrides && overrides.hasOwnProperty('sitePublished') ? overrides.sitePublished! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('sitePurgedExternally')) {
        result.sitePurgedExternally = overrides && overrides.hasOwnProperty('sitePurgedExternally') ? aComWixpressMetasiteEventApiSitePurgedExternallyInput(overrides.sitePurgedExternally ?? {}, pickedFields.get('sitePurgedExternally')) : aComWixpressMetasiteEventApiSitePurgedExternallyInput({}, pickedFields.get('sitePurgedExternally'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteRenamedPayload')) {
        result.siteRenamedPayload = overrides && overrides.hasOwnProperty('siteRenamedPayload') ? aComWixpressMetasiteEventApiSiteRenamedInput(overrides.siteRenamedPayload ?? {}, pickedFields.get('siteRenamedPayload')) : aComWixpressMetasiteEventApiSiteRenamedInput({}, pickedFields.get('siteRenamedPayload'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteTransferred')) {
        result.siteTransferred = overrides && overrides.hasOwnProperty('siteTransferred') ? aComWixpressMetasiteEventApiSiteTransferredInput(overrides.siteTransferred ?? {}, pickedFields.get('siteTransferred')) : aComWixpressMetasiteEventApiSiteTransferredInput({}, pickedFields.get('siteTransferred'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteUndeleted')) {
        result.siteUndeleted = overrides && overrides.hasOwnProperty('siteUndeleted') ? overrides.siteUndeleted! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteUnpublished')) {
        result.siteUnpublished = overrides && overrides.hasOwnProperty('siteUnpublished') ? aComWixpressMetasiteEventApiSiteUnpublishedInput(overrides.siteUnpublished ?? {}, pickedFields.get('siteUnpublished')) : aComWixpressMetasiteEventApiSiteUnpublishedInput({}, pickedFields.get('siteUnpublished'));
    }
    if (pickedFields.size === 0 || pickedFields.has('studioAssigned')) {
        result.studioAssigned = overrides && overrides.hasOwnProperty('studioAssigned') ? overrides.studioAssigned! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('studioUnassigned')) {
        result.studioUnassigned = overrides && overrides.hasOwnProperty('studioUnassigned') ? overrides.studioUnassigned! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('timestamp')) {
        result.timestamp = overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlChanged')) {
        result.urlChanged = overrides && overrides.hasOwnProperty('urlChanged') ? overrides.urlChanged! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 'aut';
    }

    return result;
};

export const aComWixpressMetasiteEventApiMetaTag = <T extends Partial<ComWixpressMetasiteEventApiMetaTag>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('property')) {
        result.property = overrides && overrides.hasOwnProperty('property') ? overrides.property! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'dignissimos';
    }

    return result;
};

export const aComWixpressMetasiteEventApiNamespaceChangedInput = <T extends Partial<ComWixpressMetasiteEventApiNamespaceChangedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newNamespace')) {
        result.newNamespace = overrides && overrides.hasOwnProperty('newNamespace') ? overrides.newNamespace! : ComWixpressMetasiteEventApiMetaSiteNamespace.AccountMasterCms;
    }
    if (pickedFields.size === 0 || pickedFields.has('oldNamespace')) {
        result.oldNamespace = overrides && overrides.hasOwnProperty('oldNamespace') ? overrides.oldNamespace! : ComWixpressMetasiteEventApiMetaSiteNamespace.AccountMasterCms;
    }

    return result;
};

export const aComWixpressMetasiteEventApiSeoData = <T extends Partial<ComWixpressMetasiteEventApiSeoData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('canonicalUrl')) {
        result.canonicalUrl = overrides && overrides.hasOwnProperty('canonicalUrl') ? overrides.canonicalUrl! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('indexable')) {
        result.indexable = overrides && overrides.hasOwnProperty('indexable') ? overrides.indexable! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('metaTags')) {
        result.metaTags = overrides && overrides.hasOwnProperty('metaTags') ? overrides.metaTags!.map((x) => aComWixpressMetasiteEventApiMetaTag(x ?? {}, pickedFields.get('metaTags'))) : [aComWixpressMetasiteEventApiMetaTag({}, pickedFields.get('metaTags'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('ogImage')) {
        result.ogImage = overrides && overrides.hasOwnProperty('ogImage') ? overrides.ogImage! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('suppressTrackingCookies')) {
        result.suppressTrackingCookies = overrides && overrides.hasOwnProperty('suppressTrackingCookies') ? overrides.suppressTrackingCookies! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'quia';
    }

    return result;
};

export const aComWixpressMetasiteEventApiServiceProvisionedInput = <T extends Partial<ComWixpressMetasiteEventApiServiceProvisionedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appDefId')) {
        result.appDefId = overrides && overrides.hasOwnProperty('appDefId') ? overrides.appDefId! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('originInstanceId')) {
        result.originInstanceId = overrides && overrides.hasOwnProperty('originInstanceId') ? overrides.originInstanceId! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('originMetaSiteId')) {
        result.originMetaSiteId = overrides && overrides.hasOwnProperty('originMetaSiteId') ? overrides.originMetaSiteId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 'voluptates';
    }

    return result;
};

export const aComWixpressMetasiteEventApiServiceRemovedInput = <T extends Partial<ComWixpressMetasiteEventApiServiceRemovedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appDefId')) {
        result.appDefId = overrides && overrides.hasOwnProperty('appDefId') ? overrides.appDefId! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 'quia';
    }

    return result;
};

export const aComWixpressMetasiteEventApiSiteCreatedInput = <T extends Partial<ComWixpressMetasiteEventApiSiteCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('context')) {
        result.context = overrides && overrides.hasOwnProperty('context') ? overrides.context! : ComWixpressMetasiteEventApiSiteCreatedContext.Duplicate;
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : ComWixpressMetasiteEventApiMetaSiteNamespace.AccountMasterCms;
    }
    if (pickedFields.size === 0 || pickedFields.has('originMetaSiteId')) {
        result.originMetaSiteId = overrides && overrides.hasOwnProperty('originMetaSiteId') ? overrides.originMetaSiteId! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('originTemplateId')) {
        result.originTemplateId = overrides && overrides.hasOwnProperty('originTemplateId') ? overrides.originTemplateId! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('ownerId')) {
        result.ownerId = overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteName')) {
        result.siteName = overrides && overrides.hasOwnProperty('siteName') ? overrides.siteName! : 'at';
    }

    return result;
};

export const aComWixpressMetasiteEventApiSiteDeletedInput = <T extends Partial<ComWixpressMetasiteEventApiSiteDeletedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deleteContext')) {
        result.deleteContext = overrides && overrides.hasOwnProperty('deleteContext') ? aComWixpressMetasiteEventApiDeleteContextInput(overrides.deleteContext ?? {}, pickedFields.get('deleteContext')) : aComWixpressMetasiteEventApiDeleteContextInput({}, pickedFields.get('deleteContext'));
    }

    return result;
};

export const aComWixpressMetasiteEventApiSiteHardDeletedInput = <T extends Partial<ComWixpressMetasiteEventApiSiteHardDeletedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deleteContext')) {
        result.deleteContext = overrides && overrides.hasOwnProperty('deleteContext') ? aComWixpressMetasiteEventApiDeleteContextInput(overrides.deleteContext ?? {}, pickedFields.get('deleteContext')) : aComWixpressMetasiteEventApiDeleteContextInput({}, pickedFields.get('deleteContext'));
    }

    return result;
};

export const aComWixpressMetasiteEventApiSitePurgedExternallyInput = <T extends Partial<ComWixpressMetasiteEventApiSitePurgedExternallyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appDefId')) {
        result.appDefId = overrides && overrides.hasOwnProperty('appDefId') ? overrides.appDefId! : ['aut'];
    }

    return result;
};

export const aComWixpressMetasiteEventApiSiteRenamedInput = <T extends Partial<ComWixpressMetasiteEventApiSiteRenamedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newSiteName')) {
        result.newSiteName = overrides && overrides.hasOwnProperty('newSiteName') ? overrides.newSiteName! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('oldSiteName')) {
        result.oldSiteName = overrides && overrides.hasOwnProperty('oldSiteName') ? overrides.oldSiteName! : 'exercitationem';
    }

    return result;
};

export const aComWixpressMetasiteEventApiSiteTransferredInput = <T extends Partial<ComWixpressMetasiteEventApiSiteTransferredInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newOwnerId')) {
        result.newOwnerId = overrides && overrides.hasOwnProperty('newOwnerId') ? overrides.newOwnerId! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('oldOwnerId')) {
        result.oldOwnerId = overrides && overrides.hasOwnProperty('oldOwnerId') ? overrides.oldOwnerId! : 'voluptates';
    }

    return result;
};

export const aComWixpressMetasiteEventApiSiteUnpublishedInput = <T extends Partial<ComWixpressMetasiteEventApiSiteUnpublishedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('urls')) {
        result.urls = overrides && overrides.hasOwnProperty('urls') ? overrides.urls! : ['voluptatibus'];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 9958;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 8664;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField.Seo];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogTagInput({}, pickedFields.get('tags'))) : [aComWixpressNpmCommunitiesPlatformizedBlogTagInput({}, pickedFields.get('tags'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogBulkTagResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressNpmCommunitiesPlatformizedBlogBulkTagResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogBulkDeleteTagRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogBulkDeleteTagRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('permanent')) {
        result.permanent = overrides && overrides.hasOwnProperty('permanent') ? overrides.permanent! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('tagIds')) {
        result.tagIds = overrides && overrides.hasOwnProperty('tagIds') ? overrides.tagIds! : ['voluptatibus'];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogBulkTagResult = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogBulkTagResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressNpmCommunitiesPlatformizedBlogTag(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressNpmCommunitiesPlatformizedBlogTag({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogCoverMedia = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogCoverMedia>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('displayed')) {
        result.displayed = overrides && overrides.hasOwnProperty('displayed') ? overrides.displayed! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideo(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideo({}, pickedFields.get('video'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogCreateTagRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogCreateTagRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField.Seo];
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'incidunt';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogCreateTagResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogCreateTagResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? aComWixpressNpmCommunitiesPlatformizedBlogTag(overrides.tag ?? {}, pickedFields.get('tag')) : aComWixpressNpmCommunitiesPlatformizedBlogTag({}, pickedFields.get('tag'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogDeleteTagRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogDeleteTagRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tagId')) {
        result.tagId = overrides && overrides.hasOwnProperty('tagId') ? overrides.tagId! : 'quis';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogEmbedMedia = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogEmbedMedia>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('thumbnail')) {
        result.thumbnail = overrides && overrides.hasOwnProperty('thumbnail') ? aComWixpressNpmCommunitiesPlatformizedBlogEmbedThumbnail(overrides.thumbnail ?? {}, pickedFields.get('thumbnail')) : aComWixpressNpmCommunitiesPlatformizedBlogEmbedThumbnail({}, pickedFields.get('thumbnail'));
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aComWixpressNpmCommunitiesPlatformizedBlogEmbedVideo(overrides.video ?? {}, pickedFields.get('video')) : aComWixpressNpmCommunitiesPlatformizedBlogEmbedVideo({}, pickedFields.get('video'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogEmbedThumbnail = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogEmbedThumbnail>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 1992;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 4865;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogEmbedVideo = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogEmbedVideo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 1803;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 2064;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField.Seo];
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'natus';
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoData'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? aComWixpressNpmCommunitiesPlatformizedBlogTag(overrides.tag ?? {}, pickedFields.get('tag')) : aComWixpressNpmCommunitiesPlatformizedBlogTag({}, pickedFields.get('tag'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField.Seo];
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'quisquam';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? aComWixpressNpmCommunitiesPlatformizedBlogTag(overrides.tag ?? {}, pickedFields.get('tag')) : aComWixpressNpmCommunitiesPlatformizedBlogTag({}, pickedFields.get('tag'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField.Seo];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'pariatur';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? aComWixpressNpmCommunitiesPlatformizedBlogTag(overrides.tag ?? {}, pickedFields.get('tag')) : aComWixpressNpmCommunitiesPlatformizedBlogTag({}, pickedFields.get('tag'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetTagRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetTagRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField.Seo];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '5d97b020-d35f-4f19-a67e-bdcb12fbaf14';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetTagsCountByLanguageResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetTagsCountByLanguageResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tagsLanguageCount')) {
        result.tagsLanguageCount = overrides && overrides.hasOwnProperty('tagsLanguageCount') ? overrides.tagsLanguageCount!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogTagLanguageCount(x ?? {}, pickedFields.get('tagsLanguageCount'))) : [aComWixpressNpmCommunitiesPlatformizedBlogTagLanguageCount({}, pickedFields.get('tagsLanguageCount'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'quod';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 4219;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'non';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 3558;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogListTagsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogListTagsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressNpmCommunitiesPlatformizedUpstreamTagCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressNpmCommunitiesPlatformizedUpstreamTagCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField.Seo];
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressNpmCommunitiesPlatformizedUpstreamTagPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressNpmCommunitiesPlatformizedUpstreamTagPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogListTagsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogListTagsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaData')) {
        result.metaData = overrides && overrides.hasOwnProperty('metaData') ? aComWixpressNpmCommunitiesPlatformizedBlogMetaData(overrides.metaData ?? {}, pickedFields.get('metaData')) : aComWixpressNpmCommunitiesPlatformizedBlogMetaData({}, pickedFields.get('metaData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogTag(x ?? {}, pickedFields.get('tags'))) : [aComWixpressNpmCommunitiesPlatformizedBlogTag({}, pickedFields.get('tags'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogMedia = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogMedia>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('displayed')) {
        result.displayed = overrides && overrides.hasOwnProperty('displayed') ? overrides.displayed! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('embedMedia')) {
        result.embedMedia = overrides && overrides.hasOwnProperty('embedMedia') ? aComWixpressNpmCommunitiesPlatformizedBlogEmbedMedia(overrides.embedMedia ?? {}, pickedFields.get('embedMedia')) : aComWixpressNpmCommunitiesPlatformizedBlogEmbedMedia({}, pickedFields.get('embedMedia'));
    }
    if (pickedFields.size === 0 || pickedFields.has('wixMedia')) {
        result.wixMedia = overrides && overrides.hasOwnProperty('wixMedia') ? aComWixpressNpmCommunitiesPlatformizedBlogWixMedia(overrides.wixMedia ?? {}, pickedFields.get('wixMedia')) : aComWixpressNpmCommunitiesPlatformizedBlogWixMedia({}, pickedFields.get('wixMedia'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogMetaData = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 1615;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 6733;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9974;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogPeriodPostCount = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogPeriodPostCount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('periodStart')) {
        result.periodStart = overrides && overrides.hasOwnProperty('periodStart') ? overrides.periodStart! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('postCount')) {
        result.postCount = overrides && overrides.hasOwnProperty('postCount') ? overrides.postCount! : 4917;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogPeriodPublicationsCount = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogPeriodPublicationsCount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('periodStart')) {
        result.periodStart = overrides && overrides.hasOwnProperty('periodStart') ? overrides.periodStart! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('publicationsCount')) {
        result.publicationsCount = overrides && overrides.hasOwnProperty('publicationsCount') ? overrides.publicationsCount! : 6423;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('months')) {
        result.months = overrides && overrides.hasOwnProperty('months') ? overrides.months! : 6387;
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsRequestOrder.Newest;
    }
    if (pickedFields.size === 0 || pickedFields.has('rangeStart')) {
        result.rangeStart = overrides && overrides.hasOwnProperty('rangeStart') ? overrides.rangeStart! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'et';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('stats')) {
        result.stats = overrides && overrides.hasOwnProperty('stats') ? overrides.stats!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogPeriodPostCount(x ?? {}, pickedFields.get('stats'))) : [aComWixpressNpmCommunitiesPlatformizedBlogPeriodPostCount({}, pickedFields.get('stats'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('months')) {
        result.months = overrides && overrides.hasOwnProperty('months') ? overrides.months! : 1125;
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsRequestOrder.Newest;
    }
    if (pickedFields.size === 0 || pickedFields.has('rangeEnd')) {
        result.rangeEnd = overrides && overrides.hasOwnProperty('rangeEnd') ? overrides.rangeEnd! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('rangeStart')) {
        result.rangeStart = overrides && overrides.hasOwnProperty('rangeStart') ? overrides.rangeStart! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'aut';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('stats')) {
        result.stats = overrides && overrides.hasOwnProperty('stats') ? overrides.stats!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogPeriodPublicationsCount(x ?? {}, pickedFields.get('stats'))) : [aComWixpressNpmCommunitiesPlatformizedBlogPeriodPublicationsCount({}, pickedFields.get('stats'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogQueryTagsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogQueryTagsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField.Seo];
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogQueryTagsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogQueryTagsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogTag(x ?? {}, pickedFields.get('items'))) : [aComWixpressNpmCommunitiesPlatformizedBlogTag({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogTag = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogTag>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'natus';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('postCount')) {
        result.postCount = overrides && overrides.hasOwnProperty('postCount') ? overrides.postCount! : 2434;
    }
    if (pickedFields.size === 0 || pickedFields.has('publishedPostCount')) {
        result.publishedPostCount = overrides && overrides.hasOwnProperty('publishedPostCount') ? overrides.publishedPostCount! : 5397;
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('translationId')) {
        result.translationId = overrides && overrides.hasOwnProperty('translationId') ? overrides.translationId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrl(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrl({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogTagInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogTagInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('postCount')) {
        result.postCount = overrides && overrides.hasOwnProperty('postCount') ? overrides.postCount! : 7604;
    }
    if (pickedFields.size === 0 || pickedFields.has('publishedPostCount')) {
        result.publishedPostCount = overrides && overrides.hasOwnProperty('publishedPostCount') ? overrides.publishedPostCount! : 9515;
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('translationId')) {
        result.translationId = overrides && overrides.hasOwnProperty('translationId') ? overrides.translationId! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlInput(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlInput({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogTagLanguageCount = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogTagLanguageCount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('languageCode')) {
        result.languageCode = overrides && overrides.hasOwnProperty('languageCode') ? overrides.languageCode! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('tagCount')) {
        result.tagCount = overrides && overrides.hasOwnProperty('tagCount') ? overrides.tagCount! : 9129;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogUpdateTagRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogUpdateTagRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['inventore'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField.Seo];
    }
    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? aComWixpressNpmCommunitiesPlatformizedBlogTagInput(overrides.tag ?? {}, pickedFields.get('tag')) : aComWixpressNpmCommunitiesPlatformizedBlogTagInput({}, pickedFields.get('tag'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogUpdateTagResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogUpdateTagResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? aComWixpressNpmCommunitiesPlatformizedBlogTag(overrides.tag ?? {}, pickedFields.get('tag')) : aComWixpressNpmCommunitiesPlatformizedBlogTag({}, pickedFields.get('tag'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Category(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Category({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categories')) {
        result.categories = overrides && overrides.hasOwnProperty('categories') ? overrides.categories!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput({}, pickedFields.get('categories'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput({}, pickedFields.get('categories'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField.InternalId];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : false;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3BulkDeleteCategoryRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkDeleteCategoryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryIds')) {
        result.categoryIds = overrides && overrides.hasOwnProperty('categoryIds') ? overrides.categoryIds! : ['nostrum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('permanent')) {
        result.permanent = overrides && overrides.hasOwnProperty('permanent') ? overrides.permanent! : false;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('postIds')) {
        result.postIds = overrides && overrides.hasOwnProperty('postIds') ? overrides.postIds! : ['sed'];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metrics')) {
        result.metrics = overrides && overrides.hasOwnProperty('metrics') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Metrics(overrides.metrics ?? {}, pickedFields.get('metrics')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Metrics({}, pickedFields.get('metrics'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('postIds')) {
        result.postIds = overrides && overrides.hasOwnProperty('postIds') ? overrides.postIds! : ['assumenda'];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('reactionsMap')) {
        result.reactionsMap = overrides && overrides.hasOwnProperty('reactionsMap') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Reactions(overrides.reactionsMap ?? {}, pickedFields.get('reactionsMap')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Reactions({}, pickedFields.get('reactionsMap'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categories')) {
        result.categories = overrides && overrides.hasOwnProperty('categories') ? overrides.categories!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3MaskedCategoryInput({}, pickedFields.get('categories'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3MaskedCategoryInput({}, pickedFields.get('categories'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField.InternalId];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : false;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3Category = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coverImage')) {
        result.coverImage = overrides && overrides.hasOwnProperty('coverImage') ? aWixCommonImage(overrides.coverImage ?? {}, pickedFields.get('coverImage')) : aWixCommonImage({}, pickedFields.get('coverImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('displayPosition')) {
        result.displayPosition = overrides && overrides.hasOwnProperty('displayPosition') ? overrides.displayPosition! : 5309;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('internalId')) {
        result.internalId = overrides && overrides.hasOwnProperty('internalId') ? overrides.internalId! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('postCount')) {
        result.postCount = overrides && overrides.hasOwnProperty('postCount') ? overrides.postCount! : 262;
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('translationId')) {
        result.translationId = overrides && overrides.hasOwnProperty('translationId') ? overrides.translationId! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('translations')) {
        result.translations = overrides && overrides.hasOwnProperty('translations') ? overrides.translations!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslation(x ?? {}, pickedFields.get('translations'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslation({}, pickedFields.get('translations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrl(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrl({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coverImage')) {
        result.coverImage = overrides && overrides.hasOwnProperty('coverImage') ? aWixCommonImageInput(overrides.coverImage ?? {}, pickedFields.get('coverImage')) : aWixCommonImageInput({}, pickedFields.get('coverImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('displayPosition')) {
        result.displayPosition = overrides && overrides.hasOwnProperty('displayPosition') ? overrides.displayPosition! : 7271;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('internalId')) {
        result.internalId = overrides && overrides.hasOwnProperty('internalId') ? overrides.internalId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('postCount')) {
        result.postCount = overrides && overrides.hasOwnProperty('postCount') ? overrides.postCount! : 2095;
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('translationId')) {
        result.translationId = overrides && overrides.hasOwnProperty('translationId') ? overrides.translationId! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('translations')) {
        result.translations = overrides && overrides.hasOwnProperty('translations') ? overrides.translations!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslationInput({}, pickedFields.get('translations'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslationInput({}, pickedFields.get('translations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlInput(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlInput({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryLanguageCount = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryLanguageCount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryCount')) {
        result.categoryCount = overrides && overrides.hasOwnProperty('categoryCount') ? overrides.categoryCount! : 4370;
    }
    if (pickedFields.size === 0 || pickedFields.has('languageCode')) {
        result.languageCode = overrides && overrides.hasOwnProperty('languageCode') ? overrides.languageCode! : 'explicabo';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslation = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrl(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrl({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslationInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlInput(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlInput({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('content')) {
        result.content = overrides && overrides.hasOwnProperty('content') ? overrides.content! : 'animi';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('richContent')) {
        result.richContent = overrides && overrides.hasOwnProperty('richContent') ? overrides.richContent! : 'quasi';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('richContent')) {
        result.richContent = overrides && overrides.hasOwnProperty('richContent') ? overrides.richContent! : 'perspiciatis';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('content')) {
        result.content = overrides && overrides.hasOwnProperty('content') ? overrides.content! : 'culpa';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput(overrides.category ?? {}, pickedFields.get('category')) : aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput({}, pickedFields.get('category'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField.InternalId];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Category(overrides.category ?? {}, pickedFields.get('category')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Category({}, pickedFields.get('category'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('postTemplateId')) {
        result.postTemplateId = overrides && overrides.hasOwnProperty('postTemplateId') ? overrides.postTemplateId! : 'rerum';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('draftPost')) {
        result.draftPost = overrides && overrides.hasOwnProperty('draftPost') ? aComWixpressNpmCommunitiesPlatformizedBlogV3DraftPost(overrides.draftPost ?? {}, pickedFields.get('draftPost')) : aComWixpressNpmCommunitiesPlatformizedBlogV3DraftPost({}, pickedFields.get('draftPost'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3DeleteCategoryRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3DeleteCategoryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryId')) {
        result.categoryId = overrides && overrides.hasOwnProperty('categoryId') ? overrides.categoryId! : 'id';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3DraftPost = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPost>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryIds')) {
        result.categoryIds = overrides && overrides.hasOwnProperty('categoryIds') ? overrides.categoryIds! : ['quis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('changeOrigin')) {
        result.changeOrigin = overrides && overrides.hasOwnProperty('changeOrigin') ? overrides.changeOrigin! : ComWixpressNpmCommunitiesPlatformizedBlogV3ChangeOriginOrigin.AddCategories;
    }
    if (pickedFields.size === 0 || pickedFields.has('commentingEnabled')) {
        result.commentingEnabled = overrides && overrides.hasOwnProperty('commentingEnabled') ? overrides.commentingEnabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('content')) {
        result.content = overrides && overrides.hasOwnProperty('content') ? overrides.content! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('contentId')) {
        result.contentId = overrides && overrides.hasOwnProperty('contentId') ? overrides.contentId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('coverMedia')) {
        result.coverMedia = overrides && overrides.hasOwnProperty('coverMedia') ? aComWixpressNpmCommunitiesPlatformizedBlogCoverMedia(overrides.coverMedia ?? {}, pickedFields.get('coverMedia')) : aComWixpressNpmCommunitiesPlatformizedBlogCoverMedia({}, pickedFields.get('coverMedia'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('editedDate')) {
        result.editedDate = overrides && overrides.hasOwnProperty('editedDate') ? overrides.editedDate! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('editingSessionId')) {
        result.editingSessionId = overrides && overrides.hasOwnProperty('editingSessionId') ? overrides.editingSessionId! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('excerpt')) {
        result.excerpt = overrides && overrides.hasOwnProperty('excerpt') ? overrides.excerpt! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('featured')) {
        result.featured = overrides && overrides.hasOwnProperty('featured') ? overrides.featured! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('firstPublishedDate')) {
        result.firstPublishedDate = overrides && overrides.hasOwnProperty('firstPublishedDate') ? overrides.firstPublishedDate! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('hasUnpublishedChanges')) {
        result.hasUnpublishedChanges = overrides && overrides.hasOwnProperty('hasUnpublishedChanges') ? overrides.hasUnpublishedChanges! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('hashtags')) {
        result.hashtags = overrides && overrides.hasOwnProperty('hashtags') ? overrides.hashtags! : ['vel'];
    }
    if (pickedFields.size === 0 || pickedFields.has('heroImage')) {
        result.heroImage = overrides && overrides.hasOwnProperty('heroImage') ? aWixCommonImage(overrides.heroImage ?? {}, pickedFields.get('heroImage')) : aWixCommonImage({}, pickedFields.get('heroImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('internalId')) {
        result.internalId = overrides && overrides.hasOwnProperty('internalId') ? overrides.internalId! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aComWixpressNpmCommunitiesPlatformizedBlogMedia(overrides.media ?? {}, pickedFields.get('media')) : aComWixpressNpmCommunitiesPlatformizedBlogMedia({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('minutesToRead')) {
        result.minutesToRead = overrides && overrides.hasOwnProperty('minutesToRead') ? overrides.minutesToRead! : 7289;
    }
    if (pickedFields.size === 0 || pickedFields.has('moderationDetails')) {
        result.moderationDetails = overrides && overrides.hasOwnProperty('moderationDetails') ? aComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails(overrides.moderationDetails ?? {}, pickedFields.get('moderationDetails')) : aComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails({}, pickedFields.get('moderationDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mostRecentContributorId')) {
        result.mostRecentContributorId = overrides && overrides.hasOwnProperty('mostRecentContributorId') ? overrides.mostRecentContributorId! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('originPostId')) {
        result.originPostId = overrides && overrides.hasOwnProperty('originPostId') ? overrides.originPostId! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('originPostInstanceId')) {
        result.originPostInstanceId = overrides && overrides.hasOwnProperty('originPostInstanceId') ? overrides.originPostInstanceId! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('previewTextParagraph')) {
        result.previewTextParagraph = overrides && overrides.hasOwnProperty('previewTextParagraph') ? overrides.previewTextParagraph! : 9964;
    }
    if (pickedFields.size === 0 || pickedFields.has('pricingPlanIds')) {
        result.pricingPlanIds = overrides && overrides.hasOwnProperty('pricingPlanIds') ? overrides.pricingPlanIds! : ['molestiae'];
    }
    if (pickedFields.size === 0 || pickedFields.has('relatedPostIds')) {
        result.relatedPostIds = overrides && overrides.hasOwnProperty('relatedPostIds') ? overrides.relatedPostIds! : ['in'];
    }
    if (pickedFields.size === 0 || pickedFields.has('richContent')) {
        result.richContent = overrides && overrides.hasOwnProperty('richContent') ? aWixRichContentV1RichContent(overrides.richContent ?? {}, pickedFields.get('richContent')) : aWixRichContentV1RichContent({}, pickedFields.get('richContent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduledPublishDate')) {
        result.scheduledPublishDate = overrides && overrides.hasOwnProperty('scheduledPublishDate') ? overrides.scheduledPublishDate! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('seoSlug')) {
        result.seoSlug = overrides && overrides.hasOwnProperty('seoSlug') ? overrides.seoSlug! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('slugs')) {
        result.slugs = overrides && overrides.hasOwnProperty('slugs') ? overrides.slugs! : ['nisi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostStatusStatus.Deleted;
    }
    if (pickedFields.size === 0 || pickedFields.has('tagIds')) {
        result.tagIds = overrides && overrides.hasOwnProperty('tagIds') ? overrides.tagIds! : ['dolores'];
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('translationId')) {
        result.translationId = overrides && overrides.hasOwnProperty('translationId') ? overrides.translationId! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('translations')) {
        result.translations = overrides && overrides.hasOwnProperty('translations') ? overrides.translations!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostTranslation(x ?? {}, pickedFields.get('translations'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostTranslation({}, pickedFields.get('translations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrl(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrl({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostTranslation = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostTranslation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostStatusStatus.Deleted;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrl(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrl({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoriesCountByLanguageResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoriesCountByLanguageResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoriesLanguageCount')) {
        result.categoriesLanguageCount = overrides && overrides.hasOwnProperty('categoriesLanguageCount') ? overrides.categoriesLanguageCount!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryLanguageCount(x ?? {}, pickedFields.get('categoriesLanguageCount'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryLanguageCount({}, pickedFields.get('categoriesLanguageCount'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField.InternalId];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'fugiat';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Category(overrides.category ?? {}, pickedFields.get('category')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Category({}, pickedFields.get('category'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField.InternalId];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '49c03456-6604-40c0-bd3b-670dde4da535';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField.ContactId];
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'omnis';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('post')) {
        result.post = overrides && overrides.hasOwnProperty('post') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Post(overrides.post ?? {}, pickedFields.get('post')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Post({}, pickedFields.get('post'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('postId')) {
        result.postId = overrides && overrides.hasOwnProperty('postId') ? overrides.postId! : 'voluptas';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metrics')) {
        result.metrics = overrides && overrides.hasOwnProperty('metrics') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Metrics(overrides.metrics ?? {}, pickedFields.get('metrics')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Metrics({}, pickedFields.get('metrics'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetPostRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField.ContactId];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b1a50858-e829-4e40-b044-78bf241d8eaf';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('postTemplateId')) {
        result.postTemplateId = overrides && overrides.hasOwnProperty('postTemplateId') ? overrides.postTemplateId! : 'veniam';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('postTemplate')) {
        result.postTemplate = overrides && overrides.hasOwnProperty('postTemplate') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Post(overrides.postTemplate ?? {}, pickedFields.get('postTemplate')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Post({}, pickedFields.get('postTemplate'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'iste';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 8863;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3LikePostRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3LikePostRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField.ContactId];
    }
    if (pickedFields.size === 0 || pickedFields.has('postId')) {
        result.postId = overrides && overrides.hasOwnProperty('postId') ? overrides.postId! : 'cum';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3LikePostResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3LikePostResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('post')) {
        result.post = overrides && overrides.hasOwnProperty('post') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Post(overrides.post ?? {}, pickedFields.get('post')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Post({}, pickedFields.get('post'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField.InternalId];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categories')) {
        result.categories = overrides && overrides.hasOwnProperty('categories') ? overrides.categories!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3Category(x ?? {}, pickedFields.get('categories'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3Category({}, pickedFields.get('categories'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('metaData')) {
        result.metaData = overrides && overrides.hasOwnProperty('metaData') ? aComWixpressNpmCommunitiesPlatformizedBlogMetaData(overrides.metaData ?? {}, pickedFields.get('metaData')) : aComWixpressNpmCommunitiesPlatformizedBlogMetaData({}, pickedFields.get('metaData'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryIds')) {
        result.categoryIds = overrides && overrides.hasOwnProperty('categoryIds') ? overrides.categoryIds! : ['culpa'];
    }
    if (pickedFields.size === 0 || pickedFields.has('featured')) {
        result.featured = overrides && overrides.hasOwnProperty('featured') ? overrides.featured! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField.ContactId];
    }
    if (pickedFields.size === 0 || pickedFields.has('hashtags')) {
        result.hashtags = overrides && overrides.hasOwnProperty('hashtags') ? overrides.hashtags! : ['ad'];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort! : ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostsSort.Feed;
    }
    if (pickedFields.size === 0 || pickedFields.has('tagIds')) {
        result.tagIds = overrides && overrides.hasOwnProperty('tagIds') ? overrides.tagIds! : ['numquam'];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaData')) {
        result.metaData = overrides && overrides.hasOwnProperty('metaData') ? aComWixpressNpmCommunitiesPlatformizedBlogMetaData(overrides.metaData ?? {}, pickedFields.get('metaData')) : aComWixpressNpmCommunitiesPlatformizedBlogMetaData({}, pickedFields.get('metaData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('posts')) {
        result.posts = overrides && overrides.hasOwnProperty('posts') ? overrides.posts!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3Post(x ?? {}, pickedFields.get('posts'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3Post({}, pickedFields.get('posts'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField.ContactId];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('month')) {
        result.month = overrides && overrides.hasOwnProperty('month') ? overrides.month! : 6713;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('year')) {
        result.year = overrides && overrides.hasOwnProperty('year') ? overrides.year! : 6985;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaData')) {
        result.metaData = overrides && overrides.hasOwnProperty('metaData') ? aComWixpressNpmCommunitiesPlatformizedBlogMetaData(overrides.metaData ?? {}, pickedFields.get('metaData')) : aComWixpressNpmCommunitiesPlatformizedBlogMetaData({}, pickedFields.get('metaData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('posts')) {
        result.posts = overrides && overrides.hasOwnProperty('posts') ? overrides.posts!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3Post(x ?? {}, pickedFields.get('posts'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3Post({}, pickedFields.get('posts'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryIds')) {
        result.categoryIds = overrides && overrides.hasOwnProperty('categoryIds') ? overrides.categoryIds! : ['cupiditate'];
    }
    if (pickedFields.size === 0 || pickedFields.has('featured')) {
        result.featured = overrides && overrides.hasOwnProperty('featured') ? overrides.featured! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField.ContactId];
    }
    if (pickedFields.size === 0 || pickedFields.has('hashtags')) {
        result.hashtags = overrides && overrides.hasOwnProperty('hashtags') ? overrides.hashtags! : ['magnam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort! : ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostsSort.Feed;
    }
    if (pickedFields.size === 0 || pickedFields.has('tagIds')) {
        result.tagIds = overrides && overrides.hasOwnProperty('tagIds') ? overrides.tagIds! : ['impedit'];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaData')) {
        result.metaData = overrides && overrides.hasOwnProperty('metaData') ? aComWixpressNpmCommunitiesPlatformizedBlogMetaData(overrides.metaData ?? {}, pickedFields.get('metaData')) : aComWixpressNpmCommunitiesPlatformizedBlogMetaData({}, pickedFields.get('metaData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('posts')) {
        result.posts = overrides && overrides.hasOwnProperty('posts') ? overrides.posts!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3Post(x ?? {}, pickedFields.get('posts'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3Post({}, pickedFields.get('posts'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryIds')) {
        result.categoryIds = overrides && overrides.hasOwnProperty('categoryIds') ? overrides.categoryIds! : ['maiores'];
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('listTemplateCategories')) {
        result.listTemplateCategories = overrides && overrides.hasOwnProperty('listTemplateCategories') ? overrides.listTemplateCategories! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort! : ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesRequestGetPostTemplatesSort.PublishedDateAsc;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('postTemplates')) {
        result.postTemplates = overrides && overrides.hasOwnProperty('postTemplates') ? overrides.postTemplates!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3Post(x ?? {}, pickedFields.get('postTemplates'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3Post({}, pickedFields.get('postTemplates'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('postTemplatesMetaData')) {
        result.postTemplatesMetaData = overrides && overrides.hasOwnProperty('postTemplatesMetaData') ? aComWixpressNpmCommunitiesPlatformizedBlogMetaData(overrides.postTemplatesMetaData ?? {}, pickedFields.get('postTemplatesMetaData')) : aComWixpressNpmCommunitiesPlatformizedBlogMetaData({}, pickedFields.get('postTemplatesMetaData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('templateCategories')) {
        result.templateCategories = overrides && overrides.hasOwnProperty('templateCategories') ? overrides.templateCategories!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3Category(x ?? {}, pickedFields.get('templateCategories'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3Category({}, pickedFields.get('templateCategories'))];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3MaskedCategoryInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3MaskedCategoryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput(overrides.category ?? {}, pickedFields.get('category')) : aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput({}, pickedFields.get('category'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['qui'];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3Metrics = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3Metrics>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('averageRating')) {
        result.averageRating = overrides && overrides.hasOwnProperty('averageRating') ? overrides.averageRating! : 2.14;
    }
    if (pickedFields.size === 0 || pickedFields.has('comments')) {
        result.comments = overrides && overrides.hasOwnProperty('comments') ? overrides.comments! : 1579;
    }
    if (pickedFields.size === 0 || pickedFields.has('likes')) {
        result.likes = overrides && overrides.hasOwnProperty('likes') ? overrides.likes! : 86;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalRatings')) {
        result.totalRatings = overrides && overrides.hasOwnProperty('totalRatings') ? overrides.totalRatings! : 8875;
    }
    if (pickedFields.size === 0 || pickedFields.has('views')) {
        result.views = overrides && overrides.hasOwnProperty('views') ? overrides.views! : 2183;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('moderatedBy')) {
        result.moderatedBy = overrides && overrides.hasOwnProperty('moderatedBy') ? overrides.moderatedBy! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('moderationDate')) {
        result.moderationDate = overrides && overrides.hasOwnProperty('moderationDate') ? overrides.moderationDate! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationStatusStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('submittedBy')) {
        result.submittedBy = overrides && overrides.hasOwnProperty('submittedBy') ? overrides.submittedBy! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('submittedDate')) {
        result.submittedDate = overrides && overrides.hasOwnProperty('submittedDate') ? overrides.submittedDate! : 'non';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3PinPostRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3PinPostRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField.ContactId];
    }
    if (pickedFields.size === 0 || pickedFields.has('postId')) {
        result.postId = overrides && overrides.hasOwnProperty('postId') ? overrides.postId! : 'veritatis';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3PinPostResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3PinPostResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('post')) {
        result.post = overrides && overrides.hasOwnProperty('post') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Post(overrides.post ?? {}, pickedFields.get('post')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Post({}, pickedFields.get('post'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3Post = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryIds')) {
        result.categoryIds = overrides && overrides.hasOwnProperty('categoryIds') ? overrides.categoryIds! : ['blanditiis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('commentingEnabled')) {
        result.commentingEnabled = overrides && overrides.hasOwnProperty('commentingEnabled') ? overrides.commentingEnabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('content')) {
        result.content = overrides && overrides.hasOwnProperty('content') ? overrides.content! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('contentId')) {
        result.contentId = overrides && overrides.hasOwnProperty('contentId') ? overrides.contentId! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('contentText')) {
        result.contentText = overrides && overrides.hasOwnProperty('contentText') ? overrides.contentText! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('coverMedia')) {
        result.coverMedia = overrides && overrides.hasOwnProperty('coverMedia') ? aComWixpressNpmCommunitiesPlatformizedBlogCoverMedia(overrides.coverMedia ?? {}, pickedFields.get('coverMedia')) : aComWixpressNpmCommunitiesPlatformizedBlogCoverMedia({}, pickedFields.get('coverMedia'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customExcerpt')) {
        result.customExcerpt = overrides && overrides.hasOwnProperty('customExcerpt') ? overrides.customExcerpt! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('excerpt')) {
        result.excerpt = overrides && overrides.hasOwnProperty('excerpt') ? overrides.excerpt! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('featured')) {
        result.featured = overrides && overrides.hasOwnProperty('featured') ? overrides.featured! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('firstPublishedDate')) {
        result.firstPublishedDate = overrides && overrides.hasOwnProperty('firstPublishedDate') ? overrides.firstPublishedDate! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('hasUnpublishedChanges')) {
        result.hasUnpublishedChanges = overrides && overrides.hasOwnProperty('hasUnpublishedChanges') ? overrides.hasUnpublishedChanges! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('hashtags')) {
        result.hashtags = overrides && overrides.hasOwnProperty('hashtags') ? overrides.hashtags! : ['quia'];
    }
    if (pickedFields.size === 0 || pickedFields.has('heroImage')) {
        result.heroImage = overrides && overrides.hasOwnProperty('heroImage') ? aWixCommonImage(overrides.heroImage ?? {}, pickedFields.get('heroImage')) : aWixCommonImage({}, pickedFields.get('heroImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('internalCategoryIds')) {
        result.internalCategoryIds = overrides && overrides.hasOwnProperty('internalCategoryIds') ? overrides.internalCategoryIds! : ['odio'];
    }
    if (pickedFields.size === 0 || pickedFields.has('internalId')) {
        result.internalId = overrides && overrides.hasOwnProperty('internalId') ? overrides.internalId! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('internalRelatedPostIds')) {
        result.internalRelatedPostIds = overrides && overrides.hasOwnProperty('internalRelatedPostIds') ? overrides.internalRelatedPostIds! : ['hic'];
    }
    if (pickedFields.size === 0 || pickedFields.has('isDemo')) {
        result.isDemo = overrides && overrides.hasOwnProperty('isDemo') ? overrides.isDemo! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastPublishedDate')) {
        result.lastPublishedDate = overrides && overrides.hasOwnProperty('lastPublishedDate') ? overrides.lastPublishedDate! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aComWixpressNpmCommunitiesPlatformizedBlogMedia(overrides.media ?? {}, pickedFields.get('media')) : aComWixpressNpmCommunitiesPlatformizedBlogMedia({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('metrics')) {
        result.metrics = overrides && overrides.hasOwnProperty('metrics') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Metrics(overrides.metrics ?? {}, pickedFields.get('metrics')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Metrics({}, pickedFields.get('metrics'));
    }
    if (pickedFields.size === 0 || pickedFields.has('minutesToRead')) {
        result.minutesToRead = overrides && overrides.hasOwnProperty('minutesToRead') ? overrides.minutesToRead! : 2121;
    }
    if (pickedFields.size === 0 || pickedFields.has('moderationDetails')) {
        result.moderationDetails = overrides && overrides.hasOwnProperty('moderationDetails') ? aComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails(overrides.moderationDetails ?? {}, pickedFields.get('moderationDetails')) : aComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails({}, pickedFields.get('moderationDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mostRecentContributorId')) {
        result.mostRecentContributorId = overrides && overrides.hasOwnProperty('mostRecentContributorId') ? overrides.mostRecentContributorId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('pinned')) {
        result.pinned = overrides && overrides.hasOwnProperty('pinned') ? overrides.pinned! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('postCountInfo')) {
        result.postCountInfo = overrides && overrides.hasOwnProperty('postCountInfo') ? aComWixpressNpmCommunitiesPlatformizedBlogV3PostCountInfo(overrides.postCountInfo ?? {}, pickedFields.get('postCountInfo')) : aComWixpressNpmCommunitiesPlatformizedBlogV3PostCountInfo({}, pickedFields.get('postCountInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('preview')) {
        result.preview = overrides && overrides.hasOwnProperty('preview') ? overrides.preview! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('pricingPlanIds')) {
        result.pricingPlanIds = overrides && overrides.hasOwnProperty('pricingPlanIds') ? overrides.pricingPlanIds! : ['aut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('referenceId')) {
        result.referenceId = overrides && overrides.hasOwnProperty('referenceId') ? overrides.referenceId! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('relatedPostIds')) {
        result.relatedPostIds = overrides && overrides.hasOwnProperty('relatedPostIds') ? overrides.relatedPostIds! : ['nostrum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('richContent')) {
        result.richContent = overrides && overrides.hasOwnProperty('richContent') ? aWixRichContentV1RichContent(overrides.richContent ?? {}, pickedFields.get('richContent')) : aWixRichContentV1RichContent({}, pickedFields.get('richContent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('richContentCompressed')) {
        result.richContentCompressed = overrides && overrides.hasOwnProperty('richContentCompressed') ? overrides.richContentCompressed! : ['sunt'];
    }
    if (pickedFields.size === 0 || pickedFields.has('richContentString')) {
        result.richContentString = overrides && overrides.hasOwnProperty('richContentString') ? overrides.richContentString! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('tagIds')) {
        result.tagIds = overrides && overrides.hasOwnProperty('tagIds') ? overrides.tagIds! : ['in'];
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('translationId')) {
        result.translationId = overrides && overrides.hasOwnProperty('translationId') ? overrides.translationId! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('translations')) {
        result.translations = overrides && overrides.hasOwnProperty('translations') ? overrides.translations!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3PostTranslation(x ?? {}, pickedFields.get('translations'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3PostTranslation({}, pickedFields.get('translations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrl(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrl({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3PostCountInfo = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('comments')) {
        result.comments = overrides && overrides.hasOwnProperty('comments') ? overrides.comments! : 7826;
    }
    if (pickedFields.size === 0 || pickedFields.has('likes')) {
        result.likes = overrides && overrides.hasOwnProperty('likes') ? overrides.likes! : 4974;
    }
    if (pickedFields.size === 0 || pickedFields.has('views')) {
        result.views = overrides && overrides.hasOwnProperty('views') ? overrides.views! : 4470;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('anonymousVisitorId')) {
        result.anonymousVisitorId = overrides && overrides.hasOwnProperty('anonymousVisitorId') ? overrides.anonymousVisitorId! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('counter')) {
        result.counter = overrides && overrides.hasOwnProperty('counter') ? overrides.counter! : 2921;
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('postId')) {
        result.postId = overrides && overrides.hasOwnProperty('postId') ? overrides.postId! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('postInternalId')) {
        result.postInternalId = overrides && overrides.hasOwnProperty('postInternalId') ? overrides.postInternalId! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedCounterField')) {
        result.updatedCounterField = overrides && overrides.hasOwnProperty('updatedCounterField') ? overrides.updatedCounterField! : ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedFieldField.LikeCount;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3PostLikedInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3PostLikedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('anonymousVisitorId')) {
        result.anonymousVisitorId = overrides && overrides.hasOwnProperty('anonymousVisitorId') ? overrides.anonymousVisitorId! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('postId')) {
        result.postId = overrides && overrides.hasOwnProperty('postId') ? overrides.postId! : 'dolor';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3PostTranslation = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3PostTranslation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrl(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrl({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField.InternalId];
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3Category(x ?? {}, pickedFields.get('items'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3Category({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField.ContactId];
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressNpmCommunitiesPlatformizedBlogV3Post(x ?? {}, pickedFields.get('items'))) : [aComWixpressNpmCommunitiesPlatformizedBlogV3Post({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3Reactions = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3Reactions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liked')) {
        result.liked = overrides && overrides.hasOwnProperty('liked') ? overrides.liked! : true;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField.ContactId];
    }
    if (pickedFields.size === 0 || pickedFields.has('postId')) {
        result.postId = overrides && overrides.hasOwnProperty('postId') ? overrides.postId! : 'in';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('post')) {
        result.post = overrides && overrides.hasOwnProperty('post') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Post(overrides.post ?? {}, pickedFields.get('post')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Post({}, pickedFields.get('post'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField.ContactId];
    }
    if (pickedFields.size === 0 || pickedFields.has('postId')) {
        result.postId = overrides && overrides.hasOwnProperty('postId') ? overrides.postId! : 'voluptatum';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('post')) {
        result.post = overrides && overrides.hasOwnProperty('post') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Post(overrides.post ?? {}, pickedFields.get('post')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Post({}, pickedFields.get('post'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput(overrides.category ?? {}, pickedFields.get('category')) : aComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput({}, pickedFields.get('category'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['reprehenderit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField.InternalId];
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aComWixpressNpmCommunitiesPlatformizedBlogV3Category(overrides.category ?? {}, pickedFields.get('category')) : aComWixpressNpmCommunitiesPlatformizedBlogV3Category({}, pickedFields.get('category'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostRequestInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('postId')) {
        result.postId = overrides && overrides.hasOwnProperty('postId') ? overrides.postId! : 'ut';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostResponse = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('views')) {
        result.views = overrides && overrides.hasOwnProperty('views') ? overrides.views! : 2953;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedBlogWixMedia = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedBlogWixMedia>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('videoV2')) {
        result.videoV2 = overrides && overrides.hasOwnProperty('videoV2') ? aWixCommonVideoV2(overrides.videoV2 ?? {}, pickedFields.get('videoV2')) : aWixCommonVideoV2({}, pickedFields.get('videoV2'));
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedUpstreamTagCursorPagingInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedUpstreamTagCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3825;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedUpstreamTagPagingInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedUpstreamTagPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 4;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 2320;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 4918;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursors = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'eveniet';
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2995;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 2989;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingMetadataV2 = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingMetadataV2>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3761;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 6674;
    }
    if (pickedFields.size === 0 || pickedFields.has('tooManyToCount')) {
        result.tooManyToCount = overrides && overrides.hasOwnProperty('tooManyToCount') ? overrides.tooManyToCount! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 2724;
    }

    return result;
};

export const aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput = <T extends Partial<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressPortfolioCollectionsCollection = <T extends Partial<ComWixpressPortfolioCollectionsCollection>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coverImage')) {
        result.coverImage = overrides && overrides.hasOwnProperty('coverImage') ? aComWixpressPortfolioCommonImage(overrides.coverImage ?? {}, pickedFields.get('coverImage')) : aComWixpressPortfolioCommonImage({}, pickedFields.get('coverImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('projectVirtualReference')) {
        result.projectVirtualReference = overrides && overrides.hasOwnProperty('projectVirtualReference') ? overrides.projectVirtualReference!.map((x) => aComWixpressPortfolioProjectsProject(x ?? {}, pickedFields.get('projectVirtualReference'))) : [aComWixpressPortfolioProjectsProject({}, pickedFields.get('projectVirtualReference'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 9420;
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 0.66;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlV2(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlV2({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressPortfolioCollectionsCollectionInput = <T extends Partial<ComWixpressPortfolioCollectionsCollectionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coverImage')) {
        result.coverImage = overrides && overrides.hasOwnProperty('coverImage') ? aComWixpressPortfolioCommonImageInput(overrides.coverImage ?? {}, pickedFields.get('coverImage')) : aComWixpressPortfolioCommonImageInput({}, pickedFields.get('coverImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'repudiandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 6610;
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 4.62;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlV2Input(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlV2Input({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressPortfolioCollectionsCreateCollectionRequestInput = <T extends Partial<ComWixpressPortfolioCollectionsCreateCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collection')) {
        result.collection = overrides && overrides.hasOwnProperty('collection') ? aComWixpressPortfolioCollectionsCollectionInput(overrides.collection ?? {}, pickedFields.get('collection')) : aComWixpressPortfolioCollectionsCollectionInput({}, pickedFields.get('collection'));
    }

    return result;
};

export const aComWixpressPortfolioCollectionsCreateCollectionResponse = <T extends Partial<ComWixpressPortfolioCollectionsCreateCollectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collection')) {
        result.collection = overrides && overrides.hasOwnProperty('collection') ? aComWixpressPortfolioCollectionsCollection(overrides.collection ?? {}, pickedFields.get('collection')) : aComWixpressPortfolioCollectionsCollection({}, pickedFields.get('collection'));
    }

    return result;
};

export const aComWixpressPortfolioCollectionsDeleteCollectionRequestInput = <T extends Partial<ComWixpressPortfolioCollectionsDeleteCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collectionId')) {
        result.collectionId = overrides && overrides.hasOwnProperty('collectionId') ? overrides.collectionId! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 2532;
    }

    return result;
};

export const aComWixpressPortfolioCollectionsDeleteCollectionResponse = <T extends Partial<ComWixpressPortfolioCollectionsDeleteCollectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collectionId')) {
        result.collectionId = overrides && overrides.hasOwnProperty('collectionId') ? overrides.collectionId! : 'et';
    }

    return result;
};

export const aComWixpressPortfolioCollectionsListCollectionsRequestInput = <T extends Partial<ComWixpressPortfolioCollectionsListCollectionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includePageUrl')) {
        result.includePageUrl = overrides && overrides.hasOwnProperty('includePageUrl') ? overrides.includePageUrl! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aComWixpressPortfolioCollectionsListCollectionsResponse = <T extends Partial<ComWixpressPortfolioCollectionsListCollectionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collections')) {
        result.collections = overrides && overrides.hasOwnProperty('collections') ? overrides.collections!.map((x) => aComWixpressPortfolioCollectionsCollection(x ?? {}, pickedFields.get('collections'))) : [aComWixpressPortfolioCollectionsCollection({}, pickedFields.get('collections'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixCommonPagingMetadataV2(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadataV2')) {
        result.pagingMetadataV2 = overrides && overrides.hasOwnProperty('pagingMetadataV2') ? aWixCommonPagingMetadataV2(overrides.pagingMetadataV2 ?? {}, pickedFields.get('pagingMetadataV2')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadataV2'));
    }

    return result;
};

export const aComWixpressPortfolioCollectionsQueryCollectionsResponse = <T extends Partial<ComWixpressPortfolioCollectionsQueryCollectionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressPortfolioCollectionsCollection(x ?? {}, pickedFields.get('items'))) : [aComWixpressPortfolioCollectionsCollection({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressPortfolioCollectionsUpdateCollectionRequestInput = <T extends Partial<ComWixpressPortfolioCollectionsUpdateCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collection')) {
        result.collection = overrides && overrides.hasOwnProperty('collection') ? aComWixpressPortfolioCollectionsCollectionInput(overrides.collection ?? {}, pickedFields.get('collection')) : aComWixpressPortfolioCollectionsCollectionInput({}, pickedFields.get('collection'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['mollitia'];
    }

    return result;
};

export const aComWixpressPortfolioCollectionsUpdateCollectionResponse = <T extends Partial<ComWixpressPortfolioCollectionsUpdateCollectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collection')) {
        result.collection = overrides && overrides.hasOwnProperty('collection') ? aComWixpressPortfolioCollectionsCollection(overrides.collection ?? {}, pickedFields.get('collection')) : aComWixpressPortfolioCollectionsCollection({}, pickedFields.get('collection'));
    }

    return result;
};

export const aComWixpressPortfolioCommonImage = <T extends Partial<ComWixpressPortfolioCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exif')) {
        result.exif = overrides && overrides.hasOwnProperty('exif') ? overrides.exif! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('focalPoint')) {
        result.focalPoint = overrides && overrides.hasOwnProperty('focalPoint') ? aComWixpressPortfolioCommonPoint(overrides.focalPoint ?? {}, pickedFields.get('focalPoint')) : aComWixpressPortfolioCommonPoint({}, pickedFields.get('focalPoint'));
    }
    if (pickedFields.size === 0 || pickedFields.has('imageInfo')) {
        result.imageInfo = overrides && overrides.hasOwnProperty('imageInfo') ? anUpstreamWixCommonPortfolioCommonImage(overrides.imageInfo ?? {}, pickedFields.get('imageInfo')) : anUpstreamWixCommonPortfolioCommonImage({}, pickedFields.get('imageInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quality')) {
        result.quality = overrides && overrides.hasOwnProperty('quality') ? overrides.quality! : 4690;
    }
    if (pickedFields.size === 0 || pickedFields.has('secure')) {
        result.secure = overrides && overrides.hasOwnProperty('secure') ? overrides.secure! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('token')) {
        result.token = overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixpressPortfolioCommonImageImageType.External;
    }
    if (pickedFields.size === 0 || pickedFields.has('unsharpMasking')) {
        result.unsharpMasking = overrides && overrides.hasOwnProperty('unsharpMasking') ? aComWixpressPortfolioCommonUnsharpMasking(overrides.unsharpMasking ?? {}, pickedFields.get('unsharpMasking')) : aComWixpressPortfolioCommonUnsharpMasking({}, pickedFields.get('unsharpMasking'));
    }

    return result;
};

export const aComWixpressPortfolioCommonImageInput = <T extends Partial<ComWixpressPortfolioCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exif')) {
        result.exif = overrides && overrides.hasOwnProperty('exif') ? overrides.exif! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('focalPoint')) {
        result.focalPoint = overrides && overrides.hasOwnProperty('focalPoint') ? aComWixpressPortfolioCommonPointInput(overrides.focalPoint ?? {}, pickedFields.get('focalPoint')) : aComWixpressPortfolioCommonPointInput({}, pickedFields.get('focalPoint'));
    }
    if (pickedFields.size === 0 || pickedFields.has('imageInfo')) {
        result.imageInfo = overrides && overrides.hasOwnProperty('imageInfo') ? anUpstreamWixCommonPortfolioCommonImageInput(overrides.imageInfo ?? {}, pickedFields.get('imageInfo')) : anUpstreamWixCommonPortfolioCommonImageInput({}, pickedFields.get('imageInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quality')) {
        result.quality = overrides && overrides.hasOwnProperty('quality') ? overrides.quality! : 6608;
    }
    if (pickedFields.size === 0 || pickedFields.has('secure')) {
        result.secure = overrides && overrides.hasOwnProperty('secure') ? overrides.secure! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('token')) {
        result.token = overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixpressPortfolioCommonImageImageType.External;
    }
    if (pickedFields.size === 0 || pickedFields.has('unsharpMasking')) {
        result.unsharpMasking = overrides && overrides.hasOwnProperty('unsharpMasking') ? aComWixpressPortfolioCommonUnsharpMaskingInput(overrides.unsharpMasking ?? {}, pickedFields.get('unsharpMasking')) : aComWixpressPortfolioCommonUnsharpMaskingInput({}, pickedFields.get('unsharpMasking'));
    }

    return result;
};

export const aComWixpressPortfolioCommonPoint = <T extends Partial<ComWixpressPortfolioCommonPoint>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('x')) {
        result.x = overrides && overrides.hasOwnProperty('x') ? overrides.x! : 0.13;
    }
    if (pickedFields.size === 0 || pickedFields.has('y')) {
        result.y = overrides && overrides.hasOwnProperty('y') ? overrides.y! : 9.55;
    }

    return result;
};

export const aComWixpressPortfolioCommonPointInput = <T extends Partial<ComWixpressPortfolioCommonPointInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('x')) {
        result.x = overrides && overrides.hasOwnProperty('x') ? overrides.x! : 4.01;
    }
    if (pickedFields.size === 0 || pickedFields.has('y')) {
        result.y = overrides && overrides.hasOwnProperty('y') ? overrides.y! : 4.1;
    }

    return result;
};

export const aComWixpressPortfolioCommonUnsharpMasking = <T extends Partial<ComWixpressPortfolioCommonUnsharpMasking>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 5.06;
    }
    if (pickedFields.size === 0 || pickedFields.has('radius')) {
        result.radius = overrides && overrides.hasOwnProperty('radius') ? overrides.radius! : 4.48;
    }
    if (pickedFields.size === 0 || pickedFields.has('threshold')) {
        result.threshold = overrides && overrides.hasOwnProperty('threshold') ? overrides.threshold! : 8.39;
    }

    return result;
};

export const aComWixpressPortfolioCommonUnsharpMaskingInput = <T extends Partial<ComWixpressPortfolioCommonUnsharpMaskingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 0.59;
    }
    if (pickedFields.size === 0 || pickedFields.has('radius')) {
        result.radius = overrides && overrides.hasOwnProperty('radius') ? overrides.radius! : 9.38;
    }
    if (pickedFields.size === 0 || pickedFields.has('threshold')) {
        result.threshold = overrides && overrides.hasOwnProperty('threshold') ? overrides.threshold! : 4.44;
    }

    return result;
};

export const aComWixpressPortfolioCommonVideo = <T extends Partial<ComWixpressPortfolioCommonVideo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durationInMillis')) {
        result.durationInMillis = overrides && overrides.hasOwnProperty('durationInMillis') ? overrides.durationInMillis! : 8593;
    }
    if (pickedFields.size === 0 || pickedFields.has('videoInfo')) {
        result.videoInfo = overrides && overrides.hasOwnProperty('videoInfo') ? anUpstreamWixCommonPortfolioCommonVideoV2(overrides.videoInfo ?? {}, pickedFields.get('videoInfo')) : anUpstreamWixCommonPortfolioCommonVideoV2({}, pickedFields.get('videoInfo'));
    }

    return result;
};

export const aComWixpressPortfolioCommonVideoInput = <T extends Partial<ComWixpressPortfolioCommonVideoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durationInMillis')) {
        result.durationInMillis = overrides && overrides.hasOwnProperty('durationInMillis') ? overrides.durationInMillis! : 4723;
    }
    if (pickedFields.size === 0 || pickedFields.has('videoInfo')) {
        result.videoInfo = overrides && overrides.hasOwnProperty('videoInfo') ? anUpstreamWixCommonPortfolioCommonVideoV2Input(overrides.videoInfo ?? {}, pickedFields.get('videoInfo')) : anUpstreamWixCommonPortfolioCommonVideoV2Input({}, pickedFields.get('videoInfo'));
    }

    return result;
};

export const aComWixpressPortfolioPortfolioappAdminRemoveMenuItemsResponse = <T extends Partial<ComWixpressPortfolioPortfolioappAdminRemoveMenuItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('numItems')) {
        result.numItems = overrides && overrides.hasOwnProperty('numItems') ? overrides.numItems! : 3364;
    }
    if (pickedFields.size === 0 || pickedFields.has('numItemsSuccessfullyDeleted')) {
        result.numItemsSuccessfullyDeleted = overrides && overrides.hasOwnProperty('numItemsSuccessfullyDeleted') ? overrides.numItemsSuccessfullyDeleted! : 6385;
    }

    return result;
};

export const aComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsRequestInput = <T extends Partial<ComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mediaIds')) {
        result.mediaIds = overrides && overrides.hasOwnProperty('mediaIds') ? overrides.mediaIds! : ['rem'];
    }

    return result;
};

export const aComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsResponse = <T extends Partial<ComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mediaTokens')) {
        result.mediaTokens = overrides && overrides.hasOwnProperty('mediaTokens') ? overrides.mediaTokens!.map((x) => aComWixpressPortfolioPortfolioappProjectItemMediaToken(x ?? {}, pickedFields.get('mediaTokens'))) : [aComWixpressPortfolioPortfolioappProjectItemMediaToken({}, pickedFields.get('mediaTokens'))];
    }

    return result;
};

export const aComWixpressPortfolioPortfolioappGetProjectPageDataRequestInput = <T extends Partial<ComWixpressPortfolioPortfolioappGetProjectPageDataRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collectionSlug')) {
        result.collectionSlug = overrides && overrides.hasOwnProperty('collectionSlug') ? overrides.collectionSlug! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('projectSlug')) {
        result.projectSlug = overrides && overrides.hasOwnProperty('projectSlug') ? overrides.projectSlug! : 'sequi';
    }

    return result;
};

export const aComWixpressPortfolioPortfolioappGetProjectPageDataResponse = <T extends Partial<ComWixpressPortfolioPortfolioappGetProjectPageDataResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nextProject')) {
        result.nextProject = overrides && overrides.hasOwnProperty('nextProject') ? aComWixpressPortfolioPortfolioappProjectSlug(overrides.nextProject ?? {}, pickedFields.get('nextProject')) : aComWixpressPortfolioPortfolioappProjectSlug({}, pickedFields.get('nextProject'));
    }
    if (pickedFields.size === 0 || pickedFields.has('previousProject')) {
        result.previousProject = overrides && overrides.hasOwnProperty('previousProject') ? aComWixpressPortfolioPortfolioappProjectSlug(overrides.previousProject ?? {}, pickedFields.get('previousProject')) : aComWixpressPortfolioPortfolioappProjectSlug({}, pickedFields.get('previousProject'));
    }
    if (pickedFields.size === 0 || pickedFields.has('project')) {
        result.project = overrides && overrides.hasOwnProperty('project') ? aComWixpressPortfolioProjectsProject(overrides.project ?? {}, pickedFields.get('project')) : aComWixpressPortfolioProjectsProject({}, pickedFields.get('project'));
    }

    return result;
};

export const aComWixpressPortfolioPortfolioappProjectItemMediaToken = <T extends Partial<ComWixpressPortfolioPortfolioappProjectItemMediaToken>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mediaId')) {
        result.mediaId = overrides && overrides.hasOwnProperty('mediaId') ? overrides.mediaId! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('mediaToken')) {
        result.mediaToken = overrides && overrides.hasOwnProperty('mediaToken') ? overrides.mediaToken! : 'unde';
    }

    return result;
};

export const aComWixpressPortfolioPortfolioappProjectSlug = <T extends Partial<ComWixpressPortfolioPortfolioappProjectSlug>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'est';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsBulkCreateProjectItemResult = <T extends Partial<ComWixpressPortfolioProjectitemsBulkCreateProjectItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressPortfolioProjectitemsItem(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressPortfolioProjectitemsItem({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsBulkCreateProjectItemsRequestInput = <T extends Partial<ComWixpressPortfolioProjectitemsBulkCreateProjectItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressPortfolioProjectitemsItemInput({}, pickedFields.get('items'))) : [aComWixpressPortfolioProjectitemsItemInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : true;
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsBulkCreateProjectItemsResponse = <T extends Partial<ComWixpressPortfolioProjectitemsBulkCreateProjectItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressPortfolioProjectitemsBulkCreateProjectItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressPortfolioProjectitemsBulkCreateProjectItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsBulkDeleteProjectItemResult = <T extends Partial<ComWixpressPortfolioProjectitemsBulkDeleteProjectItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsBulkDeleteProjectItemsRequestInput = <T extends Partial<ComWixpressPortfolioProjectitemsBulkDeleteProjectItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemIds')) {
        result.itemIds = overrides && overrides.hasOwnProperty('itemIds') ? overrides.itemIds! : ['consequatur'];
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'laborum';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsBulkDeleteProjectItemsResponse = <T extends Partial<ComWixpressPortfolioProjectitemsBulkDeleteProjectItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressPortfolioProjectitemsBulkDeleteProjectItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressPortfolioProjectitemsBulkDeleteProjectItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsBulkUpdateProjectItemResult = <T extends Partial<ComWixpressPortfolioProjectitemsBulkUpdateProjectItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressPortfolioProjectitemsItem(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressPortfolioProjectitemsItem({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsBulkUpdateProjectItemsRequestInput = <T extends Partial<ComWixpressPortfolioProjectitemsBulkUpdateProjectItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressPortfolioProjectitemsMaskedItemInput({}, pickedFields.get('items'))) : [aComWixpressPortfolioProjectitemsMaskedItemInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : false;
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsBulkUpdateProjectItemsResponse = <T extends Partial<ComWixpressPortfolioProjectitemsBulkUpdateProjectItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressPortfolioProjectitemsBulkUpdateProjectItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressPortfolioProjectitemsBulkUpdateProjectItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsCreateProjectGalleryRequestInput = <T extends Partial<ComWixpressPortfolioProjectitemsCreateProjectGalleryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'et';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsCreateProjectGalleryResponse = <T extends Partial<ComWixpressPortfolioProjectitemsCreateProjectGalleryResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('galleryId')) {
        result.galleryId = overrides && overrides.hasOwnProperty('galleryId') ? overrides.galleryId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'minus';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsCreateProjectItemRequestInput = <T extends Partial<ComWixpressPortfolioProjectitemsCreateProjectItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressPortfolioProjectitemsItemInput(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressPortfolioProjectitemsItemInput({}, pickedFields.get('item'));
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsCreateProjectItemResponse = <T extends Partial<ComWixpressPortfolioProjectitemsCreateProjectItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressPortfolioProjectitemsItem(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressPortfolioProjectitemsItem({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'natus';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsDeleteProjectItemRequestInput = <T extends Partial<ComWixpressPortfolioProjectitemsDeleteProjectItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'vel';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsDeleteProjectItemResponse = <T extends Partial<ComWixpressPortfolioProjectitemsDeleteProjectItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'odio';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsDuplicateProjectItemsRequestInput = <T extends Partial<ComWixpressPortfolioProjectitemsDuplicateProjectItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('originProjectId')) {
        result.originProjectId = overrides && overrides.hasOwnProperty('originProjectId') ? overrides.originProjectId! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('targetProjectId')) {
        result.targetProjectId = overrides && overrides.hasOwnProperty('targetProjectId') ? overrides.targetProjectId! : 'excepturi';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsDuplicateProjectItemsResponse = <T extends Partial<ComWixpressPortfolioProjectitemsDuplicateProjectItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'animi';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsItem = <T extends Partial<ComWixpressPortfolioProjectitemsItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixpressPortfolioCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aComWixpressPortfolioCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aComWixpressPortfolioProjectitemsLink(overrides.link ?? {}, pickedFields.get('link')) : aComWixpressPortfolioProjectitemsLink({}, pickedFields.get('link'));
    }
    if (pickedFields.size === 0 || pickedFields.has('project')) {
        result.project = overrides && overrides.hasOwnProperty('project') ? aComWixpressPortfolioProjectsProject(overrides.project ?? {}, pickedFields.get('project')) : aComWixpressPortfolioProjectsProject({}, pickedFields.get('project'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 4.64;
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? aComWixpressPortfolioProjectitemsTags(overrides.tags ?? {}, pickedFields.get('tags')) : aComWixpressPortfolioProjectitemsTags({}, pickedFields.get('tags'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixpressPortfolioProjectitemsItemType.Image;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aComWixpressPortfolioCommonVideo(overrides.video ?? {}, pickedFields.get('video')) : aComWixpressPortfolioCommonVideo({}, pickedFields.get('video'));
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsItemInput = <T extends Partial<ComWixpressPortfolioProjectitemsItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixpressPortfolioCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aComWixpressPortfolioCommonImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aComWixpressPortfolioProjectitemsLinkInput(overrides.link ?? {}, pickedFields.get('link')) : aComWixpressPortfolioProjectitemsLinkInput({}, pickedFields.get('link'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 7.68;
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? aComWixpressPortfolioProjectitemsTagsInput(overrides.tags ?? {}, pickedFields.get('tags')) : aComWixpressPortfolioProjectitemsTagsInput({}, pickedFields.get('tags'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixpressPortfolioProjectitemsItemType.Image;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aComWixpressPortfolioCommonVideoInput(overrides.video ?? {}, pickedFields.get('video')) : aComWixpressPortfolioCommonVideoInput({}, pickedFields.get('video'));
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsLink = <T extends Partial<ComWixpressPortfolioProjectitemsLink>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'quia';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsLinkInput = <T extends Partial<ComWixpressPortfolioProjectitemsLinkInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'quidem';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsListProjectItemsRequestInput = <T extends Partial<ComWixpressPortfolioProjectitemsListProjectItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'nam';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsListProjectItemsResponse = <T extends Partial<ComWixpressPortfolioProjectitemsListProjectItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressPortfolioProjectitemsItem(x ?? {}, pickedFields.get('items'))) : [aComWixpressPortfolioProjectitemsItem({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixCommonPagingMetadataV2(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadataV2')) {
        result.pagingMetadataV2 = overrides && overrides.hasOwnProperty('pagingMetadataV2') ? aWixCommonPagingMetadataV2(overrides.pagingMetadataV2 ?? {}, pickedFields.get('pagingMetadataV2')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadataV2'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'expedita';
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsMaskedItemInput = <T extends Partial<ComWixpressPortfolioProjectitemsMaskedItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['temporibus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressPortfolioProjectitemsItemInput(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressPortfolioProjectitemsItemInput({}, pickedFields.get('item'));
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsQueryProjectItemsResponse = <T extends Partial<ComWixpressPortfolioProjectitemsQueryProjectItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressPortfolioProjectitemsItem(x ?? {}, pickedFields.get('items'))) : [aComWixpressPortfolioProjectitemsItem({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsTags = <T extends Partial<ComWixpressPortfolioProjectitemsTags>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values! : ['harum'];
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsTagsInput = <T extends Partial<ComWixpressPortfolioProjectitemsTagsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values! : ['cum'];
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsUpdateProjectItemRequestInput = <T extends Partial<ComWixpressPortfolioProjectitemsUpdateProjectItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressPortfolioProjectitemsItemInput(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressPortfolioProjectitemsItemInput({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['occaecati'];
    }

    return result;
};

export const aComWixpressPortfolioProjectitemsUpdateProjectItemResponse = <T extends Partial<ComWixpressPortfolioProjectitemsUpdateProjectItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressPortfolioProjectitemsItem(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressPortfolioProjectitemsItem({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'tenetur';
    }

    return result;
};

export const aComWixpressPortfolioProjectsCreateProjectRequestInput = <T extends Partial<ComWixpressPortfolioProjectsCreateProjectRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('project')) {
        result.project = overrides && overrides.hasOwnProperty('project') ? aComWixpressPortfolioProjectsProjectInput(overrides.project ?? {}, pickedFields.get('project')) : aComWixpressPortfolioProjectsProjectInput({}, pickedFields.get('project'));
    }

    return result;
};

export const aComWixpressPortfolioProjectsCreateProjectResponse = <T extends Partial<ComWixpressPortfolioProjectsCreateProjectResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('project')) {
        result.project = overrides && overrides.hasOwnProperty('project') ? aComWixpressPortfolioProjectsProject(overrides.project ?? {}, pickedFields.get('project')) : aComWixpressPortfolioProjectsProject({}, pickedFields.get('project'));
    }

    return result;
};

export const aComWixpressPortfolioProjectsDeleteProjectRequestInput = <T extends Partial<ComWixpressPortfolioProjectsDeleteProjectRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 7396;
    }

    return result;
};

export const aComWixpressPortfolioProjectsDeleteProjectResponse = <T extends Partial<ComWixpressPortfolioProjectsDeleteProjectResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'quae';
    }

    return result;
};

export const aComWixpressPortfolioProjectsDetailsLink = <T extends Partial<ComWixpressPortfolioProjectsDetailsLink>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'aut';
    }

    return result;
};

export const aComWixpressPortfolioProjectsDetailsLinkInput = <T extends Partial<ComWixpressPortfolioProjectsDetailsLinkInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'distinctio';
    }

    return result;
};

export const aComWixpressPortfolioProjectsListProjectsRequestInput = <T extends Partial<ComWixpressPortfolioProjectsListProjectsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includePageUrl')) {
        result.includePageUrl = overrides && overrides.hasOwnProperty('includePageUrl') ? overrides.includePageUrl! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aComWixpressPortfolioProjectsListProjectsResponse = <T extends Partial<ComWixpressPortfolioProjectsListProjectsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixCommonPagingMetadataV2(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadataV2')) {
        result.pagingMetadataV2 = overrides && overrides.hasOwnProperty('pagingMetadataV2') ? aWixCommonPagingMetadataV2(overrides.pagingMetadataV2 ?? {}, pickedFields.get('pagingMetadataV2')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadataV2'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projects')) {
        result.projects = overrides && overrides.hasOwnProperty('projects') ? overrides.projects!.map((x) => aComWixpressPortfolioProjectsProject(x ?? {}, pickedFields.get('projects'))) : [aComWixpressPortfolioProjectsProject({}, pickedFields.get('projects'))];
    }

    return result;
};

export const aComWixpressPortfolioProjectsProject = <T extends Partial<ComWixpressPortfolioProjectsProject>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collectionIds')) {
        result.collectionIds = overrides && overrides.hasOwnProperty('collectionIds') ? overrides.collectionIds! : ['consequatur'];
    }
    if (pickedFields.size === 0 || pickedFields.has('collections')) {
        result.collections = overrides && overrides.hasOwnProperty('collections') ? overrides.collections!.map((x) => aComWixpressPortfolioCollectionsCollection(x ?? {}, pickedFields.get('collections'))) : [aComWixpressPortfolioCollectionsCollection({}, pickedFields.get('collections'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('coverImage')) {
        result.coverImage = overrides && overrides.hasOwnProperty('coverImage') ? aComWixpressPortfolioCommonImage(overrides.coverImage ?? {}, pickedFields.get('coverImage')) : aComWixpressPortfolioCommonImage({}, pickedFields.get('coverImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('coverVideo')) {
        result.coverVideo = overrides && overrides.hasOwnProperty('coverVideo') ? aComWixpressPortfolioCommonVideo(overrides.coverVideo ?? {}, pickedFields.get('coverVideo')) : aComWixpressPortfolioCommonVideo({}, pickedFields.get('coverVideo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details!.map((x) => aComWixpressPortfolioProjectsProjectDetail(x ?? {}, pickedFields.get('details'))) : [aComWixpressPortfolioProjectsProjectDetail({}, pickedFields.get('details'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemsVirtualReference')) {
        result.itemsVirtualReference = overrides && overrides.hasOwnProperty('itemsVirtualReference') ? overrides.itemsVirtualReference!.map((x) => aComWixpressPortfolioProjectitemsItem(x ?? {}, pickedFields.get('itemsVirtualReference'))) : [aComWixpressPortfolioProjectitemsItem({}, pickedFields.get('itemsVirtualReference'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 2739;
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? aComWixpressPortfolioProjectsProjectSource(overrides.source ?? {}, pickedFields.get('source')) : aComWixpressPortfolioProjectsProjectSource({}, pickedFields.get('source'));
    }
    if (pickedFields.size === 0 || pickedFields.has('syncedProject')) {
        result.syncedProject = overrides && overrides.hasOwnProperty('syncedProject') ? overrides.syncedProject! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlV2(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlV2({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressPortfolioProjectsProjectDetail = <T extends Partial<ComWixpressPortfolioProjectsProjectDetail>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aComWixpressPortfolioProjectsDetailsLink(overrides.link ?? {}, pickedFields.get('link')) : aComWixpressPortfolioProjectsDetailsLink({}, pickedFields.get('link'));
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'necessitatibus';
    }

    return result;
};

export const aComWixpressPortfolioProjectsProjectDetailInput = <T extends Partial<ComWixpressPortfolioProjectsProjectDetailInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aComWixpressPortfolioProjectsDetailsLinkInput(overrides.link ?? {}, pickedFields.get('link')) : aComWixpressPortfolioProjectsDetailsLinkInput({}, pickedFields.get('link'));
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'laboriosam';
    }

    return result;
};

export const aComWixpressPortfolioProjectsProjectInCollection = <T extends Partial<ComWixpressPortfolioProjectsProjectInCollection>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collectionId')) {
        result.collectionId = overrides && overrides.hasOwnProperty('collectionId') ? overrides.collectionId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('project')) {
        result.project = overrides && overrides.hasOwnProperty('project') ? aComWixpressPortfolioProjectsProject(overrides.project ?? {}, pickedFields.get('project')) : aComWixpressPortfolioProjectsProject({}, pickedFields.get('project'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 5.59;
    }

    return result;
};

export const aComWixpressPortfolioProjectsProjectInput = <T extends Partial<ComWixpressPortfolioProjectsProjectInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collectionIds')) {
        result.collectionIds = overrides && overrides.hasOwnProperty('collectionIds') ? overrides.collectionIds! : ['qui'];
    }
    if (pickedFields.size === 0 || pickedFields.has('coverImage')) {
        result.coverImage = overrides && overrides.hasOwnProperty('coverImage') ? aComWixpressPortfolioCommonImageInput(overrides.coverImage ?? {}, pickedFields.get('coverImage')) : aComWixpressPortfolioCommonImageInput({}, pickedFields.get('coverImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('coverVideo')) {
        result.coverVideo = overrides && overrides.hasOwnProperty('coverVideo') ? aComWixpressPortfolioCommonVideoInput(overrides.coverVideo ?? {}, pickedFields.get('coverVideo')) : aComWixpressPortfolioCommonVideoInput({}, pickedFields.get('coverVideo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'repudiandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details!.map((x) => aComWixpressPortfolioProjectsProjectDetailInput({}, pickedFields.get('details'))) : [aComWixpressPortfolioProjectsProjectDetailInput({}, pickedFields.get('details'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 7930;
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? aComWixpressPortfolioProjectsProjectSourceInput(overrides.source ?? {}, pickedFields.get('source')) : aComWixpressPortfolioProjectsProjectSourceInput({}, pickedFields.get('source'));
    }
    if (pickedFields.size === 0 || pickedFields.has('syncedProject')) {
        result.syncedProject = overrides && overrides.hasOwnProperty('syncedProject') ? overrides.syncedProject! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'repudiandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlV2Input(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlV2Input({}, pickedFields.get('url'));
    }

    return result;
};

export const aComWixpressPortfolioProjectsProjectSource = <T extends Partial<ComWixpressPortfolioProjectsProjectSource>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appDefId')) {
        result.appDefId = overrides && overrides.hasOwnProperty('appDefId') ? overrides.appDefId! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSync')) {
        result.lastSync = overrides && overrides.hasOwnProperty('lastSync') ? overrides.lastSync! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('notEditableFields')) {
        result.notEditableFields = overrides && overrides.hasOwnProperty('notEditableFields') ? overrides.notEditableFields! : ['optio'];
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceName')) {
        result.sourceName = overrides && overrides.hasOwnProperty('sourceName') ? overrides.sourceName! : 'vero';
    }
    if (pickedFields.size === 0 || pickedFields.has('syncStatus')) {
        result.syncStatus = overrides && overrides.hasOwnProperty('syncStatus') ? overrides.syncStatus! : ComWixpressPortfolioProjectsProjectSourceSyncStatus.NotSynced;
    }

    return result;
};

export const aComWixpressPortfolioProjectsProjectSourceInput = <T extends Partial<ComWixpressPortfolioProjectsProjectSourceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appDefId')) {
        result.appDefId = overrides && overrides.hasOwnProperty('appDefId') ? overrides.appDefId! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSync')) {
        result.lastSync = overrides && overrides.hasOwnProperty('lastSync') ? overrides.lastSync! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('notEditableFields')) {
        result.notEditableFields = overrides && overrides.hasOwnProperty('notEditableFields') ? overrides.notEditableFields! : ['sunt'];
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceName')) {
        result.sourceName = overrides && overrides.hasOwnProperty('sourceName') ? overrides.sourceName! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('syncStatus')) {
        result.syncStatus = overrides && overrides.hasOwnProperty('syncStatus') ? overrides.syncStatus! : ComWixpressPortfolioProjectsProjectSourceSyncStatus.NotSynced;
    }

    return result;
};

export const aComWixpressPortfolioProjectsQueryProjectWithCollectionInfoRequestInput = <T extends Partial<ComWixpressPortfolioProjectsQueryProjectWithCollectionInfoRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includePageUrl')) {
        result.includePageUrl = overrides && overrides.hasOwnProperty('includePageUrl') ? overrides.includePageUrl! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressPortfolioProjectsQueryProjectWithCollectionInfoResponse = <T extends Partial<ComWixpressPortfolioProjectsQueryProjectWithCollectionInfoResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixCommonPagingMetadataV2(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadataV2')) {
        result.pagingMetadataV2 = overrides && overrides.hasOwnProperty('pagingMetadataV2') ? aWixCommonPagingMetadataV2(overrides.pagingMetadataV2 ?? {}, pickedFields.get('pagingMetadataV2')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadataV2'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projects')) {
        result.projects = overrides && overrides.hasOwnProperty('projects') ? overrides.projects!.map((x) => aComWixpressPortfolioProjectsProjectInCollection(x ?? {}, pickedFields.get('projects'))) : [aComWixpressPortfolioProjectsProjectInCollection({}, pickedFields.get('projects'))];
    }

    return result;
};

export const aComWixpressPortfolioProjectsQueryProjectsResponse = <T extends Partial<ComWixpressPortfolioProjectsQueryProjectsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressPortfolioProjectsProject(x ?? {}, pickedFields.get('items'))) : [aComWixpressPortfolioProjectsProject({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressPortfolioProjectsUpdateProjectOrderInCollectionRequestInput = <T extends Partial<ComWixpressPortfolioProjectsUpdateProjectOrderInCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collectionId')) {
        result.collectionId = overrides && overrides.hasOwnProperty('collectionId') ? overrides.collectionId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('projectId')) {
        result.projectId = overrides && overrides.hasOwnProperty('projectId') ? overrides.projectId! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 6.98;
    }

    return result;
};

export const aComWixpressPortfolioProjectsUpdateProjectOrderInCollectionResponse = <T extends Partial<ComWixpressPortfolioProjectsUpdateProjectOrderInCollectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('project')) {
        result.project = overrides && overrides.hasOwnProperty('project') ? aComWixpressPortfolioProjectsProjectInCollection(overrides.project ?? {}, pickedFields.get('project')) : aComWixpressPortfolioProjectsProjectInCollection({}, pickedFields.get('project'));
    }
    if (pickedFields.size === 0 || pickedFields.has('projectInCollection')) {
        result.projectInCollection = overrides && overrides.hasOwnProperty('projectInCollection') ? aComWixpressPortfolioProjectsProjectInCollection(overrides.projectInCollection ?? {}, pickedFields.get('projectInCollection')) : aComWixpressPortfolioProjectsProjectInCollection({}, pickedFields.get('projectInCollection'));
    }

    return result;
};

export const aComWixpressPortfolioProjectsUpdateProjectRequestInput = <T extends Partial<ComWixpressPortfolioProjectsUpdateProjectRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['soluta'];
    }
    if (pickedFields.size === 0 || pickedFields.has('project')) {
        result.project = overrides && overrides.hasOwnProperty('project') ? aComWixpressPortfolioProjectsProjectInput(overrides.project ?? {}, pickedFields.get('project')) : aComWixpressPortfolioProjectsProjectInput({}, pickedFields.get('project'));
    }

    return result;
};

export const aComWixpressPortfolioProjectsUpdateProjectResponse = <T extends Partial<ComWixpressPortfolioProjectsUpdateProjectResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('project')) {
        result.project = overrides && overrides.hasOwnProperty('project') ? aComWixpressPortfolioProjectsProject(overrides.project ?? {}, pickedFields.get('project')) : aComWixpressPortfolioProjectsProject({}, pickedFields.get('project'));
    }

    return result;
};

export const aComWixpressPremiumDomainsNotificationsUserDomainInfoChangedEventInput = <T extends Partial<ComWixpressPremiumDomainsNotificationsUserDomainInfoChangedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('changeTime')) {
        result.changeTime = overrides && overrides.hasOwnProperty('changeTime') ? overrides.changeTime! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('crudType')) {
        result.crudType = overrides && overrides.hasOwnProperty('crudType') ? overrides.crudType! : ComWixpressPremiumDomainsNotificationsCrudType.Create;
    }
    if (pickedFields.size === 0 || pickedFields.has('domainName')) {
        result.domainName = overrides && overrides.hasOwnProperty('domainName') ? overrides.domainName! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'veniam';
    }

    return result;
};

export const aComWixpressQuotesAddressDescriptionInput = <T extends Partial<ComWixpressQuotesAddressDescriptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('content')) {
        result.content = overrides && overrides.hasOwnProperty('content') ? overrides.content! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('placement')) {
        result.placement = overrides && overrides.hasOwnProperty('placement') ? overrides.placement! : ComWixpressQuotesAddressDescriptionPlacement.After;
    }

    return result;
};

export const aComWixpressQuotesAddressInput = <T extends Partial<ComWixpressQuotesAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aComWixpressQuotesAddressDescriptionInput(overrides.description ?? {}, pickedFields.get('description')) : aComWixpressQuotesAddressDescriptionInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('state')) {
        result.state = overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'expedita';
    }
    if (pickedFields.size === 0 || pickedFields.has('street')) {
        result.street = overrides && overrides.hasOwnProperty('street') ? overrides.street! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('zip')) {
        result.zip = overrides && overrides.hasOwnProperty('zip') ? overrides.zip! : 'blanditiis';
    }

    return result;
};

export const aComWixpressQuotesApiEventsInvoicePaidEventInput = <T extends Partial<ComWixpressQuotesApiEventsInvoicePaidEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('data')) {
        result.data = overrides && overrides.hasOwnProperty('data') ? aComWixpressQuotesInvoicesInvoiceFieldsInput(overrides.data ?? {}, pickedFields.get('data')) : aComWixpressQuotesInvoicesInvoiceFieldsInput({}, pickedFields.get('data'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? aComWixpressQuotesIdAndVersionInput(overrides.id ?? {}, pickedFields.get('id')) : aComWixpressQuotesIdAndVersionInput({}, pickedFields.get('id'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressQuotesInvoicesInvoiceStatus.Deleted;
    }

    return result;
};

export const aComWixpressQuotesApiEventsInvoiceSentEventInput = <T extends Partial<ComWixpressQuotesApiEventsInvoiceSentEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('data')) {
        result.data = overrides && overrides.hasOwnProperty('data') ? aComWixpressQuotesInvoicesInvoiceFieldsInput(overrides.data ?? {}, pickedFields.get('data')) : aComWixpressQuotesInvoicesInvoiceFieldsInput({}, pickedFields.get('data'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? aComWixpressQuotesIdAndVersionInput(overrides.id ?? {}, pickedFields.get('id')) : aComWixpressQuotesIdAndVersionInput({}, pickedFields.get('id'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : ComWixpressQuotesInvoicesInvoiceStatus.Deleted;
    }

    return result;
};

export const aComWixpressQuotesBigDecimalWrapperInput = <T extends Partial<ComWixpressQuotesBigDecimalWrapperInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('serializedValue')) {
        result.serializedValue = overrides && overrides.hasOwnProperty('serializedValue') ? overrides.serializedValue! : 9.87;
    }

    return result;
};

export const aComWixpressQuotesCalculatedTaxInput = <T extends Partial<ComWixpressQuotesCalculatedTaxInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.rate ?? {}, pickedFields.get('rate')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('rate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxable')) {
        result.taxable = overrides && overrides.hasOwnProperty('taxable') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.taxable ?? {}, pickedFields.get('taxable')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('taxable'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxed')) {
        result.taxed = overrides && overrides.hasOwnProperty('taxed') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.taxed ?? {}, pickedFields.get('taxed')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('taxed'));
    }

    return result;
};

export const aComWixpressQuotesCalculatedTaxesInput = <T extends Partial<ComWixpressQuotesCalculatedTaxesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('taxes')) {
        result.taxes = overrides && overrides.hasOwnProperty('taxes') ? overrides.taxes!.map((x) => aComWixpressQuotesCalculatedTaxInput({}, pickedFields.get('taxes'))) : [aComWixpressQuotesCalculatedTaxInput({}, pickedFields.get('taxes'))];
    }

    return result;
};

export const aComWixpressQuotesCompanyInput = <T extends Partial<ComWixpressQuotesCompanyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quibusdam';
    }

    return result;
};

export const aComWixpressQuotesCustomerInput = <T extends Partial<ComWixpressQuotesCustomerInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixpressQuotesAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aComWixpressQuotesAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('billingAddress')) {
        result.billingAddress = overrides && overrides.hasOwnProperty('billingAddress') ? aWixCommonAddressInput(overrides.billingAddress ?? {}, pickedFields.get('billingAddress')) : aWixCommonAddressInput({}, pickedFields.get('billingAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? aComWixpressQuotesCompanyInput(overrides.company ?? {}, pickedFields.get('company')) : aComWixpressQuotesCompanyInput({}, pickedFields.get('company'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? aComWixpressQuotesEmailInput(overrides.email ?? {}, pickedFields.get('email')) : aComWixpressQuotesEmailInput({}, pickedFields.get('email'));
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? aComWixpressQuotesPhoneInput(overrides.phone ?? {}, pickedFields.get('phone')) : aComWixpressQuotesPhoneInput({}, pickedFields.get('phone'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingAddress')) {
        result.shippingAddress = overrides && overrides.hasOwnProperty('shippingAddress') ? aWixCommonAddressInput(overrides.shippingAddress ?? {}, pickedFields.get('shippingAddress')) : aWixCommonAddressInput({}, pickedFields.get('shippingAddress'));
    }

    return result;
};

export const aComWixpressQuotesDiscountInput = <T extends Partial<ComWixpressQuotesDiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fixed')) {
        result.fixed = overrides && overrides.hasOwnProperty('fixed') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.fixed ?? {}, pickedFields.get('fixed')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('fixed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.percentage ?? {}, pickedFields.get('percentage')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('percentage'));
    }

    return result;
};

export const aComWixpressQuotesEmailInput = <T extends Partial<ComWixpressQuotesEmailInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? overrides.address! : 'laboriosam';
    }

    return result;
};

export const aComWixpressQuotesIdAndVersionInput = <T extends Partial<ComWixpressQuotesIdAndVersionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 8509;
    }

    return result;
};

export const aComWixpressQuotesInvoicesDepositInput = <T extends Partial<ComWixpressQuotesInvoicesDepositInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('flatAmount')) {
        result.flatAmount = overrides && overrides.hasOwnProperty('flatAmount') ? overrides.flatAmount! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixpressQuotesInvoicesDepositDepositType.Flat;
    }

    return result;
};

export const aComWixpressQuotesInvoicesInvoiceDatesInput = <T extends Partial<ComWixpressQuotesInvoicesInvoiceDatesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dueDate')) {
        result.dueDate = overrides && overrides.hasOwnProperty('dueDate') ? overrides.dueDate! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('issueDate')) {
        result.issueDate = overrides && overrides.hasOwnProperty('issueDate') ? overrides.issueDate! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSeenDate')) {
        result.lastSeenDate = overrides && overrides.hasOwnProperty('lastSeenDate') ? overrides.lastSeenDate! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZoneCode')) {
        result.timeZoneCode = overrides && overrides.hasOwnProperty('timeZoneCode') ? overrides.timeZoneCode! : 'minima';
    }

    return result;
};

export const aComWixpressQuotesInvoicesInvoiceDynamicPriceTotalsInput = <T extends Partial<ComWixpressQuotesInvoicesInvoiceDynamicPriceTotalsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.balance ?? {}, pickedFields.get('balance')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('balance'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paidAmount')) {
        result.paidAmount = overrides && overrides.hasOwnProperty('paidAmount') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.paidAmount ?? {}, pickedFields.get('paidAmount')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('paidAmount'));
    }

    return result;
};

export const aComWixpressQuotesInvoicesInvoiceFieldsInput = <T extends Partial<ComWixpressQuotesInvoicesInvoiceFieldsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createOrder')) {
        result.createOrder = overrides && overrides.hasOwnProperty('createOrder') ? overrides.createOrder! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('creationAdditional_BIInformation')) {
        result.creationAdditional_BIInformation = overrides && overrides.hasOwnProperty('creationAdditional_BIInformation') ? overrides.creationAdditional_BIInformation! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyCode')) {
        result.currencyCode = overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields!.map((x) => aComWixpressCrmFinancialCommonApiV1CustomFieldValueInput({}, pickedFields.get('customFields'))) : [aComWixpressCrmFinancialCommonApiV1CustomFieldValueInput({}, pickedFields.get('customFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('customer')) {
        result.customer = overrides && overrides.hasOwnProperty('customer') ? aComWixpressQuotesCustomerInput(overrides.customer ?? {}, pickedFields.get('customer')) : aComWixpressQuotesCustomerInput({}, pickedFields.get('customer'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dates')) {
        result.dates = overrides && overrides.hasOwnProperty('dates') ? aComWixpressQuotesInvoicesInvoiceDatesInput(overrides.dates ?? {}, pickedFields.get('dates')) : aComWixpressQuotesInvoicesInvoiceDatesInput({}, pickedFields.get('dates'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deductTaxes')) {
        result.deductTaxes = overrides && overrides.hasOwnProperty('deductTaxes') ? overrides.deductTaxes! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('deposit')) {
        result.deposit = overrides && overrides.hasOwnProperty('deposit') ? aComWixpressQuotesInvoicesDepositInput(overrides.deposit ?? {}, pickedFields.get('deposit')) : aComWixpressQuotesInvoicesDepositInput({}, pickedFields.get('deposit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('designTemplateId')) {
        result.designTemplateId = overrides && overrides.hasOwnProperty('designTemplateId') ? overrides.designTemplateId! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixpressQuotesDiscountInput(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixpressQuotesDiscountInput({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dynamicTotals')) {
        result.dynamicTotals = overrides && overrides.hasOwnProperty('dynamicTotals') ? aComWixpressQuotesInvoicesInvoiceDynamicPriceTotalsInput(overrides.dynamicTotals ?? {}, pickedFields.get('dynamicTotals')) : aComWixpressQuotesInvoicesInvoiceDynamicPriceTotalsInput({}, pickedFields.get('dynamicTotals'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ecomCheckoutId')) {
        result.ecomCheckoutId = overrides && overrides.hasOwnProperty('ecomCheckoutId') ? overrides.ecomCheckoutId! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? aComWixpressQuotesLineItemsInput(overrides.lineItems ?? {}, pickedFields.get('lineItems')) : aComWixpressQuotesLineItemsInput({}, pickedFields.get('lineItems'));
    }
    if (pickedFields.size === 0 || pickedFields.has('locale')) {
        result.locale = overrides && overrides.hasOwnProperty('locale') ? aComWixpressQuotesLocaleInput(overrides.locale ?? {}, pickedFields.get('locale')) : aComWixpressQuotesLocaleInput({}, pickedFields.get('locale'));
    }
    if (pickedFields.size === 0 || pickedFields.has('metaData')) {
        result.metaData = overrides && overrides.hasOwnProperty('metaData') ? aComWixpressQuotesMetaDataInput(overrides.metaData ?? {}, pickedFields.get('metaData')) : aComWixpressQuotesMetaDataInput({}, pickedFields.get('metaData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? aComWixpressQuotesInvoicesPaymentsInput(overrides.payments ?? {}, pickedFields.get('payments')) : aComWixpressQuotesInvoicesPaymentsInput({}, pickedFields.get('payments'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxes')) {
        result.taxes = overrides && overrides.hasOwnProperty('taxes') ? aComWixpressQuotesCalculatedTaxesInput(overrides.taxes ?? {}, pickedFields.get('taxes')) : aComWixpressQuotesCalculatedTaxesInput({}, pickedFields.get('taxes'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('totals')) {
        result.totals = overrides && overrides.hasOwnProperty('totals') ? aComWixpressQuotesTotalPriceInput(overrides.totals ?? {}, pickedFields.get('totals')) : aComWixpressQuotesTotalPriceInput({}, pickedFields.get('totals'));
    }

    return result;
};

export const aComWixpressQuotesInvoicesPaymentInput = <T extends Partial<ComWixpressQuotesInvoicesPaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.amount ?? {}, pickedFields.get('amount')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('date')) {
        result.date = overrides && overrides.hasOwnProperty('date') ? overrides.date! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'debitis';
    }

    return result;
};

export const aComWixpressQuotesInvoicesPaymentsInput = <T extends Partial<ComWixpressQuotesInvoicesPaymentsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('payments')) {
        result.payments = overrides && overrides.hasOwnProperty('payments') ? overrides.payments!.map((x) => aComWixpressQuotesInvoicesPaymentInput({}, pickedFields.get('payments'))) : [aComWixpressQuotesInvoicesPaymentInput({}, pickedFields.get('payments'))];
    }

    return result;
};

export const aComWixpressQuotesItemizedFeeInput = <T extends Partial<ComWixpressQuotesItemizedFeeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('price'));
    }

    return result;
};

export const aComWixpressQuotesLineItemInput = <T extends Partial<ComWixpressQuotesLineItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aComWixpressQuotesLineItemMetaDataInput(overrides.metadata ?? {}, pickedFields.get('metadata')) : aComWixpressQuotesLineItemMetaDataInput({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vero';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.quantity ?? {}, pickedFields.get('quantity')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('quantity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? aWixCrmCommonSourceInput(overrides.source ?? {}, pickedFields.get('source')) : aWixCrmCommonSourceInput({}, pickedFields.get('source'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxedTotal')) {
        result.taxedTotal = overrides && overrides.hasOwnProperty('taxedTotal') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.taxedTotal ?? {}, pickedFields.get('taxedTotal')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('taxedTotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxes')) {
        result.taxes = overrides && overrides.hasOwnProperty('taxes') ? overrides.taxes!.map((x) => aComWixpressQuotesLineItemTaxInput({}, pickedFields.get('taxes'))) : [aComWixpressQuotesLineItemTaxInput({}, pickedFields.get('taxes'))];
    }

    return result;
};

export const aComWixpressQuotesLineItemMetaDataInput = <T extends Partial<ComWixpressQuotesLineItemMetaDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? overrides.metadata! : 'veritatis';
    }

    return result;
};

export const aComWixpressQuotesLineItemTaxInput = <T extends Partial<ComWixpressQuotesLineItemTaxInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.rate ?? {}, pickedFields.get('rate')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('rate'));
    }

    return result;
};

export const aComWixpressQuotesLineItemsInput = <T extends Partial<ComWixpressQuotesLineItemsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aComWixpressQuotesLineItemInput({}, pickedFields.get('lineItems'))) : [aComWixpressQuotesLineItemInput({}, pickedFields.get('lineItems'))];
    }

    return result;
};

export const aComWixpressQuotesLocaleInput = <T extends Partial<ComWixpressQuotesLocaleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('invariant')) {
        result.invariant = overrides && overrides.hasOwnProperty('invariant') ? overrides.invariant! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'iste';
    }

    return result;
};

export const aComWixpressQuotesMetaDataInput = <T extends Partial<ComWixpressQuotesMetaDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowEditByOthers')) {
        result.allowEditByOthers = overrides && overrides.hasOwnProperty('allowEditByOthers') ? overrides.allowEditByOthers! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('legalTerms')) {
        result.legalTerms = overrides && overrides.hasOwnProperty('legalTerms') ? overrides.legalTerms! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('notes')) {
        result.notes = overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'delectus';
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'at';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceProperties')) {
        result.sourceProperties = overrides && overrides.hasOwnProperty('sourceProperties') ? overrides.sourceProperties! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceRefId')) {
        result.sourceRefId = overrides && overrides.hasOwnProperty('sourceRefId') ? overrides.sourceRefId! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceUrl')) {
        result.sourceUrl = overrides && overrides.hasOwnProperty('sourceUrl') ? overrides.sourceUrl! : 'nostrum';
    }

    return result;
};

export const aComWixpressQuotesPhoneInput = <T extends Partial<ComWixpressQuotesPhoneInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'est';
    }

    return result;
};

export const aComWixpressQuotesTotalPriceInput = <T extends Partial<ComWixpressQuotesTotalPriceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discountAmount')) {
        result.discountAmount = overrides && overrides.hasOwnProperty('discountAmount') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.discountAmount ?? {}, pickedFields.get('discountAmount')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('discountAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fees')) {
        result.fees = overrides && overrides.hasOwnProperty('fees') ? overrides.fees!.map((x) => aComWixpressQuotesItemizedFeeInput({}, pickedFields.get('fees'))) : [aComWixpressQuotesItemizedFeeInput({}, pickedFields.get('fees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.subtotal ?? {}, pickedFields.get('subtotal')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('subtotal'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxedAmount')) {
        result.taxedAmount = overrides && overrides.hasOwnProperty('taxedAmount') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.taxedAmount ?? {}, pickedFields.get('taxedAmount')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('taxedAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? aComWixpressQuotesBigDecimalWrapperInput(overrides.total ?? {}, pickedFields.get('total')) : aComWixpressQuotesBigDecimalWrapperInput({}, pickedFields.get('total'));
    }

    return result;
};

export const aComWixpressRestHeadersEntry = <T extends Partial<ComWixpressRestHeadersEntry>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'voluptas';
    }

    return result;
};

export const aComWixpressRestRawHttpResponse = <T extends Partial<ComWixpressRestRawHttpResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('body')) {
        result.body = overrides && overrides.hasOwnProperty('body') ? overrides.body! : ['in'];
    }
    if (pickedFields.size === 0 || pickedFields.has('headers')) {
        result.headers = overrides && overrides.hasOwnProperty('headers') ? overrides.headers!.map((x) => aComWixpressRestHeadersEntry(x ?? {}, pickedFields.get('headers'))) : [aComWixpressRestHeadersEntry({}, pickedFields.get('headers'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('statusCode')) {
        result.statusCode = overrides && overrides.hasOwnProperty('statusCode') ? overrides.statusCode! : 5726;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['voluptatum'];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResponse = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResult = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1CloneLabelsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1CloneLabelsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'autem';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1CountLabelsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1CountLabelsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'perferendis';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1CountLabelsResponse = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1CountLabelsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 1408;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1CreateLabelRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1CreateLabelRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixpressRestaurantsMenusItemLabelsV1LabelInput(overrides.label ?? {}, pickedFields.get('label')) : aComWixpressRestaurantsMenusItemLabelsV1LabelInput({}, pickedFields.get('label'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1CreateLabelResponse = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1CreateLabelResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixpressRestaurantsMenusItemLabelsV1Label(overrides.label ?? {}, pickedFields.get('label')) : aComWixpressRestaurantsMenusItemLabelsV1Label({}, pickedFields.get('label'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1DeleteLabelRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1DeleteLabelRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('labelId')) {
        result.labelId = overrides && overrides.hasOwnProperty('labelId') ? overrides.labelId! : 'commodi';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfo = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'ut';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfoInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'laborum';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1GetLabelRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1GetLabelRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7dd0d3ac-85f0-4a04-ac3a-dfa16d3d751d';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1Label = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1Label>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfo(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfo({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('icon')) {
        result.icon = overrides && overrides.hasOwnProperty('icon') ? aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImage(overrides.icon ?? {}, pickedFields.get('icon')) : aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImage({}, pickedFields.get('icon'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'quia';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1LabelInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1LabelInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfoInput(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfoInput({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('icon')) {
        result.icon = overrides && overrides.hasOwnProperty('icon') ? aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImageInput(overrides.icon ?? {}, pickedFields.get('icon')) : aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImageInput({}, pickedFields.get('icon'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'natus';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'dolor';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1ListLabelsResponse = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1ListLabelsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('labels')) {
        result.labels = overrides && overrides.hasOwnProperty('labels') ? overrides.labels!.map((x) => aComWixpressRestaurantsMenusItemLabelsV1Label(x ?? {}, pickedFields.get('labels'))) : [aComWixpressRestaurantsMenusItemLabelsV1Label({}, pickedFields.get('labels'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1QueryLabelsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1QueryLabelsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1QueryLabelsResponse = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1QueryLabelsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressRestaurantsMenusItemLabelsV1Label(x ?? {}, pickedFields.get('items'))) : [aComWixpressRestaurantsMenusItemLabelsV1Label({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1UpdateLabelRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1UpdateLabelRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixpressRestaurantsMenusItemLabelsV1LabelInput(overrides.label ?? {}, pickedFields.get('label')) : aComWixpressRestaurantsMenusItemLabelsV1LabelInput({}, pickedFields.get('label'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['ad'];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1UpdateLabelResponse = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1UpdateLabelResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixpressRestaurantsMenusItemLabelsV1Label(overrides.label ?? {}, pickedFields.get('label')) : aComWixpressRestaurantsMenusItemLabelsV1Label({}, pickedFields.get('label'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonBulkActionMetadata = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonBulkActionMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalFailures')) {
        result.totalFailures = overrides && overrides.hasOwnProperty('totalFailures') ? overrides.totalFailures! : 8536;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalSuccesses')) {
        result.totalSuccesses = overrides && overrides.hasOwnProperty('totalSuccesses') ? overrides.totalSuccesses! : 773;
    }
    if (pickedFields.size === 0 || pickedFields.has('undetailedFailures')) {
        result.undetailedFailures = overrides && overrides.hasOwnProperty('undetailedFailures') ? overrides.undetailedFailures! : 8565;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3826;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorQueryInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImage = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 2929;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 8434;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImageInput = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 5867;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 3692;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonItemMetadata = <T extends Partial<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonItemMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiApplicationError(overrides.error ?? {}, pickedFields.get('error')) : aWixApiApplicationError({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalIndex')) {
        result.originalIndex = overrides && overrides.hasOwnProperty('originalIndex') ? overrides.originalIndex! : 8265;
    }
    if (pickedFields.size === 0 || pickedFields.has('success')) {
        result.success = overrides && overrides.hasOwnProperty('success') ? overrides.success! : true;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkCreateItemResult = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkCreateItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressRestaurantsMenusItemV1Item(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressRestaurantsMenusItemV1Item({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkCreateItemsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkCreateItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressRestaurantsMenusItemV1ItemInput({}, pickedFields.get('items'))) : [aComWixpressRestaurantsMenusItemV1ItemInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'exercitationem';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkCreateItemsResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkCreateItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusItemV1BulkCreateItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusItemV1BulkCreateItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkDeleteItemResult = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkDeleteItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkDeleteItemsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkDeleteItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['itaque'];
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'et';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkDeleteItemsResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkDeleteItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusItemV1BulkDeleteItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusItemV1BulkDeleteItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemIdLocationIds')) {
        result.itemIdLocationIds = overrides && overrides.hasOwnProperty('itemIdLocationIds') ? overrides.itemIdLocationIds!.map((x) => aComWixpressRestaurantsMenusItemV1ItemIdLocationIdsInput({}, pickedFields.get('itemIdLocationIds'))) : [aComWixpressRestaurantsMenusItemV1ItemIdLocationIdsInput({}, pickedFields.get('itemIdLocationIds'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['voluptatibus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('itemIds')) {
        result.itemIds = overrides && overrides.hasOwnProperty('itemIds') ? overrides.itemIds! : ['aut'];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestMaskedItemInput({}, pickedFields.get('items'))) : [aComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestMaskedItemInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'et';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestMaskedItemInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestMaskedItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressRestaurantsMenusItemV1ItemInput(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressRestaurantsMenusItemV1ItemInput({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['quasi'];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkUpdateItemResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusItemV1BulkUpdateItemResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusItemV1BulkUpdateItemResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1BulkUpdateItemResponseBulkItemResult = <T extends Partial<ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressRestaurantsMenusItemV1Item(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressRestaurantsMenusItemV1Item({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1CloneItemsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1CloneItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'et';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1CountItemsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1CountItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('searchDetails')) {
        result.searchDetails = overrides && overrides.hasOwnProperty('searchDetails') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput(overrides.searchDetails ?? {}, pickedFields.get('searchDetails')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput({}, pickedFields.get('searchDetails'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1CountItemsResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1CountItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 8817;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1CreateItemRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1CreateItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressRestaurantsMenusItemV1ItemInput(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressRestaurantsMenusItemV1ItemInput({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'aut';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1CreateItemResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1CreateItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressRestaurantsMenusItemV1Item(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressRestaurantsMenusItemV1Item({}, pickedFields.get('item'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1DeleteItemRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1DeleteItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'sit';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromModifierGroupsInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromModifierGroupsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['cum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroupIds')) {
        result.modifierGroupIds = overrides && overrides.hasOwnProperty('modifierGroupIds') ? overrides.modifierGroupIds! : ['culpa'];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromVariantsInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromVariantsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['odio'];
    }
    if (pickedFields.size === 0 || pickedFields.has('variantIds')) {
        result.variantIds = overrides && overrides.hasOwnProperty('variantIds') ? overrides.variantIds! : ['reprehenderit'];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1ExternalReferenceInfo = <T extends Partial<ComWixpressRestaurantsMenusItemV1ExternalReferenceInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'molestiae';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1ExternalReferenceInfoInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1ExternalReferenceInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'delectus';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1GetItemRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1GetItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '665d355f-b610-4ac6-b389-04697f3e3a75';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1Item = <T extends Partial<ComWixpressRestaurantsMenusItemV1Item>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalImages')) {
        result.additionalImages = overrides && overrides.hasOwnProperty('additionalImages') ? overrides.additionalImages!.map((x) => aComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage(x ?? {}, pickedFields.get('additionalImages'))) : [aComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage({}, pickedFields.get('additionalImages'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['accusantium'];
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'nisi';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aComWixpressRestaurantsMenusItemV1ExternalReferenceInfo(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aComWixpressRestaurantsMenusItemV1ExternalReferenceInfo({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('featured')) {
        result.featured = overrides && overrides.hasOwnProperty('featured') ? overrides.featured! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('labels')) {
        result.labels = overrides && overrides.hasOwnProperty('labels') ? overrides.labels!.map((x) => aComWixpressRestaurantsMenusItemV1Label(x ?? {}, pickedFields.get('labels'))) : [aComWixpressRestaurantsMenusItemV1Label({}, pickedFields.get('labels'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? aComWixpressLocationsQueryLocationsResponse(overrides.locations ?? {}, pickedFields.get('locations')) : aComWixpressLocationsQueryLocationsResponse({}, pickedFields.get('locations'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroups')) {
        result.modifierGroups = overrides && overrides.hasOwnProperty('modifierGroups') ? overrides.modifierGroups!.map((x) => aComWixpressRestaurantsMenusItemV1ModifierGroup(x ?? {}, pickedFields.get('modifierGroups'))) : [aComWixpressRestaurantsMenusItemV1ModifierGroup({}, pickedFields.get('modifierGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('oloMigrationItemId')) {
        result.oloMigrationItemId = overrides && overrides.hasOwnProperty('oloMigrationItemId') ? overrides.oloMigrationItemId! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderSettings')) {
        result.orderSettings = overrides && overrides.hasOwnProperty('orderSettings') ? aComWixpressRestaurantsMenusItemV1OrderSettings(overrides.orderSettings ?? {}, pickedFields.get('orderSettings')) : aComWixpressRestaurantsMenusItemV1OrderSettings({}, pickedFields.get('orderSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceInfo')) {
        result.priceInfo = overrides && overrides.hasOwnProperty('priceInfo') ? aComWixpressRestaurantsMenusItemV1PriceInfo(overrides.priceInfo ?? {}, pickedFields.get('priceInfo')) : aComWixpressRestaurantsMenusItemV1PriceInfo({}, pickedFields.get('priceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceVariants')) {
        result.priceVariants = overrides && overrides.hasOwnProperty('priceVariants') ? aComWixpressRestaurantsMenusItemV1PriceVariants(overrides.priceVariants ?? {}, pickedFields.get('priceVariants')) : aComWixpressRestaurantsMenusItemV1PriceVariants({}, pickedFields.get('priceVariants'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('sectionsVirtualReference')) {
        result.sectionsVirtualReference = overrides && overrides.hasOwnProperty('sectionsVirtualReference') ? aComWixpressRestaurantsMenusSectionV1QuerySectionsResponse(overrides.sectionsVirtualReference ?? {}, pickedFields.get('sectionsVirtualReference')) : aComWixpressRestaurantsMenusSectionV1QuerySectionsResponse({}, pickedFields.get('sectionsVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : false;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1ItemIdLocationIdsInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1ItemIdLocationIdsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['quia'];
    }
    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : 'nobis';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1ItemInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1ItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalImages')) {
        result.additionalImages = overrides && overrides.hasOwnProperty('additionalImages') ? overrides.additionalImages!.map((x) => aComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput({}, pickedFields.get('additionalImages'))) : [aComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput({}, pickedFields.get('additionalImages'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['autem'];
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aComWixpressRestaurantsMenusItemV1ExternalReferenceInfoInput(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aComWixpressRestaurantsMenusItemV1ExternalReferenceInfoInput({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('featured')) {
        result.featured = overrides && overrides.hasOwnProperty('featured') ? overrides.featured! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('labels')) {
        result.labels = overrides && overrides.hasOwnProperty('labels') ? overrides.labels!.map((x) => aComWixpressRestaurantsMenusItemV1LabelInput({}, pickedFields.get('labels'))) : [aComWixpressRestaurantsMenusItemV1LabelInput({}, pickedFields.get('labels'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroups')) {
        result.modifierGroups = overrides && overrides.hasOwnProperty('modifierGroups') ? overrides.modifierGroups!.map((x) => aComWixpressRestaurantsMenusItemV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))) : [aComWixpressRestaurantsMenusItemV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('oloMigrationItemId')) {
        result.oloMigrationItemId = overrides && overrides.hasOwnProperty('oloMigrationItemId') ? overrides.oloMigrationItemId! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderSettings')) {
        result.orderSettings = overrides && overrides.hasOwnProperty('orderSettings') ? aComWixpressRestaurantsMenusItemV1OrderSettingsInput(overrides.orderSettings ?? {}, pickedFields.get('orderSettings')) : aComWixpressRestaurantsMenusItemV1OrderSettingsInput({}, pickedFields.get('orderSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceInfo')) {
        result.priceInfo = overrides && overrides.hasOwnProperty('priceInfo') ? aComWixpressRestaurantsMenusItemV1PriceInfoInput(overrides.priceInfo ?? {}, pickedFields.get('priceInfo')) : aComWixpressRestaurantsMenusItemV1PriceInfoInput({}, pickedFields.get('priceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceVariants')) {
        result.priceVariants = overrides && overrides.hasOwnProperty('priceVariants') ? aComWixpressRestaurantsMenusItemV1PriceVariantsInput(overrides.priceVariants ?? {}, pickedFields.get('priceVariants')) : aComWixpressRestaurantsMenusItemV1PriceVariantsInput({}, pickedFields.get('priceVariants'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : true;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1Label = <T extends Partial<ComWixpressRestaurantsMenusItemV1Label>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aComWixpressRestaurantsMenusItemLabelsV1Label(overrides.label ?? {}, pickedFields.get('label')) : aComWixpressRestaurantsMenusItemLabelsV1Label({}, pickedFields.get('label'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1LabelInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1LabelInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eum';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1ListItemsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1ListItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemIds')) {
        result.itemIds = overrides && overrides.hasOwnProperty('itemIds') ? overrides.itemIds! : ['modi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('onlyVisible')) {
        result.onlyVisible = overrides && overrides.hasOwnProperty('onlyVisible') ? overrides.onlyVisible! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1ListItemsResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1ListItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressRestaurantsMenusItemV1Item(x ?? {}, pickedFields.get('items'))) : [aComWixpressRestaurantsMenusItemV1Item({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1ModifierGroup = <T extends Partial<ComWixpressRestaurantsMenusItemV1ModifierGroup>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroup')) {
        result.modifierGroup = overrides && overrides.hasOwnProperty('modifierGroup') ? aWixRestaurantsMenusV1ModifierGroup(overrides.modifierGroup ?? {}, pickedFields.get('modifierGroup')) : aWixRestaurantsMenusV1ModifierGroup({}, pickedFields.get('modifierGroup'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1ModifierGroupInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1ModifierGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'molestiae';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1OrderSettings = <T extends Partial<ComWixpressRestaurantsMenusItemV1OrderSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('acceptSpecialRequests')) {
        result.acceptSpecialRequests = overrides && overrides.hasOwnProperty('acceptSpecialRequests') ? overrides.acceptSpecialRequests! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('inStock')) {
        result.inStock = overrides && overrides.hasOwnProperty('inStock') ? overrides.inStock! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'sunt';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1OrderSettingsInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1OrderSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('acceptSpecialRequests')) {
        result.acceptSpecialRequests = overrides && overrides.hasOwnProperty('acceptSpecialRequests') ? overrides.acceptSpecialRequests! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('inStock')) {
        result.inStock = overrides && overrides.hasOwnProperty('inStock') ? overrides.inStock! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'magnam';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1PriceInfo = <T extends Partial<ComWixpressRestaurantsMenusItemV1PriceInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('formattedPrice')) {
        result.formattedPrice = overrides && overrides.hasOwnProperty('formattedPrice') ? overrides.formattedPrice! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'eos';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1PriceInfoInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1PriceInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('formattedPrice')) {
        result.formattedPrice = overrides && overrides.hasOwnProperty('formattedPrice') ? overrides.formattedPrice! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'voluptatem';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1PriceVariant = <T extends Partial<ComWixpressRestaurantsMenusItemV1PriceVariant>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceInfo')) {
        result.priceInfo = overrides && overrides.hasOwnProperty('priceInfo') ? aComWixpressRestaurantsMenusItemV1PriceInfo(overrides.priceInfo ?? {}, pickedFields.get('priceInfo')) : aComWixpressRestaurantsMenusItemV1PriceInfo({}, pickedFields.get('priceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('variant')) {
        result.variant = overrides && overrides.hasOwnProperty('variant') ? aWixRestaurantsMenusItemVariantV1Variant(overrides.variant ?? {}, pickedFields.get('variant')) : aWixRestaurantsMenusItemVariantV1Variant({}, pickedFields.get('variant'));
    }
    if (pickedFields.size === 0 || pickedFields.has('variantId')) {
        result.variantId = overrides && overrides.hasOwnProperty('variantId') ? overrides.variantId! : 'excepturi';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1PriceVariantInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1PriceVariantInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('priceInfo')) {
        result.priceInfo = overrides && overrides.hasOwnProperty('priceInfo') ? aComWixpressRestaurantsMenusItemV1PriceInfoInput(overrides.priceInfo ?? {}, pickedFields.get('priceInfo')) : aComWixpressRestaurantsMenusItemV1PriceInfoInput({}, pickedFields.get('priceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('variantId')) {
        result.variantId = overrides && overrides.hasOwnProperty('variantId') ? overrides.variantId! : 'exercitationem';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1PriceVariants = <T extends Partial<ComWixpressRestaurantsMenusItemV1PriceVariants>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aComWixpressRestaurantsMenusItemV1PriceVariant(x ?? {}, pickedFields.get('variants'))) : [aComWixpressRestaurantsMenusItemV1PriceVariant({}, pickedFields.get('variants'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1PriceVariantsInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1PriceVariantsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aComWixpressRestaurantsMenusItemV1PriceVariantInput({}, pickedFields.get('variants'))) : [aComWixpressRestaurantsMenusItemV1PriceVariantInput({}, pickedFields.get('variants'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1QueryItemsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1QueryItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1QueryItemsResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1QueryItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressRestaurantsMenusItemV1Item(x ?? {}, pickedFields.get('items'))) : [aComWixpressRestaurantsMenusItemV1Item({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['iste'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nobis';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : ['et'];
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? aComWixpressRestaurantsMenusItemV1QueryItemsResponse(overrides.items ?? {}, pickedFields.get('items')) : aComWixpressRestaurantsMenusItemV1QueryItemsResponse({}, pickedFields.get('items'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1SearchItemsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1SearchItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorSearchInput(overrides.search ?? {}, pickedFields.get('search')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorSearchInput({}, pickedFields.get('search'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1SearchItemsResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1SearchItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregationData')) {
        result.aggregationData = overrides && overrides.hasOwnProperty('aggregationData') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationData(overrides.aggregationData ?? {}, pickedFields.get('aggregationData')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationData({}, pickedFields.get('aggregationData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressRestaurantsMenusItemV1Item(x ?? {}, pickedFields.get('items'))) : [aComWixpressRestaurantsMenusItemV1Item({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpdateItemRequestInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpdateItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressRestaurantsMenusItemV1ItemInput(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressRestaurantsMenusItemV1ItemInput({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['ut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'labore';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpdateItemResponse = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpdateItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressRestaurantsMenusItemV1Item(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressRestaurantsMenusItemV1Item({}, pickedFields.get('item'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationData = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResults(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResults({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResults = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('ranges')) {
        result.ranges = overrides && overrides.hasOwnProperty('ranges') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults(overrides.ranges ?? {}, pickedFields.get('ranges')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults({}, pickedFields.get('ranges'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationType.Range;
    }
    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResults(overrides.values ?? {}, pickedFields.get('values')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResults({}, pickedFields.get('values'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3256;
    }
    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 9.14;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 3.94;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixpressRestaurantsMenusItemV1UpstreamWixCommonScalarType.Avg;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 7.11;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResults = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 4507;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'ipsum';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationInput(overrides.range ?? {}, pickedFields.get('range')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationInput({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationScalarAggregationInput(overrides.scalar ?? {}, pickedFields.get('scalar')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationScalarAggregationInput({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationType.Range;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buckets')) {
        result.buckets = overrides && overrides.hasOwnProperty('buckets') ? overrides.buckets!.map((x) => aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput({}, pickedFields.get('buckets'))) : [aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput({}, pickedFields.get('buckets'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 3.76;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 3.07;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationScalarAggregationInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationScalarAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : ComWixpressRestaurantsMenusItemV1UpstreamWixCommonScalarType.Avg;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1869;
    }
    if (pickedFields.size === 0 || pickedFields.has('sortDirection')) {
        result.sortDirection = overrides && overrides.hasOwnProperty('sortDirection') ? overrides.sortDirection! : ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationSortDirection.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('sortType')) {
        result.sortType = overrides && overrides.hasOwnProperty('sortType') ? overrides.sortType! : ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationSortType.Count;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 7549;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 6709;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorQueryInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorSearchInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorSearchInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregations')) {
        result.aggregations = overrides && overrides.hasOwnProperty('aggregations') ? overrides.aggregations!.map((x) => aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationInput({}, pickedFields.get('aggregations'))) : [aComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationInput({}, pickedFields.get('aggregations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput(overrides.search ?? {}, pickedFields.get('search')) : aComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput({}, pickedFields.get('search'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursors = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'minima';
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 9873;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 1451;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 1425;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 2448;
    }

    return result;
};

export const aComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput = <T extends Partial<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['quod'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fuzzy')) {
        result.fuzzy = overrides && overrides.hasOwnProperty('fuzzy') ? overrides.fuzzy! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('mode')) {
        result.mode = overrides && overrides.hasOwnProperty('mode') ? overrides.mode! : ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsMode.And;
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1BulkCreateMenuResult = <T extends Partial<ComWixpressRestaurantsMenusMenuV1BulkCreateMenuResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menu')) {
        result.menu = overrides && overrides.hasOwnProperty('menu') ? aComWixpressRestaurantsMenusMenuV1Menu(overrides.menu ?? {}, pickedFields.get('menu')) : aComWixpressRestaurantsMenusMenuV1Menu({}, pickedFields.get('menu'));
    }
    if (pickedFields.size === 0 || pickedFields.has('menuMetadata')) {
        result.menuMetadata = overrides && overrides.hasOwnProperty('menuMetadata') ? aWixCommonItemMetadata(overrides.menuMetadata ?? {}, pickedFields.get('menuMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('menuMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1BulkCreateMenusRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1BulkCreateMenusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menus')) {
        result.menus = overrides && overrides.hasOwnProperty('menus') ? overrides.menus!.map((x) => aComWixpressRestaurantsMenusMenuV1MenuInput({}, pickedFields.get('menus'))) : [aComWixpressRestaurantsMenusMenuV1MenuInput({}, pickedFields.get('menus'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1BulkCreateMenusResponse = <T extends Partial<ComWixpressRestaurantsMenusMenuV1BulkCreateMenusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusMenuV1BulkCreateMenuResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusMenuV1BulkCreateMenuResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menus')) {
        result.menus = overrides && overrides.hasOwnProperty('menus') ? overrides.menus!.map((x) => aComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestMaskedMenuInput({}, pickedFields.get('menus'))) : [aComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestMaskedMenuInput({}, pickedFields.get('menus'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestMaskedMenuInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestMaskedMenuInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['cupiditate'];
    }
    if (pickedFields.size === 0 || pickedFields.has('menu')) {
        result.menu = overrides && overrides.hasOwnProperty('menu') ? aComWixpressRestaurantsMenusMenuV1MenuInput(overrides.menu ?? {}, pickedFields.get('menu')) : aComWixpressRestaurantsMenusMenuV1MenuInput({}, pickedFields.get('menu'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponse = <T extends Partial<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponseBulkMenuResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponseBulkMenuResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponseBulkMenuResult = <T extends Partial<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponseBulkMenuResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menu')) {
        result.menu = overrides && overrides.hasOwnProperty('menu') ? aComWixpressRestaurantsMenusMenuV1Menu(overrides.menu ?? {}, pickedFields.get('menu')) : aComWixpressRestaurantsMenusMenuV1Menu({}, pickedFields.get('menu'));
    }
    if (pickedFields.size === 0 || pickedFields.has('menuMetadata')) {
        result.menuMetadata = overrides && overrides.hasOwnProperty('menuMetadata') ? aWixCommonItemMetadata(overrides.menuMetadata ?? {}, pickedFields.get('menuMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('menuMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1CloneMenusRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1CloneMenusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'consectetur';
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1CreateMenuRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1CreateMenuRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menu')) {
        result.menu = overrides && overrides.hasOwnProperty('menu') ? aComWixpressRestaurantsMenusMenuV1MenuInput(overrides.menu ?? {}, pickedFields.get('menu')) : aComWixpressRestaurantsMenusMenuV1MenuInput({}, pickedFields.get('menu'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1CreateMenuResponse = <T extends Partial<ComWixpressRestaurantsMenusMenuV1CreateMenuResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menu')) {
        result.menu = overrides && overrides.hasOwnProperty('menu') ? aComWixpressRestaurantsMenusMenuV1Menu(overrides.menu ?? {}, pickedFields.get('menu')) : aComWixpressRestaurantsMenusMenuV1Menu({}, pickedFields.get('menu'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1DeleteMenuRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1DeleteMenuRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menuId')) {
        result.menuId = overrides && overrides.hasOwnProperty('menuId') ? overrides.menuId! : 'nisi';
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1DeleteOrphanSectionsInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1DeleteOrphanSectionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menuId')) {
        result.menuId = overrides && overrides.hasOwnProperty('menuId') ? overrides.menuId! : 'molestiae';
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1GetMenuRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1GetMenuRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b0356b4b-435b-47b3-9e96-c8587be3b61a';
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1GetMenuResponse = <T extends Partial<ComWixpressRestaurantsMenusMenuV1GetMenuResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menu')) {
        result.menu = overrides && overrides.hasOwnProperty('menu') ? aComWixpressRestaurantsMenusMenuV1Menu(overrides.menu ?? {}, pickedFields.get('menu')) : aComWixpressRestaurantsMenusMenuV1Menu({}, pickedFields.get('menu'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1ListMenusRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1ListMenusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menuIds')) {
        result.menuIds = overrides && overrides.hasOwnProperty('menuIds') ? overrides.menuIds! : ['magnam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1ListMenusResponse = <T extends Partial<ComWixpressRestaurantsMenusMenuV1ListMenusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menus')) {
        result.menus = overrides && overrides.hasOwnProperty('menus') ? overrides.menus!.map((x) => aComWixpressRestaurantsMenusMenuV1Menu(x ?? {}, pickedFields.get('menus'))) : [aComWixpressRestaurantsMenusMenuV1Menu({}, pickedFields.get('menus'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1Menu = <T extends Partial<ComWixpressRestaurantsMenusMenuV1Menu>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('sectionIds')) {
        result.sectionIds = overrides && overrides.hasOwnProperty('sectionIds') ? overrides.sectionIds! : ['hic'];
    }
    if (pickedFields.size === 0 || pickedFields.has('sections')) {
        result.sections = overrides && overrides.hasOwnProperty('sections') ? aComWixpressRestaurantsMenusSectionV1QuerySectionsResponse(overrides.sections ?? {}, pickedFields.get('sections')) : aComWixpressRestaurantsMenusSectionV1QuerySectionsResponse({}, pickedFields.get('sections'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'hic';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlQueryParam')) {
        result.urlQueryParam = overrides && overrides.hasOwnProperty('urlQueryParam') ? overrides.urlQueryParam! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : true;
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1MenuInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1MenuInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('sectionIds')) {
        result.sectionIds = overrides && overrides.hasOwnProperty('sectionIds') ? overrides.sectionIds! : ['molestiae'];
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlQueryParam')) {
        result.urlQueryParam = overrides && overrides.hasOwnProperty('urlQueryParam') ? overrides.urlQueryParam! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : true;
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1QueryMenusRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1QueryMenusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1QueryMenusResponse = <T extends Partial<ComWixpressRestaurantsMenusMenuV1QueryMenusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menus')) {
        result.menus = overrides && overrides.hasOwnProperty('menus') ? overrides.menus!.map((x) => aComWixpressRestaurantsMenusMenuV1Menu(x ?? {}, pickedFields.get('menus'))) : [aComWixpressRestaurantsMenusMenuV1Menu({}, pickedFields.get('menus'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : false;
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlResponse = <T extends Partial<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menuSiteUrl')) {
        result.menuSiteUrl = overrides && overrides.hasOwnProperty('menuSiteUrl') ? aComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl(overrides.menuSiteUrl ?? {}, pickedFields.get('menuSiteUrl')) : aComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl({}, pickedFields.get('menuSiteUrl'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnFullEntity')) {
        result.returnFullEntity = overrides && overrides.hasOwnProperty('returnFullEntity') ? overrides.returnFullEntity! : true;
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlResponse = <T extends Partial<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menusSiteUrls')) {
        result.menusSiteUrls = overrides && overrides.hasOwnProperty('menusSiteUrls') ? overrides.menusSiteUrls!.map((x) => aComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl(x ?? {}, pickedFields.get('menusSiteUrls'))) : [aComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl({}, pickedFields.get('menusSiteUrls'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl = <T extends Partial<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menu')) {
        result.menu = overrides && overrides.hasOwnProperty('menu') ? aComWixpressRestaurantsMenusMenuV1Menu(overrides.menu ?? {}, pickedFields.get('menu')) : aComWixpressRestaurantsMenusMenuV1Menu({}, pickedFields.get('menu'));
    }
    if (pickedFields.size === 0 || pickedFields.has('menuId')) {
        result.menuId = overrides && overrides.hasOwnProperty('menuId') ? overrides.menuId! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('path')) {
        result.path = overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'expedita';
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlResponse = <T extends Partial<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressRestaurantsMenusMenuV1Menu(x ?? {}, pickedFields.get('items'))) : [aComWixpressRestaurantsMenusMenuV1Menu({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1UpdateExtendedFieldsResponse = <T extends Partial<ComWixpressRestaurantsMenusMenuV1UpdateExtendedFieldsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespaceData')) {
        result.namespaceData = overrides && overrides.hasOwnProperty('namespaceData') ? overrides.namespaceData! : 'quos';
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1UpdateMenuRequestInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1UpdateMenuRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['corporis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('menu')) {
        result.menu = overrides && overrides.hasOwnProperty('menu') ? aComWixpressRestaurantsMenusMenuV1MenuInput(overrides.menu ?? {}, pickedFields.get('menu')) : aComWixpressRestaurantsMenusMenuV1MenuInput({}, pickedFields.get('menu'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1UpdateMenuResponse = <T extends Partial<ComWixpressRestaurantsMenusMenuV1UpdateMenuResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('menu')) {
        result.menu = overrides && overrides.hasOwnProperty('menu') ? aComWixpressRestaurantsMenusMenuV1Menu(overrides.menu ?? {}, pickedFields.get('menu')) : aComWixpressRestaurantsMenusMenuV1Menu({}, pickedFields.get('menu'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1837;
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata = <T extends Partial<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3861;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput = <T extends Partial<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursors = <T extends Partial<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'doloribus';
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkCreateSectionResult = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkCreateSectionResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aComWixpressRestaurantsMenusSectionV1Section(overrides.item ?? {}, pickedFields.get('item')) : aComWixpressRestaurantsMenusSectionV1Section({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkCreateSectionsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkCreateSectionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('sections')) {
        result.sections = overrides && overrides.hasOwnProperty('sections') ? overrides.sections!.map((x) => aComWixpressRestaurantsMenusSectionV1SectionInput({}, pickedFields.get('sections'))) : [aComWixpressRestaurantsMenusSectionV1SectionInput({}, pickedFields.get('sections'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkCreateSectionsResponse = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkCreateSectionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusSectionV1BulkCreateSectionResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusSectionV1BulkCreateSectionResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkDeleteSectionResult = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['non'];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsResponse = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusSectionV1BulkDeleteSectionResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusSectionV1BulkDeleteSectionResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationId')) {
        result.businessLocationId = overrides && overrides.hasOwnProperty('businessLocationId') ? overrides.businessLocationId! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('sectionIds')) {
        result.sectionIds = overrides && overrides.hasOwnProperty('sectionIds') ? overrides.sectionIds! : ['dolore'];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponse = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponseBulkItemResult = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('sections')) {
        result.sections = overrides && overrides.hasOwnProperty('sections') ? overrides.sections!.map((x) => aComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestMaskedSectionInput({}, pickedFields.get('sections'))) : [aComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestMaskedSectionInput({}, pickedFields.get('sections'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestMaskedSectionInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestMaskedSectionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['aut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('section')) {
        result.section = overrides && overrides.hasOwnProperty('section') ? aComWixpressRestaurantsMenusSectionV1SectionInput(overrides.section ?? {}, pickedFields.get('section')) : aComWixpressRestaurantsMenusSectionV1SectionInput({}, pickedFields.get('section'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponse = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponseBulkSectionResult(x ?? {}, pickedFields.get('results'))) : [aComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponseBulkSectionResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponseBulkSectionResult = <T extends Partial<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponseBulkSectionResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('section')) {
        result.section = overrides && overrides.hasOwnProperty('section') ? aComWixpressRestaurantsMenusSectionV1Section(overrides.section ?? {}, pickedFields.get('section')) : aComWixpressRestaurantsMenusSectionV1Section({}, pickedFields.get('section'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sectionMetadata')) {
        result.sectionMetadata = overrides && overrides.hasOwnProperty('sectionMetadata') ? aWixCommonItemMetadata(overrides.sectionMetadata ?? {}, pickedFields.get('sectionMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('sectionMetadata'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1CloneSectionsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1CloneSectionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'laborum';
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1CreateSectionRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1CreateSectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('section')) {
        result.section = overrides && overrides.hasOwnProperty('section') ? aComWixpressRestaurantsMenusSectionV1SectionInput(overrides.section ?? {}, pickedFields.get('section')) : aComWixpressRestaurantsMenusSectionV1SectionInput({}, pickedFields.get('section'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1CreateSectionResponse = <T extends Partial<ComWixpressRestaurantsMenusSectionV1CreateSectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('section')) {
        result.section = overrides && overrides.hasOwnProperty('section') ? aComWixpressRestaurantsMenusSectionV1Section(overrides.section ?? {}, pickedFields.get('section')) : aComWixpressRestaurantsMenusSectionV1Section({}, pickedFields.get('section'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1DeleteLocationIdFromItemsInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1DeleteLocationIdFromItemsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationId')) {
        result.businessLocationId = overrides && overrides.hasOwnProperty('businessLocationId') ? overrides.businessLocationId! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemIds')) {
        result.itemIds = overrides && overrides.hasOwnProperty('itemIds') ? overrides.itemIds! : ['non'];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1DeleteOrphanItemsInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1DeleteOrphanItemsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sectionId')) {
        result.sectionId = overrides && overrides.hasOwnProperty('sectionId') ? overrides.sectionId! : 'qui';
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1DeleteSectionRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1DeleteSectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sectionId')) {
        result.sectionId = overrides && overrides.hasOwnProperty('sectionId') ? overrides.sectionId! : 'qui';
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1ExternalReferenceInfo = <T extends Partial<ComWixpressRestaurantsMenusSectionV1ExternalReferenceInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'numquam';
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1ExternalReferenceInfoInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1ExternalReferenceInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'est';
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1GetSectionRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1GetSectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'd87f0d72-e341-491f-ad6e-91ca992bf160';
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1ListSectionsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1ListSectionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('onlyVisible')) {
        result.onlyVisible = overrides && overrides.hasOwnProperty('onlyVisible') ? overrides.onlyVisible! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sectionIds')) {
        result.sectionIds = overrides && overrides.hasOwnProperty('sectionIds') ? overrides.sectionIds! : ['dolorum'];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1ListSectionsResponse = <T extends Partial<ComWixpressRestaurantsMenusSectionV1ListSectionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sections')) {
        result.sections = overrides && overrides.hasOwnProperty('sections') ? overrides.sections!.map((x) => aComWixpressRestaurantsMenusSectionV1Section(x ?? {}, pickedFields.get('sections'))) : [aComWixpressRestaurantsMenusSectionV1Section({}, pickedFields.get('sections'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1QuerySectionsResponse = <T extends Partial<ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aComWixpressRestaurantsMenusSectionV1Section(x ?? {}, pickedFields.get('items'))) : [aComWixpressRestaurantsMenusSectionV1Section({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['sint'];
    }
    if (pickedFields.size === 0 || pickedFields.has('duplicateSubEntities')) {
        result.duplicateSubEntities = overrides && overrides.hasOwnProperty('duplicateSubEntities') ? overrides.duplicateSubEntities! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sequi';
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionResponse = <T extends Partial<ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sectionId')) {
        result.sectionId = overrides && overrides.hasOwnProperty('sectionId') ? overrides.sectionId! : ['et'];
    }
    if (pickedFields.size === 0 || pickedFields.has('sections')) {
        result.sections = overrides && overrides.hasOwnProperty('sections') ? aComWixpressRestaurantsMenusSectionV1QuerySectionsResponse(overrides.sections ?? {}, pickedFields.get('sections')) : aComWixpressRestaurantsMenusSectionV1QuerySectionsResponse({}, pickedFields.get('sections'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1Section = <T extends Partial<ComWixpressRestaurantsMenusSectionV1Section>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalImages')) {
        result.additionalImages = overrides && overrides.hasOwnProperty('additionalImages') ? overrides.additionalImages!.map((x) => aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage(x ?? {}, pickedFields.get('additionalImages'))) : [aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage({}, pickedFields.get('additionalImages'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationId')) {
        result.businessLocationId = overrides && overrides.hasOwnProperty('businessLocationId') ? overrides.businessLocationId! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aComWixpressRestaurantsMenusSectionV1ExternalReferenceInfo(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aComWixpressRestaurantsMenusSectionV1ExternalReferenceInfo({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemIds')) {
        result.itemIds = overrides && overrides.hasOwnProperty('itemIds') ? overrides.itemIds! : ['iusto'];
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? aComWixpressRestaurantsMenusItemV1QueryItemsResponse(overrides.items ?? {}, pickedFields.get('items')) : aComWixpressRestaurantsMenusItemV1QueryItemsResponse({}, pickedFields.get('items'));
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('menusVirtualReference')) {
        result.menusVirtualReference = overrides && overrides.hasOwnProperty('menusVirtualReference') ? aComWixpressRestaurantsMenusMenuV1QueryMenusResponse(overrides.menusVirtualReference ?? {}, pickedFields.get('menusVirtualReference')) : aComWixpressRestaurantsMenusMenuV1QueryMenusResponse({}, pickedFields.get('menusVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('oloMigrationSectionId')) {
        result.oloMigrationSectionId = overrides && overrides.hasOwnProperty('oloMigrationSectionId') ? overrides.oloMigrationSectionId! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : false;
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1SectionInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1SectionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalImages')) {
        result.additionalImages = overrides && overrides.hasOwnProperty('additionalImages') ? overrides.additionalImages!.map((x) => aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput({}, pickedFields.get('additionalImages'))) : [aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput({}, pickedFields.get('additionalImages'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationId')) {
        result.businessLocationId = overrides && overrides.hasOwnProperty('businessLocationId') ? overrides.businessLocationId! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'delectus';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aComWixpressRestaurantsMenusSectionV1ExternalReferenceInfoInput(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aComWixpressRestaurantsMenusSectionV1ExternalReferenceInfoInput({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemIds')) {
        result.itemIds = overrides && overrides.hasOwnProperty('itemIds') ? overrides.itemIds! : ['ipsam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('oloMigrationSectionId')) {
        result.oloMigrationSectionId = overrides && overrides.hasOwnProperty('oloMigrationSectionId') ? overrides.oloMigrationSectionId! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : false;
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1UpdateSectionRequestInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1UpdateSectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['et'];
    }
    if (pickedFields.size === 0 || pickedFields.has('section')) {
        result.section = overrides && overrides.hasOwnProperty('section') ? aComWixpressRestaurantsMenusSectionV1SectionInput(overrides.section ?? {}, pickedFields.get('section')) : aComWixpressRestaurantsMenusSectionV1SectionInput({}, pickedFields.get('section'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1UpdateSectionResponse = <T extends Partial<ComWixpressRestaurantsMenusSectionV1UpdateSectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('section')) {
        result.section = overrides && overrides.hasOwnProperty('section') ? aComWixpressRestaurantsMenusSectionV1Section(overrides.section ?? {}, pickedFields.get('section')) : aComWixpressRestaurantsMenusSectionV1Section({}, pickedFields.get('section'));
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1656;
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingMetadata = <T extends Partial<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 775;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorQueryInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursors = <T extends Partial<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'voluptate';
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage = <T extends Partial<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 5845;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 2204;
    }

    return result;
};

export const aComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput = <T extends Partial<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 5905;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 6670;
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4Address = <T extends Partial<ComWixpressSitepropertiesApiV4Address>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apartmentNumber')) {
        result.apartmentNumber = overrides && overrides.hasOwnProperty('apartmentNumber') ? overrides.apartmentNumber! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('coordinates')) {
        result.coordinates = overrides && overrides.hasOwnProperty('coordinates') ? aComWixpressSitepropertiesApiV4GeoCoordinates(overrides.coordinates ?? {}, pickedFields.get('coordinates')) : aComWixpressSitepropertiesApiV4GeoCoordinates({}, pickedFields.get('coordinates'));
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('googleFormattedAddress')) {
        result.googleFormattedAddress = overrides && overrides.hasOwnProperty('googleFormattedAddress') ? overrides.googleFormattedAddress! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? aComWixpressSitepropertiesApiV4AddressHint(overrides.hint ?? {}, pickedFields.get('hint')) : aComWixpressSitepropertiesApiV4AddressHint({}, pickedFields.get('hint'));
    }
    if (pickedFields.size === 0 || pickedFields.has('isPhysical')) {
        result.isPhysical = overrides && overrides.hasOwnProperty('isPhysical') ? overrides.isPhysical! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('state')) {
        result.state = overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('street')) {
        result.street = overrides && overrides.hasOwnProperty('street') ? overrides.street! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetNumber')) {
        result.streetNumber = overrides && overrides.hasOwnProperty('streetNumber') ? overrides.streetNumber! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('zip')) {
        result.zip = overrides && overrides.hasOwnProperty('zip') ? overrides.zip! : 'eaque';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4AddressHint = <T extends Partial<ComWixpressSitepropertiesApiV4AddressHint>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('placement')) {
        result.placement = overrides && overrides.hasOwnProperty('placement') ? overrides.placement! : ComWixpressSitepropertiesApiV4PlacementType.After;
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'quod';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4AddressHintInput = <T extends Partial<ComWixpressSitepropertiesApiV4AddressHintInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('placement')) {
        result.placement = overrides && overrides.hasOwnProperty('placement') ? overrides.placement! : ComWixpressSitepropertiesApiV4PlacementType.After;
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'non';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4AddressInput = <T extends Partial<ComWixpressSitepropertiesApiV4AddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apartmentNumber')) {
        result.apartmentNumber = overrides && overrides.hasOwnProperty('apartmentNumber') ? overrides.apartmentNumber! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('coordinates')) {
        result.coordinates = overrides && overrides.hasOwnProperty('coordinates') ? aComWixpressSitepropertiesApiV4GeoCoordinatesInput(overrides.coordinates ?? {}, pickedFields.get('coordinates')) : aComWixpressSitepropertiesApiV4GeoCoordinatesInput({}, pickedFields.get('coordinates'));
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('googleFormattedAddress')) {
        result.googleFormattedAddress = overrides && overrides.hasOwnProperty('googleFormattedAddress') ? overrides.googleFormattedAddress! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? aComWixpressSitepropertiesApiV4AddressHintInput(overrides.hint ?? {}, pickedFields.get('hint')) : aComWixpressSitepropertiesApiV4AddressHintInput({}, pickedFields.get('hint'));
    }
    if (pickedFields.size === 0 || pickedFields.has('isPhysical')) {
        result.isPhysical = overrides && overrides.hasOwnProperty('isPhysical') ? overrides.isPhysical! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('state')) {
        result.state = overrides && overrides.hasOwnProperty('state') ? overrides.state! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('street')) {
        result.street = overrides && overrides.hasOwnProperty('street') ? overrides.street! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetNumber')) {
        result.streetNumber = overrides && overrides.hasOwnProperty('streetNumber') ? overrides.streetNumber! : 'nisi';
    }
    if (pickedFields.size === 0 || pickedFields.has('zip')) {
        result.zip = overrides && overrides.hasOwnProperty('zip') ? overrides.zip! : 'possimus';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4BulkPropertiesReadRequestInput = <T extends Partial<ComWixpressSitepropertiesApiV4BulkPropertiesReadRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sites')) {
        result.sites = overrides && overrides.hasOwnProperty('sites') ? overrides.sites! : ['sit'];
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4BulkPropertiesReadResponse = <T extends Partial<ComWixpressSitepropertiesApiV4BulkPropertiesReadResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sites')) {
        result.sites = overrides && overrides.hasOwnProperty('sites') ? aComWixpressSitepropertiesApiV4PropertiesReadResponse(overrides.sites ?? {}, pickedFields.get('sites')) : aComWixpressSitepropertiesApiV4PropertiesReadResponse({}, pickedFields.get('sites'));
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4BusinessContactDataInput = <T extends Partial<ComWixpressSitepropertiesApiV4BusinessContactDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixpressSitepropertiesApiV4AddressInput(overrides.address ?? {}, pickedFields.get('address')) : aComWixpressSitepropertiesApiV4AddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('fax')) {
        result.fax = overrides && overrides.hasOwnProperty('fax') ? overrides.fax! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'vel';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4BusinessProfileDataInput = <T extends Partial<ComWixpressSitepropertiesApiV4BusinessProfileDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessName')) {
        result.businessName = overrides && overrides.hasOwnProperty('businessName') ? overrides.businessName! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('logo')) {
        result.logo = overrides && overrides.hasOwnProperty('logo') ? overrides.logo! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteDisplayName')) {
        result.siteDisplayName = overrides && overrides.hasOwnProperty('siteDisplayName') ? overrides.siteDisplayName! : 'doloribus';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4BusinessSchedule = <T extends Partial<ComWixpressSitepropertiesApiV4BusinessSchedule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('periods')) {
        result.periods = overrides && overrides.hasOwnProperty('periods') ? overrides.periods!.map((x) => aComWixpressSitepropertiesApiV4TimePeriod(x ?? {}, pickedFields.get('periods'))) : [aComWixpressSitepropertiesApiV4TimePeriod({}, pickedFields.get('periods'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('specialHourPeriod')) {
        result.specialHourPeriod = overrides && overrides.hasOwnProperty('specialHourPeriod') ? overrides.specialHourPeriod!.map((x) => aComWixpressSitepropertiesApiV4SpecialHourPeriod(x ?? {}, pickedFields.get('specialHourPeriod'))) : [aComWixpressSitepropertiesApiV4SpecialHourPeriod({}, pickedFields.get('specialHourPeriod'))];
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4BusinessScheduleInput = <T extends Partial<ComWixpressSitepropertiesApiV4BusinessScheduleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('periods')) {
        result.periods = overrides && overrides.hasOwnProperty('periods') ? overrides.periods!.map((x) => aComWixpressSitepropertiesApiV4TimePeriodInput({}, pickedFields.get('periods'))) : [aComWixpressSitepropertiesApiV4TimePeriodInput({}, pickedFields.get('periods'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('specialHourPeriod')) {
        result.specialHourPeriod = overrides && overrides.hasOwnProperty('specialHourPeriod') ? overrides.specialHourPeriod!.map((x) => aComWixpressSitepropertiesApiV4SpecialHourPeriodInput({}, pickedFields.get('specialHourPeriod'))) : [aComWixpressSitepropertiesApiV4SpecialHourPeriodInput({}, pickedFields.get('specialHourPeriod'))];
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4Categories = <T extends Partial<ComWixpressSitepropertiesApiV4Categories>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessTermId')) {
        result.businessTermId = overrides && overrides.hasOwnProperty('businessTermId') ? overrides.businessTermId! : 'at';
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('secondary')) {
        result.secondary = overrides && overrides.hasOwnProperty('secondary') ? overrides.secondary! : ['sit'];
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4CategoriesInput = <T extends Partial<ComWixpressSitepropertiesApiV4CategoriesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessTermId')) {
        result.businessTermId = overrides && overrides.hasOwnProperty('businessTermId') ? overrides.businessTermId! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('secondary')) {
        result.secondary = overrides && overrides.hasOwnProperty('secondary') ? overrides.secondary! : ['enim'];
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4ChangeContextInput = <T extends Partial<ComWixpressSitepropertiesApiV4ChangeContextInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('propertiesChange')) {
        result.propertiesChange = overrides && overrides.hasOwnProperty('propertiesChange') ? overrides.propertiesChange! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteCloned')) {
        result.siteCloned = overrides && overrides.hasOwnProperty('siteCloned') ? aComWixpressSitepropertiesApiV4SiteClonedInput(overrides.siteCloned ?? {}, pickedFields.get('siteCloned')) : aComWixpressSitepropertiesApiV4SiteClonedInput({}, pickedFields.get('siteCloned'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteCreated')) {
        result.siteCreated = overrides && overrides.hasOwnProperty('siteCreated') ? aComWixpressSitepropertiesApiV4SiteCreatedInput(overrides.siteCreated ?? {}, pickedFields.get('siteCreated')) : aComWixpressSitepropertiesApiV4SiteCreatedInput({}, pickedFields.get('siteCreated'));
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4ConsentPolicy = <T extends Partial<ComWixpressSitepropertiesApiV4ConsentPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('advertising')) {
        result.advertising = overrides && overrides.hasOwnProperty('advertising') ? overrides.advertising! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('analytics')) {
        result.analytics = overrides && overrides.hasOwnProperty('analytics') ? overrides.analytics! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('dataToThirdParty')) {
        result.dataToThirdParty = overrides && overrides.hasOwnProperty('dataToThirdParty') ? overrides.dataToThirdParty! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('essential')) {
        result.essential = overrides && overrides.hasOwnProperty('essential') ? overrides.essential! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('functional')) {
        result.functional = overrides && overrides.hasOwnProperty('functional') ? overrides.functional! : true;
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4ConsentPolicyInput = <T extends Partial<ComWixpressSitepropertiesApiV4ConsentPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('advertising')) {
        result.advertising = overrides && overrides.hasOwnProperty('advertising') ? overrides.advertising! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('analytics')) {
        result.analytics = overrides && overrides.hasOwnProperty('analytics') ? overrides.analytics! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('dataToThirdParty')) {
        result.dataToThirdParty = overrides && overrides.hasOwnProperty('dataToThirdParty') ? overrides.dataToThirdParty! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('essential')) {
        result.essential = overrides && overrides.hasOwnProperty('essential') ? overrides.essential! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('functional')) {
        result.functional = overrides && overrides.hasOwnProperty('functional') ? overrides.functional! : false;
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4GeoCoordinates = <T extends Partial<ComWixpressSitepropertiesApiV4GeoCoordinates>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 6.7;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 1.97;
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4GeoCoordinatesInput = <T extends Partial<ComWixpressSitepropertiesApiV4GeoCoordinatesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 2.01;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 4.37;
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4Locale = <T extends Partial<ComWixpressSitepropertiesApiV4Locale>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('languageCode')) {
        result.languageCode = overrides && overrides.hasOwnProperty('languageCode') ? overrides.languageCode! : 'neque';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4LocaleInput = <T extends Partial<ComWixpressSitepropertiesApiV4LocaleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('languageCode')) {
        result.languageCode = overrides && overrides.hasOwnProperty('languageCode') ? overrides.languageCode! : 'vel';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4Multilingual = <T extends Partial<ComWixpressSitepropertiesApiV4Multilingual>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoRedirect')) {
        result.autoRedirect = overrides && overrides.hasOwnProperty('autoRedirect') ? overrides.autoRedirect! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('supportedLanguages')) {
        result.supportedLanguages = overrides && overrides.hasOwnProperty('supportedLanguages') ? overrides.supportedLanguages!.map((x) => aComWixpressSitepropertiesApiV4SupportedLanguage(x ?? {}, pickedFields.get('supportedLanguages'))) : [aComWixpressSitepropertiesApiV4SupportedLanguage({}, pickedFields.get('supportedLanguages'))];
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4MultilingualInput = <T extends Partial<ComWixpressSitepropertiesApiV4MultilingualInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoRedirect')) {
        result.autoRedirect = overrides && overrides.hasOwnProperty('autoRedirect') ? overrides.autoRedirect! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('supportedLanguages')) {
        result.supportedLanguages = overrides && overrides.hasOwnProperty('supportedLanguages') ? overrides.supportedLanguages!.map((x) => aComWixpressSitepropertiesApiV4SupportedLanguageInput({}, pickedFields.get('supportedLanguages'))) : [aComWixpressSitepropertiesApiV4SupportedLanguageInput({}, pickedFields.get('supportedLanguages'))];
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4Properties = <T extends Partial<ComWixpressSitepropertiesApiV4Properties>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixpressSitepropertiesApiV4Address(overrides.address ?? {}, pickedFields.get('address')) : aComWixpressSitepropertiesApiV4Address({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('businessConfig')) {
        result.businessConfig = overrides && overrides.hasOwnProperty('businessConfig') ? overrides.businessConfig! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('businessName')) {
        result.businessName = overrides && overrides.hasOwnProperty('businessName') ? overrides.businessName! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('businessSchedule')) {
        result.businessSchedule = overrides && overrides.hasOwnProperty('businessSchedule') ? aComWixpressSitepropertiesApiV4BusinessSchedule(overrides.businessSchedule ?? {}, pickedFields.get('businessSchedule')) : aComWixpressSitepropertiesApiV4BusinessSchedule({}, pickedFields.get('businessSchedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('categories')) {
        result.categories = overrides && overrides.hasOwnProperty('categories') ? aComWixpressSitepropertiesApiV4Categories(overrides.categories ?? {}, pickedFields.get('categories')) : aComWixpressSitepropertiesApiV4Categories({}, pickedFields.get('categories'));
    }
    if (pickedFields.size === 0 || pickedFields.has('consentPolicy')) {
        result.consentPolicy = overrides && overrides.hasOwnProperty('consentPolicy') ? aComWixpressSitepropertiesApiV4ConsentPolicy(overrides.consentPolicy ?? {}, pickedFields.get('consentPolicy')) : aComWixpressSitepropertiesApiV4ConsentPolicy({}, pickedFields.get('consentPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalSiteUrl')) {
        result.externalSiteUrl = overrides && overrides.hasOwnProperty('externalSiteUrl') ? overrides.externalSiteUrl! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('fax')) {
        result.fax = overrides && overrides.hasOwnProperty('fax') ? overrides.fax! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('locale')) {
        result.locale = overrides && overrides.hasOwnProperty('locale') ? aComWixpressSitepropertiesApiV4Locale(overrides.locale ?? {}, pickedFields.get('locale')) : aComWixpressSitepropertiesApiV4Locale({}, pickedFields.get('locale'));
    }
    if (pickedFields.size === 0 || pickedFields.has('logo')) {
        result.logo = overrides && overrides.hasOwnProperty('logo') ? overrides.logo! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('multilingual')) {
        result.multilingual = overrides && overrides.hasOwnProperty('multilingual') ? aComWixpressSitepropertiesApiV4Multilingual(overrides.multilingual ?? {}, pickedFields.get('multilingual')) : aComWixpressSitepropertiesApiV4Multilingual({}, pickedFields.get('multilingual'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentCurrency')) {
        result.paymentCurrency = overrides && overrides.hasOwnProperty('paymentCurrency') ? overrides.paymentCurrency! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteDisplayName')) {
        result.siteDisplayName = overrides && overrides.hasOwnProperty('siteDisplayName') ? overrides.siteDisplayName! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('trackClicksAnalytics')) {
        result.trackClicksAnalytics = overrides && overrides.hasOwnProperty('trackClicksAnalytics') ? overrides.trackClicksAnalytics! : false;
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4PropertiesInput = <T extends Partial<ComWixpressSitepropertiesApiV4PropertiesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixpressSitepropertiesApiV4AddressInput(overrides.address ?? {}, pickedFields.get('address')) : aComWixpressSitepropertiesApiV4AddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('businessConfig')) {
        result.businessConfig = overrides && overrides.hasOwnProperty('businessConfig') ? overrides.businessConfig! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('businessName')) {
        result.businessName = overrides && overrides.hasOwnProperty('businessName') ? overrides.businessName! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('businessSchedule')) {
        result.businessSchedule = overrides && overrides.hasOwnProperty('businessSchedule') ? aComWixpressSitepropertiesApiV4BusinessScheduleInput(overrides.businessSchedule ?? {}, pickedFields.get('businessSchedule')) : aComWixpressSitepropertiesApiV4BusinessScheduleInput({}, pickedFields.get('businessSchedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('categories')) {
        result.categories = overrides && overrides.hasOwnProperty('categories') ? aComWixpressSitepropertiesApiV4CategoriesInput(overrides.categories ?? {}, pickedFields.get('categories')) : aComWixpressSitepropertiesApiV4CategoriesInput({}, pickedFields.get('categories'));
    }
    if (pickedFields.size === 0 || pickedFields.has('consentPolicy')) {
        result.consentPolicy = overrides && overrides.hasOwnProperty('consentPolicy') ? aComWixpressSitepropertiesApiV4ConsentPolicyInput(overrides.consentPolicy ?? {}, pickedFields.get('consentPolicy')) : aComWixpressSitepropertiesApiV4ConsentPolicyInput({}, pickedFields.get('consentPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalSiteUrl')) {
        result.externalSiteUrl = overrides && overrides.hasOwnProperty('externalSiteUrl') ? overrides.externalSiteUrl! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('fax')) {
        result.fax = overrides && overrides.hasOwnProperty('fax') ? overrides.fax! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('locale')) {
        result.locale = overrides && overrides.hasOwnProperty('locale') ? aComWixpressSitepropertiesApiV4LocaleInput(overrides.locale ?? {}, pickedFields.get('locale')) : aComWixpressSitepropertiesApiV4LocaleInput({}, pickedFields.get('locale'));
    }
    if (pickedFields.size === 0 || pickedFields.has('logo')) {
        result.logo = overrides && overrides.hasOwnProperty('logo') ? overrides.logo! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('multilingual')) {
        result.multilingual = overrides && overrides.hasOwnProperty('multilingual') ? aComWixpressSitepropertiesApiV4MultilingualInput(overrides.multilingual ?? {}, pickedFields.get('multilingual')) : aComWixpressSitepropertiesApiV4MultilingualInput({}, pickedFields.get('multilingual'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentCurrency')) {
        result.paymentCurrency = overrides && overrides.hasOwnProperty('paymentCurrency') ? overrides.paymentCurrency! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteDisplayName')) {
        result.siteDisplayName = overrides && overrides.hasOwnProperty('siteDisplayName') ? overrides.siteDisplayName! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('trackClicksAnalytics')) {
        result.trackClicksAnalytics = overrides && overrides.hasOwnProperty('trackClicksAnalytics') ? overrides.trackClicksAnalytics! : false;
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4PropertiesReadRequestInput = <T extends Partial<ComWixpressSitepropertiesApiV4PropertiesReadRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['molestiae'];
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4PropertiesReadResponse = <T extends Partial<ComWixpressSitepropertiesApiV4PropertiesReadResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('properties')) {
        result.properties = overrides && overrides.hasOwnProperty('properties') ? aComWixpressSitepropertiesApiV4Properties(overrides.properties ?? {}, pickedFields.get('properties')) : aComWixpressSitepropertiesApiV4Properties({}, pickedFields.get('properties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 'non';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4PropertiesUpdateRequestInput = <T extends Partial<ComWixpressSitepropertiesApiV4PropertiesUpdateRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['aut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('properties')) {
        result.properties = overrides && overrides.hasOwnProperty('properties') ? aComWixpressSitepropertiesApiV4PropertiesInput(overrides.properties ?? {}, pickedFields.get('properties')) : aComWixpressSitepropertiesApiV4PropertiesInput({}, pickedFields.get('properties'));
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4PropertiesUpdateResponse = <T extends Partial<ComWixpressSitepropertiesApiV4PropertiesUpdateResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 'ipsa';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4SiteClonedInput = <T extends Partial<ComWixpressSitepropertiesApiV4SiteClonedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('originMetaSiteId')) {
        result.originMetaSiteId = overrides && overrides.hasOwnProperty('originMetaSiteId') ? overrides.originMetaSiteId! : 'eligendi';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4SiteCreatedInput = <T extends Partial<ComWixpressSitepropertiesApiV4SiteCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('originTemplateId')) {
        result.originTemplateId = overrides && overrides.hasOwnProperty('originTemplateId') ? overrides.originTemplateId! : 'consequatur';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4SitePropertiesEventInput = <T extends Partial<ComWixpressSitepropertiesApiV4SitePropertiesEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['repudiandae'];
    }
    if (pickedFields.size === 0 || pickedFields.has('properties')) {
        result.properties = overrides && overrides.hasOwnProperty('properties') ? aComWixpressSitepropertiesApiV4PropertiesInput(overrides.properties ?? {}, pickedFields.get('properties')) : aComWixpressSitepropertiesApiV4PropertiesInput({}, pickedFields.get('properties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 7121;
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4SitePropertiesNotificationInput = <T extends Partial<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('changeContext')) {
        result.changeContext = overrides && overrides.hasOwnProperty('changeContext') ? aComWixpressSitepropertiesApiV4ChangeContextInput(overrides.changeContext ?? {}, pickedFields.get('changeContext')) : aComWixpressSitepropertiesApiV4ChangeContextInput({}, pickedFields.get('changeContext'));
    }
    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aComWixpressSitepropertiesApiV4SitePropertiesEventInput(overrides.event ?? {}, pickedFields.get('event')) : aComWixpressSitepropertiesApiV4SitePropertiesEventInput({}, pickedFields.get('event'));
    }
    if (pickedFields.size === 0 || pickedFields.has('metasiteId')) {
        result.metasiteId = overrides && overrides.hasOwnProperty('metasiteId') ? overrides.metasiteId! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('translations')) {
        result.translations = overrides && overrides.hasOwnProperty('translations') ? overrides.translations!.map((x) => aComWixpressSitepropertiesApiV4TranslationInput({}, pickedFields.get('translations'))) : [aComWixpressSitepropertiesApiV4TranslationInput({}, pickedFields.get('translations'))];
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4SpecialHourPeriod = <T extends Partial<ComWixpressSitepropertiesApiV4SpecialHourPeriod>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('comment')) {
        result.comment = overrides && overrides.hasOwnProperty('comment') ? overrides.comment! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('endDate')) {
        result.endDate = overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('isClosed')) {
        result.isClosed = overrides && overrides.hasOwnProperty('isClosed') ? overrides.isClosed! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'qui';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4SpecialHourPeriodInput = <T extends Partial<ComWixpressSitepropertiesApiV4SpecialHourPeriodInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('comment')) {
        result.comment = overrides && overrides.hasOwnProperty('comment') ? overrides.comment! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('endDate')) {
        result.endDate = overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('isClosed')) {
        result.isClosed = overrides && overrides.hasOwnProperty('isClosed') ? overrides.isClosed! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'dolores';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4SupportedLanguage = <T extends Partial<ComWixpressSitepropertiesApiV4SupportedLanguage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('countryCode')) {
        result.countryCode = overrides && overrides.hasOwnProperty('countryCode') ? overrides.countryCode! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('isPrimary')) {
        result.isPrimary = overrides && overrides.hasOwnProperty('isPrimary') ? overrides.isPrimary! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('languageCode')) {
        result.languageCode = overrides && overrides.hasOwnProperty('languageCode') ? overrides.languageCode! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('locale')) {
        result.locale = overrides && overrides.hasOwnProperty('locale') ? aComWixpressSitepropertiesApiV4Locale(overrides.locale ?? {}, pickedFields.get('locale')) : aComWixpressSitepropertiesApiV4Locale({}, pickedFields.get('locale'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resolutionMethod')) {
        result.resolutionMethod = overrides && overrides.hasOwnProperty('resolutionMethod') ? overrides.resolutionMethod! : ComWixpressSitepropertiesApiV4ResolutionMethod.QueryParam;
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4SupportedLanguageInput = <T extends Partial<ComWixpressSitepropertiesApiV4SupportedLanguageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('countryCode')) {
        result.countryCode = overrides && overrides.hasOwnProperty('countryCode') ? overrides.countryCode! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('isPrimary')) {
        result.isPrimary = overrides && overrides.hasOwnProperty('isPrimary') ? overrides.isPrimary! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('isVisitorPrimary')) {
        result.isVisitorPrimary = overrides && overrides.hasOwnProperty('isVisitorPrimary') ? overrides.isVisitorPrimary! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('languageCode')) {
        result.languageCode = overrides && overrides.hasOwnProperty('languageCode') ? overrides.languageCode! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('locale')) {
        result.locale = overrides && overrides.hasOwnProperty('locale') ? aComWixpressSitepropertiesApiV4LocaleInput(overrides.locale ?? {}, pickedFields.get('locale')) : aComWixpressSitepropertiesApiV4LocaleInput({}, pickedFields.get('locale'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resolutionMethod')) {
        result.resolutionMethod = overrides && overrides.hasOwnProperty('resolutionMethod') ? overrides.resolutionMethod! : ComWixpressSitepropertiesApiV4ResolutionMethod.QueryParam;
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4TimePeriod = <T extends Partial<ComWixpressSitepropertiesApiV4TimePeriod>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('closeDay')) {
        result.closeDay = overrides && overrides.hasOwnProperty('closeDay') ? overrides.closeDay! : ComWixpressSitepropertiesApiV4DayOfWeek.Friday;
    }
    if (pickedFields.size === 0 || pickedFields.has('closeTime')) {
        result.closeTime = overrides && overrides.hasOwnProperty('closeTime') ? overrides.closeTime! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('openDay')) {
        result.openDay = overrides && overrides.hasOwnProperty('openDay') ? overrides.openDay! : ComWixpressSitepropertiesApiV4DayOfWeek.Friday;
    }
    if (pickedFields.size === 0 || pickedFields.has('openTime')) {
        result.openTime = overrides && overrides.hasOwnProperty('openTime') ? overrides.openTime! : 'accusantium';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4TimePeriodInput = <T extends Partial<ComWixpressSitepropertiesApiV4TimePeriodInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('closeDay')) {
        result.closeDay = overrides && overrides.hasOwnProperty('closeDay') ? overrides.closeDay! : ComWixpressSitepropertiesApiV4DayOfWeek.Friday;
    }
    if (pickedFields.size === 0 || pickedFields.has('closeTime')) {
        result.closeTime = overrides && overrides.hasOwnProperty('closeTime') ? overrides.closeTime! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('openDay')) {
        result.openDay = overrides && overrides.hasOwnProperty('openDay') ? overrides.openDay! : ComWixpressSitepropertiesApiV4DayOfWeek.Friday;
    }
    if (pickedFields.size === 0 || pickedFields.has('openTime')) {
        result.openTime = overrides && overrides.hasOwnProperty('openTime') ? overrides.openTime! : 'adipisci';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4TranslationInput = <T extends Partial<ComWixpressSitepropertiesApiV4TranslationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appDefId')) {
        result.appDefId = overrides && overrides.hasOwnProperty('appDefId') ? overrides.appDefId! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceType')) {
        result.serviceType = overrides && overrides.hasOwnProperty('serviceType') ? overrides.serviceType! : 'sed';
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4UpdateBusinessContactRequestInput = <T extends Partial<ComWixpressSitepropertiesApiV4UpdateBusinessContactRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessContact')) {
        result.businessContact = overrides && overrides.hasOwnProperty('businessContact') ? aComWixpressSitepropertiesApiV4BusinessContactDataInput(overrides.businessContact ?? {}, pickedFields.get('businessContact')) : aComWixpressSitepropertiesApiV4BusinessContactDataInput({}, pickedFields.get('businessContact'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['vero'];
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4UpdateBusinessProfileRequestInput = <T extends Partial<ComWixpressSitepropertiesApiV4UpdateBusinessProfileRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessProfile')) {
        result.businessProfile = overrides && overrides.hasOwnProperty('businessProfile') ? aComWixpressSitepropertiesApiV4BusinessProfileDataInput(overrides.businessProfile ?? {}, pickedFields.get('businessProfile')) : aComWixpressSitepropertiesApiV4BusinessProfileDataInput({}, pickedFields.get('businessProfile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['asperiores'];
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4UpdateBusinessScheduleRequestInput = <T extends Partial<ComWixpressSitepropertiesApiV4UpdateBusinessScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessSchedule')) {
        result.businessSchedule = overrides && overrides.hasOwnProperty('businessSchedule') ? aComWixpressSitepropertiesApiV4BusinessScheduleInput(overrides.businessSchedule ?? {}, pickedFields.get('businessSchedule')) : aComWixpressSitepropertiesApiV4BusinessScheduleInput({}, pickedFields.get('businessSchedule'));
    }

    return result;
};

export const aComWixpressSitepropertiesApiV4UpdateConsentPolicyRequestInput = <T extends Partial<ComWixpressSitepropertiesApiV4UpdateConsentPolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('consentPolicy')) {
        result.consentPolicy = overrides && overrides.hasOwnProperty('consentPolicy') ? aComWixpressSitepropertiesApiV4ConsentPolicyInput(overrides.consentPolicy ?? {}, pickedFields.get('consentPolicy')) : aComWixpressSitepropertiesApiV4ConsentPolicyInput({}, pickedFields.get('consentPolicy'));
    }

    return result;
};

export const anEcomCheckoutV1AddToCheckoutRequestInput = <T extends Partial<EcomCheckoutV1AddToCheckoutRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customLineItems')) {
        result.customLineItems = overrides && overrides.hasOwnProperty('customLineItems') ? overrides.customLineItems!.map((x) => aComWixEcomCartCheckoutCommonApiV1CustomLineItemInput({}, pickedFields.get('customLineItems'))) : [aComWixEcomCartCheckoutCommonApiV1CustomLineItemInput({}, pickedFields.get('customLineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => anEcomCheckoutV1LineItemInput({}, pickedFields.get('lineItems'))) : [anEcomCheckoutV1LineItemInput({}, pickedFields.get('lineItems'))];
    }

    return result;
};

export const anEcomCheckoutV1AddToCheckoutResponse = <T extends Partial<EcomCheckoutV1AddToCheckoutResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1Checkout(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1Checkout({}, pickedFields.get('checkout'));
    }

    return result;
};

export const anEcomCheckoutV1AddressWithContact = <T extends Partial<EcomCheckoutV1AddressWithContact>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixEcommercePlatformCommonApiAddress(overrides.address ?? {}, pickedFields.get('address')) : aComWixEcommercePlatformCommonApiAddress({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('addressesServiceId')) {
        result.addressesServiceId = overrides && overrides.hasOwnProperty('addressesServiceId') ? overrides.addressesServiceId! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('contactDetails')) {
        result.contactDetails = overrides && overrides.hasOwnProperty('contactDetails') ? aComWixEcommercePlatformCommonApiFullAddressContactDetails(overrides.contactDetails ?? {}, pickedFields.get('contactDetails')) : aComWixEcommercePlatformCommonApiFullAddressContactDetails({}, pickedFields.get('contactDetails'));
    }

    return result;
};

export const anEcomCheckoutV1AddressWithContactInput = <T extends Partial<EcomCheckoutV1AddressWithContactInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixEcommercePlatformCommonApiAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aComWixEcommercePlatformCommonApiAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('addressesServiceId')) {
        result.addressesServiceId = overrides && overrides.hasOwnProperty('addressesServiceId') ? overrides.addressesServiceId! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('contactDetails')) {
        result.contactDetails = overrides && overrides.hasOwnProperty('contactDetails') ? aComWixEcommercePlatformCommonApiFullAddressContactDetailsInput(overrides.contactDetails ?? {}, pickedFields.get('contactDetails')) : aComWixEcommercePlatformCommonApiFullAddressContactDetailsInput({}, pickedFields.get('contactDetails'));
    }

    return result;
};

export const anEcomCheckoutV1BuyerInfo = <T extends Partial<EcomCheckoutV1BuyerInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('openAccess')) {
        result.openAccess = overrides && overrides.hasOwnProperty('openAccess') ? overrides.openAccess! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('visitorId')) {
        result.visitorId = overrides && overrides.hasOwnProperty('visitorId') ? overrides.visitorId! : 'voluptatem';
    }

    return result;
};

export const anEcomCheckoutV1BuyerInfoInput = <T extends Partial<EcomCheckoutV1BuyerInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('openAccess')) {
        result.openAccess = overrides && overrides.hasOwnProperty('openAccess') ? overrides.openAccess! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('visitorId')) {
        result.visitorId = overrides && overrides.hasOwnProperty('visitorId') ? overrides.visitorId! : 'sed';
    }

    return result;
};

export const anEcomCheckoutV1Charge = <T extends Partial<EcomCheckoutV1Charge>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cycleBillingDate')) {
        result.cycleBillingDate = overrides && overrides.hasOwnProperty('cycleBillingDate') ? overrides.cycleBillingDate! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('cycleCount')) {
        result.cycleCount = overrides && overrides.hasOwnProperty('cycleCount') ? overrides.cycleCount! : 4603;
    }
    if (pickedFields.size === 0 || pickedFields.has('cycleFrom')) {
        result.cycleFrom = overrides && overrides.hasOwnProperty('cycleFrom') ? overrides.cycleFrom! : 4275;
    }
    if (pickedFields.size === 0 || pickedFields.has('priceSummary')) {
        result.priceSummary = overrides && overrides.hasOwnProperty('priceSummary') ? aComWixEcomTotalsCalculatorV1PriceSummary(overrides.priceSummary ?? {}, pickedFields.get('priceSummary')) : aComWixEcomTotalsCalculatorV1PriceSummary({}, pickedFields.get('priceSummary'));
    }

    return result;
};

export const anEcomCheckoutV1ChargeInput = <T extends Partial<EcomCheckoutV1ChargeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cycleBillingDate')) {
        result.cycleBillingDate = overrides && overrides.hasOwnProperty('cycleBillingDate') ? overrides.cycleBillingDate! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('cycleCount')) {
        result.cycleCount = overrides && overrides.hasOwnProperty('cycleCount') ? overrides.cycleCount! : 8865;
    }
    if (pickedFields.size === 0 || pickedFields.has('cycleFrom')) {
        result.cycleFrom = overrides && overrides.hasOwnProperty('cycleFrom') ? overrides.cycleFrom! : 6648;
    }
    if (pickedFields.size === 0 || pickedFields.has('priceSummary')) {
        result.priceSummary = overrides && overrides.hasOwnProperty('priceSummary') ? aComWixEcomTotalsCalculatorV1PriceSummaryInput(overrides.priceSummary ?? {}, pickedFields.get('priceSummary')) : aComWixEcomTotalsCalculatorV1PriceSummaryInput({}, pickedFields.get('priceSummary'));
    }

    return result;
};

export const anEcomCheckoutV1Checkout = <T extends Partial<EcomCheckoutV1Checkout>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomTotalsCalculatorV1AdditionalFee(x ?? {}, pickedFields.get('additionalFees'))) : [aComWixEcomTotalsCalculatorV1AdditionalFee({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('appliedDiscounts')) {
        result.appliedDiscounts = overrides && overrides.hasOwnProperty('appliedDiscounts') ? overrides.appliedDiscounts!.map((x) => aComWixEcomTotalsCalculatorV1AppliedDiscount(x ?? {}, pickedFields.get('appliedDiscounts'))) : [aComWixEcomTotalsCalculatorV1AppliedDiscount({}, pickedFields.get('appliedDiscounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('billingInfo')) {
        result.billingInfo = overrides && overrides.hasOwnProperty('billingInfo') ? anEcomCheckoutV1AddressWithContact(overrides.billingInfo ?? {}, pickedFields.get('billingInfo')) : anEcomCheckoutV1AddressWithContact({}, pickedFields.get('billingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationId')) {
        result.businessLocationId = overrides && overrides.hasOwnProperty('businessLocationId') ? overrides.businessLocationId! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerInfo')) {
        result.buyerInfo = overrides && overrides.hasOwnProperty('buyerInfo') ? anEcomCheckoutV1BuyerInfo(overrides.buyerInfo ?? {}, pickedFields.get('buyerInfo')) : anEcomCheckoutV1BuyerInfo({}, pickedFields.get('buyerInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerLanguage')) {
        result.buyerLanguage = overrides && overrides.hasOwnProperty('buyerLanguage') ? overrides.buyerLanguage! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerNote')) {
        result.buyerNote = overrides && overrides.hasOwnProperty('buyerNote') ? overrides.buyerNote! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('calculationErrors')) {
        result.calculationErrors = overrides && overrides.hasOwnProperty('calculationErrors') ? aComWixEcomTotalsCalculatorV1CalculationErrors(overrides.calculationErrors ?? {}, pickedFields.get('calculationErrors')) : aComWixEcomTotalsCalculatorV1CalculationErrors({}, pickedFields.get('calculationErrors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cartId')) {
        result.cartId = overrides && overrides.hasOwnProperty('cartId') ? overrides.cartId! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('channelType')) {
        result.channelType = overrides && overrides.hasOwnProperty('channelType') ? overrides.channelType! : ComWixEcommercePlatformCommonApiChannelType.Amazon;
    }
    if (pickedFields.size === 0 || pickedFields.has('completed')) {
        result.completed = overrides && overrides.hasOwnProperty('completed') ? overrides.completed! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('conversionCurrency')) {
        result.conversionCurrency = overrides && overrides.hasOwnProperty('conversionCurrency') ? overrides.conversionCurrency! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('conversionInfo')) {
        result.conversionInfo = overrides && overrides.hasOwnProperty('conversionInfo') ? anEcomCheckoutV1ConversionInfo(overrides.conversionInfo ?? {}, pickedFields.get('conversionInfo')) : anEcomCheckoutV1ConversionInfo({}, pickedFields.get('conversionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdBy')) {
        result.createdBy = overrides && overrides.hasOwnProperty('createdBy') ? anEcomCheckoutV1CreatedBy(overrides.createdBy ?? {}, pickedFields.get('createdBy')) : anEcomCheckoutV1CreatedBy({}, pickedFields.get('createdBy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('customContentReference')) {
        result.customContentReference = overrides && overrides.hasOwnProperty('customContentReference') ? aComWixEcomCartCheckoutCommonApiV1CustomContentReference(overrides.customContentReference ?? {}, pickedFields.get('customContentReference')) : aComWixEcomCartCheckoutCommonApiV1CustomContentReference({}, pickedFields.get('customContentReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields!.map((x) => aComWixEcomOrdersV1CustomField(x ?? {}, pickedFields.get('customFields'))) : [aComWixEcomOrdersV1CustomField({}, pickedFields.get('customFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('customSettings')) {
        result.customSettings = overrides && overrides.hasOwnProperty('customSettings') ? anEcomCheckoutV1CustomSettings(overrides.customSettings ?? {}, pickedFields.get('customSettings')) : anEcomCheckoutV1CustomSettings({}, pickedFields.get('customSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ecomId')) {
        result.ecomId = overrides && overrides.hasOwnProperty('ecomId') ? overrides.ecomId! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEnrichedLineItems')) {
        result.externalEnrichedLineItems = overrides && overrides.hasOwnProperty('externalEnrichedLineItems') ? aComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForCheckoutResponse(overrides.externalEnrichedLineItems ?? {}, pickedFields.get('externalEnrichedLineItems')) : aComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForCheckoutResponse({}, pickedFields.get('externalEnrichedLineItems'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReference')) {
        result.externalReference = overrides && overrides.hasOwnProperty('externalReference') ? aComWixEcommercePlatformCommonApiExternalReference(overrides.externalReference ?? {}, pickedFields.get('externalReference')) : aComWixEcommercePlatformCommonApiExternalReference({}, pickedFields.get('externalReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aComWixEcomTotalsCalculatorV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aComWixEcomTotalsCalculatorV1GiftCard({}, pickedFields.get('giftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => anEcomCheckoutV1LineItem(x ?? {}, pickedFields.get('lineItems'))) : [anEcomCheckoutV1LineItem({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('managedByV2')) {
        result.managedByV2 = overrides && overrides.hasOwnProperty('managedByV2') ? overrides.managedByV2! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipOptions')) {
        result.membershipOptions = overrides && overrides.hasOwnProperty('membershipOptions') ? anEcomCheckoutV1MembershipOptions(overrides.membershipOptions ?? {}, pickedFields.get('membershipOptions')) : anEcomCheckoutV1MembershipOptions({}, pickedFields.get('membershipOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('payAfterFreeTrial')) {
        result.payAfterFreeTrial = overrides && overrides.hasOwnProperty('payAfterFreeTrial') ? aComWixEcomTotalsCalculatorV1PriceSummary(overrides.payAfterFreeTrial ?? {}, pickedFields.get('payAfterFreeTrial')) : aComWixEcomTotalsCalculatorV1PriceSummary({}, pickedFields.get('payAfterFreeTrial'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payLater')) {
        result.payLater = overrides && overrides.hasOwnProperty('payLater') ? aComWixEcomTotalsCalculatorV1PriceSummary(overrides.payLater ?? {}, pickedFields.get('payLater')) : aComWixEcomTotalsCalculatorV1PriceSummary({}, pickedFields.get('payLater'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payNow')) {
        result.payNow = overrides && overrides.hasOwnProperty('payNow') ? aComWixEcomTotalsCalculatorV1PriceSummary(overrides.payNow ?? {}, pickedFields.get('payNow')) : aComWixEcomTotalsCalculatorV1PriceSummary({}, pickedFields.get('payNow'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payNowTotalAfterGiftCard')) {
        result.payNowTotalAfterGiftCard = overrides && overrides.hasOwnProperty('payNowTotalAfterGiftCard') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.payNowTotalAfterGiftCard ?? {}, pickedFields.get('payNowTotalAfterGiftCard')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('payNowTotalAfterGiftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentCurrency')) {
        result.paymentCurrency = overrides && overrides.hasOwnProperty('paymentCurrency') ? overrides.paymentCurrency! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRequired')) {
        result.paymentRequired = overrides && overrides.hasOwnProperty('paymentRequired') ? overrides.paymentRequired! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('priceSummary')) {
        result.priceSummary = overrides && overrides.hasOwnProperty('priceSummary') ? aComWixEcomTotalsCalculatorV1PriceSummary(overrides.priceSummary ?? {}, pickedFields.get('priceSummary')) : aComWixEcomTotalsCalculatorV1PriceSummary({}, pickedFields.get('priceSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('purchaseFlowId')) {
        result.purchaseFlowId = overrides && overrides.hasOwnProperty('purchaseFlowId') ? overrides.purchaseFlowId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingInfo')) {
        result.shippingInfo = overrides && overrides.hasOwnProperty('shippingInfo') ? anEcomCheckoutV1ShippingInfo(overrides.shippingInfo ?? {}, pickedFields.get('shippingInfo')) : anEcomCheckoutV1ShippingInfo({}, pickedFields.get('shippingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteLanguage')) {
        result.siteLanguage = overrides && overrides.hasOwnProperty('siteLanguage') ? overrides.siteLanguage! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionCharges')) {
        result.subscriptionCharges = overrides && overrides.hasOwnProperty('subscriptionCharges') ? overrides.subscriptionCharges!.map((x) => anEcomCheckoutV1SubscriptionCharges(x ?? {}, pickedFields.get('subscriptionCharges'))) : [anEcomCheckoutV1SubscriptionCharges({}, pickedFields.get('subscriptionCharges'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxIncludedInPrice')) {
        result.taxIncludedInPrice = overrides && overrides.hasOwnProperty('taxIncludedInPrice') ? overrides.taxIncludedInPrice! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxSummary')) {
        result.taxSummary = overrides && overrides.hasOwnProperty('taxSummary') ? aComWixEcomTotalsCalculatorV1TaxSummary(overrides.taxSummary ?? {}, pickedFields.get('taxSummary')) : aComWixEcomTotalsCalculatorV1TaxSummary({}, pickedFields.get('taxSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalAfterGiftCard')) {
        result.totalAfterGiftCard = overrides && overrides.hasOwnProperty('totalAfterGiftCard') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.totalAfterGiftCard ?? {}, pickedFields.get('totalAfterGiftCard')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('totalAfterGiftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('violations')) {
        result.violations = overrides && overrides.hasOwnProperty('violations') ? overrides.violations!.map((x) => aComWixEcommerceValidationsSpiV1Violation(x ?? {}, pickedFields.get('violations'))) : [aComWixEcommerceValidationsSpiV1Violation({}, pickedFields.get('violations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('weightUnit')) {
        result.weightUnit = overrides && overrides.hasOwnProperty('weightUnit') ? overrides.weightUnit! : ComWixEcommercePlatformCommonApiWeightUnit.Kg;
    }

    return result;
};

export const anEcomCheckoutV1CheckoutInput = <T extends Partial<EcomCheckoutV1CheckoutInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aComWixEcomTotalsCalculatorV1AdditionalFeeInput({}, pickedFields.get('additionalFees'))) : [aComWixEcomTotalsCalculatorV1AdditionalFeeInput({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('appliedDiscounts')) {
        result.appliedDiscounts = overrides && overrides.hasOwnProperty('appliedDiscounts') ? overrides.appliedDiscounts!.map((x) => aComWixEcomTotalsCalculatorV1AppliedDiscountInput({}, pickedFields.get('appliedDiscounts'))) : [aComWixEcomTotalsCalculatorV1AppliedDiscountInput({}, pickedFields.get('appliedDiscounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('billingInfo')) {
        result.billingInfo = overrides && overrides.hasOwnProperty('billingInfo') ? anEcomCheckoutV1AddressWithContactInput(overrides.billingInfo ?? {}, pickedFields.get('billingInfo')) : anEcomCheckoutV1AddressWithContactInput({}, pickedFields.get('billingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationId')) {
        result.businessLocationId = overrides && overrides.hasOwnProperty('businessLocationId') ? overrides.businessLocationId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerInfo')) {
        result.buyerInfo = overrides && overrides.hasOwnProperty('buyerInfo') ? anEcomCheckoutV1BuyerInfoInput(overrides.buyerInfo ?? {}, pickedFields.get('buyerInfo')) : anEcomCheckoutV1BuyerInfoInput({}, pickedFields.get('buyerInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerLanguage')) {
        result.buyerLanguage = overrides && overrides.hasOwnProperty('buyerLanguage') ? overrides.buyerLanguage! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerNote')) {
        result.buyerNote = overrides && overrides.hasOwnProperty('buyerNote') ? overrides.buyerNote! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('calculationErrors')) {
        result.calculationErrors = overrides && overrides.hasOwnProperty('calculationErrors') ? aComWixEcomTotalsCalculatorV1CalculationErrorsInput(overrides.calculationErrors ?? {}, pickedFields.get('calculationErrors')) : aComWixEcomTotalsCalculatorV1CalculationErrorsInput({}, pickedFields.get('calculationErrors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cartId')) {
        result.cartId = overrides && overrides.hasOwnProperty('cartId') ? overrides.cartId! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('channelType')) {
        result.channelType = overrides && overrides.hasOwnProperty('channelType') ? overrides.channelType! : ComWixEcommercePlatformCommonApiChannelType.Amazon;
    }
    if (pickedFields.size === 0 || pickedFields.has('completed')) {
        result.completed = overrides && overrides.hasOwnProperty('completed') ? overrides.completed! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('conversionCurrency')) {
        result.conversionCurrency = overrides && overrides.hasOwnProperty('conversionCurrency') ? overrides.conversionCurrency! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('conversionInfo')) {
        result.conversionInfo = overrides && overrides.hasOwnProperty('conversionInfo') ? anEcomCheckoutV1ConversionInfoInput(overrides.conversionInfo ?? {}, pickedFields.get('conversionInfo')) : anEcomCheckoutV1ConversionInfoInput({}, pickedFields.get('conversionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdBy')) {
        result.createdBy = overrides && overrides.hasOwnProperty('createdBy') ? anEcomCheckoutV1CreatedByInput(overrides.createdBy ?? {}, pickedFields.get('createdBy')) : anEcomCheckoutV1CreatedByInput({}, pickedFields.get('createdBy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('customContentReference')) {
        result.customContentReference = overrides && overrides.hasOwnProperty('customContentReference') ? aComWixEcomCartCheckoutCommonApiV1CustomContentReferenceInput(overrides.customContentReference ?? {}, pickedFields.get('customContentReference')) : aComWixEcomCartCheckoutCommonApiV1CustomContentReferenceInput({}, pickedFields.get('customContentReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields!.map((x) => aComWixEcomOrdersV1CustomFieldInput({}, pickedFields.get('customFields'))) : [aComWixEcomOrdersV1CustomFieldInput({}, pickedFields.get('customFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('customSettings')) {
        result.customSettings = overrides && overrides.hasOwnProperty('customSettings') ? anEcomCheckoutV1CustomSettingsInput(overrides.customSettings ?? {}, pickedFields.get('customSettings')) : anEcomCheckoutV1CustomSettingsInput({}, pickedFields.get('customSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReference')) {
        result.externalReference = overrides && overrides.hasOwnProperty('externalReference') ? aComWixEcommercePlatformCommonApiExternalReferenceInput(overrides.externalReference ?? {}, pickedFields.get('externalReference')) : aComWixEcommercePlatformCommonApiExternalReferenceInput({}, pickedFields.get('externalReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aComWixEcomTotalsCalculatorV1GiftCardInput(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aComWixEcomTotalsCalculatorV1GiftCardInput({}, pickedFields.get('giftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => anEcomCheckoutV1LineItemInput({}, pickedFields.get('lineItems'))) : [anEcomCheckoutV1LineItemInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('managedByV2')) {
        result.managedByV2 = overrides && overrides.hasOwnProperty('managedByV2') ? overrides.managedByV2! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('membershipOptions')) {
        result.membershipOptions = overrides && overrides.hasOwnProperty('membershipOptions') ? anEcomCheckoutV1MembershipOptionsInput(overrides.membershipOptions ?? {}, pickedFields.get('membershipOptions')) : anEcomCheckoutV1MembershipOptionsInput({}, pickedFields.get('membershipOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('payAfterFreeTrial')) {
        result.payAfterFreeTrial = overrides && overrides.hasOwnProperty('payAfterFreeTrial') ? aComWixEcomTotalsCalculatorV1PriceSummaryInput(overrides.payAfterFreeTrial ?? {}, pickedFields.get('payAfterFreeTrial')) : aComWixEcomTotalsCalculatorV1PriceSummaryInput({}, pickedFields.get('payAfterFreeTrial'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payLater')) {
        result.payLater = overrides && overrides.hasOwnProperty('payLater') ? aComWixEcomTotalsCalculatorV1PriceSummaryInput(overrides.payLater ?? {}, pickedFields.get('payLater')) : aComWixEcomTotalsCalculatorV1PriceSummaryInput({}, pickedFields.get('payLater'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payNow')) {
        result.payNow = overrides && overrides.hasOwnProperty('payNow') ? aComWixEcomTotalsCalculatorV1PriceSummaryInput(overrides.payNow ?? {}, pickedFields.get('payNow')) : aComWixEcomTotalsCalculatorV1PriceSummaryInput({}, pickedFields.get('payNow'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payNowTotalAfterGiftCard')) {
        result.payNowTotalAfterGiftCard = overrides && overrides.hasOwnProperty('payNowTotalAfterGiftCard') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.payNowTotalAfterGiftCard ?? {}, pickedFields.get('payNowTotalAfterGiftCard')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('payNowTotalAfterGiftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentCurrency')) {
        result.paymentCurrency = overrides && overrides.hasOwnProperty('paymentCurrency') ? overrides.paymentCurrency! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentRequired')) {
        result.paymentRequired = overrides && overrides.hasOwnProperty('paymentRequired') ? overrides.paymentRequired! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('priceSummary')) {
        result.priceSummary = overrides && overrides.hasOwnProperty('priceSummary') ? aComWixEcomTotalsCalculatorV1PriceSummaryInput(overrides.priceSummary ?? {}, pickedFields.get('priceSummary')) : aComWixEcomTotalsCalculatorV1PriceSummaryInput({}, pickedFields.get('priceSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('purchaseFlowId')) {
        result.purchaseFlowId = overrides && overrides.hasOwnProperty('purchaseFlowId') ? overrides.purchaseFlowId! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingInfo')) {
        result.shippingInfo = overrides && overrides.hasOwnProperty('shippingInfo') ? anEcomCheckoutV1ShippingInfoInput(overrides.shippingInfo ?? {}, pickedFields.get('shippingInfo')) : anEcomCheckoutV1ShippingInfoInput({}, pickedFields.get('shippingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteLanguage')) {
        result.siteLanguage = overrides && overrides.hasOwnProperty('siteLanguage') ? overrides.siteLanguage! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionCharges')) {
        result.subscriptionCharges = overrides && overrides.hasOwnProperty('subscriptionCharges') ? overrides.subscriptionCharges!.map((x) => anEcomCheckoutV1SubscriptionChargesInput({}, pickedFields.get('subscriptionCharges'))) : [anEcomCheckoutV1SubscriptionChargesInput({}, pickedFields.get('subscriptionCharges'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('taxIncludedInPrice')) {
        result.taxIncludedInPrice = overrides && overrides.hasOwnProperty('taxIncludedInPrice') ? overrides.taxIncludedInPrice! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxSummary')) {
        result.taxSummary = overrides && overrides.hasOwnProperty('taxSummary') ? aComWixEcomTotalsCalculatorV1TaxSummaryInput(overrides.taxSummary ?? {}, pickedFields.get('taxSummary')) : aComWixEcomTotalsCalculatorV1TaxSummaryInput({}, pickedFields.get('taxSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalAfterGiftCard')) {
        result.totalAfterGiftCard = overrides && overrides.hasOwnProperty('totalAfterGiftCard') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.totalAfterGiftCard ?? {}, pickedFields.get('totalAfterGiftCard')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('totalAfterGiftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('violations')) {
        result.violations = overrides && overrides.hasOwnProperty('violations') ? overrides.violations!.map((x) => aComWixEcommerceValidationsSpiV1ViolationInput({}, pickedFields.get('violations'))) : [aComWixEcommerceValidationsSpiV1ViolationInput({}, pickedFields.get('violations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('weightUnit')) {
        result.weightUnit = overrides && overrides.hasOwnProperty('weightUnit') ? overrides.weightUnit! : ComWixEcommercePlatformCommonApiWeightUnit.Kg;
    }

    return result;
};

export const anEcomCheckoutV1ConversionInfo = <T extends Partial<EcomCheckoutV1ConversionInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conversionRate')) {
        result.conversionRate = overrides && overrides.hasOwnProperty('conversionRate') ? overrides.conversionRate! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteCurrency')) {
        result.siteCurrency = overrides && overrides.hasOwnProperty('siteCurrency') ? overrides.siteCurrency! : 'atque';
    }

    return result;
};

export const anEcomCheckoutV1ConversionInfoInput = <T extends Partial<EcomCheckoutV1ConversionInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conversionRate')) {
        result.conversionRate = overrides && overrides.hasOwnProperty('conversionRate') ? overrides.conversionRate! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteCurrency')) {
        result.siteCurrency = overrides && overrides.hasOwnProperty('siteCurrency') ? overrides.siteCurrency! : 'hic';
    }

    return result;
};

export const anEcomCheckoutV1CreateCheckoutRequestInput = <T extends Partial<EcomCheckoutV1CreateCheckoutRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('channelType')) {
        result.channelType = overrides && overrides.hasOwnProperty('channelType') ? overrides.channelType! : ComWixEcommercePlatformCommonApiChannelType.Amazon;
    }
    if (pickedFields.size === 0 || pickedFields.has('checkoutInfo')) {
        result.checkoutInfo = overrides && overrides.hasOwnProperty('checkoutInfo') ? anEcomCheckoutV1CheckoutInput(overrides.checkoutInfo ?? {}, pickedFields.get('checkoutInfo')) : anEcomCheckoutV1CheckoutInput({}, pickedFields.get('checkoutInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('couponCode')) {
        result.couponCode = overrides && overrides.hasOwnProperty('couponCode') ? overrides.couponCode! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('customLineItems')) {
        result.customLineItems = overrides && overrides.hasOwnProperty('customLineItems') ? overrides.customLineItems!.map((x) => aComWixEcomCartCheckoutCommonApiV1CustomLineItemInput({}, pickedFields.get('customLineItems'))) : [aComWixEcomCartCheckoutCommonApiV1CustomLineItemInput({}, pickedFields.get('customLineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardCode')) {
        result.giftCardCode = overrides && overrides.hasOwnProperty('giftCardCode') ? overrides.giftCardCode! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardRedeemAmount')) {
        result.giftCardRedeemAmount = overrides && overrides.hasOwnProperty('giftCardRedeemAmount') ? overrides.giftCardRedeemAmount! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => anEcomCheckoutV1LineItemInput({}, pickedFields.get('lineItems'))) : [anEcomCheckoutV1LineItemInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantDiscounts')) {
        result.merchantDiscounts = overrides && overrides.hasOwnProperty('merchantDiscounts') ? overrides.merchantDiscounts!.map((x) => aComWixEcomTotalsCalculatorV1MerchantDiscountInputInput({}, pickedFields.get('merchantDiscounts'))) : [aComWixEcomTotalsCalculatorV1MerchantDiscountInputInput({}, pickedFields.get('merchantDiscounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('overrideCheckoutUrl')) {
        result.overrideCheckoutUrl = overrides && overrides.hasOwnProperty('overrideCheckoutUrl') ? overrides.overrideCheckoutUrl! : 'id';
    }

    return result;
};

export const anEcomCheckoutV1CreateCheckoutResponse = <T extends Partial<EcomCheckoutV1CreateCheckoutResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1Checkout(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1Checkout({}, pickedFields.get('checkout'));
    }

    return result;
};

export const anEcomCheckoutV1CreateOrderAndChargeRequestInput = <T extends Partial<EcomCheckoutV1CreateOrderAndChargeRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('delayCapture')) {
        result.delayCapture = overrides && overrides.hasOwnProperty('delayCapture') ? overrides.delayCapture! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentToken')) {
        result.paymentToken = overrides && overrides.hasOwnProperty('paymentToken') ? overrides.paymentToken! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('savePaymentMethod')) {
        result.savePaymentMethod = overrides && overrides.hasOwnProperty('savePaymentMethod') ? overrides.savePaymentMethod! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('urlParams')) {
        result.urlParams = overrides && overrides.hasOwnProperty('urlParams') ? overrides.urlParams! : 'cupiditate';
    }

    return result;
};

export const anEcomCheckoutV1CreateOrderAndChargeResponse = <T extends Partial<EcomCheckoutV1CreateOrderAndChargeResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkoutCompleted')) {
        result.checkoutCompleted = overrides && overrides.hasOwnProperty('checkoutCompleted') ? overrides.checkoutCompleted! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayOrderId')) {
        result.paymentGatewayOrderId = overrides && overrides.hasOwnProperty('paymentGatewayOrderId') ? overrides.paymentGatewayOrderId! : 'cupiditate';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentResponseToken')) {
        result.paymentResponseToken = overrides && overrides.hasOwnProperty('paymentResponseToken') ? overrides.paymentResponseToken! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionId')) {
        result.subscriptionId = overrides && overrides.hasOwnProperty('subscriptionId') ? overrides.subscriptionId! : 'aliquid';
    }

    return result;
};

export const anEcomCheckoutV1CreateOrderRequestInput = <T extends Partial<EcomCheckoutV1CreateOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('delayCapture')) {
        result.delayCapture = overrides && overrides.hasOwnProperty('delayCapture') ? overrides.delayCapture! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('savePaymentMethod')) {
        result.savePaymentMethod = overrides && overrides.hasOwnProperty('savePaymentMethod') ? overrides.savePaymentMethod! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('urlParams')) {
        result.urlParams = overrides && overrides.hasOwnProperty('urlParams') ? overrides.urlParams! : 'reprehenderit';
    }

    return result;
};

export const anEcomCheckoutV1CreateOrderResponse = <T extends Partial<EcomCheckoutV1CreateOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayOrderId')) {
        result.paymentGatewayOrderId = overrides && overrides.hasOwnProperty('paymentGatewayOrderId') ? overrides.paymentGatewayOrderId! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionId')) {
        result.subscriptionId = overrides && overrides.hasOwnProperty('subscriptionId') ? overrides.subscriptionId! : 'sapiente';
    }

    return result;
};

export const anEcomCheckoutV1CreatedBy = <T extends Partial<EcomCheckoutV1CreatedBy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('visitorId')) {
        result.visitorId = overrides && overrides.hasOwnProperty('visitorId') ? overrides.visitorId! : 'consequatur';
    }

    return result;
};

export const anEcomCheckoutV1CreatedByInput = <T extends Partial<EcomCheckoutV1CreatedByInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('visitorId')) {
        result.visitorId = overrides && overrides.hasOwnProperty('visitorId') ? overrides.visitorId! : 'consequatur';
    }

    return result;
};

export const anEcomCheckoutV1CustomSettings = <T extends Partial<EcomCheckoutV1CustomSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('disabledManualPayment')) {
        result.disabledManualPayment = overrides && overrides.hasOwnProperty('disabledManualPayment') ? overrides.disabledManualPayment! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('disabledPolicyAgreementCheckbox')) {
        result.disabledPolicyAgreementCheckbox = overrides && overrides.hasOwnProperty('disabledPolicyAgreementCheckbox') ? overrides.disabledPolicyAgreementCheckbox! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('lockCouponCode')) {
        result.lockCouponCode = overrides && overrides.hasOwnProperty('lockCouponCode') ? overrides.lockCouponCode! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('lockGiftCard')) {
        result.lockGiftCard = overrides && overrides.hasOwnProperty('lockGiftCard') ? overrides.lockGiftCard! : true;
    }

    return result;
};

export const anEcomCheckoutV1CustomSettingsInput = <T extends Partial<EcomCheckoutV1CustomSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('disabledManualPayment')) {
        result.disabledManualPayment = overrides && overrides.hasOwnProperty('disabledManualPayment') ? overrides.disabledManualPayment! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('disabledPolicyAgreementCheckbox')) {
        result.disabledPolicyAgreementCheckbox = overrides && overrides.hasOwnProperty('disabledPolicyAgreementCheckbox') ? overrides.disabledPolicyAgreementCheckbox! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('lockCouponCode')) {
        result.lockCouponCode = overrides && overrides.hasOwnProperty('lockCouponCode') ? overrides.lockCouponCode! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('lockGiftCard')) {
        result.lockGiftCard = overrides && overrides.hasOwnProperty('lockGiftCard') ? overrides.lockGiftCard! : false;
    }

    return result;
};

export const anEcomCheckoutV1DeleteCheckoutRequestInput = <T extends Partial<EcomCheckoutV1DeleteCheckoutRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }

    return result;
};

export const anEcomCheckoutV1GetCheckoutByCartIdRequestInput = <T extends Partial<EcomCheckoutV1GetCheckoutByCartIdRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nobis';
    }

    return result;
};

export const anEcomCheckoutV1GetCheckoutByCartIdResponse = <T extends Partial<EcomCheckoutV1GetCheckoutByCartIdResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1Checkout(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1Checkout({}, pickedFields.get('checkout'));
    }

    return result;
};

export const anEcomCheckoutV1GetCheckoutPaymentSettingsRequestInput = <T extends Partial<EcomCheckoutV1GetCheckoutPaymentSettingsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptate';
    }

    return result;
};

export const anEcomCheckoutV1GetCheckoutPaymentSettingsResponse = <T extends Partial<EcomCheckoutV1GetCheckoutPaymentSettingsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('blockedPaymentOptions')) {
        result.blockedPaymentOptions = overrides && overrides.hasOwnProperty('blockedPaymentOptions') ? overrides.blockedPaymentOptions! : [EcomCheckoutV1PaymentOption.Manual];
    }

    return result;
};

export const anEcomCheckoutV1GetCheckoutRequestInput = <T extends Partial<EcomCheckoutV1GetCheckoutRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f2b7ae75-603e-47f8-9007-6badf5631911';
    }
    if (pickedFields.size === 0 || pickedFields.has('refresh')) {
        result.refresh = overrides && overrides.hasOwnProperty('refresh') ? overrides.refresh! : true;
    }

    return result;
};

export const anEcomCheckoutV1GetCheckoutResponse = <T extends Partial<EcomCheckoutV1GetCheckoutResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1Checkout(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1Checkout({}, pickedFields.get('checkout'));
    }

    return result;
};

export const anEcomCheckoutV1GetCheckoutUrlRequestInput = <T extends Partial<EcomCheckoutV1GetCheckoutUrlRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currencyCode')) {
        result.currencyCode = overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'accusamus';
    }

    return result;
};

export const anEcomCheckoutV1GetCheckoutUrlResponse = <T extends Partial<EcomCheckoutV1GetCheckoutUrlResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkoutUrl')) {
        result.checkoutUrl = overrides && overrides.hasOwnProperty('checkoutUrl') ? overrides.checkoutUrl! : 'odit';
    }

    return result;
};

export const anEcomCheckoutV1GetCheckoutWithAllExtendedFieldsRequestInput = <T extends Partial<EcomCheckoutV1GetCheckoutWithAllExtendedFieldsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('refresh')) {
        result.refresh = overrides && overrides.hasOwnProperty('refresh') ? overrides.refresh! : false;
    }

    return result;
};

export const anEcomCheckoutV1GetCheckoutWithAllExtendedFieldsResponse = <T extends Partial<EcomCheckoutV1GetCheckoutWithAllExtendedFieldsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1Checkout(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1Checkout({}, pickedFields.get('checkout'));
    }

    return result;
};

export const anEcomCheckoutV1GetWixCheckoutUrlRequestInput = <T extends Partial<EcomCheckoutV1GetWixCheckoutUrlRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cartId')) {
        result.cartId = overrides && overrides.hasOwnProperty('cartId') ? overrides.cartId! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyCode')) {
        result.currencyCode = overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolor';
    }

    return result;
};

export const anEcomCheckoutV1GetWixCheckoutUrlResponse = <T extends Partial<EcomCheckoutV1GetWixCheckoutUrlResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkoutUrl')) {
        result.checkoutUrl = overrides && overrides.hasOwnProperty('checkoutUrl') ? overrides.checkoutUrl! : 'eaque';
    }

    return result;
};

export const anEcomCheckoutV1ItemAvailabilityInfo = <T extends Partial<EcomCheckoutV1ItemAvailabilityInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('quantityAvailable')) {
        result.quantityAvailable = overrides && overrides.hasOwnProperty('quantityAvailable') ? overrides.quantityAvailable! : 9889;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : EcomCheckoutV1ItemAvailabilityStatus.Available;
    }

    return result;
};

export const anEcomCheckoutV1ItemAvailabilityInfoInput = <T extends Partial<EcomCheckoutV1ItemAvailabilityInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('quantityAvailable')) {
        result.quantityAvailable = overrides && overrides.hasOwnProperty('quantityAvailable') ? overrides.quantityAvailable! : 7695;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : EcomCheckoutV1ItemAvailabilityStatus.Available;
    }

    return result;
};

export const anEcomCheckoutV1LineItem = <T extends Partial<EcomCheckoutV1LineItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availability')) {
        result.availability = overrides && overrides.hasOwnProperty('availability') ? anEcomCheckoutV1ItemAvailabilityInfo(overrides.availability ?? {}, pickedFields.get('availability')) : anEcomCheckoutV1ItemAvailabilityInfo({}, pickedFields.get('availability'));
    }
    if (pickedFields.size === 0 || pickedFields.has('catalogOverrideFields')) {
        result.catalogOverrideFields = overrides && overrides.hasOwnProperty('catalogOverrideFields') ? aComWixEcomCartCheckoutCommonApiV1CatalogOverrideFields(overrides.catalogOverrideFields ?? {}, pickedFields.get('catalogOverrideFields')) : aComWixEcomCartCheckoutCommonApiV1CatalogOverrideFields({}, pickedFields.get('catalogOverrideFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('catalogReference')) {
        result.catalogReference = overrides && overrides.hasOwnProperty('catalogReference') ? aComWixEcommerceCatalogSpiApiV1CatalogReference(overrides.catalogReference ?? {}, pickedFields.get('catalogReference')) : aComWixEcommerceCatalogSpiApiV1CatalogReference({}, pickedFields.get('catalogReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('consentRequiredPaymentPolicy')) {
        result.consentRequiredPaymentPolicy = overrides && overrides.hasOwnProperty('consentRequiredPaymentPolicy') ? overrides.consentRequiredPaymentPolicy! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('couponScopes')) {
        result.couponScopes = overrides && overrides.hasOwnProperty('couponScopes') ? overrides.couponScopes!.map((x) => aWixCouponsApiV2Scope(x ?? {}, pickedFields.get('couponScopes'))) : [aWixCouponsApiV2Scope({}, pickedFields.get('couponScopes'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('customLineItem')) {
        result.customLineItem = overrides && overrides.hasOwnProperty('customLineItem') ? overrides.customLineItem! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryProfileId')) {
        result.deliveryProfileId = overrides && overrides.hasOwnProperty('deliveryProfileId') ? overrides.deliveryProfileId! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('depositAmount')) {
        result.depositAmount = overrides && overrides.hasOwnProperty('depositAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.depositAmount ?? {}, pickedFields.get('depositAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('depositAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLine(x ?? {}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLine({}, pickedFields.get('descriptionLines'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('digitalFile')) {
        result.digitalFile = overrides && overrides.hasOwnProperty('digitalFile') ? aComWixEcommerceCatalogSpiApiV1SecuredMedia(overrides.digitalFile ?? {}, pickedFields.get('digitalFile')) : aComWixEcommerceCatalogSpiApiV1SecuredMedia({}, pickedFields.get('digitalFile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedQuantity')) {
        result.fixedQuantity = overrides && overrides.hasOwnProperty('fixedQuantity') ? overrides.fixedQuantity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillerId')) {
        result.fulfillerId = overrides && overrides.hasOwnProperty('fulfillerId') ? overrides.fulfillerId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('fullPrice')) {
        result.fullPrice = overrides && overrides.hasOwnProperty('fullPrice') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.fullPrice ?? {}, pickedFields.get('fullPrice')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('fullPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('inventoryAppId')) {
        result.inventoryAppId = overrides && overrides.hasOwnProperty('inventoryAppId') ? overrides.inventoryAppId! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemType')) {
        result.itemType = overrides && overrides.hasOwnProperty('itemType') ? aComWixEcommerceCatalogSpiApiV1ItemType(overrides.itemType ?? {}, pickedFields.get('itemType')) : aComWixEcommerceCatalogSpiApiV1ItemType({}, pickedFields.get('itemType'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemPrice')) {
        result.lineItemPrice = overrides && overrides.hasOwnProperty('lineItemPrice') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.lineItemPrice ?? {}, pickedFields.get('lineItemPrice')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('lineItemPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixCommonImage(overrides.media ?? {}, pickedFields.get('media')) : aWixCommonImage({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('membersOnly')) {
        result.membersOnly = overrides && overrides.hasOwnProperty('membersOnly') ? overrides.membersOnly! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroups')) {
        result.modifierGroups = overrides && overrides.hasOwnProperty('modifierGroups') ? overrides.modifierGroups!.map((x) => aComWixEcomCartCheckoutCommonApiV1ModifierGroup(x ?? {}, pickedFields.get('modifierGroups'))) : [aComWixEcomCartCheckoutCommonApiV1ModifierGroup({}, pickedFields.get('modifierGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiersTotalPrice')) {
        result.modifiersTotalPrice = overrides && overrides.hasOwnProperty('modifiersTotalPrice') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.modifiersTotalPrice ?? {}, pickedFields.get('modifiersTotalPrice')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('modifiersTotalPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('originalFullPrice')) {
        result.originalFullPrice = overrides && overrides.hasOwnProperty('originalFullPrice') ? overrides.originalFullPrice! : 'repudiandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalPrice')) {
        result.originalPrice = overrides && overrides.hasOwnProperty('originalPrice') ? overrides.originalPrice! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOption')) {
        result.paymentOption = overrides && overrides.hasOwnProperty('paymentOption') ? overrides.paymentOption! : ComWixEcommerceCatalogSpiApiV1PaymentOptionType.DepositOnline;
    }
    if (pickedFields.size === 0 || pickedFields.has('physicalProperties')) {
        result.physicalProperties = overrides && overrides.hasOwnProperty('physicalProperties') ? aComWixEcommerceCatalogSpiApiV1PhysicalProperties(overrides.physicalProperties ?? {}, pickedFields.get('physicalProperties')) : aComWixEcommerceCatalogSpiApiV1PhysicalProperties({}, pickedFields.get('physicalProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('policies')) {
        result.policies = overrides && overrides.hasOwnProperty('policies') ? overrides.policies!.map((x) => aComWixEcommerceCatalogSpiApiV1Policy(x ?? {}, pickedFields.get('policies'))) : [aComWixEcommerceCatalogSpiApiV1Policy({}, pickedFields.get('policies'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscounts')) {
        result.priceBeforeDiscounts = overrides && overrides.hasOwnProperty('priceBeforeDiscounts') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.priceBeforeDiscounts ?? {}, pickedFields.get('priceBeforeDiscounts')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('priceBeforeDiscounts'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscountsAndTax')) {
        result.priceBeforeDiscountsAndTax = overrides && overrides.hasOwnProperty('priceBeforeDiscountsAndTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.priceBeforeDiscountsAndTax ?? {}, pickedFields.get('priceBeforeDiscountsAndTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('priceBeforeDiscountsAndTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceDescription')) {
        result.priceDescription = overrides && overrides.hasOwnProperty('priceDescription') ? aComWixEcommerceCatalogSpiApiV1PriceDescription(overrides.priceDescription ?? {}, pickedFields.get('priceDescription')) : aComWixEcommerceCatalogSpiApiV1PriceDescription({}, pickedFields.get('priceDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceUndetermined')) {
        result.priceUndetermined = overrides && overrides.hasOwnProperty('priceUndetermined') ? overrides.priceUndetermined! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('productName')) {
        result.productName = overrides && overrides.hasOwnProperty('productName') ? aComWixEcommerceCatalogSpiApiV1ProductName(overrides.productName ?? {}, pickedFields.get('productName')) : aComWixEcommerceCatalogSpiApiV1ProductName({}, pickedFields.get('productName'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 9409;
    }
    if (pickedFields.size === 0 || pickedFields.has('rootCatalogItemId')) {
        result.rootCatalogItemId = overrides && overrides.hasOwnProperty('rootCatalogItemId') ? overrides.rootCatalogItemId! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('savePaymentMethod')) {
        result.savePaymentMethod = overrides && overrides.hasOwnProperty('savePaymentMethod') ? overrides.savePaymentMethod! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceProperties')) {
        result.serviceProperties = overrides && overrides.hasOwnProperty('serviceProperties') ? aComWixEcommerceCatalogSpiApiV1ServiceProperties(overrides.serviceProperties ?? {}, pickedFields.get('serviceProperties')) : aComWixEcommerceCatalogSpiApiV1ServiceProperties({}, pickedFields.get('serviceProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingGroupId')) {
        result.shippingGroupId = overrides && overrides.hasOwnProperty('shippingGroupId') ? overrides.shippingGroupId! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionOptionInfo')) {
        result.subscriptionOptionInfo = overrides && overrides.hasOwnProperty('subscriptionOptionInfo') ? aComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo(overrides.subscriptionOptionInfo ?? {}, pickedFields.get('subscriptionOptionInfo')) : aComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo({}, pickedFields.get('subscriptionOptionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxDetails')) {
        result.taxDetails = overrides && overrides.hasOwnProperty('taxDetails') ? aComWixEcomTotalsCalculatorV1ItemTaxFullDetails(overrides.taxDetails ?? {}, pickedFields.get('taxDetails')) : aComWixEcomTotalsCalculatorV1ItemTaxFullDetails({}, pickedFields.get('taxDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAddress')) {
        result.taxableAddress = overrides && overrides.hasOwnProperty('taxableAddress') ? aComWixEcommercePlatformCommonApiTaxableAddress(overrides.taxableAddress ?? {}, pickedFields.get('taxableAddress')) : aComWixEcommercePlatformCommonApiTaxableAddress({}, pickedFields.get('taxableAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceAfterTax')) {
        result.totalPriceAfterTax = overrides && overrides.hasOwnProperty('totalPriceAfterTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.totalPriceAfterTax ?? {}, pickedFields.get('totalPriceAfterTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('totalPriceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceBeforeTax')) {
        result.totalPriceBeforeTax = overrides && overrides.hasOwnProperty('totalPriceBeforeTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPrice(overrides.totalPriceBeforeTax ?? {}, pickedFields.get('totalPriceBeforeTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPrice({}, pickedFields.get('totalPriceBeforeTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlV2(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlV2({}, pickedFields.get('url'));
    }

    return result;
};

export const anEcomCheckoutV1LineItemInput = <T extends Partial<EcomCheckoutV1LineItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availability')) {
        result.availability = overrides && overrides.hasOwnProperty('availability') ? anEcomCheckoutV1ItemAvailabilityInfoInput(overrides.availability ?? {}, pickedFields.get('availability')) : anEcomCheckoutV1ItemAvailabilityInfoInput({}, pickedFields.get('availability'));
    }
    if (pickedFields.size === 0 || pickedFields.has('catalogOverrideFields')) {
        result.catalogOverrideFields = overrides && overrides.hasOwnProperty('catalogOverrideFields') ? aComWixEcomCartCheckoutCommonApiV1CatalogOverrideFieldsInput(overrides.catalogOverrideFields ?? {}, pickedFields.get('catalogOverrideFields')) : aComWixEcomCartCheckoutCommonApiV1CatalogOverrideFieldsInput({}, pickedFields.get('catalogOverrideFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('catalogReference')) {
        result.catalogReference = overrides && overrides.hasOwnProperty('catalogReference') ? aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput(overrides.catalogReference ?? {}, pickedFields.get('catalogReference')) : aComWixEcommerceCatalogSpiApiV1CatalogReferenceInput({}, pickedFields.get('catalogReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('consentRequiredPaymentPolicy')) {
        result.consentRequiredPaymentPolicy = overrides && overrides.hasOwnProperty('consentRequiredPaymentPolicy') ? overrides.consentRequiredPaymentPolicy! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('couponScopes')) {
        result.couponScopes = overrides && overrides.hasOwnProperty('couponScopes') ? overrides.couponScopes!.map((x) => aWixCouponsApiV2ScopeInput({}, pickedFields.get('couponScopes'))) : [aWixCouponsApiV2ScopeInput({}, pickedFields.get('couponScopes'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('customLineItem')) {
        result.customLineItem = overrides && overrides.hasOwnProperty('customLineItem') ? overrides.customLineItem! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('deliveryProfileId')) {
        result.deliveryProfileId = overrides && overrides.hasOwnProperty('deliveryProfileId') ? overrides.deliveryProfileId! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('depositAmount')) {
        result.depositAmount = overrides && overrides.hasOwnProperty('depositAmount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.depositAmount ?? {}, pickedFields.get('depositAmount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('depositAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('descriptionLines')) {
        result.descriptionLines = overrides && overrides.hasOwnProperty('descriptionLines') ? overrides.descriptionLines!.map((x) => aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))) : [aComWixEcommerceCatalogSpiApiV1DescriptionLineInput({}, pickedFields.get('descriptionLines'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('digitalFile')) {
        result.digitalFile = overrides && overrides.hasOwnProperty('digitalFile') ? aComWixEcommerceCatalogSpiApiV1SecuredMediaInput(overrides.digitalFile ?? {}, pickedFields.get('digitalFile')) : aComWixEcommerceCatalogSpiApiV1SecuredMediaInput({}, pickedFields.get('digitalFile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.discount ?? {}, pickedFields.get('discount')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedQuantity')) {
        result.fixedQuantity = overrides && overrides.hasOwnProperty('fixedQuantity') ? overrides.fixedQuantity! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillerId')) {
        result.fulfillerId = overrides && overrides.hasOwnProperty('fulfillerId') ? overrides.fulfillerId! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('fullPrice')) {
        result.fullPrice = overrides && overrides.hasOwnProperty('fullPrice') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.fullPrice ?? {}, pickedFields.get('fullPrice')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('fullPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('inventoryAppId')) {
        result.inventoryAppId = overrides && overrides.hasOwnProperty('inventoryAppId') ? overrides.inventoryAppId! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemType')) {
        result.itemType = overrides && overrides.hasOwnProperty('itemType') ? aComWixEcommerceCatalogSpiApiV1ItemTypeInput(overrides.itemType ?? {}, pickedFields.get('itemType')) : aComWixEcommerceCatalogSpiApiV1ItemTypeInput({}, pickedFields.get('itemType'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemPrice')) {
        result.lineItemPrice = overrides && overrides.hasOwnProperty('lineItemPrice') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.lineItemPrice ?? {}, pickedFields.get('lineItemPrice')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('lineItemPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixCommonImageInput(overrides.media ?? {}, pickedFields.get('media')) : aWixCommonImageInput({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('membersOnly')) {
        result.membersOnly = overrides && overrides.hasOwnProperty('membersOnly') ? overrides.membersOnly! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroups')) {
        result.modifierGroups = overrides && overrides.hasOwnProperty('modifierGroups') ? overrides.modifierGroups!.map((x) => aComWixEcomCartCheckoutCommonApiV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))) : [aComWixEcomCartCheckoutCommonApiV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiersTotalPrice')) {
        result.modifiersTotalPrice = overrides && overrides.hasOwnProperty('modifiersTotalPrice') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.modifiersTotalPrice ?? {}, pickedFields.get('modifiersTotalPrice')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('modifiersTotalPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('originalFullPrice')) {
        result.originalFullPrice = overrides && overrides.hasOwnProperty('originalFullPrice') ? overrides.originalFullPrice! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalPrice')) {
        result.originalPrice = overrides && overrides.hasOwnProperty('originalPrice') ? overrides.originalPrice! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOption')) {
        result.paymentOption = overrides && overrides.hasOwnProperty('paymentOption') ? overrides.paymentOption! : ComWixEcommerceCatalogSpiApiV1PaymentOptionType.DepositOnline;
    }
    if (pickedFields.size === 0 || pickedFields.has('physicalProperties')) {
        result.physicalProperties = overrides && overrides.hasOwnProperty('physicalProperties') ? aComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput(overrides.physicalProperties ?? {}, pickedFields.get('physicalProperties')) : aComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput({}, pickedFields.get('physicalProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('policies')) {
        result.policies = overrides && overrides.hasOwnProperty('policies') ? overrides.policies!.map((x) => aComWixEcommerceCatalogSpiApiV1PolicyInput({}, pickedFields.get('policies'))) : [aComWixEcommerceCatalogSpiApiV1PolicyInput({}, pickedFields.get('policies'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.price ?? {}, pickedFields.get('price')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscounts')) {
        result.priceBeforeDiscounts = overrides && overrides.hasOwnProperty('priceBeforeDiscounts') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.priceBeforeDiscounts ?? {}, pickedFields.get('priceBeforeDiscounts')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('priceBeforeDiscounts'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscountsAndTax')) {
        result.priceBeforeDiscountsAndTax = overrides && overrides.hasOwnProperty('priceBeforeDiscountsAndTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.priceBeforeDiscountsAndTax ?? {}, pickedFields.get('priceBeforeDiscountsAndTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('priceBeforeDiscountsAndTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceDescription')) {
        result.priceDescription = overrides && overrides.hasOwnProperty('priceDescription') ? aComWixEcommerceCatalogSpiApiV1PriceDescriptionInput(overrides.priceDescription ?? {}, pickedFields.get('priceDescription')) : aComWixEcommerceCatalogSpiApiV1PriceDescriptionInput({}, pickedFields.get('priceDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceUndetermined')) {
        result.priceUndetermined = overrides && overrides.hasOwnProperty('priceUndetermined') ? overrides.priceUndetermined! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('productName')) {
        result.productName = overrides && overrides.hasOwnProperty('productName') ? aComWixEcommerceCatalogSpiApiV1ProductNameInput(overrides.productName ?? {}, pickedFields.get('productName')) : aComWixEcommerceCatalogSpiApiV1ProductNameInput({}, pickedFields.get('productName'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 2076;
    }
    if (pickedFields.size === 0 || pickedFields.has('rootCatalogItemId')) {
        result.rootCatalogItemId = overrides && overrides.hasOwnProperty('rootCatalogItemId') ? overrides.rootCatalogItemId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('savePaymentMethod')) {
        result.savePaymentMethod = overrides && overrides.hasOwnProperty('savePaymentMethod') ? overrides.savePaymentMethod! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceProperties')) {
        result.serviceProperties = overrides && overrides.hasOwnProperty('serviceProperties') ? aComWixEcommerceCatalogSpiApiV1ServicePropertiesInput(overrides.serviceProperties ?? {}, pickedFields.get('serviceProperties')) : aComWixEcommerceCatalogSpiApiV1ServicePropertiesInput({}, pickedFields.get('serviceProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingGroupId')) {
        result.shippingGroupId = overrides && overrides.hasOwnProperty('shippingGroupId') ? overrides.shippingGroupId! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionOptionInfo')) {
        result.subscriptionOptionInfo = overrides && overrides.hasOwnProperty('subscriptionOptionInfo') ? aComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput(overrides.subscriptionOptionInfo ?? {}, pickedFields.get('subscriptionOptionInfo')) : aComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput({}, pickedFields.get('subscriptionOptionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxDetails')) {
        result.taxDetails = overrides && overrides.hasOwnProperty('taxDetails') ? aComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput(overrides.taxDetails ?? {}, pickedFields.get('taxDetails')) : aComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput({}, pickedFields.get('taxDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAddress')) {
        result.taxableAddress = overrides && overrides.hasOwnProperty('taxableAddress') ? aComWixEcommercePlatformCommonApiTaxableAddressInput(overrides.taxableAddress ?? {}, pickedFields.get('taxableAddress')) : aComWixEcommercePlatformCommonApiTaxableAddressInput({}, pickedFields.get('taxableAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceAfterTax')) {
        result.totalPriceAfterTax = overrides && overrides.hasOwnProperty('totalPriceAfterTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.totalPriceAfterTax ?? {}, pickedFields.get('totalPriceAfterTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('totalPriceAfterTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceBeforeTax')) {
        result.totalPriceBeforeTax = overrides && overrides.hasOwnProperty('totalPriceBeforeTax') ? aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput(overrides.totalPriceBeforeTax ?? {}, pickedFields.get('totalPriceBeforeTax')) : aComWixEcommercePlatformCommonApiMultiCurrencyPriceInput({}, pickedFields.get('totalPriceBeforeTax'));
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlV2Input(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlV2Input({}, pickedFields.get('url'));
    }

    return result;
};

export const anEcomCheckoutV1LineItemQuantityUpdateInput = <T extends Partial<EcomCheckoutV1LineItemQuantityUpdateInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 7088;
    }

    return result;
};

export const anEcomCheckoutV1MarkCheckoutAsCompletedAndRedirectToUrlRequestInput = <T extends Partial<EcomCheckoutV1MarkCheckoutAsCompletedAndRedirectToUrlRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('token')) {
        result.token = overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'earum';
    }

    return result;
};

export const anEcomCheckoutV1MarkCheckoutAsCompletedRequestInput = <T extends Partial<EcomCheckoutV1MarkCheckoutAsCompletedRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'at';
    }

    return result;
};

export const anEcomCheckoutV1MembershipOptions = <T extends Partial<EcomCheckoutV1MembershipOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eligibleMemberships')) {
        result.eligibleMemberships = overrides && overrides.hasOwnProperty('eligibleMemberships') ? overrides.eligibleMemberships!.map((x) => aComWixEcomMembershipsSpiV1HostMembership(x ?? {}, pickedFields.get('eligibleMemberships'))) : [aComWixEcomMembershipsSpiV1HostMembership({}, pickedFields.get('eligibleMemberships'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('invalidMemberships')) {
        result.invalidMemberships = overrides && overrides.hasOwnProperty('invalidMemberships') ? overrides.invalidMemberships!.map((x) => aComWixEcomMembershipsSpiV1HostInvalidMembership(x ?? {}, pickedFields.get('invalidMemberships'))) : [aComWixEcomMembershipsSpiV1HostInvalidMembership({}, pickedFields.get('invalidMemberships'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('selectedMemberships')) {
        result.selectedMemberships = overrides && overrides.hasOwnProperty('selectedMemberships') ? aComWixEcomMembershipsSpiV1HostSelectedMemberships(overrides.selectedMemberships ?? {}, pickedFields.get('selectedMemberships')) : aComWixEcomMembershipsSpiV1HostSelectedMemberships({}, pickedFields.get('selectedMemberships'));
    }

    return result;
};

export const anEcomCheckoutV1MembershipOptionsInput = <T extends Partial<EcomCheckoutV1MembershipOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eligibleMemberships')) {
        result.eligibleMemberships = overrides && overrides.hasOwnProperty('eligibleMemberships') ? overrides.eligibleMemberships!.map((x) => aComWixEcomMembershipsSpiV1HostMembershipInput({}, pickedFields.get('eligibleMemberships'))) : [aComWixEcomMembershipsSpiV1HostMembershipInput({}, pickedFields.get('eligibleMemberships'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('invalidMemberships')) {
        result.invalidMemberships = overrides && overrides.hasOwnProperty('invalidMemberships') ? overrides.invalidMemberships!.map((x) => aComWixEcomMembershipsSpiV1HostInvalidMembershipInput({}, pickedFields.get('invalidMemberships'))) : [aComWixEcomMembershipsSpiV1HostInvalidMembershipInput({}, pickedFields.get('invalidMemberships'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('selectedMemberships')) {
        result.selectedMemberships = overrides && overrides.hasOwnProperty('selectedMemberships') ? aComWixEcomMembershipsSpiV1HostSelectedMembershipsInput(overrides.selectedMemberships ?? {}, pickedFields.get('selectedMemberships')) : aComWixEcomMembershipsSpiV1HostSelectedMembershipsInput({}, pickedFields.get('selectedMemberships'));
    }

    return result;
};

export const anEcomCheckoutV1RemoveCouponRequestInput = <T extends Partial<EcomCheckoutV1RemoveCouponRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cupiditate';
    }

    return result;
};

export const anEcomCheckoutV1RemoveCouponResponse = <T extends Partial<EcomCheckoutV1RemoveCouponResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1Checkout(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1Checkout({}, pickedFields.get('checkout'));
    }

    return result;
};

export const anEcomCheckoutV1RemoveGiftCardRequestInput = <T extends Partial<EcomCheckoutV1RemoveGiftCardRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nulla';
    }

    return result;
};

export const anEcomCheckoutV1RemoveGiftCardResponse = <T extends Partial<EcomCheckoutV1RemoveGiftCardResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1Checkout(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1Checkout({}, pickedFields.get('checkout'));
    }

    return result;
};

export const anEcomCheckoutV1RemoveLineItemsRequestInput = <T extends Partial<EcomCheckoutV1RemoveLineItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['in'];
    }

    return result;
};

export const anEcomCheckoutV1RemoveLineItemsResponse = <T extends Partial<EcomCheckoutV1RemoveLineItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1Checkout(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1Checkout({}, pickedFields.get('checkout'));
    }

    return result;
};

export const anEcomCheckoutV1RemoveOverrideCheckoutUrlRequestInput = <T extends Partial<EcomCheckoutV1RemoveOverrideCheckoutUrlRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nesciunt';
    }

    return result;
};

export const anEcomCheckoutV1RemoveOverrideCheckoutUrlResponse = <T extends Partial<EcomCheckoutV1RemoveOverrideCheckoutUrlResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1Checkout(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1Checkout({}, pickedFields.get('checkout'));
    }

    return result;
};

export const anEcomCheckoutV1ShippingInfo = <T extends Partial<EcomCheckoutV1ShippingInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierServiceOptions')) {
        result.carrierServiceOptions = overrides && overrides.hasOwnProperty('carrierServiceOptions') ? overrides.carrierServiceOptions!.map((x) => aComWixEcomTotalsCalculatorV1CarrierServiceOption(x ?? {}, pickedFields.get('carrierServiceOptions'))) : [aComWixEcomTotalsCalculatorV1CarrierServiceOption({}, pickedFields.get('carrierServiceOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('region')) {
        result.region = overrides && overrides.hasOwnProperty('region') ? aComWixEcomTotalsCalculatorV1ShippingRegion(overrides.region ?? {}, pickedFields.get('region')) : aComWixEcomTotalsCalculatorV1ShippingRegion({}, pickedFields.get('region'));
    }
    if (pickedFields.size === 0 || pickedFields.has('selectedCarrierServiceOption')) {
        result.selectedCarrierServiceOption = overrides && overrides.hasOwnProperty('selectedCarrierServiceOption') ? aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption(overrides.selectedCarrierServiceOption ?? {}, pickedFields.get('selectedCarrierServiceOption')) : aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption({}, pickedFields.get('selectedCarrierServiceOption'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingDestination')) {
        result.shippingDestination = overrides && overrides.hasOwnProperty('shippingDestination') ? anEcomCheckoutV1AddressWithContact(overrides.shippingDestination ?? {}, pickedFields.get('shippingDestination')) : anEcomCheckoutV1AddressWithContact({}, pickedFields.get('shippingDestination'));
    }

    return result;
};

export const anEcomCheckoutV1ShippingInfoInput = <T extends Partial<EcomCheckoutV1ShippingInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('carrierServiceOptions')) {
        result.carrierServiceOptions = overrides && overrides.hasOwnProperty('carrierServiceOptions') ? overrides.carrierServiceOptions!.map((x) => aComWixEcomTotalsCalculatorV1CarrierServiceOptionInput({}, pickedFields.get('carrierServiceOptions'))) : [aComWixEcomTotalsCalculatorV1CarrierServiceOptionInput({}, pickedFields.get('carrierServiceOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('region')) {
        result.region = overrides && overrides.hasOwnProperty('region') ? aComWixEcomTotalsCalculatorV1ShippingRegionInput(overrides.region ?? {}, pickedFields.get('region')) : aComWixEcomTotalsCalculatorV1ShippingRegionInput({}, pickedFields.get('region'));
    }
    if (pickedFields.size === 0 || pickedFields.has('selectedCarrierServiceOption')) {
        result.selectedCarrierServiceOption = overrides && overrides.hasOwnProperty('selectedCarrierServiceOption') ? aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionInput(overrides.selectedCarrierServiceOption ?? {}, pickedFields.get('selectedCarrierServiceOption')) : aComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionInput({}, pickedFields.get('selectedCarrierServiceOption'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingDestination')) {
        result.shippingDestination = overrides && overrides.hasOwnProperty('shippingDestination') ? anEcomCheckoutV1AddressWithContactInput(overrides.shippingDestination ?? {}, pickedFields.get('shippingDestination')) : anEcomCheckoutV1AddressWithContactInput({}, pickedFields.get('shippingDestination'));
    }

    return result;
};

export const anEcomCheckoutV1SubscriptionCharges = <T extends Partial<EcomCheckoutV1SubscriptionCharges>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('charges')) {
        result.charges = overrides && overrides.hasOwnProperty('charges') ? overrides.charges!.map((x) => anEcomCheckoutV1Charge(x ?? {}, pickedFields.get('charges'))) : [anEcomCheckoutV1Charge({}, pickedFields.get('charges'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['qui'];
    }

    return result;
};

export const anEcomCheckoutV1SubscriptionChargesInput = <T extends Partial<EcomCheckoutV1SubscriptionChargesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('charges')) {
        result.charges = overrides && overrides.hasOwnProperty('charges') ? overrides.charges!.map((x) => anEcomCheckoutV1ChargeInput({}, pickedFields.get('charges'))) : [anEcomCheckoutV1ChargeInput({}, pickedFields.get('charges'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemIds')) {
        result.lineItemIds = overrides && overrides.hasOwnProperty('lineItemIds') ? overrides.lineItemIds! : ['quia'];
    }

    return result;
};

export const anEcomCheckoutV1UpdateCheckoutRequestInput = <T extends Partial<EcomCheckoutV1UpdateCheckoutRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1CheckoutInput(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1CheckoutInput({}, pickedFields.get('checkout'));
    }
    if (pickedFields.size === 0 || pickedFields.has('couponCode')) {
        result.couponCode = overrides && overrides.hasOwnProperty('couponCode') ? overrides.couponCode! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('customLineItems')) {
        result.customLineItems = overrides && overrides.hasOwnProperty('customLineItems') ? overrides.customLineItems!.map((x) => aComWixEcomCartCheckoutCommonApiV1CustomLineItemInput({}, pickedFields.get('customLineItems'))) : [aComWixEcomCartCheckoutCommonApiV1CustomLineItemInput({}, pickedFields.get('customLineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['sed'];
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardCode')) {
        result.giftCardCode = overrides && overrides.hasOwnProperty('giftCardCode') ? overrides.giftCardCode! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardRedeemAmount')) {
        result.giftCardRedeemAmount = overrides && overrides.hasOwnProperty('giftCardRedeemAmount') ? overrides.giftCardRedeemAmount! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('ignoreCalculationErrors')) {
        result.ignoreCalculationErrors = overrides && overrides.hasOwnProperty('ignoreCalculationErrors') ? overrides.ignoreCalculationErrors! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => anEcomCheckoutV1LineItemInput({}, pickedFields.get('lineItems'))) : [anEcomCheckoutV1LineItemInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantDiscounts')) {
        result.merchantDiscounts = overrides && overrides.hasOwnProperty('merchantDiscounts') ? overrides.merchantDiscounts!.map((x) => aComWixEcomTotalsCalculatorV1MerchantDiscountInputInput({}, pickedFields.get('merchantDiscounts'))) : [aComWixEcomTotalsCalculatorV1MerchantDiscountInputInput({}, pickedFields.get('merchantDiscounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('overrideCheckoutUrl')) {
        result.overrideCheckoutUrl = overrides && overrides.hasOwnProperty('overrideCheckoutUrl') ? overrides.overrideCheckoutUrl! : 'reiciendis';
    }

    return result;
};

export const anEcomCheckoutV1UpdateCheckoutResponse = <T extends Partial<EcomCheckoutV1UpdateCheckoutResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1Checkout(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1Checkout({}, pickedFields.get('checkout'));
    }

    return result;
};

export const anEcomCheckoutV1UpdateLineItemsQuantityRequestInput = <T extends Partial<EcomCheckoutV1UpdateLineItemsQuantityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => anEcomCheckoutV1LineItemQuantityUpdateInput({}, pickedFields.get('lineItems'))) : [anEcomCheckoutV1LineItemQuantityUpdateInput({}, pickedFields.get('lineItems'))];
    }

    return result;
};

export const anEcomCheckoutV1UpdateLineItemsQuantityResponse = <T extends Partial<EcomCheckoutV1UpdateLineItemsQuantityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? anEcomCheckoutV1Checkout(overrides.checkout ?? {}, pickedFields.get('checkout')) : anEcomCheckoutV1Checkout({}, pickedFields.get('checkout'));
    }

    return result;
};

export const anEcomCheckoutV1UpdatedCheckoutMessageInput = <T extends Partial<EcomCheckoutV1UpdatedCheckoutMessageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('oldCheckout')) {
        result.oldCheckout = overrides && overrides.hasOwnProperty('oldCheckout') ? anEcomCheckoutV1CheckoutInput(overrides.oldCheckout ?? {}, pickedFields.get('oldCheckout')) : anEcomCheckoutV1CheckoutInput({}, pickedFields.get('oldCheckout'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedCheckout')) {
        result.updatedCheckout = overrides && overrides.hasOwnProperty('updatedCheckout') ? anEcomCheckoutV1CheckoutInput(overrides.updatedCheckout ?? {}, pickedFields.get('updatedCheckout')) : anEcomCheckoutV1CheckoutInput({}, pickedFields.get('updatedCheckout'));
    }

    return result;
};

export const anExternalEchoInput = <T extends Partial<ExternalEchoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('arg2')) {
        result.arg2 = overrides && overrides.hasOwnProperty('arg2') ? overrides.arg2! : 'eum';
    }

    return result;
};

export const aGoogleProtobufStructInput = <T extends Partial<GoogleProtobufStructInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : 'animi';
    }

    return result;
};

export const aMetroinspectorV1CollectionsCollection = <T extends Partial<MetroinspectorV1CollectionsCollection>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('productIds')) {
        result.productIds = overrides && overrides.hasOwnProperty('productIds') ? overrides.productIds! : ['vel'];
    }
    if (pickedFields.size === 0 || pickedFields.has('products')) {
        result.products = overrides && overrides.hasOwnProperty('products') ? aMetroinspectorV1ProductsQueryProductsResponse(overrides.products ?? {}, pickedFields.get('products')) : aMetroinspectorV1ProductsQueryProductsResponse({}, pickedFields.get('products'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'inventore';
    }

    return result;
};

export const aMetroinspectorV1CollectionsGetCollectionRequestInput = <T extends Partial<MetroinspectorV1CollectionsGetCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '2e52aab4-19e3-49ea-8acf-ae6f81e3cac6';
    }

    return result;
};

export const aMetroinspectorV1CollectionsQueryCollectionsRequestInput = <T extends Partial<MetroinspectorV1CollectionsQueryCollectionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aMetroinspectorV1CollectionsQueryCollectionsResponse = <T extends Partial<MetroinspectorV1CollectionsQueryCollectionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aMetroinspectorV1CollectionsCollection(x ?? {}, pickedFields.get('items'))) : [aMetroinspectorV1CollectionsCollection({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aMetroinspectorV1ProductsBulkCreateProductsRequestInput = <T extends Partial<MetroinspectorV1ProductsBulkCreateProductsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('products')) {
        result.products = overrides && overrides.hasOwnProperty('products') ? overrides.products!.map((x) => aMetroinspectorV1ProductsProductInput({}, pickedFields.get('products'))) : [aMetroinspectorV1ProductsProductInput({}, pickedFields.get('products'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }

    return result;
};

export const aMetroinspectorV1ProductsBulkCreateProductsResponse = <T extends Partial<MetroinspectorV1ProductsBulkCreateProductsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aMetroinspectorV1ProductsBulkProductResult(x ?? {}, pickedFields.get('results'))) : [aMetroinspectorV1ProductsBulkProductResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aMetroinspectorV1ProductsBulkDeleteProductsRequestInput = <T extends Partial<MetroinspectorV1ProductsBulkDeleteProductsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('productIds')) {
        result.productIds = overrides && overrides.hasOwnProperty('productIds') ? overrides.productIds! : ['qui'];
    }

    return result;
};

export const aMetroinspectorV1ProductsBulkDeleteProductsResponse = <T extends Partial<MetroinspectorV1ProductsBulkDeleteProductsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aMetroinspectorV1ProductsBulkProductResult(x ?? {}, pickedFields.get('results'))) : [aMetroinspectorV1ProductsBulkProductResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aMetroinspectorV1ProductsBulkProductResult = <T extends Partial<MetroinspectorV1ProductsBulkProductResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aMetroinspectorV1ProductsProduct(overrides.item ?? {}, pickedFields.get('item')) : aMetroinspectorV1ProductsProduct({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aMetroinspectorV1ProductsBulkUpdateProductsRequestInput = <T extends Partial<MetroinspectorV1ProductsBulkUpdateProductsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('products')) {
        result.products = overrides && overrides.hasOwnProperty('products') ? overrides.products!.map((x) => aMetroinspectorV1ProductsMaskedProductInput({}, pickedFields.get('products'))) : [aMetroinspectorV1ProductsMaskedProductInput({}, pickedFields.get('products'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }

    return result;
};

export const aMetroinspectorV1ProductsBulkUpdateProductsResponse = <T extends Partial<MetroinspectorV1ProductsBulkUpdateProductsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aMetroinspectorV1ProductsBulkProductResult(x ?? {}, pickedFields.get('results'))) : [aMetroinspectorV1ProductsBulkProductResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aMetroinspectorV1ProductsCountProductsRequestInput = <T extends Partial<MetroinspectorV1ProductsCountProductsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('includeHiddenProducts')) {
        result.includeHiddenProducts = overrides && overrides.hasOwnProperty('includeHiddenProducts') ? overrides.includeHiddenProducts! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeMerchantSpecificData')) {
        result.includeMerchantSpecificData = overrides && overrides.hasOwnProperty('includeMerchantSpecificData') ? overrides.includeMerchantSpecificData! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeVariants')) {
        result.includeVariants = overrides && overrides.hasOwnProperty('includeVariants') ? overrides.includeVariants! : true;
    }

    return result;
};

export const aMetroinspectorV1ProductsCountProductsResponse = <T extends Partial<MetroinspectorV1ProductsCountProductsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 6073;
    }

    return result;
};

export const aMetroinspectorV1ProductsCreateProductRequestInput = <T extends Partial<MetroinspectorV1ProductsCreateProductRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aMetroinspectorV1ProductsProductInput(overrides.product ?? {}, pickedFields.get('product')) : aMetroinspectorV1ProductsProductInput({}, pickedFields.get('product'));
    }

    return result;
};

export const aMetroinspectorV1ProductsCreateProductResponse = <T extends Partial<MetroinspectorV1ProductsCreateProductResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aMetroinspectorV1ProductsProduct(overrides.product ?? {}, pickedFields.get('product')) : aMetroinspectorV1ProductsProduct({}, pickedFields.get('product'));
    }

    return result;
};

export const aMetroinspectorV1ProductsDeleteProductRequestInput = <T extends Partial<MetroinspectorV1ProductsDeleteProductRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('productId')) {
        result.productId = overrides && overrides.hasOwnProperty('productId') ? overrides.productId! : 'ex';
    }

    return result;
};

export const aMetroinspectorV1ProductsGetProductRequestInput = <T extends Partial<MetroinspectorV1ProductsGetProductRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dd2d628b-1678-4d4c-8b2a-9d0ab19384a1';
    }

    return result;
};

export const aMetroinspectorV1ProductsGetProductsStartWithRequestInput = <T extends Partial<MetroinspectorV1ProductsGetProductsStartWithRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'quaerat';
    }

    return result;
};

export const aMetroinspectorV1ProductsGetProductsStartWithResponse = <T extends Partial<MetroinspectorV1ProductsGetProductsStartWithResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('products')) {
        result.products = overrides && overrides.hasOwnProperty('products') ? overrides.products!.map((x) => aMetroinspectorV1ProductsProduct(x ?? {}, pickedFields.get('products'))) : [aMetroinspectorV1ProductsProduct({}, pickedFields.get('products'))];
    }

    return result;
};

export const aMetroinspectorV1ProductsMaskedProductInput = <T extends Partial<MetroinspectorV1ProductsMaskedProductInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['quod'];
    }
    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aMetroinspectorV1ProductsProductInput(overrides.product ?? {}, pickedFields.get('product')) : aMetroinspectorV1ProductsProductInput({}, pickedFields.get('product'));
    }

    return result;
};

export const aMetroinspectorV1ProductsMyAddress = <T extends Partial<MetroinspectorV1ProductsMyAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'delectus';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixCommonStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixCommonStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'doloremque';
    }

    return result;
};

export const aMetroinspectorV1ProductsMyAddressInput = <T extends Partial<MetroinspectorV1ProductsMyAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixCommonStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixCommonStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'aspernatur';
    }

    return result;
};

export const aMetroinspectorV1ProductsProduct = <T extends Partial<MetroinspectorV1ProductsProduct>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aWixCommonAddress(overrides.address ?? {}, pickedFields.get('address')) : aWixCommonAddress({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('audio')) {
        result.audio = overrides && overrides.hasOwnProperty('audio') ? aWixCommonAudio(overrides.audio ?? {}, pickedFields.get('audio')) : aWixCommonAudio({}, pickedFields.get('audio'));
    }
    if (pickedFields.size === 0 || pickedFields.has('collection')) {
        result.collection = overrides && overrides.hasOwnProperty('collection') ? aMetroinspectorV1CollectionsCollection(overrides.collection ?? {}, pickedFields.get('collection')) : aMetroinspectorV1CollectionsCollection({}, pickedFields.get('collection'));
    }
    if (pickedFields.size === 0 || pickedFields.has('collectionId')) {
        result.collectionId = overrides && overrides.hasOwnProperty('collectionId') ? overrides.collectionId! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('collectionsVirtualReference')) {
        result.collectionsVirtualReference = overrides && overrides.hasOwnProperty('collectionsVirtualReference') ? aMetroinspectorV1CollectionsQueryCollectionsResponse(overrides.collectionsVirtualReference ?? {}, pickedFields.get('collectionsVirtualReference')) : aMetroinspectorV1CollectionsQueryCollectionsResponse({}, pickedFields.get('collectionsVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('color')) {
        result.color = overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('customAddress')) {
        result.customAddress = overrides && overrides.hasOwnProperty('customAddress') ? aMetroinspectorV1ProductsMyAddress(overrides.customAddress ?? {}, pickedFields.get('customAddress')) : aMetroinspectorV1ProductsMyAddress({}, pickedFields.get('customAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('document')) {
        result.document = overrides && overrides.hasOwnProperty('document') ? aWixCommonDocument(overrides.document ?? {}, pickedFields.get('document')) : aWixCommonDocument({}, pickedFields.get('document'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEcho')) {
        result.externalEcho = overrides && overrides.hasOwnProperty('externalEcho') ? aWixCoreservicesMetroinspectorV1EchoResponse(overrides.externalEcho ?? {}, pickedFields.get('externalEcho')) : aWixCoreservicesMetroinspectorV1EchoResponse({}, pickedFields.get('externalEcho'));
    }
    if (pickedFields.size === 0 || pickedFields.has('guid')) {
        result.guid = overrides && overrides.hasOwnProperty('guid') ? overrides.guid! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nisi';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('localDate')) {
        result.localDate = overrides && overrides.hasOwnProperty('localDate') ? overrides.localDate! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('localDateTime')) {
        result.localDateTime = overrides && overrides.hasOwnProperty('localDateTime') ? overrides.localDateTime! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('localTime')) {
        result.localTime = overrides && overrides.hasOwnProperty('localTime') ? overrides.localTime! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('mainVariant')) {
        result.mainVariant = overrides && overrides.hasOwnProperty('mainVariant') ? aMetroinspectorV1ProductsVariant(overrides.mainVariant ?? {}, pickedFields.get('mainVariant')) : aMetroinspectorV1ProductsVariant({}, pickedFields.get('mainVariant'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiedDate')) {
        result.modifiedDate = overrides && overrides.hasOwnProperty('modifiedDate') ? overrides.modifiedDate! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('pageLink')) {
        result.pageLink = overrides && overrides.hasOwnProperty('pageLink') ? aWixCommonPageLink(overrides.pageLink ?? {}, pickedFields.get('pageLink')) : aWixCommonPageLink({}, pickedFields.get('pageLink'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aMetroinspectorV1ProductsVariant(x ?? {}, pickedFields.get('variants'))) : [aMetroinspectorV1ProductsVariant({}, pickedFields.get('variants'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideoV2(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideoV2({}, pickedFields.get('video'));
    }

    return result;
};

export const aMetroinspectorV1ProductsProductInput = <T extends Partial<MetroinspectorV1ProductsProductInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aWixCommonAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aWixCommonAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('audio')) {
        result.audio = overrides && overrides.hasOwnProperty('audio') ? aWixCommonAudioInput(overrides.audio ?? {}, pickedFields.get('audio')) : aWixCommonAudioInput({}, pickedFields.get('audio'));
    }
    if (pickedFields.size === 0 || pickedFields.has('collectionId')) {
        result.collectionId = overrides && overrides.hasOwnProperty('collectionId') ? overrides.collectionId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('color')) {
        result.color = overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('customAddress')) {
        result.customAddress = overrides && overrides.hasOwnProperty('customAddress') ? aMetroinspectorV1ProductsMyAddressInput(overrides.customAddress ?? {}, pickedFields.get('customAddress')) : aMetroinspectorV1ProductsMyAddressInput({}, pickedFields.get('customAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('document')) {
        result.document = overrides && overrides.hasOwnProperty('document') ? aWixCommonDocumentInput(overrides.document ?? {}, pickedFields.get('document')) : aWixCommonDocumentInput({}, pickedFields.get('document'));
    }
    if (pickedFields.size === 0 || pickedFields.has('guid')) {
        result.guid = overrides && overrides.hasOwnProperty('guid') ? overrides.guid! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('localDate')) {
        result.localDate = overrides && overrides.hasOwnProperty('localDate') ? overrides.localDate! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('localDateTime')) {
        result.localDateTime = overrides && overrides.hasOwnProperty('localDateTime') ? overrides.localDateTime! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('localTime')) {
        result.localTime = overrides && overrides.hasOwnProperty('localTime') ? overrides.localTime! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('mainVariant')) {
        result.mainVariant = overrides && overrides.hasOwnProperty('mainVariant') ? aMetroinspectorV1ProductsVariantInput(overrides.mainVariant ?? {}, pickedFields.get('mainVariant')) : aMetroinspectorV1ProductsVariantInput({}, pickedFields.get('mainVariant'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiedDate')) {
        result.modifiedDate = overrides && overrides.hasOwnProperty('modifiedDate') ? overrides.modifiedDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('pageLink')) {
        result.pageLink = overrides && overrides.hasOwnProperty('pageLink') ? aWixCommonPageLinkInput(overrides.pageLink ?? {}, pickedFields.get('pageLink')) : aWixCommonPageLinkInput({}, pickedFields.get('pageLink'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aMetroinspectorV1ProductsVariantInput({}, pickedFields.get('variants'))) : [aMetroinspectorV1ProductsVariantInput({}, pickedFields.get('variants'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideoV2Input(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideoV2Input({}, pickedFields.get('video'));
    }

    return result;
};

export const aMetroinspectorV1ProductsQueryProductsRequestInput = <T extends Partial<MetroinspectorV1ProductsQueryProductsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includeHiddenProducts')) {
        result.includeHiddenProducts = overrides && overrides.hasOwnProperty('includeHiddenProducts') ? overrides.includeHiddenProducts! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeMerchantSpecificData')) {
        result.includeMerchantSpecificData = overrides && overrides.hasOwnProperty('includeMerchantSpecificData') ? overrides.includeMerchantSpecificData! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeVariants')) {
        result.includeVariants = overrides && overrides.hasOwnProperty('includeVariants') ? overrides.includeVariants! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aMetroinspectorV1ProductsQueryProductsResponse = <T extends Partial<MetroinspectorV1ProductsQueryProductsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aMetroinspectorV1ProductsProduct(x ?? {}, pickedFields.get('items'))) : [aMetroinspectorV1ProductsProduct({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aMetroinspectorV1ProductsUpdateProductRequestInput = <T extends Partial<MetroinspectorV1ProductsUpdateProductRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['odio'];
    }
    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aMetroinspectorV1ProductsProductInput(overrides.product ?? {}, pickedFields.get('product')) : aMetroinspectorV1ProductsProductInput({}, pickedFields.get('product'));
    }
    if (pickedFields.size === 0 || pickedFields.has('productId')) {
        result.productId = overrides && overrides.hasOwnProperty('productId') ? overrides.productId! : 'enim';
    }

    return result;
};

export const aMetroinspectorV1ProductsUpdateProductResponse = <T extends Partial<MetroinspectorV1ProductsUpdateProductResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aMetroinspectorV1ProductsProduct(overrides.product ?? {}, pickedFields.get('product')) : aMetroinspectorV1ProductsProduct({}, pickedFields.get('product'));
    }

    return result;
};

export const aMetroinspectorV1ProductsVariant = <T extends Partial<MetroinspectorV1ProductsVariant>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'deserunt';
    }

    return result;
};

export const aMetroinspectorV1ProductsVariantInput = <T extends Partial<MetroinspectorV1ProductsVariantInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'voluptas';
    }

    return result;
};

export const aPageInfo = <T extends Partial<PageInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 6458;
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('nextCursor')) {
        result.nextCursor = overrides && overrides.hasOwnProperty('nextCursor') ? overrides.nextCursor! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 900;
    }
    if (pickedFields.size === 0 || pickedFields.has('prevCursor')) {
        result.prevCursor = overrides && overrides.hasOwnProperty('prevCursor') ? overrides.prevCursor! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('tooManyToCount')) {
        result.tooManyToCount = overrides && overrides.hasOwnProperty('tooManyToCount') ? overrides.tooManyToCount! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 2840;
    }

    return result;
};

export const aSpectaQlOption = <T extends Partial<SpectaQlOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'explicabo';
    }

    return result;
};

export const anUpstreamWixCommonPortfolioCommonImage = <T extends Partial<UpstreamWixCommonPortfolioCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 6756;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 1175;
    }

    return result;
};

export const anUpstreamWixCommonPortfolioCommonImageInput = <T extends Partial<UpstreamWixCommonPortfolioCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 9163;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 4810;
    }

    return result;
};

export const anUpstreamWixCommonPortfolioCommonVideoResolution = <T extends Partial<UpstreamWixCommonPortfolioCommonVideoResolution>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 8563;
    }
    if (pickedFields.size === 0 || pickedFields.has('poster')) {
        result.poster = overrides && overrides.hasOwnProperty('poster') ? anUpstreamWixCommonPortfolioCommonImage(overrides.poster ?? {}, pickedFields.get('poster')) : anUpstreamWixCommonPortfolioCommonImage({}, pickedFields.get('poster'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quality')) {
        result.quality = overrides && overrides.hasOwnProperty('quality') ? overrides.quality! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 8422;
    }

    return result;
};

export const anUpstreamWixCommonPortfolioCommonVideoResolutionInput = <T extends Partial<UpstreamWixCommonPortfolioCommonVideoResolutionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 2801;
    }
    if (pickedFields.size === 0 || pickedFields.has('poster')) {
        result.poster = overrides && overrides.hasOwnProperty('poster') ? anUpstreamWixCommonPortfolioCommonImageInput(overrides.poster ?? {}, pickedFields.get('poster')) : anUpstreamWixCommonPortfolioCommonImageInput({}, pickedFields.get('poster'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quality')) {
        result.quality = overrides && overrides.hasOwnProperty('quality') ? overrides.quality! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 96;
    }

    return result;
};

export const anUpstreamWixCommonPortfolioCommonVideoV2 = <T extends Partial<UpstreamWixCommonPortfolioCommonVideoV2>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('posters')) {
        result.posters = overrides && overrides.hasOwnProperty('posters') ? overrides.posters!.map((x) => anUpstreamWixCommonPortfolioCommonImage(x ?? {}, pickedFields.get('posters'))) : [anUpstreamWixCommonPortfolioCommonImage({}, pickedFields.get('posters'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('resolutions')) {
        result.resolutions = overrides && overrides.hasOwnProperty('resolutions') ? overrides.resolutions!.map((x) => anUpstreamWixCommonPortfolioCommonVideoResolution(x ?? {}, pickedFields.get('resolutions'))) : [anUpstreamWixCommonPortfolioCommonVideoResolution({}, pickedFields.get('resolutions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'autem';
    }

    return result;
};

export const anUpstreamWixCommonPortfolioCommonVideoV2Input = <T extends Partial<UpstreamWixCommonPortfolioCommonVideoV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('posters')) {
        result.posters = overrides && overrides.hasOwnProperty('posters') ? overrides.posters!.map((x) => anUpstreamWixCommonPortfolioCommonImageInput({}, pickedFields.get('posters'))) : [anUpstreamWixCommonPortfolioCommonImageInput({}, pickedFields.get('posters'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('resolutions')) {
        result.resolutions = overrides && overrides.hasOwnProperty('resolutions') ? overrides.resolutions!.map((x) => anUpstreamWixCommonPortfolioCommonVideoResolutionInput({}, pickedFields.get('resolutions'))) : [anUpstreamWixCommonPortfolioCommonVideoResolutionInput({}, pickedFields.get('resolutions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'maxime';
    }

    return result;
};

export const aWixApiApplicationError = <T extends Partial<WixApiApplicationError>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('data')) {
        result.data = overrides && overrides.hasOwnProperty('data') ? overrides.data! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ut';
    }

    return result;
};

export const aWixApiApplicationErrorInput = <T extends Partial<WixApiApplicationErrorInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('data')) {
        result.data = overrides && overrides.hasOwnProperty('data') ? overrides.data! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'amet';
    }

    return result;
};

export const aWixApiDetails = <T extends Partial<WixApiDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('applicationError')) {
        result.applicationError = overrides && overrides.hasOwnProperty('applicationError') ? aWixApiApplicationError(overrides.applicationError ?? {}, pickedFields.get('applicationError')) : aWixApiApplicationError({}, pickedFields.get('applicationError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('systemError')) {
        result.systemError = overrides && overrides.hasOwnProperty('systemError') ? aWixApiSystemError(overrides.systemError ?? {}, pickedFields.get('systemError')) : aWixApiSystemError({}, pickedFields.get('systemError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tracing')) {
        result.tracing = overrides && overrides.hasOwnProperty('tracing') ? overrides.tracing! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('validationError')) {
        result.validationError = overrides && overrides.hasOwnProperty('validationError') ? aWixApiValidationError(overrides.validationError ?? {}, pickedFields.get('validationError')) : aWixApiValidationError({}, pickedFields.get('validationError'));
    }

    return result;
};

export const aWixApiDetailsInput = <T extends Partial<WixApiDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('applicationError')) {
        result.applicationError = overrides && overrides.hasOwnProperty('applicationError') ? aWixApiApplicationErrorInput(overrides.applicationError ?? {}, pickedFields.get('applicationError')) : aWixApiApplicationErrorInput({}, pickedFields.get('applicationError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('systemError')) {
        result.systemError = overrides && overrides.hasOwnProperty('systemError') ? aWixApiSystemErrorInput(overrides.systemError ?? {}, pickedFields.get('systemError')) : aWixApiSystemErrorInput({}, pickedFields.get('systemError'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tracing')) {
        result.tracing = overrides && overrides.hasOwnProperty('tracing') ? overrides.tracing! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('validationError')) {
        result.validationError = overrides && overrides.hasOwnProperty('validationError') ? aWixApiValidationErrorInput(overrides.validationError ?? {}, pickedFields.get('validationError')) : aWixApiValidationErrorInput({}, pickedFields.get('validationError'));
    }

    return result;
};

export const aWixApiLoomTimecapsuleReschedule = <T extends Partial<WixApiLoomTimecapsuleReschedule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('executeAt')) {
        result.executeAt = overrides && overrides.hasOwnProperty('executeAt') ? overrides.executeAt! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('payload')) {
        result.payload = overrides && overrides.hasOwnProperty('payload') ? overrides.payload! : 'qui';
    }

    return result;
};

export const aWixApiLoomTimecapsuleTaskAction = <T extends Partial<WixApiLoomTimecapsuleTaskAction>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cancel')) {
        result.cancel = overrides && overrides.hasOwnProperty('cancel') ? overrides.cancel! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('complete')) {
        result.complete = overrides && overrides.hasOwnProperty('complete') ? overrides.complete! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('reschedule')) {
        result.reschedule = overrides && overrides.hasOwnProperty('reschedule') ? aWixApiLoomTimecapsuleReschedule(overrides.reschedule ?? {}, pickedFields.get('reschedule')) : aWixApiLoomTimecapsuleReschedule({}, pickedFields.get('reschedule'));
    }

    return result;
};

export const aWixApiLoomTimecapsuleTaskInput = <T extends Partial<WixApiLoomTimecapsuleTaskInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('executeAt')) {
        result.executeAt = overrides && overrides.hasOwnProperty('executeAt') ? overrides.executeAt! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? aWixApiLoomTimecapsuleTaskKeyInput(overrides.key ?? {}, pickedFields.get('key')) : aWixApiLoomTimecapsuleTaskKeyInput({}, pickedFields.get('key'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payload')) {
        result.payload = overrides && overrides.hasOwnProperty('payload') ? overrides.payload! : 'dolor';
    }

    return result;
};

export const aWixApiLoomTimecapsuleTaskKeyInput = <T extends Partial<WixApiLoomTimecapsuleTaskKeyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('subjectId')) {
        result.subjectId = overrides && overrides.hasOwnProperty('subjectId') ? overrides.subjectId! : 'ullam';
    }

    return result;
};

export const aWixApiSystemError = <T extends Partial<WixApiSystemError>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorCode')) {
        result.errorCode = overrides && overrides.hasOwnProperty('errorCode') ? overrides.errorCode! : 'a';
    }

    return result;
};

export const aWixApiSystemErrorInput = <T extends Partial<WixApiSystemErrorInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorCode')) {
        result.errorCode = overrides && overrides.hasOwnProperty('errorCode') ? overrides.errorCode! : 'ipsa';
    }

    return result;
};

export const aWixApiValidationError = <T extends Partial<WixApiValidationError>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldViolations')) {
        result.fieldViolations = overrides && overrides.hasOwnProperty('fieldViolations') ? overrides.fieldViolations!.map((x) => aWixApiValidationErrorFieldViolation(x ?? {}, pickedFields.get('fieldViolations'))) : [aWixApiValidationErrorFieldViolation({}, pickedFields.get('fieldViolations'))];
    }

    return result;
};

export const aWixApiValidationErrorFieldViolation = <T extends Partial<WixApiValidationErrorFieldViolation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('data')) {
        result.data = overrides && overrides.hasOwnProperty('data') ? overrides.data! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('field')) {
        result.field = overrides && overrides.hasOwnProperty('field') ? overrides.field! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('ruleName')) {
        result.ruleName = overrides && overrides.hasOwnProperty('ruleName') ? overrides.ruleName! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('violatedRule')) {
        result.violatedRule = overrides && overrides.hasOwnProperty('violatedRule') ? overrides.violatedRule! : WixApiValidationErrorRuleType.DecimalGt;
    }

    return result;
};

export const aWixApiValidationErrorFieldViolationInput = <T extends Partial<WixApiValidationErrorFieldViolationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('data')) {
        result.data = overrides && overrides.hasOwnProperty('data') ? overrides.data! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('field')) {
        result.field = overrides && overrides.hasOwnProperty('field') ? overrides.field! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('ruleName')) {
        result.ruleName = overrides && overrides.hasOwnProperty('ruleName') ? overrides.ruleName! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('violatedRule')) {
        result.violatedRule = overrides && overrides.hasOwnProperty('violatedRule') ? overrides.violatedRule! : WixApiValidationErrorRuleType.DecimalGt;
    }

    return result;
};

export const aWixApiValidationErrorInput = <T extends Partial<WixApiValidationErrorInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldViolations')) {
        result.fieldViolations = overrides && overrides.hasOwnProperty('fieldViolations') ? overrides.fieldViolations!.map((x) => aWixApiValidationErrorFieldViolationInput({}, pickedFields.get('fieldViolations'))) : [aWixApiValidationErrorFieldViolationInput({}, pickedFields.get('fieldViolations'))];
    }

    return result;
};

export const aWixBlogKafkaProducerV1SendActionEventRequestInput = <T extends Partial<WixBlogKafkaProducerV1SendActionEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('entityId')) {
        result.entityId = overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('postCountersUpdated')) {
        result.postCountersUpdated = overrides && overrides.hasOwnProperty('postCountersUpdated') ? aComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedInput(overrides.postCountersUpdated ?? {}, pickedFields.get('postCountersUpdated')) : aComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedInput({}, pickedFields.get('postCountersUpdated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('postLikedAction')) {
        result.postLikedAction = overrides && overrides.hasOwnProperty('postLikedAction') ? aComWixpressNpmCommunitiesPlatformizedBlogV3PostLikedInput(overrides.postLikedAction ?? {}, pickedFields.get('postLikedAction')) : aComWixpressNpmCommunitiesPlatformizedBlogV3PostLikedInput({}, pickedFields.get('postLikedAction'));
    }

    return result;
};

export const aWixBookingsCalendarUpstreamWixCommonCursorPagingInput = <T extends Partial<WixBookingsCalendarUpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 6877;
    }

    return result;
};

export const aWixBookingsCalendarUpstreamWixCommonQueryV2Input = <T extends Partial<WixBookingsCalendarUpstreamWixCommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixBookingsCalendarUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixBookingsCalendarUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['quo'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'nam';
    }

    return result;
};

export const aWixBookingsCalendarV2CacheInfo = <T extends Partial<WixBookingsCalendarV2CacheInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cachedDate')) {
        result.cachedDate = overrides && overrides.hasOwnProperty('cachedDate') ? overrides.cachedDate! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('feedReplayId')) {
        result.feedReplayId = overrides && overrides.hasOwnProperty('feedReplayId') ? overrides.feedReplayId! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('fromDate')) {
        result.fromDate = overrides && overrides.hasOwnProperty('fromDate') ? overrides.fromDate! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionCount')) {
        result.sessionCount = overrides && overrides.hasOwnProperty('sessionCount') ? overrides.sessionCount! : 2634;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixBookingsCalendarV2CacheInfoStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('toDate')) {
        result.toDate = overrides && overrides.hasOwnProperty('toDate') ? overrides.toDate! : 'autem';
    }

    return result;
};

export const aWixBookingsCalendarV2CacheRequestInput = <T extends Partial<WixBookingsCalendarV2CacheRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fromDate')) {
        result.fromDate = overrides && overrides.hasOwnProperty('fromDate') ? overrides.fromDate! : 'tempora';
    }

    return result;
};

export const aWixBookingsCalendarV2CacheResponse = <T extends Partial<WixBookingsCalendarV2CacheResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cacheInfo')) {
        result.cacheInfo = overrides && overrides.hasOwnProperty('cacheInfo') ? aWixBookingsCalendarV2CacheInfo(overrides.cacheInfo ?? {}, pickedFields.get('cacheInfo')) : aWixBookingsCalendarV2CacheInfo({}, pickedFields.get('cacheInfo'));
    }

    return result;
};

export const aWixBookingsCalendarV2GetCacheInfoRequestInput = <T extends Partial<WixBookingsCalendarV2GetCacheInfoRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includeSessionCount')) {
        result.includeSessionCount = overrides && overrides.hasOwnProperty('includeSessionCount') ? overrides.includeSessionCount! : true;
    }

    return result;
};

export const aWixBookingsCalendarV2GetCacheInfoResponse = <T extends Partial<WixBookingsCalendarV2GetCacheInfoResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cacheInfo')) {
        result.cacheInfo = overrides && overrides.hasOwnProperty('cacheInfo') ? aWixBookingsCalendarV2CacheInfo(overrides.cacheInfo ?? {}, pickedFields.get('cacheInfo')) : aWixBookingsCalendarV2CacheInfo({}, pickedFields.get('cacheInfo'));
    }

    return result;
};

export const aWixBookingsCalendarV2ListSessionsRequestInput = <T extends Partial<WixBookingsCalendarV2ListSessionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['itaque'];
    }
    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['ut'];
    }

    return result;
};

export const aWixBookingsCalendarV2ListSessionsResponse = <T extends Partial<WixBookingsCalendarV2ListSessionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessions')) {
        result.sessions = overrides && overrides.hasOwnProperty('sessions') ? overrides.sessions!.map((x) => aComWixBookingsSchedulesApiV1Session(x ?? {}, pickedFields.get('sessions'))) : [aComWixBookingsSchedulesApiV1Session({}, pickedFields.get('sessions'))];
    }

    return result;
};

export const aWixBookingsCalendarV2QueryEventSessionInstancesRequestInput = <T extends Partial<WixBookingsCalendarV2QueryEventSessionInstancesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fromDate')) {
        result.fromDate = overrides && overrides.hasOwnProperty('fromDate') ? overrides.fromDate! : 'natus';
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixBookingsCalendarUpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixBookingsCalendarUpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }
    if (pickedFields.size === 0 || pickedFields.has('toDate')) {
        result.toDate = overrides && overrides.hasOwnProperty('toDate') ? overrides.toDate! : 'voluptatem';
    }

    return result;
};

export const aWixBookingsCalendarV2QueryEventSessionInstancesResponse = <T extends Partial<WixBookingsCalendarV2QueryEventSessionInstancesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessions')) {
        result.sessions = overrides && overrides.hasOwnProperty('sessions') ? overrides.sessions!.map((x) => aComWixBookingsSchedulesApiV1Session(x ?? {}, pickedFields.get('sessions'))) : [aComWixBookingsSchedulesApiV1Session({}, pickedFields.get('sessions'))];
    }

    return result;
};

export const aWixBookingsCalendarV2ShortenCacheRequestInput = <T extends Partial<WixBookingsCalendarV2ShortenCacheRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fromDate')) {
        result.fromDate = overrides && overrides.hasOwnProperty('fromDate') ? overrides.fromDate! : 'tenetur';
    }

    return result;
};

export const aWixBookingsCalendarV2ShortenCacheResponse = <T extends Partial<WixBookingsCalendarV2ShortenCacheResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cacheInfo')) {
        result.cacheInfo = overrides && overrides.hasOwnProperty('cacheInfo') ? aWixBookingsCalendarV2CacheInfo(overrides.cacheInfo ?? {}, pickedFields.get('cacheInfo')) : aWixBookingsCalendarV2CacheInfo({}, pickedFields.get('cacheInfo'));
    }

    return result;
};

export const aWixBookingsCalendarfeedV2FeedEventInput = <T extends Partial<WixBookingsCalendarfeedV2FeedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sessionAddedOrUpdated')) {
        result.sessionAddedOrUpdated = overrides && overrides.hasOwnProperty('sessionAddedOrUpdated') ? aWixBookingsCalendarfeedV2SessionAddedOrUpdatedInput(overrides.sessionAddedOrUpdated ?? {}, pickedFields.get('sessionAddedOrUpdated')) : aWixBookingsCalendarfeedV2SessionAddedOrUpdatedInput({}, pickedFields.get('sessionAddedOrUpdated'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionRemoved')) {
        result.sessionRemoved = overrides && overrides.hasOwnProperty('sessionRemoved') ? aWixBookingsCalendarfeedV2SessionRemovedInput(overrides.sessionRemoved ?? {}, pickedFields.get('sessionRemoved')) : aWixBookingsCalendarfeedV2SessionRemovedInput({}, pickedFields.get('sessionRemoved'));
    }
    if (pickedFields.size === 0 || pickedFields.has('windowExtended')) {
        result.windowExtended = overrides && overrides.hasOwnProperty('windowExtended') ? aWixBookingsCalendarfeedV2WindowExtendedInput(overrides.windowExtended ?? {}, pickedFields.get('windowExtended')) : aWixBookingsCalendarfeedV2WindowExtendedInput({}, pickedFields.get('windowExtended'));
    }
    if (pickedFields.size === 0 || pickedFields.has('windowMoved')) {
        result.windowMoved = overrides && overrides.hasOwnProperty('windowMoved') ? aWixBookingsCalendarfeedV2WindowMovedInput(overrides.windowMoved ?? {}, pickedFields.get('windowMoved')) : aWixBookingsCalendarfeedV2WindowMovedInput({}, pickedFields.get('windowMoved'));
    }

    return result;
};

export const aWixBookingsCalendarfeedV2FeedReplayEventInput = <T extends Partial<WixBookingsCalendarfeedV2FeedReplayEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('replayCompleted')) {
        result.replayCompleted = overrides && overrides.hasOwnProperty('replayCompleted') ? aWixBookingsCalendarfeedV2ReplayCompletedInput(overrides.replayCompleted ?? {}, pickedFields.get('replayCompleted')) : aWixBookingsCalendarfeedV2ReplayCompletedInput({}, pickedFields.get('replayCompleted'));
    }
    if (pickedFields.size === 0 || pickedFields.has('replayId')) {
        result.replayId = overrides && overrides.hasOwnProperty('replayId') ? overrides.replayId! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionAdded')) {
        result.sessionAdded = overrides && overrides.hasOwnProperty('sessionAdded') ? aWixBookingsCalendarfeedV2SessionAddedInput(overrides.sessionAdded ?? {}, pickedFields.get('sessionAdded')) : aWixBookingsCalendarfeedV2SessionAddedInput({}, pickedFields.get('sessionAdded'));
    }

    return result;
};

export const aWixBookingsCalendarfeedV2ReplayCompletedInput = <T extends Partial<WixBookingsCalendarfeedV2ReplayCompletedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalSessions')) {
        result.totalSessions = overrides && overrides.hasOwnProperty('totalSessions') ? overrides.totalSessions! : 9198;
    }

    return result;
};

export const aWixBookingsCalendarfeedV2SessionAddedInput = <T extends Partial<WixBookingsCalendarfeedV2SessionAddedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('session')) {
        result.session = overrides && overrides.hasOwnProperty('session') ? aComWixBookingsSchedulesApiV1SessionInput(overrides.session ?? {}, pickedFields.get('session')) : aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('session'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionVersion')) {
        result.sessionVersion = overrides && overrides.hasOwnProperty('sessionVersion') ? overrides.sessionVersion! : 'pariatur';
    }

    return result;
};

export const aWixBookingsCalendarfeedV2SessionAddedOrUpdatedInput = <T extends Partial<WixBookingsCalendarfeedV2SessionAddedOrUpdatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('previousAffectedScheduleIds')) {
        result.previousAffectedScheduleIds = overrides && overrides.hasOwnProperty('previousAffectedScheduleIds') ? overrides.previousAffectedScheduleIds! : ['possimus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('previousSession')) {
        result.previousSession = overrides && overrides.hasOwnProperty('previousSession') ? aComWixBookingsSchedulesApiV1SessionInput(overrides.previousSession ?? {}, pickedFields.get('previousSession')) : aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('previousSession'));
    }
    if (pickedFields.size === 0 || pickedFields.has('session')) {
        result.session = overrides && overrides.hasOwnProperty('session') ? aComWixBookingsSchedulesApiV1SessionInput(overrides.session ?? {}, pickedFields.get('session')) : aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('session'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionVersion')) {
        result.sessionVersion = overrides && overrides.hasOwnProperty('sessionVersion') ? overrides.sessionVersion! : 'ea';
    }

    return result;
};

export const aWixBookingsCalendarfeedV2SessionRemovedInput = <T extends Partial<WixBookingsCalendarfeedV2SessionRemovedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('affectedScheduleIds')) {
        result.affectedScheduleIds = overrides && overrides.hasOwnProperty('affectedScheduleIds') ? overrides.affectedScheduleIds! : ['beatae'];
    }
    if (pickedFields.size === 0 || pickedFields.has('previousSession')) {
        result.previousSession = overrides && overrides.hasOwnProperty('previousSession') ? aComWixBookingsSchedulesApiV1SessionInput(overrides.previousSession ?? {}, pickedFields.get('previousSession')) : aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('previousSession'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('session')) {
        result.session = overrides && overrides.hasOwnProperty('session') ? aComWixBookingsSchedulesApiV1SessionInput(overrides.session ?? {}, pickedFields.get('session')) : aComWixBookingsSchedulesApiV1SessionInput({}, pickedFields.get('session'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionId')) {
        result.sessionId = overrides && overrides.hasOwnProperty('sessionId') ? overrides.sessionId! : 'repudiandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionVersion')) {
        result.sessionVersion = overrides && overrides.hasOwnProperty('sessionVersion') ? overrides.sessionVersion! : 'quidem';
    }

    return result;
};

export const aWixBookingsCalendarfeedV2WindowExtendedInput = <T extends Partial<WixBookingsCalendarfeedV2WindowExtendedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('windowEndDate')) {
        result.windowEndDate = overrides && overrides.hasOwnProperty('windowEndDate') ? overrides.windowEndDate! : 'debitis';
    }

    return result;
};

export const aWixBookingsCalendarfeedV2WindowMovedInput = <T extends Partial<WixBookingsCalendarfeedV2WindowMovedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('edge')) {
        result.edge = overrides && overrides.hasOwnProperty('edge') ? overrides.edge! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('windowVersion')) {
        result.windowVersion = overrides && overrides.hasOwnProperty('windowVersion') ? overrides.windowVersion! : 7141;
    }

    return result;
};

export const aWixBookingsCatalogV1CloneServiceOptionsAndVariantsRequestInput = <T extends Partial<WixBookingsCatalogV1CloneServiceOptionsAndVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cloneFromId')) {
        result.cloneFromId = overrides && overrides.hasOwnProperty('cloneFromId') ? overrides.cloneFromId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('targetServiceId')) {
        result.targetServiceId = overrides && overrides.hasOwnProperty('targetServiceId') ? overrides.targetServiceId! : 'dignissimos';
    }

    return result;
};

export const aWixBookingsCatalogV1CloneServiceOptionsAndVariantsResponse = <T extends Partial<WixBookingsCatalogV1CloneServiceOptionsAndVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('serviceOptionsAndVariants')) {
        result.serviceOptionsAndVariants = overrides && overrides.hasOwnProperty('serviceOptionsAndVariants') ? aWixBookingsCatalogV1ServiceOptionsAndVariants(overrides.serviceOptionsAndVariants ?? {}, pickedFields.get('serviceOptionsAndVariants')) : aWixBookingsCatalogV1ServiceOptionsAndVariants({}, pickedFields.get('serviceOptionsAndVariants'));
    }

    return result;
};

export const aWixBookingsCatalogV1CreateServiceOptionsAndVariantsRequestInput = <T extends Partial<WixBookingsCatalogV1CreateServiceOptionsAndVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('serviceOptionsAndVariants')) {
        result.serviceOptionsAndVariants = overrides && overrides.hasOwnProperty('serviceOptionsAndVariants') ? aWixBookingsCatalogV1ServiceOptionsAndVariantsInput(overrides.serviceOptionsAndVariants ?? {}, pickedFields.get('serviceOptionsAndVariants')) : aWixBookingsCatalogV1ServiceOptionsAndVariantsInput({}, pickedFields.get('serviceOptionsAndVariants'));
    }

    return result;
};

export const aWixBookingsCatalogV1CreateServiceOptionsAndVariantsResponse = <T extends Partial<WixBookingsCatalogV1CreateServiceOptionsAndVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('serviceOptionsAndVariants')) {
        result.serviceOptionsAndVariants = overrides && overrides.hasOwnProperty('serviceOptionsAndVariants') ? aWixBookingsCatalogV1ServiceOptionsAndVariants(overrides.serviceOptionsAndVariants ?? {}, pickedFields.get('serviceOptionsAndVariants')) : aWixBookingsCatalogV1ServiceOptionsAndVariants({}, pickedFields.get('serviceOptionsAndVariants'));
    }

    return result;
};

export const aWixBookingsCatalogV1CustomServiceOption = <T extends Partial<WixBookingsCatalogV1CustomServiceOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choices')) {
        result.choices = overrides && overrides.hasOwnProperty('choices') ? overrides.choices! : ['pariatur'];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'qui';
    }

    return result;
};

export const aWixBookingsCatalogV1CustomServiceOptionInput = <T extends Partial<WixBookingsCatalogV1CustomServiceOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choices')) {
        result.choices = overrides && overrides.hasOwnProperty('choices') ? overrides.choices! : ['facere'];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ipsa';
    }

    return result;
};

export const aWixBookingsCatalogV1DeleteServiceOptionsAndVariantsRequestInput = <T extends Partial<WixBookingsCatalogV1DeleteServiceOptionsAndVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceOptionsAndVariantsId')) {
        result.serviceOptionsAndVariantsId = overrides && overrides.hasOwnProperty('serviceOptionsAndVariantsId') ? overrides.serviceOptionsAndVariantsId! : 'quae';
    }

    return result;
};

export const aWixBookingsCatalogV1Duration = <T extends Partial<WixBookingsCatalogV1Duration>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('minutes')) {
        result.minutes = overrides && overrides.hasOwnProperty('minutes') ? overrides.minutes! : 5820;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'fugit';
    }

    return result;
};

export const aWixBookingsCatalogV1DurationInput = <T extends Partial<WixBookingsCatalogV1DurationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('minutes')) {
        result.minutes = overrides && overrides.hasOwnProperty('minutes') ? overrides.minutes! : 1961;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sint';
    }

    return result;
};

export const aWixBookingsCatalogV1DurationServiceOption = <T extends Partial<WixBookingsCatalogV1DurationServiceOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dolorem';
    }

    return result;
};

export const aWixBookingsCatalogV1DurationServiceOptionInput = <T extends Partial<WixBookingsCatalogV1DurationServiceOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'soluta';
    }

    return result;
};

export const aWixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdRequestInput = <T extends Partial<WixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'sit';
    }

    return result;
};

export const aWixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdResponse = <T extends Partial<WixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('serviceVariants')) {
        result.serviceVariants = overrides && overrides.hasOwnProperty('serviceVariants') ? aWixBookingsCatalogV1ServiceOptionsAndVariants(overrides.serviceVariants ?? {}, pickedFields.get('serviceVariants')) : aWixBookingsCatalogV1ServiceOptionsAndVariants({}, pickedFields.get('serviceVariants'));
    }

    return result;
};

export const aWixBookingsCatalogV1GetServiceOptionsAndVariantsRequestInput = <T extends Partial<WixBookingsCatalogV1GetServiceOptionsAndVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bb603f5f-7e0a-49a5-8882-6e49402ef4ad';
    }

    return result;
};

export const aWixBookingsCatalogV1QueryServiceOptionsAndVariantsRequestInput = <T extends Partial<WixBookingsCatalogV1QueryServiceOptionsAndVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixBookingsCatalogV1UpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixBookingsCatalogV1UpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixBookingsCatalogV1QueryServiceOptionsAndVariantsResponse = <T extends Partial<WixBookingsCatalogV1QueryServiceOptionsAndVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixBookingsCatalogV1ServiceOptionsAndVariants(x ?? {}, pickedFields.get('items'))) : [aWixBookingsCatalogV1ServiceOptionsAndVariants({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceChoice = <T extends Partial<WixBookingsCatalogV1ServiceChoice>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('duration')) {
        result.duration = overrides && overrides.hasOwnProperty('duration') ? aWixBookingsCatalogV1Duration(overrides.duration ?? {}, pickedFields.get('duration')) : aWixBookingsCatalogV1Duration({}, pickedFields.get('duration'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('optionId')) {
        result.optionId = overrides && overrides.hasOwnProperty('optionId') ? overrides.optionId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'consequatur';
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceChoiceInput = <T extends Partial<WixBookingsCatalogV1ServiceChoiceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('duration')) {
        result.duration = overrides && overrides.hasOwnProperty('duration') ? aWixBookingsCatalogV1DurationInput(overrides.duration ?? {}, pickedFields.get('duration')) : aWixBookingsCatalogV1DurationInput({}, pickedFields.get('duration'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('optionId')) {
        result.optionId = overrides && overrides.hasOwnProperty('optionId') ? overrides.optionId! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'nostrum';
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceOption = <T extends Partial<WixBookingsCatalogV1ServiceOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customData')) {
        result.customData = overrides && overrides.hasOwnProperty('customData') ? aWixBookingsCatalogV1CustomServiceOption(overrides.customData ?? {}, pickedFields.get('customData')) : aWixBookingsCatalogV1CustomServiceOption({}, pickedFields.get('customData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('durationData')) {
        result.durationData = overrides && overrides.hasOwnProperty('durationData') ? aWixBookingsCatalogV1DurationServiceOption(overrides.durationData ?? {}, pickedFields.get('durationData')) : aWixBookingsCatalogV1DurationServiceOption({}, pickedFields.get('durationData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsCatalogV1ServiceOptionTypeEnumServiceOptionType.Custom;
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceOptionInput = <T extends Partial<WixBookingsCatalogV1ServiceOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customData')) {
        result.customData = overrides && overrides.hasOwnProperty('customData') ? aWixBookingsCatalogV1CustomServiceOptionInput(overrides.customData ?? {}, pickedFields.get('customData')) : aWixBookingsCatalogV1CustomServiceOptionInput({}, pickedFields.get('customData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('durationData')) {
        result.durationData = overrides && overrides.hasOwnProperty('durationData') ? aWixBookingsCatalogV1DurationServiceOptionInput(overrides.durationData ?? {}, pickedFields.get('durationData')) : aWixBookingsCatalogV1DurationServiceOptionInput({}, pickedFields.get('durationData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsCatalogV1ServiceOptionTypeEnumServiceOptionType.Custom;
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceOptionsAndVariants = <T extends Partial<WixBookingsCatalogV1ServiceOptionsAndVariants>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxPrice')) {
        result.maxPrice = overrides && overrides.hasOwnProperty('maxPrice') ? aWixBookingsCatalogV1UpstreamWixCommonMoney(overrides.maxPrice ?? {}, pickedFields.get('maxPrice')) : aWixBookingsCatalogV1UpstreamWixCommonMoney({}, pickedFields.get('maxPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('minPrice')) {
        result.minPrice = overrides && overrides.hasOwnProperty('minPrice') ? aWixBookingsCatalogV1UpstreamWixCommonMoney(overrides.minPrice ?? {}, pickedFields.get('minPrice')) : aWixBookingsCatalogV1UpstreamWixCommonMoney({}, pickedFields.get('minPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptions(overrides.options ?? {}, pickedFields.get('options')) : aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptions({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariants(overrides.variants ?? {}, pickedFields.get('variants')) : aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariants({}, pickedFields.get('variants'));
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceOptionsAndVariantsInput = <T extends Partial<WixBookingsCatalogV1ServiceOptionsAndVariantsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxPrice')) {
        result.maxPrice = overrides && overrides.hasOwnProperty('maxPrice') ? aWixBookingsCatalogV1UpstreamWixCommonMoneyInput(overrides.maxPrice ?? {}, pickedFields.get('maxPrice')) : aWixBookingsCatalogV1UpstreamWixCommonMoneyInput({}, pickedFields.get('maxPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('minPrice')) {
        result.minPrice = overrides && overrides.hasOwnProperty('minPrice') ? aWixBookingsCatalogV1UpstreamWixCommonMoneyInput(overrides.minPrice ?? {}, pickedFields.get('minPrice')) : aWixBookingsCatalogV1UpstreamWixCommonMoneyInput({}, pickedFields.get('minPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariantsInput(overrides.variants ?? {}, pickedFields.get('variants')) : aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariantsInput({}, pickedFields.get('variants'));
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptions = <T extends Partial<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values!.map((x) => aWixBookingsCatalogV1ServiceOption(x ?? {}, pickedFields.get('values'))) : [aWixBookingsCatalogV1ServiceOption({}, pickedFields.get('values'))];
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptionsInput = <T extends Partial<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values!.map((x) => aWixBookingsCatalogV1ServiceOptionInput({}, pickedFields.get('values'))) : [aWixBookingsCatalogV1ServiceOptionInput({}, pickedFields.get('values'))];
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariants = <T extends Partial<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariants>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values!.map((x) => aWixBookingsCatalogV1ServiceVariant(x ?? {}, pickedFields.get('values'))) : [aWixBookingsCatalogV1ServiceVariant({}, pickedFields.get('values'))];
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariantsInput = <T extends Partial<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariantsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values!.map((x) => aWixBookingsCatalogV1ServiceVariantInput({}, pickedFields.get('values'))) : [aWixBookingsCatalogV1ServiceVariantInput({}, pickedFields.get('values'))];
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceVariant = <T extends Partial<WixBookingsCatalogV1ServiceVariant>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choices')) {
        result.choices = overrides && overrides.hasOwnProperty('choices') ? overrides.choices!.map((x) => aWixBookingsCatalogV1ServiceChoice(x ?? {}, pickedFields.get('choices'))) : [aWixBookingsCatalogV1ServiceChoice({}, pickedFields.get('choices'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aWixBookingsCatalogV1UpstreamWixCommonMoney(overrides.price ?? {}, pickedFields.get('price')) : aWixBookingsCatalogV1UpstreamWixCommonMoney({}, pickedFields.get('price'));
    }

    return result;
};

export const aWixBookingsCatalogV1ServiceVariantInput = <T extends Partial<WixBookingsCatalogV1ServiceVariantInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choices')) {
        result.choices = overrides && overrides.hasOwnProperty('choices') ? overrides.choices!.map((x) => aWixBookingsCatalogV1ServiceChoiceInput({}, pickedFields.get('choices'))) : [aWixBookingsCatalogV1ServiceChoiceInput({}, pickedFields.get('choices'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aWixBookingsCatalogV1UpstreamWixCommonMoneyInput(overrides.price ?? {}, pickedFields.get('price')) : aWixBookingsCatalogV1UpstreamWixCommonMoneyInput({}, pickedFields.get('price'));
    }

    return result;
};

export const aWixBookingsCatalogV1UpdateServiceOptionsAndVariantsRequestInput = <T extends Partial<WixBookingsCatalogV1UpdateServiceOptionsAndVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['hic'];
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceOptionsAndVariants')) {
        result.serviceOptionsAndVariants = overrides && overrides.hasOwnProperty('serviceOptionsAndVariants') ? aWixBookingsCatalogV1ServiceOptionsAndVariantsInput(overrides.serviceOptionsAndVariants ?? {}, pickedFields.get('serviceOptionsAndVariants')) : aWixBookingsCatalogV1ServiceOptionsAndVariantsInput({}, pickedFields.get('serviceOptionsAndVariants'));
    }

    return result;
};

export const aWixBookingsCatalogV1UpdateServiceOptionsAndVariantsResponse = <T extends Partial<WixBookingsCatalogV1UpdateServiceOptionsAndVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('serviceOptionsAndVariants')) {
        result.serviceOptionsAndVariants = overrides && overrides.hasOwnProperty('serviceOptionsAndVariants') ? aWixBookingsCatalogV1ServiceOptionsAndVariants(overrides.serviceOptionsAndVariants ?? {}, pickedFields.get('serviceOptionsAndVariants')) : aWixBookingsCatalogV1ServiceOptionsAndVariants({}, pickedFields.get('serviceOptionsAndVariants'));
    }

    return result;
};

export const aWixBookingsCatalogV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixBookingsCatalogV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3254;
    }

    return result;
};

export const aWixBookingsCatalogV1UpstreamWixCommonMoney = <T extends Partial<WixBookingsCatalogV1UpstreamWixCommonMoney>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedValue')) {
        result.formattedValue = overrides && overrides.hasOwnProperty('formattedValue') ? overrides.formattedValue! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'commodi';
    }

    return result;
};

export const aWixBookingsCatalogV1UpstreamWixCommonMoneyInput = <T extends Partial<WixBookingsCatalogV1UpstreamWixCommonMoneyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedValue')) {
        result.formattedValue = overrides && overrides.hasOwnProperty('formattedValue') ? overrides.formattedValue! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'eligendi';
    }

    return result;
};

export const aWixBookingsCatalogV1UpstreamWixCommonPagingInput = <T extends Partial<WixBookingsCatalogV1UpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 5565;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 3852;
    }

    return result;
};

export const aWixBookingsCatalogV1UpstreamWixCommonQueryV2Input = <T extends Partial<WixBookingsCatalogV1UpstreamWixCommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixBookingsCatalogV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixBookingsCatalogV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['repellendus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['qui'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixBookingsCatalogV1UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixBookingsCatalogV1UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixBookingsCatalogV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixBookingsCatalogV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixBookingsCatalogV1UpstreamWixCommonSortingInput = <T extends Partial<WixBookingsCatalogV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixBookingsCatalogV1UpstreamWixCommonSortOrder.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('selectItemsBy')) {
        result.selectItemsBy = overrides && overrides.hasOwnProperty('selectItemsBy') ? overrides.selectItemsBy! : ['beatae'];
    }

    return result;
};

export const aWixBookingsCategoriesV2Category = <T extends Partial<WixBookingsCategoriesV2Category>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 4902;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'adipisci';
    }

    return result;
};

export const aWixBookingsCategoriesV2CategoryInput = <T extends Partial<WixBookingsCategoriesV2CategoryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 145;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'non';
    }

    return result;
};

export const aWixBookingsCategoriesV2CountCategoriesRequestInput = <T extends Partial<WixBookingsCategoriesV2CountCategoriesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'odio';
    }

    return result;
};

export const aWixBookingsCategoriesV2CountCategoriesResponse = <T extends Partial<WixBookingsCategoriesV2CountCategoriesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 1985;
    }

    return result;
};

export const aWixBookingsCategoriesV2CreateCategoryRequestInput = <T extends Partial<WixBookingsCategoriesV2CreateCategoryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aWixBookingsCategoriesV2CategoryInput(overrides.category ?? {}, pickedFields.get('category')) : aWixBookingsCategoriesV2CategoryInput({}, pickedFields.get('category'));
    }

    return result;
};

export const aWixBookingsCategoriesV2CreateCategoryResponse = <T extends Partial<WixBookingsCategoriesV2CreateCategoryResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aWixBookingsCategoriesV2Category(overrides.category ?? {}, pickedFields.get('category')) : aWixBookingsCategoriesV2Category({}, pickedFields.get('category'));
    }

    return result;
};

export const aWixBookingsCategoriesV2DeleteCategoryRequestInput = <T extends Partial<WixBookingsCategoriesV2DeleteCategoryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryId')) {
        result.categoryId = overrides && overrides.hasOwnProperty('categoryId') ? overrides.categoryId! : 'officiis';
    }

    return result;
};

export const aWixBookingsCategoriesV2GetCategoryRequestInput = <T extends Partial<WixBookingsCategoriesV2GetCategoryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3bef9f83-5d40-40d8-9c7d-b715514f5f0b';
    }

    return result;
};

export const aWixBookingsCategoriesV2ImportCategoriesRequestInput = <T extends Partial<WixBookingsCategoriesV2ImportCategoriesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categories')) {
        result.categories = overrides && overrides.hasOwnProperty('categories') ? overrides.categories!.map((x) => aWixBookingsCategoriesV2CategoryInput({}, pickedFields.get('categories'))) : [aWixBookingsCategoriesV2CategoryInput({}, pickedFields.get('categories'))];
    }

    return result;
};

export const aWixBookingsCategoriesV2MoveCategoryRequestInput = <T extends Partial<WixBookingsCategoriesV2MoveCategoryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('afterCategoryId')) {
        result.afterCategoryId = overrides && overrides.hasOwnProperty('afterCategoryId') ? overrides.afterCategoryId! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('categoryId')) {
        result.categoryId = overrides && overrides.hasOwnProperty('categoryId') ? overrides.categoryId! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('position')) {
        result.position = overrides && overrides.hasOwnProperty('position') ? overrides.position! : WixBookingsCategoriesV2MoveCategoryRequestPosition.AfterCategory;
    }

    return result;
};

export const aWixBookingsCategoriesV2MoveCategoryResponse = <T extends Partial<WixBookingsCategoriesV2MoveCategoryResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aWixBookingsCategoriesV2Category(overrides.category ?? {}, pickedFields.get('category')) : aWixBookingsCategoriesV2Category({}, pickedFields.get('category'));
    }

    return result;
};

export const aWixBookingsCategoriesV2QueryCategoriesRequestInput = <T extends Partial<WixBookingsCategoriesV2QueryCategoriesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixBookingsCategoriesV2UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixBookingsCategoriesV2UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixBookingsCategoriesV2QueryCategoriesResponse = <T extends Partial<WixBookingsCategoriesV2QueryCategoriesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixBookingsCategoriesV2Category(x ?? {}, pickedFields.get('items'))) : [aWixBookingsCategoriesV2Category({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixBookingsCategoriesV2UpdateCategoryRequestInput = <T extends Partial<WixBookingsCategoriesV2UpdateCategoryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aWixBookingsCategoriesV2CategoryInput(overrides.category ?? {}, pickedFields.get('category')) : aWixBookingsCategoriesV2CategoryInput({}, pickedFields.get('category'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['eveniet'];
    }

    return result;
};

export const aWixBookingsCategoriesV2UpdateCategoryResponse = <T extends Partial<WixBookingsCategoriesV2UpdateCategoryResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aWixBookingsCategoriesV2Category(overrides.category ?? {}, pickedFields.get('category')) : aWixBookingsCategoriesV2Category({}, pickedFields.get('category'));
    }

    return result;
};

export const aWixBookingsCategoriesV2UpstreamWixCommonCursorPagingInput = <T extends Partial<WixBookingsCategoriesV2UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1855;
    }

    return result;
};

export const aWixBookingsCategoriesV2UpstreamWixCommonCursorQueryInput = <T extends Partial<WixBookingsCategoriesV2UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixBookingsCategoriesV2UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixBookingsCategoriesV2UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixBookingsCategoriesV2UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixBookingsCategoriesV2UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixBookingsCategoriesV2UpstreamWixCommonSortingInput = <T extends Partial<WixBookingsCategoriesV2UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixBookingsCategoriesV2UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixBookingsServicesV2AddOnDetails = <T extends Partial<WixBookingsServicesV2AddOnDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnId')) {
        result.addOnId = overrides && overrides.hasOwnProperty('addOnId') ? overrides.addOnId! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('durationInMinutes')) {
        result.durationInMinutes = overrides && overrides.hasOwnProperty('durationInMinutes') ? overrides.durationInMinutes! : 9574;
    }

    return result;
};

export const aWixBookingsServicesV2AddOnDetailsInput = <T extends Partial<WixBookingsServicesV2AddOnDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnId')) {
        result.addOnId = overrides && overrides.hasOwnProperty('addOnId') ? overrides.addOnId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('durationInMinutes')) {
        result.durationInMinutes = overrides && overrides.hasOwnProperty('durationInMinutes') ? overrides.durationInMinutes! : 7975;
    }

    return result;
};

export const aWixBookingsServicesV2AddOnGroup = <T extends Partial<WixBookingsServicesV2AddOnGroup>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnIds')) {
        result.addOnIds = overrides && overrides.hasOwnProperty('addOnIds') ? overrides.addOnIds! : ['aut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxNumberOfAddOns')) {
        result.maxNumberOfAddOns = overrides && overrides.hasOwnProperty('maxNumberOfAddOns') ? overrides.maxNumberOfAddOns! : 7668;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('prompt')) {
        result.prompt = overrides && overrides.hasOwnProperty('prompt') ? overrides.prompt! : 'voluptas';
    }

    return result;
};

export const aWixBookingsServicesV2AddOnGroupInput = <T extends Partial<WixBookingsServicesV2AddOnGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnIds')) {
        result.addOnIds = overrides && overrides.hasOwnProperty('addOnIds') ? overrides.addOnIds! : ['magnam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxNumberOfAddOns')) {
        result.maxNumberOfAddOns = overrides && overrides.hasOwnProperty('maxNumberOfAddOns') ? overrides.maxNumberOfAddOns! : 8626;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('prompt')) {
        result.prompt = overrides && overrides.hasOwnProperty('prompt') ? overrides.prompt! : 'ipsam';
    }

    return result;
};

export const aWixBookingsServicesV2AddOnsGroup = <T extends Partial<WixBookingsServicesV2AddOnsGroup>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnIds')) {
        result.addOnIds = overrides && overrides.hasOwnProperty('addOnIds') ? overrides.addOnIds! : ['quia'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxNumberOfAddOns')) {
        result.maxNumberOfAddOns = overrides && overrides.hasOwnProperty('maxNumberOfAddOns') ? overrides.maxNumberOfAddOns! : 4283;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('prompt')) {
        result.prompt = overrides && overrides.hasOwnProperty('prompt') ? overrides.prompt! : 'odio';
    }

    return result;
};

export const aWixBookingsServicesV2AddOnsGroupInput = <T extends Partial<WixBookingsServicesV2AddOnsGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnIds')) {
        result.addOnIds = overrides && overrides.hasOwnProperty('addOnIds') ? overrides.addOnIds! : ['accusamus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxNumberOfAddOns')) {
        result.maxNumberOfAddOns = overrides && overrides.hasOwnProperty('maxNumberOfAddOns') ? overrides.maxNumberOfAddOns! : 9574;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('prompt')) {
        result.prompt = overrides && overrides.hasOwnProperty('prompt') ? overrides.prompt! : 'voluptatibus';
    }

    return result;
};

export const aWixBookingsServicesV2AvailabilityConstraints = <T extends Partial<WixBookingsServicesV2AvailabilityConstraints>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durations')) {
        result.durations = overrides && overrides.hasOwnProperty('durations') ? overrides.durations!.map((x) => aWixBookingsServicesV2Duration(x ?? {}, pickedFields.get('durations'))) : [aWixBookingsServicesV2Duration({}, pickedFields.get('durations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionDurations')) {
        result.sessionDurations = overrides && overrides.hasOwnProperty('sessionDurations') ? overrides.sessionDurations! : [1148];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeBetweenSessions')) {
        result.timeBetweenSessions = overrides && overrides.hasOwnProperty('timeBetweenSessions') ? overrides.timeBetweenSessions! : 5312;
    }

    return result;
};

export const aWixBookingsServicesV2AvailabilityConstraintsInput = <T extends Partial<WixBookingsServicesV2AvailabilityConstraintsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durations')) {
        result.durations = overrides && overrides.hasOwnProperty('durations') ? overrides.durations!.map((x) => aWixBookingsServicesV2DurationInput({}, pickedFields.get('durations'))) : [aWixBookingsServicesV2DurationInput({}, pickedFields.get('durations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionDurations')) {
        result.sessionDurations = overrides && overrides.hasOwnProperty('sessionDurations') ? overrides.sessionDurations! : [3924];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeBetweenSessions')) {
        result.timeBetweenSessions = overrides && overrides.hasOwnProperty('timeBetweenSessions') ? overrides.timeBetweenSessions! : 4068;
    }

    return result;
};

export const aWixBookingsServicesV2BookingForm = <T extends Partial<WixBookingsServicesV2BookingForm>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('connectedServices')) {
        result.connectedServices = overrides && overrides.hasOwnProperty('connectedServices') ? overrides.connectedServices!.map((x) => aWixBookingsServicesV2BookingFormConnectedService(x ?? {}, pickedFields.get('connectedServices'))) : [aWixBookingsServicesV2BookingFormConnectedService({}, pickedFields.get('connectedServices'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('formDetails')) {
        result.formDetails = overrides && overrides.hasOwnProperty('formDetails') ? aWixBookingsServicesV2BookingFormFormDetails(overrides.formDetails ?? {}, pickedFields.get('formDetails')) : aWixBookingsServicesV2BookingFormFormDetails({}, pickedFields.get('formDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalServiceCount')) {
        result.totalServiceCount = overrides && overrides.hasOwnProperty('totalServiceCount') ? overrides.totalServiceCount! : 3635;
    }

    return result;
};

export const aWixBookingsServicesV2BookingFormConnectedService = <T extends Partial<WixBookingsServicesV2BookingFormConnectedService>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'rerum';
    }

    return result;
};

export const aWixBookingsServicesV2BookingFormFormDetails = <T extends Partial<WixBookingsServicesV2BookingFormFormDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('formId')) {
        result.formId = overrides && overrides.hasOwnProperty('formId') ? overrides.formId! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'nihil';
    }

    return result;
};

export const aWixBookingsServicesV2BookingPolicyWithServices = <T extends Partial<WixBookingsServicesV2BookingPolicyWithServices>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicy')) {
        result.bookingPolicy = overrides && overrides.hasOwnProperty('bookingPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy(overrides.bookingPolicy ?? {}, pickedFields.get('bookingPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy({}, pickedFields.get('bookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('connectedServices')) {
        result.connectedServices = overrides && overrides.hasOwnProperty('connectedServices') ? overrides.connectedServices!.map((x) => aWixBookingsServicesV2Service(x ?? {}, pickedFields.get('connectedServices'))) : [aWixBookingsServicesV2Service({}, pickedFields.get('connectedServices'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('countOfServices')) {
        result.countOfServices = overrides && overrides.hasOwnProperty('countOfServices') ? overrides.countOfServices! : 5227;
    }
    if (pickedFields.size === 0 || pickedFields.has('hasMoreServices')) {
        result.hasMoreServices = overrides && overrides.hasOwnProperty('hasMoreServices') ? overrides.hasMoreServices! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('services')) {
        result.services = overrides && overrides.hasOwnProperty('services') ? overrides.services!.map((x) => aWixBookingsServicesV2Service(x ?? {}, pickedFields.get('services'))) : [aWixBookingsServicesV2Service({}, pickedFields.get('services'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('totalServiceCount')) {
        result.totalServiceCount = overrides && overrides.hasOwnProperty('totalServiceCount') ? overrides.totalServiceCount! : 5308;
    }

    return result;
};

export const aWixBookingsServicesV2BulkCreateServicesRequestInput = <T extends Partial<WixBookingsServicesV2BulkCreateServicesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('services')) {
        result.services = overrides && overrides.hasOwnProperty('services') ? overrides.services!.map((x) => aWixBookingsServicesV2ServiceInput({}, pickedFields.get('services'))) : [aWixBookingsServicesV2ServiceInput({}, pickedFields.get('services'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('skipScheduleCreation')) {
        result.skipScheduleCreation = overrides && overrides.hasOwnProperty('skipScheduleCreation') ? overrides.skipScheduleCreation! : true;
    }

    return result;
};

export const aWixBookingsServicesV2BulkCreateServicesResponse = <T extends Partial<WixBookingsServicesV2BulkCreateServicesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixBookingsServicesV2UpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixBookingsServicesV2UpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixBookingsServicesV2BulkServiceResult(x ?? {}, pickedFields.get('results'))) : [aWixBookingsServicesV2BulkServiceResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixBookingsServicesV2BulkDeleteServicesByFilterRequestInput = <T extends Partial<WixBookingsServicesV2BulkDeleteServicesByFilterRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aWixBookingsServicesV2ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aWixBookingsServicesV2ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('preserveFutureSessionsWithParticipants')) {
        result.preserveFutureSessionsWithParticipants = overrides && overrides.hasOwnProperty('preserveFutureSessionsWithParticipants') ? overrides.preserveFutureSessionsWithParticipants! : true;
    }

    return result;
};

export const aWixBookingsServicesV2BulkDeleteServicesByFilterResponse = <T extends Partial<WixBookingsServicesV2BulkDeleteServicesByFilterResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jobId')) {
        result.jobId = overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'voluptate';
    }

    return result;
};

export const aWixBookingsServicesV2BulkDeleteServicesRequestInput = <T extends Partial<WixBookingsServicesV2BulkDeleteServicesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['in'];
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aWixBookingsServicesV2ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aWixBookingsServicesV2ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('preserveFutureSessionsWithParticipants')) {
        result.preserveFutureSessionsWithParticipants = overrides && overrides.hasOwnProperty('preserveFutureSessionsWithParticipants') ? overrides.preserveFutureSessionsWithParticipants! : false;
    }

    return result;
};

export const aWixBookingsServicesV2BulkDeleteServicesResponse = <T extends Partial<WixBookingsServicesV2BulkDeleteServicesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixBookingsServicesV2UpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixBookingsServicesV2UpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixBookingsServicesV2BulkServiceResult(x ?? {}, pickedFields.get('results'))) : [aWixBookingsServicesV2BulkServiceResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixBookingsServicesV2BulkServiceResult = <T extends Partial<WixBookingsServicesV2BulkServiceResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixBookingsServicesV2Service(overrides.item ?? {}, pickedFields.get('item')) : aWixBookingsServicesV2Service({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixBookingsServicesV2UpstreamWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixBookingsServicesV2UpstreamWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixBookingsServicesV2BulkUpdateServicesByFilterRequestInput = <T extends Partial<WixBookingsServicesV2BulkUpdateServicesByFilterRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'cupiditate';
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['dolor'];
    }
    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2ServiceInput(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2ServiceInput({}, pickedFields.get('service'));
    }

    return result;
};

export const aWixBookingsServicesV2BulkUpdateServicesByFilterResponse = <T extends Partial<WixBookingsServicesV2BulkUpdateServicesByFilterResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jobId')) {
        result.jobId = overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'laudantium';
    }

    return result;
};

export const aWixBookingsServicesV2BulkUpdateServicesRequestInput = <T extends Partial<WixBookingsServicesV2BulkUpdateServicesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('services')) {
        result.services = overrides && overrides.hasOwnProperty('services') ? overrides.services!.map((x) => aWixBookingsServicesV2BulkUpdateServicesRequestMaskedServiceInput({}, pickedFields.get('services'))) : [aWixBookingsServicesV2BulkUpdateServicesRequestMaskedServiceInput({}, pickedFields.get('services'))];
    }

    return result;
};

export const aWixBookingsServicesV2BulkUpdateServicesRequestMaskedServiceInput = <T extends Partial<WixBookingsServicesV2BulkUpdateServicesRequestMaskedServiceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['ducimus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2ServiceInput(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2ServiceInput({}, pickedFields.get('service'));
    }

    return result;
};

export const aWixBookingsServicesV2BulkUpdateServicesResponse = <T extends Partial<WixBookingsServicesV2BulkUpdateServicesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixBookingsServicesV2UpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixBookingsServicesV2UpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixBookingsServicesV2BulkServiceResult(x ?? {}, pickedFields.get('results'))) : [aWixBookingsServicesV2BulkServiceResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixBookingsServicesV2BusinessLocationOptions = <T extends Partial<WixBookingsServicesV2BusinessLocationOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aWixBookingsServicesV2UpstreamWixCommonAddress(overrides.address ?? {}, pickedFields.get('address')) : aWixBookingsServicesV2UpstreamWixCommonAddress({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'provident';
    }

    return result;
};

export const aWixBookingsServicesV2BusinessLocationOptionsInput = <T extends Partial<WixBookingsServicesV2BusinessLocationOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aWixBookingsServicesV2UpstreamWixCommonAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aWixBookingsServicesV2UpstreamWixCommonAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'nisi';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'laboriosam';
    }

    return result;
};

export const aWixBookingsServicesV2BusinessLocations = <T extends Partial<WixBookingsServicesV2BusinessLocations>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exists')) {
        result.exists = overrides && overrides.hasOwnProperty('exists') ? overrides.exists! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aWixBookingsServicesV2Location(x ?? {}, pickedFields.get('locations'))) : [aWixBookingsServicesV2Location({}, pickedFields.get('locations'))];
    }

    return result;
};

export const aWixBookingsServicesV2Category = <T extends Partial<WixBookingsServicesV2Category>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aWixBookingsCategoriesV2Category(overrides.category ?? {}, pickedFields.get('category')) : aWixBookingsCategoriesV2Category({}, pickedFields.get('category'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 1090;
    }

    return result;
};

export const aWixBookingsServicesV2CategoryInput = <T extends Partial<WixBookingsServicesV2CategoryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 3816;
    }

    return result;
};

export const aWixBookingsServicesV2CloneServiceRequestInput = <T extends Partial<WixBookingsServicesV2CloneServiceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cloneServiceName')) {
        result.cloneServiceName = overrides && overrides.hasOwnProperty('cloneServiceName') ? overrides.cloneServiceName! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('copyPricingPlans')) {
        result.copyPricingPlans = overrides && overrides.hasOwnProperty('copyPricingPlans') ? overrides.copyPricingPlans! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('copyRecurringSessions')) {
        result.copyRecurringSessions = overrides && overrides.hasOwnProperty('copyRecurringSessions') ? overrides.copyRecurringSessions! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('hideService')) {
        result.hideService = overrides && overrides.hasOwnProperty('hideService') ? overrides.hideService! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceServiceId')) {
        result.sourceServiceId = overrides && overrides.hasOwnProperty('sourceServiceId') ? overrides.sourceServiceId! : 'non';
    }

    return result;
};

export const aWixBookingsServicesV2CloneServiceResponse = <T extends Partial<WixBookingsServicesV2CloneServiceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errors')) {
        result.errors = overrides && overrides.hasOwnProperty('errors') ? overrides.errors! : [WixBookingsServicesV2CloneErrorsEnumCloneErrors.Form];
    }
    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2Service(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2Service({}, pickedFields.get('service'));
    }

    return result;
};

export const aWixBookingsServicesV2Conferencing = <T extends Partial<WixBookingsServicesV2Conferencing>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixBookingsServicesV2ConferencingInput = <T extends Partial<WixBookingsServicesV2ConferencingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsServicesV2CountServicesRequestInput = <T extends Partial<WixBookingsServicesV2CountServicesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'ratione';
    }

    return result;
};

export const aWixBookingsServicesV2CountServicesResponse = <T extends Partial<WixBookingsServicesV2CountServicesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 5629;
    }

    return result;
};

export const aWixBookingsServicesV2CreateAddOnGroupRequestInput = <T extends Partial<WixBookingsServicesV2CreateAddOnGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnGroup')) {
        result.addOnGroup = overrides && overrides.hasOwnProperty('addOnGroup') ? aWixBookingsServicesV2AddOnGroupInput(overrides.addOnGroup ?? {}, pickedFields.get('addOnGroup')) : aWixBookingsServicesV2AddOnGroupInput({}, pickedFields.get('addOnGroup'));
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'nesciunt';
    }

    return result;
};

export const aWixBookingsServicesV2CreateAddOnGroupResponse = <T extends Partial<WixBookingsServicesV2CreateAddOnGroupResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnGroup')) {
        result.addOnGroup = overrides && overrides.hasOwnProperty('addOnGroup') ? aWixBookingsServicesV2AddOnGroup(overrides.addOnGroup ?? {}, pickedFields.get('addOnGroup')) : aWixBookingsServicesV2AddOnGroup({}, pickedFields.get('addOnGroup'));
    }

    return result;
};

export const aWixBookingsServicesV2CreateAddOnsGroupRequestInput = <T extends Partial<WixBookingsServicesV2CreateAddOnsGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnsGroup')) {
        result.addOnsGroup = overrides && overrides.hasOwnProperty('addOnsGroup') ? aWixBookingsServicesV2AddOnsGroupInput(overrides.addOnsGroup ?? {}, pickedFields.get('addOnsGroup')) : aWixBookingsServicesV2AddOnsGroupInput({}, pickedFields.get('addOnsGroup'));
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'praesentium';
    }

    return result;
};

export const aWixBookingsServicesV2CreateAddOnsGroupResponse = <T extends Partial<WixBookingsServicesV2CreateAddOnsGroupResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnsGroup')) {
        result.addOnsGroup = overrides && overrides.hasOwnProperty('addOnsGroup') ? aWixBookingsServicesV2AddOnsGroup(overrides.addOnsGroup ?? {}, pickedFields.get('addOnsGroup')) : aWixBookingsServicesV2AddOnsGroup({}, pickedFields.get('addOnsGroup'));
    }

    return result;
};

export const aWixBookingsServicesV2CreateServiceRequestInput = <T extends Partial<WixBookingsServicesV2CreateServiceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2ServiceInput(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2ServiceInput({}, pickedFields.get('service'));
    }

    return result;
};

export const aWixBookingsServicesV2CreateServiceResponse = <T extends Partial<WixBookingsServicesV2CreateServiceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2Service(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2Service({}, pickedFields.get('service'));
    }

    return result;
};

export const aWixBookingsServicesV2CustomLocationOptions = <T extends Partial<WixBookingsServicesV2CustomLocationOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aWixBookingsServicesV2UpstreamWixCommonAddress(overrides.address ?? {}, pickedFields.get('address')) : aWixBookingsServicesV2UpstreamWixCommonAddress({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }

    return result;
};

export const aWixBookingsServicesV2CustomLocationOptionsInput = <T extends Partial<WixBookingsServicesV2CustomLocationOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aWixBookingsServicesV2UpstreamWixCommonAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aWixBookingsServicesV2UpstreamWixCommonAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'facilis';
    }

    return result;
};

export const aWixBookingsServicesV2CustomLocations = <T extends Partial<WixBookingsServicesV2CustomLocations>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exists')) {
        result.exists = overrides && overrides.hasOwnProperty('exists') ? overrides.exists! : true;
    }

    return result;
};

export const aWixBookingsServicesV2CustomPayment = <T extends Partial<WixBookingsServicesV2CustomPayment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'officiis';
    }

    return result;
};

export const aWixBookingsServicesV2CustomPaymentInput = <T extends Partial<WixBookingsServicesV2CustomPaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'quasi';
    }

    return result;
};

export const aWixBookingsServicesV2CustomerLocations = <T extends Partial<WixBookingsServicesV2CustomerLocations>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exists')) {
        result.exists = overrides && overrides.hasOwnProperty('exists') ? overrides.exists! : true;
    }

    return result;
};

export const aWixBookingsServicesV2DeleteAddOnGroupRequestInput = <T extends Partial<WixBookingsServicesV2DeleteAddOnGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnGroupId')) {
        result.addOnGroupId = overrides && overrides.hasOwnProperty('addOnGroupId') ? overrides.addOnGroupId! : 'commodi';
    }

    return result;
};

export const aWixBookingsServicesV2DeleteAddOnsGroupRequestInput = <T extends Partial<WixBookingsServicesV2DeleteAddOnsGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnsGroupId')) {
        result.addOnsGroupId = overrides && overrides.hasOwnProperty('addOnsGroupId') ? overrides.addOnsGroupId! : 'autem';
    }

    return result;
};

export const aWixBookingsServicesV2DeleteServiceRequestInput = <T extends Partial<WixBookingsServicesV2DeleteServiceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aWixBookingsServicesV2ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aWixBookingsServicesV2ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('preserveFutureSessionsWithParticipants')) {
        result.preserveFutureSessionsWithParticipants = overrides && overrides.hasOwnProperty('preserveFutureSessionsWithParticipants') ? overrides.preserveFutureSessionsWithParticipants! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'debitis';
    }

    return result;
};

export const aWixBookingsServicesV2DisablePricingPlansForServiceRequestInput = <T extends Partial<WixBookingsServicesV2DisablePricingPlansForServiceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pricingPlanIds')) {
        result.pricingPlanIds = overrides && overrides.hasOwnProperty('pricingPlanIds') ? overrides.pricingPlanIds! : ['doloribus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'facere';
    }

    return result;
};

export const aWixBookingsServicesV2DisablePricingPlansForServiceResponse = <T extends Partial<WixBookingsServicesV2DisablePricingPlansForServiceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2Service(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2Service({}, pickedFields.get('service'));
    }

    return result;
};

export const aWixBookingsServicesV2Duration = <T extends Partial<WixBookingsServicesV2Duration>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('minutes')) {
        result.minutes = overrides && overrides.hasOwnProperty('minutes') ? overrides.minutes! : 7810;
    }

    return result;
};

export const aWixBookingsServicesV2DurationInput = <T extends Partial<WixBookingsServicesV2DurationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('minutes')) {
        result.minutes = overrides && overrides.hasOwnProperty('minutes') ? overrides.minutes! : 1038;
    }

    return result;
};

export const aWixBookingsServicesV2EnablePricingPlansForServiceRequestInput = <T extends Partial<WixBookingsServicesV2EnablePricingPlansForServiceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pricingPlanIds')) {
        result.pricingPlanIds = overrides && overrides.hasOwnProperty('pricingPlanIds') ? overrides.pricingPlanIds! : ['ut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'eum';
    }

    return result;
};

export const aWixBookingsServicesV2EnablePricingPlansForServiceResponse = <T extends Partial<WixBookingsServicesV2EnablePricingPlansForServiceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2Service(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2Service({}, pickedFields.get('service'));
    }

    return result;
};

export const aWixBookingsServicesV2FieldViolation = <T extends Partial<WixBookingsServicesV2FieldViolation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('ruleName')) {
        result.ruleName = overrides && overrides.hasOwnProperty('ruleName') ? overrides.ruleName! : 'dolore';
    }

    return result;
};

export const aWixBookingsServicesV2FixedPayment = <T extends Partial<WixBookingsServicesV2FixedPayment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deposit')) {
        result.deposit = overrides && overrides.hasOwnProperty('deposit') ? aWixBookingsServicesV2UpstreamWixCommonMoney(overrides.deposit ?? {}, pickedFields.get('deposit')) : aWixBookingsServicesV2UpstreamWixCommonMoney({}, pickedFields.get('deposit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aWixBookingsServicesV2UpstreamWixCommonMoney(overrides.price ?? {}, pickedFields.get('price')) : aWixBookingsServicesV2UpstreamWixCommonMoney({}, pickedFields.get('price'));
    }

    return result;
};

export const aWixBookingsServicesV2FixedPaymentInput = <T extends Partial<WixBookingsServicesV2FixedPaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deposit')) {
        result.deposit = overrides && overrides.hasOwnProperty('deposit') ? aWixBookingsServicesV2UpstreamWixCommonMoneyInput(overrides.deposit ?? {}, pickedFields.get('deposit')) : aWixBookingsServicesV2UpstreamWixCommonMoneyInput({}, pickedFields.get('deposit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aWixBookingsServicesV2UpstreamWixCommonMoneyInput(overrides.price ?? {}, pickedFields.get('price')) : aWixBookingsServicesV2UpstreamWixCommonMoneyInput({}, pickedFields.get('price'));
    }

    return result;
};

export const aWixBookingsServicesV2Form = <T extends Partial<WixBookingsServicesV2Form>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('mobileSettings')) {
        result.mobileSettings = overrides && overrides.hasOwnProperty('mobileSettings') ? aWixBookingsServicesV2FormSettings(overrides.mobileSettings ?? {}, pickedFields.get('mobileSettings')) : aWixBookingsServicesV2FormSettings({}, pickedFields.get('mobileSettings'));
    }

    return result;
};

export const aWixBookingsServicesV2FormInput = <T extends Partial<WixBookingsServicesV2FormInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('mobileSettings')) {
        result.mobileSettings = overrides && overrides.hasOwnProperty('mobileSettings') ? aWixBookingsServicesV2FormSettingsInput(overrides.mobileSettings ?? {}, pickedFields.get('mobileSettings')) : aWixBookingsServicesV2FormSettingsInput({}, pickedFields.get('mobileSettings'));
    }

    return result;
};

export const aWixBookingsServicesV2FormSettings = <T extends Partial<WixBookingsServicesV2FormSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : true;
    }

    return result;
};

export const aWixBookingsServicesV2FormSettingsInput = <T extends Partial<WixBookingsServicesV2FormSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : false;
    }

    return result;
};

export const aWixBookingsServicesV2GetServiceAvailabilityConstraintsRequestInput = <T extends Partial<WixBookingsServicesV2GetServiceAvailabilityConstraintsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'unde';
    }

    return result;
};

export const aWixBookingsServicesV2GetServiceAvailabilityConstraintsResponse = <T extends Partial<WixBookingsServicesV2GetServiceAvailabilityConstraintsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('constraints')) {
        result.constraints = overrides && overrides.hasOwnProperty('constraints') ? aWixBookingsServicesV2ServiceAvailabilityConstraints(overrides.constraints ?? {}, pickedFields.get('constraints')) : aWixBookingsServicesV2ServiceAvailabilityConstraints({}, pickedFields.get('constraints'));
    }

    return result;
};

export const aWixBookingsServicesV2GetServiceRequestInput = <T extends Partial<WixBookingsServicesV2GetServiceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conditionalFields')) {
        result.conditionalFields = overrides && overrides.hasOwnProperty('conditionalFields') ? overrides.conditionalFields! : [WixBookingsServicesV2RequestedFields.ResourceTypeDetails];
    }
    if (pickedFields.size === 0 || pickedFields.has('eventuallyConsistent')) {
        result.eventuallyConsistent = overrides && overrides.hasOwnProperty('eventuallyConsistent') ? overrides.eventuallyConsistent! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3138e311-b083-4829-9a0f-5292625bdc12';
    }

    return result;
};

export const aWixBookingsServicesV2ListAddOnGroupsByServiceIdRequestInput = <T extends Partial<WixBookingsServicesV2ListAddOnGroupsByServiceIdRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('groupIds')) {
        result.groupIds = overrides && overrides.hasOwnProperty('groupIds') ? overrides.groupIds! : ['ducimus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'qui';
    }

    return result;
};

export const aWixBookingsServicesV2ListAddOnGroupsByServiceIdResponse = <T extends Partial<WixBookingsServicesV2ListAddOnGroupsByServiceIdResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnGroupsDetails')) {
        result.addOnGroupsDetails = overrides && overrides.hasOwnProperty('addOnGroupsDetails') ? overrides.addOnGroupsDetails!.map((x) => aWixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOnGroupDetail(x ?? {}, pickedFields.get('addOnGroupsDetails'))) : [aWixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOnGroupDetail({}, pickedFields.get('addOnGroupsDetails'))];
    }

    return result;
};

export const aWixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOn = <T extends Partial<WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOn>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnId')) {
        result.addOnId = overrides && overrides.hasOwnProperty('addOnId') ? overrides.addOnId! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('durationInMinutes')) {
        result.durationInMinutes = overrides && overrides.hasOwnProperty('durationInMinutes') ? overrides.durationInMinutes! : 6862;
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAmount')) {
        result.formattedAmount = overrides && overrides.hasOwnProperty('formattedAmount') ? overrides.formattedAmount! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxQuantity')) {
        result.maxQuantity = overrides && overrides.hasOwnProperty('maxQuantity') ? overrides.maxQuantity! : 8346;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'enim';
    }

    return result;
};

export const aWixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOnGroupDetail = <T extends Partial<WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOnGroupDetail>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOns')) {
        result.addOns = overrides && overrides.hasOwnProperty('addOns') ? overrides.addOns!.map((x) => aWixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOn(x ?? {}, pickedFields.get('addOns'))) : [aWixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOn({}, pickedFields.get('addOns'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('groupId')) {
        result.groupId = overrides && overrides.hasOwnProperty('groupId') ? overrides.groupId! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('groupName')) {
        result.groupName = overrides && overrides.hasOwnProperty('groupName') ? overrides.groupName! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxNumberOfAddOns')) {
        result.maxNumberOfAddOns = overrides && overrides.hasOwnProperty('maxNumberOfAddOns') ? overrides.maxNumberOfAddOns! : 5770;
    }
    if (pickedFields.size === 0 || pickedFields.has('prompt')) {
        result.prompt = overrides && overrides.hasOwnProperty('prompt') ? overrides.prompt! : 'tenetur';
    }

    return result;
};

export const aWixBookingsServicesV2ListAddOnsGroupsByServiceIdRequestInput = <T extends Partial<WixBookingsServicesV2ListAddOnsGroupsByServiceIdRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('groupIds')) {
        result.groupIds = overrides && overrides.hasOwnProperty('groupIds') ? overrides.groupIds! : ['voluptate'];
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'voluptatem';
    }

    return result;
};

export const aWixBookingsServicesV2ListAddOnsGroupsByServiceIdResponse = <T extends Partial<WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnsGroupsDetails')) {
        result.addOnsGroupsDetails = overrides && overrides.hasOwnProperty('addOnsGroupsDetails') ? overrides.addOnsGroupsDetails!.map((x) => aWixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOnsGroupDetail(x ?? {}, pickedFields.get('addOnsGroupsDetails'))) : [aWixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOnsGroupDetail({}, pickedFields.get('addOnsGroupsDetails'))];
    }

    return result;
};

export const aWixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOn = <T extends Partial<WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOn>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnId')) {
        result.addOnId = overrides && overrides.hasOwnProperty('addOnId') ? overrides.addOnId! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('durationInMinutes')) {
        result.durationInMinutes = overrides && overrides.hasOwnProperty('durationInMinutes') ? overrides.durationInMinutes! : 7147;
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAmount')) {
        result.formattedAmount = overrides && overrides.hasOwnProperty('formattedAmount') ? overrides.formattedAmount! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxQuantity')) {
        result.maxQuantity = overrides && overrides.hasOwnProperty('maxQuantity') ? overrides.maxQuantity! : 6922;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quia';
    }

    return result;
};

export const aWixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOnsGroupDetail = <T extends Partial<WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOnsGroupDetail>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOns')) {
        result.addOns = overrides && overrides.hasOwnProperty('addOns') ? overrides.addOns!.map((x) => aWixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOn(x ?? {}, pickedFields.get('addOns'))) : [aWixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOn({}, pickedFields.get('addOns'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('groupId')) {
        result.groupId = overrides && overrides.hasOwnProperty('groupId') ? overrides.groupId! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('groupName')) {
        result.groupName = overrides && overrides.hasOwnProperty('groupName') ? overrides.groupName! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('maxNumberOfAddOns')) {
        result.maxNumberOfAddOns = overrides && overrides.hasOwnProperty('maxNumberOfAddOns') ? overrides.maxNumberOfAddOns! : 4466;
    }
    if (pickedFields.size === 0 || pickedFields.has('prompt')) {
        result.prompt = overrides && overrides.hasOwnProperty('prompt') ? overrides.prompt! : 'qui';
    }

    return result;
};

export const aWixBookingsServicesV2Location = <T extends Partial<WixBookingsServicesV2Location>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('business')) {
        result.business = overrides && overrides.hasOwnProperty('business') ? aWixBookingsServicesV2BusinessLocationOptions(overrides.business ?? {}, pickedFields.get('business')) : aWixBookingsServicesV2BusinessLocationOptions({}, pickedFields.get('business'));
    }
    if (pickedFields.size === 0 || pickedFields.has('calculatedAddress')) {
        result.calculatedAddress = overrides && overrides.hasOwnProperty('calculatedAddress') ? aWixBookingsServicesV2UpstreamWixCommonAddress(overrides.calculatedAddress ?? {}, pickedFields.get('calculatedAddress')) : aWixBookingsServicesV2UpstreamWixCommonAddress({}, pickedFields.get('calculatedAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? aWixBookingsServicesV2CustomLocationOptions(overrides.custom ?? {}, pickedFields.get('custom')) : aWixBookingsServicesV2CustomLocationOptions({}, pickedFields.get('custom'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quae';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsServicesV2LocationTypeEnumLocationType.Business;
    }

    return result;
};

export const aWixBookingsServicesV2LocationInput = <T extends Partial<WixBookingsServicesV2LocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('business')) {
        result.business = overrides && overrides.hasOwnProperty('business') ? aWixBookingsServicesV2BusinessLocationOptionsInput(overrides.business ?? {}, pickedFields.get('business')) : aWixBookingsServicesV2BusinessLocationOptionsInput({}, pickedFields.get('business'));
    }
    if (pickedFields.size === 0 || pickedFields.has('calculatedAddress')) {
        result.calculatedAddress = overrides && overrides.hasOwnProperty('calculatedAddress') ? aWixBookingsServicesV2UpstreamWixCommonAddressInput(overrides.calculatedAddress ?? {}, pickedFields.get('calculatedAddress')) : aWixBookingsServicesV2UpstreamWixCommonAddressInput({}, pickedFields.get('calculatedAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? aWixBookingsServicesV2CustomLocationOptionsInput(overrides.custom ?? {}, pickedFields.get('custom')) : aWixBookingsServicesV2CustomLocationOptionsInput({}, pickedFields.get('custom'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsServicesV2LocationTypeEnumLocationType.Business;
    }

    return result;
};

export const aWixBookingsServicesV2Media = <T extends Partial<WixBookingsServicesV2Media>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coverMedia')) {
        result.coverMedia = overrides && overrides.hasOwnProperty('coverMedia') ? aWixBookingsServicesV2MediaItem(overrides.coverMedia ?? {}, pickedFields.get('coverMedia')) : aWixBookingsServicesV2MediaItem({}, pickedFields.get('coverMedia'));
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixBookingsServicesV2MediaItem(x ?? {}, pickedFields.get('items'))) : [aWixBookingsServicesV2MediaItem({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('mainMedia')) {
        result.mainMedia = overrides && overrides.hasOwnProperty('mainMedia') ? aWixBookingsServicesV2MediaItem(overrides.mainMedia ?? {}, pickedFields.get('mainMedia')) : aWixBookingsServicesV2MediaItem({}, pickedFields.get('mainMedia'));
    }

    return result;
};

export const aWixBookingsServicesV2MediaInput = <T extends Partial<WixBookingsServicesV2MediaInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coverMedia')) {
        result.coverMedia = overrides && overrides.hasOwnProperty('coverMedia') ? aWixBookingsServicesV2MediaItemInput(overrides.coverMedia ?? {}, pickedFields.get('coverMedia')) : aWixBookingsServicesV2MediaItemInput({}, pickedFields.get('coverMedia'));
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixBookingsServicesV2MediaItemInput({}, pickedFields.get('items'))) : [aWixBookingsServicesV2MediaItemInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('mainMedia')) {
        result.mainMedia = overrides && overrides.hasOwnProperty('mainMedia') ? aWixBookingsServicesV2MediaItemInput(overrides.mainMedia ?? {}, pickedFields.get('mainMedia')) : aWixBookingsServicesV2MediaItemInput({}, pickedFields.get('mainMedia'));
    }

    return result;
};

export const aWixBookingsServicesV2MediaItem = <T extends Partial<WixBookingsServicesV2MediaItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixBookingsServicesV2UpstreamWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixBookingsServicesV2UpstreamWixCommonImage({}, pickedFields.get('image'));
    }

    return result;
};

export const aWixBookingsServicesV2MediaItemInput = <T extends Partial<WixBookingsServicesV2MediaItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixBookingsServicesV2UpstreamWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixBookingsServicesV2UpstreamWixCommonImageInput({}, pickedFields.get('image'));
    }

    return result;
};

export const aWixBookingsServicesV2MoveToNewLocationsOptionsInput = <T extends Partial<WixBookingsServicesV2MoveToNewLocationsOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newLocation')) {
        result.newLocation = overrides && overrides.hasOwnProperty('newLocation') ? aWixBookingsServicesV2LocationInput(overrides.newLocation ?? {}, pickedFields.get('newLocation')) : aWixBookingsServicesV2LocationInput({}, pickedFields.get('newLocation'));
    }

    return result;
};

export const aWixBookingsServicesV2OnlineBooking = <T extends Partial<WixBookingsServicesV2OnlineBooking>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowMultipleRequests')) {
        result.allowMultipleRequests = overrides && overrides.hasOwnProperty('allowMultipleRequests') ? overrides.allowMultipleRequests! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('requireManualApproval')) {
        result.requireManualApproval = overrides && overrides.hasOwnProperty('requireManualApproval') ? overrides.requireManualApproval! : true;
    }

    return result;
};

export const aWixBookingsServicesV2OnlineBookingInput = <T extends Partial<WixBookingsServicesV2OnlineBookingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowMultipleRequests')) {
        result.allowMultipleRequests = overrides && overrides.hasOwnProperty('allowMultipleRequests') ? overrides.allowMultipleRequests! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('requireManualApproval')) {
        result.requireManualApproval = overrides && overrides.hasOwnProperty('requireManualApproval') ? overrides.requireManualApproval! : false;
    }

    return result;
};

export const aWixBookingsServicesV2ParticipantNotificationInput = <T extends Partial<WixBookingsServicesV2ParticipantNotificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('notifyParticipants')) {
        result.notifyParticipants = overrides && overrides.hasOwnProperty('notifyParticipants') ? overrides.notifyParticipants! : true;
    }

    return result;
};

export const aWixBookingsServicesV2Payment = <T extends Partial<WixBookingsServicesV2Payment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? aWixBookingsServicesV2CustomPayment(overrides.custom ?? {}, pickedFields.get('custom')) : aWixBookingsServicesV2CustomPayment({}, pickedFields.get('custom'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fixed')) {
        result.fixed = overrides && overrides.hasOwnProperty('fixed') ? aWixBookingsServicesV2FixedPayment(overrides.fixed ?? {}, pickedFields.get('fixed')) : aWixBookingsServicesV2FixedPayment({}, pickedFields.get('fixed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixBookingsServicesV2PaymentOptions(overrides.options ?? {}, pickedFields.get('options')) : aWixBookingsServicesV2PaymentOptions({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pricingPlanIds')) {
        result.pricingPlanIds = overrides && overrides.hasOwnProperty('pricingPlanIds') ? overrides.pricingPlanIds! : ['eligendi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('rateType')) {
        result.rateType = overrides && overrides.hasOwnProperty('rateType') ? overrides.rateType! : WixBookingsServicesV2RateTypeEnumRateType.Custom;
    }
    if (pickedFields.size === 0 || pickedFields.has('varied')) {
        result.varied = overrides && overrides.hasOwnProperty('varied') ? aWixBookingsServicesV2VariedPayment(overrides.varied ?? {}, pickedFields.get('varied')) : aWixBookingsServicesV2VariedPayment({}, pickedFields.get('varied'));
    }

    return result;
};

export const aWixBookingsServicesV2PaymentInput = <T extends Partial<WixBookingsServicesV2PaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? aWixBookingsServicesV2CustomPaymentInput(overrides.custom ?? {}, pickedFields.get('custom')) : aWixBookingsServicesV2CustomPaymentInput({}, pickedFields.get('custom'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fixed')) {
        result.fixed = overrides && overrides.hasOwnProperty('fixed') ? aWixBookingsServicesV2FixedPaymentInput(overrides.fixed ?? {}, pickedFields.get('fixed')) : aWixBookingsServicesV2FixedPaymentInput({}, pickedFields.get('fixed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixBookingsServicesV2PaymentOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aWixBookingsServicesV2PaymentOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pricingPlanIds')) {
        result.pricingPlanIds = overrides && overrides.hasOwnProperty('pricingPlanIds') ? overrides.pricingPlanIds! : ['ut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('rateType')) {
        result.rateType = overrides && overrides.hasOwnProperty('rateType') ? overrides.rateType! : WixBookingsServicesV2RateTypeEnumRateType.Custom;
    }
    if (pickedFields.size === 0 || pickedFields.has('varied')) {
        result.varied = overrides && overrides.hasOwnProperty('varied') ? aWixBookingsServicesV2VariedPaymentInput(overrides.varied ?? {}, pickedFields.get('varied')) : aWixBookingsServicesV2VariedPaymentInput({}, pickedFields.get('varied'));
    }

    return result;
};

export const aWixBookingsServicesV2PaymentOptions = <T extends Partial<WixBookingsServicesV2PaymentOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deposit')) {
        result.deposit = overrides && overrides.hasOwnProperty('deposit') ? overrides.deposit! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('inPerson')) {
        result.inPerson = overrides && overrides.hasOwnProperty('inPerson') ? overrides.inPerson! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('online')) {
        result.online = overrides && overrides.hasOwnProperty('online') ? overrides.online! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('pricingPlan')) {
        result.pricingPlan = overrides && overrides.hasOwnProperty('pricingPlan') ? overrides.pricingPlan! : true;
    }

    return result;
};

export const aWixBookingsServicesV2PaymentOptionsInput = <T extends Partial<WixBookingsServicesV2PaymentOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deposit')) {
        result.deposit = overrides && overrides.hasOwnProperty('deposit') ? overrides.deposit! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('inPerson')) {
        result.inPerson = overrides && overrides.hasOwnProperty('inPerson') ? overrides.inPerson! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('online')) {
        result.online = overrides && overrides.hasOwnProperty('online') ? overrides.online! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('pricingPlan')) {
        result.pricingPlan = overrides && overrides.hasOwnProperty('pricingPlan') ? overrides.pricingPlan! : true;
    }

    return result;
};

export const aWixBookingsServicesV2QueryBookingFormsRequestInput = <T extends Partial<WixBookingsServicesV2QueryBookingFormsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conditionalFields')) {
        result.conditionalFields = overrides && overrides.hasOwnProperty('conditionalFields') ? overrides.conditionalFields! : [WixBookingsServicesV2QueryBookingFormsRequestRequestedFields.DefaultBookingForm];
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixBookingsServicesV2UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixBookingsServicesV2UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixBookingsServicesV2QueryBookingFormsResponse = <T extends Partial<WixBookingsServicesV2QueryBookingFormsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingForms')) {
        result.bookingForms = overrides && overrides.hasOwnProperty('bookingForms') ? overrides.bookingForms!.map((x) => aWixBookingsServicesV2BookingForm(x ?? {}, pickedFields.get('bookingForms'))) : [aWixBookingsServicesV2BookingForm({}, pickedFields.get('bookingForms'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultBookingForm')) {
        result.defaultBookingForm = overrides && overrides.hasOwnProperty('defaultBookingForm') ? aWixBookingsServicesV2BookingForm(overrides.defaultBookingForm ?? {}, pickedFields.get('defaultBookingForm')) : aWixBookingsServicesV2BookingForm({}, pickedFields.get('defaultBookingForm'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixBookingsServicesV2QueryCategoriesFilterInput = <T extends Partial<WixBookingsServicesV2QueryCategoriesFilterInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryIds')) {
        result.categoryIds = overrides && overrides.hasOwnProperty('categoryIds') ? overrides.categoryIds! : ['ipsa'];
    }
    if (pickedFields.size === 0 || pickedFields.has('services')) {
        result.services = overrides && overrides.hasOwnProperty('services') ? overrides.services! : 'eum';
    }

    return result;
};

export const aWixBookingsServicesV2QueryCategoriesRequestInput = <T extends Partial<WixBookingsServicesV2QueryCategoriesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? aWixBookingsServicesV2QueryCategoriesFilterInput(overrides.filter ?? {}, pickedFields.get('filter')) : aWixBookingsServicesV2QueryCategoriesFilterInput({}, pickedFields.get('filter'));
    }

    return result;
};

export const aWixBookingsServicesV2QueryCategoriesResponse = <T extends Partial<WixBookingsServicesV2QueryCategoriesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categories')) {
        result.categories = overrides && overrides.hasOwnProperty('categories') ? overrides.categories!.map((x) => aWixBookingsServicesV2Category(x ?? {}, pickedFields.get('categories'))) : [aWixBookingsServicesV2Category({}, pickedFields.get('categories'))];
    }

    return result;
};

export const aWixBookingsServicesV2QueryLocationsFilterInput = <T extends Partial<WixBookingsServicesV2QueryLocationsFilterInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['quia'];
    }
    if (pickedFields.size === 0 || pickedFields.has('services')) {
        result.services = overrides && overrides.hasOwnProperty('services') ? overrides.services! : 'rerum';
    }

    return result;
};

export const aWixBookingsServicesV2QueryLocationsRequestInput = <T extends Partial<WixBookingsServicesV2QueryLocationsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? aWixBookingsServicesV2QueryLocationsFilterInput(overrides.filter ?? {}, pickedFields.get('filter')) : aWixBookingsServicesV2QueryLocationsFilterInput({}, pickedFields.get('filter'));
    }

    return result;
};

export const aWixBookingsServicesV2QueryLocationsResponse = <T extends Partial<WixBookingsServicesV2QueryLocationsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocations')) {
        result.businessLocations = overrides && overrides.hasOwnProperty('businessLocations') ? aWixBookingsServicesV2BusinessLocations(overrides.businessLocations ?? {}, pickedFields.get('businessLocations')) : aWixBookingsServicesV2BusinessLocations({}, pickedFields.get('businessLocations'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customLocations')) {
        result.customLocations = overrides && overrides.hasOwnProperty('customLocations') ? aWixBookingsServicesV2CustomLocations(overrides.customLocations ?? {}, pickedFields.get('customLocations')) : aWixBookingsServicesV2CustomLocations({}, pickedFields.get('customLocations'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customerLocations')) {
        result.customerLocations = overrides && overrides.hasOwnProperty('customerLocations') ? aWixBookingsServicesV2CustomerLocations(overrides.customerLocations ?? {}, pickedFields.get('customerLocations')) : aWixBookingsServicesV2CustomerLocations({}, pickedFields.get('customerLocations'));
    }

    return result;
};

export const aWixBookingsServicesV2QueryPoliciesRequestInput = <T extends Partial<WixBookingsServicesV2QueryPoliciesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixBookingsServicesV2UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixBookingsServicesV2UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixBookingsServicesV2QueryPoliciesResponse = <T extends Partial<WixBookingsServicesV2QueryPoliciesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicies')) {
        result.bookingPolicies = overrides && overrides.hasOwnProperty('bookingPolicies') ? overrides.bookingPolicies!.map((x) => aWixBookingsServicesV2BookingPolicyWithServices(x ?? {}, pickedFields.get('bookingPolicies'))) : [aWixBookingsServicesV2BookingPolicyWithServices({}, pickedFields.get('bookingPolicies'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixBookingsServicesV2QueryServicesMultiLanguageRequestInput = <T extends Partial<WixBookingsServicesV2QueryServicesMultiLanguageRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conditionalFields')) {
        result.conditionalFields = overrides && overrides.hasOwnProperty('conditionalFields') ? overrides.conditionalFields! : [WixBookingsServicesV2RequestedFields.ResourceTypeDetails];
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixBookingsServicesV2UpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixBookingsServicesV2UpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixBookingsServicesV2QueryServicesMultiLanguageResponse = <T extends Partial<WixBookingsServicesV2QueryServicesMultiLanguageResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixBookingsServicesV2UpstreamWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixBookingsServicesV2UpstreamWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('services')) {
        result.services = overrides && overrides.hasOwnProperty('services') ? overrides.services!.map((x) => aWixBookingsServicesV2Service(x ?? {}, pickedFields.get('services'))) : [aWixBookingsServicesV2Service({}, pickedFields.get('services'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('translatedServices')) {
        result.translatedServices = overrides && overrides.hasOwnProperty('translatedServices') ? overrides.translatedServices!.map((x) => aWixBookingsServicesV2Service(x ?? {}, pickedFields.get('translatedServices'))) : [aWixBookingsServicesV2Service({}, pickedFields.get('translatedServices'))];
    }

    return result;
};

export const aWixBookingsServicesV2QueryServicesRequestInput = <T extends Partial<WixBookingsServicesV2QueryServicesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conditionalFields')) {
        result.conditionalFields = overrides && overrides.hasOwnProperty('conditionalFields') ? overrides.conditionalFields! : [WixBookingsServicesV2RequestedFields.ResourceTypeDetails];
    }
    if (pickedFields.size === 0 || pickedFields.has('eventuallyConsistent')) {
        result.eventuallyConsistent = overrides && overrides.hasOwnProperty('eventuallyConsistent') ? overrides.eventuallyConsistent! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixBookingsServicesV2UpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixBookingsServicesV2UpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixBookingsServicesV2QueryServicesResponse = <T extends Partial<WixBookingsServicesV2QueryServicesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixBookingsServicesV2Service(x ?? {}, pickedFields.get('items'))) : [aWixBookingsServicesV2Service({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixBookingsServicesV2RemovedLocationSessionsActionInput = <T extends Partial<WixBookingsServicesV2RemovedLocationSessionsActionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('action')) {
        result.action = overrides && overrides.hasOwnProperty('action') ? overrides.action! : WixBookingsServicesV2RemovedLocationSessionsActionAction.Delete;
    }
    if (pickedFields.size === 0 || pickedFields.has('moveToLocationOptions')) {
        result.moveToLocationOptions = overrides && overrides.hasOwnProperty('moveToLocationOptions') ? aWixBookingsServicesV2MoveToNewLocationsOptionsInput(overrides.moveToLocationOptions ?? {}, pickedFields.get('moveToLocationOptions')) : aWixBookingsServicesV2MoveToNewLocationsOptionsInput({}, pickedFields.get('moveToLocationOptions'));
    }

    return result;
};

export const aWixBookingsServicesV2ResourceGroup = <T extends Partial<WixBookingsServicesV2ResourceGroup>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('requiredResourcesNumber')) {
        result.requiredResourcesNumber = overrides && overrides.hasOwnProperty('requiredResourcesNumber') ? overrides.requiredResourcesNumber! : 5963;
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceGroupId')) {
        result.resourceGroupId = overrides && overrides.hasOwnProperty('resourceGroupId') ? overrides.resourceGroupId! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceIds')) {
        result.resourceIds = overrides && overrides.hasOwnProperty('resourceIds') ? aWixBookingsServicesV2ResourceIds(overrides.resourceIds ?? {}, pickedFields.get('resourceIds')) : aWixBookingsServicesV2ResourceIds({}, pickedFields.get('resourceIds'));
    }
    if (pickedFields.size === 0 || pickedFields.has('selectableResource')) {
        result.selectableResource = overrides && overrides.hasOwnProperty('selectableResource') ? overrides.selectableResource! : true;
    }

    return result;
};

export const aWixBookingsServicesV2ResourceGroupInput = <T extends Partial<WixBookingsServicesV2ResourceGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('requiredResourcesNumber')) {
        result.requiredResourcesNumber = overrides && overrides.hasOwnProperty('requiredResourcesNumber') ? overrides.requiredResourcesNumber! : 2023;
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceGroupId')) {
        result.resourceGroupId = overrides && overrides.hasOwnProperty('resourceGroupId') ? overrides.resourceGroupId! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceIds')) {
        result.resourceIds = overrides && overrides.hasOwnProperty('resourceIds') ? aWixBookingsServicesV2ResourceIdsInput(overrides.resourceIds ?? {}, pickedFields.get('resourceIds')) : aWixBookingsServicesV2ResourceIdsInput({}, pickedFields.get('resourceIds'));
    }
    if (pickedFields.size === 0 || pickedFields.has('selectableResource')) {
        result.selectableResource = overrides && overrides.hasOwnProperty('selectableResource') ? overrides.selectableResource! : true;
    }

    return result;
};

export const aWixBookingsServicesV2ResourceIds = <T extends Partial<WixBookingsServicesV2ResourceIds>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values! : ['voluptas'];
    }

    return result;
};

export const aWixBookingsServicesV2ResourceIdsInput = <T extends Partial<WixBookingsServicesV2ResourceIdsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values! : ['omnis'];
    }

    return result;
};

export const aWixBookingsServicesV2ResourceType = <T extends Partial<WixBookingsServicesV2ResourceType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dolores';
    }

    return result;
};

export const aWixBookingsServicesV2ResourceTypeInput = <T extends Partial<WixBookingsServicesV2ResourceTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'est';
    }

    return result;
};

export const aWixBookingsServicesV2Schedule = <T extends Partial<WixBookingsServicesV2Schedule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availabilityConstraints')) {
        result.availabilityConstraints = overrides && overrides.hasOwnProperty('availabilityConstraints') ? aWixBookingsServicesV2AvailabilityConstraints(overrides.availabilityConstraints ?? {}, pickedFields.get('availabilityConstraints')) : aWixBookingsServicesV2AvailabilityConstraints({}, pickedFields.get('availabilityConstraints'));
    }
    if (pickedFields.size === 0 || pickedFields.has('firstSessionStart')) {
        result.firstSessionStart = overrides && overrides.hasOwnProperty('firstSessionStart') ? overrides.firstSessionStart! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSessionEnd')) {
        result.lastSessionEnd = overrides && overrides.hasOwnProperty('lastSessionEnd') ? overrides.lastSessionEnd! : 'omnis';
    }

    return result;
};

export const aWixBookingsServicesV2ScheduleInput = <T extends Partial<WixBookingsServicesV2ScheduleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availabilityConstraints')) {
        result.availabilityConstraints = overrides && overrides.hasOwnProperty('availabilityConstraints') ? aWixBookingsServicesV2AvailabilityConstraintsInput(overrides.availabilityConstraints ?? {}, pickedFields.get('availabilityConstraints')) : aWixBookingsServicesV2AvailabilityConstraintsInput({}, pickedFields.get('availabilityConstraints'));
    }
    if (pickedFields.size === 0 || pickedFields.has('firstSessionStart')) {
        result.firstSessionStart = overrides && overrides.hasOwnProperty('firstSessionStart') ? overrides.firstSessionStart! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSessionEnd')) {
        result.lastSessionEnd = overrides && overrides.hasOwnProperty('lastSessionEnd') ? overrides.lastSessionEnd! : 'quibusdam';
    }

    return result;
};

export const aWixBookingsServicesV2SearchServicesRequestInput = <T extends Partial<WixBookingsServicesV2SearchServicesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aWixBookingsServicesV2UpstreamWixCommonCursorSearchInput(overrides.search ?? {}, pickedFields.get('search')) : aWixBookingsServicesV2UpstreamWixCommonCursorSearchInput({}, pickedFields.get('search'));
    }

    return result;
};

export const aWixBookingsServicesV2SearchServicesResponse = <T extends Partial<WixBookingsServicesV2SearchServicesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregationData')) {
        result.aggregationData = overrides && overrides.hasOwnProperty('aggregationData') ? aWixBookingsServicesV2UpstreamWixCommonAggregationData(overrides.aggregationData ?? {}, pickedFields.get('aggregationData')) : aWixBookingsServicesV2UpstreamWixCommonAggregationData({}, pickedFields.get('aggregationData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('services')) {
        result.services = overrides && overrides.hasOwnProperty('services') ? overrides.services!.map((x) => aWixBookingsServicesV2Service(x ?? {}, pickedFields.get('services'))) : [aWixBookingsServicesV2Service({}, pickedFields.get('services'))];
    }

    return result;
};

export const aWixBookingsServicesV2Service = <T extends Partial<WixBookingsServicesV2Service>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnDetails')) {
        result.addOnDetails = overrides && overrides.hasOwnProperty('addOnDetails') ? overrides.addOnDetails!.map((x) => aWixBookingsServicesV2AddOnDetails(x ?? {}, pickedFields.get('addOnDetails'))) : [aWixBookingsServicesV2AddOnDetails({}, pickedFields.get('addOnDetails'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('addOnGroups')) {
        result.addOnGroups = overrides && overrides.hasOwnProperty('addOnGroups') ? overrides.addOnGroups!.map((x) => aWixBookingsServicesV2AddOnGroup(x ?? {}, pickedFields.get('addOnGroups'))) : [aWixBookingsServicesV2AddOnGroup({}, pickedFields.get('addOnGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('bookingPolicy')) {
        result.bookingPolicy = overrides && overrides.hasOwnProperty('bookingPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy(overrides.bookingPolicy ?? {}, pickedFields.get('bookingPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy({}, pickedFields.get('bookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aWixBookingsServicesV2Category(overrides.category ?? {}, pickedFields.get('category')) : aWixBookingsServicesV2Category({}, pickedFields.get('category'));
    }
    if (pickedFields.size === 0 || pickedFields.has('conferencing')) {
        result.conferencing = overrides && overrides.hasOwnProperty('conferencing') ? aWixBookingsServicesV2Conferencing(overrides.conferencing ?? {}, pickedFields.get('conferencing')) : aWixBookingsServicesV2Conferencing({}, pickedFields.get('conferencing'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultCapacity')) {
        result.defaultCapacity = overrides && overrides.hasOwnProperty('defaultCapacity') ? overrides.defaultCapacity! : 3386;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixBookingsServicesV2Form(overrides.form ?? {}, pickedFields.get('form')) : aWixBookingsServicesV2Form({}, pickedFields.get('form'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aWixBookingsServicesV2Location(x ?? {}, pickedFields.get('locations'))) : [aWixBookingsServicesV2Location({}, pickedFields.get('locations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('mainSlug')) {
        result.mainSlug = overrides && overrides.hasOwnProperty('mainSlug') ? aWixBookingsServicesV2Slug(overrides.mainSlug ?? {}, pickedFields.get('mainSlug')) : aWixBookingsServicesV2Slug({}, pickedFields.get('mainSlug'));
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixBookingsServicesV2Media(overrides.media ?? {}, pickedFields.get('media')) : aWixBookingsServicesV2Media({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('onlineBooking')) {
        result.onlineBooking = overrides && overrides.hasOwnProperty('onlineBooking') ? aWixBookingsServicesV2OnlineBooking(overrides.onlineBooking ?? {}, pickedFields.get('onlineBooking')) : aWixBookingsServicesV2OnlineBooking({}, pickedFields.get('onlineBooking'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aWixBookingsServicesV2Payment(overrides.payment ?? {}, pickedFields.get('payment')) : aWixBookingsServicesV2Payment({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceGroups')) {
        result.resourceGroups = overrides && overrides.hasOwnProperty('resourceGroups') ? overrides.resourceGroups!.map((x) => aWixBookingsServicesV2ResourceGroup(x ?? {}, pickedFields.get('resourceGroups'))) : [aWixBookingsServicesV2ResourceGroup({}, pickedFields.get('resourceGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixBookingsServicesV2Schedule(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixBookingsServicesV2Schedule({}, pickedFields.get('schedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceResources')) {
        result.serviceResources = overrides && overrides.hasOwnProperty('serviceResources') ? overrides.serviceResources!.map((x) => aWixBookingsServicesV2ServiceResource(x ?? {}, pickedFields.get('serviceResources'))) : [aWixBookingsServicesV2ServiceResource({}, pickedFields.get('serviceResources'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 1353;
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberDetails')) {
        result.staffMemberDetails = overrides && overrides.hasOwnProperty('staffMemberDetails') ? aWixBookingsServicesV2StaffMemberDetails(overrides.staffMemberDetails ?? {}, pickedFields.get('staffMemberDetails')) : aWixBookingsServicesV2StaffMemberDetails({}, pickedFields.get('staffMemberDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberIds')) {
        result.staffMemberIds = overrides && overrides.hasOwnProperty('staffMemberIds') ? overrides.staffMemberIds! : ['ratione'];
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMembers')) {
        result.staffMembers = overrides && overrides.hasOwnProperty('staffMembers') ? overrides.staffMembers!.map((x) => aWixBookingsServicesV2StaffMember(x ?? {}, pickedFields.get('staffMembers'))) : [aWixBookingsServicesV2StaffMember({}, pickedFields.get('staffMembers'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('supportedSlugs')) {
        result.supportedSlugs = overrides && overrides.hasOwnProperty('supportedSlugs') ? overrides.supportedSlugs!.map((x) => aWixBookingsServicesV2Slug(x ?? {}, pickedFields.get('supportedSlugs'))) : [aWixBookingsServicesV2Slug({}, pickedFields.get('supportedSlugs'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('tagLine')) {
        result.tagLine = overrides && overrides.hasOwnProperty('tagLine') ? overrides.tagLine! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsServicesV2ServiceTypeEnumServiceType.Appointment;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('urls')) {
        result.urls = overrides && overrides.hasOwnProperty('urls') ? aWixBookingsServicesV2UrLs(overrides.urls ?? {}, pickedFields.get('urls')) : aWixBookingsServicesV2UrLs({}, pickedFields.get('urls'));
    }

    return result;
};

export const aWixBookingsServicesV2ServiceAvailabilityConstraints = <T extends Partial<WixBookingsServicesV2ServiceAvailabilityConstraints>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicy')) {
        result.bookingPolicy = overrides && overrides.hasOwnProperty('bookingPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy(overrides.bookingPolicy ?? {}, pickedFields.get('bookingPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy({}, pickedFields.get('bookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aWixBookingsServicesV2Location(x ?? {}, pickedFields.get('locations'))) : [aWixBookingsServicesV2Location({}, pickedFields.get('locations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('onlineBooking')) {
        result.onlineBooking = overrides && overrides.hasOwnProperty('onlineBooking') ? aWixBookingsServicesV2OnlineBooking(overrides.onlineBooking ?? {}, pickedFields.get('onlineBooking')) : aWixBookingsServicesV2OnlineBooking({}, pickedFields.get('onlineBooking'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceGroups')) {
        result.resourceGroups = overrides && overrides.hasOwnProperty('resourceGroups') ? overrides.resourceGroups!.map((x) => aWixBookingsServicesV2ResourceGroup(x ?? {}, pickedFields.get('resourceGroups'))) : [aWixBookingsServicesV2ResourceGroup({}, pickedFields.get('resourceGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixBookingsServicesV2Schedule(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixBookingsServicesV2Schedule({}, pickedFields.get('schedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceResources')) {
        result.serviceResources = overrides && overrides.hasOwnProperty('serviceResources') ? overrides.serviceResources!.map((x) => aWixBookingsServicesV2ServiceResource(x ?? {}, pickedFields.get('serviceResources'))) : [aWixBookingsServicesV2ServiceResource({}, pickedFields.get('serviceResources'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('slotsSplitInterval')) {
        result.slotsSplitInterval = overrides && overrides.hasOwnProperty('slotsSplitInterval') ? aWixBookingsServicesV2UpstreamWixBookingsSchedulesV1SplitInterval(overrides.slotsSplitInterval ?? {}, pickedFields.get('slotsSplitInterval')) : aWixBookingsServicesV2UpstreamWixBookingsSchedulesV1SplitInterval({}, pickedFields.get('slotsSplitInterval'));
    }

    return result;
};

export const aWixBookingsServicesV2ServiceInput = <T extends Partial<WixBookingsServicesV2ServiceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnDetails')) {
        result.addOnDetails = overrides && overrides.hasOwnProperty('addOnDetails') ? overrides.addOnDetails!.map((x) => aWixBookingsServicesV2AddOnDetailsInput({}, pickedFields.get('addOnDetails'))) : [aWixBookingsServicesV2AddOnDetailsInput({}, pickedFields.get('addOnDetails'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('addOnGroups')) {
        result.addOnGroups = overrides && overrides.hasOwnProperty('addOnGroups') ? overrides.addOnGroups!.map((x) => aWixBookingsServicesV2AddOnGroupInput({}, pickedFields.get('addOnGroups'))) : [aWixBookingsServicesV2AddOnGroupInput({}, pickedFields.get('addOnGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('bookingPolicy')) {
        result.bookingPolicy = overrides && overrides.hasOwnProperty('bookingPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1BookingPolicyInput(overrides.bookingPolicy ?? {}, pickedFields.get('bookingPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1BookingPolicyInput({}, pickedFields.get('bookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? aWixBookingsServicesV2CategoryInput(overrides.category ?? {}, pickedFields.get('category')) : aWixBookingsServicesV2CategoryInput({}, pickedFields.get('category'));
    }
    if (pickedFields.size === 0 || pickedFields.has('conferencing')) {
        result.conferencing = overrides && overrides.hasOwnProperty('conferencing') ? aWixBookingsServicesV2ConferencingInput(overrides.conferencing ?? {}, pickedFields.get('conferencing')) : aWixBookingsServicesV2ConferencingInput({}, pickedFields.get('conferencing'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultCapacity')) {
        result.defaultCapacity = overrides && overrides.hasOwnProperty('defaultCapacity') ? overrides.defaultCapacity! : 3698;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixBookingsServicesV2FormInput(overrides.form ?? {}, pickedFields.get('form')) : aWixBookingsServicesV2FormInput({}, pickedFields.get('form'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aWixBookingsServicesV2LocationInput({}, pickedFields.get('locations'))) : [aWixBookingsServicesV2LocationInput({}, pickedFields.get('locations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('mainSlug')) {
        result.mainSlug = overrides && overrides.hasOwnProperty('mainSlug') ? aWixBookingsServicesV2SlugInput(overrides.mainSlug ?? {}, pickedFields.get('mainSlug')) : aWixBookingsServicesV2SlugInput({}, pickedFields.get('mainSlug'));
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixBookingsServicesV2MediaInput(overrides.media ?? {}, pickedFields.get('media')) : aWixBookingsServicesV2MediaInput({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('onlineBooking')) {
        result.onlineBooking = overrides && overrides.hasOwnProperty('onlineBooking') ? aWixBookingsServicesV2OnlineBookingInput(overrides.onlineBooking ?? {}, pickedFields.get('onlineBooking')) : aWixBookingsServicesV2OnlineBookingInput({}, pickedFields.get('onlineBooking'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aWixBookingsServicesV2PaymentInput(overrides.payment ?? {}, pickedFields.get('payment')) : aWixBookingsServicesV2PaymentInput({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixBookingsServicesV2ScheduleInput(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixBookingsServicesV2ScheduleInput({}, pickedFields.get('schedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceResources')) {
        result.serviceResources = overrides && overrides.hasOwnProperty('serviceResources') ? overrides.serviceResources!.map((x) => aWixBookingsServicesV2ServiceResourceInput({}, pickedFields.get('serviceResources'))) : [aWixBookingsServicesV2ServiceResourceInput({}, pickedFields.get('serviceResources'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('sortOrder')) {
        result.sortOrder = overrides && overrides.hasOwnProperty('sortOrder') ? overrides.sortOrder! : 5575;
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberDetails')) {
        result.staffMemberDetails = overrides && overrides.hasOwnProperty('staffMemberDetails') ? aWixBookingsServicesV2StaffMemberDetailsInput(overrides.staffMemberDetails ?? {}, pickedFields.get('staffMemberDetails')) : aWixBookingsServicesV2StaffMemberDetailsInput({}, pickedFields.get('staffMemberDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberIds')) {
        result.staffMemberIds = overrides && overrides.hasOwnProperty('staffMemberIds') ? overrides.staffMemberIds! : ['inventore'];
    }
    if (pickedFields.size === 0 || pickedFields.has('supportedSlugs')) {
        result.supportedSlugs = overrides && overrides.hasOwnProperty('supportedSlugs') ? overrides.supportedSlugs!.map((x) => aWixBookingsServicesV2SlugInput({}, pickedFields.get('supportedSlugs'))) : [aWixBookingsServicesV2SlugInput({}, pickedFields.get('supportedSlugs'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('tagLine')) {
        result.tagLine = overrides && overrides.hasOwnProperty('tagLine') ? overrides.tagLine! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsServicesV2ServiceTypeEnumServiceType.Appointment;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('urls')) {
        result.urls = overrides && overrides.hasOwnProperty('urls') ? aWixBookingsServicesV2UrLsInput(overrides.urls ?? {}, pickedFields.get('urls')) : aWixBookingsServicesV2UrLsInput({}, pickedFields.get('urls'));
    }

    return result;
};

export const aWixBookingsServicesV2ServiceResource = <T extends Partial<WixBookingsServicesV2ServiceResource>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('requiredResourcesNumber')) {
        result.requiredResourcesNumber = overrides && overrides.hasOwnProperty('requiredResourcesNumber') ? overrides.requiredResourcesNumber! : 2225;
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceIds')) {
        result.resourceIds = overrides && overrides.hasOwnProperty('resourceIds') ? aWixBookingsServicesV2ResourceIds(overrides.resourceIds ?? {}, pickedFields.get('resourceIds')) : aWixBookingsServicesV2ResourceIds({}, pickedFields.get('resourceIds'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceType')) {
        result.resourceType = overrides && overrides.hasOwnProperty('resourceType') ? aWixBookingsServicesV2ResourceType(overrides.resourceType ?? {}, pickedFields.get('resourceType')) : aWixBookingsServicesV2ResourceType({}, pickedFields.get('resourceType'));
    }
    if (pickedFields.size === 0 || pickedFields.has('selectableResource')) {
        result.selectableResource = overrides && overrides.hasOwnProperty('selectableResource') ? overrides.selectableResource! : false;
    }

    return result;
};

export const aWixBookingsServicesV2ServiceResourceInput = <T extends Partial<WixBookingsServicesV2ServiceResourceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('requiredResourcesNumber')) {
        result.requiredResourcesNumber = overrides && overrides.hasOwnProperty('requiredResourcesNumber') ? overrides.requiredResourcesNumber! : 8365;
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceIds')) {
        result.resourceIds = overrides && overrides.hasOwnProperty('resourceIds') ? aWixBookingsServicesV2ResourceIdsInput(overrides.resourceIds ?? {}, pickedFields.get('resourceIds')) : aWixBookingsServicesV2ResourceIdsInput({}, pickedFields.get('resourceIds'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceType')) {
        result.resourceType = overrides && overrides.hasOwnProperty('resourceType') ? aWixBookingsServicesV2ResourceTypeInput(overrides.resourceType ?? {}, pickedFields.get('resourceType')) : aWixBookingsServicesV2ResourceTypeInput({}, pickedFields.get('resourceType'));
    }
    if (pickedFields.size === 0 || pickedFields.has('selectableResource')) {
        result.selectableResource = overrides && overrides.hasOwnProperty('selectableResource') ? overrides.selectableResource! : false;
    }

    return result;
};

export const aWixBookingsServicesV2SetAddOnsForGroupRequestInput = <T extends Partial<WixBookingsServicesV2SetAddOnsForGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnIds')) {
        result.addOnIds = overrides && overrides.hasOwnProperty('addOnIds') ? overrides.addOnIds! : ['unde'];
    }
    if (pickedFields.size === 0 || pickedFields.has('groupId')) {
        result.groupId = overrides && overrides.hasOwnProperty('groupId') ? overrides.groupId! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'omnis';
    }

    return result;
};

export const aWixBookingsServicesV2SetAddOnsForGroupResponse = <T extends Partial<WixBookingsServicesV2SetAddOnsForGroupResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnGroup')) {
        result.addOnGroup = overrides && overrides.hasOwnProperty('addOnGroup') ? aWixBookingsServicesV2AddOnGroup(overrides.addOnGroup ?? {}, pickedFields.get('addOnGroup')) : aWixBookingsServicesV2AddOnGroup({}, pickedFields.get('addOnGroup'));
    }

    return result;
};

export const aWixBookingsServicesV2SetCustomSlugRequestInput = <T extends Partial<WixBookingsServicesV2SetCustomSlugRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'ea';
    }

    return result;
};

export const aWixBookingsServicesV2SetCustomSlugResponse = <T extends Partial<WixBookingsServicesV2SetCustomSlugResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2Service(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2Service({}, pickedFields.get('service'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? aWixBookingsServicesV2Slug(overrides.slug ?? {}, pickedFields.get('slug')) : aWixBookingsServicesV2Slug({}, pickedFields.get('slug'));
    }

    return result;
};

export const aWixBookingsServicesV2SetServiceLocationsRequestInput = <T extends Partial<WixBookingsServicesV2SetServiceLocationsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? overrides.locations!.map((x) => aWixBookingsServicesV2LocationInput({}, pickedFields.get('locations'))) : [aWixBookingsServicesV2LocationInput({}, pickedFields.get('locations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aWixBookingsServicesV2ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aWixBookingsServicesV2ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('removedLocationSessionsAction')) {
        result.removedLocationSessionsAction = overrides && overrides.hasOwnProperty('removedLocationSessionsAction') ? aWixBookingsServicesV2RemovedLocationSessionsActionInput(overrides.removedLocationSessionsAction ?? {}, pickedFields.get('removedLocationSessionsAction')) : aWixBookingsServicesV2RemovedLocationSessionsActionInput({}, pickedFields.get('removedLocationSessionsAction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'est';
    }

    return result;
};

export const aWixBookingsServicesV2SetServiceLocationsResponse = <T extends Partial<WixBookingsServicesV2SetServiceLocationsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2Service(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2Service({}, pickedFields.get('service'));
    }

    return result;
};

export const aWixBookingsServicesV2Slug = <T extends Partial<WixBookingsServicesV2Slug>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'et';
    }

    return result;
};

export const aWixBookingsServicesV2SlugInput = <T extends Partial<WixBookingsServicesV2SlugInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'delectus';
    }

    return result;
};

export const aWixBookingsServicesV2StaffMediaItem = <T extends Partial<WixBookingsServicesV2StaffMediaItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixBookingsServicesV2UpstreamWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixBookingsServicesV2UpstreamWixCommonImage({}, pickedFields.get('image'));
    }

    return result;
};

export const aWixBookingsServicesV2StaffMediaItemInput = <T extends Partial<WixBookingsServicesV2StaffMediaItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixBookingsServicesV2UpstreamWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixBookingsServicesV2UpstreamWixCommonImageInput({}, pickedFields.get('image'));
    }

    return result;
};

export const aWixBookingsServicesV2StaffMember = <T extends Partial<WixBookingsServicesV2StaffMember>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventsScheduleId')) {
        result.eventsScheduleId = overrides && overrides.hasOwnProperty('eventsScheduleId') ? overrides.eventsScheduleId! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('mainMedia')) {
        result.mainMedia = overrides && overrides.hasOwnProperty('mainMedia') ? aWixBookingsServicesV2StaffMediaItem(overrides.mainMedia ?? {}, pickedFields.get('mainMedia')) : aWixBookingsServicesV2StaffMediaItem({}, pickedFields.get('mainMedia'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('workingHoursScheduleIds')) {
        result.workingHoursScheduleIds = overrides && overrides.hasOwnProperty('workingHoursScheduleIds') ? overrides.workingHoursScheduleIds! : ['numquam'];
    }

    return result;
};

export const aWixBookingsServicesV2StaffMemberDetails = <T extends Partial<WixBookingsServicesV2StaffMemberDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMembers')) {
        result.staffMembers = overrides && overrides.hasOwnProperty('staffMembers') ? overrides.staffMembers!.map((x) => aWixBookingsServicesV2StaffMember(x ?? {}, pickedFields.get('staffMembers'))) : [aWixBookingsServicesV2StaffMember({}, pickedFields.get('staffMembers'))];
    }

    return result;
};

export const aWixBookingsServicesV2StaffMemberDetailsInput = <T extends Partial<WixBookingsServicesV2StaffMemberDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMembers')) {
        result.staffMembers = overrides && overrides.hasOwnProperty('staffMembers') ? overrides.staffMembers!.map((x) => aWixBookingsServicesV2StaffMemberInput({}, pickedFields.get('staffMembers'))) : [aWixBookingsServicesV2StaffMemberInput({}, pickedFields.get('staffMembers'))];
    }

    return result;
};

export const aWixBookingsServicesV2StaffMemberInput = <T extends Partial<WixBookingsServicesV2StaffMemberInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventsScheduleId')) {
        result.eventsScheduleId = overrides && overrides.hasOwnProperty('eventsScheduleId') ? overrides.eventsScheduleId! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('mainMedia')) {
        result.mainMedia = overrides && overrides.hasOwnProperty('mainMedia') ? aWixBookingsServicesV2StaffMediaItemInput(overrides.mainMedia ?? {}, pickedFields.get('mainMedia')) : aWixBookingsServicesV2StaffMediaItemInput({}, pickedFields.get('mainMedia'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'expedita';
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('workingHoursScheduleIds')) {
        result.workingHoursScheduleIds = overrides && overrides.hasOwnProperty('workingHoursScheduleIds') ? overrides.workingHoursScheduleIds! : ['itaque'];
    }

    return result;
};

export const aWixBookingsServicesV2UrLs = <T extends Partial<WixBookingsServicesV2UrLs>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPage')) {
        result.bookingPage = overrides && overrides.hasOwnProperty('bookingPage') ? aWixBookingsServicesV2UpstreamWixCommonPageUrlV2(overrides.bookingPage ?? {}, pickedFields.get('bookingPage')) : aWixBookingsServicesV2UpstreamWixCommonPageUrlV2({}, pickedFields.get('bookingPage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('calendarPage')) {
        result.calendarPage = overrides && overrides.hasOwnProperty('calendarPage') ? aWixBookingsServicesV2UpstreamWixCommonPageUrlV2(overrides.calendarPage ?? {}, pickedFields.get('calendarPage')) : aWixBookingsServicesV2UpstreamWixCommonPageUrlV2({}, pickedFields.get('calendarPage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('servicePage')) {
        result.servicePage = overrides && overrides.hasOwnProperty('servicePage') ? aWixBookingsServicesV2UpstreamWixCommonPageUrlV2(overrides.servicePage ?? {}, pickedFields.get('servicePage')) : aWixBookingsServicesV2UpstreamWixCommonPageUrlV2({}, pickedFields.get('servicePage'));
    }

    return result;
};

export const aWixBookingsServicesV2UrLsInput = <T extends Partial<WixBookingsServicesV2UrLsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPage')) {
        result.bookingPage = overrides && overrides.hasOwnProperty('bookingPage') ? aWixBookingsServicesV2UpstreamWixCommonPageUrlV2Input(overrides.bookingPage ?? {}, pickedFields.get('bookingPage')) : aWixBookingsServicesV2UpstreamWixCommonPageUrlV2Input({}, pickedFields.get('bookingPage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('calendarPage')) {
        result.calendarPage = overrides && overrides.hasOwnProperty('calendarPage') ? aWixBookingsServicesV2UpstreamWixCommonPageUrlV2Input(overrides.calendarPage ?? {}, pickedFields.get('calendarPage')) : aWixBookingsServicesV2UpstreamWixCommonPageUrlV2Input({}, pickedFields.get('calendarPage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('servicePage')) {
        result.servicePage = overrides && overrides.hasOwnProperty('servicePage') ? aWixBookingsServicesV2UpstreamWixCommonPageUrlV2Input(overrides.servicePage ?? {}, pickedFields.get('servicePage')) : aWixBookingsServicesV2UpstreamWixCommonPageUrlV2Input({}, pickedFields.get('servicePage'));
    }

    return result;
};

export const aWixBookingsServicesV2UpdateAddOnGroupRequestInput = <T extends Partial<WixBookingsServicesV2UpdateAddOnGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnGroup')) {
        result.addOnGroup = overrides && overrides.hasOwnProperty('addOnGroup') ? aWixBookingsServicesV2AddOnGroupInput(overrides.addOnGroup ?? {}, pickedFields.get('addOnGroup')) : aWixBookingsServicesV2AddOnGroupInput({}, pickedFields.get('addOnGroup'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['et'];
    }

    return result;
};

export const aWixBookingsServicesV2UpdateAddOnGroupResponse = <T extends Partial<WixBookingsServicesV2UpdateAddOnGroupResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnGroup')) {
        result.addOnGroup = overrides && overrides.hasOwnProperty('addOnGroup') ? aWixBookingsServicesV2AddOnGroup(overrides.addOnGroup ?? {}, pickedFields.get('addOnGroup')) : aWixBookingsServicesV2AddOnGroup({}, pickedFields.get('addOnGroup'));
    }

    return result;
};

export const aWixBookingsServicesV2UpdateAddOnsGroupRequestInput = <T extends Partial<WixBookingsServicesV2UpdateAddOnsGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnsGroup')) {
        result.addOnsGroup = overrides && overrides.hasOwnProperty('addOnsGroup') ? aWixBookingsServicesV2AddOnsGroupInput(overrides.addOnsGroup ?? {}, pickedFields.get('addOnsGroup')) : aWixBookingsServicesV2AddOnsGroupInput({}, pickedFields.get('addOnsGroup'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['et'];
    }

    return result;
};

export const aWixBookingsServicesV2UpdateAddOnsGroupResponse = <T extends Partial<WixBookingsServicesV2UpdateAddOnsGroupResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnsGroup')) {
        result.addOnsGroup = overrides && overrides.hasOwnProperty('addOnsGroup') ? aWixBookingsServicesV2AddOnsGroup(overrides.addOnsGroup ?? {}, pickedFields.get('addOnsGroup')) : aWixBookingsServicesV2AddOnsGroup({}, pickedFields.get('addOnsGroup'));
    }

    return result;
};

export const aWixBookingsServicesV2UpdateServiceRequestInput = <T extends Partial<WixBookingsServicesV2UpdateServiceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['delectus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2ServiceInput(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2ServiceInput({}, pickedFields.get('service'));
    }

    return result;
};

export const aWixBookingsServicesV2UpdateServiceResponse = <T extends Partial<WixBookingsServicesV2UpdateServiceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2Service(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2Service({}, pickedFields.get('service'));
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsSchedulesV1SplitInterval = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsSchedulesV1SplitInterval>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sameAsDuration')) {
        result.sameAsDuration = overrides && overrides.hasOwnProperty('sameAsDuration') ? overrides.sameAsDuration! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('valueInMinutes')) {
        result.valueInMinutes = overrides && overrides.hasOwnProperty('valueInMinutes') ? overrides.valueInMinutes! : 8368;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicy = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('bookAfterStartPolicy')) {
        result.bookAfterStartPolicy = overrides && overrides.hasOwnProperty('bookAfterStartPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicy(overrides.bookAfterStartPolicy ?? {}, pickedFields.get('bookAfterStartPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicy({}, pickedFields.get('bookAfterStartPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('bookingPolicy')) {
        result.bookingPolicy = overrides && overrides.hasOwnProperty('bookingPolicy') ? aWixBookingsV1BookingPolicy(overrides.bookingPolicy ?? {}, pickedFields.get('bookingPolicy')) : aWixBookingsV1BookingPolicy({}, pickedFields.get('bookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationFeePolicy')) {
        result.cancellationFeePolicy = overrides && overrides.hasOwnProperty('cancellationFeePolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicy(overrides.cancellationFeePolicy ?? {}, pickedFields.get('cancellationFeePolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicy({}, pickedFields.get('cancellationFeePolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationPolicy')) {
        result.cancellationPolicy = overrides && overrides.hasOwnProperty('cancellationPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicy(overrides.cancellationPolicy ?? {}, pickedFields.get('cancellationPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicy({}, pickedFields.get('cancellationPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('customPolicyDescription')) {
        result.customPolicyDescription = overrides && overrides.hasOwnProperty('customPolicyDescription') ? aWixBookingsServicesV2UpstreamWixBookingsV1PolicyDescription(overrides.customPolicyDescription ?? {}, pickedFields.get('customPolicyDescription')) : aWixBookingsServicesV2UpstreamWixBookingsV1PolicyDescription({}, pickedFields.get('customPolicyDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('limitEarlyBookingPolicy')) {
        result.limitEarlyBookingPolicy = overrides && overrides.hasOwnProperty('limitEarlyBookingPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicy(overrides.limitEarlyBookingPolicy ?? {}, pickedFields.get('limitEarlyBookingPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicy({}, pickedFields.get('limitEarlyBookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLateBookingPolicy')) {
        result.limitLateBookingPolicy = overrides && overrides.hasOwnProperty('limitLateBookingPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicy(overrides.limitLateBookingPolicy ?? {}, pickedFields.get('limitLateBookingPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicy({}, pickedFields.get('limitLateBookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantsPolicy')) {
        result.participantsPolicy = overrides && overrides.hasOwnProperty('participantsPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicy(overrides.participantsPolicy ?? {}, pickedFields.get('participantsPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicy({}, pickedFields.get('participantsPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('reschedulePolicy')) {
        result.reschedulePolicy = overrides && overrides.hasOwnProperty('reschedulePolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicy(overrides.reschedulePolicy ?? {}, pickedFields.get('reschedulePolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicy({}, pickedFields.get('reschedulePolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resourcesPolicy')) {
        result.resourcesPolicy = overrides && overrides.hasOwnProperty('resourcesPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicy(overrides.resourcesPolicy ?? {}, pickedFields.get('resourcesPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicy({}, pickedFields.get('resourcesPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('saveCreditCardPolicy')) {
        result.saveCreditCardPolicy = overrides && overrides.hasOwnProperty('saveCreditCardPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicy(overrides.saveCreditCardPolicy ?? {}, pickedFields.get('saveCreditCardPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicy({}, pickedFields.get('saveCreditCardPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('waitlistPolicy')) {
        result.waitlistPolicy = overrides && overrides.hasOwnProperty('waitlistPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicy(overrides.waitlistPolicy ?? {}, pickedFields.get('waitlistPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicy({}, pickedFields.get('waitlistPolicy'));
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1BookingPolicyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('bookAfterStartPolicy')) {
        result.bookAfterStartPolicy = overrides && overrides.hasOwnProperty('bookAfterStartPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicyInput(overrides.bookAfterStartPolicy ?? {}, pickedFields.get('bookAfterStartPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicyInput({}, pickedFields.get('bookAfterStartPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationFeePolicy')) {
        result.cancellationFeePolicy = overrides && overrides.hasOwnProperty('cancellationFeePolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyInput(overrides.cancellationFeePolicy ?? {}, pickedFields.get('cancellationFeePolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyInput({}, pickedFields.get('cancellationFeePolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationPolicy')) {
        result.cancellationPolicy = overrides && overrides.hasOwnProperty('cancellationPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicyInput(overrides.cancellationPolicy ?? {}, pickedFields.get('cancellationPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicyInput({}, pickedFields.get('cancellationPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('customPolicyDescription')) {
        result.customPolicyDescription = overrides && overrides.hasOwnProperty('customPolicyDescription') ? aWixBookingsServicesV2UpstreamWixBookingsV1PolicyDescriptionInput(overrides.customPolicyDescription ?? {}, pickedFields.get('customPolicyDescription')) : aWixBookingsServicesV2UpstreamWixBookingsV1PolicyDescriptionInput({}, pickedFields.get('customPolicyDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('limitEarlyBookingPolicy')) {
        result.limitEarlyBookingPolicy = overrides && overrides.hasOwnProperty('limitEarlyBookingPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicyInput(overrides.limitEarlyBookingPolicy ?? {}, pickedFields.get('limitEarlyBookingPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicyInput({}, pickedFields.get('limitEarlyBookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLateBookingPolicy')) {
        result.limitLateBookingPolicy = overrides && overrides.hasOwnProperty('limitLateBookingPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicyInput(overrides.limitLateBookingPolicy ?? {}, pickedFields.get('limitLateBookingPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicyInput({}, pickedFields.get('limitLateBookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantsPolicy')) {
        result.participantsPolicy = overrides && overrides.hasOwnProperty('participantsPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicyInput(overrides.participantsPolicy ?? {}, pickedFields.get('participantsPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicyInput({}, pickedFields.get('participantsPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('reschedulePolicy')) {
        result.reschedulePolicy = overrides && overrides.hasOwnProperty('reschedulePolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicyInput(overrides.reschedulePolicy ?? {}, pickedFields.get('reschedulePolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicyInput({}, pickedFields.get('reschedulePolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resourcesPolicy')) {
        result.resourcesPolicy = overrides && overrides.hasOwnProperty('resourcesPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicyInput(overrides.resourcesPolicy ?? {}, pickedFields.get('resourcesPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicyInput({}, pickedFields.get('resourcesPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('saveCreditCardPolicy')) {
        result.saveCreditCardPolicy = overrides && overrides.hasOwnProperty('saveCreditCardPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicyInput(overrides.saveCreditCardPolicy ?? {}, pickedFields.get('saveCreditCardPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicyInput({}, pickedFields.get('saveCreditCardPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('waitlistPolicy')) {
        result.waitlistPolicy = overrides && overrides.hasOwnProperty('waitlistPolicy') ? aWixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicyInput(overrides.waitlistPolicy ?? {}, pickedFields.get('waitlistPolicy')) : aWixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicyInput({}, pickedFields.get('waitlistPolicy'));
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicy = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoCollectFeeEnabled')) {
        result.autoCollectFeeEnabled = overrides && overrides.hasOwnProperty('autoCollectFeeEnabled') ? overrides.autoCollectFeeEnabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationWindows')) {
        result.cancellationWindows = overrides && overrides.hasOwnProperty('cancellationWindows') ? overrides.cancellationWindows!.map((x) => aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindow(x ?? {}, pickedFields.get('cancellationWindows'))) : [aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindow({}, pickedFields.get('cancellationWindows'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindow = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindow>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aWixBookingsServicesV2UpstreamWixCommonMoney(overrides.amount ?? {}, pickedFields.get('amount')) : aWixBookingsServicesV2UpstreamWixCommonMoney({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('startInMinutes')) {
        result.startInMinutes = overrides && overrides.hasOwnProperty('startInMinutes') ? overrides.startInMinutes! : 1865;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindowInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindowInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aWixBookingsServicesV2UpstreamWixCommonMoneyInput(overrides.amount ?? {}, pickedFields.get('amount')) : aWixBookingsServicesV2UpstreamWixCommonMoneyInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('startInMinutes')) {
        result.startInMinutes = overrides && overrides.hasOwnProperty('startInMinutes') ? overrides.startInMinutes! : 7148;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoCollectFeeEnabled')) {
        result.autoCollectFeeEnabled = overrides && overrides.hasOwnProperty('autoCollectFeeEnabled') ? overrides.autoCollectFeeEnabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationWindows')) {
        result.cancellationWindows = overrides && overrides.hasOwnProperty('cancellationWindows') ? overrides.cancellationWindows!.map((x) => aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindowInput({}, pickedFields.get('cancellationWindows'))) : [aWixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindowInput({}, pickedFields.get('cancellationWindows'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicy = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestCancellationInMinutes')) {
        result.latestCancellationInMinutes = overrides && overrides.hasOwnProperty('latestCancellationInMinutes') ? overrides.latestCancellationInMinutes! : 4192;
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLatestCancellation')) {
        result.limitLatestCancellation = overrides && overrides.hasOwnProperty('limitLatestCancellation') ? overrides.limitLatestCancellation! : true;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestCancellationInMinutes')) {
        result.latestCancellationInMinutes = overrides && overrides.hasOwnProperty('latestCancellationInMinutes') ? overrides.latestCancellationInMinutes! : 3648;
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLatestCancellation')) {
        result.limitLatestCancellation = overrides && overrides.hasOwnProperty('limitLatestCancellation') ? overrides.limitLatestCancellation! : true;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicy = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('earliestBookingInMinutes')) {
        result.earliestBookingInMinutes = overrides && overrides.hasOwnProperty('earliestBookingInMinutes') ? overrides.earliestBookingInMinutes! : 464;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('earliestBookingInMinutes')) {
        result.earliestBookingInMinutes = overrides && overrides.hasOwnProperty('earliestBookingInMinutes') ? overrides.earliestBookingInMinutes! : 867;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicy = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestBookingInMinutes')) {
        result.latestBookingInMinutes = overrides && overrides.hasOwnProperty('latestBookingInMinutes') ? overrides.latestBookingInMinutes! : 1852;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestBookingInMinutes')) {
        result.latestBookingInMinutes = overrides && overrides.hasOwnProperty('latestBookingInMinutes') ? overrides.latestBookingInMinutes! : 3778;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicy = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxParticipantsPerBooking')) {
        result.maxParticipantsPerBooking = overrides && overrides.hasOwnProperty('maxParticipantsPerBooking') ? overrides.maxParticipantsPerBooking! : 1538;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxParticipantsPerBooking')) {
        result.maxParticipantsPerBooking = overrides && overrides.hasOwnProperty('maxParticipantsPerBooking') ? overrides.maxParticipantsPerBooking! : 5050;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1PolicyDescription = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1PolicyDescription>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1PolicyDescriptionInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1PolicyDescriptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicy = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestRescheduleInMinutes')) {
        result.latestRescheduleInMinutes = overrides && overrides.hasOwnProperty('latestRescheduleInMinutes') ? overrides.latestRescheduleInMinutes! : 1693;
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLatestReschedule')) {
        result.limitLatestReschedule = overrides && overrides.hasOwnProperty('limitLatestReschedule') ? overrides.limitLatestReschedule! : true;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestRescheduleInMinutes')) {
        result.latestRescheduleInMinutes = overrides && overrides.hasOwnProperty('latestRescheduleInMinutes') ? overrides.latestRescheduleInMinutes! : 6702;
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLatestReschedule')) {
        result.limitLatestReschedule = overrides && overrides.hasOwnProperty('limitLatestReschedule') ? overrides.limitLatestReschedule! : false;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicy = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoAssignAllowed')) {
        result.autoAssignAllowed = overrides && overrides.hasOwnProperty('autoAssignAllowed') ? overrides.autoAssignAllowed! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoAssignAllowed')) {
        result.autoAssignAllowed = overrides && overrides.hasOwnProperty('autoAssignAllowed') ? overrides.autoAssignAllowed! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicy = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicy = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('capacity')) {
        result.capacity = overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 817;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('reservationTimeInMinutes')) {
        result.reservationTimeInMinutes = overrides && overrides.hasOwnProperty('reservationTimeInMinutes') ? overrides.reservationTimeInMinutes! : 6886;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('capacity')) {
        result.capacity = overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 2280;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('reservationTimeInMinutes')) {
        result.reservationTimeInMinutes = overrides && overrides.hasOwnProperty('reservationTimeInMinutes') ? overrides.reservationTimeInMinutes! : 3743;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAddress = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixBookingsServicesV2UpstreamWixCommonAddressLocation(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixBookingsServicesV2UpstreamWixCommonAddressLocation({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixBookingsServicesV2UpstreamWixCommonStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixBookingsServicesV2UpstreamWixCommonStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'nulla';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAddressInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixBookingsServicesV2UpstreamWixCommonAddressLocationInput(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixBookingsServicesV2UpstreamWixCommonAddressLocationInput({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixBookingsServicesV2UpstreamWixCommonStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixBookingsServicesV2UpstreamWixCommonStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'sit';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAddressLocation = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAddressLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 6.13;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 5.56;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAddressLocationInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAddressLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 2.1;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 0.29;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationData = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResults(x ?? {}, pickedFields.get('results'))) : [aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResults({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResults = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('groupedByValue')) {
        result.groupedByValue = overrides && overrides.hasOwnProperty('groupedByValue') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults(overrides.groupedByValue ?? {}, pickedFields.get('groupedByValue')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults({}, pickedFields.get('groupedByValue'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('nested')) {
        result.nested = overrides && overrides.hasOwnProperty('nested') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResults(overrides.nested ?? {}, pickedFields.get('nested')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResults({}, pickedFields.get('nested'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ranges')) {
        result.ranges = overrides && overrides.hasOwnProperty('ranges') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults(overrides.ranges ?? {}, pickedFields.get('ranges')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults({}, pickedFields.get('ranges'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsServicesV2UpstreamWixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults(overrides.values ?? {}, pickedFields.get('values')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults({}, pickedFields.get('values'));
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult(x ?? {}, pickedFields.get('results'))) : [aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 6816;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'cum';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nestedResults')) {
        result.nestedResults = overrides && overrides.hasOwnProperty('nestedResults') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults(overrides.nestedResults ?? {}, pickedFields.get('nestedResults')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults({}, pickedFields.get('nestedResults'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'et';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('ranges')) {
        result.ranges = overrides && overrides.hasOwnProperty('ranges') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults(overrides.ranges ?? {}, pickedFields.get('ranges')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults({}, pickedFields.get('ranges'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsServicesV2UpstreamWixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults(overrides.values ?? {}, pickedFields.get('values')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults({}, pickedFields.get('values'));
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResults = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults(x ?? {}, pickedFields.get('results'))) : [aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult(overrides.range ?? {}, pickedFields.get('range')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult(overrides.value ?? {}, pickedFields.get('value')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 4475;
    }
    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 9.43;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 3.43;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue(overrides.results ?? {}, pickedFields.get('results')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue({}, pickedFields.get('results'));
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 3.39;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 1144;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'voluptas';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 18;
    }
    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 6.76;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 7.66;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsServicesV2UpstreamWixCommonScalarType.Avg;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 4.15;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 5192;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'similique';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInterval.Day;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationGroupByAggregationInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationGroupByAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aWixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('nested')) {
        result.nested = overrides && overrides.hasOwnProperty('nested') ? aWixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationInput(overrides.nested ?? {}, pickedFields.get('nested')) : aWixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationInput({}, pickedFields.get('nested'));
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput(overrides.range ?? {}, pickedFields.get('range')) : aWixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsServicesV2UpstreamWixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aWixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nestedAggregations')) {
        result.nestedAggregations = overrides && overrides.hasOwnProperty('nestedAggregations') ? overrides.nestedAggregations!.map((x) => aWixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput({}, pickedFields.get('nestedAggregations'))) : [aWixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput({}, pickedFields.get('nestedAggregations'))];
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput(overrides.range ?? {}, pickedFields.get('range')) : aWixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aWixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buckets')) {
        result.buckets = overrides && overrides.hasOwnProperty('buckets') ? overrides.buckets!.map((x) => aWixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationRangeBucketInput({}, pickedFields.get('buckets'))) : [aWixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationRangeBucketInput({}, pickedFields.get('buckets'))];
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 6.57;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 4.64;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixBookingsServicesV2UpstreamWixCommonScalarType.Avg;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addToBucket')) {
        result.addToBucket = overrides && overrides.hasOwnProperty('addToBucket') ? overrides.addToBucket! : 'totam';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includeOptions')) {
        result.includeOptions = overrides && overrides.hasOwnProperty('includeOptions') ? aWixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput(overrides.includeOptions ?? {}, pickedFields.get('includeOptions')) : aWixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput({}, pickedFields.get('includeOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 9272;
    }
    if (pickedFields.size === 0 || pickedFields.has('missingValues')) {
        result.missingValues = overrides && overrides.hasOwnProperty('missingValues') ? overrides.missingValues! : WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationMissingValues.Exclude;
    }
    if (pickedFields.size === 0 || pickedFields.has('sortDirection')) {
        result.sortDirection = overrides && overrides.hasOwnProperty('sortDirection') ? overrides.sortDirection! : WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationSortDirection.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('sortType')) {
        result.sortType = overrides && overrides.hasOwnProperty('sortType') ? overrides.sortType! : WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationSortType.Count;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonBulkActionMetadata = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonBulkActionMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalFailures')) {
        result.totalFailures = overrides && overrides.hasOwnProperty('totalFailures') ? overrides.totalFailures! : 5180;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalSuccesses')) {
        result.totalSuccesses = overrides && overrides.hasOwnProperty('totalSuccesses') ? overrides.totalSuccesses! : 3829;
    }
    if (pickedFields.size === 0 || pickedFields.has('undetailedFailures')) {
        result.undetailedFailures = overrides && overrides.hasOwnProperty('undetailedFailures') ? overrides.undetailedFailures! : 5844;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonCursorPagingInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 7123;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 6205;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixBookingsServicesV2UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixBookingsServicesV2UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonCursorQueryInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixBookingsServicesV2UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixBookingsServicesV2UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixBookingsServicesV2UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixBookingsServicesV2UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonCursorSearchInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonCursorSearchInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregations')) {
        result.aggregations = overrides && overrides.hasOwnProperty('aggregations') ? overrides.aggregations!.map((x) => aWixBookingsServicesV2UpstreamWixCommonAggregationInput({}, pickedFields.get('aggregations'))) : [aWixBookingsServicesV2UpstreamWixCommonAggregationInput({}, pickedFields.get('aggregations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixBookingsServicesV2UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixBookingsServicesV2UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aWixBookingsServicesV2UpstreamWixCommonSearchDetailsInput(overrides.search ?? {}, pickedFields.get('search')) : aWixBookingsServicesV2UpstreamWixCommonSearchDetailsInput({}, pickedFields.get('search'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixBookingsServicesV2UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixBookingsServicesV2UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'blanditiis';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonCursors = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'optio';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonImage = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 7970;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 6907;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonImageInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 9380;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 3202;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonItemMetadata = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonItemMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiApplicationError(overrides.error ?? {}, pickedFields.get('error')) : aWixApiApplicationError({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalIndex')) {
        result.originalIndex = overrides && overrides.hasOwnProperty('originalIndex') ? overrides.originalIndex! : 5111;
    }
    if (pickedFields.size === 0 || pickedFields.has('success')) {
        result.success = overrides && overrides.hasOwnProperty('success') ? overrides.success! : true;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonMoney = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonMoney>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedValue')) {
        result.formattedValue = overrides && overrides.hasOwnProperty('formattedValue') ? overrides.formattedValue! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'aut';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonMoneyInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonMoneyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedValue')) {
        result.formattedValue = overrides && overrides.hasOwnProperty('formattedValue') ? overrides.formattedValue! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'qui';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonPageUrlV2 = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonPageUrlV2>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('relativePath')) {
        result.relativePath = overrides && overrides.hasOwnProperty('relativePath') ? overrides.relativePath! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'laudantium';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonPageUrlV2Input = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonPageUrlV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('relativePath')) {
        result.relativePath = overrides && overrides.hasOwnProperty('relativePath') ? overrides.relativePath! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'quam';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonPagingInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 4834;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 355;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonPagingMetadataV2 = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonPagingMetadataV2>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 6215;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixBookingsServicesV2UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixBookingsServicesV2UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 5863;
    }
    if (pickedFields.size === 0 || pickedFields.has('tooManyToCount')) {
        result.tooManyToCount = overrides && overrides.hasOwnProperty('tooManyToCount') ? overrides.tooManyToCount! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 6377;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonQueryV2Input = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixBookingsServicesV2UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixBookingsServicesV2UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['animi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['nam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixBookingsServicesV2UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixBookingsServicesV2UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixBookingsServicesV2UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixBookingsServicesV2UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonSearchDetailsInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonSearchDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['enim'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fuzzy')) {
        result.fuzzy = overrides && overrides.hasOwnProperty('fuzzy') ? overrides.fuzzy! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('mode')) {
        result.mode = overrides && overrides.hasOwnProperty('mode') ? overrides.mode! : WixBookingsServicesV2UpstreamWixCommonSearchDetailsMode.And;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonSortingInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixBookingsServicesV2UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonStreetAddress = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonStreetAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'tenetur';
    }

    return result;
};

export const aWixBookingsServicesV2UpstreamWixCommonStreetAddressInput = <T extends Partial<WixBookingsServicesV2UpstreamWixCommonStreetAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'tenetur';
    }

    return result;
};

export const aWixBookingsServicesV2ValidateAddOnsSelectionRequestInput = <T extends Partial<WixBookingsServicesV2ValidateAddOnsSelectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addOnIds')) {
        result.addOnIds = overrides && overrides.hasOwnProperty('addOnIds') ? overrides.addOnIds! : ['dolores'];
    }
    if (pickedFields.size === 0 || pickedFields.has('groupId')) {
        result.groupId = overrides && overrides.hasOwnProperty('groupId') ? overrides.groupId! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'alias';
    }

    return result;
};

export const aWixBookingsServicesV2ValidateAddOnsSelectionResponse = <T extends Partial<WixBookingsServicesV2ValidateAddOnsSelectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('result')) {
        result.result = overrides && overrides.hasOwnProperty('result') ? aWixBookingsServicesV2ValidateAddOnsSelectionResponseValidationResult(overrides.result ?? {}, pickedFields.get('result')) : aWixBookingsServicesV2ValidateAddOnsSelectionResponseValidationResult({}, pickedFields.get('result'));
    }

    return result;
};

export const aWixBookingsServicesV2ValidateAddOnsSelectionResponseValidationResult = <T extends Partial<WixBookingsServicesV2ValidateAddOnsSelectionResponseValidationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('valid')) {
        result.valid = overrides && overrides.hasOwnProperty('valid') ? overrides.valid! : false;
    }

    return result;
};

export const aWixBookingsServicesV2ValidateServiceRequestInput = <T extends Partial<WixBookingsServicesV2ValidateServiceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('service')) {
        result.service = overrides && overrides.hasOwnProperty('service') ? aWixBookingsServicesV2ServiceInput(overrides.service ?? {}, pickedFields.get('service')) : aWixBookingsServicesV2ServiceInput({}, pickedFields.get('service'));
    }

    return result;
};

export const aWixBookingsServicesV2ValidateServiceResponse = <T extends Partial<WixBookingsServicesV2ValidateServiceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldViolations')) {
        result.fieldViolations = overrides && overrides.hasOwnProperty('fieldViolations') ? overrides.fieldViolations!.map((x) => aWixBookingsServicesV2FieldViolation(x ?? {}, pickedFields.get('fieldViolations'))) : [aWixBookingsServicesV2FieldViolation({}, pickedFields.get('fieldViolations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('valid')) {
        result.valid = overrides && overrides.hasOwnProperty('valid') ? overrides.valid! : true;
    }

    return result;
};

export const aWixBookingsServicesV2ValidateSlugRequestInput = <T extends Partial<WixBookingsServicesV2ValidateSlugRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('serviceId')) {
        result.serviceId = overrides && overrides.hasOwnProperty('serviceId') ? overrides.serviceId! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'consequuntur';
    }

    return result;
};

export const aWixBookingsServicesV2ValidateSlugResponse = <T extends Partial<WixBookingsServicesV2ValidateSlugResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errors')) {
        result.errors = overrides && overrides.hasOwnProperty('errors') ? overrides.errors! : [WixBookingsServicesV2InvalidSlugErrorEnumInvalidSlugError.SlugAlreadyExists];
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('slugName')) {
        result.slugName = overrides && overrides.hasOwnProperty('slugName') ? overrides.slugName! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('valid')) {
        result.valid = overrides && overrides.hasOwnProperty('valid') ? overrides.valid! : false;
    }

    return result;
};

export const aWixBookingsServicesV2VariedPayment = <T extends Partial<WixBookingsServicesV2VariedPayment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('defaultPrice')) {
        result.defaultPrice = overrides && overrides.hasOwnProperty('defaultPrice') ? aWixBookingsServicesV2UpstreamWixCommonMoney(overrides.defaultPrice ?? {}, pickedFields.get('defaultPrice')) : aWixBookingsServicesV2UpstreamWixCommonMoney({}, pickedFields.get('defaultPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deposit')) {
        result.deposit = overrides && overrides.hasOwnProperty('deposit') ? aWixBookingsServicesV2UpstreamWixCommonMoney(overrides.deposit ?? {}, pickedFields.get('deposit')) : aWixBookingsServicesV2UpstreamWixCommonMoney({}, pickedFields.get('deposit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maxPrice')) {
        result.maxPrice = overrides && overrides.hasOwnProperty('maxPrice') ? aWixBookingsServicesV2UpstreamWixCommonMoney(overrides.maxPrice ?? {}, pickedFields.get('maxPrice')) : aWixBookingsServicesV2UpstreamWixCommonMoney({}, pickedFields.get('maxPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('minPrice')) {
        result.minPrice = overrides && overrides.hasOwnProperty('minPrice') ? aWixBookingsServicesV2UpstreamWixCommonMoney(overrides.minPrice ?? {}, pickedFields.get('minPrice')) : aWixBookingsServicesV2UpstreamWixCommonMoney({}, pickedFields.get('minPrice'));
    }

    return result;
};

export const aWixBookingsServicesV2VariedPaymentInput = <T extends Partial<WixBookingsServicesV2VariedPaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('defaultPrice')) {
        result.defaultPrice = overrides && overrides.hasOwnProperty('defaultPrice') ? aWixBookingsServicesV2UpstreamWixCommonMoneyInput(overrides.defaultPrice ?? {}, pickedFields.get('defaultPrice')) : aWixBookingsServicesV2UpstreamWixCommonMoneyInput({}, pickedFields.get('defaultPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deposit')) {
        result.deposit = overrides && overrides.hasOwnProperty('deposit') ? aWixBookingsServicesV2UpstreamWixCommonMoneyInput(overrides.deposit ?? {}, pickedFields.get('deposit')) : aWixBookingsServicesV2UpstreamWixCommonMoneyInput({}, pickedFields.get('deposit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maxPrice')) {
        result.maxPrice = overrides && overrides.hasOwnProperty('maxPrice') ? aWixBookingsServicesV2UpstreamWixCommonMoneyInput(overrides.maxPrice ?? {}, pickedFields.get('maxPrice')) : aWixBookingsServicesV2UpstreamWixCommonMoneyInput({}, pickedFields.get('maxPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('minPrice')) {
        result.minPrice = overrides && overrides.hasOwnProperty('minPrice') ? aWixBookingsServicesV2UpstreamWixCommonMoneyInput(overrides.minPrice ?? {}, pickedFields.get('minPrice')) : aWixBookingsServicesV2UpstreamWixCommonMoneyInput({}, pickedFields.get('minPrice'));
    }

    return result;
};

export const aWixBookingsStaffV1AssignBusinessScheduleRequestInput = <T extends Partial<WixBookingsStaffV1AssignBusinessScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'deleniti';
    }

    return result;
};

export const aWixBookingsStaffV1AssignBusinessScheduleResponse = <T extends Partial<WixBookingsStaffV1AssignBusinessScheduleResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMember(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMember({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1AssignCustomScheduleRequestInput = <T extends Partial<WixBookingsStaffV1AssignCustomScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'unde';
    }

    return result;
};

export const aWixBookingsStaffV1AssignCustomScheduleResponse = <T extends Partial<WixBookingsStaffV1AssignCustomScheduleResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMember(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMember({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1AssociatedConferencingProvider = <T extends Partial<WixBookingsStaffV1AssociatedConferencingProvider>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accountEmail')) {
        result.accountEmail = overrides && overrides.hasOwnProperty('accountEmail') ? overrides.accountEmail! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('connectionStatus')) {
        result.connectionStatus = overrides && overrides.hasOwnProperty('connectionStatus') ? overrides.connectionStatus! : WixBookingsStaffV1AssociatedConferencingProviderConnectionStatusStatusEnumConnectionStatus.Connected;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ducimus';
    }

    return result;
};

export const aWixBookingsStaffV1AssociatedConferencingProviderInput = <T extends Partial<WixBookingsStaffV1AssociatedConferencingProviderInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accountEmail')) {
        result.accountEmail = overrides && overrides.hasOwnProperty('accountEmail') ? overrides.accountEmail! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('connectionStatus')) {
        result.connectionStatus = overrides && overrides.hasOwnProperty('connectionStatus') ? overrides.connectionStatus! : WixBookingsStaffV1AssociatedConferencingProviderConnectionStatusStatusEnumConnectionStatus.Connected;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'voluptate';
    }

    return result;
};

export const aWixBookingsStaffV1AssociatedConferencingProviders = <T extends Partial<WixBookingsStaffV1AssociatedConferencingProviders>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixBookingsStaffV1AssociatedConferencingProvider(x ?? {}, pickedFields.get('items'))) : [aWixBookingsStaffV1AssociatedConferencingProvider({}, pickedFields.get('items'))];
    }

    return result;
};

export const aWixBookingsStaffV1AssociatedConferencingProvidersInput = <T extends Partial<WixBookingsStaffV1AssociatedConferencingProvidersInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixBookingsStaffV1AssociatedConferencingProviderInput({}, pickedFields.get('items'))) : [aWixBookingsStaffV1AssociatedConferencingProviderInput({}, pickedFields.get('items'))];
    }

    return result;
};

export const aWixBookingsStaffV1AssociatedWixIdentity = <T extends Partial<WixBookingsStaffV1AssociatedWixIdentity>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('connectionStatus')) {
        result.connectionStatus = overrides && overrides.hasOwnProperty('connectionStatus') ? overrides.connectionStatus! : WixBookingsStaffV1AssociatedWixIdentityConnectionStatusEnumConnectionStatus.Connected;
    }
    if (pickedFields.size === 0 || pickedFields.has('identificationData')) {
        result.identificationData = overrides && overrides.hasOwnProperty('identificationData') ? aWixBookingsStaffV1UpstreamWixCommonIdentificationData(overrides.identificationData ?? {}, pickedFields.get('identificationData')) : aWixBookingsStaffV1UpstreamWixCommonIdentificationData({}, pickedFields.get('identificationData'));
    }

    return result;
};

export const aWixBookingsStaffV1AssociatedWixIdentityInput = <T extends Partial<WixBookingsStaffV1AssociatedWixIdentityInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('connectionStatus')) {
        result.connectionStatus = overrides && overrides.hasOwnProperty('connectionStatus') ? overrides.connectionStatus! : WixBookingsStaffV1AssociatedWixIdentityConnectionStatusEnumConnectionStatus.Connected;
    }
    if (pickedFields.size === 0 || pickedFields.has('identificationData')) {
        result.identificationData = overrides && overrides.hasOwnProperty('identificationData') ? aWixBookingsStaffV1UpstreamWixCommonIdentificationDataInput(overrides.identificationData ?? {}, pickedFields.get('identificationData')) : aWixBookingsStaffV1UpstreamWixCommonIdentificationDataInput({}, pickedFields.get('identificationData'));
    }

    return result;
};

export const aWixBookingsStaffV1ConnectStaffMemberToUserRequestInput = <T extends Partial<WixBookingsStaffV1ConnectStaffMemberToUserRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'perspiciatis';
    }

    return result;
};

export const aWixBookingsStaffV1ConnectStaffMemberToUserResponse = <T extends Partial<WixBookingsStaffV1ConnectStaffMemberToUserResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMember(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMember({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1ConnectToUserRequestInput = <T extends Partial<WixBookingsStaffV1ConnectToUserRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'mollitia';
    }

    return result;
};

export const aWixBookingsStaffV1ConnectToUserResponse = <T extends Partial<WixBookingsStaffV1ConnectToUserResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMember(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMember({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1CountStaffMembersRequestInput = <T extends Partial<WixBookingsStaffV1CountStaffMembersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'magnam';
    }

    return result;
};

export const aWixBookingsStaffV1CountStaffMembersResponse = <T extends Partial<WixBookingsStaffV1CountStaffMembersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 4008;
    }

    return result;
};

export const aWixBookingsStaffV1CreateStaffMemberRequestInput = <T extends Partial<WixBookingsStaffV1CreateStaffMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMemberInput(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMemberInput({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1CreateStaffMemberResponse = <T extends Partial<WixBookingsStaffV1CreateStaffMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMember(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMember({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1DeleteStaffMemberRequestInput = <T extends Partial<WixBookingsStaffV1DeleteStaffMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'et';
    }

    return result;
};

export const aWixBookingsStaffV1DisconnectStaffMemberFromUserRequestInput = <T extends Partial<WixBookingsStaffV1DisconnectStaffMemberFromUserRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'iste';
    }

    return result;
};

export const aWixBookingsStaffV1DisconnectStaffMemberFromUserResponse = <T extends Partial<WixBookingsStaffV1DisconnectStaffMemberFromUserResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMember(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMember({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1DisconnectUserRequestInput = <T extends Partial<WixBookingsStaffV1DisconnectUserRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'sint';
    }

    return result;
};

export const aWixBookingsStaffV1DisconnectUserResponse = <T extends Partial<WixBookingsStaffV1DisconnectUserResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMember(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMember({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1EventSchedule = <T extends Partial<WixBookingsStaffV1EventSchedule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixCalendarSchedulesV3Schedule(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixCalendarSchedulesV3Schedule({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aWixBookingsStaffV1EventScheduleInput = <T extends Partial<WixBookingsStaffV1EventScheduleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'molestias';
    }

    return result;
};

export const aWixBookingsStaffV1GetStaffMemberRequestInput = <T extends Partial<WixBookingsStaffV1GetStaffMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '5085610e-fff7-4f86-b25a-14d6980bf1f8';
    }

    return result;
};

export const aWixBookingsStaffV1ImportStaffMemberRequestInput = <T extends Partial<WixBookingsStaffV1ImportStaffMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMemberInput(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMemberInput({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1ImportStaffMemberResponse = <T extends Partial<WixBookingsStaffV1ImportStaffMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMember(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMember({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1MediaItem = <T extends Partial<WixBookingsStaffV1MediaItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixBookingsStaffV1UpstreamWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixBookingsStaffV1UpstreamWixCommonImage({}, pickedFields.get('image'));
    }

    return result;
};

export const aWixBookingsStaffV1MediaItemInput = <T extends Partial<WixBookingsStaffV1MediaItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixBookingsStaffV1UpstreamWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixBookingsStaffV1UpstreamWixCommonImageInput({}, pickedFields.get('image'));
    }

    return result;
};

export const aWixBookingsStaffV1QueryStaffMembersRequestInput = <T extends Partial<WixBookingsStaffV1QueryStaffMembersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixBookingsStaffV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixBookingsStaffV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixBookingsStaffV1QueryStaffMembersResponse = <T extends Partial<WixBookingsStaffV1QueryStaffMembersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixBookingsStaffV1StaffMember(x ?? {}, pickedFields.get('items'))) : [aWixBookingsStaffV1StaffMember({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixBookingsStaffV1Resource = <T extends Partial<WixBookingsStaffV1Resource>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventsSchedule')) {
        result.eventsSchedule = overrides && overrides.hasOwnProperty('eventsSchedule') ? aWixBookingsStaffV1EventSchedule(overrides.eventsSchedule ?? {}, pickedFields.get('eventsSchedule')) : aWixBookingsStaffV1EventSchedule({}, pickedFields.get('eventsSchedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('usesDefaultWorkingHours')) {
        result.usesDefaultWorkingHours = overrides && overrides.hasOwnProperty('usesDefaultWorkingHours') ? overrides.usesDefaultWorkingHours! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('workingHoursSchedules')) {
        result.workingHoursSchedules = overrides && overrides.hasOwnProperty('workingHoursSchedules') ? overrides.workingHoursSchedules!.map((x) => aWixBookingsStaffV1WorkingHoursSchedule(x ?? {}, pickedFields.get('workingHoursSchedules'))) : [aWixBookingsStaffV1WorkingHoursSchedule({}, pickedFields.get('workingHoursSchedules'))];
    }

    return result;
};

export const aWixBookingsStaffV1ResourceInput = <T extends Partial<WixBookingsStaffV1ResourceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventsSchedule')) {
        result.eventsSchedule = overrides && overrides.hasOwnProperty('eventsSchedule') ? aWixBookingsStaffV1EventScheduleInput(overrides.eventsSchedule ?? {}, pickedFields.get('eventsSchedule')) : aWixBookingsStaffV1EventScheduleInput({}, pickedFields.get('eventsSchedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quae';
    }
    if (pickedFields.size === 0 || pickedFields.has('usesDefaultWorkingHours')) {
        result.usesDefaultWorkingHours = overrides && overrides.hasOwnProperty('usesDefaultWorkingHours') ? overrides.usesDefaultWorkingHours! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('workingHoursSchedules')) {
        result.workingHoursSchedules = overrides && overrides.hasOwnProperty('workingHoursSchedules') ? overrides.workingHoursSchedules!.map((x) => aWixBookingsStaffV1WorkingHoursScheduleInput({}, pickedFields.get('workingHoursSchedules'))) : [aWixBookingsStaffV1WorkingHoursScheduleInput({}, pickedFields.get('workingHoursSchedules'))];
    }

    return result;
};

export const aWixBookingsStaffV1RestoreStaffRequestInput = <T extends Partial<WixBookingsStaffV1RestoreStaffRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMemberId')) {
        result.staffMemberId = overrides && overrides.hasOwnProperty('staffMemberId') ? overrides.staffMemberId! : 'voluptatem';
    }

    return result;
};

export const aWixBookingsStaffV1RestoreStaffResponse = <T extends Partial<WixBookingsStaffV1RestoreStaffResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMember(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMember({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1StaffMember = <T extends Partial<WixBookingsStaffV1StaffMember>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('associatedConferencingProviders')) {
        result.associatedConferencingProviders = overrides && overrides.hasOwnProperty('associatedConferencingProviders') ? aWixBookingsStaffV1AssociatedConferencingProviders(overrides.associatedConferencingProviders ?? {}, pickedFields.get('associatedConferencingProviders')) : aWixBookingsStaffV1AssociatedConferencingProviders({}, pickedFields.get('associatedConferencingProviders'));
    }
    if (pickedFields.size === 0 || pickedFields.has('associatedWixIdentity')) {
        result.associatedWixIdentity = overrides && overrides.hasOwnProperty('associatedWixIdentity') ? aWixBookingsStaffV1AssociatedWixIdentity(overrides.associatedWixIdentity ?? {}, pickedFields.get('associatedWixIdentity')) : aWixBookingsStaffV1AssociatedWixIdentity({}, pickedFields.get('associatedWixIdentity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('mainMedia')) {
        result.mainMedia = overrides && overrides.hasOwnProperty('mainMedia') ? aWixBookingsStaffV1MediaItem(overrides.mainMedia ?? {}, pickedFields.get('mainMedia')) : aWixBookingsStaffV1MediaItem({}, pickedFields.get('mainMedia'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('resource')) {
        result.resource = overrides && overrides.hasOwnProperty('resource') ? aWixBookingsStaffV1Resource(overrides.resource ?? {}, pickedFields.get('resource')) : aWixBookingsStaffV1Resource({}, pickedFields.get('resource'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceId')) {
        result.resourceId = overrides && overrides.hasOwnProperty('resourceId') ? overrides.resourceId! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 1259;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'id';
    }

    return result;
};

export const aWixBookingsStaffV1StaffMemberInput = <T extends Partial<WixBookingsStaffV1StaffMemberInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('associatedConferencingProviders')) {
        result.associatedConferencingProviders = overrides && overrides.hasOwnProperty('associatedConferencingProviders') ? aWixBookingsStaffV1AssociatedConferencingProvidersInput(overrides.associatedConferencingProviders ?? {}, pickedFields.get('associatedConferencingProviders')) : aWixBookingsStaffV1AssociatedConferencingProvidersInput({}, pickedFields.get('associatedConferencingProviders'));
    }
    if (pickedFields.size === 0 || pickedFields.has('associatedWixIdentity')) {
        result.associatedWixIdentity = overrides && overrides.hasOwnProperty('associatedWixIdentity') ? aWixBookingsStaffV1AssociatedWixIdentityInput(overrides.associatedWixIdentity ?? {}, pickedFields.get('associatedWixIdentity')) : aWixBookingsStaffV1AssociatedWixIdentityInput({}, pickedFields.get('associatedWixIdentity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('mainMedia')) {
        result.mainMedia = overrides && overrides.hasOwnProperty('mainMedia') ? aWixBookingsStaffV1MediaItemInput(overrides.mainMedia ?? {}, pickedFields.get('mainMedia')) : aWixBookingsStaffV1MediaItemInput({}, pickedFields.get('mainMedia'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('resource')) {
        result.resource = overrides && overrides.hasOwnProperty('resource') ? aWixBookingsStaffV1ResourceInput(overrides.resource ?? {}, pickedFields.get('resource')) : aWixBookingsStaffV1ResourceInput({}, pickedFields.get('resource'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resourceId')) {
        result.resourceId = overrides && overrides.hasOwnProperty('resourceId') ? overrides.resourceId! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 417;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'necessitatibus';
    }

    return result;
};

export const aWixBookingsStaffV1UpdateStaffMemberRequestInput = <T extends Partial<WixBookingsStaffV1UpdateStaffMemberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['voluptas'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixBookingsStaffV1RequestedFieldsEnumRequestedFields.AssociatedConferencingProviders];
    }
    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMemberInput(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMemberInput({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1UpdateStaffMemberResponse = <T extends Partial<WixBookingsStaffV1UpdateStaffMemberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('staffMember')) {
        result.staffMember = overrides && overrides.hasOwnProperty('staffMember') ? aWixBookingsStaffV1StaffMember(overrides.staffMember ?? {}, pickedFields.get('staffMember')) : aWixBookingsStaffV1StaffMember({}, pickedFields.get('staffMember'));
    }

    return result;
};

export const aWixBookingsStaffV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixBookingsStaffV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2878;
    }

    return result;
};

export const aWixBookingsStaffV1UpstreamWixCommonCursorQueryInput = <T extends Partial<WixBookingsStaffV1UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixBookingsStaffV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixBookingsStaffV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixBookingsStaffV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixBookingsStaffV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixBookingsStaffV1UpstreamWixCommonIdentificationData = <T extends Partial<WixBookingsStaffV1UpstreamWixCommonIdentificationData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('anonymousVisitorId')) {
        result.anonymousVisitorId = overrides && overrides.hasOwnProperty('anonymousVisitorId') ? overrides.anonymousVisitorId! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('identityType')) {
        result.identityType = overrides && overrides.hasOwnProperty('identityType') ? overrides.identityType! : WixBookingsStaffV1UpstreamWixCommonIdentificationDataIdentityType.AnonymousVisitor;
    }
    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixUserId')) {
        result.wixUserId = overrides && overrides.hasOwnProperty('wixUserId') ? overrides.wixUserId! : 'iure';
    }

    return result;
};

export const aWixBookingsStaffV1UpstreamWixCommonIdentificationDataInput = <T extends Partial<WixBookingsStaffV1UpstreamWixCommonIdentificationDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('anonymousVisitorId')) {
        result.anonymousVisitorId = overrides && overrides.hasOwnProperty('anonymousVisitorId') ? overrides.anonymousVisitorId! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('identityType')) {
        result.identityType = overrides && overrides.hasOwnProperty('identityType') ? overrides.identityType! : WixBookingsStaffV1UpstreamWixCommonIdentificationDataIdentityType.AnonymousVisitor;
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixUserId')) {
        result.wixUserId = overrides && overrides.hasOwnProperty('wixUserId') ? overrides.wixUserId! : 'voluptatem';
    }

    return result;
};

export const aWixBookingsStaffV1UpstreamWixCommonImage = <T extends Partial<WixBookingsStaffV1UpstreamWixCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 5315;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 2975;
    }

    return result;
};

export const aWixBookingsStaffV1UpstreamWixCommonImageInput = <T extends Partial<WixBookingsStaffV1UpstreamWixCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 3316;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 6276;
    }

    return result;
};

export const aWixBookingsStaffV1UpstreamWixCommonSortingInput = <T extends Partial<WixBookingsStaffV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixBookingsStaffV1UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixBookingsStaffV1WorkingHoursSchedule = <T extends Partial<WixBookingsStaffV1WorkingHoursSchedule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixCalendarSchedulesV3Schedule(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixCalendarSchedulesV3Schedule({}, pickedFields.get('schedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shared')) {
        result.shared = overrides && overrides.hasOwnProperty('shared') ? overrides.shared! : true;
    }

    return result;
};

export const aWixBookingsStaffV1WorkingHoursScheduleInput = <T extends Partial<WixBookingsStaffV1WorkingHoursScheduleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('shared')) {
        result.shared = overrides && overrides.hasOwnProperty('shared') ? overrides.shared! : false;
    }

    return result;
};

export const aWixBookingsV1BookAfterStartPolicy = <T extends Partial<WixBookingsV1BookAfterStartPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsV1BookAfterStartPolicyInput = <T extends Partial<WixBookingsV1BookAfterStartPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixBookingsV1BookingPolicy = <T extends Partial<WixBookingsV1BookingPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('bookAfterStartPolicy')) {
        result.bookAfterStartPolicy = overrides && overrides.hasOwnProperty('bookAfterStartPolicy') ? aWixBookingsV1BookAfterStartPolicy(overrides.bookAfterStartPolicy ?? {}, pickedFields.get('bookAfterStartPolicy')) : aWixBookingsV1BookAfterStartPolicy({}, pickedFields.get('bookAfterStartPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationFeePolicy')) {
        result.cancellationFeePolicy = overrides && overrides.hasOwnProperty('cancellationFeePolicy') ? aWixBookingsV1CancellationFeePolicy(overrides.cancellationFeePolicy ?? {}, pickedFields.get('cancellationFeePolicy')) : aWixBookingsV1CancellationFeePolicy({}, pickedFields.get('cancellationFeePolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationPolicy')) {
        result.cancellationPolicy = overrides && overrides.hasOwnProperty('cancellationPolicy') ? aWixBookingsV1CancellationPolicy(overrides.cancellationPolicy ?? {}, pickedFields.get('cancellationPolicy')) : aWixBookingsV1CancellationPolicy({}, pickedFields.get('cancellationPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('customPolicyDescription')) {
        result.customPolicyDescription = overrides && overrides.hasOwnProperty('customPolicyDescription') ? aWixBookingsV1PolicyDescription(overrides.customPolicyDescription ?? {}, pickedFields.get('customPolicyDescription')) : aWixBookingsV1PolicyDescription({}, pickedFields.get('customPolicyDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('limitEarlyBookingPolicy')) {
        result.limitEarlyBookingPolicy = overrides && overrides.hasOwnProperty('limitEarlyBookingPolicy') ? aWixBookingsV1LimitEarlyBookingPolicy(overrides.limitEarlyBookingPolicy ?? {}, pickedFields.get('limitEarlyBookingPolicy')) : aWixBookingsV1LimitEarlyBookingPolicy({}, pickedFields.get('limitEarlyBookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLateBookingPolicy')) {
        result.limitLateBookingPolicy = overrides && overrides.hasOwnProperty('limitLateBookingPolicy') ? aWixBookingsV1LimitLateBookingPolicy(overrides.limitLateBookingPolicy ?? {}, pickedFields.get('limitLateBookingPolicy')) : aWixBookingsV1LimitLateBookingPolicy({}, pickedFields.get('limitLateBookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantsPolicy')) {
        result.participantsPolicy = overrides && overrides.hasOwnProperty('participantsPolicy') ? aWixBookingsV1ParticipantsPolicy(overrides.participantsPolicy ?? {}, pickedFields.get('participantsPolicy')) : aWixBookingsV1ParticipantsPolicy({}, pickedFields.get('participantsPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('reschedulePolicy')) {
        result.reschedulePolicy = overrides && overrides.hasOwnProperty('reschedulePolicy') ? aWixBookingsV1ReschedulePolicy(overrides.reschedulePolicy ?? {}, pickedFields.get('reschedulePolicy')) : aWixBookingsV1ReschedulePolicy({}, pickedFields.get('reschedulePolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resourcesPolicy')) {
        result.resourcesPolicy = overrides && overrides.hasOwnProperty('resourcesPolicy') ? aWixBookingsV1ResourcesPolicy(overrides.resourcesPolicy ?? {}, pickedFields.get('resourcesPolicy')) : aWixBookingsV1ResourcesPolicy({}, pickedFields.get('resourcesPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('saveCreditCardPolicy')) {
        result.saveCreditCardPolicy = overrides && overrides.hasOwnProperty('saveCreditCardPolicy') ? aWixBookingsV1SaveCreditCardPolicy(overrides.saveCreditCardPolicy ?? {}, pickedFields.get('saveCreditCardPolicy')) : aWixBookingsV1SaveCreditCardPolicy({}, pickedFields.get('saveCreditCardPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('waitlistPolicy')) {
        result.waitlistPolicy = overrides && overrides.hasOwnProperty('waitlistPolicy') ? aWixBookingsV1WaitlistPolicy(overrides.waitlistPolicy ?? {}, pickedFields.get('waitlistPolicy')) : aWixBookingsV1WaitlistPolicy({}, pickedFields.get('waitlistPolicy'));
    }

    return result;
};

export const aWixBookingsV1BookingPolicyInput = <T extends Partial<WixBookingsV1BookingPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('bookAfterStartPolicy')) {
        result.bookAfterStartPolicy = overrides && overrides.hasOwnProperty('bookAfterStartPolicy') ? aWixBookingsV1BookAfterStartPolicyInput(overrides.bookAfterStartPolicy ?? {}, pickedFields.get('bookAfterStartPolicy')) : aWixBookingsV1BookAfterStartPolicyInput({}, pickedFields.get('bookAfterStartPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationFeePolicy')) {
        result.cancellationFeePolicy = overrides && overrides.hasOwnProperty('cancellationFeePolicy') ? aWixBookingsV1CancellationFeePolicyInput(overrides.cancellationFeePolicy ?? {}, pickedFields.get('cancellationFeePolicy')) : aWixBookingsV1CancellationFeePolicyInput({}, pickedFields.get('cancellationFeePolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationPolicy')) {
        result.cancellationPolicy = overrides && overrides.hasOwnProperty('cancellationPolicy') ? aWixBookingsV1CancellationPolicyInput(overrides.cancellationPolicy ?? {}, pickedFields.get('cancellationPolicy')) : aWixBookingsV1CancellationPolicyInput({}, pickedFields.get('cancellationPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('customPolicyDescription')) {
        result.customPolicyDescription = overrides && overrides.hasOwnProperty('customPolicyDescription') ? aWixBookingsV1PolicyDescriptionInput(overrides.customPolicyDescription ?? {}, pickedFields.get('customPolicyDescription')) : aWixBookingsV1PolicyDescriptionInput({}, pickedFields.get('customPolicyDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('limitEarlyBookingPolicy')) {
        result.limitEarlyBookingPolicy = overrides && overrides.hasOwnProperty('limitEarlyBookingPolicy') ? aWixBookingsV1LimitEarlyBookingPolicyInput(overrides.limitEarlyBookingPolicy ?? {}, pickedFields.get('limitEarlyBookingPolicy')) : aWixBookingsV1LimitEarlyBookingPolicyInput({}, pickedFields.get('limitEarlyBookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLateBookingPolicy')) {
        result.limitLateBookingPolicy = overrides && overrides.hasOwnProperty('limitLateBookingPolicy') ? aWixBookingsV1LimitLateBookingPolicyInput(overrides.limitLateBookingPolicy ?? {}, pickedFields.get('limitLateBookingPolicy')) : aWixBookingsV1LimitLateBookingPolicyInput({}, pickedFields.get('limitLateBookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantsPolicy')) {
        result.participantsPolicy = overrides && overrides.hasOwnProperty('participantsPolicy') ? aWixBookingsV1ParticipantsPolicyInput(overrides.participantsPolicy ?? {}, pickedFields.get('participantsPolicy')) : aWixBookingsV1ParticipantsPolicyInput({}, pickedFields.get('participantsPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('reschedulePolicy')) {
        result.reschedulePolicy = overrides && overrides.hasOwnProperty('reschedulePolicy') ? aWixBookingsV1ReschedulePolicyInput(overrides.reschedulePolicy ?? {}, pickedFields.get('reschedulePolicy')) : aWixBookingsV1ReschedulePolicyInput({}, pickedFields.get('reschedulePolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resourcesPolicy')) {
        result.resourcesPolicy = overrides && overrides.hasOwnProperty('resourcesPolicy') ? aWixBookingsV1ResourcesPolicyInput(overrides.resourcesPolicy ?? {}, pickedFields.get('resourcesPolicy')) : aWixBookingsV1ResourcesPolicyInput({}, pickedFields.get('resourcesPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'expedita';
    }
    if (pickedFields.size === 0 || pickedFields.has('saveCreditCardPolicy')) {
        result.saveCreditCardPolicy = overrides && overrides.hasOwnProperty('saveCreditCardPolicy') ? aWixBookingsV1SaveCreditCardPolicyInput(overrides.saveCreditCardPolicy ?? {}, pickedFields.get('saveCreditCardPolicy')) : aWixBookingsV1SaveCreditCardPolicyInput({}, pickedFields.get('saveCreditCardPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('waitlistPolicy')) {
        result.waitlistPolicy = overrides && overrides.hasOwnProperty('waitlistPolicy') ? aWixBookingsV1WaitlistPolicyInput(overrides.waitlistPolicy ?? {}, pickedFields.get('waitlistPolicy')) : aWixBookingsV1WaitlistPolicyInput({}, pickedFields.get('waitlistPolicy'));
    }

    return result;
};

export const aWixBookingsV1CancellationFeePolicy = <T extends Partial<WixBookingsV1CancellationFeePolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoCollectFeeEnabled')) {
        result.autoCollectFeeEnabled = overrides && overrides.hasOwnProperty('autoCollectFeeEnabled') ? overrides.autoCollectFeeEnabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationWindows')) {
        result.cancellationWindows = overrides && overrides.hasOwnProperty('cancellationWindows') ? overrides.cancellationWindows!.map((x) => aWixBookingsV1CancellationFeePolicyCancellationWindow(x ?? {}, pickedFields.get('cancellationWindows'))) : [aWixBookingsV1CancellationFeePolicyCancellationWindow({}, pickedFields.get('cancellationWindows'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsV1CancellationFeePolicyCancellationWindow = <T extends Partial<WixBookingsV1CancellationFeePolicyCancellationWindow>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aWixBookingsV1UpstreamWixCommonMoney(overrides.amount ?? {}, pickedFields.get('amount')) : aWixBookingsV1UpstreamWixCommonMoney({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('startInMinutes')) {
        result.startInMinutes = overrides && overrides.hasOwnProperty('startInMinutes') ? overrides.startInMinutes! : 3323;
    }

    return result;
};

export const aWixBookingsV1CancellationFeePolicyCancellationWindowInput = <T extends Partial<WixBookingsV1CancellationFeePolicyCancellationWindowInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aWixBookingsV1UpstreamWixCommonMoneyInput(overrides.amount ?? {}, pickedFields.get('amount')) : aWixBookingsV1UpstreamWixCommonMoneyInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? overrides.percentage! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('startInMinutes')) {
        result.startInMinutes = overrides && overrides.hasOwnProperty('startInMinutes') ? overrides.startInMinutes! : 7549;
    }

    return result;
};

export const aWixBookingsV1CancellationFeePolicyInput = <T extends Partial<WixBookingsV1CancellationFeePolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoCollectFeeEnabled')) {
        result.autoCollectFeeEnabled = overrides && overrides.hasOwnProperty('autoCollectFeeEnabled') ? overrides.autoCollectFeeEnabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('cancellationWindows')) {
        result.cancellationWindows = overrides && overrides.hasOwnProperty('cancellationWindows') ? overrides.cancellationWindows!.map((x) => aWixBookingsV1CancellationFeePolicyCancellationWindowInput({}, pickedFields.get('cancellationWindows'))) : [aWixBookingsV1CancellationFeePolicyCancellationWindowInput({}, pickedFields.get('cancellationWindows'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixBookingsV1CancellationPolicy = <T extends Partial<WixBookingsV1CancellationPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestCancellationInMinutes')) {
        result.latestCancellationInMinutes = overrides && overrides.hasOwnProperty('latestCancellationInMinutes') ? overrides.latestCancellationInMinutes! : 2838;
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLatestCancellation')) {
        result.limitLatestCancellation = overrides && overrides.hasOwnProperty('limitLatestCancellation') ? overrides.limitLatestCancellation! : false;
    }

    return result;
};

export const aWixBookingsV1CancellationPolicyInput = <T extends Partial<WixBookingsV1CancellationPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestCancellationInMinutes')) {
        result.latestCancellationInMinutes = overrides && overrides.hasOwnProperty('latestCancellationInMinutes') ? overrides.latestCancellationInMinutes! : 2395;
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLatestCancellation')) {
        result.limitLatestCancellation = overrides && overrides.hasOwnProperty('limitLatestCancellation') ? overrides.limitLatestCancellation! : true;
    }

    return result;
};

export const aWixBookingsV1CountBookingPoliciesRequestInput = <T extends Partial<WixBookingsV1CountBookingPoliciesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'numquam';
    }

    return result;
};

export const aWixBookingsV1CountBookingPoliciesResponse = <T extends Partial<WixBookingsV1CountBookingPoliciesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 4640;
    }

    return result;
};

export const aWixBookingsV1CreateBookingPolicyRequestInput = <T extends Partial<WixBookingsV1CreateBookingPolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicy')) {
        result.bookingPolicy = overrides && overrides.hasOwnProperty('bookingPolicy') ? aWixBookingsV1BookingPolicyInput(overrides.bookingPolicy ?? {}, pickedFields.get('bookingPolicy')) : aWixBookingsV1BookingPolicyInput({}, pickedFields.get('bookingPolicy'));
    }

    return result;
};

export const aWixBookingsV1CreateBookingPolicyResponse = <T extends Partial<WixBookingsV1CreateBookingPolicyResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicy')) {
        result.bookingPolicy = overrides && overrides.hasOwnProperty('bookingPolicy') ? aWixBookingsV1BookingPolicy(overrides.bookingPolicy ?? {}, pickedFields.get('bookingPolicy')) : aWixBookingsV1BookingPolicy({}, pickedFields.get('bookingPolicy'));
    }

    return result;
};

export const aWixBookingsV1CreateMissingDefaultPolicyResponse = <T extends Partial<WixBookingsV1CreateMissingDefaultPolicyResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('defaultBookingPolicy')) {
        result.defaultBookingPolicy = overrides && overrides.hasOwnProperty('defaultBookingPolicy') ? aWixBookingsV1BookingPolicy(overrides.defaultBookingPolicy ?? {}, pickedFields.get('defaultBookingPolicy')) : aWixBookingsV1BookingPolicy({}, pickedFields.get('defaultBookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('wasANewPolicyCreated')) {
        result.wasANewPolicyCreated = overrides && overrides.hasOwnProperty('wasANewPolicyCreated') ? overrides.wasANewPolicyCreated! : true;
    }

    return result;
};

export const aWixBookingsV1DeleteBookingPolicyRequestInput = <T extends Partial<WixBookingsV1DeleteBookingPolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicyId')) {
        result.bookingPolicyId = overrides && overrides.hasOwnProperty('bookingPolicyId') ? overrides.bookingPolicyId! : 'exercitationem';
    }

    return result;
};

export const aWixBookingsV1GetBookingPolicyRequestInput = <T extends Partial<WixBookingsV1GetBookingPolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7ade35ca-90b2-4879-9f51-5c8af57219d7';
    }

    return result;
};

export const aWixBookingsV1GetStrictestBookingPolicyRequestInput = <T extends Partial<WixBookingsV1GetStrictestBookingPolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicyIds')) {
        result.bookingPolicyIds = overrides && overrides.hasOwnProperty('bookingPolicyIds') ? overrides.bookingPolicyIds! : ['ducimus'];
    }

    return result;
};

export const aWixBookingsV1GetStrictestBookingPolicyResponse = <T extends Partial<WixBookingsV1GetStrictestBookingPolicyResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicy')) {
        result.bookingPolicy = overrides && overrides.hasOwnProperty('bookingPolicy') ? aWixBookingsV1BookingPolicy(overrides.bookingPolicy ?? {}, pickedFields.get('bookingPolicy')) : aWixBookingsV1BookingPolicy({}, pickedFields.get('bookingPolicy'));
    }

    return result;
};

export const aWixBookingsV1LimitEarlyBookingPolicy = <T extends Partial<WixBookingsV1LimitEarlyBookingPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('earliestBookingInMinutes')) {
        result.earliestBookingInMinutes = overrides && overrides.hasOwnProperty('earliestBookingInMinutes') ? overrides.earliestBookingInMinutes! : 9665;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsV1LimitEarlyBookingPolicyInput = <T extends Partial<WixBookingsV1LimitEarlyBookingPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('earliestBookingInMinutes')) {
        result.earliestBookingInMinutes = overrides && overrides.hasOwnProperty('earliestBookingInMinutes') ? overrides.earliestBookingInMinutes! : 2853;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixBookingsV1LimitLateBookingPolicy = <T extends Partial<WixBookingsV1LimitLateBookingPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestBookingInMinutes')) {
        result.latestBookingInMinutes = overrides && overrides.hasOwnProperty('latestBookingInMinutes') ? overrides.latestBookingInMinutes! : 5694;
    }

    return result;
};

export const aWixBookingsV1LimitLateBookingPolicyInput = <T extends Partial<WixBookingsV1LimitLateBookingPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestBookingInMinutes')) {
        result.latestBookingInMinutes = overrides && overrides.hasOwnProperty('latestBookingInMinutes') ? overrides.latestBookingInMinutes! : 4744;
    }

    return result;
};

export const aWixBookingsV1ParticipantsPolicy = <T extends Partial<WixBookingsV1ParticipantsPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxParticipantsPerBooking')) {
        result.maxParticipantsPerBooking = overrides && overrides.hasOwnProperty('maxParticipantsPerBooking') ? overrides.maxParticipantsPerBooking! : 8651;
    }

    return result;
};

export const aWixBookingsV1ParticipantsPolicyInput = <T extends Partial<WixBookingsV1ParticipantsPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxParticipantsPerBooking')) {
        result.maxParticipantsPerBooking = overrides && overrides.hasOwnProperty('maxParticipantsPerBooking') ? overrides.maxParticipantsPerBooking! : 1718;
    }

    return result;
};

export const aWixBookingsV1PolicyDescription = <T extends Partial<WixBookingsV1PolicyDescription>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixBookingsV1PolicyDescriptionInput = <T extends Partial<WixBookingsV1PolicyDescriptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsV1QueryBookingPoliciesRequestInput = <T extends Partial<WixBookingsV1QueryBookingPoliciesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixBookingsV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixBookingsV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixBookingsV1QueryBookingPoliciesResponse = <T extends Partial<WixBookingsV1QueryBookingPoliciesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixBookingsV1BookingPolicy(x ?? {}, pickedFields.get('items'))) : [aWixBookingsV1BookingPolicy({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixBookingsV1ReschedulePolicy = <T extends Partial<WixBookingsV1ReschedulePolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestRescheduleInMinutes')) {
        result.latestRescheduleInMinutes = overrides && overrides.hasOwnProperty('latestRescheduleInMinutes') ? overrides.latestRescheduleInMinutes! : 5201;
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLatestReschedule')) {
        result.limitLatestReschedule = overrides && overrides.hasOwnProperty('limitLatestReschedule') ? overrides.limitLatestReschedule! : false;
    }

    return result;
};

export const aWixBookingsV1ReschedulePolicyInput = <T extends Partial<WixBookingsV1ReschedulePolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('latestRescheduleInMinutes')) {
        result.latestRescheduleInMinutes = overrides && overrides.hasOwnProperty('latestRescheduleInMinutes') ? overrides.latestRescheduleInMinutes! : 9212;
    }
    if (pickedFields.size === 0 || pickedFields.has('limitLatestReschedule')) {
        result.limitLatestReschedule = overrides && overrides.hasOwnProperty('limitLatestReschedule') ? overrides.limitLatestReschedule! : false;
    }

    return result;
};

export const aWixBookingsV1ResourcesPolicy = <T extends Partial<WixBookingsV1ResourcesPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoAssignAllowed')) {
        result.autoAssignAllowed = overrides && overrides.hasOwnProperty('autoAssignAllowed') ? overrides.autoAssignAllowed! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixBookingsV1ResourcesPolicyInput = <T extends Partial<WixBookingsV1ResourcesPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoAssignAllowed')) {
        result.autoAssignAllowed = overrides && overrides.hasOwnProperty('autoAssignAllowed') ? overrides.autoAssignAllowed! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsV1SaveCreditCardPolicy = <T extends Partial<WixBookingsV1SaveCreditCardPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }

    return result;
};

export const aWixBookingsV1SaveCreditCardPolicyInput = <T extends Partial<WixBookingsV1SaveCreditCardPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixBookingsV1SetDefaultBookingPolicyRequestInput = <T extends Partial<WixBookingsV1SetDefaultBookingPolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicyId')) {
        result.bookingPolicyId = overrides && overrides.hasOwnProperty('bookingPolicyId') ? overrides.bookingPolicyId! : 'quia';
    }

    return result;
};

export const aWixBookingsV1SetDefaultBookingPolicyResponse = <T extends Partial<WixBookingsV1SetDefaultBookingPolicyResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currentDefaultBookingPolicy')) {
        result.currentDefaultBookingPolicy = overrides && overrides.hasOwnProperty('currentDefaultBookingPolicy') ? aWixBookingsV1BookingPolicy(overrides.currentDefaultBookingPolicy ?? {}, pickedFields.get('currentDefaultBookingPolicy')) : aWixBookingsV1BookingPolicy({}, pickedFields.get('currentDefaultBookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('previousDefaultBookingPolicy')) {
        result.previousDefaultBookingPolicy = overrides && overrides.hasOwnProperty('previousDefaultBookingPolicy') ? aWixBookingsV1BookingPolicy(overrides.previousDefaultBookingPolicy ?? {}, pickedFields.get('previousDefaultBookingPolicy')) : aWixBookingsV1BookingPolicy({}, pickedFields.get('previousDefaultBookingPolicy'));
    }

    return result;
};

export const aWixBookingsV1UpdateAllPoliciesRequestInput = <T extends Partial<WixBookingsV1UpdateAllPoliciesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicy')) {
        result.bookingPolicy = overrides && overrides.hasOwnProperty('bookingPolicy') ? aWixBookingsV1BookingPolicyInput(overrides.bookingPolicy ?? {}, pickedFields.get('bookingPolicy')) : aWixBookingsV1BookingPolicyInput({}, pickedFields.get('bookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['earum'];
    }

    return result;
};

export const aWixBookingsV1UpdateBookingPolicyRequestInput = <T extends Partial<WixBookingsV1UpdateBookingPolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicy')) {
        result.bookingPolicy = overrides && overrides.hasOwnProperty('bookingPolicy') ? aWixBookingsV1BookingPolicyInput(overrides.bookingPolicy ?? {}, pickedFields.get('bookingPolicy')) : aWixBookingsV1BookingPolicyInput({}, pickedFields.get('bookingPolicy'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['qui'];
    }

    return result;
};

export const aWixBookingsV1UpdateBookingPolicyResponse = <T extends Partial<WixBookingsV1UpdateBookingPolicyResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingPolicy')) {
        result.bookingPolicy = overrides && overrides.hasOwnProperty('bookingPolicy') ? aWixBookingsV1BookingPolicy(overrides.bookingPolicy ?? {}, pickedFields.get('bookingPolicy')) : aWixBookingsV1BookingPolicy({}, pickedFields.get('bookingPolicy'));
    }

    return result;
};

export const aWixBookingsV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixBookingsV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3071;
    }

    return result;
};

export const aWixBookingsV1UpstreamWixCommonCursorQueryInput = <T extends Partial<WixBookingsV1UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixBookingsV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixBookingsV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixBookingsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixBookingsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixBookingsV1UpstreamWixCommonMoney = <T extends Partial<WixBookingsV1UpstreamWixCommonMoney>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedValue')) {
        result.formattedValue = overrides && overrides.hasOwnProperty('formattedValue') ? overrides.formattedValue! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'impedit';
    }

    return result;
};

export const aWixBookingsV1UpstreamWixCommonMoneyInput = <T extends Partial<WixBookingsV1UpstreamWixCommonMoneyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedValue')) {
        result.formattedValue = overrides && overrides.hasOwnProperty('formattedValue') ? overrides.formattedValue! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'quasi';
    }

    return result;
};

export const aWixBookingsV1UpstreamWixCommonSortingInput = <T extends Partial<WixBookingsV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixBookingsV1UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixBookingsV1WaitlistPolicy = <T extends Partial<WixBookingsV1WaitlistPolicy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('capacity')) {
        result.capacity = overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 5483;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('reservationTimeInMinutes')) {
        result.reservationTimeInMinutes = overrides && overrides.hasOwnProperty('reservationTimeInMinutes') ? overrides.reservationTimeInMinutes! : 7674;
    }

    return result;
};

export const aWixBookingsV1WaitlistPolicyInput = <T extends Partial<WixBookingsV1WaitlistPolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('capacity')) {
        result.capacity = overrides && overrides.hasOwnProperty('capacity') ? overrides.capacity! : 7731;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('reservationTimeInMinutes')) {
        result.reservationTimeInMinutes = overrides && overrides.hasOwnProperty('reservationTimeInMinutes') ? overrides.reservationTimeInMinutes! : 7006;
    }

    return result;
};

export const aWixCalendarEventsV3BulkCancelEventRequestInput = <T extends Partial<WixCalendarEventsV3BulkCancelEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventIds')) {
        result.eventIds = overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['autem'];
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aWixCalendarSchedulesV3ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aWixCalendarSchedulesV3ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'commodi';
    }

    return result;
};

export const aWixCalendarEventsV3BulkCancelEventResponse = <T extends Partial<WixCalendarEventsV3BulkCancelEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCalendarEventsV3UpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCalendarEventsV3UpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCalendarEventsV3BulkEventResult(x ?? {}, pickedFields.get('results'))) : [aWixCalendarEventsV3BulkEventResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCalendarEventsV3BulkCreateEventRequestInput = <T extends Partial<WixCalendarEventsV3BulkCreateEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('events')) {
        result.events = overrides && overrides.hasOwnProperty('events') ? overrides.events!.map((x) => aWixCalendarEventsV3BulkCreateEventRequestMaskedEventInput({}, pickedFields.get('events'))) : [aWixCalendarEventsV3BulkCreateEventRequestMaskedEventInput({}, pickedFields.get('events'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'ad';
    }

    return result;
};

export const aWixCalendarEventsV3BulkCreateEventRequestMaskedEventInput = <T extends Partial<WixCalendarEventsV3BulkCreateEventRequestMaskedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixCalendarEventsV3EventInput(overrides.event ?? {}, pickedFields.get('event')) : aWixCalendarEventsV3EventInput({}, pickedFields.get('event'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldmask')) {
        result.fieldmask = overrides && overrides.hasOwnProperty('fieldmask') ? overrides.fieldmask! : ['mollitia'];
    }

    return result;
};

export const aWixCalendarEventsV3BulkCreateEventResponse = <T extends Partial<WixCalendarEventsV3BulkCreateEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCalendarEventsV3UpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCalendarEventsV3UpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCalendarEventsV3BulkEventResult(x ?? {}, pickedFields.get('results'))) : [aWixCalendarEventsV3BulkEventResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCalendarEventsV3BulkEventResult = <T extends Partial<WixCalendarEventsV3BulkEventResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixCalendarEventsV3Event(overrides.item ?? {}, pickedFields.get('item')) : aWixCalendarEventsV3Event({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCalendarEventsV3UpstreamWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCalendarEventsV3UpstreamWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixCalendarEventsV3BulkUpdateEventRequestInput = <T extends Partial<WixCalendarEventsV3BulkUpdateEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('events')) {
        result.events = overrides && overrides.hasOwnProperty('events') ? overrides.events!.map((x) => aWixCalendarEventsV3BulkUpdateEventRequestMaskedEventInput({}, pickedFields.get('events'))) : [aWixCalendarEventsV3BulkUpdateEventRequestMaskedEventInput({}, pickedFields.get('events'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aWixCalendarSchedulesV3ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aWixCalendarSchedulesV3ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'rerum';
    }

    return result;
};

export const aWixCalendarEventsV3BulkUpdateEventRequestMaskedEventInput = <T extends Partial<WixCalendarEventsV3BulkUpdateEventRequestMaskedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixCalendarEventsV3EventInput(overrides.event ?? {}, pickedFields.get('event')) : aWixCalendarEventsV3EventInput({}, pickedFields.get('event'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldmask')) {
        result.fieldmask = overrides && overrides.hasOwnProperty('fieldmask') ? overrides.fieldmask! : ['qui'];
    }

    return result;
};

export const aWixCalendarEventsV3BulkUpdateEventResponse = <T extends Partial<WixCalendarEventsV3BulkUpdateEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCalendarEventsV3UpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCalendarEventsV3UpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCalendarEventsV3BulkEventResult(x ?? {}, pickedFields.get('results'))) : [aWixCalendarEventsV3BulkEventResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCalendarEventsV3CancelEventRequestInput = <T extends Partial<WixCalendarEventsV3CancelEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aWixCalendarSchedulesV3ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aWixCalendarSchedulesV3ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'ut';
    }

    return result;
};

export const aWixCalendarEventsV3CancelEventResponse = <T extends Partial<WixCalendarEventsV3CancelEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixCalendarEventsV3Event(overrides.event ?? {}, pickedFields.get('event')) : aWixCalendarEventsV3Event({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixCalendarEventsV3CreateEventRequestInput = <T extends Partial<WixCalendarEventsV3CreateEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixCalendarEventsV3EventInput(overrides.event ?? {}, pickedFields.get('event')) : aWixCalendarEventsV3EventInput({}, pickedFields.get('event'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldmask')) {
        result.fieldmask = overrides && overrides.hasOwnProperty('fieldmask') ? overrides.fieldmask! : ['nihil'];
    }
    if (pickedFields.size === 0 || pickedFields.has('idempotencyKey')) {
        result.idempotencyKey = overrides && overrides.hasOwnProperty('idempotencyKey') ? overrides.idempotencyKey! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'corporis';
    }

    return result;
};

export const aWixCalendarEventsV3CreateEventResponse = <T extends Partial<WixCalendarEventsV3CreateEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixCalendarEventsV3Event(overrides.event ?? {}, pickedFields.get('event')) : aWixCalendarEventsV3Event({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixCalendarEventsV3Event = <T extends Partial<WixCalendarEventsV3Event>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('adjustedEnd')) {
        result.adjustedEnd = overrides && overrides.hasOwnProperty('adjustedEnd') ? aWixCalendarEventsV3ZonedDate(overrides.adjustedEnd ?? {}, pickedFields.get('adjustedEnd')) : aWixCalendarEventsV3ZonedDate({}, pickedFields.get('adjustedEnd'));
    }
    if (pickedFields.size === 0 || pickedFields.has('adjustedStart')) {
        result.adjustedStart = overrides && overrides.hasOwnProperty('adjustedStart') ? aWixCalendarEventsV3ZonedDate(overrides.adjustedStart ?? {}, pickedFields.get('adjustedStart')) : aWixCalendarEventsV3ZonedDate({}, pickedFields.get('adjustedStart'));
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'at';
    }
    if (pickedFields.size === 0 || pickedFields.has('conferencingDetails')) {
        result.conferencingDetails = overrides && overrides.hasOwnProperty('conferencingDetails') ? aWixCalendarSchedulesV3ConferencingDetails(overrides.conferencingDetails ?? {}, pickedFields.get('conferencingDetails')) : aWixCalendarSchedulesV3ConferencingDetails({}, pickedFields.get('conferencingDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? aWixCalendarEventsV3ZonedDate(overrides.end ?? {}, pickedFields.get('end')) : aWixCalendarEventsV3ZonedDate({}, pickedFields.get('end'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalScheduleId')) {
        result.externalScheduleId = overrides && overrides.hasOwnProperty('externalScheduleId') ? overrides.externalScheduleId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('inheritedFields')) {
        result.inheritedFields = overrides && overrides.hasOwnProperty('inheritedFields') ? overrides.inheritedFields! : [WixCalendarEventsV3FieldEnumField.Capacity];
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aWixCalendarSchedulesV3Location(overrides.location ?? {}, pickedFields.get('location')) : aWixCalendarSchedulesV3Location({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('notes')) {
        result.notes = overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('participants')) {
        result.participants = overrides && overrides.hasOwnProperty('participants') ? aWixCalendarEventsV3Participants(overrides.participants ?? {}, pickedFields.get('participants')) : aWixCalendarEventsV3Participants({}, pickedFields.get('participants'));
    }
    if (pickedFields.size === 0 || pickedFields.has('permissions')) {
        result.permissions = overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions!.map((x) => aWixCalendarSchedulesV3Permission(x ?? {}, pickedFields.get('permissions'))) : [aWixCalendarSchedulesV3Permission({}, pickedFields.get('permissions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('recurrenceRule')) {
        result.recurrenceRule = overrides && overrides.hasOwnProperty('recurrenceRule') ? aWixCalendarEventsV3RecurrenceRule(overrides.recurrenceRule ?? {}, pickedFields.get('recurrenceRule')) : aWixCalendarEventsV3RecurrenceRule({}, pickedFields.get('recurrenceRule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('recurrenceType')) {
        result.recurrenceType = overrides && overrides.hasOwnProperty('recurrenceType') ? overrides.recurrenceType! : WixCalendarEventsV3RecurrenceTypeEnumRecurrenceType.Exception;
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringEventId')) {
        result.recurringEventId = overrides && overrides.hasOwnProperty('recurringEventId') ? overrides.recurringEventId! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('remainingCapacity')) {
        result.remainingCapacity = overrides && overrides.hasOwnProperty('remainingCapacity') ? overrides.remainingCapacity! : 6774;
    }
    if (pickedFields.size === 0 || pickedFields.has('resources')) {
        result.resources = overrides && overrides.hasOwnProperty('resources') ? overrides.resources!.map((x) => aWixCalendarEventsV3Resource(x ?? {}, pickedFields.get('resources'))) : [aWixCalendarEventsV3Resource({}, pickedFields.get('resources'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixCalendarSchedulesV3Schedule(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixCalendarSchedulesV3Schedule({}, pickedFields.get('schedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleName')) {
        result.scheduleName = overrides && overrides.hasOwnProperty('scheduleName') ? overrides.scheduleName! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionsVirtualReference')) {
        result.sessionsVirtualReference = overrides && overrides.hasOwnProperty('sessionsVirtualReference') ? aComWixBookingsCalendarApiV2QuerySessionsResponse(overrides.sessionsVirtualReference ?? {}, pickedFields.get('sessionsVirtualReference')) : aComWixBookingsCalendarApiV2QuerySessionsResponse({}, pickedFields.get('sessionsVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? aWixCalendarEventsV3ZonedDate(overrides.start ?? {}, pickedFields.get('start')) : aWixCalendarEventsV3ZonedDate({}, pickedFields.get('start'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixCalendarEventsV3EventStatus.Cancelled;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalCapacity')) {
        result.totalCapacity = overrides && overrides.hasOwnProperty('totalCapacity') ? overrides.totalCapacity! : 9333;
    }
    if (pickedFields.size === 0 || pickedFields.has('transparency')) {
        result.transparency = overrides && overrides.hasOwnProperty('transparency') ? overrides.transparency! : WixCalendarEventsV3Transparency.Opaque;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'voluptate';
    }

    return result;
};

export const aWixCalendarEventsV3EventInput = <T extends Partial<WixCalendarEventsV3EventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('adjustedEnd')) {
        result.adjustedEnd = overrides && overrides.hasOwnProperty('adjustedEnd') ? aWixCalendarEventsV3ZonedDateInput(overrides.adjustedEnd ?? {}, pickedFields.get('adjustedEnd')) : aWixCalendarEventsV3ZonedDateInput({}, pickedFields.get('adjustedEnd'));
    }
    if (pickedFields.size === 0 || pickedFields.has('adjustedStart')) {
        result.adjustedStart = overrides && overrides.hasOwnProperty('adjustedStart') ? aWixCalendarEventsV3ZonedDateInput(overrides.adjustedStart ?? {}, pickedFields.get('adjustedStart')) : aWixCalendarEventsV3ZonedDateInput({}, pickedFields.get('adjustedStart'));
    }
    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('conferencingDetails')) {
        result.conferencingDetails = overrides && overrides.hasOwnProperty('conferencingDetails') ? aWixCalendarSchedulesV3ConferencingDetailsInput(overrides.conferencingDetails ?? {}, pickedFields.get('conferencingDetails')) : aWixCalendarSchedulesV3ConferencingDetailsInput({}, pickedFields.get('conferencingDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? aWixCalendarEventsV3ZonedDateInput(overrides.end ?? {}, pickedFields.get('end')) : aWixCalendarEventsV3ZonedDateInput({}, pickedFields.get('end'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalScheduleId')) {
        result.externalScheduleId = overrides && overrides.hasOwnProperty('externalScheduleId') ? overrides.externalScheduleId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('inheritedFields')) {
        result.inheritedFields = overrides && overrides.hasOwnProperty('inheritedFields') ? overrides.inheritedFields! : [WixCalendarEventsV3FieldEnumField.Capacity];
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aWixCalendarSchedulesV3LocationInput(overrides.location ?? {}, pickedFields.get('location')) : aWixCalendarSchedulesV3LocationInput({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('notes')) {
        result.notes = overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('participants')) {
        result.participants = overrides && overrides.hasOwnProperty('participants') ? aWixCalendarEventsV3ParticipantsInput(overrides.participants ?? {}, pickedFields.get('participants')) : aWixCalendarEventsV3ParticipantsInput({}, pickedFields.get('participants'));
    }
    if (pickedFields.size === 0 || pickedFields.has('permissions')) {
        result.permissions = overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions!.map((x) => aWixCalendarSchedulesV3PermissionInput({}, pickedFields.get('permissions'))) : [aWixCalendarSchedulesV3PermissionInput({}, pickedFields.get('permissions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('recurrenceRule')) {
        result.recurrenceRule = overrides && overrides.hasOwnProperty('recurrenceRule') ? aWixCalendarEventsV3RecurrenceRuleInput(overrides.recurrenceRule ?? {}, pickedFields.get('recurrenceRule')) : aWixCalendarEventsV3RecurrenceRuleInput({}, pickedFields.get('recurrenceRule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('recurrenceType')) {
        result.recurrenceType = overrides && overrides.hasOwnProperty('recurrenceType') ? overrides.recurrenceType! : WixCalendarEventsV3RecurrenceTypeEnumRecurrenceType.Exception;
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringEventId')) {
        result.recurringEventId = overrides && overrides.hasOwnProperty('recurringEventId') ? overrides.recurringEventId! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('remainingCapacity')) {
        result.remainingCapacity = overrides && overrides.hasOwnProperty('remainingCapacity') ? overrides.remainingCapacity! : 5851;
    }
    if (pickedFields.size === 0 || pickedFields.has('resources')) {
        result.resources = overrides && overrides.hasOwnProperty('resources') ? overrides.resources!.map((x) => aWixCalendarEventsV3ResourceInput({}, pickedFields.get('resources'))) : [aWixCalendarEventsV3ResourceInput({}, pickedFields.get('resources'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleName')) {
        result.scheduleName = overrides && overrides.hasOwnProperty('scheduleName') ? overrides.scheduleName! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? aWixCalendarEventsV3ZonedDateInput(overrides.start ?? {}, pickedFields.get('start')) : aWixCalendarEventsV3ZonedDateInput({}, pickedFields.get('start'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixCalendarEventsV3EventStatus.Cancelled;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalCapacity')) {
        result.totalCapacity = overrides && overrides.hasOwnProperty('totalCapacity') ? overrides.totalCapacity! : 3155;
    }
    if (pickedFields.size === 0 || pickedFields.has('transparency')) {
        result.transparency = overrides && overrides.hasOwnProperty('transparency') ? overrides.transparency! : WixCalendarEventsV3Transparency.Opaque;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'et';
    }

    return result;
};

export const aWixCalendarEventsV3GetEventRequestInput = <T extends Partial<WixCalendarEventsV3GetEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('consistent')) {
        result.consistent = overrides && overrides.hasOwnProperty('consistent') ? overrides.consistent! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixCalendarEventsV3RequestedFieldsEnumRequestedFields.OwnPiFields];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '2130573e-86de-4b40-9e20-92836319c2eb';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'nisi';
    }

    return result;
};

export const aWixCalendarEventsV3ListEventsRequestInput = <T extends Partial<WixCalendarEventsV3ListEventsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('consistent')) {
        result.consistent = overrides && overrides.hasOwnProperty('consistent') ? overrides.consistent! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('eventIds')) {
        result.eventIds = overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['ut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixCalendarEventsV3RequestedFieldsEnumRequestedFields.OwnPiFields];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'ea';
    }

    return result;
};

export const aWixCalendarEventsV3ListEventsResponse = <T extends Partial<WixCalendarEventsV3ListEventsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('events')) {
        result.events = overrides && overrides.hasOwnProperty('events') ? overrides.events!.map((x) => aWixCalendarEventsV3Event(x ?? {}, pickedFields.get('events'))) : [aWixCalendarEventsV3Event({}, pickedFields.get('events'))];
    }

    return result;
};

export const aWixCalendarEventsV3ListRecurringEventInstancesHistoryRequestInput = <T extends Partial<WixCalendarEventsV3ListRecurringEventInstancesHistoryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCalendarEventsV3UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCalendarEventsV3UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fromDate')) {
        result.fromDate = overrides && overrides.hasOwnProperty('fromDate') ? overrides.fromDate! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringEventId')) {
        result.recurringEventId = overrides && overrides.hasOwnProperty('recurringEventId') ? overrides.recurringEventId! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('toDate')) {
        result.toDate = overrides && overrides.hasOwnProperty('toDate') ? overrides.toDate! : 'quos';
    }

    return result;
};

export const aWixCalendarEventsV3ListRecurringEventInstancesHistoryResponse = <T extends Partial<WixCalendarEventsV3ListRecurringEventInstancesHistoryResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCalendarEventsV3UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCalendarEventsV3UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringEventInstances')) {
        result.recurringEventInstances = overrides && overrides.hasOwnProperty('recurringEventInstances') ? overrides.recurringEventInstances!.map((x) => aWixCalendarEventsV3Event(x ?? {}, pickedFields.get('recurringEventInstances'))) : [aWixCalendarEventsV3Event({}, pickedFields.get('recurringEventInstances'))];
    }

    return result;
};

export const aWixCalendarEventsV3Participant = <T extends Partial<WixCalendarEventsV3Participant>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'laboriosam';
    }

    return result;
};

export const aWixCalendarEventsV3ParticipantInput = <T extends Partial<WixCalendarEventsV3ParticipantInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'doloribus';
    }

    return result;
};

export const aWixCalendarEventsV3Participants = <T extends Partial<WixCalendarEventsV3Participants>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hasMore')) {
        result.hasMore = overrides && overrides.hasOwnProperty('hasMore') ? overrides.hasMore! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('list')) {
        result.list = overrides && overrides.hasOwnProperty('list') ? overrides.list!.map((x) => aWixCalendarEventsV3Participant(x ?? {}, pickedFields.get('list'))) : [aWixCalendarEventsV3Participant({}, pickedFields.get('list'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixCalendarEventsV3ParticipantsStatus.Confirmed;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 2869;
    }

    return result;
};

export const aWixCalendarEventsV3ParticipantsInput = <T extends Partial<WixCalendarEventsV3ParticipantsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hasMore')) {
        result.hasMore = overrides && overrides.hasOwnProperty('hasMore') ? overrides.hasMore! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('list')) {
        result.list = overrides && overrides.hasOwnProperty('list') ? overrides.list!.map((x) => aWixCalendarEventsV3ParticipantInput({}, pickedFields.get('list'))) : [aWixCalendarEventsV3ParticipantInput({}, pickedFields.get('list'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixCalendarEventsV3ParticipantsStatus.Confirmed;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 6231;
    }

    return result;
};

export const aWixCalendarEventsV3QueryEventsRequestInput = <T extends Partial<WixCalendarEventsV3QueryEventsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('consistent')) {
        result.consistent = overrides && overrides.hasOwnProperty('consistent') ? overrides.consistent! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixCalendarEventsV3RequestedFieldsEnumRequestedFields.OwnPiFields];
    }
    if (pickedFields.size === 0 || pickedFields.has('fromLocalDate')) {
        result.fromLocalDate = overrides && overrides.hasOwnProperty('fromLocalDate') ? overrides.fromLocalDate! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCalendarEventsV3UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixCalendarEventsV3UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }
    if (pickedFields.size === 0 || pickedFields.has('recurrenceType')) {
        result.recurrenceType = overrides && overrides.hasOwnProperty('recurrenceType') ? overrides.recurrenceType! : [WixCalendarEventsV3RecurrenceTypeEnumRecurrenceType.Exception];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('toLocalDate')) {
        result.toLocalDate = overrides && overrides.hasOwnProperty('toLocalDate') ? overrides.toLocalDate! : 'aut';
    }

    return result;
};

export const aWixCalendarEventsV3QueryEventsResponse = <T extends Partial<WixCalendarEventsV3QueryEventsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixCalendarEventsV3Event(x ?? {}, pickedFields.get('items'))) : [aWixCalendarEventsV3Event({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixCalendarEventsV3RecurrenceRule = <T extends Partial<WixCalendarEventsV3RecurrenceRule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('adjustedUntil')) {
        result.adjustedUntil = overrides && overrides.hasOwnProperty('adjustedUntil') ? aWixCalendarEventsV3ZonedDate(overrides.adjustedUntil ?? {}, pickedFields.get('adjustedUntil')) : aWixCalendarEventsV3ZonedDate({}, pickedFields.get('adjustedUntil'));
    }
    if (pickedFields.size === 0 || pickedFields.has('days')) {
        result.days = overrides && overrides.hasOwnProperty('days') ? overrides.days! : [WixCalendarEventsV3RecurrenceRuleDay.Friday];
    }
    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : WixCalendarEventsV3RecurrenceRuleFrequency.UnknownFrequency;
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : 3826;
    }
    if (pickedFields.size === 0 || pickedFields.has('until')) {
        result.until = overrides && overrides.hasOwnProperty('until') ? aWixCalendarEventsV3ZonedDate(overrides.until ?? {}, pickedFields.get('until')) : aWixCalendarEventsV3ZonedDate({}, pickedFields.get('until'));
    }

    return result;
};

export const aWixCalendarEventsV3RecurrenceRuleInput = <T extends Partial<WixCalendarEventsV3RecurrenceRuleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('adjustedUntil')) {
        result.adjustedUntil = overrides && overrides.hasOwnProperty('adjustedUntil') ? aWixCalendarEventsV3ZonedDateInput(overrides.adjustedUntil ?? {}, pickedFields.get('adjustedUntil')) : aWixCalendarEventsV3ZonedDateInput({}, pickedFields.get('adjustedUntil'));
    }
    if (pickedFields.size === 0 || pickedFields.has('days')) {
        result.days = overrides && overrides.hasOwnProperty('days') ? overrides.days! : [WixCalendarEventsV3RecurrenceRuleDay.Friday];
    }
    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : WixCalendarEventsV3RecurrenceRuleFrequency.UnknownFrequency;
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : 3054;
    }
    if (pickedFields.size === 0 || pickedFields.has('until')) {
        result.until = overrides && overrides.hasOwnProperty('until') ? aWixCalendarEventsV3ZonedDateInput(overrides.until ?? {}, pickedFields.get('until')) : aWixCalendarEventsV3ZonedDateInput({}, pickedFields.get('until'));
    }

    return result;
};

export const aWixCalendarEventsV3Resource = <T extends Partial<WixCalendarEventsV3Resource>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('permissionRole')) {
        result.permissionRole = overrides && overrides.hasOwnProperty('permissionRole') ? overrides.permissionRole! : WixCalendarSchedulesV3PermissionRole.Commenter;
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixCalendarSchedulesV3Schedule(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixCalendarSchedulesV3Schedule({}, pickedFields.get('schedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('transparency')) {
        result.transparency = overrides && overrides.hasOwnProperty('transparency') ? overrides.transparency! : WixCalendarEventsV3Transparency.Opaque;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'nesciunt';
    }

    return result;
};

export const aWixCalendarEventsV3ResourceInput = <T extends Partial<WixCalendarEventsV3ResourceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('permissionRole')) {
        result.permissionRole = overrides && overrides.hasOwnProperty('permissionRole') ? overrides.permissionRole! : WixCalendarSchedulesV3PermissionRole.Commenter;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('transparency')) {
        result.transparency = overrides && overrides.hasOwnProperty('transparency') ? overrides.transparency! : WixCalendarEventsV3Transparency.Opaque;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'sunt';
    }

    return result;
};

export const aWixCalendarEventsV3RestoreEventDefaultsRequestInput = <T extends Partial<WixCalendarEventsV3RestoreEventDefaultsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixCalendarEventsV3FieldEnumField.Capacity];
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aWixCalendarSchedulesV3ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aWixCalendarSchedulesV3ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'aspernatur';
    }

    return result;
};

export const aWixCalendarEventsV3RestoreEventDefaultsResponse = <T extends Partial<WixCalendarEventsV3RestoreEventDefaultsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixCalendarEventsV3Event(overrides.event ?? {}, pickedFields.get('event')) : aWixCalendarEventsV3Event({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixCalendarEventsV3SplitRecurringEventRequestInput = <T extends Partial<WixCalendarEventsV3SplitRecurringEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('recurringEventId')) {
        result.recurringEventId = overrides && overrides.hasOwnProperty('recurringEventId') ? overrides.recurringEventId! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('splitLocalDate')) {
        result.splitLocalDate = overrides && overrides.hasOwnProperty('splitLocalDate') ? overrides.splitLocalDate! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'officiis';
    }

    return result;
};

export const aWixCalendarEventsV3SplitRecurringEventResponse = <T extends Partial<WixCalendarEventsV3SplitRecurringEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('newRecurringEventStartingFromSplit')) {
        result.newRecurringEventStartingFromSplit = overrides && overrides.hasOwnProperty('newRecurringEventStartingFromSplit') ? aWixCalendarEventsV3Event(overrides.newRecurringEventStartingFromSplit ?? {}, pickedFields.get('newRecurringEventStartingFromSplit')) : aWixCalendarEventsV3Event({}, pickedFields.get('newRecurringEventStartingFromSplit'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedRecurringEventEndingBeforeSplit')) {
        result.updatedRecurringEventEndingBeforeSplit = overrides && overrides.hasOwnProperty('updatedRecurringEventEndingBeforeSplit') ? aWixCalendarEventsV3Event(overrides.updatedRecurringEventEndingBeforeSplit ?? {}, pickedFields.get('updatedRecurringEventEndingBeforeSplit')) : aWixCalendarEventsV3Event({}, pickedFields.get('updatedRecurringEventEndingBeforeSplit'));
    }

    return result;
};

export const aWixCalendarEventsV3UpdateEventParticipantsRequestInput = <T extends Partial<WixCalendarEventsV3UpdateEventParticipantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('participants')) {
        result.participants = overrides && overrides.hasOwnProperty('participants') ? aWixCalendarEventsV3ParticipantsInput(overrides.participants ?? {}, pickedFields.get('participants')) : aWixCalendarEventsV3ParticipantsInput({}, pickedFields.get('participants'));
    }

    return result;
};

export const aWixCalendarEventsV3UpdateEventParticipantsResponse = <T extends Partial<WixCalendarEventsV3UpdateEventParticipantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixCalendarEventsV3Event(overrides.event ?? {}, pickedFields.get('event')) : aWixCalendarEventsV3Event({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixCalendarEventsV3UpdateEventRequestInput = <T extends Partial<WixCalendarEventsV3UpdateEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixCalendarEventsV3EventInput(overrides.event ?? {}, pickedFields.get('event')) : aWixCalendarEventsV3EventInput({}, pickedFields.get('event'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldmask')) {
        result.fieldmask = overrides && overrides.hasOwnProperty('fieldmask') ? overrides.fieldmask! : ['id'];
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aWixCalendarSchedulesV3ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aWixCalendarSchedulesV3ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'et';
    }

    return result;
};

export const aWixCalendarEventsV3UpdateEventResponse = <T extends Partial<WixCalendarEventsV3UpdateEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixCalendarEventsV3Event(overrides.event ?? {}, pickedFields.get('event')) : aWixCalendarEventsV3Event({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixCalendarEventsV3UpstreamWixCommonBulkActionMetadata = <T extends Partial<WixCalendarEventsV3UpstreamWixCommonBulkActionMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalFailures')) {
        result.totalFailures = overrides && overrides.hasOwnProperty('totalFailures') ? overrides.totalFailures! : 3600;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalSuccesses')) {
        result.totalSuccesses = overrides && overrides.hasOwnProperty('totalSuccesses') ? overrides.totalSuccesses! : 5582;
    }

    return result;
};

export const aWixCalendarEventsV3UpstreamWixCommonCursorPagingInput = <T extends Partial<WixCalendarEventsV3UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2414;
    }

    return result;
};

export const aWixCalendarEventsV3UpstreamWixCommonCursorPagingMetadata = <T extends Partial<WixCalendarEventsV3UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 2917;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixCalendarEventsV3UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixCalendarEventsV3UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }

    return result;
};

export const aWixCalendarEventsV3UpstreamWixCommonCursorQueryInput = <T extends Partial<WixCalendarEventsV3UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCalendarEventsV3UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCalendarEventsV3UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCalendarEventsV3UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCalendarEventsV3UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixCalendarEventsV3UpstreamWixCommonCursors = <T extends Partial<WixCalendarEventsV3UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'odit';
    }

    return result;
};

export const aWixCalendarEventsV3UpstreamWixCommonItemMetadata = <T extends Partial<WixCalendarEventsV3UpstreamWixCommonItemMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiApplicationError(overrides.error ?? {}, pickedFields.get('error')) : aWixApiApplicationError({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalIndex')) {
        result.originalIndex = overrides && overrides.hasOwnProperty('originalIndex') ? overrides.originalIndex! : 5821;
    }
    if (pickedFields.size === 0 || pickedFields.has('success')) {
        result.success = overrides && overrides.hasOwnProperty('success') ? overrides.success! : false;
    }

    return result;
};

export const aWixCalendarEventsV3UpstreamWixCommonSortingInput = <T extends Partial<WixCalendarEventsV3UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixCalendarEventsV3UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixCalendarEventsV3ZonedDate = <T extends Partial<WixCalendarEventsV3ZonedDate>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('localDate')) {
        result.localDate = overrides && overrides.hasOwnProperty('localDate') ? overrides.localDate! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('utcDate')) {
        result.utcDate = overrides && overrides.hasOwnProperty('utcDate') ? overrides.utcDate! : 'sit';
    }

    return result;
};

export const aWixCalendarEventsV3ZonedDateInput = <T extends Partial<WixCalendarEventsV3ZonedDateInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('localDate')) {
        result.localDate = overrides && overrides.hasOwnProperty('localDate') ? overrides.localDate! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('utcDate')) {
        result.utcDate = overrides && overrides.hasOwnProperty('utcDate') ? overrides.utcDate! : 'voluptatem';
    }

    return result;
};

export const aWixCalendarMigrationV3DeleteTargetsRequestInput = <T extends Partial<WixCalendarMigrationV3DeleteTargetsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('concurrencyLimit')) {
        result.concurrencyLimit = overrides && overrides.hasOwnProperty('concurrencyLimit') ? overrides.concurrencyLimit! : 683;
    }
    if (pickedFields.size === 0 || pickedFields.has('deleteEvents')) {
        result.deleteEvents = overrides && overrides.hasOwnProperty('deleteEvents') ? overrides.deleteEvents! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('deleteParticipantEvents')) {
        result.deleteParticipantEvents = overrides && overrides.hasOwnProperty('deleteParticipantEvents') ? overrides.deleteParticipantEvents! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('deleteParticipations')) {
        result.deleteParticipations = overrides && overrides.hasOwnProperty('deleteParticipations') ? overrides.deleteParticipations! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('deleteScheduleTimeframes')) {
        result.deleteScheduleTimeframes = overrides && overrides.hasOwnProperty('deleteScheduleTimeframes') ? overrides.deleteScheduleTimeframes! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('deleteSchedules')) {
        result.deleteSchedules = overrides && overrides.hasOwnProperty('deleteSchedules') ? overrides.deleteSchedules! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('metaSiteIds')) {
        result.metaSiteIds = overrides && overrides.hasOwnProperty('metaSiteIds') ? overrides.metaSiteIds! : ['non'];
    }

    return result;
};

export const aWixCalendarMigrationV3FixSched38956RequestInput = <T extends Partial<WixCalendarMigrationV3FixSched38956RequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dryRun')) {
        result.dryRun = overrides && overrides.hasOwnProperty('dryRun') ? overrides.dryRun! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'quisquam';
    }

    return result;
};

export const aWixCalendarMigrationV3FixSched38956Response = <T extends Partial<WixCalendarMigrationV3FixSched38956Response>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('affectedEventCount')) {
        result.affectedEventCount = overrides && overrides.hasOwnProperty('affectedEventCount') ? overrides.affectedEventCount! : 9842;
    }
    if (pickedFields.size === 0 || pickedFields.has('dryRun')) {
        result.dryRun = overrides && overrides.hasOwnProperty('dryRun') ? overrides.dryRun! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedEventCount')) {
        result.fixedEventCount = overrides && overrides.hasOwnProperty('fixedEventCount') ? overrides.fixedEventCount! : 7626;
    }

    return result;
};

export const aWixCalendarMigrationV3MigrateSiteRequestInput = <T extends Partial<WixCalendarMigrationV3MigrateSiteRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dryRun')) {
        result.dryRun = overrides && overrides.hasOwnProperty('dryRun') ? overrides.dryRun! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('skipIfTargetDataPresent')) {
        result.skipIfTargetDataPresent = overrides && overrides.hasOwnProperty('skipIfTargetDataPresent') ? overrides.skipIfTargetDataPresent! : false;
    }

    return result;
};

export const aWixCalendarMigrationV3MigrateSiteResponse = <T extends Partial<WixCalendarMigrationV3MigrateSiteResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dryRun')) {
        result.dryRun = overrides && overrides.hasOwnProperty('dryRun') ? overrides.dryRun! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('skipped')) {
        result.skipped = overrides && overrides.hasOwnProperty('skipped') ? overrides.skipped! : true;
    }

    return result;
};

export const aWixCalendarParticipanteventsV3ListEventsByContactIdRequestInput = <T extends Partial<WixCalendarParticipanteventsV3ListEventsByContactIdRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fromLocalDate')) {
        result.fromLocalDate = overrides && overrides.hasOwnProperty('fromLocalDate') ? overrides.fromLocalDate! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('toLocalDate')) {
        result.toLocalDate = overrides && overrides.hasOwnProperty('toLocalDate') ? overrides.toLocalDate! : 'rem';
    }

    return result;
};

export const aWixCalendarParticipanteventsV3ListEventsByContactIdResponse = <T extends Partial<WixCalendarParticipanteventsV3ListEventsByContactIdResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('events')) {
        result.events = overrides && overrides.hasOwnProperty('events') ? overrides.events!.map((x) => aWixCalendarEventsV3Event(x ?? {}, pickedFields.get('events'))) : [aWixCalendarEventsV3Event({}, pickedFields.get('events'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixCalendarParticipanteventsV3ListEventsByMemberIdRequestInput = <T extends Partial<WixCalendarParticipanteventsV3ListEventsByMemberIdRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('eventIds')) {
        result.eventIds = overrides && overrides.hasOwnProperty('eventIds') ? overrides.eventIds! : ['repellendus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fromLocalDate')) {
        result.fromLocalDate = overrides && overrides.hasOwnProperty('fromLocalDate') ? overrides.fromLocalDate! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('toLocalDate')) {
        result.toLocalDate = overrides && overrides.hasOwnProperty('toLocalDate') ? overrides.toLocalDate! : 'voluptates';
    }

    return result;
};

export const aWixCalendarParticipanteventsV3ListEventsByMemberIdResponse = <T extends Partial<WixCalendarParticipanteventsV3ListEventsByMemberIdResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('events')) {
        result.events = overrides && overrides.hasOwnProperty('events') ? overrides.events!.map((x) => aWixCalendarEventsV3Event(x ?? {}, pickedFields.get('events'))) : [aWixCalendarEventsV3Event({}, pickedFields.get('events'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixCalendarParticipanteventsV3ListParticipantEventsRequestInput = <T extends Partial<WixCalendarParticipanteventsV3ListParticipantEventsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fromLocalDate')) {
        result.fromLocalDate = overrides && overrides.hasOwnProperty('fromLocalDate') ? overrides.fromLocalDate! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('toLocalDate')) {
        result.toLocalDate = overrides && overrides.hasOwnProperty('toLocalDate') ? overrides.toLocalDate! : 'reiciendis';
    }

    return result;
};

export const aWixCalendarParticipanteventsV3ListParticipantEventsResponse = <T extends Partial<WixCalendarParticipanteventsV3ListParticipantEventsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('events')) {
        result.events = overrides && overrides.hasOwnProperty('events') ? overrides.events!.map((x) => aWixCalendarEventsV3Event(x ?? {}, pickedFields.get('events'))) : [aWixCalendarEventsV3Event({}, pickedFields.get('events'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput = <T extends Partial<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 9101;
    }

    return result;
};

export const aWixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata = <T extends Partial<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3249;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixCalendarParticipanteventsV3UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixCalendarParticipanteventsV3UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }

    return result;
};

export const aWixCalendarParticipanteventsV3UpstreamWixCommonCursors = <T extends Partial<WixCalendarParticipanteventsV3UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'et';
    }

    return result;
};

export const aWixCalendarSchedulesV3CancelScheduleRequestInput = <T extends Partial<WixCalendarSchedulesV3CancelScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aWixCalendarSchedulesV3ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aWixCalendarSchedulesV3ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('preserveFutureEventsWithParticipants')) {
        result.preserveFutureEventsWithParticipants = overrides && overrides.hasOwnProperty('preserveFutureEventsWithParticipants') ? overrides.preserveFutureEventsWithParticipants! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'ullam';
    }

    return result;
};

export const aWixCalendarSchedulesV3CancelScheduleResponse = <T extends Partial<WixCalendarSchedulesV3CancelScheduleResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixCalendarSchedulesV3Schedule(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixCalendarSchedulesV3Schedule({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aWixCalendarSchedulesV3CloneScheduleRequestInput = <T extends Partial<WixCalendarSchedulesV3CloneScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldmask')) {
        result.fieldmask = overrides && overrides.hasOwnProperty('fieldmask') ? overrides.fieldmask! : ['enim'];
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixCalendarSchedulesV3ScheduleInput(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixCalendarSchedulesV3ScheduleInput({}, pickedFields.get('schedule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleId')) {
        result.scheduleId = overrides && overrides.hasOwnProperty('scheduleId') ? overrides.scheduleId! : 'laborum';
    }

    return result;
};

export const aWixCalendarSchedulesV3CloneScheduleResponse = <T extends Partial<WixCalendarSchedulesV3CloneScheduleResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixCalendarSchedulesV3Schedule(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixCalendarSchedulesV3Schedule({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aWixCalendarSchedulesV3ConferencingDetails = <T extends Partial<WixCalendarSchedulesV3ConferencingDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('guestUrl')) {
        result.guestUrl = overrides && overrides.hasOwnProperty('guestUrl') ? overrides.guestUrl! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('hostUrl')) {
        result.hostUrl = overrides && overrides.hasOwnProperty('hostUrl') ? overrides.hostUrl! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('password')) {
        result.password = overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCalendarSchedulesV3ConferencingDetailsType.Custom;
    }

    return result;
};

export const aWixCalendarSchedulesV3ConferencingDetailsInput = <T extends Partial<WixCalendarSchedulesV3ConferencingDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('guestUrl')) {
        result.guestUrl = overrides && overrides.hasOwnProperty('guestUrl') ? overrides.guestUrl! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('hostUrl')) {
        result.hostUrl = overrides && overrides.hasOwnProperty('hostUrl') ? overrides.hostUrl! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('password')) {
        result.password = overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCalendarSchedulesV3ConferencingDetailsType.Custom;
    }

    return result;
};

export const aWixCalendarSchedulesV3CreateScheduleRequestInput = <T extends Partial<WixCalendarSchedulesV3CreateScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('idempotencyKey')) {
        result.idempotencyKey = overrides && overrides.hasOwnProperty('idempotencyKey') ? overrides.idempotencyKey! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixCalendarSchedulesV3ScheduleInput(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixCalendarSchedulesV3ScheduleInput({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aWixCalendarSchedulesV3CreateScheduleResponse = <T extends Partial<WixCalendarSchedulesV3CreateScheduleResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixCalendarSchedulesV3Schedule(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixCalendarSchedulesV3Schedule({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aWixCalendarSchedulesV3GetScheduleRequestInput = <T extends Partial<WixCalendarSchedulesV3GetScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixCalendarSchedulesV3RequestedFieldsEnumRequestedFields.OwnPiFields];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b50b64a4-de73-429b-b1cb-7e2e4c19a011';
    }

    return result;
};

export const aWixCalendarSchedulesV3Location = <T extends Partial<WixCalendarSchedulesV3Location>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? overrides.address! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aComWixpressLocationsLocation(overrides.location ?? {}, pickedFields.get('location')) : aComWixpressLocationsLocation({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCalendarSchedulesV3LocationType.Business;
    }

    return result;
};

export const aWixCalendarSchedulesV3LocationInput = <T extends Partial<WixCalendarSchedulesV3LocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? overrides.address! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCalendarSchedulesV3LocationType.Business;
    }

    return result;
};

export const aWixCalendarSchedulesV3ParticipantNotificationInput = <T extends Partial<WixCalendarSchedulesV3ParticipantNotificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? overrides.metadata! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('notifyParticipants')) {
        result.notifyParticipants = overrides && overrides.hasOwnProperty('notifyParticipants') ? overrides.notifyParticipants! : false;
    }

    return result;
};

export const aWixCalendarSchedulesV3Permission = <T extends Partial<WixCalendarSchedulesV3Permission>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('identity')) {
        result.identity = overrides && overrides.hasOwnProperty('identity') ? aWixCalendarSchedulesV3UpstreamWixCommonIdentificationData(overrides.identity ?? {}, pickedFields.get('identity')) : aWixCalendarSchedulesV3UpstreamWixCommonIdentificationData({}, pickedFields.get('identity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('role')) {
        result.role = overrides && overrides.hasOwnProperty('role') ? overrides.role! : WixCalendarSchedulesV3PermissionRole.Commenter;
    }

    return result;
};

export const aWixCalendarSchedulesV3PermissionInput = <T extends Partial<WixCalendarSchedulesV3PermissionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('identity')) {
        result.identity = overrides && overrides.hasOwnProperty('identity') ? aWixCalendarSchedulesV3UpstreamWixCommonIdentificationDataInput(overrides.identity ?? {}, pickedFields.get('identity')) : aWixCalendarSchedulesV3UpstreamWixCommonIdentificationDataInput({}, pickedFields.get('identity'));
    }
    if (pickedFields.size === 0 || pickedFields.has('role')) {
        result.role = overrides && overrides.hasOwnProperty('role') ? overrides.role! : WixCalendarSchedulesV3PermissionRole.Commenter;
    }

    return result;
};

export const aWixCalendarSchedulesV3QuerySchedulesRequestInput = <T extends Partial<WixCalendarSchedulesV3QuerySchedulesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('consistent')) {
        result.consistent = overrides && overrides.hasOwnProperty('consistent') ? overrides.consistent! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixCalendarSchedulesV3RequestedFieldsEnumRequestedFields.OwnPiFields];
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCalendarSchedulesV3UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixCalendarSchedulesV3UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixCalendarSchedulesV3QuerySchedulesResponse = <T extends Partial<WixCalendarSchedulesV3QuerySchedulesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixCalendarSchedulesV3Schedule(x ?? {}, pickedFields.get('items'))) : [aWixCalendarSchedulesV3Schedule({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixCalendarSchedulesV3Schedule = <T extends Partial<WixCalendarSchedulesV3Schedule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('businessTimeZoneEnabled')) {
        result.businessTimeZoneEnabled = overrides && overrides.hasOwnProperty('businessTimeZoneEnabled') ? overrides.businessTimeZoneEnabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultCapacity')) {
        result.defaultCapacity = overrides && overrides.hasOwnProperty('defaultCapacity') ? overrides.defaultCapacity! : 7781;
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultConferencingDetails')) {
        result.defaultConferencingDetails = overrides && overrides.hasOwnProperty('defaultConferencingDetails') ? aWixCalendarSchedulesV3ConferencingDetails(overrides.defaultConferencingDetails ?? {}, pickedFields.get('defaultConferencingDetails')) : aWixCalendarSchedulesV3ConferencingDetails({}, pickedFields.get('defaultConferencingDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultLocation')) {
        result.defaultLocation = overrides && overrides.hasOwnProperty('defaultLocation') ? aWixCalendarSchedulesV3Location(overrides.defaultLocation ?? {}, pickedFields.get('defaultLocation')) : aWixCalendarSchedulesV3Location({}, pickedFields.get('defaultLocation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultTitle')) {
        result.defaultTitle = overrides && overrides.hasOwnProperty('defaultTitle') ? overrides.defaultTitle! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventsVirtualReference')) {
        result.eventsVirtualReference = overrides && overrides.hasOwnProperty('eventsVirtualReference') ? aWixCalendarEventsV3QueryEventsResponse(overrides.eventsVirtualReference ?? {}, pickedFields.get('eventsVirtualReference')) : aWixCalendarEventsV3QueryEventsResponse({}, pickedFields.get('eventsVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('permissions')) {
        result.permissions = overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions!.map((x) => aWixCalendarSchedulesV3Permission(x ?? {}, pickedFields.get('permissions'))) : [aWixCalendarSchedulesV3Permission({}, pickedFields.get('permissions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixCalendarSchedulesV3ScheduleStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'ut';
    }

    return result;
};

export const aWixCalendarSchedulesV3ScheduleInput = <T extends Partial<WixCalendarSchedulesV3ScheduleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'cupiditate';
    }
    if (pickedFields.size === 0 || pickedFields.has('businessTimeZoneEnabled')) {
        result.businessTimeZoneEnabled = overrides && overrides.hasOwnProperty('businessTimeZoneEnabled') ? overrides.businessTimeZoneEnabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultCapacity')) {
        result.defaultCapacity = overrides && overrides.hasOwnProperty('defaultCapacity') ? overrides.defaultCapacity! : 2486;
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultConferencingDetails')) {
        result.defaultConferencingDetails = overrides && overrides.hasOwnProperty('defaultConferencingDetails') ? aWixCalendarSchedulesV3ConferencingDetailsInput(overrides.defaultConferencingDetails ?? {}, pickedFields.get('defaultConferencingDetails')) : aWixCalendarSchedulesV3ConferencingDetailsInput({}, pickedFields.get('defaultConferencingDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultLocation')) {
        result.defaultLocation = overrides && overrides.hasOwnProperty('defaultLocation') ? aWixCalendarSchedulesV3LocationInput(overrides.defaultLocation ?? {}, pickedFields.get('defaultLocation')) : aWixCalendarSchedulesV3LocationInput({}, pickedFields.get('defaultLocation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultTitle')) {
        result.defaultTitle = overrides && overrides.hasOwnProperty('defaultTitle') ? overrides.defaultTitle! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('permissions')) {
        result.permissions = overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions!.map((x) => aWixCalendarSchedulesV3PermissionInput({}, pickedFields.get('permissions'))) : [aWixCalendarSchedulesV3PermissionInput({}, pickedFields.get('permissions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixCalendarSchedulesV3ScheduleStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'quae';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'id';
    }

    return result;
};

export const aWixCalendarSchedulesV3UpdateScheduleRequestInput = <T extends Partial<WixCalendarSchedulesV3UpdateScheduleRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldmask')) {
        result.fieldmask = overrides && overrides.hasOwnProperty('fieldmask') ? overrides.fieldmask! : ['est'];
    }
    if (pickedFields.size === 0 || pickedFields.has('participantNotification')) {
        result.participantNotification = overrides && overrides.hasOwnProperty('participantNotification') ? aWixCalendarSchedulesV3ParticipantNotificationInput(overrides.participantNotification ?? {}, pickedFields.get('participantNotification')) : aWixCalendarSchedulesV3ParticipantNotificationInput({}, pickedFields.get('participantNotification'));
    }
    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixCalendarSchedulesV3ScheduleInput(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixCalendarSchedulesV3ScheduleInput({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aWixCalendarSchedulesV3UpdateScheduleResponse = <T extends Partial<WixCalendarSchedulesV3UpdateScheduleResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('schedule')) {
        result.schedule = overrides && overrides.hasOwnProperty('schedule') ? aWixCalendarSchedulesV3Schedule(overrides.schedule ?? {}, pickedFields.get('schedule')) : aWixCalendarSchedulesV3Schedule({}, pickedFields.get('schedule'));
    }

    return result;
};

export const aWixCalendarSchedulesV3UpstreamWixCommonCursorPagingInput = <T extends Partial<WixCalendarSchedulesV3UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2424;
    }

    return result;
};

export const aWixCalendarSchedulesV3UpstreamWixCommonCursorQueryInput = <T extends Partial<WixCalendarSchedulesV3UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCalendarSchedulesV3UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCalendarSchedulesV3UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'eos';
    }

    return result;
};

export const aWixCalendarSchedulesV3UpstreamWixCommonIdentificationData = <T extends Partial<WixCalendarSchedulesV3UpstreamWixCommonIdentificationData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('identityType')) {
        result.identityType = overrides && overrides.hasOwnProperty('identityType') ? overrides.identityType! : WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataIdentityType.Unknown;
    }
    if (pickedFields.size === 0 || pickedFields.has('wixUserId')) {
        result.wixUserId = overrides && overrides.hasOwnProperty('wixUserId') ? overrides.wixUserId! : 'ut';
    }

    return result;
};

export const aWixCalendarSchedulesV3UpstreamWixCommonIdentificationDataInput = <T extends Partial<WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('identityType')) {
        result.identityType = overrides && overrides.hasOwnProperty('identityType') ? overrides.identityType! : WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataIdentityType.Unknown;
    }
    if (pickedFields.size === 0 || pickedFields.has('wixUserId')) {
        result.wixUserId = overrides && overrides.hasOwnProperty('wixUserId') ? overrides.wixUserId! : 'illum';
    }

    return result;
};

export const aWixCatalogApiV1AddProductMediaRequestInput = <T extends Partial<WixCatalogApiV1AddProductMediaRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? overrides.media!.map((x) => aWixCatalogApiV1MediaDataForWriteInput({}, pickedFields.get('media'))) : [aWixCatalogApiV1MediaDataForWriteInput({}, pickedFields.get('media'))];
    }

    return result;
};

export const aWixCatalogApiV1AddProductMediaToChoicesRequestInput = <T extends Partial<WixCatalogApiV1AddProductMediaToChoicesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? overrides.media!.map((x) => aWixCatalogApiV1MediaAssignmentToChoiceInput({}, pickedFields.get('media'))) : [aWixCatalogApiV1MediaAssignmentToChoiceInput({}, pickedFields.get('media'))];
    }

    return result;
};

export const aWixCatalogApiV1AddProductsToCollectionRequestInput = <T extends Partial<WixCatalogApiV1AddProductsToCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('productIds')) {
        result.productIds = overrides && overrides.hasOwnProperty('productIds') ? overrides.productIds! : ['saepe'];
    }

    return result;
};

export const aWixCatalogApiV1AdditionalInfoSection = <T extends Partial<WixCatalogApiV1AdditionalInfoSection>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'non';
    }

    return result;
};

export const aWixCatalogApiV1AdditionalInfoSectionInput = <T extends Partial<WixCatalogApiV1AdditionalInfoSectionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'et';
    }

    return result;
};

export const aWixCatalogApiV1AdjustValueInput = <T extends Partial<WixCatalogApiV1AdjustValueInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cost')) {
        result.cost = overrides && overrides.hasOwnProperty('cost') ? aWixCatalogApiV1PropertyAdjustmentDataInput(overrides.cost ?? {}, pickedFields.get('cost')) : aWixCatalogApiV1PropertyAdjustmentDataInput({}, pickedFields.get('cost'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aWixCatalogApiV1PropertyAdjustmentDataInput(overrides.price ?? {}, pickedFields.get('price')) : aWixCatalogApiV1PropertyAdjustmentDataInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? aWixCatalogApiV1PropertyAdjustmentDataInput(overrides.weight ?? {}, pickedFields.get('weight')) : aWixCatalogApiV1PropertyAdjustmentDataInput({}, pickedFields.get('weight'));
    }

    return result;
};

export const aWixCatalogApiV1AggregateProductsRequestInput = <T extends Partial<WixCatalogApiV1AggregateProductsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregation')) {
        result.aggregation = overrides && overrides.hasOwnProperty('aggregation') ? overrides.aggregation! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('includeHiddenProducts')) {
        result.includeHiddenProducts = overrides && overrides.hasOwnProperty('includeHiddenProducts') ? overrides.includeHiddenProducts! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeMerchantSpecificData')) {
        result.includeMerchantSpecificData = overrides && overrides.hasOwnProperty('includeMerchantSpecificData') ? overrides.includeMerchantSpecificData! : false;
    }

    return result;
};

export const aWixCatalogApiV1AggregateProductsResponse = <T extends Partial<WixCatalogApiV1AggregateProductsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregates')) {
        result.aggregates = overrides && overrides.hasOwnProperty('aggregates') ? overrides.aggregates! : 'eveniet';
    }

    return result;
};

export const aWixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncRequestInput = <T extends Partial<WixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('adjust')) {
        result.adjust = overrides && overrides.hasOwnProperty('adjust') ? aWixCatalogApiV1AdjustValueInput(overrides.adjust ?? {}, pickedFields.get('adjust')) : aWixCatalogApiV1AdjustValueInput({}, pickedFields.get('adjust'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'aut';
    }

    return result;
};

export const aWixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncResponse = <T extends Partial<WixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCatalogApiV1BulkProductResult(x ?? {}, pickedFields.get('results'))) : [aWixCatalogApiV1BulkProductResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCatalogApiV1BulkAdjustProductPropertiesRequestInput = <T extends Partial<WixCatalogApiV1BulkAdjustProductPropertiesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('adjust')) {
        result.adjust = overrides && overrides.hasOwnProperty('adjust') ? aWixCatalogApiV1AdjustValueInput(overrides.adjust ?? {}, pickedFields.get('adjust')) : aWixCatalogApiV1AdjustValueInput({}, pickedFields.get('adjust'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['et'];
    }

    return result;
};

export const aWixCatalogApiV1BulkAdjustProductPropertiesResponse = <T extends Partial<WixCatalogApiV1BulkAdjustProductPropertiesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCatalogApiV1BulkProductResult(x ?? {}, pickedFields.get('results'))) : [aWixCatalogApiV1BulkProductResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCatalogApiV1BulkDeleteProductsRequestInput = <T extends Partial<WixCatalogApiV1BulkDeleteProductsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['enim'];
    }

    return result;
};

export const aWixCatalogApiV1BulkProductResult = <T extends Partial<WixCatalogApiV1BulkProductResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixCatalogApiV1BulkQueryCustomFieldsRequestInput = <T extends Partial<WixCatalogApiV1BulkQueryCustomFieldsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('names')) {
        result.names = overrides && overrides.hasOwnProperty('names') ? overrides.names! : ['perferendis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCatalogApiV1QueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixCatalogApiV1QueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixCatalogApiV1BulkQueryCustomFieldsResponse = <T extends Partial<WixCatalogApiV1BulkQueryCustomFieldsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixCatalogApiV1PagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixCatalogApiV1PagingMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('productIdToCustomFields')) {
        result.productIdToCustomFields = overrides && overrides.hasOwnProperty('productIdToCustomFields') ? aWixCatalogApiV1CustomFieldsContainer(overrides.productIdToCustomFields ?? {}, pickedFields.get('productIdToCustomFields')) : aWixCatalogApiV1CustomFieldsContainer({}, pickedFields.get('productIdToCustomFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalResults')) {
        result.totalResults = overrides && overrides.hasOwnProperty('totalResults') ? overrides.totalResults! : 6099;
    }

    return result;
};

export const aWixCatalogApiV1BulkRemoveCustomFieldsRequestInput = <T extends Partial<WixCatalogApiV1BulkRemoveCustomFieldsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('names')) {
        result.names = overrides && overrides.hasOwnProperty('names') ? overrides.names! : ['eum'];
    }

    return result;
};

export const aWixCatalogApiV1BulkSetCustomFieldsRequestInput = <T extends Partial<WixCatalogApiV1BulkSetCustomFieldsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'molestias';
    }

    return result;
};

export const aWixCatalogApiV1BulkUpdateProductsByFilterSyncRequestInput = <T extends Partial<WixCatalogApiV1BulkUpdateProductsByFilterSyncRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('set')) {
        result.set = overrides && overrides.hasOwnProperty('set') ? aWixCatalogApiV1SetValueInput(overrides.set ?? {}, pickedFields.get('set')) : aWixCatalogApiV1SetValueInput({}, pickedFields.get('set'));
    }

    return result;
};

export const aWixCatalogApiV1BulkUpdateProductsByFilterSyncResponse = <T extends Partial<WixCatalogApiV1BulkUpdateProductsByFilterSyncResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCatalogApiV1BulkProductResult(x ?? {}, pickedFields.get('results'))) : [aWixCatalogApiV1BulkProductResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCatalogApiV1BulkUpdateProductsRequestInput = <T extends Partial<WixCatalogApiV1BulkUpdateProductsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['ea'];
    }
    if (pickedFields.size === 0 || pickedFields.has('set')) {
        result.set = overrides && overrides.hasOwnProperty('set') ? aWixCatalogApiV1SetValueInput(overrides.set ?? {}, pickedFields.get('set')) : aWixCatalogApiV1SetValueInput({}, pickedFields.get('set'));
    }

    return result;
};

export const aWixCatalogApiV1BulkUpdateProductsResponse = <T extends Partial<WixCatalogApiV1BulkUpdateProductsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCatalogApiV1BulkProductResult(x ?? {}, pickedFields.get('results'))) : [aWixCatalogApiV1BulkProductResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCatalogApiV1Choice = <T extends Partial<WixCatalogApiV1Choice>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('inStock')) {
        result.inStock = overrides && overrides.hasOwnProperty('inStock') ? overrides.inStock! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixCatalogApiV1Media(overrides.media ?? {}, pickedFields.get('media')) : aWixCatalogApiV1Media({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : false;
    }

    return result;
};

export const aWixCatalogApiV1ChoiceInput = <T extends Partial<WixCatalogApiV1ChoiceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('inStock')) {
        result.inStock = overrides && overrides.hasOwnProperty('inStock') ? overrides.inStock! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixCatalogApiV1MediaInput(overrides.media ?? {}, pickedFields.get('media')) : aWixCatalogApiV1MediaInput({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : true;
    }

    return result;
};

export const aWixCatalogApiV1Collection = <T extends Partial<WixCatalogApiV1Collection>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastUpdated')) {
        result.lastUpdated = overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixCatalogApiV1Media(overrides.media ?? {}, pickedFields.get('media')) : aWixCatalogApiV1Media({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOfProducts')) {
        result.numberOfProducts = overrides && overrides.hasOwnProperty('numberOfProducts') ? overrides.numberOfProducts! : 7629;
    }
    if (pickedFields.size === 0 || pickedFields.has('productsVirtualReference')) {
        result.productsVirtualReference = overrides && overrides.hasOwnProperty('productsVirtualReference') ? aWixCatalogApiV1QueryProductsPlatformizedResponse(overrides.productsVirtualReference ?? {}, pickedFields.get('productsVirtualReference')) : aWixCatalogApiV1QueryProductsPlatformizedResponse({}, pickedFields.get('productsVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('seoSchema')) {
        result.seoSchema = overrides && overrides.hasOwnProperty('seoSchema') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoSchema ?? {}, pickedFields.get('seoSchema')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoSchema'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : true;
    }

    return result;
};

export const aWixCatalogApiV1CollectionInput = <T extends Partial<WixCatalogApiV1CollectionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastUpdated')) {
        result.lastUpdated = overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixCatalogApiV1MediaInput(overrides.media ?? {}, pickedFields.get('media')) : aWixCatalogApiV1MediaInput({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'expedita';
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOfProducts')) {
        result.numberOfProducts = overrides && overrides.hasOwnProperty('numberOfProducts') ? overrides.numberOfProducts! : 193;
    }
    if (pickedFields.size === 0 || pickedFields.has('seoSchema')) {
        result.seoSchema = overrides && overrides.hasOwnProperty('seoSchema') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoSchema ?? {}, pickedFields.get('seoSchema')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoSchema'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : true;
    }

    return result;
};

export const aWixCatalogApiV1CostAndProfitData = <T extends Partial<WixCatalogApiV1CostAndProfitData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('formattedItemCost')) {
        result.formattedItemCost = overrides && overrides.hasOwnProperty('formattedItemCost') ? overrides.formattedItemCost! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedProfit')) {
        result.formattedProfit = overrides && overrides.hasOwnProperty('formattedProfit') ? overrides.formattedProfit! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemCost')) {
        result.itemCost = overrides && overrides.hasOwnProperty('itemCost') ? overrides.itemCost! : 0.35;
    }
    if (pickedFields.size === 0 || pickedFields.has('profit')) {
        result.profit = overrides && overrides.hasOwnProperty('profit') ? overrides.profit! : 7.25;
    }
    if (pickedFields.size === 0 || pickedFields.has('profitMargin')) {
        result.profitMargin = overrides && overrides.hasOwnProperty('profitMargin') ? overrides.profitMargin! : 1.51;
    }

    return result;
};

export const aWixCatalogApiV1CostAndProfitDataInput = <T extends Partial<WixCatalogApiV1CostAndProfitDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('formattedItemCost')) {
        result.formattedItemCost = overrides && overrides.hasOwnProperty('formattedItemCost') ? overrides.formattedItemCost! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedProfit')) {
        result.formattedProfit = overrides && overrides.hasOwnProperty('formattedProfit') ? overrides.formattedProfit! : 'at';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemCost')) {
        result.itemCost = overrides && overrides.hasOwnProperty('itemCost') ? overrides.itemCost! : 8.36;
    }
    if (pickedFields.size === 0 || pickedFields.has('profit')) {
        result.profit = overrides && overrides.hasOwnProperty('profit') ? overrides.profit! : 2.29;
    }
    if (pickedFields.size === 0 || pickedFields.has('profitMargin')) {
        result.profitMargin = overrides && overrides.hasOwnProperty('profitMargin') ? overrides.profitMargin! : 5.37;
    }

    return result;
};

export const aWixCatalogApiV1CreateCollectionRequestInput = <T extends Partial<WixCatalogApiV1CreateCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collection')) {
        result.collection = overrides && overrides.hasOwnProperty('collection') ? aWixCatalogApiV1CollectionInput(overrides.collection ?? {}, pickedFields.get('collection')) : aWixCatalogApiV1CollectionInput({}, pickedFields.get('collection'));
    }

    return result;
};

export const aWixCatalogApiV1CreateCollectionResponse = <T extends Partial<WixCatalogApiV1CreateCollectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collection')) {
        result.collection = overrides && overrides.hasOwnProperty('collection') ? aWixCatalogApiV1Collection(overrides.collection ?? {}, pickedFields.get('collection')) : aWixCatalogApiV1Collection({}, pickedFields.get('collection'));
    }

    return result;
};

export const aWixCatalogApiV1CreateDigitalProductRequestInput = <T extends Partial<WixCatalogApiV1CreateDigitalProductRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1ProductInput(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1ProductInput({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogApiV1CreateDigitalProductResponse = <T extends Partial<WixCatalogApiV1CreateDigitalProductResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1Product(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1Product({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogApiV1CreateProductPlatformizedRequestInput = <T extends Partial<WixCatalogApiV1CreateProductPlatformizedRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1ProductInput(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1ProductInput({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogApiV1CreateProductPlatformizedResponse = <T extends Partial<WixCatalogApiV1CreateProductPlatformizedResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1Product(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1Product({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogApiV1CreateProductRequestInput = <T extends Partial<WixCatalogApiV1CreateProductRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1ProductInput(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1ProductInput({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogApiV1CreateProductResponse = <T extends Partial<WixCatalogApiV1CreateProductResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1Product(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1Product({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogApiV1CustomFieldsContainer = <T extends Partial<WixCatalogApiV1CustomFieldsContainer>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : 'dolorem';
    }

    return result;
};

export const aWixCatalogApiV1CustomTextField = <T extends Partial<WixCatalogApiV1CustomTextField>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mandatory')) {
        result.mandatory = overrides && overrides.hasOwnProperty('mandatory') ? overrides.mandatory! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxLength')) {
        result.maxLength = overrides && overrides.hasOwnProperty('maxLength') ? overrides.maxLength! : 1489;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'autem';
    }

    return result;
};

export const aWixCatalogApiV1CustomTextFieldInput = <T extends Partial<WixCatalogApiV1CustomTextFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mandatory')) {
        result.mandatory = overrides && overrides.hasOwnProperty('mandatory') ? overrides.mandatory! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxLength')) {
        result.maxLength = overrides && overrides.hasOwnProperty('maxLength') ? overrides.maxLength! : 9859;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'minus';
    }

    return result;
};

export const aWixCatalogApiV1DeleteCollectionRequestInput = <T extends Partial<WixCatalogApiV1DeleteCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quia';
    }

    return result;
};

export const aWixCatalogApiV1DeleteProductOptionsRequestInput = <T extends Partial<WixCatalogApiV1DeleteProductOptionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }

    return result;
};

export const aWixCatalogApiV1DeleteProductPlatformizedRequestInput = <T extends Partial<WixCatalogApiV1DeleteProductPlatformizedRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'rerum';
    }

    return result;
};

export const aWixCatalogApiV1DeleteProductRequestInput = <T extends Partial<WixCatalogApiV1DeleteProductRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'neque';
    }

    return result;
};

export const aWixCatalogApiV1Discount = <T extends Partial<WixCatalogApiV1Discount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCatalogApiV1DiscountDiscountType.Amount;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 0.66;
    }

    return result;
};

export const aWixCatalogApiV1DiscountInput = <T extends Partial<WixCatalogApiV1DiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCatalogApiV1DiscountDiscountType.Amount;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 9.48;
    }

    return result;
};

export const aWixCatalogApiV1FormattedPrice = <T extends Partial<WixCatalogApiV1FormattedPrice>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discountedPrice')) {
        result.discountedPrice = overrides && overrides.hasOwnProperty('discountedPrice') ? overrides.discountedPrice! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('pricePerUnit')) {
        result.pricePerUnit = overrides && overrides.hasOwnProperty('pricePerUnit') ? overrides.pricePerUnit! : 'eum';
    }

    return result;
};

export const aWixCatalogApiV1FormattedPriceInput = <T extends Partial<WixCatalogApiV1FormattedPriceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discountedPrice')) {
        result.discountedPrice = overrides && overrides.hasOwnProperty('discountedPrice') ? overrides.discountedPrice! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('pricePerUnit')) {
        result.pricePerUnit = overrides && overrides.hasOwnProperty('pricePerUnit') ? overrides.pricePerUnit! : 'facilis';
    }

    return result;
};

export const aWixCatalogApiV1GetCollectionBySlugRequestInput = <T extends Partial<WixCatalogApiV1GetCollectionBySlugRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'facilis';
    }

    return result;
};

export const aWixCatalogApiV1GetCollectionBySlugResponse = <T extends Partial<WixCatalogApiV1GetCollectionBySlugResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collection')) {
        result.collection = overrides && overrides.hasOwnProperty('collection') ? aWixCatalogApiV1Collection(overrides.collection ?? {}, pickedFields.get('collection')) : aWixCatalogApiV1Collection({}, pickedFields.get('collection'));
    }

    return result;
};

export const aWixCatalogApiV1GetCollectionRequestInput = <T extends Partial<WixCatalogApiV1GetCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('includeNumberOfProducts')) {
        result.includeNumberOfProducts = overrides && overrides.hasOwnProperty('includeNumberOfProducts') ? overrides.includeNumberOfProducts! : true;
    }

    return result;
};

export const aWixCatalogApiV1GetCollectionResponse = <T extends Partial<WixCatalogApiV1GetCollectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collection')) {
        result.collection = overrides && overrides.hasOwnProperty('collection') ? aWixCatalogApiV1Collection(overrides.collection ?? {}, pickedFields.get('collection')) : aWixCatalogApiV1Collection({}, pickedFields.get('collection'));
    }

    return result;
};

export const aWixCatalogApiV1GetProductRequestInput = <T extends Partial<WixCatalogApiV1GetProductRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '89aa3f12-c06f-46a0-b3f1-39e3b832d1fd';
    }
    if (pickedFields.size === 0 || pickedFields.has('includeMerchantSpecificData')) {
        result.includeMerchantSpecificData = overrides && overrides.hasOwnProperty('includeMerchantSpecificData') ? overrides.includeMerchantSpecificData! : true;
    }

    return result;
};

export const aWixCatalogApiV1GetProductResponse = <T extends Partial<WixCatalogApiV1GetProductResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1Product(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1Product({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogApiV1GetProductsRequestInput = <T extends Partial<WixCatalogApiV1GetProductsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['temporibus'];
    }

    return result;
};

export const aWixCatalogApiV1GetProductsResponse = <T extends Partial<WixCatalogApiV1GetProductsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('products')) {
        result.products = overrides && overrides.hasOwnProperty('products') ? overrides.products!.map((x) => aWixCatalogApiV1Product(x ?? {}, pickedFields.get('products'))) : [aWixCatalogApiV1Product({}, pickedFields.get('products'))];
    }

    return result;
};

export const aWixCatalogApiV1GetStoreVariantRequestInput = <T extends Partial<WixCatalogApiV1GetStoreVariantRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'fuga';
    }

    return result;
};

export const aWixCatalogApiV1GetStoreVariantResponse = <T extends Partial<WixCatalogApiV1GetStoreVariantResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('variant')) {
        result.variant = overrides && overrides.hasOwnProperty('variant') ? aWixCatalogApiV1StoreVariant(overrides.variant ?? {}, pickedFields.get('variant')) : aWixCatalogApiV1StoreVariant({}, pickedFields.get('variant'));
    }

    return result;
};

export const aWixCatalogApiV1Media = <T extends Partial<WixCatalogApiV1Media>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixCatalogApiV1MediaItem(x ?? {}, pickedFields.get('items'))) : [aWixCatalogApiV1MediaItem({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('mainMedia')) {
        result.mainMedia = overrides && overrides.hasOwnProperty('mainMedia') ? aWixCatalogApiV1MediaItem(overrides.mainMedia ?? {}, pickedFields.get('mainMedia')) : aWixCatalogApiV1MediaItem({}, pickedFields.get('mainMedia'));
    }

    return result;
};

export const aWixCatalogApiV1MediaAssignmentToChoiceInput = <T extends Partial<WixCatalogApiV1MediaAssignmentToChoiceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choice')) {
        result.choice = overrides && overrides.hasOwnProperty('choice') ? overrides.choice! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('mediaIds')) {
        result.mediaIds = overrides && overrides.hasOwnProperty('mediaIds') ? overrides.mediaIds! : ['nobis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('option')) {
        result.option = overrides && overrides.hasOwnProperty('option') ? overrides.option! : 'distinctio';
    }

    return result;
};

export const aWixCatalogApiV1MediaDataForWriteInput = <T extends Partial<WixCatalogApiV1MediaDataForWriteInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choice')) {
        result.choice = overrides && overrides.hasOwnProperty('choice') ? aWixCatalogApiV1MediaDataForWriteOptionAndChoiceInput(overrides.choice ?? {}, pickedFields.get('choice')) : aWixCatalogApiV1MediaDataForWriteOptionAndChoiceInput({}, pickedFields.get('choice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mediaId')) {
        result.mediaId = overrides && overrides.hasOwnProperty('mediaId') ? overrides.mediaId! : 'repudiandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'quae';
    }

    return result;
};

export const aWixCatalogApiV1MediaDataForWriteOptionAndChoiceInput = <T extends Partial<WixCatalogApiV1MediaDataForWriteOptionAndChoiceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choice')) {
        result.choice = overrides && overrides.hasOwnProperty('choice') ? overrides.choice! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('option')) {
        result.option = overrides && overrides.hasOwnProperty('option') ? overrides.option! : 'enim';
    }

    return result;
};

export const aWixCatalogApiV1MediaInput = <T extends Partial<WixCatalogApiV1MediaInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixCatalogApiV1MediaItemInput({}, pickedFields.get('items'))) : [aWixCatalogApiV1MediaItemInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('mainMedia')) {
        result.mainMedia = overrides && overrides.hasOwnProperty('mainMedia') ? aWixCatalogApiV1MediaItemInput(overrides.mainMedia ?? {}, pickedFields.get('mainMedia')) : aWixCatalogApiV1MediaItemInput({}, pickedFields.get('mainMedia'));
    }

    return result;
};

export const aWixCatalogApiV1MediaItem = <T extends Partial<WixCatalogApiV1MediaItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCatalogApiV1MediaItemUrlAndSize(overrides.image ?? {}, pickedFields.get('image')) : aWixCatalogApiV1MediaItemUrlAndSize({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mediaType')) {
        result.mediaType = overrides && overrides.hasOwnProperty('mediaType') ? overrides.mediaType! : WixCatalogApiV1MediaItemType.Audio;
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnail')) {
        result.thumbnail = overrides && overrides.hasOwnProperty('thumbnail') ? aWixCatalogApiV1MediaItemUrlAndSize(overrides.thumbnail ?? {}, pickedFields.get('thumbnail')) : aWixCatalogApiV1MediaItemUrlAndSize({}, pickedFields.get('thumbnail'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCatalogApiV1MediaItemVideo(overrides.video ?? {}, pickedFields.get('video')) : aWixCatalogApiV1MediaItemVideo({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixCatalogApiV1MediaItemInput = <T extends Partial<WixCatalogApiV1MediaItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCatalogApiV1MediaItemUrlAndSizeInput(overrides.image ?? {}, pickedFields.get('image')) : aWixCatalogApiV1MediaItemUrlAndSizeInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mediaType')) {
        result.mediaType = overrides && overrides.hasOwnProperty('mediaType') ? overrides.mediaType! : WixCatalogApiV1MediaItemType.Audio;
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnail')) {
        result.thumbnail = overrides && overrides.hasOwnProperty('thumbnail') ? aWixCatalogApiV1MediaItemUrlAndSizeInput(overrides.thumbnail ?? {}, pickedFields.get('thumbnail')) : aWixCatalogApiV1MediaItemUrlAndSizeInput({}, pickedFields.get('thumbnail'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCatalogApiV1MediaItemVideoInput(overrides.video ?? {}, pickedFields.get('video')) : aWixCatalogApiV1MediaItemVideoInput({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixCatalogApiV1MediaItemUrlAndSize = <T extends Partial<WixCatalogApiV1MediaItemUrlAndSize>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 7111;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 9627;
    }

    return result;
};

export const aWixCatalogApiV1MediaItemUrlAndSizeInput = <T extends Partial<WixCatalogApiV1MediaItemUrlAndSizeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 6792;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 4375;
    }

    return result;
};

export const aWixCatalogApiV1MediaItemVideo = <T extends Partial<WixCatalogApiV1MediaItemVideo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('files')) {
        result.files = overrides && overrides.hasOwnProperty('files') ? overrides.files!.map((x) => aWixCatalogApiV1MediaItemUrlAndSize(x ?? {}, pickedFields.get('files'))) : [aWixCatalogApiV1MediaItemUrlAndSize({}, pickedFields.get('files'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('stillFrameMediaId')) {
        result.stillFrameMediaId = overrides && overrides.hasOwnProperty('stillFrameMediaId') ? overrides.stillFrameMediaId! : 'quam';
    }

    return result;
};

export const aWixCatalogApiV1MediaItemVideoInput = <T extends Partial<WixCatalogApiV1MediaItemVideoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('files')) {
        result.files = overrides && overrides.hasOwnProperty('files') ? overrides.files!.map((x) => aWixCatalogApiV1MediaItemUrlAndSizeInput({}, pickedFields.get('files'))) : [aWixCatalogApiV1MediaItemUrlAndSizeInput({}, pickedFields.get('files'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('stillFrameMediaId')) {
        result.stillFrameMediaId = overrides && overrides.hasOwnProperty('stillFrameMediaId') ? overrides.stillFrameMediaId! : 'quod';
    }

    return result;
};

export const aWixCatalogApiV1PageUrl = <T extends Partial<WixCatalogApiV1PageUrl>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('base')) {
        result.base = overrides && overrides.hasOwnProperty('base') ? overrides.base! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('path')) {
        result.path = overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'molestias';
    }

    return result;
};

export const aWixCatalogApiV1PageUrlInput = <T extends Partial<WixCatalogApiV1PageUrlInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('base')) {
        result.base = overrides && overrides.hasOwnProperty('base') ? overrides.base! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('path')) {
        result.path = overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'aut';
    }

    return result;
};

export const aWixCatalogApiV1PagingInput = <T extends Partial<WixCatalogApiV1PagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 8041;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 5123;
    }

    return result;
};

export const aWixCatalogApiV1PagingMetadata = <T extends Partial<WixCatalogApiV1PagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items! : 8229;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 8345;
    }

    return result;
};

export const aWixCatalogApiV1PagingWithBigLimitInput = <T extends Partial<WixCatalogApiV1PagingWithBigLimitInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 5072;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 4963;
    }

    return result;
};

export const aWixCatalogApiV1PercentageDataInput = <T extends Partial<WixCatalogApiV1PercentageDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 2662;
    }
    if (pickedFields.size === 0 || pickedFields.has('roundToInt')) {
        result.roundToInt = overrides && overrides.hasOwnProperty('roundToInt') ? overrides.roundToInt! : false;
    }

    return result;
};

export const aWixCatalogApiV1PriceData = <T extends Partial<WixCatalogApiV1PriceData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('discountedPrice')) {
        result.discountedPrice = overrides && overrides.hasOwnProperty('discountedPrice') ? overrides.discountedPrice! : 3.77;
    }
    if (pickedFields.size === 0 || pickedFields.has('formatted')) {
        result.formatted = overrides && overrides.hasOwnProperty('formatted') ? aWixCatalogApiV1FormattedPrice(overrides.formatted ?? {}, pickedFields.get('formatted')) : aWixCatalogApiV1FormattedPrice({}, pickedFields.get('formatted'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 0.83;
    }
    if (pickedFields.size === 0 || pickedFields.has('pricePerUnit')) {
        result.pricePerUnit = overrides && overrides.hasOwnProperty('pricePerUnit') ? overrides.pricePerUnit! : 2.39;
    }

    return result;
};

export const aWixCatalogApiV1PriceDataInput = <T extends Partial<WixCatalogApiV1PriceDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('discountedPrice')) {
        result.discountedPrice = overrides && overrides.hasOwnProperty('discountedPrice') ? overrides.discountedPrice! : 5.72;
    }
    if (pickedFields.size === 0 || pickedFields.has('formatted')) {
        result.formatted = overrides && overrides.hasOwnProperty('formatted') ? aWixCatalogApiV1FormattedPriceInput(overrides.formatted ?? {}, pickedFields.get('formatted')) : aWixCatalogApiV1FormattedPriceInput({}, pickedFields.get('formatted'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 5.57;
    }
    if (pickedFields.size === 0 || pickedFields.has('pricePerUnit')) {
        result.pricePerUnit = overrides && overrides.hasOwnProperty('pricePerUnit') ? overrides.pricePerUnit! : 1.83;
    }

    return result;
};

export const aWixCatalogApiV1PricePerUnitData = <T extends Partial<WixCatalogApiV1PricePerUnitData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('baseMeasurementUnit')) {
        result.baseMeasurementUnit = overrides && overrides.hasOwnProperty('baseMeasurementUnit') ? overrides.baseMeasurementUnit! : ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit.Cbm;
    }
    if (pickedFields.size === 0 || pickedFields.has('baseQuantity')) {
        result.baseQuantity = overrides && overrides.hasOwnProperty('baseQuantity') ? overrides.baseQuantity! : 2.3;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalMeasurementUnit')) {
        result.totalMeasurementUnit = overrides && overrides.hasOwnProperty('totalMeasurementUnit') ? overrides.totalMeasurementUnit! : ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit.Cbm;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalQuantity')) {
        result.totalQuantity = overrides && overrides.hasOwnProperty('totalQuantity') ? overrides.totalQuantity! : 9.36;
    }

    return result;
};

export const aWixCatalogApiV1PricePerUnitDataInput = <T extends Partial<WixCatalogApiV1PricePerUnitDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('baseMeasurementUnit')) {
        result.baseMeasurementUnit = overrides && overrides.hasOwnProperty('baseMeasurementUnit') ? overrides.baseMeasurementUnit! : ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit.Cbm;
    }
    if (pickedFields.size === 0 || pickedFields.has('baseQuantity')) {
        result.baseQuantity = overrides && overrides.hasOwnProperty('baseQuantity') ? overrides.baseQuantity! : 1.71;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalMeasurementUnit')) {
        result.totalMeasurementUnit = overrides && overrides.hasOwnProperty('totalMeasurementUnit') ? overrides.totalMeasurementUnit! : ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit.Cbm;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalQuantity')) {
        result.totalQuantity = overrides && overrides.hasOwnProperty('totalQuantity') ? overrides.totalQuantity! : 5.83;
    }

    return result;
};

export const aWixCatalogApiV1Product = <T extends Partial<WixCatalogApiV1Product>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalInfoSections')) {
        result.additionalInfoSections = overrides && overrides.hasOwnProperty('additionalInfoSections') ? overrides.additionalInfoSections!.map((x) => aWixCatalogApiV1AdditionalInfoSection(x ?? {}, pickedFields.get('additionalInfoSections'))) : [aWixCatalogApiV1AdditionalInfoSection({}, pickedFields.get('additionalInfoSections'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('collectionIds')) {
        result.collectionIds = overrides && overrides.hasOwnProperty('collectionIds') ? overrides.collectionIds! : ['numquam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('collections')) {
        result.collections = overrides && overrides.hasOwnProperty('collections') ? aWixCatalogApiV2QueryCollectionsResponse(overrides.collections ?? {}, pickedFields.get('collections')) : aWixCatalogApiV2QueryCollectionsResponse({}, pickedFields.get('collections'));
    }
    if (pickedFields.size === 0 || pickedFields.has('convertedPriceData')) {
        result.convertedPriceData = overrides && overrides.hasOwnProperty('convertedPriceData') ? aWixCatalogApiV1PriceData(overrides.convertedPriceData ?? {}, pickedFields.get('convertedPriceData')) : aWixCatalogApiV1PriceData({}, pickedFields.get('convertedPriceData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('costAndProfitData')) {
        result.costAndProfitData = overrides && overrides.hasOwnProperty('costAndProfitData') ? aWixCatalogApiV1CostAndProfitData(overrides.costAndProfitData ?? {}, pickedFields.get('costAndProfitData')) : aWixCatalogApiV1CostAndProfitData({}, pickedFields.get('costAndProfitData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('costRange')) {
        result.costRange = overrides && overrides.hasOwnProperty('costRange') ? aComWixEcommerceCatalogSpiApiV1NumericPropertyRange(overrides.costRange ?? {}, pickedFields.get('costRange')) : aComWixEcommerceCatalogSpiApiV1NumericPropertyRange({}, pickedFields.get('costRange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('customTextFields')) {
        result.customTextFields = overrides && overrides.hasOwnProperty('customTextFields') ? overrides.customTextFields!.map((x) => aWixCatalogApiV1CustomTextField(x ?? {}, pickedFields.get('customTextFields'))) : [aWixCatalogApiV1CustomTextField({}, pickedFields.get('customTextFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('digitalFile')) {
        result.digitalFile = overrides && overrides.hasOwnProperty('digitalFile') ? aComWixEcommerceCatalogSpiApiV1SecuredMedia(overrides.digitalFile ?? {}, pickedFields.get('digitalFile')) : aComWixEcommerceCatalogSpiApiV1SecuredMedia({}, pickedFields.get('digitalFile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aWixCatalogApiV1Discount(overrides.discount ?? {}, pickedFields.get('discount')) : aWixCatalogApiV1Discount({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('exportProductId')) {
        result.exportProductId = overrides && overrides.hasOwnProperty('exportProductId') ? overrides.exportProductId! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('inventoryItemId')) {
        result.inventoryItemId = overrides && overrides.hasOwnProperty('inventoryItemId') ? overrides.inventoryItemId! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastUpdated')) {
        result.lastUpdated = overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('manageVariants')) {
        result.manageVariants = overrides && overrides.hasOwnProperty('manageVariants') ? overrides.manageVariants! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixCatalogApiV1Media(overrides.media ?? {}, pickedFields.get('media')) : aWixCatalogApiV1Media({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('numericId')) {
        result.numericId = overrides && overrides.hasOwnProperty('numericId') ? overrides.numericId! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aWixCatalogApiV1PriceData(overrides.price ?? {}, pickedFields.get('price')) : aWixCatalogApiV1PriceData({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceData')) {
        result.priceData = overrides && overrides.hasOwnProperty('priceData') ? aWixCatalogApiV1PriceData(overrides.priceData ?? {}, pickedFields.get('priceData')) : aWixCatalogApiV1PriceData({}, pickedFields.get('priceData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pricePerUnitData')) {
        result.pricePerUnitData = overrides && overrides.hasOwnProperty('pricePerUnitData') ? aWixCatalogApiV1PricePerUnitData(overrides.pricePerUnitData ?? {}, pickedFields.get('pricePerUnitData')) : aWixCatalogApiV1PricePerUnitData({}, pickedFields.get('pricePerUnitData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceRange')) {
        result.priceRange = overrides && overrides.hasOwnProperty('priceRange') ? aComWixEcommerceCatalogSpiApiV1NumericPropertyRange(overrides.priceRange ?? {}, pickedFields.get('priceRange')) : aComWixEcommerceCatalogSpiApiV1NumericPropertyRange({}, pickedFields.get('priceRange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('productOptions')) {
        result.productOptions = overrides && overrides.hasOwnProperty('productOptions') ? overrides.productOptions!.map((x) => aWixCatalogApiV1ProductOption(x ?? {}, pickedFields.get('productOptions'))) : [aWixCatalogApiV1ProductOption({}, pickedFields.get('productOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('productPageUrl')) {
        result.productPageUrl = overrides && overrides.hasOwnProperty('productPageUrl') ? aWixCatalogApiV1PageUrl(overrides.productPageUrl ?? {}, pickedFields.get('productPageUrl')) : aWixCatalogApiV1PageUrl({}, pickedFields.get('productPageUrl'));
    }
    if (pickedFields.size === 0 || pickedFields.has('productType')) {
        result.productType = overrides && overrides.hasOwnProperty('productType') ? overrides.productType! : WixCatalogApiV1ProductType.Digital;
    }
    if (pickedFields.size === 0 || pickedFields.has('ribbon')) {
        result.ribbon = overrides && overrides.hasOwnProperty('ribbon') ? overrides.ribbon! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('ribbons')) {
        result.ribbons = overrides && overrides.hasOwnProperty('ribbons') ? overrides.ribbons!.map((x) => aWixCatalogApiV1Ribbon(x ?? {}, pickedFields.get('ribbons'))) : [aWixCatalogApiV1Ribbon({}, pickedFields.get('ribbons'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sku')) {
        result.sku = overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('stock')) {
        result.stock = overrides && overrides.hasOwnProperty('stock') ? aWixCatalogApiV1Stock(overrides.stock ?? {}, pickedFields.get('stock')) : aWixCatalogApiV1Stock({}, pickedFields.get('stock'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aWixCatalogApiV1Variant(x ?? {}, pickedFields.get('variants'))) : [aWixCatalogApiV1Variant({}, pickedFields.get('variants'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 4.2;
    }
    if (pickedFields.size === 0 || pickedFields.has('weightRange')) {
        result.weightRange = overrides && overrides.hasOwnProperty('weightRange') ? aComWixEcommerceCatalogSpiApiV1NumericPropertyRange(overrides.weightRange ?? {}, pickedFields.get('weightRange')) : aComWixEcommerceCatalogSpiApiV1NumericPropertyRange({}, pickedFields.get('weightRange'));
    }

    return result;
};

export const aWixCatalogApiV1ProductInput = <T extends Partial<WixCatalogApiV1ProductInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalInfoSections')) {
        result.additionalInfoSections = overrides && overrides.hasOwnProperty('additionalInfoSections') ? overrides.additionalInfoSections!.map((x) => aWixCatalogApiV1AdditionalInfoSectionInput({}, pickedFields.get('additionalInfoSections'))) : [aWixCatalogApiV1AdditionalInfoSectionInput({}, pickedFields.get('additionalInfoSections'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('collectionIds')) {
        result.collectionIds = overrides && overrides.hasOwnProperty('collectionIds') ? overrides.collectionIds! : ['aut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('convertedPriceData')) {
        result.convertedPriceData = overrides && overrides.hasOwnProperty('convertedPriceData') ? aWixCatalogApiV1PriceDataInput(overrides.convertedPriceData ?? {}, pickedFields.get('convertedPriceData')) : aWixCatalogApiV1PriceDataInput({}, pickedFields.get('convertedPriceData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('costAndProfitData')) {
        result.costAndProfitData = overrides && overrides.hasOwnProperty('costAndProfitData') ? aWixCatalogApiV1CostAndProfitDataInput(overrides.costAndProfitData ?? {}, pickedFields.get('costAndProfitData')) : aWixCatalogApiV1CostAndProfitDataInput({}, pickedFields.get('costAndProfitData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('costRange')) {
        result.costRange = overrides && overrides.hasOwnProperty('costRange') ? aComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput(overrides.costRange ?? {}, pickedFields.get('costRange')) : aComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput({}, pickedFields.get('costRange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('customTextFields')) {
        result.customTextFields = overrides && overrides.hasOwnProperty('customTextFields') ? overrides.customTextFields!.map((x) => aWixCatalogApiV1CustomTextFieldInput({}, pickedFields.get('customTextFields'))) : [aWixCatalogApiV1CustomTextFieldInput({}, pickedFields.get('customTextFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('digitalFile')) {
        result.digitalFile = overrides && overrides.hasOwnProperty('digitalFile') ? aComWixEcommerceCatalogSpiApiV1SecuredMediaInput(overrides.digitalFile ?? {}, pickedFields.get('digitalFile')) : aComWixEcommerceCatalogSpiApiV1SecuredMediaInput({}, pickedFields.get('digitalFile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aWixCatalogApiV1DiscountInput(overrides.discount ?? {}, pickedFields.get('discount')) : aWixCatalogApiV1DiscountInput({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('exportProductId')) {
        result.exportProductId = overrides && overrides.hasOwnProperty('exportProductId') ? overrides.exportProductId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('inventoryItemId')) {
        result.inventoryItemId = overrides && overrides.hasOwnProperty('inventoryItemId') ? overrides.inventoryItemId! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastUpdated')) {
        result.lastUpdated = overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('manageVariants')) {
        result.manageVariants = overrides && overrides.hasOwnProperty('manageVariants') ? overrides.manageVariants! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixCatalogApiV1MediaInput(overrides.media ?? {}, pickedFields.get('media')) : aWixCatalogApiV1MediaInput({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('numericId')) {
        result.numericId = overrides && overrides.hasOwnProperty('numericId') ? overrides.numericId! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aWixCatalogApiV1PriceDataInput(overrides.price ?? {}, pickedFields.get('price')) : aWixCatalogApiV1PriceDataInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceData')) {
        result.priceData = overrides && overrides.hasOwnProperty('priceData') ? aWixCatalogApiV1PriceDataInput(overrides.priceData ?? {}, pickedFields.get('priceData')) : aWixCatalogApiV1PriceDataInput({}, pickedFields.get('priceData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pricePerUnitData')) {
        result.pricePerUnitData = overrides && overrides.hasOwnProperty('pricePerUnitData') ? aWixCatalogApiV1PricePerUnitDataInput(overrides.pricePerUnitData ?? {}, pickedFields.get('pricePerUnitData')) : aWixCatalogApiV1PricePerUnitDataInput({}, pickedFields.get('pricePerUnitData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceRange')) {
        result.priceRange = overrides && overrides.hasOwnProperty('priceRange') ? aComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput(overrides.priceRange ?? {}, pickedFields.get('priceRange')) : aComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput({}, pickedFields.get('priceRange'));
    }
    if (pickedFields.size === 0 || pickedFields.has('productOptions')) {
        result.productOptions = overrides && overrides.hasOwnProperty('productOptions') ? overrides.productOptions!.map((x) => aWixCatalogApiV1ProductOptionInput({}, pickedFields.get('productOptions'))) : [aWixCatalogApiV1ProductOptionInput({}, pickedFields.get('productOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('productPageUrl')) {
        result.productPageUrl = overrides && overrides.hasOwnProperty('productPageUrl') ? aWixCatalogApiV1PageUrlInput(overrides.productPageUrl ?? {}, pickedFields.get('productPageUrl')) : aWixCatalogApiV1PageUrlInput({}, pickedFields.get('productPageUrl'));
    }
    if (pickedFields.size === 0 || pickedFields.has('productType')) {
        result.productType = overrides && overrides.hasOwnProperty('productType') ? overrides.productType! : WixCatalogApiV1ProductType.Digital;
    }
    if (pickedFields.size === 0 || pickedFields.has('ribbon')) {
        result.ribbon = overrides && overrides.hasOwnProperty('ribbon') ? overrides.ribbon! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('ribbons')) {
        result.ribbons = overrides && overrides.hasOwnProperty('ribbons') ? overrides.ribbons!.map((x) => aWixCatalogApiV1RibbonInput({}, pickedFields.get('ribbons'))) : [aWixCatalogApiV1RibbonInput({}, pickedFields.get('ribbons'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sku')) {
        result.sku = overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('stock')) {
        result.stock = overrides && overrides.hasOwnProperty('stock') ? aWixCatalogApiV1StockInput(overrides.stock ?? {}, pickedFields.get('stock')) : aWixCatalogApiV1StockInput({}, pickedFields.get('stock'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aWixCatalogApiV1VariantInput({}, pickedFields.get('variants'))) : [aWixCatalogApiV1VariantInput({}, pickedFields.get('variants'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 0.44;
    }
    if (pickedFields.size === 0 || pickedFields.has('weightRange')) {
        result.weightRange = overrides && overrides.hasOwnProperty('weightRange') ? aComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput(overrides.weightRange ?? {}, pickedFields.get('weightRange')) : aComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput({}, pickedFields.get('weightRange'));
    }

    return result;
};

export const aWixCatalogApiV1ProductOption = <T extends Partial<WixCatalogApiV1ProductOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choices')) {
        result.choices = overrides && overrides.hasOwnProperty('choices') ? overrides.choices!.map((x) => aWixCatalogApiV1Choice(x ?? {}, pickedFields.get('choices'))) : [aWixCatalogApiV1Choice({}, pickedFields.get('choices'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('optionType')) {
        result.optionType = overrides && overrides.hasOwnProperty('optionType') ? overrides.optionType! : WixCatalogApiV1OptionType.Color;
    }

    return result;
};

export const aWixCatalogApiV1ProductOptionInput = <T extends Partial<WixCatalogApiV1ProductOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choices')) {
        result.choices = overrides && overrides.hasOwnProperty('choices') ? overrides.choices!.map((x) => aWixCatalogApiV1ChoiceInput({}, pickedFields.get('choices'))) : [aWixCatalogApiV1ChoiceInput({}, pickedFields.get('choices'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('optionType')) {
        result.optionType = overrides && overrides.hasOwnProperty('optionType') ? overrides.optionType! : WixCatalogApiV1OptionType.Color;
    }

    return result;
};

export const aWixCatalogApiV1ProductOptionsAvailabilityRequestInput = <T extends Partial<WixCatalogApiV1ProductOptionsAvailabilityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options! : 'cumque';
    }

    return result;
};

export const aWixCatalogApiV1ProductOptionsAvailabilityResponse = <T extends Partial<WixCatalogApiV1ProductOptionsAvailabilityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('availableForPurchase')) {
        result.availableForPurchase = overrides && overrides.hasOwnProperty('availableForPurchase') ? overrides.availableForPurchase! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('managedProduct')) {
        result.managedProduct = overrides && overrides.hasOwnProperty('managedProduct') ? overrides.managedProduct! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixCatalogApiV1Media(overrides.media ?? {}, pickedFields.get('media')) : aWixCatalogApiV1Media({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('productOptions')) {
        result.productOptions = overrides && overrides.hasOwnProperty('productOptions') ? overrides.productOptions!.map((x) => aWixCatalogApiV1ProductOption(x ?? {}, pickedFields.get('productOptions'))) : [aWixCatalogApiV1ProductOption({}, pickedFields.get('productOptions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('selectedVariant')) {
        result.selectedVariant = overrides && overrides.hasOwnProperty('selectedVariant') ? aWixCatalogApiV1VariantData(overrides.selectedVariant ?? {}, pickedFields.get('selectedVariant')) : aWixCatalogApiV1VariantData({}, pickedFields.get('selectedVariant'));
    }

    return result;
};

export const aWixCatalogApiV1PropertyAdjustmentDataInput = <T extends Partial<WixCatalogApiV1PropertyAdjustmentDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 2.18;
    }
    if (pickedFields.size === 0 || pickedFields.has('percentage')) {
        result.percentage = overrides && overrides.hasOwnProperty('percentage') ? aWixCatalogApiV1PercentageDataInput(overrides.percentage ?? {}, pickedFields.get('percentage')) : aWixCatalogApiV1PercentageDataInput({}, pickedFields.get('percentage'));
    }

    return result;
};

export const aWixCatalogApiV1QueryCollectionsPlatformizedRequestInput = <T extends Partial<WixCatalogApiV1QueryCollectionsPlatformizedRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixEcommerceCommonsApiPlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixEcommerceCommonsApiPlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixCatalogApiV1QueryCollectionsPlatformizedResponse = <T extends Partial<WixCatalogApiV1QueryCollectionsPlatformizedResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collections')) {
        result.collections = overrides && overrides.hasOwnProperty('collections') ? overrides.collections!.map((x) => aWixCatalogApiV1Collection(x ?? {}, pickedFields.get('collections'))) : [aWixCatalogApiV1Collection({}, pickedFields.get('collections'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aComWixEcommerceCommonsApiPlatformPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aComWixEcommerceCommonsApiPlatformPagingMetadata({}, pickedFields.get('metadata'));
    }

    return result;
};

export const aWixCatalogApiV1QueryCollectionsRequestInput = <T extends Partial<WixCatalogApiV1QueryCollectionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includeDescription')) {
        result.includeDescription = overrides && overrides.hasOwnProperty('includeDescription') ? overrides.includeDescription! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeNumberOfProducts')) {
        result.includeNumberOfProducts = overrides && overrides.hasOwnProperty('includeNumberOfProducts') ? overrides.includeNumberOfProducts! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeSeoSchema')) {
        result.includeSeoSchema = overrides && overrides.hasOwnProperty('includeSeoSchema') ? overrides.includeSeoSchema! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCatalogApiV1QueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixCatalogApiV1QueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixCatalogApiV1QueryCollectionsResponse = <T extends Partial<WixCatalogApiV1QueryCollectionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collections')) {
        result.collections = overrides && overrides.hasOwnProperty('collections') ? overrides.collections!.map((x) => aWixCatalogApiV1Collection(x ?? {}, pickedFields.get('collections'))) : [aWixCatalogApiV1Collection({}, pickedFields.get('collections'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixCatalogApiV1PagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixCatalogApiV1PagingMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalResults')) {
        result.totalResults = overrides && overrides.hasOwnProperty('totalResults') ? overrides.totalResults! : 2641;
    }

    return result;
};

export const aWixCatalogApiV1QueryCustomFieldsRequestInput = <T extends Partial<WixCatalogApiV1QueryCustomFieldsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('names')) {
        result.names = overrides && overrides.hasOwnProperty('names') ? overrides.names! : ['itaque'];
    }

    return result;
};

export const aWixCatalogApiV1QueryCustomFieldsResponse = <T extends Partial<WixCatalogApiV1QueryCustomFieldsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : 'et';
    }

    return result;
};

export const aWixCatalogApiV1QueryInput = <T extends Partial<WixCatalogApiV1QueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCatalogApiV1PagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCatalogApiV1PagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort! : 'cum';
    }

    return result;
};

export const aWixCatalogApiV1QueryProductVariantsRequestInput = <T extends Partial<WixCatalogApiV1QueryProductVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choices')) {
        result.choices = overrides && overrides.hasOwnProperty('choices') ? overrides.choices! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('includeMerchantSpecificData')) {
        result.includeMerchantSpecificData = overrides && overrides.hasOwnProperty('includeMerchantSpecificData') ? overrides.includeMerchantSpecificData! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCatalogApiV1PagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCatalogApiV1PagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('variantIds')) {
        result.variantIds = overrides && overrides.hasOwnProperty('variantIds') ? overrides.variantIds! : ['eos'];
    }

    return result;
};

export const aWixCatalogApiV1QueryProductVariantsResponse = <T extends Partial<WixCatalogApiV1QueryProductVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixCatalogApiV1PagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixCatalogApiV1PagingMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totalResults')) {
        result.totalResults = overrides && overrides.hasOwnProperty('totalResults') ? overrides.totalResults! : 7122;
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aWixCatalogApiV1Variant(x ?? {}, pickedFields.get('variants'))) : [aWixCatalogApiV1Variant({}, pickedFields.get('variants'))];
    }

    return result;
};

export const aWixCatalogApiV1QueryProductsPlatformizedRequestInput = <T extends Partial<WixCatalogApiV1QueryProductsPlatformizedRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixEcommerceCommonsApiPlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixEcommerceCommonsApiPlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixCatalogApiV1QueryProductsPlatformizedResponse = <T extends Partial<WixCatalogApiV1QueryProductsPlatformizedResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixCatalogApiV1Product(x ?? {}, pickedFields.get('items'))) : [aWixCatalogApiV1Product({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixCatalogApiV1QueryProductsRequestInput = <T extends Partial<WixCatalogApiV1QueryProductsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includeHiddenProducts')) {
        result.includeHiddenProducts = overrides && overrides.hasOwnProperty('includeHiddenProducts') ? overrides.includeHiddenProducts! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeMerchantSpecificData')) {
        result.includeMerchantSpecificData = overrides && overrides.hasOwnProperty('includeMerchantSpecificData') ? overrides.includeMerchantSpecificData! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeVariants')) {
        result.includeVariants = overrides && overrides.hasOwnProperty('includeVariants') ? overrides.includeVariants! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCatalogApiV1QueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixCatalogApiV1QueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixCatalogApiV1QueryProductsResponse = <T extends Partial<WixCatalogApiV1QueryProductsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixCatalogApiV1PagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixCatalogApiV1PagingMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('products')) {
        result.products = overrides && overrides.hasOwnProperty('products') ? overrides.products!.map((x) => aWixCatalogApiV1Product(x ?? {}, pickedFields.get('products'))) : [aWixCatalogApiV1Product({}, pickedFields.get('products'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('totalResults')) {
        result.totalResults = overrides && overrides.hasOwnProperty('totalResults') ? overrides.totalResults! : 436;
    }

    return result;
};

export const aWixCatalogApiV1QueryProductsWithBigPageLimitRequestInput = <T extends Partial<WixCatalogApiV1QueryProductsWithBigPageLimitRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includeHiddenProducts')) {
        result.includeHiddenProducts = overrides && overrides.hasOwnProperty('includeHiddenProducts') ? overrides.includeHiddenProducts! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeMerchantSpecificData')) {
        result.includeMerchantSpecificData = overrides && overrides.hasOwnProperty('includeMerchantSpecificData') ? overrides.includeMerchantSpecificData! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('includeVariants')) {
        result.includeVariants = overrides && overrides.hasOwnProperty('includeVariants') ? overrides.includeVariants! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCatalogApiV1QueryWithBigPageLimitInput(overrides.query ?? {}, pickedFields.get('query')) : aWixCatalogApiV1QueryWithBigPageLimitInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixCatalogApiV1QueryStoreVariantsRequestInput = <T extends Partial<WixCatalogApiV1QueryStoreVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : ['consequatur'];
    }
    if (pickedFields.size === 0 || pickedFields.has('includeLocationVariants')) {
        result.includeLocationVariants = overrides && overrides.hasOwnProperty('includeLocationVariants') ? overrides.includeLocationVariants! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixEcommerceCommonsApiPlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixEcommerceCommonsApiPlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixCatalogApiV1QueryStoreVariantsResponse = <T extends Partial<WixCatalogApiV1QueryStoreVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aComWixEcommerceCommonsApiPlatformPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aComWixEcommerceCommonsApiPlatformPagingMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aWixCatalogApiV1StoreVariant(x ?? {}, pickedFields.get('variants'))) : [aWixCatalogApiV1StoreVariant({}, pickedFields.get('variants'))];
    }

    return result;
};

export const aWixCatalogApiV1QueryStoreVariantsWithBigLimitRequestInput = <T extends Partial<WixCatalogApiV1QueryStoreVariantsWithBigLimitRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : ['laborum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('includeLocationVariants')) {
        result.includeLocationVariants = overrides && overrides.hasOwnProperty('includeLocationVariants') ? overrides.includeLocationVariants! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixEcommerceCommonsApiUnlimitedPlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixEcommerceCommonsApiUnlimitedPlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixCatalogApiV1QueryWithBigPageLimitInput = <T extends Partial<WixCatalogApiV1QueryWithBigPageLimitInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCatalogApiV1PagingWithBigLimitInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCatalogApiV1PagingWithBigLimitInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort! : 'et';
    }

    return result;
};

export const aWixCatalogApiV1ReCloneStoreRequestInput = <T extends Partial<WixCatalogApiV1ReCloneStoreRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metasiteId')) {
        result.metasiteId = overrides && overrides.hasOwnProperty('metasiteId') ? overrides.metasiteId! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalMetasiteId')) {
        result.originalMetasiteId = overrides && overrides.hasOwnProperty('originalMetasiteId') ? overrides.originalMetasiteId! : 'omnis';
    }

    return result;
};

export const aWixCatalogApiV1RemoveCustomFieldsRequestInput = <T extends Partial<WixCatalogApiV1RemoveCustomFieldsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('names')) {
        result.names = overrides && overrides.hasOwnProperty('names') ? overrides.names! : ['vel'];
    }

    return result;
};

export const aWixCatalogApiV1RemoveProductBrandRequestInput = <T extends Partial<WixCatalogApiV1RemoveProductBrandRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'non';
    }

    return result;
};

export const aWixCatalogApiV1RemoveProductMediaFromChoicesRequestInput = <T extends Partial<WixCatalogApiV1RemoveProductMediaFromChoicesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'commodi';
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? overrides.media!.map((x) => aWixCatalogApiV1MediaAssignmentToChoiceInput({}, pickedFields.get('media'))) : [aWixCatalogApiV1MediaAssignmentToChoiceInput({}, pickedFields.get('media'))];
    }

    return result;
};

export const aWixCatalogApiV1RemoveProductMediaRequestInput = <T extends Partial<WixCatalogApiV1RemoveProductMediaRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('mediaIds')) {
        result.mediaIds = overrides && overrides.hasOwnProperty('mediaIds') ? overrides.mediaIds! : ['adipisci'];
    }

    return result;
};

export const aWixCatalogApiV1RemoveProductRibbonRequestInput = <T extends Partial<WixCatalogApiV1RemoveProductRibbonRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }

    return result;
};

export const aWixCatalogApiV1RemoveProductsFromCollectionRequestInput = <T extends Partial<WixCatalogApiV1RemoveProductsFromCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('productIds')) {
        result.productIds = overrides && overrides.hasOwnProperty('productIds') ? overrides.productIds! : ['error'];
    }

    return result;
};

export const aWixCatalogApiV1ResetAllVariantDataRequestInput = <T extends Partial<WixCatalogApiV1ResetAllVariantDataRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ipsum';
    }

    return result;
};

export const aWixCatalogApiV1Ribbon = <T extends Partial<WixCatalogApiV1Ribbon>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'laudantium';
    }

    return result;
};

export const aWixCatalogApiV1RibbonInput = <T extends Partial<WixCatalogApiV1RibbonInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'suscipit';
    }

    return result;
};

export const aWixCatalogApiV1SetCustomFieldsRequestInput = <T extends Partial<WixCatalogApiV1SetCustomFieldsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ipsam';
    }

    return result;
};

export const aWixCatalogApiV1SetValueInput = <T extends Partial<WixCatalogApiV1SetValueInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('cost')) {
        result.cost = overrides && overrides.hasOwnProperty('cost') ? overrides.cost! : 1.27;
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 8.37;
    }
    if (pickedFields.size === 0 || pickedFields.has('ribbon')) {
        result.ribbon = overrides && overrides.hasOwnProperty('ribbon') ? overrides.ribbon! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 4.24;
    }

    return result;
};

export const aWixCatalogApiV1Stock = <T extends Partial<WixCatalogApiV1Stock>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('inStock')) {
        result.inStock = overrides && overrides.hasOwnProperty('inStock') ? overrides.inStock! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('inventoryStatus')) {
        result.inventoryStatus = overrides && overrides.hasOwnProperty('inventoryStatus') ? overrides.inventoryStatus! : WixCatalogApiV1StockInventoryStatus.InStock;
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 6356;
    }
    if (pickedFields.size === 0 || pickedFields.has('trackInventory')) {
        result.trackInventory = overrides && overrides.hasOwnProperty('trackInventory') ? overrides.trackInventory! : false;
    }

    return result;
};

export const aWixCatalogApiV1StockInput = <T extends Partial<WixCatalogApiV1StockInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('inStock')) {
        result.inStock = overrides && overrides.hasOwnProperty('inStock') ? overrides.inStock! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('inventoryStatus')) {
        result.inventoryStatus = overrides && overrides.hasOwnProperty('inventoryStatus') ? overrides.inventoryStatus! : WixCatalogApiV1StockInventoryStatus.InStock;
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 5999;
    }
    if (pickedFields.size === 0 || pickedFields.has('trackInventory')) {
        result.trackInventory = overrides && overrides.hasOwnProperty('trackInventory') ? overrides.trackInventory! : false;
    }

    return result;
};

export const aWixCatalogApiV1StoreVariant = <T extends Partial<WixCatalogApiV1StoreVariant>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choices')) {
        result.choices = overrides && overrides.hasOwnProperty('choices') ? overrides.choices! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('collectionIds')) {
        result.collectionIds = overrides && overrides.hasOwnProperty('collectionIds') ? overrides.collectionIds! : ['quo'];
    }
    if (pickedFields.size === 0 || pickedFields.has('collections')) {
        result.collections = overrides && overrides.hasOwnProperty('collections') ? aWixCatalogApiV2QueryCollectionsResponse(overrides.collections ?? {}, pickedFields.get('collections')) : aWixCatalogApiV2QueryCollectionsResponse({}, pickedFields.get('collections'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? overrides.customFields! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('managedVariant')) {
        result.managedVariant = overrides && overrides.hasOwnProperty('managedVariant') ? overrides.managedVariant! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aComWixEcommerceCommonsApiPlatformMedia(overrides.media ?? {}, pickedFields.get('media')) : aComWixEcommerceCommonsApiPlatformMedia({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('preorderInfo')) {
        result.preorderInfo = overrides && overrides.hasOwnProperty('preorderInfo') ? aWixInventoryApiV1PreorderInfo(overrides.preorderInfo ?? {}, pickedFields.get('preorderInfo')) : aWixInventoryApiV1PreorderInfo({}, pickedFields.get('preorderInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1Product(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1Product({}, pickedFields.get('product'));
    }
    if (pickedFields.size === 0 || pickedFields.has('productId')) {
        result.productId = overrides && overrides.hasOwnProperty('productId') ? overrides.productId! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('productName')) {
        result.productName = overrides && overrides.hasOwnProperty('productName') ? overrides.productName! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('sku')) {
        result.sku = overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('stock')) {
        result.stock = overrides && overrides.hasOwnProperty('stock') ? aWixCatalogApiV1VariantStock(overrides.stock ?? {}, pickedFields.get('stock')) : aWixCatalogApiV1VariantStock({}, pickedFields.get('stock'));
    }
    if (pickedFields.size === 0 || pickedFields.has('variantId')) {
        result.variantId = overrides && overrides.hasOwnProperty('variantId') ? overrides.variantId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('variantName')) {
        result.variantName = overrides && overrides.hasOwnProperty('variantName') ? overrides.variantName! : 'vero';
    }

    return result;
};

export const aWixCatalogApiV1UpdateCollectionRequestInput = <T extends Partial<WixCatalogApiV1UpdateCollectionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collection')) {
        result.collection = overrides && overrides.hasOwnProperty('collection') ? aWixCatalogApiV1CollectionInput(overrides.collection ?? {}, pickedFields.get('collection')) : aWixCatalogApiV1CollectionInput({}, pickedFields.get('collection'));
    }

    return result;
};

export const aWixCatalogApiV1UpdateCollectionResponse = <T extends Partial<WixCatalogApiV1UpdateCollectionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('collection')) {
        result.collection = overrides && overrides.hasOwnProperty('collection') ? aWixCatalogApiV1Collection(overrides.collection ?? {}, pickedFields.get('collection')) : aWixCatalogApiV1Collection({}, pickedFields.get('collection'));
    }

    return result;
};

export const aWixCatalogApiV1UpdateProductPlatformizedRequestInput = <T extends Partial<WixCatalogApiV1UpdateProductPlatformizedRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1ProductInput(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1ProductInput({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogApiV1UpdateProductPlatformizedResponse = <T extends Partial<WixCatalogApiV1UpdateProductPlatformizedResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1Product(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1Product({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogApiV1UpdateProductRequestInput = <T extends Partial<WixCatalogApiV1UpdateProductRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1ProductInput(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1ProductInput({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogApiV1UpdateProductResponse = <T extends Partial<WixCatalogApiV1UpdateProductResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1Product(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1Product({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogApiV1UpdateVariantsRequestInput = <T extends Partial<WixCatalogApiV1UpdateVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aWixCatalogApiV1VariantOverrideInput({}, pickedFields.get('variants'))) : [aWixCatalogApiV1VariantOverrideInput({}, pickedFields.get('variants'))];
    }

    return result;
};

export const aWixCatalogApiV1UpdateVariantsResponse = <T extends Partial<WixCatalogApiV1UpdateVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aWixCatalogApiV1Variant(x ?? {}, pickedFields.get('variants'))) : [aWixCatalogApiV1Variant({}, pickedFields.get('variants'))];
    }

    return result;
};

export const aWixCatalogApiV1Variant = <T extends Partial<WixCatalogApiV1Variant>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choices')) {
        result.choices = overrides && overrides.hasOwnProperty('choices') ? overrides.choices! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('stock')) {
        result.stock = overrides && overrides.hasOwnProperty('stock') ? aWixCatalogApiV1VariantStock(overrides.stock ?? {}, pickedFields.get('stock')) : aWixCatalogApiV1VariantStock({}, pickedFields.get('stock'));
    }
    if (pickedFields.size === 0 || pickedFields.has('variant')) {
        result.variant = overrides && overrides.hasOwnProperty('variant') ? aWixCatalogApiV1VariantDataWithNoStock(overrides.variant ?? {}, pickedFields.get('variant')) : aWixCatalogApiV1VariantDataWithNoStock({}, pickedFields.get('variant'));
    }

    return result;
};

export const aWixCatalogApiV1VariantData = <T extends Partial<WixCatalogApiV1VariantData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('convertedPriceData')) {
        result.convertedPriceData = overrides && overrides.hasOwnProperty('convertedPriceData') ? aWixCatalogApiV1PriceData(overrides.convertedPriceData ?? {}, pickedFields.get('convertedPriceData')) : aWixCatalogApiV1PriceData({}, pickedFields.get('convertedPriceData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('inStock')) {
        result.inStock = overrides && overrides.hasOwnProperty('inStock') ? overrides.inStock! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aWixCatalogApiV1PriceData(overrides.price ?? {}, pickedFields.get('price')) : aWixCatalogApiV1PriceData({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8729;
    }
    if (pickedFields.size === 0 || pickedFields.has('sku')) {
        result.sku = overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'delectus';
    }
    if (pickedFields.size === 0 || pickedFields.has('variantId')) {
        result.variantId = overrides && overrides.hasOwnProperty('variantId') ? overrides.variantId! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 4.68;
    }

    return result;
};

export const aWixCatalogApiV1VariantDataWithNoStock = <T extends Partial<WixCatalogApiV1VariantDataWithNoStock>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('convertedPriceData')) {
        result.convertedPriceData = overrides && overrides.hasOwnProperty('convertedPriceData') ? aWixCatalogApiV1PriceData(overrides.convertedPriceData ?? {}, pickedFields.get('convertedPriceData')) : aWixCatalogApiV1PriceData({}, pickedFields.get('convertedPriceData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('costAndProfitData')) {
        result.costAndProfitData = overrides && overrides.hasOwnProperty('costAndProfitData') ? aWixCatalogApiV1CostAndProfitData(overrides.costAndProfitData ?? {}, pickedFields.get('costAndProfitData')) : aWixCatalogApiV1CostAndProfitData({}, pickedFields.get('costAndProfitData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceData')) {
        result.priceData = overrides && overrides.hasOwnProperty('priceData') ? aWixCatalogApiV1PriceData(overrides.priceData ?? {}, pickedFields.get('priceData')) : aWixCatalogApiV1PriceData({}, pickedFields.get('priceData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sku')) {
        result.sku = overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 0.69;
    }

    return result;
};

export const aWixCatalogApiV1VariantDataWithNoStockInput = <T extends Partial<WixCatalogApiV1VariantDataWithNoStockInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('convertedPriceData')) {
        result.convertedPriceData = overrides && overrides.hasOwnProperty('convertedPriceData') ? aWixCatalogApiV1PriceDataInput(overrides.convertedPriceData ?? {}, pickedFields.get('convertedPriceData')) : aWixCatalogApiV1PriceDataInput({}, pickedFields.get('convertedPriceData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('costAndProfitData')) {
        result.costAndProfitData = overrides && overrides.hasOwnProperty('costAndProfitData') ? aWixCatalogApiV1CostAndProfitDataInput(overrides.costAndProfitData ?? {}, pickedFields.get('costAndProfitData')) : aWixCatalogApiV1CostAndProfitDataInput({}, pickedFields.get('costAndProfitData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('priceData')) {
        result.priceData = overrides && overrides.hasOwnProperty('priceData') ? aWixCatalogApiV1PriceDataInput(overrides.priceData ?? {}, pickedFields.get('priceData')) : aWixCatalogApiV1PriceDataInput({}, pickedFields.get('priceData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sku')) {
        result.sku = overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 2.01;
    }

    return result;
};

export const aWixCatalogApiV1VariantInput = <T extends Partial<WixCatalogApiV1VariantInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choices')) {
        result.choices = overrides && overrides.hasOwnProperty('choices') ? overrides.choices! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('stock')) {
        result.stock = overrides && overrides.hasOwnProperty('stock') ? aWixCatalogApiV1VariantStockInput(overrides.stock ?? {}, pickedFields.get('stock')) : aWixCatalogApiV1VariantStockInput({}, pickedFields.get('stock'));
    }
    if (pickedFields.size === 0 || pickedFields.has('variant')) {
        result.variant = overrides && overrides.hasOwnProperty('variant') ? aWixCatalogApiV1VariantDataWithNoStockInput(overrides.variant ?? {}, pickedFields.get('variant')) : aWixCatalogApiV1VariantDataWithNoStockInput({}, pickedFields.get('variant'));
    }

    return result;
};

export const aWixCatalogApiV1VariantOverrideInput = <T extends Partial<WixCatalogApiV1VariantOverrideInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('choices')) {
        result.choices = overrides && overrides.hasOwnProperty('choices') ? overrides.choices! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('cost')) {
        result.cost = overrides && overrides.hasOwnProperty('cost') ? overrides.cost! : 2;
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 3.43;
    }
    if (pickedFields.size === 0 || pickedFields.has('sku')) {
        result.sku = overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('variantIds')) {
        result.variantIds = overrides && overrides.hasOwnProperty('variantIds') ? overrides.variantIds! : ['eos'];
    }
    if (pickedFields.size === 0 || pickedFields.has('visible')) {
        result.visible = overrides && overrides.hasOwnProperty('visible') ? overrides.visible! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 9.08;
    }

    return result;
};

export const aWixCatalogApiV1VariantStock = <T extends Partial<WixCatalogApiV1VariantStock>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('inStock')) {
        result.inStock = overrides && overrides.hasOwnProperty('inStock') ? overrides.inStock! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('locationId')) {
        result.locationId = overrides && overrides.hasOwnProperty('locationId') ? overrides.locationId! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 1958;
    }
    if (pickedFields.size === 0 || pickedFields.has('trackQuantity')) {
        result.trackQuantity = overrides && overrides.hasOwnProperty('trackQuantity') ? overrides.trackQuantity! : false;
    }

    return result;
};

export const aWixCatalogApiV1VariantStockInput = <T extends Partial<WixCatalogApiV1VariantStockInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('inStock')) {
        result.inStock = overrides && overrides.hasOwnProperty('inStock') ? overrides.inStock! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('locationId')) {
        result.locationId = overrides && overrides.hasOwnProperty('locationId') ? overrides.locationId! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8911;
    }
    if (pickedFields.size === 0 || pickedFields.has('trackQuantity')) {
        result.trackQuantity = overrides && overrides.hasOwnProperty('trackQuantity') ? overrides.trackQuantity! : true;
    }

    return result;
};

export const aWixCatalogApiV2QueryCollectionsRequestInput = <T extends Partial<WixCatalogApiV2QueryCollectionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixEcommerceCommonsApiPlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixEcommerceCommonsApiPlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixCatalogApiV2QueryCollectionsResponse = <T extends Partial<WixCatalogApiV2QueryCollectionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixCatalogApiV1Collection(x ?? {}, pickedFields.get('items'))) : [aWixCatalogApiV1Collection({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixCatalogWriteProxyV1CreateProductPlatformizedRequestInput = <T extends Partial<WixCatalogWriteProxyV1CreateProductPlatformizedRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1ProductInput(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1ProductInput({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogWriteProxyV1CreateProductPlatformizedResponse = <T extends Partial<WixCatalogWriteProxyV1CreateProductPlatformizedResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1Product(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1Product({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogWriteProxyV1DeleteProductPlatformizedRequestInput = <T extends Partial<WixCatalogWriteProxyV1DeleteProductPlatformizedRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quo';
    }

    return result;
};

export const aWixCatalogWriteProxyV1UpdateProductPlatformizedRequestInput = <T extends Partial<WixCatalogWriteProxyV1UpdateProductPlatformizedRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1ProductInput(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1ProductInput({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCatalogWriteProxyV1UpdateProductPlatformizedResponse = <T extends Partial<WixCatalogWriteProxyV1UpdateProductPlatformizedResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('product')) {
        result.product = overrides && overrides.hasOwnProperty('product') ? aWixCatalogApiV1Product(overrides.product ?? {}, pickedFields.get('product')) : aWixCatalogApiV1Product({}, pickedFields.get('product'));
    }

    return result;
};

export const aWixCommonAddress = <T extends Partial<WixCommonAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixCommonAddressLocation(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixCommonAddressLocation({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixCommonStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixCommonStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionFullname')) {
        result.subdivisionFullname = overrides && overrides.hasOwnProperty('subdivisionFullname') ? overrides.subdivisionFullname! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionIso31662')) {
        result.subdivisionIso31662 = overrides && overrides.hasOwnProperty('subdivisionIso31662') ? overrides.subdivisionIso31662! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aWixCommonSubdivision(x ?? {}, pickedFields.get('subdivisions'))) : [aWixCommonSubdivision({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aWixCommonAddressInput = <T extends Partial<WixCommonAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'quae';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixCommonAddressLocationInput(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixCommonAddressLocationInput({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixCommonStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixCommonStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionFullname')) {
        result.subdivisionFullname = overrides && overrides.hasOwnProperty('subdivisionFullname') ? overrides.subdivisionFullname! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionIso31662')) {
        result.subdivisionIso31662 = overrides && overrides.hasOwnProperty('subdivisionIso31662') ? overrides.subdivisionIso31662! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))) : [aWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aWixCommonAddressLocation = <T extends Partial<WixCommonAddressLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 7.56;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 0.95;
    }

    return result;
};

export const aWixCommonAddressLocationInput = <T extends Partial<WixCommonAddressLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 8.94;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 5.28;
    }

    return result;
};

export const aWixCommonAggregationData = <T extends Partial<WixCommonAggregationData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCommonAggregationDataAggregationResults(x ?? {}, pickedFields.get('results'))) : [aWixCommonAggregationDataAggregationResults({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResults = <T extends Partial<WixCommonAggregationDataAggregationResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixCommonAggregationDataAggregationResultsDateHistogramResults(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixCommonAggregationDataAggregationResultsDateHistogramResults({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('groupedByValue')) {
        result.groupedByValue = overrides && overrides.hasOwnProperty('groupedByValue') ? aWixCommonAggregationDataAggregationResultsGroupByValueResults(overrides.groupedByValue ?? {}, pickedFields.get('groupedByValue')) : aWixCommonAggregationDataAggregationResultsGroupByValueResults({}, pickedFields.get('groupedByValue'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('nested')) {
        result.nested = overrides && overrides.hasOwnProperty('nested') ? aWixCommonAggregationDataAggregationResultsNestedResults(overrides.nested ?? {}, pickedFields.get('nested')) : aWixCommonAggregationDataAggregationResultsNestedResults({}, pickedFields.get('nested'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ranges')) {
        result.ranges = overrides && overrides.hasOwnProperty('ranges') ? aWixCommonAggregationDataAggregationResultsRangeResults(overrides.ranges ?? {}, pickedFields.get('ranges')) : aWixCommonAggregationDataAggregationResultsRangeResults({}, pickedFields.get('ranges'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixCommonAggregationDataAggregationResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixCommonAggregationDataAggregationResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? aWixCommonAggregationDataAggregationResultsValueResults(overrides.values ?? {}, pickedFields.get('values')) : aWixCommonAggregationDataAggregationResultsValueResults({}, pickedFields.get('values'));
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsDateHistogramResults = <T extends Partial<WixCommonAggregationDataAggregationResultsDateHistogramResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult(x ?? {}, pickedFields.get('results'))) : [aWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = <T extends Partial<WixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3473;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'porro';
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsGroupByValueResults = <T extends Partial<WixCommonAggregationDataAggregationResultsGroupByValueResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = <T extends Partial<WixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nestedResults')) {
        result.nestedResults = overrides && overrides.hasOwnProperty('nestedResults') ? aWixCommonAggregationDataAggregationResultsNestedAggregationResults(overrides.nestedResults ?? {}, pickedFields.get('nestedResults')) : aWixCommonAggregationDataAggregationResultsNestedAggregationResults({}, pickedFields.get('nestedResults'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'quod';
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsNestedAggregationResults = <T extends Partial<WixCommonAggregationDataAggregationResultsNestedAggregationResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('ranges')) {
        result.ranges = overrides && overrides.hasOwnProperty('ranges') ? aWixCommonAggregationDataAggregationResultsRangeResults(overrides.ranges ?? {}, pickedFields.get('ranges')) : aWixCommonAggregationDataAggregationResultsRangeResults({}, pickedFields.get('ranges'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixCommonAggregationDataAggregationResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixCommonAggregationDataAggregationResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? aWixCommonAggregationDataAggregationResultsValueResults(overrides.values ?? {}, pickedFields.get('values')) : aWixCommonAggregationDataAggregationResultsValueResults({}, pickedFields.get('values'));
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsNestedResults = <T extends Partial<WixCommonAggregationDataAggregationResultsNestedResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCommonAggregationDataAggregationResultsNestedResultsResults(x ?? {}, pickedFields.get('results'))) : [aWixCommonAggregationDataAggregationResultsNestedResultsResults({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = <T extends Partial<WixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixCommonAggregationDataAggregationResultsNestedResultsValueResult(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixCommonAggregationDataAggregationResultsNestedResultsValueResult({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixCommonAggregationDataAggregationResultsNestedResultsRangeResult(overrides.range ?? {}, pickedFields.get('range')) : aWixCommonAggregationDataAggregationResultsNestedResultsRangeResult({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixCommonAggregationDataAggregationResultsNestedResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixCommonAggregationDataAggregationResultsNestedResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixCommonAggregationDataAggregationResultsNestedResultsValueResult(overrides.value ?? {}, pickedFields.get('value')) : aWixCommonAggregationDataAggregationResultsNestedResultsValueResult({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsNestedResultsRangeResult = <T extends Partial<WixCommonAggregationDataAggregationResultsNestedResultsRangeResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 5002;
    }
    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 2.12;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 3.49;
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsNestedResultsResults = <T extends Partial<WixCommonAggregationDataAggregationResultsNestedResultsResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? aWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue(overrides.results ?? {}, pickedFields.get('results')) : aWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue({}, pickedFields.get('results'));
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsNestedResultsScalarResult = <T extends Partial<WixCommonAggregationDataAggregationResultsNestedResultsScalarResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 6.11;
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsNestedResultsValueResult = <T extends Partial<WixCommonAggregationDataAggregationResultsNestedResultsValueResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3001;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'est';
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsRangeResults = <T extends Partial<WixCommonAggregationDataAggregationResultsRangeResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = <T extends Partial<WixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 5481;
    }
    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 3.71;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 5.82;
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsScalarResult = <T extends Partial<WixCommonAggregationDataAggregationResultsScalarResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonScalarType.Avg;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 3.31;
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsValueResults = <T extends Partial<WixCommonAggregationDataAggregationResultsValueResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = <T extends Partial<WixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 5062;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'nobis';
    }

    return result;
};

export const aWixCommonAggregationDateHistogramAggregationInput = <T extends Partial<WixCommonAggregationDateHistogramAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : WixCommonAggregationDateHistogramAggregationInterval.Day;
    }

    return result;
};

export const aWixCommonAggregationGroupByAggregationInput = <T extends Partial<WixCommonAggregationGroupByAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixCommonAggregationInput = <T extends Partial<WixCommonAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixCommonAggregationDateHistogramAggregationInput(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixCommonAggregationDateHistogramAggregationInput({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('nested')) {
        result.nested = overrides && overrides.hasOwnProperty('nested') ? aWixCommonAggregationNestedAggregationInput(overrides.nested ?? {}, pickedFields.get('nested')) : aWixCommonAggregationNestedAggregationInput({}, pickedFields.get('nested'));
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixCommonAggregationRangeAggregationInput(overrides.range ?? {}, pickedFields.get('range')) : aWixCommonAggregationRangeAggregationInput({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixCommonAggregationScalarAggregationInput(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixCommonAggregationScalarAggregationInput({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixCommonAggregationNestedAggregationInput = <T extends Partial<WixCommonAggregationNestedAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nestedAggregations')) {
        result.nestedAggregations = overrides && overrides.hasOwnProperty('nestedAggregations') ? overrides.nestedAggregations!.map((x) => aWixCommonAggregationNestedAggregationNestedAggregationItemInput({}, pickedFields.get('nestedAggregations'))) : [aWixCommonAggregationNestedAggregationNestedAggregationItemInput({}, pickedFields.get('nestedAggregations'))];
    }

    return result;
};

export const aWixCommonAggregationNestedAggregationNestedAggregationItemInput = <T extends Partial<WixCommonAggregationNestedAggregationNestedAggregationItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixCommonAggregationDateHistogramAggregationInput(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixCommonAggregationDateHistogramAggregationInput({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixCommonAggregationRangeAggregationInput(overrides.range ?? {}, pickedFields.get('range')) : aWixCommonAggregationRangeAggregationInput({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixCommonAggregationScalarAggregationInput(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixCommonAggregationScalarAggregationInput({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonAggregationNestedAggregationNestedAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixCommonAggregationRangeAggregationInput = <T extends Partial<WixCommonAggregationRangeAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buckets')) {
        result.buckets = overrides && overrides.hasOwnProperty('buckets') ? overrides.buckets!.map((x) => aWixCommonAggregationRangeAggregationRangeBucketInput({}, pickedFields.get('buckets'))) : [aWixCommonAggregationRangeAggregationRangeBucketInput({}, pickedFields.get('buckets'))];
    }

    return result;
};

export const aWixCommonAggregationRangeAggregationRangeBucketInput = <T extends Partial<WixCommonAggregationRangeAggregationRangeBucketInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 8.8;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 9.54;
    }

    return result;
};

export const aWixCommonAggregationScalarAggregationInput = <T extends Partial<WixCommonAggregationScalarAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonScalarType.Avg;
    }

    return result;
};

export const aWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = <T extends Partial<WixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addToBucket')) {
        result.addToBucket = overrides && overrides.hasOwnProperty('addToBucket') ? overrides.addToBucket! : 'est';
    }

    return result;
};

export const aWixCommonAggregationValueAggregationInput = <T extends Partial<WixCommonAggregationValueAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includeOptions')) {
        result.includeOptions = overrides && overrides.hasOwnProperty('includeOptions') ? aWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput(overrides.includeOptions ?? {}, pickedFields.get('includeOptions')) : aWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput({}, pickedFields.get('includeOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3178;
    }
    if (pickedFields.size === 0 || pickedFields.has('missingValues')) {
        result.missingValues = overrides && overrides.hasOwnProperty('missingValues') ? overrides.missingValues! : WixCommonAggregationValueAggregationMissingValues.Exclude;
    }
    if (pickedFields.size === 0 || pickedFields.has('sortDirection')) {
        result.sortDirection = overrides && overrides.hasOwnProperty('sortDirection') ? overrides.sortDirection! : WixCommonAggregationValueAggregationSortDirection.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('sortType')) {
        result.sortType = overrides && overrides.hasOwnProperty('sortType') ? overrides.sortType! : WixCommonAggregationValueAggregationSortType.Count;
    }

    return result;
};

export const aWixCommonAudio = <T extends Partial<WixCommonAudio>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('assetKey')) {
        result.assetKey = overrides && overrides.hasOwnProperty('assetKey') ? overrides.assetKey! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('duration')) {
        result.duration = overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 228;
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('private')) {
        result.private = overrides && overrides.hasOwnProperty('private') ? overrides.private! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('quality')) {
        result.quality = overrides && overrides.hasOwnProperty('quality') ? overrides.quality! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'voluptas';
    }

    return result;
};

export const aWixCommonAudioInput = <T extends Partial<WixCommonAudioInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('assetKey')) {
        result.assetKey = overrides && overrides.hasOwnProperty('assetKey') ? overrides.assetKey! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('duration')) {
        result.duration = overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 2308;
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('private')) {
        result.private = overrides && overrides.hasOwnProperty('private') ? overrides.private! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('quality')) {
        result.quality = overrides && overrides.hasOwnProperty('quality') ? overrides.quality! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'quas';
    }

    return result;
};

export const aWixCommonBulkActionMetadata = <T extends Partial<WixCommonBulkActionMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalFailures')) {
        result.totalFailures = overrides && overrides.hasOwnProperty('totalFailures') ? overrides.totalFailures! : 6658;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalSuccesses')) {
        result.totalSuccesses = overrides && overrides.hasOwnProperty('totalSuccesses') ? overrides.totalSuccesses! : 9029;
    }
    if (pickedFields.size === 0 || pickedFields.has('undetailedFailures')) {
        result.undetailedFailures = overrides && overrides.hasOwnProperty('undetailedFailures') ? overrides.undetailedFailures! : 3856;
    }

    return result;
};

export const aWixCommonCursorPagingInput = <T extends Partial<WixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1889;
    }

    return result;
};

export const aWixCommonCursorPagingMetadata = <T extends Partial<WixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 1171;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 3814;
    }

    return result;
};

export const aWixCommonCursorSearchInput = <T extends Partial<WixCommonCursorSearchInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregations')) {
        result.aggregations = overrides && overrides.hasOwnProperty('aggregations') ? overrides.aggregations!.map((x) => aWixCommonAggregationInput({}, pickedFields.get('aggregations'))) : [aWixCommonAggregationInput({}, pickedFields.get('aggregations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aWixCommonSearchDetailsInput(overrides.search ?? {}, pickedFields.get('search')) : aWixCommonSearchDetailsInput({}, pickedFields.get('search'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'ea';
    }

    return result;
};

export const aWixCommonCursors = <T extends Partial<WixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'recusandae';
    }

    return result;
};

export const aWixCommonDataDataextensionsExtendedFields = <T extends Partial<WixCommonDataDataextensionsExtendedFields>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('namespaces')) {
        result.namespaces = overrides && overrides.hasOwnProperty('namespaces') ? overrides.namespaces! : 'voluptatem';
    }

    return result;
};

export const aWixCommonDataDataextensionsExtendedFieldsInput = <T extends Partial<WixCommonDataDataextensionsExtendedFieldsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('namespaces')) {
        result.namespaces = overrides && overrides.hasOwnProperty('namespaces') ? overrides.namespaces! : 'quia';
    }

    return result;
};

export const aWixCommonDataDataextensionsUpdateExtendedFieldsRequestInput = <T extends Partial<WixCommonDataDataextensionsUpdateExtendedFieldsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespaceData')) {
        result.namespaceData = overrides && overrides.hasOwnProperty('namespaceData') ? overrides.namespaceData! : 'sapiente';
    }

    return result;
};

export const aWixCommonDocument = <T extends Partial<WixCommonDocument>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnail')) {
        result.thumbnail = overrides && overrides.hasOwnProperty('thumbnail') ? aWixCommonImage(overrides.thumbnail ?? {}, pickedFields.get('thumbnail')) : aWixCommonImage({}, pickedFields.get('thumbnail'));
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'voluptatem';
    }

    return result;
};

export const aWixCommonDocumentInput = <T extends Partial<WixCommonDocumentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'debitis';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnail')) {
        result.thumbnail = overrides && overrides.hasOwnProperty('thumbnail') ? aWixCommonImageInput(overrides.thumbnail ?? {}, pickedFields.get('thumbnail')) : aWixCommonImageInput({}, pickedFields.get('thumbnail'));
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'vel';
    }

    return result;
};

export const aWixCommonDomaineventsActionEventInput = <T extends Partial<WixCommonDomaineventsActionEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bodyAsJson')) {
        result.bodyAsJson = overrides && overrides.hasOwnProperty('bodyAsJson') ? overrides.bodyAsJson! : 'laudantium';
    }

    return result;
};

export const aWixCommonDomaineventsDomainEventInput = <T extends Partial<WixCommonDomaineventsDomainEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('actionEvent')) {
        result.actionEvent = overrides && overrides.hasOwnProperty('actionEvent') ? aWixCommonDomaineventsActionEventInput(overrides.actionEvent ?? {}, pickedFields.get('actionEvent')) : aWixCommonDomaineventsActionEventInput({}, pickedFields.get('actionEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdEvent')) {
        result.createdEvent = overrides && overrides.hasOwnProperty('createdEvent') ? aWixCommonDomaineventsEntityCreatedEventInput(overrides.createdEvent ?? {}, pickedFields.get('createdEvent')) : aWixCommonDomaineventsEntityCreatedEventInput({}, pickedFields.get('createdEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deletedEvent')) {
        result.deletedEvent = overrides && overrides.hasOwnProperty('deletedEvent') ? aWixCommonDomaineventsEntityDeletedEventInput(overrides.deletedEvent ?? {}, pickedFields.get('deletedEvent')) : aWixCommonDomaineventsEntityDeletedEventInput({}, pickedFields.get('deletedEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('entityEventSequence')) {
        result.entityEventSequence = overrides && overrides.hasOwnProperty('entityEventSequence') ? overrides.entityEventSequence! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('entityFqdn')) {
        result.entityFqdn = overrides && overrides.hasOwnProperty('entityFqdn') ? overrides.entityFqdn! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('entityId')) {
        result.entityId = overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventTime')) {
        result.eventTime = overrides && overrides.hasOwnProperty('eventTime') ? overrides.eventTime! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('originatedFrom')) {
        result.originatedFrom = overrides && overrides.hasOwnProperty('originatedFrom') ? overrides.originatedFrom! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('triggeredByAnonymizeRequest')) {
        result.triggeredByAnonymizeRequest = overrides && overrides.hasOwnProperty('triggeredByAnonymizeRequest') ? overrides.triggeredByAnonymizeRequest! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedEvent')) {
        result.updatedEvent = overrides && overrides.hasOwnProperty('updatedEvent') ? aWixCommonDomaineventsEntityUpdatedEventInput(overrides.updatedEvent ?? {}, pickedFields.get('updatedEvent')) : aWixCommonDomaineventsEntityUpdatedEventInput({}, pickedFields.get('updatedEvent'));
    }

    return result;
};

export const aWixCommonDomaineventsEntityCreatedEventInput = <T extends Partial<WixCommonDomaineventsEntityCreatedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('entityAsJson')) {
        result.entityAsJson = overrides && overrides.hasOwnProperty('entityAsJson') ? overrides.entityAsJson! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('triggeredByUndelete')) {
        result.triggeredByUndelete = overrides && overrides.hasOwnProperty('triggeredByUndelete') ? overrides.triggeredByUndelete! : true;
    }

    return result;
};

export const aWixCommonDomaineventsEntityDeletedEventInput = <T extends Partial<WixCommonDomaineventsEntityDeletedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deletedEntityAsJson')) {
        result.deletedEntityAsJson = overrides && overrides.hasOwnProperty('deletedEntityAsJson') ? overrides.deletedEntityAsJson! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('movedToTrash')) {
        result.movedToTrash = overrides && overrides.hasOwnProperty('movedToTrash') ? overrides.movedToTrash! : true;
    }

    return result;
};

export const aWixCommonDomaineventsEntityUpdatedEventInput = <T extends Partial<WixCommonDomaineventsEntityUpdatedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currentEntityAsJson')) {
        result.currentEntityAsJson = overrides && overrides.hasOwnProperty('currentEntityAsJson') ? overrides.currentEntityAsJson! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiedFields')) {
        result.modifiedFields = overrides && overrides.hasOwnProperty('modifiedFields') ? overrides.modifiedFields! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('previousEntityAsJson')) {
        result.previousEntityAsJson = overrides && overrides.hasOwnProperty('previousEntityAsJson') ? overrides.previousEntityAsJson! : 'impedit';
    }

    return result;
};

export const aWixCommonFocalPoint = <T extends Partial<WixCommonFocalPoint>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 4691;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 7002;
    }
    if (pickedFields.size === 0 || pickedFields.has('x')) {
        result.x = overrides && overrides.hasOwnProperty('x') ? overrides.x! : 6.68;
    }
    if (pickedFields.size === 0 || pickedFields.has('y')) {
        result.y = overrides && overrides.hasOwnProperty('y') ? overrides.y! : 6.44;
    }

    return result;
};

export const aWixCommonFocalPointInput = <T extends Partial<WixCommonFocalPointInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 4316;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 3248;
    }
    if (pickedFields.size === 0 || pickedFields.has('x')) {
        result.x = overrides && overrides.hasOwnProperty('x') ? overrides.x! : 7.51;
    }
    if (pickedFields.size === 0 || pickedFields.has('y')) {
        result.y = overrides && overrides.hasOwnProperty('y') ? overrides.y! : 7.37;
    }

    return result;
};

export const aWixCommonFullAddressContactDetailsInput = <T extends Partial<WixCommonFullAddressContactDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('fullName')) {
        result.fullName = overrides && overrides.hasOwnProperty('fullName') ? overrides.fullName! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('vatId')) {
        result.vatId = overrides && overrides.hasOwnProperty('vatId') ? aWixCommonVatIdInput(overrides.vatId ?? {}, pickedFields.get('vatId')) : aWixCommonVatIdInput({}, pickedFields.get('vatId'));
    }

    return result;
};

export const aWixCommonImage = <T extends Partial<WixCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('focalPoint')) {
        result.focalPoint = overrides && overrides.hasOwnProperty('focalPoint') ? aWixCommonFocalPoint(overrides.focalPoint ?? {}, pickedFields.get('focalPoint')) : aWixCommonFocalPoint({}, pickedFields.get('focalPoint'));
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 6412;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 9955;
    }

    return result;
};

export const aWixCommonImageInput = <T extends Partial<WixCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('focalPoint')) {
        result.focalPoint = overrides && overrides.hasOwnProperty('focalPoint') ? aWixCommonFocalPointInput(overrides.focalPoint ?? {}, pickedFields.get('focalPoint')) : aWixCommonFocalPointInput({}, pickedFields.get('focalPoint'));
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 7851;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 4639;
    }

    return result;
};

export const aWixCommonItemMetadata = <T extends Partial<WixCommonItemMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiApplicationError(overrides.error ?? {}, pickedFields.get('error')) : aWixApiApplicationError({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalIndex')) {
        result.originalIndex = overrides && overrides.hasOwnProperty('originalIndex') ? overrides.originalIndex! : 6146;
    }
    if (pickedFields.size === 0 || pickedFields.has('success')) {
        result.success = overrides && overrides.hasOwnProperty('success') ? overrides.success! : true;
    }

    return result;
};

export const aWixCommonPageLink = <T extends Partial<WixCommonPageLink>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pageId')) {
        result.pageId = overrides && overrides.hasOwnProperty('pageId') ? overrides.pageId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('rel')) {
        result.rel = overrides && overrides.hasOwnProperty('rel') ? overrides.rel! : [WixCommonLinkRel.Nofollow];
    }
    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : 'facere';
    }

    return result;
};

export const aWixCommonPageLinkInput = <T extends Partial<WixCommonPageLinkInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pageId')) {
        result.pageId = overrides && overrides.hasOwnProperty('pageId') ? overrides.pageId! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('rel')) {
        result.rel = overrides && overrides.hasOwnProperty('rel') ? overrides.rel! : [WixCommonLinkRel.Nofollow];
    }
    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : 'accusantium';
    }

    return result;
};

export const aWixCommonPageUrl = <T extends Partial<WixCommonPageUrl>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('base')) {
        result.base = overrides && overrides.hasOwnProperty('base') ? overrides.base! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('path')) {
        result.path = overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'cumque';
    }

    return result;
};

export const aWixCommonPageUrlInput = <T extends Partial<WixCommonPageUrlInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('base')) {
        result.base = overrides && overrides.hasOwnProperty('base') ? overrides.base! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('path')) {
        result.path = overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'consequatur';
    }

    return result;
};

export const aWixCommonPageUrlV2 = <T extends Partial<WixCommonPageUrlV2>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('relativePath')) {
        result.relativePath = overrides && overrides.hasOwnProperty('relativePath') ? overrides.relativePath! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'molestiae';
    }

    return result;
};

export const aWixCommonPageUrlV2Input = <T extends Partial<WixCommonPageUrlV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('relativePath')) {
        result.relativePath = overrides && overrides.hasOwnProperty('relativePath') ? overrides.relativePath! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'modi';
    }

    return result;
};

export const aWixCommonPagingInput = <T extends Partial<WixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 7606;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 6624;
    }

    return result;
};

export const aWixCommonPagingMetadata = <T extends Partial<WixCommonPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 407;
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 226;
    }
    if (pickedFields.size === 0 || pickedFields.has('tooManyToCount')) {
        result.tooManyToCount = overrides && overrides.hasOwnProperty('tooManyToCount') ? overrides.tooManyToCount! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 7265;
    }

    return result;
};

export const aWixCommonPagingMetadataV2 = <T extends Partial<WixCommonPagingMetadataV2>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 4424;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 2775;
    }
    if (pickedFields.size === 0 || pickedFields.has('tooManyToCount')) {
        result.tooManyToCount = overrides && overrides.hasOwnProperty('tooManyToCount') ? overrides.tooManyToCount! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 3791;
    }

    return result;
};

export const aWixCommonQueryInput = <T extends Partial<WixCommonQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['quos'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['minus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixCommonQueryV2Input = <T extends Partial<WixCommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['eius'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['et'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'nisi';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixCommonSearchDetailsInput = <T extends Partial<WixCommonSearchDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['unde'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fuzzy')) {
        result.fuzzy = overrides && overrides.hasOwnProperty('fuzzy') ? overrides.fuzzy! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('mode')) {
        result.mode = overrides && overrides.hasOwnProperty('mode') ? overrides.mode! : WixCommonSearchDetailsMode.And;
    }

    return result;
};

export const aWixCommonSortingInput = <T extends Partial<WixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixCommonSortOrder.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('selectItemsBy')) {
        result.selectItemsBy = overrides && overrides.hasOwnProperty('selectItemsBy') ? overrides.selectItemsBy! : ['ut'];
    }

    return result;
};

export const aWixCommonStreetAddress = <T extends Partial<WixCommonStreetAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddressLine')) {
        result.formattedAddressLine = overrides && overrides.hasOwnProperty('formattedAddressLine') ? overrides.formattedAddressLine! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'iste';
    }

    return result;
};

export const aWixCommonStreetAddressInput = <T extends Partial<WixCommonStreetAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddressLine')) {
        result.formattedAddressLine = overrides && overrides.hasOwnProperty('formattedAddressLine') ? overrides.formattedAddressLine! : 'hic';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'iure';
    }

    return result;
};

export const aWixCommonSubdivision = <T extends Partial<WixCommonSubdivision>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('standardDetails')) {
        result.standardDetails = overrides && overrides.hasOwnProperty('standardDetails') ? aWixCommonSubdivisionStandardDetails(overrides.standardDetails ?? {}, pickedFields.get('standardDetails')) : aWixCommonSubdivisionStandardDetails({}, pickedFields.get('standardDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonSubdivisionSubdivisionType.AdministrativeAreaLevel_1;
    }
    if (pickedFields.size === 0 || pickedFields.has('typeInfo')) {
        result.typeInfo = overrides && overrides.hasOwnProperty('typeInfo') ? overrides.typeInfo! : 'sed';
    }

    return result;
};

export const aWixCommonSubdivisionInput = <T extends Partial<WixCommonSubdivisionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('standardDetails')) {
        result.standardDetails = overrides && overrides.hasOwnProperty('standardDetails') ? aWixCommonSubdivisionStandardDetailsInput(overrides.standardDetails ?? {}, pickedFields.get('standardDetails')) : aWixCommonSubdivisionStandardDetailsInput({}, pickedFields.get('standardDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonSubdivisionSubdivisionType.AdministrativeAreaLevel_1;
    }
    if (pickedFields.size === 0 || pickedFields.has('typeInfo')) {
        result.typeInfo = overrides && overrides.hasOwnProperty('typeInfo') ? overrides.typeInfo! : 'minima';
    }

    return result;
};

export const aWixCommonSubdivisionStandardDetails = <T extends Partial<WixCommonSubdivisionStandardDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('iso31662')) {
        result.iso31662 = overrides && overrides.hasOwnProperty('iso31662') ? overrides.iso31662! : 'ullam';
    }

    return result;
};

export const aWixCommonSubdivisionStandardDetailsInput = <T extends Partial<WixCommonSubdivisionStandardDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('iso31662')) {
        result.iso31662 = overrides && overrides.hasOwnProperty('iso31662') ? overrides.iso31662! : 'nam';
    }

    return result;
};

export const aWixCommonTagsTags = <T extends Partial<WixCommonTagsTags>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('privateTags')) {
        result.privateTags = overrides && overrides.hasOwnProperty('privateTags') ? aWixCommonTagsTagsTagList(overrides.privateTags ?? {}, pickedFields.get('privateTags')) : aWixCommonTagsTagsTagList({}, pickedFields.get('privateTags'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? aWixCommonTagsTagsTagList(overrides.tags ?? {}, pickedFields.get('tags')) : aWixCommonTagsTagsTagList({}, pickedFields.get('tags'));
    }

    return result;
};

export const aWixCommonTagsTagsInput = <T extends Partial<WixCommonTagsTagsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('privateTags')) {
        result.privateTags = overrides && overrides.hasOwnProperty('privateTags') ? aWixCommonTagsTagsTagListInput(overrides.privateTags ?? {}, pickedFields.get('privateTags')) : aWixCommonTagsTagsTagListInput({}, pickedFields.get('privateTags'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? aWixCommonTagsTagsTagListInput(overrides.tags ?? {}, pickedFields.get('tags')) : aWixCommonTagsTagsTagListInput({}, pickedFields.get('tags'));
    }

    return result;
};

export const aWixCommonTagsTagsTagList = <T extends Partial<WixCommonTagsTagsTagList>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tagIds')) {
        result.tagIds = overrides && overrides.hasOwnProperty('tagIds') ? overrides.tagIds! : ['libero'];
    }

    return result;
};

export const aWixCommonTagsTagsTagListInput = <T extends Partial<WixCommonTagsTagsTagListInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tagIds')) {
        result.tagIds = overrides && overrides.hasOwnProperty('tagIds') ? overrides.tagIds! : ['voluptates'];
    }

    return result;
};

export const aWixCommonVatId = <T extends Partial<WixCommonVatId>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonVatType.Cnpj;
    }

    return result;
};

export const aWixCommonVatIdInput = <T extends Partial<WixCommonVatIdInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixCommonVatType.Cnpj;
    }

    return result;
};

export const aWixCommonVideo = <T extends Partial<WixCommonVideo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 1017;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnail')) {
        result.thumbnail = overrides && overrides.hasOwnProperty('thumbnail') ? aWixCommonImage(overrides.thumbnail ?? {}, pickedFields.get('thumbnail')) : aWixCommonImage({}, pickedFields.get('thumbnail'));
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 9618;
    }

    return result;
};

export const aWixCommonVideoResolution = <T extends Partial<WixCommonVideoResolution>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('assetKey')) {
        result.assetKey = overrides && overrides.hasOwnProperty('assetKey') ? overrides.assetKey! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('durationInMilliseconds')) {
        result.durationInMilliseconds = overrides && overrides.hasOwnProperty('durationInMilliseconds') ? overrides.durationInMilliseconds! : 4122;
    }
    if (pickedFields.size === 0 || pickedFields.has('durationInSeconds')) {
        result.durationInSeconds = overrides && overrides.hasOwnProperty('durationInSeconds') ? overrides.durationInSeconds! : 4359;
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 8564;
    }
    if (pickedFields.size === 0 || pickedFields.has('poster')) {
        result.poster = overrides && overrides.hasOwnProperty('poster') ? aWixCommonImage(overrides.poster ?? {}, pickedFields.get('poster')) : aWixCommonImage({}, pickedFields.get('poster'));
    }
    if (pickedFields.size === 0 || pickedFields.has('private')) {
        result.private = overrides && overrides.hasOwnProperty('private') ? overrides.private! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('quality')) {
        result.quality = overrides && overrides.hasOwnProperty('quality') ? overrides.quality! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 4491;
    }

    return result;
};

export const aWixCommonVideoResolutionInput = <T extends Partial<WixCommonVideoResolutionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('assetKey')) {
        result.assetKey = overrides && overrides.hasOwnProperty('assetKey') ? overrides.assetKey! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('durationInMilliseconds')) {
        result.durationInMilliseconds = overrides && overrides.hasOwnProperty('durationInMilliseconds') ? overrides.durationInMilliseconds! : 6371;
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 1473;
    }
    if (pickedFields.size === 0 || pickedFields.has('poster')) {
        result.poster = overrides && overrides.hasOwnProperty('poster') ? aWixCommonImageInput(overrides.poster ?? {}, pickedFields.get('poster')) : aWixCommonImageInput({}, pickedFields.get('poster'));
    }
    if (pickedFields.size === 0 || pickedFields.has('private')) {
        result.private = overrides && overrides.hasOwnProperty('private') ? overrides.private! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('quality')) {
        result.quality = overrides && overrides.hasOwnProperty('quality') ? overrides.quality! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 7482;
    }

    return result;
};

export const aWixCommonVideoV2 = <T extends Partial<WixCommonVideoV2>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('durationInMilliseconds')) {
        result.durationInMilliseconds = overrides && overrides.hasOwnProperty('durationInMilliseconds') ? overrides.durationInMilliseconds! : 6785;
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 716;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('posters')) {
        result.posters = overrides && overrides.hasOwnProperty('posters') ? overrides.posters!.map((x) => aWixCommonImage(x ?? {}, pickedFields.get('posters'))) : [aWixCommonImage({}, pickedFields.get('posters'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('resolutions')) {
        result.resolutions = overrides && overrides.hasOwnProperty('resolutions') ? overrides.resolutions!.map((x) => aWixCommonVideoResolution(x ?? {}, pickedFields.get('resolutions'))) : [aWixCommonVideoResolution({}, pickedFields.get('resolutions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 2510;
    }

    return result;
};

export const aWixCommonVideoV2Input = <T extends Partial<WixCommonVideoV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('durationInMilliseconds')) {
        result.durationInMilliseconds = overrides && overrides.hasOwnProperty('durationInMilliseconds') ? overrides.durationInMilliseconds! : 3032;
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 7857;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('posters')) {
        result.posters = overrides && overrides.hasOwnProperty('posters') ? overrides.posters!.map((x) => aWixCommonImageInput({}, pickedFields.get('posters'))) : [aWixCommonImageInput({}, pickedFields.get('posters'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('resolutions')) {
        result.resolutions = overrides && overrides.hasOwnProperty('resolutions') ? overrides.resolutions!.map((x) => aWixCommonVideoResolutionInput({}, pickedFields.get('resolutions'))) : [aWixCommonVideoResolutionInput({}, pickedFields.get('resolutions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 924;
    }

    return result;
};

export const aWixCoreservicesMetroinspectorV1EchoMessage = <T extends Partial<WixCoreservicesMetroinspectorV1EchoMessage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('messagesList')) {
        result.messagesList = overrides && overrides.hasOwnProperty('messagesList') ? overrides.messagesList!.map((x) => aWixCoreservicesMetroinspectorV1MessageItem(x ?? {}, pickedFields.get('messagesList'))) : [aWixCoreservicesMetroinspectorV1MessageItem({}, pickedFields.get('messagesList'))];
    }

    return result;
};

export const aWixCoreservicesMetroinspectorV1EchoRequestInput = <T extends Partial<WixCoreservicesMetroinspectorV1EchoRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('arg1')) {
        result.arg1 = overrides && overrides.hasOwnProperty('arg1') ? overrides.arg1! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('arg2')) {
        result.arg2 = overrides && overrides.hasOwnProperty('arg2') ? overrides.arg2! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('someDate')) {
        result.someDate = overrides && overrides.hasOwnProperty('someDate') ? overrides.someDate! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('someInt32')) {
        result.someInt32 = overrides && overrides.hasOwnProperty('someInt32') ? overrides.someInt32! : 4115;
    }
    if (pickedFields.size === 0 || pickedFields.has('titleField')) {
        result.titleField = overrides && overrides.hasOwnProperty('titleField') ? overrides.titleField! : 'magnam';
    }

    return result;
};

export const aWixCoreservicesMetroinspectorV1EchoResponse = <T extends Partial<WixCoreservicesMetroinspectorV1EchoResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('echoMessage')) {
        result.echoMessage = overrides && overrides.hasOwnProperty('echoMessage') ? aWixCoreservicesMetroinspectorV1EchoMessage(overrides.echoMessage ?? {}, pickedFields.get('echoMessage')) : aWixCoreservicesMetroinspectorV1EchoMessage({}, pickedFields.get('echoMessage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'ex';
    }

    return result;
};

export const aWixCoreservicesMetroinspectorV1MessageItem = <T extends Partial<WixCoreservicesMetroinspectorV1MessageItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('innerMessage')) {
        result.innerMessage = overrides && overrides.hasOwnProperty('innerMessage') ? overrides.innerMessage! : 'molestias';
    }

    return result;
};

export const aWixCouponsApiV2Scope = <T extends Partial<WixCouponsApiV2Scope>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('group')) {
        result.group = overrides && overrides.hasOwnProperty('group') ? aWixCouponsApiV2ScopeGroup(overrides.group ?? {}, pickedFields.get('group')) : aWixCouponsApiV2ScopeGroup({}, pickedFields.get('group'));
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'et';
    }

    return result;
};

export const aWixCouponsApiV2ScopeGroup = <T extends Partial<WixCouponsApiV2ScopeGroup>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('entityId')) {
        result.entityId = overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ex';
    }

    return result;
};

export const aWixCouponsApiV2ScopeGroupInput = <T extends Partial<WixCouponsApiV2ScopeGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('entityId')) {
        result.entityId = overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'qui';
    }

    return result;
};

export const aWixCouponsApiV2ScopeInput = <T extends Partial<WixCouponsApiV2ScopeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('group')) {
        result.group = overrides && overrides.hasOwnProperty('group') ? aWixCouponsApiV2ScopeGroupInput(overrides.group ?? {}, pickedFields.get('group')) : aWixCouponsApiV2ScopeGroupInput({}, pickedFields.get('group'));
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'quo';
    }

    return result;
};

export const aWixCrmCommonSourceInput = <T extends Partial<WixCrmCommonSourceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sourceId')) {
        result.sourceId = overrides && overrides.hasOwnProperty('sourceId') ? overrides.sourceId! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceType')) {
        result.sourceType = overrides && overrides.hasOwnProperty('sourceType') ? overrides.sourceType! : WixCrmCommonSourceSourceType.Admin;
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1GetMetasiteDataRequestInput = <T extends Partial<WixEcomOrdersBackofficeV1GetMetasiteDataRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metasiteId')) {
        result.metasiteId = overrides && overrides.hasOwnProperty('metasiteId') ? overrides.metasiteId! : 'quia';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1GetMetasiteDataResponse = <T extends Partial<WixEcomOrdersBackofficeV1GetMetasiteDataResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('isInNewPopulation')) {
        result.isInNewPopulation = overrides && overrides.hasOwnProperty('isInNewPopulation') ? overrides.isInNewPopulation! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('metasite')) {
        result.metasite = overrides && overrides.hasOwnProperty('metasite') ? aComWixpressMetasiteApiV1MetaSite(overrides.metasite ?? {}, pickedFields.get('metasite')) : aComWixpressMetasiteApiV1MetaSite({}, pickedFields.get('metasite'));
    }
    if (pickedFields.size === 0 || pickedFields.has('metasiteUrl')) {
        result.metasiteUrl = overrides && overrides.hasOwnProperty('metasiteUrl') ? overrides.metasiteUrl! : 'cupiditate';
    }
    if (pickedFields.size === 0 || pickedFields.has('userDataResponse')) {
        result.userDataResponse = overrides && overrides.hasOwnProperty('userDataResponse') ? aWixEcomOrdersBackofficeV1UserDataResponse(overrides.userDataResponse ?? {}, pickedFields.get('userDataResponse')) : aWixEcomOrdersBackofficeV1UserDataResponse({}, pickedFields.get('userDataResponse'));
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1GetOrderAgcRequestInput = <T extends Partial<WixEcomOrdersBackofficeV1GetOrderAgcRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'non';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1GetOrderAgcResponse = <T extends Partial<WixEcomOrdersBackofficeV1GetOrderAgcResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'nihil';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1GetOrderForMetasiteRequestInput = <T extends Partial<WixEcomOrdersBackofficeV1GetOrderForMetasiteRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metasiteId')) {
        result.metasiteId = overrides && overrides.hasOwnProperty('metasiteId') ? overrides.metasiteId! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'id';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1GetOrderForMetasiteResponse = <T extends Partial<WixEcomOrdersBackofficeV1GetOrderForMetasiteResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1GetOrderOutOfBoxRequestInput = <T extends Partial<WixEcomOrdersBackofficeV1GetOrderOutOfBoxRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolorem';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1GetOrderOutOfBoxResponse = <T extends Partial<WixEcomOrdersBackofficeV1GetOrderOutOfBoxResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'eos';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1GetOrderWithFilterByLocationRequestInput = <T extends Partial<WixEcomOrdersBackofficeV1GetOrderWithFilterByLocationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nulla';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1GetOrderWithFilterByLocationResponse = <T extends Partial<WixEcomOrdersBackofficeV1GetOrderWithFilterByLocationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'quia';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteRequestInput = <T extends Partial<WixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metasiteId')) {
        result.metasiteId = overrides && overrides.hasOwnProperty('metasiteId') ? overrides.metasiteId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'labore';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteResponse = <T extends Partial<WixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1ListOrdersForMetasiteRequestInput = <T extends Partial<WixEcomOrdersBackofficeV1ListOrdersForMetasiteRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('listOrderRequest')) {
        result.listOrderRequest = overrides && overrides.hasOwnProperty('listOrderRequest') ? aComWixEcomOrdersV1ListOrdersRequestInput(overrides.listOrderRequest ?? {}, pickedFields.get('listOrderRequest')) : aComWixEcomOrdersV1ListOrdersRequestInput({}, pickedFields.get('listOrderRequest'));
    }
    if (pickedFields.size === 0 || pickedFields.has('metasiteId')) {
        result.metasiteId = overrides && overrides.hasOwnProperty('metasiteId') ? overrides.metasiteId! : 'quis';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1ListOrdersForMetasiteResponse = <T extends Partial<WixEcomOrdersBackofficeV1ListOrdersForMetasiteResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orders')) {
        result.orders = overrides && overrides.hasOwnProperty('orders') ? overrides.orders!.map((x) => aComWixEcomOrdersV1Order(x ?? {}, pickedFields.get('orders'))) : [aComWixEcomOrdersV1Order({}, pickedFields.get('orders'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1QueryOrdersForMetasiteRequestInput = <T extends Partial<WixEcomOrdersBackofficeV1QueryOrdersForMetasiteRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('internalQueryOrdersRequest')) {
        result.internalQueryOrdersRequest = overrides && overrides.hasOwnProperty('internalQueryOrdersRequest') ? aComWixEcomOrdersV1InternalQueryOrdersRequestInput(overrides.internalQueryOrdersRequest ?? {}, pickedFields.get('internalQueryOrdersRequest')) : aComWixEcomOrdersV1InternalQueryOrdersRequestInput({}, pickedFields.get('internalQueryOrdersRequest'));
    }
    if (pickedFields.size === 0 || pickedFields.has('metasiteId')) {
        result.metasiteId = overrides && overrides.hasOwnProperty('metasiteId') ? overrides.metasiteId! : 'rerum';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1QueryOrdersForMetasiteResponse = <T extends Partial<WixEcomOrdersBackofficeV1QueryOrdersForMetasiteResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orders')) {
        result.orders = overrides && overrides.hasOwnProperty('orders') ? overrides.orders!.map((x) => aComWixEcomOrdersV1Order(x ?? {}, pickedFields.get('orders'))) : [aComWixEcomOrdersV1Order({}, pickedFields.get('orders'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixEcommerceCommonsApiPlatformPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixEcommerceCommonsApiPlatformPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1TestUrlAdditionalBindingsRequestInput = <T extends Partial<WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('testId')) {
        result.testId = overrides && overrides.hasOwnProperty('testId') ? overrides.testId! : 'omnis';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1TestUrlAdditionalBindingsResponse = <T extends Partial<WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('responseString')) {
        result.responseString = overrides && overrides.hasOwnProperty('responseString') ? overrides.responseString! : 'qui';
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1UpdateOrderRequestInput = <T extends Partial<WixEcomOrdersBackofficeV1UpdateOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['nisi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1OrderInput(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1OrderInput({}, pickedFields.get('order'));
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1UpdateOrderResponse = <T extends Partial<WixEcomOrdersBackofficeV1UpdateOrderResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1UpsertRefundRequestInput = <T extends Partial<WixEcomOrdersBackofficeV1UpsertRefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metasiteId')) {
        result.metasiteId = overrides && overrides.hasOwnProperty('metasiteId') ? overrides.metasiteId! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? aComWixEcomOrdersPaymentsV1RefundInput(overrides.refund ?? {}, pickedFields.get('refund')) : aComWixEcomOrdersPaymentsV1RefundInput({}, pickedFields.get('refund'));
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1UpsertRefundResponse = <T extends Partial<WixEcomOrdersBackofficeV1UpsertRefundResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderTransactions')) {
        result.orderTransactions = overrides && overrides.hasOwnProperty('orderTransactions') ? aComWixEcomOrdersPaymentsV1OrderTransactions(overrides.orderTransactions ?? {}, pickedFields.get('orderTransactions')) : aComWixEcomOrdersPaymentsV1OrderTransactions({}, pickedFields.get('orderTransactions'));
    }

    return result;
};

export const aWixEcomOrdersBackofficeV1UserDataResponse = <T extends Partial<WixEcomOrdersBackofficeV1UserDataResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('userEmail')) {
        result.userEmail = overrides && overrides.hasOwnProperty('userEmail') ? overrides.userEmail! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('userLanguage')) {
        result.userLanguage = overrides && overrides.hasOwnProperty('userLanguage') ? overrides.userLanguage! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('userName')) {
        result.userName = overrides && overrides.hasOwnProperty('userName') ? overrides.userName! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('userStatus')) {
        result.userStatus = overrides && overrides.hasOwnProperty('userStatus') ? overrides.userStatus! : 'ad';
    }

    return result;
};

export const aWixEcommerceSubscriptionOptionApiV1DiscountInput = <T extends Partial<WixEcommerceSubscriptionOptionApiV1DiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixEcommerceSubscriptionOptionApiV1DiscountDiscountType.Amount;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 1.08;
    }

    return result;
};

export const aWixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput = <T extends Partial<WixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoRenewal')) {
        result.autoRenewal = overrides && overrides.hasOwnProperty('autoRenewal') ? overrides.autoRenewal! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('billingCycles')) {
        result.billingCycles = overrides && overrides.hasOwnProperty('billingCycles') ? overrides.billingCycles! : 2848;
    }
    if (pickedFields.size === 0 || pickedFields.has('frequency')) {
        result.frequency = overrides && overrides.hasOwnProperty('frequency') ? overrides.frequency! : WixPaymentApiPayV2SubscriptionFrequency.Day;
    }
    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : 4026;
    }

    return result;
};

export const aWixEventsAgenda = <T extends Partial<WixEventsAgenda>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('pageUrl')) {
        result.pageUrl = overrides && overrides.hasOwnProperty('pageUrl') ? aWixEventsSiteUrl(overrides.pageUrl ?? {}, pickedFields.get('pageUrl')) : aWixEventsSiteUrl({}, pickedFields.get('pageUrl'));
    }

    return result;
};

export const aWixEventsAgendaInput = <T extends Partial<WixEventsAgendaInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('pageUrl')) {
        result.pageUrl = overrides && overrides.hasOwnProperty('pageUrl') ? aWixEventsSiteUrlInput(overrides.pageUrl ?? {}, pickedFields.get('pageUrl')) : aWixEventsSiteUrlInput({}, pickedFields.get('pageUrl'));
    }

    return result;
};

export const aWixEventsBadge = <T extends Partial<WixEventsBadge>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('functionUpdateDate')) {
        result.functionUpdateDate = overrides && overrides.hasOwnProperty('functionUpdateDate') ? overrides.functionUpdateDate! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixEventsBadgeTypeType.FirstPriority;
    }

    return result;
};

export const aWixEventsBulkCancelEventsRequestInput = <T extends Partial<WixEventsBulkCancelEventsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'tempora';
    }

    return result;
};

export const aWixEventsBulkDeleteEventsRequestInput = <T extends Partial<WixEventsBulkDeleteEventsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'delectus';
    }

    return result;
};

export const aWixEventsCalendarLinks = <T extends Partial<WixEventsCalendarLinks>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('google')) {
        result.google = overrides && overrides.hasOwnProperty('google') ? overrides.google! : 'eius';
    }
    if (pickedFields.size === 0 || pickedFields.has('ics')) {
        result.ics = overrides && overrides.hasOwnProperty('ics') ? overrides.ics! : 'voluptatem';
    }

    return result;
};

export const aWixEventsCancelEventRequestInput = <T extends Partial<WixEventsCancelEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aliquid';
    }

    return result;
};

export const aWixEventsCancelEventResponse = <T extends Partial<WixEventsCancelEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEvent(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEvent({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixEventsCategoriesCategory = <T extends Partial<WixEventsCategoriesCategory>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('assignedEventsCount')) {
        result.assignedEventsCount = overrides && overrides.hasOwnProperty('assignedEventsCount') ? overrides.assignedEventsCount! : 5759;
    }
    if (pickedFields.size === 0 || pickedFields.has('counts')) {
        result.counts = overrides && overrides.hasOwnProperty('counts') ? aWixEventsCategoriesCategoryCounts(overrides.counts ?? {}, pickedFields.get('counts')) : aWixEventsCategoriesCategoryCounts({}, pickedFields.get('counts'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('states')) {
        result.states = overrides && overrides.hasOwnProperty('states') ? overrides.states! : [WixEventsCategoryStateState.Auto];
    }

    return result;
};

export const aWixEventsCategoriesCategoryCounts = <T extends Partial<WixEventsCategoriesCategoryCounts>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('assignedDraftEventsCount')) {
        result.assignedDraftEventsCount = overrides && overrides.hasOwnProperty('assignedDraftEventsCount') ? overrides.assignedDraftEventsCount! : 5654;
    }
    if (pickedFields.size === 0 || pickedFields.has('assignedEventsCount')) {
        result.assignedEventsCount = overrides && overrides.hasOwnProperty('assignedEventsCount') ? overrides.assignedEventsCount! : 2054;
    }

    return result;
};

export const aWixEventsCategoryFilterInput = <T extends Partial<WixEventsCategoryFilterInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categorised')) {
        result.categorised = overrides && overrides.hasOwnProperty('categorised') ? overrides.categorised! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('categoryId')) {
        result.categoryId = overrides && overrides.hasOwnProperty('categoryId') ? overrides.categoryId! : ['est'];
    }
    if (pickedFields.size === 0 || pickedFields.has('states')) {
        result.states = overrides && overrides.hasOwnProperty('states') ? overrides.states! : [WixEventsCategoryStateState.Auto];
    }

    return result;
};

export const aWixEventsCopyEventFromOtherSiteRequestInput = <T extends Partial<WixEventsCopyEventFromOtherSiteRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldset')) {
        result.fieldset = overrides && overrides.hasOwnProperty('fieldset') ? overrides.fieldset! : [WixEventsEventFieldset.Agenda];
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'voluptate';
    }

    return result;
};

export const aWixEventsCopyEventFromOtherSiteResponse = <T extends Partial<WixEventsCopyEventFromOtherSiteResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEvent(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEvent({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixEventsCopyEventRequestInput = <T extends Partial<WixEventsCopyEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('draft')) {
        result.draft = overrides && overrides.hasOwnProperty('draft') ? overrides.draft! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'ea';
    }

    return result;
};

export const aWixEventsCopyEventResponse = <T extends Partial<WixEventsCopyEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEvent(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEvent({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixEventsCopyEventV2RequestInput = <T extends Partial<WixEventsCopyEventV2RequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('draft')) {
        result.draft = overrides && overrides.hasOwnProperty('draft') ? overrides.draft! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEventDataInput(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEventDataInput({}, pickedFields.get('event'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['qui'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vitae';
    }

    return result;
};

export const aWixEventsCopyEventV2Response = <T extends Partial<WixEventsCopyEventV2Response>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEvent(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEvent({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixEventsCreateEventV2RequestInput = <T extends Partial<WixEventsCreateEventV2RequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('draft')) {
        result.draft = overrides && overrides.hasOwnProperty('draft') ? overrides.draft! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEventDataInput(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEventDataInput({}, pickedFields.get('event'));
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'et';
    }

    return result;
};

export const aWixEventsCreateEventV2Response = <T extends Partial<WixEventsCreateEventV2Response>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEvent(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEvent({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixEventsDashboard = <T extends Partial<WixEventsDashboard>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('rsvpSummary')) {
        result.rsvpSummary = overrides && overrides.hasOwnProperty('rsvpSummary') ? aWixEventsDashboardRsvpSummary(overrides.rsvpSummary ?? {}, pickedFields.get('rsvpSummary')) : aWixEventsDashboardRsvpSummary({}, pickedFields.get('rsvpSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ticketingSummary')) {
        result.ticketingSummary = overrides && overrides.hasOwnProperty('ticketingSummary') ? aWixEventsDashboardTicketingSummary(overrides.ticketingSummary ?? {}, pickedFields.get('ticketingSummary')) : aWixEventsDashboardTicketingSummary({}, pickedFields.get('ticketingSummary'));
    }

    return result;
};

export const aWixEventsDashboardRsvpSummary = <T extends Partial<WixEventsDashboardRsvpSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('no')) {
        result.no = overrides && overrides.hasOwnProperty('no') ? overrides.no! : 1788;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 2194;
    }
    if (pickedFields.size === 0 || pickedFields.has('waitlist')) {
        result.waitlist = overrides && overrides.hasOwnProperty('waitlist') ? overrides.waitlist! : 5227;
    }
    if (pickedFields.size === 0 || pickedFields.has('yes')) {
        result.yes = overrides && overrides.hasOwnProperty('yes') ? overrides.yes! : 8848;
    }

    return result;
};

export const aWixEventsDashboardTicketingSummary = <T extends Partial<WixEventsDashboardTicketingSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currencyLocked')) {
        result.currencyLocked = overrides && overrides.hasOwnProperty('currencyLocked') ? overrides.currencyLocked! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('orders')) {
        result.orders = overrides && overrides.hasOwnProperty('orders') ? overrides.orders! : 9218;
    }
    if (pickedFields.size === 0 || pickedFields.has('revenue')) {
        result.revenue = overrides && overrides.hasOwnProperty('revenue') ? aWixEventsMoney(overrides.revenue ?? {}, pickedFields.get('revenue')) : aWixEventsMoney({}, pickedFields.get('revenue'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tickets')) {
        result.tickets = overrides && overrides.hasOwnProperty('tickets') ? overrides.tickets! : 9092;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalSales')) {
        result.totalSales = overrides && overrides.hasOwnProperty('totalSales') ? aWixEventsMoney(overrides.totalSales ?? {}, pickedFields.get('totalSales')) : aWixEventsMoney({}, pickedFields.get('totalSales'));
    }

    return result;
};

export const aWixEventsDeleteEventRequestInput = <T extends Partial<WixEventsDeleteEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'facilis';
    }

    return result;
};

export const aWixEventsDeleteEventResponse = <T extends Partial<WixEventsDeleteEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'occaecati';
    }

    return result;
};

export const aWixEventsEvent = <T extends Partial<WixEventsEvent>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('about')) {
        result.about = overrides && overrides.hasOwnProperty('about') ? overrides.about! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('agenda')) {
        result.agenda = overrides && overrides.hasOwnProperty('agenda') ? aWixEventsAgenda(overrides.agenda ?? {}, pickedFields.get('agenda')) : aWixEventsAgenda({}, pickedFields.get('agenda'));
    }
    if (pickedFields.size === 0 || pickedFields.has('assignedContactsLabel')) {
        result.assignedContactsLabel = overrides && overrides.hasOwnProperty('assignedContactsLabel') ? overrides.assignedContactsLabel! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('badges')) {
        result.badges = overrides && overrides.hasOwnProperty('badges') ? overrides.badges!.map((x) => aWixEventsBadge(x ?? {}, pickedFields.get('badges'))) : [aWixEventsBadge({}, pickedFields.get('badges'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('calendarLinks')) {
        result.calendarLinks = overrides && overrides.hasOwnProperty('calendarLinks') ? aWixEventsCalendarLinks(overrides.calendarLinks ?? {}, pickedFields.get('calendarLinks')) : aWixEventsCalendarLinks({}, pickedFields.get('calendarLinks'));
    }
    if (pickedFields.size === 0 || pickedFields.has('categories')) {
        result.categories = overrides && overrides.hasOwnProperty('categories') ? overrides.categories!.map((x) => aWixEventsCategoriesCategory(x ?? {}, pickedFields.get('categories'))) : [aWixEventsCategoriesCategory({}, pickedFields.get('categories'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('created')) {
        result.created = overrides && overrides.hasOwnProperty('created') ? overrides.created! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('customizableTickets')) {
        result.customizableTickets = overrides && overrides.hasOwnProperty('customizableTickets') ? overrides.customizableTickets! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('dashboard')) {
        result.dashboard = overrides && overrides.hasOwnProperty('dashboard') ? aWixEventsDashboard(overrides.dashboard ?? {}, pickedFields.get('dashboard')) : aWixEventsDashboard({}, pickedFields.get('dashboard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventDisplaySettings')) {
        result.eventDisplaySettings = overrides && overrides.hasOwnProperty('eventDisplaySettings') ? aWixEventsEventDisplaySettings(overrides.eventDisplaySettings ?? {}, pickedFields.get('eventDisplaySettings')) : aWixEventsEventDisplaySettings({}, pickedFields.get('eventDisplaySettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('eventPageUrl')) {
        result.eventPageUrl = overrides && overrides.hasOwnProperty('eventPageUrl') ? aWixEventsSiteUrl(overrides.eventPageUrl ?? {}, pickedFields.get('eventPageUrl')) : aWixEventsSiteUrl({}, pickedFields.get('eventPageUrl'));
    }
    if (pickedFields.size === 0 || pickedFields.has('feed')) {
        result.feed = overrides && overrides.hasOwnProperty('feed') ? aWixEventsFeed(overrides.feed ?? {}, pickedFields.get('feed')) : aWixEventsFeed({}, pickedFields.get('feed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixEventsFormForm(overrides.form ?? {}, pickedFields.get('form')) : aWixEventsFormForm({}, pickedFields.get('form'));
    }
    if (pickedFields.size === 0 || pickedFields.has('guestListConfig')) {
        result.guestListConfig = overrides && overrides.hasOwnProperty('guestListConfig') ? aWixEventsGuestListConfig(overrides.guestListConfig ?? {}, pickedFields.get('guestListConfig')) : aWixEventsGuestListConfig({}, pickedFields.get('guestListConfig'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('instanceId')) {
        result.instanceId = overrides && overrides.hasOwnProperty('instanceId') ? overrides.instanceId! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('labellingSettings')) {
        result.labellingSettings = overrides && overrides.hasOwnProperty('labellingSettings') ? aWixEventsLabellingSettings(overrides.labellingSettings ?? {}, pickedFields.get('labellingSettings')) : aWixEventsLabellingSettings({}, pickedFields.get('labellingSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aWixEventsLocation(overrides.location ?? {}, pickedFields.get('location')) : aWixEventsLocation({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('longDescription')) {
        result.longDescription = overrides && overrides.hasOwnProperty('longDescription') ? aWixRichContentV1RichContent(overrides.longDescription ?? {}, pickedFields.get('longDescription')) : aWixRichContentV1RichContent({}, pickedFields.get('longDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mainImage')) {
        result.mainImage = overrides && overrides.hasOwnProperty('mainImage') ? aComWixEventsUpstreamWixCommonImage(overrides.mainImage ?? {}, pickedFields.get('mainImage')) : aComWixEventsUpstreamWixCommonImage({}, pickedFields.get('mainImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modified')) {
        result.modified = overrides && overrides.hasOwnProperty('modified') ? overrides.modified! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('onlineConferencing')) {
        result.onlineConferencing = overrides && overrides.hasOwnProperty('onlineConferencing') ? aWixEventsOnlineConferencing(overrides.onlineConferencing ?? {}, pickedFields.get('onlineConferencing')) : aWixEventsOnlineConferencing({}, pickedFields.get('onlineConferencing'));
    }
    if (pickedFields.size === 0 || pickedFields.has('policiesVirtualReference')) {
        result.policiesVirtualReference = overrides && overrides.hasOwnProperty('policiesVirtualReference') ? aWixEventsV2QueryPoliciesResponse(overrides.policiesVirtualReference ?? {}, pickedFields.get('policiesVirtualReference')) : aWixEventsV2QueryPoliciesResponse({}, pickedFields.get('policiesVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('publishedDate')) {
        result.publishedDate = overrides && overrides.hasOwnProperty('publishedDate') ? overrides.publishedDate! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('registration')) {
        result.registration = overrides && overrides.hasOwnProperty('registration') ? aWixEventsRegistration(overrides.registration ?? {}, pickedFields.get('registration')) : aWixEventsRegistration({}, pickedFields.get('registration'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduling')) {
        result.scheduling = overrides && overrides.hasOwnProperty('scheduling') ? aWixEventsScheduling(overrides.scheduling ?? {}, pickedFields.get('scheduling')) : aWixEventsScheduling({}, pickedFields.get('scheduling'));
    }
    if (pickedFields.size === 0 || pickedFields.has('seoSettings')) {
        result.seoSettings = overrides && overrides.hasOwnProperty('seoSettings') ? aWixEventsSeoSettings(overrides.seoSettings ?? {}, pickedFields.get('seoSettings')) : aWixEventsSeoSettings({}, pickedFields.get('seoSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixEventsEventStatus.Canceled;
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'perferendis';
    }

    return result;
};

export const aWixEventsEventDataInput = <T extends Partial<WixEventsEventDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('about')) {
        result.about = overrides && overrides.hasOwnProperty('about') ? overrides.about! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('agenda')) {
        result.agenda = overrides && overrides.hasOwnProperty('agenda') ? aWixEventsAgendaInput(overrides.agenda ?? {}, pickedFields.get('agenda')) : aWixEventsAgendaInput({}, pickedFields.get('agenda'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customizableTickets')) {
        result.customizableTickets = overrides && overrides.hasOwnProperty('customizableTickets') ? overrides.customizableTickets! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventDisplaySettings')) {
        result.eventDisplaySettings = overrides && overrides.hasOwnProperty('eventDisplaySettings') ? aWixEventsEventDisplaySettingsInput(overrides.eventDisplaySettings ?? {}, pickedFields.get('eventDisplaySettings')) : aWixEventsEventDisplaySettingsInput({}, pickedFields.get('eventDisplaySettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('guestListConfig')) {
        result.guestListConfig = overrides && overrides.hasOwnProperty('guestListConfig') ? aWixEventsGuestListConfigInput(overrides.guestListConfig ?? {}, pickedFields.get('guestListConfig')) : aWixEventsGuestListConfigInput({}, pickedFields.get('guestListConfig'));
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aWixEventsLocationInput(overrides.location ?? {}, pickedFields.get('location')) : aWixEventsLocationInput({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('longDescription')) {
        result.longDescription = overrides && overrides.hasOwnProperty('longDescription') ? aWixRichContentV1RichContentInput(overrides.longDescription ?? {}, pickedFields.get('longDescription')) : aWixRichContentV1RichContentInput({}, pickedFields.get('longDescription'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mainImage')) {
        result.mainImage = overrides && overrides.hasOwnProperty('mainImage') ? aComWixEventsUpstreamWixCommonImageInput(overrides.mainImage ?? {}, pickedFields.get('mainImage')) : aComWixEventsUpstreamWixCommonImageInput({}, pickedFields.get('mainImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('onlineConferencingConfig')) {
        result.onlineConferencingConfig = overrides && overrides.hasOwnProperty('onlineConferencingConfig') ? aWixEventsOnlineConferencingConfigInput(overrides.onlineConferencingConfig ?? {}, pickedFields.get('onlineConferencingConfig')) : aWixEventsOnlineConferencingConfigInput({}, pickedFields.get('onlineConferencingConfig'));
    }
    if (pickedFields.size === 0 || pickedFields.has('registrationConfig')) {
        result.registrationConfig = overrides && overrides.hasOwnProperty('registrationConfig') ? aWixEventsRegistrationConfigInput(overrides.registrationConfig ?? {}, pickedFields.get('registrationConfig')) : aWixEventsRegistrationConfigInput({}, pickedFields.get('registrationConfig'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rsvpCollectionConfig')) {
        result.rsvpCollectionConfig = overrides && overrides.hasOwnProperty('rsvpCollectionConfig') ? aWixEventsRsvpCollectionConfigInput(overrides.rsvpCollectionConfig ?? {}, pickedFields.get('rsvpCollectionConfig')) : aWixEventsRsvpCollectionConfigInput({}, pickedFields.get('rsvpCollectionConfig'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleConfig')) {
        result.scheduleConfig = overrides && overrides.hasOwnProperty('scheduleConfig') ? aWixEventsScheduleConfigInput(overrides.scheduleConfig ?? {}, pickedFields.get('scheduleConfig')) : aWixEventsScheduleConfigInput({}, pickedFields.get('scheduleConfig'));
    }
    if (pickedFields.size === 0 || pickedFields.has('seoSettings')) {
        result.seoSettings = overrides && overrides.hasOwnProperty('seoSettings') ? aWixEventsSeoSettingsInput(overrides.seoSettings ?? {}, pickedFields.get('seoSettings')) : aWixEventsSeoSettingsInput({}, pickedFields.get('seoSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'eum';
    }

    return result;
};

export const aWixEventsEventDisplaySettings = <T extends Partial<WixEventsEventDisplaySettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hideEventDetailsButton')) {
        result.hideEventDetailsButton = overrides && overrides.hasOwnProperty('hideEventDetailsButton') ? overrides.hideEventDetailsButton! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('hideEventDetailsPage')) {
        result.hideEventDetailsPage = overrides && overrides.hasOwnProperty('hideEventDetailsPage') ? overrides.hideEventDetailsPage! : false;
    }

    return result;
};

export const aWixEventsEventDisplaySettingsInput = <T extends Partial<WixEventsEventDisplaySettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hideEventDetailsButton')) {
        result.hideEventDetailsButton = overrides && overrides.hasOwnProperty('hideEventDetailsButton') ? overrides.hideEventDetailsButton! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('hideEventDetailsPage')) {
        result.hideEventDetailsPage = overrides && overrides.hasOwnProperty('hideEventDetailsPage') ? overrides.hideEventDetailsPage! : true;
    }

    return result;
};

export const aWixEventsEventsEventCopiedInput = <T extends Partial<WixEventsEventsEventCopiedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('derivedFromEventId')) {
        result.derivedFromEventId = overrides && overrides.hasOwnProperty('derivedFromEventId') ? overrides.derivedFromEventId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('derivedFromInstanceId')) {
        result.derivedFromInstanceId = overrides && overrides.hasOwnProperty('derivedFromInstanceId') ? overrides.derivedFromInstanceId! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? aWixEventsLocationInput(overrides.location ?? {}, pickedFields.get('location')) : aWixEventsLocationInput({}, pickedFields.get('location'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleConfig')) {
        result.scheduleConfig = overrides && overrides.hasOwnProperty('scheduleConfig') ? aWixEventsScheduleConfigInput(overrides.scheduleConfig ?? {}, pickedFields.get('scheduleConfig')) : aWixEventsScheduleConfigInput({}, pickedFields.get('scheduleConfig'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixEventsEventStatus.Canceled;
    }
    if (pickedFields.size === 0 || pickedFields.has('ticketDefinitions')) {
        result.ticketDefinitions = overrides && overrides.hasOwnProperty('ticketDefinitions') ? overrides.ticketDefinitions! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('timestamp')) {
        result.timestamp = overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'et';
    }

    return result;
};

export const aWixEventsExternalEvent = <T extends Partial<WixEventsExternalEvent>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('registration')) {
        result.registration = overrides && overrides.hasOwnProperty('registration') ? overrides.registration! : 'qui';
    }

    return result;
};

export const aWixEventsFacetCounts = <T extends Partial<WixEventsFacetCounts>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('counts')) {
        result.counts = overrides && overrides.hasOwnProperty('counts') ? overrides.counts! : 'nisi';
    }

    return result;
};

export const aWixEventsFeed = <T extends Partial<WixEventsFeed>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('token')) {
        result.token = overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'minus';
    }

    return result;
};

export const aWixEventsFindEventRequestInput = <T extends Partial<WixEventsFindEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('consistentRead')) {
        result.consistentRead = overrides && overrides.hasOwnProperty('consistentRead') ? overrides.consistentRead! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldset')) {
        result.fieldset = overrides && overrides.hasOwnProperty('fieldset') ? overrides.fieldset! : [WixEventsEventFieldset.Agenda];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'nemo';
    }

    return result;
};

export const aWixEventsFindEventResponse = <T extends Partial<WixEventsFindEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEvent(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEvent({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixEventsFindOnlineConferenceSessionRequestInput = <T extends Partial<WixEventsFindOnlineConferenceSessionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerId')) {
        result.providerId = overrides && overrides.hasOwnProperty('providerId') ? overrides.providerId! : 'eligendi';
    }

    return result;
};

export const aWixEventsFindOnlineConferenceSessionResponse = <T extends Partial<WixEventsFindOnlineConferenceSessionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('session')) {
        result.session = overrides && overrides.hasOwnProperty('session') ? aWixEventsOnlineConferencingSession(overrides.session ?? {}, pickedFields.get('session')) : aWixEventsOnlineConferencingSession({}, pickedFields.get('session'));
    }

    return result;
};

export const aWixEventsFormCheckoutFormMessages = <T extends Partial<WixEventsFormCheckoutFormMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('confirmation')) {
        result.confirmation = overrides && overrides.hasOwnProperty('confirmation') ? aWixEventsFormCheckoutFormMessagesResponseConfirmation(overrides.confirmation ?? {}, pickedFields.get('confirmation')) : aWixEventsFormCheckoutFormMessagesResponseConfirmation({}, pickedFields.get('confirmation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('submitActionLabel')) {
        result.submitActionLabel = overrides && overrides.hasOwnProperty('submitActionLabel') ? overrides.submitActionLabel! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'sit';
    }

    return result;
};

export const aWixEventsFormCheckoutFormMessagesResponseConfirmation = <T extends Partial<WixEventsFormCheckoutFormMessagesResponseConfirmation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addToCalendarLabel')) {
        result.addToCalendarLabel = overrides && overrides.hasOwnProperty('addToCalendarLabel') ? overrides.addToCalendarLabel! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('downloadTicketsLabel')) {
        result.downloadTicketsLabel = overrides && overrides.hasOwnProperty('downloadTicketsLabel') ? overrides.downloadTicketsLabel! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('shareEventLabel')) {
        result.shareEventLabel = overrides && overrides.hasOwnProperty('shareEventLabel') ? overrides.shareEventLabel! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'eum';
    }

    return result;
};

export const aWixEventsFormForm = <T extends Partial<WixEventsFormForm>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('controls')) {
        result.controls = overrides && overrides.hasOwnProperty('controls') ? overrides.controls!.map((x) => aWixEventsFormInputControl(x ?? {}, pickedFields.get('controls'))) : [aWixEventsFormInputControl({}, pickedFields.get('controls'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('messages')) {
        result.messages = overrides && overrides.hasOwnProperty('messages') ? aWixEventsFormFormMessages(overrides.messages ?? {}, pickedFields.get('messages')) : aWixEventsFormFormMessages({}, pickedFields.get('messages'));
    }

    return result;
};

export const aWixEventsFormFormMessages = <T extends Partial<WixEventsFormFormMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkout')) {
        result.checkout = overrides && overrides.hasOwnProperty('checkout') ? aWixEventsFormCheckoutFormMessages(overrides.checkout ?? {}, pickedFields.get('checkout')) : aWixEventsFormCheckoutFormMessages({}, pickedFields.get('checkout'));
    }
    if (pickedFields.size === 0 || pickedFields.has('registrationClosed')) {
        result.registrationClosed = overrides && overrides.hasOwnProperty('registrationClosed') ? aWixEventsFormRegistrationClosedMessages(overrides.registrationClosed ?? {}, pickedFields.get('registrationClosed')) : aWixEventsFormRegistrationClosedMessages({}, pickedFields.get('registrationClosed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rsvp')) {
        result.rsvp = overrides && overrides.hasOwnProperty('rsvp') ? aWixEventsFormRsvpFormMessages(overrides.rsvp ?? {}, pickedFields.get('rsvp')) : aWixEventsFormRsvpFormMessages({}, pickedFields.get('rsvp'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ticketsUnavailable')) {
        result.ticketsUnavailable = overrides && overrides.hasOwnProperty('ticketsUnavailable') ? aWixEventsFormTicketsUnavailableMessages(overrides.ticketsUnavailable ?? {}, pickedFields.get('ticketsUnavailable')) : aWixEventsFormTicketsUnavailableMessages({}, pickedFields.get('ticketsUnavailable'));
    }

    return result;
};

export const aWixEventsFormInput = <T extends Partial<WixEventsFormInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalLabels')) {
        result.additionalLabels = overrides && overrides.hasOwnProperty('additionalLabels') ? overrides.additionalLabels! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('array')) {
        result.array = overrides && overrides.hasOwnProperty('array') ? overrides.array! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('defaultOptionSelection')) {
        result.defaultOptionSelection = overrides && overrides.hasOwnProperty('defaultOptionSelection') ? aWixEventsFormOptionSelection(overrides.defaultOptionSelection ?? {}, pickedFields.get('defaultOptionSelection')) : aWixEventsFormOptionSelection({}, pickedFields.get('defaultOptionSelection'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('labels')) {
        result.labels = overrides && overrides.hasOwnProperty('labels') ? overrides.labels!.map((x) => aWixEventsFormLabel(x ?? {}, pickedFields.get('labels'))) : [aWixEventsFormLabel({}, pickedFields.get('labels'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('mandatory')) {
        result.mandatory = overrides && overrides.hasOwnProperty('mandatory') ? overrides.mandatory! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxLength')) {
        result.maxLength = overrides && overrides.hasOwnProperty('maxLength') ? overrides.maxLength! : 1898;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxSize')) {
        result.maxSize = overrides && overrides.hasOwnProperty('maxSize') ? overrides.maxSize! : 1677;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options! : ['nostrum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixEventsFormValueType.Address;
    }

    return result;
};

export const aWixEventsFormInputControl = <T extends Partial<WixEventsFormInputControl>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deleted')) {
        result.deleted = overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('inputs')) {
        result.inputs = overrides && overrides.hasOwnProperty('inputs') ? overrides.inputs!.map((x) => aWixEventsFormInput(x ?? {}, pickedFields.get('inputs'))) : [aWixEventsFormInput({}, pickedFields.get('inputs'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderIndex')) {
        result.orderIndex = overrides && overrides.hasOwnProperty('orderIndex') ? overrides.orderIndex! : 4051;
    }
    if (pickedFields.size === 0 || pickedFields.has('system')) {
        result.system = overrides && overrides.hasOwnProperty('system') ? overrides.system! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixEventsFormInputControlType.AddressFull;
    }

    return result;
};

export const aWixEventsFormLabel = <T extends Partial<WixEventsFormLabel>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ut';
    }

    return result;
};

export const aWixEventsFormOptionSelection = <T extends Partial<WixEventsFormOptionSelection>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('optionIndex')) {
        result.optionIndex = overrides && overrides.hasOwnProperty('optionIndex') ? overrides.optionIndex! : 9571;
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholderText')) {
        result.placeholderText = overrides && overrides.hasOwnProperty('placeholderText') ? overrides.placeholderText! : 'aliquam';
    }

    return result;
};

export const aWixEventsFormRegistrationClosedMessages = <T extends Partial<WixEventsFormRegistrationClosedMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exploreEventsActionLabel')) {
        result.exploreEventsActionLabel = overrides && overrides.hasOwnProperty('exploreEventsActionLabel') ? overrides.exploreEventsActionLabel! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'vel';
    }

    return result;
};

export const aWixEventsFormRsvpFormMessages = <T extends Partial<WixEventsFormRsvpFormMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('negativeMessages')) {
        result.negativeMessages = overrides && overrides.hasOwnProperty('negativeMessages') ? aWixEventsFormRsvpFormMessagesNegative(overrides.negativeMessages ?? {}, pickedFields.get('negativeMessages')) : aWixEventsFormRsvpFormMessagesNegative({}, pickedFields.get('negativeMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('positiveMessages')) {
        result.positiveMessages = overrides && overrides.hasOwnProperty('positiveMessages') ? aWixEventsFormRsvpFormMessagesPositive(overrides.positiveMessages ?? {}, pickedFields.get('positiveMessages')) : aWixEventsFormRsvpFormMessagesPositive({}, pickedFields.get('positiveMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rsvpNoOption')) {
        result.rsvpNoOption = overrides && overrides.hasOwnProperty('rsvpNoOption') ? overrides.rsvpNoOption! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('rsvpYesOption')) {
        result.rsvpYesOption = overrides && overrides.hasOwnProperty('rsvpYesOption') ? overrides.rsvpYesOption! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('submitActionLabel')) {
        result.submitActionLabel = overrides && overrides.hasOwnProperty('submitActionLabel') ? overrides.submitActionLabel! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('waitlistMessages')) {
        result.waitlistMessages = overrides && overrides.hasOwnProperty('waitlistMessages') ? aWixEventsFormRsvpFormMessagesPositive(overrides.waitlistMessages ?? {}, pickedFields.get('waitlistMessages')) : aWixEventsFormRsvpFormMessagesPositive({}, pickedFields.get('waitlistMessages'));
    }

    return result;
};

export const aWixEventsFormRsvpFormMessagesNegative = <T extends Partial<WixEventsFormRsvpFormMessagesNegative>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('confirmation')) {
        result.confirmation = overrides && overrides.hasOwnProperty('confirmation') ? aWixEventsFormRsvpFormMessagesNegativeResponseConfirmation(overrides.confirmation ?? {}, pickedFields.get('confirmation')) : aWixEventsFormRsvpFormMessagesNegativeResponseConfirmation({}, pickedFields.get('confirmation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'ipsum';
    }

    return result;
};

export const aWixEventsFormRsvpFormMessagesNegativeResponseConfirmation = <T extends Partial<WixEventsFormRsvpFormMessagesNegativeResponseConfirmation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('shareActionLabel')) {
        result.shareActionLabel = overrides && overrides.hasOwnProperty('shareActionLabel') ? overrides.shareActionLabel! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'quis';
    }

    return result;
};

export const aWixEventsFormRsvpFormMessagesPositive = <T extends Partial<WixEventsFormRsvpFormMessagesPositive>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('confirmation')) {
        result.confirmation = overrides && overrides.hasOwnProperty('confirmation') ? aWixEventsFormRsvpFormMessagesPositiveResponseConfirmation(overrides.confirmation ?? {}, pickedFields.get('confirmation')) : aWixEventsFormRsvpFormMessagesPositiveResponseConfirmation({}, pickedFields.get('confirmation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'eveniet';
    }

    return result;
};

export const aWixEventsFormRsvpFormMessagesPositiveResponseConfirmation = <T extends Partial<WixEventsFormRsvpFormMessagesPositiveResponseConfirmation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addToCalendarActionLabel')) {
        result.addToCalendarActionLabel = overrides && overrides.hasOwnProperty('addToCalendarActionLabel') ? overrides.addToCalendarActionLabel! : 'sequi';
    }
    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('shareActionLabel')) {
        result.shareActionLabel = overrides && overrides.hasOwnProperty('shareActionLabel') ? overrides.shareActionLabel! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'eligendi';
    }

    return result;
};

export const aWixEventsFormTicketsUnavailableMessages = <T extends Partial<WixEventsFormTicketsUnavailableMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('exploreEventsActionLabel')) {
        result.exploreEventsActionLabel = overrides && overrides.hasOwnProperty('exploreEventsActionLabel') ? overrides.exploreEventsActionLabel! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'quia';
    }

    return result;
};

export const aWixEventsGetEventRequestInput = <T extends Partial<WixEventsGetEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldset')) {
        result.fieldset = overrides && overrides.hasOwnProperty('fieldset') ? overrides.fieldset! : [WixEventsEventFieldset.Agenda];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6389276b-2d50-41c5-93bc-b169b991b45d';
    }
    if (pickedFields.size === 0 || pickedFields.has('resolveFullAddress')) {
        result.resolveFullAddress = overrides && overrides.hasOwnProperty('resolveFullAddress') ? overrides.resolveFullAddress! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'adipisci';
    }

    return result;
};

export const aWixEventsGetRecurringEventStateRequestInput = <T extends Partial<WixEventsGetRecurringEventStateRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryId')) {
        result.categoryId = overrides && overrides.hasOwnProperty('categoryId') ? overrides.categoryId! : 'rerum';
    }

    return result;
};

export const aWixEventsGetRecurringEventStateResponse = <T extends Partial<WixEventsGetRecurringEventStateResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('actual')) {
        result.actual = overrides && overrides.hasOwnProperty('actual') ? aWixEventsRecurringEventState(overrides.actual ?? {}, pickedFields.get('actual')) : aWixEventsRecurringEventState({}, pickedFields.get('actual'));
    }
    if (pickedFields.size === 0 || pickedFields.has('categoryId')) {
        result.categoryId = overrides && overrides.hasOwnProperty('categoryId') ? overrides.categoryId! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('desired')) {
        result.desired = overrides && overrides.hasOwnProperty('desired') ? aWixEventsRecurringEventState(overrides.desired ?? {}, pickedFields.get('desired')) : aWixEventsRecurringEventState({}, pickedFields.get('desired'));
    }
    if (pickedFields.size === 0 || pickedFields.has('inconsistentState')) {
        result.inconsistentState = overrides && overrides.hasOwnProperty('inconsistentState') ? overrides.inconsistentState! : true;
    }

    return result;
};

export const aWixEventsGetTicketingSummaryRequestInput = <T extends Partial<WixEventsGetTicketingSummaryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'consequuntur';
    }

    return result;
};

export const aWixEventsGetTicketingSummaryResponse = <T extends Partial<WixEventsGetTicketingSummaryResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('summary')) {
        result.summary = overrides && overrides.hasOwnProperty('summary') ? aWixEventsTicketing(overrides.summary ?? {}, pickedFields.get('summary')) : aWixEventsTicketing({}, pickedFields.get('summary'));
    }

    return result;
};

export const aWixEventsGuestListConfig = <T extends Partial<WixEventsGuestListConfig>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('publicGuestList')) {
        result.publicGuestList = overrides && overrides.hasOwnProperty('publicGuestList') ? overrides.publicGuestList! : true;
    }

    return result;
};

export const aWixEventsGuestListConfigInput = <T extends Partial<WixEventsGuestListConfigInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('publicGuestList')) {
        result.publicGuestList = overrides && overrides.hasOwnProperty('publicGuestList') ? overrides.publicGuestList! : true;
    }

    return result;
};

export const aWixEventsLabellingSettings = <T extends Partial<WixEventsLabellingSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('assignedContactsLabelDeleted')) {
        result.assignedContactsLabelDeleted = overrides && overrides.hasOwnProperty('assignedContactsLabelDeleted') ? overrides.assignedContactsLabelDeleted! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('assignedContactsLegacyLabelId')) {
        result.assignedContactsLegacyLabelId = overrides && overrides.hasOwnProperty('assignedContactsLegacyLabelId') ? overrides.assignedContactsLegacyLabelId! : 'explicabo';
    }

    return result;
};

export const aWixEventsListCategoryEventsRequestInput = <T extends Partial<WixEventsListCategoryEventsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryId')) {
        result.categoryId = overrides && overrides.hasOwnProperty('categoryId') ? overrides.categoryId! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldset')) {
        result.fieldset = overrides && overrides.hasOwnProperty('fieldset') ? overrides.fieldset! : [WixEventsEventFieldset.Agenda];
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixEventsUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixEventsUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aWixEventsListCategoryEventsResponse = <T extends Partial<WixEventsListCategoryEventsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('events')) {
        result.events = overrides && overrides.hasOwnProperty('events') ? overrides.events!.map((x) => aWixEventsEvent(x ?? {}, pickedFields.get('events'))) : [aWixEventsEvent({}, pickedFields.get('events'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixEventsListEventsRequestInput = <T extends Partial<WixEventsListEventsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryFilter')) {
        result.categoryFilter = overrides && overrides.hasOwnProperty('categoryFilter') ? aWixEventsCategoryFilterInput(overrides.categoryFilter ?? {}, pickedFields.get('categoryFilter')) : aWixEventsCategoryFilterInput({}, pickedFields.get('categoryFilter'));
    }
    if (pickedFields.size === 0 || pickedFields.has('facet')) {
        result.facet = overrides && overrides.hasOwnProperty('facet') ? overrides.facet! : ['ullam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldset')) {
        result.fieldset = overrides && overrides.hasOwnProperty('fieldset') ? overrides.fieldset! : [WixEventsEventFieldset.Agenda];
    }
    if (pickedFields.size === 0 || pickedFields.has('includeDrafts')) {
        result.includeDrafts = overrides && overrides.hasOwnProperty('includeDrafts') ? overrides.includeDrafts! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1293;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 514;
    }
    if (pickedFields.size === 0 || pickedFields.has('recurrenceStatus')) {
        result.recurrenceStatus = overrides && overrides.hasOwnProperty('recurrenceStatus') ? overrides.recurrenceStatus! : [WixEventsRecurrenceStatusStatus.OneTime];
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringGroupId')) {
        result.recurringGroupId = overrides && overrides.hasOwnProperty('recurringGroupId') ? overrides.recurringGroupId! : ['sit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : [WixEventsEventStatus.Canceled];
    }
    if (pickedFields.size === 0 || pickedFields.has('userFilter')) {
        result.userFilter = overrides && overrides.hasOwnProperty('userFilter') ? aWixEventsUserFilterInput(overrides.userFilter ?? {}, pickedFields.get('userFilter')) : aWixEventsUserFilterInput({}, pickedFields.get('userFilter'));
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : ['excepturi'];
    }

    return result;
};

export const aWixEventsListEventsResponse = <T extends Partial<WixEventsListEventsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('events')) {
        result.events = overrides && overrides.hasOwnProperty('events') ? overrides.events!.map((x) => aWixEventsEvent(x ?? {}, pickedFields.get('events'))) : [aWixEventsEvent({}, pickedFields.get('events'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('facets')) {
        result.facets = overrides && overrides.hasOwnProperty('facets') ? aWixEventsFacetCounts(overrides.facets ?? {}, pickedFields.get('facets')) : aWixEventsFacetCounts({}, pickedFields.get('facets'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2720;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 7924;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9947;
    }

    return result;
};

export const aWixEventsListUserEventsRequestInput = <T extends Partial<WixEventsListUserEventsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('facet')) {
        result.facet = overrides && overrides.hasOwnProperty('facet') ? overrides.facet! : ['sequi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixEventsUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixEventsUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aComWixEventsUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aComWixEventsUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : [WixEventsEventStatus.Canceled];
    }
    if (pickedFields.size === 0 || pickedFields.has('userFilter')) {
        result.userFilter = overrides && overrides.hasOwnProperty('userFilter') ? aWixEventsUserFilterInput(overrides.userFilter ?? {}, pickedFields.get('userFilter')) : aWixEventsUserFilterInput({}, pickedFields.get('userFilter'));
    }

    return result;
};

export const aWixEventsListUserEventsResponse = <T extends Partial<WixEventsListUserEventsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('events')) {
        result.events = overrides && overrides.hasOwnProperty('events') ? overrides.events!.map((x) => aWixEventsEvent(x ?? {}, pickedFields.get('events'))) : [aWixEventsEvent({}, pickedFields.get('events'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('facets')) {
        result.facets = overrides && overrides.hasOwnProperty('facets') ? aWixEventsFacetCounts(overrides.facets ?? {}, pickedFields.get('facets')) : aWixEventsFacetCounts({}, pickedFields.get('facets'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixEventsLocation = <T extends Partial<WixEventsLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? overrides.address! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('coordinates')) {
        result.coordinates = overrides && overrides.hasOwnProperty('coordinates') ? aWixEventsMapCoordinates(overrides.coordinates ?? {}, pickedFields.get('coordinates')) : aWixEventsMapCoordinates({}, pickedFields.get('coordinates'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fullAddress')) {
        result.fullAddress = overrides && overrides.hasOwnProperty('fullAddress') ? aComWixEventsUpstreamWixCommonAddress(overrides.fullAddress ?? {}, pickedFields.get('fullAddress')) : aComWixEventsUpstreamWixCommonAddress({}, pickedFields.get('fullAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'hic';
    }
    if (pickedFields.size === 0 || pickedFields.has('tbd')) {
        result.tbd = overrides && overrides.hasOwnProperty('tbd') ? overrides.tbd! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixEventsLocationLocationType.Online;
    }

    return result;
};

export const aWixEventsLocationInput = <T extends Partial<WixEventsLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? overrides.address! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('coordinates')) {
        result.coordinates = overrides && overrides.hasOwnProperty('coordinates') ? aWixEventsMapCoordinatesInput(overrides.coordinates ?? {}, pickedFields.get('coordinates')) : aWixEventsMapCoordinatesInput({}, pickedFields.get('coordinates'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fullAddress')) {
        result.fullAddress = overrides && overrides.hasOwnProperty('fullAddress') ? aComWixEventsUpstreamWixCommonAddressInput(overrides.fullAddress ?? {}, pickedFields.get('fullAddress')) : aComWixEventsUpstreamWixCommonAddressInput({}, pickedFields.get('fullAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('tbd')) {
        result.tbd = overrides && overrides.hasOwnProperty('tbd') ? overrides.tbd! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixEventsLocationLocationType.Online;
    }

    return result;
};

export const aWixEventsMapCoordinates = <T extends Partial<WixEventsMapCoordinates>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lat')) {
        result.lat = overrides && overrides.hasOwnProperty('lat') ? overrides.lat! : 9.71;
    }
    if (pickedFields.size === 0 || pickedFields.has('lng')) {
        result.lng = overrides && overrides.hasOwnProperty('lng') ? overrides.lng! : 8.66;
    }

    return result;
};

export const aWixEventsMapCoordinatesInput = <T extends Partial<WixEventsMapCoordinatesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lat')) {
        result.lat = overrides && overrides.hasOwnProperty('lat') ? overrides.lat! : 9.86;
    }
    if (pickedFields.size === 0 || pickedFields.has('lng')) {
        result.lng = overrides && overrides.hasOwnProperty('lng') ? overrides.lng! : 7.4;
    }

    return result;
};

export const aWixEventsMoney = <T extends Partial<WixEventsMoney>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'et';
    }

    return result;
};

export const aWixEventsOccurrence = <T extends Partial<WixEventsOccurrence>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('endDate')) {
        result.endDate = overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('showTimeZone')) {
        result.showTimeZone = overrides && overrides.hasOwnProperty('showTimeZone') ? overrides.showTimeZone! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZoneId')) {
        result.timeZoneId = overrides && overrides.hasOwnProperty('timeZoneId') ? overrides.timeZoneId! : 'reprehenderit';
    }

    return result;
};

export const aWixEventsOccurrenceInput = <T extends Partial<WixEventsOccurrenceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('endDate')) {
        result.endDate = overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('showTimeZone')) {
        result.showTimeZone = overrides && overrides.hasOwnProperty('showTimeZone') ? overrides.showTimeZone! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZoneId')) {
        result.timeZoneId = overrides && overrides.hasOwnProperty('timeZoneId') ? overrides.timeZoneId! : 'at';
    }

    return result;
};

export const aWixEventsOnlineConferencing = <T extends Partial<WixEventsOnlineConferencing>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('config')) {
        result.config = overrides && overrides.hasOwnProperty('config') ? aWixEventsOnlineConferencingConfig(overrides.config ?? {}, pickedFields.get('config')) : aWixEventsOnlineConferencingConfig({}, pickedFields.get('config'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerName')) {
        result.providerName = overrides && overrides.hasOwnProperty('providerName') ? overrides.providerName! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('session')) {
        result.session = overrides && overrides.hasOwnProperty('session') ? aWixEventsOnlineConferencingSession(overrides.session ?? {}, pickedFields.get('session')) : aWixEventsOnlineConferencingSession({}, pickedFields.get('session'));
    }

    return result;
};

export const aWixEventsOnlineConferencingConfig = <T extends Partial<WixEventsOnlineConferencingConfig>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conferenceType')) {
        result.conferenceType = overrides && overrides.hasOwnProperty('conferenceType') ? overrides.conferenceType! : WixEventsConferenceType.Meeting;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('providerId')) {
        result.providerId = overrides && overrides.hasOwnProperty('providerId') ? overrides.providerId! : 'dolorum';
    }

    return result;
};

export const aWixEventsOnlineConferencingConfigInput = <T extends Partial<WixEventsOnlineConferencingConfigInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conferenceType')) {
        result.conferenceType = overrides && overrides.hasOwnProperty('conferenceType') ? overrides.conferenceType! : WixEventsConferenceType.Meeting;
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('providerId')) {
        result.providerId = overrides && overrides.hasOwnProperty('providerId') ? overrides.providerId! : 'ut';
    }

    return result;
};

export const aWixEventsOnlineConferencingSession = <T extends Partial<WixEventsOnlineConferencingSession>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('guestLink')) {
        result.guestLink = overrides && overrides.hasOwnProperty('guestLink') ? overrides.guestLink! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('hostLink')) {
        result.hostLink = overrides && overrides.hasOwnProperty('hostLink') ? overrides.hostLink! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('password')) {
        result.password = overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionCreated')) {
        result.sessionCreated = overrides && overrides.hasOwnProperty('sessionCreated') ? overrides.sessionCreated! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('sessionId')) {
        result.sessionId = overrides && overrides.hasOwnProperty('sessionId') ? overrides.sessionId! : 'nihil';
    }

    return result;
};

export const aWixEventsPublishDraftEventRequestInput = <T extends Partial<WixEventsPublishDraftEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'optio';
    }

    return result;
};

export const aWixEventsPublishDraftEventResponse = <T extends Partial<WixEventsPublishDraftEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEvent(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEvent({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixEventsQueryEventsRequestInput = <T extends Partial<WixEventsQueryEventsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('facet')) {
        result.facet = overrides && overrides.hasOwnProperty('facet') ? overrides.facet! : ['sit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldset')) {
        result.fieldset = overrides && overrides.hasOwnProperty('fieldset') ? overrides.fieldset! : [WixEventsEventFieldset.Agenda];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('includeDrafts')) {
        result.includeDrafts = overrides && overrides.hasOwnProperty('includeDrafts') ? overrides.includeDrafts! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1503;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 1873;
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : ['magni'];
    }

    return result;
};

export const aWixEventsQueryEventsResponse = <T extends Partial<WixEventsQueryEventsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('events')) {
        result.events = overrides && overrides.hasOwnProperty('events') ? overrides.events!.map((x) => aWixEventsEvent(x ?? {}, pickedFields.get('events'))) : [aWixEventsEvent({}, pickedFields.get('events'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('facets')) {
        result.facets = overrides && overrides.hasOwnProperty('facets') ? aWixEventsFacetCounts(overrides.facets ?? {}, pickedFields.get('facets')) : aWixEventsFacetCounts({}, pickedFields.get('facets'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1144;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 6533;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9410;
    }

    return result;
};

export const aWixEventsQueryEventsV2RequestInput = <T extends Partial<WixEventsQueryEventsV2RequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('facet')) {
        result.facet = overrides && overrides.hasOwnProperty('facet') ? overrides.facet! : ['nemo'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldset')) {
        result.fieldset = overrides && overrides.hasOwnProperty('fieldset') ? overrides.fieldset! : [WixEventsEventFieldset.Agenda];
    }
    if (pickedFields.size === 0 || pickedFields.has('includeDrafts')) {
        result.includeDrafts = overrides && overrides.hasOwnProperty('includeDrafts') ? overrides.includeDrafts! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixEventsUpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aComWixEventsUpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixEventsQueryEventsV2Response = <T extends Partial<WixEventsQueryEventsV2Response>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixEventsEvent(x ?? {}, pickedFields.get('items'))) : [aWixEventsEvent({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixEventsRecurrences = <T extends Partial<WixEventsRecurrences>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryId')) {
        result.categoryId = overrides && overrides.hasOwnProperty('categoryId') ? overrides.categoryId! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('occurrences')) {
        result.occurrences = overrides && overrides.hasOwnProperty('occurrences') ? overrides.occurrences!.map((x) => aWixEventsOccurrence(x ?? {}, pickedFields.get('occurrences'))) : [aWixEventsOccurrence({}, pickedFields.get('occurrences'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixEventsRecurrenceStatusStatus.OneTime;
    }

    return result;
};

export const aWixEventsRecurrencesInput = <T extends Partial<WixEventsRecurrencesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryId')) {
        result.categoryId = overrides && overrides.hasOwnProperty('categoryId') ? overrides.categoryId! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('occurrences')) {
        result.occurrences = overrides && overrides.hasOwnProperty('occurrences') ? overrides.occurrences!.map((x) => aWixEventsOccurrenceInput({}, pickedFields.get('occurrences'))) : [aWixEventsOccurrenceInput({}, pickedFields.get('occurrences'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixEventsRecurrenceStatusStatus.OneTime;
    }

    return result;
};

export const aWixEventsRecurringEventDetails = <T extends Partial<WixEventsRecurringEventDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('endDate')) {
        result.endDate = overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('recurrenceStatus')) {
        result.recurrenceStatus = overrides && overrides.hasOwnProperty('recurrenceStatus') ? overrides.recurrenceStatus! : WixEventsRecurrenceStatusStatus.OneTime;
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'autem';
    }

    return result;
};

export const aWixEventsRecurringEventState = <T extends Partial<WixEventsRecurringEventState>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('recurringLastCanceled')) {
        result.recurringLastCanceled = overrides && overrides.hasOwnProperty('recurringLastCanceled') ? aWixEventsRecurringEventDetails(overrides.recurringLastCanceled ?? {}, pickedFields.get('recurringLastCanceled')) : aWixEventsRecurringEventDetails({}, pickedFields.get('recurringLastCanceled'));
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringLastEnded')) {
        result.recurringLastEnded = overrides && overrides.hasOwnProperty('recurringLastEnded') ? aWixEventsRecurringEventDetails(overrides.recurringLastEnded ?? {}, pickedFields.get('recurringLastEnded')) : aWixEventsRecurringEventDetails({}, pickedFields.get('recurringLastEnded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringNext')) {
        result.recurringNext = overrides && overrides.hasOwnProperty('recurringNext') ? aWixEventsRecurringEventDetails(overrides.recurringNext ?? {}, pickedFields.get('recurringNext')) : aWixEventsRecurringEventDetails({}, pickedFields.get('recurringNext'));
    }

    return result;
};

export const aWixEventsRegistration = <T extends Partial<WixEventsRegistration>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('external')) {
        result.external = overrides && overrides.hasOwnProperty('external') ? aWixEventsExternalEvent(overrides.external ?? {}, pickedFields.get('external')) : aWixEventsExternalEvent({}, pickedFields.get('external'));
    }
    if (pickedFields.size === 0 || pickedFields.has('initialType')) {
        result.initialType = overrides && overrides.hasOwnProperty('initialType') ? overrides.initialType! : WixEventsEventType.External;
    }
    if (pickedFields.size === 0 || pickedFields.has('restrictedTo')) {
        result.restrictedTo = overrides && overrides.hasOwnProperty('restrictedTo') ? overrides.restrictedTo! : WixEventsVisitorType.Member;
    }
    if (pickedFields.size === 0 || pickedFields.has('rsvpCollection')) {
        result.rsvpCollection = overrides && overrides.hasOwnProperty('rsvpCollection') ? aWixEventsRsvpCollection(overrides.rsvpCollection ?? {}, pickedFields.get('rsvpCollection')) : aWixEventsRsvpCollection({}, pickedFields.get('rsvpCollection'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixEventsRegistrationStatus.Closed;
    }
    if (pickedFields.size === 0 || pickedFields.has('ticketing')) {
        result.ticketing = overrides && overrides.hasOwnProperty('ticketing') ? aWixEventsTicketing(overrides.ticketing ?? {}, pickedFields.get('ticketing')) : aWixEventsTicketing({}, pickedFields.get('ticketing'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixEventsEventType.External;
    }

    return result;
};

export const aWixEventsRegistrationConfigInput = <T extends Partial<WixEventsRegistrationConfigInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('disabledRegistration')) {
        result.disabledRegistration = overrides && overrides.hasOwnProperty('disabledRegistration') ? overrides.disabledRegistration! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('externalRegistrationUrl')) {
        result.externalRegistrationUrl = overrides && overrides.hasOwnProperty('externalRegistrationUrl') ? overrides.externalRegistrationUrl! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('initialType')) {
        result.initialType = overrides && overrides.hasOwnProperty('initialType') ? overrides.initialType! : WixEventsEventType.External;
    }
    if (pickedFields.size === 0 || pickedFields.has('pausedRegistration')) {
        result.pausedRegistration = overrides && overrides.hasOwnProperty('pausedRegistration') ? overrides.pausedRegistration! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('restrictedTo')) {
        result.restrictedTo = overrides && overrides.hasOwnProperty('restrictedTo') ? overrides.restrictedTo! : WixEventsVisitorType.Member;
    }
    if (pickedFields.size === 0 || pickedFields.has('ticketingConfig')) {
        result.ticketingConfig = overrides && overrides.hasOwnProperty('ticketingConfig') ? aWixEventsTicketingConfigInput(overrides.ticketingConfig ?? {}, pickedFields.get('ticketingConfig')) : aWixEventsTicketingConfigInput({}, pickedFields.get('ticketingConfig'));
    }

    return result;
};

export const aWixEventsRsvpCollection = <T extends Partial<WixEventsRsvpCollection>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('config')) {
        result.config = overrides && overrides.hasOwnProperty('config') ? aWixEventsRsvpCollectionConfig(overrides.config ?? {}, pickedFields.get('config')) : aWixEventsRsvpCollectionConfig({}, pickedFields.get('config'));
    }

    return result;
};

export const aWixEventsRsvpCollectionConfig = <T extends Partial<WixEventsRsvpCollectionConfig>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('endDate')) {
        result.endDate = overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 5392;
    }
    if (pickedFields.size === 0 || pickedFields.has('rsvpStatusOptions')) {
        result.rsvpStatusOptions = overrides && overrides.hasOwnProperty('rsvpStatusOptions') ? overrides.rsvpStatusOptions! : WixEventsRsvpCollectionConfigRsvpStatusOptions.YesAndNo;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('waitlist')) {
        result.waitlist = overrides && overrides.hasOwnProperty('waitlist') ? overrides.waitlist! : true;
    }

    return result;
};

export const aWixEventsRsvpCollectionConfigInput = <T extends Partial<WixEventsRsvpCollectionConfigInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('endDate')) {
        result.endDate = overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 649;
    }
    if (pickedFields.size === 0 || pickedFields.has('rsvpStatusOptions')) {
        result.rsvpStatusOptions = overrides && overrides.hasOwnProperty('rsvpStatusOptions') ? overrides.rsvpStatusOptions! : WixEventsRsvpCollectionConfigRsvpStatusOptions.YesAndNo;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('waitlist')) {
        result.waitlist = overrides && overrides.hasOwnProperty('waitlist') ? overrides.waitlist! : true;
    }

    return result;
};

export const aWixEventsScheduleAddScheduleItemRequestInput = <T extends Partial<WixEventsScheduleAddScheduleItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixEventsScheduleScheduleItemDataInput(overrides.item ?? {}, pickedFields.get('item')) : aWixEventsScheduleScheduleItemDataInput({}, pickedFields.get('item'));
    }

    return result;
};

export const aWixEventsScheduleAddScheduleItemResponse = <T extends Partial<WixEventsScheduleAddScheduleItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixEventsScheduleScheduleItem(overrides.item ?? {}, pickedFields.get('item')) : aWixEventsScheduleScheduleItem({}, pickedFields.get('item'));
    }

    return result;
};

export const aWixEventsScheduleConfig = <T extends Partial<WixEventsScheduleConfig>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('endDate')) {
        result.endDate = overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('endDateHidden')) {
        result.endDateHidden = overrides && overrides.hasOwnProperty('endDateHidden') ? overrides.endDateHidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('recurrences')) {
        result.recurrences = overrides && overrides.hasOwnProperty('recurrences') ? aWixEventsRecurrences(overrides.recurrences ?? {}, pickedFields.get('recurrences')) : aWixEventsRecurrences({}, pickedFields.get('recurrences'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleTbd')) {
        result.scheduleTbd = overrides && overrides.hasOwnProperty('scheduleTbd') ? overrides.scheduleTbd! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleTbdMessage')) {
        result.scheduleTbdMessage = overrides && overrides.hasOwnProperty('scheduleTbdMessage') ? overrides.scheduleTbdMessage! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('showTimeZone')) {
        result.showTimeZone = overrides && overrides.hasOwnProperty('showTimeZone') ? overrides.showTimeZone! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZoneId')) {
        result.timeZoneId = overrides && overrides.hasOwnProperty('timeZoneId') ? overrides.timeZoneId! : 'molestiae';
    }

    return result;
};

export const aWixEventsScheduleConfigInput = <T extends Partial<WixEventsScheduleConfigInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('endDate')) {
        result.endDate = overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('endDateHidden')) {
        result.endDateHidden = overrides && overrides.hasOwnProperty('endDateHidden') ? overrides.endDateHidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('recurrences')) {
        result.recurrences = overrides && overrides.hasOwnProperty('recurrences') ? aWixEventsRecurrencesInput(overrides.recurrences ?? {}, pickedFields.get('recurrences')) : aWixEventsRecurrencesInput({}, pickedFields.get('recurrences'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleTbd')) {
        result.scheduleTbd = overrides && overrides.hasOwnProperty('scheduleTbd') ? overrides.scheduleTbd! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduleTbdMessage')) {
        result.scheduleTbdMessage = overrides && overrides.hasOwnProperty('scheduleTbdMessage') ? overrides.scheduleTbdMessage! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('showTimeZone')) {
        result.showTimeZone = overrides && overrides.hasOwnProperty('showTimeZone') ? overrides.showTimeZone! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZoneId')) {
        result.timeZoneId = overrides && overrides.hasOwnProperty('timeZoneId') ? overrides.timeZoneId! : 'facilis';
    }

    return result;
};

export const aWixEventsScheduleCreateBookmarkRequestInput = <T extends Partial<WixEventsScheduleCreateBookmarkRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : 'et';
    }

    return result;
};

export const aWixEventsScheduleDeleteBookmarkRequestInput = <T extends Partial<WixEventsScheduleDeleteBookmarkRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : 'cumque';
    }

    return result;
};

export const aWixEventsScheduleDeleteScheduleItemRequestInput = <T extends Partial<WixEventsScheduleDeleteScheduleItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemIds')) {
        result.itemIds = overrides && overrides.hasOwnProperty('itemIds') ? overrides.itemIds! : ['voluptatum'];
    }

    return result;
};

export const aWixEventsScheduleDiscardDraftRequestInput = <T extends Partial<WixEventsScheduleDiscardDraftRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'reprehenderit';
    }

    return result;
};

export const aWixEventsScheduleGetScheduleItemRequestInput = <T extends Partial<WixEventsScheduleGetScheduleItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bdf127b4-2bd8-4eb2-9aef-6d574e991761';
    }
    if (pickedFields.size === 0 || pickedFields.has('includeDraft')) {
        result.includeDraft = overrides && overrides.hasOwnProperty('includeDraft') ? overrides.includeDraft! : false;
    }

    return result;
};

export const aWixEventsScheduleGetScheduleItemResponse = <T extends Partial<WixEventsScheduleGetScheduleItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('draft')) {
        result.draft = overrides && overrides.hasOwnProperty('draft') ? aWixEventsScheduleScheduleItem(overrides.draft ?? {}, pickedFields.get('draft')) : aWixEventsScheduleScheduleItem({}, pickedFields.get('draft'));
    }
    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixEventsScheduleScheduleItem(overrides.item ?? {}, pickedFields.get('item')) : aWixEventsScheduleScheduleItem({}, pickedFields.get('item'));
    }

    return result;
};

export const aWixEventsScheduleListBookmarksRequestInput = <T extends Partial<WixEventsScheduleListBookmarksRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'deleniti';
    }

    return result;
};

export const aWixEventsScheduleListBookmarksResponse = <T extends Partial<WixEventsScheduleListBookmarksResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixEventsScheduleScheduleItem(x ?? {}, pickedFields.get('items'))) : [aWixEventsScheduleScheduleItem({}, pickedFields.get('items'))];
    }

    return result;
};

export const aWixEventsScheduleListScheduleItemsRequestInput = <T extends Partial<WixEventsScheduleListScheduleItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : ['deleniti'];
    }
    if (pickedFields.size === 0 || pickedFields.has('facet')) {
        result.facet = overrides && overrides.hasOwnProperty('facet') ? overrides.facet! : ['culpa'];
    }
    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : ['perferendis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 6466;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 2372;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aComWixEventsUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aComWixEventsUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('stageName')) {
        result.stageName = overrides && overrides.hasOwnProperty('stageName') ? overrides.stageName! : ['est'];
    }
    if (pickedFields.size === 0 || pickedFields.has('startingBefore')) {
        result.startingBefore = overrides && overrides.hasOwnProperty('startingBefore') ? overrides.startingBefore! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('startingFrom')) {
        result.startingFrom = overrides && overrides.hasOwnProperty('startingFrom') ? overrides.startingFrom! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('state')) {
        result.state = overrides && overrides.hasOwnProperty('state') ? overrides.state! : [WixEventsScheduleStateFilter.Draft];
    }
    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : ['reiciendis'];
    }

    return result;
};

export const aWixEventsScheduleListScheduleItemsResponse = <T extends Partial<WixEventsScheduleListScheduleItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('draftNotPublished')) {
        result.draftNotPublished = overrides && overrides.hasOwnProperty('draftNotPublished') ? overrides.draftNotPublished! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('facets')) {
        result.facets = overrides && overrides.hasOwnProperty('facets') ? aWixEventsFacetCounts(overrides.facets ?? {}, pickedFields.get('facets')) : aWixEventsFacetCounts({}, pickedFields.get('facets'));
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixEventsScheduleScheduleItem(x ?? {}, pickedFields.get('items'))) : [aWixEventsScheduleScheduleItem({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 4808;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 249;
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 2371;
    }

    return result;
};

export const aWixEventsSchedulePublishDraftRequestInput = <T extends Partial<WixEventsSchedulePublishDraftRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'eum';
    }

    return result;
};

export const aWixEventsScheduleQueryScheduleItemsRequestInput = <T extends Partial<WixEventsScheduleQueryScheduleItemsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixEventsUpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aComWixEventsUpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixEventsScheduleQueryScheduleItemsResponse = <T extends Partial<WixEventsScheduleQueryScheduleItemsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixEventsScheduleScheduleItem(x ?? {}, pickedFields.get('items'))) : [aWixEventsScheduleScheduleItem({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixEventsScheduleRescheduleDraftRequestInput = <T extends Partial<WixEventsScheduleRescheduleDraftRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeSlotOffset')) {
        result.timeSlotOffset = overrides && overrides.hasOwnProperty('timeSlotOffset') ? overrides.timeSlotOffset! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZoneId')) {
        result.timeZoneId = overrides && overrides.hasOwnProperty('timeZoneId') ? overrides.timeZoneId! : 'voluptatem';
    }

    return result;
};

export const aWixEventsScheduleScheduleItem = <T extends Partial<WixEventsScheduleScheduleItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('draft')) {
        result.draft = overrides && overrides.hasOwnProperty('draft') ? overrides.draft! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('stageName')) {
        result.stageName = overrides && overrides.hasOwnProperty('stageName') ? overrides.stageName! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixEventsScheduleScheduleStatus.Canceled;
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['delectus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeSlot')) {
        result.timeSlot = overrides && overrides.hasOwnProperty('timeSlot') ? aWixEventsTimeInterval(overrides.timeSlot ?? {}, pickedFields.get('timeSlot')) : aWixEventsTimeInterval({}, pickedFields.get('timeSlot'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'delectus';
    }

    return result;
};

export const aWixEventsScheduleScheduleItemDataInput = <T extends Partial<WixEventsScheduleScheduleItemDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cupiditate';
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('stageName')) {
        result.stageName = overrides && overrides.hasOwnProperty('stageName') ? overrides.stageName! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixEventsScheduleScheduleStatus.Canceled;
    }
    if (pickedFields.size === 0 || pickedFields.has('tags')) {
        result.tags = overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['ut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeSlot')) {
        result.timeSlot = overrides && overrides.hasOwnProperty('timeSlot') ? aWixEventsTimeIntervalInput(overrides.timeSlot ?? {}, pickedFields.get('timeSlot')) : aWixEventsTimeIntervalInput({}, pickedFields.get('timeSlot'));
    }

    return result;
};

export const aWixEventsScheduleUpdateScheduleItemRequestInput = <T extends Partial<WixEventsScheduleUpdateScheduleItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['qui'];
    }
    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixEventsScheduleScheduleItemDataInput(overrides.item ?? {}, pickedFields.get('item')) : aWixEventsScheduleScheduleItemDataInput({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : 'minima';
    }

    return result;
};

export const aWixEventsScheduleUpdateScheduleItemResponse = <T extends Partial<WixEventsScheduleUpdateScheduleItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixEventsScheduleScheduleItem(overrides.item ?? {}, pickedFields.get('item')) : aWixEventsScheduleScheduleItem({}, pickedFields.get('item'));
    }

    return result;
};

export const aWixEventsScheduling = <T extends Partial<WixEventsScheduling>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('config')) {
        result.config = overrides && overrides.hasOwnProperty('config') ? aWixEventsScheduleConfig(overrides.config ?? {}, pickedFields.get('config')) : aWixEventsScheduleConfig({}, pickedFields.get('config'));
    }
    if (pickedFields.size === 0 || pickedFields.has('endDateFormatted')) {
        result.endDateFormatted = overrides && overrides.hasOwnProperty('endDateFormatted') ? overrides.endDateFormatted! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('endTimeFormatted')) {
        result.endTimeFormatted = overrides && overrides.hasOwnProperty('endTimeFormatted') ? overrides.endTimeFormatted! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('formatted')) {
        result.formatted = overrides && overrides.hasOwnProperty('formatted') ? overrides.formatted! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('startDateFormatted')) {
        result.startDateFormatted = overrides && overrides.hasOwnProperty('startDateFormatted') ? overrides.startDateFormatted! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('startTimeFormatted')) {
        result.startTimeFormatted = overrides && overrides.hasOwnProperty('startTimeFormatted') ? overrides.startTimeFormatted! : 'sunt';
    }

    return result;
};

export const aWixEventsSeoSettings = <T extends Partial<WixEventsSeoSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('advancedSeoData')) {
        result.advancedSeoData = overrides && overrides.hasOwnProperty('advancedSeoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.advancedSeoData ?? {}, pickedFields.get('advancedSeoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('advancedSeoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'quaerat';
    }

    return result;
};

export const aWixEventsSeoSettingsInput = <T extends Partial<WixEventsSeoSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('advancedSeoData')) {
        result.advancedSeoData = overrides && overrides.hasOwnProperty('advancedSeoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.advancedSeoData ?? {}, pickedFields.get('advancedSeoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('advancedSeoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'tempora';
    }

    return result;
};

export const aWixEventsSiteUrl = <T extends Partial<WixEventsSiteUrl>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('base')) {
        result.base = overrides && overrides.hasOwnProperty('base') ? overrides.base! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('path')) {
        result.path = overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'corporis';
    }

    return result;
};

export const aWixEventsSiteUrlInput = <T extends Partial<WixEventsSiteUrlInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('base')) {
        result.base = overrides && overrides.hasOwnProperty('base') ? overrides.base! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('path')) {
        result.path = overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'explicabo';
    }

    return result;
};

export const aWixEventsTaxConfig = <T extends Partial<WixEventsTaxConfig>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appliesToDonations')) {
        result.appliesToDonations = overrides && overrides.hasOwnProperty('appliesToDonations') ? overrides.appliesToDonations! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixEventsTaxType.Added;
    }

    return result;
};

export const aWixEventsTaxConfigInput = <T extends Partial<WixEventsTaxConfigInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appliesToDonations')) {
        result.appliesToDonations = overrides && overrides.hasOwnProperty('appliesToDonations') ? overrides.appliesToDonations! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'vero';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixEventsTaxType.Added;
    }

    return result;
};

export const aWixEventsTicketing = <T extends Partial<WixEventsTicketing>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('config')) {
        result.config = overrides && overrides.hasOwnProperty('config') ? aWixEventsTicketingConfig(overrides.config ?? {}, pickedFields.get('config')) : aWixEventsTicketingConfig({}, pickedFields.get('config'));
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('highestPrice')) {
        result.highestPrice = overrides && overrides.hasOwnProperty('highestPrice') ? overrides.highestPrice! : 'delectus';
    }
    if (pickedFields.size === 0 || pickedFields.has('highestTicketPrice')) {
        result.highestTicketPrice = overrides && overrides.hasOwnProperty('highestTicketPrice') ? aWixEventsMoney(overrides.highestTicketPrice ?? {}, pickedFields.get('highestTicketPrice')) : aWixEventsMoney({}, pickedFields.get('highestTicketPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('highestTicketPriceFormatted')) {
        result.highestTicketPriceFormatted = overrides && overrides.hasOwnProperty('highestTicketPriceFormatted') ? overrides.highestTicketPriceFormatted! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('lowestPrice')) {
        result.lowestPrice = overrides && overrides.hasOwnProperty('lowestPrice') ? overrides.lowestPrice! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('lowestTicketPrice')) {
        result.lowestTicketPrice = overrides && overrides.hasOwnProperty('lowestTicketPrice') ? aWixEventsMoney(overrides.lowestTicketPrice ?? {}, pickedFields.get('lowestTicketPrice')) : aWixEventsMoney({}, pickedFields.get('lowestTicketPrice'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lowestTicketPriceFormatted')) {
        result.lowestTicketPriceFormatted = overrides && overrides.hasOwnProperty('lowestTicketPriceFormatted') ? overrides.lowestTicketPriceFormatted! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('soldOut')) {
        result.soldOut = overrides && overrides.hasOwnProperty('soldOut') ? overrides.soldOut! : true;
    }

    return result;
};

export const aWixEventsTicketingConfig = <T extends Partial<WixEventsTicketingConfig>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('gracePeriodInMinutes')) {
        result.gracePeriodInMinutes = overrides && overrides.hasOwnProperty('gracePeriodInMinutes') ? overrides.gracePeriodInMinutes! : 2055;
    }
    if (pickedFields.size === 0 || pickedFields.has('guestAssignedTickets')) {
        result.guestAssignedTickets = overrides && overrides.hasOwnProperty('guestAssignedTickets') ? overrides.guestAssignedTickets! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('reservationDurationInMinutes')) {
        result.reservationDurationInMinutes = overrides && overrides.hasOwnProperty('reservationDurationInMinutes') ? overrides.reservationDurationInMinutes! : 8176;
    }
    if (pickedFields.size === 0 || pickedFields.has('stockManagerAppId')) {
        result.stockManagerAppId = overrides && overrides.hasOwnProperty('stockManagerAppId') ? overrides.stockManagerAppId! : 'cupiditate';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxConfig')) {
        result.taxConfig = overrides && overrides.hasOwnProperty('taxConfig') ? aWixEventsTaxConfig(overrides.taxConfig ?? {}, pickedFields.get('taxConfig')) : aWixEventsTaxConfig({}, pickedFields.get('taxConfig'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ticketLimitPerOrder')) {
        result.ticketLimitPerOrder = overrides && overrides.hasOwnProperty('ticketLimitPerOrder') ? overrides.ticketLimitPerOrder! : 4264;
    }

    return result;
};

export const aWixEventsTicketingConfigInput = <T extends Partial<WixEventsTicketingConfigInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('gracePeriodInMinutes')) {
        result.gracePeriodInMinutes = overrides && overrides.hasOwnProperty('gracePeriodInMinutes') ? overrides.gracePeriodInMinutes! : 4905;
    }
    if (pickedFields.size === 0 || pickedFields.has('guestAssignedTickets')) {
        result.guestAssignedTickets = overrides && overrides.hasOwnProperty('guestAssignedTickets') ? overrides.guestAssignedTickets! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('reservationDurationInMinutes')) {
        result.reservationDurationInMinutes = overrides && overrides.hasOwnProperty('reservationDurationInMinutes') ? overrides.reservationDurationInMinutes! : 2622;
    }
    if (pickedFields.size === 0 || pickedFields.has('stockManagerAppId')) {
        result.stockManagerAppId = overrides && overrides.hasOwnProperty('stockManagerAppId') ? overrides.stockManagerAppId! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxConfig')) {
        result.taxConfig = overrides && overrides.hasOwnProperty('taxConfig') ? aWixEventsTaxConfigInput(overrides.taxConfig ?? {}, pickedFields.get('taxConfig')) : aWixEventsTaxConfigInput({}, pickedFields.get('taxConfig'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ticketLimitPerOrder')) {
        result.ticketLimitPerOrder = overrides && overrides.hasOwnProperty('ticketLimitPerOrder') ? overrides.ticketLimitPerOrder! : 3669;
    }

    return result;
};

export const aWixEventsTimeInterval = <T extends Partial<WixEventsTimeInterval>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? overrides.end! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? overrides.start! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZoneId')) {
        result.timeZoneId = overrides && overrides.hasOwnProperty('timeZoneId') ? overrides.timeZoneId! : 'impedit';
    }

    return result;
};

export const aWixEventsTimeIntervalInput = <T extends Partial<WixEventsTimeIntervalInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('end')) {
        result.end = overrides && overrides.hasOwnProperty('end') ? overrides.end! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? overrides.start! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZoneId')) {
        result.timeZoneId = overrides && overrides.hasOwnProperty('timeZoneId') ? overrides.timeZoneId! : 'assumenda';
    }

    return result;
};

export const aWixEventsUpdateEventRequestInput = <T extends Partial<WixEventsUpdateEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEventDataInput(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEventDataInput({}, pickedFields.get('event'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['nam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'sed';
    }

    return result;
};

export const aWixEventsUpdateEventResponse = <T extends Partial<WixEventsUpdateEventResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEvent(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEvent({}, pickedFields.get('event'));
    }

    return result;
};

export const aWixEventsUpdateRecurringStatusRequestInput = <T extends Partial<WixEventsUpdateRecurringStatusRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('categoryId')) {
        result.categoryId = overrides && overrides.hasOwnProperty('categoryId') ? overrides.categoryId! : 'omnis';
    }

    return result;
};

export const aWixEventsUserFilterInput = <T extends Partial<WixEventsUserFilterInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('relation')) {
        result.relation = overrides && overrides.hasOwnProperty('relation') ? overrides.relation! : [WixEventsUserFilterRelation.Attending];
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'eaque';
    }

    return result;
};

export const aWixEventsV2CreatePolicyRequestInput = <T extends Partial<WixEventsV2CreatePolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('policy')) {
        result.policy = overrides && overrides.hasOwnProperty('policy') ? aWixEventsV2PolicyInput(overrides.policy ?? {}, pickedFields.get('policy')) : aWixEventsV2PolicyInput({}, pickedFields.get('policy'));
    }

    return result;
};

export const aWixEventsV2CreatePolicyResponse = <T extends Partial<WixEventsV2CreatePolicyResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('policy')) {
        result.policy = overrides && overrides.hasOwnProperty('policy') ? aWixEventsV2Policy(overrides.policy ?? {}, pickedFields.get('policy')) : aWixEventsV2Policy({}, pickedFields.get('policy'));
    }

    return result;
};

export const aWixEventsV2DeletePolicyRequestInput = <T extends Partial<WixEventsV2DeletePolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('policyId')) {
        result.policyId = overrides && overrides.hasOwnProperty('policyId') ? overrides.policyId! : 'ad';
    }

    return result;
};

export const aWixEventsV2GetPolicyFromTrashBinRequestInput = <T extends Partial<WixEventsV2GetPolicyFromTrashBinRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('policyId')) {
        result.policyId = overrides && overrides.hasOwnProperty('policyId') ? overrides.policyId! : 'dolorem';
    }

    return result;
};

export const aWixEventsV2GetPolicyFromTrashBinResponse = <T extends Partial<WixEventsV2GetPolicyFromTrashBinResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('policy')) {
        result.policy = overrides && overrides.hasOwnProperty('policy') ? aWixEventsV2Policy(overrides.policy ?? {}, pickedFields.get('policy')) : aWixEventsV2Policy({}, pickedFields.get('policy'));
    }

    return result;
};

export const aWixEventsV2GetPolicyRequestInput = <T extends Partial<WixEventsV2GetPolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '38b04052-5ce1-4e3b-a5d5-b713b9aa9707';
    }

    return result;
};

export const aWixEventsV2Policy = <T extends Partial<WixEventsV2Policy>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('body')) {
        result.body = overrides && overrides.hasOwnProperty('body') ? overrides.body! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('event')) {
        result.event = overrides && overrides.hasOwnProperty('event') ? aWixEventsEvent(overrides.event ?? {}, pickedFields.get('event')) : aWixEventsEvent({}, pickedFields.get('event'));
    }
    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'repellat';
    }

    return result;
};

export const aWixEventsV2PolicyInput = <T extends Partial<WixEventsV2PolicyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('body')) {
        result.body = overrides && overrides.hasOwnProperty('body') ? overrides.body! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'omnis';
    }

    return result;
};

export const aWixEventsV2PolicyUpstreamWixCommonCursorPagingInput = <T extends Partial<WixEventsV2PolicyUpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 8269;
    }

    return result;
};

export const aWixEventsV2PolicyUpstreamWixCommonPagingInput = <T extends Partial<WixEventsV2PolicyUpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 8938;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 8016;
    }

    return result;
};

export const aWixEventsV2PolicyUpstreamWixCommonQueryV2Input = <T extends Partial<WixEventsV2PolicyUpstreamWixCommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixEventsV2PolicyUpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixEventsV2PolicyUpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixEventsV2PolicyUpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixEventsV2PolicyUpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixEventsV2PolicyUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixEventsV2PolicyUpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixEventsV2PolicyUpstreamWixCommonSortingInput = <T extends Partial<WixEventsV2PolicyUpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixEventsV2QueryPoliciesRequestInput = <T extends Partial<WixEventsV2QueryPoliciesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixEventsV2PolicyUpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixEventsV2PolicyUpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixEventsV2QueryPoliciesResponse = <T extends Partial<WixEventsV2QueryPoliciesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixEventsV2Policy(x ?? {}, pickedFields.get('items'))) : [aWixEventsV2Policy({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixEventsV2ReorderEventPoliciesRequestInput = <T extends Partial<WixEventsV2ReorderEventPoliciesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('afterPolicyId')) {
        result.afterPolicyId = overrides && overrides.hasOwnProperty('afterPolicyId') ? overrides.afterPolicyId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('beforePolicyId')) {
        result.beforePolicyId = overrides && overrides.hasOwnProperty('beforePolicyId') ? overrides.beforePolicyId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventId')) {
        result.eventId = overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('policyId')) {
        result.policyId = overrides && overrides.hasOwnProperty('policyId') ? overrides.policyId! : 'commodi';
    }

    return result;
};

export const aWixEventsV2ReorderEventPoliciesResponse = <T extends Partial<WixEventsV2ReorderEventPoliciesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('policies')) {
        result.policies = overrides && overrides.hasOwnProperty('policies') ? overrides.policies!.map((x) => aWixEventsV2Policy(x ?? {}, pickedFields.get('policies'))) : [aWixEventsV2Policy({}, pickedFields.get('policies'))];
    }

    return result;
};

export const aWixEventsV2UpdatePolicyRequestInput = <T extends Partial<WixEventsV2UpdatePolicyRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['aliquid'];
    }
    if (pickedFields.size === 0 || pickedFields.has('policy')) {
        result.policy = overrides && overrides.hasOwnProperty('policy') ? aWixEventsV2PolicyInput(overrides.policy ?? {}, pickedFields.get('policy')) : aWixEventsV2PolicyInput({}, pickedFields.get('policy'));
    }

    return result;
};

export const aWixEventsV2UpdatePolicyResponse = <T extends Partial<WixEventsV2UpdatePolicyResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('policy')) {
        result.policy = overrides && overrides.hasOwnProperty('policy') ? aWixEventsV2Policy(overrides.policy ?? {}, pickedFields.get('policy')) : aWixEventsV2Policy({}, pickedFields.get('policy'));
    }

    return result;
};

export const aWixEventsV2UpdatePolicySortIndexRequestInput = <T extends Partial<WixEventsV2UpdatePolicySortIndexRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('policyId')) {
        result.policyId = overrides && overrides.hasOwnProperty('policyId') ? overrides.policyId! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('sortIndex')) {
        result.sortIndex = overrides && overrides.hasOwnProperty('sortIndex') ? overrides.sortIndex! : 40;
    }

    return result;
};

export const aWixEventsV2UpdatePolicySortIndexResponse = <T extends Partial<WixEventsV2UpdatePolicySortIndexResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('policy')) {
        result.policy = overrides && overrides.hasOwnProperty('policy') ? aWixEventsV2Policy(overrides.policy ?? {}, pickedFields.get('policy')) : aWixEventsV2Policy({}, pickedFields.get('policy'));
    }

    return result;
};

export const aWixFormsV4BreakPoint = <T extends Partial<WixFormsV4BreakPoint>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('columns')) {
        result.columns = overrides && overrides.hasOwnProperty('columns') ? overrides.columns! : 4600;
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixFormsV4ItemLayout(x ?? {}, pickedFields.get('items'))) : [aWixFormsV4ItemLayout({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('margin')) {
        result.margin = overrides && overrides.hasOwnProperty('margin') ? aWixFormsV4BreakPointMargin(overrides.margin ?? {}, pickedFields.get('margin')) : aWixFormsV4BreakPointMargin({}, pickedFields.get('margin'));
    }
    if (pickedFields.size === 0 || pickedFields.has('padding')) {
        result.padding = overrides && overrides.hasOwnProperty('padding') ? aWixFormsV4BreakPointMargin(overrides.padding ?? {}, pickedFields.get('padding')) : aWixFormsV4BreakPointMargin({}, pickedFields.get('padding'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rowHeight')) {
        result.rowHeight = overrides && overrides.hasOwnProperty('rowHeight') ? overrides.rowHeight! : 3503;
    }
    if (pickedFields.size === 0 || pickedFields.has('sections')) {
        result.sections = overrides && overrides.hasOwnProperty('sections') ? overrides.sections!.map((x) => aWixFormsV4BreakPointSection(x ?? {}, pickedFields.get('sections'))) : [aWixFormsV4BreakPointSection({}, pickedFields.get('sections'))];
    }

    return result;
};

export const aWixFormsV4BreakPointInput = <T extends Partial<WixFormsV4BreakPointInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('columns')) {
        result.columns = overrides && overrides.hasOwnProperty('columns') ? overrides.columns! : 5391;
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixFormsV4ItemLayoutInput({}, pickedFields.get('items'))) : [aWixFormsV4ItemLayoutInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('margin')) {
        result.margin = overrides && overrides.hasOwnProperty('margin') ? aWixFormsV4BreakPointMarginInput(overrides.margin ?? {}, pickedFields.get('margin')) : aWixFormsV4BreakPointMarginInput({}, pickedFields.get('margin'));
    }
    if (pickedFields.size === 0 || pickedFields.has('padding')) {
        result.padding = overrides && overrides.hasOwnProperty('padding') ? aWixFormsV4BreakPointMarginInput(overrides.padding ?? {}, pickedFields.get('padding')) : aWixFormsV4BreakPointMarginInput({}, pickedFields.get('padding'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rowHeight')) {
        result.rowHeight = overrides && overrides.hasOwnProperty('rowHeight') ? overrides.rowHeight! : 5385;
    }
    if (pickedFields.size === 0 || pickedFields.has('sections')) {
        result.sections = overrides && overrides.hasOwnProperty('sections') ? overrides.sections!.map((x) => aWixFormsV4BreakPointSectionInput({}, pickedFields.get('sections'))) : [aWixFormsV4BreakPointSectionInput({}, pickedFields.get('sections'))];
    }

    return result;
};

export const aWixFormsV4BreakPointMargin = <T extends Partial<WixFormsV4BreakPointMargin>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('horizontal')) {
        result.horizontal = overrides && overrides.hasOwnProperty('horizontal') ? overrides.horizontal! : 2637;
    }
    if (pickedFields.size === 0 || pickedFields.has('vertical')) {
        result.vertical = overrides && overrides.hasOwnProperty('vertical') ? overrides.vertical! : 4336;
    }

    return result;
};

export const aWixFormsV4BreakPointMarginInput = <T extends Partial<WixFormsV4BreakPointMarginInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('horizontal')) {
        result.horizontal = overrides && overrides.hasOwnProperty('horizontal') ? overrides.horizontal! : 5687;
    }
    if (pickedFields.size === 0 || pickedFields.has('vertical')) {
        result.vertical = overrides && overrides.hasOwnProperty('vertical') ? overrides.vertical! : 7502;
    }

    return result;
};

export const aWixFormsV4BreakPointSection = <T extends Partial<WixFormsV4BreakPointSection>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowedFieldIds')) {
        result.allowedFieldIds = overrides && overrides.hasOwnProperty('allowedFieldIds') ? overrides.allowedFieldIds! : ['fugiat'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('row')) {
        result.row = overrides && overrides.hasOwnProperty('row') ? overrides.row! : 3878;
    }

    return result;
};

export const aWixFormsV4BreakPointSectionInput = <T extends Partial<WixFormsV4BreakPointSectionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowedFieldIds')) {
        result.allowedFieldIds = overrides && overrides.hasOwnProperty('allowedFieldIds') ? overrides.allowedFieldIds! : ['quo'];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('row')) {
        result.row = overrides && overrides.hasOwnProperty('row') ? overrides.row! : 8733;
    }

    return result;
};

export const aWixFormsV4BulkCreateFormRequestInput = <T extends Partial<WixFormsV4BulkCreateFormRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('forms')) {
        result.forms = overrides && overrides.hasOwnProperty('forms') ? overrides.forms!.map((x) => aWixFormsV4FormInput({}, pickedFields.get('forms'))) : [aWixFormsV4FormInput({}, pickedFields.get('forms'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }

    return result;
};

export const aWixFormsV4BulkCreateFormResponse = <T extends Partial<WixFormsV4BulkCreateFormResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixFormsV4BulkFormResult(x ?? {}, pickedFields.get('results'))) : [aWixFormsV4BulkFormResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixFormsV4BulkFormResult = <T extends Partial<WixFormsV4BulkFormResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixFormsV4Form(overrides.item ?? {}, pickedFields.get('item')) : aWixFormsV4Form({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixFormsV4BulkRemoveDeletedFieldRequestInput = <T extends Partial<WixFormsV4BulkRemoveDeletedFieldRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsIds')) {
        result.fieldsIds = overrides && overrides.hasOwnProperty('fieldsIds') ? overrides.fieldsIds! : ['est'];
    }
    if (pickedFields.size === 0 || pickedFields.has('formId')) {
        result.formId = overrides && overrides.hasOwnProperty('formId') ? overrides.formId! : 'dignissimos';
    }

    return result;
};

export const aWixFormsV4BulkRemoveDeletedFieldResponse = <T extends Partial<WixFormsV4BulkRemoveDeletedFieldResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4Form(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4Form({}, pickedFields.get('form'));
    }

    return result;
};

export const aWixFormsV4CloneFormRequestInput = <T extends Partial<WixFormsV4CloneFormRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('formId')) {
        result.formId = overrides && overrides.hasOwnProperty('formId') ? overrides.formId! : 'laborum';
    }

    return result;
};

export const aWixFormsV4CloneFormResponse = <T extends Partial<WixFormsV4CloneFormResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4Form(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4Form({}, pickedFields.get('form'));
    }

    return result;
};

export const aWixFormsV4CountFormsRequestInput = <T extends Partial<WixFormsV4CountFormsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [WixFormsV4CountFormsRequestCountFormsFieldset.Deleted];
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'voluptas';
    }

    return result;
};

export const aWixFormsV4CountFormsResponse = <T extends Partial<WixFormsV4CountFormsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activeCount')) {
        result.activeCount = overrides && overrides.hasOwnProperty('activeCount') ? overrides.activeCount! : 7788;
    }
    if (pickedFields.size === 0 || pickedFields.has('deletedCount')) {
        result.deletedCount = overrides && overrides.hasOwnProperty('deletedCount') ? overrides.deletedCount! : 8957;
    }

    return result;
};

export const aWixFormsV4CreateFormRequestInput = <T extends Partial<WixFormsV4CreateFormRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4FormInput(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4FormInput({}, pickedFields.get('form'));
    }

    return result;
};

export const aWixFormsV4CreateFormResponse = <T extends Partial<WixFormsV4CreateFormResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4Form(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4Form({}, pickedFields.get('form'));
    }

    return result;
};

export const aWixFormsV4DeleteFormFromTrashBinRequestInput = <T extends Partial<WixFormsV4DeleteFormFromTrashBinRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('formId')) {
        result.formId = overrides && overrides.hasOwnProperty('formId') ? overrides.formId! : 'atque';
    }

    return result;
};

export const aWixFormsV4DeleteFormRequestInput = <T extends Partial<WixFormsV4DeleteFormRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('formId')) {
        result.formId = overrides && overrides.hasOwnProperty('formId') ? overrides.formId! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 4238;
    }

    return result;
};

export const aWixFormsV4Form = <T extends Partial<WixFormsV4Form>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('deletedFields')) {
        result.deletedFields = overrides && overrides.hasOwnProperty('deletedFields') ? overrides.deletedFields!.map((x) => aWixFormsV4FormField(x ?? {}, pickedFields.get('deletedFields'))) : [aWixFormsV4FormField({}, pickedFields.get('deletedFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('deletedFieldsV2')) {
        result.deletedFieldsV2 = overrides && overrides.hasOwnProperty('deletedFieldsV2') ? overrides.deletedFieldsV2!.map((x) => aWixFormsV4FormFieldV2(x ?? {}, pickedFields.get('deletedFieldsV2'))) : [aWixFormsV4FormFieldV2({}, pickedFields.get('deletedFieldsV2'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields!.map((x) => aWixFormsV4FormField(x ?? {}, pickedFields.get('fields'))) : [aWixFormsV4FormField({}, pickedFields.get('fields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsV2')) {
        result.fieldsV2 = overrides && overrides.hasOwnProperty('fieldsV2') ? overrides.fieldsV2!.map((x) => aWixFormsV4FormFieldV2(x ?? {}, pickedFields.get('fieldsV2'))) : [aWixFormsV4FormFieldV2({}, pickedFields.get('fieldsV2'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('kind')) {
        result.kind = overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : WixFormsV4FormKindKind.Extension;
    }
    if (pickedFields.size === 0 || pickedFields.has('mediaFolderId')) {
        result.mediaFolderId = overrides && overrides.hasOwnProperty('mediaFolderId') ? overrides.mediaFolderId! : 'debitis';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('nestedForms')) {
        result.nestedForms = overrides && overrides.hasOwnProperty('nestedForms') ? overrides.nestedForms!.map((x) => aWixFormsV4FormNestedForm(x ?? {}, pickedFields.get('nestedForms'))) : [aWixFormsV4FormNestedForm({}, pickedFields.get('nestedForms'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('plansVirtualReference')) {
        result.plansVirtualReference = overrides && overrides.hasOwnProperty('plansVirtualReference') ? aComWixpressMembershipV2PlansQueryPublicPlansResponse(overrides.plansVirtualReference ?? {}, pickedFields.get('plansVirtualReference')) : aComWixpressMembershipV2PlansQueryPublicPlansResponse({}, pickedFields.get('plansVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('postSubmissionTriggers')) {
        result.postSubmissionTriggers = overrides && overrides.hasOwnProperty('postSubmissionTriggers') ? aWixFormsV4PostSubmissionTriggers(overrides.postSubmissionTriggers ?? {}, pickedFields.get('postSubmissionTriggers')) : aWixFormsV4PostSubmissionTriggers({}, pickedFields.get('postSubmissionTriggers'));
    }
    if (pickedFields.size === 0 || pickedFields.has('properties')) {
        result.properties = overrides && overrides.hasOwnProperty('properties') ? aWixFormsV4FormFormProperties(overrides.properties ?? {}, pickedFields.get('properties')) : aWixFormsV4FormFormProperties({}, pickedFields.get('properties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 6472;
    }
    if (pickedFields.size === 0 || pickedFields.has('rules')) {
        result.rules = overrides && overrides.hasOwnProperty('rules') ? overrides.rules!.map((x) => aWixFormsV4FormRule(x ?? {}, pickedFields.get('rules'))) : [aWixFormsV4FormRule({}, pickedFields.get('rules'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('steps')) {
        result.steps = overrides && overrides.hasOwnProperty('steps') ? overrides.steps!.map((x) => aWixFormsV4Step(x ?? {}, pickedFields.get('steps'))) : [aWixFormsV4Step({}, pickedFields.get('steps'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'ipsa';
    }

    return result;
};

export const aWixFormsV4FormField = <T extends Partial<WixFormsV4FormField>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataExtensionsDetails')) {
        result.dataExtensionsDetails = overrides && overrides.hasOwnProperty('dataExtensionsDetails') ? aWixFormsV4FormFieldDataExtensionsDetails(overrides.dataExtensionsDetails ?? {}, pickedFields.get('dataExtensionsDetails')) : aWixFormsV4FormFieldDataExtensionsDetails({}, pickedFields.get('dataExtensionsDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'hic';
    }
    if (pickedFields.size === 0 || pickedFields.has('nestedFormId')) {
        result.nestedFormId = overrides && overrides.hasOwnProperty('nestedFormId') ? overrides.nestedFormId! : 'hic';
    }
    if (pickedFields.size === 0 || pickedFields.has('nestedFormOverrides')) {
        result.nestedFormOverrides = overrides && overrides.hasOwnProperty('nestedFormOverrides') ? aWixFormsV4FormFieldNestedFormOverrides(overrides.nestedFormOverrides ?? {}, pickedFields.get('nestedFormOverrides')) : aWixFormsV4FormFieldNestedFormOverrides({}, pickedFields.get('nestedFormOverrides'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pii')) {
        result.pii = overrides && overrides.hasOwnProperty('pii') ? overrides.pii! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4FormFieldValidation(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4FormFieldValidation({}, pickedFields.get('validation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('view')) {
        result.view = overrides && overrides.hasOwnProperty('view') ? overrides.view! : 'ad';
    }

    return result;
};

export const aWixFormsV4FormFieldArrayErrorMessages = <T extends Partial<WixFormsV4FormFieldArrayErrorMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'molestias';
    }

    return result;
};

export const aWixFormsV4FormFieldArrayErrorMessagesInput = <T extends Partial<WixFormsV4FormFieldArrayErrorMessagesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'aspernatur';
    }

    return result;
};

export const aWixFormsV4FormFieldArrayType = <T extends Partial<WixFormsV4FormFieldArrayType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldArrayErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldArrayErrorMessages({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? aWixFormsV4FormFieldArrayTypeArrayItems(overrides.items ?? {}, pickedFields.get('items')) : aWixFormsV4FormFieldArrayTypeArrayItems({}, pickedFields.get('items'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maxItems')) {
        result.maxItems = overrides && overrides.hasOwnProperty('maxItems') ? overrides.maxItems! : 361;
    }
    if (pickedFields.size === 0 || pickedFields.has('minItems')) {
        result.minItems = overrides && overrides.hasOwnProperty('minItems') ? overrides.minItems! : 8881;
    }

    return result;
};

export const aWixFormsV4FormFieldArrayTypeArrayItems = <T extends Partial<WixFormsV4FormFieldArrayTypeArrayItems>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('boolean')) {
        result.boolean = overrides && overrides.hasOwnProperty('boolean') ? aWixFormsV4FormFieldBooleanType(overrides.boolean ?? {}, pickedFields.get('boolean')) : aWixFormsV4FormFieldBooleanType({}, pickedFields.get('boolean'));
    }
    if (pickedFields.size === 0 || pickedFields.has('integer')) {
        result.integer = overrides && overrides.hasOwnProperty('integer') ? aWixFormsV4FormFieldIntegerType(overrides.integer ?? {}, pickedFields.get('integer')) : aWixFormsV4FormFieldIntegerType({}, pickedFields.get('integer'));
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? aWixFormsV4FormFieldNumberType(overrides.number ?? {}, pickedFields.get('number')) : aWixFormsV4FormFieldNumberType({}, pickedFields.get('number'));
    }
    if (pickedFields.size === 0 || pickedFields.has('object')) {
        result.object = overrides && overrides.hasOwnProperty('object') ? aWixFormsV4FormFieldObjectType(overrides.object ?? {}, pickedFields.get('object')) : aWixFormsV4FormFieldObjectType({}, pickedFields.get('object'));
    }
    if (pickedFields.size === 0 || pickedFields.has('string')) {
        result.string = overrides && overrides.hasOwnProperty('string') ? aWixFormsV4FormFieldStringType(overrides.string ?? {}, pickedFields.get('string')) : aWixFormsV4FormFieldStringType({}, pickedFields.get('string'));
    }

    return result;
};

export const aWixFormsV4FormFieldArrayTypeArrayItemsInput = <T extends Partial<WixFormsV4FormFieldArrayTypeArrayItemsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('boolean')) {
        result.boolean = overrides && overrides.hasOwnProperty('boolean') ? aWixFormsV4FormFieldBooleanTypeInput(overrides.boolean ?? {}, pickedFields.get('boolean')) : aWixFormsV4FormFieldBooleanTypeInput({}, pickedFields.get('boolean'));
    }
    if (pickedFields.size === 0 || pickedFields.has('integer')) {
        result.integer = overrides && overrides.hasOwnProperty('integer') ? aWixFormsV4FormFieldIntegerTypeInput(overrides.integer ?? {}, pickedFields.get('integer')) : aWixFormsV4FormFieldIntegerTypeInput({}, pickedFields.get('integer'));
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? aWixFormsV4FormFieldNumberTypeInput(overrides.number ?? {}, pickedFields.get('number')) : aWixFormsV4FormFieldNumberTypeInput({}, pickedFields.get('number'));
    }
    if (pickedFields.size === 0 || pickedFields.has('object')) {
        result.object = overrides && overrides.hasOwnProperty('object') ? aWixFormsV4FormFieldObjectTypeInput(overrides.object ?? {}, pickedFields.get('object')) : aWixFormsV4FormFieldObjectTypeInput({}, pickedFields.get('object'));
    }
    if (pickedFields.size === 0 || pickedFields.has('string')) {
        result.string = overrides && overrides.hasOwnProperty('string') ? aWixFormsV4FormFieldStringTypeInput(overrides.string ?? {}, pickedFields.get('string')) : aWixFormsV4FormFieldStringTypeInput({}, pickedFields.get('string'));
    }

    return result;
};

export const aWixFormsV4FormFieldArrayTypeInput = <T extends Partial<WixFormsV4FormFieldArrayTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldArrayErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldArrayErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? aWixFormsV4FormFieldArrayTypeArrayItemsInput(overrides.items ?? {}, pickedFields.get('items')) : aWixFormsV4FormFieldArrayTypeArrayItemsInput({}, pickedFields.get('items'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maxItems')) {
        result.maxItems = overrides && overrides.hasOwnProperty('maxItems') ? overrides.maxItems! : 2101;
    }
    if (pickedFields.size === 0 || pickedFields.has('minItems')) {
        result.minItems = overrides && overrides.hasOwnProperty('minItems') ? overrides.minItems! : 3741;
    }

    return result;
};

export const aWixFormsV4FormFieldBooleanErrorMessages = <T extends Partial<WixFormsV4FormFieldBooleanErrorMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'eos';
    }

    return result;
};

export const aWixFormsV4FormFieldBooleanErrorMessagesInput = <T extends Partial<WixFormsV4FormFieldBooleanErrorMessagesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'ut';
    }

    return result;
};

export const aWixFormsV4FormFieldBooleanType = <T extends Partial<WixFormsV4FormFieldBooleanType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [false];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldBooleanErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldBooleanErrorMessages({}, pickedFields.get('errorMessages'));
    }

    return result;
};

export const aWixFormsV4FormFieldBooleanTypeInput = <T extends Partial<WixFormsV4FormFieldBooleanTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [true];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldBooleanErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldBooleanErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }

    return result;
};

export const aWixFormsV4FormFieldContactInfo = <T extends Partial<WixFormsV4FormFieldContactInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressInfo')) {
        result.addressInfo = overrides && overrides.hasOwnProperty('addressInfo') ? aWixFormsV4FormFieldContactInfoAddressInfo(overrides.addressInfo ?? {}, pickedFields.get('addressInfo')) : aWixFormsV4FormFieldContactInfoAddressInfo({}, pickedFields.get('addressInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactField')) {
        result.contactField = overrides && overrides.hasOwnProperty('contactField') ? overrides.contactField! : WixFormsV4FormFieldContactInfoContactField.Address;
    }
    if (pickedFields.size === 0 || pickedFields.has('customFieldInfo')) {
        result.customFieldInfo = overrides && overrides.hasOwnProperty('customFieldInfo') ? aWixFormsV4FormFieldContactInfoCustomFieldInfo(overrides.customFieldInfo ?? {}, pickedFields.get('customFieldInfo')) : aWixFormsV4FormFieldContactInfoCustomFieldInfo({}, pickedFields.get('customFieldInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('emailInfo')) {
        result.emailInfo = overrides && overrides.hasOwnProperty('emailInfo') ? aWixFormsV4FormFieldContactInfoEmailInfo(overrides.emailInfo ?? {}, pickedFields.get('emailInfo')) : aWixFormsV4FormFieldContactInfoEmailInfo({}, pickedFields.get('emailInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('phoneInfo')) {
        result.phoneInfo = overrides && overrides.hasOwnProperty('phoneInfo') ? aWixFormsV4FormFieldContactInfoPhoneInfo(overrides.phoneInfo ?? {}, pickedFields.get('phoneInfo')) : aWixFormsV4FormFieldContactInfoPhoneInfo({}, pickedFields.get('phoneInfo'));
    }

    return result;
};

export const aWixFormsV4FormFieldContactInfoAddressInfo = <T extends Partial<WixFormsV4FormFieldContactInfoAddressInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : WixFormsV4FormFieldContactInfoAddressInfoTag.Home;
    }

    return result;
};

export const aWixFormsV4FormFieldContactInfoAddressInfoInput = <T extends Partial<WixFormsV4FormFieldContactInfoAddressInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : WixFormsV4FormFieldContactInfoAddressInfoTag.Home;
    }

    return result;
};

export const aWixFormsV4FormFieldContactInfoCustomFieldInfo = <T extends Partial<WixFormsV4FormFieldContactInfoCustomFieldInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'eaque';
    }

    return result;
};

export const aWixFormsV4FormFieldContactInfoCustomFieldInfoInput = <T extends Partial<WixFormsV4FormFieldContactInfoCustomFieldInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'temporibus';
    }

    return result;
};

export const aWixFormsV4FormFieldContactInfoEmailInfo = <T extends Partial<WixFormsV4FormFieldContactInfoEmailInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : WixFormsV4FormFieldContactInfoEmailInfoTag.Main;
    }

    return result;
};

export const aWixFormsV4FormFieldContactInfoEmailInfoInput = <T extends Partial<WixFormsV4FormFieldContactInfoEmailInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : WixFormsV4FormFieldContactInfoEmailInfoTag.Main;
    }

    return result;
};

export const aWixFormsV4FormFieldContactInfoInput = <T extends Partial<WixFormsV4FormFieldContactInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressInfo')) {
        result.addressInfo = overrides && overrides.hasOwnProperty('addressInfo') ? aWixFormsV4FormFieldContactInfoAddressInfoInput(overrides.addressInfo ?? {}, pickedFields.get('addressInfo')) : aWixFormsV4FormFieldContactInfoAddressInfoInput({}, pickedFields.get('addressInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactField')) {
        result.contactField = overrides && overrides.hasOwnProperty('contactField') ? overrides.contactField! : WixFormsV4FormFieldContactInfoContactField.Address;
    }
    if (pickedFields.size === 0 || pickedFields.has('customFieldInfo')) {
        result.customFieldInfo = overrides && overrides.hasOwnProperty('customFieldInfo') ? aWixFormsV4FormFieldContactInfoCustomFieldInfoInput(overrides.customFieldInfo ?? {}, pickedFields.get('customFieldInfo')) : aWixFormsV4FormFieldContactInfoCustomFieldInfoInput({}, pickedFields.get('customFieldInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('emailInfo')) {
        result.emailInfo = overrides && overrides.hasOwnProperty('emailInfo') ? aWixFormsV4FormFieldContactInfoEmailInfoInput(overrides.emailInfo ?? {}, pickedFields.get('emailInfo')) : aWixFormsV4FormFieldContactInfoEmailInfoInput({}, pickedFields.get('emailInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('phoneInfo')) {
        result.phoneInfo = overrides && overrides.hasOwnProperty('phoneInfo') ? aWixFormsV4FormFieldContactInfoPhoneInfoInput(overrides.phoneInfo ?? {}, pickedFields.get('phoneInfo')) : aWixFormsV4FormFieldContactInfoPhoneInfoInput({}, pickedFields.get('phoneInfo'));
    }

    return result;
};

export const aWixFormsV4FormFieldContactInfoPhoneInfo = <T extends Partial<WixFormsV4FormFieldContactInfoPhoneInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : WixFormsV4FormFieldContactInfoPhoneInfoTag.Main;
    }

    return result;
};

export const aWixFormsV4FormFieldContactInfoPhoneInfoInput = <T extends Partial<WixFormsV4FormFieldContactInfoPhoneInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : WixFormsV4FormFieldContactInfoPhoneInfoTag.Main;
    }

    return result;
};

export const aWixFormsV4FormFieldDataExtensionsDetails = <T extends Partial<WixFormsV4FormFieldDataExtensionsDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fqdns')) {
        result.fqdns = overrides && overrides.hasOwnProperty('fqdns') ? overrides.fqdns! : ['fuga'];
    }

    return result;
};

export const aWixFormsV4FormFieldDataExtensionsDetailsInput = <T extends Partial<WixFormsV4FormFieldDataExtensionsDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fqdns')) {
        result.fqdns = overrides && overrides.hasOwnProperty('fqdns') ? overrides.fqdns! : ['mollitia'];
    }

    return result;
};

export const aWixFormsV4FormFieldInput = <T extends Partial<WixFormsV4FormFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dataExtensionsDetails')) {
        result.dataExtensionsDetails = overrides && overrides.hasOwnProperty('dataExtensionsDetails') ? aWixFormsV4FormFieldDataExtensionsDetailsInput(overrides.dataExtensionsDetails ?? {}, pickedFields.get('dataExtensionsDetails')) : aWixFormsV4FormFieldDataExtensionsDetailsInput({}, pickedFields.get('dataExtensionsDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('nestedFormId')) {
        result.nestedFormId = overrides && overrides.hasOwnProperty('nestedFormId') ? overrides.nestedFormId! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('nestedFormOverrides')) {
        result.nestedFormOverrides = overrides && overrides.hasOwnProperty('nestedFormOverrides') ? aWixFormsV4FormFieldNestedFormOverridesInput(overrides.nestedFormOverrides ?? {}, pickedFields.get('nestedFormOverrides')) : aWixFormsV4FormFieldNestedFormOverridesInput({}, pickedFields.get('nestedFormOverrides'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pii')) {
        result.pii = overrides && overrides.hasOwnProperty('pii') ? overrides.pii! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4FormFieldValidationInput(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4FormFieldValidationInput({}, pickedFields.get('validation'));
    }
    if (pickedFields.size === 0 || pickedFields.has('view')) {
        result.view = overrides && overrides.hasOwnProperty('view') ? overrides.view! : 'voluptatem';
    }

    return result;
};

export const aWixFormsV4FormFieldIntegerType = <T extends Partial<WixFormsV4FormFieldIntegerType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [7783];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldNumberErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldNumberErrorMessages({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 5974;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 5766;
    }
    if (pickedFields.size === 0 || pickedFields.has('multipleOf')) {
        result.multipleOf = overrides && overrides.hasOwnProperty('multipleOf') ? overrides.multipleOf! : 4967;
    }

    return result;
};

export const aWixFormsV4FormFieldIntegerTypeInput = <T extends Partial<WixFormsV4FormFieldIntegerTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [6785];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldNumberErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldNumberErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 1337;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 9385;
    }
    if (pickedFields.size === 0 || pickedFields.has('multipleOf')) {
        result.multipleOf = overrides && overrides.hasOwnProperty('multipleOf') ? overrides.multipleOf! : 8584;
    }

    return result;
};

export const aWixFormsV4FormFieldNestedFormOverrides = <T extends Partial<WixFormsV4FormFieldNestedFormOverrides>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldOverrides')) {
        result.fieldOverrides = overrides && overrides.hasOwnProperty('fieldOverrides') ? aWixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverrides(overrides.fieldOverrides ?? {}, pickedFields.get('fieldOverrides')) : aWixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverrides({}, pickedFields.get('fieldOverrides'));
    }

    return result;
};

export const aWixFormsV4FormFieldNestedFormOverridesInput = <T extends Partial<WixFormsV4FormFieldNestedFormOverridesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldOverrides')) {
        result.fieldOverrides = overrides && overrides.hasOwnProperty('fieldOverrides') ? aWixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverridesInput(overrides.fieldOverrides ?? {}, pickedFields.get('fieldOverrides')) : aWixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverridesInput({}, pickedFields.get('fieldOverrides'));
    }

    return result;
};

export const aWixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverrides = <T extends Partial<WixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverrides>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : true;
    }

    return result;
};

export const aWixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverridesInput = <T extends Partial<WixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverridesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : false;
    }

    return result;
};

export const aWixFormsV4FormFieldNumberErrorMessages = <T extends Partial<WixFormsV4FormFieldNumberErrorMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'nostrum';
    }

    return result;
};

export const aWixFormsV4FormFieldNumberErrorMessagesInput = <T extends Partial<WixFormsV4FormFieldNumberErrorMessagesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'quia';
    }

    return result;
};

export const aWixFormsV4FormFieldNumberType = <T extends Partial<WixFormsV4FormFieldNumberType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [9.68];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldNumberErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldNumberErrorMessages({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 8.72;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 4.86;
    }
    if (pickedFields.size === 0 || pickedFields.has('multipleOf')) {
        result.multipleOf = overrides && overrides.hasOwnProperty('multipleOf') ? overrides.multipleOf! : 0.46;
    }

    return result;
};

export const aWixFormsV4FormFieldNumberTypeInput = <T extends Partial<WixFormsV4FormFieldNumberTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [9.43];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldNumberErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldNumberErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 3.37;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 5.57;
    }
    if (pickedFields.size === 0 || pickedFields.has('multipleOf')) {
        result.multipleOf = overrides && overrides.hasOwnProperty('multipleOf') ? overrides.multipleOf! : 0.27;
    }

    return result;
};

export const aWixFormsV4FormFieldObjectErrorMessages = <T extends Partial<WixFormsV4FormFieldObjectErrorMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'at';
    }

    return result;
};

export const aWixFormsV4FormFieldObjectErrorMessagesInput = <T extends Partial<WixFormsV4FormFieldObjectErrorMessagesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'molestias';
    }

    return result;
};

export const aWixFormsV4FormFieldObjectType = <T extends Partial<WixFormsV4FormFieldObjectType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldObjectErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldObjectErrorMessages({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('properties')) {
        result.properties = overrides && overrides.hasOwnProperty('properties') ? aWixFormsV4FormFieldObjectTypePropertiesType(overrides.properties ?? {}, pickedFields.get('properties')) : aWixFormsV4FormFieldObjectTypePropertiesType({}, pickedFields.get('properties'));
    }

    return result;
};

export const aWixFormsV4FormFieldObjectTypeInput = <T extends Partial<WixFormsV4FormFieldObjectTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldObjectErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldObjectErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('properties')) {
        result.properties = overrides && overrides.hasOwnProperty('properties') ? aWixFormsV4FormFieldObjectTypePropertiesTypeInput(overrides.properties ?? {}, pickedFields.get('properties')) : aWixFormsV4FormFieldObjectTypePropertiesTypeInput({}, pickedFields.get('properties'));
    }

    return result;
};

export const aWixFormsV4FormFieldObjectTypePropertiesType = <T extends Partial<WixFormsV4FormFieldObjectTypePropertiesType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('array')) {
        result.array = overrides && overrides.hasOwnProperty('array') ? aWixFormsV4FormFieldArrayType(overrides.array ?? {}, pickedFields.get('array')) : aWixFormsV4FormFieldArrayType({}, pickedFields.get('array'));
    }
    if (pickedFields.size === 0 || pickedFields.has('boolean')) {
        result.boolean = overrides && overrides.hasOwnProperty('boolean') ? aWixFormsV4FormFieldBooleanType(overrides.boolean ?? {}, pickedFields.get('boolean')) : aWixFormsV4FormFieldBooleanType({}, pickedFields.get('boolean'));
    }
    if (pickedFields.size === 0 || pickedFields.has('integer')) {
        result.integer = overrides && overrides.hasOwnProperty('integer') ? aWixFormsV4FormFieldIntegerType(overrides.integer ?? {}, pickedFields.get('integer')) : aWixFormsV4FormFieldIntegerType({}, pickedFields.get('integer'));
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? aWixFormsV4FormFieldNumberType(overrides.number ?? {}, pickedFields.get('number')) : aWixFormsV4FormFieldNumberType({}, pickedFields.get('number'));
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('string')) {
        result.string = overrides && overrides.hasOwnProperty('string') ? aWixFormsV4FormFieldStringType(overrides.string ?? {}, pickedFields.get('string')) : aWixFormsV4FormFieldStringType({}, pickedFields.get('string'));
    }

    return result;
};

export const aWixFormsV4FormFieldObjectTypePropertiesTypeInput = <T extends Partial<WixFormsV4FormFieldObjectTypePropertiesTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('array')) {
        result.array = overrides && overrides.hasOwnProperty('array') ? aWixFormsV4FormFieldArrayTypeInput(overrides.array ?? {}, pickedFields.get('array')) : aWixFormsV4FormFieldArrayTypeInput({}, pickedFields.get('array'));
    }
    if (pickedFields.size === 0 || pickedFields.has('boolean')) {
        result.boolean = overrides && overrides.hasOwnProperty('boolean') ? aWixFormsV4FormFieldBooleanTypeInput(overrides.boolean ?? {}, pickedFields.get('boolean')) : aWixFormsV4FormFieldBooleanTypeInput({}, pickedFields.get('boolean'));
    }
    if (pickedFields.size === 0 || pickedFields.has('integer')) {
        result.integer = overrides && overrides.hasOwnProperty('integer') ? aWixFormsV4FormFieldIntegerTypeInput(overrides.integer ?? {}, pickedFields.get('integer')) : aWixFormsV4FormFieldIntegerTypeInput({}, pickedFields.get('integer'));
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? aWixFormsV4FormFieldNumberTypeInput(overrides.number ?? {}, pickedFields.get('number')) : aWixFormsV4FormFieldNumberTypeInput({}, pickedFields.get('number'));
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('string')) {
        result.string = overrides && overrides.hasOwnProperty('string') ? aWixFormsV4FormFieldStringTypeInput(overrides.string ?? {}, pickedFields.get('string')) : aWixFormsV4FormFieldStringTypeInput({}, pickedFields.get('string'));
    }

    return result;
};

export const aWixFormsV4FormFieldPaymentInfoProduct = <T extends Partial<WixFormsV4FormFieldPaymentInfoProduct>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dynamicPriceOptions')) {
        result.dynamicPriceOptions = overrides && overrides.hasOwnProperty('dynamicPriceOptions') ? aWixFormsV4FormFieldPaymentInfoProductDynamicPriceOptions(overrides.dynamicPriceOptions ?? {}, pickedFields.get('dynamicPriceOptions')) : aWixFormsV4FormFieldPaymentInfoProductDynamicPriceOptions({}, pickedFields.get('dynamicPriceOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedPriceOptions')) {
        result.fixedPriceOptions = overrides && overrides.hasOwnProperty('fixedPriceOptions') ? aWixFormsV4FormFieldPaymentInfoProductFixedPriceOptions(overrides.fixedPriceOptions ?? {}, pickedFields.get('fixedPriceOptions')) : aWixFormsV4FormFieldPaymentInfoProductFixedPriceOptions({}, pickedFields.get('fixedPriceOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceType')) {
        result.priceType = overrides && overrides.hasOwnProperty('priceType') ? overrides.priceType! : WixFormsV4FormFieldPaymentInfoProductPriceTypeEnumPriceType.DynamicPrice;
    }
    if (pickedFields.size === 0 || pickedFields.has('productType')) {
        result.productType = overrides && overrides.hasOwnProperty('productType') ? overrides.productType! : WixFormsV4FormFieldPaymentInfoProductProductTypeEnumProductType.Digital;
    }
    if (pickedFields.size === 0 || pickedFields.has('quantityLimit')) {
        result.quantityLimit = overrides && overrides.hasOwnProperty('quantityLimit') ? aWixFormsV4FormFieldPaymentInfoProductQuantityLimit(overrides.quantityLimit ?? {}, pickedFields.get('quantityLimit')) : aWixFormsV4FormFieldPaymentInfoProductQuantityLimit({}, pickedFields.get('quantityLimit'));
    }

    return result;
};

export const aWixFormsV4FormFieldPaymentInfoProductDynamicPriceOptions = <T extends Partial<WixFormsV4FormFieldPaymentInfoProductDynamicPriceOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxPrice')) {
        result.maxPrice = overrides && overrides.hasOwnProperty('maxPrice') ? overrides.maxPrice! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('minPrice')) {
        result.minPrice = overrides && overrides.hasOwnProperty('minPrice') ? overrides.minPrice! : 'consequatur';
    }

    return result;
};

export const aWixFormsV4FormFieldPaymentInfoProductDynamicPriceOptionsInput = <T extends Partial<WixFormsV4FormFieldPaymentInfoProductDynamicPriceOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxPrice')) {
        result.maxPrice = overrides && overrides.hasOwnProperty('maxPrice') ? overrides.maxPrice! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('minPrice')) {
        result.minPrice = overrides && overrides.hasOwnProperty('minPrice') ? overrides.minPrice! : 'ut';
    }

    return result;
};

export const aWixFormsV4FormFieldPaymentInfoProductFixedPriceOptions = <T extends Partial<WixFormsV4FormFieldPaymentInfoProductFixedPriceOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'est';
    }

    return result;
};

export const aWixFormsV4FormFieldPaymentInfoProductFixedPriceOptionsInput = <T extends Partial<WixFormsV4FormFieldPaymentInfoProductFixedPriceOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'sequi';
    }

    return result;
};

export const aWixFormsV4FormFieldPaymentInfoProductInput = <T extends Partial<WixFormsV4FormFieldPaymentInfoProductInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dynamicPriceOptions')) {
        result.dynamicPriceOptions = overrides && overrides.hasOwnProperty('dynamicPriceOptions') ? aWixFormsV4FormFieldPaymentInfoProductDynamicPriceOptionsInput(overrides.dynamicPriceOptions ?? {}, pickedFields.get('dynamicPriceOptions')) : aWixFormsV4FormFieldPaymentInfoProductDynamicPriceOptionsInput({}, pickedFields.get('dynamicPriceOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedPriceOptions')) {
        result.fixedPriceOptions = overrides && overrides.hasOwnProperty('fixedPriceOptions') ? aWixFormsV4FormFieldPaymentInfoProductFixedPriceOptionsInput(overrides.fixedPriceOptions ?? {}, pickedFields.get('fixedPriceOptions')) : aWixFormsV4FormFieldPaymentInfoProductFixedPriceOptionsInput({}, pickedFields.get('fixedPriceOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'commodi';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceType')) {
        result.priceType = overrides && overrides.hasOwnProperty('priceType') ? overrides.priceType! : WixFormsV4FormFieldPaymentInfoProductPriceTypeEnumPriceType.DynamicPrice;
    }
    if (pickedFields.size === 0 || pickedFields.has('productType')) {
        result.productType = overrides && overrides.hasOwnProperty('productType') ? overrides.productType! : WixFormsV4FormFieldPaymentInfoProductProductTypeEnumProductType.Digital;
    }
    if (pickedFields.size === 0 || pickedFields.has('quantityLimit')) {
        result.quantityLimit = overrides && overrides.hasOwnProperty('quantityLimit') ? aWixFormsV4FormFieldPaymentInfoProductQuantityLimitInput(overrides.quantityLimit ?? {}, pickedFields.get('quantityLimit')) : aWixFormsV4FormFieldPaymentInfoProductQuantityLimitInput({}, pickedFields.get('quantityLimit'));
    }

    return result;
};

export const aWixFormsV4FormFieldPaymentInfoProductQuantityLimit = <T extends Partial<WixFormsV4FormFieldPaymentInfoProductQuantityLimit>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 8863;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 5792;
    }

    return result;
};

export const aWixFormsV4FormFieldPaymentInfoProductQuantityLimitInput = <T extends Partial<WixFormsV4FormFieldPaymentInfoProductQuantityLimitInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 2897;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 5343;
    }

    return result;
};

export const aWixFormsV4FormFieldPredefinedValidation = <T extends Partial<WixFormsV4FormFieldPredefinedValidation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : WixFormsV4FormFieldPredefinedValidationValidationFormat.Payment;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOptions')) {
        result.paymentOptions = overrides && overrides.hasOwnProperty('paymentOptions') ? aWixFormsV4PaymentType(overrides.paymentOptions ?? {}, pickedFields.get('paymentOptions')) : aWixFormsV4PaymentType({}, pickedFields.get('paymentOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldPredefinedValidationInput = <T extends Partial<WixFormsV4FormFieldPredefinedValidationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : WixFormsV4FormFieldPredefinedValidationValidationFormat.Payment;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOptions')) {
        result.paymentOptions = overrides && overrides.hasOwnProperty('paymentOptions') ? aWixFormsV4PaymentTypeInput(overrides.paymentOptions ?? {}, pickedFields.get('paymentOptions')) : aWixFormsV4PaymentTypeInput({}, pickedFields.get('paymentOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldStringErrorMessages = <T extends Partial<WixFormsV4FormFieldStringErrorMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'non';
    }

    return result;
};

export const aWixFormsV4FormFieldStringErrorMessagesInput = <T extends Partial<WixFormsV4FormFieldStringErrorMessagesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'quaerat';
    }

    return result;
};

export const aWixFormsV4FormFieldStringType = <T extends Partial<WixFormsV4FormFieldStringType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateOptionalTimeOptions')) {
        result.dateOptionalTimeOptions = overrides && overrides.hasOwnProperty('dateOptionalTimeOptions') ? aWixFormsV4FormFieldStringTypeDateTimeConstraints(overrides.dateOptionalTimeOptions ?? {}, pickedFields.get('dateOptionalTimeOptions')) : aWixFormsV4FormFieldStringTypeDateTimeConstraints({}, pickedFields.get('dateOptionalTimeOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dateOptions')) {
        result.dateOptions = overrides && overrides.hasOwnProperty('dateOptions') ? aWixFormsV4FormFieldStringTypeDateTimeConstraints(overrides.dateOptions ?? {}, pickedFields.get('dateOptions')) : aWixFormsV4FormFieldStringTypeDateTimeConstraints({}, pickedFields.get('dateOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dateTimeOptions')) {
        result.dateTimeOptions = overrides && overrides.hasOwnProperty('dateTimeOptions') ? aWixFormsV4FormFieldStringTypeDateTimeConstraints(overrides.dateTimeOptions ?? {}, pickedFields.get('dateTimeOptions')) : aWixFormsV4FormFieldStringTypeDateTimeConstraints({}, pickedFields.get('dateTimeOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : ['ab'];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldStringErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldStringErrorMessages({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : WixFormsV4FormFieldStringTypeFormatEnumFormat.ColorHex;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxLength')) {
        result.maxLength = overrides && overrides.hasOwnProperty('maxLength') ? overrides.maxLength! : 2971;
    }
    if (pickedFields.size === 0 || pickedFields.has('minLength')) {
        result.minLength = overrides && overrides.hasOwnProperty('minLength') ? overrides.minLength! : 9119;
    }
    if (pickedFields.size === 0 || pickedFields.has('pattern')) {
        result.pattern = overrides && overrides.hasOwnProperty('pattern') ? overrides.pattern! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeOptions')) {
        result.timeOptions = overrides && overrides.hasOwnProperty('timeOptions') ? aWixFormsV4FormFieldStringTypeDateTimeConstraints(overrides.timeOptions ?? {}, pickedFields.get('timeOptions')) : aWixFormsV4FormFieldStringTypeDateTimeConstraints({}, pickedFields.get('timeOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldStringTypeDateTimeConstraints = <T extends Partial<WixFormsV4FormFieldStringTypeDateTimeConstraints>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 'dolorem';
    }

    return result;
};

export const aWixFormsV4FormFieldStringTypeDateTimeConstraintsInput = <T extends Partial<WixFormsV4FormFieldStringTypeDateTimeConstraintsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 'est';
    }

    return result;
};

export const aWixFormsV4FormFieldStringTypeInput = <T extends Partial<WixFormsV4FormFieldStringTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateOptionalTimeOptions')) {
        result.dateOptionalTimeOptions = overrides && overrides.hasOwnProperty('dateOptionalTimeOptions') ? aWixFormsV4FormFieldStringTypeDateTimeConstraintsInput(overrides.dateOptionalTimeOptions ?? {}, pickedFields.get('dateOptionalTimeOptions')) : aWixFormsV4FormFieldStringTypeDateTimeConstraintsInput({}, pickedFields.get('dateOptionalTimeOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dateOptions')) {
        result.dateOptions = overrides && overrides.hasOwnProperty('dateOptions') ? aWixFormsV4FormFieldStringTypeDateTimeConstraintsInput(overrides.dateOptions ?? {}, pickedFields.get('dateOptions')) : aWixFormsV4FormFieldStringTypeDateTimeConstraintsInput({}, pickedFields.get('dateOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dateTimeOptions')) {
        result.dateTimeOptions = overrides && overrides.hasOwnProperty('dateTimeOptions') ? aWixFormsV4FormFieldStringTypeDateTimeConstraintsInput(overrides.dateTimeOptions ?? {}, pickedFields.get('dateTimeOptions')) : aWixFormsV4FormFieldStringTypeDateTimeConstraintsInput({}, pickedFields.get('dateTimeOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : ['dignissimos'];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldStringErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldStringErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : WixFormsV4FormFieldStringTypeFormatEnumFormat.ColorHex;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxLength')) {
        result.maxLength = overrides && overrides.hasOwnProperty('maxLength') ? overrides.maxLength! : 2563;
    }
    if (pickedFields.size === 0 || pickedFields.has('minLength')) {
        result.minLength = overrides && overrides.hasOwnProperty('minLength') ? overrides.minLength! : 5988;
    }
    if (pickedFields.size === 0 || pickedFields.has('pattern')) {
        result.pattern = overrides && overrides.hasOwnProperty('pattern') ? overrides.pattern! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeOptions')) {
        result.timeOptions = overrides && overrides.hasOwnProperty('timeOptions') ? aWixFormsV4FormFieldStringTypeDateTimeConstraintsInput(overrides.timeOptions ?? {}, pickedFields.get('timeOptions')) : aWixFormsV4FormFieldStringTypeDateTimeConstraintsInput({}, pickedFields.get('timeOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2 = <T extends Partial<WixFormsV4FormFieldV2>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayOptions')) {
        result.displayOptions = overrides && overrides.hasOwnProperty('displayOptions') ? aWixFormsV4FormFieldV2DisplayField(overrides.displayOptions ?? {}, pickedFields.get('displayOptions')) : aWixFormsV4FormFieldV2DisplayField({}, pickedFields.get('displayOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldType')) {
        result.fieldType = overrides && overrides.hasOwnProperty('fieldType') ? overrides.fieldType! : WixFormsV4FormFieldV2FieldType.Display;
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('identifier')) {
        result.identifier = overrides && overrides.hasOwnProperty('identifier') ? overrides.identifier! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('inputOptions')) {
        result.inputOptions = overrides && overrides.hasOwnProperty('inputOptions') ? aWixFormsV4FormFieldV2InputField(overrides.inputOptions ?? {}, pickedFields.get('inputOptions')) : aWixFormsV4FormFieldV2InputField({}, pickedFields.get('inputOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('submitOptions')) {
        result.submitOptions = overrides && overrides.hasOwnProperty('submitOptions') ? aWixFormsV4FormFieldV2SubmitButton(overrides.submitOptions ?? {}, pickedFields.get('submitOptions')) : aWixFormsV4FormFieldV2SubmitButton({}, pickedFields.get('submitOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2DisplayField = <T extends Partial<WixFormsV4FormFieldV2DisplayField>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('header')) {
        result.header = overrides && overrides.hasOwnProperty('header') ? aWixFormsV4FormFieldV2DisplayFieldHeader(overrides.header ?? {}, pickedFields.get('header')) : aWixFormsV4FormFieldV2DisplayFieldHeader({}, pickedFields.get('header'));
    }
    if (pickedFields.size === 0 || pickedFields.has('richText')) {
        result.richText = overrides && overrides.hasOwnProperty('richText') ? aWixFormsV4FormFieldV2DisplayFieldRichText(overrides.richText ?? {}, pickedFields.get('richText')) : aWixFormsV4FormFieldV2DisplayFieldRichText({}, pickedFields.get('richText'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2DisplayFieldHeader = <T extends Partial<WixFormsV4FormFieldV2DisplayFieldHeader>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('content')) {
        result.content = overrides && overrides.hasOwnProperty('content') ? aWixRichContentV1RichContent(overrides.content ?? {}, pickedFields.get('content')) : aWixRichContentV1RichContent({}, pickedFields.get('content'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2DisplayFieldHeaderInput = <T extends Partial<WixFormsV4FormFieldV2DisplayFieldHeaderInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('content')) {
        result.content = overrides && overrides.hasOwnProperty('content') ? aWixRichContentV1RichContentInput(overrides.content ?? {}, pickedFields.get('content')) : aWixRichContentV1RichContentInput({}, pickedFields.get('content'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2DisplayFieldInput = <T extends Partial<WixFormsV4FormFieldV2DisplayFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('header')) {
        result.header = overrides && overrides.hasOwnProperty('header') ? aWixFormsV4FormFieldV2DisplayFieldHeaderInput(overrides.header ?? {}, pickedFields.get('header')) : aWixFormsV4FormFieldV2DisplayFieldHeaderInput({}, pickedFields.get('header'));
    }
    if (pickedFields.size === 0 || pickedFields.has('richText')) {
        result.richText = overrides && overrides.hasOwnProperty('richText') ? aWixFormsV4FormFieldV2DisplayFieldRichTextInput(overrides.richText ?? {}, pickedFields.get('richText')) : aWixFormsV4FormFieldV2DisplayFieldRichTextInput({}, pickedFields.get('richText'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2DisplayFieldRichText = <T extends Partial<WixFormsV4FormFieldV2DisplayFieldRichText>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('content')) {
        result.content = overrides && overrides.hasOwnProperty('content') ? aWixRichContentV1RichContent(overrides.content ?? {}, pickedFields.get('content')) : aWixRichContentV1RichContent({}, pickedFields.get('content'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2DisplayFieldRichTextInput = <T extends Partial<WixFormsV4FormFieldV2DisplayFieldRichTextInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('content')) {
        result.content = overrides && overrides.hasOwnProperty('content') ? aWixRichContentV1RichContentInput(overrides.content ?? {}, pickedFields.get('content')) : aWixRichContentV1RichContentInput({}, pickedFields.get('content'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2Input = <T extends Partial<WixFormsV4FormFieldV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayOptions')) {
        result.displayOptions = overrides && overrides.hasOwnProperty('displayOptions') ? aWixFormsV4FormFieldV2DisplayFieldInput(overrides.displayOptions ?? {}, pickedFields.get('displayOptions')) : aWixFormsV4FormFieldV2DisplayFieldInput({}, pickedFields.get('displayOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldType')) {
        result.fieldType = overrides && overrides.hasOwnProperty('fieldType') ? overrides.fieldType! : WixFormsV4FormFieldV2FieldType.Display;
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('identifier')) {
        result.identifier = overrides && overrides.hasOwnProperty('identifier') ? overrides.identifier! : 'at';
    }
    if (pickedFields.size === 0 || pickedFields.has('inputOptions')) {
        result.inputOptions = overrides && overrides.hasOwnProperty('inputOptions') ? aWixFormsV4FormFieldV2InputFieldInput(overrides.inputOptions ?? {}, pickedFields.get('inputOptions')) : aWixFormsV4FormFieldV2InputFieldInput({}, pickedFields.get('inputOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('submitOptions')) {
        result.submitOptions = overrides && overrides.hasOwnProperty('submitOptions') ? aWixFormsV4FormFieldV2SubmitButtonInput(overrides.submitOptions ?? {}, pickedFields.get('submitOptions')) : aWixFormsV4FormFieldV2SubmitButtonInput({}, pickedFields.get('submitOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputField = <T extends Partial<WixFormsV4FormFieldV2InputField>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('arrayOptions')) {
        result.arrayOptions = overrides && overrides.hasOwnProperty('arrayOptions') ? aWixFormsV4FormFieldV2InputFieldArray(overrides.arrayOptions ?? {}, pickedFields.get('arrayOptions')) : aWixFormsV4FormFieldV2InputFieldArray({}, pickedFields.get('arrayOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('booleanOptions')) {
        result.booleanOptions = overrides && overrides.hasOwnProperty('booleanOptions') ? aWixFormsV4FormFieldV2InputFieldBoolean(overrides.booleanOptions ?? {}, pickedFields.get('booleanOptions')) : aWixFormsV4FormFieldV2InputFieldBoolean({}, pickedFields.get('booleanOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('inputType')) {
        result.inputType = overrides && overrides.hasOwnProperty('inputType') ? overrides.inputType! : WixFormsV4FormFieldV2InputFieldInputType.Array;
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOptions')) {
        result.numberOptions = overrides && overrides.hasOwnProperty('numberOptions') ? aWixFormsV4FormFieldV2InputFieldNumber(overrides.numberOptions ?? {}, pickedFields.get('numberOptions')) : aWixFormsV4FormFieldV2InputFieldNumber({}, pickedFields.get('numberOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('objectOptions')) {
        result.objectOptions = overrides && overrides.hasOwnProperty('objectOptions') ? aWixFormsV4FormFieldV2InputFieldObject(overrides.objectOptions ?? {}, pickedFields.get('objectOptions')) : aWixFormsV4FormFieldV2InputFieldObject({}, pickedFields.get('objectOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOptions')) {
        result.paymentOptions = overrides && overrides.hasOwnProperty('paymentOptions') ? aWixFormsV4FormFieldV2InputFieldPayment(overrides.paymentOptions ?? {}, pickedFields.get('paymentOptions')) : aWixFormsV4FormFieldV2InputFieldPayment({}, pickedFields.get('paymentOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pii')) {
        result.pii = overrides && overrides.hasOwnProperty('pii') ? overrides.pii! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('stringOptions')) {
        result.stringOptions = overrides && overrides.hasOwnProperty('stringOptions') ? aWixFormsV4FormFieldV2InputFieldString(overrides.stringOptions ?? {}, pickedFields.get('stringOptions')) : aWixFormsV4FormFieldV2InputFieldString({}, pickedFields.get('stringOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixFileOptions')) {
        result.wixFileOptions = overrides && overrides.hasOwnProperty('wixFileOptions') ? aWixFormsV4FormFieldV2InputFieldWixFile(overrides.wixFileOptions ?? {}, pickedFields.get('wixFileOptions')) : aWixFormsV4FormFieldV2InputFieldWixFile({}, pickedFields.get('wixFileOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArray = <T extends Partial<WixFormsV4FormFieldV2InputFieldArray>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkboxGroupOptions')) {
        result.checkboxGroupOptions = overrides && overrides.hasOwnProperty('checkboxGroupOptions') ? aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroup(overrides.checkboxGroupOptions ?? {}, pickedFields.get('checkboxGroupOptions')) : aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroup({}, pickedFields.get('checkboxGroupOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldArrayComponentType.CheckboxGroup;
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4FormFieldV2InputFieldArrayType(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4FormFieldV2InputFieldArrayType({}, pickedFields.get('validation'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroup = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroup>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customOption')) {
        result.customOption = overrides && overrides.hasOwnProperty('customOption') ? aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOption(overrides.customOption ?? {}, pickedFields.get('customOption')) : aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOption({}, pickedFields.get('customOption'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContent(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContent({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options!.map((x) => aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOption(x ?? {}, pickedFields.get('options'))) : [aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOption({}, pickedFields.get('options'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : true;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOption = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'eum';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOptionInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'exercitationem';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customOption')) {
        result.customOption = overrides && overrides.hasOwnProperty('customOption') ? aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOptionInput(overrides.customOption ?? {}, pickedFields.get('customOption')) : aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOptionInput({}, pickedFields.get('customOption'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContentInput(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContentInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options!.map((x) => aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOptionInput({}, pickedFields.get('options'))) : [aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOptionInput({}, pickedFields.get('options'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : false;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOption = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixFormsV4FormFieldV2MediaItem(overrides.media ?? {}, pickedFields.get('media')) : aWixFormsV4FormFieldV2MediaItem({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'magni';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOptionInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixFormsV4FormFieldV2MediaItemInput(overrides.media ?? {}, pickedFields.get('media')) : aWixFormsV4FormFieldV2MediaItemInput({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'sunt';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayErrorMessages = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayErrorMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'vel';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayErrorMessagesInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayErrorMessagesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'eius';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkboxGroupOptions')) {
        result.checkboxGroupOptions = overrides && overrides.hasOwnProperty('checkboxGroupOptions') ? aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupInput(overrides.checkboxGroupOptions ?? {}, pickedFields.get('checkboxGroupOptions')) : aWixFormsV4FormFieldV2InputFieldArrayCheckboxGroupInput({}, pickedFields.get('checkboxGroupOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldArrayComponentType.CheckboxGroup;
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4FormFieldV2InputFieldArrayTypeInput(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4FormFieldV2InputFieldArrayTypeInput({}, pickedFields.get('validation'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayType = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldArrayErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldArrayErrorMessages({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? aWixFormsV4FormFieldV2InputFieldArrayTypeArrayItems(overrides.items ?? {}, pickedFields.get('items')) : aWixFormsV4FormFieldV2InputFieldArrayTypeArrayItems({}, pickedFields.get('items'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maxItems')) {
        result.maxItems = overrides && overrides.hasOwnProperty('maxItems') ? overrides.maxItems! : 7589;
    }
    if (pickedFields.size === 0 || pickedFields.has('minItems')) {
        result.minItems = overrides && overrides.hasOwnProperty('minItems') ? overrides.minItems! : 4877;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayTypeArrayItems = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayTypeArrayItems>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('booleanOptions')) {
        result.booleanOptions = overrides && overrides.hasOwnProperty('booleanOptions') ? aWixFormsV4FormFieldV2InputFieldBooleanType(overrides.booleanOptions ?? {}, pickedFields.get('booleanOptions')) : aWixFormsV4FormFieldV2InputFieldBooleanType({}, pickedFields.get('booleanOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('integerOptions')) {
        result.integerOptions = overrides && overrides.hasOwnProperty('integerOptions') ? aWixFormsV4FormFieldV2InputFieldIntegerType(overrides.integerOptions ?? {}, pickedFields.get('integerOptions')) : aWixFormsV4FormFieldV2InputFieldIntegerType({}, pickedFields.get('integerOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemType')) {
        result.itemType = overrides && overrides.hasOwnProperty('itemType') ? overrides.itemType! : WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsItemType.Boolean;
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOptions')) {
        result.numberOptions = overrides && overrides.hasOwnProperty('numberOptions') ? aWixFormsV4FormFieldV2InputFieldNumberType(overrides.numberOptions ?? {}, pickedFields.get('numberOptions')) : aWixFormsV4FormFieldV2InputFieldNumberType({}, pickedFields.get('numberOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('objectOptions')) {
        result.objectOptions = overrides && overrides.hasOwnProperty('objectOptions') ? aWixFormsV4FormFieldV2InputFieldObjectType(overrides.objectOptions ?? {}, pickedFields.get('objectOptions')) : aWixFormsV4FormFieldV2InputFieldObjectType({}, pickedFields.get('objectOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('stringOptions')) {
        result.stringOptions = overrides && overrides.hasOwnProperty('stringOptions') ? aWixFormsV4FormFieldV2InputFieldStringType(overrides.stringOptions ?? {}, pickedFields.get('stringOptions')) : aWixFormsV4FormFieldV2InputFieldStringType({}, pickedFields.get('stringOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('booleanOptions')) {
        result.booleanOptions = overrides && overrides.hasOwnProperty('booleanOptions') ? aWixFormsV4FormFieldV2InputFieldBooleanTypeInput(overrides.booleanOptions ?? {}, pickedFields.get('booleanOptions')) : aWixFormsV4FormFieldV2InputFieldBooleanTypeInput({}, pickedFields.get('booleanOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('integerOptions')) {
        result.integerOptions = overrides && overrides.hasOwnProperty('integerOptions') ? aWixFormsV4FormFieldV2InputFieldIntegerTypeInput(overrides.integerOptions ?? {}, pickedFields.get('integerOptions')) : aWixFormsV4FormFieldV2InputFieldIntegerTypeInput({}, pickedFields.get('integerOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemType')) {
        result.itemType = overrides && overrides.hasOwnProperty('itemType') ? overrides.itemType! : WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsItemType.Boolean;
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOptions')) {
        result.numberOptions = overrides && overrides.hasOwnProperty('numberOptions') ? aWixFormsV4FormFieldV2InputFieldNumberTypeInput(overrides.numberOptions ?? {}, pickedFields.get('numberOptions')) : aWixFormsV4FormFieldV2InputFieldNumberTypeInput({}, pickedFields.get('numberOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('objectOptions')) {
        result.objectOptions = overrides && overrides.hasOwnProperty('objectOptions') ? aWixFormsV4FormFieldV2InputFieldObjectTypeInput(overrides.objectOptions ?? {}, pickedFields.get('objectOptions')) : aWixFormsV4FormFieldV2InputFieldObjectTypeInput({}, pickedFields.get('objectOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('stringOptions')) {
        result.stringOptions = overrides && overrides.hasOwnProperty('stringOptions') ? aWixFormsV4FormFieldV2InputFieldStringTypeInput(overrides.stringOptions ?? {}, pickedFields.get('stringOptions')) : aWixFormsV4FormFieldV2InputFieldStringTypeInput({}, pickedFields.get('stringOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldArrayTypeInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldArrayTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldArrayErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldArrayErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? aWixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsInput(overrides.items ?? {}, pickedFields.get('items')) : aWixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsInput({}, pickedFields.get('items'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maxItems')) {
        result.maxItems = overrides && overrides.hasOwnProperty('maxItems') ? overrides.maxItems! : 2961;
    }
    if (pickedFields.size === 0 || pickedFields.has('minItems')) {
        result.minItems = overrides && overrides.hasOwnProperty('minItems') ? overrides.minItems! : 1082;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldBoolean = <T extends Partial<WixFormsV4FormFieldV2InputFieldBoolean>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkboxOptions')) {
        result.checkboxOptions = overrides && overrides.hasOwnProperty('checkboxOptions') ? aWixFormsV4FormFieldV2InputFieldBooleanCheckbox(overrides.checkboxOptions ?? {}, pickedFields.get('checkboxOptions')) : aWixFormsV4FormFieldV2InputFieldBooleanCheckbox({}, pickedFields.get('checkboxOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldBooleanComponentType.Checkbox;
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4FormFieldV2InputFieldBooleanType(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4FormFieldV2InputFieldBooleanType({}, pickedFields.get('validation'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldBooleanCheckbox = <T extends Partial<WixFormsV4FormFieldV2InputFieldBooleanCheckbox>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aWixRichContentV1RichContent(overrides.label ?? {}, pickedFields.get('label')) : aWixRichContentV1RichContent({}, pickedFields.get('label'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldBooleanCheckboxInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldBooleanCheckboxInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? aWixRichContentV1RichContentInput(overrides.label ?? {}, pickedFields.get('label')) : aWixRichContentV1RichContentInput({}, pickedFields.get('label'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldBooleanErrorMessages = <T extends Partial<WixFormsV4FormFieldV2InputFieldBooleanErrorMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'rerum';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldBooleanErrorMessagesInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldBooleanErrorMessagesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'ea';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldBooleanInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldBooleanInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkboxOptions')) {
        result.checkboxOptions = overrides && overrides.hasOwnProperty('checkboxOptions') ? aWixFormsV4FormFieldV2InputFieldBooleanCheckboxInput(overrides.checkboxOptions ?? {}, pickedFields.get('checkboxOptions')) : aWixFormsV4FormFieldV2InputFieldBooleanCheckboxInput({}, pickedFields.get('checkboxOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldBooleanComponentType.Checkbox;
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4FormFieldV2InputFieldBooleanTypeInput(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4FormFieldV2InputFieldBooleanTypeInput({}, pickedFields.get('validation'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldBooleanType = <T extends Partial<WixFormsV4FormFieldV2InputFieldBooleanType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [true];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldBooleanErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldBooleanErrorMessages({}, pickedFields.get('errorMessages'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldBooleanTypeInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldBooleanTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [true];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldBooleanErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldBooleanErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('arrayOptions')) {
        result.arrayOptions = overrides && overrides.hasOwnProperty('arrayOptions') ? aWixFormsV4FormFieldV2InputFieldArrayInput(overrides.arrayOptions ?? {}, pickedFields.get('arrayOptions')) : aWixFormsV4FormFieldV2InputFieldArrayInput({}, pickedFields.get('arrayOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('booleanOptions')) {
        result.booleanOptions = overrides && overrides.hasOwnProperty('booleanOptions') ? aWixFormsV4FormFieldV2InputFieldBooleanInput(overrides.booleanOptions ?? {}, pickedFields.get('booleanOptions')) : aWixFormsV4FormFieldV2InputFieldBooleanInput({}, pickedFields.get('booleanOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('inputType')) {
        result.inputType = overrides && overrides.hasOwnProperty('inputType') ? overrides.inputType! : WixFormsV4FormFieldV2InputFieldInputType.Array;
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOptions')) {
        result.numberOptions = overrides && overrides.hasOwnProperty('numberOptions') ? aWixFormsV4FormFieldV2InputFieldNumberInput(overrides.numberOptions ?? {}, pickedFields.get('numberOptions')) : aWixFormsV4FormFieldV2InputFieldNumberInput({}, pickedFields.get('numberOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('objectOptions')) {
        result.objectOptions = overrides && overrides.hasOwnProperty('objectOptions') ? aWixFormsV4FormFieldV2InputFieldObjectInput(overrides.objectOptions ?? {}, pickedFields.get('objectOptions')) : aWixFormsV4FormFieldV2InputFieldObjectInput({}, pickedFields.get('objectOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOptions')) {
        result.paymentOptions = overrides && overrides.hasOwnProperty('paymentOptions') ? aWixFormsV4FormFieldV2InputFieldPaymentInput(overrides.paymentOptions ?? {}, pickedFields.get('paymentOptions')) : aWixFormsV4FormFieldV2InputFieldPaymentInput({}, pickedFields.get('paymentOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pii')) {
        result.pii = overrides && overrides.hasOwnProperty('pii') ? overrides.pii! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('stringOptions')) {
        result.stringOptions = overrides && overrides.hasOwnProperty('stringOptions') ? aWixFormsV4FormFieldV2InputFieldStringInput(overrides.stringOptions ?? {}, pickedFields.get('stringOptions')) : aWixFormsV4FormFieldV2InputFieldStringInput({}, pickedFields.get('stringOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixFileOptions')) {
        result.wixFileOptions = overrides && overrides.hasOwnProperty('wixFileOptions') ? aWixFormsV4FormFieldV2InputFieldWixFileInput(overrides.wixFileOptions ?? {}, pickedFields.get('wixFileOptions')) : aWixFormsV4FormFieldV2InputFieldWixFileInput({}, pickedFields.get('wixFileOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldIntegerType = <T extends Partial<WixFormsV4FormFieldV2InputFieldIntegerType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [4359];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldNumberErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldNumberErrorMessages({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 9685;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 4722;
    }
    if (pickedFields.size === 0 || pickedFields.has('multipleOf')) {
        result.multipleOf = overrides && overrides.hasOwnProperty('multipleOf') ? overrides.multipleOf! : 7575;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldIntegerTypeInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldIntegerTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [8902];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 8937;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 2427;
    }
    if (pickedFields.size === 0 || pickedFields.has('multipleOf')) {
        result.multipleOf = overrides && overrides.hasOwnProperty('multipleOf') ? overrides.multipleOf! : 3966;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldNumber = <T extends Partial<WixFormsV4FormFieldV2InputFieldNumber>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldNumberComponentType.NumberInput;
    }
    if (pickedFields.size === 0 || pickedFields.has('numberInputOptions')) {
        result.numberInputOptions = overrides && overrides.hasOwnProperty('numberInputOptions') ? aWixFormsV4FormFieldV2InputFieldNumberNumberInput(overrides.numberInputOptions ?? {}, pickedFields.get('numberInputOptions')) : aWixFormsV4FormFieldV2InputFieldNumberNumberInput({}, pickedFields.get('numberInputOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4FormFieldV2InputFieldNumberType(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4FormFieldV2InputFieldNumberType({}, pickedFields.get('validation'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldNumberErrorMessages = <T extends Partial<WixFormsV4FormFieldV2InputFieldNumberErrorMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'natus';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'est';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldNumberInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldNumberInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldNumberComponentType.NumberInput;
    }
    if (pickedFields.size === 0 || pickedFields.has('numberInputOptions')) {
        result.numberInputOptions = overrides && overrides.hasOwnProperty('numberInputOptions') ? aWixFormsV4FormFieldV2InputFieldNumberNumberInputInput(overrides.numberInputOptions ?? {}, pickedFields.get('numberInputOptions')) : aWixFormsV4FormFieldV2InputFieldNumberNumberInputInput({}, pickedFields.get('numberInputOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4FormFieldV2InputFieldNumberTypeInput(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4FormFieldV2InputFieldNumberTypeInput({}, pickedFields.get('validation'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldNumberNumberInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldNumberNumberInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContent(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContent({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : true;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldNumberNumberInputInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldNumberNumberInputInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContentInput(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContentInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : false;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldNumberType = <T extends Partial<WixFormsV4FormFieldV2InputFieldNumberType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [5.84];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldNumberErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldNumberErrorMessages({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 3.51;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 3.73;
    }
    if (pickedFields.size === 0 || pickedFields.has('multipleOf')) {
        result.multipleOf = overrides && overrides.hasOwnProperty('multipleOf') ? overrides.multipleOf! : 2.05;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldNumberTypeInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldNumberTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : [5.99];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 4.7;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 5.75;
    }
    if (pickedFields.size === 0 || pickedFields.has('multipleOf')) {
        result.multipleOf = overrides && overrides.hasOwnProperty('multipleOf') ? overrides.multipleOf! : 8.66;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldObject = <T extends Partial<WixFormsV4FormFieldV2InputFieldObject>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nestedFormId')) {
        result.nestedFormId = overrides && overrides.hasOwnProperty('nestedFormId') ? overrides.nestedFormId! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('object')) {
        result.object = overrides && overrides.hasOwnProperty('object') ? aWixFormsV4FormFieldV2InputFieldObjectType(overrides.object ?? {}, pickedFields.get('object')) : aWixFormsV4FormFieldV2InputFieldObjectType({}, pickedFields.get('object'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldObjectErrorMessages = <T extends Partial<WixFormsV4FormFieldV2InputFieldObjectErrorMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'rem';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldObjectErrorMessagesInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldObjectErrorMessagesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'est';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldObjectInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldObjectInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nestedFormId')) {
        result.nestedFormId = overrides && overrides.hasOwnProperty('nestedFormId') ? overrides.nestedFormId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('object')) {
        result.object = overrides && overrides.hasOwnProperty('object') ? aWixFormsV4FormFieldV2InputFieldObjectTypeInput(overrides.object ?? {}, pickedFields.get('object')) : aWixFormsV4FormFieldV2InputFieldObjectTypeInput({}, pickedFields.get('object'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldObjectType = <T extends Partial<WixFormsV4FormFieldV2InputFieldObjectType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldObjectErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldObjectErrorMessages({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('properties')) {
        result.properties = overrides && overrides.hasOwnProperty('properties') ? aWixFormsV4FormFieldV2InputFieldObjectTypePropertiesType(overrides.properties ?? {}, pickedFields.get('properties')) : aWixFormsV4FormFieldV2InputFieldObjectTypePropertiesType({}, pickedFields.get('properties'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldObjectTypeInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldObjectTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldObjectErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldObjectErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('properties')) {
        result.properties = overrides && overrides.hasOwnProperty('properties') ? aWixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypeInput(overrides.properties ?? {}, pickedFields.get('properties')) : aWixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypeInput({}, pickedFields.get('properties'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldObjectTypePropertiesType = <T extends Partial<WixFormsV4FormFieldV2InputFieldObjectTypePropertiesType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('arrayOptions')) {
        result.arrayOptions = overrides && overrides.hasOwnProperty('arrayOptions') ? aWixFormsV4FormFieldV2InputFieldArrayType(overrides.arrayOptions ?? {}, pickedFields.get('arrayOptions')) : aWixFormsV4FormFieldV2InputFieldArrayType({}, pickedFields.get('arrayOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('booleanOptions')) {
        result.booleanOptions = overrides && overrides.hasOwnProperty('booleanOptions') ? aWixFormsV4FormFieldV2InputFieldBooleanType(overrides.booleanOptions ?? {}, pickedFields.get('booleanOptions')) : aWixFormsV4FormFieldV2InputFieldBooleanType({}, pickedFields.get('booleanOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('integerOptions')) {
        result.integerOptions = overrides && overrides.hasOwnProperty('integerOptions') ? aWixFormsV4FormFieldV2InputFieldIntegerType(overrides.integerOptions ?? {}, pickedFields.get('integerOptions')) : aWixFormsV4FormFieldV2InputFieldIntegerType({}, pickedFields.get('integerOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOptions')) {
        result.numberOptions = overrides && overrides.hasOwnProperty('numberOptions') ? aWixFormsV4FormFieldV2InputFieldNumberType(overrides.numberOptions ?? {}, pickedFields.get('numberOptions')) : aWixFormsV4FormFieldV2InputFieldNumberType({}, pickedFields.get('numberOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('propertiesType')) {
        result.propertiesType = overrides && overrides.hasOwnProperty('propertiesType') ? overrides.propertiesType! : WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypePropertiesType.Array;
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('stringOptions')) {
        result.stringOptions = overrides && overrides.hasOwnProperty('stringOptions') ? aWixFormsV4FormFieldV2InputFieldStringType(overrides.stringOptions ?? {}, pickedFields.get('stringOptions')) : aWixFormsV4FormFieldV2InputFieldStringType({}, pickedFields.get('stringOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypeInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('arrayOptions')) {
        result.arrayOptions = overrides && overrides.hasOwnProperty('arrayOptions') ? aWixFormsV4FormFieldV2InputFieldArrayTypeInput(overrides.arrayOptions ?? {}, pickedFields.get('arrayOptions')) : aWixFormsV4FormFieldV2InputFieldArrayTypeInput({}, pickedFields.get('arrayOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('booleanOptions')) {
        result.booleanOptions = overrides && overrides.hasOwnProperty('booleanOptions') ? aWixFormsV4FormFieldV2InputFieldBooleanTypeInput(overrides.booleanOptions ?? {}, pickedFields.get('booleanOptions')) : aWixFormsV4FormFieldV2InputFieldBooleanTypeInput({}, pickedFields.get('booleanOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('integerOptions')) {
        result.integerOptions = overrides && overrides.hasOwnProperty('integerOptions') ? aWixFormsV4FormFieldV2InputFieldIntegerTypeInput(overrides.integerOptions ?? {}, pickedFields.get('integerOptions')) : aWixFormsV4FormFieldV2InputFieldIntegerTypeInput({}, pickedFields.get('integerOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOptions')) {
        result.numberOptions = overrides && overrides.hasOwnProperty('numberOptions') ? aWixFormsV4FormFieldV2InputFieldNumberTypeInput(overrides.numberOptions ?? {}, pickedFields.get('numberOptions')) : aWixFormsV4FormFieldV2InputFieldNumberTypeInput({}, pickedFields.get('numberOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('propertiesType')) {
        result.propertiesType = overrides && overrides.hasOwnProperty('propertiesType') ? overrides.propertiesType! : WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypePropertiesType.Array;
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('stringOptions')) {
        result.stringOptions = overrides && overrides.hasOwnProperty('stringOptions') ? aWixFormsV4FormFieldV2InputFieldStringTypeInput(overrides.stringOptions ?? {}, pickedFields.get('stringOptions')) : aWixFormsV4FormFieldV2InputFieldStringTypeInput({}, pickedFields.get('stringOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldPayment = <T extends Partial<WixFormsV4FormFieldV2InputFieldPayment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkboxGroupOptions')) {
        result.checkboxGroupOptions = overrides && overrides.hasOwnProperty('checkboxGroupOptions') ? aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroup(overrides.checkboxGroupOptions ?? {}, pickedFields.get('checkboxGroupOptions')) : aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroup({}, pickedFields.get('checkboxGroupOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldPaymentComponentType.CheckboxGroup;
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4PaymentType(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4PaymentType({}, pickedFields.get('validation'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroup = <T extends Partial<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroup>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContent(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContent({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'quae';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options!.map((x) => aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOption(x ?? {}, pickedFields.get('options'))) : [aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOption({}, pickedFields.get('options'))];
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContentInput(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContentInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options!.map((x) => aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOptionInput({}, pickedFields.get('options'))) : [aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOptionInput({}, pickedFields.get('options'))];
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOption = <T extends Partial<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixFormsV4FormFieldV2MediaItem(overrides.media ?? {}, pickedFields.get('media')) : aWixFormsV4FormFieldV2MediaItem({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'esse';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOptionInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixFormsV4FormFieldV2MediaItemInput(overrides.media ?? {}, pickedFields.get('media')) : aWixFormsV4FormFieldV2MediaItemInput({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'adipisci';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldPaymentInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldPaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('checkboxGroupOptions')) {
        result.checkboxGroupOptions = overrides && overrides.hasOwnProperty('checkboxGroupOptions') ? aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupInput(overrides.checkboxGroupOptions ?? {}, pickedFields.get('checkboxGroupOptions')) : aWixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupInput({}, pickedFields.get('checkboxGroupOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldPaymentComponentType.CheckboxGroup;
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4PaymentTypeInput(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4PaymentTypeInput({}, pickedFields.get('validation'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldString = <T extends Partial<WixFormsV4FormFieldV2InputFieldString>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldStringComponentType.Dropdown;
    }
    if (pickedFields.size === 0 || pickedFields.has('dropdownOptions')) {
        result.dropdownOptions = overrides && overrides.hasOwnProperty('dropdownOptions') ? aWixFormsV4FormFieldV2InputFieldStringDropdown(overrides.dropdownOptions ?? {}, pickedFields.get('dropdownOptions')) : aWixFormsV4FormFieldV2InputFieldStringDropdown({}, pickedFields.get('dropdownOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('radioGroupOptions')) {
        result.radioGroupOptions = overrides && overrides.hasOwnProperty('radioGroupOptions') ? aWixFormsV4FormFieldV2InputFieldStringRadioGroup(overrides.radioGroupOptions ?? {}, pickedFields.get('radioGroupOptions')) : aWixFormsV4FormFieldV2InputFieldStringRadioGroup({}, pickedFields.get('radioGroupOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('textInputOptions')) {
        result.textInputOptions = overrides && overrides.hasOwnProperty('textInputOptions') ? aWixFormsV4FormFieldV2InputFieldStringTextInput(overrides.textInputOptions ?? {}, pickedFields.get('textInputOptions')) : aWixFormsV4FormFieldV2InputFieldStringTextInput({}, pickedFields.get('textInputOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4FormFieldV2InputFieldStringType(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4FormFieldV2InputFieldStringType({}, pickedFields.get('validation'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringDropDownCustomOption = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringDropDownCustomOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'fugiat';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringDropDownCustomOptionInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringDropDownCustomOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'laboriosam';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringDropDownOption = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringDropDownOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'magni';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringDropDownOptionInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringDropDownOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'doloremque';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringDropdown = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringDropdown>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customOption')) {
        result.customOption = overrides && overrides.hasOwnProperty('customOption') ? aWixFormsV4FormFieldV2InputFieldStringDropdownCustomOption(overrides.customOption ?? {}, pickedFields.get('customOption')) : aWixFormsV4FormFieldV2InputFieldStringDropdownCustomOption({}, pickedFields.get('customOption'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContent(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContent({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options!.map((x) => aWixFormsV4FormFieldV2InputFieldStringDropdownOption(x ?? {}, pickedFields.get('options'))) : [aWixFormsV4FormFieldV2InputFieldStringDropdownOption({}, pickedFields.get('options'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : true;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringDropdownCustomOption = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringDropdownCustomOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'similique';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringDropdownCustomOptionInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringDropdownCustomOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'modi';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringDropdownInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringDropdownInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customOption')) {
        result.customOption = overrides && overrides.hasOwnProperty('customOption') ? aWixFormsV4FormFieldV2InputFieldStringDropdownCustomOptionInput(overrides.customOption ?? {}, pickedFields.get('customOption')) : aWixFormsV4FormFieldV2InputFieldStringDropdownCustomOptionInput({}, pickedFields.get('customOption'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContentInput(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContentInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options!.map((x) => aWixFormsV4FormFieldV2InputFieldStringDropdownOptionInput({}, pickedFields.get('options'))) : [aWixFormsV4FormFieldV2InputFieldStringDropdownOptionInput({}, pickedFields.get('options'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : false;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringDropdownOption = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringDropdownOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'repellendus';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringDropdownOptionInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringDropdownOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'quia';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringErrorMessages = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringErrorMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'rerum';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringErrorMessagesInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringErrorMessagesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : 'nihil';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldStringComponentType.Dropdown;
    }
    if (pickedFields.size === 0 || pickedFields.has('dropdownOptions')) {
        result.dropdownOptions = overrides && overrides.hasOwnProperty('dropdownOptions') ? aWixFormsV4FormFieldV2InputFieldStringDropdownInput(overrides.dropdownOptions ?? {}, pickedFields.get('dropdownOptions')) : aWixFormsV4FormFieldV2InputFieldStringDropdownInput({}, pickedFields.get('dropdownOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('radioGroupOptions')) {
        result.radioGroupOptions = overrides && overrides.hasOwnProperty('radioGroupOptions') ? aWixFormsV4FormFieldV2InputFieldStringRadioGroupInput(overrides.radioGroupOptions ?? {}, pickedFields.get('radioGroupOptions')) : aWixFormsV4FormFieldV2InputFieldStringRadioGroupInput({}, pickedFields.get('radioGroupOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('textInputOptions')) {
        result.textInputOptions = overrides && overrides.hasOwnProperty('textInputOptions') ? aWixFormsV4FormFieldV2InputFieldStringTextInputInput(overrides.textInputOptions ?? {}, pickedFields.get('textInputOptions')) : aWixFormsV4FormFieldV2InputFieldStringTextInputInput({}, pickedFields.get('textInputOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('validation')) {
        result.validation = overrides && overrides.hasOwnProperty('validation') ? aWixFormsV4FormFieldV2InputFieldStringTypeInput(overrides.validation ?? {}, pickedFields.get('validation')) : aWixFormsV4FormFieldV2InputFieldStringTypeInput({}, pickedFields.get('validation'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringRadioGroup = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringRadioGroup>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customOption')) {
        result.customOption = overrides && overrides.hasOwnProperty('customOption') ? aWixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOption(overrides.customOption ?? {}, pickedFields.get('customOption')) : aWixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOption({}, pickedFields.get('customOption'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContent(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContent({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options!.map((x) => aWixFormsV4FormFieldV2InputFieldStringRadioGroupOption(x ?? {}, pickedFields.get('options'))) : [aWixFormsV4FormFieldV2InputFieldStringRadioGroupOption({}, pickedFields.get('options'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : false;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOption = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'quo';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOptionInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'laudantium';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringRadioGroupInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringRadioGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customOption')) {
        result.customOption = overrides && overrides.hasOwnProperty('customOption') ? aWixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOptionInput(overrides.customOption ?? {}, pickedFields.get('customOption')) : aWixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOptionInput({}, pickedFields.get('customOption'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContentInput(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContentInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options!.map((x) => aWixFormsV4FormFieldV2InputFieldStringRadioGroupOptionInput({}, pickedFields.get('options'))) : [aWixFormsV4FormFieldV2InputFieldStringRadioGroupOptionInput({}, pickedFields.get('options'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : true;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringRadioGroupOption = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringRadioGroupOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'distinctio';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringRadioGroupOptionInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringRadioGroupOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('default')) {
        result.default = overrides && overrides.hasOwnProperty('default') ? overrides.default! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'sed';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringTextInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringTextInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContent(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContent({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : false;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringTextInputInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringTextInputInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContentInput(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContentInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('placeholder')) {
        result.placeholder = overrides && overrides.hasOwnProperty('placeholder') ? overrides.placeholder! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : true;
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringType = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : ['consequatur'];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldStringErrorMessages(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldStringErrorMessages({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : WixFormsV4FormFieldV2InputFieldStringTypeFormatEnumFormat.ColorHex;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxLength')) {
        result.maxLength = overrides && overrides.hasOwnProperty('maxLength') ? overrides.maxLength! : 9657;
    }
    if (pickedFields.size === 0 || pickedFields.has('minLength')) {
        result.minLength = overrides && overrides.hasOwnProperty('minLength') ? overrides.minLength! : 8113;
    }
    if (pickedFields.size === 0 || pickedFields.has('pattern')) {
        result.pattern = overrides && overrides.hasOwnProperty('pattern') ? overrides.pattern! : 'sit';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldStringTypeInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldStringTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enum')) {
        result.enum = overrides && overrides.hasOwnProperty('enum') ? overrides.enum! : ['repudiandae'];
    }
    if (pickedFields.size === 0 || pickedFields.has('errorMessages')) {
        result.errorMessages = overrides && overrides.hasOwnProperty('errorMessages') ? aWixFormsV4FormFieldV2InputFieldStringErrorMessagesInput(overrides.errorMessages ?? {}, pickedFields.get('errorMessages')) : aWixFormsV4FormFieldV2InputFieldStringErrorMessagesInput({}, pickedFields.get('errorMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : WixFormsV4FormFieldV2InputFieldStringTypeFormatEnumFormat.ColorHex;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxLength')) {
        result.maxLength = overrides && overrides.hasOwnProperty('maxLength') ? overrides.maxLength! : 7184;
    }
    if (pickedFields.size === 0 || pickedFields.has('minLength')) {
        result.minLength = overrides && overrides.hasOwnProperty('minLength') ? overrides.minLength! : 1581;
    }
    if (pickedFields.size === 0 || pickedFields.has('pattern')) {
        result.pattern = overrides && overrides.hasOwnProperty('pattern') ? overrides.pattern! : 'libero';
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldWixFile = <T extends Partial<WixFormsV4FormFieldV2InputFieldWixFile>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldWixFileComponentType.FileUpload;
    }
    if (pickedFields.size === 0 || pickedFields.has('fileUploadOptions')) {
        result.fileUploadOptions = overrides && overrides.hasOwnProperty('fileUploadOptions') ? aWixFormsV4FormFieldV2InputFieldWixFileFileUpload(overrides.fileUploadOptions ?? {}, pickedFields.get('fileUploadOptions')) : aWixFormsV4FormFieldV2InputFieldWixFileFileUpload({}, pickedFields.get('fileUploadOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldWixFileFileUpload = <T extends Partial<WixFormsV4FormFieldV2InputFieldWixFileFileUpload>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buttonText')) {
        result.buttonText = overrides && overrides.hasOwnProperty('buttonText') ? overrides.buttonText! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContent(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContent({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('explanationText')) {
        result.explanationText = overrides && overrides.hasOwnProperty('explanationText') ? overrides.explanationText! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('fileLimit')) {
        result.fileLimit = overrides && overrides.hasOwnProperty('fileLimit') ? overrides.fileLimit! : 9451;
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('uploadFileFormats')) {
        result.uploadFileFormats = overrides && overrides.hasOwnProperty('uploadFileFormats') ? overrides.uploadFileFormats! : [WixFormsV4FormFieldV2InputFieldWixFileFileUploadUploadFileFormatEnumUploadFileFormat.Audio];
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldWixFileFileUploadInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldWixFileFileUploadInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buttonText')) {
        result.buttonText = overrides && overrides.hasOwnProperty('buttonText') ? overrides.buttonText! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixRichContentV1RichContentInput(overrides.description ?? {}, pickedFields.get('description')) : aWixRichContentV1RichContentInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('explanationText')) {
        result.explanationText = overrides && overrides.hasOwnProperty('explanationText') ? overrides.explanationText! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('fileLimit')) {
        result.fileLimit = overrides && overrides.hasOwnProperty('fileLimit') ? overrides.fileLimit! : 8978;
    }
    if (pickedFields.size === 0 || pickedFields.has('label')) {
        result.label = overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('showLabel')) {
        result.showLabel = overrides && overrides.hasOwnProperty('showLabel') ? overrides.showLabel! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('uploadFileFormats')) {
        result.uploadFileFormats = overrides && overrides.hasOwnProperty('uploadFileFormats') ? overrides.uploadFileFormats! : [WixFormsV4FormFieldV2InputFieldWixFileFileUploadUploadFileFormatEnumUploadFileFormat.Audio];
    }

    return result;
};

export const aWixFormsV4FormFieldV2InputFieldWixFileInput = <T extends Partial<WixFormsV4FormFieldV2InputFieldWixFileInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('componentType')) {
        result.componentType = overrides && overrides.hasOwnProperty('componentType') ? overrides.componentType! : WixFormsV4FormFieldV2InputFieldWixFileComponentType.FileUpload;
    }
    if (pickedFields.size === 0 || pickedFields.has('fileUploadOptions')) {
        result.fileUploadOptions = overrides && overrides.hasOwnProperty('fileUploadOptions') ? aWixFormsV4FormFieldV2InputFieldWixFileFileUploadInput(overrides.fileUploadOptions ?? {}, pickedFields.get('fileUploadOptions')) : aWixFormsV4FormFieldV2InputFieldWixFileFileUploadInput({}, pickedFields.get('fileUploadOptions'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2MediaItem = <T extends Partial<WixFormsV4FormFieldV2MediaItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixFormsUpstreamWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aComWixFormsUpstreamWixCommonImage({}, pickedFields.get('image'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2MediaItemInput = <T extends Partial<WixFormsV4FormFieldV2MediaItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aComWixFormsUpstreamWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aComWixFormsUpstreamWixCommonImageInput({}, pickedFields.get('image'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2SubmitButton = <T extends Partial<WixFormsV4FormFieldV2SubmitButton>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nextText')) {
        result.nextText = overrides && overrides.hasOwnProperty('nextText') ? overrides.nextText! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('previousText')) {
        result.previousText = overrides && overrides.hasOwnProperty('previousText') ? overrides.previousText! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('redirect')) {
        result.redirect = overrides && overrides.hasOwnProperty('redirect') ? aWixFormsV4FormFieldV2SubmitButtonRedirect(overrides.redirect ?? {}, pickedFields.get('redirect')) : aWixFormsV4FormFieldV2SubmitButtonRedirect({}, pickedFields.get('redirect'));
    }
    if (pickedFields.size === 0 || pickedFields.has('submitText')) {
        result.submitText = overrides && overrides.hasOwnProperty('submitText') ? overrides.submitText! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('thankYouMessage')) {
        result.thankYouMessage = overrides && overrides.hasOwnProperty('thankYouMessage') ? aWixFormsV4FormFieldV2SubmitButtonThankYouMessage(overrides.thankYouMessage ?? {}, pickedFields.get('thankYouMessage')) : aWixFormsV4FormFieldV2SubmitButtonThankYouMessage({}, pickedFields.get('thankYouMessage'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2SubmitButtonInput = <T extends Partial<WixFormsV4FormFieldV2SubmitButtonInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nextText')) {
        result.nextText = overrides && overrides.hasOwnProperty('nextText') ? overrides.nextText! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('previousText')) {
        result.previousText = overrides && overrides.hasOwnProperty('previousText') ? overrides.previousText! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('redirect')) {
        result.redirect = overrides && overrides.hasOwnProperty('redirect') ? aWixFormsV4FormFieldV2SubmitButtonRedirectInput(overrides.redirect ?? {}, pickedFields.get('redirect')) : aWixFormsV4FormFieldV2SubmitButtonRedirectInput({}, pickedFields.get('redirect'));
    }
    if (pickedFields.size === 0 || pickedFields.has('submitText')) {
        result.submitText = overrides && overrides.hasOwnProperty('submitText') ? overrides.submitText! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('thankYouMessage')) {
        result.thankYouMessage = overrides && overrides.hasOwnProperty('thankYouMessage') ? aWixFormsV4FormFieldV2SubmitButtonThankYouMessageInput(overrides.thankYouMessage ?? {}, pickedFields.get('thankYouMessage')) : aWixFormsV4FormFieldV2SubmitButtonThankYouMessageInput({}, pickedFields.get('thankYouMessage'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2SubmitButtonRedirect = <T extends Partial<WixFormsV4FormFieldV2SubmitButtonRedirect>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : WixFormsV4FormFieldV2SubmitButtonRedirectTargetEnumTarget.Blank;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'maiores';
    }

    return result;
};

export const aWixFormsV4FormFieldV2SubmitButtonRedirectInput = <T extends Partial<WixFormsV4FormFieldV2SubmitButtonRedirectInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : WixFormsV4FormFieldV2SubmitButtonRedirectTargetEnumTarget.Blank;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'a';
    }

    return result;
};

export const aWixFormsV4FormFieldV2SubmitButtonThankYouMessage = <T extends Partial<WixFormsV4FormFieldV2SubmitButtonThankYouMessage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('duration')) {
        result.duration = overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 7176;
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? aWixRichContentV1RichContent(overrides.text ?? {}, pickedFields.get('text')) : aWixRichContentV1RichContent({}, pickedFields.get('text'));
    }

    return result;
};

export const aWixFormsV4FormFieldV2SubmitButtonThankYouMessageInput = <T extends Partial<WixFormsV4FormFieldV2SubmitButtonThankYouMessageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('duration')) {
        result.duration = overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 5189;
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? aWixRichContentV1RichContentInput(overrides.text ?? {}, pickedFields.get('text')) : aWixRichContentV1RichContentInput({}, pickedFields.get('text'));
    }

    return result;
};

export const aWixFormsV4FormFieldValidation = <T extends Partial<WixFormsV4FormFieldValidation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('array')) {
        result.array = overrides && overrides.hasOwnProperty('array') ? aWixFormsV4FormFieldArrayType(overrides.array ?? {}, pickedFields.get('array')) : aWixFormsV4FormFieldArrayType({}, pickedFields.get('array'));
    }
    if (pickedFields.size === 0 || pickedFields.has('boolean')) {
        result.boolean = overrides && overrides.hasOwnProperty('boolean') ? aWixFormsV4FormFieldBooleanType(overrides.boolean ?? {}, pickedFields.get('boolean')) : aWixFormsV4FormFieldBooleanType({}, pickedFields.get('boolean'));
    }
    if (pickedFields.size === 0 || pickedFields.has('integer')) {
        result.integer = overrides && overrides.hasOwnProperty('integer') ? aWixFormsV4FormFieldIntegerType(overrides.integer ?? {}, pickedFields.get('integer')) : aWixFormsV4FormFieldIntegerType({}, pickedFields.get('integer'));
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? aWixFormsV4FormFieldNumberType(overrides.number ?? {}, pickedFields.get('number')) : aWixFormsV4FormFieldNumberType({}, pickedFields.get('number'));
    }
    if (pickedFields.size === 0 || pickedFields.has('object')) {
        result.object = overrides && overrides.hasOwnProperty('object') ? aWixFormsV4FormFieldObjectType(overrides.object ?? {}, pickedFields.get('object')) : aWixFormsV4FormFieldObjectType({}, pickedFields.get('object'));
    }
    if (pickedFields.size === 0 || pickedFields.has('predefined')) {
        result.predefined = overrides && overrides.hasOwnProperty('predefined') ? aWixFormsV4FormFieldPredefinedValidation(overrides.predefined ?? {}, pickedFields.get('predefined')) : aWixFormsV4FormFieldPredefinedValidation({}, pickedFields.get('predefined'));
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('string')) {
        result.string = overrides && overrides.hasOwnProperty('string') ? aWixFormsV4FormFieldStringType(overrides.string ?? {}, pickedFields.get('string')) : aWixFormsV4FormFieldStringType({}, pickedFields.get('string'));
    }

    return result;
};

export const aWixFormsV4FormFieldValidationInput = <T extends Partial<WixFormsV4FormFieldValidationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('array')) {
        result.array = overrides && overrides.hasOwnProperty('array') ? aWixFormsV4FormFieldArrayTypeInput(overrides.array ?? {}, pickedFields.get('array')) : aWixFormsV4FormFieldArrayTypeInput({}, pickedFields.get('array'));
    }
    if (pickedFields.size === 0 || pickedFields.has('boolean')) {
        result.boolean = overrides && overrides.hasOwnProperty('boolean') ? aWixFormsV4FormFieldBooleanTypeInput(overrides.boolean ?? {}, pickedFields.get('boolean')) : aWixFormsV4FormFieldBooleanTypeInput({}, pickedFields.get('boolean'));
    }
    if (pickedFields.size === 0 || pickedFields.has('integer')) {
        result.integer = overrides && overrides.hasOwnProperty('integer') ? aWixFormsV4FormFieldIntegerTypeInput(overrides.integer ?? {}, pickedFields.get('integer')) : aWixFormsV4FormFieldIntegerTypeInput({}, pickedFields.get('integer'));
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? aWixFormsV4FormFieldNumberTypeInput(overrides.number ?? {}, pickedFields.get('number')) : aWixFormsV4FormFieldNumberTypeInput({}, pickedFields.get('number'));
    }
    if (pickedFields.size === 0 || pickedFields.has('object')) {
        result.object = overrides && overrides.hasOwnProperty('object') ? aWixFormsV4FormFieldObjectTypeInput(overrides.object ?? {}, pickedFields.get('object')) : aWixFormsV4FormFieldObjectTypeInput({}, pickedFields.get('object'));
    }
    if (pickedFields.size === 0 || pickedFields.has('predefined')) {
        result.predefined = overrides && overrides.hasOwnProperty('predefined') ? aWixFormsV4FormFieldPredefinedValidationInput(overrides.predefined ?? {}, pickedFields.get('predefined')) : aWixFormsV4FormFieldPredefinedValidationInput({}, pickedFields.get('predefined'));
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('string')) {
        result.string = overrides && overrides.hasOwnProperty('string') ? aWixFormsV4FormFieldStringTypeInput(overrides.string ?? {}, pickedFields.get('string')) : aWixFormsV4FormFieldStringTypeInput({}, pickedFields.get('string'));
    }

    return result;
};

export const aWixFormsV4FormFormProperties = <T extends Partial<WixFormsV4FormFormProperties>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('disabled')) {
        result.disabled = overrides && overrides.hasOwnProperty('disabled') ? overrides.disabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'voluptas';
    }

    return result;
};

export const aWixFormsV4FormFormPropertiesInput = <T extends Partial<WixFormsV4FormFormPropertiesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('disabled')) {
        result.disabled = overrides && overrides.hasOwnProperty('disabled') ? overrides.disabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'facilis';
    }

    return result;
};

export const aWixFormsV4FormInput = <T extends Partial<WixFormsV4FormInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('deletedFields')) {
        result.deletedFields = overrides && overrides.hasOwnProperty('deletedFields') ? overrides.deletedFields!.map((x) => aWixFormsV4FormFieldInput({}, pickedFields.get('deletedFields'))) : [aWixFormsV4FormFieldInput({}, pickedFields.get('deletedFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('deletedFieldsV2')) {
        result.deletedFieldsV2 = overrides && overrides.hasOwnProperty('deletedFieldsV2') ? overrides.deletedFieldsV2!.map((x) => aWixFormsV4FormFieldV2Input({}, pickedFields.get('deletedFieldsV2'))) : [aWixFormsV4FormFieldV2Input({}, pickedFields.get('deletedFieldsV2'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields!.map((x) => aWixFormsV4FormFieldInput({}, pickedFields.get('fields'))) : [aWixFormsV4FormFieldInput({}, pickedFields.get('fields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsV2')) {
        result.fieldsV2 = overrides && overrides.hasOwnProperty('fieldsV2') ? overrides.fieldsV2!.map((x) => aWixFormsV4FormFieldV2Input({}, pickedFields.get('fieldsV2'))) : [aWixFormsV4FormFieldV2Input({}, pickedFields.get('fieldsV2'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('kind')) {
        result.kind = overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : WixFormsV4FormKindKind.Extension;
    }
    if (pickedFields.size === 0 || pickedFields.has('mediaFolderId')) {
        result.mediaFolderId = overrides && overrides.hasOwnProperty('mediaFolderId') ? overrides.mediaFolderId! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('nestedForms')) {
        result.nestedForms = overrides && overrides.hasOwnProperty('nestedForms') ? overrides.nestedForms!.map((x) => aWixFormsV4FormNestedFormInput({}, pickedFields.get('nestedForms'))) : [aWixFormsV4FormNestedFormInput({}, pickedFields.get('nestedForms'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('postSubmissionTriggers')) {
        result.postSubmissionTriggers = overrides && overrides.hasOwnProperty('postSubmissionTriggers') ? aWixFormsV4PostSubmissionTriggersInput(overrides.postSubmissionTriggers ?? {}, pickedFields.get('postSubmissionTriggers')) : aWixFormsV4PostSubmissionTriggersInput({}, pickedFields.get('postSubmissionTriggers'));
    }
    if (pickedFields.size === 0 || pickedFields.has('properties')) {
        result.properties = overrides && overrides.hasOwnProperty('properties') ? aWixFormsV4FormFormPropertiesInput(overrides.properties ?? {}, pickedFields.get('properties')) : aWixFormsV4FormFormPropertiesInput({}, pickedFields.get('properties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 9145;
    }
    if (pickedFields.size === 0 || pickedFields.has('rules')) {
        result.rules = overrides && overrides.hasOwnProperty('rules') ? overrides.rules!.map((x) => aWixFormsV4FormRuleInput({}, pickedFields.get('rules'))) : [aWixFormsV4FormRuleInput({}, pickedFields.get('rules'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('steps')) {
        result.steps = overrides && overrides.hasOwnProperty('steps') ? overrides.steps!.map((x) => aWixFormsV4StepInput({}, pickedFields.get('steps'))) : [aWixFormsV4StepInput({}, pickedFields.get('steps'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'cumque';
    }

    return result;
};

export const aWixFormsV4FormLayout = <T extends Partial<WixFormsV4FormLayout>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('large')) {
        result.large = overrides && overrides.hasOwnProperty('large') ? aWixFormsV4BreakPoint(overrides.large ?? {}, pickedFields.get('large')) : aWixFormsV4BreakPoint({}, pickedFields.get('large'));
    }
    if (pickedFields.size === 0 || pickedFields.has('medium')) {
        result.medium = overrides && overrides.hasOwnProperty('medium') ? aWixFormsV4BreakPoint(overrides.medium ?? {}, pickedFields.get('medium')) : aWixFormsV4BreakPoint({}, pickedFields.get('medium'));
    }
    if (pickedFields.size === 0 || pickedFields.has('small')) {
        result.small = overrides && overrides.hasOwnProperty('small') ? aWixFormsV4BreakPoint(overrides.small ?? {}, pickedFields.get('small')) : aWixFormsV4BreakPoint({}, pickedFields.get('small'));
    }

    return result;
};

export const aWixFormsV4FormLayoutInput = <T extends Partial<WixFormsV4FormLayoutInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('large')) {
        result.large = overrides && overrides.hasOwnProperty('large') ? aWixFormsV4BreakPointInput(overrides.large ?? {}, pickedFields.get('large')) : aWixFormsV4BreakPointInput({}, pickedFields.get('large'));
    }
    if (pickedFields.size === 0 || pickedFields.has('medium')) {
        result.medium = overrides && overrides.hasOwnProperty('medium') ? aWixFormsV4BreakPointInput(overrides.medium ?? {}, pickedFields.get('medium')) : aWixFormsV4BreakPointInput({}, pickedFields.get('medium'));
    }
    if (pickedFields.size === 0 || pickedFields.has('small')) {
        result.small = overrides && overrides.hasOwnProperty('small') ? aWixFormsV4BreakPointInput(overrides.small ?? {}, pickedFields.get('small')) : aWixFormsV4BreakPointInput({}, pickedFields.get('small'));
    }

    return result;
};

export const aWixFormsV4FormNestedForm = <T extends Partial<WixFormsV4FormNestedForm>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4Form(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4Form({}, pickedFields.get('form'));
    }
    if (pickedFields.size === 0 || pickedFields.has('targets')) {
        result.targets = overrides && overrides.hasOwnProperty('targets') ? overrides.targets! : ['labore'];
    }

    return result;
};

export const aWixFormsV4FormNestedFormInput = <T extends Partial<WixFormsV4FormNestedFormInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4FormInput(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4FormInput({}, pickedFields.get('form'));
    }
    if (pickedFields.size === 0 || pickedFields.has('targets')) {
        result.targets = overrides && overrides.hasOwnProperty('targets') ? overrides.targets! : ['repellendus'];
    }

    return result;
};

export const aWixFormsV4FormRule = <T extends Partial<WixFormsV4FormRule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('condition')) {
        result.condition = overrides && overrides.hasOwnProperty('condition') ? overrides.condition! : 'cupiditate';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('overrides')) {
        result.overrides = overrides && overrides.hasOwnProperty('overrides') ? overrides.overrides!.map((x) => aWixFormsV4FormRuleFormOverride(x ?? {}, pickedFields.get('overrides'))) : [aWixFormsV4FormRuleFormOverride({}, pickedFields.get('overrides'))];
    }

    return result;
};

export const aWixFormsV4FormRuleFormOverride = <T extends Partial<WixFormsV4FormRuleFormOverride>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('entityId')) {
        result.entityId = overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('entityType')) {
        result.entityType = overrides && overrides.hasOwnProperty('entityType') ? overrides.entityType! : WixFormsV4FormRuleFormOverrideOverrideEntityTypeEnumOverrideEntityType.Field;
    }
    if (pickedFields.size === 0 || pickedFields.has('valueChanges')) {
        result.valueChanges = overrides && overrides.hasOwnProperty('valueChanges') ? overrides.valueChanges! : 'qui';
    }

    return result;
};

export const aWixFormsV4FormRuleFormOverrideInput = <T extends Partial<WixFormsV4FormRuleFormOverrideInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('entityId')) {
        result.entityId = overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('entityType')) {
        result.entityType = overrides && overrides.hasOwnProperty('entityType') ? overrides.entityType! : WixFormsV4FormRuleFormOverrideOverrideEntityTypeEnumOverrideEntityType.Field;
    }
    if (pickedFields.size === 0 || pickedFields.has('valueChanges')) {
        result.valueChanges = overrides && overrides.hasOwnProperty('valueChanges') ? overrides.valueChanges! : 'necessitatibus';
    }

    return result;
};

export const aWixFormsV4FormRuleInput = <T extends Partial<WixFormsV4FormRuleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('condition')) {
        result.condition = overrides && overrides.hasOwnProperty('condition') ? overrides.condition! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('overrides')) {
        result.overrides = overrides && overrides.hasOwnProperty('overrides') ? overrides.overrides!.map((x) => aWixFormsV4FormRuleFormOverrideInput({}, pickedFields.get('overrides'))) : [aWixFormsV4FormRuleFormOverrideInput({}, pickedFields.get('overrides'))];
    }

    return result;
};

export const aWixFormsV4GetDeletedFormRequestInput = <T extends Partial<WixFormsV4GetDeletedFormRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('formId')) {
        result.formId = overrides && overrides.hasOwnProperty('formId') ? overrides.formId! : 'reiciendis';
    }

    return result;
};

export const aWixFormsV4GetDeletedFormResponse = <T extends Partial<WixFormsV4GetDeletedFormResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4Form(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4Form({}, pickedFields.get('form'));
    }

    return result;
};

export const aWixFormsV4GetFormRequestInput = <T extends Partial<WixFormsV4GetFormRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [WixFormsV4FormFieldsetFieldset.NestedForms];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f7f73181-032e-4a57-be8d-cb564ae2595a';
    }

    return result;
};

export const aWixFormsV4ItemLayout = <T extends Partial<WixFormsV4ItemLayout>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('column')) {
        result.column = overrides && overrides.hasOwnProperty('column') ? overrides.column! : 4316;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldId')) {
        result.fieldId = overrides && overrides.hasOwnProperty('fieldId') ? overrides.fieldId! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 4720;
    }
    if (pickedFields.size === 0 || pickedFields.has('row')) {
        result.row = overrides && overrides.hasOwnProperty('row') ? overrides.row! : 4473;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 4029;
    }

    return result;
};

export const aWixFormsV4ItemLayoutInput = <T extends Partial<WixFormsV4ItemLayoutInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('column')) {
        result.column = overrides && overrides.hasOwnProperty('column') ? overrides.column! : 6988;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldId')) {
        result.fieldId = overrides && overrides.hasOwnProperty('fieldId') ? overrides.fieldId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 7648;
    }
    if (pickedFields.size === 0 || pickedFields.has('row')) {
        result.row = overrides && overrides.hasOwnProperty('row') ? overrides.row! : 8318;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 6700;
    }

    return result;
};

export const aWixFormsV4ListDeletedFormsRequestInput = <T extends Partial<WixFormsV4ListDeletedFormsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('disabled')) {
        result.disabled = overrides && overrides.hasOwnProperty('disabled') ? overrides.disabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('formIds')) {
        result.formIds = overrides && overrides.hasOwnProperty('formIds') ? overrides.formIds! : ['ex'];
    }
    if (pickedFields.size === 0 || pickedFields.has('kind')) {
        result.kind = overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : WixFormsV4FormKindKind.Extension;
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixFormsV4ListDeletedFormsRequestListDeletedFormsOrder.NameAsc;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aWixFormsV4ListDeletedFormsResponse = <T extends Partial<WixFormsV4ListDeletedFormsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('forms')) {
        result.forms = overrides && overrides.hasOwnProperty('forms') ? overrides.forms!.map((x) => aWixFormsV4Form(x ?? {}, pickedFields.get('forms'))) : [aWixFormsV4Form({}, pickedFields.get('forms'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixFormsV4ListFormsRequestInput = <T extends Partial<WixFormsV4ListFormsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('disabled')) {
        result.disabled = overrides && overrides.hasOwnProperty('disabled') ? overrides.disabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [WixFormsV4FormFieldsetFieldset.NestedForms];
    }
    if (pickedFields.size === 0 || pickedFields.has('formIds')) {
        result.formIds = overrides && overrides.hasOwnProperty('formIds') ? overrides.formIds! : ['sit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('kind')) {
        result.kind = overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : WixFormsV4FormKindKind.Extension;
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixFormsV4ListFormsRequestListFormsOrder.CreatedDateAsc;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aWixFormsV4ListFormsResponse = <T extends Partial<WixFormsV4ListFormsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('forms')) {
        result.forms = overrides && overrides.hasOwnProperty('forms') ? overrides.forms!.map((x) => aWixFormsV4Form(x ?? {}, pickedFields.get('forms'))) : [aWixFormsV4Form({}, pickedFields.get('forms'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aComWixFormsUpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aComWixFormsUpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixFormsV4PaymentType = <T extends Partial<WixFormsV4PaymentType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxItems')) {
        result.maxItems = overrides && overrides.hasOwnProperty('maxItems') ? overrides.maxItems! : 4138;
    }
    if (pickedFields.size === 0 || pickedFields.has('minItems')) {
        result.minItems = overrides && overrides.hasOwnProperty('minItems') ? overrides.minItems! : 8351;
    }
    if (pickedFields.size === 0 || pickedFields.has('products')) {
        result.products = overrides && overrides.hasOwnProperty('products') ? overrides.products!.map((x) => aWixFormsV4PaymentTypeProduct(x ?? {}, pickedFields.get('products'))) : [aWixFormsV4PaymentTypeProduct({}, pickedFields.get('products'))];
    }

    return result;
};

export const aWixFormsV4PaymentTypeInput = <T extends Partial<WixFormsV4PaymentTypeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxItems')) {
        result.maxItems = overrides && overrides.hasOwnProperty('maxItems') ? overrides.maxItems! : 4046;
    }
    if (pickedFields.size === 0 || pickedFields.has('minItems')) {
        result.minItems = overrides && overrides.hasOwnProperty('minItems') ? overrides.minItems! : 9678;
    }
    if (pickedFields.size === 0 || pickedFields.has('products')) {
        result.products = overrides && overrides.hasOwnProperty('products') ? overrides.products!.map((x) => aWixFormsV4PaymentTypeProductInput({}, pickedFields.get('products'))) : [aWixFormsV4PaymentTypeProductInput({}, pickedFields.get('products'))];
    }

    return result;
};

export const aWixFormsV4PaymentTypeProduct = <T extends Partial<WixFormsV4PaymentTypeProduct>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dynamicPriceOptions')) {
        result.dynamicPriceOptions = overrides && overrides.hasOwnProperty('dynamicPriceOptions') ? aWixFormsV4PaymentTypeProductDynamicPriceOptions(overrides.dynamicPriceOptions ?? {}, pickedFields.get('dynamicPriceOptions')) : aWixFormsV4PaymentTypeProductDynamicPriceOptions({}, pickedFields.get('dynamicPriceOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedPriceOptions')) {
        result.fixedPriceOptions = overrides && overrides.hasOwnProperty('fixedPriceOptions') ? aWixFormsV4PaymentTypeProductFixedPriceOptions(overrides.fixedPriceOptions ?? {}, pickedFields.get('fixedPriceOptions')) : aWixFormsV4PaymentTypeProductFixedPriceOptions({}, pickedFields.get('fixedPriceOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceType')) {
        result.priceType = overrides && overrides.hasOwnProperty('priceType') ? overrides.priceType! : WixFormsV4PaymentTypeProductPriceTypeEnumPriceType.DynamicPrice;
    }
    if (pickedFields.size === 0 || pickedFields.has('productType')) {
        result.productType = overrides && overrides.hasOwnProperty('productType') ? overrides.productType! : WixFormsV4PaymentTypeProductProductTypeEnumProductType.Digital;
    }
    if (pickedFields.size === 0 || pickedFields.has('quantityLimit')) {
        result.quantityLimit = overrides && overrides.hasOwnProperty('quantityLimit') ? aWixFormsV4PaymentTypeProductQuantityLimit(overrides.quantityLimit ?? {}, pickedFields.get('quantityLimit')) : aWixFormsV4PaymentTypeProductQuantityLimit({}, pickedFields.get('quantityLimit'));
    }

    return result;
};

export const aWixFormsV4PaymentTypeProductDynamicPriceOptions = <T extends Partial<WixFormsV4PaymentTypeProductDynamicPriceOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxPrice')) {
        result.maxPrice = overrides && overrides.hasOwnProperty('maxPrice') ? overrides.maxPrice! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('minPrice')) {
        result.minPrice = overrides && overrides.hasOwnProperty('minPrice') ? overrides.minPrice! : 'fugiat';
    }

    return result;
};

export const aWixFormsV4PaymentTypeProductDynamicPriceOptionsInput = <T extends Partial<WixFormsV4PaymentTypeProductDynamicPriceOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxPrice')) {
        result.maxPrice = overrides && overrides.hasOwnProperty('maxPrice') ? overrides.maxPrice! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('minPrice')) {
        result.minPrice = overrides && overrides.hasOwnProperty('minPrice') ? overrides.minPrice! : 'rerum';
    }

    return result;
};

export const aWixFormsV4PaymentTypeProductFixedPriceOptions = <T extends Partial<WixFormsV4PaymentTypeProductFixedPriceOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'voluptas';
    }

    return result;
};

export const aWixFormsV4PaymentTypeProductFixedPriceOptionsInput = <T extends Partial<WixFormsV4PaymentTypeProductFixedPriceOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'est';
    }

    return result;
};

export const aWixFormsV4PaymentTypeProductInput = <T extends Partial<WixFormsV4PaymentTypeProductInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dynamicPriceOptions')) {
        result.dynamicPriceOptions = overrides && overrides.hasOwnProperty('dynamicPriceOptions') ? aWixFormsV4PaymentTypeProductDynamicPriceOptionsInput(overrides.dynamicPriceOptions ?? {}, pickedFields.get('dynamicPriceOptions')) : aWixFormsV4PaymentTypeProductDynamicPriceOptionsInput({}, pickedFields.get('dynamicPriceOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fixedPriceOptions')) {
        result.fixedPriceOptions = overrides && overrides.hasOwnProperty('fixedPriceOptions') ? aWixFormsV4PaymentTypeProductFixedPriceOptionsInput(overrides.fixedPriceOptions ?? {}, pickedFields.get('fixedPriceOptions')) : aWixFormsV4PaymentTypeProductFixedPriceOptionsInput({}, pickedFields.get('fixedPriceOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceType')) {
        result.priceType = overrides && overrides.hasOwnProperty('priceType') ? overrides.priceType! : WixFormsV4PaymentTypeProductPriceTypeEnumPriceType.DynamicPrice;
    }
    if (pickedFields.size === 0 || pickedFields.has('productType')) {
        result.productType = overrides && overrides.hasOwnProperty('productType') ? overrides.productType! : WixFormsV4PaymentTypeProductProductTypeEnumProductType.Digital;
    }
    if (pickedFields.size === 0 || pickedFields.has('quantityLimit')) {
        result.quantityLimit = overrides && overrides.hasOwnProperty('quantityLimit') ? aWixFormsV4PaymentTypeProductQuantityLimitInput(overrides.quantityLimit ?? {}, pickedFields.get('quantityLimit')) : aWixFormsV4PaymentTypeProductQuantityLimitInput({}, pickedFields.get('quantityLimit'));
    }

    return result;
};

export const aWixFormsV4PaymentTypeProductQuantityLimit = <T extends Partial<WixFormsV4PaymentTypeProductQuantityLimit>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 7338;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 9315;
    }

    return result;
};

export const aWixFormsV4PaymentTypeProductQuantityLimitInput = <T extends Partial<WixFormsV4PaymentTypeProductQuantityLimitInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maximum')) {
        result.maximum = overrides && overrides.hasOwnProperty('maximum') ? overrides.maximum! : 1568;
    }
    if (pickedFields.size === 0 || pickedFields.has('minimum')) {
        result.minimum = overrides && overrides.hasOwnProperty('minimum') ? overrides.minimum! : 2305;
    }

    return result;
};

export const aWixFormsV4PostSubmissionTriggers = <T extends Partial<WixFormsV4PostSubmissionTriggers>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('upsertContact')) {
        result.upsertContact = overrides && overrides.hasOwnProperty('upsertContact') ? aWixFormsV4UpsertContact(overrides.upsertContact ?? {}, pickedFields.get('upsertContact')) : aWixFormsV4UpsertContact({}, pickedFields.get('upsertContact'));
    }

    return result;
};

export const aWixFormsV4PostSubmissionTriggersInput = <T extends Partial<WixFormsV4PostSubmissionTriggersInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('upsertContact')) {
        result.upsertContact = overrides && overrides.hasOwnProperty('upsertContact') ? aWixFormsV4UpsertContactInput(overrides.upsertContact ?? {}, pickedFields.get('upsertContact')) : aWixFormsV4UpsertContactInput({}, pickedFields.get('upsertContact'));
    }

    return result;
};

export const aWixFormsV4QueryDeletedFormsRequestInput = <T extends Partial<WixFormsV4QueryDeletedFormsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixFormsUpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixFormsUpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixFormsV4QueryDeletedFormsResponse = <T extends Partial<WixFormsV4QueryDeletedFormsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixFormsV4Form(x ?? {}, pickedFields.get('items'))) : [aWixFormsV4Form({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixFormsV4QueryFormsRequestInput = <T extends Partial<WixFormsV4QueryFormsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : [WixFormsV4FormFieldsetFieldset.NestedForms];
    }
    if (pickedFields.size === 0 || pickedFields.has('kind')) {
        result.kind = overrides && overrides.hasOwnProperty('kind') ? overrides.kind! : WixFormsV4FormKindKind.Extension;
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aComWixFormsUpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aComWixFormsUpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixFormsV4QueryFormsResponse = <T extends Partial<WixFormsV4QueryFormsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('forms')) {
        result.forms = overrides && overrides.hasOwnProperty('forms') ? overrides.forms!.map((x) => aWixFormsV4Form(x ?? {}, pickedFields.get('forms'))) : [aWixFormsV4Form({}, pickedFields.get('forms'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aComWixFormsUpstreamWixCommonCursorPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aComWixFormsUpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('metadata'));
    }

    return result;
};

export const aWixFormsV4RestoreFromTrashBinRequestInput = <T extends Partial<WixFormsV4RestoreFromTrashBinRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('formId')) {
        result.formId = overrides && overrides.hasOwnProperty('formId') ? overrides.formId! : 'qui';
    }

    return result;
};

export const aWixFormsV4RestoreFromTrashBinResponse = <T extends Partial<WixFormsV4RestoreFromTrashBinResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4Form(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4Form({}, pickedFields.get('form'));
    }

    return result;
};

export const aWixFormsV4Step = <T extends Partial<WixFormsV4Step>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('layout')) {
        result.layout = overrides && overrides.hasOwnProperty('layout') ? aWixFormsV4FormLayout(overrides.layout ?? {}, pickedFields.get('layout')) : aWixFormsV4FormLayout({}, pickedFields.get('layout'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quasi';
    }

    return result;
};

export const aWixFormsV4StepInput = <T extends Partial<WixFormsV4StepInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('layout')) {
        result.layout = overrides && overrides.hasOwnProperty('layout') ? aWixFormsV4FormLayoutInput(overrides.layout ?? {}, pickedFields.get('layout')) : aWixFormsV4FormLayoutInput({}, pickedFields.get('layout'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ad';
    }

    return result;
};

export const aWixFormsV4UpdateExtendedFieldsResponse = <T extends Partial<WixFormsV4UpdateExtendedFieldsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespaceData')) {
        result.namespaceData = overrides && overrides.hasOwnProperty('namespaceData') ? overrides.namespaceData! : 'quam';
    }

    return result;
};

export const aWixFormsV4UpdateFormRequestInput = <T extends Partial<WixFormsV4UpdateFormRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4FormInput(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4FormInput({}, pickedFields.get('form'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['laborum'];
    }

    return result;
};

export const aWixFormsV4UpdateFormResponse = <T extends Partial<WixFormsV4UpdateFormResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('form')) {
        result.form = overrides && overrides.hasOwnProperty('form') ? aWixFormsV4Form(overrides.form ?? {}, pickedFields.get('form')) : aWixFormsV4Form({}, pickedFields.get('form'));
    }

    return result;
};

export const aWixFormsV4UpsertContact = <T extends Partial<WixFormsV4UpsertContact>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsMapping')) {
        result.fieldsMapping = overrides && overrides.hasOwnProperty('fieldsMapping') ? aWixFormsV4FormFieldContactInfo(overrides.fieldsMapping ?? {}, pickedFields.get('fieldsMapping')) : aWixFormsV4FormFieldContactInfo({}, pickedFields.get('fieldsMapping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('labels')) {
        result.labels = overrides && overrides.hasOwnProperty('labels') ? overrides.labels! : ['dolore'];
    }

    return result;
};

export const aWixFormsV4UpsertContactInput = <T extends Partial<WixFormsV4UpsertContactInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldsMapping')) {
        result.fieldsMapping = overrides && overrides.hasOwnProperty('fieldsMapping') ? aWixFormsV4FormFieldContactInfoInput(overrides.fieldsMapping ?? {}, pickedFields.get('fieldsMapping')) : aWixFormsV4FormFieldContactInfoInput({}, pickedFields.get('fieldsMapping'));
    }
    if (pickedFields.size === 0 || pickedFields.has('labels')) {
        result.labels = overrides && overrides.hasOwnProperty('labels') ? overrides.labels! : ['est'];
    }

    return result;
};

export const aWixGiftCardsGiftCardV1Amount = <T extends Partial<WixGiftCardsGiftCardV1Amount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAmount')) {
        result.formattedAmount = overrides && overrides.hasOwnProperty('formattedAmount') ? overrides.formattedAmount! : 'dolorem';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1AmountInput = <T extends Partial<WixGiftCardsGiftCardV1AmountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAmount')) {
        result.formattedAmount = overrides && overrides.hasOwnProperty('formattedAmount') ? overrides.formattedAmount! : 'non';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1CountGiftCardsRequestInput = <T extends Partial<WixGiftCardsGiftCardV1CountGiftCardsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'quae';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1CountGiftCardsResponse = <T extends Partial<WixGiftCardsGiftCardV1CountGiftCardsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 2586;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1CreateGiftCardRequestInput = <T extends Partial<WixGiftCardsGiftCardV1CreateGiftCardRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixGiftCardsGiftCardV1GiftCardInput(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixGiftCardsGiftCardV1GiftCardInput({}, pickedFields.get('giftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('idempotencyKey')) {
        result.idempotencyKey = overrides && overrides.hasOwnProperty('idempotencyKey') ? overrides.idempotencyKey! : 'doloremque';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1CreateGiftCardResponse = <T extends Partial<WixGiftCardsGiftCardV1CreateGiftCardResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixGiftCardsGiftCardV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixGiftCardsGiftCardV1GiftCard({}, pickedFields.get('giftCard'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1DisableGiftCardRequestInput = <T extends Partial<WixGiftCardsGiftCardV1DisableGiftCardRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'ut';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1DisableGiftCardResponse = <T extends Partial<WixGiftCardsGiftCardV1DisableGiftCardResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixGiftCardsGiftCardV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixGiftCardsGiftCardV1GiftCard({}, pickedFields.get('giftCard'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1FulfillGiftCardOrderRequestInput = <T extends Partial<WixGiftCardsGiftCardV1FulfillGiftCardOrderRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'enim';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1GetGiftCardRequestInput = <T extends Partial<WixGiftCardsGiftCardV1GetGiftCardRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bd466be3-b946-4d8d-933a-17782f19cefd';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1GetTransactionRequestInput = <T extends Partial<WixGiftCardsGiftCardV1GetTransactionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bc8ad3e5-4efc-41ae-b282-3f83ef02962d';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1GiftCard = <T extends Partial<WixGiftCardsGiftCardV1GiftCard>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? aWixGiftCardsGiftCardV1Amount(overrides.balance ?? {}, pickedFields.get('balance')) : aWixGiftCardsGiftCardV1Amount({}, pickedFields.get('balance'));
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('codeSuffix')) {
        result.codeSuffix = overrides && overrides.hasOwnProperty('codeSuffix') ? overrides.codeSuffix! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('disabledDate')) {
        result.disabledDate = overrides && overrides.hasOwnProperty('disabledDate') ? overrides.disabledDate! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationDate')) {
        result.expirationDate = overrides && overrides.hasOwnProperty('expirationDate') ? overrides.expirationDate! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('initialValue')) {
        result.initialValue = overrides && overrides.hasOwnProperty('initialValue') ? aWixGiftCardsGiftCardV1Amount(overrides.initialValue ?? {}, pickedFields.get('initialValue')) : aWixGiftCardsGiftCardV1Amount({}, pickedFields.get('initialValue'));
    }
    if (pickedFields.size === 0 || pickedFields.has('notificationInfo')) {
        result.notificationInfo = overrides && overrides.hasOwnProperty('notificationInfo') ? aWixGiftCardsGiftCardV1NotificationInfo(overrides.notificationInfo ?? {}, pickedFields.get('notificationInfo')) : aWixGiftCardsGiftCardV1NotificationInfo({}, pickedFields.get('notificationInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderInfo')) {
        result.orderInfo = overrides && overrides.hasOwnProperty('orderInfo') ? aWixGiftCardsGiftCardV1OrderInfo(overrides.orderInfo ?? {}, pickedFields.get('orderInfo')) : aWixGiftCardsGiftCardV1OrderInfo({}, pickedFields.get('orderInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : WixGiftCardsGiftCardV1Source.Manual;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'rem';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1GiftCardInput = <T extends Partial<WixGiftCardsGiftCardV1GiftCardInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? aWixGiftCardsGiftCardV1AmountInput(overrides.balance ?? {}, pickedFields.get('balance')) : aWixGiftCardsGiftCardV1AmountInput({}, pickedFields.get('balance'));
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('codeSuffix')) {
        result.codeSuffix = overrides && overrides.hasOwnProperty('codeSuffix') ? overrides.codeSuffix! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('disabledDate')) {
        result.disabledDate = overrides && overrides.hasOwnProperty('disabledDate') ? overrides.disabledDate! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationDate')) {
        result.expirationDate = overrides && overrides.hasOwnProperty('expirationDate') ? overrides.expirationDate! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('initialValue')) {
        result.initialValue = overrides && overrides.hasOwnProperty('initialValue') ? aWixGiftCardsGiftCardV1AmountInput(overrides.initialValue ?? {}, pickedFields.get('initialValue')) : aWixGiftCardsGiftCardV1AmountInput({}, pickedFields.get('initialValue'));
    }
    if (pickedFields.size === 0 || pickedFields.has('notificationInfo')) {
        result.notificationInfo = overrides && overrides.hasOwnProperty('notificationInfo') ? aWixGiftCardsGiftCardV1NotificationInfoInput(overrides.notificationInfo ?? {}, pickedFields.get('notificationInfo')) : aWixGiftCardsGiftCardV1NotificationInfoInput({}, pickedFields.get('notificationInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderInfo')) {
        result.orderInfo = overrides && overrides.hasOwnProperty('orderInfo') ? aWixGiftCardsGiftCardV1OrderInfoInput(overrides.orderInfo ?? {}, pickedFields.get('orderInfo')) : aWixGiftCardsGiftCardV1OrderInfoInput({}, pickedFields.get('orderInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : WixGiftCardsGiftCardV1Source.Manual;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'occaecati';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1ListGiftCardsByEmailRequestInput = <T extends Partial<WixGiftCardsGiftCardV1ListGiftCardsByEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'incidunt';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1ListGiftCardsByEmailResponse = <T extends Partial<WixGiftCardsGiftCardV1ListGiftCardsByEmailResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCards')) {
        result.giftCards = overrides && overrides.hasOwnProperty('giftCards') ? overrides.giftCards!.map((x) => aWixGiftCardsGiftCardV1GiftCard(x ?? {}, pickedFields.get('giftCards'))) : [aWixGiftCardsGiftCardV1GiftCard({}, pickedFields.get('giftCards'))];
    }

    return result;
};

export const aWixGiftCardsGiftCardV1NotificationInfo = <T extends Partial<WixGiftCardsGiftCardV1NotificationInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('imageUrl')) {
        result.imageUrl = overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('notificationDate')) {
        result.notificationDate = overrides && overrides.hasOwnProperty('notificationDate') ? overrides.notificationDate! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('personalizedMessage')) {
        result.personalizedMessage = overrides && overrides.hasOwnProperty('personalizedMessage') ? overrides.personalizedMessage! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('recipient')) {
        result.recipient = overrides && overrides.hasOwnProperty('recipient') ? aWixGiftCardsGiftCardV1Recipient(overrides.recipient ?? {}, pickedFields.get('recipient')) : aWixGiftCardsGiftCardV1Recipient({}, pickedFields.get('recipient'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sender')) {
        result.sender = overrides && overrides.hasOwnProperty('sender') ? aWixGiftCardsGiftCardV1Sender(overrides.sender ?? {}, pickedFields.get('sender')) : aWixGiftCardsGiftCardV1Sender({}, pickedFields.get('sender'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1NotificationInfoInput = <T extends Partial<WixGiftCardsGiftCardV1NotificationInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('imageUrl')) {
        result.imageUrl = overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('notificationDate')) {
        result.notificationDate = overrides && overrides.hasOwnProperty('notificationDate') ? overrides.notificationDate! : 'hic';
    }
    if (pickedFields.size === 0 || pickedFields.has('personalizedMessage')) {
        result.personalizedMessage = overrides && overrides.hasOwnProperty('personalizedMessage') ? overrides.personalizedMessage! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('recipient')) {
        result.recipient = overrides && overrides.hasOwnProperty('recipient') ? aWixGiftCardsGiftCardV1RecipientInput(overrides.recipient ?? {}, pickedFields.get('recipient')) : aWixGiftCardsGiftCardV1RecipientInput({}, pickedFields.get('recipient'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sender')) {
        result.sender = overrides && overrides.hasOwnProperty('sender') ? aWixGiftCardsGiftCardV1SenderInput(overrides.sender ?? {}, pickedFields.get('sender')) : aWixGiftCardsGiftCardV1SenderInput({}, pickedFields.get('sender'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1OrderInfo = <T extends Partial<WixGiftCardsGiftCardV1OrderInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aComWixEcomOrdersV1Order(overrides.order ?? {}, pickedFields.get('order')) : aComWixEcomOrdersV1Order({}, pickedFields.get('order'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderNumber')) {
        result.orderNumber = overrides && overrides.hasOwnProperty('orderNumber') ? overrides.orderNumber! : 'repellendus';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1OrderInfoInput = <T extends Partial<WixGiftCardsGiftCardV1OrderInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderNumber')) {
        result.orderNumber = overrides && overrides.hasOwnProperty('orderNumber') ? overrides.orderNumber! : 'sit';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1QueryGiftCardTransactionsRequestInput = <T extends Partial<WixGiftCardsGiftCardV1QueryGiftCardTransactionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1QueryGiftCardTransactionsResponse = <T extends Partial<WixGiftCardsGiftCardV1QueryGiftCardTransactionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixGiftCardsGiftCardV1Transaction(x ?? {}, pickedFields.get('items'))) : [aWixGiftCardsGiftCardV1Transaction({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1QueryGiftCardsRequestInput = <T extends Partial<WixGiftCardsGiftCardV1QueryGiftCardsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1QueryGiftCardsResponse = <T extends Partial<WixGiftCardsGiftCardV1QueryGiftCardsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixGiftCardsGiftCardV1GiftCard(x ?? {}, pickedFields.get('items'))) : [aWixGiftCardsGiftCardV1GiftCard({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1Recipient = <T extends Partial<WixGiftCardsGiftCardV1Recipient>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'consequatur';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1RecipientInput = <T extends Partial<WixGiftCardsGiftCardV1RecipientInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aut';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1SearchGiftCardsRequestInput = <T extends Partial<WixGiftCardsGiftCardV1SearchGiftCardsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aWixGiftCardsGiftCardV1UpstreamWixCommonCursorSearchInput(overrides.search ?? {}, pickedFields.get('search')) : aWixGiftCardsGiftCardV1UpstreamWixCommonCursorSearchInput({}, pickedFields.get('search'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1SearchGiftCardsResponse = <T extends Partial<WixGiftCardsGiftCardV1SearchGiftCardsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregationData')) {
        result.aggregationData = overrides && overrides.hasOwnProperty('aggregationData') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationData(overrides.aggregationData ?? {}, pickedFields.get('aggregationData')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationData({}, pickedFields.get('aggregationData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCards')) {
        result.giftCards = overrides && overrides.hasOwnProperty('giftCards') ? overrides.giftCards!.map((x) => aWixGiftCardsGiftCardV1GiftCard(x ?? {}, pickedFields.get('giftCards'))) : [aWixGiftCardsGiftCardV1GiftCard({}, pickedFields.get('giftCards'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1SendGiftCardEmailRequestInput = <T extends Partial<WixGiftCardsGiftCardV1SendGiftCardEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'optio';
    }
    if (pickedFields.size === 0 || pickedFields.has('recipientEmail')) {
        result.recipientEmail = overrides && overrides.hasOwnProperty('recipientEmail') ? overrides.recipientEmail! : 'facilis';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1Sender = <T extends Partial<WixGiftCardsGiftCardV1Sender>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'consequuntur';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1SenderInput = <T extends Partial<WixGiftCardsGiftCardV1SenderInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'et';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1Transaction = <T extends Partial<WixGiftCardsGiftCardV1Transaction>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aWixGiftCardsGiftCardV1Amount(overrides.amount ?? {}, pickedFields.get('amount')) : aWixGiftCardsGiftCardV1Amount({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('operationType')) {
        result.operationType = overrides && overrides.hasOwnProperty('operationType') ? overrides.operationType! : WixGiftCardsGiftCardV1TransactionOperationType.Add;
    }
    if (pickedFields.size === 0 || pickedFields.has('orderInfo')) {
        result.orderInfo = overrides && overrides.hasOwnProperty('orderInfo') ? aWixGiftCardsGiftCardV1OrderInfo(overrides.orderInfo ?? {}, pickedFields.get('orderInfo')) : aWixGiftCardsGiftCardV1OrderInfo({}, pickedFields.get('orderInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixGiftCardsGiftCardV1TransactionTransactionType.Initial;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedBalance')) {
        result.updatedBalance = overrides && overrides.hasOwnProperty('updatedBalance') ? aWixGiftCardsGiftCardV1Amount(overrides.updatedBalance ?? {}, pickedFields.get('updatedBalance')) : aWixGiftCardsGiftCardV1Amount({}, pickedFields.get('updatedBalance'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1TriggerGiftCardsAppInstallationFlowEventInput = <T extends Partial<WixGiftCardsGiftCardV1TriggerGiftCardsAppInstallationFlowEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'nihil';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationData = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResults(x ?? {}, pickedFields.get('results'))) : [aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResults({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResults = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('groupedByValue')) {
        result.groupedByValue = overrides && overrides.hasOwnProperty('groupedByValue') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults(overrides.groupedByValue ?? {}, pickedFields.get('groupedByValue')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults({}, pickedFields.get('groupedByValue'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('nested')) {
        result.nested = overrides && overrides.hasOwnProperty('nested') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResults(overrides.nested ?? {}, pickedFields.get('nested')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResults({}, pickedFields.get('nested'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ranges')) {
        result.ranges = overrides && overrides.hasOwnProperty('ranges') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults(overrides.ranges ?? {}, pickedFields.get('ranges')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults({}, pickedFields.get('ranges'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixGiftCardsGiftCardV1UpstreamWixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults(overrides.values ?? {}, pickedFields.get('values')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults({}, pickedFields.get('values'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult(x ?? {}, pickedFields.get('results'))) : [aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 8272;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'placeat';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nestedResults')) {
        result.nestedResults = overrides && overrides.hasOwnProperty('nestedResults') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults(overrides.nestedResults ?? {}, pickedFields.get('nestedResults')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults({}, pickedFields.get('nestedResults'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'eum';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('ranges')) {
        result.ranges = overrides && overrides.hasOwnProperty('ranges') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults(overrides.ranges ?? {}, pickedFields.get('ranges')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults({}, pickedFields.get('ranges'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixGiftCardsGiftCardV1UpstreamWixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults(overrides.values ?? {}, pickedFields.get('values')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults({}, pickedFields.get('values'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResults = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults(x ?? {}, pickedFields.get('results'))) : [aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult(overrides.range ?? {}, pickedFields.get('range')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult(overrides.value ?? {}, pickedFields.get('value')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 8652;
    }
    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 2.97;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 3.86;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue(overrides.results ?? {}, pickedFields.get('results')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue({}, pickedFields.get('results'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 8.71;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 7306;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'vero';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 7509;
    }
    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 1.45;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 1.06;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixGiftCardsGiftCardV1UpstreamWixCommonScalarType.Avg;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 3.31;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3702;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'qui';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInterval.Day;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('nested')) {
        result.nested = overrides && overrides.hasOwnProperty('nested') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationInput(overrides.nested ?? {}, pickedFields.get('nested')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationInput({}, pickedFields.get('nested'));
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput(overrides.range ?? {}, pickedFields.get('range')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixGiftCardsGiftCardV1UpstreamWixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nestedAggregations')) {
        result.nestedAggregations = overrides && overrides.hasOwnProperty('nestedAggregations') ? overrides.nestedAggregations!.map((x) => aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput({}, pickedFields.get('nestedAggregations'))) : [aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput({}, pickedFields.get('nestedAggregations'))];
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput(overrides.range ?? {}, pickedFields.get('range')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buckets')) {
        result.buckets = overrides && overrides.hasOwnProperty('buckets') ? overrides.buckets!.map((x) => aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput({}, pickedFields.get('buckets'))) : [aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput({}, pickedFields.get('buckets'))];
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 3.99;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 2.73;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixGiftCardsGiftCardV1UpstreamWixCommonScalarType.Avg;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addToBucket')) {
        result.addToBucket = overrides && overrides.hasOwnProperty('addToBucket') ? overrides.addToBucket! : 'unde';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includeOptions')) {
        result.includeOptions = overrides && overrides.hasOwnProperty('includeOptions') ? aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput(overrides.includeOptions ?? {}, pickedFields.get('includeOptions')) : aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput({}, pickedFields.get('includeOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 7274;
    }
    if (pickedFields.size === 0 || pickedFields.has('missingValues')) {
        result.missingValues = overrides && overrides.hasOwnProperty('missingValues') ? overrides.missingValues! : WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationMissingValues.Exclude;
    }
    if (pickedFields.size === 0 || pickedFields.has('sortDirection')) {
        result.sortDirection = overrides && overrides.hasOwnProperty('sortDirection') ? overrides.sortDirection! : WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationSortDirection.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('sortType')) {
        result.sortType = overrides && overrides.hasOwnProperty('sortType') ? overrides.sortType! : WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationSortType.Count;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 7736;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingMetadata = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3827;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixGiftCardsGiftCardV1UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixGiftCardsGiftCardV1UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixGiftCardsGiftCardV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixGiftCardsGiftCardV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonCursorSearchInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonCursorSearchInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregations')) {
        result.aggregations = overrides && overrides.hasOwnProperty('aggregations') ? overrides.aggregations!.map((x) => aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationInput({}, pickedFields.get('aggregations'))) : [aWixGiftCardsGiftCardV1UpstreamWixCommonAggregationInput({}, pickedFields.get('aggregations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aWixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsInput(overrides.search ?? {}, pickedFields.get('search')) : aWixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsInput({}, pickedFields.get('search'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixGiftCardsGiftCardV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixGiftCardsGiftCardV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'et';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonCursors = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'suscipit';
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['quidem'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fuzzy')) {
        result.fuzzy = overrides && overrides.hasOwnProperty('fuzzy') ? overrides.fuzzy! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('mode')) {
        result.mode = overrides && overrides.hasOwnProperty('mode') ? overrides.mode! : WixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsMode.And;
    }

    return result;
};

export const aWixGiftCardsGiftCardV1UpstreamWixCommonSortingInput = <T extends Partial<WixGiftCardsGiftCardV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixGiftCardsGiftCardV1UpstreamWixCommonSortOrder.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('selectItemsBy')) {
        result.selectItemsBy = overrides && overrides.hasOwnProperty('selectItemsBy') ? overrides.selectItemsBy! : ['animi'];
    }

    return result;
};

export const aWixHeadlessV1CreateOAuthAppRequestInput = <T extends Partial<WixHeadlessV1CreateOAuthAppRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('oAuthApp')) {
        result.oAuthApp = overrides && overrides.hasOwnProperty('oAuthApp') ? aWixHeadlessV1OAuthAppInput(overrides.oAuthApp ?? {}, pickedFields.get('oAuthApp')) : aWixHeadlessV1OAuthAppInput({}, pickedFields.get('oAuthApp'));
    }

    return result;
};

export const aWixHeadlessV1CreateOAuthAppResponse = <T extends Partial<WixHeadlessV1CreateOAuthAppResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('oAuthApp')) {
        result.oAuthApp = overrides && overrides.hasOwnProperty('oAuthApp') ? aWixHeadlessV1OAuthApp(overrides.oAuthApp ?? {}, pickedFields.get('oAuthApp')) : aWixHeadlessV1OAuthApp({}, pickedFields.get('oAuthApp'));
    }

    return result;
};

export const aWixHeadlessV1DeleteOAuthAppRequestInput = <T extends Partial<WixHeadlessV1DeleteOAuthAppRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('oAuthAppId')) {
        result.oAuthAppId = overrides && overrides.hasOwnProperty('oAuthAppId') ? overrides.oAuthAppId! : 'nihil';
    }

    return result;
};

export const aWixHeadlessV1GenerateOAuthAppSecretRequestInput = <T extends Partial<WixHeadlessV1GenerateOAuthAppSecretRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('oAuthAppId')) {
        result.oAuthAppId = overrides && overrides.hasOwnProperty('oAuthAppId') ? overrides.oAuthAppId! : 'alias';
    }

    return result;
};

export const aWixHeadlessV1GenerateOAuthAppSecretResponse = <T extends Partial<WixHeadlessV1GenerateOAuthAppSecretResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('oAuthAppSecret')) {
        result.oAuthAppSecret = overrides && overrides.hasOwnProperty('oAuthAppSecret') ? overrides.oAuthAppSecret! : 'temporibus';
    }

    return result;
};

export const aWixHeadlessV1GetOAuthAppRequestInput = <T extends Partial<WixHeadlessV1GetOAuthAppRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0fe2f42a-1b91-41da-8c7a-d4bfdf0fb008';
    }

    return result;
};

export const aWixHeadlessV1OAuthApp = <T extends Partial<WixHeadlessV1OAuthApp>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowSecretGeneration')) {
        result.allowSecretGeneration = overrides && overrides.hasOwnProperty('allowSecretGeneration') ? overrides.allowSecretGeneration! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('allowedDomains')) {
        result.allowedDomains = overrides && overrides.hasOwnProperty('allowedDomains') ? overrides.allowedDomains! : ['beatae'];
    }
    if (pickedFields.size === 0 || pickedFields.has('allowedRedirectDomains')) {
        result.allowedRedirectDomains = overrides && overrides.hasOwnProperty('allowedRedirectDomains') ? overrides.allowedRedirectDomains! : ['reprehenderit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('allowedRedirectUris')) {
        result.allowedRedirectUris = overrides && overrides.hasOwnProperty('allowedRedirectUris') ? overrides.allowedRedirectUris! : ['fugiat'];
    }
    if (pickedFields.size === 0 || pickedFields.has('applicationType')) {
        result.applicationType = overrides && overrides.hasOwnProperty('applicationType') ? overrides.applicationType! : WixHeadlessV1OAuthAppType.Mobile;
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('loginUrl')) {
        result.loginUrl = overrides && overrides.hasOwnProperty('loginUrl') ? overrides.loginUrl! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('logoutUrl')) {
        result.logoutUrl = overrides && overrides.hasOwnProperty('logoutUrl') ? overrides.logoutUrl! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('redirectUrlWixPages')) {
        result.redirectUrlWixPages = overrides && overrides.hasOwnProperty('redirectUrlWixPages') ? overrides.redirectUrlWixPages! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('secret')) {
        result.secret = overrides && overrides.hasOwnProperty('secret') ? overrides.secret! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('technology')) {
        result.technology = overrides && overrides.hasOwnProperty('technology') ? overrides.technology! : WixHeadlessV1OAuthTechnologies.Android;
    }
    if (pickedFields.size === 0 || pickedFields.has('wixPagesDomainsMappings')) {
        result.wixPagesDomainsMappings = overrides && overrides.hasOwnProperty('wixPagesDomainsMappings') ? overrides.wixPagesDomainsMappings!.map((x) => aWixHeadlessV1WixPagesDomainMapping(x ?? {}, pickedFields.get('wixPagesDomainsMappings'))) : [aWixHeadlessV1WixPagesDomainMapping({}, pickedFields.get('wixPagesDomainsMappings'))];
    }

    return result;
};

export const aWixHeadlessV1OAuthAppInput = <T extends Partial<WixHeadlessV1OAuthAppInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowSecretGeneration')) {
        result.allowSecretGeneration = overrides && overrides.hasOwnProperty('allowSecretGeneration') ? overrides.allowSecretGeneration! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('allowedRedirectDomains')) {
        result.allowedRedirectDomains = overrides && overrides.hasOwnProperty('allowedRedirectDomains') ? overrides.allowedRedirectDomains! : ['et'];
    }
    if (pickedFields.size === 0 || pickedFields.has('allowedRedirectUris')) {
        result.allowedRedirectUris = overrides && overrides.hasOwnProperty('allowedRedirectUris') ? overrides.allowedRedirectUris! : ['assumenda'];
    }
    if (pickedFields.size === 0 || pickedFields.has('applicationType')) {
        result.applicationType = overrides && overrides.hasOwnProperty('applicationType') ? overrides.applicationType! : WixHeadlessV1OAuthAppType.Mobile;
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('loginUrl')) {
        result.loginUrl = overrides && overrides.hasOwnProperty('loginUrl') ? overrides.loginUrl! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('logoutUrl')) {
        result.logoutUrl = overrides && overrides.hasOwnProperty('logoutUrl') ? overrides.logoutUrl! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('redirectUrlWixPages')) {
        result.redirectUrlWixPages = overrides && overrides.hasOwnProperty('redirectUrlWixPages') ? overrides.redirectUrlWixPages! : 'occaecati';
    }
    if (pickedFields.size === 0 || pickedFields.has('secret')) {
        result.secret = overrides && overrides.hasOwnProperty('secret') ? overrides.secret! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('technology')) {
        result.technology = overrides && overrides.hasOwnProperty('technology') ? overrides.technology! : WixHeadlessV1OAuthTechnologies.Android;
    }
    if (pickedFields.size === 0 || pickedFields.has('wixPagesDomainsMappings')) {
        result.wixPagesDomainsMappings = overrides && overrides.hasOwnProperty('wixPagesDomainsMappings') ? overrides.wixPagesDomainsMappings!.map((x) => aWixHeadlessV1WixPagesDomainMappingInput({}, pickedFields.get('wixPagesDomainsMappings'))) : [aWixHeadlessV1WixPagesDomainMappingInput({}, pickedFields.get('wixPagesDomainsMappings'))];
    }

    return result;
};

export const aWixHeadlessV1PlatformQueryInput = <T extends Partial<WixHeadlessV1PlatformQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixHeadlessV1QueryOAuthAppsRequestInput = <T extends Partial<WixHeadlessV1QueryOAuthAppsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixHeadlessV1PlatformQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixHeadlessV1PlatformQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixHeadlessV1QueryOAuthAppsResponse = <T extends Partial<WixHeadlessV1QueryOAuthAppsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixHeadlessV1OAuthApp(x ?? {}, pickedFields.get('items'))) : [aWixHeadlessV1OAuthApp({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixHeadlessV1UpdateOAuthAppRequestInput = <T extends Partial<WixHeadlessV1UpdateOAuthAppRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['veniam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('oAuthApp')) {
        result.oAuthApp = overrides && overrides.hasOwnProperty('oAuthApp') ? aWixHeadlessV1OAuthAppInput(overrides.oAuthApp ?? {}, pickedFields.get('oAuthApp')) : aWixHeadlessV1OAuthAppInput({}, pickedFields.get('oAuthApp'));
    }

    return result;
};

export const aWixHeadlessV1UpdateOAuthAppResponse = <T extends Partial<WixHeadlessV1UpdateOAuthAppResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('oAuthApp')) {
        result.oAuthApp = overrides && overrides.hasOwnProperty('oAuthApp') ? aWixHeadlessV1OAuthApp(overrides.oAuthApp ?? {}, pickedFields.get('oAuthApp')) : aWixHeadlessV1OAuthApp({}, pickedFields.get('oAuthApp'));
    }

    return result;
};

export const aWixHeadlessV1WixPagesDomainMapping = <T extends Partial<WixHeadlessV1WixPagesDomainMapping>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('destination')) {
        result.destination = overrides && overrides.hasOwnProperty('destination') ? overrides.destination! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('origin')) {
        result.origin = overrides && overrides.hasOwnProperty('origin') ? overrides.origin! : 'quibusdam';
    }

    return result;
};

export const aWixHeadlessV1WixPagesDomainMappingInput = <T extends Partial<WixHeadlessV1WixPagesDomainMappingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('destination')) {
        result.destination = overrides && overrides.hasOwnProperty('destination') ? overrides.destination! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('origin')) {
        result.origin = overrides && overrides.hasOwnProperty('origin') ? overrides.origin! : 'minus';
    }

    return result;
};

export const aWixInfraTimecapsuleV2CronTzInput = <T extends Partial<WixInfraTimecapsuleV2CronTzInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'animi';
    }

    return result;
};

export const aWixInfraTimecapsuleV2TaskIdInput = <T extends Partial<WixInfraTimecapsuleV2TaskIdInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('key')) {
        result.key = overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('taskType')) {
        result.taskType = overrides && overrides.hasOwnProperty('taskType') ? overrides.taskType! : 'non';
    }

    return result;
};

export const aWixInfraTimecapsuleV2TaskInput = <T extends Partial<WixInfraTimecapsuleV2TaskInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('classifier')) {
        result.classifier = overrides && overrides.hasOwnProperty('classifier') ? overrides.classifier! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('cron')) {
        result.cron = overrides && overrides.hasOwnProperty('cron') ? overrides.cron! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('cronTz')) {
        result.cronTz = overrides && overrides.hasOwnProperty('cronTz') ? aWixInfraTimecapsuleV2CronTzInput(overrides.cronTz ?? {}, pickedFields.get('cronTz')) : aWixInfraTimecapsuleV2CronTzInput({}, pickedFields.get('cronTz'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? aWixInfraTimecapsuleV2TaskIdInput(overrides.id ?? {}, pickedFields.get('id')) : aWixInfraTimecapsuleV2TaskIdInput({}, pickedFields.get('id'));
    }
    if (pickedFields.size === 0 || pickedFields.has('oneTime')) {
        result.oneTime = overrides && overrides.hasOwnProperty('oneTime') ? overrides.oneTime! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('payload')) {
        result.payload = overrides && overrides.hasOwnProperty('payload') ? overrides.payload! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduledFor')) {
        result.scheduledFor = overrides && overrides.hasOwnProperty('scheduledFor') ? overrides.scheduledFor! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('topic')) {
        result.topic = overrides && overrides.hasOwnProperty('topic') ? overrides.topic! : 'debitis';
    }

    return result;
};

export const aWixInventoryApiV1PreorderInfo = <T extends Partial<WixInventoryApiV1PreorderInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 6540;
    }
    if (pickedFields.size === 0 || pickedFields.has('message')) {
        result.message = overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'delectus';
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramDescription = <T extends Partial<WixOnlineprogramsCommonV3ProgramDescription>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'hic';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideoV2(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideoV2({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramDescriptionInput = <T extends Partial<WixOnlineprogramsCommonV3ProgramDescriptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details! : 'repellat';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideoV2Input(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideoV2Input({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramRestrictions = <T extends Partial<WixOnlineprogramsCommonV3ProgramRestrictions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hideFutureSteps')) {
        result.hideFutureSteps = overrides && overrides.hasOwnProperty('hideFutureSteps') ? overrides.hideFutureSteps! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxParticipants')) {
        result.maxParticipants = overrides && overrides.hasOwnProperty('maxParticipants') ? overrides.maxParticipants! : 9917;
    }
    if (pickedFields.size === 0 || pickedFields.has('resolveStepsInOrder')) {
        result.resolveStepsInOrder = overrides && overrides.hasOwnProperty('resolveStepsInOrder') ? overrides.resolveStepsInOrder! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('shareProgress')) {
        result.shareProgress = overrides && overrides.hasOwnProperty('shareProgress') ? overrides.shareProgress! : true;
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramRestrictionsInput = <T extends Partial<WixOnlineprogramsCommonV3ProgramRestrictionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hideFutureSteps')) {
        result.hideFutureSteps = overrides && overrides.hasOwnProperty('hideFutureSteps') ? overrides.hideFutureSteps! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxParticipants')) {
        result.maxParticipants = overrides && overrides.hasOwnProperty('maxParticipants') ? overrides.maxParticipants! : 5024;
    }
    if (pickedFields.size === 0 || pickedFields.has('resolveStepsInOrder')) {
        result.resolveStepsInOrder = overrides && overrides.hasOwnProperty('resolveStepsInOrder') ? overrides.resolveStepsInOrder! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('shareProgress')) {
        result.shareProgress = overrides && overrides.hasOwnProperty('shareProgress') ? overrides.shareProgress! : true;
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramReward = <T extends Partial<WixOnlineprogramsCommonV3ProgramReward>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('badgeIds')) {
        result.badgeIds = overrides && overrides.hasOwnProperty('badgeIds') ? overrides.badgeIds! : ['doloremque'];
    }
    if (pickedFields.size === 0 || pickedFields.has('certificate')) {
        result.certificate = overrides && overrides.hasOwnProperty('certificate') ? aWixOnlineprogramsCommonV3ProgramRewardCertificate(overrides.certificate ?? {}, pickedFields.get('certificate')) : aWixOnlineprogramsCommonV3ProgramRewardCertificate({}, pickedFields.get('certificate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('trigger')) {
        result.trigger = overrides && overrides.hasOwnProperty('trigger') ? overrides.trigger! : WixOnlineprogramsCommonV3ProgramRewardTrigger.AllStepsCompleted;
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramRewardCertificate = <T extends Partial<WixOnlineprogramsCommonV3ProgramRewardCertificate>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('connectedDate')) {
        result.connectedDate = overrides && overrides.hasOwnProperty('connectedDate') ? overrides.connectedDate! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramRewardCertificateInput = <T extends Partial<WixOnlineprogramsCommonV3ProgramRewardCertificateInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('connectedDate')) {
        result.connectedDate = overrides && overrides.hasOwnProperty('connectedDate') ? overrides.connectedDate! : 'cupiditate';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramRewardInput = <T extends Partial<WixOnlineprogramsCommonV3ProgramRewardInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('badgeIds')) {
        result.badgeIds = overrides && overrides.hasOwnProperty('badgeIds') ? overrides.badgeIds! : ['et'];
    }
    if (pickedFields.size === 0 || pickedFields.has('certificate')) {
        result.certificate = overrides && overrides.hasOwnProperty('certificate') ? aWixOnlineprogramsCommonV3ProgramRewardCertificateInput(overrides.certificate ?? {}, pickedFields.get('certificate')) : aWixOnlineprogramsCommonV3ProgramRewardCertificateInput({}, pickedFields.get('certificate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('trigger')) {
        result.trigger = overrides && overrides.hasOwnProperty('trigger') ? overrides.trigger! : WixOnlineprogramsCommonV3ProgramRewardTrigger.AllStepsCompleted;
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramSeo = <T extends Partial<WixOnlineprogramsCommonV3ProgramSeo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('imageUrl')) {
        result.imageUrl = overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrl(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrl({}, pickedFields.get('url'));
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramSeoInput = <T extends Partial<WixOnlineprogramsCommonV3ProgramSeoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('imageUrl')) {
        result.imageUrl = overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlInput(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlInput({}, pickedFields.get('url'));
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramTimeline = <T extends Partial<WixOnlineprogramsCommonV3ProgramTimeline>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('finishCondition')) {
        result.finishCondition = overrides && overrides.hasOwnProperty('finishCondition') ? overrides.finishCondition! : WixOnlineprogramsCommonV3ProgramTimelineFinishCondition.AllStepsCompleted;
    }
    if (pickedFields.size === 0 || pickedFields.has('selfPaced')) {
        result.selfPaced = overrides && overrides.hasOwnProperty('selfPaced') ? overrides.selfPaced! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeEvaluationOptions')) {
        result.timeEvaluationOptions = overrides && overrides.hasOwnProperty('timeEvaluationOptions') ? aWixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptions(overrides.timeEvaluationOptions ?? {}, pickedFields.get('timeEvaluationOptions')) : aWixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptions({}, pickedFields.get('timeEvaluationOptions'));
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramTimelineInput = <T extends Partial<WixOnlineprogramsCommonV3ProgramTimelineInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('finishCondition')) {
        result.finishCondition = overrides && overrides.hasOwnProperty('finishCondition') ? overrides.finishCondition! : WixOnlineprogramsCommonV3ProgramTimelineFinishCondition.AllStepsCompleted;
    }
    if (pickedFields.size === 0 || pickedFields.has('selfPaced')) {
        result.selfPaced = overrides && overrides.hasOwnProperty('selfPaced') ? overrides.selfPaced! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeEvaluationOptions')) {
        result.timeEvaluationOptions = overrides && overrides.hasOwnProperty('timeEvaluationOptions') ? aWixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptionsInput(overrides.timeEvaluationOptions ?? {}, pickedFields.get('timeEvaluationOptions')) : aWixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptionsInput({}, pickedFields.get('timeEvaluationOptions'));
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptions = <T extends Partial<WixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durationInDays')) {
        result.durationInDays = overrides && overrides.hasOwnProperty('durationInDays') ? overrides.durationInDays! : 1753;
    }

    return result;
};

export const aWixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptionsInput = <T extends Partial<WixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durationInDays')) {
        result.durationInDays = overrides && overrides.hasOwnProperty('durationInDays') ? overrides.durationInDays! : 4146;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ApplyCouponRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3ApplyCouponRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('couponCode')) {
        result.couponCode = overrides && overrides.hasOwnProperty('couponCode') ? overrides.couponCode! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'soluta';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ApplyCouponResponse = <T extends Partial<WixOnlineprogramsParticipantsV3ApplyCouponResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('couponId')) {
        result.couponId = overrides && overrides.hasOwnProperty('couponId') ? overrides.couponId! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? overrides.discount! : 7.44;
    }
    if (pickedFields.size === 0 || pickedFields.has('subTotal')) {
        result.subTotal = overrides && overrides.hasOwnProperty('subTotal') ? overrides.subTotal! : 5.05;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 0.55;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkAddAllToProgramRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3BulkAddAllToProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('excludeMemberIds')) {
        result.excludeMemberIds = overrides && overrides.hasOwnProperty('excludeMemberIds') ? overrides.excludeMemberIds! : ['illo'];
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'modi';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkAddAllToProgramResponse = <T extends Partial<WixOnlineprogramsParticipantsV3BulkAddAllToProgramResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkAddToProgramRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3BulkAddToProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('memberIds')) {
        result.memberIds = overrides && overrides.hasOwnProperty('memberIds') ? overrides.memberIds! : ['nobis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkAddToProgramResponse = <T extends Partial<WixOnlineprogramsParticipantsV3BulkAddToProgramResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsParticipantsV3BulkAddToProgramResponseBulkAddToProgramResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsParticipantsV3BulkAddToProgramResponseBulkAddToProgramResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkAddToProgramResponseBulkAddToProgramResult = <T extends Partial<WixOnlineprogramsParticipantsV3BulkAddToProgramResponseBulkAddToProgramResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixOnlineprogramsParticipantsV3Participant(overrides.item ?? {}, pickedFields.get('item')) : aWixOnlineprogramsParticipantsV3Participant({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkApproveAllParticipantRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3BulkApproveAllParticipantRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('excludeParticipantIds')) {
        result.excludeParticipantIds = overrides && overrides.hasOwnProperty('excludeParticipantIds') ? overrides.excludeParticipantIds! : ['nesciunt'];
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'dolores';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkApproveAllParticipantResponse = <T extends Partial<WixOnlineprogramsParticipantsV3BulkApproveAllParticipantResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jobId')) {
        result.jobId = overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'est';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkApproveParticipantRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3BulkApproveParticipantRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantIds')) {
        result.participantIds = overrides && overrides.hasOwnProperty('participantIds') ? overrides.participantIds! : ['dolorum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkApproveParticipantResponse = <T extends Partial<WixOnlineprogramsParticipantsV3BulkApproveParticipantResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsParticipantsV3BulkApproveParticipantResponseBulkApproveParticipantResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsParticipantsV3BulkApproveParticipantResponseBulkApproveParticipantResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkApproveParticipantResponseBulkApproveParticipantResult = <T extends Partial<WixOnlineprogramsParticipantsV3BulkApproveParticipantResponseBulkApproveParticipantResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixOnlineprogramsParticipantsV3Participant(overrides.item ?? {}, pickedFields.get('item')) : aWixOnlineprogramsParticipantsV3Participant({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resolvedSteps')) {
        result.resolvedSteps = overrides && overrides.hasOwnProperty('resolvedSteps') ? overrides.resolvedSteps!.map((x) => aWixOnlineprogramsParticipantsV3ResolvedStepInput({}, pickedFields.get('resolvedSteps'))) : [aWixOnlineprogramsParticipantsV3ResolvedStepInput({}, pickedFields.get('resolvedSteps'))];
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponse = <T extends Partial<WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixOnlineprogramsParticipantsV3UpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixOnlineprogramsParticipantsV3UpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponseBulkResolvedStepResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponseBulkResolvedStepResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponseBulkResolvedStepResult = <T extends Partial<WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponseBulkResolvedStepResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixOnlineprogramsParticipantsV3ResolvedStep(overrides.item ?? {}, pickedFields.get('item')) : aWixOnlineprogramsParticipantsV3ResolvedStep({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixOnlineprogramsParticipantsV3UpstreamWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixOnlineprogramsParticipantsV3UpstreamWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkInviteAllToProgramRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3BulkInviteAllToProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('excludeMemberIds')) {
        result.excludeMemberIds = overrides && overrides.hasOwnProperty('excludeMemberIds') ? overrides.excludeMemberIds! : ['commodi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'excepturi';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkInviteAllToProgramResponse = <T extends Partial<WixOnlineprogramsParticipantsV3BulkInviteAllToProgramResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkInviteToProgramRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3BulkInviteToProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('memberIds')) {
        result.memberIds = overrides && overrides.hasOwnProperty('memberIds') ? overrides.memberIds! : ['beatae'];
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkInviteToProgramResponse = <T extends Partial<WixOnlineprogramsParticipantsV3BulkInviteToProgramResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsParticipantsV3BulkInviteToProgramResponseBulkInviteToProgramResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsParticipantsV3BulkInviteToProgramResponseBulkInviteToProgramResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3BulkInviteToProgramResponseBulkInviteToProgramResult = <T extends Partial<WixOnlineprogramsParticipantsV3BulkInviteToProgramResponseBulkInviteToProgramResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixOnlineprogramsParticipantsV3Participant(overrides.item ?? {}, pickedFields.get('item')) : aWixOnlineprogramsParticipantsV3Participant({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3CompleteParticipantRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3CompleteParticipantRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'est';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3CompleteParticipantResponse = <T extends Partial<WixOnlineprogramsParticipantsV3CompleteParticipantResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participant')) {
        result.participant = overrides && overrides.hasOwnProperty('participant') ? aWixOnlineprogramsParticipantsV3Participant(overrides.participant ?? {}, pickedFields.get('participant')) : aWixOnlineprogramsParticipantsV3Participant({}, pickedFields.get('participant'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'voluptatibus';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsResponse = <T extends Partial<WixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('failedCount')) {
        result.failedCount = overrides && overrides.hasOwnProperty('failedCount') ? overrides.failedCount! : 6810;
    }
    if (pickedFields.size === 0 || pickedFields.has('resolvedStepsTotal')) {
        result.resolvedStepsTotal = overrides && overrides.hasOwnProperty('resolvedStepsTotal') ? overrides.resolvedStepsTotal! : 5546;
    }
    if (pickedFields.size === 0 || pickedFields.has('successfulCount')) {
        result.successfulCount = overrides && overrides.hasOwnProperty('successfulCount') ? overrides.successfulCount! : 4132;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3DeleteParticipantRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3DeleteParticipantRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'non';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ExportParticipantsStatsRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3ExportParticipantsStatsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'voluptates';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3GetAccessStatusResponse = <T extends Partial<WixOnlineprogramsParticipantsV3GetAccessStatusResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('isBlocked')) {
        result.isBlocked = overrides && overrides.hasOwnProperty('isBlocked') ? overrides.isBlocked! : true;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3GetCompletionStatsRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3GetCompletionStatsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'ut';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3GetCompletionStatsResponse = <T extends Partial<WixOnlineprogramsParticipantsV3GetCompletionStatsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('completedAll')) {
        result.completedAll = overrides && overrides.hasOwnProperty('completedAll') ? overrides.completedAll! : 8978;
    }
    if (pickedFields.size === 0 || pickedFields.has('completionRate')) {
        result.completionRate = overrides && overrides.hasOwnProperty('completionRate') ? overrides.completionRate! : 7.21;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3GetParticipantRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3GetParticipantRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a68b396f-d70c-4085-b756-d07bf59918b4';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3GetPremiumStatsResponse = <T extends Partial<WixOnlineprogramsParticipantsV3GetPremiumStatsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activeParticipantsCount')) {
        result.activeParticipantsCount = overrides && overrides.hasOwnProperty('activeParticipantsCount') ? overrides.activeParticipantsCount! : 8548;
    }
    if (pickedFields.size === 0 || pickedFields.has('activeParticipantsLimit')) {
        result.activeParticipantsLimit = overrides && overrides.hasOwnProperty('activeParticipantsLimit') ? overrides.activeParticipantsLimit! : 6227;
    }
    if (pickedFields.size === 0 || pickedFields.has('hasPremium')) {
        result.hasPremium = overrides && overrides.hasOwnProperty('hasPremium') ? overrides.hasPremium! : true;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3GetProgramSummariesRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3GetProgramSummariesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programIds')) {
        result.programIds = overrides && overrides.hasOwnProperty('programIds') ? overrides.programIds! : ['facere'];
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3GetProgramSummariesResponse = <T extends Partial<WixOnlineprogramsParticipantsV3GetProgramSummariesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('summaries')) {
        result.summaries = overrides && overrides.hasOwnProperty('summaries') ? overrides.summaries!.map((x) => aWixOnlineprogramsParticipantsV3ParticipantsSummary(x ?? {}, pickedFields.get('summaries'))) : [aWixOnlineprogramsParticipantsV3ParticipantsSummary({}, pickedFields.get('summaries'))];
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3GetResolvedStepRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3GetResolvedStepRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('stepId')) {
        result.stepId = overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'beatae';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3GetResolvedStepResponse = <T extends Partial<WixOnlineprogramsParticipantsV3GetResolvedStepResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resolvedStep')) {
        result.resolvedStep = overrides && overrides.hasOwnProperty('resolvedStep') ? aWixOnlineprogramsParticipantsV3ResolvedStep(overrides.resolvedStep ?? {}, pickedFields.get('resolvedStep')) : aWixOnlineprogramsParticipantsV3ResolvedStep({}, pickedFields.get('resolvedStep'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3GetStatisticsRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3GetStatisticsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'molestias';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3GetStatisticsResponse = <T extends Partial<WixOnlineprogramsParticipantsV3GetStatisticsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalApprovalWaiting')) {
        result.totalApprovalWaiting = overrides && overrides.hasOwnProperty('totalApprovalWaiting') ? overrides.totalApprovalWaiting! : 439;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalCompleted')) {
        result.totalCompleted = overrides && overrides.hasOwnProperty('totalCompleted') ? overrides.totalCompleted! : 2684;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalFailed')) {
        result.totalFailed = overrides && overrides.hasOwnProperty('totalFailed') ? overrides.totalFailed! : 708;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalJoined')) {
        result.totalJoined = overrides && overrides.hasOwnProperty('totalJoined') ? overrides.totalJoined! : 2782;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalWithProgress')) {
        result.totalWithProgress = overrides && overrides.hasOwnProperty('totalWithProgress') ? overrides.totalWithProgress! : 2745;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalWithoutProgress')) {
        result.totalWithoutProgress = overrides && overrides.hasOwnProperty('totalWithoutProgress') ? overrides.totalWithoutProgress! : 1126;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3IssueCertificateRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3IssueCertificateRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'explicabo';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3IssueCertificateResponse = <T extends Partial<WixOnlineprogramsParticipantsV3IssueCertificateResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participant')) {
        result.participant = overrides && overrides.hasOwnProperty('participant') ? aWixOnlineprogramsParticipantsV3Participant(overrides.participant ?? {}, pickedFields.get('participant')) : aWixOnlineprogramsParticipantsV3Participant({}, pickedFields.get('participant'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3JoinProgramRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3JoinProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'id';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3JoinProgramResponse = <T extends Partial<WixOnlineprogramsParticipantsV3JoinProgramResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participant')) {
        result.participant = overrides && overrides.hasOwnProperty('participant') ? aWixOnlineprogramsParticipantsV3Participant(overrides.participant ?? {}, pickedFields.get('participant')) : aWixOnlineprogramsParticipantsV3Participant({}, pickedFields.get('participant'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3LeaveProgramRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3LeaveProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'ea';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ListResolvedStepsRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3ListResolvedStepsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'ut';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ListResolvedStepsResponse = <T extends Partial<WixOnlineprogramsParticipantsV3ListResolvedStepsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resolvedSteps')) {
        result.resolvedSteps = overrides && overrides.hasOwnProperty('resolvedSteps') ? overrides.resolvedSteps!.map((x) => aWixOnlineprogramsParticipantsV3ResolvedStep(x ?? {}, pickedFields.get('resolvedSteps'))) : [aWixOnlineprogramsParticipantsV3ResolvedStep({}, pickedFields.get('resolvedSteps'))];
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3Membership = <T extends Partial<WixOnlineprogramsParticipantsV3Membership>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('completedStepsCount')) {
        result.completedStepsCount = overrides && overrides.hasOwnProperty('completedStepsCount') ? overrides.completedStepsCount! : 2050;
    }
    if (pickedFields.size === 0 || pickedFields.has('participant')) {
        result.participant = overrides && overrides.hasOwnProperty('participant') ? aWixOnlineprogramsParticipantsV3Participant(overrides.participant ?? {}, pickedFields.get('participant')) : aWixOnlineprogramsParticipantsV3Participant({}, pickedFields.get('participant'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('state')) {
        result.state = overrides && overrides.hasOwnProperty('state') ? overrides.state! : WixOnlineprogramsParticipantsV3ParticipantState.ApprovalPending;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3Participant = <T extends Partial<WixOnlineprogramsParticipantsV3Participant>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoRemovedOptions')) {
        result.autoRemovedOptions = overrides && overrides.hasOwnProperty('autoRemovedOptions') ? aWixOnlineprogramsParticipantsV3ParticipantAutoRemovedOptions(overrides.autoRemovedOptions ?? {}, pickedFields.get('autoRemovedOptions')) : aWixOnlineprogramsParticipantsV3ParticipantAutoRemovedOptions({}, pickedFields.get('autoRemovedOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('certificate')) {
        result.certificate = overrides && overrides.hasOwnProperty('certificate') ? aWixOnlineprogramsParticipantsV3ParticipantCertificate(overrides.certificate ?? {}, pickedFields.get('certificate')) : aWixOnlineprogramsParticipantsV3ParticipantCertificate({}, pickedFields.get('certificate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('completedOptions')) {
        result.completedOptions = overrides && overrides.hasOwnProperty('completedOptions') ? aWixOnlineprogramsParticipantsV3ParticipantCompletedOptions(overrides.completedOptions ?? {}, pickedFields.get('completedOptions')) : aWixOnlineprogramsParticipantsV3ParticipantCompletedOptions({}, pickedFields.get('completedOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('failedOptions')) {
        result.failedOptions = overrides && overrides.hasOwnProperty('failedOptions') ? aWixOnlineprogramsParticipantsV3ParticipantFailedOptions(overrides.failedOptions ?? {}, pickedFields.get('failedOptions')) : aWixOnlineprogramsParticipantsV3ParticipantFailedOptions({}, pickedFields.get('failedOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('joinedOptions')) {
        result.joinedOptions = overrides && overrides.hasOwnProperty('joinedOptions') ? aWixOnlineprogramsParticipantsV3ParticipantJoinedOptions(overrides.joinedOptions ?? {}, pickedFields.get('joinedOptions')) : aWixOnlineprogramsParticipantsV3ParticipantJoinedOptions({}, pickedFields.get('joinedOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }
    if (pickedFields.size === 0 || pickedFields.has('memberId')) {
        result.memberId = overrides && overrides.hasOwnProperty('memberId') ? overrides.memberId! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentPendingOptions')) {
        result.paymentPendingOptions = overrides && overrides.hasOwnProperty('paymentPendingOptions') ? aWixOnlineprogramsParticipantsV3ParticipantPaymentPendingOptions(overrides.paymentPendingOptions ?? {}, pickedFields.get('paymentPendingOptions')) : aWixOnlineprogramsParticipantsV3ParticipantPaymentPendingOptions({}, pickedFields.get('paymentPendingOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('progress')) {
        result.progress = overrides && overrides.hasOwnProperty('progress') ? aWixOnlineprogramsParticipantsV3Progress(overrides.progress ?? {}, pickedFields.get('progress')) : aWixOnlineprogramsParticipantsV3Progress({}, pickedFields.get('progress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'quae';
    }
    if (pickedFields.size === 0 || pickedFields.has('state')) {
        result.state = overrides && overrides.hasOwnProperty('state') ? overrides.state! : WixOnlineprogramsParticipantsV3ParticipantState.ApprovalPending;
    }
    if (pickedFields.size === 0 || pickedFields.has('suspendedOptions')) {
        result.suspendedOptions = overrides && overrides.hasOwnProperty('suspendedOptions') ? aWixOnlineprogramsParticipantsV3ParticipantSuspendedOptions(overrides.suspendedOptions ?? {}, pickedFields.get('suspendedOptions')) : aWixOnlineprogramsParticipantsV3ParticipantSuspendedOptions({}, pickedFields.get('suspendedOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'unde';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantAutoRemovedOptions = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantAutoRemovedOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'qui';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantCertificate = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantCertificate>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('issuedDate')) {
        result.issuedDate = overrides && overrides.hasOwnProperty('issuedDate') ? overrides.issuedDate! : 'natus';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantCompletedOptions = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantCompletedOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'qui';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantFailedOptions = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantFailedOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'modi';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantJoinedOptions = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantJoinedOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('freeCouponOptions')) {
        result.freeCouponOptions = overrides && overrides.hasOwnProperty('freeCouponOptions') ? aWixOnlineprogramsParticipantsV3ParticipantJoinedOptionsFreeCouponOptions(overrides.freeCouponOptions ?? {}, pickedFields.get('freeCouponOptions')) : aWixOnlineprogramsParticipantsV3ParticipantJoinedOptionsFreeCouponOptions({}, pickedFields.get('freeCouponOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('joinPath')) {
        result.joinPath = overrides && overrides.hasOwnProperty('joinPath') ? overrides.joinPath! : WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsJoinPath.Added;
    }
    if (pickedFields.size === 0 || pickedFields.has('paidPlanOptions')) {
        result.paidPlanOptions = overrides && overrides.hasOwnProperty('paidPlanOptions') ? aWixOnlineprogramsParticipantsV3ParticipantJoinedOptionsPaidPlanOptions(overrides.paidPlanOptions ?? {}, pickedFields.get('paidPlanOptions')) : aWixOnlineprogramsParticipantsV3ParticipantJoinedOptionsPaidPlanOptions({}, pickedFields.get('paidPlanOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('singlePaymentOptions')) {
        result.singlePaymentOptions = overrides && overrides.hasOwnProperty('singlePaymentOptions') ? aWixOnlineprogramsParticipantsV3ParticipantJoinedOptionsSinglePaymentOptions(overrides.singlePaymentOptions ?? {}, pickedFields.get('singlePaymentOptions')) : aWixOnlineprogramsParticipantsV3ParticipantJoinedOptionsSinglePaymentOptions({}, pickedFields.get('singlePaymentOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'doloribus';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantJoinedOptionsFreeCouponOptions = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsFreeCouponOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('couponId')) {
        result.couponId = overrides && overrides.hasOwnProperty('couponId') ? overrides.couponId! : 'et';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantJoinedOptionsPaidPlanOptions = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsPaidPlanOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('planIds')) {
        result.planIds = overrides && overrides.hasOwnProperty('planIds') ? overrides.planIds! : ['maiores'];
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantJoinedOptionsSinglePaymentOptions = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsSinglePaymentOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'ut';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantPaymentPendingOptions = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantPaymentPendingOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('offlineTrxId')) {
        result.offlineTrxId = overrides && overrides.hasOwnProperty('offlineTrxId') ? overrides.offlineTrxId! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('paidPlanIds')) {
        result.paidPlanIds = overrides && overrides.hasOwnProperty('paidPlanIds') ? overrides.paidPlanIds! : ['suscipit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentOrderId')) {
        result.paymentOrderId = overrides && overrides.hasOwnProperty('paymentOrderId') ? overrides.paymentOrderId! : 'tempore';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantSuspendedOptions = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantSuspendedOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'aut';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantsBulkCompleteEventInput = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantsBulkCompleteEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorNext')) {
        result.cursorNext = overrides && overrides.hasOwnProperty('cursorNext') ? overrides.cursorNext! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'expedita';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantsBulkDeleteEventInput = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantsBulkDeleteEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorNext')) {
        result.cursorNext = overrides && overrides.hasOwnProperty('cursorNext') ? overrides.cursorNext! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'et';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ParticipantsSummary = <T extends Partial<WixOnlineprogramsParticipantsV3ParticipantsSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('membership')) {
        result.membership = overrides && overrides.hasOwnProperty('membership') ? aWixOnlineprogramsParticipantsV3Membership(overrides.membership ?? {}, pickedFields.get('membership')) : aWixOnlineprogramsParticipantsV3Membership({}, pickedFields.get('membership'));
    }
    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3Program(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('program'));
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('statistic')) {
        result.statistic = overrides && overrides.hasOwnProperty('statistic') ? aWixOnlineprogramsParticipantsV3Statistic(overrides.statistic ?? {}, pickedFields.get('statistic')) : aWixOnlineprogramsParticipantsV3Statistic({}, pickedFields.get('statistic'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ProgramSummary = <T extends Partial<WixOnlineprogramsParticipantsV3ProgramSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('membership')) {
        result.membership = overrides && overrides.hasOwnProperty('membership') ? aWixOnlineprogramsParticipantsV3Membership(overrides.membership ?? {}, pickedFields.get('membership')) : aWixOnlineprogramsParticipantsV3Membership({}, pickedFields.get('membership'));
    }
    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3Program(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('program'));
    }
    if (pickedFields.size === 0 || pickedFields.has('statistic')) {
        result.statistic = overrides && overrides.hasOwnProperty('statistic') ? aWixOnlineprogramsParticipantsV3Statistic(overrides.statistic ?? {}, pickedFields.get('statistic')) : aWixOnlineprogramsParticipantsV3Statistic({}, pickedFields.get('statistic'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3Progress = <T extends Partial<WixOnlineprogramsParticipantsV3Progress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('completionPercentage')) {
        result.completionPercentage = overrides && overrides.hasOwnProperty('completionPercentage') ? overrides.completionPercentage! : 6.45;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalStepsAvailable')) {
        result.totalStepsAvailable = overrides && overrides.hasOwnProperty('totalStepsAvailable') ? overrides.totalStepsAvailable! : 3055;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalStepsCompleted')) {
        result.totalStepsCompleted = overrides && overrides.hasOwnProperty('totalStepsCompleted') ? overrides.totalStepsCompleted! : 6709;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3QueryParticipantsRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3QueryParticipantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3QueryParticipantsResponse = <T extends Partial<WixOnlineprogramsParticipantsV3QueryParticipantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixOnlineprogramsParticipantsV3Participant(x ?? {}, pickedFields.get('items'))) : [aWixOnlineprogramsParticipantsV3Participant({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3QueryProgramSummariesRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3QueryProgramSummariesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3QueryProgramSummariesResponse = <T extends Partial<WixOnlineprogramsParticipantsV3QueryProgramSummariesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('summaries')) {
        result.summaries = overrides && overrides.hasOwnProperty('summaries') ? overrides.summaries!.map((x) => aWixOnlineprogramsParticipantsV3ProgramSummary(x ?? {}, pickedFields.get('summaries'))) : [aWixOnlineprogramsParticipantsV3ProgramSummary({}, pickedFields.get('summaries'))];
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3QueryResolvedStepsRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3QueryResolvedStepsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3QueryResolvedStepsResponse = <T extends Partial<WixOnlineprogramsParticipantsV3QueryResolvedStepsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('resolvedSteps')) {
        result.resolvedSteps = overrides && overrides.hasOwnProperty('resolvedSteps') ? overrides.resolvedSteps!.map((x) => aWixOnlineprogramsParticipantsV3ResolvedStep(x ?? {}, pickedFields.get('resolvedSteps'))) : [aWixOnlineprogramsParticipantsV3ResolvedStep({}, pickedFields.get('resolvedSteps'))];
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ResolveStepRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3ResolveStepRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('quizSubmissionId')) {
        result.quizSubmissionId = overrides && overrides.hasOwnProperty('quizSubmissionId') ? overrides.quizSubmissionId! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('stepId')) {
        result.stepId = overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'ea';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ResolveStepResponse = <T extends Partial<WixOnlineprogramsParticipantsV3ResolveStepResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('resolvedStep')) {
        result.resolvedStep = overrides && overrides.hasOwnProperty('resolvedStep') ? aWixOnlineprogramsParticipantsV3ResolvedStep(overrides.resolvedStep ?? {}, pickedFields.get('resolvedStep')) : aWixOnlineprogramsParticipantsV3ResolvedStep({}, pickedFields.get('resolvedStep'));
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ResolvedStep = <T extends Partial<WixOnlineprogramsParticipantsV3ResolvedStep>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('earnedScore')) {
        result.earnedScore = overrides && overrides.hasOwnProperty('earnedScore') ? overrides.earnedScore! : 1446;
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participant')) {
        result.participant = overrides && overrides.hasOwnProperty('participant') ? aWixOnlineprogramsParticipantsV3Participant(overrides.participant ?? {}, pickedFields.get('participant')) : aWixOnlineprogramsParticipantsV3Participant({}, pickedFields.get('participant'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('passingGrade')) {
        result.passingGrade = overrides && overrides.hasOwnProperty('passingGrade') ? overrides.passingGrade! : 3159;
    }
    if (pickedFields.size === 0 || pickedFields.has('programStepId')) {
        result.programStepId = overrides && overrides.hasOwnProperty('programStepId') ? overrides.programStepId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('quizSubmissionId')) {
        result.quizSubmissionId = overrides && overrides.hasOwnProperty('quizSubmissionId') ? overrides.quizSubmissionId! : 'expedita';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixOnlineprogramsParticipantsV3ResolvedStepStatus.Completed;
    }
    if (pickedFields.size === 0 || pickedFields.has('step')) {
        result.step = overrides && overrides.hasOwnProperty('step') ? aWixOnlineprogramsStepsV3Step(overrides.step ?? {}, pickedFields.get('step')) : aWixOnlineprogramsStepsV3Step({}, pickedFields.get('step'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'vel';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3ResolvedStepInput = <T extends Partial<WixOnlineprogramsParticipantsV3ResolvedStepInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('earnedScore')) {
        result.earnedScore = overrides && overrides.hasOwnProperty('earnedScore') ? overrides.earnedScore! : 95;
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('passingGrade')) {
        result.passingGrade = overrides && overrides.hasOwnProperty('passingGrade') ? overrides.passingGrade! : 320;
    }
    if (pickedFields.size === 0 || pickedFields.has('programStepId')) {
        result.programStepId = overrides && overrides.hasOwnProperty('programStepId') ? overrides.programStepId! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('quizSubmissionId')) {
        result.quizSubmissionId = overrides && overrides.hasOwnProperty('quizSubmissionId') ? overrides.quizSubmissionId! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixOnlineprogramsParticipantsV3ResolvedStepStatus.Completed;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'praesentium';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3RevertCouponRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3RevertCouponRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('couponId')) {
        result.couponId = overrides && overrides.hasOwnProperty('couponId') ? overrides.couponId! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'ut';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3RevertCouponResponse = <T extends Partial<WixOnlineprogramsParticipantsV3RevertCouponResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 0.92;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3Statistic = <T extends Partial<WixOnlineprogramsParticipantsV3Statistic>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('approvalPending')) {
        result.approvalPending = overrides && overrides.hasOwnProperty('approvalPending') ? overrides.approvalPending! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('completed')) {
        result.completed = overrides && overrides.hasOwnProperty('completed') ? overrides.completed! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('failed')) {
        result.failed = overrides && overrides.hasOwnProperty('failed') ? overrides.failed! : 'sequi';
    }
    if (pickedFields.size === 0 || pickedFields.has('inProgress')) {
        result.inProgress = overrides && overrides.hasOwnProperty('inProgress') ? overrides.inProgress! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('invited')) {
        result.invited = overrides && overrides.hasOwnProperty('invited') ? overrides.invited! : 'natus';
    }
    if (pickedFields.size === 0 || pickedFields.has('joined')) {
        result.joined = overrides && overrides.hasOwnProperty('joined') ? overrides.joined! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentPending')) {
        result.paymentPending = overrides && overrides.hasOwnProperty('paymentPending') ? overrides.paymentPending! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('suspended')) {
        result.suspended = overrides && overrides.hasOwnProperty('suspended') ? overrides.suspended! : 'necessitatibus';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3UndoStepRequestInput = <T extends Partial<WixOnlineprogramsParticipantsV3UndoStepRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('stepId')) {
        result.stepId = overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'occaecati';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3UpstreamWixCommonBulkActionMetadata = <T extends Partial<WixOnlineprogramsParticipantsV3UpstreamWixCommonBulkActionMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalFailures')) {
        result.totalFailures = overrides && overrides.hasOwnProperty('totalFailures') ? overrides.totalFailures! : 8376;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalSuccesses')) {
        result.totalSuccesses = overrides && overrides.hasOwnProperty('totalSuccesses') ? overrides.totalSuccesses! : 6696;
    }
    if (pickedFields.size === 0 || pickedFields.has('undetailedFailures')) {
        result.undetailedFailures = overrides && overrides.hasOwnProperty('undetailedFailures') ? overrides.undetailedFailures! : 8224;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingInput = <T extends Partial<WixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3999;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingMetadata = <T extends Partial<WixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 1042;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixOnlineprogramsParticipantsV3UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixOnlineprogramsParticipantsV3UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3UpstreamWixCommonCursors = <T extends Partial<WixOnlineprogramsParticipantsV3UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'id';
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3UpstreamWixCommonItemMetadata = <T extends Partial<WixOnlineprogramsParticipantsV3UpstreamWixCommonItemMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiApplicationError(overrides.error ?? {}, pickedFields.get('error')) : aWixApiApplicationError({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalIndex')) {
        result.originalIndex = overrides && overrides.hasOwnProperty('originalIndex') ? overrides.originalIndex! : 8021;
    }
    if (pickedFields.size === 0 || pickedFields.has('success')) {
        result.success = overrides && overrides.hasOwnProperty('success') ? overrides.success! : false;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3UpstreamWixCommonSortingInput = <T extends Partial<WixOnlineprogramsParticipantsV3UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixOnlineprogramsParticipantsV3UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput = <T extends Partial<WixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixOnlineprogramsParticipantsV3UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixOnlineprogramsParticipantsV3UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3ArchiveProgramRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3ArchiveProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'perferendis';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3ArchiveProgramResponse = <T extends Partial<WixOnlineprogramsProgramsV3ArchiveProgramResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3Program(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('program'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programs')) {
        result.programs = overrides && overrides.hasOwnProperty('programs') ? overrides.programs!.map((x) => aWixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestProgramMigrationInput({}, pickedFields.get('programs'))) : [aWixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestProgramMigrationInput({}, pickedFields.get('programs'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestProgramMigrationInput = <T extends Partial<WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestProgramMigrationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3ProgramInput(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3ProgramInput({}, pickedFields.get('program'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sectionIds')) {
        result.sectionIds = overrides && overrides.hasOwnProperty('sectionIds') ? overrides.sectionIds! : ['similique'];
    }
    if (pickedFields.size === 0 || pickedFields.has('stepIds')) {
        result.stepIds = overrides && overrides.hasOwnProperty('stepIds') ? overrides.stepIds! : ['vel'];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3BulkCreateProgramsMigrationResponse = <T extends Partial<WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsProgramsV3BulkProgramResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsProgramsV3BulkProgramResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3BulkProgramResult = <T extends Partial<WixOnlineprogramsProgramsV3BulkProgramResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('action')) {
        result.action = overrides && overrides.hasOwnProperty('action') ? overrides.action! : WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionType.Delete;
    }
    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixOnlineprogramsProgramsV3Program(overrides.item ?? {}, pickedFields.get('item')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3BulkUpdateProgramsRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3BulkUpdateProgramsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programs')) {
        result.programs = overrides && overrides.hasOwnProperty('programs') ? overrides.programs!.map((x) => aWixOnlineprogramsProgramsV3BulkUpdateProgramsRequestMaskedProgramInput({}, pickedFields.get('programs'))) : [aWixOnlineprogramsProgramsV3BulkUpdateProgramsRequestMaskedProgramInput({}, pickedFields.get('programs'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3BulkUpdateProgramsRequestMaskedProgramInput = <T extends Partial<WixOnlineprogramsProgramsV3BulkUpdateProgramsRequestMaskedProgramInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['alias'];
    }
    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3ProgramInput(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3ProgramInput({}, pickedFields.get('program'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3BulkUpdateProgramsResponse = <T extends Partial<WixOnlineprogramsProgramsV3BulkUpdateProgramsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsProgramsV3BulkUpdateProgramsResponseBulkUpdateProgramResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsProgramsV3BulkUpdateProgramsResponseBulkUpdateProgramResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3BulkUpdateProgramsResponseBulkUpdateProgramResult = <T extends Partial<WixOnlineprogramsProgramsV3BulkUpdateProgramsResponseBulkUpdateProgramResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixOnlineprogramsProgramsV3Program(overrides.item ?? {}, pickedFields.get('item')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3ContentSummary = <T extends Partial<WixOnlineprogramsProgramsV3ContentSummary>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sectionCount')) {
        result.sectionCount = overrides && overrides.hasOwnProperty('sectionCount') ? overrides.sectionCount! : 8628;
    }
    if (pickedFields.size === 0 || pickedFields.has('stepCount')) {
        result.stepCount = overrides && overrides.hasOwnProperty('stepCount') ? overrides.stepCount! : 1700;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3ContentSummaryInput = <T extends Partial<WixOnlineprogramsProgramsV3ContentSummaryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sectionCount')) {
        result.sectionCount = overrides && overrides.hasOwnProperty('sectionCount') ? overrides.sectionCount! : 4450;
    }
    if (pickedFields.size === 0 || pickedFields.has('stepCount')) {
        result.stepCount = overrides && overrides.hasOwnProperty('stepCount') ? overrides.stepCount! : 4958;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3CountProgramsRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3CountProgramsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'repellat';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3CountProgramsResponse = <T extends Partial<WixOnlineprogramsProgramsV3CountProgramsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 1829;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3CreateProgramRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3CreateProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3ProgramInput(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3ProgramInput({}, pickedFields.get('program'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3CreateProgramResponse = <T extends Partial<WixOnlineprogramsProgramsV3CreateProgramResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3Program(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('program'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3DeleteProgramRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3DeleteProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'vitae';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3Description = <T extends Partial<WixOnlineprogramsProgramsV3Description>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideoV2(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideoV2({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3DescriptionInput = <T extends Partial<WixOnlineprogramsProgramsV3DescriptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideoV2Input(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideoV2Input({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3DuplicateProgramRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3DuplicateProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'earum';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3DuplicateProgramResponse = <T extends Partial<WixOnlineprogramsProgramsV3DuplicateProgramResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3Program(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('program'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3EndProgramRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3EndProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'id';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3EndProgramResponse = <T extends Partial<WixOnlineprogramsProgramsV3EndProgramResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3Program(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('program'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3GetProgramMembershipRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3GetProgramMembershipRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'beatae';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3GetProgramMembershipResponse = <T extends Partial<WixOnlineprogramsProgramsV3GetProgramMembershipResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programMembership')) {
        result.programMembership = overrides && overrides.hasOwnProperty('programMembership') ? aWixOnlineprogramsProgramsV3ProgramMembership(overrides.programMembership ?? {}, pickedFields.get('programMembership')) : aWixOnlineprogramsProgramsV3ProgramMembership({}, pickedFields.get('programMembership'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3GetProgramRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3GetProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '672fbd80-f0c2-4c1c-8058-b431c014ec8c';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3ListProgramMembershipsRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3ListProgramMembershipsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3ListProgramMembershipsResponse = <T extends Partial<WixOnlineprogramsProgramsV3ListProgramMembershipsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('programMemberships')) {
        result.programMemberships = overrides && overrides.hasOwnProperty('programMemberships') ? overrides.programMemberships!.map((x) => aWixOnlineprogramsProgramsV3ProgramMembership(x ?? {}, pickedFields.get('programMemberships'))) : [aWixOnlineprogramsProgramsV3ProgramMembership({}, pickedFields.get('programMemberships'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3ListSampleProgramsResponse = <T extends Partial<WixOnlineprogramsProgramsV3ListSampleProgramsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programs')) {
        result.programs = overrides && overrides.hasOwnProperty('programs') ? overrides.programs!.map((x) => aWixOnlineprogramsProgramsV3Program(x ?? {}, pickedFields.get('programs'))) : [aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('programs'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3Membership = <T extends Partial<WixOnlineprogramsProgramsV3Membership>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('participant')) {
        result.participant = overrides && overrides.hasOwnProperty('participant') ? aWixOnlineprogramsParticipantsV3Participant(overrides.participant ?? {}, pickedFields.get('participant')) : aWixOnlineprogramsParticipantsV3Participant({}, pickedFields.get('participant'));
    }
    if (pickedFields.size === 0 || pickedFields.has('participantId')) {
        result.participantId = overrides && overrides.hasOwnProperty('participantId') ? overrides.participantId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantState')) {
        result.participantState = overrides && overrides.hasOwnProperty('participantState') ? overrides.participantState! : WixOnlineprogramsProgramsV3MembershipParticipantState.Completed;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3Program = <T extends Partial<WixOnlineprogramsProgramsV3Program>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accessType')) {
        result.accessType = overrides && overrides.hasOwnProperty('accessType') ? overrides.accessType! : WixOnlineprogramsProgramsV3AccessType.Private;
    }
    if (pickedFields.size === 0 || pickedFields.has('categoryIds')) {
        result.categoryIds = overrides && overrides.hasOwnProperty('categoryIds') ? overrides.categoryIds! : ['deleniti'];
    }
    if (pickedFields.size === 0 || pickedFields.has('contentSummary')) {
        result.contentSummary = overrides && overrides.hasOwnProperty('contentSummary') ? aWixOnlineprogramsProgramsV3ContentSummary(overrides.contentSummary ?? {}, pickedFields.get('contentSummary')) : aWixOnlineprogramsProgramsV3ContentSummary({}, pickedFields.get('contentSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixOnlineprogramsProgramsV3Description(overrides.description ?? {}, pickedFields.get('description')) : aWixOnlineprogramsProgramsV3Description({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('ownerUserId')) {
        result.ownerUserId = overrides && overrides.hasOwnProperty('ownerUserId') ? overrides.ownerUserId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('participantsVirtualReference')) {
        result.participantsVirtualReference = overrides && overrides.hasOwnProperty('participantsVirtualReference') ? aWixOnlineprogramsParticipantsV3QueryParticipantsResponse(overrides.participantsVirtualReference ?? {}, pickedFields.get('participantsVirtualReference')) : aWixOnlineprogramsParticipantsV3QueryParticipantsResponse({}, pickedFields.get('participantsVirtualReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonMoney(overrides.price ?? {}, pickedFields.get('price')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonMoney({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('restrictions')) {
        result.restrictions = overrides && overrides.hasOwnProperty('restrictions') ? aWixOnlineprogramsProgramsV3Restrictions(overrides.restrictions ?? {}, pickedFields.get('restrictions')) : aWixOnlineprogramsProgramsV3Restrictions({}, pickedFields.get('restrictions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('rewards')) {
        result.rewards = overrides && overrides.hasOwnProperty('rewards') ? overrides.rewards!.map((x) => aWixOnlineprogramsProgramsV3Reward(x ?? {}, pickedFields.get('rewards'))) : [aWixOnlineprogramsProgramsV3Reward({}, pickedFields.get('rewards'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('seo')) {
        result.seo = overrides && overrides.hasOwnProperty('seo') ? aWixOnlineprogramsProgramsV3Seo(overrides.seo ?? {}, pickedFields.get('seo')) : aWixOnlineprogramsProgramsV3Seo({}, pickedFields.get('seo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shouldSendInvoice')) {
        result.shouldSendInvoice = overrides && overrides.hasOwnProperty('shouldSendInvoice') ? overrides.shouldSendInvoice! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('socialGroupId')) {
        result.socialGroupId = overrides && overrides.hasOwnProperty('socialGroupId') ? overrides.socialGroupId! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('state')) {
        result.state = overrides && overrides.hasOwnProperty('state') ? overrides.state! : WixOnlineprogramsProgramsV3State.Archived;
    }
    if (pickedFields.size === 0 || pickedFields.has('stateUpdatedDate')) {
        result.stateUpdatedDate = overrides && overrides.hasOwnProperty('stateUpdatedDate') ? overrides.stateUpdatedDate! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeline')) {
        result.timeline = overrides && overrides.hasOwnProperty('timeline') ? aWixOnlineprogramsProgramsV3Timeline(overrides.timeline ?? {}, pickedFields.get('timeline')) : aWixOnlineprogramsProgramsV3Timeline({}, pickedFields.get('timeline'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('videoStepsSettings')) {
        result.videoStepsSettings = overrides && overrides.hasOwnProperty('videoStepsSettings') ? aWixOnlineprogramsProgramsV3VideoStepsSettings(overrides.videoStepsSettings ?? {}, pickedFields.get('videoStepsSettings')) : aWixOnlineprogramsProgramsV3VideoStepsSettings({}, pickedFields.get('videoStepsSettings'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3ProgramInput = <T extends Partial<WixOnlineprogramsProgramsV3ProgramInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accessType')) {
        result.accessType = overrides && overrides.hasOwnProperty('accessType') ? overrides.accessType! : WixOnlineprogramsProgramsV3AccessType.Private;
    }
    if (pickedFields.size === 0 || pickedFields.has('categoryIds')) {
        result.categoryIds = overrides && overrides.hasOwnProperty('categoryIds') ? overrides.categoryIds! : ['accusamus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('contentSummary')) {
        result.contentSummary = overrides && overrides.hasOwnProperty('contentSummary') ? aWixOnlineprogramsProgramsV3ContentSummaryInput(overrides.contentSummary ?? {}, pickedFields.get('contentSummary')) : aWixOnlineprogramsProgramsV3ContentSummaryInput({}, pickedFields.get('contentSummary'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixOnlineprogramsProgramsV3DescriptionInput(overrides.description ?? {}, pickedFields.get('description')) : aWixOnlineprogramsProgramsV3DescriptionInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('ownerUserId')) {
        result.ownerUserId = overrides && overrides.hasOwnProperty('ownerUserId') ? overrides.ownerUserId! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonMoneyInput(overrides.price ?? {}, pickedFields.get('price')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonMoneyInput({}, pickedFields.get('price'));
    }
    if (pickedFields.size === 0 || pickedFields.has('restrictions')) {
        result.restrictions = overrides && overrides.hasOwnProperty('restrictions') ? aWixOnlineprogramsProgramsV3RestrictionsInput(overrides.restrictions ?? {}, pickedFields.get('restrictions')) : aWixOnlineprogramsProgramsV3RestrictionsInput({}, pickedFields.get('restrictions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('rewards')) {
        result.rewards = overrides && overrides.hasOwnProperty('rewards') ? overrides.rewards!.map((x) => aWixOnlineprogramsProgramsV3RewardInput({}, pickedFields.get('rewards'))) : [aWixOnlineprogramsProgramsV3RewardInput({}, pickedFields.get('rewards'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('seo')) {
        result.seo = overrides && overrides.hasOwnProperty('seo') ? aWixOnlineprogramsProgramsV3SeoInput(overrides.seo ?? {}, pickedFields.get('seo')) : aWixOnlineprogramsProgramsV3SeoInput({}, pickedFields.get('seo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shouldSendInvoice')) {
        result.shouldSendInvoice = overrides && overrides.hasOwnProperty('shouldSendInvoice') ? overrides.shouldSendInvoice! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('socialGroupId')) {
        result.socialGroupId = overrides && overrides.hasOwnProperty('socialGroupId') ? overrides.socialGroupId! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('state')) {
        result.state = overrides && overrides.hasOwnProperty('state') ? overrides.state! : WixOnlineprogramsProgramsV3State.Archived;
    }
    if (pickedFields.size === 0 || pickedFields.has('stateUpdatedDate')) {
        result.stateUpdatedDate = overrides && overrides.hasOwnProperty('stateUpdatedDate') ? overrides.stateUpdatedDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('timeline')) {
        result.timeline = overrides && overrides.hasOwnProperty('timeline') ? aWixOnlineprogramsProgramsV3TimelineInput(overrides.timeline ?? {}, pickedFields.get('timeline')) : aWixOnlineprogramsProgramsV3TimelineInput({}, pickedFields.get('timeline'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('videoStepsSettings')) {
        result.videoStepsSettings = overrides && overrides.hasOwnProperty('videoStepsSettings') ? aWixOnlineprogramsProgramsV3VideoStepsSettingsInput(overrides.videoStepsSettings ?? {}, pickedFields.get('videoStepsSettings')) : aWixOnlineprogramsProgramsV3VideoStepsSettingsInput({}, pickedFields.get('videoStepsSettings'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3ProgramMembership = <T extends Partial<WixOnlineprogramsProgramsV3ProgramMembership>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('membership')) {
        result.membership = overrides && overrides.hasOwnProperty('membership') ? aWixOnlineprogramsProgramsV3Membership(overrides.membership ?? {}, pickedFields.get('membership')) : aWixOnlineprogramsProgramsV3Membership({}, pickedFields.get('membership'));
    }
    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3Program(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('program'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3PublishProgramRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3PublishProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'qui';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3PublishProgramResponse = <T extends Partial<WixOnlineprogramsProgramsV3PublishProgramResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3Program(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('program'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3QueryProgramsRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3QueryProgramsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3QueryProgramsResponse = <T extends Partial<WixOnlineprogramsProgramsV3QueryProgramsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixOnlineprogramsProgramsV3Program(x ?? {}, pickedFields.get('items'))) : [aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3ResolveProgramSlugRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3ResolveProgramSlugRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'impedit';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3ResolveProgramSlugResponse = <T extends Partial<WixOnlineprogramsProgramsV3ResolveProgramSlugResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3Program(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('program'));
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'vel';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3Restrictions = <T extends Partial<WixOnlineprogramsProgramsV3Restrictions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hideFutureSteps')) {
        result.hideFutureSteps = overrides && overrides.hasOwnProperty('hideFutureSteps') ? overrides.hideFutureSteps! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxParticipants')) {
        result.maxParticipants = overrides && overrides.hasOwnProperty('maxParticipants') ? overrides.maxParticipants! : 7558;
    }
    if (pickedFields.size === 0 || pickedFields.has('resolveStepsInOrder')) {
        result.resolveStepsInOrder = overrides && overrides.hasOwnProperty('resolveStepsInOrder') ? overrides.resolveStepsInOrder! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('shareProgress')) {
        result.shareProgress = overrides && overrides.hasOwnProperty('shareProgress') ? overrides.shareProgress! : false;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3RestrictionsInput = <T extends Partial<WixOnlineprogramsProgramsV3RestrictionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('hideFutureSteps')) {
        result.hideFutureSteps = overrides && overrides.hasOwnProperty('hideFutureSteps') ? overrides.hideFutureSteps! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxParticipants')) {
        result.maxParticipants = overrides && overrides.hasOwnProperty('maxParticipants') ? overrides.maxParticipants! : 6053;
    }
    if (pickedFields.size === 0 || pickedFields.has('resolveStepsInOrder')) {
        result.resolveStepsInOrder = overrides && overrides.hasOwnProperty('resolveStepsInOrder') ? overrides.resolveStepsInOrder! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('shareProgress')) {
        result.shareProgress = overrides && overrides.hasOwnProperty('shareProgress') ? overrides.shareProgress! : false;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3Reward = <T extends Partial<WixOnlineprogramsProgramsV3Reward>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('badgeIds')) {
        result.badgeIds = overrides && overrides.hasOwnProperty('badgeIds') ? overrides.badgeIds! : ['iure'];
    }
    if (pickedFields.size === 0 || pickedFields.has('certificate')) {
        result.certificate = overrides && overrides.hasOwnProperty('certificate') ? aWixOnlineprogramsProgramsV3RewardCertificate(overrides.certificate ?? {}, pickedFields.get('certificate')) : aWixOnlineprogramsProgramsV3RewardCertificate({}, pickedFields.get('certificate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('trigger')) {
        result.trigger = overrides && overrides.hasOwnProperty('trigger') ? overrides.trigger! : WixOnlineprogramsProgramsV3RewardTrigger.AllStepsCompleted;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3RewardCertificate = <T extends Partial<WixOnlineprogramsProgramsV3RewardCertificate>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('connectedDate')) {
        result.connectedDate = overrides && overrides.hasOwnProperty('connectedDate') ? overrides.connectedDate! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aliquid';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3RewardCertificateInput = <T extends Partial<WixOnlineprogramsProgramsV3RewardCertificateInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('connectedDate')) {
        result.connectedDate = overrides && overrides.hasOwnProperty('connectedDate') ? overrides.connectedDate! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'temporibus';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3RewardInput = <T extends Partial<WixOnlineprogramsProgramsV3RewardInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('badgeIds')) {
        result.badgeIds = overrides && overrides.hasOwnProperty('badgeIds') ? overrides.badgeIds! : ['ea'];
    }
    if (pickedFields.size === 0 || pickedFields.has('certificate')) {
        result.certificate = overrides && overrides.hasOwnProperty('certificate') ? aWixOnlineprogramsProgramsV3RewardCertificateInput(overrides.certificate ?? {}, pickedFields.get('certificate')) : aWixOnlineprogramsProgramsV3RewardCertificateInput({}, pickedFields.get('certificate'));
    }
    if (pickedFields.size === 0 || pickedFields.has('trigger')) {
        result.trigger = overrides && overrides.hasOwnProperty('trigger') ? overrides.trigger! : WixOnlineprogramsProgramsV3RewardTrigger.AllStepsCompleted;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3SearchProgramsRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3SearchProgramsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorSearchInput(overrides.search ?? {}, pickedFields.get('search')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorSearchInput({}, pickedFields.get('search'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3SearchProgramsResponse = <T extends Partial<WixOnlineprogramsProgramsV3SearchProgramsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregationData')) {
        result.aggregationData = overrides && overrides.hasOwnProperty('aggregationData') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationData(overrides.aggregationData ?? {}, pickedFields.get('aggregationData')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationData({}, pickedFields.get('aggregationData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('programs')) {
        result.programs = overrides && overrides.hasOwnProperty('programs') ? overrides.programs!.map((x) => aWixOnlineprogramsProgramsV3Program(x ?? {}, pickedFields.get('programs'))) : [aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('programs'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3Seo = <T extends Partial<WixOnlineprogramsProgramsV3Seo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('courseWorkload')) {
        result.courseWorkload = overrides && overrides.hasOwnProperty('courseWorkload') ? overrides.courseWorkload! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('imageAlt')) {
        result.imageAlt = overrides && overrides.hasOwnProperty('imageAlt') ? overrides.imageAlt! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('imageUrl')) {
        result.imageUrl = overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'natus';
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchema(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchema({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrl(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrl({}, pickedFields.get('url'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3SeoInput = <T extends Partial<WixOnlineprogramsProgramsV3SeoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('courseWorkload')) {
        result.courseWorkload = overrides && overrides.hasOwnProperty('courseWorkload') ? overrides.courseWorkload! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('imageAlt')) {
        result.imageAlt = overrides && overrides.hasOwnProperty('imageAlt') ? overrides.imageAlt! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('imageUrl')) {
        result.imageUrl = overrides && overrides.hasOwnProperty('imageUrl') ? overrides.imageUrl! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('seoData')) {
        result.seoData = overrides && overrides.hasOwnProperty('seoData') ? aComWixpressAdvancedSeoSeoSchemaInput(overrides.seoData ?? {}, pickedFields.get('seoData')) : aComWixpressAdvancedSeoSeoSchemaInput({}, pickedFields.get('seoData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? aWixCommonPageUrlInput(overrides.url ?? {}, pickedFields.get('url')) : aWixCommonPageUrlInput({}, pickedFields.get('url'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3Timeline = <T extends Partial<WixOnlineprogramsProgramsV3Timeline>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durationInDays')) {
        result.durationInDays = overrides && overrides.hasOwnProperty('durationInDays') ? overrides.durationInDays! : 6526;
    }
    if (pickedFields.size === 0 || pickedFields.has('selfPaced')) {
        result.selfPaced = overrides && overrides.hasOwnProperty('selfPaced') ? overrides.selfPaced! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'ab';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3TimelineInput = <T extends Partial<WixOnlineprogramsProgramsV3TimelineInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durationInDays')) {
        result.durationInDays = overrides && overrides.hasOwnProperty('durationInDays') ? overrides.durationInDays! : 1202;
    }
    if (pickedFields.size === 0 || pickedFields.has('selfPaced')) {
        result.selfPaced = overrides && overrides.hasOwnProperty('selfPaced') ? overrides.selfPaced! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'sint';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3TimelineTimeEvaluationOptions = <T extends Partial<WixOnlineprogramsProgramsV3TimelineTimeEvaluationOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durationInDays')) {
        result.durationInDays = overrides && overrides.hasOwnProperty('durationInDays') ? overrides.durationInDays! : 996;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3TimelineTimeEvaluationOptionsInput = <T extends Partial<WixOnlineprogramsProgramsV3TimelineTimeEvaluationOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durationInDays')) {
        result.durationInDays = overrides && overrides.hasOwnProperty('durationInDays') ? overrides.durationInDays! : 143;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpdateProgramRequestInput = <T extends Partial<WixOnlineprogramsProgramsV3UpdateProgramRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['aut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3ProgramInput(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3ProgramInput({}, pickedFields.get('program'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpdateProgramResponse = <T extends Partial<WixOnlineprogramsProgramsV3UpdateProgramResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('program')) {
        result.program = overrides && overrides.hasOwnProperty('program') ? aWixOnlineprogramsProgramsV3Program(overrides.program ?? {}, pickedFields.get('program')) : aWixOnlineprogramsProgramsV3Program({}, pickedFields.get('program'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationData = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResults(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResults({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResults = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('groupedByValue')) {
        result.groupedByValue = overrides && overrides.hasOwnProperty('groupedByValue') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults(overrides.groupedByValue ?? {}, pickedFields.get('groupedByValue')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults({}, pickedFields.get('groupedByValue'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('nested')) {
        result.nested = overrides && overrides.hasOwnProperty('nested') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResults(overrides.nested ?? {}, pickedFields.get('nested')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResults({}, pickedFields.get('nested'));
    }
    if (pickedFields.size === 0 || pickedFields.has('ranges')) {
        result.ranges = overrides && overrides.hasOwnProperty('ranges') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults(overrides.ranges ?? {}, pickedFields.get('ranges')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults({}, pickedFields.get('ranges'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults(overrides.values ?? {}, pickedFields.get('values')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults({}, pickedFields.get('values'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 341;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'ab';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nestedResults')) {
        result.nestedResults = overrides && overrides.hasOwnProperty('nestedResults') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults(overrides.nestedResults ?? {}, pickedFields.get('nestedResults')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults({}, pickedFields.get('nestedResults'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'iste';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('ranges')) {
        result.ranges = overrides && overrides.hasOwnProperty('ranges') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults(overrides.ranges ?? {}, pickedFields.get('ranges')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults({}, pickedFields.get('ranges'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults(overrides.values ?? {}, pickedFields.get('values')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults({}, pickedFields.get('values'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResults = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult(overrides.range ?? {}, pickedFields.get('range')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult(overrides.value ?? {}, pickedFields.get('value')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 9094;
    }
    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 2.19;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 2.31;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue(overrides.results ?? {}, pickedFields.get('results')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue({}, pickedFields.get('results'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 4.51;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 5258;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'iure';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 6862;
    }
    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 2.36;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 4.76;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixOnlineprogramsProgramsV3UpstreamWixCommonScalarType.Avg;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 6.63;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3550;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'perferendis';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('interval')) {
        result.interval = overrides && overrides.hasOwnProperty('interval') ? overrides.interval! : WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInterval.Day;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationGroupByAggregationInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationGroupByAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('nested')) {
        result.nested = overrides && overrides.hasOwnProperty('nested') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationInput(overrides.nested ?? {}, pickedFields.get('nested')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationInput({}, pickedFields.get('nested'));
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput(overrides.range ?? {}, pickedFields.get('range')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nestedAggregations')) {
        result.nestedAggregations = overrides && overrides.hasOwnProperty('nestedAggregations') ? overrides.nestedAggregations!.map((x) => aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput({}, pickedFields.get('nestedAggregations'))) : [aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput({}, pickedFields.get('nestedAggregations'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dateHistogram')) {
        result.dateHistogram = overrides && overrides.hasOwnProperty('dateHistogram') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput(overrides.dateHistogram ?? {}, pickedFields.get('dateHistogram')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput({}, pickedFields.get('dateHistogram'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldPath')) {
        result.fieldPath = overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('range')) {
        result.range = overrides && overrides.hasOwnProperty('range') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput(overrides.range ?? {}, pickedFields.get('range')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput({}, pickedFields.get('range'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scalar')) {
        result.scalar = overrides && overrides.hasOwnProperty('scalar') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput(overrides.scalar ?? {}, pickedFields.get('scalar')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput({}, pickedFields.get('scalar'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationType.DateHistogram;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput(overrides.value ?? {}, pickedFields.get('value')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput({}, pickedFields.get('value'));
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buckets')) {
        result.buckets = overrides && overrides.hasOwnProperty('buckets') ? overrides.buckets!.map((x) => aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationRangeBucketInput({}, pickedFields.get('buckets'))) : [aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationRangeBucketInput({}, pickedFields.get('buckets'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('from')) {
        result.from = overrides && overrides.hasOwnProperty('from') ? overrides.from! : 2.32;
    }
    if (pickedFields.size === 0 || pickedFields.has('to')) {
        result.to = overrides && overrides.hasOwnProperty('to') ? overrides.to! : 7.33;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixOnlineprogramsProgramsV3UpstreamWixCommonScalarType.Avg;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addToBucket')) {
        result.addToBucket = overrides && overrides.hasOwnProperty('addToBucket') ? overrides.addToBucket! : 'et';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('includeOptions')) {
        result.includeOptions = overrides && overrides.hasOwnProperty('includeOptions') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput(overrides.includeOptions ?? {}, pickedFields.get('includeOptions')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput({}, pickedFields.get('includeOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 9870;
    }
    if (pickedFields.size === 0 || pickedFields.has('missingValues')) {
        result.missingValues = overrides && overrides.hasOwnProperty('missingValues') ? overrides.missingValues! : WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationMissingValues.Exclude;
    }
    if (pickedFields.size === 0 || pickedFields.has('sortDirection')) {
        result.sortDirection = overrides && overrides.hasOwnProperty('sortDirection') ? overrides.sortDirection! : WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationSortDirection.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('sortType')) {
        result.sortType = overrides && overrides.hasOwnProperty('sortType') ? overrides.sortType! : WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationSortType.Count;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalFailures')) {
        result.totalFailures = overrides && overrides.hasOwnProperty('totalFailures') ? overrides.totalFailures! : 5597;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalSuccesses')) {
        result.totalSuccesses = overrides && overrides.hasOwnProperty('totalSuccesses') ? overrides.totalSuccesses! : 7373;
    }
    if (pickedFields.size === 0 || pickedFields.has('undetailedFailures')) {
        result.undetailedFailures = overrides && overrides.hasOwnProperty('undetailedFailures') ? overrides.undetailedFailures! : 2901;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2225;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 4289;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 5316;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorSearchInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorSearchInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregations')) {
        result.aggregations = overrides && overrides.hasOwnProperty('aggregations') ? overrides.aggregations!.map((x) => aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationInput({}, pickedFields.get('aggregations'))) : [aWixOnlineprogramsProgramsV3UpstreamWixCommonAggregationInput({}, pickedFields.get('aggregations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsInput(overrides.search ?? {}, pickedFields.get('search')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsInput({}, pickedFields.get('search'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'eveniet';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonCursors = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'nobis';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('error')) {
        result.error = overrides && overrides.hasOwnProperty('error') ? aWixApiApplicationError(overrides.error ?? {}, pickedFields.get('error')) : aWixApiApplicationError({}, pickedFields.get('error'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('originalIndex')) {
        result.originalIndex = overrides && overrides.hasOwnProperty('originalIndex') ? overrides.originalIndex! : 6742;
    }
    if (pickedFields.size === 0 || pickedFields.has('success')) {
        result.success = overrides && overrides.hasOwnProperty('success') ? overrides.success! : true;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonMoney = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonMoney>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'qui';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonMoneyInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonMoneyInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'sit';
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonPagingInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 5710;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 5196;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonPagingMetadataV2 = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonPagingMetadataV2>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 1310;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 4849;
    }
    if (pickedFields.size === 0 || pickedFields.has('tooManyToCount')) {
        result.tooManyToCount = overrides && overrides.hasOwnProperty('tooManyToCount') ? overrides.tooManyToCount! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9332;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['quas'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['accusamus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixOnlineprogramsProgramsV3UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixOnlineprogramsProgramsV3UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expression')) {
        result.expression = overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['tempora'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fuzzy')) {
        result.fuzzy = overrides && overrides.hasOwnProperty('fuzzy') ? overrides.fuzzy! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('mode')) {
        result.mode = overrides && overrides.hasOwnProperty('mode') ? overrides.mode! : WixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsMode.And;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput = <T extends Partial<WixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixOnlineprogramsProgramsV3UpstreamWixCommonSortOrder.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('selectItemsBy')) {
        result.selectItemsBy = overrides && overrides.hasOwnProperty('selectItemsBy') ? overrides.selectItemsBy! : ['cupiditate'];
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3VideoStepsSettings = <T extends Partial<WixOnlineprogramsProgramsV3VideoStepsSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoNavigate')) {
        result.autoNavigate = overrides && overrides.hasOwnProperty('autoNavigate') ? overrides.autoNavigate! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('requiredCompletionPercentage')) {
        result.requiredCompletionPercentage = overrides && overrides.hasOwnProperty('requiredCompletionPercentage') ? overrides.requiredCompletionPercentage! : 4.07;
    }

    return result;
};

export const aWixOnlineprogramsProgramsV3VideoStepsSettingsInput = <T extends Partial<WixOnlineprogramsProgramsV3VideoStepsSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoNavigate')) {
        result.autoNavigate = overrides && overrides.hasOwnProperty('autoNavigate') ? overrides.autoNavigate! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('requiredCompletionPercentage')) {
        result.requiredCompletionPercentage = overrides && overrides.hasOwnProperty('requiredCompletionPercentage') ? overrides.requiredCompletionPercentage! : 2.36;
    }

    return result;
};

export const aWixOnlineprogramsStepsV3BulkCloneStepRequestInput = <T extends Partial<WixOnlineprogramsStepsV3BulkCloneStepRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('clonedProgramId')) {
        result.clonedProgramId = overrides && overrides.hasOwnProperty('clonedProgramId') ? overrides.clonedProgramId! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('prototypeIdToClonedId')) {
        result.prototypeIdToClonedId = overrides && overrides.hasOwnProperty('prototypeIdToClonedId') ? overrides.prototypeIdToClonedId! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('prototypeProgramId')) {
        result.prototypeProgramId = overrides && overrides.hasOwnProperty('prototypeProgramId') ? overrides.prototypeProgramId! : 'consequuntur';
    }

    return result;
};

export const aWixOnlineprogramsStepsV3BulkCloneStepResponse = <T extends Partial<WixOnlineprogramsStepsV3BulkCloneStepResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdStepIds')) {
        result.createdStepIds = overrides && overrides.hasOwnProperty('createdStepIds') ? overrides.createdStepIds! : ['omnis'];
    }

    return result;
};

export const aWixOnlineprogramsStepsV3BulkCreateStepMigrationRequestInput = <T extends Partial<WixOnlineprogramsStepsV3BulkCreateStepMigrationRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('steps')) {
        result.steps = overrides && overrides.hasOwnProperty('steps') ? overrides.steps!.map((x) => aWixOnlineprogramsStepsV3StepInput({}, pickedFields.get('steps'))) : [aWixOnlineprogramsStepsV3StepInput({}, pickedFields.get('steps'))];
    }

    return result;
};

export const aWixOnlineprogramsStepsV3BulkCreateStepMigrationResponse = <T extends Partial<WixOnlineprogramsStepsV3BulkCreateStepMigrationResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsStepsV3BulkStepResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsStepsV3BulkStepResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsStepsV3BulkCreateStepRequestInput = <T extends Partial<WixOnlineprogramsStepsV3BulkCreateStepRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('steps')) {
        result.steps = overrides && overrides.hasOwnProperty('steps') ? overrides.steps!.map((x) => aWixOnlineprogramsStepsV3StepInput({}, pickedFields.get('steps'))) : [aWixOnlineprogramsStepsV3StepInput({}, pickedFields.get('steps'))];
    }

    return result;
};

export const aWixOnlineprogramsStepsV3BulkCreateStepResponse = <T extends Partial<WixOnlineprogramsStepsV3BulkCreateStepResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixOnlineprogramsStepsV3BulkStepResult(x ?? {}, pickedFields.get('results'))) : [aWixOnlineprogramsStepsV3BulkStepResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixOnlineprogramsStepsV3BulkStepResult = <T extends Partial<WixOnlineprogramsStepsV3BulkStepResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('action')) {
        result.action = overrides && overrides.hasOwnProperty('action') ? overrides.action! : WixCommonBulkActionType.Delete;
    }
    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixOnlineprogramsStepsV3Step(overrides.item ?? {}, pickedFields.get('item')) : aWixOnlineprogramsStepsV3Step({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3CloneStepRequestInput = <T extends Partial<WixOnlineprogramsStepsV3CloneStepRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('stepId')) {
        result.stepId = overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'ea';
    }

    return result;
};

export const aWixOnlineprogramsStepsV3CloneStepResponse = <T extends Partial<WixOnlineprogramsStepsV3CloneStepResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('step')) {
        result.step = overrides && overrides.hasOwnProperty('step') ? aWixOnlineprogramsStepsV3Step(overrides.step ?? {}, pickedFields.get('step')) : aWixOnlineprogramsStepsV3Step({}, pickedFields.get('step'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3CreateStepRequestInput = <T extends Partial<WixOnlineprogramsStepsV3CreateStepRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('step')) {
        result.step = overrides && overrides.hasOwnProperty('step') ? aWixOnlineprogramsStepsV3StepInput(overrides.step ?? {}, pickedFields.get('step')) : aWixOnlineprogramsStepsV3StepInput({}, pickedFields.get('step'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3CreateStepResponse = <T extends Partial<WixOnlineprogramsStepsV3CreateStepResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('step')) {
        result.step = overrides && overrides.hasOwnProperty('step') ? aWixOnlineprogramsStepsV3Step(overrides.step ?? {}, pickedFields.get('step')) : aWixOnlineprogramsStepsV3Step({}, pickedFields.get('step'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3DeleteAllProgramStepsRequestInput = <T extends Partial<WixOnlineprogramsStepsV3DeleteAllProgramStepsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'in';
    }

    return result;
};

export const aWixOnlineprogramsStepsV3DeleteAllProgramStepsResponse = <T extends Partial<WixOnlineprogramsStepsV3DeleteAllProgramStepsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('failedCount')) {
        result.failedCount = overrides && overrides.hasOwnProperty('failedCount') ? overrides.failedCount! : 878;
    }
    if (pickedFields.size === 0 || pickedFields.has('stepsTotal')) {
        result.stepsTotal = overrides && overrides.hasOwnProperty('stepsTotal') ? overrides.stepsTotal! : 1465;
    }
    if (pickedFields.size === 0 || pickedFields.has('successfulCount')) {
        result.successfulCount = overrides && overrides.hasOwnProperty('successfulCount') ? overrides.successfulCount! : 4055;
    }

    return result;
};

export const aWixOnlineprogramsStepsV3DeleteStepRequestInput = <T extends Partial<WixOnlineprogramsStepsV3DeleteStepRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('stepId')) {
        result.stepId = overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'voluptatem';
    }

    return result;
};

export const aWixOnlineprogramsStepsV3Description = <T extends Partial<WixOnlineprogramsStepsV3Description>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideoV2(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideoV2({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3DescriptionInput = <T extends Partial<WixOnlineprogramsStepsV3DescriptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('details')) {
        result.details = overrides && overrides.hasOwnProperty('details') ? overrides.details! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixCommonImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixCommonImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideoV2Input(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideoV2Input({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3GetStepRequestInput = <T extends Partial<WixOnlineprogramsStepsV3GetStepRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('descriptionFieldSet')) {
        result.descriptionFieldSet = overrides && overrides.hasOwnProperty('descriptionFieldSet') ? overrides.descriptionFieldSet! : WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet.Extended;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '65d747f8-396e-4ac4-8e8b-3c94e36d9a68';
    }

    return result;
};

export const aWixOnlineprogramsStepsV3ListAllProgramStepsRequestInput = <T extends Partial<WixOnlineprogramsStepsV3ListAllProgramStepsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('descriptionFieldSet')) {
        result.descriptionFieldSet = overrides && overrides.hasOwnProperty('descriptionFieldSet') ? overrides.descriptionFieldSet! : WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet.Extended;
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'consequatur';
    }

    return result;
};

export const aWixOnlineprogramsStepsV3ListAllProgramStepsResponse = <T extends Partial<WixOnlineprogramsStepsV3ListAllProgramStepsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('steps')) {
        result.steps = overrides && overrides.hasOwnProperty('steps') ? overrides.steps!.map((x) => aWixOnlineprogramsStepsV3Step(x ?? {}, pickedFields.get('steps'))) : [aWixOnlineprogramsStepsV3Step({}, pickedFields.get('steps'))];
    }

    return result;
};

export const aWixOnlineprogramsStepsV3MoveStepRequestInput = <T extends Partial<WixOnlineprogramsStepsV3MoveStepRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('afterStepId')) {
        result.afterStepId = overrides && overrides.hasOwnProperty('afterStepId') ? overrides.afterStepId! : 'expedita';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'sequi';
    }
    if (pickedFields.size === 0 || pickedFields.has('sectionId')) {
        result.sectionId = overrides && overrides.hasOwnProperty('sectionId') ? overrides.sectionId! : 'vero';
    }
    if (pickedFields.size === 0 || pickedFields.has('stepId')) {
        result.stepId = overrides && overrides.hasOwnProperty('stepId') ? overrides.stepId! : 'dignissimos';
    }

    return result;
};

export const aWixOnlineprogramsStepsV3MoveStepResponse = <T extends Partial<WixOnlineprogramsStepsV3MoveStepResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('step')) {
        result.step = overrides && overrides.hasOwnProperty('step') ? aWixOnlineprogramsStepsV3Step(overrides.step ?? {}, pickedFields.get('step')) : aWixOnlineprogramsStepsV3Step({}, pickedFields.get('step'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3QueryStepsRequestInput = <T extends Partial<WixOnlineprogramsStepsV3QueryStepsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('descriptionFieldSet')) {
        result.descriptionFieldSet = overrides && overrides.hasOwnProperty('descriptionFieldSet') ? overrides.descriptionFieldSet! : WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet.Extended;
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'maiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3QueryStepsResponse = <T extends Partial<WixOnlineprogramsStepsV3QueryStepsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixOnlineprogramsStepsV3Step(x ?? {}, pickedFields.get('items'))) : [aWixOnlineprogramsStepsV3Step({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3QueryStepsWithoutPagingRequestInput = <T extends Partial<WixOnlineprogramsStepsV3QueryStepsWithoutPagingRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('descriptionFieldSet')) {
        result.descriptionFieldSet = overrides && overrides.hasOwnProperty('descriptionFieldSet') ? overrides.descriptionFieldSet! : WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet.Extended;
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3QueryStepsWithoutPagingResponse = <T extends Partial<WixOnlineprogramsStepsV3QueryStepsWithoutPagingResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('steps')) {
        result.steps = overrides && overrides.hasOwnProperty('steps') ? overrides.steps!.map((x) => aWixOnlineprogramsStepsV3Step(x ?? {}, pickedFields.get('steps'))) : [aWixOnlineprogramsStepsV3Step({}, pickedFields.get('steps'))];
    }

    return result;
};

export const aWixOnlineprogramsStepsV3Step = <T extends Partial<WixOnlineprogramsStepsV3Step>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixOnlineprogramsStepsV3Description(overrides.description ?? {}, pickedFields.get('description')) : aWixOnlineprogramsStepsV3Description({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('ordering')) {
        result.ordering = overrides && overrides.hasOwnProperty('ordering') ? overrides.ordering! : 6.78;
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('quizOptions')) {
        result.quizOptions = overrides && overrides.hasOwnProperty('quizOptions') ? aWixOnlineprogramsStepsV3StepQuizOptions(overrides.quizOptions ?? {}, pickedFields.get('quizOptions')) : aWixOnlineprogramsStepsV3StepQuizOptions({}, pickedFields.get('quizOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('sectionId')) {
        result.sectionId = overrides && overrides.hasOwnProperty('sectionId') ? overrides.sectionId! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('stepType')) {
        result.stepType = overrides && overrides.hasOwnProperty('stepType') ? overrides.stepType! : WixOnlineprogramsStepsV3StepStepType.Article;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('videoOptions')) {
        result.videoOptions = overrides && overrides.hasOwnProperty('videoOptions') ? aWixOnlineprogramsStepsV3StepVideoOptions(overrides.videoOptions ?? {}, pickedFields.get('videoOptions')) : aWixOnlineprogramsStepsV3StepVideoOptions({}, pickedFields.get('videoOptions'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3StepInput = <T extends Partial<WixOnlineprogramsStepsV3StepInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? aWixOnlineprogramsStepsV3DescriptionInput(overrides.description ?? {}, pickedFields.get('description')) : aWixOnlineprogramsStepsV3DescriptionInput({}, pickedFields.get('description'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'debitis';
    }
    if (pickedFields.size === 0 || pickedFields.has('ordering')) {
        result.ordering = overrides && overrides.hasOwnProperty('ordering') ? overrides.ordering! : 5.23;
    }
    if (pickedFields.size === 0 || pickedFields.has('programId')) {
        result.programId = overrides && overrides.hasOwnProperty('programId') ? overrides.programId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('quizOptions')) {
        result.quizOptions = overrides && overrides.hasOwnProperty('quizOptions') ? aWixOnlineprogramsStepsV3StepQuizOptionsInput(overrides.quizOptions ?? {}, pickedFields.get('quizOptions')) : aWixOnlineprogramsStepsV3StepQuizOptionsInput({}, pickedFields.get('quizOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('sectionId')) {
        result.sectionId = overrides && overrides.hasOwnProperty('sectionId') ? overrides.sectionId! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('stepType')) {
        result.stepType = overrides && overrides.hasOwnProperty('stepType') ? overrides.stepType! : WixOnlineprogramsStepsV3StepStepType.Article;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('videoOptions')) {
        result.videoOptions = overrides && overrides.hasOwnProperty('videoOptions') ? aWixOnlineprogramsStepsV3StepVideoOptionsInput(overrides.videoOptions ?? {}, pickedFields.get('videoOptions')) : aWixOnlineprogramsStepsV3StepVideoOptionsInput({}, pickedFields.get('videoOptions'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3StepQuizOptions = <T extends Partial<WixOnlineprogramsStepsV3StepQuizOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('passingGrade')) {
        result.passingGrade = overrides && overrides.hasOwnProperty('passingGrade') ? overrides.passingGrade! : 3.74;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalQuestions')) {
        result.totalQuestions = overrides && overrides.hasOwnProperty('totalQuestions') ? overrides.totalQuestions! : 3303;
    }

    return result;
};

export const aWixOnlineprogramsStepsV3StepQuizOptionsInput = <T extends Partial<WixOnlineprogramsStepsV3StepQuizOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('passingGrade')) {
        result.passingGrade = overrides && overrides.hasOwnProperty('passingGrade') ? overrides.passingGrade! : 4.55;
    }
    if (pickedFields.size === 0 || pickedFields.has('totalQuestions')) {
        result.totalQuestions = overrides && overrides.hasOwnProperty('totalQuestions') ? overrides.totalQuestions! : 1638;
    }

    return result;
};

export const aWixOnlineprogramsStepsV3StepVideoOptions = <T extends Partial<WixOnlineprogramsStepsV3StepVideoOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coverImage')) {
        result.coverImage = overrides && overrides.hasOwnProperty('coverImage') ? aWixCommonImage(overrides.coverImage ?? {}, pickedFields.get('coverImage')) : aWixCommonImage({}, pickedFields.get('coverImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deleted')) {
        result.deleted = overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('durationInMilliseconds')) {
        result.durationInMilliseconds = overrides && overrides.hasOwnProperty('durationInMilliseconds') ? overrides.durationInMilliseconds! : 3162;
    }
    if (pickedFields.size === 0 || pickedFields.has('requiredCompletionPercentage')) {
        result.requiredCompletionPercentage = overrides && overrides.hasOwnProperty('requiredCompletionPercentage') ? overrides.requiredCompletionPercentage! : 8.35;
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideoV2(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideoV2({}, pickedFields.get('video'));
    }
    if (pickedFields.size === 0 || pickedFields.has('wixVideo')) {
        result.wixVideo = overrides && overrides.hasOwnProperty('wixVideo') ? aWixOnlineprogramsStepsV3StepVideoOptionsWixVideo(overrides.wixVideo ?? {}, pickedFields.get('wixVideo')) : aWixOnlineprogramsStepsV3StepVideoOptionsWixVideo({}, pickedFields.get('wixVideo'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3StepVideoOptionsInput = <T extends Partial<WixOnlineprogramsStepsV3StepVideoOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('coverImage')) {
        result.coverImage = overrides && overrides.hasOwnProperty('coverImage') ? aWixCommonImageInput(overrides.coverImage ?? {}, pickedFields.get('coverImage')) : aWixCommonImageInput({}, pickedFields.get('coverImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('deleted')) {
        result.deleted = overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('durationInMilliseconds')) {
        result.durationInMilliseconds = overrides && overrides.hasOwnProperty('durationInMilliseconds') ? overrides.durationInMilliseconds! : 6648;
    }
    if (pickedFields.size === 0 || pickedFields.has('requiredCompletionPercentage')) {
        result.requiredCompletionPercentage = overrides && overrides.hasOwnProperty('requiredCompletionPercentage') ? overrides.requiredCompletionPercentage! : 9.12;
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixCommonVideoV2Input(overrides.video ?? {}, pickedFields.get('video')) : aWixCommonVideoV2Input({}, pickedFields.get('video'));
    }
    if (pickedFields.size === 0 || pickedFields.has('wixVideo')) {
        result.wixVideo = overrides && overrides.hasOwnProperty('wixVideo') ? aWixOnlineprogramsStepsV3StepVideoOptionsWixVideoInput(overrides.wixVideo ?? {}, pickedFields.get('wixVideo')) : aWixOnlineprogramsStepsV3StepVideoOptionsWixVideoInput({}, pickedFields.get('wixVideo'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3StepVideoOptionsWixVideo = <T extends Partial<WixOnlineprogramsStepsV3StepVideoOptionsWixVideo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('paid')) {
        result.paid = overrides && overrides.hasOwnProperty('paid') ? overrides.paid! : true;
    }

    return result;
};

export const aWixOnlineprogramsStepsV3StepVideoOptionsWixVideoInput = <T extends Partial<WixOnlineprogramsStepsV3StepVideoOptionsWixVideoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('paid')) {
        result.paid = overrides && overrides.hasOwnProperty('paid') ? overrides.paid! : false;
    }

    return result;
};

export const aWixOnlineprogramsStepsV3UpdateStepRequestInput = <T extends Partial<WixOnlineprogramsStepsV3UpdateStepRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['occaecati'];
    }
    if (pickedFields.size === 0 || pickedFields.has('step')) {
        result.step = overrides && overrides.hasOwnProperty('step') ? aWixOnlineprogramsStepsV3StepInput(overrides.step ?? {}, pickedFields.get('step')) : aWixOnlineprogramsStepsV3StepInput({}, pickedFields.get('step'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3UpdateStepResponse = <T extends Partial<WixOnlineprogramsStepsV3UpdateStepResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('step')) {
        result.step = overrides && overrides.hasOwnProperty('step') ? aWixOnlineprogramsStepsV3Step(overrides.step ?? {}, pickedFields.get('step')) : aWixOnlineprogramsStepsV3Step({}, pickedFields.get('step'));
    }

    return result;
};

export const aWixOnlineprogramsStepsV3UpstreamWixCommonCursorPagingInput = <T extends Partial<WixOnlineprogramsStepsV3UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 4674;
    }

    return result;
};

export const aWixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput = <T extends Partial<WixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixOnlineprogramsStepsV3UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixOnlineprogramsStepsV3UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixOrdersApiV2AppliedCouponInput = <T extends Partial<WixOrdersApiV2AppliedCouponInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('couponId')) {
        result.couponId = overrides && overrides.hasOwnProperty('couponId') ? overrides.couponId! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'consectetur';
    }

    return result;
};

export const aWixOrdersApiV2BillingInfoInput = <T extends Partial<WixOrdersApiV2BillingInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalTransactionId')) {
        result.externalTransactionId = overrides && overrides.hasOwnProperty('externalTransactionId') ? overrides.externalTransactionId! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('paidDate')) {
        result.paidDate = overrides && overrides.hasOwnProperty('paidDate') ? overrides.paidDate! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayTransactionId')) {
        result.paymentGatewayTransactionId = overrides && overrides.hasOwnProperty('paymentGatewayTransactionId') ? overrides.paymentGatewayTransactionId! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? overrides.paymentMethod! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentProviderTransactionId')) {
        result.paymentProviderTransactionId = overrides && overrides.hasOwnProperty('paymentProviderTransactionId') ? overrides.paymentProviderTransactionId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundableByPaymentProvider')) {
        result.refundableByPaymentProvider = overrides && overrides.hasOwnProperty('refundableByPaymentProvider') ? overrides.refundableByPaymentProvider! : true;
    }

    return result;
};

export const aWixOrdersApiV2BuyerInfoInput = <T extends Partial<WixOrdersApiV2BuyerInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('identityType')) {
        result.identityType = overrides && overrides.hasOwnProperty('identityType') ? overrides.identityType! : WixOrdersApiV2IdentityType.Contact;
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixOrdersApiV2IdentityType.Contact;
    }

    return result;
};

export const aWixOrdersApiV2OrderCreatedInput = <T extends Partial<WixOrdersApiV2OrderCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appliedCoupon')) {
        result.appliedCoupon = overrides && overrides.hasOwnProperty('appliedCoupon') ? aWixOrdersApiV2AppliedCouponInput(overrides.appliedCoupon ?? {}, pickedFields.get('appliedCoupon')) : aWixOrdersApiV2AppliedCouponInput({}, pickedFields.get('appliedCoupon'));
    }
    if (pickedFields.size === 0 || pickedFields.has('archived')) {
        result.archived = overrides && overrides.hasOwnProperty('archived') ? overrides.archived! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('billingInfo')) {
        result.billingInfo = overrides && overrides.hasOwnProperty('billingInfo') ? aWixOrdersApiV2BillingInfoInput(overrides.billingInfo ?? {}, pickedFields.get('billingInfo')) : aWixOrdersApiV2BillingInfoInput({}, pickedFields.get('billingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerInfo')) {
        result.buyerInfo = overrides && overrides.hasOwnProperty('buyerInfo') ? aWixOrdersApiV2BuyerInfoInput(overrides.buyerInfo ?? {}, pickedFields.get('buyerInfo')) : aWixOrdersApiV2BuyerInfoInput({}, pickedFields.get('buyerInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cartId')) {
        result.cartId = overrides && overrides.hasOwnProperty('cartId') ? overrides.cartId! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('checkoutId')) {
        result.checkoutId = overrides && overrides.hasOwnProperty('checkoutId') ? overrides.checkoutId! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('dateCreated')) {
        result.dateCreated = overrides && overrides.hasOwnProperty('dateCreated') ? overrides.dateCreated! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillmentStatus')) {
        result.fulfillmentStatus = overrides && overrides.hasOwnProperty('fulfillmentStatus') ? overrides.fulfillmentStatus! : WixOrdersApiV2FulfillmentStatus.Canceled;
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 735;
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('ordersExperiments')) {
        result.ordersExperiments = overrides && overrides.hasOwnProperty('ordersExperiments') ? aComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput(overrides.ordersExperiments ?? {}, pickedFields.get('ordersExperiments')) : aComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput({}, pickedFields.get('ordersExperiments'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentStatus')) {
        result.paymentStatus = overrides && overrides.hasOwnProperty('paymentStatus') ? overrides.paymentStatus! : WixOrdersApiV2PaymentStatus.FullyRefunded;
    }
    if (pickedFields.size === 0 || pickedFields.has('read')) {
        result.read = overrides && overrides.hasOwnProperty('read') ? overrides.read! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionInfo')) {
        result.subscriptionInfo = overrides && overrides.hasOwnProperty('subscriptionInfo') ? aWixOrdersApiV2SubscriptionInfoInput(overrides.subscriptionInfo ?? {}, pickedFields.get('subscriptionInfo')) : aWixOrdersApiV2SubscriptionInfoInput({}, pickedFields.get('subscriptionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totals')) {
        result.totals = overrides && overrides.hasOwnProperty('totals') ? aWixOrdersApiV2TotalsInput(overrides.totals ?? {}, pickedFields.get('totals')) : aWixOrdersApiV2TotalsInput({}, pickedFields.get('totals'));
    }
    if (pickedFields.size === 0 || pickedFields.has('weightUnit')) {
        result.weightUnit = overrides && overrides.hasOwnProperty('weightUnit') ? overrides.weightUnit! : ComWixEcommercePlatformCommonApiWeightUnit.Kg;
    }

    return result;
};

export const aWixOrdersApiV2SubscriptionInfoInput = <T extends Partial<WixOrdersApiV2SubscriptionInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cycleNumber')) {
        result.cycleNumber = overrides && overrides.hasOwnProperty('cycleNumber') ? overrides.cycleNumber! : 8201;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionOptionInfo')) {
        result.subscriptionOptionInfo = overrides && overrides.hasOwnProperty('subscriptionOptionInfo') ? aWixOrdersApiV2SubscriptionOptionInfoInput(overrides.subscriptionOptionInfo ?? {}, pickedFields.get('subscriptionOptionInfo')) : aWixOrdersApiV2SubscriptionOptionInfoInput({}, pickedFields.get('subscriptionOptionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionSettings')) {
        result.subscriptionSettings = overrides && overrides.hasOwnProperty('subscriptionSettings') ? aWixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput(overrides.subscriptionSettings ?? {}, pickedFields.get('subscriptionSettings')) : aWixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput({}, pickedFields.get('subscriptionSettings'));
    }

    return result;
};

export const aWixOrdersApiV2SubscriptionOptionInfoInput = <T extends Partial<WixOrdersApiV2SubscriptionOptionInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'et';
    }

    return result;
};

export const aWixOrdersApiV2TotalsInput = <T extends Partial<WixOrdersApiV2TotalsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? overrides.discount! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? overrides.giftCard! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 8257;
    }
    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? overrides.refund! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? overrides.shipping! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? overrides.subtotal! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 'porro';
    }

    return result;
};

export const aWixPaymentApiPayV3AccountInfoInput = <T extends Partial<WixPaymentApiPayV3AccountInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'saepe';
    }

    return result;
};

export const aWixPaymentApiPayV3CreditCardPaymentMethodDataInput = <T extends Partial<WixPaymentApiPayV3CreditCardPaymentMethodDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expiryMonth')) {
        result.expiryMonth = overrides && overrides.hasOwnProperty('expiryMonth') ? overrides.expiryMonth! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('holderName')) {
        result.holderName = overrides && overrides.hasOwnProperty('holderName') ? overrides.holderName! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('maskedCreditCard')) {
        result.maskedCreditCard = overrides && overrides.hasOwnProperty('maskedCreditCard') ? overrides.maskedCreditCard! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('network')) {
        result.network = overrides && overrides.hasOwnProperty('network') ? overrides.network! : 'sequi';
    }

    return result;
};

export const aWixPaymentApiPayV3CurrencyAmountInput = <T extends Partial<WixPaymentApiPayV3CurrencyAmountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 2.65;
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'non';
    }

    return result;
};

export const aWixPaymentApiPayV3OrderAdditionalChargesInput = <T extends Partial<WixPaymentApiPayV3OrderAdditionalChargesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('applicationFee')) {
        result.applicationFee = overrides && overrides.hasOwnProperty('applicationFee') ? overrides.applicationFee! : 7.7;
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? overrides.discount! : 3.81;
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? overrides.shipping! : 1.14;
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : 6.23;
    }

    return result;
};

export const aWixPaymentApiPayV3OrderInput = <T extends Partial<WixPaymentApiPayV3OrderInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalCharges')) {
        result.additionalCharges = overrides && overrides.hasOwnProperty('additionalCharges') ? aWixPaymentApiPayV3OrderAdditionalChargesInput(overrides.additionalCharges ?? {}, pickedFields.get('additionalCharges')) : aWixPaymentApiPayV3OrderAdditionalChargesInput({}, pickedFields.get('additionalCharges'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdAt')) {
        result.createdAt = overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalData')) {
        result.externalData = overrides && overrides.hasOwnProperty('externalData') ? overrides.externalData! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixPaymentApiPayV3OrderItemInput({}, pickedFields.get('items'))) : [aWixPaymentApiPayV3OrderItemInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('itemsTotalCount')) {
        result.itemsTotalCount = overrides && overrides.hasOwnProperty('itemsTotalCount') ? overrides.itemsTotalCount! : 3824;
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingAddress')) {
        result.shippingAddress = overrides && overrides.hasOwnProperty('shippingAddress') ? aWixCommonAddressInput(overrides.shippingAddress ?? {}, pickedFields.get('shippingAddress')) : aWixCommonAddressInput({}, pickedFields.get('shippingAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingAddressContacts')) {
        result.shippingAddressContacts = overrides && overrides.hasOwnProperty('shippingAddressContacts') ? aWixCommonFullAddressContactDetailsInput(overrides.shippingAddressContacts ?? {}, pickedFields.get('shippingAddressContacts')) : aWixCommonFullAddressContactDetailsInput({}, pickedFields.get('shippingAddressContacts'));
    }
    if (pickedFields.size === 0 || pickedFields.has('wixAppBuyerId')) {
        result.wixAppBuyerId = overrides && overrides.hasOwnProperty('wixAppBuyerId') ? overrides.wixAppBuyerId! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixAppOrderId')) {
        result.wixAppOrderId = overrides && overrides.hasOwnProperty('wixAppOrderId') ? overrides.wixAppOrderId! : 'facilis';
    }

    return result;
};

export const aWixPaymentApiPayV3OrderItemInput = <T extends Partial<WixPaymentApiPayV3OrderItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('category')) {
        result.category = overrides && overrides.hasOwnProperty('category') ? overrides.category! : WixPaymentApiPayV3OrderItemOrderItemCategory.Digital;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 7.62;
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 4394;
    }
    if (pickedFields.size === 0 || pickedFields.has('weightInKg')) {
        result.weightInKg = overrides && overrides.hasOwnProperty('weightInKg') ? overrides.weightInKg! : 9.56;
    }

    return result;
};

export const aWixPaymentApiPayV3PaymentEventInput = <T extends Partial<WixPaymentApiPayV3PaymentEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('eventTime')) {
        result.eventTime = overrides && overrides.hasOwnProperty('eventTime') ? overrides.eventTime! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('eventType')) {
        result.eventType = overrides && overrides.hasOwnProperty('eventType') ? overrides.eventType! : WixPaymentApiPayV3PaymentEventEventType.RecurringPaymentStatusChanged;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('managingWixAppId')) {
        result.managingWixAppId = overrides && overrides.hasOwnProperty('managingWixAppId') ? overrides.managingWixAppId! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringPaymentStatusChangedEvent')) {
        result.recurringPaymentStatusChangedEvent = overrides && overrides.hasOwnProperty('recurringPaymentStatusChangedEvent') ? aWixPaymentApiPayV3RecurringPaymentStatusChangedEventInput(overrides.recurringPaymentStatusChangedEvent ?? {}, pickedFields.get('recurringPaymentStatusChangedEvent')) : aWixPaymentApiPayV3RecurringPaymentStatusChangedEventInput({}, pickedFields.get('recurringPaymentStatusChangedEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundStatusChangedEvent')) {
        result.refundStatusChangedEvent = overrides && overrides.hasOwnProperty('refundStatusChangedEvent') ? aWixPaymentApiPayV3RefundStatusChangedEventInput(overrides.refundStatusChangedEvent ?? {}, pickedFields.get('refundStatusChangedEvent')) : aWixPaymentApiPayV3RefundStatusChangedEventInput({}, pickedFields.get('refundStatusChangedEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionCreatedEvent')) {
        result.transactionCreatedEvent = overrides && overrides.hasOwnProperty('transactionCreatedEvent') ? aWixPaymentApiPayV3TransactionCreatedEventInput(overrides.transactionCreatedEvent ?? {}, pickedFields.get('transactionCreatedEvent')) : aWixPaymentApiPayV3TransactionCreatedEventInput({}, pickedFields.get('transactionCreatedEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionStatusChangedEvent')) {
        result.transactionStatusChangedEvent = overrides && overrides.hasOwnProperty('transactionStatusChangedEvent') ? aWixPaymentApiPayV3TransactionStatusChangedEventInput(overrides.transactionStatusChangedEvent ?? {}, pickedFields.get('transactionStatusChangedEvent')) : aWixPaymentApiPayV3TransactionStatusChangedEventInput({}, pickedFields.get('transactionStatusChangedEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionUpdatedEvent')) {
        result.transactionUpdatedEvent = overrides && overrides.hasOwnProperty('transactionUpdatedEvent') ? aWixPaymentApiPayV3TransactionUpdatedEventInput(overrides.transactionUpdatedEvent ?? {}, pickedFields.get('transactionUpdatedEvent')) : aWixPaymentApiPayV3TransactionUpdatedEventInput({}, pickedFields.get('transactionUpdatedEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('wixAppId')) {
        result.wixAppId = overrides && overrides.hasOwnProperty('wixAppId') ? overrides.wixAppId! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('wixAppInstanceId')) {
        result.wixAppInstanceId = overrides && overrides.hasOwnProperty('wixAppInstanceId') ? overrides.wixAppInstanceId! : 'deleniti';
    }

    return result;
};

export const aWixPaymentApiPayV3RecurringPaymentCancellationDetailsInput = <T extends Partial<WixPaymentApiPayV3RecurringPaymentCancellationDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('initiator')) {
        result.initiator = overrides && overrides.hasOwnProperty('initiator') ? overrides.initiator! : WixPaymentApiPayV3RecurringPaymentCancellationDetailsInitiator.Buyer;
    }
    if (pickedFields.size === 0 || pickedFields.has('paidRegularCycleCount')) {
        result.paidRegularCycleCount = overrides && overrides.hasOwnProperty('paidRegularCycleCount') ? overrides.paidRegularCycleCount! : 8367;
    }

    return result;
};

export const aWixPaymentApiPayV3RecurringPaymentDetailsInput = <T extends Partial<WixPaymentApiPayV3RecurringPaymentDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cycleNumber')) {
        result.cycleNumber = overrides && overrides.hasOwnProperty('cycleNumber') ? overrides.cycleNumber! : 7945;
    }

    return result;
};

export const aWixPaymentApiPayV3RecurringPaymentStatusChangedEventInput = <T extends Partial<WixPaymentApiPayV3RecurringPaymentStatusChangedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cancellationDetails')) {
        result.cancellationDetails = overrides && overrides.hasOwnProperty('cancellationDetails') ? aWixPaymentApiPayV3RecurringPaymentCancellationDetailsInput(overrides.cancellationDetails ?? {}, pickedFields.get('cancellationDetails')) : aWixPaymentApiPayV3RecurringPaymentCancellationDetailsInput({}, pickedFields.get('cancellationDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aWixPaymentApiPayV3OrderInput(overrides.order ?? {}, pickedFields.get('order')) : aWixPaymentApiPayV3OrderInput({}, pickedFields.get('order'));
    }
    if (pickedFields.size === 0 || pickedFields.has('previousStatus')) {
        result.previousStatus = overrides && overrides.hasOwnProperty('previousStatus') ? overrides.previousStatus! : WixPaymentApiPayV3RecurringPaymentStatusStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixPaymentApiPayV3RecurringPaymentStatusStatus.Active;
    }

    return result;
};

export const aWixPaymentApiPayV3RefundInput = <T extends Partial<WixPaymentApiPayV3RefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aWixPaymentApiPayV3CurrencyAmountInput(overrides.amount ?? {}, pickedFields.get('amount')) : aWixPaymentApiPayV3CurrencyAmountInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdAt')) {
        result.createdAt = overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('reasonCode')) {
        result.reasonCode = overrides && overrides.hasOwnProperty('reasonCode') ? overrides.reasonCode! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixPaymentApiPayV3RefundRefundStatus.Approved;
    }

    return result;
};

export const aWixPaymentApiPayV3RefundStatusChangedEventInput = <T extends Partial<WixPaymentApiPayV3RefundStatusChangedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aWixPaymentApiPayV3OrderInput(overrides.order ?? {}, pickedFields.get('order')) : aWixPaymentApiPayV3OrderInput({}, pickedFields.get('order'));
    }
    if (pickedFields.size === 0 || pickedFields.has('previousStatus')) {
        result.previousStatus = overrides && overrides.hasOwnProperty('previousStatus') ? overrides.previousStatus! : WixPaymentApiPayV3RefundRefundStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? aWixPaymentApiPayV3RefundInput(overrides.refund ?? {}, pickedFields.get('refund')) : aWixPaymentApiPayV3RefundInput({}, pickedFields.get('refund'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixPaymentApiPayV3TransactionInput(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixPaymentApiPayV3TransactionInput({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aWixPaymentApiPayV3ScheduledActionInput = <T extends Partial<WixPaymentApiPayV3ScheduledActionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('executionDate')) {
        result.executionDate = overrides && overrides.hasOwnProperty('executionDate') ? overrides.executionDate! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixPaymentApiPayV3ScheduledActionScheduledActionType.Capture;
    }

    return result;
};

export const aWixPaymentApiPayV3TransactionCreatedEventInput = <T extends Partial<WixPaymentApiPayV3TransactionCreatedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aWixPaymentApiPayV3OrderInput(overrides.order ?? {}, pickedFields.get('order')) : aWixPaymentApiPayV3OrderInput({}, pickedFields.get('order'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixPaymentApiPayV3TransactionInput(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixPaymentApiPayV3TransactionInput({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aWixPaymentApiPayV3TransactionInput = <T extends Partial<WixPaymentApiPayV3TransactionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? aWixPaymentApiPayV3CurrencyAmountInput(overrides.amount ?? {}, pickedFields.get('amount')) : aWixPaymentApiPayV3CurrencyAmountInput({}, pickedFields.get('amount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('billingAddress')) {
        result.billingAddress = overrides && overrides.hasOwnProperty('billingAddress') ? aWixCommonAddressInput(overrides.billingAddress ?? {}, pickedFields.get('billingAddress')) : aWixCommonAddressInput({}, pickedFields.get('billingAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('billingAddressContacts')) {
        result.billingAddressContacts = overrides && overrides.hasOwnProperty('billingAddressContacts') ? aWixCommonFullAddressContactDetailsInput(overrides.billingAddressContacts ?? {}, pickedFields.get('billingAddressContacts')) : aWixCommonFullAddressContactDetailsInput({}, pickedFields.get('billingAddressContacts'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdAt')) {
        result.createdAt = overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('creditCardPaymentMethodData')) {
        result.creditCardPaymentMethodData = overrides && overrides.hasOwnProperty('creditCardPaymentMethodData') ? aWixPaymentApiPayV3CreditCardPaymentMethodDataInput(overrides.creditCardPaymentMethodData ?? {}, pickedFields.get('creditCardPaymentMethodData')) : aWixPaymentApiPayV3CreditCardPaymentMethodDataInput({}, pickedFields.get('creditCardPaymentMethodData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('installments')) {
        result.installments = overrides && overrides.hasOwnProperty('installments') ? overrides.installments! : 4607;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? overrides.paymentMethod! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethodAccountInfo')) {
        result.paymentMethodAccountInfo = overrides && overrides.hasOwnProperty('paymentMethodAccountInfo') ? aWixPaymentApiPayV3AccountInfoInput(overrides.paymentMethodAccountInfo ?? {}, pickedFields.get('paymentMethodAccountInfo')) : aWixPaymentApiPayV3AccountInfoInput({}, pickedFields.get('paymentMethodAccountInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentProvider')) {
        result.paymentProvider = overrides && overrides.hasOwnProperty('paymentProvider') ? overrides.paymentProvider! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerTransactionId')) {
        result.providerTransactionId = overrides && overrides.hasOwnProperty('providerTransactionId') ? overrides.providerTransactionId! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('reasonCode')) {
        result.reasonCode = overrides && overrides.hasOwnProperty('reasonCode') ? overrides.reasonCode! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('recurringPaymentDetails')) {
        result.recurringPaymentDetails = overrides && overrides.hasOwnProperty('recurringPaymentDetails') ? aWixPaymentApiPayV3RecurringPaymentDetailsInput(overrides.recurringPaymentDetails ?? {}, pickedFields.get('recurringPaymentDetails')) : aWixPaymentApiPayV3RecurringPaymentDetailsInput({}, pickedFields.get('recurringPaymentDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundedAmount')) {
        result.refundedAmount = overrides && overrides.hasOwnProperty('refundedAmount') ? aWixPaymentApiPayV3CurrencyAmountInput(overrides.refundedAmount ?? {}, pickedFields.get('refundedAmount')) : aWixPaymentApiPayV3CurrencyAmountInput({}, pickedFields.get('refundedAmount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduledAction')) {
        result.scheduledAction = overrides && overrides.hasOwnProperty('scheduledAction') ? aWixPaymentApiPayV3ScheduledActionInput(overrides.scheduledAction ?? {}, pickedFields.get('scheduledAction')) : aWixPaymentApiPayV3ScheduledActionInput({}, pickedFields.get('scheduledAction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixPaymentApiPayV3TransactionTransactionStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('verticalOrderId')) {
        result.verticalOrderId = overrides && overrides.hasOwnProperty('verticalOrderId') ? overrides.verticalOrderId! : 'sed';
    }

    return result;
};

export const aWixPaymentApiPayV3TransactionStatusChangedEventInput = <T extends Partial<WixPaymentApiPayV3TransactionStatusChangedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aWixPaymentApiPayV3OrderInput(overrides.order ?? {}, pickedFields.get('order')) : aWixPaymentApiPayV3OrderInput({}, pickedFields.get('order'));
    }
    if (pickedFields.size === 0 || pickedFields.has('previousStatus')) {
        result.previousStatus = overrides && overrides.hasOwnProperty('previousStatus') ? overrides.previousStatus! : WixPaymentApiPayV3TransactionTransactionStatus.Approved;
    }
    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixPaymentApiPayV3TransactionInput(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixPaymentApiPayV3TransactionInput({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aWixPaymentApiPayV3TransactionUpdatedEventInput = <T extends Partial<WixPaymentApiPayV3TransactionUpdatedEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? aWixPaymentApiPayV3OrderInput(overrides.order ?? {}, pickedFields.get('order')) : aWixPaymentApiPayV3OrderInput({}, pickedFields.get('order'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixPaymentApiPayV3TransactionInput(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixPaymentApiPayV3TransactionInput({}, pickedFields.get('transaction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('triggeredByAnonymizeRequest')) {
        result.triggeredByAnonymizeRequest = overrides && overrides.hasOwnProperty('triggeredByAnonymizeRequest') ? overrides.triggeredByAnonymizeRequest! : true;
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1CreatePaymentAgreementRequestInput = <T extends Partial<WixPaymentsPaymentAgreementsV1CreatePaymentAgreementRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixPaymentsPaymentAgreementsV1RequestedFields.SensitiveInfo];
    }
    if (pickedFields.size === 0 || pickedFields.has('idempotencyKey')) {
        result.idempotencyKey = overrides && overrides.hasOwnProperty('idempotencyKey') ? overrides.idempotencyKey! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentAgreement')) {
        result.paymentAgreement = overrides && overrides.hasOwnProperty('paymentAgreement') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementInput(overrides.paymentAgreement ?? {}, pickedFields.get('paymentAgreement')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementInput({}, pickedFields.get('paymentAgreement'));
    }
    if (pickedFields.size === 0 || pickedFields.has('temporaryCardToken')) {
        result.temporaryCardToken = overrides && overrides.hasOwnProperty('temporaryCardToken') ? overrides.temporaryCardToken! : 'qui';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1CreatePaymentAgreementResponse = <T extends Partial<WixPaymentsPaymentAgreementsV1CreatePaymentAgreementResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentAgreement')) {
        result.paymentAgreement = overrides && overrides.hasOwnProperty('paymentAgreement') ? aWixPaymentsPaymentAgreementsV1PaymentAgreement(overrides.paymentAgreement ?? {}, pickedFields.get('paymentAgreement')) : aWixPaymentsPaymentAgreementsV1PaymentAgreement({}, pickedFields.get('paymentAgreement'));
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1DeletePaymentAgreementRequestInput = <T extends Partial<WixPaymentsPaymentAgreementsV1DeletePaymentAgreementRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentAgreementId')) {
        result.paymentAgreementId = overrides && overrides.hasOwnProperty('paymentAgreementId') ? overrides.paymentAgreementId! : 'aut';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1FinalizePaymentAgreementRequestInput = <T extends Partial<WixPaymentsPaymentAgreementsV1FinalizePaymentAgreementRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentAgreementId')) {
        result.paymentAgreementId = overrides && overrides.hasOwnProperty('paymentAgreementId') ? overrides.paymentAgreementId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteId')) {
        result.siteId = overrides && overrides.hasOwnProperty('siteId') ? overrides.siteId! : 'tenetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('temporaryToken')) {
        result.temporaryToken = overrides && overrides.hasOwnProperty('temporaryToken') ? overrides.temporaryToken! : 'fugit';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1GetPaymentAgreementRequestInput = <T extends Partial<WixPaymentsPaymentAgreementsV1GetPaymentAgreementRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixPaymentsPaymentAgreementsV1RequestedFields.SensitiveInfo];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a0e60a0b-e27f-465e-aa9d-e5f2b6dfa204';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreement = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreement>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('billingAddress')) {
        result.billingAddress = overrides && overrides.hasOwnProperty('billingAddress') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddress(overrides.billingAddress ?? {}, pickedFields.get('billingAddress')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddress({}, pickedFields.get('billingAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargeId')) {
        result.chargeId = overrides && overrides.hasOwnProperty('chargeId') ? overrides.chargeId! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantCreated')) {
        result.merchantCreated = overrides && overrides.hasOwnProperty('merchantCreated') ? overrides.merchantCreated! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('owner')) {
        result.owner = overrides && overrides.hasOwnProperty('owner') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementOwner(overrides.owner ?? {}, pickedFields.get('owner')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementOwner({}, pickedFields.get('owner'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentIntentId')) {
        result.paymentIntentId = overrides && overrides.hasOwnProperty('paymentIntentId') ? overrides.paymentIntentId! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethod(overrides.paymentMethod ?? {}, pickedFields.get('paymentMethod')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethod({}, pickedFields.get('paymentMethod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerId')) {
        result.providerId = overrides && overrides.hasOwnProperty('providerId') ? overrides.providerId! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('sandbox')) {
        result.sandbox = overrides && overrides.hasOwnProperty('sandbox') ? overrides.sandbox! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethodId')) {
        result.savedPaymentMethodId = overrides && overrides.hasOwnProperty('savedPaymentMethodId') ? overrides.savedPaymentMethodId! : 'unde';
    }
    if (pickedFields.size === 0 || pickedFields.has('sensitiveInfo')) {
        result.sensitiveInfo = overrides && overrides.hasOwnProperty('sensitiveInfo') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfo(overrides.sensitiveInfo ?? {}, pickedFields.get('sensitiveInfo')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfo({}, pickedFields.get('sensitiveInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'iure';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfo = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('countryCode')) {
        result.countryCode = overrides && overrides.hasOwnProperty('countryCode') ? overrides.countryCode! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('iban')) {
        result.iban = overrides && overrides.hasOwnProperty('iban') ? overrides.iban! : 'repudiandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('ownerName')) {
        result.ownerName = overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'consequatur';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfoInput = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('countryCode')) {
        result.countryCode = overrides && overrides.hasOwnProperty('countryCode') ? overrides.countryCode! : 'at';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('iban')) {
        result.iban = overrides && overrides.hasOwnProperty('iban') ? overrides.iban! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('ownerName')) {
        result.ownerName = overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'ut';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddress = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddress(overrides.address ?? {}, pickedFields.get('address')) : aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddress({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactDetails')) {
        result.contactDetails = overrides && overrides.hasOwnProperty('contactDetails') ? aWixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetails(overrides.contactDetails ?? {}, pickedFields.get('contactDetails')) : aWixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetails({}, pickedFields.get('contactDetails'));
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddressInput = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactDetails')) {
        result.contactDetails = overrides && overrides.hasOwnProperty('contactDetails') ? aWixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetailsInput(overrides.contactDetails ?? {}, pickedFields.get('contactDetails')) : aWixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetailsInput({}, pickedFields.get('contactDetails'));
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementCardInfo = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementCardInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bin')) {
        result.bin = overrides && overrides.hasOwnProperty('bin') ? overrides.bin! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : WixPaymentsPaymentAgreementsV1PaymentAgreementCardBrandEnumCardBrand.Amex;
    }
    if (pickedFields.size === 0 || pickedFields.has('cardholderName')) {
        result.cardholderName = overrides && overrides.hasOwnProperty('cardholderName') ? overrides.cardholderName! : 'quae';
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationMonth')) {
        result.expirationMonth = overrides && overrides.hasOwnProperty('expirationMonth') ? overrides.expirationMonth! : 966;
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationYear')) {
        result.expirationYear = overrides && overrides.hasOwnProperty('expirationYear') ? overrides.expirationYear! : 5245;
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'est';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementCardInfoInput = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementCardInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bin')) {
        result.bin = overrides && overrides.hasOwnProperty('bin') ? overrides.bin! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : WixPaymentsPaymentAgreementsV1PaymentAgreementCardBrandEnumCardBrand.Amex;
    }
    if (pickedFields.size === 0 || pickedFields.has('cardholderName')) {
        result.cardholderName = overrides && overrides.hasOwnProperty('cardholderName') ? overrides.cardholderName! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationMonth')) {
        result.expirationMonth = overrides && overrides.hasOwnProperty('expirationMonth') ? overrides.expirationMonth! : 1204;
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationYear')) {
        result.expirationYear = overrides && overrides.hasOwnProperty('expirationYear') ? overrides.expirationYear! : 4463;
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'sed';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementInput = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('billingAddress')) {
        result.billingAddress = overrides && overrides.hasOwnProperty('billingAddress') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddressInput(overrides.billingAddress ?? {}, pickedFields.get('billingAddress')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddressInput({}, pickedFields.get('billingAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('chargeId')) {
        result.chargeId = overrides && overrides.hasOwnProperty('chargeId') ? overrides.chargeId! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantCreated')) {
        result.merchantCreated = overrides && overrides.hasOwnProperty('merchantCreated') ? overrides.merchantCreated! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('owner')) {
        result.owner = overrides && overrides.hasOwnProperty('owner') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementOwnerInput(overrides.owner ?? {}, pickedFields.get('owner')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementOwnerInput({}, pickedFields.get('owner'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentIntentId')) {
        result.paymentIntentId = overrides && overrides.hasOwnProperty('paymentIntentId') ? overrides.paymentIntentId! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethodInput(overrides.paymentMethod ?? {}, pickedFields.get('paymentMethod')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethodInput({}, pickedFields.get('paymentMethod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('providerId')) {
        result.providerId = overrides && overrides.hasOwnProperty('providerId') ? overrides.providerId! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('sandbox')) {
        result.sandbox = overrides && overrides.hasOwnProperty('sandbox') ? overrides.sandbox! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethodId')) {
        result.savedPaymentMethodId = overrides && overrides.hasOwnProperty('savedPaymentMethodId') ? overrides.savedPaymentMethodId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('sensitiveInfo')) {
        result.sensitiveInfo = overrides && overrides.hasOwnProperty('sensitiveInfo') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfoInput(overrides.sensitiveInfo ?? {}, pickedFields.get('sensitiveInfo')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfoInput({}, pickedFields.get('sensitiveInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'aspernatur';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReference = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReference>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dsTransactionId')) {
        result.dsTransactionId = overrides && overrides.hasOwnProperty('dsTransactionId') ? overrides.dsTransactionId! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('networkTransactionId')) {
        result.networkTransactionId = overrides && overrides.hasOwnProperty('networkTransactionId') ? overrides.networkTransactionId! : 'incidunt';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReferenceInput = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReferenceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('dsTransactionId')) {
        result.dsTransactionId = overrides && overrides.hasOwnProperty('dsTransactionId') ? overrides.dsTransactionId! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('networkTransactionId')) {
        result.networkTransactionId = overrides && overrides.hasOwnProperty('networkTransactionId') ? overrides.networkTransactionId! : 'pariatur';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementOwner = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementOwner>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteMemberId')) {
        result.siteMemberId = overrides && overrides.hasOwnProperty('siteMemberId') ? overrides.siteMemberId! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteVisitorId')) {
        result.siteVisitorId = overrides && overrides.hasOwnProperty('siteVisitorId') ? overrides.siteVisitorId! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'possimus';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementOwnerInput = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementOwnerInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteMemberId')) {
        result.siteMemberId = overrides && overrides.hasOwnProperty('siteMemberId') ? overrides.siteMemberId! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteVisitorId')) {
        result.siteVisitorId = overrides && overrides.hasOwnProperty('siteVisitorId') ? overrides.siteVisitorId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('userId')) {
        result.userId = overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'repellendus';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethod = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethod>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accountInfo')) {
        result.accountInfo = overrides && overrides.hasOwnProperty('accountInfo') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfo(overrides.accountInfo ?? {}, pickedFields.get('accountInfo')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfo({}, pickedFields.get('accountInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cardInfo')) {
        result.cardInfo = overrides && overrides.hasOwnProperty('cardInfo') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementCardInfo(overrides.cardInfo ?? {}, pickedFields.get('cardInfo')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementCardInfo({}, pickedFields.get('cardInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('typeId')) {
        result.typeId = overrides && overrides.hasOwnProperty('typeId') ? overrides.typeId! : 'qui';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethodInput = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethodInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('accountInfo')) {
        result.accountInfo = overrides && overrides.hasOwnProperty('accountInfo') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfoInput(overrides.accountInfo ?? {}, pickedFields.get('accountInfo')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfoInput({}, pickedFields.get('accountInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cardInfo')) {
        result.cardInfo = overrides && overrides.hasOwnProperty('cardInfo') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementCardInfoInput(overrides.cardInfo ?? {}, pickedFields.get('cardInfo')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementCardInfoInput({}, pickedFields.get('cardInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('typeId')) {
        result.typeId = overrides && overrides.hasOwnProperty('typeId') ? overrides.typeId! : 'eaque';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfo = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('merchantCredentials')) {
        result.merchantCredentials = overrides && overrides.hasOwnProperty('merchantCredentials') ? overrides.merchantCredentials! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('networkReference')) {
        result.networkReference = overrides && overrides.hasOwnProperty('networkReference') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReference(overrides.networkReference ?? {}, pickedFields.get('networkReference')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReference({}, pickedFields.get('networkReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('persistentCardToken')) {
        result.persistentCardToken = overrides && overrides.hasOwnProperty('persistentCardToken') ? overrides.persistentCardToken! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerToken')) {
        result.providerToken = overrides && overrides.hasOwnProperty('providerToken') ? overrides.providerToken! : 'quis';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfoInput = <T extends Partial<WixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('merchantCredentials')) {
        result.merchantCredentials = overrides && overrides.hasOwnProperty('merchantCredentials') ? overrides.merchantCredentials! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('networkReference')) {
        result.networkReference = overrides && overrides.hasOwnProperty('networkReference') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReferenceInput(overrides.networkReference ?? {}, pickedFields.get('networkReference')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReferenceInput({}, pickedFields.get('networkReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('persistentCardToken')) {
        result.persistentCardToken = overrides && overrides.hasOwnProperty('persistentCardToken') ? overrides.persistentCardToken! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerToken')) {
        result.providerToken = overrides && overrides.hasOwnProperty('providerToken') ? overrides.providerToken! : 'ut';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1QueryPaymentAgreementsRequestInput = <T extends Partial<WixPaymentsPaymentAgreementsV1QueryPaymentAgreementsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixPaymentsPaymentAgreementsV1RequestedFields.SensitiveInfo];
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixPaymentsPaymentAgreementsV1UpstreamWixQueryCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixPaymentsPaymentAgreementsV1UpstreamWixQueryCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1QueryPaymentAgreementsResponse = <T extends Partial<WixPaymentsPaymentAgreementsV1QueryPaymentAgreementsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixPaymentsPaymentAgreementsV1PaymentAgreement(x ?? {}, pickedFields.get('items'))) : [aWixPaymentsPaymentAgreementsV1PaymentAgreement({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpdateExtendedFieldsRequestInput = <T extends Partial<WixPaymentsPaymentAgreementsV1UpdateExtendedFieldsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixPaymentsPaymentAgreementsV1RequestedFields.SensitiveInfo];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespace')) {
        result.namespace = overrides && overrides.hasOwnProperty('namespace') ? overrides.namespace! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('namespaceData')) {
        result.namespaceData = overrides && overrides.hasOwnProperty('namespaceData') ? overrides.namespaceData! : 'ab';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpdateExtendedFieldsResponse = <T extends Partial<WixPaymentsPaymentAgreementsV1UpdateExtendedFieldsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentAgreement')) {
        result.paymentAgreement = overrides && overrides.hasOwnProperty('paymentAgreement') ? aWixPaymentsPaymentAgreementsV1PaymentAgreement(overrides.paymentAgreement ?? {}, pickedFields.get('paymentAgreement')) : aWixPaymentsPaymentAgreementsV1PaymentAgreement({}, pickedFields.get('paymentAgreement'));
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpdatePaymentAgreementRequestInput = <T extends Partial<WixPaymentsPaymentAgreementsV1UpdatePaymentAgreementRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['distinctio'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixPaymentsPaymentAgreementsV1RequestedFields.SensitiveInfo];
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentAgreement')) {
        result.paymentAgreement = overrides && overrides.hasOwnProperty('paymentAgreement') ? aWixPaymentsPaymentAgreementsV1PaymentAgreementInput(overrides.paymentAgreement ?? {}, pickedFields.get('paymentAgreement')) : aWixPaymentsPaymentAgreementsV1PaymentAgreementInput({}, pickedFields.get('paymentAgreement'));
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpdatePaymentAgreementResponse = <T extends Partial<WixPaymentsPaymentAgreementsV1UpdatePaymentAgreementResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentAgreement')) {
        result.paymentAgreement = overrides && overrides.hasOwnProperty('paymentAgreement') ? aWixPaymentsPaymentAgreementsV1PaymentAgreement(overrides.paymentAgreement ?? {}, pickedFields.get('paymentAgreement')) : aWixPaymentsPaymentAgreementsV1PaymentAgreement({}, pickedFields.get('paymentAgreement'));
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddress = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocation(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocation({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionFullname')) {
        result.subdivisionFullname = overrides && overrides.hasOwnProperty('subdivisionFullname') ? overrides.subdivisionFullname! : 'fugiat';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aWixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivision(x ?? {}, pickedFields.get('subdivisions'))) : [aWixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivision({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressInput = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocationInput(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocationInput({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'aperiam';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionFullname')) {
        result.subdivisionFullname = overrides && overrides.hasOwnProperty('subdivisionFullname') ? overrides.subdivisionFullname! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aWixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))) : [aWixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocation = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 0.96;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 3.34;
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocationInput = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 2.46;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 9.07;
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3754;
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetails = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('fullName')) {
        result.fullName = overrides && overrides.hasOwnProperty('fullName') ? overrides.fullName! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('vatId')) {
        result.vatId = overrides && overrides.hasOwnProperty('vatId') ? aWixPaymentsPaymentAgreementsV1UpstreamWixCommonVatId(overrides.vatId ?? {}, pickedFields.get('vatId')) : aWixPaymentsPaymentAgreementsV1UpstreamWixCommonVatId({}, pickedFields.get('vatId'));
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetailsInput = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('fullName')) {
        result.fullName = overrides && overrides.hasOwnProperty('fullName') ? overrides.fullName! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('vatId')) {
        result.vatId = overrides && overrides.hasOwnProperty('vatId') ? aWixPaymentsPaymentAgreementsV1UpstreamWixCommonVatIdInput(overrides.vatId ?? {}, pickedFields.get('vatId')) : aWixPaymentsPaymentAgreementsV1UpstreamWixCommonVatIdInput({}, pickedFields.get('vatId'));
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonSortingInput = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'delectus';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixPaymentsPaymentAgreementsV1UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddress = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddressLine')) {
        result.formattedAddressLine = overrides && overrides.hasOwnProperty('formattedAddressLine') ? overrides.formattedAddressLine! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'ipsum';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddressInput = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddressLine')) {
        result.formattedAddressLine = overrides && overrides.hasOwnProperty('formattedAddressLine') ? overrides.formattedAddressLine! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'quis';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivision = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivision>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionSubdivisionType.AdministrativeAreaLevel_1;
    }
    if (pickedFields.size === 0 || pickedFields.has('typeInfo')) {
        result.typeInfo = overrides && overrides.hasOwnProperty('typeInfo') ? overrides.typeInfo! : 'rem';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionInput = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionSubdivisionType.AdministrativeAreaLevel_1;
    }
    if (pickedFields.size === 0 || pickedFields.has('typeInfo')) {
        result.typeInfo = overrides && overrides.hasOwnProperty('typeInfo') ? overrides.typeInfo! : 'ipsa';
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonVatId = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatId>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatType.Cnpj;
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixCommonVatIdInput = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatIdInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatType.Cnpj;
    }

    return result;
};

export const aWixPaymentsPaymentAgreementsV1UpstreamWixQueryCursorQueryInput = <T extends Partial<WixPaymentsPaymentAgreementsV1UpstreamWixQueryCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixPaymentsPaymentAgreementsV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixPaymentsPaymentAgreementsV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixPaymentsPaymentAgreementsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixPaymentsPaymentAgreementsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixPaymentsRefundsV1CreateRefundRequestInput = <T extends Partial<WixPaymentsRefundsV1CreateRefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('previouslyRefundedAmount')) {
        result.previouslyRefundedAmount = overrides && overrides.hasOwnProperty('previouslyRefundedAmount') ? overrides.previouslyRefundedAmount! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? aWixPaymentsRefundsV1RefundInput(overrides.refund ?? {}, pickedFields.get('refund')) : aWixPaymentsRefundsV1RefundInput({}, pickedFields.get('refund'));
    }
    if (pickedFields.size === 0 || pickedFields.has('returnProcessingFee')) {
        result.returnProcessingFee = overrides && overrides.hasOwnProperty('returnProcessingFee') ? overrides.returnProcessingFee! : true;
    }

    return result;
};

export const aWixPaymentsRefundsV1CreateRefundResponse = <T extends Partial<WixPaymentsRefundsV1CreateRefundResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? aWixPaymentsRefundsV1Refund(overrides.refund ?? {}, pickedFields.get('refund')) : aWixPaymentsRefundsV1Refund({}, pickedFields.get('refund'));
    }

    return result;
};

export const aWixPaymentsRefundsV1GetRefundRequestInput = <T extends Partial<WixPaymentsRefundsV1GetRefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '546f1ac8-8c95-4afe-87fc-ec1578feb39b';
    }

    return result;
};

export const aWixPaymentsRefundsV1GetRefundabilityRequestInput = <T extends Partial<WixPaymentsRefundsV1GetRefundabilityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('chargeId')) {
        result.chargeId = overrides && overrides.hasOwnProperty('chargeId') ? overrides.chargeId! : 'veniam';
    }

    return result;
};

export const aWixPaymentsRefundsV1GetRefundabilityResponse = <T extends Partial<WixPaymentsRefundsV1GetRefundabilityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('refundability')) {
        result.refundability = overrides && overrides.hasOwnProperty('refundability') ? aWixPaymentsRefundsV1Refundability(overrides.refundability ?? {}, pickedFields.get('refundability')) : aWixPaymentsRefundsV1Refundability({}, pickedFields.get('refundability'));
    }

    return result;
};

export const aWixPaymentsRefundsV1InternalSyncRefundRequestInput = <T extends Partial<WixPaymentsRefundsV1InternalSyncRefundRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('acquirerReferenceNumber')) {
        result.acquirerReferenceNumber = overrides && overrides.hasOwnProperty('acquirerReferenceNumber') ? overrides.acquirerReferenceNumber! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('chargeId')) {
        result.chargeId = overrides && overrides.hasOwnProperty('chargeId') ? overrides.chargeId! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyCode')) {
        result.currencyCode = overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerRefundId')) {
        result.providerRefundId = overrides && overrides.hasOwnProperty('providerRefundId') ? overrides.providerRefundId! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundId')) {
        result.refundId = overrides && overrides.hasOwnProperty('refundId') ? overrides.refundId! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnedApplicationFee')) {
        result.returnedApplicationFee = overrides && overrides.hasOwnProperty('returnedApplicationFee') ? overrides.returnedApplicationFee! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnedProcessingFee')) {
        result.returnedProcessingFee = overrides && overrides.hasOwnProperty('returnedProcessingFee') ? overrides.returnedProcessingFee! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixPaymentsRefundsV1RefundStatus.Failed;
    }
    if (pickedFields.size === 0 || pickedFields.has('statusCode')) {
        result.statusCode = overrides && overrides.hasOwnProperty('statusCode') ? overrides.statusCode! : 'corrupti';
    }

    return result;
};

export const aWixPaymentsRefundsV1InternalSyncRefundResponse = <T extends Partial<WixPaymentsRefundsV1InternalSyncRefundResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? aWixPaymentsRefundsV1Refund(overrides.refund ?? {}, pickedFields.get('refund')) : aWixPaymentsRefundsV1Refund({}, pickedFields.get('refund'));
    }

    return result;
};

export const aWixPaymentsRefundsV1QueryRefundsRequestInput = <T extends Partial<WixPaymentsRefundsV1QueryRefundsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixPaymentsRefundsV1UpstreamWixQueryCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixPaymentsRefundsV1UpstreamWixQueryCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixPaymentsRefundsV1QueryRefundsResponse = <T extends Partial<WixPaymentsRefundsV1QueryRefundsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixPaymentsRefundsV1Refund(x ?? {}, pickedFields.get('items'))) : [aWixPaymentsRefundsV1Refund({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixPaymentsRefundsV1Refund = <T extends Partial<WixPaymentsRefundsV1Refund>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('acquirerReferenceNumber')) {
        result.acquirerReferenceNumber = overrides && overrides.hasOwnProperty('acquirerReferenceNumber') ? overrides.acquirerReferenceNumber! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('chargeId')) {
        result.chargeId = overrides && overrides.hasOwnProperty('chargeId') ? overrides.chargeId! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyCode')) {
        result.currencyCode = overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('full')) {
        result.full = overrides && overrides.hasOwnProperty('full') ? overrides.full! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('initiator')) {
        result.initiator = overrides && overrides.hasOwnProperty('initiator') ? overrides.initiator! : WixPaymentsRefundsV1RefundInitiator.Api;
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerRefundId')) {
        result.providerRefundId = overrides && overrides.hasOwnProperty('providerRefundId') ? overrides.providerRefundId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnedApplicationFee')) {
        result.returnedApplicationFee = overrides && overrides.hasOwnProperty('returnedApplicationFee') ? overrides.returnedApplicationFee! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnedProcessingFee')) {
        result.returnedProcessingFee = overrides && overrides.hasOwnProperty('returnedProcessingFee') ? overrides.returnedProcessingFee! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixPaymentsRefundsV1RefundStatus.Failed;
    }
    if (pickedFields.size === 0 || pickedFields.has('statusInfo')) {
        result.statusInfo = overrides && overrides.hasOwnProperty('statusInfo') ? aWixPaymentsRefundsV1StatusInfo(overrides.statusInfo ?? {}, pickedFields.get('statusInfo')) : aWixPaymentsRefundsV1StatusInfo({}, pickedFields.get('statusInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'nemo';
    }

    return result;
};

export const aWixPaymentsRefundsV1RefundDetails = <T extends Partial<WixPaymentsRefundsV1RefundDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxRefundAmount')) {
        result.maxRefundAmount = overrides && overrides.hasOwnProperty('maxRefundAmount') ? overrides.maxRefundAmount! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('minRefundAmount')) {
        result.minRefundAmount = overrides && overrides.hasOwnProperty('minRefundAmount') ? overrides.minRefundAmount! : 'iste';
    }

    return result;
};

export const aWixPaymentsRefundsV1RefundInput = <T extends Partial<WixPaymentsRefundsV1RefundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('acquirerReferenceNumber')) {
        result.acquirerReferenceNumber = overrides && overrides.hasOwnProperty('acquirerReferenceNumber') ? overrides.acquirerReferenceNumber! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('chargeId')) {
        result.chargeId = overrides && overrides.hasOwnProperty('chargeId') ? overrides.chargeId! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyCode')) {
        result.currencyCode = overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('full')) {
        result.full = overrides && overrides.hasOwnProperty('full') ? overrides.full! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('initiator')) {
        result.initiator = overrides && overrides.hasOwnProperty('initiator') ? overrides.initiator! : WixPaymentsRefundsV1RefundInitiator.Api;
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerRefundId')) {
        result.providerRefundId = overrides && overrides.hasOwnProperty('providerRefundId') ? overrides.providerRefundId! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnedApplicationFee')) {
        result.returnedApplicationFee = overrides && overrides.hasOwnProperty('returnedApplicationFee') ? overrides.returnedApplicationFee! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('returnedProcessingFee')) {
        result.returnedProcessingFee = overrides && overrides.hasOwnProperty('returnedProcessingFee') ? overrides.returnedProcessingFee! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixPaymentsRefundsV1RefundStatus.Failed;
    }
    if (pickedFields.size === 0 || pickedFields.has('statusInfo')) {
        result.statusInfo = overrides && overrides.hasOwnProperty('statusInfo') ? aWixPaymentsRefundsV1StatusInfoInput(overrides.statusInfo ?? {}, pickedFields.get('statusInfo')) : aWixPaymentsRefundsV1StatusInfoInput({}, pickedFields.get('statusInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'totam';
    }

    return result;
};

export const aWixPaymentsRefundsV1Refundability = <T extends Partial<WixPaymentsRefundsV1Refundability>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyCode')) {
        result.currencyCode = overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('previouslyRefundedAmount')) {
        result.previouslyRefundedAmount = overrides && overrides.hasOwnProperty('previouslyRefundedAmount') ? overrides.previouslyRefundedAmount! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('refundDetails')) {
        result.refundDetails = overrides && overrides.hasOwnProperty('refundDetails') ? aWixPaymentsRefundsV1RefundDetails(overrides.refundDetails ?? {}, pickedFields.get('refundDetails')) : aWixPaymentsRefundsV1RefundDetails({}, pickedFields.get('refundDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refundable')) {
        result.refundable = overrides && overrides.hasOwnProperty('refundable') ? overrides.refundable! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('rejectionDetails')) {
        result.rejectionDetails = overrides && overrides.hasOwnProperty('rejectionDetails') ? aWixPaymentsRefundsV1RejectionDetails(overrides.rejectionDetails ?? {}, pickedFields.get('rejectionDetails')) : aWixPaymentsRefundsV1RejectionDetails({}, pickedFields.get('rejectionDetails'));
    }

    return result;
};

export const aWixPaymentsRefundsV1RejectionDetails = <T extends Partial<WixPaymentsRefundsV1RejectionDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : WixPaymentsRefundsV1RejectionDetailsRejectionReason.ChargeDisputed;
    }

    return result;
};

export const aWixPaymentsRefundsV1StatusInfo = <T extends Partial<WixPaymentsRefundsV1StatusInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'nostrum';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'et';
    }

    return result;
};

export const aWixPaymentsRefundsV1StatusInfoInput = <T extends Partial<WixPaymentsRefundsV1StatusInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'odit';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'error';
    }

    return result;
};

export const aWixPaymentsRefundsV1UpdateExtendedFieldsResponse = <T extends Partial<WixPaymentsRefundsV1UpdateExtendedFieldsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('refund')) {
        result.refund = overrides && overrides.hasOwnProperty('refund') ? aWixPaymentsRefundsV1Refund(overrides.refund ?? {}, pickedFields.get('refund')) : aWixPaymentsRefundsV1Refund({}, pickedFields.get('refund'));
    }

    return result;
};

export const aWixPaymentsRefundsV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixPaymentsRefundsV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3408;
    }

    return result;
};

export const aWixPaymentsRefundsV1UpstreamWixCommonSortingInput = <T extends Partial<WixPaymentsRefundsV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixPaymentsRefundsV1UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixPaymentsRefundsV1UpstreamWixQueryCursorQueryInput = <T extends Partial<WixPaymentsRefundsV1UpstreamWixQueryCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixPaymentsRefundsV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixPaymentsRefundsV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixPaymentsRefundsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixPaymentsRefundsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingInput = <T extends Partial<WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 6539;
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingMetadata = <T extends Partial<WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 3062;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixPaymentsSavedPaymentMethodsUpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixPaymentsSavedPaymentMethodsUpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsUpstreamWixCommonCursors = <T extends Partial<WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'et';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1DeleteSavedPaymentMethodRequestInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1DeleteSavedPaymentMethodRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethodId')) {
        result.savedPaymentMethodId = overrides && overrides.hasOwnProperty('savedPaymentMethodId') ? overrides.savedPaymentMethodId! : 'qui';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1FindSavedCreditCardRequestInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1FindSavedCreditCardRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expirationMonth')) {
        result.expirationMonth = overrides && overrides.hasOwnProperty('expirationMonth') ? overrides.expirationMonth! : 9776;
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationYear')) {
        result.expirationYear = overrides && overrides.hasOwnProperty('expirationYear') ? overrides.expirationYear! : 9192;
    }
    if (pickedFields.size === 0 || pickedFields.has('siteMemberId')) {
        result.siteMemberId = overrides && overrides.hasOwnProperty('siteMemberId') ? overrides.siteMemberId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('temporaryCardToken')) {
        result.temporaryCardToken = overrides && overrides.hasOwnProperty('temporaryCardToken') ? overrides.temporaryCardToken! : 'minima';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1FindSavedCreditCardResponse = <T extends Partial<WixPaymentsSavedPaymentMethodsV1FindSavedCreditCardResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethodId')) {
        result.savedPaymentMethodId = overrides && overrides.hasOwnProperty('savedPaymentMethodId') ? overrides.savedPaymentMethodId! : 'ab';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1GetSavedPaymentMethodRequestInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1GetSavedPaymentMethodRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixPaymentsSavedPaymentMethodsV1RequestedFields.SensitiveInfo];
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'be5d4467-457f-4c9e-b8db-7431509b87da';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsRequestInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [WixPaymentsSavedPaymentMethodsV1RequestedFields.SensitiveInfo];
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantUseAllowed')) {
        result.merchantUseAllowed = overrides && overrides.hasOwnProperty('merchantUseAllowed') ? overrides.merchantUseAllowed! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethodTypeId')) {
        result.paymentMethodTypeId = overrides && overrides.hasOwnProperty('paymentMethodTypeId') ? overrides.paymentMethodTypeId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('siteMemberId')) {
        result.siteMemberId = overrides && overrides.hasOwnProperty('siteMemberId') ? overrides.siteMemberId! : 'deleniti';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsResponse = <T extends Partial<WixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethods')) {
        result.savedPaymentMethods = overrides && overrides.hasOwnProperty('savedPaymentMethods') ? overrides.savedPaymentMethods!.map((x) => aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethod(x ?? {}, pickedFields.get('savedPaymentMethods'))) : [aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethod({}, pickedFields.get('savedPaymentMethods'))];
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1MarkSavedPaymentMethodPrimaryRequestInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1MarkSavedPaymentMethodPrimaryRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethodId')) {
        result.savedPaymentMethodId = overrides && overrides.hasOwnProperty('savedPaymentMethodId') ? overrides.savedPaymentMethodId! : 'aut';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethod = <T extends Partial<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('member')) {
        result.member = overrides && overrides.hasOwnProperty('member') ? aComWixpressMembersApiMember(overrides.member ?? {}, pickedFields.get('member')) : aComWixpressMembersApiMember({}, pickedFields.get('member'));
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantUseAllowed')) {
        result.merchantUseAllowed = overrides && overrides.hasOwnProperty('merchantUseAllowed') ? overrides.merchantUseAllowed! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethod(overrides.paymentMethod ?? {}, pickedFields.get('paymentMethod')) : aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethod({}, pickedFields.get('paymentMethod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('sensitiveInfo')) {
        result.sensitiveInfo = overrides && overrides.hasOwnProperty('sensitiveInfo') ? aWixPaymentsSavedPaymentMethodsV1SensitiveInfo(overrides.sensitiveInfo ?? {}, pickedFields.get('sensitiveInfo')) : aWixPaymentsSavedPaymentMethodsV1SensitiveInfo({}, pickedFields.get('sensitiveInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteMemberId')) {
        result.siteMemberId = overrides && overrides.hasOwnProperty('siteMemberId') ? overrides.siteMemberId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'ullam';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfo = <T extends Partial<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bin')) {
        result.bin = overrides && overrides.hasOwnProperty('bin') ? overrides.bin! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : WixPaymentsSavedPaymentMethodsV1CardBrandEnumCardBrand.Amex;
    }
    if (pickedFields.size === 0 || pickedFields.has('cardholderName')) {
        result.cardholderName = overrides && overrides.hasOwnProperty('cardholderName') ? overrides.cardholderName! : 'at';
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationMonth')) {
        result.expirationMonth = overrides && overrides.hasOwnProperty('expirationMonth') ? overrides.expirationMonth! : 5613;
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationYear')) {
        result.expirationYear = overrides && overrides.hasOwnProperty('expirationYear') ? overrides.expirationYear! : 8944;
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'natus';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfoInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bin')) {
        result.bin = overrides && overrides.hasOwnProperty('bin') ? overrides.bin! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('brand')) {
        result.brand = overrides && overrides.hasOwnProperty('brand') ? overrides.brand! : WixPaymentsSavedPaymentMethodsV1CardBrandEnumCardBrand.Amex;
    }
    if (pickedFields.size === 0 || pickedFields.has('cardholderName')) {
        result.cardholderName = overrides && overrides.hasOwnProperty('cardholderName') ? overrides.cardholderName! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationMonth')) {
        result.expirationMonth = overrides && overrides.hasOwnProperty('expirationMonth') ? overrides.expirationMonth! : 9790;
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationYear')) {
        result.expirationYear = overrides && overrides.hasOwnProperty('expirationYear') ? overrides.expirationYear! : 3649;
    }
    if (pickedFields.size === 0 || pickedFields.has('lastFourDigits')) {
        result.lastFourDigits = overrides && overrides.hasOwnProperty('lastFourDigits') ? overrides.lastFourDigits! : 'error';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantUseAllowed')) {
        result.merchantUseAllowed = overrides && overrides.hasOwnProperty('merchantUseAllowed') ? overrides.merchantUseAllowed! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethodInput(overrides.paymentMethod ?? {}, pickedFields.get('paymentMethod')) : aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethodInput({}, pickedFields.get('paymentMethod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('primary')) {
        result.primary = overrides && overrides.hasOwnProperty('primary') ? overrides.primary! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('sensitiveInfo')) {
        result.sensitiveInfo = overrides && overrides.hasOwnProperty('sensitiveInfo') ? aWixPaymentsSavedPaymentMethodsV1SensitiveInfoInput(overrides.sensitiveInfo ?? {}, pickedFields.get('sensitiveInfo')) : aWixPaymentsSavedPaymentMethodsV1SensitiveInfoInput({}, pickedFields.get('sensitiveInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('siteMemberId')) {
        result.siteMemberId = overrides && overrides.hasOwnProperty('siteMemberId') ? overrides.siteMemberId! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'quod';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethod = <T extends Partial<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethod>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cardInfo')) {
        result.cardInfo = overrides && overrides.hasOwnProperty('cardInfo') ? aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfo(overrides.cardInfo ?? {}, pickedFields.get('cardInfo')) : aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfo({}, pickedFields.get('cardInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethodBrandId')) {
        result.paymentMethodBrandId = overrides && overrides.hasOwnProperty('paymentMethodBrandId') ? overrides.paymentMethodBrandId! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethodTypeId')) {
        result.paymentMethodTypeId = overrides && overrides.hasOwnProperty('paymentMethodTypeId') ? overrides.paymentMethodTypeId! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('typeId')) {
        result.typeId = overrides && overrides.hasOwnProperty('typeId') ? overrides.typeId! : 'quo';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethodInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethodInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cardInfo')) {
        result.cardInfo = overrides && overrides.hasOwnProperty('cardInfo') ? aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfoInput(overrides.cardInfo ?? {}, pickedFields.get('cardInfo')) : aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfoInput({}, pickedFields.get('cardInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethodBrandId')) {
        result.paymentMethodBrandId = overrides && overrides.hasOwnProperty('paymentMethodBrandId') ? overrides.paymentMethodBrandId! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethodTypeId')) {
        result.paymentMethodTypeId = overrides && overrides.hasOwnProperty('paymentMethodTypeId') ? overrides.paymentMethodTypeId! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('typeId')) {
        result.typeId = overrides && overrides.hasOwnProperty('typeId') ? overrides.typeId! : 'similique';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1SensitiveInfo = <T extends Partial<WixPaymentsSavedPaymentMethodsV1SensitiveInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cardSensitiveInfo')) {
        result.cardSensitiveInfo = overrides && overrides.hasOwnProperty('cardSensitiveInfo') ? aWixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfo(overrides.cardSensitiveInfo ?? {}, pickedFields.get('cardSensitiveInfo')) : aWixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfo({}, pickedFields.get('cardSensitiveInfo'));
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfo = <T extends Partial<WixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('persistentToken')) {
        result.persistentToken = overrides && overrides.hasOwnProperty('persistentToken') ? overrides.persistentToken! : 'quas';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfoInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('persistentToken')) {
        result.persistentToken = overrides && overrides.hasOwnProperty('persistentToken') ? overrides.persistentToken! : 'molestiae';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1SensitiveInfoInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1SensitiveInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cardSensitiveInfo')) {
        result.cardSensitiveInfo = overrides && overrides.hasOwnProperty('cardSensitiveInfo') ? aWixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfoInput(overrides.cardSensitiveInfo ?? {}, pickedFields.get('cardSensitiveInfo')) : aWixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfoInput({}, pickedFields.get('cardSensitiveInfo'));
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodRequestInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['debitis'];
    }
    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethod')) {
        result.savedPaymentMethod = overrides && overrides.hasOwnProperty('savedPaymentMethod') ? aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput(overrides.savedPaymentMethod ?? {}, pickedFields.get('savedPaymentMethod')) : aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput({}, pickedFields.get('savedPaymentMethod'));
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodResponse = <T extends Partial<WixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethod')) {
        result.savedPaymentMethod = overrides && overrides.hasOwnProperty('savedPaymentMethod') ? aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethod(overrides.savedPaymentMethod ?? {}, pickedFields.get('savedPaymentMethod')) : aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethod({}, pickedFields.get('savedPaymentMethod'));
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodRequestInput = <T extends Partial<WixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethod')) {
        result.savedPaymentMethod = overrides && overrides.hasOwnProperty('savedPaymentMethod') ? aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput(overrides.savedPaymentMethod ?? {}, pickedFields.get('savedPaymentMethod')) : aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput({}, pickedFields.get('savedPaymentMethod'));
    }
    if (pickedFields.size === 0 || pickedFields.has('temporaryCardToken')) {
        result.temporaryCardToken = overrides && overrides.hasOwnProperty('temporaryCardToken') ? overrides.temporaryCardToken! : 'eius';
    }

    return result;
};

export const aWixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodResponse = <T extends Partial<WixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('savedPaymentMethod')) {
        result.savedPaymentMethod = overrides && overrides.hasOwnProperty('savedPaymentMethod') ? aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethod(overrides.savedPaymentMethod ?? {}, pickedFields.get('savedPaymentMethod')) : aWixPaymentsSavedPaymentMethodsV1SavedPaymentMethod({}, pickedFields.get('savedPaymentMethod'));
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1BuyerFlow = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1BuyerFlow>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('countryRestricted')) {
        result.countryRestricted = overrides && overrides.hasOwnProperty('countryRestricted') ? overrides.countryRestricted! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('icons')) {
        result.icons = overrides && overrides.hasOwnProperty('icons') ? overrides.icons!.map((x) => aWixPaymentsSitePaymentMethodTypesV1Icon(x ?? {}, pickedFields.get('icons'))) : [aWixPaymentsSitePaymentMethodTypesV1Icon({}, pickedFields.get('icons'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('minPaymentAmount')) {
        result.minPaymentAmount = overrides && overrides.hasOwnProperty('minPaymentAmount') ? overrides.minPaymentAmount! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('priority')) {
        result.priority = overrides && overrides.hasOwnProperty('priority') ? overrides.priority! : 9048;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1Features = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1Features>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authCapture')) {
        result.authCapture = overrides && overrides.hasOwnProperty('authCapture') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesAuthCapture(overrides.authCapture ?? {}, pickedFields.get('authCapture')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesAuthCapture({}, pickedFields.get('authCapture'));
    }
    if (pickedFields.size === 0 || pickedFields.has('credentialOnFile')) {
        result.credentialOnFile = overrides && overrides.hasOwnProperty('credentialOnFile') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesCredentialOnFile(overrides.credentialOnFile ?? {}, pickedFields.get('credentialOnFile')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesCredentialOnFile({}, pickedFields.get('credentialOnFile'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customTokenization')) {
        result.customTokenization = overrides && overrides.hasOwnProperty('customTokenization') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesCustomTokenization(overrides.customTokenization ?? {}, pickedFields.get('customTokenization')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesCustomTokenization({}, pickedFields.get('customTokenization'));
    }
    if (pickedFields.size === 0 || pickedFields.has('disputes')) {
        result.disputes = overrides && overrides.hasOwnProperty('disputes') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesDisputes(overrides.disputes ?? {}, pickedFields.get('disputes')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesDisputes({}, pickedFields.get('disputes'));
    }
    if (pickedFields.size === 0 || pickedFields.has('expressFlow')) {
        result.expressFlow = overrides && overrides.hasOwnProperty('expressFlow') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesExpressFlow(overrides.expressFlow ?? {}, pickedFields.get('expressFlow')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesExpressFlow({}, pickedFields.get('expressFlow'));
    }
    if (pickedFields.size === 0 || pickedFields.has('installments')) {
        result.installments = overrides && overrides.hasOwnProperty('installments') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesInstallments(overrides.installments ?? {}, pickedFields.get('installments')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesInstallments({}, pickedFields.get('installments'));
    }
    if (pickedFields.size === 0 || pickedFields.has('moto')) {
        result.moto = overrides && overrides.hasOwnProperty('moto') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesMoto(overrides.moto ?? {}, pickedFields.get('moto')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesMoto({}, pickedFields.get('moto'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nextAction')) {
        result.nextAction = overrides && overrides.hasOwnProperty('nextAction') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesNextAction(overrides.nextAction ?? {}, pickedFields.get('nextAction')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesNextAction({}, pickedFields.get('nextAction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('promotionalMessages')) {
        result.promotionalMessages = overrides && overrides.hasOwnProperty('promotionalMessages') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesPromotionalMessages(overrides.promotionalMessages ?? {}, pickedFields.get('promotionalMessages')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesPromotionalMessages({}, pickedFields.get('promotionalMessages'));
    }
    if (pickedFields.size === 0 || pickedFields.has('refunds')) {
        result.refunds = overrides && overrides.hasOwnProperty('refunds') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesRefunds(overrides.refunds ?? {}, pickedFields.get('refunds')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesRefunds({}, pickedFields.get('refunds'));
    }
    if (pickedFields.size === 0 || pickedFields.has('regularFlow')) {
        result.regularFlow = overrides && overrides.hasOwnProperty('regularFlow') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesRegularFlow(overrides.regularFlow ?? {}, pickedFields.get('regularFlow')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesRegularFlow({}, pickedFields.get('regularFlow'));
    }
    if (pickedFields.size === 0 || pickedFields.has('regularTokenization')) {
        result.regularTokenization = overrides && overrides.hasOwnProperty('regularTokenization') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesRegularTokenization(overrides.regularTokenization ?? {}, pickedFields.get('regularTokenization')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesRegularTokenization({}, pickedFields.get('regularTokenization'));
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesAuthCapture = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesAuthCapture>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxCapturePeriodInDays')) {
        result.maxCapturePeriodInDays = overrides && overrides.hasOwnProperty('maxCapturePeriodInDays') ? overrides.maxCapturePeriodInDays! : 7267;
    }
    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : false;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesCredentialOnFile = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesCredentialOnFile>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : true;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesCustomTokenization = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesCustomTokenization>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : false;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesDisputes = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesDisputes>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : true;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesExpressFlow = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesExpressFlow>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : true;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesInstallments = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesInstallments>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowedCountries')) {
        result.allowedCountries = overrides && overrides.hasOwnProperty('allowedCountries') ? overrides.allowedCountries! : ['qui'];
    }
    if (pickedFields.size === 0 || pickedFields.has('allowedCountryCodes')) {
        result.allowedCountryCodes = overrides && overrides.hasOwnProperty('allowedCountryCodes') ? overrides.allowedCountryCodes! : ['rem'];
    }
    if (pickedFields.size === 0 || pickedFields.has('maxInstallmentLimit')) {
        result.maxInstallmentLimit = overrides && overrides.hasOwnProperty('maxInstallmentLimit') ? overrides.maxInstallmentLimit! : 1963;
    }
    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : false;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesMoto = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesMoto>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : false;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesNextAction = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesNextAction>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('barcode')) {
        result.barcode = overrides && overrides.hasOwnProperty('barcode') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionBarcode(overrides.barcode ?? {}, pickedFields.get('barcode')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionBarcode({}, pickedFields.get('barcode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fullPageRedirect')) {
        result.fullPageRedirect = overrides && overrides.hasOwnProperty('fullPageRedirect') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionFullPageRedirect(overrides.fullPageRedirect ?? {}, pickedFields.get('fullPageRedirect')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionFullPageRedirect({}, pickedFields.get('fullPageRedirect'));
    }
    if (pickedFields.size === 0 || pickedFields.has('iframe')) {
        result.iframe = overrides && overrides.hasOwnProperty('iframe') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionIFrame(overrides.iframe ?? {}, pickedFields.get('iframe')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionIFrame({}, pickedFields.get('iframe'));
    }
    if (pickedFields.size === 0 || pickedFields.has('newTab')) {
        result.newTab = overrides && overrides.hasOwnProperty('newTab') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionNewTab(overrides.newTab ?? {}, pickedFields.get('newTab')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionNewTab({}, pickedFields.get('newTab'));
    }
    if (pickedFields.size === 0 || pickedFields.has('qrCode')) {
        result.qrCode = overrides && overrides.hasOwnProperty('qrCode') ? aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionQrCode(overrides.qrCode ?? {}, pickedFields.get('qrCode')) : aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionQrCode({}, pickedFields.get('qrCode'));
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionBarcode = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionBarcode>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : true;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionFullPageRedirect = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionFullPageRedirect>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : false;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionIFrame = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionIFrame>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : true;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionNewTab = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionNewTab>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : true;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesNextActionQrCode = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionQrCode>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : false;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesPromotionalMessages = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesPromotionalMessages>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : false;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesRefunds = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesRefunds>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxRefundabilityPeriodInDays')) {
        result.maxRefundabilityPeriodInDays = overrides && overrides.hasOwnProperty('maxRefundabilityPeriodInDays') ? overrides.maxRefundabilityPeriodInDays! : 3394;
    }
    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : false;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesRegularFlow = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesRegularFlow>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : false;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1FeaturesRegularTokenization = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1FeaturesRegularTokenization>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('supported')) {
        result.supported = overrides && overrides.hasOwnProperty('supported') ? overrides.supported! : false;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1GetSitePaymentMethodTypeRequestInput = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1GetSitePaymentMethodTypeRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('countryCode')) {
        result.countryCode = overrides && overrides.hasOwnProperty('countryCode') ? overrides.countryCode! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyCode')) {
        result.currencyCode = overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a286538e-11ae-403a-ace9-cc87bf8dac08';
    }
    if (pickedFields.size === 0 || pickedFields.has('languageCode')) {
        result.languageCode = overrides && overrides.hasOwnProperty('languageCode') ? overrides.languageCode! : 'facilis';
    }
    if (pickedFields.size === 0 || pickedFields.has('requestedFields')) {
        result.requestedFields = overrides && overrides.hasOwnProperty('requestedFields') ? overrides.requestedFields! : [WixPaymentsSitePaymentMethodTypesV1RequestedFields.AllowedCurrencies];
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1Icon = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1Icon>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('format')) {
        result.format = overrides && overrides.hasOwnProperty('format') ? overrides.format! : WixPaymentsSitePaymentMethodTypesV1IconFormat.Png;
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixPaymentsSitePaymentMethodTypesV1UpstreamWixCommonImage(overrides.image ?? {}, pickedFields.get('image')) : aWixPaymentsSitePaymentMethodTypesV1UpstreamWixCommonImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tag')) {
        result.tag = overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : 'qui';
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesRequestInput = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('countryCode')) {
        result.countryCode = overrides && overrides.hasOwnProperty('countryCode') ? overrides.countryCode! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyCode')) {
        result.currencyCode = overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['voluptatum'];
    }
    if (pickedFields.size === 0 || pickedFields.has('languageCode')) {
        result.languageCode = overrides && overrides.hasOwnProperty('languageCode') ? overrides.languageCode! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('requestedFields')) {
        result.requestedFields = overrides && overrides.hasOwnProperty('requestedFields') ? overrides.requestedFields! : [WixPaymentsSitePaymentMethodTypesV1RequestedFields.AllowedCurrencies];
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesResponse = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sitePaymentMethodTypes')) {
        result.sitePaymentMethodTypes = overrides && overrides.hasOwnProperty('sitePaymentMethodTypes') ? overrides.sitePaymentMethodTypes!.map((x) => aWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType(x ?? {}, pickedFields.get('sitePaymentMethodTypes'))) : [aWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType({}, pickedFields.get('sitePaymentMethodTypes'))];
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1MerchantFlow = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1MerchantFlow>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('countryRestricted')) {
        result.countryRestricted = overrides && overrides.hasOwnProperty('countryRestricted') ? overrides.countryRestricted! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('hidden')) {
        result.hidden = overrides && overrides.hasOwnProperty('hidden') ? overrides.hidden! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('icons')) {
        result.icons = overrides && overrides.hasOwnProperty('icons') ? overrides.icons!.map((x) => aWixPaymentsSitePaymentMethodTypesV1Icon(x ?? {}, pickedFields.get('icons'))) : [aWixPaymentsSitePaymentMethodTypesV1Icon({}, pickedFields.get('icons'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('priority')) {
        result.priority = overrides && overrides.hasOwnProperty('priority') ? overrides.priority! : 7075;
    }
    if (pickedFields.size === 0 || pickedFields.has('promoted')) {
        result.promoted = overrides && overrides.hasOwnProperty('promoted') ? overrides.promoted! : true;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowedCurrencies')) {
        result.allowedCurrencies = overrides && overrides.hasOwnProperty('allowedCurrencies') ? overrides.allowedCurrencies! : ['mollitia'];
    }
    if (pickedFields.size === 0 || pickedFields.has('allowedCurrencyCodes')) {
        result.allowedCurrencyCodes = overrides && overrides.hasOwnProperty('allowedCurrencyCodes') ? overrides.allowedCurrencyCodes! : ['impedit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('brandOnly')) {
        result.brandOnly = overrides && overrides.hasOwnProperty('brandOnly') ? overrides.brandOnly! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerFlow')) {
        result.buyerFlow = overrides && overrides.hasOwnProperty('buyerFlow') ? aWixPaymentsSitePaymentMethodTypesV1BuyerFlow(overrides.buyerFlow ?? {}, pickedFields.get('buyerFlow')) : aWixPaymentsSitePaymentMethodTypesV1BuyerFlow({}, pickedFields.get('buyerFlow'));
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyRestricted')) {
        result.currencyRestricted = overrides && overrides.hasOwnProperty('currencyRestricted') ? overrides.currencyRestricted! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('currencyRestrictionEnabled')) {
        result.currencyRestrictionEnabled = overrides && overrides.hasOwnProperty('currencyRestrictionEnabled') ? overrides.currencyRestrictionEnabled! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('displayName')) {
        result.displayName = overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('features')) {
        result.features = overrides && overrides.hasOwnProperty('features') ? aWixPaymentsSitePaymentMethodTypesV1Features(overrides.features ?? {}, pickedFields.get('features')) : aWixPaymentsSitePaymentMethodTypesV1Features({}, pickedFields.get('features'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('inPerson')) {
        result.inPerson = overrides && overrides.hasOwnProperty('inPerson') ? overrides.inPerson! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('legacyId')) {
        result.legacyId = overrides && overrides.hasOwnProperty('legacyId') ? overrides.legacyId! : 'itaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('merchantFlow')) {
        result.merchantFlow = overrides && overrides.hasOwnProperty('merchantFlow') ? aWixPaymentsSitePaymentMethodTypesV1MerchantFlow(overrides.merchantFlow ?? {}, pickedFields.get('merchantFlow')) : aWixPaymentsSitePaymentMethodTypesV1MerchantFlow({}, pickedFields.get('merchantFlow'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionExpirationDelayInSeconds')) {
        result.transactionExpirationDelayInSeconds = overrides && overrides.hasOwnProperty('transactionExpirationDelayInSeconds') ? overrides.transactionExpirationDelayInSeconds! : 8968;
    }
    if (pickedFields.size === 0 || pickedFields.has('velo')) {
        result.velo = overrides && overrides.hasOwnProperty('velo') ? overrides.velo! : true;
    }

    return result;
};

export const aWixPaymentsSitePaymentMethodTypesV1UpstreamWixCommonImage = <T extends Partial<WixPaymentsSitePaymentMethodTypesV1UpstreamWixCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 8703;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 1819;
    }

    return result;
};

export const aWixPopulationV2CreatedElementsEventInput = <T extends Partial<WixPopulationV2CreatedElementsEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('created')) {
        result.created = overrides && overrides.hasOwnProperty('created') ? overrides.created!.map((x) => aWixPopulationV2ElementInput({}, pickedFields.get('created'))) : [aWixPopulationV2ElementInput({}, pickedFields.get('created'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('populationId')) {
        result.populationId = overrides && overrides.hasOwnProperty('populationId') ? overrides.populationId! : 'praesentium';
    }

    return result;
};

export const aWixPopulationV2ElementInput = <T extends Partial<WixPopulationV2ElementInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('populationId')) {
        result.populationId = overrides && overrides.hasOwnProperty('populationId') ? overrides.populationId! : 'cumque';
    }

    return result;
};

export const aWixReceiptsV1AdditionalFee = <T extends Partial<WixReceiptsV1AdditionalFee>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceAfterTax')) {
        result.priceAfterTax = overrides && overrides.hasOwnProperty('priceAfterTax') ? overrides.priceAfterTax! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeTax')) {
        result.priceBeforeTax = overrides && overrides.hasOwnProperty('priceBeforeTax') ? overrides.priceBeforeTax! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aWixReceiptsV1AdditionalFeeTax(x ?? {}, pickedFields.get('taxBreakdown'))) : [aWixReceiptsV1AdditionalFeeTax({}, pickedFields.get('taxBreakdown'))];
    }

    return result;
};

export const aWixReceiptsV1AdditionalFeeInput = <T extends Partial<WixReceiptsV1AdditionalFeeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'at';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceAfterTax')) {
        result.priceAfterTax = overrides && overrides.hasOwnProperty('priceAfterTax') ? overrides.priceAfterTax! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeTax')) {
        result.priceBeforeTax = overrides && overrides.hasOwnProperty('priceBeforeTax') ? overrides.priceBeforeTax! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aWixReceiptsV1AdditionalFeeTaxInput({}, pickedFields.get('taxBreakdown'))) : [aWixReceiptsV1AdditionalFeeTaxInput({}, pickedFields.get('taxBreakdown'))];
    }

    return result;
};

export const aWixReceiptsV1AdditionalFeeTax = <T extends Partial<WixReceiptsV1AdditionalFeeTax>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'commodi';
    }

    return result;
};

export const aWixReceiptsV1AdditionalFeeTaxInput = <T extends Partial<WixReceiptsV1AdditionalFeeTaxInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'est';
    }

    return result;
};

export const aWixReceiptsV1BackofficeUpdateReceiptRequestInput = <T extends Partial<WixReceiptsV1BackofficeUpdateReceiptRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['tenetur'];
    }
    if (pickedFields.size === 0 || pickedFields.has('receipt')) {
        result.receipt = overrides && overrides.hasOwnProperty('receipt') ? aWixReceiptsV1ReceiptInput(overrides.receipt ?? {}, pickedFields.get('receipt')) : aWixReceiptsV1ReceiptInput({}, pickedFields.get('receipt'));
    }

    return result;
};

export const aWixReceiptsV1BackofficeUpdateReceiptResponse = <T extends Partial<WixReceiptsV1BackofficeUpdateReceiptResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('receipt')) {
        result.receipt = overrides && overrides.hasOwnProperty('receipt') ? aWixReceiptsV1Receipt(overrides.receipt ?? {}, pickedFields.get('receipt')) : aWixReceiptsV1Receipt({}, pickedFields.get('receipt'));
    }

    return result;
};

export const aWixReceiptsV1BusinessDetails = <T extends Partial<WixReceiptsV1BusinessDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aWixReceiptsV1UpstreamWixCommonAddress(overrides.address ?? {}, pickedFields.get('address')) : aWixReceiptsV1UpstreamWixCommonAddress({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('logo')) {
        result.logo = overrides && overrides.hasOwnProperty('logo') ? aWixReceiptsV1UpstreamWixCommonImage(overrides.logo ?? {}, pickedFields.get('logo')) : aWixReceiptsV1UpstreamWixCommonImage({}, pickedFields.get('logo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'ipsum';
    }

    return result;
};

export const aWixReceiptsV1BusinessDetailsInput = <T extends Partial<WixReceiptsV1BusinessDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aWixReceiptsV1UpstreamWixCommonAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aWixReceiptsV1UpstreamWixCommonAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('logo')) {
        result.logo = overrides && overrides.hasOwnProperty('logo') ? aWixReceiptsV1UpstreamWixCommonImageInput(overrides.logo ?? {}, pickedFields.get('logo')) : aWixReceiptsV1UpstreamWixCommonImageInput({}, pickedFields.get('logo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'voluptas';
    }

    return result;
};

export const aWixReceiptsV1CreateReceiptRequestInput = <T extends Partial<WixReceiptsV1CreateReceiptRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('receipt')) {
        result.receipt = overrides && overrides.hasOwnProperty('receipt') ? aWixReceiptsV1ReceiptInput(overrides.receipt ?? {}, pickedFields.get('receipt')) : aWixReceiptsV1ReceiptInput({}, pickedFields.get('receipt'));
    }

    return result;
};

export const aWixReceiptsV1CreateReceiptResponse = <T extends Partial<WixReceiptsV1CreateReceiptResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('receipt')) {
        result.receipt = overrides && overrides.hasOwnProperty('receipt') ? aWixReceiptsV1Receipt(overrides.receipt ?? {}, pickedFields.get('receipt')) : aWixReceiptsV1Receipt({}, pickedFields.get('receipt'));
    }

    return result;
};

export const aWixReceiptsV1CustomField = <T extends Partial<WixReceiptsV1CustomField>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'tenetur';
    }

    return result;
};

export const aWixReceiptsV1CustomFieldInput = <T extends Partial<WixReceiptsV1CustomFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'officia';
    }

    return result;
};

export const aWixReceiptsV1CustomFields = <T extends Partial<WixReceiptsV1CustomFields>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessCustomFields')) {
        result.businessCustomFields = overrides && overrides.hasOwnProperty('businessCustomFields') ? overrides.businessCustomFields!.map((x) => aWixReceiptsV1CustomField(x ?? {}, pickedFields.get('businessCustomFields'))) : [aWixReceiptsV1CustomField({}, pickedFields.get('businessCustomFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('customerCustomFields')) {
        result.customerCustomFields = overrides && overrides.hasOwnProperty('customerCustomFields') ? overrides.customerCustomFields!.map((x) => aWixReceiptsV1CustomField(x ?? {}, pickedFields.get('customerCustomFields'))) : [aWixReceiptsV1CustomField({}, pickedFields.get('customerCustomFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('footerCustomFields')) {
        result.footerCustomFields = overrides && overrides.hasOwnProperty('footerCustomFields') ? overrides.footerCustomFields!.map((x) => aWixReceiptsV1FooterCustomField(x ?? {}, pickedFields.get('footerCustomFields'))) : [aWixReceiptsV1FooterCustomField({}, pickedFields.get('footerCustomFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('headerCustomFields')) {
        result.headerCustomFields = overrides && overrides.hasOwnProperty('headerCustomFields') ? overrides.headerCustomFields!.map((x) => aWixReceiptsV1CustomField(x ?? {}, pickedFields.get('headerCustomFields'))) : [aWixReceiptsV1CustomField({}, pickedFields.get('headerCustomFields'))];
    }

    return result;
};

export const aWixReceiptsV1CustomFieldsInput = <T extends Partial<WixReceiptsV1CustomFieldsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessCustomFields')) {
        result.businessCustomFields = overrides && overrides.hasOwnProperty('businessCustomFields') ? overrides.businessCustomFields!.map((x) => aWixReceiptsV1CustomFieldInput({}, pickedFields.get('businessCustomFields'))) : [aWixReceiptsV1CustomFieldInput({}, pickedFields.get('businessCustomFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('customerCustomFields')) {
        result.customerCustomFields = overrides && overrides.hasOwnProperty('customerCustomFields') ? overrides.customerCustomFields!.map((x) => aWixReceiptsV1CustomFieldInput({}, pickedFields.get('customerCustomFields'))) : [aWixReceiptsV1CustomFieldInput({}, pickedFields.get('customerCustomFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('footerCustomFields')) {
        result.footerCustomFields = overrides && overrides.hasOwnProperty('footerCustomFields') ? overrides.footerCustomFields!.map((x) => aWixReceiptsV1FooterCustomFieldInput({}, pickedFields.get('footerCustomFields'))) : [aWixReceiptsV1FooterCustomFieldInput({}, pickedFields.get('footerCustomFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('headerCustomFields')) {
        result.headerCustomFields = overrides && overrides.hasOwnProperty('headerCustomFields') ? overrides.headerCustomFields!.map((x) => aWixReceiptsV1CustomFieldInput({}, pickedFields.get('headerCustomFields'))) : [aWixReceiptsV1CustomFieldInput({}, pickedFields.get('headerCustomFields'))];
    }

    return result;
};

export const aWixReceiptsV1Customer = <T extends Partial<WixReceiptsV1Customer>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('billingAddress')) {
        result.billingAddress = overrides && overrides.hasOwnProperty('billingAddress') ? aWixReceiptsV1UpstreamWixCommonAddress(overrides.billingAddress ?? {}, pickedFields.get('billingAddress')) : aWixReceiptsV1UpstreamWixCommonAddress({}, pickedFields.get('billingAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactDetails')) {
        result.contactDetails = overrides && overrides.hasOwnProperty('contactDetails') ? aWixReceiptsV1UpstreamWixCommonFullAddressContactDetails(overrides.contactDetails ?? {}, pickedFields.get('contactDetails')) : aWixReceiptsV1UpstreamWixCommonFullAddressContactDetails({}, pickedFields.get('contactDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingAddress')) {
        result.shippingAddress = overrides && overrides.hasOwnProperty('shippingAddress') ? aWixReceiptsV1UpstreamWixCommonAddress(overrides.shippingAddress ?? {}, pickedFields.get('shippingAddress')) : aWixReceiptsV1UpstreamWixCommonAddress({}, pickedFields.get('shippingAddress'));
    }

    return result;
};

export const aWixReceiptsV1CustomerInput = <T extends Partial<WixReceiptsV1CustomerInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('billingAddress')) {
        result.billingAddress = overrides && overrides.hasOwnProperty('billingAddress') ? aWixReceiptsV1UpstreamWixCommonAddressInput(overrides.billingAddress ?? {}, pickedFields.get('billingAddress')) : aWixReceiptsV1UpstreamWixCommonAddressInput({}, pickedFields.get('billingAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactDetails')) {
        result.contactDetails = overrides && overrides.hasOwnProperty('contactDetails') ? aWixReceiptsV1UpstreamWixCommonFullAddressContactDetailsInput(overrides.contactDetails ?? {}, pickedFields.get('contactDetails')) : aWixReceiptsV1UpstreamWixCommonFullAddressContactDetailsInput({}, pickedFields.get('contactDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingAddress')) {
        result.shippingAddress = overrides && overrides.hasOwnProperty('shippingAddress') ? aWixReceiptsV1UpstreamWixCommonAddressInput(overrides.shippingAddress ?? {}, pickedFields.get('shippingAddress')) : aWixReceiptsV1UpstreamWixCommonAddressInput({}, pickedFields.get('shippingAddress'));
    }

    return result;
};

export const aWixReceiptsV1Discount = <T extends Partial<WixReceiptsV1Discount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('displayName')) {
        result.displayName = overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ea';
    }

    return result;
};

export const aWixReceiptsV1DiscountInput = <T extends Partial<WixReceiptsV1DiscountInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('displayName')) {
        result.displayName = overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'dolorum';
    }

    return result;
};

export const aWixReceiptsV1Document = <T extends Partial<WixReceiptsV1Document>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('downloadUrl')) {
        result.downloadUrl = overrides && overrides.hasOwnProperty('downloadUrl') ? overrides.downloadUrl! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixReceiptsV1DocumentDocumentStatus.Available;
    }

    return result;
};

export const aWixReceiptsV1DocumentInput = <T extends Partial<WixReceiptsV1DocumentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('downloadUrl')) {
        result.downloadUrl = overrides && overrides.hasOwnProperty('downloadUrl') ? overrides.downloadUrl! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixReceiptsV1DocumentDocumentStatus.Available;
    }

    return result;
};

export const aWixReceiptsV1EventsGenerateReceiptDocumentInput = <T extends Partial<WixReceiptsV1EventsGenerateReceiptDocumentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('requestOrigin')) {
        result.requestOrigin = overrides && overrides.hasOwnProperty('requestOrigin') ? overrides.requestOrigin! : WixReceiptsV1EventsGenerateReceiptDocumentRequestOrigin.Initial;
    }

    return result;
};

export const aWixReceiptsV1EventsReceiptDocumentHandledFailedInput = <T extends Partial<WixReceiptsV1EventsReceiptDocumentHandledFailedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'non';
    }

    return result;
};

export const aWixReceiptsV1EventsReceiptDocumentHandledInput = <T extends Partial<WixReceiptsV1EventsReceiptDocumentHandledInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('failed')) {
        result.failed = overrides && overrides.hasOwnProperty('failed') ? aWixReceiptsV1EventsReceiptDocumentHandledFailedInput(overrides.failed ?? {}, pickedFields.get('failed')) : aWixReceiptsV1EventsReceiptDocumentHandledFailedInput({}, pickedFields.get('failed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('succeeded')) {
        result.succeeded = overrides && overrides.hasOwnProperty('succeeded') ? aWixReceiptsV1EventsReceiptDocumentHandledSucceededInput(overrides.succeeded ?? {}, pickedFields.get('succeeded')) : aWixReceiptsV1EventsReceiptDocumentHandledSucceededInput({}, pickedFields.get('succeeded'));
    }

    return result;
};

export const aWixReceiptsV1EventsReceiptDocumentHandledSucceededInput = <T extends Partial<WixReceiptsV1EventsReceiptDocumentHandledSucceededInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('downloadUrl')) {
        result.downloadUrl = overrides && overrides.hasOwnProperty('downloadUrl') ? overrides.downloadUrl! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('mediaFileId')) {
        result.mediaFileId = overrides && overrides.hasOwnProperty('mediaFileId') ? overrides.mediaFileId! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'magnam';
    }

    return result;
};

export const aWixReceiptsV1EventsReceiptNumberingProcessInput = <T extends Partial<WixReceiptsV1EventsReceiptNumberingProcessInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'ea';
    }

    return result;
};

export const aWixReceiptsV1FooterCustomField = <T extends Partial<WixReceiptsV1FooterCustomField>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'porro';
    }

    return result;
};

export const aWixReceiptsV1FooterCustomFieldInput = <T extends Partial<WixReceiptsV1FooterCustomFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'et';
    }

    return result;
};

export const aWixReceiptsV1GetLatestReceiptNumberRequestInput = <T extends Partial<WixReceiptsV1GetLatestReceiptNumberRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('prefix')) {
        result.prefix = overrides && overrides.hasOwnProperty('prefix') ? overrides.prefix! : 'ex';
    }

    return result;
};

export const aWixReceiptsV1GetLatestReceiptNumberResponse = <T extends Partial<WixReceiptsV1GetLatestReceiptNumberResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 4705;
    }

    return result;
};

export const aWixReceiptsV1GetReceiptRequestInput = <T extends Partial<WixReceiptsV1GetReceiptRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f1f3616a-849f-4f5d-9fdb-513175f800b7';
    }

    return result;
};

export const aWixReceiptsV1LineItem = <T extends Partial<WixReceiptsV1LineItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'debitis';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscounts')) {
        result.priceBeforeDiscounts = overrides && overrides.hasOwnProperty('priceBeforeDiscounts') ? overrides.priceBeforeDiscounts! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aWixReceiptsV1LineItemTax(x ?? {}, pickedFields.get('taxBreakdown'))) : [aWixReceiptsV1LineItemTax({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('totals')) {
        result.totals = overrides && overrides.hasOwnProperty('totals') ? aWixReceiptsV1LineItemTotals(overrides.totals ?? {}, pickedFields.get('totals')) : aWixReceiptsV1LineItemTotals({}, pickedFields.get('totals'));
    }

    return result;
};

export const aWixReceiptsV1LineItemInput = <T extends Partial<WixReceiptsV1LineItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 'quae';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeDiscounts')) {
        result.priceBeforeDiscounts = overrides && overrides.hasOwnProperty('priceBeforeDiscounts') ? overrides.priceBeforeDiscounts! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aWixReceiptsV1LineItemTaxInput({}, pickedFields.get('taxBreakdown'))) : [aWixReceiptsV1LineItemTaxInput({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('totals')) {
        result.totals = overrides && overrides.hasOwnProperty('totals') ? aWixReceiptsV1LineItemTotalsInput(overrides.totals ?? {}, pickedFields.get('totals')) : aWixReceiptsV1LineItemTotalsInput({}, pickedFields.get('totals'));
    }

    return result;
};

export const aWixReceiptsV1LineItemTax = <T extends Partial<WixReceiptsV1LineItemTax>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('taxAmount')) {
        result.taxAmount = overrides && overrides.hasOwnProperty('taxAmount') ? overrides.taxAmount! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxName')) {
        result.taxName = overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxRate')) {
        result.taxRate = overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? overrides.taxableAmount! : 'quo';
    }

    return result;
};

export const aWixReceiptsV1LineItemTaxInput = <T extends Partial<WixReceiptsV1LineItemTaxInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('taxAmount')) {
        result.taxAmount = overrides && overrides.hasOwnProperty('taxAmount') ? overrides.taxAmount! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxName')) {
        result.taxName = overrides && overrides.hasOwnProperty('taxName') ? overrides.taxName! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxRate')) {
        result.taxRate = overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 'repudiandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? overrides.taxableAmount! : 'repellat';
    }

    return result;
};

export const aWixReceiptsV1LineItemTotals = <T extends Partial<WixReceiptsV1LineItemTotals>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalDiscount')) {
        result.totalDiscount = overrides && overrides.hasOwnProperty('totalDiscount') ? overrides.totalDiscount! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceAfterTax')) {
        result.totalPriceAfterTax = overrides && overrides.hasOwnProperty('totalPriceAfterTax') ? overrides.totalPriceAfterTax! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceBeforeTax')) {
        result.totalPriceBeforeTax = overrides && overrides.hasOwnProperty('totalPriceBeforeTax') ? overrides.totalPriceBeforeTax! : 'deleniti';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? overrides.totalTax! : 'consequatur';
    }

    return result;
};

export const aWixReceiptsV1LineItemTotalsInput = <T extends Partial<WixReceiptsV1LineItemTotalsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('totalDiscount')) {
        result.totalDiscount = overrides && overrides.hasOwnProperty('totalDiscount') ? overrides.totalDiscount! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceAfterTax')) {
        result.totalPriceAfterTax = overrides && overrides.hasOwnProperty('totalPriceAfterTax') ? overrides.totalPriceAfterTax! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPriceBeforeTax')) {
        result.totalPriceBeforeTax = overrides && overrides.hasOwnProperty('totalPriceBeforeTax') ? overrides.totalPriceBeforeTax! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalTax')) {
        result.totalTax = overrides && overrides.hasOwnProperty('totalTax') ? overrides.totalTax! : 'quae';
    }

    return result;
};

export const aWixReceiptsV1Locale = <T extends Partial<WixReceiptsV1Locale>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('languageCode')) {
        result.languageCode = overrides && overrides.hasOwnProperty('languageCode') ? overrides.languageCode! : 'minus';
    }

    return result;
};

export const aWixReceiptsV1LocaleInput = <T extends Partial<WixReceiptsV1LocaleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('languageCode')) {
        result.languageCode = overrides && overrides.hasOwnProperty('languageCode') ? overrides.languageCode! : 'quas';
    }

    return result;
};

export const aWixReceiptsV1Payment = <T extends Partial<WixReceiptsV1Payment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? overrides.paymentMethod! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethodDetails')) {
        result.paymentMethodDetails = overrides && overrides.hasOwnProperty('paymentMethodDetails') ? overrides.paymentMethodDetails! : 'repellendus';
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionDate')) {
        result.transactionDate = overrides && overrides.hasOwnProperty('transactionDate') ? overrides.transactionDate! : 'magni';
    }

    return result;
};

export const aWixReceiptsV1PaymentInput = <T extends Partial<WixReceiptsV1PaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? overrides.paymentMethod! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethodDetails')) {
        result.paymentMethodDetails = overrides && overrides.hasOwnProperty('paymentMethodDetails') ? overrides.paymentMethodDetails! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionDate')) {
        result.transactionDate = overrides && overrides.hasOwnProperty('transactionDate') ? overrides.transactionDate! : 'doloremque';
    }

    return result;
};

export const aWixReceiptsV1QueryReceiptsRequestInput = <T extends Partial<WixReceiptsV1QueryReceiptsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixReceiptsV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixReceiptsV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixReceiptsV1QueryReceiptsResponse = <T extends Partial<WixReceiptsV1QueryReceiptsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixReceiptsV1Receipt(x ?? {}, pickedFields.get('items'))) : [aWixReceiptsV1Receipt({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixReceiptsV1Receipt = <T extends Partial<WixReceiptsV1Receipt>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aWixReceiptsV1AdditionalFee(x ?? {}, pickedFields.get('additionalFees'))) : [aWixReceiptsV1AdditionalFee({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('businessDetails')) {
        result.businessDetails = overrides && overrides.hasOwnProperty('businessDetails') ? aWixReceiptsV1BusinessDetails(overrides.businessDetails ?? {}, pickedFields.get('businessDetails')) : aWixReceiptsV1BusinessDetails({}, pickedFields.get('businessDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? aWixReceiptsV1CustomFields(overrides.customFields ?? {}, pickedFields.get('customFields')) : aWixReceiptsV1CustomFields({}, pickedFields.get('customFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customer')) {
        result.customer = overrides && overrides.hasOwnProperty('customer') ? aWixReceiptsV1Customer(overrides.customer ?? {}, pickedFields.get('customer')) : aWixReceiptsV1Customer({}, pickedFields.get('customer'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discounts')) {
        result.discounts = overrides && overrides.hasOwnProperty('discounts') ? overrides.discounts!.map((x) => aWixReceiptsV1Discount(x ?? {}, pickedFields.get('discounts'))) : [aWixReceiptsV1Discount({}, pickedFields.get('discounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('document')) {
        result.document = overrides && overrides.hasOwnProperty('document') ? aWixReceiptsV1Document(overrides.document ?? {}, pickedFields.get('document')) : aWixReceiptsV1Document({}, pickedFields.get('document'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aWixReceiptsV1LineItem(x ?? {}, pickedFields.get('lineItems'))) : [aWixReceiptsV1LineItem({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('numbering')) {
        result.numbering = overrides && overrides.hasOwnProperty('numbering') ? aWixReceiptsV1ReceiptNumbering(overrides.numbering ?? {}, pickedFields.get('numbering')) : aWixReceiptsV1ReceiptNumbering({}, pickedFields.get('numbering'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aWixReceiptsV1Payment(overrides.payment ?? {}, pickedFields.get('payment')) : aWixReceiptsV1Payment({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('presetId')) {
        result.presetId = overrides && overrides.hasOwnProperty('presetId') ? overrides.presetId! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('regionalProperties')) {
        result.regionalProperties = overrides && overrides.hasOwnProperty('regionalProperties') ? aWixReceiptsV1RegionalProperties(overrides.regionalProperties ?? {}, pickedFields.get('regionalProperties')) : aWixReceiptsV1RegionalProperties({}, pickedFields.get('regionalProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingInfo')) {
        result.shippingInfo = overrides && overrides.hasOwnProperty('shippingInfo') ? aWixReceiptsV1ShippingInfo(overrides.shippingInfo ?? {}, pickedFields.get('shippingInfo')) : aWixReceiptsV1ShippingInfo({}, pickedFields.get('shippingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceReference')) {
        result.sourceReference = overrides && overrides.hasOwnProperty('sourceReference') ? aWixReceiptsV1SourceReference(overrides.sourceReference ?? {}, pickedFields.get('sourceReference')) : aWixReceiptsV1SourceReference({}, pickedFields.get('sourceReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aWixReceiptsV1Tax(x ?? {}, pickedFields.get('taxBreakdown'))) : [aWixReceiptsV1Tax({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('totals')) {
        result.totals = overrides && overrides.hasOwnProperty('totals') ? aWixReceiptsV1Totals(overrides.totals ?? {}, pickedFields.get('totals')) : aWixReceiptsV1Totals({}, pickedFields.get('totals'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'ut';
    }

    return result;
};

export const aWixReceiptsV1ReceiptInput = <T extends Partial<WixReceiptsV1ReceiptInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees!.map((x) => aWixReceiptsV1AdditionalFeeInput({}, pickedFields.get('additionalFees'))) : [aWixReceiptsV1AdditionalFeeInput({}, pickedFields.get('additionalFees'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('businessDetails')) {
        result.businessDetails = overrides && overrides.hasOwnProperty('businessDetails') ? aWixReceiptsV1BusinessDetailsInput(overrides.businessDetails ?? {}, pickedFields.get('businessDetails')) : aWixReceiptsV1BusinessDetailsInput({}, pickedFields.get('businessDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('customFields')) {
        result.customFields = overrides && overrides.hasOwnProperty('customFields') ? aWixReceiptsV1CustomFieldsInput(overrides.customFields ?? {}, pickedFields.get('customFields')) : aWixReceiptsV1CustomFieldsInput({}, pickedFields.get('customFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customer')) {
        result.customer = overrides && overrides.hasOwnProperty('customer') ? aWixReceiptsV1CustomerInput(overrides.customer ?? {}, pickedFields.get('customer')) : aWixReceiptsV1CustomerInput({}, pickedFields.get('customer'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discounts')) {
        result.discounts = overrides && overrides.hasOwnProperty('discounts') ? overrides.discounts!.map((x) => aWixReceiptsV1DiscountInput({}, pickedFields.get('discounts'))) : [aWixReceiptsV1DiscountInput({}, pickedFields.get('discounts'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('document')) {
        result.document = overrides && overrides.hasOwnProperty('document') ? aWixReceiptsV1DocumentInput(overrides.document ?? {}, pickedFields.get('document')) : aWixReceiptsV1DocumentInput({}, pickedFields.get('document'));
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aWixReceiptsV1LineItemInput({}, pickedFields.get('lineItems'))) : [aWixReceiptsV1LineItemInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('numbering')) {
        result.numbering = overrides && overrides.hasOwnProperty('numbering') ? aWixReceiptsV1ReceiptNumberingInput(overrides.numbering ?? {}, pickedFields.get('numbering')) : aWixReceiptsV1ReceiptNumberingInput({}, pickedFields.get('numbering'));
    }
    if (pickedFields.size === 0 || pickedFields.has('payment')) {
        result.payment = overrides && overrides.hasOwnProperty('payment') ? aWixReceiptsV1PaymentInput(overrides.payment ?? {}, pickedFields.get('payment')) : aWixReceiptsV1PaymentInput({}, pickedFields.get('payment'));
    }
    if (pickedFields.size === 0 || pickedFields.has('presetId')) {
        result.presetId = overrides && overrides.hasOwnProperty('presetId') ? overrides.presetId! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('regionalProperties')) {
        result.regionalProperties = overrides && overrides.hasOwnProperty('regionalProperties') ? aWixReceiptsV1RegionalPropertiesInput(overrides.regionalProperties ?? {}, pickedFields.get('regionalProperties')) : aWixReceiptsV1RegionalPropertiesInput({}, pickedFields.get('regionalProperties'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingInfo')) {
        result.shippingInfo = overrides && overrides.hasOwnProperty('shippingInfo') ? aWixReceiptsV1ShippingInfoInput(overrides.shippingInfo ?? {}, pickedFields.get('shippingInfo')) : aWixReceiptsV1ShippingInfoInput({}, pickedFields.get('shippingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceReference')) {
        result.sourceReference = overrides && overrides.hasOwnProperty('sourceReference') ? aWixReceiptsV1SourceReferenceInput(overrides.sourceReference ?? {}, pickedFields.get('sourceReference')) : aWixReceiptsV1SourceReferenceInput({}, pickedFields.get('sourceReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aWixReceiptsV1TaxInput({}, pickedFields.get('taxBreakdown'))) : [aWixReceiptsV1TaxInput({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('totals')) {
        result.totals = overrides && overrides.hasOwnProperty('totals') ? aWixReceiptsV1TotalsInput(overrides.totals ?? {}, pickedFields.get('totals')) : aWixReceiptsV1TotalsInput({}, pickedFields.get('totals'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'reiciendis';
    }

    return result;
};

export const aWixReceiptsV1ReceiptNumbering = <T extends Partial<WixReceiptsV1ReceiptNumbering>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayNumber')) {
        result.displayNumber = overrides && overrides.hasOwnProperty('displayNumber') ? overrides.displayNumber! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 4347;
    }
    if (pickedFields.size === 0 || pickedFields.has('prefix')) {
        result.prefix = overrides && overrides.hasOwnProperty('prefix') ? overrides.prefix! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('suffix')) {
        result.suffix = overrides && overrides.hasOwnProperty('suffix') ? overrides.suffix! : 'fugit';
    }

    return result;
};

export const aWixReceiptsV1ReceiptNumberingInput = <T extends Partial<WixReceiptsV1ReceiptNumberingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('displayNumber')) {
        result.displayNumber = overrides && overrides.hasOwnProperty('displayNumber') ? overrides.displayNumber! : 'commodi';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 9028;
    }
    if (pickedFields.size === 0 || pickedFields.has('prefix')) {
        result.prefix = overrides && overrides.hasOwnProperty('prefix') ? overrides.prefix! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('suffix')) {
        result.suffix = overrides && overrides.hasOwnProperty('suffix') ? overrides.suffix! : 'architecto';
    }

    return result;
};

export const aWixReceiptsV1RegenerateReceiptDocumentRequestInput = <T extends Partial<WixReceiptsV1RegenerateReceiptDocumentRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'qui';
    }

    return result;
};

export const aWixReceiptsV1RegionalProperties = <T extends Partial<WixReceiptsV1RegionalProperties>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('locale')) {
        result.locale = overrides && overrides.hasOwnProperty('locale') ? aWixReceiptsV1Locale(overrides.locale ?? {}, pickedFields.get('locale')) : aWixReceiptsV1Locale({}, pickedFields.get('locale'));
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'fugit';
    }

    return result;
};

export const aWixReceiptsV1RegionalPropertiesInput = <T extends Partial<WixReceiptsV1RegionalPropertiesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('locale')) {
        result.locale = overrides && overrides.hasOwnProperty('locale') ? aWixReceiptsV1LocaleInput(overrides.locale ?? {}, pickedFields.get('locale')) : aWixReceiptsV1LocaleInput({}, pickedFields.get('locale'));
    }
    if (pickedFields.size === 0 || pickedFields.has('timeZone')) {
        result.timeZone = overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'accusamus';
    }

    return result;
};

export const aWixReceiptsV1SendReceiptEmailRequestInput = <T extends Partial<WixReceiptsV1SendReceiptEmailRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contactId')) {
        result.contactId = overrides && overrides.hasOwnProperty('contactId') ? overrides.contactId! : 'aliquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptId')) {
        result.receiptId = overrides && overrides.hasOwnProperty('receiptId') ? overrides.receiptId! : 'ex';
    }

    return result;
};

export const aWixReceiptsV1ShippingInfo = <T extends Partial<WixReceiptsV1ShippingInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('priceAfterTax')) {
        result.priceAfterTax = overrides && overrides.hasOwnProperty('priceAfterTax') ? overrides.priceAfterTax! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeTax')) {
        result.priceBeforeTax = overrides && overrides.hasOwnProperty('priceBeforeTax') ? overrides.priceBeforeTax! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aWixReceiptsV1ShippingTax(x ?? {}, pickedFields.get('taxBreakdown'))) : [aWixReceiptsV1ShippingTax({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'ea';
    }

    return result;
};

export const aWixReceiptsV1ShippingInfoInput = <T extends Partial<WixReceiptsV1ShippingInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('priceAfterTax')) {
        result.priceAfterTax = overrides && overrides.hasOwnProperty('priceAfterTax') ? overrides.priceAfterTax! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('priceBeforeTax')) {
        result.priceBeforeTax = overrides && overrides.hasOwnProperty('priceBeforeTax') ? overrides.priceBeforeTax! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxBreakdown')) {
        result.taxBreakdown = overrides && overrides.hasOwnProperty('taxBreakdown') ? overrides.taxBreakdown!.map((x) => aWixReceiptsV1ShippingTaxInput({}, pickedFields.get('taxBreakdown'))) : [aWixReceiptsV1ShippingTaxInput({}, pickedFields.get('taxBreakdown'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'sed';
    }

    return result;
};

export const aWixReceiptsV1ShippingTax = <T extends Partial<WixReceiptsV1ShippingTax>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'dignissimos';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'ab';
    }

    return result;
};

export const aWixReceiptsV1ShippingTaxInput = <T extends Partial<WixReceiptsV1ShippingTaxInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'asperiores';
    }

    return result;
};

export const aWixReceiptsV1SourceReference = <T extends Partial<WixReceiptsV1SourceReference>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceId')) {
        result.externalReferenceId = overrides && overrides.hasOwnProperty('externalReferenceId') ? overrides.externalReferenceId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptOrderType')) {
        result.receiptOrderType = overrides && overrides.hasOwnProperty('receiptOrderType') ? overrides.receiptOrderType! : WixReceiptsV1SourceReferenceReceiptOrderType.UnknownOrderType;
    }
    if (pickedFields.size === 0 || pickedFields.has('wixEcomOrder')) {
        result.wixEcomOrder = overrides && overrides.hasOwnProperty('wixEcomOrder') ? aWixReceiptsV1SourceReferenceWixEcom(overrides.wixEcomOrder ?? {}, pickedFields.get('wixEcomOrder')) : aWixReceiptsV1SourceReferenceWixEcom({}, pickedFields.get('wixEcomOrder'));
    }
    if (pickedFields.size === 0 || pickedFields.has('wixPaymentOrder')) {
        result.wixPaymentOrder = overrides && overrides.hasOwnProperty('wixPaymentOrder') ? aWixReceiptsV1SourceReferenceWixPayment(overrides.wixPaymentOrder ?? {}, pickedFields.get('wixPaymentOrder')) : aWixReceiptsV1SourceReferenceWixPayment({}, pickedFields.get('wixPaymentOrder'));
    }

    return result;
};

export const aWixReceiptsV1SourceReferenceInput = <T extends Partial<WixReceiptsV1SourceReferenceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceId')) {
        result.externalReferenceId = overrides && overrides.hasOwnProperty('externalReferenceId') ? overrides.externalReferenceId! : 'totam';
    }
    if (pickedFields.size === 0 || pickedFields.has('receiptOrderType')) {
        result.receiptOrderType = overrides && overrides.hasOwnProperty('receiptOrderType') ? overrides.receiptOrderType! : WixReceiptsV1SourceReferenceReceiptOrderType.UnknownOrderType;
    }
    if (pickedFields.size === 0 || pickedFields.has('wixEcomOrder')) {
        result.wixEcomOrder = overrides && overrides.hasOwnProperty('wixEcomOrder') ? aWixReceiptsV1SourceReferenceWixEcomInput(overrides.wixEcomOrder ?? {}, pickedFields.get('wixEcomOrder')) : aWixReceiptsV1SourceReferenceWixEcomInput({}, pickedFields.get('wixEcomOrder'));
    }
    if (pickedFields.size === 0 || pickedFields.has('wixPaymentOrder')) {
        result.wixPaymentOrder = overrides && overrides.hasOwnProperty('wixPaymentOrder') ? aWixReceiptsV1SourceReferenceWixPaymentInput(overrides.wixPaymentOrder ?? {}, pickedFields.get('wixPaymentOrder')) : aWixReceiptsV1SourceReferenceWixPaymentInput({}, pickedFields.get('wixPaymentOrder'));
    }

    return result;
};

export const aWixReceiptsV1SourceReferenceWixEcom = <T extends Partial<WixReceiptsV1SourceReferenceWixEcom>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'velit';
    }

    return result;
};

export const aWixReceiptsV1SourceReferenceWixEcomInput = <T extends Partial<WixReceiptsV1SourceReferenceWixEcomInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'similique';
    }

    return result;
};

export const aWixReceiptsV1SourceReferenceWixPayment = <T extends Partial<WixReceiptsV1SourceReferenceWixPayment>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'quam';
    }

    return result;
};

export const aWixReceiptsV1SourceReferenceWixPaymentInput = <T extends Partial<WixReceiptsV1SourceReferenceWixPaymentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'tempore';
    }

    return result;
};

export const aWixReceiptsV1Tax = <T extends Partial<WixReceiptsV1Tax>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxAmount')) {
        result.taxAmount = overrides && overrides.hasOwnProperty('taxAmount') ? overrides.taxAmount! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? overrides.taxableAmount! : 'distinctio';
    }

    return result;
};

export const aWixReceiptsV1TaxInput = <T extends Partial<WixReceiptsV1TaxInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'harum';
    }
    if (pickedFields.size === 0 || pickedFields.has('rate')) {
        result.rate = overrides && overrides.hasOwnProperty('rate') ? overrides.rate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxAmount')) {
        result.taxAmount = overrides && overrides.hasOwnProperty('taxAmount') ? overrides.taxAmount! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxableAmount')) {
        result.taxableAmount = overrides && overrides.hasOwnProperty('taxableAmount') ? overrides.taxableAmount! : 'facilis';
    }

    return result;
};

export const aWixReceiptsV1Totals = <T extends Partial<WixReceiptsV1Totals>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? overrides.discount! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? overrides.shipping! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? overrides.subtotal! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 'eos';
    }

    return result;
};

export const aWixReceiptsV1TotalsInput = <T extends Partial<WixReceiptsV1TotalsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalFees')) {
        result.additionalFees = overrides && overrides.hasOwnProperty('additionalFees') ? overrides.additionalFees! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? overrides.discount! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? overrides.shipping! : 'explicabo';
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? overrides.subtotal! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 'non';
    }

    return result;
};

export const aWixReceiptsV1UpdateExtendedFieldsResponse = <T extends Partial<WixReceiptsV1UpdateExtendedFieldsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('receipt')) {
        result.receipt = overrides && overrides.hasOwnProperty('receipt') ? aWixReceiptsV1Receipt(overrides.receipt ?? {}, pickedFields.get('receipt')) : aWixReceiptsV1Receipt({}, pickedFields.get('receipt'));
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonAddress = <T extends Partial<WixReceiptsV1UpstreamWixCommonAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'corporis';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixReceiptsV1UpstreamWixCommonAddressLocation(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixReceiptsV1UpstreamWixCommonAddressLocation({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixReceiptsV1UpstreamWixCommonStreetAddress(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixReceiptsV1UpstreamWixCommonStreetAddress({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionFullname')) {
        result.subdivisionFullname = overrides && overrides.hasOwnProperty('subdivisionFullname') ? overrides.subdivisionFullname! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionIso31662')) {
        result.subdivisionIso31662 = overrides && overrides.hasOwnProperty('subdivisionIso31662') ? overrides.subdivisionIso31662! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aWixReceiptsV1UpstreamWixCommonSubdivision(x ?? {}, pickedFields.get('subdivisions'))) : [aWixReceiptsV1UpstreamWixCommonSubdivision({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonAddressInput = <T extends Partial<WixReceiptsV1UpstreamWixCommonAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('addressLine2')) {
        result.addressLine2 = overrides && overrides.hasOwnProperty('addressLine2') ? overrides.addressLine2! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('countryFullname')) {
        result.countryFullname = overrides && overrides.hasOwnProperty('countryFullname') ? overrides.countryFullname! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddress')) {
        result.formattedAddress = overrides && overrides.hasOwnProperty('formattedAddress') ? overrides.formattedAddress! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('geocode')) {
        result.geocode = overrides && overrides.hasOwnProperty('geocode') ? aWixReceiptsV1UpstreamWixCommonAddressLocationInput(overrides.geocode ?? {}, pickedFields.get('geocode')) : aWixReceiptsV1UpstreamWixCommonAddressLocationInput({}, pickedFields.get('geocode'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hint')) {
        result.hint = overrides && overrides.hasOwnProperty('hint') ? overrides.hint! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('postalCode')) {
        result.postalCode = overrides && overrides.hasOwnProperty('postalCode') ? overrides.postalCode! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('streetAddress')) {
        result.streetAddress = overrides && overrides.hasOwnProperty('streetAddress') ? aWixReceiptsV1UpstreamWixCommonStreetAddressInput(overrides.streetAddress ?? {}, pickedFields.get('streetAddress')) : aWixReceiptsV1UpstreamWixCommonStreetAddressInput({}, pickedFields.get('streetAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionFullname')) {
        result.subdivisionFullname = overrides && overrides.hasOwnProperty('subdivisionFullname') ? overrides.subdivisionFullname! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisionIso31662')) {
        result.subdivisionIso31662 = overrides && overrides.hasOwnProperty('subdivisionIso31662') ? overrides.subdivisionIso31662! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivisions')) {
        result.subdivisions = overrides && overrides.hasOwnProperty('subdivisions') ? overrides.subdivisions!.map((x) => aWixReceiptsV1UpstreamWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))) : [aWixReceiptsV1UpstreamWixCommonSubdivisionInput({}, pickedFields.get('subdivisions'))];
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonAddressLocation = <T extends Partial<WixReceiptsV1UpstreamWixCommonAddressLocation>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 6.97;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 4.64;
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonAddressLocationInput = <T extends Partial<WixReceiptsV1UpstreamWixCommonAddressLocationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('latitude')) {
        result.latitude = overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 2.36;
    }
    if (pickedFields.size === 0 || pickedFields.has('longitude')) {
        result.longitude = overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 8.85;
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixReceiptsV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2348;
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonCursorQueryInput = <T extends Partial<WixReceiptsV1UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixReceiptsV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixReceiptsV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixReceiptsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixReceiptsV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonFullAddressContactDetails = <T extends Partial<WixReceiptsV1UpstreamWixCommonFullAddressContactDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('fullName')) {
        result.fullName = overrides && overrides.hasOwnProperty('fullName') ? overrides.fullName! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('vatId')) {
        result.vatId = overrides && overrides.hasOwnProperty('vatId') ? aWixReceiptsV1UpstreamWixCommonVatId(overrides.vatId ?? {}, pickedFields.get('vatId')) : aWixReceiptsV1UpstreamWixCommonVatId({}, pickedFields.get('vatId'));
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonFullAddressContactDetailsInput = <T extends Partial<WixReceiptsV1UpstreamWixCommonFullAddressContactDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('company')) {
        result.company = overrides && overrides.hasOwnProperty('company') ? overrides.company! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('fullName')) {
        result.fullName = overrides && overrides.hasOwnProperty('fullName') ? overrides.fullName! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('vatId')) {
        result.vatId = overrides && overrides.hasOwnProperty('vatId') ? aWixReceiptsV1UpstreamWixCommonVatIdInput(overrides.vatId ?? {}, pickedFields.get('vatId')) : aWixReceiptsV1UpstreamWixCommonVatIdInput({}, pickedFields.get('vatId'));
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonImage = <T extends Partial<WixReceiptsV1UpstreamWixCommonImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'eaque';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 304;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 5312;
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonImageInput = <T extends Partial<WixReceiptsV1UpstreamWixCommonImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('filename')) {
        result.filename = overrides && overrides.hasOwnProperty('filename') ? overrides.filename! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 5770;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInBytes')) {
        result.sizeInBytes = overrides && overrides.hasOwnProperty('sizeInBytes') ? overrides.sizeInBytes! : 'expedita';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('urlExpirationDate')) {
        result.urlExpirationDate = overrides && overrides.hasOwnProperty('urlExpirationDate') ? overrides.urlExpirationDate! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 7770;
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonSortingInput = <T extends Partial<WixReceiptsV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixReceiptsV1UpstreamWixCommonSortOrder.Asc;
    }
    if (pickedFields.size === 0 || pickedFields.has('selectItemsBy')) {
        result.selectItemsBy = overrides && overrides.hasOwnProperty('selectItemsBy') ? overrides.selectItemsBy! : ['animi'];
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonStreetAddress = <T extends Partial<WixReceiptsV1UpstreamWixCommonStreetAddress>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddressLine')) {
        result.formattedAddressLine = overrides && overrides.hasOwnProperty('formattedAddressLine') ? overrides.formattedAddressLine! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'aut';
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonStreetAddressInput = <T extends Partial<WixReceiptsV1UpstreamWixCommonStreetAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('apt')) {
        result.apt = overrides && overrides.hasOwnProperty('apt') ? overrides.apt! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAddressLine')) {
        result.formattedAddressLine = overrides && overrides.hasOwnProperty('formattedAddressLine') ? overrides.formattedAddressLine! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'laborum';
    }
    if (pickedFields.size === 0 || pickedFields.has('number')) {
        result.number = overrides && overrides.hasOwnProperty('number') ? overrides.number! : 'occaecati';
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonSubdivision = <T extends Partial<WixReceiptsV1UpstreamWixCommonSubdivision>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('standardDetails')) {
        result.standardDetails = overrides && overrides.hasOwnProperty('standardDetails') ? aWixReceiptsV1UpstreamWixCommonSubdivisionStandardDetails(overrides.standardDetails ?? {}, pickedFields.get('standardDetails')) : aWixReceiptsV1UpstreamWixCommonSubdivisionStandardDetails({}, pickedFields.get('standardDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixReceiptsV1UpstreamWixCommonSubdivisionSubdivisionType.AdministrativeAreaLevel_1;
    }
    if (pickedFields.size === 0 || pickedFields.has('typeInfo')) {
        result.typeInfo = overrides && overrides.hasOwnProperty('typeInfo') ? overrides.typeInfo! : 'molestiae';
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonSubdivisionInput = <T extends Partial<WixReceiptsV1UpstreamWixCommonSubdivisionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'nisi';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('standardDetails')) {
        result.standardDetails = overrides && overrides.hasOwnProperty('standardDetails') ? aWixReceiptsV1UpstreamWixCommonSubdivisionStandardDetailsInput(overrides.standardDetails ?? {}, pickedFields.get('standardDetails')) : aWixReceiptsV1UpstreamWixCommonSubdivisionStandardDetailsInput({}, pickedFields.get('standardDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixReceiptsV1UpstreamWixCommonSubdivisionSubdivisionType.AdministrativeAreaLevel_1;
    }
    if (pickedFields.size === 0 || pickedFields.has('typeInfo')) {
        result.typeInfo = overrides && overrides.hasOwnProperty('typeInfo') ? overrides.typeInfo! : 'et';
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonSubdivisionStandardDetails = <T extends Partial<WixReceiptsV1UpstreamWixCommonSubdivisionStandardDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('iso31662')) {
        result.iso31662 = overrides && overrides.hasOwnProperty('iso31662') ? overrides.iso31662! : 'magnam';
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonSubdivisionStandardDetailsInput = <T extends Partial<WixReceiptsV1UpstreamWixCommonSubdivisionStandardDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('iso31662')) {
        result.iso31662 = overrides && overrides.hasOwnProperty('iso31662') ? overrides.iso31662! : 'ea';
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonVatId = <T extends Partial<WixReceiptsV1UpstreamWixCommonVatId>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixReceiptsV1UpstreamWixCommonVatType.Cnpj;
    }

    return result;
};

export const aWixReceiptsV1UpstreamWixCommonVatIdInput = <T extends Partial<WixReceiptsV1UpstreamWixCommonVatIdInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixReceiptsV1UpstreamWixCommonVatType.Cnpj;
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkCreateModifierResult = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkCreateModifierResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modifier')) {
        result.modifier = overrides && overrides.hasOwnProperty('modifier') ? aWixRestaurantsMenusItemModifierV1Modifier(overrides.modifier ?? {}, pickedFields.get('modifier')) : aWixRestaurantsMenusItemModifierV1Modifier({}, pickedFields.get('modifier'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkCreateModifiersRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkCreateModifiersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifiers')) {
        result.modifiers = overrides && overrides.hasOwnProperty('modifiers') ? overrides.modifiers!.map((x) => aWixRestaurantsMenusItemModifierV1ModifierInput({}, pickedFields.get('modifiers'))) : [aWixRestaurantsMenusItemModifierV1ModifierInput({}, pickedFields.get('modifiers'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkCreateModifiersResponse = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkCreateModifiersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemModifierV1BulkCreateModifierResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemModifierV1BulkCreateModifierResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkDeleteModifiersRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkDeleteModifiersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['modi'];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkDeleteModifiersResponse = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemModifierV1BulkDeleteModifiersResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemModifierV1BulkDeleteModifiersResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkDeleteModifiersResult = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierIdAttachedToOrphanItem')) {
        result.modifierIdAttachedToOrphanItem = overrides && overrides.hasOwnProperty('modifierIdAttachedToOrphanItem') ? overrides.modifierIdAttachedToOrphanItem!.map((x) => aWixRestaurantsMenusItemModifierV1ModifierIdAttachedToOrphanItemInput({}, pickedFields.get('modifierIdAttachedToOrphanItem'))) : [aWixRestaurantsMenusItemModifierV1ModifierIdAttachedToOrphanItemInput({}, pickedFields.get('modifierIdAttachedToOrphanItem'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponse = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierIdLocationIds')) {
        result.modifierIdLocationIds = overrides && overrides.hasOwnProperty('modifierIdLocationIds') ? overrides.modifierIdLocationIds!.map((x) => aWixRestaurantsMenusItemModifierV1ModifierIdLocationIdsInput({}, pickedFields.get('modifierIdLocationIds'))) : [aWixRestaurantsMenusItemModifierV1ModifierIdLocationIdsInput({}, pickedFields.get('modifierIdLocationIds'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponse = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['dolor'];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierIds')) {
        result.modifierIds = overrides && overrides.hasOwnProperty('modifierIds') ? overrides.modifierIds! : ['sit'];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponse = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateModifierResult = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateModifierResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modifier')) {
        result.modifier = overrides && overrides.hasOwnProperty('modifier') ? aWixRestaurantsMenusItemModifierV1Modifier(overrides.modifier ?? {}, pickedFields.get('modifier')) : aWixRestaurantsMenusItemModifierV1Modifier({}, pickedFields.get('modifier'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateModifiersRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateModifiersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifiers')) {
        result.modifiers = overrides && overrides.hasOwnProperty('modifiers') ? overrides.modifiers!.map((x) => aWixRestaurantsMenusItemModifierV1MaskedModifierInput({}, pickedFields.get('modifiers'))) : [aWixRestaurantsMenusItemModifierV1MaskedModifierInput({}, pickedFields.get('modifiers'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1BulkUpdateModifiersResponse = <T extends Partial<WixRestaurantsMenusItemModifierV1BulkUpdateModifiersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemModifierV1BulkUpdateModifierResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemModifierV1BulkUpdateModifierResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1CloneModifiersRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1CloneModifiersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'odio';
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1CountModifiersRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1CountModifiersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'accusamus';
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1CountModifiersResponse = <T extends Partial<WixRestaurantsMenusItemModifierV1CountModifiersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 7544;
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1CreateModifierRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1CreateModifierRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifier')) {
        result.modifier = overrides && overrides.hasOwnProperty('modifier') ? aWixRestaurantsMenusItemModifierV1ModifierInput(overrides.modifier ?? {}, pickedFields.get('modifier')) : aWixRestaurantsMenusItemModifierV1ModifierInput({}, pickedFields.get('modifier'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1CreateModifierResponse = <T extends Partial<WixRestaurantsMenusItemModifierV1CreateModifierResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifier')) {
        result.modifier = overrides && overrides.hasOwnProperty('modifier') ? aWixRestaurantsMenusItemModifierV1Modifier(overrides.modifier ?? {}, pickedFields.get('modifier')) : aWixRestaurantsMenusItemModifierV1Modifier({}, pickedFields.get('modifier'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1DeleteModifierRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1DeleteModifierRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierId')) {
        result.modifierId = overrides && overrides.hasOwnProperty('modifierId') ? overrides.modifierId! : 'veritatis';
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1ExternalReferenceInfo = <T extends Partial<WixRestaurantsMenusItemModifierV1ExternalReferenceInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'fugit';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'commodi';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'non';
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1ExternalReferenceInfoInput = <T extends Partial<WixRestaurantsMenusItemModifierV1ExternalReferenceInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'reiciendis';
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1GetModifierRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1GetModifierRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '917ea921-9d60-4aa1-b1d3-4f948a6c134e';
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1ListModifiersRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1ListModifiersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierIds')) {
        result.modifierIds = overrides && overrides.hasOwnProperty('modifierIds') ? overrides.modifierIds! : ['minima'];
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1ListModifiersResponse = <T extends Partial<WixRestaurantsMenusItemModifierV1ListModifiersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiers')) {
        result.modifiers = overrides && overrides.hasOwnProperty('modifiers') ? overrides.modifiers!.map((x) => aWixRestaurantsMenusItemModifierV1Modifier(x ?? {}, pickedFields.get('modifiers'))) : [aWixRestaurantsMenusItemModifierV1Modifier({}, pickedFields.get('modifiers'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1MaskedModifierInput = <T extends Partial<WixRestaurantsMenusItemModifierV1MaskedModifierInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['et'];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifier')) {
        result.modifier = overrides && overrides.hasOwnProperty('modifier') ? aWixRestaurantsMenusItemModifierV1ModifierInput(overrides.modifier ?? {}, pickedFields.get('modifier')) : aWixRestaurantsMenusItemModifierV1ModifierInput({}, pickedFields.get('modifier'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1Modifier = <T extends Partial<WixRestaurantsMenusItemModifierV1Modifier>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attachedToOrphanItem')) {
        result.attachedToOrphanItem = overrides && overrides.hasOwnProperty('attachedToOrphanItem') ? overrides.attachedToOrphanItem! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['maxime'];
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aWixRestaurantsMenusItemModifierV1ExternalReferenceInfo(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aWixRestaurantsMenusItemModifierV1ExternalReferenceInfo({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('inStock')) {
        result.inStock = overrides && overrides.hasOwnProperty('inStock') ? overrides.inStock! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? aComWixpressLocationsQueryLocationsResponse(overrides.locations ?? {}, pickedFields.get('locations')) : aComWixpressLocationsQueryLocationsResponse({}, pickedFields.get('locations'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'quam';
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1ModifierIdAttachedToOrphanItemInput = <T extends Partial<WixRestaurantsMenusItemModifierV1ModifierIdAttachedToOrphanItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attachedToOrphanItem')) {
        result.attachedToOrphanItem = overrides && overrides.hasOwnProperty('attachedToOrphanItem') ? overrides.attachedToOrphanItem! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierId')) {
        result.modifierId = overrides && overrides.hasOwnProperty('modifierId') ? overrides.modifierId! : 'in';
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1ModifierIdLocationIdsInput = <T extends Partial<WixRestaurantsMenusItemModifierV1ModifierIdLocationIdsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['officia'];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierId')) {
        result.modifierId = overrides && overrides.hasOwnProperty('modifierId') ? overrides.modifierId! : 'aspernatur';
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1ModifierInput = <T extends Partial<WixRestaurantsMenusItemModifierV1ModifierInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attachedToOrphanItem')) {
        result.attachedToOrphanItem = overrides && overrides.hasOwnProperty('attachedToOrphanItem') ? overrides.attachedToOrphanItem! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['minus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aWixRestaurantsMenusItemModifierV1ExternalReferenceInfoInput(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aWixRestaurantsMenusItemModifierV1ExternalReferenceInfoInput({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'at';
    }
    if (pickedFields.size === 0 || pickedFields.has('inStock')) {
        result.inStock = overrides && overrides.hasOwnProperty('inStock') ? overrides.inStock! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'tempora';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'voluptatum';
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1QueryModifiersRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1QueryModifiersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1QueryModifiersResponse = <T extends Partial<WixRestaurantsMenusItemModifierV1QueryModifiersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixRestaurantsMenusItemModifierV1Modifier(x ?? {}, pickedFields.get('items'))) : [aWixRestaurantsMenusItemModifierV1Modifier({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1UpdateModifierRequestInput = <T extends Partial<WixRestaurantsMenusItemModifierV1UpdateModifierRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['impedit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifier')) {
        result.modifier = overrides && overrides.hasOwnProperty('modifier') ? aWixRestaurantsMenusItemModifierV1ModifierInput(overrides.modifier ?? {}, pickedFields.get('modifier')) : aWixRestaurantsMenusItemModifierV1ModifierInput({}, pickedFields.get('modifier'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1UpdateModifierResponse = <T extends Partial<WixRestaurantsMenusItemModifierV1UpdateModifierResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifier')) {
        result.modifier = overrides && overrides.hasOwnProperty('modifier') ? aWixRestaurantsMenusItemModifierV1Modifier(overrides.modifier ?? {}, pickedFields.get('modifier')) : aWixRestaurantsMenusItemModifierV1Modifier({}, pickedFields.get('modifier'));
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 4566;
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingMetadata = <T extends Partial<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 279;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorQueryInput = <T extends Partial<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemModifierV1UpstreamWixCommonCursors = <T extends Partial<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'facilis';
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkCreateVariantsRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkCreateVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aWixRestaurantsMenusItemVariantV1VariantInput({}, pickedFields.get('variants'))) : [aWixRestaurantsMenusItemVariantV1VariantInput({}, pickedFields.get('variants'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkCreateVariantsResponse = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkCreateVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemVariantV1BulkVariantResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemVariantV1BulkVariantResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkDeleteVariantsRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkDeleteVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['quia'];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkDeleteVariantsResponse = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemVariantV1BulkDeleteVariantsResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemVariantV1BulkDeleteVariantsResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkDeleteVariantsResult = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('variantIdAttachedToOrphanItem')) {
        result.variantIdAttachedToOrphanItem = overrides && overrides.hasOwnProperty('variantIdAttachedToOrphanItem') ? overrides.variantIdAttachedToOrphanItem!.map((x) => aWixRestaurantsMenusItemVariantV1VariantIdAttachedToOrphanItemInput({}, pickedFields.get('variantIdAttachedToOrphanItem'))) : [aWixRestaurantsMenusItemVariantV1VariantIdAttachedToOrphanItemInput({}, pickedFields.get('variantIdAttachedToOrphanItem'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponse = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('variantIdLocationIds')) {
        result.variantIdLocationIds = overrides && overrides.hasOwnProperty('variantIdLocationIds') ? overrides.variantIdLocationIds!.map((x) => aWixRestaurantsMenusItemVariantV1VariantIdLocationIdsInput({}, pickedFields.get('variantIdLocationIds'))) : [aWixRestaurantsMenusItemVariantV1VariantIdLocationIdsInput({}, pickedFields.get('variantIdLocationIds'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponse = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['impedit'];
    }
    if (pickedFields.size === 0 || pickedFields.has('variantIds')) {
        result.variantIds = overrides && overrides.hasOwnProperty('variantIds') ? overrides.variantIds! : ['dignissimos'];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponse = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkUpdateVariantsRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkUpdateVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aWixRestaurantsMenusItemVariantV1MaskedVariantInput({}, pickedFields.get('variants'))) : [aWixRestaurantsMenusItemVariantV1MaskedVariantInput({}, pickedFields.get('variants'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkUpdateVariantsResponse = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkUpdateVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusItemVariantV1BulkVariantResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusItemVariantV1BulkVariantResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1BulkVariantResult = <T extends Partial<WixRestaurantsMenusItemVariantV1BulkVariantResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('variant')) {
        result.variant = overrides && overrides.hasOwnProperty('variant') ? aWixRestaurantsMenusItemVariantV1Variant(overrides.variant ?? {}, pickedFields.get('variant')) : aWixRestaurantsMenusItemVariantV1Variant({}, pickedFields.get('variant'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1CloneVariantsRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1CloneVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'aliquam';
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1CountVariantsRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1CountVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'possimus';
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1CountVariantsResponse = <T extends Partial<WixRestaurantsMenusItemVariantV1CountVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 7322;
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1CreateVariantRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1CreateVariantRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('variant')) {
        result.variant = overrides && overrides.hasOwnProperty('variant') ? aWixRestaurantsMenusItemVariantV1VariantInput(overrides.variant ?? {}, pickedFields.get('variant')) : aWixRestaurantsMenusItemVariantV1VariantInput({}, pickedFields.get('variant'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1CreateVariantResponse = <T extends Partial<WixRestaurantsMenusItemVariantV1CreateVariantResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('variant')) {
        result.variant = overrides && overrides.hasOwnProperty('variant') ? aWixRestaurantsMenusItemVariantV1Variant(overrides.variant ?? {}, pickedFields.get('variant')) : aWixRestaurantsMenusItemVariantV1Variant({}, pickedFields.get('variant'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1DeleteVariantRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1DeleteVariantRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('variantId')) {
        result.variantId = overrides && overrides.hasOwnProperty('variantId') ? overrides.variantId! : 'quia';
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1ExternalReferenceInfo = <T extends Partial<WixRestaurantsMenusItemVariantV1ExternalReferenceInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'provident';
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1ExternalReferenceInfoInput = <T extends Partial<WixRestaurantsMenusItemVariantV1ExternalReferenceInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'ex';
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1GetVariantRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1GetVariantRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '99eefa75-2a33-4e14-9b8f-9e6627e4152a';
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1ListVariantsRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1ListVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('variantIds')) {
        result.variantIds = overrides && overrides.hasOwnProperty('variantIds') ? overrides.variantIds! : ['mollitia'];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1ListVariantsResponse = <T extends Partial<WixRestaurantsMenusItemVariantV1ListVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('variants')) {
        result.variants = overrides && overrides.hasOwnProperty('variants') ? overrides.variants!.map((x) => aWixRestaurantsMenusItemVariantV1Variant(x ?? {}, pickedFields.get('variants'))) : [aWixRestaurantsMenusItemVariantV1Variant({}, pickedFields.get('variants'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1MaskedVariantInput = <T extends Partial<WixRestaurantsMenusItemVariantV1MaskedVariantInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['commodi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('variant')) {
        result.variant = overrides && overrides.hasOwnProperty('variant') ? aWixRestaurantsMenusItemVariantV1VariantInput(overrides.variant ?? {}, pickedFields.get('variant')) : aWixRestaurantsMenusItemVariantV1VariantInput({}, pickedFields.get('variant'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1QueryVariantsRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1QueryVariantsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRestaurantsMenusItemVariantV1UpstreamWixQueryCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixRestaurantsMenusItemVariantV1UpstreamWixQueryCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1QueryVariantsResponse = <T extends Partial<WixRestaurantsMenusItemVariantV1QueryVariantsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixRestaurantsMenusItemVariantV1Variant(x ?? {}, pickedFields.get('items'))) : [aWixRestaurantsMenusItemVariantV1Variant({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1UpdateVariantRequestInput = <T extends Partial<WixRestaurantsMenusItemVariantV1UpdateVariantRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['a'];
    }
    if (pickedFields.size === 0 || pickedFields.has('variant')) {
        result.variant = overrides && overrides.hasOwnProperty('variant') ? aWixRestaurantsMenusItemVariantV1VariantInput(overrides.variant ?? {}, pickedFields.get('variant')) : aWixRestaurantsMenusItemVariantV1VariantInput({}, pickedFields.get('variant'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1UpdateVariantResponse = <T extends Partial<WixRestaurantsMenusItemVariantV1UpdateVariantResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('variant')) {
        result.variant = overrides && overrides.hasOwnProperty('variant') ? aWixRestaurantsMenusItemVariantV1Variant(overrides.variant ?? {}, pickedFields.get('variant')) : aWixRestaurantsMenusItemVariantV1Variant({}, pickedFields.get('variant'));
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'nobis';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 5445;
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingMetadata = <T extends Partial<WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 7719;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixRestaurantsMenusItemVariantV1UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixRestaurantsMenusItemVariantV1UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1UpstreamWixCommonCursors = <T extends Partial<WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'aliquid';
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1UpstreamWixCommonSortingInput = <T extends Partial<WixRestaurantsMenusItemVariantV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'accusantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixRestaurantsMenusItemVariantV1UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1UpstreamWixQueryCursorQueryInput = <T extends Partial<WixRestaurantsMenusItemVariantV1UpstreamWixQueryCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixRestaurantsMenusItemVariantV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixRestaurantsMenusItemVariantV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1Variant = <T extends Partial<WixRestaurantsMenusItemVariantV1Variant>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attachedToOrphanItem')) {
        result.attachedToOrphanItem = overrides && overrides.hasOwnProperty('attachedToOrphanItem') ? overrides.attachedToOrphanItem! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['quo'];
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aWixRestaurantsMenusItemVariantV1ExternalReferenceInfo(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aWixRestaurantsMenusItemVariantV1ExternalReferenceInfo({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? aComWixpressLocationsQueryLocationsResponse(overrides.locations ?? {}, pickedFields.get('locations')) : aComWixpressLocationsQueryLocationsResponse({}, pickedFields.get('locations'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('oloMigrationVariantId')) {
        result.oloMigrationVariantId = overrides && overrides.hasOwnProperty('oloMigrationVariantId') ? overrides.oloMigrationVariantId! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'explicabo';
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1VariantIdAttachedToOrphanItemInput = <T extends Partial<WixRestaurantsMenusItemVariantV1VariantIdAttachedToOrphanItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attachedToOrphanItem')) {
        result.attachedToOrphanItem = overrides && overrides.hasOwnProperty('attachedToOrphanItem') ? overrides.attachedToOrphanItem! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('variantId')) {
        result.variantId = overrides && overrides.hasOwnProperty('variantId') ? overrides.variantId! : 'assumenda';
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1VariantIdLocationIdsInput = <T extends Partial<WixRestaurantsMenusItemVariantV1VariantIdLocationIdsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['repudiandae'];
    }
    if (pickedFields.size === 0 || pickedFields.has('variantId')) {
        result.variantId = overrides && overrides.hasOwnProperty('variantId') ? overrides.variantId! : 'est';
    }

    return result;
};

export const aWixRestaurantsMenusItemVariantV1VariantInput = <T extends Partial<WixRestaurantsMenusItemVariantV1VariantInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attachedToOrphanItem')) {
        result.attachedToOrphanItem = overrides && overrides.hasOwnProperty('attachedToOrphanItem') ? overrides.attachedToOrphanItem! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['voluptas'];
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'repellat';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aWixRestaurantsMenusItemVariantV1ExternalReferenceInfoInput(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aWixRestaurantsMenusItemVariantV1ExternalReferenceInfoInput({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('oloMigrationVariantId')) {
        result.oloMigrationVariantId = overrides && overrides.hasOwnProperty('oloMigrationVariantId') ? overrides.oloMigrationVariantId! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'et';
    }

    return result;
};

export const aWixRestaurantsMenusV1AdditionalChargeInfo = <T extends Partial<WixRestaurantsMenusV1AdditionalChargeInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalCharge')) {
        result.additionalCharge = overrides && overrides.hasOwnProperty('additionalCharge') ? overrides.additionalCharge! : 'consequuntur';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAdditionalCharge')) {
        result.formattedAdditionalCharge = overrides && overrides.hasOwnProperty('formattedAdditionalCharge') ? overrides.formattedAdditionalCharge! : 'vel';
    }

    return result;
};

export const aWixRestaurantsMenusV1AdditionalChargeInfoInput = <T extends Partial<WixRestaurantsMenusV1AdditionalChargeInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalCharge')) {
        result.additionalCharge = overrides && overrides.hasOwnProperty('additionalCharge') ? overrides.additionalCharge! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('formattedAdditionalCharge')) {
        result.formattedAdditionalCharge = overrides && overrides.hasOwnProperty('formattedAdditionalCharge') ? overrides.formattedAdditionalCharge! : 'quasi';
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkCreateModifierGroupsRequestInput = <T extends Partial<WixRestaurantsMenusV1BulkCreateModifierGroupsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierGroups')) {
        result.modifierGroups = overrides && overrides.hasOwnProperty('modifierGroups') ? overrides.modifierGroups!.map((x) => aWixRestaurantsMenusV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))) : [aWixRestaurantsMenusV1ModifierGroupInput({}, pickedFields.get('modifierGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkCreateModifierGroupsResponse = <T extends Partial<WixRestaurantsMenusV1BulkCreateModifierGroupsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusV1BulkCreateModifierGroupsResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusV1BulkCreateModifierGroupsResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkCreateModifierGroupsResult = <T extends Partial<WixRestaurantsMenusV1BulkCreateModifierGroupsResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroup')) {
        result.modifierGroup = overrides && overrides.hasOwnProperty('modifierGroup') ? aWixRestaurantsMenusV1ModifierGroup(overrides.modifierGroup ?? {}, pickedFields.get('modifierGroup')) : aWixRestaurantsMenusV1ModifierGroup({}, pickedFields.get('modifierGroup'));
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkDeleteModifierGroupsRequestInput = <T extends Partial<WixRestaurantsMenusV1BulkDeleteModifierGroupsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('ids')) {
        result.ids = overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['consectetur'];
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkDeleteModifierGroupsResponse = <T extends Partial<WixRestaurantsMenusV1BulkDeleteModifierGroupsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusV1BulkDeleteModifierGroupsResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusV1BulkDeleteModifierGroupsResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkDeleteModifierGroupsResult = <T extends Partial<WixRestaurantsMenusV1BulkDeleteModifierGroupsResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemRequestInput = <T extends Partial<WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierGroupIdAttachedToOrphanItem')) {
        result.modifierGroupIdAttachedToOrphanItem = overrides && overrides.hasOwnProperty('modifierGroupIdAttachedToOrphanItem') ? overrides.modifierGroupIdAttachedToOrphanItem!.map((x) => aWixRestaurantsMenusV1ModifierGroupIdAttachedToOrphanItemInput({}, pickedFields.get('modifierGroupIdAttachedToOrphanItem'))) : [aWixRestaurantsMenusV1ModifierGroupIdAttachedToOrphanItemInput({}, pickedFields.get('modifierGroupIdAttachedToOrphanItem'))];
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponse = <T extends Partial<WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult = <T extends Partial<WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = <T extends Partial<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierGroupIdLocationIds')) {
        result.modifierGroupIdLocationIds = overrides && overrides.hasOwnProperty('modifierGroupIdLocationIds') ? overrides.modifierGroupIdLocationIds!.map((x) => aWixRestaurantsMenusV1ModifierGroupIdLocationIdsInput({}, pickedFields.get('modifierGroupIdLocationIds'))) : [aWixRestaurantsMenusV1ModifierGroupIdLocationIdsInput({}, pickedFields.get('modifierGroupIdLocationIds'))];
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponse = <T extends Partial<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = <T extends Partial<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsRequestInput = <T extends Partial<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['magnam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroupIds')) {
        result.modifierGroupIds = overrides && overrides.hasOwnProperty('modifierGroupIds') ? overrides.modifierGroupIds! : ['qui'];
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponse = <T extends Partial<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponseBulkItemResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponseBulkItemResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = <T extends Partial<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateModifierGroupsRequestInput = <T extends Partial<WixRestaurantsMenusV1BulkUpdateModifierGroupsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierGroups')) {
        result.modifierGroups = overrides && overrides.hasOwnProperty('modifierGroups') ? overrides.modifierGroups!.map((x) => aWixRestaurantsMenusV1MaskedModifierGroupInput({}, pickedFields.get('modifierGroups'))) : [aWixRestaurantsMenusV1MaskedModifierGroupInput({}, pickedFields.get('modifierGroups'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('returnEntity')) {
        result.returnEntity = overrides && overrides.hasOwnProperty('returnEntity') ? overrides.returnEntity! : true;
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateModifierGroupsResponse = <T extends Partial<WixRestaurantsMenusV1BulkUpdateModifierGroupsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkActionMetadata')) {
        result.bulkActionMetadata = overrides && overrides.hasOwnProperty('bulkActionMetadata') ? aWixCommonBulkActionMetadata(overrides.bulkActionMetadata ?? {}, pickedFields.get('bulkActionMetadata')) : aWixCommonBulkActionMetadata({}, pickedFields.get('bulkActionMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('results')) {
        result.results = overrides && overrides.hasOwnProperty('results') ? overrides.results!.map((x) => aWixRestaurantsMenusV1BulkUpdateModifierGroupsResult(x ?? {}, pickedFields.get('results'))) : [aWixRestaurantsMenusV1BulkUpdateModifierGroupsResult({}, pickedFields.get('results'))];
    }

    return result;
};

export const aWixRestaurantsMenusV1BulkUpdateModifierGroupsResult = <T extends Partial<WixRestaurantsMenusV1BulkUpdateModifierGroupsResult>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('itemMetadata')) {
        result.itemMetadata = overrides && overrides.hasOwnProperty('itemMetadata') ? aWixCommonItemMetadata(overrides.itemMetadata ?? {}, pickedFields.get('itemMetadata')) : aWixCommonItemMetadata({}, pickedFields.get('itemMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroup')) {
        result.modifierGroup = overrides && overrides.hasOwnProperty('modifierGroup') ? aWixRestaurantsMenusV1ModifierGroup(overrides.modifierGroup ?? {}, pickedFields.get('modifierGroup')) : aWixRestaurantsMenusV1ModifierGroup({}, pickedFields.get('modifierGroup'));
    }

    return result;
};

export const aWixRestaurantsMenusV1CloneModifierGroupsRequestInput = <T extends Partial<WixRestaurantsMenusV1CloneModifierGroupsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'dignissimos';
    }

    return result;
};

export const aWixRestaurantsMenusV1CountModifierGroupsRequestInput = <T extends Partial<WixRestaurantsMenusV1CountModifierGroupsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'delectus';
    }

    return result;
};

export const aWixRestaurantsMenusV1CountModifierGroupsResponse = <T extends Partial<WixRestaurantsMenusV1CountModifierGroupsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 5985;
    }

    return result;
};

export const aWixRestaurantsMenusV1CreateModifierGroupRequestInput = <T extends Partial<WixRestaurantsMenusV1CreateModifierGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierGroup')) {
        result.modifierGroup = overrides && overrides.hasOwnProperty('modifierGroup') ? aWixRestaurantsMenusV1ModifierGroupInput(overrides.modifierGroup ?? {}, pickedFields.get('modifierGroup')) : aWixRestaurantsMenusV1ModifierGroupInput({}, pickedFields.get('modifierGroup'));
    }

    return result;
};

export const aWixRestaurantsMenusV1CreateModifierGroupResponse = <T extends Partial<WixRestaurantsMenusV1CreateModifierGroupResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierGroup')) {
        result.modifierGroup = overrides && overrides.hasOwnProperty('modifierGroup') ? aWixRestaurantsMenusV1ModifierGroup(overrides.modifierGroup ?? {}, pickedFields.get('modifierGroup')) : aWixRestaurantsMenusV1ModifierGroup({}, pickedFields.get('modifierGroup'));
    }

    return result;
};

export const aWixRestaurantsMenusV1DeleteLocationIdsFromModifiersInput = <T extends Partial<WixRestaurantsMenusV1DeleteLocationIdsFromModifiersInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['eaque'];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierIds')) {
        result.modifierIds = overrides && overrides.hasOwnProperty('modifierIds') ? overrides.modifierIds! : ['dolores'];
    }

    return result;
};

export const aWixRestaurantsMenusV1DeleteModifierGroupRequestInput = <T extends Partial<WixRestaurantsMenusV1DeleteModifierGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierGroupId')) {
        result.modifierGroupId = overrides && overrides.hasOwnProperty('modifierGroupId') ? overrides.modifierGroupId! : 'laboriosam';
    }

    return result;
};

export const aWixRestaurantsMenusV1ExternalReferenceInfo = <T extends Partial<WixRestaurantsMenusV1ExternalReferenceInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'quis';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'nulla';
    }

    return result;
};

export const aWixRestaurantsMenusV1ExternalReferenceInfoInput = <T extends Partial<WixRestaurantsMenusV1ExternalReferenceInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('externalAppId')) {
        result.externalAppId = overrides && overrides.hasOwnProperty('externalAppId') ? overrides.externalAppId! : 'porro';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEntityId')) {
        result.externalEntityId = overrides && overrides.hasOwnProperty('externalEntityId') ? overrides.externalEntityId! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastSyncDate')) {
        result.lastSyncDate = overrides && overrides.hasOwnProperty('lastSyncDate') ? overrides.lastSyncDate! : 'a';
    }

    return result;
};

export const aWixRestaurantsMenusV1GetModifierGroupRequestInput = <T extends Partial<WixRestaurantsMenusV1GetModifierGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'abc9f501-f131-4583-9644-9ae9fe6c79fc';
    }

    return result;
};

export const aWixRestaurantsMenusV1ListModifierGroupRequestInput = <T extends Partial<WixRestaurantsMenusV1ListModifierGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierGroupIds')) {
        result.modifierGroupIds = overrides && overrides.hasOwnProperty('modifierGroupIds') ? overrides.modifierGroupIds! : ['tenetur'];
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('paging'));
    }

    return result;
};

export const aWixRestaurantsMenusV1ListModifierGroupResponse = <T extends Partial<WixRestaurantsMenusV1ListModifierGroupResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixRestaurantsMenusV1UpstreamWixCommonCursorPagingMetadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixRestaurantsMenusV1UpstreamWixCommonCursorPagingMetadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroups')) {
        result.modifierGroups = overrides && overrides.hasOwnProperty('modifierGroups') ? overrides.modifierGroups!.map((x) => aWixRestaurantsMenusV1ModifierGroup(x ?? {}, pickedFields.get('modifierGroups'))) : [aWixRestaurantsMenusV1ModifierGroup({}, pickedFields.get('modifierGroups'))];
    }

    return result;
};

export const aWixRestaurantsMenusV1MaskedModifierGroupInput = <T extends Partial<WixRestaurantsMenusV1MaskedModifierGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['quisquam'];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroup')) {
        result.modifierGroup = overrides && overrides.hasOwnProperty('modifierGroup') ? aWixRestaurantsMenusV1ModifierGroupInput(overrides.modifierGroup ?? {}, pickedFields.get('modifierGroup')) : aWixRestaurantsMenusV1ModifierGroupInput({}, pickedFields.get('modifierGroup'));
    }

    return result;
};

export const aWixRestaurantsMenusV1Modifier = <T extends Partial<WixRestaurantsMenusV1Modifier>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalCharge')) {
        result.additionalCharge = overrides && overrides.hasOwnProperty('additionalCharge') ? overrides.additionalCharge! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('additionalChargeInfo')) {
        result.additionalChargeInfo = overrides && overrides.hasOwnProperty('additionalChargeInfo') ? aWixRestaurantsMenusV1AdditionalChargeInfo(overrides.additionalChargeInfo ?? {}, pickedFields.get('additionalChargeInfo')) : aWixRestaurantsMenusV1AdditionalChargeInfo({}, pickedFields.get('additionalChargeInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('modifier')) {
        result.modifier = overrides && overrides.hasOwnProperty('modifier') ? aWixRestaurantsMenusItemModifierV1Modifier(overrides.modifier ?? {}, pickedFields.get('modifier')) : aWixRestaurantsMenusItemModifierV1Modifier({}, pickedFields.get('modifier'));
    }
    if (pickedFields.size === 0 || pickedFields.has('preSelected')) {
        result.preSelected = overrides && overrides.hasOwnProperty('preSelected') ? overrides.preSelected! : false;
    }

    return result;
};

export const aWixRestaurantsMenusV1ModifierGroup = <T extends Partial<WixRestaurantsMenusV1ModifierGroup>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attachedToOrphanItem')) {
        result.attachedToOrphanItem = overrides && overrides.hasOwnProperty('attachedToOrphanItem') ? overrides.attachedToOrphanItem! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['nemo'];
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'quos';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFields(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFields({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aWixRestaurantsMenusV1ExternalReferenceInfo(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aWixRestaurantsMenusV1ExternalReferenceInfo({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'debitis';
    }
    if (pickedFields.size === 0 || pickedFields.has('locations')) {
        result.locations = overrides && overrides.hasOwnProperty('locations') ? aComWixpressLocationsQueryLocationsResponse(overrides.locations ?? {}, pickedFields.get('locations')) : aComWixpressLocationsQueryLocationsResponse({}, pickedFields.get('locations'));
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiers')) {
        result.modifiers = overrides && overrides.hasOwnProperty('modifiers') ? overrides.modifiers!.map((x) => aWixRestaurantsMenusV1Modifier(x ?? {}, pickedFields.get('modifiers'))) : [aWixRestaurantsMenusV1Modifier({}, pickedFields.get('modifiers'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('rule')) {
        result.rule = overrides && overrides.hasOwnProperty('rule') ? aWixRestaurantsMenusV1Rule(overrides.rule ?? {}, pickedFields.get('rule')) : aWixRestaurantsMenusV1Rule({}, pickedFields.get('rule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'inventore';
    }

    return result;
};

export const aWixRestaurantsMenusV1ModifierGroupIdAttachedToOrphanItemInput = <T extends Partial<WixRestaurantsMenusV1ModifierGroupIdAttachedToOrphanItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attachedToOrphanItem')) {
        result.attachedToOrphanItem = overrides && overrides.hasOwnProperty('attachedToOrphanItem') ? overrides.attachedToOrphanItem! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroupId')) {
        result.modifierGroupId = overrides && overrides.hasOwnProperty('modifierGroupId') ? overrides.modifierGroupId! : 'doloremque';
    }

    return result;
};

export const aWixRestaurantsMenusV1ModifierGroupIdLocationIdsInput = <T extends Partial<WixRestaurantsMenusV1ModifierGroupIdLocationIdsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['ab'];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroupId')) {
        result.modifierGroupId = overrides && overrides.hasOwnProperty('modifierGroupId') ? overrides.modifierGroupId! : 'velit';
    }

    return result;
};

export const aWixRestaurantsMenusV1ModifierGroupInput = <T extends Partial<WixRestaurantsMenusV1ModifierGroupInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('attachedToOrphanItem')) {
        result.attachedToOrphanItem = overrides && overrides.hasOwnProperty('attachedToOrphanItem') ? overrides.attachedToOrphanItem! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('businessLocationIds')) {
        result.businessLocationIds = overrides && overrides.hasOwnProperty('businessLocationIds') ? overrides.businessLocationIds! : ['accusamus'];
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('extendedFields')) {
        result.extendedFields = overrides && overrides.hasOwnProperty('extendedFields') ? aWixCommonDataDataextensionsExtendedFieldsInput(overrides.extendedFields ?? {}, pickedFields.get('extendedFields')) : aWixCommonDataDataextensionsExtendedFieldsInput({}, pickedFields.get('extendedFields'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalReferenceInfo')) {
        result.externalReferenceInfo = overrides && overrides.hasOwnProperty('externalReferenceInfo') ? aWixRestaurantsMenusV1ExternalReferenceInfoInput(overrides.externalReferenceInfo ?? {}, pickedFields.get('externalReferenceInfo')) : aWixRestaurantsMenusV1ExternalReferenceInfoInput({}, pickedFields.get('externalReferenceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('modifiers')) {
        result.modifiers = overrides && overrides.hasOwnProperty('modifiers') ? overrides.modifiers!.map((x) => aWixRestaurantsMenusV1ModifierInput({}, pickedFields.get('modifiers'))) : [aWixRestaurantsMenusV1ModifierInput({}, pickedFields.get('modifiers'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('rule')) {
        result.rule = overrides && overrides.hasOwnProperty('rule') ? aWixRestaurantsMenusV1RuleInput(overrides.rule ?? {}, pickedFields.get('rule')) : aWixRestaurantsMenusV1RuleInput({}, pickedFields.get('rule'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'deserunt';
    }

    return result;
};

export const aWixRestaurantsMenusV1ModifierInput = <T extends Partial<WixRestaurantsMenusV1ModifierInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('additionalChargeInfo')) {
        result.additionalChargeInfo = overrides && overrides.hasOwnProperty('additionalChargeInfo') ? aWixRestaurantsMenusV1AdditionalChargeInfoInput(overrides.additionalChargeInfo ?? {}, pickedFields.get('additionalChargeInfo')) : aWixRestaurantsMenusV1AdditionalChargeInfoInput({}, pickedFields.get('additionalChargeInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('preSelected')) {
        result.preSelected = overrides && overrides.hasOwnProperty('preSelected') ? overrides.preSelected! : false;
    }

    return result;
};

export const aWixRestaurantsMenusV1QueryModifierGroupsRequestInput = <T extends Partial<WixRestaurantsMenusV1QueryModifierGroupsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRestaurantsMenusV1UpstreamWixCommonCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixRestaurantsMenusV1UpstreamWixCommonCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRestaurantsMenusV1QueryModifierGroupsResponse = <T extends Partial<WixRestaurantsMenusV1QueryModifierGroupsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixRestaurantsMenusV1ModifierGroup(x ?? {}, pickedFields.get('items'))) : [aWixRestaurantsMenusV1ModifierGroup({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixRestaurantsMenusV1Rule = <T extends Partial<WixRestaurantsMenusV1Rule>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxSelections')) {
        result.maxSelections = overrides && overrides.hasOwnProperty('maxSelections') ? overrides.maxSelections! : 3921;
    }
    if (pickedFields.size === 0 || pickedFields.has('minSelections')) {
        result.minSelections = overrides && overrides.hasOwnProperty('minSelections') ? overrides.minSelections! : 1172;
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : true;
    }

    return result;
};

export const aWixRestaurantsMenusV1RuleInput = <T extends Partial<WixRestaurantsMenusV1RuleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('maxSelections')) {
        result.maxSelections = overrides && overrides.hasOwnProperty('maxSelections') ? overrides.maxSelections! : 2311;
    }
    if (pickedFields.size === 0 || pickedFields.has('minSelections')) {
        result.minSelections = overrides && overrides.hasOwnProperty('minSelections') ? overrides.minSelections! : 7101;
    }
    if (pickedFields.size === 0 || pickedFields.has('required')) {
        result.required = overrides && overrides.hasOwnProperty('required') ? overrides.required! : false;
    }

    return result;
};

export const aWixRestaurantsMenusV1RuleMultiSelect = <T extends Partial<WixRestaurantsMenusV1RuleMultiSelect>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('freeSelections')) {
        result.freeSelections = overrides && overrides.hasOwnProperty('freeSelections') ? overrides.freeSelections! : 3661;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxSelections')) {
        result.maxSelections = overrides && overrides.hasOwnProperty('maxSelections') ? overrides.maxSelections! : 9646;
    }
    if (pickedFields.size === 0 || pickedFields.has('minSelections')) {
        result.minSelections = overrides && overrides.hasOwnProperty('minSelections') ? overrides.minSelections! : 8203;
    }

    return result;
};

export const aWixRestaurantsMenusV1RuleMultiSelectInput = <T extends Partial<WixRestaurantsMenusV1RuleMultiSelectInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('freeSelections')) {
        result.freeSelections = overrides && overrides.hasOwnProperty('freeSelections') ? overrides.freeSelections! : 3142;
    }
    if (pickedFields.size === 0 || pickedFields.has('maxSelections')) {
        result.maxSelections = overrides && overrides.hasOwnProperty('maxSelections') ? overrides.maxSelections! : 4082;
    }
    if (pickedFields.size === 0 || pickedFields.has('minSelections')) {
        result.minSelections = overrides && overrides.hasOwnProperty('minSelections') ? overrides.minSelections! : 1612;
    }

    return result;
};

export const aWixRestaurantsMenusV1UpdateModifierGroupRequestInput = <T extends Partial<WixRestaurantsMenusV1UpdateModifierGroupRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['voluptates'];
    }
    if (pickedFields.size === 0 || pickedFields.has('modifierGroup')) {
        result.modifierGroup = overrides && overrides.hasOwnProperty('modifierGroup') ? aWixRestaurantsMenusV1ModifierGroupInput(overrides.modifierGroup ?? {}, pickedFields.get('modifierGroup')) : aWixRestaurantsMenusV1ModifierGroupInput({}, pickedFields.get('modifierGroup'));
    }

    return result;
};

export const aWixRestaurantsMenusV1UpdateModifierGroupResponse = <T extends Partial<WixRestaurantsMenusV1UpdateModifierGroupResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('modifierGroup')) {
        result.modifierGroup = overrides && overrides.hasOwnProperty('modifierGroup') ? aWixRestaurantsMenusV1ModifierGroup(overrides.modifierGroup ?? {}, pickedFields.get('modifierGroup')) : aWixRestaurantsMenusV1ModifierGroup({}, pickedFields.get('modifierGroup'));
    }

    return result;
};

export const aWixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 7190;
    }

    return result;
};

export const aWixRestaurantsMenusV1UpstreamWixCommonCursorPagingMetadata = <T extends Partial<WixRestaurantsMenusV1UpstreamWixCommonCursorPagingMetadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 9090;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixRestaurantsMenusV1UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixRestaurantsMenusV1UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }

    return result;
};

export const aWixRestaurantsMenusV1UpstreamWixCommonCursorQueryInput = <T extends Partial<WixRestaurantsMenusV1UpstreamWixCommonCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixRestaurantsMenusV1UpstreamWixCommonCursors = <T extends Partial<WixRestaurantsMenusV1UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'eum';
    }

    return result;
};

export const aWixRichContentV1AnchorData = <T extends Partial<WixRichContentV1AnchorData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('anchor')) {
        result.anchor = overrides && overrides.hasOwnProperty('anchor') ? overrides.anchor! : 'soluta';
    }

    return result;
};

export const aWixRichContentV1AnchorDataInput = <T extends Partial<WixRichContentV1AnchorDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('anchor')) {
        result.anchor = overrides && overrides.hasOwnProperty('anchor') ? overrides.anchor! : 'et';
    }

    return result;
};

export const aWixRichContentV1AppEmbedData = <T extends Partial<WixRichContentV1AppEmbedData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingData')) {
        result.bookingData = overrides && overrides.hasOwnProperty('bookingData') ? aWixRichContentV1AppEmbedDataBookingData(overrides.bookingData ?? {}, pickedFields.get('bookingData')) : aWixRichContentV1AppEmbedDataBookingData({}, pickedFields.get('bookingData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('eventData')) {
        result.eventData = overrides && overrides.hasOwnProperty('eventData') ? aWixRichContentV1AppEmbedDataEventData(overrides.eventData ?? {}, pickedFields.get('eventData')) : aWixRichContentV1AppEmbedDataEventData({}, pickedFields.get('eventData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1Media(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1Media({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('imageSrc')) {
        result.imageSrc = overrides && overrides.hasOwnProperty('imageSrc') ? overrides.imageSrc! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1AppEmbedDataAppType.Booking;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'vel';
    }

    return result;
};

export const aWixRichContentV1AppEmbedDataBookingData = <T extends Partial<WixRichContentV1AppEmbedDataBookingData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durations')) {
        result.durations = overrides && overrides.hasOwnProperty('durations') ? overrides.durations! : 'explicabo';
    }

    return result;
};

export const aWixRichContentV1AppEmbedDataBookingDataInput = <T extends Partial<WixRichContentV1AppEmbedDataBookingDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('durations')) {
        result.durations = overrides && overrides.hasOwnProperty('durations') ? overrides.durations! : 'quis';
    }

    return result;
};

export const aWixRichContentV1AppEmbedDataEventData = <T extends Partial<WixRichContentV1AppEmbedDataEventData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? overrides.location! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduling')) {
        result.scheduling = overrides && overrides.hasOwnProperty('scheduling') ? overrides.scheduling! : 'assumenda';
    }

    return result;
};

export const aWixRichContentV1AppEmbedDataEventDataInput = <T extends Partial<WixRichContentV1AppEmbedDataEventDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('location')) {
        result.location = overrides && overrides.hasOwnProperty('location') ? overrides.location! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('scheduling')) {
        result.scheduling = overrides && overrides.hasOwnProperty('scheduling') ? overrides.scheduling! : 'est';
    }

    return result;
};

export const aWixRichContentV1AppEmbedDataInput = <T extends Partial<WixRichContentV1AppEmbedDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bookingData')) {
        result.bookingData = overrides && overrides.hasOwnProperty('bookingData') ? aWixRichContentV1AppEmbedDataBookingDataInput(overrides.bookingData ?? {}, pickedFields.get('bookingData')) : aWixRichContentV1AppEmbedDataBookingDataInput({}, pickedFields.get('bookingData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('eventData')) {
        result.eventData = overrides && overrides.hasOwnProperty('eventData') ? aWixRichContentV1AppEmbedDataEventDataInput(overrides.eventData ?? {}, pickedFields.get('eventData')) : aWixRichContentV1AppEmbedDataEventDataInput({}, pickedFields.get('eventData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1MediaInput(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1MediaInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('imageSrc')) {
        result.imageSrc = overrides && overrides.hasOwnProperty('imageSrc') ? overrides.imageSrc! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('itemId')) {
        result.itemId = overrides && overrides.hasOwnProperty('itemId') ? overrides.itemId! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1AppEmbedDataAppType.Booking;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'aut';
    }

    return result;
};

export const aWixRichContentV1AudioData = <T extends Partial<WixRichContentV1AudioData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('audio')) {
        result.audio = overrides && overrides.hasOwnProperty('audio') ? aWixRichContentV1Media(overrides.audio ?? {}, pickedFields.get('audio')) : aWixRichContentV1Media({}, pickedFields.get('audio'));
    }
    if (pickedFields.size === 0 || pickedFields.has('authorName')) {
        result.authorName = overrides && overrides.hasOwnProperty('authorName') ? overrides.authorName! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('coverImage')) {
        result.coverImage = overrides && overrides.hasOwnProperty('coverImage') ? aWixRichContentV1Media(overrides.coverImage ?? {}, pickedFields.get('coverImage')) : aWixRichContentV1Media({}, pickedFields.get('coverImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDownload')) {
        result.disableDownload = overrides && overrides.hasOwnProperty('disableDownload') ? overrides.disableDownload! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('html')) {
        result.html = overrides && overrides.hasOwnProperty('html') ? overrides.html! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'assumenda';
    }

    return result;
};

export const aWixRichContentV1AudioDataInput = <T extends Partial<WixRichContentV1AudioDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('audio')) {
        result.audio = overrides && overrides.hasOwnProperty('audio') ? aWixRichContentV1MediaInput(overrides.audio ?? {}, pickedFields.get('audio')) : aWixRichContentV1MediaInput({}, pickedFields.get('audio'));
    }
    if (pickedFields.size === 0 || pickedFields.has('authorName')) {
        result.authorName = overrides && overrides.hasOwnProperty('authorName') ? overrides.authorName! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('coverImage')) {
        result.coverImage = overrides && overrides.hasOwnProperty('coverImage') ? aWixRichContentV1MediaInput(overrides.coverImage ?? {}, pickedFields.get('coverImage')) : aWixRichContentV1MediaInput({}, pickedFields.get('coverImage'));
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDownload')) {
        result.disableDownload = overrides && overrides.hasOwnProperty('disableDownload') ? overrides.disableDownload! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('html')) {
        result.html = overrides && overrides.hasOwnProperty('html') ? overrides.html! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'nostrum';
    }

    return result;
};

export const aWixRichContentV1BlockquoteData = <T extends Partial<WixRichContentV1BlockquoteData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('indentation')) {
        result.indentation = overrides && overrides.hasOwnProperty('indentation') ? overrides.indentation! : 7241;
    }

    return result;
};

export const aWixRichContentV1BlockquoteDataInput = <T extends Partial<WixRichContentV1BlockquoteDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('indentation')) {
        result.indentation = overrides && overrides.hasOwnProperty('indentation') ? overrides.indentation! : 2797;
    }

    return result;
};

export const aWixRichContentV1BulletedListData = <T extends Partial<WixRichContentV1BulletedListData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('indentation')) {
        result.indentation = overrides && overrides.hasOwnProperty('indentation') ? overrides.indentation! : 8166;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 1444;
    }

    return result;
};

export const aWixRichContentV1BulletedListDataInput = <T extends Partial<WixRichContentV1BulletedListDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('indentation')) {
        result.indentation = overrides && overrides.hasOwnProperty('indentation') ? overrides.indentation! : 1783;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 382;
    }

    return result;
};

export const aWixRichContentV1ButtonData = <T extends Partial<WixRichContentV1ButtonData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aWixRichContentV1Link(overrides.link ?? {}, pickedFields.get('link')) : aWixRichContentV1Link({}, pickedFields.get('link'));
    }
    if (pickedFields.size === 0 || pickedFields.has('styles')) {
        result.styles = overrides && overrides.hasOwnProperty('styles') ? aWixRichContentV1ButtonDataStyles(overrides.styles ?? {}, pickedFields.get('styles')) : aWixRichContentV1ButtonDataStyles({}, pickedFields.get('styles'));
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'repellat';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1ButtonDataType.Action;
    }

    return result;
};

export const aWixRichContentV1ButtonDataInput = <T extends Partial<WixRichContentV1ButtonDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aWixRichContentV1LinkInput(overrides.link ?? {}, pickedFields.get('link')) : aWixRichContentV1LinkInput({}, pickedFields.get('link'));
    }
    if (pickedFields.size === 0 || pickedFields.has('styles')) {
        result.styles = overrides && overrides.hasOwnProperty('styles') ? aWixRichContentV1ButtonDataStylesInput(overrides.styles ?? {}, pickedFields.get('styles')) : aWixRichContentV1ButtonDataStylesInput({}, pickedFields.get('styles'));
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1ButtonDataType.Action;
    }

    return result;
};

export const aWixRichContentV1ButtonDataStyles = <T extends Partial<WixRichContentV1ButtonDataStyles>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('border')) {
        result.border = overrides && overrides.hasOwnProperty('border') ? aWixRichContentV1ButtonDataStylesBorder(overrides.border ?? {}, pickedFields.get('border')) : aWixRichContentV1ButtonDataStylesBorder({}, pickedFields.get('border'));
    }
    if (pickedFields.size === 0 || pickedFields.has('colors')) {
        result.colors = overrides && overrides.hasOwnProperty('colors') ? aWixRichContentV1ButtonDataStylesColors(overrides.colors ?? {}, pickedFields.get('colors')) : aWixRichContentV1ButtonDataStylesColors({}, pickedFields.get('colors'));
    }

    return result;
};

export const aWixRichContentV1ButtonDataStylesBorder = <T extends Partial<WixRichContentV1ButtonDataStylesBorder>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('radius')) {
        result.radius = overrides && overrides.hasOwnProperty('radius') ? overrides.radius! : 3437;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 5942;
    }

    return result;
};

export const aWixRichContentV1ButtonDataStylesBorderInput = <T extends Partial<WixRichContentV1ButtonDataStylesBorderInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('radius')) {
        result.radius = overrides && overrides.hasOwnProperty('radius') ? overrides.radius! : 927;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 6607;
    }

    return result;
};

export const aWixRichContentV1ButtonDataStylesColors = <T extends Partial<WixRichContentV1ButtonDataStylesColors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('background')) {
        result.background = overrides && overrides.hasOwnProperty('background') ? overrides.background! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('border')) {
        result.border = overrides && overrides.hasOwnProperty('border') ? overrides.border! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'velit';
    }

    return result;
};

export const aWixRichContentV1ButtonDataStylesColorsInput = <T extends Partial<WixRichContentV1ButtonDataStylesColorsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('background')) {
        result.background = overrides && overrides.hasOwnProperty('background') ? overrides.background! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('border')) {
        result.border = overrides && overrides.hasOwnProperty('border') ? overrides.border! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'quia';
    }

    return result;
};

export const aWixRichContentV1ButtonDataStylesInput = <T extends Partial<WixRichContentV1ButtonDataStylesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('backgroundColor')) {
        result.backgroundColor = overrides && overrides.hasOwnProperty('backgroundColor') ? overrides.backgroundColor! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('backgroundColorHover')) {
        result.backgroundColorHover = overrides && overrides.hasOwnProperty('backgroundColorHover') ? overrides.backgroundColorHover! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('border')) {
        result.border = overrides && overrides.hasOwnProperty('border') ? aWixRichContentV1ButtonDataStylesBorderInput(overrides.border ?? {}, pickedFields.get('border')) : aWixRichContentV1ButtonDataStylesBorderInput({}, pickedFields.get('border'));
    }
    if (pickedFields.size === 0 || pickedFields.has('borderColor')) {
        result.borderColor = overrides && overrides.hasOwnProperty('borderColor') ? overrides.borderColor! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('borderColorHover')) {
        result.borderColorHover = overrides && overrides.hasOwnProperty('borderColorHover') ? overrides.borderColorHover! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('borderRadius')) {
        result.borderRadius = overrides && overrides.hasOwnProperty('borderRadius') ? overrides.borderRadius! : 8140;
    }
    if (pickedFields.size === 0 || pickedFields.has('borderWidth')) {
        result.borderWidth = overrides && overrides.hasOwnProperty('borderWidth') ? overrides.borderWidth! : 1597;
    }
    if (pickedFields.size === 0 || pickedFields.has('borderWidthHover')) {
        result.borderWidthHover = overrides && overrides.hasOwnProperty('borderWidthHover') ? overrides.borderWidthHover! : 352;
    }
    if (pickedFields.size === 0 || pickedFields.has('buttonSize')) {
        result.buttonSize = overrides && overrides.hasOwnProperty('buttonSize') ? overrides.buttonSize! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('colors')) {
        result.colors = overrides && overrides.hasOwnProperty('colors') ? aWixRichContentV1ButtonDataStylesColorsInput(overrides.colors ?? {}, pickedFields.get('colors')) : aWixRichContentV1ButtonDataStylesColorsInput({}, pickedFields.get('colors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('textColor')) {
        result.textColor = overrides && overrides.hasOwnProperty('textColor') ? overrides.textColor! : 'eos';
    }
    if (pickedFields.size === 0 || pickedFields.has('textColorHover')) {
        result.textColorHover = overrides && overrides.hasOwnProperty('textColorHover') ? overrides.textColorHover! : 'reprehenderit';
    }

    return result;
};

export const aWixRichContentV1CaptionData = <T extends Partial<WixRichContentV1CaptionData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('textStyle')) {
        result.textStyle = overrides && overrides.hasOwnProperty('textStyle') ? aWixRichContentV1TextStyle(overrides.textStyle ?? {}, pickedFields.get('textStyle')) : aWixRichContentV1TextStyle({}, pickedFields.get('textStyle'));
    }

    return result;
};

export const aWixRichContentV1CaptionDataInput = <T extends Partial<WixRichContentV1CaptionDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('textStyle')) {
        result.textStyle = overrides && overrides.hasOwnProperty('textStyle') ? aWixRichContentV1TextStyleInput(overrides.textStyle ?? {}, pickedFields.get('textStyle')) : aWixRichContentV1TextStyleInput({}, pickedFields.get('textStyle'));
    }

    return result;
};

export const aWixRichContentV1CodeBlockData = <T extends Partial<WixRichContentV1CodeBlockData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('textStyle')) {
        result.textStyle = overrides && overrides.hasOwnProperty('textStyle') ? aWixRichContentV1TextStyle(overrides.textStyle ?? {}, pickedFields.get('textStyle')) : aWixRichContentV1TextStyle({}, pickedFields.get('textStyle'));
    }

    return result;
};

export const aWixRichContentV1CodeBlockDataInput = <T extends Partial<WixRichContentV1CodeBlockDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('textStyle')) {
        result.textStyle = overrides && overrides.hasOwnProperty('textStyle') ? aWixRichContentV1TextStyleInput(overrides.textStyle ?? {}, pickedFields.get('textStyle')) : aWixRichContentV1TextStyleInput({}, pickedFields.get('textStyle'));
    }

    return result;
};

export const aWixRichContentV1CollapsibleListData = <T extends Partial<WixRichContentV1CollapsibleListData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('direction')) {
        result.direction = overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : WixRichContentV1CollapsibleListDataDirection.Ltr;
    }
    if (pickedFields.size === 0 || pickedFields.has('expandOnlyOne')) {
        result.expandOnlyOne = overrides && overrides.hasOwnProperty('expandOnlyOne') ? overrides.expandOnlyOne! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('initialExpandedItems')) {
        result.initialExpandedItems = overrides && overrides.hasOwnProperty('initialExpandedItems') ? overrides.initialExpandedItems! : WixRichContentV1CollapsibleListDataInitialExpandedItems.All;
    }
    if (pickedFields.size === 0 || pickedFields.has('isQapageData')) {
        result.isQapageData = overrides && overrides.hasOwnProperty('isQapageData') ? overrides.isQapageData! : true;
    }

    return result;
};

export const aWixRichContentV1CollapsibleListDataInput = <T extends Partial<WixRichContentV1CollapsibleListDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('direction')) {
        result.direction = overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : WixRichContentV1CollapsibleListDataDirection.Ltr;
    }
    if (pickedFields.size === 0 || pickedFields.has('expandOnlyOne')) {
        result.expandOnlyOne = overrides && overrides.hasOwnProperty('expandOnlyOne') ? overrides.expandOnlyOne! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('initialExpandedItems')) {
        result.initialExpandedItems = overrides && overrides.hasOwnProperty('initialExpandedItems') ? overrides.initialExpandedItems! : WixRichContentV1CollapsibleListDataInitialExpandedItems.All;
    }
    if (pickedFields.size === 0 || pickedFields.has('isQapageData')) {
        result.isQapageData = overrides && overrides.hasOwnProperty('isQapageData') ? overrides.isQapageData! : false;
    }

    return result;
};

export const aWixRichContentV1ColorData = <T extends Partial<WixRichContentV1ColorData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('background')) {
        result.background = overrides && overrides.hasOwnProperty('background') ? overrides.background! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('foreground')) {
        result.foreground = overrides && overrides.hasOwnProperty('foreground') ? overrides.foreground! : 'quis';
    }

    return result;
};

export const aWixRichContentV1ColorDataInput = <T extends Partial<WixRichContentV1ColorDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('background')) {
        result.background = overrides && overrides.hasOwnProperty('background') ? overrides.background! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('foreground')) {
        result.foreground = overrides && overrides.hasOwnProperty('foreground') ? overrides.foreground! : 'explicabo';
    }

    return result;
};

export const aWixRichContentV1Decoration = <T extends Partial<WixRichContentV1Decoration>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('anchorData')) {
        result.anchorData = overrides && overrides.hasOwnProperty('anchorData') ? aWixRichContentV1AnchorData(overrides.anchorData ?? {}, pickedFields.get('anchorData')) : aWixRichContentV1AnchorData({}, pickedFields.get('anchorData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('colorData')) {
        result.colorData = overrides && overrides.hasOwnProperty('colorData') ? aWixRichContentV1ColorData(overrides.colorData ?? {}, pickedFields.get('colorData')) : aWixRichContentV1ColorData({}, pickedFields.get('colorData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fontSizeData')) {
        result.fontSizeData = overrides && overrides.hasOwnProperty('fontSizeData') ? aWixRichContentV1FontSizeData(overrides.fontSizeData ?? {}, pickedFields.get('fontSizeData')) : aWixRichContentV1FontSizeData({}, pickedFields.get('fontSizeData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fontWeightValue')) {
        result.fontWeightValue = overrides && overrides.hasOwnProperty('fontWeightValue') ? overrides.fontWeightValue! : 5264;
    }
    if (pickedFields.size === 0 || pickedFields.has('italicData')) {
        result.italicData = overrides && overrides.hasOwnProperty('italicData') ? overrides.italicData! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('linkData')) {
        result.linkData = overrides && overrides.hasOwnProperty('linkData') ? aWixRichContentV1LinkData(overrides.linkData ?? {}, pickedFields.get('linkData')) : aWixRichContentV1LinkData({}, pickedFields.get('linkData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mentionData')) {
        result.mentionData = overrides && overrides.hasOwnProperty('mentionData') ? aWixRichContentV1MentionData(overrides.mentionData ?? {}, pickedFields.get('mentionData')) : aWixRichContentV1MentionData({}, pickedFields.get('mentionData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('spoilerData')) {
        result.spoilerData = overrides && overrides.hasOwnProperty('spoilerData') ? aWixRichContentV1SpoilerData(overrides.spoilerData ?? {}, pickedFields.get('spoilerData')) : aWixRichContentV1SpoilerData({}, pickedFields.get('spoilerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1DecorationType.Anchor;
    }
    if (pickedFields.size === 0 || pickedFields.has('underlineData')) {
        result.underlineData = overrides && overrides.hasOwnProperty('underlineData') ? overrides.underlineData! : false;
    }

    return result;
};

export const aWixRichContentV1DecorationInput = <T extends Partial<WixRichContentV1DecorationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('anchorData')) {
        result.anchorData = overrides && overrides.hasOwnProperty('anchorData') ? aWixRichContentV1AnchorDataInput(overrides.anchorData ?? {}, pickedFields.get('anchorData')) : aWixRichContentV1AnchorDataInput({}, pickedFields.get('anchorData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('colorData')) {
        result.colorData = overrides && overrides.hasOwnProperty('colorData') ? aWixRichContentV1ColorDataInput(overrides.colorData ?? {}, pickedFields.get('colorData')) : aWixRichContentV1ColorDataInput({}, pickedFields.get('colorData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fontSizeData')) {
        result.fontSizeData = overrides && overrides.hasOwnProperty('fontSizeData') ? aWixRichContentV1FontSizeDataInput(overrides.fontSizeData ?? {}, pickedFields.get('fontSizeData')) : aWixRichContentV1FontSizeDataInput({}, pickedFields.get('fontSizeData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fontWeightValue')) {
        result.fontWeightValue = overrides && overrides.hasOwnProperty('fontWeightValue') ? overrides.fontWeightValue! : 1114;
    }
    if (pickedFields.size === 0 || pickedFields.has('italicData')) {
        result.italicData = overrides && overrides.hasOwnProperty('italicData') ? overrides.italicData! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('linkData')) {
        result.linkData = overrides && overrides.hasOwnProperty('linkData') ? aWixRichContentV1LinkDataInput(overrides.linkData ?? {}, pickedFields.get('linkData')) : aWixRichContentV1LinkDataInput({}, pickedFields.get('linkData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mentionData')) {
        result.mentionData = overrides && overrides.hasOwnProperty('mentionData') ? aWixRichContentV1MentionDataInput(overrides.mentionData ?? {}, pickedFields.get('mentionData')) : aWixRichContentV1MentionDataInput({}, pickedFields.get('mentionData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('spoilerData')) {
        result.spoilerData = overrides && overrides.hasOwnProperty('spoilerData') ? aWixRichContentV1SpoilerDataInput(overrides.spoilerData ?? {}, pickedFields.get('spoilerData')) : aWixRichContentV1SpoilerDataInput({}, pickedFields.get('spoilerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('strikethroughData')) {
        result.strikethroughData = overrides && overrides.hasOwnProperty('strikethroughData') ? overrides.strikethroughData! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1DecorationType.Anchor;
    }
    if (pickedFields.size === 0 || pickedFields.has('underlineData')) {
        result.underlineData = overrides && overrides.hasOwnProperty('underlineData') ? overrides.underlineData! : true;
    }

    return result;
};

export const aWixRichContentV1DividerData = <T extends Partial<WixRichContentV1DividerData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('alignment')) {
        result.alignment = overrides && overrides.hasOwnProperty('alignment') ? overrides.alignment! : WixRichContentV1DividerDataAlignment.Center;
    }
    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineStyle')) {
        result.lineStyle = overrides && overrides.hasOwnProperty('lineStyle') ? overrides.lineStyle! : WixRichContentV1DividerDataLineStyle.Dashed;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : WixRichContentV1DividerDataWidth.Large;
    }

    return result;
};

export const aWixRichContentV1DividerDataInput = <T extends Partial<WixRichContentV1DividerDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('alignment')) {
        result.alignment = overrides && overrides.hasOwnProperty('alignment') ? overrides.alignment! : WixRichContentV1DividerDataAlignment.Center;
    }
    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lineStyle')) {
        result.lineStyle = overrides && overrides.hasOwnProperty('lineStyle') ? overrides.lineStyle! : WixRichContentV1DividerDataLineStyle.Dashed;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : WixRichContentV1DividerDataWidth.Large;
    }

    return result;
};

export const aWixRichContentV1DocumentStyle = <T extends Partial<WixRichContentV1DocumentStyle>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('blockquote')) {
        result.blockquote = overrides && overrides.hasOwnProperty('blockquote') ? aWixRichContentV1TextNodeStyle(overrides.blockquote ?? {}, pickedFields.get('blockquote')) : aWixRichContentV1TextNodeStyle({}, pickedFields.get('blockquote'));
    }
    if (pickedFields.size === 0 || pickedFields.has('codeBlock')) {
        result.codeBlock = overrides && overrides.hasOwnProperty('codeBlock') ? aWixRichContentV1TextNodeStyle(overrides.codeBlock ?? {}, pickedFields.get('codeBlock')) : aWixRichContentV1TextNodeStyle({}, pickedFields.get('codeBlock'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerFive')) {
        result.headerFive = overrides && overrides.hasOwnProperty('headerFive') ? aWixRichContentV1TextNodeStyle(overrides.headerFive ?? {}, pickedFields.get('headerFive')) : aWixRichContentV1TextNodeStyle({}, pickedFields.get('headerFive'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerFour')) {
        result.headerFour = overrides && overrides.hasOwnProperty('headerFour') ? aWixRichContentV1TextNodeStyle(overrides.headerFour ?? {}, pickedFields.get('headerFour')) : aWixRichContentV1TextNodeStyle({}, pickedFields.get('headerFour'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerOne')) {
        result.headerOne = overrides && overrides.hasOwnProperty('headerOne') ? aWixRichContentV1TextNodeStyle(overrides.headerOne ?? {}, pickedFields.get('headerOne')) : aWixRichContentV1TextNodeStyle({}, pickedFields.get('headerOne'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerSix')) {
        result.headerSix = overrides && overrides.hasOwnProperty('headerSix') ? aWixRichContentV1TextNodeStyle(overrides.headerSix ?? {}, pickedFields.get('headerSix')) : aWixRichContentV1TextNodeStyle({}, pickedFields.get('headerSix'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerThree')) {
        result.headerThree = overrides && overrides.hasOwnProperty('headerThree') ? aWixRichContentV1TextNodeStyle(overrides.headerThree ?? {}, pickedFields.get('headerThree')) : aWixRichContentV1TextNodeStyle({}, pickedFields.get('headerThree'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerTwo')) {
        result.headerTwo = overrides && overrides.hasOwnProperty('headerTwo') ? aWixRichContentV1TextNodeStyle(overrides.headerTwo ?? {}, pickedFields.get('headerTwo')) : aWixRichContentV1TextNodeStyle({}, pickedFields.get('headerTwo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paragraph')) {
        result.paragraph = overrides && overrides.hasOwnProperty('paragraph') ? aWixRichContentV1TextNodeStyle(overrides.paragraph ?? {}, pickedFields.get('paragraph')) : aWixRichContentV1TextNodeStyle({}, pickedFields.get('paragraph'));
    }

    return result;
};

export const aWixRichContentV1DocumentStyleInput = <T extends Partial<WixRichContentV1DocumentStyleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('blockquote')) {
        result.blockquote = overrides && overrides.hasOwnProperty('blockquote') ? aWixRichContentV1TextNodeStyleInput(overrides.blockquote ?? {}, pickedFields.get('blockquote')) : aWixRichContentV1TextNodeStyleInput({}, pickedFields.get('blockquote'));
    }
    if (pickedFields.size === 0 || pickedFields.has('codeBlock')) {
        result.codeBlock = overrides && overrides.hasOwnProperty('codeBlock') ? aWixRichContentV1TextNodeStyleInput(overrides.codeBlock ?? {}, pickedFields.get('codeBlock')) : aWixRichContentV1TextNodeStyleInput({}, pickedFields.get('codeBlock'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerFive')) {
        result.headerFive = overrides && overrides.hasOwnProperty('headerFive') ? aWixRichContentV1TextNodeStyleInput(overrides.headerFive ?? {}, pickedFields.get('headerFive')) : aWixRichContentV1TextNodeStyleInput({}, pickedFields.get('headerFive'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerFour')) {
        result.headerFour = overrides && overrides.hasOwnProperty('headerFour') ? aWixRichContentV1TextNodeStyleInput(overrides.headerFour ?? {}, pickedFields.get('headerFour')) : aWixRichContentV1TextNodeStyleInput({}, pickedFields.get('headerFour'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerOne')) {
        result.headerOne = overrides && overrides.hasOwnProperty('headerOne') ? aWixRichContentV1TextNodeStyleInput(overrides.headerOne ?? {}, pickedFields.get('headerOne')) : aWixRichContentV1TextNodeStyleInput({}, pickedFields.get('headerOne'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerSix')) {
        result.headerSix = overrides && overrides.hasOwnProperty('headerSix') ? aWixRichContentV1TextNodeStyleInput(overrides.headerSix ?? {}, pickedFields.get('headerSix')) : aWixRichContentV1TextNodeStyleInput({}, pickedFields.get('headerSix'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerThree')) {
        result.headerThree = overrides && overrides.hasOwnProperty('headerThree') ? aWixRichContentV1TextNodeStyleInput(overrides.headerThree ?? {}, pickedFields.get('headerThree')) : aWixRichContentV1TextNodeStyleInput({}, pickedFields.get('headerThree'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headerTwo')) {
        result.headerTwo = overrides && overrides.hasOwnProperty('headerTwo') ? aWixRichContentV1TextNodeStyleInput(overrides.headerTwo ?? {}, pickedFields.get('headerTwo')) : aWixRichContentV1TextNodeStyleInput({}, pickedFields.get('headerTwo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paragraph')) {
        result.paragraph = overrides && overrides.hasOwnProperty('paragraph') ? aWixRichContentV1TextNodeStyleInput(overrides.paragraph ?? {}, pickedFields.get('paragraph')) : aWixRichContentV1TextNodeStyleInput({}, pickedFields.get('paragraph'));
    }

    return result;
};

export const aWixRichContentV1EmbedData = <T extends Partial<WixRichContentV1EmbedData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('oembed')) {
        result.oembed = overrides && overrides.hasOwnProperty('oembed') ? aWixRichContentV1Oembed(overrides.oembed ?? {}, pickedFields.get('oembed')) : aWixRichContentV1Oembed({}, pickedFields.get('oembed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('src')) {
        result.src = overrides && overrides.hasOwnProperty('src') ? overrides.src! : 'aut';
    }

    return result;
};

export const aWixRichContentV1EmbedDataInput = <T extends Partial<WixRichContentV1EmbedDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('oembed')) {
        result.oembed = overrides && overrides.hasOwnProperty('oembed') ? aWixRichContentV1OembedInput(overrides.oembed ?? {}, pickedFields.get('oembed')) : aWixRichContentV1OembedInput({}, pickedFields.get('oembed'));
    }
    if (pickedFields.size === 0 || pickedFields.has('src')) {
        result.src = overrides && overrides.hasOwnProperty('src') ? overrides.src! : 'quo';
    }

    return result;
};

export const aWixRichContentV1FileData = <T extends Partial<WixRichContentV1FileData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mimeType')) {
        result.mimeType = overrides && overrides.hasOwnProperty('mimeType') ? overrides.mimeType! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('path')) {
        result.path = overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('pdfSettings')) {
        result.pdfSettings = overrides && overrides.hasOwnProperty('pdfSettings') ? aWixRichContentV1FileDataPdfSettings(overrides.pdfSettings ?? {}, pickedFields.get('pdfSettings')) : aWixRichContentV1FileDataPdfSettings({}, pickedFields.get('pdfSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('size')) {
        result.size = overrides && overrides.hasOwnProperty('size') ? overrides.size! : 5477;
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInKb')) {
        result.sizeInKb = overrides && overrides.hasOwnProperty('sizeInKb') ? overrides.sizeInKb! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('src')) {
        result.src = overrides && overrides.hasOwnProperty('src') ? aWixRichContentV1FileSource(overrides.src ?? {}, pickedFields.get('src')) : aWixRichContentV1FileSource({}, pickedFields.get('src'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'facilis';
    }

    return result;
};

export const aWixRichContentV1FileDataInput = <T extends Partial<WixRichContentV1FileDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mimeType')) {
        result.mimeType = overrides && overrides.hasOwnProperty('mimeType') ? overrides.mimeType! : 'exercitationem';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('path')) {
        result.path = overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('pdfSettings')) {
        result.pdfSettings = overrides && overrides.hasOwnProperty('pdfSettings') ? aWixRichContentV1FileDataPdfSettingsInput(overrides.pdfSettings ?? {}, pickedFields.get('pdfSettings')) : aWixRichContentV1FileDataPdfSettingsInput({}, pickedFields.get('pdfSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('size')) {
        result.size = overrides && overrides.hasOwnProperty('size') ? overrides.size! : 2152;
    }
    if (pickedFields.size === 0 || pickedFields.has('sizeInKb')) {
        result.sizeInKb = overrides && overrides.hasOwnProperty('sizeInKb') ? overrides.sizeInKb! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('src')) {
        result.src = overrides && overrides.hasOwnProperty('src') ? aWixRichContentV1FileSourceInput(overrides.src ?? {}, pickedFields.get('src')) : aWixRichContentV1FileSourceInput({}, pickedFields.get('src'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'nobis';
    }

    return result;
};

export const aWixRichContentV1FileDataPdfSettings = <T extends Partial<WixRichContentV1FileDataPdfSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('disableDownload')) {
        result.disableDownload = overrides && overrides.hasOwnProperty('disableDownload') ? overrides.disableDownload! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('disablePrint')) {
        result.disablePrint = overrides && overrides.hasOwnProperty('disablePrint') ? overrides.disablePrint! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('viewMode')) {
        result.viewMode = overrides && overrides.hasOwnProperty('viewMode') ? overrides.viewMode! : WixRichContentV1FileDataPdfSettingsViewMode.Full;
    }

    return result;
};

export const aWixRichContentV1FileDataPdfSettingsInput = <T extends Partial<WixRichContentV1FileDataPdfSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('disableDownload')) {
        result.disableDownload = overrides && overrides.hasOwnProperty('disableDownload') ? overrides.disableDownload! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('disablePrint')) {
        result.disablePrint = overrides && overrides.hasOwnProperty('disablePrint') ? overrides.disablePrint! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('viewMode')) {
        result.viewMode = overrides && overrides.hasOwnProperty('viewMode') ? overrides.viewMode! : WixRichContentV1FileDataPdfSettingsViewMode.Full;
    }

    return result;
};

export const aWixRichContentV1FileSource = <T extends Partial<WixRichContentV1FileSource>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : 'quam';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('private')) {
        result.private = overrides && overrides.hasOwnProperty('private') ? overrides.private! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'sed';
    }

    return result;
};

export const aWixRichContentV1FileSourceInput = <T extends Partial<WixRichContentV1FileSourceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('private')) {
        result.private = overrides && overrides.hasOwnProperty('private') ? overrides.private! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'ducimus';
    }

    return result;
};

export const aWixRichContentV1FontSizeData = <T extends Partial<WixRichContentV1FontSizeData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('unit')) {
        result.unit = overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : WixRichContentV1FontSizeDatafontType.Em;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 4408;
    }

    return result;
};

export const aWixRichContentV1FontSizeDataInput = <T extends Partial<WixRichContentV1FontSizeDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('unit')) {
        result.unit = overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : WixRichContentV1FontSizeDatafontType.Em;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 1338;
    }

    return result;
};

export const aWixRichContentV1Gif = <T extends Partial<WixRichContentV1Gif>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('gif')) {
        result.gif = overrides && overrides.hasOwnProperty('gif') ? overrides.gif! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('mp4')) {
        result.mp4 = overrides && overrides.hasOwnProperty('mp4') ? overrides.mp4! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('still')) {
        result.still = overrides && overrides.hasOwnProperty('still') ? overrides.still! : 'sed';
    }

    return result;
};

export const aWixRichContentV1GifData = <T extends Partial<WixRichContentV1GifData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('downsized')) {
        result.downsized = overrides && overrides.hasOwnProperty('downsized') ? aWixRichContentV1Gif(overrides.downsized ?? {}, pickedFields.get('downsized')) : aWixRichContentV1Gif({}, pickedFields.get('downsized'));
    }
    if (pickedFields.size === 0 || pickedFields.has('gifType')) {
        result.gifType = overrides && overrides.hasOwnProperty('gifType') ? overrides.gifType! : WixRichContentV1GifDataGifType.Gif;
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 5797;
    }
    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? aWixRichContentV1Gif(overrides.original ?? {}, pickedFields.get('original')) : aWixRichContentV1Gif({}, pickedFields.get('original'));
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 6978;
    }

    return result;
};

export const aWixRichContentV1GifDataInput = <T extends Partial<WixRichContentV1GifDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('downsized')) {
        result.downsized = overrides && overrides.hasOwnProperty('downsized') ? aWixRichContentV1GifInput(overrides.downsized ?? {}, pickedFields.get('downsized')) : aWixRichContentV1GifInput({}, pickedFields.get('downsized'));
    }
    if (pickedFields.size === 0 || pickedFields.has('gifType')) {
        result.gifType = overrides && overrides.hasOwnProperty('gifType') ? overrides.gifType! : WixRichContentV1GifDataGifType.Gif;
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 6366;
    }
    if (pickedFields.size === 0 || pickedFields.has('original')) {
        result.original = overrides && overrides.hasOwnProperty('original') ? aWixRichContentV1GifInput(overrides.original ?? {}, pickedFields.get('original')) : aWixRichContentV1GifInput({}, pickedFields.get('original'));
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 855;
    }

    return result;
};

export const aWixRichContentV1GifInput = <T extends Partial<WixRichContentV1GifInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('gif')) {
        result.gif = overrides && overrides.hasOwnProperty('gif') ? overrides.gif! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('mp4')) {
        result.mp4 = overrides && overrides.hasOwnProperty('mp4') ? overrides.mp4! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('still')) {
        result.still = overrides && overrides.hasOwnProperty('still') ? overrides.still! : 'consequatur';
    }

    return result;
};

export const aWixRichContentV1GalleryData = <T extends Partial<WixRichContentV1GalleryData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDownload')) {
        result.disableDownload = overrides && overrides.hasOwnProperty('disableDownload') ? overrides.disableDownload! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('disableExpand')) {
        result.disableExpand = overrides && overrides.hasOwnProperty('disableExpand') ? overrides.disableExpand! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixRichContentV1GalleryDataItem(x ?? {}, pickedFields.get('items'))) : [aWixRichContentV1GalleryDataItem({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixRichContentV1GalleryOptions(overrides.options ?? {}, pickedFields.get('options')) : aWixRichContentV1GalleryOptions({}, pickedFields.get('options'));
    }

    return result;
};

export const aWixRichContentV1GalleryDataInput = <T extends Partial<WixRichContentV1GalleryDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDownload')) {
        result.disableDownload = overrides && overrides.hasOwnProperty('disableDownload') ? overrides.disableDownload! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('disableExpand')) {
        result.disableExpand = overrides && overrides.hasOwnProperty('disableExpand') ? overrides.disableExpand! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixRichContentV1GalleryDataItemInput({}, pickedFields.get('items'))) : [aWixRichContentV1GalleryDataItemInput({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixRichContentV1GalleryOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aWixRichContentV1GalleryOptionsInput({}, pickedFields.get('options'));
    }

    return result;
};

export const aWixRichContentV1GalleryDataItem = <T extends Partial<WixRichContentV1GalleryDataItem>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'expedita';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1GalleryDataItemImage(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1GalleryDataItemImage({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixRichContentV1GalleryDataItemVideo(overrides.video ?? {}, pickedFields.get('video')) : aWixRichContentV1GalleryDataItemVideo({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixRichContentV1GalleryDataItemImage = <T extends Partial<WixRichContentV1GalleryDataItemImage>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aWixRichContentV1Link(overrides.link ?? {}, pickedFields.get('link')) : aWixRichContentV1Link({}, pickedFields.get('link'));
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixRichContentV1Media(overrides.media ?? {}, pickedFields.get('media')) : aWixRichContentV1Media({}, pickedFields.get('media'));
    }

    return result;
};

export const aWixRichContentV1GalleryDataItemImageInput = <T extends Partial<WixRichContentV1GalleryDataItemImageInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aWixRichContentV1LinkInput(overrides.link ?? {}, pickedFields.get('link')) : aWixRichContentV1LinkInput({}, pickedFields.get('link'));
    }
    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixRichContentV1MediaInput(overrides.media ?? {}, pickedFields.get('media')) : aWixRichContentV1MediaInput({}, pickedFields.get('media'));
    }

    return result;
};

export const aWixRichContentV1GalleryDataItemInput = <T extends Partial<WixRichContentV1GalleryDataItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1GalleryDataItemImageInput(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1GalleryDataItemImageInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixRichContentV1GalleryDataItemVideoInput(overrides.video ?? {}, pickedFields.get('video')) : aWixRichContentV1GalleryDataItemVideoInput({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixRichContentV1GalleryDataItemVideo = <T extends Partial<WixRichContentV1GalleryDataItemVideo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixRichContentV1Media(overrides.media ?? {}, pickedFields.get('media')) : aWixRichContentV1Media({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnail')) {
        result.thumbnail = overrides && overrides.hasOwnProperty('thumbnail') ? aWixRichContentV1Media(overrides.thumbnail ?? {}, pickedFields.get('thumbnail')) : aWixRichContentV1Media({}, pickedFields.get('thumbnail'));
    }

    return result;
};

export const aWixRichContentV1GalleryDataItemVideoInput = <T extends Partial<WixRichContentV1GalleryDataItemVideoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('media')) {
        result.media = overrides && overrides.hasOwnProperty('media') ? aWixRichContentV1MediaInput(overrides.media ?? {}, pickedFields.get('media')) : aWixRichContentV1MediaInput({}, pickedFields.get('media'));
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnail')) {
        result.thumbnail = overrides && overrides.hasOwnProperty('thumbnail') ? aWixRichContentV1MediaInput(overrides.thumbnail ?? {}, pickedFields.get('thumbnail')) : aWixRichContentV1MediaInput({}, pickedFields.get('thumbnail'));
    }

    return result;
};

export const aWixRichContentV1GalleryOptions = <T extends Partial<WixRichContentV1GalleryOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixRichContentV1GalleryOptionsItemStyle(overrides.item ?? {}, pickedFields.get('item')) : aWixRichContentV1GalleryOptionsItemStyle({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('layout')) {
        result.layout = overrides && overrides.hasOwnProperty('layout') ? aWixRichContentV1GalleryOptionsLayout(overrides.layout ?? {}, pickedFields.get('layout')) : aWixRichContentV1GalleryOptionsLayout({}, pickedFields.get('layout'));
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnails')) {
        result.thumbnails = overrides && overrides.hasOwnProperty('thumbnails') ? aWixRichContentV1GalleryOptionsThumbnails(overrides.thumbnails ?? {}, pickedFields.get('thumbnails')) : aWixRichContentV1GalleryOptionsThumbnails({}, pickedFields.get('thumbnails'));
    }

    return result;
};

export const aWixRichContentV1GalleryOptionsInput = <T extends Partial<WixRichContentV1GalleryOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('item')) {
        result.item = overrides && overrides.hasOwnProperty('item') ? aWixRichContentV1GalleryOptionsItemStyleInput(overrides.item ?? {}, pickedFields.get('item')) : aWixRichContentV1GalleryOptionsItemStyleInput({}, pickedFields.get('item'));
    }
    if (pickedFields.size === 0 || pickedFields.has('layout')) {
        result.layout = overrides && overrides.hasOwnProperty('layout') ? aWixRichContentV1GalleryOptionsLayoutInput(overrides.layout ?? {}, pickedFields.get('layout')) : aWixRichContentV1GalleryOptionsLayoutInput({}, pickedFields.get('layout'));
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnails')) {
        result.thumbnails = overrides && overrides.hasOwnProperty('thumbnails') ? aWixRichContentV1GalleryOptionsThumbnailsInput(overrides.thumbnails ?? {}, pickedFields.get('thumbnails')) : aWixRichContentV1GalleryOptionsThumbnailsInput({}, pickedFields.get('thumbnails'));
    }

    return result;
};

export const aWixRichContentV1GalleryOptionsItemStyle = <T extends Partial<WixRichContentV1GalleryOptionsItemStyle>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('crop')) {
        result.crop = overrides && overrides.hasOwnProperty('crop') ? overrides.crop! : WixRichContentV1GalleryOptionsItemStyleCrop.Fill;
    }
    if (pickedFields.size === 0 || pickedFields.has('ratio')) {
        result.ratio = overrides && overrides.hasOwnProperty('ratio') ? overrides.ratio! : 5.08;
    }
    if (pickedFields.size === 0 || pickedFields.has('spacing')) {
        result.spacing = overrides && overrides.hasOwnProperty('spacing') ? overrides.spacing! : 5139;
    }
    if (pickedFields.size === 0 || pickedFields.has('targetSize')) {
        result.targetSize = overrides && overrides.hasOwnProperty('targetSize') ? overrides.targetSize! : 1011;
    }

    return result;
};

export const aWixRichContentV1GalleryOptionsItemStyleInput = <T extends Partial<WixRichContentV1GalleryOptionsItemStyleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('crop')) {
        result.crop = overrides && overrides.hasOwnProperty('crop') ? overrides.crop! : WixRichContentV1GalleryOptionsItemStyleCrop.Fill;
    }
    if (pickedFields.size === 0 || pickedFields.has('ratio')) {
        result.ratio = overrides && overrides.hasOwnProperty('ratio') ? overrides.ratio! : 2.22;
    }
    if (pickedFields.size === 0 || pickedFields.has('spacing')) {
        result.spacing = overrides && overrides.hasOwnProperty('spacing') ? overrides.spacing! : 5836;
    }
    if (pickedFields.size === 0 || pickedFields.has('targetSize')) {
        result.targetSize = overrides && overrides.hasOwnProperty('targetSize') ? overrides.targetSize! : 4527;
    }

    return result;
};

export const aWixRichContentV1GalleryOptionsLayout = <T extends Partial<WixRichContentV1GalleryOptionsLayout>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('horizontalScroll')) {
        result.horizontalScroll = overrides && overrides.hasOwnProperty('horizontalScroll') ? overrides.horizontalScroll! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('mobileNumberOfColumns')) {
        result.mobileNumberOfColumns = overrides && overrides.hasOwnProperty('mobileNumberOfColumns') ? overrides.mobileNumberOfColumns! : 1992;
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOfColumns')) {
        result.numberOfColumns = overrides && overrides.hasOwnProperty('numberOfColumns') ? overrides.numberOfColumns! : 8108;
    }
    if (pickedFields.size === 0 || pickedFields.has('orientation')) {
        result.orientation = overrides && overrides.hasOwnProperty('orientation') ? overrides.orientation! : WixRichContentV1GalleryOptionsLayoutOrientation.Columns;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1GalleryOptionsLayoutType.Collage;
    }

    return result;
};

export const aWixRichContentV1GalleryOptionsLayoutInput = <T extends Partial<WixRichContentV1GalleryOptionsLayoutInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('horizontalScroll')) {
        result.horizontalScroll = overrides && overrides.hasOwnProperty('horizontalScroll') ? overrides.horizontalScroll! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('mobileNumberOfColumns')) {
        result.mobileNumberOfColumns = overrides && overrides.hasOwnProperty('mobileNumberOfColumns') ? overrides.mobileNumberOfColumns! : 8047;
    }
    if (pickedFields.size === 0 || pickedFields.has('numberOfColumns')) {
        result.numberOfColumns = overrides && overrides.hasOwnProperty('numberOfColumns') ? overrides.numberOfColumns! : 3092;
    }
    if (pickedFields.size === 0 || pickedFields.has('orientation')) {
        result.orientation = overrides && overrides.hasOwnProperty('orientation') ? overrides.orientation! : WixRichContentV1GalleryOptionsLayoutOrientation.Columns;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1GalleryOptionsLayoutType.Collage;
    }

    return result;
};

export const aWixRichContentV1GalleryOptionsThumbnails = <T extends Partial<WixRichContentV1GalleryOptionsThumbnails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('placement')) {
        result.placement = overrides && overrides.hasOwnProperty('placement') ? overrides.placement! : WixRichContentV1GalleryOptionsThumbnailsAlignment.Bottom;
    }
    if (pickedFields.size === 0 || pickedFields.has('spacing')) {
        result.spacing = overrides && overrides.hasOwnProperty('spacing') ? overrides.spacing! : 8246;
    }

    return result;
};

export const aWixRichContentV1GalleryOptionsThumbnailsInput = <T extends Partial<WixRichContentV1GalleryOptionsThumbnailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('placement')) {
        result.placement = overrides && overrides.hasOwnProperty('placement') ? overrides.placement! : WixRichContentV1GalleryOptionsThumbnailsAlignment.Bottom;
    }
    if (pickedFields.size === 0 || pickedFields.has('spacing')) {
        result.spacing = overrides && overrides.hasOwnProperty('spacing') ? overrides.spacing! : 6142;
    }

    return result;
};

export const aWixRichContentV1HtmlData = <T extends Partial<WixRichContentV1HtmlData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoHeight')) {
        result.autoHeight = overrides && overrides.hasOwnProperty('autoHeight') ? overrides.autoHeight! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('html')) {
        result.html = overrides && overrides.hasOwnProperty('html') ? overrides.html! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('isAdsense')) {
        result.isAdsense = overrides && overrides.hasOwnProperty('isAdsense') ? overrides.isAdsense! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : WixRichContentV1HtmlDataSource.Adsense;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'esse';
    }

    return result;
};

export const aWixRichContentV1HtmlDataInput = <T extends Partial<WixRichContentV1HtmlDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoHeight')) {
        result.autoHeight = overrides && overrides.hasOwnProperty('autoHeight') ? overrides.autoHeight! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('html')) {
        result.html = overrides && overrides.hasOwnProperty('html') ? overrides.html! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('isAdsense')) {
        result.isAdsense = overrides && overrides.hasOwnProperty('isAdsense') ? overrides.isAdsense! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? overrides.source! : WixRichContentV1HtmlDataSource.Adsense;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'tempore';
    }

    return result;
};

export const aWixRichContentV1HeadingData = <T extends Partial<WixRichContentV1HeadingData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('indentation')) {
        result.indentation = overrides && overrides.hasOwnProperty('indentation') ? overrides.indentation! : 3652;
    }
    if (pickedFields.size === 0 || pickedFields.has('level')) {
        result.level = overrides && overrides.hasOwnProperty('level') ? overrides.level! : 4354;
    }
    if (pickedFields.size === 0 || pickedFields.has('textStyle')) {
        result.textStyle = overrides && overrides.hasOwnProperty('textStyle') ? aWixRichContentV1TextStyle(overrides.textStyle ?? {}, pickedFields.get('textStyle')) : aWixRichContentV1TextStyle({}, pickedFields.get('textStyle'));
    }

    return result;
};

export const aWixRichContentV1HeadingDataInput = <T extends Partial<WixRichContentV1HeadingDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('indentation')) {
        result.indentation = overrides && overrides.hasOwnProperty('indentation') ? overrides.indentation! : 349;
    }
    if (pickedFields.size === 0 || pickedFields.has('level')) {
        result.level = overrides && overrides.hasOwnProperty('level') ? overrides.level! : 4238;
    }
    if (pickedFields.size === 0 || pickedFields.has('textStyle')) {
        result.textStyle = overrides && overrides.hasOwnProperty('textStyle') ? aWixRichContentV1TextStyleInput(overrides.textStyle ?? {}, pickedFields.get('textStyle')) : aWixRichContentV1TextStyleInput({}, pickedFields.get('textStyle'));
    }

    return result;
};

export const aWixRichContentV1ImageData = <T extends Partial<WixRichContentV1ImageData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('caption')) {
        result.caption = overrides && overrides.hasOwnProperty('caption') ? overrides.caption! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDownload')) {
        result.disableDownload = overrides && overrides.hasOwnProperty('disableDownload') ? overrides.disableDownload! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('disableExpand')) {
        result.disableExpand = overrides && overrides.hasOwnProperty('disableExpand') ? overrides.disableExpand! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1Media(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1Media({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aWixRichContentV1Link(overrides.link ?? {}, pickedFields.get('link')) : aWixRichContentV1Link({}, pickedFields.get('link'));
    }

    return result;
};

export const aWixRichContentV1ImageDataInput = <T extends Partial<WixRichContentV1ImageDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('caption')) {
        result.caption = overrides && overrides.hasOwnProperty('caption') ? overrides.caption! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('decorative')) {
        result.decorative = overrides && overrides.hasOwnProperty('decorative') ? overrides.decorative! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDownload')) {
        result.disableDownload = overrides && overrides.hasOwnProperty('disableDownload') ? overrides.disableDownload! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('disableExpand')) {
        result.disableExpand = overrides && overrides.hasOwnProperty('disableExpand') ? overrides.disableExpand! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1MediaInput(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1MediaInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aWixRichContentV1LinkInput(overrides.link ?? {}, pickedFields.get('link')) : aWixRichContentV1LinkInput({}, pickedFields.get('link'));
    }
    if (pickedFields.size === 0 || pickedFields.has('styles')) {
        result.styles = overrides && overrides.hasOwnProperty('styles') ? aWixRichContentV1ImageDataStylesInput(overrides.styles ?? {}, pickedFields.get('styles')) : aWixRichContentV1ImageDataStylesInput({}, pickedFields.get('styles'));
    }

    return result;
};

export const aWixRichContentV1ImageDataStyles = <T extends Partial<WixRichContentV1ImageDataStyles>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('border')) {
        result.border = overrides && overrides.hasOwnProperty('border') ? aWixRichContentV1ImageDataStylesBorder(overrides.border ?? {}, pickedFields.get('border')) : aWixRichContentV1ImageDataStylesBorder({}, pickedFields.get('border'));
    }

    return result;
};

export const aWixRichContentV1ImageDataStylesBorder = <T extends Partial<WixRichContentV1ImageDataStylesBorder>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('color')) {
        result.color = overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('radius')) {
        result.radius = overrides && overrides.hasOwnProperty('radius') ? overrides.radius! : 9808;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 5970;
    }

    return result;
};

export const aWixRichContentV1ImageDataStylesBorderInput = <T extends Partial<WixRichContentV1ImageDataStylesBorderInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('color')) {
        result.color = overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('radius')) {
        result.radius = overrides && overrides.hasOwnProperty('radius') ? overrides.radius! : 4826;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 1345;
    }

    return result;
};

export const aWixRichContentV1ImageDataStylesInput = <T extends Partial<WixRichContentV1ImageDataStylesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('border')) {
        result.border = overrides && overrides.hasOwnProperty('border') ? aWixRichContentV1ImageDataStylesBorderInput(overrides.border ?? {}, pickedFields.get('border')) : aWixRichContentV1ImageDataStylesBorderInput({}, pickedFields.get('border'));
    }

    return result;
};

export const aWixRichContentV1LayoutCellData = <T extends Partial<WixRichContentV1LayoutCellData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('colSpan')) {
        result.colSpan = overrides && overrides.hasOwnProperty('colSpan') ? overrides.colSpan! : 6973;
    }

    return result;
};

export const aWixRichContentV1LayoutCellDataInput = <T extends Partial<WixRichContentV1LayoutCellDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('colSpan')) {
        result.colSpan = overrides && overrides.hasOwnProperty('colSpan') ? overrides.colSpan! : 8832;
    }

    return result;
};

export const aWixRichContentV1Link = <T extends Partial<WixRichContentV1Link>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('anchor')) {
        result.anchor = overrides && overrides.hasOwnProperty('anchor') ? overrides.anchor! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('customData')) {
        result.customData = overrides && overrides.hasOwnProperty('customData') ? overrides.customData! : 'veritatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('rel')) {
        result.rel = overrides && overrides.hasOwnProperty('rel') ? aWixRichContentV1LinkRel(overrides.rel ?? {}, pickedFields.get('rel')) : aWixRichContentV1LinkRel({}, pickedFields.get('rel'));
    }
    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : WixRichContentV1LinkTarget.Blank;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'consequatur';
    }

    return result;
};

export const aWixRichContentV1LinkData = <T extends Partial<WixRichContentV1LinkData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aWixRichContentV1Link(overrides.link ?? {}, pickedFields.get('link')) : aWixRichContentV1Link({}, pickedFields.get('link'));
    }

    return result;
};

export const aWixRichContentV1LinkDataInput = <T extends Partial<WixRichContentV1LinkDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aWixRichContentV1LinkInput(overrides.link ?? {}, pickedFields.get('link')) : aWixRichContentV1LinkInput({}, pickedFields.get('link'));
    }

    return result;
};

export const aWixRichContentV1LinkInput = <T extends Partial<WixRichContentV1LinkInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('anchor')) {
        result.anchor = overrides && overrides.hasOwnProperty('anchor') ? overrides.anchor! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('customData')) {
        result.customData = overrides && overrides.hasOwnProperty('customData') ? overrides.customData! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('rel')) {
        result.rel = overrides && overrides.hasOwnProperty('rel') ? aWixRichContentV1LinkRelInput(overrides.rel ?? {}, pickedFields.get('rel')) : aWixRichContentV1LinkRelInput({}, pickedFields.get('rel'));
    }
    if (pickedFields.size === 0 || pickedFields.has('target')) {
        result.target = overrides && overrides.hasOwnProperty('target') ? overrides.target! : WixRichContentV1LinkTarget.Blank;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'ea';
    }

    return result;
};

export const aWixRichContentV1LinkPreviewData = <T extends Partial<WixRichContentV1LinkPreviewData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('html')) {
        result.html = overrides && overrides.hasOwnProperty('html') ? overrides.html! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aWixRichContentV1Link(overrides.link ?? {}, pickedFields.get('link')) : aWixRichContentV1Link({}, pickedFields.get('link'));
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnailUrl')) {
        result.thumbnailUrl = overrides && overrides.hasOwnProperty('thumbnailUrl') ? overrides.thumbnailUrl! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'eius';
    }

    return result;
};

export const aWixRichContentV1LinkPreviewDataInput = <T extends Partial<WixRichContentV1LinkPreviewDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('html')) {
        result.html = overrides && overrides.hasOwnProperty('html') ? overrides.html! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('link')) {
        result.link = overrides && overrides.hasOwnProperty('link') ? aWixRichContentV1LinkInput(overrides.link ?? {}, pickedFields.get('link')) : aWixRichContentV1LinkInput({}, pickedFields.get('link'));
    }
    if (pickedFields.size === 0 || pickedFields.has('styles')) {
        result.styles = overrides && overrides.hasOwnProperty('styles') ? aWixRichContentV1LinkPreviewDataStylesInput(overrides.styles ?? {}, pickedFields.get('styles')) : aWixRichContentV1LinkPreviewDataStylesInput({}, pickedFields.get('styles'));
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnailUrl')) {
        result.thumbnailUrl = overrides && overrides.hasOwnProperty('thumbnailUrl') ? overrides.thumbnailUrl! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'quo';
    }

    return result;
};

export const aWixRichContentV1LinkPreviewDataStyles = <T extends Partial<WixRichContentV1LinkPreviewDataStyles>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('backgroundColor')) {
        result.backgroundColor = overrides && overrides.hasOwnProperty('backgroundColor') ? overrides.backgroundColor! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('borderColor')) {
        result.borderColor = overrides && overrides.hasOwnProperty('borderColor') ? overrides.borderColor! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('borderRadius')) {
        result.borderRadius = overrides && overrides.hasOwnProperty('borderRadius') ? overrides.borderRadius! : 2273;
    }
    if (pickedFields.size === 0 || pickedFields.has('borderWidth')) {
        result.borderWidth = overrides && overrides.hasOwnProperty('borderWidth') ? overrides.borderWidth! : 6051;
    }
    if (pickedFields.size === 0 || pickedFields.has('linkColor')) {
        result.linkColor = overrides && overrides.hasOwnProperty('linkColor') ? overrides.linkColor! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('subtitleColor')) {
        result.subtitleColor = overrides && overrides.hasOwnProperty('subtitleColor') ? overrides.subtitleColor! : 'reprehenderit';
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnailPosition')) {
        result.thumbnailPosition = overrides && overrides.hasOwnProperty('thumbnailPosition') ? overrides.thumbnailPosition! : WixRichContentV1LinkPreviewDataStylesPosition.End;
    }
    if (pickedFields.size === 0 || pickedFields.has('titleColor')) {
        result.titleColor = overrides && overrides.hasOwnProperty('titleColor') ? overrides.titleColor! : 'explicabo';
    }

    return result;
};

export const aWixRichContentV1LinkPreviewDataStylesInput = <T extends Partial<WixRichContentV1LinkPreviewDataStylesInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('backgroundColor')) {
        result.backgroundColor = overrides && overrides.hasOwnProperty('backgroundColor') ? overrides.backgroundColor! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('borderColor')) {
        result.borderColor = overrides && overrides.hasOwnProperty('borderColor') ? overrides.borderColor! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('borderRadius')) {
        result.borderRadius = overrides && overrides.hasOwnProperty('borderRadius') ? overrides.borderRadius! : 6518;
    }
    if (pickedFields.size === 0 || pickedFields.has('borderWidth')) {
        result.borderWidth = overrides && overrides.hasOwnProperty('borderWidth') ? overrides.borderWidth! : 3458;
    }
    if (pickedFields.size === 0 || pickedFields.has('linkColor')) {
        result.linkColor = overrides && overrides.hasOwnProperty('linkColor') ? overrides.linkColor! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('subtitleColor')) {
        result.subtitleColor = overrides && overrides.hasOwnProperty('subtitleColor') ? overrides.subtitleColor! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnailPosition')) {
        result.thumbnailPosition = overrides && overrides.hasOwnProperty('thumbnailPosition') ? overrides.thumbnailPosition! : WixRichContentV1LinkPreviewDataStylesPosition.End;
    }
    if (pickedFields.size === 0 || pickedFields.has('titleColor')) {
        result.titleColor = overrides && overrides.hasOwnProperty('titleColor') ? overrides.titleColor! : 'ex';
    }

    return result;
};

export const aWixRichContentV1LinkRel = <T extends Partial<WixRichContentV1LinkRel>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nofollow')) {
        result.nofollow = overrides && overrides.hasOwnProperty('nofollow') ? overrides.nofollow! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('noreferrer')) {
        result.noreferrer = overrides && overrides.hasOwnProperty('noreferrer') ? overrides.noreferrer! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('sponsored')) {
        result.sponsored = overrides && overrides.hasOwnProperty('sponsored') ? overrides.sponsored! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('ugc')) {
        result.ugc = overrides && overrides.hasOwnProperty('ugc') ? overrides.ugc! : false;
    }

    return result;
};

export const aWixRichContentV1LinkRelInput = <T extends Partial<WixRichContentV1LinkRelInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('nofollow')) {
        result.nofollow = overrides && overrides.hasOwnProperty('nofollow') ? overrides.nofollow! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('noreferrer')) {
        result.noreferrer = overrides && overrides.hasOwnProperty('noreferrer') ? overrides.noreferrer! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('sponsored')) {
        result.sponsored = overrides && overrides.hasOwnProperty('sponsored') ? overrides.sponsored! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('ugc')) {
        result.ugc = overrides && overrides.hasOwnProperty('ugc') ? overrides.ugc! : true;
    }

    return result;
};

export const aWixRichContentV1ListValue = <T extends Partial<WixRichContentV1ListValue>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values!.map((x) => aWixRichContentV1Value(x ?? {}, pickedFields.get('values'))) : [aWixRichContentV1Value({}, pickedFields.get('values'))];
    }

    return result;
};

export const aWixRichContentV1ListValueInput = <T extends Partial<WixRichContentV1ListValueInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('values')) {
        result.values = overrides && overrides.hasOwnProperty('values') ? overrides.values!.map((x) => aWixRichContentV1ValueInput({}, pickedFields.get('values'))) : [aWixRichContentV1ValueInput({}, pickedFields.get('values'))];
    }

    return result;
};

export const aWixRichContentV1MapData = <T extends Partial<WixRichContentV1MapData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mapSettings')) {
        result.mapSettings = overrides && overrides.hasOwnProperty('mapSettings') ? aWixRichContentV1MapSettings(overrides.mapSettings ?? {}, pickedFields.get('mapSettings')) : aWixRichContentV1MapSettings({}, pickedFields.get('mapSettings'));
    }

    return result;
};

export const aWixRichContentV1MapDataInput = <T extends Partial<WixRichContentV1MapDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mapSettings')) {
        result.mapSettings = overrides && overrides.hasOwnProperty('mapSettings') ? aWixRichContentV1MapSettingsInput(overrides.mapSettings ?? {}, pickedFields.get('mapSettings')) : aWixRichContentV1MapSettingsInput({}, pickedFields.get('mapSettings'));
    }

    return result;
};

export const aWixRichContentV1MapSettings = <T extends Partial<WixRichContentV1MapSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? overrides.address! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('draggable')) {
        result.draggable = overrides && overrides.hasOwnProperty('draggable') ? overrides.draggable! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('initialZoom')) {
        result.initialZoom = overrides && overrides.hasOwnProperty('initialZoom') ? overrides.initialZoom! : 9024;
    }
    if (pickedFields.size === 0 || pickedFields.has('lat')) {
        result.lat = overrides && overrides.hasOwnProperty('lat') ? overrides.lat! : 2.77;
    }
    if (pickedFields.size === 0 || pickedFields.has('lng')) {
        result.lng = overrides && overrides.hasOwnProperty('lng') ? overrides.lng! : 1.32;
    }
    if (pickedFields.size === 0 || pickedFields.has('locationName')) {
        result.locationName = overrides && overrides.hasOwnProperty('locationName') ? overrides.locationName! : 'cumque';
    }
    if (pickedFields.size === 0 || pickedFields.has('mapType')) {
        result.mapType = overrides && overrides.hasOwnProperty('mapType') ? overrides.mapType! : WixRichContentV1MapType.Hybrid;
    }
    if (pickedFields.size === 0 || pickedFields.has('marker')) {
        result.marker = overrides && overrides.hasOwnProperty('marker') ? overrides.marker! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('streetViewControl')) {
        result.streetViewControl = overrides && overrides.hasOwnProperty('streetViewControl') ? overrides.streetViewControl! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('viewModeControl')) {
        result.viewModeControl = overrides && overrides.hasOwnProperty('viewModeControl') ? overrides.viewModeControl! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('zoomControl')) {
        result.zoomControl = overrides && overrides.hasOwnProperty('zoomControl') ? overrides.zoomControl! : true;
    }

    return result;
};

export const aWixRichContentV1MapSettingsInput = <T extends Partial<WixRichContentV1MapSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? overrides.address! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('draggable')) {
        result.draggable = overrides && overrides.hasOwnProperty('draggable') ? overrides.draggable! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('initialZoom')) {
        result.initialZoom = overrides && overrides.hasOwnProperty('initialZoom') ? overrides.initialZoom! : 2471;
    }
    if (pickedFields.size === 0 || pickedFields.has('lat')) {
        result.lat = overrides && overrides.hasOwnProperty('lat') ? overrides.lat! : 8.92;
    }
    if (pickedFields.size === 0 || pickedFields.has('lng')) {
        result.lng = overrides && overrides.hasOwnProperty('lng') ? overrides.lng! : 2.27;
    }
    if (pickedFields.size === 0 || pickedFields.has('locationName')) {
        result.locationName = overrides && overrides.hasOwnProperty('locationName') ? overrides.locationName! : 'sapiente';
    }
    if (pickedFields.size === 0 || pickedFields.has('mapType')) {
        result.mapType = overrides && overrides.hasOwnProperty('mapType') ? overrides.mapType! : WixRichContentV1MapType.Hybrid;
    }
    if (pickedFields.size === 0 || pickedFields.has('marker')) {
        result.marker = overrides && overrides.hasOwnProperty('marker') ? overrides.marker! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('streetViewControl')) {
        result.streetViewControl = overrides && overrides.hasOwnProperty('streetViewControl') ? overrides.streetViewControl! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('viewModeControl')) {
        result.viewModeControl = overrides && overrides.hasOwnProperty('viewModeControl') ? overrides.viewModeControl! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('zoomControl')) {
        result.zoomControl = overrides && overrides.hasOwnProperty('zoomControl') ? overrides.zoomControl! : false;
    }

    return result;
};

export const aWixRichContentV1Media = <T extends Partial<WixRichContentV1Media>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('duration')) {
        result.duration = overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 6.23;
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 8865;
    }
    if (pickedFields.size === 0 || pickedFields.has('src')) {
        result.src = overrides && overrides.hasOwnProperty('src') ? aWixRichContentV1FileSource(overrides.src ?? {}, pickedFields.get('src')) : aWixRichContentV1FileSource({}, pickedFields.get('src'));
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 6880;
    }

    return result;
};

export const aWixRichContentV1MediaInput = <T extends Partial<WixRichContentV1MediaInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('duration')) {
        result.duration = overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 1.93;
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 6661;
    }
    if (pickedFields.size === 0 || pickedFields.has('src')) {
        result.src = overrides && overrides.hasOwnProperty('src') ? aWixRichContentV1FileSourceInput(overrides.src ?? {}, pickedFields.get('src')) : aWixRichContentV1FileSourceInput({}, pickedFields.get('src'));
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 7426;
    }

    return result;
};

export const aWixRichContentV1MentionData = <T extends Partial<WixRichContentV1MentionData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'natus';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'quia';
    }

    return result;
};

export const aWixRichContentV1MentionDataInput = <T extends Partial<WixRichContentV1MentionDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'officiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('slug')) {
        result.slug = overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'incidunt';
    }

    return result;
};

export const aWixRichContentV1Metadata = <T extends Partial<WixRichContentV1Metadata>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdTimestamp')) {
        result.createdTimestamp = overrides && overrides.hasOwnProperty('createdTimestamp') ? overrides.createdTimestamp! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedTimestamp')) {
        result.updatedTimestamp = overrides && overrides.hasOwnProperty('updatedTimestamp') ? overrides.updatedTimestamp! : 'adipisci';
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 9545;
    }

    return result;
};

export const aWixRichContentV1MetadataInput = <T extends Partial<WixRichContentV1MetadataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdTimestamp')) {
        result.createdTimestamp = overrides && overrides.hasOwnProperty('createdTimestamp') ? overrides.createdTimestamp! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedTimestamp')) {
        result.updatedTimestamp = overrides && overrides.hasOwnProperty('updatedTimestamp') ? overrides.updatedTimestamp! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 2898;
    }

    return result;
};

export const aWixRichContentV1Node = <T extends Partial<WixRichContentV1Node>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appEmbedData')) {
        result.appEmbedData = overrides && overrides.hasOwnProperty('appEmbedData') ? aWixRichContentV1AppEmbedData(overrides.appEmbedData ?? {}, pickedFields.get('appEmbedData')) : aWixRichContentV1AppEmbedData({}, pickedFields.get('appEmbedData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('audioData')) {
        result.audioData = overrides && overrides.hasOwnProperty('audioData') ? aWixRichContentV1AudioData(overrides.audioData ?? {}, pickedFields.get('audioData')) : aWixRichContentV1AudioData({}, pickedFields.get('audioData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('blockquoteData')) {
        result.blockquoteData = overrides && overrides.hasOwnProperty('blockquoteData') ? aWixRichContentV1BlockquoteData(overrides.blockquoteData ?? {}, pickedFields.get('blockquoteData')) : aWixRichContentV1BlockquoteData({}, pickedFields.get('blockquoteData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('bulletedListData')) {
        result.bulletedListData = overrides && overrides.hasOwnProperty('bulletedListData') ? aWixRichContentV1BulletedListData(overrides.bulletedListData ?? {}, pickedFields.get('bulletedListData')) : aWixRichContentV1BulletedListData({}, pickedFields.get('bulletedListData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('buttonData')) {
        result.buttonData = overrides && overrides.hasOwnProperty('buttonData') ? aWixRichContentV1ButtonData(overrides.buttonData ?? {}, pickedFields.get('buttonData')) : aWixRichContentV1ButtonData({}, pickedFields.get('buttonData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('captionData')) {
        result.captionData = overrides && overrides.hasOwnProperty('captionData') ? aWixRichContentV1CaptionData(overrides.captionData ?? {}, pickedFields.get('captionData')) : aWixRichContentV1CaptionData({}, pickedFields.get('captionData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('codeBlockData')) {
        result.codeBlockData = overrides && overrides.hasOwnProperty('codeBlockData') ? aWixRichContentV1CodeBlockData(overrides.codeBlockData ?? {}, pickedFields.get('codeBlockData')) : aWixRichContentV1CodeBlockData({}, pickedFields.get('codeBlockData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('collapsibleListData')) {
        result.collapsibleListData = overrides && overrides.hasOwnProperty('collapsibleListData') ? aWixRichContentV1CollapsibleListData(overrides.collapsibleListData ?? {}, pickedFields.get('collapsibleListData')) : aWixRichContentV1CollapsibleListData({}, pickedFields.get('collapsibleListData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dividerData')) {
        result.dividerData = overrides && overrides.hasOwnProperty('dividerData') ? aWixRichContentV1DividerData(overrides.dividerData ?? {}, pickedFields.get('dividerData')) : aWixRichContentV1DividerData({}, pickedFields.get('dividerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('embedData')) {
        result.embedData = overrides && overrides.hasOwnProperty('embedData') ? aWixRichContentV1EmbedData(overrides.embedData ?? {}, pickedFields.get('embedData')) : aWixRichContentV1EmbedData({}, pickedFields.get('embedData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalData')) {
        result.externalData = overrides && overrides.hasOwnProperty('externalData') ? aWixRichContentV1Struct(overrides.externalData ?? {}, pickedFields.get('externalData')) : aWixRichContentV1Struct({}, pickedFields.get('externalData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fileData')) {
        result.fileData = overrides && overrides.hasOwnProperty('fileData') ? aWixRichContentV1FileData(overrides.fileData ?? {}, pickedFields.get('fileData')) : aWixRichContentV1FileData({}, pickedFields.get('fileData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('galleryData')) {
        result.galleryData = overrides && overrides.hasOwnProperty('galleryData') ? aWixRichContentV1GalleryData(overrides.galleryData ?? {}, pickedFields.get('galleryData')) : aWixRichContentV1GalleryData({}, pickedFields.get('galleryData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('gifData')) {
        result.gifData = overrides && overrides.hasOwnProperty('gifData') ? aWixRichContentV1GifData(overrides.gifData ?? {}, pickedFields.get('gifData')) : aWixRichContentV1GifData({}, pickedFields.get('gifData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headingData')) {
        result.headingData = overrides && overrides.hasOwnProperty('headingData') ? aWixRichContentV1HeadingData(overrides.headingData ?? {}, pickedFields.get('headingData')) : aWixRichContentV1HeadingData({}, pickedFields.get('headingData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('htmlData')) {
        result.htmlData = overrides && overrides.hasOwnProperty('htmlData') ? aWixRichContentV1HtmlData(overrides.htmlData ?? {}, pickedFields.get('htmlData')) : aWixRichContentV1HtmlData({}, pickedFields.get('htmlData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('imageData')) {
        result.imageData = overrides && overrides.hasOwnProperty('imageData') ? aWixRichContentV1ImageData(overrides.imageData ?? {}, pickedFields.get('imageData')) : aWixRichContentV1ImageData({}, pickedFields.get('imageData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('layoutCellData')) {
        result.layoutCellData = overrides && overrides.hasOwnProperty('layoutCellData') ? aWixRichContentV1LayoutCellData(overrides.layoutCellData ?? {}, pickedFields.get('layoutCellData')) : aWixRichContentV1LayoutCellData({}, pickedFields.get('layoutCellData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('linkPreviewData')) {
        result.linkPreviewData = overrides && overrides.hasOwnProperty('linkPreviewData') ? aWixRichContentV1LinkPreviewData(overrides.linkPreviewData ?? {}, pickedFields.get('linkPreviewData')) : aWixRichContentV1LinkPreviewData({}, pickedFields.get('linkPreviewData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mapData')) {
        result.mapData = overrides && overrides.hasOwnProperty('mapData') ? aWixRichContentV1MapData(overrides.mapData ?? {}, pickedFields.get('mapData')) : aWixRichContentV1MapData({}, pickedFields.get('mapData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nodes')) {
        result.nodes = overrides && overrides.hasOwnProperty('nodes') ? overrides.nodes!.map((x) => aWixRichContentV1Node(x ?? {}, pickedFields.get('nodes'))) : [aWixRichContentV1Node({}, pickedFields.get('nodes'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderedListData')) {
        result.orderedListData = overrides && overrides.hasOwnProperty('orderedListData') ? aWixRichContentV1OrderedListData(overrides.orderedListData ?? {}, pickedFields.get('orderedListData')) : aWixRichContentV1OrderedListData({}, pickedFields.get('orderedListData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paragraphData')) {
        result.paragraphData = overrides && overrides.hasOwnProperty('paragraphData') ? aWixRichContentV1ParagraphData(overrides.paragraphData ?? {}, pickedFields.get('paragraphData')) : aWixRichContentV1ParagraphData({}, pickedFields.get('paragraphData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pollData')) {
        result.pollData = overrides && overrides.hasOwnProperty('pollData') ? aWixRichContentV1PollData(overrides.pollData ?? {}, pickedFields.get('pollData')) : aWixRichContentV1PollData({}, pickedFields.get('pollData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('style')) {
        result.style = overrides && overrides.hasOwnProperty('style') ? aWixRichContentV1NodeStyle(overrides.style ?? {}, pickedFields.get('style')) : aWixRichContentV1NodeStyle({}, pickedFields.get('style'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tableCellData')) {
        result.tableCellData = overrides && overrides.hasOwnProperty('tableCellData') ? aWixRichContentV1TableCellData(overrides.tableCellData ?? {}, pickedFields.get('tableCellData')) : aWixRichContentV1TableCellData({}, pickedFields.get('tableCellData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tableData')) {
        result.tableData = overrides && overrides.hasOwnProperty('tableData') ? aWixRichContentV1TableData(overrides.tableData ?? {}, pickedFields.get('tableData')) : aWixRichContentV1TableData({}, pickedFields.get('tableData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('textData')) {
        result.textData = overrides && overrides.hasOwnProperty('textData') ? aWixRichContentV1TextData(overrides.textData ?? {}, pickedFields.get('textData')) : aWixRichContentV1TextData({}, pickedFields.get('textData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1NodeType.AppEmbed;
    }
    if (pickedFields.size === 0 || pickedFields.has('videoData')) {
        result.videoData = overrides && overrides.hasOwnProperty('videoData') ? aWixRichContentV1VideoData(overrides.videoData ?? {}, pickedFields.get('videoData')) : aWixRichContentV1VideoData({}, pickedFields.get('videoData'));
    }

    return result;
};

export const aWixRichContentV1NodeInput = <T extends Partial<WixRichContentV1NodeInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appEmbedData')) {
        result.appEmbedData = overrides && overrides.hasOwnProperty('appEmbedData') ? aWixRichContentV1AppEmbedDataInput(overrides.appEmbedData ?? {}, pickedFields.get('appEmbedData')) : aWixRichContentV1AppEmbedDataInput({}, pickedFields.get('appEmbedData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('audioData')) {
        result.audioData = overrides && overrides.hasOwnProperty('audioData') ? aWixRichContentV1AudioDataInput(overrides.audioData ?? {}, pickedFields.get('audioData')) : aWixRichContentV1AudioDataInput({}, pickedFields.get('audioData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('blockquoteData')) {
        result.blockquoteData = overrides && overrides.hasOwnProperty('blockquoteData') ? aWixRichContentV1BlockquoteDataInput(overrides.blockquoteData ?? {}, pickedFields.get('blockquoteData')) : aWixRichContentV1BlockquoteDataInput({}, pickedFields.get('blockquoteData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('bulletedListData')) {
        result.bulletedListData = overrides && overrides.hasOwnProperty('bulletedListData') ? aWixRichContentV1BulletedListDataInput(overrides.bulletedListData ?? {}, pickedFields.get('bulletedListData')) : aWixRichContentV1BulletedListDataInput({}, pickedFields.get('bulletedListData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('buttonData')) {
        result.buttonData = overrides && overrides.hasOwnProperty('buttonData') ? aWixRichContentV1ButtonDataInput(overrides.buttonData ?? {}, pickedFields.get('buttonData')) : aWixRichContentV1ButtonDataInput({}, pickedFields.get('buttonData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('captionData')) {
        result.captionData = overrides && overrides.hasOwnProperty('captionData') ? aWixRichContentV1CaptionDataInput(overrides.captionData ?? {}, pickedFields.get('captionData')) : aWixRichContentV1CaptionDataInput({}, pickedFields.get('captionData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('codeBlockData')) {
        result.codeBlockData = overrides && overrides.hasOwnProperty('codeBlockData') ? aWixRichContentV1CodeBlockDataInput(overrides.codeBlockData ?? {}, pickedFields.get('codeBlockData')) : aWixRichContentV1CodeBlockDataInput({}, pickedFields.get('codeBlockData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('collapsibleListData')) {
        result.collapsibleListData = overrides && overrides.hasOwnProperty('collapsibleListData') ? aWixRichContentV1CollapsibleListDataInput(overrides.collapsibleListData ?? {}, pickedFields.get('collapsibleListData')) : aWixRichContentV1CollapsibleListDataInput({}, pickedFields.get('collapsibleListData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dividerData')) {
        result.dividerData = overrides && overrides.hasOwnProperty('dividerData') ? aWixRichContentV1DividerDataInput(overrides.dividerData ?? {}, pickedFields.get('dividerData')) : aWixRichContentV1DividerDataInput({}, pickedFields.get('dividerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('embedData')) {
        result.embedData = overrides && overrides.hasOwnProperty('embedData') ? aWixRichContentV1EmbedDataInput(overrides.embedData ?? {}, pickedFields.get('embedData')) : aWixRichContentV1EmbedDataInput({}, pickedFields.get('embedData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalData')) {
        result.externalData = overrides && overrides.hasOwnProperty('externalData') ? aWixRichContentV1StructInput(overrides.externalData ?? {}, pickedFields.get('externalData')) : aWixRichContentV1StructInput({}, pickedFields.get('externalData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fileData')) {
        result.fileData = overrides && overrides.hasOwnProperty('fileData') ? aWixRichContentV1FileDataInput(overrides.fileData ?? {}, pickedFields.get('fileData')) : aWixRichContentV1FileDataInput({}, pickedFields.get('fileData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('galleryData')) {
        result.galleryData = overrides && overrides.hasOwnProperty('galleryData') ? aWixRichContentV1GalleryDataInput(overrides.galleryData ?? {}, pickedFields.get('galleryData')) : aWixRichContentV1GalleryDataInput({}, pickedFields.get('galleryData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('gifData')) {
        result.gifData = overrides && overrides.hasOwnProperty('gifData') ? aWixRichContentV1GifDataInput(overrides.gifData ?? {}, pickedFields.get('gifData')) : aWixRichContentV1GifDataInput({}, pickedFields.get('gifData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('headingData')) {
        result.headingData = overrides && overrides.hasOwnProperty('headingData') ? aWixRichContentV1HeadingDataInput(overrides.headingData ?? {}, pickedFields.get('headingData')) : aWixRichContentV1HeadingDataInput({}, pickedFields.get('headingData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('htmlData')) {
        result.htmlData = overrides && overrides.hasOwnProperty('htmlData') ? aWixRichContentV1HtmlDataInput(overrides.htmlData ?? {}, pickedFields.get('htmlData')) : aWixRichContentV1HtmlDataInput({}, pickedFields.get('htmlData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('imageData')) {
        result.imageData = overrides && overrides.hasOwnProperty('imageData') ? aWixRichContentV1ImageDataInput(overrides.imageData ?? {}, pickedFields.get('imageData')) : aWixRichContentV1ImageDataInput({}, pickedFields.get('imageData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('layoutCellData')) {
        result.layoutCellData = overrides && overrides.hasOwnProperty('layoutCellData') ? aWixRichContentV1LayoutCellDataInput(overrides.layoutCellData ?? {}, pickedFields.get('layoutCellData')) : aWixRichContentV1LayoutCellDataInput({}, pickedFields.get('layoutCellData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('linkPreviewData')) {
        result.linkPreviewData = overrides && overrides.hasOwnProperty('linkPreviewData') ? aWixRichContentV1LinkPreviewDataInput(overrides.linkPreviewData ?? {}, pickedFields.get('linkPreviewData')) : aWixRichContentV1LinkPreviewDataInput({}, pickedFields.get('linkPreviewData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('mapData')) {
        result.mapData = overrides && overrides.hasOwnProperty('mapData') ? aWixRichContentV1MapDataInput(overrides.mapData ?? {}, pickedFields.get('mapData')) : aWixRichContentV1MapDataInput({}, pickedFields.get('mapData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nodes')) {
        result.nodes = overrides && overrides.hasOwnProperty('nodes') ? overrides.nodes!.map((x) => aWixRichContentV1NodeInput({}, pickedFields.get('nodes'))) : [aWixRichContentV1NodeInput({}, pickedFields.get('nodes'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('orderedListData')) {
        result.orderedListData = overrides && overrides.hasOwnProperty('orderedListData') ? aWixRichContentV1OrderedListDataInput(overrides.orderedListData ?? {}, pickedFields.get('orderedListData')) : aWixRichContentV1OrderedListDataInput({}, pickedFields.get('orderedListData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('paragraphData')) {
        result.paragraphData = overrides && overrides.hasOwnProperty('paragraphData') ? aWixRichContentV1ParagraphDataInput(overrides.paragraphData ?? {}, pickedFields.get('paragraphData')) : aWixRichContentV1ParagraphDataInput({}, pickedFields.get('paragraphData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pollData')) {
        result.pollData = overrides && overrides.hasOwnProperty('pollData') ? aWixRichContentV1PollDataInput(overrides.pollData ?? {}, pickedFields.get('pollData')) : aWixRichContentV1PollDataInput({}, pickedFields.get('pollData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('style')) {
        result.style = overrides && overrides.hasOwnProperty('style') ? aWixRichContentV1NodeStyleInput(overrides.style ?? {}, pickedFields.get('style')) : aWixRichContentV1NodeStyleInput({}, pickedFields.get('style'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tableCellData')) {
        result.tableCellData = overrides && overrides.hasOwnProperty('tableCellData') ? aWixRichContentV1TableCellDataInput(overrides.tableCellData ?? {}, pickedFields.get('tableCellData')) : aWixRichContentV1TableCellDataInput({}, pickedFields.get('tableCellData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tableData')) {
        result.tableData = overrides && overrides.hasOwnProperty('tableData') ? aWixRichContentV1TableDataInput(overrides.tableData ?? {}, pickedFields.get('tableData')) : aWixRichContentV1TableDataInput({}, pickedFields.get('tableData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('textData')) {
        result.textData = overrides && overrides.hasOwnProperty('textData') ? aWixRichContentV1TextDataInput(overrides.textData ?? {}, pickedFields.get('textData')) : aWixRichContentV1TextDataInput({}, pickedFields.get('textData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1NodeType.AppEmbed;
    }
    if (pickedFields.size === 0 || pickedFields.has('videoData')) {
        result.videoData = overrides && overrides.hasOwnProperty('videoData') ? aWixRichContentV1VideoDataInput(overrides.videoData ?? {}, pickedFields.get('videoData')) : aWixRichContentV1VideoDataInput({}, pickedFields.get('videoData'));
    }

    return result;
};

export const aWixRichContentV1NodeStyle = <T extends Partial<WixRichContentV1NodeStyle>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('backgroundColor')) {
        result.backgroundColor = overrides && overrides.hasOwnProperty('backgroundColor') ? overrides.backgroundColor! : 'neque';
    }
    if (pickedFields.size === 0 || pickedFields.has('paddingBottom')) {
        result.paddingBottom = overrides && overrides.hasOwnProperty('paddingBottom') ? overrides.paddingBottom! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('paddingTop')) {
        result.paddingTop = overrides && overrides.hasOwnProperty('paddingTop') ? overrides.paddingTop! : 'voluptate';
    }

    return result;
};

export const aWixRichContentV1NodeStyleInput = <T extends Partial<WixRichContentV1NodeStyleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('backgroundColor')) {
        result.backgroundColor = overrides && overrides.hasOwnProperty('backgroundColor') ? overrides.backgroundColor! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('paddingBottom')) {
        result.paddingBottom = overrides && overrides.hasOwnProperty('paddingBottom') ? overrides.paddingBottom! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('paddingTop')) {
        result.paddingTop = overrides && overrides.hasOwnProperty('paddingTop') ? overrides.paddingTop! : 'alias';
    }

    return result;
};

export const aWixRichContentV1Oembed = <T extends Partial<WixRichContentV1Oembed>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorName')) {
        result.authorName = overrides && overrides.hasOwnProperty('authorName') ? overrides.authorName! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('authorUrl')) {
        result.authorUrl = overrides && overrides.hasOwnProperty('authorUrl') ? overrides.authorUrl! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 9015;
    }
    if (pickedFields.size === 0 || pickedFields.has('html')) {
        result.html = overrides && overrides.hasOwnProperty('html') ? overrides.html! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerName')) {
        result.providerName = overrides && overrides.hasOwnProperty('providerName') ? overrides.providerName! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerUrl')) {
        result.providerUrl = overrides && overrides.hasOwnProperty('providerUrl') ? overrides.providerUrl! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnailHeight')) {
        result.thumbnailHeight = overrides && overrides.hasOwnProperty('thumbnailHeight') ? overrides.thumbnailHeight! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnailUrl')) {
        result.thumbnailUrl = overrides && overrides.hasOwnProperty('thumbnailUrl') ? overrides.thumbnailUrl! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnailWidth')) {
        result.thumbnailWidth = overrides && overrides.hasOwnProperty('thumbnailWidth') ? overrides.thumbnailWidth! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 'autem';
    }
    if (pickedFields.size === 0 || pickedFields.has('videoUrl')) {
        result.videoUrl = overrides && overrides.hasOwnProperty('videoUrl') ? overrides.videoUrl! : 'soluta';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 2527;
    }

    return result;
};

export const aWixRichContentV1OembedInput = <T extends Partial<WixRichContentV1OembedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('authorName')) {
        result.authorName = overrides && overrides.hasOwnProperty('authorName') ? overrides.authorName! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('authorUrl')) {
        result.authorUrl = overrides && overrides.hasOwnProperty('authorUrl') ? overrides.authorUrl! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 656;
    }
    if (pickedFields.size === 0 || pickedFields.has('html')) {
        result.html = overrides && overrides.hasOwnProperty('html') ? overrides.html! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerName')) {
        result.providerName = overrides && overrides.hasOwnProperty('providerName') ? overrides.providerName! : 'modi';
    }
    if (pickedFields.size === 0 || pickedFields.has('providerUrl')) {
        result.providerUrl = overrides && overrides.hasOwnProperty('providerUrl') ? overrides.providerUrl! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnailHeight')) {
        result.thumbnailHeight = overrides && overrides.hasOwnProperty('thumbnailHeight') ? overrides.thumbnailHeight! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnailUrl')) {
        result.thumbnailUrl = overrides && overrides.hasOwnProperty('thumbnailUrl') ? overrides.thumbnailUrl! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnailWidth')) {
        result.thumbnailWidth = overrides && overrides.hasOwnProperty('thumbnailWidth') ? overrides.thumbnailWidth! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('version')) {
        result.version = overrides && overrides.hasOwnProperty('version') ? overrides.version! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('videoUrl')) {
        result.videoUrl = overrides && overrides.hasOwnProperty('videoUrl') ? overrides.videoUrl! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 1102;
    }

    return result;
};

export const aWixRichContentV1OrderedListData = <T extends Partial<WixRichContentV1OrderedListData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('indentation')) {
        result.indentation = overrides && overrides.hasOwnProperty('indentation') ? overrides.indentation! : 2030;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 9342;
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? overrides.start! : 4235;
    }

    return result;
};

export const aWixRichContentV1OrderedListDataInput = <T extends Partial<WixRichContentV1OrderedListDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('indentation')) {
        result.indentation = overrides && overrides.hasOwnProperty('indentation') ? overrides.indentation! : 6742;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 4697;
    }
    if (pickedFields.size === 0 || pickedFields.has('start')) {
        result.start = overrides && overrides.hasOwnProperty('start') ? overrides.start! : 673;
    }

    return result;
};

export const aWixRichContentV1ParagraphData = <T extends Partial<WixRichContentV1ParagraphData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('indentation')) {
        result.indentation = overrides && overrides.hasOwnProperty('indentation') ? overrides.indentation! : 9660;
    }
    if (pickedFields.size === 0 || pickedFields.has('level')) {
        result.level = overrides && overrides.hasOwnProperty('level') ? overrides.level! : 1572;
    }
    if (pickedFields.size === 0 || pickedFields.has('textStyle')) {
        result.textStyle = overrides && overrides.hasOwnProperty('textStyle') ? aWixRichContentV1TextStyle(overrides.textStyle ?? {}, pickedFields.get('textStyle')) : aWixRichContentV1TextStyle({}, pickedFields.get('textStyle'));
    }

    return result;
};

export const aWixRichContentV1ParagraphDataInput = <T extends Partial<WixRichContentV1ParagraphDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('indentation')) {
        result.indentation = overrides && overrides.hasOwnProperty('indentation') ? overrides.indentation! : 781;
    }
    if (pickedFields.size === 0 || pickedFields.has('level')) {
        result.level = overrides && overrides.hasOwnProperty('level') ? overrides.level! : 5703;
    }
    if (pickedFields.size === 0 || pickedFields.has('textStyle')) {
        result.textStyle = overrides && overrides.hasOwnProperty('textStyle') ? aWixRichContentV1TextStyleInput(overrides.textStyle ?? {}, pickedFields.get('textStyle')) : aWixRichContentV1TextStyleInput({}, pickedFields.get('textStyle'));
    }

    return result;
};

export const aWixRichContentV1PlaybackOptions = <T extends Partial<WixRichContentV1PlaybackOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoPlay')) {
        result.autoPlay = overrides && overrides.hasOwnProperty('autoPlay') ? overrides.autoPlay! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('playInLoop')) {
        result.playInLoop = overrides && overrides.hasOwnProperty('playInLoop') ? overrides.playInLoop! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('showControls')) {
        result.showControls = overrides && overrides.hasOwnProperty('showControls') ? overrides.showControls! : false;
    }

    return result;
};

export const aWixRichContentV1PlaybackOptionsInput = <T extends Partial<WixRichContentV1PlaybackOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('autoPlay')) {
        result.autoPlay = overrides && overrides.hasOwnProperty('autoPlay') ? overrides.autoPlay! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('playInLoop')) {
        result.playInLoop = overrides && overrides.hasOwnProperty('playInLoop') ? overrides.playInLoop! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('showControls')) {
        result.showControls = overrides && overrides.hasOwnProperty('showControls') ? overrides.showControls! : true;
    }

    return result;
};

export const aWixRichContentV1PluginContainerData = <T extends Partial<WixRichContentV1PluginContainerData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('alignment')) {
        result.alignment = overrides && overrides.hasOwnProperty('alignment') ? overrides.alignment! : WixRichContentV1PluginContainerDataAlignment.Center;
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? aWixRichContentV1PluginContainerDataHeight(overrides.height ?? {}, pickedFields.get('height')) : aWixRichContentV1PluginContainerDataHeight({}, pickedFields.get('height'));
    }
    if (pickedFields.size === 0 || pickedFields.has('spoiler')) {
        result.spoiler = overrides && overrides.hasOwnProperty('spoiler') ? aWixRichContentV1PluginContainerDataSpoiler(overrides.spoiler ?? {}, pickedFields.get('spoiler')) : aWixRichContentV1PluginContainerDataSpoiler({}, pickedFields.get('spoiler'));
    }
    if (pickedFields.size === 0 || pickedFields.has('textWrap')) {
        result.textWrap = overrides && overrides.hasOwnProperty('textWrap') ? overrides.textWrap! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? aWixRichContentV1PluginContainerDataWidth(overrides.width ?? {}, pickedFields.get('width')) : aWixRichContentV1PluginContainerDataWidth({}, pickedFields.get('width'));
    }

    return result;
};

export const aWixRichContentV1PluginContainerDataHeight = <T extends Partial<WixRichContentV1PluginContainerDataHeight>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : 'veritatis';
    }

    return result;
};

export const aWixRichContentV1PluginContainerDataHeightInput = <T extends Partial<WixRichContentV1PluginContainerDataHeightInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : 'est';
    }

    return result;
};

export const aWixRichContentV1PluginContainerDataInput = <T extends Partial<WixRichContentV1PluginContainerDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('alignment')) {
        result.alignment = overrides && overrides.hasOwnProperty('alignment') ? overrides.alignment! : WixRichContentV1PluginContainerDataAlignment.Center;
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? aWixRichContentV1PluginContainerDataHeightInput(overrides.height ?? {}, pickedFields.get('height')) : aWixRichContentV1PluginContainerDataHeightInput({}, pickedFields.get('height'));
    }
    if (pickedFields.size === 0 || pickedFields.has('spoiler')) {
        result.spoiler = overrides && overrides.hasOwnProperty('spoiler') ? aWixRichContentV1PluginContainerDataSpoilerInput(overrides.spoiler ?? {}, pickedFields.get('spoiler')) : aWixRichContentV1PluginContainerDataSpoilerInput({}, pickedFields.get('spoiler'));
    }
    if (pickedFields.size === 0 || pickedFields.has('textWrap')) {
        result.textWrap = overrides && overrides.hasOwnProperty('textWrap') ? overrides.textWrap! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? aWixRichContentV1PluginContainerDataWidthInput(overrides.width ?? {}, pickedFields.get('width')) : aWixRichContentV1PluginContainerDataWidthInput({}, pickedFields.get('width'));
    }

    return result;
};

export const aWixRichContentV1PluginContainerDataSpoiler = <T extends Partial<WixRichContentV1PluginContainerDataSpoiler>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buttonText')) {
        result.buttonText = overrides && overrides.hasOwnProperty('buttonText') ? overrides.buttonText! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixRichContentV1PluginContainerDataSpoilerInput = <T extends Partial<WixRichContentV1PluginContainerDataSpoilerInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buttonText')) {
        result.buttonText = overrides && overrides.hasOwnProperty('buttonText') ? overrides.buttonText! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'illo';
    }
    if (pickedFields.size === 0 || pickedFields.has('enabled')) {
        result.enabled = overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true;
    }

    return result;
};

export const aWixRichContentV1PluginContainerDataWidth = <T extends Partial<WixRichContentV1PluginContainerDataWidth>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('size')) {
        result.size = overrides && overrides.hasOwnProperty('size') ? overrides.size! : WixRichContentV1PluginContainerDataWidthType.Content;
    }

    return result;
};

export const aWixRichContentV1PluginContainerDataWidthInput = <T extends Partial<WixRichContentV1PluginContainerDataWidthInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('custom')) {
        result.custom = overrides && overrides.hasOwnProperty('custom') ? overrides.custom! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('size')) {
        result.size = overrides && overrides.hasOwnProperty('size') ? overrides.size! : WixRichContentV1PluginContainerDataWidthType.Content;
    }

    return result;
};

export const aWixRichContentV1PollData = <T extends Partial<WixRichContentV1PollData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('design')) {
        result.design = overrides && overrides.hasOwnProperty('design') ? aWixRichContentV1PollDataDesign(overrides.design ?? {}, pickedFields.get('design')) : aWixRichContentV1PollDataDesign({}, pickedFields.get('design'));
    }
    if (pickedFields.size === 0 || pickedFields.has('layout')) {
        result.layout = overrides && overrides.hasOwnProperty('layout') ? aWixRichContentV1PollDataLayout(overrides.layout ?? {}, pickedFields.get('layout')) : aWixRichContentV1PollDataLayout({}, pickedFields.get('layout'));
    }
    if (pickedFields.size === 0 || pickedFields.has('poll')) {
        result.poll = overrides && overrides.hasOwnProperty('poll') ? aWixRichContentV1PollDataPoll(overrides.poll ?? {}, pickedFields.get('poll')) : aWixRichContentV1PollDataPoll({}, pickedFields.get('poll'));
    }

    return result;
};

export const aWixRichContentV1PollDataDesign = <T extends Partial<WixRichContentV1PollDataDesign>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixRichContentV1PollDataDesignOptionDesign(overrides.options ?? {}, pickedFields.get('options')) : aWixRichContentV1PollDataDesignOptionDesign({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('poll')) {
        result.poll = overrides && overrides.hasOwnProperty('poll') ? aWixRichContentV1PollDataDesignPollDesign(overrides.poll ?? {}, pickedFields.get('poll')) : aWixRichContentV1PollDataDesignPollDesign({}, pickedFields.get('poll'));
    }

    return result;
};

export const aWixRichContentV1PollDataDesignInput = <T extends Partial<WixRichContentV1PollDataDesignInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixRichContentV1PollDataDesignOptionDesignInput(overrides.options ?? {}, pickedFields.get('options')) : aWixRichContentV1PollDataDesignOptionDesignInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('poll')) {
        result.poll = overrides && overrides.hasOwnProperty('poll') ? aWixRichContentV1PollDataDesignPollDesignInput(overrides.poll ?? {}, pickedFields.get('poll')) : aWixRichContentV1PollDataDesignPollDesignInput({}, pickedFields.get('poll'));
    }

    return result;
};

export const aWixRichContentV1PollDataDesignOptionDesign = <T extends Partial<WixRichContentV1PollDataDesignOptionDesign>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('borderRadius')) {
        result.borderRadius = overrides && overrides.hasOwnProperty('borderRadius') ? overrides.borderRadius! : 7826;
    }

    return result;
};

export const aWixRichContentV1PollDataDesignOptionDesignInput = <T extends Partial<WixRichContentV1PollDataDesignOptionDesignInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('borderRadius')) {
        result.borderRadius = overrides && overrides.hasOwnProperty('borderRadius') ? overrides.borderRadius! : 237;
    }

    return result;
};

export const aWixRichContentV1PollDataDesignPollDesign = <T extends Partial<WixRichContentV1PollDataDesignPollDesign>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('background')) {
        result.background = overrides && overrides.hasOwnProperty('background') ? aWixRichContentV1PollDataDesignPollDesignBackground(overrides.background ?? {}, pickedFields.get('background')) : aWixRichContentV1PollDataDesignPollDesignBackground({}, pickedFields.get('background'));
    }
    if (pickedFields.size === 0 || pickedFields.has('borderRadius')) {
        result.borderRadius = overrides && overrides.hasOwnProperty('borderRadius') ? overrides.borderRadius! : 8683;
    }

    return result;
};

export const aWixRichContentV1PollDataDesignPollDesignBackground = <T extends Partial<WixRichContentV1PollDataDesignPollDesignBackground>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('color')) {
        result.color = overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'consequatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('gradient')) {
        result.gradient = overrides && overrides.hasOwnProperty('gradient') ? aWixRichContentV1PollDataDesignPollDesignBackgroundGradient(overrides.gradient ?? {}, pickedFields.get('gradient')) : aWixRichContentV1PollDataDesignPollDesignBackgroundGradient({}, pickedFields.get('gradient'));
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1Media(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1Media({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1PollDataDesignPollDesignBackgroundType.Color;
    }

    return result;
};

export const aWixRichContentV1PollDataDesignPollDesignBackgroundGradient = <T extends Partial<WixRichContentV1PollDataDesignPollDesignBackgroundGradient>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('angle')) {
        result.angle = overrides && overrides.hasOwnProperty('angle') ? overrides.angle! : 1872;
    }
    if (pickedFields.size === 0 || pickedFields.has('lastColor')) {
        result.lastColor = overrides && overrides.hasOwnProperty('lastColor') ? overrides.lastColor! : 'at';
    }
    if (pickedFields.size === 0 || pickedFields.has('startColor')) {
        result.startColor = overrides && overrides.hasOwnProperty('startColor') ? overrides.startColor! : 'qui';
    }

    return result;
};

export const aWixRichContentV1PollDataDesignPollDesignBackgroundGradientInput = <T extends Partial<WixRichContentV1PollDataDesignPollDesignBackgroundGradientInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('angle')) {
        result.angle = overrides && overrides.hasOwnProperty('angle') ? overrides.angle! : 5425;
    }
    if (pickedFields.size === 0 || pickedFields.has('lastColor')) {
        result.lastColor = overrides && overrides.hasOwnProperty('lastColor') ? overrides.lastColor! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('startColor')) {
        result.startColor = overrides && overrides.hasOwnProperty('startColor') ? overrides.startColor! : 'occaecati';
    }

    return result;
};

export const aWixRichContentV1PollDataDesignPollDesignBackgroundInput = <T extends Partial<WixRichContentV1PollDataDesignPollDesignBackgroundInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('color')) {
        result.color = overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'expedita';
    }
    if (pickedFields.size === 0 || pickedFields.has('gradient')) {
        result.gradient = overrides && overrides.hasOwnProperty('gradient') ? aWixRichContentV1PollDataDesignPollDesignBackgroundGradientInput(overrides.gradient ?? {}, pickedFields.get('gradient')) : aWixRichContentV1PollDataDesignPollDesignBackgroundGradientInput({}, pickedFields.get('gradient'));
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1MediaInput(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1MediaInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1PollDataDesignPollDesignBackgroundType.Color;
    }

    return result;
};

export const aWixRichContentV1PollDataDesignPollDesignInput = <T extends Partial<WixRichContentV1PollDataDesignPollDesignInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('background')) {
        result.background = overrides && overrides.hasOwnProperty('background') ? aWixRichContentV1PollDataDesignPollDesignBackgroundInput(overrides.background ?? {}, pickedFields.get('background')) : aWixRichContentV1PollDataDesignPollDesignBackgroundInput({}, pickedFields.get('background'));
    }
    if (pickedFields.size === 0 || pickedFields.has('borderRadius')) {
        result.borderRadius = overrides && overrides.hasOwnProperty('borderRadius') ? overrides.borderRadius! : 6425;
    }

    return result;
};

export const aWixRichContentV1PollDataInput = <T extends Partial<WixRichContentV1PollDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('design')) {
        result.design = overrides && overrides.hasOwnProperty('design') ? aWixRichContentV1PollDataDesignInput(overrides.design ?? {}, pickedFields.get('design')) : aWixRichContentV1PollDataDesignInput({}, pickedFields.get('design'));
    }
    if (pickedFields.size === 0 || pickedFields.has('layout')) {
        result.layout = overrides && overrides.hasOwnProperty('layout') ? aWixRichContentV1PollDataLayoutInput(overrides.layout ?? {}, pickedFields.get('layout')) : aWixRichContentV1PollDataLayoutInput({}, pickedFields.get('layout'));
    }
    if (pickedFields.size === 0 || pickedFields.has('poll')) {
        result.poll = overrides && overrides.hasOwnProperty('poll') ? aWixRichContentV1PollDataPollInput(overrides.poll ?? {}, pickedFields.get('poll')) : aWixRichContentV1PollDataPollInput({}, pickedFields.get('poll'));
    }

    return result;
};

export const aWixRichContentV1PollDataLayout = <T extends Partial<WixRichContentV1PollDataLayout>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixRichContentV1PollDataLayoutOptionLayout(overrides.options ?? {}, pickedFields.get('options')) : aWixRichContentV1PollDataLayoutOptionLayout({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('poll')) {
        result.poll = overrides && overrides.hasOwnProperty('poll') ? aWixRichContentV1PollDataLayoutPollLayout(overrides.poll ?? {}, pickedFields.get('poll')) : aWixRichContentV1PollDataLayoutPollLayout({}, pickedFields.get('poll'));
    }

    return result;
};

export const aWixRichContentV1PollDataLayoutInput = <T extends Partial<WixRichContentV1PollDataLayoutInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixRichContentV1PollDataLayoutOptionLayoutInput(overrides.options ?? {}, pickedFields.get('options')) : aWixRichContentV1PollDataLayoutOptionLayoutInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('poll')) {
        result.poll = overrides && overrides.hasOwnProperty('poll') ? aWixRichContentV1PollDataLayoutPollLayoutInput(overrides.poll ?? {}, pickedFields.get('poll')) : aWixRichContentV1PollDataLayoutPollLayoutInput({}, pickedFields.get('poll'));
    }

    return result;
};

export const aWixRichContentV1PollDataLayoutOptionLayout = <T extends Partial<WixRichContentV1PollDataLayoutOptionLayout>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enableImage')) {
        result.enableImage = overrides && overrides.hasOwnProperty('enableImage') ? overrides.enableImage! : false;
    }

    return result;
};

export const aWixRichContentV1PollDataLayoutOptionLayoutInput = <T extends Partial<WixRichContentV1PollDataLayoutOptionLayoutInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('enableImage')) {
        result.enableImage = overrides && overrides.hasOwnProperty('enableImage') ? overrides.enableImage! : true;
    }

    return result;
};

export const aWixRichContentV1PollDataLayoutPollLayout = <T extends Partial<WixRichContentV1PollDataLayoutPollLayout>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('direction')) {
        result.direction = overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : WixRichContentV1PollDataLayoutPollLayoutDirection.Ltr;
    }
    if (pickedFields.size === 0 || pickedFields.has('enableImage')) {
        result.enableImage = overrides && overrides.hasOwnProperty('enableImage') ? overrides.enableImage! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1PollDataLayoutPollLayoutType.Grid;
    }

    return result;
};

export const aWixRichContentV1PollDataLayoutPollLayoutInput = <T extends Partial<WixRichContentV1PollDataLayoutPollLayoutInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('direction')) {
        result.direction = overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : WixRichContentV1PollDataLayoutPollLayoutDirection.Ltr;
    }
    if (pickedFields.size === 0 || pickedFields.has('enableImage')) {
        result.enableImage = overrides && overrides.hasOwnProperty('enableImage') ? overrides.enableImage! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRichContentV1PollDataLayoutPollLayoutType.Grid;
    }

    return result;
};

export const aWixRichContentV1PollDataPoll = <T extends Partial<WixRichContentV1PollDataPoll>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('creatorId')) {
        result.creatorId = overrides && overrides.hasOwnProperty('creatorId') ? overrides.creatorId! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1Media(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1Media({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options!.map((x) => aWixRichContentV1PollDataPollOption(x ?? {}, pickedFields.get('options'))) : [aWixRichContentV1PollDataPollOption({}, pickedFields.get('options'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('settings')) {
        result.settings = overrides && overrides.hasOwnProperty('settings') ? aWixRichContentV1PollDataPollSettings(overrides.settings ?? {}, pickedFields.get('settings')) : aWixRichContentV1PollDataPollSettings({}, pickedFields.get('settings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'autem';
    }

    return result;
};

export const aWixRichContentV1PollDataPollInput = <T extends Partial<WixRichContentV1PollDataPollInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('creatorId')) {
        result.creatorId = overrides && overrides.hasOwnProperty('creatorId') ? overrides.creatorId! : 'architecto';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'iure';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1MediaInput(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1MediaInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options!.map((x) => aWixRichContentV1PollDataPollOptionInput({}, pickedFields.get('options'))) : [aWixRichContentV1PollDataPollOptionInput({}, pickedFields.get('options'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('settings')) {
        result.settings = overrides && overrides.hasOwnProperty('settings') ? aWixRichContentV1PollDataPollSettingsInput(overrides.settings ?? {}, pickedFields.get('settings')) : aWixRichContentV1PollDataPollSettingsInput({}, pickedFields.get('settings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'sed';
    }

    return result;
};

export const aWixRichContentV1PollDataPollOption = <T extends Partial<WixRichContentV1PollDataPollOption>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1Media(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1Media({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'quis';
    }

    return result;
};

export const aWixRichContentV1PollDataPollOptionInput = <T extends Partial<WixRichContentV1PollDataPollOptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('image')) {
        result.image = overrides && overrides.hasOwnProperty('image') ? aWixRichContentV1MediaInput(overrides.image ?? {}, pickedFields.get('image')) : aWixRichContentV1MediaInput({}, pickedFields.get('image'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'cumque';
    }

    return result;
};

export const aWixRichContentV1PollDataPollSettings = <T extends Partial<WixRichContentV1PollDataPollSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('permissions')) {
        result.permissions = overrides && overrides.hasOwnProperty('permissions') ? aWixRichContentV1PollDataPollSettingsPermissions(overrides.permissions ?? {}, pickedFields.get('permissions')) : aWixRichContentV1PollDataPollSettingsPermissions({}, pickedFields.get('permissions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('showVoters')) {
        result.showVoters = overrides && overrides.hasOwnProperty('showVoters') ? overrides.showVoters! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('showVotesCount')) {
        result.showVotesCount = overrides && overrides.hasOwnProperty('showVotesCount') ? overrides.showVotesCount! : false;
    }

    return result;
};

export const aWixRichContentV1PollDataPollSettingsInput = <T extends Partial<WixRichContentV1PollDataPollSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('permissions')) {
        result.permissions = overrides && overrides.hasOwnProperty('permissions') ? aWixRichContentV1PollDataPollSettingsPermissionsInput(overrides.permissions ?? {}, pickedFields.get('permissions')) : aWixRichContentV1PollDataPollSettingsPermissionsInput({}, pickedFields.get('permissions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('showVoters')) {
        result.showVoters = overrides && overrides.hasOwnProperty('showVoters') ? overrides.showVoters! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('showVotesCount')) {
        result.showVotesCount = overrides && overrides.hasOwnProperty('showVotesCount') ? overrides.showVotesCount! : false;
    }

    return result;
};

export const aWixRichContentV1PollDataPollSettingsPermissions = <T extends Partial<WixRichContentV1PollDataPollSettingsPermissions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowMultipleVotes')) {
        result.allowMultipleVotes = overrides && overrides.hasOwnProperty('allowMultipleVotes') ? overrides.allowMultipleVotes! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('view')) {
        result.view = overrides && overrides.hasOwnProperty('view') ? overrides.view! : WixRichContentV1PollDataPollSettingsPermissionsViewRole.Creator;
    }
    if (pickedFields.size === 0 || pickedFields.has('vote')) {
        result.vote = overrides && overrides.hasOwnProperty('vote') ? overrides.vote! : WixRichContentV1PollDataPollSettingsPermissionsVoteRole.All;
    }

    return result;
};

export const aWixRichContentV1PollDataPollSettingsPermissionsInput = <T extends Partial<WixRichContentV1PollDataPollSettingsPermissionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('allowMultipleVotes')) {
        result.allowMultipleVotes = overrides && overrides.hasOwnProperty('allowMultipleVotes') ? overrides.allowMultipleVotes! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('view')) {
        result.view = overrides && overrides.hasOwnProperty('view') ? overrides.view! : WixRichContentV1PollDataPollSettingsPermissionsViewRole.Creator;
    }
    if (pickedFields.size === 0 || pickedFields.has('vote')) {
        result.vote = overrides && overrides.hasOwnProperty('vote') ? overrides.vote! : WixRichContentV1PollDataPollSettingsPermissionsVoteRole.All;
    }

    return result;
};

export const aWixRichContentV1RichContent = <T extends Partial<WixRichContentV1RichContent>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('documentStyle')) {
        result.documentStyle = overrides && overrides.hasOwnProperty('documentStyle') ? aWixRichContentV1DocumentStyle(overrides.documentStyle ?? {}, pickedFields.get('documentStyle')) : aWixRichContentV1DocumentStyle({}, pickedFields.get('documentStyle'));
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixRichContentV1Metadata(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixRichContentV1Metadata({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nodes')) {
        result.nodes = overrides && overrides.hasOwnProperty('nodes') ? overrides.nodes!.map((x) => aWixRichContentV1Node(x ?? {}, pickedFields.get('nodes'))) : [aWixRichContentV1Node({}, pickedFields.get('nodes'))];
    }

    return result;
};

export const aWixRichContentV1RichContentInput = <T extends Partial<WixRichContentV1RichContentInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('documentStyle')) {
        result.documentStyle = overrides && overrides.hasOwnProperty('documentStyle') ? aWixRichContentV1DocumentStyleInput(overrides.documentStyle ?? {}, pickedFields.get('documentStyle')) : aWixRichContentV1DocumentStyleInput({}, pickedFields.get('documentStyle'));
    }
    if (pickedFields.size === 0 || pickedFields.has('metadata')) {
        result.metadata = overrides && overrides.hasOwnProperty('metadata') ? aWixRichContentV1MetadataInput(overrides.metadata ?? {}, pickedFields.get('metadata')) : aWixRichContentV1MetadataInput({}, pickedFields.get('metadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nodes')) {
        result.nodes = overrides && overrides.hasOwnProperty('nodes') ? overrides.nodes!.map((x) => aWixRichContentV1NodeInput({}, pickedFields.get('nodes'))) : [aWixRichContentV1NodeInput({}, pickedFields.get('nodes'))];
    }

    return result;
};

export const aWixRichContentV1SpoilerData = <T extends Partial<WixRichContentV1SpoilerData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }

    return result;
};

export const aWixRichContentV1SpoilerDataInput = <T extends Partial<WixRichContentV1SpoilerDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolores';
    }

    return result;
};

export const aWixRichContentV1Struct = <T extends Partial<WixRichContentV1Struct>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? aWixRichContentV1Value(overrides.fields ?? {}, pickedFields.get('fields')) : aWixRichContentV1Value({}, pickedFields.get('fields'));
    }

    return result;
};

export const aWixRichContentV1StructInput = <T extends Partial<WixRichContentV1StructInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? aWixRichContentV1ValueInput(overrides.fields ?? {}, pickedFields.get('fields')) : aWixRichContentV1ValueInput({}, pickedFields.get('fields'));
    }

    return result;
};

export const aWixRichContentV1TableCellData = <T extends Partial<WixRichContentV1TableCellData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('borderColors')) {
        result.borderColors = overrides && overrides.hasOwnProperty('borderColors') ? aWixRichContentV1TableCellDataBorderColors(overrides.borderColors ?? {}, pickedFields.get('borderColors')) : aWixRichContentV1TableCellDataBorderColors({}, pickedFields.get('borderColors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cellStyle')) {
        result.cellStyle = overrides && overrides.hasOwnProperty('cellStyle') ? aWixRichContentV1TableCellDataCellStyle(overrides.cellStyle ?? {}, pickedFields.get('cellStyle')) : aWixRichContentV1TableCellDataCellStyle({}, pickedFields.get('cellStyle'));
    }

    return result;
};

export const aWixRichContentV1TableCellDataBorderColors = <T extends Partial<WixRichContentV1TableCellDataBorderColors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bottom')) {
        result.bottom = overrides && overrides.hasOwnProperty('bottom') ? overrides.bottom! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('left')) {
        result.left = overrides && overrides.hasOwnProperty('left') ? overrides.left! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('right')) {
        result.right = overrides && overrides.hasOwnProperty('right') ? overrides.right! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('top')) {
        result.top = overrides && overrides.hasOwnProperty('top') ? overrides.top! : 'at';
    }

    return result;
};

export const aWixRichContentV1TableCellDataBorderColorsInput = <T extends Partial<WixRichContentV1TableCellDataBorderColorsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bottom')) {
        result.bottom = overrides && overrides.hasOwnProperty('bottom') ? overrides.bottom! : 'doloremque';
    }
    if (pickedFields.size === 0 || pickedFields.has('left')) {
        result.left = overrides && overrides.hasOwnProperty('left') ? overrides.left! : 'quisquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('right')) {
        result.right = overrides && overrides.hasOwnProperty('right') ? overrides.right! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('top')) {
        result.top = overrides && overrides.hasOwnProperty('top') ? overrides.top! : 'repudiandae';
    }

    return result;
};

export const aWixRichContentV1TableCellDataCellStyle = <T extends Partial<WixRichContentV1TableCellDataCellStyle>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('backgroundColor')) {
        result.backgroundColor = overrides && overrides.hasOwnProperty('backgroundColor') ? overrides.backgroundColor! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('verticalAlignment')) {
        result.verticalAlignment = overrides && overrides.hasOwnProperty('verticalAlignment') ? overrides.verticalAlignment! : WixRichContentV1TableCellDataVerticalAlignment.Bottom;
    }

    return result;
};

export const aWixRichContentV1TableCellDataCellStyleInput = <T extends Partial<WixRichContentV1TableCellDataCellStyleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('backgroundColor')) {
        result.backgroundColor = overrides && overrides.hasOwnProperty('backgroundColor') ? overrides.backgroundColor! : 'perferendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('verticalAlignment')) {
        result.verticalAlignment = overrides && overrides.hasOwnProperty('verticalAlignment') ? overrides.verticalAlignment! : WixRichContentV1TableCellDataVerticalAlignment.Bottom;
    }

    return result;
};

export const aWixRichContentV1TableCellDataInput = <T extends Partial<WixRichContentV1TableCellDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('borderColors')) {
        result.borderColors = overrides && overrides.hasOwnProperty('borderColors') ? aWixRichContentV1TableCellDataBorderColorsInput(overrides.borderColors ?? {}, pickedFields.get('borderColors')) : aWixRichContentV1TableCellDataBorderColorsInput({}, pickedFields.get('borderColors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('cellStyle')) {
        result.cellStyle = overrides && overrides.hasOwnProperty('cellStyle') ? aWixRichContentV1TableCellDataCellStyleInput(overrides.cellStyle ?? {}, pickedFields.get('cellStyle')) : aWixRichContentV1TableCellDataCellStyleInput({}, pickedFields.get('cellStyle'));
    }

    return result;
};

export const aWixRichContentV1TableData = <T extends Partial<WixRichContentV1TableData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('columnHeader')) {
        result.columnHeader = overrides && overrides.hasOwnProperty('columnHeader') ? overrides.columnHeader! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dimensions')) {
        result.dimensions = overrides && overrides.hasOwnProperty('dimensions') ? aWixRichContentV1TableDataDimensions(overrides.dimensions ?? {}, pickedFields.get('dimensions')) : aWixRichContentV1TableDataDimensions({}, pickedFields.get('dimensions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('header')) {
        result.header = overrides && overrides.hasOwnProperty('header') ? overrides.header! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('rowHeader')) {
        result.rowHeader = overrides && overrides.hasOwnProperty('rowHeader') ? overrides.rowHeader! : false;
    }

    return result;
};

export const aWixRichContentV1TableDataDimensions = <T extends Partial<WixRichContentV1TableDataDimensions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('colsMinWidth')) {
        result.colsMinWidth = overrides && overrides.hasOwnProperty('colsMinWidth') ? overrides.colsMinWidth! : [9892];
    }
    if (pickedFields.size === 0 || pickedFields.has('colsWidthRatio')) {
        result.colsWidthRatio = overrides && overrides.hasOwnProperty('colsWidthRatio') ? overrides.colsWidthRatio! : [4452];
    }
    if (pickedFields.size === 0 || pickedFields.has('rowsHeight')) {
        result.rowsHeight = overrides && overrides.hasOwnProperty('rowsHeight') ? overrides.rowsHeight! : [8303];
    }

    return result;
};

export const aWixRichContentV1TableDataDimensionsInput = <T extends Partial<WixRichContentV1TableDataDimensionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('colsMinWidth')) {
        result.colsMinWidth = overrides && overrides.hasOwnProperty('colsMinWidth') ? overrides.colsMinWidth! : [9609];
    }
    if (pickedFields.size === 0 || pickedFields.has('colsWidthRatio')) {
        result.colsWidthRatio = overrides && overrides.hasOwnProperty('colsWidthRatio') ? overrides.colsWidthRatio! : [892];
    }
    if (pickedFields.size === 0 || pickedFields.has('rowsHeight')) {
        result.rowsHeight = overrides && overrides.hasOwnProperty('rowsHeight') ? overrides.rowsHeight! : [2573];
    }

    return result;
};

export const aWixRichContentV1TableDataInput = <T extends Partial<WixRichContentV1TableDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('columnHeader')) {
        result.columnHeader = overrides && overrides.hasOwnProperty('columnHeader') ? overrides.columnHeader! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dimensions')) {
        result.dimensions = overrides && overrides.hasOwnProperty('dimensions') ? aWixRichContentV1TableDataDimensionsInput(overrides.dimensions ?? {}, pickedFields.get('dimensions')) : aWixRichContentV1TableDataDimensionsInput({}, pickedFields.get('dimensions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('header')) {
        result.header = overrides && overrides.hasOwnProperty('header') ? overrides.header! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('rowHeader')) {
        result.rowHeader = overrides && overrides.hasOwnProperty('rowHeader') ? overrides.rowHeader! : false;
    }

    return result;
};

export const aWixRichContentV1TextData = <T extends Partial<WixRichContentV1TextData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('decorations')) {
        result.decorations = overrides && overrides.hasOwnProperty('decorations') ? overrides.decorations!.map((x) => aWixRichContentV1Decoration(x ?? {}, pickedFields.get('decorations'))) : [aWixRichContentV1Decoration({}, pickedFields.get('decorations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'similique';
    }

    return result;
};

export const aWixRichContentV1TextDataInput = <T extends Partial<WixRichContentV1TextDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('decorations')) {
        result.decorations = overrides && overrides.hasOwnProperty('decorations') ? overrides.decorations!.map((x) => aWixRichContentV1DecorationInput({}, pickedFields.get('decorations'))) : [aWixRichContentV1DecorationInput({}, pickedFields.get('decorations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('text')) {
        result.text = overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'amet';
    }

    return result;
};

export const aWixRichContentV1TextNodeStyle = <T extends Partial<WixRichContentV1TextNodeStyle>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('decorations')) {
        result.decorations = overrides && overrides.hasOwnProperty('decorations') ? overrides.decorations!.map((x) => aWixRichContentV1Decoration(x ?? {}, pickedFields.get('decorations'))) : [aWixRichContentV1Decoration({}, pickedFields.get('decorations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineHeight')) {
        result.lineHeight = overrides && overrides.hasOwnProperty('lineHeight') ? overrides.lineHeight! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('nodeStyle')) {
        result.nodeStyle = overrides && overrides.hasOwnProperty('nodeStyle') ? aWixRichContentV1NodeStyle(overrides.nodeStyle ?? {}, pickedFields.get('nodeStyle')) : aWixRichContentV1NodeStyle({}, pickedFields.get('nodeStyle'));
    }

    return result;
};

export const aWixRichContentV1TextNodeStyleInput = <T extends Partial<WixRichContentV1TextNodeStyleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('decorations')) {
        result.decorations = overrides && overrides.hasOwnProperty('decorations') ? overrides.decorations!.map((x) => aWixRichContentV1DecorationInput({}, pickedFields.get('decorations'))) : [aWixRichContentV1DecorationInput({}, pickedFields.get('decorations'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('lineHeight')) {
        result.lineHeight = overrides && overrides.hasOwnProperty('lineHeight') ? overrides.lineHeight! : 'ullam';
    }
    if (pickedFields.size === 0 || pickedFields.has('nodeStyle')) {
        result.nodeStyle = overrides && overrides.hasOwnProperty('nodeStyle') ? aWixRichContentV1NodeStyleInput(overrides.nodeStyle ?? {}, pickedFields.get('nodeStyle')) : aWixRichContentV1NodeStyleInput({}, pickedFields.get('nodeStyle'));
    }

    return result;
};

export const aWixRichContentV1TextStyle = <T extends Partial<WixRichContentV1TextStyle>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineHeight')) {
        result.lineHeight = overrides && overrides.hasOwnProperty('lineHeight') ? overrides.lineHeight! : 'magni';
    }
    if (pickedFields.size === 0 || pickedFields.has('textAlignment')) {
        result.textAlignment = overrides && overrides.hasOwnProperty('textAlignment') ? overrides.textAlignment! : WixRichContentV1TextStyleTextAlignment.Auto;
    }

    return result;
};

export const aWixRichContentV1TextStyleInput = <T extends Partial<WixRichContentV1TextStyleInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lineHeight')) {
        result.lineHeight = overrides && overrides.hasOwnProperty('lineHeight') ? overrides.lineHeight! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('textAlignment')) {
        result.textAlignment = overrides && overrides.hasOwnProperty('textAlignment') ? overrides.textAlignment! : WixRichContentV1TextStyleTextAlignment.Auto;
    }

    return result;
};

export const aWixRichContentV1Value = <T extends Partial<WixRichContentV1Value>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('boolValue')) {
        result.boolValue = overrides && overrides.hasOwnProperty('boolValue') ? overrides.boolValue! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('listValue')) {
        result.listValue = overrides && overrides.hasOwnProperty('listValue') ? aWixRichContentV1ListValue(overrides.listValue ?? {}, pickedFields.get('listValue')) : aWixRichContentV1ListValue({}, pickedFields.get('listValue'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nullValue')) {
        result.nullValue = overrides && overrides.hasOwnProperty('nullValue') ? overrides.nullValue! : WixRichContentV1NullValue.NullValue;
    }
    if (pickedFields.size === 0 || pickedFields.has('numberValue')) {
        result.numberValue = overrides && overrides.hasOwnProperty('numberValue') ? overrides.numberValue! : 5.34;
    }
    if (pickedFields.size === 0 || pickedFields.has('stringValue')) {
        result.stringValue = overrides && overrides.hasOwnProperty('stringValue') ? overrides.stringValue! : 'temporibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('structValue')) {
        result.structValue = overrides && overrides.hasOwnProperty('structValue') ? aWixRichContentV1Struct(overrides.structValue ?? {}, pickedFields.get('structValue')) : aWixRichContentV1Struct({}, pickedFields.get('structValue'));
    }

    return result;
};

export const aWixRichContentV1ValueInput = <T extends Partial<WixRichContentV1ValueInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('boolValue')) {
        result.boolValue = overrides && overrides.hasOwnProperty('boolValue') ? overrides.boolValue! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('listValue')) {
        result.listValue = overrides && overrides.hasOwnProperty('listValue') ? aWixRichContentV1ListValueInput(overrides.listValue ?? {}, pickedFields.get('listValue')) : aWixRichContentV1ListValueInput({}, pickedFields.get('listValue'));
    }
    if (pickedFields.size === 0 || pickedFields.has('nullValue')) {
        result.nullValue = overrides && overrides.hasOwnProperty('nullValue') ? overrides.nullValue! : WixRichContentV1NullValue.NullValue;
    }
    if (pickedFields.size === 0 || pickedFields.has('numberValue')) {
        result.numberValue = overrides && overrides.hasOwnProperty('numberValue') ? overrides.numberValue! : 9.17;
    }
    if (pickedFields.size === 0 || pickedFields.has('stringValue')) {
        result.stringValue = overrides && overrides.hasOwnProperty('stringValue') ? overrides.stringValue! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('structValue')) {
        result.structValue = overrides && overrides.hasOwnProperty('structValue') ? aWixRichContentV1StructInput(overrides.structValue ?? {}, pickedFields.get('structValue')) : aWixRichContentV1StructInput({}, pickedFields.get('structValue'));
    }

    return result;
};

export const aWixRichContentV1VideoData = <T extends Partial<WixRichContentV1VideoData>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerData(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerData({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDownload')) {
        result.disableDownload = overrides && overrides.hasOwnProperty('disableDownload') ? overrides.disableDownload! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixRichContentV1PlaybackOptions(overrides.options ?? {}, pickedFields.get('options')) : aWixRichContentV1PlaybackOptions({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnail')) {
        result.thumbnail = overrides && overrides.hasOwnProperty('thumbnail') ? aWixRichContentV1Media(overrides.thumbnail ?? {}, pickedFields.get('thumbnail')) : aWixRichContentV1Media({}, pickedFields.get('thumbnail'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'laboriosam';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixRichContentV1Media(overrides.video ?? {}, pickedFields.get('video')) : aWixRichContentV1Media({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixRichContentV1VideoDataInput = <T extends Partial<WixRichContentV1VideoDataInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('containerData')) {
        result.containerData = overrides && overrides.hasOwnProperty('containerData') ? aWixRichContentV1PluginContainerDataInput(overrides.containerData ?? {}, pickedFields.get('containerData')) : aWixRichContentV1PluginContainerDataInput({}, pickedFields.get('containerData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDownload')) {
        result.disableDownload = overrides && overrides.hasOwnProperty('disableDownload') ? overrides.disableDownload! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? aWixRichContentV1PlaybackOptionsInput(overrides.options ?? {}, pickedFields.get('options')) : aWixRichContentV1PlaybackOptionsInput({}, pickedFields.get('options'));
    }
    if (pickedFields.size === 0 || pickedFields.has('thumbnail')) {
        result.thumbnail = overrides && overrides.hasOwnProperty('thumbnail') ? aWixRichContentV1MediaInput(overrides.thumbnail ?? {}, pickedFields.get('thumbnail')) : aWixRichContentV1MediaInput({}, pickedFields.get('thumbnail'));
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('video')) {
        result.video = overrides && overrides.hasOwnProperty('video') ? aWixRichContentV1MediaInput(overrides.video ?? {}, pickedFields.get('video')) : aWixRichContentV1MediaInput({}, pickedFields.get('video'));
    }

    return result;
};

export const aWixRiseV1ActionInitiator = <T extends Partial<WixRiseV1ActionInitiator>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseV1ActionInitiatorInitiatorType.App;
    }

    return result;
};

export const aWixRiseV1ActionInitiatorInput = <T extends Partial<WixRiseV1ActionInitiatorInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseV1ActionInitiatorInitiatorType.App;
    }

    return result;
};

export const aWixRiseV1AddCustomerReferenceRequestInput = <T extends Partial<WixRiseV1AddCustomerReferenceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseV1CustomerReferenceInput(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseV1CustomerReferenceInput({}, pickedFields.get('customerReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletId')) {
        result.walletId = overrides && overrides.hasOwnProperty('walletId') ? overrides.walletId! : 'illo';
    }

    return result;
};

export const aWixRiseV1AddCustomerReferenceResponse = <T extends Partial<WixRiseV1AddCustomerReferenceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseV1CustomerReference(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseV1CustomerReference({}, pickedFields.get('customerReference'));
    }

    return result;
};

export const aWixRiseV1BulkDeleteGiftCardsByFilterRequestInput = <T extends Partial<WixRiseV1BulkDeleteGiftCardsByFilterRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('expectedAmount')) {
        result.expectedAmount = overrides && overrides.hasOwnProperty('expectedAmount') ? overrides.expectedAmount! : 157;
    }
    if (pickedFields.size === 0 || pickedFields.has('metaSiteId')) {
        result.metaSiteId = overrides && overrides.hasOwnProperty('metaSiteId') ? overrides.metaSiteId! : 'cum';
    }
    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1BulkDeleteGiftCardsByFilterResponse = <T extends Partial<WixRiseV1BulkDeleteGiftCardsByFilterResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('jobId')) {
        result.jobId = overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'ipsum';
    }

    return result;
};

export const aWixRiseV1BulkOptions = <T extends Partial<WixRiseV1BulkOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkId')) {
        result.bulkId = overrides && overrides.hasOwnProperty('bulkId') ? overrides.bulkId! : 'odio';
    }
    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'perspiciatis';
    }

    return result;
};

export const aWixRiseV1BulkOptionsInput = <T extends Partial<WixRiseV1BulkOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkId')) {
        result.bulkId = overrides && overrides.hasOwnProperty('bulkId') ? overrides.bulkId! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'maiores';
    }

    return result;
};

export const aWixRiseV1CampaignOptions = <T extends Partial<WixRiseV1CampaignOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('campaignId')) {
        result.campaignId = overrides && overrides.hasOwnProperty('campaignId') ? overrides.campaignId! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }

    return result;
};

export const aWixRiseV1CampaignOptionsInput = <T extends Partial<WixRiseV1CampaignOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('campaignId')) {
        result.campaignId = overrides && overrides.hasOwnProperty('campaignId') ? overrides.campaignId! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : false;
    }

    return result;
};

export const aWixRiseV1CountGiftCardsRequestInput = <T extends Partial<WixRiseV1CountGiftCardsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'quisquam';
    }

    return result;
};

export const aWixRiseV1CountGiftCardsResponse = <T extends Partial<WixRiseV1CountGiftCardsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 6450;
    }

    return result;
};

export const aWixRiseV1CountWalletsRequestInput = <T extends Partial<WixRiseV1CountWalletsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'molestiae';
    }

    return result;
};

export const aWixRiseV1CountWalletsResponse = <T extends Partial<WixRiseV1CountWalletsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 1978;
    }

    return result;
};

export const aWixRiseV1CreateCustomerReferenceRequestInput = <T extends Partial<WixRiseV1CreateCustomerReferenceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseV1CustomerReferenceInput(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseV1CustomerReferenceInput({}, pickedFields.get('customerReference'));
    }

    return result;
};

export const aWixRiseV1CreateCustomerReferenceResponse = <T extends Partial<WixRiseV1CreateCustomerReferenceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseV1CustomerReference(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseV1CustomerReference({}, pickedFields.get('customerReference'));
    }

    return result;
};

export const aWixRiseV1CreateGiftCardRequestInput = <T extends Partial<WixRiseV1CreateGiftCardRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCardInput(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCardInput({}, pickedFields.get('giftCard'));
    }

    return result;
};

export const aWixRiseV1CreateGiftCardResponse = <T extends Partial<WixRiseV1CreateGiftCardResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCard({}, pickedFields.get('giftCard'));
    }

    return result;
};

export const aWixRiseV1CreateMigrationGiftCardRequestInput = <T extends Partial<WixRiseV1CreateMigrationGiftCardRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCardInput(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCardInput({}, pickedFields.get('giftCard'));
    }

    return result;
};

export const aWixRiseV1CreateMigrationGiftCardResponse = <T extends Partial<WixRiseV1CreateMigrationGiftCardResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCard({}, pickedFields.get('giftCard'));
    }

    return result;
};

export const aWixRiseV1CreateMigrationTransactionRequestInput = <T extends Partial<WixRiseV1CreateMigrationTransactionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixRiseV1TransactionInput(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixRiseV1TransactionInput({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aWixRiseV1CreateMigrationTransactionResponse = <T extends Partial<WixRiseV1CreateMigrationTransactionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixRiseV1Transaction(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixRiseV1Transaction({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aWixRiseV1CreateMigrationWalletActionRequestInput = <T extends Partial<WixRiseV1CreateMigrationWalletActionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletActionInput(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletActionInput({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1CreateMigrationWalletActionResponse = <T extends Partial<WixRiseV1CreateMigrationWalletActionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1CreateWalletActionByCustomerReferenceRequestInput = <T extends Partial<WixRiseV1CreateWalletActionByCustomerReferenceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseV1CustomerReferenceInput(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseV1CustomerReferenceInput({}, pickedFields.get('customerReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('newWalletCurrency')) {
        result.newWalletCurrency = overrides && overrides.hasOwnProperty('newWalletCurrency') ? overrides.newWalletCurrency! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletActionInput(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletActionInput({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1CreateWalletActionByCustomerReferenceResponse = <T extends Partial<WixRiseV1CreateWalletActionByCustomerReferenceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('wallet')) {
        result.wallet = overrides && overrides.hasOwnProperty('wallet') ? aWixRiseV1Wallet(overrides.wallet ?? {}, pickedFields.get('wallet')) : aWixRiseV1Wallet({}, pickedFields.get('wallet'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1CreateWalletActionRequestInput = <T extends Partial<WixRiseV1CreateWalletActionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletActionInput(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletActionInput({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1CreateWalletActionResponse = <T extends Partial<WixRiseV1CreateWalletActionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1CreateWalletRequestInput = <T extends Partial<WixRiseV1CreateWalletRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseV1CustomerReferenceInput(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseV1CustomerReferenceInput({}, pickedFields.get('customerReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('initialValue')) {
        result.initialValue = overrides && overrides.hasOwnProperty('initialValue') ? overrides.initialValue! : 'aperiam';
    }

    return result;
};

export const aWixRiseV1CreateWalletResponse = <T extends Partial<WixRiseV1CreateWalletResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('wallet')) {
        result.wallet = overrides && overrides.hasOwnProperty('wallet') ? aWixRiseV1Wallet(overrides.wallet ?? {}, pickedFields.get('wallet')) : aWixRiseV1Wallet({}, pickedFields.get('wallet'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'soluta';
    }

    return result;
};

export const aWixRiseV1CustomerReference = <T extends Partial<WixRiseV1CustomerReference>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'quo';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'sequi';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'recusandae';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceCustomerId')) {
        result.sourceCustomerId = overrides && overrides.hasOwnProperty('sourceCustomerId') ? overrides.sourceCustomerId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'quis';
    }

    return result;
};

export const aWixRiseV1CustomerReferenceInput = <T extends Partial<WixRiseV1CustomerReferenceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'nesciunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'eveniet';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'dolore';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceCustomerId')) {
        result.sourceCustomerId = overrides && overrides.hasOwnProperty('sourceCustomerId') ? overrides.sourceCustomerId! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'in';
    }

    return result;
};

export const aWixRiseV1CustomerReferenceQueryInput = <T extends Partial<WixRiseV1CustomerReferenceQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerReferenceSource')) {
        result.customerReferenceSource = overrides && overrides.hasOwnProperty('customerReferenceSource') ? aWixRiseV1SourceInput(overrides.customerReferenceSource ?? {}, pickedFields.get('customerReferenceSource')) : aWixRiseV1SourceInput({}, pickedFields.get('customerReferenceSource'));
    }

    return result;
};

export const aWixRiseV1DecreaseBalanceRequestInput = <T extends Partial<WixRiseV1DecreaseBalanceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixRiseV1TransactionInput(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixRiseV1TransactionInput({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aWixRiseV1DecreaseBalanceResponse = <T extends Partial<WixRiseV1DecreaseBalanceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? overrides.balance! : 'quasi';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixRiseV1Transaction(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixRiseV1Transaction({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aWixRiseV1DeleteCustomerReferenceRequestInput = <T extends Partial<WixRiseV1DeleteCustomerReferenceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRiseV1CustomerReferenceQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixRiseV1CustomerReferenceQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1DeleteWalletActionRequestInput = <T extends Partial<WixRiseV1DeleteWalletActionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'corporis';
    }

    return result;
};

export const aWixRiseV1DisableGiftCardRequestInput = <T extends Partial<WixRiseV1DisableGiftCardRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'veritatis';
    }

    return result;
};

export const aWixRiseV1DisableGiftCardResponse = <T extends Partial<WixRiseV1DisableGiftCardResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCard({}, pickedFields.get('giftCard'));
    }

    return result;
};

export const aWixRiseV1DisableWalletActionRequestInput = <T extends Partial<WixRiseV1DisableWalletActionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'consequatur';
    }

    return result;
};

export const aWixRiseV1DisableWalletActionResponse = <T extends Partial<WixRiseV1DisableWalletActionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1EndMigrationWalletActionRequestInput = <T extends Partial<WixRiseV1EndMigrationWalletActionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amountToSubtract')) {
        result.amountToSubtract = overrides && overrides.hasOwnProperty('amountToSubtract') ? overrides.amountToSubtract! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'tenetur';
    }

    return result;
};

export const aWixRiseV1EndMigrationWalletActionResponse = <T extends Partial<WixRiseV1EndMigrationWalletActionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1ExternalEvent = <T extends Partial<WixRiseV1ExternalEvent>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : WixRiseV1ExternalEventExternalEventType.Compensation;
    }

    return result;
};

export const aWixRiseV1ExternalEventInput = <T extends Partial<WixRiseV1ExternalEventInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : WixRiseV1ExternalEventExternalEventType.Compensation;
    }

    return result;
};

export const aWixRiseV1GetCustomerReferenceRequestInput = <T extends Partial<WixRiseV1GetCustomerReferenceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRiseV1CustomerReferenceQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixRiseV1CustomerReferenceQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1GetCustomerReferenceResponse = <T extends Partial<WixRiseV1GetCustomerReferenceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseV1CustomerReference(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseV1CustomerReference({}, pickedFields.get('customerReference'));
    }

    return result;
};

export const aWixRiseV1GetGiftCardConsistentRequestInput = <T extends Partial<WixRiseV1GetGiftCardConsistentRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'aperiam';
    }

    return result;
};

export const aWixRiseV1GetGiftCardConsistentResponse = <T extends Partial<WixRiseV1GetGiftCardConsistentResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCard({}, pickedFields.get('giftCard'));
    }

    return result;
};

export const aWixRiseV1GetGiftCardRequestInput = <T extends Partial<WixRiseV1GetGiftCardRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6aac3cc5-c633-4674-b2df-fbb2f0fcb4d7';
    }

    return result;
};

export const aWixRiseV1GetOrCreateWalletRequestInput = <T extends Partial<WixRiseV1GetOrCreateWalletRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseV1CustomerReferenceInput(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseV1CustomerReferenceInput({}, pickedFields.get('customerReference'));
    }

    return result;
};

export const aWixRiseV1GetOrCreateWalletResponse = <T extends Partial<WixRiseV1GetOrCreateWalletResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('wallet')) {
        result.wallet = overrides && overrides.hasOwnProperty('wallet') ? aWixRiseV1Wallet(overrides.wallet ?? {}, pickedFields.get('wallet')) : aWixRiseV1Wallet({}, pickedFields.get('wallet'));
    }

    return result;
};

export const aWixRiseV1GetRefundableAmountsRequestInput = <T extends Partial<WixRiseV1GetRefundableAmountsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'ipsa';
    }

    return result;
};

export const aWixRiseV1GetRefundableAmountsResponse = <T extends Partial<WixRiseV1GetRefundableAmountsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amounts')) {
        result.amounts = overrides && overrides.hasOwnProperty('amounts') ? overrides.amounts!.map((x) => aWixRiseV1RefundableAmount(x ?? {}, pickedFields.get('amounts'))) : [aWixRiseV1RefundableAmount({}, pickedFields.get('amounts'))];
    }

    return result;
};

export const aWixRiseV1GetTransactionRequestInput = <T extends Partial<WixRiseV1GetTransactionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cd327ec9-3fc2-4778-85a1-45755d4aab64';
    }

    return result;
};

export const aWixRiseV1GetWalletActionRequestInput = <T extends Partial<WixRiseV1GetWalletActionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8a4b2884-ca87-4703-a1fd-8c66802ccdf0';
    }

    return result;
};

export const aWixRiseV1GetWalletGiftCardRequestInput = <T extends Partial<WixRiseV1GetWalletGiftCardRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRiseV1WalletQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixRiseV1WalletQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1GetWalletGiftCardResponse = <T extends Partial<WixRiseV1GetWalletGiftCardResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCard({}, pickedFields.get('giftCard'));
    }

    return result;
};

export const aWixRiseV1GetWalletRequestInput = <T extends Partial<WixRiseV1GetWalletRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b0095625-792b-4b9a-8058-9535310c6f25';
    }

    return result;
};

export const aWixRiseV1GetWalletResponse = <T extends Partial<WixRiseV1GetWalletResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('wallet')) {
        result.wallet = overrides && overrides.hasOwnProperty('wallet') ? aWixRiseV1Wallet(overrides.wallet ?? {}, pickedFields.get('wallet')) : aWixRiseV1Wallet({}, pickedFields.get('wallet'));
    }

    return result;
};

export const aWixRiseV1GiftCard = <T extends Partial<WixRiseV1GiftCard>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? overrides.balance! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'reiciendis';
    }
    if (pickedFields.size === 0 || pickedFields.has('codeSuffix')) {
        result.codeSuffix = overrides && overrides.hasOwnProperty('codeSuffix') ? overrides.codeSuffix! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'voluptates';
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDate')) {
        result.disableDate = overrides && overrides.hasOwnProperty('disableDate') ? overrides.disableDate! : 'minus';
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationDate')) {
        result.expirationDate = overrides && overrides.hasOwnProperty('expirationDate') ? overrides.expirationDate! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('idempotencyKey')) {
        result.idempotencyKey = overrides && overrides.hasOwnProperty('idempotencyKey') ? overrides.idempotencyKey! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('initialValue')) {
        result.initialValue = overrides && overrides.hasOwnProperty('initialValue') ? overrides.initialValue! : 'illum';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastActivityForReminders')) {
        result.lastActivityForReminders = overrides && overrides.hasOwnProperty('lastActivityForReminders') ? overrides.lastActivityForReminders! : 'saepe';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastTransactionId')) {
        result.lastTransactionId = overrides && overrides.hasOwnProperty('lastTransactionId') ? overrides.lastTransactionId! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceInfo')) {
        result.sourceInfo = overrides && overrides.hasOwnProperty('sourceInfo') ? aWixRiseV1GiftCardSourceInfo(overrides.sourceInfo ?? {}, pickedFields.get('sourceInfo')) : aWixRiseV1GiftCardSourceInfo({}, pickedFields.get('sourceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionDetails')) {
        result.transactionDetails = overrides && overrides.hasOwnProperty('transactionDetails') ? aWixRiseV1TransactionDetails(overrides.transactionDetails ?? {}, pickedFields.get('transactionDetails')) : aWixRiseV1TransactionDetails({}, pickedFields.get('transactionDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletsVirtualReference')) {
        result.walletsVirtualReference = overrides && overrides.hasOwnProperty('walletsVirtualReference') ? aWixRiseV1QueryWalletsResponse(overrides.walletsVirtualReference ?? {}, pickedFields.get('walletsVirtualReference')) : aWixRiseV1QueryWalletsResponse({}, pickedFields.get('walletsVirtualReference'));
    }

    return result;
};

export const aWixRiseV1GiftCardInfo = <T extends Partial<WixRiseV1GiftCardInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? overrides.balance! : 'impedit';
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'rem';
    }
    if (pickedFields.size === 0 || pickedFields.has('codeSuffix')) {
        result.codeSuffix = overrides && overrides.hasOwnProperty('codeSuffix') ? overrides.codeSuffix! : 'inventore';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'nemo';
    }

    return result;
};

export const aWixRiseV1GiftCardInput = <T extends Partial<WixRiseV1GiftCardInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? overrides.balance! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('codeSuffix')) {
        result.codeSuffix = overrides && overrides.hasOwnProperty('codeSuffix') ? overrides.codeSuffix! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDate')) {
        result.disableDate = overrides && overrides.hasOwnProperty('disableDate') ? overrides.disableDate! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationDate')) {
        result.expirationDate = overrides && overrides.hasOwnProperty('expirationDate') ? overrides.expirationDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'beatae';
    }
    if (pickedFields.size === 0 || pickedFields.has('idempotencyKey')) {
        result.idempotencyKey = overrides && overrides.hasOwnProperty('idempotencyKey') ? overrides.idempotencyKey! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('initialValue')) {
        result.initialValue = overrides && overrides.hasOwnProperty('initialValue') ? overrides.initialValue! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastActivityForReminders')) {
        result.lastActivityForReminders = overrides && overrides.hasOwnProperty('lastActivityForReminders') ? overrides.lastActivityForReminders! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'eligendi';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceInfo')) {
        result.sourceInfo = overrides && overrides.hasOwnProperty('sourceInfo') ? aWixRiseV1GiftCardSourceInfoInput(overrides.sourceInfo ?? {}, pickedFields.get('sourceInfo')) : aWixRiseV1GiftCardSourceInfoInput({}, pickedFields.get('sourceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionDetails')) {
        result.transactionDetails = overrides && overrides.hasOwnProperty('transactionDetails') ? aWixRiseV1TransactionDetailsInput(overrides.transactionDetails ?? {}, pickedFields.get('transactionDetails')) : aWixRiseV1TransactionDetailsInput({}, pickedFields.get('transactionDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'non';
    }

    return result;
};

export const aWixRiseV1GiftCardSourceInfo = <T extends Partial<WixRiseV1GiftCardSourceInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkOptions')) {
        result.bulkOptions = overrides && overrides.hasOwnProperty('bulkOptions') ? aWixRiseV1BulkOptions(overrides.bulkOptions ?? {}, pickedFields.get('bulkOptions')) : aWixRiseV1BulkOptions({}, pickedFields.get('bulkOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('campaignOptions')) {
        result.campaignOptions = overrides && overrides.hasOwnProperty('campaignOptions') ? aWixRiseV1CampaignOptions(overrides.campaignOptions ?? {}, pickedFields.get('campaignOptions')) : aWixRiseV1CampaignOptions({}, pickedFields.get('campaignOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('initiator')) {
        result.initiator = overrides && overrides.hasOwnProperty('initiator') ? aWixRiseV1ActionInitiator(overrides.initiator ?? {}, pickedFields.get('initiator')) : aWixRiseV1ActionInitiator({}, pickedFields.get('initiator'));
    }
    if (pickedFields.size === 0 || pickedFields.has('manualOptions')) {
        result.manualOptions = overrides && overrides.hasOwnProperty('manualOptions') ? aWixRiseV1ManualOptions(overrides.manualOptions ?? {}, pickedFields.get('manualOptions')) : aWixRiseV1ManualOptions({}, pickedFields.get('manualOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('migrationOptions')) {
        result.migrationOptions = overrides && overrides.hasOwnProperty('migrationOptions') ? aWixRiseV1MigrationOptions(overrides.migrationOptions ?? {}, pickedFields.get('migrationOptions')) : aWixRiseV1MigrationOptions({}, pickedFields.get('migrationOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderOptions')) {
        result.orderOptions = overrides && overrides.hasOwnProperty('orderOptions') ? aWixRiseV1OrderOptions(overrides.orderOptions ?? {}, pickedFields.get('orderOptions')) : aWixRiseV1OrderOptions({}, pickedFields.get('orderOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'error';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceLocationId')) {
        result.sourceLocationId = overrides && overrides.hasOwnProperty('sourceLocationId') ? overrides.sourceLocationId! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('storeCreditOptions')) {
        result.storeCreditOptions = overrides && overrides.hasOwnProperty('storeCreditOptions') ? aWixRiseV1StoreCreditOptions(overrides.storeCreditOptions ?? {}, pickedFields.get('storeCreditOptions')) : aWixRiseV1StoreCreditOptions({}, pickedFields.get('storeCreditOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseV1GiftCardType.Bulk;
    }
    if (pickedFields.size === 0 || pickedFields.has('workflowOptions')) {
        result.workflowOptions = overrides && overrides.hasOwnProperty('workflowOptions') ? aWixRiseV1WorkflowOptions(overrides.workflowOptions ?? {}, pickedFields.get('workflowOptions')) : aWixRiseV1WorkflowOptions({}, pickedFields.get('workflowOptions'));
    }

    return result;
};

export const aWixRiseV1GiftCardSourceInfoInput = <T extends Partial<WixRiseV1GiftCardSourceInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('bulkOptions')) {
        result.bulkOptions = overrides && overrides.hasOwnProperty('bulkOptions') ? aWixRiseV1BulkOptionsInput(overrides.bulkOptions ?? {}, pickedFields.get('bulkOptions')) : aWixRiseV1BulkOptionsInput({}, pickedFields.get('bulkOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('campaignOptions')) {
        result.campaignOptions = overrides && overrides.hasOwnProperty('campaignOptions') ? aWixRiseV1CampaignOptionsInput(overrides.campaignOptions ?? {}, pickedFields.get('campaignOptions')) : aWixRiseV1CampaignOptionsInput({}, pickedFields.get('campaignOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('initiator')) {
        result.initiator = overrides && overrides.hasOwnProperty('initiator') ? aWixRiseV1ActionInitiatorInput(overrides.initiator ?? {}, pickedFields.get('initiator')) : aWixRiseV1ActionInitiatorInput({}, pickedFields.get('initiator'));
    }
    if (pickedFields.size === 0 || pickedFields.has('manualOptions')) {
        result.manualOptions = overrides && overrides.hasOwnProperty('manualOptions') ? aWixRiseV1ManualOptionsInput(overrides.manualOptions ?? {}, pickedFields.get('manualOptions')) : aWixRiseV1ManualOptionsInput({}, pickedFields.get('manualOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('migrationOptions')) {
        result.migrationOptions = overrides && overrides.hasOwnProperty('migrationOptions') ? aWixRiseV1MigrationOptionsInput(overrides.migrationOptions ?? {}, pickedFields.get('migrationOptions')) : aWixRiseV1MigrationOptionsInput({}, pickedFields.get('migrationOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderOptions')) {
        result.orderOptions = overrides && overrides.hasOwnProperty('orderOptions') ? aWixRiseV1OrderOptionsInput(overrides.orderOptions ?? {}, pickedFields.get('orderOptions')) : aWixRiseV1OrderOptionsInput({}, pickedFields.get('orderOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceLocationId')) {
        result.sourceLocationId = overrides && overrides.hasOwnProperty('sourceLocationId') ? overrides.sourceLocationId! : 'voluptatum';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('storeCreditOptions')) {
        result.storeCreditOptions = overrides && overrides.hasOwnProperty('storeCreditOptions') ? aWixRiseV1StoreCreditOptionsInput(overrides.storeCreditOptions ?? {}, pickedFields.get('storeCreditOptions')) : aWixRiseV1StoreCreditOptionsInput({}, pickedFields.get('storeCreditOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseV1GiftCardType.Bulk;
    }
    if (pickedFields.size === 0 || pickedFields.has('workflowOptions')) {
        result.workflowOptions = overrides && overrides.hasOwnProperty('workflowOptions') ? aWixRiseV1WorkflowOptionsInput(overrides.workflowOptions ?? {}, pickedFields.get('workflowOptions')) : aWixRiseV1WorkflowOptionsInput({}, pickedFields.get('workflowOptions'));
    }

    return result;
};

export const aWixRiseV1IncreaseBalanceRequestInput = <T extends Partial<WixRiseV1IncreaseBalanceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixRiseV1TransactionInput(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixRiseV1TransactionInput({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aWixRiseV1IncreaseBalanceResponse = <T extends Partial<WixRiseV1IncreaseBalanceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? overrides.balance! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'quidem';
    }
    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixRiseV1Transaction(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixRiseV1Transaction({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aWixRiseV1InitialOptions = <T extends Partial<WixRiseV1InitialOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCardType')) {
        result.giftCardType = overrides && overrides.hasOwnProperty('giftCardType') ? overrides.giftCardType! : WixRiseV1GiftCardType.Bulk;
    }

    return result;
};

export const aWixRiseV1InitialOptionsInput = <T extends Partial<WixRiseV1InitialOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCardType')) {
        result.giftCardType = overrides && overrides.hasOwnProperty('giftCardType') ? overrides.giftCardType! : WixRiseV1GiftCardType.Bulk;
    }

    return result;
};

export const aWixRiseV1ManualOptions = <T extends Partial<WixRiseV1ManualOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'maxime';
    }

    return result;
};

export const aWixRiseV1ManualOptionsInput = <T extends Partial<WixRiseV1ManualOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'incidunt';
    }

    return result;
};

export const aWixRiseV1MigrateWalletRequestInput = <T extends Partial<WixRiseV1MigrateWalletRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('channelId')) {
        result.channelId = overrides && overrides.hasOwnProperty('channelId') ? overrides.channelId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseV1CustomerReferenceInput(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseV1CustomerReferenceInput({}, pickedFields.get('customerReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCardInput(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCardInput({}, pickedFields.get('giftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('tenantId')) {
        result.tenantId = overrides && overrides.hasOwnProperty('tenantId') ? overrides.tenantId! : 'totam';
    }

    return result;
};

export const aWixRiseV1MigrateWalletResponse = <T extends Partial<WixRiseV1MigrateWalletResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCard({}, pickedFields.get('giftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('wallet')) {
        result.wallet = overrides && overrides.hasOwnProperty('wallet') ? aWixRiseV1Wallet(overrides.wallet ?? {}, pickedFields.get('wallet')) : aWixRiseV1Wallet({}, pickedFields.get('wallet'));
    }

    return result;
};

export const aWixRiseV1MigrationOptions = <T extends Partial<WixRiseV1MigrationOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('previousId')) {
        result.previousId = overrides && overrides.hasOwnProperty('previousId') ? overrides.previousId! : 'ut';
    }

    return result;
};

export const aWixRiseV1MigrationOptionsInput = <T extends Partial<WixRiseV1MigrationOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('previousId')) {
        result.previousId = overrides && overrides.hasOwnProperty('previousId') ? overrides.previousId! : 'quo';
    }

    return result;
};

export const aWixRiseV1OrderOptions = <T extends Partial<WixRiseV1OrderOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'ratione';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderNumber')) {
        result.orderNumber = overrides && overrides.hasOwnProperty('orderNumber') ? overrides.orderNumber! : 'dolores';
    }

    return result;
};

export const aWixRiseV1OrderOptionsInput = <T extends Partial<WixRiseV1OrderOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'ipsa';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderNumber')) {
        result.orderNumber = overrides && overrides.hasOwnProperty('orderNumber') ? overrides.orderNumber! : 'enim';
    }

    return result;
};

export const aWixRiseV1PaymentMethodRefundOptions = <T extends Partial<WixRiseV1PaymentMethodRefundOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activeFundingTransaction')) {
        result.activeFundingTransaction = overrides && overrides.hasOwnProperty('activeFundingTransaction') ? aWixRiseV1PaymentMethodRefundWalletActionDetails(overrides.activeFundingTransaction ?? {}, pickedFields.get('activeFundingTransaction')) : aWixRiseV1PaymentMethodRefundWalletActionDetails({}, pickedFields.get('activeFundingTransaction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderNumber')) {
        result.orderNumber = overrides && overrides.hasOwnProperty('orderNumber') ? overrides.orderNumber! : 'fugit';
    }

    return result;
};

export const aWixRiseV1PaymentMethodRefundOptionsInput = <T extends Partial<WixRiseV1PaymentMethodRefundOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('activeFundingTransaction')) {
        result.activeFundingTransaction = overrides && overrides.hasOwnProperty('activeFundingTransaction') ? aWixRiseV1PaymentMethodRefundWalletActionDetailsInput(overrides.activeFundingTransaction ?? {}, pickedFields.get('activeFundingTransaction')) : aWixRiseV1PaymentMethodRefundWalletActionDetailsInput({}, pickedFields.get('activeFundingTransaction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderNumber')) {
        result.orderNumber = overrides && overrides.hasOwnProperty('orderNumber') ? overrides.orderNumber! : 'sed';
    }

    return result;
};

export const aWixRiseV1PaymentMethodRefundWalletActionDetails = <T extends Partial<WixRiseV1PaymentMethodRefundWalletActionDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fundingTransactionId')) {
        result.fundingTransactionId = overrides && overrides.hasOwnProperty('fundingTransactionId') ? overrides.fundingTransactionId! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixRiseV1Transaction(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixRiseV1Transaction({}, pickedFields.get('transaction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'quod';
    }

    return result;
};

export const aWixRiseV1PaymentMethodRefundWalletActionDetailsInput = <T extends Partial<WixRiseV1PaymentMethodRefundWalletActionDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fundingTransactionId')) {
        result.fundingTransactionId = overrides && overrides.hasOwnProperty('fundingTransactionId') ? overrides.fundingTransactionId! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'non';
    }

    return result;
};

export const aWixRiseV1ProduceTransactionAddedEventRequestInput = <T extends Partial<WixRiseV1ProduceTransactionAddedEventRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'atque';
    }

    return result;
};

export const aWixRiseV1QueryByContactInput = <T extends Partial<WixRiseV1QueryByContactInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 6211;
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixRiseV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixRiseV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixRiseV1QueryGiftCardsRequestInput = <T extends Partial<WixRiseV1QueryGiftCardsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1QueryGiftCardsResponse = <T extends Partial<WixRiseV1QueryGiftCardsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixRiseV1GiftCard(x ?? {}, pickedFields.get('items'))) : [aWixRiseV1GiftCard({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixRiseV1QueryTransactionsInternalRequestInput = <T extends Partial<WixRiseV1QueryTransactionsInternalRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1QueryTransactionsInternalResponse = <T extends Partial<WixRiseV1QueryTransactionsInternalResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactions')) {
        result.transactions = overrides && overrides.hasOwnProperty('transactions') ? overrides.transactions!.map((x) => aWixRiseV1Transaction(x ?? {}, pickedFields.get('transactions'))) : [aWixRiseV1Transaction({}, pickedFields.get('transactions'))];
    }

    return result;
};

export const aWixRiseV1QueryTransactionsRequestInput = <T extends Partial<WixRiseV1QueryTransactionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixCommonQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixCommonQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1QueryTransactionsResponse = <T extends Partial<WixRiseV1QueryTransactionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixRiseV1Transaction(x ?? {}, pickedFields.get('items'))) : [aWixRiseV1Transaction({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixRiseV1QueryUnredeemedWalletActionsRequestInput = <T extends Partial<WixRiseV1QueryUnredeemedWalletActionsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRiseWalletActionV1UpstreamWixQueryQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixRiseWalletActionV1UpstreamWixQueryQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1QueryUnredeemedWalletActionsResponse = <T extends Partial<WixRiseV1QueryUnredeemedWalletActionsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActions')) {
        result.walletActions = overrides && overrides.hasOwnProperty('walletActions') ? overrides.walletActions!.map((x) => aWixRiseV1WalletActionWithBalance(x ?? {}, pickedFields.get('walletActions'))) : [aWixRiseV1WalletActionWithBalance({}, pickedFields.get('walletActions'))];
    }

    return result;
};

export const aWixRiseV1QueryWalletActionBalancesRequestInput = <T extends Partial<WixRiseV1QueryWalletActionBalancesRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRiseWalletActionV1UpstreamWixQueryQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixRiseWalletActionV1UpstreamWixQueryQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1QueryWalletActionBalancesResponse = <T extends Partial<WixRiseV1QueryWalletActionBalancesResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2({}, pickedFields.get('pagingMetadata'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActions')) {
        result.walletActions = overrides && overrides.hasOwnProperty('walletActions') ? overrides.walletActions!.map((x) => aWixRiseV1WalletActionWithBalance(x ?? {}, pickedFields.get('walletActions'))) : [aWixRiseV1WalletActionWithBalance({}, pickedFields.get('walletActions'))];
    }

    return result;
};

export const aWixRiseV1QueryWalletActionBalancesResponseWalletActionWithBalance = <T extends Partial<WixRiseV1QueryWalletActionBalancesResponseWalletActionWithBalance>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? overrides.balance! : 'molestiae';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1QueryWalletActionRequestInput = <T extends Partial<WixRiseV1QueryWalletActionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRiseWalletActionV1UpstreamWixQueryQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixRiseWalletActionV1UpstreamWixQueryQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1QueryWalletActionResponse = <T extends Partial<WixRiseV1QueryWalletActionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixRiseV1WalletAction(x ?? {}, pickedFields.get('items'))) : [aWixRiseV1WalletAction({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixRiseV1QueryWalletsByContactRequestInput = <T extends Partial<WixRiseV1QueryWalletsByContactRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRiseV1QueryByContactInput(overrides.query ?? {}, pickedFields.get('query')) : aWixRiseV1QueryByContactInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1QueryWalletsByContactResponse = <T extends Partial<WixRiseV1QueryWalletsByContactResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('wallets')) {
        result.wallets = overrides && overrides.hasOwnProperty('wallets') ? overrides.wallets!.map((x) => aWixRiseV1Wallet(x ?? {}, pickedFields.get('wallets'))) : [aWixRiseV1Wallet({}, pickedFields.get('wallets'))];
    }

    return result;
};

export const aWixRiseV1QueryWalletsRequestInput = <T extends Partial<WixRiseV1QueryWalletsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRiseV1UpstreamWixQueryQueryV2Input(overrides.query ?? {}, pickedFields.get('query')) : aWixRiseV1UpstreamWixQueryQueryV2Input({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseV1QueryWalletsResponse = <T extends Partial<WixRiseV1QueryWalletsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixRiseV1Wallet(x ?? {}, pickedFields.get('items'))) : [aWixRiseV1Wallet({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixRiseV1RedeemOptions = <T extends Partial<WixRiseV1RedeemOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderNumber')) {
        result.orderNumber = overrides && overrides.hasOwnProperty('orderNumber') ? overrides.orderNumber! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPrice')) {
        result.totalPrice = overrides && overrides.hasOwnProperty('totalPrice') ? overrides.totalPrice! : 'repudiandae';
    }

    return result;
};

export const aWixRiseV1RedeemOptionsInput = <T extends Partial<WixRiseV1RedeemOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderNumber')) {
        result.orderNumber = overrides && overrides.hasOwnProperty('orderNumber') ? overrides.orderNumber! : 'ex';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPrice')) {
        result.totalPrice = overrides && overrides.hasOwnProperty('totalPrice') ? overrides.totalPrice! : 'sed';
    }

    return result;
};

export const aWixRiseV1RefundTransactionContextInput = <T extends Partial<WixRiseV1RefundTransactionContextInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'assumenda';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceLocationId')) {
        result.sourceLocationId = overrides && overrides.hasOwnProperty('sourceLocationId') ? overrides.sourceLocationId! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceOrderId')) {
        result.sourceOrderId = overrides && overrides.hasOwnProperty('sourceOrderId') ? overrides.sourceOrderId! : 'distinctio';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceOrderNumber')) {
        result.sourceOrderNumber = overrides && overrides.hasOwnProperty('sourceOrderNumber') ? overrides.sourceOrderNumber! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'animi';
    }

    return result;
};

export const aWixRiseV1RefundTransactionRequestInput = <T extends Partial<WixRiseV1RefundTransactionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'quas';
    }
    if (pickedFields.size === 0 || pickedFields.has('context')) {
        result.context = overrides && overrides.hasOwnProperty('context') ? aWixRiseV1RefundTransactionContextInput(overrides.context ?? {}, pickedFields.get('context')) : aWixRiseV1RefundTransactionContextInput({}, pickedFields.get('context'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'beatae';
    }

    return result;
};

export const aWixRiseV1RefundableAmount = <T extends Partial<WixRiseV1RefundableAmount>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'aspernatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('fundingTransactionId')) {
        result.fundingTransactionId = overrides && overrides.hasOwnProperty('fundingTransactionId') ? overrides.fundingTransactionId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'quia';
    }

    return result;
};

export const aWixRiseV1RewardOptions = <T extends Partial<WixRiseV1RewardOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'et';
    }

    return result;
};

export const aWixRiseV1RewardOptionsInput = <T extends Partial<WixRiseV1RewardOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'voluptas';
    }

    return result;
};

export const aWixRiseV1SearchGiftCardsRequestInput = <T extends Partial<WixRiseV1SearchGiftCardsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('search')) {
        result.search = overrides && overrides.hasOwnProperty('search') ? aWixCommonCursorSearchInput(overrides.search ?? {}, pickedFields.get('search')) : aWixCommonCursorSearchInput({}, pickedFields.get('search'));
    }

    return result;
};

export const aWixRiseV1SearchGiftCardsResponse = <T extends Partial<WixRiseV1SearchGiftCardsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('aggregationData')) {
        result.aggregationData = overrides && overrides.hasOwnProperty('aggregationData') ? aWixCommonAggregationData(overrides.aggregationData ?? {}, pickedFields.get('aggregationData')) : aWixCommonAggregationData({}, pickedFields.get('aggregationData'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCards')) {
        result.giftCards = overrides && overrides.hasOwnProperty('giftCards') ? overrides.giftCards!.map((x) => aWixRiseV1GiftCard(x ?? {}, pickedFields.get('giftCards'))) : [aWixRiseV1GiftCard({}, pickedFields.get('giftCards'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pagingMetadata')) {
        result.pagingMetadata = overrides && overrides.hasOwnProperty('pagingMetadata') ? aWixCommonCursorPagingMetadata(overrides.pagingMetadata ?? {}, pickedFields.get('pagingMetadata')) : aWixCommonCursorPagingMetadata({}, pickedFields.get('pagingMetadata'));
    }

    return result;
};

export const aWixRiseV1SourceInput = <T extends Partial<WixRiseV1SourceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceCustomerId')) {
        result.sourceCustomerId = overrides && overrides.hasOwnProperty('sourceCustomerId') ? overrides.sourceCustomerId! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'aut';
    }

    return result;
};

export const aWixRiseV1StoreCreditContext = <T extends Partial<WixRiseV1StoreCreditContext>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('issuer')) {
        result.issuer = overrides && overrides.hasOwnProperty('issuer') ? overrides.issuer! : WixRiseV1StoreCreditContextStoreCreditIssuerType.Bulk;
    }
    if (pickedFields.size === 0 || pickedFields.has('issuerId')) {
        result.issuerId = overrides && overrides.hasOwnProperty('issuerId') ? overrides.issuerId! : 'debitis';
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'molestias';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'neque';
    }

    return result;
};

export const aWixRiseV1StoreCreditContextInput = <T extends Partial<WixRiseV1StoreCreditContextInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('issuer')) {
        result.issuer = overrides && overrides.hasOwnProperty('issuer') ? overrides.issuer! : WixRiseV1StoreCreditContextStoreCreditIssuerType.Bulk;
    }
    if (pickedFields.size === 0 || pickedFields.has('issuerId')) {
        result.issuerId = overrides && overrides.hasOwnProperty('issuerId') ? overrides.issuerId! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'praesentium';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'neque';
    }

    return result;
};

export const aWixRiseV1StoreCreditOptions = <T extends Partial<WixRiseV1StoreCreditOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('wallet')) {
        result.wallet = overrides && overrides.hasOwnProperty('wallet') ? aWixRiseV1Wallet(overrides.wallet ?? {}, pickedFields.get('wallet')) : aWixRiseV1Wallet({}, pickedFields.get('wallet'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletId')) {
        result.walletId = overrides && overrides.hasOwnProperty('walletId') ? overrides.walletId! : 'non';
    }

    return result;
};

export const aWixRiseV1StoreCreditOptionsInput = <T extends Partial<WixRiseV1StoreCreditOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('walletId')) {
        result.walletId = overrides && overrides.hasOwnProperty('walletId') ? overrides.walletId! : 'eos';
    }

    return result;
};

export const aWixRiseV1StoreCreditRefundOptions = <T extends Partial<WixRiseV1StoreCreditRefundOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'aut';
    }

    return result;
};

export const aWixRiseV1StoreCreditRefundOptionsInput = <T extends Partial<WixRiseV1StoreCreditRefundOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'quia';
    }

    return result;
};

export const aWixRiseV1Transaction = <T extends Partial<WixRiseV1Transaction>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('bulkOptions')) {
        result.bulkOptions = overrides && overrides.hasOwnProperty('bulkOptions') ? aWixRiseV1BulkOptions(overrides.bulkOptions ?? {}, pickedFields.get('bulkOptions')) : aWixRiseV1BulkOptions({}, pickedFields.get('bulkOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('campaignOptions')) {
        result.campaignOptions = overrides && overrides.hasOwnProperty('campaignOptions') ? aWixRiseV1CampaignOptions(overrides.campaignOptions ?? {}, pickedFields.get('campaignOptions')) : aWixRiseV1CampaignOptions({}, pickedFields.get('campaignOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEvent')) {
        result.externalEvent = overrides && overrides.hasOwnProperty('externalEvent') ? aWixRiseV1ExternalEvent(overrides.externalEvent ?? {}, pickedFields.get('externalEvent')) : aWixRiseV1ExternalEvent({}, pickedFields.get('externalEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'nihil';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'quaerat';
    }
    if (pickedFields.size === 0 || pickedFields.has('idempotencyKey')) {
        result.idempotencyKey = overrides && overrides.hasOwnProperty('idempotencyKey') ? overrides.idempotencyKey! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('initialOptions')) {
        result.initialOptions = overrides && overrides.hasOwnProperty('initialOptions') ? aWixRiseV1InitialOptions(overrides.initialOptions ?? {}, pickedFields.get('initialOptions')) : aWixRiseV1InitialOptions({}, pickedFields.get('initialOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('manualOptions')) {
        result.manualOptions = overrides && overrides.hasOwnProperty('manualOptions') ? aWixRiseV1ManualOptions(overrides.manualOptions ?? {}, pickedFields.get('manualOptions')) : aWixRiseV1ManualOptions({}, pickedFields.get('manualOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('migrationOptions')) {
        result.migrationOptions = overrides && overrides.hasOwnProperty('migrationOptions') ? aWixRiseV1MigrationOptions(overrides.migrationOptions ?? {}, pickedFields.get('migrationOptions')) : aWixRiseV1MigrationOptions({}, pickedFields.get('migrationOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('operationType')) {
        result.operationType = overrides && overrides.hasOwnProperty('operationType') ? overrides.operationType! : WixRiseV1TransactionOperationType.Add;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethodRefundOptions')) {
        result.paymentMethodRefundOptions = overrides && overrides.hasOwnProperty('paymentMethodRefundOptions') ? aWixRiseV1PaymentMethodRefundOptions(overrides.paymentMethodRefundOptions ?? {}, pickedFields.get('paymentMethodRefundOptions')) : aWixRiseV1PaymentMethodRefundOptions({}, pickedFields.get('paymentMethodRefundOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('redeemOptions')) {
        result.redeemOptions = overrides && overrides.hasOwnProperty('redeemOptions') ? aWixRiseV1RedeemOptions(overrides.redeemOptions ?? {}, pickedFields.get('redeemOptions')) : aWixRiseV1RedeemOptions({}, pickedFields.get('redeemOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rewardOptions')) {
        result.rewardOptions = overrides && overrides.hasOwnProperty('rewardOptions') ? aWixRiseV1RewardOptions(overrides.rewardOptions ?? {}, pickedFields.get('rewardOptions')) : aWixRiseV1RewardOptions({}, pickedFields.get('rewardOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceInfo')) {
        result.sourceInfo = overrides && overrides.hasOwnProperty('sourceInfo') ? aWixRiseV1TransactionSourceInfo(overrides.sourceInfo ?? {}, pickedFields.get('sourceInfo')) : aWixRiseV1TransactionSourceInfo({}, pickedFields.get('sourceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('storeCreditRefundOptions')) {
        result.storeCreditRefundOptions = overrides && overrides.hasOwnProperty('storeCreditRefundOptions') ? aWixRiseV1StoreCreditRefundOptions(overrides.storeCreditRefundOptions ?? {}, pickedFields.get('storeCreditRefundOptions')) : aWixRiseV1StoreCreditRefundOptions({}, pickedFields.get('storeCreditRefundOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseV1TransactionTransactionType.Bulk;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedBalance')) {
        result.updatedBalance = overrides && overrides.hasOwnProperty('updatedBalance') ? overrides.updatedBalance! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('voidOptions')) {
        result.voidOptions = overrides && overrides.hasOwnProperty('voidOptions') ? aWixRiseV1VoidOptions(overrides.voidOptions ?? {}, pickedFields.get('voidOptions')) : aWixRiseV1VoidOptions({}, pickedFields.get('voidOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionEndOptions')) {
        result.walletActionEndOptions = overrides && overrides.hasOwnProperty('walletActionEndOptions') ? aWixRiseV1WalletActionEndOptions(overrides.walletActionEndOptions ?? {}, pickedFields.get('walletActionEndOptions')) : aWixRiseV1WalletActionEndOptions({}, pickedFields.get('walletActionEndOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionStartOptions')) {
        result.walletActionStartOptions = overrides && overrides.hasOwnProperty('walletActionStartOptions') ? aWixRiseV1WalletActionStartOptions(overrides.walletActionStartOptions ?? {}, pickedFields.get('walletActionStartOptions')) : aWixRiseV1WalletActionStartOptions({}, pickedFields.get('walletActionStartOptions'));
    }

    return result;
};

export const aWixRiseV1TransactionDetails = <T extends Partial<WixRiseV1TransactionDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lastDecreasingTransaction')) {
        result.lastDecreasingTransaction = overrides && overrides.hasOwnProperty('lastDecreasingTransaction') ? aWixRiseV1TransactionDetailsTransactionWrapper(overrides.lastDecreasingTransaction ?? {}, pickedFields.get('lastDecreasingTransaction')) : aWixRiseV1TransactionDetailsTransactionWrapper({}, pickedFields.get('lastDecreasingTransaction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lastIncreasingTransaction')) {
        result.lastIncreasingTransaction = overrides && overrides.hasOwnProperty('lastIncreasingTransaction') ? aWixRiseV1TransactionDetailsTransactionWrapper(overrides.lastIncreasingTransaction ?? {}, pickedFields.get('lastIncreasingTransaction')) : aWixRiseV1TransactionDetailsTransactionWrapper({}, pickedFields.get('lastIncreasingTransaction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lastTransaction')) {
        result.lastTransaction = overrides && overrides.hasOwnProperty('lastTransaction') ? aWixRiseV1TransactionDetailsTransactionWrapper(overrides.lastTransaction ?? {}, pickedFields.get('lastTransaction')) : aWixRiseV1TransactionDetailsTransactionWrapper({}, pickedFields.get('lastTransaction'));
    }

    return result;
};

export const aWixRiseV1TransactionDetailsInput = <T extends Partial<WixRiseV1TransactionDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('lastDecreasingTransaction')) {
        result.lastDecreasingTransaction = overrides && overrides.hasOwnProperty('lastDecreasingTransaction') ? aWixRiseV1TransactionDetailsTransactionWrapperInput(overrides.lastDecreasingTransaction ?? {}, pickedFields.get('lastDecreasingTransaction')) : aWixRiseV1TransactionDetailsTransactionWrapperInput({}, pickedFields.get('lastDecreasingTransaction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lastIncreasingTransaction')) {
        result.lastIncreasingTransaction = overrides && overrides.hasOwnProperty('lastIncreasingTransaction') ? aWixRiseV1TransactionDetailsTransactionWrapperInput(overrides.lastIncreasingTransaction ?? {}, pickedFields.get('lastIncreasingTransaction')) : aWixRiseV1TransactionDetailsTransactionWrapperInput({}, pickedFields.get('lastIncreasingTransaction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('lastTransaction')) {
        result.lastTransaction = overrides && overrides.hasOwnProperty('lastTransaction') ? aWixRiseV1TransactionDetailsTransactionWrapperInput(overrides.lastTransaction ?? {}, pickedFields.get('lastTransaction')) : aWixRiseV1TransactionDetailsTransactionWrapperInput({}, pickedFields.get('lastTransaction'));
    }

    return result;
};

export const aWixRiseV1TransactionDetailsTransactionWrapper = <T extends Partial<WixRiseV1TransactionDetailsTransactionWrapper>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixRiseV1Transaction(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixRiseV1Transaction({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aWixRiseV1TransactionDetailsTransactionWrapperInput = <T extends Partial<WixRiseV1TransactionDetailsTransactionWrapperInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'laudantium';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sed';
    }

    return result;
};

export const aWixRiseV1TransactionInput = <T extends Partial<WixRiseV1TransactionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'labore';
    }
    if (pickedFields.size === 0 || pickedFields.has('campaignOptions')) {
        result.campaignOptions = overrides && overrides.hasOwnProperty('campaignOptions') ? aWixRiseV1CampaignOptionsInput(overrides.campaignOptions ?? {}, pickedFields.get('campaignOptions')) : aWixRiseV1CampaignOptionsInput({}, pickedFields.get('campaignOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'aliquid';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEvent')) {
        result.externalEvent = overrides && overrides.hasOwnProperty('externalEvent') ? aWixRiseV1ExternalEventInput(overrides.externalEvent ?? {}, pickedFields.get('externalEvent')) : aWixRiseV1ExternalEventInput({}, pickedFields.get('externalEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'deserunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('idempotencyKey')) {
        result.idempotencyKey = overrides && overrides.hasOwnProperty('idempotencyKey') ? overrides.idempotencyKey! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('initialOptions')) {
        result.initialOptions = overrides && overrides.hasOwnProperty('initialOptions') ? aWixRiseV1InitialOptionsInput(overrides.initialOptions ?? {}, pickedFields.get('initialOptions')) : aWixRiseV1InitialOptionsInput({}, pickedFields.get('initialOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('manualOptions')) {
        result.manualOptions = overrides && overrides.hasOwnProperty('manualOptions') ? aWixRiseV1ManualOptionsInput(overrides.manualOptions ?? {}, pickedFields.get('manualOptions')) : aWixRiseV1ManualOptionsInput({}, pickedFields.get('manualOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('migrationOptions')) {
        result.migrationOptions = overrides && overrides.hasOwnProperty('migrationOptions') ? aWixRiseV1MigrationOptionsInput(overrides.migrationOptions ?? {}, pickedFields.get('migrationOptions')) : aWixRiseV1MigrationOptionsInput({}, pickedFields.get('migrationOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('operationType')) {
        result.operationType = overrides && overrides.hasOwnProperty('operationType') ? overrides.operationType! : WixRiseV1TransactionOperationType.Add;
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethodRefundOptions')) {
        result.paymentMethodRefundOptions = overrides && overrides.hasOwnProperty('paymentMethodRefundOptions') ? aWixRiseV1PaymentMethodRefundOptionsInput(overrides.paymentMethodRefundOptions ?? {}, pickedFields.get('paymentMethodRefundOptions')) : aWixRiseV1PaymentMethodRefundOptionsInput({}, pickedFields.get('paymentMethodRefundOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('redeemOptions')) {
        result.redeemOptions = overrides && overrides.hasOwnProperty('redeemOptions') ? aWixRiseV1RedeemOptionsInput(overrides.redeemOptions ?? {}, pickedFields.get('redeemOptions')) : aWixRiseV1RedeemOptionsInput({}, pickedFields.get('redeemOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('rewardOptions')) {
        result.rewardOptions = overrides && overrides.hasOwnProperty('rewardOptions') ? aWixRiseV1RewardOptionsInput(overrides.rewardOptions ?? {}, pickedFields.get('rewardOptions')) : aWixRiseV1RewardOptionsInput({}, pickedFields.get('rewardOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceInfo')) {
        result.sourceInfo = overrides && overrides.hasOwnProperty('sourceInfo') ? aWixRiseV1TransactionSourceInfoInput(overrides.sourceInfo ?? {}, pickedFields.get('sourceInfo')) : aWixRiseV1TransactionSourceInfoInput({}, pickedFields.get('sourceInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('storeCreditRefundOptions')) {
        result.storeCreditRefundOptions = overrides && overrides.hasOwnProperty('storeCreditRefundOptions') ? aWixRiseV1StoreCreditRefundOptionsInput(overrides.storeCreditRefundOptions ?? {}, pickedFields.get('storeCreditRefundOptions')) : aWixRiseV1StoreCreditRefundOptionsInput({}, pickedFields.get('storeCreditRefundOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseV1TransactionTransactionType.Bulk;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedBalance')) {
        result.updatedBalance = overrides && overrides.hasOwnProperty('updatedBalance') ? overrides.updatedBalance! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('voidOptions')) {
        result.voidOptions = overrides && overrides.hasOwnProperty('voidOptions') ? aWixRiseV1VoidOptionsInput(overrides.voidOptions ?? {}, pickedFields.get('voidOptions')) : aWixRiseV1VoidOptionsInput({}, pickedFields.get('voidOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionEndOptions')) {
        result.walletActionEndOptions = overrides && overrides.hasOwnProperty('walletActionEndOptions') ? aWixRiseV1WalletActionEndOptionsInput(overrides.walletActionEndOptions ?? {}, pickedFields.get('walletActionEndOptions')) : aWixRiseV1WalletActionEndOptionsInput({}, pickedFields.get('walletActionEndOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionStartOptions')) {
        result.walletActionStartOptions = overrides && overrides.hasOwnProperty('walletActionStartOptions') ? aWixRiseV1WalletActionStartOptionsInput(overrides.walletActionStartOptions ?? {}, pickedFields.get('walletActionStartOptions')) : aWixRiseV1WalletActionStartOptionsInput({}, pickedFields.get('walletActionStartOptions'));
    }

    return result;
};

export const aWixRiseV1TransactionSourceInfo = <T extends Partial<WixRiseV1TransactionSourceInfo>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('initiator')) {
        result.initiator = overrides && overrides.hasOwnProperty('initiator') ? aWixRiseV1ActionInitiator(overrides.initiator ?? {}, pickedFields.get('initiator')) : aWixRiseV1ActionInitiator({}, pickedFields.get('initiator'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceLocationId')) {
        result.sourceLocationId = overrides && overrides.hasOwnProperty('sourceLocationId') ? overrides.sourceLocationId! : 'nam';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'est';
    }

    return result;
};

export const aWixRiseV1TransactionSourceInfoInput = <T extends Partial<WixRiseV1TransactionSourceInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('initiator')) {
        result.initiator = overrides && overrides.hasOwnProperty('initiator') ? aWixRiseV1ActionInitiatorInput(overrides.initiator ?? {}, pickedFields.get('initiator')) : aWixRiseV1ActionInitiatorInput({}, pickedFields.get('initiator'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceLocationId')) {
        result.sourceLocationId = overrides && overrides.hasOwnProperty('sourceLocationId') ? overrides.sourceLocationId! : 'libero';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'quia';
    }

    return result;
};

export const aWixRiseV1UpdateCustomerReferenceRequestInput = <T extends Partial<WixRiseV1UpdateCustomerReferenceRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseV1CustomerReferenceInput(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseV1CustomerReferenceInput({}, pickedFields.get('customerReference'));
    }

    return result;
};

export const aWixRiseV1UpdateCustomerReferenceResponse = <T extends Partial<WixRiseV1UpdateCustomerReferenceResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseV1CustomerReference(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseV1CustomerReference({}, pickedFields.get('customerReference'));
    }

    return result;
};

export const aWixRiseV1UpdateGiftCardRequestInput = <T extends Partial<WixRiseV1UpdateGiftCardRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['corrupti'];
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCardInput(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCardInput({}, pickedFields.get('giftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'pariatur';
    }

    return result;
};

export const aWixRiseV1UpdateGiftCardResponse = <T extends Partial<WixRiseV1UpdateGiftCardResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCard({}, pickedFields.get('giftCard'));
    }

    return result;
};

export const aWixRiseV1UpdateLastActivityForRemindersRequestInput = <T extends Partial<WixRiseV1UpdateLastActivityForRemindersRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'qui';
    }

    return result;
};

export const aWixRiseV1UpdateLastActivityForRemindersResponse = <T extends Partial<WixRiseV1UpdateLastActivityForRemindersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCard({}, pickedFields.get('giftCard'));
    }

    return result;
};

export const aWixRiseV1UpdateWalletActionRequestInput = <T extends Partial<WixRiseV1UpdateWalletActionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('mask')) {
        result.mask = overrides && overrides.hasOwnProperty('mask') ? overrides.mask! : ['iste'];
    }
    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletActionInput(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletActionInput({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1UpdateWalletActionResponse = <T extends Partial<WixRiseV1UpdateWalletActionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixRiseV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 6680;
    }

    return result;
};

export const aWixRiseV1UpstreamWixCommonPagingInput = <T extends Partial<WixRiseV1UpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 5826;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 9308;
    }

    return result;
};

export const aWixRiseV1UpstreamWixCommonSortingInput = <T extends Partial<WixRiseV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'veniam';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixRiseV1UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixRiseV1UpstreamWixQueryQueryV2Input = <T extends Partial<WixRiseV1UpstreamWixQueryQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixRiseV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixRiseV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['culpa'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['officia'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixRiseV1UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixRiseV1UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixRiseV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixRiseV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixRiseV1VoidOptions = <T extends Partial<WixRiseV1VoidOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixRiseV1Transaction(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixRiseV1Transaction({}, pickedFields.get('transaction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'praesentium';
    }

    return result;
};

export const aWixRiseV1VoidOptionsInput = <T extends Partial<WixRiseV1VoidOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'impedit';
    }

    return result;
};

export const aWixRiseV1VoidTransactionRequestInput = <T extends Partial<WixRiseV1VoidTransactionRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'maxime';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'assumenda';
    }

    return result;
};

export const aWixRiseV1VoidTransactionResponse = <T extends Partial<WixRiseV1VoidTransactionResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? overrides.balance! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixRiseV1Transaction(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixRiseV1Transaction({}, pickedFields.get('transaction'));
    }

    return result;
};

export const aWixRiseV1Wallet = <T extends Partial<WixRiseV1Wallet>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('contact')) {
        result.contact = overrides && overrides.hasOwnProperty('contact') ? aComWixpressContactsCoreApiV4Contact(overrides.contact ?? {}, pickedFields.get('contact')) : aComWixpressContactsCoreApiV4Contact({}, pickedFields.get('contact'));
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('customerReferences')) {
        result.customerReferences = overrides && overrides.hasOwnProperty('customerReferences') ? overrides.customerReferences!.map((x) => aWixRiseV1CustomerReference(x ?? {}, pickedFields.get('customerReferences'))) : [aWixRiseV1CustomerReference({}, pickedFields.get('customerReferences'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCard')) {
        result.giftCard = overrides && overrides.hasOwnProperty('giftCard') ? aWixRiseV1GiftCard(overrides.giftCard ?? {}, pickedFields.get('giftCard')) : aWixRiseV1GiftCard({}, pickedFields.get('giftCard'));
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardId')) {
        result.giftCardId = overrides && overrides.hasOwnProperty('giftCardId') ? overrides.giftCardId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('giftCardInfo')) {
        result.giftCardInfo = overrides && overrides.hasOwnProperty('giftCardInfo') ? aWixRiseV1GiftCardInfo(overrides.giftCardInfo ?? {}, pickedFields.get('giftCardInfo')) : aWixRiseV1GiftCardInfo({}, pickedFields.get('giftCardInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'consectetur';
    }
    if (pickedFields.size === 0 || pickedFields.has('primaryCustomerReferenceId')) {
        result.primaryCustomerReferenceId = overrides && overrides.hasOwnProperty('primaryCustomerReferenceId') ? overrides.primaryCustomerReferenceId! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'numquam';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'reprehenderit';
    }

    return result;
};

export const aWixRiseV1WalletAction = <T extends Partial<WixRiseV1WalletAction>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'blanditiis';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDate')) {
        result.disableDate = overrides && overrides.hasOwnProperty('disableDate') ? overrides.disableDate! : 'corrupti';
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationDate')) {
        result.expirationDate = overrides && overrides.hasOwnProperty('expirationDate') ? overrides.expirationDate! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEvent')) {
        result.externalEvent = overrides && overrides.hasOwnProperty('externalEvent') ? aWixRiseV1ExternalEvent(overrides.externalEvent ?? {}, pickedFields.get('externalEvent')) : aWixRiseV1ExternalEvent({}, pickedFields.get('externalEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'perspiciatis';
    }
    if (pickedFields.size === 0 || pickedFields.has('idempotencyKey')) {
        result.idempotencyKey = overrides && overrides.hasOwnProperty('idempotencyKey') ? overrides.idempotencyKey! : 'asperiores';
    }
    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'a';
    }
    if (pickedFields.size === 0 || pickedFields.has('notifications')) {
        result.notifications = overrides && overrides.hasOwnProperty('notifications') ? aWixRiseV1WalletActionNotifications(overrides.notifications ?? {}, pickedFields.get('notifications')) : aWixRiseV1WalletActionNotifications({}, pickedFields.get('notifications'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'ea';
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? aWixRiseV1ActionInitiator(overrides.source ?? {}, pickedFields.get('source')) : aWixRiseV1ActionInitiator({}, pickedFields.get('source'));
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixRiseV1WalletActionWalletActionStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('storeCreditContext')) {
        result.storeCreditContext = overrides && overrides.hasOwnProperty('storeCreditContext') ? aWixRiseV1StoreCreditContext(overrides.storeCreditContext ?? {}, pickedFields.get('storeCreditContext')) : aWixRiseV1StoreCreditContext({}, pickedFields.get('storeCreditContext'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseV1WalletActionWalletActionType.Refund;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'excepturi';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionEnded')) {
        result.walletActionEnded = overrides && overrides.hasOwnProperty('walletActionEnded') ? aWixRiseV1WalletActionWalletActionExecutionDetails(overrides.walletActionEnded ?? {}, pickedFields.get('walletActionEnded')) : aWixRiseV1WalletActionWalletActionExecutionDetails({}, pickedFields.get('walletActionEnded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionStarted')) {
        result.walletActionStarted = overrides && overrides.hasOwnProperty('walletActionStarted') ? aWixRiseV1WalletActionWalletActionExecutionDetails(overrides.walletActionStarted ?? {}, pickedFields.get('walletActionStarted')) : aWixRiseV1WalletActionWalletActionExecutionDetails({}, pickedFields.get('walletActionStarted'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletId')) {
        result.walletId = overrides && overrides.hasOwnProperty('walletId') ? overrides.walletId! : 'repellendus';
    }

    return result;
};

export const aWixRiseV1WalletActionEmailParams = <T extends Partial<WixRiseV1WalletActionEmailParams>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('overrideTemplateId')) {
        result.overrideTemplateId = overrides && overrides.hasOwnProperty('overrideTemplateId') ? overrides.overrideTemplateId! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('skipEmailDispatch')) {
        result.skipEmailDispatch = overrides && overrides.hasOwnProperty('skipEmailDispatch') ? overrides.skipEmailDispatch! : true;
    }

    return result;
};

export const aWixRiseV1WalletActionEmailParamsInput = <T extends Partial<WixRiseV1WalletActionEmailParamsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('overrideTemplateId')) {
        result.overrideTemplateId = overrides && overrides.hasOwnProperty('overrideTemplateId') ? overrides.overrideTemplateId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('skipEmailDispatch')) {
        result.skipEmailDispatch = overrides && overrides.hasOwnProperty('skipEmailDispatch') ? overrides.skipEmailDispatch! : true;
    }

    return result;
};

export const aWixRiseV1WalletActionEndOptions = <T extends Partial<WixRiseV1WalletActionEndOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : WixRiseV1WalletActionEndOptionsWalletActionEndReason.Cancel;
    }
    if (pickedFields.size === 0 || pickedFields.has('transaction')) {
        result.transaction = overrides && overrides.hasOwnProperty('transaction') ? aWixRiseV1Transaction(overrides.transaction ?? {}, pickedFields.get('transaction')) : aWixRiseV1Transaction({}, pickedFields.get('transaction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'earum';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'consequatur';
    }

    return result;
};

export const aWixRiseV1WalletActionEndOptionsInput = <T extends Partial<WixRiseV1WalletActionEndOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('reason')) {
        result.reason = overrides && overrides.hasOwnProperty('reason') ? overrides.reason! : WixRiseV1WalletActionEndOptionsWalletActionEndReason.Cancel;
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'autem';
    }

    return result;
};

export const aWixRiseV1WalletActionInput = <T extends Partial<WixRiseV1WalletActionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'qui';
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'vel';
    }
    if (pickedFields.size === 0 || pickedFields.has('disableDate')) {
        result.disableDate = overrides && overrides.hasOwnProperty('disableDate') ? overrides.disableDate! : 'necessitatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('expirationDate')) {
        result.expirationDate = overrides && overrides.hasOwnProperty('expirationDate') ? overrides.expirationDate! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalEvent')) {
        result.externalEvent = overrides && overrides.hasOwnProperty('externalEvent') ? aWixRiseV1ExternalEventInput(overrides.externalEvent ?? {}, pickedFields.get('externalEvent')) : aWixRiseV1ExternalEventInput({}, pickedFields.get('externalEvent'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sed';
    }
    if (pickedFields.size === 0 || pickedFields.has('idempotencyKey')) {
        result.idempotencyKey = overrides && overrides.hasOwnProperty('idempotencyKey') ? overrides.idempotencyKey! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('note')) {
        result.note = overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('notifications')) {
        result.notifications = overrides && overrides.hasOwnProperty('notifications') ? aWixRiseV1WalletActionNotificationsInput(overrides.notifications ?? {}, pickedFields.get('notifications')) : aWixRiseV1WalletActionNotificationsInput({}, pickedFields.get('notifications'));
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'placeat';
    }
    if (pickedFields.size === 0 || pickedFields.has('source')) {
        result.source = overrides && overrides.hasOwnProperty('source') ? aWixRiseV1ActionInitiatorInput(overrides.source ?? {}, pickedFields.get('source')) : aWixRiseV1ActionInitiatorInput({}, pickedFields.get('source'));
    }
    if (pickedFields.size === 0 || pickedFields.has('startDate')) {
        result.startDate = overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'incidunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixRiseV1WalletActionWalletActionStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('storeCreditContext')) {
        result.storeCreditContext = overrides && overrides.hasOwnProperty('storeCreditContext') ? aWixRiseV1StoreCreditContextInput(overrides.storeCreditContext ?? {}, pickedFields.get('storeCreditContext')) : aWixRiseV1StoreCreditContextInput({}, pickedFields.get('storeCreditContext'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseV1WalletActionWalletActionType.Refund;
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionEnded')) {
        result.walletActionEnded = overrides && overrides.hasOwnProperty('walletActionEnded') ? aWixRiseV1WalletActionWalletActionExecutionDetailsInput(overrides.walletActionEnded ?? {}, pickedFields.get('walletActionEnded')) : aWixRiseV1WalletActionWalletActionExecutionDetailsInput({}, pickedFields.get('walletActionEnded'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionStarted')) {
        result.walletActionStarted = overrides && overrides.hasOwnProperty('walletActionStarted') ? aWixRiseV1WalletActionWalletActionExecutionDetailsInput(overrides.walletActionStarted ?? {}, pickedFields.get('walletActionStarted')) : aWixRiseV1WalletActionWalletActionExecutionDetailsInput({}, pickedFields.get('walletActionStarted'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletId')) {
        result.walletId = overrides && overrides.hasOwnProperty('walletId') ? overrides.walletId! : 'delectus';
    }

    return result;
};

export const aWixRiseV1WalletActionNotifications = <T extends Partial<WixRiseV1WalletActionNotifications>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailParams')) {
        result.emailParams = overrides && overrides.hasOwnProperty('emailParams') ? aWixRiseV1WalletActionEmailParams(overrides.emailParams ?? {}, pickedFields.get('emailParams')) : aWixRiseV1WalletActionEmailParams({}, pickedFields.get('emailParams'));
    }

    return result;
};

export const aWixRiseV1WalletActionNotificationsInput = <T extends Partial<WixRiseV1WalletActionNotificationsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('emailParams')) {
        result.emailParams = overrides && overrides.hasOwnProperty('emailParams') ? aWixRiseV1WalletActionEmailParamsInput(overrides.emailParams ?? {}, pickedFields.get('emailParams')) : aWixRiseV1WalletActionEmailParamsInput({}, pickedFields.get('emailParams'));
    }

    return result;
};

export const aWixRiseV1WalletActionStartOptions = <T extends Partial<WixRiseV1WalletActionStartOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('context')) {
        result.context = overrides && overrides.hasOwnProperty('context') ? aWixRiseV1StoreCreditContext(overrides.context ?? {}, pickedFields.get('context')) : aWixRiseV1StoreCreditContext({}, pickedFields.get('context'));
    }
    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'dicta';
    }

    return result;
};

export const aWixRiseV1WalletActionStartOptionsInput = <T extends Partial<WixRiseV1WalletActionStartOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('context')) {
        result.context = overrides && overrides.hasOwnProperty('context') ? aWixRiseV1StoreCreditContextInput(overrides.context ?? {}, pickedFields.get('context')) : aWixRiseV1StoreCreditContextInput({}, pickedFields.get('context'));
    }
    if (pickedFields.size === 0 || pickedFields.has('liability')) {
        result.liability = overrides && overrides.hasOwnProperty('liability') ? overrides.liability! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('walletActionId')) {
        result.walletActionId = overrides && overrides.hasOwnProperty('walletActionId') ? overrides.walletActionId! : 'id';
    }

    return result;
};

export const aWixRiseV1WalletActionWalletActionContextWorkflowPayload = <T extends Partial<WixRiseV1WalletActionWalletActionContextWorkflowPayload>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'dolorum';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'iure';
    }

    return result;
};

export const aWixRiseV1WalletActionWalletActionContextWorkflowPayloadInput = <T extends Partial<WixRiseV1WalletActionWalletActionContextWorkflowPayloadInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'excepturi';
    }

    return result;
};

export const aWixRiseV1WalletActionWalletActionExecutionDetails = <T extends Partial<WixRiseV1WalletActionWalletActionExecutionDetails>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('executionDate')) {
        result.executionDate = overrides && overrides.hasOwnProperty('executionDate') ? overrides.executionDate! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'aut';
    }

    return result;
};

export const aWixRiseV1WalletActionWalletActionExecutionDetailsInput = <T extends Partial<WixRiseV1WalletActionWalletActionExecutionDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('executionDate')) {
        result.executionDate = overrides && overrides.hasOwnProperty('executionDate') ? overrides.executionDate! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('transactionId')) {
        result.transactionId = overrides && overrides.hasOwnProperty('transactionId') ? overrides.transactionId! : 'mollitia';
    }

    return result;
};

export const aWixRiseV1WalletActionWithBalance = <T extends Partial<WixRiseV1WalletActionWithBalance>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('balance')) {
        result.balance = overrides && overrides.hasOwnProperty('balance') ? overrides.balance! : 'animi';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletAction')) {
        result.walletAction = overrides && overrides.hasOwnProperty('walletAction') ? aWixRiseV1WalletAction(overrides.walletAction ?? {}, pickedFields.get('walletAction')) : aWixRiseV1WalletAction({}, pickedFields.get('walletAction'));
    }

    return result;
};

export const aWixRiseV1WalletQueryInput = <T extends Partial<WixRiseV1WalletQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('customerReferenceSource')) {
        result.customerReferenceSource = overrides && overrides.hasOwnProperty('customerReferenceSource') ? aWixRiseV1SourceInput(overrides.customerReferenceSource ?? {}, pickedFields.get('customerReferenceSource')) : aWixRiseV1SourceInput({}, pickedFields.get('customerReferenceSource'));
    }
    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('walletId')) {
        result.walletId = overrides && overrides.hasOwnProperty('walletId') ? overrides.walletId! : 'dignissimos';
    }

    return result;
};

export const aWixRiseV1WorkflowOptions = <T extends Partial<WixRiseV1WorkflowOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('workflowId')) {
        result.workflowId = overrides && overrides.hasOwnProperty('workflowId') ? overrides.workflowId! : 'quaerat';
    }

    return result;
};

export const aWixRiseV1WorkflowOptionsInput = <T extends Partial<WixRiseV1WorkflowOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('workflowId')) {
        result.workflowId = overrides && overrides.hasOwnProperty('workflowId') ? overrides.workflowId! : 'asperiores';
    }

    return result;
};

export const aWixRiseWalletActionV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixRiseWalletActionV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 7836;
    }

    return result;
};

export const aWixRiseWalletActionV1UpstreamWixCommonCursors = <T extends Partial<WixRiseWalletActionV1UpstreamWixCommonCursors>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('next')) {
        result.next = overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'esse';
    }
    if (pickedFields.size === 0 || pickedFields.has('prev')) {
        result.prev = overrides && overrides.hasOwnProperty('prev') ? overrides.prev! : 'architecto';
    }

    return result;
};

export const aWixRiseWalletActionV1UpstreamWixCommonPagingInput = <T extends Partial<WixRiseWalletActionV1UpstreamWixCommonPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 3364;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 8650;
    }

    return result;
};

export const aWixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2 = <T extends Partial<WixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('count')) {
        result.count = overrides && overrides.hasOwnProperty('count') ? overrides.count! : 4391;
    }
    if (pickedFields.size === 0 || pickedFields.has('cursors')) {
        result.cursors = overrides && overrides.hasOwnProperty('cursors') ? aWixRiseWalletActionV1UpstreamWixCommonCursors(overrides.cursors ?? {}, pickedFields.get('cursors')) : aWixRiseWalletActionV1UpstreamWixCommonCursors({}, pickedFields.get('cursors'));
    }
    if (pickedFields.size === 0 || pickedFields.has('hasNext')) {
        result.hasNext = overrides && overrides.hasOwnProperty('hasNext') ? overrides.hasNext! : true;
    }
    if (pickedFields.size === 0 || pickedFields.has('offset')) {
        result.offset = overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 4856;
    }
    if (pickedFields.size === 0 || pickedFields.has('tooManyToCount')) {
        result.tooManyToCount = overrides && overrides.hasOwnProperty('tooManyToCount') ? overrides.tooManyToCount! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 91;
    }

    return result;
};

export const aWixRiseWalletActionV1UpstreamWixCommonSortingInput = <T extends Partial<WixRiseWalletActionV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixRiseWalletActionV1UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixRiseWalletActionV1UpstreamWixQueryQueryV2Input = <T extends Partial<WixRiseWalletActionV1UpstreamWixQueryQueryV2Input>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixRiseWalletActionV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixRiseWalletActionV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fields')) {
        result.fields = overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['aut'];
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsets')) {
        result.fieldsets = overrides && overrides.hasOwnProperty('fieldsets') ? overrides.fieldsets! : ['commodi'];
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('paging')) {
        result.paging = overrides && overrides.hasOwnProperty('paging') ? aWixRiseWalletActionV1UpstreamWixCommonPagingInput(overrides.paging ?? {}, pickedFields.get('paging')) : aWixRiseWalletActionV1UpstreamWixCommonPagingInput({}, pickedFields.get('paging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixRiseWalletActionV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixRiseWalletActionV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixRiseWorkflowV1Action = <T extends Partial<WixRiseWorkflowV1Action>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conditionOptions')) {
        result.conditionOptions = overrides && overrides.hasOwnProperty('conditionOptions') ? aWixRiseWorkflowV1ConditionOptions(overrides.conditionOptions ?? {}, pickedFields.get('conditionOptions')) : aWixRiseWorkflowV1ConditionOptions({}, pickedFields.get('conditionOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsReferences')) {
        result.fieldsReferences = overrides && overrides.hasOwnProperty('fieldsReferences') ? aWixRiseWorkflowV1FieldValueMapper(overrides.fieldsReferences ?? {}, pickedFields.get('fieldsReferences')) : aWixRiseWorkflowV1FieldValueMapper({}, pickedFields.get('fieldsReferences'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ipsam';
    }
    if (pickedFields.size === 0 || pickedFields.has('issueStoreCreditOptions')) {
        result.issueStoreCreditOptions = overrides && overrides.hasOwnProperty('issueStoreCreditOptions') ? aWixRiseWorkflowV1IssueStoreCreditOptions(overrides.issueStoreCreditOptions ?? {}, pickedFields.get('issueStoreCreditOptions')) : aWixRiseWorkflowV1IssueStoreCreditOptions({}, pickedFields.get('issueStoreCreditOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseWorkflowV1ActionActionType.Condition;
    }

    return result;
};

export const aWixRiseWorkflowV1ActionInput = <T extends Partial<WixRiseWorkflowV1ActionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('conditionOptions')) {
        result.conditionOptions = overrides && overrides.hasOwnProperty('conditionOptions') ? aWixRiseWorkflowV1ConditionOptionsInput(overrides.conditionOptions ?? {}, pickedFields.get('conditionOptions')) : aWixRiseWorkflowV1ConditionOptionsInput({}, pickedFields.get('conditionOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('fieldsReferences')) {
        result.fieldsReferences = overrides && overrides.hasOwnProperty('fieldsReferences') ? aWixRiseWorkflowV1FieldValueMapperInput(overrides.fieldsReferences ?? {}, pickedFields.get('fieldsReferences')) : aWixRiseWorkflowV1FieldValueMapperInput({}, pickedFields.get('fieldsReferences'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('issueStoreCreditOptions')) {
        result.issueStoreCreditOptions = overrides && overrides.hasOwnProperty('issueStoreCreditOptions') ? aWixRiseWorkflowV1IssueStoreCreditOptionsInput(overrides.issueStoreCreditOptions ?? {}, pickedFields.get('issueStoreCreditOptions')) : aWixRiseWorkflowV1IssueStoreCreditOptionsInput({}, pickedFields.get('issueStoreCreditOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseWorkflowV1ActionActionType.Condition;
    }

    return result;
};

export const aWixRiseWorkflowV1ConditionOptions = <T extends Partial<WixRiseWorkflowV1ConditionOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('actions')) {
        result.actions = overrides && overrides.hasOwnProperty('actions') ? overrides.actions!.map((x) => aWixRiseWorkflowV1Action(x ?? {}, pickedFields.get('actions'))) : [aWixRiseWorkflowV1Action({}, pickedFields.get('actions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('conditions')) {
        result.conditions = overrides && overrides.hasOwnProperty('conditions') ? overrides.conditions!.map((x) => aWixRiseWorkflowV1LogicalCondition(x ?? {}, pickedFields.get('conditions'))) : [aWixRiseWorkflowV1LogicalCondition({}, pickedFields.get('conditions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('operator')) {
        result.operator = overrides && overrides.hasOwnProperty('operator') ? overrides.operator! : WixRiseWorkflowV1ConditionOptionsCompoundOperator.And;
    }

    return result;
};

export const aWixRiseWorkflowV1ConditionOptionsInput = <T extends Partial<WixRiseWorkflowV1ConditionOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('actions')) {
        result.actions = overrides && overrides.hasOwnProperty('actions') ? overrides.actions!.map((x) => aWixRiseWorkflowV1ActionInput({}, pickedFields.get('actions'))) : [aWixRiseWorkflowV1ActionInput({}, pickedFields.get('actions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('conditions')) {
        result.conditions = overrides && overrides.hasOwnProperty('conditions') ? overrides.conditions!.map((x) => aWixRiseWorkflowV1LogicalConditionInput({}, pickedFields.get('conditions'))) : [aWixRiseWorkflowV1LogicalConditionInput({}, pickedFields.get('conditions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('operator')) {
        result.operator = overrides && overrides.hasOwnProperty('operator') ? overrides.operator! : WixRiseWorkflowV1ConditionOptionsCompoundOperator.And;
    }

    return result;
};

export const aWixRiseWorkflowV1CreateWorkflowRequestInput = <T extends Partial<WixRiseWorkflowV1CreateWorkflowRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('workflow')) {
        result.workflow = overrides && overrides.hasOwnProperty('workflow') ? aWixRiseWorkflowV1WorkflowInput(overrides.workflow ?? {}, pickedFields.get('workflow')) : aWixRiseWorkflowV1WorkflowInput({}, pickedFields.get('workflow'));
    }

    return result;
};

export const aWixRiseWorkflowV1CreateWorkflowResponse = <T extends Partial<WixRiseWorkflowV1CreateWorkflowResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('workflow')) {
        result.workflow = overrides && overrides.hasOwnProperty('workflow') ? aWixRiseWorkflowV1Workflow(overrides.workflow ?? {}, pickedFields.get('workflow')) : aWixRiseWorkflowV1Workflow({}, pickedFields.get('workflow'));
    }

    return result;
};

export const aWixRiseWorkflowV1CustomerReferenceInput = <T extends Partial<WixRiseWorkflowV1CustomerReferenceInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('email')) {
        result.email = overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('firstName')) {
        result.firstName = overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'similique';
    }
    if (pickedFields.size === 0 || pickedFields.has('lastName')) {
        result.lastName = overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('phone')) {
        result.phone = overrides && overrides.hasOwnProperty('phone') ? overrides.phone! : 'ut';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceChannelId')) {
        result.sourceChannelId = overrides && overrides.hasOwnProperty('sourceChannelId') ? overrides.sourceChannelId! : 'est';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceCustomerId')) {
        result.sourceCustomerId = overrides && overrides.hasOwnProperty('sourceCustomerId') ? overrides.sourceCustomerId! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('sourceTenantId')) {
        result.sourceTenantId = overrides && overrides.hasOwnProperty('sourceTenantId') ? overrides.sourceTenantId! : 'quae';
    }

    return result;
};

export const aWixRiseWorkflowV1DeleteWorkflowRequestInput = <T extends Partial<WixRiseWorkflowV1DeleteWorkflowRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'voluptas';
    }
    if (pickedFields.size === 0 || pickedFields.has('workflowId')) {
        result.workflowId = overrides && overrides.hasOwnProperty('workflowId') ? overrides.workflowId! : 'molestias';
    }

    return result;
};

export const aWixRiseWorkflowV1FieldValueMapper = <T extends Partial<WixRiseWorkflowV1FieldValueMapper>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseWorkflowV1FieldValueMapperMappingType.Fixed;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'reprehenderit';
    }

    return result;
};

export const aWixRiseWorkflowV1FieldValueMapperInput = <T extends Partial<WixRiseWorkflowV1FieldValueMapperInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseWorkflowV1FieldValueMapperMappingType.Fixed;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'autem';
    }

    return result;
};

export const aWixRiseWorkflowV1GetWorkflowRequestInput = <T extends Partial<WixRiseWorkflowV1GetWorkflowRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9f9dbbb9-090d-4483-9e99-fc43b2058f95';
    }

    return result;
};

export const aWixRiseWorkflowV1IssueStoreCreditOptions = <T extends Partial<WixRiseWorkflowV1IssueStoreCreditOptions>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('settings')) {
        result.settings = overrides && overrides.hasOwnProperty('settings') ? aWixRiseWorkflowV1IssueStoreCreditSettings(overrides.settings ?? {}, pickedFields.get('settings')) : aWixRiseWorkflowV1IssueStoreCreditSettings({}, pickedFields.get('settings'));
    }

    return result;
};

export const aWixRiseWorkflowV1IssueStoreCreditOptionsInput = <T extends Partial<WixRiseWorkflowV1IssueStoreCreditOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('settings')) {
        result.settings = overrides && overrides.hasOwnProperty('settings') ? aWixRiseWorkflowV1IssueStoreCreditSettingsInput(overrides.settings ?? {}, pickedFields.get('settings')) : aWixRiseWorkflowV1IssueStoreCreditSettingsInput({}, pickedFields.get('settings'));
    }

    return result;
};

export const aWixRiseWorkflowV1IssueStoreCreditSettings = <T extends Partial<WixRiseWorkflowV1IssueStoreCreditSettings>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'mollitia';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseWorkflowV1IssueStoreCreditSettingsType.Fixed;
    }

    return result;
};

export const aWixRiseWorkflowV1IssueStoreCreditSettingsInput = <T extends Partial<WixRiseWorkflowV1IssueStoreCreditSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('amount')) {
        result.amount = overrides && overrides.hasOwnProperty('amount') ? overrides.amount! : 'ipsum';
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseWorkflowV1IssueStoreCreditSettingsType.Fixed;
    }

    return result;
};

export const aWixRiseWorkflowV1ListTriggersResponse = <T extends Partial<WixRiseWorkflowV1ListTriggersResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('triggers')) {
        result.triggers = overrides && overrides.hasOwnProperty('triggers') ? overrides.triggers!.map((x) => aWixRiseWorkflowV1Trigger(x ?? {}, pickedFields.get('triggers'))) : [aWixRiseWorkflowV1Trigger({}, pickedFields.get('triggers'))];
    }

    return result;
};

export const aWixRiseWorkflowV1LogicalCondition = <T extends Partial<WixRiseWorkflowV1LogicalCondition>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldReference')) {
        result.fieldReference = overrides && overrides.hasOwnProperty('fieldReference') ? overrides.fieldReference! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('operator')) {
        result.operator = overrides && overrides.hasOwnProperty('operator') ? overrides.operator! : WixRiseWorkflowV1LogicalConditionLogicalOperator.Eq;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'reprehenderit';
    }

    return result;
};

export const aWixRiseWorkflowV1LogicalConditionInput = <T extends Partial<WixRiseWorkflowV1LogicalConditionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldReference')) {
        result.fieldReference = overrides && overrides.hasOwnProperty('fieldReference') ? overrides.fieldReference! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('operator')) {
        result.operator = overrides && overrides.hasOwnProperty('operator') ? overrides.operator! : WixRiseWorkflowV1LogicalConditionLogicalOperator.Eq;
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'eos';
    }

    return result;
};

export const aWixRiseWorkflowV1OrderPaidOptionsInput = <T extends Partial<WixRiseWorkflowV1OrderPaidOptionsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('payload')) {
        result.payload = overrides && overrides.hasOwnProperty('payload') ? aWixRiseWorkflowV1OrderPaidPayloadInput(overrides.payload ?? {}, pickedFields.get('payload')) : aWixRiseWorkflowV1OrderPaidPayloadInput({}, pickedFields.get('payload'));
    }

    return result;
};

export const aWixRiseWorkflowV1OrderPaidPayloadInput = <T extends Partial<WixRiseWorkflowV1OrderPaidPayloadInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'amet';
    }
    if (pickedFields.size === 0 || pickedFields.has('customerReference')) {
        result.customerReference = overrides && overrides.hasOwnProperty('customerReference') ? aWixRiseWorkflowV1CustomerReferenceInput(overrides.customerReference ?? {}, pickedFields.get('customerReference')) : aWixRiseWorkflowV1CustomerReferenceInput({}, pickedFields.get('customerReference'));
    }
    if (pickedFields.size === 0 || pickedFields.has('orderId')) {
        result.orderId = overrides && overrides.hasOwnProperty('orderId') ? overrides.orderId! : 'culpa';
    }
    if (pickedFields.size === 0 || pickedFields.has('orderTotal')) {
        result.orderTotal = overrides && overrides.hasOwnProperty('orderTotal') ? overrides.orderTotal! : 'sed';
    }

    return result;
};

export const aWixRiseWorkflowV1QueryWorkflowsRequestInput = <T extends Partial<WixRiseWorkflowV1QueryWorkflowsRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('query')) {
        result.query = overrides && overrides.hasOwnProperty('query') ? aWixRiseWorkflowV1UpstreamWixQueryCursorQueryInput(overrides.query ?? {}, pickedFields.get('query')) : aWixRiseWorkflowV1UpstreamWixQueryCursorQueryInput({}, pickedFields.get('query'));
    }

    return result;
};

export const aWixRiseWorkflowV1QueryWorkflowsResponse = <T extends Partial<WixRiseWorkflowV1QueryWorkflowsResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('items')) {
        result.items = overrides && overrides.hasOwnProperty('items') ? overrides.items!.map((x) => aWixRiseWorkflowV1Workflow(x ?? {}, pickedFields.get('items'))) : [aWixRiseWorkflowV1Workflow({}, pickedFields.get('items'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('pageInfo')) {
        result.pageInfo = overrides && overrides.hasOwnProperty('pageInfo') ? aPageInfo(overrides.pageInfo ?? {}, pickedFields.get('pageInfo')) : aPageInfo({}, pickedFields.get('pageInfo'));
    }

    return result;
};

export const aWixRiseWorkflowV1ReportTriggerRequestInput = <T extends Partial<WixRiseWorkflowV1ReportTriggerRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('orderPaidOptions')) {
        result.orderPaidOptions = overrides && overrides.hasOwnProperty('orderPaidOptions') ? aWixRiseWorkflowV1OrderPaidOptionsInput(overrides.orderPaidOptions ?? {}, pickedFields.get('orderPaidOptions')) : aWixRiseWorkflowV1OrderPaidOptionsInput({}, pickedFields.get('orderPaidOptions'));
    }
    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixRiseWorkflowV1ReportTriggerRequestTriggerType.OrderPaid;
    }

    return result;
};

export const aWixRiseWorkflowV1Trigger = <T extends Partial<WixRiseWorkflowV1Trigger>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'consequatur';
    }

    return result;
};

export const aWixRiseWorkflowV1UpdateWorkflowRequestInput = <T extends Partial<WixRiseWorkflowV1UpdateWorkflowRequestInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldMask')) {
        result.fieldMask = overrides && overrides.hasOwnProperty('fieldMask') ? overrides.fieldMask! : ['saepe'];
    }
    if (pickedFields.size === 0 || pickedFields.has('workflow')) {
        result.workflow = overrides && overrides.hasOwnProperty('workflow') ? aWixRiseWorkflowV1WorkflowInput(overrides.workflow ?? {}, pickedFields.get('workflow')) : aWixRiseWorkflowV1WorkflowInput({}, pickedFields.get('workflow'));
    }

    return result;
};

export const aWixRiseWorkflowV1UpdateWorkflowResponse = <T extends Partial<WixRiseWorkflowV1UpdateWorkflowResponse>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('workflow')) {
        result.workflow = overrides && overrides.hasOwnProperty('workflow') ? aWixRiseWorkflowV1Workflow(overrides.workflow ?? {}, pickedFields.get('workflow')) : aWixRiseWorkflowV1Workflow({}, pickedFields.get('workflow'));
    }

    return result;
};

export const aWixRiseWorkflowV1UpstreamWixCommonCursorPagingInput = <T extends Partial<WixRiseWorkflowV1UpstreamWixCommonCursorPagingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursor')) {
        result.cursor = overrides && overrides.hasOwnProperty('cursor') ? overrides.cursor! : 'eum';
    }
    if (pickedFields.size === 0 || pickedFields.has('limit')) {
        result.limit = overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 8253;
    }

    return result;
};

export const aWixRiseWorkflowV1UpstreamWixCommonSortingInput = <T extends Partial<WixRiseWorkflowV1UpstreamWixCommonSortingInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('fieldName')) {
        result.fieldName = overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'velit';
    }
    if (pickedFields.size === 0 || pickedFields.has('order')) {
        result.order = overrides && overrides.hasOwnProperty('order') ? overrides.order! : WixRiseWorkflowV1UpstreamWixCommonSortOrder.Asc;
    }

    return result;
};

export const aWixRiseWorkflowV1UpstreamWixQueryCursorQueryInput = <T extends Partial<WixRiseWorkflowV1UpstreamWixQueryCursorQueryInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('cursorPaging')) {
        result.cursorPaging = overrides && overrides.hasOwnProperty('cursorPaging') ? aWixRiseWorkflowV1UpstreamWixCommonCursorPagingInput(overrides.cursorPaging ?? {}, pickedFields.get('cursorPaging')) : aWixRiseWorkflowV1UpstreamWixCommonCursorPagingInput({}, pickedFields.get('cursorPaging'));
    }
    if (pickedFields.size === 0 || pickedFields.has('filter')) {
        result.filter = overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'doloribus';
    }
    if (pickedFields.size === 0 || pickedFields.has('sort')) {
        result.sort = overrides && overrides.hasOwnProperty('sort') ? overrides.sort!.map((x) => aWixRiseWorkflowV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))) : [aWixRiseWorkflowV1UpstreamWixCommonSortingInput({}, pickedFields.get('sort'))];
    }

    return result;
};

export const aWixRiseWorkflowV1Workflow = <T extends Partial<WixRiseWorkflowV1Workflow>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('actions')) {
        result.actions = overrides && overrides.hasOwnProperty('actions') ? overrides.actions!.map((x) => aWixRiseWorkflowV1Action(x ?? {}, pickedFields.get('actions'))) : [aWixRiseWorkflowV1Action({}, pickedFields.get('actions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('esbConfigurationId')) {
        result.esbConfigurationId = overrides && overrides.hasOwnProperty('esbConfigurationId') ? overrides.esbConfigurationId! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'iste';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'fuga';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixRiseWorkflowV1WorkflowStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('triggerId')) {
        result.triggerId = overrides && overrides.hasOwnProperty('triggerId') ? overrides.triggerId! : 'sint';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'voluptatum';
    }

    return result;
};

export const aWixRiseWorkflowV1WorkflowInput = <T extends Partial<WixRiseWorkflowV1WorkflowInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('actions')) {
        result.actions = overrides && overrides.hasOwnProperty('actions') ? overrides.actions!.map((x) => aWixRiseWorkflowV1ActionInput({}, pickedFields.get('actions'))) : [aWixRiseWorkflowV1ActionInput({}, pickedFields.get('actions'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('createdDate')) {
        result.createdDate = overrides && overrides.hasOwnProperty('createdDate') ? overrides.createdDate! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('esbConfigurationId')) {
        result.esbConfigurationId = overrides && overrides.hasOwnProperty('esbConfigurationId') ? overrides.esbConfigurationId! : 'quod';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sit';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('revision')) {
        result.revision = overrides && overrides.hasOwnProperty('revision') ? overrides.revision! : 'omnis';
    }
    if (pickedFields.size === 0 || pickedFields.has('status')) {
        result.status = overrides && overrides.hasOwnProperty('status') ? overrides.status! : WixRiseWorkflowV1WorkflowStatus.Active;
    }
    if (pickedFields.size === 0 || pickedFields.has('triggerId')) {
        result.triggerId = overrides && overrides.hasOwnProperty('triggerId') ? overrides.triggerId! : 'facere';
    }
    if (pickedFields.size === 0 || pickedFields.has('updatedDate')) {
        result.updatedDate = overrides && overrides.hasOwnProperty('updatedDate') ? overrides.updatedDate! : 'a';
    }

    return result;
};

export const aWixSearchV1SearchIndexingNotificationInput = <T extends Partial<WixSearchV1SearchIndexingNotificationInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('documentType')) {
        result.documentType = overrides && overrides.hasOwnProperty('documentType') ? overrides.documentType! : 'officia';
    }
    if (pickedFields.size === 0 || pickedFields.has('indexState')) {
        result.indexState = overrides && overrides.hasOwnProperty('indexState') ? overrides.indexState! : WixSearchV1SearchIndexingNotificationState.Off;
    }
    if (pickedFields.size === 0 || pickedFields.has('language')) {
        result.language = overrides && overrides.hasOwnProperty('language') ? overrides.language! : 'magnam';
    }
    if (pickedFields.size === 0 || pickedFields.has('msId')) {
        result.msId = overrides && overrides.hasOwnProperty('msId') ? overrides.msId! : 'non';
    }

    return result;
};

export const aWixSubscriptionsApiV1AppliedCouponInput = <T extends Partial<WixSubscriptionsApiV1AppliedCouponInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('code')) {
        result.code = overrides && overrides.hasOwnProperty('code') ? overrides.code! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('couponId')) {
        result.couponId = overrides && overrides.hasOwnProperty('couponId') ? overrides.couponId! : 'enim';
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'voluptatem';
    }

    return result;
};

export const aWixSubscriptionsApiV1BillingInfoInput = <T extends Partial<WixSubscriptionsApiV1BillingInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayOrderId')) {
        result.paymentGatewayOrderId = overrides && overrides.hasOwnProperty('paymentGatewayOrderId') ? overrides.paymentGatewayOrderId! : 'dolores';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentGatewayTransactionId')) {
        result.paymentGatewayTransactionId = overrides && overrides.hasOwnProperty('paymentGatewayTransactionId') ? overrides.paymentGatewayTransactionId! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('paymentMethod')) {
        result.paymentMethod = overrides && overrides.hasOwnProperty('paymentMethod') ? overrides.paymentMethod! : 'ut';
    }

    return result;
};

export const aWixSubscriptionsApiV1BuyerInfoInput = <T extends Partial<WixSubscriptionsApiV1BuyerInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'provident';
    }
    if (pickedFields.size === 0 || pickedFields.has('identityType')) {
        result.identityType = overrides && overrides.hasOwnProperty('identityType') ? overrides.identityType! : WixSubscriptionsApiV1IdentityType.Contact;
    }
    if (pickedFields.size === 0 || pickedFields.has('visitorId')) {
        result.visitorId = overrides && overrides.hasOwnProperty('visitorId') ? overrides.visitorId! : 'magnam';
    }

    return result;
};

export const aWixSubscriptionsApiV1ChannelInfoInput = <T extends Partial<WixSubscriptionsApiV1ChannelInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('type')) {
        result.type = overrides && overrides.hasOwnProperty('type') ? overrides.type! : WixSubscriptionsApiV1ChannelInfoChannelType.OtherPlatform;
    }

    return result;
};

export const aWixSubscriptionsApiV1ChargeDetailsInput = <T extends Partial<WixSubscriptionsApiV1ChargeDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? overrides.discount! : 5.3;
    }
    if (pickedFields.size === 0 || pickedFields.has('price')) {
        result.price = overrides && overrides.hasOwnProperty('price') ? overrides.price! : 3.8;
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : 3.43;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxIncludedInPrice')) {
        result.taxIncludedInPrice = overrides && overrides.hasOwnProperty('taxIncludedInPrice') ? overrides.taxIncludedInPrice! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxRate')) {
        result.taxRate = overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('totalPrice')) {
        result.totalPrice = overrides && overrides.hasOwnProperty('totalPrice') ? overrides.totalPrice! : 5.24;
    }

    return result;
};

export const aWixSubscriptionsApiV1CustomFieldInput = <T extends Partial<WixSubscriptionsApiV1CustomFieldInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'voluptatibus';
    }
    if (pickedFields.size === 0 || pickedFields.has('translatedTitle')) {
        result.translatedTitle = overrides && overrides.hasOwnProperty('translatedTitle') ? overrides.translatedTitle! : 'rerum';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'quas';
    }

    return result;
};

export const aWixSubscriptionsApiV1CustomTextFieldSelectionInput = <T extends Partial<WixSubscriptionsApiV1CustomTextFieldSelectionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'voluptate';
    }
    if (pickedFields.size === 0 || pickedFields.has('value')) {
        result.value = overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'voluptatem';
    }

    return result;
};

export const aWixSubscriptionsApiV1LineItemInput = <T extends Partial<WixSubscriptionsApiV1LineItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('chargeDetails')) {
        result.chargeDetails = overrides && overrides.hasOwnProperty('chargeDetails') ? aWixSubscriptionsApiV1ChargeDetailsInput(overrides.chargeDetails ?? {}, pickedFields.get('chargeDetails')) : aWixSubscriptionsApiV1ChargeDetailsInput({}, pickedFields.get('chargeDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('customTextFields')) {
        result.customTextFields = overrides && overrides.hasOwnProperty('customTextFields') ? overrides.customTextFields!.map((x) => aWixSubscriptionsApiV1CustomTextFieldSelectionInput({}, pickedFields.get('customTextFields'))) : [aWixSubscriptionsApiV1CustomTextFieldSelectionInput({}, pickedFields.get('customTextFields'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('index')) {
        result.index = overrides && overrides.hasOwnProperty('index') ? overrides.index! : 6618;
    }
    if (pickedFields.size === 0 || pickedFields.has('options')) {
        result.options = overrides && overrides.hasOwnProperty('options') ? overrides.options!.map((x) => aWixSubscriptionsApiV1OptionSelectionInput({}, pickedFields.get('options'))) : [aWixSubscriptionsApiV1OptionSelectionInput({}, pickedFields.get('options'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('productDetails')) {
        result.productDetails = overrides && overrides.hasOwnProperty('productDetails') ? aWixSubscriptionsApiV1ProductDetailsInput(overrides.productDetails ?? {}, pickedFields.get('productDetails')) : aWixSubscriptionsApiV1ProductDetailsInput({}, pickedFields.get('productDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 9564;
    }
    if (pickedFields.size === 0 || pickedFields.has('variantId')) {
        result.variantId = overrides && overrides.hasOwnProperty('variantId') ? overrides.variantId! : 'cupiditate';
    }

    return result;
};

export const aWixSubscriptionsApiV1MediaItemInput = <T extends Partial<WixSubscriptionsApiV1MediaItemInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('altText')) {
        result.altText = overrides && overrides.hasOwnProperty('altText') ? overrides.altText! : 'quae';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalImageUrl')) {
        result.externalImageUrl = overrides && overrides.hasOwnProperty('externalImageUrl') ? overrides.externalImageUrl! : 'dicta';
    }
    if (pickedFields.size === 0 || pickedFields.has('height')) {
        result.height = overrides && overrides.hasOwnProperty('height') ? overrides.height! : 9365;
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'minima';
    }
    if (pickedFields.size === 0 || pickedFields.has('mediaType')) {
        result.mediaType = overrides && overrides.hasOwnProperty('mediaType') ? overrides.mediaType! : WixSubscriptionsApiV1MediaItemType.Image;
    }
    if (pickedFields.size === 0 || pickedFields.has('url')) {
        result.url = overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'nulla';
    }
    if (pickedFields.size === 0 || pickedFields.has('width')) {
        result.width = overrides && overrides.hasOwnProperty('width') ? overrides.width! : 673;
    }

    return result;
};

export const aWixSubscriptionsApiV1OptionSelectionInput = <T extends Partial<WixSubscriptionsApiV1OptionSelectionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('option')) {
        result.option = overrides && overrides.hasOwnProperty('option') ? overrides.option! : 'suscipit';
    }
    if (pickedFields.size === 0 || pickedFields.has('selection')) {
        result.selection = overrides && overrides.hasOwnProperty('selection') ? overrides.selection! : 'voluptas';
    }

    return result;
};

export const aWixSubscriptionsApiV1PickupAddressInput = <T extends Partial<WixSubscriptionsApiV1PickupAddressInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('addressLine')) {
        result.addressLine = overrides && overrides.hasOwnProperty('addressLine') ? overrides.addressLine! : 'possimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('city')) {
        result.city = overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'ab';
    }
    if (pickedFields.size === 0 || pickedFields.has('country')) {
        result.country = overrides && overrides.hasOwnProperty('country') ? overrides.country! : 'dolor';
    }
    if (pickedFields.size === 0 || pickedFields.has('subdivision')) {
        result.subdivision = overrides && overrides.hasOwnProperty('subdivision') ? overrides.subdivision! : 'vitae';
    }
    if (pickedFields.size === 0 || pickedFields.has('zipCode')) {
        result.zipCode = overrides && overrides.hasOwnProperty('zipCode') ? overrides.zipCode! : 'est';
    }

    return result;
};

export const aWixSubscriptionsApiV1PickupDetailsInput = <T extends Partial<WixSubscriptionsApiV1PickupDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aWixSubscriptionsApiV1PickupAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aWixSubscriptionsApiV1PickupAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('pickupInstructions')) {
        result.pickupInstructions = overrides && overrides.hasOwnProperty('pickupInstructions') ? overrides.pickupInstructions! : 'harum';
    }

    return result;
};

export const aWixSubscriptionsApiV1ProductDetailsInput = <T extends Partial<WixSubscriptionsApiV1ProductDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appId')) {
        result.appId = overrides && overrides.hasOwnProperty('appId') ? overrides.appId! : 'in';
    }
    if (pickedFields.size === 0 || pickedFields.has('fulfillerId')) {
        result.fulfillerId = overrides && overrides.hasOwnProperty('fulfillerId') ? overrides.fulfillerId! : 'accusamus';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItemType')) {
        result.lineItemType = overrides && overrides.hasOwnProperty('lineItemType') ? overrides.lineItemType! : WixSubscriptionsApiV1LineItemType.CustomAmountItem;
    }
    if (pickedFields.size === 0 || pickedFields.has('mediaItem')) {
        result.mediaItem = overrides && overrides.hasOwnProperty('mediaItem') ? aWixSubscriptionsApiV1MediaItemInput(overrides.mediaItem ?? {}, pickedFields.get('mediaItem')) : aWixSubscriptionsApiV1MediaItemInput({}, pickedFields.get('mediaItem'));
    }
    if (pickedFields.size === 0 || pickedFields.has('name')) {
        result.name = overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ducimus';
    }
    if (pickedFields.size === 0 || pickedFields.has('notes')) {
        result.notes = overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : 'aut';
    }
    if (pickedFields.size === 0 || pickedFields.has('productId')) {
        result.productId = overrides && overrides.hasOwnProperty('productId') ? overrides.productId! : 'atque';
    }
    if (pickedFields.size === 0 || pickedFields.has('sku')) {
        result.sku = overrides && overrides.hasOwnProperty('sku') ? overrides.sku! : 'voluptatem';
    }
    if (pickedFields.size === 0 || pickedFields.has('taxGroupId')) {
        result.taxGroupId = overrides && overrides.hasOwnProperty('taxGroupId') ? overrides.taxGroupId! : 'dolorem';
    }
    if (pickedFields.size === 0 || pickedFields.has('translatedName')) {
        result.translatedName = overrides && overrides.hasOwnProperty('translatedName') ? overrides.translatedName! : 'tempore';
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 1.61;
    }

    return result;
};

export const aWixSubscriptionsApiV1ShipmentDetailsInput = <T extends Partial<WixSubscriptionsApiV1ShipmentDetailsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('address')) {
        result.address = overrides && overrides.hasOwnProperty('address') ? aComWixEcommerceCommonsApiAddressInput(overrides.address ?? {}, pickedFields.get('address')) : aComWixEcommerceCommonsApiAddressInput({}, pickedFields.get('address'));
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? overrides.discount! : 7.45;
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : 1.89;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxIncludedInPrice')) {
        result.taxIncludedInPrice = overrides && overrides.hasOwnProperty('taxIncludedInPrice') ? overrides.taxIncludedInPrice! : false;
    }
    if (pickedFields.size === 0 || pickedFields.has('taxRate')) {
        result.taxRate = overrides && overrides.hasOwnProperty('taxRate') ? overrides.taxRate! : 'corrupti';
    }

    return result;
};

export const aWixSubscriptionsApiV1ShippingInfoInput = <T extends Partial<WixSubscriptionsApiV1ShippingInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('deliveryOption')) {
        result.deliveryOption = overrides && overrides.hasOwnProperty('deliveryOption') ? overrides.deliveryOption! : 'ad';
    }
    if (pickedFields.size === 0 || pickedFields.has('estimatedDeliveryTime')) {
        result.estimatedDeliveryTime = overrides && overrides.hasOwnProperty('estimatedDeliveryTime') ? overrides.estimatedDeliveryTime! : 'non';
    }
    if (pickedFields.size === 0 || pickedFields.has('pickupDetails')) {
        result.pickupDetails = overrides && overrides.hasOwnProperty('pickupDetails') ? aWixSubscriptionsApiV1PickupDetailsInput(overrides.pickupDetails ?? {}, pickedFields.get('pickupDetails')) : aWixSubscriptionsApiV1PickupDetailsInput({}, pickedFields.get('pickupDetails'));
    }
    if (pickedFields.size === 0 || pickedFields.has('shipmentDetails')) {
        result.shipmentDetails = overrides && overrides.hasOwnProperty('shipmentDetails') ? aWixSubscriptionsApiV1ShipmentDetailsInput(overrides.shipmentDetails ?? {}, pickedFields.get('shipmentDetails')) : aWixSubscriptionsApiV1ShipmentDetailsInput({}, pickedFields.get('shipmentDetails'));
    }

    return result;
};

export const aWixSubscriptionsApiV1StoreSettingsInput = <T extends Partial<WixSubscriptionsApiV1StoreSettingsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('buyerLanguage')) {
        result.buyerLanguage = overrides && overrides.hasOwnProperty('buyerLanguage') ? overrides.buyerLanguage! : 'natus';
    }
    if (pickedFields.size === 0 || pickedFields.has('currency')) {
        result.currency = overrides && overrides.hasOwnProperty('currency') ? overrides.currency! : 'id';
    }
    if (pickedFields.size === 0 || pickedFields.has('weightUnit')) {
        result.weightUnit = overrides && overrides.hasOwnProperty('weightUnit') ? overrides.weightUnit! : ComWixEcommercePlatformCommonApiWeightUnit.Kg;
    }

    return result;
};

export const aWixSubscriptionsApiV1SubscriptionCreatedInput = <T extends Partial<WixSubscriptionsApiV1SubscriptionCreatedInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('subscription')) {
        result.subscription = overrides && overrides.hasOwnProperty('subscription') ? aWixSubscriptionsApiV1SubscriptionInput(overrides.subscription ?? {}, pickedFields.get('subscription')) : aWixSubscriptionsApiV1SubscriptionInput({}, pickedFields.get('subscription'));
    }

    return result;
};

export const aWixSubscriptionsApiV1SubscriptionInput = <T extends Partial<WixSubscriptionsApiV1SubscriptionInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('appliedCoupon')) {
        result.appliedCoupon = overrides && overrides.hasOwnProperty('appliedCoupon') ? aWixSubscriptionsApiV1AppliedCouponInput(overrides.appliedCoupon ?? {}, pickedFields.get('appliedCoupon')) : aWixSubscriptionsApiV1AppliedCouponInput({}, pickedFields.get('appliedCoupon'));
    }
    if (pickedFields.size === 0 || pickedFields.has('billingAddress')) {
        result.billingAddress = overrides && overrides.hasOwnProperty('billingAddress') ? aComWixEcommerceCommonsApiAddressInput(overrides.billingAddress ?? {}, pickedFields.get('billingAddress')) : aComWixEcommerceCommonsApiAddressInput({}, pickedFields.get('billingAddress'));
    }
    if (pickedFields.size === 0 || pickedFields.has('billingInfo')) {
        result.billingInfo = overrides && overrides.hasOwnProperty('billingInfo') ? aWixSubscriptionsApiV1BillingInfoInput(overrides.billingInfo ?? {}, pickedFields.get('billingInfo')) : aWixSubscriptionsApiV1BillingInfoInput({}, pickedFields.get('billingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerInfo')) {
        result.buyerInfo = overrides && overrides.hasOwnProperty('buyerInfo') ? aWixSubscriptionsApiV1BuyerInfoInput(overrides.buyerInfo ?? {}, pickedFields.get('buyerInfo')) : aWixSubscriptionsApiV1BuyerInfoInput({}, pickedFields.get('buyerInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('buyerNote')) {
        result.buyerNote = overrides && overrides.hasOwnProperty('buyerNote') ? overrides.buyerNote! : 'pariatur';
    }
    if (pickedFields.size === 0 || pickedFields.has('cartId')) {
        result.cartId = overrides && overrides.hasOwnProperty('cartId') ? overrides.cartId! : 'iusto';
    }
    if (pickedFields.size === 0 || pickedFields.has('channelInfo')) {
        result.channelInfo = overrides && overrides.hasOwnProperty('channelInfo') ? aWixSubscriptionsApiV1ChannelInfoInput(overrides.channelInfo ?? {}, pickedFields.get('channelInfo')) : aWixSubscriptionsApiV1ChannelInfoInput({}, pickedFields.get('channelInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('checkoutId')) {
        result.checkoutId = overrides && overrides.hasOwnProperty('checkoutId') ? overrides.checkoutId! : 'quibusdam';
    }
    if (pickedFields.size === 0 || pickedFields.has('customField')) {
        result.customField = overrides && overrides.hasOwnProperty('customField') ? aWixSubscriptionsApiV1CustomFieldInput(overrides.customField ?? {}, pickedFields.get('customField')) : aWixSubscriptionsApiV1CustomFieldInput({}, pickedFields.get('customField'));
    }
    if (pickedFields.size === 0 || pickedFields.has('dateCreated')) {
        result.dateCreated = overrides && overrides.hasOwnProperty('dateCreated') ? overrides.dateCreated! : 'quia';
    }
    if (pickedFields.size === 0 || pickedFields.has('externalId')) {
        result.externalId = overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'nemo';
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'delectus';
    }
    if (pickedFields.size === 0 || pickedFields.has('lineItems')) {
        result.lineItems = overrides && overrides.hasOwnProperty('lineItems') ? overrides.lineItems!.map((x) => aWixSubscriptionsApiV1LineItemInput({}, pickedFields.get('lineItems'))) : [aWixSubscriptionsApiV1LineItemInput({}, pickedFields.get('lineItems'))];
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingInfo')) {
        result.shippingInfo = overrides && overrides.hasOwnProperty('shippingInfo') ? aWixSubscriptionsApiV1ShippingInfoInput(overrides.shippingInfo ?? {}, pickedFields.get('shippingInfo')) : aWixSubscriptionsApiV1ShippingInfoInput({}, pickedFields.get('shippingInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('storeSettings')) {
        result.storeSettings = overrides && overrides.hasOwnProperty('storeSettings') ? aWixSubscriptionsApiV1StoreSettingsInput(overrides.storeSettings ?? {}, pickedFields.get('storeSettings')) : aWixSubscriptionsApiV1StoreSettingsInput({}, pickedFields.get('storeSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionOptionInfo')) {
        result.subscriptionOptionInfo = overrides && overrides.hasOwnProperty('subscriptionOptionInfo') ? aWixSubscriptionsApiV1SubscriptionOptionInfoInput(overrides.subscriptionOptionInfo ?? {}, pickedFields.get('subscriptionOptionInfo')) : aWixSubscriptionsApiV1SubscriptionOptionInfoInput({}, pickedFields.get('subscriptionOptionInfo'));
    }
    if (pickedFields.size === 0 || pickedFields.has('subscriptionSettings')) {
        result.subscriptionSettings = overrides && overrides.hasOwnProperty('subscriptionSettings') ? aWixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput(overrides.subscriptionSettings ?? {}, pickedFields.get('subscriptionSettings')) : aWixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput({}, pickedFields.get('subscriptionSettings'));
    }
    if (pickedFields.size === 0 || pickedFields.has('totals')) {
        result.totals = overrides && overrides.hasOwnProperty('totals') ? aWixSubscriptionsApiV1TotalsInput(overrides.totals ?? {}, pickedFields.get('totals')) : aWixSubscriptionsApiV1TotalsInput({}, pickedFields.get('totals'));
    }

    return result;
};

export const aWixSubscriptionsApiV1SubscriptionOptionInfoInput = <T extends Partial<WixSubscriptionsApiV1SubscriptionOptionInfoInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('description')) {
        result.description = overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'alias';
    }
    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? aWixEcommerceSubscriptionOptionApiV1DiscountInput(overrides.discount ?? {}, pickedFields.get('discount')) : aWixEcommerceSubscriptionOptionApiV1DiscountInput({}, pickedFields.get('discount'));
    }
    if (pickedFields.size === 0 || pickedFields.has('id')) {
        result.id = overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'sunt';
    }
    if (pickedFields.size === 0 || pickedFields.has('title')) {
        result.title = overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'et';
    }

    return result;
};

export const aWixSubscriptionsApiV1TotalsInput = <T extends Partial<WixSubscriptionsApiV1TotalsInput>>(overrides?: T, pickedFields: PickedFields = new Map()): T => {
    const result = {} as T;

    if (pickedFields.size === 0 || pickedFields.has('discount')) {
        result.discount = overrides && overrides.hasOwnProperty('discount') ? overrides.discount! : 7.24;
    }
    if (pickedFields.size === 0 || pickedFields.has('quantity')) {
        result.quantity = overrides && overrides.hasOwnProperty('quantity') ? overrides.quantity! : 2389;
    }
    if (pickedFields.size === 0 || pickedFields.has('shipping')) {
        result.shipping = overrides && overrides.hasOwnProperty('shipping') ? overrides.shipping! : 4.86;
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingAfterTax')) {
        result.shippingAfterTax = overrides && overrides.hasOwnProperty('shippingAfterTax') ? overrides.shippingAfterTax! : 1.03;
    }
    if (pickedFields.size === 0 || pickedFields.has('shippingBeforeTax')) {
        result.shippingBeforeTax = overrides && overrides.hasOwnProperty('shippingBeforeTax') ? overrides.shippingBeforeTax! : 1.64;
    }
    if (pickedFields.size === 0 || pickedFields.has('subtotal')) {
        result.subtotal = overrides && overrides.hasOwnProperty('subtotal') ? overrides.subtotal! : 6.51;
    }
    if (pickedFields.size === 0 || pickedFields.has('tax')) {
        result.tax = overrides && overrides.hasOwnProperty('tax') ? overrides.tax! : 2.9;
    }
    if (pickedFields.size === 0 || pickedFields.has('total')) {
        result.total = overrides && overrides.hasOwnProperty('total') ? overrides.total! : 5.91;
    }
    if (pickedFields.size === 0 || pickedFields.has('weight')) {
        result.weight = overrides && overrides.hasOwnProperty('weight') ? overrides.weight! : 4.03;
    }

    return result;
};

export type QueryEventsOperation = DeepPick<{
  wixCalendarEventsV3Events: WixCalendarEventsV3QueryEventsResponse;
}, 'wixCalendarEventsV3Events.items.scheduleId'
 | 'wixCalendarEventsV3Events.items.recurrenceRule.days'
>


export const aQueryEventsOperationResponse = (overrides?: Partial<QueryEventsOperation>): QueryEventsOperation => {
  const relationshipsToOmit= new Set<string>()
  const pickedFields = new Map<string, any>([
   ['wixCalendarEventsV3Events', new Map([['items', new Map([['scheduleId', undefined],['recurrenceRule', new Map([['days', undefined]])]])]])],
  ]);

  return {
    wixCalendarEventsV3Events: (overrides && overrides.hasOwnProperty('wixCalendarEventsV3Events') ? aWixCalendarEventsV3QueryEventsResponse(overrides.wixCalendarEventsV3Events ?? {}, pickedFields.get('wixCalendarEventsV3Events')) : aWixCalendarEventsV3QueryEventsResponse({}, pickedFields.get('wixCalendarEventsV3Events'))),
  };
};

